var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key2, value) => key2 in obj ? __defProp(obj, key2, { enumerable: true, configurable: true, writable: true, value }) : obj[key2] = value;
var __publicField = (obj, key2, value) => __defNormalProp(obj, typeof key2 !== "symbol" ? key2 + "" : key2, value);
var _a2;
import * as React from "react";
import React__default, { createContext, useContext, useReducer, useState, useLayoutEffect, useEffect, useMemo as useMemo$1, useRef, createElement, Component, createRef, forwardRef as forwardRef$1, useCallback as useCallback$1, useId as useId$2, useImperativeHandle, Fragment as Fragment$1, memo, Children, cloneElement, useDebugValue } from "react";
import { QueryClient, QueryClientProvider, useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { Grid, GridItem, Text as Text$3, Button as Button$1, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Flex, Box as Box$1, forwardRef, ListItem as ListItem$1, List as List$1, Heading as Heading$5, Center, Tab, NumberInput, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper, Alert, Spinner as Spinner$1, FormControl as FormControl$2, VStack, FormHelperText, FormLabel, InputGroup, InputLeftAddon, useColorMode, Portal as Portal$2, Tr, Td, Editable as Editable$1, EditablePreview, EditableInput, Table as Table$3, Thead, Th, Tbody, Input as Input$1, FormErrorMessage, HStack, useClipboard, InputRightAddon, IconButton as IconButton$1, Textarea as Textarea$1, Checkbox as Checkbox$2, useDisclosure, MenuItem, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, Menu as Menu$1, MenuButton as MenuButton$1, MenuList, Tabs, TabList, TabPanels, TabPanel, ButtonGroup as ButtonGroup$1, Divider as Divider$2, AbsoluteCenter, CheckboxGroup as CheckboxGroup$2, AccordionItem, AccordionButton, AccordionIcon, AccordionPanel, Select as Select$2, Accordion as Accordion$1, Link as Link$2, createIcon, UnorderedList, Badge, Collapse, useColorModeValue, AlertIcon as AlertIcon$1, RadioGroup as RadioGroup$1, Radio as Radio$1, chakra, Tooltip as Tooltip$1, StackDivider, extendTheme, InputRightElement, TableContainer as TableContainer$2, Popover as Popover$2, PopoverTrigger, PopoverContent as PopoverContent$1, PopoverArrow, PopoverCloseButton, PopoverFooter, PopoverBody, useTab, useMultiStyleConfig, CloseButton as CloseButton$1, AlertTitle, AlertDescription } from "@chakra-ui/react";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { unstable_batchedUpdates, findDOMNode, createPortal } from "react-dom";
import { DragHandleIcon, HamburgerIcon, ChevronDownIcon as ChevronDownIcon$1, ChevronRightIcon as ChevronRightIcon$1, Icon as Icon$2, CloseIcon, EditIcon, CheckIcon as CheckIcon$1 } from "@chakra-ui/icons";
import { BrowserQRCodeReader } from "@zxing/browser";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs$1(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f2 = React__default, k2 = Symbol.for("react.element"), l2 = Symbol.for("react.fragment"), m2 = Object.prototype.hasOwnProperty, n2 = f2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p2 = { key: true, ref: true, __self: true, __source: true };
  function q2(c2, a2, g2) {
    var b2, d2 = {}, e = null, h2 = null;
    void 0 !== g2 && (e = "" + g2);
    void 0 !== a2.key && (e = "" + a2.key);
    void 0 !== a2.ref && (h2 = a2.ref);
    for (b2 in a2) m2.call(a2, b2) && !p2.hasOwnProperty(b2) && (d2[b2] = a2[b2]);
    if (c2 && c2.defaultProps) for (b2 in a2 = c2.defaultProps, a2) void 0 === d2[b2] && (d2[b2] = a2[b2]);
    return { $$typeof: k2, type: c2, key: e, ref: h2, props: d2, _owner: n2.current };
  }
  reactJsxRuntime_production_min.Fragment = l2;
  reactJsxRuntime_production_min.jsx = q2;
  reactJsxRuntime_production_min.jsxs = q2;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React2 = React__default;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error2(format2) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format2, args);
          }
        }
      }
      function printWarning(level, format2, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format2 += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format2);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error2("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init2 = lazyComponent._init;
              try {
                return getComponentNameFromType(init2(payload));
              } catch (x2) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign2 = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign2({}, props, {
                value: prevLog
              }),
              info: assign2({}, props, {
                value: prevInfo
              }),
              warn: assign2({}, props, {
                value: prevWarn
              }),
              error: assign2({}, props, {
                value: prevError
              }),
              group: assign2({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign2({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign2({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error2("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix2;
      function describeBuiltInComponentFrame(name2, source, ownerFn) {
        {
          if (prefix2 === void 0) {
            try {
              throw Error();
            } catch (x2) {
              var match5 = x2.stack.trim().match(/\n( *(at )?)/);
              prefix2 = match5 && match5[1] || "";
            }
          }
          return "\n" + prefix2 + name2;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn2, construct) {
        if (!fn2 || reentry) {
          return "";
        }
        {
          var frame = componentFrameCache.get(fn2);
          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x2) {
                control = x2;
              }
              Reflect.construct(fn2, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x2) {
                control = x2;
              }
              fn2.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x2) {
              control = x2;
            }
            fn2();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s2 = sampleLines.length - 1;
            var c2 = controlLines.length - 1;
            while (s2 >= 1 && c2 >= 0 && sampleLines[s2] !== controlLines[c2]) {
              c2--;
            }
            for (; s2 >= 1 && c2 >= 0; s2--, c2--) {
              if (sampleLines[s2] !== controlLines[c2]) {
                if (s2 !== 1 || c2 !== 1) {
                  do {
                    s2--;
                    c2--;
                    if (c2 < 0 || sampleLines[s2] !== controlLines[c2]) {
                      var _frame = "\n" + sampleLines[s2].replace(" at new ", " at ");
                      if (fn2.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn2.displayName);
                      }
                      {
                        if (typeof fn2 === "function") {
                          componentFrameCache.set(fn2, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s2 >= 1 && c2 >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name2 = fn2 ? fn2.displayName || fn2.name : "";
        var syntheticFrame = name2 ? describeBuiltInComponentFrame(name2) : "";
        {
          if (typeof fn2 === "function") {
            componentFrameCache.set(fn2, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn2, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn2, false);
        }
      }
      function shouldConstruct(Component2) {
        var prototype = Component2.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init2 = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init2(payload), source, ownerFn);
              } catch (x2) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty2 = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element2) {
        {
          if (element2) {
            var owner = element2._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element2.type, element2._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values2, location, componentName, element2) {
        {
          var has2 = Function.call.bind(hasOwnProperty2);
          for (var typeSpecName in typeSpecs) {
            if (has2(typeSpecs, typeSpecName)) {
              var error$12 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$12 = typeSpecs[typeSpecName](values2, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$12 = ex;
              }
              if (error$12 && !(error$12 instanceof Error)) {
                setCurrentlyValidatingElement(element2);
                error2("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$12);
                setCurrentlyValidatingElement(null);
              }
              if (error$12 instanceof Error && !(error$12.message in loggedTypeFailures)) {
                loggedTypeFailures[error$12.message] = true;
                setCurrentlyValidatingElement(element2);
                error2("Failed %s type: %s", location, error$12.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray2(a2) {
        return isArrayImpl(a2);
      }
      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error2("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      function hasValidRef(config2) {
        {
          if (hasOwnProperty2.call(config2, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config2, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config2.ref !== void 0;
      }
      function hasValidKey(config2) {
        {
          if (hasOwnProperty2.call(config2, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config2.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config2, self2) {
        {
          if (typeof config2.ref === "string" && ReactCurrentOwner.current && self2) ;
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error2("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error2("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key2, ref2, self2, source, owner, props) {
        var element2 = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type,
          key: key2,
          ref: ref2,
          props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          element2._store = {};
          Object.defineProperty(element2._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element2, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self2
          });
          Object.defineProperty(element2, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element2.props);
            Object.freeze(element2);
          }
        }
        return element2;
      };
      function jsxDEV(type, config2, maybeKey, source, self2) {
        {
          var propName;
          var props = {};
          var key2 = null;
          var ref2 = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key2 = "" + maybeKey;
          }
          if (hasValidKey(config2)) {
            {
              checkKeyStringCoercion(config2.key);
            }
            key2 = "" + config2.key;
          }
          if (hasValidRef(config2)) {
            ref2 = config2.ref;
            warnIfStringRefCannotBeAutoConverted(config2, self2);
          }
          for (propName in config2) {
            if (hasOwnProperty2.call(config2, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config2[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps2 = type.defaultProps;
            for (propName in defaultProps2) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps2[propName];
              }
            }
          }
          if (key2 || ref2) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key2) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref2) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key2, ref2, self2, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element2) {
        {
          if (element2) {
            var owner = element2._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element2.type, element2._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name2 = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name2) {
              return "\n\nCheck the render method of `" + name2 + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      function validateExplicitKey(element2, parentType) {
        {
          if (!element2._store || element2._store.validated || element2.key != null) {
            return;
          }
          element2._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element2 && element2._owner && element2._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element2._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element2);
          error2('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node2, parentType) {
        {
          if (typeof node2 !== "object") {
            return;
          }
          if (isArray2(node2)) {
            for (var i = 0; i < node2.length; i++) {
              var child = node2[i];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node2)) {
            if (node2._store) {
              node2._store.validated = true;
            }
          } else if (node2) {
            var iteratorFn = getIteratorFn(node2);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node2.entries) {
                var iterator = iteratorFn.call(node2);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element2) {
        {
          var type = element2.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes2;
          if (typeof type === "function") {
            propTypes2 = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes2 = type.propTypes;
          } else {
            return;
          }
          if (propTypes2) {
            var name2 = getComponentNameFromType(type);
            checkPropTypes(propTypes2, element2.props, "prop", name2, element2);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error2("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error2("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys2 = Object.keys(fragment.props);
          for (var i = 0; i < keys2.length; i++) {
            var key2 = keys2[i];
            if (key2 !== "children" && key2 !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error2("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key2);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error2("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      var didWarnAboutKeySpread = {};
      function jsxWithValidation(type, props, key2, isStaticChildren, source, self2) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum();
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray2(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error2("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }
          var element2 = jsxDEV(type, props, key2, source, self2);
          if (element2 == null) {
            return element2;
          }
          if (validType) {
            var children = props.children;
            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray2(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error2("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          {
            if (hasOwnProperty2.call(props, "key")) {
              var componentName = getComponentNameFromType(type);
              var keys2 = Object.keys(props).filter(function(k2) {
                return k2 !== "key";
              });
              var beforeExample = keys2.length > 0 ? "{key: someKey, " + keys2.join(": ..., ") + ": ...}" : "{key: someKey}";
              if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys2.length > 0 ? "{" + keys2.join(": ..., ") + ": ...}" : "{}";
                error2('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element2);
          } else {
            validatePropTypes(element2);
          }
          return element2;
        }
      }
      function jsxWithValidationStatic(type, props, key2) {
        {
          return jsxWithValidation(type, props, key2, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key2) {
        {
          return jsxWithValidation(type, props, key2, false);
        }
      }
      var jsx = jsxWithValidationDynamic;
      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }
  return reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  hasRequiredJsxRuntime = 1;
  if (process.env.NODE_ENV === "production") {
    jsxRuntime.exports = requireReactJsxRuntime_production_min();
  } else {
    jsxRuntime.exports = requireReactJsxRuntime_development();
  }
  return jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
const millisecondsInWeek$1 = 6048e5;
const millisecondsInDay$1 = 864e5;
const millisecondsInMinute$1 = 6e4;
const millisecondsInHour$1 = 36e5;
const millisecondsInSecond$1 = 1e3;
const constructFromSymbol = Symbol.for("constructDateFrom");
function constructFrom$1(date, value) {
  if (typeof date === "function") return date(value);
  if (date && typeof date === "object" && constructFromSymbol in date)
    return date[constructFromSymbol](value);
  if (date instanceof Date) return new date.constructor(value);
  return new Date(value);
}
function toDate$3(argument, context) {
  return constructFrom$1(context || argument, argument);
}
function addDays$1(date, amount, options) {
  const _date = toDate$3(date, options == null ? void 0 : options.in);
  if (isNaN(amount)) return constructFrom$1((options == null ? void 0 : options.in) || date, NaN);
  if (!amount) return _date;
  _date.setDate(_date.getDate() + amount);
  return _date;
}
function addMilliseconds$1(date, amount, options) {
  return constructFrom$1(date, +toDate$3(date) + amount);
}
function addHours$1(date, amount, options) {
  return addMilliseconds$1(date, amount * millisecondsInHour$1);
}
let defaultOptions$5 = {};
function getDefaultOptions$3() {
  return defaultOptions$5;
}
function startOfWeek$1(date, options) {
  var _a3, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions$3();
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_b = (_a3 = options == null ? void 0 : options.locale) == null ? void 0 : _a3.options) == null ? void 0 : _b.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const _date = toDate$3(date, options == null ? void 0 : options.in);
  const day = _date.getDay();
  const diff2 = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  _date.setDate(_date.getDate() - diff2);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function startOfISOWeek$1(date, options) {
  return startOfWeek$1(date, { ...options, weekStartsOn: 1 });
}
function getISOWeekYear$1(date, options) {
  const _date = toDate$3(date, options == null ? void 0 : options.in);
  const year = _date.getFullYear();
  const fourthOfJanuaryOfNextYear = constructFrom$1(_date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek$1(fourthOfJanuaryOfNextYear);
  const fourthOfJanuaryOfThisYear = constructFrom$1(_date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek$1(fourthOfJanuaryOfThisYear);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function getTimezoneOffsetInMilliseconds$2(date) {
  const _date = toDate$3(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds()
    )
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}
function normalizeDates(context, ...dates) {
  const normalize2 = constructFrom$1.bind(
    null,
    dates.find((date) => typeof date === "object")
  );
  return dates.map(normalize2);
}
function startOfDay$1(date, options) {
  const _date = toDate$3(date, options == null ? void 0 : options.in);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function differenceInCalendarDays$1(laterDate, earlierDate, options) {
  const [laterDate_, earlierDate_] = normalizeDates(
    options == null ? void 0 : options.in,
    laterDate,
    earlierDate
  );
  const laterStartOfDay = startOfDay$1(laterDate_);
  const earlierStartOfDay = startOfDay$1(earlierDate_);
  const laterTimestamp = +laterStartOfDay - getTimezoneOffsetInMilliseconds$2(laterStartOfDay);
  const earlierTimestamp = +earlierStartOfDay - getTimezoneOffsetInMilliseconds$2(earlierStartOfDay);
  return Math.round((laterTimestamp - earlierTimestamp) / millisecondsInDay$1);
}
function startOfISOWeekYear$1(date, options) {
  const year = getISOWeekYear$1(date, options);
  const fourthOfJanuary = constructFrom$1(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek$1(fourthOfJanuary);
}
function max$3(dates, options) {
  let result;
  let context = options == null ? void 0 : options.in;
  dates.forEach((date) => {
    if (!context && typeof date === "object")
      context = constructFrom$1.bind(null, date);
    const date_ = toDate$3(date, context);
    if (!result || result < date_ || isNaN(+date_)) result = date_;
  });
  return constructFrom$1(context, result || NaN);
}
function min$3(dates, options) {
  let result;
  let context = options == null ? void 0 : options.in;
  dates.forEach((date) => {
    if (!context && typeof date === "object")
      context = constructFrom$1.bind(null, date);
    const date_ = toDate$3(date, context);
    if (!result || result > date_ || isNaN(+date_)) result = date_;
  });
  return constructFrom$1(context, result || NaN);
}
function isSameDay$2(laterDate, earlierDate, options) {
  const [dateLeft_, dateRight_] = normalizeDates(
    options == null ? void 0 : options.in,
    laterDate,
    earlierDate
  );
  return +startOfDay$1(dateLeft_) === +startOfDay$1(dateRight_);
}
function isDate$3(value) {
  return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
function isValid$6(date) {
  return !(!isDate$3(date) && typeof date !== "number" || isNaN(+toDate$3(date)));
}
function normalizeInterval(context, interval) {
  const [start4, end2] = normalizeDates(context, interval.start, interval.end);
  return { start: start4, end: end2 };
}
function eachDayOfInterval(interval, options) {
  const { start: start4, end: end2 } = normalizeInterval(options == null ? void 0 : options.in, interval);
  let reversed = +start4 > +end2;
  const endTime = reversed ? +start4 : +end2;
  const date = reversed ? end2 : start4;
  date.setHours(0, 0, 0, 0);
  let step = 1;
  const dates = [];
  while (+date <= endTime) {
    dates.push(constructFrom$1(start4, date));
    date.setDate(date.getDate() + step);
    date.setHours(0, 0, 0, 0);
  }
  return reversed ? dates.reverse() : dates;
}
function startOfYear$1(date, options) {
  const date_ = toDate$3(date, options == null ? void 0 : options.in);
  date_.setFullYear(date_.getFullYear(), 0, 1);
  date_.setHours(0, 0, 0, 0);
  return date_;
}
const formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
const formatDistance$1 = (token2, count2, options) => {
  let result;
  const tokenValue = formatDistanceLocale$1[token2];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count2 === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count2.toString());
  }
  if (options == null ? void 0 : options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
function buildFormatLongFn$1(args) {
  return (options = {}) => {
    const width2 = options.width ? String(options.width) : args.defaultWidth;
    const format2 = args.formats[width2] || args.formats[args.defaultWidth];
    return format2;
  };
}
const dateFormats$1 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
const timeFormats$1 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
const dateTimeFormats$1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong$1 = {
  date: buildFormatLongFn$1({
    formats: dateFormats$1,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn$1({
    formats: timeFormats$1,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn$1({
    formats: dateTimeFormats$1,
    defaultWidth: "full"
  })
};
const formatRelativeLocale$1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
const formatRelative$1 = (token2, _date, _baseDate, _options) => formatRelativeLocale$1[token2];
function buildLocalizeFn$1(args) {
  return (value, options) => {
    const context = (options == null ? void 0 : options.context) ? String(options.context) : "standalone";
    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width2 = (options == null ? void 0 : options.width) ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width2] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width2 = (options == null ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[width2] || args.values[defaultWidth];
    }
    const index2 = args.argumentCallback ? args.argumentCallback(value) : value;
    return valuesArray[index2];
  };
}
const eraValues$1 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
const quarterValues$1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
const monthValues$1 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};
const dayValues$1 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
};
const dayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
const formattingDayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
const ordinalNumber$1 = (dirtyNumber, _options) => {
  const number2 = Number(dirtyNumber);
  const rem100 = number2 % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number2 + "st";
      case 2:
        return number2 + "nd";
      case 3:
        return number2 + "rd";
    }
  }
  return number2 + "th";
};
const localize$1 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn$1({
    values: eraValues$1,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn$1({
    values: quarterValues$1,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn$1({
    values: monthValues$1,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn$1({
    values: dayValues$1,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues$1,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn$1(args) {
  return (string2, options = {}) => {
    const width2 = options.width;
    const matchPattern = width2 && args.matchPatterns[width2] || args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string2.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];
    const parsePatterns = width2 && args.parsePatterns[width2] || args.parsePatterns[args.defaultParseWidth];
    const key2 = Array.isArray(parsePatterns) ? findIndex$3(parsePatterns, (pattern) => pattern.test(matchedString)) : (
      // [TODO] -- I challenge you to fix the type
      findKey$1(parsePatterns, (pattern) => pattern.test(matchedString))
    );
    let value;
    value = args.valueCallback ? args.valueCallback(key2) : key2;
    value = options.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      options.valueCallback(value)
    ) : value;
    const rest = string2.slice(matchedString.length);
    return { value, rest };
  };
}
function findKey$1(object, predicate) {
  for (const key2 in object) {
    if (Object.prototype.hasOwnProperty.call(object, key2) && predicate(object[key2])) {
      return key2;
    }
  }
  return void 0;
}
function findIndex$3(array, predicate) {
  for (let key2 = 0; key2 < array.length; key2++) {
    if (predicate(array[key2])) {
      return key2;
    }
  }
  return void 0;
}
function buildMatchPatternFn$1(args) {
  return (string2, options = {}) => {
    const matchResult = string2.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];
    const parseResult = string2.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    const rest = string2.slice(matchedString.length);
    return { value, rest };
  };
}
const matchOrdinalNumberPattern$1 = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern$1 = /\d+/i;
const matchEraPatterns$1 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns$1 = {
  any: [/^b/i, /^(a|c)/i]
};
const matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns$1 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
};
const matchDayPatterns$1 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns$1 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
const matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
const match$3 = {
  ordinalNumber: buildMatchPatternFn$1({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: (value) => parseInt(value, 10)
  }),
  era: buildMatchFn$1({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn$1({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: "any",
    valueCallback: (index2) => index2 + 1
  }),
  month: buildMatchFn$1({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn$1({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn$1({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: "any"
  })
};
const enUS$1 = {
  code: "en-US",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$3,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function getDayOfYear$1(date, options) {
  const _date = toDate$3(date, options == null ? void 0 : options.in);
  const diff2 = differenceInCalendarDays$1(_date, startOfYear$1(_date));
  const dayOfYear = diff2 + 1;
  return dayOfYear;
}
function getISOWeek$1(date, options) {
  const _date = toDate$3(date, options == null ? void 0 : options.in);
  const diff2 = +startOfISOWeek$1(_date) - +startOfISOWeekYear$1(_date);
  return Math.round(diff2 / millisecondsInWeek$1) + 1;
}
function getWeekYear$1(date, options) {
  var _a3, _b, _c, _d;
  const _date = toDate$3(date, options == null ? void 0 : options.in);
  const year = _date.getFullYear();
  const defaultOptions2 = getDefaultOptions$3();
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a3 = options == null ? void 0 : options.locale) == null ? void 0 : _a3.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const firstWeekOfNextYear = constructFrom$1((options == null ? void 0 : options.in) || date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek$1(firstWeekOfNextYear, options);
  const firstWeekOfThisYear = constructFrom$1((options == null ? void 0 : options.in) || date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek$1(firstWeekOfThisYear, options);
  if (+_date >= +startOfNextYear) {
    return year + 1;
  } else if (+_date >= +startOfThisYear) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfWeekYear$1(date, options) {
  var _a3, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions$3();
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a3 = options == null ? void 0 : options.locale) == null ? void 0 : _a3.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const year = getWeekYear$1(date, options);
  const firstWeek = constructFrom$1((options == null ? void 0 : options.in) || date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek$1(firstWeek, options);
  return _date;
}
function getWeek$2(date, options) {
  const _date = toDate$3(date, options == null ? void 0 : options.in);
  const diff2 = +startOfWeek$1(_date, options) - +startOfWeekYear$1(_date, options);
  return Math.round(diff2 / millisecondsInWeek$1) + 1;
}
function addLeadingZeros$1(number2, targetLength) {
  const sign2 = number2 < 0 ? "-" : "";
  const output = Math.abs(number2).toString().padStart(targetLength, "0");
  return sign2 + output;
}
const lightFormatters$1 = {
  // Year
  y(date, token2) {
    const signedYear = date.getFullYear();
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros$1(token2 === "yy" ? year % 100 : year, token2.length);
  },
  // Month
  M(date, token2) {
    const month = date.getMonth();
    return token2 === "M" ? String(month + 1) : addLeadingZeros$1(month + 1, 2);
  },
  // Day of the month
  d(date, token2) {
    return addLeadingZeros$1(date.getDate(), token2.length);
  },
  // AM or PM
  a(date, token2) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(date, token2) {
    return addLeadingZeros$1(date.getHours() % 12 || 12, token2.length);
  },
  // Hour [0-23]
  H(date, token2) {
    return addLeadingZeros$1(date.getHours(), token2.length);
  },
  // Minute
  m(date, token2) {
    return addLeadingZeros$1(date.getMinutes(), token2.length);
  },
  // Second
  s(date, token2) {
    return addLeadingZeros$1(date.getSeconds(), token2.length);
  },
  // Fraction of second
  S(date, token2) {
    const numberOfDigits = token2.length;
    const milliseconds2 = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds2 * Math.pow(10, numberOfDigits - 3)
    );
    return addLeadingZeros$1(fractionalSeconds, token2.length);
  }
};
const dayPeriodEnum$1 = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
const formatters$1 = {
  // Era
  G: function(date, token2, localize2) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token2) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return localize2.era(era, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize2.era(era, { width: "wide" });
    }
  },
  // Year
  y: function(date, token2, localize2) {
    if (token2 === "yo") {
      const signedYear = date.getFullYear();
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, { unit: "year" });
    }
    return lightFormatters$1.y(date, token2);
  },
  // Local week-numbering year
  Y: function(date, token2, localize2, options) {
    const signedWeekYear = getWeekYear$1(date, options);
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token2 === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros$1(twoDigitYear, 2);
    }
    if (token2 === "Yo") {
      return localize2.ordinalNumber(weekYear, { unit: "year" });
    }
    return addLeadingZeros$1(weekYear, token2.length);
  },
  // ISO week-numbering year
  R: function(date, token2) {
    const isoWeekYear = getISOWeekYear$1(date);
    return addLeadingZeros$1(isoWeekYear, token2.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(date, token2) {
    const year = date.getFullYear();
    return addLeadingZeros$1(year, token2.length);
  },
  // Quarter
  Q: function(date, token2, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token2) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return addLeadingZeros$1(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(date, token2, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token2) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return addLeadingZeros$1(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(date, token2, localize2) {
    const month = date.getMonth();
    switch (token2) {
      case "M":
      case "MM":
        return lightFormatters$1.M(date, token2);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize2.month(month, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(date, token2, localize2) {
    const month = date.getMonth();
    switch (token2) {
      // 1, 2, ..., 12
      case "L":
        return String(month + 1);
      // 01, 02, ..., 12
      case "LL":
        return addLeadingZeros$1(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize2.month(month, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(date, token2, localize2, options) {
    const week = getWeek$2(date, options);
    if (token2 === "wo") {
      return localize2.ordinalNumber(week, { unit: "week" });
    }
    return addLeadingZeros$1(week, token2.length);
  },
  // ISO week of year
  I: function(date, token2, localize2) {
    const isoWeek = getISOWeek$1(date);
    if (token2 === "Io") {
      return localize2.ordinalNumber(isoWeek, { unit: "week" });
    }
    return addLeadingZeros$1(isoWeek, token2.length);
  },
  // Day of the month
  d: function(date, token2, localize2) {
    if (token2 === "do") {
      return localize2.ordinalNumber(date.getDate(), { unit: "date" });
    }
    return lightFormatters$1.d(date, token2);
  },
  // Day of year
  D: function(date, token2, localize2) {
    const dayOfYear = getDayOfYear$1(date);
    if (token2 === "Do") {
      return localize2.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }
    return addLeadingZeros$1(dayOfYear, token2.length);
  },
  // Day of week
  E: function(date, token2, localize2) {
    const dayOfWeek = date.getDay();
    switch (token2) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(date, token2, localize2, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return addLeadingZeros$1(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(date, token2, localize2, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return addLeadingZeros$1(localDayOfWeek, token2.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(date, token2, localize2) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token2) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return addLeadingZeros$1(isoDayOfWeek, token2.length);
      // 2nd
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, { unit: "day" });
      // Tue
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(date, token2, localize2) {
    const hours2 = date.getHours();
    const dayPeriodEnumValue = hours2 / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(date, token2, localize2) {
    const hours2 = date.getHours();
    let dayPeriodEnumValue;
    if (hours2 === 12) {
      dayPeriodEnumValue = dayPeriodEnum$1.noon;
    } else if (hours2 === 0) {
      dayPeriodEnumValue = dayPeriodEnum$1.midnight;
    } else {
      dayPeriodEnumValue = hours2 / 12 >= 1 ? "pm" : "am";
    }
    switch (token2) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(date, token2, localize2) {
    const hours2 = date.getHours();
    let dayPeriodEnumValue;
    if (hours2 >= 17) {
      dayPeriodEnumValue = dayPeriodEnum$1.evening;
    } else if (hours2 >= 12) {
      dayPeriodEnumValue = dayPeriodEnum$1.afternoon;
    } else if (hours2 >= 4) {
      dayPeriodEnumValue = dayPeriodEnum$1.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum$1.night;
    }
    switch (token2) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(date, token2, localize2) {
    if (token2 === "ho") {
      let hours2 = date.getHours() % 12;
      if (hours2 === 0) hours2 = 12;
      return localize2.ordinalNumber(hours2, { unit: "hour" });
    }
    return lightFormatters$1.h(date, token2);
  },
  // Hour [0-23]
  H: function(date, token2, localize2) {
    if (token2 === "Ho") {
      return localize2.ordinalNumber(date.getHours(), { unit: "hour" });
    }
    return lightFormatters$1.H(date, token2);
  },
  // Hour [0-11]
  K: function(date, token2, localize2) {
    const hours2 = date.getHours() % 12;
    if (token2 === "Ko") {
      return localize2.ordinalNumber(hours2, { unit: "hour" });
    }
    return addLeadingZeros$1(hours2, token2.length);
  },
  // Hour [1-24]
  k: function(date, token2, localize2) {
    let hours2 = date.getHours();
    if (hours2 === 0) hours2 = 24;
    if (token2 === "ko") {
      return localize2.ordinalNumber(hours2, { unit: "hour" });
    }
    return addLeadingZeros$1(hours2, token2.length);
  },
  // Minute
  m: function(date, token2, localize2) {
    if (token2 === "mo") {
      return localize2.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }
    return lightFormatters$1.m(date, token2);
  },
  // Second
  s: function(date, token2, localize2) {
    if (token2 === "so") {
      return localize2.ordinalNumber(date.getSeconds(), { unit: "second" });
    }
    return lightFormatters$1.s(date, token2);
  },
  // Fraction of second
  S: function(date, token2) {
    return lightFormatters$1.S(date, token2);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(date, token2, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token2) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes$1(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return formatTimezone$1(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return formatTimezone$1(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(date, token2, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token2) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes$1(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return formatTimezone$1(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return formatTimezone$1(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function(date, token2, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token2) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort$1(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone$1(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(date, token2, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token2) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort$1(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone$1(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function(date, token2, _localize) {
    const timestamp = Math.trunc(+date / 1e3);
    return addLeadingZeros$1(timestamp, token2.length);
  },
  // Milliseconds timestamp
  T: function(date, token2, _localize) {
    return addLeadingZeros$1(+date, token2.length);
  }
};
function formatTimezoneShort$1(offset3, delimiter2 = "") {
  const sign2 = offset3 > 0 ? "-" : "+";
  const absOffset = Math.abs(offset3);
  const hours2 = Math.trunc(absOffset / 60);
  const minutes2 = absOffset % 60;
  if (minutes2 === 0) {
    return sign2 + String(hours2);
  }
  return sign2 + String(hours2) + delimiter2 + addLeadingZeros$1(minutes2, 2);
}
function formatTimezoneWithOptionalMinutes$1(offset3, delimiter2) {
  if (offset3 % 60 === 0) {
    const sign2 = offset3 > 0 ? "-" : "+";
    return sign2 + addLeadingZeros$1(Math.abs(offset3) / 60, 2);
  }
  return formatTimezone$1(offset3, delimiter2);
}
function formatTimezone$1(offset3, delimiter2 = "") {
  const sign2 = offset3 > 0 ? "-" : "+";
  const absOffset = Math.abs(offset3);
  const hours2 = addLeadingZeros$1(Math.trunc(absOffset / 60), 2);
  const minutes2 = addLeadingZeros$1(absOffset % 60, 2);
  return sign2 + hours2 + delimiter2 + minutes2;
}
const dateLongFormatter$1 = (pattern, formatLong2) => {
  switch (pattern) {
    case "P":
      return formatLong2.date({ width: "short" });
    case "PP":
      return formatLong2.date({ width: "medium" });
    case "PPP":
      return formatLong2.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong2.date({ width: "full" });
  }
};
const timeLongFormatter$1 = (pattern, formatLong2) => {
  switch (pattern) {
    case "p":
      return formatLong2.time({ width: "short" });
    case "pp":
      return formatLong2.time({ width: "medium" });
    case "ppp":
      return formatLong2.time({ width: "long" });
    case "pppp":
    default:
      return formatLong2.time({ width: "full" });
  }
};
const dateTimeLongFormatter$1 = (pattern, formatLong2) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter$1(pattern, formatLong2);
  }
  let dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({ width: "full" });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter$1(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter$1(timePattern, formatLong2));
};
const longFormatters$1 = {
  p: timeLongFormatter$1,
  P: dateTimeLongFormatter$1
};
const dayOfYearTokenRE$1 = /^D+$/;
const weekYearTokenRE$1 = /^Y+$/;
const throwTokens$1 = ["D", "DD", "YY", "YYYY"];
function isProtectedDayOfYearToken$1(token2) {
  return dayOfYearTokenRE$1.test(token2);
}
function isProtectedWeekYearToken$1(token2) {
  return weekYearTokenRE$1.test(token2);
}
function warnOrThrowProtectedError$1(token2, format2, input) {
  const _message = message$1(token2, format2, input);
  console.warn(_message);
  if (throwTokens$1.includes(token2)) throw new RangeError(_message);
}
function message$1(token2, format2, input) {
  const subject = token2[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token2.toLowerCase()}\` instead of \`${token2}\` (in \`${format2}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const formattingTokensRegExp$3 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
const longFormattingTokensRegExp$4 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp$3 = /^'([^]*?)'?$/;
const doubleQuoteRegExp$3 = /''/g;
const unescapedLatinCharacterRegExp$3 = /[a-zA-Z]/;
function format$2(date, formatStr, options) {
  var _a3, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions$3();
  const locale2 = defaultOptions2.locale ?? enUS$1;
  const firstWeekContainsDate = defaultOptions2.firstWeekContainsDate ?? ((_b = (_a3 = defaultOptions2.locale) == null ? void 0 : _a3.options) == null ? void 0 : _b.firstWeekContainsDate) ?? 1;
  const weekStartsOn = defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const originalDate = toDate$3(date, options == null ? void 0 : options.in);
  if (!isValid$6(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  let parts = formatStr.match(longFormattingTokensRegExp$4).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      const longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$3).map((substring) => {
    if (substring === "''") {
      return { isToken: false, value: "'" };
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return { isToken: false, value: cleanEscapedString$3(substring) };
    }
    if (formatters$1[firstCharacter]) {
      return { isToken: true, value: substring };
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp$3)) {
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + firstCharacter + "`"
      );
    }
    return { isToken: false, value: substring };
  });
  if (locale2.localize.preprocessor) {
    parts = locale2.localize.preprocessor(originalDate, parts);
  }
  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2
  };
  return parts.map((part) => {
    if (!part.isToken) return part.value;
    const token2 = part.value;
    if (isProtectedWeekYearToken$1(token2) || isProtectedDayOfYearToken$1(token2)) {
      warnOrThrowProtectedError$1(token2, formatStr, String(date));
    }
    const formatter = formatters$1[token2[0]];
    return formatter(originalDate, token2, locale2.localize, formatterOptions);
  }).join("");
}
function cleanEscapedString$3(input) {
  const matched = input.match(escapedStringRegExp$3);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp$3, "'");
}
function formatISO(date, options) {
  const date_ = toDate$3(date, options == null ? void 0 : options.in);
  if (isNaN(+date_)) {
    throw new RangeError("Invalid time value");
  }
  const format2 = (options == null ? void 0 : options.format) ?? "extended";
  const representation = (options == null ? void 0 : options.representation) ?? "complete";
  let result = "";
  let tzOffset = "";
  const dateDelimiter = format2 === "extended" ? "-" : "";
  const timeDelimiter = format2 === "extended" ? ":" : "";
  if (representation !== "time") {
    const day = addLeadingZeros$1(date_.getDate(), 2);
    const month = addLeadingZeros$1(date_.getMonth() + 1, 2);
    const year = addLeadingZeros$1(date_.getFullYear(), 4);
    result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
  }
  if (representation !== "date") {
    const offset3 = date_.getTimezoneOffset();
    if (offset3 !== 0) {
      const absoluteOffset = Math.abs(offset3);
      const hourOffset = addLeadingZeros$1(Math.trunc(absoluteOffset / 60), 2);
      const minuteOffset = addLeadingZeros$1(absoluteOffset % 60, 2);
      const sign2 = offset3 < 0 ? "+" : "-";
      tzOffset = `${sign2}${hourOffset}:${minuteOffset}`;
    } else {
      tzOffset = "Z";
    }
    const hour = addLeadingZeros$1(date_.getHours(), 2);
    const minute = addLeadingZeros$1(date_.getMinutes(), 2);
    const second = addLeadingZeros$1(date_.getSeconds(), 2);
    const separator = result === "" ? "" : "T";
    const time = [hour, minute, second].join(timeDelimiter);
    result = `${result}${separator}${time}${tzOffset}`;
  }
  return result;
}
function getDefaultOptions$2() {
  return Object.assign({}, getDefaultOptions$3());
}
function getISODay$1(date, options) {
  const day = toDate$3(date, options == null ? void 0 : options.in).getDay();
  return day === 0 ? 7 : day;
}
function transpose$1(date, constructor) {
  const date_ = isConstructor(constructor) ? new constructor(0) : constructFrom$1(constructor, 0);
  date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
  date_.setHours(
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds()
  );
  return date_;
}
function isConstructor(constructor) {
  var _a3;
  return typeof constructor === "function" && ((_a3 = constructor.prototype) == null ? void 0 : _a3.constructor) === constructor;
}
const TIMEZONE_UNIT_PRIORITY$1 = 10;
let Setter$1 = class Setter {
  constructor() {
    __publicField(this, "subPriority", 0);
  }
  validate(_utcDate, _options) {
    return true;
  }
};
let ValueSetter$1 = class ValueSetter extends Setter$1 {
  constructor(value, validateValue, setValue, priority, subPriority) {
    super();
    this.value = value;
    this.validateValue = validateValue;
    this.setValue = setValue;
    this.priority = priority;
    if (subPriority) {
      this.subPriority = subPriority;
    }
  }
  validate(date, options) {
    return this.validateValue(date, this.value, options);
  }
  set(date, flags, options) {
    return this.setValue(date, flags, this.value, options);
  }
};
class DateTimezoneSetter extends Setter$1 {
  constructor(context, reference) {
    super();
    __publicField(this, "priority", TIMEZONE_UNIT_PRIORITY$1);
    __publicField(this, "subPriority", -1);
    this.context = context || ((date) => constructFrom$1(reference, date));
  }
  set(date, flags) {
    if (flags.timestampIsSet) return date;
    return constructFrom$1(date, transpose$1(date, this.context));
  }
}
let Parser$1 = class Parser {
  run(dateString, token2, match5, options) {
    const result = this.parse(dateString, token2, match5, options);
    if (!result) {
      return null;
    }
    return {
      setter: new ValueSetter$1(
        result.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: result.rest
    };
  }
  validate(_utcDate, _value, _options) {
    return true;
  }
};
let EraParser$1 = class EraParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 140);
    __publicField(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return match5.era(dateString, { width: "abbreviated" }) || match5.era(dateString, { width: "narrow" });
      // A, B
      case "GGGGG":
        return match5.era(dateString, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return match5.era(dateString, { width: "wide" }) || match5.era(dateString, { width: "abbreviated" }) || match5.era(dateString, { width: "narrow" });
    }
  }
  set(date, flags, value) {
    flags.era = value;
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
};
const numericPatterns$1 = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
};
const timezonePatterns$1 = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function mapValue$1(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern$1(pattern, dateString) {
  const matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern$1(pattern, dateString) {
  const matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  const sign2 = matchResult[1] === "+" ? 1 : -1;
  const hours2 = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  const minutes2 = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  const seconds2 = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign2 * (hours2 * millisecondsInHour$1 + minutes2 * millisecondsInMinute$1 + seconds2 * millisecondsInSecond$1),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned$1(dateString) {
  return parseNumericPattern$1(numericPatterns$1.anyDigitsSigned, dateString);
}
function parseNDigits$1(n2, dateString) {
  switch (n2) {
    case 1:
      return parseNumericPattern$1(numericPatterns$1.singleDigit, dateString);
    case 2:
      return parseNumericPattern$1(numericPatterns$1.twoDigits, dateString);
    case 3:
      return parseNumericPattern$1(numericPatterns$1.threeDigits, dateString);
    case 4:
      return parseNumericPattern$1(numericPatterns$1.fourDigits, dateString);
    default:
      return parseNumericPattern$1(new RegExp("^\\d{1," + n2 + "}"), dateString);
  }
}
function parseNDigitsSigned$1(n2, dateString) {
  switch (n2) {
    case 1:
      return parseNumericPattern$1(numericPatterns$1.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern$1(numericPatterns$1.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern$1(numericPatterns$1.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern$1(numericPatterns$1.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern$1(new RegExp("^-?\\d{1," + n2 + "}"), dateString);
  }
}
function dayPeriodEnumToHours$1(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear$1(twoDigitYear, currentYear) {
  const isCommonEra = currentYear > 0;
  const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  let result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    const rangeEnd = absCurrentYear + 50;
    const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
    const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex$4(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
let YearParser$1 = class YearParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 130);
    __publicField(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token2 === "yy"
    });
    switch (token2) {
      case "y":
        return mapValue$1(parseNDigits$1(4, dateString), valueCallback);
      case "yo":
        return mapValue$1(
          match5.ordinalNumber(dateString, {
            unit: "year"
          }),
          valueCallback
        );
      default:
        return mapValue$1(parseNDigits$1(token2.length, dateString), valueCallback);
    }
  }
  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }
  set(date, flags, value) {
    const currentYear = date.getFullYear();
    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear$1(
        value.year,
        currentYear
      );
      date.setFullYear(normalizedTwoDigitYear, 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    }
    const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
};
let LocalWeekYearParser$1 = class LocalWeekYearParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 130);
    __publicField(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token2 === "YY"
    });
    switch (token2) {
      case "Y":
        return mapValue$1(parseNDigits$1(4, dateString), valueCallback);
      case "Yo":
        return mapValue$1(
          match5.ordinalNumber(dateString, {
            unit: "year"
          }),
          valueCallback
        );
      default:
        return mapValue$1(parseNDigits$1(token2.length, dateString), valueCallback);
    }
  }
  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }
  set(date, flags, value, options) {
    const currentYear = getWeekYear$1(date, options);
    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear$1(
        value.year,
        currentYear
      );
      date.setFullYear(
        normalizedTwoDigitYear,
        0,
        options.firstWeekContainsDate
      );
      date.setHours(0, 0, 0, 0);
      return startOfWeek$1(date, options);
    }
    const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, options.firstWeekContainsDate);
    date.setHours(0, 0, 0, 0);
    return startOfWeek$1(date, options);
  }
};
let ISOWeekYearParser$1 = class ISOWeekYearParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 130);
    __publicField(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2) {
    if (token2 === "R") {
      return parseNDigitsSigned$1(4, dateString);
    }
    return parseNDigitsSigned$1(token2.length, dateString);
  }
  set(date, _flags, value) {
    const firstWeekOfYear = constructFrom$1(date, 0);
    firstWeekOfYear.setFullYear(value, 0, 4);
    firstWeekOfYear.setHours(0, 0, 0, 0);
    return startOfISOWeek$1(firstWeekOfYear);
  }
};
let ExtendedYearParser$1 = class ExtendedYearParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 130);
    __publicField(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token2) {
    if (token2 === "u") {
      return parseNDigitsSigned$1(4, dateString);
    }
    return parseNDigitsSigned$1(token2.length, dateString);
  }
  set(date, _flags, value) {
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
};
let QuarterParser$1 = class QuarterParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 120);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return parseNDigits$1(token2.length, dateString);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return match5.ordinalNumber(dateString, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return match5.quarter(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return match5.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return match5.quarter(dateString, {
          width: "wide",
          context: "formatting"
        }) || match5.quarter(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 4;
  }
  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
};
let StandAloneQuarterParser$1 = class StandAloneQuarterParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 120);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return parseNDigits$1(token2.length, dateString);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return match5.ordinalNumber(dateString, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return match5.quarter(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match5.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return match5.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return match5.quarter(dateString, {
          width: "wide",
          context: "standalone"
        }) || match5.quarter(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match5.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 4;
  }
  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
};
let MonthParser$1 = class MonthParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    __publicField(this, "priority", 110);
  }
  parse(dateString, token2, match5) {
    const valueCallback = (value) => value - 1;
    switch (token2) {
      // 1, 2, ..., 12
      case "M":
        return mapValue$1(
          parseNumericPattern$1(numericPatterns$1.month, dateString),
          valueCallback
        );
      // 01, 02, ..., 12
      case "MM":
        return mapValue$1(parseNDigits$1(2, dateString), valueCallback);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return mapValue$1(
          match5.ordinalNumber(dateString, {
            unit: "month"
          }),
          valueCallback
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return match5.month(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.month(dateString, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return match5.month(dateString, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return match5.month(dateString, { width: "wide", context: "formatting" }) || match5.month(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.month(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
};
let StandAloneMonthParser$1 = class StandAloneMonthParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 110);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    const valueCallback = (value) => value - 1;
    switch (token2) {
      // 1, 2, ..., 12
      case "L":
        return mapValue$1(
          parseNumericPattern$1(numericPatterns$1.month, dateString),
          valueCallback
        );
      // 01, 02, ..., 12
      case "LL":
        return mapValue$1(parseNDigits$1(2, dateString), valueCallback);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return mapValue$1(
          match5.ordinalNumber(dateString, {
            unit: "month"
          }),
          valueCallback
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return match5.month(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match5.month(dateString, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return match5.month(dateString, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return match5.month(dateString, { width: "wide", context: "standalone" }) || match5.month(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match5.month(dateString, { width: "narrow", context: "standalone" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
};
function setWeek$1(date, week, options) {
  const date_ = toDate$3(date, options == null ? void 0 : options.in);
  const diff2 = getWeek$2(date_, options) - week;
  date_.setDate(date_.getDate() - diff2 * 7);
  return toDate$3(date_, options == null ? void 0 : options.in);
}
let LocalWeekParser$1 = class LocalWeekParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 100);
    __publicField(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "w":
        return parseNumericPattern$1(numericPatterns$1.week, dateString);
      case "wo":
        return match5.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits$1(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 53;
  }
  set(date, _flags, value, options) {
    return startOfWeek$1(setWeek$1(date, value, options), options);
  }
};
function setISOWeek$1(date, week, options) {
  const _date = toDate$3(date, options == null ? void 0 : options.in);
  const diff2 = getISOWeek$1(_date, options) - week;
  _date.setDate(_date.getDate() - diff2 * 7);
  return _date;
}
let ISOWeekParser$1 = class ISOWeekParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 100);
    __publicField(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "I":
        return parseNumericPattern$1(numericPatterns$1.week, dateString);
      case "Io":
        return match5.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits$1(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 53;
  }
  set(date, _flags, value) {
    return startOfISOWeek$1(setISOWeek$1(date, value));
  }
};
const DAYS_IN_MONTH$2 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const DAYS_IN_MONTH_LEAP_YEAR$2 = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
let DateParser$1 = class DateParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "subPriority", 1);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "d":
        return parseNumericPattern$1(numericPatterns$1.date, dateString);
      case "do":
        return match5.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits$1(token2.length, dateString);
    }
  }
  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear2 = isLeapYearIndex$4(year);
    const month = date.getMonth();
    if (isLeapYear2) {
      return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR$2[month];
    } else {
      return value >= 1 && value <= DAYS_IN_MONTH$2[month];
    }
  }
  set(date, _flags, value) {
    date.setDate(value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
};
let DayOfYearParser$1 = class DayOfYearParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "subpriority", 1);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "D":
      case "DD":
        return parseNumericPattern$1(numericPatterns$1.dayOfYear, dateString);
      case "Do":
        return match5.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits$1(token2.length, dateString);
    }
  }
  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear2 = isLeapYearIndex$4(year);
    if (isLeapYear2) {
      return value >= 1 && value <= 366;
    } else {
      return value >= 1 && value <= 365;
    }
  }
  set(date, _flags, value) {
    date.setMonth(0, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
};
function setDay$1(date, day, options) {
  var _a3, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions$3();
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_b = (_a3 = options == null ? void 0 : options.locale) == null ? void 0 : _a3.options) == null ? void 0 : _b.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const date_ = toDate$3(date, options == null ? void 0 : options.in);
  const currentDay = date_.getDay();
  const remainder = day % 7;
  const dayIndex = (remainder + 7) % 7;
  const delta = 7 - weekStartsOn;
  const diff2 = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
  return addDays$1(date_, diff2, options);
}
let DayParser$1 = class DayParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return match5.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.day(dateString, { width: "short", context: "formatting" }) || match5.day(dateString, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return match5.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return match5.day(dateString, { width: "short", context: "formatting" }) || match5.day(dateString, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return match5.day(dateString, { width: "wide", context: "formatting" }) || match5.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.day(dateString, { width: "short", context: "formatting" }) || match5.day(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options) {
    date = setDay$1(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }
};
let LocalDayParser$1 = class LocalDayParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5, options) {
    const valueCallback = (value) => {
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
    };
    switch (token2) {
      // 3
      case "e":
      case "ee":
        return mapValue$1(parseNDigits$1(token2.length, dateString), valueCallback);
      // 3rd
      case "eo":
        return mapValue$1(
          match5.ordinalNumber(dateString, {
            unit: "day"
          }),
          valueCallback
        );
      // Tue
      case "eee":
        return match5.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.day(dateString, { width: "short", context: "formatting" }) || match5.day(dateString, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return match5.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return match5.day(dateString, { width: "short", context: "formatting" }) || match5.day(dateString, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return match5.day(dateString, { width: "wide", context: "formatting" }) || match5.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.day(dateString, { width: "short", context: "formatting" }) || match5.day(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options) {
    date = setDay$1(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }
};
let StandAloneLocalDayParser$1 = class StandAloneLocalDayParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5, options) {
    const valueCallback = (value) => {
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
    };
    switch (token2) {
      // 3
      case "c":
      case "cc":
        return mapValue$1(parseNDigits$1(token2.length, dateString), valueCallback);
      // 3rd
      case "co":
        return mapValue$1(
          match5.ordinalNumber(dateString, {
            unit: "day"
          }),
          valueCallback
        );
      // Tue
      case "ccc":
        return match5.day(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match5.day(dateString, { width: "short", context: "standalone" }) || match5.day(dateString, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return match5.day(dateString, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return match5.day(dateString, { width: "short", context: "standalone" }) || match5.day(dateString, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return match5.day(dateString, { width: "wide", context: "standalone" }) || match5.day(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match5.day(dateString, { width: "short", context: "standalone" }) || match5.day(dateString, { width: "narrow", context: "standalone" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options) {
    date = setDay$1(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }
};
function setISODay$1(date, day, options) {
  const date_ = toDate$3(date, options == null ? void 0 : options.in);
  const currentDay = getISODay$1(date_, options);
  const diff2 = day - currentDay;
  return addDays$1(date_, diff2, options);
}
let ISODayParser$1 = class ISODayParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    const valueCallback = (value) => {
      if (value === 0) {
        return 7;
      }
      return value;
    };
    switch (token2) {
      // 2
      case "i":
      case "ii":
        return parseNDigits$1(token2.length, dateString);
      // 2nd
      case "io":
        return match5.ordinalNumber(dateString, { unit: "day" });
      // Tue
      case "iii":
        return mapValue$1(
          match5.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          }),
          valueCallback
        );
      // T
      case "iiiii":
        return mapValue$1(
          match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          }),
          valueCallback
        );
      // Tu
      case "iiiiii":
        return mapValue$1(
          match5.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          }),
          valueCallback
        );
      // Tuesday
      case "iiii":
      default:
        return mapValue$1(
          match5.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          }),
          valueCallback
        );
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 7;
  }
  set(date, _flags, value) {
    date = setISODay$1(date, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
};
let AMPMParser$1 = class AMPMParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 80);
    __publicField(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "a":
      case "aa":
      case "aaa":
        return match5.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return match5.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours$1(value), 0, 0, 0);
    return date;
  }
};
let AMPMMidnightParser$1 = class AMPMMidnightParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 80);
    __publicField(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "b":
      case "bb":
      case "bbb":
        return match5.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return match5.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours$1(value), 0, 0, 0);
    return date;
  }
};
let DayPeriodParser$1 = class DayPeriodParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 80);
    __publicField(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "B":
      case "BB":
      case "BBB":
        return match5.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return match5.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours$1(value), 0, 0, 0);
    return date;
  }
};
let Hour1to12Parser$1 = class Hour1to12Parser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 70);
    __publicField(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "h":
        return parseNumericPattern$1(numericPatterns$1.hour12h, dateString);
      case "ho":
        return match5.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits$1(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 12;
  }
  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else if (!isPM && value === 12) {
      date.setHours(0, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }
};
let Hour0to23Parser$1 = class Hour0to23Parser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 70);
    __publicField(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "H":
        return parseNumericPattern$1(numericPatterns$1.hour23h, dateString);
      case "Ho":
        return match5.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits$1(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 23;
  }
  set(date, _flags, value) {
    date.setHours(value, 0, 0, 0);
    return date;
  }
};
let Hour0To11Parser$1 = class Hour0To11Parser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 70);
    __publicField(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "K":
        return parseNumericPattern$1(numericPatterns$1.hour11h, dateString);
      case "Ko":
        return match5.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits$1(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }
};
let Hour1To24Parser$1 = class Hour1To24Parser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 70);
    __publicField(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "k":
        return parseNumericPattern$1(numericPatterns$1.hour24h, dateString);
      case "ko":
        return match5.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits$1(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 24;
  }
  set(date, _flags, value) {
    const hours2 = value <= 24 ? value % 24 : value;
    date.setHours(hours2, 0, 0, 0);
    return date;
  }
};
let MinuteParser$1 = class MinuteParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 60);
    __publicField(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "m":
        return parseNumericPattern$1(numericPatterns$1.minute, dateString);
      case "mo":
        return match5.ordinalNumber(dateString, { unit: "minute" });
      default:
        return parseNDigits$1(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 59;
  }
  set(date, _flags, value) {
    date.setMinutes(value, 0, 0);
    return date;
  }
};
let SecondParser$1 = class SecondParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 50);
    __publicField(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "s":
        return parseNumericPattern$1(numericPatterns$1.second, dateString);
      case "so":
        return match5.ordinalNumber(dateString, { unit: "second" });
      default:
        return parseNDigits$1(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 59;
  }
  set(date, _flags, value) {
    date.setSeconds(value, 0);
    return date;
  }
};
let FractionOfSecondParser$1 = class FractionOfSecondParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 30);
    __publicField(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(dateString, token2) {
    const valueCallback = (value) => Math.trunc(value * Math.pow(10, -token2.length + 3));
    return mapValue$1(parseNDigits$1(token2.length, dateString), valueCallback);
  }
  set(date, _flags, value) {
    date.setMilliseconds(value);
    return date;
  }
};
let ISOTimezoneWithZParser$1 = class ISOTimezoneWithZParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 10);
    __publicField(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(dateString, token2) {
    switch (token2) {
      case "X":
        return parseTimezonePattern$1(
          timezonePatterns$1.basicOptionalMinutes,
          dateString
        );
      case "XX":
        return parseTimezonePattern$1(timezonePatterns$1.basic, dateString);
      case "XXXX":
        return parseTimezonePattern$1(
          timezonePatterns$1.basicOptionalSeconds,
          dateString
        );
      case "XXXXX":
        return parseTimezonePattern$1(
          timezonePatterns$1.extendedOptionalSeconds,
          dateString
        );
      case "XXX":
      default:
        return parseTimezonePattern$1(timezonePatterns$1.extended, dateString);
    }
  }
  set(date, flags, value) {
    if (flags.timestampIsSet) return date;
    return constructFrom$1(
      date,
      date.getTime() - getTimezoneOffsetInMilliseconds$2(date) - value
    );
  }
};
let ISOTimezoneParser$1 = class ISOTimezoneParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 10);
    __publicField(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(dateString, token2) {
    switch (token2) {
      case "x":
        return parseTimezonePattern$1(
          timezonePatterns$1.basicOptionalMinutes,
          dateString
        );
      case "xx":
        return parseTimezonePattern$1(timezonePatterns$1.basic, dateString);
      case "xxxx":
        return parseTimezonePattern$1(
          timezonePatterns$1.basicOptionalSeconds,
          dateString
        );
      case "xxxxx":
        return parseTimezonePattern$1(
          timezonePatterns$1.extendedOptionalSeconds,
          dateString
        );
      case "xxx":
      default:
        return parseTimezonePattern$1(timezonePatterns$1.extended, dateString);
    }
  }
  set(date, flags, value) {
    if (flags.timestampIsSet) return date;
    return constructFrom$1(
      date,
      date.getTime() - getTimezoneOffsetInMilliseconds$2(date) - value
    );
  }
};
let TimestampSecondsParser$1 = class TimestampSecondsParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 40);
    __publicField(this, "incompatibleTokens", "*");
  }
  parse(dateString) {
    return parseAnyDigitsSigned$1(dateString);
  }
  set(date, _flags, value) {
    return [constructFrom$1(date, value * 1e3), { timestampIsSet: true }];
  }
};
let TimestampMillisecondsParser$1 = class TimestampMillisecondsParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 20);
    __publicField(this, "incompatibleTokens", "*");
  }
  parse(dateString) {
    return parseAnyDigitsSigned$1(dateString);
  }
  set(date, _flags, value) {
    return [constructFrom$1(date, value), { timestampIsSet: true }];
  }
};
const parsers$1 = {
  G: new EraParser$1(),
  y: new YearParser$1(),
  Y: new LocalWeekYearParser$1(),
  R: new ISOWeekYearParser$1(),
  u: new ExtendedYearParser$1(),
  Q: new QuarterParser$1(),
  q: new StandAloneQuarterParser$1(),
  M: new MonthParser$1(),
  L: new StandAloneMonthParser$1(),
  w: new LocalWeekParser$1(),
  I: new ISOWeekParser$1(),
  d: new DateParser$1(),
  D: new DayOfYearParser$1(),
  E: new DayParser$1(),
  e: new LocalDayParser$1(),
  c: new StandAloneLocalDayParser$1(),
  i: new ISODayParser$1(),
  a: new AMPMParser$1(),
  b: new AMPMMidnightParser$1(),
  B: new DayPeriodParser$1(),
  h: new Hour1to12Parser$1(),
  H: new Hour0to23Parser$1(),
  K: new Hour0To11Parser$1(),
  k: new Hour1To24Parser$1(),
  m: new MinuteParser$1(),
  s: new SecondParser$1(),
  S: new FractionOfSecondParser$1(),
  X: new ISOTimezoneWithZParser$1(),
  x: new ISOTimezoneParser$1(),
  t: new TimestampSecondsParser$1(),
  T: new TimestampMillisecondsParser$1()
};
const formattingTokensRegExp$2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
const longFormattingTokensRegExp$3 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp$2 = /^'([^]*?)'?$/;
const doubleQuoteRegExp$2 = /''/g;
const notWhitespaceRegExp$1 = /\S/;
const unescapedLatinCharacterRegExp$2 = /[a-zA-Z]/;
function parse$4(dateStr, formatStr, referenceDate, options) {
  var _a3, _b, _c, _d;
  const invalidDate2 = () => constructFrom$1(referenceDate, NaN);
  const defaultOptions2 = getDefaultOptions$2();
  const locale2 = defaultOptions2.locale ?? enUS$1;
  const firstWeekContainsDate = defaultOptions2.firstWeekContainsDate ?? ((_b = (_a3 = defaultOptions2.locale) == null ? void 0 : _a3.options) == null ? void 0 : _b.firstWeekContainsDate) ?? 1;
  const weekStartsOn = defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2
  };
  const setters = [new DateTimezoneSetter(options == null ? void 0 : options.in, referenceDate)];
  const tokens2 = formatStr.match(longFormattingTokensRegExp$3).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter in longFormatters$1) {
      const longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$2);
  const usedTokens = [];
  for (let token2 of tokens2) {
    if (isProtectedWeekYearToken$1(token2)) {
      warnOrThrowProtectedError$1(token2, formatStr, dateStr);
    }
    if (isProtectedDayOfYearToken$1(token2)) {
      warnOrThrowProtectedError$1(token2, formatStr, dateStr);
    }
    const firstCharacter = token2[0];
    const parser = parsers$1[firstCharacter];
    if (parser) {
      const { incompatibleTokens } = parser;
      if (Array.isArray(incompatibleTokens)) {
        const incompatibleToken = usedTokens.find(
          (usedToken) => incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter
        );
        if (incompatibleToken) {
          throw new RangeError(
            `The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token2}\` at the same time`
          );
        }
      } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
        throw new RangeError(
          `The format string mustn't contain \`${token2}\` and any other token at the same time`
        );
      }
      usedTokens.push({ token: firstCharacter, fullToken: token2 });
      const parseResult = parser.run(
        dateStr,
        token2,
        locale2.match,
        subFnOptions
      );
      if (!parseResult) {
        return invalidDate2();
      }
      setters.push(parseResult.setter);
      dateStr = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp$2)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + firstCharacter + "`"
        );
      }
      if (token2 === "''") {
        token2 = "'";
      } else if (firstCharacter === "'") {
        token2 = cleanEscapedString$2(token2);
      }
      if (dateStr.indexOf(token2) === 0) {
        dateStr = dateStr.slice(token2.length);
      } else {
        return invalidDate2();
      }
    }
  }
  if (dateStr.length > 0 && notWhitespaceRegExp$1.test(dateStr)) {
    return invalidDate2();
  }
  const uniquePrioritySetters = setters.map((setter) => setter.priority).sort((a2, b2) => b2 - a2).filter((priority, index2, array) => array.indexOf(priority) === index2).map(
    (priority) => setters.filter((setter) => setter.priority === priority).sort((a2, b2) => b2.subPriority - a2.subPriority)
  ).map((setterArray) => setterArray[0]);
  let date = toDate$3(referenceDate, options == null ? void 0 : options.in);
  if (isNaN(+date)) return invalidDate2();
  const flags = {};
  for (const setter of uniquePrioritySetters) {
    if (!setter.validate(date, subFnOptions)) {
      return invalidDate2();
    }
    const result = setter.set(date, flags, subFnOptions);
    if (Array.isArray(result)) {
      date = result[0];
      Object.assign(flags, result[1]);
    } else {
      date = result;
    }
  }
  return date;
}
function cleanEscapedString$2(input) {
  return input.match(escapedStringRegExp$2)[1].replace(doubleQuoteRegExp$2, "'");
}
function subDays$1(date, amount, options) {
  return addDays$1(date, -1, options);
}
function parseISO$1(argument, options) {
  const invalidDate2 = () => constructFrom$1(options == null ? void 0 : options.in, NaN);
  const additionalDigits = 2;
  const dateStrings = splitDateString$2(argument);
  let date;
  if (dateStrings.date) {
    const parseYearResult = parseYear$2(dateStrings.date, additionalDigits);
    date = parseDate$3(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(+date)) return invalidDate2();
  const timestamp = +date;
  let time = 0;
  let offset3;
  if (dateStrings.time) {
    time = parseTime$2(dateStrings.time);
    if (isNaN(time)) return invalidDate2();
  }
  if (dateStrings.timezone) {
    offset3 = parseTimezone$1(dateStrings.timezone);
    if (isNaN(offset3)) return invalidDate2();
  } else {
    const tmpDate = new Date(timestamp + time);
    const result = toDate$3(0, options == null ? void 0 : options.in);
    result.setFullYear(
      tmpDate.getUTCFullYear(),
      tmpDate.getUTCMonth(),
      tmpDate.getUTCDate()
    );
    result.setHours(
      tmpDate.getUTCHours(),
      tmpDate.getUTCMinutes(),
      tmpDate.getUTCSeconds(),
      tmpDate.getUTCMilliseconds()
    );
    return result;
  }
  return toDate$3(timestamp + time + offset3, options == null ? void 0 : options.in);
}
const patterns$3 = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
const dateRegex$2 = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const timeRegex$2 = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const timezoneRegex$1 = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString$2(dateString) {
  const dateStrings = {};
  const array = dateString.split(patterns$3.dateTimeDelimiter);
  let timeString;
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns$3.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns$3.timeZoneDelimiter)[0];
      timeString = dateString.substr(
        dateStrings.date.length,
        dateString.length
      );
    }
  }
  if (timeString) {
    const token2 = patterns$3.timezone.exec(timeString);
    if (token2) {
      dateStrings.time = timeString.replace(token2[1], "");
      dateStrings.timezone = token2[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear$2(dateString, additionalDigits) {
  const regex2 = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)"
  );
  const captures = dateString.match(regex2);
  if (!captures) return { year: NaN, restDateString: "" };
  const year = captures[1] ? parseInt(captures[1]) : null;
  const century = captures[2] ? parseInt(captures[2]) : null;
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate$3(dateString, year) {
  if (year === null) return /* @__PURE__ */ new Date(NaN);
  const captures = dateString.match(dateRegex$2);
  if (!captures) return /* @__PURE__ */ new Date(NaN);
  const isWeekDate = !!captures[4];
  const dayOfYear = parseDateUnit$1(captures[1]);
  const month = parseDateUnit$1(captures[2]) - 1;
  const day = parseDateUnit$1(captures[3]);
  const week = parseDateUnit$1(captures[4]);
  const dayOfWeek = parseDateUnit$1(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate$2(year, week, dayOfWeek)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    return dayOfISOWeekYear$2(year, week, dayOfWeek);
  } else {
    const date = /* @__PURE__ */ new Date(0);
    if (!validateDate$2(year, month, day) || !validateDayOfYearDate$2(year, dayOfYear)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit$1(value) {
  return value ? parseInt(value) : 1;
}
function parseTime$2(timeString) {
  const captures = timeString.match(timeRegex$2);
  if (!captures) return NaN;
  const hours2 = parseTimeUnit$1(captures[1]);
  const minutes2 = parseTimeUnit$1(captures[2]);
  const seconds2 = parseTimeUnit$1(captures[3]);
  if (!validateTime$2(hours2, minutes2, seconds2)) {
    return NaN;
  }
  return hours2 * millisecondsInHour$1 + minutes2 * millisecondsInMinute$1 + seconds2 * 1e3;
}
function parseTimeUnit$1(value) {
  return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone$1(timezoneString) {
  if (timezoneString === "Z") return 0;
  const captures = timezoneString.match(timezoneRegex$1);
  if (!captures) return 0;
  const sign2 = captures[1] === "+" ? -1 : 1;
  const hours2 = parseInt(captures[2]);
  const minutes2 = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone$2(hours2, minutes2)) {
    return NaN;
  }
  return sign2 * (hours2 * millisecondsInHour$1 + minutes2 * millisecondsInMinute$1);
}
function dayOfISOWeekYear$2(isoWeekYear, week, day) {
  const date = /* @__PURE__ */ new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  const fourthOfJanuaryDay = date.getUTCDay() || 7;
  const diff2 = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff2);
  return date;
}
const daysInMonths$1 = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex$3(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate$2(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths$1[month] || (isLeapYearIndex$3(year) ? 29 : 28));
}
function validateDayOfYearDate$2(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex$3(year) ? 366 : 365);
}
function validateWeekDate$2(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime$2(hours2, minutes2, seconds2) {
  if (hours2 === 24) {
    return minutes2 === 0 && seconds2 === 0;
  }
  return seconds2 >= 0 && seconds2 < 60 && minutes2 >= 0 && minutes2 < 60 && hours2 >= 0 && hours2 < 25;
}
function validateTimezone$2(_hours, minutes2) {
  return minutes2 >= 0 && minutes2 <= 59;
}
function setHours$1(date, hours2, options) {
  const _date = toDate$3(date, options == null ? void 0 : options.in);
  _date.setHours(hours2);
  return _date;
}
function setMinutes$1(date, minutes2, options) {
  const date_ = toDate$3(date, options == null ? void 0 : options.in);
  date_.setMinutes(minutes2);
  return date_;
}
const parseDateOrString = (input) => {
  if (typeof input === "string") {
    return parseISODate(input);
  } else {
    return input;
  }
};
const parseISODate = (isoString) => isoString !== void 0 ? parseISO$1(isoString) : void 0;
const formatISODate = (date) => date !== void 0 ? formatISO(date, { representation: "date" }) : void 0;
const formatISODateTimeUTC = (date) => date !== void 0 ? format$2(date, "yyyy-MM-dd'T'HH:mm:ss") : void 0;
const setHoursAndMinutes = (date, hours2, minutes2) => setMinutes$1(setHours$1(date, hours2), minutes2);
let random = (bytes) => crypto.getRandomValues(new Uint8Array(bytes));
let customRandom = (alphabet2, defaultSize, getRandom) => {
  let mask = (2 << Math.log2(alphabet2.length - 1)) - 1;
  let step = -~(1.6 * mask * defaultSize / alphabet2.length);
  return (size2 = defaultSize) => {
    let id = "";
    while (true) {
      let bytes = getRandom(step);
      let j2 = step | 0;
      while (j2--) {
        id += alphabet2[bytes[j2] & mask] || "";
        if (id.length >= size2) return id;
      }
    }
  };
};
let customAlphabet = (alphabet2, size2 = 21) => customRandom(alphabet2, size2 | 0, random);
var byteToHex = [];
for (var i$2 = 0; i$2 < 256; ++i$2) {
  byteToHex.push((i$2 + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset3 = 0) {
  return (byteToHex[arr[offset3 + 0]] + byteToHex[arr[offset3 + 1]] + byteToHex[arr[offset3 + 2]] + byteToHex[arr[offset3 + 3]] + "-" + byteToHex[arr[offset3 + 4]] + byteToHex[arr[offset3 + 5]] + "-" + byteToHex[arr[offset3 + 6]] + byteToHex[arr[offset3 + 7]] + "-" + byteToHex[arr[offset3 + 8]] + byteToHex[arr[offset3 + 9]] + "-" + byteToHex[arr[offset3 + 10]] + byteToHex[arr[offset3 + 11]] + byteToHex[arr[offset3 + 12]] + byteToHex[arr[offset3 + 13]] + byteToHex[arr[offset3 + 14]] + byteToHex[arr[offset3 + 15]]).toLowerCase();
}
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
var randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const native = {
  randomUUID
};
function v4(options, buf, offset3) {
  if (native.randomUUID && true && !options) {
    return native.randomUUID();
  }
  options = options || {};
  var rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  return unsafeStringify(rnds);
}
const alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
const idGenerator = customAlphabet(alphabet, 12);
const uuid = () => v4();
const isChoiceWithId = (choice) => choice.id !== void 0;
const isChoiceObject = (choice) => typeof choice === "object" && !Array.isArray(choice);
const isChoiceWithMetadata = (choice) => isChoiceObject(choice) && choice.metadata instanceof Array && choice.metadata.length > 0;
const hasChoices = (field) => "choices" in field && field.choices !== void 0 && field.choices !== null && field.choices.length > 1;
const normalizedChoice = (choice) => {
  if (Array.isArray(choice)) {
    return {
      label: choice[0],
      value: choice[1]
    };
  } else if (typeof choice === "string") {
    return {
      label: choice,
      value: choice
    };
  } else if (choice.value === void 0 || choice.value === null || choice.value === "") {
    return {
      ...choice,
      value: choice.label
    };
  } else {
    return choice;
  }
};
const normalizedChoiceWithId = (choiceOption) => {
  const choice = normalizedChoice(choiceOption);
  if (isChoiceWithId(choice)) {
    return choice;
  } else {
    return {
      ...choice,
      id: idGenerator()
    };
  }
};
const normalizedFieldChoices = (field) => {
  if (!("choices" in field) || !field.choices) {
    return [];
  } else {
    return field.choices.map(normalizedChoiceWithId);
  }
};
const isFieldContainer = (field) => field.type === "page" || field.type === "section";
const isInfoField = (field) => field.type === "info";
const isRoomBlockField$1 = (field) => field.type === "room_block";
const isPage$1 = (field) => field.type === "page";
function findField(fields, name2) {
  if (!fields) {
    return null;
  }
  for (const theField of fields) {
    if (theField.name === name2) {
      return theField;
    }
    if (isFieldContainer(theField)) {
      const found2 = findField(theField.fields, name2);
      if (found2) return found2;
    }
  }
  return null;
}
const findFieldWithContainer = (fields, name2) => {
  if (!fields) {
    return {};
  }
  for (const theField of fields) {
    if (theField.name === name2) {
      return { field: theField, container: fields };
    }
    if (isFieldContainer(theField)) {
      const found2 = findFieldWithContainer(theField.fields, name2);
      if (found2.field) return found2;
    }
  }
  return {};
};
function findFieldWithParent(fields, name2) {
  var _a3;
  for (const theField of fields) {
    if (theField.name === name2) {
      return { field: theField };
    }
    if (isFieldContainer(theField) && ((_a3 = theField.fields) == null ? void 0 : _a3.length) > 0) {
      const found2 = findFieldWithParent(theField.fields, name2);
      if (found2.field) {
        if (!found2.parent) {
          found2.parent = theField;
        }
        return found2;
      }
    }
  }
  return {};
}
function flatFields$2(container) {
  if (!container.fields) {
    return [];
  }
  const result = [];
  container.fields.forEach((field) => {
    result.push(field);
    if (isFieldContainer(field)) {
      result.push(...flatFields$2(field));
    }
  });
  return result;
}
function getSelectedItems$1(state) {
  const selectedPage = state.fields.find((p2) => p2.name === state.selectedPageName) || state.fields[0];
  const selectedField = state.selectedFieldName !== void 0 ? findField(state.fields, state.selectedFieldName) : null;
  return { selectedPage, selectedField };
}
const containsAttendeeReference = (field) => field.fields.some(
  (f2) => f2.type === "attendee_reference" || isFieldContainer(f2) && containsAttendeeReference(f2)
);
const isAttendeeReferenceContainer = (field) => isFieldContainer(field) && containsAttendeeReference(field);
const protectFromHideOrDelete = (field, settings) => settings.protectAttendeeReferenceFields && (isAttendeeReferenceContainer(field) || field.type === "attendee_reference");
const getRootItem = (field, form) => {
  if (field.type === "page") {
    return field;
  }
  const { parent: parent2 } = findFieldWithParent(form.fields, field.name);
  if (parent2 === void 0) {
    throw new Error("Field has no parent");
  }
  if (parent2.type === "page") {
    return parent2;
  }
  return getRootItem(parent2, form);
};
const complexFieldTypesEnabled = (formSettings) => formSettings.sessionBookingEnabled || formSettings.roomingEnabled || formSettings.documentUploadsEnabled || formSettings.leadScannersEnabled;
const isPreRegPage = (field) => field.type === "page" && field.phase === "pretrack";
const isPreRegField = (field, form) => isPreRegPage(field) || isPreRegPage(getRootItem(field, form));
const getPhasedPages = (pages) => pages.reduce(
  (acc, page) => {
    if (isPreRegPage(page)) {
      acc.pretrack.push(page);
    } else {
      acc.default.push(page);
    }
    return acc;
  },
  { pretrack: [], default: [] }
);
const getPreRegPages = (form) => form.fields.filter(isPreRegPage);
const getPreRegFields = (form) => getPreRegPages(form).flatMap((page) => flatFields$2(page));
const isPreRegPageSelected = (form, editorState) => {
  const selectedPage = form.fields.find(
    (f2) => f2.name === editorState.selectedPageName
  );
  return selectedPage !== void 0 && isPreRegPage(selectedPage);
};
const isRadioField = (field) => (field.type === "string" || field.type === "integer") && field.choices !== void 0 && field.widget === "radio";
const isDropDownField = (field) => (field.type === "string" || field.type === "integer") && field.choices !== void 0 && field.widget !== "radio";
const isCheckboxField = (field) => field.type === "boolean";
const isTextField = (field) => field.type === "time" || field.type === "string" && (field.widget === void 0 || field.widget === "text" || field.widget === "" || field.widget === null) && (field.choices === void 0 || field.choices === null);
const isTextAreaField = (field) => field.type === "string" && field.widget === "textarea";
const isEmailField = (field) => field.type === "string" && field.widget === "email";
const isAttendeeReferenceField = (field) => field.type === "attendee_reference";
const isPhoneNumberField = (field) => field.type === "telephone";
const isDateField = (field) => field.type === "date";
const isIntegerField = (field) => field.type === "integer" && (field.choices === void 0 || field.choices === null);
const isDocumentUpload = (field) => field.type === "document";
const isSection = (field) => field.type === "section";
const isPage = (field) => field.type === "page";
const isRoomBlockField = (field) => field.type === "room_block";
const isSessionField = (field) => field.type === "session_booking";
const isLeadScannerField = (field) => field.type === "lead_scanner";
const inputFieldWithKind = (field) => {
  if (isRadioField(field)) {
    return Object.assign({}, field, { kind: "radio" });
  }
  if (isDropDownField(field)) {
    return Object.assign({}, field, { kind: "dropdown" });
  }
  if (isTextField(field)) {
    return Object.assign({}, field, { kind: "text" });
  }
  if (isTextAreaField(field)) {
    return Object.assign({}, field, {
      kind: "textarea"
    });
  }
  if (isCheckboxField(field)) {
    return Object.assign({}, field, { kind: "checkbox" });
  }
  if (isEmailField(field)) {
    return Object.assign({}, field, { kind: "email" });
  }
  if (isAttendeeReferenceField(field)) {
    return Object.assign({}, field, {
      kind: "attendee_reference"
    });
  }
  if (isPhoneNumberField(field)) {
    return Object.assign({}, field, {
      kind: "telephone"
    });
  }
  if (isIntegerField(field)) {
    return Object.assign({}, field, { kind: "integer" });
  }
  if (isDateField(field)) {
    return Object.assign({}, field, { kind: "date" });
  }
  if (isDocumentUpload(field)) {
    return Object.assign({}, field, {
      kind: "document"
    });
  }
  console.error("Failed to find field", field);
  throw new Error("Failed to find field");
};
const formItemToV2 = (field) => {
  var _a3;
  if (isSection(field)) {
    return Object.assign({}, field, {
      fields: ((_a3 = field.fields) == null ? void 0 : _a3.map(formItemToV2)) || []
    });
  }
  if (isPage(field)) {
    return Object.assign({}, field, {
      fields: field.fields.map(formItemToV2)
    });
  }
  if (isInfoField(field) || isRoomBlockField(field) || isSessionField(field) || isLeadScannerField(field)) {
    return field;
  }
  return inputFieldWithKind(field);
};
const union = (a2, b2) => /* @__PURE__ */ new Set([...Array.from(a2.values()), ...Array.from(b2.values())]);
const getMetaValues = (metaKey, metadata) => new Set(
  metadata.filter(({ key: key2 }) => key2 === metaKey).map(({ value }) => value)
);
const getSlotsTagValues = (tag2, session) => session.slots.reduce(
  (tags2, slot) => slot.metadata !== void 0 ? union(tags2, getMetaValues(tag2, slot.metadata)) : tags2,
  /* @__PURE__ */ new Set()
);
const getSessionsTagValues = (tag2, sessions) => sessions.reduce(
  (tags2, session) => union(tags2, getSlotsTagValues(tag2, session)),
  /* @__PURE__ */ new Set()
);
const getTicketTypeTagValues = (tag2, track2) => {
  var _a3;
  return ((_a3 = track2.ticketTypes) == null ? void 0 : _a3.reduce(
    (tags2, ticketType) => ticketType.metadata !== void 0 ? union(tags2, getMetaValues(tag2, ticketType.metadata)) : tags2,
    /* @__PURE__ */ new Set()
  )) || /* @__PURE__ */ new Set();
};
const getTracksTagValues = (tag2, tracks) => tracks.reduce(
  (tags2, track2) => union(tags2, getTicketTypeTagValues(tag2, track2)),
  /* @__PURE__ */ new Set()
);
const EVENT_PATH = "EVENT_PATH";
const getFormItemTagValues = (item) => {
  if (isDropDownField(item)) {
    return item.choices.reduce((tags2, choice) => {
      if (isChoiceWithMetadata(choice)) {
        return union(tags2, getMetaValues(EVENT_PATH, choice.metadata));
      }
      return tags2;
    }, /* @__PURE__ */ new Set());
  } else if (isCheckboxField(item)) {
    return getMetaValues(EVENT_PATH, item.metadata || []);
  } else {
    return /* @__PURE__ */ new Set();
  }
};
const getPreRegEventPathValues = (form) => getPreRegFields(form).reduce((tags2, field) => {
  return union(tags2, getFormItemTagValues(field));
}, /* @__PURE__ */ new Set());
const getEventPathValues = (form, tracks, sessions) => {
  let eventPaths = getPreRegEventPathValues(form);
  if (tracks !== void 0) {
    eventPaths = union(eventPaths, getTracksTagValues(EVENT_PATH, tracks));
  }
  if (sessions !== void 0) {
    eventPaths = union(eventPaths, getSessionsTagValues(EVENT_PATH, sessions));
  }
  return eventPaths;
};
function isValidMetaTag(metaTag) {
  return typeof metaTag.key === "string" && typeof metaTag.value === "string" && metaTag.key.length > 0 && metaTag.value.length > 0;
}
const isDependTarget = (field) => field.type === "boolean" || field.type === "session_booking" || field.type === "room_block" || hasChoices(field);
const getDependTargets = (form) => flatFields$2(form).filter(isDependTarget);
const getFieldDependTargets = (form, field) => getDependTargets(form).filter((targ) => canDependOnField(field, targ, form));
const getDependTargetsWithEventPath = (form, field, sessions, tracks) => {
  const fieldTargets = getFieldDependTargets(form, field);
  const eventPaths = getEventPathValues(form, tracks, sessions);
  if (sessions !== void 0 && eventPaths.size > 0) {
    return ["EVENT_PATH", ...fieldTargets];
  } else {
    return fieldTargets;
  }
};
const canDependOnField = (field, dependCandidate, form) => {
  if (field.name === dependCandidate.name) {
    return false;
  }
  if (isPreRegField(field, form)) {
    return isPreRegField(dependCandidate, form);
  }
  return true;
};
const getDependTarget = (form, name2) => getDependTargets(form).find((f2) => f2.name === name2);
const targetName = (target) => target === "EVENT_PATH" ? "EVENT_PATH" : target.name;
const isDependsField = (target) => target !== "EVENT_PATH";
const isDependantField = (targetField, sourceFieldName) => {
  if (targetField.dependsOn === void 0 || targetField.dependsOn === null) {
    return false;
  }
  if (Array.isArray(targetField.dependsOn)) {
    return targetField.dependsOn[0] === sourceFieldName;
  }
  return targetField.dependsOn === sourceFieldName;
};
const hasIncludeRoomTypes = (field) => field.includeRoomTypes !== void 0 && field.includeRoomTypes.length > 0;
const hasRoomBlockField = (form, roomBlock) => flatFields$2(form).some(
  (f2) => f2.type === "room_block" && f2.roomBlockId === roomBlock.id
);
const hasIncludeSlots = (field) => field.includeSlots !== void 0 && field.includeSlots.length > 0;
const getFieldForSession = (form, session) => flatFields$2(form).find(
  (f2) => f2.type === "session_booking" && f2.session === session.id
);
const hasTracksSelected = (field) => field.tracks !== void 0 && field.tracks.length > 0;
const hasTracks = (field) => "tracks" in field && field.tracks !== void 0 && (field == null ? void 0 : field.tracks.length) > 0;
const getTracksVisibilitySource = (field, form) => {
  const { parent: parent2 } = findFieldWithParent(form.fields, field.name);
  if (parent2 === void 0) {
    return hasTracks(field) ? field : void 0;
  }
  const ancestorSource = getTracksVisibilitySource(parent2, form);
  if (ancestorSource !== void 0) {
    return ancestorSource;
  } else {
    return hasTracks(parent2) ? parent2 : void 0;
  }
};
const isTrackVisible = (field, track2) => {
  var _a3;
  return field.tracks === void 0 || field.tracks.length === 0 || ((_a3 = field == null ? void 0 : field.tracks) == null ? void 0 : _a3.includes(track2.id));
};
function itemYMapKey(itemId) {
  return `item:${itemId}`;
}
function isRootItem(item) {
  return !("parentId" in item);
}
function isChildItem(item) {
  return "parentId" in item;
}
function getYFormItemByID(id, ydoc) {
  return getYFormItem(itemYMapKey(id), ydoc);
}
function getYFormItem(prefixedId, ydoc) {
  const item = {};
  Object.entries(ydoc.getMap(prefixedId).toJSON()).forEach(([key2, value]) => {
    if (typeof value === "bigint") {
      item[key2] = Number(value);
    } else {
      item[key2] = value;
    }
  });
  return item;
}
function getItems(ydoc) {
  const itemIds = Array.from(ydoc.getMap("itemIdMap").keys());
  return itemIds.map((itemId) => getYFormItem(itemId, ydoc));
}
function getPages$1(ydoc) {
  const pagesArray = getItems(ydoc).filter(isRootItem);
  pagesArray.sort((a2, b2) => Number(a2.sort) - Number(b2.sort));
  return pagesArray;
}
function getPhasedPageCollection(ydoc, forPageName, phasesEnabled) {
  const pages = getPages$1(ydoc);
  if (!phasesEnabled) {
    return pages;
  }
  const page = pages.find((p2) => p2.name === forPageName);
  if (page === void 0) {
    throw new Error(`Page ${forPageName} not found`);
  }
  if (isPreRegPage(page)) {
    return pages.filter(isPreRegPage);
  } else {
    return pages.filter((p2) => !isPreRegPage(p2));
  }
}
function getChildItems(ydoc, parentId) {
  const children = getItems(ydoc).filter(
    (item) => isChildItem(item) && item.parentId === parentId
  );
  children.sort((a2, b2) => Number(a2.sort) - Number(b2.sort));
  return children;
}
function getItemsWithChildren(ydoc, parentId) {
  const items = getChildItems(ydoc, parentId);
  return items.map((item) => {
    if (isFieldContainer(item)) {
      return {
        ...item,
        fields: getItemsWithChildren(ydoc, item.name)
      };
    } else {
      return item;
    }
  });
}
function getFieldsAsTree(ydoc) {
  const pages = getPages$1(ydoc);
  return pages.map((page) => ({
    ...page,
    fields: getItemsWithChildren(ydoc, page.name)
  }));
}
function getMaxPagesSort$1(ydoc) {
  var _a3;
  const pages = getPages$1(ydoc);
  return Number(((_a3 = pages[pages.length - 1]) == null ? void 0 : _a3.sort) ?? 0);
}
function getMaxChildSort(ydoc, parentId) {
  var _a3;
  const children = getChildItems(ydoc, parentId);
  return Number(((_a3 = children[children.length - 1]) == null ? void 0 : _a3.sort) ?? 0);
}
function findDependants(ydoc, itemId) {
  return getItems(ydoc).filter((item) => isDependantField(item, itemId));
}
function ydocIsDirty$1(state) {
  return state.getMap("editorState").get("isDirty") === true;
}
function numberToCents(numericPrice2) {
  if (Number.isInteger(numericPrice2)) {
    return numericPrice2 * 100;
  }
  return Math.round(numericPrice2 * 100);
}
function formatCents(cents) {
  const dollars = cents / 100;
  if (Number.isInteger(dollars)) {
    return dollars.toLocaleString();
  } else {
    return dollars.toFixed(2).toLocaleString();
  }
}
function priceWithSymbol({
  currency,
  price
}) {
  const numericPrice2 = Number(price);
  if (isNaN(numericPrice2)) {
    return "";
  }
  const symbol = currency ? currency : "$";
  return `${symbol}${formatCents(numericPrice2)}`;
}
function n(n2) {
  for (var r2 = arguments.length, t2 = Array(r2 > 1 ? r2 - 1 : 0), e = 1; e < r2; e++) t2[e - 1] = arguments[e];
  if ("production" !== process.env.NODE_ENV) {
    var i = Y$1[n2], o2 = i ? "function" == typeof i ? i.apply(null, t2) : i : "unknown error nr: " + n2;
    throw Error("[Immer] " + o2);
  }
  throw Error("[Immer] minified error nr: " + n2 + (t2.length ? " " + t2.map(function(n3) {
    return "'" + n3 + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r$1(n2) {
  return !!n2 && !!n2[Q$1];
}
function t(n2) {
  var r2;
  return !!n2 && (function(n3) {
    if (!n3 || "object" != typeof n3) return false;
    var r3 = Object.getPrototypeOf(n3);
    if (null === r3) return true;
    var t2 = Object.hasOwnProperty.call(r3, "constructor") && r3.constructor;
    return t2 === Object || "function" == typeof t2 && Function.toString.call(t2) === Z$1;
  }(n2) || Array.isArray(n2) || !!n2[L$1] || !!(null === (r2 = n2.constructor) || void 0 === r2 ? void 0 : r2[L$1]) || s(n2) || v$1(n2));
}
function i$1(n2, r2, t2) {
  void 0 === t2 && (t2 = false), 0 === o(n2) ? (t2 ? Object.keys : nn)(n2).forEach(function(e) {
    t2 && "symbol" == typeof e || r2(e, n2[e], n2);
  }) : n2.forEach(function(t3, e) {
    return r2(e, t3, n2);
  });
}
function o(n2) {
  var r2 = n2[Q$1];
  return r2 ? r2.i > 3 ? r2.i - 4 : r2.i : Array.isArray(n2) ? 1 : s(n2) ? 2 : v$1(n2) ? 3 : 0;
}
function u(n2, r2) {
  return 2 === o(n2) ? n2.has(r2) : Object.prototype.hasOwnProperty.call(n2, r2);
}
function a(n2, r2) {
  return 2 === o(n2) ? n2.get(r2) : n2[r2];
}
function f(n2, r2, t2) {
  var e = o(n2);
  2 === e ? n2.set(r2, t2) : 3 === e ? n2.add(t2) : n2[r2] = t2;
}
function c(n2, r2) {
  return n2 === r2 ? 0 !== n2 || 1 / n2 == 1 / r2 : n2 != n2 && r2 != r2;
}
function s(n2) {
  return X$1 && n2 instanceof Map;
}
function v$1(n2) {
  return q$1 && n2 instanceof Set;
}
function p(n2) {
  return n2.o || n2.t;
}
function l(n2) {
  if (Array.isArray(n2)) return Array.prototype.slice.call(n2);
  var r2 = rn(n2);
  delete r2[Q$1];
  for (var t2 = nn(r2), e = 0; e < t2.length; e++) {
    var i = t2[e], o2 = r2[i];
    false === o2.writable && (o2.writable = true, o2.configurable = true), (o2.get || o2.set) && (r2[i] = { configurable: true, writable: true, enumerable: o2.enumerable, value: n2[i] });
  }
  return Object.create(Object.getPrototypeOf(n2), r2);
}
function d(n2, e) {
  return void 0 === e && (e = false), y$1(n2) || r$1(n2) || !t(n2) || (o(n2) > 1 && (n2.set = n2.add = n2.clear = n2.delete = h), Object.freeze(n2), e && i$1(n2, function(n3, r2) {
    return d(r2, true);
  }, true)), n2;
}
function h() {
  n(2);
}
function y$1(n2) {
  return null == n2 || "object" != typeof n2 || Object.isFrozen(n2);
}
function b$1(r2) {
  var t2 = tn[r2];
  return t2 || n(18, r2), t2;
}
function _$1() {
  return "production" === process.env.NODE_ENV || U$1 || n(0), U$1;
}
function j$1(n2, r2) {
  r2 && (b$1("Patches"), n2.u = [], n2.s = [], n2.v = r2);
}
function g$1(n2) {
  O$1(n2), n2.p.forEach(S$1), n2.p = null;
}
function O$1(n2) {
  n2 === U$1 && (U$1 = n2.l);
}
function w$1(n2) {
  return U$1 = { p: [], l: U$1, h: n2, m: true, _: 0 };
}
function S$1(n2) {
  var r2 = n2[Q$1];
  0 === r2.i || 1 === r2.i ? r2.j() : r2.g = true;
}
function P(r2, e) {
  e._ = e.p.length;
  var i = e.p[0], o2 = void 0 !== r2 && r2 !== i;
  return e.h.O || b$1("ES5").S(e, r2, o2), o2 ? (i[Q$1].P && (g$1(e), n(4)), t(r2) && (r2 = M$1(e, r2), e.l || x$1(e, r2)), e.u && b$1("Patches").M(i[Q$1].t, r2, e.u, e.s)) : r2 = M$1(e, i, []), g$1(e), e.u && e.v(e.u, e.s), r2 !== H$1 ? r2 : void 0;
}
function M$1(n2, r2, t2) {
  if (y$1(r2)) return r2;
  var e = r2[Q$1];
  if (!e) return i$1(r2, function(i, o3) {
    return A(n2, e, r2, i, o3, t2);
  }, true), r2;
  if (e.A !== n2) return r2;
  if (!e.P) return x$1(n2, e.t, true), e.t;
  if (!e.I) {
    e.I = true, e.A._--;
    var o2 = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u2 = o2, a2 = false;
    3 === e.i && (u2 = new Set(o2), o2.clear(), a2 = true), i$1(u2, function(r3, i) {
      return A(n2, e, o2, r3, i, t2, a2);
    }), x$1(n2, o2, false), t2 && n2.u && b$1("Patches").N(e, t2, n2.u, n2.s);
  }
  return e.o;
}
function A(e, i, o2, a2, c2, s2, v2) {
  if ("production" !== process.env.NODE_ENV && c2 === o2 && n(5), r$1(c2)) {
    var p2 = M$1(e, c2, s2 && i && 3 !== i.i && !u(i.R, a2) ? s2.concat(a2) : void 0);
    if (f(o2, a2, p2), !r$1(p2)) return;
    e.m = false;
  } else v2 && o2.add(c2);
  if (t(c2) && !y$1(c2)) {
    if (!e.h.D && e._ < 1) return;
    M$1(e, c2), i && i.A.l || x$1(e, c2);
  }
}
function x$1(n2, r2, t2) {
  void 0 === t2 && (t2 = false), !n2.l && n2.h.D && n2.m && d(r2, t2);
}
function z$2(n2, r2) {
  var t2 = n2[Q$1];
  return (t2 ? p(t2) : n2)[r2];
}
function I$1(n2, r2) {
  if (r2 in n2) for (var t2 = Object.getPrototypeOf(n2); t2; ) {
    var e = Object.getOwnPropertyDescriptor(t2, r2);
    if (e) return e;
    t2 = Object.getPrototypeOf(t2);
  }
}
function k$1(n2) {
  n2.P || (n2.P = true, n2.l && k$1(n2.l));
}
function E$1(n2) {
  n2.o || (n2.o = l(n2.t));
}
function N$1(n2, r2, t2) {
  var e = s(r2) ? b$1("MapSet").F(r2, t2) : v$1(r2) ? b$1("MapSet").T(r2, t2) : n2.O ? function(n3, r3) {
    var t3 = Array.isArray(n3), e2 = { i: t3 ? 1 : 0, A: r3 ? r3.A : _$1(), P: false, I: false, R: {}, l: r3, t: n3, k: null, o: null, j: null, C: false }, i = e2, o2 = en;
    t3 && (i = [e2], o2 = on);
    var u2 = Proxy.revocable(i, o2), a2 = u2.revoke, f2 = u2.proxy;
    return e2.k = f2, e2.j = a2, f2;
  }(r2, t2) : b$1("ES5").J(r2, t2);
  return (t2 ? t2.A : _$1()).p.push(e), e;
}
function R$1(e) {
  return r$1(e) || n(22, e), function n2(r2) {
    if (!t(r2)) return r2;
    var e2, u2 = r2[Q$1], c2 = o(r2);
    if (u2) {
      if (!u2.P && (u2.i < 4 || !b$1("ES5").K(u2))) return u2.t;
      u2.I = true, e2 = D$1(r2, c2), u2.I = false;
    } else e2 = D$1(r2, c2);
    return i$1(e2, function(r3, t2) {
      u2 && a(u2.t, r3) === t2 || f(e2, r3, n2(t2));
    }), 3 === c2 ? new Set(e2) : e2;
  }(e);
}
function D$1(n2, r2) {
  switch (r2) {
    case 2:
      return new Map(n2);
    case 3:
      return Array.from(n2);
  }
  return l(n2);
}
var G$1, U$1, W$1 = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X$1 = "undefined" != typeof Map, q$1 = "undefined" != typeof Set, B$1 = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H$1 = W$1 ? Symbol.for("immer-nothing") : ((G$1 = {})["immer-nothing"] = true, G$1), L$1 = W$1 ? Symbol.for("immer-draftable") : "__$immer_draftable", Q$1 = W$1 ? Symbol.for("immer-state") : "__$immer_state", Y$1 = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(n2) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n2;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(n2) {
  return "Cannot apply patch, path doesn't resolve: " + n2;
}, 16: 'Sets cannot have "replace" patches.', 17: function(n2) {
  return "Unsupported patch operation: " + n2;
}, 18: function(n2) {
  return "The plugin for '" + n2 + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n2 + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(n2) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n2 + "'";
}, 22: function(n2) {
  return "'current' expects a draft, got: " + n2;
}, 23: function(n2) {
  return "'original' expects a draft, got: " + n2;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, Z$1 = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n2) {
  return Object.getOwnPropertyNames(n2).concat(Object.getOwnPropertySymbols(n2));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n2) {
  var r2 = {};
  return nn(n2).forEach(function(t2) {
    r2[t2] = Object.getOwnPropertyDescriptor(n2, t2);
  }), r2;
}, tn = {}, en = { get: function(n2, r2) {
  if (r2 === Q$1) return n2;
  var e = p(n2);
  if (!u(e, r2)) return function(n3, r3, t2) {
    var e2, i2 = I$1(r3, t2);
    return i2 ? "value" in i2 ? i2.value : null === (e2 = i2.get) || void 0 === e2 ? void 0 : e2.call(n3.k) : void 0;
  }(n2, e, r2);
  var i = e[r2];
  return n2.I || !t(i) ? i : i === z$2(n2.t, r2) ? (E$1(n2), n2.o[r2] = N$1(n2.A.h, i, n2)) : i;
}, has: function(n2, r2) {
  return r2 in p(n2);
}, ownKeys: function(n2) {
  return Reflect.ownKeys(p(n2));
}, set: function(n2, r2, t2) {
  var e = I$1(p(n2), r2);
  if (null == e ? void 0 : e.set) return e.set.call(n2.k, t2), true;
  if (!n2.P) {
    var i = z$2(p(n2), r2), o2 = null == i ? void 0 : i[Q$1];
    if (o2 && o2.t === t2) return n2.o[r2] = t2, n2.R[r2] = false, true;
    if (c(t2, i) && (void 0 !== t2 || u(n2.t, r2))) return true;
    E$1(n2), k$1(n2);
  }
  return n2.o[r2] === t2 && (void 0 !== t2 || r2 in n2.o) || Number.isNaN(t2) && Number.isNaN(n2.o[r2]) || (n2.o[r2] = t2, n2.R[r2] = true), true;
}, deleteProperty: function(n2, r2) {
  return void 0 !== z$2(n2.t, r2) || r2 in n2.t ? (n2.R[r2] = false, E$1(n2), k$1(n2)) : delete n2.R[r2], n2.o && delete n2.o[r2], true;
}, getOwnPropertyDescriptor: function(n2, r2) {
  var t2 = p(n2), e = Reflect.getOwnPropertyDescriptor(t2, r2);
  return e ? { writable: true, configurable: 1 !== n2.i || "length" !== r2, enumerable: e.enumerable, value: t2[r2] } : e;
}, defineProperty: function() {
  n(11);
}, getPrototypeOf: function(n2) {
  return Object.getPrototypeOf(n2.t);
}, setPrototypeOf: function() {
  n(12);
} }, on = {};
i$1(en, function(n2, r2) {
  on[n2] = function() {
    return arguments[0] = arguments[0][0], r2.apply(this, arguments);
  };
}), on.deleteProperty = function(r2, t2) {
  return "production" !== process.env.NODE_ENV && isNaN(parseInt(t2)) && n(13), on.set.call(this, r2, t2, void 0);
}, on.set = function(r2, t2, e) {
  return "production" !== process.env.NODE_ENV && "length" !== t2 && isNaN(parseInt(t2)) && n(14), en.set.call(this, r2[0], t2, e, r2[0]);
};
var un = function() {
  function e(r2) {
    var e2 = this;
    this.O = B$1, this.D = true, this.produce = function(r3, i2, o2) {
      if ("function" == typeof r3 && "function" != typeof i2) {
        var u2 = i2;
        i2 = r3;
        var a2 = e2;
        return function(n2) {
          var r4 = this;
          void 0 === n2 && (n2 = u2);
          for (var t2 = arguments.length, e3 = Array(t2 > 1 ? t2 - 1 : 0), o3 = 1; o3 < t2; o3++) e3[o3 - 1] = arguments[o3];
          return a2.produce(n2, function(n3) {
            var t3;
            return (t3 = i2).call.apply(t3, [r4, n3].concat(e3));
          });
        };
      }
      var f2;
      if ("function" != typeof i2 && n(6), void 0 !== o2 && "function" != typeof o2 && n(7), t(r3)) {
        var c2 = w$1(e2), s2 = N$1(e2, r3, void 0), v2 = true;
        try {
          f2 = i2(s2), v2 = false;
        } finally {
          v2 ? g$1(c2) : O$1(c2);
        }
        return "undefined" != typeof Promise && f2 instanceof Promise ? f2.then(function(n2) {
          return j$1(c2, o2), P(n2, c2);
        }, function(n2) {
          throw g$1(c2), n2;
        }) : (j$1(c2, o2), P(f2, c2));
      }
      if (!r3 || "object" != typeof r3) {
        if (void 0 === (f2 = i2(r3)) && (f2 = r3), f2 === H$1 && (f2 = void 0), e2.D && d(f2, true), o2) {
          var p2 = [], l2 = [];
          b$1("Patches").M(r3, f2, p2, l2), o2(p2, l2);
        }
        return f2;
      }
      n(21, r3);
    }, this.produceWithPatches = function(n2, r3) {
      if ("function" == typeof n2) return function(r4) {
        for (var t3 = arguments.length, i3 = Array(t3 > 1 ? t3 - 1 : 0), o3 = 1; o3 < t3; o3++) i3[o3 - 1] = arguments[o3];
        return e2.produceWithPatches(r4, function(r5) {
          return n2.apply(void 0, [r5].concat(i3));
        });
      };
      var t2, i2, o2 = e2.produce(n2, r3, function(n3, r4) {
        t2 = n3, i2 = r4;
      });
      return "undefined" != typeof Promise && o2 instanceof Promise ? o2.then(function(n3) {
        return [n3, t2, i2];
      }) : [o2, t2, i2];
    }, "boolean" == typeof (null == r2 ? void 0 : r2.useProxies) && this.setUseProxies(r2.useProxies), "boolean" == typeof (null == r2 ? void 0 : r2.autoFreeze) && this.setAutoFreeze(r2.autoFreeze);
  }
  var i = e.prototype;
  return i.createDraft = function(e2) {
    t(e2) || n(8), r$1(e2) && (e2 = R$1(e2));
    var i2 = w$1(this), o2 = N$1(this, e2, void 0);
    return o2[Q$1].C = true, O$1(i2), o2;
  }, i.finishDraft = function(r2, t2) {
    var e2 = r2 && r2[Q$1];
    "production" !== process.env.NODE_ENV && (e2 && e2.C || n(9), e2.I && n(10));
    var i2 = e2.A;
    return j$1(i2, t2), P(void 0, i2);
  }, i.setAutoFreeze = function(n2) {
    this.D = n2;
  }, i.setUseProxies = function(r2) {
    r2 && !B$1 && n(20), this.O = r2;
  }, i.applyPatches = function(n2, t2) {
    var e2;
    for (e2 = t2.length - 1; e2 >= 0; e2--) {
      var i2 = t2[e2];
      if (0 === i2.path.length && "replace" === i2.op) {
        n2 = i2.value;
        break;
      }
    }
    e2 > -1 && (t2 = t2.slice(e2 + 1));
    var o2 = b$1("Patches").$;
    return r$1(n2) ? o2(n2, t2) : this.produce(n2, function(n3) {
      return o2(n3, t2);
    });
  }, e;
}(), an = new un(), fn = an.produce;
an.produceWithPatches.bind(an);
an.setAutoFreeze.bind(an);
an.setUseProxies.bind(an);
an.applyPatches.bind(an);
an.createDraft.bind(an);
an.finishDraft.bind(an);
const roomBlockDefaults = {
  collectPayment: true,
  hidePrices: false
};
const initialApplicationState = {
  isDirty: false
};
const roomTypeDefaults = {
  name: "Standard room",
  nights: [],
  minOccupancy: 1,
  maxOccupancy: 2,
  price: 1e4
};
const reducer$7 = (state, action) => {
  return fn(state, ({ roomBlock, application }) => {
    var _a3;
    switch (action.type) {
      case "add_room_type":
        const roomType = initializeRoomType(roomBlock, action.payload);
        roomBlock.roomTypes.push({
          ...roomType,
          nights: getRoomTypeNights(roomType, roomBlock)
        });
        application.isDirty = true;
        break;
      case "update_room_type":
        roomBlock.roomTypes = roomBlock.roomTypes.map((roomType2) => {
          if (action.id === roomType2.id) {
            return { ...roomType2, ...action.payload };
          } else {
            return roomType2;
          }
        });
        application.isDirty = true;
        break;
      case "delete_room_type":
        roomBlock.roomTypes = roomBlock.roomTypes.filter(
          (r2) => r2.id !== action.id
        );
        if (((_a3 = application.selectedRoomType) == null ? void 0 : _a3.id) === action.id) {
          application.selectedRoomType = void 0;
        }
        application.isDirty = true;
        break;
      case "set_dates":
        roomBlock.startDate = action.payload.startDate;
        roomBlock.endDate = action.payload.endDate;
        if (roomBlock.startDate && roomBlock.endDate) {
          roomBlock.roomTypes = setRoomTypeNights(roomBlock).roomTypes;
        }
        application.isDirty = true;
        break;
      case "set_name":
        roomBlock.name = action.payload.name;
        application.isDirty = true;
        break;
      case "update_room_block":
        Object.assign(roomBlock, action.payload);
        application.isDirty = true;
        break;
      case "update_availability":
        const roomNight = getRoomNight(roomBlock, action.id);
        if (!roomNight) {
          console.error(`Unable to find a room night with id ${action.id}`);
          return;
        }
        roomNight.availability = action.availability;
        application.isDirty = true;
        break;
      case "select_room_type":
        application.selectedRoomType = action.payload;
        break;
      case "set_is_dirty":
        application.isDirty = action.isDirty;
        break;
      default:
        throw new Error("Unknown action");
    }
  });
};
const initializeState$2 = (state) => {
  return fn(state, ({ roomBlock }) => {
    setRoomTypeNights(roomBlock);
  });
};
const getSortedItems = (items) => items.slice().sort((a2, b2) => Number(a2.sort) - Number(b2.sort));
const getSortItemIndex = (fromIndex, toIndex, isInsertion) => {
  if (isInsertion) {
    return {
      startIndex: toIndex - 1,
      endIndex: toIndex
    };
  } else {
    return {
      startIndex: fromIndex > toIndex ? toIndex - 1 : toIndex,
      endIndex: fromIndex > toIndex ? toIndex : toIndex + 1
    };
  }
};
const getNewSort = (items, fromIndex, toIndex, isInsertion = false) => {
  const sortedItems = getSortedItems(items);
  if (items.length === 0) {
    return 1;
  }
  if (toIndex >= items.length - 1 && !isInsertion) {
    return Number(sortedItems[items.length - 1].sort) + 1;
  }
  const { startIndex, endIndex } = getSortItemIndex(
    fromIndex,
    toIndex,
    isInsertion
  );
  const startSort = toIndex === 0 ? 0 : Number(items[startIndex].sort);
  const endSort = endIndex > sortedItems.length - 1 ? Number(sortedItems[sortedItems.length - 1].sort) + 1 : Number(sortedItems[endIndex].sort);
  return (startSort + endSort) / 2;
};
const getNextSort = (items) => {
  if (items === void 0) {
    return 1;
  } else {
    return Math.max(0, ...items.map((item) => Number(item.sort))) + 1;
  }
};
const DEFAULT_AVAILABILITY = 1;
const initializeRoomNight = (roomType, date) => ({
  date,
  id: idGenerator(),
  roomTypeId: roomType.id,
  availability: DEFAULT_AVAILABILITY
});
const getRoomNight$1 = (roomType, date) => roomType.nights.find((rn2) => isSameDay$2(date, rn2.date));
const getRoomTypeNights = (roomType, roomBlock) => getRoomBlockDateRange(roomBlock).map((date) => {
  const existingNight = getRoomNight$1(roomType, date);
  if (existingNight) {
    return { ...existingNight, date };
  } else {
    return initializeRoomNight(roomType, date);
  }
});
function setRoomTypeNights(roomBlock) {
  if (!isValidRoomBlock(roomBlock)) {
    throw new Error("Invalid room block");
  }
  return {
    ...roomBlock,
    roomTypes: roomBlock.roomTypes.map((roomType) => ({
      ...roomType,
      nights: getRoomTypeNights(roomType, roomBlock)
    }))
  };
}
const getRoomTypes = (roomBlock) => "roomTypes" in roomBlock ? roomBlock.roomTypes : [];
const initializeRoomType = (roomBlock, roomType) => ({
  ...roomTypeDefaults,
  name: `Room type ${getRoomTypes(roomBlock).length + 1}`,
  sort: getNextSort(getRoomTypes(roomBlock)),
  id: idGenerator(),
  ...roomType
});
const initializeRoomBlock = (roomBlockInput) => {
  return setRoomTypeNights({
    ...roomBlockInput,
    roomTypes: [initializeRoomType(roomBlockInput)]
  });
};
const defaultRoomBlockDates = (formSettings) => {
  console.log("Default dates", formSettings);
  if (isSameDay$2(formSettings.startDate, formSettings.endDate)) {
    return {
      startDate: formSettings.startDate,
      endDate: addDays$1(formSettings.endDate, 1)
    };
  } else {
    return {
      startDate: formSettings.startDate,
      endDate: formSettings.endDate
    };
  }
};
const initializeRoomBlockPrimer = (roomBlockInput) => {
  return setRoomTypeNights({
    ...roomBlockInput,
    roomTypes: roomBlockInput.roomTypes
  });
};
const getRoomBlockDateRange = (roomBlock) => eachDayOfInterval({
  start: roomBlock.startDate,
  end: subDays$1(roomBlock.endDate)
});
const getBlockNightsCount = (roomBlock) => getRoomBlockDateRange(roomBlock).length;
const getBookingNightsCount = (roomBooking) => eachDayOfInterval({
  start: roomBooking.checkIn,
  end: subDays$1(roomBooking.checkOut)
}).length;
const hasRoomTypes = (rb) => rb.roomTypes.length > 0;
const isValidRoomBlock = (rb) => hasRoomTypes(rb);
const canDeleteRoomBlock = (rb, form) => rb.numberBooked === 0 && !hasRoomBlockField(form, rb);
function getSortedRoomBlocks(roomBlocks2) {
  return [...roomBlocks2].sort((a2, b2) => a2.name.localeCompare(b2.name));
}
const getIncludedRoomTypes = (roomBlock, formField) => {
  return formField.includeRoomTypes === void 0 ? roomBlock.roomTypes : roomBlock.roomTypes.filter(
    (rt) => {
      var _a3;
      return (_a3 = formField.includeRoomTypes) == null ? void 0 : _a3.includes(rt.id);
    }
  );
};
const getIncludedRoomTypesWithOccupancy = (roomBlock, formField) => {
  const result = [];
  const roomTypes2 = getIncludedRoomTypes(roomBlock, formField);
  for (const roomType of roomTypes2) {
    for (let i = roomType.minOccupancy; i <= roomType.maxOccupancy; i++) {
      result.push({ roomType, occupancy: i });
    }
  }
  return result;
};
function getRoomNight(roomBlock, roomNightId) {
  for (const roomType of roomBlock.roomTypes) {
    const night = roomType.nights.find((n2) => n2.id === roomNightId);
    if (night) {
      return night;
    }
  }
}
const getPriceOverride$1 = (formField, roomNight) => formField.priceOverrides !== void 0 ? formField.priceOverrides[roomNight.id] : void 0;
const getOccupancyPriceOverride = (formField, roomNight, occupancy) => {
  var _a3;
  return formField.occupancyPriceOverrides !== void 0 ? (_a3 = formField.occupancyPriceOverrides[roomNight.id]) == null ? void 0 : _a3[occupancy] : void 0;
};
const getInitialOccupancy = (booking, roomType) => {
  if (roomType.occupancy !== void 0) {
    return roomType.occupancy;
  }
  if (booking.occupancy === void 0) {
    return roomType.minOccupancy;
  }
  if (booking.occupancy > roomType.maxOccupancy) {
    return roomType.maxOccupancy;
  }
  if (booking.occupancy < roomType.minOccupancy) {
    return roomType.minOccupancy;
  }
  return booking.occupancy;
};
const roomBookingHasDates = (booking) => booking.checkIn !== void 0 && booking.checkOut !== void 0;
const isValidRoomBooking = (booking) => booking.checkIn !== void 0 && booking.checkOut !== void 0 && booking.roomType !== void 0 && booking.occupancy !== void 0;
const shouldShowPrice = (roomBlock, booking) => roomBlock.hidePrices !== true && booking.priceCents !== null && booking.priceCents !== void 0 && booking.priceCents !== 0;
const defaultBookingDateDefaults = (roomBlock, formSettings) => {
  const defaultDates = defaultRoomBlockDates(formSettings);
  return {
    defaultCheckIn: formatISODate(
      max$3([roomBlock.startDate, defaultDates.startDate])
    ),
    defaultCheckOut: formatISODate(
      min$3([roomBlock.endDate, addDays$1(defaultDates.endDate, 1)])
    )
  };
};
const availableRoomTypeId = (roomType) => roomType.occupancy !== void 0 ? `${roomType.id}-${roomType.occupancy}` : roomType.id;
const getAvailableRoomType = (availableRoomTypes, id) => availableRoomTypes.find((rt) => id === availableRoomTypeId(rt));
const defaultFormSettings = {
  dateFormat: "MMM d yyy",
  dateTimeFormat: "MMM d yyy h:mm aaa",
  documentUploadsEnabled: false,
  guestBookingEnabled: false,
  leadScannersEnabled: false,
  metadataEnabled: false,
  multipleSessionSlotChoices: false,
  newAddPanel: false,
  newChoicesEditor: false,
  occupancyPricingEnabled: false,
  protectAttendeeReferenceFields: true,
  roomingEnabled: false,
  registrationPhasesEnabled: false,
  sessionBookingEnabled: false,
  sessionSlotDescriptionsEnabled: false,
  shoppingCartCurrency: "$",
  shoppingCartEnabled: false,
  tracksBlockedByUntrackedRegistrations: false,
  tracksEnabled: false
};
const defaultChoices = [
  ["One", "One"],
  ["Two", "Two"]
].map(normalizedChoiceWithId);
const fieldDefaults = {
  textField: {
    type: "string",
    kind: "text",
    label: "New text field"
  },
  checkBoxField: {
    label: "New check box",
    kind: "checkbox",
    type: "boolean"
  },
  dropDownField: {
    label: "New drop down",
    type: "string",
    kind: "dropdown",
    choices: defaultChoices,
    includeBlank: true
  },
  radioField: {
    label: "New Radio",
    type: "string",
    widget: "radio",
    kind: "radio",
    choices: defaultChoices
  },
  numberField: {
    type: "integer",
    kind: "integer",
    label: "New number field"
  },
  textAreaField: {
    type: "string",
    widget: "textarea",
    kind: "textarea",
    label: "New text area field"
  },
  emailField: {
    type: "string",
    widget: "email",
    kind: "email",
    label: "New email field"
  },
  dateField: {
    type: "date",
    kind: "date",
    label: "New date field"
  },
  phoneNumberField: {
    type: "telephone",
    kind: "telephone",
    label: "New telephone field"
  },
  documentField: {
    type: "document",
    kind: "document",
    label: "New document upload"
  },
  infoField: {
    type: "info",
    text: "New info section"
  },
  leadScannerField: {
    type: "lead_scanner",
    label: "Attendee Lead Scanner"
  },
  section: {
    type: "section",
    label: "New section",
    fields: []
  }
};
const defaultSessionField = (session) => ({
  session: session.id,
  type: "session_booking",
  label: session.name,
  helpText: session.description
});
const defaultRoomBlockField = (roomBlock, formSettings) => ({
  type: "room_block",
  roomBlockId: roomBlock.id,
  label: roomBlock.name,
  ...defaultBookingDateDefaults(roomBlock, formSettings)
});
const pageDefaults$1 = {
  label: "New Section",
  type: "page",
  fields: []
};
const baseFieldDefaults = {
  type: "string",
  label: "New field"
};
const infoDefaultText = "Click to edit";
const handlePreserveConsecutiveUppercase = (decamelized, separator) => {
  decamelized = decamelized.replace(
    new RegExp("((?<![\\p{Uppercase_Letter}\\d])[\\p{Uppercase_Letter}\\d](?![\\p{Uppercase_Letter}\\d]))", "gu"),
    ($0) => $0.toLowerCase()
  );
  return decamelized.replace(
    new RegExp("(\\p{Uppercase_Letter}+)(\\p{Uppercase_Letter}\\p{Lowercase_Letter}+)", "gu"),
    (_2, $1, $2) => $1 + separator + $2.toLowerCase()
  );
};
function decamelize(text2, {
  separator = "_",
  preserveConsecutiveUppercase = false
} = {}) {
  if (!(typeof text2 === "string" && typeof separator === "string")) {
    throw new TypeError(
      "The `text` and `separator` arguments should be of type `string`"
    );
  }
  if (text2.length < 2) {
    return preserveConsecutiveUppercase ? text2 : text2.toLowerCase();
  }
  const replacement = `$1${separator}$2`;
  const decamelized = text2.replace(
    new RegExp("([\\p{Lowercase_Letter}\\d])(\\p{Uppercase_Letter})", "gu"),
    replacement
  );
  if (preserveConsecutiveUppercase) {
    return handlePreserveConsecutiveUppercase(decamelized, separator);
  }
  return decamelized.replace(
    new RegExp("(\\p{Uppercase_Letter})(\\p{Uppercase_Letter}\\p{Lowercase_Letter}+)", "gu"),
    replacement
  ).toLowerCase();
}
function humanizeString(string2) {
  if (typeof string2 !== "string") {
    throw new TypeError("Expected a string");
  }
  string2 = decamelize(string2);
  string2 = string2.toLowerCase().replace(/[_-]+/g, " ").replace(/\s{2,}/g, " ").trim();
  string2 = string2.charAt(0).toUpperCase() + string2.slice(1);
  return string2;
}
function generateName(fields, label) {
  if (!label) {
    return idGenerator();
  }
  const sanitizedLabel = label.replace(/[^a-zA-Z0-9\s]/g, "").replace(/\s+/g, " ").replace(/\s/g, "_").replace(/^[0-9]+/, "");
  const name2 = sanitizedLabel.toLowerCase();
  const existingField = findField(fields, name2);
  if (existingField) {
    return `${name2}_${idGenerator()}`;
  } else {
    return name2;
  }
}
const fieldLabel = (field) => field.label !== void 0 ? field.label : humanizeString(field.name);
function visitFields(fields, callback) {
  fields.forEach((field) => {
    callback(field);
    if (isFieldContainer(field)) {
      visitFields(field.fields, callback);
    }
  });
}
function withField(fields, name2, callback) {
  callback(findFieldWithContainer(fields, name2));
}
function withFieldAndParent(fields, name2, callback) {
  callback(findFieldWithParent(fields, name2));
}
const isStructuredDepends = (depends) => depends !== void 0 && depends !== null && typeof depends !== "string";
function findDependents(fields, name2, callback) {
  visitFields(fields, (field) => {
    if (isStructuredDepends(field.dependsOn) && field.dependsOn[0] === name2 || field.dependsOn === name2) {
      callback(field);
    }
  });
}
function clearDependents(fields, name2) {
  findDependents(fields, name2, (dependant) => {
    delete dependant.dependsOn;
  });
}
const reducer$6 = (state, action) => {
  return fn(state, (draft) => {
    var _a3;
    switch (action.type) {
      case "select_page":
        const page = draft.fields.find((p2) => p2.name === action.name);
        if (page === void 0) {
          console.error(
            `Trying to select a page that doesn't exist: ${action.name}`
          );
          break;
        }
        draft.selectedPageName = page.name;
        draft.selectedFieldName = page.name;
        draft.selectedTab = "edit";
        break;
      case "select_field":
        draft.selectedFieldName = (_a3 = findField(draft.fields, action.name)) == null ? void 0 : _a3.name;
        draft.selectedTab = "edit";
        break;
      case "select_tab":
        draft.selectedTab = action.tab;
        break;
      case "add_field":
        const parentFieldName = action.parent ?? draft.selectedPageName;
        if (parentFieldName === void 0) {
          console.error(
            `Please supply a field name to add a field or ensure a has been selected`
          );
          break;
        }
        withField(draft.fields, parentFieldName, ({ field: parent2 }) => {
          if (parent2 === void 0) {
            console.error(
              `Trying to add field to undefined parent field ${action.parent}`
            );
            return;
          }
          if (!isFieldContainer(parent2)) {
            console.error(
              `Trying to add field to invalid parent field ${action.parent}`
            );
            return;
          }
          const newField = {
            ...baseFieldDefaults,
            ...action.field
          };
          if (!newField.name) {
            newField.name = idGenerator();
            newField.isNew = true;
          }
          if (isInfoField(newField)) {
            newField.text = infoDefaultText;
          }
          if (parent2.fields) {
            parent2.fields.push(newField);
          } else {
            parent2.fields = [newField];
          }
        });
        draft.dirty = true;
        break;
      case "move_field":
        withFieldAndParent(draft.fields, action.field, ({ field: field2, parent: parent2 }) => {
          if (parent2 === void 0 || field2 === void 0) {
            console.error(`Error finding field ${action.field}`);
            return;
          }
          let destination;
          if (!action.destination) {
            destination = parent2;
          } else {
            destination = findField(draft.fields, action.destination);
            if (destination === null) {
              console.error(
                `Invalid destination field specified for move destination: ${action.destination}`
              );
              return;
            }
          }
          if (!isFieldContainer(destination)) {
            console.error(
              `Move to invalid destination field ${destination.name}`
            );
            return;
          }
          const startIndex2 = parent2.fields.findIndex(
            (f2) => f2.name === field2.name
          );
          const [removed] = parent2.fields.splice(startIndex2, 1);
          if (destination.fields) {
            destination.fields.splice(action.index, 0, removed);
          } else {
            destination.fields = [removed];
          }
          draft.dirty = true;
        });
        break;
      case "add_page":
        const newPage = { ...pageDefaults$1, ...action.page };
        if (!newPage.name) {
          newPage.name = idGenerator();
          newPage.isNew = true;
        }
        if (draft.fields) {
          if (newPage.phase === "pretrack") {
            const preRegPageCount2 = draft.fields.filter(
              (f2) => f2.phase === "pretrack"
            ).length;
            draft.fields.splice(preRegPageCount2, 0, newPage);
          } else {
            draft.fields.push(newPage);
          }
        } else {
          draft.fields = [newPage];
        }
        draft.dirty = true;
        draft.selectedPageName = newPage.name;
        draft.selectedFieldName = newPage.name;
        draft.selectedTab = "edit";
        break;
      case "update_field":
        const fieldToUpdate = findField(draft.fields, action.name);
        if (fieldToUpdate === null) {
          console.error(`Failed to find field to update: ${action.name}`);
          break;
        }
        Object.assign(fieldToUpdate, action.payload);
        if (action.payload.type === "boolean") {
          if ("widget" in fieldToUpdate) {
            delete fieldToUpdate.widget;
          }
          if ("choices" in fieldToUpdate) {
            delete fieldToUpdate.choices;
          }
        }
        if (action.payload.tracks !== void 0 && isFieldContainer(fieldToUpdate)) {
          visitFields(fieldToUpdate.fields, (field2) => {
            field2.tracks = void 0;
          });
        }
        console.log("fieldToUpdate", fieldToUpdate);
        draft.dirty = true;
        break;
      case "move_page":
        const startIndex = draft.fields.findIndex(
          (f2) => f2.name === action.name
        );
        if (startIndex === -1) {
          throw new Error(`Page not found with name: ${action.name}`);
        }
        const pageToMove = draft.fields.splice(startIndex, 1)[0];
        const preRegPageCount = draft.fields.filter(
          (f2) => f2.phase === "pretrack"
        ).length;
        const toIndex = isPreRegPage(pageToMove) ? action.toIndex : action.toIndex + preRegPageCount;
        draft.fields.splice(toIndex, 0, pageToMove);
        draft.dirty = true;
        break;
      case "delete_field":
        const { field, container } = findFieldWithContainer(
          draft.fields,
          action.name
        );
        if (field === void 0) {
          console.error(`Attempting to delete undefined field: ${action.name}`);
          break;
        }
        if (container === void 0) {
          console.error(`Error. Field container not found for: ${action.name}`);
          break;
        }
        const index2 = container.findIndex((f2) => f2.name === field.name);
        container.splice(index2, 1);
        if (field.name === draft.selectedPageName) {
          draft.selectedPageName = draft.fields[0].name;
          draft.selectedFieldName = void 0;
        }
        clearDependents(draft.fields, field.name);
        draft.dirty = true;
        break;
      case "reset_fields":
        draft.fields = action.fields;
        draft.dirty = false;
        const selectedPage = draft.selectedPageName && findField(draft.fields, draft.selectedPageName);
        if (!selectedPage) {
          draft.selectedPageName = draft.fields[0].name;
        }
        break;
      case "name_new_fields":
        visitFields(draft.fields, (field2) => {
          if (field2.isNew) {
            delete field2.isNew;
            const oldName = field2.name;
            field2.name = generateName(draft.fields, field2.label);
            if (oldName === draft.selectedPageName) {
              draft.selectedPageName = field2.name;
            }
          }
        });
        break;
      case "set_dirty":
        draft.dirty = action.dirty;
        break;
      default:
        throw new Error(`Unknown action ${action.type}`);
    }
  });
};
const initializeState$1 = (state) => {
  if (state.fields.length === 0) {
    return state;
  } else {
    return {
      ...state,
      selectedPageName: state.fields[0].name,
      selectedFieldName: state.fields[0].name
    };
  }
};
const FormContext = createContext(void 0);
const FormProvider = ({
  children,
  form,
  formSettings,
  editorState,
  dispatch
}) => {
  const [queryClient] = React__default.useState(() => new QueryClient());
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormContext.Provider,
    {
      value: {
        form,
        formSettings,
        editorState,
        dispatch
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(QueryClientProvider, { client: queryClient, children })
    }
  );
};
const FormStateProvider = ({
  form: initialForm,
  formSettings,
  children
}) => {
  const [{ fields, ...editorState }, dispatch] = useReducer(
    reducer$6,
    initialForm,
    initializeState$1
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormProvider,
    {
      form: { fields },
      formSettings: { ...defaultFormSettings, ...formSettings },
      editorState,
      dispatch,
      children
    }
  );
};
const useRegForm = () => useContext(FormContext);
const useCollabRegForm = () => {
  const { form, formSettings, editorState, dispatch } = useRegForm();
  return {
    form,
    formSettings,
    editorState,
    dispatch
  };
};
const EditorLayout = ({ children, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Grid,
  {
    minW: "900px",
    height: "calc(100vh - 60px)",
    overflow: "auto",
    templateColumns: "minmax(205px, 0.8fr) 2fr minmax(300px, 1.5fr)",
    templateRows: "min-content auto",
    templateAreas: "'header header header' 'sidebar main right_panel'",
    alignContent: "stretch",
    gap: 0,
    ...props,
    children
  }
);
const EditorHeader$1 = ({ children, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(GridItem, { gridArea: "header", colSpan: 3, ...props, children });
const StateBarClean = ({ children }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "t-state-bar-clean state-bar clean", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "state-bar-copy", children: "Saved, nothing added or changed." }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "state-bar-actions", children })
] });
const StateBar = ({
  children,
  dirty = false,
  disabled = false,
  showResetButton = true,
  onSave,
  onReset
}) => {
  if (dirty) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "t-state-bar-dirty state-bar", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "state-bar-copy", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "dark", children: "unsaved changes " }),
        "Save and apply to this event, or reset to removed any unsaved changes"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "state-bar-actions", children: [
        showResetButton && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            type: "reset",
            className: "reset t-reset",
            onClick: (e) => {
              e.preventDefault();
              if (typeof onReset === "function") {
                onReset();
              }
            },
            children: "Reset"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "button",
          {
            type: "submit",
            className: "save",
            disabled,
            onClick: (e) => {
              e.preventDefault();
              onSave();
            },
            children: "Save"
          }
        ),
        children
      ] })
    ] });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StateBarClean, { children });
  }
};
const DirtyCopy$1 = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  Text$3,
  {
    textStyle: "label",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { as: "span", color: "black", children: [
        "unsaved changes",
        " "
      ] }),
      "Save and apply to this event, or reset to removed any unsaved changes"
    ]
  }
);
const CleanCopy$1 = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { textStyle: "label", children: "Saved, nothing added or changed." });
const ConfirmResetButton = ({
  onConfirm
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleConfirm = () => {
    setIsOpen(false);
    onConfirm();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        variant: "ghost",
        size: "sm",
        onClick: () => setIsOpen(true),
        className: "t-state-bar-reset",
        children: "Reset"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen, onClose: () => setIsOpen(false), children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalContent, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Confirm Reset" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: "Are you sure you want to reset to the last saved state for all editors?" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalFooter, { justifyContent: "space-between", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { variant: "ghost", onClick: () => setIsOpen(false), children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", mr: 3, onClick: handleConfirm, children: "Reset" })
        ] })
      ] })
    ] })
  ] });
};
const ResetButton = ({
  onReset,
  confirmReset = false
}) => confirmReset ? /* @__PURE__ */ jsxRuntimeExports.jsx(ConfirmResetButton, { onConfirm: onReset }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
  Button$1,
  {
    variant: "ghost",
    size: "sm",
    onClick: onReset,
    className: "t-state-bar-reset",
    children: "Reset"
  }
);
const StateBarV2$1 = ({
  children,
  dirty = false,
  disabled = false,
  confirmReset = false,
  onSave,
  onReset
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  Flex,
  {
    p: 2,
    bgColor: dirty ? "redAlpha.400" : "blueAlpha.400",
    color: "white",
    justifyContent: "space-between",
    alignItems: "center",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { overflow: "hidden", children: dirty ? /* @__PURE__ */ jsxRuntimeExports.jsx(DirtyCopy$1, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(CleanCopy$1, {}) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { minW: "fit-content", flexShrink: 0, children: [
        children,
        dirty && onReset !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(ResetButton, { onReset, confirmReset }),
        dirty && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button$1,
          {
            colorScheme: "green",
            size: "sm",
            disabled,
            onClick: onSave,
            className: "t-state-bar-save",
            children: "Save"
          }
        )
      ] })
    ]
  }
);
const EditorSidebar = ({ children, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(GridItem, { gridArea: "sidebar", ...props, children });
function _setPrototypeOf$3(t2, e) {
  return _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t3, e2) {
    return t3.__proto__ = e2, t3;
  }, _setPrototypeOf$3(t2, e);
}
function _inheritsLoose$2(t2, o2) {
  t2.prototype = Object.create(o2.prototype), t2.prototype.constructor = t2, _setPrototypeOf$3(t2, o2);
}
function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function(n2) {
    for (var e = 1; e < arguments.length; e++) {
      var t2 = arguments[e];
      for (var r2 in t2) ({}).hasOwnProperty.call(t2, r2) && (n2[r2] = t2[r2]);
    }
    return n2;
  }, _extends$6.apply(null, arguments);
}
function _typeof$1(o2) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$1(o2);
}
function toPrimitive(t2, r2) {
  if ("object" != _typeof$1(t2) || !t2) return t2;
  var e = t2[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t2, r2);
    if ("object" != _typeof$1(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t2);
}
function toPropertyKey(t2) {
  var i = toPrimitive(t2, "string");
  return "symbol" == _typeof$1(i) ? i : i + "";
}
function _defineProperty$3(e, r2, t2) {
  return (r2 = toPropertyKey(r2)) in e ? Object.defineProperty(e, r2, {
    value: t2,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r2] = t2, e;
}
function ownKeys$7(e, r2) {
  var t2 = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t2.push.apply(t2, o2);
  }
  return t2;
}
function _objectSpread2$2(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t2 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$7(Object(t2), true).forEach(function(r3) {
      _defineProperty$3(e, r3, t2[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t2)) : ownKeys$7(Object(t2)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t2, r3));
    });
  }
  return e;
}
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or use the non-minified dev environment for full errors. ";
}
var $$observable = function() {
  return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
var randomString = function randomString2() {
  return Math.random().toString(36).substring(7).split("").join(".");
};
var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString()
};
function isPlainObject$4(obj) {
  if (typeof obj !== "object" || obj === null) return false;
  var proto2 = obj;
  while (Object.getPrototypeOf(proto2) !== null) {
    proto2 = Object.getPrototypeOf(proto2);
  }
  return Object.getPrototypeOf(obj) === proto2;
}
function miniKindOf(val) {
  if (val === void 0) return "undefined";
  if (val === null) return "null";
  var type = typeof val;
  switch (type) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function": {
      return type;
    }
  }
  if (Array.isArray(val)) return "array";
  if (isDate$2(val)) return "date";
  if (isError(val)) return "error";
  var constructorName = ctorName(val);
  switch (constructorName) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return constructorName;
  }
  return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
  return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
  return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate$2(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
  var typeOfVal = typeof val;
  if (process.env.NODE_ENV !== "production") {
    typeOfVal = miniKindOf(val);
  }
  return typeOfVal;
}
function createStore$2(reducer2, preloadedState, enhancer) {
  var _ref2;
  if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  }
  if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
    enhancer = preloadedState;
    preloadedState = void 0;
  }
  if (typeof enhancer !== "undefined") {
    if (typeof enhancer !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }
    return enhancer(createStore$2)(reducer2, preloadedState);
  }
  if (typeof reducer2 !== "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer2) + "'");
  }
  var currentReducer = reducer2;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  function getState() {
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    }
    return currentState;
  }
  function subscribe(listener) {
    if (typeof listener !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    }
    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index2 = nextListeners.indexOf(listener);
      nextListeners.splice(index2, 1);
      currentListeners = null;
    };
  }
  function dispatch(action) {
    if (!isPlainObject$4(action)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }
    if (typeof action.type === "undefined") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : "Reducers may not dispatch actions.");
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }
    return action;
  }
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }
    currentReducer = nextReducer;
    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  function observable() {
    var _ref;
    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe2(observer) {
        if (typeof observer !== "object" || observer === null) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }
        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }
        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe
        };
      }
    }, _ref[$$observable] = function() {
      return this;
    }, _ref;
  }
  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch,
    subscribe,
    getState,
    replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
function bindActionCreator(actionCreator, dispatch) {
  return function() {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
function bindActionCreators$1(actionCreators, dispatch) {
  if (typeof actionCreators === "function") {
    return bindActionCreator(actionCreators, dispatch);
  }
  if (typeof actionCreators !== "object" || actionCreators === null) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + `'. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?`);
  }
  var boundActionCreators = {};
  for (var key2 in actionCreators) {
    var actionCreator = actionCreators[key2];
    if (typeof actionCreator === "function") {
      boundActionCreators[key2] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}
function compose$2() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }
  if (funcs.length === 0) {
    return function(arg) {
      return arg;
    };
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce(function(a2, b2) {
    return function() {
      return a2(b2.apply(void 0, arguments));
    };
  });
}
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }
  return function(createStore2) {
    return function() {
      var store = createStore2.apply(void 0, arguments);
      var _dispatch = function dispatch() {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      };
      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function(middleware2) {
        return middleware2(middlewareAPI);
      });
      _dispatch = compose$2.apply(void 0, chain)(store.dispatch);
      return _objectSpread2$2(_objectSpread2$2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}
var propTypes = { exports: {} };
var reactIs = { exports: {} };
var reactIs_production_min = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b2 = Symbol.for("react.element"), c2 = Symbol.for("react.portal"), d2 = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f2 = Symbol.for("react.profiler"), g2 = Symbol.for("react.provider"), h2 = Symbol.for("react.context"), k2 = Symbol.for("react.server_context"), l2 = Symbol.for("react.forward_ref"), m2 = Symbol.for("react.suspense"), n2 = Symbol.for("react.suspense_list"), p2 = Symbol.for("react.memo"), q2 = Symbol.for("react.lazy"), t2 = Symbol.for("react.offscreen"), u2;
  u2 = Symbol.for("react.module.reference");
  function v2(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var r2 = a2.$$typeof;
      switch (r2) {
        case b2:
          switch (a2 = a2.type, a2) {
            case d2:
            case f2:
            case e:
            case m2:
            case n2:
              return a2;
            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k2:
                case h2:
                case l2:
                case q2:
                case p2:
                case g2:
                  return a2;
                default:
                  return r2;
              }
          }
        case c2:
          return r2;
      }
    }
  }
  reactIs_production_min.ContextConsumer = h2;
  reactIs_production_min.ContextProvider = g2;
  reactIs_production_min.Element = b2;
  reactIs_production_min.ForwardRef = l2;
  reactIs_production_min.Fragment = d2;
  reactIs_production_min.Lazy = q2;
  reactIs_production_min.Memo = p2;
  reactIs_production_min.Portal = c2;
  reactIs_production_min.Profiler = f2;
  reactIs_production_min.StrictMode = e;
  reactIs_production_min.Suspense = m2;
  reactIs_production_min.SuspenseList = n2;
  reactIs_production_min.isAsyncMode = function() {
    return false;
  };
  reactIs_production_min.isConcurrentMode = function() {
    return false;
  };
  reactIs_production_min.isContextConsumer = function(a2) {
    return v2(a2) === h2;
  };
  reactIs_production_min.isContextProvider = function(a2) {
    return v2(a2) === g2;
  };
  reactIs_production_min.isElement = function(a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === b2;
  };
  reactIs_production_min.isForwardRef = function(a2) {
    return v2(a2) === l2;
  };
  reactIs_production_min.isFragment = function(a2) {
    return v2(a2) === d2;
  };
  reactIs_production_min.isLazy = function(a2) {
    return v2(a2) === q2;
  };
  reactIs_production_min.isMemo = function(a2) {
    return v2(a2) === p2;
  };
  reactIs_production_min.isPortal = function(a2) {
    return v2(a2) === c2;
  };
  reactIs_production_min.isProfiler = function(a2) {
    return v2(a2) === f2;
  };
  reactIs_production_min.isStrictMode = function(a2) {
    return v2(a2) === e;
  };
  reactIs_production_min.isSuspense = function(a2) {
    return v2(a2) === m2;
  };
  reactIs_production_min.isSuspenseList = function(a2) {
    return v2(a2) === n2;
  };
  reactIs_production_min.isValidElementType = function(a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === d2 || a2 === f2 || a2 === e || a2 === m2 || a2 === n2 || a2 === t2 || "object" === typeof a2 && null !== a2 && (a2.$$typeof === q2 || a2.$$typeof === p2 || a2.$$typeof === g2 || a2.$$typeof === h2 || a2.$$typeof === l2 || a2.$$typeof === u2 || void 0 !== a2.getModuleId) ? true : false;
  };
  reactIs_production_min.typeOf = v2;
  return reactIs_production_min;
}
var reactIs_development = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function typeOf2(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_SERVER_CONTEXT_TYPE:
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal2 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      var hasWarnedAboutDeprecatedIsConcurrentMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }
      function isConcurrentMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true;
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }
      function isContextConsumer(object) {
        return typeOf2(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf2(object) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf2(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment2(object) {
        return typeOf2(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf2(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf2(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf2(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf2(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf2(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf2(object) === REACT_SUSPENSE_TYPE;
      }
      function isSuspenseList(object) {
        return typeOf2(object) === REACT_SUSPENSE_LIST_TYPE;
      }
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal2;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.SuspenseList = SuspenseList;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement2;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment2;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isSuspenseList = isSuspenseList;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf2;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject2(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2["_" + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
        return test2[n2];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from3;
    var to2 = toObject2(target);
    var symbols;
    for (var s2 = 1; s2 < arguments.length; s2++) {
      from3 = Object(arguments[s2]);
      for (var key2 in from3) {
        if (hasOwnProperty2.call(from3, key2)) {
          to2[key2] = from3[key2];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from3);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from3, symbols[i])) {
            to2[symbols[i]] = from3[symbols[i]];
          }
        }
      }
    }
    return to2;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = /* @__PURE__ */ requireHas();
    printWarning = function(text2) {
      var message2 = "Warning: " + text2;
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x2) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values2, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error2;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error2 = typeSpecs[typeSpecName](values2, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error2 = ex;
          }
          if (error2 && !(error2 instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error2 + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error2 instanceof Error && !(error2.message in loggedTypeFailures)) {
            loggedTypeFailures[error2.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error2.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign2 = requireObjectAssign();
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  var has2 = /* @__PURE__ */ requireHas();
  var checkPropTypes = /* @__PURE__ */ requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text2) {
      var message2 = "Warning: " + text2;
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x2) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is2(x2, y2) {
      if (x2 === y2) {
        return x2 !== 0 || 1 / x2 === 1 / y2;
      } else {
        return x2 !== x2 && y2 !== y2;
      }
    }
    function PropTypeError(message2, data) {
      this.message = message2;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error2 = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
          if (error2 instanceof Error) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is2(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key2, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key2 in propValue) {
          if (has2(propValue, key2)) {
            var error2 = typeChecker(propValue, key2, componentName, location, propFullName + "." + key2, ReactPropTypesSecret);
            if (error2 instanceof Error) {
              return error2;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker2 = arrayOfTypeCheckers[i2];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode2(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key2, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key2 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key2 in shapeTypes) {
          var checker = shapeTypes[key2];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key2, getPreciseType(checker));
          }
          var error2 = checker(propValue, key2, componentName, location, propFullName + "." + key2, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign2({}, props[propName], shapeTypes);
        for (var key2 in allKeys) {
          var checker = shapeTypes[key2];
          if (has2(shapeTypes, key2) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key2, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key2 + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error2 = checker(propValue, key2, componentName, location, propFullName + "." + key2, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode2(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode2);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode2(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode2(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  function emptyFunction2() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction2;
  factoryWithThrowingShims = function() {
    function shim2(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim2.isRequired = shim2;
    function getShim() {
      return shim2;
    }
    var ReactPropTypes = {
      array: shim2,
      bigint: shim2,
      bool: shim2,
      func: shim2,
      number: shim2,
      object: shim2,
      string: shim2,
      symbol: shim2,
      any: shim2,
      arrayOf: getShim,
      element: shim2,
      elementType: shim2,
      instanceOf: getShim,
      node: shim2,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction2
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  hasRequiredPropTypes = 1;
  if (process.env.NODE_ENV !== "production") {
    var ReactIs = requireReactIs();
    var throwOnDirectAccess = true;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
  } else {
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  }
  return propTypes.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs$1(propTypesExports);
var ReactReduxContext = /* @__PURE__ */ React__default.createContext(null);
if (process.env.NODE_ENV !== "production") {
  ReactReduxContext.displayName = "ReactRedux";
}
function defaultNoopBatch(callback) {
  callback();
}
var batch = defaultNoopBatch;
var setBatch = function setBatch2(newBatch) {
  return batch = newBatch;
};
var getBatch = function getBatch2() {
  return batch;
};
function createListenerCollection() {
  var batch2 = getBatch();
  var first2 = null;
  var last = null;
  return {
    clear: function clear() {
      first2 = null;
      last = null;
    },
    notify: function notify2() {
      batch2(function() {
        var listener = first2;
        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get6() {
      var listeners = [];
      var listener = first2;
      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }
      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback,
        next: null,
        prev: last
      };
      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first2 = listener;
      }
      return function unsubscribe() {
        if (!isSubscribed || first2 === null) return;
        isSubscribed = false;
        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }
        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first2 = listener.next;
        }
      };
    }
  };
}
var nullListeners = {
  notify: function notify() {
  },
  get: function get() {
    return [];
  }
};
function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;
  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }
  function notifyNestedSubs() {
    listeners.notify();
  }
  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }
  function isSubscribed() {
    return Boolean(unsubscribe);
  }
  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }
  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = void 0;
      listeners.clear();
      listeners = nullListeners;
    }
  }
  var subscription = {
    addNestedSub,
    notifyNestedSubs,
    handleChangeWrapper,
    isSubscribed,
    trySubscribe,
    tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}
var useIsomorphicLayoutEffect$6 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? useLayoutEffect : useEffect;
function Provider$1(_ref) {
  var store = _ref.store, context = _ref.context, children = _ref.children;
  var contextValue = useMemo$1(function() {
    var subscription = createSubscription(store);
    return {
      store,
      subscription
    };
  }, [store]);
  var previousState = useMemo$1(function() {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect$6(function() {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();
    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }
    return function() {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context2 = context || ReactReduxContext;
  return /* @__PURE__ */ React__default.createElement(Context2.Provider, {
    value: contextValue
  }, children);
}
if (process.env.NODE_ENV !== "production") {
  Provider$1.propTypes = {
    store: PropTypes.shape({
      subscribe: PropTypes.func.isRequired,
      dispatch: PropTypes.func.isRequired,
      getState: PropTypes.func.isRequired
    }),
    context: PropTypes.object,
    children: PropTypes.any
  };
}
function _objectWithoutPropertiesLoose$3(r2, e) {
  if (null == r2) return {};
  var t2 = {};
  for (var n2 in r2) if ({}.hasOwnProperty.call(r2, n2)) {
    if (-1 !== e.indexOf(n2)) continue;
    t2[n2] = r2[n2];
  }
  return t2;
}
var hoistNonReactStatics_cjs;
var hasRequiredHoistNonReactStatics_cjs;
function requireHoistNonReactStatics_cjs() {
  if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
  hasRequiredHoistNonReactStatics_cjs = 1;
  var reactIs2 = requireReactIs();
  var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
  };
  var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
  };
  var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
  };
  var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
  };
  var TYPE_STATICS = {};
  TYPE_STATICS[reactIs2.ForwardRef] = FORWARD_REF_STATICS;
  TYPE_STATICS[reactIs2.Memo] = MEMO_STATICS;
  function getStatics(component) {
    if (reactIs2.isMemo(component)) {
      return MEMO_STATICS;
    }
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
  }
  var defineProperty = Object.defineProperty;
  var getOwnPropertyNames = Object.getOwnPropertyNames;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var getPrototypeOf = Object.getPrototypeOf;
  var objectPrototype = Object.prototype;
  function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
      if (objectPrototype) {
        var inheritedComponent = getPrototypeOf(sourceComponent);
        if (inheritedComponent && inheritedComponent !== objectPrototype) {
          hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
      }
      var keys2 = getOwnPropertyNames(sourceComponent);
      if (getOwnPropertySymbols) {
        keys2 = keys2.concat(getOwnPropertySymbols(sourceComponent));
      }
      var targetStatics = getStatics(targetComponent);
      var sourceStatics = getStatics(sourceComponent);
      for (var i = 0; i < keys2.length; ++i) {
        var key2 = keys2[i];
        if (!KNOWN_STATICS[key2] && !(blacklist && blacklist[key2]) && !(sourceStatics && sourceStatics[key2]) && !(targetStatics && targetStatics[key2])) {
          var descriptor = getOwnPropertyDescriptor(sourceComponent, key2);
          try {
            defineProperty(targetComponent, key2, descriptor);
          } catch (e) {
          }
        }
      }
    }
    return targetComponent;
  }
  hoistNonReactStatics_cjs = hoistNonReactStatics;
  return hoistNonReactStatics_cjs;
}
var hoistNonReactStatics_cjsExports = requireHoistNonReactStatics_cjs();
const m = /* @__PURE__ */ getDefaultExportFromCjs$1(hoistNonReactStatics_cjsExports);
var reactIsExports = requireReactIs();
var _excluded$4 = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"], _excluded2 = ["reactReduxForwardedRef"];
var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];
var stringifyComponent = function stringifyComponent2(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};
function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect$6(function() {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}
function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false;
  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}
function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  if (!shouldHandleStateChanges) return;
  var didUnsubscribe = false;
  var lastThrownError = null;
  var checkForUpdates = function checkForUpdates2() {
    if (didUnsubscribe) {
      return;
    }
    var latestStoreState = store.getState();
    var newChildProps, error2;
    try {
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error2 = e;
      lastThrownError = e;
    }
    if (!error2) {
      lastThrownError = null;
    }
    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true;
      forceComponentUpdateDispatch({
        type: "STORE_UPDATED",
        payload: {
          error: error2
        }
      });
    }
  };
  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe();
  checkForUpdates();
  var unsubscribeWrapper = function unsubscribeWrapper2() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;
    if (lastThrownError) {
      throw lastThrownError;
    }
  };
  return unsubscribeWrapper;
}
var initStateUpdates = function initStateUpdates2() {
  return [null, 0];
};
function connectAdvanced(selectorFactory, _ref) {
  if (_ref === void 0) {
    _ref = {};
  }
  var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name2) {
    return "ConnectAdvanced(" + name2 + ")";
  } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? void 0 : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef2 = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context, connectOptions = _objectWithoutPropertiesLoose$3(_ref2, _excluded$4);
  if (process.env.NODE_ENV !== "production") {
    if (renderCountProp !== void 0) {
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    }
    if (withRef) {
      throw new Error("withRef is removed. To access the wrapped instance, use a ref on the connected component");
    }
    var customStoreWarningMessage = "To use a custom Redux store for specific components, create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    if (storeKey !== "store") {
      throw new Error("storeKey has been removed and does not do anything. " + customStoreWarningMessage);
    }
  }
  var Context2 = context;
  return function wrapWithConnect(WrappedComponent) {
    if (process.env.NODE_ENV !== "production" && !reactIsExports.isValidElementType(WrappedComponent)) {
      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
    var displayName = getDisplayName(wrappedComponentName);
    var selectorFactoryOptions = _extends$6({}, connectOptions, {
      getDisplayName,
      methodName,
      renderCountProp,
      shouldHandleStateChanges,
      storeKey,
      displayName,
      wrappedComponentName,
      WrappedComponent
    });
    var pure = connectOptions.pure;
    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    }
    var usePureOnlyMemo = pure ? useMemo$1 : function(callback) {
      return callback();
    };
    function ConnectFunction(props) {
      var _useMemo = useMemo$1(function() {
        var reactReduxForwardedRef2 = props.reactReduxForwardedRef, wrapperProps2 = _objectWithoutPropertiesLoose$3(props, _excluded2);
        return [props.context, reactReduxForwardedRef2, wrapperProps2];
      }, [props]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
      var ContextToUse = useMemo$1(function() {
        return propsContext && propsContext.Consumer && reactIsExports.isContextConsumer(/* @__PURE__ */ React__default.createElement(propsContext.Consumer, null)) ? propsContext : Context2;
      }, [propsContext, Context2]);
      var contextValue = useContext(ContextToUse);
      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
      if (process.env.NODE_ENV !== "production" && !didStoreComeFromProps && !didStoreComeFromContext) {
        throw new Error('Could not find "store" in the context of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      }
      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = useMemo$1(function() {
        return createChildSelector(store);
      }, [store]);
      var _useMemo2 = useMemo$1(function() {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY;
        var subscription2 = createSubscription(store, didStoreComeFromProps ? null : contextValue.subscription);
        var notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
        return [subscription2, notifyNestedSubs2];
      }, [store, didStoreComeFromProps, contextValue]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1];
      var overriddenContextValue = useMemo$1(function() {
        if (didStoreComeFromProps) {
          return contextValue;
        }
        return _extends$6({}, contextValue, {
          subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]);
      var _useReducer = useReducer(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1];
      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      }
      var lastChildProps = useRef();
      var lastWrapperProps = useRef(wrapperProps);
      var childPropsFromStoreUpdate = useRef();
      var renderIsScheduled = useRef(false);
      var actualChildProps = usePureOnlyMemo(function() {
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        }
        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]);
      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]);
      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]);
      var renderedWrappedComponent = useMemo$1(function() {
        return /* @__PURE__ */ React__default.createElement(WrappedComponent, _extends$6({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]);
      var renderedChild = useMemo$1(function() {
        if (shouldHandleStateChanges) {
          return /* @__PURE__ */ React__default.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }
        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    }
    var Connect = pure ? React__default.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;
    if (forwardRef2) {
      var forwarded = React__default.forwardRef(function forwardConnectRef(props, ref2) {
        return /* @__PURE__ */ React__default.createElement(Connect, _extends$6({}, props, {
          reactReduxForwardedRef: ref2
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return m(forwarded, WrappedComponent);
    }
    return m(Connect, WrappedComponent);
  };
}
function is(x2, y2) {
  if (x2 === y2) {
    return x2 !== 0 || y2 !== 0 || 1 / x2 === 1 / y2;
  } else {
    return x2 !== x2 && y2 !== y2;
  }
}
function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;
  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}
function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};
  var _loop = function _loop2(key3) {
    var actionCreator = actionCreators[key3];
    if (typeof actionCreator === "function") {
      boundActionCreators[key3] = function() {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };
  for (var key2 in actionCreators) {
    _loop(key2);
  }
  return boundActionCreators;
}
function isPlainObject$3(obj) {
  if (typeof obj !== "object" || obj === null) return false;
  var proto2 = Object.getPrototypeOf(obj);
  if (proto2 === null) return true;
  var baseProto = proto2;
  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }
  return proto2 === baseProto;
}
function warning$3(message2) {
  if (typeof console !== "undefined" && typeof console.error === "function") {
    console.error(message2);
  }
  try {
    throw new Error(message2);
  } catch (e) {
  }
}
function verifyPlainObject(value, displayName, methodName) {
  if (!isPlainObject$3(value)) {
    warning$3(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}
function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);
    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== void 0 ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;
    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };
    proxy.dependsOnOwnProps = true;
    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);
      if (typeof props === "function") {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }
      if (process.env.NODE_ENV !== "production") verifyPlainObject(props, displayName, methodName);
      return props;
    };
    return proxy;
  };
}
function whenMapDispatchToPropsIsFunction(mapDispatchToProps2) {
  return typeof mapDispatchToProps2 === "function" ? wrapMapToPropsFunc(mapDispatchToProps2, "mapDispatchToProps") : void 0;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps2) {
  return !mapDispatchToProps2 ? wrapMapToPropsConstant(function(dispatch) {
    return {
      dispatch
    };
  }) : void 0;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps2) {
  return mapDispatchToProps2 && typeof mapDispatchToProps2 === "object" ? wrapMapToPropsConstant(function(dispatch) {
    return bindActionCreators(mapDispatchToProps2, dispatch);
  }) : void 0;
}
const defaultMapDispatchToPropsFactories = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === "function" ? wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : void 0;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function() {
    return {};
  }) : void 0;
}
const defaultMapStateToPropsFactories = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends$6({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (process.env.NODE_ENV !== "production") verifyPlainObject(mergedProps, displayName, "mergeProps");
      }
      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === "function" ? wrapMergePropsFunc(mergeProps) : void 0;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function() {
    return defaultMergeProps;
  } : void 0;
}
const defaultMergePropsFactories = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
function verify(selector2, methodName, displayName) {
  if (!selector2) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
    if (!Object.prototype.hasOwnProperty.call(selector2, "dependsOnOwnProps")) {
      warning$3("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}
function verifySubselectors(mapStateToProps, mapDispatchToProps2, mergeProps, displayName) {
  verify(mapStateToProps, "mapStateToProps", displayName);
  verify(mapDispatchToProps2, "mapDispatchToProps", displayName);
  verify(mergeProps, "mergeProps", displayName);
}
var _excluded$3 = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps2, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps2(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps2, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;
  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps2(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }
  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps2.dependsOnOwnProps) dispatchProps = mapDispatchToProps2(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }
  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps2.dependsOnOwnProps) dispatchProps = mapDispatchToProps2(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }
  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }
  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }
  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}
function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = _objectWithoutPropertiesLoose$3(_ref2, _excluded$3);
  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps2 = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);
  if (process.env.NODE_ENV !== "production") {
    verifySubselectors(mapStateToProps, mapDispatchToProps2, mergeProps, options.displayName);
  }
  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps2, mergeProps, dispatch, options);
}
var _excluded$2 = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
function match$2(arg, factories, name2) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }
  return function(dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name2 + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}
function strictEqual(a2, b2) {
  return a2 === b2;
}
function createConnect(_temp5) {
  var _ref = _temp5 === void 0 ? {} : _temp5, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;
  return function connect2(mapStateToProps, mapDispatchToProps2, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }
    var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE, extraOptions = _objectWithoutPropertiesLoose$3(_ref3, _excluded$2);
    var initMapStateToProps = match$2(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
    var initMapDispatchToProps = match$2(mapDispatchToProps2, mapDispatchToPropsFactories, "mapDispatchToProps");
    var initMergeProps = match$2(mergeProps, mergePropsFactories, "mergeProps");
    return connectHOC(selectorFactory, _extends$6({
      // used in error messages
      methodName: "connect",
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name2) {
        return "Connect(" + name2 + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps,
      initMapDispatchToProps,
      initMergeProps,
      pure,
      areStatesEqual,
      areOwnPropsEqual,
      areStatePropsEqual,
      areMergedPropsEqual
    }, extraOptions));
  };
}
const connect = /* @__PURE__ */ createConnect();
setBatch(unstable_batchedUpdates);
function areInputsEqual$1(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }
  return true;
}
function useMemoOne(getResult, inputs) {
  var initial = useState(function() {
    return {
      inputs,
      result: getResult()
    };
  })[0];
  var isFirstRun = useRef(true);
  var committed = useRef(initial);
  var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && areInputsEqual$1(inputs, committed.current.inputs));
  var cache = useCache ? committed.current : {
    inputs,
    result: getResult()
  };
  useEffect(function() {
    isFirstRun.current = false;
    committed.current = cache;
  }, [cache]);
  return cache.result;
}
function useCallbackOne(callback, inputs) {
  return useMemoOne(function() {
    return callback;
  }, inputs);
}
var useMemo = useMemoOne;
var useCallback = useCallbackOne;
var isProduction$2 = process.env.NODE_ENV === "production";
var prefix$3 = "Invariant failed";
function invariant$2(condition, message2) {
  if (isProduction$2) {
    throw new Error(prefix$3);
  }
  var provided = typeof message2 === "function" ? message2() : message2;
  var value = provided ? "".concat(prefix$3, ": ").concat(provided) : prefix$3;
  throw new Error(value);
}
var getRect = function getRect2(_ref) {
  var top2 = _ref.top, right2 = _ref.right, bottom2 = _ref.bottom, left2 = _ref.left;
  var width2 = right2 - left2;
  var height2 = bottom2 - top2;
  var rect = {
    top: top2,
    right: right2,
    bottom: bottom2,
    left: left2,
    width: width2,
    height: height2,
    x: left2,
    y: top2,
    center: {
      x: (right2 + left2) / 2,
      y: (bottom2 + top2) / 2
    }
  };
  return rect;
};
var expand = function expand2(target, expandBy) {
  return {
    top: target.top - expandBy.top,
    left: target.left - expandBy.left,
    bottom: target.bottom + expandBy.bottom,
    right: target.right + expandBy.right
  };
};
var shrink = function shrink2(target, shrinkBy) {
  return {
    top: target.top + shrinkBy.top,
    left: target.left + shrinkBy.left,
    bottom: target.bottom - shrinkBy.bottom,
    right: target.right - shrinkBy.right
  };
};
var shift$1 = function shift(target, shiftBy) {
  return {
    top: target.top + shiftBy.y,
    left: target.left + shiftBy.x,
    bottom: target.bottom + shiftBy.y,
    right: target.right + shiftBy.x
  };
};
var noSpacing$2 = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var createBox = function createBox2(_ref2) {
  var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin2 = _ref2$margin === void 0 ? noSpacing$2 : _ref2$margin, _ref2$border = _ref2.border, border2 = _ref2$border === void 0 ? noSpacing$2 : _ref2$border, _ref2$padding = _ref2.padding, padding2 = _ref2$padding === void 0 ? noSpacing$2 : _ref2$padding;
  var marginBox = getRect(expand(borderBox, margin2));
  var paddingBox = getRect(shrink(borderBox, border2));
  var contentBox = getRect(shrink(paddingBox, padding2));
  return {
    marginBox,
    borderBox: getRect(borderBox),
    paddingBox,
    contentBox,
    margin: margin2,
    border: border2,
    padding: padding2
  };
};
var parse$3 = function parse(raw) {
  var value = raw.slice(0, -2);
  var suffix2 = raw.slice(-2);
  if (suffix2 !== "px") {
    return 0;
  }
  var result = Number(value);
  !!isNaN(result) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Could not parse value [raw: " + raw + ", without suffix: " + value + "]") : invariant$2() : void 0;
  return result;
};
var getWindowScroll$2 = function getWindowScroll() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};
var offset$4 = function offset(original, change) {
  var borderBox = original.borderBox, border2 = original.border, margin2 = original.margin, padding2 = original.padding;
  var shifted = shift$1(borderBox, change);
  return createBox({
    borderBox: shifted,
    border: border2,
    margin: margin2,
    padding: padding2
  });
};
var withScroll = function withScroll2(original, scroll4) {
  if (scroll4 === void 0) {
    scroll4 = getWindowScroll$2();
  }
  return offset$4(original, scroll4);
};
var calculateBox = function calculateBox2(borderBox, styles2) {
  var margin2 = {
    top: parse$3(styles2.marginTop),
    right: parse$3(styles2.marginRight),
    bottom: parse$3(styles2.marginBottom),
    left: parse$3(styles2.marginLeft)
  };
  var padding2 = {
    top: parse$3(styles2.paddingTop),
    right: parse$3(styles2.paddingRight),
    bottom: parse$3(styles2.paddingBottom),
    left: parse$3(styles2.paddingLeft)
  };
  var border2 = {
    top: parse$3(styles2.borderTopWidth),
    right: parse$3(styles2.borderRightWidth),
    bottom: parse$3(styles2.borderBottomWidth),
    left: parse$3(styles2.borderLeftWidth)
  };
  return createBox({
    borderBox,
    margin: margin2,
    padding: padding2,
    border: border2
  });
};
var getBox = function getBox2(el) {
  var borderBox = el.getBoundingClientRect();
  var styles2 = window.getComputedStyle(el);
  return calculateBox(borderBox, styles2);
};
var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === "number" && value !== value;
};
function isEqual$6(first2, second) {
  if (first2 === second) {
    return true;
  }
  if (safeIsNaN(first2) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i = 0; i < newInputs.length; i++) {
    if (!isEqual$6(newInputs[i], lastInputs[i])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual7) {
  if (isEqual7 === void 0) {
    isEqual7 = areInputsEqual;
  }
  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (calledOnce && lastThis === this && isEqual7(newArgs, lastArgs)) {
      return lastResult;
    }
    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }
  return memoized;
}
var rafSchd = function rafSchd2(fn2) {
  var lastArgs = [];
  var frameId = null;
  var wrapperFn = function wrapperFn2() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    lastArgs = args;
    if (frameId) {
      return;
    }
    frameId = requestAnimationFrame(function() {
      frameId = null;
      fn2.apply(void 0, lastArgs);
    });
  };
  wrapperFn.cancel = function() {
    if (!frameId) {
      return;
    }
    cancelAnimationFrame(frameId);
    frameId = null;
  };
  return wrapperFn;
};
var isProduction$1 = process.env.NODE_ENV === "production";
var spacesAndTabs$1 = /[ \t]{2,}/g;
var lineStartWithSpaces$1 = /^[ \t]*/gm;
var clean$4 = function clean(value) {
  return value.replace(spacesAndTabs$1, " ").replace(lineStartWithSpaces$1, "").trim();
};
var getDevMessage$1 = function getDevMessage(message2) {
  return clean$4("\n  %creact-beautiful-dnd\n\n  %c" + clean$4(message2) + "\n\n  %c👷‍ This is a development only message. It will be removed in production builds.\n");
};
var getFormattedMessage$1 = function getFormattedMessage(message2) {
  return [getDevMessage$1(message2), "color: #00C584; font-size: 1.2em; font-weight: bold;", "line-height: 1.5", "color: #723874;"];
};
var isDisabledFlag$1 = "__react-beautiful-dnd-disable-dev-warnings";
function log(type, message2) {
  var _console;
  if (isProduction$1) {
    return;
  }
  if (typeof window !== "undefined" && window[isDisabledFlag$1]) {
    return;
  }
  (_console = console)[type].apply(_console, getFormattedMessage$1(message2));
}
var warning$2 = log.bind(null, "warn");
var error$1 = log.bind(null, "error");
function noop$7() {
}
function getOptions$2(shared2, fromBinding) {
  return _extends$6({}, shared2, {}, fromBinding);
}
function bindEvents$1(el, bindings, sharedOptions2) {
  var unbindings = bindings.map(function(binding) {
    var options = getOptions$2(sharedOptions2, binding.options);
    el.addEventListener(binding.eventName, binding.fn, options);
    return function unbind() {
      el.removeEventListener(binding.eventName, binding.fn, options);
    };
  });
  return function unbindAll() {
    unbindings.forEach(function(unbind) {
      unbind();
    });
  };
}
var isProduction$1$1 = process.env.NODE_ENV === "production";
var prefix$2 = "Invariant failed";
function RbdInvariant(message2) {
  this.message = message2;
}
RbdInvariant.prototype.toString = function toString() {
  return this.message;
};
function invariant$1(condition, message2) {
  if (isProduction$1$1) {
    throw new RbdInvariant(prefix$2);
  } else {
    throw new RbdInvariant(prefix$2 + ": " + (message2 || ""));
  }
}
var ErrorBoundary$1 = function(_React$Component) {
  _inheritsLoose$2(ErrorBoundary2, _React$Component);
  function ErrorBoundary2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.callbacks = null;
    _this.unbind = noop$7;
    _this.onWindowError = function(event) {
      var callbacks = _this.getCallbacks();
      if (callbacks.isDragging()) {
        callbacks.tryAbort();
        process.env.NODE_ENV !== "production" ? warning$2("\n        An error was caught by our window 'error' event listener while a drag was occurring.\n        The active drag has been aborted.\n      ") : void 0;
      }
      var err = event.error;
      if (err instanceof RbdInvariant) {
        event.preventDefault();
        if (process.env.NODE_ENV !== "production") {
          error$1(err.message);
        }
      }
    };
    _this.getCallbacks = function() {
      if (!_this.callbacks) {
        throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
      }
      return _this.callbacks;
    };
    _this.setCallbacks = function(callbacks) {
      _this.callbacks = callbacks;
    };
    return _this;
  }
  var _proto = ErrorBoundary2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.unbind = bindEvents$1(window, [{
      eventName: "error",
      fn: this.onWindowError
    }]);
  };
  _proto.componentDidCatch = function componentDidCatch(err) {
    if (err instanceof RbdInvariant) {
      if (process.env.NODE_ENV !== "production") {
        error$1(err.message);
      }
      this.setState({});
      return;
    }
    throw err;
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unbind();
  };
  _proto.render = function render() {
    return this.props.children(this.setCallbacks);
  };
  return ErrorBoundary2;
}(React__default.Component);
var dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";
var position$5 = function position(index2) {
  return index2 + 1;
};
var onDragStart$1 = function onDragStart(start4) {
  return "\n  You have lifted an item in position " + position$5(start4.source.index) + "\n";
};
var withLocation$1 = function withLocation(source, destination) {
  var isInHomeList = source.droppableId === destination.droppableId;
  var startPosition = position$5(source.index);
  var endPosition = position$5(destination.index);
  if (isInHomeList) {
    return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
  }
  return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var withCombine$1 = function withCombine(id, source, combine2) {
  var inHomeList = source.droppableId === combine2.droppableId;
  if (inHomeList) {
    return "\n      The item " + id + "\n      has been combined with " + combine2.draggableId;
  }
  return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine2.draggableId + "\n      in list " + combine2.droppableId + "\n    ";
};
var onDragUpdate$1 = function onDragUpdate(update2) {
  var location = update2.destination;
  if (location) {
    return withLocation$1(update2.source, location);
  }
  var combine2 = update2.combine;
  if (combine2) {
    return withCombine$1(update2.draggableId, update2.source, combine2);
  }
  return "You are over an area that cannot be dropped on";
};
var returnedToStart$1 = function returnedToStart(source) {
  return "\n  The item has returned to its starting position\n  of " + position$5(source.index) + "\n";
};
var onDragEnd$1 = function onDragEnd(result) {
  if (result.reason === "CANCEL") {
    return "\n      Movement cancelled.\n      " + returnedToStart$1(result.source) + "\n    ";
  }
  var location = result.destination;
  var combine2 = result.combine;
  if (location) {
    return "\n      You have dropped the item.\n      " + withLocation$1(result.source, location) + "\n    ";
  }
  if (combine2) {
    return "\n      You have dropped the item.\n      " + withCombine$1(result.draggableId, result.source, combine2) + "\n    ";
  }
  return "\n    The item has been dropped while not over a drop area.\n    " + returnedToStart$1(result.source) + "\n  ";
};
var preset$1 = {
  dragHandleUsageInstructions,
  onDragStart: onDragStart$1,
  onDragUpdate: onDragUpdate$1,
  onDragEnd: onDragEnd$1
};
var origin$1 = {
  x: 0,
  y: 0
};
var add$4 = function add(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};
var subtract$4 = function subtract(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};
var isEqual$5 = function isEqual(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};
var negate$1 = function negate(point2) {
  return {
    x: point2.x !== 0 ? -point2.x : 0,
    y: point2.y !== 0 ? -point2.y : 0
  };
};
var patch$2 = function patch(line2, value, otherValue) {
  var _ref;
  if (otherValue === void 0) {
    otherValue = 0;
  }
  return _ref = {}, _ref[line2] = value, _ref[line2 === "x" ? "y" : "x"] = otherValue, _ref;
};
var distance$1 = function distance(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var closest$1 = function closest(target, points) {
  return Math.min.apply(Math, points.map(function(point2) {
    return distance$1(target, point2);
  }));
};
var apply$3 = function apply(fn2) {
  return function(point2) {
    return {
      x: fn2(point2.x),
      y: fn2(point2.y)
    };
  };
};
var executeClip$1 = function(frame, subject) {
  var result = getRect({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left)
  });
  if (result.width <= 0 || result.height <= 0) {
    return null;
  }
  return result;
};
var offsetByPosition$1 = function offsetByPosition(spacing, point2) {
  return {
    top: spacing.top + point2.y,
    left: spacing.left + point2.x,
    bottom: spacing.bottom + point2.y,
    right: spacing.right + point2.x
  };
};
var getCorners$1 = function getCorners(spacing) {
  return [{
    x: spacing.left,
    y: spacing.top
  }, {
    x: spacing.right,
    y: spacing.top
  }, {
    x: spacing.left,
    y: spacing.bottom
  }, {
    x: spacing.right,
    y: spacing.bottom
  }];
};
var noSpacing$1 = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var scroll$2 = function scroll(target, frame) {
  if (!frame) {
    return target;
  }
  return offsetByPosition$1(target, frame.scroll.diff.displacement);
};
var increase$1 = function increase(target, axis, withPlaceholder) {
  if (withPlaceholder && withPlaceholder.increasedBy) {
    var _extends2;
    return _extends$6({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
  }
  return target;
};
var clip$1 = function clip(target, frame) {
  if (frame && frame.shouldClipSubject) {
    return executeClip$1(frame.pageMarginBox, target);
  }
  return getRect(target);
};
var getSubject$1 = function(_ref) {
  var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
  var scrolled = scroll$2(page.marginBox, frame);
  var increased = increase$1(scrolled, axis, withPlaceholder);
  var clipped = clip$1(increased, frame);
  return {
    page,
    withPlaceholder,
    active: clipped
  };
};
var scrollDroppable$1 = function(droppable2, newScroll) {
  !droppable2.frame ? process.env.NODE_ENV !== "production" ? invariant$1() : invariant$1() : void 0;
  var scrollable = droppable2.frame;
  var scrollDiff = subtract$4(newScroll, scrollable.scroll.initial);
  var scrollDisplacement = negate$1(scrollDiff);
  var frame = _extends$6({}, scrollable, {
    scroll: {
      initial: scrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement
      },
      max: scrollable.scroll.max
    }
  });
  var subject = getSubject$1({
    page: droppable2.subject.page,
    withPlaceholder: droppable2.subject.withPlaceholder,
    axis: droppable2.axis,
    frame
  });
  var result = _extends$6({}, droppable2, {
    frame,
    subject
  });
  return result;
};
function isInteger$2(value) {
  if (Number.isInteger) {
    return Number.isInteger(value);
  }
  return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
function values$3(map3) {
  if (Object.values) {
    return Object.values(map3);
  }
  return Object.keys(map3).map(function(key2) {
    return map3[key2];
  });
}
function findIndex$2(list2, predicate) {
  if (list2.findIndex) {
    return list2.findIndex(predicate);
  }
  for (var i = 0; i < list2.length; i++) {
    if (predicate(list2[i])) {
      return i;
    }
  }
  return -1;
}
function find$3(list2, predicate) {
  if (list2.find) {
    return list2.find(predicate);
  }
  var index2 = findIndex$2(list2, predicate);
  if (index2 !== -1) {
    return list2[index2];
  }
  return void 0;
}
function toArray$1(list2) {
  return Array.prototype.slice.call(list2);
}
var toDroppableMap$1 = memoizeOne(function(droppables) {
  return droppables.reduce(function(previous2, current) {
    previous2[current.descriptor.id] = current;
    return previous2;
  }, {});
});
var toDraggableMap$1 = memoizeOne(function(draggables) {
  return draggables.reduce(function(previous2, current) {
    previous2[current.descriptor.id] = current;
    return previous2;
  }, {});
});
var toDroppableList$1 = memoizeOne(function(droppables) {
  return values$3(droppables);
});
var toDraggableList$1 = memoizeOne(function(draggables) {
  return values$3(draggables);
});
var getDraggablesInsideDroppable$1 = memoizeOne(function(droppableId, draggables) {
  var result = toDraggableList$1(draggables).filter(function(draggable2) {
    return droppableId === draggable2.descriptor.droppableId;
  }).sort(function(a2, b2) {
    return a2.descriptor.index - b2.descriptor.index;
  });
  return result;
});
function tryGetDestination(impact) {
  if (impact.at && impact.at.type === "REORDER") {
    return impact.at.destination;
  }
  return null;
}
function tryGetCombine(impact) {
  if (impact.at && impact.at.type === "COMBINE") {
    return impact.at.combine;
  }
  return null;
}
var removeDraggableFromList$1 = memoizeOne(function(remove, list2) {
  return list2.filter(function(item) {
    return item.descriptor.id !== remove.descriptor.id;
  });
});
var moveToNextCombine$1 = function(_ref) {
  var isMovingForward = _ref.isMovingForward, draggable2 = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
  if (!destination.isCombineEnabled) {
    return null;
  }
  var location = tryGetDestination(previousImpact);
  if (!location) {
    return null;
  }
  function getImpact(target) {
    var at = {
      type: "COMBINE",
      combine: {
        draggableId: target,
        droppableId: destination.descriptor.id
      }
    };
    return _extends$6({}, previousImpact, {
      at
    });
  }
  var all2 = previousImpact.displaced.all;
  var closestId = all2.length ? all2[0] : null;
  if (isMovingForward) {
    return closestId ? getImpact(closestId) : null;
  }
  var withoutDraggable = removeDraggableFromList$1(draggable2, insideDestination);
  if (!closestId) {
    if (!withoutDraggable.length) {
      return null;
    }
    var last = withoutDraggable[withoutDraggable.length - 1];
    return getImpact(last.descriptor.id);
  }
  var indexOfClosest = findIndex$2(withoutDraggable, function(d2) {
    return d2.descriptor.id === closestId;
  });
  !(indexOfClosest !== -1) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Could not find displaced item in set") : invariant$1() : void 0;
  var proposedIndex = indexOfClosest - 1;
  if (proposedIndex < 0) {
    return null;
  }
  var before = withoutDraggable[proposedIndex];
  return getImpact(before.descriptor.id);
};
var isHomeOf$1 = function(draggable2, destination) {
  return draggable2.descriptor.droppableId === destination.descriptor.id;
};
var noDisplacedBy$1 = {
  point: origin$1,
  value: 0
};
var emptyGroups = {
  invisible: {},
  visible: {},
  all: []
};
var noImpact$1 = {
  displaced: emptyGroups,
  displacedBy: noDisplacedBy$1,
  at: null
};
var isWithin$1 = function(lowerBound, upperBound) {
  return function(value) {
    return lowerBound <= value && value <= upperBound;
  };
};
var isPartiallyVisibleThroughFrame$1 = function(frame) {
  var isWithinVertical = isWithin$1(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin$1(frame.left, frame.right);
  return function(subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    if (isContained) {
      return true;
    }
    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
    if (isPartiallyContained) {
      return true;
    }
    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
    if (isTargetBiggerThanFrame) {
      return true;
    }
    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
    return isTargetBiggerOnOneAxis;
  };
};
var isTotallyVisibleThroughFrame$1 = function(frame) {
  var isWithinVertical = isWithin$1(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin$1(frame.left, frame.right);
  return function(subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    return isContained;
  };
};
var vertical$1 = {
  direction: "vertical",
  line: "y",
  crossAxisLine: "x",
  start: "top",
  end: "bottom",
  size: "height",
  crossAxisStart: "left",
  crossAxisEnd: "right",
  crossAxisSize: "width"
};
var horizontal$1 = {
  direction: "horizontal",
  line: "x",
  crossAxisLine: "y",
  start: "left",
  end: "right",
  size: "width",
  crossAxisStart: "top",
  crossAxisEnd: "bottom",
  crossAxisSize: "height"
};
var isTotallyVisibleThroughFrameOnAxis$1 = function(axis) {
  return function(frame) {
    var isWithinVertical = isWithin$1(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin$1(frame.left, frame.right);
    return function(subject) {
      if (axis === vertical$1) {
        return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
      }
      return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    };
  };
};
var getDroppableDisplaced$1 = function getDroppableDisplaced(target, destination) {
  var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin$1;
  return offsetByPosition$1(target, displacement);
};
var isVisibleInDroppable$1 = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
  if (!destination.subject.active) {
    return false;
  }
  return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var isVisibleInViewport$1 = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
  return isVisibleThroughFrameFn(viewport)(target);
};
var isVisible$2 = function isVisible(_ref) {
  var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement2 = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
  var displacedTarget = withDroppableDisplacement2 ? getDroppableDisplaced$1(toBeDisplaced, destination) : toBeDisplaced;
  return isVisibleInDroppable$1(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport$1(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var isPartiallyVisible$1 = function isPartiallyVisible(args) {
  return isVisible$2(_extends$6({}, args, {
    isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame$1
  }));
};
var isTotallyVisible$1 = function isTotallyVisible(args) {
  return isVisible$2(_extends$6({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrame$1
  }));
};
var isTotallyVisibleOnAxis$1 = function isTotallyVisibleOnAxis(args) {
  return isVisible$2(_extends$6({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis$1(args.destination.axis)
  }));
};
var getShouldAnimate$1 = function getShouldAnimate(id, last, forceShouldAnimate) {
  if (typeof forceShouldAnimate === "boolean") {
    return forceShouldAnimate;
  }
  if (!last) {
    return true;
  }
  var invisible = last.invisible, visible = last.visible;
  if (invisible[id]) {
    return false;
  }
  var previous2 = visible[id];
  return previous2 ? previous2.shouldAnimate : true;
};
function getTarget$1(draggable2, displacedBy) {
  var marginBox = draggable2.page.marginBox;
  var expandBy = {
    top: displacedBy.point.y,
    right: 0,
    bottom: 0,
    left: displacedBy.point.x
  };
  return getRect(expand(marginBox, expandBy));
}
function getDisplacementGroups(_ref) {
  var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
  return afterDragging.reduce(function process2(groups, draggable2) {
    var target = getTarget$1(draggable2, displacedBy);
    var id = draggable2.descriptor.id;
    groups.all.push(id);
    var isVisible4 = isPartiallyVisible$1({
      target,
      destination,
      viewport,
      withDroppableDisplacement: true
    });
    if (!isVisible4) {
      groups.invisible[draggable2.descriptor.id] = true;
      return groups;
    }
    var shouldAnimate = getShouldAnimate$1(id, last, forceShouldAnimate);
    var displacement = {
      draggableId: id,
      shouldAnimate
    };
    groups.visible[id] = displacement;
    return groups;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}
function getIndexOfLastItem(draggables, options) {
  if (!draggables.length) {
    return 0;
  }
  var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
  return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function goAtEnd(_ref) {
  var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
  var newIndex = getIndexOfLastItem(insideDestination, {
    inHomeList
  });
  return {
    displaced: emptyGroups,
    displacedBy,
    at: {
      type: "REORDER",
      destination: {
        droppableId: destination.descriptor.id,
        index: newIndex
      }
    }
  };
}
function calculateReorderImpact(_ref2) {
  var draggable2 = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index2 = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
  var inHomeList = isHomeOf$1(draggable2, destination);
  if (index2 == null) {
    return goAtEnd({
      insideDestination,
      inHomeList,
      displacedBy,
      destination
    });
  }
  var match5 = find$3(insideDestination, function(item) {
    return item.descriptor.index === index2;
  });
  if (!match5) {
    return goAtEnd({
      insideDestination,
      inHomeList,
      displacedBy,
      destination
    });
  }
  var withoutDragging = removeDraggableFromList$1(draggable2, insideDestination);
  var sliceFrom = insideDestination.indexOf(match5);
  var impacted = withoutDragging.slice(sliceFrom);
  var displaced = getDisplacementGroups({
    afterDragging: impacted,
    destination,
    displacedBy,
    last,
    viewport: viewport.frame,
    forceShouldAnimate
  });
  return {
    displaced,
    displacedBy,
    at: {
      type: "REORDER",
      destination: {
        droppableId: destination.descriptor.id,
        index: index2
      }
    }
  };
}
function didStartAfterCritical(draggableId, afterCritical) {
  return Boolean(afterCritical.effected[draggableId]);
}
var fromCombine$1 = function(_ref) {
  var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine2 = _ref.combine, afterCritical = _ref.afterCritical;
  if (!destination.isCombineEnabled) {
    return null;
  }
  var combineId = combine2.draggableId;
  var combineWith = draggables[combineId];
  var combineWithIndex = combineWith.descriptor.index;
  var didCombineWithStartAfterCritical = didStartAfterCritical(combineId, afterCritical);
  if (didCombineWithStartAfterCritical) {
    if (isMovingForward) {
      return combineWithIndex;
    }
    return combineWithIndex - 1;
  }
  if (isMovingForward) {
    return combineWithIndex + 1;
  }
  return combineWithIndex;
};
var fromReorder$1 = function(_ref) {
  var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
  if (!insideDestination.length) {
    return null;
  }
  var currentIndex = location.index;
  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
  var firstIndex = insideDestination[0].descriptor.index;
  var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
  var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
  if (proposedIndex < firstIndex) {
    return null;
  }
  if (proposedIndex > upperBound) {
    return null;
  }
  return proposedIndex;
};
var moveToNextIndex$1 = function(_ref) {
  var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable2 = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
  var wasAt = previousImpact.at;
  !wasAt ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot move in direction without previous impact location") : invariant$1() : void 0;
  if (wasAt.type === "REORDER") {
    var _newIndex = fromReorder$1({
      isMovingForward,
      isInHomeList,
      location: wasAt.destination,
      insideDestination
    });
    if (_newIndex == null) {
      return null;
    }
    return calculateReorderImpact({
      draggable: draggable2,
      insideDestination,
      destination,
      viewport,
      last: previousImpact.displaced,
      displacedBy: previousImpact.displacedBy,
      index: _newIndex
    });
  }
  var newIndex = fromCombine$1({
    isMovingForward,
    destination,
    displaced: previousImpact.displaced,
    draggables,
    combine: wasAt.combine,
    afterCritical
  });
  if (newIndex == null) {
    return null;
  }
  return calculateReorderImpact({
    draggable: draggable2,
    insideDestination,
    destination,
    viewport,
    last: previousImpact.displaced,
    displacedBy: previousImpact.displacedBy,
    index: newIndex
  });
};
var getCombinedItemDisplacement$1 = function(_ref) {
  var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
  var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
  if (didStartAfterCritical(combineWith, afterCritical)) {
    return isDisplaced ? origin$1 : negate$1(displacedBy.point);
  }
  return isDisplaced ? displacedBy.point : origin$1;
};
var whenCombining$1 = function(_ref) {
  var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
  var combine2 = tryGetCombine(impact);
  !combine2 ? process.env.NODE_ENV !== "production" ? invariant$1() : invariant$1() : void 0;
  var combineWith = combine2.draggableId;
  var center = draggables[combineWith].page.borderBox.center;
  var displaceBy = getCombinedItemDisplacement$1({
    displaced: impact.displaced,
    afterCritical,
    combineWith,
    displacedBy: impact.displacedBy
  });
  return add$4(center, displaceBy);
};
var distanceFromStartToBorderBoxCenter$1 = function distanceFromStartToBorderBoxCenter(axis, box) {
  return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var distanceFromEndToBorderBoxCenter$1 = function distanceFromEndToBorderBoxCenter(axis, box) {
  return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var getCrossAxisBorderBoxCenter$1 = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
  return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var goAfter$1 = function goAfter(_ref) {
  var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
  return patch$2(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter$1(axis, isMoving), getCrossAxisBorderBoxCenter$1(axis, moveRelativeTo.marginBox, isMoving));
};
var goBefore$1 = function goBefore(_ref2) {
  var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
  return patch$2(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter$1(axis, isMoving), getCrossAxisBorderBoxCenter$1(axis, moveRelativeTo.marginBox, isMoving));
};
var goIntoStart$1 = function goIntoStart(_ref3) {
  var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
  return patch$2(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter$1(axis, isMoving), getCrossAxisBorderBoxCenter$1(axis, moveInto.contentBox, isMoving));
};
var whenReordering$1 = function(_ref) {
  var impact = _ref.impact, draggable2 = _ref.draggable, draggables = _ref.draggables, droppable2 = _ref.droppable, afterCritical = _ref.afterCritical;
  var insideDestination = getDraggablesInsideDroppable$1(droppable2.descriptor.id, draggables);
  var draggablePage = draggable2.page;
  var axis = droppable2.axis;
  if (!insideDestination.length) {
    return goIntoStart$1({
      axis,
      moveInto: droppable2.page,
      isMoving: draggablePage
    });
  }
  var displaced = impact.displaced, displacedBy = impact.displacedBy;
  var closestAfter = displaced.all[0];
  if (closestAfter) {
    var closest4 = draggables[closestAfter];
    if (didStartAfterCritical(closestAfter, afterCritical)) {
      return goBefore$1({
        axis,
        moveRelativeTo: closest4.page,
        isMoving: draggablePage
      });
    }
    var withDisplacement = offset$4(closest4.page, displacedBy.point);
    return goBefore$1({
      axis,
      moveRelativeTo: withDisplacement,
      isMoving: draggablePage
    });
  }
  var last = insideDestination[insideDestination.length - 1];
  if (last.descriptor.id === draggable2.descriptor.id) {
    return draggablePage.borderBox.center;
  }
  if (didStartAfterCritical(last.descriptor.id, afterCritical)) {
    var page = offset$4(last.page, negate$1(afterCritical.displacedBy.point));
    return goAfter$1({
      axis,
      moveRelativeTo: page,
      isMoving: draggablePage
    });
  }
  return goAfter$1({
    axis,
    moveRelativeTo: last.page,
    isMoving: draggablePage
  });
};
var withDroppableDisplacement$1 = function(droppable2, point2) {
  var frame = droppable2.frame;
  if (!frame) {
    return point2;
  }
  return add$4(point2, frame.scroll.diff.displacement);
};
var getResultWithoutDroppableDisplacement$1 = function getResultWithoutDroppableDisplacement(_ref) {
  var impact = _ref.impact, draggable2 = _ref.draggable, droppable2 = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
  var original = draggable2.page.borderBox.center;
  var at = impact.at;
  if (!droppable2) {
    return original;
  }
  if (!at) {
    return original;
  }
  if (at.type === "REORDER") {
    return whenReordering$1({
      impact,
      draggable: draggable2,
      draggables,
      droppable: droppable2,
      afterCritical
    });
  }
  return whenCombining$1({
    impact,
    draggables,
    afterCritical
  });
};
var getPageBorderBoxCenterFromImpact$1 = function(args) {
  var withoutDisplacement = getResultWithoutDroppableDisplacement$1(args);
  var droppable2 = args.droppable;
  var withDisplacement = droppable2 ? withDroppableDisplacement$1(droppable2, withoutDisplacement) : withoutDisplacement;
  return withDisplacement;
};
var scrollViewport$1 = function(viewport, newScroll) {
  var diff2 = subtract$4(newScroll, viewport.scroll.initial);
  var displacement = negate$1(diff2);
  var frame = getRect({
    top: newScroll.y,
    bottom: newScroll.y + viewport.frame.height,
    left: newScroll.x,
    right: newScroll.x + viewport.frame.width
  });
  var updated = {
    frame,
    scroll: {
      initial: viewport.scroll.initial,
      max: viewport.scroll.max,
      current: newScroll,
      diff: {
        value: diff2,
        displacement
      }
    }
  };
  return updated;
};
function getDraggables(ids2, draggables) {
  return ids2.map(function(id) {
    return draggables[id];
  });
}
function tryGetVisible(id, groups) {
  for (var i = 0; i < groups.length; i++) {
    var displacement = groups[i].visible[id];
    if (displacement) {
      return displacement;
    }
  }
  return null;
}
var speculativelyIncrease$1 = function(_ref) {
  var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
  var scrolledViewport = scrollViewport$1(viewport, add$4(viewport.scroll.current, maxScrollChange));
  var scrolledDroppable = destination.frame ? scrollDroppable$1(destination, add$4(destination.frame.scroll.current, maxScrollChange)) : destination;
  var last = impact.displaced;
  var withViewportScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination,
    displacedBy: impact.displacedBy,
    viewport: scrolledViewport.frame,
    last,
    forceShouldAnimate: false
  });
  var withDroppableScroll2 = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: scrolledDroppable,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    last,
    forceShouldAnimate: false
  });
  var invisible = {};
  var visible = {};
  var groups = [last, withViewportScroll, withDroppableScroll2];
  last.all.forEach(function(id) {
    var displacement = tryGetVisible(id, groups);
    if (displacement) {
      visible[id] = displacement;
      return;
    }
    invisible[id] = true;
  });
  var newImpact = _extends$6({}, impact, {
    displaced: {
      all: last.all,
      invisible,
      visible
    }
  });
  return newImpact;
};
var withViewportDisplacement$1 = function(viewport, point2) {
  return add$4(viewport.scroll.diff.displacement, point2);
};
var getClientFromPageBorderBoxCenter$1 = function(_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable2 = _ref.draggable, viewport = _ref.viewport;
  var withoutPageScrollChange = withViewportDisplacement$1(viewport, pageBorderBoxCenter);
  var offset3 = subtract$4(withoutPageScrollChange, draggable2.page.borderBox.center);
  return add$4(draggable2.client.borderBox.center, offset3);
};
var isTotallyVisibleInNewLocation$1 = function(_ref) {
  var draggable2 = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement2 = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
  var changeNeeded = subtract$4(newPageBorderBoxCenter, draggable2.page.borderBox.center);
  var shifted = offsetByPosition$1(draggable2.page.borderBox, changeNeeded);
  var args = {
    target: shifted,
    destination,
    withDroppableDisplacement: withDroppableDisplacement2,
    viewport
  };
  return onlyOnMainAxis ? isTotallyVisibleOnAxis$1(args) : isTotallyVisible$1(args);
};
var moveToNextPlace$1 = function(_ref) {
  var isMovingForward = _ref.isMovingForward, draggable2 = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
  if (!destination.isEnabled) {
    return null;
  }
  var insideDestination = getDraggablesInsideDroppable$1(destination.descriptor.id, draggables);
  var isInHomeList = isHomeOf$1(draggable2, destination);
  var impact = moveToNextCombine$1({
    isMovingForward,
    draggable: draggable2,
    destination,
    insideDestination,
    previousImpact
  }) || moveToNextIndex$1({
    isMovingForward,
    isInHomeList,
    draggable: draggable2,
    draggables,
    destination,
    insideDestination,
    previousImpact,
    viewport,
    afterCritical
  });
  if (!impact) {
    return null;
  }
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact$1({
    impact,
    draggable: draggable2,
    droppable: destination,
    draggables,
    afterCritical
  });
  var isVisibleInNewLocation = isTotallyVisibleInNewLocation$1({
    draggable: draggable2,
    destination,
    newPageBorderBoxCenter: pageBorderBoxCenter,
    viewport: viewport.frame,
    withDroppableDisplacement: false,
    onlyOnMainAxis: true
  });
  if (isVisibleInNewLocation) {
    var clientSelection = getClientFromPageBorderBoxCenter$1({
      pageBorderBoxCenter,
      draggable: draggable2,
      viewport
    });
    return {
      clientSelection,
      impact,
      scrollJumpRequest: null
    };
  }
  var distance4 = subtract$4(pageBorderBoxCenter, previousPageBorderBoxCenter);
  var cautious = speculativelyIncrease$1({
    impact,
    viewport,
    destination,
    draggables,
    maxScrollChange: distance4
  });
  return {
    clientSelection: previousClientSelection,
    impact: cautious,
    scrollJumpRequest: distance4
  };
};
var getKnownActive$1 = function getKnownActive(droppable2) {
  var rect = droppable2.subject.active;
  !rect ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot get clipped area from droppable") : invariant$1() : void 0;
  return rect;
};
var getBestCrossAxisDroppable$1 = function(_ref) {
  var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
  var active = source.subject.active;
  if (!active) {
    return null;
  }
  var axis = source.axis;
  var isBetweenSourceClipped = isWithin$1(active[axis.start], active[axis.end]);
  var candidates = toDroppableList$1(droppables).filter(function(droppable2) {
    return droppable2 !== source;
  }).filter(function(droppable2) {
    return droppable2.isEnabled;
  }).filter(function(droppable2) {
    return Boolean(droppable2.subject.active);
  }).filter(function(droppable2) {
    return isPartiallyVisibleThroughFrame$1(viewport.frame)(getKnownActive$1(droppable2));
  }).filter(function(droppable2) {
    var activeOfTarget = getKnownActive$1(droppable2);
    if (isMovingForward) {
      return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
    }
    return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
  }).filter(function(droppable2) {
    var activeOfTarget = getKnownActive$1(droppable2);
    var isBetweenDestinationClipped = isWithin$1(activeOfTarget[axis.start], activeOfTarget[axis.end]);
    return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
  }).sort(function(a2, b2) {
    var first2 = getKnownActive$1(a2)[axis.crossAxisStart];
    var second = getKnownActive$1(b2)[axis.crossAxisStart];
    if (isMovingForward) {
      return first2 - second;
    }
    return second - first2;
  }).filter(function(droppable2, index2, array) {
    return getKnownActive$1(droppable2)[axis.crossAxisStart] === getKnownActive$1(array[0])[axis.crossAxisStart];
  });
  if (!candidates.length) {
    return null;
  }
  if (candidates.length === 1) {
    return candidates[0];
  }
  var contains = candidates.filter(function(droppable2) {
    var isWithinDroppable = isWithin$1(getKnownActive$1(droppable2)[axis.start], getKnownActive$1(droppable2)[axis.end]);
    return isWithinDroppable(pageBorderBoxCenter[axis.line]);
  });
  if (contains.length === 1) {
    return contains[0];
  }
  if (contains.length > 1) {
    return contains.sort(function(a2, b2) {
      return getKnownActive$1(a2)[axis.start] - getKnownActive$1(b2)[axis.start];
    })[0];
  }
  return candidates.sort(function(a2, b2) {
    var first2 = closest$1(pageBorderBoxCenter, getCorners$1(getKnownActive$1(a2)));
    var second = closest$1(pageBorderBoxCenter, getCorners$1(getKnownActive$1(b2)));
    if (first2 !== second) {
      return first2 - second;
    }
    return getKnownActive$1(a2)[axis.start] - getKnownActive$1(b2)[axis.start];
  })[0];
};
var getCurrentPageBorderBoxCenter$1 = function getCurrentPageBorderBoxCenter(draggable2, afterCritical) {
  var original = draggable2.page.borderBox.center;
  return didStartAfterCritical(draggable2.descriptor.id, afterCritical) ? subtract$4(original, afterCritical.displacedBy.point) : original;
};
var getCurrentPageBorderBox$1 = function getCurrentPageBorderBox(draggable2, afterCritical) {
  var original = draggable2.page.borderBox;
  return didStartAfterCritical(draggable2.descriptor.id, afterCritical) ? offsetByPosition$1(original, negate$1(afterCritical.displacedBy.point)) : original;
};
var getClosestDraggable$1 = function(_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
  var sorted = insideDestination.filter(function(draggable2) {
    return isTotallyVisible$1({
      target: getCurrentPageBorderBox$1(draggable2, afterCritical),
      destination,
      viewport: viewport.frame,
      withDroppableDisplacement: true
    });
  }).sort(function(a2, b2) {
    var distanceToA = distance$1(pageBorderBoxCenter, withDroppableDisplacement$1(destination, getCurrentPageBorderBoxCenter$1(a2, afterCritical)));
    var distanceToB = distance$1(pageBorderBoxCenter, withDroppableDisplacement$1(destination, getCurrentPageBorderBoxCenter$1(b2, afterCritical)));
    if (distanceToA < distanceToB) {
      return -1;
    }
    if (distanceToB < distanceToA) {
      return 1;
    }
    return a2.descriptor.index - b2.descriptor.index;
  });
  return sorted[0] || null;
};
var getDisplacedBy$1 = memoizeOne(function getDisplacedBy(axis, displaceBy) {
  var displacement = displaceBy[axis.line];
  return {
    value: displacement,
    point: patch$2(axis.line, displacement)
  };
});
var getRequiredGrowthForPlaceholder$1 = function getRequiredGrowthForPlaceholder(droppable2, placeholderSize, draggables) {
  var axis = droppable2.axis;
  if (droppable2.descriptor.mode === "virtual") {
    return patch$2(axis.line, placeholderSize[axis.line]);
  }
  var availableSpace = droppable2.subject.page.contentBox[axis.size];
  var insideDroppable = getDraggablesInsideDroppable$1(droppable2.descriptor.id, draggables);
  var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
    return sum + dimension.client.marginBox[axis.size];
  }, 0);
  var requiredSpace = spaceUsed + placeholderSize[axis.line];
  var needsToGrowBy = requiredSpace - availableSpace;
  if (needsToGrowBy <= 0) {
    return null;
  }
  return patch$2(axis.line, needsToGrowBy);
};
var withMaxScroll$1 = function withMaxScroll(frame, max2) {
  return _extends$6({}, frame, {
    scroll: _extends$6({}, frame.scroll, {
      max: max2
    })
  });
};
var addPlaceholder$1 = function addPlaceholder(droppable2, draggable2, draggables) {
  var frame = droppable2.frame;
  !!isHomeOf$1(draggable2, droppable2) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Should not add placeholder space to home list") : invariant$1() : void 0;
  !!droppable2.subject.withPlaceholder ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot add placeholder size to a subject when it already has one") : invariant$1() : void 0;
  var placeholderSize = getDisplacedBy$1(droppable2.axis, draggable2.displaceBy).point;
  var requiredGrowth = getRequiredGrowthForPlaceholder$1(droppable2, placeholderSize, draggables);
  var added = {
    placeholderSize,
    increasedBy: requiredGrowth,
    oldFrameMaxScroll: droppable2.frame ? droppable2.frame.scroll.max : null
  };
  if (!frame) {
    var _subject = getSubject$1({
      page: droppable2.subject.page,
      withPlaceholder: added,
      axis: droppable2.axis,
      frame: droppable2.frame
    });
    return _extends$6({}, droppable2, {
      subject: _subject
    });
  }
  var maxScroll = requiredGrowth ? add$4(frame.scroll.max, requiredGrowth) : frame.scroll.max;
  var newFrame = withMaxScroll$1(frame, maxScroll);
  var subject = getSubject$1({
    page: droppable2.subject.page,
    withPlaceholder: added,
    axis: droppable2.axis,
    frame: newFrame
  });
  return _extends$6({}, droppable2, {
    subject,
    frame: newFrame
  });
};
var removePlaceholder$1 = function removePlaceholder(droppable2) {
  var added = droppable2.subject.withPlaceholder;
  !added ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot remove placeholder form subject when there was none") : invariant$1() : void 0;
  var frame = droppable2.frame;
  if (!frame) {
    var _subject2 = getSubject$1({
      page: droppable2.subject.page,
      axis: droppable2.axis,
      frame: null,
      withPlaceholder: null
    });
    return _extends$6({}, droppable2, {
      subject: _subject2
    });
  }
  var oldMaxScroll = added.oldFrameMaxScroll;
  !oldMaxScroll ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Expected droppable with frame to have old max frame scroll when removing placeholder") : invariant$1() : void 0;
  var newFrame = withMaxScroll$1(frame, oldMaxScroll);
  var subject = getSubject$1({
    page: droppable2.subject.page,
    axis: droppable2.axis,
    frame: newFrame,
    withPlaceholder: null
  });
  return _extends$6({}, droppable2, {
    subject,
    frame: newFrame
  });
};
var moveToNewDroppable$1 = function(_ref) {
  var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable2 = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
  if (!moveRelativeTo) {
    if (insideDestination.length) {
      return null;
    }
    var proposed = {
      displaced: emptyGroups,
      displacedBy: noDisplacedBy$1,
      at: {
        type: "REORDER",
        destination: {
          droppableId: destination.descriptor.id,
          index: 0
        }
      }
    };
    var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact$1({
      impact: proposed,
      draggable: draggable2,
      droppable: destination,
      draggables,
      afterCritical
    });
    var withPlaceholder = isHomeOf$1(draggable2, destination) ? destination : addPlaceholder$1(destination, draggable2, draggables);
    var isVisibleInNewLocation = isTotallyVisibleInNewLocation$1({
      draggable: draggable2,
      destination: withPlaceholder,
      newPageBorderBoxCenter: proposedPageBorderBoxCenter,
      viewport: viewport.frame,
      withDroppableDisplacement: false,
      onlyOnMainAxis: true
    });
    return isVisibleInNewLocation ? proposed : null;
  }
  var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
  var proposedIndex = function() {
    var relativeTo = moveRelativeTo.descriptor.index;
    if (moveRelativeTo.descriptor.id === draggable2.descriptor.id) {
      return relativeTo;
    }
    if (isGoingBeforeTarget) {
      return relativeTo;
    }
    return relativeTo + 1;
  }();
  var displacedBy = getDisplacedBy$1(destination.axis, draggable2.displaceBy);
  return calculateReorderImpact({
    draggable: draggable2,
    insideDestination,
    destination,
    viewport,
    displacedBy,
    last: emptyGroups,
    index: proposedIndex
  });
};
var moveCrossAxis$1 = function(_ref) {
  var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable2 = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
  var destination = getBestCrossAxisDroppable$1({
    isMovingForward,
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    source: isOver,
    droppables,
    viewport
  });
  if (!destination) {
    return null;
  }
  var insideDestination = getDraggablesInsideDroppable$1(destination.descriptor.id, draggables);
  var moveRelativeTo = getClosestDraggable$1({
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    viewport,
    destination,
    insideDestination,
    afterCritical
  });
  var impact = moveToNewDroppable$1({
    previousPageBorderBoxCenter,
    destination,
    draggable: draggable2,
    draggables,
    moveRelativeTo,
    insideDestination,
    viewport,
    afterCritical
  });
  if (!impact) {
    return null;
  }
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact$1({
    impact,
    draggable: draggable2,
    droppable: destination,
    draggables,
    afterCritical
  });
  var clientSelection = getClientFromPageBorderBoxCenter$1({
    pageBorderBoxCenter,
    draggable: draggable2,
    viewport
  });
  return {
    clientSelection,
    impact,
    scrollJumpRequest: null
  };
};
var whatIsDraggedOver$1 = function(impact) {
  var at = impact.at;
  if (!at) {
    return null;
  }
  if (at.type === "REORDER") {
    return at.destination.droppableId;
  }
  return at.combine.droppableId;
};
var getDroppableOver$2 = function getDroppableOver(impact, droppables) {
  var id = whatIsDraggedOver$1(impact);
  return id ? droppables[id] : null;
};
var moveInDirection$1 = function(_ref) {
  var state = _ref.state, type = _ref.type;
  var isActuallyOver = getDroppableOver$2(state.impact, state.dimensions.droppables);
  var isMainAxisMovementAllowed = Boolean(isActuallyOver);
  var home2 = state.dimensions.droppables[state.critical.droppable.id];
  var isOver = isActuallyOver || home2;
  var direction = isOver.axis.direction;
  var isMovingOnMainAxis = direction === "vertical" && (type === "MOVE_UP" || type === "MOVE_DOWN") || direction === "horizontal" && (type === "MOVE_LEFT" || type === "MOVE_RIGHT");
  if (isMovingOnMainAxis && !isMainAxisMovementAllowed) {
    return null;
  }
  var isMovingForward = type === "MOVE_DOWN" || type === "MOVE_RIGHT";
  var draggable2 = state.dimensions.draggables[state.critical.draggable.id];
  var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
  var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
  return isMovingOnMainAxis ? moveToNextPlace$1({
    isMovingForward,
    previousPageBorderBoxCenter,
    draggable: draggable2,
    destination: isOver,
    draggables,
    viewport: state.viewport,
    previousClientSelection: state.current.client.selection,
    previousImpact: state.impact,
    afterCritical: state.afterCritical
  }) : moveCrossAxis$1({
    isMovingForward,
    previousPageBorderBoxCenter,
    draggable: draggable2,
    isOver,
    draggables,
    droppables,
    viewport: state.viewport,
    afterCritical: state.afterCritical
  });
};
function isMovementAllowed$1(state) {
  return state.phase === "DRAGGING" || state.phase === "COLLECTING";
}
function isPositionInFrame$1(frame) {
  var isWithinVertical = isWithin$1(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin$1(frame.left, frame.right);
  return function run2(point2) {
    return isWithinVertical(point2.y) && isWithinHorizontal(point2.x);
  };
}
function getHasOverlap(first2, second) {
  return first2.left < second.right && first2.right > second.left && first2.top < second.bottom && first2.bottom > second.top;
}
function getFurthestAway(_ref) {
  var pageBorderBox = _ref.pageBorderBox, draggable2 = _ref.draggable, candidates = _ref.candidates;
  var startCenter = draggable2.page.borderBox.center;
  var sorted = candidates.map(function(candidate) {
    var axis = candidate.axis;
    var target = patch$2(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
    return {
      id: candidate.descriptor.id,
      distance: distance$1(startCenter, target)
    };
  }).sort(function(a2, b2) {
    return b2.distance - a2.distance;
  });
  return sorted[0] ? sorted[0].id : null;
}
function getDroppableOver$1$1(_ref2) {
  var pageBorderBox = _ref2.pageBorderBox, draggable2 = _ref2.draggable, droppables = _ref2.droppables;
  var candidates = toDroppableList$1(droppables).filter(function(item) {
    if (!item.isEnabled) {
      return false;
    }
    var active = item.subject.active;
    if (!active) {
      return false;
    }
    if (!getHasOverlap(pageBorderBox, active)) {
      return false;
    }
    if (isPositionInFrame$1(active)(pageBorderBox.center)) {
      return true;
    }
    var axis = item.axis;
    var childCenter = active.center[axis.crossAxisLine];
    var crossAxisStart = pageBorderBox[axis.crossAxisStart];
    var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
    var isContained = isWithin$1(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
    var isStartContained = isContained(crossAxisStart);
    var isEndContained = isContained(crossAxisEnd);
    if (!isStartContained && !isEndContained) {
      return true;
    }
    if (isStartContained) {
      return crossAxisStart < childCenter;
    }
    return crossAxisEnd > childCenter;
  });
  if (!candidates.length) {
    return null;
  }
  if (candidates.length === 1) {
    return candidates[0].descriptor.id;
  }
  return getFurthestAway({
    pageBorderBox,
    draggable: draggable2,
    candidates
  });
}
var offsetRectByPosition = function offsetRectByPosition2(rect, point2) {
  return getRect(offsetByPosition$1(rect, point2));
};
var withDroppableScroll$1 = function(droppable2, area) {
  var frame = droppable2.frame;
  if (!frame) {
    return area;
  }
  return offsetRectByPosition(area, frame.scroll.diff.value);
};
function getIsDisplaced(_ref) {
  var displaced = _ref.displaced, id = _ref.id;
  return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function atIndex(_ref) {
  var draggable2 = _ref.draggable, closest4 = _ref.closest, inHomeList = _ref.inHomeList;
  if (!closest4) {
    return null;
  }
  if (!inHomeList) {
    return closest4.descriptor.index;
  }
  if (closest4.descriptor.index > draggable2.descriptor.index) {
    return closest4.descriptor.index - 1;
  }
  return closest4.descriptor.index;
}
var getReorderImpact$1 = function(_ref2) {
  var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable2 = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
  var axis = destination.axis;
  var displacedBy = getDisplacedBy$1(destination.axis, draggable2.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList$1(draggable2, insideDestination);
  var closest4 = find$3(withoutDragging, function(child) {
    var id = child.descriptor.id;
    var childCenter = child.page.borderBox.center[axis.line];
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: last,
      id
    });
    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd <= childCenter;
      }
      return targetStart < childCenter - displacement;
    }
    if (isDisplaced) {
      return targetEnd <= childCenter + displacement;
    }
    return targetStart < childCenter;
  });
  var newIndex = atIndex({
    draggable: draggable2,
    closest: closest4,
    inHomeList: isHomeOf$1(draggable2, destination)
  });
  return calculateReorderImpact({
    draggable: draggable2,
    insideDestination,
    destination,
    viewport,
    last,
    displacedBy,
    index: newIndex
  });
};
var combineThresholdDivisor = 4;
var getCombineImpact$1 = function(_ref) {
  var draggable2 = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
  if (!destination.isCombineEnabled) {
    return null;
  }
  var axis = destination.axis;
  var displacedBy = getDisplacedBy$1(destination.axis, draggable2.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList$1(draggable2, insideDestination);
  var combineWith = find$3(withoutDragging, function(child) {
    var id = child.descriptor.id;
    var childRect = child.page.borderBox;
    var childSize = childRect[axis.size];
    var threshold = childSize / combineThresholdDivisor;
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: previousImpact.displaced,
      id
    });
    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
      }
      return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
    }
    if (isDisplaced) {
      return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
    }
    return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
  });
  if (!combineWith) {
    return null;
  }
  var impact = {
    displacedBy,
    displaced: previousImpact.displaced,
    at: {
      type: "COMBINE",
      combine: {
        draggableId: combineWith.descriptor.id,
        droppableId: destination.descriptor.id
      }
    }
  };
  return impact;
};
var getDragImpact$1 = function(_ref) {
  var pageOffset = _ref.pageOffset, draggable2 = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
  var pageBorderBox = offsetRectByPosition(draggable2.page.borderBox, pageOffset);
  var destinationId = getDroppableOver$1$1({
    pageBorderBox,
    draggable: draggable2,
    droppables
  });
  if (!destinationId) {
    return noImpact$1;
  }
  var destination = droppables[destinationId];
  var insideDestination = getDraggablesInsideDroppable$1(destination.descriptor.id, draggables);
  var pageBorderBoxWithDroppableScroll = withDroppableScroll$1(destination, pageBorderBox);
  return getCombineImpact$1({
    pageBorderBoxWithDroppableScroll,
    draggable: draggable2,
    previousImpact,
    destination,
    insideDestination,
    afterCritical
  }) || getReorderImpact$1({
    pageBorderBoxWithDroppableScroll,
    draggable: draggable2,
    destination,
    insideDestination,
    last: previousImpact.displaced,
    viewport,
    afterCritical
  });
};
var patchDroppableMap$1 = function(droppables, updated) {
  var _extends2;
  return _extends$6({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var clearUnusedPlaceholder$1 = function clearUnusedPlaceholder(_ref) {
  var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
  var last = whatIsDraggedOver$1(previousImpact);
  var now2 = whatIsDraggedOver$1(impact);
  if (!last) {
    return droppables;
  }
  if (last === now2) {
    return droppables;
  }
  var lastDroppable = droppables[last];
  if (!lastDroppable.subject.withPlaceholder) {
    return droppables;
  }
  var updated = removePlaceholder$1(lastDroppable);
  return patchDroppableMap$1(droppables, updated);
};
var recomputePlaceholders$1 = function(_ref2) {
  var draggable2 = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
  var cleaned = clearUnusedPlaceholder$1({
    previousImpact,
    impact,
    droppables
  });
  var isOver = whatIsDraggedOver$1(impact);
  if (!isOver) {
    return cleaned;
  }
  var droppable2 = droppables[isOver];
  if (isHomeOf$1(draggable2, droppable2)) {
    return cleaned;
  }
  if (droppable2.subject.withPlaceholder) {
    return cleaned;
  }
  var patched = addPlaceholder$1(droppable2, draggable2, draggables);
  return patchDroppableMap$1(cleaned, patched);
};
var update$1 = function(_ref) {
  var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var clientSelection = forcedClientSelection || state.current.client.selection;
  var offset3 = subtract$4(clientSelection, state.initial.client.selection);
  var client2 = {
    offset: offset3,
    selection: clientSelection,
    borderBoxCenter: add$4(state.initial.client.borderBoxCenter, offset3)
  };
  var page = {
    selection: add$4(client2.selection, viewport.scroll.current),
    borderBoxCenter: add$4(client2.borderBoxCenter, viewport.scroll.current),
    offset: add$4(client2.offset, viewport.scroll.diff.value)
  };
  var current = {
    client: client2,
    page
  };
  if (state.phase === "COLLECTING") {
    return _extends$6({
      phase: "COLLECTING"
    }, state, {
      dimensions,
      viewport,
      current
    });
  }
  var draggable2 = dimensions.draggables[state.critical.draggable.id];
  var newImpact = forcedImpact || getDragImpact$1({
    pageOffset: page.offset,
    draggable: draggable2,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: state.impact,
    viewport,
    afterCritical: state.afterCritical
  });
  var withUpdatedPlaceholders = recomputePlaceholders$1({
    draggable: draggable2,
    impact: newImpact,
    previousImpact: state.impact,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables
  });
  var result = _extends$6({}, state, {
    current,
    dimensions: {
      draggables: dimensions.draggables,
      droppables: withUpdatedPlaceholders
    },
    impact: newImpact,
    viewport,
    scrollJumpRequest: scrollJumpRequest || null,
    forceShouldAnimate: scrollJumpRequest ? false : null
  });
  return result;
};
function getDraggables$1(ids2, draggables) {
  return ids2.map(function(id) {
    return draggables[id];
  });
}
var recompute$1 = function(_ref) {
  var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
  var last = impact.displaced;
  var afterDragging = getDraggables$1(last.all, draggables);
  var displaced = getDisplacementGroups({
    afterDragging,
    destination,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    forceShouldAnimate,
    last
  });
  return _extends$6({}, impact, {
    displaced
  });
};
var getClientBorderBoxCenter$1 = function(_ref) {
  var impact = _ref.impact, draggable2 = _ref.draggable, droppable2 = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact$1({
    impact,
    draggable: draggable2,
    draggables,
    droppable: droppable2,
    afterCritical
  });
  return getClientFromPageBorderBoxCenter$1({
    pageBorderBoxCenter,
    draggable: draggable2,
    viewport
  });
};
var refreshSnap$1 = function(_ref) {
  var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
  !(state.movementMode === "SNAP") ? process.env.NODE_ENV !== "production" ? invariant$1() : invariant$1() : void 0;
  var needsVisibilityCheck = state.impact;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var draggables = dimensions.draggables, droppables = dimensions.droppables;
  var draggable2 = draggables[state.critical.draggable.id];
  var isOver = whatIsDraggedOver$1(needsVisibilityCheck);
  !isOver ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Must be over a destination in SNAP movement mode") : invariant$1() : void 0;
  var destination = droppables[isOver];
  var impact = recompute$1({
    impact: needsVisibilityCheck,
    viewport,
    destination,
    draggables
  });
  var clientSelection = getClientBorderBoxCenter$1({
    impact,
    draggable: draggable2,
    droppable: destination,
    draggables,
    viewport,
    afterCritical: state.afterCritical
  });
  return update$1({
    impact,
    clientSelection,
    state,
    dimensions,
    viewport
  });
};
var getHomeLocation$1 = function(descriptor) {
  return {
    index: descriptor.index,
    droppableId: descriptor.droppableId
  };
};
var getLiftEffect = function(_ref) {
  var draggable2 = _ref.draggable, home2 = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
  var displacedBy = getDisplacedBy$1(home2.axis, draggable2.displaceBy);
  var insideHome = getDraggablesInsideDroppable$1(home2.descriptor.id, draggables);
  var rawIndex = insideHome.indexOf(draggable2);
  !(rawIndex !== -1) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Expected draggable to be inside home list") : invariant$1() : void 0;
  var afterDragging = insideHome.slice(rawIndex + 1);
  var effected = afterDragging.reduce(function(previous2, item) {
    previous2[item.descriptor.id] = true;
    return previous2;
  }, {});
  var afterCritical = {
    inVirtualList: home2.descriptor.mode === "virtual",
    displacedBy,
    effected
  };
  var displaced = getDisplacementGroups({
    afterDragging,
    destination: home2,
    displacedBy,
    last: null,
    viewport: viewport.frame,
    forceShouldAnimate: false
  });
  var impact = {
    displaced,
    displacedBy,
    at: {
      type: "REORDER",
      destination: getHomeLocation$1(draggable2.descriptor)
    }
  };
  return {
    impact,
    afterCritical
  };
};
var patchDimensionMap$1 = function(dimensions, updated) {
  return {
    draggables: dimensions.draggables,
    droppables: patchDroppableMap$1(dimensions.droppables, updated)
  };
};
var start$1 = function start(key2) {
  if (process.env.NODE_ENV !== "production") {
    {
      return;
    }
  }
};
var finish$1 = function finish(key2) {
  if (process.env.NODE_ENV !== "production") {
    {
      return;
    }
  }
};
var offsetDraggable$1 = function(_ref) {
  var draggable2 = _ref.draggable, offset$12 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
  var client2 = offset$4(draggable2.client, offset$12);
  var page = withScroll(client2, initialWindowScroll);
  var moved = _extends$6({}, draggable2, {
    placeholder: _extends$6({}, draggable2.placeholder, {
      client: client2
    }),
    client: client2,
    page
  });
  return moved;
};
var getFrame$1 = function(droppable2) {
  var frame = droppable2.frame;
  !frame ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Expected Droppable to have a frame") : invariant$1() : void 0;
  return frame;
};
var adjustAdditionsForScrollChanges$1 = function(_ref) {
  var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
  var windowScrollChange = viewport.scroll.diff.value;
  return additions.map(function(draggable2) {
    var droppableId = draggable2.descriptor.droppableId;
    var modified = updatedDroppables[droppableId];
    var frame = getFrame$1(modified);
    var droppableScrollChange = frame.scroll.diff.value;
    var totalChange = add$4(windowScrollChange, droppableScrollChange);
    var moved = offsetDraggable$1({
      draggable: draggable2,
      offset: totalChange,
      initialWindowScroll: viewport.scroll.initial
    });
    return moved;
  });
};
var publishWhileDraggingInVirtual = function(_ref) {
  var state = _ref.state, published = _ref.published;
  start$1();
  var withScrollChange = published.modified.map(function(update2) {
    var existing = state.dimensions.droppables[update2.droppableId];
    var scrolled = scrollDroppable$1(existing, update2.scroll);
    return scrolled;
  });
  var droppables = _extends$6({}, state.dimensions.droppables, {}, toDroppableMap$1(withScrollChange));
  var updatedAdditions = toDraggableMap$1(adjustAdditionsForScrollChanges$1({
    additions: published.additions,
    updatedDroppables: droppables,
    viewport: state.viewport
  }));
  var draggables = _extends$6({}, state.dimensions.draggables, {}, updatedAdditions);
  published.removals.forEach(function(id) {
    delete draggables[id];
  });
  var dimensions = {
    droppables,
    draggables
  };
  var wasOverId = whatIsDraggedOver$1(state.impact);
  var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
  var draggable2 = dimensions.draggables[state.critical.draggable.id];
  var home2 = dimensions.droppables[state.critical.droppable.id];
  var _getLiftEffect = getLiftEffect({
    draggable: draggable2,
    home: home2,
    draggables,
    viewport: state.viewport
  }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
  var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
  var impact = getDragImpact$1({
    pageOffset: state.current.page.offset,
    draggable: dimensions.draggables[state.critical.draggable.id],
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact,
    viewport: state.viewport,
    afterCritical
  });
  finish$1();
  var draggingState = _extends$6({
    phase: "DRAGGING"
  }, state, {
    phase: "DRAGGING",
    impact,
    onLiftImpact,
    dimensions,
    afterCritical,
    forceShouldAnimate: false
  });
  if (state.phase === "COLLECTING") {
    return draggingState;
  }
  var dropPending4 = _extends$6({
    phase: "DROP_PENDING"
  }, draggingState, {
    phase: "DROP_PENDING",
    reason: state.reason,
    isWaiting: false
  });
  return dropPending4;
};
var isSnapping$1 = function isSnapping(state) {
  return state.movementMode === "SNAP";
};
var postDroppableChange$1 = function postDroppableChange(state, updated, isEnabledChanging) {
  var dimensions = patchDimensionMap$1(state.dimensions, updated);
  if (!isSnapping$1(state) || isEnabledChanging) {
    return update$1({
      state,
      dimensions
    });
  }
  return refreshSnap$1({
    state,
    dimensions
  });
};
function removeScrollJumpRequest(state) {
  if (state.isDragging && state.movementMode === "SNAP") {
    return _extends$6({
      phase: "DRAGGING"
    }, state, {
      scrollJumpRequest: null
    });
  }
  return state;
}
var idle$1 = {
  phase: "IDLE",
  completed: null,
  shouldFlush: false
};
var reducer$5 = function(state, action) {
  if (state === void 0) {
    state = idle$1;
  }
  if (action.type === "FLUSH") {
    return _extends$6({}, idle$1, {
      shouldFlush: true
    });
  }
  if (action.type === "INITIAL_PUBLISH") {
    !(state.phase === "IDLE") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "INITIAL_PUBLISH must come after a IDLE phase") : invariant$1() : void 0;
    var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
    var draggable2 = dimensions.draggables[critical.draggable.id];
    var home2 = dimensions.droppables[critical.droppable.id];
    var client2 = {
      selection: clientSelection,
      borderBoxCenter: draggable2.client.borderBox.center,
      offset: origin$1
    };
    var initial = {
      client: client2,
      page: {
        selection: add$4(client2.selection, viewport.scroll.initial),
        borderBoxCenter: add$4(client2.selection, viewport.scroll.initial),
        offset: add$4(client2.selection, viewport.scroll.diff.value)
      }
    };
    var isWindowScrollAllowed = toDroppableList$1(dimensions.droppables).every(function(item) {
      return !item.isFixedOnPage;
    });
    var _getLiftEffect = getLiftEffect({
      draggable: draggable2,
      home: home2,
      draggables: dimensions.draggables,
      viewport
    }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var result = {
      phase: "DRAGGING",
      isDragging: true,
      critical,
      movementMode,
      dimensions,
      initial,
      current: initial,
      isWindowScrollAllowed,
      impact,
      afterCritical,
      onLiftImpact: impact,
      viewport,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return result;
  }
  if (action.type === "COLLECTION_STARTING") {
    if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") {
      return state;
    }
    !(state.phase === "DRAGGING") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Collection cannot start from phase " + state.phase) : invariant$1() : void 0;
    var _result = _extends$6({
      phase: "COLLECTING"
    }, state, {
      phase: "COLLECTING"
    });
    return _result;
  }
  if (action.type === "PUBLISH_WHILE_DRAGGING") {
    !(state.phase === "COLLECTING" || state.phase === "DROP_PENDING") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Unexpected " + action.type + " received in phase " + state.phase) : invariant$1() : void 0;
    return publishWhileDraggingInVirtual({
      state,
      published: action.payload
    });
  }
  if (action.type === "MOVE") {
    if (state.phase === "DROP_PENDING") {
      return state;
    }
    !isMovementAllowed$1(state) ? process.env.NODE_ENV !== "production" ? invariant$1(false, action.type + " not permitted in phase " + state.phase) : invariant$1() : void 0;
    var _clientSelection = action.payload.client;
    if (isEqual$5(_clientSelection, state.current.client.selection)) {
      return state;
    }
    return update$1({
      state,
      clientSelection: _clientSelection,
      impact: isSnapping$1(state) ? state.impact : null
    });
  }
  if (action.type === "UPDATE_DROPPABLE_SCROLL") {
    if (state.phase === "DROP_PENDING") {
      return removeScrollJumpRequest(state);
    }
    if (state.phase === "COLLECTING") {
      return removeScrollJumpRequest(state);
    }
    !isMovementAllowed$1(state) ? process.env.NODE_ENV !== "production" ? invariant$1(false, action.type + " not permitted in phase " + state.phase) : invariant$1() : void 0;
    var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
    var target = state.dimensions.droppables[id];
    if (!target) {
      return state;
    }
    var scrolled = scrollDroppable$1(target, newScroll);
    return postDroppableChange$1(state, scrolled, false);
  }
  if (action.type === "UPDATE_DROPPABLE_IS_ENABLED") {
    if (state.phase === "DROP_PENDING") {
      return state;
    }
    !isMovementAllowed$1(state) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Attempting to move in an unsupported phase " + state.phase) : invariant$1() : void 0;
    var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
    var _target = state.dimensions.droppables[_id];
    !_target ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot find Droppable[id: " + _id + "] to toggle its enabled state") : invariant$1() : void 0;
    !(_target.isEnabled !== isEnabled) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Trying to set droppable isEnabled to " + String(isEnabled) + "\n      but it is already " + String(_target.isEnabled)) : invariant$1() : void 0;
    var updated = _extends$6({}, _target, {
      isEnabled
    });
    return postDroppableChange$1(state, updated, true);
  }
  if (action.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
    if (state.phase === "DROP_PENDING") {
      return state;
    }
    !isMovementAllowed$1(state) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Attempting to move in an unsupported phase " + state.phase) : invariant$1() : void 0;
    var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
    var _target2 = state.dimensions.droppables[_id2];
    !_target2 ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot find Droppable[id: " + _id2 + "] to toggle its isCombineEnabled state") : invariant$1() : void 0;
    !(_target2.isCombineEnabled !== isCombineEnabled) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Trying to set droppable isCombineEnabled to " + String(isCombineEnabled) + "\n      but it is already " + String(_target2.isCombineEnabled)) : invariant$1() : void 0;
    var _updated = _extends$6({}, _target2, {
      isCombineEnabled
    });
    return postDroppableChange$1(state, _updated, true);
  }
  if (action.type === "MOVE_BY_WINDOW_SCROLL") {
    if (state.phase === "DROP_PENDING" || state.phase === "DROP_ANIMATING") {
      return state;
    }
    !isMovementAllowed$1(state) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot move by window in phase " + state.phase) : invariant$1() : void 0;
    !state.isWindowScrollAllowed ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Window scrolling is currently not supported for fixed lists") : invariant$1() : void 0;
    var _newScroll = action.payload.newScroll;
    if (isEqual$5(state.viewport.scroll.current, _newScroll)) {
      return removeScrollJumpRequest(state);
    }
    var _viewport = scrollViewport$1(state.viewport, _newScroll);
    if (isSnapping$1(state)) {
      return refreshSnap$1({
        state,
        viewport: _viewport
      });
    }
    return update$1({
      state,
      viewport: _viewport
    });
  }
  if (action.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
    if (!isMovementAllowed$1(state)) {
      return state;
    }
    var maxScroll = action.payload.maxScroll;
    if (isEqual$5(maxScroll, state.viewport.scroll.max)) {
      return state;
    }
    var withMaxScroll4 = _extends$6({}, state.viewport, {
      scroll: _extends$6({}, state.viewport.scroll, {
        max: maxScroll
      })
    });
    return _extends$6({
      phase: "DRAGGING"
    }, state, {
      viewport: withMaxScroll4
    });
  }
  if (action.type === "MOVE_UP" || action.type === "MOVE_DOWN" || action.type === "MOVE_LEFT" || action.type === "MOVE_RIGHT") {
    if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") {
      return state;
    }
    !(state.phase === "DRAGGING") ? process.env.NODE_ENV !== "production" ? invariant$1(false, action.type + " received while not in DRAGGING phase") : invariant$1() : void 0;
    var _result2 = moveInDirection$1({
      state,
      type: action.type
    });
    if (!_result2) {
      return state;
    }
    return update$1({
      state,
      impact: _result2.impact,
      clientSelection: _result2.clientSelection,
      scrollJumpRequest: _result2.scrollJumpRequest
    });
  }
  if (action.type === "DROP_PENDING") {
    var reason = action.payload.reason;
    !(state.phase === "COLLECTING") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Can only move into the DROP_PENDING phase from the COLLECTING phase") : invariant$1() : void 0;
    var newState = _extends$6({
      phase: "DROP_PENDING"
    }, state, {
      phase: "DROP_PENDING",
      isWaiting: true,
      reason
    });
    return newState;
  }
  if (action.type === "DROP_ANIMATE") {
    var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
    !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot animate drop from phase " + state.phase) : invariant$1() : void 0;
    var _result3 = {
      phase: "DROP_ANIMATING",
      completed,
      dropDuration,
      newHomeClientOffset,
      dimensions: state.dimensions
    };
    return _result3;
  }
  if (action.type === "DROP_COMPLETE") {
    var _completed = action.payload.completed;
    return {
      phase: "IDLE",
      completed: _completed,
      shouldFlush: false
    };
  }
  return state;
};
var beforeInitialCapture = function beforeInitialCapture2(args) {
  return {
    type: "BEFORE_INITIAL_CAPTURE",
    payload: args
  };
};
var lift$4 = function lift(args) {
  return {
    type: "LIFT",
    payload: args
  };
};
var initialPublish$1 = function initialPublish(args) {
  return {
    type: "INITIAL_PUBLISH",
    payload: args
  };
};
var publishWhileDragging$2 = function publishWhileDragging(args) {
  return {
    type: "PUBLISH_WHILE_DRAGGING",
    payload: args
  };
};
var collectionStarting$1 = function collectionStarting() {
  return {
    type: "COLLECTION_STARTING",
    payload: null
  };
};
var updateDroppableScroll$1 = function updateDroppableScroll(args) {
  return {
    type: "UPDATE_DROPPABLE_SCROLL",
    payload: args
  };
};
var updateDroppableIsEnabled$1 = function updateDroppableIsEnabled(args) {
  return {
    type: "UPDATE_DROPPABLE_IS_ENABLED",
    payload: args
  };
};
var updateDroppableIsCombineEnabled$1 = function updateDroppableIsCombineEnabled(args) {
  return {
    type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
    payload: args
  };
};
var move$1 = function move(args) {
  return {
    type: "MOVE",
    payload: args
  };
};
var moveByWindowScroll$1 = function moveByWindowScroll(args) {
  return {
    type: "MOVE_BY_WINDOW_SCROLL",
    payload: args
  };
};
var updateViewportMaxScroll$1 = function updateViewportMaxScroll(args) {
  return {
    type: "UPDATE_VIEWPORT_MAX_SCROLL",
    payload: args
  };
};
var moveUp$1 = function moveUp() {
  return {
    type: "MOVE_UP",
    payload: null
  };
};
var moveDown$1 = function moveDown() {
  return {
    type: "MOVE_DOWN",
    payload: null
  };
};
var moveRight$1 = function moveRight() {
  return {
    type: "MOVE_RIGHT",
    payload: null
  };
};
var moveLeft$1 = function moveLeft() {
  return {
    type: "MOVE_LEFT",
    payload: null
  };
};
var flush = function flush2() {
  return {
    type: "FLUSH",
    payload: null
  };
};
var animateDrop$1 = function animateDrop(args) {
  return {
    type: "DROP_ANIMATE",
    payload: args
  };
};
var completeDrop$1 = function completeDrop(args) {
  return {
    type: "DROP_COMPLETE",
    payload: args
  };
};
var drop$2 = function drop(args) {
  return {
    type: "DROP",
    payload: args
  };
};
var dropPending$1 = function dropPending(args) {
  return {
    type: "DROP_PENDING",
    payload: args
  };
};
var dropAnimationFinished$1 = function dropAnimationFinished() {
  return {
    type: "DROP_ANIMATION_FINISHED",
    payload: null
  };
};
function checkIndexes(insideDestination) {
  if (insideDestination.length <= 1) {
    return;
  }
  var indexes = insideDestination.map(function(d2) {
    return d2.descriptor.index;
  });
  var errors = {};
  for (var i = 1; i < indexes.length; i++) {
    var current = indexes[i];
    var previous2 = indexes[i - 1];
    if (current !== previous2 + 1) {
      errors[current] = true;
    }
  }
  if (!Object.keys(errors).length) {
    return;
  }
  var formatted = indexes.map(function(index2) {
    var hasError = Boolean(errors[index2]);
    return hasError ? "[🔥" + index2 + "]" : "" + index2;
  }).join(", ");
  process.env.NODE_ENV !== "production" ? warning$2("\n    Detected non-consecutive <Draggable /> indexes.\n\n    (This can cause unexpected bugs)\n\n    " + formatted + "\n  ") : void 0;
}
function validateDimensions(critical, dimensions) {
  if (process.env.NODE_ENV !== "production") {
    var insideDestination = getDraggablesInsideDroppable$1(critical.droppable.id, dimensions.draggables);
    checkIndexes(insideDestination);
  }
}
var lift$1$2 = function(marshal) {
  return function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next2) {
      return function(action) {
        if (action.type !== "LIFT") {
          next2(action);
          return;
        }
        var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
        var initial = getState();
        if (initial.phase === "DROP_ANIMATING") {
          dispatch(completeDrop$1({
            completed: initial.completed
          }));
        }
        !(getState().phase === "IDLE") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Unexpected phase to start a drag") : invariant$1() : void 0;
        dispatch(flush());
        dispatch(beforeInitialCapture({
          draggableId: id,
          movementMode
        }));
        var scrollOptions = {
          shouldPublishImmediately: movementMode === "SNAP"
        };
        var request = {
          draggableId: id,
          scrollOptions
        };
        var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
        validateDimensions(critical, dimensions);
        dispatch(initialPublish$1({
          critical,
          dimensions,
          clientSelection,
          movementMode,
          viewport
        }));
      };
    };
  };
};
var style$4 = function(marshal) {
  return function() {
    return function(next2) {
      return function(action) {
        if (action.type === "INITIAL_PUBLISH") {
          marshal.dragging();
        }
        if (action.type === "DROP_ANIMATE") {
          marshal.dropping(action.payload.completed.result.reason);
        }
        if (action.type === "FLUSH" || action.type === "DROP_COMPLETE") {
          marshal.resting();
        }
        next2(action);
      };
    };
  };
};
var curves$1 = {
  outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
  drop: "cubic-bezier(.2,1,.1,1)"
};
var combine$2 = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
};
var timings$1 = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
};
var outOfTheWayTiming$1 = timings$1.outOfTheWay + "s " + curves$1.outOfTheWay;
var transitions$1 = {
  fluid: "opacity " + outOfTheWayTiming$1,
  snap: "transform " + outOfTheWayTiming$1 + ", opacity " + outOfTheWayTiming$1,
  drop: function drop2(duration) {
    var timing = duration + "s " + curves$1.drop;
    return "transform " + timing + ", opacity " + timing;
  },
  outOfTheWay: "transform " + outOfTheWayTiming$1,
  placeholder: "height " + outOfTheWayTiming$1 + ", width " + outOfTheWayTiming$1 + ", margin " + outOfTheWayTiming$1
};
var moveTo$1 = function moveTo(offset3) {
  return isEqual$5(offset3, origin$1) ? null : "translate(" + offset3.x + "px, " + offset3.y + "px)";
};
var transforms$2 = {
  moveTo: moveTo$1,
  drop: function drop3(offset3, isCombining) {
    var translate = moveTo$1(offset3);
    if (!translate) {
      return null;
    }
    if (!isCombining) {
      return translate;
    }
    return translate + " scale(" + combine$2.scale.drop + ")";
  }
};
var minDropTime$1 = timings$1.minDropTime, maxDropTime$1 = timings$1.maxDropTime;
var dropTimeRange$1 = maxDropTime$1 - minDropTime$1;
var maxDropTimeAtDistance$1 = 1500;
var cancelDropModifier$1 = 0.6;
var getDropDuration$1 = function(_ref) {
  var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
  var distance$1$1 = distance$1(current, destination);
  if (distance$1$1 <= 0) {
    return minDropTime$1;
  }
  if (distance$1$1 >= maxDropTimeAtDistance$1) {
    return maxDropTime$1;
  }
  var percentage = distance$1$1 / maxDropTimeAtDistance$1;
  var duration = minDropTime$1 + dropTimeRange$1 * percentage;
  var withDuration = reason === "CANCEL" ? duration * cancelDropModifier$1 : duration;
  return Number(withDuration.toFixed(2));
};
var getNewHomeClientOffset$1 = function(_ref) {
  var impact = _ref.impact, draggable2 = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
  var draggables = dimensions.draggables, droppables = dimensions.droppables;
  var droppableId = whatIsDraggedOver$1(impact);
  var destination = droppableId ? droppables[droppableId] : null;
  var home2 = droppables[draggable2.descriptor.droppableId];
  var newClientCenter = getClientBorderBoxCenter$1({
    impact,
    draggable: draggable2,
    draggables,
    afterCritical,
    droppable: destination || home2,
    viewport
  });
  var offset3 = subtract$4(newClientCenter, draggable2.client.borderBox.center);
  return offset3;
};
var getDropImpact$1 = function(_ref) {
  var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home2 = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
  if (!lastImpact.at || reason !== "DROP") {
    var recomputedHomeImpact = recompute$1({
      draggables,
      impact: onLiftImpact,
      destination: home2,
      viewport,
      forceShouldAnimate: true
    });
    return {
      impact: recomputedHomeImpact,
      didDropInsideDroppable: false
    };
  }
  if (lastImpact.at.type === "REORDER") {
    return {
      impact: lastImpact,
      didDropInsideDroppable: true
    };
  }
  var withoutMovement = _extends$6({}, lastImpact, {
    displaced: emptyGroups
  });
  return {
    impact: withoutMovement,
    didDropInsideDroppable: true
  };
};
var drop$1$1 = function(_ref) {
  var getState = _ref.getState, dispatch = _ref.dispatch;
  return function(next2) {
    return function(action) {
      if (action.type !== "DROP") {
        next2(action);
        return;
      }
      var state = getState();
      var reason = action.payload.reason;
      if (state.phase === "COLLECTING") {
        dispatch(dropPending$1({
          reason
        }));
        return;
      }
      if (state.phase === "IDLE") {
        return;
      }
      var isWaitingForDrop = state.phase === "DROP_PENDING" && state.isWaiting;
      !!isWaitingForDrop ? process.env.NODE_ENV !== "production" ? invariant$1(false, "A DROP action occurred while DROP_PENDING and still waiting") : invariant$1() : void 0;
      !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot drop in phase: " + state.phase) : invariant$1() : void 0;
      var critical = state.critical;
      var dimensions = state.dimensions;
      var draggable2 = dimensions.draggables[state.critical.draggable.id];
      var _getDropImpact = getDropImpact$1({
        reason,
        lastImpact: state.impact,
        afterCritical: state.afterCritical,
        onLiftImpact: state.onLiftImpact,
        home: state.dimensions.droppables[state.critical.droppable.id],
        viewport: state.viewport,
        draggables: state.dimensions.draggables
      }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
      var destination = didDropInsideDroppable ? tryGetDestination(impact) : null;
      var combine2 = didDropInsideDroppable ? tryGetCombine(impact) : null;
      var source = {
        index: critical.draggable.index,
        droppableId: critical.droppable.id
      };
      var result = {
        draggableId: draggable2.descriptor.id,
        type: draggable2.descriptor.type,
        source,
        reason,
        mode: state.movementMode,
        destination,
        combine: combine2
      };
      var newHomeClientOffset = getNewHomeClientOffset$1({
        impact,
        draggable: draggable2,
        dimensions,
        viewport: state.viewport,
        afterCritical: state.afterCritical
      });
      var completed = {
        critical: state.critical,
        afterCritical: state.afterCritical,
        result,
        impact
      };
      var isAnimationRequired = !isEqual$5(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
      if (!isAnimationRequired) {
        dispatch(completeDrop$1({
          completed
        }));
        return;
      }
      var dropDuration = getDropDuration$1({
        current: state.current.client.offset,
        destination: newHomeClientOffset,
        reason
      });
      var args = {
        newHomeClientOffset,
        dropDuration,
        completed
      };
      dispatch(animateDrop$1(args));
    };
  };
};
var getWindowScroll$1 = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};
function getWindowScrollBinding(update2) {
  return {
    eventName: "scroll",
    options: {
      passive: true,
      capture: false
    },
    fn: function fn2(event) {
      if (event.target !== window && event.target !== window.document) {
        return;
      }
      update2();
    }
  };
}
function getScrollListener(_ref) {
  var onWindowScroll = _ref.onWindowScroll;
  function updateScroll() {
    onWindowScroll(getWindowScroll$1());
  }
  var scheduled = rafSchd(updateScroll);
  var binding = getWindowScrollBinding(scheduled);
  var unbind = noop$7;
  function isActive2() {
    return unbind !== noop$7;
  }
  function start4() {
    !!isActive2() ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot start scroll listener when already active") : invariant$1() : void 0;
    unbind = bindEvents$1(window, [binding]);
  }
  function stop() {
    !isActive2() ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot stop scroll listener when not active") : invariant$1() : void 0;
    scheduled.cancel();
    unbind();
    unbind = noop$7;
  }
  return {
    start: start4,
    stop,
    isActive: isActive2
  };
}
var shouldEnd$1 = function shouldEnd(action) {
  return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var scrollListener = function(store) {
  var listener = getScrollListener({
    onWindowScroll: function onWindowScroll(newScroll) {
      store.dispatch(moveByWindowScroll$1({
        newScroll
      }));
    }
  });
  return function(next2) {
    return function(action) {
      if (!listener.isActive() && action.type === "INITIAL_PUBLISH") {
        listener.start();
      }
      if (listener.isActive() && shouldEnd$1(action)) {
        listener.stop();
      }
      next2(action);
    };
  };
};
var getExpiringAnnounce$1 = function(announce2) {
  var wasCalled = false;
  var isExpired = false;
  var timeoutId = setTimeout(function() {
    isExpired = true;
  });
  var result = function result2(message2) {
    if (wasCalled) {
      process.env.NODE_ENV !== "production" ? warning$2("Announcement already made. Not making a second announcement") : void 0;
      return;
    }
    if (isExpired) {
      process.env.NODE_ENV !== "production" ? warning$2("\n        Announcements cannot be made asynchronously.\n        Default message has already been announced.\n      ") : void 0;
      return;
    }
    wasCalled = true;
    announce2(message2);
    clearTimeout(timeoutId);
  };
  result.wasCalled = function() {
    return wasCalled;
  };
  return result;
};
var getAsyncMarshal$1 = function() {
  var entries = [];
  var execute4 = function execute5(timerId) {
    var index2 = findIndex$2(entries, function(item) {
      return item.timerId === timerId;
    });
    !(index2 !== -1) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Could not find timer") : invariant$1() : void 0;
    var _entries$splice = entries.splice(index2, 1), entry = _entries$splice[0];
    entry.callback();
  };
  var add4 = function add5(fn2) {
    var timerId = setTimeout(function() {
      return execute4(timerId);
    });
    var entry = {
      timerId,
      callback: fn2
    };
    entries.push(entry);
  };
  var flush3 = function flush4() {
    if (!entries.length) {
      return;
    }
    var shallow = [].concat(entries);
    entries.length = 0;
    shallow.forEach(function(entry) {
      clearTimeout(entry.timerId);
      entry.callback();
    });
  };
  return {
    add: add4,
    flush: flush3
  };
};
var areLocationsEqual$1 = function areLocationsEqual(first2, second) {
  if (first2 == null && second == null) {
    return true;
  }
  if (first2 == null || second == null) {
    return false;
  }
  return first2.droppableId === second.droppableId && first2.index === second.index;
};
var isCombineEqual$1 = function isCombineEqual(first2, second) {
  if (first2 == null && second == null) {
    return true;
  }
  if (first2 == null || second == null) {
    return false;
  }
  return first2.draggableId === second.draggableId && first2.droppableId === second.droppableId;
};
var isCriticalEqual$1 = function isCriticalEqual(first2, second) {
  if (first2 === second) {
    return true;
  }
  var isDraggableEqual = first2.draggable.id === second.draggable.id && first2.draggable.droppableId === second.draggable.droppableId && first2.draggable.type === second.draggable.type && first2.draggable.index === second.draggable.index;
  var isDroppableEqual = first2.droppable.id === second.droppable.id && first2.droppable.type === second.droppable.type;
  return isDraggableEqual && isDroppableEqual;
};
var withTimings$1 = function withTimings(key2, fn2) {
  start$1();
  fn2();
  finish$1();
};
var getDragStart$1 = function getDragStart(critical, mode) {
  return {
    draggableId: critical.draggable.id,
    type: critical.droppable.type,
    source: {
      droppableId: critical.droppable.id,
      index: critical.draggable.index
    },
    mode
  };
};
var execute$1 = function execute(responder, data, announce2, getDefaultMessage) {
  if (!responder) {
    announce2(getDefaultMessage(data));
    return;
  }
  var willExpire = getExpiringAnnounce$1(announce2);
  var provided = {
    announce: willExpire
  };
  responder(data, provided);
  if (!willExpire.wasCalled()) {
    announce2(getDefaultMessage(data));
  }
};
var getPublisher$1 = function(getResponders, announce2) {
  var asyncMarshal = getAsyncMarshal$1();
  var dragging = null;
  var beforeCapture = function beforeCapture2(draggableId, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot fire onBeforeCapture as a drag start has already been published") : invariant$1() : void 0;
    withTimings$1("onBeforeCapture", function() {
      var fn2 = getResponders().onBeforeCapture;
      if (fn2) {
        var before = {
          draggableId,
          mode
        };
        fn2(before);
      }
    });
  };
  var beforeStart = function beforeStart2(critical, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot fire onBeforeDragStart as a drag start has already been published") : invariant$1() : void 0;
    withTimings$1("onBeforeDragStart", function() {
      var fn2 = getResponders().onBeforeDragStart;
      if (fn2) {
        fn2(getDragStart$1(critical, mode));
      }
    });
  };
  var start4 = function start5(critical, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot fire onBeforeDragStart as a drag start has already been published") : invariant$1() : void 0;
    var data = getDragStart$1(critical, mode);
    dragging = {
      mode,
      lastCritical: critical,
      lastLocation: data.source,
      lastCombine: null
    };
    asyncMarshal.add(function() {
      withTimings$1("onDragStart", function() {
        return execute$1(getResponders().onDragStart, data, announce2, preset$1.onDragStart);
      });
    });
  };
  var update2 = function update3(critical, impact) {
    var location = tryGetDestination(impact);
    var combine2 = tryGetCombine(impact);
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot fire onDragMove when onDragStart has not been called") : invariant$1() : void 0;
    var hasCriticalChanged = !isCriticalEqual$1(critical, dragging.lastCritical);
    if (hasCriticalChanged) {
      dragging.lastCritical = critical;
    }
    var hasLocationChanged = !areLocationsEqual$1(dragging.lastLocation, location);
    if (hasLocationChanged) {
      dragging.lastLocation = location;
    }
    var hasGroupingChanged = !isCombineEqual$1(dragging.lastCombine, combine2);
    if (hasGroupingChanged) {
      dragging.lastCombine = combine2;
    }
    if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) {
      return;
    }
    var data = _extends$6({}, getDragStart$1(critical, dragging.mode), {
      combine: combine2,
      destination: location
    });
    asyncMarshal.add(function() {
      withTimings$1("onDragUpdate", function() {
        return execute$1(getResponders().onDragUpdate, data, announce2, preset$1.onDragUpdate);
      });
    });
  };
  var flush3 = function flush4() {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Can only flush responders while dragging") : invariant$1() : void 0;
    asyncMarshal.flush();
  };
  var drop8 = function drop9(result) {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot fire onDragEnd when there is no matching onDragStart") : invariant$1() : void 0;
    dragging = null;
    withTimings$1("onDragEnd", function() {
      return execute$1(getResponders().onDragEnd, result, announce2, preset$1.onDragEnd);
    });
  };
  var abort = function abort2() {
    if (!dragging) {
      return;
    }
    var result = _extends$6({}, getDragStart$1(dragging.lastCritical, dragging.mode), {
      combine: null,
      destination: null,
      reason: "CANCEL"
    });
    drop8(result);
  };
  return {
    beforeCapture,
    beforeStart,
    start: start4,
    update: update2,
    flush: flush3,
    drop: drop8,
    abort
  };
};
var responders$1 = function(getResponders, announce2) {
  var publisher = getPublisher$1(getResponders, announce2);
  return function(store) {
    return function(next2) {
      return function(action) {
        if (action.type === "BEFORE_INITIAL_CAPTURE") {
          publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
          return;
        }
        if (action.type === "INITIAL_PUBLISH") {
          var critical = action.payload.critical;
          publisher.beforeStart(critical, action.payload.movementMode);
          next2(action);
          publisher.start(critical, action.payload.movementMode);
          return;
        }
        if (action.type === "DROP_COMPLETE") {
          var result = action.payload.completed.result;
          publisher.flush();
          next2(action);
          publisher.drop(result);
          return;
        }
        next2(action);
        if (action.type === "FLUSH") {
          publisher.abort();
          return;
        }
        var state = store.getState();
        if (state.phase === "DRAGGING") {
          publisher.update(state.critical, state.impact);
        }
      };
    };
  };
};
var dropAnimationFinish$1 = function(store) {
  return function(next2) {
    return function(action) {
      if (action.type !== "DROP_ANIMATION_FINISHED") {
        next2(action);
        return;
      }
      var state = store.getState();
      !(state.phase === "DROP_ANIMATING") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot finish a drop animating when no drop is occurring") : invariant$1() : void 0;
      store.dispatch(completeDrop$1({
        completed: state.completed
      }));
    };
  };
};
var dropAnimationFlushOnScroll = function(store) {
  var unbind = null;
  var frameId = null;
  function clear() {
    if (frameId) {
      cancelAnimationFrame(frameId);
      frameId = null;
    }
    if (unbind) {
      unbind();
      unbind = null;
    }
  }
  return function(next2) {
    return function(action) {
      if (action.type === "FLUSH" || action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATION_FINISHED") {
        clear();
      }
      next2(action);
      if (action.type !== "DROP_ANIMATE") {
        return;
      }
      var binding = {
        eventName: "scroll",
        options: {
          capture: true,
          passive: false,
          once: true
        },
        fn: function flushDropAnimation() {
          var state = store.getState();
          if (state.phase === "DROP_ANIMATING") {
            store.dispatch(dropAnimationFinished$1());
          }
        }
      };
      frameId = requestAnimationFrame(function() {
        frameId = null;
        unbind = bindEvents$1(window, [binding]);
      });
    };
  };
};
var dimensionMarshalStopper$1 = function(marshal) {
  return function() {
    return function(next2) {
      return function(action) {
        if (action.type === "DROP_COMPLETE" || action.type === "FLUSH" || action.type === "DROP_ANIMATE") {
          marshal.stopPublishing();
        }
        next2(action);
      };
    };
  };
};
var focus$1 = function(marshal) {
  var isWatching = false;
  return function() {
    return function(next2) {
      return function(action) {
        if (action.type === "INITIAL_PUBLISH") {
          isWatching = true;
          marshal.tryRecordFocus(action.payload.critical.draggable.id);
          next2(action);
          marshal.tryRestoreFocusRecorded();
          return;
        }
        next2(action);
        if (!isWatching) {
          return;
        }
        if (action.type === "FLUSH") {
          isWatching = false;
          marshal.tryRestoreFocusRecorded();
          return;
        }
        if (action.type === "DROP_COMPLETE") {
          isWatching = false;
          var result = action.payload.completed.result;
          if (result.combine) {
            marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
          }
          marshal.tryRestoreFocusRecorded();
        }
      };
    };
  };
};
var shouldStop = function shouldStop2(action) {
  return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var autoScroll$1 = function(autoScroller) {
  return function(store) {
    return function(next2) {
      return function(action) {
        if (shouldStop(action)) {
          autoScroller.stop();
          next2(action);
          return;
        }
        if (action.type === "INITIAL_PUBLISH") {
          next2(action);
          var state = store.getState();
          !(state.phase === "DRAGGING") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Expected phase to be DRAGGING after INITIAL_PUBLISH") : invariant$1() : void 0;
          autoScroller.start(state);
          return;
        }
        next2(action);
        autoScroller.scroll(store.getState());
      };
    };
  };
};
var pendingDrop$1 = function(store) {
  return function(next2) {
    return function(action) {
      next2(action);
      if (action.type !== "PUBLISH_WHILE_DRAGGING") {
        return;
      }
      var postActionState = store.getState();
      if (postActionState.phase !== "DROP_PENDING") {
        return;
      }
      if (postActionState.isWaiting) {
        return;
      }
      store.dispatch(drop$2({
        reason: postActionState.reason
      }));
    };
  };
};
var composeEnhancers$1 = process.env.NODE_ENV !== "production" && typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  name: "react-beautiful-dnd"
}) : compose$2;
var createStore$1 = function(_ref) {
  var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce2 = _ref.announce, autoScroller = _ref.autoScroller;
  return createStore$2(reducer$5, composeEnhancers$1(applyMiddleware(style$4(styleMarshal), dimensionMarshalStopper$1(dimensionMarshal), lift$1$2(dimensionMarshal), drop$1$1, dropAnimationFinish$1, dropAnimationFlushOnScroll, pendingDrop$1, autoScroll$1(autoScroller), scrollListener, focus$1(focusMarshal), responders$1(getResponders, announce2))));
};
var clean$1$1 = function clean2() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
function createPublisher$1(_ref) {
  var registry2 = _ref.registry, callbacks = _ref.callbacks;
  var staging = clean$1$1();
  var frameId = null;
  var collect = function collect2() {
    if (frameId) {
      return;
    }
    callbacks.collectionStarting();
    frameId = requestAnimationFrame(function() {
      frameId = null;
      start$1();
      var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
      var added = Object.keys(additions).map(function(id) {
        return registry2.draggable.getById(id).getDimension(origin$1);
      }).sort(function(a2, b2) {
        return a2.descriptor.index - b2.descriptor.index;
      });
      var updated = Object.keys(modified).map(function(id) {
        var entry = registry2.droppable.getById(id);
        var scroll4 = entry.callbacks.getScrollWhileDragging();
        return {
          droppableId: id,
          scroll: scroll4
        };
      });
      var result = {
        additions: added,
        removals: Object.keys(removals),
        modified: updated
      };
      staging = clean$1$1();
      finish$1();
      callbacks.publish(result);
    });
  };
  var add4 = function add5(entry) {
    var id = entry.descriptor.id;
    staging.additions[id] = entry;
    staging.modified[entry.descriptor.droppableId] = true;
    if (staging.removals[id]) {
      delete staging.removals[id];
    }
    collect();
  };
  var remove = function remove2(entry) {
    var descriptor = entry.descriptor;
    staging.removals[descriptor.id] = true;
    staging.modified[descriptor.droppableId] = true;
    if (staging.additions[descriptor.id]) {
      delete staging.additions[descriptor.id];
    }
    collect();
  };
  var stop = function stop2() {
    if (!frameId) {
      return;
    }
    cancelAnimationFrame(frameId);
    frameId = null;
    staging = clean$1$1();
  };
  return {
    add: add4,
    remove,
    stop
  };
}
var getMaxScroll$1 = function(_ref) {
  var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height2 = _ref.height, width2 = _ref.width;
  var maxScroll = subtract$4({
    x: scrollWidth,
    y: scrollHeight
  }, {
    x: width2,
    y: height2
  });
  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };
  return adjustedMaxScroll;
};
var getDocumentElement$2 = function() {
  var doc2 = document.documentElement;
  !doc2 ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot find document.documentElement") : invariant$1() : void 0;
  return doc2;
};
var getMaxWindowScroll$1 = function() {
  var doc2 = getDocumentElement$2();
  var maxScroll = getMaxScroll$1({
    scrollHeight: doc2.scrollHeight,
    scrollWidth: doc2.scrollWidth,
    width: doc2.clientWidth,
    height: doc2.clientHeight
  });
  return maxScroll;
};
var getViewport$1 = function() {
  var scroll4 = getWindowScroll$1();
  var maxScroll = getMaxWindowScroll$1();
  var top2 = scroll4.y;
  var left2 = scroll4.x;
  var doc2 = getDocumentElement$2();
  var width2 = doc2.clientWidth;
  var height2 = doc2.clientHeight;
  var right2 = left2 + width2;
  var bottom2 = top2 + height2;
  var frame = getRect({
    top: top2,
    left: left2,
    right: right2,
    bottom: bottom2
  });
  var viewport = {
    frame,
    scroll: {
      initial: scroll4,
      current: scroll4,
      max: maxScroll,
      diff: {
        value: origin$1,
        displacement: origin$1
      }
    }
  };
  return viewport;
};
var getInitialPublish$1 = function(_ref) {
  var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry2 = _ref.registry;
  start$1();
  var viewport = getViewport$1();
  var windowScroll = viewport.scroll.current;
  var home2 = critical.droppable;
  var droppables = registry2.droppable.getAllByType(home2.type).map(function(entry) {
    return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
  });
  var draggables = registry2.draggable.getAllByType(critical.draggable.type).map(function(entry) {
    return entry.getDimension(windowScroll);
  });
  var dimensions = {
    draggables: toDraggableMap$1(draggables),
    droppables: toDroppableMap$1(droppables)
  };
  finish$1();
  var result = {
    dimensions,
    critical,
    viewport
  };
  return result;
};
function shouldPublishUpdate(registry2, dragging, entry) {
  if (entry.descriptor.id === dragging.id) {
    return false;
  }
  if (entry.descriptor.type !== dragging.type) {
    return false;
  }
  var home2 = registry2.droppable.getById(entry.descriptor.droppableId);
  if (home2.descriptor.mode !== "virtual") {
    process.env.NODE_ENV !== "production" ? warning$2("\n      You are attempting to add or remove a Draggable [id: " + entry.descriptor.id + "]\n      while a drag is occurring. This is only supported for virtual lists.\n\n      See https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/patterns/virtual-lists.md\n    ") : void 0;
    return false;
  }
  return true;
}
var createDimensionMarshal$1 = function(registry2, callbacks) {
  var collection = null;
  var publisher = createPublisher$1({
    callbacks: {
      publish: callbacks.publishWhileDragging,
      collectionStarting: callbacks.collectionStarting
    },
    registry: registry2
  });
  var updateDroppableIsEnabled4 = function updateDroppableIsEnabled5(id, isEnabled) {
    !registry2.droppable.exists(id) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot update is enabled flag of Droppable " + id + " as it is not registered") : invariant$1() : void 0;
    if (!collection) {
      return;
    }
    callbacks.updateDroppableIsEnabled({
      id,
      isEnabled
    });
  };
  var updateDroppableIsCombineEnabled4 = function updateDroppableIsCombineEnabled5(id, isCombineEnabled) {
    if (!collection) {
      return;
    }
    !registry2.droppable.exists(id) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot update isCombineEnabled flag of Droppable " + id + " as it is not registered") : invariant$1() : void 0;
    callbacks.updateDroppableIsCombineEnabled({
      id,
      isCombineEnabled
    });
  };
  var updateDroppableScroll4 = function updateDroppableScroll5(id, newScroll) {
    if (!collection) {
      return;
    }
    !registry2.droppable.exists(id) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot update the scroll on Droppable " + id + " as it is not registered") : invariant$1() : void 0;
    callbacks.updateDroppableScroll({
      id,
      newScroll
    });
  };
  var scrollDroppable2 = function scrollDroppable3(id, change) {
    if (!collection) {
      return;
    }
    registry2.droppable.getById(id).callbacks.scroll(change);
  };
  var stopPublishing = function stopPublishing2() {
    if (!collection) {
      return;
    }
    publisher.stop();
    var home2 = collection.critical.droppable;
    registry2.droppable.getAllByType(home2.type).forEach(function(entry) {
      return entry.callbacks.dragStopped();
    });
    collection.unsubscribe();
    collection = null;
  };
  var subscriber = function subscriber2(event) {
    !collection ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Should only be subscribed when a collection is occurring") : invariant$1() : void 0;
    var dragging = collection.critical.draggable;
    if (event.type === "ADDITION") {
      if (shouldPublishUpdate(registry2, dragging, event.value)) {
        publisher.add(event.value);
      }
    }
    if (event.type === "REMOVAL") {
      if (shouldPublishUpdate(registry2, dragging, event.value)) {
        publisher.remove(event.value);
      }
    }
  };
  var startPublishing = function startPublishing2(request) {
    !!collection ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot start capturing critical dimensions as there is already a collection") : invariant$1() : void 0;
    var entry = registry2.draggable.getById(request.draggableId);
    var home2 = registry2.droppable.getById(entry.descriptor.droppableId);
    var critical = {
      draggable: entry.descriptor,
      droppable: home2.descriptor
    };
    var unsubscribe = registry2.subscribe(subscriber);
    collection = {
      critical,
      unsubscribe
    };
    return getInitialPublish$1({
      critical,
      registry: registry2,
      scrollOptions: request.scrollOptions
    });
  };
  var marshal = {
    updateDroppableIsEnabled: updateDroppableIsEnabled4,
    updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled4,
    scrollDroppable: scrollDroppable2,
    updateDroppableScroll: updateDroppableScroll4,
    startPublishing,
    stopPublishing
  };
  return marshal;
};
var canStartDrag$1 = function(state, id) {
  if (state.phase === "IDLE") {
    return true;
  }
  if (state.phase !== "DROP_ANIMATING") {
    return false;
  }
  if (state.completed.result.draggableId === id) {
    return false;
  }
  return state.completed.result.reason === "DROP";
};
var scrollWindow$1 = function(change) {
  window.scrollBy(change.x, change.y);
};
var getScrollableDroppables$1 = memoizeOne(function(droppables) {
  return toDroppableList$1(droppables).filter(function(droppable2) {
    if (!droppable2.isEnabled) {
      return false;
    }
    if (!droppable2.frame) {
      return false;
    }
    return true;
  });
});
var getScrollableDroppableOver$1 = function getScrollableDroppableOver(target, droppables) {
  var maybe = find$3(getScrollableDroppables$1(droppables), function(droppable2) {
    !droppable2.frame ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Invalid result") : invariant$1() : void 0;
    return isPositionInFrame$1(droppable2.frame.pageMarginBox)(target);
  });
  return maybe;
};
var getBestScrollableDroppable$1 = function(_ref) {
  var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
  if (destination) {
    var _dimension = droppables[destination];
    if (!_dimension.frame) {
      return null;
    }
    return _dimension;
  }
  var dimension = getScrollableDroppableOver$1(center, droppables);
  return dimension;
};
var config$9 = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function ease(percentage) {
    return Math.pow(percentage, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
};
var getDistanceThresholds$1 = function(container, axis) {
  var startScrollingFrom = container[axis.size] * config$9.startFromPercentage;
  var maxScrollValueAt = container[axis.size] * config$9.maxScrollAtPercentage;
  var thresholds2 = {
    startScrollingFrom,
    maxScrollValueAt
  };
  return thresholds2;
};
var getPercentage$1 = function(_ref) {
  var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
  var range = endOfRange - startOfRange;
  if (range === 0) {
    process.env.NODE_ENV !== "production" ? warning$2("\n      Detected distance range of 0 in the fluid auto scroller\n      This is unexpected and would cause a divide by 0 issue.\n      Not allowing an auto scroll\n    ") : void 0;
    return 0;
  }
  var currentInRange = current - startOfRange;
  var percentage = currentInRange / range;
  return percentage;
};
var minScroll$1 = 1;
var getValueFromDistance$1 = function(distanceToEdge, thresholds2) {
  if (distanceToEdge > thresholds2.startScrollingFrom) {
    return 0;
  }
  if (distanceToEdge <= thresholds2.maxScrollValueAt) {
    return config$9.maxPixelScroll;
  }
  if (distanceToEdge === thresholds2.startScrollingFrom) {
    return minScroll$1;
  }
  var percentageFromMaxScrollValueAt = getPercentage$1({
    startOfRange: thresholds2.maxScrollValueAt,
    endOfRange: thresholds2.startScrollingFrom,
    current: distanceToEdge
  });
  var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
  var scroll4 = config$9.maxPixelScroll * config$9.ease(percentageFromStartScrollingFrom);
  return Math.ceil(scroll4);
};
var accelerateAt$1 = config$9.durationDampening.accelerateAt;
var stopAt$1 = config$9.durationDampening.stopDampeningAt;
var dampenValueByTime$1 = function(proposedScroll, dragStartTime) {
  var startOfRange = dragStartTime;
  var endOfRange = stopAt$1;
  var now2 = Date.now();
  var runTime = now2 - startOfRange;
  if (runTime >= stopAt$1) {
    return proposedScroll;
  }
  if (runTime < accelerateAt$1) {
    return minScroll$1;
  }
  var betweenAccelerateAtAndStopAtPercentage = getPercentage$1({
    startOfRange: accelerateAt$1,
    endOfRange,
    current: runTime
  });
  var scroll4 = proposedScroll * config$9.ease(betweenAccelerateAtAndStopAtPercentage);
  return Math.ceil(scroll4);
};
var getValue$2 = function(_ref) {
  var distanceToEdge = _ref.distanceToEdge, thresholds2 = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll4 = getValueFromDistance$1(distanceToEdge, thresholds2);
  if (scroll4 === 0) {
    return 0;
  }
  if (!shouldUseTimeDampening) {
    return scroll4;
  }
  return Math.max(dampenValueByTime$1(scroll4, dragStartTime), minScroll$1);
};
var getScrollOnAxis$1 = function(_ref) {
  var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var thresholds2 = getDistanceThresholds$1(container, axis);
  var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
  if (isCloserToEnd) {
    return getValue$2({
      distanceToEdge: distanceToEdges[axis.end],
      thresholds: thresholds2,
      dragStartTime,
      shouldUseTimeDampening
    });
  }
  return -1 * getValue$2({
    distanceToEdge: distanceToEdges[axis.start],
    thresholds: thresholds2,
    dragStartTime,
    shouldUseTimeDampening
  });
};
var adjustForSizeLimits$1 = function(_ref) {
  var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
  var isTooBigVertically = subject.height > container.height;
  var isTooBigHorizontally = subject.width > container.width;
  if (!isTooBigHorizontally && !isTooBigVertically) {
    return proposedScroll;
  }
  if (isTooBigHorizontally && isTooBigVertically) {
    return null;
  }
  return {
    x: isTooBigHorizontally ? 0 : proposedScroll.x,
    y: isTooBigVertically ? 0 : proposedScroll.y
  };
};
var clean$2$1 = apply$3(function(value) {
  return value === 0 ? 0 : value;
});
var getScroll$2 = function(_ref) {
  var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var distanceToEdges = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };
  var y2 = getScrollOnAxis$1({
    container,
    distanceToEdges,
    dragStartTime,
    axis: vertical$1,
    shouldUseTimeDampening
  });
  var x2 = getScrollOnAxis$1({
    container,
    distanceToEdges,
    dragStartTime,
    axis: horizontal$1,
    shouldUseTimeDampening
  });
  var required2 = clean$2$1({
    x: x2,
    y: y2
  });
  if (isEqual$5(required2, origin$1)) {
    return null;
  }
  var limited = adjustForSizeLimits$1({
    container,
    subject,
    proposedScroll: required2
  });
  if (!limited) {
    return null;
  }
  return isEqual$5(limited, origin$1) ? null : limited;
};
var smallestSigned$1 = apply$3(function(value) {
  if (value === 0) {
    return 0;
  }
  return value > 0 ? 1 : -1;
});
var getOverlap$1 = /* @__PURE__ */ function() {
  var getRemainder = function getRemainder2(target, max2) {
    if (target < 0) {
      return target;
    }
    if (target > max2) {
      return target - max2;
    }
    return 0;
  };
  return function(_ref) {
    var current = _ref.current, max2 = _ref.max, change = _ref.change;
    var targetScroll = add$4(current, change);
    var overlap = {
      x: getRemainder(targetScroll.x, max2.x),
      y: getRemainder(targetScroll.y, max2.y)
    };
    if (isEqual$5(overlap, origin$1)) {
      return null;
    }
    return overlap;
  };
}();
var canPartiallyScroll$1 = function canPartiallyScroll(_ref2) {
  var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
  var max2 = {
    x: Math.max(current.x, rawMax.x),
    y: Math.max(current.y, rawMax.y)
  };
  var smallestChange = smallestSigned$1(change);
  var overlap = getOverlap$1({
    max: max2,
    current,
    change: smallestChange
  });
  if (!overlap) {
    return true;
  }
  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }
  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }
  return false;
};
var canScrollWindow$1 = function canScrollWindow(viewport, change) {
  return canPartiallyScroll$1({
    current: viewport.scroll.current,
    max: viewport.scroll.max,
    change
  });
};
var getWindowOverlap$1 = function getWindowOverlap(viewport, change) {
  if (!canScrollWindow$1(viewport, change)) {
    return null;
  }
  var max2 = viewport.scroll.max;
  var current = viewport.scroll.current;
  return getOverlap$1({
    current,
    max: max2,
    change
  });
};
var canScrollDroppable$1 = function canScrollDroppable(droppable2, change) {
  var frame = droppable2.frame;
  if (!frame) {
    return false;
  }
  return canPartiallyScroll$1({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change
  });
};
var getDroppableOverlap$1 = function getDroppableOverlap(droppable2, change) {
  var frame = droppable2.frame;
  if (!frame) {
    return null;
  }
  if (!canScrollDroppable$1(droppable2, change)) {
    return null;
  }
  return getOverlap$1({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change
  });
};
var getWindowScrollChange$1 = function(_ref) {
  var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll4 = getScroll$2({
    dragStartTime,
    container: viewport.frame,
    subject,
    center,
    shouldUseTimeDampening
  });
  return scroll4 && canScrollWindow$1(viewport, scroll4) ? scroll4 : null;
};
var getDroppableScrollChange$1 = function(_ref) {
  var droppable2 = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var frame = droppable2.frame;
  if (!frame) {
    return null;
  }
  var scroll4 = getScroll$2({
    dragStartTime,
    container: frame.pageMarginBox,
    subject,
    center,
    shouldUseTimeDampening
  });
  return scroll4 && canScrollDroppable$1(droppable2, scroll4) ? scroll4 : null;
};
var scroll$1$1 = function(_ref) {
  var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow2 = _ref.scrollWindow, scrollDroppable2 = _ref.scrollDroppable;
  var center = state.current.page.borderBoxCenter;
  var draggable2 = state.dimensions.draggables[state.critical.draggable.id];
  var subject = draggable2.page.marginBox;
  if (state.isWindowScrollAllowed) {
    var viewport = state.viewport;
    var _change = getWindowScrollChange$1({
      dragStartTime,
      viewport,
      subject,
      center,
      shouldUseTimeDampening
    });
    if (_change) {
      scrollWindow2(_change);
      return;
    }
  }
  var droppable2 = getBestScrollableDroppable$1({
    center,
    destination: whatIsDraggedOver$1(state.impact),
    droppables: state.dimensions.droppables
  });
  if (!droppable2) {
    return;
  }
  var change = getDroppableScrollChange$1({
    dragStartTime,
    droppable: droppable2,
    subject,
    center,
    shouldUseTimeDampening
  });
  if (change) {
    scrollDroppable2(droppable2.descriptor.id, change);
  }
};
var createFluidScroller$1 = function(_ref) {
  var scrollWindow2 = _ref.scrollWindow, scrollDroppable2 = _ref.scrollDroppable;
  var scheduleWindowScroll = rafSchd(scrollWindow2);
  var scheduleDroppableScroll = rafSchd(scrollDroppable2);
  var dragging = null;
  var tryScroll = function tryScroll2(state) {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot fluid scroll if not dragging") : invariant$1() : void 0;
    var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
    scroll$1$1({
      state,
      scrollWindow: scheduleWindowScroll,
      scrollDroppable: scheduleDroppableScroll,
      dragStartTime,
      shouldUseTimeDampening
    });
  };
  var start$1$1 = function start$1$12(state) {
    start$1();
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot start auto scrolling when already started") : invariant$1() : void 0;
    var dragStartTime = Date.now();
    var wasScrollNeeded = false;
    var fakeScrollCallback = function fakeScrollCallback2() {
      wasScrollNeeded = true;
    };
    scroll$1$1({
      state,
      dragStartTime: 0,
      shouldUseTimeDampening: false,
      scrollWindow: fakeScrollCallback,
      scrollDroppable: fakeScrollCallback
    });
    dragging = {
      dragStartTime,
      shouldUseTimeDampening: wasScrollNeeded
    };
    finish$1();
    if (wasScrollNeeded) {
      tryScroll(state);
    }
  };
  var stop = function stop2() {
    if (!dragging) {
      return;
    }
    scheduleWindowScroll.cancel();
    scheduleDroppableScroll.cancel();
    dragging = null;
  };
  return {
    start: start$1$1,
    stop,
    scroll: tryScroll
  };
};
var createJumpScroller$1 = function(_ref) {
  var move4 = _ref.move, scrollDroppable2 = _ref.scrollDroppable, scrollWindow2 = _ref.scrollWindow;
  var moveByOffset = function moveByOffset2(state, offset3) {
    var client2 = add$4(state.current.client.selection, offset3);
    move4({
      client: client2
    });
  };
  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan2(droppable2, change) {
    if (!canScrollDroppable$1(droppable2, change)) {
      return change;
    }
    var overlap = getDroppableOverlap$1(droppable2, change);
    if (!overlap) {
      scrollDroppable2(droppable2.descriptor.id, change);
      return null;
    }
    var whatTheDroppableCanScroll = subtract$4(change, overlap);
    scrollDroppable2(droppable2.descriptor.id, whatTheDroppableCanScroll);
    var remainder = subtract$4(change, whatTheDroppableCanScroll);
    return remainder;
  };
  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan2(isWindowScrollAllowed, viewport, change) {
    if (!isWindowScrollAllowed) {
      return change;
    }
    if (!canScrollWindow$1(viewport, change)) {
      return change;
    }
    var overlap = getWindowOverlap$1(viewport, change);
    if (!overlap) {
      scrollWindow2(change);
      return null;
    }
    var whatTheWindowCanScroll = subtract$4(change, overlap);
    scrollWindow2(whatTheWindowCanScroll);
    var remainder = subtract$4(change, whatTheWindowCanScroll);
    return remainder;
  };
  var jumpScroller = function jumpScroller2(state) {
    var request = state.scrollJumpRequest;
    if (!request) {
      return;
    }
    var destination = whatIsDraggedOver$1(state.impact);
    !destination ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot perform a jump scroll when there is no destination") : invariant$1() : void 0;
    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
    if (!droppableRemainder) {
      return;
    }
    var viewport = state.viewport;
    var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
    if (!windowRemainder) {
      return;
    }
    moveByOffset(state, windowRemainder);
  };
  return jumpScroller;
};
var createAutoScroller$1 = function(_ref) {
  var scrollDroppable2 = _ref.scrollDroppable, scrollWindow2 = _ref.scrollWindow, move4 = _ref.move;
  var fluidScroller = createFluidScroller$1({
    scrollWindow: scrollWindow2,
    scrollDroppable: scrollDroppable2
  });
  var jumpScroll = createJumpScroller$1({
    move: move4,
    scrollWindow: scrollWindow2,
    scrollDroppable: scrollDroppable2
  });
  var scroll4 = function scroll5(state) {
    if (state.phase !== "DRAGGING") {
      return;
    }
    if (state.movementMode === "FLUID") {
      fluidScroller.scroll(state);
      return;
    }
    if (!state.scrollJumpRequest) {
      return;
    }
    jumpScroll(state);
  };
  var scroller = {
    scroll: scroll4,
    start: fluidScroller.start,
    stop: fluidScroller.stop
  };
  return scroller;
};
var prefix$1$1 = "data-rbd";
var dragHandle$1 = function() {
  var base2 = prefix$1$1 + "-drag-handle";
  return {
    base: base2,
    draggableId: base2 + "-draggable-id",
    contextId: base2 + "-context-id"
  };
}();
var draggable$1 = function() {
  var base2 = prefix$1$1 + "-draggable";
  return {
    base: base2,
    contextId: base2 + "-context-id",
    id: base2 + "-id"
  };
}();
var droppable$1 = function() {
  var base2 = prefix$1$1 + "-droppable";
  return {
    base: base2,
    contextId: base2 + "-context-id",
    id: base2 + "-id"
  };
}();
var scrollContainer = {
  contextId: prefix$1$1 + "-scroll-container-context-id"
};
var makeGetSelector$1 = function makeGetSelector(context) {
  return function(attribute) {
    return "[" + attribute + '="' + context + '"]';
  };
};
var getStyles$2 = function getStyles(rules, property) {
  return rules.map(function(rule) {
    var value = rule.styles[property];
    if (!value) {
      return "";
    }
    return rule.selector + " { " + value + " }";
  }).join(" ");
};
var noPointerEvents$1 = "pointer-events: none;";
var getStyles$1$2 = function(contextId) {
  var getSelector2 = makeGetSelector$1(contextId);
  var dragHandle$1$1 = function() {
    var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
    return {
      selector: getSelector2(dragHandle$1.contextId),
      styles: {
        always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
        resting: grabCursor,
        dragging: noPointerEvents$1,
        dropAnimating: grabCursor
      }
    };
  }();
  var draggable$1$1 = function() {
    var transition = "\n      transition: " + transitions$1.outOfTheWay + ";\n    ";
    return {
      selector: getSelector2(draggable$1.contextId),
      styles: {
        dragging: transition,
        dropAnimating: transition,
        userCancel: transition
      }
    };
  }();
  var droppable$1$1 = {
    selector: getSelector2(droppable$1.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  };
  var body = {
    selector: "body",
    styles: {
      dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
    }
  };
  var rules = [draggable$1$1, dragHandle$1$1, droppable$1$1, body];
  return {
    always: getStyles$2(rules, "always"),
    resting: getStyles$2(rules, "resting"),
    dragging: getStyles$2(rules, "dragging"),
    dropAnimating: getStyles$2(rules, "dropAnimating"),
    userCancel: getStyles$2(rules, "userCancel")
  };
};
var useIsomorphicLayoutEffect$5 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? useLayoutEffect : useEffect;
var getHead$1 = function getHead() {
  var head = document.querySelector("head");
  !head ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot find the head to append a style to") : invariant$1() : void 0;
  return head;
};
var createStyleEl$1 = function createStyleEl(nonce) {
  var el = document.createElement("style");
  if (nonce) {
    el.setAttribute("nonce", nonce);
  }
  el.type = "text/css";
  return el;
};
function useStyleMarshal$1(contextId, nonce) {
  var styles2 = useMemo(function() {
    return getStyles$1$2(contextId);
  }, [contextId]);
  var alwaysRef = useRef(null);
  var dynamicRef = useRef(null);
  var setDynamicStyle = useCallback(memoizeOne(function(proposed) {
    var el = dynamicRef.current;
    !el ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot set dynamic style element if it is not set") : invariant$1() : void 0;
    el.textContent = proposed;
  }), []);
  var setAlwaysStyle = useCallback(function(proposed) {
    var el = alwaysRef.current;
    !el ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot set dynamic style element if it is not set") : invariant$1() : void 0;
    el.textContent = proposed;
  }, []);
  useIsomorphicLayoutEffect$5(function() {
    !(!alwaysRef.current && !dynamicRef.current) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "style elements already mounted") : invariant$1() : void 0;
    var always = createStyleEl$1(nonce);
    var dynamic = createStyleEl$1(nonce);
    alwaysRef.current = always;
    dynamicRef.current = dynamic;
    always.setAttribute(prefix$1$1 + "-always", contextId);
    dynamic.setAttribute(prefix$1$1 + "-dynamic", contextId);
    getHead$1().appendChild(always);
    getHead$1().appendChild(dynamic);
    setAlwaysStyle(styles2.always);
    setDynamicStyle(styles2.resting);
    return function() {
      var remove = function remove2(ref2) {
        var current = ref2.current;
        !current ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot unmount ref as it is not set") : invariant$1() : void 0;
        getHead$1().removeChild(current);
        ref2.current = null;
      };
      remove(alwaysRef);
      remove(dynamicRef);
    };
  }, [nonce, setAlwaysStyle, setDynamicStyle, styles2.always, styles2.resting, contextId]);
  var dragging = useCallback(function() {
    return setDynamicStyle(styles2.dragging);
  }, [setDynamicStyle, styles2.dragging]);
  var dropping = useCallback(function(reason) {
    if (reason === "DROP") {
      setDynamicStyle(styles2.dropAnimating);
      return;
    }
    setDynamicStyle(styles2.userCancel);
  }, [setDynamicStyle, styles2.dropAnimating, styles2.userCancel]);
  var resting = useCallback(function() {
    if (!dynamicRef.current) {
      return;
    }
    setDynamicStyle(styles2.resting);
  }, [setDynamicStyle, styles2.resting]);
  var marshal = useMemo(function() {
    return {
      dragging,
      dropping,
      resting
    };
  }, [dragging, dropping, resting]);
  return marshal;
}
var getWindowFromEl$1 = function(el) {
  return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function isHtmlElement$1(el) {
  return el instanceof getWindowFromEl$1(el).HTMLElement;
}
function findDragHandle(contextId, draggableId) {
  var selector2 = "[" + dragHandle$1.contextId + '="' + contextId + '"]';
  var possible = toArray$1(document.querySelectorAll(selector2));
  if (!possible.length) {
    process.env.NODE_ENV !== "production" ? warning$2('Unable to find any drag handles in the context "' + contextId + '"') : void 0;
    return null;
  }
  var handle2 = find$3(possible, function(el) {
    return el.getAttribute(dragHandle$1.draggableId) === draggableId;
  });
  if (!handle2) {
    process.env.NODE_ENV !== "production" ? warning$2('Unable to find drag handle with id "' + draggableId + '" as no handle with a matching id was found') : void 0;
    return null;
  }
  if (!isHtmlElement$1(handle2)) {
    process.env.NODE_ENV !== "production" ? warning$2("drag handle needs to be a HTMLElement") : void 0;
    return null;
  }
  return handle2;
}
function useFocusMarshal(contextId) {
  var entriesRef = useRef({});
  var recordRef = useRef(null);
  var restoreFocusFrameRef = useRef(null);
  var isMountedRef = useRef(false);
  var register2 = useCallback(function register3(id, focus2) {
    var entry = {
      id,
      focus: focus2
    };
    entriesRef.current[id] = entry;
    return function unregister() {
      var entries = entriesRef.current;
      var current = entries[id];
      if (current !== entry) {
        delete entries[id];
      }
    };
  }, []);
  var tryGiveFocus = useCallback(function tryGiveFocus2(tryGiveFocusTo) {
    var handle2 = findDragHandle(contextId, tryGiveFocusTo);
    if (handle2 && handle2 !== document.activeElement) {
      handle2.focus();
    }
  }, [contextId]);
  var tryShiftRecord = useCallback(function tryShiftRecord2(previous2, redirectTo) {
    if (recordRef.current === previous2) {
      recordRef.current = redirectTo;
    }
  }, []);
  var tryRestoreFocusRecorded = useCallback(function tryRestoreFocusRecorded2() {
    if (restoreFocusFrameRef.current) {
      return;
    }
    if (!isMountedRef.current) {
      return;
    }
    restoreFocusFrameRef.current = requestAnimationFrame(function() {
      restoreFocusFrameRef.current = null;
      var record = recordRef.current;
      if (record) {
        tryGiveFocus(record);
      }
    });
  }, [tryGiveFocus]);
  var tryRecordFocus = useCallback(function tryRecordFocus2(id) {
    recordRef.current = null;
    var focused = document.activeElement;
    if (!focused) {
      return;
    }
    if (focused.getAttribute(dragHandle$1.draggableId) !== id) {
      return;
    }
    recordRef.current = id;
  }, []);
  useIsomorphicLayoutEffect$5(function() {
    isMountedRef.current = true;
    return function clearFrameOnUnmount() {
      isMountedRef.current = false;
      var frameId = restoreFocusFrameRef.current;
      if (frameId) {
        cancelAnimationFrame(frameId);
      }
    };
  }, []);
  var marshal = useMemo(function() {
    return {
      register: register2,
      tryRecordFocus,
      tryRestoreFocusRecorded,
      tryShiftRecord
    };
  }, [register2, tryRecordFocus, tryRestoreFocusRecorded, tryShiftRecord]);
  return marshal;
}
function createRegistry() {
  var entries = {
    draggables: {},
    droppables: {}
  };
  var subscribers = [];
  function subscribe(cb) {
    subscribers.push(cb);
    return function unsubscribe() {
      var index2 = subscribers.indexOf(cb);
      if (index2 === -1) {
        return;
      }
      subscribers.splice(index2, 1);
    };
  }
  function notify2(event) {
    if (subscribers.length) {
      subscribers.forEach(function(cb) {
        return cb(event);
      });
    }
  }
  function findDraggableById(id) {
    return entries.draggables[id] || null;
  }
  function getDraggableById(id) {
    var entry = findDraggableById(id);
    !entry ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot find draggable entry with id [" + id + "]") : invariant$1() : void 0;
    return entry;
  }
  var draggableAPI = {
    register: function register2(entry) {
      entries.draggables[entry.descriptor.id] = entry;
      notify2({
        type: "ADDITION",
        value: entry
      });
    },
    update: function update2(entry, last) {
      var current = entries.draggables[last.descriptor.id];
      if (!current) {
        return;
      }
      if (current.uniqueId !== entry.uniqueId) {
        return;
      }
      delete entries.draggables[last.descriptor.id];
      entries.draggables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var draggableId = entry.descriptor.id;
      var current = findDraggableById(draggableId);
      if (!current) {
        return;
      }
      if (entry.uniqueId !== current.uniqueId) {
        return;
      }
      delete entries.draggables[draggableId];
      notify2({
        type: "REMOVAL",
        value: entry
      });
    },
    getById: getDraggableById,
    findById: findDraggableById,
    exists: function exists(id) {
      return Boolean(findDraggableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values$3(entries.draggables).filter(function(entry) {
        return entry.descriptor.type === type;
      });
    }
  };
  function findDroppableById(id) {
    return entries.droppables[id] || null;
  }
  function getDroppableById(id) {
    var entry = findDroppableById(id);
    !entry ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot find droppable entry with id [" + id + "]") : invariant$1() : void 0;
    return entry;
  }
  var droppableAPI = {
    register: function register2(entry) {
      entries.droppables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var current = findDroppableById(entry.descriptor.id);
      if (!current) {
        return;
      }
      if (entry.uniqueId !== current.uniqueId) {
        return;
      }
      delete entries.droppables[entry.descriptor.id];
    },
    getById: getDroppableById,
    findById: findDroppableById,
    exists: function exists(id) {
      return Boolean(findDroppableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values$3(entries.droppables).filter(function(entry) {
        return entry.descriptor.type === type;
      });
    }
  };
  function clean7() {
    entries.draggables = {};
    entries.droppables = {};
    subscribers.length = 0;
  }
  return {
    draggable: draggableAPI,
    droppable: droppableAPI,
    subscribe,
    clean: clean7
  };
}
function useRegistry() {
  var registry2 = useMemo(createRegistry, []);
  useEffect(function() {
    return function unmount() {
      requestAnimationFrame(registry2.clean);
    };
  }, [registry2]);
  return registry2;
}
var StoreContext$1 = React__default.createContext(null);
var getBodyElement$1 = function() {
  var body = document.body;
  !body ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot find document.body") : invariant$1() : void 0;
  return body;
};
var visuallyHidden$1 = {
  position: "absolute",
  width: "1px",
  height: "1px",
  margin: "-1px",
  border: "0",
  padding: "0",
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  "clip-path": "inset(100%)"
};
var getId$1 = function getId(contextId) {
  return "rbd-announcement-" + contextId;
};
function useAnnouncer$1(contextId) {
  var id = useMemo(function() {
    return getId$1(contextId);
  }, [contextId]);
  var ref2 = useRef(null);
  useEffect(function setup() {
    var el = document.createElement("div");
    ref2.current = el;
    el.id = id;
    el.setAttribute("aria-live", "assertive");
    el.setAttribute("aria-atomic", "true");
    _extends$6(el.style, visuallyHidden$1);
    getBodyElement$1().appendChild(el);
    return function cleanup() {
      setTimeout(function remove() {
        var body = getBodyElement$1();
        if (body.contains(el)) {
          body.removeChild(el);
        }
        if (el === ref2.current) {
          ref2.current = null;
        }
      });
    };
  }, [id]);
  var announce2 = useCallback(function(message2) {
    var el = ref2.current;
    if (el) {
      el.textContent = message2;
      return;
    }
    process.env.NODE_ENV !== "production" ? warning$2('\n      A screen reader message was trying to be announced but it was unable to do so.\n      This can occur if you unmount your <DragDropContext /> in your onDragEnd.\n      Consider calling provided.announce() before the unmount so that the instruction will\n      not be lost for users relying on a screen reader.\n\n      Message not passed to screen reader:\n\n      "' + message2 + '"\n    ') : void 0;
  }, []);
  return announce2;
}
var count$1 = 0;
var defaults$7 = {
  separator: "::"
};
function useUniqueId$1(prefix2, options) {
  if (options === void 0) {
    options = defaults$7;
  }
  return useMemo(function() {
    return "" + prefix2 + options.separator + count$1++;
  }, [options.separator, prefix2]);
}
function getElementId(_ref) {
  var contextId = _ref.contextId, uniqueId2 = _ref.uniqueId;
  return "rbd-hidden-text-" + contextId + "-" + uniqueId2;
}
function useHiddenTextElement(_ref2) {
  var contextId = _ref2.contextId, text2 = _ref2.text;
  var uniqueId2 = useUniqueId$1("hidden-text", {
    separator: "-"
  });
  var id = useMemo(function() {
    return getElementId({
      contextId,
      uniqueId: uniqueId2
    });
  }, [uniqueId2, contextId]);
  useEffect(function mount() {
    var el = document.createElement("div");
    el.id = id;
    el.textContent = text2;
    el.style.display = "none";
    getBodyElement$1().appendChild(el);
    return function unmount() {
      var body = getBodyElement$1();
      if (body.contains(el)) {
        body.removeChild(el);
      }
    };
  }, [id, text2]);
  return id;
}
var AppContext$1 = React__default.createContext(null);
var peerDependencies$1 = {
  react: "^16.8.5 || ^17.0.0 || ^18.0.0",
  "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
};
var semver$1 = /(\d+)\.(\d+)\.(\d+)/;
var getVersion$1 = function getVersion(value) {
  var result = semver$1.exec(value);
  !(result != null) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Unable to parse React version " + value) : invariant$1() : void 0;
  var major = Number(result[1]);
  var minor = Number(result[2]);
  var patch4 = Number(result[3]);
  return {
    major,
    minor,
    patch: patch4,
    raw: value
  };
};
var isSatisfied$1 = function isSatisfied(expected, actual) {
  if (actual.major > expected.major) {
    return true;
  }
  if (actual.major < expected.major) {
    return false;
  }
  if (actual.minor > expected.minor) {
    return true;
  }
  if (actual.minor < expected.minor) {
    return false;
  }
  return actual.patch >= expected.patch;
};
var checkReactVersion$1 = function(peerDepValue, actualValue) {
  var peerDep = getVersion$1(peerDepValue);
  var actual = getVersion$1(actualValue);
  if (isSatisfied$1(peerDep, actual)) {
    return;
  }
  process.env.NODE_ENV !== "production" ? warning$2("\n    React version: [" + actual.raw + "]\n    does not satisfy expected peer dependency version: [" + peerDep.raw + "]\n\n    This can result in run time bugs, and even fatal crashes\n  ") : void 0;
};
var suffix$1 = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var checkDoctype$1 = function(doc2) {
  var doctype = doc2.doctype;
  if (!doctype) {
    process.env.NODE_ENV !== "production" ? warning$2("\n      No <!doctype html> found.\n\n      " + suffix$1 + "\n    ") : void 0;
    return;
  }
  if (doctype.name.toLowerCase() !== "html") {
    process.env.NODE_ENV !== "production" ? warning$2("\n      Unexpected <!doctype> found: (" + doctype.name + ")\n\n      " + suffix$1 + "\n    ") : void 0;
  }
  if (doctype.publicId !== "") {
    process.env.NODE_ENV !== "production" ? warning$2("\n      Unexpected <!doctype> publicId found: (" + doctype.publicId + ")\n      A html5 doctype does not have a publicId\n\n      " + suffix$1 + "\n    ") : void 0;
  }
};
function useDev(useHook) {
  if (process.env.NODE_ENV !== "production") {
    useHook();
  }
}
function useDevSetupWarning(fn2, inputs) {
  useDev(function() {
    useEffect(function() {
      try {
        fn2();
      } catch (e) {
        error$1("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
      }
    }, inputs);
  });
}
function useStartupValidation$1() {
  useDevSetupWarning(function() {
    checkReactVersion$1(peerDependencies$1.react, React__default.version);
    checkDoctype$1(document);
  }, []);
}
function usePrevious$2(current) {
  var ref2 = useRef(current);
  useEffect(function() {
    ref2.current = current;
  });
  return ref2;
}
function create$2() {
  var lock = null;
  function isClaimed() {
    return Boolean(lock);
  }
  function isActive2(value) {
    return value === lock;
  }
  function claim(abandon) {
    !!lock ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot claim lock as it is already claimed") : invariant$1() : void 0;
    var newLock = {
      abandon
    };
    lock = newLock;
    return newLock;
  }
  function release() {
    !lock ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot release lock when there is no lock") : invariant$1() : void 0;
    lock = null;
  }
  function tryAbandon() {
    if (lock) {
      lock.abandon();
      release();
    }
  }
  return {
    isClaimed,
    isActive: isActive2,
    claim,
    release,
    tryAbandon
  };
}
var tab$2 = 9;
var enter$2 = 13;
var escape$2 = 27;
var space$4 = 32;
var pageUp$1 = 33;
var pageDown$1 = 34;
var end$1 = 35;
var home$1 = 36;
var arrowLeft$1 = 37;
var arrowUp$1 = 38;
var arrowRight$1 = 39;
var arrowDown$1 = 40;
var _preventedKeys$1;
var preventedKeys$1 = (_preventedKeys$1 = {}, _preventedKeys$1[enter$2] = true, _preventedKeys$1[tab$2] = true, _preventedKeys$1);
var preventStandardKeyEvents$1 = function(event) {
  if (preventedKeys$1[event.keyCode]) {
    event.preventDefault();
  }
};
var supportedEventName$1 = function() {
  var base2 = "visibilitychange";
  if (typeof document === "undefined") {
    return base2;
  }
  var candidates = [base2, "ms" + base2, "webkit" + base2, "moz" + base2, "o" + base2];
  var supported = find$3(candidates, function(eventName) {
    return "on" + eventName in document;
  });
  return supported || base2;
}();
var primaryButton$1 = 0;
var sloppyClickThreshold$1 = 5;
function isSloppyClickThresholdExceeded$1(original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold$1 || Math.abs(current.y - original.y) >= sloppyClickThreshold$1;
}
var idle$1$1 = {
  type: "IDLE"
};
function getCaptureBindings(_ref) {
  var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
  return [{
    eventName: "mousemove",
    fn: function fn2(event) {
      var button = event.button, clientX = event.clientX, clientY = event.clientY;
      if (button !== primaryButton$1) {
        return;
      }
      var point2 = {
        x: clientX,
        y: clientY
      };
      var phase = getPhase();
      if (phase.type === "DRAGGING") {
        event.preventDefault();
        phase.actions.move(point2);
        return;
      }
      !(phase.type === "PENDING") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot be IDLE") : invariant$1() : void 0;
      var pending = phase.point;
      if (!isSloppyClickThresholdExceeded$1(pending, point2)) {
        return;
      }
      event.preventDefault();
      var actions = phase.actions.fluidLift(point2);
      setPhase({
        type: "DRAGGING",
        actions
      });
    }
  }, {
    eventName: "mouseup",
    fn: function fn2(event) {
      var phase = getPhase();
      if (phase.type !== "DRAGGING") {
        cancel();
        return;
      }
      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: "mousedown",
    fn: function fn2(event) {
      if (getPhase().type === "DRAGGING") {
        event.preventDefault();
      }
      cancel();
    }
  }, {
    eventName: "keydown",
    fn: function fn2(event) {
      var phase = getPhase();
      if (phase.type === "PENDING") {
        cancel();
        return;
      }
      if (event.keyCode === escape$2) {
        event.preventDefault();
        cancel();
        return;
      }
      preventStandardKeyEvents$1(event);
    }
  }, {
    eventName: "resize",
    fn: cancel
  }, {
    eventName: "scroll",
    options: {
      passive: true,
      capture: false
    },
    fn: function fn2() {
      if (getPhase().type === "PENDING") {
        cancel();
      }
    }
  }, {
    eventName: "webkitmouseforcedown",
    fn: function fn2(event) {
      var phase = getPhase();
      !(phase.type !== "IDLE") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Unexpected phase") : invariant$1() : void 0;
      if (phase.actions.shouldRespectForcePress()) {
        cancel();
        return;
      }
      event.preventDefault();
    }
  }, {
    eventName: supportedEventName$1,
    fn: cancel
  }];
}
function useMouseSensor$1(api) {
  var phaseRef = useRef(idle$1$1);
  var unbindEventsRef = useRef(noop$7);
  var startCaptureBinding = useMemo(function() {
    return {
      eventName: "mousedown",
      fn: function onMouseDown(event) {
        if (event.defaultPrevented) {
          return;
        }
        if (event.button !== primaryButton$1) {
          return;
        }
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
          return;
        }
        var draggableId = api.findClosestDraggableId(event);
        if (!draggableId) {
          return;
        }
        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });
        if (!actions) {
          return;
        }
        event.preventDefault();
        var point2 = {
          x: event.clientX,
          y: event.clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point2);
      }
    };
  }, [api]);
  var preventForcePressBinding = useMemo(function() {
    return {
      eventName: "webkitmouseforcewillbegin",
      fn: function fn2(event) {
        if (event.defaultPrevented) {
          return;
        }
        var id = api.findClosestDraggableId(event);
        if (!id) {
          return;
        }
        var options = api.findOptionsForDraggable(id);
        if (!options) {
          return;
        }
        if (options.shouldRespectForcePress) {
          return;
        }
        if (!api.canGetLock(id)) {
          return;
        }
        event.preventDefault();
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture2() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents$1(window, [preventForcePressBinding, startCaptureBinding], options);
  }, [preventForcePressBinding, startCaptureBinding]);
  var stop = useCallback(function() {
    var current = phaseRef.current;
    if (current.type === "IDLE") {
      return;
    }
    phaseRef.current = idle$1$1;
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture]);
  var cancel = useCallback(function() {
    var phase = phaseRef.current;
    stop();
    if (phase.type === "DRAGGING") {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }
    if (phase.type === "PENDING") {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents2() {
    var options = {
      capture: true,
      passive: false
    };
    var bindings = getCaptureBindings({
      cancel,
      completed: stop,
      getPhase: function getPhase() {
        return phaseRef.current;
      },
      setPhase: function setPhase(phase) {
        phaseRef.current = phase;
      }
    });
    unbindEventsRef.current = bindEvents$1(window, bindings, options);
  }, [cancel, stop]);
  var startPendingDrag = useCallback(function startPendingDrag2(actions, point2) {
    !(phaseRef.current.type === "IDLE") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Expected to move from IDLE to PENDING drag") : invariant$1() : void 0;
    phaseRef.current = {
      type: "PENDING",
      point: point2,
      actions
    };
    bindCapturingEvents();
  }, [bindCapturingEvents]);
  useIsomorphicLayoutEffect$5(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}
var _scrollJumpKeys$1;
function noop$1$2() {
}
var scrollJumpKeys$1 = (_scrollJumpKeys$1 = {}, _scrollJumpKeys$1[pageDown$1] = true, _scrollJumpKeys$1[pageUp$1] = true, _scrollJumpKeys$1[home$1] = true, _scrollJumpKeys$1[end$1] = true, _scrollJumpKeys$1);
function getDraggingBindings(actions, stop) {
  function cancel() {
    stop();
    actions.cancel();
  }
  function drop8() {
    stop();
    actions.drop();
  }
  return [{
    eventName: "keydown",
    fn: function fn2(event) {
      if (event.keyCode === escape$2) {
        event.preventDefault();
        cancel();
        return;
      }
      if (event.keyCode === space$4) {
        event.preventDefault();
        drop8();
        return;
      }
      if (event.keyCode === arrowDown$1) {
        event.preventDefault();
        actions.moveDown();
        return;
      }
      if (event.keyCode === arrowUp$1) {
        event.preventDefault();
        actions.moveUp();
        return;
      }
      if (event.keyCode === arrowRight$1) {
        event.preventDefault();
        actions.moveRight();
        return;
      }
      if (event.keyCode === arrowLeft$1) {
        event.preventDefault();
        actions.moveLeft();
        return;
      }
      if (scrollJumpKeys$1[event.keyCode]) {
        event.preventDefault();
        return;
      }
      preventStandardKeyEvents$1(event);
    }
  }, {
    eventName: "mousedown",
    fn: cancel
  }, {
    eventName: "mouseup",
    fn: cancel
  }, {
    eventName: "click",
    fn: cancel
  }, {
    eventName: "touchstart",
    fn: cancel
  }, {
    eventName: "resize",
    fn: cancel
  }, {
    eventName: "wheel",
    fn: cancel,
    options: {
      passive: true
    }
  }, {
    eventName: supportedEventName$1,
    fn: cancel
  }];
}
function useKeyboardSensor$1(api) {
  var unbindEventsRef = useRef(noop$1$2);
  var startCaptureBinding = useMemo(function() {
    return {
      eventName: "keydown",
      fn: function onKeyDown(event) {
        if (event.defaultPrevented) {
          return;
        }
        if (event.keyCode !== space$4) {
          return;
        }
        var draggableId = api.findClosestDraggableId(event);
        if (!draggableId) {
          return;
        }
        var preDrag = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });
        if (!preDrag) {
          return;
        }
        event.preventDefault();
        var isCapturing = true;
        var actions = preDrag.snapLift();
        unbindEventsRef.current();
        function stop() {
          !isCapturing ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot stop capturing a keyboard drag when not capturing") : invariant$1() : void 0;
          isCapturing = false;
          unbindEventsRef.current();
          listenForCapture();
        }
        unbindEventsRef.current = bindEvents$1(window, getDraggingBindings(actions, stop), {
          capture: true,
          passive: false
        });
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function tryStartCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents$1(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  useIsomorphicLayoutEffect$5(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}
var idle$2 = {
  type: "IDLE"
};
var timeForLongPress$1 = 120;
var forcePressThreshold$1 = 0.15;
function getWindowBindings(_ref) {
  var cancel = _ref.cancel, getPhase = _ref.getPhase;
  return [{
    eventName: "orientationchange",
    fn: cancel
  }, {
    eventName: "resize",
    fn: cancel
  }, {
    eventName: "contextmenu",
    fn: function fn2(event) {
      event.preventDefault();
    }
  }, {
    eventName: "keydown",
    fn: function fn2(event) {
      if (getPhase().type !== "DRAGGING") {
        cancel();
        return;
      }
      if (event.keyCode === escape$2) {
        event.preventDefault();
      }
      cancel();
    }
  }, {
    eventName: supportedEventName$1,
    fn: cancel
  }];
}
function getHandleBindings(_ref2) {
  var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
  return [{
    eventName: "touchmove",
    options: {
      capture: false
    },
    fn: function fn2(event) {
      var phase = getPhase();
      if (phase.type !== "DRAGGING") {
        cancel();
        return;
      }
      phase.hasMoved = true;
      var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
      var point2 = {
        x: clientX,
        y: clientY
      };
      event.preventDefault();
      phase.actions.move(point2);
    }
  }, {
    eventName: "touchend",
    fn: function fn2(event) {
      var phase = getPhase();
      if (phase.type !== "DRAGGING") {
        cancel();
        return;
      }
      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: "touchcancel",
    fn: function fn2(event) {
      if (getPhase().type !== "DRAGGING") {
        cancel();
        return;
      }
      event.preventDefault();
      cancel();
    }
  }, {
    eventName: "touchforcechange",
    fn: function fn2(event) {
      var phase = getPhase();
      !(phase.type !== "IDLE") ? process.env.NODE_ENV !== "production" ? invariant$1() : invariant$1() : void 0;
      var touch = event.touches[0];
      if (!touch) {
        return;
      }
      var isForcePress = touch.force >= forcePressThreshold$1;
      if (!isForcePress) {
        return;
      }
      var shouldRespect = phase.actions.shouldRespectForcePress();
      if (phase.type === "PENDING") {
        if (shouldRespect) {
          cancel();
        }
        return;
      }
      if (shouldRespect) {
        if (phase.hasMoved) {
          event.preventDefault();
          return;
        }
        cancel();
        return;
      }
      event.preventDefault();
    }
  }, {
    eventName: supportedEventName$1,
    fn: cancel
  }];
}
function useTouchSensor$1(api) {
  var phaseRef = useRef(idle$2);
  var unbindEventsRef = useRef(noop$7);
  var getPhase = useCallback(function getPhase2() {
    return phaseRef.current;
  }, []);
  var setPhase = useCallback(function setPhase2(phase) {
    phaseRef.current = phase;
  }, []);
  var startCaptureBinding = useMemo(function() {
    return {
      eventName: "touchstart",
      fn: function onTouchStart(event) {
        if (event.defaultPrevented) {
          return;
        }
        var draggableId = api.findClosestDraggableId(event);
        if (!draggableId) {
          return;
        }
        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });
        if (!actions) {
          return;
        }
        var touch = event.touches[0];
        var clientX = touch.clientX, clientY = touch.clientY;
        var point2 = {
          x: clientX,
          y: clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point2);
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture2() {
    var options = {
      capture: true,
      passive: false
    };
    unbindEventsRef.current = bindEvents$1(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  var stop = useCallback(function() {
    var current = phaseRef.current;
    if (current.type === "IDLE") {
      return;
    }
    if (current.type === "PENDING") {
      clearTimeout(current.longPressTimerId);
    }
    setPhase(idle$2);
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture, setPhase]);
  var cancel = useCallback(function() {
    var phase = phaseRef.current;
    stop();
    if (phase.type === "DRAGGING") {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }
    if (phase.type === "PENDING") {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents2() {
    var options = {
      capture: true,
      passive: false
    };
    var args = {
      cancel,
      completed: stop,
      getPhase
    };
    var unbindTarget = bindEvents$1(window, getHandleBindings(args), options);
    var unbindWindow = bindEvents$1(window, getWindowBindings(args), options);
    unbindEventsRef.current = function unbindAll() {
      unbindTarget();
      unbindWindow();
    };
  }, [cancel, getPhase, stop]);
  var startDragging = useCallback(function startDragging2() {
    var phase = getPhase();
    !(phase.type === "PENDING") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot start dragging from phase " + phase.type) : invariant$1() : void 0;
    var actions = phase.actions.fluidLift(phase.point);
    setPhase({
      type: "DRAGGING",
      actions,
      hasMoved: false
    });
  }, [getPhase, setPhase]);
  var startPendingDrag = useCallback(function startPendingDrag2(actions, point2) {
    !(getPhase().type === "IDLE") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Expected to move from IDLE to PENDING drag") : invariant$1() : void 0;
    var longPressTimerId = setTimeout(startDragging, timeForLongPress$1);
    setPhase({
      type: "PENDING",
      point: point2,
      actions,
      longPressTimerId
    });
    bindCapturingEvents();
  }, [bindCapturingEvents, getPhase, setPhase, startDragging]);
  useIsomorphicLayoutEffect$5(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
      var phase = getPhase();
      if (phase.type === "PENDING") {
        clearTimeout(phase.longPressTimerId);
        setPhase(idle$2);
      }
    };
  }, [getPhase, listenForCapture, setPhase]);
  useIsomorphicLayoutEffect$5(function webkitHack() {
    var unbind = bindEvents$1(window, [{
      eventName: "touchmove",
      fn: function fn2() {
      },
      options: {
        capture: false,
        passive: false
      }
    }]);
    return unbind;
  }, []);
}
function useValidateSensorHooks(sensorHooks) {
  useDev(function() {
    var previousRef = usePrevious$2(sensorHooks);
    useDevSetupWarning(function() {
      !(previousRef.current.length === sensorHooks.length) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot change the amount of sensor hooks after mounting") : invariant$1(false) : void 0;
    });
  });
}
var interactiveTagNames$1 = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};
function isAnInteractiveElement$1(parent2, current) {
  if (current == null) {
    return false;
  }
  var hasAnInteractiveTag = Boolean(interactiveTagNames$1[current.tagName.toLowerCase()]);
  if (hasAnInteractiveTag) {
    return true;
  }
  var attribute = current.getAttribute("contenteditable");
  if (attribute === "true" || attribute === "") {
    return true;
  }
  if (current === parent2) {
    return false;
  }
  return isAnInteractiveElement$1(parent2, current.parentElement);
}
function isEventInInteractiveElement(draggable2, event) {
  var target = event.target;
  if (!isHtmlElement$1(target)) {
    return false;
  }
  return isAnInteractiveElement$1(draggable2, target);
}
var getBorderBoxCenterPosition$1 = function(el) {
  return getRect(el.getBoundingClientRect()).center;
};
function isElement$2(el) {
  return el instanceof getWindowFromEl$1(el).Element;
}
var supportedMatchesName = function() {
  var base2 = "matches";
  if (typeof document === "undefined") {
    return base2;
  }
  var candidates = [base2, "msMatchesSelector", "webkitMatchesSelector"];
  var value = find$3(candidates, function(name2) {
    return name2 in Element.prototype;
  });
  return value || base2;
}();
function closestPonyfill(el, selector2) {
  if (el == null) {
    return null;
  }
  if (el[supportedMatchesName](selector2)) {
    return el;
  }
  return closestPonyfill(el.parentElement, selector2);
}
function closest$1$1(el, selector2) {
  if (el.closest) {
    return el.closest(selector2);
  }
  return closestPonyfill(el, selector2);
}
function getSelector(contextId) {
  return "[" + dragHandle$1.contextId + '="' + contextId + '"]';
}
function findClosestDragHandleFromEvent(contextId, event) {
  var target = event.target;
  if (!isElement$2(target)) {
    process.env.NODE_ENV !== "production" ? warning$2("event.target must be a Element") : void 0;
    return null;
  }
  var selector2 = getSelector(contextId);
  var handle2 = closest$1$1(target, selector2);
  if (!handle2) {
    return null;
  }
  if (!isHtmlElement$1(handle2)) {
    process.env.NODE_ENV !== "production" ? warning$2("drag handle must be a HTMLElement") : void 0;
    return null;
  }
  return handle2;
}
function tryGetClosestDraggableIdFromEvent(contextId, event) {
  var handle2 = findClosestDragHandleFromEvent(contextId, event);
  if (!handle2) {
    return null;
  }
  return handle2.getAttribute(dragHandle$1.draggableId);
}
function findDraggable(contextId, draggableId) {
  var selector2 = "[" + draggable$1.contextId + '="' + contextId + '"]';
  var possible = toArray$1(document.querySelectorAll(selector2));
  var draggable$1$1 = find$3(possible, function(el) {
    return el.getAttribute(draggable$1.id) === draggableId;
  });
  if (!draggable$1$1) {
    return null;
  }
  if (!isHtmlElement$1(draggable$1$1)) {
    process.env.NODE_ENV !== "production" ? warning$2("Draggable element is not a HTMLElement") : void 0;
    return null;
  }
  return draggable$1$1;
}
function preventDefault$1(event) {
  event.preventDefault();
}
function _isActive(_ref) {
  var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
  if (!isLockActive()) {
    if (shouldWarn) {
      process.env.NODE_ENV !== "production" ? warning$2("\n        Cannot perform action.\n        The sensor no longer has an action lock.\n\n        Tips:\n\n        - Throw away your action handlers when forceStop() is called\n        - Check actions.isActive() if you really need to\n      ") : void 0;
    }
    return false;
  }
  if (expected !== phase) {
    if (shouldWarn) {
      process.env.NODE_ENV !== "production" ? warning$2("\n        Cannot perform action.\n        The actions you used belong to an outdated phase\n\n        Current phase: " + expected + "\n        You called an action from outdated phase: " + phase + "\n\n        Tips:\n\n        - Do not use preDragActions actions after calling preDragActions.lift()\n      ") : void 0;
    }
    return false;
  }
  return true;
}
function canStart(_ref2) {
  var lockAPI = _ref2.lockAPI, store = _ref2.store, registry2 = _ref2.registry, draggableId = _ref2.draggableId;
  if (lockAPI.isClaimed()) {
    return false;
  }
  var entry = registry2.draggable.findById(draggableId);
  if (!entry) {
    process.env.NODE_ENV !== "production" ? warning$2("Unable to find draggable with id: " + draggableId) : void 0;
    return false;
  }
  if (!entry.options.isEnabled) {
    return false;
  }
  if (!canStartDrag$1(store.getState(), draggableId)) {
    return false;
  }
  return true;
}
function tryStart(_ref3) {
  var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry2 = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
  var shouldStart = canStart({
    lockAPI,
    store,
    registry: registry2,
    draggableId
  });
  if (!shouldStart) {
    return null;
  }
  var entry = registry2.draggable.getById(draggableId);
  var el = findDraggable(contextId, entry.descriptor.id);
  if (!el) {
    process.env.NODE_ENV !== "production" ? warning$2("Unable to find draggable element with id: " + draggableId) : void 0;
    return null;
  }
  if (sourceEvent && !entry.options.canDragInteractiveElements && isEventInInteractiveElement(el, sourceEvent)) {
    return null;
  }
  var lock = lockAPI.claim(forceSensorStop || noop$7);
  var phase = "PRE_DRAG";
  function getShouldRespectForcePress() {
    return entry.options.shouldRespectForcePress;
  }
  function isLockActive() {
    return lockAPI.isActive(lock);
  }
  function tryDispatch(expected, getAction) {
    if (_isActive({
      expected,
      phase,
      isLockActive,
      shouldWarn: true
    })) {
      store.dispatch(getAction());
    }
  }
  var tryDispatchWhenDragging = tryDispatch.bind(null, "DRAGGING");
  function lift$12(args) {
    function completed() {
      lockAPI.release();
      phase = "COMPLETED";
    }
    if (phase !== "PRE_DRAG") {
      completed();
      !(phase === "PRE_DRAG") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot lift in phase " + phase) : invariant$1() : void 0;
    }
    store.dispatch(lift$4(args.liftActionArgs));
    phase = "DRAGGING";
    function finish4(reason, options) {
      if (options === void 0) {
        options = {
          shouldBlockNextClick: false
        };
      }
      args.cleanup();
      if (options.shouldBlockNextClick) {
        var unbind = bindEvents$1(window, [{
          eventName: "click",
          fn: preventDefault$1,
          options: {
            once: true,
            passive: false,
            capture: true
          }
        }]);
        setTimeout(unbind);
      }
      completed();
      store.dispatch(drop$2({
        reason
      }));
    }
    return _extends$6({
      isActive: function isActive2() {
        return _isActive({
          expected: "DRAGGING",
          phase,
          isLockActive,
          shouldWarn: false
        });
      },
      shouldRespectForcePress: getShouldRespectForcePress,
      drop: function drop8(options) {
        return finish4("DROP", options);
      },
      cancel: function cancel(options) {
        return finish4("CANCEL", options);
      }
    }, args.actions);
  }
  function fluidLift(clientSelection) {
    var move$1$1 = rafSchd(function(client2) {
      tryDispatchWhenDragging(function() {
        return move$1({
          client: client2
        });
      });
    });
    var api = lift$12({
      liftActionArgs: {
        id: draggableId,
        clientSelection,
        movementMode: "FLUID"
      },
      cleanup: function cleanup() {
        return move$1$1.cancel();
      },
      actions: {
        move: move$1$1
      }
    });
    return _extends$6({}, api, {
      move: move$1$1
    });
  }
  function snapLift() {
    var actions = {
      moveUp: function moveUp$1$1() {
        return tryDispatchWhenDragging(moveUp$1);
      },
      moveRight: function moveRight$1$1() {
        return tryDispatchWhenDragging(moveRight$1);
      },
      moveDown: function moveDown$1$1() {
        return tryDispatchWhenDragging(moveDown$1);
      },
      moveLeft: function moveLeft$1$1() {
        return tryDispatchWhenDragging(moveLeft$1);
      }
    };
    return lift$12({
      liftActionArgs: {
        id: draggableId,
        clientSelection: getBorderBoxCenterPosition$1(el),
        movementMode: "SNAP"
      },
      cleanup: noop$7,
      actions
    });
  }
  function abortPreDrag() {
    var shouldRelease = _isActive({
      expected: "PRE_DRAG",
      phase,
      isLockActive,
      shouldWarn: true
    });
    if (shouldRelease) {
      lockAPI.release();
    }
  }
  var preDrag = {
    isActive: function isActive2() {
      return _isActive({
        expected: "PRE_DRAG",
        phase,
        isLockActive,
        shouldWarn: false
      });
    },
    shouldRespectForcePress: getShouldRespectForcePress,
    fluidLift,
    snapLift,
    abort: abortPreDrag
  };
  return preDrag;
}
var defaultSensors$1 = [useMouseSensor$1, useKeyboardSensor$1, useTouchSensor$1];
function useSensorMarshal(_ref4) {
  var contextId = _ref4.contextId, store = _ref4.store, registry2 = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
  var useSensors2 = [].concat(enableDefaultSensors ? defaultSensors$1 : [], customSensors || []);
  var lockAPI = useState(function() {
    return create$2();
  })[0];
  var tryAbandonLock = useCallback(function tryAbandonLock2(previous2, current) {
    if (previous2.isDragging && !current.isDragging) {
      lockAPI.tryAbandon();
    }
  }, [lockAPI]);
  useIsomorphicLayoutEffect$5(function listenToStore() {
    var previous2 = store.getState();
    var unsubscribe = store.subscribe(function() {
      var current = store.getState();
      tryAbandonLock(previous2, current);
      previous2 = current;
    });
    return unsubscribe;
  }, [lockAPI, store, tryAbandonLock]);
  useIsomorphicLayoutEffect$5(function() {
    return lockAPI.tryAbandon;
  }, [lockAPI.tryAbandon]);
  var canGetLock = useCallback(function(draggableId) {
    return canStart({
      lockAPI,
      registry: registry2,
      store,
      draggableId
    });
  }, [lockAPI, registry2, store]);
  var tryGetLock = useCallback(function(draggableId, forceStop, options) {
    return tryStart({
      lockAPI,
      registry: registry2,
      contextId,
      store,
      draggableId,
      forceSensorStop: forceStop,
      sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
    });
  }, [contextId, lockAPI, registry2, store]);
  var findClosestDraggableId = useCallback(function(event) {
    return tryGetClosestDraggableIdFromEvent(contextId, event);
  }, [contextId]);
  var findOptionsForDraggable = useCallback(function(id) {
    var entry = registry2.draggable.findById(id);
    return entry ? entry.options : null;
  }, [registry2.draggable]);
  var tryReleaseLock = useCallback(function tryReleaseLock2() {
    if (!lockAPI.isClaimed()) {
      return;
    }
    lockAPI.tryAbandon();
    if (store.getState().phase !== "IDLE") {
      store.dispatch(flush());
    }
  }, [lockAPI, store]);
  var isLockClaimed = useCallback(lockAPI.isClaimed, [lockAPI]);
  var api = useMemo(function() {
    return {
      canGetLock,
      tryGetLock,
      findClosestDraggableId,
      findOptionsForDraggable,
      tryReleaseLock,
      isLockClaimed
    };
  }, [canGetLock, tryGetLock, findClosestDraggableId, findOptionsForDraggable, tryReleaseLock, isLockClaimed]);
  useValidateSensorHooks(useSensors2);
  for (var i = 0; i < useSensors2.length; i++) {
    useSensors2[i](api);
  }
}
var createResponders$1 = function createResponders(props) {
  return {
    onBeforeCapture: props.onBeforeCapture,
    onBeforeDragStart: props.onBeforeDragStart,
    onDragStart: props.onDragStart,
    onDragEnd: props.onDragEnd,
    onDragUpdate: props.onDragUpdate
  };
};
function getStore$1(lazyRef) {
  !lazyRef.current ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Could not find store from lazy ref") : invariant$1() : void 0;
  return lazyRef.current;
}
function App$1(props) {
  var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, dragHandleUsageInstructions2 = props.dragHandleUsageInstructions;
  var lazyStoreRef = useRef(null);
  useStartupValidation$1();
  var lastPropsRef = usePrevious$2(props);
  var getResponders = useCallback(function() {
    return createResponders$1(lastPropsRef.current);
  }, [lastPropsRef]);
  var announce2 = useAnnouncer$1(contextId);
  var dragHandleUsageInstructionsId = useHiddenTextElement({
    contextId,
    text: dragHandleUsageInstructions2
  });
  var styleMarshal = useStyleMarshal$1(contextId, nonce);
  var lazyDispatch = useCallback(function(action) {
    getStore$1(lazyStoreRef).dispatch(action);
  }, []);
  var marshalCallbacks = useMemo(function() {
    return bindActionCreators$1({
      publishWhileDragging: publishWhileDragging$2,
      updateDroppableScroll: updateDroppableScroll$1,
      updateDroppableIsEnabled: updateDroppableIsEnabled$1,
      updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled$1,
      collectionStarting: collectionStarting$1
    }, lazyDispatch);
  }, [lazyDispatch]);
  var registry2 = useRegistry();
  var dimensionMarshal = useMemo(function() {
    return createDimensionMarshal$1(registry2, marshalCallbacks);
  }, [registry2, marshalCallbacks]);
  var autoScroller = useMemo(function() {
    return createAutoScroller$1(_extends$6({
      scrollWindow: scrollWindow$1,
      scrollDroppable: dimensionMarshal.scrollDroppable
    }, bindActionCreators$1({
      move: move$1
    }, lazyDispatch)));
  }, [dimensionMarshal.scrollDroppable, lazyDispatch]);
  var focusMarshal = useFocusMarshal(contextId);
  var store = useMemo(function() {
    return createStore$1({
      announce: announce2,
      autoScroller,
      dimensionMarshal,
      focusMarshal,
      getResponders,
      styleMarshal
    });
  }, [announce2, autoScroller, dimensionMarshal, focusMarshal, getResponders, styleMarshal]);
  if (process.env.NODE_ENV !== "production") {
    if (lazyStoreRef.current && lazyStoreRef.current !== store) {
      process.env.NODE_ENV !== "production" ? warning$2("unexpected store change") : void 0;
    }
  }
  lazyStoreRef.current = store;
  var tryResetStore = useCallback(function() {
    var current = getStore$1(lazyStoreRef);
    var state = current.getState();
    if (state.phase !== "IDLE") {
      current.dispatch(flush());
    }
  }, []);
  var isDragging = useCallback(function() {
    var state = getStore$1(lazyStoreRef).getState();
    return state.isDragging || state.phase === "DROP_ANIMATING";
  }, []);
  var appCallbacks = useMemo(function() {
    return {
      isDragging,
      tryAbort: tryResetStore
    };
  }, [isDragging, tryResetStore]);
  setCallbacks(appCallbacks);
  var getCanLift = useCallback(function(id) {
    return canStartDrag$1(getStore$1(lazyStoreRef).getState(), id);
  }, []);
  var getIsMovementAllowed = useCallback(function() {
    return isMovementAllowed$1(getStore$1(lazyStoreRef).getState());
  }, []);
  var appContext = useMemo(function() {
    return {
      marshal: dimensionMarshal,
      focus: focusMarshal,
      contextId,
      canLift: getCanLift,
      isMovementAllowed: getIsMovementAllowed,
      dragHandleUsageInstructionsId,
      registry: registry2
    };
  }, [contextId, dimensionMarshal, dragHandleUsageInstructionsId, focusMarshal, getCanLift, getIsMovementAllowed, registry2]);
  useSensorMarshal({
    contextId,
    store,
    registry: registry2,
    customSensors: sensors,
    enableDefaultSensors: props.enableDefaultSensors !== false
  });
  useEffect(function() {
    return tryResetStore;
  }, [tryResetStore]);
  return React__default.createElement(AppContext$1.Provider, {
    value: appContext
  }, React__default.createElement(Provider$1, {
    context: StoreContext$1,
    store
  }, props.children));
}
var count$1$1 = 0;
function useInstanceCount() {
  return useMemo(function() {
    return "" + count$1$1++;
  }, []);
}
function DragDropContext$1(props) {
  var contextId = useInstanceCount();
  var dragHandleUsageInstructions2 = props.dragHandleUsageInstructions || preset$1.dragHandleUsageInstructions;
  return React__default.createElement(ErrorBoundary$1, null, function(setCallbacks) {
    return React__default.createElement(App$1, {
      nonce: props.nonce,
      contextId,
      setCallbacks,
      dragHandleUsageInstructions: dragHandleUsageInstructions2,
      enableDefaultSensors: props.enableDefaultSensors,
      sensors: props.sensors,
      onBeforeCapture: props.onBeforeCapture,
      onBeforeDragStart: props.onBeforeDragStart,
      onDragStart: props.onDragStart,
      onDragUpdate: props.onDragUpdate,
      onDragEnd: props.onDragEnd
    }, props.children);
  });
}
var isEqual$1$2 = function isEqual2(base2) {
  return function(value) {
    return base2 === value;
  };
};
var isScroll$1 = isEqual$1$2("scroll");
var isAuto$1 = isEqual$1$2("auto");
var isVisible$1$1 = isEqual$1$2("visible");
var isEither$1 = function isEither(overflow2, fn2) {
  return fn2(overflow2.overflowX) || fn2(overflow2.overflowY);
};
var isBoth$1 = function isBoth(overflow2, fn2) {
  return fn2(overflow2.overflowX) && fn2(overflow2.overflowY);
};
var isElementScrollable$1 = function isElementScrollable(el) {
  var style3 = window.getComputedStyle(el);
  var overflow2 = {
    overflowX: style3.overflowX,
    overflowY: style3.overflowY
  };
  return isEither$1(overflow2, isScroll$1) || isEither$1(overflow2, isAuto$1);
};
var isBodyScrollable$1 = function isBodyScrollable() {
  if (process.env.NODE_ENV === "production") {
    return false;
  }
  var body = getBodyElement$1();
  var html2 = document.documentElement;
  !html2 ? process.env.NODE_ENV !== "production" ? invariant$1() : invariant$1() : void 0;
  if (!isElementScrollable$1(body)) {
    return false;
  }
  var htmlStyle = window.getComputedStyle(html2);
  var htmlOverflow = {
    overflowX: htmlStyle.overflowX,
    overflowY: htmlStyle.overflowY
  };
  if (isBoth$1(htmlOverflow, isVisible$1$1)) {
    return false;
  }
  process.env.NODE_ENV !== "production" ? warning$2("\n    We have detected that your <body> element might be a scroll container.\n    We have found no reliable way of detecting whether the <body> element is a scroll container.\n    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)\n\n    Because we cannot determine if the <body> is a scroll container, and generally it is not one,\n    we will be treating the <body> as *not* a scroll container\n\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md\n  ") : void 0;
  return false;
};
var getClosestScrollable$1 = function getClosestScrollable(el) {
  if (el == null) {
    return null;
  }
  if (el === document.body) {
    return isBodyScrollable$1() ? el : null;
  }
  if (el === document.documentElement) {
    return null;
  }
  if (!isElementScrollable$1(el)) {
    return getClosestScrollable(el.parentElement);
  }
  return el;
};
var checkForNestedScrollContainers$1 = function(scrollable) {
  if (!scrollable) {
    return;
  }
  var anotherScrollParent = getClosestScrollable$1(scrollable.parentElement);
  if (!anotherScrollParent) {
    return;
  }
  process.env.NODE_ENV !== "production" ? warning$2("\n    Droppable: unsupported nested scroll container detected.\n    A Droppable can only have one scroll parent (which can be itself)\n    Nested scroll containers are currently not supported.\n\n    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131\n  ") : void 0;
};
var getScroll$1$1 = function(el) {
  return {
    x: el.scrollLeft,
    y: el.scrollTop
  };
};
var getIsFixed$1 = function getIsFixed(el) {
  if (!el) {
    return false;
  }
  var style3 = window.getComputedStyle(el);
  if (style3.position === "fixed") {
    return true;
  }
  return getIsFixed(el.parentElement);
};
var getEnv$1 = function(start4) {
  var closestScrollable = getClosestScrollable$1(start4);
  var isFixedOnPage = getIsFixed$1(start4);
  return {
    closestScrollable,
    isFixedOnPage
  };
};
var getDroppableDimension$1 = function(_ref) {
  var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client2 = _ref.client, page = _ref.page, closest4 = _ref.closest;
  var frame = function() {
    if (!closest4) {
      return null;
    }
    var scrollSize = closest4.scrollSize, frameClient = closest4.client;
    var maxScroll = getMaxScroll$1({
      scrollHeight: scrollSize.scrollHeight,
      scrollWidth: scrollSize.scrollWidth,
      height: frameClient.paddingBox.height,
      width: frameClient.paddingBox.width
    });
    return {
      pageMarginBox: closest4.page.marginBox,
      frameClient,
      scrollSize,
      shouldClipSubject: closest4.shouldClipSubject,
      scroll: {
        initial: closest4.scroll,
        current: closest4.scroll,
        max: maxScroll,
        diff: {
          value: origin$1,
          displacement: origin$1
        }
      }
    };
  }();
  var axis = direction === "vertical" ? vertical$1 : horizontal$1;
  var subject = getSubject$1({
    page,
    withPlaceholder: null,
    axis,
    frame
  });
  var dimension = {
    descriptor,
    isCombineEnabled,
    isFixedOnPage,
    axis,
    isEnabled,
    client: client2,
    page,
    frame,
    subject
  };
  return dimension;
};
var getClient$1 = function getClient(targetRef, closestScrollable) {
  var base2 = getBox(targetRef);
  if (!closestScrollable) {
    return base2;
  }
  if (targetRef !== closestScrollable) {
    return base2;
  }
  var top2 = base2.paddingBox.top - closestScrollable.scrollTop;
  var left2 = base2.paddingBox.left - closestScrollable.scrollLeft;
  var bottom2 = top2 + closestScrollable.scrollHeight;
  var right2 = left2 + closestScrollable.scrollWidth;
  var paddingBox = {
    top: top2,
    right: right2,
    bottom: bottom2,
    left: left2
  };
  var borderBox = expand(paddingBox, base2.border);
  var client2 = createBox({
    borderBox,
    margin: base2.margin,
    border: base2.border,
    padding: base2.padding
  });
  return client2;
};
var getDimension$2 = function(_ref) {
  var ref2 = _ref.ref, descriptor = _ref.descriptor, env2 = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
  var closestScrollable = env2.closestScrollable;
  var client2 = getClient$1(ref2, closestScrollable);
  var page = withScroll(client2, windowScroll);
  var closest4 = function() {
    if (!closestScrollable) {
      return null;
    }
    var frameClient = getBox(closestScrollable);
    var scrollSize = {
      scrollHeight: closestScrollable.scrollHeight,
      scrollWidth: closestScrollable.scrollWidth
    };
    return {
      client: frameClient,
      page: withScroll(frameClient, windowScroll),
      scroll: getScroll$1$1(closestScrollable),
      scrollSize,
      shouldClipSubject
    };
  }();
  var dimension = getDroppableDimension$1({
    descriptor,
    isEnabled: !isDropDisabled,
    isCombineEnabled,
    isFixedOnPage: env2.isFixedOnPage,
    direction,
    client: client2,
    page,
    closest: closest4
  });
  return dimension;
};
var immediate$1 = {
  passive: false
};
var delayed$1 = {
  passive: true
};
var getListenerOptions$1 = function(options) {
  return options.shouldPublishImmediately ? immediate$1 : delayed$1;
};
function useRequiredContext$1(Context2) {
  var result = useContext(Context2);
  !result ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Could not find required context") : invariant$1() : void 0;
  return result;
}
var getClosestScrollableFromDrag$1 = function getClosestScrollableFromDrag(dragging) {
  return dragging && dragging.env.closestScrollable || null;
};
function useDroppablePublisher(args) {
  var whileDraggingRef = useRef(null);
  var appContext = useRequiredContext$1(AppContext$1);
  var uniqueId2 = useUniqueId$1("droppable");
  var registry2 = appContext.registry, marshal = appContext.marshal;
  var previousRef = usePrevious$2(args);
  var descriptor = useMemo(function() {
    return {
      id: args.droppableId,
      type: args.type,
      mode: args.mode
    };
  }, [args.droppableId, args.mode, args.type]);
  var publishedDescriptorRef = useRef(descriptor);
  var memoizedUpdateScroll = useMemo(function() {
    return memoizeOne(function(x2, y2) {
      !whileDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Can only update scroll when dragging") : invariant$1() : void 0;
      var scroll5 = {
        x: x2,
        y: y2
      };
      marshal.updateDroppableScroll(descriptor.id, scroll5);
    });
  }, [descriptor.id, marshal]);
  var getClosestScroll = useCallback(function() {
    var dragging = whileDraggingRef.current;
    if (!dragging || !dragging.env.closestScrollable) {
      return origin$1;
    }
    return getScroll$1$1(dragging.env.closestScrollable);
  }, []);
  var updateScroll = useCallback(function() {
    var scroll5 = getClosestScroll();
    memoizedUpdateScroll(scroll5.x, scroll5.y);
  }, [getClosestScroll, memoizedUpdateScroll]);
  var scheduleScrollUpdate = useMemo(function() {
    return rafSchd(updateScroll);
  }, [updateScroll]);
  var onClosestScroll = useCallback(function() {
    var dragging = whileDraggingRef.current;
    var closest4 = getClosestScrollableFromDrag$1(dragging);
    !(dragging && closest4) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Could not find scroll options while scrolling") : invariant$1() : void 0;
    var options = dragging.scrollOptions;
    if (options.shouldPublishImmediately) {
      updateScroll();
      return;
    }
    scheduleScrollUpdate();
  }, [scheduleScrollUpdate, updateScroll]);
  var getDimensionAndWatchScroll = useCallback(function(windowScroll, options) {
    !!whileDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot collect a droppable while a drag is occurring") : invariant$1() : void 0;
    var previous2 = previousRef.current;
    var ref2 = previous2.getDroppableRef();
    !ref2 ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot collect without a droppable ref") : invariant$1() : void 0;
    var env2 = getEnv$1(ref2);
    var dragging = {
      ref: ref2,
      descriptor,
      env: env2,
      scrollOptions: options
    };
    whileDraggingRef.current = dragging;
    var dimension = getDimension$2({
      ref: ref2,
      descriptor,
      env: env2,
      windowScroll,
      direction: previous2.direction,
      isDropDisabled: previous2.isDropDisabled,
      isCombineEnabled: previous2.isCombineEnabled,
      shouldClipSubject: !previous2.ignoreContainerClipping
    });
    var scrollable = env2.closestScrollable;
    if (scrollable) {
      scrollable.setAttribute(scrollContainer.contextId, appContext.contextId);
      scrollable.addEventListener("scroll", onClosestScroll, getListenerOptions$1(dragging.scrollOptions));
      if (process.env.NODE_ENV !== "production") {
        checkForNestedScrollContainers$1(scrollable);
      }
    }
    return dimension;
  }, [appContext.contextId, descriptor, onClosestScroll, previousRef]);
  var getScrollWhileDragging = useCallback(function() {
    var dragging = whileDraggingRef.current;
    var closest4 = getClosestScrollableFromDrag$1(dragging);
    !(dragging && closest4) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Can only recollect Droppable client for Droppables that have a scroll container") : invariant$1() : void 0;
    return getScroll$1$1(closest4);
  }, []);
  var dragStopped = useCallback(function() {
    var dragging = whileDraggingRef.current;
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot stop drag when no active drag") : invariant$1() : void 0;
    var closest4 = getClosestScrollableFromDrag$1(dragging);
    whileDraggingRef.current = null;
    if (!closest4) {
      return;
    }
    scheduleScrollUpdate.cancel();
    closest4.removeAttribute(scrollContainer.contextId);
    closest4.removeEventListener("scroll", onClosestScroll, getListenerOptions$1(dragging.scrollOptions));
  }, [onClosestScroll, scheduleScrollUpdate]);
  var scroll4 = useCallback(function(change) {
    var dragging = whileDraggingRef.current;
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot scroll when there is no drag") : invariant$1() : void 0;
    var closest4 = getClosestScrollableFromDrag$1(dragging);
    !closest4 ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot scroll a droppable with no closest scrollable") : invariant$1() : void 0;
    closest4.scrollTop += change.y;
    closest4.scrollLeft += change.x;
  }, []);
  var callbacks = useMemo(function() {
    return {
      getDimensionAndWatchScroll,
      getScrollWhileDragging,
      dragStopped,
      scroll: scroll4
    };
  }, [dragStopped, getDimensionAndWatchScroll, getScrollWhileDragging, scroll4]);
  var entry = useMemo(function() {
    return {
      uniqueId: uniqueId2,
      descriptor,
      callbacks
    };
  }, [callbacks, descriptor, uniqueId2]);
  useIsomorphicLayoutEffect$5(function() {
    publishedDescriptorRef.current = entry.descriptor;
    registry2.droppable.register(entry);
    return function() {
      if (whileDraggingRef.current) {
        process.env.NODE_ENV !== "production" ? warning$2("Unsupported: changing the droppableId or type of a Droppable during a drag") : void 0;
        dragStopped();
      }
      registry2.droppable.unregister(entry);
    };
  }, [callbacks, descriptor, dragStopped, entry, marshal, registry2.droppable]);
  useIsomorphicLayoutEffect$5(function() {
    if (!whileDraggingRef.current) {
      return;
    }
    marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
  }, [args.isDropDisabled, marshal]);
  useIsomorphicLayoutEffect$5(function() {
    if (!whileDraggingRef.current) {
      return;
    }
    marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
  }, [args.isCombineEnabled, marshal]);
}
function noop$2$2() {
}
var empty$4 = {
  width: 0,
  height: 0,
  margin: noSpacing$1
};
var getSize$1 = function getSize(_ref) {
  var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder2 = _ref.placeholder, animate = _ref.animate;
  if (isAnimatingOpenOnMount) {
    return empty$4;
  }
  if (animate === "close") {
    return empty$4;
  }
  return {
    height: placeholder2.client.borderBox.height,
    width: placeholder2.client.borderBox.width,
    margin: placeholder2.client.margin
  };
};
var getStyle$2 = function getStyle(_ref2) {
  var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder2 = _ref2.placeholder, animate = _ref2.animate;
  var size2 = getSize$1({
    isAnimatingOpenOnMount,
    placeholder: placeholder2,
    animate
  });
  return {
    display: placeholder2.display,
    boxSizing: "border-box",
    width: size2.width,
    height: size2.height,
    marginTop: size2.margin.top,
    marginRight: size2.margin.right,
    marginBottom: size2.margin.bottom,
    marginLeft: size2.margin.left,
    flexShrink: "0",
    flexGrow: "0",
    pointerEvents: "none",
    transition: animate !== "none" ? transitions$1.placeholder : null
  };
};
function Placeholder$3(props) {
  var animateOpenTimerRef = useRef(null);
  var tryClearAnimateOpenTimer = useCallback(function() {
    if (!animateOpenTimerRef.current) {
      return;
    }
    clearTimeout(animateOpenTimerRef.current);
    animateOpenTimerRef.current = null;
  }, []);
  var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
  var _useState = useState(props.animate === "open"), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
  useEffect(function() {
    if (!isAnimatingOpenOnMount) {
      return noop$2$2;
    }
    if (animate !== "open") {
      tryClearAnimateOpenTimer();
      setIsAnimatingOpenOnMount(false);
      return noop$2$2;
    }
    if (animateOpenTimerRef.current) {
      return noop$2$2;
    }
    animateOpenTimerRef.current = setTimeout(function() {
      animateOpenTimerRef.current = null;
      setIsAnimatingOpenOnMount(false);
    });
    return tryClearAnimateOpenTimer;
  }, [animate, isAnimatingOpenOnMount, tryClearAnimateOpenTimer]);
  var onSizeChangeEnd = useCallback(function(event) {
    if (event.propertyName !== "height") {
      return;
    }
    onTransitionEnd();
    if (animate === "close") {
      onClose();
    }
  }, [animate, onClose, onTransitionEnd]);
  var style3 = getStyle$2({
    isAnimatingOpenOnMount,
    animate: props.animate,
    placeholder: props.placeholder
  });
  return React__default.createElement(props.placeholder.tagName, {
    style: style3,
    "data-rbd-placeholder-context-id": contextId,
    onTransitionEnd: onSizeChangeEnd,
    ref: props.innerRef
  });
}
var Placeholder$1$2 = React__default.memo(Placeholder$3);
var DroppableContext$1 = React__default.createContext(null);
function checkIsValidInnerRef$1(el) {
  !(el && isHtmlElement$1(el)) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "\n    provided.innerRef has not been provided with a HTMLElement.\n\n    You can find a guide on using the innerRef callback functions at:\n    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md\n  ") : invariant$1() : void 0;
}
function isBoolean$1(value) {
  return typeof value === "boolean";
}
function runChecks(args, checks2) {
  checks2.forEach(function(check) {
    return check(args);
  });
}
var shared = [function required(_ref) {
  var props = _ref.props;
  !props.droppableId ? process.env.NODE_ENV !== "production" ? invariant$1(false, "A Droppable requires a droppableId prop") : invariant$1() : void 0;
  !(typeof props.droppableId === "string") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "A Droppable requires a [string] droppableId. Provided: [" + typeof props.droppableId + "]") : invariant$1() : void 0;
}, function _boolean(_ref2) {
  var props = _ref2.props;
  !isBoolean$1(props.isDropDisabled) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "isDropDisabled must be a boolean") : invariant$1() : void 0;
  !isBoolean$1(props.isCombineEnabled) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "isCombineEnabled must be a boolean") : invariant$1() : void 0;
  !isBoolean$1(props.ignoreContainerClipping) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "ignoreContainerClipping must be a boolean") : invariant$1() : void 0;
}, function ref(_ref3) {
  var getDroppableRef = _ref3.getDroppableRef;
  checkIsValidInnerRef$1(getDroppableRef());
}];
var standard = [function placeholder(_ref4) {
  var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
  if (!props.placeholder) {
    return;
  }
  var ref2 = getPlaceholderRef();
  if (ref2) {
    return;
  }
  process.env.NODE_ENV !== "production" ? warning$2('\n      Droppable setup issue [droppableId: "' + props.droppableId + '"]:\n      DroppableProvided > placeholder could not be found.\n\n      Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.\n      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md\n    ') : void 0;
}];
var virtual = [function hasClone(_ref5) {
  var props = _ref5.props;
  !props.renderClone ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Must provide a clone render function (renderClone) for virtual lists") : invariant$1() : void 0;
}, function hasNoPlaceholder(_ref6) {
  var getPlaceholderRef = _ref6.getPlaceholderRef;
  !!getPlaceholderRef() ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Expected virtual list to not have a placeholder") : invariant$1() : void 0;
}];
function useValidation$3(args) {
  useDevSetupWarning(function() {
    runChecks(args, shared);
    if (args.props.mode === "standard") {
      runChecks(args, standard);
    }
    if (args.props.mode === "virtual") {
      runChecks(args, virtual);
    }
  });
}
var AnimateInOut$1 = function(_React$PureComponent) {
  _inheritsLoose$2(AnimateInOut2, _React$PureComponent);
  function AnimateInOut2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      isVisible: Boolean(_this.props.on),
      data: _this.props.on,
      animate: _this.props.shouldAnimate && _this.props.on ? "open" : "none"
    };
    _this.onClose = function() {
      if (_this.state.animate !== "close") {
        return;
      }
      _this.setState({
        isVisible: false
      });
    };
    return _this;
  }
  AnimateInOut2.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (!props.shouldAnimate) {
      return {
        isVisible: Boolean(props.on),
        data: props.on,
        animate: "none"
      };
    }
    if (props.on) {
      return {
        isVisible: true,
        data: props.on,
        animate: "open"
      };
    }
    if (state.isVisible) {
      return {
        isVisible: true,
        data: state.data,
        animate: "close"
      };
    }
    return {
      isVisible: false,
      animate: "close",
      data: null
    };
  };
  var _proto = AnimateInOut2.prototype;
  _proto.render = function render() {
    if (!this.state.isVisible) {
      return null;
    }
    var provided = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(provided);
  };
  return AnimateInOut2;
}(React__default.PureComponent);
var zIndexOptions$1 = {
  dragging: 5e3,
  dropAnimating: 4500
};
var getDraggingTransition$1 = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
  if (dropping) {
    return transitions$1.drop(dropping.duration);
  }
  if (shouldAnimateDragMovement) {
    return transitions$1.snap;
  }
  return transitions$1.fluid;
};
var getDraggingOpacity$1 = function getDraggingOpacity(isCombining, isDropAnimating) {
  if (!isCombining) {
    return null;
  }
  return isDropAnimating ? combine$2.opacity.drop : combine$2.opacity.combining;
};
var getShouldDraggingAnimate$1 = function getShouldDraggingAnimate(dragging) {
  if (dragging.forceShouldAnimate != null) {
    return dragging.forceShouldAnimate;
  }
  return dragging.mode === "SNAP";
};
function getDraggingStyle$1(dragging) {
  var dimension = dragging.dimension;
  var box = dimension.client;
  var offset3 = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
  var isCombining = Boolean(combineWith);
  var shouldAnimate = getShouldDraggingAnimate$1(dragging);
  var isDropAnimating = Boolean(dropping);
  var transform = isDropAnimating ? transforms$2.drop(offset3, isCombining) : transforms$2.moveTo(offset3);
  var style3 = {
    position: "fixed",
    top: box.marginBox.top,
    left: box.marginBox.left,
    boxSizing: "border-box",
    width: box.borderBox.width,
    height: box.borderBox.height,
    transition: getDraggingTransition$1(shouldAnimate, dropping),
    transform,
    opacity: getDraggingOpacity$1(isCombining, isDropAnimating),
    zIndex: isDropAnimating ? zIndexOptions$1.dropAnimating : zIndexOptions$1.dragging,
    pointerEvents: "none"
  };
  return style3;
}
function getSecondaryStyle$1(secondary) {
  return {
    transform: transforms$2.moveTo(secondary.offset),
    transition: secondary.shouldAnimateDisplacement ? null : "none"
  };
}
function getStyle$1$1(mapped) {
  return mapped.type === "DRAGGING" ? getDraggingStyle$1(mapped) : getSecondaryStyle$1(mapped);
}
function getDimension$1$1(descriptor, el, windowScroll) {
  if (windowScroll === void 0) {
    windowScroll = origin$1;
  }
  var computedStyles = window.getComputedStyle(el);
  var borderBox = el.getBoundingClientRect();
  var client2 = calculateBox(borderBox, computedStyles);
  var page = withScroll(client2, windowScroll);
  var placeholder2 = {
    client: client2,
    tagName: el.tagName.toLowerCase(),
    display: computedStyles.display
  };
  var displaceBy = {
    x: client2.marginBox.width,
    y: client2.marginBox.height
  };
  var dimension = {
    descriptor,
    placeholder: placeholder2,
    displaceBy,
    client: client2,
    page
  };
  return dimension;
}
function useDraggablePublisher(args) {
  var uniqueId2 = useUniqueId$1("draggable");
  var descriptor = args.descriptor, registry2 = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
  var options = useMemo(function() {
    return {
      canDragInteractiveElements,
      shouldRespectForcePress,
      isEnabled
    };
  }, [canDragInteractiveElements, isEnabled, shouldRespectForcePress]);
  var getDimension2 = useCallback(function(windowScroll) {
    var el = getDraggableRef();
    !el ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Cannot get dimension when no ref is set") : invariant$1() : void 0;
    return getDimension$1$1(descriptor, el, windowScroll);
  }, [descriptor, getDraggableRef]);
  var entry = useMemo(function() {
    return {
      uniqueId: uniqueId2,
      descriptor,
      options,
      getDimension: getDimension2
    };
  }, [descriptor, getDimension2, options, uniqueId2]);
  var publishedRef = useRef(entry);
  var isFirstPublishRef = useRef(true);
  useIsomorphicLayoutEffect$5(function() {
    registry2.draggable.register(publishedRef.current);
    return function() {
      return registry2.draggable.unregister(publishedRef.current);
    };
  }, [registry2.draggable]);
  useIsomorphicLayoutEffect$5(function() {
    if (isFirstPublishRef.current) {
      isFirstPublishRef.current = false;
      return;
    }
    var last = publishedRef.current;
    publishedRef.current = entry;
    registry2.draggable.update(entry, last);
  }, [entry, registry2.draggable]);
}
function useValidation$1$1(props, contextId, getRef) {
  useDevSetupWarning(function() {
    function prefix2(id2) {
      return "Draggable[id: " + id2 + "]: ";
    }
    var id = props.draggableId;
    !id ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Draggable requires a draggableId") : invariant$1(false) : void 0;
    !(typeof id === "string") ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Draggable requires a [string] draggableId.\n      Provided: [type: " + typeof id + "] (value: " + id + ")") : invariant$1(false) : void 0;
    !isInteger$2(props.index) ? process.env.NODE_ENV !== "production" ? invariant$1(false, prefix2(id) + " requires an integer index prop") : invariant$1(false) : void 0;
    if (props.mapped.type === "DRAGGING") {
      return;
    }
    checkIsValidInnerRef$1(getRef());
    if (props.isEnabled) {
      !findDragHandle(contextId, id) ? process.env.NODE_ENV !== "production" ? invariant$1(false, prefix2(id) + " Unable to find drag handle") : invariant$1(false) : void 0;
    }
  });
}
function useClonePropValidation(isClone) {
  useDev(function() {
    var initialRef = useRef(isClone);
    useDevSetupWarning(function() {
      !(isClone === initialRef.current) ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Draggable isClone prop value changed during component life") : invariant$1(false) : void 0;
    }, [isClone]);
  });
}
function preventHtml5Dnd$1(event) {
  event.preventDefault();
}
function Draggable$1(props) {
  var ref2 = useRef(null);
  var setRef = useCallback(function(el) {
    ref2.current = el;
  }, []);
  var getRef = useCallback(function() {
    return ref2.current;
  }, []);
  var _useRequiredContext = useRequiredContext$1(AppContext$1), contextId = _useRequiredContext.contextId, dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId, registry2 = _useRequiredContext.registry;
  var _useRequiredContext2 = useRequiredContext$1(DroppableContext$1), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
  var descriptor = useMemo(function() {
    return {
      id: props.draggableId,
      index: props.index,
      type,
      droppableId
    };
  }, [props.draggableId, props.index, type, droppableId]);
  var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
  useValidation$1$1(props, contextId, getRef);
  useClonePropValidation(isClone);
  if (!isClone) {
    var forPublisher = useMemo(function() {
      return {
        descriptor,
        registry: registry2,
        getDraggableRef: getRef,
        canDragInteractiveElements,
        shouldRespectForcePress,
        isEnabled
      };
    }, [descriptor, registry2, getRef, canDragInteractiveElements, shouldRespectForcePress, isEnabled]);
    useDraggablePublisher(forPublisher);
  }
  var dragHandleProps = useMemo(function() {
    return isEnabled ? {
      tabIndex: 0,
      role: "button",
      "aria-describedby": dragHandleUsageInstructionsId,
      "data-rbd-drag-handle-draggable-id": draggableId,
      "data-rbd-drag-handle-context-id": contextId,
      draggable: false,
      onDragStart: preventHtml5Dnd$1
    } : null;
  }, [contextId, dragHandleUsageInstructionsId, draggableId, isEnabled]);
  var onMoveEnd = useCallback(function(event) {
    if (mapped.type !== "DRAGGING") {
      return;
    }
    if (!mapped.dropping) {
      return;
    }
    if (event.propertyName !== "transform") {
      return;
    }
    dropAnimationFinishedAction();
  }, [dropAnimationFinishedAction, mapped]);
  var provided = useMemo(function() {
    var style3 = getStyle$1$1(mapped);
    var onTransitionEnd = mapped.type === "DRAGGING" && mapped.dropping ? onMoveEnd : null;
    var result = {
      innerRef: setRef,
      draggableProps: {
        "data-rbd-draggable-context-id": contextId,
        "data-rbd-draggable-id": draggableId,
        style: style3,
        onTransitionEnd
      },
      dragHandleProps
    };
    return result;
  }, [contextId, dragHandleProps, draggableId, mapped, onMoveEnd, setRef]);
  var rubric = useMemo(function() {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  }, [descriptor.droppableId, descriptor.id, descriptor.index, descriptor.type]);
  return children(provided, mapped.snapshot, rubric);
}
var isStrictEqual$1 = function(a2, b2) {
  return a2 === b2;
};
var whatIsDraggedOverFromResult$1 = function(result) {
  var combine2 = result.combine, destination = result.destination;
  if (destination) {
    return destination.droppableId;
  }
  if (combine2) {
    return combine2.droppableId;
  }
  return null;
};
var getCombineWithFromResult$1 = function getCombineWithFromResult(result) {
  return result.combine ? result.combine.draggableId : null;
};
var getCombineWithFromImpact$1 = function getCombineWithFromImpact(impact) {
  return impact.at && impact.at.type === "COMBINE" ? impact.at.combine.draggableId : null;
};
function getDraggableSelector() {
  var memoizedOffset = memoizeOne(function(x2, y2) {
    return {
      x: x2,
      y: y2
    };
  });
  var getMemoizedSnapshot = memoizeOne(function(mode, isClone, draggingOver, combineWith, dropping) {
    return {
      isDragging: true,
      isClone,
      isDropAnimating: Boolean(dropping),
      dropAnimation: dropping,
      mode,
      draggingOver,
      combineWith,
      combineTargetFor: null
    };
  });
  var getMemoizedProps = memoizeOne(function(offset3, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
    return {
      mapped: {
        type: "DRAGGING",
        dropping: null,
        draggingOver,
        combineWith,
        mode,
        offset: offset3,
        dimension,
        forceShouldAnimate,
        snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
      }
    };
  });
  var selector2 = function selector3(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id !== ownProps.draggableId) {
        return null;
      }
      var offset3 = state.current.client.offset;
      var dimension = state.dimensions.draggables[ownProps.draggableId];
      var draggingOver = whatIsDraggedOver$1(state.impact);
      var combineWith = getCombineWithFromImpact$1(state.impact);
      var forceShouldAnimate = state.forceShouldAnimate;
      return getMemoizedProps(memoizedOffset(offset3.x, offset3.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
    }
    if (state.phase === "DROP_ANIMATING") {
      var completed = state.completed;
      if (completed.result.draggableId !== ownProps.draggableId) {
        return null;
      }
      var isClone = ownProps.isClone;
      var _dimension = state.dimensions.draggables[ownProps.draggableId];
      var result = completed.result;
      var mode = result.mode;
      var _draggingOver = whatIsDraggedOverFromResult$1(result);
      var _combineWith = getCombineWithFromResult$1(result);
      var duration = state.dropDuration;
      var dropping = {
        duration,
        curve: curves$1.drop,
        moveTo: state.newHomeClientOffset,
        opacity: _combineWith ? combine$2.opacity.drop : null,
        scale: _combineWith ? combine$2.scale.drop : null
      };
      return {
        mapped: {
          type: "DRAGGING",
          offset: state.newHomeClientOffset,
          dimension: _dimension,
          dropping,
          draggingOver: _draggingOver,
          combineWith: _combineWith,
          mode,
          forceShouldAnimate: null,
          snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
        }
      };
    }
    return null;
  };
  return selector2;
}
function getSecondarySnapshot(combineTargetFor) {
  return {
    isDragging: false,
    isDropAnimating: false,
    isClone: false,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor,
    combineWith: null
  };
}
var atRest = {
  mapped: {
    type: "SECONDARY",
    offset: origin$1,
    combineTargetFor: null,
    shouldAnimateDisplacement: true,
    snapshot: getSecondarySnapshot(null)
  }
};
function getSecondarySelector() {
  var memoizedOffset = memoizeOne(function(x2, y2) {
    return {
      x: x2,
      y: y2
    };
  });
  var getMemoizedSnapshot = memoizeOne(getSecondarySnapshot);
  var getMemoizedProps = memoizeOne(function(offset3, combineTargetFor, shouldAnimateDisplacement) {
    if (combineTargetFor === void 0) {
      combineTargetFor = null;
    }
    return {
      mapped: {
        type: "SECONDARY",
        offset: offset3,
        combineTargetFor,
        shouldAnimateDisplacement,
        snapshot: getMemoizedSnapshot(combineTargetFor)
      }
    };
  });
  var getFallback = function getFallback2(combineTargetFor) {
    return combineTargetFor ? getMemoizedProps(origin$1, combineTargetFor, true) : null;
  };
  var getProps = function getProps2(ownId, draggingId, impact, afterCritical) {
    var visualDisplacement = impact.displaced.visible[ownId];
    var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
    var combine2 = tryGetCombine(impact);
    var combineTargetFor = combine2 && combine2.draggableId === ownId ? draggingId : null;
    if (!visualDisplacement) {
      if (!isAfterCriticalInVirtualList) {
        return getFallback(combineTargetFor);
      }
      if (impact.displaced.invisible[ownId]) {
        return null;
      }
      var change = negate$1(afterCritical.displacedBy.point);
      var _offset = memoizedOffset(change.x, change.y);
      return getMemoizedProps(_offset, combineTargetFor, true);
    }
    if (isAfterCriticalInVirtualList) {
      return getFallback(combineTargetFor);
    }
    var displaceBy = impact.displacedBy.point;
    var offset3 = memoizedOffset(displaceBy.x, displaceBy.y);
    return getMemoizedProps(offset3, combineTargetFor, visualDisplacement.shouldAnimate);
  };
  var selector2 = function selector3(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id === ownProps.draggableId) {
        return null;
      }
      return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
    }
    if (state.phase === "DROP_ANIMATING") {
      var completed = state.completed;
      if (completed.result.draggableId === ownProps.draggableId) {
        return null;
      }
      return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
    }
    return null;
  };
  return selector2;
}
var makeMapStateToProps$2 = function makeMapStateToProps() {
  var draggingSelector = getDraggableSelector();
  var secondarySelector = getSecondarySelector();
  var selector2 = function selector3(state, ownProps) {
    return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || atRest;
  };
  return selector2;
};
var mapDispatchToProps$2 = {
  dropAnimationFinished: dropAnimationFinished$1
};
var ConnectedDraggable$1 = connect(makeMapStateToProps$2, mapDispatchToProps$2, null, {
  context: StoreContext$1,
  pure: true,
  areStatePropsEqual: isStrictEqual$1
})(Draggable$1);
function PrivateDraggable(props) {
  var droppableContext = useRequiredContext$1(DroppableContext$1);
  var isUsingCloneFor = droppableContext.isUsingCloneFor;
  if (isUsingCloneFor === props.draggableId && !props.isClone) {
    return null;
  }
  return React__default.createElement(ConnectedDraggable$1, props);
}
function PublicDraggable(props) {
  var isEnabled = typeof props.isDragDisabled === "boolean" ? !props.isDragDisabled : true;
  var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
  var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
  return React__default.createElement(PrivateDraggable, _extends$6({}, props, {
    isClone: false,
    isEnabled,
    canDragInteractiveElements,
    shouldRespectForcePress
  }));
}
function Droppable$1(props) {
  var appContext = useContext(AppContext$1);
  !appContext ? process.env.NODE_ENV !== "production" ? invariant$1(false, "Could not find app context") : invariant$1() : void 0;
  var contextId = appContext.contextId, isMovementAllowed2 = appContext.isMovementAllowed;
  var droppableRef = useRef(null);
  var placeholderRef = useRef(null);
  var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll4 = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
  var getDroppableRef = useCallback(function() {
    return droppableRef.current;
  }, []);
  var setDroppableRef = useCallback(function(value) {
    droppableRef.current = value;
  }, []);
  var getPlaceholderRef = useCallback(function() {
    return placeholderRef.current;
  }, []);
  var setPlaceholderRef = useCallback(function(value) {
    placeholderRef.current = value;
  }, []);
  useValidation$3({
    props,
    getDroppableRef,
    getPlaceholderRef
  });
  var onPlaceholderTransitionEnd = useCallback(function() {
    if (isMovementAllowed2()) {
      updateViewportMaxScroll4({
        maxScroll: getMaxWindowScroll$1()
      });
    }
  }, [isMovementAllowed2, updateViewportMaxScroll4]);
  useDroppablePublisher({
    droppableId,
    type,
    mode,
    direction,
    isDropDisabled,
    isCombineEnabled,
    ignoreContainerClipping,
    getDroppableRef
  });
  var placeholder2 = React__default.createElement(AnimateInOut$1, {
    on: props.placeholder,
    shouldAnimate: props.shouldAnimatePlaceholder
  }, function(_ref) {
    var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
    return React__default.createElement(Placeholder$1$2, {
      placeholder: data,
      onClose,
      innerRef: setPlaceholderRef,
      animate,
      contextId,
      onTransitionEnd: onPlaceholderTransitionEnd
    });
  });
  var provided = useMemo(function() {
    return {
      innerRef: setDroppableRef,
      placeholder: placeholder2,
      droppableProps: {
        "data-rbd-droppable-id": droppableId,
        "data-rbd-droppable-context-id": contextId
      }
    };
  }, [contextId, droppableId, placeholder2, setDroppableRef]);
  var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
  var droppableContext = useMemo(function() {
    return {
      droppableId,
      type,
      isUsingCloneFor
    };
  }, [droppableId, isUsingCloneFor, type]);
  function getClone() {
    if (!useClone) {
      return null;
    }
    var dragging = useClone.dragging, render = useClone.render;
    var node2 = React__default.createElement(PrivateDraggable, {
      draggableId: dragging.draggableId,
      index: dragging.source.index,
      isClone: true,
      isEnabled: true,
      shouldRespectForcePress: false,
      canDragInteractiveElements: true
    }, function(draggableProvided, draggableSnapshot) {
      return render(draggableProvided, draggableSnapshot, dragging);
    });
    return ReactDOM__default.createPortal(node2, getContainerForClone());
  }
  return React__default.createElement(DroppableContext$1.Provider, {
    value: droppableContext
  }, children(provided, snapshot), getClone());
}
var isMatchingType$1 = function isMatchingType(type, critical) {
  return type === critical.droppable.type;
};
var getDraggable$1 = function getDraggable(critical, dimensions) {
  return dimensions.draggables[critical.draggable.id];
};
var makeMapStateToProps$1$1 = function makeMapStateToProps2() {
  var idleWithAnimation = {
    placeholder: null,
    shouldAnimatePlaceholder: true,
    snapshot: {
      isDraggingOver: false,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: false
    },
    useClone: null
  };
  var idleWithoutAnimation = _extends$6({}, idleWithAnimation, {
    shouldAnimatePlaceholder: false
  });
  var getDraggableRubric = memoizeOne(function(descriptor) {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  });
  var getMapProps = memoizeOne(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
    var draggableId = dragging.descriptor.id;
    var isHome = dragging.descriptor.droppableId === id;
    if (isHome) {
      var useClone = renderClone ? {
        render: renderClone,
        dragging: getDraggableRubric(dragging.descriptor)
      } : null;
      var _snapshot = {
        isDraggingOver: isDraggingOverForConsumer,
        draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
        draggingFromThisWith: draggableId,
        isUsingPlaceholder: true
      };
      return {
        placeholder: dragging.placeholder,
        shouldAnimatePlaceholder: false,
        snapshot: _snapshot,
        useClone
      };
    }
    if (!isEnabled) {
      return idleWithoutAnimation;
    }
    if (!isDraggingOverForImpact) {
      return idleWithAnimation;
    }
    var snapshot = {
      isDraggingOver: isDraggingOverForConsumer,
      draggingOverWith: draggableId,
      draggingFromThisWith: null,
      isUsingPlaceholder: true
    };
    return {
      placeholder: dragging.placeholder,
      shouldAnimatePlaceholder: true,
      snapshot,
      useClone: null
    };
  });
  var selector2 = function selector3(state, ownProps) {
    var id = ownProps.droppableId;
    var type = ownProps.type;
    var isEnabled = !ownProps.isDropDisabled;
    var renderClone = ownProps.renderClone;
    if (state.isDragging) {
      var critical = state.critical;
      if (!isMatchingType$1(type, critical)) {
        return idleWithoutAnimation;
      }
      var dragging = getDraggable$1(critical, state.dimensions);
      var isDraggingOver = whatIsDraggedOver$1(state.impact) === id;
      return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
    }
    if (state.phase === "DROP_ANIMATING") {
      var completed = state.completed;
      if (!isMatchingType$1(type, completed.critical)) {
        return idleWithoutAnimation;
      }
      var _dragging = getDraggable$1(completed.critical, state.dimensions);
      return getMapProps(id, isEnabled, whatIsDraggedOverFromResult$1(completed.result) === id, whatIsDraggedOver$1(completed.impact) === id, _dragging, renderClone);
    }
    if (state.phase === "IDLE" && state.completed && !state.shouldFlush) {
      var _completed = state.completed;
      if (!isMatchingType$1(type, _completed.critical)) {
        return idleWithoutAnimation;
      }
      var wasOver = whatIsDraggedOver$1(_completed.impact) === id;
      var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === "COMBINE");
      var isHome = _completed.critical.droppable.id === id;
      if (wasOver) {
        return wasCombining ? idleWithAnimation : idleWithoutAnimation;
      }
      if (isHome) {
        return idleWithAnimation;
      }
      return idleWithoutAnimation;
    }
    return idleWithoutAnimation;
  };
  return selector2;
};
var mapDispatchToProps$1$1 = {
  updateViewportMaxScroll: updateViewportMaxScroll$1
};
function getBody() {
  !document.body ? process.env.NODE_ENV !== "production" ? invariant$1(false, "document.body is not ready") : invariant$1() : void 0;
  return document.body;
}
var defaultProps$2 = {
  mode: "standard",
  type: "DEFAULT",
  direction: "vertical",
  isDropDisabled: false,
  isCombineEnabled: false,
  ignoreContainerClipping: false,
  renderClone: null,
  getContainerForClone: getBody
};
var ConnectedDroppable$1 = connect(makeMapStateToProps$1$1, mapDispatchToProps$1$1, null, {
  context: StoreContext$1,
  pure: true,
  areStatePropsEqual: isStrictEqual$1
})(Droppable$1);
ConnectedDroppable$1.defaultProps = defaultProps$2;
const SidebarItem = forwardRef(
  (props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    ListItem$1,
    {
      ref: ref2,
      cursor: "grab",
      borderBottom: "1px solid white",
      borderBottomColor: "whiteAlpha.200",
      padding: 6,
      textStyle: "editorItemLabel",
      ...props
    }
  )
);
const ChangeHistoryContext = createContext(
  void 0
);
const ChangeHistoryProvider = ({
  changeHistory,
  children
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(ChangeHistoryContext.Provider, { value: { changeHistory }, children });
const useChangeHistory = () => useContext(ChangeHistoryContext);
const idsEqual = (idA, idB) => idA.toString() === idB.toString();
const getSlotIndex = (session, slotId) => {
  var _a3;
  return (_a3 = session.slots) == null ? void 0 : _a3.findIndex((s2) => idsEqual(s2.id, slotId));
};
const initializeSlot = (session) => ({
  totalCapacity: 0,
  name: `Slot ${session.slots.length + 1}`,
  sort: Infinity
});
const hasSessionFormField = (form, session) => getFieldForSession(form, session) !== void 0;
const canSelectSession = (form, formSettings, session) => session.slots.length > 0;
const getSessionFieldLabel = (field, session) => {
  if (field.label !== void 0) {
    return field.label;
  }
  if (session !== void 0) {
    return session.name;
  }
  return humanizeString(field.name);
};
const canDeleteSlot = (slot, session) => {
  if (slot.numberBooked !== void 0 && slot.numberBooked > 0) {
    return false;
  }
  if (session && session.slots.length <= 1) {
    return false;
  }
  return true;
};
const canDeleteSession = (form, session) => session.slots.every((slot) => canDeleteSlot(slot, session)) && !hasSessionFormField(form, session);
const visibleSlots = (field, session) => hasIncludeSlots(field) ? field.includeSlots.map((id) => session.slots.find((s2) => idsEqual(s2.id, id))).filter((s2) => s2 !== void 0) : session.slots;
const slotExists = (session, id) => session.slots.some((s2) => idsEqual(id, s2.id));
const isVisibleSlot = (field, session, id) => field.includeSlots !== void 0 ? field.includeSlots.some((s2) => idsEqual(id, s2)) : slotExists(session, id);
const getPriceOverride = (field, slot) => {
  var _a3;
  return (_a3 = field.priceOverrides) == null ? void 0 : _a3[slot.id];
};
const getSessionSlotFieldPrice = (slot, field) => {
  var _a3;
  return ((_a3 = field == null ? void 0 : field.priceOverrides) == null ? void 0 : _a3[slot.id]) || slot.priceInCents;
};
function getUnsavedChanges$1(ydoc) {
  return ydoc.getArray("unsavedChanges");
}
function getPreviousChanges$1(ydoc) {
  return ydoc.getArray("previousChanges");
}
function getChangeHistory$1(ydoc) {
  return {
    unsavedChanges: getUnsavedChanges$1(ydoc).toArray(),
    previousChanges: getPreviousChanges$1(ydoc).toArray()
  };
}
function getLastUpdateIndexForUser$1(changes, userId) {
  const lastChangeIndexForUser = changes.findIndex(
    (change2) => idsEqual(change2.user.id, userId)
  );
  if (lastChangeIndexForUser === -1) {
    return -1;
  }
  const change = changes[lastChangeIndexForUser];
  if (change.type === "update_item") {
    return lastChangeIndexForUser;
  } else {
    return -1;
  }
}
function mergedChanges$1(originalChange, newChange) {
  return {
    ...originalChange,
    update: {
      ...originalChange.update,
      ...newChange.update
    },
    timestamp: newChange.timestamp
  };
}
function unsavedFieldUpdates(fieldName, changes) {
  return changes == null ? void 0 : changes.filter(
    (change) => (change.type === "update_item" || change.type === "add_item") && change.item.name === fieldName
  );
}
function unsavedFieldChanges(fieldName, changes) {
  return changes == null ? void 0 : changes.filter(
    (change) => (change.type === "update_item" || change.type === "add_item" || change.type === "delete_item") && change.item.name === fieldName
  );
}
function getUnsavedPageChanges(page, changes) {
  const directPageChanges = unsavedFieldUpdates(page.name, changes);
  return flatFields$2(page).reduce((result, field) => {
    const fieldChanges = unsavedFieldChanges(field.name, changes);
    return result.concat(fieldChanges || []);
  }, directPageChanges || []);
}
function uniqueChangeUsers$1(changes) {
  const users = /* @__PURE__ */ new Map();
  changes.forEach((change) => {
    if (change.user) {
      users.set(change.user.id, change.user);
    }
  });
  return Array.from(users.values());
}
const ChangeHistoryIndicator = ({
  changes
}) => {
  const editors = uniqueChangeUsers$1(changes);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: editors.map((user) => /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("b", { style: { color: user.color }, children: user.initials }) }, user.id)) });
};
const PageChangesContainer = ({
  page,
  children
}) => {
  const context = useChangeHistory();
  if (context === void 0) {
    return children;
  }
  const { changeHistory } = context;
  const changes = getUnsavedPageChanges(page, changeHistory.unsavedChanges);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    changes !== void 0 && (changes == null ? void 0 : changes.length) > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(ChangeHistoryIndicator, { changes }),
    children
  ] });
};
const pageLabel = (page) => page.label || humanizeString(page.name.toString());
const PagesMenuListing = ({ pages }) => {
  const { dispatch } = useRegForm();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DragDropContext$1,
    {
      onDragEnd: (result) => result.destination !== void 0 && result.destination !== null && dispatch({
        type: "move_page",
        name: result.draggableId,
        toIndex: result.destination.index
      }),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectedDroppable$1, { droppableId: "pagesMenu", children: (provided) => /* @__PURE__ */ jsxRuntimeExports.jsxs(List$1, { ref: provided.innerRef, children: [
        pages.map((page, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(PublicDraggable, { draggableId: page.name, index: index2, children: (provided2) => /* @__PURE__ */ jsxRuntimeExports.jsx(PageChangesContainer, { page, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          SidebarItem,
          {
            className: "t-page-item",
            ref: provided2.innerRef,
            ...provided2.draggableProps,
            ...provided2.dragHandleProps,
            onClick: () => dispatch({ type: "select_page", name: page.name }),
            children: pageLabel(page)
          }
        ) }) }, page.name)),
        provided.placeholder
      ] }) })
    }
  );
};
const PhasedPagesMenu = () => {
  const { form, dispatch } = useRegForm();
  const phasedPages = getPhasedPages(form.fields);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { className: "t-pages-menu t-phased-pages-meny", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { size: "xs", mt: 4, children: "Pre-track selection pages" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(PagesMenuListing, { pages: phasedPages.pretrack }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { py: 5, pr: 5, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        width: "full",
        className: "t-add-page",
        colorScheme: "blue",
        onClick: () => dispatch({ type: "add_page", page: { phase: "pretrack" } }),
        children: "Add Page (Pre-track)"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { size: "xs", mt: 4, children: "Registration pages" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(PagesMenuListing, { pages: phasedPages.default }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { py: 5, pr: 5, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        width: "full",
        className: "t-add-page",
        colorScheme: "blue",
        onClick: () => dispatch({ type: "add_page" }),
        children: "Add Page"
      }
    ) })
  ] });
};
const PagesMenu$2 = () => {
  const { form, dispatch } = useRegForm();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { className: "t-pages-menu", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(PagesMenuListing, { pages: form.fields }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { py: 5, pr: 5, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        width: "full",
        className: "t-add-page",
        colorScheme: "blue",
        onClick: () => dispatch({ type: "add_page" }),
        children: "Add Page"
      }
    ) })
  ] });
};
const PagesMenuContainer = () => {
  const { formSettings } = useRegForm();
  if (formSettings.registrationPhasesEnabled) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(PhasedPagesMenu, {});
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(PagesMenu$2, {});
  }
};
const SidebarTab = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Tab,
  {
    sx: {
      fontSize: "12px !important",
      lineHeight: "28px !important",
      margin: "0 !important"
    },
    _hover: { bg: "blackAlpha.200" },
    _selected: { bg: "blackAlpha.200" },
    _focus: { boxShadow: "none" },
    borderRadius: 0,
    border: 0,
    ...props
  }
);
class AdminApiUrls {
  constructor(baseUrl = "http://get.lvh.me:3003") {
    this.paths = {
      roomBlocks: "room_nights",
      roomBookings: "room_bookings",
      sessions: "bookable_sessions",
      tracks: "tracks",
      sponsorTiers: "sponsorship-tiers",
      reports: "reports"
    };
    this.baseUrl = baseUrl;
  }
  roomBlocksUrl() {
    return `${this.baseUrl}/${this.paths.roomBlocks}`;
  }
  roomBlockUrl(roomBlockId) {
    return `${this.roomBlocksUrl()}/${roomBlockId}`;
  }
  roomBookingsUrl(roomBlockId) {
    return `${this.roomBlocksUrl()}/${roomBlockId}/${this.paths.roomBookings}`;
  }
  roomBookingUrl(roomBookingId) {
    return `${this.baseUrl}/${this.paths.roomBookings}/${roomBookingId}`;
  }
  sessionsUrl() {
    return `${this.baseUrl}/${this.paths.sessions}`;
  }
  sessionUrl(sessionId) {
    return `${this.sessionsUrl()}/${sessionId}`;
  }
  sponsorTiersUrl() {
    return `${this.baseUrl}/${this.paths.sponsorTiers}`;
  }
  tracksUrl() {
    return `${this.baseUrl}/${this.paths.tracks}`;
  }
  trackUrl(trackId) {
    return `${this.tracksUrl()}/${trackId}`;
  }
  reportsUrl() {
    return `${this.baseUrl}/${this.paths.reports}`;
  }
  reportUrl(reportID) {
    return `${this.reportsUrl()}/${reportID}`;
  }
}
class BaseApiClient {
  constructor(urls, fetcher) {
    this.urls = urls;
    this.fetcher = fetcher;
  }
}
const headers = {
  accept: "application/json"
};
const writeHeaders = {
  ...headers,
  "content-type": "application/json;charset=UTF-8"
};
const adaptRoomBlockForRequest = (roomBlock) => {
  return {
    ...roomBlock,
    startDate: formatISO(roomBlock.startDate, { representation: "date" }),
    endDate: formatISO(roomBlock.endDate, { representation: "date" }),
    roomTypes: roomBlock.roomTypes.map((roomType) => ({
      ...roomType,
      nights: roomType.nights.map((night) => ({
        id: night.id,
        date: formatISO(night.date, { representation: "date" }),
        availability: night.availability
      }))
    }))
  };
};
const adaptRoomBlockFromResponse = (roomBlock) => ({
  ...roomBlock,
  startDate: parseISO$1(roomBlock.startDate),
  endDate: parseISO$1(roomBlock.endDate),
  roomTypes: roomBlock.roomTypes.map((responseRoomType) => ({
    ...responseRoomType,
    nights: responseRoomType.nights.map((responseRoomNight) => ({
      ...responseRoomNight,
      date: parseISO$1(responseRoomNight.date),
      roomTypeId: responseRoomType.id
    }))
  }))
});
const adaptRegFlowRoomBlockFromResponse = (roomBlock) => ({
  ...roomBlock,
  startDate: parseISO$1(roomBlock.startDate),
  endDate: parseISO$1(roomBlock.endDate)
});
function adaptRoomBookingResponse(booking) {
  return {
    ...booking,
    checkIn: parseISO$1(booking.checkIn),
    checkOut: parseISO$1(booking.checkOut)
  };
}
const adaptRoomBookingForRequest = ({
  roomType,
  ...booking
}) => ({
  ...booking,
  checkIn: formatISO(booking.checkIn, { representation: "date" }),
  checkOut: formatISO(booking.checkOut, { representation: "date" }),
  roomTypeId: roomType.id
});
class RoomingClient extends BaseApiClient {
  async getRoomBlocks() {
    const response = await this.fetcher(this.urls.roomBlocksUrl(), { headers });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return json.map(adaptRoomBlockFromResponse);
  }
  async getRoomBlock(id) {
    const response = await this.fetcher(this.urls.roomBlockUrl(id), {
      headers
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return adaptRoomBlockFromResponse(json.roomBlock);
  }
  async createRoomBlock(roomBlock) {
    const response = await this.fetcher(this.urls.roomBlocksUrl(), {
      method: "POST",
      headers: writeHeaders,
      body: JSON.stringify({ roomBlock: adaptRoomBlockForRequest(roomBlock) })
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return adaptRoomBlockFromResponse(json.roomBlock);
  }
  async updateRoomBlock(roomBlock) {
    const response = await this.fetcher(this.urls.roomBlockUrl(roomBlock.id), {
      method: "PUT",
      headers: writeHeaders,
      body: JSON.stringify({ roomBlock: adaptRoomBlockForRequest(roomBlock) })
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return adaptRoomBlockFromResponse(json.roomBlock);
  }
  async deleteRoomBlock(roomBlock) {
    const response = await this.fetcher(this.urls.roomBlockUrl(roomBlock.id), {
      method: "DELETE",
      headers: writeHeaders
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return adaptRoomBlockFromResponse(json.roomBlock);
  }
  async getBooking(bookingId) {
    const response = await this.fetcher(this.urls.roomBookingUrl(bookingId), {
      headers
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return json.booking;
  }
  async createBooking(booking, roomBlockId) {
    const response = await this.fetcher(
      this.urls.roomBookingsUrl(roomBlockId),
      {
        method: "POST",
        headers: writeHeaders,
        body: JSON.stringify({ booking })
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return adaptRoomBookingResponse(json.booking);
  }
  async cancelBooking(booking) {
    const response = await this.fetcher(this.urls.roomBookingUrl(booking.id), {
      method: "DELETE",
      headers: writeHeaders,
      body: JSON.stringify({ booking })
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return adaptRoomBookingResponse(json.booking);
  }
}
const buildRequestSlot = (slot) => {
  const requestSlot = {
    name: slot.name,
    total_capacity: slot.totalCapacity,
    price_cents: slot.priceInCents || null,
    sort: slot.sort,
    metadata: slot.metadata,
    description: slot.description,
    start_time: slot.startTime !== void 0 ? formatISODateTimeUTC(slot.startTime) : null,
    end_time: slot.endTime !== void 0 ? formatISODateTimeUTC(slot.endTime) : null
  };
  if (!slot.isNew) {
    requestSlot.id = slot.id;
  }
  return requestSlot;
};
const buildSlotFromResponse = (responseSlot) => {
  return {
    id: responseSlot.id,
    name: responseSlot.name,
    totalCapacity: responseSlot.total_capacity,
    numberBooked: responseSlot.number_booked,
    priceInCents: responseSlot.price_cents,
    sort: responseSlot.sort || Infinity,
    metadata: responseSlot.metadata,
    description: responseSlot.description,
    startTime: responseSlot.start_time ? parseISO$1(responseSlot.start_time) : void 0,
    endTime: responseSlot.end_time ? parseISO$1(responseSlot.end_time) : void 0
  };
};
const buildSessionRequestBody = (session) => {
  const { slots, checkpointCreation, ...attributes } = session;
  return {
    session_booking_session: {
      ...attributes,
      checkpoint_creation: checkpointCreation,
      slots_attributes: buildSlotsAttributes(session)
    }
  };
};
const buildSlotsAttributes = (session) => {
  const slotsAttributes = session.slots.map(buildRequestSlot);
  if (session.deletedSlots !== void 0) {
    session.deletedSlots.forEach(
      (id) => slotsAttributes.push({ id, _destroy: 1 })
    );
  }
  return slotsAttributes;
};
const buildSessionInputRequestBody = (session) => {
  const { checkpointCreation, ...attributes } = session;
  return {
    session_booking_session: {
      ...attributes,
      checkpoint_creation: checkpointCreation
    }
  };
};
const buildSessionFromResponse = (responseSession) => {
  const { slots, checkpoint_creation, ...attributes } = responseSession;
  return {
    ...attributes,
    checkpointCreation: checkpoint_creation,
    slots: slots.map(buildSlotFromResponse).sort((a2, b2) => a2.sort - b2.sort),
    deletedSlots: []
  };
};
const buildSessionsFromResponse = (sessionsResponseBody) => sessionsResponseBody.map(buildSessionFromResponse);
class SessionsClient extends BaseApiClient {
  async getSessions() {
    const response = await this.fetcher(this.urls.sessionsUrl(), {
      headers
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return buildSessionsFromResponse(json);
  }
  async getSession(sessionId) {
    const response = await this.fetcher(this.urls.sessionUrl(sessionId), {
      headers
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return buildSessionFromResponse(json);
  }
  async updateSession(session) {
    const response = await this.fetcher(this.urls.sessionUrl(session.id), {
      method: "PUT",
      headers: writeHeaders,
      body: JSON.stringify(buildSessionRequestBody(session))
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return buildSessionFromResponse(json);
  }
  async deleteSession(session) {
    const response = await this.fetcher(this.urls.sessionUrl(session.id), {
      method: "DELETE",
      headers: writeHeaders,
      body: JSON.stringify(buildSessionRequestBody(session))
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return buildSessionFromResponse(json);
  }
  async createSession(session) {
    const response = await this.fetcher(this.urls.sessionsUrl(), {
      method: "POST",
      headers: writeHeaders,
      body: JSON.stringify(buildSessionInputRequestBody(session))
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return buildSessionFromResponse(json);
  }
  async createSessionWithSlots(session) {
    const response = await this.fetcher(this.urls.sessionsUrl() + "/create_with_slots", {
      method: "POST",
      headers: writeHeaders,
      body: JSON.stringify(buildSessionRequestBody(session))
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return buildSessionFromResponse(json);
  }
}
const extractDate = (object, key2, representation = "date") => {
  if (!(key2 in object)) {
    return void 0;
  }
  const value = object[key2];
  if (value === void 0) {
    return null;
  }
  return formatISO(value, { representation });
};
const buildRequestGuestInvites = (track2) => {
  var _a3;
  return (_a3 = track2.guestInvites) == null ? void 0 : _a3.map((invite) => ({
    id: invite.id,
    inviter_track_id: invite.inviterTrackId,
    number_of_invites: invite.numberOfInvites
  }));
};
const buildRequestTicketTypes = (track2) => {
  var _a3, _b;
  const result = [];
  (_a3 = track2.ticketTypes) == null ? void 0 : _a3.forEach((ticketType) => {
    const requestTicketType = {
      name: ticketType.name,
      sort: ticketType.sort,
      available_from: extractDate(ticketType, "availableFrom", "complete"),
      available_to: extractDate(ticketType, "availableTo", "complete"),
      capacity: ticketType.capacity || null,
      price_cents: ticketType.priceInCents || null,
      metadata: ticketType.metadata
    };
    if (!ticketType.isNew) {
      requestTicketType.id = ticketType.id;
    }
    result.push(requestTicketType);
  });
  (_b = track2.deletedTicketTypes) == null ? void 0 : _b.forEach((id) => {
    result.push({
      id,
      _destroy: 1
    });
  });
  if (result.length === 0) {
    return void 0;
  } else {
    return result;
  }
};
const buildCreateTrackRequest = (track2) => ({
  name: track2.name,
  description: track2.description,
  invite_only: track2.inviteOnly,
  is_guest_track: track2.isGuestTrack,
  is_speaker_track: track2.isSpeakerTrack,
  number_booked: track2.numberBooked,
  guest_account_activation: track2.guestAccountActivation,
  override_registration_close: track2.overrideRegistrationClose,
  guest_invites: buildRequestGuestInvites(track2),
  ticket_types_attributes: buildRequestTicketTypes(track2),
  sort: track2.sort
});
const buildUpdateTrackRequest = (track2) => ({
  id: track2.id,
  name: track2.name,
  description: track2.description,
  invite_only: track2.inviteOnly,
  is_guest_track: track2.isGuestTrack,
  is_speaker_track: track2.isSpeakerTrack,
  number_booked: track2.numberBooked,
  guest_account_activation: track2.guestAccountActivation,
  override_registration_close: track2.overrideRegistrationClose,
  guest_invites: buildRequestGuestInvites(track2),
  ticket_types_attributes: buildRequestTicketTypes(track2),
  pre_populate_fields: track2.prePopulateFields,
  sort: track2.sort,
  metadata: track2.metadata
});
const buildGuestInvitesFromResponse = (track2) => {
  var _a3;
  return (_a3 = track2 == null ? void 0 : track2.guest_invites) == null ? void 0 : _a3.map((invite) => ({
    id: invite.id,
    inviterTrackId: invite.inviter_track_id,
    numberOfInvites: invite.number_of_invites
  }));
};
const buildTicketTypeFromResponse = (track2) => {
  var _a3;
  return (_a3 = track2 == null ? void 0 : track2.ticket_types) == null ? void 0 : _a3.map((ticketType) => ({
    id: ticketType.id,
    name: ticketType.name,
    sort: ticketType.sort,
    availableFrom: ticketType.available_from ? parseISO$1(ticketType.available_from) : void 0,
    availableTo: ticketType.available_to ? parseISO$1(ticketType.available_to) : void 0,
    priceInCents: ticketType.price_cents || void 0,
    capacity: ticketType.capacity || void 0,
    numberBooked: ticketType.number_booked,
    metadata: ticketType.metadata
  }));
};
const buildTrackFromResponse = (track2) => ({
  id: track2.id,
  inviteUrl: track2.invite_url,
  name: track2.name,
  description: track2.description,
  inviteOnly: track2.invite_only,
  numberBooked: track2.number_booked,
  isGuestTrack: track2.is_guest_track,
  isSpeakerTrack: track2.is_speaker_track,
  guestAccountActivation: track2.guest_account_activation,
  overrideRegistrationClose: track2.override_registration_close,
  guestInvites: buildGuestInvitesFromResponse(track2),
  ticketTypes: buildTicketTypeFromResponse(track2) || [],
  prePopulateFields: track2.pre_populate_fields,
  sort: track2.sort,
  metadata: track2.metadata
});
class TracksClient extends BaseApiClient {
  async getTracks() {
    const response = await this.fetcher(this.urls.tracksUrl(), {
      headers
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return json.map(buildTrackFromResponse);
  }
  async createTrack(track2) {
    const response = await this.fetcher(this.urls.tracksUrl(), {
      method: "POST",
      headers: writeHeaders,
      body: JSON.stringify({ track: buildCreateTrackRequest(track2) })
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return buildTrackFromResponse(json.track);
  }
  async updateTrack(update2) {
    const response = await this.fetcher(this.urls.trackUrl(update2.id), {
      method: "PUT",
      headers: writeHeaders,
      body: JSON.stringify({ track: buildUpdateTrackRequest(update2) })
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return buildTrackFromResponse(json.track);
  }
  async deleteTrack(track2) {
    const response = await this.fetcher(this.urls.trackUrl(track2.id), {
      method: "DELETE",
      headers: writeHeaders
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return json.track;
  }
}
class SponsorsClient extends BaseApiClient {
  async getSponsorTiers() {
    const response = await this.fetcher(this.urls.sponsorTiersUrl(), {
      headers
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return json;
  }
}
class AdminApiClient {
  constructor(apiUrl = "http://get.lvh.me:3003", fetchFn) {
    this.urls = new AdminApiUrls(apiUrl);
    this.fetchFn = fetchFn;
    const doFetch = (url, options) => {
      if (fetchFn === void 0) {
        return fetch(url, options);
      } else {
        return fetchFn(url, options);
      }
    };
    this.rooming = new RoomingClient(this.urls, doFetch);
    this.sessions = new SessionsClient(this.urls, doFetch);
    this.tracks = new TracksClient(this.urls, doFetch);
    this.sponsors = new SponsorsClient(this.urls, doFetch);
  }
}
const AdminApiContext = React__default.createContext(
  new AdminApiClient()
);
const useAdminApi = () => useContext(AdminApiContext);
const urlDate = (date) => formatISO(date, { representation: "date" });
class RegFlowApiUrls {
  constructor(baseUrl = "http://get.lvh.me:3003/reg") {
    this.paths = {
      roomBlocks: "room_blocks"
    };
    this.baseUrl = baseUrl;
  }
  roomBookingsUrl(formField) {
    return `${this.baseUrl}/room_bookings/${formField}`;
  }
  roomTypesUrl(formField) {
    return `${this.roomBookingsUrl(formField)}/availability`;
  }
  roomTypesAvailabilityUrl(formField, checkIn, checkOut) {
    return `${this.roomTypesUrl(formField)}?checkIn=${urlDate(
      checkIn
    )}&checkOut=${urlDate(checkOut)}`;
  }
}
class RoomBookingClient extends BaseApiClient {
  async getRoomBlockAvailability(formField, checkIn, checkOut) {
    const response = await this.fetcher(
      this.urls.roomTypesAvailabilityUrl(formField, checkIn, checkOut)
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return json.roomTypes;
  }
  async getBooking(formField) {
    const response = await this.fetcher(this.urls.roomBookingsUrl(formField), {
      headers
    });
    if (response.status === 404) {
      return null;
    }
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return adaptRoomBookingResponse(json.booking);
  }
  async createBooking(booking) {
    const response = await this.fetcher(
      this.urls.roomBookingsUrl(booking.formField),
      {
        method: "POST",
        headers: writeHeaders,
        body: JSON.stringify({ booking: adaptRoomBookingForRequest(booking) })
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return adaptRoomBookingResponse(json.booking);
  }
  async cancelBooking(booking) {
    const response = await this.fetcher(
      this.urls.roomBookingsUrl(booking.formField),
      {
        method: "DELETE",
        headers: writeHeaders,
        body: JSON.stringify({ booking })
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return adaptRoomBookingResponse(json.booking);
  }
  async updateBooking(formField, update2) {
    const response = await this.fetcher(this.urls.roomBookingsUrl(formField), {
      method: "PATCH",
      headers: writeHeaders,
      body: JSON.stringify({ booking: update2 })
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const json = await response.json();
    return adaptRoomBookingResponse(json.booking);
  }
}
class RegFlowApiClient {
  constructor(apiUrl = "http://get.lvh.me:3003/reg", fetchFn) {
    this.urls = new RegFlowApiUrls(apiUrl);
    this.fetchFn = fetchFn;
    const doFetch = (url, options) => {
      if (fetchFn === void 0) {
        return fetch(url, options);
      } else {
        return fetchFn(url, options);
      }
    };
    this.roomBooking = new RoomBookingClient(this.urls, doFetch);
  }
}
const RegFlowApiContext = React__default.createContext(
  new RegFlowApiClient()
);
const useRegFlowApi = () => useContext(RegFlowApiContext);
const useUpdateTrack = (options) => {
  const { tracks } = useAdminApi();
  const queryClient = useQueryClient();
  const mutateFn = (update2) => tracks.updateTrack(update2);
  return useMutation(mutateFn, {
    ...options,
    onSuccess: (data, variables, context) => {
      var _a3;
      queryClient.invalidateQueries({ queryKey: ["tracks"] });
      (_a3 = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a3.call(void 0, data, variables, context);
    }
  });
};
var isCheckBoxInput = (element2) => element2.type === "checkbox";
var isDateObject = (value) => value instanceof Date;
var isNullOrUndefined = (value) => value == null;
const isObjectType = (value) => typeof value === "object";
var isObject$1 = (value) => !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !isDateObject(value);
var getEventValue = (event) => isObject$1(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var getNodeParentName = (name2) => name2.substring(0, name2.search(/\.\d+(\.|$)/)) || name2;
var isNameInFieldArray = (names, name2) => names.has(getNodeParentName(name2));
var isPlainObject$2 = (tempObject) => {
  const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
  return isObject$1(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function cloneObject(data) {
  let copy2;
  const isArray2 = Array.isArray(data);
  const isFileListInstance = typeof FileList !== "undefined" ? data instanceof FileList : false;
  if (data instanceof Date) {
    copy2 = new Date(data);
  } else if (!(isWeb && (data instanceof Blob || isFileListInstance)) && (isArray2 || isObject$1(data))) {
    copy2 = isArray2 ? [] : {};
    if (!isArray2 && !isPlainObject$2(data)) {
      copy2 = data;
    } else {
      for (const key2 in data) {
        if (data.hasOwnProperty(key2)) {
          copy2[key2] = cloneObject(data[key2]);
        }
      }
    }
  } else {
    return data;
  }
  return copy2;
}
var isKey = (value) => /^\w*$/.test(value);
var isUndefined$1 = (val) => val === void 0;
var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];
var stringToPath = (input) => compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var get$6 = (object, path2, defaultValue2) => {
  if (!path2 || !isObject$1(object)) {
    return defaultValue2;
  }
  const result = (isKey(path2) ? [path2] : stringToPath(path2)).reduce((result2, key2) => isNullOrUndefined(result2) ? result2 : result2[key2], object);
  return isUndefined$1(result) || result === object ? isUndefined$1(object[path2]) ? defaultValue2 : object[path2] : result;
};
var isBoolean = (value) => typeof value === "boolean";
var set$3 = (object, path2, value) => {
  let index2 = -1;
  const tempPath = isKey(path2) ? [path2] : stringToPath(path2);
  const length2 = tempPath.length;
  const lastIndex = length2 - 1;
  while (++index2 < length2) {
    const key2 = tempPath[index2];
    let newValue = value;
    if (index2 !== lastIndex) {
      const objValue = object[key2];
      newValue = isObject$1(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index2 + 1]) ? [] : {};
    }
    if (key2 === "__proto__" || key2 === "constructor" || key2 === "prototype") {
      return;
    }
    object[key2] = newValue;
    object = object[key2];
  }
};
const EVENTS = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
};
const VALIDATION_MODE = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
};
const INPUT_VALIDATION_RULES = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
};
const HookFormContext = React__default.createContext(null);
HookFormContext.displayName = "HookFormContext";
const useFormContext = () => React__default.useContext(HookFormContext);
var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
  const result = {
    defaultValues: control._defaultValues
  };
  for (const key2 in formState) {
    Object.defineProperty(result, key2, {
      get: () => {
        const _key = key2;
        if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
          control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
        }
        localProxyFormState && (localProxyFormState[_key] = true);
        return formState[_key];
      }
    });
  }
  return result;
};
const useIsomorphicLayoutEffect$4 = typeof window !== "undefined" ? React__default.useLayoutEffect : React__default.useEffect;
function useFormState(props) {
  const methods = useFormContext();
  const { control = methods.control, disabled, name: name2, exact } = props || {};
  const [formState, updateFormState] = React__default.useState(control._formState);
  const _localProxyFormState = React__default.useRef({
    isDirty: false,
    isLoading: false,
    dirtyFields: false,
    touchedFields: false,
    validatingFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  });
  useIsomorphicLayoutEffect$4(() => control._subscribe({
    name: name2,
    formState: _localProxyFormState.current,
    exact,
    callback: (formState2) => {
      !disabled && updateFormState({
        ...control._formState,
        ...formState2
      });
    }
  }), [name2, disabled, exact]);
  React__default.useEffect(() => {
    _localProxyFormState.current.isValid && control._setValid(true);
  }, [control]);
  return React__default.useMemo(() => getProxyFormState(formState, control, _localProxyFormState.current, false), [formState, control]);
}
var isString$1 = (value) => typeof value === "string";
var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue2) => {
  if (isString$1(names)) {
    isGlobal && _names.watch.add(names);
    return get$6(formValues, names, defaultValue2);
  }
  if (Array.isArray(names)) {
    return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get$6(formValues, fieldName)));
  }
  isGlobal && (_names.watchAll = true);
  return formValues;
};
var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);
function deepEqual$2(object1, object2, _internal_visited = /* @__PURE__ */ new WeakSet()) {
  if (isPrimitive(object1) || isPrimitive(object2)) {
    return object1 === object2;
  }
  if (isDateObject(object1) && isDateObject(object2)) {
    return object1.getTime() === object2.getTime();
  }
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  if (_internal_visited.has(object1) || _internal_visited.has(object2)) {
    return true;
  }
  _internal_visited.add(object1);
  _internal_visited.add(object2);
  for (const key2 of keys1) {
    const val1 = object1[key2];
    if (!keys2.includes(key2)) {
      return false;
    }
    if (key2 !== "ref") {
      const val2 = object2[key2];
      if (isDateObject(val1) && isDateObject(val2) || isObject$1(val1) && isObject$1(val2) || Array.isArray(val1) && Array.isArray(val2) ? !deepEqual$2(val1, val2, _internal_visited) : val1 !== val2) {
        return false;
      }
    }
  }
  return true;
}
function useWatch(props) {
  const methods = useFormContext();
  const { control = methods.control, name: name2, defaultValue: defaultValue2, disabled, exact, compute } = props || {};
  const _defaultValue = React__default.useRef(defaultValue2);
  const _compute = React__default.useRef(compute);
  const _computeFormValues = React__default.useRef(void 0);
  _compute.current = compute;
  const defaultValueMemo = React__default.useMemo(() => control._getWatch(name2, _defaultValue.current), [control, name2]);
  const [value, updateValue] = React__default.useState(_compute.current ? _compute.current(defaultValueMemo) : defaultValueMemo);
  useIsomorphicLayoutEffect$4(() => control._subscribe({
    name: name2,
    formState: {
      values: true
    },
    exact,
    callback: (formState) => {
      if (!disabled) {
        const formValues = generateWatchOutput(name2, control._names, formState.values || control._formValues, false, _defaultValue.current);
        if (_compute.current) {
          const computedFormValues = _compute.current(formValues);
          if (!deepEqual$2(computedFormValues, _computeFormValues.current)) {
            updateValue(computedFormValues);
            _computeFormValues.current = computedFormValues;
          }
        } else {
          updateValue(formValues);
        }
      }
    }
  }), [control, disabled, name2, exact]);
  React__default.useEffect(() => control._removeUnmounted());
  return value;
}
function useController(props) {
  const methods = useFormContext();
  const { name: name2, disabled, control = methods.control, shouldUnregister, defaultValue: defaultValue2 } = props;
  const isArrayField = isNameInFieldArray(control._names.array, name2);
  const defaultValueMemo = React__default.useMemo(() => get$6(control._formValues, name2, get$6(control._defaultValues, name2, defaultValue2)), [control, name2, defaultValue2]);
  const value = useWatch({
    control,
    name: name2,
    defaultValue: defaultValueMemo,
    exact: true
  });
  const formState = useFormState({
    control,
    name: name2,
    exact: true
  });
  const _props = React__default.useRef(props);
  const _registerProps = React__default.useRef(control.register(name2, {
    ...props.rules,
    value,
    ...isBoolean(props.disabled) ? { disabled: props.disabled } : {}
  }));
  _props.current = props;
  const fieldState = React__default.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: true,
      get: () => !!get$6(formState.errors, name2)
    },
    isDirty: {
      enumerable: true,
      get: () => !!get$6(formState.dirtyFields, name2)
    },
    isTouched: {
      enumerable: true,
      get: () => !!get$6(formState.touchedFields, name2)
    },
    isValidating: {
      enumerable: true,
      get: () => !!get$6(formState.validatingFields, name2)
    },
    error: {
      enumerable: true,
      get: () => get$6(formState.errors, name2)
    }
  }), [formState, name2]);
  const onChange = React__default.useCallback((event) => _registerProps.current.onChange({
    target: {
      value: getEventValue(event),
      name: name2
    },
    type: EVENTS.CHANGE
  }), [name2]);
  const onBlur = React__default.useCallback(() => _registerProps.current.onBlur({
    target: {
      value: get$6(control._formValues, name2),
      name: name2
    },
    type: EVENTS.BLUR
  }), [name2, control._formValues]);
  const ref2 = React__default.useCallback((elm) => {
    const field2 = get$6(control._fields, name2);
    if (field2 && elm) {
      field2._f.ref = {
        focus: () => elm.focus && elm.focus(),
        select: () => elm.select && elm.select(),
        setCustomValidity: (message2) => elm.setCustomValidity(message2),
        reportValidity: () => elm.reportValidity()
      };
    }
  }, [control._fields, name2]);
  const field = React__default.useMemo(() => ({
    name: name2,
    value,
    ...isBoolean(disabled) || formState.disabled ? { disabled: formState.disabled || disabled } : {},
    onChange,
    onBlur,
    ref: ref2
  }), [name2, disabled, formState.disabled, onChange, onBlur, ref2, value]);
  React__default.useEffect(() => {
    const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
    control.register(name2, {
      ..._props.current.rules,
      ...isBoolean(_props.current.disabled) ? { disabled: _props.current.disabled } : {}
    });
    const updateMounted = (name3, value2) => {
      const field2 = get$6(control._fields, name3);
      if (field2 && field2._f) {
        field2._f.mount = value2;
      }
    };
    updateMounted(name2, true);
    if (_shouldUnregisterField) {
      const value2 = cloneObject(get$6(control._options.defaultValues, name2));
      set$3(control._defaultValues, name2, value2);
      if (isUndefined$1(get$6(control._formValues, name2))) {
        set$3(control._formValues, name2, value2);
      }
    }
    !isArrayField && control.register(name2);
    return () => {
      (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name2) : updateMounted(name2, false);
    };
  }, [name2, control, isArrayField, shouldUnregister]);
  React__default.useEffect(() => {
    control._setDisabledField({
      disabled,
      name: name2
    });
  }, [disabled, name2, control]);
  return React__default.useMemo(() => ({
    field,
    formState,
    fieldState
  }), [field, formState, fieldState]);
}
const Controller = (props) => props.render(useController(props));
var appendErrors = (name2, validateAllFieldCriteria, errors, type, message2) => validateAllFieldCriteria ? {
  ...errors[name2],
  types: {
    ...errors[name2] && errors[name2].types ? errors[name2].types : {},
    [type]: message2 || true
  }
} : {};
var convertToArrayPayload = (value) => Array.isArray(value) ? value : [value];
var createSubject = () => {
  let _observers = [];
  const next2 = (value) => {
    for (const observer of _observers) {
      observer.next && observer.next(value);
    }
  };
  const subscribe = (observer) => {
    _observers.push(observer);
    return {
      unsubscribe: () => {
        _observers = _observers.filter((o2) => o2 !== observer);
      }
    };
  };
  const unsubscribe = () => {
    _observers = [];
  };
  return {
    get observers() {
      return _observers;
    },
    next: next2,
    subscribe,
    unsubscribe
  };
};
var isEmptyObject$1 = (value) => isObject$1(value) && !Object.keys(value).length;
var isFileInput = (element2) => element2.type === "file";
var isFunction$2 = (value) => typeof value === "function";
var isHTMLElement$2 = (value) => {
  if (!isWeb) {
    return false;
  }
  const owner = value ? value.ownerDocument : 0;
  return value instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var isMultipleSelect = (element2) => element2.type === `select-multiple`;
var isRadioInput = (element2) => element2.type === "radio";
var isRadioOrCheckbox = (ref2) => isRadioInput(ref2) || isCheckBoxInput(ref2);
var live = (ref2) => isHTMLElement$2(ref2) && ref2.isConnected;
function baseGet(object, updatePath) {
  const length2 = updatePath.slice(0, -1).length;
  let index2 = 0;
  while (index2 < length2) {
    object = isUndefined$1(object) ? index2++ : object[updatePath[index2++]];
  }
  return object;
}
function isEmptyArray$1(obj) {
  for (const key2 in obj) {
    if (obj.hasOwnProperty(key2) && !isUndefined$1(obj[key2])) {
      return false;
    }
  }
  return true;
}
function unset(object, path2) {
  const paths = Array.isArray(path2) ? path2 : isKey(path2) ? [path2] : stringToPath(path2);
  const childObject = paths.length === 1 ? object : baseGet(object, paths);
  const index2 = paths.length - 1;
  const key2 = paths[index2];
  if (childObject) {
    delete childObject[key2];
  }
  if (index2 !== 0 && (isObject$1(childObject) && isEmptyObject$1(childObject) || Array.isArray(childObject) && isEmptyArray$1(childObject))) {
    unset(object, paths.slice(0, -1));
  }
  return object;
}
var objectHasFunction = (data) => {
  for (const key2 in data) {
    if (isFunction$2(data[key2])) {
      return true;
    }
  }
  return false;
};
function markFieldsDirty(data, fields = {}) {
  const isParentNodeArray = Array.isArray(data);
  if (isObject$1(data) || isParentNodeArray) {
    for (const key2 in data) {
      if (Array.isArray(data[key2]) || isObject$1(data[key2]) && !objectHasFunction(data[key2])) {
        fields[key2] = Array.isArray(data[key2]) ? [] : {};
        markFieldsDirty(data[key2], fields[key2]);
      } else if (!isNullOrUndefined(data[key2])) {
        fields[key2] = true;
      }
    }
  }
  return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
  const isParentNodeArray = Array.isArray(data);
  if (isObject$1(data) || isParentNodeArray) {
    for (const key2 in data) {
      if (Array.isArray(data[key2]) || isObject$1(data[key2]) && !objectHasFunction(data[key2])) {
        if (isUndefined$1(formValues) || isPrimitive(dirtyFieldsFromValues[key2])) {
          dirtyFieldsFromValues[key2] = Array.isArray(data[key2]) ? markFieldsDirty(data[key2], []) : { ...markFieldsDirty(data[key2]) };
        } else {
          getDirtyFieldsFromDefaultValues(data[key2], isNullOrUndefined(formValues) ? {} : formValues[key2], dirtyFieldsFromValues[key2]);
        }
      } else {
        dirtyFieldsFromValues[key2] = !deepEqual$2(data[key2], formValues[key2]);
      }
    }
  }
  return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));
const defaultResult = {
  value: false,
  isValid: false
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
  if (Array.isArray(options)) {
    if (options.length > 1) {
      const values2 = options.filter((option) => option && option.checked && !option.disabled).map((option) => option.value);
      return { value: values2, isValid: !!values2.length };
    }
    return options[0].checked && !options[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      options[0].attributes && !isUndefined$1(options[0].attributes.value) ? isUndefined$1(options[0].value) || options[0].value === "" ? validResult : { value: options[0].value, isValid: true } : validResult
    ) : defaultResult;
  }
  return defaultResult;
};
var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined$1(value) ? value : valueAsNumber ? value === "" ? NaN : value ? +value : value : valueAsDate && isString$1(value) ? new Date(value) : setValueAs ? setValueAs(value) : value;
const defaultReturn = {
  isValid: false,
  value: null
};
var getRadioValue = (options) => Array.isArray(options) ? options.reduce((previous2, option) => option && option.checked && !option.disabled ? {
  isValid: true,
  value: option.value
} : previous2, defaultReturn) : defaultReturn;
function getFieldValue(_f) {
  const ref2 = _f.ref;
  if (isFileInput(ref2)) {
    return ref2.files;
  }
  if (isRadioInput(ref2)) {
    return getRadioValue(_f.refs).value;
  }
  if (isMultipleSelect(ref2)) {
    return [...ref2.selectedOptions].map(({ value }) => value);
  }
  if (isCheckBoxInput(ref2)) {
    return getCheckboxValue(_f.refs).value;
  }
  return getFieldValueAs(isUndefined$1(ref2.value) ? _f.ref.value : ref2.value, _f);
}
var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
  const fields = {};
  for (const name2 of fieldsNames) {
    const field = get$6(_fields, name2);
    field && set$3(fields, name2, field._f);
  }
  return {
    criteriaMode,
    names: [...fieldsNames],
    fields,
    shouldUseNativeValidation
  };
};
var isRegex = (value) => value instanceof RegExp;
var getRuleValue = (rule) => isUndefined$1(rule) ? rule : isRegex(rule) ? rule.source : isObject$1(rule) ? isRegex(rule.value) ? rule.value.source : rule.value : rule;
var getValidationModes = (mode) => ({
  isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
  isOnBlur: mode === VALIDATION_MODE.onBlur,
  isOnChange: mode === VALIDATION_MODE.onChange,
  isOnAll: mode === VALIDATION_MODE.all,
  isOnTouch: mode === VALIDATION_MODE.onTouched
});
const ASYNC_FUNCTION = "AsyncFunction";
var hasPromiseValidation = (fieldReference) => !!fieldReference && !!fieldReference.validate && !!(isFunction$2(fieldReference.validate) && fieldReference.validate.constructor.name === ASYNC_FUNCTION || isObject$1(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction) => validateFunction.constructor.name === ASYNC_FUNCTION));
var hasValidation = (options) => options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
var isWatched = (name2, _names, isBlurEvent) => !isBlurEvent && (_names.watchAll || _names.watch.has(name2) || [..._names.watch].some((watchName) => name2.startsWith(watchName) && /^\.\w+/.test(name2.slice(watchName.length))));
const iterateFieldsByAction = (fields, action, fieldsNames, abortEarly) => {
  for (const key2 of fieldsNames || Object.keys(fields)) {
    const field = get$6(fields, key2);
    if (field) {
      const { _f, ...currentField } = field;
      if (_f) {
        if (_f.refs && _f.refs[0] && action(_f.refs[0], key2) && !abortEarly) {
          return true;
        } else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) {
          return true;
        } else {
          if (iterateFieldsByAction(currentField, action)) {
            break;
          }
        }
      } else if (isObject$1(currentField)) {
        if (iterateFieldsByAction(currentField, action)) {
          break;
        }
      }
    }
  }
  return;
};
function schemaErrorLookup(errors, _fields, name2) {
  const error2 = get$6(errors, name2);
  if (error2 || isKey(name2)) {
    return {
      error: error2,
      name: name2
    };
  }
  const names = name2.split(".");
  while (names.length) {
    const fieldName = names.join(".");
    const field = get$6(_fields, fieldName);
    const foundError = get$6(errors, fieldName);
    if (field && !Array.isArray(field) && name2 !== fieldName) {
      return { name: name2 };
    }
    if (foundError && foundError.type) {
      return {
        name: fieldName,
        error: foundError
      };
    }
    if (foundError && foundError.root && foundError.root.type) {
      return {
        name: `${fieldName}.root`,
        error: foundError.root
      };
    }
    names.pop();
  }
  return {
    name: name2
  };
}
var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
  updateFormState(formStateData);
  const { name: name2, ...formState } = formStateData;
  return isEmptyObject$1(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key2) => _proxyFormState[key2] === (!isRoot || VALIDATION_MODE.all));
};
var shouldSubscribeByName = (name2, signalName, exact) => !name2 || !signalName || name2 === signalName || convertToArrayPayload(name2).some((currentName) => currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
  if (mode.isOnAll) {
    return false;
  } else if (!isSubmitted && mode.isOnTouch) {
    return !(isTouched || isBlurEvent);
  } else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
    return !isBlurEvent;
  } else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
    return isBlurEvent;
  }
  return true;
};
var unsetEmptyArray = (ref2, name2) => !compact(get$6(ref2, name2)).length && unset(ref2, name2);
var updateFieldArrayRootError = (errors, error2, name2) => {
  const fieldArrayErrors = convertToArrayPayload(get$6(errors, name2));
  set$3(fieldArrayErrors, "root", error2[name2]);
  set$3(errors, name2, fieldArrayErrors);
  return errors;
};
var isMessage = (value) => isString$1(value);
function getValidateError(result, ref2, type = "validate") {
  if (isMessage(result) || Array.isArray(result) && result.every(isMessage) || isBoolean(result) && !result) {
    return {
      type,
      message: isMessage(result) ? result : "",
      ref: ref2
    };
  }
}
var getValueAndMessage = (validationData) => isObject$1(validationData) && !isRegex(validationData) ? validationData : {
  value: validationData,
  message: ""
};
var validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
  const { ref: ref2, refs, required: required2, maxLength, minLength, min: min2, max: max2, pattern, validate, name: name2, valueAsNumber, mount } = field._f;
  const inputValue = get$6(formValues, name2);
  if (!mount || disabledFieldNames.has(name2)) {
    return {};
  }
  const inputRef = refs ? refs[0] : ref2;
  const setCustomValidity = (message2) => {
    if (shouldUseNativeValidation && inputRef.reportValidity) {
      inputRef.setCustomValidity(isBoolean(message2) ? "" : message2 || "");
      inputRef.reportValidity();
    }
  };
  const error2 = {};
  const isRadio = isRadioInput(ref2);
  const isCheckBox = isCheckBoxInput(ref2);
  const isRadioOrCheckbox2 = isRadio || isCheckBox;
  const isEmpty2 = (valueAsNumber || isFileInput(ref2)) && isUndefined$1(ref2.value) && isUndefined$1(inputValue) || isHTMLElement$2(ref2) && ref2.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
  const appendErrorsCurry = appendErrors.bind(null, name2, validateAllFieldCriteria, error2);
  const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
    const message2 = exceedMax ? maxLengthMessage : minLengthMessage;
    error2[name2] = {
      type: exceedMax ? maxType : minType,
      message: message2,
      ref: ref2,
      ...appendErrorsCurry(exceedMax ? maxType : minType, message2)
    };
  };
  if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required2 && (!isRadioOrCheckbox2 && (isEmpty2 || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid)) {
    const { value, message: message2 } = isMessage(required2) ? { value: !!required2, message: required2 } : getValueAndMessage(required2);
    if (value) {
      error2[name2] = {
        type: INPUT_VALIDATION_RULES.required,
        message: message2,
        ref: inputRef,
        ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message2)
      };
      if (!validateAllFieldCriteria) {
        setCustomValidity(message2);
        return error2;
      }
    }
  }
  if (!isEmpty2 && (!isNullOrUndefined(min2) || !isNullOrUndefined(max2))) {
    let exceedMax;
    let exceedMin;
    const maxOutput = getValueAndMessage(max2);
    const minOutput = getValueAndMessage(min2);
    if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
      const valueNumber = ref2.valueAsNumber || (inputValue ? +inputValue : inputValue);
      if (!isNullOrUndefined(maxOutput.value)) {
        exceedMax = valueNumber > maxOutput.value;
      }
      if (!isNullOrUndefined(minOutput.value)) {
        exceedMin = valueNumber < minOutput.value;
      }
    } else {
      const valueDate = ref2.valueAsDate || new Date(inputValue);
      const convertTimeToDate = (time) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + time);
      const isTime = ref2.type == "time";
      const isWeek = ref2.type == "week";
      if (isString$1(maxOutput.value) && inputValue) {
        exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
      }
      if (isString$1(minOutput.value) && inputValue) {
        exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
      }
    }
    if (exceedMax || exceedMin) {
      getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
      if (!validateAllFieldCriteria) {
        setCustomValidity(error2[name2].message);
        return error2;
      }
    }
  }
  if ((maxLength || minLength) && !isEmpty2 && (isString$1(inputValue) || isFieldArray && Array.isArray(inputValue))) {
    const maxLengthOutput = getValueAndMessage(maxLength);
    const minLengthOutput = getValueAndMessage(minLength);
    const exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
    const exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
    if (exceedMax || exceedMin) {
      getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
      if (!validateAllFieldCriteria) {
        setCustomValidity(error2[name2].message);
        return error2;
      }
    }
  }
  if (pattern && !isEmpty2 && isString$1(inputValue)) {
    const { value: patternValue, message: message2 } = getValueAndMessage(pattern);
    if (isRegex(patternValue) && !inputValue.match(patternValue)) {
      error2[name2] = {
        type: INPUT_VALIDATION_RULES.pattern,
        message: message2,
        ref: ref2,
        ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message2)
      };
      if (!validateAllFieldCriteria) {
        setCustomValidity(message2);
        return error2;
      }
    }
  }
  if (validate) {
    if (isFunction$2(validate)) {
      const result = await validate(inputValue, formValues);
      const validateError = getValidateError(result, inputRef);
      if (validateError) {
        error2[name2] = {
          ...validateError,
          ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message)
        };
        if (!validateAllFieldCriteria) {
          setCustomValidity(validateError.message);
          return error2;
        }
      }
    } else if (isObject$1(validate)) {
      let validationResult = {};
      for (const key2 in validate) {
        if (!isEmptyObject$1(validationResult) && !validateAllFieldCriteria) {
          break;
        }
        const validateError = getValidateError(await validate[key2](inputValue, formValues), inputRef, key2);
        if (validateError) {
          validationResult = {
            ...validateError,
            ...appendErrorsCurry(key2, validateError.message)
          };
          setCustomValidity(validateError.message);
          if (validateAllFieldCriteria) {
            error2[name2] = validationResult;
          }
        }
      }
      if (!isEmptyObject$1(validationResult)) {
        error2[name2] = {
          ref: inputRef,
          ...validationResult
        };
        if (!validateAllFieldCriteria) {
          return error2;
        }
      }
    }
  }
  setCustomValidity(true);
  return error2;
};
const defaultOptions$4 = {
  mode: VALIDATION_MODE.onSubmit,
  reValidateMode: VALIDATION_MODE.onChange,
  shouldFocusError: true
};
function createFormControl(props = {}) {
  let _options = {
    ...defaultOptions$4,
    ...props
  };
  let _formState = {
    submitCount: 0,
    isDirty: false,
    isReady: false,
    isLoading: isFunction$2(_options.defaultValues),
    isValidating: false,
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: _options.errors || {},
    disabled: _options.disabled || false
  };
  let _fields = {};
  let _defaultValues = isObject$1(_options.defaultValues) || isObject$1(_options.values) ? cloneObject(_options.defaultValues || _options.values) || {} : {};
  let _formValues = _options.shouldUnregister ? {} : cloneObject(_defaultValues);
  let _state = {
    action: false,
    mount: false,
    watch: false
  };
  let _names = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  };
  let delayErrorCallback;
  let timer = 0;
  const _proxyFormState = {
    isDirty: false,
    dirtyFields: false,
    validatingFields: false,
    touchedFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  };
  let _proxySubscribeFormState = {
    ..._proxyFormState
  };
  const _subjects = {
    array: createSubject(),
    state: createSubject()
  };
  const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
  const debounce2 = (callback) => (wait2) => {
    clearTimeout(timer);
    timer = setTimeout(callback, wait2);
  };
  const _setValid = async (shouldUpdateValid) => {
    if (!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid)) {
      const isValid2 = _options.resolver ? isEmptyObject$1((await _runSchema()).errors) : await executeBuiltInValidation(_fields, true);
      if (isValid2 !== _formState.isValid) {
        _subjects.state.next({
          isValid: isValid2
        });
      }
    }
  };
  const _updateIsValidating = (names, isValidating) => {
    if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
      (names || Array.from(_names.mount)).forEach((name2) => {
        if (name2) {
          isValidating ? set$3(_formState.validatingFields, name2, isValidating) : unset(_formState.validatingFields, name2);
        }
      });
      _subjects.state.next({
        validatingFields: _formState.validatingFields,
        isValidating: !isEmptyObject$1(_formState.validatingFields)
      });
    }
  };
  const _setFieldArray = (name2, values2 = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
    if (args && method && !_options.disabled) {
      _state.action = true;
      if (shouldUpdateFieldsAndState && Array.isArray(get$6(_fields, name2))) {
        const fieldValues = method(get$6(_fields, name2), args.argA, args.argB);
        shouldSetValues && set$3(_fields, name2, fieldValues);
      }
      if (shouldUpdateFieldsAndState && Array.isArray(get$6(_formState.errors, name2))) {
        const errors = method(get$6(_formState.errors, name2), args.argA, args.argB);
        shouldSetValues && set$3(_formState.errors, name2, errors);
        unsetEmptyArray(_formState.errors, name2);
      }
      if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray(get$6(_formState.touchedFields, name2))) {
        const touchedFields = method(get$6(_formState.touchedFields, name2), args.argA, args.argB);
        shouldSetValues && set$3(_formState.touchedFields, name2, touchedFields);
      }
      if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) {
        _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
      }
      _subjects.state.next({
        name: name2,
        isDirty: _getDirty(name2, values2),
        dirtyFields: _formState.dirtyFields,
        errors: _formState.errors,
        isValid: _formState.isValid
      });
    } else {
      set$3(_formValues, name2, values2);
    }
  };
  const updateErrors = (name2, error2) => {
    set$3(_formState.errors, name2, error2);
    _subjects.state.next({
      errors: _formState.errors
    });
  };
  const _setErrors = (errors) => {
    _formState.errors = errors;
    _subjects.state.next({
      errors: _formState.errors,
      isValid: false
    });
  };
  const updateValidAndValue = (name2, shouldSkipSetValueAs, value, ref2) => {
    const field = get$6(_fields, name2);
    if (field) {
      const defaultValue2 = get$6(_formValues, name2, isUndefined$1(value) ? get$6(_defaultValues, name2) : value);
      isUndefined$1(defaultValue2) || ref2 && ref2.defaultChecked || shouldSkipSetValueAs ? set$3(_formValues, name2, shouldSkipSetValueAs ? defaultValue2 : getFieldValue(field._f)) : setFieldValue(name2, defaultValue2);
      _state.mount && _setValid();
    }
  };
  const updateTouchAndDirty = (name2, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
    let shouldUpdateField = false;
    let isPreviousDirty = false;
    const output = {
      name: name2
    };
    if (!_options.disabled) {
      if (!isBlurEvent || shouldDirty) {
        if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
          isPreviousDirty = _formState.isDirty;
          _formState.isDirty = output.isDirty = _getDirty();
          shouldUpdateField = isPreviousDirty !== output.isDirty;
        }
        const isCurrentFieldPristine = deepEqual$2(get$6(_defaultValues, name2), fieldValue);
        isPreviousDirty = !!get$6(_formState.dirtyFields, name2);
        isCurrentFieldPristine ? unset(_formState.dirtyFields, name2) : set$3(_formState.dirtyFields, name2, true);
        output.dirtyFields = _formState.dirtyFields;
        shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
      }
      if (isBlurEvent) {
        const isPreviousFieldTouched = get$6(_formState.touchedFields, name2);
        if (!isPreviousFieldTouched) {
          set$3(_formState.touchedFields, name2, isBlurEvent);
          output.touchedFields = _formState.touchedFields;
          shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
        }
      }
      shouldUpdateField && shouldRender && _subjects.state.next(output);
    }
    return shouldUpdateField ? output : {};
  };
  const shouldRenderByError = (name2, isValid2, error2, fieldState) => {
    const previousFieldError = get$6(_formState.errors, name2);
    const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isBoolean(isValid2) && _formState.isValid !== isValid2;
    if (_options.delayError && error2) {
      delayErrorCallback = debounce2(() => updateErrors(name2, error2));
      delayErrorCallback(_options.delayError);
    } else {
      clearTimeout(timer);
      delayErrorCallback = null;
      error2 ? set$3(_formState.errors, name2, error2) : unset(_formState.errors, name2);
    }
    if ((error2 ? !deepEqual$2(previousFieldError, error2) : previousFieldError) || !isEmptyObject$1(fieldState) || shouldUpdateValid) {
      const updatedFormState = {
        ...fieldState,
        ...shouldUpdateValid && isBoolean(isValid2) ? { isValid: isValid2 } : {},
        errors: _formState.errors,
        name: name2
      };
      _formState = {
        ..._formState,
        ...updatedFormState
      };
      _subjects.state.next(updatedFormState);
    }
  };
  const _runSchema = async (name2) => {
    _updateIsValidating(name2, true);
    const result = await _options.resolver(_formValues, _options.context, getResolverOptions(name2 || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    _updateIsValidating(name2);
    return result;
  };
  const executeSchemaAndUpdateState = async (names) => {
    const { errors } = await _runSchema(names);
    if (names) {
      for (const name2 of names) {
        const error2 = get$6(errors, name2);
        error2 ? set$3(_formState.errors, name2, error2) : unset(_formState.errors, name2);
      }
    } else {
      _formState.errors = errors;
    }
    return errors;
  };
  const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
    valid: true
  }) => {
    for (const name2 in fields) {
      const field = fields[name2];
      if (field) {
        const { _f, ...fieldValue } = field;
        if (_f) {
          const isFieldArrayRoot = _names.array.has(_f.name);
          const isPromiseFunction = field._f && hasPromiseValidation(field._f);
          if (isPromiseFunction && _proxyFormState.validatingFields) {
            _updateIsValidating([name2], true);
          }
          const fieldError = await validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
          if (isPromiseFunction && _proxyFormState.validatingFields) {
            _updateIsValidating([name2]);
          }
          if (fieldError[_f.name]) {
            context.valid = false;
            if (shouldOnlyCheckValid) {
              break;
            }
          }
          !shouldOnlyCheckValid && (get$6(fieldError, _f.name) ? isFieldArrayRoot ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : set$3(_formState.errors, _f.name, fieldError[_f.name]) : unset(_formState.errors, _f.name));
        }
        !isEmptyObject$1(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
      }
    }
    return context.valid;
  };
  const _removeUnmounted = () => {
    for (const name2 of _names.unMount) {
      const field = get$6(_fields, name2);
      field && (field._f.refs ? field._f.refs.every((ref2) => !live(ref2)) : !live(field._f.ref)) && unregister(name2);
    }
    _names.unMount = /* @__PURE__ */ new Set();
  };
  const _getDirty = (name2, data) => !_options.disabled && (name2 && data && set$3(_formValues, name2, data), !deepEqual$2(getValues(), _defaultValues));
  const _getWatch = (names, defaultValue2, isGlobal) => generateWatchOutput(names, _names, {
    ..._state.mount ? _formValues : isUndefined$1(defaultValue2) ? _defaultValues : isString$1(names) ? { [names]: defaultValue2 } : defaultValue2
  }, isGlobal, defaultValue2);
  const _getFieldArray = (name2) => compact(get$6(_state.mount ? _formValues : _defaultValues, name2, _options.shouldUnregister ? get$6(_defaultValues, name2, []) : []));
  const setFieldValue = (name2, value, options = {}) => {
    const field = get$6(_fields, name2);
    let fieldValue = value;
    if (field) {
      const fieldReference = field._f;
      if (fieldReference) {
        !fieldReference.disabled && set$3(_formValues, name2, getFieldValueAs(value, fieldReference));
        fieldValue = isHTMLElement$2(fieldReference.ref) && isNullOrUndefined(value) ? "" : value;
        if (isMultipleSelect(fieldReference.ref)) {
          [...fieldReference.ref.options].forEach((optionRef) => optionRef.selected = fieldValue.includes(optionRef.value));
        } else if (fieldReference.refs) {
          if (isCheckBoxInput(fieldReference.ref)) {
            fieldReference.refs.forEach((checkboxRef) => {
              if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                if (Array.isArray(fieldValue)) {
                  checkboxRef.checked = !!fieldValue.find((data) => data === checkboxRef.value);
                } else {
                  checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                }
              }
            });
          } else {
            fieldReference.refs.forEach((radioRef) => radioRef.checked = radioRef.value === fieldValue);
          }
        } else if (isFileInput(fieldReference.ref)) {
          fieldReference.ref.value = "";
        } else {
          fieldReference.ref.value = fieldValue;
          if (!fieldReference.ref.type) {
            _subjects.state.next({
              name: name2,
              values: cloneObject(_formValues)
            });
          }
        }
      }
    }
    (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name2, fieldValue, options.shouldTouch, options.shouldDirty, true);
    options.shouldValidate && trigger(name2);
  };
  const setValues = (name2, value, options) => {
    for (const fieldKey in value) {
      if (!value.hasOwnProperty(fieldKey)) {
        return;
      }
      const fieldValue = value[fieldKey];
      const fieldName = name2 + "." + fieldKey;
      const field = get$6(_fields, fieldName);
      (_names.array.has(name2) || isObject$1(fieldValue) || field && !field._f) && !isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
    }
  };
  const setValue = (name2, value, options = {}) => {
    const field = get$6(_fields, name2);
    const isFieldArray = _names.array.has(name2);
    const cloneValue = cloneObject(value);
    set$3(_formValues, name2, cloneValue);
    if (isFieldArray) {
      _subjects.array.next({
        name: name2,
        values: cloneObject(_formValues)
      });
      if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) {
        _subjects.state.next({
          name: name2,
          dirtyFields: getDirtyFields(_defaultValues, _formValues),
          isDirty: _getDirty(name2, cloneValue)
        });
      }
    } else {
      field && !field._f && !isNullOrUndefined(cloneValue) ? setValues(name2, cloneValue, options) : setFieldValue(name2, cloneValue, options);
    }
    isWatched(name2, _names) && _subjects.state.next({ ..._formState, name: name2 });
    _subjects.state.next({
      name: _state.mount ? name2 : void 0,
      values: cloneObject(_formValues)
    });
  };
  const onChange = async (event) => {
    _state.mount = true;
    const target = event.target;
    let name2 = target.name;
    let isFieldValueUpdated = true;
    const field = get$6(_fields, name2);
    const _updateIsFieldValueUpdated = (fieldValue) => {
      isFieldValueUpdated = Number.isNaN(fieldValue) || isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || deepEqual$2(fieldValue, get$6(_formValues, name2, fieldValue));
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    if (field) {
      let error2;
      let isValid2;
      const fieldValue = target.type ? getFieldValue(field._f) : getEventValue(event);
      const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
      const shouldSkipValidation = !hasValidation(field._f) && !_options.resolver && !get$6(_formState.errors, name2) && !field._f.deps || skipValidation(isBlurEvent, get$6(_formState.touchedFields, name2), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
      const watched = isWatched(name2, _names, isBlurEvent);
      set$3(_formValues, name2, fieldValue);
      if (isBlurEvent) {
        field._f.onBlur && field._f.onBlur(event);
        delayErrorCallback && delayErrorCallback(0);
      } else if (field._f.onChange) {
        field._f.onChange(event);
      }
      const fieldState = updateTouchAndDirty(name2, fieldValue, isBlurEvent);
      const shouldRender = !isEmptyObject$1(fieldState) || watched;
      !isBlurEvent && _subjects.state.next({
        name: name2,
        type: event.type,
        values: cloneObject(_formValues)
      });
      if (shouldSkipValidation) {
        if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
          if (_options.mode === "onBlur") {
            if (isBlurEvent) {
              _setValid();
            }
          } else if (!isBlurEvent) {
            _setValid();
          }
        }
        return shouldRender && _subjects.state.next({ name: name2, ...watched ? {} : fieldState });
      }
      !isBlurEvent && watched && _subjects.state.next({ ..._formState });
      if (_options.resolver) {
        const { errors } = await _runSchema([name2]);
        _updateIsFieldValueUpdated(fieldValue);
        if (isFieldValueUpdated) {
          const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name2);
          const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name2);
          error2 = errorLookupResult.error;
          name2 = errorLookupResult.name;
          isValid2 = isEmptyObject$1(errors);
        }
      } else {
        _updateIsValidating([name2], true);
        error2 = (await validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name2];
        _updateIsValidating([name2]);
        _updateIsFieldValueUpdated(fieldValue);
        if (isFieldValueUpdated) {
          if (error2) {
            isValid2 = false;
          } else if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
            isValid2 = await executeBuiltInValidation(_fields, true);
          }
        }
      }
      if (isFieldValueUpdated) {
        field._f.deps && trigger(field._f.deps);
        shouldRenderByError(name2, isValid2, error2, fieldState);
      }
    }
  };
  const _focusInput = (ref2, key2) => {
    if (get$6(_formState.errors, key2) && ref2.focus) {
      ref2.focus();
      return 1;
    }
    return;
  };
  const trigger = async (name2, options = {}) => {
    let isValid2;
    let validationResult;
    const fieldNames = convertToArrayPayload(name2);
    if (_options.resolver) {
      const errors = await executeSchemaAndUpdateState(isUndefined$1(name2) ? name2 : fieldNames);
      isValid2 = isEmptyObject$1(errors);
      validationResult = name2 ? !fieldNames.some((name3) => get$6(errors, name3)) : isValid2;
    } else if (name2) {
      validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
        const field = get$6(_fields, fieldName);
        return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
      }))).every(Boolean);
      !(!validationResult && !_formState.isValid) && _setValid();
    } else {
      validationResult = isValid2 = await executeBuiltInValidation(_fields);
    }
    _subjects.state.next({
      ...!isString$1(name2) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid2 !== _formState.isValid ? {} : { name: name2 },
      ..._options.resolver || !name2 ? { isValid: isValid2 } : {},
      errors: _formState.errors
    });
    options.shouldFocus && !validationResult && iterateFieldsByAction(_fields, _focusInput, name2 ? fieldNames : _names.mount);
    return validationResult;
  };
  const getValues = (fieldNames) => {
    const values2 = {
      ..._state.mount ? _formValues : _defaultValues
    };
    return isUndefined$1(fieldNames) ? values2 : isString$1(fieldNames) ? get$6(values2, fieldNames) : fieldNames.map((name2) => get$6(values2, name2));
  };
  const getFieldState = (name2, formState) => ({
    invalid: !!get$6((formState || _formState).errors, name2),
    isDirty: !!get$6((formState || _formState).dirtyFields, name2),
    error: get$6((formState || _formState).errors, name2),
    isValidating: !!get$6(_formState.validatingFields, name2),
    isTouched: !!get$6((formState || _formState).touchedFields, name2)
  });
  const clearErrors = (name2) => {
    name2 && convertToArrayPayload(name2).forEach((inputName) => unset(_formState.errors, inputName));
    _subjects.state.next({
      errors: name2 ? _formState.errors : {}
    });
  };
  const setError = (name2, error2, options) => {
    const ref2 = (get$6(_fields, name2, { _f: {} })._f || {}).ref;
    const currentError = get$6(_formState.errors, name2) || {};
    const { ref: currentRef, message: message2, type, ...restOfErrorTree } = currentError;
    set$3(_formState.errors, name2, {
      ...restOfErrorTree,
      ...error2,
      ref: ref2
    });
    _subjects.state.next({
      name: name2,
      errors: _formState.errors,
      isValid: false
    });
    options && options.shouldFocus && ref2 && ref2.focus && ref2.focus();
  };
  const watch = (name2, defaultValue2) => isFunction$2(name2) ? _subjects.state.subscribe({
    next: (payload) => "values" in payload && name2(_getWatch(void 0, defaultValue2), payload)
  }) : _getWatch(name2, defaultValue2, true);
  const _subscribe = (props2) => _subjects.state.subscribe({
    next: (formState) => {
      if (shouldSubscribeByName(props2.name, formState.name, props2.exact) && shouldRenderFormState(formState, props2.formState || _proxyFormState, _setFormState, props2.reRenderRoot)) {
        props2.callback({
          values: { ..._formValues },
          ..._formState,
          ...formState,
          defaultValues: _defaultValues
        });
      }
    }
  }).unsubscribe;
  const subscribe = (props2) => {
    _state.mount = true;
    _proxySubscribeFormState = {
      ..._proxySubscribeFormState,
      ...props2.formState
    };
    return _subscribe({
      ...props2,
      formState: _proxySubscribeFormState
    });
  };
  const unregister = (name2, options = {}) => {
    for (const fieldName of name2 ? convertToArrayPayload(name2) : _names.mount) {
      _names.mount.delete(fieldName);
      _names.array.delete(fieldName);
      if (!options.keepValue) {
        unset(_fields, fieldName);
        unset(_formValues, fieldName);
      }
      !options.keepError && unset(_formState.errors, fieldName);
      !options.keepDirty && unset(_formState.dirtyFields, fieldName);
      !options.keepTouched && unset(_formState.touchedFields, fieldName);
      !options.keepIsValidating && unset(_formState.validatingFields, fieldName);
      !_options.shouldUnregister && !options.keepDefaultValue && unset(_defaultValues, fieldName);
    }
    _subjects.state.next({
      values: cloneObject(_formValues)
    });
    _subjects.state.next({
      ..._formState,
      ...!options.keepDirty ? {} : { isDirty: _getDirty() }
    });
    !options.keepIsValid && _setValid();
  };
  const _setDisabledField = ({ disabled, name: name2 }) => {
    if (isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name2)) {
      disabled ? _names.disabled.add(name2) : _names.disabled.delete(name2);
    }
  };
  const register2 = (name2, options = {}) => {
    let field = get$6(_fields, name2);
    const disabledIsDefined = isBoolean(options.disabled) || isBoolean(_options.disabled);
    set$3(_fields, name2, {
      ...field || {},
      _f: {
        ...field && field._f ? field._f : { ref: { name: name2 } },
        name: name2,
        mount: true,
        ...options
      }
    });
    _names.mount.add(name2);
    if (field) {
      _setDisabledField({
        disabled: isBoolean(options.disabled) ? options.disabled : _options.disabled,
        name: name2
      });
    } else {
      updateValidAndValue(name2, true, options.value);
    }
    return {
      ...disabledIsDefined ? { disabled: options.disabled || _options.disabled } : {},
      ..._options.progressive ? {
        required: !!options.required,
        min: getRuleValue(options.min),
        max: getRuleValue(options.max),
        minLength: getRuleValue(options.minLength),
        maxLength: getRuleValue(options.maxLength),
        pattern: getRuleValue(options.pattern)
      } : {},
      name: name2,
      onChange,
      onBlur: onChange,
      ref: (ref2) => {
        if (ref2) {
          register2(name2, options);
          field = get$6(_fields, name2);
          const fieldRef = isUndefined$1(ref2.value) ? ref2.querySelectorAll ? ref2.querySelectorAll("input,select,textarea")[0] || ref2 : ref2 : ref2;
          const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
          const refs = field._f.refs || [];
          if (radioOrCheckbox ? refs.find((option) => option === fieldRef) : fieldRef === field._f.ref) {
            return;
          }
          set$3(_fields, name2, {
            _f: {
              ...field._f,
              ...radioOrCheckbox ? {
                refs: [
                  ...refs.filter(live),
                  fieldRef,
                  ...Array.isArray(get$6(_defaultValues, name2)) ? [{}] : []
                ],
                ref: { type: fieldRef.type, name: name2 }
              } : { ref: fieldRef }
            }
          });
          updateValidAndValue(name2, false, void 0, fieldRef);
        } else {
          field = get$6(_fields, name2, {});
          if (field._f) {
            field._f.mount = false;
          }
          (_options.shouldUnregister || options.shouldUnregister) && !(isNameInFieldArray(_names.array, name2) && _state.action) && _names.unMount.add(name2);
        }
      }
    };
  };
  const _focusError = () => _options.shouldFocusError && iterateFieldsByAction(_fields, _focusInput, _names.mount);
  const _disableForm = (disabled) => {
    if (isBoolean(disabled)) {
      _subjects.state.next({ disabled });
      iterateFieldsByAction(_fields, (ref2, name2) => {
        const currentField = get$6(_fields, name2);
        if (currentField) {
          ref2.disabled = currentField._f.disabled || disabled;
          if (Array.isArray(currentField._f.refs)) {
            currentField._f.refs.forEach((inputRef) => {
              inputRef.disabled = currentField._f.disabled || disabled;
            });
          }
        }
      }, 0, false);
    }
  };
  const handleSubmit = (onValid, onInvalid) => async (e) => {
    let onValidError = void 0;
    if (e) {
      e.preventDefault && e.preventDefault();
      e.persist && e.persist();
    }
    let fieldValues = cloneObject(_formValues);
    _subjects.state.next({
      isSubmitting: true
    });
    if (_options.resolver) {
      const { errors, values: values2 } = await _runSchema();
      _formState.errors = errors;
      fieldValues = cloneObject(values2);
    } else {
      await executeBuiltInValidation(_fields);
    }
    if (_names.disabled.size) {
      for (const name2 of _names.disabled) {
        unset(fieldValues, name2);
      }
    }
    unset(_formState.errors, "root");
    if (isEmptyObject$1(_formState.errors)) {
      _subjects.state.next({
        errors: {}
      });
      try {
        await onValid(fieldValues, e);
      } catch (error2) {
        onValidError = error2;
      }
    } else {
      if (onInvalid) {
        await onInvalid({ ..._formState.errors }, e);
      }
      _focusError();
      setTimeout(_focusError);
    }
    _subjects.state.next({
      isSubmitted: true,
      isSubmitting: false,
      isSubmitSuccessful: isEmptyObject$1(_formState.errors) && !onValidError,
      submitCount: _formState.submitCount + 1,
      errors: _formState.errors
    });
    if (onValidError) {
      throw onValidError;
    }
  };
  const resetField = (name2, options = {}) => {
    if (get$6(_fields, name2)) {
      if (isUndefined$1(options.defaultValue)) {
        setValue(name2, cloneObject(get$6(_defaultValues, name2)));
      } else {
        setValue(name2, options.defaultValue);
        set$3(_defaultValues, name2, cloneObject(options.defaultValue));
      }
      if (!options.keepTouched) {
        unset(_formState.touchedFields, name2);
      }
      if (!options.keepDirty) {
        unset(_formState.dirtyFields, name2);
        _formState.isDirty = options.defaultValue ? _getDirty(name2, cloneObject(get$6(_defaultValues, name2))) : _getDirty();
      }
      if (!options.keepError) {
        unset(_formState.errors, name2);
        _proxyFormState.isValid && _setValid();
      }
      _subjects.state.next({ ..._formState });
    }
  };
  const _reset = (formValues, keepStateOptions = {}) => {
    const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
    const cloneUpdatedValues = cloneObject(updatedValues);
    const isEmptyResetValues = isEmptyObject$1(formValues);
    const values2 = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
    if (!keepStateOptions.keepDefaultValues) {
      _defaultValues = updatedValues;
    }
    if (!keepStateOptions.keepValues) {
      if (keepStateOptions.keepDirtyValues) {
        const fieldsToCheck = /* @__PURE__ */ new Set([
          ..._names.mount,
          ...Object.keys(getDirtyFields(_defaultValues, _formValues))
        ]);
        for (const fieldName of Array.from(fieldsToCheck)) {
          get$6(_formState.dirtyFields, fieldName) ? set$3(values2, fieldName, get$6(_formValues, fieldName)) : setValue(fieldName, get$6(values2, fieldName));
        }
      } else {
        if (isWeb && isUndefined$1(formValues)) {
          for (const name2 of _names.mount) {
            const field = get$6(_fields, name2);
            if (field && field._f) {
              const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
              if (isHTMLElement$2(fieldReference)) {
                const form = fieldReference.closest("form");
                if (form) {
                  form.reset();
                  break;
                }
              }
            }
          }
        }
        if (keepStateOptions.keepFieldsRef) {
          for (const fieldName of _names.mount) {
            setValue(fieldName, get$6(values2, fieldName));
          }
        } else {
          _fields = {};
        }
      }
      _formValues = _options.shouldUnregister ? keepStateOptions.keepDefaultValues ? cloneObject(_defaultValues) : {} : cloneObject(values2);
      _subjects.array.next({
        values: { ...values2 }
      });
      _subjects.state.next({
        values: { ...values2 }
      });
    }
    _names = {
      mount: keepStateOptions.keepDirtyValues ? _names.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: false,
      focus: ""
    };
    _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
    _state.watch = !!_options.shouldUnregister;
    _subjects.state.next({
      submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
      isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !deepEqual$2(formValues, _defaultValues)),
      isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
      dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
      touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
      errors: keepStateOptions.keepErrors ? _formState.errors : {},
      isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
      isSubmitting: false
    });
  };
  const reset2 = (formValues, keepStateOptions) => _reset(isFunction$2(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
  const setFocus = (name2, options = {}) => {
    const field = get$6(_fields, name2);
    const fieldReference = field && field._f;
    if (fieldReference) {
      const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
      if (fieldRef.focus) {
        fieldRef.focus();
        options.shouldSelect && isFunction$2(fieldRef.select) && fieldRef.select();
      }
    }
  };
  const _setFormState = (updatedFormState) => {
    _formState = {
      ..._formState,
      ...updatedFormState
    };
  };
  const _resetDefaultValues = () => isFunction$2(_options.defaultValues) && _options.defaultValues().then((values2) => {
    reset2(values2, _options.resetOptions);
    _subjects.state.next({
      isLoading: false
    });
  });
  const methods = {
    control: {
      register: register2,
      unregister,
      getFieldState,
      handleSubmit,
      setError,
      _subscribe,
      _runSchema,
      _focusError,
      _getWatch,
      _getDirty,
      _setValid,
      _setFieldArray,
      _setDisabledField,
      _setErrors,
      _getFieldArray,
      _reset,
      _resetDefaultValues,
      _removeUnmounted,
      _disableForm,
      _subjects,
      _proxyFormState,
      get _fields() {
        return _fields;
      },
      get _formValues() {
        return _formValues;
      },
      get _state() {
        return _state;
      },
      set _state(value) {
        _state = value;
      },
      get _defaultValues() {
        return _defaultValues;
      },
      get _names() {
        return _names;
      },
      set _names(value) {
        _names = value;
      },
      get _formState() {
        return _formState;
      },
      get _options() {
        return _options;
      },
      set _options(value) {
        _options = {
          ..._options,
          ...value
        };
      }
    },
    subscribe,
    trigger,
    register: register2,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset: reset2,
    resetField,
    clearErrors,
    unregister,
    setError,
    setFocus,
    getFieldState
  };
  return {
    ...methods,
    formControl: methods
  };
}
var generateId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  const d2 = typeof performance === "undefined" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c2) => {
    const r2 = (Math.random() * 16 + d2) % 16 | 0;
    return (c2 == "x" ? r2 : r2 & 3 | 8).toString(16);
  });
};
var getFocusFieldName = (name2, index2, options = {}) => options.shouldFocus || isUndefined$1(options.shouldFocus) ? options.focusName || `${name2}.${isUndefined$1(options.focusIndex) ? index2 : options.focusIndex}.` : "";
var appendAt = (data, value) => [
  ...data,
  ...convertToArrayPayload(value)
];
var fillEmptyArray = (value) => Array.isArray(value) ? value.map(() => void 0) : void 0;
function insert(data, index2, value) {
  return [
    ...data.slice(0, index2),
    ...convertToArrayPayload(value),
    ...data.slice(index2)
  ];
}
var moveArrayAt = (data, from3, to2) => {
  if (!Array.isArray(data)) {
    return [];
  }
  if (isUndefined$1(data[to2])) {
    data[to2] = void 0;
  }
  data.splice(to2, 0, data.splice(from3, 1)[0]);
  return data;
};
var prependAt = (data, value) => [
  ...convertToArrayPayload(value),
  ...convertToArrayPayload(data)
];
function removeAtIndexes(data, indexes) {
  let i = 0;
  const temp = [...data];
  for (const index2 of indexes) {
    temp.splice(index2 - i, 1);
    i++;
  }
  return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index2) => isUndefined$1(index2) ? [] : removeAtIndexes(data, convertToArrayPayload(index2).sort((a2, b2) => a2 - b2));
var swapArrayAt = (data, indexA, indexB) => {
  [data[indexA], data[indexB]] = [data[indexB], data[indexA]];
};
var updateAt = (fieldValues, index2, value) => {
  fieldValues[index2] = value;
  return fieldValues;
};
function useFieldArray(props) {
  const methods = useFormContext();
  const { control = methods.control, name: name2, keyName: keyName2 = "id", shouldUnregister, rules } = props;
  const [fields, setFields] = React__default.useState(control._getFieldArray(name2));
  const ids2 = React__default.useRef(control._getFieldArray(name2).map(generateId));
  const _fieldIds = React__default.useRef(fields);
  const _actioned = React__default.useRef(false);
  _fieldIds.current = fields;
  control._names.array.add(name2);
  React__default.useMemo(() => rules && control.register(name2, rules), [control, rules, name2]);
  useIsomorphicLayoutEffect$4(() => control._subjects.array.subscribe({
    next: ({ values: values2, name: fieldArrayName }) => {
      if (fieldArrayName === name2 || !fieldArrayName) {
        const fieldValues = get$6(values2, name2);
        if (Array.isArray(fieldValues)) {
          setFields(fieldValues);
          ids2.current = fieldValues.map(generateId);
        }
      }
    }
  }).unsubscribe, [control, name2]);
  const updateValues = React__default.useCallback((updatedFieldArrayValues) => {
    _actioned.current = true;
    control._setFieldArray(name2, updatedFieldArrayValues);
  }, [control, name2]);
  const append3 = (value, options) => {
    const appendValue = convertToArrayPayload(cloneObject(value));
    const updatedFieldArrayValues = appendAt(control._getFieldArray(name2), appendValue);
    control._names.focus = getFocusFieldName(name2, updatedFieldArrayValues.length - 1, options);
    ids2.current = appendAt(ids2.current, appendValue.map(generateId));
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    control._setFieldArray(name2, updatedFieldArrayValues, appendAt, {
      argA: fillEmptyArray(value)
    });
  };
  const prepend2 = (value, options) => {
    const prependValue = convertToArrayPayload(cloneObject(value));
    const updatedFieldArrayValues = prependAt(control._getFieldArray(name2), prependValue);
    control._names.focus = getFocusFieldName(name2, 0, options);
    ids2.current = prependAt(ids2.current, prependValue.map(generateId));
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    control._setFieldArray(name2, updatedFieldArrayValues, prependAt, {
      argA: fillEmptyArray(value)
    });
  };
  const remove = (index2) => {
    const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name2), index2);
    ids2.current = removeArrayAt(ids2.current, index2);
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    !Array.isArray(get$6(control._fields, name2)) && set$3(control._fields, name2, void 0);
    control._setFieldArray(name2, updatedFieldArrayValues, removeArrayAt, {
      argA: index2
    });
  };
  const insert$1 = (index2, value, options) => {
    const insertValue = convertToArrayPayload(cloneObject(value));
    const updatedFieldArrayValues = insert(control._getFieldArray(name2), index2, insertValue);
    control._names.focus = getFocusFieldName(name2, index2, options);
    ids2.current = insert(ids2.current, index2, insertValue.map(generateId));
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    control._setFieldArray(name2, updatedFieldArrayValues, insert, {
      argA: index2,
      argB: fillEmptyArray(value)
    });
  };
  const swap2 = (indexA, indexB) => {
    const updatedFieldArrayValues = control._getFieldArray(name2);
    swapArrayAt(updatedFieldArrayValues, indexA, indexB);
    swapArrayAt(ids2.current, indexA, indexB);
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    control._setFieldArray(name2, updatedFieldArrayValues, swapArrayAt, {
      argA: indexA,
      argB: indexB
    }, false);
  };
  const move4 = (from3, to2) => {
    const updatedFieldArrayValues = control._getFieldArray(name2);
    moveArrayAt(updatedFieldArrayValues, from3, to2);
    moveArrayAt(ids2.current, from3, to2);
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    control._setFieldArray(name2, updatedFieldArrayValues, moveArrayAt, {
      argA: from3,
      argB: to2
    }, false);
  };
  const update2 = (index2, value) => {
    const updateValue = cloneObject(value);
    const updatedFieldArrayValues = updateAt(control._getFieldArray(name2), index2, updateValue);
    ids2.current = [...updatedFieldArrayValues].map((item, i) => !item || i === index2 ? generateId() : ids2.current[i]);
    updateValues(updatedFieldArrayValues);
    setFields([...updatedFieldArrayValues]);
    control._setFieldArray(name2, updatedFieldArrayValues, updateAt, {
      argA: index2,
      argB: updateValue
    }, true, false);
  };
  const replace2 = (value) => {
    const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
    ids2.current = updatedFieldArrayValues.map(generateId);
    updateValues([...updatedFieldArrayValues]);
    setFields([...updatedFieldArrayValues]);
    control._setFieldArray(name2, [...updatedFieldArrayValues], (data) => data, {}, true, false);
  };
  React__default.useEffect(() => {
    control._state.action = false;
    isWatched(name2, control._names) && control._subjects.state.next({
      ...control._formState
    });
    if (_actioned.current && (!getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted) && !getValidationModes(control._options.reValidateMode).isOnSubmit) {
      if (control._options.resolver) {
        control._runSchema([name2]).then((result) => {
          const error2 = get$6(result.errors, name2);
          const existingError = get$6(control._formState.errors, name2);
          if (existingError ? !error2 && existingError.type || error2 && (existingError.type !== error2.type || existingError.message !== error2.message) : error2 && error2.type) {
            error2 ? set$3(control._formState.errors, name2, error2) : unset(control._formState.errors, name2);
            control._subjects.state.next({
              errors: control._formState.errors
            });
          }
        });
      } else {
        const field = get$6(control._fields, name2);
        if (field && field._f && !(getValidationModes(control._options.reValidateMode).isOnSubmit && getValidationModes(control._options.mode).isOnSubmit)) {
          validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error2) => !isEmptyObject$1(error2) && control._subjects.state.next({
            errors: updateFieldArrayRootError(control._formState.errors, error2, name2)
          }));
        }
      }
    }
    control._subjects.state.next({
      name: name2,
      values: cloneObject(control._formValues)
    });
    control._names.focus && iterateFieldsByAction(control._fields, (ref2, key2) => {
      if (control._names.focus && key2.startsWith(control._names.focus) && ref2.focus) {
        ref2.focus();
        return 1;
      }
      return;
    });
    control._names.focus = "";
    control._setValid();
    _actioned.current = false;
  }, [fields, name2, control]);
  React__default.useEffect(() => {
    !get$6(control._formValues, name2) && control._setFieldArray(name2);
    return () => {
      const updateMounted = (name3, value) => {
        const field = get$6(control._fields, name3);
        if (field && field._f) {
          field._f.mount = value;
        }
      };
      control._options.shouldUnregister || shouldUnregister ? control.unregister(name2) : updateMounted(name2, false);
    };
  }, [name2, control, keyName2, shouldUnregister]);
  return {
    swap: React__default.useCallback(swap2, [updateValues, name2, control]),
    move: React__default.useCallback(move4, [updateValues, name2, control]),
    prepend: React__default.useCallback(prepend2, [updateValues, name2, control]),
    append: React__default.useCallback(append3, [updateValues, name2, control]),
    remove: React__default.useCallback(remove, [updateValues, name2, control]),
    insert: React__default.useCallback(insert$1, [updateValues, name2, control]),
    update: React__default.useCallback(update2, [updateValues, name2, control]),
    replace: React__default.useCallback(replace2, [updateValues, name2, control]),
    fields: React__default.useMemo(() => fields.map((field, index2) => ({
      ...field,
      [keyName2]: ids2.current[index2] || generateId()
    })), [fields, keyName2])
  };
}
function useForm(props = {}) {
  const _formControl = React__default.useRef(void 0);
  const _values = React__default.useRef(void 0);
  const [formState, updateFormState] = React__default.useState({
    isDirty: false,
    isValidating: false,
    isLoading: isFunction$2(props.defaultValues),
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: props.errors || {},
    disabled: props.disabled || false,
    isReady: false,
    defaultValues: isFunction$2(props.defaultValues) ? void 0 : props.defaultValues
  });
  if (!_formControl.current) {
    if (props.formControl) {
      _formControl.current = {
        ...props.formControl,
        formState
      };
      if (props.defaultValues && !isFunction$2(props.defaultValues)) {
        props.formControl.reset(props.defaultValues, props.resetOptions);
      }
    } else {
      const { formControl, ...rest } = createFormControl(props);
      _formControl.current = {
        ...rest,
        formState
      };
    }
  }
  const control = _formControl.current.control;
  control._options = props;
  useIsomorphicLayoutEffect$4(() => {
    const sub = control._subscribe({
      formState: control._proxyFormState,
      callback: () => updateFormState({ ...control._formState }),
      reRenderRoot: true
    });
    updateFormState((data) => ({
      ...data,
      isReady: true
    }));
    control._formState.isReady = true;
    return sub;
  }, [control]);
  React__default.useEffect(() => control._disableForm(props.disabled), [control, props.disabled]);
  React__default.useEffect(() => {
    if (props.mode) {
      control._options.mode = props.mode;
    }
    if (props.reValidateMode) {
      control._options.reValidateMode = props.reValidateMode;
    }
  }, [control, props.mode, props.reValidateMode]);
  React__default.useEffect(() => {
    if (props.errors) {
      control._setErrors(props.errors);
      control._focusError();
    }
  }, [control, props.errors]);
  React__default.useEffect(() => {
    props.shouldUnregister && control._subjects.state.next({
      values: control._getWatch()
    });
  }, [control, props.shouldUnregister]);
  React__default.useEffect(() => {
    if (control._proxyFormState.isDirty) {
      const isDirty2 = control._getDirty();
      if (isDirty2 !== formState.isDirty) {
        control._subjects.state.next({
          isDirty: isDirty2
        });
      }
    }
  }, [control, formState.isDirty]);
  React__default.useEffect(() => {
    if (props.values && !deepEqual$2(props.values, _values.current)) {
      control._reset(props.values, {
        keepFieldsRef: true,
        ...control._options.resetOptions
      });
      _values.current = props.values;
      updateFormState((state) => ({ ...state }));
    } else {
      control._resetDefaultValues();
    }
  }, [control, props.values]);
  React__default.useEffect(() => {
    if (!control._state.mount) {
      control._setValid();
      control._state.mount = true;
    }
    if (control._state.watch) {
      control._state.watch = false;
      control._subjects.state.next({ ...control._formState });
    }
    control._removeUnmounted();
  });
  _formControl.current.formState = getProxyFormState(formState, control);
  return _formControl.current;
}
const useTracks = () => {
  var _a3;
  const [selectedTracks, setSelectedTracks] = useState([]);
  const { tracks } = useAdminApi();
  const queryResult = useQuery(
    ["tracks"],
    () => tracks.getTracks()
  );
  const result = {
    ...queryResult,
    selectedTracks,
    selectTracks: setSelectedTracks
  };
  if ((_a3 = result == null ? void 0 : result.data) == null ? void 0 : _a3.length) {
    result.tracks = getSortedItems(result.data);
  }
  return result;
};
const reducer$4 = (state, action) => {
  switch (action.type) {
    case "remove_invite":
      return state.filter(
        (i) => !idsEqual(i.inviterTrackId, action.inviterTrackId)
      );
    case "add_invite":
      return [
        ...state,
        {
          inviterTrackId: action.inviterTrackId,
          numberOfInvites: action.numberOfInvites
        }
      ];
    case "update_invite":
      return state.map(
        (i) => idsEqual(i.inviterTrackId, action.inviterTrackId) ? { ...i, numberOfInvites: action.numberOfInvites } : i
      );
  }
};
const canDeleteTrack = (track2) => track2.numberBooked === void 0 || track2.numberBooked === 0;
const trackHasBookings = (track2) => track2.numberBooked !== void 0 && track2.numberBooked > 0;
const isTrackWithBookings = (track2) => track2 !== void 0 && trackHasBookings(track2);
const getInvitingTracks = (guestTrack, tracks) => tracks.filter(
  (t2) => t2.isGuestTrack !== true && (guestTrack.id === void 0 || !idsEqual(t2.id, guestTrack.id))
);
const guestInvitesFor = (guestTrack, otherTrack) => {
  var _a3, _b;
  return (_b = (_a3 = guestTrack.guestInvites) == null ? void 0 : _a3.find(
    (invite) => idsEqual(invite.inviterTrackId, otherTrack.id)
  )) == null ? void 0 : _b.numberOfInvites;
};
const canPrePop = (field) => {
  switch (field.type) {
    case "info":
    case "session_booking":
    case "attendee_reference":
    case "room_block":
      return false;
    case "section":
    case "page":
      return field.fields.some(canPrePop);
    default:
      return true;
  }
};
const prePopChildren = (field) => field.fields.filter(canPrePop);
const fieldIsPrePop = (field, prePopFields) => {
  switch (field.type) {
    case "page":
    case "section":
      return prePopChildren(field).every(
        (field2) => fieldIsPrePop(field2, prePopFields)
      );
    default:
      return prePopFields.includes(field.name);
  }
};
const isTrackWithCapacity = (track2) => trackTotalCapacity(track2) !== void 0;
const isUnlimitedCapacity = (track2) => !isTrackWithCapacity(track2);
const isGuestTrack = (track2) => track2.isGuestTrack === true;
const invitesWithTrack = (guestTrack, tracks) => {
  var _a3;
  if (guestTrack.guestInvites === void 0) {
    return [];
  }
  return (_a3 = guestTrack.guestInvites) == null ? void 0 : _a3.reduce(
    (result, invite) => {
      const inviterTrack = tracks.find((t2) => t2.id === invite.inviterTrackId);
      if (inviterTrack !== void 0) {
        result.push({
          numberOfInvites: invite.numberOfInvites,
          inviterTrack
        });
      }
      return result;
    },
    []
  );
};
const guestTrackCapacityViaInvites = (guestTrack, tracks) => {
  const invites = invitesWithTrack(guestTrack, tracks);
  if (invites.some(({ inviterTrack }) => isUnlimitedCapacity(inviterTrack))) {
    return void 0;
  }
  return invites.reduce((tally, invite) => {
    if (isTrackWithCapacity(invite.inviterTrack)) {
      return tally + invite.numberOfInvites * (trackTotalCapacity(invite.inviterTrack) || 0);
    } else {
      return tally;
    }
  }, 0);
};
const trackTotalCapacity = (track2) => {
  const sum = track2.ticketTypes.reduce(
    (acc, tt2) => tt2.capacity !== void 0 ? acc + tt2.capacity : acc,
    0
  );
  if (sum === 0) {
    return void 0;
  } else {
    return sum;
  }
};
const guestTrackCapacity = (guestTrack, tracks) => {
  const assignedCapacity = trackTotalCapacity(guestTrack);
  const inviteCapacity = guestTrackCapacityViaInvites(guestTrack, tracks);
  if (assignedCapacity === void 0 && inviteCapacity === void 0) {
    return void 0;
  }
  if (assignedCapacity === void 0) {
    return inviteCapacity;
  }
  if (inviteCapacity === void 0) {
    return assignedCapacity;
  }
  return Math.min(assignedCapacity, inviteCapacity);
};
const trackCapacity = (track2, tracks) => isGuestTrack(track2) ? guestTrackCapacity(track2, tracks) : trackTotalCapacity(track2);
const getTrackPrice = (track2) => {
  const prices = track2.ticketTypes.map((t2) => t2.priceInCents).filter((t2) => t2 !== void 0);
  if (prices.length === 0) {
    return null;
  }
  const max2 = Math.max(...prices);
  const min2 = Math.min(...prices);
  if (min2 === max2) {
    return min2;
  }
  return { min: min2, max: max2 };
};
const GuestInviteInput$1 = ({
  guestTrack,
  inviterTrack,
  maxInvites,
  onChange
}) => {
  const [value, setValue] = useState(
    guestInvitesFor(guestTrack, inviterTrack)
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    NumberInput,
    {
      min: 0,
      max: maxInvites,
      value,
      onChange: (valueAsString, valueAsNumber) => {
        if (isNaN(valueAsNumber)) {
          setValue(void 0);
        } else {
          setValue(valueAsNumber);
        }
        onChange(valueAsNumber);
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(NumberInputField, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(NumberInputStepper, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(NumberIncrementStepper, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(NumberDecrementStepper, {})
        ] })
      ]
    }
  );
};
const MAX_GUEST_BOOKINGS$1 = 10;
const GuestTrackInvites$1 = ({
  guestTrack,
  onChange
}) => {
  const { data: tracks, error: error2 } = useTracks();
  const [guestInvites, dispatch] = useReducer(
    reducer$4,
    guestTrack.guestInvites || []
  );
  useEffect(() => {
    onChange(guestInvites);
  }, [guestInvites]);
  if (error2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { status: "error", children: "Error loading tracks" });
  }
  if (tracks === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {});
  }
  const handleInvitesChange = (track2, numberOfInvites) => {
    if (isNaN(numberOfInvites) || numberOfInvites === 0) {
      dispatch({ type: "remove_invite", inviterTrackId: track2.id });
    } else if (guestInvites.some((i) => idsEqual(i.inviterTrackId, track2.id))) {
      dispatch({
        type: "update_invite",
        inviterTrackId: track2.id,
        numberOfInvites
      });
    } else {
      dispatch({
        type: "add_invite",
        inviterTrackId: track2.id,
        numberOfInvites
      });
    }
  };
  const invitingTracks = getInvitingTracks(guestTrack, tracks);
  if (invitingTracks.length === 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { status: "warning", children: "Please add at least one non-guest track to set guest invite options." }) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", px: 4, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { mb: 4, children: "Select the number of guests that can be added to this track by attendees registering on other tracks on this event." }),
    getInvitingTracks(guestTrack, tracks).map((track2) => /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { justifyContent: "space-between", alignItems: "start", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FormLabel, { pt: 1, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: track2.name }),
        " track number of guests"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { maxW: "70px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        GuestInviteInput$1,
        {
          guestTrack,
          inviterTrack: track2,
          maxInvites: MAX_GUEST_BOOKINGS$1,
          onChange: (value) => handleInvitesChange(track2, value)
        }
      ) })
    ] }) }, track2.id))
  ] }) });
};
const ticketTypeDefaults = {
  name: "Admission",
  sort: 1
};
const initTicketType$1 = (ticketType) => ({
  ...ticketType,
  isNew: true,
  id: idGenerator()
});
const defaultTicketType = () => initTicketType$1(ticketTypeDefaults);
const initTicketType = (ticketType) => ({
  ...ticketType,
  isNew: true,
  id: idGenerator()
});
const ticketTypeReducer = (state, action) => {
  console.log("ticket type reducer action", action);
  return fn(state, (draft) => {
    var _a3;
    switch (action.type) {
      case "add_ticket_type": {
        if (draft.ticketTypes === void 0) {
          draft.ticketTypes = [];
        }
        draft.ticketTypes.push(initTicketType(action.payload));
        break;
      }
      case "update_ticket_type": {
        const index2 = (_a3 = draft == null ? void 0 : draft.ticketTypes) == null ? void 0 : _a3.findIndex(
          (t2) => idsEqual(t2.id, action.payload.id)
        );
        if (index2 === -1 || index2 === void 0 || draft.ticketTypes === void 0) {
          console.error("Missing ticket type index", action.payload.id);
          break;
        }
        draft.ticketTypes[index2] = {
          ...draft.ticketTypes[index2],
          ...action.payload
        };
        if (draft.ticketTypes[index2].name === void 0 || draft.ticketTypes[index2].name === "" || draft.ticketTypes[index2].name === null) {
          draft.ticketTypes[index2].name = ticketTypeDefaults.name;
        }
        break;
      }
      case "delete_ticket_type": {
        if (draft.ticketTypes === void 0) {
          console.error("No ticket types to delete");
          break;
        }
        draft.ticketTypes = draft.ticketTypes.filter(
          (t2) => !idsEqual(t2.id, action.payload.id)
        );
        if (draft.deletedTicketTypes === void 0) {
          draft.deletedTicketTypes = [];
        }
        draft.deletedTicketTypes.push(action.payload.id);
        break;
      }
      case "move_ticket_type": {
        if (draft.ticketTypes === void 0) {
          console.error("Can't move empty ticket types");
          break;
        }
        const ticketType = draft.ticketTypes[action.payload.fromIndex];
        ticketType.sort = getNewSort(
          draft.ticketTypes,
          action.payload.fromIndex,
          action.payload.toIndex
        );
        draft.ticketTypes = getSortedItems(draft.ticketTypes);
        break;
      }
    }
  });
};
const initializeValue = (value) => value === null ? void 0 : value;
const IntegerInput = ({
  onChange,
  value: initialValue,
  ...props
}) => {
  const [value, setValue] = useState(
    initializeValue(initialValue)
  );
  useEffect(() => {
    setValue(initializeValue(initialValue));
  }, [initialValue]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    NumberInput,
    {
      ...props,
      value: value === null ? void 0 : value,
      onChange: (valueAsString, valueAsNumber) => {
        setValue(valueAsString);
        if (!isNaN(valueAsNumber)) {
          if (Number.isInteger(valueAsNumber)) {
            onChange(valueAsNumber);
          } else {
            const valueAsInteger = Math.floor(valueAsNumber);
            setValue(valueAsInteger);
            onChange(valueAsInteger);
          }
        } else if (valueAsString === "") {
          onChange(void 0);
        }
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(NumberInputField, { style: { marginBottom: 0 } }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(NumberInputStepper, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(NumberIncrementStepper, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(NumberDecrementStepper, {})
        ] })
      ]
    }
  );
};
const PercentageInput$1 = ({
  onChange,
  value: initialValue,
  ...props
}) => {
  const [value, setValue] = useState(initialValue);
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    NumberInput,
    {
      ...props,
      value,
      onChange: (valueAsString, valueAsNumber) => {
        setValue(valueAsString);
        if (!isNaN(valueAsNumber)) {
          onChange(valueAsNumber);
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(InputGroup, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(InputLeftAddon, { pl: 2, pr: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { as: "span", fontSize: "md", children: "%" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(NumberInputField, { style: { marginBottom: 0 } })
      ] })
    }
  );
};
const PriceInput$3 = ({
  valueInCents,
  defaultValue: defaultValue2,
  currency = "$",
  precision = 2,
  onChange,
  inputFieldProps = {},
  ...props
}) => {
  const [value, setValue] = useState(defaultValue2);
  useEffect(() => {
    if (valueInCents === void 0 || valueInCents === null) {
      return;
    }
    if (value !== (valueInCents / 100).toFixed(1)) {
      setValue(formatCents(valueInCents));
    }
  }, [valueInCents]);
  const handleChange = (valueString, valueAsNumber) => {
    setValue(valueString);
    if (!isNaN(valueAsNumber)) {
      onChange(numberToCents(valueAsNumber));
    } else {
      onChange(void 0);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    NumberInput,
    {
      defaultValue: defaultValue2,
      precision: Number.isInteger(Number(value)) ? 0 : precision,
      focusInputOnChange: false,
      size: "md",
      min: 0,
      onChange: handleChange,
      value,
      ...props,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(InputGroup, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(InputLeftAddon, { pl: 2, pr: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { as: "span", fontSize: "md", children: currency }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(NumberInputField, { style: { marginBottom: 0 }, ...inputFieldProps })
      ] })
    }
  );
};
function tzTokenizeDate(date, timeZone) {
  const dtf = getDateTimeFormat(timeZone);
  return "formatToParts" in dtf ? partsOffset(dtf, date) : hackyOffset(dtf, date);
}
const typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function partsOffset(dtf, date) {
  try {
    const formatted = dtf.formatToParts(date);
    const filled = [];
    for (let i = 0; i < formatted.length; i++) {
      const pos = typeToPos[formatted[i].type];
      if (pos !== void 0) {
        filled[pos] = parseInt(formatted[i].value, 10);
      }
    }
    return filled;
  } catch (error2) {
    if (error2 instanceof RangeError) {
      return [NaN];
    }
    throw error2;
  }
}
function hackyOffset(dtf, date) {
  const formatted = dtf.format(date);
  const parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
  return [
    parseInt(parsed[3], 10),
    parseInt(parsed[1], 10),
    parseInt(parsed[2], 10),
    parseInt(parsed[4], 10),
    parseInt(parsed[5], 10),
    parseInt(parsed[6], 10)
  ];
}
const dtfCache = {};
const testDateFormatted = new Intl.DateTimeFormat("en-US", {
  hourCycle: "h23",
  timeZone: "America/New_York",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z"));
const hourCycleSupported = testDateFormatted === "06/25/2014, 00:00:00" || testDateFormatted === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function getDateTimeFormat(timeZone) {
  if (!dtfCache[timeZone]) {
    dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return dtfCache[timeZone];
}
function newDateUTC(fullYear, month, day, hour, minute, second, millisecond) {
  const utcDate = /* @__PURE__ */ new Date(0);
  utcDate.setUTCFullYear(fullYear, month, day);
  utcDate.setUTCHours(hour, minute, second, millisecond);
  return utcDate;
}
const MILLISECONDS_IN_HOUR$1 = 36e5;
const MILLISECONDS_IN_MINUTE$1 = 6e4;
const patterns$2 = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function tzParseTimezone(timezoneString, date, isUtcDate) {
  if (!timezoneString) {
    return 0;
  }
  let token2 = patterns$2.timezoneZ.exec(timezoneString);
  if (token2) {
    return 0;
  }
  let hours2;
  let absoluteOffset;
  token2 = patterns$2.timezoneHH.exec(timezoneString);
  if (token2) {
    hours2 = parseInt(token2[1], 10);
    if (!validateTimezone$1(hours2)) {
      return NaN;
    }
    return -(hours2 * MILLISECONDS_IN_HOUR$1);
  }
  token2 = patterns$2.timezoneHHMM.exec(timezoneString);
  if (token2) {
    hours2 = parseInt(token2[2], 10);
    const minutes2 = parseInt(token2[3], 10);
    if (!validateTimezone$1(hours2, minutes2)) {
      return NaN;
    }
    absoluteOffset = Math.abs(hours2) * MILLISECONDS_IN_HOUR$1 + minutes2 * MILLISECONDS_IN_MINUTE$1;
    return token2[1] === "+" ? -absoluteOffset : absoluteOffset;
  }
  if (isValidTimezoneIANAString(timezoneString)) {
    date = new Date(date || Date.now());
    const utcDate = isUtcDate ? date : toUtcDate(date);
    const offset3 = calcOffset(utcDate, timezoneString);
    const fixedOffset = isUtcDate ? offset3 : fixOffset(date, offset3, timezoneString);
    return -fixedOffset;
  }
  return NaN;
}
function toUtcDate(date) {
  return newDateUTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function calcOffset(date, timezoneString) {
  const tokens2 = tzTokenizeDate(date, timezoneString);
  const asUTC = newDateUTC(tokens2[0], tokens2[1] - 1, tokens2[2], tokens2[3] % 24, tokens2[4], tokens2[5], 0).getTime();
  let asTS = date.getTime();
  const over = asTS % 1e3;
  asTS -= over >= 0 ? over : 1e3 + over;
  return asUTC - asTS;
}
function fixOffset(date, offset3, timezoneString) {
  const localTS = date.getTime();
  let utcGuess = localTS - offset3;
  const o2 = calcOffset(new Date(utcGuess), timezoneString);
  if (offset3 === o2) {
    return offset3;
  }
  utcGuess -= o2 - offset3;
  const o3 = calcOffset(new Date(utcGuess), timezoneString);
  if (o2 === o3) {
    return o2;
  }
  return Math.max(o2, o3);
}
function validateTimezone$1(hours2, minutes2) {
  return -23 <= hours2 && hours2 <= 23 && (minutes2 == null || 0 <= minutes2 && minutes2 <= 59);
}
const validIANATimezoneCache = {};
function isValidTimezoneIANAString(timeZoneString) {
  if (validIANATimezoneCache[timeZoneString])
    return true;
  try {
    new Intl.DateTimeFormat(void 0, { timeZone: timeZoneString });
    validIANATimezoneCache[timeZoneString] = true;
    return true;
  } catch (error2) {
    return false;
  }
}
function getTimezoneOffsetInMilliseconds$1(date) {
  const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return +date - +utcDate;
}
const tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
const MILLISECONDS_IN_HOUR = 36e5;
const MILLISECONDS_IN_MINUTE = 6e4;
const DEFAULT_ADDITIONAL_DIGITS = 2;
const patterns$1 = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: tzPattern
};
function toDate$2(argument, options = {}) {
  if (arguments.length < 1) {
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  }
  if (argument === null) {
    return /* @__PURE__ */ new Date(NaN);
  }
  const additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : Number(options.additionalDigits);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  }
  if (argument instanceof Date || typeof argument === "object" && Object.prototype.toString.call(argument) === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || Object.prototype.toString.call(argument) === "[object Number]") {
    return new Date(argument);
  } else if (!(Object.prototype.toString.call(argument) === "[object String]")) {
    return /* @__PURE__ */ new Date(NaN);
  }
  const dateStrings = splitDateString$1(argument);
  const { year, restDateString } = parseYear$1(dateStrings.date, additionalDigits);
  const date = parseDate$2(restDateString, year);
  if (date === null || isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (date) {
    const timestamp = date.getTime();
    let time = 0;
    let offset3;
    if (dateStrings.time) {
      time = parseTime$1(dateStrings.time);
      if (time === null || isNaN(time)) {
        return /* @__PURE__ */ new Date(NaN);
      }
    }
    if (dateStrings.timeZone || options.timeZone) {
      offset3 = tzParseTimezone(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
      if (isNaN(offset3)) {
        return /* @__PURE__ */ new Date(NaN);
      }
    } else {
      offset3 = getTimezoneOffsetInMilliseconds$1(new Date(timestamp + time));
      offset3 = getTimezoneOffsetInMilliseconds$1(new Date(timestamp + time + offset3));
    }
    return new Date(timestamp + time + offset3);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
}
function splitDateString$1(dateString) {
  const dateStrings = {};
  let parts = patterns$1.dateTimePattern.exec(dateString);
  let timeString;
  if (!parts) {
    parts = patterns$1.datePattern.exec(dateString);
    if (parts) {
      dateStrings.date = parts[1];
      timeString = parts[2];
    } else {
      dateStrings.date = null;
      timeString = dateString;
    }
  } else {
    dateStrings.date = parts[1];
    timeString = parts[3];
  }
  if (timeString) {
    const token2 = patterns$1.timeZone.exec(timeString);
    if (token2) {
      dateStrings.time = timeString.replace(token2[1], "");
      dateStrings.timeZone = token2[1].trim();
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear$1(dateString, additionalDigits) {
  if (dateString) {
    const patternYYY = patterns$1.YYY[additionalDigits];
    const patternYYYYY = patterns$1.YYYYY[additionalDigits];
    let token2 = patterns$1.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token2) {
      const yearString = token2[1];
      return {
        year: parseInt(yearString, 10),
        restDateString: dateString.slice(yearString.length)
      };
    }
    token2 = patterns$1.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token2) {
      const centuryString = token2[1];
      return {
        year: parseInt(centuryString, 10) * 100,
        restDateString: dateString.slice(centuryString.length)
      };
    }
  }
  return {
    year: null
  };
}
function parseDate$2(dateString, year) {
  if (year === null) {
    return null;
  }
  let date;
  let month;
  let week;
  if (!dateString || !dateString.length) {
    date = /* @__PURE__ */ new Date(0);
    date.setUTCFullYear(year);
    return date;
  }
  let token2 = patterns$1.MM.exec(dateString);
  if (token2) {
    date = /* @__PURE__ */ new Date(0);
    month = parseInt(token2[1], 10) - 1;
    if (!validateDate$1(year, month)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    date.setUTCFullYear(year, month);
    return date;
  }
  token2 = patterns$1.DDD.exec(dateString);
  if (token2) {
    date = /* @__PURE__ */ new Date(0);
    const dayOfYear = parseInt(token2[1], 10);
    if (!validateDayOfYearDate$1(year, dayOfYear)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    date.setUTCFullYear(year, 0, dayOfYear);
    return date;
  }
  token2 = patterns$1.MMDD.exec(dateString);
  if (token2) {
    date = /* @__PURE__ */ new Date(0);
    month = parseInt(token2[1], 10) - 1;
    const day = parseInt(token2[2], 10);
    if (!validateDate$1(year, month, day)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    date.setUTCFullYear(year, month, day);
    return date;
  }
  token2 = patterns$1.Www.exec(dateString);
  if (token2) {
    week = parseInt(token2[1], 10) - 1;
    if (!validateWeekDate$1(week)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    return dayOfISOWeekYear$1(year, week);
  }
  token2 = patterns$1.WwwD.exec(dateString);
  if (token2) {
    week = parseInt(token2[1], 10) - 1;
    const dayOfWeek = parseInt(token2[2], 10) - 1;
    if (!validateWeekDate$1(week, dayOfWeek)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    return dayOfISOWeekYear$1(year, week, dayOfWeek);
  }
  return null;
}
function parseTime$1(timeString) {
  let hours2;
  let minutes2;
  let token2 = patterns$1.HH.exec(timeString);
  if (token2) {
    hours2 = parseFloat(token2[1].replace(",", "."));
    if (!validateTime$1(hours2)) {
      return NaN;
    }
    return hours2 % 24 * MILLISECONDS_IN_HOUR;
  }
  token2 = patterns$1.HHMM.exec(timeString);
  if (token2) {
    hours2 = parseInt(token2[1], 10);
    minutes2 = parseFloat(token2[2].replace(",", "."));
    if (!validateTime$1(hours2, minutes2)) {
      return NaN;
    }
    return hours2 % 24 * MILLISECONDS_IN_HOUR + minutes2 * MILLISECONDS_IN_MINUTE;
  }
  token2 = patterns$1.HHMMSS.exec(timeString);
  if (token2) {
    hours2 = parseInt(token2[1], 10);
    minutes2 = parseInt(token2[2], 10);
    const seconds2 = parseFloat(token2[3].replace(",", "."));
    if (!validateTime$1(hours2, minutes2, seconds2)) {
      return NaN;
    }
    return hours2 % 24 * MILLISECONDS_IN_HOUR + minutes2 * MILLISECONDS_IN_MINUTE + seconds2 * 1e3;
  }
  return null;
}
function dayOfISOWeekYear$1(isoWeekYear, week, day) {
  week = week || 0;
  day = day || 0;
  const date = /* @__PURE__ */ new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  const fourthOfJanuaryDay = date.getUTCDay() || 7;
  const diff2 = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff2);
  return date;
}
const DAYS_IN_MONTH$1 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const DAYS_IN_MONTH_LEAP_YEAR$1 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex$2(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate$1(year, month, date) {
  if (month < 0 || month > 11) {
    return false;
  }
  if (date != null) {
    if (date < 1) {
      return false;
    }
    const isLeapYear2 = isLeapYearIndex$2(year);
    if (isLeapYear2 && date > DAYS_IN_MONTH_LEAP_YEAR$1[month]) {
      return false;
    }
    if (!isLeapYear2 && date > DAYS_IN_MONTH$1[month]) {
      return false;
    }
  }
  return true;
}
function validateDayOfYearDate$1(year, dayOfYear) {
  if (dayOfYear < 1) {
    return false;
  }
  const isLeapYear2 = isLeapYearIndex$2(year);
  if (isLeapYear2 && dayOfYear > 366) {
    return false;
  }
  if (!isLeapYear2 && dayOfYear > 365) {
    return false;
  }
  return true;
}
function validateWeekDate$1(week, day) {
  if (week < 0 || week > 52) {
    return false;
  }
  if (day != null && (day < 0 || day > 6)) {
    return false;
  }
  return true;
}
function validateTime$1(hours2, minutes2, seconds2) {
  if (hours2 < 0 || hours2 >= 25) {
    return false;
  }
  if (minutes2 != null && (minutes2 < 0 || minutes2 >= 60)) {
    return false;
  }
  if (seconds2 != null && (seconds2 < 0 || seconds2 >= 60)) {
    return false;
  }
  return true;
}
function toZonedTime(date, timeZone, options) {
  date = toDate$2(date, options);
  const offsetMilliseconds = tzParseTimezone(timeZone, date, true);
  const d2 = new Date(date.getTime() - offsetMilliseconds);
  const resultDate = /* @__PURE__ */ new Date(0);
  resultDate.setFullYear(d2.getUTCFullYear(), d2.getUTCMonth(), d2.getUTCDate());
  resultDate.setHours(d2.getUTCHours(), d2.getUTCMinutes(), d2.getUTCSeconds(), d2.getUTCMilliseconds());
  return resultDate;
}
function getTimezoneOffset(timeZone, date) {
  return -tzParseTimezone(timeZone, date);
}
function r(e) {
  var t2, f2, n2 = "";
  if ("string" == typeof e || "number" == typeof e) n2 += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o2 = e.length;
    for (t2 = 0; t2 < o2; t2++) e[t2] && (f2 = r(e[t2])) && (n2 && (n2 += " "), n2 += f2);
  } else for (f2 in e) e[f2] && (n2 && (n2 += " "), n2 += f2);
  return n2;
}
function clsx() {
  for (var e, t2, f2 = 0, n2 = "", o2 = arguments.length; f2 < o2; f2++) (e = arguments[f2]) && (t2 = r(e)) && (n2 && (n2 += " "), n2 += t2);
  return n2;
}
function isDate$1(value) {
  return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
function toDate$1(argument) {
  const argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
    return new argument.constructor(+argument);
  } else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") {
    return new Date(argument);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
}
function isValid$5(date) {
  if (!isDate$1(date) && typeof date !== "number") {
    return false;
  }
  const _date = toDate$1(date);
  return !isNaN(Number(_date));
}
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
const formatDistance = (token2, count2, options) => {
  let result;
  const tokenValue = formatDistanceLocale[token2];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count2 === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count2.toString());
  }
  if (options == null ? void 0 : options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
function buildFormatLongFn(args) {
  return (options = {}) => {
    const width2 = options.width ? String(options.width) : args.defaultWidth;
    const format2 = args.formats[width2] || args.formats[args.defaultWidth];
    return format2;
  };
}
const dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
const timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
const dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
const formatRelative = (token2, _date, _baseDate, _options) => formatRelativeLocale[token2];
function buildLocalizeFn(args) {
  return (value, options) => {
    const context = (options == null ? void 0 : options.context) ? String(options.context) : "standalone";
    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width2 = (options == null ? void 0 : options.width) ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width2] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width2 = (options == null ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[width2] || args.values[defaultWidth];
    }
    const index2 = args.argumentCallback ? args.argumentCallback(value) : value;
    return valuesArray[index2];
  };
}
const eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};
const dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
};
const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
const ordinalNumber = (dirtyNumber, _options) => {
  const number2 = Number(dirtyNumber);
  const rem100 = number2 % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number2 + "st";
      case 2:
        return number2 + "nd";
      case 3:
        return number2 + "rd";
    }
  }
  return number2 + "th";
};
const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(args) {
  return (string2, options = {}) => {
    const width2 = options.width;
    const matchPattern = width2 && args.matchPatterns[width2] || args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string2.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];
    const parsePatterns = width2 && args.parsePatterns[width2] || args.parsePatterns[args.defaultParseWidth];
    const key2 = Array.isArray(parsePatterns) ? findIndex$1(parsePatterns, (pattern) => pattern.test(matchedString)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      findKey(parsePatterns, (pattern) => pattern.test(matchedString))
    );
    let value;
    value = args.valueCallback ? args.valueCallback(key2) : key2;
    value = options.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      options.valueCallback(value)
    ) : value;
    const rest = string2.slice(matchedString.length);
    return { value, rest };
  };
}
function findKey(object, predicate) {
  for (const key2 in object) {
    if (Object.prototype.hasOwnProperty.call(object, key2) && predicate(object[key2])) {
      return key2;
    }
  }
  return void 0;
}
function findIndex$1(array, predicate) {
  for (let key2 = 0; key2 < array.length; key2++) {
    if (predicate(array[key2])) {
      return key2;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return (string2, options = {}) => {
    const matchResult = string2.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];
    const parseResult = string2.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    const rest = string2.slice(matchedString.length);
    return { value, rest };
  };
}
const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
};
const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
const match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index2) => index2 + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
const enUS = {
  code: "en-US",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match: match$1,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let defaultOptions$3 = {};
function getDefaultOptions$1() {
  return defaultOptions$3;
}
const millisecondsInWeek = 6048e5;
const millisecondsInDay = 864e5;
const millisecondsInMinute = 6e4;
const millisecondsInHour = 36e5;
const millisecondsInSecond = 1e3;
function startOfDay(date) {
  const _date = toDate$1(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function getTimezoneOffsetInMilliseconds(date) {
  const _date = toDate$1(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds()
    )
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}
function differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = startOfDay(dateLeft);
  const startOfDayRight = startOfDay(dateRight);
  const timestampLeft = +startOfDayLeft - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  const timestampRight = +startOfDayRight - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / millisecondsInDay);
}
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return new Date(value);
  }
}
function startOfYear(date) {
  const cleanDate = toDate$1(date);
  const _date = constructFrom(date, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function getDayOfYear(date) {
  const _date = toDate$1(date);
  const diff2 = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff2 + 1;
  return dayOfYear;
}
function startOfWeek(date, options) {
  var _a3, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions$1();
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_b = (_a3 = options == null ? void 0 : options.locale) == null ? void 0 : _a3.options) == null ? void 0 : _b.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const _date = toDate$1(date);
  const day = _date.getDay();
  const diff2 = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  _date.setDate(_date.getDate() - diff2);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function startOfISOWeek(date) {
  return startOfWeek(date, { weekStartsOn: 1 });
}
function getISOWeekYear(date) {
  const _date = toDate$1(date);
  const year = _date.getFullYear();
  const fourthOfJanuaryOfNextYear = constructFrom(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  const fourthOfJanuaryOfThisYear = constructFrom(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfISOWeekYear(date) {
  const year = getISOWeekYear(date);
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}
function getISOWeek(date) {
  const _date = toDate$1(date);
  const diff2 = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);
  return Math.round(diff2 / millisecondsInWeek) + 1;
}
function getWeekYear(date, options) {
  var _a3, _b, _c, _d;
  const _date = toDate$1(date);
  const year = _date.getFullYear();
  const defaultOptions2 = getDefaultOptions$1();
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a3 = options == null ? void 0 : options.locale) == null ? void 0 : _a3.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const firstWeekOfNextYear = constructFrom(date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  const firstWeekOfThisYear = constructFrom(date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfWeekYear(date, options) {
  var _a3, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions$1();
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a3 = options == null ? void 0 : options.locale) == null ? void 0 : _a3.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const year = getWeekYear(date, options);
  const firstWeek = constructFrom(date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}
function getWeek$1(date, options) {
  const _date = toDate$1(date);
  const diff2 = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);
  return Math.round(diff2 / millisecondsInWeek) + 1;
}
function addLeadingZeros(number2, targetLength) {
  const sign2 = number2 < 0 ? "-" : "";
  const output = Math.abs(number2).toString().padStart(targetLength, "0");
  return sign2 + output;
}
const lightFormatters = {
  // Year
  y(date, token2) {
    const signedYear = date.getFullYear();
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token2 === "yy" ? year % 100 : year, token2.length);
  },
  // Month
  M(date, token2) {
    const month = date.getMonth();
    return token2 === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d(date, token2) {
    return addLeadingZeros(date.getDate(), token2.length);
  },
  // AM or PM
  a(date, token2) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(date, token2) {
    return addLeadingZeros(date.getHours() % 12 || 12, token2.length);
  },
  // Hour [0-23]
  H(date, token2) {
    return addLeadingZeros(date.getHours(), token2.length);
  },
  // Minute
  m(date, token2) {
    return addLeadingZeros(date.getMinutes(), token2.length);
  },
  // Second
  s(date, token2) {
    return addLeadingZeros(date.getSeconds(), token2.length);
  },
  // Fraction of second
  S(date, token2) {
    const numberOfDigits = token2.length;
    const milliseconds2 = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds2 * Math.pow(10, numberOfDigits - 3)
    );
    return addLeadingZeros(fractionalSeconds, token2.length);
  }
};
const dayPeriodEnum = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
const formatters = {
  // Era
  G: function(date, token2, localize2) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token2) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return localize2.era(era, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize2.era(era, { width: "wide" });
    }
  },
  // Year
  y: function(date, token2, localize2) {
    if (token2 === "yo") {
      const signedYear = date.getFullYear();
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, { unit: "year" });
    }
    return lightFormatters.y(date, token2);
  },
  // Local week-numbering year
  Y: function(date, token2, localize2, options) {
    const signedWeekYear = getWeekYear(date, options);
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token2 === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token2 === "Yo") {
      return localize2.ordinalNumber(weekYear, { unit: "year" });
    }
    return addLeadingZeros(weekYear, token2.length);
  },
  // ISO week-numbering year
  R: function(date, token2) {
    const isoWeekYear = getISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token2.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(date, token2) {
    const year = date.getFullYear();
    return addLeadingZeros(year, token2.length);
  },
  // Quarter
  Q: function(date, token2, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token2) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(date, token2, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token2) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(date, token2, localize2) {
    const month = date.getMonth();
    switch (token2) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token2);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize2.month(month, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(date, token2, localize2) {
    const month = date.getMonth();
    switch (token2) {
      // 1, 2, ..., 12
      case "L":
        return String(month + 1);
      // 01, 02, ..., 12
      case "LL":
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize2.month(month, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(date, token2, localize2, options) {
    const week = getWeek$1(date, options);
    if (token2 === "wo") {
      return localize2.ordinalNumber(week, { unit: "week" });
    }
    return addLeadingZeros(week, token2.length);
  },
  // ISO week of year
  I: function(date, token2, localize2) {
    const isoWeek = getISOWeek(date);
    if (token2 === "Io") {
      return localize2.ordinalNumber(isoWeek, { unit: "week" });
    }
    return addLeadingZeros(isoWeek, token2.length);
  },
  // Day of the month
  d: function(date, token2, localize2) {
    if (token2 === "do") {
      return localize2.ordinalNumber(date.getDate(), { unit: "date" });
    }
    return lightFormatters.d(date, token2);
  },
  // Day of year
  D: function(date, token2, localize2) {
    const dayOfYear = getDayOfYear(date);
    if (token2 === "Do") {
      return localize2.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }
    return addLeadingZeros(dayOfYear, token2.length);
  },
  // Day of week
  E: function(date, token2, localize2) {
    const dayOfWeek = date.getDay();
    switch (token2) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(date, token2, localize2, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(date, token2, localize2, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return addLeadingZeros(localDayOfWeek, token2.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(date, token2, localize2) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token2) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token2.length);
      // 2nd
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, { unit: "day" });
      // Tue
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(date, token2, localize2) {
    const hours2 = date.getHours();
    const dayPeriodEnumValue = hours2 / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(date, token2, localize2) {
    const hours2 = date.getHours();
    let dayPeriodEnumValue;
    if (hours2 === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours2 === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours2 / 12 >= 1 ? "pm" : "am";
    }
    switch (token2) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(date, token2, localize2) {
    const hours2 = date.getHours();
    let dayPeriodEnumValue;
    if (hours2 >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours2 >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours2 >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token2) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(date, token2, localize2) {
    if (token2 === "ho") {
      let hours2 = date.getHours() % 12;
      if (hours2 === 0) hours2 = 12;
      return localize2.ordinalNumber(hours2, { unit: "hour" });
    }
    return lightFormatters.h(date, token2);
  },
  // Hour [0-23]
  H: function(date, token2, localize2) {
    if (token2 === "Ho") {
      return localize2.ordinalNumber(date.getHours(), { unit: "hour" });
    }
    return lightFormatters.H(date, token2);
  },
  // Hour [0-11]
  K: function(date, token2, localize2) {
    const hours2 = date.getHours() % 12;
    if (token2 === "Ko") {
      return localize2.ordinalNumber(hours2, { unit: "hour" });
    }
    return addLeadingZeros(hours2, token2.length);
  },
  // Hour [1-24]
  k: function(date, token2, localize2) {
    let hours2 = date.getHours();
    if (hours2 === 0) hours2 = 24;
    if (token2 === "ko") {
      return localize2.ordinalNumber(hours2, { unit: "hour" });
    }
    return addLeadingZeros(hours2, token2.length);
  },
  // Minute
  m: function(date, token2, localize2) {
    if (token2 === "mo") {
      return localize2.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }
    return lightFormatters.m(date, token2);
  },
  // Second
  s: function(date, token2, localize2) {
    if (token2 === "so") {
      return localize2.ordinalNumber(date.getSeconds(), { unit: "second" });
    }
    return lightFormatters.s(date, token2);
  },
  // Fraction of second
  S: function(date, token2) {
    return lightFormatters.S(date, token2);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(date, token2, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token2) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(date, token2, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token2) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function(date, token2, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token2) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(date, token2, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token2) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function(date, token2, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1e3);
    return addLeadingZeros(timestamp, token2.length);
  },
  // Milliseconds timestamp
  T: function(date, token2, _localize) {
    const timestamp = date.getTime();
    return addLeadingZeros(timestamp, token2.length);
  }
};
function formatTimezoneShort(offset3, delimiter2 = "") {
  const sign2 = offset3 > 0 ? "-" : "+";
  const absOffset = Math.abs(offset3);
  const hours2 = Math.trunc(absOffset / 60);
  const minutes2 = absOffset % 60;
  if (minutes2 === 0) {
    return sign2 + String(hours2);
  }
  return sign2 + String(hours2) + delimiter2 + addLeadingZeros(minutes2, 2);
}
function formatTimezoneWithOptionalMinutes(offset3, delimiter2) {
  if (offset3 % 60 === 0) {
    const sign2 = offset3 > 0 ? "-" : "+";
    return sign2 + addLeadingZeros(Math.abs(offset3) / 60, 2);
  }
  return formatTimezone(offset3, delimiter2);
}
function formatTimezone(offset3, delimiter2 = "") {
  const sign2 = offset3 > 0 ? "-" : "+";
  const absOffset = Math.abs(offset3);
  const hours2 = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes2 = addLeadingZeros(absOffset % 60, 2);
  return sign2 + hours2 + delimiter2 + minutes2;
}
const dateLongFormatter = (pattern, formatLong2) => {
  switch (pattern) {
    case "P":
      return formatLong2.date({ width: "short" });
    case "PP":
      return formatLong2.date({ width: "medium" });
    case "PPP":
      return formatLong2.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong2.date({ width: "full" });
  }
};
const timeLongFormatter = (pattern, formatLong2) => {
  switch (pattern) {
    case "p":
      return formatLong2.time({ width: "short" });
    case "pp":
      return formatLong2.time({ width: "medium" });
    case "ppp":
      return formatLong2.time({ width: "long" });
    case "pppp":
    default:
      return formatLong2.time({ width: "full" });
  }
};
const dateTimeLongFormatter = (pattern, formatLong2) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  let dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({ width: "full" });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;
const throwTokens = ["D", "DD", "YY", "YYYY"];
function isProtectedDayOfYearToken(token2) {
  return dayOfYearTokenRE.test(token2);
}
function isProtectedWeekYearToken(token2) {
  return weekYearTokenRE.test(token2);
}
function warnOrThrowProtectedError(token2, format2, input) {
  const _message = message(token2, format2, input);
  console.warn(_message);
  if (throwTokens.includes(token2)) throw new RangeError(_message);
}
function message(token2, format2, input) {
  const subject = token2[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token2.toLowerCase()}\` instead of \`${token2}\` (in \`${format2}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
const longFormattingTokensRegExp$2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp$1 = /^'([^]*?)'?$/;
const doubleQuoteRegExp$1 = /''/g;
const unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
function format$1(date, formatStr, options) {
  var _a3, _b, _c, _d, _e2, _f, _g, _h;
  const defaultOptions2 = getDefaultOptions$1();
  const locale2 = (options == null ? void 0 : options.locale) ?? defaultOptions2.locale ?? enUS;
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a3 = options == null ? void 0 : options.locale) == null ? void 0 : _a3.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_f = (_e2 = options == null ? void 0 : options.locale) == null ? void 0 : _e2.options) == null ? void 0 : _f.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_h = (_g = defaultOptions2.locale) == null ? void 0 : _g.options) == null ? void 0 : _h.weekStartsOn) ?? 0;
  const originalDate = toDate$1(date);
  if (!isValid$5(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  let parts = formatStr.match(longFormattingTokensRegExp$2).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$1).map((substring) => {
    if (substring === "''") {
      return { isToken: false, value: "'" };
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return { isToken: false, value: cleanEscapedString$1(substring) };
    }
    if (formatters[firstCharacter]) {
      return { isToken: true, value: substring };
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + firstCharacter + "`"
      );
    }
    return { isToken: false, value: substring };
  });
  if (locale2.localize.preprocessor) {
    parts = locale2.localize.preprocessor(originalDate, parts);
  }
  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2
  };
  return parts.map((part) => {
    if (!part.isToken) return part.value;
    const token2 = part.value;
    if (!(options == null ? void 0 : options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token2) || !(options == null ? void 0 : options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token2)) {
      warnOrThrowProtectedError(token2, formatStr, String(date));
    }
    const formatter = formatters[token2[0]];
    return formatter(originalDate, token2, locale2.localize, formatterOptions);
  }).join("");
}
function cleanEscapedString$1(input) {
  const matched = input.match(escapedStringRegExp$1);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp$1, "'");
}
function addMilliseconds(date, amount) {
  const timestamp = +toDate$1(date);
  return constructFrom(date, timestamp + amount);
}
function addMinutes(date, amount) {
  return addMilliseconds(date, amount * millisecondsInMinute);
}
function addHours(date, amount) {
  return addMilliseconds(date, amount * millisecondsInHour);
}
function addDays(date, amount) {
  const _date = toDate$1(date);
  if (isNaN(amount)) return constructFrom(date, NaN);
  if (!amount) {
    return _date;
  }
  _date.setDate(_date.getDate() + amount);
  return _date;
}
function addWeeks(date, amount) {
  const days2 = amount * 7;
  return addDays(date, days2);
}
function addMonths(date, amount) {
  const _date = toDate$1(date);
  if (isNaN(amount)) return constructFrom(date, NaN);
  if (!amount) {
    return _date;
  }
  const dayOfMonth = _date.getDate();
  const endOfDesiredMonth = constructFrom(date, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth2 = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth2) {
    return endOfDesiredMonth;
  } else {
    _date.setFullYear(
      endOfDesiredMonth.getFullYear(),
      endOfDesiredMonth.getMonth(),
      dayOfMonth
    );
    return _date;
  }
}
function addQuarters(date, amount) {
  const months2 = amount * 3;
  return addMonths(date, months2);
}
function addYears(date, amount) {
  return addMonths(date, amount * 12);
}
function subDays(date, amount) {
  return addDays(date, -1);
}
function subWeeks(date, amount) {
  return addWeeks(date, -1);
}
function subMonths(date, amount) {
  return addMonths(date, -amount);
}
function subQuarters(date, amount) {
  return addQuarters(date, -1);
}
function subYears(date, amount) {
  return addYears(date, -amount);
}
function getSeconds(date) {
  const _date = toDate$1(date);
  const seconds2 = _date.getSeconds();
  return seconds2;
}
function getMinutes(date) {
  const _date = toDate$1(date);
  const minutes2 = _date.getMinutes();
  return minutes2;
}
function getHours(date) {
  const _date = toDate$1(date);
  const hours2 = _date.getHours();
  return hours2;
}
function getDay(date) {
  const _date = toDate$1(date);
  const day = _date.getDay();
  return day;
}
function getDate(date) {
  const _date = toDate$1(date);
  const dayOfMonth = _date.getDate();
  return dayOfMonth;
}
function getMonth(date) {
  const _date = toDate$1(date);
  const month = _date.getMonth();
  return month;
}
function getQuarter(date) {
  const _date = toDate$1(date);
  const quarter = Math.trunc(_date.getMonth() / 3) + 1;
  return quarter;
}
function getYear(date) {
  return toDate$1(date).getFullYear();
}
function getTime(date) {
  const _date = toDate$1(date);
  const timestamp = _date.getTime();
  return timestamp;
}
function setSeconds(date, seconds2) {
  const _date = toDate$1(date);
  _date.setSeconds(seconds2);
  return _date;
}
function setMinutes(date, minutes2) {
  const _date = toDate$1(date);
  _date.setMinutes(minutes2);
  return _date;
}
function setHours(date, hours2) {
  const _date = toDate$1(date);
  _date.setHours(hours2);
  return _date;
}
function getDaysInMonth$1(date) {
  const _date = toDate$1(date);
  const year = _date.getFullYear();
  const monthIndex = _date.getMonth();
  const lastDayOfMonth = constructFrom(date, 0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
function setMonth$1(date, month) {
  const _date = toDate$1(date);
  const year = _date.getFullYear();
  const day = _date.getDate();
  const dateWithDesiredMonth = constructFrom(date, 0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  const daysInMonth2 = getDaysInMonth$1(dateWithDesiredMonth);
  _date.setMonth(month, Math.min(day, daysInMonth2));
  return _date;
}
function setQuarter(date, quarter) {
  const _date = toDate$1(date);
  const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
  const diff2 = quarter - oldQuarter;
  return setMonth$1(_date, _date.getMonth() + diff2 * 3);
}
function setYear(date, year) {
  const _date = toDate$1(date);
  if (isNaN(+_date)) {
    return constructFrom(date, NaN);
  }
  _date.setFullYear(year);
  return _date;
}
function min$2(dates) {
  let result;
  dates.forEach((dirtyDate) => {
    const date = toDate$1(dirtyDate);
    if (!result || result > date || isNaN(+date)) {
      result = date;
    }
  });
  return result || /* @__PURE__ */ new Date(NaN);
}
function max$2(dates) {
  let result;
  dates.forEach(function(dirtyDate) {
    const currentDate = toDate$1(dirtyDate);
    if (result === void 0 || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || /* @__PURE__ */ new Date(NaN);
}
function differenceInCalendarMonths(dateLeft, dateRight) {
  const _dateLeft = toDate$1(dateLeft);
  const _dateRight = toDate$1(dateRight);
  const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
  const monthDiff2 = _dateLeft.getMonth() - _dateRight.getMonth();
  return yearDiff * 12 + monthDiff2;
}
function differenceInCalendarYears(dateLeft, dateRight) {
  const _dateLeft = toDate$1(dateLeft);
  const _dateRight = toDate$1(dateRight);
  return _dateLeft.getFullYear() - _dateRight.getFullYear();
}
function differenceInCalendarQuarters(dateLeft, dateRight) {
  const _dateLeft = toDate$1(dateLeft);
  const _dateRight = toDate$1(dateRight);
  const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
  const quarterDiff = getQuarter(_dateLeft) - getQuarter(_dateRight);
  return yearDiff * 4 + quarterDiff;
}
function startOfMonth(date) {
  const _date = toDate$1(date);
  _date.setDate(1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function startOfQuarter(date) {
  const _date = toDate$1(date);
  const currentMonth = _date.getMonth();
  const month = currentMonth - currentMonth % 3;
  _date.setMonth(month, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function endOfDay(date) {
  const _date = toDate$1(date);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
function endOfWeek(date, options) {
  var _a3, _b;
  const defaultOptions2 = getDefaultOptions$1();
  const weekStartsOn = defaultOptions2.weekStartsOn ?? ((_b = (_a3 = defaultOptions2.locale) == null ? void 0 : _a3.options) == null ? void 0 : _b.weekStartsOn) ?? 0;
  const _date = toDate$1(date);
  const day = _date.getDay();
  const diff2 = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  _date.setDate(_date.getDate() + diff2);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
function endOfMonth(date) {
  const _date = toDate$1(date);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
function endOfYear(date) {
  const _date = toDate$1(date);
  const year = _date.getFullYear();
  _date.setFullYear(year + 1, 0, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
function isEqual$4(leftDate, rightDate) {
  const _dateLeft = toDate$1(leftDate);
  const _dateRight = toDate$1(rightDate);
  return +_dateLeft === +_dateRight;
}
function isSameDay$1(dateLeft, dateRight) {
  const dateLeftStartOfDay = startOfDay(dateLeft);
  const dateRightStartOfDay = startOfDay(dateRight);
  return +dateLeftStartOfDay === +dateRightStartOfDay;
}
function isSameMonth$1(dateLeft, dateRight) {
  const _dateLeft = toDate$1(dateLeft);
  const _dateRight = toDate$1(dateRight);
  return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}
function isSameYear$1(dateLeft, dateRight) {
  const _dateLeft = toDate$1(dateLeft);
  const _dateRight = toDate$1(dateRight);
  return _dateLeft.getFullYear() === _dateRight.getFullYear();
}
function isSameQuarter$1(dateLeft, dateRight) {
  const dateLeftStartOfQuarter = startOfQuarter(dateLeft);
  const dateRightStartOfQuarter = startOfQuarter(dateRight);
  return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}
function isAfter$2(date, dateToCompare) {
  const _date = toDate$1(date);
  const _dateToCompare = toDate$1(dateToCompare);
  return _date.getTime() > _dateToCompare.getTime();
}
function isBefore$1(date, dateToCompare) {
  const _date = toDate$1(date);
  const _dateToCompare = toDate$1(dateToCompare);
  return +_date < +_dateToCompare;
}
function isWithinInterval(date, interval) {
  const time = +toDate$1(date);
  const [startTime, endTime] = [
    +toDate$1(interval.start),
    +toDate$1(interval.end)
  ].sort((a2, b2) => a2 - b2);
  return time >= startTime && time <= endTime;
}
function getDefaultOptions() {
  return Object.assign({}, getDefaultOptions$1());
}
function transpose(fromDate, constructor) {
  const date = constructor instanceof Date ? constructFrom(constructor, 0) : new constructor(0);
  date.setFullYear(
    fromDate.getFullYear(),
    fromDate.getMonth(),
    fromDate.getDate()
  );
  date.setHours(
    fromDate.getHours(),
    fromDate.getMinutes(),
    fromDate.getSeconds(),
    fromDate.getMilliseconds()
  );
  return date;
}
const TIMEZONE_UNIT_PRIORITY = 10;
class Setter2 {
  constructor() {
    __publicField(this, "subPriority", 0);
  }
  validate(_utcDate, _options) {
    return true;
  }
}
class ValueSetter2 extends Setter2 {
  constructor(value, validateValue, setValue, priority, subPriority) {
    super();
    this.value = value;
    this.validateValue = validateValue;
    this.setValue = setValue;
    this.priority = priority;
    if (subPriority) {
      this.subPriority = subPriority;
    }
  }
  validate(date, options) {
    return this.validateValue(date, this.value, options);
  }
  set(date, flags, options) {
    return this.setValue(date, flags, this.value, options);
  }
}
class DateToSystemTimezoneSetter extends Setter2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", TIMEZONE_UNIT_PRIORITY);
    __publicField(this, "subPriority", -1);
  }
  set(date, flags) {
    if (flags.timestampIsSet) return date;
    return constructFrom(date, transpose(date, Date));
  }
}
class Parser2 {
  run(dateString, token2, match5, options) {
    const result = this.parse(dateString, token2, match5, options);
    if (!result) {
      return null;
    }
    return {
      setter: new ValueSetter2(
        result.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: result.rest
    };
  }
  validate(_utcDate, _value, _options) {
    return true;
  }
}
class EraParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 140);
    __publicField(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return match5.era(dateString, { width: "abbreviated" }) || match5.era(dateString, { width: "narrow" });
      // A, B
      case "GGGGG":
        return match5.era(dateString, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return match5.era(dateString, { width: "wide" }) || match5.era(dateString, { width: "abbreviated" }) || match5.era(dateString, { width: "narrow" });
    }
  }
  set(date, flags, value) {
    flags.era = value;
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
const numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
};
const timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  const sign2 = matchResult[1] === "+" ? 1 : -1;
  const hours2 = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  const minutes2 = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  const seconds2 = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign2 * (hours2 * millisecondsInHour + minutes2 * millisecondsInMinute + seconds2 * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n2, dateString) {
  switch (n2) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n2 + "}"), dateString);
  }
}
function parseNDigitsSigned(n2, dateString) {
  switch (n2) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n2 + "}"), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  const isCommonEra = currentYear > 0;
  const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  let result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    const rangeEnd = absCurrentYear + 50;
    const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
    const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
class YearParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 130);
    __publicField(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token2 === "yy"
    });
    switch (token2) {
      case "y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "yo":
        return mapValue(
          match5.ordinalNumber(dateString, {
            unit: "year"
          }),
          valueCallback
        );
      default:
        return mapValue(parseNDigits(token2.length, dateString), valueCallback);
    }
  }
  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }
  set(date, flags, value) {
    const currentYear = date.getFullYear();
    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear(
        value.year,
        currentYear
      );
      date.setFullYear(normalizedTwoDigitYear, 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    }
    const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class LocalWeekYearParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 130);
    __publicField(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token2 === "YY"
    });
    switch (token2) {
      case "Y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "Yo":
        return mapValue(
          match5.ordinalNumber(dateString, {
            unit: "year"
          }),
          valueCallback
        );
      default:
        return mapValue(parseNDigits(token2.length, dateString), valueCallback);
    }
  }
  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }
  set(date, flags, value, options) {
    const currentYear = getWeekYear(date, options);
    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear(
        value.year,
        currentYear
      );
      date.setFullYear(
        normalizedTwoDigitYear,
        0,
        options.firstWeekContainsDate
      );
      date.setHours(0, 0, 0, 0);
      return startOfWeek(date, options);
    }
    const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, options.firstWeekContainsDate);
    date.setHours(0, 0, 0, 0);
    return startOfWeek(date, options);
  }
}
class ISOWeekYearParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 130);
    __publicField(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2) {
    if (token2 === "R") {
      return parseNDigitsSigned(4, dateString);
    }
    return parseNDigitsSigned(token2.length, dateString);
  }
  set(date, _flags, value) {
    const firstWeekOfYear = constructFrom(date, 0);
    firstWeekOfYear.setFullYear(value, 0, 4);
    firstWeekOfYear.setHours(0, 0, 0, 0);
    return startOfISOWeek(firstWeekOfYear);
  }
}
class ExtendedYearParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 130);
    __publicField(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token2) {
    if (token2 === "u") {
      return parseNDigitsSigned(4, dateString);
    }
    return parseNDigitsSigned(token2.length, dateString);
  }
  set(date, _flags, value) {
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class QuarterParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 120);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return parseNDigits(token2.length, dateString);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return match5.ordinalNumber(dateString, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return match5.quarter(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return match5.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return match5.quarter(dateString, {
          width: "wide",
          context: "formatting"
        }) || match5.quarter(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 4;
  }
  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class StandAloneQuarterParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 120);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return parseNDigits(token2.length, dateString);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return match5.ordinalNumber(dateString, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return match5.quarter(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match5.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return match5.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return match5.quarter(dateString, {
          width: "wide",
          context: "standalone"
        }) || match5.quarter(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match5.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 4;
  }
  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class MonthParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    __publicField(this, "priority", 110);
  }
  parse(dateString, token2, match5) {
    const valueCallback = (value) => value - 1;
    switch (token2) {
      // 1, 2, ..., 12
      case "M":
        return mapValue(
          parseNumericPattern(numericPatterns.month, dateString),
          valueCallback
        );
      // 01, 02, ..., 12
      case "MM":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return mapValue(
          match5.ordinalNumber(dateString, {
            unit: "month"
          }),
          valueCallback
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return match5.month(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.month(dateString, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return match5.month(dateString, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return match5.month(dateString, { width: "wide", context: "formatting" }) || match5.month(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.month(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class StandAloneMonthParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 110);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    const valueCallback = (value) => value - 1;
    switch (token2) {
      // 1, 2, ..., 12
      case "L":
        return mapValue(
          parseNumericPattern(numericPatterns.month, dateString),
          valueCallback
        );
      // 01, 02, ..., 12
      case "LL":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return mapValue(
          match5.ordinalNumber(dateString, {
            unit: "month"
          }),
          valueCallback
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return match5.month(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match5.month(dateString, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return match5.month(dateString, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return match5.month(dateString, { width: "wide", context: "standalone" }) || match5.month(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match5.month(dateString, { width: "narrow", context: "standalone" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
function setWeek(date, week, options) {
  const _date = toDate$1(date);
  const diff2 = getWeek$1(_date, options) - week;
  _date.setDate(_date.getDate() - diff2 * 7);
  return _date;
}
class LocalWeekParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 100);
    __publicField(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "w":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "wo":
        return match5.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 53;
  }
  set(date, _flags, value, options) {
    return startOfWeek(setWeek(date, value, options), options);
  }
}
function setISOWeek(date, week) {
  const _date = toDate$1(date);
  const diff2 = getISOWeek(_date) - week;
  _date.setDate(_date.getDate() - diff2 * 7);
  return _date;
}
class ISOWeekParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 100);
    __publicField(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "I":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "Io":
        return match5.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 53;
  }
  set(date, _flags, value) {
    return startOfISOWeek(setISOWeek(date, value));
  }
}
const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const DAYS_IN_MONTH_LEAP_YEAR = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class DateParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "subPriority", 1);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "d":
        return parseNumericPattern(numericPatterns.date, dateString);
      case "do":
        return match5.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear2 = isLeapYearIndex$1(year);
    const month = date.getMonth();
    if (isLeapYear2) {
      return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
    } else {
      return value >= 1 && value <= DAYS_IN_MONTH[month];
    }
  }
  set(date, _flags, value) {
    date.setDate(value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class DayOfYearParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "subpriority", 1);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "D":
      case "DD":
        return parseNumericPattern(numericPatterns.dayOfYear, dateString);
      case "Do":
        return match5.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear2 = isLeapYearIndex$1(year);
    if (isLeapYear2) {
      return value >= 1 && value <= 366;
    } else {
      return value >= 1 && value <= 365;
    }
  }
  set(date, _flags, value) {
    date.setMonth(0, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
function setDay(date, day, options) {
  var _a3, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions$1();
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_b = (_a3 = options == null ? void 0 : options.locale) == null ? void 0 : _a3.options) == null ? void 0 : _b.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const _date = toDate$1(date);
  const currentDay = _date.getDay();
  const remainder = day % 7;
  const dayIndex = (remainder + 7) % 7;
  const delta = 7 - weekStartsOn;
  const diff2 = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
  return addDays(_date, diff2);
}
class DayParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return match5.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.day(dateString, { width: "short", context: "formatting" }) || match5.day(dateString, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return match5.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return match5.day(dateString, { width: "short", context: "formatting" }) || match5.day(dateString, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return match5.day(dateString, { width: "wide", context: "formatting" }) || match5.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.day(dateString, { width: "short", context: "formatting" }) || match5.day(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class LocalDayParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5, options) {
    const valueCallback = (value) => {
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
    };
    switch (token2) {
      // 3
      case "e":
      case "ee":
        return mapValue(parseNDigits(token2.length, dateString), valueCallback);
      // 3rd
      case "eo":
        return mapValue(
          match5.ordinalNumber(dateString, {
            unit: "day"
          }),
          valueCallback
        );
      // Tue
      case "eee":
        return match5.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.day(dateString, { width: "short", context: "formatting" }) || match5.day(dateString, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return match5.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return match5.day(dateString, { width: "short", context: "formatting" }) || match5.day(dateString, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return match5.day(dateString, { width: "wide", context: "formatting" }) || match5.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.day(dateString, { width: "short", context: "formatting" }) || match5.day(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class StandAloneLocalDayParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5, options) {
    const valueCallback = (value) => {
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
    };
    switch (token2) {
      // 3
      case "c":
      case "cc":
        return mapValue(parseNDigits(token2.length, dateString), valueCallback);
      // 3rd
      case "co":
        return mapValue(
          match5.ordinalNumber(dateString, {
            unit: "day"
          }),
          valueCallback
        );
      // Tue
      case "ccc":
        return match5.day(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match5.day(dateString, { width: "short", context: "standalone" }) || match5.day(dateString, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return match5.day(dateString, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return match5.day(dateString, { width: "short", context: "standalone" }) || match5.day(dateString, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return match5.day(dateString, { width: "wide", context: "standalone" }) || match5.day(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match5.day(dateString, { width: "short", context: "standalone" }) || match5.day(dateString, { width: "narrow", context: "standalone" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options) {
    date = setDay(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
function getISODay(date) {
  const _date = toDate$1(date);
  let day = _date.getDay();
  if (day === 0) {
    day = 7;
  }
  return day;
}
function setISODay(date, day) {
  const _date = toDate$1(date);
  const currentDay = getISODay(_date);
  const diff2 = day - currentDay;
  return addDays(_date, diff2);
}
class ISODayParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match5) {
    const valueCallback = (value) => {
      if (value === 0) {
        return 7;
      }
      return value;
    };
    switch (token2) {
      // 2
      case "i":
      case "ii":
        return parseNDigits(token2.length, dateString);
      // 2nd
      case "io":
        return match5.ordinalNumber(dateString, { unit: "day" });
      // Tue
      case "iii":
        return mapValue(
          match5.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          }),
          valueCallback
        );
      // T
      case "iiiii":
        return mapValue(
          match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          }),
          valueCallback
        );
      // Tu
      case "iiiiii":
        return mapValue(
          match5.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          }),
          valueCallback
        );
      // Tuesday
      case "iiii":
      default:
        return mapValue(
          match5.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          }),
          valueCallback
        );
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 7;
  }
  set(date, _flags, value) {
    date = setISODay(date, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class AMPMParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 80);
    __publicField(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "a":
      case "aa":
      case "aaa":
        return match5.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return match5.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }
}
class AMPMMidnightParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 80);
    __publicField(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "b":
      case "bb":
      case "bbb":
        return match5.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return match5.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }
}
class DayPeriodParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 80);
    __publicField(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "B":
      case "BB":
      case "BBB":
        return match5.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return match5.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match5.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }
}
class Hour1to12Parser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 70);
    __publicField(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "h":
        return parseNumericPattern(numericPatterns.hour12h, dateString);
      case "ho":
        return match5.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 12;
  }
  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else if (!isPM && value === 12) {
      date.setHours(0, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }
}
class Hour0to23Parser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 70);
    __publicField(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "H":
        return parseNumericPattern(numericPatterns.hour23h, dateString);
      case "Ho":
        return match5.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 23;
  }
  set(date, _flags, value) {
    date.setHours(value, 0, 0, 0);
    return date;
  }
}
class Hour0To11Parser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 70);
    __publicField(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "K":
        return parseNumericPattern(numericPatterns.hour11h, dateString);
      case "Ko":
        return match5.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }
}
class Hour1To24Parser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 70);
    __publicField(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "k":
        return parseNumericPattern(numericPatterns.hour24h, dateString);
      case "ko":
        return match5.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 24;
  }
  set(date, _flags, value) {
    const hours2 = value <= 24 ? value % 24 : value;
    date.setHours(hours2, 0, 0, 0);
    return date;
  }
}
class MinuteParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 60);
    __publicField(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "m":
        return parseNumericPattern(numericPatterns.minute, dateString);
      case "mo":
        return match5.ordinalNumber(dateString, { unit: "minute" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 59;
  }
  set(date, _flags, value) {
    date.setMinutes(value, 0, 0);
    return date;
  }
}
class SecondParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 50);
    __publicField(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(dateString, token2, match5) {
    switch (token2) {
      case "s":
        return parseNumericPattern(numericPatterns.second, dateString);
      case "so":
        return match5.ordinalNumber(dateString, { unit: "second" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 59;
  }
  set(date, _flags, value) {
    date.setSeconds(value, 0);
    return date;
  }
}
class FractionOfSecondParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 30);
    __publicField(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(dateString, token2) {
    const valueCallback = (value) => Math.trunc(value * Math.pow(10, -token2.length + 3));
    return mapValue(parseNDigits(token2.length, dateString), valueCallback);
  }
  set(date, _flags, value) {
    date.setMilliseconds(value);
    return date;
  }
}
class ISOTimezoneWithZParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 10);
    __publicField(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(dateString, token2) {
    switch (token2) {
      case "X":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalMinutes,
          dateString
        );
      case "XX":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "XXXX":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalSeconds,
          dateString
        );
      case "XXXXX":
        return parseTimezonePattern(
          timezonePatterns.extendedOptionalSeconds,
          dateString
        );
      case "XXX":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }
  set(date, flags, value) {
    if (flags.timestampIsSet) return date;
    return constructFrom(
      date,
      date.getTime() - getTimezoneOffsetInMilliseconds(date) - value
    );
  }
}
class ISOTimezoneParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 10);
    __publicField(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(dateString, token2) {
    switch (token2) {
      case "x":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalMinutes,
          dateString
        );
      case "xx":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "xxxx":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalSeconds,
          dateString
        );
      case "xxxxx":
        return parseTimezonePattern(
          timezonePatterns.extendedOptionalSeconds,
          dateString
        );
      case "xxx":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }
  set(date, flags, value) {
    if (flags.timestampIsSet) return date;
    return constructFrom(
      date,
      date.getTime() - getTimezoneOffsetInMilliseconds(date) - value
    );
  }
}
class TimestampSecondsParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 40);
    __publicField(this, "incompatibleTokens", "*");
  }
  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }
  set(date, _flags, value) {
    return [constructFrom(date, value * 1e3), { timestampIsSet: true }];
  }
}
class TimestampMillisecondsParser2 extends Parser2 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 20);
    __publicField(this, "incompatibleTokens", "*");
  }
  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }
  set(date, _flags, value) {
    return [constructFrom(date, value), { timestampIsSet: true }];
  }
}
const parsers = {
  G: new EraParser2(),
  y: new YearParser2(),
  Y: new LocalWeekYearParser2(),
  R: new ISOWeekYearParser2(),
  u: new ExtendedYearParser2(),
  Q: new QuarterParser2(),
  q: new StandAloneQuarterParser2(),
  M: new MonthParser2(),
  L: new StandAloneMonthParser2(),
  w: new LocalWeekParser2(),
  I: new ISOWeekParser2(),
  d: new DateParser2(),
  D: new DayOfYearParser2(),
  E: new DayParser2(),
  e: new LocalDayParser2(),
  c: new StandAloneLocalDayParser2(),
  i: new ISODayParser2(),
  a: new AMPMParser2(),
  b: new AMPMMidnightParser2(),
  B: new DayPeriodParser2(),
  h: new Hour1to12Parser2(),
  H: new Hour0to23Parser2(),
  K: new Hour0To11Parser2(),
  k: new Hour1To24Parser2(),
  m: new MinuteParser2(),
  s: new SecondParser2(),
  S: new FractionOfSecondParser2(),
  X: new ISOTimezoneWithZParser2(),
  x: new ISOTimezoneParser2(),
  t: new TimestampSecondsParser2(),
  T: new TimestampMillisecondsParser2()
};
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
const longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const notWhitespaceRegExp = /\S/;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse$2(dateStr, formatStr, referenceDate, options) {
  var _a3, _b, _c, _d, _e2, _f, _g, _h;
  const defaultOptions2 = getDefaultOptions();
  const locale2 = (options == null ? void 0 : options.locale) ?? defaultOptions2.locale ?? enUS;
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a3 = options == null ? void 0 : options.locale) == null ? void 0 : _a3.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_f = (_e2 = options == null ? void 0 : options.locale) == null ? void 0 : _e2.options) == null ? void 0 : _f.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_h = (_g = defaultOptions2.locale) == null ? void 0 : _g.options) == null ? void 0 : _h.weekStartsOn) ?? 0;
  if (formatStr === "") {
    if (dateStr === "") {
      return toDate$1(referenceDate);
    } else {
      return constructFrom(referenceDate, NaN);
    }
  }
  const subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2
  };
  const setters = [new DateToSystemTimezoneSetter()];
  const tokens2 = formatStr.match(longFormattingTokensRegExp$1).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter in longFormatters) {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp);
  const usedTokens = [];
  for (let token2 of tokens2) {
    if (!(options == null ? void 0 : options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token2)) {
      warnOrThrowProtectedError(token2, formatStr, dateStr);
    }
    if (!(options == null ? void 0 : options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token2)) {
      warnOrThrowProtectedError(token2, formatStr, dateStr);
    }
    const firstCharacter = token2[0];
    const parser = parsers[firstCharacter];
    if (parser) {
      const { incompatibleTokens } = parser;
      if (Array.isArray(incompatibleTokens)) {
        const incompatibleToken = usedTokens.find(
          (usedToken) => incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter
        );
        if (incompatibleToken) {
          throw new RangeError(
            `The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token2}\` at the same time`
          );
        }
      } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
        throw new RangeError(
          `The format string mustn't contain \`${token2}\` and any other token at the same time`
        );
      }
      usedTokens.push({ token: firstCharacter, fullToken: token2 });
      const parseResult = parser.run(
        dateStr,
        token2,
        locale2.match,
        subFnOptions
      );
      if (!parseResult) {
        return constructFrom(referenceDate, NaN);
      }
      setters.push(parseResult.setter);
      dateStr = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + firstCharacter + "`"
        );
      }
      if (token2 === "''") {
        token2 = "'";
      } else if (firstCharacter === "'") {
        token2 = cleanEscapedString(token2);
      }
      if (dateStr.indexOf(token2) === 0) {
        dateStr = dateStr.slice(token2.length);
      } else {
        return constructFrom(referenceDate, NaN);
      }
    }
  }
  if (dateStr.length > 0 && notWhitespaceRegExp.test(dateStr)) {
    return constructFrom(referenceDate, NaN);
  }
  const uniquePrioritySetters = setters.map((setter) => setter.priority).sort((a2, b2) => b2 - a2).filter((priority, index2, array) => array.indexOf(priority) === index2).map(
    (priority) => setters.filter((setter) => setter.priority === priority).sort((a2, b2) => b2.subPriority - a2.subPriority)
  ).map((setterArray) => setterArray[0]);
  let date = toDate$1(referenceDate);
  if (isNaN(date.getTime())) {
    return constructFrom(referenceDate, NaN);
  }
  const flags = {};
  for (const setter of uniquePrioritySetters) {
    if (!setter.validate(date, subFnOptions)) {
      return constructFrom(referenceDate, NaN);
    }
    const result = setter.set(date, flags, subFnOptions);
    if (Array.isArray(result)) {
      date = result[0];
      Object.assign(flags, result[1]);
    } else {
      date = result;
    }
  }
  return constructFrom(referenceDate, date);
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
function parseISO(argument, options) {
  const additionalDigits = 2;
  const dateStrings = splitDateString(argument);
  let date;
  if (dateStrings.date) {
    const parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate$1(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  const timestamp = date.getTime();
  let time = 0;
  let offset3;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset3 = parseTimezone(dateStrings.timezone);
    if (isNaN(offset3)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  } else {
    const dirtyDate = new Date(timestamp + time);
    const result = /* @__PURE__ */ new Date(0);
    result.setFullYear(
      dirtyDate.getUTCFullYear(),
      dirtyDate.getUTCMonth(),
      dirtyDate.getUTCDate()
    );
    result.setHours(
      dirtyDate.getUTCHours(),
      dirtyDate.getUTCMinutes(),
      dirtyDate.getUTCSeconds(),
      dirtyDate.getUTCMilliseconds()
    );
    return result;
  }
  return new Date(timestamp + time + offset3);
}
const patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
const dateRegex$1 = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const timeRegex$1 = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  const dateStrings = {};
  const array = dateString.split(patterns.dateTimeDelimiter);
  let timeString;
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(
        dateStrings.date.length,
        dateString.length
      );
    }
  }
  if (timeString) {
    const token2 = patterns.timezone.exec(timeString);
    if (token2) {
      dateStrings.time = timeString.replace(token2[1], "");
      dateStrings.timezone = token2[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  const regex2 = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)"
  );
  const captures = dateString.match(regex2);
  if (!captures) return { year: NaN, restDateString: "" };
  const year = captures[1] ? parseInt(captures[1]) : null;
  const century = captures[2] ? parseInt(captures[2]) : null;
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate$1(dateString, year) {
  if (year === null) return /* @__PURE__ */ new Date(NaN);
  const captures = dateString.match(dateRegex$1);
  if (!captures) return /* @__PURE__ */ new Date(NaN);
  const isWeekDate = !!captures[4];
  const dayOfYear = parseDateUnit(captures[1]);
  const month = parseDateUnit(captures[2]) - 1;
  const day = parseDateUnit(captures[3]);
  const week = parseDateUnit(captures[4]);
  const dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    const date = /* @__PURE__ */ new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  const captures = timeString.match(timeRegex$1);
  if (!captures) return NaN;
  const hours2 = parseTimeUnit(captures[1]);
  const minutes2 = parseTimeUnit(captures[2]);
  const seconds2 = parseTimeUnit(captures[3]);
  if (!validateTime(hours2, minutes2, seconds2)) {
    return NaN;
  }
  return hours2 * millisecondsInHour + minutes2 * millisecondsInMinute + seconds2 * 1e3;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === "Z") return 0;
  const captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  const sign2 = captures[1] === "+" ? -1 : 1;
  const hours2 = parseInt(captures[2]);
  const minutes2 = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours2, minutes2)) {
    return NaN;
  }
  return sign2 * (hours2 * millisecondsInHour + minutes2 * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  const date = /* @__PURE__ */ new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  const fourthOfJanuaryDay = date.getUTCDay() || 7;
  const diff2 = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff2);
  return date;
}
const daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours2, minutes2, seconds2) {
  if (hours2 === 24) {
    return minutes2 === 0 && seconds2 === 0;
  }
  return seconds2 >= 0 && seconds2 < 60 && minutes2 >= 0 && minutes2 < 60 && hours2 >= 0 && hours2 < 25;
}
function validateTimezone(_hours, minutes2) {
  return minutes2 >= 0 && minutes2 <= 59;
}
function addSeconds(date, amount) {
  return addMilliseconds(date, amount * 1e3);
}
function set$2(date, values2) {
  let _date = toDate$1(date);
  if (isNaN(+_date)) {
    return constructFrom(date, NaN);
  }
  if (values2.year != null) {
    _date.setFullYear(values2.year);
  }
  if (values2.month != null) {
    _date = setMonth$1(_date, values2.month);
  }
  if (values2.date != null) {
    _date.setDate(values2.date);
  }
  if (values2.hours != null) {
    _date.setHours(values2.hours);
  }
  if (values2.minutes != null) {
    _date.setMinutes(values2.minutes);
  }
  if (values2.seconds != null) {
    _date.setSeconds(values2.seconds);
  }
  if (values2.milliseconds != null) {
    _date.setMilliseconds(values2.milliseconds);
  }
  return _date;
}
function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$2(subClass, superClass);
}
function _setPrototypeOf$2(o2, p2) {
  _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$2(o2, p2);
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key2 = sourceKeys[i];
    if (excluded.indexOf(key2) >= 0) continue;
    target[key2] = source[key2];
  }
  return target;
}
function _assertThisInitialized$2(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  }
  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }
  return current.classList.contains(ignoreClass);
}
function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  }
  while (current.parentNode || current.host) {
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }
    current = current.parentNode || current.host;
  }
  return current;
}
function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}
var testPassiveEventSupport = function testPassiveEventSupport2() {
  if (typeof window === "undefined" || typeof window.addEventListener !== "function") {
    return;
  }
  var passive = false;
  var options = Object.defineProperty({}, "passive", {
    get: function get6() {
      passive = true;
    }
  });
  var noop6 = function noop7() {
  };
  window.addEventListener("testPassiveEventSupport", noop6, options);
  window.removeEventListener("testPassiveEventSupport", noop6, options);
  return passive;
};
function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }
  return function() {
    return ++seed;
  };
}
var uid = autoInc();
var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ["touchstart", "touchmove"];
var IGNORE_CLASS_NAME = "ignore-react-onclickoutside";
function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = {};
  var isTouchEvent2 = touchEvents.indexOf(eventName) !== -1;
  if (isTouchEvent2 && passiveEventSupport) {
    handlerOptions.passive = !instance.props.preventDefault;
  }
  return handlerOptions;
}
function onClickOutsideHOC(WrappedComponent, config2) {
  var _class, _temp5;
  var componentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
  return _temp5 = _class = /* @__PURE__ */ function(_Component) {
    _inheritsLoose$1(onClickOutside, _Component);
    function onClickOutside(props) {
      var _this;
      _this = _Component.call(this, props) || this;
      _this.__outsideClickHandler = function(event) {
        if (typeof _this.__clickOutsideHandlerProp === "function") {
          _this.__clickOutsideHandlerProp(event);
          return;
        }
        var instance = _this.getInstance();
        if (typeof instance.props.handleClickOutside === "function") {
          instance.props.handleClickOutside(event);
          return;
        }
        if (typeof instance.handleClickOutside === "function") {
          instance.handleClickOutside(event);
          return;
        }
        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };
      _this.__getComponentNode = function() {
        var instance = _this.getInstance();
        if (typeof instance.setClickOutsideRef === "function") {
          return instance.setClickOutsideRef();
        }
        return findDOMNode(instance);
      };
      _this.enableOnClickOutside = function() {
        if (typeof document === "undefined" || enabledInstances[_this._uid]) {
          return;
        }
        if (typeof passiveEventSupport === "undefined") {
          passiveEventSupport = testPassiveEventSupport();
        }
        enabledInstances[_this._uid] = true;
        var events2 = _this.props.eventTypes;
        if (!events2.forEach) {
          events2 = [events2];
        }
        handlersMap[_this._uid] = function(event) {
          if (_this.componentNode === null) return;
          if (_this.initTimeStamp > event.timeStamp) return;
          if (_this.props.preventDefault) {
            event.preventDefault();
          }
          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }
          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }
          _this.__outsideClickHandler(event);
        };
        events2.forEach(function(eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized$2(_this), eventName));
        });
      };
      _this.disableOnClickOutside = function() {
        delete enabledInstances[_this._uid];
        var fn2 = handlersMap[_this._uid];
        if (fn2 && typeof document !== "undefined") {
          var events2 = _this.props.eventTypes;
          if (!events2.forEach) {
            events2 = [events2];
          }
          events2.forEach(function(eventName) {
            return document.removeEventListener(eventName, fn2, getEventHandlerOptions(_assertThisInitialized$2(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };
      _this.getRef = function(ref2) {
        return _this.instanceRef = ref2;
      };
      _this._uid = uid();
      _this.initTimeStamp = performance.now();
      return _this;
    }
    var _proto = onClickOutside.prototype;
    _proto.getInstance = function getInstance2() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }
      var ref2 = this.instanceRef;
      return ref2.getInstance ? ref2.getInstance() : ref2;
    };
    _proto.componentDidMount = function componentDidMount() {
      if (typeof document === "undefined" || !document.createElement) {
        return;
      }
      this.getInstance();
      this.componentNode = this.__getComponentNode();
      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    _proto.render = function render() {
      var _this$props = this.props;
      _this$props.excludeScrollbar;
      var props = _objectWithoutPropertiesLoose$2(_this$props, ["excludeScrollbar"]);
      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }
      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return createElement(WrappedComponent, props);
    };
    return onClickOutside;
  }(Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function() {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp5;
}
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node2) {
  if (isNode$1(node2)) {
    return (node2.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow$1(node2) {
  var _node$ownerDocument;
  return (node2 == null || (_node$ownerDocument = node2.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement$1(node2) {
  var _ref;
  return (_ref = (isNode$1(node2) ? node2.ownerDocument : node2.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode$1(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow$1(value).Node;
}
function isElement$1(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow$1(value).Element;
}
function isHTMLElement$1(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow$1(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow$1(value).ShadowRoot;
}
const invalidOverflowDisplayValues = /* @__PURE__ */ new Set(["inline", "contents"]);
function isOverflowElement(element2) {
  const {
    overflow: overflow2,
    overflowX: overflowX2,
    overflowY: overflowY2,
    display: display2
  } = getComputedStyle$1(element2);
  return /auto|scroll|overlay|hidden|clip/.test(overflow2 + overflowY2 + overflowX2) && !invalidOverflowDisplayValues.has(display2);
}
const tableElements$1 = /* @__PURE__ */ new Set(["table", "td", "th"]);
function isTableElement(element2) {
  return tableElements$1.has(getNodeName(element2));
}
const topLayerSelectors = [":popover-open", ":modal"];
function isTopLayer(element2) {
  return topLayerSelectors.some((selector2) => {
    try {
      return element2.matches(selector2);
    } catch (_e2) {
      return false;
    }
  });
}
const transformProperties = ["transform", "translate", "scale", "rotate", "perspective"];
const willChangeValues = ["transform", "translate", "scale", "rotate", "perspective", "filter"];
const containValues = ["paint", "layout", "strict", "content"];
function isContainingBlock(elementOrCss) {
  const webkit2 = isWebKit();
  const css3 = isElement$1(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;
  return transformProperties.some((value) => css3[value] ? css3[value] !== "none" : false) || (css3.containerType ? css3.containerType !== "normal" : false) || !webkit2 && (css3.backdropFilter ? css3.backdropFilter !== "none" : false) || !webkit2 && (css3.filter ? css3.filter !== "none" : false) || willChangeValues.some((value) => (css3.willChange || "").includes(value)) || containValues.some((value) => (css3.contain || "").includes(value));
}
function getContainingBlock(element2) {
  let currentNode = getParentNode(element2);
  while (isHTMLElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
const lastTraversableNodeNames = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function isLastTraversableNode(node2) {
  return lastTraversableNodeNames.has(getNodeName(node2));
}
function getComputedStyle$1(element2) {
  return getWindow$1(element2).getComputedStyle(element2);
}
function getNodeScroll(element2) {
  if (isElement$1(element2)) {
    return {
      scrollLeft: element2.scrollLeft,
      scrollTop: element2.scrollTop
    };
  }
  return {
    scrollLeft: element2.scrollX,
    scrollTop: element2.scrollY
  };
}
function getParentNode(node2) {
  if (getNodeName(node2) === "html") {
    return node2;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node2.assignedSlot || // DOM Element detected.
    node2.parentNode || // ShadowRoot detected.
    isShadowRoot(node2) && node2.host || // Fallback.
    getDocumentElement$1(node2)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node2) {
  const parentNode2 = getParentNode(node2);
  if (isLastTraversableNode(parentNode2)) {
    return node2.ownerDocument ? node2.ownerDocument.body : node2.body;
  }
  if (isHTMLElement$1(parentNode2) && isOverflowElement(parentNode2)) {
    return parentNode2;
  }
  return getNearestOverflowAncestor(parentNode2);
}
function getOverflowAncestors(node2, list2, traverseIframes) {
  var _node$ownerDocument2;
  if (list2 === void 0) {
    list2 = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node2);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node2.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow$1(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list2.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list2.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
const min$1 = Math.min;
const max$1 = Math.max;
const round$1 = Math.round;
const floor = Math.floor;
const createCoords = (v2) => ({
  x: v2,
  y: v2
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start4, value, end2) {
  return max$1(start4, min$1(value, end2));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide$1(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
const yAxisSides = /* @__PURE__ */ new Set(["top", "bottom"]);
function getSideAxis(placement) {
  return yAxisSides.has(getSide$1(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length2 = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length2] > rects.floating[length2]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
const lrPlacement = ["left", "right"];
const rlPlacement = ["right", "left"];
const tbPlacement = ["top", "bottom"];
const btPlacement = ["bottom", "top"];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case "left":
    case "right":
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list2 = getSideList(getSide$1(placement), direction === "start", rtl);
  if (alignment) {
    list2 = list2.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list2 = list2.concat(list2.map(getOppositeAlignmentPlacement));
    }
  }
  return list2;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding2) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding2
  };
}
function getPaddingObject(padding2) {
  return typeof padding2 !== "number" ? expandPaddingObject(padding2) : {
    top: padding2,
    right: padding2,
    bottom: padding2,
    left: padding2
  };
}
function rectToClientRect(rect) {
  const {
    x: x2,
    y: y2,
    width: width2,
    height: height2
  } = rect;
  return {
    width: width2,
    height: height2,
    top: y2,
    left: x2,
    right: x2 + width2,
    bottom: y2 + height2,
    x: x2,
    y: y2
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide$1(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config2) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware: middleware2 = [],
    platform: platform2
  } = config2;
  const validMiddleware = middleware2.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x: x2,
    y: y2
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name: name2,
      fn: fn2
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset: reset2
    } = await fn2({
      x: x2,
      y: y2,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x2 = nextX != null ? nextX : x2;
    y2 = nextY != null ? nextY : y2;
    middlewareData = {
      ...middlewareData,
      [name2]: {
        ...middlewareData[name2],
        ...data
      }
    };
    if (reset2 && resetCount <= 50) {
      resetCount++;
      if (typeof reset2 === "object") {
        if (reset2.placement) {
          statefulPlacement = reset2.placement;
        }
        if (reset2.rects) {
          rects = reset2.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset2.rects;
        }
        ({
          x: x2,
          y: y2
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x: x2,
    y: y2,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x: x2,
    y: y2,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding: padding2 = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding2);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element2 = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element2))) != null ? _await$platform$isEle : true) ? element2 : element2.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x: x2,
    y: y2,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const arrow$4 = (options) => ({
  name: "arrow",
  options,
  async fn(state) {
    const {
      x: x2,
      y: y2,
      placement,
      rects,
      platform: platform2,
      elements,
      middlewareData
    } = state;
    const {
      element: element2,
      padding: padding2 = 0
    } = evaluate(options, state) || {};
    if (element2 == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding2);
    const coords = {
      x: x2,
      y: y2
    };
    const axis = getAlignmentAxis(placement);
    const length2 = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element2);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length2] + rects.reference[axis] - coords[axis] - rects.floating[length2];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element2));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements.floating[clientProp] || rects.floating[length2];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length2] / 2 - 1;
    const minPadding = min$1(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min$1(paddingObject[maxProp], largestPossiblePadding);
    const min$1$1 = minPadding;
    const max2 = clientSize - arrowDimensions[length2] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length2] / 2 + centerToReference;
    const offset3 = clamp(min$1$1, center, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset3 && rects.reference[length2] / 2 - (center < min$1$1 ? minPadding : maxPadding) - arrowDimensions[length2] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1$1 ? center - min$1$1 : center - max2 : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset3,
        centerOffset: center - offset3 - alignmentOffset,
        ...shouldAddOffset && {
          alignmentOffset
        }
      },
      reset: shouldAddOffset
    };
  }
});
const flip$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide$1(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide$1(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow2 = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow2[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow2[sides[0]], overflow2[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== getSideAxis(nextPlacement) : false;
          if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          overflowsData.every((d2) => getSideAxis(d2.placement) === initialSideAxis ? d2.overflows[0] > 0 : true)) {
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d2) => d2.overflows[0] <= 0).sort((a2, b2) => a2.overflows[1] - b2.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d2) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d2.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d2) => [d2.placement, d2.overflows.filter((overflow3) => overflow3 > 0).reduce((acc, overflow3) => acc + overflow3, 0)]).sort((a2, b2) => a2[1] - b2[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
const originSides = /* @__PURE__ */ new Set(["left", "top"]);
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide$1(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = originSides.has(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset$3 = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x: x2,
        y: y2,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x2 + diffCoords.x,
        y: y2 + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
function getCssDimensions(element2) {
  const css3 = getComputedStyle$1(element2);
  let width2 = parseFloat(css3.width) || 0;
  let height2 = parseFloat(css3.height) || 0;
  const hasOffset = isHTMLElement$1(element2);
  const offsetWidth = hasOffset ? element2.offsetWidth : width2;
  const offsetHeight = hasOffset ? element2.offsetHeight : height2;
  const shouldFallback = round$1(width2) !== offsetWidth || round$1(height2) !== offsetHeight;
  if (shouldFallback) {
    width2 = offsetWidth;
    height2 = offsetHeight;
  }
  return {
    width: width2,
    height: height2,
    $: shouldFallback
  };
}
function unwrapElement(element2) {
  return !isElement$1(element2) ? element2.contextElement : element2;
}
function getScale(element2) {
  const domElement = unwrapElement(element2);
  if (!isHTMLElement$1(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width: width2,
    height: height2,
    $: $2
  } = getCssDimensions(domElement);
  let x2 = ($2 ? round$1(rect.width) : rect.width) / width2;
  let y2 = ($2 ? round$1(rect.height) : rect.height) / height2;
  if (!x2 || !Number.isFinite(x2)) {
    x2 = 1;
  }
  if (!y2 || !Number.isFinite(y2)) {
    y2 = 1;
  }
  return {
    x: x2,
    y: y2
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element2) {
  const win = getWindow$1(element2);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element2, isFixed2, floatingOffsetParent) {
  if (isFixed2 === void 0) {
    isFixed2 = false;
  }
  if (!floatingOffsetParent || isFixed2 && floatingOffsetParent !== getWindow$1(element2)) {
    return false;
  }
  return isFixed2;
}
function getBoundingClientRect(element2, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect2 = element2.getBoundingClientRect();
  const domElement = unwrapElement(element2);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement$1(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element2);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x2 = (clientRect2.left + visualOffsets.x) / scale.x;
  let y2 = (clientRect2.top + visualOffsets.y) / scale.y;
  let width2 = clientRect2.width / scale.x;
  let height2 = clientRect2.height / scale.y;
  if (domElement) {
    const win = getWindow$1(domElement);
    const offsetWin = offsetParent && isElement$1(offsetParent) ? getWindow$1(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css3 = getComputedStyle$1(currentIFrame);
      const left2 = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css3.paddingLeft)) * iframeScale.x;
      const top2 = iframeRect.top + (currentIFrame.clientTop + parseFloat(css3.paddingTop)) * iframeScale.y;
      x2 *= iframeScale.x;
      y2 *= iframeScale.y;
      width2 *= iframeScale.x;
      height2 *= iframeScale.y;
      x2 += left2;
      y2 += top2;
      currentWin = getWindow$1(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width: width2,
    height: height2,
    x: x2,
    y: y2
  });
}
function getWindowScrollBarX(element2, rect) {
  const leftScroll = getNodeScroll(element2).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement$1(element2)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll4, ignoreScrollbarX) {
  if (ignoreScrollbarX === void 0) {
    ignoreScrollbarX = false;
  }
  const htmlRect = documentElement.getBoundingClientRect();
  const x2 = htmlRect.left + scroll4.scrollLeft - (ignoreScrollbarX ? 0 : (
    // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect)
  ));
  const y2 = htmlRect.top + scroll4.scrollTop;
  return {
    x: x2,
    y: y2
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed2 = strategy === "fixed";
  const documentElement = getDocumentElement$1(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed2) {
    return rect;
  }
  let scroll4 = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed2) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll4 = getNodeScroll(offsetParent);
    }
    if (isHTMLElement$1(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed2 ? getHTMLOffset(documentElement, scroll4, true) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll4.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll4.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element2) {
  return Array.from(element2.getClientRects());
}
function getDocumentRect(element2) {
  const html2 = getDocumentElement$1(element2);
  const scroll4 = getNodeScroll(element2);
  const body = element2.ownerDocument.body;
  const width2 = max$1(html2.scrollWidth, html2.clientWidth, body.scrollWidth, body.clientWidth);
  const height2 = max$1(html2.scrollHeight, html2.clientHeight, body.scrollHeight, body.clientHeight);
  let x2 = -scroll4.scrollLeft + getWindowScrollBarX(element2);
  const y2 = -scroll4.scrollTop;
  if (getComputedStyle$1(body).direction === "rtl") {
    x2 += max$1(html2.clientWidth, body.clientWidth) - width2;
  }
  return {
    width: width2,
    height: height2,
    x: x2,
    y: y2
  };
}
function getViewportRect(element2, strategy) {
  const win = getWindow$1(element2);
  const html2 = getDocumentElement$1(element2);
  const visualViewport = win.visualViewport;
  let width2 = html2.clientWidth;
  let height2 = html2.clientHeight;
  let x2 = 0;
  let y2 = 0;
  if (visualViewport) {
    width2 = visualViewport.width;
    height2 = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  return {
    width: width2,
    height: height2,
    x: x2,
    y: y2
  };
}
const absoluteOrFixed = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function getInnerBoundingClientRect(element2, strategy) {
  const clientRect2 = getBoundingClientRect(element2, true, strategy === "fixed");
  const top2 = clientRect2.top + element2.clientTop;
  const left2 = clientRect2.left + element2.clientLeft;
  const scale = isHTMLElement$1(element2) ? getScale(element2) : createCoords(1);
  const width2 = element2.clientWidth * scale.x;
  const height2 = element2.clientHeight * scale.y;
  const x2 = left2 * scale.x;
  const y2 = top2 * scale.y;
  return {
    width: width2,
    height: height2,
    x: x2,
    y: y2
  };
}
function getClientRectFromClippingAncestor(element2, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element2, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement$1(element2));
  } else if (isElement$1(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element2);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element2, stopNode) {
  const parentNode2 = getParentNode(element2);
  if (parentNode2 === stopNode || !isElement$1(parentNode2) || isLastTraversableNode(parentNode2)) {
    return false;
  }
  return getComputedStyle$1(parentNode2).position === "fixed" || hasFixedPositionAncestor(parentNode2, stopNode);
}
function getClippingElementAncestors(element2, cache) {
  const cachedResult2 = cache.get(element2);
  if (cachedResult2) {
    return cachedResult2;
  }
  let result = getOverflowAncestors(element2, [], false).filter((el) => isElement$1(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element2).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element2) : element2;
  while (isElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element2, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element2, result);
  return result;
}
function getClippingRect$1(_ref) {
  let {
    element: element2,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element2) ? [] : getClippingElementAncestors(element2, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element2, clippingAncestor, strategy);
    accRect.top = max$1(rect.top, accRect.top);
    accRect.right = min$1(rect.right, accRect.right);
    accRect.bottom = min$1(rect.bottom, accRect.bottom);
    accRect.left = max$1(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element2, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element2) {
  const {
    width: width2,
    height: height2
  } = getCssDimensions(element2);
  return {
    width: width2,
    height: height2
  };
}
function getRectRelativeToOffsetParent(element2, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  const documentElement = getDocumentElement$1(offsetParent);
  const isFixed2 = strategy === "fixed";
  const rect = getBoundingClientRect(element2, true, isFixed2, offsetParent);
  let scroll4 = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  function setLeftRTLScrollbarOffset() {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed2) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll4 = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed2, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      setLeftRTLScrollbarOffset();
    }
  }
  if (isFixed2 && !isOffsetParentAnElement && documentElement) {
    setLeftRTLScrollbarOffset();
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed2 ? getHTMLOffset(documentElement, scroll4) : createCoords(0);
  const x2 = rect.left + scroll4.scrollLeft - offsets.x - htmlOffset.x;
  const y2 = rect.top + scroll4.scrollTop - offsets.y - htmlOffset.y;
  return {
    x: x2,
    y: y2,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element2) {
  return getComputedStyle$1(element2).position === "static";
}
function getTrueOffsetParent(element2, polyfill2) {
  if (!isHTMLElement$1(element2) || getComputedStyle$1(element2).position === "fixed") {
    return null;
  }
  if (polyfill2) {
    return polyfill2(element2);
  }
  let rawOffsetParent = element2.offsetParent;
  if (getDocumentElement$1(element2) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element2, polyfill2) {
  const win = getWindow$1(element2);
  if (isTopLayer(element2)) {
    return win;
  }
  if (!isHTMLElement$1(element2)) {
    let svgOffsetParent = getParentNode(element2);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement$1(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element2, polyfill2);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill2);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element2) || win;
}
const getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element2) {
  return getComputedStyle$1(element2).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: getDocumentElement$1,
  getClippingRect: getClippingRect$1,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement$1,
  isRTL
};
function rectsAreEqual(a2, b2) {
  return a2.x === b2.x && a2.y === b2.y && a2.width === b2.width && a2.height === b2.height;
}
function observeMove(element2, onMove) {
  let io = null;
  let timeoutId;
  const root2 = getDocumentElement$1(element2);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element2.getBoundingClientRect();
    const {
      left: left2,
      top: top2,
      width: width2,
      height: height2
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width2 || !height2) {
      return;
    }
    const insetTop = floor(top2);
    const insetRight = floor(root2.clientWidth - (left2 + width2));
    const insetBottom = floor(root2.clientHeight - (top2 + height2));
    const insetLeft = floor(left2);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max$1(0, min$1(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element2.getBoundingClientRect())) {
        refresh();
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root2.ownerDocument
      });
    } catch (_e2) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element2);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update2, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update2, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update2);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update2) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update2();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update2();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update2();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update2);
      ancestorResize && ancestor.removeEventListener("resize", update2);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const offset$2 = offset$3;
const flip$1 = flip$2;
const arrow$3 = arrow$4;
const computePosition = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
var isClient = typeof document !== "undefined";
var noop$6 = function noop() {
};
var index$3 = isClient ? useLayoutEffect : noop$6;
function deepEqual$1(a2, b2) {
  if (a2 === b2) {
    return true;
  }
  if (typeof a2 !== typeof b2) {
    return false;
  }
  if (typeof a2 === "function" && a2.toString() === b2.toString()) {
    return true;
  }
  let length2;
  let i;
  let keys2;
  if (a2 && b2 && typeof a2 === "object") {
    if (Array.isArray(a2)) {
      length2 = a2.length;
      if (length2 !== b2.length) return false;
      for (i = length2; i-- !== 0; ) {
        if (!deepEqual$1(a2[i], b2[i])) {
          return false;
        }
      }
      return true;
    }
    keys2 = Object.keys(a2);
    length2 = keys2.length;
    if (length2 !== Object.keys(b2).length) {
      return false;
    }
    for (i = length2; i-- !== 0; ) {
      if (!{}.hasOwnProperty.call(b2, keys2[i])) {
        return false;
      }
    }
    for (i = length2; i-- !== 0; ) {
      const key2 = keys2[i];
      if (key2 === "_owner" && a2.$$typeof) {
        continue;
      }
      if (!deepEqual$1(a2[key2], b2[key2])) {
        return false;
      }
    }
    return true;
  }
  return a2 !== a2 && b2 !== b2;
}
function getDPR(element2) {
  if (typeof window === "undefined") {
    return 1;
  }
  const win = element2.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}
function roundByDPR(element2, value) {
  const dpr = getDPR(element2);
  return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
  const ref2 = React.useRef(value);
  index$3(() => {
    ref2.current = value;
  });
  return ref2;
}
function useFloating$1(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware: middleware2 = [],
    platform: platform2,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = React.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware2);
  if (!deepEqual$1(latestMiddleware, middleware2)) {
    setLatestMiddleware(middleware2);
  }
  const [_reference, _setReference] = React.useState(null);
  const [_floating, _setFloating] = React.useState(null);
  const setReference = React.useCallback((node2) => {
    if (node2 !== referenceRef.current) {
      referenceRef.current = node2;
      _setReference(node2);
    }
  }, []);
  const setFloating = React.useCallback((node2) => {
    if (node2 !== floatingRef.current) {
      floatingRef.current = node2;
      _setFloating(node2);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React.useRef(null);
  const floatingRef = React.useRef(null);
  const dataRef = React.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform2);
  const openRef = useLatestRef(open);
  const update2 = React.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config2 = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config2.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config2).then((data2) => {
      const fullData = {
        ...data2,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual$1(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index$3(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data2) => ({
        ...data2,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React.useRef(false);
  index$3(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index$3(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update2);
      }
      update2();
    }
  }, [referenceEl, floatingEl, update2, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x2 = roundByDPR(elements.floating, data.x);
    const y2 = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x2 + "px, " + y2 + "px)",
        ...getDPR(elements.floating) >= 1.5 && {
          willChange: "transform"
        }
      };
    }
    return {
      position: strategy,
      left: x2,
      top: y2
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React.useMemo(() => ({
    ...data,
    update: update2,
    refs,
    elements,
    floatingStyles
  }), [data, update2, refs, elements, floatingStyles]);
}
const arrow$1$1 = (options) => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, "current");
  }
  return {
    name: "arrow",
    options,
    fn(state) {
      const {
        element: element2,
        padding: padding2
      } = typeof options === "function" ? options(state) : options;
      if (element2 && isRef(element2)) {
        if (element2.current != null) {
          return arrow$3({
            element: element2.current,
            padding: padding2
          }).fn(state);
        }
        return {};
      }
      if (element2) {
        return arrow$3({
          element: element2,
          padding: padding2
        }).fn(state);
      }
      return {};
    }
  };
};
const offset$1 = (options, deps) => ({
  ...offset$2(options),
  options: [options, deps]
});
const flip = (options, deps) => ({
  ...flip$1(options),
  options: [options, deps]
});
const arrow$2 = (options, deps) => ({
  ...arrow$1$1(options),
  options: [options, deps]
});
const SafeReact = {
  ...React
};
const useInsertionEffect$1 = SafeReact.useInsertionEffect;
const useSafeInsertionEffect = useInsertionEffect$1 || ((fn2) => fn2());
function useEffectEvent(callback) {
  const ref2 = React.useRef(() => {
    if (process.env.NODE_ENV !== "production") {
      throw new Error("Cannot call an event handler while rendering.");
    }
  });
  useSafeInsertionEffect(() => {
    ref2.current = callback;
  });
  return React.useCallback(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref2.current == null ? void 0 : ref2.current(...args);
  }, []);
}
var index$2 = typeof document !== "undefined" ? useLayoutEffect : useEffect;
function _extends$5() {
  _extends$5 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$5.apply(this, arguments);
}
let serverHandoffComplete = false;
let count = 0;
const genId = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + count++
);
function useFloatingId() {
  const [id, setId] = React.useState(() => serverHandoffComplete ? genId() : void 0);
  index$2(() => {
    if (id == null) {
      setId(genId());
    }
  }, []);
  React.useEffect(() => {
    serverHandoffComplete = true;
  }, []);
  return id;
}
const useReactId = SafeReact.useId;
const useId$1 = useReactId || useFloatingId;
let devMessageSet;
if (process.env.NODE_ENV !== "production") {
  devMessageSet = /* @__PURE__ */ new Set();
}
function warn$3() {
  var _devMessageSet;
  for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
    messages[_key] = arguments[_key];
  }
  const message2 = "Floating UI: " + messages.join(" ");
  if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(message2))) {
    var _devMessageSet2;
    (_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(message2);
    console.warn(message2);
  }
}
function error() {
  var _devMessageSet3;
  for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    messages[_key2] = arguments[_key2];
  }
  const message2 = "Floating UI: " + messages.join(" ");
  if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message2))) {
    var _devMessageSet4;
    (_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message2);
    console.error(message2);
  }
}
const FloatingArrow = /* @__PURE__ */ React.forwardRef(function FloatingArrow2(props, ref2) {
  const {
    context: {
      placement,
      elements: {
        floating
      },
      middlewareData: {
        arrow: arrow2,
        shift: shift3
      }
    },
    width: width2 = 14,
    height: height2 = 7,
    tipRadius = 0,
    strokeWidth = 0,
    staticOffset,
    stroke,
    d: d2,
    style: {
      transform,
      ...restStyle
    } = {},
    ...rest
  } = props;
  if (process.env.NODE_ENV !== "production") {
    if (!ref2) {
      warn$3("The `ref` prop is required for `FloatingArrow`.");
    }
  }
  const clipPathId = useId$1();
  const [isRTL2, setIsRTL] = React.useState(false);
  index$2(() => {
    if (!floating) return;
    const isRTL3 = getComputedStyle$1(floating).direction === "rtl";
    if (isRTL3) {
      setIsRTL(true);
    }
  }, [floating]);
  if (!floating) {
    return null;
  }
  const [side, alignment] = placement.split("-");
  const isVerticalSide = side === "top" || side === "bottom";
  let computedStaticOffset = staticOffset;
  if (isVerticalSide && shift3 != null && shift3.x || !isVerticalSide && shift3 != null && shift3.y) {
    computedStaticOffset = null;
  }
  const computedStrokeWidth = strokeWidth * 2;
  const halfStrokeWidth = computedStrokeWidth / 2;
  const svgX = width2 / 2 * (tipRadius / -8 + 1);
  const svgY = height2 / 2 * tipRadius / 4;
  const isCustomShape = !!d2;
  const yOffsetProp = computedStaticOffset && alignment === "end" ? "bottom" : "top";
  let xOffsetProp = computedStaticOffset && alignment === "end" ? "right" : "left";
  if (computedStaticOffset && isRTL2) {
    xOffsetProp = alignment === "end" ? "left" : "right";
  }
  const arrowX = (arrow2 == null ? void 0 : arrow2.x) != null ? computedStaticOffset || arrow2.x : "";
  const arrowY = (arrow2 == null ? void 0 : arrow2.y) != null ? computedStaticOffset || arrow2.y : "";
  const dValue = d2 || "M0,0" + (" H" + width2) + (" L" + (width2 - svgX) + "," + (height2 - svgY)) + (" Q" + width2 / 2 + "," + height2 + " " + svgX + "," + (height2 - svgY)) + " Z";
  const rotation = {
    top: isCustomShape ? "rotate(180deg)" : "",
    left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: isCustomShape ? "" : "rotate(180deg)",
    right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
  }[side];
  return /* @__PURE__ */ React.createElement("svg", _extends$5({}, rest, {
    "aria-hidden": true,
    ref: ref2,
    width: isCustomShape ? width2 : width2 + computedStrokeWidth,
    height: width2,
    viewBox: "0 0 " + width2 + " " + (height2 > width2 ? height2 : width2),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [xOffsetProp]: arrowX,
      [yOffsetProp]: arrowY,
      [side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + computedStrokeWidth / 2 + "px)",
      transform: [rotation, transform].filter((t2) => !!t2).join(" "),
      ...restStyle
    }
  }), computedStrokeWidth > 0 && /* @__PURE__ */ React.createElement("path", {
    clipPath: "url(#" + clipPathId + ")",
    fill: "none",
    stroke,
    strokeWidth: computedStrokeWidth + (d2 ? 0 : 1),
    d: dValue
  }), /* @__PURE__ */ React.createElement("path", {
    stroke: computedStrokeWidth && !d2 ? rest.fill : "none",
    d: dValue
  }), /* @__PURE__ */ React.createElement("clipPath", {
    id: clipPathId
  }, /* @__PURE__ */ React.createElement("rect", {
    x: -halfStrokeWidth,
    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
    width: width2 + computedStrokeWidth,
    height: width2
  })));
});
function createPubSub() {
  const map3 = /* @__PURE__ */ new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map3.get(event)) == null || _map$get.forEach((handler) => handler(data));
    },
    on(event, listener) {
      map3.set(event, [...map3.get(event) || [], listener]);
    },
    off(event, listener) {
      var _map$get2;
      map3.set(event, ((_map$get2 = map3.get(event)) == null ? void 0 : _map$get2.filter((l2) => l2 !== listener)) || []);
    }
  };
}
const FloatingNodeContext = /* @__PURE__ */ React.createContext(null);
const FloatingTreeContext = /* @__PURE__ */ React.createContext(null);
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = React.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const useFloatingTree = () => React.useContext(FloatingTreeContext);
function useFloatingRootContext(options) {
  const {
    open = false,
    onOpenChange: onOpenChangeProp,
    elements: elementsProp
  } = options;
  const floatingId = useId$1();
  const dataRef = React.useRef({});
  const [events2] = React.useState(() => createPubSub());
  const nested = useFloatingParentNodeId() != null;
  if (process.env.NODE_ENV !== "production") {
    const optionDomReference = elementsProp.reference;
    if (optionDomReference && !isElement$1(optionDomReference)) {
      error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
    }
  }
  const [positionReference, setPositionReference] = React.useState(elementsProp.reference);
  const onOpenChange = useEffectEvent((open2, event, reason) => {
    dataRef.current.openEvent = open2 ? event : void 0;
    events2.emit("openchange", {
      open: open2,
      event,
      reason,
      nested
    });
    onOpenChangeProp == null || onOpenChangeProp(open2, event, reason);
  });
  const refs = React.useMemo(() => ({
    setPositionReference
  }), []);
  const elements = React.useMemo(() => ({
    reference: positionReference || elementsProp.reference || null,
    floating: elementsProp.floating || null,
    domReference: elementsProp.reference
  }), [positionReference, elementsProp.reference, elementsProp.floating]);
  return React.useMemo(() => ({
    dataRef,
    open,
    onOpenChange,
    elements,
    events: events2,
    floatingId,
    refs
  }), [open, onOpenChange, elements, events2, floatingId, refs]);
}
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    nodeId
  } = options;
  const internalRootContext = useFloatingRootContext({
    ...options,
    elements: {
      reference: null,
      floating: null,
      ...options.elements
    }
  });
  const rootContext = options.rootContext || internalRootContext;
  const computedElements = rootContext.elements;
  const [_domReference, setDomReference] = React.useState(null);
  const [positionReference, _setPositionReference] = React.useState(null);
  const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
  const domReference = optionDomReference || _domReference;
  const domReferenceRef = React.useRef(null);
  const tree = useFloatingTree();
  index$2(() => {
    if (domReference) {
      domReferenceRef.current = domReference;
    }
  }, [domReference]);
  const position4 = useFloating$1({
    ...options,
    elements: {
      ...computedElements,
      ...positionReference && {
        reference: positionReference
      }
    }
  });
  const setPositionReference = React.useCallback((node2) => {
    const computedPositionReference = isElement$1(node2) ? {
      getBoundingClientRect: () => node2.getBoundingClientRect(),
      contextElement: node2
    } : node2;
    _setPositionReference(computedPositionReference);
    position4.refs.setReference(computedPositionReference);
  }, [position4.refs]);
  const setReference = React.useCallback((node2) => {
    if (isElement$1(node2) || node2 === null) {
      domReferenceRef.current = node2;
      setDomReference(node2);
    }
    if (isElement$1(position4.refs.reference.current) || position4.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node2 !== null && !isElement$1(node2)) {
      position4.refs.setReference(node2);
    }
  }, [position4.refs]);
  const refs = React.useMemo(() => ({
    ...position4.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position4.refs, setReference, setPositionReference]);
  const elements = React.useMemo(() => ({
    ...position4.elements,
    domReference
  }), [position4.elements, domReference]);
  const context = React.useMemo(() => ({
    ...position4,
    ...rootContext,
    refs,
    elements,
    nodeId
  }), [position4, refs, elements, nodeId, rootContext]);
  index$2(() => {
    rootContext.dataRef.current.floatingContext = context;
    const node2 = tree == null ? void 0 : tree.nodesRef.current.find((node3) => node3.id === nodeId);
    if (node2) {
      node2.context = context;
    }
  });
  return React.useMemo(() => ({
    ...position4,
    context,
    refs,
    elements
  }), [position4, refs, elements, context]);
}
/*!
  react-datepicker v6.9.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/
function _callSuper(t2, o2, e) {
  return o2 = _getPrototypeOf$1(o2), _possibleConstructorReturn$1(t2, _isNativeReflectConstruct$2() ? Reflect.construct(o2, e || [], _getPrototypeOf$1(t2).constructor) : o2.apply(t2, e));
}
function _isNativeReflectConstruct$2() {
  try {
    var t2 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t3) {
  }
  return (_isNativeReflectConstruct$2 = function() {
    return !!t2;
  })();
}
function ownKeys$6(e, r2) {
  var t2 = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t2.push.apply(t2, o2);
  }
  return t2;
}
function _objectSpread2$1(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t2 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$6(Object(t2), true).forEach(function(r3) {
      _defineProperty$2(e, r3, t2[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t2)) : ownKeys$6(Object(t2)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t2, r3));
    });
  }
  return e;
}
function _toPrimitive$2(t2, r2) {
  if ("object" != typeof t2 || !t2) return t2;
  var e = t2[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t2, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t2);
}
function _toPropertyKey$1(t2) {
  var i = _toPrimitive$2(t2, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o2) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof(o2);
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty$2(obj, key2, value) {
  key2 = _toPropertyKey$1(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _getPrototypeOf$1(o2) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$1(o2);
}
function _setPrototypeOf$1(o2, p2) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$1(o2, p2);
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn$1(self2, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self2);
}
function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$1();
}
function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);
}
function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray$2(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$2(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$2(o2, minLen);
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var DEFAULT_YEAR_ITEM_NUMBER = 12;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function newDate(value) {
  var d2 = value ? typeof value === "string" || value instanceof String ? parseISO(value) : toDate$1(value) : /* @__PURE__ */ new Date();
  return isValid$4(d2) ? d2 : null;
}
function parseDate(value, dateFormat, locale2, strictParsing, minDate) {
  var parsedDate = null;
  var localeObject = getLocaleObject(locale2) || getLocaleObject(getDefaultLocale());
  var strictParsingValueMatch = true;
  if (Array.isArray(dateFormat)) {
    dateFormat.forEach(function(df) {
      var tryParseDate = parse$2(value, df, /* @__PURE__ */ new Date(), {
        locale: localeObject,
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
      });
      if (strictParsing) {
        strictParsingValueMatch = isValid$4(tryParseDate, minDate) && value === formatDate(tryParseDate, df, locale2);
      }
      if (isValid$4(tryParseDate, minDate) && strictParsingValueMatch) {
        parsedDate = tryParseDate;
      }
    });
    return parsedDate;
  }
  parsedDate = parse$2(value, dateFormat, /* @__PURE__ */ new Date(), {
    locale: localeObject,
    useAdditionalWeekYearTokens: true,
    useAdditionalDayOfYearTokens: true
  });
  if (strictParsing) {
    strictParsingValueMatch = isValid$4(parsedDate) && value === formatDate(parsedDate, dateFormat, locale2);
  } else if (!isValid$4(parsedDate)) {
    dateFormat = dateFormat.match(longFormattingTokensRegExp).map(function(substring) {
      var firstCharacter = substring[0];
      if (firstCharacter === "p" || firstCharacter === "P") {
        var longFormatter = longFormatters[firstCharacter];
        return localeObject ? longFormatter(substring, localeObject.formatLong) : firstCharacter;
      }
      return substring;
    }).join("");
    if (value.length > 0) {
      parsedDate = parse$2(value, dateFormat.slice(0, value.length), /* @__PURE__ */ new Date(), {
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
      });
    }
    if (!isValid$4(parsedDate)) {
      parsedDate = new Date(value);
    }
  }
  return isValid$4(parsedDate) && strictParsingValueMatch ? parsedDate : null;
}
function isValid$4(date, minDate) {
  minDate = minDate ? minDate : /* @__PURE__ */ new Date("1/1/1000");
  return isValid$5(date) && !isBefore$1(date, minDate);
}
function formatDate(date, formatStr, locale2) {
  if (locale2 === "en") {
    return format$1(date, formatStr, {
      useAdditionalWeekYearTokens: true,
      useAdditionalDayOfYearTokens: true
    });
  }
  var localeObj = getLocaleObject(locale2);
  if (locale2 && !localeObj) {
    console.warn('A locale object was not found for the provided string ["'.concat(locale2, '"].'));
  }
  if (!localeObj && !!getDefaultLocale() && !!getLocaleObject(getDefaultLocale())) {
    localeObj = getLocaleObject(getDefaultLocale());
  }
  return format$1(date, formatStr, {
    locale: localeObj ? localeObj : null,
    useAdditionalWeekYearTokens: true,
    useAdditionalDayOfYearTokens: true
  });
}
function safeDateFormat(date, _ref) {
  var dateFormat = _ref.dateFormat, locale2 = _ref.locale;
  return date && formatDate(date, Array.isArray(dateFormat) ? dateFormat[0] : dateFormat, locale2) || "";
}
function safeDateRangeFormat(startDate, endDate, props) {
  if (!startDate) {
    return "";
  }
  var formattedStartDate = safeDateFormat(startDate, props);
  var formattedEndDate = endDate ? safeDateFormat(endDate, props) : "";
  return "".concat(formattedStartDate, " - ").concat(formattedEndDate);
}
function safeMultipleDatesFormat(dates, props) {
  if (!(dates !== null && dates !== void 0 && dates.length)) {
    return "";
  }
  var formattedFirstDate = safeDateFormat(dates[0], props);
  if (dates.length === 1) {
    return formattedFirstDate;
  }
  if (dates.length === 2) {
    var formattedSecondDate = safeDateFormat(dates[1], props);
    return "".concat(formattedFirstDate, ", ").concat(formattedSecondDate);
  }
  var extraDatesCount = dates.length - 1;
  return "".concat(formattedFirstDate, " (+").concat(extraDatesCount, ")");
}
function setTime(date, _ref2) {
  var _ref2$hour = _ref2.hour, hour = _ref2$hour === void 0 ? 0 : _ref2$hour, _ref2$minute = _ref2.minute, minute = _ref2$minute === void 0 ? 0 : _ref2$minute, _ref2$second = _ref2.second, second = _ref2$second === void 0 ? 0 : _ref2$second;
  return setHours(setMinutes(setSeconds(date, second), minute), hour);
}
function getWeek(date, locale2) {
  getDefaultLocale() && getLocaleObject(getDefaultLocale());
  return getISOWeek(date);
}
function getDayOfWeekCode(day, locale2) {
  return formatDate(day, "ddd", locale2);
}
function getStartOfDay(date) {
  return startOfDay(date);
}
function getStartOfWeek(date, locale2, calendarStartDay) {
  var localeObj = locale2 ? getLocaleObject(locale2) : getLocaleObject(getDefaultLocale());
  return startOfWeek(date, {
    locale: localeObj,
    weekStartsOn: calendarStartDay
  });
}
function getStartOfMonth(date) {
  return startOfMonth(date);
}
function getStartOfYear(date) {
  return startOfYear(date);
}
function getStartOfQuarter(date) {
  return startOfQuarter(date);
}
function getStartOfToday() {
  return startOfDay(newDate());
}
function getEndOfWeek(date) {
  return endOfWeek(date);
}
function isSameYear(date1, date2) {
  if (date1 && date2) {
    return isSameYear$1(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
function isSameMonth(date1, date2) {
  if (date1 && date2) {
    return isSameMonth$1(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
function isSameQuarter(date1, date2) {
  if (date1 && date2) {
    return isSameQuarter$1(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
function isSameDay(date1, date2) {
  if (date1 && date2) {
    return isSameDay$1(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
function isEqual$3(date1, date2) {
  if (date1 && date2) {
    return isEqual$4(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
function isDayInRange(day, startDate, endDate) {
  var valid2;
  var start4 = startOfDay(startDate);
  var end2 = endOfDay(endDate);
  try {
    valid2 = isWithinInterval(day, {
      start: start4,
      end: end2
    });
  } catch (err) {
    valid2 = false;
  }
  return valid2;
}
function getDefaultLocale() {
  var scope = typeof window !== "undefined" ? window : globalThis;
  return scope.__localeId__;
}
function getLocaleObject(localeSpec) {
  if (typeof localeSpec === "string") {
    var scope = typeof window !== "undefined" ? window : globalThis;
    return scope.__localeData__ ? scope.__localeData__[localeSpec] : null;
  } else {
    return localeSpec;
  }
}
function getFormattedWeekdayInLocale(date, formatFunc, locale2) {
  return formatFunc(formatDate(date, "EEEE", locale2));
}
function getWeekdayMinInLocale(date, locale2) {
  return formatDate(date, "EEEEEE", locale2);
}
function getWeekdayShortInLocale(date, locale2) {
  return formatDate(date, "EEE", locale2);
}
function getMonthInLocale(month, locale2) {
  return formatDate(setMonth$1(newDate(), month), "LLLL", locale2);
}
function getMonthShortInLocale(month, locale2) {
  return formatDate(setMonth$1(newDate(), month), "LLL", locale2);
}
function getQuarterShortInLocale(quarter, locale2) {
  return formatDate(setQuarter(newDate(), quarter), "QQQ", locale2);
}
function isDayDisabled(day) {
  var _ref3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, minDate = _ref3.minDate, maxDate = _ref3.maxDate, excludeDates = _ref3.excludeDates, excludeDateIntervals = _ref3.excludeDateIntervals, includeDates = _ref3.includeDates, includeDateIntervals = _ref3.includeDateIntervals, filterDate = _ref3.filterDate;
  return isOutOfBounds(day, {
    minDate,
    maxDate
  }) || excludeDates && excludeDates.some(function(excludeDate) {
    return isSameDay(day, excludeDate.date ? excludeDate.date : excludeDate);
  }) || excludeDateIntervals && excludeDateIntervals.some(function(_ref4) {
    var start4 = _ref4.start, end2 = _ref4.end;
    return isWithinInterval(day, {
      start: start4,
      end: end2
    });
  }) || includeDates && !includeDates.some(function(includeDate) {
    return isSameDay(day, includeDate);
  }) || includeDateIntervals && !includeDateIntervals.some(function(_ref5) {
    var start4 = _ref5.start, end2 = _ref5.end;
    return isWithinInterval(day, {
      start: start4,
      end: end2
    });
  }) || filterDate && !filterDate(newDate(day)) || false;
}
function isDayExcluded(day) {
  var _ref6 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, excludeDates = _ref6.excludeDates, excludeDateIntervals = _ref6.excludeDateIntervals;
  if (excludeDateIntervals && excludeDateIntervals.length > 0) {
    return excludeDateIntervals.some(function(_ref7) {
      var start4 = _ref7.start, end2 = _ref7.end;
      return isWithinInterval(day, {
        start: start4,
        end: end2
      });
    });
  }
  return excludeDates && excludeDates.some(function(excludeDate) {
    return isSameDay(day, excludeDate.date ? excludeDate.date : excludeDate);
  }) || false;
}
function isMonthDisabled(month) {
  var _ref8 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, minDate = _ref8.minDate, maxDate = _ref8.maxDate, excludeDates = _ref8.excludeDates, includeDates = _ref8.includeDates, filterDate = _ref8.filterDate;
  return isOutOfBounds(month, {
    minDate: startOfMonth(minDate),
    maxDate: endOfMonth(maxDate)
  }) || excludeDates && excludeDates.some(function(excludeDate) {
    return isSameMonth(month, excludeDate);
  }) || includeDates && !includeDates.some(function(includeDate) {
    return isSameMonth(month, includeDate);
  }) || filterDate && !filterDate(newDate(month)) || false;
}
function isMonthInRange(startDate, endDate, m2, day) {
  var startDateYear = getYear(startDate);
  var startDateMonth = getMonth(startDate);
  var endDateYear = getYear(endDate);
  var endDateMonth = getMonth(endDate);
  var dayYear = getYear(day);
  if (startDateYear === endDateYear && startDateYear === dayYear) {
    return startDateMonth <= m2 && m2 <= endDateMonth;
  } else if (startDateYear < endDateYear) {
    return dayYear === startDateYear && startDateMonth <= m2 || dayYear === endDateYear && endDateMonth >= m2 || dayYear < endDateYear && dayYear > startDateYear;
  }
}
function isQuarterDisabled(quarter) {
  var _ref9 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, minDate = _ref9.minDate, maxDate = _ref9.maxDate, excludeDates = _ref9.excludeDates, includeDates = _ref9.includeDates, filterDate = _ref9.filterDate;
  return isOutOfBounds(quarter, {
    minDate,
    maxDate
  }) || excludeDates && excludeDates.some(function(excludeDate) {
    return isSameQuarter(quarter, excludeDate);
  }) || includeDates && !includeDates.some(function(includeDate) {
    return isSameQuarter(quarter, includeDate);
  }) || filterDate && !filterDate(newDate(quarter)) || false;
}
function isYearInRange(year, start4, end2) {
  if (!isValid$5(start4) || !isValid$5(end2)) return false;
  var startYear = getYear(start4);
  var endYear = getYear(end2);
  return startYear <= year && endYear >= year;
}
function isYearDisabled(year) {
  var _ref10 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, minDate = _ref10.minDate, maxDate = _ref10.maxDate, excludeDates = _ref10.excludeDates, includeDates = _ref10.includeDates, filterDate = _ref10.filterDate;
  var date = new Date(year, 0, 1);
  return isOutOfBounds(date, {
    minDate: startOfYear(minDate),
    maxDate: endOfYear(maxDate)
  }) || excludeDates && excludeDates.some(function(excludeDate) {
    return isSameYear(date, excludeDate);
  }) || includeDates && !includeDates.some(function(includeDate) {
    return isSameYear(date, includeDate);
  }) || filterDate && !filterDate(newDate(date)) || false;
}
function isQuarterInRange(startDate, endDate, q2, day) {
  var startDateYear = getYear(startDate);
  var startDateQuarter = getQuarter(startDate);
  var endDateYear = getYear(endDate);
  var endDateQuarter = getQuarter(endDate);
  var dayYear = getYear(day);
  if (startDateYear === endDateYear && startDateYear === dayYear) {
    return startDateQuarter <= q2 && q2 <= endDateQuarter;
  } else if (startDateYear < endDateYear) {
    return dayYear === startDateYear && startDateQuarter <= q2 || dayYear === endDateYear && endDateQuarter >= q2 || dayYear < endDateYear && dayYear > startDateYear;
  }
}
function isOutOfBounds(day) {
  var _ref11 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, minDate = _ref11.minDate, maxDate = _ref11.maxDate;
  return minDate && differenceInCalendarDays(day, minDate) < 0 || maxDate && differenceInCalendarDays(day, maxDate) > 0;
}
function isTimeInList(time, times) {
  return times.some(function(listTime) {
    return getHours(listTime) === getHours(time) && getMinutes(listTime) === getMinutes(time) && getSeconds(listTime) === getSeconds(time);
  });
}
function isTimeDisabled(time) {
  var _ref12 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, excludeTimes = _ref12.excludeTimes, includeTimes = _ref12.includeTimes, filterTime = _ref12.filterTime;
  return excludeTimes && isTimeInList(time, excludeTimes) || includeTimes && !isTimeInList(time, includeTimes) || filterTime && !filterTime(time) || false;
}
function isTimeInDisabledRange(time, _ref13) {
  var minTime = _ref13.minTime, maxTime = _ref13.maxTime;
  if (!minTime || !maxTime) {
    throw new Error("Both minTime and maxTime props required");
  }
  var baseTime = newDate();
  baseTime = setHours(baseTime, getHours(time));
  baseTime = setMinutes(baseTime, getMinutes(time));
  baseTime = setSeconds(baseTime, getSeconds(time));
  var min2 = newDate();
  min2 = setHours(min2, getHours(minTime));
  min2 = setMinutes(min2, getMinutes(minTime));
  min2 = setSeconds(min2, getSeconds(minTime));
  var max2 = newDate();
  max2 = setHours(max2, getHours(maxTime));
  max2 = setMinutes(max2, getMinutes(maxTime));
  max2 = setSeconds(max2, getSeconds(maxTime));
  var valid2;
  try {
    valid2 = !isWithinInterval(baseTime, {
      start: min2,
      end: max2
    });
  } catch (err) {
    valid2 = false;
  }
  return valid2;
}
function monthDisabledBefore(day) {
  var _ref14 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, minDate = _ref14.minDate, includeDates = _ref14.includeDates;
  var previousMonth = subMonths(day, 1);
  return minDate && differenceInCalendarMonths(minDate, previousMonth) > 0 || includeDates && includeDates.every(function(includeDate) {
    return differenceInCalendarMonths(includeDate, previousMonth) > 0;
  }) || false;
}
function monthDisabledAfter(day) {
  var _ref15 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, maxDate = _ref15.maxDate, includeDates = _ref15.includeDates;
  var nextMonth = addMonths(day, 1);
  return maxDate && differenceInCalendarMonths(nextMonth, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
    return differenceInCalendarMonths(nextMonth, includeDate) > 0;
  }) || false;
}
function quarterDisabledBefore(date) {
  var _ref16 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, minDate = _ref16.minDate, includeDates = _ref16.includeDates;
  var firstDateOfYear = startOfYear(date);
  var previousQuarter = subQuarters(firstDateOfYear);
  return minDate && differenceInCalendarQuarters(minDate, previousQuarter) > 0 || includeDates && includeDates.every(function(includeDate) {
    return differenceInCalendarQuarters(includeDate, previousQuarter) > 0;
  }) || false;
}
function quarterDisabledAfter(date) {
  var _ref17 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, maxDate = _ref17.maxDate, includeDates = _ref17.includeDates;
  var lastDateOfYear = endOfYear(date);
  var nextQuarter = addQuarters(lastDateOfYear, 1);
  return maxDate && differenceInCalendarQuarters(nextQuarter, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
    return differenceInCalendarQuarters(nextQuarter, includeDate) > 0;
  }) || false;
}
function yearDisabledBefore(day) {
  var _ref18 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, minDate = _ref18.minDate, includeDates = _ref18.includeDates;
  var previousYear = subYears(day, 1);
  return minDate && differenceInCalendarYears(minDate, previousYear) > 0 || includeDates && includeDates.every(function(includeDate) {
    return differenceInCalendarYears(includeDate, previousYear) > 0;
  }) || false;
}
function yearsDisabledBefore(day) {
  var _ref19 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, minDate = _ref19.minDate, _ref19$yearItemNumber = _ref19.yearItemNumber, yearItemNumber = _ref19$yearItemNumber === void 0 ? DEFAULT_YEAR_ITEM_NUMBER : _ref19$yearItemNumber;
  var previousYear = getStartOfYear(subYears(day, yearItemNumber));
  var _getYearsPeriod = getYearsPeriod(previousYear, yearItemNumber), endPeriod = _getYearsPeriod.endPeriod;
  var minDateYear = minDate && getYear(minDate);
  return minDateYear && minDateYear > endPeriod || false;
}
function yearDisabledAfter(day) {
  var _ref20 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, maxDate = _ref20.maxDate, includeDates = _ref20.includeDates;
  var nextYear = addYears(day, 1);
  return maxDate && differenceInCalendarYears(nextYear, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
    return differenceInCalendarYears(nextYear, includeDate) > 0;
  }) || false;
}
function yearsDisabledAfter(day) {
  var _ref21 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, maxDate = _ref21.maxDate, _ref21$yearItemNumber = _ref21.yearItemNumber, yearItemNumber = _ref21$yearItemNumber === void 0 ? DEFAULT_YEAR_ITEM_NUMBER : _ref21$yearItemNumber;
  var nextYear = addYears(day, yearItemNumber);
  var _getYearsPeriod2 = getYearsPeriod(nextYear, yearItemNumber), startPeriod = _getYearsPeriod2.startPeriod;
  var maxDateYear = maxDate && getYear(maxDate);
  return maxDateYear && maxDateYear < startPeriod || false;
}
function getEffectiveMinDate(_ref22) {
  var minDate = _ref22.minDate, includeDates = _ref22.includeDates;
  if (includeDates && minDate) {
    var minDates = includeDates.filter(function(includeDate) {
      return differenceInCalendarDays(includeDate, minDate) >= 0;
    });
    return min$2(minDates);
  } else if (includeDates) {
    return min$2(includeDates);
  } else {
    return minDate;
  }
}
function getEffectiveMaxDate(_ref23) {
  var maxDate = _ref23.maxDate, includeDates = _ref23.includeDates;
  if (includeDates && maxDate) {
    var maxDates = includeDates.filter(function(includeDate) {
      return differenceInCalendarDays(includeDate, maxDate) <= 0;
    });
    return max$2(maxDates);
  } else if (includeDates) {
    return max$2(includeDates);
  } else {
    return maxDate;
  }
}
function getHightLightDaysMap() {
  var highlightDates = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var defaultClassName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--highlighted";
  var dateClasses = /* @__PURE__ */ new Map();
  for (var i = 0, len = highlightDates.length; i < len; i++) {
    var obj = highlightDates[i];
    if (isDate$1(obj)) {
      var key2 = formatDate(obj, "MM.dd.yyyy");
      var classNamesArr = dateClasses.get(key2) || [];
      if (!classNamesArr.includes(defaultClassName)) {
        classNamesArr.push(defaultClassName);
        dateClasses.set(key2, classNamesArr);
      }
    } else if (_typeof(obj) === "object") {
      var keys2 = Object.keys(obj);
      var className = keys2[0];
      var arrOfDates = obj[keys2[0]];
      if (typeof className === "string" && arrOfDates.constructor === Array) {
        for (var k2 = 0, _len = arrOfDates.length; k2 < _len; k2++) {
          var _key = formatDate(arrOfDates[k2], "MM.dd.yyyy");
          var _classNamesArr = dateClasses.get(_key) || [];
          if (!_classNamesArr.includes(className)) {
            _classNamesArr.push(className);
            dateClasses.set(_key, _classNamesArr);
          }
        }
      }
    }
  }
  return dateClasses;
}
function arraysAreEqual(array1, array2) {
  if (array1.length !== array2.length) {
    return false;
  }
  return array1.every(function(value, index2) {
    return value === array2[index2];
  });
}
function getHolidaysMap() {
  var holidayDates = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var defaultClassName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--holidays";
  var dateClasses = /* @__PURE__ */ new Map();
  holidayDates.forEach(function(holiday) {
    var dateObj = holiday.date, holidayName = holiday.holidayName;
    if (!isDate$1(dateObj)) {
      return;
    }
    var key2 = formatDate(dateObj, "MM.dd.yyyy");
    var classNamesObj = dateClasses.get(key2) || {};
    if ("className" in classNamesObj && classNamesObj["className"] === defaultClassName && arraysAreEqual(classNamesObj["holidayNames"], [holidayName])) {
      return;
    }
    classNamesObj["className"] = defaultClassName;
    var holidayNameArr = classNamesObj["holidayNames"];
    classNamesObj["holidayNames"] = holidayNameArr ? [].concat(_toConsumableArray$1(holidayNameArr), [holidayName]) : [holidayName];
    dateClasses.set(key2, classNamesObj);
  });
  return dateClasses;
}
function timesToInjectAfter(startOfDay2, currentTime, currentMultiplier, intervals, injectedTimes) {
  var l2 = injectedTimes.length;
  var times = [];
  for (var i = 0; i < l2; i++) {
    var injectedTime = startOfDay2;
    injectedTime = addHours(injectedTime, getHours(injectedTimes[i]));
    injectedTime = addMinutes(injectedTime, getMinutes(injectedTimes[i]));
    injectedTime = addSeconds(injectedTime, getSeconds(injectedTimes[i]));
    var nextTime = addMinutes(startOfDay2, (currentMultiplier + 1) * intervals);
    if (isAfter$2(injectedTime, currentTime) && isBefore$1(injectedTime, nextTime)) {
      times.push(injectedTimes[i]);
    }
  }
  return times;
}
function addZero(i) {
  return i < 10 ? "0".concat(i) : "".concat(i);
}
function getYearsPeriod(date) {
  var yearItemNumber = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_YEAR_ITEM_NUMBER;
  var endPeriod = Math.ceil(getYear(date) / yearItemNumber) * yearItemNumber;
  var startPeriod = endPeriod - (yearItemNumber - 1);
  return {
    startPeriod,
    endPeriod
  };
}
function getHoursInDay(d2) {
  var startOfDay2 = new Date(d2.getFullYear(), d2.getMonth(), d2.getDate());
  var startOfTheNextDay = new Date(d2.getFullYear(), d2.getMonth(), d2.getDate(), 24);
  return Math.round((+startOfTheNextDay - +startOfDay2) / 36e5);
}
function startOfMinute(d2) {
  var seconds2 = d2.getSeconds();
  var milliseconds2 = d2.getMilliseconds();
  return toDate$1(d2.getTime() - seconds2 * 1e3 - milliseconds2);
}
function isSameMinute(d1, d2) {
  return startOfMinute(d1).getTime() === startOfMinute(d2).getTime();
}
function getMidnightDate(date) {
  if (!isDate$1(date)) {
    throw new Error("Invalid date");
  }
  var dateWithoutTime = new Date(date);
  dateWithoutTime.setHours(0, 0, 0, 0);
  return dateWithoutTime;
}
function isDateBefore(date, dateToCompare) {
  if (!isDate$1(date) || !isDate$1(dateToCompare)) {
    throw new Error("Invalid date received");
  }
  var midnightDate = getMidnightDate(date);
  var midnightDateToCompare = getMidnightDate(dateToCompare);
  return isBefore$1(midnightDate, midnightDateToCompare);
}
function isSpaceKeyDown(event) {
  var SPACE_KEY = " ";
  return event.key === SPACE_KEY;
}
function generateYears(year, noOfYear, minDate, maxDate) {
  var list2 = [];
  for (var i = 0; i < 2 * noOfYear + 1; i++) {
    var newYear = year + noOfYear - i;
    var isInRange = true;
    if (minDate) {
      isInRange = getYear(minDate) <= newYear;
    }
    if (maxDate && isInRange) {
      isInRange = getYear(maxDate) >= newYear;
    }
    if (isInRange) {
      list2.push(newYear);
    }
  }
  return list2;
}
var YearDropdownOptions = /* @__PURE__ */ function(_React$Component) {
  function YearDropdownOptions2(props) {
    var _this;
    _classCallCheck$1(this, YearDropdownOptions2);
    _this = _callSuper(this, YearDropdownOptions2, [props]);
    _defineProperty$2(_this, "renderOptions", function() {
      var selectedYear = _this.props.year;
      var options = _this.state.yearsList.map(function(year) {
        return /* @__PURE__ */ React__default.createElement("div", {
          className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
          key: year,
          onClick: _this.onChange.bind(_this, year),
          "aria-selected": selectedYear === year ? "true" : void 0
        }, selectedYear === year ? /* @__PURE__ */ React__default.createElement("span", {
          className: "react-datepicker__year-option--selected"
        }, "✓") : "", year);
      });
      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : null;
      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : null;
      if (!maxYear || !_this.state.yearsList.find(function(year) {
        return year === maxYear;
      })) {
        options.unshift(/* @__PURE__ */ React__default.createElement("div", {
          className: "react-datepicker__year-option",
          key: "upcoming",
          onClick: _this.incrementYears
        }, /* @__PURE__ */ React__default.createElement("a", {
          className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
        })));
      }
      if (!minYear || !_this.state.yearsList.find(function(year) {
        return year === minYear;
      })) {
        options.push(/* @__PURE__ */ React__default.createElement("div", {
          className: "react-datepicker__year-option",
          key: "previous",
          onClick: _this.decrementYears
        }, /* @__PURE__ */ React__default.createElement("a", {
          className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
        })));
      }
      return options;
    });
    _defineProperty$2(_this, "onChange", function(year) {
      _this.props.onChange(year);
    });
    _defineProperty$2(_this, "handleClickOutside", function() {
      _this.props.onCancel();
    });
    _defineProperty$2(_this, "shiftYears", function(amount) {
      var years2 = _this.state.yearsList.map(function(year) {
        return year + amount;
      });
      _this.setState({
        yearsList: years2
      });
    });
    _defineProperty$2(_this, "incrementYears", function() {
      return _this.shiftYears(1);
    });
    _defineProperty$2(_this, "decrementYears", function() {
      return _this.shiftYears(-1);
    });
    var yearDropdownItemNumber = props.yearDropdownItemNumber, scrollableYearDropdown = props.scrollableYearDropdown;
    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
    _this.state = {
      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
    };
    _this.dropdownRef = /* @__PURE__ */ createRef();
    return _this;
  }
  _inherits$1(YearDropdownOptions2, _React$Component);
  return _createClass$1(YearDropdownOptions2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var dropdownCurrent = this.dropdownRef.current;
      if (dropdownCurrent) {
        var dropdownCurrentChildren = dropdownCurrent.children ? Array.from(dropdownCurrent.children) : null;
        var selectedYearOptionEl = dropdownCurrentChildren ? dropdownCurrentChildren.find(function(childEl) {
          return childEl.ariaSelected;
        }) : null;
        dropdownCurrent.scrollTop = selectedYearOptionEl ? selectedYearOptionEl.offsetTop + (selectedYearOptionEl.clientHeight - dropdownCurrent.clientHeight) / 2 : (dropdownCurrent.scrollHeight - dropdownCurrent.clientHeight) / 2;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var dropdownClass = clsx({
        "react-datepicker__year-dropdown": true,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return /* @__PURE__ */ React__default.createElement("div", {
        className: dropdownClass,
        ref: this.dropdownRef
      }, this.renderOptions());
    }
  }]);
}(React__default.Component);
var WrappedYearDropdownOptions = onClickOutsideHOC(YearDropdownOptions);
var YearDropdown = /* @__PURE__ */ function(_React$Component) {
  function YearDropdown2() {
    var _this;
    _classCallCheck$1(this, YearDropdown2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, YearDropdown2, [].concat(args));
    _defineProperty$2(_this, "state", {
      dropdownVisible: false
    });
    _defineProperty$2(_this, "renderSelectOptions", function() {
      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;
      var options = [];
      for (var i = minYear; i <= maxYear; i++) {
        options.push(/* @__PURE__ */ React__default.createElement("option", {
          key: i,
          value: i
        }, i));
      }
      return options;
    });
    _defineProperty$2(_this, "onSelectChange", function(e) {
      _this.onChange(e.target.value);
    });
    _defineProperty$2(_this, "renderSelectMode", function() {
      return /* @__PURE__ */ React__default.createElement("select", {
        value: _this.props.year,
        className: "react-datepicker__year-select",
        onChange: _this.onSelectChange
      }, _this.renderSelectOptions());
    });
    _defineProperty$2(_this, "renderReadView", function(visible) {
      return /* @__PURE__ */ React__default.createElement("div", {
        key: "read",
        style: {
          visibility: visible ? "visible" : "hidden"
        },
        className: "react-datepicker__year-read-view",
        onClick: function onClick(event) {
          return _this.toggleDropdown(event);
        }
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "react-datepicker__year-read-view--down-arrow"
      }), /* @__PURE__ */ React__default.createElement("span", {
        className: "react-datepicker__year-read-view--selected-year"
      }, _this.props.year));
    });
    _defineProperty$2(_this, "renderDropdown", function() {
      return /* @__PURE__ */ React__default.createElement(WrappedYearDropdownOptions, {
        key: "dropdown",
        year: _this.props.year,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    });
    _defineProperty$2(_this, "renderScrollMode", function() {
      var dropdownVisible = _this.state.dropdownVisible;
      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    });
    _defineProperty$2(_this, "onChange", function(year) {
      _this.toggleDropdown();
      if (year === _this.props.year) return;
      _this.props.onChange(year);
    });
    _defineProperty$2(_this, "toggleDropdown", function(event) {
      _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      }, function() {
        if (_this.props.adjustDateOnChange) {
          _this.handleYearChange(_this.props.date, event);
        }
      });
    });
    _defineProperty$2(_this, "handleYearChange", function(date, event) {
      _this.onSelect(date, event);
      _this.setOpen();
    });
    _defineProperty$2(_this, "onSelect", function(date, event) {
      if (_this.props.onSelect) {
        _this.props.onSelect(date, event);
      }
    });
    _defineProperty$2(_this, "setOpen", function() {
      if (_this.props.setOpen) {
        _this.props.setOpen(true);
      }
    });
    return _this;
  }
  _inherits$1(YearDropdown2, _React$Component);
  return _createClass$1(YearDropdown2, [{
    key: "render",
    value: function render() {
      var renderedDropdown;
      switch (this.props.dropdownMode) {
        case "scroll":
          renderedDropdown = this.renderScrollMode();
          break;
        case "select":
          renderedDropdown = this.renderSelectMode();
          break;
      }
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
      }, renderedDropdown);
    }
  }]);
}(React__default.Component);
var MonthDropdownOptions = /* @__PURE__ */ function(_React$Component) {
  function MonthDropdownOptions2() {
    var _this;
    _classCallCheck$1(this, MonthDropdownOptions2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MonthDropdownOptions2, [].concat(args));
    _defineProperty$2(_this, "isSelectedMonth", function(i) {
      return _this.props.month === i;
    });
    _defineProperty$2(_this, "renderOptions", function() {
      return _this.props.monthNames.map(function(month, i) {
        return /* @__PURE__ */ React__default.createElement("div", {
          className: _this.isSelectedMonth(i) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
          key: month,
          onClick: _this.onChange.bind(_this, i),
          "aria-selected": _this.isSelectedMonth(i) ? "true" : void 0
        }, _this.isSelectedMonth(i) ? /* @__PURE__ */ React__default.createElement("span", {
          className: "react-datepicker__month-option--selected"
        }, "✓") : "", month);
      });
    });
    _defineProperty$2(_this, "onChange", function(month) {
      return _this.props.onChange(month);
    });
    _defineProperty$2(_this, "handleClickOutside", function() {
      return _this.props.onCancel();
    });
    return _this;
  }
  _inherits$1(MonthDropdownOptions2, _React$Component);
  return _createClass$1(MonthDropdownOptions2, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__month-dropdown"
      }, this.renderOptions());
    }
  }]);
}(React__default.Component);
var WrappedMonthDropdownOptions = onClickOutsideHOC(MonthDropdownOptions);
var MonthDropdown = /* @__PURE__ */ function(_React$Component) {
  function MonthDropdown2() {
    var _this;
    _classCallCheck$1(this, MonthDropdown2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MonthDropdown2, [].concat(args));
    _defineProperty$2(_this, "state", {
      dropdownVisible: false
    });
    _defineProperty$2(_this, "renderSelectOptions", function(monthNames) {
      return monthNames.map(function(M2, i) {
        return /* @__PURE__ */ React__default.createElement("option", {
          key: i,
          value: i
        }, M2);
      });
    });
    _defineProperty$2(_this, "renderSelectMode", function(monthNames) {
      return /* @__PURE__ */ React__default.createElement("select", {
        value: _this.props.month,
        className: "react-datepicker__month-select",
        onChange: function onChange(e) {
          return _this.onChange(e.target.value);
        }
      }, _this.renderSelectOptions(monthNames));
    });
    _defineProperty$2(_this, "renderReadView", function(visible, monthNames) {
      return /* @__PURE__ */ React__default.createElement("div", {
        key: "read",
        style: {
          visibility: visible ? "visible" : "hidden"
        },
        className: "react-datepicker__month-read-view",
        onClick: _this.toggleDropdown
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "react-datepicker__month-read-view--down-arrow"
      }), /* @__PURE__ */ React__default.createElement("span", {
        className: "react-datepicker__month-read-view--selected-month"
      }, monthNames[_this.props.month]));
    });
    _defineProperty$2(_this, "renderDropdown", function(monthNames) {
      return /* @__PURE__ */ React__default.createElement(WrappedMonthDropdownOptions, {
        key: "dropdown",
        month: _this.props.month,
        monthNames,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown
      });
    });
    _defineProperty$2(_this, "renderScrollMode", function(monthNames) {
      var dropdownVisible = _this.state.dropdownVisible;
      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown(monthNames));
      }
      return result;
    });
    _defineProperty$2(_this, "onChange", function(month) {
      _this.toggleDropdown();
      if (month !== _this.props.month) {
        _this.props.onChange(month);
      }
    });
    _defineProperty$2(_this, "toggleDropdown", function() {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    });
    return _this;
  }
  _inherits$1(MonthDropdown2, _React$Component);
  return _createClass$1(MonthDropdown2, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(M2) {
        return getMonthShortInLocale(M2, _this2.props.locale);
      } : function(M2) {
        return getMonthInLocale(M2, _this2.props.locale);
      });
      var renderedDropdown;
      switch (this.props.dropdownMode) {
        case "scroll":
          renderedDropdown = this.renderScrollMode(monthNames);
          break;
        case "select":
          renderedDropdown = this.renderSelectMode(monthNames);
          break;
      }
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
      }, renderedDropdown);
    }
  }]);
}(React__default.Component);
function generateMonthYears(minDate, maxDate) {
  var list2 = [];
  var currDate = getStartOfMonth(minDate);
  var lastDate = getStartOfMonth(maxDate);
  while (!isAfter$2(currDate, lastDate)) {
    list2.push(newDate(currDate));
    currDate = addMonths(currDate, 1);
  }
  return list2;
}
var MonthYearDropdownOptions = /* @__PURE__ */ function(_React$Component) {
  function MonthYearDropdownOptions2(props) {
    var _this;
    _classCallCheck$1(this, MonthYearDropdownOptions2);
    _this = _callSuper(this, MonthYearDropdownOptions2, [props]);
    _defineProperty$2(_this, "renderOptions", function() {
      return _this.state.monthYearsList.map(function(monthYear) {
        var monthYearPoint = getTime(monthYear);
        var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);
        return /* @__PURE__ */ React__default.createElement("div", {
          className: isSameMonthYear ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
          key: monthYearPoint,
          onClick: _this.onChange.bind(_this, monthYearPoint),
          "aria-selected": isSameMonthYear ? "true" : void 0
        }, isSameMonthYear ? /* @__PURE__ */ React__default.createElement("span", {
          className: "react-datepicker__month-year-option--selected"
        }, "✓") : "", formatDate(monthYear, _this.props.dateFormat, _this.props.locale));
      });
    });
    _defineProperty$2(_this, "onChange", function(monthYear) {
      return _this.props.onChange(monthYear);
    });
    _defineProperty$2(_this, "handleClickOutside", function() {
      _this.props.onCancel();
    });
    _this.state = {
      monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }
  _inherits$1(MonthYearDropdownOptions2, _React$Component);
  return _createClass$1(MonthYearDropdownOptions2, [{
    key: "render",
    value: function render() {
      var dropdownClass = clsx({
        "react-datepicker__month-year-dropdown": true,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return /* @__PURE__ */ React__default.createElement("div", {
        className: dropdownClass
      }, this.renderOptions());
    }
  }]);
}(React__default.Component);
var WrappedMonthYearDropdownOptions = onClickOutsideHOC(MonthYearDropdownOptions);
var MonthYearDropdown = /* @__PURE__ */ function(_React$Component) {
  function MonthYearDropdown2() {
    var _this;
    _classCallCheck$1(this, MonthYearDropdown2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MonthYearDropdown2, [].concat(args));
    _defineProperty$2(_this, "state", {
      dropdownVisible: false
    });
    _defineProperty$2(_this, "renderSelectOptions", function() {
      var currDate = getStartOfMonth(_this.props.minDate);
      var lastDate = getStartOfMonth(_this.props.maxDate);
      var options = [];
      while (!isAfter$2(currDate, lastDate)) {
        var timePoint = getTime(currDate);
        options.push(/* @__PURE__ */ React__default.createElement("option", {
          key: timePoint,
          value: timePoint
        }, formatDate(currDate, _this.props.dateFormat, _this.props.locale)));
        currDate = addMonths(currDate, 1);
      }
      return options;
    });
    _defineProperty$2(_this, "onSelectChange", function(e) {
      _this.onChange(e.target.value);
    });
    _defineProperty$2(_this, "renderSelectMode", function() {
      return /* @__PURE__ */ React__default.createElement("select", {
        value: getTime(getStartOfMonth(_this.props.date)),
        className: "react-datepicker__month-year-select",
        onChange: _this.onSelectChange
      }, _this.renderSelectOptions());
    });
    _defineProperty$2(_this, "renderReadView", function(visible) {
      var yearMonth = formatDate(_this.props.date, _this.props.dateFormat, _this.props.locale);
      return /* @__PURE__ */ React__default.createElement("div", {
        key: "read",
        style: {
          visibility: visible ? "visible" : "hidden"
        },
        className: "react-datepicker__month-year-read-view",
        onClick: function onClick(event) {
          return _this.toggleDropdown(event);
        }
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: "react-datepicker__month-year-read-view--down-arrow"
      }), /* @__PURE__ */ React__default.createElement("span", {
        className: "react-datepicker__month-year-read-view--selected-month-year"
      }, yearMonth));
    });
    _defineProperty$2(_this, "renderDropdown", function() {
      return /* @__PURE__ */ React__default.createElement(WrappedMonthYearDropdownOptions, {
        key: "dropdown",
        date: _this.props.date,
        dateFormat: _this.props.dateFormat,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
        locale: _this.props.locale
      });
    });
    _defineProperty$2(_this, "renderScrollMode", function() {
      var dropdownVisible = _this.state.dropdownVisible;
      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    });
    _defineProperty$2(_this, "onChange", function(monthYearPoint) {
      _this.toggleDropdown();
      var changedDate = newDate(parseInt(monthYearPoint));
      if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
        return;
      }
      _this.props.onChange(changedDate);
    });
    _defineProperty$2(_this, "toggleDropdown", function() {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    });
    return _this;
  }
  _inherits$1(MonthYearDropdown2, _React$Component);
  return _createClass$1(MonthYearDropdown2, [{
    key: "render",
    value: function render() {
      var renderedDropdown;
      switch (this.props.dropdownMode) {
        case "scroll":
          renderedDropdown = this.renderScrollMode();
          break;
        case "select":
          renderedDropdown = this.renderSelectMode();
          break;
      }
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
      }, renderedDropdown);
    }
  }]);
}(React__default.Component);
var Day = /* @__PURE__ */ function(_React$Component) {
  function Day2() {
    var _this;
    _classCallCheck$1(this, Day2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Day2, [].concat(args));
    _defineProperty$2(_this, "dayEl", /* @__PURE__ */ React__default.createRef());
    _defineProperty$2(_this, "handleClick", function(event) {
      if (!_this.isDisabled() && _this.props.onClick) {
        _this.props.onClick(event);
      }
    });
    _defineProperty$2(_this, "handleMouseEnter", function(event) {
      if (!_this.isDisabled() && _this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    });
    _defineProperty$2(_this, "handleOnKeyDown", function(event) {
      var eventKey = event.key;
      if (eventKey === " ") {
        event.preventDefault();
        event.key = "Enter";
      }
      _this.props.handleOnKeyDown(event);
    });
    _defineProperty$2(_this, "isSameDay", function(other2) {
      return isSameDay(_this.props.day, other2);
    });
    _defineProperty$2(_this, "isKeyboardSelected", function() {
      var _this$props$selectedD;
      if (_this.props.disabledKeyboardNavigation) {
        return false;
      }
      var isSelectedDate = _this.props.selectsMultiple ? (_this$props$selectedD = _this.props.selectedDates) === null || _this$props$selectedD === void 0 ? void 0 : _this$props$selectedD.some(function(date) {
        return _this.isSameDayOrWeek(date);
      }) : _this.isSameDayOrWeek(_this.props.selected);
      return !isSelectedDate && _this.isSameDayOrWeek(_this.props.preSelection);
    });
    _defineProperty$2(_this, "isDisabled", function() {
      return isDayDisabled(_this.props.day, _this.props);
    });
    _defineProperty$2(_this, "isExcluded", function() {
      return isDayExcluded(_this.props.day, _this.props);
    });
    _defineProperty$2(_this, "isStartOfWeek", function() {
      return isSameDay(_this.props.day, getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
    });
    _defineProperty$2(_this, "isSameWeek", function(other2) {
      return _this.props.showWeekPicker && isSameDay(other2, getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
    });
    _defineProperty$2(_this, "isSameDayOrWeek", function(other2) {
      return _this.isSameDay(other2) || _this.isSameWeek(other2);
    });
    _defineProperty$2(_this, "getHighLightedClass", function() {
      var _this$props = _this.props, day = _this$props.day, highlightDates = _this$props.highlightDates;
      if (!highlightDates) {
        return false;
      }
      var dayStr = formatDate(day, "MM.dd.yyyy");
      return highlightDates.get(dayStr);
    });
    _defineProperty$2(_this, "getHolidaysClass", function() {
      var _this$props2 = _this.props, day = _this$props2.day, holidays = _this$props2.holidays;
      if (!holidays) {
        return false;
      }
      var dayStr = formatDate(day, "MM.dd.yyyy");
      if (holidays.has(dayStr)) {
        return [holidays.get(dayStr).className];
      }
    });
    _defineProperty$2(_this, "isInRange", function() {
      var _this$props3 = _this.props, day = _this$props3.day, startDate = _this$props3.startDate, endDate = _this$props3.endDate;
      if (!startDate || !endDate) {
        return false;
      }
      return isDayInRange(day, startDate, endDate);
    });
    _defineProperty$2(_this, "isInSelectingRange", function() {
      var _this$props$selecting;
      var _this$props4 = _this.props, day = _this$props4.day, selectsStart = _this$props4.selectsStart, selectsEnd = _this$props4.selectsEnd, selectsRange = _this$props4.selectsRange, selectsDisabledDaysInRange = _this$props4.selectsDisabledDaysInRange, startDate = _this$props4.startDate, endDate = _this$props4.endDate;
      var selectingDate = (_this$props$selecting = _this.props.selectingDate) !== null && _this$props$selecting !== void 0 ? _this$props$selecting : _this.props.preSelection;
      if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate || !selectsDisabledDaysInRange && _this.isDisabled()) {
        return false;
      }
      if (selectsStart && endDate && (isBefore$1(selectingDate, endDate) || isEqual$3(selectingDate, endDate))) {
        return isDayInRange(day, selectingDate, endDate);
      }
      if (selectsEnd && startDate && (isAfter$2(selectingDate, startDate) || isEqual$3(selectingDate, startDate))) {
        return isDayInRange(day, startDate, selectingDate);
      }
      if (selectsRange && startDate && !endDate && (isAfter$2(selectingDate, startDate) || isEqual$3(selectingDate, startDate))) {
        return isDayInRange(day, startDate, selectingDate);
      }
      return false;
    });
    _defineProperty$2(_this, "isSelectingRangeStart", function() {
      var _this$props$selecting2;
      if (!_this.isInSelectingRange()) {
        return false;
      }
      var _this$props5 = _this.props, day = _this$props5.day, startDate = _this$props5.startDate, selectsStart = _this$props5.selectsStart;
      var selectingDate = (_this$props$selecting2 = _this.props.selectingDate) !== null && _this$props$selecting2 !== void 0 ? _this$props$selecting2 : _this.props.preSelection;
      if (selectsStart) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, startDate);
      }
    });
    _defineProperty$2(_this, "isSelectingRangeEnd", function() {
      var _this$props$selecting3;
      if (!_this.isInSelectingRange()) {
        return false;
      }
      var _this$props6 = _this.props, day = _this$props6.day, endDate = _this$props6.endDate, selectsEnd = _this$props6.selectsEnd, selectsRange = _this$props6.selectsRange;
      var selectingDate = (_this$props$selecting3 = _this.props.selectingDate) !== null && _this$props$selecting3 !== void 0 ? _this$props$selecting3 : _this.props.preSelection;
      if (selectsEnd || selectsRange) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, endDate);
      }
    });
    _defineProperty$2(_this, "isRangeStart", function() {
      var _this$props7 = _this.props, day = _this$props7.day, startDate = _this$props7.startDate, endDate = _this$props7.endDate;
      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(startDate, day);
    });
    _defineProperty$2(_this, "isRangeEnd", function() {
      var _this$props8 = _this.props, day = _this$props8.day, startDate = _this$props8.startDate, endDate = _this$props8.endDate;
      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(endDate, day);
    });
    _defineProperty$2(_this, "isWeekend", function() {
      var weekday = getDay(_this.props.day);
      return weekday === 0 || weekday === 6;
    });
    _defineProperty$2(_this, "isAfterMonth", function() {
      return _this.props.month !== void 0 && (_this.props.month + 1) % 12 === getMonth(_this.props.day);
    });
    _defineProperty$2(_this, "isBeforeMonth", function() {
      return _this.props.month !== void 0 && (getMonth(_this.props.day) + 1) % 12 === _this.props.month;
    });
    _defineProperty$2(_this, "isCurrentDay", function() {
      return _this.isSameDay(newDate());
    });
    _defineProperty$2(_this, "isSelected", function() {
      if (_this.props.selectsMultiple) {
        var _this$props$selectedD2;
        return (_this$props$selectedD2 = _this.props.selectedDates) === null || _this$props$selectedD2 === void 0 ? void 0 : _this$props$selectedD2.some(function(date) {
          return _this.isSameDayOrWeek(date);
        });
      }
      return _this.isSameDayOrWeek(_this.props.selected);
    });
    _defineProperty$2(_this, "getClassNames", function(date) {
      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : void 0;
      return clsx("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
        "react-datepicker__day--disabled": _this.isDisabled(),
        "react-datepicker__day--excluded": _this.isExcluded(),
        "react-datepicker__day--selected": _this.isSelected(),
        "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
        "react-datepicker__day--range-start": _this.isRangeStart(),
        "react-datepicker__day--range-end": _this.isRangeEnd(),
        "react-datepicker__day--in-range": _this.isInRange(),
        "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
        "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
        "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
        "react-datepicker__day--today": _this.isCurrentDay(),
        "react-datepicker__day--weekend": _this.isWeekend(),
        "react-datepicker__day--outside-month": _this.isAfterMonth() || _this.isBeforeMonth()
      }, _this.getHighLightedClass("react-datepicker__day--highlighted"), _this.getHolidaysClass());
    });
    _defineProperty$2(_this, "getAriaLabel", function() {
      var _this$props9 = _this.props, day = _this$props9.day, _this$props9$ariaLabe = _this$props9.ariaLabelPrefixWhenEnabled, ariaLabelPrefixWhenEnabled = _this$props9$ariaLabe === void 0 ? "Choose" : _this$props9$ariaLabe, _this$props9$ariaLabe2 = _this$props9.ariaLabelPrefixWhenDisabled, ariaLabelPrefixWhenDisabled = _this$props9$ariaLabe2 === void 0 ? "Not available" : _this$props9$ariaLabe2;
      var prefix2 = _this.isDisabled() || _this.isExcluded() ? ariaLabelPrefixWhenDisabled : ariaLabelPrefixWhenEnabled;
      return "".concat(prefix2, " ").concat(formatDate(day, "PPPP", _this.props.locale));
    });
    _defineProperty$2(_this, "getTitle", function() {
      var _this$props10 = _this.props, day = _this$props10.day, _this$props10$holiday = _this$props10.holidays, holidays = _this$props10$holiday === void 0 ? /* @__PURE__ */ new Map() : _this$props10$holiday, excludeDates = _this$props10.excludeDates;
      var compareDt = formatDate(day, "MM.dd.yyyy");
      var titles = [];
      if (holidays.has(compareDt)) {
        titles.push.apply(titles, _toConsumableArray$1(holidays.get(compareDt).holidayNames));
      }
      if (_this.isExcluded()) {
        titles.push(excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.filter(function(excludeDate) {
          return isSameDay(excludeDate.date ? excludeDate.date : excludeDate, day);
        }).map(function(excludeDate) {
          return excludeDate.message;
        }));
      }
      return titles.join(", ");
    });
    _defineProperty$2(_this, "getTabIndex", function(selected, preSelection) {
      var selectedDay = selected || _this.props.selected;
      var preSelectionDay = preSelection || _this.props.preSelection;
      var tabIndex = !(_this.props.showWeekPicker && (_this.props.showWeekNumber || !_this.isStartOfWeek())) && (_this.isKeyboardSelected() || _this.isSameDay(selectedDay) && isSameDay(preSelectionDay, selectedDay)) ? 0 : -1;
      return tabIndex;
    });
    _defineProperty$2(_this, "handleFocusDay", function() {
      var _this$dayEl$current;
      var prevProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var shouldFocusDay = false;
      if (_this.getTabIndex() === 0 && !prevProps.isInputFocused && _this.isSameDay(_this.props.preSelection)) {
        if (!document.activeElement || document.activeElement === document.body) {
          shouldFocusDay = true;
        }
        if (_this.props.inline && !_this.props.shouldFocusDayInline) {
          shouldFocusDay = false;
        }
        if (_this.props.containerRef && _this.props.containerRef.current && _this.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day")) {
          shouldFocusDay = true;
        }
        if (_this.props.monthShowsDuplicateDaysEnd && _this.isAfterMonth()) {
          shouldFocusDay = false;
        }
        if (_this.props.monthShowsDuplicateDaysStart && _this.isBeforeMonth()) {
          shouldFocusDay = false;
        }
      }
      shouldFocusDay && ((_this$dayEl$current = _this.dayEl.current) === null || _this$dayEl$current === void 0 ? void 0 : _this$dayEl$current.focus({
        preventScroll: true
      }));
    });
    _defineProperty$2(_this, "renderDayContents", function() {
      if (_this.props.monthShowsDuplicateDaysEnd && _this.isAfterMonth()) return null;
      if (_this.props.monthShowsDuplicateDaysStart && _this.isBeforeMonth()) return null;
      return _this.props.renderDayContents ? _this.props.renderDayContents(getDate(_this.props.day), _this.props.day) : getDate(_this.props.day);
    });
    _defineProperty$2(_this, "render", function() {
      return /* @__PURE__ */ React__default.createElement("div", {
        ref: _this.dayEl,
        className: _this.getClassNames(_this.props.day),
        onKeyDown: _this.handleOnKeyDown,
        onClick: _this.handleClick,
        onMouseEnter: !_this.props.usePointerEvent ? _this.handleMouseEnter : void 0,
        onPointerEnter: _this.props.usePointerEvent ? _this.handleMouseEnter : void 0,
        tabIndex: _this.getTabIndex(),
        "aria-label": _this.getAriaLabel(),
        role: "option",
        title: _this.getTitle(),
        "aria-disabled": _this.isDisabled(),
        "aria-current": _this.isCurrentDay() ? "date" : void 0,
        "aria-selected": _this.isSelected() || _this.isInRange()
      }, _this.renderDayContents(), _this.getTitle() !== "" && /* @__PURE__ */ React__default.createElement("span", {
        className: "overlay"
      }, _this.getTitle()));
    });
    return _this;
  }
  _inherits$1(Day2, _React$Component);
  return _createClass$1(Day2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleFocusDay();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.handleFocusDay(prevProps);
    }
  }]);
}(React__default.Component);
var WeekNumber = /* @__PURE__ */ function(_React$Component) {
  function WeekNumber2() {
    var _this;
    _classCallCheck$1(this, WeekNumber2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WeekNumber2, [].concat(args));
    _defineProperty$2(_this, "weekNumberEl", /* @__PURE__ */ React__default.createRef());
    _defineProperty$2(_this, "handleClick", function(event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    });
    _defineProperty$2(_this, "handleOnKeyDown", function(event) {
      var eventKey = event.key;
      if (eventKey === " ") {
        event.preventDefault();
        event.key = "Enter";
      }
      _this.props.handleOnKeyDown(event);
    });
    _defineProperty$2(_this, "isKeyboardSelected", function() {
      return !_this.props.disabledKeyboardNavigation && !isSameDay(_this.props.date, _this.props.selected) && isSameDay(_this.props.date, _this.props.preSelection);
    });
    _defineProperty$2(_this, "getTabIndex", function() {
      return _this.props.showWeekPicker && _this.props.showWeekNumber && (_this.isKeyboardSelected() || isSameDay(_this.props.date, _this.props.selected) && isSameDay(_this.props.preSelection, _this.props.selected)) ? 0 : -1;
    });
    _defineProperty$2(_this, "handleFocusWeekNumber", function() {
      var prevProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var shouldFocusWeekNumber = false;
      if (_this.getTabIndex() === 0 && !prevProps.isInputFocused && isSameDay(_this.props.date, _this.props.preSelection)) {
        if (!document.activeElement || document.activeElement === document.body) {
          shouldFocusWeekNumber = true;
        }
        if (_this.props.inline && !_this.props.shouldFocusDayInline) {
          shouldFocusWeekNumber = false;
        }
        if (_this.props.containerRef && _this.props.containerRef.current && _this.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number")) {
          shouldFocusWeekNumber = true;
        }
      }
      shouldFocusWeekNumber && _this.weekNumberEl.current && _this.weekNumberEl.current.focus({
        preventScroll: true
      });
    });
    return _this;
  }
  _inherits$1(WeekNumber2, _React$Component);
  return _createClass$1(WeekNumber2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleFocusWeekNumber();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.handleFocusWeekNumber(prevProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props, weekNumber = _this$props.weekNumber, _this$props$ariaLabel = _this$props.ariaLabelPrefix, ariaLabelPrefix = _this$props$ariaLabel === void 0 ? "week " : _this$props$ariaLabel, onClick = _this$props.onClick;
      var weekNumberClasses = {
        "react-datepicker__week-number": true,
        "react-datepicker__week-number--clickable": !!onClick,
        "react-datepicker__week-number--selected": !!onClick && isSameDay(this.props.date, this.props.selected),
        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
      };
      return /* @__PURE__ */ React__default.createElement("div", {
        ref: this.weekNumberEl,
        className: clsx(weekNumberClasses),
        "aria-label": "".concat(ariaLabelPrefix, " ").concat(this.props.weekNumber),
        onClick: this.handleClick,
        onKeyDown: this.handleOnKeyDown,
        tabIndex: this.getTabIndex()
      }, weekNumber);
    }
  }], [{
    key: "defaultProps",
    get: function get6() {
      return {
        ariaLabelPrefix: "week "
      };
    }
  }]);
}(React__default.Component);
var Week = /* @__PURE__ */ function(_React$Component) {
  function Week2() {
    var _this;
    _classCallCheck$1(this, Week2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Week2, [].concat(args));
    _defineProperty$2(_this, "handleDayClick", function(day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    });
    _defineProperty$2(_this, "handleDayMouseEnter", function(day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    });
    _defineProperty$2(_this, "handleWeekClick", function(day, weekNumber, event) {
      if (typeof _this.props.onWeekSelect === "function") {
        _this.props.onWeekSelect(day, weekNumber, event);
      }
      if (_this.props.showWeekPicker) {
        _this.handleDayClick(day, event);
      }
      if (_this.props.shouldCloseOnSelect) {
        _this.props.setOpen(false);
      }
    });
    _defineProperty$2(_this, "formatWeekNumber", function(date) {
      if (_this.props.formatWeekNumber) {
        return _this.props.formatWeekNumber(date);
      }
      return getWeek(date);
    });
    _defineProperty$2(_this, "renderDays", function() {
      var startOfWeek2 = _this.startOfWeek();
      var days2 = [];
      var weekNumber = _this.formatWeekNumber(startOfWeek2);
      if (_this.props.showWeekNumber) {
        var onClickAction = _this.props.onWeekSelect || _this.props.showWeekPicker ? _this.handleWeekClick.bind(_this, startOfWeek2, weekNumber) : void 0;
        days2.push(/* @__PURE__ */ React__default.createElement(WeekNumber, {
          key: "W",
          weekNumber,
          date: startOfWeek2,
          onClick: onClickAction,
          selected: _this.props.selected,
          preSelection: _this.props.preSelection,
          ariaLabelPrefix: _this.props.ariaLabelPrefix,
          showWeekPicker: _this.props.showWeekPicker,
          showWeekNumber: _this.props.showWeekNumber,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          handleOnKeyDown: _this.props.handleOnKeyDown,
          isInputFocused: _this.props.isInputFocused,
          containerRef: _this.props.containerRef
        }));
      }
      return days2.concat([0, 1, 2, 3, 4, 5, 6].map(function(offset3) {
        var day = addDays(startOfWeek2, offset3);
        return /* @__PURE__ */ React__default.createElement(Day, {
          ariaLabelPrefixWhenEnabled: _this.props.chooseDayAriaLabelPrefix,
          ariaLabelPrefixWhenDisabled: _this.props.disabledDayAriaLabelPrefix,
          key: day.valueOf(),
          day,
          month: _this.props.month,
          onClick: _this.handleDayClick.bind(_this, day),
          usePointerEvent: _this.props.usePointerEvent,
          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          calendarStartDay: _this.props.calendarStartDay,
          excludeDates: _this.props.excludeDates,
          excludeDateIntervals: _this.props.excludeDateIntervals,
          includeDates: _this.props.includeDates,
          includeDateIntervals: _this.props.includeDateIntervals,
          highlightDates: _this.props.highlightDates,
          holidays: _this.props.holidays,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          selectsRange: _this.props.selectsRange,
          showWeekPicker: _this.props.showWeekPicker,
          showWeekNumber: _this.props.showWeekNumber,
          selectsDisabledDaysInRange: _this.props.selectsDisabledDaysInRange,
          selectsMultiple: _this.props.selectsMultiple,
          selectedDates: _this.props.selectedDates,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          renderDayContents: _this.props.renderDayContents,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          handleOnKeyDown: _this.props.handleOnKeyDown,
          isInputFocused: _this.props.isInputFocused,
          containerRef: _this.props.containerRef,
          inline: _this.props.inline,
          shouldFocusDayInline: _this.props.shouldFocusDayInline,
          monthShowsDuplicateDaysEnd: _this.props.monthShowsDuplicateDaysEnd,
          monthShowsDuplicateDaysStart: _this.props.monthShowsDuplicateDaysStart,
          locale: _this.props.locale
        });
      }));
    });
    _defineProperty$2(_this, "startOfWeek", function() {
      return getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay);
    });
    _defineProperty$2(_this, "isKeyboardSelected", function() {
      return !_this.props.disabledKeyboardNavigation && !isSameDay(_this.startOfWeek(), _this.props.selected) && isSameDay(_this.startOfWeek(), _this.props.preSelection);
    });
    return _this;
  }
  _inherits$1(Week2, _React$Component);
  return _createClass$1(Week2, [{
    key: "render",
    value: function render() {
      var weekNumberClasses = {
        "react-datepicker__week": true,
        "react-datepicker__week--selected": isSameDay(this.startOfWeek(), this.props.selected),
        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
      };
      return /* @__PURE__ */ React__default.createElement("div", {
        className: clsx(weekNumberClasses)
      }, this.renderDays());
    }
  }], [{
    key: "defaultProps",
    get: function get6() {
      return {
        shouldCloseOnSelect: true
      };
    }
  }]);
}(React__default.Component);
var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
var MONTH_COLUMNS_LAYOUT = {
  TWO_COLUMNS: "two_columns",
  THREE_COLUMNS: "three_columns",
  FOUR_COLUMNS: "four_columns"
};
var MONTH_COLUMNS = _defineProperty$2(_defineProperty$2(_defineProperty$2({}, MONTH_COLUMNS_LAYOUT.TWO_COLUMNS, {
  grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]],
  verticalNavigationOffset: 2
}), MONTH_COLUMNS_LAYOUT.THREE_COLUMNS, {
  grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]],
  verticalNavigationOffset: 3
}), MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS, {
  grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]],
  verticalNavigationOffset: 4
});
var MONTH_NAVIGATION_HORIZONTAL_OFFSET = 1;
function getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker) {
  if (showFourColumnMonthYearPicker) return MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS;
  if (showTwoColumnMonthYearPicker) return MONTH_COLUMNS_LAYOUT.TWO_COLUMNS;
  return MONTH_COLUMNS_LAYOUT.THREE_COLUMNS;
}
var Month = /* @__PURE__ */ function(_React$Component) {
  function Month2() {
    var _this;
    _classCallCheck$1(this, Month2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Month2, [].concat(args));
    _defineProperty$2(_this, "MONTH_REFS", _toConsumableArray$1(Array(12)).map(function() {
      return /* @__PURE__ */ React__default.createRef();
    }));
    _defineProperty$2(_this, "QUARTER_REFS", _toConsumableArray$1(Array(4)).map(function() {
      return /* @__PURE__ */ React__default.createRef();
    }));
    _defineProperty$2(_this, "isDisabled", function(date) {
      return isDayDisabled(date, _this.props);
    });
    _defineProperty$2(_this, "isExcluded", function(date) {
      return isDayExcluded(date, _this.props);
    });
    _defineProperty$2(_this, "handleDayClick", function(day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event, _this.props.orderInDisplay);
      }
    });
    _defineProperty$2(_this, "handleDayMouseEnter", function(day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    });
    _defineProperty$2(_this, "handleMouseLeave", function() {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave();
      }
    });
    _defineProperty$2(_this, "isRangeStartMonth", function(m2) {
      var _this$props = _this.props, day = _this$props.day, startDate = _this$props.startDate, endDate = _this$props.endDate;
      if (!startDate || !endDate) {
        return false;
      }
      return isSameMonth(setMonth$1(day, m2), startDate);
    });
    _defineProperty$2(_this, "isRangeStartQuarter", function(q2) {
      var _this$props2 = _this.props, day = _this$props2.day, startDate = _this$props2.startDate, endDate = _this$props2.endDate;
      if (!startDate || !endDate) {
        return false;
      }
      return isSameQuarter(setQuarter(day, q2), startDate);
    });
    _defineProperty$2(_this, "isRangeEndMonth", function(m2) {
      var _this$props3 = _this.props, day = _this$props3.day, startDate = _this$props3.startDate, endDate = _this$props3.endDate;
      if (!startDate || !endDate) {
        return false;
      }
      return isSameMonth(setMonth$1(day, m2), endDate);
    });
    _defineProperty$2(_this, "isRangeEndQuarter", function(q2) {
      var _this$props4 = _this.props, day = _this$props4.day, startDate = _this$props4.startDate, endDate = _this$props4.endDate;
      if (!startDate || !endDate) {
        return false;
      }
      return isSameQuarter(setQuarter(day, q2), endDate);
    });
    _defineProperty$2(_this, "isInSelectingRangeMonth", function(m2) {
      var _this$props$selecting;
      var _this$props5 = _this.props, day = _this$props5.day, selectsStart = _this$props5.selectsStart, selectsEnd = _this$props5.selectsEnd, selectsRange = _this$props5.selectsRange, startDate = _this$props5.startDate, endDate = _this$props5.endDate;
      var selectingDate = (_this$props$selecting = _this.props.selectingDate) !== null && _this$props$selecting !== void 0 ? _this$props$selecting : _this.props.preSelection;
      if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) {
        return false;
      }
      if (selectsStart && endDate) {
        return isMonthInRange(selectingDate, endDate, m2, day);
      }
      if (selectsEnd && startDate) {
        return isMonthInRange(startDate, selectingDate, m2, day);
      }
      if (selectsRange && startDate && !endDate) {
        return isMonthInRange(startDate, selectingDate, m2, day);
      }
      return false;
    });
    _defineProperty$2(_this, "isSelectingMonthRangeStart", function(m2) {
      var _this$props$selecting2;
      if (!_this.isInSelectingRangeMonth(m2)) {
        return false;
      }
      var _this$props6 = _this.props, day = _this$props6.day, startDate = _this$props6.startDate, selectsStart = _this$props6.selectsStart;
      var _month = setMonth$1(day, m2);
      var selectingDate = (_this$props$selecting2 = _this.props.selectingDate) !== null && _this$props$selecting2 !== void 0 ? _this$props$selecting2 : _this.props.preSelection;
      if (selectsStart) {
        return isSameMonth(_month, selectingDate);
      } else {
        return isSameMonth(_month, startDate);
      }
    });
    _defineProperty$2(_this, "isSelectingMonthRangeEnd", function(m2) {
      var _this$props$selecting3;
      if (!_this.isInSelectingRangeMonth(m2)) {
        return false;
      }
      var _this$props7 = _this.props, day = _this$props7.day, endDate = _this$props7.endDate, selectsEnd = _this$props7.selectsEnd, selectsRange = _this$props7.selectsRange;
      var _month = setMonth$1(day, m2);
      var selectingDate = (_this$props$selecting3 = _this.props.selectingDate) !== null && _this$props$selecting3 !== void 0 ? _this$props$selecting3 : _this.props.preSelection;
      if (selectsEnd || selectsRange) {
        return isSameMonth(_month, selectingDate);
      } else {
        return isSameMonth(_month, endDate);
      }
    });
    _defineProperty$2(_this, "isInSelectingRangeQuarter", function(q2) {
      var _this$props$selecting4;
      var _this$props8 = _this.props, day = _this$props8.day, selectsStart = _this$props8.selectsStart, selectsEnd = _this$props8.selectsEnd, selectsRange = _this$props8.selectsRange, startDate = _this$props8.startDate, endDate = _this$props8.endDate;
      var selectingDate = (_this$props$selecting4 = _this.props.selectingDate) !== null && _this$props$selecting4 !== void 0 ? _this$props$selecting4 : _this.props.preSelection;
      if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) {
        return false;
      }
      if (selectsStart && endDate) {
        return isQuarterInRange(selectingDate, endDate, q2, day);
      }
      if (selectsEnd && startDate) {
        return isQuarterInRange(startDate, selectingDate, q2, day);
      }
      if (selectsRange && startDate && !endDate) {
        return isQuarterInRange(startDate, selectingDate, q2, day);
      }
      return false;
    });
    _defineProperty$2(_this, "isWeekInMonth", function(startOfWeek2) {
      var day = _this.props.day;
      var endOfWeek2 = addDays(startOfWeek2, 6);
      return isSameMonth(startOfWeek2, day) || isSameMonth(endOfWeek2, day);
    });
    _defineProperty$2(_this, "isCurrentMonth", function(day, m2) {
      return getYear(day) === getYear(newDate()) && m2 === getMonth(newDate());
    });
    _defineProperty$2(_this, "isCurrentQuarter", function(day, q2) {
      return getYear(day) === getYear(newDate()) && q2 === getQuarter(newDate());
    });
    _defineProperty$2(_this, "isSelectedMonth", function(day, m2, selected) {
      return getMonth(selected) === m2 && getYear(day) === getYear(selected);
    });
    _defineProperty$2(_this, "isSelectedQuarter", function(day, q2, selected) {
      return getQuarter(day) === q2 && getYear(day) === getYear(selected);
    });
    _defineProperty$2(_this, "renderWeeks", function() {
      var weeks2 = [];
      var isFixedHeight = _this.props.fixedHeight;
      var i = 0;
      var breakAfterNextPush = false;
      var currentWeekStart = getStartOfWeek(getStartOfMonth(_this.props.day), _this.props.locale, _this.props.calendarStartDay);
      var selected = _this.props.showWeekPicker ? getStartOfWeek(_this.props.selected, _this.props.locale, _this.props.calendarStartDay) : _this.props.selected;
      var preSelection = _this.props.showWeekPicker ? getStartOfWeek(_this.props.preSelection, _this.props.locale, _this.props.calendarStartDay) : _this.props.preSelection;
      while (true) {
        weeks2.push(/* @__PURE__ */ React__default.createElement(Week, {
          ariaLabelPrefix: _this.props.weekAriaLabelPrefix,
          chooseDayAriaLabelPrefix: _this.props.chooseDayAriaLabelPrefix,
          disabledDayAriaLabelPrefix: _this.props.disabledDayAriaLabelPrefix,
          key: i,
          day: currentWeekStart,
          month: getMonth(_this.props.day),
          onDayClick: _this.handleDayClick,
          usePointerEvent: _this.props.usePointerEvent,
          onDayMouseEnter: _this.handleDayMouseEnter,
          onWeekSelect: _this.props.onWeekSelect,
          formatWeekNumber: _this.props.formatWeekNumber,
          locale: _this.props.locale,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          excludeDateIntervals: _this.props.excludeDateIntervals,
          includeDates: _this.props.includeDates,
          includeDateIntervals: _this.props.includeDateIntervals,
          inline: _this.props.inline,
          shouldFocusDayInline: _this.props.shouldFocusDayInline,
          highlightDates: _this.props.highlightDates,
          holidays: _this.props.holidays,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection,
          selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          selectsRange: _this.props.selectsRange,
          selectsDisabledDaysInRange: _this.props.selectsDisabledDaysInRange,
          selectsMultiple: _this.props.selectsMultiple,
          selectedDates: _this.props.selectedDates,
          showWeekNumber: _this.props.showWeekNumbers,
          showWeekPicker: _this.props.showWeekPicker,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          setOpen: _this.props.setOpen,
          shouldCloseOnSelect: _this.props.shouldCloseOnSelect,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          renderDayContents: _this.props.renderDayContents,
          handleOnKeyDown: _this.props.handleOnKeyDown,
          isInputFocused: _this.props.isInputFocused,
          containerRef: _this.props.containerRef,
          calendarStartDay: _this.props.calendarStartDay,
          monthShowsDuplicateDaysEnd: _this.props.monthShowsDuplicateDaysEnd,
          monthShowsDuplicateDaysStart: _this.props.monthShowsDuplicateDaysStart
        }));
        if (breakAfterNextPush) break;
        i++;
        currentWeekStart = addWeeks(currentWeekStart, 1);
        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
          if (_this.props.peekNextMonth) {
            breakAfterNextPush = true;
          } else {
            break;
          }
        }
      }
      return weeks2;
    });
    _defineProperty$2(_this, "onMonthClick", function(e, m2) {
      var labelDate = setMonth$1(_this.props.day, m2);
      if (isMonthDisabled(labelDate, _this.props)) {
        return;
      }
      _this.handleDayClick(getStartOfMonth(labelDate), e);
    });
    _defineProperty$2(_this, "onMonthMouseEnter", function(m2) {
      var labelDate = setMonth$1(_this.props.day, m2);
      if (isMonthDisabled(labelDate, _this.props)) {
        return;
      }
      _this.handleDayMouseEnter(getStartOfMonth(labelDate));
    });
    _defineProperty$2(_this, "handleMonthNavigation", function(newMonth, newDate2) {
      if (_this.isDisabled(newDate2) || _this.isExcluded(newDate2)) return;
      _this.props.setPreSelection(newDate2);
      _this.MONTH_REFS[newMonth].current && _this.MONTH_REFS[newMonth].current.focus();
    });
    _defineProperty$2(_this, "onMonthKeyDown", function(event, month) {
      var _this$props9 = _this.props, selected = _this$props9.selected, preSelection = _this$props9.preSelection, disabledKeyboardNavigation = _this$props9.disabledKeyboardNavigation, showTwoColumnMonthYearPicker = _this$props9.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker = _this$props9.showFourColumnMonthYearPicker, setPreSelection = _this$props9.setPreSelection, handleOnMonthKeyDown = _this$props9.handleOnMonthKeyDown;
      var eventKey = event.key;
      if (eventKey !== "Tab") {
        event.preventDefault();
      }
      if (!disabledKeyboardNavigation) {
        var monthColumnsLayout = getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker);
        var verticalOffset = MONTH_COLUMNS[monthColumnsLayout].verticalNavigationOffset;
        var monthsGrid = MONTH_COLUMNS[monthColumnsLayout].grid;
        switch (eventKey) {
          case "Enter":
            _this.onMonthClick(event, month);
            setPreSelection(selected);
            break;
          case "ArrowRight":
            _this.handleMonthNavigation(month === 11 ? 0 : month + MONTH_NAVIGATION_HORIZONTAL_OFFSET, addMonths(preSelection, MONTH_NAVIGATION_HORIZONTAL_OFFSET));
            break;
          case "ArrowLeft":
            _this.handleMonthNavigation(month === 0 ? 11 : month - MONTH_NAVIGATION_HORIZONTAL_OFFSET, subMonths(preSelection, MONTH_NAVIGATION_HORIZONTAL_OFFSET));
            break;
          case "ArrowUp":
            _this.handleMonthNavigation(
              // Check if month on the first row
              monthsGrid[0].includes(month) ? month + 12 - verticalOffset : month - verticalOffset,
              subMonths(preSelection, verticalOffset)
            );
            break;
          case "ArrowDown":
            _this.handleMonthNavigation(
              // Check if month on the last row
              monthsGrid[monthsGrid.length - 1].includes(month) ? month - 12 + verticalOffset : month + verticalOffset,
              addMonths(preSelection, verticalOffset)
            );
            break;
        }
      }
      handleOnMonthKeyDown && handleOnMonthKeyDown(event);
    });
    _defineProperty$2(_this, "onQuarterClick", function(e, q2) {
      var labelDate = setQuarter(_this.props.day, q2);
      if (isQuarterDisabled(labelDate, _this.props)) {
        return;
      }
      _this.handleDayClick(getStartOfQuarter(labelDate), e);
    });
    _defineProperty$2(_this, "onQuarterMouseEnter", function(q2) {
      var labelDate = setQuarter(_this.props.day, q2);
      if (isQuarterDisabled(labelDate, _this.props)) {
        return;
      }
      _this.handleDayMouseEnter(getStartOfQuarter(labelDate));
    });
    _defineProperty$2(_this, "handleQuarterNavigation", function(newQuarter, newDate2) {
      if (_this.isDisabled(newDate2) || _this.isExcluded(newDate2)) return;
      _this.props.setPreSelection(newDate2);
      _this.QUARTER_REFS[newQuarter - 1].current && _this.QUARTER_REFS[newQuarter - 1].current.focus();
    });
    _defineProperty$2(_this, "onQuarterKeyDown", function(event, quarter) {
      var eventKey = event.key;
      if (!_this.props.disabledKeyboardNavigation) {
        switch (eventKey) {
          case "Enter":
            _this.onQuarterClick(event, quarter);
            _this.props.setPreSelection(_this.props.selected);
            break;
          case "ArrowRight":
            _this.handleQuarterNavigation(quarter === 4 ? 1 : quarter + 1, addQuarters(_this.props.preSelection, 1));
            break;
          case "ArrowLeft":
            _this.handleQuarterNavigation(quarter === 1 ? 4 : quarter - 1, subQuarters(_this.props.preSelection));
            break;
        }
      }
    });
    _defineProperty$2(_this, "isMonthDisabled", function(month) {
      var _this$props10 = _this.props, day = _this$props10.day, minDate = _this$props10.minDate, maxDate = _this$props10.maxDate, excludeDates = _this$props10.excludeDates, includeDates = _this$props10.includeDates;
      var labelDate = setMonth$1(day, month);
      return (minDate || maxDate || excludeDates || includeDates) && isMonthDisabled(labelDate, _this.props);
    });
    _defineProperty$2(_this, "getMonthClassNames", function(m2) {
      var _this$props11 = _this.props, day = _this$props11.day, startDate = _this$props11.startDate, endDate = _this$props11.endDate, selected = _this$props11.selected, preSelection = _this$props11.preSelection, monthClassName = _this$props11.monthClassName;
      var _monthClassName = monthClassName ? monthClassName(setMonth$1(day, m2)) : void 0;
      return clsx("react-datepicker__month-text", "react-datepicker__month-".concat(m2), _monthClassName, {
        "react-datepicker__month-text--disabled": _this.isMonthDisabled(m2),
        "react-datepicker__month-text--selected": _this.isSelectedMonth(day, m2, selected),
        "react-datepicker__month-text--keyboard-selected": !_this.props.disabledKeyboardNavigation && _this.isSelectedMonth(day, m2, preSelection),
        "react-datepicker__month-text--in-selecting-range": _this.isInSelectingRangeMonth(m2),
        "react-datepicker__month-text--in-range": isMonthInRange(startDate, endDate, m2, day),
        "react-datepicker__month-text--range-start": _this.isRangeStartMonth(m2),
        "react-datepicker__month-text--range-end": _this.isRangeEndMonth(m2),
        "react-datepicker__month-text--selecting-range-start": _this.isSelectingMonthRangeStart(m2),
        "react-datepicker__month-text--selecting-range-end": _this.isSelectingMonthRangeEnd(m2),
        "react-datepicker__month-text--today": _this.isCurrentMonth(day, m2)
      });
    });
    _defineProperty$2(_this, "getTabIndex", function(m2) {
      var preSelectedMonth = getMonth(_this.props.preSelection);
      var tabIndex = !_this.props.disabledKeyboardNavigation && m2 === preSelectedMonth ? "0" : "-1";
      return tabIndex;
    });
    _defineProperty$2(_this, "getQuarterTabIndex", function(q2) {
      var preSelectedQuarter = getQuarter(_this.props.preSelection);
      var tabIndex = !_this.props.disabledKeyboardNavigation && q2 === preSelectedQuarter ? "0" : "-1";
      return tabIndex;
    });
    _defineProperty$2(_this, "getAriaLabel", function(month) {
      var _this$props12 = _this.props, _this$props12$chooseD = _this$props12.chooseDayAriaLabelPrefix, chooseDayAriaLabelPrefix = _this$props12$chooseD === void 0 ? "Choose" : _this$props12$chooseD, _this$props12$disable = _this$props12.disabledDayAriaLabelPrefix, disabledDayAriaLabelPrefix = _this$props12$disable === void 0 ? "Not available" : _this$props12$disable, day = _this$props12.day, locale2 = _this$props12.locale;
      var labelDate = setMonth$1(day, month);
      var prefix2 = _this.isDisabled(labelDate) || _this.isExcluded(labelDate) ? disabledDayAriaLabelPrefix : chooseDayAriaLabelPrefix;
      return "".concat(prefix2, " ").concat(formatDate(labelDate, "MMMM yyyy", locale2));
    });
    _defineProperty$2(_this, "getQuarterClassNames", function(q2) {
      var _this$props13 = _this.props, day = _this$props13.day, startDate = _this$props13.startDate, endDate = _this$props13.endDate, selected = _this$props13.selected, minDate = _this$props13.minDate, maxDate = _this$props13.maxDate, preSelection = _this$props13.preSelection, disabledKeyboardNavigation = _this$props13.disabledKeyboardNavigation;
      return clsx("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(q2), {
        "react-datepicker__quarter-text--disabled": (minDate || maxDate) && isQuarterDisabled(setQuarter(day, q2), _this.props),
        "react-datepicker__quarter-text--selected": _this.isSelectedQuarter(day, q2, selected),
        "react-datepicker__quarter-text--keyboard-selected": !disabledKeyboardNavigation && _this.isSelectedQuarter(day, q2, preSelection),
        "react-datepicker__quarter-text--in-selecting-range": _this.isInSelectingRangeQuarter(q2),
        "react-datepicker__quarter-text--in-range": isQuarterInRange(startDate, endDate, q2, day),
        "react-datepicker__quarter-text--range-start": _this.isRangeStartQuarter(q2),
        "react-datepicker__quarter-text--range-end": _this.isRangeEndQuarter(q2)
      });
    });
    _defineProperty$2(_this, "getMonthContent", function(m2) {
      var _this$props14 = _this.props, showFullMonthYearPicker = _this$props14.showFullMonthYearPicker, renderMonthContent = _this$props14.renderMonthContent, locale2 = _this$props14.locale, day = _this$props14.day;
      var shortMonthText = getMonthShortInLocale(m2, locale2);
      var fullMonthText = getMonthInLocale(m2, locale2);
      if (renderMonthContent) {
        return renderMonthContent(m2, shortMonthText, fullMonthText, day);
      }
      return showFullMonthYearPicker ? fullMonthText : shortMonthText;
    });
    _defineProperty$2(_this, "getQuarterContent", function(q2) {
      var _this$props15 = _this.props, renderQuarterContent = _this$props15.renderQuarterContent, locale2 = _this$props15.locale;
      var shortQuarter = getQuarterShortInLocale(q2, locale2);
      return renderQuarterContent ? renderQuarterContent(q2, shortQuarter) : shortQuarter;
    });
    _defineProperty$2(_this, "renderMonths", function() {
      var _this$props16 = _this.props, showTwoColumnMonthYearPicker = _this$props16.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker = _this$props16.showFourColumnMonthYearPicker, day = _this$props16.day, selected = _this$props16.selected;
      var monthColumns = MONTH_COLUMNS[getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker)].grid;
      return monthColumns.map(function(month, i) {
        return /* @__PURE__ */ React__default.createElement("div", {
          className: "react-datepicker__month-wrapper",
          key: i
        }, month.map(function(m2, j2) {
          return /* @__PURE__ */ React__default.createElement("div", {
            ref: _this.MONTH_REFS[m2],
            key: j2,
            onClick: function onClick(ev) {
              _this.onMonthClick(ev, m2);
            },
            onKeyDown: function onKeyDown(ev) {
              if (isSpaceKeyDown(ev)) {
                ev.preventDefault();
                ev.key = "Enter";
              }
              _this.onMonthKeyDown(ev, m2);
            },
            onMouseEnter: !_this.props.usePointerEvent ? function() {
              return _this.onMonthMouseEnter(m2);
            } : void 0,
            onPointerEnter: _this.props.usePointerEvent ? function() {
              return _this.onMonthMouseEnter(m2);
            } : void 0,
            tabIndex: _this.getTabIndex(m2),
            className: _this.getMonthClassNames(m2),
            "aria-disabled": _this.isMonthDisabled(m2),
            role: "option",
            "aria-label": _this.getAriaLabel(m2),
            "aria-current": _this.isCurrentMonth(day, m2) ? "date" : void 0,
            "aria-selected": _this.isSelectedMonth(day, m2, selected)
          }, _this.getMonthContent(m2));
        }));
      });
    });
    _defineProperty$2(_this, "renderQuarters", function() {
      var _this$props17 = _this.props, day = _this$props17.day, selected = _this$props17.selected;
      var quarters = [1, 2, 3, 4];
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__quarter-wrapper"
      }, quarters.map(function(q2, j2) {
        return /* @__PURE__ */ React__default.createElement("div", {
          key: j2,
          ref: _this.QUARTER_REFS[j2],
          role: "option",
          onClick: function onClick(ev) {
            _this.onQuarterClick(ev, q2);
          },
          onKeyDown: function onKeyDown(ev) {
            _this.onQuarterKeyDown(ev, q2);
          },
          onMouseEnter: !_this.props.usePointerEvent ? function() {
            return _this.onQuarterMouseEnter(q2);
          } : void 0,
          onPointerEnter: _this.props.usePointerEvent ? function() {
            return _this.onQuarterMouseEnter(q2);
          } : void 0,
          className: _this.getQuarterClassNames(q2),
          "aria-selected": _this.isSelectedQuarter(day, q2, selected),
          tabIndex: _this.getQuarterTabIndex(q2),
          "aria-current": _this.isCurrentQuarter(day, q2) ? "date" : void 0
        }, _this.getQuarterContent(q2));
      }));
    });
    _defineProperty$2(_this, "getClassNames", function() {
      var _this$props18 = _this.props, selectingDate = _this$props18.selectingDate, selectsStart = _this$props18.selectsStart, selectsEnd = _this$props18.selectsEnd, showMonthYearPicker = _this$props18.showMonthYearPicker, showQuarterYearPicker = _this$props18.showQuarterYearPicker, showWeekPicker = _this$props18.showWeekPicker;
      return clsx("react-datepicker__month", {
        "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
      }, {
        "react-datepicker__monthPicker": showMonthYearPicker
      }, {
        "react-datepicker__quarterPicker": showQuarterYearPicker
      }, {
        "react-datepicker__weekPicker": showWeekPicker
      });
    });
    return _this;
  }
  _inherits$1(Month2, _React$Component);
  return _createClass$1(Month2, [{
    key: "render",
    value: function render() {
      var _this$props19 = this.props, showMonthYearPicker = _this$props19.showMonthYearPicker, showQuarterYearPicker = _this$props19.showQuarterYearPicker, day = _this$props19.day, _this$props19$ariaLab = _this$props19.ariaLabelPrefix, ariaLabelPrefix = _this$props19$ariaLab === void 0 ? "Month " : _this$props19$ariaLab;
      var formattedAriaLabelPrefix = ariaLabelPrefix ? ariaLabelPrefix.trim() + " " : "";
      return /* @__PURE__ */ React__default.createElement("div", {
        className: this.getClassNames(),
        onMouseLeave: !this.props.usePointerEvent ? this.handleMouseLeave : void 0,
        onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0,
        "aria-label": "".concat(formattedAriaLabelPrefix).concat(formatDate(day, "MMMM, yyyy", this.props.locale)),
        role: "listbox"
      }, showMonthYearPicker ? this.renderMonths() : showQuarterYearPicker ? this.renderQuarters() : this.renderWeeks());
    }
  }]);
}(React__default.Component);
var Time = /* @__PURE__ */ function(_React$Component) {
  function Time2() {
    var _this;
    _classCallCheck$1(this, Time2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Time2, [].concat(args));
    _defineProperty$2(_this, "state", {
      height: null
    });
    _defineProperty$2(_this, "scrollToTheSelectedTime", function() {
      requestAnimationFrame(function() {
        if (!_this.list) return;
        _this.list.scrollTop = _this.centerLi && Time2.calcCenterPosition(_this.props.monthRef ? _this.props.monthRef.clientHeight - _this.header.clientHeight : _this.list.clientHeight, _this.centerLi);
      });
    });
    _defineProperty$2(_this, "handleClick", function(time) {
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && isTimeDisabled(time, _this.props)) {
        return;
      }
      _this.props.onChange(time);
    });
    _defineProperty$2(_this, "isSelectedTime", function(time) {
      return _this.props.selected && isSameMinute(_this.props.selected, time);
    });
    _defineProperty$2(_this, "isDisabledTime", function(time) {
      return (_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && isTimeDisabled(time, _this.props);
    });
    _defineProperty$2(_this, "liClasses", function(time) {
      var classes2 = ["react-datepicker__time-list-item", _this.props.timeClassName ? _this.props.timeClassName(time) : void 0];
      if (_this.isSelectedTime(time)) {
        classes2.push("react-datepicker__time-list-item--selected");
      }
      if (_this.isDisabledTime(time)) {
        classes2.push("react-datepicker__time-list-item--disabled");
      }
      if (_this.props.injectTimes && (getHours(time) * 3600 + getMinutes(time) * 60 + getSeconds(time)) % (_this.props.intervals * 60) !== 0) {
        classes2.push("react-datepicker__time-list-item--injected");
      }
      return classes2.join(" ");
    });
    _defineProperty$2(_this, "handleOnKeyDown", function(event, time) {
      if (event.key === " ") {
        event.preventDefault();
        event.key = "Enter";
      }
      if ((event.key === "ArrowUp" || event.key === "ArrowLeft") && event.target.previousSibling) {
        event.preventDefault();
        event.target.previousSibling.focus();
      }
      if ((event.key === "ArrowDown" || event.key === "ArrowRight") && event.target.nextSibling) {
        event.preventDefault();
        event.target.nextSibling.focus();
      }
      if (event.key === "Enter") {
        _this.handleClick(time);
      }
      _this.props.handleOnKeyDown(event);
    });
    _defineProperty$2(_this, "renderTimes", function() {
      var times = [];
      var format2 = _this.props.format ? _this.props.format : "p";
      var intervals = _this.props.intervals;
      var activeDate = _this.props.selected || _this.props.openToDate || newDate();
      var base2 = getStartOfDay(activeDate);
      var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function(a2, b2) {
        return a2 - b2;
      });
      var minutesInDay = 60 * getHoursInDay(activeDate);
      var multiplier = minutesInDay / intervals;
      for (var i = 0; i < multiplier; i++) {
        var currentTime = addMinutes(base2, i * intervals);
        times.push(currentTime);
        if (sortedInjectTimes) {
          var timesToInject = timesToInjectAfter(base2, currentTime, i, intervals, sortedInjectTimes);
          times = times.concat(timesToInject);
        }
      }
      var timeToFocus = times.reduce(function(prev2, time) {
        if (time.getTime() <= activeDate.getTime()) {
          return time;
        }
        return prev2;
      }, times[0]);
      return times.map(function(time, i2) {
        return /* @__PURE__ */ React__default.createElement("li", {
          key: i2,
          onClick: _this.handleClick.bind(_this, time),
          className: _this.liClasses(time),
          ref: function ref2(li) {
            if (time === timeToFocus) {
              _this.centerLi = li;
            }
          },
          onKeyDown: function onKeyDown(ev) {
            _this.handleOnKeyDown(ev, time);
          },
          tabIndex: time === timeToFocus ? 0 : -1,
          role: "option",
          "aria-selected": _this.isSelectedTime(time) ? "true" : void 0,
          "aria-disabled": _this.isDisabledTime(time) ? "true" : void 0
        }, formatDate(time, format2, _this.props.locale));
      });
    });
    return _this;
  }
  _inherits$1(Time2, _React$Component);
  return _createClass$1(Time2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollToTheSelectedTime();
      if (this.props.monthRef && this.header) {
        this.setState({
          height: this.props.monthRef.clientHeight - this.header.clientHeight
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var height2 = this.state.height;
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
        ref: function ref2(header) {
          _this2.header = header;
        }
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker-time__header"
      }, this.props.timeCaption)), /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__time"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__time-box"
      }, /* @__PURE__ */ React__default.createElement("ul", {
        className: "react-datepicker__time-list",
        ref: function ref2(list2) {
          _this2.list = list2;
        },
        style: height2 ? {
          height: height2
        } : {},
        role: "listbox",
        "aria-label": this.props.timeCaption
      }, this.renderTimes()))));
    }
  }], [{
    key: "defaultProps",
    get: function get6() {
      return {
        intervals: 30,
        onTimeChange: function onTimeChange() {
        },
        todayButton: null,
        timeCaption: "Time"
      };
    }
  }]);
}(React__default.Component);
_defineProperty$2(Time, "calcCenterPosition", function(listHeight, centerLiRef) {
  return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
});
var VERTICAL_NAVIGATION_OFFSET = 3;
var Year = /* @__PURE__ */ function(_React$Component) {
  function Year2(props) {
    var _this;
    _classCallCheck$1(this, Year2);
    _this = _callSuper(this, Year2, [props]);
    _defineProperty$2(_this, "YEAR_REFS", _toConsumableArray$1(Array(_this.props.yearItemNumber)).map(function() {
      return /* @__PURE__ */ React__default.createRef();
    }));
    _defineProperty$2(_this, "isDisabled", function(date) {
      return isDayDisabled(date, _this.props);
    });
    _defineProperty$2(_this, "isExcluded", function(date) {
      return isDayExcluded(date, _this.props);
    });
    _defineProperty$2(_this, "selectingDate", function() {
      var _this$props$selecting;
      return (_this$props$selecting = _this.props.selectingDate) !== null && _this$props$selecting !== void 0 ? _this$props$selecting : _this.props.preSelection;
    });
    _defineProperty$2(_this, "updateFocusOnPaginate", function(refIndex) {
      var waitForReRender = (function() {
        this.YEAR_REFS[refIndex].current.focus();
      }).bind(_this);
      window.requestAnimationFrame(waitForReRender);
    });
    _defineProperty$2(_this, "handleYearClick", function(day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    });
    _defineProperty$2(_this, "handleYearNavigation", function(newYear, newDate2) {
      var _this$props = _this.props, date = _this$props.date, yearItemNumber = _this$props.yearItemNumber;
      var _utils$getYearsPeriod = getYearsPeriod(date, yearItemNumber), startPeriod = _utils$getYearsPeriod.startPeriod;
      if (_this.isDisabled(newDate2) || _this.isExcluded(newDate2)) return;
      _this.props.setPreSelection(newDate2);
      if (newYear - startPeriod < 0) {
        _this.updateFocusOnPaginate(yearItemNumber - (startPeriod - newYear));
      } else if (newYear - startPeriod >= yearItemNumber) {
        _this.updateFocusOnPaginate(Math.abs(yearItemNumber - (newYear - startPeriod)));
      } else _this.YEAR_REFS[newYear - startPeriod].current.focus();
    });
    _defineProperty$2(_this, "isSameDay", function(y2, other2) {
      return isSameDay(y2, other2);
    });
    _defineProperty$2(_this, "isCurrentYear", function(y2) {
      return y2 === getYear(newDate());
    });
    _defineProperty$2(_this, "isRangeStart", function(y2) {
      return _this.props.startDate && _this.props.endDate && isSameYear(setYear(newDate(), y2), _this.props.startDate);
    });
    _defineProperty$2(_this, "isRangeEnd", function(y2) {
      return _this.props.startDate && _this.props.endDate && isSameYear(setYear(newDate(), y2), _this.props.endDate);
    });
    _defineProperty$2(_this, "isInRange", function(y2) {
      return isYearInRange(y2, _this.props.startDate, _this.props.endDate);
    });
    _defineProperty$2(_this, "isInSelectingRange", function(y2) {
      var _this$props2 = _this.props, selectsStart = _this$props2.selectsStart, selectsEnd = _this$props2.selectsEnd, selectsRange = _this$props2.selectsRange, startDate = _this$props2.startDate, endDate = _this$props2.endDate;
      if (!(selectsStart || selectsEnd || selectsRange) || !_this.selectingDate()) {
        return false;
      }
      if (selectsStart && endDate) {
        return isYearInRange(y2, _this.selectingDate(), endDate);
      }
      if (selectsEnd && startDate) {
        return isYearInRange(y2, startDate, _this.selectingDate());
      }
      if (selectsRange && startDate && !endDate) {
        return isYearInRange(y2, startDate, _this.selectingDate());
      }
      return false;
    });
    _defineProperty$2(_this, "isSelectingRangeStart", function(y2) {
      if (!_this.isInSelectingRange(y2)) {
        return false;
      }
      var _this$props3 = _this.props, startDate = _this$props3.startDate, selectsStart = _this$props3.selectsStart;
      var _year = setYear(newDate(), y2);
      if (selectsStart) {
        return isSameYear(_year, _this.selectingDate());
      }
      return isSameYear(_year, startDate);
    });
    _defineProperty$2(_this, "isSelectingRangeEnd", function(y2) {
      if (!_this.isInSelectingRange(y2)) {
        return false;
      }
      var _this$props4 = _this.props, endDate = _this$props4.endDate, selectsEnd = _this$props4.selectsEnd, selectsRange = _this$props4.selectsRange;
      var _year = setYear(newDate(), y2);
      if (selectsEnd || selectsRange) {
        return isSameYear(_year, _this.selectingDate());
      }
      return isSameYear(_year, endDate);
    });
    _defineProperty$2(_this, "isKeyboardSelected", function(y2) {
      var date = getStartOfYear(setYear(_this.props.date, y2));
      return !_this.props.disabledKeyboardNavigation && !_this.props.inline && !isSameDay(date, getStartOfYear(_this.props.selected)) && isSameDay(date, getStartOfYear(_this.props.preSelection));
    });
    _defineProperty$2(_this, "onYearClick", function(e, y2) {
      var date = _this.props.date;
      _this.handleYearClick(getStartOfYear(setYear(date, y2)), e);
    });
    _defineProperty$2(_this, "onYearKeyDown", function(e, y2) {
      var key2 = e.key;
      var _this$props5 = _this.props, date = _this$props5.date, yearItemNumber = _this$props5.yearItemNumber, handleOnKeyDown = _this$props5.handleOnKeyDown;
      if (key2 !== "Tab") {
        e.preventDefault();
      }
      if (!_this.props.disabledKeyboardNavigation) {
        switch (key2) {
          case "Enter":
            _this.onYearClick(e, y2);
            _this.props.setPreSelection(_this.props.selected);
            break;
          case "ArrowRight":
            _this.handleYearNavigation(y2 + 1, addYears(_this.props.preSelection, 1));
            break;
          case "ArrowLeft":
            _this.handleYearNavigation(y2 - 1, subYears(_this.props.preSelection, 1));
            break;
          case "ArrowUp": {
            var _utils$getYearsPeriod2 = getYearsPeriod(date, yearItemNumber), startPeriod = _utils$getYearsPeriod2.startPeriod;
            var offset3 = VERTICAL_NAVIGATION_OFFSET;
            var newYear = y2 - offset3;
            if (newYear < startPeriod) {
              var leftOverOffset = yearItemNumber % offset3;
              if (y2 >= startPeriod && y2 < startPeriod + leftOverOffset) {
                offset3 = leftOverOffset;
              } else {
                offset3 += leftOverOffset;
              }
              newYear = y2 - offset3;
            }
            _this.handleYearNavigation(newYear, subYears(_this.props.preSelection, offset3));
            break;
          }
          case "ArrowDown": {
            var _utils$getYearsPeriod3 = getYearsPeriod(date, yearItemNumber), endPeriod = _utils$getYearsPeriod3.endPeriod;
            var _offset = VERTICAL_NAVIGATION_OFFSET;
            var _newYear = y2 + _offset;
            if (_newYear > endPeriod) {
              var _leftOverOffset = yearItemNumber % _offset;
              if (y2 <= endPeriod && y2 > endPeriod - _leftOverOffset) {
                _offset = _leftOverOffset;
              } else {
                _offset += _leftOverOffset;
              }
              _newYear = y2 + _offset;
            }
            _this.handleYearNavigation(_newYear, addYears(_this.props.preSelection, _offset));
            break;
          }
        }
      }
      handleOnKeyDown && handleOnKeyDown(e);
    });
    _defineProperty$2(_this, "getYearClassNames", function(y2) {
      var _this$props6 = _this.props, date = _this$props6.date, minDate = _this$props6.minDate, maxDate = _this$props6.maxDate, selected = _this$props6.selected, excludeDates = _this$props6.excludeDates, includeDates = _this$props6.includeDates, filterDate = _this$props6.filterDate, yearClassName = _this$props6.yearClassName;
      return clsx("react-datepicker__year-text", "react-datepicker__year-".concat(y2), yearClassName ? yearClassName(setYear(date, y2)) : void 0, {
        "react-datepicker__year-text--selected": y2 === getYear(selected),
        "react-datepicker__year-text--disabled": (minDate || maxDate || excludeDates || includeDates || filterDate) && isYearDisabled(y2, _this.props),
        "react-datepicker__year-text--keyboard-selected": _this.isKeyboardSelected(y2),
        "react-datepicker__year-text--range-start": _this.isRangeStart(y2),
        "react-datepicker__year-text--range-end": _this.isRangeEnd(y2),
        "react-datepicker__year-text--in-range": _this.isInRange(y2),
        "react-datepicker__year-text--in-selecting-range": _this.isInSelectingRange(y2),
        "react-datepicker__year-text--selecting-range-start": _this.isSelectingRangeStart(y2),
        "react-datepicker__year-text--selecting-range-end": _this.isSelectingRangeEnd(y2),
        "react-datepicker__year-text--today": _this.isCurrentYear(y2)
      });
    });
    _defineProperty$2(_this, "getYearTabIndex", function(y2) {
      if (_this.props.disabledKeyboardNavigation) return "-1";
      var preSelected = getYear(_this.props.preSelection);
      return y2 === preSelected ? "0" : "-1";
    });
    _defineProperty$2(_this, "getYearContainerClassNames", function() {
      var _this$props7 = _this.props, selectingDate = _this$props7.selectingDate, selectsStart = _this$props7.selectsStart, selectsEnd = _this$props7.selectsEnd, selectsRange = _this$props7.selectsRange;
      return clsx("react-datepicker__year", {
        "react-datepicker__year--selecting-range": selectingDate && (selectsStart || selectsEnd || selectsRange)
      });
    });
    _defineProperty$2(_this, "getYearContent", function(y2) {
      return _this.props.renderYearContent ? _this.props.renderYearContent(y2) : y2;
    });
    return _this;
  }
  _inherits$1(Year2, _React$Component);
  return _createClass$1(Year2, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var yearsList = [];
      var _this$props8 = this.props, date = _this$props8.date, yearItemNumber = _this$props8.yearItemNumber, onYearMouseEnter = _this$props8.onYearMouseEnter, onYearMouseLeave = _this$props8.onYearMouseLeave;
      var _utils$getYearsPeriod4 = getYearsPeriod(date, yearItemNumber), startPeriod = _utils$getYearsPeriod4.startPeriod, endPeriod = _utils$getYearsPeriod4.endPeriod;
      var _loop = function _loop2(y3) {
        yearsList.push(/* @__PURE__ */ React__default.createElement("div", {
          ref: _this2.YEAR_REFS[y3 - startPeriod],
          onClick: function onClick(ev) {
            _this2.onYearClick(ev, y3);
          },
          onKeyDown: function onKeyDown(ev) {
            if (isSpaceKeyDown(ev)) {
              ev.preventDefault();
              ev.key = "Enter";
            }
            _this2.onYearKeyDown(ev, y3);
          },
          tabIndex: _this2.getYearTabIndex(y3),
          className: _this2.getYearClassNames(y3),
          onMouseEnter: !_this2.props.usePointerEvent ? function(ev) {
            return onYearMouseEnter(ev, y3);
          } : void 0,
          onPointerEnter: _this2.props.usePointerEvent ? function(ev) {
            return onYearMouseEnter(ev, y3);
          } : void 0,
          onMouseLeave: !_this2.props.usePointerEvent ? function(ev) {
            return onYearMouseLeave(ev, y3);
          } : void 0,
          onPointerLeave: _this2.props.usePointerEvent ? function(ev) {
            return onYearMouseLeave(ev, y3);
          } : void 0,
          key: y3,
          "aria-current": _this2.isCurrentYear(y3) ? "date" : void 0
        }, _this2.getYearContent(y3)));
      };
      for (var y2 = startPeriod; y2 <= endPeriod; y2++) {
        _loop(y2);
      }
      return /* @__PURE__ */ React__default.createElement("div", {
        className: this.getYearContainerClassNames()
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__year-wrapper",
        onMouseLeave: !this.props.usePointerEvent ? this.props.clearSelectingDate : void 0,
        onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0
      }, yearsList));
    }
  }]);
}(React__default.Component);
var inputTime = /* @__PURE__ */ function(_React$Component) {
  function inputTime2(props) {
    var _this;
    _classCallCheck$1(this, inputTime2);
    _this = _callSuper(this, inputTime2, [props]);
    _defineProperty$2(_this, "onTimeChange", function(time) {
      _this.setState({
        time
      });
      var propDate = _this.props.date;
      var isPropDateValid = propDate instanceof Date && !isNaN(propDate);
      var date = isPropDateValid ? propDate : /* @__PURE__ */ new Date();
      date.setHours(time.split(":")[0]);
      date.setMinutes(time.split(":")[1]);
      _this.props.onChange(date);
    });
    _defineProperty$2(_this, "renderTimeInput", function() {
      var time = _this.state.time;
      var _this$props = _this.props, date = _this$props.date, timeString = _this$props.timeString, customTimeInput = _this$props.customTimeInput;
      if (customTimeInput) {
        return /* @__PURE__ */ React__default.cloneElement(customTimeInput, {
          date,
          value: time,
          onChange: _this.onTimeChange
        });
      }
      return /* @__PURE__ */ React__default.createElement("input", {
        type: "time",
        className: "react-datepicker-time__input",
        placeholder: "Time",
        name: "time-input",
        required: true,
        value: time,
        onChange: function onChange(ev) {
          _this.onTimeChange(ev.target.value || timeString);
        }
      });
    });
    _this.state = {
      time: _this.props.timeString
    };
    return _this;
  }
  _inherits$1(inputTime2, _React$Component);
  return _createClass$1(inputTime2, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__input-time-container"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker-time__caption"
      }, this.props.timeInputLabel), /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker-time__input-container"
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker-time__input"
      }, this.renderTimeInput())));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.timeString !== state.time) {
        return {
          time: props.timeString
        };
      }
      return null;
    }
  }]);
}(React__default.Component);
function CalendarContainer(_ref) {
  var _ref$showTimeSelectOn = _ref.showTimeSelectOnly, showTimeSelectOnly = _ref$showTimeSelectOn === void 0 ? false : _ref$showTimeSelectOn, _ref$showTime = _ref.showTime, showTime = _ref$showTime === void 0 ? false : _ref$showTime, className = _ref.className, children = _ref.children;
  var ariaLabel = showTimeSelectOnly ? "Choose Time" : "Choose Date".concat(showTime ? " and Time" : "");
  return /* @__PURE__ */ React__default.createElement("div", {
    className,
    role: "dialog",
    "aria-label": ariaLabel,
    "aria-modal": "true"
  }, children);
}
var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];
var isDropdownSelect = function isDropdownSelect2() {
  var element2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var classNames2 = (element2.className || "").split(/\s+/);
  return DROPDOWN_FOCUS_CLASSNAMES.some(function(testClassname) {
    return classNames2.indexOf(testClassname) >= 0;
  });
};
var Calendar = /* @__PURE__ */ function(_React$Component) {
  function Calendar2(props) {
    var _this;
    _classCallCheck$1(this, Calendar2);
    _this = _callSuper(this, Calendar2, [props]);
    _defineProperty$2(_this, "handleClickOutside", function(event) {
      _this.props.onClickOutside(event);
    });
    _defineProperty$2(_this, "setClickOutsideRef", function() {
      return _this.containerRef.current;
    });
    _defineProperty$2(_this, "handleDropdownFocus", function(event) {
      if (isDropdownSelect(event.target)) {
        _this.props.onDropdownFocus();
      }
    });
    _defineProperty$2(_this, "getDateInView", function() {
      var _this$props = _this.props, preSelection = _this$props.preSelection, selected = _this$props.selected, openToDate = _this$props.openToDate;
      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var current = newDate();
      var initialDate = openToDate || selected || preSelection;
      if (initialDate) {
        return initialDate;
      } else {
        if (minDate && isBefore$1(current, minDate)) {
          return minDate;
        } else if (maxDate && isAfter$2(current, maxDate)) {
          return maxDate;
        }
      }
      return current;
    });
    _defineProperty$2(_this, "increaseMonth", function() {
      _this.setState(function(_ref) {
        var date = _ref.date;
        return {
          date: addMonths(date, 1)
        };
      }, function() {
        return _this.handleMonthChange(_this.state.date);
      });
    });
    _defineProperty$2(_this, "decreaseMonth", function() {
      _this.setState(function(_ref2) {
        var date = _ref2.date;
        return {
          date: subMonths(date, 1)
        };
      }, function() {
        return _this.handleMonthChange(_this.state.date);
      });
    });
    _defineProperty$2(_this, "handleDayClick", function(day, event, monthSelectedIn) {
      _this.props.onSelect(day, event, monthSelectedIn);
      _this.props.setPreSelection && _this.props.setPreSelection(day);
    });
    _defineProperty$2(_this, "handleDayMouseEnter", function(day) {
      _this.setState({
        selectingDate: day
      });
      _this.props.onDayMouseEnter && _this.props.onDayMouseEnter(day);
    });
    _defineProperty$2(_this, "handleMonthMouseLeave", function() {
      _this.setState({
        selectingDate: null
      });
      _this.props.onMonthMouseLeave && _this.props.onMonthMouseLeave();
    });
    _defineProperty$2(_this, "handleYearMouseEnter", function(event, year) {
      _this.setState({
        selectingDate: setYear(newDate(), year)
      });
      !!_this.props.onYearMouseEnter && _this.props.onYearMouseEnter(event, year);
    });
    _defineProperty$2(_this, "handleYearMouseLeave", function(event, year) {
      !!_this.props.onYearMouseLeave && _this.props.onYearMouseLeave(event, year);
    });
    _defineProperty$2(_this, "handleYearChange", function(date) {
      if (_this.props.onYearChange) {
        _this.props.onYearChange(date);
        _this.setState({
          isRenderAriaLiveMessage: true
        });
      }
      if (_this.props.adjustDateOnChange) {
        if (_this.props.onSelect) {
          _this.props.onSelect(date);
        }
        if (_this.props.setOpen) {
          _this.props.setOpen(true);
        }
      }
      _this.props.setPreSelection && _this.props.setPreSelection(date);
    });
    _defineProperty$2(_this, "handleMonthChange", function(date) {
      _this.handleCustomMonthChange(date);
      if (_this.props.adjustDateOnChange) {
        if (_this.props.onSelect) {
          _this.props.onSelect(date);
        }
        if (_this.props.setOpen) {
          _this.props.setOpen(true);
        }
      }
      _this.props.setPreSelection && _this.props.setPreSelection(date);
    });
    _defineProperty$2(_this, "handleCustomMonthChange", function(date) {
      if (_this.props.onMonthChange) {
        _this.props.onMonthChange(date);
        _this.setState({
          isRenderAriaLiveMessage: true
        });
      }
    });
    _defineProperty$2(_this, "handleMonthYearChange", function(date) {
      _this.handleYearChange(date);
      _this.handleMonthChange(date);
    });
    _defineProperty$2(_this, "changeYear", function(year) {
      _this.setState(function(_ref3) {
        var date = _ref3.date;
        return {
          date: setYear(date, year)
        };
      }, function() {
        return _this.handleYearChange(_this.state.date);
      });
    });
    _defineProperty$2(_this, "changeMonth", function(month) {
      _this.setState(function(_ref4) {
        var date = _ref4.date;
        return {
          date: setMonth$1(date, month)
        };
      }, function() {
        return _this.handleMonthChange(_this.state.date);
      });
    });
    _defineProperty$2(_this, "changeMonthYear", function(monthYear) {
      _this.setState(function(_ref5) {
        var date = _ref5.date;
        return {
          date: setYear(setMonth$1(date, getMonth(monthYear)), getYear(monthYear))
        };
      }, function() {
        return _this.handleMonthYearChange(_this.state.date);
      });
    });
    _defineProperty$2(_this, "header", function() {
      var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _this.state.date;
      var startOfWeek2 = getStartOfWeek(date, _this.props.locale, _this.props.calendarStartDay);
      var dayNames = [];
      if (_this.props.showWeekNumbers) {
        dayNames.push(/* @__PURE__ */ React__default.createElement("div", {
          key: "W",
          className: "react-datepicker__day-name"
        }, _this.props.weekLabel || "#"));
      }
      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function(offset3) {
        var day = addDays(startOfWeek2, offset3);
        var weekDayName = _this.formatWeekday(day, _this.props.locale);
        var weekDayClassName = _this.props.weekDayClassName ? _this.props.weekDayClassName(day) : void 0;
        return /* @__PURE__ */ React__default.createElement("div", {
          key: offset3,
          "aria-label": formatDate(day, "EEEE", _this.props.locale),
          className: clsx("react-datepicker__day-name", weekDayClassName)
        }, weekDayName);
      }));
    });
    _defineProperty$2(_this, "formatWeekday", function(day, locale2) {
      if (_this.props.formatWeekDay) {
        return getFormattedWeekdayInLocale(day, _this.props.formatWeekDay, locale2);
      }
      return _this.props.useWeekdaysShort ? getWeekdayShortInLocale(day, locale2) : getWeekdayMinInLocale(day, locale2);
    });
    _defineProperty$2(_this, "decreaseYear", function() {
      _this.setState(function(_ref6) {
        var date = _ref6.date;
        return {
          date: subYears(date, _this.props.showYearPicker ? _this.props.yearItemNumber : 1)
        };
      }, function() {
        return _this.handleYearChange(_this.state.date);
      });
    });
    _defineProperty$2(_this, "clearSelectingDate", function() {
      _this.setState({
        selectingDate: null
      });
    });
    _defineProperty$2(_this, "renderPreviousButton", function() {
      if (_this.props.renderCustomHeader) {
        return;
      }
      var allPrevDaysDisabled;
      switch (true) {
        case _this.props.showMonthYearPicker:
          allPrevDaysDisabled = yearDisabledBefore(_this.state.date, _this.props);
          break;
        case _this.props.showYearPicker:
          allPrevDaysDisabled = yearsDisabledBefore(_this.state.date, _this.props);
          break;
        case _this.props.showQuarterYearPicker:
          allPrevDaysDisabled = quarterDisabledBefore(_this.state.date, _this.props);
          break;
        default:
          allPrevDaysDisabled = monthDisabledBefore(_this.state.date, _this.props);
          break;
      }
      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }
      var iconClasses = ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"];
      var classes2 = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];
      var clickHandler2 = _this.decreaseMonth;
      if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) {
        clickHandler2 = _this.decreaseYear;
      }
      if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes2.push("react-datepicker__navigation--previous--disabled");
        clickHandler2 = null;
      }
      var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
      var _this$props2 = _this.props, previousMonthButtonLabel = _this$props2.previousMonthButtonLabel, previousYearButtonLabel = _this$props2.previousYearButtonLabel;
      var _this$props3 = _this.props, _this$props3$previous = _this$props3.previousMonthAriaLabel, previousMonthAriaLabel = _this$props3$previous === void 0 ? typeof previousMonthButtonLabel === "string" ? previousMonthButtonLabel : "Previous Month" : _this$props3$previous, _this$props3$previous2 = _this$props3.previousYearAriaLabel, previousYearAriaLabel = _this$props3$previous2 === void 0 ? typeof previousYearButtonLabel === "string" ? previousYearButtonLabel : "Previous Year" : _this$props3$previous2;
      return /* @__PURE__ */ React__default.createElement("button", {
        type: "button",
        className: classes2.join(" "),
        onClick: clickHandler2,
        onKeyDown: _this.props.handleOnKeyDown,
        "aria-label": isForYear ? previousYearAriaLabel : previousMonthAriaLabel
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: iconClasses.join(" ")
      }, isForYear ? _this.props.previousYearButtonLabel : _this.props.previousMonthButtonLabel));
    });
    _defineProperty$2(_this, "increaseYear", function() {
      _this.setState(function(_ref7) {
        var date = _ref7.date;
        return {
          date: addYears(date, _this.props.showYearPicker ? _this.props.yearItemNumber : 1)
        };
      }, function() {
        return _this.handleYearChange(_this.state.date);
      });
    });
    _defineProperty$2(_this, "renderNextButton", function() {
      if (_this.props.renderCustomHeader) {
        return;
      }
      var allNextDaysDisabled;
      switch (true) {
        case _this.props.showMonthYearPicker:
          allNextDaysDisabled = yearDisabledAfter(_this.state.date, _this.props);
          break;
        case _this.props.showYearPicker:
          allNextDaysDisabled = yearsDisabledAfter(_this.state.date, _this.props);
          break;
        case _this.props.showQuarterYearPicker:
          allNextDaysDisabled = quarterDisabledAfter(_this.state.date, _this.props);
          break;
        default:
          allNextDaysDisabled = monthDisabledAfter(_this.state.date, _this.props);
          break;
      }
      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }
      var classes2 = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
      var iconClasses = ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"];
      if (_this.props.showTimeSelect) {
        classes2.push("react-datepicker__navigation--next--with-time");
      }
      if (_this.props.todayButton) {
        classes2.push("react-datepicker__navigation--next--with-today-button");
      }
      var clickHandler2 = _this.increaseMonth;
      if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) {
        clickHandler2 = _this.increaseYear;
      }
      if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes2.push("react-datepicker__navigation--next--disabled");
        clickHandler2 = null;
      }
      var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
      var _this$props4 = _this.props, nextMonthButtonLabel = _this$props4.nextMonthButtonLabel, nextYearButtonLabel = _this$props4.nextYearButtonLabel;
      var _this$props5 = _this.props, _this$props5$nextMont = _this$props5.nextMonthAriaLabel, nextMonthAriaLabel = _this$props5$nextMont === void 0 ? typeof nextMonthButtonLabel === "string" ? nextMonthButtonLabel : "Next Month" : _this$props5$nextMont, _this$props5$nextYear = _this$props5.nextYearAriaLabel, nextYearAriaLabel = _this$props5$nextYear === void 0 ? typeof nextYearButtonLabel === "string" ? nextYearButtonLabel : "Next Year" : _this$props5$nextYear;
      return /* @__PURE__ */ React__default.createElement("button", {
        type: "button",
        className: classes2.join(" "),
        onClick: clickHandler2,
        onKeyDown: _this.props.handleOnKeyDown,
        "aria-label": isForYear ? nextYearAriaLabel : nextMonthAriaLabel
      }, /* @__PURE__ */ React__default.createElement("span", {
        className: iconClasses.join(" ")
      }, isForYear ? _this.props.nextYearButtonLabel : _this.props.nextMonthButtonLabel));
    });
    _defineProperty$2(_this, "renderCurrentMonth", function() {
      var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _this.state.date;
      var classes2 = ["react-datepicker__current-month"];
      if (_this.props.showYearDropdown) {
        classes2.push("react-datepicker__current-month--hasYearDropdown");
      }
      if (_this.props.showMonthDropdown) {
        classes2.push("react-datepicker__current-month--hasMonthDropdown");
      }
      if (_this.props.showMonthYearDropdown) {
        classes2.push("react-datepicker__current-month--hasMonthYearDropdown");
      }
      return /* @__PURE__ */ React__default.createElement("div", {
        className: classes2.join(" ")
      }, formatDate(date, _this.props.dateFormat, _this.props.locale));
    });
    _defineProperty$2(_this, "renderYearDropdown", function() {
      var overrideHide = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
      if (!_this.props.showYearDropdown || overrideHide) {
        return;
      }
      return /* @__PURE__ */ React__default.createElement(YearDropdown, {
        adjustDateOnChange: _this.props.adjustDateOnChange,
        date: _this.state.date,
        onSelect: _this.props.onSelect,
        setOpen: _this.props.setOpen,
        dropdownMode: _this.props.dropdownMode,
        onChange: _this.changeYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        year: getYear(_this.state.date),
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    });
    _defineProperty$2(_this, "renderMonthDropdown", function() {
      var overrideHide = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
      if (!_this.props.showMonthDropdown || overrideHide) {
        return;
      }
      return /* @__PURE__ */ React__default.createElement(MonthDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        onChange: _this.changeMonth,
        month: getMonth(_this.state.date),
        useShortMonthInDropdown: _this.props.useShortMonthInDropdown
      });
    });
    _defineProperty$2(_this, "renderMonthYearDropdown", function() {
      var overrideHide = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
      if (!_this.props.showMonthYearDropdown || overrideHide) {
        return;
      }
      return /* @__PURE__ */ React__default.createElement(MonthYearDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonthYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        date: _this.state.date,
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    });
    _defineProperty$2(_this, "handleTodayButtonClick", function(e) {
      _this.props.onSelect(getStartOfToday(), e);
      _this.props.setPreSelection && _this.props.setPreSelection(getStartOfToday());
    });
    _defineProperty$2(_this, "renderTodayButton", function() {
      if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
        return;
      }
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__today-button",
        onClick: function onClick(e) {
          return _this.handleTodayButtonClick(e);
        }
      }, _this.props.todayButton);
    });
    _defineProperty$2(_this, "renderDefaultHeader", function(_ref8) {
      var monthDate = _ref8.monthDate, i = _ref8.i;
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__header ".concat(_this.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
      }, _this.renderCurrentMonth(monthDate), /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(_this.props.dropdownMode),
        onFocus: _this.handleDropdownFocus
      }, _this.renderMonthDropdown(i !== 0), _this.renderMonthYearDropdown(i !== 0), _this.renderYearDropdown(i !== 0)), /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__day-names"
      }, _this.header(monthDate)));
    });
    _defineProperty$2(_this, "renderCustomHeader", function() {
      var headerArgs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var monthDate = headerArgs.monthDate, i = headerArgs.i;
      if (_this.props.showTimeSelect && !_this.state.monthContainer || _this.props.showTimeSelectOnly) {
        return null;
      }
      var prevMonthButtonDisabled = monthDisabledBefore(_this.state.date, _this.props);
      var nextMonthButtonDisabled = monthDisabledAfter(_this.state.date, _this.props);
      var prevYearButtonDisabled = yearDisabledBefore(_this.state.date, _this.props);
      var nextYearButtonDisabled = yearDisabledAfter(_this.state.date, _this.props);
      var showDayNames = !_this.props.showMonthYearPicker && !_this.props.showQuarterYearPicker && !_this.props.showYearPicker;
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__header react-datepicker__header--custom",
        onFocus: _this.props.onDropdownFocus
      }, _this.props.renderCustomHeader(_objectSpread2$1(_objectSpread2$1({}, _this.state), {}, {
        customHeaderCount: i,
        monthDate,
        changeMonth: _this.changeMonth,
        changeYear: _this.changeYear,
        decreaseMonth: _this.decreaseMonth,
        increaseMonth: _this.increaseMonth,
        decreaseYear: _this.decreaseYear,
        increaseYear: _this.increaseYear,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
        prevYearButtonDisabled,
        nextYearButtonDisabled
      })), showDayNames && /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__day-names"
      }, _this.header(monthDate)));
    });
    _defineProperty$2(_this, "renderYearHeader", function(_ref9) {
      var monthDate = _ref9.monthDate;
      var _this$props6 = _this.props, showYearPicker = _this$props6.showYearPicker, yearItemNumber = _this$props6.yearItemNumber;
      var _getYearsPeriod = getYearsPeriod(monthDate, yearItemNumber), startPeriod = _getYearsPeriod.startPeriod, endPeriod = _getYearsPeriod.endPeriod;
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__header react-datepicker-year-header"
      }, showYearPicker ? "".concat(startPeriod, " - ").concat(endPeriod) : getYear(monthDate));
    });
    _defineProperty$2(_this, "renderHeader", function(headerArgs) {
      switch (true) {
        case _this.props.renderCustomHeader !== void 0:
          return _this.renderCustomHeader(headerArgs);
        case (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker):
          return _this.renderYearHeader(headerArgs);
        default:
          return _this.renderDefaultHeader(headerArgs);
      }
    });
    _defineProperty$2(_this, "renderMonths", function() {
      var _this$props$monthSele;
      if (_this.props.showTimeSelectOnly || _this.props.showYearPicker) {
        return;
      }
      var monthList = [];
      var monthsToSubtract = _this.props.showPreviousMonths ? _this.props.monthsShown - 1 : 0;
      var fromMonthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? addYears(_this.state.date, monthsToSubtract) : subMonths(_this.state.date, monthsToSubtract);
      var monthSelectedIn = (_this$props$monthSele = _this.props.monthSelectedIn) !== null && _this$props$monthSele !== void 0 ? _this$props$monthSele : monthsToSubtract;
      for (var i = 0; i < _this.props.monthsShown; ++i) {
        var monthsToAdd = i - monthSelectedIn + monthsToSubtract;
        var monthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? addYears(fromMonthDate, monthsToAdd) : addMonths(fromMonthDate, monthsToAdd);
        var monthKey = "month-".concat(i);
        var monthShowsDuplicateDaysEnd = i < _this.props.monthsShown - 1;
        var monthShowsDuplicateDaysStart = i > 0;
        monthList.push(/* @__PURE__ */ React__default.createElement("div", {
          key: monthKey,
          ref: function ref2(div) {
            _this.monthContainer = div;
          },
          className: "react-datepicker__month-container"
        }, _this.renderHeader({
          monthDate,
          i
        }), /* @__PURE__ */ React__default.createElement(Month, {
          chooseDayAriaLabelPrefix: _this.props.chooseDayAriaLabelPrefix,
          disabledDayAriaLabelPrefix: _this.props.disabledDayAriaLabelPrefix,
          weekAriaLabelPrefix: _this.props.weekAriaLabelPrefix,
          ariaLabelPrefix: _this.props.monthAriaLabelPrefix,
          onChange: _this.changeMonthYear,
          day: monthDate,
          dayClassName: _this.props.dayClassName,
          calendarStartDay: _this.props.calendarStartDay,
          monthClassName: _this.props.monthClassName,
          onDayClick: _this.handleDayClick,
          handleOnKeyDown: _this.props.handleOnDayKeyDown,
          handleOnMonthKeyDown: _this.props.handleOnKeyDown,
          usePointerEvent: _this.props.usePointerEvent,
          onDayMouseEnter: _this.handleDayMouseEnter,
          onMouseLeave: _this.handleMonthMouseLeave,
          onWeekSelect: _this.props.onWeekSelect,
          orderInDisplay: i,
          formatWeekNumber: _this.props.formatWeekNumber,
          locale: _this.props.locale,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          excludeDateIntervals: _this.props.excludeDateIntervals,
          highlightDates: _this.props.highlightDates,
          holidays: _this.props.holidays,
          selectingDate: _this.state.selectingDate,
          includeDates: _this.props.includeDates,
          includeDateIntervals: _this.props.includeDateIntervals,
          inline: _this.props.inline,
          shouldFocusDayInline: _this.props.shouldFocusDayInline,
          fixedHeight: _this.props.fixedHeight,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          setPreSelection: _this.props.setPreSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          selectsRange: _this.props.selectsRange,
          selectsDisabledDaysInRange: _this.props.selectsDisabledDaysInRange,
          selectsMultiple: _this.props.selectsMultiple,
          selectedDates: _this.props.selectedDates,
          showWeekNumbers: _this.props.showWeekNumbers,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          peekNextMonth: _this.props.peekNextMonth,
          setOpen: _this.props.setOpen,
          shouldCloseOnSelect: _this.props.shouldCloseOnSelect,
          renderDayContents: _this.props.renderDayContents,
          renderMonthContent: _this.props.renderMonthContent,
          renderQuarterContent: _this.props.renderQuarterContent,
          renderYearContent: _this.props.renderYearContent,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          showMonthYearPicker: _this.props.showMonthYearPicker,
          showFullMonthYearPicker: _this.props.showFullMonthYearPicker,
          showTwoColumnMonthYearPicker: _this.props.showTwoColumnMonthYearPicker,
          showFourColumnMonthYearPicker: _this.props.showFourColumnMonthYearPicker,
          showYearPicker: _this.props.showYearPicker,
          showQuarterYearPicker: _this.props.showQuarterYearPicker,
          showWeekPicker: _this.props.showWeekPicker,
          isInputFocused: _this.props.isInputFocused,
          containerRef: _this.containerRef,
          monthShowsDuplicateDaysEnd,
          monthShowsDuplicateDaysStart
        })));
      }
      return monthList;
    });
    _defineProperty$2(_this, "renderYears", function() {
      if (_this.props.showTimeSelectOnly) {
        return;
      }
      if (_this.props.showYearPicker) {
        return /* @__PURE__ */ React__default.createElement("div", {
          className: "react-datepicker__year--container"
        }, _this.renderHeader({
          monthDate: _this.state.date
        }), /* @__PURE__ */ React__default.createElement(Year, _extends$4({
          onDayClick: _this.handleDayClick,
          selectingDate: _this.state.selectingDate,
          clearSelectingDate: _this.clearSelectingDate,
          date: _this.state.date
        }, _this.props, {
          onYearMouseEnter: _this.handleYearMouseEnter,
          onYearMouseLeave: _this.handleYearMouseLeave
        })));
      }
    });
    _defineProperty$2(_this, "renderTimeSection", function() {
      if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) {
        return /* @__PURE__ */ React__default.createElement(Time, {
          selected: _this.props.selected,
          openToDate: _this.props.openToDate,
          onChange: _this.props.onTimeChange,
          timeClassName: _this.props.timeClassName,
          format: _this.props.timeFormat,
          includeTimes: _this.props.includeTimes,
          intervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          filterTime: _this.props.filterTime,
          timeCaption: _this.props.timeCaption,
          todayButton: _this.props.todayButton,
          showMonthDropdown: _this.props.showMonthDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          monthRef: _this.state.monthContainer,
          injectTimes: _this.props.injectTimes,
          locale: _this.props.locale,
          handleOnKeyDown: _this.props.handleOnKeyDown,
          showTimeSelectOnly: _this.props.showTimeSelectOnly
        });
      }
    });
    _defineProperty$2(_this, "renderInputTimeSection", function() {
      var time = new Date(_this.props.selected);
      var timeValid = isValid$4(time) && Boolean(_this.props.selected);
      var timeString = timeValid ? "".concat(addZero(time.getHours()), ":").concat(addZero(time.getMinutes())) : "";
      if (_this.props.showTimeInput) {
        return /* @__PURE__ */ React__default.createElement(inputTime, {
          date: time,
          timeString,
          timeInputLabel: _this.props.timeInputLabel,
          onChange: _this.props.onTimeChange,
          customTimeInput: _this.props.customTimeInput
        });
      }
    });
    _defineProperty$2(_this, "renderAriaLiveRegion", function() {
      var _getYearsPeriod2 = getYearsPeriod(_this.state.date, _this.props.yearItemNumber), startPeriod = _getYearsPeriod2.startPeriod, endPeriod = _getYearsPeriod2.endPeriod;
      var ariaLiveMessage;
      if (_this.props.showYearPicker) {
        ariaLiveMessage = "".concat(startPeriod, " - ").concat(endPeriod);
      } else if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker) {
        ariaLiveMessage = getYear(_this.state.date);
      } else {
        ariaLiveMessage = "".concat(getMonthInLocale(getMonth(_this.state.date), _this.props.locale), " ").concat(getYear(_this.state.date));
      }
      return /* @__PURE__ */ React__default.createElement("span", {
        role: "alert",
        "aria-live": "polite",
        className: "react-datepicker__aria-live"
      }, _this.state.isRenderAriaLiveMessage && ariaLiveMessage);
    });
    _defineProperty$2(_this, "renderChildren", function() {
      if (_this.props.children) {
        return /* @__PURE__ */ React__default.createElement("div", {
          className: "react-datepicker__children-container"
        }, _this.props.children);
      }
    });
    _this.containerRef = /* @__PURE__ */ React__default.createRef();
    _this.state = {
      date: _this.getDateInView(),
      selectingDate: null,
      monthContainer: null,
      isRenderAriaLiveMessage: false
    };
    return _this;
  }
  _inherits$1(Calendar2, _React$Component);
  return _createClass$1(Calendar2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.showTimeSelect) {
        this.assignMonthContainer = function() {
          _this2.setState({
            monthContainer: _this2.monthContainer
          });
        }();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;
      if (this.props.preSelection && (!isSameDay(this.props.preSelection, prevProps.preSelection) || this.props.monthSelectedIn !== prevProps.monthSelectedIn)) {
        var hasMonthChanged = !isSameMonth(this.state.date, this.props.preSelection);
        this.setState({
          date: this.props.preSelection
        }, function() {
          return hasMonthChanged && _this3.handleCustomMonthChange(_this3.state.date);
        });
      } else if (this.props.openToDate && !isSameDay(this.props.openToDate, prevProps.openToDate)) {
        this.setState({
          date: this.props.openToDate
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var Container = this.props.container || CalendarContainer;
      return /* @__PURE__ */ React__default.createElement("div", {
        style: {
          display: "contents"
        },
        ref: this.containerRef
      }, /* @__PURE__ */ React__default.createElement(Container, {
        className: clsx("react-datepicker", this.props.className, {
          "react-datepicker--time-only": this.props.showTimeSelectOnly
        }),
        showTime: this.props.showTimeSelect || this.props.showTimeInput,
        showTimeSelectOnly: this.props.showTimeSelectOnly
      }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
    }
  }], [{
    key: "defaultProps",
    get: function get6() {
      return {
        onDropdownFocus: function onDropdownFocus() {
        },
        monthsShown: 1,
        forceShowMonthNavigation: false,
        timeCaption: "Time",
        previousYearButtonLabel: "Previous Year",
        nextYearButtonLabel: "Next Year",
        previousMonthButtonLabel: "Previous Month",
        nextMonthButtonLabel: "Next Month",
        customTimeInput: null,
        yearItemNumber: DEFAULT_YEAR_ITEM_NUMBER
      };
    }
  }]);
}(React__default.Component);
var CalendarIcon$1 = function CalendarIcon(_ref) {
  var icon = _ref.icon, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, _onClick = _ref.onClick;
  var defaultClass = "react-datepicker__calendar-icon";
  if (/* @__PURE__ */ React__default.isValidElement(icon)) {
    return /* @__PURE__ */ React__default.cloneElement(icon, {
      className: "".concat(icon.props.className || "", " ").concat(defaultClass, " ").concat(className),
      onClick: function onClick(e) {
        if (typeof icon.props.onClick === "function") {
          icon.props.onClick(e);
        }
        if (typeof _onClick === "function") {
          _onClick(e);
        }
      }
    });
  }
  if (typeof icon === "string") {
    return /* @__PURE__ */ React__default.createElement("i", {
      className: "".concat(defaultClass, " ").concat(icon, " ").concat(className),
      "aria-hidden": "true",
      onClick: _onClick
    });
  }
  return /* @__PURE__ */ React__default.createElement("svg", {
    className: "".concat(defaultClass, " ").concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    onClick: _onClick
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
  }));
};
var CalendarIcon$1$1 = CalendarIcon$1;
var Portal$1 = /* @__PURE__ */ function(_React$Component) {
  function Portal2(props) {
    var _this;
    _classCallCheck$1(this, Portal2);
    _this = _callSuper(this, Portal2, [props]);
    _this.el = document.createElement("div");
    return _this;
  }
  _inherits$1(Portal2, _React$Component);
  return _createClass$1(Portal2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId);
      if (!this.portalRoot) {
        this.portalRoot = document.createElement("div");
        this.portalRoot.setAttribute("id", this.props.portalId);
        (this.props.portalHost || document.body).appendChild(this.portalRoot);
      }
      this.portalRoot.appendChild(this.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.portalRoot.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function render() {
      return /* @__PURE__ */ ReactDOM__default.createPortal(this.props.children, this.el);
    }
  }]);
}(React__default.Component);
var focusableElementsSelector = "[tabindex], a, button, input, select, textarea";
var focusableFilter = function focusableFilter2(node2) {
  return !node2.disabled && node2.tabIndex !== -1;
};
var TabLoop = /* @__PURE__ */ function(_React$Component) {
  function TabLoop2(props) {
    var _this;
    _classCallCheck$1(this, TabLoop2);
    _this = _callSuper(this, TabLoop2, [props]);
    _defineProperty$2(_this, "getTabChildren", function() {
      return Array.prototype.slice.call(_this.tabLoopRef.current.querySelectorAll(focusableElementsSelector), 1, -1).filter(focusableFilter);
    });
    _defineProperty$2(_this, "handleFocusStart", function() {
      var tabChildren = _this.getTabChildren();
      tabChildren && tabChildren.length > 1 && tabChildren[tabChildren.length - 1].focus();
    });
    _defineProperty$2(_this, "handleFocusEnd", function() {
      var tabChildren = _this.getTabChildren();
      tabChildren && tabChildren.length > 1 && tabChildren[0].focus();
    });
    _this.tabLoopRef = /* @__PURE__ */ React__default.createRef();
    return _this;
  }
  _inherits$1(TabLoop2, _React$Component);
  return _createClass$1(TabLoop2, [{
    key: "render",
    value: function render() {
      if (!this.props.enableTabLoop) {
        return this.props.children;
      }
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__tab-loop",
        ref: this.tabLoopRef
      }, /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__tab-loop__start",
        tabIndex: "0",
        onFocus: this.handleFocusStart
      }), this.props.children, /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__tab-loop__end",
        tabIndex: "0",
        onFocus: this.handleFocusEnd
      }));
    }
  }], [{
    key: "defaultProps",
    get: function get6() {
      return {
        enableTabLoop: true
      };
    }
  }]);
}(React__default.Component);
function withFloating(Component2) {
  var WithFloating = function WithFloating2(props) {
    var alt_props = _objectSpread2$1(_objectSpread2$1({}, props), {}, {
      popperModifiers: props.popperModifiers || [],
      popperProps: props.popperProps || {},
      hidePopper: typeof props.hidePopper === "boolean" ? props.hidePopper : true
    });
    var arrowRef = React__default.useRef();
    var floatingProps = useFloating(_objectSpread2$1({
      open: !alt_props.hidePopper,
      whileElementsMounted: autoUpdate,
      placement: alt_props.popperPlacement,
      middleware: [flip({
        padding: 15
      }), offset$1(10), arrow$2({
        element: arrowRef
      })].concat(_toConsumableArray$1(alt_props.popperModifiers))
    }, alt_props.popperProps));
    return /* @__PURE__ */ React__default.createElement(Component2, _extends$4({}, alt_props, {
      popperProps: _objectSpread2$1(_objectSpread2$1({}, floatingProps), {}, {
        arrowRef
      })
    }));
  };
  return WithFloating;
}
var PopperComponent = /* @__PURE__ */ function(_React$Component) {
  function PopperComponent2() {
    _classCallCheck$1(this, PopperComponent2);
    return _callSuper(this, PopperComponent2, arguments);
  }
  _inherits$1(PopperComponent2, _React$Component);
  return _createClass$1(PopperComponent2, [{
    key: "render",
    value: function render() {
      var _this$props = this.props, className = _this$props.className, wrapperClassName = _this$props.wrapperClassName, hidePopper = _this$props.hidePopper, popperComponent = _this$props.popperComponent, targetComponent = _this$props.targetComponent, enableTabLoop = _this$props.enableTabLoop, popperOnKeyDown = _this$props.popperOnKeyDown, portalId = _this$props.portalId, portalHost = _this$props.portalHost, popperProps = _this$props.popperProps, showArrow = _this$props.showArrow;
      var popper;
      if (!hidePopper) {
        var classes2 = clsx("react-datepicker-popper", className);
        popper = /* @__PURE__ */ React__default.createElement(TabLoop, {
          enableTabLoop
        }, /* @__PURE__ */ React__default.createElement("div", {
          ref: popperProps.refs.setFloating,
          style: popperProps.floatingStyles,
          className: classes2,
          "data-placement": popperProps.placement,
          onKeyDown: popperOnKeyDown
        }, popperComponent, showArrow && /* @__PURE__ */ React__default.createElement(FloatingArrow, {
          ref: popperProps.arrowRef,
          context: popperProps.context,
          fill: "currentColor",
          strokeWidth: 1,
          height: 8,
          width: 16,
          style: {
            transform: "translateY(-1px)"
          },
          className: "react-datepicker__triangle"
        })));
      }
      if (this.props.popperContainer) {
        popper = /* @__PURE__ */ React__default.createElement(this.props.popperContainer, {}, popper);
      }
      if (portalId && !hidePopper) {
        popper = /* @__PURE__ */ React__default.createElement(Portal$1, {
          portalId,
          portalHost
        }, popper);
      }
      var wrapperClasses = clsx("react-datepicker-wrapper", wrapperClassName);
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", {
        ref: popperProps.refs.setReference,
        className: wrapperClasses
      }, targetComponent), popper);
    }
  }], [{
    key: "defaultProps",
    get: function get6() {
      return {
        hidePopper: true
      };
    }
  }]);
}(React__default.Component);
var PopperComponent$1 = withFloating(PopperComponent);
var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
var WrappedCalendar = onClickOutsideHOC(Calendar);
function hasPreSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
  }
  return date1 !== date2;
}
var INPUT_ERR_1 = "Date input not valid.";
var DatePicker$1 = /* @__PURE__ */ function(_React$Component) {
  function DatePicker2(props) {
    var _this;
    _classCallCheck$1(this, DatePicker2);
    _this = _callSuper(this, DatePicker2, [props]);
    _defineProperty$2(_this, "getPreSelection", function() {
      return _this.props.openToDate ? _this.props.openToDate : _this.props.selectsEnd && _this.props.startDate ? _this.props.startDate : _this.props.selectsStart && _this.props.endDate ? _this.props.endDate : newDate();
    });
    _defineProperty$2(_this, "modifyHolidays", function() {
      var _this$props$holidays;
      return (_this$props$holidays = _this.props.holidays) === null || _this$props$holidays === void 0 ? void 0 : _this$props$holidays.reduce(function(accumulator, holiday) {
        var date = new Date(holiday.date);
        if (!isValid$5(date)) {
          return accumulator;
        }
        return [].concat(_toConsumableArray$1(accumulator), [_objectSpread2$1(_objectSpread2$1({}, holiday), {}, {
          date
        })]);
      }, []);
    });
    _defineProperty$2(_this, "calcInitialState", function() {
      var _ref;
      var defaultPreSelection = _this.getPreSelection();
      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var boundedPreSelection = minDate && isBefore$1(defaultPreSelection, startOfDay(minDate)) ? minDate : maxDate && isAfter$2(defaultPreSelection, endOfDay(maxDate)) ? maxDate : defaultPreSelection;
      return {
        open: _this.props.startOpen || false,
        preventFocus: false,
        preSelection: (_ref = _this.props.selectsRange ? _this.props.startDate : _this.props.selected) !== null && _ref !== void 0 ? _ref : boundedPreSelection,
        // transforming highlighted days (perhaps nested array)
        // to flat Map for faster access in day.jsx
        highlightDates: getHightLightDaysMap(_this.props.highlightDates),
        focused: false,
        // used to focus day in inline version after month has changed, but not on
        // initial render
        shouldFocusDayInline: false,
        isRenderAriaLiveMessage: false
      };
    });
    _defineProperty$2(_this, "clearPreventFocusTimeout", function() {
      if (_this.preventFocusTimeout) {
        clearTimeout(_this.preventFocusTimeout);
      }
    });
    _defineProperty$2(_this, "setFocus", function() {
      if (_this.input && _this.input.focus) {
        _this.input.focus({
          preventScroll: true
        });
      }
    });
    _defineProperty$2(_this, "setBlur", function() {
      if (_this.input && _this.input.blur) {
        _this.input.blur();
      }
      _this.cancelFocusInput();
    });
    _defineProperty$2(_this, "setOpen", function(open) {
      var skipSetBlur = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      _this.setState({
        open,
        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
      }, function() {
        if (!open) {
          _this.setState(function(prev2) {
            return {
              focused: skipSetBlur ? prev2.focused : false
            };
          }, function() {
            !skipSetBlur && _this.setBlur();
            _this.setState({
              inputValue: null
            });
          });
        }
      });
    });
    _defineProperty$2(_this, "inputOk", function() {
      return isDate$1(_this.state.preSelection);
    });
    _defineProperty$2(_this, "isCalendarOpen", function() {
      return _this.props.open === void 0 ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
    });
    _defineProperty$2(_this, "handleFocus", function(event) {
      if (!_this.state.preventFocus) {
        _this.props.onFocus(event);
        if (!_this.props.preventOpenOnFocus && !_this.props.readOnly) {
          _this.setOpen(true);
        }
      }
      _this.setState({
        focused: true
      });
    });
    _defineProperty$2(_this, "sendFocusBackToInput", function() {
      if (_this.preventFocusTimeout) {
        _this.clearPreventFocusTimeout();
      }
      _this.setState({
        preventFocus: true
      }, function() {
        _this.preventFocusTimeout = setTimeout(function() {
          _this.setFocus();
          _this.setState({
            preventFocus: false
          });
        });
      });
    });
    _defineProperty$2(_this, "cancelFocusInput", function() {
      clearTimeout(_this.inputFocusTimeout);
      _this.inputFocusTimeout = null;
    });
    _defineProperty$2(_this, "deferFocusInput", function() {
      _this.cancelFocusInput();
      _this.inputFocusTimeout = setTimeout(function() {
        return _this.setFocus();
      }, 1);
    });
    _defineProperty$2(_this, "handleDropdownFocus", function() {
      _this.cancelFocusInput();
    });
    _defineProperty$2(_this, "handleBlur", function(event) {
      if (!_this.state.open || _this.props.withPortal || _this.props.showTimeInput) {
        _this.props.onBlur(event);
      }
      _this.setState({
        focused: false
      });
    });
    _defineProperty$2(_this, "handleCalendarClickOutside", function(event) {
      if (!_this.props.inline) {
        _this.setOpen(false);
      }
      _this.props.onClickOutside(event);
      if (_this.props.withPortal) {
        event.preventDefault();
      }
    });
    _defineProperty$2(_this, "handleChange", function() {
      for (var _len = arguments.length, allArgs = new Array(_len), _key = 0; _key < _len; _key++) {
        allArgs[_key] = arguments[_key];
      }
      var event = allArgs[0];
      if (_this.props.onChangeRaw) {
        _this.props.onChangeRaw.apply(_this, allArgs);
        if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
          return;
        }
      }
      _this.setState({
        inputValue: event.target.value,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_INPUT
      });
      var date = parseDate(event.target.value, _this.props.dateFormat, _this.props.locale, _this.props.strictParsing, _this.props.minDate);
      if (_this.props.showTimeSelectOnly && _this.props.selected && date && !isSameDay(date, _this.props.selected)) {
        date = set$2(_this.props.selected, {
          hours: getHours(date),
          minutes: getMinutes(date),
          seconds: getSeconds(date)
        });
      }
      if (date || !event.target.value) {
        _this.setSelected(date, event, true);
      }
    });
    _defineProperty$2(_this, "handleSelect", function(date, event, monthSelectedIn) {
      if (_this.props.shouldCloseOnSelect && !_this.props.showTimeSelect) {
        _this.sendFocusBackToInput();
      }
      if (_this.props.onChangeRaw) {
        _this.props.onChangeRaw(event);
      }
      _this.setSelected(date, event, false, monthSelectedIn);
      if (_this.props.showDateSelect) {
        _this.setState({
          isRenderAriaLiveMessage: true
        });
      }
      if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
        _this.setPreSelection(date);
      } else if (!_this.props.inline) {
        if (!_this.props.selectsRange) {
          _this.setOpen(false);
        }
        var _this$props = _this.props, startDate = _this$props.startDate, endDate = _this$props.endDate;
        if (startDate && !endDate && (_this.props.swapRange || !isDateBefore(date, startDate))) {
          _this.setOpen(false);
        }
      }
    });
    _defineProperty$2(_this, "setSelected", function(date, event, keepInput, monthSelectedIn) {
      var changedDate = date;
      if (_this.props.showYearPicker) {
        if (changedDate !== null && isYearDisabled(getYear(changedDate), _this.props)) {
          return;
        }
      } else if (_this.props.showMonthYearPicker) {
        if (changedDate !== null && isMonthDisabled(changedDate, _this.props)) {
          return;
        }
      } else {
        if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
          return;
        }
      }
      var _this$props2 = _this.props, onChange = _this$props2.onChange, selectsRange = _this$props2.selectsRange, startDate = _this$props2.startDate, endDate = _this$props2.endDate, selectsMultiple = _this$props2.selectsMultiple, selectedDates = _this$props2.selectedDates, minTime = _this$props2.minTime, swapRange = _this$props2.swapRange;
      if (!isEqual$3(_this.props.selected, changedDate) || _this.props.allowSameDay || selectsRange || selectsMultiple) {
        if (changedDate !== null) {
          if (_this.props.selected && (!keepInput || !_this.props.showTimeSelect && !_this.props.showTimeSelectOnly && !_this.props.showTimeInput)) {
            changedDate = setTime(changedDate, {
              hour: getHours(_this.props.selected),
              minute: getMinutes(_this.props.selected),
              second: getSeconds(_this.props.selected)
            });
          }
          if (!keepInput && (_this.props.showTimeSelect || _this.props.showTimeSelectOnly)) {
            if (minTime) {
              changedDate = setTime(changedDate, {
                hour: minTime.getHours(),
                minute: minTime.getMinutes(),
                second: minTime.getSeconds()
              });
            }
          }
          if (!_this.props.inline) {
            _this.setState({
              preSelection: changedDate
            });
          }
          if (!_this.props.focusSelectedMonth) {
            _this.setState({
              monthSelectedIn
            });
          }
        }
        if (selectsRange) {
          var noRanges = !startDate && !endDate;
          var hasStartRange = startDate && !endDate;
          var isRangeFilled = startDate && endDate;
          if (noRanges) {
            onChange([changedDate, null], event);
          } else if (hasStartRange) {
            if (changedDate === null) {
              onChange([null, null], event);
            } else if (isDateBefore(changedDate, startDate)) {
              if (swapRange) {
                onChange([changedDate, startDate], event);
              } else {
                onChange([changedDate, null], event);
              }
            } else {
              onChange([startDate, changedDate], event);
            }
          }
          if (isRangeFilled) {
            onChange([changedDate, null], event);
          }
        } else if (selectsMultiple) {
          if (!(selectedDates !== null && selectedDates !== void 0 && selectedDates.length)) {
            onChange([changedDate], event);
          } else {
            var isChangedDateAlreadySelected = selectedDates.some(function(selectedDate) {
              return isSameDay(selectedDate, changedDate);
            });
            if (isChangedDateAlreadySelected) {
              var nextDates = selectedDates.filter(function(selectedDate) {
                return !isSameDay(selectedDate, changedDate);
              });
              onChange(nextDates, event);
            } else {
              onChange([].concat(_toConsumableArray$1(selectedDates), [changedDate]), event);
            }
          }
        } else {
          onChange(changedDate, event);
        }
      }
      if (!keepInput) {
        _this.props.onSelect(changedDate, event);
        _this.setState({
          inputValue: null
        });
      }
    });
    _defineProperty$2(_this, "setPreSelection", function(date) {
      var hasMinDate = typeof _this.props.minDate !== "undefined";
      var hasMaxDate = typeof _this.props.maxDate !== "undefined";
      var isValidDateSelection = true;
      if (date) {
        var dateStartOfDay = startOfDay(date);
        if (hasMinDate && hasMaxDate) {
          isValidDateSelection = isDayInRange(date, _this.props.minDate, _this.props.maxDate);
        } else if (hasMinDate) {
          var minDateStartOfDay = startOfDay(_this.props.minDate);
          isValidDateSelection = isAfter$2(date, minDateStartOfDay) || isEqual$3(dateStartOfDay, minDateStartOfDay);
        } else if (hasMaxDate) {
          var maxDateEndOfDay = endOfDay(_this.props.maxDate);
          isValidDateSelection = isBefore$1(date, maxDateEndOfDay) || isEqual$3(dateStartOfDay, maxDateEndOfDay);
        }
      }
      if (isValidDateSelection) {
        _this.setState({
          preSelection: date
        });
      }
    });
    _defineProperty$2(_this, "toggleCalendar", function() {
      _this.setOpen(!_this.state.open);
    });
    _defineProperty$2(_this, "handleTimeChange", function(time) {
      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
      var changedDate = _this.props.selected ? time : setTime(selected, {
        hour: getHours(time),
        minute: getMinutes(time)
      });
      _this.setState({
        preSelection: changedDate
      });
      _this.props.onChange(changedDate);
      if (_this.props.shouldCloseOnSelect) {
        _this.sendFocusBackToInput();
        _this.setOpen(false);
      }
      if (_this.props.showTimeInput) {
        _this.setOpen(true);
      }
      if (_this.props.showTimeSelectOnly || _this.props.showTimeSelect) {
        _this.setState({
          isRenderAriaLiveMessage: true
        });
      }
      _this.setState({
        inputValue: null
      });
    });
    _defineProperty$2(_this, "onInputClick", function() {
      if (!_this.props.disabled && !_this.props.readOnly) {
        _this.setOpen(true);
      }
      _this.props.onInputClick();
    });
    _defineProperty$2(_this, "onInputKeyDown", function(event) {
      _this.props.onKeyDown(event);
      var eventKey = event.key;
      if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
        if (eventKey === "ArrowDown" || eventKey === "ArrowUp" || eventKey === "Enter") {
          _this.onInputClick();
        }
        return;
      }
      if (_this.state.open) {
        if (eventKey === "ArrowDown" || eventKey === "ArrowUp") {
          event.preventDefault();
          var selectorString = _this.props.showWeekPicker && _this.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : _this.props.showFullMonthYearPicker || _this.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]';
          var selectedItem = _this.calendar.componentNode && _this.calendar.componentNode.querySelector(selectorString);
          selectedItem && selectedItem.focus({
            preventScroll: true
          });
          return;
        }
        var copy2 = newDate(_this.state.preSelection);
        if (eventKey === "Enter") {
          event.preventDefault();
          if (_this.inputOk() && _this.state.lastPreSelectChange === PRESELECT_CHANGE_VIA_NAVIGATE) {
            _this.handleSelect(copy2, event);
            !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy2);
          } else {
            _this.setOpen(false);
          }
        } else if (eventKey === "Escape") {
          event.preventDefault();
          _this.sendFocusBackToInput();
          _this.setOpen(false);
        } else if (eventKey === "Tab") {
          _this.setOpen(false);
        }
        if (!_this.inputOk()) {
          _this.props.onInputError({
            code: 1,
            msg: INPUT_ERR_1
          });
        }
      }
    });
    _defineProperty$2(_this, "onPortalKeyDown", function(event) {
      var eventKey = event.key;
      if (eventKey === "Escape") {
        event.preventDefault();
        _this.setState({
          preventFocus: true
        }, function() {
          _this.setOpen(false);
          setTimeout(function() {
            _this.setFocus();
            _this.setState({
              preventFocus: false
            });
          });
        });
      }
    });
    _defineProperty$2(_this, "onDayKeyDown", function(event) {
      _this.props.onKeyDown(event);
      var eventKey = event.key;
      var isShiftKeyActive = event.shiftKey;
      var copy2 = newDate(_this.state.preSelection);
      if (eventKey === "Enter") {
        event.preventDefault();
        _this.handleSelect(copy2, event);
        !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy2);
      } else if (eventKey === "Escape") {
        event.preventDefault();
        _this.setOpen(false);
        if (!_this.inputOk()) {
          _this.props.onInputError({
            code: 1,
            msg: INPUT_ERR_1
          });
        }
      } else if (!_this.props.disabledKeyboardNavigation) {
        var newSelection;
        switch (eventKey) {
          case "ArrowLeft":
            if (_this.props.showWeekPicker) {
              newSelection = subWeeks(copy2);
            } else {
              newSelection = subDays(copy2);
            }
            break;
          case "ArrowRight":
            if (_this.props.showWeekPicker) {
              newSelection = addWeeks(copy2, 1);
            } else {
              newSelection = addDays(copy2, 1);
            }
            break;
          case "ArrowUp":
            newSelection = subWeeks(copy2);
            break;
          case "ArrowDown":
            newSelection = addWeeks(copy2, 1);
            break;
          case "PageUp":
            newSelection = isShiftKeyActive ? subYears(copy2, 1) : subMonths(copy2, 1);
            break;
          case "PageDown":
            newSelection = isShiftKeyActive ? addYears(copy2, 1) : addMonths(copy2, 1);
            break;
          case "Home":
            newSelection = getStartOfWeek(copy2, _this.props.locale, _this.props.calendarStartDay);
            break;
          case "End":
            newSelection = getEndOfWeek(copy2);
            break;
          default:
            newSelection = null;
            break;
        }
        if (!newSelection) {
          if (_this.props.onInputError) {
            _this.props.onInputError({
              code: 1,
              msg: INPUT_ERR_1
            });
          }
          return;
        }
        event.preventDefault();
        _this.setState({
          lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
        });
        if (_this.props.adjustDateOnChange) {
          _this.setSelected(newSelection);
        }
        _this.setPreSelection(newSelection);
        if (_this.props.inline) {
          var prevMonth = getMonth(copy2);
          var newMonth = getMonth(newSelection);
          var prevYear = getYear(copy2);
          var newYear = getYear(newSelection);
          if (prevMonth !== newMonth || prevYear !== newYear) {
            _this.setState({
              shouldFocusDayInline: true
            });
          } else {
            _this.setState({
              shouldFocusDayInline: false
            });
          }
        }
      }
    });
    _defineProperty$2(_this, "onPopperKeyDown", function(event) {
      var eventKey = event.key;
      if (eventKey === "Escape") {
        event.preventDefault();
        _this.sendFocusBackToInput();
      }
    });
    _defineProperty$2(_this, "onClearClick", function(event) {
      if (event) {
        if (event.preventDefault) {
          event.preventDefault();
        }
      }
      _this.sendFocusBackToInput();
      if (_this.props.selectsRange) {
        _this.props.onChange([null, null], event);
      } else {
        _this.props.onChange(null, event);
      }
      _this.setState({
        inputValue: null
      });
    });
    _defineProperty$2(_this, "clear", function() {
      _this.onClearClick();
    });
    _defineProperty$2(_this, "onScroll", function(event) {
      if (typeof _this.props.closeOnScroll === "boolean" && _this.props.closeOnScroll) {
        if (event.target === document || event.target === document.documentElement || event.target === document.body) {
          _this.setOpen(false);
        }
      } else if (typeof _this.props.closeOnScroll === "function") {
        if (_this.props.closeOnScroll(event)) {
          _this.setOpen(false);
        }
      }
    });
    _defineProperty$2(_this, "renderCalendar", function() {
      if (!_this.props.inline && !_this.isCalendarOpen()) {
        return null;
      }
      return /* @__PURE__ */ React__default.createElement(WrappedCalendar, {
        ref: function ref2(elem) {
          _this.calendar = elem;
        },
        locale: _this.props.locale,
        calendarStartDay: _this.props.calendarStartDay,
        chooseDayAriaLabelPrefix: _this.props.chooseDayAriaLabelPrefix,
        disabledDayAriaLabelPrefix: _this.props.disabledDayAriaLabelPrefix,
        weekAriaLabelPrefix: _this.props.weekAriaLabelPrefix,
        monthAriaLabelPrefix: _this.props.monthAriaLabelPrefix,
        adjustDateOnChange: _this.props.adjustDateOnChange,
        setOpen: _this.setOpen,
        shouldCloseOnSelect: _this.props.shouldCloseOnSelect,
        dateFormat: _this.props.dateFormatCalendar,
        useWeekdaysShort: _this.props.useWeekdaysShort,
        formatWeekDay: _this.props.formatWeekDay,
        dropdownMode: _this.props.dropdownMode,
        selected: _this.props.selected,
        preSelection: _this.state.preSelection,
        onSelect: _this.handleSelect,
        onWeekSelect: _this.props.onWeekSelect,
        openToDate: _this.props.openToDate,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        selectsStart: _this.props.selectsStart,
        selectsEnd: _this.props.selectsEnd,
        selectsRange: _this.props.selectsRange,
        selectsMultiple: _this.props.selectsMultiple,
        selectedDates: _this.props.selectedDates,
        startDate: _this.props.startDate,
        endDate: _this.props.endDate,
        excludeDates: _this.props.excludeDates,
        excludeDateIntervals: _this.props.excludeDateIntervals,
        filterDate: _this.props.filterDate,
        onClickOutside: _this.handleCalendarClickOutside,
        formatWeekNumber: _this.props.formatWeekNumber,
        highlightDates: _this.state.highlightDates,
        holidays: getHolidaysMap(_this.modifyHolidays()),
        includeDates: _this.props.includeDates,
        includeDateIntervals: _this.props.includeDateIntervals,
        includeTimes: _this.props.includeTimes,
        injectTimes: _this.props.injectTimes,
        inline: _this.props.inline,
        shouldFocusDayInline: _this.state.shouldFocusDayInline,
        peekNextMonth: _this.props.peekNextMonth,
        showMonthDropdown: _this.props.showMonthDropdown,
        showPreviousMonths: _this.props.showPreviousMonths,
        useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
        showMonthYearDropdown: _this.props.showMonthYearDropdown,
        showWeekNumbers: _this.props.showWeekNumbers,
        showYearDropdown: _this.props.showYearDropdown,
        withPortal: _this.props.withPortal,
        forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
        showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
        todayButton: _this.props.todayButton,
        weekLabel: _this.props.weekLabel,
        outsideClickIgnoreClass,
        fixedHeight: _this.props.fixedHeight,
        monthsShown: _this.props.monthsShown,
        monthSelectedIn: _this.state.monthSelectedIn,
        onDropdownFocus: _this.handleDropdownFocus,
        onMonthChange: _this.props.onMonthChange,
        onYearChange: _this.props.onYearChange,
        dayClassName: _this.props.dayClassName,
        weekDayClassName: _this.props.weekDayClassName,
        monthClassName: _this.props.monthClassName,
        timeClassName: _this.props.timeClassName,
        showDateSelect: _this.props.showDateSelect,
        showTimeSelect: _this.props.showTimeSelect,
        showTimeSelectOnly: _this.props.showTimeSelectOnly,
        onTimeChange: _this.handleTimeChange,
        timeFormat: _this.props.timeFormat,
        timeIntervals: _this.props.timeIntervals,
        minTime: _this.props.minTime,
        maxTime: _this.props.maxTime,
        excludeTimes: _this.props.excludeTimes,
        filterTime: _this.props.filterTime,
        timeCaption: _this.props.timeCaption,
        className: _this.props.calendarClassName,
        container: _this.props.calendarContainer,
        yearItemNumber: _this.props.yearItemNumber,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber,
        previousMonthAriaLabel: _this.props.previousMonthAriaLabel,
        previousMonthButtonLabel: _this.props.previousMonthButtonLabel,
        nextMonthAriaLabel: _this.props.nextMonthAriaLabel,
        nextMonthButtonLabel: _this.props.nextMonthButtonLabel,
        previousYearAriaLabel: _this.props.previousYearAriaLabel,
        previousYearButtonLabel: _this.props.previousYearButtonLabel,
        nextYearAriaLabel: _this.props.nextYearAriaLabel,
        nextYearButtonLabel: _this.props.nextYearButtonLabel,
        timeInputLabel: _this.props.timeInputLabel,
        disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
        renderCustomHeader: _this.props.renderCustomHeader,
        popperProps: _this.props.popperProps,
        renderDayContents: _this.props.renderDayContents,
        renderMonthContent: _this.props.renderMonthContent,
        renderQuarterContent: _this.props.renderQuarterContent,
        renderYearContent: _this.props.renderYearContent,
        onDayMouseEnter: _this.props.onDayMouseEnter,
        onMonthMouseLeave: _this.props.onMonthMouseLeave,
        onYearMouseEnter: _this.props.onYearMouseEnter,
        onYearMouseLeave: _this.props.onYearMouseLeave,
        selectsDisabledDaysInRange: _this.props.selectsDisabledDaysInRange,
        showTimeInput: _this.props.showTimeInput,
        showMonthYearPicker: _this.props.showMonthYearPicker,
        showFullMonthYearPicker: _this.props.showFullMonthYearPicker,
        showTwoColumnMonthYearPicker: _this.props.showTwoColumnMonthYearPicker,
        showFourColumnMonthYearPicker: _this.props.showFourColumnMonthYearPicker,
        showYearPicker: _this.props.showYearPicker,
        showQuarterYearPicker: _this.props.showQuarterYearPicker,
        showWeekPicker: _this.props.showWeekPicker,
        excludeScrollbar: _this.props.excludeScrollbar,
        handleOnKeyDown: _this.props.onKeyDown,
        handleOnDayKeyDown: _this.onDayKeyDown,
        isInputFocused: _this.state.focused,
        customTimeInput: _this.props.customTimeInput,
        setPreSelection: _this.setPreSelection,
        usePointerEvent: _this.props.usePointerEvent,
        yearClassName: _this.props.yearClassName
      }, _this.props.children);
    });
    _defineProperty$2(_this, "renderAriaLiveRegion", function() {
      var _this$props3 = _this.props, dateFormat = _this$props3.dateFormat, locale2 = _this$props3.locale;
      var isContainsTime = _this.props.showTimeInput || _this.props.showTimeSelect;
      var longDateFormat2 = isContainsTime ? "PPPPp" : "PPPP";
      var ariaLiveMessage;
      if (_this.props.selectsRange) {
        ariaLiveMessage = "Selected start date: ".concat(safeDateFormat(_this.props.startDate, {
          dateFormat: longDateFormat2,
          locale: locale2
        }), ". ").concat(_this.props.endDate ? "End date: " + safeDateFormat(_this.props.endDate, {
          dateFormat: longDateFormat2,
          locale: locale2
        }) : "");
      } else {
        if (_this.props.showTimeSelectOnly) {
          ariaLiveMessage = "Selected time: ".concat(safeDateFormat(_this.props.selected, {
            dateFormat,
            locale: locale2
          }));
        } else if (_this.props.showYearPicker) {
          ariaLiveMessage = "Selected year: ".concat(safeDateFormat(_this.props.selected, {
            dateFormat: "yyyy",
            locale: locale2
          }));
        } else if (_this.props.showMonthYearPicker) {
          ariaLiveMessage = "Selected month: ".concat(safeDateFormat(_this.props.selected, {
            dateFormat: "MMMM yyyy",
            locale: locale2
          }));
        } else if (_this.props.showQuarterYearPicker) {
          ariaLiveMessage = "Selected quarter: ".concat(safeDateFormat(_this.props.selected, {
            dateFormat: "yyyy, QQQ",
            locale: locale2
          }));
        } else {
          ariaLiveMessage = "Selected date: ".concat(safeDateFormat(_this.props.selected, {
            dateFormat: longDateFormat2,
            locale: locale2
          }));
        }
      }
      return /* @__PURE__ */ React__default.createElement("span", {
        role: "alert",
        "aria-live": "polite",
        className: "react-datepicker__aria-live"
      }, ariaLiveMessage);
    });
    _defineProperty$2(_this, "renderDateInput", function() {
      var _React$cloneElement;
      var className = clsx(_this.props.className, _defineProperty$2({}, outsideClickIgnoreClass, _this.state.open));
      var customInput = _this.props.customInput || /* @__PURE__ */ React__default.createElement("input", {
        type: "text"
      });
      var customInputRef = _this.props.customInputRef || "ref";
      var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : _this.props.selectsRange ? safeDateRangeFormat(_this.props.startDate, _this.props.endDate, _this.props) : _this.props.selectsMultiple ? safeMultipleDatesFormat(_this.props.selectedDates, _this.props) : safeDateFormat(_this.props.selected, _this.props);
      return /* @__PURE__ */ React__default.cloneElement(customInput, (_React$cloneElement = {}, _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_React$cloneElement, customInputRef, function(input) {
        _this.input = input;
      }), "value", inputValue), "onBlur", _this.handleBlur), "onChange", _this.handleChange), "onClick", _this.onInputClick), "onFocus", _this.handleFocus), "onKeyDown", _this.onInputKeyDown), "id", _this.props.id), "name", _this.props.name), "form", _this.props.form), _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_React$cloneElement, "autoFocus", _this.props.autoFocus), "placeholder", _this.props.placeholderText), "disabled", _this.props.disabled), "autoComplete", _this.props.autoComplete), "className", clsx(customInput.props.className, className)), "title", _this.props.title), "readOnly", _this.props.readOnly), "required", _this.props.required), "tabIndex", _this.props.tabIndex), "aria-describedby", _this.props.ariaDescribedBy), _defineProperty$2(_defineProperty$2(_defineProperty$2(_React$cloneElement, "aria-invalid", _this.props.ariaInvalid), "aria-labelledby", _this.props.ariaLabelledBy), "aria-required", _this.props.ariaRequired)));
    });
    _defineProperty$2(_this, "renderClearButton", function() {
      var _this$props4 = _this.props, isClearable = _this$props4.isClearable, disabled = _this$props4.disabled, selected = _this$props4.selected, startDate = _this$props4.startDate, endDate = _this$props4.endDate, clearButtonTitle = _this$props4.clearButtonTitle, _this$props4$clearBut = _this$props4.clearButtonClassName, clearButtonClassName = _this$props4$clearBut === void 0 ? "" : _this$props4$clearBut, _this$props4$ariaLabe = _this$props4.ariaLabelClose, ariaLabelClose = _this$props4$ariaLabe === void 0 ? "Close" : _this$props4$ariaLabe, selectedDates = _this$props4.selectedDates;
      if (isClearable && (selected != null || startDate != null || endDate != null || selectedDates !== null && selectedDates !== void 0 && selectedDates.length)) {
        return /* @__PURE__ */ React__default.createElement("button", {
          type: "button",
          className: clsx("react-datepicker__close-icon", clearButtonClassName, {
            "react-datepicker__close-icon--disabled": disabled
          }),
          disabled,
          "aria-label": ariaLabelClose,
          onClick: _this.onClearClick,
          title: clearButtonTitle,
          tabIndex: -1
        });
      } else {
        return null;
      }
    });
    _this.state = _this.calcInitialState();
    _this.preventFocusTimeout = null;
    return _this;
  }
  _inherits$1(DatePicker2, _React$Component);
  return _createClass$1(DatePicker2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("scroll", this.onScroll, true);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.inline && hasPreSelectionChanged(prevProps.selected, this.props.selected)) {
        this.setPreSelection(this.props.selected);
      }
      if (this.state.monthSelectedIn !== void 0 && prevProps.monthsShown !== this.props.monthsShown) {
        this.setState({
          monthSelectedIn: 0
        });
      }
      if (prevProps.highlightDates !== this.props.highlightDates) {
        this.setState({
          highlightDates: getHightLightDaysMap(this.props.highlightDates)
        });
      }
      if (!prevState.focused && !isEqual$3(prevProps.selected, this.props.selected)) {
        this.setState({
          inputValue: null
        });
      }
      if (prevState.open !== this.state.open) {
        if (prevState.open === false && this.state.open === true) {
          this.props.onCalendarOpen();
        }
        if (prevState.open === true && this.state.open === false) {
          this.props.onCalendarClose();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearPreventFocusTimeout();
      window.removeEventListener("scroll", this.onScroll, true);
    }
  }, {
    key: "renderInputContainer",
    value: function renderInputContainer() {
      var _this$props5 = this.props, showIcon = _this$props5.showIcon, icon = _this$props5.icon, calendarIconClassname = _this$props5.calendarIconClassname, toggleCalendarOnIconClick = _this$props5.toggleCalendarOnIconClick;
      var open = this.state.open;
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "react-datepicker__input-container".concat(showIcon ? " react-datepicker__view-calendar-icon" : "")
      }, showIcon && /* @__PURE__ */ React__default.createElement(CalendarIcon$1$1, _extends$4({
        icon,
        className: "".concat(calendarIconClassname, " ").concat(open && "react-datepicker-ignore-onclickoutside")
      }, toggleCalendarOnIconClick ? {
        onClick: this.toggleCalendar
      } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
    }
  }, {
    key: "render",
    value: function render() {
      var calendar2 = this.renderCalendar();
      if (this.props.inline) return calendar2;
      if (this.props.withPortal) {
        var portalContainer = this.state.open ? /* @__PURE__ */ React__default.createElement(TabLoop, {
          enableTabLoop: this.props.enableTabLoop
        }, /* @__PURE__ */ React__default.createElement("div", {
          className: "react-datepicker__portal",
          tabIndex: -1,
          onKeyDown: this.onPortalKeyDown
        }, calendar2)) : null;
        if (this.state.open && this.props.portalId) {
          portalContainer = /* @__PURE__ */ React__default.createElement(Portal$1, {
            portalId: this.props.portalId,
            portalHost: this.props.portalHost
          }, portalContainer);
        }
        return /* @__PURE__ */ React__default.createElement("div", null, this.renderInputContainer(), portalContainer);
      }
      return /* @__PURE__ */ React__default.createElement(PopperComponent$1, {
        className: this.props.popperClassName,
        wrapperClassName: this.props.wrapperClassName,
        hidePopper: !this.isCalendarOpen(),
        portalId: this.props.portalId,
        portalHost: this.props.portalHost,
        popperModifiers: this.props.popperModifiers,
        targetComponent: this.renderInputContainer(),
        popperContainer: this.props.popperContainer,
        popperComponent: calendar2,
        popperPlacement: this.props.popperPlacement,
        popperProps: this.props.popperProps,
        popperOnKeyDown: this.onPopperKeyDown,
        enableTabLoop: this.props.enableTabLoop,
        showArrow: this.props.showPopperArrow
      });
    }
  }], [{
    key: "defaultProps",
    get: function get6() {
      return {
        allowSameDay: false,
        dateFormat: "MM/dd/yyyy",
        dateFormatCalendar: "LLLL yyyy",
        onChange: function onChange() {
        },
        disabled: false,
        disabledKeyboardNavigation: false,
        dropdownMode: "scroll",
        onFocus: function onFocus() {
        },
        onBlur: function onBlur() {
        },
        onKeyDown: function onKeyDown() {
        },
        onInputClick: function onInputClick() {
        },
        onSelect: function onSelect() {
        },
        onClickOutside: function onClickOutside() {
        },
        onMonthChange: function onMonthChange() {
        },
        onCalendarOpen: function onCalendarOpen() {
        },
        onCalendarClose: function onCalendarClose() {
        },
        preventOpenOnFocus: false,
        onYearChange: function onYearChange() {
        },
        onInputError: function onInputError() {
        },
        monthsShown: 1,
        readOnly: false,
        withPortal: false,
        selectsDisabledDaysInRange: false,
        shouldCloseOnSelect: true,
        showTimeSelect: false,
        showTimeInput: false,
        showPreviousMonths: false,
        showMonthYearPicker: false,
        showFullMonthYearPicker: false,
        showTwoColumnMonthYearPicker: false,
        showFourColumnMonthYearPicker: false,
        showYearPicker: false,
        showQuarterYearPicker: false,
        showWeekPicker: false,
        strictParsing: false,
        swapRange: false,
        timeIntervals: 30,
        timeCaption: "Time",
        previousMonthAriaLabel: "Previous Month",
        previousMonthButtonLabel: "Previous Month",
        nextMonthAriaLabel: "Next Month",
        nextMonthButtonLabel: "Next Month",
        previousYearAriaLabel: "Previous Year",
        previousYearButtonLabel: "Previous Year",
        nextYearAriaLabel: "Next Year",
        nextYearButtonLabel: "Next Year",
        timeInputLabel: "Time",
        enableTabLoop: true,
        yearItemNumber: DEFAULT_YEAR_ITEM_NUMBER,
        focusSelectedMonth: false,
        showPopperArrow: true,
        excludeScrollbar: true,
        customTimeInput: null,
        calendarStartDay: void 0,
        toggleCalendarOnIconClick: false,
        usePointerEvent: false
      };
    }
  }]);
}(React__default.Component);
var PRESELECT_CHANGE_VIA_INPUT = "input";
var PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";
const DatePicker = ({
  selectedDate,
  onChange,
  usePortal = false,
  isClearable = false,
  showPopperArrow = false,
  ...props
}) => {
  const isLight = useColorMode().colorMode === "light";
  return (
    // if you don't want to use chakra's colors or you just want to use the original ones,
    // set className to "light-theme-original" ↓↓↓↓
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: isLight ? "light-theme" : "dark-theme", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      DatePicker$1,
      {
        selected: selectedDate,
        onChange: (date) => {
          if (date === null) {
            if (isClearable) {
              onChange(void 0);
            }
          } else if (!Array.isArray(date)) {
            onChange(date);
          } else {
            onChange(void 0);
          }
        },
        isClearable,
        popperContainer: usePortal ? (props2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Portal$2, { children: props2.children }) : void 0,
        showPopperArrow,
        className: "react-datepicker__input-text",
        ...props
      }
    ) })
  );
};
const formatWithoutTz$1 = "yyyy-MM-dd HH:mm:ss.SSS";
const zeroPad$1 = (date) => String(Math.abs(date)).padStart(2, "0");
const plusOrMinus$1 = (date) => date < 0 ? "-" : "+";
const utcOffSetMillisecondsToFormatString$1 = (utcOffsetMs) => {
  const utcOffsetSeconds = utcOffsetMs / 1e3;
  const utcOffsetHours = utcOffsetSeconds / 3600;
  const utcOffsetMinutes = utcOffsetSeconds % 3600 / 60;
  return `${plusOrMinus$1(utcOffsetHours)}${zeroPad$1(utcOffsetHours)}:${zeroPad$1(
    utcOffsetMinutes
  )}`;
};
const setLocalZone$1 = (date, timezone) => {
  const dateInZone = toZonedTime(date, timezone);
  const dateInZoneFormattedWithoutZone = format$2(dateInZone, formatWithoutTz$1);
  const localZone = format$2(
    parse$4(dateInZoneFormattedWithoutZone, formatWithoutTz$1, /* @__PURE__ */ new Date()),
    "X"
  );
  return new Date(dateInZoneFormattedWithoutZone + localZone);
};
const setOtherZone$1 = (date, timezone) => {
  const dateWithoutZone = format$2(date, formatWithoutTz$1);
  const offset3 = getTimezoneOffset(timezone, date);
  const offsetFormatted = utcOffSetMillisecondsToFormatString$1(offset3);
  return new Date(dateWithoutZone + offsetFormatted);
};
const TimeZoneMappingDatePicker$1 = ({
  timezone,
  onChange,
  selectedDate,
  ...props
}) => timezone !== void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
  DatePicker,
  {
    selectedDate: selectedDate ? setLocalZone$1(selectedDate, timezone) : void 0,
    onChange: (v2) => {
      onChange(v2 ? setOtherZone$1(v2, timezone) : void 0);
    },
    ...props
  }
) : /* @__PURE__ */ jsxRuntimeExports.jsx(DatePicker, { selectedDate, onChange, ...props });
const TicketTypeRow$1 = ({
  ticketType,
  index: index2,
  onChange,
  onDelete,
  onEditMeta
}) => {
  const { formSettings } = useRegForm();
  const [name2, setName] = useState(ticketType.name);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PublicDraggable, { draggableId: ticketType.id.toString(), index: index2, children: (provided, snapshot) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Tr,
    {
      display: snapshot.isDragging ? "table" : "table-row",
      ref: provided.innerRef,
      ...provided.draggableProps,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "10%", ...provided.dragHandleProps, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pl: 4, pb: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DragHandleIcon, { color: "gray.500" }) }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "25%", px: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { minWidth: 200, pl: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Editable$1,
          {
            value: name2,
            placeholder: ticketTypeDefaults.name,
            onChange: (newName) => {
              setName(newName);
              if (newName !== "") {
                onChange({ ...ticketType, name: newName });
              }
            },
            onBlur: () => {
              if (name2 === "") {
                onChange({ ...ticketType, name: ticketTypeDefaults.name });
              }
            },
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(EditablePreview, {}),
              /* @__PURE__ */ jsxRuntimeExports.jsx(EditableInput, { maxLength: 100 })
            ]
          }
        ) }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "25%", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "flex-start", m: 0, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            TimeZoneMappingDatePicker$1,
            {
              isClearable: true,
              clearButtonTitle: "Clear",
              placeholderText: "From",
              selectsStart: true,
              startDate: ticketType.availableFrom,
              endDate: ticketType.availableTo,
              maxDate: ticketType.availableTo,
              onChange: (availableFrom) => {
                console.log("available from change", availableFrom);
                onChange({ ...ticketType, availableFrom });
              },
              selectedDate: ticketType.availableFrom,
              dateFormat: `${formSettings.dateFormat} HH:mm`,
              showTimeSelect: true,
              timeFormat: "HH:mm",
              timeIntervals: 15,
              timezone: formSettings.timezone
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            TimeZoneMappingDatePicker$1,
            {
              isClearable: true,
              clearButtonTitle: "Clear",
              placeholderText: "To",
              selectsEnd: true,
              startDate: ticketType.availableFrom,
              endDate: ticketType.availableTo,
              minDate: ticketType.availableFrom,
              onChange: (availableTo) => onChange({ ...ticketType, availableTo }),
              selectedDate: ticketType.availableTo,
              dateFormat: `${formSettings.dateFormat} HH:mm`,
              showTimeSelect: true,
              timeFormat: "HH:mm",
              timeIntervals: 15,
              timezone: formSettings.timezone
            }
          )
        ] }) }),
        formSettings.shoppingCartEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { px: 1, verticalAlign: "top", pt: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          PriceInput$3,
          {
            currency: formSettings.shoppingCartCurrency,
            valueInCents: ticketType.priceInCents,
            onChange: (priceInCents) => onChange({ ...ticketType, priceInCents })
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { px: 1, verticalAlign: "top", pt: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { m: 0, align: "flex-start", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            IntegerInput,
            {
              min: 0,
              value: ticketType.capacity,
              onChange: (capacity) => onChange({ ...ticketType, capacity })
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { px: 2, children: [
            (ticketType == null ? void 0 : ticketType.numberBooked) || 0,
            " Booked"
          ] })
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { px: 1, verticalAlign: "top", pt: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { spacing: 1, alignItems: "flex-start", children: [
          onEditMeta !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              size: "xs",
              onClick: () => onEditMeta(ticketType),
              title: "Edit metadata",
              children: "meta"
            }
          ),
          onDelete !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "red", size: "xs", onClick: onDelete, children: "Delete" })
        ] }) })
      ]
    }
  ) });
};
const TicketTypeTable$1 = ({
  track: track2,
  dispatch,
  onEditMeta
}) => {
  const { formSettings } = useRegForm();
  const handleDragEnd = (result) => {
    if (result.destination) {
      dispatch({
        type: "move_ticket_type",
        payload: {
          fromIndex: result.source.index,
          toIndex: result.destination.index
        }
      });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DragDropContext$1, { onDragEnd: handleDragEnd, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$3, { size: "sm", style: { tableLayout: "fixed" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Thead, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { width: "10%", children: "Drag to reorder" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { width: "25%", children: "Name (click to edit)" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { width: "25%", children: "Available" }),
      formSettings.shoppingCartEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { width: "15%", children: "Price" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { width: "12%", children: "Total available" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, {})
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectedDroppable$1, { droppableId: "ticketTypes", children: (provided) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Tbody, { ref: provided.innerRef, ...provided.droppableProps, children: [
      getSortedItems(track2.ticketTypes).map((ticketType, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        TicketTypeRow$1,
        {
          index: index2,
          ticketType,
          onChange: (t2) => dispatch({ type: "update_ticket_type", payload: t2 }),
          onDelete: track2.ticketTypes.length > 1 && !(ticketType.numberBooked !== void 0 && ticketType.numberBooked > 0) ? () => dispatch({
            type: "delete_ticket_type",
            payload: ticketType
          }) : void 0,
          onEditMeta
        },
        ticketType.id
      )),
      provided.placeholder
    ] }) })
  ] }) });
};
function sheetForTag(tag2) {
  if (tag2.sheet) {
    return tag2.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag2) {
      return document.styleSheets[i];
    }
  }
  return void 0;
}
function createStyleElement(options) {
  var tag2 = document.createElement("style");
  tag2.setAttribute("data-emotion", options.key);
  if (options.nonce !== void 0) {
    tag2.setAttribute("nonce", options.nonce);
  }
  tag2.appendChild(document.createTextNode(""));
  tag2.setAttribute("data-s", "");
  return tag2;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options) {
    var _this = this;
    this._insertTag = function(tag2) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag2, before);
      _this.tags.push(tag2);
    };
    this.isSpeedy = options.speedy === void 0 ? true : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert2(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag2 = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag2);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag2.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush3() {
    this.tags.forEach(function(tag2) {
      var _tag$parentNode;
      return (_tag$parentNode = tag2.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag2);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
}();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";
var abs$2 = Math.abs;
var from$1 = String.fromCharCode;
var assign$3 = Object.assign;
function hash(value, length2) {
  return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim(value) {
  return value.trim();
}
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace$2(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search2) {
  return value.indexOf(search2);
}
function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr(value, begin, end2) {
  return value.slice(begin, end2);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array) {
  return array.push(value), value;
}
function combine$1(array, callback) {
  return array.map(callback).join("");
}
var line = 1;
var column = 1;
var length = 0;
var position$4 = 0;
var character = 0;
var characters = "";
function node$1(value, root2, parent2, type, props, children, length2) {
  return { value, root: root2, parent: parent2, type, props, children, line, column, length: length2, return: "" };
}
function copy$1(root2, props) {
  return assign$3(node$1("", null, null, "", null, null, 0), root2, { length: -root2.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position$4 > 0 ? charat(characters, --position$4) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position$4 < length ? charat(characters, position$4++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position$4);
}
function caret() {
  return position$4;
}
function slice(begin, end2) {
  return substr(characters, begin, end2);
}
function token$1(type) {
  switch (type) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position$4 = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type) {
  return trim(slice(position$4 - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function whitespace$2(type) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token$1(type) > 2 || token$1(character) > 3 ? "" : " ";
}
function escaping(index2, count2) {
  while (--count2 && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index2, caret() + (count2 < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
  while (next())
    switch (character) {
      // ] ) " '
      case type:
        return position$4;
      // " '
      case 34:
      case 39:
        if (type !== 34 && type !== 39)
          delimiter(character);
        break;
      // (
      case 40:
        if (type === 41)
          delimiter(type);
        break;
      // \
      case 92:
        next();
        break;
    }
  return position$4;
}
function commenter(type, index2) {
  while (next())
    if (type + character === 47 + 10)
      break;
    else if (type + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index2, position$4 - 1) + "*" + from$1(type === 47 ? type : next());
}
function identifier(index2) {
  while (!token$1(peek()))
    next();
  return slice(index2, position$4);
}
function compile(value) {
  return dealloc(parse$1("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse$1(value, root2, parent2, rule, rules, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset3 = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous2 = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type = "";
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters2 = type;
  while (scanning)
    switch (previous2 = character2, character2 = next()) {
      // (
      case 40:
        if (previous2 != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace$2(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace$2(previous2);
        break;
      // \
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      // /
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root2, parent2), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      // {
      case 123 * variable:
        points[index2++] = strlen(characters2) * ampersand;
      // } ; \0
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          // \0 }
          case 0:
          case 125:
            scanning = 0;
          // ;
          case 59 + offset3:
            if (ampersand == -1) characters2 = replace$2(characters2, /\f/g, "");
            if (property > 0 && strlen(characters2) - length2)
              append(property > 32 ? declaration(characters2 + ";", rule, parent2, length2 - 1) : declaration(replace$2(characters2, " ", "") + ";", rule, parent2, length2 - 2), declarations);
            break;
          // @ ;
          case 59:
            characters2 += ";";
          // { rule/at-rule
          default:
            append(reference = ruleset(characters2, root2, parent2, index2, offset3, rules, points, type, props = [], children = [], length2), rulesets);
            if (character2 === 123)
              if (offset3 === 0)
                parse$1(characters2, root2, reference, reference, props, rulesets, length2, points, children);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse$1(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                    break;
                  default:
                    parse$1(characters2, reference, reference, reference, [""], children, 0, points, children);
                }
        }
        index2 = offset3 = property = 0, variable = ampersand = 1, type = characters2 = "", length2 = pseudo;
        break;
      // :
      case 58:
        length2 = 1 + strlen(characters2), property = previous2;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from$1(character2), character2 * variable) {
          // &
          case 38:
            ampersand = offset3 > 0 ? 1 : (characters2 += "\f", -1);
            break;
          // ,
          case 44:
            points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          // @
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset3 = length2 = strlen(type = characters2 += identifier(caret())), character2++;
            break;
          // -
          case 45:
            if (previous2 === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root2, parent2, index2, offset3, rules, points, type, props, children, length2) {
  var post2 = offset3 - 1;
  var rule = offset3 === 0 ? rules : [""];
  var size2 = sizeof(rule);
  for (var i = 0, j2 = 0, k2 = 0; i < index2; ++i)
    for (var x2 = 0, y2 = substr(value, post2 + 1, post2 = abs$2(j2 = points[i])), z2 = value; x2 < size2; ++x2)
      if (z2 = trim(j2 > 0 ? rule[x2] + " " + y2 : replace$2(y2, /&\f/g, rule[x2])))
        props[k2++] = z2;
  return node$1(value, root2, parent2, offset3 === 0 ? RULESET : type, props, children, length2);
}
function comment(value, root2, parent2) {
  return node$1(value, root2, parent2, COMMENT, from$1(char()), substr(value, 2, -2), 0);
}
function declaration(value, root2, parent2, length2) {
  return node$1(value, root2, parent2, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function serialize$3(children, callback) {
  var output = "";
  var length2 = sizeof(children);
  for (var i = 0; i < length2; i++)
    output += callback(children[i], i, children, callback) || "";
  return output;
}
function stringify$2(element2, index2, children, callback) {
  switch (element2.type) {
    case LAYER:
      if (element2.children.length) break;
    case IMPORT:
    case DECLARATION:
      return element2.return = element2.return || element2.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element2.return = element2.value + "{" + serialize$3(element2.children, callback) + "}";
    case RULESET:
      element2.value = element2.props.join(",");
  }
  return strlen(children = serialize$3(element2.children, callback)) ? element2.return = element2.value + "{" + children + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element2, index2, children, callback) {
    var output = "";
    for (var i = 0; i < length2; i++)
      output += collection[i](element2, index2, children, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element2) {
    if (!element2.root) {
      if (element2 = element2.return)
        callback(element2);
    }
  };
}
function memoize(fn2) {
  var cache = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache[arg] === void 0) cache[arg] = fn2(arg);
    return cache[arg];
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index2) {
  var previous2 = 0;
  var character2 = 0;
  while (true) {
    previous2 = character2;
    character2 = peek();
    if (previous2 === 38 && character2 === 12) {
      points[index2] = 1;
    }
    if (token$1(character2)) {
      break;
    }
    next();
  }
  return slice(begin, position$4);
};
var toRules = function toRules2(parsed, points) {
  var index2 = -1;
  var character2 = 44;
  do {
    switch (token$1(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index2] = 1;
        }
        parsed[index2] += identifierWithPointTracking(position$4 - 1, points, index2);
        break;
      case 2:
        parsed[index2] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index2] = peek() === 58 ? "&\f" : "";
          points[index2] = parsed[index2].length;
          break;
        }
      // fallthrough
      default:
        parsed[index2] += from$1(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element2) {
  if (element2.type !== "rule" || !element2.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element2.length < 1) {
    return;
  }
  var value = element2.value;
  var parent2 = element2.parent;
  var isImplicitRule = element2.column === parent2.column && element2.line === parent2.line;
  while (parent2.type !== "rule") {
    parent2 = parent2.parent;
    if (!parent2) return;
  }
  if (element2.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent2)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element2, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent2.props;
  for (var i = 0, k2 = 0; i < rules.length; i++) {
    for (var j2 = 0; j2 < parentRules.length; j2++, k2++) {
      element2.props[k2] = points[i] ? rules[i].replace(/&\f/g, parentRules[j2]) : parentRules[j2] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel2(element2) {
  if (element2.type === "decl") {
    var value = element2.value;
    if (
      // charcode for l
      value.charCodeAt(0) === 108 && // charcode for b
      value.charCodeAt(2) === 98
    ) {
      element2["return"] = "";
      element2.value = "";
    }
  }
};
function prefix$1(value, length2) {
  switch (hash(value, length2)) {
    // color-adjust
    case 5103:
      return WEBKIT + "print-" + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    // align-items
    case 5187:
      return WEBKIT + value + replace$2(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    // align-self
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace$2(value, /flex-|-self/, "") + value;
    // align-content
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace$2(value, /align-content|flex-|-self/, "") + value;
    // flex-shrink
    case 5548:
      return WEBKIT + value + MS + replace$2(value, "shrink", "negative") + value;
    // flex-basis
    case 5292:
      return WEBKIT + value + MS + replace$2(value, "basis", "preferred-size") + value;
    // flex-grow
    case 6060:
      return WEBKIT + "box-" + replace$2(value, "-grow", "") + WEBKIT + value + MS + replace$2(value, "grow", "positive") + value;
    // transition
    case 4554:
      return WEBKIT + replace$2(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    // cursor
    case 6187:
      return replace$2(replace$2(replace$2(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    // background, background-image
    case 5495:
    case 3959:
      return replace$2(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    // justify-content
    case 4968:
      return replace$2(replace$2(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$2(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6) switch (charat(value, length2 + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (charat(value, length2 + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return replace$2(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
        // (s)tretch
        case 115:
          return ~indexof(value, "stretch") ? prefix$1(replace$2(value, "stretch", "fill-available"), length2) + value : value;
      }
      break;
    // position: sticky
    case 4949:
      if (charat(value, length2 + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        // stic(k)y
        case 107:
          return replace$2(value, ":", ":" + WEBKIT) + value;
        // (inline-)?fl(e)x
        case 101:
          return replace$2(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    // writing-mode
    case 5936:
      switch (charat(value, length2 + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace$2(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        // vertical-r(l)
        case 108:
          return WEBKIT + value + MS + replace$2(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        // horizontal(-)tb
        case 45:
          return WEBKIT + value + MS + replace$2(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer2(element2, index2, children, callback) {
  if (element2.length > -1) {
    if (!element2["return"]) switch (element2.type) {
      case DECLARATION:
        element2["return"] = prefix$1(element2.value, element2.length);
        break;
      case KEYFRAMES:
        return serialize$3([copy$1(element2, {
          value: replace$2(element2.value, "@", "@" + WEBKIT)
        })], callback);
      case RULESET:
        if (element2.length) return combine$1(element2.props, function(value) {
          switch (match(value, /(::plac\w+|:read-\w+)/)) {
            // :read-(only|write)
            case ":read-only":
            case ":read-write":
              return serialize$3([copy$1(element2, {
                props: [replace$2(value, /:(read-\w+)/, ":" + MOZ + "$1")]
              })], callback);
            // :placeholder
            case "::placeholder":
              return serialize$3([copy$1(element2, {
                props: [replace$2(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
              }), copy$1(element2, {
                props: [replace$2(value, /:(plac\w+)/, ":" + MOZ + "$1")]
              }), copy$1(element2, {
                props: [replace$2(value, /:(plac\w+)/, MS + "input-$1")]
              })], callback);
          }
          return "";
        });
    }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options) {
  var key2 = options.key;
  if (key2 === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options.container || document.head;
    Array.prototype.forEach.call(
      // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll('style[data-emotion^="' + key2 + ' "]'),
      function(node2) {
        var attrib = node2.getAttribute("data-emotion").split(" ");
        for (var i = 1; i < attrib.length; i++) {
          inserted[attrib[i]] = true;
        }
        nodesToHydrate.push(node2);
      }
    );
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify$2, rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer2 = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles2) {
      return serialize$3(compile(styles2), serializer2);
    };
    _insert = function insert2(selector2, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector2 ? selector2 + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }
  var cache = {
    key: key2,
    sheet: new StyleSheet({
      key: key2,
      container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames2) {
  var rawClassName = "";
  classNames2.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
    // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache.registered[className] === void 0
  ) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h2 = 0;
  var k2, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k2 = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k2 = /* Math.imul(k, m): */
    (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16);
    k2 ^= /* k >>> r: */
    k2 >>> 24;
    h2 = /* Math.imul(k, m): */
    (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h2 ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h2 ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h2 ^= str.charCodeAt(i) & 255;
      h2 = /* Math.imul(h, m): */
      (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  h2 ^= h2 >>> 13;
  h2 = /* Math.imul(h, m): */
  (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  return ((h2 ^ h2 >>> 15) >>> 0).toString(36);
}
var unitlessKeys$1 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key2, value) {
  switch (key2) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match5, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys$1[key2] !== 1 && !isCustomProperty(key2) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  var componentSelector = interpolation;
  if (componentSelector.__emotion_styles !== void 0) {
    return componentSelector;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      var keyframes = interpolation;
      if (keyframes.anim === 1) {
        cursor = {
          name: keyframes.name,
          styles: keyframes.styles,
          next: cursor
        };
        return keyframes.name;
      }
      var serializedStyles = interpolation;
      if (serializedStyles.styles !== void 0) {
        var next2 = serializedStyles.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles2 = serializedStyles.styles + ";";
        return styles2;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      }
      break;
    }
  }
  var asString = interpolation;
  if (registered == null) {
    return asString;
  }
  var cached = registered[asString];
  return cached !== void 0 ? cached : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string2 = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string2 += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key2 in obj) {
      var value = obj[key2];
      if (typeof value !== "object") {
        var asString = value;
        if (registered != null && registered[asString] !== void 0) {
          string2 += key2 + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string2 += processStyleName(key2) + ":" + processStyleValue(key2, asString) + ";";
        }
      } else {
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string2 += processStyleName(key2) + ":" + processStyleValue(key2, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (key2) {
            case "animation":
            case "animationName": {
              string2 += processStyleName(key2) + ":" + interpolated + ";";
              break;
            }
            default: {
              string2 += key2 + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string2;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles2 = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles2 += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;
    styles2 += asTemplateStringsArr[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles2 += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      var templateStringsArr = strings;
      styles2 += templateStringsArr[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match5;
  while ((match5 = labelPattern.exec(styles2)) !== null) {
    identifierName += "-" + match5[1];
  }
  var name2 = murmur2(styles2) + identifierName;
  return {
    name: name2,
    styles: styles2,
    next: cursor
  };
}
var syncFallback = function syncFallback2(create2) {
  return create2();
};
var useInsertionEffect = React["useInsertionEffect"] ? React["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var EmotionCacheContext = /* @__PURE__ */ React.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
);
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ forwardRef$1(function(props, ref2) {
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref2);
  });
};
var ThemeContext$1 = /* @__PURE__ */ React.createContext({});
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var isPropValid = /* @__PURE__ */ memoize(
  function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
var testOmitPropsOnStringTag = isPropValid;
var testOmitPropsOnComponent = function testOmitPropsOnComponent2(key2) {
  return key2 !== "theme";
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp2(tag2) {
  return typeof tag2 === "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag2.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps2(tag2, options, isReal) {
  var shouldForwardProp;
  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag2.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
      return tag2.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }
  if (typeof shouldForwardProp !== "function" && isReal) {
    shouldForwardProp = tag2.__emotion_forwardProp;
  }
  return shouldForwardProp;
};
var Insertion = function Insertion2(_ref) {
  var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache, serialized, isStringTag);
  });
  return null;
};
var createStyled = function createStyled2(tag2, options) {
  var isReal = tag2.__emotion_real === tag2;
  var baseTag = isReal && tag2.__emotion_base || tag2;
  var identifierName;
  var targetClassName;
  if (options !== void 0) {
    identifierName = options.label;
    targetClassName = options.target;
  }
  var shouldForwardProp = composeShouldForwardProps(tag2, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp("as");
  return function() {
    var args = arguments;
    var styles2 = isReal && tag2.__emotion_styles !== void 0 ? tag2.__emotion_styles.slice(0) : [];
    if (identifierName !== void 0) {
      styles2.push("label:" + identifierName + ";");
    }
    if (args[0] == null || args[0].raw === void 0) {
      styles2.push.apply(styles2, args);
    } else {
      var templateStringsArr = args[0];
      styles2.push(templateStringsArr[0]);
      var len = args.length;
      var i = 1;
      for (; i < len; i++) {
        styles2.push(args[i], templateStringsArr[i]);
      }
    }
    var Styled = withEmotionCache(function(props, cache, ref2) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = "";
      var classInterpolations = [];
      var mergedProps = props;
      if (props.theme == null) {
        mergedProps = {};
        for (var key2 in props) {
          mergedProps[key2] = props[key2];
        }
        mergedProps.theme = React.useContext(ThemeContext$1);
      }
      if (typeof props.className === "string") {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }
      var serialized = serializeStyles(styles2.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;
      if (targetClassName !== void 0) {
        className += " " + targetClassName;
      }
      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === void 0 ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};
      for (var _key in props) {
        if (shouldUseAs && _key === "as") continue;
        if (finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }
      newProps.className = className;
      if (ref2) {
        newProps.ref = ref2;
      }
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion, {
        cache,
        serialized,
        isStringTag: typeof FinalTag === "string"
      }), /* @__PURE__ */ React.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== void 0 ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
    Styled.defaultProps = tag2.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles2;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, "toString", {
      value: function value() {
        return "." + targetClassName;
      }
    });
    Styled.withComponent = function(nextTag, nextOptions) {
      var newStyled = createStyled2(nextTag, _extends$6({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      }));
      return newStyled.apply(void 0, styles2);
    };
    return Styled;
  };
};
var tags = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
var styled = createStyled.bind(null);
tags.forEach(function(tagName) {
  styled[tagName] = styled(tagName);
});
const ResetForm = styled.form`
  width: initial;
  margin: initial;
  float: initial;
`;
const useNestedForm = (options) => {
  const { handleSubmit: internalSubmit, ...rest } = useForm(options);
  const handleSubmit = (onSubmit) => (e) => {
    e.preventDefault();
    internalSubmit(onSubmit)(e);
    e.stopPropagation();
  };
  return {
    handleSubmit,
    ...rest
  };
};
const MetadataForm = ({
  metadata,
  onSave,
  onCancel,
  formRef,
  scrollRef,
  showSubmitButton = true
}) => {
  const {
    register: register2,
    control,
    handleSubmit,
    formState: { errors }
  } = useNestedForm({
    defaultValues: { metadata: metadata || [] }
  });
  const { fields, append: append3, remove } = useFieldArray({
    control,
    name: "metadata"
  });
  const handleAddItem = () => {
    append3({});
    setTimeout(
      () => {
        var _a3;
        return (_a3 = scrollRef == null ? void 0 : scrollRef.current) == null ? void 0 : _a3.scrollIntoView({
          block: "end",
          behavior: "smooth"
        });
      },
      30
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    ResetForm,
    {
      ref: formRef,
      onSubmit: handleSubmit((values2) => {
        onSave(
          values2.metadata !== void 0 ? values2.metadata.filter(isValidMetaTag) : []
        );
      }),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$3, { size: "sm", style: { tableLayout: "fixed" }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Thead, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Key" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Value" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { textAlign: "center", width: "15%", children: "Actions" })
          ] }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Tbody, { children: fields.map((field, index2) => {
            var _a3, _b, _c, _d, _e2, _f, _g, _h, _i, _j;
            return /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { verticalAlign: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { isInvalid: !!((_b = (_a3 = errors == null ? void 0 : errors.metadata) == null ? void 0 : _a3[index2]) == null ? void 0 : _b.key), children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Input$1,
                  {
                    id: `metadata.${index2}.key`,
                    defaultValue: field.key,
                    placeholder: "key",
                    ...register2(`metadata.${index2}.key`, {
                      required: "Please enter a key",
                      pattern: {
                        value: /^[a-zA-Z][a-zA-Z0-9_]*/,
                        message: "Key must contain letters, numbers and underscores only and must start with a letter"
                      },
                      minLength: {
                        value: 3,
                        message: "Minimum length is three characters"
                      },
                      maxLength: {
                        value: 30,
                        message: "Maximum length is 30 characters"
                      }
                    })
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormErrorMessage, { children: (_e2 = (_d = (_c = errors == null ? void 0 : errors.metadata) == null ? void 0 : _c[index2]) == null ? void 0 : _d.key) == null ? void 0 : _e2.message })
              ] }) }, "key"),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { verticalAlign: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                FormControl$2,
                {
                  isInvalid: !!((_g = (_f = errors == null ? void 0 : errors.metadata) == null ? void 0 : _f[index2]) == null ? void 0 : _g.value),
                  justifyContent: "flex-start",
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      Input$1,
                      {
                        ...register2(`metadata.${index2}.value`, {
                          required: "Please enter a value"
                        }),
                        id: `metadata.${index2}.value`,
                        name: `metadata[${index2}].value`,
                        defaultValue: field.value,
                        placeholder: "value"
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(FormErrorMessage, { children: (_j = (_i = (_h = errors == null ? void 0 : errors.metadata) == null ? void 0 : _h[index2]) == null ? void 0 : _i.value) == null ? void 0 : _j.message })
                  ]
                }
              ) }, "value"),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "15%", textAlign: "center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                Button$1,
                {
                  onClick: () => remove(index2),
                  colorScheme: "red",
                  size: "xs",
                  children: "Delete"
                }
              ) }, "buttons")
            ] }, field.id);
          }) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { pt: 6, pb: showSubmitButton ? 2 : 6, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", variant: "outline", onClick: handleAddItem, children: "Add item +" }) }),
        showSubmitButton && /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { justify: "flex-end", pb: 10, spacing: 2, children: [
          onCancel !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", type: "submit", children: "Save metadata" })
        ] })
      ]
    }
  );
};
const TicketTypeEditor$1 = ({
  track: initialTrack,
  onChange
}) => {
  const { formSettings } = useRegForm();
  const [track2, dispatch] = useReducer(ticketTypeReducer, initialTrack);
  const [editMetaTicketType, setEditMetaTicketType] = useState();
  const scrollRef = useRef(null);
  useEffect(() => {
    onChange(track2.ticketTypes, track2.deletedTicketTypes);
  }, [track2]);
  const handleAddTicketType = () => {
    dispatch({
      type: "add_ticket_type",
      payload: {
        name: ticketTypeDefaults.name,
        sort: getNextSort(track2.ticketTypes)
      }
    });
    setTimeout(
      () => {
        var _a3;
        return (_a3 = scrollRef == null ? void 0 : scrollRef.current) == null ? void 0 : _a3.scrollIntoView({
          block: "end",
          behavior: "smooth"
        });
      },
      30
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { ref: scrollRef, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { children: "Admission Types" }),
    editMetaTicketType === void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
      TicketTypeTable$1,
      {
        track: track2,
        dispatch,
        onEditMeta: formSettings.metadataEnabled ? setEditMetaTicketType : void 0
      }
    ),
    editMetaTicketType !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(Portal$2, { containerRef: scrollRef, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { py: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Heading$5, { size: "md", children: [
        editMetaTicketType.name,
        " metadata"
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        MetadataForm,
        {
          metadata: editMetaTicketType.metadata,
          scrollRef,
          onSave: (metadata) => {
            dispatch({
              type: "update_ticket_type",
              payload: { ...editMetaTicketType, metadata }
            });
            setEditMetaTicketType(void 0);
          },
          onCancel: () => setEditMetaTicketType(void 0)
        }
      )
    ] }),
    editMetaTicketType === void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { pt: 4, pb: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        colorScheme: "blue",
        variant: "outline",
        onClick: handleAddTicketType,
        children: "Add admission type +"
      }
    ) })
  ] });
};
var DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext = React__default.createContext && /* @__PURE__ */ React__default.createContext(DefaultContext);
var _excluded$1 = ["attr", "size", "title"];
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, key2)) {
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
function ownKeys$5(e, r2) {
  var t2 = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t2.push.apply(t2, o2);
  }
  return t2;
}
function _objectSpread$4(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t2 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$5(Object(t2), true).forEach(function(r3) {
      _defineProperty$1(e, r3, t2[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t2)) : ownKeys$5(Object(t2)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t2, r3));
    });
  }
  return e;
}
function _defineProperty$1(obj, key2, value) {
  key2 = _toPropertyKey(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _toPropertyKey(t2) {
  var i = _toPrimitive$1(t2, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1(t2, r2) {
  if ("object" != typeof t2 || !t2) return t2;
  var e = t2[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t2, r2);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t2);
}
function Tree2Element(tree) {
  return tree && tree.map((node2, i) => /* @__PURE__ */ React__default.createElement(node2.tag, _objectSpread$4({
    key: i
  }, node2.attr), Tree2Element(node2.child)));
}
function GenIcon(data) {
  return (props) => /* @__PURE__ */ React__default.createElement(IconBase, _extends$3({
    attr: _objectSpread$4({}, data.attr)
  }, props), Tree2Element(data.child));
}
function IconBase(props) {
  var elem = (conf) => {
    var {
      attr,
      size: size2,
      title
    } = props, svgProps = _objectWithoutProperties$1(props, _excluded$1);
    var computedSize = size2 || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return /* @__PURE__ */ React__default.createElement("svg", _extends$3({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: _objectSpread$4(_objectSpread$4({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && /* @__PURE__ */ React__default.createElement("title", null, title), props.children);
  };
  return IconContext !== void 0 ? /* @__PURE__ */ React__default.createElement(IconContext.Consumer, null, (conf) => elem(conf)) : elem(DefaultContext);
}
function FaClipboard(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 384 512" }, "child": [{ "tag": "path", "attr": { "d": "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z" }, "child": [] }] })(props);
}
const CopyableInput$1 = ({ text: text2 }) => {
  const { onCopy } = useClipboard(text2);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(InputGroup, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Input$1, { value: text2, disabled: true }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputRightAddon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconButton$1,
      {
        "aria-label": "Copy to clipboard",
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(FaClipboard, {}),
        onClick: onCopy
      }
    ) })
  ] });
};
function TrackForm$1({
  track: initialTrack,
  onSubmit,
  formRef
}) {
  const { formSettings } = useRegForm();
  const [deletedTicketTypes, setDeletedTicketTypes] = useState(initialTrack == null ? void 0 : initialTrack.deletedTicketTypes);
  const {
    handleSubmit,
    control,
    register: register2,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: { ticketTypes: [defaultTicketType()], ...initialTrack }
  });
  const track2 = { ...watch(), deletedTicketTypes };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "form",
    {
      id: "track-form",
      onSubmit: handleSubmit((update2) => {
        onSubmit({ ...update2, deletedTicketTypes });
      }),
      ref: formRef,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { pb: 12, px: 16, spacing: 6, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            FormControl$2,
            {
              isRequired: true,
              isInvalid: errors.name !== void 0,
              id: "track_name",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { htmlFor: "name", children: "Name" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Input$1,
                  {
                    id: `track-${(initialTrack == null ? void 0 : initialTrack.id) !== void 0 ? initialTrack.id : "new"}`,
                    ...register2("name", { required: "Track name is required" }),
                    placeholder: "name"
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormErrorMessage, { children: errors.name && errors.name.message })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { isInvalid: errors.description !== void 0, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { htmlFor: "description", children: "Description" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Textarea$1,
              {
                ...register2("description"),
                placeholder: "This description is displayed on the track selection page during registration."
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormErrorMessage, { children: errors.description && errors.description.message })
          ] }),
          formSettings.guestBookingEnabled && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Checkbox$2,
                {
                  ...register2("isSpeakerTrack"),
                  isDisabled: isTrackWithBookings(initialTrack) || track2.isGuestTrack,
                  children: "Track is a Speaker track"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "If selected, registration for this track is only possible as Speakers of other tracks." }),
              isTrackWithBookings(initialTrack) && /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: "This track has registrations and its speaker track status cannot be changed." }) })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Checkbox$2,
                {
                  ...register2("isGuestTrack"),
                  isDisabled: isTrackWithBookings(initialTrack) || track2.isSpeakerTrack,
                  children: "Track is a Guest track"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "If selected, registration for this track is only possible as Guests of other tracks. Check the box to see invitation options." }),
              isTrackWithBookings(initialTrack) && /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: "This track has registrations and its guest track status cannot be changed." }) })
            ] }),
            track2.isGuestTrack && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Controller,
                {
                  control,
                  name: "guestInvites",
                  render: ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                    GuestTrackInvites$1,
                    {
                      guestTrack: { ...track2, id: initialTrack == null ? void 0 : initialTrack.id },
                      onChange: field.onChange
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$2, { ...register2("guestAccountActivation"), children: "Guests receive a registration confirmation email" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "Guests are able to activate their account and edit their registration." })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$2, { ...register2("overrideRegistrationClose"), children: "Override registration close date" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "If selected, inviters can still register guests after overall event registration has closed / frozen. (Guest track admission type availability dates are not affected by this setting.)" })
              ] })
            ] })
          ] }),
          !track2.isGuestTrack && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$2, { ...register2("inviteOnly"), children: "Invite Only" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "If selected, registration for this track is only available to users who are invited via event invitations." })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Invite Link" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "Invite links provide a direct path for track registration. Anyone following the link can followed a streamlined, track specific registration flow, even if the track is marked as invite only above." }),
              (initialTrack == null ? void 0 : initialTrack.inviteUrl) === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "Please save the Track to generate the invite link." }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CopyableInput$1, { text: initialTrack.inviteUrl })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Controller,
          {
            name: "ticketTypes",
            control,
            render: ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              TicketTypeEditor$1,
              {
                track: track2,
                onChange: (ticketTypes, deletedTicketTypes2) => {
                  field.onChange(ticketTypes);
                  setDeletedTicketTypes(deletedTicketTypes2);
                }
              }
            )
          }
        )
      ]
    }
  );
}
const EditTrack$1 = ({
  track: initialTrack,
  onUpdated,
  onCancel
}) => {
  const mutation = useUpdateTrack({ onSuccess: onUpdated });
  const formRef = React__default.createRef();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Event Tracks" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalBody, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Heading$5, { as: "h1", color: "gray.700", pb: 16, textAlign: "center", children: [
        initialTrack.name,
        " / Edit"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TrackForm$1,
        {
          formRef,
          track: initialTrack,
          onSubmit: (track2) => mutation.mutate({ ...track2, id: initialTrack.id })
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              onClick: () => {
                var _a3;
                return (_a3 = formRef == null ? void 0 : formRef.current) == null ? void 0 : _a3.dispatchEvent(
                  new Event("submit", { cancelable: true, bubbles: true })
                );
              },
              colorScheme: "green",
              children: "Update Track"
            }
          )
        ]
      }
    )
  ] });
};
const EditTrackModal = ({
  track: track2,
  onUpdated,
  renderButton
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    renderButton === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", onClick: onOpen, children: "Edit Track" }) : renderButton({ isOpen, onOpen, onClose }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Modal,
      {
        isOpen,
        onClose,
        size: "xl",
        scrollBehavior: "inside",
        portalProps: {
          appendToParentPortal: true
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalContent, { minW: 850, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            EditTrack$1,
            {
              track: track2,
              onUpdated: (track22) => {
                onUpdated == null ? void 0 : onUpdated.call(void 0, track22);
                onClose();
              },
              onCancel: onClose
            }
          ) })
        ]
      }
    )
  ] });
};
const SectionListItem$1 = ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  Flex,
  {
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 6,
    borderBottom: "1px solid black",
    borderBottomColor: "blackAlpha.100",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { textStyle: "editorH2", as: "h3", pb: 1, children: field.label || humanizeString(field.name) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { color: "gray.500", children: "SECTION" })
    ]
  }
);
const PageListItem$1 = ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  Flex,
  {
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8,
    marginTop: 16,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { as: "h2", textStyle: "formPageTitle", children: field.label || humanizeString(field.name) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { color: "gray.500", children: "PAGE" })
    ]
  }
);
function _getDefaults() {
  return {
    async: false,
    breaks: false,
    extensions: null,
    gfm: true,
    hooks: null,
    pedantic: false,
    renderer: null,
    silent: false,
    tokenizer: null,
    walkTokens: null
  };
}
var _defaults = _getDefaults();
function changeDefaults(newDefaults) {
  _defaults = newDefaults;
}
var noopTest = { exec: () => null };
function edit(regex2, opt = "") {
  let source = typeof regex2 === "string" ? regex2 : regex2.source;
  const obj = {
    replace: (name2, val) => {
      let valSource = typeof val === "string" ? val : val.source;
      valSource = valSource.replace(other.caret, "$1");
      source = source.replace(name2, valSource);
      return obj;
    },
    getRegex: () => {
      return new RegExp(source, opt);
    }
  };
  return obj;
}
var other = {
  codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
  outputLinkReplace: /\\([\[\]])/g,
  indentCodeCompensation: /^(\s+)(?:```)/,
  beginningSpace: /^\s+/,
  endingHash: /#$/,
  startingSpaceChar: /^ /,
  endingSpaceChar: / $/,
  nonSpaceChar: /[^ ]/,
  newLineCharGlobal: /\n/g,
  tabCharGlobal: /\t/g,
  multipleSpaceGlobal: /\s+/g,
  blankLine: /^[ \t]*$/,
  doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
  blockquoteStart: /^ {0,3}>/,
  blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
  blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
  listReplaceTabs: /^\t+/,
  listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
  listIsTask: /^\[[ xX]\] /,
  listReplaceTask: /^\[[ xX]\] +/,
  anyLine: /\n.*\n/,
  hrefBrackets: /^<(.*)>$/,
  tableDelimiter: /[:|]/,
  tableAlignChars: /^\||\| *$/g,
  tableRowBlankLine: /\n[ \t]*$/,
  tableAlignRight: /^ *-+: *$/,
  tableAlignCenter: /^ *:-+: *$/,
  tableAlignLeft: /^ *:-+ *$/,
  startATag: /^<a /i,
  endATag: /^<\/a>/i,
  startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
  endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
  startAngleBracket: /^</,
  endAngleBracket: />$/,
  pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
  unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
  escapeTest: /[&<>"']/,
  escapeReplace: /[&<>"']/g,
  escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
  escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
  unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
  caret: /(^|[^\[])\^/g,
  percentDecode: /%25/g,
  findPipe: /\|/g,
  splitPipe: / \|/,
  slashPipe: /\\\|/g,
  carriageReturn: /\r\n|\r/g,
  spaceLine: /^ +$/gm,
  notSpaceStart: /^\S*/,
  endingNewline: /\n$/,
  listItemRegex: (bull) => new RegExp(`^( {0,3}${bull})((?:[	 ][^\\n]*)?(?:\\n|$))`),
  nextBulletRegex: (indent2) => new RegExp(`^ {0,${Math.min(3, indent2 - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
  hrRegex: (indent2) => new RegExp(`^ {0,${Math.min(3, indent2 - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
  fencesBeginRegex: (indent2) => new RegExp(`^ {0,${Math.min(3, indent2 - 1)}}(?:\`\`\`|~~~)`),
  headingBeginRegex: (indent2) => new RegExp(`^ {0,${Math.min(3, indent2 - 1)}}#`),
  htmlBeginRegex: (indent2) => new RegExp(`^ {0,${Math.min(3, indent2 - 1)}}<(?:[a-z].*>|!--)`, "i")
};
var newline = /^(?:[ \t]*(?:\n|$))+/;
var blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
var fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
var hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
var heading$2 = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
var bullet = /(?:[*+-]|\d{1,9}[.)])/;
var lheadingCore = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/;
var lheading = edit(lheadingCore).replace(/bull/g, bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex();
var lheadingGfm = edit(lheadingCore).replace(/bull/g, bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex();
var _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
var blockText = /^[^\n]+/;
var _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
var def = edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", _blockLabel).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
var list$4 = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, bullet).getRegex();
var _tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
var _comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
var html$4 = edit(
  "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))",
  "i"
).replace("comment", _comment).replace("tag", _tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
var paragraph$2 = edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex();
var blockquote$2 = edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", paragraph$2).getRegex();
var blockNormal = {
  blockquote: blockquote$2,
  code: blockCode,
  def,
  fences,
  heading: heading$2,
  hr,
  html: html$4,
  lheading,
  list: list$4,
  newline,
  paragraph: paragraph$2,
  table: noopTest,
  text: blockText
};
var gfmTable$1 = edit(
  "^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex();
var blockGfm = {
  ...blockNormal,
  lheading: lheadingGfm,
  table: gfmTable$1,
  paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", gfmTable$1).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex()
};
var blockPedantic = {
  ...blockNormal,
  html: edit(
    `^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`
  ).replace("comment", _comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: noopTest,
  // fences not supported
  lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", lheading).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
};
var escape$1 = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
var inlineCode$2 = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
var br = /^( {2,}|\\)\n(?!\s*$)/;
var inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
var _punctuation = /[\p{P}\p{S}]/u;
var _punctuationOrSpace = /[\s\p{P}\p{S}]/u;
var _notPunctuationOrSpace = /[^\s\p{P}\p{S}]/u;
var punctuation = edit(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, _punctuationOrSpace).getRegex();
var _punctuationGfmStrongEm = /(?!~)[\p{P}\p{S}]/u;
var _punctuationOrSpaceGfmStrongEm = /(?!~)[\s\p{P}\p{S}]/u;
var _notPunctuationOrSpaceGfmStrongEm = /(?:[^\s\p{P}\p{S}]|~)/u;
var blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g;
var emStrongLDelimCore = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/;
var emStrongLDelim = edit(emStrongLDelimCore, "u").replace(/punct/g, _punctuation).getRegex();
var emStrongLDelimGfm = edit(emStrongLDelimCore, "u").replace(/punct/g, _punctuationGfmStrongEm).getRegex();
var emStrongRDelimAstCore = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)";
var emStrongRDelimAst = edit(emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
var emStrongRDelimAstGfm = edit(emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, _notPunctuationOrSpaceGfmStrongEm).replace(/punctSpace/g, _punctuationOrSpaceGfmStrongEm).replace(/punct/g, _punctuationGfmStrongEm).getRegex();
var emStrongRDelimUnd = edit(
  "^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)",
  "gu"
).replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
var anyPunctuation = edit(/\\(punct)/, "gu").replace(/punct/g, _punctuation).getRegex();
var autolink$2 = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
var _inlineComment = edit(_comment).replace("(?:-->|$)", "-->").getRegex();
var tag = edit(
  "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>"
).replace("comment", _inlineComment).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
var _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
var link$2 = edit(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]*(?:\n[ \t]*)?)(title))?\s*\)/).replace("label", _inlineLabel).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
var reflink = edit(/^!?\[(label)\]\[(ref)\]/).replace("label", _inlineLabel).replace("ref", _blockLabel).getRegex();
var nolink = edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", _blockLabel).getRegex();
var reflinkSearch = edit("reflink|nolink(?!\\()", "g").replace("reflink", reflink).replace("nolink", nolink).getRegex();
var inlineNormal = {
  _backpedal: noopTest,
  // only used for GFM url
  anyPunctuation,
  autolink: autolink$2,
  blockSkip,
  br,
  code: inlineCode$2,
  del: noopTest,
  emStrongLDelim,
  emStrongRDelimAst,
  emStrongRDelimUnd,
  escape: escape$1,
  link: link$2,
  nolink,
  punctuation,
  reflink,
  reflinkSearch,
  tag,
  text: inlineText,
  url: noopTest
};
var inlinePedantic = {
  ...inlineNormal,
  link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", _inlineLabel).getRegex(),
  reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", _inlineLabel).getRegex()
};
var inlineGfm = {
  ...inlineNormal,
  emStrongRDelimAst: emStrongRDelimAstGfm,
  emStrongLDelim: emStrongLDelimGfm,
  url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
  _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
var inlineBreaks = {
  ...inlineGfm,
  br: edit(br).replace("{2,}", "*").getRegex(),
  text: edit(inlineGfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
};
var block = {
  normal: blockNormal,
  gfm: blockGfm,
  pedantic: blockPedantic
};
var inline = {
  normal: inlineNormal,
  gfm: inlineGfm,
  breaks: inlineBreaks,
  pedantic: inlinePedantic
};
var escapeReplacements = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
var getEscapeReplacement = (ch) => escapeReplacements[ch];
function escape2(html2, encode) {
  if (encode) {
    if (other.escapeTest.test(html2)) {
      return html2.replace(other.escapeReplace, getEscapeReplacement);
    }
  } else {
    if (other.escapeTestNoEncode.test(html2)) {
      return html2.replace(other.escapeReplaceNoEncode, getEscapeReplacement);
    }
  }
  return html2;
}
function cleanUrl(href) {
  try {
    href = encodeURI(href).replace(other.percentDecode, "%");
  } catch {
    return null;
  }
  return href;
}
function splitCells(tableRow2, count2) {
  var _a3;
  const row = tableRow2.replace(other.findPipe, (match5, offset3, str) => {
    let escaped = false;
    let curr = offset3;
    while (--curr >= 0 && str[curr] === "\\") escaped = !escaped;
    if (escaped) {
      return "|";
    } else {
      return " |";
    }
  }), cells = row.split(other.splitPipe);
  let i = 0;
  if (!cells[0].trim()) {
    cells.shift();
  }
  if (cells.length > 0 && !((_a3 = cells.at(-1)) == null ? void 0 : _a3.trim())) {
    cells.pop();
  }
  if (count2) {
    if (cells.length > count2) {
      cells.splice(count2);
    } else {
      while (cells.length < count2) cells.push("");
    }
  }
  for (; i < cells.length; i++) {
    cells[i] = cells[i].trim().replace(other.slashPipe, "|");
  }
  return cells;
}
function rtrim(str, c2, invert) {
  const l2 = str.length;
  if (l2 === 0) {
    return "";
  }
  let suffLen = 0;
  while (suffLen < l2) {
    const currChar = str.charAt(l2 - suffLen - 1);
    if (currChar === c2 && true) {
      suffLen++;
    } else {
      break;
    }
  }
  return str.slice(0, l2 - suffLen);
}
function findClosingBracket(str, b2) {
  if (str.indexOf(b2[1]) === -1) {
    return -1;
  }
  let level = 0;
  for (let i = 0; i < str.length; i++) {
    if (str[i] === "\\") {
      i++;
    } else if (str[i] === b2[0]) {
      level++;
    } else if (str[i] === b2[1]) {
      level--;
      if (level < 0) {
        return i;
      }
    }
  }
  if (level > 0) {
    return -2;
  }
  return -1;
}
function outputLink(cap2, link2, raw, lexer2, rules) {
  const href = link2.href;
  const title = link2.title || null;
  const text2 = cap2[1].replace(rules.other.outputLinkReplace, "$1");
  lexer2.state.inLink = true;
  const token2 = {
    type: cap2[0].charAt(0) === "!" ? "image" : "link",
    raw,
    href,
    title,
    text: text2,
    tokens: lexer2.inlineTokens(text2)
  };
  lexer2.state.inLink = false;
  return token2;
}
function indentCodeCompensation(raw, text2, rules) {
  const matchIndentToCode = raw.match(rules.other.indentCodeCompensation);
  if (matchIndentToCode === null) {
    return text2;
  }
  const indentToCode = matchIndentToCode[1];
  return text2.split("\n").map((node2) => {
    const matchIndentInNode = node2.match(rules.other.beginningSpace);
    if (matchIndentInNode === null) {
      return node2;
    }
    const [indentInNode] = matchIndentInNode;
    if (indentInNode.length >= indentToCode.length) {
      return node2.slice(indentToCode.length);
    }
    return node2;
  }).join("\n");
}
var _Tokenizer = class {
  // set by the lexer
  constructor(options2) {
    __publicField(this, "options");
    __publicField(this, "rules");
    // set by the lexer
    __publicField(this, "lexer");
    this.options = options2 || _defaults;
  }
  space(src) {
    const cap2 = this.rules.block.newline.exec(src);
    if (cap2 && cap2[0].length > 0) {
      return {
        type: "space",
        raw: cap2[0]
      };
    }
  }
  code(src) {
    const cap2 = this.rules.block.code.exec(src);
    if (cap2) {
      const text2 = cap2[0].replace(this.rules.other.codeRemoveIndent, "");
      return {
        type: "code",
        raw: cap2[0],
        codeBlockStyle: "indented",
        text: !this.options.pedantic ? rtrim(text2, "\n") : text2
      };
    }
  }
  fences(src) {
    const cap2 = this.rules.block.fences.exec(src);
    if (cap2) {
      const raw = cap2[0];
      const text2 = indentCodeCompensation(raw, cap2[3] || "", this.rules);
      return {
        type: "code",
        raw,
        lang: cap2[2] ? cap2[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : cap2[2],
        text: text2
      };
    }
  }
  heading(src) {
    const cap2 = this.rules.block.heading.exec(src);
    if (cap2) {
      let text2 = cap2[2].trim();
      if (this.rules.other.endingHash.test(text2)) {
        const trimmed = rtrim(text2, "#");
        if (this.options.pedantic) {
          text2 = trimmed.trim();
        } else if (!trimmed || this.rules.other.endingSpaceChar.test(trimmed)) {
          text2 = trimmed.trim();
        }
      }
      return {
        type: "heading",
        raw: cap2[0],
        depth: cap2[1].length,
        text: text2,
        tokens: this.lexer.inline(text2)
      };
    }
  }
  hr(src) {
    const cap2 = this.rules.block.hr.exec(src);
    if (cap2) {
      return {
        type: "hr",
        raw: rtrim(cap2[0], "\n")
      };
    }
  }
  blockquote(src) {
    const cap2 = this.rules.block.blockquote.exec(src);
    if (cap2) {
      let lines = rtrim(cap2[0], "\n").split("\n");
      let raw = "";
      let text2 = "";
      const tokens2 = [];
      while (lines.length > 0) {
        let inBlockquote = false;
        const currentLines = [];
        let i;
        for (i = 0; i < lines.length; i++) {
          if (this.rules.other.blockquoteStart.test(lines[i])) {
            currentLines.push(lines[i]);
            inBlockquote = true;
          } else if (!inBlockquote) {
            currentLines.push(lines[i]);
          } else {
            break;
          }
        }
        lines = lines.slice(i);
        const currentRaw = currentLines.join("\n");
        const currentText = currentRaw.replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
        raw = raw ? `${raw}
${currentRaw}` : currentRaw;
        text2 = text2 ? `${text2}
${currentText}` : currentText;
        const top2 = this.lexer.state.top;
        this.lexer.state.top = true;
        this.lexer.blockTokens(currentText, tokens2, true);
        this.lexer.state.top = top2;
        if (lines.length === 0) {
          break;
        }
        const lastToken = tokens2.at(-1);
        if ((lastToken == null ? void 0 : lastToken.type) === "code") {
          break;
        } else if ((lastToken == null ? void 0 : lastToken.type) === "blockquote") {
          const oldToken = lastToken;
          const newText = oldToken.raw + "\n" + lines.join("\n");
          const newToken = this.blockquote(newText);
          tokens2[tokens2.length - 1] = newToken;
          raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
          text2 = text2.substring(0, text2.length - oldToken.text.length) + newToken.text;
          break;
        } else if ((lastToken == null ? void 0 : lastToken.type) === "list") {
          const oldToken = lastToken;
          const newText = oldToken.raw + "\n" + lines.join("\n");
          const newToken = this.list(newText);
          tokens2[tokens2.length - 1] = newToken;
          raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
          text2 = text2.substring(0, text2.length - oldToken.raw.length) + newToken.raw;
          lines = newText.substring(tokens2.at(-1).raw.length).split("\n");
          continue;
        }
      }
      return {
        type: "blockquote",
        raw,
        tokens: tokens2,
        text: text2
      };
    }
  }
  list(src) {
    let cap2 = this.rules.block.list.exec(src);
    if (cap2) {
      let bull = cap2[1].trim();
      const isordered = bull.length > 1;
      const list2 = {
        type: "list",
        raw: "",
        ordered: isordered,
        start: isordered ? +bull.slice(0, -1) : "",
        loose: false,
        items: []
      };
      bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
      if (this.options.pedantic) {
        bull = isordered ? bull : "[*+-]";
      }
      const itemRegex = this.rules.other.listItemRegex(bull);
      let endsWithBlankLine = false;
      while (src) {
        let endEarly = false;
        let raw = "";
        let itemContents = "";
        if (!(cap2 = itemRegex.exec(src))) {
          break;
        }
        if (this.rules.block.hr.test(src)) {
          break;
        }
        raw = cap2[0];
        src = src.substring(raw.length);
        let line2 = cap2[2].split("\n", 1)[0].replace(this.rules.other.listReplaceTabs, (t2) => " ".repeat(3 * t2.length));
        let nextLine = src.split("\n", 1)[0];
        let blankLine2 = !line2.trim();
        let indent2 = 0;
        if (this.options.pedantic) {
          indent2 = 2;
          itemContents = line2.trimStart();
        } else if (blankLine2) {
          indent2 = cap2[1].length + 1;
        } else {
          indent2 = cap2[2].search(this.rules.other.nonSpaceChar);
          indent2 = indent2 > 4 ? 1 : indent2;
          itemContents = line2.slice(indent2);
          indent2 += cap2[1].length;
        }
        if (blankLine2 && this.rules.other.blankLine.test(nextLine)) {
          raw += nextLine + "\n";
          src = src.substring(nextLine.length + 1);
          endEarly = true;
        }
        if (!endEarly) {
          const nextBulletRegex = this.rules.other.nextBulletRegex(indent2);
          const hrRegex = this.rules.other.hrRegex(indent2);
          const fencesBeginRegex = this.rules.other.fencesBeginRegex(indent2);
          const headingBeginRegex = this.rules.other.headingBeginRegex(indent2);
          const htmlBeginRegex = this.rules.other.htmlBeginRegex(indent2);
          while (src) {
            const rawLine = src.split("\n", 1)[0];
            let nextLineWithoutTabs;
            nextLine = rawLine;
            if (this.options.pedantic) {
              nextLine = nextLine.replace(this.rules.other.listReplaceNesting, "  ");
              nextLineWithoutTabs = nextLine;
            } else {
              nextLineWithoutTabs = nextLine.replace(this.rules.other.tabCharGlobal, "    ");
            }
            if (fencesBeginRegex.test(nextLine)) {
              break;
            }
            if (headingBeginRegex.test(nextLine)) {
              break;
            }
            if (htmlBeginRegex.test(nextLine)) {
              break;
            }
            if (nextBulletRegex.test(nextLine)) {
              break;
            }
            if (hrRegex.test(nextLine)) {
              break;
            }
            if (nextLineWithoutTabs.search(this.rules.other.nonSpaceChar) >= indent2 || !nextLine.trim()) {
              itemContents += "\n" + nextLineWithoutTabs.slice(indent2);
            } else {
              if (blankLine2) {
                break;
              }
              if (line2.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4) {
                break;
              }
              if (fencesBeginRegex.test(line2)) {
                break;
              }
              if (headingBeginRegex.test(line2)) {
                break;
              }
              if (hrRegex.test(line2)) {
                break;
              }
              itemContents += "\n" + nextLine;
            }
            if (!blankLine2 && !nextLine.trim()) {
              blankLine2 = true;
            }
            raw += rawLine + "\n";
            src = src.substring(rawLine.length + 1);
            line2 = nextLineWithoutTabs.slice(indent2);
          }
        }
        if (!list2.loose) {
          if (endsWithBlankLine) {
            list2.loose = true;
          } else if (this.rules.other.doubleBlankLine.test(raw)) {
            endsWithBlankLine = true;
          }
        }
        let istask = null;
        let ischecked;
        if (this.options.gfm) {
          istask = this.rules.other.listIsTask.exec(itemContents);
          if (istask) {
            ischecked = istask[0] !== "[ ] ";
            itemContents = itemContents.replace(this.rules.other.listReplaceTask, "");
          }
        }
        list2.items.push({
          type: "list_item",
          raw,
          task: !!istask,
          checked: ischecked,
          loose: false,
          text: itemContents,
          tokens: []
        });
        list2.raw += raw;
      }
      const lastItem2 = list2.items.at(-1);
      if (lastItem2) {
        lastItem2.raw = lastItem2.raw.trimEnd();
        lastItem2.text = lastItem2.text.trimEnd();
      } else {
        return;
      }
      list2.raw = list2.raw.trimEnd();
      for (let i = 0; i < list2.items.length; i++) {
        this.lexer.state.top = false;
        list2.items[i].tokens = this.lexer.blockTokens(list2.items[i].text, []);
        if (!list2.loose) {
          const spacers = list2.items[i].tokens.filter((t2) => t2.type === "space");
          const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t2) => this.rules.other.anyLine.test(t2.raw));
          list2.loose = hasMultipleLineBreaks;
        }
      }
      if (list2.loose) {
        for (let i = 0; i < list2.items.length; i++) {
          list2.items[i].loose = true;
        }
      }
      return list2;
    }
  }
  html(src) {
    const cap2 = this.rules.block.html.exec(src);
    if (cap2) {
      const token2 = {
        type: "html",
        block: true,
        raw: cap2[0],
        pre: cap2[1] === "pre" || cap2[1] === "script" || cap2[1] === "style",
        text: cap2[0]
      };
      return token2;
    }
  }
  def(src) {
    const cap2 = this.rules.block.def.exec(src);
    if (cap2) {
      const tag2 = cap2[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " ");
      const href = cap2[2] ? cap2[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "";
      const title = cap2[3] ? cap2[3].substring(1, cap2[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : cap2[3];
      return {
        type: "def",
        tag: tag2,
        raw: cap2[0],
        href,
        title
      };
    }
  }
  table(src) {
    var _a3;
    const cap2 = this.rules.block.table.exec(src);
    if (!cap2) {
      return;
    }
    if (!this.rules.other.tableDelimiter.test(cap2[2])) {
      return;
    }
    const headers2 = splitCells(cap2[1]);
    const aligns = cap2[2].replace(this.rules.other.tableAlignChars, "").split("|");
    const rows = ((_a3 = cap2[3]) == null ? void 0 : _a3.trim()) ? cap2[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [];
    const item = {
      type: "table",
      raw: cap2[0],
      header: [],
      align: [],
      rows: []
    };
    if (headers2.length !== aligns.length) {
      return;
    }
    for (const align of aligns) {
      if (this.rules.other.tableAlignRight.test(align)) {
        item.align.push("right");
      } else if (this.rules.other.tableAlignCenter.test(align)) {
        item.align.push("center");
      } else if (this.rules.other.tableAlignLeft.test(align)) {
        item.align.push("left");
      } else {
        item.align.push(null);
      }
    }
    for (let i = 0; i < headers2.length; i++) {
      item.header.push({
        text: headers2[i],
        tokens: this.lexer.inline(headers2[i]),
        header: true,
        align: item.align[i]
      });
    }
    for (const row of rows) {
      item.rows.push(splitCells(row, item.header.length).map((cell, i) => {
        return {
          text: cell,
          tokens: this.lexer.inline(cell),
          header: false,
          align: item.align[i]
        };
      }));
    }
    return item;
  }
  lheading(src) {
    const cap2 = this.rules.block.lheading.exec(src);
    if (cap2) {
      return {
        type: "heading",
        raw: cap2[0],
        depth: cap2[2].charAt(0) === "=" ? 1 : 2,
        text: cap2[1],
        tokens: this.lexer.inline(cap2[1])
      };
    }
  }
  paragraph(src) {
    const cap2 = this.rules.block.paragraph.exec(src);
    if (cap2) {
      const text2 = cap2[1].charAt(cap2[1].length - 1) === "\n" ? cap2[1].slice(0, -1) : cap2[1];
      return {
        type: "paragraph",
        raw: cap2[0],
        text: text2,
        tokens: this.lexer.inline(text2)
      };
    }
  }
  text(src) {
    const cap2 = this.rules.block.text.exec(src);
    if (cap2) {
      return {
        type: "text",
        raw: cap2[0],
        text: cap2[0],
        tokens: this.lexer.inline(cap2[0])
      };
    }
  }
  escape(src) {
    const cap2 = this.rules.inline.escape.exec(src);
    if (cap2) {
      return {
        type: "escape",
        raw: cap2[0],
        text: cap2[1]
      };
    }
  }
  tag(src) {
    const cap2 = this.rules.inline.tag.exec(src);
    if (cap2) {
      if (!this.lexer.state.inLink && this.rules.other.startATag.test(cap2[0])) {
        this.lexer.state.inLink = true;
      } else if (this.lexer.state.inLink && this.rules.other.endATag.test(cap2[0])) {
        this.lexer.state.inLink = false;
      }
      if (!this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(cap2[0])) {
        this.lexer.state.inRawBlock = true;
      } else if (this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(cap2[0])) {
        this.lexer.state.inRawBlock = false;
      }
      return {
        type: "html",
        raw: cap2[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        block: false,
        text: cap2[0]
      };
    }
  }
  link(src) {
    const cap2 = this.rules.inline.link.exec(src);
    if (cap2) {
      const trimmedUrl = cap2[2].trim();
      if (!this.options.pedantic && this.rules.other.startAngleBracket.test(trimmedUrl)) {
        if (!this.rules.other.endAngleBracket.test(trimmedUrl)) {
          return;
        }
        const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
        if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
          return;
        }
      } else {
        const lastParenIndex = findClosingBracket(cap2[2], "()");
        if (lastParenIndex === -2) {
          return;
        }
        if (lastParenIndex > -1) {
          const start4 = cap2[0].indexOf("!") === 0 ? 5 : 4;
          const linkLen = start4 + cap2[1].length + lastParenIndex;
          cap2[2] = cap2[2].substring(0, lastParenIndex);
          cap2[0] = cap2[0].substring(0, linkLen).trim();
          cap2[3] = "";
        }
      }
      let href = cap2[2];
      let title = "";
      if (this.options.pedantic) {
        const link2 = this.rules.other.pedanticHrefTitle.exec(href);
        if (link2) {
          href = link2[1];
          title = link2[3];
        }
      } else {
        title = cap2[3] ? cap2[3].slice(1, -1) : "";
      }
      href = href.trim();
      if (this.rules.other.startAngleBracket.test(href)) {
        if (this.options.pedantic && !this.rules.other.endAngleBracket.test(trimmedUrl)) {
          href = href.slice(1);
        } else {
          href = href.slice(1, -1);
        }
      }
      return outputLink(cap2, {
        href: href ? href.replace(this.rules.inline.anyPunctuation, "$1") : href,
        title: title ? title.replace(this.rules.inline.anyPunctuation, "$1") : title
      }, cap2[0], this.lexer, this.rules);
    }
  }
  reflink(src, links) {
    let cap2;
    if ((cap2 = this.rules.inline.reflink.exec(src)) || (cap2 = this.rules.inline.nolink.exec(src))) {
      const linkString = (cap2[2] || cap2[1]).replace(this.rules.other.multipleSpaceGlobal, " ");
      const link2 = links[linkString.toLowerCase()];
      if (!link2) {
        const text2 = cap2[0].charAt(0);
        return {
          type: "text",
          raw: text2,
          text: text2
        };
      }
      return outputLink(cap2, link2, cap2[0], this.lexer, this.rules);
    }
  }
  emStrong(src, maskedSrc, prevChar = "") {
    let match5 = this.rules.inline.emStrongLDelim.exec(src);
    if (!match5) return;
    if (match5[3] && prevChar.match(this.rules.other.unicodeAlphaNumeric)) return;
    const nextChar = match5[1] || match5[2] || "";
    if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
      const lLength = [...match5[0]].length - 1;
      let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
      const endReg = match5[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
      endReg.lastIndex = 0;
      maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
      while ((match5 = endReg.exec(maskedSrc)) != null) {
        rDelim = match5[1] || match5[2] || match5[3] || match5[4] || match5[5] || match5[6];
        if (!rDelim) continue;
        rLength = [...rDelim].length;
        if (match5[3] || match5[4]) {
          delimTotal += rLength;
          continue;
        } else if (match5[5] || match5[6]) {
          if (lLength % 3 && !((lLength + rLength) % 3)) {
            midDelimTotal += rLength;
            continue;
          }
        }
        delimTotal -= rLength;
        if (delimTotal > 0) continue;
        rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
        const lastCharLength = [...match5[0]][0].length;
        const raw = src.slice(0, lLength + match5.index + lastCharLength + rLength);
        if (Math.min(lLength, rLength) % 2) {
          const text22 = raw.slice(1, -1);
          return {
            type: "em",
            raw,
            text: text22,
            tokens: this.lexer.inlineTokens(text22)
          };
        }
        const text2 = raw.slice(2, -2);
        return {
          type: "strong",
          raw,
          text: text2,
          tokens: this.lexer.inlineTokens(text2)
        };
      }
    }
  }
  codespan(src) {
    const cap2 = this.rules.inline.code.exec(src);
    if (cap2) {
      let text2 = cap2[2].replace(this.rules.other.newLineCharGlobal, " ");
      const hasNonSpaceChars = this.rules.other.nonSpaceChar.test(text2);
      const hasSpaceCharsOnBothEnds = this.rules.other.startingSpaceChar.test(text2) && this.rules.other.endingSpaceChar.test(text2);
      if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
        text2 = text2.substring(1, text2.length - 1);
      }
      return {
        type: "codespan",
        raw: cap2[0],
        text: text2
      };
    }
  }
  br(src) {
    const cap2 = this.rules.inline.br.exec(src);
    if (cap2) {
      return {
        type: "br",
        raw: cap2[0]
      };
    }
  }
  del(src) {
    const cap2 = this.rules.inline.del.exec(src);
    if (cap2) {
      return {
        type: "del",
        raw: cap2[0],
        text: cap2[2],
        tokens: this.lexer.inlineTokens(cap2[2])
      };
    }
  }
  autolink(src) {
    const cap2 = this.rules.inline.autolink.exec(src);
    if (cap2) {
      let text2, href;
      if (cap2[2] === "@") {
        text2 = cap2[1];
        href = "mailto:" + text2;
      } else {
        text2 = cap2[1];
        href = text2;
      }
      return {
        type: "link",
        raw: cap2[0],
        text: text2,
        href,
        tokens: [
          {
            type: "text",
            raw: text2,
            text: text2
          }
        ]
      };
    }
  }
  url(src) {
    var _a3;
    let cap2;
    if (cap2 = this.rules.inline.url.exec(src)) {
      let text2, href;
      if (cap2[2] === "@") {
        text2 = cap2[0];
        href = "mailto:" + text2;
      } else {
        let prevCapZero;
        do {
          prevCapZero = cap2[0];
          cap2[0] = ((_a3 = this.rules.inline._backpedal.exec(cap2[0])) == null ? void 0 : _a3[0]) ?? "";
        } while (prevCapZero !== cap2[0]);
        text2 = cap2[0];
        if (cap2[1] === "www.") {
          href = "http://" + cap2[0];
        } else {
          href = cap2[0];
        }
      }
      return {
        type: "link",
        raw: cap2[0],
        text: text2,
        href,
        tokens: [
          {
            type: "text",
            raw: text2,
            text: text2
          }
        ]
      };
    }
  }
  inlineText(src) {
    const cap2 = this.rules.inline.text.exec(src);
    if (cap2) {
      const escaped = this.lexer.state.inRawBlock;
      return {
        type: "text",
        raw: cap2[0],
        text: cap2[0],
        escaped
      };
    }
  }
};
var _Lexer = class __Lexer {
  constructor(options2) {
    __publicField(this, "tokens");
    __publicField(this, "options");
    __publicField(this, "state");
    __publicField(this, "tokenizer");
    __publicField(this, "inlineQueue");
    this.tokens = [];
    this.tokens.links = /* @__PURE__ */ Object.create(null);
    this.options = options2 || _defaults;
    this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
    this.tokenizer = this.options.tokenizer;
    this.tokenizer.options = this.options;
    this.tokenizer.lexer = this;
    this.inlineQueue = [];
    this.state = {
      inLink: false,
      inRawBlock: false,
      top: true
    };
    const rules = {
      other,
      block: block.normal,
      inline: inline.normal
    };
    if (this.options.pedantic) {
      rules.block = block.pedantic;
      rules.inline = inline.pedantic;
    } else if (this.options.gfm) {
      rules.block = block.gfm;
      if (this.options.breaks) {
        rules.inline = inline.breaks;
      } else {
        rules.inline = inline.gfm;
      }
    }
    this.tokenizer.rules = rules;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block,
      inline
    };
  }
  /**
   * Static Lex Method
   */
  static lex(src, options2) {
    const lexer2 = new __Lexer(options2);
    return lexer2.lex(src);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(src, options2) {
    const lexer2 = new __Lexer(options2);
    return lexer2.inlineTokens(src);
  }
  /**
   * Preprocessing
   */
  lex(src) {
    src = src.replace(other.carriageReturn, "\n");
    this.blockTokens(src, this.tokens);
    for (let i = 0; i < this.inlineQueue.length; i++) {
      const next2 = this.inlineQueue[i];
      this.inlineTokens(next2.src, next2.tokens);
    }
    this.inlineQueue = [];
    return this.tokens;
  }
  blockTokens(src, tokens2 = [], lastParagraphClipped = false) {
    var _a3, _b, _c;
    if (this.options.pedantic) {
      src = src.replace(other.tabCharGlobal, "    ").replace(other.spaceLine, "");
    }
    while (src) {
      let token2;
      if ((_b = (_a3 = this.options.extensions) == null ? void 0 : _a3.block) == null ? void 0 : _b.some((extTokenizer) => {
        if (token2 = extTokenizer.call({ lexer: this }, src, tokens2)) {
          src = src.substring(token2.raw.length);
          tokens2.push(token2);
          return true;
        }
        return false;
      })) {
        continue;
      }
      if (token2 = this.tokenizer.space(src)) {
        src = src.substring(token2.raw.length);
        const lastToken = tokens2.at(-1);
        if (token2.raw.length === 1 && lastToken !== void 0) {
          lastToken.raw += "\n";
        } else {
          tokens2.push(token2);
        }
        continue;
      }
      if (token2 = this.tokenizer.code(src)) {
        src = src.substring(token2.raw.length);
        const lastToken = tokens2.at(-1);
        if ((lastToken == null ? void 0 : lastToken.type) === "paragraph" || (lastToken == null ? void 0 : lastToken.type) === "text") {
          lastToken.raw += "\n" + token2.raw;
          lastToken.text += "\n" + token2.text;
          this.inlineQueue.at(-1).src = lastToken.text;
        } else {
          tokens2.push(token2);
        }
        continue;
      }
      if (token2 = this.tokenizer.fences(src)) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.heading(src)) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.hr(src)) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.blockquote(src)) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.list(src)) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.html(src)) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.def(src)) {
        src = src.substring(token2.raw.length);
        const lastToken = tokens2.at(-1);
        if ((lastToken == null ? void 0 : lastToken.type) === "paragraph" || (lastToken == null ? void 0 : lastToken.type) === "text") {
          lastToken.raw += "\n" + token2.raw;
          lastToken.text += "\n" + token2.raw;
          this.inlineQueue.at(-1).src = lastToken.text;
        } else if (!this.tokens.links[token2.tag]) {
          this.tokens.links[token2.tag] = {
            href: token2.href,
            title: token2.title
          };
        }
        continue;
      }
      if (token2 = this.tokenizer.table(src)) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.lheading(src)) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      let cutSrc = src;
      if ((_c = this.options.extensions) == null ? void 0 : _c.startBlock) {
        let startIndex = Infinity;
        const tempSrc = src.slice(1);
        let tempStart;
        this.options.extensions.startBlock.forEach((getStartIndex) => {
          tempStart = getStartIndex.call({ lexer: this }, tempSrc);
          if (typeof tempStart === "number" && tempStart >= 0) {
            startIndex = Math.min(startIndex, tempStart);
          }
        });
        if (startIndex < Infinity && startIndex >= 0) {
          cutSrc = src.substring(0, startIndex + 1);
        }
      }
      if (this.state.top && (token2 = this.tokenizer.paragraph(cutSrc))) {
        const lastToken = tokens2.at(-1);
        if (lastParagraphClipped && (lastToken == null ? void 0 : lastToken.type) === "paragraph") {
          lastToken.raw += "\n" + token2.raw;
          lastToken.text += "\n" + token2.text;
          this.inlineQueue.pop();
          this.inlineQueue.at(-1).src = lastToken.text;
        } else {
          tokens2.push(token2);
        }
        lastParagraphClipped = cutSrc.length !== src.length;
        src = src.substring(token2.raw.length);
        continue;
      }
      if (token2 = this.tokenizer.text(src)) {
        src = src.substring(token2.raw.length);
        const lastToken = tokens2.at(-1);
        if ((lastToken == null ? void 0 : lastToken.type) === "text") {
          lastToken.raw += "\n" + token2.raw;
          lastToken.text += "\n" + token2.text;
          this.inlineQueue.pop();
          this.inlineQueue.at(-1).src = lastToken.text;
        } else {
          tokens2.push(token2);
        }
        continue;
      }
      if (src) {
        const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
        if (this.options.silent) {
          console.error(errMsg);
          break;
        } else {
          throw new Error(errMsg);
        }
      }
    }
    this.state.top = true;
    return tokens2;
  }
  inline(src, tokens2 = []) {
    this.inlineQueue.push({ src, tokens: tokens2 });
    return tokens2;
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(src, tokens2 = []) {
    var _a3, _b, _c;
    let maskedSrc = src;
    let match5 = null;
    if (this.tokens.links) {
      const links = Object.keys(this.tokens.links);
      if (links.length > 0) {
        while ((match5 = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
          if (links.includes(match5[0].slice(match5[0].lastIndexOf("[") + 1, -1))) {
            maskedSrc = maskedSrc.slice(0, match5.index) + "[" + "a".repeat(match5[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
          }
        }
      }
    }
    while ((match5 = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null) {
      maskedSrc = maskedSrc.slice(0, match5.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
    }
    while ((match5 = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
      maskedSrc = maskedSrc.slice(0, match5.index) + "[" + "a".repeat(match5[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    }
    let keepPrevChar = false;
    let prevChar = "";
    while (src) {
      if (!keepPrevChar) {
        prevChar = "";
      }
      keepPrevChar = false;
      let token2;
      if ((_b = (_a3 = this.options.extensions) == null ? void 0 : _a3.inline) == null ? void 0 : _b.some((extTokenizer) => {
        if (token2 = extTokenizer.call({ lexer: this }, src, tokens2)) {
          src = src.substring(token2.raw.length);
          tokens2.push(token2);
          return true;
        }
        return false;
      })) {
        continue;
      }
      if (token2 = this.tokenizer.escape(src)) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.tag(src)) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.link(src)) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.reflink(src, this.tokens.links)) {
        src = src.substring(token2.raw.length);
        const lastToken = tokens2.at(-1);
        if (token2.type === "text" && (lastToken == null ? void 0 : lastToken.type) === "text") {
          lastToken.raw += token2.raw;
          lastToken.text += token2.text;
        } else {
          tokens2.push(token2);
        }
        continue;
      }
      if (token2 = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.codespan(src)) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.br(src)) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.del(src)) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      if (token2 = this.tokenizer.autolink(src)) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      if (!this.state.inLink && (token2 = this.tokenizer.url(src))) {
        src = src.substring(token2.raw.length);
        tokens2.push(token2);
        continue;
      }
      let cutSrc = src;
      if ((_c = this.options.extensions) == null ? void 0 : _c.startInline) {
        let startIndex = Infinity;
        const tempSrc = src.slice(1);
        let tempStart;
        this.options.extensions.startInline.forEach((getStartIndex) => {
          tempStart = getStartIndex.call({ lexer: this }, tempSrc);
          if (typeof tempStart === "number" && tempStart >= 0) {
            startIndex = Math.min(startIndex, tempStart);
          }
        });
        if (startIndex < Infinity && startIndex >= 0) {
          cutSrc = src.substring(0, startIndex + 1);
        }
      }
      if (token2 = this.tokenizer.inlineText(cutSrc)) {
        src = src.substring(token2.raw.length);
        if (token2.raw.slice(-1) !== "_") {
          prevChar = token2.raw.slice(-1);
        }
        keepPrevChar = true;
        const lastToken = tokens2.at(-1);
        if ((lastToken == null ? void 0 : lastToken.type) === "text") {
          lastToken.raw += token2.raw;
          lastToken.text += token2.text;
        } else {
          tokens2.push(token2);
        }
        continue;
      }
      if (src) {
        const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
        if (this.options.silent) {
          console.error(errMsg);
          break;
        } else {
          throw new Error(errMsg);
        }
      }
    }
    return tokens2;
  }
};
var _Renderer = class {
  // set by the parser
  constructor(options2) {
    __publicField(this, "options");
    __publicField(this, "parser");
    this.options = options2 || _defaults;
  }
  space(token2) {
    return "";
  }
  code({ text: text2, lang: lang2, escaped }) {
    var _a3;
    const langString = (_a3 = (lang2 || "").match(other.notSpaceStart)) == null ? void 0 : _a3[0];
    const code = text2.replace(other.endingNewline, "") + "\n";
    if (!langString) {
      return "<pre><code>" + (escaped ? code : escape2(code, true)) + "</code></pre>\n";
    }
    return '<pre><code class="language-' + escape2(langString) + '">' + (escaped ? code : escape2(code, true)) + "</code></pre>\n";
  }
  blockquote({ tokens: tokens2 }) {
    const body = this.parser.parse(tokens2);
    return `<blockquote>
${body}</blockquote>
`;
  }
  html({ text: text2 }) {
    return text2;
  }
  heading({ tokens: tokens2, depth }) {
    return `<h${depth}>${this.parser.parseInline(tokens2)}</h${depth}>
`;
  }
  hr(token2) {
    return "<hr>\n";
  }
  list(token2) {
    const ordered = token2.ordered;
    const start4 = token2.start;
    let body = "";
    for (let j2 = 0; j2 < token2.items.length; j2++) {
      const item = token2.items[j2];
      body += this.listitem(item);
    }
    const type = ordered ? "ol" : "ul";
    const startAttr = ordered && start4 !== 1 ? ' start="' + start4 + '"' : "";
    return "<" + type + startAttr + ">\n" + body + "</" + type + ">\n";
  }
  listitem(item) {
    var _a3;
    let itemBody = "";
    if (item.task) {
      const checkbox = this.checkbox({ checked: !!item.checked });
      if (item.loose) {
        if (((_a3 = item.tokens[0]) == null ? void 0 : _a3.type) === "paragraph") {
          item.tokens[0].text = checkbox + " " + item.tokens[0].text;
          if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") {
            item.tokens[0].tokens[0].text = checkbox + " " + escape2(item.tokens[0].tokens[0].text);
            item.tokens[0].tokens[0].escaped = true;
          }
        } else {
          item.tokens.unshift({
            type: "text",
            raw: checkbox + " ",
            text: checkbox + " ",
            escaped: true
          });
        }
      } else {
        itemBody += checkbox + " ";
      }
    }
    itemBody += this.parser.parse(item.tokens, !!item.loose);
    return `<li>${itemBody}</li>
`;
  }
  checkbox({ checked }) {
    return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
  }
  paragraph({ tokens: tokens2 }) {
    return `<p>${this.parser.parseInline(tokens2)}</p>
`;
  }
  table(token2) {
    let header = "";
    let cell = "";
    for (let j2 = 0; j2 < token2.header.length; j2++) {
      cell += this.tablecell(token2.header[j2]);
    }
    header += this.tablerow({ text: cell });
    let body = "";
    for (let j2 = 0; j2 < token2.rows.length; j2++) {
      const row = token2.rows[j2];
      cell = "";
      for (let k2 = 0; k2 < row.length; k2++) {
        cell += this.tablecell(row[k2]);
      }
      body += this.tablerow({ text: cell });
    }
    if (body) body = `<tbody>${body}</tbody>`;
    return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
  }
  tablerow({ text: text2 }) {
    return `<tr>
${text2}</tr>
`;
  }
  tablecell(token2) {
    const content2 = this.parser.parseInline(token2.tokens);
    const type = token2.header ? "th" : "td";
    const tag2 = token2.align ? `<${type} align="${token2.align}">` : `<${type}>`;
    return tag2 + content2 + `</${type}>
`;
  }
  /**
   * span level renderer
   */
  strong({ tokens: tokens2 }) {
    return `<strong>${this.parser.parseInline(tokens2)}</strong>`;
  }
  em({ tokens: tokens2 }) {
    return `<em>${this.parser.parseInline(tokens2)}</em>`;
  }
  codespan({ text: text2 }) {
    return `<code>${escape2(text2, true)}</code>`;
  }
  br(token2) {
    return "<br>";
  }
  del({ tokens: tokens2 }) {
    return `<del>${this.parser.parseInline(tokens2)}</del>`;
  }
  link({ href, title, tokens: tokens2 }) {
    const text2 = this.parser.parseInline(tokens2);
    const cleanHref = cleanUrl(href);
    if (cleanHref === null) {
      return text2;
    }
    href = cleanHref;
    let out = '<a href="' + href + '"';
    if (title) {
      out += ' title="' + escape2(title) + '"';
    }
    out += ">" + text2 + "</a>";
    return out;
  }
  image({ href, title, text: text2, tokens: tokens2 }) {
    if (tokens2) {
      text2 = this.parser.parseInline(tokens2, this.parser.textRenderer);
    }
    const cleanHref = cleanUrl(href);
    if (cleanHref === null) {
      return escape2(text2);
    }
    href = cleanHref;
    let out = `<img src="${href}" alt="${text2}"`;
    if (title) {
      out += ` title="${escape2(title)}"`;
    }
    out += ">";
    return out;
  }
  text(token2) {
    return "tokens" in token2 && token2.tokens ? this.parser.parseInline(token2.tokens) : "escaped" in token2 && token2.escaped ? token2.text : escape2(token2.text);
  }
};
var _TextRenderer = class {
  // no need for block level renderers
  strong({ text: text2 }) {
    return text2;
  }
  em({ text: text2 }) {
    return text2;
  }
  codespan({ text: text2 }) {
    return text2;
  }
  del({ text: text2 }) {
    return text2;
  }
  html({ text: text2 }) {
    return text2;
  }
  text({ text: text2 }) {
    return text2;
  }
  link({ text: text2 }) {
    return "" + text2;
  }
  image({ text: text2 }) {
    return "" + text2;
  }
  br() {
    return "";
  }
};
var _Parser = class __Parser {
  constructor(options2) {
    __publicField(this, "options");
    __publicField(this, "renderer");
    __publicField(this, "textRenderer");
    this.options = options2 || _defaults;
    this.options.renderer = this.options.renderer || new _Renderer();
    this.renderer = this.options.renderer;
    this.renderer.options = this.options;
    this.renderer.parser = this;
    this.textRenderer = new _TextRenderer();
  }
  /**
   * Static Parse Method
   */
  static parse(tokens2, options2) {
    const parser2 = new __Parser(options2);
    return parser2.parse(tokens2);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(tokens2, options2) {
    const parser2 = new __Parser(options2);
    return parser2.parseInline(tokens2);
  }
  /**
   * Parse Loop
   */
  parse(tokens2, top2 = true) {
    var _a3, _b;
    let out = "";
    for (let i = 0; i < tokens2.length; i++) {
      const anyToken = tokens2[i];
      if ((_b = (_a3 = this.options.extensions) == null ? void 0 : _a3.renderers) == null ? void 0 : _b[anyToken.type]) {
        const genericToken = anyToken;
        const ret = this.options.extensions.renderers[genericToken.type].call({ parser: this }, genericToken);
        if (ret !== false || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(genericToken.type)) {
          out += ret || "";
          continue;
        }
      }
      const token2 = anyToken;
      switch (token2.type) {
        case "space": {
          out += this.renderer.space(token2);
          continue;
        }
        case "hr": {
          out += this.renderer.hr(token2);
          continue;
        }
        case "heading": {
          out += this.renderer.heading(token2);
          continue;
        }
        case "code": {
          out += this.renderer.code(token2);
          continue;
        }
        case "table": {
          out += this.renderer.table(token2);
          continue;
        }
        case "blockquote": {
          out += this.renderer.blockquote(token2);
          continue;
        }
        case "list": {
          out += this.renderer.list(token2);
          continue;
        }
        case "html": {
          out += this.renderer.html(token2);
          continue;
        }
        case "paragraph": {
          out += this.renderer.paragraph(token2);
          continue;
        }
        case "text": {
          let textToken = token2;
          let body = this.renderer.text(textToken);
          while (i + 1 < tokens2.length && tokens2[i + 1].type === "text") {
            textToken = tokens2[++i];
            body += "\n" + this.renderer.text(textToken);
          }
          if (top2) {
            out += this.renderer.paragraph({
              type: "paragraph",
              raw: body,
              text: body,
              tokens: [{ type: "text", raw: body, text: body, escaped: true }]
            });
          } else {
            out += body;
          }
          continue;
        }
        default: {
          const errMsg = 'Token with "' + token2.type + '" type was not found.';
          if (this.options.silent) {
            console.error(errMsg);
            return "";
          } else {
            throw new Error(errMsg);
          }
        }
      }
    }
    return out;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(tokens2, renderer = this.renderer) {
    var _a3, _b;
    let out = "";
    for (let i = 0; i < tokens2.length; i++) {
      const anyToken = tokens2[i];
      if ((_b = (_a3 = this.options.extensions) == null ? void 0 : _a3.renderers) == null ? void 0 : _b[anyToken.type]) {
        const ret = this.options.extensions.renderers[anyToken.type].call({ parser: this }, anyToken);
        if (ret !== false || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(anyToken.type)) {
          out += ret || "";
          continue;
        }
      }
      const token2 = anyToken;
      switch (token2.type) {
        case "escape": {
          out += renderer.text(token2);
          break;
        }
        case "html": {
          out += renderer.html(token2);
          break;
        }
        case "link": {
          out += renderer.link(token2);
          break;
        }
        case "image": {
          out += renderer.image(token2);
          break;
        }
        case "strong": {
          out += renderer.strong(token2);
          break;
        }
        case "em": {
          out += renderer.em(token2);
          break;
        }
        case "codespan": {
          out += renderer.codespan(token2);
          break;
        }
        case "br": {
          out += renderer.br(token2);
          break;
        }
        case "del": {
          out += renderer.del(token2);
          break;
        }
        case "text": {
          out += renderer.text(token2);
          break;
        }
        default: {
          const errMsg = 'Token with "' + token2.type + '" type was not found.';
          if (this.options.silent) {
            console.error(errMsg);
            return "";
          } else {
            throw new Error(errMsg);
          }
        }
      }
    }
    return out;
  }
};
var _Hooks = (_a2 = class {
  constructor(options2) {
    __publicField(this, "options");
    __publicField(this, "block");
    this.options = options2 || _defaults;
  }
  /**
   * Process markdown before marked
   */
  preprocess(markdown) {
    return markdown;
  }
  /**
   * Process HTML after marked is finished
   */
  postprocess(html2) {
    return html2;
  }
  /**
   * Process all tokens before walk tokens
   */
  processAllTokens(tokens2) {
    return tokens2;
  }
  /**
   * Provide function to tokenize markdown
   */
  provideLexer() {
    return this.block ? _Lexer.lex : _Lexer.lexInline;
  }
  /**
   * Provide function to parse tokens
   */
  provideParser() {
    return this.block ? _Parser.parse : _Parser.parseInline;
  }
}, __publicField(_a2, "passThroughHooks", /* @__PURE__ */ new Set([
  "preprocess",
  "postprocess",
  "processAllTokens"
])), _a2);
var Marked = class {
  constructor(...args) {
    __publicField(this, "defaults", _getDefaults());
    __publicField(this, "options", this.setOptions);
    __publicField(this, "parse", this.parseMarkdown(true));
    __publicField(this, "parseInline", this.parseMarkdown(false));
    __publicField(this, "Parser", _Parser);
    __publicField(this, "Renderer", _Renderer);
    __publicField(this, "TextRenderer", _TextRenderer);
    __publicField(this, "Lexer", _Lexer);
    __publicField(this, "Tokenizer", _Tokenizer);
    __publicField(this, "Hooks", _Hooks);
    this.use(...args);
  }
  /**
   * Run callback for every token
   */
  walkTokens(tokens2, callback) {
    var _a3, _b;
    let values2 = [];
    for (const token2 of tokens2) {
      values2 = values2.concat(callback.call(this, token2));
      switch (token2.type) {
        case "table": {
          const tableToken = token2;
          for (const cell of tableToken.header) {
            values2 = values2.concat(this.walkTokens(cell.tokens, callback));
          }
          for (const row of tableToken.rows) {
            for (const cell of row) {
              values2 = values2.concat(this.walkTokens(cell.tokens, callback));
            }
          }
          break;
        }
        case "list": {
          const listToken = token2;
          values2 = values2.concat(this.walkTokens(listToken.items, callback));
          break;
        }
        default: {
          const genericToken = token2;
          if ((_b = (_a3 = this.defaults.extensions) == null ? void 0 : _a3.childTokens) == null ? void 0 : _b[genericToken.type]) {
            this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens) => {
              const tokens22 = genericToken[childTokens].flat(Infinity);
              values2 = values2.concat(this.walkTokens(tokens22, callback));
            });
          } else if (genericToken.tokens) {
            values2 = values2.concat(this.walkTokens(genericToken.tokens, callback));
          }
        }
      }
    }
    return values2;
  }
  use(...args) {
    const extensions = this.defaults.extensions || { renderers: {}, childTokens: {} };
    args.forEach((pack) => {
      const opts = { ...pack };
      opts.async = this.defaults.async || opts.async || false;
      if (pack.extensions) {
        pack.extensions.forEach((ext) => {
          if (!ext.name) {
            throw new Error("extension name required");
          }
          if ("renderer" in ext) {
            const prevRenderer = extensions.renderers[ext.name];
            if (prevRenderer) {
              extensions.renderers[ext.name] = function(...args2) {
                let ret = ext.renderer.apply(this, args2);
                if (ret === false) {
                  ret = prevRenderer.apply(this, args2);
                }
                return ret;
              };
            } else {
              extensions.renderers[ext.name] = ext.renderer;
            }
          }
          if ("tokenizer" in ext) {
            if (!ext.level || ext.level !== "block" && ext.level !== "inline") {
              throw new Error("extension level must be 'block' or 'inline'");
            }
            const extLevel = extensions[ext.level];
            if (extLevel) {
              extLevel.unshift(ext.tokenizer);
            } else {
              extensions[ext.level] = [ext.tokenizer];
            }
            if (ext.start) {
              if (ext.level === "block") {
                if (extensions.startBlock) {
                  extensions.startBlock.push(ext.start);
                } else {
                  extensions.startBlock = [ext.start];
                }
              } else if (ext.level === "inline") {
                if (extensions.startInline) {
                  extensions.startInline.push(ext.start);
                } else {
                  extensions.startInline = [ext.start];
                }
              }
            }
          }
          if ("childTokens" in ext && ext.childTokens) {
            extensions.childTokens[ext.name] = ext.childTokens;
          }
        });
        opts.extensions = extensions;
      }
      if (pack.renderer) {
        const renderer = this.defaults.renderer || new _Renderer(this.defaults);
        for (const prop in pack.renderer) {
          if (!(prop in renderer)) {
            throw new Error(`renderer '${prop}' does not exist`);
          }
          if (["options", "parser"].includes(prop)) {
            continue;
          }
          const rendererProp = prop;
          const rendererFunc = pack.renderer[rendererProp];
          const prevRenderer = renderer[rendererProp];
          renderer[rendererProp] = (...args2) => {
            let ret = rendererFunc.apply(renderer, args2);
            if (ret === false) {
              ret = prevRenderer.apply(renderer, args2);
            }
            return ret || "";
          };
        }
        opts.renderer = renderer;
      }
      if (pack.tokenizer) {
        const tokenizer = this.defaults.tokenizer || new _Tokenizer(this.defaults);
        for (const prop in pack.tokenizer) {
          if (!(prop in tokenizer)) {
            throw new Error(`tokenizer '${prop}' does not exist`);
          }
          if (["options", "rules", "lexer"].includes(prop)) {
            continue;
          }
          const tokenizerProp = prop;
          const tokenizerFunc = pack.tokenizer[tokenizerProp];
          const prevTokenizer = tokenizer[tokenizerProp];
          tokenizer[tokenizerProp] = (...args2) => {
            let ret = tokenizerFunc.apply(tokenizer, args2);
            if (ret === false) {
              ret = prevTokenizer.apply(tokenizer, args2);
            }
            return ret;
          };
        }
        opts.tokenizer = tokenizer;
      }
      if (pack.hooks) {
        const hooks2 = this.defaults.hooks || new _Hooks();
        for (const prop in pack.hooks) {
          if (!(prop in hooks2)) {
            throw new Error(`hook '${prop}' does not exist`);
          }
          if (["options", "block"].includes(prop)) {
            continue;
          }
          const hooksProp = prop;
          const hooksFunc = pack.hooks[hooksProp];
          const prevHook = hooks2[hooksProp];
          if (_Hooks.passThroughHooks.has(prop)) {
            hooks2[hooksProp] = (arg) => {
              if (this.defaults.async) {
                return Promise.resolve(hooksFunc.call(hooks2, arg)).then((ret2) => {
                  return prevHook.call(hooks2, ret2);
                });
              }
              const ret = hooksFunc.call(hooks2, arg);
              return prevHook.call(hooks2, ret);
            };
          } else {
            hooks2[hooksProp] = (...args2) => {
              let ret = hooksFunc.apply(hooks2, args2);
              if (ret === false) {
                ret = prevHook.apply(hooks2, args2);
              }
              return ret;
            };
          }
        }
        opts.hooks = hooks2;
      }
      if (pack.walkTokens) {
        const walkTokens2 = this.defaults.walkTokens;
        const packWalktokens = pack.walkTokens;
        opts.walkTokens = function(token2) {
          let values2 = [];
          values2.push(packWalktokens.call(this, token2));
          if (walkTokens2) {
            values2 = values2.concat(walkTokens2.call(this, token2));
          }
          return values2;
        };
      }
      this.defaults = { ...this.defaults, ...opts };
    });
    return this;
  }
  setOptions(opt) {
    this.defaults = { ...this.defaults, ...opt };
    return this;
  }
  lexer(src, options2) {
    return _Lexer.lex(src, options2 ?? this.defaults);
  }
  parser(tokens2, options2) {
    return _Parser.parse(tokens2, options2 ?? this.defaults);
  }
  parseMarkdown(blockType) {
    const parse22 = (src, options2) => {
      const origOpt = { ...options2 };
      const opt = { ...this.defaults, ...origOpt };
      const throwError = this.onError(!!opt.silent, !!opt.async);
      if (this.defaults.async === true && origOpt.async === false) {
        return throwError(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
      }
      if (typeof src === "undefined" || src === null) {
        return throwError(new Error("marked(): input parameter is undefined or null"));
      }
      if (typeof src !== "string") {
        return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
      }
      if (opt.hooks) {
        opt.hooks.options = opt;
        opt.hooks.block = blockType;
      }
      const lexer2 = opt.hooks ? opt.hooks.provideLexer() : blockType ? _Lexer.lex : _Lexer.lexInline;
      const parser2 = opt.hooks ? opt.hooks.provideParser() : blockType ? _Parser.parse : _Parser.parseInline;
      if (opt.async) {
        return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src2) => lexer2(src2, opt)).then((tokens2) => opt.hooks ? opt.hooks.processAllTokens(tokens2) : tokens2).then((tokens2) => opt.walkTokens ? Promise.all(this.walkTokens(tokens2, opt.walkTokens)).then(() => tokens2) : tokens2).then((tokens2) => parser2(tokens2, opt)).then((html2) => opt.hooks ? opt.hooks.postprocess(html2) : html2).catch(throwError);
      }
      try {
        if (opt.hooks) {
          src = opt.hooks.preprocess(src);
        }
        let tokens2 = lexer2(src, opt);
        if (opt.hooks) {
          tokens2 = opt.hooks.processAllTokens(tokens2);
        }
        if (opt.walkTokens) {
          this.walkTokens(tokens2, opt.walkTokens);
        }
        let html2 = parser2(tokens2, opt);
        if (opt.hooks) {
          html2 = opt.hooks.postprocess(html2);
        }
        return html2;
      } catch (e) {
        return throwError(e);
      }
    };
    return parse22;
  }
  onError(silent, async) {
    return (e) => {
      e.message += "\nPlease report this to https://github.com/markedjs/marked.";
      if (silent) {
        const msg = "<p>An error occurred:</p><pre>" + escape2(e.message + "", true) + "</pre>";
        if (async) {
          return Promise.resolve(msg);
        }
        return msg;
      }
      if (async) {
        return Promise.reject(e);
      }
      throw e;
    };
  }
};
var markedInstance = new Marked();
function marked(src, opt) {
  return markedInstance.parse(src, opt);
}
marked.options = marked.setOptions = function(options2) {
  markedInstance.setOptions(options2);
  marked.defaults = markedInstance.defaults;
  changeDefaults(marked.defaults);
  return marked;
};
marked.getDefaults = _getDefaults;
marked.defaults = _defaults;
marked.use = function(...args) {
  markedInstance.use(...args);
  marked.defaults = markedInstance.defaults;
  changeDefaults(marked.defaults);
  return marked;
};
marked.walkTokens = function(tokens2, callback) {
  return markedInstance.walkTokens(tokens2, callback);
};
marked.parseInline = markedInstance.parseInline;
marked.Parser = _Parser;
marked.parser = _Parser.parse;
marked.Renderer = _Renderer;
marked.TextRenderer = _TextRenderer;
marked.Lexer = _Lexer;
marked.lexer = _Lexer.lex;
marked.Tokenizer = _Tokenizer;
marked.Hooks = _Hooks;
marked.parse = marked;
marked.options;
marked.setOptions;
marked.use;
marked.walkTokens;
marked.parseInline;
_Parser.parse;
_Lexer.lex;
const InfoListItem$1 = ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  Flex,
  {
    pl: 10,
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 6,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Box$1,
        {
          pr: 8,
          pb: 2,
          dangerouslySetInnerHTML: { __html: marked(field.text) }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { color: "gray.500", children: "INFO" })
    ]
  }
);
const InputFieldListItem$1 = ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { justifyContent: "space-between", alignItems: "center", marginBottom: 6, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { fontWeight: "bold", children: [
    field.label || humanizeString(field.name),
    " ",
    field.required && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "required", children: "*" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { color: "gray.500", children: "FIELD" })
] });
const SessionFieldListItem$1 = ({
  field
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { justifyContent: "space-between", alignItems: "center", marginBottom: 6, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { fontWeight: "bold", children: [
    field.label || humanizeString(field.name),
    " ",
    field.required && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "required", children: "*" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { color: "gray.500", children: "SESSION" })
] });
const FieldListItem$3 = ({ field }) => {
  switch (field.type) {
    case "page":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(PageListItem$1, { field });
    case "section":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SectionListItem$1, { field });
    case "session_booking":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SessionFieldListItem$1, { field });
    case "info":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(InfoListItem$1, { field });
    case "room_block":
      return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Room Block" });
    case "lead_scanner":
      return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Lead Scanner" });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(InputFieldListItem$1, { field });
  }
};
const TrackFieldList$1 = ({ fields, track: track2 }) => {
  const trackFields = fields.filter((f2) => isTrackVisible(f2, track2));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(List$1, { paddingBottom: 3, children: trackFields.map((field) => /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItem$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldListItem$3, { field }),
    isFieldContainer(field) && /* @__PURE__ */ jsxRuntimeExports.jsx(TrackFieldList$1, { fields: field.fields, track: track2 })
  ] }, field.name)) });
};
const TrackFieldsModal = ({
  track: track2,
  renderButton
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { form } = useRegForm();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    renderButton === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", onClick: onOpen, children: "View track fields" }) : renderButton({ isOpen, onOpen, onClose }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Modal,
      {
        isOpen,
        onClose,
        size: "xl",
        scrollBehavior: "inside",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalContent, { minW: 700, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Event Tracks" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalBody, { px: 50, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Heading$5, { as: "h1", color: "gray.700", textAlign: "center", children: [
                track2.name,
                " / Fields"
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(TrackFieldList$1, { track: track2, fields: form.fields })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              ModalFooter,
              {
                px: 10,
                display: "flex",
                bg: "gray.50",
                justifyContent: "flex-end",
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: onClose, colorScheme: "blue", children: "Close" })
              }
            )
          ] })
        ]
      }
    )
  ] });
};
const appendField = (fields, field) => {
  switch (field.type) {
    case "page":
    case "section":
      return prePopChildren(field).reduce(
        (previousFields, childField) => appendField(previousFields, childField),
        [...fields]
      );
    default:
      const fieldExists = fields.includes(field.name);
      if (fieldExists) {
        return [...fields];
      } else {
        return [...fields, field.name];
      }
  }
};
const removeField = (fields, field) => {
  switch (field.type) {
    case "page":
    case "section":
      return prePopChildren(field).reduce(
        (previousFields, childField) => removeField(previousFields, childField),
        fields
      );
    default:
      return fields.filter((fieldName) => fieldName !== field.name);
  }
};
const prePopFieldsReducer = (fields, action) => {
  switch (action.type) {
    case "ADD_FIELD":
      return appendField(fields, action.field);
    case "REMOVE_FIELD":
      return removeField(fields, action.field);
  }
};
const GuestTrackFields = ({
  fields,
  track: track2,
  prePopFields,
  onChange
}) => {
  const trackFields = fields.filter((f2) => isTrackVisible(f2, track2));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(List$1, { paddingBottom: 3, children: trackFields.map((field) => /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItem$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { justifyContent: "space-between", alignItems: "flex-start", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { flexGrow: 1, pb: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldListItem$3, { field }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormControl$2,
        {
          width: "180px",
          pl: field.type === "page" ? 5 : 10,
          pt: field.type === "page" ? 20 : 0,
          mr: 0,
          ml: 5,
          children: canPrePop(field) && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Checkbox$2,
            {
              isChecked: fieldIsPrePop(field, prePopFields),
              onChange: () => onChange(field),
              defaultChecked: false,
              children: "Pre-populate"
            }
          )
        }
      )
    ] }),
    isFieldContainer(field) && /* @__PURE__ */ jsxRuntimeExports.jsx(
      GuestTrackFields,
      {
        fields: field.fields,
        track: track2,
        prePopFields,
        onChange
      }
    )
  ] }, field.name)) });
};
const GuestTrackFieldsContainer = ({
  fields,
  track: track2,
  onChange
}) => {
  const [prePopFields, dispatch] = useReducer(
    prePopFieldsReducer,
    track2.prePopulateFields !== void 0 ? track2.prePopulateFields : [],
    (init2) => init2
  );
  useEffect(() => {
    onChange(prePopFields);
  }, [prePopFields]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    GuestTrackFields,
    {
      fields,
      track: track2,
      prePopFields,
      onChange: (field) => !fieldIsPrePop(field, prePopFields) ? dispatch({ type: "ADD_FIELD", field }) : dispatch({ type: "REMOVE_FIELD", field })
    }
  );
};
const GuestTrackModal = ({
  track: initialTrack,
  renderButton
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { form } = useRegForm();
  const [track2, setTrack] = useState(initialTrack);
  const mutation = useUpdateTrack({ onSuccess: onClose });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    renderButton === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", onClick: onOpen, children: "Track fields and pre-population" }) : renderButton({ isOpen, onOpen, onClose }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Modal,
      {
        isOpen,
        onClose,
        size: "xl",
        scrollBehavior: "inside",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalContent, { minW: 800, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Event Tracks" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalBody, { px: 50, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Heading$5, { as: "h1", color: "gray.700", textAlign: "center", children: [
                track2.name,
                " / Fields"
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { pt: 10, children: [
                "Here are the fields in the track ",
                /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: track2.name }),
                '. Check "',
                /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: "Pre-populate" }),
                "&quote; to automatically pre-populate these fields from the main registration."
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                GuestTrackFieldsContainer,
                {
                  track: track2,
                  fields: form.fields,
                  onChange: (prePopulateFields) => setTrack({ ...track2, prePopulateFields })
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              ModalFooter,
              {
                px: 10,
                display: "flex",
                bg: "gray.50",
                justifyContent: "space-between",
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: onClose, colorScheme: "blue", children: "Close" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Button$1,
                    {
                      disabled: track2.prePopulateFields === void 0,
                      onClick: () => track2.prePopulateFields !== void 0 && mutation.mutate({
                        id: track2.id,
                        prePopulateFields: track2.prePopulateFields
                      }),
                      colorScheme: "green",
                      children: "Save"
                    }
                  )
                ]
              }
            )
          ] })
        ]
      }
    )
  ] });
};
const MetadataModal = ({
  title,
  metadata,
  onSave,
  renderButton
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const formRef = React__default.createRef();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    renderButton === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", onClick: onOpen, children: "Metadata" }) : renderButton({ isOpen, onOpen, onClose }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Modal,
      {
        isOpen,
        onClose,
        size: "xl",
        scrollBehavior: "inside",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalContent, { minW: 700, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Edit Metadata" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { as: "h1", color: "gray.700", pb: 16, textAlign: "center", children: title }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { px: 12, py: 5, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                MetadataForm,
                {
                  metadata,
                  onSave: (metadata2) => {
                    onClose();
                    onSave(metadata2);
                  },
                  formRef,
                  showSubmitButton: false
                }
              ) })
            ] }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              ModalFooter,
              {
                px: 10,
                display: "flex",
                bg: "gray.50",
                justifyContent: "space-between",
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onClose, children: "Cancel" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Button$1,
                    {
                      onClick: () => {
                        var _a3;
                        return (_a3 = formRef == null ? void 0 : formRef.current) == null ? void 0 : _a3.dispatchEvent(
                          new Event("submit", { cancelable: true, bubbles: true })
                        );
                      },
                      colorScheme: "green",
                      children: "Save Metadata"
                    }
                  )
                ]
              }
            )
          ] })
        ]
      }
    )
  ] });
};
const useDeleteTrack = (options) => {
  const { tracks } = useAdminApi();
  const queryClient = useQueryClient();
  const mutateFn = (track2) => tracks.deleteTrack(track2);
  return useMutation(mutateFn, {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["tracks"] });
    }
  });
};
const DeleteTrackMenuItem = ({
  track: track2
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const deleteMutation = useDeleteTrack();
  const cancelRef = useRef(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { fontSize: "sm", color: "red", onClick: onOpen, children: "Delete track" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AlertDialog,
      {
        isOpen,
        leastDestructiveRef: cancelRef,
        onClose,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertDialogOverlay, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(AlertDialogContent, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(AlertDialogHeader, { fontSize: "lg", fontWeight: "bold", children: "Delete Track" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(AlertDialogBody, { children: "Are you sure? The track will be permanently deleted." }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(AlertDialogFooter, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { ref: cancelRef, onClick: onClose, children: "Cancel" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button$1,
              {
                onClick: () => {
                  deleteMutation.mutate(track2);
                  onClose();
                },
                colorScheme: "red",
                ml: 3,
                children: "Delete"
              }
            )
          ] })
        ] }) })
      }
    )
  ] });
};
const formatPrice = (price, currency, prefix2 = "") => {
  if (price === null) {
    return null;
  }
  if (typeof price === "number") {
    return `${prefix2}${priceWithSymbol({ currency, price })}`;
  }
  return `${prefix2}${priceWithSymbol({ currency, price: price.min })} - ${priceWithSymbol({
    currency,
    price: price.max
  })}`;
};
const TrackPriceRange = ({
  track: track2,
  prefix: prefix2 = ""
}) => {
  const {
    formSettings: { shoppingCartCurrency: currency }
  } = useRegForm();
  const price = getTrackPrice(track2);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: formatPrice(price, currency, prefix2) });
};
const TrackCapacity$1 = ({
  track: track2,
  tracks
}) => {
  const capacity = trackCapacity(track2, tracks);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: capacity !== void 0 && capacity !== null ? capacity.toString() : "Unlimited" });
};
const GuestInviteSummary = ({ guestTrack, tracks }) => {
  const invites = invitesWithTrack(guestTrack, tracks);
  if (invites.length === 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      "GUEST TRACK. No invites yet",
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {})
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    "Guest of ",
    invites.map(({ inviterTrack }) => inviterTrack.name).join(", "),
    /* @__PURE__ */ jsxRuntimeExports.jsx("br", {})
  ] });
};
const TrackSidebarItem = ({
  track: track2,
  tracks,
  dndRef,
  dragHandleProps,
  ...props
}) => {
  const updateMutation = useUpdateTrack();
  const { formSettings } = useRegForm();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarItem, { ref: dndRef, ...props, py: 5, pr: 0, pl: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { justifyContent: "space-between", align: "flex-start", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      VStack,
      {
        align: "left",
        flexGrow: 1,
        spacing: 3,
        pt: 1,
        ...dragHandleProps,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { children: [
            track2.name,
            " ",
            /* @__PURE__ */ jsxRuntimeExports.jsx(TrackPriceRange, { track: track2, prefix: " " })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { fontSize: "xs", children: [
            isGuestTrack(track2) && /* @__PURE__ */ jsxRuntimeExports.jsx(GuestInviteSummary, { guestTrack: track2, tracks }),
            track2.inviteOnly ? "Invite only - " : null,
            "Registrations ",
            track2.numberBooked ? track2.numberBooked : 0,
            " / ",
            /* @__PURE__ */ jsxRuntimeExports.jsx(TrackCapacity$1, { track: track2, tracks })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Menu$1, { placement: "right-start", offset: [-12, 3], children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        MenuButton$1,
        {
          as: Button$1,
          variant: "text",
          _hover: { bg: "blackAlpha.200" },
          _focus: { boxShadow: "none" },
          sx: {
            padding: "4px 0 !important",
            width: "auto !important",
            height: "auto !important",
            fontSize: "16px !important"
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(HamburgerIcon, {})
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Portal$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(MenuList, { borderRadius: 0, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          EditTrackModal,
          {
            track: track2,
            onUpdated: () => console.log("edit track updated"),
            renderButton: ({ onOpen }) => /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { fontSize: "sm", onClick: onOpen, children: "Edit track" })
          }
        ),
        isGuestTrack(track2) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          GuestTrackModal,
          {
            track: track2,
            renderButton: ({ onOpen }) => /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { fontSize: "sm", onClick: onOpen, children: "Track fields and pre-population" })
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
          TrackFieldsModal,
          {
            track: track2,
            renderButton: ({ onOpen }) => /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { fontSize: "sm", onClick: onOpen, children: "Track fields preview" })
          }
        ),
        formSettings.metadataEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
          MetadataModal,
          {
            title: `Track ${track2.name}`,
            metadata: track2.metadata,
            onSave: (metadata) => updateMutation.mutate({ id: track2.id, metadata }),
            renderButton: ({ onOpen }) => /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { fontSize: "sm", onClick: onOpen, children: "Track metadata" })
          }
        ),
        canDeleteTrack(track2) && /* @__PURE__ */ jsxRuntimeExports.jsx(DeleteTrackMenuItem, { track: track2 })
      ] }) })
    ] })
  ] }) }, track2.id);
};
const useAddTrack = (options) => {
  const queryClient = useQueryClient();
  const { tracks } = useAdminApi();
  const mutateFn = (newTrack) => tracks.createTrack(newTrack);
  return useMutation(mutateFn, {
    ...options,
    onSuccess: (data, variables, context) => {
      var _a3;
      queryClient.invalidateQueries({ queryKey: ["tracks"] });
      (_a3 = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a3.call(void 0, data, variables, context);
    }
  });
};
const AddTrack$1 = ({ onAdded, onCancel }) => {
  const mutation = useAddTrack({ onSuccess: onAdded });
  const { tracks } = useTracks();
  const formRef = React__default.createRef();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Event Tracks" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalBody, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { as: "h1", color: "gray.700", pb: 16, textAlign: "center", children: "Add Track" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TrackForm$1,
        {
          formRef,
          onSubmit: (track2) => mutation.mutate({
            ...track2,
            sort: getNextSort(tracks)
          })
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              disabled: mutation.isLoading,
              onClick: () => {
                var _a3;
                return (_a3 = formRef == null ? void 0 : formRef.current) == null ? void 0 : _a3.dispatchEvent(
                  new Event("submit", { cancelable: true, bubbles: true })
                );
              },
              colorScheme: "green",
              children: "Create Track"
            }
          )
        ]
      }
    )
  ] });
};
const AddTrackModal = ({
  onAdded,
  renderButton
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    renderButton === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", onClick: onOpen, children: "Add Track" }) : renderButton({ isOpen, onOpen, onClose }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Modal,
      {
        isOpen,
        onClose,
        size: "xl",
        scrollBehavior: "inside",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalContent, { minW: 850, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            AddTrack$1,
            {
              onAdded: (track2) => {
                onAdded == null ? void 0 : onAdded.call(void 0, track2);
                onClose();
              },
              onCancel: onClose
            }
          ) })
        ]
      }
    )
  ] });
};
const AddTrackButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  AddTrackModal,
  {
    renderButton: ({ onOpen }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { width: "full", colorScheme: "blue", onClick: onOpen, children: "Add Track" })
  }
);
const TracksMenu = ({ tracks, onMoveTrack }) => {
  const handleMoveTrack = (result) => {
    if (result.destination === void 0 || result.destination === null) {
      return;
    }
    onMoveTrack(result.source.index, result.destination.index);
  };
  if (tracks.length === 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { px: 3, children: "Tracks are custom registration paths through your event." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { py: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AddTrackButton, {}) })
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(DragDropContext$1, { onDragEnd: handleMoveTrack, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectedDroppable$1, { droppableId: "pagesMenu", children: (provided) => /* @__PURE__ */ jsxRuntimeExports.jsxs(List$1, { ref: provided.innerRef, children: [
      tracks.map((track2, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        PublicDraggable,
        {
          draggableId: track2.id.toString(),
          index: index2,
          children: (provided2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            TrackSidebarItem,
            {
              dndRef: provided2.innerRef,
              ...provided2.draggableProps,
              dragHandleProps: provided2.dragHandleProps,
              track: track2,
              tracks
            }
          )
        },
        track2.id
      )),
      provided.placeholder
    ] }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { py: 5, pr: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AddTrackButton, {}) })
  ] });
};
const TrackUpdateContext = createContext({});
const TrackUpdateProvider = ({ tracksLastUpdated, children }) => /* @__PURE__ */ jsxRuntimeExports.jsx(TrackUpdateContext.Provider, { value: { tracksLastUpdated }, children });
const useTracksLastUpdated = () => useContext(TrackUpdateContext);
const TracksMenuContainer$1 = () => {
  const { data, isLoading, selectedTracks, selectTracks } = useTracks();
  const mutation = useUpdateTrack();
  const queryClient = useQueryClient();
  const [tracks, setTracks] = useState();
  const { tracksLastUpdated } = useTracksLastUpdated();
  useEffect(() => {
    if (data !== void 0) {
      setTracks(getSortedItems(data));
    }
  }, [data]);
  useEffect(() => {
    console.log("Invalidating tracks query", tracksLastUpdated);
    queryClient.refetchQueries({ queryKey: ["tracks"] });
  }, [tracksLastUpdated]);
  if (tracks === void 0 || isLoading) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { py: 8, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {}) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TracksMenu,
    {
      tracks,
      onMoveTrack: (fromIndex, toIndex) => {
        const track2 = tracks[fromIndex];
        track2.sort = getNewSort(tracks, fromIndex, toIndex);
        setTracks(getSortedItems(tracks));
        mutation.mutate({ id: track2.id, sort: track2.sort });
      },
      onSelectTracks: selectTracks,
      selectedTracks
    }
  );
};
const TracksBlankPattern$1 = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { spacing: 5, pt: 3, px: 1, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { textAlign: "center", size: "md", lineHeight: 1.5, children: "Tracks Not Available" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { fontSize: "md", children: "Tracks are not available at this event as there have been registrations taken without a track." }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { fontSize: "md", children: "To use tracks on this event, please delete all existing registrations." })
] });
const SidebarTabs = () => {
  const { formSettings } = useRegForm();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Tabs, { isFitted: true, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(TabList, { borderBottomWidth: 1, borderBottomColor: "whiteAlpha.600", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarTab, { borderRight: "1px solid", borderRightColor: "whiteAlpha.600", children: "Pages" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarTab, { children: "Tracks" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(TabPanels, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(TabPanel, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(PagesMenuContainer, {}) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TabPanel, { children: formSettings.tracksBlockedByUntrackedRegistrations ? /* @__PURE__ */ jsxRuntimeExports.jsx(TracksBlankPattern$1, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(TracksMenuContainer$1, {}) })
    ] })
  ] });
};
const Sidebar = () => {
  const { formSettings } = useRegForm();
  if (formSettings.tracksEnabled || formSettings.tracksBlockedByUntrackedRegistrations) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarTabs, {});
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(PagesMenuContainer, {});
  }
};
const EditorMain = ({ children, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(GridItem, { gridArea: "main", ...props, children });
const EditorRightPanel = ({ children, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  GridItem,
  {
    gridArea: "right_panel",
    borderLeftWidth: "10px",
    borderLeftStyle: "solid",
    borderLeftColor: "blackAlpha.100",
    ...props,
    children
  }
);
const DEFAULT_MIN_LEGNTH$1 = 3;
const MinLengthInput$1 = ({
  minLength = DEFAULT_MIN_LEGNTH$1,
  value,
  onChange,
  ...inputProps
}) => {
  const [inputValue, setInputValue] = useState(value);
  useEffect(() => {
    setInputValue(value);
  }, [value]);
  const handleChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    if (newValue.length >= minLength) {
      onChange == null ? void 0 : onChange(e);
    } else {
      if (value !== void 0) {
        onChange == null ? void 0 : onChange({ ...e, target: { ...e.target, value: value.toString() } });
      }
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Input$1, { ...inputProps, value: inputValue, onChange: handleChange });
};
const isInputField$1 = (field) => field.type !== "page" && field.type !== "section" && field.type !== "info";
const FieldTextForm$1 = ({
  field,
  onChange,
  labelFieldLabel = "Field label"
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { id: "labelText", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { textStyle: "label", children: labelFieldLabel }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        MinLengthInput$1,
        {
          value: field.label,
          size: "lg",
          placeholder: labelFieldLabel,
          onChange: (e) => onChange({ label: e.target.value })
        }
      )
    ] }),
    isInputField$1(field) && /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { id: "helpText", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { textStyle: "label", children: "Field Help Text" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Textarea$1,
        {
          value: field.helpText,
          onChange: (e) => onChange({ helpText: e.target.value })
        }
      )
    ] })
  ] });
};
const FieldPropertiesForm$1 = ({
  field,
  onChange
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
    field.type !== "info" && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { id: "required", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox$2,
      {
        isChecked: field.required,
        onChange: (e) => onChange({ required: e.target.checked }),
        children: "Field is required"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { id: "officeOnly", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox$2,
      {
        isChecked: field.officeOnly,
        onChange: (e) => onChange({ officeOnly: e.target.checked }),
        children: "Field is admin visible only"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { id: "editLocked", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Checkbox$2,
      {
        isChecked: field.editLocked,
        onChange: (e) => onChange({ editLocked: e.target.checked }),
        children: [
          "Field is edit locked",
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "If selected, attendees cannot edit this field after registration. (Admins can still edit.)" })
        ]
      }
    ) }),
    field.type === "boolean" && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Checkbox$2,
      {
        onChange: (e) => onChange({ checkpoint: e.target.checked }),
        children: [
          "Create a checkpoint",
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "Create a checkpoint for users who select this field" })
        ]
      }
    ) })
  ] });
};
const isNumeric = (num) => (typeof num === "number" || typeof num === "string" && num.trim() !== "") && !isNaN(num);
const isChoiceNumeric = (choice) => isNumeric(choice.value);
const numericChoice = (choice) => isChoiceNumeric(choice) ? { ...choice, value: Number(choice.value) } : choice;
const inferDataTypeFromChoices = (field) => {
  const choices = normalizedFieldChoices(field);
  if (choices.every(isChoiceNumeric)) {
    return {
      type: "integer",
      choices: choices.map(numericChoice),
      includeBlank: field.includeBlank
    };
  } else {
    return {
      type: "string",
      choices: field.choices,
      includeBlank: field.includeBlank
    };
  }
};
const updateChoiceLabelAndValue = (choice, payload) => {
  const newChoice = { ...choice, ...payload };
  if ("label" in payload && payload.label !== void 0 && !("value" in payload) && choice.value === choice.label) {
    newChoice.value = payload.label;
  }
  return newChoice;
};
const choicesReducer = (state, action) => {
  switch (action.type) {
    case "add_choice":
      return [...state, { ...action.payload, id: idGenerator() }];
    case "update_choice":
      return state.map(
        (choice) => action.id === choice.id ? updateChoiceLabelAndValue(choice, action.payload) : choice
      );
    case "move_choice":
      const result = [...state];
      const [removed] = result.splice(action.startIndex, 1);
      result.splice(action.endIndex, 0, removed);
      return result;
    case "delete_choice":
      return state.filter((choice) => choice.id !== action.id);
  }
};
const ChoicesTable$1 = ({
  choices,
  showPrices = false,
  currency = "$",
  onMoveChoice,
  onUpdateChoice,
  onDeleteChoice,
  onEditMetadata
}) => {
  const handleDragEnd = (result) => {
    if (result.destination) {
      onMoveChoice(result.source.index, result.destination.index);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DragDropContext$1, { onDragEnd: handleDragEnd, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$3, { size: "sm", style: { tableLayout: "fixed" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Thead, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { width: "15%", children: "Sort" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Form Label (click to edit)" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Report Value (click to edit)" }),
      showPrices && /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { isNumeric: true, width: "20%", children: "Price" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { width: "12%" })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectedDroppable$1, { droppableId: "sessionSlots", children: (provided) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Tbody, { ref: provided.innerRef, ...provided.droppableProps, children: [
      choices.map((choice, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        PublicDraggable,
        {
          draggableId: choice.id,
          index: index2,
          children: (provided2, snapshot) => {
            var _a3;
            return /* @__PURE__ */ jsxRuntimeExports.jsxs(
              Tr,
              {
                display: snapshot.isDragging ? "table" : "table-row",
                ref: provided2.innerRef,
                ...provided2.draggableProps,
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "15%", ...provided2.dragHandleProps, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pl: 4, pb: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DragHandleIcon, { color: "gray.500" }) }) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { pl: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                    Editable$1,
                    {
                      placeholder: "Choose a label",
                      value: choice.label,
                      onChange: (label) => onUpdateChoice(choice, { label }),
                      children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx(EditablePreview, {}),
                        /* @__PURE__ */ jsxRuntimeExports.jsx(EditableInput, {})
                      ]
                    }
                  ) }) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { pl: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                    Editable$1,
                    {
                      placeholder: choice.label,
                      value: (_a3 = choice.value) == null ? void 0 : _a3.toString(),
                      onChange: (value) => onUpdateChoice(choice, { value }),
                      children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx(EditablePreview, {}),
                        /* @__PURE__ */ jsxRuntimeExports.jsx(EditableInput, {})
                      ]
                    }
                  ) }) }),
                  showPrices && /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "20%", px: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { justify: "flex-end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    PriceInput$3,
                    {
                      id: `slot-${choice.id}-price`,
                      valueInCents: choice.price,
                      currency,
                      onChange: (price) => onUpdateChoice(choice, { price })
                    }
                  ) }) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "15%", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonGroup$1, { spacing: 1, children: [
                    onEditMetadata !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
                      Button$1,
                      {
                        size: "xs",
                        colorScheme: "blue",
                        onClick: () => onEditMetadata(choice),
                        title: "Edit metadata",
                        children: "meta"
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      Button$1,
                      {
                        onClick: () => onDeleteChoice(choice),
                        colorScheme: "red",
                        size: "xs",
                        children: "Delete"
                      }
                    )
                  ] }) })
                ]
              }
            );
          }
        },
        choice.id
      )),
      provided.placeholder
    ] }) })
  ] }) });
};
const ChoicesEditor$1 = ({
  field,
  showPrices = false,
  currency = "$",
  onChange,
  onEditMetadata,
  onImportChoices
}) => {
  const [choices, dispatch] = useReducer(
    choicesReducer,
    normalizedFieldChoices(field)
  );
  useEffect(() => {
    onChange({ choices });
  }, [choices]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ChoicesTable$1,
      {
        choices,
        showPrices,
        currency,
        onMoveChoice: (startIndex, endIndex) => dispatch({ type: "move_choice", startIndex, endIndex }),
        onUpdateChoice: (choice, update2) => dispatch({ type: "update_choice", id: choice.id, payload: update2 }),
        onDeleteChoice: (choice) => dispatch({ type: "delete_choice", id: choice.id }),
        onEditMetadata: onEditMetadata !== void 0 ? (choice) => onEditMetadata(choice) : void 0
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        colorScheme: "blue",
        variant: "outline",
        onClick: () => dispatch({
          type: "add_choice",
          payload: {
            label: `Choice ${choices.length + 1}`,
            value: `Choice ${choices.length + 1}`
          }
        }),
        children: "Add Choice +"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { position: "relative", py: "1", px: "4", w: "100%", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider$2, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(AbsoluteCenter, { bg: "white", px: "4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { as: "b", children: "OR" }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        colorScheme: "blue",
        variant: "outline",
        mb: "4",
        onClick: onImportChoices,
        children: "Import choices"
      }
    ),
    field.kind !== "radio" && /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { isDisabled: choices.length === 0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox$2,
      {
        isChecked: field.includeBlank,
        onChange: (e) => onChange({ includeBlank: e.target.checked }),
        children: "Include a blank value in the choices list"
      }
    ) }) })
  ] });
};
const ChoiceIndex = ({
  field,
  showPrices,
  currency,
  onChange,
  onSave,
  onClose,
  onEditMetadata,
  onImportChoices
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Edit choices" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalBody, { px: 50, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Heading$5, { as: "h1", color: "gray.700", textAlign: "center", children: [
        field.label,
        " / choices"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pt: 10, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        ChoicesEditor$1,
        {
          field,
          showPrices,
          currency,
          onChange,
          onEditMetadata,
          onImportChoices
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: onClose, children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "green", onClick: onSave, children: "Save" })
        ]
      }
    )
  ] });
};
const ChoiceMetadata = ({
  field,
  choice,
  onSave,
  onCancel
}) => {
  const formRef = React__default.createRef();
  const [choices, dispatch] = useReducer(
    choicesReducer,
    normalizedFieldChoices(field)
  );
  const [saved, setSaved] = useState(false);
  useEffect(() => {
    if (saved) {
      onSave(choices);
    }
  }, [saved]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Edit choices" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalBody, { px: 50, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Heading$5, { as: "h1", color: "gray.700", textAlign: "center", children: [
        field.label,
        " / choices / ",
        choice.label,
        " / metadata"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { px: 12, py: 5, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        MetadataForm,
        {
          metadata: choice.metadata,
          onSave: (metadata) => {
            dispatch({
              type: "update_choice",
              id: choice.id,
              payload: { metadata }
            });
            setSaved(true);
          },
          formRef,
          showSubmitButton: false
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              onClick: () => {
                var _a3;
                return (_a3 = formRef == null ? void 0 : formRef.current) == null ? void 0 : _a3.dispatchEvent(
                  new Event("submit", { cancelable: true, bubbles: true })
                );
              },
              colorScheme: "green",
              children: "Save Metadata"
            }
          )
        ]
      }
    )
  ] });
};
var papaparse_min$1 = { exports: {} };
/* @license
Papa Parse
v5.5.3
https://github.com/mholt/PapaParse
License: MIT
*/
var papaparse_min = papaparse_min$1.exports;
var hasRequiredPapaparse_min;
function requirePapaparse_min() {
  if (hasRequiredPapaparse_min) return papaparse_min$1.exports;
  hasRequiredPapaparse_min = 1;
  (function(module2, exports) {
    ((e, t2) => {
      module2.exports = t2();
    })(papaparse_min, function r2() {
      var n2 = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n2 ? n2 : {};
      var d2, s2 = !n2.document && !!n2.postMessage, a2 = n2.IS_PAPA_WORKER || false, o2 = {}, h2 = 0, v2 = {};
      function u2(e) {
        this._handle = null, this._finished = false, this._completed = false, this._halted = false, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = true, this._completeResults = { data: [], errors: [], meta: {} }, (function(e2) {
          var t2 = b2(e2);
          t2.chunkSize = parseInt(t2.chunkSize), e2.step || e2.chunk || (t2.chunkSize = null);
          this._handle = new i(t2), (this._handle.streamer = this)._config = t2;
        }).call(this, e), this.parseChunk = function(t2, e2) {
          var i2 = parseInt(this._config.skipFirstNLines) || 0;
          if (this.isFirstChunk && 0 < i2) {
            let e3 = this._config.newline;
            e3 || (r3 = this._config.quoteChar || '"', e3 = this._handle.guessLineEndings(t2, r3)), t2 = [...t2.split(e3).slice(i2)].join(e3);
          }
          this.isFirstChunk && U2(this._config.beforeFirstChunk) && void 0 !== (r3 = this._config.beforeFirstChunk(t2)) && (t2 = r3), this.isFirstChunk = false, this._halted = false;
          var i2 = this._partialLine + t2, r3 = (this._partialLine = "", this._handle.parse(i2, this._baseIndex, !this._finished));
          if (!this._handle.paused() && !this._handle.aborted()) {
            t2 = r3.meta.cursor, i2 = (this._finished || (this._partialLine = i2.substring(t2 - this._baseIndex), this._baseIndex = t2), r3 && r3.data && (this._rowCount += r3.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview);
            if (a2) n2.postMessage({ results: r3, workerId: v2.WORKER_ID, finished: i2 });
            else if (U2(this._config.chunk) && !e2) {
              if (this._config.chunk(r3, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = true);
              this._completeResults = r3 = void 0;
            }
            return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(r3.data), this._completeResults.errors = this._completeResults.errors.concat(r3.errors), this._completeResults.meta = r3.meta), this._completed || !i2 || !U2(this._config.complete) || r3 && r3.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = true), i2 || r3 && r3.meta.paused || this._nextChunk(), r3;
          }
          this._halted = true;
        }, this._sendError = function(e2) {
          U2(this._config.error) ? this._config.error(e2) : a2 && this._config.error && n2.postMessage({ workerId: v2.WORKER_ID, error: e2, finished: false });
        };
      }
      function f2(e) {
        var r3;
        (e = e || {}).chunkSize || (e.chunkSize = v2.RemoteChunkSize), u2.call(this, e), this._nextChunk = s2 ? function() {
          this._readChunk(), this._chunkLoaded();
        } : function() {
          this._readChunk();
        }, this.stream = function(e2) {
          this._input = e2, this._nextChunk();
        }, this._readChunk = function() {
          if (this._finished) this._chunkLoaded();
          else {
            if (r3 = new XMLHttpRequest(), this._config.withCredentials && (r3.withCredentials = this._config.withCredentials), s2 || (r3.onload = y2(this._chunkLoaded, this), r3.onerror = y2(this._chunkError, this)), r3.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !s2), this._config.downloadRequestHeaders) {
              var e2, t2 = this._config.downloadRequestHeaders;
              for (e2 in t2) r3.setRequestHeader(e2, t2[e2]);
            }
            var i2;
            this._config.chunkSize && (i2 = this._start + this._config.chunkSize - 1, r3.setRequestHeader("Range", "bytes=" + this._start + "-" + i2));
            try {
              r3.send(this._config.downloadRequestBody);
            } catch (e3) {
              this._chunkError(e3.message);
            }
            s2 && 0 === r3.status && this._chunkError();
          }
        }, this._chunkLoaded = function() {
          4 === r3.readyState && (r3.status < 200 || 400 <= r3.status ? this._chunkError() : (this._start += this._config.chunkSize || r3.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((e2) => null !== (e2 = e2.getResponseHeader("Content-Range")) ? parseInt(e2.substring(e2.lastIndexOf("/") + 1)) : -1)(r3), this.parseChunk(r3.responseText)));
        }, this._chunkError = function(e2) {
          e2 = r3.statusText || e2;
          this._sendError(new Error(e2));
        };
      }
      function l2(e) {
        (e = e || {}).chunkSize || (e.chunkSize = v2.LocalChunkSize), u2.call(this, e);
        var i2, r3, n3 = "undefined" != typeof FileReader;
        this.stream = function(e2) {
          this._input = e2, r3 = e2.slice || e2.webkitSlice || e2.mozSlice, n3 ? ((i2 = new FileReader()).onload = y2(this._chunkLoaded, this), i2.onerror = y2(this._chunkError, this)) : i2 = new FileReaderSync(), this._nextChunk();
        }, this._nextChunk = function() {
          this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
          var e2 = this._input, t2 = (this._config.chunkSize && (t2 = Math.min(this._start + this._config.chunkSize, this._input.size), e2 = r3.call(e2, this._start, t2)), i2.readAsText(e2, this._config.encoding));
          n3 || this._chunkLoaded({ target: { result: t2 } });
        }, this._chunkLoaded = function(e2) {
          this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e2.target.result);
        }, this._chunkError = function() {
          this._sendError(i2.error);
        };
      }
      function c2(e) {
        var i2;
        u2.call(this, e = e || {}), this.stream = function(e2) {
          return i2 = e2, this._nextChunk();
        }, this._nextChunk = function() {
          var e2, t2;
          if (!this._finished) return e2 = this._config.chunkSize, i2 = e2 ? (t2 = i2.substring(0, e2), i2.substring(e2)) : (t2 = i2, ""), this._finished = !i2, this.parseChunk(t2);
        };
      }
      function p2(e) {
        u2.call(this, e = e || {});
        var t2 = [], i2 = true, r3 = false;
        this.pause = function() {
          u2.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
          u2.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e2) {
          this._input = e2, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
          r3 && 1 === t2.length && (this._finished = true);
        }, this._nextChunk = function() {
          this._checkIsFinished(), t2.length ? this.parseChunk(t2.shift()) : i2 = true;
        }, this._streamData = y2(function(e2) {
          try {
            t2.push("string" == typeof e2 ? e2 : e2.toString(this._config.encoding)), i2 && (i2 = false, this._checkIsFinished(), this.parseChunk(t2.shift()));
          } catch (e3) {
            this._streamError(e3);
          }
        }, this), this._streamError = y2(function(e2) {
          this._streamCleanUp(), this._sendError(e2);
        }, this), this._streamEnd = y2(function() {
          this._streamCleanUp(), r3 = true, this._streamData("");
        }, this), this._streamCleanUp = y2(function() {
          this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
      }
      function i(m3) {
        var n3, s3, a3, t2, o3 = Math.pow(2, 53), h3 = -o3, u3 = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, d3 = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, i2 = this, r3 = 0, f3 = 0, l3 = false, e = false, c3 = [], p3 = { data: [], errors: [], meta: {} };
        function y3(e2) {
          return "greedy" === m3.skipEmptyLines ? "" === e2.join("").trim() : 1 === e2.length && 0 === e2[0].length;
        }
        function g3() {
          if (p3 && a3 && (k2("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + v2.DefaultDelimiter + "'"), a3 = false), m3.skipEmptyLines && (p3.data = p3.data.filter(function(e3) {
            return !y3(e3);
          })), _3()) {
            let t3 = function(e3, t4) {
              U2(m3.transformHeader) && (e3 = m3.transformHeader(e3, t4)), c3.push(e3);
            };
            if (p3) if (Array.isArray(p3.data[0])) {
              for (var e2 = 0; _3() && e2 < p3.data.length; e2++) p3.data[e2].forEach(t3);
              p3.data.splice(0, 1);
            } else p3.data.forEach(t3);
          }
          function i3(e3, t3) {
            for (var i4 = m3.header ? {} : [], r5 = 0; r5 < e3.length; r5++) {
              var n4 = r5, s4 = e3[r5], s4 = ((e4, t4) => ((e5) => (m3.dynamicTypingFunction && void 0 === m3.dynamicTyping[e5] && (m3.dynamicTyping[e5] = m3.dynamicTypingFunction(e5)), true === (m3.dynamicTyping[e5] || m3.dynamicTyping)))(e4) ? "true" === t4 || "TRUE" === t4 || "false" !== t4 && "FALSE" !== t4 && (((e5) => {
                if (u3.test(e5)) {
                  e5 = parseFloat(e5);
                  if (h3 < e5 && e5 < o3) return 1;
                }
              })(t4) ? parseFloat(t4) : d3.test(t4) ? new Date(t4) : "" === t4 ? null : t4) : t4)(n4 = m3.header ? r5 >= c3.length ? "__parsed_extra" : c3[r5] : n4, s4 = m3.transform ? m3.transform(s4, n4) : s4);
              "__parsed_extra" === n4 ? (i4[n4] = i4[n4] || [], i4[n4].push(s4)) : i4[n4] = s4;
            }
            return m3.header && (r5 > c3.length ? k2("FieldMismatch", "TooManyFields", "Too many fields: expected " + c3.length + " fields but parsed " + r5, f3 + t3) : r5 < c3.length && k2("FieldMismatch", "TooFewFields", "Too few fields: expected " + c3.length + " fields but parsed " + r5, f3 + t3)), i4;
          }
          var r4;
          p3 && (m3.header || m3.dynamicTyping || m3.transform) && (r4 = 1, !p3.data.length || Array.isArray(p3.data[0]) ? (p3.data = p3.data.map(i3), r4 = p3.data.length) : p3.data = i3(p3.data, 0), m3.header && p3.meta && (p3.meta.fields = c3), f3 += r4);
        }
        function _3() {
          return m3.header && 0 === c3.length;
        }
        function k2(e2, t3, i3, r4) {
          e2 = { type: e2, code: t3, message: i3 };
          void 0 !== r4 && (e2.row = r4), p3.errors.push(e2);
        }
        U2(m3.step) && (t2 = m3.step, m3.step = function(e2) {
          p3 = e2, _3() ? g3() : (g3(), 0 !== p3.data.length && (r3 += e2.data.length, m3.preview && r3 > m3.preview ? s3.abort() : (p3.data = p3.data[0], t2(p3, i2))));
        }), this.parse = function(e2, t3, i3) {
          var r4 = m3.quoteChar || '"', r4 = (m3.newline || (m3.newline = this.guessLineEndings(e2, r4)), a3 = false, m3.delimiter ? U2(m3.delimiter) && (m3.delimiter = m3.delimiter(e2), p3.meta.delimiter = m3.delimiter) : ((r4 = ((e3, t4, i4, r5, n4) => {
            var s4, a4, o4, h4;
            n4 = n4 || [",", "	", "|", ";", v2.RECORD_SEP, v2.UNIT_SEP];
            for (var u4 = 0; u4 < n4.length; u4++) {
              for (var d4, f4 = n4[u4], l4 = 0, c4 = 0, p4 = 0, g4 = (o4 = void 0, new E2({ comments: r5, delimiter: f4, newline: t4, preview: 10 }).parse(e3)), _4 = 0; _4 < g4.data.length; _4++) i4 && y3(g4.data[_4]) ? p4++ : (d4 = g4.data[_4].length, c4 += d4, void 0 === o4 ? o4 = d4 : 0 < d4 && (l4 += Math.abs(d4 - o4), o4 = d4));
              0 < g4.data.length && (c4 /= g4.data.length - p4), (void 0 === a4 || l4 <= a4) && (void 0 === h4 || h4 < c4) && 1.99 < c4 && (a4 = l4, s4 = f4, h4 = c4);
            }
            return { successful: !!(m3.delimiter = s4), bestDelimiter: s4 };
          })(e2, m3.newline, m3.skipEmptyLines, m3.comments, m3.delimitersToGuess)).successful ? m3.delimiter = r4.bestDelimiter : (a3 = true, m3.delimiter = v2.DefaultDelimiter), p3.meta.delimiter = m3.delimiter), b2(m3));
          return m3.preview && m3.header && r4.preview++, n3 = e2, s3 = new E2(r4), p3 = s3.parse(n3, t3, i3), g3(), l3 ? { meta: { paused: true } } : p3 || { meta: { paused: false } };
        }, this.paused = function() {
          return l3;
        }, this.pause = function() {
          l3 = true, s3.abort(), n3 = U2(m3.chunk) ? "" : n3.substring(s3.getCharIndex());
        }, this.resume = function() {
          i2.streamer._halted ? (l3 = false, i2.streamer.parseChunk(n3, true)) : setTimeout(i2.resume, 3);
        }, this.aborted = function() {
          return e;
        }, this.abort = function() {
          e = true, s3.abort(), p3.meta.aborted = true, U2(m3.complete) && m3.complete(p3), n3 = "";
        }, this.guessLineEndings = function(e2, t3) {
          e2 = e2.substring(0, 1048576);
          var t3 = new RegExp(P2(t3) + "([^]*?)" + P2(t3), "gm"), i3 = (e2 = e2.replace(t3, "")).split("\r"), t3 = e2.split("\n"), e2 = 1 < t3.length && t3[0].length < i3[0].length;
          if (1 === i3.length || e2) return "\n";
          for (var r4 = 0, n4 = 0; n4 < i3.length; n4++) "\n" === i3[n4][0] && r4++;
          return r4 >= i3.length / 2 ? "\r\n" : "\r";
        };
      }
      function P2(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }
      function E2(C2) {
        var S2 = (C2 = C2 || {}).delimiter, O2 = C2.newline, x2 = C2.comments, I2 = C2.step, A2 = C2.preview, T2 = C2.fastMode, D2 = null, L2 = false, F2 = null == C2.quoteChar ? '"' : C2.quoteChar, j2 = F2;
        if (void 0 !== C2.escapeChar && (j2 = C2.escapeChar), ("string" != typeof S2 || -1 < v2.BAD_DELIMITERS.indexOf(S2)) && (S2 = ","), x2 === S2) throw new Error("Comment character same as delimiter");
        true === x2 ? x2 = "#" : ("string" != typeof x2 || -1 < v2.BAD_DELIMITERS.indexOf(x2)) && (x2 = false), "\n" !== O2 && "\r" !== O2 && "\r\n" !== O2 && (O2 = "\n");
        var z2 = 0, M2 = false;
        this.parse = function(i2, t2, r3) {
          if ("string" != typeof i2) throw new Error("Input must be a string");
          var n3 = i2.length, e = S2.length, s3 = O2.length, a3 = x2.length, o3 = U2(I2), h3 = [], u3 = [], d3 = [], f3 = z2 = 0;
          if (!i2) return w2();
          if (T2 || false !== T2 && -1 === i2.indexOf(F2)) {
            for (var l3 = i2.split(O2), c3 = 0; c3 < l3.length; c3++) {
              if (d3 = l3[c3], z2 += d3.length, c3 !== l3.length - 1) z2 += O2.length;
              else if (r3) return w2();
              if (!x2 || d3.substring(0, a3) !== x2) {
                if (o3) {
                  if (h3 = [], k2(d3.split(S2)), R2(), M2) return w2();
                } else k2(d3.split(S2));
                if (A2 && A2 <= c3) return h3 = h3.slice(0, A2), w2(true);
              }
            }
            return w2();
          }
          for (var p3 = i2.indexOf(S2, z2), g3 = i2.indexOf(O2, z2), _3 = new RegExp(P2(j2) + P2(F2), "g"), m3 = i2.indexOf(F2, z2); ; ) if (i2[z2] === F2) for (m3 = z2, z2++; ; ) {
            if (-1 === (m3 = i2.indexOf(F2, m3 + 1))) return r3 || u3.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: h3.length, index: z2 }), E3();
            if (m3 === n3 - 1) return E3(i2.substring(z2, m3).replace(_3, F2));
            if (F2 === j2 && i2[m3 + 1] === j2) m3++;
            else if (F2 === j2 || 0 === m3 || i2[m3 - 1] !== j2) {
              -1 !== p3 && p3 < m3 + 1 && (p3 = i2.indexOf(S2, m3 + 1));
              var y3 = v3(-1 === (g3 = -1 !== g3 && g3 < m3 + 1 ? i2.indexOf(O2, m3 + 1) : g3) ? p3 : Math.min(p3, g3));
              if (i2.substr(m3 + 1 + y3, e) === S2) {
                d3.push(i2.substring(z2, m3).replace(_3, F2)), i2[z2 = m3 + 1 + y3 + e] !== F2 && (m3 = i2.indexOf(F2, z2)), p3 = i2.indexOf(S2, z2), g3 = i2.indexOf(O2, z2);
                break;
              }
              y3 = v3(g3);
              if (i2.substring(m3 + 1 + y3, m3 + 1 + y3 + s3) === O2) {
                if (d3.push(i2.substring(z2, m3).replace(_3, F2)), b3(m3 + 1 + y3 + s3), p3 = i2.indexOf(S2, z2), m3 = i2.indexOf(F2, z2), o3 && (R2(), M2)) return w2();
                if (A2 && h3.length >= A2) return w2(true);
                break;
              }
              u3.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: h3.length, index: z2 }), m3++;
            }
          }
          else if (x2 && 0 === d3.length && i2.substring(z2, z2 + a3) === x2) {
            if (-1 === g3) return w2();
            z2 = g3 + s3, g3 = i2.indexOf(O2, z2), p3 = i2.indexOf(S2, z2);
          } else if (-1 !== p3 && (p3 < g3 || -1 === g3)) d3.push(i2.substring(z2, p3)), z2 = p3 + e, p3 = i2.indexOf(S2, z2);
          else {
            if (-1 === g3) break;
            if (d3.push(i2.substring(z2, g3)), b3(g3 + s3), o3 && (R2(), M2)) return w2();
            if (A2 && h3.length >= A2) return w2(true);
          }
          return E3();
          function k2(e2) {
            h3.push(e2), f3 = z2;
          }
          function v3(e2) {
            var t3 = 0;
            return t3 = -1 !== e2 && (e2 = i2.substring(m3 + 1, e2)) && "" === e2.trim() ? e2.length : t3;
          }
          function E3(e2) {
            return r3 || (void 0 === e2 && (e2 = i2.substring(z2)), d3.push(e2), z2 = n3, k2(d3), o3 && R2()), w2();
          }
          function b3(e2) {
            z2 = e2, k2(d3), d3 = [], g3 = i2.indexOf(O2, z2);
          }
          function w2(e2) {
            if (C2.header && !t2 && h3.length && !L2) {
              var s4 = h3[0], a4 = /* @__PURE__ */ Object.create(null), o4 = new Set(s4);
              let n4 = false;
              for (let r4 = 0; r4 < s4.length; r4++) {
                let i3 = s4[r4];
                if (a4[i3 = U2(C2.transformHeader) ? C2.transformHeader(i3, r4) : i3]) {
                  let e3, t3 = a4[i3];
                  for (; e3 = i3 + "_" + t3, t3++, o4.has(e3); ) ;
                  o4.add(e3), s4[r4] = e3, a4[i3]++, n4 = true, (D2 = null === D2 ? {} : D2)[e3] = i3;
                } else a4[i3] = 1, s4[r4] = i3;
                o4.add(i3);
              }
              n4 && console.warn("Duplicate headers found and renamed."), L2 = true;
            }
            return { data: h3, errors: u3, meta: { delimiter: S2, linebreak: O2, aborted: M2, truncated: !!e2, cursor: f3 + (t2 || 0), renamedHeaders: D2 } };
          }
          function R2() {
            I2(w2()), h3 = [], u3 = [];
          }
        }, this.abort = function() {
          M2 = true;
        }, this.getCharIndex = function() {
          return z2;
        };
      }
      function g2(e) {
        var t2 = e.data, i2 = o2[t2.workerId], r3 = false;
        if (t2.error) i2.userError(t2.error, t2.file);
        else if (t2.results && t2.results.data) {
          var n3 = { abort: function() {
            r3 = true, _2(t2.workerId, { data: [], errors: [], meta: { aborted: true } });
          }, pause: m2, resume: m2 };
          if (U2(i2.userStep)) {
            for (var s3 = 0; s3 < t2.results.data.length && (i2.userStep({ data: t2.results.data[s3], errors: t2.results.errors, meta: t2.results.meta }, n3), !r3); s3++) ;
            delete t2.results;
          } else U2(i2.userChunk) && (i2.userChunk(t2.results, n3, t2.file), delete t2.results);
        }
        t2.finished && !r3 && _2(t2.workerId, t2.results);
      }
      function _2(e, t2) {
        var i2 = o2[e];
        U2(i2.userComplete) && i2.userComplete(t2), i2.terminate(), delete o2[e];
      }
      function m2() {
        throw new Error("Not implemented.");
      }
      function b2(e) {
        if ("object" != typeof e || null === e) return e;
        var t2, i2 = Array.isArray(e) ? [] : {};
        for (t2 in e) i2[t2] = b2(e[t2]);
        return i2;
      }
      function y2(e, t2) {
        return function() {
          e.apply(t2, arguments);
        };
      }
      function U2(e) {
        return "function" == typeof e;
      }
      return v2.parse = function(e, t2) {
        var i2 = (t2 = t2 || {}).dynamicTyping || false;
        U2(i2) && (t2.dynamicTypingFunction = i2, i2 = {});
        if (t2.dynamicTyping = i2, t2.transform = !!U2(t2.transform) && t2.transform, !t2.worker || !v2.WORKERS_SUPPORTED) return i2 = null, v2.NODE_STREAM_INPUT, "string" == typeof e ? (e = ((e2) => 65279 !== e2.charCodeAt(0) ? e2 : e2.slice(1))(e), i2 = new (t2.download ? f2 : c2)(t2)) : true === e.readable && U2(e.read) && U2(e.on) ? i2 = new p2(t2) : (n2.File && e instanceof File || e instanceof Object) && (i2 = new l2(t2)), i2.stream(e);
        (i2 = (() => {
          var e2;
          return !!v2.WORKERS_SUPPORTED && (e2 = (() => {
            var e3 = n2.URL || n2.webkitURL || null, t3 = r2.toString();
            return v2.BLOB_URL || (v2.BLOB_URL = e3.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", t3, ")();"], { type: "text/javascript" })));
          })(), (e2 = new n2.Worker(e2)).onmessage = g2, e2.id = h2++, o2[e2.id] = e2);
        })()).userStep = t2.step, i2.userChunk = t2.chunk, i2.userComplete = t2.complete, i2.userError = t2.error, t2.step = U2(t2.step), t2.chunk = U2(t2.chunk), t2.complete = U2(t2.complete), t2.error = U2(t2.error), delete t2.worker, i2.postMessage({ input: e, config: t2, workerId: i2.id });
      }, v2.unparse = function(e, t2) {
        var n3 = false, _3 = true, m3 = ",", y3 = "\r\n", s3 = '"', a3 = s3 + s3, i2 = false, r3 = null, o3 = false, h3 = ((() => {
          if ("object" == typeof t2) {
            if ("string" != typeof t2.delimiter || v2.BAD_DELIMITERS.filter(function(e2) {
              return -1 !== t2.delimiter.indexOf(e2);
            }).length || (m3 = t2.delimiter), "boolean" != typeof t2.quotes && "function" != typeof t2.quotes && !Array.isArray(t2.quotes) || (n3 = t2.quotes), "boolean" != typeof t2.skipEmptyLines && "string" != typeof t2.skipEmptyLines || (i2 = t2.skipEmptyLines), "string" == typeof t2.newline && (y3 = t2.newline), "string" == typeof t2.quoteChar && (s3 = t2.quoteChar), "boolean" == typeof t2.header && (_3 = t2.header), Array.isArray(t2.columns)) {
              if (0 === t2.columns.length) throw new Error("Option columns is empty");
              r3 = t2.columns;
            }
            void 0 !== t2.escapeChar && (a3 = t2.escapeChar + s3), t2.escapeFormulae instanceof RegExp ? o3 = t2.escapeFormulae : "boolean" == typeof t2.escapeFormulae && t2.escapeFormulae && (o3 = /^[=+\-@\t\r].*$/);
          }
        })(), new RegExp(P2(s3), "g"));
        "string" == typeof e && (e = JSON.parse(e));
        if (Array.isArray(e)) {
          if (!e.length || Array.isArray(e[0])) return u3(null, e, i2);
          if ("object" == typeof e[0]) return u3(r3 || Object.keys(e[0]), e, i2);
        } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || r3), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [e.data])), u3(e.fields || [], e.data || [], i2);
        throw new Error("Unable to serialize unrecognized input");
        function u3(e2, t3, i3) {
          var r4 = "", n4 = ("string" == typeof e2 && (e2 = JSON.parse(e2)), "string" == typeof t3 && (t3 = JSON.parse(t3)), Array.isArray(e2) && 0 < e2.length), s4 = !Array.isArray(t3[0]);
          if (n4 && _3) {
            for (var a4 = 0; a4 < e2.length; a4++) 0 < a4 && (r4 += m3), r4 += k2(e2[a4], a4);
            0 < t3.length && (r4 += y3);
          }
          for (var o4 = 0; o4 < t3.length; o4++) {
            var h4 = (n4 ? e2 : t3[o4]).length, u4 = false, d3 = n4 ? 0 === Object.keys(t3[o4]).length : 0 === t3[o4].length;
            if (i3 && !n4 && (u4 = "greedy" === i3 ? "" === t3[o4].join("").trim() : 1 === t3[o4].length && 0 === t3[o4][0].length), "greedy" === i3 && n4) {
              for (var f3 = [], l3 = 0; l3 < h4; l3++) {
                var c3 = s4 ? e2[l3] : l3;
                f3.push(t3[o4][c3]);
              }
              u4 = "" === f3.join("").trim();
            }
            if (!u4) {
              for (var p3 = 0; p3 < h4; p3++) {
                0 < p3 && !d3 && (r4 += m3);
                var g3 = n4 && s4 ? e2[p3] : p3;
                r4 += k2(t3[o4][g3], p3);
              }
              o4 < t3.length - 1 && (!i3 || 0 < h4 && !d3) && (r4 += y3);
            }
          }
          return r4;
        }
        function k2(e2, t3) {
          var i3, r4;
          return null == e2 ? "" : e2.constructor === Date ? JSON.stringify(e2).slice(1, 25) : (r4 = false, o3 && "string" == typeof e2 && o3.test(e2) && (e2 = "'" + e2, r4 = true), i3 = e2.toString().replace(h3, a3), (r4 = r4 || true === n3 || "function" == typeof n3 && n3(e2, t3) || Array.isArray(n3) && n3[t3] || ((e3, t4) => {
            for (var i4 = 0; i4 < t4.length; i4++) if (-1 < e3.indexOf(t4[i4])) return true;
            return false;
          })(i3, v2.BAD_DELIMITERS) || -1 < i3.indexOf(m3) || " " === i3.charAt(0) || " " === i3.charAt(i3.length - 1)) ? s3 + i3 + s3 : i3);
        }
      }, v2.RECORD_SEP = String.fromCharCode(30), v2.UNIT_SEP = String.fromCharCode(31), v2.BYTE_ORDER_MARK = "\uFEFF", v2.BAD_DELIMITERS = ["\r", "\n", '"', v2.BYTE_ORDER_MARK], v2.WORKERS_SUPPORTED = !s2 && !!n2.Worker, v2.NODE_STREAM_INPUT = 1, v2.LocalChunkSize = 10485760, v2.RemoteChunkSize = 5242880, v2.DefaultDelimiter = ",", v2.Parser = E2, v2.ParserHandle = i, v2.NetworkStreamer = f2, v2.FileStreamer = l2, v2.StringStreamer = c2, v2.ReadableStreamStreamer = p2, n2.jQuery && ((d2 = n2.jQuery).fn.parse = function(o3) {
        var i2 = o3.config || {}, h3 = [];
        return this.each(function(e2) {
          if (!("INPUT" === d2(this).prop("tagName").toUpperCase() && "file" === d2(this).attr("type").toLowerCase() && n2.FileReader) || !this.files || 0 === this.files.length) return true;
          for (var t2 = 0; t2 < this.files.length; t2++) h3.push({ file: this.files[t2], inputElem: this, instanceConfig: d2.extend({}, i2) });
        }), e(), this;
        function e() {
          if (0 === h3.length) U2(o3.complete) && o3.complete();
          else {
            var e2, t2, i3, r3, n3 = h3[0];
            if (U2(o3.before)) {
              var s3 = o3.before(n3.file, n3.inputElem);
              if ("object" == typeof s3) {
                if ("abort" === s3.action) return e2 = "AbortError", t2 = n3.file, i3 = n3.inputElem, r3 = s3.reason, void (U2(o3.error) && o3.error({ name: e2 }, t2, i3, r3));
                if ("skip" === s3.action) return void u3();
                "object" == typeof s3.config && (n3.instanceConfig = d2.extend(n3.instanceConfig, s3.config));
              } else if ("skip" === s3) return void u3();
            }
            var a3 = n3.instanceConfig.complete;
            n3.instanceConfig.complete = function(e3) {
              U2(a3) && a3(e3, n3.file, n3.inputElem), u3();
            }, v2.parse(n3.file, n3.instanceConfig);
          }
        }
        function u3() {
          h3.splice(0, 1), e();
        }
      }), a2 && (n2.onmessage = function(e) {
        e = e.data;
        void 0 === v2.WORKER_ID && e && (v2.WORKER_ID = e.workerId);
        "string" == typeof e.input ? n2.postMessage({ workerId: v2.WORKER_ID, results: v2.parse(e.input, e.config), finished: true }) : (n2.File && e.input instanceof File || e.input instanceof Object) && (e = v2.parse(e.input, e.config)) && n2.postMessage({ workerId: v2.WORKER_ID, results: e, finished: true });
      }), (f2.prototype = Object.create(u2.prototype)).constructor = f2, (l2.prototype = Object.create(u2.prototype)).constructor = l2, (c2.prototype = Object.create(c2.prototype)).constructor = c2, (p2.prototype = Object.create(u2.prototype)).constructor = p2, v2;
    });
  })(papaparse_min$1);
  return papaparse_min$1.exports;
}
var papaparse_minExports = requirePapaparse_min();
const placholderText$1 = `Choice 1, value 1
Choice 2, value 2
Choice 3, value 3
`;
const ChoiceImport = ({
  field,
  onAppend,
  onCancel
}) => {
  const [importText, setImportText] = useState("");
  const [errors, setErrors] = useState([]);
  const handleSave = () => {
    setErrors([]);
    const newErrors = [];
    const choices = [];
    const parsed = papaparse_minExports.parse(importText, { header: false, delimiter: "," });
    if (parsed.errors.length > 0) {
      newErrors.push(`Error parsing CSV: ${parsed.errors[0].message}`);
    }
    if (parsed.data.length === 0) {
      newErrors.push("Error: No rows found");
    }
    parsed.data.forEach((row, index2) => {
      if (row.length === 0) return;
      if (row.length === 1 && row[0] === "") return;
      if (row.length < 2) {
        newErrors.push(
          `Error on line ${index2 + 1}: Each row must have at least two columns`
        );
      } else {
        choices.push({
          label: row[0],
          value: row[1]
        });
      }
    });
    if (newErrors.length > 0) {
      setErrors(newErrors);
    } else {
      onAppend(choices);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Import choices" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalBody, { px: 50, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Heading$5, { as: "h1", color: "gray.700", textAlign: "center", children: [
        field.label,
        " / Import Choices"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { px: 12, py: 5, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { isInvalid: errors.length > 0, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Enter choice labels and values in CSV format" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Textarea$1,
          {
            value: importText,
            placeholder: placholderText$1,
            onChange: (e) => setImportText(e.target.value)
          }
        ),
        errors.map((error2, idx) => /* @__PURE__ */ jsxRuntimeExports.jsx(FormErrorMessage, { children: error2 }, idx))
      ] }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "green", onClick: handleSave, children: "Import" })
        ]
      }
    )
  ] });
};
const ChoicesEditorModal = ({
  field: initialField,
  renderButton
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { formSettings, dispatch } = useRegForm();
  const [field, setField] = useState(initialField);
  const [choice, setChoice] = useState();
  const [page, setPage] = useState(
    "ChoiceIndex"
    /* ChoiceIndex */
  );
  useEffect(() => {
    setField(initialField);
  }, [initialField]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    renderButton === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", onClick: onOpen, children: "Edit choices" }) : renderButton({ isOpen, onOpen, onClose }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Modal,
      {
        isOpen,
        onClose: () => {
          setPage(
            "ChoiceIndex"
            /* ChoiceIndex */
          );
          onClose();
        },
        size: "xl",
        scrollBehavior: "inside",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalContent, { minW: 800, children: [
            page === "ChoiceIndex" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              ChoiceIndex,
              {
                field,
                showPrices: formSettings.shoppingCartEnabled,
                currency: formSettings.shoppingCartCurrency,
                onSave: () => {
                  dispatch({
                    type: "update_field",
                    name: field.name,
                    payload: inferDataTypeFromChoices(field)
                  });
                  onClose();
                },
                onClose,
                onChange: (update2) => setField(Object.assign({}, field, update2)),
                onEditMetadata: formSettings.metadataEnabled ? (choice2) => {
                  setChoice(choice2);
                  setPage(
                    "ChoiceMetadata"
                    /* ChoiceMetadata */
                  );
                } : void 0,
                onImportChoices: () => setPage(
                  "ChoiceImport"
                  /* ChoiceImport */
                )
              }
            ),
            page === "ChoiceImport" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              ChoiceImport,
              {
                field,
                onAppend: (choices) => {
                  setField({
                    ...field,
                    choices: [...field.choices, ...choices].map(
                      normalizedChoiceWithId
                    )
                  });
                  setPage(
                    "ChoiceIndex"
                    /* ChoiceIndex */
                  );
                },
                onCancel: () => setPage(
                  "ChoiceIndex"
                  /* ChoiceIndex */
                )
              }
            ),
            page === "ChoiceMetadata" && choice !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
              ChoiceMetadata,
              {
                field,
                choice,
                onSave: (choices) => {
                  setField({ ...field, choices });
                  setPage(
                    "ChoiceIndex"
                    /* ChoiceIndex */
                  );
                },
                onCancel: () => setPage(
                  "ChoiceIndex"
                  /* ChoiceIndex */
                )
              }
            )
          ] })
        ]
      }
    )
  ] });
};
var classnames = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var hasRequiredClassnames;
function requireClassnames() {
  if (hasRequiredClassnames) return classnames.exports;
  hasRequiredClassnames = 1;
  (function(module2) {
    (function() {
      var hasOwn = {}.hasOwnProperty;
      function classNames2() {
        var classes2 = "";
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (arg) {
            classes2 = appendClass(classes2, parseValue(arg));
          }
        }
        return classes2;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames2.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes2 = "";
        for (var key2 in arg) {
          if (hasOwn.call(arg, key2) && arg[key2]) {
            classes2 = appendClass(classes2, key2);
          }
        }
        return classes2;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (module2.exports) {
        classNames2.default = classNames2;
        module2.exports = classNames2;
      } else {
        window.classNames = classNames2;
      }
    })();
  })(classnames);
  return classnames.exports;
}
var classnamesExports = requireClassnames();
const classNames = /* @__PURE__ */ getDefaultExportFromCjs$1(classnamesExports);
const TracksVisibilityForm$1 = ({
  field,
  tracks,
  onChange
}) => {
  var _a3;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", spacing: 2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox$2,
      {
        isChecked: !hasTracksSelected(field),
        onChange: (event) => event.target.checked && onChange([]),
        children: "Visible to all tracks"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Visible to selected tracks only" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        CheckboxGroup$2,
        {
          value: (_a3 = field.tracks) == null ? void 0 : _a3.map((t2) => t2.toString()),
          onChange: (trackIds) => {
            onChange(trackIds.map((id) => Number(id)));
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", paddingLeft: 4, children: tracks.map((track2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$2, { value: track2.id.toString(), children: track2.name }, track2.id)) })
        }
      )
    ] })
  ] });
};
const FieldTrackList = ({ field }) => {
  const { tracks } = useTracks();
  if (tracks === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {});
  }
  const fieldTracks = tracks.filter((t2) => {
    var _a3;
    return (_a3 = field.tracks) == null ? void 0 : _a3.includes(t2.id);
  });
  if (fieldTracks.length === 0) {
    return null;
  }
  if (fieldTracks.length === 1) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: fieldTracks[0].name });
  }
  const [last, ...rest] = fieldTracks.reverse();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    rest.reverse().map((t2, i) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      i > 0 && ", ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: t2.name })
    ] })),
    " and ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: last.name }),
    " only."
  ] });
};
const EditorAccordionItem = ({
  title,
  children
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(AccordionItem, { py: 2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(AccordionButton, { maxWidth: "100%", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { flex: 1, textAlign: "left", color: "gray.700", children: title }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionIcon, { color: "gray.700" })
  ] }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionPanel, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pt: 2, px: 4, pb: 2, children }) })
] });
const TracksAccordionItem = ({
  field
}) => {
  const { tracks } = useTracks();
  const { dispatch, formSettings, form } = useRegForm();
  const tracksVisibilitySource = getTracksVisibilitySource(field, form);
  if (!formSettings.tracksEnabled || tracks === void 0 || protectFromHideOrDelete(field, formSettings) || (tracks == null ? void 0 : tracks.length) === 0 || isPreRegField(field, form)) {
    return null;
  }
  if (tracksVisibilitySource !== void 0 && tracksVisibilitySource.name !== field.name) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "track visibility", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { children: [
      "Track visibility has been set by ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: tracksVisibilitySource.label }),
      " ",
      "to ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(FieldTrackList, { field: tracksVisibilitySource })
    ] }) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "track visibility", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    TracksVisibilityForm$1,
    {
      field,
      tracks,
      onChange: (tracks2) => dispatch({
        type: "update_field",
        name: field.name,
        payload: { tracks: tracks2 }
      })
    }
  ) });
};
const getDependsName = (field) => Array.isArray(field.dependsOn) ? field.dependsOn[0] : field.dependsOn;
const getDependsValue = (field) => Array.isArray(field.dependsOn) ? field.dependsOn[1] : void 0;
const useSession = (sessionId, options) => {
  const { sessions } = useAdminApi();
  return useQuery(
    ["sessions", sessionId],
    () => sessions.getSession(sessionId),
    options
  );
};
const SessionDependsCheckboxGroup$1 = ({ dependsValue, sessionBookingField, onChange }) => {
  const { data: session } = useSession(sessionBookingField.session);
  if (session === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {});
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Value" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CheckboxGroup$2,
      {
        value: dependsValue == null ? void 0 : dependsValue.map((v2) => v2.toString()),
        onChange: (values2) => {
          onChange(values2.map((v2) => Number(v2)));
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", spacing: 4, children: session.slots.map((slot) => /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$2, { value: slot.id.toString(), children: slot.name }, slot.id)) })
      }
    )
  ] });
};
const EventPathCheckboxGroup$3 = ({
  form,
  dependsValue,
  sessions,
  tracks,
  onChange
}) => {
  const eventPaths = getEventPathValues(form, tracks, sessions);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Paths" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxGroup$2, { value: dependsValue, onChange, children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", spacing: 4, children: Array.from(eventPaths.values()).sort().map((path2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$2, { value: path2, children: path2 }, path2)) }) })
  ] });
};
const useRoomBlock = (id) => {
  const { rooming } = useAdminApi();
  return useQuery(
    ["roomBlocks", id],
    () => rooming.getRoomBlock(id)
  );
};
const getAvailableRoomTypes$1 = (roomBlock, roomBlockField) => {
  if (roomBlockField.includeRoomTypes === void 0) {
    return roomBlock.roomTypes;
  } else {
    return roomBlock.roomTypes.filter(
      (rt) => {
        var _a3;
        return (_a3 = roomBlockField.includeRoomTypes) == null ? void 0 : _a3.includes(rt.id);
      }
    );
  }
};
const RoomBlockDependsValueCheckboxes$1 = ({ dependsValue, roomBlockField, onChange }) => {
  const { data: roomBlock } = useRoomBlock(roomBlockField.roomBlockId);
  if (roomBlock === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {});
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { textStyle: "label", children: "Booked" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Checkbox$2,
        {
          isChecked: dependsValue === void 0,
          onChange: () => onChange(void 0),
          children: "Not booked"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { textStyle: "label", children: "Room type" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        CheckboxGroup$2,
        {
          value: dependsValue === void 0 ? [] : dependsValue == null ? void 0 : dependsValue.map((v2) => v2.toString()),
          onChange: (values2) => onChange(values2.map((v2) => v2.toString())),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", children: getAvailableRoomTypes$1(roomBlock, roomBlockField).map(
            (roomType) => /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$2, { value: roomType.id.toString(), children: roomType.name }, roomType.id)
          ) })
        }
      )
    ] })
  ] });
};
const DependsValueForm$1 = ({
  form,
  dependsTarget,
  field,
  sessions = [],
  tracks = [],
  onChange
}) => {
  var _a3, _b;
  if (!isDependsField(dependsTarget)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      EventPathCheckboxGroup$3,
      {
        form,
        sessions,
        tracks,
        onChange,
        dependsValue: (_a3 = getDependsValue(field)) == null ? void 0 : _a3.map((v2) => v2.toString())
      }
    );
  }
  switch (dependsTarget.type) {
    case "boolean":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { fontSize: "md", pt: 2, pr: 12, pl: 4, children: [
        "This field will be visible when the ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: dependsTarget.label }),
        " ",
        "checkbox is checked."
      ] });
    case "session_booking":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        SessionDependsCheckboxGroup$1,
        {
          dependsValue: getDependsValue(field),
          sessionBookingField: dependsTarget,
          onChange
        }
      );
    case "room_block":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        RoomBlockDependsValueCheckboxes$1,
        {
          dependsValue: getDependsValue(field),
          roomBlockField: dependsTarget,
          onChange
        }
      );
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { textStyle: "label", children: "Field Value" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CheckboxGroup$2,
          {
            onChange,
            value: (_b = getDependsValue(field)) == null ? void 0 : _b.map((v2) => v2.toString()),
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", children: normalizedFieldChoices(dependsTarget).map((choice) => {
              var _a4;
              return /* @__PURE__ */ jsxRuntimeExports.jsx(
                Checkbox$2,
                {
                  value: ((_a4 = choice.value) == null ? void 0 : _a4.toString()) || choice.label,
                  children: choice.label
                },
                choice.value || choice.label
              );
            }) })
          }
        )
      ] });
  }
};
const DependsOnForm$1 = ({
  field,
  sessions,
  tracks,
  onChange
}) => {
  const { form } = useRegForm();
  const dependTargets = getDependTargetsWithEventPath(
    form,
    field,
    sessions,
    tracks
  );
  const [dependsTarget, setDependsTarget] = useState(
    dependTargets.find(
      (f2) => isDependsField(f2) ? f2.name === getDependsName(field) : "EVENT_PATH" === getDependsName(field)
    )
  );
  const handleFieldChange = (e) => {
    const newTarget = e.target.value === "EVENT_PATH" ? "EVENT_PATH" : getDependTarget(form, e.target.value);
    setDependsTarget(newTarget);
    if (newTarget === void 0) {
      onChange({ dependsOn: void 0 });
    } else if (newTarget !== "EVENT_PATH" && (newTarget.type === "boolean" || newTarget.type === "room_block")) {
      onChange({ dependsOn: newTarget.name });
    }
  };
  const handleValueChange = (values2) => {
    if (dependsTarget !== void 0) {
      onChange({
        dependsOn: [targetName(dependsTarget), values2]
      });
    }
  };
  const handleClear = () => {
    setDependsTarget(void 0);
    onChange({ dependsOn: void 0 });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { minH: "20em", align: "left", spacing: 3, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { fontSize: "md", children: "Only visible if another field is selected" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { id: "depends_on", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { textStyle: "label", children: "Field" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { alignItems: "center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Select$2,
          {
            value: dependsTarget !== void 0 ? targetName(dependsTarget) : "",
            onChange: handleFieldChange,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "", children: "---- Please Choose -----" }, "blank"),
              dependTargets.map(
                (target) => isDependsField(target) ? /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: target.name, children: fieldLabel(target) }, target.name) : /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "EVENT_PATH", children: "EVENT_PATH" }, "EVENT_PATH")
              )
            ]
          }
        ),
        dependsTarget !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { mb: 2, size: "sm", colorScheme: "red", onClick: handleClear, children: "Clear" })
      ] })
    ] }),
    dependsTarget !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
      DependsValueForm$1,
      {
        form,
        dependsTarget,
        field,
        sessions,
        tracks,
        onChange: handleValueChange
      }
    )
  ] });
};
const useSessions = () => {
  const { sessions } = useAdminApi();
  const queryResult = useQuery(
    ["sessions"],
    () => sessions.getSessions()
  );
  const { data, ...rest } = queryResult;
  return { ...rest, sessions: data };
};
const DependsOnFormWithEventPath$1 = ({
  field,
  onChange
}) => {
  const {
    error: sessionsError,
    isLoading: sessionsLoading,
    sessions
  } = useSessions();
  const { error: tracksError, isLoading: tracksLoading, tracks } = useTracks();
  if (sessionsError) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { status: "error", children: "Error Fetching Sessions" });
  }
  if (tracksError) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { status: "error", children: "Error Fetching Tracks" });
  }
  if (tracksLoading || sessionsLoading) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {});
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DependsOnForm$1,
    {
      field,
      onChange,
      sessions,
      tracks
    }
  );
};
const DependsOnFormContainer$1 = ({
  field,
  onChange
}) => {
  const { formSettings } = useRegForm();
  if (formSettings.metadataEnabled) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(DependsOnFormWithEventPath$1, { field, onChange });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(DependsOnForm$1, { field, onChange });
  }
};
function MdQrCodeScanner(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M9.5 6.5v3h-3v-3h3M11 5H5v6h6V5zm-1.5 9.5v3h-3v-3h3M11 13H5v6h6v-6zm6.5-6.5v3h-3v-3h3M19 5h-6v6h6V5zm-6 8h1.5v1.5H13V13zm1.5 1.5H16V16h-1.5v-1.5zM16 13h1.5v1.5H16V13zm-3 3h1.5v1.5H13V16zm1.5 1.5H16V19h-1.5v-1.5zM16 16h1.5v1.5H16V16zm1.5-1.5H19V16h-1.5v-1.5zm0 3H19V19h-1.5v-1.5zM22 7h-2V4h-3V2h5v5zm0 15v-5h-2v3h-3v2h5zM2 22h5v-2H4v-3H2v5zM2 2v5h2V4h3V2H2z" }, "child": [] }] })(props);
}
function MdTextFields(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z" }, "child": [] }] })(props);
}
function MdTextSnippet(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" }, "child": [] }, { "tag": "path", "attr": { "d": "m20.41 8.41-4.83-4.83c-.37-.37-.88-.58-1.41-.58H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9.83c0-.53-.21-1.04-.59-1.42zM7 7h7v2H7V7zm10 10H7v-2h10v2zm0-4H7v-2h10v2z" }, "child": [] }] })(props);
}
function MdFilter9Plus(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1v1H9v2h3a2 2 0 0 0 2-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z" }, "child": [] }] })(props);
}
function MdHotel(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z" }, "child": [] }] })(props);
}
function MdMenuBook(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z" }, "child": [] }, { "tag": "path", "attr": { "d": "M17.5 10.5c.88 0 1.73.09 2.5.26V9.24c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99zM13 12.49v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26V11.9c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.3-4.5.83zM17.5 14.33c-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26v-1.52c-.79-.16-1.64-.24-2.5-.24z" }, "child": [] }] })(props);
}
function MdArrowDropDown(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" }, "child": [] }, { "tag": "path", "attr": { "d": "m7 10 5 5 5-5z" }, "child": [] }] })(props);
}
function MdRadioButtonChecked(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" }, "child": [] }] })(props);
}
function MdOutlineVerified(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M23 11.99 20.56 9.2l.34-3.69-3.61-.82L15.4 1.5 12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 11.99l2.44 2.79-.34 3.7 3.61.82 1.89 3.2 3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69 2.44-2.8zm-3.95 1.48-.56.65.08.85.18 1.95-1.9.43-.84.19-.44.74-.99 1.68-1.78-.77-.8-.34-.79.34-1.78.77-.99-1.67-.44-.74-.84-.19-1.9-.43.18-1.96.08-.85-.56-.65L3.67 12l1.29-1.48.56-.65-.09-.86-.18-1.94 1.9-.43.84-.19.44-.74.99-1.68 1.78.77.8.34.79-.34 1.78-.77.99 1.68.44.74.84.19 1.9.43-.18 1.95-.08.85.56.65 1.29 1.47-1.28 1.48z" }, "child": [] }, { "tag": "path", "attr": { "d": "m10.09 13.75-2.32-2.33-1.48 1.49 3.8 3.81 7.34-7.36-1.48-1.49z" }, "child": [] }] })(props);
}
function MdOutlineFeaturedPlayList(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 10h9v2H5zm0-3h9v2H5z" }, "child": [] }] })(props);
}
function MdOutlineAlternateEmail(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M12 1.95c-5.52 0-10 4.48-10 10s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57v-1.43c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57v-1.43c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" }, "child": [] }] })(props);
}
function MdOutlineUpload(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M9 16h6v-6h4l-7-7-7 7h4v6zm3-10.17L14.17 8H13v6h-2V8H9.83L12 5.83zM5 18h14v2H5z" }, "child": [] }] })(props);
}
function MdOutlineLocalPhone(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57a.84.84 0 0 0-.31-.05c-.26 0-.51.1-.71.29l-2.2 2.2a15.149 15.149 0 0 1-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1z" }, "child": [] }] })(props);
}
function MdOutlineChevronLeft(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z" }, "child": [] }] })(props);
}
function MdOutlineChevronRight(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z" }, "child": [] }] })(props);
}
function MdOutlineFirstPage(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M24 0v24H0V0h24z", "opacity": ".87" }, "child": [] }, { "tag": "path", "attr": { "d": "M18.41 16.59 13.82 12l4.59-4.59L17 6l-6 6 6 6 1.41-1.41zM6 6h2v12H6V6z" }, "child": [] }] })(props);
}
function MdOutlineLastPage(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z", "opacity": ".87" }, "child": [] }, { "tag": "path", "attr": { "d": "M5.59 7.41 10.18 12l-4.59 4.59L7 18l6-6-6-6-1.41 1.41zM16 6h2v12h-2V6z" }, "child": [] }] })(props);
}
function MdOutlineCheckBox(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM17.99 9l-1.41-1.42-6.59 6.59-2.58-2.57-1.42 1.41 4 3.99z" }, "child": [] }] })(props);
}
function BsCalendarDate(props) {
  return GenIcon({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M6.445 11.688V6.354h-.633A13 13 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23" }, "child": [] }, { "tag": "path", "attr": { "d": "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" }, "child": [] }] })(props);
}
function BsTextareaT(props) {
  return GenIcon({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M1.5 2.5A1.5 1.5 0 0 1 3 1h10a1.5 1.5 0 0 1 1.5 1.5v3.563a2 2 0 0 1 0 3.874V13.5A1.5 1.5 0 0 1 13 15H3a1.5 1.5 0 0 1-1.5-1.5V9.937a2 2 0 0 1 0-3.874zm1 3.563a2 2 0 0 1 0 3.874V13.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9.937a2 2 0 0 1 0-3.874V2.5A.5.5 0 0 0 13 2H3a.5.5 0 0 0-.5.5zM2 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2" }, "child": [] }, { "tag": "path", "attr": { "d": "M11.434 4H4.566L4.5 5.994h.386c.21-1.252.612-1.446 2.173-1.495l.343-.011v6.343c0 .537-.116.665-1.049.748V12h3.294v-.421c-.938-.083-1.054-.21-1.054-.748V4.488l.348.01c1.56.05 1.963.244 2.173 1.496h.386z" }, "child": [] }] })(props);
}
function AiOutlineNumber(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 1024 1024" }, "child": [{ "tag": "path", "attr": { "d": "M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z" }, "child": [] }] })(props);
}
const fieldIcons = {
  attendee_reference: MdTextFields,
  checkbox: MdOutlineCheckBox,
  date: BsCalendarDate,
  dropdown: MdArrowDropDown,
  document: MdOutlineUpload,
  email: MdOutlineAlternateEmail,
  info: MdTextSnippet,
  integer: AiOutlineNumber,
  lead_scanner: MdQrCodeScanner,
  page: MdMenuBook,
  telephone: MdOutlineLocalPhone,
  radio: MdRadioButtonChecked,
  room_block: MdHotel,
  section: MdOutlineFeaturedPlayList,
  session_booking: MdFilter9Plus,
  sponsor: MdOutlineVerified,
  textarea: BsTextareaT,
  text: MdTextFields
};
const getIcon$1 = (formItem) => fieldIcons["kind" in formItem && formItem.kind !== void 0 ? formItem.kind : formItem.type];
const FieldIcon = ({ field, ...iconProps }) => {
  const TheIcon = getIcon$1(field);
  if (TheIcon === void 0 || TheIcon === null) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: "Icon missing" });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TheIcon, { ...iconProps });
};
const fieldLabels$1 = {
  attendee_reference: "text field",
  checkbox: "check box",
  date: "date",
  document: "document",
  dropdown: "dropdown",
  email: "email address",
  info: "info text",
  integer: "number",
  lead_scanner: "lead scanner",
  page: "page",
  telephone: "phone number",
  radio: "radio buttons",
  room_block: "room block",
  section: "section",
  session_booking: "session booking",
  textarea: "text area",
  text: "text field"
};
const getLabel$1 = (formItem) => fieldLabels$1["kind" in formItem && formItem.kind !== void 0 ? formItem.kind : formItem.type];
const EditorHeader = ({
  field,
  children,
  onDelete
}) => {
  const { formSettings } = useRegForm();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "center", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { flex: 1, maxW: "3.5em", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldIcon, { size: "100%", field }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { flex: 3, justifyContent: "space-between", alignItems: "baseline", children: [
      children !== void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { pl: 5, py: 2, align: "left", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { fontSize: "2xl", mb: 2, children: getLabel$1(field) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pl: 1, children })
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { fontSize: "2xl", pl: 4, children: getLabel$1(field) }),
      !protectFromHideOrDelete(field, formSettings) && /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { size: "sm", colorScheme: "red", onClick: () => onDelete(field), children: "Delete" })
    ] })
  ] });
};
const numericPrice$1 = (price) => price === void 0 || price === "" ? void 0 : Number(price);
const FieldPriceForm$1 = ({
  field,
  currency,
  onChange
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Price to attendee when selected" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    PriceInput$3,
    {
      valueInCents: numericPrice$1(field.price),
      onChange: (price) => onChange({ price }),
      currency
    }
  )
] });
const InputEditor$1 = ({ field }) => {
  const { dispatch, formSettings } = useRegForm();
  const handleChange = (update2) => {
    dispatch({
      type: "update_field",
      name: field.name,
      payload: update2
    });
  };
  const handleDelete2 = (field2) => dispatch({ type: "delete_field", name: field2.name });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { children: [
    field.kind === "radio" || field.kind === "dropdown" ? /* @__PURE__ */ jsxRuntimeExports.jsx(EditorHeader, { onDelete: handleDelete2, field, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChoicesEditorModal, { field }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(EditorHeader, { onDelete: handleDelete2, field }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { p: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldTextForm$1, { field, onChange: handleChange }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Accordion$1, { allowMultiple: true, defaultIndex: [0], children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Properties", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldPropertiesForm$1, { field, onChange: handleChange }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TracksAccordionItem, { field }),
      field.type !== "attendee_reference" && /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Depends on", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DependsOnFormContainer$1, { field, onChange: handleChange }) }),
      formSettings.shoppingCartEnabled && field.type === "boolean" && /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Price", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        FieldPriceForm$1,
        {
          field,
          onChange: handleChange,
          currency: formSettings.shoppingCartCurrency
        }
      ) }),
      formSettings.metadataEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Metadata", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        MetadataModal,
        {
          metadata: field.metadata,
          title: `Field ${field.label} metadata`,
          onSave: (metadata) => handleChange({ metadata })
        }
      ) })
    ] })
  ] });
};
const ContainerEditor$1 = ({ field }) => {
  const { dispatch, formSettings } = useRegForm();
  const handleChange = (update2) => {
    dispatch({
      type: "update_field",
      name: field.name,
      payload: update2
    });
  };
  const handleDelete2 = (field2) => dispatch({ type: "delete_field", name: field2.name });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(EditorHeader, { onDelete: handleDelete2, field }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { p: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      FieldTextForm$1,
      {
        field,
        labelFieldLabel: "title",
        onChange: handleChange
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Accordion$1, { allowMultiple: true, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(TracksAccordionItem, { field }),
      field.type === "section" && !protectFromHideOrDelete(field, formSettings) && /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Depends on", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DependsOnFormContainer$1, { field, onChange: handleChange }) }),
      formSettings.metadataEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Metadata", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        MetadataModal,
        {
          metadata: field.metadata,
          title: `Field ${field.label} metadata`,
          onSave: (metadata) => handleChange({ metadata })
        }
      ) })
    ] })
  ] });
};
const InfoSectionEditor$1 = ({ field }) => {
  const { dispatch } = useRegForm();
  const handleChange = (update2) => {
    dispatch({
      type: "update_field",
      name: field.name,
      payload: update2
    });
  };
  const handleDelete2 = (field2) => dispatch({ type: "delete_field", name: field2.name });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(EditorHeader, { field, onDelete: handleDelete2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { p: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { id: "helpText", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { textStyle: "label", children: "Info field content (markdown format is applied)" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Textarea$1,
        {
          rows: 9,
          value: field.text,
          onChange: (e) => handleChange({ text: e.target.value })
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Accordion$1, { allowMultiple: true, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(TracksAccordionItem, { field }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Depends on", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DependsOnFormContainer$1, { field, onChange: handleChange }) })
    ] })
  ] });
};
const reducer$3 = (state, action) => {
  return fn(state, (draft) => {
    switch (action.type) {
      case "add_slot": {
        if (draft.slots === void 0) {
          draft.slots = [];
        }
        draft.slots.push({
          isNew: true,
          id: idGenerator(),
          ...action.payload,
          sort: draft.slots.length + 1
        });
        break;
      }
      case "update_slot": {
        const slotIndex = getSlotIndex(draft, action.payload.id);
        if (slotIndex === -1) {
          console.error("missing slot id", action.payload.id);
          break;
        }
        draft.slots[slotIndex] = {
          ...draft.slots[slotIndex],
          ...action.payload
        };
        break;
      }
      case "delete_slot": {
        draft.slots = draft.slots.filter(
          (s2) => !idsEqual(s2.id, action.payload.id)
        );
        if (draft.deletedSlots === void 0) {
          draft.deletedSlots = [];
        }
        draft.deletedSlots.push(action.payload.id);
        break;
      }
      case "move_slot": {
        const [removed] = draft.slots.splice(action.fromIndex, 1);
        draft.slots.splice(action.toIndex, 0, removed);
        draft.slots.forEach((slot, index2) => slot.sort = index2 + 1);
        break;
      }
      case "reset": {
        return action.payload;
      }
    }
  });
};
const useUpdateSession = (options) => {
  const { sessions } = useAdminApi();
  const queryClient = useQueryClient();
  const mutateFn = (newSession) => sessions.updateSession(newSession);
  return useMutation(mutateFn, {
    ...options,
    onSuccess: (data, variables, context) => {
      var _a3;
      queryClient.setQueryData(["sessions", data.id], data);
      (_a3 = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a3.call(void 0, data, variables, context);
    }
  });
};
const CapacityInput$2 = ({
  id,
  value = "",
  defaultValue: defaultValue2 = 0,
  onChange
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { id, isRequired: true, maxW: 70, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    NumberInput,
    {
      maxWidth: 40,
      value,
      defaultValue: defaultValue2,
      size: "md",
      min: 0,
      onChange: (_2, valueAsNumber) => onChange(isNaN(valueAsNumber) ? defaultValue2 : valueAsNumber),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(NumberInputField, { name: "totalCapacity", style: { marginBottom: 0 } }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(NumberInputStepper, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(NumberIncrementStepper, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(NumberDecrementStepper, {})
        ] })
      ]
    }
  ) });
};
const SlotsTable$1 = ({
  session,
  onUpdateSlot,
  onDeleteSlot,
  onMoveSlot,
  onEditMetadata,
  onEditDetails
}) => {
  const { formSettings } = useRegForm();
  const handleDragEnd = (result) => {
    if (result.destination) {
      onMoveSlot(result.source.index, result.destination.index);
    }
  };
  const safeSlots = (session.slots || []).filter((slot) => slot.id !== void 0 && slot.id !== null);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DragDropContext$1, { onDragEnd: handleDragEnd, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$3, { size: "sm", style: { tableLayout: "fixed" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Thead, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { width: "15%", children: "Drag to reorder" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { width: "33%", children: "Name (click to edit)" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { isNumeric: true, width: "20%", children: "Total capacity" }),
      formSettings.shoppingCartEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { isNumeric: true, width: "20%", children: "Price" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { textAlign: "center", width: "12%", children: "Number booked" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { width: "15%", children: "Actions" })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectedDroppable$1, { droppableId: "sessionSlots", children: (provided) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Tbody, { ref: provided.innerRef, ...provided.droppableProps, children: [
      safeSlots.map((slot, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        PublicDraggable,
        {
          draggableId: slot.id.toString(),
          index: index2,
          children: (provided2, snapshot) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
            Tr,
            {
              display: snapshot.isDragging ? "table" : "table-row",
              ref: provided2.innerRef,
              ...provided2.draggableProps,
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "15%", ...provided2.dragHandleProps, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pl: 4, pb: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DragHandleIcon, { color: "gray.500" }) }) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "33%", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { minWidth: 200, pl: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  Editable$1,
                  {
                    placeholder: "Choose a label",
                    value: slot.name,
                    onChange: (label) => onUpdateSlot({ ...slot, name: label }),
                    children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(EditablePreview, {}),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(EditableInput, { maxLength: 255 })
                    ]
                  }
                ) }) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "20%", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { justify: "flex-end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  CapacityInput$2,
                  {
                    id: `slot-${slot.id}-totalCapacity`,
                    value: slot.totalCapacity,
                    onChange: (totalCapacity) => onUpdateSlot({ ...slot, totalCapacity })
                  }
                ) }) }),
                formSettings.shoppingCartEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "20%", px: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { justify: "flex-end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  PriceInput$3,
                  {
                    id: `slot-${slot.id}-price`,
                    valueInCents: slot.priceInCents,
                    currency: formSettings.shoppingCartCurrency,
                    onChange: (priceInCents) => onUpdateSlot({ ...slot, priceInCents }),
                    inputFieldProps: { name: "price" }
                  }
                ) }) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { isNumeric: true, width: "12%", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pr: 2, children: (slot == null ? void 0 : slot.numberBooked) || 0 }) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "15%", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { spacing: 1, alignItems: "flex-start", children: [
                  onEditMetadata !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Button$1,
                    {
                      size: "xs",
                      onClick: () => onEditMetadata(slot),
                      title: "Edit metadata",
                      children: "meta"
                    }
                  ),
                  onEditDetails !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Button$1,
                    {
                      size: "xs",
                      onClick: () => onEditDetails(slot),
                      title: "Edit details",
                      children: "details"
                    }
                  ),
                  canDeleteSlot(slot) && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Button$1,
                    {
                      onClick: () => onDeleteSlot(slot),
                      colorScheme: "red",
                      size: "xs",
                      children: "Delete"
                    }
                  )
                ] }) })
              ]
            }
          )
        },
        slot.id.toString()
      )),
      provided.placeholder
    ] }) })
  ] }) });
};
const EditSlotsTable = ({
  onSave,
  onEditSession,
  onAddSlot,
  onCancel,
  cancelButtonText,
  ...props
}) => {
  const scrollRef = useRef(null);
  const handleAddSlot = () => {
    onAddSlot();
    setTimeout(
      () => {
        var _a3;
        return (_a3 = scrollRef == null ? void 0 : scrollRef.current) == null ? void 0 : _a3.scrollIntoView({
          block: "end",
          behavior: "smooth"
        });
      },
      30
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { ref: scrollRef, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Heading$5, { as: "h1", color: "gray.700", pb: 16, textAlign: "center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Link$2,
          {
            color: "blueAlpha.500",
            title: "Edit session details",
            onClick: onEditSession,
            children: props.session.name
          }
        ),
        " ",
        "/ Slots"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(SlotsTable$1, { ...props }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { pt: 6, pb: 6, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          colorScheme: "blue",
          variant: "outline",
          onClick: handleAddSlot,
          children: "Add slot +"
        }
      ) })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: cancelButtonText }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "green", onClick: onSave, children: "Save slots" })
        ]
      }
    )
  ] });
};
const MetadataEditor = ({
  session,
  slot,
  onEditSession,
  onCancel,
  ...props
}) => {
  const metadataFormRef = React__default.createRef();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Heading$5, { as: "h1", color: "gray.700", pb: 16, textAlign: "center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Link$2,
          {
            color: "blueAlpha.500",
            title: "Edit session details",
            onClick: onEditSession,
            children: session.name
          }
        ),
        " ",
        "/ Slots / ",
        slot.name,
        " / Metadata"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        MetadataForm,
        {
          ...props,
          metadata: slot.metadata,
          formRef: metadataFormRef
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              colorScheme: "green",
              onClick: () => {
                var _a3;
                (_a3 = metadataFormRef == null ? void 0 : metadataFormRef.current) == null ? void 0 : _a3.dispatchEvent(
                  new Event("submit", { cancelable: true, bubbles: true })
                );
              },
              children: "Save Metadata"
            }
          )
        ]
      }
    )
  ] });
};
const EditSlotDetails = ({
  session,
  slot,
  onEditSession,
  onSave,
  onCancel
}) => {
  const {
    handleSubmit,
    register: register2,
    control,
    setValue,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: slot
  });
  const currentSlot = watch();
  const { formSettings } = useRegForm();
  useEffect(() => {
    if (currentSlot.startTime === void 0) {
      setValue("endTime", void 0);
    }
  }, [currentSlot.startTime, setValue]);
  const defaultTime = setHoursAndMinutes(formSettings.startDate, 9, 0);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalBody, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Heading$5, { as: "h1", color: "gray.700", pb: 16, textAlign: "center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Link$2,
          {
            color: "blueAlpha.500",
            title: "Edit session details",
            onClick: onEditSession,
            children: session.name
          }
        ),
        " ",
        "/ Slots / ",
        slot.name,
        " / Description"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("form", { id: "add-session-form", onSubmit: handleSubmit(onSave), children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { pb: 10, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Start time" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Controller,
            {
              name: "startTime",
              control,
              render: ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                DatePicker,
                {
                  isClearable: true,
                  clearButtonTitle: "Clear",
                  onChange: field.onChange,
                  selectedDate: field.value,
                  maxDate: currentSlot.endTime,
                  dateFormat: formSettings.dateTimeFormat,
                  openToDate: defaultTime,
                  showTimeSelect: true,
                  timeIntervals: 15
                }
              )
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "The start time for the slot." })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { isDisabled: currentSlot.startTime === void 0, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "End time" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Controller,
            {
              name: "endTime",
              control,
              render: ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                DatePicker,
                {
                  disabled: currentSlot.startTime === void 0,
                  isClearable: true,
                  clearButtonTitle: "Clear",
                  onChange: field.onChange,
                  selectedDate: field.value,
                  minDate: currentSlot.startTime,
                  dateFormat: formSettings.dateTimeFormat,
                  openToDate: currentSlot.startTime ? addHours$1(currentSlot.startTime, 1) : defaultTime,
                  showTimeSelect: true,
                  timeIntervals: 15
                }
              )
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "The end time for the slot. Attendees will not be able to select overlapping session slots on the same form field." })
        ] }),
        formSettings.sessionSlotDescriptionsEnabled && /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { isInvalid: errors.description !== void 0, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { htmlFor: "description", children: "Session description" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea$1, { ...register2("description") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormErrorMessage, { children: errors.description && errors.description.message }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "The session slot description is html formatted content that is displayed in a modal on the registration form by slot selection." })
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: handleSubmit(onSave), colorScheme: "green", children: "Save details" })
        ]
      }
    )
  ] });
};
const EditSlots = ({
  session: initialSession,
  onSave,
  onCancel,
  onEditSession,
  cancelButtonText = "Cancel"
}) => {
  const mutation = useUpdateSession();
  const [session, dispatch] = useReducer(reducer$3, initialSession);
  const [page, setPage] = useState(
    "SlotsTable"
    /* SlotsTable */
  );
  const [selectedSlot, setSelectedSlot] = useState();
  const [triggerSave, setTriggerSave] = useState(false);
  const { formSettings } = useRegForm();
  useEffect(() => {
    if (triggerSave) {
      mutation.mutate(session, {
        onSuccess: (newSession) => dispatch({ type: "reset", payload: newSession })
      });
      setTriggerSave(false);
    }
  }, [triggerSave]);
  useEffect(() => {
    dispatch({ type: "reset", payload: initialSession });
  }, [initialSession]);
  const handleAddSlot = () => {
    dispatch({ type: "add_slot", payload: initializeSlot(session) });
  };
  const handleSaveSlots = () => {
    mutation.mutate(session, {
      onSuccess: onSave
    });
  };
  const showSlotsTable = () => {
    setPage(
      "SlotsTable"
      /* SlotsTable */
    );
    setSelectedSlot(void 0);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Event Sessions" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    page === "SlotsTable" && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      EditSlotsTable,
      {
        session,
        onSave: handleSaveSlots,
        onEditSession,
        onAddSlot: handleAddSlot,
        onUpdateSlot: (slot) => dispatch({ type: "update_slot", payload: slot }),
        onMoveSlot: (fromIndex, toIndex) => dispatch({
          type: "move_slot",
          fromIndex,
          toIndex
        }),
        onDeleteSlot: (slot) => dispatch({ type: "delete_slot", payload: slot }),
        onEditMetadata: formSettings.metadataEnabled ? (slot) => {
          setSelectedSlot(slot);
          setPage(
            "MetadataEditor"
            /* MetadataEditor */
          );
        } : void 0,
        onEditDetails: (slot) => {
          setSelectedSlot(slot);
          setPage(
            "DescriptionEditor"
            /* DescriptionEditor */
          );
        },
        onCancel,
        cancelButtonText
      }
    ) }),
    page === "MetadataEditor" && selectedSlot !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
      MetadataEditor,
      {
        session,
        slot: selectedSlot,
        onEditSession,
        onSave: (metadata) => {
          dispatch({
            type: "update_slot",
            payload: { ...selectedSlot, metadata }
          });
          showSlotsTable();
          setTriggerSave(true);
        },
        showSubmitButton: false,
        onCancel: showSlotsTable
      }
    ),
    page === "DescriptionEditor" && selectedSlot !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
      EditSlotDetails,
      {
        session,
        slot: selectedSlot,
        onEditSession,
        onSave: (update2) => {
          dispatch({
            type: "update_slot",
            payload: { ...selectedSlot, ...update2 }
          });
          showSlotsTable();
          setTriggerSave(true);
        },
        onCancel: showSlotsTable
      }
    )
  ] });
};
const EditSession$1 = ({
  session,
  onUpdated,
  onCancel
}) => {
  const mutation = useUpdateSession({ onSuccess: (data) => onUpdated(data) });
  const {
    handleSubmit,
    register: register2,
    formState: { errors }
  } = useForm({
    defaultValues: session
  });
  const handleUpdateSession = (update2) => {
    mutation.mutate({ ...session, ...update2 });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Event Sessions" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { pb: 10, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Heading$5, { as: "h1", color: "gray.700", pb: 16, children: [
        "Edit Session / ",
        session.name
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "form",
        {
          id: "add-session-form",
          onSubmit: handleSubmit(handleUpdateSession),
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              FormControl$2,
              {
                isInvalid: errors.name !== void 0,
                id: "session_name",
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { htmlFor: "name", children: "Session name" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Input$1,
                    {
                      ...register2("name", {
                        required: "Session name is required"
                      }),
                      placeholder: "name",
                      maxLength: 100
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(FormErrorMessage, { children: errors.name && errors.name.message })
                ]
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { htmlFor: "checkpointCreation", children: "Checkpoint creation" }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(
                Select$2,
                {
                  id: "checkpointCreation",
                  ...register2("checkpointCreation", { valueAsNumber: true }),
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: 0, children: "No Checkpoints" }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: 1, children: "One Checkpoint Per Session" }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: 2, children: "A checkpoint for each session slot" })
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { isInvalid: errors.description !== void 0, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { htmlFor: "description", children: "Session description" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea$1, { ...register2("description") }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormErrorMessage, { children: errors.description && errors.description.message })
            ] })
          ] })
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: handleSubmit(handleUpdateSession), colorScheme: "green", children: "Update session" })
        ]
      }
    )
  ] });
};
const ModalLoadingPage = ({
  title,
  heading: heading2
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: title }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalBody, { pb: 20, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { as: "h1", color: "gray.700", pb: 16, textAlign: "center", children: heading2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { p: 5, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, { size: "xl" }) })
  ] })
] });
const EditSessionModal = ({
  sessionId,
  renderButton
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [page, setPage] = useState(
    "Loading"
    /* Loading */
  );
  const { isLoading, data } = useSession(sessionId);
  useEffect(() => {
    if (isLoading) {
      setPage(
        "Loading"
        /* Loading */
      );
    } else {
      setPage(
        "EditSlots"
        /* EditSlots */
      );
    }
  }, [isLoading]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    renderButton === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", onClick: onOpen, children: "Edit session" }) : renderButton({ isOpen, onOpen, onClose }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Modal,
      {
        isOpen,
        onClose,
        size: "xl",
        scrollBehavior: "inside",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalContent, { minW: 800, children: [
            page === "Loading" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              ModalLoadingPage,
              {
                title: "Event Sessions",
                heading: "Loading Session"
              }
            ),
            page === "EditSlots" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              EditSlots,
              {
                isLoading: true,
                session: data,
                onSave: onClose,
                onCancel: onClose,
                onEditSession: () => setPage(
                  "EditSession"
                  /* EditSession */
                )
              }
            ),
            page === "EditSession" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              EditSession$1,
              {
                session: data,
                onUpdated: () => {
                  setPage(
                    "EditSlots"
                    /* EditSlots */
                  );
                },
                onCancel: () => setPage(
                  "EditSlots"
                  /* EditSlots */
                )
              }
            )
          ] })
        ]
      }
    )
  ] });
};
const SlotInclusionForm = ({
  field,
  session,
  onChange
}) => {
  var _a3;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", spacing: 2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox$2,
      {
        isChecked: !hasIncludeSlots(field),
        onChange: (event) => event.target.checked && onChange([]),
        children: "Include all session slots"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Include selected session slots" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        CheckboxGroup$2,
        {
          value: (_a3 = field.includeSlots) == null ? void 0 : _a3.map((s2) => s2.toString()),
          onChange: (value) => onChange(value),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", paddingLeft: 4, children: session.slots.map((slot) => /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { justifyContent: "space-between", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$2, { value: slot.id.toString(), children: slot.name }) }, slot.id)) })
        }
      )
    ] })
  ] });
};
const maxChoicesForMin$1 = (field, minChoices) => {
  if (field.maxChoices === void 0 || field.maxChoices < minChoices) {
    return minChoices;
  } else {
    return field.maxChoices;
  }
};
const minChoicesForMax$1 = (field, maxChoices) => {
  if (field.minChoices === void 0 || field.minChoices <= maxChoices) {
    return field.minChoices;
  } else {
    return maxChoices;
  }
};
const MinMaxSlotChoices = ({
  field,
  onChange
}) => {
  var _a3;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", pt: 4, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { as: "h4", size: "md", children: "Number of slot choices" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { textStyle: "label", children: "Minimum" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "The minimum session slots a user can select for this field." }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          NumberInput,
          {
            value: field.minChoices,
            onChange: (_2, valueAsNumber) => {
              if (!Number.isNaN(valueAsNumber)) {
                onChange({
                  minChoices: valueAsNumber,
                  maxChoices: maxChoicesForMin$1(field, valueAsNumber)
                });
              } else {
                onChange({
                  minChoices: void 0
                });
              }
            },
            min: 0,
            mt: 2,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(NumberInputField, {}),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(NumberInputStepper, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(NumberIncrementStepper, {}),
                /* @__PURE__ */ jsxRuntimeExports.jsx(NumberDecrementStepper, {})
              ] })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { textStyle: "label", children: "Maximum" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "The maximum session slots a user can select for this field." }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          NumberInput,
          {
            value: field.maxChoices,
            onChange: (_2, valueAsNumber) => {
              if (!Number.isNaN(valueAsNumber)) {
                const newMax = Math.max(valueAsNumber, 1);
                onChange({
                  maxChoices: newMax,
                  minChoices: minChoicesForMax$1(field, newMax)
                });
              } else {
                onChange({
                  maxChoices: void 0
                });
              }
            },
            min: ((_a3 = field == null ? void 0 : field.defaultSlots) == null ? void 0 : _a3.length) || 1,
            mt: 2,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(NumberInputField, {}),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(NumberInputStepper, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(NumberIncrementStepper, {}),
                /* @__PURE__ */ jsxRuntimeExports.jsx(NumberDecrementStepper, {})
              ] })
            ]
          }
        )
      ] })
    ] })
  ] });
};
const SlotDefaultsForm = ({
  field,
  session,
  onChange
}) => {
  var _a3;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", spacing: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Select slots by default" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CheckboxGroup$2,
      {
        value: (_a3 = field.defaultSlots) == null ? void 0 : _a3.map((s2) => s2.toString()),
        onChange: (value) => onChange(value),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", paddingLeft: 4, children: visibleSlots(field, session).map((slot) => /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { justifyContent: "space-between", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$2, { value: slot.id.toString(), children: slot.name }) }, slot.id)) })
      }
    )
  ] }) });
};
const SessionPriceOverridesTable = ({ session, formField, onChange }) => {
  const { formSettings } = useRegForm();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { width: "100%", overflowX: "auto", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$3, { style: { tableLayout: "auto" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Thead, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Slot" }, "slotName"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { isNumeric: true, children: "Default price" }, "defaultPrice"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { isNumeric: true, children: "Override Price" }, "overridePrice")
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tbody, { children: visibleSlots(formField, session).map((slot) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { children: slot.name }, "slotName"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { isNumeric: true, children: slot.priceInCents && priceWithSymbol({
        price: slot.priceInCents,
        currency: formSettings.shoppingCartCurrency
      }) }, "defaultPrice"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "auto", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        PriceInput$3,
        {
          currency: formSettings.shoppingCartCurrency,
          onChange: (price) => onChange(slot, price),
          valueInCents: getPriceOverride(formField, slot),
          minW: "95px"
        }
      ) }, "priceOverride")
    ] }, slot.id)) })
  ] }) });
};
const SessionPriceOverrides = ({
  formField,
  onSave,
  onCancel
}) => {
  const { dispatch } = useRegForm();
  const [priceOverrides, setPriceOverrides] = useState(
    formField.priceOverrides
  );
  const { data: session, error: error2, isLoading } = useSession(formField.session);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Session Pricing" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { as: "h1", color: "gray.700", pb: 16, children: "Price overrides" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { align: "center", width: "70%", pb: 5, children: "Override price used for specific sessions when users choose sessions using this form field." }),
      error2 && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { status: "error", children: "Error loading Session" }),
      isLoading && /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, { size: "xl" }),
      session !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
        SessionPriceOverridesTable,
        {
          session,
          formField,
          onChange: (slot, price) => {
            if (price !== void 0) {
              setPriceOverrides({ ...priceOverrides, [slot.id]: price });
            } else {
              const clone2 = Object.assign({}, priceOverrides);
              delete clone2[slot.id];
              setPriceOverrides(clone2);
            }
          }
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              colorScheme: "green",
              onClick: () => {
                dispatch({
                  type: "update_field",
                  name: formField.name,
                  payload: { priceOverrides }
                });
                onSave();
              },
              children: "Save"
            }
          )
        ]
      }
    )
  ] });
};
const SessionPriceOverridesModal = ({ formField, renderButton }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    renderButton === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", onClick: onOpen, children: "Override prices" }) : renderButton({ isOpen, onOpen, onClose }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Modal,
      {
        isOpen,
        onClose,
        size: "xl",
        scrollBehavior: "inside",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalContent, { minW: 800, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            SessionPriceOverrides,
            {
              formField,
              onSave: onClose,
              onCancel: onClose
            }
          ) })
        ]
      }
    )
  ] });
};
const SessionBookingFieldEditor$1 = ({
  field,
  session
}) => {
  const { dispatch, formSettings } = useRegForm();
  const handleChange = (update2) => {
    dispatch({
      type: "update_field",
      name: field.name,
      payload: update2
    });
  };
  const handleDelete2 = (field2) => dispatch({ type: "delete_field", name: field2.name });
  const handleChangeDefaults = (defaultSlots) => {
    const filteredDefaultSlots = defaultSlots == null ? void 0 : defaultSlots.filter(
      (id) => isVisibleSlot(field, session, id)
    );
    if (filteredDefaultSlots === void 0 || field.maxChoices !== void 0 && field.maxChoices > filteredDefaultSlots.length) {
      handleChange({ defaultSlots });
    } else {
      handleChange({ defaultSlots, maxChoices: filteredDefaultSlots.length });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(EditorHeader, { onDelete: handleDelete2, field, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EditSessionModal, { sessionId: session.id }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { p: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldTextForm$1, { field, onChange: handleChange }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Accordion$1, { allowMultiple: true, defaultIndex: [0], children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Slots", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        SlotInclusionForm,
        {
          field,
          session,
          onChange: (includeSlots) => handleChange({
            includeSlots: includeSlots == null ? void 0 : includeSlots.map((id) => Number(id))
          })
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(EditorAccordionItem, { title: "Slot options", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          SlotDefaultsForm,
          {
            field,
            session,
            onChange: (defaultSlots) => handleChangeDefaults(defaultSlots == null ? void 0 : defaultSlots.map((id) => Number(id)))
          }
        ),
        formSettings.multipleSessionSlotChoices && /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { py: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MinMaxSlotChoices, { field, onChange: handleChange }) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Slot pricing", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { children: "Override prices for session slots" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(SessionPriceOverridesModal, { formField: field })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Properties", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldPropertiesForm$1, { field, onChange: handleChange }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TracksAccordionItem, { field }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Depends on", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DependsOnFormContainer$1, { field, onChange: handleChange }) }),
      formSettings.metadataEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Metadata", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        MetadataModal,
        {
          metadata: field.metadata,
          title: `Field ${field.label} metadata`,
          onSave: (metadata) => handleChange({ metadata })
        }
      ) })
    ] })
  ] });
};
const SessionBookingFieldEditorContainer$1 = ({ field }) => {
  const { isLoading, data: session } = useSession(field.session);
  if (isLoading) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {}) });
  }
  if (session === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Error loading session" });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SessionBookingFieldEditor$1, { field, session });
};
const useUpdateRoomBlock = (options) => {
  const { rooming } = useAdminApi();
  const queryClient = useQueryClient();
  const mutateFn = (roomBlock) => rooming.updateRoomBlock(roomBlock);
  return useMutation(mutateFn, {
    ...options,
    onSuccess: (data, variables, context) => {
      var _a3;
      queryClient.invalidateQueries({ queryKey: ["roomBlocks"] });
      (_a3 = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a3.call(options, data, variables, context);
    }
  });
};
const defaultCurrency = {
  isoCode: "USD",
  symbol: "$"
};
const defaultDateFormats = {
  regular: "MMM d yyy",
  short: "eee d MMM"
};
const defaultLocale = {
  currency: defaultCurrency,
  dateFormats: defaultDateFormats
};
const LocaleContext = createContext(defaultLocale);
const LocaleProvider = ({
  currency = defaultCurrency,
  dateFormats: dateFormats2 = {},
  children
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    LocaleContext.Provider,
    {
      value: {
        currency,
        dateFormats: { ...defaultDateFormats, ...dateFormats2 }
      },
      children
    }
  );
};
const useLocale = () => {
  const context = useContext(LocaleContext);
  if (context === void 0) {
    return defaultLocale;
  }
  return context;
};
const RoomingTable = ({
  roomBlock,
  onAvailabilityChange,
  onUpdateRoomType,
  onMoveRoomType,
  onDeleteRoomType
}) => {
  const { dateFormats: dateFormats2 } = useLocale();
  const { formSettings } = useRegForm();
  const nights = getRoomBlockDateRange(roomBlock);
  const handleDragEnd = (result) => {
    if (result.destination) {
      onMoveRoomType(result.source.index, result.destination.index);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DragDropContext$1, { onDragEnd: handleDragEnd, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { width: "100%", overflowX: "auto", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$3, { style: { tableLayout: "auto" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Thead, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { width: "15%", children: "Drag to reorder" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Room type (click to edit)" }, "roomType"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Minimum Occupancy" }, "minOccupancy"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Maximum Occupancy" }, "maxOccupancy"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Rate" }, "price"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Resort fee" }, "resortFee"),
      nights.map((night) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Th, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("abbr", { title: "Availability", children: "Avail." }),
        " ",
        format$2(night, dateFormats2.short)
      ] }, night.toISOString())),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Actions" }, "actions")
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectedDroppable$1, { droppableId: "roomTypes", children: (provided) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Tbody, { ref: provided.innerRef, ...provided.droppableProps, children: [
      getSortedItems(roomBlock.roomTypes).map(
        (roomType, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          PublicDraggable,
          {
            draggableId: roomType.id,
            index: index2,
            children: (provided2, snapshot) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
              Tr,
              {
                ...provided2.draggableProps,
                display: snapshot.isDragging ? "table" : "table-row",
                background: "white",
                ref: provided2.innerRef,
                style: {
                  ...provided2.draggableProps.style,
                  width: snapshot.isDragging ? 500 : "auto"
                },
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "15%", ...provided2.dragHandleProps, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pl: 4, pb: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(DragHandleIcon, { color: "gray.500" }) }) }) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { minWidth: 120, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                    Editable$1,
                    {
                      placeholder: "Choose a label",
                      value: roomType.name,
                      onChange: (name2) => onUpdateRoomType(roomType.id, { name: name2 }),
                      children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx(EditablePreview, {}),
                        /* @__PURE__ */ jsxRuntimeExports.jsx(EditableInput, {})
                      ]
                    }
                  ) }) }, "roomType"),
                  !snapshot.isDragging && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "auto", px: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                      NumberInput,
                      {
                        size: "md",
                        minWidth: "50px",
                        maxWidth: "60px",
                        min: 1,
                        max: roomType.maxOccupancy,
                        value: roomType.minOccupancy,
                        onChange: (valueAsString, valueAsNumber) => !Number.isNaN(valueAsNumber) && onUpdateRoomType(roomType.id, {
                          minOccupancy: valueAsNumber
                        }),
                        children: [
                          /* @__PURE__ */ jsxRuntimeExports.jsx(
                            NumberInputField,
                            {
                              min: 0,
                              sx: { marginBottom: "0px !important" }
                            }
                          ),
                          /* @__PURE__ */ jsxRuntimeExports.jsxs(NumberInputStepper, { children: [
                            /* @__PURE__ */ jsxRuntimeExports.jsx(NumberIncrementStepper, {}),
                            /* @__PURE__ */ jsxRuntimeExports.jsx(NumberDecrementStepper, {})
                          ] })
                        ]
                      }
                    ) }, "minOccupancy"),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "auto", px: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                      NumberInput,
                      {
                        size: "md",
                        minWidth: "50px",
                        maxWidth: "60px",
                        min: roomType.minOccupancy,
                        value: roomType.maxOccupancy,
                        onChange: (valueAsString, valueAsNumber) => !Number.isNaN(valueAsNumber) && onUpdateRoomType(roomType.id, {
                          maxOccupancy: valueAsNumber
                        }),
                        children: [
                          /* @__PURE__ */ jsxRuntimeExports.jsx(
                            NumberInputField,
                            {
                              min: 0,
                              sx: { marginBottom: "0px !important" }
                            }
                          ),
                          /* @__PURE__ */ jsxRuntimeExports.jsxs(NumberInputStepper, { children: [
                            /* @__PURE__ */ jsxRuntimeExports.jsx(NumberIncrementStepper, {}),
                            /* @__PURE__ */ jsxRuntimeExports.jsx(NumberDecrementStepper, {})
                          ] })
                        ]
                      }
                    ) }, "maxOccupancy"),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                      PriceInput$3,
                      {
                        currency: formSettings.shoppingCartCurrency,
                        onChange: (price) => onUpdateRoomType(roomType.id, { price }),
                        valueInCents: roomType.price,
                        minW: "80px"
                      }
                    ) }, "price"),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                      PriceInput$3,
                      {
                        currency: formSettings.shoppingCartCurrency,
                        onChange: (resortFee) => onUpdateRoomType(roomType.id, { resortFee }),
                        valueInCents: roomType.resortFee,
                        minW: "80px"
                      }
                    ) }, "resortFee"),
                    roomType.nights.map((night) => /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "auto", px: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                      NumberInput,
                      {
                        size: "md",
                        minWidth: "70px",
                        maxWidth: "0px",
                        min: 0,
                        value: night.availability,
                        onChange: (valueAsString, valueAsNumber) => {
                          onAvailabilityChange(
                            night,
                            Number.isNaN(valueAsNumber) ? 0 : valueAsNumber
                          );
                        },
                        children: [
                          /* @__PURE__ */ jsxRuntimeExports.jsx(
                            NumberInputField,
                            {
                              min: 0,
                              sx: { marginBottom: "0px !important" }
                            }
                          ),
                          /* @__PURE__ */ jsxRuntimeExports.jsxs(NumberInputStepper, { children: [
                            /* @__PURE__ */ jsxRuntimeExports.jsx(NumberIncrementStepper, {}),
                            /* @__PURE__ */ jsxRuntimeExports.jsx(NumberDecrementStepper, {})
                          ] })
                        ]
                      }
                    ) }, night.id)),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { children: !roomType.hasValidBookings && /* @__PURE__ */ jsxRuntimeExports.jsx(
                      Button$1,
                      {
                        colorScheme: "red",
                        size: "xs",
                        onClick: () => onDeleteRoomType(roomType.id),
                        children: "Delete"
                      }
                    ) })
                  ] })
                ]
              }
            )
          },
          roomType.id
        )
      ),
      provided.placeholder
    ] }) })
  ] }) }) });
};
const minDefaultCheckIn = (roomBlock, field) => field.availableFrom !== void 0 ? parseISODate(field.availableFrom) : roomBlock.startDate;
const maxDefaultCheckOut = (roomBlock, field) => field.availableTo !== void 0 ? parseISODate(field.availableTo) : roomBlock.endDate;
const normalisedRoomBlockDates = (roomBlock, field) => {
  const update2 = {};
  const availableFromDate = parseISODate(field.availableFrom);
  if (availableFromDate !== void 0 && roomBlock.startDate > availableFromDate) {
    update2.availableFrom = formatISODate(roomBlock.startDate);
  }
  const availableToDate = parseISODate(field.availableTo);
  if (availableToDate !== void 0 && roomBlock.endDate < availableToDate) {
    update2.availableTo = formatISODate(roomBlock.endDate);
  }
  const minDefault = minDefaultCheckIn(roomBlock, { ...field, ...update2 });
  const maxDefault = maxDefaultCheckOut(roomBlock, { ...field, ...update2 });
  const defaultCheckIn = parseISODate(field.defaultCheckIn);
  const defaultCheckOut = parseISODate(field.defaultCheckOut);
  if (defaultCheckIn !== void 0 && defaultCheckIn < minDefault) {
    update2.defaultCheckIn = formatISODate(minDefault);
  }
  if (defaultCheckOut !== void 0 && defaultCheckOut > maxDefault) {
    update2.defaultCheckOut = formatISODate(maxDefault);
  }
  return update2;
};
const normalizeRoomingFieldDates = (roomBlock, form, dispatch) => {
  const roomBlockFields = flatFields$2(form).filter(isRoomBlockField$1).filter((f2) => idsEqual(f2.roomBlockId, roomBlock.id));
  roomBlockFields.forEach((field) => {
    const normalisedDates = normalisedRoomBlockDates(roomBlock, field);
    dispatch({
      type: "update_field",
      name: field.name,
      payload: normalisedDates
    });
  });
};
const EditRoomBlock$1 = ({
  roomBlock: initialRoomBlock,
  onSave,
  onCancel,
  onSelectRoomBlock
}) => {
  const [{ roomBlock }, dispatch] = useReducer(
    reducer$7,
    { application: initialApplicationState, roomBlock: initialRoomBlock },
    initializeState$2
  );
  const { form, formSettings, dispatch: formDispatch } = useRegForm();
  const mutation = useUpdateRoomBlock({
    onSuccess: (roomBlock2) => normalizeRoomingFieldDates(roomBlock2, form, formDispatch)
  });
  const [saveTrigger, setSaveTrigger] = useState();
  const scrollRef = useRef(null);
  const sortedRoomTypes = getSortedItems(roomBlock.roomTypes);
  const handleAddRoomType = () => {
    dispatch({ type: "add_room_type" });
    setTimeout(
      () => {
        var _a3;
        return (_a3 = scrollRef == null ? void 0 : scrollRef.current) == null ? void 0 : _a3.scrollIntoView({
          block: "end",
          behavior: "smooth"
        });
      },
      30
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Event Accommodation" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { ref: scrollRef, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { textAlign: "center", as: "h1", color: "gray.700", pb: 16, children: "Edit room block" }),
      mutation.error && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { status: "error", children: "Error updating Room Block" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { width: "100%", ml: 3, pb: 12, pr: "200px", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { as: "h2", size: "md", mb: 4, children: "Name and Dates" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { px: 4, align: "left", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            FormControl$2,
            {
              isRequired: true,
              isInvalid: roomBlock.name === void 0 || roomBlock.name === "",
              pt: 2,
              pb: 4,
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Name" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Input$1,
                  {
                    name: "name",
                    value: roomBlock.name,
                    onChange: (e) => dispatch({
                      type: "set_name",
                      payload: { name: e.target.value }
                    })
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { pr: "30px", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { htmlFor: "room_block_start_date", children: "Start date (first check in)" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                DatePicker,
                {
                  selectedDate: roomBlock.startDate,
                  onChange: (date) => dispatch({
                    type: "set_dates",
                    payload: {
                      startDate: date,
                      endDate: roomBlock.endDate
                    }
                  }),
                  selectsStart: true,
                  startDate: roomBlock.startDate,
                  endDate: roomBlock.endDate,
                  maxDate: roomBlock.endDate,
                  dateFormat: formSettings.dateFormat
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { htmlFor: "room_block_end_date", children: "End date (last check out)" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                DatePicker,
                {
                  selectedDate: roomBlock.endDate,
                  onChange: (date) => dispatch({
                    type: "set_dates",
                    payload: {
                      startDate: roomBlock.startDate,
                      endDate: date
                    }
                  }),
                  selectsEnd: true,
                  startDate: roomBlock.startDate,
                  endDate: roomBlock.endDate,
                  minDate: addDays$1(roomBlock.startDate, 1),
                  dateFormat: formSettings.dateFormat
                }
              )
            ] })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { width: "100%", ml: 3, pb: 12, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { as: "h2", size: "md", mb: 4, children: "Payments" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { pl: 4, maxW: 600, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { pb: 4, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Checkbox$2,
              {
                isChecked: roomBlock.collectPayment,
                onChange: (e) => {
                  if (e.target.checked) {
                    dispatch({
                      type: "update_room_block",
                      payload: { collectPayment: true, hidePrices: false }
                    });
                  } else {
                    dispatch({
                      type: "update_room_block",
                      payload: { collectPayment: false }
                    });
                  }
                },
                children: "Invoice full room amount at registration"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "If selected and the fee calculator is enabled, the full room block amount will be added to the event invoice. If a payment gateway is configured, this will be used to collect payment." })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { pb: 4, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Checkbox$2,
              {
                isChecked: roomBlock.hidePrices,
                onChange: (e) => dispatch({
                  type: "update_room_block",
                  payload: { hidePrices: e.target.checked }
                }),
                children: "Hide room prices during registration"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "If selected, room prices will be hidden from registrants during the registration process." })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Tax rate" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              PercentageInput$1,
              {
                value: roomBlock.taxRate,
                min: 0,
                maxW: 60,
                onChange: (taxRate) => dispatch({
                  type: "update_room_block",
                  payload: { taxRate }
                })
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "Set a tax rate percentage. This will be added to the registration invoice as a separate line item." })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { width: "100%", ml: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { as: "h2", size: "md", mb: 4, children: "Room types and availability" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        RoomingTable,
        {
          roomBlock,
          onAvailabilityChange: (roomNight, availability) => dispatch({
            type: "update_availability",
            id: roomNight.id,
            availability
          }),
          onUpdateRoomType: (id, roomType) => dispatch({
            type: "update_room_type",
            id,
            payload: roomType
          }),
          onMoveRoomType: (fromIndex, toIndex) => {
            const target = sortedRoomTypes[fromIndex];
            dispatch({
              type: "update_room_type",
              id: target.id,
              payload: {
                sort: getNewSort(sortedRoomTypes, fromIndex, toIndex)
              }
            });
          },
          onDeleteRoomType: (id) => dispatch({ type: "delete_room_type", id })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { pt: 2, pb: 5, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          colorScheme: "blue",
          variant: "outline",
          onClick: handleAddRoomType,
          children: "Add Room Type +"
        }
      ) })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", onClick: onCancel, children: "Back" }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonGroup$1, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button$1,
              {
                leftIcon: mutation.isLoading && saveTrigger === "SAVE" ? /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, { size: "xs" }) : void 0,
                disabled: mutation.isLoading,
                onClick: () => {
                  setSaveTrigger("SAVE");
                  mutation.mutate(roomBlock, {
                    onSuccess: () => {
                      dispatch({ type: "set_is_dirty", isDirty: false });
                      onSave == null ? void 0 : onSave(roomBlock);
                    }
                  });
                },
                colorScheme: "green",
                children: "Save"
              }
            ),
            !hasRoomBlockField(form, roomBlock) && onSelectRoomBlock !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button$1,
              {
                leftIcon: mutation.isLoading && saveTrigger === "FORM" ? /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, { size: "xs" }) : void 0,
                disabled: mutation.isLoading,
                onClick: () => {
                  setSaveTrigger("FORM");
                  mutation.mutate(roomBlock, {
                    onSuccess: (roomBlock2) => {
                      dispatch({ type: "set_is_dirty", isDirty: false });
                      onSelectRoomBlock == null ? void 0 : onSelectRoomBlock(roomBlock2);
                    }
                  });
                },
                colorScheme: "green",
                children: "Save and add to form"
              }
            )
          ] })
        ]
      }
    )
  ] });
};
const EditRoomBlockContainer = ({
  roomBlockId,
  onSave,
  onCancel,
  onSelectRoomBlock
}) => {
  const { data } = useRoomBlock(roomBlockId);
  const [roomBlock, setRoomBlock] = useState(
    data
  );
  useEffect(() => {
    setRoomBlock(data);
  }, [data]);
  if (roomBlock !== void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      EditRoomBlock$1,
      {
        roomBlock,
        onSave,
        onCancel,
        onSelectRoomBlock
      }
    );
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      ModalLoadingPage,
      {
        title: "Event accommodation",
        heading: "Loading room block"
      }
    );
  }
};
const EditRoomBlockModal = ({
  roomBlockId,
  renderButton
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    renderButton === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", onClick: onOpen, children: "Edit room block" }) : renderButton({ isOpen, onOpen, onClose }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Modal,
      {
        isOpen,
        onClose,
        size: "xl",
        scrollBehavior: "inside",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalContent, { minW: 800, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            EditRoomBlockContainer,
            {
              roomBlockId,
              onCancel: onClose,
              onSave: onClose
            }
          ) })
        ]
      }
    )
  ] });
};
const RoomTypeInclusionForm$1 = ({
  field,
  roomBlock,
  onChange
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", spacing: 2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Checkbox$2,
    {
      isChecked: !hasIncludeRoomTypes(field),
      onChange: (event) => event.target.checked && onChange([]),
      children: "Include all room types"
    }
  ) }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Include selected room types only" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CheckboxGroup$2,
      {
        value: field.includeRoomTypes,
        onChange: (value) => onChange(value),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", paddingLeft: 4, children: roomBlock.roomTypes.map((roomType) => /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { justifyContent: "space-between", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$2, { value: roomType.id, children: roomType.name }) }, roomType.id)) })
      }
    )
  ] })
] });
const RoomingFieldDefaultsForm$1 = ({
  roomBlock,
  field,
  onChange
}) => {
  const { dateFormats: dateFormats2 } = useLocale();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", spacing: 2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Default check in date" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "The default check in date pre-selected on the registration form." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DatePicker,
        {
          onChangeRaw: (e) => e.preventDefault(),
          minDate: roomBlock.startDate,
          maxDate: subDays$1(roomBlock.endDate),
          dateFormat: dateFormats2.regular,
          onChange: (defaultCheckIn) => onChange({ defaultCheckIn: formatISODate(defaultCheckIn) }),
          selectedDate: parseISODate(field.defaultCheckIn),
          usePortal: true,
          isClearable: true
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Default check out date" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "The default check out date pre-selected on the registration form." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DatePicker,
        {
          onChangeRaw: (e) => e.preventDefault(),
          minDate: addDays$1(roomBlock.startDate, 1),
          maxDate: roomBlock.endDate,
          dateFormat: dateFormats2.regular,
          onChange: (defaultCheckOut) => onChange({ defaultCheckOut: formatISODate(defaultCheckOut) }),
          selectedDate: parseISODate(field.defaultCheckOut),
          usePortal: true,
          isClearable: true
        }
      )
    ] })
  ] });
};
const RoomingFieldAvailableDatesForm$1 = ({ roomBlock, field, onChange }) => {
  const { dateFormats: dateFormats2 } = useLocale();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", spacing: 2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Availability start date" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "Override room block default start date availability for this field. (Admins can still book all room block dates)." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DatePicker,
        {
          onChangeRaw: (e) => e.preventDefault(),
          minDate: roomBlock.startDate,
          maxDate: subDays$1(roomBlock.endDate),
          dateFormat: dateFormats2.regular,
          onChange: (availabilityStartDate) => onChange({
            availableFrom: formatISODate(availabilityStartDate)
          }),
          selectedDate: parseISODate(field.availableFrom),
          usePortal: true,
          isClearable: true
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Availability end date" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "Override room block default end date availability for this field. (Admins can still book all room block dates)." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DatePicker,
        {
          onChangeRaw: (e) => e.preventDefault(),
          minDate: addDays$1(roomBlock.startDate, 1),
          maxDate: roomBlock.endDate,
          dateFormat: dateFormats2.regular,
          onChange: (availabilityEndDate) => onChange({
            availableTo: formatISODate(availabilityEndDate)
          }),
          selectedDate: parseISODate(field.availableTo),
          usePortal: true,
          isClearable: true
        }
      )
    ] })
  ] });
};
const PriceOverridesTable = ({
  roomBlock,
  formField,
  onChange
}) => {
  const { dateFormats: dateFormats2 } = useLocale();
  const { formSettings } = useRegForm();
  const nights = getRoomBlockDateRange(roomBlock);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { width: "100%", overflowX: "auto", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$3, { style: { tableLayout: "auto" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Thead, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Room type" }, "roomType"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Occupancy" }, "occupancy"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { isNumeric: true, children: "Default price" }, "defaultPrice"),
      nights.map((night) => /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: format$2(night, dateFormats2.short) }, night.toISOString()))
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tbody, { children: getIncludedRoomTypes(roomBlock, formField).map((roomType) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { minW: 120, children: roomType.name }, "roomType"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Td, {}, "occupancy"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { isNumeric: true, children: priceWithSymbol({
        price: roomType.price,
        currency: formSettings.shoppingCartCurrency
      }) }, "defaultPrice"),
      roomType.nights.map((night) => /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "auto", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        PriceInput$3,
        {
          currency: formSettings.shoppingCartCurrency,
          onChange: (price) => onChange(night, price),
          valueInCents: getPriceOverride$1(formField, night),
          minW: "95px"
        }
      ) }, night.id))
    ] }, roomType.id)) })
  ] }) });
};
const PriceOverrides = ({
  formField,
  onSave,
  onCancel
}) => {
  const { dispatch } = useRegForm();
  const [priceOverrides, setPriceOverrides] = useState(
    formField.priceOverrides
  );
  const {
    data: roomBlock,
    error: error2,
    isLoading
  } = useRoomBlock(formField.roomBlockId);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Event Accommodation" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { as: "h1", color: "gray.700", pb: 16, children: "Price overrides" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { align: "center", width: "70%", pb: 5, children: "Override price used for specific nights when users choose accommodation using this form field" }),
      error2 && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { status: "error", children: "Error loading Room Block" }),
      isLoading && /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pb: 8, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, { size: "xl" }) }),
      roomBlock !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
        PriceOverridesTable,
        {
          roomBlock,
          formField: {
            ...formField,
            priceOverrides
          },
          onChange: (night, price) => {
            if (price !== void 0) {
              setPriceOverrides({ ...priceOverrides, [night.id]: price });
            } else {
              const clone2 = Object.assign({}, priceOverrides);
              delete clone2[night.id];
              setPriceOverrides(clone2);
            }
          }
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              colorScheme: "green",
              onClick: () => {
                dispatch({
                  type: "update_field",
                  name: formField.name,
                  payload: { priceOverrides }
                });
                onSave();
              },
              children: "Save"
            }
          )
        ]
      }
    )
  ] });
};
const OccupancyPriceOverrideTable = ({ roomBlock, formField, onChange }) => {
  const { dateFormats: dateFormats2 } = useLocale();
  const { formSettings } = useRegForm();
  const nights = getRoomBlockDateRange(roomBlock);
  console.log("form field", formField);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { width: "100%", overflowX: "auto", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$3, { style: { tableLayout: "auto" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Thead, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Room type" }, "roomType"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Occupancy" }, "occupancy"),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { isNumeric: true, children: "Default price" }, "defaultPrice"),
      nights.map((night) => /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: format$2(night, dateFormats2.short) }, night.toISOString()))
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tbody, { children: getIncludedRoomTypesWithOccupancy(roomBlock, formField).map(
      ({ roomType, occupancy }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { minW: 120, children: roomType.name }, "roomType"),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { children: occupancy }, "occupancy"),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { isNumeric: true, children: priceWithSymbol({
          price: roomType.price,
          currency: formSettings.shoppingCartCurrency
        }) }, "defaultPrice"),
        roomType.nights.map((night) => /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "auto", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          PriceInput$3,
          {
            currency: formSettings.shoppingCartCurrency,
            onChange: (price) => onChange(night, occupancy, price),
            valueInCents: getOccupancyPriceOverride(
              formField,
              night,
              occupancy
            ),
            minW: "95px"
          }
        ) }, night.id))
      ] }, `${roomType.id}-${occupancy}`)
    ) })
  ] }) });
};
const OccupancyPriceOverrides = ({
  formField,
  onSave,
  onCancel
}) => {
  const { dispatch } = useRegForm();
  const [occupancyPriceOverrides, setOccupancyPriceOverrides] = useState(
    formField.occupancyPriceOverrides
  );
  const {
    data: roomBlock,
    error: error2,
    isLoading
  } = useRoomBlock(formField.roomBlockId);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Event Accommodation" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { as: "h1", color: "gray.700", pb: 16, children: "Price overrides" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { align: "center", width: "70%", pb: 5, children: "Override price used for specific nights and occupancy when users choose accommodation using this form field" }),
      error2 && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { status: "error", children: "Error loading Room Block" }),
      isLoading && /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pb: 8, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, { size: "xl" }) }),
      roomBlock !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
        OccupancyPriceOverrideTable,
        {
          roomBlock,
          formField: {
            ...formField,
            occupancyPriceOverrides
          },
          onChange: (night, occupancy, price) => {
            if (price !== void 0) {
              const nightOverrides = (occupancyPriceOverrides == null ? void 0 : occupancyPriceOverrides[night.id]) !== void 0 ? { ...occupancyPriceOverrides == null ? void 0 : occupancyPriceOverrides[night.id] } : {};
              nightOverrides[occupancy] = price;
              setOccupancyPriceOverrides({
                ...occupancyPriceOverrides,
                [night.id]: nightOverrides
              });
            } else {
              const nightOverrides = occupancyPriceOverrides == null ? void 0 : occupancyPriceOverrides[night.id];
              if (nightOverrides !== void 0) {
                const clone2 = Object.assign({}, nightOverrides);
                delete clone2[occupancy];
                setOccupancyPriceOverrides({
                  ...occupancyPriceOverrides,
                  [night.id]: clone2
                });
              }
            }
          }
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              colorScheme: "green",
              onClick: () => {
                dispatch({
                  type: "update_field",
                  name: formField.name,
                  payload: { occupancyPriceOverrides }
                });
                onSave();
              },
              children: "Save"
            }
          )
        ]
      }
    )
  ] });
};
const PriceOverridesModal = ({
  formField,
  renderButton
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    renderButton === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", onClick: onOpen, children: "Override prices" }) : renderButton({ isOpen, onOpen, onClose }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Modal,
      {
        isOpen,
        onClose,
        size: "xl",
        scrollBehavior: "inside",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalContent, { minW: 800, children: formField.occupancyPricing ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            OccupancyPriceOverrides,
            {
              formField,
              onSave: onClose,
              onCancel: onClose
            }
          ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
            PriceOverrides,
            {
              formField,
              onSave: onClose,
              onCancel: onClose
            }
          ) })
        ]
      }
    )
  ] });
};
const RoomingPricingForm$1 = ({
  field,
  onChange
}) => {
  const { formSettings } = useRegForm();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", spacing: 2, children: [
    formSettings.occupancyPricingEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox$2,
      {
        isChecked: field.occupancyPricing,
        onChange: (event) => onChange({ occupancyPricing: event.target.checked }),
        children: "Use occupancy based pricing for room types"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(PriceOverridesModal, { formField: field })
  ] });
};
const RoomBlockFieldEditor$1 = ({
  field,
  roomBlock
}) => {
  const { dispatch } = useRegForm();
  const handleChange = (update2) => dispatch({
    type: "update_field",
    name: field.name,
    payload: update2
  });
  const handleRoomingChange = (update2) => {
    const normalisedUpdate = normalisedRoomBlockDates(roomBlock, {
      ...field,
      ...update2
    });
    dispatch({
      type: "update_field",
      name: field.name,
      payload: { ...update2, ...normalisedUpdate }
    });
  };
  const handleDelete2 = (field2) => dispatch({ type: "delete_field", name: field2.name });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(EditorHeader, { onDelete: handleDelete2, field, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EditRoomBlockModal, { roomBlockId: roomBlock.id }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { p: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldTextForm$1, { field, onChange: handleChange }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Accordion$1, { allowMultiple: true, defaultIndex: [0, 1, 2], children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Room types", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        RoomTypeInclusionForm$1,
        {
          field,
          roomBlock,
          onChange: (includeRoomTypes) => handleRoomingChange({ includeRoomTypes })
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Pricing", children: /* @__PURE__ */ jsxRuntimeExports.jsx(RoomingPricingForm$1, { field, onChange: handleChange }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Available dates", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        RoomingFieldAvailableDatesForm$1,
        {
          roomBlock,
          field,
          onChange: handleRoomingChange
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Default dates", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        RoomingFieldDefaultsForm$1,
        {
          roomBlock,
          field,
          onChange: handleRoomingChange
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Properties", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldPropertiesForm$1, { field, onChange: handleChange }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TracksAccordionItem, { field }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Depends on", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DependsOnFormContainer$1, { field, onChange: handleChange }) })
    ] })
  ] });
};
const RoomBlockFieldEditorContainer$1 = ({ field }) => {
  const { error: error2, data: roomBlock } = useRoomBlock(field.roomBlockId);
  if (error2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Error loading room block" });
  }
  if (roomBlock === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { py: 6, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {}) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RoomBlockFieldEditor$1, { field, roomBlock });
};
const LeadScannerEditor$1 = ({ field }) => {
  const { dispatch, formSettings } = useRegForm();
  const handleChange = (update2) => {
    dispatch({
      type: "update_field",
      name: field.name,
      payload: update2
    });
  };
  const handleDelete2 = (field2) => dispatch({ type: "delete_field", name: field2.name });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(EditorHeader, { onDelete: handleDelete2, field }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { p: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldTextForm$1, { field, onChange: handleChange }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Accordion$1, { allowMultiple: true, defaultIndex: [0], children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Properties", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldPropertiesForm$1, { field, onChange: handleChange }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TracksAccordionItem, { field }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Depends on", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DependsOnFormContainer$1, { field, onChange: handleChange }) }),
      formSettings.shoppingCartEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Price", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        FieldPriceForm$1,
        {
          field,
          onChange: handleChange,
          currency: formSettings.shoppingCartCurrency
        }
      ) }),
      formSettings.metadataEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(EditorAccordionItem, { title: "Metadata", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        MetadataModal,
        {
          metadata: field.metadata,
          title: `Field ${field.label} metadata`,
          onSave: (metadata) => handleChange({ metadata })
        }
      ) })
    ] })
  ] });
};
const FieldEditor = ({ field: v1Field }) => {
  if (v1Field === null || v1Field === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { children: "Please select a field to start editing" });
  }
  const field = formItemToV2(v1Field);
  switch (field.type) {
    case "page":
    case "section":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerEditor$1, { field }, field.name);
    case "info":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(InfoSectionEditor$1, { field }, field.name);
    case "session_booking":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SessionBookingFieldEditorContainer$1, { field }, field.name);
    case "room_block":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(RoomBlockFieldEditorContainer$1, { field }, field.name);
    case "lead_scanner":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(LeadScannerEditor$1, { field }, field.name);
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(InputEditor$1, { field }, field.name);
  }
};
const AddFieldLink = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Link$2, { _hover: { textDecoration: "none" }, ...props });
const FieldButton = ({
  label,
  description,
  Icon: Icon2
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { py: 4, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { w: "12%", flexShrink: 0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon2, { size: "100%", color: "rgba(50,50,50,0.9)" }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", pl: 4, pt: 2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { textStyle: "editorItemLabel", as: "h5", children: label }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { mt: 0, fontSize: "sm", children: description })
  ] })
] });
const PageButton = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label: "Page",
    description: "Add a page to the form",
    Icon: fieldIcons.page,
    ...props
  }
);
const SectionButton = ({
  label = "Section",
  description = "Group fields together"
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label,
    description,
    Icon: fieldIcons.section
  }
);
const InfoTextButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label: "Info Text",
    description: "Display informative text",
    Icon: fieldIcons.info
  }
);
const TextFieldButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label: "Text field",
    description: "Use text fields to collect simple text input",
    Icon: fieldIcons.text
  }
);
const CheckBoxButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label: "Check box",
    description: "Use checkboxes to collect yes or no answers to questions",
    Icon: fieldIcons.checkbox
  }
);
const DropDownButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label: "Dropdown",
    description: "Use dropdowns to collect options with choices",
    Icon: fieldIcons.dropdown
  }
);
const RadioFieldButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label: "Radio",
    description: "Use radio buttons to collect options with choices",
    Icon: fieldIcons.radio
  }
);
const IntegerFieldButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label: "Number",
    description: "Collect numeric data",
    Icon: AiOutlineNumber
  }
);
const DateFieldButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label: "Date input",
    description: "Allow the user to select a date",
    Icon: fieldIcons.date
  }
);
const TextAreaButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label: "Text area",
    description: "Collect multi-line text",
    Icon: fieldIcons.textarea
  }
);
const EmailFieldButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label: "Email",
    description: "Collect email addresses",
    Icon: fieldIcons.email
  }
);
const PhoneNumberButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label: "Phone number",
    description: "Collect telephone numbers",
    Icon: fieldIcons.telephone
  }
);
const SimpleFields = ({ addFieldHandler }) => {
  const { dispatch, formSettings } = useRegForm();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddFieldLink,
      {
        onClick: () => addFieldHandler(() => dispatch({ type: "add_page" })),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PageButton, {})
      }
    ),
    formSettings.registrationPhasesEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddFieldLink,
      {
        onClick: () => addFieldHandler(
          () => dispatch({
            type: "add_page",
            page: { phase: "pretrack" }
          })
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          PageButton,
          {
            description: "Add a page to the form (pre-registration)",
            label: "Add pre-registration page"
          }
        )
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddFieldLink,
      {
        onClick: () => addFieldHandler(
          () => dispatch({ type: "add_field", field: fieldDefaults.section })
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(SectionButton, {})
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddFieldLink,
      {
        onClick: () => addFieldHandler(
          () => dispatch({ type: "add_field", field: fieldDefaults.infoField })
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(InfoTextButton, {})
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("hr", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddFieldLink,
      {
        onClick: () => addFieldHandler(
          () => dispatch({ type: "add_field", field: fieldDefaults.textField })
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(TextFieldButton, {})
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddFieldLink,
      {
        onClick: () => addFieldHandler(
          () => dispatch({ type: "add_field", field: fieldDefaults.checkBoxField })
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckBoxButton, {})
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddFieldLink,
      {
        onClick: () => addFieldHandler(
          () => dispatch({ type: "add_field", field: fieldDefaults.dropDownField })
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(DropDownButton, {})
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddFieldLink,
      {
        onClick: () => addFieldHandler(
          () => dispatch({ type: "add_field", field: fieldDefaults.radioField })
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(RadioFieldButton, {})
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddFieldLink,
      {
        onClick: () => addFieldHandler(
          () => dispatch({ type: "add_field", field: fieldDefaults.numberField })
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(IntegerFieldButton, {})
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddFieldLink,
      {
        onClick: () => addFieldHandler(
          () => dispatch({ type: "add_field", field: fieldDefaults.dateField })
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(DateFieldButton, {})
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddFieldLink,
      {
        onClick: () => addFieldHandler(
          () => dispatch({ type: "add_field", field: fieldDefaults.textAreaField })
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(TextAreaButton, {})
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddFieldLink,
      {
        onClick: () => addFieldHandler(
          () => dispatch({ type: "add_field", field: fieldDefaults.emailField })
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(EmailFieldButton, {})
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddFieldLink,
      {
        onClick: () => addFieldHandler(
          () => dispatch({
            type: "add_field",
            field: fieldDefaults.phoneNumberField
          })
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PhoneNumberButton, {})
      }
    )
  ] });
};
const DocumentFieldButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label: "Document upload",
    description: "Collect document uploads during registration",
    Icon: fieldIcons.document
  }
);
const useAddSession = (options) => {
  const { sessions } = useAdminApi();
  const mutateFn = (newSession) => sessions.createSession(newSession);
  return useMutation(mutateFn, options);
};
const AddSession$1 = ({ onAdded, onCancel }) => {
  const mutation = useAddSession({ onSuccess: (data) => onAdded(data) });
  const {
    handleSubmit,
    register: register2,
    formState: { errors }
  } = useForm();
  const handleAddSession = (session) => {
    mutation.mutate(session);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Event Sessions" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { pb: 10, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { as: "h1", color: "gray.700", pb: 16, children: "Add a Session" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("form", { id: "add-session-form", onSubmit: handleSubmit(handleAddSession), children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          FormControl$2,
          {
            isInvalid: errors.name !== void 0,
            id: "session_name",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { htmlFor: "name", children: "Session name" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Input$1,
                {
                  ...register2("name", {
                    required: "Session name is required"
                  }),
                  placeholder: "name",
                  maxLength: 100
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormErrorMessage, { children: errors.name && errors.name.message })
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { htmlFor: "checkpointCreation", children: "Checkpoint creation" }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            Select$2,
            {
              id: "checkpointCreation",
              ...register2("checkpointCreation", { valueAsNumber: true }),
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: 0, children: "No Checkpoints" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: 1, children: "One Checkpoint Per Session" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: 2, children: "A checkpoint for each session slot" })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { isInvalid: errors.description !== void 0, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { htmlFor: "description", children: "Session description" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea$1, { ...register2("description") }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormErrorMessage, { children: errors.description && errors.description.message })
        ] })
      ] }) })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: handleSubmit(handleAddSession), colorScheme: "green", children: "Create session" })
        ]
      }
    )
  ] });
};
const SessionsTable$1 = ({
  sessions,
  selectButtonText = "Add to form",
  onSelectSession,
  onDeleteSession,
  onEditSlots
}) => {
  const { form, formSettings } = useRegForm();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$3, { size: "sm", style: { tableLayout: "fixed" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Thead, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Name" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Form field" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { width: "10%", children: "Slots" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { textAlign: "center", children: "Actions" })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tbody, { children: sessions.map((session) => {
      var _a3;
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { children: session.name }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Td, { children: [
          ((_a3 = getFieldForSession(form, session)) == null ? void 0 : _a3.label) || "None",
          " "
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "10%", children: session.slots.length }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonGroup$1, { spacing: 1, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { size: "xs", onClick: () => onEditSlots(session), children: "Edit slots" }),
          canSelectSession(form, formSettings, session) && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              size: "xs",
              onClick: () => onSelectSession(session),
              colorScheme: "green",
              children: selectButtonText
            }
          ),
          canDeleteSession(form, session) && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              size: "xs",
              onClick: () => onDeleteSession(session),
              colorScheme: "red",
              children: "Delete"
            }
          )
        ] }) })
      ] }, session.id);
    }) })
  ] });
};
const BookableSessionsIcon = createIcon({
  displayName: "BookableSessionsIcon",
  viewBox: "0 0 22 22",
  path: /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "22", height: "22", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M2 4H0v16c0 1.1.9 2 2 2h16v-2H2V4zm11 7V7a2 2 0 00-2-2h-1a2 2 0 00-2 2v1a2 2 0 002 2h1v1H8v2h3a2 2 0 002-2zm-3-3V7h1v1h-1zm10-8H6C4.9 0 4 .9 4 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 8h-2V6h-2v2h-2v2h2v2h2v-2h2v6H6V2h14v6z",
      fill: "#FFF",
      fillRule: "evenodd"
    }
  ) })
});
const BookableSessionsPanel = (props) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  VStack,
  {
    px: 4,
    py: 3,
    bg: "features.sessions",
    boxShadow: "inset 0px 0px 1px 1px rebeccapurple",
    _hover: {
      bg: "rebeccapurple"
    },
    transition: "all 0.2 s ease-in-out",
    maxH: "min",
    ...props,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(BookableSessionsIcon, { boxSize: 6 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Text$3,
        {
          sx: {
            fontSize: "10px !important",
            fontWeight: "700 !important"
          },
          color: "white",
          textTransform: "uppercase",
          children: "Sessions"
        }
      )
    ]
  }
);
const GettingStarted$1 = ({
  onNewSession,
  onCancel
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Event Sessions" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { as: "h1", color: "gray.700", pb: 14, textAlign: "center", children: "Getting started with sessions" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { px: 8, py: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(BookableSessionsPanel, {}) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(UnorderedList, { spacing: 3, pl: 2, pr: 4, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem$1, { children: "Bookable sessions are capacity limited areas of the event." }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem$1, { children: "Each session has multiple slots attendees can choose from." }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem$1, { children: "If a session is marked as required, the attendees must be able to select a slot with available capacity to complete their registration." })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { pt: 6, pb: 6, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", variant: "outline", onClick: onNewSession, children: "Create a session +" }) })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: "Cancel" })
      }
    )
  ] });
};
const useDeleteSession = (options) => {
  const { sessions } = useAdminApi();
  const queryClient = useQueryClient();
  const mutateFn = (session) => sessions.deleteSession(session);
  return useMutation(mutateFn, {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.removeQueries({ queryKey: ["sessions"] });
    }
  });
};
const ListSessions$1 = ({
  onCancel,
  onSelectSession,
  onEditSlots,
  onNewSession
}) => {
  const { isLoading, error: error2, sessions } = useSessions();
  const mutation = useDeleteSession();
  if ((sessions == null ? void 0 : sessions.length) === 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(GettingStarted$1, { onNewSession, onCancel });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Event Sessions" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { as: "h1", color: "gray.700", pb: 16, children: "Select a Session" }),
      error2 && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { status: "error", children: "Error Fetching Sessions" }),
      isLoading && /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {}),
      sessions !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
        SessionsTable$1,
        {
          sessions,
          onSelectSession,
          onEditSlots,
          onDeleteSession: (session) => mutation.mutate(session)
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", variant: "outline", onClick: onNewSession, children: "Add Session +" })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: "Cancel" })
      }
    )
  ] });
};
const SessionBookingModal = ({
  form,
  onSelectSession,
  renderButton
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [session, setSession] = useState();
  const [, setAlertMessage] = useState(null);
  const [page, setPage] = useState(
    "ListSessions"
    /* ListSessions */
  );
  useEffect(() => {
    if (isOpen) {
      setPage(
        "ListSessions"
        /* ListSessions */
      );
    }
  }, [isOpen]);
  const handleAddSession = (addedSession) => {
    setAlertMessage({ status: "success", message: "Session added" });
    setSession(addedSession);
    setPage(
      "EditSlots"
      /* EditSlots */
    );
  };
  const handleEditSlots = (session2) => {
    setSession(session2);
    setPage(
      "EditSlots"
      /* EditSlots */
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    renderButton === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", onClick: onOpen, children: "Sessions" }) : renderButton({ isOpen, onOpen, onClose }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Modal,
      {
        isOpen,
        onClose,
        size: "xl",
        scrollBehavior: "inside",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalContent, { minW: 800, children: [
            page === "ListSessions" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              ListSessions$1,
              {
                form,
                onCancel: onClose,
                onSelectSession: (session2) => {
                  onSelectSession(session2);
                  onClose();
                },
                onEditSlots: handleEditSlots,
                onNewSession: () => setPage(
                  "AddSession"
                  /* AddSession */
                )
              }
            ),
            page === "EditSlots" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              EditSlots,
              {
                session,
                onSave: () => setPage(
                  "ListSessions"
                  /* ListSessions */
                ),
                onCancel: () => setPage(
                  "ListSessions"
                  /* ListSessions */
                ),
                onEditSession: () => setPage(
                  "EditSession"
                  /* EditSession */
                ),
                cancelButtonText: "Back to sessions"
              }
            ),
            page === "AddSession" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              AddSession$1,
              {
                onAdded: handleAddSession,
                onCancel: () => setPage(
                  "ListSessions"
                  /* ListSessions */
                )
              }
            ),
            page === "EditSession" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              EditSession$1,
              {
                session,
                onUpdated: (session2) => {
                  setSession(session2);
                  setPage(
                    "EditSlots"
                    /* EditSlots */
                  );
                },
                onCancel: () => setPage(
                  "EditSlots"
                  /* EditSlots */
                )
              }
            )
          ] })
        ]
      }
    )
  ] });
};
const SessionBookingButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label: fieldLabels$1.session_booking,
    description: "Add bookable sessions with restricted capacity and price",
    Icon: fieldIcons.session_booking
  }
);
const useRoomBlocks = () => {
  const { rooming } = useAdminApi();
  return useQuery(
    ["roomBlocks"],
    () => rooming.getRoomBlocks()
  );
};
const AccommodationIcon = createIcon({
  displayName: "AccommodationIcon",
  viewBox: "0 0 22 22",
  path: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      width: "22px",
      height: "22px",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "accommodation" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("desc", { children: "Created with Sketch." }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "g",
          {
            id: "Page-1",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "g",
              {
                id: "accommodation-dark",
                transform: "translate(0.000000, 3.000000)",
                fill: "#FFFFFF",
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "path",
                  {
                    d: "M6.1754386,7.9122807 C7.77719298,7.9122807 9.07017544,6.61929825 9.07017544,5.01754386 C9.07017544,3.41578947 7.77719298,2.12280702 6.1754386,2.12280702 C4.57368421,2.12280702 3.28070175,3.41578947 3.28070175,5.01754386 C3.28070175,6.61929825 4.57368421,7.9122807 6.1754386,7.9122807 L6.1754386,7.9122807 Z M17.754386,2.12280702 L10.0350877,2.12280702 L10.0350877,8.87719298 L2.31578947,8.87719298 L2.31578947,0.192982456 L0.385964912,0.192982456 L0.385964912,14.6666667 L2.31578947,14.6666667 L2.31578947,11.7719298 L19.6842105,11.7719298 L19.6842105,14.6666667 L21.6140351,14.6666667 L21.6140351,5.98245614 C21.6140351,3.85 19.8868421,2.12280702 17.754386,2.12280702 L17.754386,2.12280702 Z",
                    id: "Icon"
                  }
                )
              }
            )
          }
        )
      ]
    }
  )
});
const AccommodationPanel = (props) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  VStack,
  {
    px: "17px",
    py: 3,
    bg: "darkblue",
    boxShadow: "inset 0px 0px 1px 1px #1D2951",
    _hover: {
      bg: "#1D2951"
    },
    transition: "all 0.2 s ease-in-out",
    maxH: "min",
    ...props,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(AccommodationIcon, { boxSize: 8 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Text$3,
        {
          sx: {
            fontSize: "10px !important",
            fontWeight: "700 !important"
          },
          color: "white",
          textTransform: "uppercase",
          children: "Rooming"
        }
      )
    ]
  }
);
const GettingStarted = ({
  onNewRoomBlock,
  onCancel
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Event Accommodation" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { as: "h1", color: "gray.700", pb: 14, textAlign: "center", children: "Getting started with Accommodation" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { px: 8, py: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AccommodationPanel, {}) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(UnorderedList, { spacing: 3, pl: 2, pr: 4, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem$1, { children: "Room blocks let you manage event accommodation that attendees can choose during registration." }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem$1, { children: "You can create multiple room blocks, and set availability for different room types on different nights." }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem$1, { children: "You can use normal form depends on and tracks visibility controls to control which attendees can register for which room nights, and at what price." })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { pt: 6, pb: 6, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          colorScheme: "blue",
          variant: "outline",
          onClick: onNewRoomBlock,
          children: "Create a room block +"
        }
      ) })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: "Cancel" })
      }
    )
  ] });
};
const RoomBlockDateRange = ({
  roomBlock,
  dateFormat = "MMM d yyyy"
}) => {
  const numberOfNights = getBlockNightsCount(roomBlock);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    format$2(roomBlock.startDate, dateFormat),
    " - ",
    format$2(roomBlock.endDate, dateFormat),
    " (",
    numberOfNights,
    " ",
    numberOfNights === 1 ? "night" : "nights",
    ")"
  ] });
};
const RoomBlockTable$1 = ({
  roomBlocks: roomBlocks2,
  onEditRoomBlock,
  onSelectRoomBlock,
  onDelete
}) => {
  const { form } = useRegForm();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$3, { size: "sm", style: { tableLayout: "fixed" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Thead, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Name" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { width: "33%", children: "Dates" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { isNumeric: true, width: "10%", children: "Room types" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { isNumeric: true, width: "12%", children: "Booked" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { textAlign: "center", children: "Actions" })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tbody, { children: roomBlocks2.map((roomBlock) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { children: roomBlock.name }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "35%", children: /* @__PURE__ */ jsxRuntimeExports.jsx(RoomBlockDateRange, { roomBlock }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { isNumeric: true, width: "10%", px: 5, children: roomBlock.roomTypes.length }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { isNumeric: true, width: "12%", px: 5, children: roomBlock.numberBooked }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonGroup$1, { spacing: 1, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { size: "xs", onClick: () => onEditRoomBlock(roomBlock), children: "Edit" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button$1,
          {
            colorScheme: "green",
            size: "xs",
            onClick: () => onSelectRoomBlock(roomBlock),
            children: "Add to form"
          }
        ),
        canDeleteRoomBlock(roomBlock, form) && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button$1,
          {
            colorScheme: "red",
            size: "xs",
            onClick: () => onDelete(roomBlock),
            children: "Delete"
          }
        )
      ] }) })
    ] }, roomBlock.id)) })
  ] });
};
const useDeleteRoomBlock = (options) => {
  const { rooming } = useAdminApi();
  const queryClient = useQueryClient();
  const mutateFn = (roomBlock) => rooming.deleteRoomBlock(roomBlock);
  return useMutation(mutateFn, {
    ...options,
    onSuccess: (data, variables, context) => {
      var _a3;
      queryClient.invalidateQueries({ queryKey: ["roomBlocks"] });
      (_a3 = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a3.call(options, data, variables, context);
    }
  });
};
const ListRoomBlocks$1 = ({
  onCancel,
  onEditRoomBlock,
  onNewRoomBlock,
  onSelectRoomBlock
}) => {
  const { isLoading, error: error2, data: roomBlocks2 } = useRoomBlocks();
  const deleteMutation = useDeleteRoomBlock();
  if ((roomBlocks2 == null ? void 0 : roomBlocks2.length) === 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(GettingStarted, { onNewRoomBlock, onCancel });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Event Accommodation" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { as: "h1", color: "gray.700", pb: 16, children: "Room Blocks" }),
      error2 && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { status: "error", children: "Error loading Room Blocks" }),
      isLoading && /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pb: 8, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, { size: "xl" }) }),
      roomBlocks2 !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
        RoomBlockTable$1,
        {
          roomBlocks: getSortedRoomBlocks(roomBlocks2),
          onEditRoomBlock,
          onDelete: (roomBlock) => deleteMutation.mutate(roomBlock),
          onSelectRoomBlock
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", variant: "outline", onClick: onNewRoomBlock, children: "Add Room Block +" })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: "Cancel" })
      }
    )
  ] });
};
const RoomBlockForm$1 = ({
  roomBlock: initialRoomBlock,
  onSubmit,
  formRef
}) => {
  const {
    handleSubmit,
    control,
    register: register2,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: initialRoomBlock
  });
  const bottomRef = useRef(null);
  const { formSettings } = useRegForm();
  const { startDate, endDate } = watch();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("form", { id: "room-block-form", onSubmit: handleSubmit(onSubmit), ref: formRef, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        FormControl$2,
        {
          isRequired: true,
          isInvalid: errors.name !== void 0,
          id: "room_block_name",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { htmlFor: "name", children: "Name" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Input$1,
              {
                ...register2("name", { required: "Room block name is required" }),
                placeholder: "name"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormErrorMessage, { children: errors.name && errors.name.message })
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { pt: 3, pb: 300, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { isRequired: true, isInvalid: errors.startDate !== void 0, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { htmlFor: "room_block_start_date", children: "Start date" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Controller,
            {
              name: "startDate",
              control,
              render: ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                DatePicker,
                {
                  selectedDate: field.value,
                  onChange: field.onChange,
                  selectsStart: true,
                  startDate,
                  endDate,
                  maxDate: subDays$1(endDate),
                  dateFormat: formSettings.dateFormat,
                  onFocus: () => {
                    var _a3;
                    return (_a3 = bottomRef.current) == null ? void 0 : _a3.scrollIntoView({ behavior: "smooth" });
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormErrorMessage, { children: errors.startDate && errors.startDate.message })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { isRequired: true, isInvalid: errors.startDate !== void 0, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { htmlFor: "room_block_start_date", children: "End date" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Controller,
            {
              name: "endDate",
              control,
              render: ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                DatePicker,
                {
                  selectedDate: field.value,
                  onChange: field.onChange,
                  selectsEnd: true,
                  startDate,
                  endDate,
                  minDate: addDays$1(startDate, 1),
                  dateFormat: formSettings.dateFormat,
                  onFocus: () => {
                    var _a3;
                    return (_a3 = bottomRef.current) == null ? void 0 : _a3.scrollIntoView();
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormErrorMessage, { children: errors.startDate && errors.startDate.message })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: bottomRef })
  ] });
};
const useAddRoomBlock = (options) => {
  const queryClient = useQueryClient();
  const { rooming } = useAdminApi();
  const mutateFn = (roomBlockInput) => rooming.createRoomBlock(initializeRoomBlock(roomBlockInput));
  return useMutation(mutateFn, {
    ...options,
    onSuccess: async (data, variables, context) => {
      var _a3;
      await queryClient.refetchQueries({ queryKey: ["roomBlocks"] });
      (_a3 = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a3.call(options, data, variables, context);
    }
  });
};
const useAddRoomBlockPrimer = (options) => {
  const queryClient = useQueryClient();
  const { rooming } = useAdminApi();
  const mutateFn = (roomBlockInput) => rooming.createRoomBlock(initializeRoomBlockPrimer(roomBlockInput));
  return useMutation(mutateFn, {
    ...options,
    onSuccess: async (data, variables, context) => {
      var _a3;
      await queryClient.refetchQueries({ queryKey: ["roomBlocks"] });
      (_a3 = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a3.call(options, data, variables, context);
    }
  });
};
const AddRoomBlock$1 = ({
  roomBlock = {},
  onAdded,
  onCancel
}) => {
  const mutation = useAddRoomBlock({ onSuccess: onAdded });
  const { formSettings } = useRegForm();
  const formRef = React__default.createRef();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Event Accommodation" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$5, { as: "h1", color: "gray.700", pb: 16, children: "Add Room Block" }),
      mutation.error && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { status: "error", children: "Error creating Room Block" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        RoomBlockForm$1,
        {
          roomBlock: {
            ...defaultRoomBlockDates(formSettings),
            ...roomBlock
          },
          onSubmit: (roomBlock2) => mutation.mutate({ ...roomBlockDefaults, ...roomBlock2 }),
          formRef
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "gray", onClick: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              disabled: mutation.isLoading,
              leftIcon: mutation.isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, { size: "xs" }) : void 0,
              onClick: () => {
                var _a3;
                return (_a3 = formRef == null ? void 0 : formRef.current) == null ? void 0 : _a3.dispatchEvent(
                  new Event("submit", { cancelable: true, bubbles: true })
                );
              },
              colorScheme: "green",
              children: "Create Room Block"
            }
          )
        ]
      }
    )
  ] });
};
const RoomingModal = ({
  renderButton,
  onSelectRoomBlock
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [page, setPage] = useState(
    "ListRoomBlocks"
    /* ListRoomBlocks */
  );
  const [roomBlockId, setRoomBlockId] = useState();
  useEffect(() => {
    if (isOpen) {
      setPage(
        "ListRoomBlocks"
        /* ListRoomBlocks */
      );
    }
  }, [isOpen]);
  const handleAddToForm = (roomBlock) => {
    onSelectRoomBlock(roomBlock);
    onClose();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    renderButton === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", onClick: onOpen, children: "Rooming" }) : renderButton({ isOpen, onOpen, onClose }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Modal,
      {
        isOpen,
        onClose,
        size: "xl",
        scrollBehavior: "inside",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalContent, { minW: 800, children: [
            page === "ListRoomBlocks" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              ListRoomBlocks$1,
              {
                onCancel: onClose,
                onEditRoomBlock: (roomBlock) => {
                  setRoomBlockId(roomBlock.id);
                  setPage(
                    "EditRoomBlock"
                    /* EditRoomBlock */
                  );
                },
                onSelectRoomBlock: handleAddToForm,
                onNewRoomBlock: () => setPage(
                  "AddRoomBlock"
                  /* AddRoomBlock */
                )
              }
            ),
            page === "EditRoomBlock" && roomBlockId !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
              EditRoomBlockContainer,
              {
                roomBlockId,
                onCancel: () => setPage(
                  "ListRoomBlocks"
                  /* ListRoomBlocks */
                ),
                onSelectRoomBlock: handleAddToForm,
                onSave: () => setPage(
                  "ListRoomBlocks"
                  /* ListRoomBlocks */
                )
              }
            ),
            page === "AddRoomBlock" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              AddRoomBlock$1,
              {
                onAdded: (roomBlock) => {
                  setRoomBlockId(roomBlock.id);
                  setPage(
                    "EditRoomBlock"
                    /* EditRoomBlock */
                  );
                },
                onCancel: onClose
              }
            )
          ] })
        ]
      }
    )
  ] });
};
const RoomBookingButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label: fieldLabels$1.room_block,
    description: "Add room blocks for attendee accommodation booking",
    Icon: fieldIcons.room_block
  }
);
const LeadScannerButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label: "Lead Scanner",
    description: "Enabling Lead Retrieval by allowing Attendees to select a Lead Scanner during registration",
    Icon: fieldIcons.lead_scanner
  }
);
const ComplexFields = ({
  addFieldHandler,
  onFieldAdded
}) => {
  const { dispatch, form, formSettings } = useRegForm();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    formSettings.documentUploadsEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddFieldLink,
      {
        onClick: () => addFieldHandler(
          () => dispatch({
            type: "add_field",
            field: fieldDefaults.documentField
          })
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(DocumentFieldButton, {})
      }
    ),
    formSettings.sessionBookingEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
      SessionBookingModal,
      {
        form,
        showPrices: formSettings.shoppingCartEnabled,
        currency: formSettings.shoppingCartCurrency,
        onSelectSession: (session) => {
          dispatch({
            type: "add_field",
            field: defaultSessionField(session)
          });
          onFieldAdded == null ? void 0 : onFieldAdded();
        },
        renderButton: (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(AddFieldLink, { onClick: props.onOpen, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SessionBookingButton, {}) })
      }
    ),
    formSettings.roomingEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
      RoomingModal,
      {
        onSelectRoomBlock: (roomBlock) => {
          dispatch({
            type: "add_field",
            field: defaultRoomBlockField(roomBlock, formSettings)
          });
          onFieldAdded == null ? void 0 : onFieldAdded();
        },
        renderButton: (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(AddFieldLink, { onClick: props.onOpen, children: /* @__PURE__ */ jsxRuntimeExports.jsx(RoomBookingButton, {}) })
      }
    ),
    formSettings.leadScannersEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddFieldLink,
      {
        onClick: () => addFieldHandler(
          () => dispatch({
            type: "add_field",
            field: fieldDefaults.leadScannerField
          })
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(LeadScannerButton, {})
      }
    )
  ] });
};
const AddPanel$1 = ({ onFieldAdded }) => {
  const { form, editorState, formSettings } = useRegForm();
  const addFieldHandler = (callback) => {
    callback();
    onFieldAdded == null ? void 0 : onFieldAdded();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { px: 4, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(SimpleFields, { addFieldHandler }),
    !isPreRegPageSelected(form, editorState) && complexFieldTypesEnabled(formSettings) && /* @__PURE__ */ jsxRuntimeExports.jsx(
      ComplexFields,
      {
        addFieldHandler,
        onFieldAdded
      }
    )
  ] });
};
const RightPanelTab = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Tab,
  {
    sx: {
      fontSize: "12px !important",
      lineHeight: "28px !important",
      margin: "0 !important"
    },
    bg: "blackAlpha.200",
    _hover: { bg: "blackAlpha.30", color: "inherit" },
    _selected: { bg: "blackAlpha.30" },
    _focus: { boxShadow: "none" },
    borderRadius: 0,
    border: 0,
    color: "gray.800",
    ...props
  }
);
const ChangeDescription$1 = ({ change }) => {
  switch (change.type) {
    case "save_form":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Saved ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: "the form" })
      ] });
    case "reset_form":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Reset ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: "the form" })
      ] });
    case "add_item":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Added ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: change.item.label || change.item.name })
      ] });
    case "update_item":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Updated ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: change.item.label || change.item.name })
      ] });
    case "delete_item":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Deleted ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: change.item.label || change.item.name })
      ] });
    case "item_changeset":
      const changeset = change;
      const addCount = changeset.includedChanges.filter((c2) => c2.type === "add_item").length;
      const updateCount = changeset.includedChanges.filter((c2) => c2.type === "update_item").length;
      const deleteCount = changeset.includedChanges.filter((c2) => c2.type === "delete_item").length;
      const actions = [];
      if (addCount > 0) actions.push(`${addCount} added`);
      if (updateCount > 0) actions.push(`${updateCount} updated`);
      if (deleteCount > 0) actions.push(`${deleteCount} deleted`);
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: "Batch operation" }),
        " (",
        actions.join(", "),
        ")"
      ] });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Made changes to ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: "the form" })
      ] });
  }
};
const ChangeHistoryList = ({ changes, enableUndo = true }) => {
  const { dispatch } = useRegForm();
  const [expandedChangesets, setExpandedChangesets] = useState(/* @__PURE__ */ new Set());
  const handleUndo = (changeId) => {
    dispatch({ type: "undo_change", changeId });
  };
  const toggleChangeset = (changesetId) => {
    const newExpanded = new Set(expandedChangesets);
    if (newExpanded.has(changesetId)) {
      newExpanded.delete(changesetId);
    } else {
      newExpanded.add(changesetId);
    }
    setExpandedChangesets(newExpanded);
  };
  const firstUndoableIndex = changes.findIndex(
    (c2) => c2.type !== "save_form" && c2.type !== "reset_form"
  );
  const firstUndoableId = firstUndoableIndex !== -1 ? changes[firstUndoableIndex].id : null;
  const renderChange = (change, depth = 0, isNested = false) => {
    const isAI = Boolean(change.ai);
    const isUndoable = enableUndo && !isNested && change.id === firstUndoableId && change.type !== "save_form" && change.type !== "reset_form";
    if (change.type === "item_changeset") {
      const changeset = change;
      const isExpanded = expandedChangesets.has(changeset.id);
      const allDeletes = changeset.includedChanges.length > 0 && changeset.includedChanges.every((c2) => c2.type === "delete_item");
      let label = null;
      if (allDeletes) {
        const firstDelete = changeset.includedChanges[0];
        label = firstDelete.itemLabel || firstDelete.item && firstDelete.item.label || "item";
      }
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { border: "1px", borderColor: "gray.200", borderRadius: "md", p: 3, mb: 2, ml: depth * 24, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { justify: "space-between", align: "start", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "start", flex: 1, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              IconButton$1,
              {
                size: "sm",
                variant: "ghost",
                icon: isExpanded ? /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronDownIcon$1, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronRightIcon$1, {}),
                onClick: () => toggleChangeset(changeset.id),
                "aria-label": isExpanded ? "Collapse changeset" : "Expand changeset"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { fontWeight: "bold", color: change.user.color, children: change.user.name }),
            isAI && /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { colorScheme: "green", ml: 2, children: "AI" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { children: allDeletes && label ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              "Deleted ",
              /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { as: "span", fontWeight: "bold", display: "inline", children: label })
            ] }) : changeset.includedChanges.length > 1 ? `made ${changeset.includedChanges.length} changes` : changeset.includedChanges.length === 1 ? changeset.includedChanges[0].itemLabel || "Change" : "Change set" }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { fontSize: "sm", color: "gray.500", children: [
              "at ",
              new Date(change.timestamp).toLocaleTimeString()
            ] })
          ] }),
          !allDeletes && /* @__PURE__ */ jsxRuntimeExports.jsx(Collapse, { in: isExpanded, animateOpacity: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { ml: 8, mt: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "start", spacing: 1, children: changeset.includedChanges.map((includedChange, idx) => /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pl: 2, borderLeft: "2px", borderColor: "gray.300", children: renderChange(includedChange, depth + 1, true) }, idx)) }) }) })
        ] }),
        isUndoable && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button$1,
          {
            size: "sm",
            colorScheme: "blue",
            variant: "outline",
            onClick: () => handleUndo(changeset.id),
            children: "Undo All"
          }
        )
      ] }) }, change.id);
    }
    if (change.type === "delete_item" && "includedChanges" in change && Array.isArray(change.includedChanges) && change.includedChanges.length > 0) {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { border: "1px", borderColor: "red.200", borderRadius: "md", p: 3, mb: 2, ml: depth * 24, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { justify: "space-between", align: "center", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { fontWeight: "bold", color: change.user.color, children: change.user.name }),
            isAI && /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { colorScheme: "green", ml: 2, children: "AI" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(ChangeDescription$1, { change }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { fontSize: "sm", color: "gray.500", children: [
              "at ",
              new Date(change.timestamp).toLocaleTimeString()
            ] })
          ] }),
          isUndoable && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              size: "sm",
              colorScheme: "blue",
              variant: "outline",
              onClick: () => handleUndo(change.id),
              children: "Undo"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { ml: 8, mt: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "start", spacing: 1, children: change.includedChanges.map((nestedChange, idx) => /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pl: 2, borderLeft: "2px", borderColor: "red.300", children: renderChange(nestedChange, depth + 1, true) }, nestedChange.id || idx)) }) })
      ] }, change.id);
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { border: "1px", borderColor: "gray.200", borderRadius: "md", p: 3, mb: 2, ml: depth * 24, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { justify: "space-between", align: "center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { fontWeight: "bold", color: change.user.color, children: change.user.name }),
        isAI && /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { colorScheme: "green", ml: 2, children: "AI" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ChangeDescription$1, { change }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { fontSize: "sm", color: "gray.500", children: [
          "at ",
          new Date(change.timestamp).toLocaleTimeString()
        ] })
      ] }),
      isUndoable && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          size: "sm",
          colorScheme: "blue",
          variant: "outline",
          onClick: () => handleUndo(change.id),
          children: "Undo"
        }
      )
    ] }) }, change.id);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "stretch", spacing: 0, children: changes.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { color: "gray.500", textAlign: "center", py: 4, children: "No changes to display" }) : changes.map((change) => renderChange(change)) });
};
const ChangeHistoryListContainer$1 = () => {
  const context = useChangeHistory();
  if (context === void 0) {
    return null;
  }
  const { changeHistory } = context;
  const hasUnsaved = changeHistory.unsavedChanges.length > 0;
  const hasPrevious = changeHistory.previousChanges.length > 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    hasUnsaved && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: "Unsaved changes" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ChangeHistoryList, { changes: changeHistory.unsavedChanges, enableUndo: true })
    ] }),
    hasPrevious && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: "Previous changes" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ChangeHistoryList, { changes: changeHistory.previousChanges, enableUndo: !hasUnsaved })
    ] }),
    !hasUnsaved && !hasPrevious && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { textAlign: "center", color: "gray" }, children: "No changes to display" })
  ] });
};
var AssistantState = /* @__PURE__ */ ((AssistantState2) => {
  AssistantState2[AssistantState2["IDLE"] = 0] = "IDLE";
  AssistantState2[AssistantState2["PROCESSING"] = 1] = "PROCESSING";
  AssistantState2[AssistantState2["STREAMING"] = 2] = "STREAMING";
  AssistantState2[AssistantState2["TOOL_CALLS"] = 3] = "TOOL_CALLS";
  AssistantState2[AssistantState2["ERROR_CORRECTION"] = 4] = "ERROR_CORRECTION";
  AssistantState2[AssistantState2["ERROR"] = 5] = "ERROR";
  return AssistantState2;
})(AssistantState || {});
const ChatContext = createContext({
  chatHistory: [],
  onSuggestionAccepted: () => {
  },
  onSuggestionRejected: () => {
  }
});
const updateMessageById = (messages, messageId, updater) => {
  const index2 = messages.findIndex((message2) => message2.id === messageId);
  if (index2 === -1) return messages;
  const nextMessages = [...messages];
  nextMessages[index2] = updater(nextMessages[index2]);
  return nextMessages;
};
const createAssistantMessage = (messageId, content2) => ({
  id: messageId,
  author: "assistant",
  isStreamFinished: false,
  isCurrentUser: false,
  status: "pending",
  content: content2
});
const ChatProvider = ({ chat, assistantEvents, children, dispatch }) => {
  const [chatId] = useState(() => v4());
  const [chatHistory, setChatHistory] = useState((chat == null ? void 0 : chat.messages) || []);
  const [assistantState, setAssistantState] = useState(
    0
    /* IDLE */
  );
  const appendStreamChunk = (messageId, chunk) => {
    setChatHistory((prev2) => {
      const index2 = prev2.findIndex((message2) => message2.id === messageId);
      if (index2 === -1) {
        return [...prev2, createAssistantMessage(messageId, chunk)];
      }
      return updateMessageById(prev2, messageId, (message2) => ({
        ...message2,
        content: message2.content + chunk
      }));
    });
  };
  const markStreamFinished = (messageId) => {
    setChatHistory((prev2) => updateMessageById(prev2, messageId, (message2) => ({
      ...message2,
      isStreamFinished: true
    })));
  };
  const onAsk = (message2, hidden = false) => {
    if (assistantState != 0) return;
    setChatHistory((prev2) => [...prev2, {
      id: v4(),
      author: "me",
      content: message2,
      isCurrentUser: true,
      isStreamFinished: true,
      hidden,
      avatarUrl: chat == null ? void 0 : chat.avatarUrl
    }]);
    chat == null ? void 0 : chat.onAsk(message2, chatId);
    setAssistantState(
      1
      /* PROCESSING */
    );
  };
  const onError = (messageId, error2) => {
    setChatHistory((prev2) => {
      const updated = updateMessageById(prev2, messageId, (message2) => ({
        ...message2,
        status: "error"
      }));
      updated.push({
        id: v4(),
        author: "me",
        content: error2,
        isCurrentUser: true,
        isStreamFinished: true,
        hidden: true,
        avatarUrl: chat == null ? void 0 : chat.avatarUrl
      });
      return updated;
    });
    chat == null ? void 0 : chat.onAsk(error2, chatId);
    setAssistantState(
      4
      /* ERROR_CORRECTION */
    );
  };
  const onSuggestionAccepted = (messageId) => {
    var _a3;
    setChatHistory((prev2) => updateMessageById(prev2, messageId, (message22) => ({
      ...message22,
      status: "accepted"
    })));
    const message2 = "*System Message*: Suggestion accepted by user";
    setChatHistory((prev2) => [...prev2, {
      id: v4(),
      author: "me",
      content: message2,
      isCurrentUser: true,
      isStreamFinished: true,
      hidden: true
    }]);
    (_a3 = chat == null ? void 0 : chat.onTell) == null ? void 0 : _a3.call(chat, message2, chatId);
  };
  const onSuggestionRejected = (messageId) => {
    setChatHistory((prev2) => updateMessageById(prev2, messageId, (message22) => ({
      ...message22,
      status: "rejected"
    })));
    const message2 = "*System Message*: Suggestion rejected by user";
    setChatHistory((prev2) => [...prev2, {
      id: v4(),
      author: "me",
      content: message2,
      isCurrentUser: true,
      isStreamFinished: true,
      hidden: true
    }]);
    chat == null ? void 0 : chat.onAsk(message2, chatId);
    setAssistantState(
      1
      /* PROCESSING */
    );
  };
  useEffect(() => {
    if (!assistantEvents) return;
    const unsubscribe = assistantEvents.onAny(({ event, payload: eventPayload }) => {
      console.log(event, eventPayload);
      switch (event) {
        case "assistant.trigger_action": {
          const name2 = eventPayload.name;
          if (!name2) break;
          const payload = (eventPayload == null ? void 0 : eventPayload.payload) ?? {};
          dispatch == null ? void 0 : dispatch({ type: name2, ...payload });
          break;
        }
        case "assistant.stream_end": {
          setAssistantState(
            0
            /* IDLE */
          );
          const messageId = eventPayload == null ? void 0 : eventPayload.message_id;
          if (!messageId) break;
          markStreamFinished(messageId);
          break;
        }
        case "assistant.tool_calls":
          setAssistantState(
            3
            /* TOOL_CALLS */
          );
          break;
        case "assistant.full_response":
          break;
        case "assistant.error": {
          setAssistantState(
            5
            /* ERROR */
          );
          break;
        }
        case "assistant.stream_chunk": {
          const messageId = eventPayload == null ? void 0 : eventPayload.message_id;
          if (!messageId) break;
          setAssistantState(
            2
            /* STREAMING */
          );
          appendStreamChunk(messageId, (eventPayload == null ? void 0 : eventPayload.content) ?? "");
          break;
        }
      }
    });
    return () => {
      unsubscribe();
    };
  }, [assistantEvents, dispatch]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ChatContext.Provider, { value: {
    chat,
    chatHistory,
    onAsk,
    onError,
    assistantState,
    assistantEvents,
    onSuggestionAccepted,
    onSuggestionRejected,
    avatarUrl: chat == null ? void 0 : chat.avatarUrl
  }, children });
};
const useChat = () => {
  const context = useContext(ChatContext);
  return {
    chat: context.chat,
    chatHistory: context.chatHistory,
    onAsk: context.onAsk,
    onError: context.onError,
    assistantState: context.assistantState,
    assistantEvents: context.assistantEvents,
    onSuggestionAccepted: context.onSuggestionAccepted,
    onSuggestionRejected: context.onSuggestionRejected,
    avatarUrl: context.avatarUrl
  };
};
var defaultOptions$2 = {
  readAheadChars: 15,
  targetBufferChars: 15,
  adjustPercentage: 0.2,
  frameLookBackMs: 1e4,
  windowLookBackMs: 2e3
};
var calcPercentage = ({
  isBehind,
  adjustPercentage,
  isStreamFinished
}) => {
  if (isStreamFinished) {
    return 1;
  }
  if (isBehind) {
    return 1 - adjustPercentage;
  }
  return 1 + adjustPercentage;
};
var getVisibleTextEveryNFrames = (lookbackFrameCount, windowLookBackCount, visibleTextLengthsAllOriginal) => {
  const visibleTextLengthsAll = [0, ...visibleTextLengthsAllOriginal];
  const lookbackFrames = Math.min(
    lookbackFrameCount,
    visibleTextLengthsAll.length
  );
  const windowFrames = Math.min(
    windowLookBackCount,
    visibleTextLengthsAll.length
  );
  const recentVisibleTextLengths = visibleTextLengthsAll.slice(
    -1 * lookbackFrames
  );
  const textAddedCounts = [];
  if (windowFrames > 0) {
    for (let start4 = 0; start4 < recentVisibleTextLengths.length - windowFrames + 1; start4++) {
      const end2 = start4 + windowFrames - 1;
      const textAddedCount = recentVisibleTextLengths[end2] - recentVisibleTextLengths[start4];
      textAddedCounts.push(textAddedCount);
    }
  }
  const avgTextAddedCount = textAddedCounts.reduce((a2, b2) => a2 + b2, 0) / textAddedCounts.length;
  const result = avgTextAddedCount > 0 ? windowFrames / avgTextAddedCount : windowFrames;
  return result;
};
var throttleBasic = (userOptions = {}) => {
  const {
    frameLookBackMs,
    targetBufferChars,
    readAheadChars,
    adjustPercentage,
    windowLookBackMs
  } = {
    ...defaultOptions$2,
    ...userOptions
  };
  return ({
    visibleText,
    isStreamFinished,
    visibleTextAll,
    visibleTextLengthsAll,
    frameCount,
    visibleTextIncrements,
    visibleTextLengthTarget,
    startStreamTime
  }) => {
    const timeSinceStartMs = performance.now() - startStreamTime;
    const timeSinceStartSec = timeSinceStartMs / 1e3;
    const fps = frameCount / timeSinceStartSec;
    const bufferSize = visibleTextAll.length - visibleTextLengthTarget;
    const lookbackFrameCount = Math.ceil(frameLookBackMs / (1e3 / fps));
    const windowLookBackCount = Math.ceil(windowLookBackMs / (1e3 / fps));
    const visibleTextEveryNFrames = getVisibleTextEveryNFrames(
      lookbackFrameCount,
      windowLookBackCount,
      visibleTextLengthsAll
    );
    let framesSinceLastIncrement = [...visibleTextIncrements].reverse().findIndex((inc) => inc > 0);
    framesSinceLastIncrement = framesSinceLastIncrement === -1 ? frameCount : framesSinceLastIncrement;
    let visibleTextIncrement = 0;
    const targetBufferSize = readAheadChars + targetBufferChars;
    if (!isStreamFinished && (bufferSize < readAheadChars || visibleText.length === 0 && bufferSize < targetBufferSize) || visibleTextLengthTarget >= visibleTextAll.length) {
      visibleTextIncrement = 0;
    } else {
      const targetBufferSize2 = readAheadChars + targetBufferChars;
      const isBehind = bufferSize > targetBufferSize2;
      const targetFrameEveryN = visibleTextEveryNFrames * calcPercentage({ adjustPercentage, isBehind, isStreamFinished });
      if (targetFrameEveryN > 1) {
        visibleTextIncrement = framesSinceLastIncrement >= targetFrameEveryN ? 1 : 0;
      } else {
        visibleTextIncrement = Math.round(1 / targetFrameEveryN);
      }
    }
    return {
      visibleTextIncrement
    };
  };
};
var completeMatchesForBlock = ({
  llmOutput,
  block: block2,
  priority
}) => {
  const matches2 = [];
  let index2 = 0;
  while (index2 < llmOutput.length) {
    const nextMatch = block2.findCompleteMatch(llmOutput.slice(index2));
    if (nextMatch) {
      matches2.push({
        block: block2,
        match: {
          outputRaw: nextMatch.outputRaw,
          startIndex: index2 + nextMatch.startIndex,
          endIndex: index2 + nextMatch.endIndex
        },
        llmOutput,
        isComplete: true,
        priority
      });
      index2 += nextMatch.endIndex;
    } else {
      return matches2;
    }
  }
  return matches2;
};
var highestPriorityNonOverlappingMatches = (matches2) => {
  return matches2.filter((match5) => {
    const higherPriorityMatches = matches2.filter(
      (m2) => m2.priority < match5.priority
    );
    return !higherPriorityMatches.some(
      (m2) => isOverlapping(m2.match, match5.match)
    );
  });
};
var byMatchStartIndex = (match12, match22) => match12.match.startIndex - match22.match.startIndex;
var isOverlapping = (match12, match22) => {
  return match12.startIndex >= match22.startIndex && match12.startIndex < match22.endIndex || // match1 starts inside match2
  match12.endIndex > match22.startIndex && match12.endIndex <= match22.endIndex || // match1 ends inside match2
  match22.startIndex >= match12.startIndex && match22.startIndex < match12.endIndex || // match2 starts inside match1
  match22.endIndex > match12.startIndex && match22.endIndex <= match12.endIndex;
};
var findPartialMatch = ({
  llmOutput,
  blocks,
  currentIndex
}) => {
  for (const [priority, block2] of Array.from(blocks.entries())) {
    const outputRaw = llmOutput.slice(currentIndex);
    const partialMatch = block2.findPartialMatch(outputRaw);
    if (partialMatch) {
      return {
        block: block2,
        match: {
          outputRaw: partialMatch.outputRaw,
          startIndex: partialMatch.startIndex + currentIndex,
          endIndex: partialMatch.endIndex + currentIndex
        },
        llmOutput,
        isComplete: true,
        priority
      };
    }
  }
  return void 0;
};
var fallbacksInGaps = ({
  blockMatches,
  llmOutput,
  fallbackPriority,
  fallbackBlock
}) => {
  const fallbacks = blockMatches.map((match5, index2) => {
    const previousMatchEndIndex = index2 === 0 ? 0 : blockMatches[index2 - 1].match.endIndex;
    if (previousMatchEndIndex < match5.match.startIndex) {
      const outputRaw = llmOutput.slice(
        previousMatchEndIndex,
        match5.match.startIndex
      );
      return {
        block: fallbackBlock,
        match: {
          startIndex: previousMatchEndIndex,
          endIndex: match5.match.startIndex,
          outputRaw
        },
        priority: fallbackPriority,
        llmOutput,
        isComplete: true
      };
    }
    return void 0;
  }).filter((match5) => match5 !== void 0);
  const lastMatchEndIndex = blockMatches.length > 0 ? blockMatches[blockMatches.length - 1].match.endIndex : 0;
  if (lastMatchEndIndex < llmOutput.length) {
    const outputRaw = llmOutput.slice(lastMatchEndIndex, llmOutput.length);
    fallbacks.push({
      block: fallbackBlock,
      match: {
        startIndex: lastMatchEndIndex,
        endIndex: llmOutput.length,
        outputRaw
      },
      priority: fallbackPriority,
      llmOutput,
      isComplete: false
    });
  }
  return fallbacks;
};
var matchesWithLookback = ({
  llmOutputRaw,
  matches: matches2,
  visibleTextLengthTarget,
  isStreamFinished
}) => {
  return matches2.reduce((acc, match5, index2) => {
    const visibleTextSoFar = acc.map((m2) => m2.visibleText.length).reduce((a2, b2) => a2 + b2, 0);
    const localVisibleTextLengthTarget = Math.max(
      visibleTextLengthTarget - visibleTextSoFar,
      0
    );
    const isLastMatch = index2 === matches2.length - 1;
    const isComplete = !isLastMatch || isStreamFinished;
    const { output, visibleText } = match5.block.lookBack({
      isComplete,
      visibleTextLengthTarget: localVisibleTextLengthTarget,
      isStreamFinished,
      output: match5.match.outputRaw
    });
    if (visibleText.length > localVisibleTextLengthTarget && process.env.NODE_ENV === "development") {
      console.warn(
        `Visible text length exceeded target for: ${visibleText} has length ${visibleText.length} target: ${localVisibleTextLengthTarget}. Raw output: ${llmOutputRaw}`
      );
    }
    const matchWithLookback = {
      ...match5.match,
      isComplete,
      block: match5.block,
      priority: match5.priority,
      llmOutput: match5.llmOutput,
      output,
      visibleText,
      isVisible: visibleText.length > 0
    };
    return [...acc, matchWithLookback];
  }, []);
};
var matchBlocks = ({
  llmOutput,
  blocks,
  fallbackBlock,
  isStreamFinished,
  visibleTextLengthTarget = Number.MAX_SAFE_INTEGER
}) => {
  const allCompleteMatches = blocks.flatMap(
    (block2, priority) => completeMatchesForBlock({
      llmOutput,
      block: block2,
      priority
    })
  );
  const matches2 = highestPriorityNonOverlappingMatches(allCompleteMatches);
  matches2.sort(byMatchStartIndex);
  const lastMatchEndIndex = matches2.length > 0 ? matches2[matches2.length - 1].match.endIndex : 0;
  const partialMatch = !isStreamFinished ? findPartialMatch({
    llmOutput,
    currentIndex: lastMatchEndIndex,
    blocks
  }) : void 0;
  if (partialMatch) {
    matches2.push(partialMatch);
  }
  const fallBacks = fallbacksInGaps({
    blockMatches: matches2,
    llmOutput,
    fallbackPriority: blocks.length,
    fallbackBlock
  });
  for (const fallBack of fallBacks) {
    matches2.push(fallBack);
  }
  matches2.sort(byMatchStartIndex);
  return matchesWithLookback({
    llmOutputRaw: llmOutput,
    matches: matches2,
    isStreamFinished,
    visibleTextLengthTarget
  });
};
var matchesToVisibleText = (matches2) => {
  return matches2.map((match5) => match5.visibleText).join("");
};
var matchesToOutput = (matches2) => {
  return matches2.map((match5) => match5.output).join("");
};
var initialState$1 = {
  blockMatches: [],
  isFinished: false,
  visibleText: ""
};
var useLLMOutput = ({
  llmOutput,
  isStreamFinished,
  blocks = [],
  fallbackBlock,
  throttle: throttle2 = throttleBasic(),
  onFinish = () => null
}) => {
  const startTime = useRef(performance.now());
  const lastRenderTime = useRef(performance.now());
  const renderLoopRef = useRef();
  const frameRef = useRef();
  const frameCountRef = useRef(0);
  const finishTimeRef = useRef();
  const previousFrameTimeRef = useRef();
  const visibleTextAllLengthsRef = useRef([]);
  const outputLengthsRef = useRef([]);
  const visibleTextIncrementsRef = useRef([]);
  const visibleTextLengthTargetRef = useRef(0);
  const memoMatchBlocks = useMemo$1(() => {
    return matchBlocks({
      llmOutput,
      blocks,
      fallbackBlock,
      isStreamFinished
    });
  }, [llmOutput, isStreamFinished]);
  const [{ blockMatches, ...state }, setState] = useState({
    ...initialState$1,
    finishCount: 0,
    blockMatches: memoMatchBlocks
  });
  const reset2 = useCallback$1(() => {
    setState((state2) => ({ ...state2, ...initialState$1 }));
    startTime.current = performance.now();
    finishTimeRef.current = void 0;
    previousFrameTimeRef.current = void 0;
    visibleTextAllLengthsRef.current = [];
    outputLengthsRef.current = [];
    visibleTextIncrementsRef.current = [];
    visibleTextLengthTargetRef.current = 0;
    frameCountRef.current = 0;
    if (frameRef.current) {
      cancelAnimationFrame(frameRef.current);
      frameRef.current = void 0;
    }
  }, [setState]);
  const restart = useCallback$1(() => {
    reset2();
    setTimeout(() => {
      if (renderLoopRef.current) {
        frameRef.current = requestAnimationFrame(renderLoopRef.current);
      }
    }, 10);
  }, [reset2]);
  const renderLoop = (frameTime) => {
    if (!renderLoopRef.current) {
      return;
    }
    const allMatches = matchBlocks({
      llmOutput,
      blocks,
      fallbackBlock,
      isStreamFinished
    });
    const visibleText = matchesToVisibleText(blockMatches);
    const outputRendered = matchesToOutput(blockMatches);
    const visibleTextAll = matchesToVisibleText(allMatches);
    const outputAll = matchesToOutput(allMatches);
    if (!isStreamFinished) {
      visibleTextAllLengthsRef.current.push(visibleTextAll.length);
      outputLengthsRef.current.push(outputAll.length);
    }
    const isFinished = visibleText === visibleTextAll && isStreamFinished;
    if (isFinished) {
      frameRef.current = void 0;
      setState((state2) => ({
        ...state2,
        blockMatches,
        isFinished,
        finishCount: state2.finishCount + 1,
        visibleText
      }));
      onFinish();
      return;
    }
    const visibleTextLengthsAll = isStreamFinished ? [...visibleTextAllLengthsRef.current, visibleTextAll.length] : visibleTextAllLengthsRef.current;
    const outputLengths = isStreamFinished ? [...outputLengthsRef.current, outputAll.length] : outputLengthsRef.current;
    const { visibleTextIncrement } = throttle2({
      outputRaw: llmOutput,
      outputRendered,
      outputAll,
      visibleText,
      visibleTextAll,
      startStreamTime: startTime.current,
      isStreamFinished,
      frameCount: frameCountRef.current,
      frameTime,
      frameTimePrevious: previousFrameTimeRef.current,
      finishStreamTime: finishTimeRef.current,
      visibleTextLengthsAll,
      outputLengths,
      visibleTextIncrements: visibleTextIncrementsRef.current,
      visibleTextLengthTarget: visibleTextLengthTargetRef.current
    });
    if (visibleTextIncrement < 0) {
      throw new Error("throttle returned negative visibleTextIncrement");
    }
    visibleTextIncrementsRef.current.push(visibleTextIncrement);
    visibleTextLengthTargetRef.current = visibleTextLengthTargetRef.current + visibleTextIncrement;
    if (visibleTextLengthTargetRef.current > visibleText.length) {
      const matches2 = matchBlocks({
        llmOutput,
        blocks,
        fallbackBlock,
        isStreamFinished,
        visibleTextLengthTarget: visibleTextLengthTargetRef.current
      });
      const updatedVisibleText = matchesToVisibleText(matches2);
      lastRenderTime.current = performance.now();
      setState((state2) => ({
        ...state2,
        blockMatches: matches2,
        isFinished,
        visibleText: updatedVisibleText
      }));
    }
    frameRef.current = requestAnimationFrame(renderLoopRef.current);
    previousFrameTimeRef.current = frameTime;
    frameCountRef.current = frameCountRef.current + 1;
  };
  useEffect(() => {
    renderLoopRef.current = renderLoop;
  });
  useEffect(() => {
    renderLoopRef.current = renderLoop;
    if (!frameRef.current && llmOutput && llmOutput.length > 0) {
      frameRef.current = requestAnimationFrame(renderLoopRef.current);
    } else if (
      // reset the render loop if user clears the llmOutput
      visibleTextIncrementsRef.current.length > 0 && llmOutput.length === 0
    ) {
      reset2();
    }
  }, [llmOutput]);
  useEffect(() => {
  }, []);
  useEffect(() => {
    if (!finishTimeRef.current && isStreamFinished) {
      finishTimeRef.current = performance.now();
    }
  }, [isStreamFinished]);
  return { blockMatches, restart, ...state };
};
const emptyOptions$2 = {};
function toString$2(value, options) {
  const settings = emptyOptions$2;
  const includeImageAlt = typeof settings.includeImageAlt === "boolean" ? settings.includeImageAlt : true;
  const includeHtml = typeof settings.includeHtml === "boolean" ? settings.includeHtml : true;
  return one$1(value, includeImageAlt, includeHtml);
}
function one$1(value, includeImageAlt, includeHtml) {
  if (node(value)) {
    if ("value" in value) {
      return value.type === "html" && !includeHtml ? "" : value.value;
    }
    if (includeImageAlt && "alt" in value && value.alt) {
      return value.alt;
    }
    if ("children" in value) {
      return all$1(value.children, includeImageAlt, includeHtml);
    }
  }
  if (Array.isArray(value)) {
    return all$1(value, includeImageAlt, includeHtml);
  }
  return "";
}
function all$1(values2, includeImageAlt, includeHtml) {
  const result = [];
  let index2 = -1;
  while (++index2 < values2.length) {
    result[index2] = one$1(values2[index2], includeImageAlt, includeHtml);
  }
  return result.join("");
}
function node(value) {
  return Boolean(value && typeof value === "object");
}
const element$1 = document.createElement("i");
function decodeNamedCharacterReference(value) {
  const characterReference2 = "&" + value + ";";
  element$1.innerHTML = characterReference2;
  const character2 = element$1.textContent;
  if (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    character2.charCodeAt(character2.length - 1) === 59 && value !== "semi"
  ) {
    return false;
  }
  return character2 === characterReference2 ? false : character2;
}
function splice(list2, start4, remove, items) {
  const end2 = list2.length;
  let chunkStart = 0;
  let parameters;
  if (start4 < 0) {
    start4 = -start4 > end2 ? 0 : end2 + start4;
  } else {
    start4 = start4 > end2 ? end2 : start4;
  }
  remove = remove > 0 ? remove : 0;
  if (items.length < 1e4) {
    parameters = Array.from(items);
    parameters.unshift(start4, remove);
    list2.splice(...parameters);
  } else {
    if (remove) list2.splice(start4, remove);
    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 1e4);
      parameters.unshift(start4, 0);
      list2.splice(...parameters);
      chunkStart += 1e4;
      start4 += 1e4;
    }
  }
}
function push$1(list2, items) {
  if (list2.length > 0) {
    splice(list2, list2.length, 0, items);
    return list2;
  }
  return items;
}
const hasOwnProperty = {}.hasOwnProperty;
function combineExtensions(extensions) {
  const all2 = {};
  let index2 = -1;
  while (++index2 < extensions.length) {
    syntaxExtension(all2, extensions[index2]);
  }
  return all2;
}
function syntaxExtension(all2, extension2) {
  let hook;
  for (hook in extension2) {
    const maybe = hasOwnProperty.call(all2, hook) ? all2[hook] : void 0;
    const left2 = maybe || (all2[hook] = {});
    const right2 = extension2[hook];
    let code;
    if (right2) {
      for (code in right2) {
        if (!hasOwnProperty.call(left2, code)) left2[code] = [];
        const value = right2[code];
        constructs(
          // @ts-expect-error Looks like a list.
          left2[code],
          Array.isArray(value) ? value : value ? [value] : []
        );
      }
    }
  }
}
function constructs(existing, list2) {
  let index2 = -1;
  const before = [];
  while (++index2 < list2.length) {
    (list2[index2].add === "after" ? existing : before).push(list2[index2]);
  }
  splice(existing, 0, 0, before);
}
function decodeNumericCharacterReference(value, base2) {
  const code = Number.parseInt(value, base2);
  if (
    // C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || /* eslint-disable no-bitwise */
    (code & 65535) === 65535 || (code & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    code > 1114111
  ) {
    return "�";
  }
  return String.fromCodePoint(code);
}
function normalizeIdentifier(value) {
  return value.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const asciiAlpha = regexCheck(/[A-Za-z]/);
const asciiAlphanumeric = regexCheck(/[\dA-Za-z]/);
const asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function asciiControl(code) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127)
  );
}
const asciiDigit = regexCheck(/\d/);
const asciiHexDigit = regexCheck(/[\dA-Fa-f]/);
const asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);
function markdownLineEnding(code) {
  return code !== null && code < -2;
}
function markdownLineEndingOrSpace(code) {
  return code !== null && (code < 0 || code === 32);
}
function markdownSpace(code) {
  return code === -2 || code === -1 || code === 32;
}
const unicodePunctuation = regexCheck(new RegExp("\\p{P}|\\p{S}", "u"));
const unicodeWhitespace = regexCheck(/\s/);
function regexCheck(regex2) {
  return check;
  function check(code) {
    return code !== null && code > -1 && regex2.test(String.fromCharCode(code));
  }
}
function normalizeUri(value) {
  const result = [];
  let index2 = -1;
  let start4 = 0;
  let skip = 0;
  while (++index2 < value.length) {
    const code = value.charCodeAt(index2);
    let replace2 = "";
    if (code === 37 && asciiAlphanumeric(value.charCodeAt(index2 + 1)) && asciiAlphanumeric(value.charCodeAt(index2 + 2))) {
      skip = 2;
    } else if (code < 128) {
      if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) {
        replace2 = String.fromCharCode(code);
      }
    } else if (code > 55295 && code < 57344) {
      const next2 = value.charCodeAt(index2 + 1);
      if (code < 56320 && next2 > 56319 && next2 < 57344) {
        replace2 = String.fromCharCode(code, next2);
        skip = 1;
      } else {
        replace2 = "�";
      }
    } else {
      replace2 = String.fromCharCode(code);
    }
    if (replace2) {
      result.push(value.slice(start4, index2), encodeURIComponent(replace2));
      start4 = index2 + skip + 1;
      replace2 = "";
    }
    if (skip) {
      index2 += skip;
      skip = 0;
    }
  }
  return result.join("") + value.slice(start4);
}
function factorySpace(effects, ok2, type, max2) {
  const limit = max2 ? max2 - 1 : Number.POSITIVE_INFINITY;
  let size2 = 0;
  return start4;
  function start4(code) {
    if (markdownSpace(code)) {
      effects.enter(type);
      return prefix2(code);
    }
    return ok2(code);
  }
  function prefix2(code) {
    if (markdownSpace(code) && size2++ < limit) {
      effects.consume(code);
      return prefix2;
    }
    effects.exit(type);
    return ok2(code);
  }
}
const content$1 = {
  tokenize: initializeContent
};
function initializeContent(effects) {
  const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
  let previous2;
  return contentStart;
  function afterContentStartConstruct(code) {
    if (code === null) {
      effects.consume(code);
      return;
    }
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return factorySpace(effects, contentStart, "linePrefix");
  }
  function paragraphInitial(code) {
    effects.enter("paragraph");
    return lineStart(code);
  }
  function lineStart(code) {
    const token2 = effects.enter("chunkText", {
      contentType: "text",
      previous: previous2
    });
    if (previous2) {
      previous2.next = token2;
    }
    previous2 = token2;
    return data(code);
  }
  function data(code) {
    if (code === null) {
      effects.exit("chunkText");
      effects.exit("paragraph");
      effects.consume(code);
      return;
    }
    if (markdownLineEnding(code)) {
      effects.consume(code);
      effects.exit("chunkText");
      return lineStart;
    }
    effects.consume(code);
    return data;
  }
}
const document$2 = {
  tokenize: initializeDocument
};
const containerConstruct = {
  tokenize: tokenizeContainer
};
function initializeDocument(effects) {
  const self2 = this;
  const stack = [];
  let continued = 0;
  let childFlow;
  let childToken;
  let lineStartOffset;
  return start4;
  function start4(code) {
    if (continued < stack.length) {
      const item = stack[continued];
      self2.containerState = item[1];
      return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
    }
    return checkNewContainers(code);
  }
  function documentContinue(code) {
    continued++;
    if (self2.containerState._closeFlow) {
      self2.containerState._closeFlow = void 0;
      if (childFlow) {
        closeFlow();
      }
      const indexBeforeExits = self2.events.length;
      let indexBeforeFlow = indexBeforeExits;
      let point2;
      while (indexBeforeFlow--) {
        if (self2.events[indexBeforeFlow][0] === "exit" && self2.events[indexBeforeFlow][1].type === "chunkFlow") {
          point2 = self2.events[indexBeforeFlow][1].end;
          break;
        }
      }
      exitContainers(continued);
      let index2 = indexBeforeExits;
      while (index2 < self2.events.length) {
        self2.events[index2][1].end = {
          ...point2
        };
        index2++;
      }
      splice(self2.events, indexBeforeFlow + 1, 0, self2.events.slice(indexBeforeExits));
      self2.events.length = index2;
      return checkNewContainers(code);
    }
    return start4(code);
  }
  function checkNewContainers(code) {
    if (continued === stack.length) {
      if (!childFlow) {
        return documentContinued(code);
      }
      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
        return flowStart(code);
      }
      self2.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
    }
    self2.containerState = {};
    return effects.check(containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
  }
  function thereIsANewContainer(code) {
    if (childFlow) closeFlow();
    exitContainers(continued);
    return documentContinued(code);
  }
  function thereIsNoNewContainer(code) {
    self2.parser.lazy[self2.now().line] = continued !== stack.length;
    lineStartOffset = self2.now().offset;
    return flowStart(code);
  }
  function documentContinued(code) {
    self2.containerState = {};
    return effects.attempt(containerConstruct, containerContinue, flowStart)(code);
  }
  function containerContinue(code) {
    continued++;
    stack.push([self2.currentConstruct, self2.containerState]);
    return documentContinued(code);
  }
  function flowStart(code) {
    if (code === null) {
      if (childFlow) closeFlow();
      exitContainers(0);
      effects.consume(code);
      return;
    }
    childFlow = childFlow || self2.parser.flow(self2.now());
    effects.enter("chunkFlow", {
      _tokenizer: childFlow,
      contentType: "flow",
      previous: childToken
    });
    return flowContinue(code);
  }
  function flowContinue(code) {
    if (code === null) {
      writeToChild(effects.exit("chunkFlow"), true);
      exitContainers(0);
      effects.consume(code);
      return;
    }
    if (markdownLineEnding(code)) {
      effects.consume(code);
      writeToChild(effects.exit("chunkFlow"));
      continued = 0;
      self2.interrupt = void 0;
      return start4;
    }
    effects.consume(code);
    return flowContinue;
  }
  function writeToChild(token2, endOfFile) {
    const stream = self2.sliceStream(token2);
    if (endOfFile) stream.push(null);
    token2.previous = childToken;
    if (childToken) childToken.next = token2;
    childToken = token2;
    childFlow.defineSkip(token2.start);
    childFlow.write(stream);
    if (self2.parser.lazy[token2.start.line]) {
      let index2 = childFlow.events.length;
      while (index2--) {
        if (
          // The token starts before the line ending…
          childFlow.events[index2][1].start.offset < lineStartOffset && // …and either is not ended yet…
          (!childFlow.events[index2][1].end || // …or ends after it.
          childFlow.events[index2][1].end.offset > lineStartOffset)
        ) {
          return;
        }
      }
      const indexBeforeExits = self2.events.length;
      let indexBeforeFlow = indexBeforeExits;
      let seen;
      let point2;
      while (indexBeforeFlow--) {
        if (self2.events[indexBeforeFlow][0] === "exit" && self2.events[indexBeforeFlow][1].type === "chunkFlow") {
          if (seen) {
            point2 = self2.events[indexBeforeFlow][1].end;
            break;
          }
          seen = true;
        }
      }
      exitContainers(continued);
      index2 = indexBeforeExits;
      while (index2 < self2.events.length) {
        self2.events[index2][1].end = {
          ...point2
        };
        index2++;
      }
      splice(self2.events, indexBeforeFlow + 1, 0, self2.events.slice(indexBeforeExits));
      self2.events.length = index2;
    }
  }
  function exitContainers(size2) {
    let index2 = stack.length;
    while (index2-- > size2) {
      const entry = stack[index2];
      self2.containerState = entry[1];
      entry[0].exit.call(self2, effects);
    }
    stack.length = size2;
  }
  function closeFlow() {
    childFlow.write([null]);
    childToken = void 0;
    childFlow = void 0;
    self2.containerState._closeFlow = void 0;
  }
}
function tokenizeContainer(effects, ok2, nok) {
  return factorySpace(effects, effects.attempt(this.parser.constructs.document, ok2, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function classifyCharacter(code) {
  if (code === null || markdownLineEndingOrSpace(code) || unicodeWhitespace(code)) {
    return 1;
  }
  if (unicodePunctuation(code)) {
    return 2;
  }
}
function resolveAll(constructs2, events2, context) {
  const called = [];
  let index2 = -1;
  while (++index2 < constructs2.length) {
    const resolve = constructs2[index2].resolveAll;
    if (resolve && !called.includes(resolve)) {
      events2 = resolve(events2, context);
      called.push(resolve);
    }
  }
  return events2;
}
const attention = {
  name: "attention",
  resolveAll: resolveAllAttention,
  tokenize: tokenizeAttention
};
function resolveAllAttention(events2, context) {
  let index2 = -1;
  let open;
  let group;
  let text2;
  let openingSequence;
  let closingSequence;
  let use;
  let nextEvents;
  let offset3;
  while (++index2 < events2.length) {
    if (events2[index2][0] === "enter" && events2[index2][1].type === "attentionSequence" && events2[index2][1]._close) {
      open = index2;
      while (open--) {
        if (events2[open][0] === "exit" && events2[open][1].type === "attentionSequence" && events2[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events2[open][1]).charCodeAt(0) === context.sliceSerialize(events2[index2][1]).charCodeAt(0)) {
          if ((events2[open][1]._close || events2[index2][1]._open) && (events2[index2][1].end.offset - events2[index2][1].start.offset) % 3 && !((events2[open][1].end.offset - events2[open][1].start.offset + events2[index2][1].end.offset - events2[index2][1].start.offset) % 3)) {
            continue;
          }
          use = events2[open][1].end.offset - events2[open][1].start.offset > 1 && events2[index2][1].end.offset - events2[index2][1].start.offset > 1 ? 2 : 1;
          const start4 = {
            ...events2[open][1].end
          };
          const end2 = {
            ...events2[index2][1].start
          };
          movePoint(start4, -use);
          movePoint(end2, use);
          openingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start: start4,
            end: {
              ...events2[open][1].end
            }
          };
          closingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...events2[index2][1].start
            },
            end: end2
          };
          text2 = {
            type: use > 1 ? "strongText" : "emphasisText",
            start: {
              ...events2[open][1].end
            },
            end: {
              ...events2[index2][1].start
            }
          };
          group = {
            type: use > 1 ? "strong" : "emphasis",
            start: {
              ...openingSequence.start
            },
            end: {
              ...closingSequence.end
            }
          };
          events2[open][1].end = {
            ...openingSequence.start
          };
          events2[index2][1].start = {
            ...closingSequence.end
          };
          nextEvents = [];
          if (events2[open][1].end.offset - events2[open][1].start.offset) {
            nextEvents = push$1(nextEvents, [["enter", events2[open][1], context], ["exit", events2[open][1], context]]);
          }
          nextEvents = push$1(nextEvents, [["enter", group, context], ["enter", openingSequence, context], ["exit", openingSequence, context], ["enter", text2, context]]);
          nextEvents = push$1(nextEvents, resolveAll(context.parser.constructs.insideSpan.null, events2.slice(open + 1, index2), context));
          nextEvents = push$1(nextEvents, [["exit", text2, context], ["enter", closingSequence, context], ["exit", closingSequence, context], ["exit", group, context]]);
          if (events2[index2][1].end.offset - events2[index2][1].start.offset) {
            offset3 = 2;
            nextEvents = push$1(nextEvents, [["enter", events2[index2][1], context], ["exit", events2[index2][1], context]]);
          } else {
            offset3 = 0;
          }
          splice(events2, open - 1, index2 - open + 3, nextEvents);
          index2 = open + nextEvents.length - offset3 - 2;
          break;
        }
      }
    }
  }
  index2 = -1;
  while (++index2 < events2.length) {
    if (events2[index2][1].type === "attentionSequence") {
      events2[index2][1].type = "data";
    }
  }
  return events2;
}
function tokenizeAttention(effects, ok2) {
  const attentionMarkers2 = this.parser.constructs.attentionMarkers.null;
  const previous2 = this.previous;
  const before = classifyCharacter(previous2);
  let marker;
  return start4;
  function start4(code) {
    marker = code;
    effects.enter("attentionSequence");
    return inside(code);
  }
  function inside(code) {
    if (code === marker) {
      effects.consume(code);
      return inside;
    }
    const token2 = effects.exit("attentionSequence");
    const after = classifyCharacter(code);
    const open = !after || after === 2 && before || attentionMarkers2.includes(code);
    const close2 = !before || before === 2 && after || attentionMarkers2.includes(previous2);
    token2._open = Boolean(marker === 42 ? open : open && (before || !close2));
    token2._close = Boolean(marker === 42 ? close2 : close2 && (after || !open));
    return ok2(code);
  }
}
function movePoint(point2, offset3) {
  point2.column += offset3;
  point2.offset += offset3;
  point2._bufferIndex += offset3;
}
const autolink$1 = {
  name: "autolink",
  tokenize: tokenizeAutolink
};
function tokenizeAutolink(effects, ok2, nok) {
  let size2 = 0;
  return start4;
  function start4(code) {
    effects.enter("autolink");
    effects.enter("autolinkMarker");
    effects.consume(code);
    effects.exit("autolinkMarker");
    effects.enter("autolinkProtocol");
    return open;
  }
  function open(code) {
    if (asciiAlpha(code)) {
      effects.consume(code);
      return schemeOrEmailAtext;
    }
    if (code === 64) {
      return nok(code);
    }
    return emailAtext(code);
  }
  function schemeOrEmailAtext(code) {
    if (code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)) {
      size2 = 1;
      return schemeInsideOrEmailAtext(code);
    }
    return emailAtext(code);
  }
  function schemeInsideOrEmailAtext(code) {
    if (code === 58) {
      effects.consume(code);
      size2 = 0;
      return urlInside;
    }
    if ((code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)) && size2++ < 32) {
      effects.consume(code);
      return schemeInsideOrEmailAtext;
    }
    size2 = 0;
    return emailAtext(code);
  }
  function urlInside(code) {
    if (code === 62) {
      effects.exit("autolinkProtocol");
      effects.enter("autolinkMarker");
      effects.consume(code);
      effects.exit("autolinkMarker");
      effects.exit("autolink");
      return ok2;
    }
    if (code === null || code === 32 || code === 60 || asciiControl(code)) {
      return nok(code);
    }
    effects.consume(code);
    return urlInside;
  }
  function emailAtext(code) {
    if (code === 64) {
      effects.consume(code);
      return emailAtSignOrDot;
    }
    if (asciiAtext(code)) {
      effects.consume(code);
      return emailAtext;
    }
    return nok(code);
  }
  function emailAtSignOrDot(code) {
    return asciiAlphanumeric(code) ? emailLabel(code) : nok(code);
  }
  function emailLabel(code) {
    if (code === 46) {
      effects.consume(code);
      size2 = 0;
      return emailAtSignOrDot;
    }
    if (code === 62) {
      effects.exit("autolinkProtocol").type = "autolinkEmail";
      effects.enter("autolinkMarker");
      effects.consume(code);
      effects.exit("autolinkMarker");
      effects.exit("autolink");
      return ok2;
    }
    return emailValue(code);
  }
  function emailValue(code) {
    if ((code === 45 || asciiAlphanumeric(code)) && size2++ < 63) {
      const next2 = code === 45 ? emailValue : emailLabel;
      effects.consume(code);
      return next2;
    }
    return nok(code);
  }
}
const blankLine = {
  partial: true,
  tokenize: tokenizeBlankLine
};
function tokenizeBlankLine(effects, ok2, nok) {
  return start4;
  function start4(code) {
    return markdownSpace(code) ? factorySpace(effects, after, "linePrefix")(code) : after(code);
  }
  function after(code) {
    return code === null || markdownLineEnding(code) ? ok2(code) : nok(code);
  }
}
const blockQuote = {
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit: exit$1,
  name: "blockQuote",
  tokenize: tokenizeBlockQuoteStart
};
function tokenizeBlockQuoteStart(effects, ok2, nok) {
  const self2 = this;
  return start4;
  function start4(code) {
    if (code === 62) {
      const state = self2.containerState;
      if (!state.open) {
        effects.enter("blockQuote", {
          _container: true
        });
        state.open = true;
      }
      effects.enter("blockQuotePrefix");
      effects.enter("blockQuoteMarker");
      effects.consume(code);
      effects.exit("blockQuoteMarker");
      return after;
    }
    return nok(code);
  }
  function after(code) {
    if (markdownSpace(code)) {
      effects.enter("blockQuotePrefixWhitespace");
      effects.consume(code);
      effects.exit("blockQuotePrefixWhitespace");
      effects.exit("blockQuotePrefix");
      return ok2;
    }
    effects.exit("blockQuotePrefix");
    return ok2(code);
  }
}
function tokenizeBlockQuoteContinuation(effects, ok2, nok) {
  const self2 = this;
  return contStart;
  function contStart(code) {
    if (markdownSpace(code)) {
      return factorySpace(effects, contBefore, "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code);
    }
    return contBefore(code);
  }
  function contBefore(code) {
    return effects.attempt(blockQuote, ok2, nok)(code);
  }
}
function exit$1(effects) {
  effects.exit("blockQuote");
}
const characterEscape = {
  name: "characterEscape",
  tokenize: tokenizeCharacterEscape
};
function tokenizeCharacterEscape(effects, ok2, nok) {
  return start4;
  function start4(code) {
    effects.enter("characterEscape");
    effects.enter("escapeMarker");
    effects.consume(code);
    effects.exit("escapeMarker");
    return inside;
  }
  function inside(code) {
    if (asciiPunctuation(code)) {
      effects.enter("characterEscapeValue");
      effects.consume(code);
      effects.exit("characterEscapeValue");
      effects.exit("characterEscape");
      return ok2;
    }
    return nok(code);
  }
}
const characterReference = {
  name: "characterReference",
  tokenize: tokenizeCharacterReference
};
function tokenizeCharacterReference(effects, ok2, nok) {
  const self2 = this;
  let size2 = 0;
  let max2;
  let test;
  return start4;
  function start4(code) {
    effects.enter("characterReference");
    effects.enter("characterReferenceMarker");
    effects.consume(code);
    effects.exit("characterReferenceMarker");
    return open;
  }
  function open(code) {
    if (code === 35) {
      effects.enter("characterReferenceMarkerNumeric");
      effects.consume(code);
      effects.exit("characterReferenceMarkerNumeric");
      return numeric2;
    }
    effects.enter("characterReferenceValue");
    max2 = 31;
    test = asciiAlphanumeric;
    return value(code);
  }
  function numeric2(code) {
    if (code === 88 || code === 120) {
      effects.enter("characterReferenceMarkerHexadecimal");
      effects.consume(code);
      effects.exit("characterReferenceMarkerHexadecimal");
      effects.enter("characterReferenceValue");
      max2 = 6;
      test = asciiHexDigit;
      return value;
    }
    effects.enter("characterReferenceValue");
    max2 = 7;
    test = asciiDigit;
    return value(code);
  }
  function value(code) {
    if (code === 59 && size2) {
      const token2 = effects.exit("characterReferenceValue");
      if (test === asciiAlphanumeric && !decodeNamedCharacterReference(self2.sliceSerialize(token2))) {
        return nok(code);
      }
      effects.enter("characterReferenceMarker");
      effects.consume(code);
      effects.exit("characterReferenceMarker");
      effects.exit("characterReference");
      return ok2;
    }
    if (test(code) && size2++ < max2) {
      effects.consume(code);
      return value;
    }
    return nok(code);
  }
}
const nonLazyContinuation = {
  partial: true,
  tokenize: tokenizeNonLazyContinuation
};
const codeFenced = {
  concrete: true,
  name: "codeFenced",
  tokenize: tokenizeCodeFenced
};
function tokenizeCodeFenced(effects, ok2, nok) {
  const self2 = this;
  const closeStart = {
    partial: true,
    tokenize: tokenizeCloseStart
  };
  let initialPrefix = 0;
  let sizeOpen = 0;
  let marker;
  return start4;
  function start4(code) {
    return beforeSequenceOpen(code);
  }
  function beforeSequenceOpen(code) {
    const tail = self2.events[self2.events.length - 1];
    initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    marker = code;
    effects.enter("codeFenced");
    effects.enter("codeFencedFence");
    effects.enter("codeFencedFenceSequence");
    return sequenceOpen(code);
  }
  function sequenceOpen(code) {
    if (code === marker) {
      sizeOpen++;
      effects.consume(code);
      return sequenceOpen;
    }
    if (sizeOpen < 3) {
      return nok(code);
    }
    effects.exit("codeFencedFenceSequence");
    return markdownSpace(code) ? factorySpace(effects, infoBefore, "whitespace")(code) : infoBefore(code);
  }
  function infoBefore(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("codeFencedFence");
      return self2.interrupt ? ok2(code) : effects.check(nonLazyContinuation, atNonLazyBreak, after)(code);
    }
    effects.enter("codeFencedFenceInfo");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return info(code);
  }
  function info(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return infoBefore(code);
    }
    if (markdownSpace(code)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return factorySpace(effects, metaBefore, "whitespace")(code);
    }
    if (code === 96 && code === marker) {
      return nok(code);
    }
    effects.consume(code);
    return info;
  }
  function metaBefore(code) {
    if (code === null || markdownLineEnding(code)) {
      return infoBefore(code);
    }
    effects.enter("codeFencedFenceMeta");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return meta(code);
  }
  function meta(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceMeta");
      return infoBefore(code);
    }
    if (code === 96 && code === marker) {
      return nok(code);
    }
    effects.consume(code);
    return meta;
  }
  function atNonLazyBreak(code) {
    return effects.attempt(closeStart, after, contentBefore)(code);
  }
  function contentBefore(code) {
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return contentStart;
  }
  function contentStart(code) {
    return initialPrefix > 0 && markdownSpace(code) ? factorySpace(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
  }
  function beforeContentChunk(code) {
    if (code === null || markdownLineEnding(code)) {
      return effects.check(nonLazyContinuation, atNonLazyBreak, after)(code);
    }
    effects.enter("codeFlowValue");
    return contentChunk(code);
  }
  function contentChunk(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("codeFlowValue");
      return beforeContentChunk(code);
    }
    effects.consume(code);
    return contentChunk;
  }
  function after(code) {
    effects.exit("codeFenced");
    return ok2(code);
  }
  function tokenizeCloseStart(effects2, ok3, nok2) {
    let size2 = 0;
    return startBefore;
    function startBefore(code) {
      effects2.enter("lineEnding");
      effects2.consume(code);
      effects2.exit("lineEnding");
      return start5;
    }
    function start5(code) {
      effects2.enter("codeFencedFence");
      return markdownSpace(code) ? factorySpace(effects2, beforeSequenceClose, "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code) : beforeSequenceClose(code);
    }
    function beforeSequenceClose(code) {
      if (code === marker) {
        effects2.enter("codeFencedFenceSequence");
        return sequenceClose(code);
      }
      return nok2(code);
    }
    function sequenceClose(code) {
      if (code === marker) {
        size2++;
        effects2.consume(code);
        return sequenceClose;
      }
      if (size2 >= sizeOpen) {
        effects2.exit("codeFencedFenceSequence");
        return markdownSpace(code) ? factorySpace(effects2, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
      }
      return nok2(code);
    }
    function sequenceCloseAfter(code) {
      if (code === null || markdownLineEnding(code)) {
        effects2.exit("codeFencedFence");
        return ok3(code);
      }
      return nok2(code);
    }
  }
}
function tokenizeNonLazyContinuation(effects, ok2, nok) {
  const self2 = this;
  return start4;
  function start4(code) {
    if (code === null) {
      return nok(code);
    }
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return lineStart;
  }
  function lineStart(code) {
    return self2.parser.lazy[self2.now().line] ? nok(code) : ok2(code);
  }
}
const codeIndented = {
  name: "codeIndented",
  tokenize: tokenizeCodeIndented
};
const furtherStart = {
  partial: true,
  tokenize: tokenizeFurtherStart
};
function tokenizeCodeIndented(effects, ok2, nok) {
  const self2 = this;
  return start4;
  function start4(code) {
    effects.enter("codeIndented");
    return factorySpace(effects, afterPrefix, "linePrefix", 4 + 1)(code);
  }
  function afterPrefix(code) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
  }
  function atBreak(code) {
    if (code === null) {
      return after(code);
    }
    if (markdownLineEnding(code)) {
      return effects.attempt(furtherStart, atBreak, after)(code);
    }
    effects.enter("codeFlowValue");
    return inside(code);
  }
  function inside(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("codeFlowValue");
      return atBreak(code);
    }
    effects.consume(code);
    return inside;
  }
  function after(code) {
    effects.exit("codeIndented");
    return ok2(code);
  }
}
function tokenizeFurtherStart(effects, ok2, nok) {
  const self2 = this;
  return furtherStart2;
  function furtherStart2(code) {
    if (self2.parser.lazy[self2.now().line]) {
      return nok(code);
    }
    if (markdownLineEnding(code)) {
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      return furtherStart2;
    }
    return factorySpace(effects, afterPrefix, "linePrefix", 4 + 1)(code);
  }
  function afterPrefix(code) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok2(code) : markdownLineEnding(code) ? furtherStart2(code) : nok(code);
  }
}
const codeText = {
  name: "codeText",
  previous: previous$1,
  resolve: resolveCodeText,
  tokenize: tokenizeCodeText
};
function resolveCodeText(events2) {
  let tailExitIndex = events2.length - 4;
  let headEnterIndex = 3;
  let index2;
  let enter2;
  if ((events2[headEnterIndex][1].type === "lineEnding" || events2[headEnterIndex][1].type === "space") && (events2[tailExitIndex][1].type === "lineEnding" || events2[tailExitIndex][1].type === "space")) {
    index2 = headEnterIndex;
    while (++index2 < tailExitIndex) {
      if (events2[index2][1].type === "codeTextData") {
        events2[headEnterIndex][1].type = "codeTextPadding";
        events2[tailExitIndex][1].type = "codeTextPadding";
        headEnterIndex += 2;
        tailExitIndex -= 2;
        break;
      }
    }
  }
  index2 = headEnterIndex - 1;
  tailExitIndex++;
  while (++index2 <= tailExitIndex) {
    if (enter2 === void 0) {
      if (index2 !== tailExitIndex && events2[index2][1].type !== "lineEnding") {
        enter2 = index2;
      }
    } else if (index2 === tailExitIndex || events2[index2][1].type === "lineEnding") {
      events2[enter2][1].type = "codeTextData";
      if (index2 !== enter2 + 2) {
        events2[enter2][1].end = events2[index2 - 1][1].end;
        events2.splice(enter2 + 2, index2 - enter2 - 2);
        tailExitIndex -= index2 - enter2 - 2;
        index2 = enter2 + 2;
      }
      enter2 = void 0;
    }
  }
  return events2;
}
function previous$1(code) {
  return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeCodeText(effects, ok2, nok) {
  let sizeOpen = 0;
  let size2;
  let token2;
  return start4;
  function start4(code) {
    effects.enter("codeText");
    effects.enter("codeTextSequence");
    return sequenceOpen(code);
  }
  function sequenceOpen(code) {
    if (code === 96) {
      effects.consume(code);
      sizeOpen++;
      return sequenceOpen;
    }
    effects.exit("codeTextSequence");
    return between3(code);
  }
  function between3(code) {
    if (code === null) {
      return nok(code);
    }
    if (code === 32) {
      effects.enter("space");
      effects.consume(code);
      effects.exit("space");
      return between3;
    }
    if (code === 96) {
      token2 = effects.enter("codeTextSequence");
      size2 = 0;
      return sequenceClose(code);
    }
    if (markdownLineEnding(code)) {
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      return between3;
    }
    effects.enter("codeTextData");
    return data(code);
  }
  function data(code) {
    if (code === null || code === 32 || code === 96 || markdownLineEnding(code)) {
      effects.exit("codeTextData");
      return between3(code);
    }
    effects.consume(code);
    return data;
  }
  function sequenceClose(code) {
    if (code === 96) {
      effects.consume(code);
      size2++;
      return sequenceClose;
    }
    if (size2 === sizeOpen) {
      effects.exit("codeTextSequence");
      effects.exit("codeText");
      return ok2(code);
    }
    token2.type = "codeTextData";
    return data(code);
  }
}
class SpliceBuffer {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(initial) {
    this.left = initial ? [...initial] : [];
    this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(index2) {
    if (index2 < 0 || index2 >= this.left.length + this.right.length) {
      throw new RangeError("Cannot access index `" + index2 + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    }
    if (index2 < this.left.length) return this.left[index2];
    return this.right[this.right.length - index2 + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    this.setCursor(0);
    return this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(start4, end2) {
    const stop = end2 === null || end2 === void 0 ? Number.POSITIVE_INFINITY : end2;
    if (stop < this.left.length) {
      return this.left.slice(start4, stop);
    }
    if (start4 > this.left.length) {
      return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start4 + this.left.length).reverse();
    }
    return this.left.slice(start4).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(start4, deleteCount, items) {
    const count2 = deleteCount || 0;
    this.setCursor(Math.trunc(start4));
    const removed = this.right.splice(this.right.length - count2, Number.POSITIVE_INFINITY);
    if (items) chunkedPush(this.left, items);
    return removed.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    this.setCursor(Number.POSITIVE_INFINITY);
    return this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(item) {
    this.setCursor(Number.POSITIVE_INFINITY);
    this.left.push(item);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(items) {
    this.setCursor(Number.POSITIVE_INFINITY);
    chunkedPush(this.left, items);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(item) {
    this.setCursor(0);
    this.right.push(item);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(items) {
    this.setCursor(0);
    chunkedPush(this.right, items.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n2) {
    if (n2 === this.left.length || n2 > this.left.length && this.right.length === 0 || n2 < 0 && this.left.length === 0) return;
    if (n2 < this.left.length) {
      const removed = this.left.splice(n2, Number.POSITIVE_INFINITY);
      chunkedPush(this.right, removed.reverse());
    } else {
      const removed = this.right.splice(this.left.length + this.right.length - n2, Number.POSITIVE_INFINITY);
      chunkedPush(this.left, removed.reverse());
    }
  }
}
function chunkedPush(list2, right2) {
  let chunkStart = 0;
  if (right2.length < 1e4) {
    list2.push(...right2);
  } else {
    while (chunkStart < right2.length) {
      list2.push(...right2.slice(chunkStart, chunkStart + 1e4));
      chunkStart += 1e4;
    }
  }
}
function subtokenize(eventsArray) {
  const jumps = {};
  let index2 = -1;
  let event;
  let lineIndex;
  let otherIndex;
  let otherEvent;
  let parameters;
  let subevents;
  let more;
  const events2 = new SpliceBuffer(eventsArray);
  while (++index2 < events2.length) {
    while (index2 in jumps) {
      index2 = jumps[index2];
    }
    event = events2.get(index2);
    if (index2 && event[1].type === "chunkFlow" && events2.get(index2 - 1)[1].type === "listItemPrefix") {
      subevents = event[1]._tokenizer.events;
      otherIndex = 0;
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") {
        otherIndex += 2;
      }
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") {
        while (++otherIndex < subevents.length) {
          if (subevents[otherIndex][1].type === "content") {
            break;
          }
          if (subevents[otherIndex][1].type === "chunkText") {
            subevents[otherIndex][1]._isInFirstContentOfListItem = true;
            otherIndex++;
          }
        }
      }
    }
    if (event[0] === "enter") {
      if (event[1].contentType) {
        Object.assign(jumps, subcontent(events2, index2));
        index2 = jumps[index2];
        more = true;
      }
    } else if (event[1]._container) {
      otherIndex = index2;
      lineIndex = void 0;
      while (otherIndex--) {
        otherEvent = events2.get(otherIndex);
        if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
          if (otherEvent[0] === "enter") {
            if (lineIndex) {
              events2.get(lineIndex)[1].type = "lineEndingBlank";
            }
            otherEvent[1].type = "lineEnding";
            lineIndex = otherIndex;
          }
        } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ;
        else {
          break;
        }
      }
      if (lineIndex) {
        event[1].end = {
          ...events2.get(lineIndex)[1].start
        };
        parameters = events2.slice(lineIndex, index2);
        parameters.unshift(event);
        events2.splice(lineIndex, index2 - lineIndex + 1, parameters);
      }
    }
  }
  splice(eventsArray, 0, Number.POSITIVE_INFINITY, events2.slice(0));
  return !more;
}
function subcontent(events2, eventIndex) {
  const token2 = events2.get(eventIndex)[1];
  const context = events2.get(eventIndex)[2];
  let startPosition = eventIndex - 1;
  const startPositions = [];
  let tokenizer = token2._tokenizer;
  if (!tokenizer) {
    tokenizer = context.parser[token2.contentType](token2.start);
    if (token2._contentTypeTextTrailing) {
      tokenizer._contentTypeTextTrailing = true;
    }
  }
  const childEvents = tokenizer.events;
  const jumps = [];
  const gaps = {};
  let stream;
  let previous2;
  let index2 = -1;
  let current = token2;
  let adjust = 0;
  let start4 = 0;
  const breaks = [start4];
  while (current) {
    while (events2.get(++startPosition)[1] !== current) {
    }
    startPositions.push(startPosition);
    if (!current._tokenizer) {
      stream = context.sliceStream(current);
      if (!current.next) {
        stream.push(null);
      }
      if (previous2) {
        tokenizer.defineSkip(current.start);
      }
      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = true;
      }
      tokenizer.write(stream);
      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = void 0;
      }
    }
    previous2 = current;
    current = current.next;
  }
  current = token2;
  while (++index2 < childEvents.length) {
    if (
      // Find a void token that includes a break.
      childEvents[index2][0] === "exit" && childEvents[index2 - 1][0] === "enter" && childEvents[index2][1].type === childEvents[index2 - 1][1].type && childEvents[index2][1].start.line !== childEvents[index2][1].end.line
    ) {
      start4 = index2 + 1;
      breaks.push(start4);
      current._tokenizer = void 0;
      current.previous = void 0;
      current = current.next;
    }
  }
  tokenizer.events = [];
  if (current) {
    current._tokenizer = void 0;
    current.previous = void 0;
  } else {
    breaks.pop();
  }
  index2 = breaks.length;
  while (index2--) {
    const slice3 = childEvents.slice(breaks[index2], breaks[index2 + 1]);
    const start5 = startPositions.pop();
    jumps.push([start5, start5 + slice3.length - 1]);
    events2.splice(start5, 2, slice3);
  }
  jumps.reverse();
  index2 = -1;
  while (++index2 < jumps.length) {
    gaps[adjust + jumps[index2][0]] = adjust + jumps[index2][1];
    adjust += jumps[index2][1] - jumps[index2][0] - 1;
  }
  return gaps;
}
const content = {
  resolve: resolveContent,
  tokenize: tokenizeContent
};
const continuationConstruct = {
  partial: true,
  tokenize: tokenizeContinuation
};
function resolveContent(events2) {
  subtokenize(events2);
  return events2;
}
function tokenizeContent(effects, ok2) {
  let previous2;
  return chunkStart;
  function chunkStart(code) {
    effects.enter("content");
    previous2 = effects.enter("chunkContent", {
      contentType: "content"
    });
    return chunkInside(code);
  }
  function chunkInside(code) {
    if (code === null) {
      return contentEnd(code);
    }
    if (markdownLineEnding(code)) {
      return effects.check(continuationConstruct, contentContinue, contentEnd)(code);
    }
    effects.consume(code);
    return chunkInside;
  }
  function contentEnd(code) {
    effects.exit("chunkContent");
    effects.exit("content");
    return ok2(code);
  }
  function contentContinue(code) {
    effects.consume(code);
    effects.exit("chunkContent");
    previous2.next = effects.enter("chunkContent", {
      contentType: "content",
      previous: previous2
    });
    previous2 = previous2.next;
    return chunkInside;
  }
}
function tokenizeContinuation(effects, ok2, nok) {
  const self2 = this;
  return startLookahead;
  function startLookahead(code) {
    effects.exit("chunkContent");
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return factorySpace(effects, prefixed, "linePrefix");
  }
  function prefixed(code) {
    if (code === null || markdownLineEnding(code)) {
      return nok(code);
    }
    const tail = self2.events[self2.events.length - 1];
    if (!self2.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) {
      return ok2(code);
    }
    return effects.interrupt(self2.parser.constructs.flow, nok, ok2)(code);
  }
}
function factoryDestination(effects, ok2, nok, type, literalType2, literalMarkerType, rawType, stringType2, max2) {
  const limit = max2 || Number.POSITIVE_INFINITY;
  let balance = 0;
  return start4;
  function start4(code) {
    if (code === 60) {
      effects.enter(type);
      effects.enter(literalType2);
      effects.enter(literalMarkerType);
      effects.consume(code);
      effects.exit(literalMarkerType);
      return enclosedBefore;
    }
    if (code === null || code === 32 || code === 41 || asciiControl(code)) {
      return nok(code);
    }
    effects.enter(type);
    effects.enter(rawType);
    effects.enter(stringType2);
    effects.enter("chunkString", {
      contentType: "string"
    });
    return raw(code);
  }
  function enclosedBefore(code) {
    if (code === 62) {
      effects.enter(literalMarkerType);
      effects.consume(code);
      effects.exit(literalMarkerType);
      effects.exit(literalType2);
      effects.exit(type);
      return ok2;
    }
    effects.enter(stringType2);
    effects.enter("chunkString", {
      contentType: "string"
    });
    return enclosed(code);
  }
  function enclosed(code) {
    if (code === 62) {
      effects.exit("chunkString");
      effects.exit(stringType2);
      return enclosedBefore(code);
    }
    if (code === null || code === 60 || markdownLineEnding(code)) {
      return nok(code);
    }
    effects.consume(code);
    return code === 92 ? enclosedEscape : enclosed;
  }
  function enclosedEscape(code) {
    if (code === 60 || code === 62 || code === 92) {
      effects.consume(code);
      return enclosed;
    }
    return enclosed(code);
  }
  function raw(code) {
    if (!balance && (code === null || code === 41 || markdownLineEndingOrSpace(code))) {
      effects.exit("chunkString");
      effects.exit(stringType2);
      effects.exit(rawType);
      effects.exit(type);
      return ok2(code);
    }
    if (balance < limit && code === 40) {
      effects.consume(code);
      balance++;
      return raw;
    }
    if (code === 41) {
      effects.consume(code);
      balance--;
      return raw;
    }
    if (code === null || code === 32 || code === 40 || asciiControl(code)) {
      return nok(code);
    }
    effects.consume(code);
    return code === 92 ? rawEscape : raw;
  }
  function rawEscape(code) {
    if (code === 40 || code === 41 || code === 92) {
      effects.consume(code);
      return raw;
    }
    return raw(code);
  }
}
function factoryLabel(effects, ok2, nok, type, markerType, stringType2) {
  const self2 = this;
  let size2 = 0;
  let seen;
  return start4;
  function start4(code) {
    effects.enter(type);
    effects.enter(markerType);
    effects.consume(code);
    effects.exit(markerType);
    effects.enter(stringType2);
    return atBreak;
  }
  function atBreak(code) {
    if (size2 > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    code === 94 && !size2 && "_hiddenFootnoteSupport" in self2.parser.constructs) {
      return nok(code);
    }
    if (code === 93) {
      effects.exit(stringType2);
      effects.enter(markerType);
      effects.consume(code);
      effects.exit(markerType);
      effects.exit(type);
      return ok2;
    }
    if (markdownLineEnding(code)) {
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      return atBreak;
    }
    effects.enter("chunkString", {
      contentType: "string"
    });
    return labelInside(code);
  }
  function labelInside(code) {
    if (code === null || code === 91 || code === 93 || markdownLineEnding(code) || size2++ > 999) {
      effects.exit("chunkString");
      return atBreak(code);
    }
    effects.consume(code);
    if (!seen) seen = !markdownSpace(code);
    return code === 92 ? labelEscape : labelInside;
  }
  function labelEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code);
      size2++;
      return labelInside;
    }
    return labelInside(code);
  }
}
function factoryTitle(effects, ok2, nok, type, markerType, stringType2) {
  let marker;
  return start4;
  function start4(code) {
    if (code === 34 || code === 39 || code === 40) {
      effects.enter(type);
      effects.enter(markerType);
      effects.consume(code);
      effects.exit(markerType);
      marker = code === 40 ? 41 : code;
      return begin;
    }
    return nok(code);
  }
  function begin(code) {
    if (code === marker) {
      effects.enter(markerType);
      effects.consume(code);
      effects.exit(markerType);
      effects.exit(type);
      return ok2;
    }
    effects.enter(stringType2);
    return atBreak(code);
  }
  function atBreak(code) {
    if (code === marker) {
      effects.exit(stringType2);
      return begin(marker);
    }
    if (code === null) {
      return nok(code);
    }
    if (markdownLineEnding(code)) {
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      return factorySpace(effects, atBreak, "linePrefix");
    }
    effects.enter("chunkString", {
      contentType: "string"
    });
    return inside(code);
  }
  function inside(code) {
    if (code === marker || code === null || markdownLineEnding(code)) {
      effects.exit("chunkString");
      return atBreak(code);
    }
    effects.consume(code);
    return code === 92 ? escape3 : inside;
  }
  function escape3(code) {
    if (code === marker || code === 92) {
      effects.consume(code);
      return inside;
    }
    return inside(code);
  }
}
function factoryWhitespace(effects, ok2) {
  let seen;
  return start4;
  function start4(code) {
    if (markdownLineEnding(code)) {
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      seen = true;
      return start4;
    }
    if (markdownSpace(code)) {
      return factorySpace(effects, start4, seen ? "linePrefix" : "lineSuffix")(code);
    }
    return ok2(code);
  }
}
const definition$1 = {
  name: "definition",
  tokenize: tokenizeDefinition
};
const titleBefore = {
  partial: true,
  tokenize: tokenizeTitleBefore
};
function tokenizeDefinition(effects, ok2, nok) {
  const self2 = this;
  let identifier2;
  return start4;
  function start4(code) {
    effects.enter("definition");
    return before(code);
  }
  function before(code) {
    return factoryLabel.call(
      self2,
      effects,
      labelAfter,
      // Note: we don’t need to reset the way `markdown-rs` does.
      nok,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(code);
  }
  function labelAfter(code) {
    identifier2 = normalizeIdentifier(self2.sliceSerialize(self2.events[self2.events.length - 1][1]).slice(1, -1));
    if (code === 58) {
      effects.enter("definitionMarker");
      effects.consume(code);
      effects.exit("definitionMarker");
      return markerAfter;
    }
    return nok(code);
  }
  function markerAfter(code) {
    return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, destinationBefore)(code) : destinationBefore(code);
  }
  function destinationBefore(code) {
    return factoryDestination(
      effects,
      destinationAfter,
      // Note: we don’t need to reset the way `markdown-rs` does.
      nok,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(code);
  }
  function destinationAfter(code) {
    return effects.attempt(titleBefore, after, after)(code);
  }
  function after(code) {
    return markdownSpace(code) ? factorySpace(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
  }
  function afterWhitespace(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("definition");
      self2.parser.defined.push(identifier2);
      return ok2(code);
    }
    return nok(code);
  }
}
function tokenizeTitleBefore(effects, ok2, nok) {
  return titleBefore2;
  function titleBefore2(code) {
    return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, beforeMarker)(code) : nok(code);
  }
  function beforeMarker(code) {
    return factoryTitle(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
  }
  function titleAfter(code) {
    return markdownSpace(code) ? factorySpace(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
  }
  function titleAfterOptionalWhitespace(code) {
    return code === null || markdownLineEnding(code) ? ok2(code) : nok(code);
  }
}
const hardBreakEscape = {
  name: "hardBreakEscape",
  tokenize: tokenizeHardBreakEscape
};
function tokenizeHardBreakEscape(effects, ok2, nok) {
  return start4;
  function start4(code) {
    effects.enter("hardBreakEscape");
    effects.consume(code);
    return after;
  }
  function after(code) {
    if (markdownLineEnding(code)) {
      effects.exit("hardBreakEscape");
      return ok2(code);
    }
    return nok(code);
  }
}
const headingAtx = {
  name: "headingAtx",
  resolve: resolveHeadingAtx,
  tokenize: tokenizeHeadingAtx
};
function resolveHeadingAtx(events2, context) {
  let contentEnd = events2.length - 2;
  let contentStart = 3;
  let content2;
  let text2;
  if (events2[contentStart][1].type === "whitespace") {
    contentStart += 2;
  }
  if (contentEnd - 2 > contentStart && events2[contentEnd][1].type === "whitespace") {
    contentEnd -= 2;
  }
  if (events2[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events2[contentEnd - 2][1].type === "whitespace")) {
    contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
  }
  if (contentEnd > contentStart) {
    content2 = {
      type: "atxHeadingText",
      start: events2[contentStart][1].start,
      end: events2[contentEnd][1].end
    };
    text2 = {
      type: "chunkText",
      start: events2[contentStart][1].start,
      end: events2[contentEnd][1].end,
      contentType: "text"
    };
    splice(events2, contentStart, contentEnd - contentStart + 1, [["enter", content2, context], ["enter", text2, context], ["exit", text2, context], ["exit", content2, context]]);
  }
  return events2;
}
function tokenizeHeadingAtx(effects, ok2, nok) {
  let size2 = 0;
  return start4;
  function start4(code) {
    effects.enter("atxHeading");
    return before(code);
  }
  function before(code) {
    effects.enter("atxHeadingSequence");
    return sequenceOpen(code);
  }
  function sequenceOpen(code) {
    if (code === 35 && size2++ < 6) {
      effects.consume(code);
      return sequenceOpen;
    }
    if (code === null || markdownLineEndingOrSpace(code)) {
      effects.exit("atxHeadingSequence");
      return atBreak(code);
    }
    return nok(code);
  }
  function atBreak(code) {
    if (code === 35) {
      effects.enter("atxHeadingSequence");
      return sequenceFurther(code);
    }
    if (code === null || markdownLineEnding(code)) {
      effects.exit("atxHeading");
      return ok2(code);
    }
    if (markdownSpace(code)) {
      return factorySpace(effects, atBreak, "whitespace")(code);
    }
    effects.enter("atxHeadingText");
    return data(code);
  }
  function sequenceFurther(code) {
    if (code === 35) {
      effects.consume(code);
      return sequenceFurther;
    }
    effects.exit("atxHeadingSequence");
    return atBreak(code);
  }
  function data(code) {
    if (code === null || code === 35 || markdownLineEndingOrSpace(code)) {
      effects.exit("atxHeadingText");
      return atBreak(code);
    }
    effects.consume(code);
    return data;
  }
}
const htmlBlockNames = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
];
const htmlRawNames = ["pre", "script", "style", "textarea"];
const htmlFlow = {
  concrete: true,
  name: "htmlFlow",
  resolveTo: resolveToHtmlFlow,
  tokenize: tokenizeHtmlFlow
};
const blankLineBefore = {
  partial: true,
  tokenize: tokenizeBlankLineBefore
};
const nonLazyContinuationStart = {
  partial: true,
  tokenize: tokenizeNonLazyContinuationStart
};
function resolveToHtmlFlow(events2) {
  let index2 = events2.length;
  while (index2--) {
    if (events2[index2][0] === "enter" && events2[index2][1].type === "htmlFlow") {
      break;
    }
  }
  if (index2 > 1 && events2[index2 - 2][1].type === "linePrefix") {
    events2[index2][1].start = events2[index2 - 2][1].start;
    events2[index2 + 1][1].start = events2[index2 - 2][1].start;
    events2.splice(index2 - 2, 2);
  }
  return events2;
}
function tokenizeHtmlFlow(effects, ok2, nok) {
  const self2 = this;
  let marker;
  let closingTag;
  let buffer;
  let index2;
  let markerB;
  return start4;
  function start4(code) {
    return before(code);
  }
  function before(code) {
    effects.enter("htmlFlow");
    effects.enter("htmlFlowData");
    effects.consume(code);
    return open;
  }
  function open(code) {
    if (code === 33) {
      effects.consume(code);
      return declarationOpen;
    }
    if (code === 47) {
      effects.consume(code);
      closingTag = true;
      return tagCloseStart;
    }
    if (code === 63) {
      effects.consume(code);
      marker = 3;
      return self2.interrupt ? ok2 : continuationDeclarationInside;
    }
    if (asciiAlpha(code)) {
      effects.consume(code);
      buffer = String.fromCharCode(code);
      return tagName;
    }
    return nok(code);
  }
  function declarationOpen(code) {
    if (code === 45) {
      effects.consume(code);
      marker = 2;
      return commentOpenInside;
    }
    if (code === 91) {
      effects.consume(code);
      marker = 5;
      index2 = 0;
      return cdataOpenInside;
    }
    if (asciiAlpha(code)) {
      effects.consume(code);
      marker = 4;
      return self2.interrupt ? ok2 : continuationDeclarationInside;
    }
    return nok(code);
  }
  function commentOpenInside(code) {
    if (code === 45) {
      effects.consume(code);
      return self2.interrupt ? ok2 : continuationDeclarationInside;
    }
    return nok(code);
  }
  function cdataOpenInside(code) {
    const value = "CDATA[";
    if (code === value.charCodeAt(index2++)) {
      effects.consume(code);
      if (index2 === value.length) {
        return self2.interrupt ? ok2 : continuation;
      }
      return cdataOpenInside;
    }
    return nok(code);
  }
  function tagCloseStart(code) {
    if (asciiAlpha(code)) {
      effects.consume(code);
      buffer = String.fromCharCode(code);
      return tagName;
    }
    return nok(code);
  }
  function tagName(code) {
    if (code === null || code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      const slash = code === 47;
      const name2 = buffer.toLowerCase();
      if (!slash && !closingTag && htmlRawNames.includes(name2)) {
        marker = 1;
        return self2.interrupt ? ok2(code) : continuation(code);
      }
      if (htmlBlockNames.includes(buffer.toLowerCase())) {
        marker = 6;
        if (slash) {
          effects.consume(code);
          return basicSelfClosing;
        }
        return self2.interrupt ? ok2(code) : continuation(code);
      }
      marker = 7;
      return self2.interrupt && !self2.parser.lazy[self2.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
    }
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code);
      buffer += String.fromCharCode(code);
      return tagName;
    }
    return nok(code);
  }
  function basicSelfClosing(code) {
    if (code === 62) {
      effects.consume(code);
      return self2.interrupt ? ok2 : continuation;
    }
    return nok(code);
  }
  function completeClosingTagAfter(code) {
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeClosingTagAfter;
    }
    return completeEnd(code);
  }
  function completeAttributeNameBefore(code) {
    if (code === 47) {
      effects.consume(code);
      return completeEnd;
    }
    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code);
      return completeAttributeName;
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeAttributeNameBefore;
    }
    return completeEnd(code);
  }
  function completeAttributeName(code) {
    if (code === 45 || code === 46 || code === 58 || code === 95 || asciiAlphanumeric(code)) {
      effects.consume(code);
      return completeAttributeName;
    }
    return completeAttributeNameAfter(code);
  }
  function completeAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code);
      return completeAttributeValueBefore;
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeAttributeNameAfter;
    }
    return completeAttributeNameBefore(code);
  }
  function completeAttributeValueBefore(code) {
    if (code === null || code === 60 || code === 61 || code === 62 || code === 96) {
      return nok(code);
    }
    if (code === 34 || code === 39) {
      effects.consume(code);
      markerB = code;
      return completeAttributeValueQuoted;
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeAttributeValueBefore;
    }
    return completeAttributeValueUnquoted(code);
  }
  function completeAttributeValueQuoted(code) {
    if (code === markerB) {
      effects.consume(code);
      markerB = null;
      return completeAttributeValueQuotedAfter;
    }
    if (code === null || markdownLineEnding(code)) {
      return nok(code);
    }
    effects.consume(code);
    return completeAttributeValueQuoted;
  }
  function completeAttributeValueUnquoted(code) {
    if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || markdownLineEndingOrSpace(code)) {
      return completeAttributeNameAfter(code);
    }
    effects.consume(code);
    return completeAttributeValueUnquoted;
  }
  function completeAttributeValueQuotedAfter(code) {
    if (code === 47 || code === 62 || markdownSpace(code)) {
      return completeAttributeNameBefore(code);
    }
    return nok(code);
  }
  function completeEnd(code) {
    if (code === 62) {
      effects.consume(code);
      return completeAfter;
    }
    return nok(code);
  }
  function completeAfter(code) {
    if (code === null || markdownLineEnding(code)) {
      return continuation(code);
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeAfter;
    }
    return nok(code);
  }
  function continuation(code) {
    if (code === 45 && marker === 2) {
      effects.consume(code);
      return continuationCommentInside;
    }
    if (code === 60 && marker === 1) {
      effects.consume(code);
      return continuationRawTagOpen;
    }
    if (code === 62 && marker === 4) {
      effects.consume(code);
      return continuationClose;
    }
    if (code === 63 && marker === 3) {
      effects.consume(code);
      return continuationDeclarationInside;
    }
    if (code === 93 && marker === 5) {
      effects.consume(code);
      return continuationCdataInside;
    }
    if (markdownLineEnding(code) && (marker === 6 || marker === 7)) {
      effects.exit("htmlFlowData");
      return effects.check(blankLineBefore, continuationAfter, continuationStart)(code);
    }
    if (code === null || markdownLineEnding(code)) {
      effects.exit("htmlFlowData");
      return continuationStart(code);
    }
    effects.consume(code);
    return continuation;
  }
  function continuationStart(code) {
    return effects.check(nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
  }
  function continuationStartNonLazy(code) {
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return continuationBefore;
  }
  function continuationBefore(code) {
    if (code === null || markdownLineEnding(code)) {
      return continuationStart(code);
    }
    effects.enter("htmlFlowData");
    return continuation(code);
  }
  function continuationCommentInside(code) {
    if (code === 45) {
      effects.consume(code);
      return continuationDeclarationInside;
    }
    return continuation(code);
  }
  function continuationRawTagOpen(code) {
    if (code === 47) {
      effects.consume(code);
      buffer = "";
      return continuationRawEndTag;
    }
    return continuation(code);
  }
  function continuationRawEndTag(code) {
    if (code === 62) {
      const name2 = buffer.toLowerCase();
      if (htmlRawNames.includes(name2)) {
        effects.consume(code);
        return continuationClose;
      }
      return continuation(code);
    }
    if (asciiAlpha(code) && buffer.length < 8) {
      effects.consume(code);
      buffer += String.fromCharCode(code);
      return continuationRawEndTag;
    }
    return continuation(code);
  }
  function continuationCdataInside(code) {
    if (code === 93) {
      effects.consume(code);
      return continuationDeclarationInside;
    }
    return continuation(code);
  }
  function continuationDeclarationInside(code) {
    if (code === 62) {
      effects.consume(code);
      return continuationClose;
    }
    if (code === 45 && marker === 2) {
      effects.consume(code);
      return continuationDeclarationInside;
    }
    return continuation(code);
  }
  function continuationClose(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("htmlFlowData");
      return continuationAfter(code);
    }
    effects.consume(code);
    return continuationClose;
  }
  function continuationAfter(code) {
    effects.exit("htmlFlow");
    return ok2(code);
  }
}
function tokenizeNonLazyContinuationStart(effects, ok2, nok) {
  const self2 = this;
  return start4;
  function start4(code) {
    if (markdownLineEnding(code)) {
      effects.enter("lineEnding");
      effects.consume(code);
      effects.exit("lineEnding");
      return after;
    }
    return nok(code);
  }
  function after(code) {
    return self2.parser.lazy[self2.now().line] ? nok(code) : ok2(code);
  }
}
function tokenizeBlankLineBefore(effects, ok2, nok) {
  return start4;
  function start4(code) {
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return effects.attempt(blankLine, ok2, nok);
  }
}
const htmlText = {
  name: "htmlText",
  tokenize: tokenizeHtmlText
};
function tokenizeHtmlText(effects, ok2, nok) {
  const self2 = this;
  let marker;
  let index2;
  let returnState;
  return start4;
  function start4(code) {
    effects.enter("htmlText");
    effects.enter("htmlTextData");
    effects.consume(code);
    return open;
  }
  function open(code) {
    if (code === 33) {
      effects.consume(code);
      return declarationOpen;
    }
    if (code === 47) {
      effects.consume(code);
      return tagCloseStart;
    }
    if (code === 63) {
      effects.consume(code);
      return instruction;
    }
    if (asciiAlpha(code)) {
      effects.consume(code);
      return tagOpen;
    }
    return nok(code);
  }
  function declarationOpen(code) {
    if (code === 45) {
      effects.consume(code);
      return commentOpenInside;
    }
    if (code === 91) {
      effects.consume(code);
      index2 = 0;
      return cdataOpenInside;
    }
    if (asciiAlpha(code)) {
      effects.consume(code);
      return declaration2;
    }
    return nok(code);
  }
  function commentOpenInside(code) {
    if (code === 45) {
      effects.consume(code);
      return commentEnd;
    }
    return nok(code);
  }
  function comment2(code) {
    if (code === null) {
      return nok(code);
    }
    if (code === 45) {
      effects.consume(code);
      return commentClose;
    }
    if (markdownLineEnding(code)) {
      returnState = comment2;
      return lineEndingBefore(code);
    }
    effects.consume(code);
    return comment2;
  }
  function commentClose(code) {
    if (code === 45) {
      effects.consume(code);
      return commentEnd;
    }
    return comment2(code);
  }
  function commentEnd(code) {
    return code === 62 ? end2(code) : code === 45 ? commentClose(code) : comment2(code);
  }
  function cdataOpenInside(code) {
    const value = "CDATA[";
    if (code === value.charCodeAt(index2++)) {
      effects.consume(code);
      return index2 === value.length ? cdata : cdataOpenInside;
    }
    return nok(code);
  }
  function cdata(code) {
    if (code === null) {
      return nok(code);
    }
    if (code === 93) {
      effects.consume(code);
      return cdataClose;
    }
    if (markdownLineEnding(code)) {
      returnState = cdata;
      return lineEndingBefore(code);
    }
    effects.consume(code);
    return cdata;
  }
  function cdataClose(code) {
    if (code === 93) {
      effects.consume(code);
      return cdataEnd;
    }
    return cdata(code);
  }
  function cdataEnd(code) {
    if (code === 62) {
      return end2(code);
    }
    if (code === 93) {
      effects.consume(code);
      return cdataEnd;
    }
    return cdata(code);
  }
  function declaration2(code) {
    if (code === null || code === 62) {
      return end2(code);
    }
    if (markdownLineEnding(code)) {
      returnState = declaration2;
      return lineEndingBefore(code);
    }
    effects.consume(code);
    return declaration2;
  }
  function instruction(code) {
    if (code === null) {
      return nok(code);
    }
    if (code === 63) {
      effects.consume(code);
      return instructionClose;
    }
    if (markdownLineEnding(code)) {
      returnState = instruction;
      return lineEndingBefore(code);
    }
    effects.consume(code);
    return instruction;
  }
  function instructionClose(code) {
    return code === 62 ? end2(code) : instruction(code);
  }
  function tagCloseStart(code) {
    if (asciiAlpha(code)) {
      effects.consume(code);
      return tagClose;
    }
    return nok(code);
  }
  function tagClose(code) {
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code);
      return tagClose;
    }
    return tagCloseBetween(code);
  }
  function tagCloseBetween(code) {
    if (markdownLineEnding(code)) {
      returnState = tagCloseBetween;
      return lineEndingBefore(code);
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return tagCloseBetween;
    }
    return end2(code);
  }
  function tagOpen(code) {
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code);
      return tagOpen;
    }
    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code);
    }
    return nok(code);
  }
  function tagOpenBetween(code) {
    if (code === 47) {
      effects.consume(code);
      return end2;
    }
    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code);
      return tagOpenAttributeName;
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenBetween;
      return lineEndingBefore(code);
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return tagOpenBetween;
    }
    return end2(code);
  }
  function tagOpenAttributeName(code) {
    if (code === 45 || code === 46 || code === 58 || code === 95 || asciiAlphanumeric(code)) {
      effects.consume(code);
      return tagOpenAttributeName;
    }
    return tagOpenAttributeNameAfter(code);
  }
  function tagOpenAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code);
      return tagOpenAttributeValueBefore;
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeNameAfter;
      return lineEndingBefore(code);
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return tagOpenAttributeNameAfter;
    }
    return tagOpenBetween(code);
  }
  function tagOpenAttributeValueBefore(code) {
    if (code === null || code === 60 || code === 61 || code === 62 || code === 96) {
      return nok(code);
    }
    if (code === 34 || code === 39) {
      effects.consume(code);
      marker = code;
      return tagOpenAttributeValueQuoted;
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueBefore;
      return lineEndingBefore(code);
    }
    if (markdownSpace(code)) {
      effects.consume(code);
      return tagOpenAttributeValueBefore;
    }
    effects.consume(code);
    return tagOpenAttributeValueUnquoted;
  }
  function tagOpenAttributeValueQuoted(code) {
    if (code === marker) {
      effects.consume(code);
      marker = void 0;
      return tagOpenAttributeValueQuotedAfter;
    }
    if (code === null) {
      return nok(code);
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueQuoted;
      return lineEndingBefore(code);
    }
    effects.consume(code);
    return tagOpenAttributeValueQuoted;
  }
  function tagOpenAttributeValueUnquoted(code) {
    if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) {
      return nok(code);
    }
    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code);
    }
    effects.consume(code);
    return tagOpenAttributeValueUnquoted;
  }
  function tagOpenAttributeValueQuotedAfter(code) {
    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code);
    }
    return nok(code);
  }
  function end2(code) {
    if (code === 62) {
      effects.consume(code);
      effects.exit("htmlTextData");
      effects.exit("htmlText");
      return ok2;
    }
    return nok(code);
  }
  function lineEndingBefore(code) {
    effects.exit("htmlTextData");
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return lineEndingAfter;
  }
  function lineEndingAfter(code) {
    return markdownSpace(code) ? factorySpace(effects, lineEndingAfterPrefix, "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code) : lineEndingAfterPrefix(code);
  }
  function lineEndingAfterPrefix(code) {
    effects.enter("htmlTextData");
    return returnState(code);
  }
}
const labelEnd = {
  name: "labelEnd",
  resolveAll: resolveAllLabelEnd,
  resolveTo: resolveToLabelEnd,
  tokenize: tokenizeLabelEnd
};
const resourceConstruct = {
  tokenize: tokenizeResource
};
const referenceFullConstruct = {
  tokenize: tokenizeReferenceFull
};
const referenceCollapsedConstruct = {
  tokenize: tokenizeReferenceCollapsed
};
function resolveAllLabelEnd(events2) {
  let index2 = -1;
  const newEvents = [];
  while (++index2 < events2.length) {
    const token2 = events2[index2][1];
    newEvents.push(events2[index2]);
    if (token2.type === "labelImage" || token2.type === "labelLink" || token2.type === "labelEnd") {
      const offset3 = token2.type === "labelImage" ? 4 : 2;
      token2.type = "data";
      index2 += offset3;
    }
  }
  if (events2.length !== newEvents.length) {
    splice(events2, 0, events2.length, newEvents);
  }
  return events2;
}
function resolveToLabelEnd(events2, context) {
  let index2 = events2.length;
  let offset3 = 0;
  let token2;
  let open;
  let close2;
  let media;
  while (index2--) {
    token2 = events2[index2][1];
    if (open) {
      if (token2.type === "link" || token2.type === "labelLink" && token2._inactive) {
        break;
      }
      if (events2[index2][0] === "enter" && token2.type === "labelLink") {
        token2._inactive = true;
      }
    } else if (close2) {
      if (events2[index2][0] === "enter" && (token2.type === "labelImage" || token2.type === "labelLink") && !token2._balanced) {
        open = index2;
        if (token2.type !== "labelLink") {
          offset3 = 2;
          break;
        }
      }
    } else if (token2.type === "labelEnd") {
      close2 = index2;
    }
  }
  const group = {
    type: events2[open][1].type === "labelLink" ? "link" : "image",
    start: {
      ...events2[open][1].start
    },
    end: {
      ...events2[events2.length - 1][1].end
    }
  };
  const label = {
    type: "label",
    start: {
      ...events2[open][1].start
    },
    end: {
      ...events2[close2][1].end
    }
  };
  const text2 = {
    type: "labelText",
    start: {
      ...events2[open + offset3 + 2][1].end
    },
    end: {
      ...events2[close2 - 2][1].start
    }
  };
  media = [["enter", group, context], ["enter", label, context]];
  media = push$1(media, events2.slice(open + 1, open + offset3 + 3));
  media = push$1(media, [["enter", text2, context]]);
  media = push$1(media, resolveAll(context.parser.constructs.insideSpan.null, events2.slice(open + offset3 + 4, close2 - 3), context));
  media = push$1(media, [["exit", text2, context], events2[close2 - 2], events2[close2 - 1], ["exit", label, context]]);
  media = push$1(media, events2.slice(close2 + 1));
  media = push$1(media, [["exit", group, context]]);
  splice(events2, open, events2.length, media);
  return events2;
}
function tokenizeLabelEnd(effects, ok2, nok) {
  const self2 = this;
  let index2 = self2.events.length;
  let labelStart;
  let defined;
  while (index2--) {
    if ((self2.events[index2][1].type === "labelImage" || self2.events[index2][1].type === "labelLink") && !self2.events[index2][1]._balanced) {
      labelStart = self2.events[index2][1];
      break;
    }
  }
  return start4;
  function start4(code) {
    if (!labelStart) {
      return nok(code);
    }
    if (labelStart._inactive) {
      return labelEndNok(code);
    }
    defined = self2.parser.defined.includes(normalizeIdentifier(self2.sliceSerialize({
      start: labelStart.end,
      end: self2.now()
    })));
    effects.enter("labelEnd");
    effects.enter("labelMarker");
    effects.consume(code);
    effects.exit("labelMarker");
    effects.exit("labelEnd");
    return after;
  }
  function after(code) {
    if (code === 40) {
      return effects.attempt(resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
    }
    if (code === 91) {
      return effects.attempt(referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
    }
    return defined ? labelEndOk(code) : labelEndNok(code);
  }
  function referenceNotFull(code) {
    return effects.attempt(referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
  }
  function labelEndOk(code) {
    return ok2(code);
  }
  function labelEndNok(code) {
    labelStart._balanced = true;
    return nok(code);
  }
}
function tokenizeResource(effects, ok2, nok) {
  return resourceStart;
  function resourceStart(code) {
    effects.enter("resource");
    effects.enter("resourceMarker");
    effects.consume(code);
    effects.exit("resourceMarker");
    return resourceBefore;
  }
  function resourceBefore(code) {
    return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, resourceOpen)(code) : resourceOpen(code);
  }
  function resourceOpen(code) {
    if (code === 41) {
      return resourceEnd(code);
    }
    return factoryDestination(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
  }
  function resourceDestinationAfter(code) {
    return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, resourceBetween)(code) : resourceEnd(code);
  }
  function resourceDestinationMissing(code) {
    return nok(code);
  }
  function resourceBetween(code) {
    if (code === 34 || code === 39 || code === 40) {
      return factoryTitle(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
    }
    return resourceEnd(code);
  }
  function resourceTitleAfter(code) {
    return markdownLineEndingOrSpace(code) ? factoryWhitespace(effects, resourceEnd)(code) : resourceEnd(code);
  }
  function resourceEnd(code) {
    if (code === 41) {
      effects.enter("resourceMarker");
      effects.consume(code);
      effects.exit("resourceMarker");
      effects.exit("resource");
      return ok2;
    }
    return nok(code);
  }
}
function tokenizeReferenceFull(effects, ok2, nok) {
  const self2 = this;
  return referenceFull;
  function referenceFull(code) {
    return factoryLabel.call(self2, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
  }
  function referenceFullAfter(code) {
    return self2.parser.defined.includes(normalizeIdentifier(self2.sliceSerialize(self2.events[self2.events.length - 1][1]).slice(1, -1))) ? ok2(code) : nok(code);
  }
  function referenceFullMissing(code) {
    return nok(code);
  }
}
function tokenizeReferenceCollapsed(effects, ok2, nok) {
  return referenceCollapsedStart;
  function referenceCollapsedStart(code) {
    effects.enter("reference");
    effects.enter("referenceMarker");
    effects.consume(code);
    effects.exit("referenceMarker");
    return referenceCollapsedOpen;
  }
  function referenceCollapsedOpen(code) {
    if (code === 93) {
      effects.enter("referenceMarker");
      effects.consume(code);
      effects.exit("referenceMarker");
      effects.exit("reference");
      return ok2;
    }
    return nok(code);
  }
}
const labelStartImage = {
  name: "labelStartImage",
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartImage
};
function tokenizeLabelStartImage(effects, ok2, nok) {
  const self2 = this;
  return start4;
  function start4(code) {
    effects.enter("labelImage");
    effects.enter("labelImageMarker");
    effects.consume(code);
    effects.exit("labelImageMarker");
    return open;
  }
  function open(code) {
    if (code === 91) {
      effects.enter("labelMarker");
      effects.consume(code);
      effects.exit("labelMarker");
      effects.exit("labelImage");
      return after;
    }
    return nok(code);
  }
  function after(code) {
    return code === 94 && "_hiddenFootnoteSupport" in self2.parser.constructs ? nok(code) : ok2(code);
  }
}
const labelStartLink = {
  name: "labelStartLink",
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartLink
};
function tokenizeLabelStartLink(effects, ok2, nok) {
  const self2 = this;
  return start4;
  function start4(code) {
    effects.enter("labelLink");
    effects.enter("labelMarker");
    effects.consume(code);
    effects.exit("labelMarker");
    effects.exit("labelLink");
    return after;
  }
  function after(code) {
    return code === 94 && "_hiddenFootnoteSupport" in self2.parser.constructs ? nok(code) : ok2(code);
  }
}
const lineEnding = {
  name: "lineEnding",
  tokenize: tokenizeLineEnding
};
function tokenizeLineEnding(effects, ok2) {
  return start4;
  function start4(code) {
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    return factorySpace(effects, ok2, "linePrefix");
  }
}
const thematicBreak$2 = {
  name: "thematicBreak",
  tokenize: tokenizeThematicBreak
};
function tokenizeThematicBreak(effects, ok2, nok) {
  let size2 = 0;
  let marker;
  return start4;
  function start4(code) {
    effects.enter("thematicBreak");
    return before(code);
  }
  function before(code) {
    marker = code;
    return atBreak(code);
  }
  function atBreak(code) {
    if (code === marker) {
      effects.enter("thematicBreakSequence");
      return sequence(code);
    }
    if (size2 >= 3 && (code === null || markdownLineEnding(code))) {
      effects.exit("thematicBreak");
      return ok2(code);
    }
    return nok(code);
  }
  function sequence(code) {
    if (code === marker) {
      effects.consume(code);
      size2++;
      return sequence;
    }
    effects.exit("thematicBreakSequence");
    return markdownSpace(code) ? factorySpace(effects, atBreak, "whitespace")(code) : atBreak(code);
  }
}
const list$3 = {
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd,
  name: "list",
  tokenize: tokenizeListStart
};
const listItemPrefixWhitespaceConstruct = {
  partial: true,
  tokenize: tokenizeListItemPrefixWhitespace
};
const indentConstruct = {
  partial: true,
  tokenize: tokenizeIndent$1
};
function tokenizeListStart(effects, ok2, nok) {
  const self2 = this;
  const tail = self2.events[self2.events.length - 1];
  let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
  let size2 = 0;
  return start4;
  function start4(code) {
    const kind = self2.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
    if (kind === "listUnordered" ? !self2.containerState.marker || code === self2.containerState.marker : asciiDigit(code)) {
      if (!self2.containerState.type) {
        self2.containerState.type = kind;
        effects.enter(kind, {
          _container: true
        });
      }
      if (kind === "listUnordered") {
        effects.enter("listItemPrefix");
        return code === 42 || code === 45 ? effects.check(thematicBreak$2, nok, atMarker)(code) : atMarker(code);
      }
      if (!self2.interrupt || code === 49) {
        effects.enter("listItemPrefix");
        effects.enter("listItemValue");
        return inside(code);
      }
    }
    return nok(code);
  }
  function inside(code) {
    if (asciiDigit(code) && ++size2 < 10) {
      effects.consume(code);
      return inside;
    }
    if ((!self2.interrupt || size2 < 2) && (self2.containerState.marker ? code === self2.containerState.marker : code === 41 || code === 46)) {
      effects.exit("listItemValue");
      return atMarker(code);
    }
    return nok(code);
  }
  function atMarker(code) {
    effects.enter("listItemMarker");
    effects.consume(code);
    effects.exit("listItemMarker");
    self2.containerState.marker = self2.containerState.marker || code;
    return effects.check(
      blankLine,
      // Can’t be empty when interrupting.
      self2.interrupt ? nok : onBlank,
      effects.attempt(listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix)
    );
  }
  function onBlank(code) {
    self2.containerState.initialBlankLine = true;
    initialSize++;
    return endOfPrefix(code);
  }
  function otherPrefix(code) {
    if (markdownSpace(code)) {
      effects.enter("listItemPrefixWhitespace");
      effects.consume(code);
      effects.exit("listItemPrefixWhitespace");
      return endOfPrefix;
    }
    return nok(code);
  }
  function endOfPrefix(code) {
    self2.containerState.size = initialSize + self2.sliceSerialize(effects.exit("listItemPrefix"), true).length;
    return ok2(code);
  }
}
function tokenizeListContinuation(effects, ok2, nok) {
  const self2 = this;
  self2.containerState._closeFlow = void 0;
  return effects.check(blankLine, onBlank, notBlank);
  function onBlank(code) {
    self2.containerState.furtherBlankLines = self2.containerState.furtherBlankLines || self2.containerState.initialBlankLine;
    return factorySpace(effects, ok2, "listItemIndent", self2.containerState.size + 1)(code);
  }
  function notBlank(code) {
    if (self2.containerState.furtherBlankLines || !markdownSpace(code)) {
      self2.containerState.furtherBlankLines = void 0;
      self2.containerState.initialBlankLine = void 0;
      return notInCurrentItem(code);
    }
    self2.containerState.furtherBlankLines = void 0;
    self2.containerState.initialBlankLine = void 0;
    return effects.attempt(indentConstruct, ok2, notInCurrentItem)(code);
  }
  function notInCurrentItem(code) {
    self2.containerState._closeFlow = true;
    self2.interrupt = void 0;
    return factorySpace(effects, effects.attempt(list$3, ok2, nok), "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code);
  }
}
function tokenizeIndent$1(effects, ok2, nok) {
  const self2 = this;
  return factorySpace(effects, afterPrefix, "listItemIndent", self2.containerState.size + 1);
  function afterPrefix(code) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self2.containerState.size ? ok2(code) : nok(code);
  }
}
function tokenizeListEnd(effects) {
  effects.exit(this.containerState.type);
}
function tokenizeListItemPrefixWhitespace(effects, ok2, nok) {
  const self2 = this;
  return factorySpace(effects, afterPrefix, "listItemPrefixWhitespace", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1);
  function afterPrefix(code) {
    const tail = self2.events[self2.events.length - 1];
    return !markdownSpace(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok2(code) : nok(code);
  }
}
const setextUnderline = {
  name: "setextUnderline",
  resolveTo: resolveToSetextUnderline,
  tokenize: tokenizeSetextUnderline
};
function resolveToSetextUnderline(events2, context) {
  let index2 = events2.length;
  let content2;
  let text2;
  let definition2;
  while (index2--) {
    if (events2[index2][0] === "enter") {
      if (events2[index2][1].type === "content") {
        content2 = index2;
        break;
      }
      if (events2[index2][1].type === "paragraph") {
        text2 = index2;
      }
    } else {
      if (events2[index2][1].type === "content") {
        events2.splice(index2, 1);
      }
      if (!definition2 && events2[index2][1].type === "definition") {
        definition2 = index2;
      }
    }
  }
  const heading2 = {
    type: "setextHeading",
    start: {
      ...events2[content2][1].start
    },
    end: {
      ...events2[events2.length - 1][1].end
    }
  };
  events2[text2][1].type = "setextHeadingText";
  if (definition2) {
    events2.splice(text2, 0, ["enter", heading2, context]);
    events2.splice(definition2 + 1, 0, ["exit", events2[content2][1], context]);
    events2[content2][1].end = {
      ...events2[definition2][1].end
    };
  } else {
    events2[content2][1] = heading2;
  }
  events2.push(["exit", heading2, context]);
  return events2;
}
function tokenizeSetextUnderline(effects, ok2, nok) {
  const self2 = this;
  let marker;
  return start4;
  function start4(code) {
    let index2 = self2.events.length;
    let paragraph2;
    while (index2--) {
      if (self2.events[index2][1].type !== "lineEnding" && self2.events[index2][1].type !== "linePrefix" && self2.events[index2][1].type !== "content") {
        paragraph2 = self2.events[index2][1].type === "paragraph";
        break;
      }
    }
    if (!self2.parser.lazy[self2.now().line] && (self2.interrupt || paragraph2)) {
      effects.enter("setextHeadingLine");
      marker = code;
      return before(code);
    }
    return nok(code);
  }
  function before(code) {
    effects.enter("setextHeadingLineSequence");
    return inside(code);
  }
  function inside(code) {
    if (code === marker) {
      effects.consume(code);
      return inside;
    }
    effects.exit("setextHeadingLineSequence");
    return markdownSpace(code) ? factorySpace(effects, after, "lineSuffix")(code) : after(code);
  }
  function after(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit("setextHeadingLine");
      return ok2(code);
    }
    return nok(code);
  }
}
const flow$1 = {
  tokenize: initializeFlow
};
function initializeFlow(effects) {
  const self2 = this;
  const initial = effects.attempt(
    // Try to parse a blank line.
    blankLine,
    atBlankEnding,
    // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, factorySpace(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt(content, afterConstruct)), "linePrefix"))
  );
  return initial;
  function atBlankEnding(code) {
    if (code === null) {
      effects.consume(code);
      return;
    }
    effects.enter("lineEndingBlank");
    effects.consume(code);
    effects.exit("lineEndingBlank");
    self2.currentConstruct = void 0;
    return initial;
  }
  function afterConstruct(code) {
    if (code === null) {
      effects.consume(code);
      return;
    }
    effects.enter("lineEnding");
    effects.consume(code);
    effects.exit("lineEnding");
    self2.currentConstruct = void 0;
    return initial;
  }
}
const resolver = {
  resolveAll: createResolver()
};
const string$1 = initializeFactory("string");
const text$5 = initializeFactory("text");
function initializeFactory(field) {
  return {
    resolveAll: createResolver(field === "text" ? resolveAllLineSuffixes : void 0),
    tokenize: initializeText
  };
  function initializeText(effects) {
    const self2 = this;
    const constructs2 = this.parser.constructs[field];
    const text2 = effects.attempt(constructs2, start4, notText);
    return start4;
    function start4(code) {
      return atBreak(code) ? text2(code) : notText(code);
    }
    function notText(code) {
      if (code === null) {
        effects.consume(code);
        return;
      }
      effects.enter("data");
      effects.consume(code);
      return data;
    }
    function data(code) {
      if (atBreak(code)) {
        effects.exit("data");
        return text2(code);
      }
      effects.consume(code);
      return data;
    }
    function atBreak(code) {
      if (code === null) {
        return true;
      }
      const list2 = constructs2[code];
      let index2 = -1;
      if (list2) {
        while (++index2 < list2.length) {
          const item = list2[index2];
          if (!item.previous || item.previous.call(self2, self2.previous)) {
            return true;
          }
        }
      }
      return false;
    }
  }
}
function createResolver(extraResolver) {
  return resolveAllText;
  function resolveAllText(events2, context) {
    let index2 = -1;
    let enter2;
    while (++index2 <= events2.length) {
      if (enter2 === void 0) {
        if (events2[index2] && events2[index2][1].type === "data") {
          enter2 = index2;
          index2++;
        }
      } else if (!events2[index2] || events2[index2][1].type !== "data") {
        if (index2 !== enter2 + 2) {
          events2[enter2][1].end = events2[index2 - 1][1].end;
          events2.splice(enter2 + 2, index2 - enter2 - 2);
          index2 = enter2 + 2;
        }
        enter2 = void 0;
      }
    }
    return extraResolver ? extraResolver(events2, context) : events2;
  }
}
function resolveAllLineSuffixes(events2, context) {
  let eventIndex = 0;
  while (++eventIndex <= events2.length) {
    if ((eventIndex === events2.length || events2[eventIndex][1].type === "lineEnding") && events2[eventIndex - 1][1].type === "data") {
      const data = events2[eventIndex - 1][1];
      const chunks = context.sliceStream(data);
      let index2 = chunks.length;
      let bufferIndex = -1;
      let size2 = 0;
      let tabs;
      while (index2--) {
        const chunk = chunks[index2];
        if (typeof chunk === "string") {
          bufferIndex = chunk.length;
          while (chunk.charCodeAt(bufferIndex - 1) === 32) {
            size2++;
            bufferIndex--;
          }
          if (bufferIndex) break;
          bufferIndex = -1;
        } else if (chunk === -2) {
          tabs = true;
          size2++;
        } else if (chunk === -1) ;
        else {
          index2++;
          break;
        }
      }
      if (context._contentTypeTextTrailing && eventIndex === events2.length) {
        size2 = 0;
      }
      if (size2) {
        const token2 = {
          type: eventIndex === events2.length || tabs || size2 < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: index2 ? bufferIndex : data.start._bufferIndex + bufferIndex,
            _index: data.start._index + index2,
            line: data.end.line,
            column: data.end.column - size2,
            offset: data.end.offset - size2
          },
          end: {
            ...data.end
          }
        };
        data.end = {
          ...token2.start
        };
        if (data.start.offset === data.end.offset) {
          Object.assign(data, token2);
        } else {
          events2.splice(eventIndex, 0, ["enter", token2, context], ["exit", token2, context]);
          eventIndex += 2;
        }
      }
      eventIndex++;
    }
  }
  return events2;
}
const document$1 = {
  [42]: list$3,
  [43]: list$3,
  [45]: list$3,
  [48]: list$3,
  [49]: list$3,
  [50]: list$3,
  [51]: list$3,
  [52]: list$3,
  [53]: list$3,
  [54]: list$3,
  [55]: list$3,
  [56]: list$3,
  [57]: list$3,
  [62]: blockQuote
};
const contentInitial = {
  [91]: definition$1
};
const flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  [32]: codeIndented
};
const flow = {
  [35]: headingAtx,
  [42]: thematicBreak$2,
  [45]: [setextUnderline, thematicBreak$2],
  [60]: htmlFlow,
  [61]: setextUnderline,
  [95]: thematicBreak$2,
  [96]: codeFenced,
  [126]: codeFenced
};
const string = {
  [38]: characterReference,
  [92]: characterEscape
};
const text$4 = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  [33]: labelStartImage,
  [38]: characterReference,
  [42]: attention,
  [60]: [autolink$1, htmlText],
  [91]: labelStartLink,
  [92]: [hardBreakEscape, characterEscape],
  [93]: labelEnd,
  [95]: attention,
  [96]: codeText
};
const insideSpan = {
  null: [attention, resolver]
};
const attentionMarkers = {
  null: [42, 95]
};
const disable = {
  null: []
};
const defaultConstructs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers,
  contentInitial,
  disable,
  document: document$1,
  flow,
  flowInitial,
  insideSpan,
  string,
  text: text$4
}, Symbol.toStringTag, { value: "Module" }));
function createTokenizer(parser, initialize, from3) {
  let point2 = {
    _bufferIndex: -1,
    _index: 0,
    line: from3 && from3.line || 1,
    column: from3 && from3.column || 1,
    offset: from3 && from3.offset || 0
  };
  const columnStart = {};
  const resolveAllConstructs = [];
  let chunks = [];
  let stack = [];
  const effects = {
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    consume,
    enter: enter2,
    exit: exit2,
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: true
    })
  };
  const context = {
    code: null,
    containerState: {},
    defineSkip,
    events: [],
    now: now2,
    parser,
    previous: null,
    sliceSerialize,
    sliceStream,
    write
  };
  let state = initialize.tokenize.call(context, effects);
  if (initialize.resolveAll) {
    resolveAllConstructs.push(initialize);
  }
  return context;
  function write(slice3) {
    chunks = push$1(chunks, slice3);
    main();
    if (chunks[chunks.length - 1] !== null) {
      return [];
    }
    addResult(initialize, 0);
    context.events = resolveAll(resolveAllConstructs, context.events, context);
    return context.events;
  }
  function sliceSerialize(token2, expandTabs) {
    return serializeChunks(sliceStream(token2), expandTabs);
  }
  function sliceStream(token2) {
    return sliceChunks(chunks, token2);
  }
  function now2() {
    const {
      _bufferIndex,
      _index,
      line: line2,
      column: column2,
      offset: offset3
    } = point2;
    return {
      _bufferIndex,
      _index,
      line: line2,
      column: column2,
      offset: offset3
    };
  }
  function defineSkip(value) {
    columnStart[value.line] = value.column;
    accountForPotentialSkip();
  }
  function main() {
    let chunkIndex;
    while (point2._index < chunks.length) {
      const chunk = chunks[point2._index];
      if (typeof chunk === "string") {
        chunkIndex = point2._index;
        if (point2._bufferIndex < 0) {
          point2._bufferIndex = 0;
        }
        while (point2._index === chunkIndex && point2._bufferIndex < chunk.length) {
          go(chunk.charCodeAt(point2._bufferIndex));
        }
      } else {
        go(chunk);
      }
    }
  }
  function go(code) {
    state = state(code);
  }
  function consume(code) {
    if (markdownLineEnding(code)) {
      point2.line++;
      point2.column = 1;
      point2.offset += code === -3 ? 2 : 1;
      accountForPotentialSkip();
    } else if (code !== -1) {
      point2.column++;
      point2.offset++;
    }
    if (point2._bufferIndex < 0) {
      point2._index++;
    } else {
      point2._bufferIndex++;
      if (point2._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
      // strings.
      /** @type {string} */
      chunks[point2._index].length) {
        point2._bufferIndex = -1;
        point2._index++;
      }
    }
    context.previous = code;
  }
  function enter2(type, fields) {
    const token2 = fields || {};
    token2.type = type;
    token2.start = now2();
    context.events.push(["enter", token2, context]);
    stack.push(token2);
    return token2;
  }
  function exit2(type) {
    const token2 = stack.pop();
    token2.end = now2();
    context.events.push(["exit", token2, context]);
    return token2;
  }
  function onsuccessfulconstruct(construct, info) {
    addResult(construct, info.from);
  }
  function onsuccessfulcheck(_2, info) {
    info.restore();
  }
  function constructFactory(onreturn, fields) {
    return hook;
    function hook(constructs2, returnState, bogusState) {
      let listOfConstructs;
      let constructIndex;
      let currentConstruct;
      let info;
      return Array.isArray(constructs2) ? (
        /* c8 ignore next 1 */
        handleListOfConstructs(constructs2)
      ) : "tokenize" in constructs2 ? (
        // Looks like a construct.
        handleListOfConstructs([
          /** @type {Construct} */
          constructs2
        ])
      ) : handleMapOfConstructs(constructs2);
      function handleMapOfConstructs(map3) {
        return start4;
        function start4(code) {
          const left2 = code !== null && map3[code];
          const all2 = code !== null && map3.null;
          const list2 = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(left2) ? left2 : left2 ? [left2] : [],
            ...Array.isArray(all2) ? all2 : all2 ? [all2] : []
          ];
          return handleListOfConstructs(list2)(code);
        }
      }
      function handleListOfConstructs(list2) {
        listOfConstructs = list2;
        constructIndex = 0;
        if (list2.length === 0) {
          return bogusState;
        }
        return handleConstruct(list2[constructIndex]);
      }
      function handleConstruct(construct) {
        return start4;
        function start4(code) {
          info = store();
          currentConstruct = construct;
          if (!construct.partial) {
            context.currentConstruct = construct;
          }
          if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) {
            return nok();
          }
          return construct.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            fields ? Object.assign(Object.create(context), fields) : context,
            effects,
            ok2,
            nok
          )(code);
        }
      }
      function ok2(code) {
        onreturn(currentConstruct, info);
        return returnState;
      }
      function nok(code) {
        info.restore();
        if (++constructIndex < listOfConstructs.length) {
          return handleConstruct(listOfConstructs[constructIndex]);
        }
        return bogusState;
      }
    }
  }
  function addResult(construct, from4) {
    if (construct.resolveAll && !resolveAllConstructs.includes(construct)) {
      resolveAllConstructs.push(construct);
    }
    if (construct.resolve) {
      splice(context.events, from4, context.events.length - from4, construct.resolve(context.events.slice(from4), context));
    }
    if (construct.resolveTo) {
      context.events = construct.resolveTo(context.events, context);
    }
  }
  function store() {
    const startPoint = now2();
    const startPrevious = context.previous;
    const startCurrentConstruct = context.currentConstruct;
    const startEventsIndex = context.events.length;
    const startStack = Array.from(stack);
    return {
      from: startEventsIndex,
      restore
    };
    function restore() {
      point2 = startPoint;
      context.previous = startPrevious;
      context.currentConstruct = startCurrentConstruct;
      context.events.length = startEventsIndex;
      stack = startStack;
      accountForPotentialSkip();
    }
  }
  function accountForPotentialSkip() {
    if (point2.line in columnStart && point2.column < 2) {
      point2.column = columnStart[point2.line];
      point2.offset += columnStart[point2.line] - 1;
    }
  }
}
function sliceChunks(chunks, token2) {
  const startIndex = token2.start._index;
  const startBufferIndex = token2.start._bufferIndex;
  const endIndex = token2.end._index;
  const endBufferIndex = token2.end._bufferIndex;
  let view;
  if (startIndex === endIndex) {
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)];
  } else {
    view = chunks.slice(startIndex, endIndex);
    if (startBufferIndex > -1) {
      const head = view[0];
      if (typeof head === "string") {
        view[0] = head.slice(startBufferIndex);
      } else {
        view.shift();
      }
    }
    if (endBufferIndex > 0) {
      view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
  }
  return view;
}
function serializeChunks(chunks, expandTabs) {
  let index2 = -1;
  const result = [];
  let atTab;
  while (++index2 < chunks.length) {
    const chunk = chunks[index2];
    let value;
    if (typeof chunk === "string") {
      value = chunk;
    } else switch (chunk) {
      case -5: {
        value = "\r";
        break;
      }
      case -4: {
        value = "\n";
        break;
      }
      case -3: {
        value = "\r\n";
        break;
      }
      case -2: {
        value = expandTabs ? " " : "	";
        break;
      }
      case -1: {
        if (!expandTabs && atTab) continue;
        value = " ";
        break;
      }
      default: {
        value = String.fromCharCode(chunk);
      }
    }
    atTab = chunk === -2;
    result.push(value);
  }
  return result.join("");
}
function parse2(options) {
  const settings = options || {};
  const constructs2 = (
    /** @type {FullNormalizedExtension} */
    combineExtensions([defaultConstructs, ...settings.extensions || []])
  );
  const parser = {
    constructs: constructs2,
    content: create2(content$1),
    defined: [],
    document: create2(document$2),
    flow: create2(flow$1),
    lazy: {},
    string: create2(string$1),
    text: create2(text$5)
  };
  return parser;
  function create2(initial) {
    return creator;
    function creator(from3) {
      return createTokenizer(parser, initial, from3);
    }
  }
}
function postprocess(events2) {
  while (!subtokenize(events2)) {
  }
  return events2;
}
const search = /[\0\t\n\r]/g;
function preprocess() {
  let column2 = 1;
  let buffer = "";
  let start4 = true;
  let atCarriageReturn;
  return preprocessor;
  function preprocessor(value, encoding, end2) {
    const chunks = [];
    let match5;
    let next2;
    let startPosition;
    let endPosition;
    let code;
    value = buffer + (typeof value === "string" ? value.toString() : new TextDecoder(encoding || void 0).decode(value));
    startPosition = 0;
    buffer = "";
    if (start4) {
      if (value.charCodeAt(0) === 65279) {
        startPosition++;
      }
      start4 = void 0;
    }
    while (startPosition < value.length) {
      search.lastIndex = startPosition;
      match5 = search.exec(value);
      endPosition = match5 && match5.index !== void 0 ? match5.index : value.length;
      code = value.charCodeAt(endPosition);
      if (!match5) {
        buffer = value.slice(startPosition);
        break;
      }
      if (code === 10 && startPosition === endPosition && atCarriageReturn) {
        chunks.push(-3);
        atCarriageReturn = void 0;
      } else {
        if (atCarriageReturn) {
          chunks.push(-5);
          atCarriageReturn = void 0;
        }
        if (startPosition < endPosition) {
          chunks.push(value.slice(startPosition, endPosition));
          column2 += endPosition - startPosition;
        }
        switch (code) {
          case 0: {
            chunks.push(65533);
            column2++;
            break;
          }
          case 9: {
            next2 = Math.ceil(column2 / 4) * 4;
            chunks.push(-2);
            while (column2++ < next2) chunks.push(-1);
            break;
          }
          case 10: {
            chunks.push(-4);
            column2 = 1;
            break;
          }
          default: {
            atCarriageReturn = true;
            column2 = 1;
          }
        }
      }
      startPosition = endPosition + 1;
    }
    if (end2) {
      if (atCarriageReturn) chunks.push(-5);
      if (buffer) chunks.push(buffer);
      chunks.push(null);
    }
    return chunks;
  }
}
const characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function decodeString(value) {
  return value.replace(characterEscapeOrReference, decode);
}
function decode($0, $1, $2) {
  if ($1) {
    return $1;
  }
  const head = $2.charCodeAt(0);
  if (head === 35) {
    const head2 = $2.charCodeAt(1);
    const hex = head2 === 120 || head2 === 88;
    return decodeNumericCharacterReference($2.slice(hex ? 2 : 1), hex ? 16 : 10);
  }
  return decodeNamedCharacterReference($2) || $0;
}
function stringifyPosition(value) {
  if (!value || typeof value !== "object") {
    return "";
  }
  if ("position" in value || "type" in value) {
    return position$3(value.position);
  }
  if ("start" in value || "end" in value) {
    return position$3(value);
  }
  if ("line" in value || "column" in value) {
    return point$2(value);
  }
  return "";
}
function point$2(point2) {
  return index$1(point2 && point2.line) + ":" + index$1(point2 && point2.column);
}
function position$3(pos) {
  return point$2(pos && pos.start) + "-" + point$2(pos && pos.end);
}
function index$1(value) {
  return value && typeof value === "number" ? value : 1;
}
const own$5 = {}.hasOwnProperty;
function fromMarkdown(value, encoding, options) {
  if (typeof encoding !== "string") {
    options = encoding;
    encoding = void 0;
  }
  return compiler(options)(postprocess(parse2(options).document().write(preprocess()(value, encoding, true))));
}
function compiler(options) {
  const config2 = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: opener(link2),
      autolinkProtocol: onenterdata,
      autolinkEmail: onenterdata,
      atxHeading: opener(heading2),
      blockQuote: opener(blockQuote2),
      characterEscape: onenterdata,
      characterReference: onenterdata,
      codeFenced: opener(codeFlow),
      codeFencedFenceInfo: buffer,
      codeFencedFenceMeta: buffer,
      codeIndented: opener(codeFlow, buffer),
      codeText: opener(codeText2, buffer),
      codeTextData: onenterdata,
      data: onenterdata,
      codeFlowValue: onenterdata,
      definition: opener(definition2),
      definitionDestinationString: buffer,
      definitionLabelString: buffer,
      definitionTitleString: buffer,
      emphasis: opener(emphasis2),
      hardBreakEscape: opener(hardBreak2),
      hardBreakTrailing: opener(hardBreak2),
      htmlFlow: opener(html2, buffer),
      htmlFlowData: onenterdata,
      htmlText: opener(html2, buffer),
      htmlTextData: onenterdata,
      image: opener(image2),
      label: buffer,
      link: opener(link2),
      listItem: opener(listItem2),
      listItemValue: onenterlistitemvalue,
      listOrdered: opener(list2, onenterlistordered),
      listUnordered: opener(list2),
      paragraph: opener(paragraph2),
      reference: onenterreference,
      referenceString: buffer,
      resourceDestinationString: buffer,
      resourceTitleString: buffer,
      setextHeading: opener(heading2),
      strong: opener(strong2),
      thematicBreak: opener(thematicBreak2)
    },
    exit: {
      atxHeading: closer(),
      atxHeadingSequence: onexitatxheadingsequence,
      autolink: closer(),
      autolinkEmail: onexitautolinkemail,
      autolinkProtocol: onexitautolinkprotocol,
      blockQuote: closer(),
      characterEscapeValue: onexitdata,
      characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
      characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
      characterReferenceValue: onexitcharacterreferencevalue,
      characterReference: onexitcharacterreference,
      codeFenced: closer(onexitcodefenced),
      codeFencedFence: onexitcodefencedfence,
      codeFencedFenceInfo: onexitcodefencedfenceinfo,
      codeFencedFenceMeta: onexitcodefencedfencemeta,
      codeFlowValue: onexitdata,
      codeIndented: closer(onexitcodeindented),
      codeText: closer(onexitcodetext),
      codeTextData: onexitdata,
      data: onexitdata,
      definition: closer(),
      definitionDestinationString: onexitdefinitiondestinationstring,
      definitionLabelString: onexitdefinitionlabelstring,
      definitionTitleString: onexitdefinitiontitlestring,
      emphasis: closer(),
      hardBreakEscape: closer(onexithardbreak),
      hardBreakTrailing: closer(onexithardbreak),
      htmlFlow: closer(onexithtmlflow),
      htmlFlowData: onexitdata,
      htmlText: closer(onexithtmltext),
      htmlTextData: onexitdata,
      image: closer(onexitimage),
      label: onexitlabel,
      labelText: onexitlabeltext,
      lineEnding: onexitlineending,
      link: closer(onexitlink),
      listItem: closer(),
      listOrdered: closer(),
      listUnordered: closer(),
      paragraph: closer(),
      referenceString: onexitreferencestring,
      resourceDestinationString: onexitresourcedestinationstring,
      resourceTitleString: onexitresourcetitlestring,
      resource: onexitresource,
      setextHeading: closer(onexitsetextheading),
      setextHeadingLineSequence: onexitsetextheadinglinesequence,
      setextHeadingText: onexitsetextheadingtext,
      strong: closer(),
      thematicBreak: closer()
    }
  };
  configure$1(config2, (options || {}).mdastExtensions || []);
  const data = {};
  return compile2;
  function compile2(events2) {
    let tree = {
      type: "root",
      children: []
    };
    const context = {
      stack: [tree],
      tokenStack: [],
      config: config2,
      enter: enter2,
      exit: exit2,
      buffer,
      resume,
      data
    };
    const listStack = [];
    let index2 = -1;
    while (++index2 < events2.length) {
      if (events2[index2][1].type === "listOrdered" || events2[index2][1].type === "listUnordered") {
        if (events2[index2][0] === "enter") {
          listStack.push(index2);
        } else {
          const tail = listStack.pop();
          index2 = prepareList(events2, tail, index2);
        }
      }
    }
    index2 = -1;
    while (++index2 < events2.length) {
      const handler = config2[events2[index2][0]];
      if (own$5.call(handler, events2[index2][1].type)) {
        handler[events2[index2][1].type].call(Object.assign({
          sliceSerialize: events2[index2][2].sliceSerialize
        }, context), events2[index2][1]);
      }
    }
    if (context.tokenStack.length > 0) {
      const tail = context.tokenStack[context.tokenStack.length - 1];
      const handler = tail[1] || defaultOnError;
      handler.call(context, void 0, tail[0]);
    }
    tree.position = {
      start: point$1(events2.length > 0 ? events2[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: point$1(events2.length > 0 ? events2[events2.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    };
    index2 = -1;
    while (++index2 < config2.transforms.length) {
      tree = config2.transforms[index2](tree) || tree;
    }
    return tree;
  }
  function prepareList(events2, start4, length2) {
    let index2 = start4 - 1;
    let containerBalance = -1;
    let listSpread = false;
    let listItem3;
    let lineIndex;
    let firstBlankLineIndex;
    let atMarker;
    while (++index2 <= length2) {
      const event = events2[index2];
      switch (event[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          if (event[0] === "enter") {
            containerBalance++;
          } else {
            containerBalance--;
          }
          atMarker = void 0;
          break;
        }
        case "lineEndingBlank": {
          if (event[0] === "enter") {
            if (listItem3 && !atMarker && !containerBalance && !firstBlankLineIndex) {
              firstBlankLineIndex = index2;
            }
            atMarker = void 0;
          }
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace": {
          break;
        }
        default: {
          atMarker = void 0;
        }
      }
      if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
        if (listItem3) {
          let tailIndex = index2;
          lineIndex = void 0;
          while (tailIndex--) {
            const tailEvent = events2[tailIndex];
            if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
              if (tailEvent[0] === "exit") continue;
              if (lineIndex) {
                events2[lineIndex][1].type = "lineEndingBlank";
                listSpread = true;
              }
              tailEvent[1].type = "lineEnding";
              lineIndex = tailIndex;
            } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
            else {
              break;
            }
          }
          if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) {
            listItem3._spread = true;
          }
          listItem3.end = Object.assign({}, lineIndex ? events2[lineIndex][1].start : event[1].end);
          events2.splice(lineIndex || index2, 0, ["exit", listItem3, event[2]]);
          index2++;
          length2++;
        }
        if (event[1].type === "listItemPrefix") {
          const item = {
            type: "listItem",
            _spread: false,
            start: Object.assign({}, event[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          listItem3 = item;
          events2.splice(index2, 0, ["enter", item, event[2]]);
          index2++;
          length2++;
          firstBlankLineIndex = void 0;
          atMarker = true;
        }
      }
    }
    events2[start4][1]._spread = listSpread;
    return length2;
  }
  function opener(create2, and) {
    return open;
    function open(token2) {
      enter2.call(this, create2(token2), token2);
      if (and) and.call(this, token2);
    }
  }
  function buffer() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function enter2(node2, token2, errorHandler) {
    const parent2 = this.stack[this.stack.length - 1];
    const siblings = parent2.children;
    siblings.push(node2);
    this.stack.push(node2);
    this.tokenStack.push([token2, errorHandler || void 0]);
    node2.position = {
      start: point$1(token2.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function closer(and) {
    return close2;
    function close2(token2) {
      if (and) and.call(this, token2);
      exit2.call(this, token2);
    }
  }
  function exit2(token2, onExitError) {
    const node2 = this.stack.pop();
    const open = this.tokenStack.pop();
    if (!open) {
      throw new Error("Cannot close `" + token2.type + "` (" + stringifyPosition({
        start: token2.start,
        end: token2.end
      }) + "): it’s not open");
    } else if (open[0].type !== token2.type) {
      if (onExitError) {
        onExitError.call(this, token2, open[0]);
      } else {
        const handler = open[1] || defaultOnError;
        handler.call(this, token2, open[0]);
      }
    }
    node2.position.end = point$1(token2.end);
  }
  function resume() {
    return toString$2(this.stack.pop());
  }
  function onenterlistordered() {
    this.data.expectingFirstListItemValue = true;
  }
  function onenterlistitemvalue(token2) {
    if (this.data.expectingFirstListItemValue) {
      const ancestor = this.stack[this.stack.length - 2];
      ancestor.start = Number.parseInt(this.sliceSerialize(token2), 10);
      this.data.expectingFirstListItemValue = void 0;
    }
  }
  function onexitcodefencedfenceinfo() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.lang = data2;
  }
  function onexitcodefencedfencemeta() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.meta = data2;
  }
  function onexitcodefencedfence() {
    if (this.data.flowCodeInside) return;
    this.buffer();
    this.data.flowCodeInside = true;
  }
  function onexitcodefenced() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.value = data2.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
    this.data.flowCodeInside = void 0;
  }
  function onexitcodeindented() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.value = data2.replace(/(\r?\n|\r)$/g, "");
  }
  function onexitdefinitionlabelstring(token2) {
    const label = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.label = label;
    node2.identifier = normalizeIdentifier(this.sliceSerialize(token2)).toLowerCase();
  }
  function onexitdefinitiontitlestring() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.title = data2;
  }
  function onexitdefinitiondestinationstring() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.url = data2;
  }
  function onexitatxheadingsequence(token2) {
    const node2 = this.stack[this.stack.length - 1];
    if (!node2.depth) {
      const depth = this.sliceSerialize(token2).length;
      node2.depth = depth;
    }
  }
  function onexitsetextheadingtext() {
    this.data.setextHeadingSlurpLineEnding = true;
  }
  function onexitsetextheadinglinesequence(token2) {
    const node2 = this.stack[this.stack.length - 1];
    node2.depth = this.sliceSerialize(token2).codePointAt(0) === 61 ? 1 : 2;
  }
  function onexitsetextheading() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function onenterdata(token2) {
    const node2 = this.stack[this.stack.length - 1];
    const siblings = node2.children;
    let tail = siblings[siblings.length - 1];
    if (!tail || tail.type !== "text") {
      tail = text2();
      tail.position = {
        start: point$1(token2.start),
        // @ts-expect-error: we’ll add `end` later.
        end: void 0
      };
      siblings.push(tail);
    }
    this.stack.push(tail);
  }
  function onexitdata(token2) {
    const tail = this.stack.pop();
    tail.value += this.sliceSerialize(token2);
    tail.position.end = point$1(token2.end);
  }
  function onexitlineending(token2) {
    const context = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const tail = context.children[context.children.length - 1];
      tail.position.end = point$1(token2.end);
      this.data.atHardBreak = void 0;
      return;
    }
    if (!this.data.setextHeadingSlurpLineEnding && config2.canContainEols.includes(context.type)) {
      onenterdata.call(this, token2);
      onexitdata.call(this, token2);
    }
  }
  function onexithardbreak() {
    this.data.atHardBreak = true;
  }
  function onexithtmlflow() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.value = data2;
  }
  function onexithtmltext() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.value = data2;
  }
  function onexitcodetext() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.value = data2;
  }
  function onexitlink() {
    const node2 = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const referenceType = this.data.referenceType || "shortcut";
      node2.type += "Reference";
      node2.referenceType = referenceType;
      delete node2.url;
      delete node2.title;
    } else {
      delete node2.identifier;
      delete node2.label;
    }
    this.data.referenceType = void 0;
  }
  function onexitimage() {
    const node2 = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const referenceType = this.data.referenceType || "shortcut";
      node2.type += "Reference";
      node2.referenceType = referenceType;
      delete node2.url;
      delete node2.title;
    } else {
      delete node2.identifier;
      delete node2.label;
    }
    this.data.referenceType = void 0;
  }
  function onexitlabeltext(token2) {
    const string2 = this.sliceSerialize(token2);
    const ancestor = this.stack[this.stack.length - 2];
    ancestor.label = decodeString(string2);
    ancestor.identifier = normalizeIdentifier(string2).toLowerCase();
  }
  function onexitlabel() {
    const fragment = this.stack[this.stack.length - 1];
    const value = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    this.data.inReference = true;
    if (node2.type === "link") {
      const children = fragment.children;
      node2.children = children;
    } else {
      node2.alt = value;
    }
  }
  function onexitresourcedestinationstring() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.url = data2;
  }
  function onexitresourcetitlestring() {
    const data2 = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.title = data2;
  }
  function onexitresource() {
    this.data.inReference = void 0;
  }
  function onenterreference() {
    this.data.referenceType = "collapsed";
  }
  function onexitreferencestring(token2) {
    const label = this.resume();
    const node2 = this.stack[this.stack.length - 1];
    node2.label = label;
    node2.identifier = normalizeIdentifier(this.sliceSerialize(token2)).toLowerCase();
    this.data.referenceType = "full";
  }
  function onexitcharacterreferencemarker(token2) {
    this.data.characterReferenceType = token2.type;
  }
  function onexitcharacterreferencevalue(token2) {
    const data2 = this.sliceSerialize(token2);
    const type = this.data.characterReferenceType;
    let value;
    if (type) {
      value = decodeNumericCharacterReference(data2, type === "characterReferenceMarkerNumeric" ? 10 : 16);
      this.data.characterReferenceType = void 0;
    } else {
      const result = decodeNamedCharacterReference(data2);
      value = result;
    }
    const tail = this.stack[this.stack.length - 1];
    tail.value += value;
  }
  function onexitcharacterreference(token2) {
    const tail = this.stack.pop();
    tail.position.end = point$1(token2.end);
  }
  function onexitautolinkprotocol(token2) {
    onexitdata.call(this, token2);
    const node2 = this.stack[this.stack.length - 1];
    node2.url = this.sliceSerialize(token2);
  }
  function onexitautolinkemail(token2) {
    onexitdata.call(this, token2);
    const node2 = this.stack[this.stack.length - 1];
    node2.url = "mailto:" + this.sliceSerialize(token2);
  }
  function blockQuote2() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function codeFlow() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function codeText2() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function definition2() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function emphasis2() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function heading2() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function hardBreak2() {
    return {
      type: "break"
    };
  }
  function html2() {
    return {
      type: "html",
      value: ""
    };
  }
  function image2() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function link2() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function list2(token2) {
    return {
      type: "list",
      ordered: token2.type === "listOrdered",
      start: null,
      spread: token2._spread,
      children: []
    };
  }
  function listItem2(token2) {
    return {
      type: "listItem",
      spread: token2._spread,
      checked: null,
      children: []
    };
  }
  function paragraph2() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function strong2() {
    return {
      type: "strong",
      children: []
    };
  }
  function text2() {
    return {
      type: "text",
      value: ""
    };
  }
  function thematicBreak2() {
    return {
      type: "thematicBreak"
    };
  }
}
function point$1(d2) {
  return {
    line: d2.line,
    column: d2.column,
    offset: d2.offset
  };
}
function configure$1(combined, extensions) {
  let index2 = -1;
  while (++index2 < extensions.length) {
    const value = extensions[index2];
    if (Array.isArray(value)) {
      configure$1(combined, value);
    } else {
      extension(combined, value);
    }
  }
}
function extension(combined, extension2) {
  let key2;
  for (key2 in extension2) {
    if (own$5.call(extension2, key2)) {
      switch (key2) {
        case "canContainEols": {
          const right2 = extension2[key2];
          if (right2) {
            combined[key2].push(...right2);
          }
          break;
        }
        case "transforms": {
          const right2 = extension2[key2];
          if (right2) {
            combined[key2].push(...right2);
          }
          break;
        }
        case "enter":
        case "exit": {
          const right2 = extension2[key2];
          if (right2) {
            Object.assign(combined[key2], right2);
          }
          break;
        }
      }
    }
  }
}
function defaultOnError(left2, right2) {
  if (left2) {
    throw new Error("Cannot close `" + left2.type + "` (" + stringifyPosition({
      start: left2.start,
      end: left2.end
    }) + "): a different token (`" + right2.type + "`, " + stringifyPosition({
      start: right2.start,
      end: right2.end
    }) + ") is open");
  } else {
    throw new Error("Cannot close document, a token (`" + right2.type + "`, " + stringifyPosition({
      start: right2.start,
      end: right2.end
    }) + ") is still open");
  }
}
function ccount(value, character2) {
  const source = String(value);
  if (typeof character2 !== "string") {
    throw new TypeError("Expected character");
  }
  let count2 = 0;
  let index2 = source.indexOf(character2);
  while (index2 !== -1) {
    count2++;
    index2 = source.indexOf(character2, index2 + character2.length);
  }
  return count2;
}
function ok$1() {
}
function unreachable() {
}
function escapeStringRegexp(string2) {
  if (typeof string2 !== "string") {
    throw new TypeError("Expected a string");
  }
  return string2.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const convert = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(test) {
    if (test === null || test === void 0) {
      return ok;
    }
    if (typeof test === "function") {
      return castFactory(test);
    }
    if (typeof test === "object") {
      return Array.isArray(test) ? anyFactory(test) : propsFactory(test);
    }
    if (typeof test === "string") {
      return typeFactory(test);
    }
    throw new Error("Expected function, string, or object as test");
  }
);
function anyFactory(tests) {
  const checks2 = [];
  let index2 = -1;
  while (++index2 < tests.length) {
    checks2[index2] = convert(tests[index2]);
  }
  return castFactory(any);
  function any(...parameters) {
    let index3 = -1;
    while (++index3 < checks2.length) {
      if (checks2[index3].apply(this, parameters)) return true;
    }
    return false;
  }
}
function propsFactory(check) {
  const checkAsRecord = (
    /** @type {Record<string, unknown>} */
    check
  );
  return castFactory(all2);
  function all2(node2) {
    const nodeAsRecord = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      node2
    );
    let key2;
    for (key2 in check) {
      if (nodeAsRecord[key2] !== checkAsRecord[key2]) return false;
    }
    return true;
  }
}
function typeFactory(check) {
  return castFactory(type);
  function type(node2) {
    return node2 && node2.type === check;
  }
}
function castFactory(testFunction) {
  return check;
  function check(value, index2, parent2) {
    return Boolean(
      looksLikeANode(value) && testFunction.call(
        this,
        value,
        typeof index2 === "number" ? index2 : void 0,
        parent2 || void 0
      )
    );
  }
}
function ok() {
  return true;
}
function looksLikeANode(value) {
  return value !== null && typeof value === "object" && "type" in value;
}
function color$1(d2) {
  return d2;
}
const empty$3 = [];
const CONTINUE = true;
const EXIT = false;
const SKIP = "skip";
function visitParents(tree, test, visitor, reverse) {
  let check;
  if (typeof test === "function" && typeof visitor !== "function") {
    reverse = visitor;
    visitor = test;
  } else {
    check = test;
  }
  const is2 = convert(check);
  const step = reverse ? -1 : 1;
  factory(tree, void 0, [])();
  function factory(node2, index2, parents) {
    const value = (
      /** @type {Record<string, unknown>} */
      node2 && typeof node2 === "object" ? node2 : {}
    );
    if (typeof value.type === "string") {
      const name2 = (
        // `hast`
        typeof value.tagName === "string" ? value.tagName : (
          // `xast`
          typeof value.name === "string" ? value.name : void 0
        )
      );
      Object.defineProperty(visit2, "name", {
        value: "node (" + color$1(node2.type + (name2 ? "<" + name2 + ">" : "")) + ")"
      });
    }
    return visit2;
    function visit2() {
      let result = empty$3;
      let subresult;
      let offset3;
      let grandparents;
      if (!test || is2(node2, index2, parents[parents.length - 1] || void 0)) {
        result = toResult(visitor(node2, parents));
        if (result[0] === EXIT) {
          return result;
        }
      }
      if ("children" in node2 && node2.children) {
        const nodeAsParent = (
          /** @type {UnistParent} */
          node2
        );
        if (nodeAsParent.children && result[0] !== SKIP) {
          offset3 = (reverse ? nodeAsParent.children.length : -1) + step;
          grandparents = parents.concat(nodeAsParent);
          while (offset3 > -1 && offset3 < nodeAsParent.children.length) {
            const child = nodeAsParent.children[offset3];
            subresult = factory(child, offset3, grandparents)();
            if (subresult[0] === EXIT) {
              return subresult;
            }
            offset3 = typeof subresult[1] === "number" ? subresult[1] : offset3 + step;
          }
        }
      }
      return result;
    }
  }
}
function toResult(value) {
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === "number") {
    return [CONTINUE, value];
  }
  return value === null || value === void 0 ? empty$3 : [value];
}
function findAndReplace(tree, list2, options) {
  const settings = options || {};
  const ignored = convert(settings.ignore || []);
  const pairs = toPairs(list2);
  let pairIndex = -1;
  while (++pairIndex < pairs.length) {
    visitParents(tree, "text", visitor);
  }
  function visitor(node2, parents) {
    let index2 = -1;
    let grandparent;
    while (++index2 < parents.length) {
      const parent2 = parents[index2];
      const siblings = grandparent ? grandparent.children : void 0;
      if (ignored(
        parent2,
        siblings ? siblings.indexOf(parent2) : void 0,
        grandparent
      )) {
        return;
      }
      grandparent = parent2;
    }
    if (grandparent) {
      return handler(node2, parents);
    }
  }
  function handler(node2, parents) {
    const parent2 = parents[parents.length - 1];
    const find2 = pairs[pairIndex][0];
    const replace2 = pairs[pairIndex][1];
    let start4 = 0;
    const siblings = parent2.children;
    const index2 = siblings.indexOf(node2);
    let change = false;
    let nodes = [];
    find2.lastIndex = 0;
    let match5 = find2.exec(node2.value);
    while (match5) {
      const position4 = match5.index;
      const matchObject = {
        index: match5.index,
        input: match5.input,
        stack: [...parents, node2]
      };
      let value = replace2(...match5, matchObject);
      if (typeof value === "string") {
        value = value.length > 0 ? { type: "text", value } : void 0;
      }
      if (value === false) {
        find2.lastIndex = position4 + 1;
      } else {
        if (start4 !== position4) {
          nodes.push({
            type: "text",
            value: node2.value.slice(start4, position4)
          });
        }
        if (Array.isArray(value)) {
          nodes.push(...value);
        } else if (value) {
          nodes.push(value);
        }
        start4 = position4 + match5[0].length;
        change = true;
      }
      if (!find2.global) {
        break;
      }
      match5 = find2.exec(node2.value);
    }
    if (change) {
      if (start4 < node2.value.length) {
        nodes.push({ type: "text", value: node2.value.slice(start4) });
      }
      parent2.children.splice(index2, 1, ...nodes);
    } else {
      nodes = [node2];
    }
    return index2 + nodes.length;
  }
}
function toPairs(tupleOrList) {
  const result = [];
  if (!Array.isArray(tupleOrList)) {
    throw new TypeError("Expected find and replace tuple or list of tuples");
  }
  const list2 = !tupleOrList[0] || Array.isArray(tupleOrList[0]) ? tupleOrList : [tupleOrList];
  let index2 = -1;
  while (++index2 < list2.length) {
    const tuple = list2[index2];
    result.push([toExpression(tuple[0]), toFunction(tuple[1])]);
  }
  return result;
}
function toExpression(find2) {
  return typeof find2 === "string" ? new RegExp(escapeStringRegexp(find2), "g") : find2;
}
function toFunction(replace2) {
  return typeof replace2 === "function" ? replace2 : function() {
    return replace2;
  };
}
const inConstruct = "phrasing";
const notInConstruct = ["autolink", "link", "image", "label"];
function gfmAutolinkLiteralFromMarkdown() {
  return {
    transforms: [transformGfmAutolinkLiterals],
    enter: {
      literalAutolink: enterLiteralAutolink,
      literalAutolinkEmail: enterLiteralAutolinkValue,
      literalAutolinkHttp: enterLiteralAutolinkValue,
      literalAutolinkWww: enterLiteralAutolinkValue
    },
    exit: {
      literalAutolink: exitLiteralAutolink,
      literalAutolinkEmail: exitLiteralAutolinkEmail,
      literalAutolinkHttp: exitLiteralAutolinkHttp,
      literalAutolinkWww: exitLiteralAutolinkWww
    }
  };
}
function gfmAutolinkLiteralToMarkdown() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct,
        notInConstruct
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct,
        notInConstruct
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct,
        notInConstruct
      }
    ]
  };
}
function enterLiteralAutolink(token2) {
  this.enter({ type: "link", title: null, url: "", children: [] }, token2);
}
function enterLiteralAutolinkValue(token2) {
  this.config.enter.autolinkProtocol.call(this, token2);
}
function exitLiteralAutolinkHttp(token2) {
  this.config.exit.autolinkProtocol.call(this, token2);
}
function exitLiteralAutolinkWww(token2) {
  this.config.exit.data.call(this, token2);
  const node2 = this.stack[this.stack.length - 1];
  ok$1(node2.type === "link");
  node2.url = "http://" + this.sliceSerialize(token2);
}
function exitLiteralAutolinkEmail(token2) {
  this.config.exit.autolinkEmail.call(this, token2);
}
function exitLiteralAutolink(token2) {
  this.exit(token2);
}
function transformGfmAutolinkLiterals(tree) {
  findAndReplace(
    tree,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, findUrl],
      [new RegExp("(?<=^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"), findEmail]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function findUrl(_2, protocol, domain2, path2, match5) {
  let prefix2 = "";
  if (!previous(match5)) {
    return false;
  }
  if (/^w/i.test(protocol)) {
    domain2 = protocol + domain2;
    protocol = "";
    prefix2 = "http://";
  }
  if (!isCorrectDomain(domain2)) {
    return false;
  }
  const parts = splitUrl(domain2 + path2);
  if (!parts[0]) return false;
  const result = {
    type: "link",
    title: null,
    url: prefix2 + protocol + parts[0],
    children: [{ type: "text", value: protocol + parts[0] }]
  };
  if (parts[1]) {
    return [result, { type: "text", value: parts[1] }];
  }
  return result;
}
function findEmail(_2, atext, label, match5) {
  if (
    // Not an expected previous character.
    !previous(match5, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)
  ) {
    return false;
  }
  return {
    type: "link",
    title: null,
    url: "mailto:" + atext + "@" + label,
    children: [{ type: "text", value: atext + "@" + label }]
  };
}
function isCorrectDomain(domain2) {
  const parts = domain2.split(".");
  if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) {
    return false;
  }
  return true;
}
function splitUrl(url) {
  const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
  if (!trailExec) {
    return [url, void 0];
  }
  url = url.slice(0, trailExec.index);
  let trail2 = trailExec[0];
  let closingParenIndex = trail2.indexOf(")");
  const openingParens = ccount(url, "(");
  let closingParens = ccount(url, ")");
  while (closingParenIndex !== -1 && openingParens > closingParens) {
    url += trail2.slice(0, closingParenIndex + 1);
    trail2 = trail2.slice(closingParenIndex + 1);
    closingParenIndex = trail2.indexOf(")");
    closingParens++;
  }
  return [url, trail2];
}
function previous(match5, email) {
  const code = match5.input.charCodeAt(match5.index - 1);
  return (match5.index === 0 || unicodeWhitespace(code) || unicodePunctuation(code)) && // If it’s an email, the previous character should not be a slash.
  (!email || code !== 47);
}
footnoteReference$1.peek = footnoteReferencePeek;
function enterFootnoteCallString() {
  this.buffer();
}
function enterFootnoteCall(token2) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, token2);
}
function enterFootnoteDefinitionLabelString() {
  this.buffer();
}
function enterFootnoteDefinition(token2) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    token2
  );
}
function exitFootnoteCallString(token2) {
  const label = this.resume();
  const node2 = this.stack[this.stack.length - 1];
  ok$1(node2.type === "footnoteReference");
  node2.identifier = normalizeIdentifier(
    this.sliceSerialize(token2)
  ).toLowerCase();
  node2.label = label;
}
function exitFootnoteCall(token2) {
  this.exit(token2);
}
function exitFootnoteDefinitionLabelString(token2) {
  const label = this.resume();
  const node2 = this.stack[this.stack.length - 1];
  ok$1(node2.type === "footnoteDefinition");
  node2.identifier = normalizeIdentifier(
    this.sliceSerialize(token2)
  ).toLowerCase();
  node2.label = label;
}
function exitFootnoteDefinition(token2) {
  this.exit(token2);
}
function footnoteReferencePeek() {
  return "[";
}
function footnoteReference$1(node2, _2, state, info) {
  const tracker = state.createTracker(info);
  let value = tracker.move("[^");
  const exit2 = state.enter("footnoteReference");
  const subexit = state.enter("reference");
  value += tracker.move(
    state.safe(state.associationId(node2), { after: "]", before: value })
  );
  subexit();
  exit2();
  value += tracker.move("]");
  return value;
}
function gfmFootnoteFromMarkdown() {
  return {
    enter: {
      gfmFootnoteCallString: enterFootnoteCallString,
      gfmFootnoteCall: enterFootnoteCall,
      gfmFootnoteDefinitionLabelString: enterFootnoteDefinitionLabelString,
      gfmFootnoteDefinition: enterFootnoteDefinition
    },
    exit: {
      gfmFootnoteCallString: exitFootnoteCallString,
      gfmFootnoteCall: exitFootnoteCall,
      gfmFootnoteDefinitionLabelString: exitFootnoteDefinitionLabelString,
      gfmFootnoteDefinition: exitFootnoteDefinition
    }
  };
}
function gfmFootnoteToMarkdown(options) {
  return {
    handlers: { footnoteDefinition, footnoteReference: footnoteReference$1 },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function footnoteDefinition(node2, _2, state, info) {
    const tracker = state.createTracker(info);
    let value = tracker.move("[^");
    const exit2 = state.enter("footnoteDefinition");
    const subexit = state.enter("label");
    value += tracker.move(
      state.safe(state.associationId(node2), { before: value, after: "]" })
    );
    subexit();
    value += tracker.move("]:");
    if (node2.children && node2.children.length > 0) {
      tracker.shift(4);
      value += tracker.move(
        " " + state.indentLines(
          state.containerFlow(node2, tracker.current()),
          mapExceptFirst
        )
      );
    }
    exit2();
    return value;
  }
}
function mapExceptFirst(line2, index2, blank) {
  return index2 === 0 ? line2 : mapAll(line2, index2, blank);
}
function mapAll(line2, index2, blank) {
  return (blank ? "" : "    ") + line2;
}
const constructsWithoutStrikethrough = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
handleDelete.peek = peekDelete;
function gfmStrikethroughFromMarkdown() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: enterStrikethrough },
    exit: { strikethrough: exitStrikethrough }
  };
}
function gfmStrikethroughToMarkdown() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: constructsWithoutStrikethrough
      }
    ],
    handlers: { delete: handleDelete }
  };
}
function enterStrikethrough(token2) {
  this.enter({ type: "delete", children: [] }, token2);
}
function exitStrikethrough(token2) {
  this.exit(token2);
}
function handleDelete(node2, _2, state, info) {
  const tracker = state.createTracker(info);
  const exit2 = state.enter("strikethrough");
  let value = tracker.move("~~");
  value += state.containerPhrasing(node2, {
    ...tracker.current(),
    before: value,
    after: "~"
  });
  value += tracker.move("~~");
  exit2();
  return value;
}
function peekDelete() {
  return "~";
}
function defaultStringLength(value) {
  return value.length;
}
function markdownTable(table2, options) {
  const settings = options || {};
  const align = (settings.align || []).concat();
  const stringLength = settings.stringLength || defaultStringLength;
  const alignments = [];
  const cellMatrix = [];
  const sizeMatrix = [];
  const longestCellByColumn = [];
  let mostCellsPerRow = 0;
  let rowIndex = -1;
  while (++rowIndex < table2.length) {
    const row2 = [];
    const sizes3 = [];
    let columnIndex2 = -1;
    if (table2[rowIndex].length > mostCellsPerRow) {
      mostCellsPerRow = table2[rowIndex].length;
    }
    while (++columnIndex2 < table2[rowIndex].length) {
      const cell = serialize$2(table2[rowIndex][columnIndex2]);
      if (settings.alignDelimiters !== false) {
        const size2 = stringLength(cell);
        sizes3[columnIndex2] = size2;
        if (longestCellByColumn[columnIndex2] === void 0 || size2 > longestCellByColumn[columnIndex2]) {
          longestCellByColumn[columnIndex2] = size2;
        }
      }
      row2.push(cell);
    }
    cellMatrix[rowIndex] = row2;
    sizeMatrix[rowIndex] = sizes3;
  }
  let columnIndex = -1;
  if (typeof align === "object" && "length" in align) {
    while (++columnIndex < mostCellsPerRow) {
      alignments[columnIndex] = toAlignment(align[columnIndex]);
    }
  } else {
    const code = toAlignment(align);
    while (++columnIndex < mostCellsPerRow) {
      alignments[columnIndex] = code;
    }
  }
  columnIndex = -1;
  const row = [];
  const sizes2 = [];
  while (++columnIndex < mostCellsPerRow) {
    const code = alignments[columnIndex];
    let before = "";
    let after = "";
    if (code === 99) {
      before = ":";
      after = ":";
    } else if (code === 108) {
      before = ":";
    } else if (code === 114) {
      after = ":";
    }
    let size2 = settings.alignDelimiters === false ? 1 : Math.max(
      1,
      longestCellByColumn[columnIndex] - before.length - after.length
    );
    const cell = before + "-".repeat(size2) + after;
    if (settings.alignDelimiters !== false) {
      size2 = before.length + size2 + after.length;
      if (size2 > longestCellByColumn[columnIndex]) {
        longestCellByColumn[columnIndex] = size2;
      }
      sizes2[columnIndex] = size2;
    }
    row[columnIndex] = cell;
  }
  cellMatrix.splice(1, 0, row);
  sizeMatrix.splice(1, 0, sizes2);
  rowIndex = -1;
  const lines = [];
  while (++rowIndex < cellMatrix.length) {
    const row2 = cellMatrix[rowIndex];
    const sizes3 = sizeMatrix[rowIndex];
    columnIndex = -1;
    const line2 = [];
    while (++columnIndex < mostCellsPerRow) {
      const cell = row2[columnIndex] || "";
      let before = "";
      let after = "";
      if (settings.alignDelimiters !== false) {
        const size2 = longestCellByColumn[columnIndex] - (sizes3[columnIndex] || 0);
        const code = alignments[columnIndex];
        if (code === 114) {
          before = " ".repeat(size2);
        } else if (code === 99) {
          if (size2 % 2) {
            before = " ".repeat(size2 / 2 + 0.5);
            after = " ".repeat(size2 / 2 - 0.5);
          } else {
            before = " ".repeat(size2 / 2);
            after = before;
          }
        } else {
          after = " ".repeat(size2);
        }
      }
      if (settings.delimiterStart !== false && !columnIndex) {
        line2.push("|");
      }
      if (settings.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(settings.alignDelimiters === false && cell === "") && (settings.delimiterStart !== false || columnIndex)) {
        line2.push(" ");
      }
      if (settings.alignDelimiters !== false) {
        line2.push(before);
      }
      line2.push(cell);
      if (settings.alignDelimiters !== false) {
        line2.push(after);
      }
      if (settings.padding !== false) {
        line2.push(" ");
      }
      if (settings.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) {
        line2.push("|");
      }
    }
    lines.push(
      settings.delimiterEnd === false ? line2.join("").replace(/ +$/, "") : line2.join("")
    );
  }
  return lines.join("\n");
}
function serialize$2(value) {
  return value === null || value === void 0 ? "" : String(value);
}
function toAlignment(value) {
  const code = typeof value === "string" ? value.codePointAt(0) : 0;
  return code === 67 || code === 99 ? 99 : code === 76 || code === 108 ? 108 : code === 82 || code === 114 ? 114 : 0;
}
const own$4 = {}.hasOwnProperty;
function zwitch(key2, options) {
  const settings = options || {};
  function one2(value, ...parameters) {
    let fn2 = one2.invalid;
    const handlers2 = one2.handlers;
    if (value && own$4.call(value, key2)) {
      const id = String(value[key2]);
      fn2 = own$4.call(handlers2, id) ? handlers2[id] : one2.unknown;
    }
    if (fn2) {
      return fn2.call(this, value, ...parameters);
    }
  }
  one2.handlers = settings.handlers || {};
  one2.invalid = settings.invalid;
  one2.unknown = settings.unknown;
  return one2;
}
const own$3 = {}.hasOwnProperty;
function configure(base2, extension2) {
  let index2 = -1;
  let key2;
  if (extension2.extensions) {
    while (++index2 < extension2.extensions.length) {
      configure(base2, extension2.extensions[index2]);
    }
  }
  for (key2 in extension2) {
    if (own$3.call(extension2, key2)) {
      switch (key2) {
        case "extensions": {
          break;
        }
        /* c8 ignore next 4 */
        case "unsafe": {
          list$2(base2[key2], extension2[key2]);
          break;
        }
        case "join": {
          list$2(base2[key2], extension2[key2]);
          break;
        }
        case "handlers": {
          map$3(base2[key2], extension2[key2]);
          break;
        }
        default: {
          base2.options[key2] = extension2[key2];
        }
      }
    }
  }
  return base2;
}
function list$2(left2, right2) {
  if (right2) {
    left2.push(...right2);
  }
}
function map$3(left2, right2) {
  if (right2) {
    Object.assign(left2, right2);
  }
}
function blockquote$1(node2, _2, state, info) {
  const exit2 = state.enter("blockquote");
  const tracker = state.createTracker(info);
  tracker.move("> ");
  tracker.shift(2);
  const value = state.indentLines(
    state.containerFlow(node2, tracker.current()),
    map$2
  );
  exit2();
  return value;
}
function map$2(line2, _2, blank) {
  return ">" + (blank ? "" : " ") + line2;
}
function patternInScope(stack, pattern) {
  return listInScope(stack, pattern.inConstruct, true) && !listInScope(stack, pattern.notInConstruct, false);
}
function listInScope(stack, list2, none2) {
  if (typeof list2 === "string") {
    list2 = [list2];
  }
  if (!list2 || list2.length === 0) {
    return none2;
  }
  let index2 = -1;
  while (++index2 < list2.length) {
    if (stack.includes(list2[index2])) {
      return true;
    }
  }
  return false;
}
function hardBreak$1(_2, _1, state, info) {
  let index2 = -1;
  while (++index2 < state.unsafe.length) {
    if (state.unsafe[index2].character === "\n" && patternInScope(state.stack, state.unsafe[index2])) {
      return /[ \t]/.test(info.before) ? "" : " ";
    }
  }
  return "\\\n";
}
function longestStreak(value, substring) {
  const source = String(value);
  let index2 = source.indexOf(substring);
  let expected = index2;
  let count2 = 0;
  let max2 = 0;
  if (typeof substring !== "string") {
    throw new TypeError("Expected substring");
  }
  while (index2 !== -1) {
    if (index2 === expected) {
      if (++count2 > max2) {
        max2 = count2;
      }
    } else {
      count2 = 1;
    }
    expected = index2 + substring.length;
    index2 = source.indexOf(substring, expected);
  }
  return max2;
}
function formatCodeAsIndented(node2, state) {
  return Boolean(
    state.options.fences === false && node2.value && // If there’s no info…
    !node2.lang && // And there’s a non-whitespace character…
    /[^ \r\n]/.test(node2.value) && // And the value doesn’t start or end in a blank…
    !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node2.value)
  );
}
function checkFence(state) {
  const marker = state.options.fence || "`";
  if (marker !== "`" && marker !== "~") {
    throw new Error(
      "Cannot serialize code with `" + marker + "` for `options.fence`, expected `` ` `` or `~`"
    );
  }
  return marker;
}
function code$3(node2, _2, state, info) {
  const marker = checkFence(state);
  const raw = node2.value || "";
  const suffix2 = marker === "`" ? "GraveAccent" : "Tilde";
  if (formatCodeAsIndented(node2, state)) {
    const exit3 = state.enter("codeIndented");
    const value2 = state.indentLines(raw, map$1);
    exit3();
    return value2;
  }
  const tracker = state.createTracker(info);
  const sequence = marker.repeat(Math.max(longestStreak(raw, marker) + 1, 3));
  const exit2 = state.enter("codeFenced");
  let value = tracker.move(sequence);
  if (node2.lang) {
    const subexit = state.enter(`codeFencedLang${suffix2}`);
    value += tracker.move(
      state.safe(node2.lang, {
        before: value,
        after: " ",
        encode: ["`"],
        ...tracker.current()
      })
    );
    subexit();
  }
  if (node2.lang && node2.meta) {
    const subexit = state.enter(`codeFencedMeta${suffix2}`);
    value += tracker.move(" ");
    value += tracker.move(
      state.safe(node2.meta, {
        before: value,
        after: "\n",
        encode: ["`"],
        ...tracker.current()
      })
    );
    subexit();
  }
  value += tracker.move("\n");
  if (raw) {
    value += tracker.move(raw + "\n");
  }
  value += tracker.move(sequence);
  exit2();
  return value;
}
function map$1(line2, _2, blank) {
  return (blank ? "" : "    ") + line2;
}
function checkQuote(state) {
  const marker = state.options.quote || '"';
  if (marker !== '"' && marker !== "'") {
    throw new Error(
      "Cannot serialize title with `" + marker + "` for `options.quote`, expected `\"`, or `'`"
    );
  }
  return marker;
}
function definition(node2, _2, state, info) {
  const quote = checkQuote(state);
  const suffix2 = quote === '"' ? "Quote" : "Apostrophe";
  const exit2 = state.enter("definition");
  let subexit = state.enter("label");
  const tracker = state.createTracker(info);
  let value = tracker.move("[");
  value += tracker.move(
    state.safe(state.associationId(node2), {
      before: value,
      after: "]",
      ...tracker.current()
    })
  );
  value += tracker.move("]: ");
  subexit();
  if (
    // If there’s no url, or…
    !node2.url || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node2.url)
  ) {
    subexit = state.enter("destinationLiteral");
    value += tracker.move("<");
    value += tracker.move(
      state.safe(node2.url, { before: value, after: ">", ...tracker.current() })
    );
    value += tracker.move(">");
  } else {
    subexit = state.enter("destinationRaw");
    value += tracker.move(
      state.safe(node2.url, {
        before: value,
        after: node2.title ? " " : "\n",
        ...tracker.current()
      })
    );
  }
  subexit();
  if (node2.title) {
    subexit = state.enter(`title${suffix2}`);
    value += tracker.move(" " + quote);
    value += tracker.move(
      state.safe(node2.title, {
        before: value,
        after: quote,
        ...tracker.current()
      })
    );
    value += tracker.move(quote);
    subexit();
  }
  exit2();
  return value;
}
function checkEmphasis(state) {
  const marker = state.options.emphasis || "*";
  if (marker !== "*" && marker !== "_") {
    throw new Error(
      "Cannot serialize emphasis with `" + marker + "` for `options.emphasis`, expected `*`, or `_`"
    );
  }
  return marker;
}
function encodeCharacterReference(code) {
  return "&#x" + code.toString(16).toUpperCase() + ";";
}
function encodeInfo(outside, inside, marker) {
  const outsideKind = classifyCharacter(outside);
  const insideKind = classifyCharacter(inside);
  if (outsideKind === void 0) {
    return insideKind === void 0 ? (
      // Letter inside:
      // we have to encode *both* letters for `_` as it is looser.
      // it already forms for `*` (and GFMs `~`).
      marker === "_" ? { inside: true, outside: true } : { inside: false, outside: false }
    ) : insideKind === 1 ? (
      // Whitespace inside: encode both (letter, whitespace).
      { inside: true, outside: true }
    ) : (
      // Punctuation inside: encode outer (letter)
      { inside: false, outside: true }
    );
  }
  if (outsideKind === 1) {
    return insideKind === void 0 ? (
      // Letter inside: already forms.
      { inside: false, outside: false }
    ) : insideKind === 1 ? (
      // Whitespace inside: encode both (whitespace).
      { inside: true, outside: true }
    ) : (
      // Punctuation inside: already forms.
      { inside: false, outside: false }
    );
  }
  return insideKind === void 0 ? (
    // Letter inside: already forms.
    { inside: false, outside: false }
  ) : insideKind === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: true, outside: false }
  ) : (
    // Punctuation inside: already forms.
    { inside: false, outside: false }
  );
}
emphasis$1.peek = emphasisPeek;
function emphasis$1(node2, _2, state, info) {
  const marker = checkEmphasis(state);
  const exit2 = state.enter("emphasis");
  const tracker = state.createTracker(info);
  const before = tracker.move(marker);
  let between3 = tracker.move(
    state.containerPhrasing(node2, {
      after: marker,
      before,
      ...tracker.current()
    })
  );
  const betweenHead = between3.charCodeAt(0);
  const open = encodeInfo(
    info.before.charCodeAt(info.before.length - 1),
    betweenHead,
    marker
  );
  if (open.inside) {
    between3 = encodeCharacterReference(betweenHead) + between3.slice(1);
  }
  const betweenTail = between3.charCodeAt(between3.length - 1);
  const close2 = encodeInfo(info.after.charCodeAt(0), betweenTail, marker);
  if (close2.inside) {
    between3 = between3.slice(0, -1) + encodeCharacterReference(betweenTail);
  }
  const after = tracker.move(marker);
  exit2();
  state.attentionEncodeSurroundingInfo = {
    after: close2.outside,
    before: open.outside
  };
  return before + between3 + after;
}
function emphasisPeek(_2, _1, state) {
  return state.options.emphasis || "*";
}
function visit(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
  let reverse;
  let test;
  let visitor;
  if (typeof testOrVisitor === "function" && typeof visitorOrReverse !== "function") {
    test = void 0;
    visitor = testOrVisitor;
    reverse = visitorOrReverse;
  } else {
    test = testOrVisitor;
    visitor = visitorOrReverse;
    reverse = maybeReverse;
  }
  visitParents(tree, test, overload, reverse);
  function overload(node2, parents) {
    const parent2 = parents[parents.length - 1];
    const index2 = parent2 ? parent2.children.indexOf(node2) : void 0;
    return visitor(node2, index2, parent2);
  }
}
function formatHeadingAsSetext(node2, state) {
  let literalWithBreak = false;
  visit(node2, function(node3) {
    if ("value" in node3 && /\r?\n|\r/.test(node3.value) || node3.type === "break") {
      literalWithBreak = true;
      return EXIT;
    }
  });
  return Boolean(
    (!node2.depth || node2.depth < 3) && toString$2(node2) && (state.options.setext || literalWithBreak)
  );
}
function heading$1(node2, _2, state, info) {
  const rank = Math.max(Math.min(6, node2.depth || 1), 1);
  const tracker = state.createTracker(info);
  if (formatHeadingAsSetext(node2, state)) {
    const exit3 = state.enter("headingSetext");
    const subexit2 = state.enter("phrasing");
    const value2 = state.containerPhrasing(node2, {
      ...tracker.current(),
      before: "\n",
      after: "\n"
    });
    subexit2();
    exit3();
    return value2 + "\n" + (rank === 1 ? "=" : "-").repeat(
      // The whole size…
      value2.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(value2.lastIndexOf("\r"), value2.lastIndexOf("\n")) + 1)
    );
  }
  const sequence = "#".repeat(rank);
  const exit2 = state.enter("headingAtx");
  const subexit = state.enter("phrasing");
  tracker.move(sequence + " ");
  let value = state.containerPhrasing(node2, {
    before: "# ",
    after: "\n",
    ...tracker.current()
  });
  if (/^[\t ]/.test(value)) {
    value = encodeCharacterReference(value.charCodeAt(0)) + value.slice(1);
  }
  value = value ? sequence + " " + value : sequence;
  if (state.options.closeAtx) {
    value += " " + sequence;
  }
  subexit();
  exit2();
  return value;
}
html$3.peek = htmlPeek;
function html$3(node2) {
  return node2.value || "";
}
function htmlPeek() {
  return "<";
}
image$1.peek = imagePeek;
function image$1(node2, _2, state, info) {
  const quote = checkQuote(state);
  const suffix2 = quote === '"' ? "Quote" : "Apostrophe";
  const exit2 = state.enter("image");
  let subexit = state.enter("label");
  const tracker = state.createTracker(info);
  let value = tracker.move("![");
  value += tracker.move(
    state.safe(node2.alt, { before: value, after: "]", ...tracker.current() })
  );
  value += tracker.move("](");
  subexit();
  if (
    // If there’s no url but there is a title…
    !node2.url && node2.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node2.url)
  ) {
    subexit = state.enter("destinationLiteral");
    value += tracker.move("<");
    value += tracker.move(
      state.safe(node2.url, { before: value, after: ">", ...tracker.current() })
    );
    value += tracker.move(">");
  } else {
    subexit = state.enter("destinationRaw");
    value += tracker.move(
      state.safe(node2.url, {
        before: value,
        after: node2.title ? " " : ")",
        ...tracker.current()
      })
    );
  }
  subexit();
  if (node2.title) {
    subexit = state.enter(`title${suffix2}`);
    value += tracker.move(" " + quote);
    value += tracker.move(
      state.safe(node2.title, {
        before: value,
        after: quote,
        ...tracker.current()
      })
    );
    value += tracker.move(quote);
    subexit();
  }
  value += tracker.move(")");
  exit2();
  return value;
}
function imagePeek() {
  return "!";
}
imageReference$1.peek = imageReferencePeek;
function imageReference$1(node2, _2, state, info) {
  const type = node2.referenceType;
  const exit2 = state.enter("imageReference");
  let subexit = state.enter("label");
  const tracker = state.createTracker(info);
  let value = tracker.move("![");
  const alt = state.safe(node2.alt, {
    before: value,
    after: "]",
    ...tracker.current()
  });
  value += tracker.move(alt + "][");
  subexit();
  const stack = state.stack;
  state.stack = [];
  subexit = state.enter("reference");
  const reference = state.safe(state.associationId(node2), {
    before: value,
    after: "]",
    ...tracker.current()
  });
  subexit();
  state.stack = stack;
  exit2();
  if (type === "full" || !alt || alt !== reference) {
    value += tracker.move(reference + "]");
  } else if (type === "shortcut") {
    value = value.slice(0, -1);
  } else {
    value += tracker.move("]");
  }
  return value;
}
function imageReferencePeek() {
  return "!";
}
inlineCode$1.peek = inlineCodePeek;
function inlineCode$1(node2, _2, state) {
  let value = node2.value || "";
  let sequence = "`";
  let index2 = -1;
  while (new RegExp("(^|[^`])" + sequence + "([^`]|$)").test(value)) {
    sequence += "`";
  }
  if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) {
    value = " " + value + " ";
  }
  while (++index2 < state.unsafe.length) {
    const pattern = state.unsafe[index2];
    const expression = state.compilePattern(pattern);
    let match5;
    if (!pattern.atBreak) continue;
    while (match5 = expression.exec(value)) {
      let position4 = match5.index;
      if (value.charCodeAt(position4) === 10 && value.charCodeAt(position4 - 1) === 13) {
        position4--;
      }
      value = value.slice(0, position4) + " " + value.slice(match5.index + 1);
    }
  }
  return sequence + value + sequence;
}
function inlineCodePeek() {
  return "`";
}
function formatLinkAsAutolink(node2, state) {
  const raw = toString$2(node2);
  return Boolean(
    !state.options.resourceLink && // If there’s a url…
    node2.url && // And there’s a no title…
    !node2.title && // And the content of `node` is a single text node…
    node2.children && node2.children.length === 1 && node2.children[0].type === "text" && // And if the url is the same as the content…
    (raw === node2.url || "mailto:" + raw === node2.url) && // And that starts w/ a protocol…
    /^[a-z][a-z+.-]+:/i.test(node2.url) && // And that doesn’t contain ASCII control codes (character escapes and
    // references don’t work), space, or angle brackets…
    !/[\0- <>\u007F]/.test(node2.url)
  );
}
link$1.peek = linkPeek;
function link$1(node2, _2, state, info) {
  const quote = checkQuote(state);
  const suffix2 = quote === '"' ? "Quote" : "Apostrophe";
  const tracker = state.createTracker(info);
  let exit2;
  let subexit;
  if (formatLinkAsAutolink(node2, state)) {
    const stack = state.stack;
    state.stack = [];
    exit2 = state.enter("autolink");
    let value2 = tracker.move("<");
    value2 += tracker.move(
      state.containerPhrasing(node2, {
        before: value2,
        after: ">",
        ...tracker.current()
      })
    );
    value2 += tracker.move(">");
    exit2();
    state.stack = stack;
    return value2;
  }
  exit2 = state.enter("link");
  subexit = state.enter("label");
  let value = tracker.move("[");
  value += tracker.move(
    state.containerPhrasing(node2, {
      before: value,
      after: "](",
      ...tracker.current()
    })
  );
  value += tracker.move("](");
  subexit();
  if (
    // If there’s no url but there is a title…
    !node2.url && node2.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node2.url)
  ) {
    subexit = state.enter("destinationLiteral");
    value += tracker.move("<");
    value += tracker.move(
      state.safe(node2.url, { before: value, after: ">", ...tracker.current() })
    );
    value += tracker.move(">");
  } else {
    subexit = state.enter("destinationRaw");
    value += tracker.move(
      state.safe(node2.url, {
        before: value,
        after: node2.title ? " " : ")",
        ...tracker.current()
      })
    );
  }
  subexit();
  if (node2.title) {
    subexit = state.enter(`title${suffix2}`);
    value += tracker.move(" " + quote);
    value += tracker.move(
      state.safe(node2.title, {
        before: value,
        after: quote,
        ...tracker.current()
      })
    );
    value += tracker.move(quote);
    subexit();
  }
  value += tracker.move(")");
  exit2();
  return value;
}
function linkPeek(node2, _2, state) {
  return formatLinkAsAutolink(node2, state) ? "<" : "[";
}
linkReference$1.peek = linkReferencePeek;
function linkReference$1(node2, _2, state, info) {
  const type = node2.referenceType;
  const exit2 = state.enter("linkReference");
  let subexit = state.enter("label");
  const tracker = state.createTracker(info);
  let value = tracker.move("[");
  const text2 = state.containerPhrasing(node2, {
    before: value,
    after: "]",
    ...tracker.current()
  });
  value += tracker.move(text2 + "][");
  subexit();
  const stack = state.stack;
  state.stack = [];
  subexit = state.enter("reference");
  const reference = state.safe(state.associationId(node2), {
    before: value,
    after: "]",
    ...tracker.current()
  });
  subexit();
  state.stack = stack;
  exit2();
  if (type === "full" || !text2 || text2 !== reference) {
    value += tracker.move(reference + "]");
  } else if (type === "shortcut") {
    value = value.slice(0, -1);
  } else {
    value += tracker.move("]");
  }
  return value;
}
function linkReferencePeek() {
  return "[";
}
function checkBullet(state) {
  const marker = state.options.bullet || "*";
  if (marker !== "*" && marker !== "+" && marker !== "-") {
    throw new Error(
      "Cannot serialize items with `" + marker + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  }
  return marker;
}
function checkBulletOther(state) {
  const bullet2 = checkBullet(state);
  const bulletOther = state.options.bulletOther;
  if (!bulletOther) {
    return bullet2 === "*" ? "-" : "*";
  }
  if (bulletOther !== "*" && bulletOther !== "+" && bulletOther !== "-") {
    throw new Error(
      "Cannot serialize items with `" + bulletOther + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  }
  if (bulletOther === bullet2) {
    throw new Error(
      "Expected `bullet` (`" + bullet2 + "`) and `bulletOther` (`" + bulletOther + "`) to be different"
    );
  }
  return bulletOther;
}
function checkBulletOrdered(state) {
  const marker = state.options.bulletOrdered || ".";
  if (marker !== "." && marker !== ")") {
    throw new Error(
      "Cannot serialize items with `" + marker + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  }
  return marker;
}
function checkRule(state) {
  const marker = state.options.rule || "*";
  if (marker !== "*" && marker !== "-" && marker !== "_") {
    throw new Error(
      "Cannot serialize rules with `" + marker + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  }
  return marker;
}
function list$1(node2, parent2, state, info) {
  const exit2 = state.enter("list");
  const bulletCurrent = state.bulletCurrent;
  let bullet2 = node2.ordered ? checkBulletOrdered(state) : checkBullet(state);
  const bulletOther = node2.ordered ? bullet2 === "." ? ")" : "." : checkBulletOther(state);
  let useDifferentMarker = parent2 && state.bulletLastUsed ? bullet2 === state.bulletLastUsed : false;
  if (!node2.ordered) {
    const firstListItem = node2.children ? node2.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (bullet2 === "*" || bullet2 === "-") && // Empty first list item:
      firstListItem && (!firstListItem.children || !firstListItem.children[0]) && // Directly in two other list items:
      state.stack[state.stack.length - 1] === "list" && state.stack[state.stack.length - 2] === "listItem" && state.stack[state.stack.length - 3] === "list" && state.stack[state.stack.length - 4] === "listItem" && // That are each the first child.
      state.indexStack[state.indexStack.length - 1] === 0 && state.indexStack[state.indexStack.length - 2] === 0 && state.indexStack[state.indexStack.length - 3] === 0
    ) {
      useDifferentMarker = true;
    }
    if (checkRule(state) === bullet2 && firstListItem) {
      let index2 = -1;
      while (++index2 < node2.children.length) {
        const item = node2.children[index2];
        if (item && item.type === "listItem" && item.children && item.children[0] && item.children[0].type === "thematicBreak") {
          useDifferentMarker = true;
          break;
        }
      }
    }
  }
  if (useDifferentMarker) {
    bullet2 = bulletOther;
  }
  state.bulletCurrent = bullet2;
  const value = state.containerFlow(node2, info);
  state.bulletLastUsed = bullet2;
  state.bulletCurrent = bulletCurrent;
  exit2();
  return value;
}
function checkListItemIndent(state) {
  const style3 = state.options.listItemIndent || "one";
  if (style3 !== "tab" && style3 !== "one" && style3 !== "mixed") {
    throw new Error(
      "Cannot serialize items with `" + style3 + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  }
  return style3;
}
function listItem$1(node2, parent2, state, info) {
  const listItemIndent = checkListItemIndent(state);
  let bullet2 = state.bulletCurrent || checkBullet(state);
  if (parent2 && parent2.type === "list" && parent2.ordered) {
    bullet2 = (typeof parent2.start === "number" && parent2.start > -1 ? parent2.start : 1) + (state.options.incrementListMarker === false ? 0 : parent2.children.indexOf(node2)) + bullet2;
  }
  let size2 = bullet2.length + 1;
  if (listItemIndent === "tab" || listItemIndent === "mixed" && (parent2 && parent2.type === "list" && parent2.spread || node2.spread)) {
    size2 = Math.ceil(size2 / 4) * 4;
  }
  const tracker = state.createTracker(info);
  tracker.move(bullet2 + " ".repeat(size2 - bullet2.length));
  tracker.shift(size2);
  const exit2 = state.enter("listItem");
  const value = state.indentLines(
    state.containerFlow(node2, tracker.current()),
    map3
  );
  exit2();
  return value;
  function map3(line2, index2, blank) {
    if (index2) {
      return (blank ? "" : " ".repeat(size2)) + line2;
    }
    return (blank ? bullet2 : bullet2 + " ".repeat(size2 - bullet2.length)) + line2;
  }
}
function paragraph$1(node2, _2, state, info) {
  const exit2 = state.enter("paragraph");
  const subexit = state.enter("phrasing");
  const value = state.containerPhrasing(node2, info);
  subexit();
  exit2();
  return value;
}
const phrasing = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  convert([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function root$2(node2, _2, state, info) {
  const hasPhrasing = node2.children.some(function(d2) {
    return phrasing(d2);
  });
  const container = hasPhrasing ? state.containerPhrasing : state.containerFlow;
  return container.call(state, node2, info);
}
function checkStrong(state) {
  const marker = state.options.strong || "*";
  if (marker !== "*" && marker !== "_") {
    throw new Error(
      "Cannot serialize strong with `" + marker + "` for `options.strong`, expected `*`, or `_`"
    );
  }
  return marker;
}
strong$1.peek = strongPeek;
function strong$1(node2, _2, state, info) {
  const marker = checkStrong(state);
  const exit2 = state.enter("strong");
  const tracker = state.createTracker(info);
  const before = tracker.move(marker + marker);
  let between3 = tracker.move(
    state.containerPhrasing(node2, {
      after: marker,
      before,
      ...tracker.current()
    })
  );
  const betweenHead = between3.charCodeAt(0);
  const open = encodeInfo(
    info.before.charCodeAt(info.before.length - 1),
    betweenHead,
    marker
  );
  if (open.inside) {
    between3 = encodeCharacterReference(betweenHead) + between3.slice(1);
  }
  const betweenTail = between3.charCodeAt(between3.length - 1);
  const close2 = encodeInfo(info.after.charCodeAt(0), betweenTail, marker);
  if (close2.inside) {
    between3 = between3.slice(0, -1) + encodeCharacterReference(betweenTail);
  }
  const after = tracker.move(marker + marker);
  exit2();
  state.attentionEncodeSurroundingInfo = {
    after: close2.outside,
    before: open.outside
  };
  return before + between3 + after;
}
function strongPeek(_2, _1, state) {
  return state.options.strong || "*";
}
function text$3(node2, _2, state, info) {
  return state.safe(node2.value, info);
}
function checkRuleRepetition(state) {
  const repetition = state.options.ruleRepetition || 3;
  if (repetition < 3) {
    throw new Error(
      "Cannot serialize rules with repetition `" + repetition + "` for `options.ruleRepetition`, expected `3` or more"
    );
  }
  return repetition;
}
function thematicBreak$1(_2, _1, state) {
  const value = (checkRule(state) + (state.options.ruleSpaces ? " " : "")).repeat(checkRuleRepetition(state));
  return state.options.ruleSpaces ? value.slice(0, -1) : value;
}
const handle = {
  blockquote: blockquote$1,
  break: hardBreak$1,
  code: code$3,
  definition,
  emphasis: emphasis$1,
  hardBreak: hardBreak$1,
  heading: heading$1,
  html: html$3,
  image: image$1,
  imageReference: imageReference$1,
  inlineCode: inlineCode$1,
  link: link$1,
  linkReference: linkReference$1,
  list: list$1,
  listItem: listItem$1,
  paragraph: paragraph$1,
  root: root$2,
  strong: strong$1,
  text: text$3,
  thematicBreak: thematicBreak$1
};
const join$2 = [joinDefaults];
function joinDefaults(left2, right2, parent2, state) {
  if (right2.type === "code" && formatCodeAsIndented(right2, state) && (left2.type === "list" || left2.type === right2.type && formatCodeAsIndented(left2, state))) {
    return false;
  }
  if ("spread" in parent2 && typeof parent2.spread === "boolean") {
    if (left2.type === "paragraph" && // Two paragraphs.
    (left2.type === right2.type || right2.type === "definition" || // Paragraph followed by a setext heading.
    right2.type === "heading" && formatHeadingAsSetext(right2, state))) {
      return;
    }
    return parent2.spread ? 1 : 0;
  }
}
const fullPhrasingSpans = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
const unsafe = [
  { character: "	", after: "[\\r\\n]", inConstruct: "phrasing" },
  { character: "	", before: "[\\r\\n]", inConstruct: "phrasing" },
  {
    character: "	",
    inConstruct: ["codeFencedLangGraveAccent", "codeFencedLangTilde"]
  },
  {
    character: "\r",
    inConstruct: [
      "codeFencedLangGraveAccent",
      "codeFencedLangTilde",
      "codeFencedMetaGraveAccent",
      "codeFencedMetaTilde",
      "destinationLiteral",
      "headingAtx"
    ]
  },
  {
    character: "\n",
    inConstruct: [
      "codeFencedLangGraveAccent",
      "codeFencedLangTilde",
      "codeFencedMetaGraveAccent",
      "codeFencedMetaTilde",
      "destinationLiteral",
      "headingAtx"
    ]
  },
  { character: " ", after: "[\\r\\n]", inConstruct: "phrasing" },
  { character: " ", before: "[\\r\\n]", inConstruct: "phrasing" },
  {
    character: " ",
    inConstruct: ["codeFencedLangGraveAccent", "codeFencedLangTilde"]
  },
  // An exclamation mark can start an image, if it is followed by a link or
  // a link reference.
  {
    character: "!",
    after: "\\[",
    inConstruct: "phrasing",
    notInConstruct: fullPhrasingSpans
  },
  // A quote can break out of a title.
  { character: '"', inConstruct: "titleQuote" },
  // A number sign could start an ATX heading if it starts a line.
  { atBreak: true, character: "#" },
  { character: "#", inConstruct: "headingAtx", after: "(?:[\r\n]|$)" },
  // Dollar sign and percentage are not used in markdown.
  // An ampersand could start a character reference.
  { character: "&", after: "[#A-Za-z]", inConstruct: "phrasing" },
  // An apostrophe can break out of a title.
  { character: "'", inConstruct: "titleApostrophe" },
  // A left paren could break out of a destination raw.
  { character: "(", inConstruct: "destinationRaw" },
  // A left paren followed by `]` could make something into a link or image.
  {
    before: "\\]",
    character: "(",
    inConstruct: "phrasing",
    notInConstruct: fullPhrasingSpans
  },
  // A right paren could start a list item or break out of a destination
  // raw.
  { atBreak: true, before: "\\d+", character: ")" },
  { character: ")", inConstruct: "destinationRaw" },
  // An asterisk can start thematic breaks, list items, emphasis, strong.
  { atBreak: true, character: "*", after: "(?:[ 	\r\n*])" },
  { character: "*", inConstruct: "phrasing", notInConstruct: fullPhrasingSpans },
  // A plus sign could start a list item.
  { atBreak: true, character: "+", after: "(?:[ 	\r\n])" },
  // A dash can start thematic breaks, list items, and setext heading
  // underlines.
  { atBreak: true, character: "-", after: "(?:[ 	\r\n-])" },
  // A dot could start a list item.
  { atBreak: true, before: "\\d+", character: ".", after: "(?:[ 	\r\n]|$)" },
  // Slash, colon, and semicolon are not used in markdown for constructs.
  // A less than can start html (flow or text) or an autolink.
  // HTML could start with an exclamation mark (declaration, cdata, comment),
  // slash (closing tag), question mark (instruction), or a letter (tag).
  // An autolink also starts with a letter.
  // Finally, it could break out of a destination literal.
  { atBreak: true, character: "<", after: "[!/?A-Za-z]" },
  {
    character: "<",
    after: "[!/?A-Za-z]",
    inConstruct: "phrasing",
    notInConstruct: fullPhrasingSpans
  },
  { character: "<", inConstruct: "destinationLiteral" },
  // An equals to can start setext heading underlines.
  { atBreak: true, character: "=" },
  // A greater than can start block quotes and it can break out of a
  // destination literal.
  { atBreak: true, character: ">" },
  { character: ">", inConstruct: "destinationLiteral" },
  // Question mark and at sign are not used in markdown for constructs.
  // A left bracket can start definitions, references, labels,
  { atBreak: true, character: "[" },
  { character: "[", inConstruct: "phrasing", notInConstruct: fullPhrasingSpans },
  { character: "[", inConstruct: ["label", "reference"] },
  // A backslash can start an escape (when followed by punctuation) or a
  // hard break (when followed by an eol).
  // Note: typical escapes are handled in `safe`!
  { character: "\\", after: "[\\r\\n]", inConstruct: "phrasing" },
  // A right bracket can exit labels.
  { character: "]", inConstruct: ["label", "reference"] },
  // Caret is not used in markdown for constructs.
  // An underscore can start emphasis, strong, or a thematic break.
  { atBreak: true, character: "_" },
  { character: "_", inConstruct: "phrasing", notInConstruct: fullPhrasingSpans },
  // A grave accent can start code (fenced or text), or it can break out of
  // a grave accent code fence.
  { atBreak: true, character: "`" },
  {
    character: "`",
    inConstruct: ["codeFencedLangGraveAccent", "codeFencedMetaGraveAccent"]
  },
  { character: "`", inConstruct: "phrasing", notInConstruct: fullPhrasingSpans },
  // Left brace, vertical bar, right brace are not used in markdown for
  // constructs.
  // A tilde can start code (fenced).
  { atBreak: true, character: "~" }
];
function association(node2) {
  if (node2.label || !node2.identifier) {
    return node2.label || "";
  }
  return decodeString(node2.identifier);
}
function compilePattern(pattern) {
  if (!pattern._compiled) {
    const before = (pattern.atBreak ? "[\\r\\n][\\t ]*" : "") + (pattern.before ? "(?:" + pattern.before + ")" : "");
    pattern._compiled = new RegExp(
      (before ? "(" + before + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? "\\" : "") + pattern.character + (pattern.after ? "(?:" + pattern.after + ")" : ""),
      "g"
    );
  }
  return pattern._compiled;
}
function containerPhrasing(parent2, state, info) {
  const indexStack = state.indexStack;
  const children = parent2.children || [];
  const results = [];
  let index2 = -1;
  let before = info.before;
  let encodeAfter;
  indexStack.push(-1);
  let tracker = state.createTracker(info);
  while (++index2 < children.length) {
    const child = children[index2];
    let after;
    indexStack[indexStack.length - 1] = index2;
    if (index2 + 1 < children.length) {
      let handle2 = state.handle.handlers[children[index2 + 1].type];
      if (handle2 && handle2.peek) handle2 = handle2.peek;
      after = handle2 ? handle2(children[index2 + 1], parent2, state, {
        before: "",
        after: "",
        ...tracker.current()
      }).charAt(0) : "";
    } else {
      after = info.after;
    }
    if (results.length > 0 && (before === "\r" || before === "\n") && child.type === "html") {
      results[results.length - 1] = results[results.length - 1].replace(
        /(\r?\n|\r)$/,
        " "
      );
      before = " ";
      tracker = state.createTracker(info);
      tracker.move(results.join(""));
    }
    let value = state.handle(child, parent2, state, {
      ...tracker.current(),
      after,
      before
    });
    if (encodeAfter && encodeAfter === value.slice(0, 1)) {
      value = encodeCharacterReference(encodeAfter.charCodeAt(0)) + value.slice(1);
    }
    const encodingInfo = state.attentionEncodeSurroundingInfo;
    state.attentionEncodeSurroundingInfo = void 0;
    encodeAfter = void 0;
    if (encodingInfo) {
      if (results.length > 0 && encodingInfo.before && before === results[results.length - 1].slice(-1)) {
        results[results.length - 1] = results[results.length - 1].slice(0, -1) + encodeCharacterReference(before.charCodeAt(0));
      }
      if (encodingInfo.after) encodeAfter = after;
    }
    tracker.move(value);
    results.push(value);
    before = value.slice(-1);
  }
  indexStack.pop();
  return results.join("");
}
function containerFlow(parent2, state, info) {
  const indexStack = state.indexStack;
  const children = parent2.children || [];
  const tracker = state.createTracker(info);
  const results = [];
  let index2 = -1;
  indexStack.push(-1);
  while (++index2 < children.length) {
    const child = children[index2];
    indexStack[indexStack.length - 1] = index2;
    results.push(
      tracker.move(
        state.handle(child, parent2, state, {
          before: "\n",
          after: "\n",
          ...tracker.current()
        })
      )
    );
    if (child.type !== "list") {
      state.bulletLastUsed = void 0;
    }
    if (index2 < children.length - 1) {
      results.push(
        tracker.move(between$1(child, children[index2 + 1], parent2, state))
      );
    }
  }
  indexStack.pop();
  return results.join("");
}
function between$1(left2, right2, parent2, state) {
  let index2 = state.join.length;
  while (index2--) {
    const result = state.join[index2](left2, right2, parent2, state);
    if (result === true || result === 1) {
      break;
    }
    if (typeof result === "number") {
      return "\n".repeat(1 + result);
    }
    if (result === false) {
      return "\n\n<!---->\n\n";
    }
  }
  return "\n\n";
}
const eol = /\r?\n|\r/g;
function indentLines(value, map3) {
  const result = [];
  let start4 = 0;
  let line2 = 0;
  let match5;
  while (match5 = eol.exec(value)) {
    one2(value.slice(start4, match5.index));
    result.push(match5[0]);
    start4 = match5.index + match5[0].length;
    line2++;
  }
  one2(value.slice(start4));
  return result.join("");
  function one2(value2) {
    result.push(map3(value2, line2, !value2));
  }
}
function safe(state, input, config2) {
  const value = (config2.before || "") + (input || "") + (config2.after || "");
  const positions = [];
  const result = [];
  const infos = {};
  let index2 = -1;
  while (++index2 < state.unsafe.length) {
    const pattern = state.unsafe[index2];
    if (!patternInScope(state.stack, pattern)) {
      continue;
    }
    const expression = state.compilePattern(pattern);
    let match5;
    while (match5 = expression.exec(value)) {
      const before = "before" in pattern || Boolean(pattern.atBreak);
      const after = "after" in pattern;
      const position4 = match5.index + (before ? match5[1].length : 0);
      if (positions.includes(position4)) {
        if (infos[position4].before && !before) {
          infos[position4].before = false;
        }
        if (infos[position4].after && !after) {
          infos[position4].after = false;
        }
      } else {
        positions.push(position4);
        infos[position4] = { before, after };
      }
    }
  }
  positions.sort(numerical);
  let start4 = config2.before ? config2.before.length : 0;
  const end2 = value.length - (config2.after ? config2.after.length : 0);
  index2 = -1;
  while (++index2 < positions.length) {
    const position4 = positions[index2];
    if (position4 < start4 || position4 >= end2) {
      continue;
    }
    if (position4 + 1 < end2 && positions[index2 + 1] === position4 + 1 && infos[position4].after && !infos[position4 + 1].before && !infos[position4 + 1].after || positions[index2 - 1] === position4 - 1 && infos[position4].before && !infos[position4 - 1].before && !infos[position4 - 1].after) {
      continue;
    }
    if (start4 !== position4) {
      result.push(escapeBackslashes(value.slice(start4, position4), "\\"));
    }
    start4 = position4;
    if (/[!-/:-@[-`{-~]/.test(value.charAt(position4)) && (!config2.encode || !config2.encode.includes(value.charAt(position4)))) {
      result.push("\\");
    } else {
      result.push(encodeCharacterReference(value.charCodeAt(position4)));
      start4++;
    }
  }
  result.push(escapeBackslashes(value.slice(start4, end2), config2.after));
  return result.join("");
}
function numerical(a2, b2) {
  return a2 - b2;
}
function escapeBackslashes(value, after) {
  const expression = /\\(?=[!-/:-@[-`{-~])/g;
  const positions = [];
  const results = [];
  const whole = value + after;
  let index2 = -1;
  let start4 = 0;
  let match5;
  while (match5 = expression.exec(whole)) {
    positions.push(match5.index);
  }
  while (++index2 < positions.length) {
    if (start4 !== positions[index2]) {
      results.push(value.slice(start4, positions[index2]));
    }
    results.push("\\");
    start4 = positions[index2];
  }
  results.push(value.slice(start4));
  return results.join("");
}
function track(config2) {
  const options = config2 || {};
  const now2 = options.now || {};
  let lineShift = options.lineShift || 0;
  let line2 = now2.line || 1;
  let column2 = now2.column || 1;
  return { move: move4, current, shift: shift3 };
  function current() {
    return { now: { line: line2, column: column2 }, lineShift };
  }
  function shift3(value) {
    lineShift += value;
  }
  function move4(input) {
    const value = input || "";
    const chunks = value.split(/\r?\n|\r/g);
    const tail = chunks[chunks.length - 1];
    line2 += chunks.length - 1;
    column2 = chunks.length === 1 ? column2 + tail.length : 1 + tail.length + lineShift;
    return value;
  }
}
function toMarkdown(tree, options) {
  const settings = options || {};
  const state = {
    associationId: association,
    containerPhrasing: containerPhrasingBound,
    containerFlow: containerFlowBound,
    createTracker: track,
    compilePattern,
    enter: enter2,
    // @ts-expect-error: GFM / frontmatter are typed in `mdast` but not defined
    // here.
    handlers: { ...handle },
    // @ts-expect-error: add `handle` in a second.
    handle: void 0,
    indentLines,
    indexStack: [],
    join: [...join$2],
    options: {},
    safe: safeBound,
    stack: [],
    unsafe: [...unsafe]
  };
  configure(state, settings);
  if (state.options.tightDefinitions) {
    state.join.push(joinDefinition);
  }
  state.handle = zwitch("type", {
    invalid,
    unknown,
    handlers: state.handlers
  });
  let result = state.handle(tree, void 0, state, {
    before: "\n",
    after: "\n",
    now: { line: 1, column: 1 },
    lineShift: 0
  });
  if (result && result.charCodeAt(result.length - 1) !== 10 && result.charCodeAt(result.length - 1) !== 13) {
    result += "\n";
  }
  return result;
  function enter2(name2) {
    state.stack.push(name2);
    return exit2;
    function exit2() {
      state.stack.pop();
    }
  }
}
function invalid(value) {
  throw new Error("Cannot handle value `" + value + "`, expected node");
}
function unknown(value) {
  const node2 = (
    /** @type {Nodes} */
    value
  );
  throw new Error("Cannot handle unknown node `" + node2.type + "`");
}
function joinDefinition(left2, right2) {
  if (left2.type === "definition" && left2.type === right2.type) {
    return 0;
  }
}
function containerPhrasingBound(parent2, info) {
  return containerPhrasing(parent2, this, info);
}
function containerFlowBound(parent2, info) {
  return containerFlow(parent2, this, info);
}
function safeBound(value, config2) {
  return safe(this, value, config2);
}
function gfmTableFromMarkdown() {
  return {
    enter: {
      table: enterTable,
      tableData: enterCell,
      tableHeader: enterCell,
      tableRow: enterRow
    },
    exit: {
      codeText: exitCodeText,
      table: exitTable,
      tableData: exit,
      tableHeader: exit,
      tableRow: exit
    }
  };
}
function enterTable(token2) {
  const align = token2._align;
  this.enter(
    {
      type: "table",
      align: align.map(function(d2) {
        return d2 === "none" ? null : d2;
      }),
      children: []
    },
    token2
  );
  this.data.inTable = true;
}
function exitTable(token2) {
  this.exit(token2);
  this.data.inTable = void 0;
}
function enterRow(token2) {
  this.enter({ type: "tableRow", children: [] }, token2);
}
function exit(token2) {
  this.exit(token2);
}
function enterCell(token2) {
  this.enter({ type: "tableCell", children: [] }, token2);
}
function exitCodeText(token2) {
  let value = this.resume();
  if (this.data.inTable) {
    value = value.replace(/\\([\\|])/g, replace$1);
  }
  const node2 = this.stack[this.stack.length - 1];
  ok$1(node2.type === "inlineCode");
  node2.value = value;
  this.exit(token2);
}
function replace$1($0, $1) {
  return $1 === "|" ? $1 : $0;
}
function gfmTableToMarkdown(options) {
  const settings = {};
  const padding2 = settings.tableCellPadding;
  const alignDelimiters = settings.tablePipeAlign;
  const stringLength = settings.stringLength;
  const around = padding2 ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: "\n", inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: true, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: true, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: true, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: inlineCodeWithTable,
      table: handleTable,
      tableCell: handleTableCell,
      tableRow: handleTableRow
    }
  };
  function handleTable(node2, _2, state, info) {
    return serializeData(handleTableAsData(node2, state, info), node2.align);
  }
  function handleTableRow(node2, _2, state, info) {
    const row = handleTableRowAsData(node2, state, info);
    const value = serializeData([row]);
    return value.slice(0, value.indexOf("\n"));
  }
  function handleTableCell(node2, _2, state, info) {
    const exit2 = state.enter("tableCell");
    const subexit = state.enter("phrasing");
    const value = state.containerPhrasing(node2, {
      ...info,
      before: around,
      after: around
    });
    subexit();
    exit2();
    return value;
  }
  function serializeData(matrix, align) {
    return markdownTable(matrix, {
      align,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: padding2,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength
    });
  }
  function handleTableAsData(node2, state, info) {
    const children = node2.children;
    let index2 = -1;
    const result = [];
    const subexit = state.enter("table");
    while (++index2 < children.length) {
      result[index2] = handleTableRowAsData(children[index2], state, info);
    }
    subexit();
    return result;
  }
  function handleTableRowAsData(node2, state, info) {
    const children = node2.children;
    let index2 = -1;
    const result = [];
    const subexit = state.enter("tableRow");
    while (++index2 < children.length) {
      result[index2] = handleTableCell(children[index2], node2, state, info);
    }
    subexit();
    return result;
  }
  function inlineCodeWithTable(node2, parent2, state) {
    let value = handle.inlineCode(node2, parent2, state);
    if (state.stack.includes("tableCell")) {
      value = value.replace(/\|/g, "\\$&");
    }
    return value;
  }
}
function gfmTaskListItemFromMarkdown() {
  return {
    exit: {
      taskListCheckValueChecked: exitCheck,
      taskListCheckValueUnchecked: exitCheck,
      paragraph: exitParagraphWithTaskListItem
    }
  };
}
function gfmTaskListItemToMarkdown() {
  return {
    unsafe: [{ atBreak: true, character: "-", after: "[:|-]" }],
    handlers: { listItem: listItemWithTaskListItem }
  };
}
function exitCheck(token2) {
  const node2 = this.stack[this.stack.length - 2];
  ok$1(node2.type === "listItem");
  node2.checked = token2.type === "taskListCheckValueChecked";
}
function exitParagraphWithTaskListItem(token2) {
  const parent2 = this.stack[this.stack.length - 2];
  if (parent2 && parent2.type === "listItem" && typeof parent2.checked === "boolean") {
    const node2 = this.stack[this.stack.length - 1];
    ok$1(node2.type === "paragraph");
    const head = node2.children[0];
    if (head && head.type === "text") {
      const siblings = parent2.children;
      let index2 = -1;
      let firstParaghraph;
      while (++index2 < siblings.length) {
        const sibling = siblings[index2];
        if (sibling.type === "paragraph") {
          firstParaghraph = sibling;
          break;
        }
      }
      if (firstParaghraph === node2) {
        head.value = head.value.slice(1);
        if (head.value.length === 0) {
          node2.children.shift();
        } else if (node2.position && head.position && typeof head.position.start.offset === "number") {
          head.position.start.column++;
          head.position.start.offset++;
          node2.position.start = Object.assign({}, head.position.start);
        }
      }
    }
  }
  this.exit(token2);
}
function listItemWithTaskListItem(node2, parent2, state, info) {
  const head = node2.children[0];
  const checkable = typeof node2.checked === "boolean" && head && head.type === "paragraph";
  const checkbox = "[" + (node2.checked ? "x" : " ") + "] ";
  const tracker = state.createTracker(info);
  if (checkable) {
    tracker.move(checkbox);
  }
  let value = handle.listItem(node2, parent2, state, {
    ...info,
    ...tracker.current()
  });
  if (checkable) {
    value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
  }
  return value;
  function check($0) {
    return $0 + checkbox;
  }
}
function gfmFromMarkdown() {
  return [
    gfmAutolinkLiteralFromMarkdown(),
    gfmFootnoteFromMarkdown(),
    gfmStrikethroughFromMarkdown(),
    gfmTableFromMarkdown(),
    gfmTaskListItemFromMarkdown()
  ];
}
function gfmToMarkdown(options) {
  return {
    extensions: [
      gfmAutolinkLiteralToMarkdown(),
      gfmFootnoteToMarkdown(),
      gfmStrikethroughToMarkdown(),
      gfmTableToMarkdown(),
      gfmTaskListItemToMarkdown()
    ]
  };
}
const wwwPrefix = {
  tokenize: tokenizeWwwPrefix,
  partial: true
};
const domain$1 = {
  tokenize: tokenizeDomain,
  partial: true
};
const path = {
  tokenize: tokenizePath,
  partial: true
};
const trail = {
  tokenize: tokenizeTrail,
  partial: true
};
const emailDomainDotTrail = {
  tokenize: tokenizeEmailDomainDotTrail,
  partial: true
};
const wwwAutolink = {
  name: "wwwAutolink",
  tokenize: tokenizeWwwAutolink,
  previous: previousWww
};
const protocolAutolink = {
  name: "protocolAutolink",
  tokenize: tokenizeProtocolAutolink,
  previous: previousProtocol
};
const emailAutolink = {
  name: "emailAutolink",
  tokenize: tokenizeEmailAutolink,
  previous: previousEmail
};
const text$2 = {};
function gfmAutolinkLiteral() {
  return {
    text: text$2
  };
}
let code$2 = 48;
while (code$2 < 123) {
  text$2[code$2] = emailAutolink;
  code$2++;
  if (code$2 === 58) code$2 = 65;
  else if (code$2 === 91) code$2 = 97;
}
text$2[43] = emailAutolink;
text$2[45] = emailAutolink;
text$2[46] = emailAutolink;
text$2[95] = emailAutolink;
text$2[72] = [emailAutolink, protocolAutolink];
text$2[104] = [emailAutolink, protocolAutolink];
text$2[87] = [emailAutolink, wwwAutolink];
text$2[119] = [emailAutolink, wwwAutolink];
function tokenizeEmailAutolink(effects, ok2, nok) {
  const self2 = this;
  let dot;
  let data;
  return start4;
  function start4(code) {
    if (!gfmAtext(code) || !previousEmail.call(self2, self2.previous) || previousUnbalanced(self2.events)) {
      return nok(code);
    }
    effects.enter("literalAutolink");
    effects.enter("literalAutolinkEmail");
    return atext(code);
  }
  function atext(code) {
    if (gfmAtext(code)) {
      effects.consume(code);
      return atext;
    }
    if (code === 64) {
      effects.consume(code);
      return emailDomain;
    }
    return nok(code);
  }
  function emailDomain(code) {
    if (code === 46) {
      return effects.check(emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
    }
    if (code === 45 || code === 95 || asciiAlphanumeric(code)) {
      data = true;
      effects.consume(code);
      return emailDomain;
    }
    return emailDomainAfter(code);
  }
  function emailDomainDot(code) {
    effects.consume(code);
    dot = true;
    return emailDomain;
  }
  function emailDomainAfter(code) {
    if (data && dot && asciiAlpha(self2.previous)) {
      effects.exit("literalAutolinkEmail");
      effects.exit("literalAutolink");
      return ok2(code);
    }
    return nok(code);
  }
}
function tokenizeWwwAutolink(effects, ok2, nok) {
  const self2 = this;
  return wwwStart;
  function wwwStart(code) {
    if (code !== 87 && code !== 119 || !previousWww.call(self2, self2.previous) || previousUnbalanced(self2.events)) {
      return nok(code);
    }
    effects.enter("literalAutolink");
    effects.enter("literalAutolinkWww");
    return effects.check(wwwPrefix, effects.attempt(domain$1, effects.attempt(path, wwwAfter), nok), nok)(code);
  }
  function wwwAfter(code) {
    effects.exit("literalAutolinkWww");
    effects.exit("literalAutolink");
    return ok2(code);
  }
}
function tokenizeProtocolAutolink(effects, ok2, nok) {
  const self2 = this;
  let buffer = "";
  let seen = false;
  return protocolStart;
  function protocolStart(code) {
    if ((code === 72 || code === 104) && previousProtocol.call(self2, self2.previous) && !previousUnbalanced(self2.events)) {
      effects.enter("literalAutolink");
      effects.enter("literalAutolinkHttp");
      buffer += String.fromCodePoint(code);
      effects.consume(code);
      return protocolPrefixInside;
    }
    return nok(code);
  }
  function protocolPrefixInside(code) {
    if (asciiAlpha(code) && buffer.length < 5) {
      buffer += String.fromCodePoint(code);
      effects.consume(code);
      return protocolPrefixInside;
    }
    if (code === 58) {
      const protocol = buffer.toLowerCase();
      if (protocol === "http" || protocol === "https") {
        effects.consume(code);
        return protocolSlashesInside;
      }
    }
    return nok(code);
  }
  function protocolSlashesInside(code) {
    if (code === 47) {
      effects.consume(code);
      if (seen) {
        return afterProtocol;
      }
      seen = true;
      return protocolSlashesInside;
    }
    return nok(code);
  }
  function afterProtocol(code) {
    return code === null || asciiControl(code) || markdownLineEndingOrSpace(code) || unicodeWhitespace(code) || unicodePunctuation(code) ? nok(code) : effects.attempt(domain$1, effects.attempt(path, protocolAfter), nok)(code);
  }
  function protocolAfter(code) {
    effects.exit("literalAutolinkHttp");
    effects.exit("literalAutolink");
    return ok2(code);
  }
}
function tokenizeWwwPrefix(effects, ok2, nok) {
  let size2 = 0;
  return wwwPrefixInside;
  function wwwPrefixInside(code) {
    if ((code === 87 || code === 119) && size2 < 3) {
      size2++;
      effects.consume(code);
      return wwwPrefixInside;
    }
    if (code === 46 && size2 === 3) {
      effects.consume(code);
      return wwwPrefixAfter;
    }
    return nok(code);
  }
  function wwwPrefixAfter(code) {
    return code === null ? nok(code) : ok2(code);
  }
}
function tokenizeDomain(effects, ok2, nok) {
  let underscoreInLastSegment;
  let underscoreInLastLastSegment;
  let seen;
  return domainInside;
  function domainInside(code) {
    if (code === 46 || code === 95) {
      return effects.check(trail, domainAfter, domainAtPunctuation)(code);
    }
    if (code === null || markdownLineEndingOrSpace(code) || unicodeWhitespace(code) || code !== 45 && unicodePunctuation(code)) {
      return domainAfter(code);
    }
    seen = true;
    effects.consume(code);
    return domainInside;
  }
  function domainAtPunctuation(code) {
    if (code === 95) {
      underscoreInLastSegment = true;
    } else {
      underscoreInLastLastSegment = underscoreInLastSegment;
      underscoreInLastSegment = void 0;
    }
    effects.consume(code);
    return domainInside;
  }
  function domainAfter(code) {
    if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) {
      return nok(code);
    }
    return ok2(code);
  }
}
function tokenizePath(effects, ok2) {
  let sizeOpen = 0;
  let sizeClose = 0;
  return pathInside;
  function pathInside(code) {
    if (code === 40) {
      sizeOpen++;
      effects.consume(code);
      return pathInside;
    }
    if (code === 41 && sizeClose < sizeOpen) {
      return pathAtPunctuation(code);
    }
    if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) {
      return effects.check(trail, ok2, pathAtPunctuation)(code);
    }
    if (code === null || markdownLineEndingOrSpace(code) || unicodeWhitespace(code)) {
      return ok2(code);
    }
    effects.consume(code);
    return pathInside;
  }
  function pathAtPunctuation(code) {
    if (code === 41) {
      sizeClose++;
    }
    effects.consume(code);
    return pathInside;
  }
}
function tokenizeTrail(effects, ok2, nok) {
  return trail2;
  function trail2(code) {
    if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
      effects.consume(code);
      return trail2;
    }
    if (code === 38) {
      effects.consume(code);
      return trailCharacterReferenceStart;
    }
    if (code === 93) {
      effects.consume(code);
      return trailBracketAfter;
    }
    if (
      // `<` is an end.
      code === 60 || // So is whitespace.
      code === null || markdownLineEndingOrSpace(code) || unicodeWhitespace(code)
    ) {
      return ok2(code);
    }
    return nok(code);
  }
  function trailBracketAfter(code) {
    if (code === null || code === 40 || code === 91 || markdownLineEndingOrSpace(code) || unicodeWhitespace(code)) {
      return ok2(code);
    }
    return trail2(code);
  }
  function trailCharacterReferenceStart(code) {
    return asciiAlpha(code) ? trailCharacterReferenceInside(code) : nok(code);
  }
  function trailCharacterReferenceInside(code) {
    if (code === 59) {
      effects.consume(code);
      return trail2;
    }
    if (asciiAlpha(code)) {
      effects.consume(code);
      return trailCharacterReferenceInside;
    }
    return nok(code);
  }
}
function tokenizeEmailDomainDotTrail(effects, ok2, nok) {
  return start4;
  function start4(code) {
    effects.consume(code);
    return after;
  }
  function after(code) {
    return asciiAlphanumeric(code) ? nok(code) : ok2(code);
  }
}
function previousWww(code) {
  return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || markdownLineEndingOrSpace(code);
}
function previousProtocol(code) {
  return !asciiAlpha(code);
}
function previousEmail(code) {
  return !(code === 47 || gfmAtext(code));
}
function gfmAtext(code) {
  return code === 43 || code === 45 || code === 46 || code === 95 || asciiAlphanumeric(code);
}
function previousUnbalanced(events2) {
  let index2 = events2.length;
  let result = false;
  while (index2--) {
    const token2 = events2[index2][1];
    if ((token2.type === "labelLink" || token2.type === "labelImage") && !token2._balanced) {
      result = true;
      break;
    }
    if (token2._gfmAutolinkLiteralWalkedInto) {
      result = false;
      break;
    }
  }
  if (events2.length > 0 && !result) {
    events2[events2.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
  }
  return result;
}
const indent = {
  tokenize: tokenizeIndent,
  partial: true
};
function gfmFootnote() {
  return {
    document: {
      [91]: {
        name: "gfmFootnoteDefinition",
        tokenize: tokenizeDefinitionStart,
        continuation: {
          tokenize: tokenizeDefinitionContinuation
        },
        exit: gfmFootnoteDefinitionEnd
      }
    },
    text: {
      [91]: {
        name: "gfmFootnoteCall",
        tokenize: tokenizeGfmFootnoteCall
      },
      [93]: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: tokenizePotentialGfmFootnoteCall,
        resolveTo: resolveToPotentialGfmFootnoteCall
      }
    }
  };
}
function tokenizePotentialGfmFootnoteCall(effects, ok2, nok) {
  const self2 = this;
  let index2 = self2.events.length;
  const defined = self2.parser.gfmFootnotes || (self2.parser.gfmFootnotes = []);
  let labelStart;
  while (index2--) {
    const token2 = self2.events[index2][1];
    if (token2.type === "labelImage") {
      labelStart = token2;
      break;
    }
    if (token2.type === "gfmFootnoteCall" || token2.type === "labelLink" || token2.type === "label" || token2.type === "image" || token2.type === "link") {
      break;
    }
  }
  return start4;
  function start4(code) {
    if (!labelStart || !labelStart._balanced) {
      return nok(code);
    }
    const id = normalizeIdentifier(self2.sliceSerialize({
      start: labelStart.end,
      end: self2.now()
    }));
    if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) {
      return nok(code);
    }
    effects.enter("gfmFootnoteCallLabelMarker");
    effects.consume(code);
    effects.exit("gfmFootnoteCallLabelMarker");
    return ok2(code);
  }
}
function resolveToPotentialGfmFootnoteCall(events2, context) {
  let index2 = events2.length;
  while (index2--) {
    if (events2[index2][1].type === "labelImage" && events2[index2][0] === "enter") {
      events2[index2][1];
      break;
    }
  }
  events2[index2 + 1][1].type = "data";
  events2[index2 + 3][1].type = "gfmFootnoteCallLabelMarker";
  const call = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, events2[index2 + 3][1].start),
    end: Object.assign({}, events2[events2.length - 1][1].end)
  };
  const marker = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, events2[index2 + 3][1].end),
    end: Object.assign({}, events2[index2 + 3][1].end)
  };
  marker.end.column++;
  marker.end.offset++;
  marker.end._bufferIndex++;
  const string2 = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, marker.end),
    end: Object.assign({}, events2[events2.length - 1][1].start)
  };
  const chunk = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, string2.start),
    end: Object.assign({}, string2.end)
  };
  const replacement = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    events2[index2 + 1],
    events2[index2 + 2],
    ["enter", call, context],
    // The `[`
    events2[index2 + 3],
    events2[index2 + 4],
    // The `^`.
    ["enter", marker, context],
    ["exit", marker, context],
    // Everything in between.
    ["enter", string2, context],
    ["enter", chunk, context],
    ["exit", chunk, context],
    ["exit", string2, context],
    // The ending (`]`, properly parsed and labelled).
    events2[events2.length - 2],
    events2[events2.length - 1],
    ["exit", call, context]
  ];
  events2.splice(index2, events2.length - index2 + 1, ...replacement);
  return events2;
}
function tokenizeGfmFootnoteCall(effects, ok2, nok) {
  const self2 = this;
  const defined = self2.parser.gfmFootnotes || (self2.parser.gfmFootnotes = []);
  let size2 = 0;
  let data;
  return start4;
  function start4(code) {
    effects.enter("gfmFootnoteCall");
    effects.enter("gfmFootnoteCallLabelMarker");
    effects.consume(code);
    effects.exit("gfmFootnoteCallLabelMarker");
    return callStart;
  }
  function callStart(code) {
    if (code !== 94) return nok(code);
    effects.enter("gfmFootnoteCallMarker");
    effects.consume(code);
    effects.exit("gfmFootnoteCallMarker");
    effects.enter("gfmFootnoteCallString");
    effects.enter("chunkString").contentType = "string";
    return callData;
  }
  function callData(code) {
    if (
      // Too long.
      size2 > 999 || // Closing brace with nothing.
      code === 93 && !data || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      code === null || code === 91 || markdownLineEndingOrSpace(code)
    ) {
      return nok(code);
    }
    if (code === 93) {
      effects.exit("chunkString");
      const token2 = effects.exit("gfmFootnoteCallString");
      if (!defined.includes(normalizeIdentifier(self2.sliceSerialize(token2)))) {
        return nok(code);
      }
      effects.enter("gfmFootnoteCallLabelMarker");
      effects.consume(code);
      effects.exit("gfmFootnoteCallLabelMarker");
      effects.exit("gfmFootnoteCall");
      return ok2;
    }
    if (!markdownLineEndingOrSpace(code)) {
      data = true;
    }
    size2++;
    effects.consume(code);
    return code === 92 ? callEscape : callData;
  }
  function callEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code);
      size2++;
      return callData;
    }
    return callData(code);
  }
}
function tokenizeDefinitionStart(effects, ok2, nok) {
  const self2 = this;
  const defined = self2.parser.gfmFootnotes || (self2.parser.gfmFootnotes = []);
  let identifier2;
  let size2 = 0;
  let data;
  return start4;
  function start4(code) {
    effects.enter("gfmFootnoteDefinition")._container = true;
    effects.enter("gfmFootnoteDefinitionLabel");
    effects.enter("gfmFootnoteDefinitionLabelMarker");
    effects.consume(code);
    effects.exit("gfmFootnoteDefinitionLabelMarker");
    return labelAtMarker;
  }
  function labelAtMarker(code) {
    if (code === 94) {
      effects.enter("gfmFootnoteDefinitionMarker");
      effects.consume(code);
      effects.exit("gfmFootnoteDefinitionMarker");
      effects.enter("gfmFootnoteDefinitionLabelString");
      effects.enter("chunkString").contentType = "string";
      return labelInside;
    }
    return nok(code);
  }
  function labelInside(code) {
    if (
      // Too long.
      size2 > 999 || // Closing brace with nothing.
      code === 93 && !data || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      code === null || code === 91 || markdownLineEndingOrSpace(code)
    ) {
      return nok(code);
    }
    if (code === 93) {
      effects.exit("chunkString");
      const token2 = effects.exit("gfmFootnoteDefinitionLabelString");
      identifier2 = normalizeIdentifier(self2.sliceSerialize(token2));
      effects.enter("gfmFootnoteDefinitionLabelMarker");
      effects.consume(code);
      effects.exit("gfmFootnoteDefinitionLabelMarker");
      effects.exit("gfmFootnoteDefinitionLabel");
      return labelAfter;
    }
    if (!markdownLineEndingOrSpace(code)) {
      data = true;
    }
    size2++;
    effects.consume(code);
    return code === 92 ? labelEscape : labelInside;
  }
  function labelEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code);
      size2++;
      return labelInside;
    }
    return labelInside(code);
  }
  function labelAfter(code) {
    if (code === 58) {
      effects.enter("definitionMarker");
      effects.consume(code);
      effects.exit("definitionMarker");
      if (!defined.includes(identifier2)) {
        defined.push(identifier2);
      }
      return factorySpace(effects, whitespaceAfter, "gfmFootnoteDefinitionWhitespace");
    }
    return nok(code);
  }
  function whitespaceAfter(code) {
    return ok2(code);
  }
}
function tokenizeDefinitionContinuation(effects, ok2, nok) {
  return effects.check(blankLine, ok2, effects.attempt(indent, ok2, nok));
}
function gfmFootnoteDefinitionEnd(effects) {
  effects.exit("gfmFootnoteDefinition");
}
function tokenizeIndent(effects, ok2, nok) {
  const self2 = this;
  return factorySpace(effects, afterPrefix, "gfmFootnoteDefinitionIndent", 4 + 1);
  function afterPrefix(code) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "gfmFootnoteDefinitionIndent" && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok2(code) : nok(code);
  }
}
function gfmStrikethrough(options) {
  const options_ = {};
  let single = options_.singleTilde;
  const tokenizer = {
    name: "strikethrough",
    tokenize: tokenizeStrikethrough,
    resolveAll: resolveAllStrikethrough
  };
  if (single === null || single === void 0) {
    single = true;
  }
  return {
    text: {
      [126]: tokenizer
    },
    insideSpan: {
      null: [tokenizer]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function resolveAllStrikethrough(events2, context) {
    let index2 = -1;
    while (++index2 < events2.length) {
      if (events2[index2][0] === "enter" && events2[index2][1].type === "strikethroughSequenceTemporary" && events2[index2][1]._close) {
        let open = index2;
        while (open--) {
          if (events2[open][0] === "exit" && events2[open][1].type === "strikethroughSequenceTemporary" && events2[open][1]._open && // If the sizes are the same:
          events2[index2][1].end.offset - events2[index2][1].start.offset === events2[open][1].end.offset - events2[open][1].start.offset) {
            events2[index2][1].type = "strikethroughSequence";
            events2[open][1].type = "strikethroughSequence";
            const strikethrough2 = {
              type: "strikethrough",
              start: Object.assign({}, events2[open][1].start),
              end: Object.assign({}, events2[index2][1].end)
            };
            const text2 = {
              type: "strikethroughText",
              start: Object.assign({}, events2[open][1].end),
              end: Object.assign({}, events2[index2][1].start)
            };
            const nextEvents = [["enter", strikethrough2, context], ["enter", events2[open][1], context], ["exit", events2[open][1], context], ["enter", text2, context]];
            const insideSpan2 = context.parser.constructs.insideSpan.null;
            if (insideSpan2) {
              splice(nextEvents, nextEvents.length, 0, resolveAll(insideSpan2, events2.slice(open + 1, index2), context));
            }
            splice(nextEvents, nextEvents.length, 0, [["exit", text2, context], ["enter", events2[index2][1], context], ["exit", events2[index2][1], context], ["exit", strikethrough2, context]]);
            splice(events2, open - 1, index2 - open + 3, nextEvents);
            index2 = open + nextEvents.length - 2;
            break;
          }
        }
      }
    }
    index2 = -1;
    while (++index2 < events2.length) {
      if (events2[index2][1].type === "strikethroughSequenceTemporary") {
        events2[index2][1].type = "data";
      }
    }
    return events2;
  }
  function tokenizeStrikethrough(effects, ok2, nok) {
    const previous2 = this.previous;
    const events2 = this.events;
    let size2 = 0;
    return start4;
    function start4(code) {
      if (previous2 === 126 && events2[events2.length - 1][1].type !== "characterEscape") {
        return nok(code);
      }
      effects.enter("strikethroughSequenceTemporary");
      return more(code);
    }
    function more(code) {
      const before = classifyCharacter(previous2);
      if (code === 126) {
        if (size2 > 1) return nok(code);
        effects.consume(code);
        size2++;
        return more;
      }
      if (size2 < 2 && !single) return nok(code);
      const token2 = effects.exit("strikethroughSequenceTemporary");
      const after = classifyCharacter(code);
      token2._open = !after || after === 2 && Boolean(before);
      token2._close = !before || before === 2 && Boolean(after);
      return ok2(code);
    }
  }
}
class EditMap {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(index2, remove, add4) {
    addImplementation(this, index2, remove, add4);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(events2) {
    this.map.sort(function(a2, b2) {
      return a2[0] - b2[0];
    });
    if (this.map.length === 0) {
      return;
    }
    let index2 = this.map.length;
    const vecs = [];
    while (index2 > 0) {
      index2 -= 1;
      vecs.push(events2.slice(this.map[index2][0] + this.map[index2][1]), this.map[index2][2]);
      events2.length = this.map[index2][0];
    }
    vecs.push(events2.slice());
    events2.length = 0;
    let slice3 = vecs.pop();
    while (slice3) {
      for (const element2 of slice3) {
        events2.push(element2);
      }
      slice3 = vecs.pop();
    }
    this.map.length = 0;
  }
}
function addImplementation(editMap, at, remove, add4) {
  let index2 = 0;
  if (remove === 0 && add4.length === 0) {
    return;
  }
  while (index2 < editMap.map.length) {
    if (editMap.map[index2][0] === at) {
      editMap.map[index2][1] += remove;
      editMap.map[index2][2].push(...add4);
      return;
    }
    index2 += 1;
  }
  editMap.map.push([at, remove, add4]);
}
function gfmTableAlign(events2, index2) {
  let inDelimiterRow = false;
  const align = [];
  while (index2 < events2.length) {
    const event = events2[index2];
    if (inDelimiterRow) {
      if (event[0] === "enter") {
        if (event[1].type === "tableContent") {
          align.push(events2[index2 + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
        }
      } else if (event[1].type === "tableContent") {
        if (events2[index2 - 1][1].type === "tableDelimiterMarker") {
          const alignIndex = align.length - 1;
          align[alignIndex] = align[alignIndex] === "left" ? "center" : "right";
        }
      } else if (event[1].type === "tableDelimiterRow") {
        break;
      }
    } else if (event[0] === "enter" && event[1].type === "tableDelimiterRow") {
      inDelimiterRow = true;
    }
    index2 += 1;
  }
  return align;
}
function gfmTable() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: tokenizeTable,
        resolveAll: resolveTable
      }
    }
  };
}
function tokenizeTable(effects, ok2, nok) {
  const self2 = this;
  let size2 = 0;
  let sizeB = 0;
  let seen;
  return start4;
  function start4(code) {
    let index2 = self2.events.length - 1;
    while (index2 > -1) {
      const type = self2.events[index2][1].type;
      if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      type === "linePrefix") index2--;
      else break;
    }
    const tail = index2 > -1 ? self2.events[index2][1].type : null;
    const next2 = tail === "tableHead" || tail === "tableRow" ? bodyRowStart : headRowBefore;
    if (next2 === bodyRowStart && self2.parser.lazy[self2.now().line]) {
      return nok(code);
    }
    return next2(code);
  }
  function headRowBefore(code) {
    effects.enter("tableHead");
    effects.enter("tableRow");
    return headRowStart(code);
  }
  function headRowStart(code) {
    if (code === 124) {
      return headRowBreak(code);
    }
    seen = true;
    sizeB += 1;
    return headRowBreak(code);
  }
  function headRowBreak(code) {
    if (code === null) {
      return nok(code);
    }
    if (markdownLineEnding(code)) {
      if (sizeB > 1) {
        sizeB = 0;
        self2.interrupt = true;
        effects.exit("tableRow");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return headDelimiterStart;
      }
      return nok(code);
    }
    if (markdownSpace(code)) {
      return factorySpace(effects, headRowBreak, "whitespace")(code);
    }
    sizeB += 1;
    if (seen) {
      seen = false;
      size2 += 1;
    }
    if (code === 124) {
      effects.enter("tableCellDivider");
      effects.consume(code);
      effects.exit("tableCellDivider");
      seen = true;
      return headRowBreak;
    }
    effects.enter("data");
    return headRowData(code);
  }
  function headRowData(code) {
    if (code === null || code === 124 || markdownLineEndingOrSpace(code)) {
      effects.exit("data");
      return headRowBreak(code);
    }
    effects.consume(code);
    return code === 92 ? headRowEscape : headRowData;
  }
  function headRowEscape(code) {
    if (code === 92 || code === 124) {
      effects.consume(code);
      return headRowData;
    }
    return headRowData(code);
  }
  function headDelimiterStart(code) {
    self2.interrupt = false;
    if (self2.parser.lazy[self2.now().line]) {
      return nok(code);
    }
    effects.enter("tableDelimiterRow");
    seen = false;
    if (markdownSpace(code)) {
      return factorySpace(effects, headDelimiterBefore, "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code);
    }
    return headDelimiterBefore(code);
  }
  function headDelimiterBefore(code) {
    if (code === 45 || code === 58) {
      return headDelimiterValueBefore(code);
    }
    if (code === 124) {
      seen = true;
      effects.enter("tableCellDivider");
      effects.consume(code);
      effects.exit("tableCellDivider");
      return headDelimiterCellBefore;
    }
    return headDelimiterNok(code);
  }
  function headDelimiterCellBefore(code) {
    if (markdownSpace(code)) {
      return factorySpace(effects, headDelimiterValueBefore, "whitespace")(code);
    }
    return headDelimiterValueBefore(code);
  }
  function headDelimiterValueBefore(code) {
    if (code === 58) {
      sizeB += 1;
      seen = true;
      effects.enter("tableDelimiterMarker");
      effects.consume(code);
      effects.exit("tableDelimiterMarker");
      return headDelimiterLeftAlignmentAfter;
    }
    if (code === 45) {
      sizeB += 1;
      return headDelimiterLeftAlignmentAfter(code);
    }
    if (code === null || markdownLineEnding(code)) {
      return headDelimiterCellAfter(code);
    }
    return headDelimiterNok(code);
  }
  function headDelimiterLeftAlignmentAfter(code) {
    if (code === 45) {
      effects.enter("tableDelimiterFiller");
      return headDelimiterFiller(code);
    }
    return headDelimiterNok(code);
  }
  function headDelimiterFiller(code) {
    if (code === 45) {
      effects.consume(code);
      return headDelimiterFiller;
    }
    if (code === 58) {
      seen = true;
      effects.exit("tableDelimiterFiller");
      effects.enter("tableDelimiterMarker");
      effects.consume(code);
      effects.exit("tableDelimiterMarker");
      return headDelimiterRightAlignmentAfter;
    }
    effects.exit("tableDelimiterFiller");
    return headDelimiterRightAlignmentAfter(code);
  }
  function headDelimiterRightAlignmentAfter(code) {
    if (markdownSpace(code)) {
      return factorySpace(effects, headDelimiterCellAfter, "whitespace")(code);
    }
    return headDelimiterCellAfter(code);
  }
  function headDelimiterCellAfter(code) {
    if (code === 124) {
      return headDelimiterBefore(code);
    }
    if (code === null || markdownLineEnding(code)) {
      if (!seen || size2 !== sizeB) {
        return headDelimiterNok(code);
      }
      effects.exit("tableDelimiterRow");
      effects.exit("tableHead");
      return ok2(code);
    }
    return headDelimiterNok(code);
  }
  function headDelimiterNok(code) {
    return nok(code);
  }
  function bodyRowStart(code) {
    effects.enter("tableRow");
    return bodyRowBreak(code);
  }
  function bodyRowBreak(code) {
    if (code === 124) {
      effects.enter("tableCellDivider");
      effects.consume(code);
      effects.exit("tableCellDivider");
      return bodyRowBreak;
    }
    if (code === null || markdownLineEnding(code)) {
      effects.exit("tableRow");
      return ok2(code);
    }
    if (markdownSpace(code)) {
      return factorySpace(effects, bodyRowBreak, "whitespace")(code);
    }
    effects.enter("data");
    return bodyRowData(code);
  }
  function bodyRowData(code) {
    if (code === null || code === 124 || markdownLineEndingOrSpace(code)) {
      effects.exit("data");
      return bodyRowBreak(code);
    }
    effects.consume(code);
    return code === 92 ? bodyRowEscape : bodyRowData;
  }
  function bodyRowEscape(code) {
    if (code === 92 || code === 124) {
      effects.consume(code);
      return bodyRowData;
    }
    return bodyRowData(code);
  }
}
function resolveTable(events2, context) {
  let index2 = -1;
  let inFirstCellAwaitingPipe = true;
  let rowKind = 0;
  let lastCell = [0, 0, 0, 0];
  let cell = [0, 0, 0, 0];
  let afterHeadAwaitingFirstBodyRow = false;
  let lastTableEnd = 0;
  let currentTable;
  let currentBody;
  let currentCell;
  const map3 = new EditMap();
  while (++index2 < events2.length) {
    const event = events2[index2];
    const token2 = event[1];
    if (event[0] === "enter") {
      if (token2.type === "tableHead") {
        afterHeadAwaitingFirstBodyRow = false;
        if (lastTableEnd !== 0) {
          flushTableEnd(map3, context, lastTableEnd, currentTable, currentBody);
          currentBody = void 0;
          lastTableEnd = 0;
        }
        currentTable = {
          type: "table",
          start: Object.assign({}, token2.start),
          // Note: correct end is set later.
          end: Object.assign({}, token2.end)
        };
        map3.add(index2, 0, [["enter", currentTable, context]]);
      } else if (token2.type === "tableRow" || token2.type === "tableDelimiterRow") {
        inFirstCellAwaitingPipe = true;
        currentCell = void 0;
        lastCell = [0, 0, 0, 0];
        cell = [0, index2 + 1, 0, 0];
        if (afterHeadAwaitingFirstBodyRow) {
          afterHeadAwaitingFirstBodyRow = false;
          currentBody = {
            type: "tableBody",
            start: Object.assign({}, token2.start),
            // Note: correct end is set later.
            end: Object.assign({}, token2.end)
          };
          map3.add(index2, 0, [["enter", currentBody, context]]);
        }
        rowKind = token2.type === "tableDelimiterRow" ? 2 : currentBody ? 3 : 1;
      } else if (rowKind && (token2.type === "data" || token2.type === "tableDelimiterMarker" || token2.type === "tableDelimiterFiller")) {
        inFirstCellAwaitingPipe = false;
        if (cell[2] === 0) {
          if (lastCell[1] !== 0) {
            cell[0] = cell[1];
            currentCell = flushCell(map3, context, lastCell, rowKind, void 0, currentCell);
            lastCell = [0, 0, 0, 0];
          }
          cell[2] = index2;
        }
      } else if (token2.type === "tableCellDivider") {
        if (inFirstCellAwaitingPipe) {
          inFirstCellAwaitingPipe = false;
        } else {
          if (lastCell[1] !== 0) {
            cell[0] = cell[1];
            currentCell = flushCell(map3, context, lastCell, rowKind, void 0, currentCell);
          }
          lastCell = cell;
          cell = [lastCell[1], index2, 0, 0];
        }
      }
    } else if (token2.type === "tableHead") {
      afterHeadAwaitingFirstBodyRow = true;
      lastTableEnd = index2;
    } else if (token2.type === "tableRow" || token2.type === "tableDelimiterRow") {
      lastTableEnd = index2;
      if (lastCell[1] !== 0) {
        cell[0] = cell[1];
        currentCell = flushCell(map3, context, lastCell, rowKind, index2, currentCell);
      } else if (cell[1] !== 0) {
        currentCell = flushCell(map3, context, cell, rowKind, index2, currentCell);
      }
      rowKind = 0;
    } else if (rowKind && (token2.type === "data" || token2.type === "tableDelimiterMarker" || token2.type === "tableDelimiterFiller")) {
      cell[3] = index2;
    }
  }
  if (lastTableEnd !== 0) {
    flushTableEnd(map3, context, lastTableEnd, currentTable, currentBody);
  }
  map3.consume(context.events);
  index2 = -1;
  while (++index2 < context.events.length) {
    const event = context.events[index2];
    if (event[0] === "enter" && event[1].type === "table") {
      event[1]._align = gfmTableAlign(context.events, index2);
    }
  }
  return events2;
}
function flushCell(map3, context, range, rowKind, rowEnd, previousCell) {
  const groupName = rowKind === 1 ? "tableHeader" : rowKind === 2 ? "tableDelimiter" : "tableData";
  const valueName = "tableContent";
  if (range[0] !== 0) {
    previousCell.end = Object.assign({}, getPoint(context.events, range[0]));
    map3.add(range[0], 0, [["exit", previousCell, context]]);
  }
  const now2 = getPoint(context.events, range[1]);
  previousCell = {
    type: groupName,
    start: Object.assign({}, now2),
    // Note: correct end is set later.
    end: Object.assign({}, now2)
  };
  map3.add(range[1], 0, [["enter", previousCell, context]]);
  if (range[2] !== 0) {
    const relatedStart = getPoint(context.events, range[2]);
    const relatedEnd = getPoint(context.events, range[3]);
    const valueToken = {
      type: valueName,
      start: Object.assign({}, relatedStart),
      end: Object.assign({}, relatedEnd)
    };
    map3.add(range[2], 0, [["enter", valueToken, context]]);
    if (rowKind !== 2) {
      const start4 = context.events[range[2]];
      const end2 = context.events[range[3]];
      start4[1].end = Object.assign({}, end2[1].end);
      start4[1].type = "chunkText";
      start4[1].contentType = "text";
      if (range[3] > range[2] + 1) {
        const a2 = range[2] + 1;
        const b2 = range[3] - range[2] - 1;
        map3.add(a2, b2, []);
      }
    }
    map3.add(range[3] + 1, 0, [["exit", valueToken, context]]);
  }
  if (rowEnd !== void 0) {
    previousCell.end = Object.assign({}, getPoint(context.events, rowEnd));
    map3.add(rowEnd, 0, [["exit", previousCell, context]]);
    previousCell = void 0;
  }
  return previousCell;
}
function flushTableEnd(map3, context, index2, table2, tableBody) {
  const exits = [];
  const related = getPoint(context.events, index2);
  if (tableBody) {
    tableBody.end = Object.assign({}, related);
    exits.push(["exit", tableBody, context]);
  }
  table2.end = Object.assign({}, related);
  exits.push(["exit", table2, context]);
  map3.add(index2 + 1, 0, exits);
}
function getPoint(events2, index2) {
  const event = events2[index2];
  const side = event[0] === "enter" ? "start" : "end";
  return event[1][side];
}
const tasklistCheck = {
  name: "tasklistCheck",
  tokenize: tokenizeTasklistCheck
};
function gfmTaskListItem() {
  return {
    text: {
      [91]: tasklistCheck
    }
  };
}
function tokenizeTasklistCheck(effects, ok2, nok) {
  const self2 = this;
  return open;
  function open(code) {
    if (
      // Exit if there’s stuff before.
      self2.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !self2._gfmTasklistFirstContentOfListItem
    ) {
      return nok(code);
    }
    effects.enter("taskListCheck");
    effects.enter("taskListCheckMarker");
    effects.consume(code);
    effects.exit("taskListCheckMarker");
    return inside;
  }
  function inside(code) {
    if (markdownLineEndingOrSpace(code)) {
      effects.enter("taskListCheckValueUnchecked");
      effects.consume(code);
      effects.exit("taskListCheckValueUnchecked");
      return close2;
    }
    if (code === 88 || code === 120) {
      effects.enter("taskListCheckValueChecked");
      effects.consume(code);
      effects.exit("taskListCheckValueChecked");
      return close2;
    }
    return nok(code);
  }
  function close2(code) {
    if (code === 93) {
      effects.enter("taskListCheckMarker");
      effects.consume(code);
      effects.exit("taskListCheckMarker");
      effects.exit("taskListCheck");
      return after;
    }
    return nok(code);
  }
  function after(code) {
    if (markdownLineEnding(code)) {
      return ok2(code);
    }
    if (markdownSpace(code)) {
      return effects.check({
        tokenize: spaceThenNonSpace
      }, ok2, nok)(code);
    }
    return nok(code);
  }
}
function spaceThenNonSpace(effects, ok2, nok) {
  return factorySpace(effects, after, "whitespace");
  function after(code) {
    return code === null ? nok(code) : ok2(code);
  }
}
function gfm(options) {
  return combineExtensions([
    gfmAutolinkLiteral(),
    gfmFootnote(),
    gfmStrikethrough(),
    gfmTable(),
    gfmTaskListItem()
  ]);
}
var __spreadArray = function(to2, from3, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l2 = from3.length, ar; i < l2; i++) {
    if (ar || !(i in from3)) {
      if (!ar) ar = Array.prototype.slice.call(from3, 0, i);
      ar[i] = from3[i];
    }
  }
  return to2.concat(ar || Array.prototype.slice.call(from3));
};
function lazyDataLastImpl(fn2, args, lazyFactory) {
  var ret = function(data) {
    return fn2.apply(void 0, __spreadArray([data], Array.from(args), false));
  };
  var lazy = lazyFactory !== null && lazyFactory !== void 0 ? lazyFactory : fn2.lazy;
  return lazy === void 0 ? ret : Object.assign(ret, { lazy, lazyArgs: args });
}
function purry(fn2, args, lazyFactory) {
  var diff2 = fn2.length - args.length;
  if (diff2 === 0) {
    return fn2.apply(void 0, Array.from(args));
  }
  if (diff2 === 1) {
    return lazyDataLastImpl(fn2, args, lazyFactory);
  }
  throw new Error("Wrong number of arguments");
}
function isDeepEqual() {
  return purry(isDeepEqualImplementation, arguments);
}
function isDeepEqualImplementation(data, other2) {
  if (data === other2) {
    return true;
  }
  if (typeof data === "number" && typeof other2 === "number") {
    return data !== data && other2 !== other2;
  }
  if (typeof data !== "object" || typeof other2 !== "object") {
    return false;
  }
  if (data === null || other2 === null) {
    return false;
  }
  if (Object.getPrototypeOf(data) !== Object.getPrototypeOf(other2)) {
    return false;
  }
  if (data instanceof Set) {
    return isDeepEqualSets(data, other2);
  }
  if (Array.isArray(data)) {
    if (data.length !== other2.length) {
      return false;
    }
    for (var i = 0; i < data.length; i++) {
      if (!isDeepEqualImplementation(data[i], other2[i])) {
        return false;
      }
    }
    return true;
  }
  if (data instanceof Date) {
    return data.getTime() === other2.getTime();
  }
  if (data instanceof RegExp) {
    return data.toString() === other2.toString();
  }
  if (data instanceof Map) {
    return isDeepEqualMaps(data, other2);
  }
  var keys2 = Object.keys(data);
  if (keys2.length !== Object.keys(other2).length) {
    return false;
  }
  for (var _i = 0, keys_1 = keys2; _i < keys_1.length; _i++) {
    var key2 = keys_1[_i];
    if (!Object.prototype.hasOwnProperty.call(other2, key2)) {
      return false;
    }
    if (!isDeepEqualImplementation(data[key2], other2[key2])) {
      return false;
    }
  }
  return true;
}
function isDeepEqualMaps(data, other2) {
  if (data.size !== other2.size) {
    return false;
  }
  var keys2 = Array.from(data.keys());
  for (var _i = 0, keys_2 = keys2; _i < keys_2.length; _i++) {
    var key2 = keys_2[_i];
    if (!other2.has(key2)) {
      return false;
    }
    if (!isDeepEqualImplementation(data.get(key2), other2.get(key2))) {
      return false;
    }
  }
  return true;
}
function isDeepEqualSets(data, other2) {
  if (data.size !== other2.size) {
    return false;
  }
  var dataArr = Array.from(data.values());
  var otherArr = Array.from(other2.values());
  for (var _i = 0, dataArr_1 = dataArr; _i < dataArr_1.length; _i++) {
    var dataItem = dataArr_1[_i];
    var isFound = false;
    for (var i = 0; i < otherArr.length; i++) {
      if (isDeepEqualImplementation(dataItem, otherArr[i])) {
        isFound = true;
        otherArr.splice(i, 1);
        break;
      }
    }
    if (!isFound) {
      return false;
    }
  }
  return true;
}
var ZERO_WIDTH_SPACE = "​";
var ENCLOSING_START_REGEX = /(\*{1,3}|(^|\s|\n)_{1,3}|~{1,3})(\S|$)/;
var LINK_REGEX = /(\[$|\[[^\]]+$|\[[^\]]+\]$|\[[^\]]+\]\(.*$)/;
var isEmptyList = (list2) => {
  return list2.children.length === 1 && list2.children[0].type === "listItem" && list2.children[0].children.length === 0;
};
var isListCharacterLength = (list2, length2) => {
  return Boolean(
    list2.position && list2.position.start.line === list2.position.end.line && list2.position.end.column && list2.position.start.column && list2.position.end.column - list2.position.start.column === length2
  );
};
var markdownToAst = (markdown) => {
  return fromMarkdown(markdown, {
    extensions: [gfm()],
    mdastExtensions: [gfmFromMarkdown()]
  });
};
var astToMarkdown = (markdownAst) => {
  preserveWhitespaceInAst(markdownAst);
  return toMarkdown(markdownAst, { extensions: [gfmToMarkdown()] });
};
var afterLastNewline = (markdown) => {
  const lastNewlineIndex = markdown.lastIndexOf("\n");
  return markdown.slice(lastNewlineIndex + 1);
};
var addZeroWidthSpaceAfterTrailingWhitespace = (text2) => {
  return text2.replace(/ $/, ` ${ZERO_WIDTH_SPACE}`);
};
var removeZeroWidthSpaces = (text2) => {
  return text2.replaceAll(ZERO_WIDTH_SPACE, "");
};
var preserveWhitespaceInAst = (root2) => {
  visit(root2, "text", (node2, index2, parent2) => {
    if (parent2 && ["emphasis", "strong", "delete"].includes(parent2.type)) {
      const indexWithinParent = parent2.children.findIndex((n2) => {
        return isDeepEqual(n2.position, node2.position);
      });
      const isLastChild = indexWithinParent === parent2.children.length - 1;
      if (isLastChild) {
        node2.value = addZeroWidthSpaceAfterTrailingWhitespace(node2.value);
      }
    }
  });
  return root2;
};
var removeRegexesFromParagraph = (root2, paragraph2, regexes2) => {
  regexes2.forEach((regex2) => {
    if (removeRegexFromParagraph(root2, paragraph2, regex2)) {
      return;
    }
  });
};
var removeRegexFromParagraph = (root2, paragraph2, regex2) => {
  const partialAmbiguousEnclosingSymbolsIndex = paragraph2.children.findIndex(
    (child) => {
      return child.type === "text" && regex2.test(afterLastNewline(child.value));
    }
  );
  if (partialAmbiguousEnclosingSymbolsIndex !== -1) {
    const match5 = paragraph2.children[partialAmbiguousEnclosingSymbolsIndex];
    const matchText = match5.value;
    const matchIndex = regex2.exec(matchText).index;
    if (matchIndex > 0) {
      paragraph2.children[partialAmbiguousEnclosingSymbolsIndex] = {
        type: "text",
        value: matchText.slice(0, matchIndex)
      };
      paragraph2.children.splice(partialAmbiguousEnclosingSymbolsIndex + 1);
    } else {
      paragraph2.children.splice(partialAmbiguousEnclosingSymbolsIndex);
    }
    if (paragraph2.children.length === 0) {
      root2.children.splice(-1);
    }
  }
  return partialAmbiguousEnclosingSymbolsIndex !== -1;
};
var removePartialAmbiguousMarkdownFromAst = (root2) => {
  if (root2.children.length === 0) {
    return;
  }
  const lastChild = root2.children[root2.children.length - 1];
  if (lastChild.type === "paragraph") {
    removeRegexesFromParagraph(root2, lastChild, [
      ENCLOSING_START_REGEX,
      LINK_REGEX
    ]);
  } else if (
    // if there is an empty list item at the end, remove it
    lastChild.type === "list" && isEmptyList(lastChild) && isListCharacterLength(lastChild, 1)
  ) {
    root2.children.splice(-1);
  } else if (lastChild.type === "thematicBreak") {
    root2.children.splice(-1);
  }
};
var THEMATIC_BREAK_VISIBLE = "_";
var LIST_ITEM_VISIBLE = "*";
var markdownAstToVisibleTextHelper = (markdownAst) => {
  return markdownAst.children.map((child) => {
    if (child.type === "text") {
      return child.value;
    }
    if (child.type === "inlineCode") {
      return child.value;
    }
    if (child.type === "thematicBreak") {
      return THEMATIC_BREAK_VISIBLE;
    }
    if (child.type === "heading") {
      return markdownAstToVisibleTextHelper(child);
    }
    if (child.type === "paragraph") {
      return markdownAstToVisibleTextHelper(child);
    }
    if (child.type === "listItem") {
      return LIST_ITEM_VISIBLE + markdownAstToVisibleTextHelper(child);
    }
    if ("children" in child) {
      return markdownAstToVisibleTextHelper(child);
    }
    return "";
  }).join("");
};
var markdownAstToVisibleText = (markdownAst, isFinished) => {
  if (!isFinished) {
    removePartialAmbiguousMarkdownFromAst(markdownAst);
  }
  return removeZeroWidthSpaces(
    markdownAstToVisibleTextHelper(markdownAst)
  ).replaceAll("\n", "");
};
var markdownToVisibleText = (markdown, isFinished) => {
  const markdownAst = markdownToAst(markdown);
  return markdownAstToVisibleText(markdownAst, isFinished);
};
var removeVisibleCharsFromAstHelper = (node2, visibleCharsToRemove) => {
  if (node2.type === "text" || node2.type === "inlineCode") {
    if (node2.value.length <= visibleCharsToRemove) {
      return { charsRemoved: node2.value.length, toDelete: true };
    } else {
      node2.value = node2.value.slice(0, -1 * visibleCharsToRemove);
      return { charsRemoved: visibleCharsToRemove, toDelete: false };
    }
  }
  if (node2.type === "thematicBreak") {
    return { charsRemoved: THEMATIC_BREAK_VISIBLE.length, toDelete: true };
  }
  let removedCharsCount = 0;
  if ("children" in node2) {
    let index2 = node2.children.length - 1;
    while (index2 >= 0 && removedCharsCount < visibleCharsToRemove) {
      const child = node2.children[index2];
      const { charsRemoved, toDelete } = removeVisibleCharsFromAstHelper(
        child,
        visibleCharsToRemove - removedCharsCount
      );
      removedCharsCount += charsRemoved;
      if (toDelete) {
        node2.children.splice(index2, 1);
      }
      index2--;
    }
    if (node2.type === "listItem") {
      const shouldDeleteListItem = node2.children.length === 0 && visibleCharsToRemove - removedCharsCount > 0;
      return {
        charsRemoved: removedCharsCount + (shouldDeleteListItem ? LIST_ITEM_VISIBLE.length : 0),
        toDelete: shouldDeleteListItem
      };
    }
    return {
      charsRemoved: removedCharsCount,
      toDelete: node2.children.length === 0
    };
  }
  return { charsRemoved: 0, toDelete: false };
};
var removeVisibleCharsFromAst = (node2, visibleCharsToRemove) => {
  const { toDelete } = removeVisibleCharsFromAstHelper(
    node2,
    visibleCharsToRemove
  );
  if (toDelete) {
    node2.children = [];
  }
};
var markdownWithVisibleChars = (markdown, visibleChars, isFinished) => {
  const markdownAst = markdownToAst(markdown);
  if (!isFinished) {
    removePartialAmbiguousMarkdownFromAst(markdownAst);
  }
  const visibleText = markdownAstToVisibleText(markdownAst, isFinished);
  const charsToRemove = visibleText.length - visibleChars;
  removeVisibleCharsFromAst(markdownAst, charsToRemove);
  return astToMarkdown(markdownAst);
};
var markdownLookBack = () => ({
  output: completeLlmOutput,
  visibleTextLengthTarget,
  isStreamFinished
}) => {
  const output = markdownWithVisibleChars(
    completeLlmOutput,
    visibleTextLengthTarget,
    isStreamFinished
  );
  const visibleText = markdownToVisibleText(output, isStreamFinished);
  return {
    output,
    visibleText
  };
};
const MarkdownOutput$1 = ({
  blockMatch
}) => {
  if (!blockMatch.isVisible) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: blockMatch.output });
};
var regexMatchToLLmOutputMatch = (regexMatch) => {
  if (regexMatch) {
    const matchString = regexMatch[0];
    const startIndex = regexMatch.index;
    const endIndex = startIndex + matchString.length;
    return {
      startIndex,
      endIndex,
      outputRaw: matchString
    };
  }
  return void 0;
};
var regexMatcherGlobal = (regex2) => (llmOutput) => {
  if (!regex2.global) {
    throw new Error("regexMatcherGlobal does not support non-global regexes");
  }
  const matches2 = Array.from(llmOutput.matchAll(regex2));
  if (!matches2) {
    return [];
  }
  return matches2.map((m2) => regexMatchToLLmOutputMatch(m2)).filter((m2) => m2 !== void 0);
};
var removeStartEndChars = (str, { startChar, endChar }) => {
  return str.replaceAll(startChar, "").replaceAll(endChar, "");
};
class Hooks {
  /**
   * @callback HookCallback
   * @this {*|Jsep} this
   * @param {Jsep} env
   * @returns: void
   */
  /**
   * Adds the given callback to the list of callbacks for the given hook.
   *
   * The callback will be invoked when the hook it is registered for is run.
   *
   * One callback function can be registered to multiple hooks and the same hook multiple times.
   *
   * @param {string|object} name The name of the hook, or an object of callbacks keyed by name
   * @param {HookCallback|boolean} callback The callback function which is given environment variables.
   * @param {?boolean} [first=false] Will add the hook to the top of the list (defaults to the bottom)
   * @public
   */
  add(name2, callback, first2) {
    if (typeof arguments[0] != "string") {
      for (let name3 in arguments[0]) {
        this.add(name3, arguments[0][name3], arguments[1]);
      }
    } else {
      (Array.isArray(name2) ? name2 : [name2]).forEach(function(name3) {
        this[name3] = this[name3] || [];
        if (callback) {
          this[name3][first2 ? "unshift" : "push"](callback);
        }
      }, this);
    }
  }
  /**
   * Runs a hook invoking all registered callbacks with the given environment variables.
   *
   * Callbacks will be invoked synchronously and in the order in which they were registered.
   *
   * @param {string} name The name of the hook.
   * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
   * @public
   */
  run(name2, env2) {
    this[name2] = this[name2] || [];
    this[name2].forEach(function(callback) {
      callback.call(env2 && env2.context ? env2.context : env2, env2);
    });
  }
}
class Plugins {
  constructor(jsep2) {
    this.jsep = jsep2;
    this.registered = {};
  }
  /**
   * @callback PluginSetup
   * @this {Jsep} jsep
   * @returns: void
   */
  /**
   * Adds the given plugin(s) to the registry
   *
   * @param {object} plugins
   * @param {string} plugins.name The name of the plugin
   * @param {PluginSetup} plugins.init The init function
   * @public
   */
  register() {
    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }
    plugins.forEach((plugin2) => {
      if (typeof plugin2 !== "object" || !plugin2.name || !plugin2.init) {
        throw new Error("Invalid JSEP plugin format");
      }
      if (this.registered[plugin2.name]) {
        return;
      }
      plugin2.init(this.jsep);
      this.registered[plugin2.name] = plugin2;
    });
  }
}
class Jsep {
  /**
   * @returns {string}
   */
  static get version() {
    return "1.4.0";
  }
  /**
   * @returns {string}
   */
  static toString() {
    return "JavaScript Expression Parser (JSEP) v" + Jsep.version;
  }
  // ==================== CONFIG ================================
  /**
   * @method addUnaryOp
   * @param {string} op_name The name of the unary op to add
   * @returns {Jsep}
   */
  static addUnaryOp(op_name) {
    Jsep.max_unop_len = Math.max(op_name.length, Jsep.max_unop_len);
    Jsep.unary_ops[op_name] = 1;
    return Jsep;
  }
  /**
   * @method jsep.addBinaryOp
   * @param {string} op_name The name of the binary op to add
   * @param {number} precedence The precedence of the binary op (can be a float). Higher number = higher precedence
   * @param {boolean} [isRightAssociative=false] whether operator is right-associative
   * @returns {Jsep}
   */
  static addBinaryOp(op_name, precedence, isRightAssociative) {
    Jsep.max_binop_len = Math.max(op_name.length, Jsep.max_binop_len);
    Jsep.binary_ops[op_name] = precedence;
    if (isRightAssociative) {
      Jsep.right_associative.add(op_name);
    } else {
      Jsep.right_associative.delete(op_name);
    }
    return Jsep;
  }
  /**
   * @method addIdentifierChar
   * @param {string} char The additional character to treat as a valid part of an identifier
   * @returns {Jsep}
   */
  static addIdentifierChar(char2) {
    Jsep.additional_identifier_chars.add(char2);
    return Jsep;
  }
  /**
   * @method addLiteral
   * @param {string} literal_name The name of the literal to add
   * @param {*} literal_value The value of the literal
   * @returns {Jsep}
   */
  static addLiteral(literal_name, literal_value) {
    Jsep.literals[literal_name] = literal_value;
    return Jsep;
  }
  /**
   * @method removeUnaryOp
   * @param {string} op_name The name of the unary op to remove
   * @returns {Jsep}
   */
  static removeUnaryOp(op_name) {
    delete Jsep.unary_ops[op_name];
    if (op_name.length === Jsep.max_unop_len) {
      Jsep.max_unop_len = Jsep.getMaxKeyLen(Jsep.unary_ops);
    }
    return Jsep;
  }
  /**
   * @method removeAllUnaryOps
   * @returns {Jsep}
   */
  static removeAllUnaryOps() {
    Jsep.unary_ops = {};
    Jsep.max_unop_len = 0;
    return Jsep;
  }
  /**
   * @method removeIdentifierChar
   * @param {string} char The additional character to stop treating as a valid part of an identifier
   * @returns {Jsep}
   */
  static removeIdentifierChar(char2) {
    Jsep.additional_identifier_chars.delete(char2);
    return Jsep;
  }
  /**
   * @method removeBinaryOp
   * @param {string} op_name The name of the binary op to remove
   * @returns {Jsep}
   */
  static removeBinaryOp(op_name) {
    delete Jsep.binary_ops[op_name];
    if (op_name.length === Jsep.max_binop_len) {
      Jsep.max_binop_len = Jsep.getMaxKeyLen(Jsep.binary_ops);
    }
    Jsep.right_associative.delete(op_name);
    return Jsep;
  }
  /**
   * @method removeAllBinaryOps
   * @returns {Jsep}
   */
  static removeAllBinaryOps() {
    Jsep.binary_ops = {};
    Jsep.max_binop_len = 0;
    return Jsep;
  }
  /**
   * @method removeLiteral
   * @param {string} literal_name The name of the literal to remove
   * @returns {Jsep}
   */
  static removeLiteral(literal_name) {
    delete Jsep.literals[literal_name];
    return Jsep;
  }
  /**
   * @method removeAllLiterals
   * @returns {Jsep}
   */
  static removeAllLiterals() {
    Jsep.literals = {};
    return Jsep;
  }
  // ==================== END CONFIG ============================
  /**
   * @returns {string}
   */
  get char() {
    return this.expr.charAt(this.index);
  }
  /**
   * @returns {number}
   */
  get code() {
    return this.expr.charCodeAt(this.index);
  }
  /**
   * @param {string} expr a string with the passed in express
   * @returns Jsep
   */
  constructor(expr) {
    this.expr = expr;
    this.index = 0;
  }
  /**
   * static top-level parser
   * @returns {jsep.Expression}
   */
  static parse(expr) {
    return new Jsep(expr).parse();
  }
  /**
   * Get the longest key length of any object
   * @param {object} obj
   * @returns {number}
   */
  static getMaxKeyLen(obj) {
    return Math.max(0, ...Object.keys(obj).map((k2) => k2.length));
  }
  /**
   * `ch` is a character code in the next three functions
   * @param {number} ch
   * @returns {boolean}
   */
  static isDecimalDigit(ch) {
    return ch >= 48 && ch <= 57;
  }
  /**
   * Returns the precedence of a binary operator or `0` if it isn't a binary operator. Can be float.
   * @param {string} op_val
   * @returns {number}
   */
  static binaryPrecedence(op_val) {
    return Jsep.binary_ops[op_val] || 0;
  }
  /**
   * Looks for start of identifier
   * @param {number} ch
   * @returns {boolean}
   */
  static isIdentifierStart(ch) {
    return ch >= 65 && ch <= 90 || // A...Z
    ch >= 97 && ch <= 122 || // a...z
    ch >= 128 && !Jsep.binary_ops[String.fromCharCode(ch)] || // any non-ASCII that is not an operator
    Jsep.additional_identifier_chars.has(String.fromCharCode(ch));
  }
  /**
   * @param {number} ch
   * @returns {boolean}
   */
  static isIdentifierPart(ch) {
    return Jsep.isIdentifierStart(ch) || Jsep.isDecimalDigit(ch);
  }
  /**
   * throw error at index of the expression
   * @param {string} message
   * @throws
   */
  throwError(message2) {
    const error2 = new Error(message2 + " at character " + this.index);
    error2.index = this.index;
    error2.description = message2;
    throw error2;
  }
  /**
   * Run a given hook
   * @param {string} name
   * @param {jsep.Expression|false} [node]
   * @returns {?jsep.Expression}
   */
  runHook(name2, node2) {
    if (Jsep.hooks[name2]) {
      const env2 = {
        context: this,
        node: node2
      };
      Jsep.hooks.run(name2, env2);
      return env2.node;
    }
    return node2;
  }
  /**
   * Runs a given hook until one returns a node
   * @param {string} name
   * @returns {?jsep.Expression}
   */
  searchHook(name2) {
    if (Jsep.hooks[name2]) {
      const env2 = {
        context: this
      };
      Jsep.hooks[name2].find(function(callback) {
        callback.call(env2.context, env2);
        return env2.node;
      });
      return env2.node;
    }
  }
  /**
   * Push `index` up to the next non-space character
   */
  gobbleSpaces() {
    let ch = this.code;
    while (ch === Jsep.SPACE_CODE || ch === Jsep.TAB_CODE || ch === Jsep.LF_CODE || ch === Jsep.CR_CODE) {
      ch = this.expr.charCodeAt(++this.index);
    }
    this.runHook("gobble-spaces");
  }
  /**
   * Top-level method to parse all expressions and returns compound or single node
   * @returns {jsep.Expression}
   */
  parse() {
    this.runHook("before-all");
    const nodes = this.gobbleExpressions();
    const node2 = nodes.length === 1 ? nodes[0] : {
      type: Jsep.COMPOUND,
      body: nodes
    };
    return this.runHook("after-all", node2);
  }
  /**
   * top-level parser (but can be reused within as well)
   * @param {number} [untilICode]
   * @returns {jsep.Expression[]}
   */
  gobbleExpressions(untilICode) {
    let nodes = [], ch_i, node2;
    while (this.index < this.expr.length) {
      ch_i = this.code;
      if (ch_i === Jsep.SEMCOL_CODE || ch_i === Jsep.COMMA_CODE) {
        this.index++;
      } else {
        if (node2 = this.gobbleExpression()) {
          nodes.push(node2);
        } else if (this.index < this.expr.length) {
          if (ch_i === untilICode) {
            break;
          }
          this.throwError('Unexpected "' + this.char + '"');
        }
      }
    }
    return nodes;
  }
  /**
   * The main parsing function.
   * @returns {?jsep.Expression}
   */
  gobbleExpression() {
    const node2 = this.searchHook("gobble-expression") || this.gobbleBinaryExpression();
    this.gobbleSpaces();
    return this.runHook("after-expression", node2);
  }
  /**
   * Search for the operation portion of the string (e.g. `+`, `===`)
   * Start by taking the longest possible binary operations (3 characters: `===`, `!==`, `>>>`)
   * and move down from 3 to 2 to 1 character until a matching binary operation is found
   * then, return that binary operation
   * @returns {string|boolean}
   */
  gobbleBinaryOp() {
    this.gobbleSpaces();
    let to_check = this.expr.substr(this.index, Jsep.max_binop_len);
    let tc_len = to_check.length;
    while (tc_len > 0) {
      if (Jsep.binary_ops.hasOwnProperty(to_check) && (!Jsep.isIdentifierStart(this.code) || this.index + to_check.length < this.expr.length && !Jsep.isIdentifierPart(this.expr.charCodeAt(this.index + to_check.length)))) {
        this.index += tc_len;
        return to_check;
      }
      to_check = to_check.substr(0, --tc_len);
    }
    return false;
  }
  /**
   * This function is responsible for gobbling an individual expression,
   * e.g. `1`, `1+2`, `a+(b*2)-Math.sqrt(2)`
   * @returns {?jsep.BinaryExpression}
   */
  gobbleBinaryExpression() {
    let node2, biop, prec, stack, biop_info, left2, right2, i, cur_biop;
    left2 = this.gobbleToken();
    if (!left2) {
      return left2;
    }
    biop = this.gobbleBinaryOp();
    if (!biop) {
      return left2;
    }
    biop_info = {
      value: biop,
      prec: Jsep.binaryPrecedence(biop),
      right_a: Jsep.right_associative.has(biop)
    };
    right2 = this.gobbleToken();
    if (!right2) {
      this.throwError("Expected expression after " + biop);
    }
    stack = [left2, biop_info, right2];
    while (biop = this.gobbleBinaryOp()) {
      prec = Jsep.binaryPrecedence(biop);
      if (prec === 0) {
        this.index -= biop.length;
        break;
      }
      biop_info = {
        value: biop,
        prec,
        right_a: Jsep.right_associative.has(biop)
      };
      cur_biop = biop;
      const comparePrev = (prev2) => biop_info.right_a && prev2.right_a ? prec > prev2.prec : prec <= prev2.prec;
      while (stack.length > 2 && comparePrev(stack[stack.length - 2])) {
        right2 = stack.pop();
        biop = stack.pop().value;
        left2 = stack.pop();
        node2 = {
          type: Jsep.BINARY_EXP,
          operator: biop,
          left: left2,
          right: right2
        };
        stack.push(node2);
      }
      node2 = this.gobbleToken();
      if (!node2) {
        this.throwError("Expected expression after " + cur_biop);
      }
      stack.push(biop_info, node2);
    }
    i = stack.length - 1;
    node2 = stack[i];
    while (i > 1) {
      node2 = {
        type: Jsep.BINARY_EXP,
        operator: stack[i - 1].value,
        left: stack[i - 2],
        right: node2
      };
      i -= 2;
    }
    return node2;
  }
  /**
   * An individual part of a binary expression:
   * e.g. `foo.bar(baz)`, `1`, `"abc"`, `(a % 2)` (because it's in parenthesis)
   * @returns {boolean|jsep.Expression}
   */
  gobbleToken() {
    let ch, to_check, tc_len, node2;
    this.gobbleSpaces();
    node2 = this.searchHook("gobble-token");
    if (node2) {
      return this.runHook("after-token", node2);
    }
    ch = this.code;
    if (Jsep.isDecimalDigit(ch) || ch === Jsep.PERIOD_CODE) {
      return this.gobbleNumericLiteral();
    }
    if (ch === Jsep.SQUOTE_CODE || ch === Jsep.DQUOTE_CODE) {
      node2 = this.gobbleStringLiteral();
    } else if (ch === Jsep.OBRACK_CODE) {
      node2 = this.gobbleArray();
    } else {
      to_check = this.expr.substr(this.index, Jsep.max_unop_len);
      tc_len = to_check.length;
      while (tc_len > 0) {
        if (Jsep.unary_ops.hasOwnProperty(to_check) && (!Jsep.isIdentifierStart(this.code) || this.index + to_check.length < this.expr.length && !Jsep.isIdentifierPart(this.expr.charCodeAt(this.index + to_check.length)))) {
          this.index += tc_len;
          const argument = this.gobbleToken();
          if (!argument) {
            this.throwError("missing unaryOp argument");
          }
          return this.runHook("after-token", {
            type: Jsep.UNARY_EXP,
            operator: to_check,
            argument,
            prefix: true
          });
        }
        to_check = to_check.substr(0, --tc_len);
      }
      if (Jsep.isIdentifierStart(ch)) {
        node2 = this.gobbleIdentifier();
        if (Jsep.literals.hasOwnProperty(node2.name)) {
          node2 = {
            type: Jsep.LITERAL,
            value: Jsep.literals[node2.name],
            raw: node2.name
          };
        } else if (node2.name === Jsep.this_str) {
          node2 = {
            type: Jsep.THIS_EXP
          };
        }
      } else if (ch === Jsep.OPAREN_CODE) {
        node2 = this.gobbleGroup();
      }
    }
    if (!node2) {
      return this.runHook("after-token", false);
    }
    node2 = this.gobbleTokenProperty(node2);
    return this.runHook("after-token", node2);
  }
  /**
   * Gobble properties of of identifiers/strings/arrays/groups.
   * e.g. `foo`, `bar.baz`, `foo['bar'].baz`
   * It also gobbles function calls:
   * e.g. `Math.acos(obj.angle)`
   * @param {jsep.Expression} node
   * @returns {jsep.Expression}
   */
  gobbleTokenProperty(node2) {
    this.gobbleSpaces();
    let ch = this.code;
    while (ch === Jsep.PERIOD_CODE || ch === Jsep.OBRACK_CODE || ch === Jsep.OPAREN_CODE || ch === Jsep.QUMARK_CODE) {
      let optional;
      if (ch === Jsep.QUMARK_CODE) {
        if (this.expr.charCodeAt(this.index + 1) !== Jsep.PERIOD_CODE) {
          break;
        }
        optional = true;
        this.index += 2;
        this.gobbleSpaces();
        ch = this.code;
      }
      this.index++;
      if (ch === Jsep.OBRACK_CODE) {
        node2 = {
          type: Jsep.MEMBER_EXP,
          computed: true,
          object: node2,
          property: this.gobbleExpression()
        };
        if (!node2.property) {
          this.throwError('Unexpected "' + this.char + '"');
        }
        this.gobbleSpaces();
        ch = this.code;
        if (ch !== Jsep.CBRACK_CODE) {
          this.throwError("Unclosed [");
        }
        this.index++;
      } else if (ch === Jsep.OPAREN_CODE) {
        node2 = {
          type: Jsep.CALL_EXP,
          "arguments": this.gobbleArguments(Jsep.CPAREN_CODE),
          callee: node2
        };
      } else if (ch === Jsep.PERIOD_CODE || optional) {
        if (optional) {
          this.index--;
        }
        this.gobbleSpaces();
        node2 = {
          type: Jsep.MEMBER_EXP,
          computed: false,
          object: node2,
          property: this.gobbleIdentifier()
        };
      }
      if (optional) {
        node2.optional = true;
      }
      this.gobbleSpaces();
      ch = this.code;
    }
    return node2;
  }
  /**
   * Parse simple numeric literals: `12`, `3.4`, `.5`. Do this by using a string to
   * keep track of everything in the numeric literal and then calling `parseFloat` on that string
   * @returns {jsep.Literal}
   */
  gobbleNumericLiteral() {
    let number2 = "", ch, chCode;
    while (Jsep.isDecimalDigit(this.code)) {
      number2 += this.expr.charAt(this.index++);
    }
    if (this.code === Jsep.PERIOD_CODE) {
      number2 += this.expr.charAt(this.index++);
      while (Jsep.isDecimalDigit(this.code)) {
        number2 += this.expr.charAt(this.index++);
      }
    }
    ch = this.char;
    if (ch === "e" || ch === "E") {
      number2 += this.expr.charAt(this.index++);
      ch = this.char;
      if (ch === "+" || ch === "-") {
        number2 += this.expr.charAt(this.index++);
      }
      while (Jsep.isDecimalDigit(this.code)) {
        number2 += this.expr.charAt(this.index++);
      }
      if (!Jsep.isDecimalDigit(this.expr.charCodeAt(this.index - 1))) {
        this.throwError("Expected exponent (" + number2 + this.char + ")");
      }
    }
    chCode = this.code;
    if (Jsep.isIdentifierStart(chCode)) {
      this.throwError("Variable names cannot start with a number (" + number2 + this.char + ")");
    } else if (chCode === Jsep.PERIOD_CODE || number2.length === 1 && number2.charCodeAt(0) === Jsep.PERIOD_CODE) {
      this.throwError("Unexpected period");
    }
    return {
      type: Jsep.LITERAL,
      value: parseFloat(number2),
      raw: number2
    };
  }
  /**
   * Parses a string literal, staring with single or double quotes with basic support for escape codes
   * e.g. `"hello world"`, `'this is\nJSEP'`
   * @returns {jsep.Literal}
   */
  gobbleStringLiteral() {
    let str = "";
    const startIndex = this.index;
    const quote = this.expr.charAt(this.index++);
    let closed = false;
    while (this.index < this.expr.length) {
      let ch = this.expr.charAt(this.index++);
      if (ch === quote) {
        closed = true;
        break;
      } else if (ch === "\\") {
        ch = this.expr.charAt(this.index++);
        switch (ch) {
          case "n":
            str += "\n";
            break;
          case "r":
            str += "\r";
            break;
          case "t":
            str += "	";
            break;
          case "b":
            str += "\b";
            break;
          case "f":
            str += "\f";
            break;
          case "v":
            str += "\v";
            break;
          default:
            str += ch;
        }
      } else {
        str += ch;
      }
    }
    if (!closed) {
      this.throwError('Unclosed quote after "' + str + '"');
    }
    return {
      type: Jsep.LITERAL,
      value: str,
      raw: this.expr.substring(startIndex, this.index)
    };
  }
  /**
   * Gobbles only identifiers
   * e.g.: `foo`, `_value`, `$x1`
   * Also, this function checks if that identifier is a literal:
   * (e.g. `true`, `false`, `null`) or `this`
   * @returns {jsep.Identifier}
   */
  gobbleIdentifier() {
    let ch = this.code, start4 = this.index;
    if (Jsep.isIdentifierStart(ch)) {
      this.index++;
    } else {
      this.throwError("Unexpected " + this.char);
    }
    while (this.index < this.expr.length) {
      ch = this.code;
      if (Jsep.isIdentifierPart(ch)) {
        this.index++;
      } else {
        break;
      }
    }
    return {
      type: Jsep.IDENTIFIER,
      name: this.expr.slice(start4, this.index)
    };
  }
  /**
   * Gobbles a list of arguments within the context of a function call
   * or array literal. This function also assumes that the opening character
   * `(` or `[` has already been gobbled, and gobbles expressions and commas
   * until the terminator character `)` or `]` is encountered.
   * e.g. `foo(bar, baz)`, `my_func()`, or `[bar, baz]`
   * @param {number} termination
   * @returns {jsep.Expression[]}
   */
  gobbleArguments(termination) {
    const args = [];
    let closed = false;
    let separator_count = 0;
    while (this.index < this.expr.length) {
      this.gobbleSpaces();
      let ch_i = this.code;
      if (ch_i === termination) {
        closed = true;
        this.index++;
        if (termination === Jsep.CPAREN_CODE && separator_count && separator_count >= args.length) {
          this.throwError("Unexpected token " + String.fromCharCode(termination));
        }
        break;
      } else if (ch_i === Jsep.COMMA_CODE) {
        this.index++;
        separator_count++;
        if (separator_count !== args.length) {
          if (termination === Jsep.CPAREN_CODE) {
            this.throwError("Unexpected token ,");
          } else if (termination === Jsep.CBRACK_CODE) {
            for (let arg = args.length; arg < separator_count; arg++) {
              args.push(null);
            }
          }
        }
      } else if (args.length !== separator_count && separator_count !== 0) {
        this.throwError("Expected comma");
      } else {
        const node2 = this.gobbleExpression();
        if (!node2 || node2.type === Jsep.COMPOUND) {
          this.throwError("Expected comma");
        }
        args.push(node2);
      }
    }
    if (!closed) {
      this.throwError("Expected " + String.fromCharCode(termination));
    }
    return args;
  }
  /**
   * Responsible for parsing a group of things within parentheses `()`
   * that have no identifier in front (so not a function call)
   * This function assumes that it needs to gobble the opening parenthesis
   * and then tries to gobble everything within that parenthesis, assuming
   * that the next thing it should see is the close parenthesis. If not,
   * then the expression probably doesn't have a `)`
   * @returns {boolean|jsep.Expression}
   */
  gobbleGroup() {
    this.index++;
    let nodes = this.gobbleExpressions(Jsep.CPAREN_CODE);
    if (this.code === Jsep.CPAREN_CODE) {
      this.index++;
      if (nodes.length === 1) {
        return nodes[0];
      } else if (!nodes.length) {
        return false;
      } else {
        return {
          type: Jsep.SEQUENCE_EXP,
          expressions: nodes
        };
      }
    } else {
      this.throwError("Unclosed (");
    }
  }
  /**
   * Responsible for parsing Array literals `[1, 2, 3]`
   * This function assumes that it needs to gobble the opening bracket
   * and then tries to gobble the expressions as arguments.
   * @returns {jsep.ArrayExpression}
   */
  gobbleArray() {
    this.index++;
    return {
      type: Jsep.ARRAY_EXP,
      elements: this.gobbleArguments(Jsep.CBRACK_CODE)
    };
  }
}
const hooks$1 = new Hooks();
Object.assign(Jsep, {
  hooks: hooks$1,
  plugins: new Plugins(Jsep),
  // Node Types
  // ----------
  // This is the full set of types that any JSEP node can be.
  // Store them here to save space when minified
  COMPOUND: "Compound",
  SEQUENCE_EXP: "SequenceExpression",
  IDENTIFIER: "Identifier",
  MEMBER_EXP: "MemberExpression",
  LITERAL: "Literal",
  THIS_EXP: "ThisExpression",
  CALL_EXP: "CallExpression",
  UNARY_EXP: "UnaryExpression",
  BINARY_EXP: "BinaryExpression",
  ARRAY_EXP: "ArrayExpression",
  TAB_CODE: 9,
  LF_CODE: 10,
  CR_CODE: 13,
  SPACE_CODE: 32,
  PERIOD_CODE: 46,
  // '.'
  COMMA_CODE: 44,
  // ','
  SQUOTE_CODE: 39,
  // single quote
  DQUOTE_CODE: 34,
  // double quotes
  OPAREN_CODE: 40,
  // (
  CPAREN_CODE: 41,
  // )
  OBRACK_CODE: 91,
  // [
  CBRACK_CODE: 93,
  // ]
  QUMARK_CODE: 63,
  // ?
  SEMCOL_CODE: 59,
  // ;
  COLON_CODE: 58,
  // :
  // Operations
  // ----------
  // Use a quickly-accessible map to store all of the unary operators
  // Values are set to `1` (it really doesn't matter)
  unary_ops: {
    "-": 1,
    "!": 1,
    "~": 1,
    "+": 1
  },
  // Also use a map for the binary operations but set their values to their
  // binary precedence for quick reference (higher number = higher precedence)
  // see [Order of operations](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Operator_Precedence)
  binary_ops: {
    "||": 1,
    "??": 1,
    "&&": 2,
    "|": 3,
    "^": 4,
    "&": 5,
    "==": 6,
    "!=": 6,
    "===": 6,
    "!==": 6,
    "<": 7,
    ">": 7,
    "<=": 7,
    ">=": 7,
    "<<": 8,
    ">>": 8,
    ">>>": 8,
    "+": 9,
    "-": 9,
    "*": 10,
    "/": 10,
    "%": 10,
    "**": 11
  },
  // sets specific binary_ops as right-associative
  right_associative: /* @__PURE__ */ new Set(["**"]),
  // Additional valid identifier chars, apart from a-z, A-Z and 0-9 (except on the starting char)
  additional_identifier_chars: /* @__PURE__ */ new Set(["$", "_"]),
  // Literals
  // ----------
  // Store the values to return for the various literals we may encounter
  literals: {
    "true": true,
    "false": false,
    "null": null
  },
  // Except for `this`, which is special. This could be changed to something like `'self'` as well
  this_str: "this"
});
Jsep.max_unop_len = Jsep.getMaxKeyLen(Jsep.unary_ops);
Jsep.max_binop_len = Jsep.getMaxKeyLen(Jsep.binary_ops);
const jsep = (expr) => new Jsep(expr).parse();
const stdClassProps = Object.getOwnPropertyNames(class Test {
});
Object.getOwnPropertyNames(Jsep).filter((prop) => !stdClassProps.includes(prop) && jsep[prop] === void 0).forEach((m2) => {
  jsep[m2] = Jsep[m2];
});
jsep.Jsep = Jsep;
const CONDITIONAL_EXP = "ConditionalExpression";
var ternary = {
  name: "ternary",
  init(jsep2) {
    jsep2.hooks.add("after-expression", function gobbleTernary(env2) {
      if (env2.node && this.code === jsep2.QUMARK_CODE) {
        this.index++;
        const test = env2.node;
        const consequent = this.gobbleExpression();
        if (!consequent) {
          this.throwError("Expected expression");
        }
        this.gobbleSpaces();
        if (this.code === jsep2.COLON_CODE) {
          this.index++;
          const alternate = this.gobbleExpression();
          if (!alternate) {
            this.throwError("Expected expression");
          }
          env2.node = {
            type: CONDITIONAL_EXP,
            test,
            consequent,
            alternate
          };
          if (test.operator && jsep2.binary_ops[test.operator] <= 0.9) {
            let newTest = test;
            while (newTest.right.operator && jsep2.binary_ops[newTest.right.operator] <= 0.9) {
              newTest = newTest.right;
            }
            env2.node.test = newTest.right;
            newTest.right = env2.node;
            env2.node = test;
          }
        } else {
          this.throwError("Expected :");
        }
      }
    });
  }
};
jsep.plugins.register(ternary);
const FSLASH_CODE = 47;
const BSLASH_CODE = 92;
var index = {
  name: "regex",
  init(jsep2) {
    jsep2.hooks.add("gobble-token", function gobbleRegexLiteral(env2) {
      if (this.code === FSLASH_CODE) {
        const patternIndex = ++this.index;
        let inCharSet = false;
        while (this.index < this.expr.length) {
          if (this.code === FSLASH_CODE && !inCharSet) {
            const pattern = this.expr.slice(patternIndex, this.index);
            let flags = "";
            while (++this.index < this.expr.length) {
              const code = this.code;
              if (code >= 97 && code <= 122 || code >= 65 && code <= 90 || code >= 48 && code <= 57) {
                flags += this.char;
              } else {
                break;
              }
            }
            let value;
            try {
              value = new RegExp(pattern, flags);
            } catch (e) {
              this.throwError(e.message);
            }
            env2.node = {
              type: jsep2.LITERAL,
              value,
              raw: this.expr.slice(patternIndex - 1, this.index)
            };
            env2.node = this.gobbleTokenProperty(env2.node);
            return env2.node;
          }
          if (this.code === jsep2.OBRACK_CODE) {
            inCharSet = true;
          } else if (inCharSet && this.code === jsep2.CBRACK_CODE) {
            inCharSet = false;
          }
          this.index += this.code === BSLASH_CODE ? 2 : 1;
        }
        this.throwError("Unclosed Regex");
      }
    });
  }
};
const PLUS_CODE = 43;
const MINUS_CODE = 45;
const plugin = {
  name: "assignment",
  assignmentOperators: /* @__PURE__ */ new Set(["=", "*=", "**=", "/=", "%=", "+=", "-=", "<<=", ">>=", ">>>=", "&=", "^=", "|=", "||=", "&&=", "??="]),
  updateOperators: [PLUS_CODE, MINUS_CODE],
  assignmentPrecedence: 0.9,
  init(jsep2) {
    const updateNodeTypes = [jsep2.IDENTIFIER, jsep2.MEMBER_EXP];
    plugin.assignmentOperators.forEach((op) => jsep2.addBinaryOp(op, plugin.assignmentPrecedence, true));
    jsep2.hooks.add("gobble-token", function gobbleUpdatePrefix(env2) {
      const code = this.code;
      if (plugin.updateOperators.some((c2) => c2 === code && c2 === this.expr.charCodeAt(this.index + 1))) {
        this.index += 2;
        env2.node = {
          type: "UpdateExpression",
          operator: code === PLUS_CODE ? "++" : "--",
          argument: this.gobbleTokenProperty(this.gobbleIdentifier()),
          prefix: true
        };
        if (!env2.node.argument || !updateNodeTypes.includes(env2.node.argument.type)) {
          this.throwError(`Unexpected ${env2.node.operator}`);
        }
      }
    });
    jsep2.hooks.add("after-token", function gobbleUpdatePostfix(env2) {
      if (env2.node) {
        const code = this.code;
        if (plugin.updateOperators.some((c2) => c2 === code && c2 === this.expr.charCodeAt(this.index + 1))) {
          if (!updateNodeTypes.includes(env2.node.type)) {
            this.throwError(`Unexpected ${env2.node.operator}`);
          }
          this.index += 2;
          env2.node = {
            type: "UpdateExpression",
            operator: code === PLUS_CODE ? "++" : "--",
            argument: env2.node,
            prefix: false
          };
        }
      }
    });
    jsep2.hooks.add("after-expression", function gobbleAssignment(env2) {
      if (env2.node) {
        updateBinariesToAssignments(env2.node);
      }
    });
    function updateBinariesToAssignments(node2) {
      if (plugin.assignmentOperators.has(node2.operator)) {
        node2.type = "AssignmentExpression";
        updateBinariesToAssignments(node2.left);
        updateBinariesToAssignments(node2.right);
      } else if (!node2.operator) {
        Object.values(node2).forEach((val) => {
          if (val && typeof val === "object") {
            updateBinariesToAssignments(val);
          }
        });
      }
    }
  }
};
jsep.plugins.register(index, plugin);
jsep.addUnaryOp("typeof");
jsep.addLiteral("null", null);
jsep.addLiteral("undefined", void 0);
const BLOCKED_PROTO_PROPERTIES = /* @__PURE__ */ new Set(["constructor", "__proto__", "__defineGetter__", "__defineSetter__"]);
const SafeEval = {
  /**
   * @param {jsep.Expression} ast
   * @param {Record<string, any>} subs
   */
  evalAst(ast, subs) {
    switch (ast.type) {
      case "BinaryExpression":
      case "LogicalExpression":
        return SafeEval.evalBinaryExpression(ast, subs);
      case "Compound":
        return SafeEval.evalCompound(ast, subs);
      case "ConditionalExpression":
        return SafeEval.evalConditionalExpression(ast, subs);
      case "Identifier":
        return SafeEval.evalIdentifier(ast, subs);
      case "Literal":
        return SafeEval.evalLiteral(ast, subs);
      case "MemberExpression":
        return SafeEval.evalMemberExpression(ast, subs);
      case "UnaryExpression":
        return SafeEval.evalUnaryExpression(ast, subs);
      case "ArrayExpression":
        return SafeEval.evalArrayExpression(ast, subs);
      case "CallExpression":
        return SafeEval.evalCallExpression(ast, subs);
      case "AssignmentExpression":
        return SafeEval.evalAssignmentExpression(ast, subs);
      default:
        throw SyntaxError("Unexpected expression", ast);
    }
  },
  evalBinaryExpression(ast, subs) {
    const result = {
      "||": (a2, b2) => a2 || b2(),
      "&&": (a2, b2) => a2 && b2(),
      "|": (a2, b2) => a2 | b2(),
      "^": (a2, b2) => a2 ^ b2(),
      "&": (a2, b2) => a2 & b2(),
      // eslint-disable-next-line eqeqeq -- API
      "==": (a2, b2) => a2 == b2(),
      // eslint-disable-next-line eqeqeq -- API
      "!=": (a2, b2) => a2 != b2(),
      "===": (a2, b2) => a2 === b2(),
      "!==": (a2, b2) => a2 !== b2(),
      "<": (a2, b2) => a2 < b2(),
      ">": (a2, b2) => a2 > b2(),
      "<=": (a2, b2) => a2 <= b2(),
      ">=": (a2, b2) => a2 >= b2(),
      "<<": (a2, b2) => a2 << b2(),
      ">>": (a2, b2) => a2 >> b2(),
      ">>>": (a2, b2) => a2 >>> b2(),
      "+": (a2, b2) => a2 + b2(),
      "-": (a2, b2) => a2 - b2(),
      "*": (a2, b2) => a2 * b2(),
      "/": (a2, b2) => a2 / b2(),
      "%": (a2, b2) => a2 % b2()
    }[ast.operator](SafeEval.evalAst(ast.left, subs), () => SafeEval.evalAst(ast.right, subs));
    return result;
  },
  evalCompound(ast, subs) {
    let last;
    for (let i = 0; i < ast.body.length; i++) {
      if (ast.body[i].type === "Identifier" && ["var", "let", "const"].includes(ast.body[i].name) && ast.body[i + 1] && ast.body[i + 1].type === "AssignmentExpression") {
        i += 1;
      }
      const expr = ast.body[i];
      last = SafeEval.evalAst(expr, subs);
    }
    return last;
  },
  evalConditionalExpression(ast, subs) {
    if (SafeEval.evalAst(ast.test, subs)) {
      return SafeEval.evalAst(ast.consequent, subs);
    }
    return SafeEval.evalAst(ast.alternate, subs);
  },
  evalIdentifier(ast, subs) {
    if (Object.hasOwn(subs, ast.name)) {
      return subs[ast.name];
    }
    throw ReferenceError(`${ast.name} is not defined`);
  },
  evalLiteral(ast) {
    return ast.value;
  },
  evalMemberExpression(ast, subs) {
    const prop = String(
      // NOTE: `String(value)` throws error when
      // value has overwritten the toString method to return non-string
      // i.e. `value = {toString: () => []}`
      ast.computed ? SafeEval.evalAst(ast.property) : ast.property.name
      // `object.property` property is Identifier
    );
    const obj = SafeEval.evalAst(ast.object, subs);
    if (obj === void 0 || obj === null) {
      throw TypeError(`Cannot read properties of ${obj} (reading '${prop}')`);
    }
    if (!Object.hasOwn(obj, prop) && BLOCKED_PROTO_PROPERTIES.has(prop)) {
      throw TypeError(`Cannot read properties of ${obj} (reading '${prop}')`);
    }
    const result = obj[prop];
    if (typeof result === "function") {
      return result.bind(obj);
    }
    return result;
  },
  evalUnaryExpression(ast, subs) {
    const result = {
      "-": (a2) => -SafeEval.evalAst(a2, subs),
      "!": (a2) => !SafeEval.evalAst(a2, subs),
      "~": (a2) => ~SafeEval.evalAst(a2, subs),
      // eslint-disable-next-line no-implicit-coercion -- API
      "+": (a2) => +SafeEval.evalAst(a2, subs),
      typeof: (a2) => typeof SafeEval.evalAst(a2, subs)
    }[ast.operator](ast.argument);
    return result;
  },
  evalArrayExpression(ast, subs) {
    return ast.elements.map((el) => SafeEval.evalAst(el, subs));
  },
  evalCallExpression(ast, subs) {
    const args = ast.arguments.map((arg) => SafeEval.evalAst(arg, subs));
    const func = SafeEval.evalAst(ast.callee, subs);
    return func(...args);
  },
  evalAssignmentExpression(ast, subs) {
    if (ast.left.type !== "Identifier") {
      throw SyntaxError("Invalid left-hand side in assignment");
    }
    const id = ast.left.name;
    const value = SafeEval.evalAst(ast.right, subs);
    subs[id] = value;
    return subs[id];
  }
};
class SafeScript {
  /**
   * @param {string} expr Expression to evaluate
   */
  constructor(expr) {
    this.code = expr;
    this.ast = jsep(this.code);
  }
  /**
   * @param {object} context Object whose items will be added
   *   to evaluation
   * @returns {EvaluatedResult} Result of evaluated code
   */
  runInNewContext(context) {
    const keyMap = Object.assign(/* @__PURE__ */ Object.create(null), context);
    return SafeEval.evalAst(this.ast, keyMap);
  }
}
function push(arr, item) {
  arr = arr.slice();
  arr.push(item);
  return arr;
}
function unshift(item, arr) {
  arr = arr.slice();
  arr.unshift(item);
  return arr;
}
class NewError extends Error {
  /**
   * @param {AnyResult} value The evaluated scalar value
   */
  constructor(value) {
    super('JSONPath should not be called with "new" (it prevents return of (unwrapped) scalar values)');
    this.avoidNew = true;
    this.value = value;
    this.name = "NewError";
  }
}
function JSONPath(opts, expr, obj, callback, otherTypeCallback) {
  if (!(this instanceof JSONPath)) {
    try {
      return new JSONPath(opts, expr, obj, callback, otherTypeCallback);
    } catch (e) {
      if (!e.avoidNew) {
        throw e;
      }
      return e.value;
    }
  }
  if (typeof opts === "string") {
    otherTypeCallback = callback;
    callback = obj;
    obj = expr;
    expr = opts;
    opts = null;
  }
  const optObj = opts && typeof opts === "object";
  opts = opts || {};
  this.json = opts.json || obj;
  this.path = opts.path || expr;
  this.resultType = opts.resultType || "value";
  this.flatten = opts.flatten || false;
  this.wrap = Object.hasOwn(opts, "wrap") ? opts.wrap : true;
  this.sandbox = opts.sandbox || {};
  this.eval = opts.eval === void 0 ? "safe" : opts.eval;
  this.ignoreEvalErrors = typeof opts.ignoreEvalErrors === "undefined" ? false : opts.ignoreEvalErrors;
  this.parent = opts.parent || null;
  this.parentProperty = opts.parentProperty || null;
  this.callback = opts.callback || callback || null;
  this.otherTypeCallback = opts.otherTypeCallback || otherTypeCallback || function() {
    throw new TypeError("You must supply an otherTypeCallback callback option with the @other() operator.");
  };
  if (opts.autostart !== false) {
    const args = {
      path: optObj ? opts.path : expr
    };
    if (!optObj) {
      args.json = obj;
    } else if ("json" in opts) {
      args.json = opts.json;
    }
    const ret = this.evaluate(args);
    if (!ret || typeof ret !== "object") {
      throw new NewError(ret);
    }
    return ret;
  }
}
JSONPath.prototype.evaluate = function(expr, json, callback, otherTypeCallback) {
  let currParent = this.parent, currParentProperty = this.parentProperty;
  let {
    flatten,
    wrap: wrap2
  } = this;
  this.currResultType = this.resultType;
  this.currEval = this.eval;
  this.currSandbox = this.sandbox;
  callback = callback || this.callback;
  this.currOtherTypeCallback = otherTypeCallback || this.otherTypeCallback;
  json = json || this.json;
  expr = expr || this.path;
  if (expr && typeof expr === "object" && !Array.isArray(expr)) {
    if (!expr.path && expr.path !== "") {
      throw new TypeError('You must supply a "path" property when providing an object argument to JSONPath.evaluate().');
    }
    if (!Object.hasOwn(expr, "json")) {
      throw new TypeError('You must supply a "json" property when providing an object argument to JSONPath.evaluate().');
    }
    ({
      json
    } = expr);
    flatten = Object.hasOwn(expr, "flatten") ? expr.flatten : flatten;
    this.currResultType = Object.hasOwn(expr, "resultType") ? expr.resultType : this.currResultType;
    this.currSandbox = Object.hasOwn(expr, "sandbox") ? expr.sandbox : this.currSandbox;
    wrap2 = Object.hasOwn(expr, "wrap") ? expr.wrap : wrap2;
    this.currEval = Object.hasOwn(expr, "eval") ? expr.eval : this.currEval;
    callback = Object.hasOwn(expr, "callback") ? expr.callback : callback;
    this.currOtherTypeCallback = Object.hasOwn(expr, "otherTypeCallback") ? expr.otherTypeCallback : this.currOtherTypeCallback;
    currParent = Object.hasOwn(expr, "parent") ? expr.parent : currParent;
    currParentProperty = Object.hasOwn(expr, "parentProperty") ? expr.parentProperty : currParentProperty;
    expr = expr.path;
  }
  currParent = currParent || null;
  currParentProperty = currParentProperty || null;
  if (Array.isArray(expr)) {
    expr = JSONPath.toPathString(expr);
  }
  if (!expr && expr !== "" || !json) {
    return void 0;
  }
  const exprList = JSONPath.toPathArray(expr);
  if (exprList[0] === "$" && exprList.length > 1) {
    exprList.shift();
  }
  this._hasParentSelector = null;
  const result = this._trace(exprList, json, ["$"], currParent, currParentProperty, callback).filter(function(ea) {
    return ea && !ea.isParentSelector;
  });
  if (!result.length) {
    return wrap2 ? [] : void 0;
  }
  if (!wrap2 && result.length === 1 && !result[0].hasArrExpr) {
    return this._getPreferredOutput(result[0]);
  }
  return result.reduce((rslt, ea) => {
    const valOrPath = this._getPreferredOutput(ea);
    if (flatten && Array.isArray(valOrPath)) {
      rslt = rslt.concat(valOrPath);
    } else {
      rslt.push(valOrPath);
    }
    return rslt;
  }, []);
};
JSONPath.prototype._getPreferredOutput = function(ea) {
  const resultType = this.currResultType;
  switch (resultType) {
    case "all": {
      const path2 = Array.isArray(ea.path) ? ea.path : JSONPath.toPathArray(ea.path);
      ea.pointer = JSONPath.toPointer(path2);
      ea.path = typeof ea.path === "string" ? ea.path : JSONPath.toPathString(ea.path);
      return ea;
    }
    case "value":
    case "parent":
    case "parentProperty":
      return ea[resultType];
    case "path":
      return JSONPath.toPathString(ea[resultType]);
    case "pointer":
      return JSONPath.toPointer(ea.path);
    default:
      throw new TypeError("Unknown result type");
  }
};
JSONPath.prototype._handleCallback = function(fullRetObj, callback, type) {
  if (callback) {
    const preferredOutput = this._getPreferredOutput(fullRetObj);
    fullRetObj.path = typeof fullRetObj.path === "string" ? fullRetObj.path : JSONPath.toPathString(fullRetObj.path);
    callback(preferredOutput, type, fullRetObj);
  }
};
JSONPath.prototype._trace = function(expr, val, path2, parent2, parentPropName, callback, hasArrExpr, literalPriority) {
  let retObj;
  if (!expr.length) {
    retObj = {
      path: path2,
      value: val,
      parent: parent2,
      parentProperty: parentPropName,
      hasArrExpr
    };
    this._handleCallback(retObj, callback, "value");
    return retObj;
  }
  const loc = expr[0], x2 = expr.slice(1);
  const ret = [];
  function addRet(elems) {
    if (Array.isArray(elems)) {
      elems.forEach((t2) => {
        ret.push(t2);
      });
    } else {
      ret.push(elems);
    }
  }
  if ((typeof loc !== "string" || literalPriority) && val && Object.hasOwn(val, loc)) {
    addRet(this._trace(x2, val[loc], push(path2, loc), val, loc, callback, hasArrExpr));
  } else if (loc === "*") {
    this._walk(val, (m2) => {
      addRet(this._trace(x2, val[m2], push(path2, m2), val, m2, callback, true, true));
    });
  } else if (loc === "..") {
    addRet(this._trace(x2, val, path2, parent2, parentPropName, callback, hasArrExpr));
    this._walk(val, (m2) => {
      if (typeof val[m2] === "object") {
        addRet(this._trace(expr.slice(), val[m2], push(path2, m2), val, m2, callback, true));
      }
    });
  } else if (loc === "^") {
    this._hasParentSelector = true;
    return {
      path: path2.slice(0, -1),
      expr: x2,
      isParentSelector: true
    };
  } else if (loc === "~") {
    retObj = {
      path: push(path2, loc),
      value: parentPropName,
      parent: parent2,
      parentProperty: null
    };
    this._handleCallback(retObj, callback, "property");
    return retObj;
  } else if (loc === "$") {
    addRet(this._trace(x2, val, path2, null, null, callback, hasArrExpr));
  } else if (/^(-?\d*):(-?\d*):?(\d*)$/u.test(loc)) {
    addRet(this._slice(loc, x2, val, path2, parent2, parentPropName, callback));
  } else if (loc.indexOf("?(") === 0) {
    if (this.currEval === false) {
      throw new Error("Eval [?(expr)] prevented in JSONPath expression.");
    }
    const safeLoc = loc.replace(/^\?\((.*?)\)$/u, "$1");
    const nested = /@.?([^?]*)[['](\??\(.*?\))(?!.\)\])[\]']/gu.exec(safeLoc);
    if (nested) {
      this._walk(val, (m2) => {
        const npath = [nested[2]];
        const nvalue = nested[1] ? val[m2][nested[1]] : val[m2];
        const filterResults = this._trace(npath, nvalue, path2, parent2, parentPropName, callback, true);
        if (filterResults.length > 0) {
          addRet(this._trace(x2, val[m2], push(path2, m2), val, m2, callback, true));
        }
      });
    } else {
      this._walk(val, (m2) => {
        if (this._eval(safeLoc, val[m2], m2, path2, parent2, parentPropName)) {
          addRet(this._trace(x2, val[m2], push(path2, m2), val, m2, callback, true));
        }
      });
    }
  } else if (loc[0] === "(") {
    if (this.currEval === false) {
      throw new Error("Eval [(expr)] prevented in JSONPath expression.");
    }
    addRet(this._trace(unshift(this._eval(loc, val, path2.at(-1), path2.slice(0, -1), parent2, parentPropName), x2), val, path2, parent2, parentPropName, callback, hasArrExpr));
  } else if (loc[0] === "@") {
    let addType = false;
    const valueType = loc.slice(1, -2);
    switch (valueType) {
      case "scalar":
        if (!val || !["object", "function"].includes(typeof val)) {
          addType = true;
        }
        break;
      case "boolean":
      case "string":
      case "undefined":
      case "function":
        if (typeof val === valueType) {
          addType = true;
        }
        break;
      case "integer":
        if (Number.isFinite(val) && !(val % 1)) {
          addType = true;
        }
        break;
      case "number":
        if (Number.isFinite(val)) {
          addType = true;
        }
        break;
      case "nonFinite":
        if (typeof val === "number" && !Number.isFinite(val)) {
          addType = true;
        }
        break;
      case "object":
        if (val && typeof val === valueType) {
          addType = true;
        }
        break;
      case "array":
        if (Array.isArray(val)) {
          addType = true;
        }
        break;
      case "other":
        addType = this.currOtherTypeCallback(val, path2, parent2, parentPropName);
        break;
      case "null":
        if (val === null) {
          addType = true;
        }
        break;
      /* c8 ignore next 2 */
      default:
        throw new TypeError("Unknown value type " + valueType);
    }
    if (addType) {
      retObj = {
        path: path2,
        value: val,
        parent: parent2,
        parentProperty: parentPropName
      };
      this._handleCallback(retObj, callback, "value");
      return retObj;
    }
  } else if (loc[0] === "`" && val && Object.hasOwn(val, loc.slice(1))) {
    const locProp = loc.slice(1);
    addRet(this._trace(x2, val[locProp], push(path2, locProp), val, locProp, callback, hasArrExpr, true));
  } else if (loc.includes(",")) {
    const parts = loc.split(",");
    for (const part of parts) {
      addRet(this._trace(unshift(part, x2), val, path2, parent2, parentPropName, callback, true));
    }
  } else if (!literalPriority && val && Object.hasOwn(val, loc)) {
    addRet(this._trace(x2, val[loc], push(path2, loc), val, loc, callback, hasArrExpr, true));
  }
  if (this._hasParentSelector) {
    for (let t2 = 0; t2 < ret.length; t2++) {
      const rett = ret[t2];
      if (rett && rett.isParentSelector) {
        const tmp = this._trace(rett.expr, val, rett.path, parent2, parentPropName, callback, hasArrExpr);
        if (Array.isArray(tmp)) {
          ret[t2] = tmp[0];
          const tl = tmp.length;
          for (let tt2 = 1; tt2 < tl; tt2++) {
            t2++;
            ret.splice(t2, 0, tmp[tt2]);
          }
        } else {
          ret[t2] = tmp;
        }
      }
    }
  }
  return ret;
};
JSONPath.prototype._walk = function(val, f2) {
  if (Array.isArray(val)) {
    const n2 = val.length;
    for (let i = 0; i < n2; i++) {
      f2(i);
    }
  } else if (val && typeof val === "object") {
    Object.keys(val).forEach((m2) => {
      f2(m2);
    });
  }
};
JSONPath.prototype._slice = function(loc, expr, val, path2, parent2, parentPropName, callback) {
  if (!Array.isArray(val)) {
    return void 0;
  }
  const len = val.length, parts = loc.split(":"), step = parts[2] && Number.parseInt(parts[2]) || 1;
  let start4 = parts[0] && Number.parseInt(parts[0]) || 0, end2 = parts[1] && Number.parseInt(parts[1]) || len;
  start4 = start4 < 0 ? Math.max(0, start4 + len) : Math.min(len, start4);
  end2 = end2 < 0 ? Math.max(0, end2 + len) : Math.min(len, end2);
  const ret = [];
  for (let i = start4; i < end2; i += step) {
    const tmp = this._trace(unshift(i, expr), val, path2, parent2, parentPropName, callback, true);
    tmp.forEach((t2) => {
      ret.push(t2);
    });
  }
  return ret;
};
JSONPath.prototype._eval = function(code, _v, _vname, path2, parent2, parentPropName) {
  this.currSandbox._$_parentProperty = parentPropName;
  this.currSandbox._$_parent = parent2;
  this.currSandbox._$_property = _vname;
  this.currSandbox._$_root = this.json;
  this.currSandbox._$_v = _v;
  const containsPath = code.includes("@path");
  if (containsPath) {
    this.currSandbox._$_path = JSONPath.toPathString(path2.concat([_vname]));
  }
  const scriptCacheKey = this.currEval + "Script:" + code;
  if (!JSONPath.cache[scriptCacheKey]) {
    let script = code.replaceAll("@parentProperty", "_$_parentProperty").replaceAll("@parent", "_$_parent").replaceAll("@property", "_$_property").replaceAll("@root", "_$_root").replaceAll(/@([.\s)[])/gu, "_$_v$1");
    if (containsPath) {
      script = script.replaceAll("@path", "_$_path");
    }
    if (this.currEval === "safe" || this.currEval === true || this.currEval === void 0) {
      JSONPath.cache[scriptCacheKey] = new this.safeVm.Script(script);
    } else if (this.currEval === "native") {
      JSONPath.cache[scriptCacheKey] = new this.vm.Script(script);
    } else if (typeof this.currEval === "function" && this.currEval.prototype && Object.hasOwn(this.currEval.prototype, "runInNewContext")) {
      const CurrEval = this.currEval;
      JSONPath.cache[scriptCacheKey] = new CurrEval(script);
    } else if (typeof this.currEval === "function") {
      JSONPath.cache[scriptCacheKey] = {
        runInNewContext: (context) => this.currEval(script, context)
      };
    } else {
      throw new TypeError(`Unknown "eval" property "${this.currEval}"`);
    }
  }
  try {
    return JSONPath.cache[scriptCacheKey].runInNewContext(this.currSandbox);
  } catch (e) {
    if (this.ignoreEvalErrors) {
      return false;
    }
    throw new Error("jsonPath: " + e.message + ": " + code);
  }
};
JSONPath.cache = {};
JSONPath.toPathString = function(pathArr) {
  const x2 = pathArr, n2 = x2.length;
  let p2 = "$";
  for (let i = 1; i < n2; i++) {
    if (!/^(~|\^|@.*?\(\))$/u.test(x2[i])) {
      p2 += /^[0-9*]+$/u.test(x2[i]) ? "[" + x2[i] + "]" : "['" + x2[i] + "']";
    }
  }
  return p2;
};
JSONPath.toPointer = function(pointer) {
  const x2 = pointer, n2 = x2.length;
  let p2 = "";
  for (let i = 1; i < n2; i++) {
    if (!/^(~|\^|@.*?\(\))$/u.test(x2[i])) {
      p2 += "/" + x2[i].toString().replaceAll("~", "~0").replaceAll("/", "~1");
    }
  }
  return p2;
};
JSONPath.toPathArray = function(expr) {
  const {
    cache
  } = JSONPath;
  if (cache[expr]) {
    return cache[expr].concat();
  }
  const subx = [];
  const normalized = expr.replaceAll(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/gu, ";$&;").replaceAll(/[['](\??\(.*?\))[\]'](?!.\])/gu, function($0, $1) {
    return "[#" + (subx.push($1) - 1) + "]";
  }).replaceAll(/\[['"]([^'\]]*)['"]\]/gu, function($0, prop) {
    return "['" + prop.replaceAll(".", "%@%").replaceAll("~", "%%@@%%") + "']";
  }).replaceAll("~", ";~;").replaceAll(/['"]?\.['"]?(?![^[]*\])|\[['"]?/gu, ";").replaceAll("%@%", ".").replaceAll("%%@@%%", "~").replaceAll(/(?:;)?(\^+)(?:;)?/gu, function($0, ups) {
    return ";" + ups.split("").join(";") + ";";
  }).replaceAll(/;;;|;;/gu, ";..;").replaceAll(/;$|'?\]|'$/gu, "");
  const exprList = normalized.split(";").map(function(exp) {
    const match5 = exp.match(/#(\d+)/u);
    return !match5 || !match5[1] ? exp : subx[match5[1]];
  });
  cache[expr] = exprList;
  return cache[expr].concat();
};
JSONPath.prototype.safeVm = {
  Script: SafeScript
};
const moveToAnotherArray = function(source, target, conditionCb) {
  const il = source.length;
  for (let i = 0; i < il; i++) {
    const item = source[i];
    if (conditionCb(item)) {
      target.push(source.splice(i--, 1)[0]);
    }
  }
};
class Script {
  /**
   * @param {string} expr Expression to evaluate
   */
  constructor(expr) {
    this.code = expr;
  }
  /**
   * @param {object} context Object whose items will be added
   *   to evaluation
   * @returns {EvaluatedResult} Result of evaluated code
   */
  runInNewContext(context) {
    let expr = this.code;
    const keys2 = Object.keys(context);
    const funcs = [];
    moveToAnotherArray(keys2, funcs, (key2) => {
      return typeof context[key2] === "function";
    });
    const values2 = keys2.map((vr) => {
      return context[vr];
    });
    const funcString = funcs.reduce((s2, func) => {
      let fString = context[func].toString();
      if (!/function/u.test(fString)) {
        fString = "function " + fString;
      }
      return "var " + func + "=" + fString + ";" + s2;
    }, "");
    expr = funcString + expr;
    if (!/(['"])use strict\1/u.test(expr) && !keys2.includes("arguments")) {
      expr = "var arguments = undefined;" + expr;
    }
    expr = expr.replace(/;\s*$/u, "");
    const lastStatementEnd = expr.lastIndexOf(";");
    const code = lastStatementEnd !== -1 ? expr.slice(0, lastStatementEnd + 1) + " return " + expr.slice(lastStatementEnd + 1) : " return " + expr;
    return new Function(...keys2, code)(...values2);
  }
}
JSONPath.prototype.vm = {
  Script
};
class JSONRepairError extends Error {
  constructor(message2, position4) {
    super(`${message2} at position ${position4}`);
    this.position = position4;
  }
}
const codeSpace = 32;
const codeNewline = 10;
const codeTab = 9;
const codeReturn = 13;
const codeNonBreakingSpace = 160;
const codeEnQuad = 8192;
const codeHairSpace = 8202;
const codeNarrowNoBreakSpace = 8239;
const codeMediumMathematicalSpace = 8287;
const codeIdeographicSpace = 12288;
function isHex(char2) {
  return /^[0-9A-Fa-f]$/.test(char2);
}
function isDigit(char2) {
  return char2 >= "0" && char2 <= "9";
}
function isValidStringCharacter(char2) {
  return char2 >= " ";
}
function isDelimiter(char2) {
  return ",:[]/{}()\n+".includes(char2);
}
function isFunctionNameCharStart(char2) {
  return char2 >= "a" && char2 <= "z" || char2 >= "A" && char2 <= "Z" || char2 === "_" || char2 === "$";
}
function isFunctionNameChar(char2) {
  return char2 >= "a" && char2 <= "z" || char2 >= "A" && char2 <= "Z" || char2 === "_" || char2 === "$" || char2 >= "0" && char2 <= "9";
}
const regexUrlStart = /^(http|https|ftp|mailto|file|data|irc):\/\/$/;
const regexUrlChar = /^[A-Za-z0-9-._~:/?#@!$&'()*+;=]$/;
function isUnquotedStringDelimiter(char2) {
  return ",[]/{}\n+".includes(char2);
}
function isStartOfValue(char2) {
  return isQuote(char2) || regexStartOfValue.test(char2);
}
const regexStartOfValue = /^[[{\w-]$/;
function isControlCharacter(char2) {
  return char2 === "\n" || char2 === "\r" || char2 === "	" || char2 === "\b" || char2 === "\f";
}
function isWhitespace(text2, index2) {
  const code = text2.charCodeAt(index2);
  return code === codeSpace || code === codeNewline || code === codeTab || code === codeReturn;
}
function isWhitespaceExceptNewline(text2, index2) {
  const code = text2.charCodeAt(index2);
  return code === codeSpace || code === codeTab || code === codeReturn;
}
function isSpecialWhitespace(text2, index2) {
  const code = text2.charCodeAt(index2);
  return code === codeNonBreakingSpace || code >= codeEnQuad && code <= codeHairSpace || code === codeNarrowNoBreakSpace || code === codeMediumMathematicalSpace || code === codeIdeographicSpace;
}
function isQuote(char2) {
  return isDoubleQuoteLike(char2) || isSingleQuoteLike(char2);
}
function isDoubleQuoteLike(char2) {
  return char2 === '"' || char2 === "“" || char2 === "”";
}
function isDoubleQuote(char2) {
  return char2 === '"';
}
function isSingleQuoteLike(char2) {
  return char2 === "'" || char2 === "‘" || char2 === "’" || char2 === "`" || char2 === "´";
}
function isSingleQuote(char2) {
  return char2 === "'";
}
function stripLastOccurrence(text2, textToStrip) {
  let stripRemainingText = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  const index2 = text2.lastIndexOf(textToStrip);
  return index2 !== -1 ? text2.substring(0, index2) + (stripRemainingText ? "" : text2.substring(index2 + 1)) : text2;
}
function insertBeforeLastWhitespace(text2, textToInsert) {
  let index2 = text2.length;
  if (!isWhitespace(text2, index2 - 1)) {
    return text2 + textToInsert;
  }
  while (isWhitespace(text2, index2 - 1)) {
    index2--;
  }
  return text2.substring(0, index2) + textToInsert + text2.substring(index2);
}
function removeAtIndex(text2, start4, count2) {
  return text2.substring(0, start4) + text2.substring(start4 + count2);
}
function endsWithCommaOrNewline(text2) {
  return /[,\n][ \t\r]*$/.test(text2);
}
const controlCharacters = {
  "\b": "\\b",
  "\f": "\\f",
  "\n": "\\n",
  "\r": "\\r",
  "	": "\\t"
};
const escapeCharacters = {
  '"': '"',
  "\\": "\\",
  "/": "/",
  b: "\b",
  f: "\f",
  n: "\n",
  r: "\r",
  t: "	"
  // note that \u is handled separately in parseString()
};
function jsonrepair(text2) {
  let i = 0;
  let output = "";
  parseMarkdownCodeBlock(["```", "[```", "{```"]);
  const processed = parseValue();
  if (!processed) {
    throwUnexpectedEnd();
  }
  parseMarkdownCodeBlock(["```", "```]", "```}"]);
  const processedComma = parseCharacter(",");
  if (processedComma) {
    parseWhitespaceAndSkipComments();
  }
  if (isStartOfValue(text2[i]) && endsWithCommaOrNewline(output)) {
    if (!processedComma) {
      output = insertBeforeLastWhitespace(output, ",");
    }
    parseNewlineDelimitedJSON();
  } else if (processedComma) {
    output = stripLastOccurrence(output, ",");
  }
  while (text2[i] === "}" || text2[i] === "]") {
    i++;
    parseWhitespaceAndSkipComments();
  }
  if (i >= text2.length) {
    return output;
  }
  throwUnexpectedCharacter();
  function parseValue() {
    parseWhitespaceAndSkipComments();
    const processed2 = parseObject() || parseArray() || parseString() || parseNumber() || parseKeywords() || parseUnquotedString(false) || parseRegex();
    parseWhitespaceAndSkipComments();
    return processed2;
  }
  function parseWhitespaceAndSkipComments() {
    let skipNewline = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    const start4 = i;
    let changed = parseWhitespace(skipNewline);
    do {
      changed = parseComment();
      if (changed) {
        changed = parseWhitespace(skipNewline);
      }
    } while (changed);
    return i > start4;
  }
  function parseWhitespace(skipNewline) {
    const _isWhiteSpace = skipNewline ? isWhitespace : isWhitespaceExceptNewline;
    let whitespace2 = "";
    while (true) {
      if (_isWhiteSpace(text2, i)) {
        whitespace2 += text2[i];
        i++;
      } else if (isSpecialWhitespace(text2, i)) {
        whitespace2 += " ";
        i++;
      } else {
        break;
      }
    }
    if (whitespace2.length > 0) {
      output += whitespace2;
      return true;
    }
    return false;
  }
  function parseComment() {
    if (text2[i] === "/" && text2[i + 1] === "*") {
      while (i < text2.length && !atEndOfBlockComment(text2, i)) {
        i++;
      }
      i += 2;
      return true;
    }
    if (text2[i] === "/" && text2[i + 1] === "/") {
      while (i < text2.length && text2[i] !== "\n") {
        i++;
      }
      return true;
    }
    return false;
  }
  function parseMarkdownCodeBlock(blocks) {
    if (skipMarkdownCodeBlock(blocks)) {
      if (isFunctionNameCharStart(text2[i])) {
        while (i < text2.length && isFunctionNameChar(text2[i])) {
          i++;
        }
      }
      parseWhitespaceAndSkipComments();
      return true;
    }
    return false;
  }
  function skipMarkdownCodeBlock(blocks) {
    for (const block2 of blocks) {
      const end2 = i + block2.length;
      if (text2.slice(i, end2) === block2) {
        i = end2;
        return true;
      }
    }
    return false;
  }
  function parseCharacter(char2) {
    if (text2[i] === char2) {
      output += text2[i];
      i++;
      return true;
    }
    return false;
  }
  function skipCharacter(char2) {
    if (text2[i] === char2) {
      i++;
      return true;
    }
    return false;
  }
  function skipEscapeCharacter() {
    return skipCharacter("\\");
  }
  function skipEllipsis() {
    parseWhitespaceAndSkipComments();
    if (text2[i] === "." && text2[i + 1] === "." && text2[i + 2] === ".") {
      i += 3;
      parseWhitespaceAndSkipComments();
      skipCharacter(",");
      return true;
    }
    return false;
  }
  function parseObject() {
    if (text2[i] === "{") {
      output += "{";
      i++;
      parseWhitespaceAndSkipComments();
      if (skipCharacter(",")) {
        parseWhitespaceAndSkipComments();
      }
      let initial = true;
      while (i < text2.length && text2[i] !== "}") {
        let processedComma2;
        if (!initial) {
          processedComma2 = parseCharacter(",");
          if (!processedComma2) {
            output = insertBeforeLastWhitespace(output, ",");
          }
          parseWhitespaceAndSkipComments();
        } else {
          processedComma2 = true;
          initial = false;
        }
        skipEllipsis();
        const processedKey = parseString() || parseUnquotedString(true);
        if (!processedKey) {
          if (text2[i] === "}" || text2[i] === "{" || text2[i] === "]" || text2[i] === "[" || text2[i] === void 0) {
            output = stripLastOccurrence(output, ",");
          } else {
            throwObjectKeyExpected();
          }
          break;
        }
        parseWhitespaceAndSkipComments();
        const processedColon = parseCharacter(":");
        const truncatedText = i >= text2.length;
        if (!processedColon) {
          if (isStartOfValue(text2[i]) || truncatedText) {
            output = insertBeforeLastWhitespace(output, ":");
          } else {
            throwColonExpected();
          }
        }
        const processedValue = parseValue();
        if (!processedValue) {
          if (processedColon || truncatedText) {
            output += "null";
          } else {
            throwColonExpected();
          }
        }
      }
      if (text2[i] === "}") {
        output += "}";
        i++;
      } else {
        output = insertBeforeLastWhitespace(output, "}");
      }
      return true;
    }
    return false;
  }
  function parseArray() {
    if (text2[i] === "[") {
      output += "[";
      i++;
      parseWhitespaceAndSkipComments();
      if (skipCharacter(",")) {
        parseWhitespaceAndSkipComments();
      }
      let initial = true;
      while (i < text2.length && text2[i] !== "]") {
        if (!initial) {
          const processedComma2 = parseCharacter(",");
          if (!processedComma2) {
            output = insertBeforeLastWhitespace(output, ",");
          }
        } else {
          initial = false;
        }
        skipEllipsis();
        const processedValue = parseValue();
        if (!processedValue) {
          output = stripLastOccurrence(output, ",");
          break;
        }
      }
      if (text2[i] === "]") {
        output += "]";
        i++;
      } else {
        output = insertBeforeLastWhitespace(output, "]");
      }
      return true;
    }
    return false;
  }
  function parseNewlineDelimitedJSON() {
    let initial = true;
    let processedValue = true;
    while (processedValue) {
      if (!initial) {
        const processedComma2 = parseCharacter(",");
        if (!processedComma2) {
          output = insertBeforeLastWhitespace(output, ",");
        }
      } else {
        initial = false;
      }
      processedValue = parseValue();
    }
    if (!processedValue) {
      output = stripLastOccurrence(output, ",");
    }
    output = `[
${output}
]`;
  }
  function parseString() {
    let stopAtDelimiter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    let stopAtIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
    let skipEscapeChars = text2[i] === "\\";
    if (skipEscapeChars) {
      i++;
      skipEscapeChars = true;
    }
    if (isQuote(text2[i])) {
      const isEndQuote = isDoubleQuote(text2[i]) ? isDoubleQuote : isSingleQuote(text2[i]) ? isSingleQuote : isSingleQuoteLike(text2[i]) ? isSingleQuoteLike : isDoubleQuoteLike;
      const iBefore = i;
      const oBefore = output.length;
      let str = '"';
      i++;
      while (true) {
        if (i >= text2.length) {
          const iPrev = prevNonWhitespaceIndex(i - 1);
          if (!stopAtDelimiter && isDelimiter(text2.charAt(iPrev))) {
            i = iBefore;
            output = output.substring(0, oBefore);
            return parseString(true);
          }
          str = insertBeforeLastWhitespace(str, '"');
          output += str;
          return true;
        }
        if (i === stopAtIndex) {
          str = insertBeforeLastWhitespace(str, '"');
          output += str;
          return true;
        }
        if (isEndQuote(text2[i])) {
          const iQuote = i;
          const oQuote = str.length;
          str += '"';
          i++;
          output += str;
          parseWhitespaceAndSkipComments(false);
          if (stopAtDelimiter || i >= text2.length || isDelimiter(text2[i]) || isQuote(text2[i]) || isDigit(text2[i])) {
            parseConcatenatedString();
            return true;
          }
          const iPrevChar = prevNonWhitespaceIndex(iQuote - 1);
          const prevChar = text2.charAt(iPrevChar);
          if (prevChar === ",") {
            i = iBefore;
            output = output.substring(0, oBefore);
            return parseString(false, iPrevChar);
          }
          if (isDelimiter(prevChar)) {
            i = iBefore;
            output = output.substring(0, oBefore);
            return parseString(true);
          }
          output = output.substring(0, oBefore);
          i = iQuote + 1;
          str = `${str.substring(0, oQuote)}\\${str.substring(oQuote)}`;
        } else if (stopAtDelimiter && isUnquotedStringDelimiter(text2[i])) {
          if (text2[i - 1] === ":" && regexUrlStart.test(text2.substring(iBefore + 1, i + 2))) {
            while (i < text2.length && regexUrlChar.test(text2[i])) {
              str += text2[i];
              i++;
            }
          }
          str = insertBeforeLastWhitespace(str, '"');
          output += str;
          parseConcatenatedString();
          return true;
        } else if (text2[i] === "\\") {
          const char2 = text2.charAt(i + 1);
          const escapeChar = escapeCharacters[char2];
          if (escapeChar !== void 0) {
            str += text2.slice(i, i + 2);
            i += 2;
          } else if (char2 === "u") {
            let j2 = 2;
            while (j2 < 6 && isHex(text2[i + j2])) {
              j2++;
            }
            if (j2 === 6) {
              str += text2.slice(i, i + 6);
              i += 6;
            } else if (i + j2 >= text2.length) {
              i = text2.length;
            } else {
              throwInvalidUnicodeCharacter();
            }
          } else {
            str += char2;
            i += 2;
          }
        } else {
          const char2 = text2.charAt(i);
          if (char2 === '"' && text2[i - 1] !== "\\") {
            str += `\\${char2}`;
            i++;
          } else if (isControlCharacter(char2)) {
            str += controlCharacters[char2];
            i++;
          } else {
            if (!isValidStringCharacter(char2)) {
              throwInvalidCharacter(char2);
            }
            str += char2;
            i++;
          }
        }
        if (skipEscapeChars) {
          skipEscapeCharacter();
        }
      }
    }
    return false;
  }
  function parseConcatenatedString() {
    let processed2 = false;
    parseWhitespaceAndSkipComments();
    while (text2[i] === "+") {
      processed2 = true;
      i++;
      parseWhitespaceAndSkipComments();
      output = stripLastOccurrence(output, '"', true);
      const start4 = output.length;
      const parsedStr = parseString();
      if (parsedStr) {
        output = removeAtIndex(output, start4, 1);
      } else {
        output = insertBeforeLastWhitespace(output, '"');
      }
    }
    return processed2;
  }
  function parseNumber() {
    const start4 = i;
    if (text2[i] === "-") {
      i++;
      if (atEndOfNumber()) {
        repairNumberEndingWithNumericSymbol(start4);
        return true;
      }
      if (!isDigit(text2[i])) {
        i = start4;
        return false;
      }
    }
    while (isDigit(text2[i])) {
      i++;
    }
    if (text2[i] === ".") {
      i++;
      if (atEndOfNumber()) {
        repairNumberEndingWithNumericSymbol(start4);
        return true;
      }
      if (!isDigit(text2[i])) {
        i = start4;
        return false;
      }
      while (isDigit(text2[i])) {
        i++;
      }
    }
    if (text2[i] === "e" || text2[i] === "E") {
      i++;
      if (text2[i] === "-" || text2[i] === "+") {
        i++;
      }
      if (atEndOfNumber()) {
        repairNumberEndingWithNumericSymbol(start4);
        return true;
      }
      if (!isDigit(text2[i])) {
        i = start4;
        return false;
      }
      while (isDigit(text2[i])) {
        i++;
      }
    }
    if (!atEndOfNumber()) {
      i = start4;
      return false;
    }
    if (i > start4) {
      const num = text2.slice(start4, i);
      const hasInvalidLeadingZero = /^0\d/.test(num);
      output += hasInvalidLeadingZero ? `"${num}"` : num;
      return true;
    }
    return false;
  }
  function parseKeywords() {
    return parseKeyword("true", "true") || parseKeyword("false", "false") || parseKeyword("null", "null") || // repair Python keywords True, False, None
    parseKeyword("True", "true") || parseKeyword("False", "false") || parseKeyword("None", "null");
  }
  function parseKeyword(name2, value) {
    if (text2.slice(i, i + name2.length) === name2) {
      output += value;
      i += name2.length;
      return true;
    }
    return false;
  }
  function parseUnquotedString(isKey2) {
    const start4 = i;
    if (isFunctionNameCharStart(text2[i])) {
      while (i < text2.length && isFunctionNameChar(text2[i])) {
        i++;
      }
      let j2 = i;
      while (isWhitespace(text2, j2)) {
        j2++;
      }
      if (text2[j2] === "(") {
        i = j2 + 1;
        parseValue();
        if (text2[i] === ")") {
          i++;
          if (text2[i] === ";") {
            i++;
          }
        }
        return true;
      }
    }
    while (i < text2.length && !isUnquotedStringDelimiter(text2[i]) && !isQuote(text2[i]) && (!isKey2 || text2[i] !== ":")) {
      i++;
    }
    if (text2[i - 1] === ":" && regexUrlStart.test(text2.substring(start4, i + 2))) {
      while (i < text2.length && regexUrlChar.test(text2[i])) {
        i++;
      }
    }
    if (i > start4) {
      while (isWhitespace(text2, i - 1) && i > 0) {
        i--;
      }
      const symbol = text2.slice(start4, i);
      output += symbol === "undefined" ? "null" : JSON.stringify(symbol);
      if (text2[i] === '"') {
        i++;
      }
      return true;
    }
  }
  function parseRegex() {
    if (text2[i] === "/") {
      const start4 = i;
      i++;
      while (i < text2.length && (text2[i] !== "/" || text2[i - 1] === "\\")) {
        i++;
      }
      i++;
      output += `"${text2.substring(start4, i)}"`;
      return true;
    }
  }
  function prevNonWhitespaceIndex(start4) {
    let prev2 = start4;
    while (prev2 > 0 && isWhitespace(text2, prev2)) {
      prev2--;
    }
    return prev2;
  }
  function atEndOfNumber() {
    return i >= text2.length || isDelimiter(text2[i]) || isWhitespace(text2, i);
  }
  function repairNumberEndingWithNumericSymbol(start4) {
    output += `${text2.slice(start4, i)}0`;
  }
  function throwInvalidCharacter(char2) {
    throw new JSONRepairError(`Invalid character ${JSON.stringify(char2)}`, i);
  }
  function throwUnexpectedCharacter() {
    throw new JSONRepairError(`Unexpected character ${JSON.stringify(text2[i])}`, i);
  }
  function throwUnexpectedEnd() {
    throw new JSONRepairError("Unexpected end of json string", text2.length);
  }
  function throwObjectKeyExpected() {
    throw new JSONRepairError("Object key expected", i);
  }
  function throwColonExpected() {
    throw new JSONRepairError("Colon expected", i);
  }
  function throwInvalidUnicodeCharacter() {
    const chars = text2.slice(i, i + 6);
    throw new JSONRepairError(`Invalid unicode character "${chars}"`, i);
  }
}
function atEndOfBlockComment(text2, i) {
  return text2[i] === "*" && text2[i + 1] === "/";
}
var util;
(function(util2) {
  util2.assertEqual = (_2) => {
  };
  function assertIs(_arg) {
  }
  util2.assertIs = assertIs;
  function assertNever(_x) {
    throw new Error();
  }
  util2.assertNever = assertNever;
  util2.arrayToEnum = (items) => {
    const obj = {};
    for (const item of items) {
      obj[item] = item;
    }
    return obj;
  };
  util2.getValidEnumValues = (obj) => {
    const validKeys = util2.objectKeys(obj).filter((k2) => typeof obj[obj[k2]] !== "number");
    const filtered = {};
    for (const k2 of validKeys) {
      filtered[k2] = obj[k2];
    }
    return util2.objectValues(filtered);
  };
  util2.objectValues = (obj) => {
    return util2.objectKeys(obj).map(function(e) {
      return obj[e];
    });
  };
  util2.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object) => {
    const keys2 = [];
    for (const key2 in object) {
      if (Object.prototype.hasOwnProperty.call(object, key2)) {
        keys2.push(key2);
      }
    }
    return keys2;
  };
  util2.find = (arr, checker) => {
    for (const item of arr) {
      if (checker(item))
        return item;
    }
    return void 0;
  };
  util2.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
  function joinValues(array, separator = " | ") {
    return array.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
  }
  util2.joinValues = joinValues;
  util2.jsonStringifyReplacer = (_2, value) => {
    if (typeof value === "bigint") {
      return value.toString();
    }
    return value;
  };
})(util || (util = {}));
var objectUtil;
(function(objectUtil2) {
  objectUtil2.mergeShapes = (first2, second) => {
    return {
      ...first2,
      ...second
      // second overwrites first
    };
  };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]);
const getParsedType = (data) => {
  const t2 = typeof data;
  switch (t2) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return Number.isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      if (Array.isArray(data)) {
        return ZodParsedType.array;
      }
      if (data === null) {
        return ZodParsedType.null;
      }
      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return ZodParsedType.promise;
      }
      if (typeof Map !== "undefined" && data instanceof Map) {
        return ZodParsedType.map;
      }
      if (typeof Set !== "undefined" && data instanceof Set) {
        return ZodParsedType.set;
      }
      if (typeof Date !== "undefined" && data instanceof Date) {
        return ZodParsedType.date;
      }
      return ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
};
const ZodIssueCode = util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
const quotelessJson = (obj) => {
  const json = JSON.stringify(obj, null, 2);
  return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
  get errors() {
    return this.issues;
  }
  constructor(issues) {
    super();
    this.issues = [];
    this.addIssue = (sub) => {
      this.issues = [...this.issues, sub];
    };
    this.addIssues = (subs = []) => {
      this.issues = [...this.issues, ...subs];
    };
    const actualProto = new.target.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      this.__proto__ = actualProto;
    }
    this.name = "ZodError";
    this.issues = issues;
  }
  format(_mapper) {
    const mapper = _mapper || function(issue) {
      return issue.message;
    };
    const fieldErrors = { _errors: [] };
    const processError = (error2) => {
      for (const issue of error2.issues) {
        if (issue.code === "invalid_union") {
          issue.unionErrors.map(processError);
        } else if (issue.code === "invalid_return_type") {
          processError(issue.returnTypeError);
        } else if (issue.code === "invalid_arguments") {
          processError(issue.argumentsError);
        } else if (issue.path.length === 0) {
          fieldErrors._errors.push(mapper(issue));
        } else {
          let curr = fieldErrors;
          let i = 0;
          while (i < issue.path.length) {
            const el = issue.path[i];
            const terminal = i === issue.path.length - 1;
            if (!terminal) {
              curr[el] = curr[el] || { _errors: [] };
            } else {
              curr[el] = curr[el] || { _errors: [] };
              curr[el]._errors.push(mapper(issue));
            }
            curr = curr[el];
            i++;
          }
        }
      }
    };
    processError(this);
    return fieldErrors;
  }
  static assert(value) {
    if (!(value instanceof ZodError)) {
      throw new Error(`Not a ZodError: ${value}`);
    }
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(mapper = (issue) => issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of this.issues) {
      if (sub.path.length > 0) {
        const firstEl = sub.path[0];
        fieldErrors[firstEl] = fieldErrors[firstEl] || [];
        fieldErrors[firstEl].push(mapper(sub));
      } else {
        formErrors.push(mapper(sub));
      }
    }
    return { formErrors, fieldErrors };
  }
  get formErrors() {
    return this.flatten();
  }
}
ZodError.create = (issues) => {
  const error2 = new ZodError(issues);
  return error2;
};
const errorMap = (issue, _ctx2) => {
  let message2;
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message2 = "Required";
      } else {
        message2 = `Expected ${issue.expected}, received ${issue.received}`;
      }
      break;
    case ZodIssueCode.invalid_literal:
      message2 = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      message2 = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      message2 = `Invalid input`;
      break;
    case ZodIssueCode.invalid_union_discriminator:
      message2 = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      message2 = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      message2 = `Invalid function arguments`;
      break;
    case ZodIssueCode.invalid_return_type:
      message2 = `Invalid function return type`;
      break;
    case ZodIssueCode.invalid_date:
      message2 = `Invalid date`;
      break;
    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === "object") {
        if ("includes" in issue.validation) {
          message2 = `Invalid input: must include "${issue.validation.includes}"`;
          if (typeof issue.validation.position === "number") {
            message2 = `${message2} at one or more positions greater than or equal to ${issue.validation.position}`;
          }
        } else if ("startsWith" in issue.validation) {
          message2 = `Invalid input: must start with "${issue.validation.startsWith}"`;
        } else if ("endsWith" in issue.validation) {
          message2 = `Invalid input: must end with "${issue.validation.endsWith}"`;
        } else {
          util.assertNever(issue.validation);
        }
      } else if (issue.validation !== "regex") {
        message2 = `Invalid ${issue.validation}`;
      } else {
        message2 = "Invalid";
      }
      break;
    case ZodIssueCode.too_small:
      if (issue.type === "array")
        message2 = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
      else if (issue.type === "string")
        message2 = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
      else if (issue.type === "number")
        message2 = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === "bigint")
        message2 = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === "date")
        message2 = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
      else
        message2 = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      if (issue.type === "array")
        message2 = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
      else if (issue.type === "string")
        message2 = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
      else if (issue.type === "number")
        message2 = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "bigint")
        message2 = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "date")
        message2 = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
      else
        message2 = "Invalid input";
      break;
    case ZodIssueCode.custom:
      message2 = `Invalid input`;
      break;
    case ZodIssueCode.invalid_intersection_types:
      message2 = `Intersection results could not be merged`;
      break;
    case ZodIssueCode.not_multiple_of:
      message2 = `Number must be a multiple of ${issue.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      message2 = "Number must be finite";
      break;
    default:
      message2 = _ctx2.defaultError;
      util.assertNever(issue);
  }
  return { message: message2 };
};
let overrideErrorMap = errorMap;
function setErrorMap(map3) {
  overrideErrorMap = map3;
}
function getErrorMap() {
  return overrideErrorMap;
}
const makeIssue = (params) => {
  const { data, path: path2, errorMaps, issueData } = params;
  const fullPath = [...path2, ...issueData.path || []];
  const fullIssue = {
    ...issueData,
    path: fullPath
  };
  if (issueData.message !== void 0) {
    return {
      ...issueData,
      path: fullPath,
      message: issueData.message
    };
  }
  let errorMessage = "";
  const maps = errorMaps.filter((m2) => !!m2).slice().reverse();
  for (const map3 of maps) {
    errorMessage = map3(fullIssue, { data, defaultError: errorMessage }).message;
  }
  return {
    ...issueData,
    path: fullPath,
    message: errorMessage
  };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
  const overrideMap = getErrorMap();
  const issue = makeIssue({
    issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [
      ctx.common.contextualErrorMap,
      // contextual error map is first priority
      ctx.schemaErrorMap,
      // then schema-bound map if available
      overrideMap,
      // then global override map
      overrideMap === errorMap ? void 0 : errorMap
      // then global default map
    ].filter((x2) => !!x2)
  });
  ctx.common.issues.push(issue);
}
class ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    if (this.value === "valid")
      this.value = "dirty";
  }
  abort() {
    if (this.value !== "aborted")
      this.value = "aborted";
  }
  static mergeArray(status, results) {
    const arrayValue = [];
    for (const s2 of results) {
      if (s2.status === "aborted")
        return INVALID;
      if (s2.status === "dirty")
        status.dirty();
      arrayValue.push(s2.value);
    }
    return { status: status.value, value: arrayValue };
  }
  static async mergeObjectAsync(status, pairs) {
    const syncPairs = [];
    for (const pair of pairs) {
      const key2 = await pair.key;
      const value = await pair.value;
      syncPairs.push({
        key: key2,
        value
      });
    }
    return ParseStatus.mergeObjectSync(status, syncPairs);
  }
  static mergeObjectSync(status, pairs) {
    const finalObject = {};
    for (const pair of pairs) {
      const { key: key2, value } = pair;
      if (key2.status === "aborted")
        return INVALID;
      if (value.status === "aborted")
        return INVALID;
      if (key2.status === "dirty")
        status.dirty();
      if (value.status === "dirty")
        status.dirty();
      if (key2.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
        finalObject[key2.value] = value.value;
      }
    }
    return { status: status.value, value: finalObject };
  }
}
const INVALID = Object.freeze({
  status: "aborted"
});
const DIRTY = (value) => ({ status: "dirty", value });
const OK = (value) => ({ status: "valid", value });
const isAborted = (x2) => x2.status === "aborted";
const isDirty = (x2) => x2.status === "dirty";
const isValid$3 = (x2) => x2.status === "valid";
const isAsync = (x2) => typeof Promise !== "undefined" && x2 instanceof Promise;
var errorUtil;
(function(errorUtil2) {
  errorUtil2.errToObj = (message2) => typeof message2 === "string" ? { message: message2 } : message2 || {};
  errorUtil2.toString = (message2) => typeof message2 === "string" ? message2 : message2 == null ? void 0 : message2.message;
})(errorUtil || (errorUtil = {}));
class ParseInputLazyPath {
  constructor(parent2, value, path2, key2) {
    this._cachedPath = [];
    this.parent = parent2;
    this.data = value;
    this._path = path2;
    this._key = key2;
  }
  get path() {
    if (!this._cachedPath.length) {
      if (Array.isArray(this._key)) {
        this._cachedPath.push(...this._path, ...this._key);
      } else {
        this._cachedPath.push(...this._path, this._key);
      }
    }
    return this._cachedPath;
  }
}
const handleResult = (ctx, result) => {
  if (isValid$3(result)) {
    return { success: true, data: result.value };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }
    return {
      success: false,
      get error() {
        if (this._error)
          return this._error;
        const error2 = new ZodError(ctx.common.issues);
        this._error = error2;
        return this._error;
      }
    };
  }
};
function processCreateParams(params) {
  if (!params)
    return {};
  const { errorMap: errorMap2, invalid_type_error, required_error, description } = params;
  if (errorMap2 && (invalid_type_error || required_error)) {
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  }
  if (errorMap2)
    return { errorMap: errorMap2, description };
  const customMap = (iss, ctx) => {
    const { message: message2 } = params;
    if (iss.code === "invalid_enum_value") {
      return { message: message2 ?? ctx.defaultError };
    }
    if (typeof ctx.data === "undefined") {
      return { message: message2 ?? required_error ?? ctx.defaultError };
    }
    if (iss.code !== "invalid_type")
      return { message: ctx.defaultError };
    return { message: message2 ?? invalid_type_error ?? ctx.defaultError };
  };
  return { errorMap: customMap, description };
}
class ZodType {
  get description() {
    return this._def.description;
  }
  _getType(input) {
    return getParsedType(input.data);
  }
  _getOrReturnCtx(input, ctx) {
    return ctx || {
      common: input.parent.common,
      data: input.data,
      parsedType: getParsedType(input.data),
      schemaErrorMap: this._def.errorMap,
      path: input.path,
      parent: input.parent
    };
  }
  _processInputParams(input) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      }
    };
  }
  _parseSync(input) {
    const result = this._parse(input);
    if (isAsync(result)) {
      throw new Error("Synchronous parse encountered promise.");
    }
    return result;
  }
  _parseAsync(input) {
    const result = this._parse(input);
    return Promise.resolve(result);
  }
  parse(data, params) {
    const result = this.safeParse(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  safeParse(data, params) {
    const ctx = {
      common: {
        issues: [],
        async: (params == null ? void 0 : params.async) ?? false,
        contextualErrorMap: params == null ? void 0 : params.errorMap
      },
      path: (params == null ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const result = this._parseSync({ data, path: ctx.path, parent: ctx });
    return handleResult(ctx, result);
  }
  "~validate"(data) {
    var _a3, _b;
    const ctx = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    if (!this["~standard"].async) {
      try {
        const result = this._parseSync({ data, path: [], parent: ctx });
        return isValid$3(result) ? {
          value: result.value
        } : {
          issues: ctx.common.issues
        };
      } catch (err) {
        if ((_b = (_a3 = err == null ? void 0 : err.message) == null ? void 0 : _a3.toLowerCase()) == null ? void 0 : _b.includes("encountered")) {
          this["~standard"].async = true;
        }
        ctx.common = {
          issues: [],
          async: true
        };
      }
    }
    return this._parseAsync({ data, path: [], parent: ctx }).then((result) => isValid$3(result) ? {
      value: result.value
    } : {
      issues: ctx.common.issues
    });
  }
  async parseAsync(data, params) {
    const result = await this.safeParseAsync(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  async safeParseAsync(data, params) {
    const ctx = {
      common: {
        issues: [],
        contextualErrorMap: params == null ? void 0 : params.errorMap,
        async: true
      },
      path: (params == null ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
    const result = await (isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
    return handleResult(ctx, result);
  }
  refine(check, message2) {
    const getIssueProperties = (val) => {
      if (typeof message2 === "string" || typeof message2 === "undefined") {
        return { message: message2 };
      } else if (typeof message2 === "function") {
        return message2(val);
      } else {
        return message2;
      }
    };
    return this._refinement((val, ctx) => {
      const result = check(val);
      const setError = () => ctx.addIssue({
        code: ZodIssueCode.custom,
        ...getIssueProperties(val)
      });
      if (typeof Promise !== "undefined" && result instanceof Promise) {
        return result.then((data) => {
          if (!data) {
            setError();
            return false;
          } else {
            return true;
          }
        });
      }
      if (!result) {
        setError();
        return false;
      } else {
        return true;
      }
    });
  }
  refinement(check, refinementData) {
    return this._refinement((val, ctx) => {
      if (!check(val)) {
        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
        return false;
      } else {
        return true;
      }
    });
  }
  _refinement(refinement) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement }
    });
  }
  superRefine(refinement) {
    return this._refinement(refinement);
  }
  constructor(def2) {
    this.spa = this.safeParseAsync;
    this._def = def2;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
    this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (data) => this["~validate"](data)
    };
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(option) {
    return ZodUnion.create([this, option], this._def);
  }
  and(incoming) {
    return ZodIntersection.create(this, incoming, this._def);
  }
  transform(transform) {
    return new ZodEffects({
      ...processCreateParams(this._def),
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform }
    });
  }
  default(def2) {
    const defaultValueFunc = typeof def2 === "function" ? def2 : () => def2;
    return new ZodDefault({
      ...processCreateParams(this._def),
      innerType: this,
      defaultValue: defaultValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    });
  }
  brand() {
    return new ZodBranded({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this,
      ...processCreateParams(this._def)
    });
  }
  catch(def2) {
    const catchValueFunc = typeof def2 === "function" ? def2 : () => def2;
    return new ZodCatch({
      ...processCreateParams(this._def),
      innerType: this,
      catchValue: catchValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    });
  }
  describe(description) {
    const This = this.constructor;
    return new This({
      ...this._def,
      description
    });
  }
  pipe(target) {
    return ZodPipeline.create(this, target);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[0-9a-z]+$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const nanoidRegex = /^[a-z0-9_-]{21}$/i;
const jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
const base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
const dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
  let secondsRegexSource = `[0-5]\\d`;
  if (args.precision) {
    secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
  } else if (args.precision == null) {
    secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
  }
  const secondsQuantifier = args.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function timeRegex(args) {
  return new RegExp(`^${timeRegexSource(args)}$`);
}
function datetimeRegex(args) {
  let regex2 = `${dateRegexSource}T${timeRegexSource(args)}`;
  const opts = [];
  opts.push(args.local ? `Z?` : `Z`);
  if (args.offset)
    opts.push(`([+-]\\d{2}:?\\d{2})`);
  regex2 = `${regex2}(${opts.join("|")})`;
  return new RegExp(`^${regex2}$`);
}
function isValidIP(ip, version) {
  if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
    return true;
  }
  if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
    return true;
  }
  return false;
}
function isValidJWT(jwt, alg) {
  if (!jwtRegex.test(jwt))
    return false;
  try {
    const [header] = jwt.split(".");
    if (!header)
      return false;
    const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
    const decoded = JSON.parse(atob(base64));
    if (typeof decoded !== "object" || decoded === null)
      return false;
    if ("typ" in decoded && (decoded == null ? void 0 : decoded.typ) !== "JWT")
      return false;
    if (!decoded.alg)
      return false;
    if (alg && decoded.alg !== alg)
      return false;
    return true;
  } catch {
    return false;
  }
}
function isValidCidr(ip, version) {
  if ((version === "v4" || !version) && ipv4CidrRegex.test(ip)) {
    return true;
  }
  if ((version === "v6" || !version) && ipv6CidrRegex.test(ip)) {
    return true;
  }
  return false;
}
class ZodString extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = String(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.string) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.string,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.length < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.length > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "length") {
        const tooBig = input.data.length > check.value;
        const tooSmall = input.data.length < check.value;
        if (tooBig || tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          if (tooBig) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          } else if (tooSmall) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          }
          status.dirty();
        }
      } else if (check.kind === "email") {
        if (!emailRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "email",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "emoji") {
        if (!emojiRegex) {
          emojiRegex = new RegExp(_emojiRegex, "u");
        }
        if (!emojiRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "emoji",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "uuid") {
        if (!uuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "uuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "nanoid") {
        if (!nanoidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "nanoid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid") {
        if (!cuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid2") {
        if (!cuid2Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid2",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ulid") {
        if (!ulidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ulid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "url") {
        try {
          new URL(input.data);
        } catch {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "regex") {
        check.regex.lastIndex = 0;
        const testResult = check.regex.test(input.data);
        if (!testResult) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "regex",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "trim") {
        input.data = input.data.trim();
      } else if (check.kind === "includes") {
        if (!input.data.includes(check.value, check.position)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { includes: check.value, position: check.position },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "toLowerCase") {
        input.data = input.data.toLowerCase();
      } else if (check.kind === "toUpperCase") {
        input.data = input.data.toUpperCase();
      } else if (check.kind === "startsWith") {
        if (!input.data.startsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { startsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "endsWith") {
        if (!input.data.endsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { endsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "datetime") {
        const regex2 = datetimeRegex(check);
        if (!regex2.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "datetime",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "date") {
        const regex2 = dateRegex;
        if (!regex2.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "date",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "time") {
        const regex2 = timeRegex(check);
        if (!regex2.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "time",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "duration") {
        if (!durationRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "duration",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ip") {
        if (!isValidIP(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ip",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "jwt") {
        if (!isValidJWT(input.data, check.alg)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "jwt",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cidr") {
        if (!isValidCidr(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cidr",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "base64") {
        if (!base64Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "base64",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "base64url") {
        if (!base64urlRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "base64url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _regex(regex2, validation, message2) {
    return this.refinement((data) => regex2.test(data), {
      validation,
      code: ZodIssueCode.invalid_string,
      ...errorUtil.errToObj(message2)
    });
  }
  _addCheck(check) {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  email(message2) {
    return this._addCheck({ kind: "email", ...errorUtil.errToObj(message2) });
  }
  url(message2) {
    return this._addCheck({ kind: "url", ...errorUtil.errToObj(message2) });
  }
  emoji(message2) {
    return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message2) });
  }
  uuid(message2) {
    return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message2) });
  }
  nanoid(message2) {
    return this._addCheck({ kind: "nanoid", ...errorUtil.errToObj(message2) });
  }
  cuid(message2) {
    return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message2) });
  }
  cuid2(message2) {
    return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message2) });
  }
  ulid(message2) {
    return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message2) });
  }
  base64(message2) {
    return this._addCheck({ kind: "base64", ...errorUtil.errToObj(message2) });
  }
  base64url(message2) {
    return this._addCheck({
      kind: "base64url",
      ...errorUtil.errToObj(message2)
    });
  }
  jwt(options) {
    return this._addCheck({ kind: "jwt", ...errorUtil.errToObj(options) });
  }
  ip(options) {
    return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
  }
  cidr(options) {
    return this._addCheck({ kind: "cidr", ...errorUtil.errToObj(options) });
  }
  datetime(options) {
    if (typeof options === "string") {
      return this._addCheck({
        kind: "datetime",
        precision: null,
        offset: false,
        local: false,
        message: options
      });
    }
    return this._addCheck({
      kind: "datetime",
      precision: typeof (options == null ? void 0 : options.precision) === "undefined" ? null : options == null ? void 0 : options.precision,
      offset: (options == null ? void 0 : options.offset) ?? false,
      local: (options == null ? void 0 : options.local) ?? false,
      ...errorUtil.errToObj(options == null ? void 0 : options.message)
    });
  }
  date(message2) {
    return this._addCheck({ kind: "date", message: message2 });
  }
  time(options) {
    if (typeof options === "string") {
      return this._addCheck({
        kind: "time",
        precision: null,
        message: options
      });
    }
    return this._addCheck({
      kind: "time",
      precision: typeof (options == null ? void 0 : options.precision) === "undefined" ? null : options == null ? void 0 : options.precision,
      ...errorUtil.errToObj(options == null ? void 0 : options.message)
    });
  }
  duration(message2) {
    return this._addCheck({ kind: "duration", ...errorUtil.errToObj(message2) });
  }
  regex(regex2, message2) {
    return this._addCheck({
      kind: "regex",
      regex: regex2,
      ...errorUtil.errToObj(message2)
    });
  }
  includes(value, options) {
    return this._addCheck({
      kind: "includes",
      value,
      position: options == null ? void 0 : options.position,
      ...errorUtil.errToObj(options == null ? void 0 : options.message)
    });
  }
  startsWith(value, message2) {
    return this._addCheck({
      kind: "startsWith",
      value,
      ...errorUtil.errToObj(message2)
    });
  }
  endsWith(value, message2) {
    return this._addCheck({
      kind: "endsWith",
      value,
      ...errorUtil.errToObj(message2)
    });
  }
  min(minLength, message2) {
    return this._addCheck({
      kind: "min",
      value: minLength,
      ...errorUtil.errToObj(message2)
    });
  }
  max(maxLength, message2) {
    return this._addCheck({
      kind: "max",
      value: maxLength,
      ...errorUtil.errToObj(message2)
    });
  }
  length(len, message2) {
    return this._addCheck({
      kind: "length",
      value: len,
      ...errorUtil.errToObj(message2)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(message2) {
    return this.min(1, errorUtil.errToObj(message2));
  }
  trim() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((ch) => ch.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((ch) => ch.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((ch) => ch.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((ch) => ch.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((ch) => ch.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((ch) => ch.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((ch) => ch.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((ch) => ch.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((ch) => ch.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((ch) => ch.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((ch) => ch.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((ch) => ch.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((ch) => ch.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((ch) => ch.kind === "base64url");
  }
  get minLength() {
    let min2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min2 === null || ch.value > min2)
          min2 = ch.value;
      }
    }
    return min2;
  }
  get maxLength() {
    let max2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max2 === null || ch.value < max2)
          max2 = ch.value;
      }
    }
    return max2;
  }
}
ZodString.create = (params) => {
  return new ZodString({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (params == null ? void 0 : params.coerce) ?? false,
    ...processCreateParams(params)
  });
};
function floatSafeRemainder(val, step) {
  const valDecCount = (val.toString().split(".")[1] || "").length;
  const stepDecCount = (step.toString().split(".")[1] || "").length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
  const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / 10 ** decCount;
}
class ZodNumber extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
    this.step = this.multipleOf;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = Number(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.number) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "int") {
        if (!util.isInteger(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: "integer",
            received: "float",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (floatSafeRemainder(input.data, check.value) !== 0) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "finite") {
        if (!Number.isFinite(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_finite,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message2) {
    return this.setLimit("min", value, true, errorUtil.toString(message2));
  }
  gt(value, message2) {
    return this.setLimit("min", value, false, errorUtil.toString(message2));
  }
  lte(value, message2) {
    return this.setLimit("max", value, true, errorUtil.toString(message2));
  }
  lt(value, message2) {
    return this.setLimit("max", value, false, errorUtil.toString(message2));
  }
  setLimit(kind, value, inclusive, message2) {
    return new ZodNumber({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message2)
        }
      ]
    });
  }
  _addCheck(check) {
    return new ZodNumber({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  int(message2) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(message2)
    });
  }
  positive(message2) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message2)
    });
  }
  negative(message2) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message2)
    });
  }
  nonpositive(message2) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message2)
    });
  }
  nonnegative(message2) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message2)
    });
  }
  multipleOf(value, message2) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message2)
    });
  }
  finite(message2) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(message2)
    });
  }
  safe(message2) {
    return this._addCheck({
      kind: "min",
      inclusive: true,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(message2)
    })._addCheck({
      kind: "max",
      inclusive: true,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(message2)
    });
  }
  get minValue() {
    let min2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min2 === null || ch.value > min2)
          min2 = ch.value;
      }
    }
    return min2;
  }
  get maxValue() {
    let max2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max2 === null || ch.value < max2)
          max2 = ch.value;
      }
    }
    return max2;
  }
  get isInt() {
    return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value));
  }
  get isFinite() {
    let max2 = null;
    let min2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
        return true;
      } else if (ch.kind === "min") {
        if (min2 === null || ch.value > min2)
          min2 = ch.value;
      } else if (ch.kind === "max") {
        if (max2 === null || ch.value < max2)
          max2 = ch.value;
      }
    }
    return Number.isFinite(min2) && Number.isFinite(max2);
  }
}
ZodNumber.create = (params) => {
  return new ZodNumber({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber,
    coerce: (params == null ? void 0 : params.coerce) || false,
    ...processCreateParams(params)
  });
};
class ZodBigInt extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
  }
  _parse(input) {
    if (this._def.coerce) {
      try {
        input.data = BigInt(input.data);
      } catch {
        return this._getInvalidInput(input);
      }
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.bigint) {
      return this._getInvalidInput(input);
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            type: "bigint",
            minimum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            type: "bigint",
            maximum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (input.data % check.value !== BigInt(0)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _getInvalidInput(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.bigint,
      received: ctx.parsedType
    });
    return INVALID;
  }
  gte(value, message2) {
    return this.setLimit("min", value, true, errorUtil.toString(message2));
  }
  gt(value, message2) {
    return this.setLimit("min", value, false, errorUtil.toString(message2));
  }
  lte(value, message2) {
    return this.setLimit("max", value, true, errorUtil.toString(message2));
  }
  lt(value, message2) {
    return this.setLimit("max", value, false, errorUtil.toString(message2));
  }
  setLimit(kind, value, inclusive, message2) {
    return new ZodBigInt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message2)
        }
      ]
    });
  }
  _addCheck(check) {
    return new ZodBigInt({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  positive(message2) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message2)
    });
  }
  negative(message2) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message2)
    });
  }
  nonpositive(message2) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message2)
    });
  }
  nonnegative(message2) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message2)
    });
  }
  multipleOf(value, message2) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message2)
    });
  }
  get minValue() {
    let min2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min2 === null || ch.value > min2)
          min2 = ch.value;
      }
    }
    return min2;
  }
  get maxValue() {
    let max2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max2 === null || ch.value < max2)
          max2 = ch.value;
      }
    }
    return max2;
  }
}
ZodBigInt.create = (params) => {
  return new ZodBigInt({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (params == null ? void 0 : params.coerce) ?? false,
    ...processCreateParams(params)
  });
};
class ZodBoolean extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = Boolean(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.boolean) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodBoolean.create = (params) => {
  return new ZodBoolean({
    typeName: ZodFirstPartyTypeKind.ZodBoolean,
    coerce: (params == null ? void 0 : params.coerce) || false,
    ...processCreateParams(params)
  });
};
class ZodDate extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = new Date(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.date) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    if (Number.isNaN(input.data.getTime())) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_date
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.getTime() < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            message: check.message,
            inclusive: true,
            exact: false,
            minimum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.getTime() > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            message: check.message,
            inclusive: true,
            exact: false,
            maximum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return {
      status: status.value,
      value: new Date(input.data.getTime())
    };
  }
  _addCheck(check) {
    return new ZodDate({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  min(minDate, message2) {
    return this._addCheck({
      kind: "min",
      value: minDate.getTime(),
      message: errorUtil.toString(message2)
    });
  }
  max(maxDate, message2) {
    return this._addCheck({
      kind: "max",
      value: maxDate.getTime(),
      message: errorUtil.toString(message2)
    });
  }
  get minDate() {
    let min2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min2 === null || ch.value > min2)
          min2 = ch.value;
      }
    }
    return min2 != null ? new Date(min2) : null;
  }
  get maxDate() {
    let max2 = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max2 === null || ch.value < max2)
          max2 = ch.value;
      }
    }
    return max2 != null ? new Date(max2) : null;
  }
}
ZodDate.create = (params) => {
  return new ZodDate({
    checks: [],
    coerce: (params == null ? void 0 : params.coerce) || false,
    typeName: ZodFirstPartyTypeKind.ZodDate,
    ...processCreateParams(params)
  });
};
class ZodSymbol extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.symbol) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodSymbol.create = (params) => {
  return new ZodSymbol({
    typeName: ZodFirstPartyTypeKind.ZodSymbol,
    ...processCreateParams(params)
  });
};
class ZodUndefined extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodUndefined.create = (params) => {
  return new ZodUndefined({
    typeName: ZodFirstPartyTypeKind.ZodUndefined,
    ...processCreateParams(params)
  });
};
class ZodNull extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.null) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodNull.create = (params) => {
  return new ZodNull({
    typeName: ZodFirstPartyTypeKind.ZodNull,
    ...processCreateParams(params)
  });
};
class ZodAny extends ZodType {
  constructor() {
    super(...arguments);
    this._any = true;
  }
  _parse(input) {
    return OK(input.data);
  }
}
ZodAny.create = (params) => {
  return new ZodAny({
    typeName: ZodFirstPartyTypeKind.ZodAny,
    ...processCreateParams(params)
  });
};
class ZodUnknown extends ZodType {
  constructor() {
    super(...arguments);
    this._unknown = true;
  }
  _parse(input) {
    return OK(input.data);
  }
}
ZodUnknown.create = (params) => {
  return new ZodUnknown({
    typeName: ZodFirstPartyTypeKind.ZodUnknown,
    ...processCreateParams(params)
  });
};
class ZodNever extends ZodType {
  _parse(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: ctx.parsedType
    });
    return INVALID;
  }
}
ZodNever.create = (params) => {
  return new ZodNever({
    typeName: ZodFirstPartyTypeKind.ZodNever,
    ...processCreateParams(params)
  });
};
class ZodVoid extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
}
ZodVoid.create = (params) => {
  return new ZodVoid({
    typeName: ZodFirstPartyTypeKind.ZodVoid,
    ...processCreateParams(params)
  });
};
class ZodArray extends ZodType {
  _parse(input) {
    const { ctx, status } = this._processInputParams(input);
    const def2 = this._def;
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (def2.exactLength !== null) {
      const tooBig = ctx.data.length > def2.exactLength.value;
      const tooSmall = ctx.data.length < def2.exactLength.value;
      if (tooBig || tooSmall) {
        addIssueToContext(ctx, {
          code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
          minimum: tooSmall ? def2.exactLength.value : void 0,
          maximum: tooBig ? def2.exactLength.value : void 0,
          type: "array",
          inclusive: true,
          exact: true,
          message: def2.exactLength.message
        });
        status.dirty();
      }
    }
    if (def2.minLength !== null) {
      if (ctx.data.length < def2.minLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def2.minLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def2.minLength.message
        });
        status.dirty();
      }
    }
    if (def2.maxLength !== null) {
      if (ctx.data.length > def2.maxLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def2.maxLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def2.maxLength.message
        });
        status.dirty();
      }
    }
    if (ctx.common.async) {
      return Promise.all([...ctx.data].map((item, i) => {
        return def2.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
      })).then((result2) => {
        return ParseStatus.mergeArray(status, result2);
      });
    }
    const result = [...ctx.data].map((item, i) => {
      return def2.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
    });
    return ParseStatus.mergeArray(status, result);
  }
  get element() {
    return this._def.type;
  }
  min(minLength, message2) {
    return new ZodArray({
      ...this._def,
      minLength: { value: minLength, message: errorUtil.toString(message2) }
    });
  }
  max(maxLength, message2) {
    return new ZodArray({
      ...this._def,
      maxLength: { value: maxLength, message: errorUtil.toString(message2) }
    });
  }
  length(len, message2) {
    return new ZodArray({
      ...this._def,
      exactLength: { value: len, message: errorUtil.toString(message2) }
    });
  }
  nonempty(message2) {
    return this.min(1, message2);
  }
}
ZodArray.create = (schema, params) => {
  return new ZodArray({
    type: schema,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray,
    ...processCreateParams(params)
  });
};
function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    const newShape = {};
    for (const key2 in schema.shape) {
      const fieldSchema = schema.shape[key2];
      newShape[key2] = ZodOptional.create(deepPartialify(fieldSchema));
    }
    return new ZodObject({
      ...schema._def,
      shape: () => newShape
    });
  } else if (schema instanceof ZodArray) {
    return new ZodArray({
      ...schema._def,
      type: deepPartialify(schema.element)
    });
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
  } else {
    return schema;
  }
}
class ZodObject extends ZodType {
  constructor() {
    super(...arguments);
    this._cached = null;
    this.nonstrict = this.passthrough;
    this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const shape = this._def.shape();
    const keys2 = util.objectKeys(shape);
    this._cached = { shape, keys: keys2 };
    return this._cached;
  }
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.object) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const { status, ctx } = this._processInputParams(input);
    const { shape, keys: shapeKeys } = this._getCached();
    const extraKeys = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
      for (const key2 in ctx.data) {
        if (!shapeKeys.includes(key2)) {
          extraKeys.push(key2);
        }
      }
    }
    const pairs = [];
    for (const key2 of shapeKeys) {
      const keyValidator = shape[key2];
      const value = ctx.data[key2];
      pairs.push({
        key: { status: "valid", value: key2 },
        value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key2)),
        alwaysSet: key2 in ctx.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const unknownKeys = this._def.unknownKeys;
      if (unknownKeys === "passthrough") {
        for (const key2 of extraKeys) {
          pairs.push({
            key: { status: "valid", value: key2 },
            value: { status: "valid", value: ctx.data[key2] }
          });
        }
      } else if (unknownKeys === "strict") {
        if (extraKeys.length > 0) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.unrecognized_keys,
            keys: extraKeys
          });
          status.dirty();
        }
      } else if (unknownKeys === "strip") ;
      else {
        throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
      }
    } else {
      const catchall = this._def.catchall;
      for (const key2 of extraKeys) {
        const value = ctx.data[key2];
        pairs.push({
          key: { status: "valid", value: key2 },
          value: catchall._parse(
            new ParseInputLazyPath(ctx, value, ctx.path, key2)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: key2 in ctx.data
        });
      }
    }
    if (ctx.common.async) {
      return Promise.resolve().then(async () => {
        const syncPairs = [];
        for (const pair of pairs) {
          const key2 = await pair.key;
          const value = await pair.value;
          syncPairs.push({
            key: key2,
            value,
            alwaysSet: pair.alwaysSet
          });
        }
        return syncPairs;
      }).then((syncPairs) => {
        return ParseStatus.mergeObjectSync(status, syncPairs);
      });
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get shape() {
    return this._def.shape();
  }
  strict(message2) {
    errorUtil.errToObj;
    return new ZodObject({
      ...this._def,
      unknownKeys: "strict",
      ...message2 !== void 0 ? {
        errorMap: (issue, ctx) => {
          var _a3, _b;
          const defaultError = ((_b = (_a3 = this._def).errorMap) == null ? void 0 : _b.call(_a3, issue, ctx).message) ?? ctx.defaultError;
          if (issue.code === "unrecognized_keys")
            return {
              message: errorUtil.errToObj(message2).message ?? defaultError
            };
          return {
            message: defaultError
          };
        }
      } : {}
    });
  }
  strip() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(augmentation) {
    return new ZodObject({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...augmentation
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(merging) {
    const merged = new ZodObject({
      unknownKeys: merging._def.unknownKeys,
      catchall: merging._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...merging._def.shape()
      }),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
    return merged;
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(key2, schema) {
    return this.augment({ [key2]: schema });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(index2) {
    return new ZodObject({
      ...this._def,
      catchall: index2
    });
  }
  pick(mask) {
    const shape = {};
    for (const key2 of util.objectKeys(mask)) {
      if (mask[key2] && this.shape[key2]) {
        shape[key2] = this.shape[key2];
      }
    }
    return new ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  omit(mask) {
    const shape = {};
    for (const key2 of util.objectKeys(this.shape)) {
      if (!mask[key2]) {
        shape[key2] = this.shape[key2];
      }
    }
    return new ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(mask) {
    const newShape = {};
    for (const key2 of util.objectKeys(this.shape)) {
      const fieldSchema = this.shape[key2];
      if (mask && !mask[key2]) {
        newShape[key2] = fieldSchema;
      } else {
        newShape[key2] = fieldSchema.optional();
      }
    }
    return new ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  required(mask) {
    const newShape = {};
    for (const key2 of util.objectKeys(this.shape)) {
      if (mask && !mask[key2]) {
        newShape[key2] = this.shape[key2];
      } else {
        const fieldSchema = this.shape[key2];
        let newField = fieldSchema;
        while (newField instanceof ZodOptional) {
          newField = newField._def.innerType;
        }
        newShape[key2] = newField;
      }
    }
    return new ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  keyof() {
    return createZodEnum(util.objectKeys(this.shape));
  }
}
ZodObject.create = (shape, params) => {
  return new ZodObject({
    shape: () => shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.strictCreate = (shape, params) => {
  return new ZodObject({
    shape: () => shape,
    unknownKeys: "strict",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.lazycreate = (shape, params) => {
  return new ZodObject({
    shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
class ZodUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const options = this._def.options;
    function handleResults(results) {
      for (const result of results) {
        if (result.result.status === "valid") {
          return result.result;
        }
      }
      for (const result of results) {
        if (result.result.status === "dirty") {
          ctx.common.issues.push(...result.ctx.common.issues);
          return result.result;
        }
      }
      const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return Promise.all(options.map(async (option) => {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          }),
          ctx: childCtx
        };
      })).then(handleResults);
    } else {
      let dirty = void 0;
      const issues = [];
      for (const option of options) {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        const result = option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: childCtx
        });
        if (result.status === "valid") {
          return result;
        } else if (result.status === "dirty" && !dirty) {
          dirty = { result, ctx: childCtx };
        }
        if (childCtx.common.issues.length) {
          issues.push(childCtx.common.issues);
        }
      }
      if (dirty) {
        ctx.common.issues.push(...dirty.ctx.common.issues);
        return dirty.result;
      }
      const unionErrors = issues.map((issues2) => new ZodError(issues2));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
}
ZodUnion.create = (types2, params) => {
  return new ZodUnion({
    options: types2,
    typeName: ZodFirstPartyTypeKind.ZodUnion,
    ...processCreateParams(params)
  });
};
const getDiscriminator = (type) => {
  if (type instanceof ZodLazy) {
    return getDiscriminator(type.schema);
  } else if (type instanceof ZodEffects) {
    return getDiscriminator(type.innerType());
  } else if (type instanceof ZodLiteral) {
    return [type.value];
  } else if (type instanceof ZodEnum) {
    return type.options;
  } else if (type instanceof ZodNativeEnum) {
    return util.objectValues(type.enum);
  } else if (type instanceof ZodDefault) {
    return getDiscriminator(type._def.innerType);
  } else if (type instanceof ZodUndefined) {
    return [void 0];
  } else if (type instanceof ZodNull) {
    return [null];
  } else if (type instanceof ZodOptional) {
    return [void 0, ...getDiscriminator(type.unwrap())];
  } else if (type instanceof ZodNullable) {
    return [null, ...getDiscriminator(type.unwrap())];
  } else if (type instanceof ZodBranded) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodReadonly) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodCatch) {
    return getDiscriminator(type._def.innerType);
  } else {
    return [];
  }
};
class ZodDiscriminatedUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const discriminator = this.discriminator;
    const discriminatorValue = ctx.data[discriminator];
    const option = this.optionsMap.get(discriminatorValue);
    if (!option) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [discriminator]
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return option._parseAsync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    } else {
      return option._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(discriminator, options, params) {
    const optionsMap = /* @__PURE__ */ new Map();
    for (const type of options) {
      const discriminatorValues = getDiscriminator(type.shape[discriminator]);
      if (!discriminatorValues.length) {
        throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
      }
      for (const value of discriminatorValues) {
        if (optionsMap.has(value)) {
          throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
        }
        optionsMap.set(value, type);
      }
    }
    return new ZodDiscriminatedUnion({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator,
      options,
      optionsMap,
      ...processCreateParams(params)
    });
  }
}
function mergeValues(a2, b2) {
  const aType = getParsedType(a2);
  const bType = getParsedType(b2);
  if (a2 === b2) {
    return { valid: true, data: a2 };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    const bKeys = util.objectKeys(b2);
    const sharedKeys = util.objectKeys(a2).filter((key2) => bKeys.indexOf(key2) !== -1);
    const newObj = { ...a2, ...b2 };
    for (const key2 of sharedKeys) {
      const sharedValue = mergeValues(a2[key2], b2[key2]);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newObj[key2] = sharedValue.data;
    }
    return { valid: true, data: newObj };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a2.length !== b2.length) {
      return { valid: false };
    }
    const newArray = [];
    for (let index2 = 0; index2 < a2.length; index2++) {
      const itemA = a2[index2];
      const itemB = b2[index2];
      const sharedValue = mergeValues(itemA, itemB);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newArray.push(sharedValue.data);
    }
    return { valid: true, data: newArray };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a2 === +b2) {
    return { valid: true, data: a2 };
  } else {
    return { valid: false };
  }
}
class ZodIntersection extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const handleParsed = (parsedLeft, parsedRight) => {
      if (isAborted(parsedLeft) || isAborted(parsedRight)) {
        return INVALID;
      }
      const merged = mergeValues(parsedLeft.value, parsedRight.value);
      if (!merged.valid) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_intersection_types
        });
        return INVALID;
      }
      if (isDirty(parsedLeft) || isDirty(parsedRight)) {
        status.dirty();
      }
      return { status: status.value, value: merged.data };
    };
    if (ctx.common.async) {
      return Promise.all([
        this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }),
        this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })
      ]).then(([left2, right2]) => handleParsed(left2, right2));
    } else {
      return handleParsed(this._def.left._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }), this._def.right._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }));
    }
  }
}
ZodIntersection.create = (left2, right2, params) => {
  return new ZodIntersection({
    left: left2,
    right: right2,
    typeName: ZodFirstPartyTypeKind.ZodIntersection,
    ...processCreateParams(params)
  });
};
class ZodTuple extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (ctx.data.length < this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      return INVALID;
    }
    const rest = this._def.rest;
    if (!rest && ctx.data.length > this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_big,
        maximum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      status.dirty();
    }
    const items = [...ctx.data].map((item, itemIndex) => {
      const schema = this._def.items[itemIndex] || this._def.rest;
      if (!schema)
        return null;
      return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
    }).filter((x2) => !!x2);
    if (ctx.common.async) {
      return Promise.all(items).then((results) => {
        return ParseStatus.mergeArray(status, results);
      });
    } else {
      return ParseStatus.mergeArray(status, items);
    }
  }
  get items() {
    return this._def.items;
  }
  rest(rest) {
    return new ZodTuple({
      ...this._def,
      rest
    });
  }
}
ZodTuple.create = (schemas, params) => {
  if (!Array.isArray(schemas)) {
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  }
  return new ZodTuple({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null,
    ...processCreateParams(params)
  });
};
class ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const pairs = [];
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    for (const key2 in ctx.data) {
      pairs.push({
        key: keyType._parse(new ParseInputLazyPath(ctx, key2, ctx.path, key2)),
        value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key2], ctx.path, key2)),
        alwaysSet: key2 in ctx.data
      });
    }
    if (ctx.common.async) {
      return ParseStatus.mergeObjectAsync(status, pairs);
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get element() {
    return this._def.valueType;
  }
  static create(first2, second, third) {
    if (second instanceof ZodType) {
      return new ZodRecord({
        keyType: first2,
        valueType: second,
        typeName: ZodFirstPartyTypeKind.ZodRecord,
        ...processCreateParams(third)
      });
    }
    return new ZodRecord({
      keyType: ZodString.create(),
      valueType: first2,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(second)
    });
  }
}
class ZodMap extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.map) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    const pairs = [...ctx.data.entries()].map(([key2, value], index2) => {
      return {
        key: keyType._parse(new ParseInputLazyPath(ctx, key2, ctx.path, [index2, "key"])),
        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index2, "value"]))
      };
    });
    if (ctx.common.async) {
      const finalMap = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const pair of pairs) {
          const key2 = await pair.key;
          const value = await pair.value;
          if (key2.status === "aborted" || value.status === "aborted") {
            return INVALID;
          }
          if (key2.status === "dirty" || value.status === "dirty") {
            status.dirty();
          }
          finalMap.set(key2.value, value.value);
        }
        return { status: status.value, value: finalMap };
      });
    } else {
      const finalMap = /* @__PURE__ */ new Map();
      for (const pair of pairs) {
        const key2 = pair.key;
        const value = pair.value;
        if (key2.status === "aborted" || value.status === "aborted") {
          return INVALID;
        }
        if (key2.status === "dirty" || value.status === "dirty") {
          status.dirty();
        }
        finalMap.set(key2.value, value.value);
      }
      return { status: status.value, value: finalMap };
    }
  }
}
ZodMap.create = (keyType, valueType, params) => {
  return new ZodMap({
    valueType,
    keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap,
    ...processCreateParams(params)
  });
};
class ZodSet extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.set) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const def2 = this._def;
    if (def2.minSize !== null) {
      if (ctx.data.size < def2.minSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def2.minSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def2.minSize.message
        });
        status.dirty();
      }
    }
    if (def2.maxSize !== null) {
      if (ctx.data.size > def2.maxSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def2.maxSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def2.maxSize.message
        });
        status.dirty();
      }
    }
    const valueType = this._def.valueType;
    function finalizeSet(elements2) {
      const parsedSet = /* @__PURE__ */ new Set();
      for (const element2 of elements2) {
        if (element2.status === "aborted")
          return INVALID;
        if (element2.status === "dirty")
          status.dirty();
        parsedSet.add(element2.value);
      }
      return { status: status.value, value: parsedSet };
    }
    const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
    if (ctx.common.async) {
      return Promise.all(elements).then((elements2) => finalizeSet(elements2));
    } else {
      return finalizeSet(elements);
    }
  }
  min(minSize, message2) {
    return new ZodSet({
      ...this._def,
      minSize: { value: minSize, message: errorUtil.toString(message2) }
    });
  }
  max(maxSize, message2) {
    return new ZodSet({
      ...this._def,
      maxSize: { value: maxSize, message: errorUtil.toString(message2) }
    });
  }
  size(size2, message2) {
    return this.min(size2, message2).max(size2, message2);
  }
  nonempty(message2) {
    return this.min(1, message2);
  }
}
ZodSet.create = (valueType, params) => {
  return new ZodSet({
    valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet,
    ...processCreateParams(params)
  });
};
class ZodFunction extends ZodType {
  constructor() {
    super(...arguments);
    this.validate = this.implement;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.function) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: ctx.parsedType
      });
      return INVALID;
    }
    function makeArgsIssue(args, error2) {
      return makeIssue({
        data: args,
        path: ctx.path,
        errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap(), errorMap].filter((x2) => !!x2),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: error2
        }
      });
    }
    function makeReturnsIssue(returns, error2) {
      return makeIssue({
        data: returns,
        path: ctx.path,
        errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap(), errorMap].filter((x2) => !!x2),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: error2
        }
      });
    }
    const params = { errorMap: ctx.common.contextualErrorMap };
    const fn2 = ctx.data;
    if (this._def.returns instanceof ZodPromise) {
      const me = this;
      return OK(async function(...args) {
        const error2 = new ZodError([]);
        const parsedArgs = await me._def.args.parseAsync(args, params).catch((e) => {
          error2.addIssue(makeArgsIssue(args, e));
          throw error2;
        });
        const result = await Reflect.apply(fn2, this, parsedArgs);
        const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e) => {
          error2.addIssue(makeReturnsIssue(result, e));
          throw error2;
        });
        return parsedReturns;
      });
    } else {
      const me = this;
      return OK(function(...args) {
        const parsedArgs = me._def.args.safeParse(args, params);
        if (!parsedArgs.success) {
          throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
        }
        const result = Reflect.apply(fn2, this, parsedArgs.data);
        const parsedReturns = me._def.returns.safeParse(result, params);
        if (!parsedReturns.success) {
          throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
        }
        return parsedReturns.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...items) {
    return new ZodFunction({
      ...this._def,
      args: ZodTuple.create(items).rest(ZodUnknown.create())
    });
  }
  returns(returnType) {
    return new ZodFunction({
      ...this._def,
      returns: returnType
    });
  }
  implement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  strictImplement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  static create(args, returns, params) {
    return new ZodFunction({
      args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: returns || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction,
      ...processCreateParams(params)
    });
  }
}
class ZodLazy extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const lazySchema = this._def.getter();
    return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
  }
}
ZodLazy.create = (getter, params) => {
  return new ZodLazy({
    getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy,
    ...processCreateParams(params)
  });
};
class ZodLiteral extends ZodType {
  _parse(input) {
    if (input.data !== this._def.value) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
  get value() {
    return this._def.value;
  }
}
ZodLiteral.create = (value, params) => {
  return new ZodLiteral({
    value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral,
    ...processCreateParams(params)
  });
};
function createZodEnum(values2, params) {
  return new ZodEnum({
    values: values2,
    typeName: ZodFirstPartyTypeKind.ZodEnum,
    ...processCreateParams(params)
  });
}
class ZodEnum extends ZodType {
  _parse(input) {
    if (typeof input.data !== "string") {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (!this._cache) {
      this._cache = new Set(this._def.values);
    }
    if (!this._cache.has(input.data)) {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Values() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  extract(values2, newDef = this._def) {
    return ZodEnum.create(values2, {
      ...this._def,
      ...newDef
    });
  }
  exclude(values2, newDef = this._def) {
    return ZodEnum.create(this.options.filter((opt) => !values2.includes(opt)), {
      ...this._def,
      ...newDef
    });
  }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
  _parse(input) {
    const nativeEnumValues = util.getValidEnumValues(this._def.values);
    const ctx = this._getOrReturnCtx(input);
    if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (!this._cache) {
      this._cache = new Set(util.getValidEnumValues(this._def.values));
    }
    if (!this._cache.has(input.data)) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get enum() {
    return this._def.values;
  }
}
ZodNativeEnum.create = (values2, params) => {
  return new ZodNativeEnum({
    values: values2,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
    ...processCreateParams(params)
  });
};
class ZodPromise extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
    return OK(promisified.then((data) => {
      return this._def.type.parseAsync(data, {
        path: ctx.path,
        errorMap: ctx.common.contextualErrorMap
      });
    }));
  }
}
ZodPromise.create = (schema, params) => {
  return new ZodPromise({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise,
    ...processCreateParams(params)
  });
};
class ZodEffects extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const effect = this._def.effect || null;
    const checkCtx = {
      addIssue: (arg) => {
        addIssueToContext(ctx, arg);
        if (arg.fatal) {
          status.abort();
        } else {
          status.dirty();
        }
      },
      get path() {
        return ctx.path;
      }
    };
    checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
    if (effect.type === "preprocess") {
      const processed = effect.transform(ctx.data, checkCtx);
      if (ctx.common.async) {
        return Promise.resolve(processed).then(async (processed2) => {
          if (status.value === "aborted")
            return INVALID;
          const result = await this._def.schema._parseAsync({
            data: processed2,
            path: ctx.path,
            parent: ctx
          });
          if (result.status === "aborted")
            return INVALID;
          if (result.status === "dirty")
            return DIRTY(result.value);
          if (status.value === "dirty")
            return DIRTY(result.value);
          return result;
        });
      } else {
        if (status.value === "aborted")
          return INVALID;
        const result = this._def.schema._parseSync({
          data: processed,
          path: ctx.path,
          parent: ctx
        });
        if (result.status === "aborted")
          return INVALID;
        if (result.status === "dirty")
          return DIRTY(result.value);
        if (status.value === "dirty")
          return DIRTY(result.value);
        return result;
      }
    }
    if (effect.type === "refinement") {
      const executeRefinement = (acc) => {
        const result = effect.refinement(acc, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(result);
        }
        if (result instanceof Promise) {
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        }
        return acc;
      };
      if (ctx.common.async === false) {
        const inner = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inner.status === "aborted")
          return INVALID;
        if (inner.status === "dirty")
          status.dirty();
        executeRefinement(inner.value);
        return { status: status.value, value: inner.value };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
          if (inner.status === "aborted")
            return INVALID;
          if (inner.status === "dirty")
            status.dirty();
          return executeRefinement(inner.value).then(() => {
            return { status: status.value, value: inner.value };
          });
        });
      }
    }
    if (effect.type === "transform") {
      if (ctx.common.async === false) {
        const base2 = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (!isValid$3(base2))
          return INVALID;
        const result = effect.transform(base2.value, checkCtx);
        if (result instanceof Promise) {
          throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
        }
        return { status: status.value, value: result };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base2) => {
          if (!isValid$3(base2))
            return INVALID;
          return Promise.resolve(effect.transform(base2.value, checkCtx)).then((result) => ({
            status: status.value,
            value: result
          }));
        });
      }
    }
    util.assertNever(effect);
  }
}
ZodEffects.create = (schema, effect, params) => {
  return new ZodEffects({
    schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect,
    ...processCreateParams(params)
  });
};
ZodEffects.createWithPreprocess = (preprocess2, schema, params) => {
  return new ZodEffects({
    schema,
    effect: { type: "preprocess", transform: preprocess2 },
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    ...processCreateParams(params)
  });
};
class ZodOptional extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.undefined) {
      return OK(void 0);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodOptional.create = (type, params) => {
  return new ZodOptional({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional,
    ...processCreateParams(params)
  });
};
class ZodNullable extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.null) {
      return OK(null);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodNullable.create = (type, params) => {
  return new ZodNullable({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable,
    ...processCreateParams(params)
  });
};
class ZodDefault extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    let data = ctx.data;
    if (ctx.parsedType === ZodParsedType.undefined) {
      data = this._def.defaultValue();
    }
    return this._def.innerType._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ZodDefault.create = (type, params) => {
  return new ZodDefault({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodDefault,
    defaultValue: typeof params.default === "function" ? params.default : () => params.default,
    ...processCreateParams(params)
  });
};
class ZodCatch extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const newCtx = {
      ...ctx,
      common: {
        ...ctx.common,
        issues: []
      }
    };
    const result = this._def.innerType._parse({
      data: newCtx.data,
      path: newCtx.path,
      parent: {
        ...newCtx
      }
    });
    if (isAsync(result)) {
      return result.then((result2) => {
        return {
          status: "valid",
          value: result2.status === "valid" ? result2.value : this._def.catchValue({
            get error() {
              return new ZodError(newCtx.common.issues);
            },
            input: newCtx.data
          })
        };
      });
    } else {
      return {
        status: "valid",
        value: result.status === "valid" ? result.value : this._def.catchValue({
          get error() {
            return new ZodError(newCtx.common.issues);
          },
          input: newCtx.data
        })
      };
    }
  }
  removeCatch() {
    return this._def.innerType;
  }
}
ZodCatch.create = (type, params) => {
  return new ZodCatch({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodCatch,
    catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
    ...processCreateParams(params)
  });
};
class ZodNaN extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.nan) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
}
ZodNaN.create = (params) => {
  return new ZodNaN({
    typeName: ZodFirstPartyTypeKind.ZodNaN,
    ...processCreateParams(params)
  });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const data = ctx.data;
    return this._def.type._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class ZodPipeline extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.common.async) {
      const handleAsync = async () => {
        const inResult = await this._def.in._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID;
        if (inResult.status === "dirty") {
          status.dirty();
          return DIRTY(inResult.value);
        } else {
          return this._def.out._parseAsync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      };
      return handleAsync();
    } else {
      const inResult = this._def.in._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
      if (inResult.status === "aborted")
        return INVALID;
      if (inResult.status === "dirty") {
        status.dirty();
        return {
          status: "dirty",
          value: inResult.value
        };
      } else {
        return this._def.out._parseSync({
          data: inResult.value,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }
  static create(a2, b2) {
    return new ZodPipeline({
      in: a2,
      out: b2,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
}
class ZodReadonly extends ZodType {
  _parse(input) {
    const result = this._def.innerType._parse(input);
    const freeze = (data) => {
      if (isValid$3(data)) {
        data.value = Object.freeze(data.value);
      }
      return data;
    };
    return isAsync(result) ? result.then((data) => freeze(data)) : freeze(result);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodReadonly.create = (type, params) => {
  return new ZodReadonly({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodReadonly,
    ...processCreateParams(params)
  });
};
function cleanParams(params, data) {
  const p2 = typeof params === "function" ? params(data) : typeof params === "string" ? { message: params } : params;
  const p22 = typeof p2 === "string" ? { message: p2 } : p2;
  return p22;
}
function custom(check, _params = {}, fatal) {
  if (check)
    return ZodAny.create().superRefine((data, ctx) => {
      const r2 = check(data);
      if (r2 instanceof Promise) {
        return r2.then((r3) => {
          if (!r3) {
            const params = cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({ code: "custom", ...params, fatal: _fatal });
          }
        });
      }
      if (!r2) {
        const params = cleanParams(_params, data);
        const _fatal = params.fatal ?? fatal ?? true;
        ctx.addIssue({ code: "custom", ...params, fatal: _fatal });
      }
      return;
    });
  return ZodAny.create();
}
const late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind2) {
  ZodFirstPartyTypeKind2["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind2["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind2["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind2["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind2["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind2["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind2["ZodSymbol"] = "ZodSymbol";
  ZodFirstPartyTypeKind2["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind2["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind2["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind2["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind2["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind2["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind2["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind2["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind2["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind2["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind2["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind2["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind2["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind2["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind2["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind2["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind2["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind2["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind2["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind2["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind2["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind2["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind2["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind2["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind2["ZodCatch"] = "ZodCatch";
  ZodFirstPartyTypeKind2["ZodPromise"] = "ZodPromise";
  ZodFirstPartyTypeKind2["ZodBranded"] = "ZodBranded";
  ZodFirstPartyTypeKind2["ZodPipeline"] = "ZodPipeline";
  ZodFirstPartyTypeKind2["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (cls, params = {
  message: `Input not instance of ${cls.name}`
}) => custom((data) => data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = () => stringType().optional();
const onumber = () => numberType().optional();
const oboolean = () => booleanType().optional();
const coerce = {
  string: (arg) => ZodString.create({ ...arg, coerce: true }),
  number: (arg) => ZodNumber.create({ ...arg, coerce: true }),
  boolean: (arg) => ZodBoolean.create({
    ...arg,
    coerce: true
  }),
  bigint: (arg) => ZodBigInt.create({ ...arg, coerce: true }),
  date: (arg) => ZodDate.create({ ...arg, coerce: true })
};
const NEVER = INVALID;
const z$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BRAND,
  DIRTY,
  EMPTY_PATH,
  INVALID,
  NEVER,
  OK,
  ParseStatus,
  Schema: ZodType,
  ZodAny,
  ZodArray,
  ZodBigInt,
  ZodBoolean,
  ZodBranded,
  ZodCatch,
  ZodDate,
  ZodDefault,
  ZodDiscriminatedUnion,
  ZodEffects,
  ZodEnum,
  ZodError,
  get ZodFirstPartyTypeKind() {
    return ZodFirstPartyTypeKind;
  },
  ZodFunction,
  ZodIntersection,
  ZodIssueCode,
  ZodLazy,
  ZodLiteral,
  ZodMap,
  ZodNaN,
  ZodNativeEnum,
  ZodNever,
  ZodNull,
  ZodNullable,
  ZodNumber,
  ZodObject,
  ZodOptional,
  ZodParsedType,
  ZodPipeline,
  ZodPromise,
  ZodReadonly,
  ZodRecord,
  ZodSchema: ZodType,
  ZodSet,
  ZodString,
  ZodSymbol,
  ZodTransformer: ZodEffects,
  ZodTuple,
  ZodType,
  ZodUndefined,
  ZodUnion,
  ZodUnknown,
  ZodVoid,
  addIssueToContext,
  any: anyType,
  array: arrayType,
  bigint: bigIntType,
  boolean: booleanType,
  coerce,
  custom,
  date: dateType,
  datetimeRegex,
  defaultErrorMap: errorMap,
  discriminatedUnion: discriminatedUnionType,
  effect: effectsType,
  enum: enumType,
  function: functionType,
  getErrorMap,
  getParsedType,
  instanceof: instanceOfType,
  intersection: intersectionType,
  isAborted,
  isAsync,
  isDirty,
  isValid: isValid$3,
  late,
  lazy: lazyType,
  literal: literalType,
  makeIssue,
  map: mapType,
  nan: nanType,
  nativeEnum: nativeEnumType,
  never: neverType,
  null: nullType,
  nullable: nullableType,
  number: numberType,
  object: objectType,
  get objectUtil() {
    return objectUtil;
  },
  oboolean,
  onumber,
  optional: optionalType,
  ostring,
  pipeline: pipelineType,
  preprocess: preprocessType,
  promise: promiseType,
  quotelessJson,
  record: recordType,
  set: setType,
  setErrorMap,
  strictObject: strictObjectType,
  string: stringType,
  symbol: symbolType,
  transformer: effectsType,
  tuple: tupleType,
  undefined: undefinedType,
  union: unionType,
  unknown: unknownType,
  get util() {
    return util;
  },
  void: voidType
}, Symbol.toStringTag, { value: "Module" }));
new Set("ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvxyz0123456789");
var setJsonPath = (object, path2, value) => {
  const result = JSONPath({ path: path2, json: object, resultType: "pointer" });
  if (result.length === 0) {
    throw new Error("Path not found in the object.");
  }
  result.forEach((resultPath) => {
    let parts = resultPath.slice(1).split("/");
    let lastPart = parts.pop();
    let currentObject = object;
    parts.forEach((part) => {
      part = decodeURIComponent(part.replace(/~1/g, "/").replace(/~0/g, "~"));
      if (!(part in currentObject)) {
        throw new Error("Intermediate path not found in the object.");
      }
      currentObject = currentObject[part];
    });
    lastPart = decodeURIComponent(
      lastPart.replace(/~1/g, "/").replace(/~0/g, "~")
    );
    currentObject[lastPart] = value;
  });
};
var traverseLeafNodes = (jsonObject, isPathAllowed, callback) => {
  const traverse = (currentObject, currentPath) => {
    if (currentObject !== null && typeof currentObject === "object") {
      if (!Array.isArray(currentObject) && Object.keys(currentObject).length === 0 || Array.isArray(currentObject) && currentObject.length === 0) {
        if (shouldTraverse(currentPath, true)) {
          callback(currentObject, currentPath);
        }
      } else {
        if (!shouldTraverse(currentPath, false)) {
          return;
        }
        Object.entries(currentObject).forEach(([key2, value]) => {
          traverse(
            value,
            `${currentPath}${Array.isArray(currentObject) ? `[${key2}]` : `.${key2}`}`
          );
        });
      }
    } else {
      if (shouldTraverse(currentPath, true)) {
        callback(currentObject, currentPath);
      }
    }
  };
  const shouldTraverse = (path2, isLeaf) => {
    const pathPointer = JSONPath({
      path: path2,
      json: jsonObject,
      resultType: "pointer"
    });
    return isPathAllowed(pathPointer, jsonObject, isLeaf);
  };
  traverse(jsonObject, "$");
};
var isAllowed = (allowPaths) => (pathPointers, jsonObject, isLeaf) => {
  return !isLeaf || allowPaths.some((allowPath) => {
    const allowPathPointers = JSONPath({
      path: allowPath,
      json: jsonObject,
      resultType: "pointer"
    });
    return allowPathPointers.some(
      (app) => pathPointers.some((p2) => p2 === app)
    );
  });
};
var isIgnored = (ignorePaths) => (pathPointers, jsonObject) => {
  return !ignorePaths.some((ignorePath) => {
    const ignorePathPointers = JSONPath({
      path: ignorePath,
      json: jsonObject,
      resultType: "pointer"
    });
    return ignorePathPointers.some(
      (app) => pathPointers.some((p2) => p2 === app)
    );
  });
};
var defaultOptions$1 = {
  startChar: "【",
  endChar: "】",
  defaultVisible: false,
  visibleKeyPaths: [],
  invisibleKeyPaths: [],
  typeKey: "type"
};
var getOptions$1 = (userOptions) => {
  if (!userOptions.type) {
    throw new Error("type option is required");
  }
  return { ...defaultOptions$1, ...userOptions };
};
var parseJson5 = (json5) => {
  try {
    return JSON.parse(jsonrepair(json5));
  } catch (e) {
    return void 0;
  }
};
var jsonBlockLookBack = (userOptions) => {
  const options = getOptions$1(userOptions);
  const { type, typeKey, defaultVisible, visibleKeyPaths, invisibleKeyPaths } = options;
  return ({ output, visibleTextLengthTarget, isComplete }) => {
    const object = parseJson5(removeStartEndChars(output, options));
    if (!object || object[typeKey] !== type) {
      return { output: "", visibleText: "" };
    }
    let remainingChars = visibleTextLengthTarget;
    let visibleText = "";
    const shouldTraverse = defaultVisible ? isIgnored([`$.${typeKey}`, ...invisibleKeyPaths]) : isAllowed(visibleKeyPaths);
    traverseLeafNodes(object, shouldTraverse, (value, path2) => {
      if (typeof value === "string") {
        const valueString = `${value}`;
        const chars = Math.min(remainingChars, valueString.length);
        const valueVisible = valueString.slice(0, chars);
        visibleText += valueVisible;
        setJsonPath(object, path2, valueVisible);
        remainingChars -= chars;
      }
    });
    const isStreamingKeys = defaultVisible || visibleKeyPaths.length > 0;
    return {
      output: JSON.stringify(object, null, 2),
      visibleText: isStreamingKeys ? visibleText : isComplete && visibleTextLengthTarget > 0 ? " " : ""
    };
  };
};
var findJsonBlock = (regex2, options) => {
  const { type } = options;
  const matcher = regexMatcherGlobal(regex2);
  return (llmOutput) => {
    const matches2 = matcher(llmOutput);
    if (matches2.length === 0) {
      return void 0;
    }
    return matches2.find((match5) => {
      const block2 = parseJson5(removeStartEndChars(match5.outputRaw, options));
      if (!block2 || block2[options.typeKey] !== type) {
        return void 0;
      }
      return match5;
    });
  };
};
var findCompleteJsonBlock = (userOptions) => {
  const options = getOptions$1(userOptions);
  const { startChar, endChar } = options;
  const regex2 = new RegExp(`${startChar}([\\s\\S]*?)${endChar}`, "g");
  return findJsonBlock(regex2, options);
};
var findPartialJsonBlock = (userOptions) => {
  const options = getOptions$1(userOptions);
  const { startChar } = options;
  const regex2 = new RegExp(`${startChar}([\\s\\S]*)`, "g");
  return findJsonBlock(regex2, options);
};
var jsonBlock = (options) => {
  return {
    findCompleteMatch: findCompleteJsonBlock(options),
    findPartialMatch: findPartialJsonBlock(options),
    lookBack: jsonBlockLookBack(options),
    component: ({ blockMatch }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://llm-ui.com/docs/blocks/json", children: "Docs to setup your own component" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("pre", { children: blockMatch.output })
    ] })
  };
};
const zID = unionType([stringType(), numberType()]);
const zDependsValue = unionType([
  stringType(),
  numberType(),
  booleanType()
]);
const zDependsWithValue = tupleType([
  stringType(),
  arrayType(zDependsValue).optional()
]);
const zDependsFieldValue = unionType([
  stringType(),
  zDependsWithValue
]);
const zMetaTag = objectType({
  key: stringType(),
  value: stringType()
});
const zChoice = objectType({
  id: stringType().optional(),
  label: stringType(),
  value: unionType([stringType(), numberType()]),
  price: numberType().optional(),
  metadata: arrayType(zMetaTag).optional()
});
const zChoicePair = tupleType([
  stringType(),
  stringType()
]);
const zChoiceWithId = zChoice.extend({
  id: stringType()
});
const zChoiceOption = unionType([
  stringType(),
  zChoicePair,
  zChoice,
  zChoiceWithId
]);
const zFieldBase = objectType({
  name: stringType(),
  label: stringType().optional(),
  officeOnly: booleanType().optional(),
  dependsOn: zDependsFieldValue.optional(),
  editLocked: booleanType().optional(),
  isNew: booleanType().optional(),
  tracks: arrayType(zID).optional(),
  metadata: arrayType(zMetaTag).optional(),
  sort: numberType().optional()
});
const zInputOptions = objectType({
  helpText: stringType().optional(),
  required: booleanType().optional()
});
const zPhasedField = objectType({
  phase: literalType("pretrack").optional()
});
const zInputField = zFieldBase.extend(zInputOptions.shape).extend({
  type: unionType([
    literalType("string"),
    literalType("integer"),
    literalType("date"),
    literalType("time"),
    literalType("boolean"),
    literalType("telephone"),
    literalType("attendee_reference"),
    literalType("document")
  ]),
  choices: arrayType(zChoiceOption).nullable().optional(),
  includeBlank: booleanType().optional(),
  widget: unionType([
    literalType("radio"),
    literalType("textarea"),
    literalType("email"),
    literalType("text"),
    literalType(""),
    nullType()
  ]).optional(),
  price: unionType([stringType(), numberType()]).optional(),
  checkpoint: booleanType().optional()
});
const zRoomBlockField = zFieldBase.extend(zInputOptions.shape).extend({
  type: literalType("room_block"),
  roomBlockId: zID,
  includeRoomTypes: arrayType(stringType()).optional(),
  priceOverrides: recordType(stringType(), numberType()).optional(),
  occupancyPricing: booleanType().optional(),
  occupancyPriceOverrides: recordType(stringType(), recordType(numberType(), numberType())).optional(),
  availableFrom: stringType().optional(),
  availableTo: stringType().optional(),
  defaultCheckIn: stringType().optional(),
  defaultCheckOut: stringType().optional()
});
const zSessionBookingField = zFieldBase.extend(zInputOptions.shape).extend({
  type: literalType("session_booking"),
  includeSlots: arrayType(zID).optional(),
  defaultSlots: arrayType(zID).optional(),
  session: zID,
  quantityField: stringType().optional(),
  minChoices: numberType().optional(),
  maxChoices: numberType().optional(),
  priceOverrides: recordType(zID, numberType()).optional()
});
zSessionBookingField.extend(
  {
    includeSlots: arrayType(zID)
  }
);
const zInfoField = zFieldBase.extend({
  type: literalType("info"),
  text: stringType()
});
const zLeadScannerField = zFieldBase.extend(zInputOptions.shape).extend({
  type: literalType("lead_scanner"),
  price: unionType([stringType(), numberType()]).optional()
});
const zFormField = unionType([
  zInputField,
  zRoomBlockField,
  zSessionBookingField,
  zInfoField,
  zLeadScannerField
]);
const zFormSection = zFieldBase.extend({
  type: literalType("section"),
  fields: arrayType(zFormField)
});
const zFormPage = zFieldBase.extend(zPhasedField.shape).extend({
  type: literalType("page"),
  fields: arrayType(unionType([zFormField, zFormSection]))
});
const zFormItem = unionType([
  zFormField,
  zFormSection,
  zFormPage
]);
const zFieldContainer = unionType([
  zFormPage,
  zFormSection
]);
objectType({
  field: zFormItem.optional(),
  container: arrayType(zFormItem).optional()
});
objectType({
  field: zFormItem.optional(),
  parent: zFieldContainer.optional()
});
objectType({
  pretrack: arrayType(zFormPage),
  default: arrayType(zFormPage)
});
const zInputFieldNoChoices = zInputField.omit({
  choices: true
});
const zTextField = zInputFieldNoChoices.extend({
  type: literalType("string"),
  kind: literalType("text")
});
const zTextAreaField = zInputFieldNoChoices.extend({
  type: literalType("string"),
  kind: literalType("textarea"),
  widget: literalType("textarea")
});
const zEmailField = zInputFieldNoChoices.extend({
  type: literalType("string"),
  kind: literalType("email"),
  widget: literalType("email")
});
const zNumberField = zInputFieldNoChoices.extend({
  type: literalType("integer"),
  kind: literalType("integer")
});
const zPhoneNumberField = zInputFieldNoChoices.extend({
  type: literalType("telephone"),
  kind: literalType("telephone")
});
const zAttendeeReferenceField = zInputFieldNoChoices.extend({
  type: literalType("attendee_reference"),
  kind: literalType("attendee_reference")
});
const zDropDownField = zFieldBase.extend(zInputOptions.shape).extend({
  type: unionType([literalType("string"), literalType("integer")]),
  kind: literalType("dropdown"),
  choices: arrayType(zChoiceOption),
  includeBlank: booleanType().optional()
});
const zRadioField = zFieldBase.extend(zInputOptions.shape).extend({
  type: unionType([literalType("string"), literalType("integer")]),
  kind: literalType("radio"),
  choices: arrayType(zChoiceOption),
  widget: literalType("radio")
});
const zDocumentUploadField = zInputFieldNoChoices.extend({
  type: literalType("document"),
  kind: literalType("document")
});
const zCheckBoxField = zInputFieldNoChoices.extend({
  type: literalType("boolean"),
  kind: literalType("checkbox")
});
const zDateField = zInputFieldNoChoices.extend({
  type: literalType("date"),
  kind: literalType("date")
});
const zAddTextField = objectType({
  type: literalType("add_text_field"),
  parentId: stringType(),
  payload: objectType({ field: zTextField })
});
const zAddTextareaField = objectType({
  type: literalType("add_textarea_field"),
  parentId: stringType(),
  payload: objectType({ field: zTextAreaField })
});
const zAddEmailField = objectType({
  type: literalType("add_email_field"),
  parentId: stringType(),
  payload: objectType({ field: zEmailField })
});
const zAddNumberField = objectType({
  type: literalType("add_number_field"),
  parentId: stringType(),
  payload: objectType({ field: zNumberField })
});
const zAddPhoneNumberField = objectType({
  type: literalType("add_phone_number_field"),
  parentId: stringType(),
  payload: objectType({ field: zPhoneNumberField })
});
const zAddAttendeeReferenceField = objectType({
  type: literalType("add_attendee_reference_field"),
  parentId: stringType(),
  payload: objectType({ field: zAttendeeReferenceField })
});
const zAddDropdownField = objectType({
  type: literalType("add_dropdown_field"),
  parentId: stringType(),
  payload: objectType({ field: zDropDownField })
});
const zAddRadioField = objectType({
  type: literalType("add_radio_field"),
  parentId: stringType(),
  payload: objectType({ field: zRadioField })
});
const zAddDocumentUploadField = objectType({
  type: literalType("add_document_upload_field"),
  parentId: stringType(),
  payload: objectType({ field: zDocumentUploadField })
});
const zAddCheckboxField = objectType({
  type: literalType("add_checkbox_field"),
  parentId: stringType(),
  payload: objectType({ field: zCheckBoxField })
});
const zAddDateField = objectType({
  type: literalType("add_date_field"),
  parentId: stringType(),
  payload: objectType({ field: zDateField })
});
const zAddRoomBlockField = objectType({
  type: literalType("add_room_block_field"),
  parentId: stringType(),
  payload: objectType({ field: zRoomBlockField })
});
const zAddSessionBookingField = objectType({
  type: literalType("add_session_booking_field"),
  parentId: stringType(),
  payload: objectType({
    field: zSessionBookingField.extend({ type: literalType("session_booking") })
  })
});
const zAddInfoField = objectType({
  type: literalType("add_info_field"),
  parentId: stringType(),
  payload: objectType({ field: zInfoField })
});
const zAddLeadScannerField = objectType({
  type: literalType("add_lead_scanner_field"),
  parentId: stringType(),
  payload: objectType({ field: zLeadScannerField })
});
const zAddSection = objectType({
  type: literalType("add_section"),
  parentId: stringType(),
  payload: objectType({ section: zFormSection.omit({ fields: true }) })
});
const zAddPage = objectType({
  type: literalType("add_page"),
  payload: objectType({ page: zFormPage.omit({ fields: true }) })
});
const zUpdateTextField = objectType({
  type: literalType("update_text_field"),
  payload: objectType({ id: zID, field: zTextField.partial() })
});
const zUpdateTextareaField = objectType({
  type: literalType("update_textarea_field"),
  payload: objectType({ id: zID, field: zTextAreaField.partial() })
});
const zUpdateEmailField = objectType({
  type: literalType("update_email_field"),
  payload: objectType({ id: zID, field: zEmailField.partial() })
});
const zUpdateNumberField = objectType({
  type: literalType("update_number_field"),
  payload: objectType({ id: zID, field: zNumberField.partial() })
});
const zUpdatePhoneNumberField = objectType({
  type: literalType("update_phone_number_field"),
  payload: objectType({ id: zID, field: zPhoneNumberField.partial() })
});
const zUpdateAttendeeReferenceField = objectType({
  type: literalType("update_attendee_reference_field"),
  payload: objectType({ id: zID, field: zAttendeeReferenceField.partial() })
});
const zUpdateDropdownField = objectType({
  type: literalType("update_dropdown_field"),
  payload: objectType({ id: zID, field: zDropDownField.partial() })
});
const zUpdateRadioField = objectType({
  type: literalType("update_radio_field"),
  payload: objectType({ id: zID, field: zRadioField.partial() })
});
const zUpdateDocumentUploadField = objectType({
  type: literalType("update_document_upload_field"),
  payload: objectType({ id: zID, field: zDocumentUploadField.partial() })
});
const zUpdateCheckboxField = objectType({
  type: literalType("update_checkbox_field"),
  payload: objectType({ id: zID, field: zCheckBoxField.partial() })
});
const zUpdateDateField = objectType({
  type: literalType("update_date_field"),
  payload: objectType({ id: zID, field: zDateField.partial() })
});
const zUpdateRoomBlockField = objectType({
  type: literalType("update_room_block_field"),
  payload: objectType({ id: zID, field: zRoomBlockField.partial() })
});
const zUpdateSessionBookingField = objectType({
  type: literalType("update_session_booking_field"),
  payload: objectType({ id: zID, field: zSessionBookingField.partial() })
});
const zUpdateInfoField = objectType({
  type: literalType("update_info_field"),
  payload: objectType({ id: zID, field: zInfoField.partial() })
});
const zUpdateLeadScannerField = objectType({
  type: literalType("update_lead_scanner_field"),
  payload: objectType({ id: zID, field: zLeadScannerField.partial() })
});
const zUpdateSection = objectType({
  type: literalType("update_section"),
  payload: objectType({ id: zID, section: zFormSection.partial() })
});
const zUpdatePage = objectType({
  type: literalType("update_page"),
  payload: objectType({ id: zID, page: zFormPage.partial() })
});
const zDeleteItem = objectType({
  type: literalType("delete_item"),
  payload: objectType({ id: zID, label: stringType() })
});
const zMoveField = objectType({
  type: literalType("move_field"),
  payload: objectType({ id: zID, index: numberType(), destination: zID, label: stringType(), destinationLabel: stringType() })
});
const zMovePage = objectType({
  type: literalType("move_page"),
  payload: objectType({ id: zID, toIndex: numberType(), label: stringType() })
});
const zFormAssistantAction = discriminatedUnionType("type", [
  zAddTextField,
  zAddTextareaField,
  zAddEmailField,
  zAddNumberField,
  zAddPhoneNumberField,
  zAddAttendeeReferenceField,
  zAddDropdownField,
  zAddRadioField,
  zAddDocumentUploadField,
  zAddCheckboxField,
  zAddDateField,
  zAddRoomBlockField,
  zAddSessionBookingField,
  zAddInfoField,
  zAddLeadScannerField,
  zAddSection,
  zAddPage,
  zUpdateTextField,
  zUpdateTextareaField,
  zUpdateEmailField,
  zUpdateNumberField,
  zUpdatePhoneNumberField,
  zUpdateAttendeeReferenceField,
  zUpdateDropdownField,
  zUpdateRadioField,
  zUpdateDocumentUploadField,
  zUpdateCheckboxField,
  zUpdateDateField,
  zUpdateRoomBlockField,
  zUpdateSessionBookingField,
  zUpdateInfoField,
  zUpdateLeadScannerField,
  zUpdateSection,
  zUpdatePage,
  zDeleteItem,
  zMoveField,
  zMovePage
]);
const zFormAssistantChangeSuggestion = objectType({
  type: literalType("form_assistant_actions"),
  actions: arrayType(zFormAssistantAction)
  // Represents a tuple with at least one FormAssistantAction
});
function getActionSummary(action) {
  switch (action.type) {
    case "add_text_field":
      return `Add text field "${action.payload.field.label}"`;
    case "add_textarea_field":
      return `Add text area "${action.payload.field.label}"`;
    case "add_email_field":
      return `Add email field "${action.payload.field.label}"`;
    case "add_number_field":
      return `Add number field "${action.payload.field.label}"`;
    case "add_phone_number_field":
      return `Add phone number field "${action.payload.field.label}"`;
    case "add_dropdown_field":
      return `Add dropdown "${action.payload.field.label}"`;
    case "add_radio_field":
      return `Add radio options "${action.payload.field.label}"`;
    case "add_checkbox_field":
      return `Add checkbox "${action.payload.field.label}"`;
    case "add_date_field":
      return `Add date field "${action.payload.field.label}"`;
    case "add_section":
      return `Add section "${action.payload.section.label}"`;
    case "add_page":
      return `Add page "${action.payload.page.label}"`;
    case "add_room_block_field":
      return `Add room block "${action.payload.field.label}"`;
    case "add_session_booking_field":
      return `Add session booking "${action.payload.field.label}"`;
    case "add_info_field":
      return `Add info field "${action.payload.field.label}"`;
    case "add_lead_scanner_field":
      return `Add lead scanner field "${action.payload.field.label}"`;
    case "update_text_field":
    case "update_textarea_field":
    case "update_email_field":
    case "update_number_field":
    case "update_phone_number_field":
    case "update_dropdown_field":
    case "update_radio_field":
    case "update_checkbox_field":
    case "update_date_field":
    case "update_room_block_field":
    case "update_session_booking_field":
    case "update_info_field":
    case "update_lead_scanner_field":
      return `Update field ${action.payload.field.label}`;
    case "update_section":
      return `Update section ${action.payload.section.label}`;
    case "update_page":
      return `Update page ${action.payload.page.label}`;
    case "delete_item":
      return `Delete item ${action.payload.label}`;
    case "move_field":
      return `Move field ${action.payload.label} to ${action.payload.destinationLabel}`;
    case "move_page":
      return `Move page ${action.payload.label} to ${action.payload.toIndex}`;
    default:
      return `Unknown action`;
  }
}
const ActionSuggestions$1 = ({
  suggestion,
  status,
  onAccept,
  onReject
}) => {
  const borderColor2 = useColorModeValue("gray.200", "gray.600");
  const bgColor = useColorModeValue("gray.50", "gray.700");
  if (status === "accepted" || status === "rejected") {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Box$1,
      {
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: borderColor2,
        borderRadius: "md",
        p: 4,
        my: 3,
        bg: bgColor,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { fontWeight: "bold", mb: 2, children: status === "accepted" ? "Accepted Form Changes" : "Rejected Form Changes" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(List$1, { spacing: 1, mb: 3, pl: 4, children: suggestion.actions.map((action, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { fontSize: "sm", children: getActionSummary(action) }) }, index2)) })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box$1,
    {
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: borderColor2,
      borderRadius: "md",
      p: 4,
      my: 3,
      bg: bgColor,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { fontWeight: "bold", mb: 2, children: "Suggested Form Changes" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(List$1, { spacing: 1, mb: 3, pl: 4, children: suggestion.actions.map((action, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { fontSize: "sm", children: getActionSummary(action) }) }, index2)) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { justifyContent: "flex-end", gap: 3, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "red", size: "sm", onClick: onReject, children: "Decline" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", size: "sm", onClick: onAccept, children: "Apply Changes" })
        ] })
      ]
    }
  );
};
function ydocChangeSuggestionsActionTransformer(action) {
  switch (action.type) {
    case "add_radio_field": {
      return {
        type: "add_field",
        parent: action.parentId,
        field: {
          ...action.payload.field,
          widget: "radio"
        }
      };
    }
    // ----- ADD FIELD ACTIONS -----
    case "add_text_field":
    case "add_textarea_field":
    case "add_email_field":
    case "add_number_field":
    case "add_phone_number_field":
    case "add_attendee_reference_field":
    case "add_dropdown_field":
    case "add_document_upload_field":
    case "add_checkbox_field":
    case "add_date_field":
    case "add_room_block_field":
    case "add_session_booking_field":
    case "add_info_field":
    case "add_lead_scanner_field": {
      return {
        type: "add_field",
        parent: action.parentId,
        field: action.payload.field
      };
    }
    case "add_section": {
      return {
        type: "add_field",
        parent: action.parentId,
        field: { ...action.payload.section, fields: [] }
      };
    }
    case "add_page": {
      return {
        type: "add_page",
        page: action.payload.page
      };
    }
    // ----- UPDATE FIELD ACTIONS -----
    case "update_text_field":
    case "update_textarea_field":
    case "update_email_field":
    case "update_number_field":
    case "update_phone_number_field":
    case "update_attendee_reference_field":
    case "update_dropdown_field":
    case "update_radio_field":
    case "update_document_upload_field":
    case "update_checkbox_field":
    case "update_date_field":
    case "update_room_block_field":
    case "update_session_booking_field":
    case "update_info_field":
    case "update_lead_scanner_field": {
      return {
        type: "update_field",
        name: action.payload.id.toString(),
        payload: action.payload.field
      };
    }
    // ----- UPDATE CONTAINER ACTIONS -----
    case "update_section": {
      return {
        type: "update_field",
        name: action.payload.id.toString(),
        payload: action.payload.section
      };
    }
    case "update_page": {
      return {
        type: "update_field",
        name: action.payload.id.toString(),
        payload: action.payload.page
      };
    }
    // ----- MOVE ACTIONS -----
    case "move_field": {
      return {
        type: "move_field",
        field: action.payload.id.toString(),
        index: action.payload.index,
        destination: action.payload.destination.toString()
      };
    }
    case "move_page": {
      return {
        type: "move_page",
        name: action.payload.id.toString(),
        toIndex: action.payload.toIndex
      };
    }
    // ----- DELETE ACTIONS -----
    case "delete_item": {
      return {
        type: "delete_field",
        name: action.payload.id.toString()
      };
    }
  }
}
const ActionSuggestionsContainer$1 = ({ suggestion }) => {
  const [acceptanceStatus, setAcceptanceStatus] = useState("pending");
  const { dispatch } = useCollabRegForm();
  const handleAccept = useCallback$1(() => {
    setAcceptanceStatus("accepted");
    const transformedActions = suggestion.actions.map(
      (action) => ydocChangeSuggestionsActionTransformer(action)
    );
    console.log("Dispatching batched actions", transformedActions);
    dispatch({
      type: "batch_change",
      payload: transformedActions
    });
  }, [suggestion]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    ActionSuggestions$1,
    {
      suggestion,
      status: acceptanceStatus,
      onAccept: handleAccept,
      onReject: () => setAcceptanceStatus("rejected")
    }
  );
};
const SuggestedActionsOutput$1 = ({ blockMatch }) => {
  if (!blockMatch.isVisible) {
    return null;
  }
  const { data: suggestion, error: error2 } = zFormAssistantChangeSuggestion.safeParse(
    parseJson5(blockMatch.output)
  );
  if (error2) {
    console.error("Error parsing JSON:", error2.toString());
    console.error("Output is", parseJson5(blockMatch.output));
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: error2.toString() });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionSuggestionsContainer$1, { suggestion });
};
const buttonsSchema$1 = z$1.object({
  type: z$1.literal("buttons"),
  buttons: z$1.array(z$1.object({ text: z$1.string() }))
});
const ReasoningOutput$1 = ({ blockMatch }) => {
  if (!blockMatch.isVisible) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    "Reasoning:",
    blockMatch.output
  ] });
};
const ChoiceOutput = ({ blockMatch, onChoiceClick }) => {
  if (!blockMatch.isVisible) {
    return null;
  }
  const { data: buttons, error: error2 } = buttonsSchema$1.safeParse(
    parseJson5(blockMatch.output)
  );
  if (error2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: error2.toString() });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: buttons.buttons.map((button, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: () => onChoiceClick == null ? void 0 : onChoiceClick(button.text), children: button.text }, index2)) });
};
const FormAssistantChatMessage$1 = ({
  message: message2,
  onAsk = () => {
  }
}) => {
  const ChoiceOutputWithAsk = ({ blockMatch }) => /* @__PURE__ */ jsxRuntimeExports.jsx(ChoiceOutput, { blockMatch, onChoiceClick: onAsk });
  const { blockMatches } = useLLMOutput({
    llmOutput: message2.content,
    blocks: [
      {
        ...jsonBlock({ type: "form_assistant_actions" }),
        component: SuggestedActionsOutput$1
      },
      {
        ...jsonBlock({ type: "reasoning" }),
        component: ReasoningOutput$1
      },
      {
        ...jsonBlock({ type: "buttons" }),
        component: ChoiceOutputWithAsk
      }
    ],
    fallbackBlock: {
      component: MarkdownOutput$1,
      // from Step 1
      lookBack: markdownLookBack()
    },
    isStreamFinished: message2.isStreamFinished
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: message2.author }),
    blockMatches.map((match5, index2) => {
      const BlockComponent = match5.block.component;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BlockComponent, { blockMatch: match5 }, index2);
    })
  ] });
};
const FormAssistantChat$1 = () => {
  const { chat } = useChat();
  if (!chat) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { spacing: 4, align: "stretch", children: [
    chat.messages.map((message2, index2) => {
      if (message2.isCurrentUser) {
        return /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("b", { children: [
            message2.author,
            ":"
          ] }),
          message2.content
        ] }, index2);
      } else {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(FormAssistantChatMessage$1, { message: message2, onAsk: chat.onAsk }, index2);
      }
    }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Input$1,
      {
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            const input = e.currentTarget.value;
            chat.onAsk(input);
            e.currentTarget.value = "";
          }
        }
      }
    )
  ] }) });
};
function getTabFromIndex(index2) {
  switch (index2) {
    case 0:
      return "add";
    case 1:
      return "edit";
    case 2:
      return "history";
    case 3:
      return "chat";
    default:
      throw new Error("Invalid tab index");
  }
}
function getIndexFromTab(tab2) {
  switch (tab2) {
    case "edit":
      return 1;
    case "history":
      return 2;
    case "chat":
      return 3;
    case "add":
    default:
      return 0;
  }
}
const RightPanel = ({
  onFieldAdded,
  showHistory = false
}) => {
  const { form, editorState, dispatch } = useRegForm();
  const { selectedField } = getSelectedItems$1({
    fields: form.fields,
    ...editorState
  });
  const tabIndex = getIndexFromTab(editorState.selectedTab);
  const { chat } = useChat();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Tabs,
    {
      isFitted: true,
      index: tabIndex,
      onChange: (index2) => dispatch({ type: "select_tab", tab: getTabFromIndex(index2) }),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(TabList, { borderBottomWidth: 1, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(RightPanelTab, { children: "Add" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(RightPanelTab, { children: "Edit" }),
          showHistory && /* @__PURE__ */ jsxRuntimeExports.jsx(RightPanelTab, { children: "History" }),
          chat && /* @__PURE__ */ jsxRuntimeExports.jsx(RightPanelTab, { children: "Chat" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(TabPanels, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(TabPanel, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(AddPanel$1, { onFieldAdded }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(TabPanel, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldEditor, { field: selectedField }) }),
          showHistory && /* @__PURE__ */ jsxRuntimeExports.jsx(TabPanel, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChangeHistoryListContainer$1, {}) }),
          chat && /* @__PURE__ */ jsxRuntimeExports.jsx(TabPanel, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormAssistantChat$1, {}) })
        ] })
      ]
    }
  );
};
function _classCallCheck(a2, n2) {
  if (!(a2 instanceof n2)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r2) {
  for (var t2 = 0; t2 < r2.length; t2++) {
    var o2 = r2[t2];
    o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e, toPropertyKey(o2.key), o2);
  }
}
function _createClass(e, r2, t2) {
  return r2 && _defineProperties(e.prototype, r2), t2 && _defineProperties(e, t2), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t2, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t2.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t2,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t2, "prototype", {
    writable: false
  }), e && _setPrototypeOf$3(t2, e);
}
function _possibleConstructorReturn(t2, e) {
  if (e && ("object" == _typeof$1(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t2);
}
function _getPrototypeOf(t2) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t3) {
    return t3.__proto__ || Object.getPrototypeOf(t3);
  }, _getPrototypeOf(t2);
}
var es6_object_assign = {};
var _global = { exports: {} };
var hasRequired_global;
function require_global() {
  if (hasRequired_global) return _global.exports;
  hasRequired_global = 1;
  var global2 = _global.exports = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
  if (typeof __g == "number") __g = global2;
  return _global.exports;
}
var _core = { exports: {} };
var hasRequired_core;
function require_core() {
  if (hasRequired_core) return _core.exports;
  hasRequired_core = 1;
  var core = _core.exports = { version: "2.6.12" };
  if (typeof __e == "number") __e = core;
  return _core.exports;
}
var _aFunction;
var hasRequired_aFunction;
function require_aFunction() {
  if (hasRequired_aFunction) return _aFunction;
  hasRequired_aFunction = 1;
  _aFunction = function(it) {
    if (typeof it != "function") throw TypeError(it + " is not a function!");
    return it;
  };
  return _aFunction;
}
var _ctx;
var hasRequired_ctx;
function require_ctx() {
  if (hasRequired_ctx) return _ctx;
  hasRequired_ctx = 1;
  var aFunction = require_aFunction();
  _ctx = function(fn2, that, length2) {
    aFunction(fn2);
    if (that === void 0) return fn2;
    switch (length2) {
      case 1:
        return function(a2) {
          return fn2.call(that, a2);
        };
      case 2:
        return function(a2, b2) {
          return fn2.call(that, a2, b2);
        };
      case 3:
        return function(a2, b2, c2) {
          return fn2.call(that, a2, b2, c2);
        };
    }
    return function() {
      return fn2.apply(that, arguments);
    };
  };
  return _ctx;
}
var _objectDp = {};
var _isObject;
var hasRequired_isObject;
function require_isObject() {
  if (hasRequired_isObject) return _isObject;
  hasRequired_isObject = 1;
  _isObject = function(it) {
    return typeof it === "object" ? it !== null : typeof it === "function";
  };
  return _isObject;
}
var _anObject;
var hasRequired_anObject;
function require_anObject() {
  if (hasRequired_anObject) return _anObject;
  hasRequired_anObject = 1;
  var isObject2 = require_isObject();
  _anObject = function(it) {
    if (!isObject2(it)) throw TypeError(it + " is not an object!");
    return it;
  };
  return _anObject;
}
var _fails;
var hasRequired_fails;
function require_fails() {
  if (hasRequired_fails) return _fails;
  hasRequired_fails = 1;
  _fails = function(exec) {
    try {
      return !!exec();
    } catch (e) {
      return true;
    }
  };
  return _fails;
}
var _descriptors;
var hasRequired_descriptors;
function require_descriptors() {
  if (hasRequired_descriptors) return _descriptors;
  hasRequired_descriptors = 1;
  _descriptors = !require_fails()(function() {
    return Object.defineProperty({}, "a", { get: function() {
      return 7;
    } }).a != 7;
  });
  return _descriptors;
}
var _domCreate;
var hasRequired_domCreate;
function require_domCreate() {
  if (hasRequired_domCreate) return _domCreate;
  hasRequired_domCreate = 1;
  var isObject2 = require_isObject();
  var document2 = require_global().document;
  var is2 = isObject2(document2) && isObject2(document2.createElement);
  _domCreate = function(it) {
    return is2 ? document2.createElement(it) : {};
  };
  return _domCreate;
}
var _ie8DomDefine;
var hasRequired_ie8DomDefine;
function require_ie8DomDefine() {
  if (hasRequired_ie8DomDefine) return _ie8DomDefine;
  hasRequired_ie8DomDefine = 1;
  _ie8DomDefine = !require_descriptors() && !require_fails()(function() {
    return Object.defineProperty(require_domCreate()("div"), "a", { get: function() {
      return 7;
    } }).a != 7;
  });
  return _ie8DomDefine;
}
var _toPrimitive;
var hasRequired_toPrimitive;
function require_toPrimitive() {
  if (hasRequired_toPrimitive) return _toPrimitive;
  hasRequired_toPrimitive = 1;
  var isObject2 = require_isObject();
  _toPrimitive = function(it, S2) {
    if (!isObject2(it)) return it;
    var fn2, val;
    if (S2 && typeof (fn2 = it.toString) == "function" && !isObject2(val = fn2.call(it))) return val;
    if (typeof (fn2 = it.valueOf) == "function" && !isObject2(val = fn2.call(it))) return val;
    if (!S2 && typeof (fn2 = it.toString) == "function" && !isObject2(val = fn2.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
  };
  return _toPrimitive;
}
var hasRequired_objectDp;
function require_objectDp() {
  if (hasRequired_objectDp) return _objectDp;
  hasRequired_objectDp = 1;
  var anObject = require_anObject();
  var IE8_DOM_DEFINE = require_ie8DomDefine();
  var toPrimitive2 = require_toPrimitive();
  var dP = Object.defineProperty;
  _objectDp.f = require_descriptors() ? Object.defineProperty : function defineProperty(O2, P2, Attributes) {
    anObject(O2);
    P2 = toPrimitive2(P2, true);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
      return dP(O2, P2, Attributes);
    } catch (e) {
    }
    if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported!");
    if ("value" in Attributes) O2[P2] = Attributes.value;
    return O2;
  };
  return _objectDp;
}
var _propertyDesc;
var hasRequired_propertyDesc;
function require_propertyDesc() {
  if (hasRequired_propertyDesc) return _propertyDesc;
  hasRequired_propertyDesc = 1;
  _propertyDesc = function(bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value
    };
  };
  return _propertyDesc;
}
var _hide;
var hasRequired_hide;
function require_hide() {
  if (hasRequired_hide) return _hide;
  hasRequired_hide = 1;
  var dP = require_objectDp();
  var createDesc = require_propertyDesc();
  _hide = require_descriptors() ? function(object, key2, value) {
    return dP.f(object, key2, createDesc(1, value));
  } : function(object, key2, value) {
    object[key2] = value;
    return object;
  };
  return _hide;
}
var _has;
var hasRequired_has;
function require_has() {
  if (hasRequired_has) return _has;
  hasRequired_has = 1;
  var hasOwnProperty2 = {}.hasOwnProperty;
  _has = function(it, key2) {
    return hasOwnProperty2.call(it, key2);
  };
  return _has;
}
var _export;
var hasRequired_export;
function require_export() {
  if (hasRequired_export) return _export;
  hasRequired_export = 1;
  var global2 = require_global();
  var core = require_core();
  var ctx = require_ctx();
  var hide = require_hide();
  var has2 = require_has();
  var PROTOTYPE = "prototype";
  var $export = function(type, name2, source) {
    var IS_FORCED = type & $export.F;
    var IS_GLOBAL = type & $export.G;
    var IS_STATIC = type & $export.S;
    var IS_PROTO = type & $export.P;
    var IS_BIND = type & $export.B;
    var IS_WRAP = type & $export.W;
    var exports = IS_GLOBAL ? core : core[name2] || (core[name2] = {});
    var expProto = exports[PROTOTYPE];
    var target = IS_GLOBAL ? global2 : IS_STATIC ? global2[name2] : (global2[name2] || {})[PROTOTYPE];
    var key2, own2, out;
    if (IS_GLOBAL) source = name2;
    for (key2 in source) {
      own2 = !IS_FORCED && target && target[key2] !== void 0;
      if (own2 && has2(exports, key2)) continue;
      out = own2 ? target[key2] : source[key2];
      exports[key2] = IS_GLOBAL && typeof target[key2] != "function" ? source[key2] : IS_BIND && own2 ? ctx(out, global2) : IS_WRAP && target[key2] == out ? function(C2) {
        var F2 = function(a2, b2, c2) {
          if (this instanceof C2) {
            switch (arguments.length) {
              case 0:
                return new C2();
              case 1:
                return new C2(a2);
              case 2:
                return new C2(a2, b2);
            }
            return new C2(a2, b2, c2);
          }
          return C2.apply(this, arguments);
        };
        F2[PROTOTYPE] = C2[PROTOTYPE];
        return F2;
      }(out) : IS_PROTO && typeof out == "function" ? ctx(Function.call, out) : out;
      if (IS_PROTO) {
        (exports.virtual || (exports.virtual = {}))[key2] = out;
        if (type & $export.R && expProto && !expProto[key2]) hide(expProto, key2, out);
      }
    }
  };
  $export.F = 1;
  $export.G = 2;
  $export.S = 4;
  $export.P = 8;
  $export.B = 16;
  $export.W = 32;
  $export.U = 64;
  $export.R = 128;
  _export = $export;
  return _export;
}
var _cof;
var hasRequired_cof;
function require_cof() {
  if (hasRequired_cof) return _cof;
  hasRequired_cof = 1;
  var toString3 = {}.toString;
  _cof = function(it) {
    return toString3.call(it).slice(8, -1);
  };
  return _cof;
}
var _iobject;
var hasRequired_iobject;
function require_iobject() {
  if (hasRequired_iobject) return _iobject;
  hasRequired_iobject = 1;
  var cof = require_cof();
  _iobject = Object("z").propertyIsEnumerable(0) ? Object : function(it) {
    return cof(it) == "String" ? it.split("") : Object(it);
  };
  return _iobject;
}
var _defined;
var hasRequired_defined;
function require_defined() {
  if (hasRequired_defined) return _defined;
  hasRequired_defined = 1;
  _defined = function(it) {
    if (it == void 0) throw TypeError("Can't call method on  " + it);
    return it;
  };
  return _defined;
}
var _toIobject;
var hasRequired_toIobject;
function require_toIobject() {
  if (hasRequired_toIobject) return _toIobject;
  hasRequired_toIobject = 1;
  var IObject = require_iobject();
  var defined = require_defined();
  _toIobject = function(it) {
    return IObject(defined(it));
  };
  return _toIobject;
}
var _toInteger;
var hasRequired_toInteger;
function require_toInteger() {
  if (hasRequired_toInteger) return _toInteger;
  hasRequired_toInteger = 1;
  var ceil = Math.ceil;
  var floor2 = Math.floor;
  _toInteger = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor2 : ceil)(it);
  };
  return _toInteger;
}
var _toLength;
var hasRequired_toLength;
function require_toLength() {
  if (hasRequired_toLength) return _toLength;
  hasRequired_toLength = 1;
  var toInteger = require_toInteger();
  var min2 = Math.min;
  _toLength = function(it) {
    return it > 0 ? min2(toInteger(it), 9007199254740991) : 0;
  };
  return _toLength;
}
var _toAbsoluteIndex;
var hasRequired_toAbsoluteIndex;
function require_toAbsoluteIndex() {
  if (hasRequired_toAbsoluteIndex) return _toAbsoluteIndex;
  hasRequired_toAbsoluteIndex = 1;
  var toInteger = require_toInteger();
  var max2 = Math.max;
  var min2 = Math.min;
  _toAbsoluteIndex = function(index2, length2) {
    index2 = toInteger(index2);
    return index2 < 0 ? max2(index2 + length2, 0) : min2(index2, length2);
  };
  return _toAbsoluteIndex;
}
var _arrayIncludes;
var hasRequired_arrayIncludes;
function require_arrayIncludes() {
  if (hasRequired_arrayIncludes) return _arrayIncludes;
  hasRequired_arrayIncludes = 1;
  var toIObject = require_toIobject();
  var toLength = require_toLength();
  var toAbsoluteIndex = require_toAbsoluteIndex();
  _arrayIncludes = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
      var O2 = toIObject($this);
      var length2 = toLength(O2.length);
      var index2 = toAbsoluteIndex(fromIndex, length2);
      var value;
      if (IS_INCLUDES && el != el) while (length2 > index2) {
        value = O2[index2++];
        if (value != value) return true;
      }
      else for (; length2 > index2; index2++) if (IS_INCLUDES || index2 in O2) {
        if (O2[index2] === el) return IS_INCLUDES || index2 || 0;
      }
      return !IS_INCLUDES && -1;
    };
  };
  return _arrayIncludes;
}
var _shared = { exports: {} };
var _library;
var hasRequired_library;
function require_library() {
  if (hasRequired_library) return _library;
  hasRequired_library = 1;
  _library = true;
  return _library;
}
var hasRequired_shared;
function require_shared() {
  if (hasRequired_shared) return _shared.exports;
  hasRequired_shared = 1;
  var core = require_core();
  var global2 = require_global();
  var SHARED = "__core-js_shared__";
  var store = global2[SHARED] || (global2[SHARED] = {});
  (_shared.exports = function(key2, value) {
    return store[key2] || (store[key2] = value !== void 0 ? value : {});
  })("versions", []).push({
    version: core.version,
    mode: require_library() ? "pure" : "global",
    copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
  });
  return _shared.exports;
}
var _uid;
var hasRequired_uid;
function require_uid() {
  if (hasRequired_uid) return _uid;
  hasRequired_uid = 1;
  var id = 0;
  var px = Math.random();
  _uid = function(key2) {
    return "Symbol(".concat(key2 === void 0 ? "" : key2, ")_", (++id + px).toString(36));
  };
  return _uid;
}
var _sharedKey;
var hasRequired_sharedKey;
function require_sharedKey() {
  if (hasRequired_sharedKey) return _sharedKey;
  hasRequired_sharedKey = 1;
  var shared2 = require_shared()("keys");
  var uid2 = require_uid();
  _sharedKey = function(key2) {
    return shared2[key2] || (shared2[key2] = uid2(key2));
  };
  return _sharedKey;
}
var _objectKeysInternal;
var hasRequired_objectKeysInternal;
function require_objectKeysInternal() {
  if (hasRequired_objectKeysInternal) return _objectKeysInternal;
  hasRequired_objectKeysInternal = 1;
  var has2 = require_has();
  var toIObject = require_toIobject();
  var arrayIndexOf = require_arrayIncludes()(false);
  var IE_PROTO = require_sharedKey()("IE_PROTO");
  _objectKeysInternal = function(object, names) {
    var O2 = toIObject(object);
    var i = 0;
    var result = [];
    var key2;
    for (key2 in O2) if (key2 != IE_PROTO) has2(O2, key2) && result.push(key2);
    while (names.length > i) if (has2(O2, key2 = names[i++])) {
      ~arrayIndexOf(result, key2) || result.push(key2);
    }
    return result;
  };
  return _objectKeysInternal;
}
var _enumBugKeys;
var hasRequired_enumBugKeys;
function require_enumBugKeys() {
  if (hasRequired_enumBugKeys) return _enumBugKeys;
  hasRequired_enumBugKeys = 1;
  _enumBugKeys = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  return _enumBugKeys;
}
var _objectKeys;
var hasRequired_objectKeys;
function require_objectKeys() {
  if (hasRequired_objectKeys) return _objectKeys;
  hasRequired_objectKeys = 1;
  var $keys = require_objectKeysInternal();
  var enumBugKeys = require_enumBugKeys();
  _objectKeys = Object.keys || function keys2(O2) {
    return $keys(O2, enumBugKeys);
  };
  return _objectKeys;
}
var _objectGops = {};
var hasRequired_objectGops;
function require_objectGops() {
  if (hasRequired_objectGops) return _objectGops;
  hasRequired_objectGops = 1;
  _objectGops.f = Object.getOwnPropertySymbols;
  return _objectGops;
}
var _objectPie = {};
var hasRequired_objectPie;
function require_objectPie() {
  if (hasRequired_objectPie) return _objectPie;
  hasRequired_objectPie = 1;
  _objectPie.f = {}.propertyIsEnumerable;
  return _objectPie;
}
var _toObject;
var hasRequired_toObject;
function require_toObject() {
  if (hasRequired_toObject) return _toObject;
  hasRequired_toObject = 1;
  var defined = require_defined();
  _toObject = function(it) {
    return Object(defined(it));
  };
  return _toObject;
}
var _objectAssign;
var hasRequired_objectAssign;
function require_objectAssign() {
  if (hasRequired_objectAssign) return _objectAssign;
  hasRequired_objectAssign = 1;
  var DESCRIPTORS = require_descriptors();
  var getKeys = require_objectKeys();
  var gOPS = require_objectGops();
  var pIE = require_objectPie();
  var toObject2 = require_toObject();
  var IObject = require_iobject();
  var $assign = Object.assign;
  _objectAssign = !$assign || require_fails()(function() {
    var A2 = {};
    var B2 = {};
    var S2 = Symbol();
    var K2 = "abcdefghijklmnopqrst";
    A2[S2] = 7;
    K2.split("").forEach(function(k2) {
      B2[k2] = k2;
    });
    return $assign({}, A2)[S2] != 7 || Object.keys($assign({}, B2)).join("") != K2;
  }) ? function assign2(target, source) {
    var T2 = toObject2(target);
    var aLen = arguments.length;
    var index2 = 1;
    var getSymbols = gOPS.f;
    var isEnum = pIE.f;
    while (aLen > index2) {
      var S2 = IObject(arguments[index2++]);
      var keys2 = getSymbols ? getKeys(S2).concat(getSymbols(S2)) : getKeys(S2);
      var length2 = keys2.length;
      var j2 = 0;
      var key2;
      while (length2 > j2) {
        key2 = keys2[j2++];
        if (!DESCRIPTORS || isEnum.call(S2, key2)) T2[key2] = S2[key2];
      }
    }
    return T2;
  } : $assign;
  return _objectAssign;
}
var hasRequiredEs6_object_assign;
function requireEs6_object_assign() {
  if (hasRequiredEs6_object_assign) return es6_object_assign;
  hasRequiredEs6_object_assign = 1;
  var $export = require_export();
  $export($export.S + $export.F, "Object", { assign: require_objectAssign() });
  return es6_object_assign;
}
var assign$2;
var hasRequiredAssign$1;
function requireAssign$1() {
  if (hasRequiredAssign$1) return assign$2;
  hasRequiredAssign$1 = 1;
  requireEs6_object_assign();
  assign$2 = require_core().Object.assign;
  return assign$2;
}
var assignExports$1 = requireAssign$1();
const _Object$assign$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(assignExports$1);
function _extends$2() {
  return _extends$2 = _Object$assign$1 ? _Object$assign$1.bind() : function(n2) {
    for (var e = 1; e < arguments.length; e++) {
      var t2 = arguments[e];
      for (var r2 in t2) ({}).hasOwnProperty.call(t2, r2) && (n2[r2] = t2[r2]);
    }
    return n2;
  }, _extends$2.apply(null, arguments);
}
var es6_object_create = {};
var _objectDps;
var hasRequired_objectDps;
function require_objectDps() {
  if (hasRequired_objectDps) return _objectDps;
  hasRequired_objectDps = 1;
  var dP = require_objectDp();
  var anObject = require_anObject();
  var getKeys = require_objectKeys();
  _objectDps = require_descriptors() ? Object.defineProperties : function defineProperties(O2, Properties) {
    anObject(O2);
    var keys2 = getKeys(Properties);
    var length2 = keys2.length;
    var i = 0;
    var P2;
    while (length2 > i) dP.f(O2, P2 = keys2[i++], Properties[P2]);
    return O2;
  };
  return _objectDps;
}
var _html;
var hasRequired_html;
function require_html() {
  if (hasRequired_html) return _html;
  hasRequired_html = 1;
  var document2 = require_global().document;
  _html = document2 && document2.documentElement;
  return _html;
}
var _objectCreate;
var hasRequired_objectCreate;
function require_objectCreate() {
  if (hasRequired_objectCreate) return _objectCreate;
  hasRequired_objectCreate = 1;
  var anObject = require_anObject();
  var dPs = require_objectDps();
  var enumBugKeys = require_enumBugKeys();
  var IE_PROTO = require_sharedKey()("IE_PROTO");
  var Empty = function() {
  };
  var PROTOTYPE = "prototype";
  var createDict = function() {
    var iframe = require_domCreate()("iframe");
    var i = enumBugKeys.length;
    var lt = "<";
    var gt = ">";
    var iframeDocument;
    iframe.style.display = "none";
    require_html().appendChild(iframe);
    iframe.src = "javascript:";
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + "script" + gt + "document.F=Object" + lt + "/script" + gt);
    iframeDocument.close();
    createDict = iframeDocument.F;
    while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
    return createDict();
  };
  _objectCreate = Object.create || function create2(O2, Properties) {
    var result;
    if (O2 !== null) {
      Empty[PROTOTYPE] = anObject(O2);
      result = new Empty();
      Empty[PROTOTYPE] = null;
      result[IE_PROTO] = O2;
    } else result = createDict();
    return Properties === void 0 ? result : dPs(result, Properties);
  };
  return _objectCreate;
}
var hasRequiredEs6_object_create;
function requireEs6_object_create() {
  if (hasRequiredEs6_object_create) return es6_object_create;
  hasRequiredEs6_object_create = 1;
  var $export = require_export();
  $export($export.S, "Object", { create: require_objectCreate() });
  return es6_object_create;
}
var create$1;
var hasRequiredCreate;
function requireCreate() {
  if (hasRequiredCreate) return create$1;
  hasRequiredCreate = 1;
  requireEs6_object_create();
  var $Object = require_core().Object;
  create$1 = function create2(P2, D2) {
    return $Object.create(P2, D2);
  };
  return create$1;
}
var createExports = requireCreate();
const _Object$create = /* @__PURE__ */ getDefaultExportFromCjs$1(createExports);
var es6_object_setPrototypeOf = {};
var _objectGopd = {};
var hasRequired_objectGopd;
function require_objectGopd() {
  if (hasRequired_objectGopd) return _objectGopd;
  hasRequired_objectGopd = 1;
  var pIE = require_objectPie();
  var createDesc = require_propertyDesc();
  var toIObject = require_toIobject();
  var toPrimitive2 = require_toPrimitive();
  var has2 = require_has();
  var IE8_DOM_DEFINE = require_ie8DomDefine();
  var gOPD = Object.getOwnPropertyDescriptor;
  _objectGopd.f = require_descriptors() ? gOPD : function getOwnPropertyDescriptor(O2, P2) {
    O2 = toIObject(O2);
    P2 = toPrimitive2(P2, true);
    if (IE8_DOM_DEFINE) try {
      return gOPD(O2, P2);
    } catch (e) {
    }
    if (has2(O2, P2)) return createDesc(!pIE.f.call(O2, P2), O2[P2]);
  };
  return _objectGopd;
}
var _setProto;
var hasRequired_setProto;
function require_setProto() {
  if (hasRequired_setProto) return _setProto;
  hasRequired_setProto = 1;
  var isObject2 = require_isObject();
  var anObject = require_anObject();
  var check = function(O2, proto2) {
    anObject(O2);
    if (!isObject2(proto2) && proto2 !== null) throw TypeError(proto2 + ": can't set as prototype!");
  };
  _setProto = {
    set: Object.setPrototypeOf || ("__proto__" in {} ? (
      // eslint-disable-line
      function(test, buggy, set2) {
        try {
          set2 = require_ctx()(Function.call, require_objectGopd().f(Object.prototype, "__proto__").set, 2);
          set2(test, []);
          buggy = !(test instanceof Array);
        } catch (e) {
          buggy = true;
        }
        return function setPrototypeOf2(O2, proto2) {
          check(O2, proto2);
          if (buggy) O2.__proto__ = proto2;
          else set2(O2, proto2);
          return O2;
        };
      }({}, false)
    ) : void 0),
    check
  };
  return _setProto;
}
var hasRequiredEs6_object_setPrototypeOf;
function requireEs6_object_setPrototypeOf() {
  if (hasRequiredEs6_object_setPrototypeOf) return es6_object_setPrototypeOf;
  hasRequiredEs6_object_setPrototypeOf = 1;
  var $export = require_export();
  $export($export.S, "Object", { setPrototypeOf: require_setProto().set });
  return es6_object_setPrototypeOf;
}
var setPrototypeOf;
var hasRequiredSetPrototypeOf;
function requireSetPrototypeOf() {
  if (hasRequiredSetPrototypeOf) return setPrototypeOf;
  hasRequiredSetPrototypeOf = 1;
  requireEs6_object_setPrototypeOf();
  setPrototypeOf = require_core().Object.setPrototypeOf;
  return setPrototypeOf;
}
var setPrototypeOfExports = requireSetPrototypeOf();
const _Object$setPrototypeOf = /* @__PURE__ */ getDefaultExportFromCjs$1(setPrototypeOfExports);
function _setPrototypeOf(t2, e) {
  return _setPrototypeOf = _Object$setPrototypeOf ? _Object$setPrototypeOf.bind() : function(t3, e2) {
    return t3.__proto__ = e2, t3;
  }, _setPrototypeOf(t2, e);
}
function _inheritsLoose(t2, o2) {
  t2.prototype = _Object$create(o2.prototype), t2.prototype.constructor = t2, _setPrototypeOf(t2, o2);
}
var es7_object_values = {};
var _objectToArray;
var hasRequired_objectToArray;
function require_objectToArray() {
  if (hasRequired_objectToArray) return _objectToArray;
  hasRequired_objectToArray = 1;
  var DESCRIPTORS = require_descriptors();
  var getKeys = require_objectKeys();
  var toIObject = require_toIobject();
  var isEnum = require_objectPie().f;
  _objectToArray = function(isEntries) {
    return function(it) {
      var O2 = toIObject(it);
      var keys2 = getKeys(O2);
      var length2 = keys2.length;
      var i = 0;
      var result = [];
      var key2;
      while (length2 > i) {
        key2 = keys2[i++];
        if (!DESCRIPTORS || isEnum.call(O2, key2)) {
          result.push(isEntries ? [key2, O2[key2]] : O2[key2]);
        }
      }
      return result;
    };
  };
  return _objectToArray;
}
var hasRequiredEs7_object_values;
function requireEs7_object_values() {
  if (hasRequiredEs7_object_values) return es7_object_values;
  hasRequiredEs7_object_values = 1;
  var $export = require_export();
  var $values = require_objectToArray()(false);
  $export($export.S, "Object", {
    values: function values2(it) {
      return $values(it);
    }
  });
  return es7_object_values;
}
var values$2;
var hasRequiredValues$1;
function requireValues$1() {
  if (hasRequiredValues$1) return values$2;
  hasRequiredValues$1 = 1;
  requireEs7_object_values();
  values$2 = require_core().Object.values;
  return values$2;
}
var values$1;
var hasRequiredValues;
function requireValues() {
  if (hasRequiredValues) return values$1;
  hasRequiredValues = 1;
  values$1 = requireValues$1();
  return values$1;
}
var valuesExports = requireValues();
const _Object$values = /* @__PURE__ */ getDefaultExportFromCjs$1(valuesExports);
var es6_object_keys = {};
var _objectSap;
var hasRequired_objectSap;
function require_objectSap() {
  if (hasRequired_objectSap) return _objectSap;
  hasRequired_objectSap = 1;
  var $export = require_export();
  var core = require_core();
  var fails = require_fails();
  _objectSap = function(KEY, exec) {
    var fn2 = (core.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn2);
    $export($export.S + $export.F * fails(function() {
      fn2(1);
    }), "Object", exp);
  };
  return _objectSap;
}
var hasRequiredEs6_object_keys;
function requireEs6_object_keys() {
  if (hasRequiredEs6_object_keys) return es6_object_keys;
  hasRequiredEs6_object_keys = 1;
  var toObject2 = require_toObject();
  var $keys = require_objectKeys();
  require_objectSap()("keys", function() {
    return function keys2(it) {
      return $keys(toObject2(it));
    };
  });
  return es6_object_keys;
}
var keys$4;
var hasRequiredKeys$1;
function requireKeys$1() {
  if (hasRequiredKeys$1) return keys$4;
  hasRequiredKeys$1 = 1;
  requireEs6_object_keys();
  keys$4 = require_core().Object.keys;
  return keys$4;
}
var keys$3;
var hasRequiredKeys;
function requireKeys() {
  if (hasRequiredKeys) return keys$3;
  hasRequiredKeys = 1;
  keys$3 = requireKeys$1();
  return keys$3;
}
var keysExports = requireKeys();
const _Object$keys = /* @__PURE__ */ getDefaultExportFromCjs$1(keysExports);
var es6_date_now = {};
var hasRequiredEs6_date_now;
function requireEs6_date_now() {
  if (hasRequiredEs6_date_now) return es6_date_now;
  hasRequiredEs6_date_now = 1;
  var $export = require_export();
  $export($export.S, "Date", { now: function() {
    return (/* @__PURE__ */ new Date()).getTime();
  } });
  return es6_date_now;
}
var now$2;
var hasRequiredNow$1;
function requireNow$1() {
  if (hasRequiredNow$1) return now$2;
  hasRequiredNow$1 = 1;
  requireEs6_date_now();
  now$2 = require_core().Date.now;
  return now$2;
}
var now$1;
var hasRequiredNow;
function requireNow() {
  if (hasRequiredNow) return now$1;
  hasRequiredNow = 1;
  now$1 = requireNow$1();
  return now$1;
}
var nowExports = requireNow();
const _Date$now = /* @__PURE__ */ getDefaultExportFromCjs$1(nowExports);
var assign$1;
var hasRequiredAssign;
function requireAssign() {
  if (hasRequiredAssign) return assign$1;
  hasRequiredAssign = 1;
  assign$1 = requireAssign$1();
  return assign$1;
}
var assignExports = requireAssign();
const _Object$assign = /* @__PURE__ */ getDefaultExportFromCjs$1(assignExports);
var es6_number_isInteger = {};
var _isInteger;
var hasRequired_isInteger;
function require_isInteger() {
  if (hasRequired_isInteger) return _isInteger;
  hasRequired_isInteger = 1;
  var isObject2 = require_isObject();
  var floor2 = Math.floor;
  _isInteger = function isInteger2(it) {
    return !isObject2(it) && isFinite(it) && floor2(it) === it;
  };
  return _isInteger;
}
var hasRequiredEs6_number_isInteger;
function requireEs6_number_isInteger() {
  if (hasRequiredEs6_number_isInteger) return es6_number_isInteger;
  hasRequiredEs6_number_isInteger = 1;
  var $export = require_export();
  $export($export.S, "Number", { isInteger: require_isInteger() });
  return es6_number_isInteger;
}
var isInteger$1;
var hasRequiredIsInteger$1;
function requireIsInteger$1() {
  if (hasRequiredIsInteger$1) return isInteger$1;
  hasRequiredIsInteger$1 = 1;
  requireEs6_number_isInteger();
  isInteger$1 = require_core().Number.isInteger;
  return isInteger$1;
}
var isInteger;
var hasRequiredIsInteger;
function requireIsInteger() {
  if (hasRequiredIsInteger) return isInteger;
  hasRequiredIsInteger = 1;
  isInteger = requireIsInteger$1();
  return isInteger;
}
var isIntegerExports = requireIsInteger();
const _Number$isInteger = /* @__PURE__ */ getDefaultExportFromCjs$1(isIntegerExports);
var isProduction = process.env.NODE_ENV === "production";
var spacesAndTabs = /[ \t]{2,}/g;
var lineStartWithSpaces = /^[ \t]*/gm;
var clean3 = function clean4(value) {
  return value.replace(spacesAndTabs, " ").replace(lineStartWithSpaces, "").trim();
};
var getDevMessage2 = function getDevMessage3(message2) {
  return clean3("\n  %creact-beautiful-dnd\n\n  %c" + clean3(message2) + "\n\n  %c👷‍ This is a development only message. It will be removed in production builds.\n");
};
var getFormattedMessage2 = function getFormattedMessage3(message2) {
  return [getDevMessage2(message2), "color: #00C584; font-size: 1.2em; font-weight: bold;", "line-height: 1.5", "color: #723874;"];
};
var isDisabledFlag = "__react-beautiful-dnd-disable-dev-warnings";
var warning$1 = function warning(message2) {
  var _console;
  if (isProduction) {
    return;
  }
  if (typeof window !== "undefined" && window[isDisabledFlag]) {
    return;
  }
  (_console = console).warn.apply(_console, getFormattedMessage2(message2));
};
function printFatalError(error2) {
  var _console;
  if (process.env.NODE_ENV === "production") {
    return;
  }
  (_console = console).error.apply(_console, getFormattedMessage2("\n        An error has occurred while a drag is occurring.\n        Any existing drag will be cancelled.\n\n        > " + error2.message + "\n        "));
  console.error("raw", error2);
}
function shouldRecover(error2) {
  return error2.message.indexOf("Invariant failed") !== -1;
}
var ErrorBoundary = function(_React$Component) {
  _inheritsLoose(ErrorBoundary2, _React$Component);
  function ErrorBoundary2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.onError = void 0;
    _this.setOnError = function(fn2) {
      _this.onError = fn2;
    };
    _this.onFatalError = function(error2) {
      printFatalError(error2);
      if (_this.onError) {
        _this.onError();
      } else {
        process.env.NODE_ENV !== "production" ? warning$1("Could not find recovering function") : void 0;
      }
      if (shouldRecover(error2)) {
        _this.setState({});
      }
    };
    return _this;
  }
  var _proto = ErrorBoundary2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener("error", this.onFatalError);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener("error", this.onFatalError);
  };
  _proto.componentDidCatch = function componentDidCatch(error2) {
    this.onFatalError(error2);
    if (!shouldRecover(error2)) {
      throw error2;
    }
  };
  _proto.render = function render() {
    return this.props.children(this.setOnError);
  };
  return ErrorBoundary2;
}(React__default.Component);
var origin = {
  x: 0,
  y: 0
};
var add$3 = function add2(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};
var subtract$3 = function subtract2(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};
var isEqual$1 = function isEqual3(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};
var negate2 = function negate3(point2) {
  return {
    x: point2.x !== 0 ? -point2.x : 0,
    y: point2.y !== 0 ? -point2.y : 0
  };
};
var patch$1 = function patch2(line2, value, otherValue) {
  var _ref;
  if (otherValue === void 0) {
    otherValue = 0;
  }
  return _ref = {}, _ref[line2] = value, _ref[line2 === "x" ? "y" : "x"] = otherValue, _ref;
};
var distance2 = function distance3(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var closest2 = function closest3(target, points) {
  return Math.min.apply(Math, points.map(function(point2) {
    return distance2(target, point2);
  }));
};
var apply$2 = function apply2(fn2) {
  return function(point2) {
    return {
      x: fn2(point2.x),
      y: fn2(point2.y)
    };
  };
};
var executeClip = function(frame, subject) {
  var result = getRect({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left)
  });
  if (result.width <= 0 || result.height <= 0) {
    return null;
  }
  return result;
};
var isEqual$1$1 = function isEqual4(first2, second) {
  return first2.top === second.top && first2.right === second.right && first2.bottom === second.bottom && first2.left === second.left;
};
var offsetByPosition2 = function offsetByPosition3(spacing, point2) {
  return {
    top: spacing.top + point2.y,
    left: spacing.left + point2.x,
    bottom: spacing.bottom + point2.y,
    right: spacing.right + point2.x
  };
};
var getCorners2 = function getCorners3(spacing) {
  return [{
    x: spacing.left,
    y: spacing.top
  }, {
    x: spacing.right,
    y: spacing.top
  }, {
    x: spacing.left,
    y: spacing.bottom
  }, {
    x: spacing.right,
    y: spacing.bottom
  }];
};
var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var scroll2 = function scroll3(target, frame) {
  if (!frame) {
    return target;
  }
  return offsetByPosition2(target, frame.scroll.diff.displacement);
};
var increase2 = function increase3(target, axis, withPlaceholder) {
  if (withPlaceholder && withPlaceholder.increasedBy) {
    var _extends2;
    return _extends$2({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
  }
  return target;
};
var clip2 = function clip3(target, frame) {
  if (frame && frame.shouldClipSubject) {
    return executeClip(frame.pageMarginBox, target);
  }
  return getRect(target);
};
var getSubject = function(_ref) {
  var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
  var scrolled = scroll2(page.marginBox, frame);
  var increased = increase2(scrolled, axis, withPlaceholder);
  var clipped = clip2(increased, frame);
  return {
    page,
    withPlaceholder,
    active: clipped
  };
};
var scrollDroppable = function(droppable2, newScroll) {
  !droppable2.frame ? process.env.NODE_ENV !== "production" ? invariant$2() : invariant$2() : void 0;
  var scrollable = droppable2.frame;
  var scrollDiff = subtract$3(newScroll, scrollable.scroll.initial);
  var scrollDisplacement = negate2(scrollDiff);
  var frame = _extends$2({}, scrollable, {
    scroll: {
      initial: scrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement
      },
      max: scrollable.scroll.max
    }
  });
  var subject = getSubject({
    page: droppable2.subject.page,
    withPlaceholder: droppable2.subject.withPlaceholder,
    axis: droppable2.axis,
    frame
  });
  var result = _extends$2({}, droppable2, {
    frame,
    subject
  });
  return result;
};
var start2 = function start3(key2) {
  if (process.env.NODE_ENV !== "production") {
    {
      return;
    }
  }
};
var finish2 = function finish3(key2) {
  if (process.env.NODE_ENV !== "production") {
    {
      return;
    }
  }
};
var whatIsDraggedOver = function(impact) {
  var merge3 = impact.merge, destination = impact.destination;
  if (destination) {
    return destination.droppableId;
  }
  if (merge3) {
    return merge3.combine.droppableId;
  }
  return null;
};
function values(map3) {
  return _Object$values(map3);
}
function findIndex(list2, predicate) {
  if (list2.findIndex) {
    return list2.findIndex(predicate);
  }
  for (var i = 0; i < list2.length; i++) {
    if (predicate(list2[i])) {
      return i;
    }
  }
  return -1;
}
function find$2(list2, predicate) {
  if (list2.find) {
    return list2.find(predicate);
  }
  var index2 = findIndex(list2, predicate);
  if (index2 !== -1) {
    return list2[index2];
  }
  return void 0;
}
var toDroppableMap = memoizeOne(function(droppables) {
  return droppables.reduce(function(previous2, current) {
    previous2[current.descriptor.id] = current;
    return previous2;
  }, {});
});
var toDraggableMap = memoizeOne(function(draggables) {
  return draggables.reduce(function(previous2, current) {
    previous2[current.descriptor.id] = current;
    return previous2;
  }, {});
});
var toDroppableList = memoizeOne(function(droppables) {
  return values(droppables);
});
var toDraggableList = memoizeOne(function(draggables) {
  return values(draggables);
});
var isWithin = function(lowerBound, upperBound) {
  return function(value) {
    return lowerBound <= value && value <= upperBound;
  };
};
var isPositionInFrame = function(frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function(point2) {
    return isWithinVertical(point2.y) && isWithinVertical(point2.y) && isWithinHorizontal(point2.x) && isWithinHorizontal(point2.x);
  };
};
var getDroppableOver2 = function(_ref) {
  var target = _ref.target, droppables = _ref.droppables;
  var maybe = find$2(toDroppableList(droppables), function(droppable2) {
    if (!droppable2.isEnabled) {
      return false;
    }
    var active = droppable2.subject.active;
    if (!active) {
      return false;
    }
    return isPositionInFrame(active)(target);
  });
  return maybe ? maybe.descriptor.id : null;
};
var getDraggablesInsideDroppable = memoizeOne(function(droppableId, draggables) {
  var result = toDraggableList(draggables).filter(function(draggable2) {
    return droppableId === draggable2.descriptor.droppableId;
  }).sort(function(a2, b2) {
    return a2.descriptor.index - b2.descriptor.index;
  });
  return result;
});
var withDroppableScroll = function(droppable2, point2) {
  var frame = droppable2.frame;
  if (!frame) {
    return point2;
  }
  return add$3(point2, frame.scroll.diff.value);
};
var vertical = {
  direction: "vertical",
  line: "y",
  crossAxisLine: "x",
  start: "top",
  end: "bottom",
  size: "height",
  crossAxisStart: "left",
  crossAxisEnd: "right",
  crossAxisSize: "width"
};
var horizontal = {
  direction: "horizontal",
  line: "x",
  crossAxisLine: "y",
  start: "left",
  end: "right",
  size: "width",
  crossAxisStart: "top",
  crossAxisEnd: "bottom",
  crossAxisSize: "height"
};
var isUserMovingForward = function(axis, direction) {
  return axis === vertical ? direction.vertical === "down" : direction.horizontal === "right";
};
var didStartDisplaced = function(draggableId, onLift) {
  return Boolean(onLift.wasDisplaced[draggableId]);
};
var getCombinedItemDisplacement = function(_ref) {
  var displaced = _ref.displaced, onLift = _ref.onLift, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
  var isDisplaced = Boolean(displaced[combineWith]);
  if (didStartDisplaced(combineWith, onLift)) {
    return isDisplaced ? origin : negate2(displacedBy.point);
  }
  return isDisplaced ? displacedBy.point : origin;
};
var getWhenEntered = function getWhenEntered2(id, current, oldMerge) {
  if (!oldMerge) {
    return current;
  }
  if (id !== oldMerge.combine.draggableId) {
    return current;
  }
  return oldMerge.whenEntered;
};
var isCombiningWith = function isCombiningWith2(_ref) {
  var id = _ref.id, currentCenter = _ref.currentCenter, axis = _ref.axis, borderBox = _ref.borderBox, displaceBy = _ref.displaceBy, currentUserDirection = _ref.currentUserDirection, oldMerge = _ref.oldMerge;
  var start4 = borderBox[axis.start] + displaceBy[axis.line];
  var end2 = borderBox[axis.end] + displaceBy[axis.line];
  var size2 = borderBox[axis.size];
  var twoThirdsOfSize = size2 * 0.666;
  var whenEntered = getWhenEntered(id, currentUserDirection, oldMerge);
  var isMovingForward = isUserMovingForward(axis, whenEntered);
  var targetCenter = currentCenter[axis.line];
  if (isMovingForward) {
    return isWithin(start4, start4 + twoThirdsOfSize)(targetCenter);
  }
  return isWithin(end2 - twoThirdsOfSize, end2)(targetCenter);
};
var getCombineImpact = function(_ref2) {
  var currentCenter = _ref2.pageBorderBoxCenterWithDroppableScrollChange, previousImpact = _ref2.previousImpact, destination = _ref2.destination, insideDestinationWithoutDraggable = _ref2.insideDestinationWithoutDraggable, userDirection = _ref2.userDirection, onLift = _ref2.onLift;
  if (!destination.isCombineEnabled) {
    return null;
  }
  var axis = destination.axis;
  var map3 = previousImpact.movement.map;
  var canBeDisplacedBy = previousImpact.movement.displacedBy;
  var oldMerge = previousImpact.merge;
  var target = find$2(insideDestinationWithoutDraggable, function(child) {
    var id = child.descriptor.id;
    var displaceBy = getCombinedItemDisplacement({
      displaced: map3,
      onLift,
      combineWith: id,
      displacedBy: canBeDisplacedBy
    });
    return isCombiningWith({
      id,
      currentCenter,
      axis,
      borderBox: child.page.borderBox,
      displaceBy,
      currentUserDirection: userDirection,
      oldMerge
    });
  });
  if (!target) {
    return null;
  }
  var merge3 = {
    whenEntered: getWhenEntered(target.descriptor.id, userDirection, oldMerge),
    combine: {
      draggableId: target.descriptor.id,
      droppableId: destination.descriptor.id
    }
  };
  var withMerge = _extends$2({}, previousImpact, {
    destination: null,
    merge: merge3
  });
  return withMerge;
};
var isPartiallyVisibleThroughFrame = function(frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function(subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    if (isContained) {
      return true;
    }
    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
    if (isPartiallyContained) {
      return true;
    }
    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
    if (isTargetBiggerThanFrame) {
      return true;
    }
    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
    return isTargetBiggerOnOneAxis;
  };
};
var isTotallyVisibleThroughFrame = function(frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function(subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    return isContained;
  };
};
var isTotallyVisibleThroughFrameOnAxis = function(axis) {
  return function(frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function(subject) {
      if (axis === vertical) {
        return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
      }
      return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    };
  };
};
var getDroppableDisplaced2 = function getDroppableDisplaced3(target, destination) {
  var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
  return offsetByPosition2(target, displacement);
};
var isVisibleInDroppable2 = function isVisibleInDroppable3(target, destination, isVisibleThroughFrameFn) {
  if (!destination.subject.active) {
    return false;
  }
  return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var isVisibleInViewport2 = function isVisibleInViewport3(target, viewport, isVisibleThroughFrameFn) {
  return isVisibleThroughFrameFn(viewport)(target);
};
var isVisible2 = function isVisible3(_ref) {
  var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement2 = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
  var displacedTarget = withDroppableDisplacement2 ? getDroppableDisplaced2(toBeDisplaced, destination) : toBeDisplaced;
  return isVisibleInDroppable2(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport2(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var isPartiallyVisible2 = function isPartiallyVisible3(args) {
  return isVisible2(_extends$2({}, args, {
    isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
  }));
};
var isTotallyVisible2 = function isTotallyVisible3(args) {
  return isVisible2(_extends$2({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
  }));
};
var isTotallyVisibleOnAxis2 = function isTotallyVisibleOnAxis3(args) {
  return isVisible2(_extends$2({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
  }));
};
var getShouldAnimate2 = function getShouldAnimate3(forceShouldAnimate, isVisible4, previous2) {
  if (typeof forceShouldAnimate === "boolean") {
    return forceShouldAnimate;
  }
  if (!isVisible4) {
    return false;
  }
  if (!previous2) {
    return true;
  }
  return previous2.shouldAnimate;
};
var getTarget = function getTarget2(draggable2, onLift) {
  var marginBox = draggable2.page.marginBox;
  if (!didStartDisplaced(draggable2.descriptor.id, onLift)) {
    return marginBox;
  }
  var expandBy = {
    top: onLift.displacedBy.point.y,
    right: 0,
    bottom: 0,
    left: onLift.displacedBy.point.x
  };
  return getRect(expand(marginBox, expandBy));
};
var getDisplacement = function(_ref) {
  var draggable2 = _ref.draggable, destination = _ref.destination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, onLift = _ref.onLift, forceShouldAnimate = _ref.forceShouldAnimate;
  var id = draggable2.descriptor.id;
  var map3 = previousImpact.movement.map;
  var target = getTarget(draggable2, onLift);
  var isVisible4 = isPartiallyVisible2({
    target,
    destination,
    viewport,
    withDroppableDisplacement: true
  });
  var shouldAnimate = getShouldAnimate2(forceShouldAnimate, isVisible4, map3[id]);
  var displacement = {
    draggableId: id,
    isVisible: isVisible4,
    shouldAnimate
  };
  return displacement;
};
var getDisplacementMap = memoizeOne(function(displaced) {
  return displaced.reduce(function(map3, displacement) {
    map3[displacement.draggableId] = displacement;
    return map3;
  }, {});
});
var getDisplacedBy2 = memoizeOne(function(axis, displaceBy) {
  var displacement = displaceBy[axis.line];
  return {
    value: displacement,
    point: patch$1(axis.line, displacement)
  };
});
var getReorderImpact = function(_ref) {
  var currentCenter = _ref.pageBorderBoxCenterWithDroppableScrollChange, draggable2 = _ref.draggable, destination = _ref.destination, insideDestinationWithoutDraggable = _ref.insideDestinationWithoutDraggable, previousImpact = _ref.previousImpact, viewport = _ref.viewport, userDirection = _ref.userDirection, onLift = _ref.onLift;
  var axis = destination.axis;
  var isMovingForward = isUserMovingForward(destination.axis, userDirection);
  var displacedBy = getDisplacedBy2(destination.axis, draggable2.displaceBy);
  var targetCenter = currentCenter[axis.line];
  var displacement = displacedBy.value;
  var displaced = insideDestinationWithoutDraggable.filter(function(child) {
    var borderBox = child.page.borderBox;
    var start4 = borderBox[axis.start];
    var end2 = borderBox[axis.end];
    var didStartDisplaced$1 = didStartDisplaced(child.descriptor.id, onLift);
    if (isMovingForward) {
      if (didStartDisplaced$1) {
        return targetCenter < start4;
      }
      return targetCenter < start4 + displacement;
    }
    if (didStartDisplaced$1) {
      return targetCenter <= end2 - displacement;
    }
    return targetCenter <= end2;
  }).map(function(dimension) {
    return getDisplacement({
      draggable: dimension,
      destination,
      previousImpact,
      viewport: viewport.frame,
      onLift
    });
  });
  var newIndex = insideDestinationWithoutDraggable.length - displaced.length;
  var movement = {
    displacedBy,
    displaced,
    map: getDisplacementMap(displaced)
  };
  var impact = {
    movement,
    destination: {
      droppableId: destination.descriptor.id,
      index: newIndex
    },
    merge: null
  };
  return impact;
};
var noDisplacedBy = {
  point: origin,
  value: 0
};
var noMovement = {
  displaced: [],
  map: {},
  displacedBy: noDisplacedBy
};
var noImpact = {
  movement: noMovement,
  destination: null,
  merge: null
};
var removeDraggableFromList = memoizeOne(function(remove, list2) {
  return list2.filter(function(item) {
    return item.descriptor.id !== remove.descriptor.id;
  });
});
var getDragImpact = function(_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable2 = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, userDirection = _ref.userDirection, onLift = _ref.onLift;
  var destinationId = getDroppableOver2({
    target: pageBorderBoxCenter,
    droppables
  });
  if (!destinationId) {
    return noImpact;
  }
  var destination = droppables[destinationId];
  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var insideDestinationWithoutDraggable = removeDraggableFromList(draggable2, insideDestination);
  var pageBorderBoxCenterWithDroppableScrollChange = withDroppableScroll(destination, pageBorderBoxCenter);
  var withMerge = getCombineImpact({
    pageBorderBoxCenterWithDroppableScrollChange,
    previousImpact,
    destination,
    insideDestinationWithoutDraggable,
    userDirection,
    onLift
  });
  if (withMerge) {
    return withMerge;
  }
  return getReorderImpact({
    pageBorderBoxCenterWithDroppableScrollChange,
    destination,
    draggable: draggable2,
    insideDestinationWithoutDraggable,
    previousImpact,
    viewport,
    userDirection,
    onLift
  });
};
var getHomeLocation = function(descriptor) {
  return {
    index: descriptor.index,
    droppableId: descriptor.droppableId
  };
};
var getHomeOnLift = function(_ref) {
  var draggable2 = _ref.draggable, home2 = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
  var displacedBy = getDisplacedBy2(home2.axis, draggable2.displaceBy);
  var insideHome = getDraggablesInsideDroppable(home2.descriptor.id, draggables);
  var originallyDisplaced = insideHome.slice(draggable2.descriptor.index + 1);
  var wasDisplaced = originallyDisplaced.reduce(function(previous2, item) {
    previous2[item.descriptor.id] = true;
    return previous2;
  }, {});
  var onLift = {
    displacedBy,
    wasDisplaced
  };
  var displaced = originallyDisplaced.map(function(dimension) {
    return getDisplacement({
      draggable: dimension,
      destination: home2,
      previousImpact: noImpact,
      viewport: viewport.frame,
      forceShouldAnimate: false,
      onLift
    });
  });
  var movement = {
    displaced,
    map: getDisplacementMap(displaced),
    displacedBy
  };
  var impact = {
    movement,
    destination: getHomeLocation(draggable2.descriptor),
    merge: null
  };
  return {
    impact,
    onLift
  };
};
var getDragPositions = function(_ref) {
  var oldInitial = _ref.initial, oldCurrent = _ref.current, oldClientBorderBoxCenter = _ref.oldClientBorderBoxCenter, newClientBorderBoxCenter = _ref.newClientBorderBoxCenter, viewport = _ref.viewport;
  var shift3 = subtract$3(newClientBorderBoxCenter, oldClientBorderBoxCenter);
  var initial = function() {
    var client2 = {
      selection: add$3(oldInitial.client.selection, shift3),
      borderBoxCenter: newClientBorderBoxCenter,
      offset: origin
    };
    var page = {
      selection: add$3(client2.selection, viewport.scroll.initial),
      borderBoxCenter: add$3(client2.selection, viewport.scroll.initial)
    };
    return {
      client: client2,
      page
    };
  }();
  var current = function() {
    var reverse = negate2(shift3);
    var offset3 = add$3(oldCurrent.client.offset, reverse);
    var client2 = {
      selection: add$3(initial.client.selection, offset3),
      borderBoxCenter: add$3(initial.client.borderBoxCenter, offset3),
      offset: offset3
    };
    var page = {
      selection: add$3(client2.selection, viewport.scroll.current),
      borderBoxCenter: add$3(client2.borderBoxCenter, viewport.scroll.current)
    };
    !isEqual$1(oldCurrent.client.borderBoxCenter, client2.borderBoxCenter) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "\n        Incorrect new client center position.\n        Expected (" + oldCurrent.client.borderBoxCenter.x + ", " + oldCurrent.client.borderBoxCenter.y + ")\n        to equal (" + client2.borderBoxCenter.x + ", " + client2.borderBoxCenter.y + ")\n      ") : invariant$2() : void 0;
    return {
      client: client2,
      page
    };
  }();
  return {
    current,
    initial
  };
};
var offsetDraggable = function(_ref) {
  var draggable2 = _ref.draggable, offset$12 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
  var client2 = offset$4(draggable2.client, offset$12);
  var page = withScroll(client2, initialWindowScroll);
  var moved = _extends$2({}, draggable2, {
    placeholder: _extends$2({}, draggable2.placeholder, {
      client: client2
    }),
    client: client2,
    page
  });
  return moved;
};
var adjustExistingForAdditionsAndRemovals = function(_ref) {
  var existing = _ref.existing, droppables = _ref.droppables, addedDraggables = _ref.additions, removedDraggables = _ref.removals, viewport = _ref.viewport;
  var shifted = {};
  toDroppableList(droppables).forEach(function(droppable2) {
    var axis = droppable2.axis;
    var original = getDraggablesInsideDroppable(droppable2.descriptor.id, existing);
    var toShift = {};
    var addShift = function addShift2(id, shift3) {
      var previous2 = toShift[id];
      if (!previous2) {
        toShift[id] = shift3;
        return;
      }
      toShift[id] = {
        indexChange: previous2.indexChange + shift3.indexChange,
        offset: add$3(previous2.offset, shift3.offset)
      };
    };
    var removals = toDraggableMap(removedDraggables.map(function(id) {
      var item = existing[id];
      !item ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Could not find removed draggable "' + id + '"') : invariant$2() : void 0;
      return item;
    }).filter(function(draggable2) {
      return draggable2.descriptor.droppableId === droppable2.descriptor.id;
    }));
    var withRemovals = original.filter(function(item, index2) {
      var isBeingRemoved = Boolean(removals[item.descriptor.id]);
      if (!isBeingRemoved) {
        return true;
      }
      var offset3 = negate2(patch$1(axis.line, item.displaceBy[axis.line]));
      original.slice(index2).forEach(function(sibling) {
        if (removals[sibling.descriptor.id]) {
          return;
        }
        addShift(sibling.descriptor.id, {
          indexChange: -1,
          offset: offset3
        });
      });
      return false;
    });
    var additions = addedDraggables.filter(function(draggable2) {
      return draggable2.descriptor.droppableId === droppable2.descriptor.id;
    });
    var withAdditions = withRemovals.slice(0);
    additions.forEach(function(item) {
      withAdditions.splice(item.descriptor.index, 0, item);
    });
    var additionMap = toDraggableMap(additions);
    withAdditions.forEach(function(item, index2) {
      var wasAdded = Boolean(additionMap[item.descriptor.id]);
      if (!wasAdded) {
        return;
      }
      var offset3 = patch$1(axis.line, item.client.marginBox[axis.size]);
      withAdditions.slice(index2).forEach(function(sibling) {
        if (additionMap[sibling.descriptor.id]) {
          return;
        }
        addShift(sibling.descriptor.id, {
          indexChange: 1,
          offset: offset3
        });
      });
    });
    withAdditions.forEach(function(item) {
      if (additionMap[item.descriptor.id]) {
        return;
      }
      var shift3 = toShift[item.descriptor.id];
      if (!shift3) {
        return;
      }
      var moved = offsetDraggable({
        draggable: item,
        offset: shift3.offset,
        initialWindowScroll: viewport.scroll.initial
      });
      var index2 = item.descriptor.index + shift3.indexChange;
      var updated = _extends$2({}, moved, {
        descriptor: _extends$2({}, item.descriptor, {
          index: index2
        })
      });
      shifted[moved.descriptor.id] = updated;
    });
  });
  var map3 = _extends$2({}, existing, shifted);
  return map3;
};
var adjustAdditionsForScrollChanges = function(_ref) {
  var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
  var windowScrollChange = viewport.scroll.diff.value;
  return additions.map(function(draggable2) {
    var droppableId = draggable2.descriptor.droppableId;
    var modified = updatedDroppables[droppableId];
    var frame = modified.frame;
    !frame ? process.env.NODE_ENV !== "production" ? invariant$2() : invariant$2() : void 0;
    var droppableScrollChange = frame.scroll.diff.value;
    var totalChange = add$3(windowScrollChange, droppableScrollChange);
    var moved = offsetDraggable({
      draggable: draggable2,
      offset: totalChange,
      initialWindowScroll: viewport.scroll.initial
    });
    return moved;
  });
};
var adjustAdditionsForCollapsedHome = function(_ref) {
  var additions = _ref.additions, dragging = _ref.dragging, home2 = _ref.home, viewport = _ref.viewport;
  var displacedBy = getDisplacedBy2(home2.axis, dragging.displaceBy);
  return additions.map(function(draggable2) {
    if (draggable2.descriptor.droppableId !== home2.descriptor.id) {
      return draggable2;
    }
    if (draggable2.descriptor.index < dragging.descriptor.index) {
      return draggable2;
    }
    return offsetDraggable({
      draggable: draggable2,
      offset: displacedBy.point,
      initialWindowScroll: viewport.scroll.initial
    });
  });
};
var updateDraggables = function(_ref) {
  var updatedDroppables = _ref.updatedDroppables, criticalId = _ref.criticalId, unmodifiedExisting = _ref.existing, unmodifiedAdditions = _ref.additions, removals = _ref.removals, viewport = _ref.viewport;
  var existing = adjustExistingForAdditionsAndRemovals({
    droppables: updatedDroppables,
    existing: unmodifiedExisting,
    additions: unmodifiedAdditions,
    removals,
    viewport
  });
  var dragging = existing[criticalId];
  var home2 = updatedDroppables[dragging.descriptor.droppableId];
  var scrolledAdditions = adjustAdditionsForScrollChanges({
    additions: unmodifiedAdditions,
    updatedDroppables,
    viewport
  });
  var additions = adjustAdditionsForCollapsedHome({
    additions: scrolledAdditions,
    dragging,
    home: home2,
    viewport
  });
  var map3 = _extends$2({}, existing, toDraggableMap(additions));
  removals.forEach(function(id) {
    delete map3[id];
  });
  return map3;
};
var getMaxScroll = function(_ref) {
  var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height2 = _ref.height, width2 = _ref.width;
  var maxScroll = subtract$3({
    x: scrollWidth,
    y: scrollHeight
  }, {
    x: width2,
    y: height2
  });
  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };
  return adjustedMaxScroll;
};
var getDroppableDimension = function(_ref) {
  var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client2 = _ref.client, page = _ref.page, closest4 = _ref.closest;
  var frame = function() {
    if (!closest4) {
      return null;
    }
    var scrollSize = closest4.scrollSize, frameClient = closest4.client;
    var maxScroll = getMaxScroll({
      scrollHeight: scrollSize.scrollHeight,
      scrollWidth: scrollSize.scrollWidth,
      height: frameClient.paddingBox.height,
      width: frameClient.paddingBox.width
    });
    return {
      pageMarginBox: closest4.page.marginBox,
      frameClient,
      scrollSize,
      shouldClipSubject: closest4.shouldClipSubject,
      scroll: {
        initial: closest4.scroll,
        current: closest4.scroll,
        max: maxScroll,
        diff: {
          value: origin,
          displacement: origin
        }
      }
    };
  }();
  var axis = direction === "vertical" ? vertical : horizontal;
  var subject = getSubject({
    page,
    withPlaceholder: null,
    axis,
    frame
  });
  var dimension = {
    descriptor,
    isCombineEnabled,
    isFixedOnPage,
    axis,
    isEnabled,
    client: client2,
    page,
    frame,
    subject
  };
  return dimension;
};
var isHomeOf = function(draggable2, destination) {
  return draggable2.descriptor.droppableId === destination.descriptor.id;
};
var getRequiredGrowthForPlaceholder2 = function getRequiredGrowthForPlaceholder3(droppable2, placeholderSize, draggables) {
  var axis = droppable2.axis;
  var availableSpace = droppable2.subject.page.contentBox[axis.size];
  var insideDroppable = getDraggablesInsideDroppable(droppable2.descriptor.id, draggables);
  var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
    return sum + dimension.client.marginBox[axis.size];
  }, 0);
  var requiredSpace = spaceUsed + placeholderSize[axis.line];
  var needsToGrowBy = requiredSpace - availableSpace;
  if (needsToGrowBy <= 0) {
    return null;
  }
  return patch$1(axis.line, needsToGrowBy);
};
var withMaxScroll2 = function withMaxScroll3(frame, max2) {
  return _extends$2({}, frame, {
    scroll: _extends$2({}, frame.scroll, {
      max: max2
    })
  });
};
var addPlaceholder2 = function addPlaceholder3(droppable2, draggable2, draggables) {
  var frame = droppable2.frame;
  !!isHomeOf(draggable2, droppable2) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Should not add placeholder space to home list") : invariant$2() : void 0;
  !!droppable2.subject.withPlaceholder ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot add placeholder size to a subject when it already has one") : invariant$2() : void 0;
  var placeholderSize = getDisplacedBy2(droppable2.axis, draggable2.displaceBy).point;
  var requiredGrowth = getRequiredGrowthForPlaceholder2(droppable2, placeholderSize, draggables);
  var added = {
    placeholderSize,
    increasedBy: requiredGrowth,
    oldFrameMaxScroll: droppable2.frame ? droppable2.frame.scroll.max : null
  };
  if (!frame) {
    var _subject = getSubject({
      page: droppable2.subject.page,
      withPlaceholder: added,
      axis: droppable2.axis,
      frame: droppable2.frame
    });
    return _extends$2({}, droppable2, {
      subject: _subject
    });
  }
  var maxScroll = requiredGrowth ? add$3(frame.scroll.max, requiredGrowth) : frame.scroll.max;
  var newFrame = withMaxScroll2(frame, maxScroll);
  var subject = getSubject({
    page: droppable2.subject.page,
    withPlaceholder: added,
    axis: droppable2.axis,
    frame: newFrame
  });
  return _extends$2({}, droppable2, {
    subject,
    frame: newFrame
  });
};
var removePlaceholder2 = function removePlaceholder3(droppable2) {
  var added = droppable2.subject.withPlaceholder;
  !added ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot remove placeholder form subject when there was none") : invariant$2() : void 0;
  var frame = droppable2.frame;
  if (!frame) {
    var _subject2 = getSubject({
      page: droppable2.subject.page,
      axis: droppable2.axis,
      frame: null,
      withPlaceholder: null
    });
    return _extends$2({}, droppable2, {
      subject: _subject2
    });
  }
  var oldMaxScroll = added.oldFrameMaxScroll;
  !oldMaxScroll ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Expected droppable with frame to have old max frame scroll when removing placeholder") : invariant$2() : void 0;
  var newFrame = withMaxScroll2(frame, oldMaxScroll);
  var subject = getSubject({
    page: droppable2.subject.page,
    axis: droppable2.axis,
    frame: newFrame,
    withPlaceholder: null
  });
  return _extends$2({}, droppable2, {
    subject,
    frame: newFrame
  });
};
var getFrame = function(droppable2) {
  var frame = droppable2.frame;
  !frame ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Expected Droppable to have a frame") : invariant$2() : void 0;
  return frame;
};
var throwIfSpacingChange = function throwIfSpacingChange2(old, fresh) {
  if (process.env.NODE_ENV !== "production") {
    var getMessage = function getMessage2(spacingType) {
      return "Cannot change the " + spacingType + " of a Droppable during a drag";
    };
    !isEqual$1$1(old.margin, fresh.margin) ? process.env.NODE_ENV !== "production" ? invariant$2(false, getMessage("margin")) : invariant$2() : void 0;
    !isEqual$1$1(old.border, fresh.border) ? process.env.NODE_ENV !== "production" ? invariant$2(false, getMessage("border")) : invariant$2() : void 0;
    !isEqual$1$1(old.padding, fresh.padding) ? process.env.NODE_ENV !== "production" ? invariant$2(false, getMessage("padding")) : invariant$2() : void 0;
  }
};
var adjustBorderBoxSize = function adjustBorderBoxSize2(axis, old, fresh) {
  return {
    top: old.top,
    left: old.left,
    right: old.left + fresh.width,
    bottom: old.top + fresh.height
  };
};
var updateDroppables = function(_ref) {
  var modified = _ref.modified, existing = _ref.existing, viewport = _ref.viewport;
  if (!modified.length) {
    return existing;
  }
  var adjusted = modified.map(function(provided) {
    var raw = existing[provided.descriptor.id];
    !raw ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Could not locate droppable in existing droppables") : invariant$2() : void 0;
    var hasPlaceholder = Boolean(raw.subject.withPlaceholder);
    var dimension = hasPlaceholder ? removePlaceholder2(raw) : raw;
    var oldClient = dimension.client;
    var newClient = provided.client;
    var oldScrollable = getFrame(dimension);
    var newScrollable = getFrame(provided);
    if (process.env.NODE_ENV !== "production") {
      throwIfSpacingChange(dimension.client, provided.client);
      throwIfSpacingChange(oldScrollable.frameClient, newScrollable.frameClient);
      var isFrameEqual = oldScrollable.frameClient.borderBox.height === newScrollable.frameClient.borderBox.height && oldScrollable.frameClient.borderBox.width === newScrollable.frameClient.borderBox.width;
      !isFrameEqual ? process.env.NODE_ENV !== "production" ? invariant$2(false, "The width and height of your Droppable scroll container cannot change when adding or removing Draggables during a drag") : invariant$2() : void 0;
    }
    var client2 = createBox({
      borderBox: adjustBorderBoxSize(dimension.axis, oldClient.borderBox, newClient.borderBox),
      margin: oldClient.margin,
      border: oldClient.border,
      padding: oldClient.padding
    });
    var closest4 = {
      client: oldScrollable.frameClient,
      page: withScroll(oldScrollable.frameClient, viewport.scroll.initial),
      shouldClipSubject: oldScrollable.shouldClipSubject,
      scrollSize: newScrollable.scrollSize,
      scroll: oldScrollable.scroll.initial
    };
    var withSizeChanged = getDroppableDimension({
      descriptor: provided.descriptor,
      isEnabled: provided.isEnabled,
      isCombineEnabled: provided.isCombineEnabled,
      isFixedOnPage: provided.isFixedOnPage,
      direction: provided.axis.direction,
      client: client2,
      page: withScroll(client2, viewport.scroll.initial),
      closest: closest4
    });
    var scrolled = scrollDroppable(withSizeChanged, newScrollable.scroll.current);
    return scrolled;
  });
  var result = _extends$2({}, existing, toDroppableMap(adjusted));
  return result;
};
var withNoAnimatedDisplacement = function(impact) {
  var displaced = impact.movement.displaced;
  if (!displaced.length) {
    return impact;
  }
  var withoutAnimation = displaced.map(function(displacement) {
    if (!displacement.isVisible) {
      return displacement;
    }
    if (!displacement.shouldAnimate) {
      return displacement;
    }
    return _extends$2({}, displacement, {
      shouldAnimate: false
    });
  });
  var result = _extends$2({}, impact, {
    movement: _extends$2({}, impact.movement, {
      displaced: withoutAnimation,
      map: getDisplacementMap(withoutAnimation)
    })
  });
  return result;
};
var patchDroppableMap = function(droppables, updated) {
  var _extends2;
  return _extends$2({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var clearUnusedPlaceholder2 = function clearUnusedPlaceholder3(_ref) {
  var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
  var last = whatIsDraggedOver(previousImpact);
  var now2 = whatIsDraggedOver(impact);
  if (!last) {
    return droppables;
  }
  if (last === now2) {
    return droppables;
  }
  var lastDroppable = droppables[last];
  if (!lastDroppable.subject.withPlaceholder) {
    return droppables;
  }
  var updated = removePlaceholder2(lastDroppable);
  return patchDroppableMap(droppables, updated);
};
var recomputePlaceholders = function(_ref2) {
  var draggable2 = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
  var cleaned = clearUnusedPlaceholder2({
    previousImpact,
    impact,
    droppables
  });
  var isOver = whatIsDraggedOver(impact);
  if (!isOver) {
    return cleaned;
  }
  var droppable2 = droppables[isOver];
  if (isHomeOf(draggable2, droppable2)) {
    return cleaned;
  }
  if (droppable2.subject.withPlaceholder) {
    return cleaned;
  }
  var patched = addPlaceholder2(droppable2, draggable2, draggables);
  return patchDroppableMap(cleaned, patched);
};
var publishWhileDragging2 = function(_ref) {
  var _extends2, _extends3;
  var state = _ref.state, published = _ref.published;
  start2();
  var updatedDroppables = updateDroppables({
    modified: published.modified,
    existing: state.dimensions.droppables,
    viewport: state.viewport
  });
  var draggables = updateDraggables({
    updatedDroppables,
    criticalId: state.critical.draggable.id,
    existing: state.dimensions.draggables,
    additions: published.additions,
    removals: published.removals,
    viewport: state.viewport
  });
  var critical = {
    draggable: draggables[state.critical.draggable.id].descriptor,
    droppable: updatedDroppables[state.critical.droppable.id].descriptor
  };
  var original = state.dimensions.draggables[critical.draggable.id];
  var updated = draggables[critical.draggable.id];
  var droppables = recomputePlaceholders({
    draggable: updated,
    draggables,
    droppables: updatedDroppables,
    previousImpact: state.impact,
    impact: state.impact
  });
  var dimensions = {
    draggables,
    droppables
  };
  var _getDragPositions = getDragPositions({
    initial: state.initial,
    current: state.current,
    oldClientBorderBoxCenter: original.client.borderBox.center,
    newClientBorderBoxCenter: updated.client.borderBox.center,
    viewport: state.viewport
  }), initial = _getDragPositions.initial, current = _getDragPositions.current;
  var _getHomeOnLift = getHomeOnLift({
    draggable: updated,
    home: dimensions.droppables[critical.droppable.id],
    draggables: dimensions.draggables,
    viewport: state.viewport
  }), homeImpact = _getHomeOnLift.impact, onLift = _getHomeOnLift.onLift;
  var impact = withNoAnimatedDisplacement(getDragImpact({
    pageBorderBoxCenter: current.page.borderBoxCenter,
    draggable: updated,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: homeImpact,
    viewport: state.viewport,
    userDirection: state.userDirection,
    onLift
  }));
  var isOrphaned = Boolean(state.movementMode === "SNAP" && !whatIsDraggedOver(impact));
  !!isOrphaned ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Dragging item no longer has a valid merge/destination after a dynamic update. This is not supported") : invariant$2() : void 0;
  finish2();
  var draggingState = _extends$2({
    phase: "DRAGGING"
  }, state, (_extends2 = {}, _extends2["phase"] = "DRAGGING", _extends2.critical = critical, _extends2.current = current, _extends2.initial = initial, _extends2.impact = impact, _extends2.dimensions = dimensions, _extends2.onLift = onLift, _extends2.onLiftImpact = homeImpact, _extends2.forceShouldAnimate = false, _extends2));
  if (state.phase === "COLLECTING") {
    return draggingState;
  }
  var dropPending4 = _extends$2({
    phase: "DROP_PENDING"
  }, draggingState, (_extends3 = {}, _extends3["phase"] = "DROP_PENDING", _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));
  return dropPending4;
};
var forward = {
  vertical: "down",
  horizontal: "right"
};
var backward = {
  vertical: "up",
  horizontal: "left"
};
var moveToNextCombine = function(_ref) {
  var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable2 = _ref.draggable, destination = _ref.destination, originalInsideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
  if (!destination.isCombineEnabled) {
    return null;
  }
  if (previousImpact.merge) {
    return null;
  }
  var location = previousImpact.destination;
  !location ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Need a previous location to move from into a combine") : invariant$2() : void 0;
  var currentIndex = location.index;
  var currentInsideDestination = function() {
    var shallow = originalInsideDestination.slice();
    if (isInHomeList) {
      shallow.splice(draggable2.descriptor.index, 1);
    }
    shallow.splice(location.index, 0, draggable2);
    return shallow;
  }();
  var targetIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
  if (targetIndex < 0) {
    return null;
  }
  if (targetIndex > currentInsideDestination.length - 1) {
    return null;
  }
  var target = currentInsideDestination[targetIndex];
  !(target !== draggable2) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot combine with self") : invariant$2() : void 0;
  var merge3 = {
    whenEntered: isMovingForward ? forward : backward,
    combine: {
      draggableId: target.descriptor.id,
      droppableId: destination.descriptor.id
    }
  };
  var impact = {
    movement: previousImpact.movement,
    destination: null,
    merge: merge3
  };
  return impact;
};
var addClosest = function addClosest2(add4, displaced) {
  var added = {
    draggableId: add4.descriptor.id,
    isVisible: true,
    shouldAnimate: true
  };
  return [added].concat(displaced);
};
var removeClosest = function removeClosest2(displaced) {
  return displaced.slice(1);
};
var fromReorder = function(_ref) {
  var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable2 = _ref.draggable, initialInside = _ref.insideDestination, location = _ref.location;
  var insideDestination = initialInside.slice();
  var currentIndex = location.index;
  var isInForeignList = !isInHomeList;
  if (isInForeignList) {
    insideDestination.splice(location.index, 0, draggable2);
  }
  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
  if (proposedIndex < 0) {
    return null;
  }
  if (proposedIndex > insideDestination.length - 1) {
    return null;
  }
  return {
    proposedIndex,
    modifyDisplacement: true
  };
};
var fromCombine = function(_ref) {
  var isMovingForward = _ref.isMovingForward, destination = _ref.destination, previousImpact = _ref.previousImpact, draggables = _ref.draggables, merge3 = _ref.merge, onLift = _ref.onLift;
  if (!destination.isCombineEnabled) {
    return null;
  }
  var movement = previousImpact.movement;
  var combineId = merge3.combine.draggableId;
  var combine2 = draggables[combineId];
  var combineIndex = combine2.descriptor.index;
  var wasDisplacedAtStart = didStartDisplaced(combineId, onLift);
  if (wasDisplacedAtStart) {
    var hasDisplacedFromStart = !movement.map[combineId];
    if (hasDisplacedFromStart) {
      if (isMovingForward) {
        return {
          proposedIndex: combineIndex,
          modifyDisplacement: false
        };
      }
      return {
        proposedIndex: combineIndex - 1,
        modifyDisplacement: true
      };
    }
    if (isMovingForward) {
      return {
        proposedIndex: combineIndex,
        modifyDisplacement: true
      };
    }
    return {
      proposedIndex: combineIndex - 1,
      modifyDisplacement: false
    };
  }
  var isDisplaced = Boolean(movement.map[combineId]);
  if (isDisplaced) {
    if (isMovingForward) {
      return {
        proposedIndex: combineIndex + 1,
        modifyDisplacement: true
      };
    }
    return {
      proposedIndex: combineIndex,
      modifyDisplacement: false
    };
  }
  if (isMovingForward) {
    return {
      proposedIndex: combineIndex + 1,
      modifyDisplacement: false
    };
  }
  return {
    proposedIndex: combineIndex,
    modifyDisplacement: true
  };
};
var moveToNextIndex = function(_ref) {
  var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable2 = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, onLift = _ref.onLift;
  var instruction = function() {
    if (previousImpact.destination) {
      return fromReorder({
        isMovingForward,
        isInHomeList,
        draggable: draggable2,
        location: previousImpact.destination,
        insideDestination
      });
    }
    if (previousImpact.merge) {
      return fromCombine({
        isMovingForward,
        destination,
        previousImpact,
        draggables,
        merge: previousImpact.merge,
        onLift
      });
    }
    return null;
  }();
  if (instruction == null) {
    return null;
  }
  var proposedIndex = instruction.proposedIndex, modifyDisplacement = instruction.modifyDisplacement;
  var displacedBy = getDisplacedBy2(destination.axis, draggable2.displaceBy);
  var displaced = function() {
    var lastDisplaced = previousImpact.movement.displaced;
    if (!modifyDisplacement) {
      return lastDisplaced;
    }
    if (isMovingForward) {
      return removeClosest(lastDisplaced);
    }
    var withoutDraggable = removeDraggableFromList(draggable2, insideDestination);
    var atProposedIndex = withoutDraggable[proposedIndex];
    return addClosest(atProposedIndex, lastDisplaced);
  }();
  return {
    movement: {
      displacedBy,
      displaced,
      map: getDisplacementMap(displaced)
    },
    destination: {
      droppableId: destination.descriptor.id,
      index: proposedIndex
    },
    merge: null
  };
};
var whenCombining = function(_ref) {
  var combine2 = _ref.combine, onLift = _ref.onLift, movement = _ref.movement, draggables = _ref.draggables;
  var combineWith = combine2.draggableId;
  var center = draggables[combineWith].page.borderBox.center;
  var displaceBy = getCombinedItemDisplacement({
    displaced: movement.map,
    onLift,
    combineWith,
    displacedBy: movement.displacedBy
  });
  return add$3(center, displaceBy);
};
var distanceFromStartToBorderBoxCenter2 = function distanceFromStartToBorderBoxCenter3(axis, box) {
  return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var distanceFromEndToBorderBoxCenter2 = function distanceFromEndToBorderBoxCenter3(axis, box) {
  return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var getCrossAxisBorderBoxCenter2 = function getCrossAxisBorderBoxCenter3(axis, target, isMoving) {
  return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var goAfter2 = function goAfter3(_ref) {
  var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
  return patch$1(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter2(axis, isMoving), getCrossAxisBorderBoxCenter2(axis, moveRelativeTo.marginBox, isMoving));
};
var goBefore2 = function goBefore3(_ref2) {
  var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
  return patch$1(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter2(axis, isMoving), getCrossAxisBorderBoxCenter2(axis, moveRelativeTo.marginBox, isMoving));
};
var goIntoStart2 = function goIntoStart3(_ref3) {
  var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
  return patch$1(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter2(axis, isMoving), getCrossAxisBorderBoxCenter2(axis, moveInto.contentBox, isMoving));
};
var whenReordering = function(_ref) {
  var movement = _ref.movement, draggable2 = _ref.draggable, draggables = _ref.draggables, droppable2 = _ref.droppable, onLift = _ref.onLift;
  var insideDestination = getDraggablesInsideDroppable(droppable2.descriptor.id, draggables);
  var draggablePage = draggable2.page;
  var axis = droppable2.axis;
  if (!insideDestination.length) {
    return goIntoStart2({
      axis,
      moveInto: droppable2.page,
      isMoving: draggablePage
    });
  }
  var displaced = movement.displaced, displacedBy = movement.displacedBy;
  if (displaced.length) {
    var closestAfter = draggables[displaced[0].draggableId];
    if (didStartDisplaced(closestAfter.descriptor.id, onLift)) {
      return goBefore2({
        axis,
        moveRelativeTo: closestAfter.page,
        isMoving: draggablePage
      });
    }
    var withDisplacement = offset$4(closestAfter.page, displacedBy.point);
    return goBefore2({
      axis,
      moveRelativeTo: withDisplacement,
      isMoving: draggablePage
    });
  }
  var last = insideDestination[insideDestination.length - 1];
  if (last.descriptor.id === draggable2.descriptor.id) {
    return draggablePage.borderBox.center;
  }
  if (didStartDisplaced(last.descriptor.id, onLift)) {
    var page = offset$4(last.page, negate2(onLift.displacedBy.point));
    return goAfter2({
      axis,
      moveRelativeTo: page,
      isMoving: draggablePage
    });
  }
  return goAfter2({
    axis,
    moveRelativeTo: last.page,
    isMoving: draggablePage
  });
};
var withDroppableDisplacement = function(droppable2, point2) {
  var frame = droppable2.frame;
  if (!frame) {
    return point2;
  }
  return add$3(point2, frame.scroll.diff.displacement);
};
var getResultWithoutDroppableDisplacement2 = function getResultWithoutDroppableDisplacement3(_ref) {
  var impact = _ref.impact, draggable2 = _ref.draggable, droppable2 = _ref.droppable, draggables = _ref.draggables, onLift = _ref.onLift;
  var merge3 = impact.merge;
  var destination = impact.destination;
  var original = draggable2.page.borderBox.center;
  if (!droppable2) {
    return original;
  }
  if (destination) {
    return whenReordering({
      movement: impact.movement,
      draggable: draggable2,
      draggables,
      droppable: droppable2,
      onLift
    });
  }
  if (merge3) {
    return whenCombining({
      movement: impact.movement,
      combine: merge3.combine,
      draggables,
      onLift
    });
  }
  return original;
};
var getPageBorderBoxCenterFromImpact = function(args) {
  var withoutDisplacement = getResultWithoutDroppableDisplacement2(args);
  var droppable2 = args.droppable;
  var withDisplacement = droppable2 ? withDroppableDisplacement(droppable2, withoutDisplacement) : withoutDisplacement;
  return withDisplacement;
};
var scrollViewport = function(viewport, newScroll) {
  var diff2 = subtract$3(newScroll, viewport.scroll.initial);
  var displacement = negate2(diff2);
  var frame = getRect({
    top: newScroll.y,
    bottom: newScroll.y + viewport.frame.height,
    left: newScroll.x,
    right: newScroll.x + viewport.frame.width
  });
  var updated = {
    frame,
    scroll: {
      initial: viewport.scroll.initial,
      max: viewport.scroll.max,
      current: newScroll,
      diff: {
        value: diff2,
        displacement
      }
    }
  };
  return updated;
};
var withNewDisplacement = function(impact, displaced) {
  return _extends$2({}, impact, {
    movement: _extends$2({}, impact.movement, {
      displaced,
      map: getDisplacementMap(displaced)
    })
  });
};
var speculativelyIncrease = function(_ref) {
  var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange, onLift = _ref.onLift;
  var displaced = impact.movement.displaced;
  var scrolledViewport = scrollViewport(viewport, add$3(viewport.scroll.current, maxScrollChange));
  var scrolledDroppable = destination.frame ? scrollDroppable(destination, add$3(destination.frame.scroll.current, maxScrollChange)) : destination;
  var updated = displaced.map(function(entry) {
    if (entry.isVisible) {
      return entry;
    }
    var draggable2 = draggables[entry.draggableId];
    var withScrolledViewport = getDisplacement({
      draggable: draggable2,
      destination,
      previousImpact: impact,
      viewport: scrolledViewport.frame,
      onLift,
      forceShouldAnimate: false
    });
    if (withScrolledViewport.isVisible) {
      return withScrolledViewport;
    }
    var withScrolledDroppable = getDisplacement({
      draggable: draggable2,
      destination: scrolledDroppable,
      previousImpact: impact,
      viewport: viewport.frame,
      onLift,
      forceShouldAnimate: false
    });
    if (withScrolledDroppable.isVisible) {
      return withScrolledDroppable;
    }
    return entry;
  });
  return withNewDisplacement(impact, updated);
};
var withViewportDisplacement = function(viewport, point2) {
  return add$3(viewport.scroll.diff.displacement, point2);
};
var getClientFromPageBorderBoxCenter = function(_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable2 = _ref.draggable, viewport = _ref.viewport;
  var withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
  var offset3 = subtract$3(withoutPageScrollChange, draggable2.page.borderBox.center);
  return add$3(draggable2.client.borderBox.center, offset3);
};
var isTotallyVisibleInNewLocation = function(_ref) {
  var draggable2 = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement2 = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
  var changeNeeded = subtract$3(newPageBorderBoxCenter, draggable2.page.borderBox.center);
  var shifted = offsetByPosition2(draggable2.page.borderBox, changeNeeded);
  var args = {
    target: shifted,
    destination,
    withDroppableDisplacement: withDroppableDisplacement2,
    viewport
  };
  return onlyOnMainAxis ? isTotallyVisibleOnAxis2(args) : isTotallyVisible2(args);
};
var moveToNextPlace = function(_ref) {
  var isMovingForward = _ref.isMovingForward, draggable2 = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, onLift = _ref.onLift;
  if (!destination.isEnabled) {
    return null;
  }
  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var isInHomeList = isHomeOf(draggable2, destination);
  var impact = moveToNextCombine({
    isInHomeList,
    isMovingForward,
    draggable: draggable2,
    destination,
    insideDestination,
    previousImpact
  }) || moveToNextIndex({
    isMovingForward,
    isInHomeList,
    draggable: draggable2,
    draggables,
    destination,
    insideDestination,
    previousImpact,
    onLift
  });
  if (!impact) {
    return null;
  }
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact,
    draggable: draggable2,
    droppable: destination,
    draggables,
    onLift
  });
  var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
    draggable: draggable2,
    destination,
    newPageBorderBoxCenter: pageBorderBoxCenter,
    viewport: viewport.frame,
    withDroppableDisplacement: false,
    onlyOnMainAxis: true
  });
  if (isVisibleInNewLocation) {
    var clientSelection = getClientFromPageBorderBoxCenter({
      pageBorderBoxCenter,
      draggable: draggable2,
      viewport
    });
    return {
      clientSelection,
      impact,
      scrollJumpRequest: null
    };
  }
  var distance4 = subtract$3(pageBorderBoxCenter, previousPageBorderBoxCenter);
  var cautious = speculativelyIncrease({
    impact,
    viewport,
    destination,
    draggables,
    maxScrollChange: distance4,
    onLift
  });
  return {
    clientSelection: previousClientSelection,
    impact: cautious,
    scrollJumpRequest: distance4
  };
};
var getKnownActive2 = function getKnownActive3(droppable2) {
  var rect = droppable2.subject.active;
  !rect ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot get clipped area from droppable") : invariant$2() : void 0;
  return rect;
};
var getBestCrossAxisDroppable = function(_ref) {
  var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
  var active = source.subject.active;
  if (!active) {
    return null;
  }
  var axis = source.axis;
  var isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
  var candidates = toDroppableList(droppables).filter(function(droppable2) {
    return droppable2 !== source;
  }).filter(function(droppable2) {
    return droppable2.isEnabled;
  }).filter(function(droppable2) {
    return Boolean(droppable2.subject.active);
  }).filter(function(droppable2) {
    return isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive2(droppable2));
  }).filter(function(droppable2) {
    var activeOfTarget = getKnownActive2(droppable2);
    if (isMovingForward) {
      return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
    }
    return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
  }).filter(function(droppable2) {
    var activeOfTarget = getKnownActive2(droppable2);
    var isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
    return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
  }).sort(function(a2, b2) {
    var first2 = getKnownActive2(a2)[axis.crossAxisStart];
    var second = getKnownActive2(b2)[axis.crossAxisStart];
    if (isMovingForward) {
      return first2 - second;
    }
    return second - first2;
  }).filter(function(droppable2, index2, array) {
    return getKnownActive2(droppable2)[axis.crossAxisStart] === getKnownActive2(array[0])[axis.crossAxisStart];
  });
  if (!candidates.length) {
    return null;
  }
  if (candidates.length === 1) {
    return candidates[0];
  }
  var contains = candidates.filter(function(droppable2) {
    var isWithinDroppable = isWithin(getKnownActive2(droppable2)[axis.start], getKnownActive2(droppable2)[axis.end]);
    return isWithinDroppable(pageBorderBoxCenter[axis.line]);
  });
  if (contains.length === 1) {
    return contains[0];
  }
  if (contains.length > 1) {
    return contains.sort(function(a2, b2) {
      return getKnownActive2(a2)[axis.start] - getKnownActive2(b2)[axis.start];
    })[0];
  }
  return candidates.sort(function(a2, b2) {
    var first2 = closest2(pageBorderBoxCenter, getCorners2(getKnownActive2(a2)));
    var second = closest2(pageBorderBoxCenter, getCorners2(getKnownActive2(b2)));
    if (first2 !== second) {
      return first2 - second;
    }
    return getKnownActive2(a2)[axis.start] - getKnownActive2(b2)[axis.start];
  })[0];
};
var getCurrentPageBorderBoxCenter2 = function getCurrentPageBorderBoxCenter3(draggable2, onLift) {
  var original = draggable2.page.borderBox.center;
  return didStartDisplaced(draggable2.descriptor.id, onLift) ? subtract$3(original, onLift.displacedBy.point) : original;
};
var getCurrentPageBorderBox2 = function getCurrentPageBorderBox3(draggable2, onLift) {
  var original = draggable2.page.borderBox;
  return didStartDisplaced(draggable2.descriptor.id, onLift) ? offsetByPosition2(original, negate2(onLift.displacedBy.point)) : original;
};
var getClosestDraggable = function(_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, onLift = _ref.onLift;
  var sorted = insideDestination.filter(function(draggable2) {
    return isTotallyVisible2({
      target: getCurrentPageBorderBox2(draggable2, onLift),
      destination,
      viewport: viewport.frame,
      withDroppableDisplacement: true
    });
  }).sort(function(a2, b2) {
    var distanceToA = distance2(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter2(a2, onLift)));
    var distanceToB = distance2(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter2(b2, onLift)));
    if (distanceToA < distanceToB) {
      return -1;
    }
    if (distanceToB < distanceToA) {
      return 1;
    }
    return a2.descriptor.index - b2.descriptor.index;
  });
  return sorted[0] || null;
};
var moveToNewDroppable = function(_ref) {
  var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable2 = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, onLift = _ref.onLift;
  if (!moveRelativeTo) {
    if (insideDestination.length) {
      return null;
    }
    var proposed = {
      movement: noMovement,
      destination: {
        droppableId: destination.descriptor.id,
        index: 0
      },
      merge: null
    };
    var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
      impact: proposed,
      draggable: draggable2,
      droppable: destination,
      draggables,
      onLift
    });
    var withPlaceholder = isHomeOf(draggable2, destination) ? destination : addPlaceholder2(destination, draggable2, draggables);
    var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
      draggable: draggable2,
      destination: withPlaceholder,
      newPageBorderBoxCenter: proposedPageBorderBoxCenter,
      viewport: viewport.frame,
      withDroppableDisplacement: false,
      onlyOnMainAxis: true
    });
    return isVisibleInNewLocation ? proposed : null;
  }
  var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] < moveRelativeTo.page.borderBox.center[destination.axis.line]);
  var targetIndex = insideDestination.indexOf(moveRelativeTo);
  !(targetIndex !== -1) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot find target in list") : invariant$2() : void 0;
  var proposedIndex = function() {
    if (moveRelativeTo.descriptor.id === draggable2.descriptor.id) {
      return targetIndex;
    }
    if (isGoingBeforeTarget) {
      return targetIndex;
    }
    return targetIndex + 1;
  }();
  var displaced = removeDraggableFromList(draggable2, insideDestination).slice(proposedIndex).map(function(dimension) {
    return getDisplacement({
      draggable: dimension,
      destination,
      viewport: viewport.frame,
      previousImpact,
      onLift
    });
  });
  var displacedBy = getDisplacedBy2(destination.axis, draggable2.displaceBy);
  var impact = {
    movement: {
      displacedBy,
      displaced,
      map: getDisplacementMap(displaced)
    },
    destination: {
      droppableId: destination.descriptor.id,
      index: proposedIndex
    },
    merge: null
  };
  return impact;
};
var moveCrossAxis = function(_ref) {
  var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable2 = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, onLift = _ref.onLift;
  var destination = getBestCrossAxisDroppable({
    isMovingForward,
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    source: isOver,
    droppables,
    viewport
  });
  if (!destination) {
    return null;
  }
  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var moveRelativeTo = getClosestDraggable({
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    viewport,
    destination,
    insideDestination,
    onLift
  });
  var impact = moveToNewDroppable({
    previousPageBorderBoxCenter,
    destination,
    draggable: draggable2,
    draggables,
    moveRelativeTo,
    insideDestination,
    previousImpact,
    viewport,
    onLift
  });
  if (!impact) {
    return null;
  }
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact,
    draggable: draggable2,
    droppable: destination,
    draggables,
    onLift
  });
  var clientSelection = getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter,
    draggable: draggable2,
    viewport
  });
  return {
    clientSelection,
    impact,
    scrollJumpRequest: null
  };
};
var getDroppableOver$1 = function getDroppableOver3(impact, droppables) {
  var id = whatIsDraggedOver(impact);
  return id ? droppables[id] : null;
};
var moveInDirection = function(_ref) {
  var state = _ref.state, type = _ref.type;
  var isActuallyOver = getDroppableOver$1(state.impact, state.dimensions.droppables);
  var isMainAxisMovementAllowed = Boolean(isActuallyOver);
  var home2 = state.dimensions.droppables[state.critical.droppable.id];
  var isOver = isActuallyOver || home2;
  var direction = isOver.axis.direction;
  var isMovingOnMainAxis = direction === "vertical" && (type === "MOVE_UP" || type === "MOVE_DOWN") || direction === "horizontal" && (type === "MOVE_LEFT" || type === "MOVE_RIGHT");
  if (isMovingOnMainAxis && !isMainAxisMovementAllowed) {
    return null;
  }
  var isMovingForward = type === "MOVE_DOWN" || type === "MOVE_RIGHT";
  var draggable2 = state.dimensions.draggables[state.critical.draggable.id];
  var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
  var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
  return isMovingOnMainAxis ? moveToNextPlace({
    isMovingForward,
    previousPageBorderBoxCenter,
    draggable: draggable2,
    destination: isOver,
    draggables,
    viewport: state.viewport,
    previousClientSelection: state.current.client.selection,
    previousImpact: state.impact,
    onLift: state.onLift
  }) : moveCrossAxis({
    isMovingForward,
    previousPageBorderBoxCenter,
    draggable: draggable2,
    isOver,
    draggables,
    droppables,
    previousImpact: state.impact,
    viewport: state.viewport,
    onLift: state.onLift
  });
};
function isMovementAllowed(state) {
  return state.phase === "DRAGGING" || state.phase === "COLLECTING";
}
var getVertical = function getVertical2(previous2, diff2) {
  if (diff2 === 0) {
    return previous2;
  }
  return diff2 > 0 ? "down" : "up";
};
var getHorizontal = function getHorizontal2(previous2, diff2) {
  if (diff2 === 0) {
    return previous2;
  }
  return diff2 > 0 ? "right" : "left";
};
var getUserDirection = function(previous2, oldPageBorderBoxCenter, newPageBorderBoxCenter) {
  var diff2 = subtract$3(newPageBorderBoxCenter, oldPageBorderBoxCenter);
  return {
    horizontal: getHorizontal(previous2.horizontal, diff2.x),
    vertical: getVertical(previous2.vertical, diff2.y)
  };
};
var update = function(_ref) {
  var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
  var viewport = forcedViewport || state.viewport;
  var currentWindowScroll = viewport.scroll.current;
  var dimensions = forcedDimensions || state.dimensions;
  var clientSelection = forcedClientSelection || state.current.client.selection;
  var offset3 = subtract$3(clientSelection, state.initial.client.selection);
  var client2 = {
    offset: offset3,
    selection: clientSelection,
    borderBoxCenter: add$3(state.initial.client.borderBoxCenter, offset3)
  };
  var page = {
    selection: add$3(client2.selection, currentWindowScroll),
    borderBoxCenter: add$3(client2.borderBoxCenter, currentWindowScroll)
  };
  var current = {
    client: client2,
    page
  };
  var userDirection = getUserDirection(state.userDirection, state.current.page.borderBoxCenter, current.page.borderBoxCenter);
  if (state.phase === "COLLECTING") {
    return _extends$2({
      phase: "COLLECTING"
    }, state, {
      dimensions,
      viewport,
      current,
      userDirection
    });
  }
  var draggable2 = dimensions.draggables[state.critical.draggable.id];
  var newImpact = forcedImpact || getDragImpact({
    pageBorderBoxCenter: page.borderBoxCenter,
    draggable: draggable2,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: state.impact,
    viewport,
    userDirection,
    onLift: state.onLift
  });
  var withUpdatedPlaceholders = recomputePlaceholders({
    draggable: draggable2,
    impact: newImpact,
    previousImpact: state.impact,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables
  });
  var result = _extends$2({}, state, {
    current,
    userDirection,
    dimensions: {
      draggables: dimensions.draggables,
      droppables: withUpdatedPlaceholders
    },
    impact: newImpact,
    viewport,
    scrollJumpRequest: scrollJumpRequest || null,
    forceShouldAnimate: scrollJumpRequest ? false : null
  });
  return result;
};
var recompute = function(_ref) {
  var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, onLift = _ref.onLift, forceShouldAnimate = _ref.forceShouldAnimate;
  var updated = impact.movement.displaced.map(function(entry) {
    return getDisplacement({
      draggable: draggables[entry.draggableId],
      destination,
      previousImpact: impact,
      viewport: viewport.frame,
      onLift,
      forceShouldAnimate
    });
  });
  return withNewDisplacement(impact, updated);
};
var getClientBorderBoxCenter = function(_ref) {
  var impact = _ref.impact, draggable2 = _ref.draggable, droppable2 = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, onLift = _ref.onLift;
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact,
    draggable: draggable2,
    draggables,
    droppable: droppable2,
    onLift
  });
  return getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter,
    draggable: draggable2,
    viewport
  });
};
var refreshSnap = function(_ref) {
  var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
  !(state.movementMode === "SNAP") ? process.env.NODE_ENV !== "production" ? invariant$2() : invariant$2() : void 0;
  var needsVisibilityCheck = state.impact;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var draggables = dimensions.draggables, droppables = dimensions.droppables;
  var draggable2 = draggables[state.critical.draggable.id];
  var isOver = whatIsDraggedOver(needsVisibilityCheck);
  !isOver ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Must be over a destination in SNAP movement mode") : invariant$2() : void 0;
  var destination = droppables[isOver];
  var impact = recompute({
    impact: needsVisibilityCheck,
    viewport,
    destination,
    draggables,
    onLift: state.onLift
  });
  var clientSelection = getClientBorderBoxCenter({
    impact,
    draggable: draggable2,
    droppable: destination,
    draggables,
    viewport,
    onLift: state.onLift
  });
  return update({
    impact,
    clientSelection,
    state,
    dimensions,
    viewport
  });
};
var patchDimensionMap = function(dimensions, updated) {
  return {
    draggables: dimensions.draggables,
    droppables: patchDroppableMap(dimensions.droppables, updated)
  };
};
var isSnapping2 = function isSnapping3(state) {
  return state.movementMode === "SNAP";
};
var postDroppableChange2 = function postDroppableChange3(state, updated, isEnabledChanging) {
  var dimensions = patchDimensionMap(state.dimensions, updated);
  if (!isSnapping2(state) || isEnabledChanging) {
    return update({
      state,
      dimensions
    });
  }
  return refreshSnap({
    state,
    dimensions
  });
};
var idle = {
  phase: "IDLE",
  completed: null,
  shouldFlush: false
};
var reducer$2 = function(state, action) {
  if (state === void 0) {
    state = idle;
  }
  if (action.type === "CLEAN") {
    return _extends$2({}, idle, {
      shouldFlush: action.payload.shouldFlush
    });
  }
  if (action.type === "INITIAL_PUBLISH") {
    !(state.phase === "IDLE") ? process.env.NODE_ENV !== "production" ? invariant$2(false, "INITIAL_PUBLISH must come after a IDLE phase") : invariant$2() : void 0;
    var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
    var draggable2 = dimensions.draggables[critical.draggable.id];
    var home2 = dimensions.droppables[critical.droppable.id];
    var client2 = {
      selection: clientSelection,
      borderBoxCenter: draggable2.client.borderBox.center,
      offset: origin
    };
    var initial = {
      client: client2,
      page: {
        selection: add$3(client2.selection, viewport.scroll.initial),
        borderBoxCenter: add$3(client2.selection, viewport.scroll.initial)
      }
    };
    var isWindowScrollAllowed = toDroppableList(dimensions.droppables).every(function(item) {
      return !item.isFixedOnPage;
    });
    var _getHomeOnLift = getHomeOnLift({
      draggable: draggable2,
      home: home2,
      draggables: dimensions.draggables,
      viewport
    }), impact = _getHomeOnLift.impact, onLift = _getHomeOnLift.onLift;
    var result = {
      phase: "DRAGGING",
      isDragging: true,
      critical,
      movementMode,
      dimensions,
      initial,
      current: initial,
      isWindowScrollAllowed,
      impact,
      onLift,
      onLiftImpact: impact,
      viewport,
      userDirection: forward,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return result;
  }
  if (action.type === "COLLECTION_STARTING") {
    var _extends2;
    if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") {
      return state;
    }
    !(state.phase === "DRAGGING") ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Collection cannot start from phase " + state.phase) : invariant$2() : void 0;
    var _result = _extends$2({
      phase: "COLLECTING"
    }, state, (_extends2 = {}, _extends2["phase"] = "COLLECTING", _extends2));
    return _result;
  }
  if (action.type === "PUBLISH_WHILE_DRAGGING") {
    !(state.phase === "COLLECTING" || state.phase === "DROP_PENDING") ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Unexpected " + action.type + " received in phase " + state.phase) : invariant$2() : void 0;
    return publishWhileDragging2({
      state,
      published: action.payload
    });
  }
  if (action.type === "MOVE") {
    if (state.phase === "DROP_PENDING") {
      return state;
    }
    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant$2(false, action.type + " not permitted in phase " + state.phase) : invariant$2() : void 0;
    var _clientSelection = action.payload.client;
    if (isEqual$1(_clientSelection, state.current.client.selection)) {
      return state;
    }
    return update({
      state,
      clientSelection: _clientSelection,
      impact: isSnapping2(state) ? state.impact : null
    });
  }
  if (action.type === "UPDATE_DROPPABLE_SCROLL") {
    if (state.phase === "DROP_PENDING") {
      return state;
    }
    if (state.phase === "COLLECTING") {
      return state;
    }
    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant$2(false, action.type + " not permitted in phase " + state.phase) : invariant$2() : void 0;
    var _action$payload2 = action.payload, id = _action$payload2.id, offset3 = _action$payload2.offset;
    var target = state.dimensions.droppables[id];
    if (!target) {
      return state;
    }
    var scrolled = scrollDroppable(target, offset3);
    return postDroppableChange2(state, scrolled, false);
  }
  if (action.type === "UPDATE_DROPPABLE_IS_ENABLED") {
    if (state.phase === "DROP_PENDING") {
      return state;
    }
    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Attempting to move in an unsupported phase " + state.phase) : invariant$2() : void 0;
    var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
    var _target = state.dimensions.droppables[_id];
    !_target ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot find Droppable[id: " + _id + "] to toggle its enabled state") : invariant$2() : void 0;
    !(_target.isEnabled !== isEnabled) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Trying to set droppable isEnabled to " + String(isEnabled) + "\n      but it is already " + String(_target.isEnabled)) : invariant$2() : void 0;
    var updated = _extends$2({}, _target, {
      isEnabled
    });
    return postDroppableChange2(state, updated, true);
  }
  if (action.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
    if (state.phase === "DROP_PENDING") {
      return state;
    }
    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Attempting to move in an unsupported phase " + state.phase) : invariant$2() : void 0;
    var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
    var _target2 = state.dimensions.droppables[_id2];
    !_target2 ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot find Droppable[id: " + _id2 + "] to toggle its isCombineEnabled state") : invariant$2() : void 0;
    !(_target2.isCombineEnabled !== isCombineEnabled) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Trying to set droppable isCombineEnabled to " + String(isCombineEnabled) + "\n      but it is already " + String(_target2.isCombineEnabled)) : invariant$2() : void 0;
    var _updated = _extends$2({}, _target2, {
      isCombineEnabled
    });
    return postDroppableChange2(state, _updated, true);
  }
  if (action.type === "MOVE_BY_WINDOW_SCROLL") {
    if (state.phase === "DROP_PENDING" || state.phase === "DROP_ANIMATING") {
      return state;
    }
    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot move by window in phase " + state.phase) : invariant$2() : void 0;
    !state.isWindowScrollAllowed ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Window scrolling is currently not supported for fixed lists. Aborting drag") : invariant$2() : void 0;
    var newScroll = action.payload.newScroll;
    if (isEqual$1(state.viewport.scroll.current, newScroll)) {
      return state;
    }
    var _viewport = scrollViewport(state.viewport, newScroll);
    if (isSnapping2(state)) {
      return refreshSnap({
        state,
        viewport: _viewport
      });
    }
    return update({
      state,
      viewport: _viewport
    });
  }
  if (action.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
    if (!isMovementAllowed(state)) {
      return state;
    }
    var maxScroll = action.payload.maxScroll;
    if (isEqual$1(maxScroll, state.viewport.scroll.max)) {
      return state;
    }
    var withMaxScroll4 = _extends$2({}, state.viewport, {
      scroll: _extends$2({}, state.viewport.scroll, {
        max: maxScroll
      })
    });
    return _extends$2({
      phase: "DRAGGING"
    }, state, {
      viewport: withMaxScroll4
    });
  }
  if (action.type === "MOVE_UP" || action.type === "MOVE_DOWN" || action.type === "MOVE_LEFT" || action.type === "MOVE_RIGHT") {
    if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") {
      return state;
    }
    !(state.phase === "DRAGGING") ? process.env.NODE_ENV !== "production" ? invariant$2(false, action.type + " received while not in DRAGGING phase") : invariant$2() : void 0;
    var _result2 = moveInDirection({
      state,
      type: action.type
    });
    if (!_result2) {
      return state;
    }
    return update({
      state,
      impact: _result2.impact,
      clientSelection: _result2.clientSelection,
      scrollJumpRequest: _result2.scrollJumpRequest
    });
  }
  if (action.type === "DROP_PENDING") {
    var _extends3;
    var reason = action.payload.reason;
    !(state.phase === "COLLECTING") ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Can only move into the DROP_PENDING phase from the COLLECTING phase") : invariant$2() : void 0;
    var newState = _extends$2({
      phase: "DROP_PENDING"
    }, state, (_extends3 = {}, _extends3["phase"] = "DROP_PENDING", _extends3.isWaiting = true, _extends3.reason = reason, _extends3));
    return newState;
  }
  if (action.type === "DROP_ANIMATE") {
    var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
    !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot animate drop from phase " + state.phase) : invariant$2() : void 0;
    var _result3 = {
      phase: "DROP_ANIMATING",
      dimensions: state.dimensions,
      completed,
      dropDuration,
      newHomeClientOffset
    };
    return _result3;
  }
  if (action.type === "DROP_COMPLETE") {
    var _action$payload6 = action.payload, _completed = _action$payload6.completed, shouldFlush = _action$payload6.shouldFlush;
    return {
      phase: "IDLE",
      completed: _completed,
      shouldFlush
    };
  }
  return state;
};
var lift$3 = function lift2(args) {
  return {
    type: "LIFT",
    payload: args
  };
};
var initialPublish2 = function initialPublish3(args) {
  return {
    type: "INITIAL_PUBLISH",
    payload: args
  };
};
var publishWhileDragging$1 = function publishWhileDragging3(args) {
  return {
    type: "PUBLISH_WHILE_DRAGGING",
    payload: args
  };
};
var collectionStarting2 = function collectionStarting3() {
  return {
    type: "COLLECTION_STARTING",
    payload: null
  };
};
var updateDroppableScroll2 = function updateDroppableScroll3(args) {
  return {
    type: "UPDATE_DROPPABLE_SCROLL",
    payload: args
  };
};
var updateDroppableIsEnabled2 = function updateDroppableIsEnabled3(args) {
  return {
    type: "UPDATE_DROPPABLE_IS_ENABLED",
    payload: args
  };
};
var updateDroppableIsCombineEnabled2 = function updateDroppableIsCombineEnabled3(args) {
  return {
    type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
    payload: args
  };
};
var move2 = function move3(args) {
  return {
    type: "MOVE",
    payload: args
  };
};
var moveByWindowScroll2 = function moveByWindowScroll3(args) {
  return {
    type: "MOVE_BY_WINDOW_SCROLL",
    payload: args
  };
};
var updateViewportMaxScroll2 = function updateViewportMaxScroll3(args) {
  return {
    type: "UPDATE_VIEWPORT_MAX_SCROLL",
    payload: args
  };
};
var moveUp2 = function moveUp3() {
  return {
    type: "MOVE_UP",
    payload: null
  };
};
var moveDown2 = function moveDown3() {
  return {
    type: "MOVE_DOWN",
    payload: null
  };
};
var moveRight2 = function moveRight3() {
  return {
    type: "MOVE_RIGHT",
    payload: null
  };
};
var moveLeft2 = function moveLeft3() {
  return {
    type: "MOVE_LEFT",
    payload: null
  };
};
var clean$1 = function clean5(args) {
  if (args === void 0) {
    args = {
      shouldFlush: false
    };
  }
  return {
    type: "CLEAN",
    payload: args
  };
};
var animateDrop2 = function animateDrop3(args) {
  return {
    type: "DROP_ANIMATE",
    payload: args
  };
};
var completeDrop2 = function completeDrop3(args) {
  return {
    type: "DROP_COMPLETE",
    payload: args
  };
};
var drop4 = function drop5(args) {
  return {
    type: "DROP",
    payload: args
  };
};
var dropPending2 = function dropPending3(args) {
  return {
    type: "DROP_PENDING",
    payload: args
  };
};
var dropAnimationFinished2 = function dropAnimationFinished3() {
  return {
    type: "DROP_ANIMATION_FINISHED",
    payload: null
  };
};
var lift$1$1 = function(marshal) {
  return function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next2) {
      return function(action) {
        if (action.type !== "LIFT") {
          next2(action);
          return;
        }
        var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
        var initial = getState();
        if (initial.phase === "DROP_ANIMATING") {
          dispatch(completeDrop2({
            completed: initial.completed,
            shouldFlush: true
          }));
        }
        !(getState().phase === "IDLE") ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Incorrect phase to start a drag") : invariant$2() : void 0;
        var scrollOptions = {
          shouldPublishImmediately: movementMode === "SNAP"
        };
        var request = {
          draggableId: id,
          scrollOptions
        };
        var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
        dispatch(initialPublish2({
          critical,
          dimensions,
          clientSelection,
          movementMode,
          viewport
        }));
      };
    };
  };
};
var style$3 = function(marshal) {
  return function() {
    return function(next2) {
      return function(action) {
        if (action.type === "INITIAL_PUBLISH") {
          marshal.dragging();
        }
        if (action.type === "DROP_ANIMATE") {
          marshal.dropping(action.payload.completed.result.reason);
        }
        if (action.type === "CLEAN" || action.type === "DROP_COMPLETE") {
          marshal.resting();
        }
        next2(action);
      };
    };
  };
};
var curves = {
  outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
  drop: "cubic-bezier(.2,1,.1,1)"
};
var combine = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
};
var timings = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
};
var outOfTheWayTiming = timings.outOfTheWay + "s " + curves.outOfTheWay;
var transitions = {
  fluid: "opacity " + outOfTheWayTiming,
  snap: "transform " + outOfTheWayTiming + ", opacity " + outOfTheWayTiming,
  drop: function drop6(duration) {
    var timing = duration + "s " + curves.drop;
    return "transform " + timing + ", opacity " + timing;
  },
  outOfTheWay: "transform " + outOfTheWayTiming,
  placeholder: "height " + outOfTheWayTiming + ", width " + outOfTheWayTiming + ", margin " + outOfTheWayTiming
};
var moveTo2 = function moveTo3(offset3) {
  return isEqual$1(offset3, origin) ? null : "translate(" + offset3.x + "px, " + offset3.y + "px)";
};
var transforms$1 = {
  moveTo: moveTo2,
  drop: function drop7(offset3, isCombining) {
    var translate = moveTo2(offset3);
    if (!translate) {
      return null;
    }
    if (!isCombining) {
      return translate;
    }
    return translate + " scale(" + combine.scale.drop + ")";
  }
};
var minDropTime = timings.minDropTime, maxDropTime = timings.maxDropTime;
var dropTimeRange = maxDropTime - minDropTime;
var maxDropTimeAtDistance = 1500;
var cancelDropModifier = 0.6;
var getDropDuration = function(_ref) {
  var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
  var distance$12 = distance2(current, destination);
  if (distance$12 <= 0) {
    return minDropTime;
  }
  if (distance$12 >= maxDropTimeAtDistance) {
    return maxDropTime;
  }
  var percentage = distance$12 / maxDropTimeAtDistance;
  var duration = minDropTime + dropTimeRange * percentage;
  var withDuration = reason === "CANCEL" ? duration * cancelDropModifier : duration;
  return Number(withDuration.toFixed(2));
};
var getNewHomeClientOffset = function(_ref) {
  var impact = _ref.impact, draggable2 = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, onLift = _ref.onLift;
  var draggables = dimensions.draggables, droppables = dimensions.droppables;
  var droppableId = whatIsDraggedOver(impact);
  var destination = droppableId ? droppables[droppableId] : null;
  var home2 = droppables[draggable2.descriptor.droppableId];
  var newClientCenter = getClientBorderBoxCenter({
    impact,
    draggable: draggable2,
    draggables,
    onLift,
    droppable: destination || home2,
    viewport
  });
  var offset3 = subtract$3(newClientCenter, draggable2.client.borderBox.center);
  var merge3 = impact.merge;
  if (merge3 && didStartDisplaced(merge3.combine.draggableId, onLift)) {
    return subtract$3(offset3, onLift.displacedBy.point);
  }
  return offset3;
};
var getDropImpact = function(_ref) {
  var reason = _ref.reason, lastImpact = _ref.lastImpact, home2 = _ref.home, viewport = _ref.viewport, draggables = _ref.draggables, onLiftImpact = _ref.onLiftImpact, onLift = _ref.onLift;
  var didDropInsideDroppable = reason === "DROP" && Boolean(whatIsDraggedOver(lastImpact));
  if (!didDropInsideDroppable) {
    var impact = recompute({
      impact: onLiftImpact,
      destination: home2,
      viewport,
      draggables,
      onLift,
      forceShouldAnimate: true
    });
    return {
      impact,
      didDropInsideDroppable
    };
  }
  if (lastImpact.destination) {
    return {
      impact: lastImpact,
      didDropInsideDroppable
    };
  }
  var withoutMovement = _extends$2({}, lastImpact, {
    movement: noMovement
  });
  return {
    impact: withoutMovement,
    didDropInsideDroppable
  };
};
var drop$1 = function(_ref) {
  var getState = _ref.getState, dispatch = _ref.dispatch;
  return function(next2) {
    return function(action) {
      if (action.type !== "DROP") {
        next2(action);
        return;
      }
      var state = getState();
      var reason = action.payload.reason;
      if (state.phase === "COLLECTING") {
        dispatch(dropPending2({
          reason
        }));
        return;
      }
      if (state.phase === "IDLE") {
        return;
      }
      var isWaitingForDrop = state.phase === "DROP_PENDING" && state.isWaiting;
      !!isWaitingForDrop ? process.env.NODE_ENV !== "production" ? invariant$2(false, "A DROP action occurred while DROP_PENDING and still waiting") : invariant$2() : void 0;
      !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot drop in phase: " + state.phase) : invariant$2() : void 0;
      var critical = state.critical;
      var dimensions = state.dimensions;
      var _getDropImpact = getDropImpact({
        reason,
        lastImpact: state.impact,
        onLift: state.onLift,
        onLiftImpact: state.onLiftImpact,
        home: state.dimensions.droppables[state.critical.droppable.id],
        viewport: state.viewport,
        draggables: state.dimensions.draggables
      }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
      var draggable2 = dimensions.draggables[state.critical.draggable.id];
      var destination = didDropInsideDroppable ? impact.destination : null;
      var combine2 = didDropInsideDroppable && impact.merge ? impact.merge.combine : null;
      var source = {
        index: critical.draggable.index,
        droppableId: critical.droppable.id
      };
      var result = {
        draggableId: draggable2.descriptor.id,
        type: draggable2.descriptor.type,
        source,
        reason,
        mode: state.movementMode,
        destination,
        combine: combine2
      };
      var newHomeClientOffset = getNewHomeClientOffset({
        impact,
        draggable: draggable2,
        dimensions,
        viewport: state.viewport,
        onLift: state.onLift
      });
      var completed = {
        critical: state.critical,
        result,
        impact
      };
      var isAnimationRequired = !isEqual$1(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
      if (!isAnimationRequired) {
        dispatch(completeDrop2({
          completed,
          shouldFlush: false
        }));
        return;
      }
      var dropDuration = getDropDuration({
        current: state.current.client.offset,
        destination: newHomeClientOffset,
        reason
      });
      var args = {
        newHomeClientOffset,
        dropDuration,
        completed
      };
      dispatch(animateDrop2(args));
    };
  };
};
var position$2 = function position2(index2) {
  return index2 + 1;
};
var onDragStart2 = function onDragStart3(start4) {
  return "\n  You have lifted an item in position " + position$2(start4.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};
var withLocation2 = function withLocation3(source, destination) {
  var isInHomeList = source.droppableId === destination.droppableId;
  var startPosition = position$2(source.index);
  var endPosition = position$2(destination.index);
  if (isInHomeList) {
    return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
  }
  return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var withCombine2 = function withCombine3(id, source, combine2) {
  var inHomeList = source.droppableId === combine2.droppableId;
  if (inHomeList) {
    return "\n      The item " + id + "\n      has been combined with " + combine2.draggableId;
  }
  return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine2.draggableId + "\n      in list " + combine2.droppableId + "\n    ";
};
var onDragUpdate2 = function onDragUpdate3(update2) {
  var location = update2.destination;
  if (location) {
    return withLocation2(update2.source, location);
  }
  var combine2 = update2.combine;
  if (combine2) {
    return withCombine2(update2.draggableId, update2.source, combine2);
  }
  return "You are over an area that cannot be dropped on";
};
var returnedToStart2 = function returnedToStart3(source) {
  return "\n  The item has returned to its starting position\n  of " + position$2(source.index) + "\n";
};
var onDragEnd2 = function onDragEnd3(result) {
  if (result.reason === "CANCEL") {
    return "\n      Movement cancelled.\n      " + returnedToStart2(result.source) + "\n    ";
  }
  var location = result.destination;
  var combine2 = result.combine;
  if (location) {
    return "\n      You have dropped the item.\n      " + withLocation2(result.source, location) + "\n    ";
  }
  if (combine2) {
    return "\n      You have dropped the item.\n      " + withCombine2(result.draggableId, result.source, combine2) + "\n    ";
  }
  return "\n    The item has been dropped while not over a drop area.\n    " + returnedToStart2(result.source) + "\n  ";
};
var preset = {
  onDragStart: onDragStart2,
  onDragUpdate: onDragUpdate2,
  onDragEnd: onDragEnd2
};
var getExpiringAnnounce = function(announce2) {
  var wasCalled = false;
  var isExpired = false;
  var timeoutId = setTimeout(function() {
    isExpired = true;
  });
  var result = function result2(message2) {
    if (wasCalled) {
      process.env.NODE_ENV !== "production" ? warning$1("Announcement already made. Not making a second announcement") : void 0;
      return;
    }
    if (isExpired) {
      process.env.NODE_ENV !== "production" ? warning$1("\n        Announcements cannot be made asynchronously.\n        Default message has already been announced.\n      ") : void 0;
      return;
    }
    wasCalled = true;
    announce2(message2);
    clearTimeout(timeoutId);
  };
  result.wasCalled = function() {
    return wasCalled;
  };
  return result;
};
var getAsyncMarshal = function() {
  var entries = [];
  var execute4 = function execute5(timerId) {
    var index2 = findIndex(entries, function(item) {
      return item.timerId === timerId;
    });
    !(index2 !== -1) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Could not find timer") : invariant$2() : void 0;
    var _entries$splice = entries.splice(index2, 1), entry = _entries$splice[0];
    entry.callback();
  };
  var add4 = function add5(fn2) {
    var timerId = setTimeout(function() {
      return execute4(timerId);
    });
    var entry = {
      timerId,
      callback: fn2
    };
    entries.push(entry);
  };
  var flush3 = function flush4() {
    if (!entries.length) {
      return;
    }
    var shallow = [].concat(entries);
    entries.length = 0;
    shallow.forEach(function(entry) {
      clearTimeout(entry.timerId);
      entry.callback();
    });
  };
  return {
    add: add4,
    flush: flush3
  };
};
var areLocationsEqual2 = function areLocationsEqual3(first2, second) {
  if (first2 == null && second == null) {
    return true;
  }
  if (first2 == null || second == null) {
    return false;
  }
  return first2.droppableId === second.droppableId && first2.index === second.index;
};
var isCombineEqual2 = function isCombineEqual3(first2, second) {
  if (first2 == null && second == null) {
    return true;
  }
  if (first2 == null || second == null) {
    return false;
  }
  return first2.draggableId === second.draggableId && first2.droppableId === second.droppableId;
};
var isCriticalEqual2 = function isCriticalEqual3(first2, second) {
  if (first2 === second) {
    return true;
  }
  var isDraggableEqual = first2.draggable.id === second.draggable.id && first2.draggable.droppableId === second.draggable.droppableId && first2.draggable.type === second.draggable.type && first2.draggable.index === second.draggable.index;
  var isDroppableEqual = first2.droppable.id === second.droppable.id && first2.droppable.type === second.droppable.type;
  return isDraggableEqual && isDroppableEqual;
};
var withTimings2 = function withTimings3(key2, fn2) {
  start2();
  fn2();
  finish2();
};
var getDragStart2 = function getDragStart3(critical, mode) {
  return {
    draggableId: critical.draggable.id,
    type: critical.droppable.type,
    source: {
      droppableId: critical.droppable.id,
      index: critical.draggable.index
    },
    mode
  };
};
var execute2 = function execute3(responder, data, announce2, getDefaultMessage) {
  if (!responder) {
    announce2(getDefaultMessage(data));
    return;
  }
  var willExpire = getExpiringAnnounce(announce2);
  var provided = {
    announce: willExpire
  };
  responder(data, provided);
  if (!willExpire.wasCalled()) {
    announce2(getDefaultMessage(data));
  }
};
var getPublisher = function(getResponders, announce2) {
  var asyncMarshal = getAsyncMarshal();
  var dragging = null;
  var beforeStart = function beforeStart2(critical, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot fire onBeforeDragStart as a drag start has already been published") : invariant$2() : void 0;
    withTimings2("onBeforeDragStart", function() {
      var fn2 = getResponders().onBeforeDragStart;
      if (fn2) {
        fn2(getDragStart2(critical, mode));
      }
    });
  };
  var start4 = function start5(critical, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot fire onBeforeDragStart as a drag start has already been published") : invariant$2() : void 0;
    var data = getDragStart2(critical, mode);
    dragging = {
      mode,
      lastCritical: critical,
      lastLocation: data.source,
      lastCombine: null
    };
    asyncMarshal.add(function() {
      withTimings2("onDragStart", function() {
        return execute2(getResponders().onDragStart, data, announce2, preset.onDragStart);
      });
    });
  };
  var update2 = function update3(critical, impact) {
    var location = impact.destination;
    var combine2 = impact.merge ? impact.merge.combine : null;
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot fire onDragMove when onDragStart has not been called") : invariant$2() : void 0;
    var hasCriticalChanged = !isCriticalEqual2(critical, dragging.lastCritical);
    if (hasCriticalChanged) {
      dragging.lastCritical = critical;
    }
    var hasLocationChanged = !areLocationsEqual2(dragging.lastLocation, location);
    if (hasLocationChanged) {
      dragging.lastLocation = location;
    }
    var hasGroupingChanged = !isCombineEqual2(dragging.lastCombine, combine2);
    if (hasGroupingChanged) {
      dragging.lastCombine = combine2;
    }
    if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) {
      return;
    }
    var data = _extends$2({}, getDragStart2(critical, dragging.mode), {
      combine: combine2,
      destination: location
    });
    asyncMarshal.add(function() {
      withTimings2("onDragUpdate", function() {
        return execute2(getResponders().onDragUpdate, data, announce2, preset.onDragUpdate);
      });
    });
  };
  var flush3 = function flush4() {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Can only flush responders while dragging") : invariant$2() : void 0;
    asyncMarshal.flush();
  };
  var drop8 = function drop9(result) {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot fire onDragEnd when there is no matching onDragStart") : invariant$2() : void 0;
    dragging = null;
    withTimings2("onDragEnd", function() {
      return execute2(getResponders().onDragEnd, result, announce2, preset.onDragEnd);
    });
  };
  var abort = function abort2() {
    if (!dragging) {
      return;
    }
    var result = _extends$2({}, getDragStart2(dragging.lastCritical, dragging.mode), {
      combine: null,
      destination: null,
      reason: "CANCEL"
    });
    drop8(result);
  };
  return {
    beforeStart,
    start: start4,
    update: update2,
    flush: flush3,
    drop: drop8,
    abort
  };
};
var responders = function(getResponders, announce2) {
  var publisher = getPublisher(getResponders, announce2);
  return function(store) {
    return function(next2) {
      return function(action) {
        if (action.type === "INITIAL_PUBLISH") {
          var critical = action.payload.critical;
          publisher.beforeStart(critical, action.payload.movementMode);
          next2(action);
          publisher.start(critical, action.payload.movementMode);
          return;
        }
        if (action.type === "DROP_COMPLETE") {
          var result = action.payload.completed.result;
          publisher.flush();
          next2(action);
          publisher.drop(result);
          return;
        }
        next2(action);
        if (action.type === "CLEAN") {
          publisher.abort();
          return;
        }
        var state = store.getState();
        if (state.phase === "DRAGGING") {
          publisher.update(state.critical, state.impact);
        }
      };
    };
  };
};
var dropAnimationFinish = function(store) {
  return function(next2) {
    return function(action) {
      if (action.type !== "DROP_ANIMATION_FINISHED") {
        next2(action);
        return;
      }
      var state = store.getState();
      !(state.phase === "DROP_ANIMATING") ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot finish a drop animating when no drop is occurring") : invariant$2() : void 0;
      store.dispatch(completeDrop2({
        completed: state.completed,
        shouldFlush: false
      }));
    };
  };
};
var dimensionMarshalStopper = function(marshal) {
  return function() {
    return function(next2) {
      return function(action) {
        if (action.type === "DROP_COMPLETE" || action.type === "CLEAN" || action.type === "DROP_ANIMATE") {
          marshal.stopPublishing();
        }
        next2(action);
      };
    };
  };
};
var shouldEnd2 = function shouldEnd3(action) {
  return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "CLEAN";
};
var shouldCancelPending = function shouldCancelPending2(action) {
  return action.type === "COLLECTION_STARTING";
};
var autoScroll = function(autoScroller) {
  return function(store) {
    return function(next2) {
      return function(action) {
        if (shouldEnd2(action)) {
          autoScroller.stop();
          next2(action);
          return;
        }
        if (shouldCancelPending(action)) {
          autoScroller.cancelPending();
          next2(action);
          return;
        }
        if (action.type === "INITIAL_PUBLISH") {
          next2(action);
          var state = store.getState();
          !(state.phase === "DRAGGING") ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Expected phase to be DRAGGING after INITIAL_PUBLISH") : invariant$2() : void 0;
          autoScroller.start(state);
          return;
        }
        next2(action);
        autoScroller.scroll(store.getState());
      };
    };
  };
};
var pendingDrop = function(store) {
  return function(next2) {
    return function(action) {
      next2(action);
      if (action.type !== "PUBLISH_WHILE_DRAGGING") {
        return;
      }
      var postActionState = store.getState();
      if (postActionState.phase !== "DROP_PENDING") {
        return;
      }
      if (postActionState.isWaiting) {
        return;
      }
      store.dispatch(drop4({
        reason: postActionState.reason
      }));
    };
  };
};
var composeEnhancers = process.env.NODE_ENV !== "production" && typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose$2;
var createStore = function(_ref) {
  var dimensionMarshal = _ref.dimensionMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce2 = _ref.announce, autoScroller = _ref.autoScroller;
  return createStore$2(reducer$2, composeEnhancers(applyMiddleware(style$3(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift$1$1(dimensionMarshal), drop$1, dropAnimationFinish, pendingDrop, autoScroll(autoScroller), responders(getResponders, announce2))));
};
var clean$2 = function clean6() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
var createPublisher = function(_ref) {
  var getEntries = _ref.getEntries, callbacks = _ref.callbacks;
  var advancedUsageWarning = function() {
    if (process.env.NODE_ENV === "production") {
      return function() {
      };
    }
    var hasAnnounced = false;
    return function() {
      if (hasAnnounced) {
        return;
      }
      hasAnnounced = true;
      process.env.NODE_ENV !== "production" ? warning$1("\n        Advanced usage warning: you are adding or removing a dimension during a drag\n        This an advanced feature.\n\n        More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/changes-while-dragging.md\n      ") : void 0;
    };
  }();
  var staging = clean$2();
  var frameId = null;
  var collect = function collect2() {
    advancedUsageWarning();
    if (frameId) {
      return;
    }
    frameId = requestAnimationFrame(function() {
      frameId = null;
      callbacks.collectionStarting();
      var critical = callbacks.getCritical();
      start2();
      var entries = getEntries();
      var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
      var added = _Object$keys(additions).map(function(id) {
        return entries.draggables[id].getDimension(origin);
      }).sort(function(a2, b2) {
        return a2.descriptor.index - b2.descriptor.index;
      });
      var updated = _Object$keys(modified).map(function(id) {
        var entry = entries.droppables[id];
        !entry ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot find dynamically added droppable in cache") : invariant$2() : void 0;
        var isHome = entry.descriptor.id === critical.droppable.id;
        var options = {
          withoutPlaceholder: !isHome
        };
        return entry.callbacks.recollect(options);
      });
      var result = {
        additions: added,
        removals: _Object$keys(removals),
        modified: updated
      };
      staging = clean$2();
      finish2();
      callbacks.publish(result);
    });
  };
  var add4 = function add5(descriptor) {
    staging.additions[descriptor.id] = descriptor;
    staging.modified[descriptor.droppableId] = true;
    if (staging.removals[descriptor.id]) {
      delete staging.removals[descriptor.id];
    }
    collect();
  };
  var remove = function remove2(descriptor) {
    staging.removals[descriptor.id] = descriptor;
    staging.modified[descriptor.droppableId] = true;
    if (staging.additions[descriptor.id]) {
      delete staging.additions[descriptor.id];
    }
    collect();
  };
  var stop = function stop2() {
    if (!frameId) {
      return;
    }
    cancelAnimationFrame(frameId);
    frameId = null;
    staging = clean$2();
  };
  return {
    add: add4,
    remove,
    stop
  };
};
var getWindowScroll2 = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};
var getDocumentElement = function() {
  var doc2 = document.documentElement;
  !doc2 ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot find document.documentElement") : invariant$2() : void 0;
  return doc2;
};
var getMaxWindowScroll = function() {
  var doc2 = getDocumentElement();
  var maxScroll = getMaxScroll({
    scrollHeight: doc2.scrollHeight,
    scrollWidth: doc2.scrollWidth,
    width: doc2.clientWidth,
    height: doc2.clientHeight
  });
  return maxScroll;
};
var getViewport = function() {
  var scroll4 = getWindowScroll2();
  var maxScroll = getMaxWindowScroll();
  var top2 = scroll4.y;
  var left2 = scroll4.x;
  var doc2 = getDocumentElement();
  var width2 = doc2.clientWidth;
  var height2 = doc2.clientHeight;
  var right2 = left2 + width2;
  var bottom2 = top2 + height2;
  var frame = getRect({
    top: top2,
    left: left2,
    right: right2,
    bottom: bottom2
  });
  var viewport = {
    frame,
    scroll: {
      initial: scroll4,
      current: scroll4,
      max: maxScroll,
      diff: {
        value: origin,
        displacement: origin
      }
    }
  };
  return viewport;
};
var getInitialPublish = function(_ref) {
  var critical = _ref.critical, scrollOptions = _ref.scrollOptions, entries = _ref.entries;
  start2();
  var viewport = getViewport();
  var windowScroll = viewport.scroll.current;
  var home2 = critical.droppable;
  var droppables = values(entries.droppables).filter(function(entry) {
    return entry.descriptor.type === home2.type;
  }).map(function(entry) {
    return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
  });
  var draggables = values(entries.draggables).filter(function(entry) {
    return entry.descriptor.type === critical.draggable.type;
  }).map(function(entry) {
    return entry.getDimension(windowScroll);
  });
  var dimensions = {
    draggables: toDraggableMap(draggables),
    droppables: toDroppableMap(droppables)
  };
  finish2();
  var result = {
    dimensions,
    critical,
    viewport
  };
  return result;
};
var throwIfAddOrRemoveOfWrongType = function throwIfAddOrRemoveOfWrongType2(collection, descriptor) {
  !(collection.critical.draggable.type === descriptor.type) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "We have detected that you have added a Draggable during a drag.\n      This is not of the same type as the dragging item\n\n      Dragging type: " + collection.critical.draggable.type + ".\n      Added type: " + descriptor.type + "\n\n      We are not allowing this as you can run into problems if your change\n      has shifted the positioning of other Droppables, or has changed the size of the page") : invariant$2() : void 0;
};
var createDimensionMarshal = function(callbacks) {
  var entries = {
    droppables: {},
    draggables: {}
  };
  var collection = null;
  var publisher = createPublisher({
    callbacks: {
      publish: callbacks.publishWhileDragging,
      collectionStarting: callbacks.collectionStarting,
      getCritical: function getCritical() {
        !collection ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot get critical when there is no collection") : invariant$2() : void 0;
        return collection.critical;
      }
    },
    getEntries: function getEntries() {
      return entries;
    }
  });
  var registerDraggable = function registerDraggable2(descriptor, getDimension2) {
    var entry = {
      descriptor,
      getDimension: getDimension2
    };
    entries.draggables[descriptor.id] = entry;
    if (!collection) {
      return;
    }
    throwIfAddOrRemoveOfWrongType(collection, descriptor);
    publisher.add(descriptor);
  };
  var updateDraggable = function updateDraggable2(published, descriptor, getDimension2) {
    var existing = entries.draggables[published.id];
    !existing ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot update draggable registration as no published registration was found") : invariant$2() : void 0;
    if (existing.descriptor === published) {
      delete entries.draggables[published.id];
    } else {
      process.env.NODE_ENV !== "production" ? warning$1(`
        Detected incorrect usage of 'key' on '<Draggable draggableId="` + published.id + `"$ />

        Your 'key' should be:
        - Unique for each Draggable in a list
        - Not be based on the index of the Draggable

        Usually you want your 'key' to just be the 'draggableId'

        More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/draggable.md#keys-for-a-list-of-draggable-
      `) : void 0;
    }
    var entry = {
      descriptor,
      getDimension: getDimension2
    };
    entries.draggables[descriptor.id] = entry;
  };
  var unregisterDraggable = function unregisterDraggable2(descriptor) {
    var entry = entries.draggables[descriptor.id];
    !entry ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot unregister Draggable with id:\n      " + descriptor.id + " as it is not registered") : invariant$2() : void 0;
    if (entry.descriptor !== descriptor) {
      return;
    }
    delete entries.draggables[descriptor.id];
    if (!collection) {
      return;
    }
    !(collection.critical.draggable.id !== descriptor.id) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot remove the dragging item during a drag") : invariant$2() : void 0;
    throwIfAddOrRemoveOfWrongType(collection, descriptor);
    publisher.remove(descriptor);
  };
  var registerDroppable = function registerDroppable2(descriptor, droppableCallbacks) {
    var id = descriptor.id;
    entries.droppables[id] = {
      descriptor,
      callbacks: droppableCallbacks
    };
    !!collection ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot add a Droppable during a drag") : invariant$2() : void 0;
  };
  var unregisterDroppable = function unregisterDroppable2(descriptor) {
    var entry = entries.droppables[descriptor.id];
    !entry ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot unregister Droppable with id " + descriptor.id + " as as it is not registered") : invariant$2() : void 0;
    if (entry.descriptor !== descriptor) {
      return;
    }
    delete entries.droppables[descriptor.id];
    !!collection ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot add a Droppable during a drag") : invariant$2() : void 0;
  };
  var updateDroppableIsEnabled4 = function updateDroppableIsEnabled5(id, isEnabled) {
    !entries.droppables[id] ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot update is enabled flag of Droppable " + id + " as it is not registered") : invariant$2() : void 0;
    if (!collection) {
      return;
    }
    callbacks.updateDroppableIsEnabled({
      id,
      isEnabled
    });
  };
  var updateDroppableIsCombineEnabled4 = function updateDroppableIsCombineEnabled5(id, isCombineEnabled) {
    !entries.droppables[id] ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot update isCombineEnabled flag of Droppable " + id + " as it is not registered") : invariant$2() : void 0;
    if (!collection) {
      return;
    }
    callbacks.updateDroppableIsCombineEnabled({
      id,
      isCombineEnabled
    });
  };
  var updateDroppableScroll4 = function updateDroppableScroll5(id, newScroll) {
    !entries.droppables[id] ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot update the scroll on Droppable " + id + " as it is not registered") : invariant$2() : void 0;
    if (!collection) {
      return;
    }
    callbacks.updateDroppableScroll({
      id,
      offset: newScroll
    });
  };
  var scrollDroppable2 = function scrollDroppable3(id, change) {
    var entry = entries.droppables[id];
    !entry ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot scroll Droppable " + id + " as it is not registered") : invariant$2() : void 0;
    if (!collection) {
      return;
    }
    entry.callbacks.scroll(change);
  };
  var stopPublishing = function stopPublishing2() {
    if (!collection) {
      return;
    }
    publisher.stop();
    var home2 = collection.critical.droppable;
    values(entries.droppables).filter(function(entry) {
      return entry.descriptor.type === home2.type;
    }).forEach(function(entry) {
      return entry.callbacks.dragStopped();
    });
    collection = null;
  };
  var startPublishing = function startPublishing2(request) {
    !!collection ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot start capturing critical dimensions as there is already a collection") : invariant$2() : void 0;
    var entry = entries.draggables[request.draggableId];
    !entry ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot find critical draggable entry") : invariant$2() : void 0;
    var home2 = entries.droppables[entry.descriptor.droppableId];
    !home2 ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot find critical droppable entry") : invariant$2() : void 0;
    var critical = {
      draggable: entry.descriptor,
      droppable: home2.descriptor
    };
    collection = {
      critical
    };
    return getInitialPublish({
      critical,
      entries,
      scrollOptions: request.scrollOptions
    });
  };
  var marshal = {
    registerDraggable,
    updateDraggable,
    unregisterDraggable,
    registerDroppable,
    unregisterDroppable,
    updateDroppableIsEnabled: updateDroppableIsEnabled4,
    updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled4,
    scrollDroppable: scrollDroppable2,
    updateDroppableScroll: updateDroppableScroll4,
    startPublishing,
    stopPublishing
  };
  return marshal;
};
var canStartDrag = function(state, id) {
  if (state.phase === "IDLE") {
    return true;
  }
  if (state.phase !== "DROP_ANIMATING") {
    return false;
  }
  if (state.completed.result.draggableId === id) {
    return false;
  }
  return state.completed.result.reason === "DROP";
};
var scrollWindow = function(change) {
  window.scrollBy(change.x, change.y);
};
var getScrollableDroppables = memoizeOne(function(droppables) {
  return toDroppableList(droppables).filter(function(droppable2) {
    if (!droppable2.isEnabled) {
      return false;
    }
    if (!droppable2.frame) {
      return false;
    }
    return true;
  });
});
var getScrollableDroppableOver2 = function getScrollableDroppableOver3(target, droppables) {
  var maybe = find$2(getScrollableDroppables(droppables), function(droppable2) {
    !droppable2.frame ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Invalid result") : invariant$2() : void 0;
    return isPositionInFrame(droppable2.frame.pageMarginBox)(target);
  });
  return maybe;
};
var getBestScrollableDroppable = function(_ref) {
  var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
  if (destination) {
    var _dimension = droppables[destination];
    if (!_dimension.frame) {
      return null;
    }
    return _dimension;
  }
  var dimension = getScrollableDroppableOver2(center, droppables);
  return dimension;
};
var config$8 = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function ease2(percentage) {
    return Math.pow(percentage, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
};
var getDistanceThresholds = function(container, axis) {
  var startScrollingFrom = container[axis.size] * config$8.startFromPercentage;
  var maxScrollValueAt = container[axis.size] * config$8.maxScrollAtPercentage;
  var thresholds2 = {
    startScrollingFrom,
    maxScrollValueAt
  };
  return thresholds2;
};
var getPercentage = function(_ref) {
  var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
  var range = endOfRange - startOfRange;
  if (range === 0) {
    process.env.NODE_ENV !== "production" ? warning$1("\n      Detected distance range of 0 in the fluid auto scroller\n      This is unexpected and would cause a divide by 0 issue.\n      Not allowing an auto scroll\n    ") : void 0;
    return 0;
  }
  var currentInRange = current - startOfRange;
  var percentage = currentInRange / range;
  return percentage;
};
var minScroll = 1;
var getValueFromDistance = function(distanceToEdge, thresholds2) {
  if (distanceToEdge > thresholds2.startScrollingFrom) {
    return 0;
  }
  if (distanceToEdge <= thresholds2.maxScrollValueAt) {
    return config$8.maxPixelScroll;
  }
  if (distanceToEdge === thresholds2.startScrollingFrom) {
    return minScroll;
  }
  var percentageFromMaxScrollValueAt = getPercentage({
    startOfRange: thresholds2.maxScrollValueAt,
    endOfRange: thresholds2.startScrollingFrom,
    current: distanceToEdge
  });
  var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
  var scroll4 = config$8.maxPixelScroll * config$8.ease(percentageFromStartScrollingFrom);
  return Math.ceil(scroll4);
};
var accelerateAt = config$8.durationDampening.accelerateAt;
var stopAt = config$8.durationDampening.stopDampeningAt;
var dampenValueByTime = function(proposedScroll, dragStartTime) {
  var startOfRange = dragStartTime;
  var endOfRange = stopAt;
  var now2 = _Date$now();
  var runTime = now2 - startOfRange;
  if (runTime >= stopAt) {
    return proposedScroll;
  }
  if (runTime < accelerateAt) {
    return minScroll;
  }
  var betweenAccelerateAtAndStopAtPercentage = getPercentage({
    startOfRange: accelerateAt,
    endOfRange,
    current: runTime
  });
  var scroll4 = proposedScroll * config$8.ease(betweenAccelerateAtAndStopAtPercentage);
  return Math.ceil(scroll4);
};
var getValue$1 = function(_ref) {
  var distanceToEdge = _ref.distanceToEdge, thresholds2 = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll4 = getValueFromDistance(distanceToEdge, thresholds2);
  if (scroll4 === 0) {
    return 0;
  }
  if (!shouldUseTimeDampening) {
    return scroll4;
  }
  return Math.max(dampenValueByTime(scroll4, dragStartTime), minScroll);
};
var getScrollOnAxis = function(_ref) {
  var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var thresholds2 = getDistanceThresholds(container, axis);
  var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
  if (isCloserToEnd) {
    return getValue$1({
      distanceToEdge: distanceToEdges[axis.end],
      thresholds: thresholds2,
      dragStartTime,
      shouldUseTimeDampening
    });
  }
  return -1 * getValue$1({
    distanceToEdge: distanceToEdges[axis.start],
    thresholds: thresholds2,
    dragStartTime,
    shouldUseTimeDampening
  });
};
var adjustForSizeLimits = function(_ref) {
  var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
  var isTooBigVertically = subject.height > container.height;
  var isTooBigHorizontally = subject.width > container.width;
  if (!isTooBigHorizontally && !isTooBigVertically) {
    return proposedScroll;
  }
  if (isTooBigHorizontally && isTooBigVertically) {
    return null;
  }
  return {
    x: isTooBigHorizontally ? 0 : proposedScroll.x,
    y: isTooBigVertically ? 0 : proposedScroll.y
  };
};
var clean$3 = apply$2(function(value) {
  return value === 0 ? 0 : value;
});
var getScroll = function(_ref) {
  var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var distanceToEdges = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };
  var y2 = getScrollOnAxis({
    container,
    distanceToEdges,
    dragStartTime,
    axis: vertical,
    shouldUseTimeDampening
  });
  var x2 = getScrollOnAxis({
    container,
    distanceToEdges,
    dragStartTime,
    axis: horizontal,
    shouldUseTimeDampening
  });
  var required2 = clean$3({
    x: x2,
    y: y2
  });
  if (isEqual$1(required2, origin)) {
    return null;
  }
  var limited = adjustForSizeLimits({
    container,
    subject,
    proposedScroll: required2
  });
  if (!limited) {
    return null;
  }
  return isEqual$1(limited, origin) ? null : limited;
};
var smallestSigned = apply$2(function(value) {
  if (value === 0) {
    return 0;
  }
  return value > 0 ? 1 : -1;
});
var getOverlap = /* @__PURE__ */ function() {
  var getRemainder = function getRemainder2(target, max2) {
    if (target < 0) {
      return target;
    }
    if (target > max2) {
      return target - max2;
    }
    return 0;
  };
  return function(_ref) {
    var current = _ref.current, max2 = _ref.max, change = _ref.change;
    var targetScroll = add$3(current, change);
    var overlap = {
      x: getRemainder(targetScroll.x, max2.x),
      y: getRemainder(targetScroll.y, max2.y)
    };
    if (isEqual$1(overlap, origin)) {
      return null;
    }
    return overlap;
  };
}();
var canPartiallyScroll2 = function canPartiallyScroll3(_ref2) {
  var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
  var max2 = {
    x: Math.max(current.x, rawMax.x),
    y: Math.max(current.y, rawMax.y)
  };
  var smallestChange = smallestSigned(change);
  var overlap = getOverlap({
    max: max2,
    current,
    change: smallestChange
  });
  if (!overlap) {
    return true;
  }
  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }
  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }
  return false;
};
var canScrollWindow2 = function canScrollWindow3(viewport, change) {
  return canPartiallyScroll2({
    current: viewport.scroll.current,
    max: viewport.scroll.max,
    change
  });
};
var getWindowOverlap2 = function getWindowOverlap3(viewport, change) {
  if (!canScrollWindow2(viewport, change)) {
    return null;
  }
  var max2 = viewport.scroll.max;
  var current = viewport.scroll.current;
  return getOverlap({
    current,
    max: max2,
    change
  });
};
var canScrollDroppable2 = function canScrollDroppable3(droppable2, change) {
  var frame = droppable2.frame;
  if (!frame) {
    return false;
  }
  return canPartiallyScroll2({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change
  });
};
var getDroppableOverlap2 = function getDroppableOverlap3(droppable2, change) {
  var frame = droppable2.frame;
  if (!frame) {
    return null;
  }
  if (!canScrollDroppable2(droppable2, change)) {
    return null;
  }
  return getOverlap({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change
  });
};
var getWindowScrollChange = function(_ref) {
  var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll4 = getScroll({
    dragStartTime,
    container: viewport.frame,
    subject,
    center,
    shouldUseTimeDampening
  });
  return scroll4 && canScrollWindow2(viewport, scroll4) ? scroll4 : null;
};
var getDroppableScrollChange = function(_ref) {
  var droppable2 = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var frame = droppable2.frame;
  if (!frame) {
    return null;
  }
  var scroll4 = getScroll({
    dragStartTime,
    container: frame.pageMarginBox,
    subject,
    center,
    shouldUseTimeDampening
  });
  return scroll4 && canScrollDroppable2(droppable2, scroll4) ? scroll4 : null;
};
var scroll$1 = function(_ref) {
  var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow2 = _ref.scrollWindow, scrollDroppable2 = _ref.scrollDroppable;
  var center = state.current.page.borderBoxCenter;
  var draggable2 = state.dimensions.draggables[state.critical.draggable.id];
  var subject = draggable2.page.marginBox;
  if (state.isWindowScrollAllowed) {
    var viewport = state.viewport;
    var _change = getWindowScrollChange({
      dragStartTime,
      viewport,
      subject,
      center,
      shouldUseTimeDampening
    });
    if (_change) {
      scrollWindow2(_change);
      return;
    }
  }
  var droppable2 = getBestScrollableDroppable({
    center,
    destination: whatIsDraggedOver(state.impact),
    droppables: state.dimensions.droppables
  });
  if (!droppable2) {
    return;
  }
  var change = getDroppableScrollChange({
    dragStartTime,
    droppable: droppable2,
    subject,
    center,
    shouldUseTimeDampening
  });
  if (change) {
    scrollDroppable2(droppable2.descriptor.id, change);
  }
};
var createFluidScroller = function(_ref) {
  var scrollWindow2 = _ref.scrollWindow, scrollDroppable2 = _ref.scrollDroppable;
  var scheduleWindowScroll = rafSchd(scrollWindow2);
  var scheduleDroppableScroll = rafSchd(scrollDroppable2);
  var dragging = null;
  var tryScroll = function tryScroll2(state) {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot fluid scroll if not dragging") : invariant$2() : void 0;
    var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
    scroll$1({
      state,
      scrollWindow: scheduleWindowScroll,
      scrollDroppable: scheduleDroppableScroll,
      dragStartTime,
      shouldUseTimeDampening
    });
  };
  var cancelPending = function cancelPending2() {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot cancel pending fluid scroll when not started") : invariant$2() : void 0;
    scheduleWindowScroll.cancel();
    scheduleDroppableScroll.cancel();
  };
  var start$12 = function start$13(state) {
    start2();
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot start auto scrolling when already started") : invariant$2() : void 0;
    var dragStartTime = _Date$now();
    var wasScrollNeeded = false;
    var fakeScrollCallback = function fakeScrollCallback2() {
      wasScrollNeeded = true;
    };
    scroll$1({
      state,
      dragStartTime: 0,
      shouldUseTimeDampening: false,
      scrollWindow: fakeScrollCallback,
      scrollDroppable: fakeScrollCallback
    });
    dragging = {
      dragStartTime,
      shouldUseTimeDampening: wasScrollNeeded
    };
    finish2();
    if (wasScrollNeeded) {
      tryScroll(state);
    }
  };
  var stop = function stop2() {
    if (!dragging) {
      return;
    }
    cancelPending();
    dragging = null;
  };
  return {
    start: start$12,
    stop,
    cancelPending,
    scroll: tryScroll
  };
};
var createJumpScroller = function(_ref) {
  var move4 = _ref.move, scrollDroppable2 = _ref.scrollDroppable, scrollWindow2 = _ref.scrollWindow;
  var moveByOffset = function moveByOffset2(state, offset3) {
    var client2 = add$3(state.current.client.selection, offset3);
    move4({
      client: client2
    });
  };
  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan2(droppable2, change) {
    if (!canScrollDroppable2(droppable2, change)) {
      return change;
    }
    var overlap = getDroppableOverlap2(droppable2, change);
    if (!overlap) {
      scrollDroppable2(droppable2.descriptor.id, change);
      return null;
    }
    var whatTheDroppableCanScroll = subtract$3(change, overlap);
    scrollDroppable2(droppable2.descriptor.id, whatTheDroppableCanScroll);
    var remainder = subtract$3(change, whatTheDroppableCanScroll);
    return remainder;
  };
  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan2(isWindowScrollAllowed, viewport, change) {
    if (!isWindowScrollAllowed) {
      return change;
    }
    if (!canScrollWindow2(viewport, change)) {
      return change;
    }
    var overlap = getWindowOverlap2(viewport, change);
    if (!overlap) {
      scrollWindow2(change);
      return null;
    }
    var whatTheWindowCanScroll = subtract$3(change, overlap);
    scrollWindow2(whatTheWindowCanScroll);
    var remainder = subtract$3(change, whatTheWindowCanScroll);
    return remainder;
  };
  var jumpScroller = function jumpScroller2(state) {
    var request = state.scrollJumpRequest;
    if (!request) {
      return;
    }
    var destination = whatIsDraggedOver(state.impact);
    !destination ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot perform a jump scroll when there is no destination") : invariant$2() : void 0;
    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
    if (!droppableRemainder) {
      return;
    }
    var viewport = state.viewport;
    var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
    if (!windowRemainder) {
      return;
    }
    moveByOffset(state, windowRemainder);
  };
  return jumpScroller;
};
var createAutoScroller = function(_ref) {
  var scrollDroppable2 = _ref.scrollDroppable, scrollWindow2 = _ref.scrollWindow, move4 = _ref.move;
  var fluidScroller = createFluidScroller({
    scrollWindow: scrollWindow2,
    scrollDroppable: scrollDroppable2
  });
  var jumpScroll = createJumpScroller({
    move: move4,
    scrollWindow: scrollWindow2,
    scrollDroppable: scrollDroppable2
  });
  var scroll4 = function scroll5(state) {
    if (state.phase !== "DRAGGING") {
      return;
    }
    if (state.movementMode === "FLUID") {
      fluidScroller.scroll(state);
      return;
    }
    if (!state.scrollJumpRequest) {
      return;
    }
    jumpScroll(state);
  };
  var scroller = {
    scroll: scroll4,
    cancelPending: fluidScroller.cancelPending,
    start: fluidScroller.start,
    stop: fluidScroller.stop
  };
  return scroller;
};
var prefix = "data-react-beautiful-dnd";
var dragHandle = prefix + "-drag-handle";
var draggable = prefix + "-draggable";
var droppable = prefix + "-droppable";
var makeGetSelector2 = function makeGetSelector3(context) {
  return function(attribute) {
    return "[" + attribute + '="' + context + '"]';
  };
};
var getStyles$1 = function getStyles2(rules, property) {
  return rules.map(function(rule) {
    var value = rule.styles[property];
    if (!value) {
      return "";
    }
    return rule.selector + " { " + value + " }";
  }).join(" ");
};
var noPointerEvents = "pointer-events: none;";
var getStyles$1$1 = function(uniqueContext) {
  var getSelector2 = makeGetSelector2(uniqueContext);
  var dragHandle$12 = function() {
    var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
    return {
      selector: getSelector2(dragHandle),
      styles: {
        always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
        resting: grabCursor,
        dragging: noPointerEvents,
        dropAnimating: grabCursor
      }
    };
  }();
  var draggable$12 = function() {
    var transition = "\n      transition: " + transitions.outOfTheWay + ";\n    ";
    return {
      selector: getSelector2(draggable),
      styles: {
        dragging: transition,
        dropAnimating: transition,
        userCancel: transition
      }
    };
  }();
  var droppable$12 = {
    selector: getSelector2(droppable),
    styles: {
      always: "overflow-anchor: none;"
    }
  };
  var body = {
    selector: "body",
    styles: {
      dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
    }
  };
  var rules = [draggable$12, dragHandle$12, droppable$12, body];
  return {
    always: getStyles$1(rules, "always"),
    resting: getStyles$1(rules, "resting"),
    dragging: getStyles$1(rules, "dragging"),
    dropAnimating: getStyles$1(rules, "dropAnimating"),
    userCancel: getStyles$1(rules, "userCancel")
  };
};
var useIsomorphicLayoutEffect$3 = typeof window !== "undefined" ? useLayoutEffect : useEffect;
var getHead2 = function getHead3() {
  var head = document.querySelector("head");
  !head ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot find the head to append a style to") : invariant$2() : void 0;
  return head;
};
var createStyleEl2 = function createStyleEl3() {
  var el = document.createElement("style");
  el.type = "text/css";
  return el;
};
function useStyleMarshal(uniqueId2) {
  var uniqueContext = useMemo(function() {
    return "" + uniqueId2;
  }, [uniqueId2]);
  var styles2 = useMemo(function() {
    return getStyles$1$1(uniqueContext);
  }, [uniqueContext]);
  var alwaysRef = useRef(null);
  var dynamicRef = useRef(null);
  var setDynamicStyle = useCallback(memoizeOne(function(proposed) {
    var el = dynamicRef.current;
    !el ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot set dynamic style element if it is not set") : invariant$2() : void 0;
    el.textContent = proposed;
  }), []);
  var setAlwaysStyle = useCallback(function(proposed) {
    var el = alwaysRef.current;
    !el ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot set dynamic style element if it is not set") : invariant$2() : void 0;
    el.textContent = proposed;
  }, []);
  useIsomorphicLayoutEffect$3(function() {
    !(!alwaysRef.current && !dynamicRef.current) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "style elements already mounted") : invariant$2() : void 0;
    var always = createStyleEl2();
    var dynamic = createStyleEl2();
    alwaysRef.current = always;
    dynamicRef.current = dynamic;
    always.setAttribute(prefix + "-always", uniqueContext);
    dynamic.setAttribute(prefix + "-dynamic", uniqueContext);
    getHead2().appendChild(always);
    getHead2().appendChild(dynamic);
    setAlwaysStyle(styles2.always);
    setDynamicStyle(styles2.resting);
    return function() {
      var remove = function remove2(ref2) {
        var current = ref2.current;
        !current ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot unmount ref as it is not set") : invariant$2() : void 0;
        getHead2().removeChild(current);
        ref2.current = null;
      };
      remove(alwaysRef);
      remove(dynamicRef);
    };
  }, [setAlwaysStyle, setDynamicStyle, styles2.always, styles2.resting, uniqueContext]);
  var dragging = useCallback(function() {
    return setDynamicStyle(styles2.dragging);
  }, [setDynamicStyle, styles2.dragging]);
  var dropping = useCallback(function(reason) {
    if (reason === "DROP") {
      setDynamicStyle(styles2.dropAnimating);
      return;
    }
    setDynamicStyle(styles2.userCancel);
  }, [setDynamicStyle, styles2.dropAnimating, styles2.userCancel]);
  var resting = useCallback(function() {
    if (!dynamicRef.current) {
      return;
    }
    setDynamicStyle(styles2.resting);
  }, [setDynamicStyle, styles2.resting]);
  var marshal = useMemo(function() {
    return {
      dragging,
      dropping,
      resting,
      styleContext: uniqueContext
    };
  }, [dragging, dropping, resting, uniqueContext]);
  return marshal;
}
var StoreContext = React__default.createContext(null);
var getBodyElement = function() {
  var body = document.body;
  !body ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot find document.body") : invariant$2() : void 0;
  return body;
};
var visuallyHidden = {
  position: "absolute",
  width: "1px",
  height: "1px",
  margin: "-1px",
  border: "0",
  padding: "0",
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  "clip-path": "inset(100%)"
};
var getId2 = function getId3(uniqueId2) {
  return "react-beautiful-dnd-announcement-" + uniqueId2;
};
function useAnnouncer(uniqueId2) {
  var id = useMemo(function() {
    return getId2(uniqueId2);
  }, [uniqueId2]);
  var ref2 = useRef(null);
  useEffect(function() {
    !!ref2.current ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Announcement node already mounted") : invariant$2() : void 0;
    var el = document.createElement("div");
    ref2.current = el;
    el.id = id;
    el.setAttribute("aria-live", "assertive");
    el.setAttribute("role", "log");
    el.setAttribute("aria-atomic", "true");
    _Object$assign(el.style, visuallyHidden);
    getBodyElement().appendChild(el);
    return function() {
      var toBeRemoved = ref2.current;
      !toBeRemoved ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot unmount announcement node") : invariant$2() : void 0;
      getBodyElement().removeChild(toBeRemoved);
      ref2.current = null;
    };
  }, [id]);
  var announce2 = useCallback(function(message2) {
    var el = ref2.current;
    if (el) {
      el.textContent = message2;
      return;
    }
    process.env.NODE_ENV !== "production" ? warning$1('\n      A screen reader message was trying to be announced but it was unable to do so.\n      This can occur if you unmount your <DragDropContext /> in your onDragEnd.\n      Consider calling provided.announce() before the unmount so that the instruction will\n      not be lost for users relying on a screen reader.\n\n      Message not passed to screen reader:\n\n      "' + message2 + '"\n    ') : void 0;
  }, []);
  return announce2;
}
var AppContext = React__default.createContext(null);
var peerDependencies = {
  react: "^16.8.5"
};
var semver = /(\d+)\.(\d+)\.(\d+)/;
var getVersion2 = function getVersion3(value) {
  var result = semver.exec(value);
  !(result != null) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Unable to parse React version " + value) : invariant$2() : void 0;
  var major = Number(result[1]);
  var minor = Number(result[2]);
  var patch4 = Number(result[3]);
  return {
    major,
    minor,
    patch: patch4,
    raw: value
  };
};
var isSatisfied2 = function isSatisfied3(expected, actual) {
  if (actual.major > expected.major) {
    return true;
  }
  if (actual.major < expected.major) {
    return false;
  }
  if (actual.minor > expected.minor) {
    return true;
  }
  if (actual.minor < expected.minor) {
    return false;
  }
  return actual.patch >= expected.patch;
};
var checkReactVersion = function(peerDepValue, actualValue) {
  var peerDep = getVersion2(peerDepValue);
  var actual = getVersion2(actualValue);
  if (isSatisfied2(peerDep, actual)) {
    return;
  }
  process.env.NODE_ENV !== "production" ? warning$1("\n    React version: [" + actual.raw + "]\n    does not satisfy expected peer dependency version: [" + peerDep.raw + "]\n\n    This can result in run time bugs, and even fatal crashes\n  ") : void 0;
};
var suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var checkDoctype = function(doc2) {
  var doctype = doc2.doctype;
  if (!doctype) {
    process.env.NODE_ENV !== "production" ? warning$1("\n      No <!doctype html> found.\n\n      " + suffix + "\n    ") : void 0;
    return;
  }
  if (doctype.name.toLowerCase() !== "html") {
    process.env.NODE_ENV !== "production" ? warning$1("\n      Unexpected <!doctype> found: (" + doctype.name + ")\n\n      " + suffix + "\n    ") : void 0;
  }
  if (doctype.publicId !== "") {
    process.env.NODE_ENV !== "production" ? warning$1("\n      Unexpected <!doctype> publicId found: (" + doctype.publicId + ")\n      A html5 doctype does not have a publicId\n\n      " + suffix + "\n    ") : void 0;
  }
};
function useStartupValidation() {
  useEffect(function() {
    if (process.env.NODE_ENV === "production") {
      return;
    }
    checkReactVersion(peerDependencies.react, React__default.version);
    checkDoctype(document);
  }, []);
}
function usePrevious$1(current) {
  var ref2 = useRef(current);
  useEffect(function() {
    ref2.current = current;
  });
  return ref2;
}
var createResponders2 = function createResponders3(props) {
  return {
    onBeforeDragStart: props.onBeforeDragStart,
    onDragStart: props.onDragStart,
    onDragEnd: props.onDragEnd,
    onDragUpdate: props.onDragUpdate
  };
};
function getStore(lazyRef) {
  !lazyRef.current ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Could not find store from lazy ref") : invariant$2() : void 0;
  return lazyRef.current;
}
function App(props) {
  var uniqueId2 = props.uniqueId, setOnError = props.setOnError;
  var lazyStoreRef = useRef(null);
  useStartupValidation();
  var lastPropsRef = usePrevious$1(props);
  var getResponders = useCallback(function() {
    return createResponders2(lastPropsRef.current);
  }, [lastPropsRef]);
  var announce2 = useAnnouncer(uniqueId2);
  var styleMarshal = useStyleMarshal(uniqueId2);
  var lazyDispatch = useCallback(function(action) {
    getStore(lazyStoreRef).dispatch(action);
  }, []);
  var callbacks = useMemo(function() {
    return bindActionCreators$1({
      publishWhileDragging: publishWhileDragging$1,
      updateDroppableScroll: updateDroppableScroll2,
      updateDroppableIsEnabled: updateDroppableIsEnabled2,
      updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled2,
      collectionStarting: collectionStarting2
    }, lazyDispatch);
  }, [lazyDispatch]);
  var dimensionMarshal = useMemo(function() {
    return createDimensionMarshal(callbacks);
  }, [callbacks]);
  var autoScroller = useMemo(function() {
    return createAutoScroller(_extends$2({
      scrollWindow,
      scrollDroppable: dimensionMarshal.scrollDroppable
    }, bindActionCreators$1({
      move: move2
    }, lazyDispatch)));
  }, [dimensionMarshal.scrollDroppable, lazyDispatch]);
  var store = useMemo(function() {
    return createStore({
      dimensionMarshal,
      styleMarshal,
      announce: announce2,
      autoScroller,
      getResponders
    });
  }, [announce2, autoScroller, dimensionMarshal, getResponders, styleMarshal]);
  if (process.env.NODE_ENV !== "production") {
    if (lazyStoreRef.current && lazyStoreRef.current !== store) {
      process.env.NODE_ENV !== "production" ? warning$1("unexpected store change") : void 0;
    }
  }
  lazyStoreRef.current = store;
  var tryResetStore = useCallback(function() {
    var current = getStore(lazyStoreRef);
    var state = current.getState();
    if (state.phase !== "IDLE") {
      current.dispatch(clean$1({
        shouldFlush: true
      }));
    }
  }, []);
  setOnError(tryResetStore);
  var getCanLift = useCallback(function(id) {
    return canStartDrag(getStore(lazyStoreRef).getState(), id);
  }, []);
  var getIsMovementAllowed = useCallback(function() {
    return isMovementAllowed(getStore(lazyStoreRef).getState());
  }, []);
  var appContext = useMemo(function() {
    return {
      marshal: dimensionMarshal,
      style: styleMarshal.styleContext,
      canLift: getCanLift,
      isMovementAllowed: getIsMovementAllowed
    };
  }, [dimensionMarshal, getCanLift, getIsMovementAllowed, styleMarshal.styleContext]);
  useEffect(function() {
    return tryResetStore;
  }, [tryResetStore]);
  return React__default.createElement(AppContext.Provider, {
    value: appContext
  }, React__default.createElement(Provider$1, {
    context: StoreContext,
    store
  }, props.children));
}
var instanceCount = 0;
function DragDropContext(props) {
  var uniqueId2 = useMemo(function() {
    return instanceCount++;
  }, []);
  return React__default.createElement(ErrorBoundary, null, function(setOnError) {
    return React__default.createElement(App, _extends$2({
      setOnError,
      uniqueId: uniqueId2
    }, props), props.children);
  });
}
var isEqual$2 = function isEqual5(base2) {
  return function(value) {
    return base2 === value;
  };
};
var isScroll = isEqual$2("scroll");
var isAuto = isEqual$2("auto");
var isVisible$1 = isEqual$2("visible");
var isEither2 = function isEither3(overflow2, fn2) {
  return fn2(overflow2.overflowX) || fn2(overflow2.overflowY);
};
var isBoth2 = function isBoth3(overflow2, fn2) {
  return fn2(overflow2.overflowX) && fn2(overflow2.overflowY);
};
var isElementScrollable2 = function isElementScrollable3(el) {
  var style3 = window.getComputedStyle(el);
  var overflow2 = {
    overflowX: style3.overflowX,
    overflowY: style3.overflowY
  };
  return isEither2(overflow2, isScroll) || isEither2(overflow2, isAuto);
};
var isBodyScrollable2 = function isBodyScrollable3() {
  if (process.env.NODE_ENV === "production") {
    return false;
  }
  var body = getBodyElement();
  var html2 = document.documentElement;
  !html2 ? process.env.NODE_ENV !== "production" ? invariant$2() : invariant$2() : void 0;
  if (!isElementScrollable2(body)) {
    return false;
  }
  var htmlStyle = window.getComputedStyle(html2);
  var htmlOverflow = {
    overflowX: htmlStyle.overflowX,
    overflowY: htmlStyle.overflowY
  };
  if (isBoth2(htmlOverflow, isVisible$1)) {
    return false;
  }
  process.env.NODE_ENV !== "production" ? warning$1("\n    We have detected that your <body> element might be a scroll container.\n    We have found no reliable way of detecting whether the <body> element is a scroll container.\n    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)\n\n    Because we cannot determine if the <body> is a scroll container, and generally it is not one,\n    we will be treating the <body> as *not* a scroll container\n\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md\n  ") : void 0;
  return false;
};
var getClosestScrollable2 = function getClosestScrollable3(el) {
  if (el == null) {
    return null;
  }
  if (el === document.body) {
    return isBodyScrollable2() ? el : null;
  }
  if (el === document.documentElement) {
    return null;
  }
  if (!isElementScrollable2(el)) {
    return getClosestScrollable3(el.parentElement);
  }
  return el;
};
var checkForNestedScrollContainers = function(scrollable) {
  if (!scrollable) {
    return;
  }
  var anotherScrollParent = getClosestScrollable2(scrollable.parentElement);
  if (!anotherScrollParent) {
    return;
  }
  process.env.NODE_ENV !== "production" ? warning$1("\n    Droppable: unsupported nested scroll container detected.\n    A Droppable can only have one scroll parent (which can be itself)\n    Nested scroll containers are currently not supported.\n\n    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131\n  ") : void 0;
};
var getScroll$1 = function(el) {
  return {
    x: el.scrollLeft,
    y: el.scrollTop
  };
};
var getIsFixed2 = function getIsFixed3(el) {
  if (!el) {
    return false;
  }
  var style3 = window.getComputedStyle(el);
  if (style3.position === "fixed") {
    return true;
  }
  return getIsFixed3(el.parentElement);
};
var getEnv = function(start4) {
  var closestScrollable = getClosestScrollable2(start4);
  var isFixedOnPage = getIsFixed2(start4);
  return {
    closestScrollable,
    isFixedOnPage
  };
};
var getClient2 = function getClient3(targetRef, closestScrollable) {
  var base2 = getBox(targetRef);
  if (!closestScrollable) {
    return base2;
  }
  if (targetRef !== closestScrollable) {
    return base2;
  }
  var top2 = base2.paddingBox.top - closestScrollable.scrollTop;
  var left2 = base2.paddingBox.left - closestScrollable.scrollLeft;
  var bottom2 = top2 + closestScrollable.scrollHeight;
  var right2 = left2 + closestScrollable.scrollWidth;
  var paddingBox = {
    top: top2,
    right: right2,
    bottom: bottom2,
    left: left2
  };
  var borderBox = expand(paddingBox, base2.border);
  var client2 = createBox({
    borderBox,
    margin: base2.margin,
    border: base2.border,
    padding: base2.padding
  });
  return client2;
};
var getDimension = function(_ref) {
  var ref2 = _ref.ref, descriptor = _ref.descriptor, env2 = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
  var closestScrollable = env2.closestScrollable;
  var client2 = getClient2(ref2, closestScrollable);
  var page = withScroll(client2, windowScroll);
  var closest4 = function() {
    if (!closestScrollable) {
      return null;
    }
    var frameClient = getBox(closestScrollable);
    var scrollSize = {
      scrollHeight: closestScrollable.scrollHeight,
      scrollWidth: closestScrollable.scrollWidth
    };
    return {
      client: frameClient,
      page: withScroll(frameClient, windowScroll),
      scroll: getScroll$1(closestScrollable),
      scrollSize,
      shouldClipSubject
    };
  }();
  var dimension = getDroppableDimension({
    descriptor,
    isEnabled: !isDropDisabled,
    isCombineEnabled,
    isFixedOnPage: env2.isFixedOnPage,
    direction,
    client: client2,
    page,
    closest: closest4
  });
  return dimension;
};
function withoutPlaceholder(placeholder2, fn2) {
  if (!placeholder2) {
    return fn2();
  }
  var last = placeholder2.style.display;
  placeholder2.style.display = "none";
  var result = fn2();
  placeholder2.style.display = last;
  return result;
}
var immediate = {
  passive: false
};
var delayed = {
  passive: true
};
var getListenerOptions = function(options) {
  return options.shouldPublishImmediately ? immediate : delayed;
};
function useRequiredContext(Context2) {
  var result = useContext(Context2);
  !result ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Could not find required context") : invariant$2() : void 0;
  return result;
}
var getClosestScrollableFromDrag2 = function getClosestScrollableFromDrag3(dragging) {
  return dragging && dragging.env.closestScrollable || null;
};
function useDroppableDimensionPublisher(args) {
  var whileDraggingRef = useRef(null);
  var appContext = useRequiredContext(AppContext);
  var marshal = appContext.marshal;
  var previousRef = usePrevious$1(args);
  var descriptor = useMemo(function() {
    return {
      id: args.droppableId,
      type: args.type
    };
  }, [args.droppableId, args.type]);
  var publishedDescriptorRef = useRef(descriptor);
  var memoizedUpdateScroll = useMemo(function() {
    return memoizeOne(function(x2, y2) {
      !whileDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Can only update scroll when dragging") : invariant$2() : void 0;
      var scroll5 = {
        x: x2,
        y: y2
      };
      marshal.updateDroppableScroll(descriptor.id, scroll5);
    });
  }, [descriptor.id, marshal]);
  var getClosestScroll = useCallback(function() {
    var dragging = whileDraggingRef.current;
    if (!dragging || !dragging.env.closestScrollable) {
      return origin;
    }
    return getScroll$1(dragging.env.closestScrollable);
  }, []);
  var updateScroll = useCallback(function() {
    var scroll5 = getClosestScroll();
    memoizedUpdateScroll(scroll5.x, scroll5.y);
  }, [getClosestScroll, memoizedUpdateScroll]);
  var scheduleScrollUpdate = useMemo(function() {
    return rafSchd(updateScroll);
  }, [updateScroll]);
  var onClosestScroll = useCallback(function() {
    var dragging = whileDraggingRef.current;
    var closest4 = getClosestScrollableFromDrag2(dragging);
    !(dragging && closest4) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Could not find scroll options while scrolling") : invariant$2() : void 0;
    var options = dragging.scrollOptions;
    if (options.shouldPublishImmediately) {
      updateScroll();
      return;
    }
    scheduleScrollUpdate();
  }, [scheduleScrollUpdate, updateScroll]);
  var getDimensionAndWatchScroll = useCallback(function(windowScroll, options) {
    !!whileDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot collect a droppable while a drag is occurring") : invariant$2() : void 0;
    var previous2 = previousRef.current;
    var ref2 = previous2.getDroppableRef();
    !ref2 ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot collect without a droppable ref") : invariant$2() : void 0;
    var env2 = getEnv(ref2);
    var dragging = {
      ref: ref2,
      descriptor,
      env: env2,
      scrollOptions: options
    };
    whileDraggingRef.current = dragging;
    var dimension = getDimension({
      ref: ref2,
      descriptor,
      env: env2,
      windowScroll,
      direction: previous2.direction,
      isDropDisabled: previous2.isDropDisabled,
      isCombineEnabled: previous2.isCombineEnabled,
      shouldClipSubject: !previous2.ignoreContainerClipping
    });
    if (env2.closestScrollable) {
      env2.closestScrollable.addEventListener("scroll", onClosestScroll, getListenerOptions(dragging.scrollOptions));
      if (process.env.NODE_ENV !== "production") {
        checkForNestedScrollContainers(env2.closestScrollable);
      }
    }
    return dimension;
  }, [descriptor, onClosestScroll, previousRef]);
  var recollect = useCallback(function(options) {
    var dragging = whileDraggingRef.current;
    var closest4 = getClosestScrollableFromDrag2(dragging);
    !(dragging && closest4) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Can only recollect Droppable client for Droppables that have a scroll container") : invariant$2() : void 0;
    var previous2 = previousRef.current;
    var execute4 = function execute5() {
      return getDimension({
        ref: dragging.ref,
        descriptor: dragging.descriptor,
        env: dragging.env,
        windowScroll: origin,
        direction: previous2.direction,
        isDropDisabled: previous2.isDropDisabled,
        isCombineEnabled: previous2.isCombineEnabled,
        shouldClipSubject: !previous2.ignoreContainerClipping
      });
    };
    if (!options.withoutPlaceholder) {
      return execute4();
    }
    return withoutPlaceholder(previous2.getPlaceholderRef(), execute4);
  }, [previousRef]);
  var dragStopped = useCallback(function() {
    var dragging = whileDraggingRef.current;
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot stop drag when no active drag") : invariant$2() : void 0;
    var closest4 = getClosestScrollableFromDrag2(dragging);
    whileDraggingRef.current = null;
    if (!closest4) {
      return;
    }
    scheduleScrollUpdate.cancel();
    closest4.removeEventListener("scroll", onClosestScroll, getListenerOptions(dragging.scrollOptions));
  }, [onClosestScroll, scheduleScrollUpdate]);
  var scroll4 = useCallback(function(change) {
    var dragging = whileDraggingRef.current;
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot scroll when there is no drag") : invariant$2() : void 0;
    var closest4 = getClosestScrollableFromDrag2(dragging);
    !closest4 ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot scroll a droppable with no closest scrollable") : invariant$2() : void 0;
    closest4.scrollTop += change.y;
    closest4.scrollLeft += change.x;
  }, []);
  var callbacks = useMemo(function() {
    return {
      getDimensionAndWatchScroll,
      recollect,
      dragStopped,
      scroll: scroll4
    };
  }, [dragStopped, getDimensionAndWatchScroll, recollect, scroll4]);
  useIsomorphicLayoutEffect$3(function() {
    publishedDescriptorRef.current = descriptor;
    marshal.registerDroppable(descriptor, callbacks);
    return function() {
      if (whileDraggingRef.current) {
        process.env.NODE_ENV !== "production" ? warning$1("Unsupported: changing the droppableId or type of a Droppable during a drag") : void 0;
        dragStopped();
      }
      marshal.unregisterDroppable(descriptor);
    };
  }, [callbacks, descriptor, dragStopped, marshal]);
  useIsomorphicLayoutEffect$3(function() {
    if (!whileDraggingRef.current) {
      return;
    }
    marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
  }, [args.isDropDisabled, marshal]);
  useIsomorphicLayoutEffect$3(function() {
    if (!whileDraggingRef.current) {
      return;
    }
    marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
  }, [args.isCombineEnabled, marshal]);
}
function noop$5() {
}
var empty$2 = {
  width: 0,
  height: 0,
  margin: noSpacing
};
var getSize2 = function getSize3(_ref) {
  var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder2 = _ref.placeholder, animate = _ref.animate;
  if (isAnimatingOpenOnMount) {
    return empty$2;
  }
  if (animate === "close") {
    return empty$2;
  }
  return {
    height: placeholder2.client.borderBox.height,
    width: placeholder2.client.borderBox.width,
    margin: placeholder2.client.margin
  };
};
var getStyle2 = function getStyle3(_ref2) {
  var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder2 = _ref2.placeholder, animate = _ref2.animate;
  var size2 = getSize2({
    isAnimatingOpenOnMount,
    placeholder: placeholder2,
    animate
  });
  return {
    display: placeholder2.display,
    boxSizing: "border-box",
    width: size2.width,
    height: size2.height,
    marginTop: size2.margin.top,
    marginRight: size2.margin.right,
    marginBottom: size2.margin.bottom,
    marginLeft: size2.margin.left,
    flexShrink: "0",
    flexGrow: "0",
    pointerEvents: "none",
    transition: transitions.placeholder
  };
};
function Placeholder$2(props) {
  var animateOpenTimerRef = useRef(null);
  var tryClearAnimateOpenTimer = useCallback(function() {
    if (!animateOpenTimerRef.current) {
      return;
    }
    clearTimeout(animateOpenTimerRef.current);
    animateOpenTimerRef.current = null;
  }, []);
  var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, styleContext = props.styleContext;
  var _useState = useState(props.animate === "open"), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
  useEffect(function() {
    if (!isAnimatingOpenOnMount) {
      return noop$5;
    }
    if (animate !== "open") {
      tryClearAnimateOpenTimer();
      setIsAnimatingOpenOnMount(false);
      return noop$5;
    }
    if (animateOpenTimerRef.current) {
      return noop$5;
    }
    animateOpenTimerRef.current = setTimeout(function() {
      animateOpenTimerRef.current = null;
      setIsAnimatingOpenOnMount(false);
    });
    return tryClearAnimateOpenTimer;
  }, [animate, isAnimatingOpenOnMount, tryClearAnimateOpenTimer]);
  var onSizeChangeEnd = useCallback(function(event) {
    if (event.propertyName !== "height") {
      return;
    }
    onTransitionEnd();
    if (animate === "close") {
      onClose();
    }
  }, [animate, onClose, onTransitionEnd]);
  var style3 = getStyle2({
    isAnimatingOpenOnMount,
    animate: props.animate,
    placeholder: props.placeholder
  });
  return React__default.createElement(props.placeholder.tagName, {
    style: style3,
    "data-react-beautiful-dnd-placeholder": styleContext,
    onTransitionEnd: onSizeChangeEnd,
    ref: props.innerRef
  });
}
var Placeholder$1$1 = React__default.memo(Placeholder$2);
var DroppableContext = React__default.createContext(null);
var getWindowFromEl = function(el) {
  return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function isHtmlElement(el) {
  return el instanceof getWindowFromEl(el).HTMLElement;
}
function checkIsValidInnerRef(el) {
  !(el && isHtmlElement(el)) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "\n    provided.innerRef has not been provided with a HTMLElement.\n\n    You can find a guide on using the innerRef callback functions at:\n    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md\n  ") : invariant$2() : void 0;
}
function checkOwnProps(props) {
  !props.droppableId ? process.env.NODE_ENV !== "production" ? invariant$2(false, "A Droppable requires a droppableId prop") : invariant$2() : void 0;
  !(typeof props.isDropDisabled === "boolean") ? process.env.NODE_ENV !== "production" ? invariant$2(false, "isDropDisabled must be a boolean") : invariant$2() : void 0;
  !(typeof props.isCombineEnabled === "boolean") ? process.env.NODE_ENV !== "production" ? invariant$2(false, "isCombineEnabled must be a boolean") : invariant$2() : void 0;
  !(typeof props.ignoreContainerClipping === "boolean") ? process.env.NODE_ENV !== "production" ? invariant$2(false, "ignoreContainerClipping must be a boolean") : invariant$2() : void 0;
}
function checkPlaceholderRef(props, placeholderEl) {
  if (!props.placeholder) {
    return;
  }
  if (placeholderEl) {
    return;
  }
  process.env.NODE_ENV !== "production" ? warning$1('\n    Droppable setup issue [droppableId: "' + props.droppableId + '"]:\n    DroppableProvided > placeholder could not be found.\n\n    Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md\n  ') : void 0;
}
function useValidation(_ref) {
  var props = _ref.props, getDroppableRef = _ref.getDroppableRef, getPlaceholderRef = _ref.getPlaceholderRef;
  useEffect(function() {
    if (process.env.NODE_ENV !== "production") {
      checkOwnProps(props);
      checkIsValidInnerRef(getDroppableRef());
      checkPlaceholderRef(props, getPlaceholderRef());
    }
  });
}
var AnimateInOut = function(_React$PureComponent) {
  _inheritsLoose(AnimateInOut2, _React$PureComponent);
  function AnimateInOut2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      isVisible: Boolean(_this.props.on),
      data: _this.props.on,
      animate: _this.props.shouldAnimate && _this.props.on ? "open" : "none"
    };
    _this.onClose = function() {
      if (_this.state.animate !== "close") {
        return;
      }
      _this.setState({
        isVisible: false
      });
    };
    return _this;
  }
  AnimateInOut2.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (!props.shouldAnimate) {
      return {
        isVisible: Boolean(props.on),
        data: props.on,
        animate: "none"
      };
    }
    if (props.on) {
      return {
        isVisible: true,
        data: props.on,
        animate: "open"
      };
    }
    if (state.isVisible) {
      return {
        isVisible: true,
        data: state.data,
        animate: "close"
      };
    }
    return {
      isVisible: false,
      animate: "close",
      data: null
    };
  };
  var _proto = AnimateInOut2.prototype;
  _proto.render = function render() {
    if (!this.state.isVisible) {
      return null;
    }
    var provided = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(provided);
  };
  return AnimateInOut2;
}(React__default.PureComponent);
function Droppable(props) {
  var appContext = useContext(AppContext);
  !appContext ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Could not find app context") : invariant$2() : void 0;
  var styleContext = appContext.style, isMovementAllowed2 = appContext.isMovementAllowed;
  var droppableRef = useRef(null);
  var placeholderRef = useRef(null);
  var children = props.children, droppableId = props.droppableId, type = props.type, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, updateViewportMaxScroll4 = props.updateViewportMaxScroll;
  var getDroppableRef = useCallback(function() {
    return droppableRef.current;
  }, []);
  var getPlaceholderRef = useCallback(function() {
    return placeholderRef.current;
  }, []);
  var setDroppableRef = useCallback(function(value) {
    droppableRef.current = value;
  }, []);
  var setPlaceholderRef = useCallback(function(value) {
    placeholderRef.current = value;
  }, []);
  var onPlaceholderTransitionEnd = useCallback(function() {
    if (isMovementAllowed2()) {
      updateViewportMaxScroll4({
        maxScroll: getMaxWindowScroll()
      });
    }
  }, [isMovementAllowed2, updateViewportMaxScroll4]);
  useDroppableDimensionPublisher({
    droppableId,
    type,
    direction,
    isDropDisabled,
    isCombineEnabled,
    ignoreContainerClipping,
    getDroppableRef,
    getPlaceholderRef
  });
  var placeholder2 = React__default.createElement(AnimateInOut, {
    on: props.placeholder,
    shouldAnimate: props.shouldAnimatePlaceholder
  }, function(_ref) {
    var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
    return React__default.createElement(Placeholder$1$1, {
      placeholder: data,
      onClose,
      innerRef: setPlaceholderRef,
      animate,
      styleContext,
      onTransitionEnd: onPlaceholderTransitionEnd
    });
  });
  var provided = useMemo(function() {
    return {
      innerRef: setDroppableRef,
      placeholder: placeholder2,
      droppableProps: {
        "data-react-beautiful-dnd-droppable": styleContext
      }
    };
  }, [placeholder2, setDroppableRef, styleContext]);
  var droppableContext = useMemo(function() {
    return {
      droppableId,
      type
    };
  }, [droppableId, type]);
  useValidation({
    props,
    getDroppableRef: function getDroppableRef2() {
      return droppableRef.current;
    },
    getPlaceholderRef: function getPlaceholderRef2() {
      return placeholderRef.current;
    }
  });
  return React__default.createElement(DroppableContext.Provider, {
    value: droppableContext
  }, children(provided, snapshot));
}
var isStrictEqual = function(a2, b2) {
  return a2 === b2;
};
var whatIsDraggedOverFromResult = function(result) {
  var combine2 = result.combine, destination = result.destination;
  if (destination) {
    return destination.droppableId;
  }
  if (combine2) {
    return combine2.droppableId;
  }
  return null;
};
var isMatchingType2 = function isMatchingType3(type, critical) {
  return type === critical.droppable.type;
};
var getDraggable2 = function getDraggable3(critical, dimensions) {
  return dimensions.draggables[critical.draggable.id];
};
var makeMapStateToProps3 = function makeMapStateToProps4() {
  var idle2 = {
    placeholder: null,
    shouldAnimatePlaceholder: true,
    snapshot: {
      isDraggingOver: false,
      draggingOverWith: null,
      draggingFromThisWith: null
    }
  };
  var idleWithoutAnimation = _extends$2({}, idle2, {
    shouldAnimatePlaceholder: false
  });
  var getMapProps = memoizeOne(function(id, isDraggingOver, dragging, snapshot) {
    var isHome = dragging.descriptor.droppableId === id;
    if (isHome) {
      return {
        placeholder: dragging.placeholder,
        shouldAnimatePlaceholder: false,
        snapshot
      };
    }
    if (!isDraggingOver) {
      return idle2;
    }
    return {
      placeholder: dragging.placeholder,
      shouldAnimatePlaceholder: true,
      snapshot
    };
  });
  var getSnapshot = memoizeOne(function(id, isDraggingOver, dragging) {
    var draggableId = dragging.descriptor.id;
    var isHome = dragging.descriptor.droppableId === id;
    var draggingOverWith = isDraggingOver ? draggableId : null;
    var draggingFromThisWith = isHome ? draggableId : null;
    return {
      isDraggingOver,
      draggingOverWith,
      draggingFromThisWith
    };
  });
  var selector2 = function selector3(state, ownProps) {
    var id = ownProps.droppableId;
    var type = ownProps.type;
    if (state.isDragging) {
      var critical = state.critical;
      if (!isMatchingType2(type, critical)) {
        return idle2;
      }
      var dragging = getDraggable2(critical, state.dimensions);
      var isDraggingOver = whatIsDraggedOver(state.impact) === id;
      var snapshot = getSnapshot(id, isDraggingOver, dragging);
      return getMapProps(id, isDraggingOver, dragging, snapshot);
    }
    if (state.phase === "DROP_ANIMATING") {
      var completed = state.completed;
      if (!isMatchingType2(type, completed.critical)) {
        return idle2;
      }
      var _dragging = getDraggable2(completed.critical, state.dimensions);
      var _snapshot = getSnapshot(id, whatIsDraggedOverFromResult(completed.result) === id, _dragging);
      return getMapProps(id, whatIsDraggedOver(completed.impact) === id, _dragging, _snapshot);
    }
    if (state.phase === "IDLE" && !state.completed && state.shouldFlush) {
      return idleWithoutAnimation;
    }
    if (state.phase === "IDLE" && state.completed) {
      var _completed = state.completed;
      if (!isMatchingType2(type, _completed.critical)) {
        return idle2;
      }
      var wasOver = whatIsDraggedOver(_completed.impact) === id;
      var wasCombining = Boolean(_completed.impact.merge);
      if (state.shouldFlush) {
        return idleWithoutAnimation;
      }
      if (wasOver) {
        return wasCombining ? idle2 : idleWithoutAnimation;
      }
      return idle2;
    }
    return idle2;
  };
  return selector2;
};
var mapDispatchToProps = {
  updateViewportMaxScroll: updateViewportMaxScroll2
};
var defaultProps = {
  type: "DEFAULT",
  direction: "vertical",
  isDropDisabled: false,
  isCombineEnabled: false,
  ignoreContainerClipping: false
};
var ConnectedDroppable = connect(makeMapStateToProps3, mapDispatchToProps, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Droppable);
ConnectedDroppable.defaultProps = defaultProps;
var zIndexOptions = {
  dragging: 5e3,
  dropAnimating: 4500
};
var getDraggingTransition2 = function getDraggingTransition3(shouldAnimateDragMovement, dropping) {
  if (dropping) {
    return transitions.drop(dropping.duration);
  }
  if (shouldAnimateDragMovement) {
    return transitions.snap;
  }
  return transitions.fluid;
};
var getDraggingOpacity2 = function getDraggingOpacity3(isCombining, isDropAnimating) {
  if (!isCombining) {
    return null;
  }
  return isDropAnimating ? combine.opacity.drop : combine.opacity.combining;
};
var getShouldDraggingAnimate2 = function getShouldDraggingAnimate3(dragging) {
  if (dragging.forceShouldAnimate != null) {
    return dragging.forceShouldAnimate;
  }
  return dragging.mode === "SNAP";
};
function getDraggingStyle(dragging) {
  var dimension = dragging.dimension;
  var box = dimension.client;
  var offset3 = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
  var isCombining = Boolean(combineWith);
  var shouldAnimate = getShouldDraggingAnimate2(dragging);
  var isDropAnimating = Boolean(dropping);
  var transform = isDropAnimating ? transforms$1.drop(offset3, isCombining) : transforms$1.moveTo(offset3);
  var style3 = {
    position: "fixed",
    top: box.marginBox.top,
    left: box.marginBox.left,
    boxSizing: "border-box",
    width: box.borderBox.width,
    height: box.borderBox.height,
    transition: getDraggingTransition2(shouldAnimate, dropping),
    transform,
    opacity: getDraggingOpacity2(isCombining, isDropAnimating),
    zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
    pointerEvents: "none"
  };
  return style3;
}
function getSecondaryStyle(secondary) {
  return {
    transform: transforms$1.moveTo(secondary.offset),
    transition: secondary.shouldAnimateDisplacement ? null : "none"
  };
}
function getStyle$1(mapped) {
  return mapped.type === "DRAGGING" ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
}
var createEventMarshal = function() {
  var isMouseDownHandled = false;
  var handle2 = function handle3() {
    !!isMouseDownHandled ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot handle mouse down as it is already handled") : invariant$2() : void 0;
    isMouseDownHandled = true;
  };
  var isHandled = function isHandled2() {
    return isMouseDownHandled;
  };
  var reset2 = function reset3() {
    isMouseDownHandled = false;
  };
  return {
    handle: handle2,
    isHandled,
    reset: reset2
  };
};
var getOptions = function getOptions2(shared2, fromBinding) {
  return _extends$2({}, shared2, fromBinding);
};
var bindEvents = function bindEvents2(el, bindings, sharedOptions2) {
  bindings.forEach(function(binding) {
    var options = getOptions(sharedOptions2, binding.options);
    el.addEventListener(binding.eventName, binding.fn, options);
  });
};
var unbindEvents = function unbindEvents2(el, bindings, sharedOptions2) {
  bindings.forEach(function(binding) {
    var options = getOptions(sharedOptions2, binding.options);
    el.removeEventListener(binding.eventName, binding.fn, options);
  });
};
var createScheduler = function(callbacks) {
  var memoizedMove = memoizeOne(function(x2, y2) {
    var point2 = {
      x: x2,
      y: y2
    };
    callbacks.onMove(point2);
  });
  var move4 = rafSchd(function(point2) {
    return memoizedMove(point2.x, point2.y);
  });
  var moveUp4 = rafSchd(callbacks.onMoveUp);
  var moveDown4 = rafSchd(callbacks.onMoveDown);
  var moveRight4 = rafSchd(callbacks.onMoveRight);
  var moveLeft4 = rafSchd(callbacks.onMoveLeft);
  var windowScrollMove = rafSchd(callbacks.onWindowScroll);
  var cancel = function cancel2() {
    move4.cancel();
    moveUp4.cancel();
    moveDown4.cancel();
    moveRight4.cancel();
    moveLeft4.cancel();
    windowScrollMove.cancel();
  };
  return {
    move: move4,
    moveUp: moveUp4,
    moveDown: moveDown4,
    moveRight: moveRight4,
    moveLeft: moveLeft4,
    windowScrollMove,
    cancel
  };
};
var tab$1 = 9;
var enter$1 = 13;
var escape = 27;
var space$3 = 32;
var pageUp = 33;
var pageDown = 34;
var end = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight = 39;
var arrowDown = 40;
var supportedEventName = function() {
  var base2 = "visibilitychange";
  if (typeof document === "undefined") {
    return base2;
  }
  var candidates = [base2, "ms" + base2, "webkit" + base2, "moz" + base2, "o" + base2];
  var supported = find$2(candidates, function(eventName) {
    return "on" + eventName in document;
  });
  return supported || base2;
}();
var sharedOptions = {
  capture: true
};
var createPostDragEventPreventer = function(getWindow2) {
  var isBound = false;
  var bind2 = function bind3() {
    if (isBound) {
      return;
    }
    isBound = true;
    bindEvents(getWindow2(), pointerEvents, sharedOptions);
  };
  var unbind = function unbind2() {
    if (!isBound) {
      return;
    }
    isBound = false;
    unbindEvents(getWindow2(), pointerEvents, sharedOptions);
  };
  var pointerEvents = [{
    eventName: "click",
    fn: function fn2(event) {
      event.preventDefault();
      unbind();
    }
  }, {
    eventName: "mousedown",
    fn: unbind
  }, {
    eventName: "touchstart",
    fn: unbind
  }];
  var preventNext = function preventNext2() {
    if (isBound) {
      unbind();
    }
    bind2();
  };
  var preventer = {
    preventNext,
    abort: unbind
  };
  return preventer;
};
var sloppyClickThreshold = 5;
var isSloppyClickThresholdExceeded = function(original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
};
var _preventedKeys;
var preventedKeys = (_preventedKeys = {}, _preventedKeys[enter$1] = true, _preventedKeys[tab$1] = true, _preventedKeys);
var preventStandardKeyEvents = function(event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
};
var primaryButton = 0;
var noop$1$1 = function noop2() {
};
var mouseDownMarshal = createEventMarshal();
function useMouseSensor(args) {
  var canStartCapturing = args.canStartCapturing, getWindow2 = args.getWindow, callbacks = args.callbacks, onCaptureStart = args.onCaptureStart, onCaptureEnd = args.onCaptureEnd;
  var pendingRef = useRef(null);
  var isDraggingRef = useRef(false);
  var unbindWindowEventsRef = useRef(noop$1$1);
  var getIsCapturing = useCallback(function() {
    return Boolean(pendingRef.current || isDraggingRef.current);
  }, []);
  var schedule = useMemo(function() {
    !!getIsCapturing() ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Should not recreate scheduler while capturing") : invariant$2() : void 0;
    return createScheduler(callbacks);
  }, [callbacks, getIsCapturing]);
  var postDragEventPreventer = useMemo(function() {
    return createPostDragEventPreventer(getWindow2);
  }, [getWindow2]);
  var stop = useCallback(function() {
    if (!getIsCapturing()) {
      return;
    }
    schedule.cancel();
    unbindWindowEventsRef.current();
    var shouldBlockClick = isDraggingRef.current;
    mouseDownMarshal.reset();
    if (shouldBlockClick) {
      postDragEventPreventer.preventNext();
    }
    pendingRef.current = null;
    isDraggingRef.current = false;
    onCaptureEnd();
  }, [getIsCapturing, onCaptureEnd, postDragEventPreventer, schedule]);
  var cancel = useCallback(function() {
    var wasDragging = isDraggingRef.current;
    stop();
    if (wasDragging) {
      callbacks.onCancel();
    }
  }, [callbacks, stop]);
  var startDragging = useCallback(function() {
    !!isDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot start a drag while dragging") : invariant$2() : void 0;
    var pending = pendingRef.current;
    !pending ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot start a drag without a pending drag") : invariant$2() : void 0;
    pendingRef.current = null;
    isDraggingRef.current = true;
    callbacks.onLift({
      clientSelection: pending,
      movementMode: "FLUID"
    });
  }, [callbacks]);
  var windowBindings = useMemo(function() {
    !!getIsCapturing() ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Should not recreate window bindings while capturing") : invariant$2() : void 0;
    var bindings = [{
      eventName: "mousemove",
      fn: function fn2(event) {
        var button = event.button, clientX = event.clientX, clientY = event.clientY;
        if (button !== primaryButton) {
          return;
        }
        var point2 = {
          x: clientX,
          y: clientY
        };
        if (isDraggingRef.current) {
          event.preventDefault();
          schedule.move(point2);
          return;
        }
        var pending = pendingRef.current;
        if (!pending) {
          stop();
          process.env.NODE_ENV !== "production" ? invariant$2(false, "Expected there to be an active or pending drag when window mousemove event is received") : invariant$2();
        }
        if (!isSloppyClickThresholdExceeded(pending, point2)) {
          return;
        }
        event.preventDefault();
        startDragging();
      }
    }, {
      eventName: "mouseup",
      fn: function fn2(event) {
        var wasDragging = isDraggingRef.current;
        stop();
        if (wasDragging) {
          event.preventDefault();
          callbacks.onDrop();
        }
      }
    }, {
      eventName: "mousedown",
      fn: function fn2(event) {
        if (isDraggingRef.current) {
          event.preventDefault();
        }
        cancel();
      }
    }, {
      eventName: "keydown",
      fn: function fn2(event) {
        if (pendingRef.current) {
          stop();
          return;
        }
        if (event.keyCode === escape) {
          event.preventDefault();
          cancel();
          return;
        }
        preventStandardKeyEvents(event);
      }
    }, {
      eventName: "resize",
      fn: cancel
    }, {
      eventName: "scroll",
      options: {
        passive: true,
        capture: false
      },
      fn: function fn2(event) {
        if (event.currentTarget !== getWindow2()) {
          return;
        }
        if (pendingRef.current) {
          stop();
          return;
        }
        schedule.windowScrollMove();
      }
    }, {
      eventName: "webkitmouseforcedown",
      fn: function fn2() {
        cancel();
      }
    }, {
      eventName: supportedEventName,
      fn: cancel
    }];
    return bindings;
  }, [getIsCapturing, cancel, startDragging, schedule, stop, callbacks, getWindow2]);
  var bindWindowEvents = useCallback(function() {
    var win = getWindow2();
    var options = {
      capture: true
    };
    unbindWindowEventsRef.current = function() {
      return unbindEvents(win, windowBindings, options);
    };
    bindEvents(win, windowBindings, options);
  }, [getWindow2, windowBindings]);
  var startPendingDrag = useCallback(function(point2) {
    !!pendingRef.current ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Expected there to be no pending drag") : invariant$2() : void 0;
    pendingRef.current = point2;
    onCaptureStart(stop);
    bindWindowEvents();
  }, [bindWindowEvents, onCaptureStart, stop]);
  var onMouseDown = useCallback(function(event) {
    if (mouseDownMarshal.isHandled()) {
      return;
    }
    !!getIsCapturing() ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Should not be able to perform a mouse down while a drag or pending drag is occurring") : invariant$2() : void 0;
    if (!canStartCapturing(event)) {
      return;
    }
    if (event.button !== primaryButton) {
      return;
    }
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
      return;
    }
    mouseDownMarshal.handle();
    event.preventDefault();
    var point2 = {
      x: event.clientX,
      y: event.clientY
    };
    startPendingDrag(point2);
  }, [canStartCapturing, getIsCapturing, startPendingDrag]);
  return onMouseDown;
}
function isElement(el) {
  return el instanceof getWindowFromEl(el).Element;
}
var interactiveTagNames = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};
var isAnInteractiveElement = function isAnInteractiveElement2(parent2, current) {
  if (current == null) {
    return false;
  }
  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);
  if (hasAnInteractiveTag) {
    return true;
  }
  var attribute = current.getAttribute("contenteditable");
  if (attribute === "true" || attribute === "") {
    return true;
  }
  if (current === parent2) {
    return false;
  }
  return isAnInteractiveElement2(parent2, current.parentElement);
};
var shouldAllowDraggingFromTarget = function(event, canDragInteractiveElements) {
  if (canDragInteractiveElements) {
    return true;
  }
  var target = event.target, currentTarget = event.currentTarget;
  if (!isElement(target) || !isElement(currentTarget)) {
    return true;
  }
  return !isAnInteractiveElement(currentTarget, target);
};
var getBorderBoxCenterPosition = function(el) {
  return getRect(el.getBoundingClientRect()).center;
};
var _scrollJumpKeys;
var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[pageDown] = true, _scrollJumpKeys[pageUp] = true, _scrollJumpKeys[home] = true, _scrollJumpKeys[end] = true, _scrollJumpKeys);
function noop$2$1() {
}
function useKeyboardSensor(args) {
  var canStartCapturing = args.canStartCapturing, getWindow2 = args.getWindow, callbacks = args.callbacks, onCaptureStart = args.onCaptureStart, onCaptureEnd = args.onCaptureEnd, getDraggableRef = args.getDraggableRef;
  var isDraggingRef = useRef(false);
  var unbindWindowEventsRef = useRef(noop$2$1);
  var getIsDragging = useCallback(function() {
    return isDraggingRef.current;
  }, []);
  var schedule = useMemo(function() {
    !!getIsDragging() ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Should not recreate scheduler while capturing") : invariant$2() : void 0;
    return createScheduler(callbacks);
  }, [callbacks, getIsDragging]);
  var stop = useCallback(function() {
    if (!getIsDragging()) {
      return;
    }
    schedule.cancel();
    unbindWindowEventsRef.current();
    isDraggingRef.current = false;
    onCaptureEnd();
  }, [getIsDragging, onCaptureEnd, schedule]);
  var cancel = useCallback(function() {
    var wasDragging = isDraggingRef.current;
    stop();
    if (wasDragging) {
      callbacks.onCancel();
    }
  }, [callbacks, stop]);
  var windowBindings = useMemo(function() {
    !!getIsDragging() ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Should not recreate window bindings when dragging") : invariant$2() : void 0;
    return [{
      eventName: "mousedown",
      fn: cancel
    }, {
      eventName: "mouseup",
      fn: cancel
    }, {
      eventName: "click",
      fn: cancel
    }, {
      eventName: "touchstart",
      fn: cancel
    }, {
      eventName: "resize",
      fn: cancel
    }, {
      eventName: "wheel",
      fn: cancel,
      options: {
        passive: true
      }
    }, {
      eventName: "scroll",
      options: {
        capture: false
      },
      fn: function fn2(event) {
        if (event.currentTarget !== getWindow2()) {
          return;
        }
        callbacks.onWindowScroll();
      }
    }, {
      eventName: supportedEventName,
      fn: cancel
    }];
  }, [callbacks, cancel, getIsDragging, getWindow2]);
  var bindWindowEvents = useCallback(function() {
    var win = getWindow2();
    var options = {
      capture: true
    };
    unbindWindowEventsRef.current = function() {
      return unbindEvents(win, windowBindings, options);
    };
    bindEvents(win, windowBindings, options);
  }, [getWindow2, windowBindings]);
  var startDragging = useCallback(function() {
    !!isDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot start a drag while dragging") : invariant$2() : void 0;
    var ref2 = getDraggableRef();
    !ref2 ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot start a keyboard drag without a draggable ref") : invariant$2() : void 0;
    isDraggingRef.current = true;
    onCaptureStart(stop);
    bindWindowEvents();
    var center = getBorderBoxCenterPosition(ref2);
    callbacks.onLift({
      clientSelection: center,
      movementMode: "SNAP"
    });
  }, [bindWindowEvents, callbacks, getDraggableRef, onCaptureStart, stop]);
  var onKeyDown = useCallback(function(event) {
    if (!getIsDragging()) {
      if (event.defaultPrevented) {
        return;
      }
      if (!canStartCapturing(event)) {
        return;
      }
      if (event.keyCode !== space$3) {
        return;
      }
      event.preventDefault();
      startDragging();
      return;
    }
    if (event.keyCode === escape) {
      event.preventDefault();
      cancel();
      return;
    }
    if (event.keyCode === space$3) {
      event.preventDefault();
      stop();
      callbacks.onDrop();
      return;
    }
    if (event.keyCode === arrowDown) {
      event.preventDefault();
      schedule.moveDown();
      return;
    }
    if (event.keyCode === arrowUp) {
      event.preventDefault();
      schedule.moveUp();
      return;
    }
    if (event.keyCode === arrowRight) {
      event.preventDefault();
      schedule.moveRight();
      return;
    }
    if (event.keyCode === arrowLeft) {
      event.preventDefault();
      schedule.moveLeft();
      return;
    }
    if (scrollJumpKeys[event.keyCode]) {
      event.preventDefault();
      return;
    }
    preventStandardKeyEvents(event);
  }, [callbacks, canStartCapturing, cancel, getIsDragging, schedule, startDragging, stop]);
  return onKeyDown;
}
var timeForLongPress = 120;
var forcePressThreshold = 0.15;
var touchStartMarshal = createEventMarshal();
var noop$3$1 = function noop3() {
};
function useTouchSensor(args) {
  var callbacks = args.callbacks, getWindow2 = args.getWindow, canStartCapturing = args.canStartCapturing, getShouldRespectForcePress = args.getShouldRespectForcePress, onCaptureStart = args.onCaptureStart, onCaptureEnd = args.onCaptureEnd;
  var pendingRef = useRef(null);
  var isDraggingRef = useRef(false);
  var hasMovedRef = useRef(false);
  var unbindWindowEventsRef = useRef(noop$3$1);
  var getIsCapturing = useCallback(function() {
    return Boolean(pendingRef.current || isDraggingRef.current);
  }, []);
  var postDragClickPreventer = useMemo(function() {
    return createPostDragEventPreventer(getWindow2);
  }, [getWindow2]);
  var schedule = useMemo(function() {
    !!getIsCapturing() ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Should not recreate scheduler while capturing") : invariant$2() : void 0;
    return createScheduler(callbacks);
  }, [callbacks, getIsCapturing]);
  var stop = useCallback(function() {
    if (!getIsCapturing()) {
      return;
    }
    schedule.cancel();
    unbindWindowEventsRef.current();
    touchStartMarshal.reset();
    hasMovedRef.current = false;
    onCaptureEnd();
    if (isDraggingRef.current) {
      postDragClickPreventer.preventNext();
      isDraggingRef.current = false;
      return;
    }
    var pending = pendingRef.current;
    !pending ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Expected a pending drag") : invariant$2() : void 0;
    clearTimeout(pending.longPressTimerId);
    pendingRef.current = null;
  }, [getIsCapturing, onCaptureEnd, postDragClickPreventer, schedule]);
  var cancel = useCallback(function() {
    var wasDragging = isDraggingRef.current;
    stop();
    if (wasDragging) {
      callbacks.onCancel();
    }
  }, [callbacks, stop]);
  var windowBindings = useMemo(function() {
    !!getIsCapturing() ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Should not recreate window bindings while capturing") : invariant$2() : void 0;
    var bindings = [{
      eventName: "touchmove",
      options: {
        passive: false,
        capture: false
      },
      fn: function fn2(event) {
        if (!isDraggingRef.current) {
          stop();
          return;
        }
        if (!hasMovedRef.current) {
          hasMovedRef.current = true;
        }
        var touch = event.touches[0];
        if (!touch) {
          return;
        }
        var point2 = {
          x: touch.clientX,
          y: touch.clientY
        };
        event.preventDefault();
        schedule.move(point2);
      }
    }, {
      eventName: "touchend",
      fn: function fn2(event) {
        if (!isDraggingRef.current) {
          stop();
          return;
        }
        event.preventDefault();
        stop();
        callbacks.onDrop();
      }
    }, {
      eventName: "touchcancel",
      fn: function fn2(event) {
        if (!isDraggingRef.current) {
          stop();
          return;
        }
        event.preventDefault();
        cancel();
      }
    }, {
      eventName: "touchstart",
      fn: cancel
    }, {
      eventName: "orientationchange",
      fn: cancel
    }, {
      eventName: "resize",
      fn: cancel
    }, {
      eventName: "scroll",
      options: {
        passive: true,
        capture: false
      },
      fn: function fn2() {
        if (pendingRef.current) {
          stop();
          return;
        }
        schedule.windowScrollMove();
      }
    }, {
      eventName: "contextmenu",
      fn: function fn2(event) {
        event.preventDefault();
      }
    }, {
      eventName: "keydown",
      fn: function fn2(event) {
        if (!isDraggingRef.current) {
          cancel();
          return;
        }
        if (event.keyCode === escape) {
          event.preventDefault();
        }
        cancel();
      }
    }, {
      eventName: "touchforcechange",
      fn: function fn2(event) {
        var touch = event.touches[0];
        var isForcePress = touch.force >= forcePressThreshold;
        if (!isForcePress) {
          return;
        }
        var shouldRespect = getShouldRespectForcePress();
        if (pendingRef.current) {
          if (shouldRespect) {
            cancel();
          }
          return;
        }
        if (shouldRespect) {
          if (hasMovedRef.current) {
            event.preventDefault();
            return;
          }
          cancel();
          return;
        }
        event.preventDefault();
      }
    }, {
      eventName: supportedEventName,
      fn: cancel
    }];
    return bindings;
  }, [callbacks, cancel, getIsCapturing, getShouldRespectForcePress, schedule, stop]);
  var bindWindowEvents = useCallback(function() {
    var win = getWindow2();
    var options = {
      capture: true
    };
    unbindWindowEventsRef.current = function() {
      return unbindEvents(win, windowBindings, options);
    };
    bindEvents(win, windowBindings, options);
  }, [getWindow2, windowBindings]);
  var startDragging = useCallback(function() {
    var pending = pendingRef.current;
    !pending ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot start a drag without a pending drag") : invariant$2() : void 0;
    isDraggingRef.current = true;
    pendingRef.current = null;
    hasMovedRef.current = false;
    callbacks.onLift({
      clientSelection: pending.point,
      movementMode: "FLUID"
    });
  }, [callbacks]);
  var startPendingDrag = useCallback(function(event) {
    !!pendingRef.current ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Expected there to be no pending drag") : invariant$2() : void 0;
    var touch = event.touches[0];
    var clientX = touch.clientX, clientY = touch.clientY;
    var point2 = {
      x: clientX,
      y: clientY
    };
    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
    var pending = {
      point: point2,
      longPressTimerId
    };
    pendingRef.current = pending;
    onCaptureStart(stop);
    bindWindowEvents();
  }, [bindWindowEvents, onCaptureStart, startDragging, stop]);
  var onTouchStart = function onTouchStart2(event) {
    if (touchStartMarshal.isHandled()) {
      return;
    }
    !!getIsCapturing() ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Should not be able to perform a touch start while a drag or pending drag is occurring") : invariant$2() : void 0;
    if (!canStartCapturing(event)) {
      return;
    }
    touchStartMarshal.handle();
    startPendingDrag(event);
  };
  useIsomorphicLayoutEffect$3(function webkitHack() {
    var unbind = bindEvents(window, [{
      eventName: "touchmove",
      fn: noop$3$1,
      options: {
        capture: false,
        passive: false
      }
    }]);
    return unbind;
  }, []);
  return onTouchStart;
}
function isSvgElement(el) {
  return Boolean(getWindowFromEl(el).SVGElement) && el instanceof getWindowFromEl(el).SVGElement;
}
var selector = "[" + dragHandle + "]";
var throwIfSVG = function throwIfSVG2(el) {
  !!isSvgElement(el) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "A drag handle cannot be an SVGElement: it has inconsistent focus support.\n\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/dragging-svgs.md") : invariant$2() : void 0;
};
var getDragHandleRef = function getDragHandleRef2(draggableRef) {
  if (draggableRef.hasAttribute(dragHandle)) {
    throwIfSVG(draggableRef);
    return draggableRef;
  }
  var el = draggableRef.querySelector(selector);
  throwIfSVG(draggableRef);
  !el ? process.env.NODE_ENV !== "production" ? invariant$2(false, "\n      Cannot find drag handle element inside of Draggable.\n      Please be sure to apply the {...provided.dragHandleProps} to your Draggable\n\n      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/draggable.md\n    ") : invariant$2() : void 0;
  !isHtmlElement(el) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "A drag handle must be a HTMLElement") : invariant$2() : void 0;
  return el;
};
function useValidation$1(_ref) {
  var isEnabled = _ref.isEnabled, getDraggableRef = _ref.getDraggableRef;
  useEffect(function() {
    if (process.env.NODE_ENV !== "production") {
      if (!isEnabled) {
        return;
      }
      var draggableRef = getDraggableRef();
      !draggableRef ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Drag handle was unable to find draggable ref") : invariant$2() : void 0;
      getDragHandleRef(draggableRef);
    }
  }, [getDraggableRef, isEnabled]);
}
var retainingFocusFor = null;
var listenerOptions = {
  capture: true
};
var clearRetentionOnFocusChange = function() {
  var isBound = false;
  var bind2 = function bind3() {
    if (isBound) {
      return;
    }
    isBound = true;
    window.addEventListener("focus", onWindowFocusChange, listenerOptions);
  };
  var unbind = function unbind2() {
    if (!isBound) {
      return;
    }
    isBound = false;
    window.removeEventListener("focus", onWindowFocusChange, listenerOptions);
  };
  var onWindowFocusChange = function onWindowFocusChange2() {
    unbind();
    retainingFocusFor = null;
  };
  var result = function result2() {
    return bind2();
  };
  result.cancel = function() {
    return unbind();
  };
  return result;
}();
var retain = function retain2(id) {
  retainingFocusFor = id;
  clearRetentionOnFocusChange();
};
var tryRestoreFocus = function tryRestoreFocus2(id, draggableRef) {
  if (!retainingFocusFor) {
    return;
  }
  if (id !== retainingFocusFor) {
    return;
  }
  retainingFocusFor = null;
  clearRetentionOnFocusChange.cancel();
  var dragHandleRef = getDragHandleRef(draggableRef);
  if (!dragHandleRef) {
    process.env.NODE_ENV !== "production" ? warning$1("Could not find drag handle in the DOM to focus on it") : void 0;
    return;
  }
  dragHandleRef.focus();
};
var retainer = {
  retain,
  tryRestoreFocus
};
function noop$4$1() {
}
function useFocusRetainer(args) {
  var isFocusedRef = useRef(false);
  var lastArgsRef = usePrevious$1(args);
  var getDraggableRef = args.getDraggableRef;
  var onFocus = useCallback(function() {
    isFocusedRef.current = true;
  }, []);
  var onBlur = useCallback(function() {
    isFocusedRef.current = false;
  }, []);
  useIsomorphicLayoutEffect$3(function() {
    var first2 = lastArgsRef.current;
    if (!first2.isEnabled) {
      return noop$4$1;
    }
    var draggable2 = getDraggableRef();
    !draggable2 ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Drag handle could not obtain draggable ref") : invariant$2() : void 0;
    var dragHandle2 = getDragHandleRef(draggable2);
    retainer.tryRestoreFocus(first2.draggableId, dragHandle2);
    return function() {
      var last = lastArgsRef.current;
      var shouldRetainFocus = function() {
        if (!last.isEnabled) {
          return false;
        }
        if (!isFocusedRef.current) {
          return false;
        }
        return last.isDragging || last.isDropAnimating;
      }();
      if (shouldRetainFocus) {
        retainer.retain(last.draggableId);
      }
    };
  }, [getDraggableRef, lastArgsRef]);
  var lastDraggableRef = useRef(null);
  useIsomorphicLayoutEffect$3(function() {
    if (!lastDraggableRef.current) {
      return;
    }
    var draggableRef = getDraggableRef();
    if (!draggableRef) {
      return;
    }
    if (draggableRef === lastDraggableRef.current) {
      return;
    }
    if (isFocusedRef.current && lastArgsRef.current.isEnabled) {
      getDragHandleRef(draggableRef).focus();
    }
  });
  useIsomorphicLayoutEffect$3(function() {
    lastDraggableRef.current = getDraggableRef();
  });
  return {
    onBlur,
    onFocus
  };
}
function preventHtml5Dnd(event) {
  event.preventDefault();
}
function useDragHandle(args) {
  var capturingRef = useRef(null);
  var onCaptureStart = useCallback(function(abort) {
    !!capturingRef.current ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot start capturing while something else is") : invariant$2() : void 0;
    capturingRef.current = {
      abort
    };
  }, []);
  var onCaptureEnd = useCallback(function() {
    !capturingRef.current ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot stop capturing while nothing is capturing") : invariant$2() : void 0;
    capturingRef.current = null;
  }, []);
  var abortCapture = useCallback(function() {
    !capturingRef.current ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot abort capture when there is none") : invariant$2() : void 0;
    capturingRef.current.abort();
  }, []);
  var _useRequiredContext = useRequiredContext(AppContext), canLift = _useRequiredContext.canLift, styleContext = _useRequiredContext.style;
  var isDragging = args.isDragging, isEnabled = args.isEnabled, draggableId = args.draggableId, callbacks = args.callbacks, getDraggableRef = args.getDraggableRef, getShouldRespectForcePress = args.getShouldRespectForcePress, canDragInteractiveElements = args.canDragInteractiveElements;
  var lastArgsRef = usePrevious$1(args);
  useValidation$1({
    isEnabled,
    getDraggableRef
  });
  var getWindow2 = useCallback(function() {
    return getWindowFromEl(getDraggableRef());
  }, [getDraggableRef]);
  var canStartCapturing = useCallback(function(event) {
    if (!isEnabled) {
      return false;
    }
    if (capturingRef.current) {
      return false;
    }
    if (!canLift(draggableId)) {
      return false;
    }
    return shouldAllowDraggingFromTarget(event, canDragInteractiveElements);
  }, [canDragInteractiveElements, canLift, draggableId, isEnabled]);
  var _useFocusRetainer = useFocusRetainer(args), onBlur = _useFocusRetainer.onBlur, onFocus = _useFocusRetainer.onFocus;
  var mouseArgs = useMemo(function() {
    return {
      callbacks,
      getDraggableRef,
      getWindow: getWindow2,
      canStartCapturing,
      onCaptureStart,
      onCaptureEnd,
      getShouldRespectForcePress
    };
  }, [callbacks, getDraggableRef, getWindow2, canStartCapturing, onCaptureStart, onCaptureEnd, getShouldRespectForcePress]);
  var onMouseDown = useMouseSensor(mouseArgs);
  var keyboardArgs = useMemo(function() {
    return {
      callbacks,
      getDraggableRef,
      getWindow: getWindow2,
      canStartCapturing,
      onCaptureStart,
      onCaptureEnd
    };
  }, [callbacks, canStartCapturing, getDraggableRef, getWindow2, onCaptureEnd, onCaptureStart]);
  var onKeyDown = useKeyboardSensor(keyboardArgs);
  var touchArgs = useMemo(function() {
    return {
      callbacks,
      getDraggableRef,
      getWindow: getWindow2,
      canStartCapturing,
      getShouldRespectForcePress,
      onCaptureStart,
      onCaptureEnd
    };
  }, [callbacks, getDraggableRef, getWindow2, canStartCapturing, getShouldRespectForcePress, onCaptureStart, onCaptureEnd]);
  var onTouchStart = useTouchSensor(touchArgs);
  useIsomorphicLayoutEffect$3(function() {
    return function() {
      if (!capturingRef.current) {
        return;
      }
      abortCapture();
      if (lastArgsRef.current.isDragging) {
        lastArgsRef.current.callbacks.onCancel();
      }
    };
  }, []);
  if (!isEnabled && capturingRef.current) {
    abortCapture();
    if (lastArgsRef.current.isDragging) {
      process.env.NODE_ENV !== "production" ? warning$1("You have disabled dragging on a Draggable while it was dragging. The drag has been cancelled") : void 0;
      callbacks.onCancel();
    }
  }
  useIsomorphicLayoutEffect$3(function() {
    if (!isDragging && capturingRef.current) {
      abortCapture();
    }
  }, [abortCapture, isDragging]);
  var props = useMemo(function() {
    if (!isEnabled) {
      return null;
    }
    return {
      onMouseDown,
      onKeyDown,
      onTouchStart,
      onFocus,
      onBlur,
      tabIndex: 0,
      "data-react-beautiful-dnd-drag-handle": styleContext,
      "aria-roledescription": "Draggable item. Press space bar to lift",
      draggable: false,
      onDragStart: preventHtml5Dnd
    };
  }, [isEnabled, onBlur, onFocus, onKeyDown, onMouseDown, onTouchStart, styleContext]);
  return props;
}
function getDimension$1(descriptor, el, windowScroll) {
  if (windowScroll === void 0) {
    windowScroll = origin;
  }
  var computedStyles = window.getComputedStyle(el);
  var borderBox = el.getBoundingClientRect();
  var client2 = calculateBox(borderBox, computedStyles);
  var page = withScroll(client2, windowScroll);
  var placeholder2 = {
    client: client2,
    tagName: el.tagName.toLowerCase(),
    display: computedStyles.display
  };
  var displaceBy = {
    x: client2.marginBox.width,
    y: client2.marginBox.height
  };
  var dimension = {
    descriptor,
    placeholder: placeholder2,
    displaceBy,
    client: client2,
    page
  };
  return dimension;
}
function useDraggableDimensionPublisher(args) {
  var draggableId = args.draggableId, index2 = args.index, getDraggableRef = args.getDraggableRef;
  var appContext = useRequiredContext(AppContext);
  var marshal = appContext.marshal;
  var droppableContext = useRequiredContext(DroppableContext);
  var droppableId = droppableContext.droppableId, type = droppableContext.type;
  var descriptor = useMemo(function() {
    var result = {
      id: draggableId,
      droppableId,
      type,
      index: index2
    };
    return result;
  }, [draggableId, droppableId, index2, type]);
  var publishedDescriptorRef = useRef(descriptor);
  var makeDimension = useCallback(function(windowScroll) {
    var latest = publishedDescriptorRef.current;
    var el = getDraggableRef();
    !el ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot get dimension when no ref is set") : invariant$2() : void 0;
    return getDimension$1(latest, el, windowScroll);
  }, [getDraggableRef]);
  useIsomorphicLayoutEffect$3(function() {
    marshal.registerDraggable(publishedDescriptorRef.current, makeDimension);
    return function() {
      return marshal.unregisterDraggable(publishedDescriptorRef.current);
    };
  }, [makeDimension, marshal]);
  useIsomorphicLayoutEffect$3(function() {
    if (publishedDescriptorRef.current === descriptor) {
      return;
    }
    var previous2 = publishedDescriptorRef.current;
    publishedDescriptorRef.current = descriptor;
    marshal.updateDraggable(previous2, descriptor, makeDimension);
  }, [descriptor, makeDimension, marshal]);
}
function checkOwnProps$1(props) {
  !_Number$isInteger(props.index) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Draggable requires an integer index prop") : invariant$2() : void 0;
  !props.draggableId ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Draggable requires a draggableId") : invariant$2() : void 0;
  !(typeof props.isDragDisabled === "boolean") ? process.env.NODE_ENV !== "production" ? invariant$2(false, "isDragDisabled must be a boolean") : invariant$2() : void 0;
}
function checkForOutdatedProps(props) {
  if (Object.prototype.hasOwnProperty.call(props, "shouldRespectForceTouch")) {
    process.env.NODE_ENV !== "production" ? warning$1("shouldRespectForceTouch has been renamed to shouldRespectForcePress") : void 0;
  }
}
function useValidation$2(props, getRef) {
  useEffect(function() {
    if (process.env.NODE_ENV !== "production") {
      checkOwnProps$1(props);
      checkForOutdatedProps(props);
      checkIsValidInnerRef(getRef());
    }
  });
}
function Draggable(props) {
  var ref2 = useRef(null);
  var setRef = useCallback(function(el) {
    ref2.current = el;
  }, []);
  var getRef = useCallback(function() {
    return ref2.current;
  }, []);
  var appContext = useRequiredContext(AppContext);
  useValidation$2(props, getRef);
  var children = props.children, draggableId = props.draggableId, isDragDisabled = props.isDragDisabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.disableInteractiveElementBlocking, index2 = props.index, mapped = props.mapped, moveUpAction = props.moveUp, moveAction = props.move, dropAction = props.drop, moveDownAction = props.moveDown, moveRightAction = props.moveRight, moveLeftAction = props.moveLeft, moveByWindowScrollAction = props.moveByWindowScroll, liftAction = props.lift, dropAnimationFinishedAction = props.dropAnimationFinished;
  var forPublisher = useMemo(function() {
    return {
      draggableId,
      index: index2,
      getDraggableRef: getRef
    };
  }, [draggableId, getRef, index2]);
  useDraggableDimensionPublisher(forPublisher);
  var onLift = useCallback(function(options) {
    start2();
    var el = ref2.current;
    !el ? process.env.NODE_ENV !== "production" ? invariant$2() : invariant$2() : void 0;
    !!isDragDisabled ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot lift a Draggable when it is disabled") : invariant$2() : void 0;
    var clientSelection = options.clientSelection, movementMode = options.movementMode;
    liftAction({
      id: draggableId,
      clientSelection,
      movementMode
    });
    finish2();
  }, [draggableId, isDragDisabled, liftAction]);
  var getShouldRespectForcePress = useCallback(function() {
    return shouldRespectForcePress;
  }, [shouldRespectForcePress]);
  var callbacks = useMemo(function() {
    return {
      onLift,
      onMove: function onMove(clientSelection) {
        return moveAction({
          client: clientSelection
        });
      },
      onDrop: function onDrop() {
        return dropAction({
          reason: "DROP"
        });
      },
      onCancel: function onCancel() {
        return dropAction({
          reason: "CANCEL"
        });
      },
      onMoveUp: moveUpAction,
      onMoveDown: moveDownAction,
      onMoveRight: moveRightAction,
      onMoveLeft: moveLeftAction,
      onWindowScroll: function onWindowScroll() {
        return moveByWindowScrollAction({
          newScroll: getWindowScroll2()
        });
      }
    };
  }, [dropAction, moveAction, moveByWindowScrollAction, moveDownAction, moveLeftAction, moveRightAction, moveUpAction, onLift]);
  var isDragging = mapped.type === "DRAGGING";
  var isDropAnimating = mapped.type === "DRAGGING" && Boolean(mapped.dropping);
  var dragHandleArgs = useMemo(function() {
    return {
      draggableId,
      isDragging,
      isDropAnimating,
      isEnabled: !isDragDisabled,
      callbacks,
      getDraggableRef: getRef,
      canDragInteractiveElements,
      getShouldRespectForcePress
    };
  }, [callbacks, canDragInteractiveElements, draggableId, getRef, getShouldRespectForcePress, isDragDisabled, isDragging, isDropAnimating]);
  var dragHandleProps = useDragHandle(dragHandleArgs);
  var onMoveEnd = useCallback(function(event) {
    if (mapped.type !== "DRAGGING") {
      return;
    }
    if (!mapped.dropping) {
      return;
    }
    if (event.propertyName !== "transform") {
      return;
    }
    dropAnimationFinishedAction();
  }, [dropAnimationFinishedAction, mapped]);
  var provided = useMemo(function() {
    var style3 = getStyle$1(mapped);
    var onTransitionEnd = mapped.type === "DRAGGING" && mapped.dropping ? onMoveEnd : null;
    var result = {
      innerRef: setRef,
      draggableProps: {
        "data-react-beautiful-dnd-draggable": appContext.style,
        style: style3,
        onTransitionEnd
      },
      dragHandleProps
    };
    return result;
  }, [appContext.style, dragHandleProps, mapped, onMoveEnd, setRef]);
  return children(provided, mapped.snapshot);
}
var getCombineWithFromResult2 = function getCombineWithFromResult3(result) {
  return result.combine ? result.combine.draggableId : null;
};
var getCombineWithFromImpact2 = function getCombineWithFromImpact3(impact) {
  return impact.merge ? impact.merge.combine.draggableId : null;
};
var makeMapStateToProps$1 = function makeMapStateToProps5() {
  var getDraggingSnapshot = memoizeOne(function(mode, draggingOver, combineWith, dropping) {
    return {
      isDragging: true,
      isDropAnimating: Boolean(dropping),
      dropAnimation: dropping,
      mode,
      draggingOver,
      combineWith,
      combineTargetFor: null
    };
  });
  var getSecondarySnapshot2 = memoizeOne(function(combineTargetFor) {
    return {
      isDragging: false,
      isDropAnimating: false,
      dropAnimation: null,
      mode: null,
      draggingOver: null,
      combineTargetFor,
      combineWith: null
    };
  });
  var defaultMapProps = {
    mapped: {
      type: "SECONDARY",
      offset: origin,
      combineTargetFor: null,
      shouldAnimateDisplacement: true,
      snapshot: getSecondarySnapshot2(null)
    }
  };
  var memoizedOffset = memoizeOne(function(x2, y2) {
    return {
      x: x2,
      y: y2
    };
  });
  var getDraggingProps = memoizeOne(function(offset3, mode, dimension, draggingOver, combineWith, forceShouldAnimate) {
    return {
      mapped: {
        type: "DRAGGING",
        dropping: null,
        draggingOver,
        combineWith,
        mode,
        offset: offset3,
        dimension,
        forceShouldAnimate,
        snapshot: getDraggingSnapshot(mode, draggingOver, combineWith, null)
      }
    };
  });
  var getSecondaryProps = memoizeOne(function(offset3, combineTargetFor, shouldAnimateDisplacement) {
    if (combineTargetFor === void 0) {
      combineTargetFor = null;
    }
    return {
      mapped: {
        type: "SECONDARY",
        offset: offset3,
        combineTargetFor,
        shouldAnimateDisplacement,
        snapshot: getSecondarySnapshot2(combineTargetFor)
      }
    };
  });
  var getSecondaryMovement = function getSecondaryMovement2(ownId, draggingId, impact) {
    var map3 = impact.movement.map;
    var displacement = map3[ownId];
    var movement = impact.movement;
    var merge3 = impact.merge;
    var isCombinedWith = Boolean(merge3 && merge3.combine.draggableId === ownId);
    var displacedBy = movement.displacedBy.point;
    var offset3 = memoizedOffset(displacedBy.x, displacedBy.y);
    if (isCombinedWith) {
      return getSecondaryProps(displacement ? offset3 : origin, draggingId, displacement ? displacement.shouldAnimate : true);
    }
    if (!displacement) {
      return null;
    }
    if (!displacement.isVisible) {
      return null;
    }
    return getSecondaryProps(offset3, null, displacement.shouldAnimate);
  };
  var draggingSelector = function draggingSelector2(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id !== ownProps.draggableId) {
        return null;
      }
      var offset3 = state.current.client.offset;
      var dimension = state.dimensions.draggables[ownProps.draggableId];
      var mode = state.movementMode;
      var draggingOver = whatIsDraggedOver(state.impact);
      var combineWith = getCombineWithFromImpact2(state.impact);
      var forceShouldAnimate = state.forceShouldAnimate;
      return getDraggingProps(memoizedOffset(offset3.x, offset3.y), mode, dimension, draggingOver, combineWith, forceShouldAnimate);
    }
    if (state.phase === "DROP_ANIMATING") {
      var completed = state.completed;
      if (completed.result.draggableId !== ownProps.draggableId) {
        return null;
      }
      var _dimension = state.dimensions.draggables[ownProps.draggableId];
      var result = completed.result;
      var _mode = result.mode;
      var _draggingOver = whatIsDraggedOverFromResult(result);
      var _combineWith = getCombineWithFromResult2(result);
      var duration = state.dropDuration;
      var dropping = {
        duration,
        curve: curves.drop,
        moveTo: state.newHomeClientOffset,
        opacity: _combineWith ? combine.opacity.drop : null,
        scale: _combineWith ? combine.scale.drop : null
      };
      return {
        mapped: {
          type: "DRAGGING",
          offset: state.newHomeClientOffset,
          dimension: _dimension,
          dropping,
          draggingOver: _draggingOver,
          combineWith: _combineWith,
          mode: _mode,
          forceShouldAnimate: null,
          snapshot: getDraggingSnapshot(_mode, _draggingOver, _combineWith, dropping)
        }
      };
    }
    return null;
  };
  var secondarySelector = function secondarySelector2(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id === ownProps.draggableId) {
        return null;
      }
      return getSecondaryMovement(ownProps.draggableId, state.critical.draggable.id, state.impact);
    }
    if (state.phase === "DROP_ANIMATING") {
      var completed = state.completed;
      if (completed.result.draggableId === ownProps.draggableId) {
        return null;
      }
      return getSecondaryMovement(ownProps.draggableId, completed.result.draggableId, completed.impact);
    }
    return null;
  };
  var selector2 = function selector3(state, ownProps) {
    return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || defaultMapProps;
  };
  return selector2;
};
var mapDispatchToProps$1 = {
  lift: lift$3,
  move: move2,
  moveUp: moveUp2,
  moveDown: moveDown2,
  moveLeft: moveLeft2,
  moveRight: moveRight2,
  moveByWindowScroll: moveByWindowScroll2,
  drop: drop4,
  dropAnimationFinished: dropAnimationFinished2
};
var defaultProps$1 = {
  isDragDisabled: false,
  disableInteractiveElementBlocking: false,
  shouldRespectForcePress: false
};
var ConnectedDraggable = connect(makeMapStateToProps$1, mapDispatchToProps$1, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Draggable);
ConnectedDraggable.defaultProps = defaultProps$1;
function _arrayLikeToArray$1(r2, a2) {
  (null == a2 || a2 > r2.length) && (a2 = r2.length);
  for (var e = 0, n2 = Array(a2); e < a2; e++) n2[e] = r2[e];
  return n2;
}
function _arrayWithoutHoles(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray$1(r2);
}
function _iterableToArray(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _unsupportedIterableToArray$1(r2, a2) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray$1(r2, a2);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray$1(r2, a2) : void 0;
  }
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(r2) {
  return _arrayWithoutHoles(r2) || _iterableToArray(r2) || _unsupportedIterableToArray$1(r2) || _nonIterableSpread();
}
var isSamePath = function isSamePath2(a2, b2) {
  if (a2 === b2) {
    return true;
  }
  return a2.length === b2.length && a2.every(function(v2, i) {
    return v2 === b2[i];
  });
};
var hasSameParent = function hasSameParent2(a2, b2) {
  return isSamePath(getParentPath(a2), getParentPath(b2));
};
var getParentPath = function getParentPath2(child) {
  return child.slice(0, child.length - 1);
};
var isTopOfSubtree = function isTopOfSubtree2(belowPath, abovePath) {
  return !abovePath || isParentOf(abovePath, belowPath);
};
var isParentOf = function isParentOf2(parent2, child) {
  return isSamePath(parent2, getParentPath(child));
};
var getIndexAmongSiblings = function getIndexAmongSiblings2(path2) {
  var lastIndex = path2[path2.length - 1];
  return lastIndex;
};
var getPathOnLevel = function getPathOnLevel2(path2, level) {
  return path2.slice(0, level);
};
var moveAfterPath = function moveAfterPath2(after, from3) {
  var newPath = _toConsumableArray(after);
  var movedDownOnTheSameLevel = isLowerSibling(newPath, from3);
  if (!movedDownOnTheSameLevel) {
    newPath[newPath.length - 1] += 1;
  }
  return newPath;
};
var isLowerSibling = function isLowerSibling2(a2, other2) {
  return hasSameParent(a2, other2) && getIndexAmongSiblings(a2) > getIndexAmongSiblings(other2);
};
function ownKeys$4(e, r2) {
  var t2 = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t2.push.apply(t2, o2);
  }
  return t2;
}
function _objectSpread$3(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t2 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$4(Object(t2), true).forEach(function(r3) {
      _defineProperty$3(e, r3, t2[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t2)) : ownKeys$4(Object(t2)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t2, r3));
    });
  }
  return e;
}
var mutateTree = function mutateTree2(tree, itemId, mutation) {
  var itemToChange = tree.items[itemId];
  if (!itemToChange) {
    return tree;
  }
  return {
    // rootId should not change
    rootId: tree.rootId,
    items: _objectSpread$3(_objectSpread$3({}, tree.items), {}, _defineProperty$3({}, itemId, _objectSpread$3(_objectSpread$3({}, itemToChange), mutation)))
  };
};
function _createForOfIteratorHelper(r2, e) {
  var t2 = "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (!t2) {
    if (Array.isArray(r2) || (t2 = _unsupportedIterableToArray(r2)) || e) {
      t2 && (r2 = t2);
      var _n = 0, F2 = function F3() {
      };
      return { s: F2, n: function n2() {
        return _n >= r2.length ? { done: true } : { done: false, value: r2[_n++] };
      }, e: function e2(r3) {
        throw r3;
      }, f: F2 };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o2, a2 = true, u2 = false;
  return { s: function s2() {
    t2 = t2.call(r2);
  }, n: function n2() {
    var r3 = t2.next();
    return a2 = r3.done, r3;
  }, e: function e2(r3) {
    u2 = true, o2 = r3;
  }, f: function f2() {
    try {
      a2 || null == t2.return || t2.return();
    } finally {
      if (u2) throw o2;
    }
  } };
}
function _unsupportedIterableToArray(r2, a2) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray(r2, a2);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray(r2, a2) : void 0;
  }
}
function _arrayLikeToArray(r2, a2) {
  (null == a2 || a2 > r2.length) && (a2 = r2.length);
  for (var e = 0, n2 = Array(a2); e < a2; e++) n2[e] = r2[e];
  return n2;
}
var flattenTree = function flattenTree2(tree) {
  var path2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return tree.items[tree.rootId] ? tree.items[tree.rootId].children.reduce(function(accum, itemId, index2) {
    var item = tree.items[itemId];
    var currentPath = [].concat(_toConsumableArray(path2), [index2]);
    var currentItem = createFlattenedItem(item, currentPath);
    var children = flattenChildren(tree, item, currentPath);
    return [].concat(_toConsumableArray(accum), [currentItem], _toConsumableArray(children));
  }, []) : [];
};
var createFlattenedItem = function createFlattenedItem2(item, currentPath) {
  return {
    item,
    path: currentPath
  };
};
var flattenChildren = function flattenChildren2(tree, item, currentPath) {
  return item.isExpanded ? flattenTree({
    rootId: item.id,
    items: tree.items
  }, currentPath) : [];
};
var getItem = function getItem2(tree, path2) {
  var cursor2 = tree.items[tree.rootId];
  var _iterator = _createForOfIteratorHelper(path2), _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
      var i = _step.value;
      cursor2 = tree.items[cursor2.children[i]];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return cursor2;
};
var getParent = function getParent2(tree, path2) {
  var parentPath = getParentPath(path2);
  return getItem(tree, parentPath);
};
var getTreePosition = function getTreePosition2(tree, path2) {
  var parent2 = getParent(tree, path2);
  var index2 = getIndexAmongSiblings(path2);
  return {
    parentId: parent2.id,
    index: index2
  };
};
var hasLoadedChildren = function hasLoadedChildren2(item) {
  return !!item.hasChildren && item.children.length > 0;
};
var isLeafItem = function isLeafItem2(item) {
  return !item.hasChildren;
};
var removeItemFromTree = function removeItemFromTree2(tree, position4) {
  var sourceParent = tree.items[position4.parentId];
  var newSourceChildren = _toConsumableArray(sourceParent.children);
  var itemRemoved = newSourceChildren.splice(position4.index, 1)[0];
  var newTree = mutateTree(tree, position4.parentId, {
    children: newSourceChildren,
    hasChildren: newSourceChildren.length > 0,
    isExpanded: newSourceChildren.length > 0 && sourceParent.isExpanded
  });
  return {
    tree: newTree,
    itemRemoved
  };
};
var addItemToTree = function addItemToTree2(tree, position4, item) {
  var destinationParent = tree.items[position4.parentId];
  var newDestinationChildren = _toConsumableArray(destinationParent.children);
  if (typeof position4.index === "undefined") {
    if (hasLoadedChildren(destinationParent) || isLeafItem(destinationParent)) {
      newDestinationChildren.push(item);
    }
  } else {
    newDestinationChildren.splice(position4.index, 0, item);
  }
  return mutateTree(tree, position4.parentId, {
    children: newDestinationChildren,
    hasChildren: true
  });
};
var noop$4 = function noop4() {
};
var between = function between2(min2, max2, number2) {
  return Math.min(max2, Math.max(min2, number2));
};
var getFlatItemPath = function getFlatItemPath2(flattenedTree, sourceIndex) {
  return flattenedTree[sourceIndex].path;
};
var getSourcePath = getFlatItemPath;
var getDestinationPath = function getDestinationPath2(flattenedTree, sourceIndex, destinationIndex, level) {
  var down = destinationIndex > sourceIndex;
  var sourcePath = getSourcePath(flattenedTree, sourceIndex);
  var sameIndex = destinationIndex === sourceIndex;
  var upperPath = down ? flattenedTree[destinationIndex].path : flattenedTree[destinationIndex - 1] && flattenedTree[destinationIndex - 1].path;
  var lowerPath = down || sameIndex ? flattenedTree[destinationIndex + 1] && flattenedTree[destinationIndex + 1].path : flattenedTree[destinationIndex].path;
  if (sameIndex) {
    if (typeof level !== "number") {
      return sourcePath;
    }
    if (!upperPath) {
      return sourcePath;
    }
    var minLevel = lowerPath ? lowerPath.length : 1;
    var maxLevel = Math.max(sourcePath.length, upperPath.length);
    var finalLevel = between(minLevel, maxLevel, level);
    var sameLevel = finalLevel === sourcePath.length;
    if (sameLevel) {
      return sourcePath;
    }
    var previousPathOnTheFinalLevel = getPathOnLevel(upperPath, finalLevel);
    return moveAfterPath(previousPathOnTheFinalLevel, sourcePath);
  }
  if (lowerPath && isTopOfSubtree(lowerPath, upperPath)) {
    return lowerPath;
  }
  if (upperPath && lowerPath && hasSameParent(upperPath, lowerPath)) {
    if (down && hasSameParent(upperPath, sourcePath)) {
      return upperPath;
    }
    return lowerPath;
  }
  if (upperPath) {
    var _finalLevel = calculateFinalLevel(sourcePath, upperPath, lowerPath, level);
    var _previousPathOnTheFinalLevel = getPathOnLevel(upperPath, _finalLevel);
    return moveAfterPath(_previousPathOnTheFinalLevel, sourcePath);
  }
  return sourcePath;
};
var calculateFinalLevel = function calculateFinalLevel2(sourcePath, upperPath, lowerPath, level) {
  var upperLevel = upperPath.length;
  var lowerLevel = lowerPath ? lowerPath.length : 1;
  var sourceLevel = sourcePath.length;
  if (typeof level === "number") {
    return between(lowerLevel, upperLevel, level);
  }
  return sourceLevel <= lowerLevel ? lowerLevel : upperLevel;
};
var getItemById$1 = function getItemById(flattenedTree, id) {
  return flattenedTree.find(function(item) {
    return item.item.id === id;
  });
};
var getIndexById = function getIndexById2(flattenedTree, id) {
  return flattenedTree.findIndex(function(item) {
    return item.item.id === id;
  });
};
function ownKeys$3(e, r2) {
  var t2 = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t2.push.apply(t2, o2);
  }
  return t2;
}
function _objectSpread$2(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t2 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$3(Object(t2), true).forEach(function(r3) {
      _defineProperty$3(e, r3, t2[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t2)) : ownKeys$3(Object(t2)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t2, r3));
    });
  }
  return e;
}
var calculateFinalDropPositions = function calculateFinalDropPositions2(tree, flattenedTree, dragState) {
  var source = dragState.source, destination = dragState.destination, combine2 = dragState.combine, horizontalLevel = dragState.horizontalLevel;
  var sourcePath = getSourcePath(flattenedTree, source.index);
  var sourcePosition = getTreePosition(tree, sourcePath);
  if (combine2) {
    return {
      sourcePosition,
      destinationPosition: {
        parentId: combine2.draggableId
      }
    };
  }
  if (!destination) {
    return {
      sourcePosition,
      destinationPosition: void 0
    };
  }
  var destinationPath = getDestinationPath(flattenedTree, source.index, destination.index, horizontalLevel);
  var destinationPosition = _objectSpread$2({}, getTreePosition(tree, destinationPath));
  return {
    sourcePosition,
    destinationPosition
  };
};
var sameProps = function sameProps2(oldProps, newProps, props) {
  return props.find(function(p2) {
    return oldProps[p2] !== newProps[p2];
  }) === void 0;
};
function ownKeys$2(e, r2) {
  var t2 = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t2.push.apply(t2, o2);
  }
  return t2;
}
function _objectSpread$1(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t2 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$2(Object(t2), true).forEach(function(r3) {
      _defineProperty$3(e, r3, t2[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t2)) : ownKeys$2(Object(t2)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t2, r3));
    });
  }
  return e;
}
function _createSuper$1(t2) {
  var r2 = _isNativeReflectConstruct$1();
  return function() {
    var e, o2 = _getPrototypeOf(t2);
    if (r2) {
      var s2 = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o2, arguments, s2);
    } else e = o2.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct$1() {
  try {
    var t2 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t3) {
  }
  return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct2() {
    return !!t2;
  })();
}
var TreeItem = /* @__PURE__ */ function(_Component) {
  _inherits(TreeItem2, _Component);
  var _super = _createSuper$1(TreeItem2);
  function TreeItem2() {
    var _this;
    _classCallCheck(this, TreeItem2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$3(_assertThisInitialized(_this), "patchDraggableProps", function(draggableProps, snapshot) {
      var _this$props = _this.props, path2 = _this$props.path, offsetPerLevel = _this$props.offsetPerLevel;
      var transitions2 = draggableProps.style && draggableProps.style.transition ? [draggableProps.style.transition] : [];
      if (snapshot.dropAnimation) {
        transitions2.push(
          // @ts-ignore
          "padding-left ".concat(snapshot.dropAnimation.duration, "s ").concat(snapshot.dropAnimation.curve)
        );
      }
      var transition = transitions2.join(", ");
      return _objectSpread$1(_objectSpread$1({}, draggableProps), {}, {
        style: _objectSpread$1(_objectSpread$1({}, draggableProps.style), {}, {
          paddingLeft: (path2.length - 1) * offsetPerLevel,
          // @ts-ignore
          transition
        })
      });
    });
    return _this;
  }
  _createClass(TreeItem2, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !sameProps(this.props, nextProps, ["item", "provided", "snapshot", "onCollapse", "onExpand"]) || !isSamePath(this.props.path, nextProps.path) || // also rerender tree item even if the item is not draggable, this allows draggable/nondraggable items to behave the same
      this.props.provided.dragHandleProps === null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props, item = _this$props2.item, path2 = _this$props2.path, _onExpand = _this$props2.onExpand, _onCollapse = _this$props2.onCollapse, renderItem = _this$props2.renderItem, provided = _this$props2.provided, snapshot = _this$props2.snapshot, itemRef = _this$props2.itemRef;
      var innerRef = function innerRef2(el) {
        itemRef(item.id, el);
        provided.innerRef(el);
      };
      var finalProvided = {
        draggableProps: this.patchDraggableProps(provided.draggableProps, snapshot),
        dragHandleProps: provided.dragHandleProps,
        innerRef
      };
      return renderItem({
        item,
        depth: path2.length - 1,
        onExpand: function onExpand(itemId) {
          return _onExpand(itemId, path2);
        },
        onCollapse: function onCollapse(itemId) {
          return _onCollapse(itemId, path2);
        },
        provided: finalProvided,
        snapshot
      });
    }
  }]);
  return TreeItem2;
}(Component);
var DelayedFunction = /* @__PURE__ */ function() {
  function DelayedFunction2(delay) {
    _classCallCheck(this, DelayedFunction2);
    this.delay = delay;
  }
  _createClass(DelayedFunction2, [{
    key: "start",
    value: function start4(fn2) {
      this.stop();
      this.timeoutId = window.setTimeout(fn2, this.delay);
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = void 0;
      }
    }
  }]);
  return DelayedFunction2;
}();
function ownKeys$1(e, r2) {
  var t2 = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t2.push.apply(t2, o2);
  }
  return t2;
}
function _objectSpread(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t2 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$1(Object(t2), true).forEach(function(r3) {
      _defineProperty$3(e, r3, t2[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t2)) : ownKeys$1(Object(t2)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t2, r3));
    });
  }
  return e;
}
function _createSuper(t2) {
  var r2 = _isNativeReflectConstruct();
  return function() {
    var e, o2 = _getPrototypeOf(t2);
    if (r2) {
      var s2 = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o2, arguments, s2);
    } else e = o2.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t2 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t3) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
    return !!t2;
  })();
}
var Tree = /* @__PURE__ */ function(_Component) {
  _inherits(Tree2, _Component);
  var _super = _createSuper(Tree2);
  function Tree2() {
    var _this;
    _classCallCheck(this, Tree2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$3(_assertThisInitialized(_this), "state", {
      flattenedTree: [],
      draggedItemId: void 0
    });
    _defineProperty$3(_assertThisInitialized(_this), "itemsElement", {});
    _defineProperty$3(_assertThisInitialized(_this), "expandTimer", new DelayedFunction(500));
    _defineProperty$3(_assertThisInitialized(_this), "onDragStart", function(result) {
      var onDragStart4 = _this.props.onDragStart;
      _this.dragState = {
        source: result.source,
        destination: result.source,
        mode: result.mode
      };
      _this.setState({
        draggedItemId: result.draggableId
      });
      if (onDragStart4) {
        onDragStart4(result.draggableId);
      }
    });
    _defineProperty$3(_assertThisInitialized(_this), "onDragUpdate", function(update2) {
      var onExpand = _this.props.onExpand;
      var flattenedTree = _this.state.flattenedTree;
      if (!_this.dragState) {
        return;
      }
      _this.expandTimer.stop();
      if (update2.combine) {
        var draggableId = update2.combine.draggableId;
        var item = getItemById$1(flattenedTree, draggableId);
        if (item && _this.isExpandable(item)) {
          _this.expandTimer.start(function() {
            return onExpand(draggableId, item.path);
          });
        }
      }
      _this.dragState = _objectSpread(_objectSpread({}, _this.dragState), {}, {
        destination: update2.destination,
        combine: update2.combine
      });
    });
    _defineProperty$3(_assertThisInitialized(_this), "onDropAnimating", function() {
      _this.expandTimer.stop();
    });
    _defineProperty$3(_assertThisInitialized(_this), "onDragEnd", function(result) {
      var _this$props = _this.props, onDragEnd4 = _this$props.onDragEnd, tree = _this$props.tree;
      var flattenedTree = _this.state.flattenedTree;
      _this.expandTimer.stop();
      var finalDragState = _objectSpread(_objectSpread({}, _this.dragState), {}, {
        source: result.source,
        destination: result.destination,
        combine: result.combine
      });
      _this.setState({
        draggedItemId: void 0
      });
      var _calculateFinalDropPo = calculateFinalDropPositions(tree, flattenedTree, finalDragState), sourcePosition = _calculateFinalDropPo.sourcePosition, destinationPosition = _calculateFinalDropPo.destinationPosition;
      onDragEnd4(sourcePosition, destinationPosition);
      _this.dragState = void 0;
    });
    _defineProperty$3(_assertThisInitialized(_this), "onPointerMove", function() {
      if (_this.dragState) {
        _this.dragState = _objectSpread(_objectSpread({}, _this.dragState), {}, {
          horizontalLevel: _this.getDroppedLevel()
        });
      }
    });
    _defineProperty$3(_assertThisInitialized(_this), "calculateEffectivePath", function(flatItem, snapshot) {
      var _this$state = _this.state, flattenedTree = _this$state.flattenedTree, draggedItemId = _this$state.draggedItemId;
      if (_this.dragState && draggedItemId === flatItem.item.id && (_this.dragState.destination || _this.dragState.combine)) {
        var _this$dragState = _this.dragState, source = _this$dragState.source, destination = _this$dragState.destination, combine2 = _this$dragState.combine, horizontalLevel = _this$dragState.horizontalLevel, mode = _this$dragState.mode;
        if (mode === "SNAP" || snapshot.isDropAnimating) {
          if (destination) {
            return getDestinationPath(flattenedTree, source.index, destination.index, horizontalLevel);
          }
          if (combine2) {
            return getDestinationPath(flattenedTree, source.index, getIndexById(flattenedTree, combine2.draggableId), horizontalLevel);
          }
        }
      }
      return flatItem.path;
    });
    _defineProperty$3(_assertThisInitialized(_this), "isExpandable", function(item) {
      return !!item.item.hasChildren && !item.item.isExpanded;
    });
    _defineProperty$3(_assertThisInitialized(_this), "getDroppedLevel", function() {
      var offsetPerLevel = _this.props.offsetPerLevel;
      var draggedItemId = _this.state.draggedItemId;
      if (!_this.dragState || !_this.containerElement) {
        return void 0;
      }
      var containerLeft = getBox(_this.containerElement).contentBox.left;
      var itemElement = _this.itemsElement[draggedItemId];
      if (itemElement) {
        var currentLeft = getBox(itemElement).contentBox.left;
        var relativeLeft = Math.max(currentLeft - containerLeft, 0);
        return Math.floor((relativeLeft + offsetPerLevel / 2) / offsetPerLevel) + 1;
      }
      return void 0;
    });
    _defineProperty$3(_assertThisInitialized(_this), "patchDroppableProvided", function(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        innerRef: function innerRef(el) {
          _this.containerElement = el;
          provided.innerRef(el);
        }
      });
    });
    _defineProperty$3(_assertThisInitialized(_this), "setItemRef", function(itemId, el) {
      if (!!el) {
        _this.itemsElement[itemId] = el;
      }
    });
    _defineProperty$3(_assertThisInitialized(_this), "renderItems", function() {
      var flattenedTree = _this.state.flattenedTree;
      return flattenedTree.map(_this.renderItem);
    });
    _defineProperty$3(_assertThisInitialized(_this), "renderItem", function(flatItem, index2) {
      var isDragEnabled = _this.props.isDragEnabled;
      if (isDragEnabled === false) {
        return _this.renderTreeItem({
          flatItem,
          path: flatItem.path,
          provided: {
            draggableProps: {
              "data-react-beautiful-dnd-draggable": ""
            },
            innerRef: function innerRef() {
            },
            dragHandleProps: null
          },
          snapshot: {
            isDragging: false,
            isDropAnimating: false
          }
        });
      }
      var isDragDisabled = typeof isDragEnabled === "function" ? !isDragEnabled(flatItem.item) : !isDragEnabled;
      return /* @__PURE__ */ React__default.createElement(ConnectedDraggable, {
        key: flatItem.item.id,
        draggableId: flatItem.item.id.toString(),
        index: index2,
        isDragDisabled
      }, _this.renderDraggableItem(flatItem));
    });
    _defineProperty$3(_assertThisInitialized(_this), "renderDraggableItem", function(flatItem) {
      return function(provided, snapshot) {
        var currentPath = _this.calculateEffectivePath(flatItem, snapshot);
        if (snapshot.isDropAnimating) {
          _this.onDropAnimating();
        }
        return _this.renderTreeItem({
          flatItem,
          path: currentPath,
          provided,
          snapshot
        });
      };
    });
    _defineProperty$3(_assertThisInitialized(_this), "renderTreeItem", function(_ref) {
      var flatItem = _ref.flatItem, path2 = _ref.path, provided = _ref.provided, snapshot = _ref.snapshot;
      var _this$props2 = _this.props, renderItem = _this$props2.renderItem, onExpand = _this$props2.onExpand, onCollapse = _this$props2.onCollapse, offsetPerLevel = _this$props2.offsetPerLevel;
      return /* @__PURE__ */ React__default.createElement(TreeItem, {
        key: flatItem.item.id,
        item: flatItem.item,
        path: path2,
        onExpand,
        onCollapse,
        renderItem,
        provided,
        snapshot,
        itemRef: _this.setItemRef,
        offsetPerLevel
      });
    });
    return _this;
  }
  _createClass(Tree2, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var isNestingEnabled = this.props.isNestingEnabled;
      var renderedItems = this.renderItems();
      return /* @__PURE__ */ React__default.createElement(DragDropContext, {
        onDragStart: this.onDragStart,
        onDragEnd: this.onDragEnd,
        onDragUpdate: this.onDragUpdate
      }, /* @__PURE__ */ React__default.createElement(ConnectedDroppable, {
        droppableId: "tree",
        isCombineEnabled: isNestingEnabled,
        ignoreContainerClipping: true
      }, function(provided) {
        var finalProvided = _this2.patchDroppableProvided(provided);
        return /* @__PURE__ */ React__default.createElement("div", _extends$6({
          ref: finalProvided.innerRef,
          style: {
            pointerEvents: "auto"
          },
          onTouchMove: _this2.onPointerMove,
          onMouseMove: _this2.onPointerMove
        }, finalProvided.droppableProps), renderedItems, provided.placeholder);
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var draggedItemId = state.draggedItemId;
      var tree = props.tree;
      var finalTree = Tree2.closeParentIfNeeded(tree, draggedItemId);
      var flattenedTree = flattenTree(finalTree);
      return _objectSpread(_objectSpread({}, state), {}, {
        flattenedTree
      });
    }
  }, {
    key: "closeParentIfNeeded",
    value: function closeParentIfNeeded(tree, draggedItemId) {
      if (!!draggedItemId) {
        return mutateTree(tree, draggedItemId, {
          isExpanded: false
        });
      }
      return tree;
    }
  }]);
  return Tree2;
}(Component);
_defineProperty$3(Tree, "defaultProps", {
  tree: {
    children: []
  },
  onExpand: noop$4,
  onCollapse: noop$4,
  onDragStart: noop$4,
  onDragEnd: noop$4,
  renderItem: noop$4,
  offsetPerLevel: 35,
  isDragEnabled: false,
  isNestingEnabled: false
});
var moveItemOnTree = function moveItemOnTree2(tree, from3, to2) {
  var _removeItemFromTree = removeItemFromTree(tree, from3), treeWithoutSource = _removeItemFromTree.tree, itemRemoved = _removeItemFromTree.itemRemoved;
  return addItemToTree(treeWithoutSource, to2, itemRemoved);
};
function FieldLabel({
  name: name2,
  text: text2,
  required: required2 = false
}) {
  const id = `id_${name2}`;
  const labelText = text2 ? text2 : humanizeString(name2);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { className: "editable", htmlFor: id, children: [
    labelText,
    required2 && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "require", children: "*" })
  ] });
}
function FieldHelp({ helpText, children = void 0 }) {
  if (helpText || children) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "help", children: helpText || children });
  } else {
    return null;
  }
}
function DateField$1({
  name: name2,
  label,
  helpText,
  required: required2,
  onSelect
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { onClick: () => onSelect(name2), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldLabel, { text: label, name: name2, required: required2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldHelp, { helpText }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("input", { name: name2, type: "date" })
  ] });
}
function InfoSection$1({ name: name2, text: text2, onSelect }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: () => onSelect(name2), children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "content",
      dangerouslySetInnerHTML: { __html: marked(text2) }
    }
  ) });
}
function priceLabel$1({ label, price, showPrice, currency }) {
  if (showPrice && price) {
    return `${label} (${currency}${formatCents(price)})`;
  } else {
    return label;
  }
}
function InputField$1({
  name: name2,
  label,
  price,
  helpText,
  required: required2,
  type,
  showPrice = false,
  currency = "$",
  onSelect
}) {
  let inputType;
  switch (type) {
    case "boolean":
      inputType = "checkbox";
      break;
    case "document":
      inputType = "file";
      break;
    case "date":
    case "email":
      inputType = type;
      break;
    default:
      inputType = "text";
  }
  const labelText = priceLabel$1({
    label,
    price,
    showPrice: showPrice && type === "boolean",
    currency
  });
  if (type === "boolean") {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { onClick: () => onSelect(name2), children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FieldHelp, { helpText }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { name: name2, type: inputType }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FieldLabel, { text: labelText, name: name2, required: required2 })
    ] });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { onClick: () => onSelect(name2), children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FieldLabel, { text: labelText, name: name2, required: required2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FieldHelp, { helpText }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { name: name2, type: inputType })
    ] });
  }
}
function FieldLegend({ name: name2, text: text2 = null, required: required2 = false }) {
  const labelText = !!text2 ? text2 : humanizeString(name2);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("legend", { className: "editable", children: [
    labelText,
    required2 && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "require", children: "*" })
  ] });
}
function choiceToObject$1(choice) {
  if (choice.value) {
    return { ...choice };
  }
  if (choice.label) {
    return { ...choice, value: choice.label };
  }
  if (Array.isArray(choice)) {
    return { label: choice[0], value: choice[1] };
  }
  return { label: choice, value: choice };
}
function RadioField$1({
  name: name2,
  label = null,
  required: required2 = false,
  helpText = null,
  choices,
  includeBlank = false,
  blankText = "--- Please select ----",
  showPrices = false,
  currency = "$",
  onSelect
}) {
  const options = choices.map(choiceToObject$1);
  if (includeBlank) {
    options.unshift({ label: blankText, value: "" });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { onClick: () => onSelect(name2), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldLegend, { name: name2, text: label, required: required2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldHelp, { helpText }),
    options.map((option) => {
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "radio", name: name2, value: option.value }),
        priceLabel$1({ ...option, showPrice: showPrices, currency })
      ] }) }, option.value);
    })
  ] });
}
function DraggableField({ field, index: index2, onSelect }) {
  if (!field.name) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PublicDraggable, { draggableId: field.name, index: index2, children: (provided, snapshot) => /* @__PURE__ */ createElement(
    "div",
    {
      ref: provided.innerRef,
      ...provided.draggableProps,
      ...provided.dragHandleProps,
      className: `t-field ${field.type}`,
      key: field.name,
      onClick: () => onSelect(field.name)
    },
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldListItem$2, { field })
  ) }, field.name);
}
function DraggableSection({ field, index: index2, onSelect, onDragEnd: onDragEnd4 }) {
  if (!field.name) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PublicDraggable, { draggableId: field.name, index: index2, children: (provided, snapshot) => /* @__PURE__ */ createElement(
    "div",
    {
      ref: provided.innerRef,
      ...provided.draggableProps,
      ...provided.dragHandleProps,
      className: "t-field",
      key: field.name,
      onClick: () => onSelect(field.name)
    },
    /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { onClick: () => onSelect(field.name), children: field.label }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FieldListDroppable,
      {
        fields: field.fields,
        onSelect,
        droppableId: field.name,
        droppableType: "nestedSection"
      }
    )
  ) }, field.name);
}
function FieldListDroppable({
  fields = [],
  droppableId,
  droppableType = "topLevel",
  onSelect,
  onChange,
  onDragEnd: onDragEnd4
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectedDroppable$1, { droppableId, type: droppableType, children: (provided, snapshot) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      style: { minHeight: 50 },
      ref: provided.innerRef,
      ...provided.droppableProps,
      children: [
        fields.map((field, index2) => {
          if (field.type === "section") {
            return /* @__PURE__ */ jsxRuntimeExports.jsx(
              DraggableSection,
              {
                field,
                index: index2,
                onSelect,
                onDragEnd: onDragEnd4
              },
              field.name
            );
          } else {
            return /* @__PURE__ */ jsxRuntimeExports.jsx(
              DraggableField,
              {
                field,
                index: index2,
                onSelect
              },
              field.name
            );
          }
        }),
        provided.placeholder
      ]
    }
  ) });
}
function FieldListDraggable({
  fields = [],
  onSelect,
  onChange,
  onMoveField
}) {
  const handleDragEnd = (result) => {
    const { destination, draggableId } = result;
    if (destination) {
      onMoveField({
        field: draggableId,
        destination: destination.droppableId === "fieldsList" ? null : destination.droppableId,
        index: destination.index
      });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(DragDropContext$1, { onDragEnd: handleDragEnd, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    FieldListDroppable,
    {
      droppableId: "fieldsList",
      fields,
      onSelect,
      onDragEnd: handleDragEnd
    }
  ) }) });
}
function Section$3({
  field,
  isExpanded = false,
  renderChildren = true,
  showPrices = false,
  onSelect,
  onExpand,
  onCollapse
}) {
  const handleToggle = () => {
    isExpanded ? onCollapse(field.name) : onExpand(field.name);
  };
  const handleSelect = (id) => {
    onSelect(id);
  };
  const toggleIndicator = isExpanded ? "toggle close" : "toggle open";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { className: "editable", onClick: () => onSelect(field.name), children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: toggleIndicator, onClick: handleToggle }),
      field.label
    ] }),
    renderChildren && /* @__PURE__ */ jsxRuntimeExports.jsx(
      FieldListDraggable,
      {
        fields: field.fields,
        showPrices,
        onSelect: handleSelect
      }
    )
  ] });
}
function SelectField$1({
  name: name2,
  label = null,
  required: required2 = false,
  helpText = null,
  choices,
  includeBlank = false,
  blankText = "--- Please select ----",
  showPrices = false,
  currency = "$",
  onSelect
}) {
  const options = choices.map(choiceToObject$1);
  if (includeBlank) {
    options.unshift({ label: blankText, value: "" });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { onClick: () => onSelect(name2), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldLabel, { text: label, name: name2, required: required2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldHelp, { helpText }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("select", { name: name2, children: options.map((option) => {
      return /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: option.value, children: priceLabel$1({ ...option, showPrice: showPrices, currency }) }, option.value);
    }) })
  ] });
}
function TextAreaField$1({
  name: name2,
  label,
  helpText,
  required: required2,
  onSelect
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { onClick: () => onSelect(name2), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldLabel, { text: label, name: name2, required: required2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldHelp, { helpText }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("textarea", { name: name2, readOnly: true })
  ] });
}
const SessionSlotSelect = ({
  field,
  session,
  showPrices = false,
  currency = "$"
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Select$2, { bg: "white", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { children: " -- Make your selection -- " }, "blank"),
  visibleSlots(field, session).map((slot) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { children: priceLabel$1({
    label: slot.name,
    showPrice: showPrices,
    price: getSessionSlotFieldPrice(slot, field),
    currency
  }) }, slot.id))
] });
const SingleSlotPreview = ({
  field,
  session,
  showPrices = false,
  currency = "$",
  error: error2
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { justifyContent: "space-between", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { flexGrow: 1, mr: 4, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FieldLabel,
      {
        text: getSessionFieldLabel(field, session),
        name: field.name,
        required: field.required
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldHelp, { helpText: field.helpText }),
    error2 && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { children: "Error loading session data" }),
    session && /* @__PURE__ */ jsxRuntimeExports.jsx(
      SessionSlotSelect,
      {
        field,
        session,
        currency,
        showPrices
      }
    )
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BookableSessionsPanel, {}) })
] }) });
const SlotChoicesInfo$1 = ({ field }) => {
  if (field.maxChoices !== void 0 && field.minChoices !== void 0) {
    if (field.maxChoices === field.minChoices) {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Choose exactly ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: field.minChoices }),
        " slots"
      ] });
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Choose between ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: field.minChoices }),
        " and ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: field.maxChoices }),
        " ",
        "slots."
      ] });
    }
  }
  if (field.maxChoices !== void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      "Choose up to ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: field.maxChoices }),
      " slots"
    ] });
  }
  if (field.minChoices !== void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      "Choose at least ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: field.minChoices }),
      " slots"
    ] });
  }
  return null;
};
const SessionSlotChecklist$1 = ({
  field,
  session,
  showPrices = false,
  currency = "$"
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxGroup$2, { value: field.defaultSlots, children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", children: visibleSlots(field, session).map((slot) => /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$2, { value: slot.id, children: priceLabel$1({
    label: slot.name,
    showPrice: showPrices,
    price: getSessionSlotFieldPrice(slot, field),
    currency
  }) }, slot.id)) }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SlotChoicesInfo$1, { field }) })
] });
const MultiSlotPreview = ({
  field,
  session,
  showPrices = false,
  currency = "$",
  error: error2
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { justifyContent: "space-between", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { spacing: 3, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { flexGrow: 1, mr: 4, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        FieldLabel,
        {
          text: getSessionFieldLabel(field, session),
          name: field.name,
          required: field.required
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FieldHelp, { helpText: field.helpText }),
      error2 && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { children: "Error loading session data" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { children: session && /* @__PURE__ */ jsxRuntimeExports.jsx(
      SessionSlotChecklist$1,
      {
        field,
        session,
        currency,
        showPrices
      }
    ) })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BookableSessionsPanel, {}) })
] });
const SessionFieldPreview$1 = ({
  field,
  showPrices = false,
  currency = "$",
  onSelect
}) => {
  const { isLoading, error: error2, data: session } = useSession(field.session);
  if (error2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { children: "Error loading session" });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { onClick: () => onSelect(field.name), children: isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { py: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {}) }) : field.maxChoices !== void 0 && field.maxChoices > 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    MultiSlotPreview,
    {
      field,
      session,
      error: error2,
      currency,
      showPrices
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    SingleSlotPreview,
    {
      field,
      session,
      error: error2,
      currency,
      showPrices
    }
  ) });
};
const defaultStartDate$1 = (field, roomBlock) => {
  if (field.defaultCheckIn !== void 0) {
    return parseISO$1(field.defaultCheckIn);
  }
  if (field.availableFrom !== void 0) {
    return parseISO$1(field.availableFrom);
  }
  return roomBlock.startDate;
};
const defaultEndDate$1 = (field, roomBlock) => {
  if (field.defaultCheckOut !== void 0) {
    return parseISO$1(field.defaultCheckOut);
  }
  if (field.availableTo !== void 0) {
    return parseISO$1(field.availableTo);
  }
  return roomBlock.endDate;
};
const RoomingFieldPreview$1 = ({
  field,
  onSelect
}) => {
  const { dateFormats: dateFormats2 } = useLocale();
  const { isLoading, error: error2, data: roomBlock } = useRoomBlock(field.roomBlockId);
  const [booking, setBooking] = useState();
  useEffect(() => {
    if (booking === void 0 && roomBlock !== void 0) {
      setBooking({ checkIn: roomBlock.startDate, checkOut: roomBlock.endDate });
    }
  }, [roomBlock, booking]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { onClick: () => onSelect(field.name), children: isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { py: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {}) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { justifyContent: "space-between", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { flexGrow: 1, mr: 4, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FieldLabel,
      {
        text: field.label,
        name: field.name,
        required: field.required
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldHelp, { helpText: field.helpText }),
    error2 && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { children: "Error loading room block" }),
    isLoading && /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {}),
    roomBlock !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { isDisabled: true, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Check in" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Input$1,
          {
            value: format$2(
              defaultStartDate$1(field, roomBlock),
              dateFormats2.regular
            )
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { isDisabled: true, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Check out" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Input$1,
          {
            value: format$2(
              defaultEndDate$1(field, roomBlock),
              dateFormats2.regular
            )
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { isDisabled: true, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Room Type" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Select$2, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("option", { children: "-- Please select --" }, "blank"),
          roomBlock.roomTypes.map((rt) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { children: rt.name }, rt.id))
        ] })
      ] })
    ] })
  ] }) }) });
};
const LeadScannerFieldPreview$1 = ({
  field,
  onSelect
}) => {
  const { formSettings } = useRegForm();
  const labelText = priceLabel$1({
    label: field.label,
    price: field.price,
    showPrice: formSettings.shoppingCartEnabled,
    currency: formSettings.shoppingCartCurrency
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: "test-lead-scanner-preview",
      onClick: () => onSelect(field.name),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("input", { name: field.name, type: "checkbox" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          FieldLabel,
          {
            text: labelText,
            name: field.name,
            required: field.required
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FieldHelp, { helpText: field.helpText })
      ]
    }
  );
};
function FieldListItem$2({
  field,
  onSelect,
  renderChildren = true,
  isExpanded = true,
  showPrices = false,
  currency = "$",
  onExpand,
  onCollapse
}) {
  if (field.widget === "textarea") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(TextAreaField$1, { ...field, onSelect });
  } else if (field.choices && field.choices.length) {
    if (field.widget === "radio") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        RadioField$1,
        {
          ...field,
          showPrices,
          currency,
          onSelect
        }
      );
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        SelectField$1,
        {
          ...field,
          showPrices,
          currency,
          onSelect
        }
      );
    }
  }
  switch (field.type) {
    case "date":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DateField$1, { ...field, onSelect });
    case "info":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(InfoSection$1, { ...field, onSelect });
    case "section":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Section$3,
        {
          field,
          onSelect,
          showPrices,
          renderChildren,
          isExpanded,
          onExpand,
          onCollapse
        }
      );
    case "room_block":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(RoomingFieldPreview$1, { field, onSelect });
    case "session_booking":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        SessionFieldPreview$1,
        {
          field,
          onSelect,
          showPrices,
          currency
        }
      );
    case "lead_scanner":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(LeadScannerFieldPreview$1, { field, onSelect });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(InputField$1, { ...field, onSelect, showPrice: showPrices });
  }
}
function flatFields$1(container) {
  if (container.fields) {
    const fields = [container];
    container.fields.forEach((f2) => {
      flatFields$1(f2).forEach((innerF) => {
        fields.push(innerF);
      });
    });
    return fields;
  } else {
    return [container];
  }
}
function containerToTreeItem$1(container, treeData) {
  const treeItem = {
    id: container.name,
    data: container
  };
  treeItem.hasChildren = true;
  treeItem.isExpanded = true;
  if (container.fields && container.fields.length > 0) {
    treeItem.children = container.fields.map((f2) => f2.name);
  } else {
    const placeholderId = `placeholder-${container.name}`;
    treeItem.children = [placeholderId];
    treeData.items[placeholderId] = {
      id: placeholderId,
      data: { type: "placeholder" }
    };
  }
  return treeItem;
}
function fieldToTreeItem$1(field, treeData) {
  if (field.type === "section" || field.type === "page") {
    return containerToTreeItem$1(field, treeData);
  }
  const treeItem = {
    id: field.name,
    data: field
  };
  if (field.fields) {
    treeItem.hasChildren = true;
    treeItem.children = field.fields.map((f2) => f2.name);
    treeItem.isExpanded = true;
  } else {
    treeItem.hasChildren = false;
  }
  return treeItem;
}
function pageToTree$1(page) {
  const treeData = {
    rootId: page.name,
    items: {}
  };
  flatFields$1(page).map((f2) => fieldToTreeItem$1(f2, treeData)).forEach((i) => {
    treeData.items[i.id] = i;
  });
  Object.values(treeData.items).forEach((item) => {
    if (item.hasChildren) {
      const lastChildName = item.children[item.children.length - 1];
      treeData.items[lastChildName].isLastChild = true;
    }
  });
  return treeData;
}
const ChangeHistoryContainer = ({
  item,
  children
}) => {
  const context = useChangeHistory();
  if (context === void 0) {
    return children;
  }
  const { changeHistory } = context;
  const unsavedItemChanges = unsavedFieldUpdates(
    item.id,
    changeHistory.unsavedChanges
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    unsavedItemChanges !== void 0 && (unsavedItemChanges == null ? void 0 : unsavedItemChanges.length) > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(ChangeHistoryIndicator, { changes: unsavedItemChanges }),
    children
  ] });
};
function Placeholder$1({ provided }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: "t-field",
      ref: provided.innerRef,
      ...provided.draggableProps,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ...provided.dragHandleProps }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "drag-area", children: "Drag items here" })
      ]
    }
  );
}
const renderItemFactory$1 = ({ onSelect, showPrices, currency, roomBlocks: roomBlocks2 }) => {
  const renderItem = ({ item, depth, onExpand, onCollapse, provided }) => {
    const classes2 = classNames(
      {
        "t-field": true,
        "in-section": depth > 0,
        "last-in-section": depth > 0 && item.isLastChild,
        "last-in-page": depth === 0 && item.isLastChild
      },
      item.data.type
    );
    if (item.data.type === "placeholder") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Placeholder$1, { provided });
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ChangeHistoryContainer, { item, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: classes2,
          ref: provided.innerRef,
          ...provided.draggableProps,
          ...provided.dragHandleProps,
          onClick: () => onSelect(item.id),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            FieldListItem$2,
            {
              field: item.data,
              onSelect,
              renderChildren: false,
              isExpanded: item.isExpanded,
              showPrices,
              currency,
              onExpand,
              onCollapse
            }
          )
        }
      ) });
    }
  };
  return renderItem;
};
const simpleRenderItem$1 = ({ item, depth, onExpand, onCollapse, provided }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ref: provided.innerRef,
      ...provided.draggableProps,
      ...provided.dragHandleProps,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: item.data.name })
    }
  );
};
function TreeFieldList$1({
  page,
  showPrices = false,
  currency = "$",
  onSelect,
  onMoveField,
  simple = false
}) {
  const [tree, setTree] = useState(pageToTree$1(page));
  const [collapsedItems, setCollapsedItems] = useState(/* @__PURE__ */ new Set());
  useEffect(() => {
    let newTree = pageToTree$1(page);
    newTree = collapseItemsOnTree(newTree, collapsedItems);
    setTree(newTree);
  }, [page]);
  const collapseItemsOnTree = (tree2, collapsed) => {
    let newTree = tree2;
    Object.values(tree2.items).filter((i) => i.hasChildren).forEach((item) => {
      if (collapsed.has(item.id)) {
        newTree = mutateTree(newTree, item.id, { isExpanded: false });
      } else {
        newTree = mutateTree(newTree, item.id, { isExpanded: true });
      }
    });
    return newTree;
  };
  const handleDragEnd = (source, destination) => {
    if (!destination) {
      return;
    }
    const newTree = moveItemOnTree(tree, source, destination);
    setTree(newTree);
    onMoveField({
      field: tree.items[source.parentId].children[source.index],
      destination: destination.parentId,
      index: destination.index
    });
  };
  const handleExpand = (itemId) => {
    collapsedItems.delete(itemId);
    setTree(collapseItemsOnTree(tree, collapsedItems));
    setCollapsedItems(collapsedItems);
  };
  const handleCollapse = (itemId) => {
    collapsedItems.add(itemId);
    setTree(collapseItemsOnTree(tree, collapsedItems));
    setCollapsedItems(collapsedItems);
  };
  const renderItem = simple ? simpleRenderItem$1 : renderItemFactory$1({ onSelect, showPrices, currency });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "form-field-list", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tree,
    {
      tree,
      renderItem,
      isNestingEnabled: false,
      onDragEnd: handleDragEnd,
      onExpand: handleExpand,
      onCollapse: handleCollapse,
      isDragEnabled: true
    }
  ) });
}
const FieldListContainer$1 = () => {
  const { form, formSettings, editorState, dispatch } = useRegForm();
  if (form.fields.length === 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { p: 4, children: "Add a page to get started" });
  }
  const { selectedPage } = getSelectedItems$1({ ...form, ...editorState });
  if (!selectedPage) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { p: 4, children: "Select a page to get started" });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TreeFieldList$1,
    {
      page: selectedPage,
      showPrices: formSettings.shoppingCartEnabled,
      currency: formSettings.shoppingCartCurrency,
      onSelect: (name2) => dispatch({ type: "select_field", name: name2 }),
      onMoveField: ({
        field,
        destination,
        index: index2
      }) => dispatch({
        type: "move_field",
        field,
        index: index2,
        destination
      })
    }
  );
};
const FormEditorV3 = ({
  initialFields,
  onSave,
  onPreview,
  ...settings
}) => {
  const formSettings = {
    ...defaultFormSettings,
    ...settings
  };
  const [{ fields, ...uiState }, dispatch] = useReducer(
    reducer$6,
    { fields: initialFields },
    initializeState$1
  );
  const [saving, setSaving] = useState(false);
  const editorEndRef = useRef(null);
  useEffect(() => {
    const doSave = async () => {
      if (saving && fields.length > 0) {
        const success = await onSave(fields);
        setSaving(false);
        if (success) {
          dispatch({ type: "set_dirty", dirty: false });
        }
      }
    };
    doSave();
  }, [saving]);
  const handleSave = () => {
    dispatch({ type: "name_new_fields" });
    setSaving(true);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormProvider,
    {
      form: { fields },
      formSettings,
      editorState: uiState,
      dispatch,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(EditorLayout, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(EditorHeader$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          StateBarV2$1,
          {
            dirty: uiState.dirty,
            onSave: handleSave,
            onReset: () => dispatch({ type: "reset_fields", fields: initialFields }),
            children: fields.length !== 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button$1,
              {
                onClick: () => onPreview(fields),
                variant: "ghost",
                size: "sm",
                children: "Preview"
              }
            ) })
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(EditorSidebar, { overflow: "auto", background: "grayAlpha.800", color: "white", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Sidebar, {}) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(EditorMain, { overflow: "auto", px: 8, pb: 16, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "dynamic-editor", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldListContainer$1, {}) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { height: 100 }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { ref: editorEndRef })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(EditorRightPanel, { overflow: "auto", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          RightPanel,
          {
            onFieldAdded: () => {
              var _a3;
              return (_a3 = editorEndRef == null ? void 0 : editorEndRef.current) == null ? void 0 : _a3.scrollIntoView({
                behavior: "smooth"
              });
            }
          }
        ) })
      ] })
    }
  );
};
const formEditorUIStateReducer = (state, action) => {
  return fn(state, (draft) => {
    switch (action.type) {
      case "select_page":
        draft.selectedPageName = action.name;
        draft.selectedFieldName = action.name;
        if (action.showEditor !== false) {
          draft.selectedTab = "edit";
        }
        break;
      case "select_field":
        draft.selectedFieldName = action.name;
        draft.selectedTab = "edit";
        break;
      case "select_tab":
        draft.selectedTab = action.tab;
        break;
      case "set_dirty":
        draft.dirty = action.dirty;
        break;
      case "set_saving":
        draft.saving = action.saving;
        break;
      case "deselect_field":
        draft.selectedFieldName = void 0;
        draft.selectedTab = void 0;
        break;
    }
  });
};
function setDirty$1(ydoc) {
  ydoc.getMap("editorState").set("isDirty", true);
}
const ydocFormOperationsReducer = (state, action) => {
  switch (action.type) {
    case "add_item": {
      const itemIds = state.getMap("itemIdMap");
      const newItemId = itemYMapKey(action.payload.name);
      if (itemIds.has(newItemId)) {
        console.error(`Item with id ${newItemId} already exists`);
        break;
      }
      itemIds.set(newItemId, true);
      const itemMap = state.getMap(newItemId);
      Object.entries(action.payload).forEach(([key2, value]) => {
        if (typeof value === "bigint") {
          itemMap.set(key2, Number(value));
        } else {
          itemMap.set(key2, value);
        }
      });
      setDirty$1(state);
      break;
    }
    case "update_item": {
      const itemMap = state.getMap(itemYMapKey(action.id));
      Object.entries(action.payload).forEach(([key2, value]) => {
        if (typeof value === "bigint") {
          itemMap.set(key2, Number(value));
        } else {
          itemMap.set(key2, value);
        }
      });
      setDirty$1(state);
      break;
    }
    case "delete_item": {
      const itemIds = state.getMap("itemIdMap");
      const deleteItemId = itemYMapKey(action.id);
      if (itemIds.has(deleteItemId)) {
        itemIds.delete(deleteItemId);
      }
      const itemMap = state.getMap(deleteItemId);
      itemMap.set("isDeleted", true);
      setDirty$1(state);
      break;
    }
  }
  return state;
};
function createAddItemChange(operation, user, parentId, ai) {
  return {
    id: uuid(),
    timestamp: (/* @__PURE__ */ new Date()).getTime(),
    type: "add_item",
    item: operation.payload,
    operation,
    user,
    parentId,
    ai,
    undoOperation: {
      type: "delete_item",
      id: operation.payload.name
    }
  };
}
function reverseUpdate(update2, originalItem) {
  const reversePayload = {};
  for (const key2 of Object.keys(update2.payload)) {
    reversePayload[key2] = originalItem[key2];
  }
  return {
    type: "update_item",
    id: update2.id,
    payload: reversePayload
  };
}
function createUpdateItemChange(operation, user, itemBeforeChange, parentId, ai) {
  return {
    id: uuid(),
    timestamp: (/* @__PURE__ */ new Date()).getTime(),
    type: "update_item",
    item: itemBeforeChange,
    operation,
    undoOperation: reverseUpdate(operation, itemBeforeChange),
    user,
    parentId,
    ai
  };
}
function createDeleteItemChange(operation, user, itemBeforeDelete, parentId, ai) {
  return {
    id: uuid(),
    timestamp: (/* @__PURE__ */ new Date()).getTime(),
    type: "delete_item",
    item: itemBeforeDelete,
    operation,
    undoOperation: {
      type: "add_item",
      payload: itemBeforeDelete
    },
    includedChanges: [],
    user,
    parentId,
    ai
  };
}
const MAX_HISTORY_ENTRIES$1 = 100;
const ydocFormHistoryReducer = (state, action) => {
  switch (action.type) {
    case "add_item":
    case "delete_item": {
      const unsavedChanges = getUnsavedChanges$1(state);
      unsavedChanges.unshift([action]);
      return state;
    }
    case "update_item": {
      state.transact(() => {
        const unsavedChanges = getUnsavedChanges$1(state);
        const unsavedChangesArray = unsavedChanges.toArray();
        const updateItemIndex = getLastUpdateIndexForUser$1(
          unsavedChangesArray,
          action.user.id
        );
        if (updateItemIndex === -1) {
          unsavedChanges.unshift([action]);
          return;
        }
        const updateItemChange = unsavedChangesArray[updateItemIndex];
        if (updateItemChange.operation.id !== action.operation.id) {
          unsavedChanges.unshift([action]);
          return;
        }
        const mergedChange = mergedChanges$1(updateItemChange, action);
        unsavedChanges.delete(updateItemIndex, 1);
        unsavedChanges.unshift([mergedChange]);
      });
      return state;
    }
    case "save_form": {
      state.transact(() => {
        const unsavedChanges = getUnsavedChanges$1(state);
        const previousChanges = getPreviousChanges$1(state);
        previousChanges.unshift([action, ...unsavedChanges.toArray()]);
        unsavedChanges.delete(0, unsavedChanges.length);
        if (previousChanges.length > MAX_HISTORY_ENTRIES$1) {
          previousChanges.delete(
            MAX_HISTORY_ENTRIES$1,
            previousChanges.length - MAX_HISTORY_ENTRIES$1
          );
        }
      });
      return state;
    }
    case "reset_form": {
      state.transact(() => {
        const unsavedChanges = getUnsavedChanges$1(state);
        const previousChanges = getPreviousChanges$1(state);
        unsavedChanges.delete(0, unsavedChanges.length);
        previousChanges.unshift([action]);
      });
      return state;
    }
    default:
      throw new Error(`Unknown action type: ${action.type}`);
  }
};
function deleteItemRecursively(ydoc, itemName, user, parentChangeSet) {
  const item = getYFormItemByID(itemName, ydoc);
  const deleteOp = { type: "delete_item", id: itemName };
  const deleteChange = createDeleteItemChange(deleteOp, user, item);
  deleteChange.includedChanges = [];
  if (isFieldContainer(item)) {
    const children = getChildItems(ydoc, itemName);
    for (const child of children) {
      deleteItemRecursively(ydoc, child.name, user, deleteChange);
    }
  }
  for (const dependent of findDependants(ydoc, itemName)) {
    ydocFormOperationsReducer(ydoc, {
      type: "update_item",
      id: dependent.name,
      payload: { dependsOn: void 0 }
    });
  }
  ydocFormOperationsReducer(ydoc, deleteOp);
  if (parentChangeSet) {
    parentChangeSet.includedChanges.unshift(deleteChange);
  }
  return deleteChange;
}
function ydocDeleteField(ydoc, action) {
  const deleteChange = deleteItemRecursively(
    ydoc,
    action.name,
    action.user,
    action.parentChangeSet
  );
  if (!action.parentChangeSet) {
    ydocFormHistoryReducer(ydoc, deleteChange);
  }
}
function initPage(ydoc, newPage) {
  return {
    type: "page",
    label: "New Page",
    sort: getMaxPagesSort$1(ydoc) + 1,
    name: newPage.name || idGenerator(),
    isNew: true,
    fields: [],
    ...newPage
  };
}
function initField(ydoc, parentId, newField) {
  const field = {
    parentId,
    type: "string",
    sort: getMaxChildSort(ydoc, parentId) + 1,
    label: "New field",
    name: newField.name || idGenerator(),
    isNew: true,
    ...newField
  };
  if (isInfoField(field) && field.type === "info") {
    field.text = infoDefaultText;
  }
  return field;
}
function ydocAddPage(ydoc, action) {
  const newPage = initPage(ydoc, action.page || {});
  const addItemOperation = {
    type: "add_item",
    payload: newPage
  };
  ydocFormOperationsReducer(ydoc, addItemOperation);
  const addItemChange = createAddItemChange(addItemOperation, action.user);
  if (action.parentChangeSet) {
    action.parentChangeSet.includedChanges.unshift(addItemChange);
  } else {
    ydocFormHistoryReducer(ydoc, addItemChange);
  }
  return newPage;
}
const ydocAddField = (ydoc, action) => {
  const parentField = getYFormItemByID(action.parent, ydoc);
  if (!parentField) {
    throw new Error(
      `Trying to add field to undefined parent field ${action.parent}`
    );
  }
  if (!isFieldContainer(parentField)) {
    console.error("Invalid field container", parentField);
    console.log("pages", getPages$1(ydoc));
    throw new Error(
      `Trying to add field to invalid parent field ${action.parent}`
    );
  }
  const newField = initField(ydoc, parentField.name, action.field || {});
  const addFieldOperation = {
    type: "add_item",
    payload: newField
  };
  ydocFormOperationsReducer(ydoc, addFieldOperation);
  const addItemChange = createAddItemChange(
    addFieldOperation,
    action.user,
    parentField.name
  );
  if (action.parentChangeSet) {
    action.parentChangeSet.includedChanges.unshift(addItemChange);
  } else {
    ydocFormHistoryReducer(ydoc, addItemChange);
  }
  return newField;
};
function isNoopUpdate(update2, previous2) {
  if (!previous2) return false;
  return Object.keys(update2).every(
    (key2) => previous2[key2] === update2[key2]
  );
}
const ydocUpdateField = (ydoc, action) => {
  const previousItem = getYFormItemByID(action.name, ydoc);
  if (!previousItem || !previousItem.name) {
    throw new Error(`Trying to update non-existent field ${action.name}`);
  }
  if (isNoopUpdate(action.payload, previousItem)) {
    return;
  }
  const updateFieldOperation = {
    type: "update_item",
    id: action.name,
    payload: action.payload
  };
  ydocFormOperationsReducer(ydoc, updateFieldOperation);
  const updateItemChange = createUpdateItemChange(
    updateFieldOperation,
    action.user,
    previousItem
  );
  if (action.parentChangeSet) {
    action.parentChangeSet.includedChanges.unshift(updateItemChange);
  } else {
    ydocFormHistoryReducer(ydoc, updateItemChange);
  }
};
const ydocFormReducer = (state, action) => {
  var _a3;
  switch (action.type) {
    case "select_page": {
      state.ydoc.getMap("editorState").set("currentPage", action.name);
      return {
        ...state,
        editorState: formEditorUIStateReducer(state.editorState, action)
      };
    }
    case "select_field":
    case "select_tab":
    case "set_saving":
      return {
        ...state,
        editorState: formEditorUIStateReducer(state.editorState, action)
      };
    case "add_page": {
      let newEditorState = state.editorState;
      state.ydoc.transact(() => {
        const newPage = ydocAddPage(state.ydoc, action);
        newEditorState = formEditorUIStateReducer(state.editorState, {
          type: "select_page",
          name: newPage.name
        });
      });
      return {
        ydoc: state.ydoc,
        editorState: newEditorState,
        formSettings: state.formSettings
      };
    }
    case "add_field": {
      const parentFieldName = action.parent ?? state.editorState.selectedPageName;
      if (parentFieldName === void 0) {
        throw new Error(
          "Please supply a field name to add a field or ensure a field has been selected"
        );
      }
      let newField = null;
      state.ydoc.transact(() => {
        newField = ydocAddField(state.ydoc, {
          ...action,
          parent: parentFieldName
        });
      });
      const newEditorState = newField ? formEditorUIStateReducer(state.editorState, {
        type: "select_field",
        name: newField.name
      }) : state.editorState;
      return {
        ydoc: state.ydoc,
        editorState: newEditorState,
        formSettings: state.formSettings
      };
    }
    case "update_field": {
      state.ydoc.transact(() => {
        ydocUpdateField(state.ydoc, action);
      });
      return {
        ydoc: state.ydoc,
        editorState: state.editorState,
        formSettings: state.formSettings
      };
    }
    case "move_page": {
      const pages = getPhasedPageCollection(
        state.ydoc,
        action.name,
        state.formSettings.registrationPhasesEnabled
      );
      const startIndex = pages.findIndex((page) => page.name === action.name);
      state.ydoc.transact(() => {
        ydocUpdateField(state.ydoc, {
          name: action.name,
          user: action.user,
          payload: { sort: getNewSort(pages, startIndex, action.toIndex) }
        });
      });
      return {
        ydoc: state.ydoc,
        editorState: state.editorState,
        formSettings: state.formSettings
      };
    }
    case "move_field": {
      const field = getYFormItemByID(action.field, state.ydoc);
      const destination = getYFormItemByID(action.destination, state.ydoc);
      if (!field || !destination) {
        throw new Error("Field or destination not found");
      }
      const destinationFields = getChildItems(state.ydoc, destination.name);
      const startIndex = destinationFields.findIndex(
        (f2) => f2.name === field.name
      );
      state.ydoc.transact(() => {
        ydocUpdateField(state.ydoc, {
          name: field.name,
          user: action.user,
          payload: {
            parentId: destination.name,
            sort: getNewSort(
              destinationFields,
              Math.max(0, startIndex),
              action.index,
              isChildItem(field) && !idsEqual(destination.name, field.parentId)
            )
          }
        });
      });
      return {
        ydoc: state.ydoc,
        editorState: state.editorState,
        formSettings: state.formSettings
      };
    }
    case "delete_field": {
      state.ydoc.transact(() => {
        ydocDeleteField(state.ydoc, action);
      });
      let newEditorState = state.editorState;
      if (action.name === state.editorState.selectedPageName) {
        const pages = getPages$1(state.ydoc);
        newEditorState = formEditorUIStateReducer(state.editorState, {
          type: "select_page",
          name: (_a3 = pages[0]) == null ? void 0 : _a3.name
        });
      }
      return {
        ydoc: state.ydoc,
        editorState: newEditorState,
        formSettings: state.formSettings
      };
    }
    case "batch_change": {
      state.ydoc.transact(() => {
        const parentChangeSet = {
          type: "item_changeset",
          id: uuid(),
          user: action.user,
          timestamp: Date.now(),
          includedChanges: []
        };
        for (const op of action.payload) {
          switch (op.type) {
            case "add_page": {
              ydocAddPage(state.ydoc, {
                ...op,
                user: action.user,
                parentChangeSet
              });
              break;
            }
            case "add_field": {
              if (op.parent === void 0) {
                throw new Error("Parent field name not supplied");
              }
              ydocAddField(state.ydoc, {
                ...op,
                user: action.user,
                parentChangeSet
              });
              break;
            }
            case "update_field": {
              ydocUpdateField(state.ydoc, {
                ...op,
                user: action.user,
                parentChangeSet
              });
              break;
            }
            case "delete_field": {
              ydocDeleteField(state.ydoc, {
                ...op,
                user: action.user,
                parentChangeSet
              });
            }
          }
        }
        getUnsavedChanges$1(state.ydoc).unshift([parentChangeSet]);
      });
      return state;
    }
    case "undo_change": {
      const unsavedChanges = getUnsavedChanges$1(state.ydoc);
      const changesArray = unsavedChanges.toArray();
      const idx = changesArray.findIndex(
        (entry2) => entry2.id === action.changeId
      );
      if (idx === -1) {
        throw new Error(
          `Change or changeset with id ${action.changeId} not found`
        );
      }
      const entry = changesArray[idx];
      const applyUndo = (change) => {
        if (change.type === "delete_item" && Array.isArray(change.includedChanges) && change.includedChanges.length > 0) {
          for (let i = change.includedChanges.length - 1; i >= 0; i--) {
            applyUndo(change.includedChanges[i]);
          }
        }
        if ("undoOperation" in change && change.undoOperation && typeof change.undoOperation === "object" && Object.keys(change.undoOperation).length > 0) {
          if (change.type === "update_item" && change.undoOperation.type === "update_item") {
            ydocFormOperationsReducer(
              state.ydoc,
              change.undoOperation
            );
          } else if (change.type === "delete_item" && change.undoOperation.type === "add_item") {
            ydocFormOperationsReducer(
              state.ydoc,
              change.undoOperation
            );
          } else if (change.type === "add_item" && change.undoOperation.type === "delete_item") {
            ydocFormOperationsReducer(
              state.ydoc,
              change.undoOperation
            );
          }
        }
      };
      state.ydoc.transact(() => {
        if (entry.type === "item_changeset") {
          for (let i = 0; i < entry.includedChanges.length; i++) {
            applyUndo(entry.includedChanges[i]);
          }
        } else {
          applyUndo(entry);
        }
      });
      return { ...state };
    }
    // Restore update_ydoc action for triggering a React render after ydoc is updated from the server
    case "update_ydoc": {
      return {
        ...state,
        ydoc: action.payload.ydoc
      };
    }
    case "deselect_field": {
      return {
        ...state,
        editorState: formEditorUIStateReducer(state.editorState, action)
      };
    }
    default:
      throw new Error(`Unknown action type: ${action.type}`);
  }
};
const SessionUpdateContext = createContext({});
const SessionUpdateProvider = ({
  sessionsLastUpdated,
  children
}) => {
  const queryClient = useQueryClient();
  useEffect(() => {
    if (sessionsLastUpdated !== void 0) {
      queryClient.refetchQueries({ queryKey: ["sessions"] });
    }
  }, [sessionsLastUpdated, queryClient]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SessionUpdateContext.Provider, { value: { sessionsLastUpdated }, children });
};
const CollaborativeFormEditor = ({
  ydoc: initialYdoc,
  currentUser,
  chat,
  onSave,
  onReset,
  onPreview,
  assistantEvents,
  ...settings
}) => {
  const formSettings = {
    ...defaultFormSettings,
    ...settings
  };
  const [{ ydoc, editorState: uiState }, dispatchWithoutUser] = useReducer(
    ydocFormReducer,
    {
      ydoc: initialYdoc,
      editorState: {},
      formSettings
    }
  );
  const [changeHistory, setChangeHistory] = useState(
    getChangeHistory$1(ydoc)
  );
  const [, historyDispatch] = useReducer(ydocFormHistoryReducer, ydoc);
  const editorEndRef = useRef(null);
  const dispatch = (action) => dispatchWithoutUser({ ...action, user: currentUser });
  ydoc.on("update", () => {
    dispatch({ type: "update_ydoc", payload: { ydoc } });
    setChangeHistory(getChangeHistory$1(ydoc));
  });
  const fields = getFieldsAsTree(ydoc);
  useEffect(() => {
    if (fields.length > 0 && !uiState.selectedPageName) {
      dispatch({ type: "select_page", name: fields[0].name });
    }
  }, [fields.length > 0]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormProvider,
    {
      form: { fields },
      formSettings,
      editorState: uiState,
      dispatch,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChangeHistoryProvider, { changeHistory, children: /* @__PURE__ */ jsxRuntimeExports.jsx(TrackUpdateProvider, { tracksLastUpdated: settings.tracksLastUpdated, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        SessionUpdateProvider,
        {
          sessionsLastUpdated: settings.sessionsLastUpdated,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChatProvider, { chat, assistantEvents, dispatch, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(EditorLayout, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(EditorHeader$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              StateBarV2$1,
              {
                dirty: ydocIsDirty$1(ydoc),
                confirmReset: true,
                onSave: () => {
                  historyDispatch({
                    id: uuid(),
                    type: "save_form",
                    user: currentUser,
                    timestamp: (/* @__PURE__ */ new Date()).getTime()
                  });
                  onSave();
                },
                onReset: () => {
                  historyDispatch({
                    id: uuid(),
                    type: "reset_form",
                    user: currentUser,
                    timestamp: (/* @__PURE__ */ new Date()).getTime()
                  });
                },
                children: fields.length !== 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Button$1,
                  {
                    onClick: () => onPreview(fields),
                    variant: "ghost",
                    size: "sm",
                    children: "Preview"
                  }
                ) })
              }
            ) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              EditorSidebar,
              {
                overflow: "auto",
                background: "grayAlpha.800",
                color: "white",
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(Sidebar, {})
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(EditorMain, { overflow: "auto", px: 8, pb: 16, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "dynamic-editor", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldListContainer$1, {}) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { height: 100 }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { ref: editorEndRef })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(EditorRightPanel, { overflow: "auto", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              RightPanel,
              {
                showHistory: true,
                onFieldAdded: () => {
                  var _a3;
                  return (_a3 = editorEndRef == null ? void 0 : editorEndRef.current) == null ? void 0 : _a3.scrollIntoView({
                    behavior: "smooth"
                  });
                }
              }
            ) })
          ] }) })
        }
      ) }) })
    }
  );
};
var lodash_isempty = { exports: {} };
lodash_isempty.exports;
var hasRequiredLodash_isempty;
function requireLodash_isempty() {
  if (hasRequiredLodash_isempty) return lodash_isempty.exports;
  hasRequiredLodash_isempty = 1;
  (function(module2, exports) {
    var MAX_SAFE_INTEGER = 9007199254740991;
    var argsTag = "[object Arguments]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
    var dataViewTag = "[object DataView]";
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal || freeSelf || Function("return this")();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    function getValue3(object, key2) {
      return object == null ? void 0 : object[key2];
    }
    function isHostObject(value) {
      var result = false;
      if (value != null && typeof value.toString != "function") {
        try {
          result = !!(value + "");
        } catch (e) {
        }
      }
      return result;
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    var funcProto = Function.prototype, objectProto = Object.prototype;
    var coreJsData = root2["__core-js_shared__"];
    var maskSrcKey = function() {
      var uid2 = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid2 ? "Symbol(src)_1." + uid2 : "";
    }();
    var funcToString = funcProto.toString;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    var objectToString = objectProto.toString;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    var Buffer2 = moduleExports ? root2.Buffer : void 0, propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0, nativeKeys = overArg(Object.keys, Object);
    var DataView2 = getNative(root2, "DataView"), Map2 = getNative(root2, "Map"), Promise2 = getNative(root2, "Promise"), Set2 = getNative(root2, "Set"), WeakMap2 = getNative(root2, "WeakMap");
    var nonEnumShadows = !propertyIsEnumerable.call({ "valueOf": 1 }, "valueOf");
    var dataViewCtorString = toSource(DataView2), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
    function baseGetTag(value) {
      return objectToString.call(value);
    }
    function baseIsNative(value) {
      if (!isObject2(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction2(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    function getNative(object, key2) {
      var value = getValue3(object, key2);
      return baseIsNative(value) ? value : void 0;
    }
    var getTag = baseGetTag;
    if (DataView2 && getTag(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
      getTag = function(value) {
        var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : void 0;
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    function isPrototype(value) {
      var Ctor = value && value.constructor, proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value === proto2;
    }
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    function isArguments(value) {
      return isArrayLikeObject(value) && hasOwnProperty2.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
    }
    var isArray2 = Array.isArray;
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction2(value);
    }
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    var isBuffer = nativeIsBuffer || stubFalse;
    function isEmpty2(value) {
      if (isArrayLike(value) && (isArray2(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isArguments(value))) {
        return !value.length;
      }
      var tag2 = getTag(value);
      if (tag2 == mapTag || tag2 == setTag) {
        return !value.size;
      }
      if (nonEnumShadows || isPrototype(value)) {
        return !nativeKeys(value).length;
      }
      for (var key2 in value) {
        if (hasOwnProperty2.call(value, key2)) {
          return false;
        }
      }
      return true;
    }
    function isFunction2(value) {
      var tag2 = isObject2(value) ? objectToString.call(value) : "";
      return tag2 == funcTag || tag2 == genTag;
    }
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    function isObject2(value) {
      var type = typeof value;
      return !!value && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return !!value && typeof value == "object";
    }
    function stubFalse() {
      return false;
    }
    module2.exports = isEmpty2;
  })(lodash_isempty, lodash_isempty.exports);
  return lodash_isempty.exports;
}
requireLodash_isempty();
function fontStack(fonts2) {
  return fonts2.map((font) => font.includes(" ") ? `"${font}"` : font).join(", ");
}
const colors$1 = {
  "light": {
    "colors": {
      "canvasDefaultTransparent": "var(--bgColor-transparent, var(--color-canvas-default-transparent, rgba(255,255,255,0)))",
      "pageHeaderBg": "var(--page-header-bgColor, var(--color-page-header-bg, #f6f8fa))",
      "marketingIcon": {
        "primary": "var(--color-marketing-icon-primary, #218bff)",
        "secondary": "var(--color-marketing-icon-secondary, #54aeff)"
      },
      "diffBlob": {
        "addition": {
          "numText": "var(--diffBlob-addition-fgColor-num, var(--color-diff-blob-addition-num-text, #1F2328))",
          "fg": "var(--diffBlob-addition-fgColor-text, var(--color-diff-blob-addition-fg, #1F2328))",
          "numBg": "var(--diffBlob-addition-bgColor-num, var(--color-diff-blob-addition-num-bg, #ccffd8))",
          "lineBg": "var(--diffBlob-addition-bgColor-line, var(--color-diff-blob-addition-line-bg, #e6ffec))",
          "wordBg": "var(--diffBlob-addition-bgColor-word, var(--color-diff-blob-addition-word-bg, #abf2bc))"
        },
        "deletion": {
          "numText": "var(--diffBlob-deletion-fgColor-num, var(--color-diff-blob-deletion-num-text, #1F2328))",
          "fg": "var(--diffBlob-deletion-fgColor-text, var(--color-diff-blob-deletion-fg, #1F2328))",
          "numBg": "var(--diffBlob-deletion-bgColor-num, var(--color-diff-blob-deletion-num-bg, #ffd7d5))",
          "lineBg": "var(--diffBlob-deletion-bgColor-line, var(--color-diff-blob-deletion-line-bg, #ffebe9))",
          "wordBg": "var(--diffBlob-deletion-bgColor-word, var(--color-diff-blob-deletion-word-bg, rgba(255,129,130,0.4)))"
        },
        "hunk": {
          "numBg": "var(--diffBlob-hunk-bgColor-num, var(--color-diff-blob-hunk-num-bg, rgba(84,174,255,0.4)))"
        },
        "expander": {
          "icon": "var(--diffBlob-expander-iconColor, var(--color-diff-blob-expander-icon, #656d76))"
        },
        "selectedLineHighlightMixBlendMode": "var(--color-diff-blob-selected-line-highlight-mix-blend-mode, multiply)"
      },
      "diffstat": {
        "deletionBorder": "var(--color-diffstat-deletion-border, rgba(31,35,40,0.15))",
        "additionBorder": "var(--color-diffstat-addition-border, rgba(31,35,40,0.15))",
        "additionBg": "var(undefined, var(--color-diffstat-addition-bg, #1f883d))"
      },
      "searchKeyword": {
        "hl": "var(--highlight-neutral-bgColor, var(--color-search-keyword-hl, #fff8c5))"
      },
      "prettylights": {
        "syntax": {
          "comment": "var(--color-prettylights-syntax-comment, #57606a)",
          "constant": "var(--color-prettylights-syntax-constant, #0550ae)",
          "entity": "var(--color-prettylights-syntax-entity, #6639ba)",
          "storageModifierImport": "var(--color-prettylights-syntax-storage-modifier-import, #24292f)",
          "entityTag": "var(--color-prettylights-syntax-entity-tag, #116329)",
          "keyword": "var(--color-prettylights-syntax-keyword, #cf222e)",
          "string": "var(--color-prettylights-syntax-string, #0a3069)",
          "variable": "var(--color-prettylights-syntax-variable, #953800)",
          "brackethighlighterUnmatched": "var(--color-prettylights-syntax-brackethighlighter-unmatched, #82071e)",
          "invalidIllegalText": "var(--color-prettylights-syntax-invalid-illegal-text, #f6f8fa)",
          "invalidIllegalBg": "var(--color-prettylights-syntax-invalid-illegal-bg, #82071e)",
          "carriageReturnText": "var(--color-prettylights-syntax-carriage-return-text, #f6f8fa)",
          "carriageReturnBg": "var(--color-prettylights-syntax-carriage-return-bg, #cf222e)",
          "stringRegexp": "var(--color-prettylights-syntax-string-regexp, #116329)",
          "markupList": "var(--color-prettylights-syntax-markup-list, #3b2300)",
          "markupHeading": "var(--color-prettylights-syntax-markup-heading, #0550ae)",
          "markupItalic": "var(--color-prettylights-syntax-markup-italic, #24292f)",
          "markupBold": "var(--color-prettylights-syntax-markup-bold, #24292f)",
          "markupDeletedText": "var(--color-prettylights-syntax-markup-deleted-text, #82071e)",
          "markupDeletedBg": "var(--color-prettylights-syntax-markup-deleted-bg, #ffebe9)",
          "markupInsertedText": "var(--color-prettylights-syntax-markup-inserted-text, #116329)",
          "markupInsertedBg": "var(--color-prettylights-syntax-markup-inserted-bg, #dafbe1)",
          "markupChangedText": "var(--color-prettylights-syntax-markup-changed-text, #953800)",
          "markupChangedBg": "var(--color-prettylights-syntax-markup-changed-bg, #ffd8b5)",
          "markupIgnoredText": "var(--color-prettylights-syntax-markup-ignored-text, #eaeef2)",
          "markupIgnoredBg": "var(--color-prettylights-syntax-markup-ignored-bg, #0550ae)",
          "metaDiffRange": "var(--color-prettylights-syntax-meta-diff-range, #8250df)",
          "brackethighlighterAngle": "var(--color-prettylights-syntax-brackethighlighter-angle, #57606a)",
          "sublimelinterGutterMark": "var(--color-prettylights-syntax-sublimelinter-gutter-mark, #8c959f)",
          "constantOtherReferenceLink": "var(--color-prettylights-syntax-constant-other-reference-link, #0a3069)"
        }
      },
      "codemirror": {
        "text": "var(--codeMirror-fgColor, var(--color-codemirror-text, #1F2328))",
        "bg": "var(--codeMirror-bgColor, var(--color-codemirror-bg, #ffffff))",
        "guttersBg": "var(--codeMirror-gutters-bgColor, var(--color-codemirror-gutters-bg, #ffffff))",
        "guttermarkerText": "var(--codeMirror-gutterMarker-fgColor-default, var(--color-codemirror-guttermarker-text, #ffffff))",
        "guttermarkerSubtleText": "var(--codeMirror-gutterMarker-fgColor-muted, var(--color-codemirror-guttermarker-subtle-text, #6e7781))",
        "linenumberText": "var(--codeMirror-lineNumber-fgColor, var(--color-codemirror-linenumber-text, #656d76))",
        "cursor": "var(--codeMirror-cursor-fgColor, var(--color-codemirror-cursor, #1F2328))",
        "selectionBg": "var(--codeMirror-selection-bgColor, var(--color-codemirror-selection-bg, rgba(84,174,255,0.4)))",
        "activelineBg": "var(--codeMirror-activeline-bgColor, var(--color-codemirror-activeline-bg, rgba(234,238,242,0.5)))",
        "matchingbracketText": "var(--codeMirror-matchingBracket-fgColor, var(--color-codemirror-matchingbracket-text, #1F2328))",
        "linesBg": "var(--codeMirror-lines-bgColor, var(--color-codemirror-lines-bg, #ffffff))",
        "syntax": {
          "comment": "var(--codeMirror-syntax-fgColor-comment, var(--color-codemirror-syntax-comment, #24292f))",
          "constant": "var(--codeMirror-syntax-fgColor-constant, var(--color-codemirror-syntax-constant, #0550ae))",
          "entity": "var(--codeMirror-syntax-fgColor-entity, var(--color-codemirror-syntax-entity, #8250df))",
          "keyword": "var(--codeMirror-syntax-fgColor-keyword, var(--color-codemirror-syntax-keyword, #cf222e))",
          "storage": "var(--codeMirror-syntax-fgColor-storage, var(--color-codemirror-syntax-storage, #cf222e))",
          "string": "var(--codeMirror-syntax-fgColor-string, var(--color-codemirror-syntax-string, #0a3069))",
          "support": "var(--codeMirror-syntax-fgColor-support, var(--color-codemirror-syntax-support, #0550ae))",
          "variable": "var(--codeMirror-syntax-fgColor-variable, var(--color-codemirror-syntax-variable, #953800))"
        }
      },
      "checks": {
        "bg": "var(--color-checks-bg, #24292f)",
        "runBorderWidth": "var(--color-checks-run-border-width, 0px)",
        "containerBorderWidth": "var(--color-checks-container-border-width, 0px)",
        "textPrimary": "var(--color-checks-text-primary, #f6f8fa)",
        "textSecondary": "var(--color-checks-text-secondary, #8c959f)",
        "textLink": "var(--color-checks-text-link, #54aeff)",
        "btnIcon": "var(--color-checks-btn-icon, #afb8c1)",
        "btnHoverIcon": "var(--color-checks-btn-hover-icon, #f6f8fa)",
        "btnHoverBg": "var(--color-checks-btn-hover-bg, rgba(255,255,255,0.125))",
        "inputText": "var(--color-checks-input-text, #eaeef2)",
        "inputPlaceholderText": "var(--color-checks-input-placeholder-text, #8c959f)",
        "inputFocusText": "var(--color-checks-input-focus-text, #8c959f)",
        "inputBg": "var(--color-checks-input-bg, #32383f)",
        "inputShadow": "var(--color-checks-input-shadow, none)",
        "donutError": "var(--color-checks-donut-error, #fa4549)",
        "donutPending": "var(--color-checks-donut-pending, #bf8700)",
        "donutSuccess": "var(--color-checks-donut-success, #1f883d)",
        "donutNeutral": "var(--color-checks-donut-neutral, #afb8c1)",
        "dropdownText": "var(--color-checks-dropdown-text, #afb8c1)",
        "dropdownBg": "var(--color-checks-dropdown-bg, #32383f)",
        "dropdownBorder": "var(--color-checks-dropdown-border, #424a53)",
        "dropdownShadow": "var(--color-checks-dropdown-shadow, rgba(31,35,40,0.3))",
        "dropdownHoverText": "var(--color-checks-dropdown-hover-text, #f6f8fa)",
        "dropdownHoverBg": "var(--color-checks-dropdown-hover-bg, #424a53)",
        "dropdownBtnHoverText": "var(--color-checks-dropdown-btn-hover-text, #f6f8fa)",
        "dropdownBtnHoverBg": "var(--color-checks-dropdown-btn-hover-bg, #32383f)",
        "scrollbarThumbBg": "var(--color-checks-scrollbar-thumb-bg, #57606a)",
        "headerLabelText": "var(--color-checks-header-label-text, #d0d7de)",
        "headerLabelOpenText": "var(--color-checks-header-label-open-text, #f6f8fa)",
        "headerBorder": "var(--color-checks-header-border, #32383f)",
        "headerIcon": "var(--color-checks-header-icon, #8c959f)",
        "lineText": "var(--color-checks-line-text, #d0d7de)",
        "lineNumText": "var(--color-checks-line-num-text, rgba(140,149,159,0.75))",
        "lineTimestampText": "var(--color-checks-line-timestamp-text, #8c959f)",
        "lineHoverBg": "var(--color-checks-line-hover-bg, #32383f)",
        "lineSelectedBg": "var(--color-checks-line-selected-bg, rgba(33,139,255,0.15))",
        "lineSelectedNumText": "var(--color-checks-line-selected-num-text, #54aeff)",
        "lineDtFmText": "var(--color-checks-line-dt-fm-text, #24292f)",
        "lineDtFmBg": "var(--color-checks-line-dt-fm-bg, #9a6700)",
        "gateBg": "var(--color-checks-gate-bg, rgba(125,78,0,0.15))",
        "gateText": "var(--color-checks-gate-text, #d0d7de)",
        "gateWaitingText": "var(--color-checks-gate-waiting-text, #d4a72c)",
        "stepHeaderOpenBg": "var(--color-checks-step-header-open-bg, #32383f)",
        "stepErrorText": "var(--color-checks-step-error-text, #ff8182)",
        "stepWarningText": "var(--color-checks-step-warning-text, #d4a72c)",
        "loglineText": "var(--color-checks-logline-text, #8c959f)",
        "loglineNumText": "var(--color-checks-logline-num-text, rgba(140,149,159,0.75))",
        "loglineDebugText": "var(--color-checks-logline-debug-text, #c297ff)",
        "loglineErrorText": "var(--color-checks-logline-error-text, #d0d7de)",
        "loglineErrorNumText": "var(--color-checks-logline-error-num-text, #ff8182)",
        "loglineErrorBg": "var(--color-checks-logline-error-bg, rgba(164,14,38,0.15))",
        "loglineWarningText": "var(--color-checks-logline-warning-text, #d0d7de)",
        "loglineWarningNumText": "var(--color-checks-logline-warning-num-text, #d4a72c)",
        "loglineWarningBg": "var(--color-checks-logline-warning-bg, rgba(125,78,0,0.15))",
        "loglineCommandText": "var(--color-checks-logline-command-text, #54aeff)",
        "loglineSectionText": "var(--color-checks-logline-section-text, #4ac26b)",
        "ansi": {
          "black": "var(--color-checks-ansi-black, #24292f)",
          "blackBright": "var(--color-checks-ansi-black-bright, #32383f)",
          "white": "var(--color-checks-ansi-white, #d0d7de)",
          "whiteBright": "var(--color-checks-ansi-white-bright, #d0d7de)",
          "gray": "var(--color-checks-ansi-gray, #8c959f)",
          "red": "var(--color-checks-ansi-red, #ff8182)",
          "redBright": "var(--color-checks-ansi-red-bright, #ffaba8)",
          "green": "var(--color-checks-ansi-green, #4ac26b)",
          "greenBright": "var(--color-checks-ansi-green-bright, #6fdd8b)",
          "yellow": "var(--color-checks-ansi-yellow, #d4a72c)",
          "yellowBright": "var(--color-checks-ansi-yellow-bright, #eac54f)",
          "blue": "var(--color-checks-ansi-blue, #54aeff)",
          "blueBright": "var(--color-checks-ansi-blue-bright, #80ccff)",
          "magenta": "var(--color-checks-ansi-magenta, #c297ff)",
          "magentaBright": "var(--color-checks-ansi-magenta-bright, #d8b9ff)",
          "cyan": "var(--color-checks-ansi-cyan, #76e3ea)",
          "cyanBright": "var(--color-checks-ansi-cyan-bright, #b3f0ff)"
        }
      },
      "project": {
        "headerBg": "var(--color-project-header-bg, #24292f)",
        "sidebarBg": "var(--color-project-sidebar-bg, #ffffff)",
        "gradientIn": "var(--color-project-gradient-in, #ffffff)",
        "gradientOut": "var(--color-project-gradient-out, rgba(255,255,255,0))"
      },
      "mktg": {
        "btn": {
          "bg": "var(--color-mktg-btn-bg, #1b1f23))"
        }
      },
      "control": {
        "borderColor": {
          "emphasis": "var(--control-borderColor-emphasis, var(--color-control-border-color-emphasis, #858F99))"
        }
      },
      "avatar": {
        "bg": "var(--avatar-bgColor, var(--color-avatar-bg, #ffffff))",
        "border": "var(--avatar-borderColor, var(--color-avatar-border, rgba(31,35,40,0.15)))",
        "stackFade": "var(--avatarStack-fade-bgColor-default, var(--color-avatar-stack-fade, #afb8c1))",
        "stackFadeMore": "var(--avatarStack-fade-bgColor-muted, var(--color-avatar-stack-fade-more, #d0d7de))"
      },
      "topicTag": {
        "border": "var(--topicTag-borderColor, var(--color-topic-tag-border, transparent))"
      },
      "counter": {
        "border": "var(--counter-borderColor, var(--color-counter-border, transparent))"
      },
      "selectMenu": {
        "backdropBorder": "var(--selectMenu-borderColor, var(--color-select-menu-backdrop-border, transparent))",
        "tapHighlight": "var(--control-bgColor-active, var(--color-select-menu-tap-highlight, rgba(175,184,193,0.5)))",
        "tapFocusBg": "var(--selectMenu-bgColor-active, var(--color-select-menu-tap-focus-bg, #b6e3ff))"
      },
      "overlay": {
        "backdrop": "var(--overlay-backdrop-bgColor, var(--color-overlay-backdrop, rgba(140,149,159,0.2)))"
      },
      "header": {
        "text": "var(--header-fgColor-default, var(--color-header-text, rgba(255,255,255,0.7)))",
        "bg": "var(--header-bgColor, var(--color-header-bg, #24292f))",
        "divider": "var(--header-borderColor-divider, var(--color-header-divider, #57606a))",
        "logo": "var(--header-fgColor-logo, var(--color-header-logo, #ffffff))"
      },
      "headerSearch": {
        "bg": "var(--headerSearch-bgColor, var(--color-header-search-bg, #24292f))",
        "border": "var(--headerSearch-borderColor, var(--color-header-search-border, #57606a))"
      },
      "sidenav": {
        "selectedBg": "var(--sideNav-bgColor-selected, var(--color-sidenav-selected-bg, #ffffff))"
      },
      "menu": {
        "bgActive": "var(--menu-bgColor-active, var(--color-menu-bg-active, transparent))"
      },
      "input": {
        "disabledBg": "var(--control-bgColor-disabled, var(--color-input-disabled-bg, rgba(175,184,193,0.2)))"
      },
      "timeline": {
        "badgeBg": "var(--timelineBadge-bgColor, var(--color-timeline-badge-bg, #eaeef2))"
      },
      "ansi": {
        "black": "var(--color-ansi-black, #24292f)",
        "blackBright": "var(--color-ansi-black-bright, #57606a)",
        "white": "var(--color-ansi-white, #6e7781)",
        "whiteBright": "var(--color-ansi-white-bright, #8c959f)",
        "gray": "var(--color-ansi-gray, #6e7781)",
        "red": "var(--color-ansi-red, #cf222e)",
        "redBright": "var(--color-ansi-red-bright, #a40e26)",
        "green": "var(--color-ansi-green, #116329)",
        "greenBright": "var(--color-ansi-green-bright, #1a7f37)",
        "yellow": "var(--color-ansi-yellow, #4d2d00)",
        "yellowBright": "var(--color-ansi-yellow-bright, #633c01)",
        "blue": "var(--color-ansi-blue, #0969da)",
        "blueBright": "var(--color-ansi-blue-bright, #218bff)",
        "magenta": "var(--color-ansi-magenta, #8250df)",
        "magentaBright": "var(--color-ansi-magenta-bright, #a475f9)",
        "cyan": "var(--color-ansi-cyan, #1b7c83)",
        "cyanBright": "var(--color-ansi-cyan-bright, #3192aa)"
      },
      "btn": {
        "text": "var(--button-default-fgColor-rest, var(--color-btn-text, #24292f))",
        "bg": "var(--button-default-bgColor-rest, var(--color-btn-bg, #f6f8fa))",
        "border": "var(--button-default-borderColor-rest, var(--color-btn-border, rgba(31,35,40,0.15)))",
        "hoverBg": "var(--button-default-bgColor-hover, var(--color-btn-hover-bg, #f3f4f6))",
        "hoverBorder": "var(--button-default-borderColor-hover, var(--color-btn-hover-border, rgba(31,35,40,0.15)))",
        "activeBg": "var(--button-default-bgColor-active, var(--color-btn-active-bg, hsla(220,14%,93%,1)))",
        "activeBorder": "var(--button-default-borderColor-active, var(--color-btn-active-border, rgba(31,35,40,0.15)))",
        "selectedBg": "var(--button-default-bgColor-selected, var(--color-btn-selected-bg, hsla(220,14%,94%,1)))",
        "counterBg": "var(--buttonCounter-default-bgColor-rest, var(--color-btn-counter-bg, rgba(31,35,40,0.08)))",
        "primary": {
          "text": "var(--button-primary-fgColor-rest, var(--color-btn-primary-text, #ffffff))",
          "bg": "var(--button-primary-bgColor-rest, var(--color-btn-primary-bg, #1f883d))",
          "border": "var(--button-primary-borderColor-rest, var(--color-btn-primary-border, rgba(31,35,40,0.15)))",
          "hoverBg": "var(--button-primary-bgColor-hover, var(--color-btn-primary-hover-bg, #1a7f37))",
          "hoverBorder": "var(--button-primary-borderColor-hover, var(--color-btn-primary-hover-border, rgba(31,35,40,0.15)))",
          "selectedBg": "var(--button-primary-bgColor-active, var(--color-btn-primary-selected-bg, hsla(137,66%,28%,1)))",
          "disabledText": "var(--button-primary-fgColor-disabled, var(--color-btn-primary-disabled-text, rgba(255,255,255,0.8)))",
          "disabledBg": "var(--button-primary-bgColor-disabled, var(--color-btn-primary-disabled-bg, #94d3a2))",
          "disabledBorder": "var(--button-primary-borderColor-disabled, var(--color-btn-primary-disabled-border, rgba(31,35,40,0.15)))",
          "icon": "var(--button-primary-iconColor-rest, var(--color-btn-primary-icon, rgba(255,255,255,0.8)))",
          "counterBg": "var(--buttonCounter-primary-bgColor-rest, var(--color-btn-primary-counter-bg, rgba(0,45,17,0.2)))"
        },
        "outline": {
          "text": "var(--button-outline-fgColor-rest, var(--color-btn-outline-text, #0969da))",
          "hoverText": "var(--button-outline-fgColor-hover, var(--color-btn-outline-hover-text, #ffffff))",
          "hoverBg": "var(--button-outline-bgColor-hover, var(--color-btn-outline-hover-bg, #0969da))",
          "hoverBorder": "var(--button-outline-borderColor-hover, var(--color-btn-outline-hover-border, rgba(31,35,40,0.15)))",
          "hoverCounterBg": "var(--buttonCounter-outline-bgColor-hover, var(--color-btn-outline-hover-counter-bg, rgba(255,255,255,0.2)))",
          "selectedText": "var(--button-outline-fgColor-active, var(--color-btn-outline-selected-text, #ffffff))",
          "selectedBg": "var(--button-outline-bgColor-active, var(--color-btn-outline-selected-bg, hsla(212,92%,42%,1)))",
          "selectedBorder": "var(--button-outline-borderColor-active, var(--color-btn-outline-selected-border, rgba(31,35,40,0.15)))",
          "disabledText": "var(--button-outline-fgColor-disabled, var(--color-btn-outline-disabled-text, rgba(9,105,218,0.5)))",
          "disabledBg": "var(--button-outline-bgColor-disabled, var(--color-btn-outline-disabled-bg, #f6f8fa))",
          "disabledCounterBg": "var(--buttonCounter-outline-bgColor-disabled, var(--color-btn-outline-disabled-counter-bg, rgba(9,105,218,0.05)))",
          "counterBg": "var(--buttonCounter-outline-bgColor-rest, var(--color-btn-outline-counter-bg, #0969da1a))",
          "counterFg": "var(--buttonCounter-outline-fgColor-rest, var(--color-btn-outline-counter-fg, #0550ae))",
          "hoverCounterFg": "var(--buttonCounter-outline-fgColor-hover, var(--color-btn-outline-hover-counter-fg, #ffffff))",
          "disabledCounterFg": "var(--buttonCounter-outline-fgColor-disabled, var(--color-btn-outline-disabled-counter-fg, rgba(9,105,218,0.5)))"
        },
        "danger": {
          "text": "var(--button-danger-fgColor-rest, var(--color-btn-danger-text, #cf222e))",
          "hoverText": "var(--button-danger-fgColor-hover, var(--color-btn-danger-hover-text, #ffffff))",
          "hoverBg": "var(--button-danger-bgColor-hover, var(--color-btn-danger-hover-bg, #a40e26))",
          "hoverBorder": "var(--button-danger-borderColor-hover, var(--color-btn-danger-hover-border, rgba(31,35,40,0.15)))",
          "hoverCounterBg": "var(--buttonCounter-danger-bgColor-hover, var(--color-btn-danger-hover-counter-bg, rgba(255,255,255,0.2)))",
          "selectedText": "var(--button-danger-fgColor-active, var(--color-btn-danger-selected-text, #ffffff))",
          "selectedBg": "var(--button-danger-bgColor-active, var(--color-btn-danger-selected-bg, hsla(356,72%,44%,1)))",
          "selectedBorder": "var(--button-danger-borderColor-active, var(--color-btn-danger-selected-border, rgba(31,35,40,0.15)))",
          "disabledText": "var(--button-danger-fgColor-disabled, var(--color-btn-danger-disabled-text, rgba(207,34,46,0.5)))",
          "disabledBg": "var(--button-danger-bgColor-disabled, var(--color-btn-danger-disabled-bg, #f6f8fa))",
          "disabledCounterBg": "var(--buttonCounter-danger-bgColor-disabled, var(--color-btn-danger-disabled-counter-bg, rgba(207,34,46,0.05)))",
          "counterBg": "var(--buttonCounter-danger-bgColor-rest, var(--color-btn-danger-counter-bg, rgba(207,34,46,0.1)))",
          "icon": "var(--button-danger-iconColor-rest, var(--color-btn-danger-icon, #cf222e))",
          "hoverIcon": "var(--button-danger-iconColor-hover, var(--color-btn-danger-hover-icon, #ffffff))",
          "counterFg": "var(--buttonCounter-danger-fgColor-rest, var(--color-btn-danger-counter-fg, #a40e26))",
          "hoverCounterFg": "var(--buttonCounter-danger-fgColor-hover, var(--color-btn-danger-hover-counter-fg, #ffffff))",
          "disabledCounterFg": "var(--buttonCounter-danger-fgColor-disabled, var(--color-btn-danger-disabled-counter-fg, rgba(207,34,46,0.5)))"
        },
        "inactive": {
          "bg": "var(--button-inactive-bgColor-rest, var(--color-btn-inactive-bg, #eaeef2))",
          "text": "var(--button-inactive-fgColor-rest, var(--color-btn-inactive-text, #57606a))"
        }
      },
      "underlinenav": {
        "icon": "var(--underlineNav-iconColor-rest, var(--color-underlinenav-icon, #6e7781))",
        "borderHover": "var(--underlineNav-borderColor-hover, var(--color-underlinenav-border-hover, rgba(175,184,193,0.2)))"
      },
      "actionListItem": {
        "inlineDivider": "var(--borderColor-muted, var(--color-action-list-item-inline-divider, rgba(208,215,222,0.48)))",
        "default": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-action-list-item-default-hover-bg, rgba(208,215,222,0.32)))",
          "hoverBorder": "var(--control-transparent-borderColor-hover, var(--color-action-list-item-default-hover-border, transparent))",
          "activeBg": "var(--control-transparent-bgColor-active, var(--color-action-list-item-default-active-bg, rgba(208,215,222,0.48)))",
          "activeBorder": "var(--control-transparent-borderColor-active, var(--color-action-list-item-default-active-border, transparent))",
          "selectedBg": "var(--control-transparent-bgColor-selected, var(--color-action-list-item-default-selected-bg, rgba(208,215,222,0.24)))"
        },
        "danger": {
          "hoverBg": "var(--control-danger-bgColor-hover, var(--color-action-list-item-default-danger-hover-bg, rgba(255,235,233,0.64)))",
          "activeBg": "var(--control-danger-bgColor-active, var(--color-action-list-item-default-danger-active-bg, #ffebe9))",
          "hoverText": "var(--control-danger-fgColor-hover, var(--color-action-list-item-default-danger-hover-text, #d1242f))"
        }
      },
      "switchTrack": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-switch-track-bg, #eaeef2))",
        "hoverBg": "var(--controlTrack-bgColor-hover, var(--color-switch-track-hover-bg, hsla(210,24%,90%,1)))",
        "activeBg": "var(--controlTrack-bgColor-active, var(--color-switch-track-active-bg, hsla(210,24%,88%,1)))",
        "disabledBg": "var(--controlTrack-bgColor-disabled, var(--color-switch-track-disabled-bg, #8c959f))",
        "fg": "var(--controlTrack-fgColor-rest, var(--color-switch-track-fg, #656d76))",
        "disabledFg": "var(--controlTrack-fgColor-disabled, var(--color-switch-track-disabled-fg, #ffffff))",
        "border": "var(--controlTrack-borderColor-rest, var(--color-switch-track-border, transparent))",
        "checked": {
          "bg": "var(--control-checked-bgColor-rest, var(--color-switch-track-checked-bg, #0969da))",
          "hoverBg": "var(--control-checked-bgColor-hover, var(--color-switch-track-checked-hover-bg, #0860CA))",
          "activeBg": "var(--control-checked-bgColor-active, var(--color-switch-track-checked-active-bg, #0757BA))",
          "fg": "var(--control-checked-fgColor-rest, var(--color-switch-track-checked-fg, #ffffff))",
          "disabledFg": "var(--control-checked-fgColor-disabled, var(--color-switch-track-checked-disabled-fg, #ffffff))",
          "border": "var(--borderColor-transparent, var(--color-switch-track-checked-border, transparent))"
        }
      },
      "switchKnob": {
        "bg": "var(--controlKnob-bgColor-rest, var(--color-switch-knob-bg, #ffffff))",
        "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-disabled-bg, #f6f8fa))",
        "border": "var(--controlKnob-borderColor-rest, var(--color-switch-knob-border, #858F99))",
        "checked": {
          "bg": "var(--controlKnob-bgColor-checked, var(--color-switch-knob-checked-bg, #ffffff))",
          "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-checked-disabled-bg, #f6f8fa))",
          "border": "var(--controlKnob-borderColor-checked, var(--color-switch-knob-checked-border, #0969da))"
        }
      },
      "segmentedControl": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-segmented-control-bg, #eaeef2))",
        "button": {
          "bg": "var(--controlKnob-bgColor-rest, var(--color-segmented-control-button-bg, #ffffff))",
          "hover": {
            "bg": "var(--controlTrack-bgColor-hover, var(--color-segmented-control-button-hover-bg, rgba(175,184,193,0.2)))"
          },
          "active": {
            "bg": "var(--controlTrack-bgColor-active, var(--color-segmented-control-button-hover-active-bg, rgba(175,184,193,0.4)))"
          },
          "selected": {
            "border": "var(--controlKnob-borderColor-rest, var(--color-segmented-control-button-hover-active-selected-border, #8c959f))"
          }
        }
      },
      "treeViewItem": {
        "chevron": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-tree-view-item-chevron-hover-bg, rgba(208,215,222,0.32)))"
        },
        "directory": {
          "fill": "var(--treeViewItem-leadingVisual-iconColor-rest, var(--color-tree-view-item-chevron-directory-fill, #54aeff))"
        }
      },
      "fg": {
        "default": "var(--fgColor-default, var(--color-fg-default, #1F2328))",
        "muted": "var(--fgColor-muted, var(--color-fg-muted, #656d76))",
        "subtle": "var(--fgColor-muted, var(--color-fg-subtle, #6e7781))",
        "onEmphasis": "var(--fgColor-onEmphasis, var(--color-fg-on-emphasis, #ffffff))"
      },
      "canvas": {
        "default": "var(--bgColor-default, var(--color-canvas-default, #ffffff))",
        "overlay": "var(--overlay-bgColor, var(--color-canvas-overlay, #ffffff))",
        "inset": "var(--bgColor-inset, var(--color-canvas-inset, #f6f8fa))",
        "subtle": "var(--bgColor-muted, var(--color-canvas-subtle, #f6f8fa))"
      },
      "border": {
        "default": "var(--borderColor-default, var(--color-border-default, #d0d7de))",
        "muted": "var(--borderColor-muted, var(--color-border-muted, hsla(210,18%,87%,1)))",
        "subtle": "var(--borderColor-muted, var(--color-border-subtle, rgba(31,35,40,0.15)))"
      },
      "neutral": {
        "emphasisPlus": "var(--bgColor-emphasis, var(--color-neutral-emphasis-plus, #24292f))",
        "emphasis": "var(--bgColor-neutral-emphasis, var(--color-neutral-emphasis, #6e7781))",
        "muted": "var(--bgColor-neutral-muted, var(--color-neutral-muted, rgba(175,184,193,0.2)))",
        "subtle": "var(--bgColor-neutral-muted, var(--color-neutral-subtle, rgba(234,238,242,0.5)))"
      },
      "accent": {
        "fg": "var(--fgColor-accent, var(--color-accent-fg, #0969da))",
        "emphasis": "var(--bgColor-accent-emphasis, var(--color-accent-emphasis, #0969da))",
        "muted": "var(--borderColor-accent-muted, var(--color-accent-muted, rgba(84,174,255,0.4)))",
        "subtle": "var(--bgColor-accent-muted, var(--color-accent-subtle, #ddf4ff))"
      },
      "success": {
        "fg": "var(--fgColor-success, var(--color-success-fg, #1a7f37))",
        "emphasis": "var(--bgColor-success-emphasis, var(--color-success-emphasis, #1f883d))",
        "muted": "var(--borderColor-success-muted, var(--color-success-muted, rgba(74,194,107,0.4)))",
        "subtle": "var(--bgColor-success-muted, var(--color-success-subtle, #dafbe1))"
      },
      "attention": {
        "fg": "var(--fgColor-attention, var(--color-attention-fg, #9a6700))",
        "emphasis": "var(--bgColor-attention-emphasis, var(--color-attention-emphasis, #9a6700))",
        "muted": "var(--borderColor-attention-muted, var(--color-attention-muted, rgba(212,167,44,0.4)))",
        "subtle": "var(--bgColor-attention-muted, var(--color-attention-subtle, #fff8c5))"
      },
      "severe": {
        "fg": "var(--fgColor-severe, var(--color-severe-fg, #bc4c00))",
        "emphasis": "var(--bgColor-severe-emphasis, var(--color-severe-emphasis, #bc4c00))",
        "muted": "var(--borderColor-severe-muted, var(--color-severe-muted, rgba(251,143,68,0.4)))",
        "subtle": "var(--bgColor-severe-muted, var(--color-severe-subtle, #fff1e5))"
      },
      "danger": {
        "fg": "var(--fgColor-danger, var(--color-danger-fg, #d1242f))",
        "emphasis": "var(--borderColor-danger-emphasis, var(--color-danger-emphasis, #cf222e))",
        "muted": "var(--borderColor-danger-muted, var(--color-danger-muted, rgba(255,129,130,0.4)))",
        "subtle": "var(--bgColor-danger-muted, var(--color-danger-subtle, #ffebe9))"
      },
      "open": {
        "fg": "var(--fgColor-open, var(--color-open-fg, #1a7f37))",
        "emphasis": "var(--bgColor-open-emphasis, var(--color-open-emphasis, #1f883d))",
        "muted": "var(--borderColor-open-muted, var(--color-open-muted, rgba(74,194,107,0.4)))",
        "subtle": "var(--bgColor-open-muted, var(--color-open-subtle, #dafbe1))"
      },
      "closed": {
        "fg": "var(--fgColor-closed, var(--color-closed-fg, #d1242f))",
        "emphasis": "var(--bgColor-closed-emphasis, var(--color-closed-emphasis, #cf222e))",
        "muted": "var(--borderColor-closed-muted, var(--color-closed-muted, rgba(255,129,130,0.4)))",
        "subtle": "var(--bgColor-closed-muted, var(--color-closed-subtle, #ffebe9))"
      },
      "done": {
        "fg": "var(--fgColor-done, var(--color-done-fg, #8250df))",
        "emphasis": "var(--bgColor-done-emphasis, var(--color-done-emphasis, #8250df))",
        "muted": "var(--borderColor-done-muted, var(--color-done-muted, rgba(194,151,255,0.4)))",
        "subtle": "var(--bgColor-done-muted, var(--color-done-subtle, #fbefff))"
      },
      "sponsors": {
        "fg": "var(--fgColor-sponsors, var(--color-sponsors-fg, #bf3989))",
        "emphasis": "var(--bgColor-sponsors-emphasis, var(--color-sponsors-emphasis, #bf3989))",
        "muted": "var(--borderColor-sponsors-muted, var(--color-sponsors-muted, rgba(255,128,200,0.4)))",
        "subtle": "var(--bgColor-sponsors-muted, var(--color-sponsors-subtle, #ffeff7))"
      },
      "primer": {
        "fg": {
          "disabled": "var(--fgColor-disabled, var(--color-primer-fg-disabled, #8c959f))"
        },
        "canvas": {
          "backdrop": "var(--overlay-backdrop-bgColor, var(--color-primer-fg-canvas-backdrop, rgba(31,35,40,0.5)))",
          "sticky": "var(--color-primer-canvas-sticky, rgba(255,255,255,0.95))"
        },
        "border": {
          "active": "var(--underlineNav-borderColor-active, var(--color-primer-border-active, #fd8c73))",
          "contrast": "var(--borderColor-muted, var(--color-primer-border-contrast, rgba(31,35,40,0.1)))"
        }
      }
    },
    "shadows": {
      "mktg": {
        "btn": {
          "shadow": {
            "outline": "var(--color-mktg-btn-shadow-outline, rgb(0 0 0 / 15%) 0 0 0 1px inset))",
            "focus": "var(--color-mktg-btn-shadow-focus, rgb(0 0 0 / 15%) 0 0 0 4px))",
            "hover": "var(--color-mktg-btn-shadow-hover, 0 3px 2px rgba(0, 0, 0, 0.07), 0 7px 5px rgba(0, 0, 0, 0.04), 0 12px 10px rgba(0, 0, 0, 0.03), 0 22px 18px rgba(0, 0, 0, 0.03), 0 42px 33px rgba(0, 0, 0, 0.02), 0 100px 80px rgba(0, 0, 0, 0.02)))",
            "hoverMuted": "var(--color-mktg-btn-shadow-hover-muted, rgb(0 0 0 / 70%) 0 0 0 2px inset))"
          }
        }
      },
      "avatar": {
        "childShadow": "var(--avatar-shadow, var(--color-avatar-child-shadow, 0 0 0 2px rgba(255,255,255,0.8)))"
      },
      "overlay": {
        "shadow": "var(--shadow-floating-small, var(--color-overlay-shadow, 0 1px 3px rgba(31,35,40,0.12), 0 8px 24px rgba(66,74,83,0.12)))"
      },
      "btn": {
        "shadow": "var(--button-default-shadow-resting, var(--color-btn-shadow, 0 1px 0 rgba(31,35,40,0.04)))",
        "insetShadow": "var(--button-default-shadow-inset, var(--color-btn-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.25)))",
        "primary": {
          "shadow": "var(--shadow-resting-small, var(--color-btn-primary-shadow, 0 1px 0 rgba(31,35,40,0.1)))",
          "insetShadow": "var(--shadow-highlight, var(--color-btn-primary-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.03)))",
          "selectedShadow": "var(--button-primary-shadow-selected, var(--color-btn-primary-selected-shadow, inset 0 1px 0 rgba(0,45,17,0.2)))"
        },
        "outline": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-outline-hover-shadow, 0 1px 0 rgba(31,35,40,0.1)))",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-outline-hover-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.03)))",
          "selectedShadow": "var(--button-outline-shadow-selected, var(--color-btn-outline-selected-shadow, inset 0 1px 0 rgba(0,33,85,0.2)))"
        },
        "danger": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-danger-hover-shadow, 0 1px 0 rgba(31,35,40,0.1)))",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-danger-hover-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.03)))",
          "selectedShadow": "var(--button-danger-shadow-selected, var(--color-btn-danger-selected-shadow, inset 0 1px 0 rgba(76,0,20,0.2)))"
        }
      },
      "shadow": {
        "small": "var(--shadow-resting-small, var(--color-shadow-small, 0 1px 0 rgba(31,35,40,0.04)))",
        "medium": "var(--shadow-resting-medium, var(--color-shadow-medium, 0 3px 6px rgba(140,149,159,0.15)))",
        "large": "var(--shadow-floating-large, var(--color-shadow-large, 0 8px 24px rgba(140,149,159,0.2)))",
        "extraLarge": "var(--shadow-floating-xlarge, var(--color-shadow-extra-large, 0 12px 28px rgba(140,149,159,0.3)))"
      },
      "primer": {
        "shadow": {
          "highlight": "var(--shadow-highlight, var(--color-primer-shadow-highlight, inset 0 1px 0 rgba(255,255,255,0.25)))",
          "inset": "var(--shadow-inset, var(--color-primer-shadow-inset, inset 0 1px 0 rgba(208,215,222,0.2)))"
        }
      }
    }
  },
  "light_high_contrast": {
    "colors": {
      "canvasDefaultTransparent": "var(--bgColor-transparent, var(--color-canvas-default-transparent, rgba(255,255,255,0)))",
      "pageHeaderBg": "var(--page-header-bgColor, var(--color-page-header-bg, #ffffff))",
      "marketingIcon": {
        "primary": "var(--color-marketing-icon-primary, #1168e3)",
        "secondary": "var(--color-marketing-icon-secondary, #368cf9)"
      },
      "diffBlob": {
        "addition": {
          "numText": "var(--diffBlob-addition-fgColor-num, var(--color-diff-blob-addition-num-text, #0e1116))",
          "fg": "var(--diffBlob-addition-fgColor-text, var(--color-diff-blob-addition-fg, #ffffff))",
          "numBg": "var(--diffBlob-addition-bgColor-num, var(--color-diff-blob-addition-num-bg, #ccffd8))",
          "lineBg": "var(--diffBlob-addition-bgColor-line, var(--color-diff-blob-addition-line-bg, #e6ffec))",
          "wordBg": "var(--diffBlob-addition-bgColor-word, var(--color-diff-blob-addition-word-bg, #055d20))"
        },
        "deletion": {
          "numText": "var(--diffBlob-deletion-fgColor-num, var(--color-diff-blob-deletion-num-text, #0e1116))",
          "fg": "var(--diffBlob-deletion-fgColor-text, var(--color-diff-blob-deletion-fg, #ffffff))",
          "numBg": "var(--diffBlob-deletion-bgColor-num, var(--color-diff-blob-deletion-num-bg, #ffd7d5))",
          "lineBg": "var(--diffBlob-deletion-bgColor-line, var(--color-diff-blob-deletion-line-bg, #fff0ee))",
          "wordBg": "var(--diffBlob-deletion-bgColor-word, var(--color-diff-blob-deletion-word-bg, #a0111f))"
        },
        "hunk": {
          "numBg": "var(--diffBlob-hunk-bgColor-num, var(--color-diff-blob-hunk-num-bg, #9cd7ff))"
        },
        "expander": {
          "icon": "var(--diffBlob-expander-iconColor, var(--color-diff-blob-expander-icon, #0e1116))"
        },
        "selectedLineHighlightMixBlendMode": "var(--color-diff-blob-selected-line-highlight-mix-blend-mode, multiply)"
      },
      "diffstat": {
        "deletionBorder": "var(--color-diffstat-deletion-border, rgba(1,4,9,0.8))",
        "additionBorder": "var(--color-diffstat-addition-border, rgba(1,4,9,0.8))",
        "additionBg": "var(undefined, var(--color-diffstat-addition-bg, #055d20))"
      },
      "searchKeyword": {
        "hl": "var(--highlight-neutral-bgColor, var(--color-search-keyword-hl, #fcf7be))"
      },
      "prettylights": {
        "syntax": {
          "comment": "var(--color-prettylights-syntax-comment, #4b535d)",
          "constant": "var(--color-prettylights-syntax-constant, #023b95)",
          "entity": "var(--color-prettylights-syntax-entity, #512598)",
          "storageModifierImport": "var(--color-prettylights-syntax-storage-modifier-import, #0e1116)",
          "entityTag": "var(--color-prettylights-syntax-entity-tag, #024c1a)",
          "keyword": "var(--color-prettylights-syntax-keyword, #a0111f)",
          "string": "var(--color-prettylights-syntax-string, #032563)",
          "variable": "var(--color-prettylights-syntax-variable, #702c00)",
          "brackethighlighterUnmatched": "var(--color-prettylights-syntax-brackethighlighter-unmatched, #6e011a)",
          "invalidIllegalText": "var(--color-prettylights-syntax-invalid-illegal-text, #ffffff)",
          "invalidIllegalBg": "var(--color-prettylights-syntax-invalid-illegal-bg, #6e011a)",
          "carriageReturnText": "var(--color-prettylights-syntax-carriage-return-text, #ffffff)",
          "carriageReturnBg": "var(--color-prettylights-syntax-carriage-return-bg, #a0111f)",
          "stringRegexp": "var(--color-prettylights-syntax-string-regexp, #024c1a)",
          "markupList": "var(--color-prettylights-syntax-markup-list, #2e1800)",
          "markupHeading": "var(--color-prettylights-syntax-markup-heading, #023b95)",
          "markupItalic": "var(--color-prettylights-syntax-markup-italic, #0e1116)",
          "markupBold": "var(--color-prettylights-syntax-markup-bold, #0e1116)",
          "markupDeletedText": "var(--color-prettylights-syntax-markup-deleted-text, #6e011a)",
          "markupDeletedBg": "var(--color-prettylights-syntax-markup-deleted-bg, #fff0ee)",
          "markupInsertedText": "var(--color-prettylights-syntax-markup-inserted-text, #024c1a)",
          "markupInsertedBg": "var(--color-prettylights-syntax-markup-inserted-bg, #d2fedb)",
          "markupChangedText": "var(--color-prettylights-syntax-markup-changed-text, #702c00)",
          "markupChangedBg": "var(--color-prettylights-syntax-markup-changed-bg, #ffc67b)",
          "markupIgnoredText": "var(--color-prettylights-syntax-markup-ignored-text, #e7ecf0)",
          "markupIgnoredBg": "var(--color-prettylights-syntax-markup-ignored-bg, #023b95)",
          "metaDiffRange": "var(--color-prettylights-syntax-meta-diff-range, #622cbc)",
          "brackethighlighterAngle": "var(--color-prettylights-syntax-brackethighlighter-angle, #4b535d)",
          "sublimelinterGutterMark": "var(--color-prettylights-syntax-sublimelinter-gutter-mark, #88929d)",
          "constantOtherReferenceLink": "var(--color-prettylights-syntax-constant-other-reference-link, #032563)"
        }
      },
      "codemirror": {
        "text": "var(--codeMirror-fgColor, var(--color-codemirror-text, #0e1116))",
        "bg": "var(--codeMirror-bgColor, var(--color-codemirror-bg, #ffffff))",
        "guttersBg": "var(--codeMirror-gutters-bgColor, var(--color-codemirror-gutters-bg, #ffffff))",
        "guttermarkerText": "var(--codeMirror-gutterMarker-fgColor-default, var(--color-codemirror-guttermarker-text, #ffffff))",
        "guttermarkerSubtleText": "var(--codeMirror-gutterMarker-fgColor-muted, var(--color-codemirror-guttermarker-subtle-text, #66707b))",
        "linenumberText": "var(--codeMirror-lineNumber-fgColor, var(--color-codemirror-linenumber-text, #0e1116))",
        "cursor": "var(--codeMirror-cursor-fgColor, var(--color-codemirror-cursor, #0e1116))",
        "selectionBg": "var(--codeMirror-selection-bgColor, var(--color-codemirror-selection-bg, #368cf9))",
        "activelineBg": "var(--codeMirror-activeline-bgColor, var(--color-codemirror-activeline-bg, #e7ecf0))",
        "matchingbracketText": "var(--codeMirror-matchingBracket-fgColor, var(--color-codemirror-matchingbracket-text, #0e1116))",
        "linesBg": "var(--codeMirror-lines-bgColor, var(--color-codemirror-lines-bg, #ffffff))",
        "syntax": {
          "comment": "var(--codeMirror-syntax-fgColor-comment, var(--color-codemirror-syntax-comment, #0e1116))",
          "constant": "var(--codeMirror-syntax-fgColor-constant, var(--color-codemirror-syntax-constant, #023b95))",
          "entity": "var(--codeMirror-syntax-fgColor-entity, var(--color-codemirror-syntax-entity, #622cbc))",
          "keyword": "var(--codeMirror-syntax-fgColor-keyword, var(--color-codemirror-syntax-keyword, #a0111f))",
          "storage": "var(--codeMirror-syntax-fgColor-storage, var(--color-codemirror-syntax-storage, #a0111f))",
          "string": "var(--codeMirror-syntax-fgColor-string, var(--color-codemirror-syntax-string, #032563))",
          "support": "var(--codeMirror-syntax-fgColor-support, var(--color-codemirror-syntax-support, #023b95))",
          "variable": "var(--codeMirror-syntax-fgColor-variable, var(--color-codemirror-syntax-variable, #702c00))"
        }
      },
      "checks": {
        "bg": "var(--color-checks-bg, #0e1116)",
        "runBorderWidth": "var(--color-checks-run-border-width, 0px)",
        "containerBorderWidth": "var(--color-checks-container-border-width, 0px)",
        "textPrimary": "var(--color-checks-text-primary, #ffffff)",
        "textSecondary": "var(--color-checks-text-secondary, #88929d)",
        "textLink": "var(--color-checks-text-link, #368cf9)",
        "btnIcon": "var(--color-checks-btn-icon, #acb6c0)",
        "btnHoverIcon": "var(--color-checks-btn-hover-icon, #ffffff)",
        "btnHoverBg": "var(--color-checks-btn-hover-bg, rgba(255,255,255,0.125))",
        "inputText": "var(--color-checks-input-text, #e7ecf0)",
        "inputPlaceholderText": "var(--color-checks-input-placeholder-text, #88929d)",
        "inputFocusText": "var(--color-checks-input-focus-text, #88929d)",
        "inputBg": "var(--color-checks-input-bg, #20252c)",
        "inputShadow": "var(--color-checks-input-shadow, none)",
        "donutError": "var(--color-checks-donut-error, #d5232c)",
        "donutPending": "var(--color-checks-donut-pending, #956400)",
        "donutSuccess": "var(--color-checks-donut-success, #055d20)",
        "donutNeutral": "var(--color-checks-donut-neutral, #acb6c0)",
        "dropdownText": "var(--color-checks-dropdown-text, #acb6c0)",
        "dropdownBg": "var(--color-checks-dropdown-bg, #20252c)",
        "dropdownBorder": "var(--color-checks-dropdown-border, #343b43)",
        "dropdownShadow": "var(--color-checks-dropdown-shadow, rgba(1,4,9,0.3))",
        "dropdownHoverText": "var(--color-checks-dropdown-hover-text, #ffffff)",
        "dropdownHoverBg": "var(--color-checks-dropdown-hover-bg, #343b43)",
        "dropdownBtnHoverText": "var(--color-checks-dropdown-btn-hover-text, #ffffff)",
        "dropdownBtnHoverBg": "var(--color-checks-dropdown-btn-hover-bg, #20252c)",
        "scrollbarThumbBg": "var(--color-checks-scrollbar-thumb-bg, #4b535d)",
        "headerLabelText": "var(--color-checks-header-label-text, #ced5dc)",
        "headerLabelOpenText": "var(--color-checks-header-label-open-text, #ffffff)",
        "headerBorder": "var(--color-checks-header-border, #20252c)",
        "headerIcon": "var(--color-checks-header-icon, #88929d)",
        "lineText": "var(--color-checks-line-text, #ced5dc)",
        "lineNumText": "var(--color-checks-line-num-text, rgba(136,146,157,0.75))",
        "lineTimestampText": "var(--color-checks-line-timestamp-text, #88929d)",
        "lineHoverBg": "var(--color-checks-line-hover-bg, #20252c)",
        "lineSelectedBg": "var(--color-checks-line-selected-bg, rgba(17,104,227,0.15))",
        "lineSelectedNumText": "var(--color-checks-line-selected-num-text, #368cf9)",
        "lineDtFmText": "var(--color-checks-line-dt-fm-text, #0e1116)",
        "lineDtFmBg": "var(--color-checks-line-dt-fm-bg, #744500)",
        "gateBg": "var(--color-checks-gate-bg, rgba(96,55,0,0.15))",
        "gateText": "var(--color-checks-gate-text, #ced5dc)",
        "gateWaitingText": "var(--color-checks-gate-waiting-text, #b58407)",
        "stepHeaderOpenBg": "var(--color-checks-step-header-open-bg, #20252c)",
        "stepErrorText": "var(--color-checks-step-error-text, #ee5a5d)",
        "stepWarningText": "var(--color-checks-step-warning-text, #b58407)",
        "loglineText": "var(--color-checks-logline-text, #88929d)",
        "loglineNumText": "var(--color-checks-logline-num-text, rgba(136,146,157,0.75))",
        "loglineDebugText": "var(--color-checks-logline-debug-text, #a371f7)",
        "loglineErrorText": "var(--color-checks-logline-error-text, #ced5dc)",
        "loglineErrorNumText": "var(--color-checks-logline-error-num-text, #ee5a5d)",
        "loglineErrorBg": "var(--color-checks-logline-error-bg, rgba(134,6,29,0.15))",
        "loglineWarningText": "var(--color-checks-logline-warning-text, #ced5dc)",
        "loglineWarningNumText": "var(--color-checks-logline-warning-num-text, #b58407)",
        "loglineWarningBg": "var(--color-checks-logline-warning-bg, rgba(96,55,0,0.15))",
        "loglineCommandText": "var(--color-checks-logline-command-text, #368cf9)",
        "loglineSectionText": "var(--color-checks-logline-section-text, #26a148)",
        "ansi": {
          "black": "var(--color-checks-ansi-black, #0e1116)",
          "blackBright": "var(--color-checks-ansi-black-bright, #20252c)",
          "white": "var(--color-checks-ansi-white, #ced5dc)",
          "whiteBright": "var(--color-checks-ansi-white-bright, #ced5dc)",
          "gray": "var(--color-checks-ansi-gray, #88929d)",
          "red": "var(--color-checks-ansi-red, #ee5a5d)",
          "redBright": "var(--color-checks-ansi-red-bright, #ff8e8a)",
          "green": "var(--color-checks-ansi-green, #26a148)",
          "greenBright": "var(--color-checks-ansi-green-bright, #43c663)",
          "yellow": "var(--color-checks-ansi-yellow, #b58407)",
          "yellowBright": "var(--color-checks-ansi-yellow-bright, #d5a824)",
          "blue": "var(--color-checks-ansi-blue, #368cf9)",
          "blueBright": "var(--color-checks-ansi-blue-bright, #67b3fd)",
          "magenta": "var(--color-checks-ansi-magenta, #a371f7)",
          "magentaBright": "var(--color-checks-ansi-magenta-bright, #c49bff)",
          "cyan": "var(--color-checks-ansi-cyan, #76e3ea)",
          "cyanBright": "var(--color-checks-ansi-cyan-bright, #b3f0ff)"
        }
      },
      "project": {
        "headerBg": "var(--color-project-header-bg, #0e1116)",
        "sidebarBg": "var(--color-project-sidebar-bg, #ffffff)",
        "gradientIn": "var(--color-project-gradient-in, #ffffff)",
        "gradientOut": "var(--color-project-gradient-out, rgba(255,255,255,0))"
      },
      "mktg": {
        "btn": {
          "bg": "var(--color-mktg-btn-bg, #1b1f23))"
        }
      },
      "control": {
        "borderColor": {
          "emphasis": "var(--control-borderColor-emphasis, var(--color-control-border-color-emphasis, #20252c))"
        }
      },
      "avatar": {
        "bg": "var(--avatar-bgColor, var(--color-avatar-bg, #ffffff))",
        "border": "var(--avatar-borderColor, var(--color-avatar-border, rgba(1,4,9,0.8)))",
        "stackFade": "var(--avatarStack-fade-bgColor-default, var(--color-avatar-stack-fade, #acb6c0))",
        "stackFadeMore": "var(--avatarStack-fade-bgColor-muted, var(--color-avatar-stack-fade-more, #ced5dc))"
      },
      "topicTag": {
        "border": "var(--topicTag-borderColor, var(--color-topic-tag-border, #0349b4))"
      },
      "counter": {
        "border": "var(--counter-borderColor, var(--color-counter-border, #20252c))"
      },
      "selectMenu": {
        "backdropBorder": "var(--selectMenu-borderColor, var(--color-select-menu-backdrop-border, transparent))",
        "tapHighlight": "var(--control-bgColor-active, var(--color-select-menu-tap-highlight, rgba(172,182,192,0.5)))",
        "tapFocusBg": "var(--selectMenu-bgColor-active, var(--color-select-menu-tap-focus-bg, #9cd7ff))"
      },
      "overlay": {
        "backdrop": "var(--overlay-backdrop-bgColor, var(--color-overlay-backdrop, rgba(136,146,157,0.2)))"
      },
      "header": {
        "text": "var(--header-fgColor-default, var(--color-header-text, rgba(255,255,255,0.7)))",
        "bg": "var(--header-bgColor, var(--color-header-bg, #0e1116))",
        "divider": "var(--header-borderColor-divider, var(--color-header-divider, #acb6c0))",
        "logo": "var(--header-fgColor-logo, var(--color-header-logo, #ffffff))"
      },
      "headerSearch": {
        "bg": "var(--headerSearch-bgColor, var(--color-header-search-bg, #0e1116))",
        "border": "var(--headerSearch-borderColor, var(--color-header-search-border, #4b535d))"
      },
      "sidenav": {
        "selectedBg": "var(--sideNav-bgColor-selected, var(--color-sidenav-selected-bg, #ffffff))"
      },
      "menu": {
        "bgActive": "var(--menu-bgColor-active, var(--color-menu-bg-active, transparent))"
      },
      "input": {
        "disabledBg": "var(--control-bgColor-disabled, var(--color-input-disabled-bg, rgba(172,182,192,0.2)))"
      },
      "timeline": {
        "badgeBg": "var(--timelineBadge-bgColor, var(--color-timeline-badge-bg, #e7ecf0))"
      },
      "ansi": {
        "black": "var(--color-ansi-black, #0e1116)",
        "blackBright": "var(--color-ansi-black-bright, #4b535d)",
        "white": "var(--color-ansi-white, #66707b)",
        "whiteBright": "var(--color-ansi-white-bright, #88929d)",
        "gray": "var(--color-ansi-gray, #66707b)",
        "red": "var(--color-ansi-red, #a0111f)",
        "redBright": "var(--color-ansi-red-bright, #86061d)",
        "green": "var(--color-ansi-green, #024c1a)",
        "greenBright": "var(--color-ansi-green-bright, #055d20)",
        "yellow": "var(--color-ansi-yellow, #3f2200)",
        "yellowBright": "var(--color-ansi-yellow-bright, #4e2c00)",
        "blue": "var(--color-ansi-blue, #0349b4)",
        "blueBright": "var(--color-ansi-blue-bright, #1168e3)",
        "magenta": "var(--color-ansi-magenta, #622cbc)",
        "magentaBright": "var(--color-ansi-magenta-bright, #844ae7)",
        "cyan": "var(--color-ansi-cyan, #1b7c83)",
        "cyanBright": "var(--color-ansi-cyan-bright, #3192aa)"
      },
      "btn": {
        "text": "var(--button-default-fgColor-rest, var(--color-btn-text, #0e1116))",
        "bg": "var(--button-default-bgColor-rest, var(--color-btn-bg, #e7ecf0))",
        "border": "var(--button-default-borderColor-rest, var(--color-btn-border, rgba(1,4,9,0.8)))",
        "hoverBg": "var(--button-default-bgColor-hover, var(--color-btn-hover-bg, #ced5dc))",
        "hoverBorder": "var(--button-default-borderColor-hover, var(--color-btn-hover-border, rgba(1,4,9,0.8)))",
        "activeBg": "var(--button-default-bgColor-active, var(--color-btn-active-bg, #acb6c0))",
        "activeBorder": "var(--button-default-borderColor-active, var(--color-btn-active-border, rgba(1,4,9,0.8)))",
        "selectedBg": "var(--button-default-bgColor-selected, var(--color-btn-selected-bg, #acb6c0))",
        "counterBg": "var(--buttonCounter-default-bgColor-rest, var(--color-btn-counter-bg, rgba(1,4,9,0.08)))",
        "primary": {
          "text": "var(--button-primary-fgColor-rest, var(--color-btn-primary-text, #ffffff))",
          "bg": "var(--button-primary-bgColor-rest, var(--color-btn-primary-bg, #055d20))",
          "border": "var(--button-primary-borderColor-rest, var(--color-btn-primary-border, #013d14))",
          "hoverBg": "var(--button-primary-bgColor-hover, var(--color-btn-primary-hover-bg, #024c1a))",
          "hoverBorder": "var(--button-primary-borderColor-hover, var(--color-btn-primary-hover-border, #013d14))",
          "selectedBg": "var(--button-primary-bgColor-active, var(--color-btn-primary-selected-bg, hsla(139,95%,13%,1)))",
          "disabledText": "var(--button-primary-fgColor-disabled, var(--color-btn-primary-disabled-text, rgba(255,255,255,0.8)))",
          "disabledBg": "var(--button-primary-bgColor-disabled, var(--color-btn-primary-disabled-bg, #94d3a2))",
          "disabledBorder": "var(--button-primary-borderColor-disabled, var(--color-btn-primary-disabled-border, rgba(1,4,9,0.8)))",
          "icon": "var(--button-primary-iconColor-rest, var(--color-btn-primary-icon, rgba(255,255,255,0.8)))",
          "counterBg": "var(--buttonCounter-primary-bgColor-rest, var(--color-btn-primary-counter-bg, rgba(0,35,11,0.2)))"
        },
        "outline": {
          "text": "var(--button-outline-fgColor-rest, var(--color-btn-outline-text, #023b95))",
          "hoverText": "var(--button-outline-fgColor-hover, var(--color-btn-outline-hover-text, #ffffff))",
          "hoverBg": "var(--button-outline-bgColor-hover, var(--color-btn-outline-hover-bg, #0349b4))",
          "hoverBorder": "var(--button-outline-borderColor-hover, var(--color-btn-outline-hover-border, #022f7a))",
          "hoverCounterBg": "var(--buttonCounter-outline-bgColor-hover, var(--color-btn-outline-hover-counter-bg, rgba(255,255,255,0.2)))",
          "selectedText": "var(--button-outline-fgColor-active, var(--color-btn-outline-selected-text, #ffffff))",
          "selectedBg": "var(--button-outline-bgColor-active, var(--color-btn-outline-selected-bg, #022f7a))",
          "selectedBorder": "var(--button-outline-borderColor-active, var(--color-btn-outline-selected-border, #022f7a))",
          "disabledText": "var(--button-outline-fgColor-disabled, var(--color-btn-outline-disabled-text, rgba(3,73,180,0.5)))",
          "disabledBg": "var(--button-outline-bgColor-disabled, var(--color-btn-outline-disabled-bg, #e7ecf0))",
          "disabledCounterBg": "var(--buttonCounter-outline-bgColor-disabled, var(--color-btn-outline-disabled-counter-bg, rgba(3,73,180,0.05)))",
          "counterBg": "var(--buttonCounter-outline-bgColor-rest, var(--color-btn-outline-counter-bg, #0969da1a))",
          "counterFg": "var(--buttonCounter-outline-fgColor-rest, var(--color-btn-outline-counter-fg, #023b95))",
          "hoverCounterFg": "var(--buttonCounter-outline-fgColor-hover, var(--color-btn-outline-hover-counter-fg, #ffffff))",
          "disabledCounterFg": "var(--buttonCounter-outline-fgColor-disabled, var(--color-btn-outline-disabled-counter-fg, rgba(3,73,180,0.5)))"
        },
        "danger": {
          "text": "var(--button-danger-fgColor-rest, var(--color-btn-danger-text, #86061d))",
          "hoverText": "var(--button-danger-fgColor-hover, var(--color-btn-danger-hover-text, #ffffff))",
          "hoverBg": "var(--button-danger-bgColor-hover, var(--color-btn-danger-hover-bg, #a0111f))",
          "hoverBorder": "var(--button-danger-borderColor-hover, var(--color-btn-danger-hover-border, #6e011a))",
          "hoverCounterBg": "var(--buttonCounter-danger-bgColor-hover, var(--color-btn-danger-hover-counter-bg, rgba(255,255,255,0.2)))",
          "selectedText": "var(--button-danger-fgColor-active, var(--color-btn-danger-selected-text, #ffffff))",
          "selectedBg": "var(--button-danger-bgColor-active, var(--color-btn-danger-selected-bg, #6e011a))",
          "selectedBorder": "var(--button-danger-borderColor-active, var(--color-btn-danger-selected-border, #6e011a))",
          "disabledText": "var(--button-danger-fgColor-disabled, var(--color-btn-danger-disabled-text, rgba(160,17,31,0.5)))",
          "disabledBg": "var(--button-danger-bgColor-disabled, var(--color-btn-danger-disabled-bg, #e7ecf0))",
          "disabledCounterBg": "var(--buttonCounter-danger-bgColor-disabled, var(--color-btn-danger-disabled-counter-bg, rgba(160,17,31,0.05)))",
          "counterBg": "var(--buttonCounter-danger-bgColor-rest, var(--color-btn-danger-counter-bg, rgba(160,17,31,0.1)))",
          "icon": "var(--button-danger-iconColor-rest, var(--color-btn-danger-icon, #86061d))",
          "hoverIcon": "var(--button-danger-iconColor-hover, var(--color-btn-danger-hover-icon, #ffffff))",
          "counterFg": "var(--buttonCounter-danger-fgColor-rest, var(--color-btn-danger-counter-fg, #86061d))",
          "hoverCounterFg": "var(--buttonCounter-danger-fgColor-hover, var(--color-btn-danger-hover-counter-fg, #ffffff))",
          "disabledCounterFg": "var(--buttonCounter-danger-fgColor-disabled, var(--color-btn-danger-disabled-counter-fg, rgba(160,17,31,0.5)))"
        },
        "inactive": {
          "bg": "var(--button-inactive-bgColor-rest, var(--color-btn-inactive-bg, #e7ecf0))",
          "text": "var(--button-inactive-fgColor-rest, var(--color-btn-inactive-text, #4b535d))"
        }
      },
      "underlinenav": {
        "icon": "var(--underlineNav-iconColor-rest, var(--color-underlinenav-icon, #66707b))",
        "borderHover": "var(--underlineNav-borderColor-hover, var(--color-underlinenav-border-hover, rgba(172,182,192,0.2)))"
      },
      "actionListItem": {
        "inlineDivider": "var(--borderColor-muted, var(--color-action-list-item-inline-divider, #88929d))",
        "default": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-action-list-item-default-hover-bg, #e7ecf0))",
          "hoverBorder": "var(--control-transparent-borderColor-hover, var(--color-action-list-item-default-hover-border, #88929d))",
          "activeBg": "var(--control-transparent-bgColor-active, var(--color-action-list-item-default-active-bg, #ced5dc))",
          "activeBorder": "var(--control-transparent-borderColor-active, var(--color-action-list-item-default-active-border, #20252c))",
          "selectedBg": "var(--control-transparent-bgColor-selected, var(--color-action-list-item-default-selected-bg, #ced5dc))"
        },
        "danger": {
          "hoverBg": "var(--control-danger-bgColor-hover, var(--color-action-list-item-danger-hover-bg, #a0111f))",
          "activeBg": "var(--control-danger-bgColor-active, var(--color-action-list-item-danger-active-bg, #6e011a))",
          "hoverText": "var(--control-danger-fgColor-hover, var(--color-action-list-item-danger-hover-text, #ffffff))"
        }
      },
      "switchTrack": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-switch-track-bg, #66707b))",
        "hoverBg": "var(--controlTrack-bgColor-hover, var(--color-switch-track-hover-bg, hsla(211,9%,47%,1)))",
        "activeBg": "var(--controlTrack-bgColor-active, var(--color-switch-track-active-bg, hsla(211,9%,49%,1)))",
        "disabledBg": "var(--controlTrack-bgColor-disabled, var(--color-switch-track-disabled-bg, #88929d))",
        "fg": "var(--controlTrack-fgColor-rest, var(--color-switch-track-fg, #ffffff))",
        "disabledFg": "var(--controlTrack-fgColor-disabled, var(--color-switch-track-disabled-fg, #ffffff))",
        "border": "var(--controlTrack-borderColor-rest, var(--color-switch-track-border, transparent))",
        "checked": {
          "bg": "var(--control-checked-bgColor-rest, var(--color-switch-track-checked-bg, #0349b4))",
          "hoverBg": "var(--control-checked-bgColor-hover, var(--color-switch-track-checked-hover-bg, #0860CA))",
          "activeBg": "var(--control-checked-bgColor-active, var(--color-switch-track-checked-active-bg, #0757BA))",
          "fg": "var(--control-checked-fgColor-rest, var(--color-switch-track-checked-fg, #ffffff))",
          "disabledFg": "var(--control-checked-fgColor-disabled, var(--color-switch-track-checked-disabled-fg, #ffffff))",
          "border": "var(--borderColor-transparent, var(--color-switch-track-checked-border, transparent))"
        }
      },
      "switchKnob": {
        "bg": "var(--controlKnob-bgColor-rest, var(--color-switch-knob-bg, #ffffff))",
        "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-disabled-bg, #e7ecf0))",
        "border": "var(--controlKnob-borderColor-rest, var(--color-switch-knob-border, #20252c))",
        "checked": {
          "bg": "var(--controlKnob-bgColor-checked, var(--color-switch-knob-checked-bg, #ffffff))",
          "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-checked-disabled-bg, #e7ecf0))",
          "border": "var(--controlKnob-borderColor-checked, var(--color-switch-knob-checked-border, #0349b4))"
        }
      },
      "segmentedControl": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-segmented-control-bg, #e7ecf0))",
        "button": {
          "bg": "var(--controlKnob-bgColor-rest, var(--color-segmented-control-button-bg, #ffffff))",
          "hover": {
            "bg": "var(--controlTrack-bgColor-hover, var(--color-segmented-control-button-hover-bg, rgba(172,182,192,0.2)))"
          },
          "active": {
            "bg": "var(--controlTrack-bgColor-active, var(--color-segmented-control-button-hover-active-bg, rgba(172,182,192,0.4)))"
          },
          "selected": {
            "border": "var(--controlKnob-borderColor-rest, var(--color-segmented-control-button-hover-active-selected-border, #88929d))"
          }
        }
      },
      "treeViewItem": {
        "chevron": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-tree-view-item-chevron-hover-bg, #ced5dc))"
        },
        "directory": {
          "fill": "var(--treeViewItem-leadingVisual-iconColor-rest, var(--color-tree-view-item-chevron-directory-fill, #368cf9))"
        }
      },
      "fg": {
        "default": "var(--fgColor-default, var(--color-fg-default, #0e1116))",
        "muted": "var(--fgColor-muted, var(--color-fg-muted, #0e1116))",
        "subtle": "var(--fgColor-muted, var(--color-fg-subtle, #66707b))",
        "onEmphasis": "var(--fgColor-onEmphasis, var(--color-fg-on-emphasis, #ffffff))"
      },
      "canvas": {
        "default": "var(--bgColor-default, var(--color-canvas-default, #ffffff))",
        "overlay": "var(--overlay-bgColor, var(--color-canvas-overlay, #ffffff))",
        "inset": "var(--bgColor-inset, var(--color-canvas-inset, #ffffff))",
        "subtle": "var(--bgColor-muted, var(--color-canvas-subtle, #e7ecf0))"
      },
      "border": {
        "default": "var(--borderColor-default, var(--color-border-default, #20252c))",
        "muted": "var(--borderColor-muted, var(--color-border-muted, #88929d))",
        "subtle": "var(--borderColor-muted, var(--color-border-subtle, rgba(1,4,9,0.8)))"
      },
      "neutral": {
        "emphasisPlus": "var(--bgColor-emphasis, var(--color-neutral-emphasis-plus, #0e1116))",
        "emphasis": "var(--bgColor-neutral-emphasis, var(--color-neutral-emphasis, #66707b))",
        "muted": "var(--bgColor-neutral-muted, var(--color-neutral-muted, rgba(172,182,192,0.2)))",
        "subtle": "var(--bgColor-neutral-muted, var(--color-neutral-subtle, #e7ecf0))"
      },
      "accent": {
        "fg": "var(--fgColor-accent, var(--color-accent-fg, #0349b4))",
        "emphasis": "var(--bgColor-accent-emphasis, var(--color-accent-emphasis, #0349b4))",
        "muted": "var(--borderColor-accent-muted, var(--color-accent-muted, #368cf9))",
        "subtle": "var(--bgColor-accent-muted, var(--color-accent-subtle, #dff7ff))"
      },
      "success": {
        "fg": "var(--fgColor-success, var(--color-success-fg, #055d20))",
        "emphasis": "var(--bgColor-success-emphasis, var(--color-success-emphasis, #055d20))",
        "muted": "var(--borderColor-success-muted, var(--color-success-muted, #26a148))",
        "subtle": "var(--bgColor-success-muted, var(--color-success-subtle, #d2fedb))"
      },
      "attention": {
        "fg": "var(--fgColor-attention, var(--color-attention-fg, #744500))",
        "emphasis": "var(--bgColor-attention-emphasis, var(--color-attention-emphasis, #744500))",
        "muted": "var(--borderColor-attention-muted, var(--color-attention-muted, #b58407))",
        "subtle": "var(--bgColor-attention-muted, var(--color-attention-subtle, #fcf7be))"
      },
      "severe": {
        "fg": "var(--fgColor-severe, var(--color-severe-fg, #873800))",
        "emphasis": "var(--bgColor-severe-emphasis, var(--color-severe-emphasis, #873800))",
        "muted": "var(--borderColor-severe-muted, var(--color-severe-muted, #dc6d1a))",
        "subtle": "var(--bgColor-severe-muted, var(--color-severe-subtle, #fff2d5))"
      },
      "danger": {
        "fg": "var(--fgColor-danger, var(--color-danger-fg, #d1242f))",
        "emphasis": "var(--borderColor-danger-emphasis, var(--color-danger-emphasis, #a0111f))",
        "muted": "var(--borderColor-danger-muted, var(--color-danger-muted, #ee5a5d))",
        "subtle": "var(--bgColor-danger-muted, var(--color-danger-subtle, #fff0ee))"
      },
      "open": {
        "fg": "var(--fgColor-open, var(--color-open-fg, #055d20))",
        "emphasis": "var(--bgColor-open-emphasis, var(--color-open-emphasis, #055d20))",
        "muted": "var(--borderColor-open-muted, var(--color-open-muted, rgba(38,161,72,0.4)))",
        "subtle": "var(--bgColor-open-muted, var(--color-open-subtle, #d2fedb))"
      },
      "closed": {
        "fg": "var(--fgColor-closed, var(--color-closed-fg, #d1242f))",
        "emphasis": "var(--bgColor-closed-emphasis, var(--color-closed-emphasis, #a0111f))",
        "muted": "var(--borderColor-closed-muted, var(--color-closed-muted, rgba(238,90,93,0.4)))",
        "subtle": "var(--bgColor-closed-muted, var(--color-closed-subtle, #fff0ee))"
      },
      "done": {
        "fg": "var(--fgColor-done, var(--color-done-fg, #622cbc))",
        "emphasis": "var(--bgColor-done-emphasis, var(--color-done-emphasis, #622cbc))",
        "muted": "var(--borderColor-done-muted, var(--color-done-muted, #a371f7))",
        "subtle": "var(--bgColor-done-muted, var(--color-done-subtle, #faf0fe))"
      },
      "sponsors": {
        "fg": "var(--fgColor-sponsors, var(--color-sponsors-fg, #971368))",
        "emphasis": "var(--bgColor-sponsors-emphasis, var(--color-sponsors-emphasis, #971368))",
        "muted": "var(--borderColor-sponsors-muted, var(--color-sponsors-muted, #ed4baf))",
        "subtle": "var(--bgColor-sponsors-muted, var(--color-sponsors-subtle, #feeff7))"
      },
      "primer": {
        "fg": {
          "disabled": "var(--fgColor-disabled, var(--color-primer-fg-disabled, #88929d))"
        },
        "canvas": {
          "backdrop": "var(--overlay-backdrop-bgColor, var(--color-primer-fg-canvas-backdrop, rgba(1,4,9,0.5)))",
          "sticky": "var(--color-primer-canvas-sticky, rgba(255,255,255,0.95))"
        },
        "border": {
          "active": "var(--underlineNav-borderColor-active, var(--color-primer-border-active, #ef5b48))",
          "contrast": "var(--borderColor-muted, var(--color-primer-border-contrast, rgba(1,4,9,0.1)))"
        }
      }
    },
    "shadows": {
      "mktg": {
        "btn": {
          "shadow": {
            "outline": "var(--color-mktg-btn-shadow-outline, rgb(0 0 0 / 15%) 0 0 0 1px inset))",
            "focus": "var(--color-mktg-btn-shadow-focus, rgb(0 0 0 / 15%) 0 0 0 4px))",
            "hover": "var(--color-mktg-btn-shadow-hover, 0 3px 2px rgba(0, 0, 0, 0.07), 0 7px 5px rgba(0, 0, 0, 0.04), 0 12px 10px rgba(0, 0, 0, 0.03), 0 22px 18px rgba(0, 0, 0, 0.03), 0 42px 33px rgba(0, 0, 0, 0.02), 0 100px 80px rgba(0, 0, 0, 0.02)))",
            "hoverMuted": "var(--color-mktg-btn-shadow-hover-muted, rgb(0 0 0 / 70%) 0 0 0 2px inset))"
          }
        }
      },
      "avatar": {
        "childShadow": "var(--avatar-shadow, var(--color-avatar-child-shadow, 0 0 0 2px rgba(255,255,255,0.8)))"
      },
      "overlay": {
        "shadow": "var(--shadow-floating-small, var(--color-overlay-shadow, 0 1px 3px rgba(1,4,9,0.12), 0 8px 24px rgba(52,59,67,0.12)))"
      },
      "btn": {
        "shadow": "var(--button-default-shadow-resting, var(--color-btn-shadow, 0 1px 0 rgba(1,4,9,0.04)))",
        "insetShadow": "var(--button-default-shadow-inset, var(--color-btn-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.25)))",
        "primary": {
          "shadow": "var(--shadow-resting-small, var(--color-btn-primary-shadow, 0 1px 0 rgba(1,4,9,0.1)))",
          "insetShadow": "var(--shadow-highlight, var(--color-btn-primary-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.03)))",
          "selectedShadow": "var(--button-primary-shadow-selected, var(--color-btn-primary-selected-shadow, inset 0 1px 0 rgba(0,35,11,0.2)))"
        },
        "outline": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-outline-hover-shadow, 0 1px 0 rgba(1,4,9,0.1)))",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-outline-hover-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.03)))",
          "selectedShadow": "var(--button-outline-shadow-selected, var(--color-btn-outline-selected-shadow, inset 0 1px 0 rgba(2,26,74,0.2)))"
        },
        "danger": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-danger-hover-shadow, 0 1px 0 rgba(1,4,9,0.1)))",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-danger-hover-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.03)))",
          "selectedShadow": "var(--button-danger-shadow-selected, var(--color-btn-danger-selected-shadow, inset 0 1px 0 rgba(67,0,17,0.2)))"
        }
      },
      "shadow": {
        "small": "var(--shadow-resting-small, var(--color-shadow-small, 0 1px 0 rgba(1,4,9,0.04)))",
        "medium": "var(--shadow-resting-medium, var(--color-shadow-medium, 0 3px 6px rgba(136,146,157,0.15)))",
        "large": "var(--shadow-floating-large, var(--color-shadow-large, 0 8px 24px rgba(136,146,157,0.2)))",
        "extraLarge": "var(--shadow-floating-xlarge, var(--color-shadow-extra-large, 0 12px 28px rgba(136,146,157,0.3)))"
      },
      "primer": {
        "shadow": {
          "highlight": "var(--shadow-highlight, var(--color-primer-shadow-highlight, inset 0 1px 0 rgba(255,255,255,0.25)))",
          "inset": "var(--shadow-inset, var(--color-primer-shadow-inset, inset 0 1px 0 rgba(206,213,220,0.2)))"
        }
      }
    }
  },
  "light_colorblind": {
    "colors": {
      "canvasDefaultTransparent": "var(--bgColor-transparent, var(--color-canvas-default-transparent, rgba(255,255,255,0)))",
      "pageHeaderBg": "var(--page-header-bgColor, var(--color-page-header-bg, #f6f8fa))",
      "marketingIcon": {
        "primary": "var(--color-marketing-icon-primary, #218bff)",
        "secondary": "var(--color-marketing-icon-secondary, #54aeff)"
      },
      "diffBlob": {
        "addition": {
          "numText": "var(--diffBlob-addition-fgColor-num, var(--color-diff-blob-addition-num-text, #24292f))",
          "fg": "var(--diffBlob-addition-fgColor-text, var(--color-diff-blob-addition-fg, #24292f))",
          "numBg": "var(--diffBlob-addition-bgColor-num, var(--color-diff-blob-addition-num-bg, rgba(84,174,255,0.4)))",
          "lineBg": "var(--diffBlob-addition-bgColor-line, var(--color-diff-blob-addition-line-bg, rgba(221,244,255,0.5)))",
          "wordBg": "var(--diffBlob-addition-bgColor-word, var(--color-diff-blob-addition-word-bg, rgba(84,174,255,0.4)))"
        },
        "deletion": {
          "numText": "var(--diffBlob-deletion-fgColor-num, var(--color-diff-blob-deletion-num-text, #24292f))",
          "fg": "var(--diffBlob-deletion-fgColor-text, var(--color-diff-blob-deletion-fg, #24292f))",
          "numBg": "var(--diffBlob-deletion-bgColor-num, var(--color-diff-blob-deletion-num-bg, rgba(247,153,57,0.4)))",
          "lineBg": "var(--diffBlob-deletion-bgColor-line, var(--color-diff-blob-deletion-line-bg, rgba(255,245,232,0.5)))",
          "wordBg": "var(--diffBlob-deletion-bgColor-word, var(--color-diff-blob-deletion-word-bg, rgba(255,188,109,0.5)))"
        },
        "hunk": {
          "numBg": "var(--diffBlob-hunk-bgColor-num, var(--color-diff-blob-hunk-num-bg, rgba(84,174,255,0.4)))"
        },
        "expander": {
          "icon": "var(--diffBlob-expander-iconColor, var(--color-diff-blob-expander-icon, #57606a))"
        },
        "selectedLineHighlightMixBlendMode": "var(--color-diff-blob-selected-line-highlight-mix-blend-mode, multiply)"
      },
      "diffstat": {
        "deletionBorder": "var(--color-diffstat-deletion-border, rgba(27,31,36,0.15))",
        "additionBorder": "var(--color-diffstat-addition-border, rgba(27,31,36,0.15))",
        "additionBg": "var(undefined, var(--color-diffstat-addition-bg, #0969da))"
      },
      "searchKeyword": {
        "hl": "var(--highlight-neutral-bgColor, var(--color-search-keyword-hl, #fff8c5))"
      },
      "prettylights": {
        "syntax": {
          "comment": "var(--color-prettylights-syntax-comment, #57606a)",
          "constant": "var(--color-prettylights-syntax-constant, #0550ae)",
          "entity": "var(--color-prettylights-syntax-entity, #6639ba)",
          "storageModifierImport": "var(--color-prettylights-syntax-storage-modifier-import, #24292f)",
          "entityTag": "var(--color-prettylights-syntax-entity-tag, #0550ae)",
          "keyword": "var(--color-prettylights-syntax-keyword, #b35900)",
          "string": "var(--color-prettylights-syntax-string, #0a3069)",
          "variable": "var(--color-prettylights-syntax-variable, #8a4600)",
          "brackethighlighterUnmatched": "var(--color-prettylights-syntax-brackethighlighter-unmatched, #6f3800)",
          "invalidIllegalText": "var(--color-prettylights-syntax-invalid-illegal-text, #f6f8fa)",
          "invalidIllegalBg": "var(--color-prettylights-syntax-invalid-illegal-bg, #6f3800)",
          "carriageReturnText": "var(--color-prettylights-syntax-carriage-return-text, #f6f8fa)",
          "carriageReturnBg": "var(--color-prettylights-syntax-carriage-return-bg, #b35900)",
          "stringRegexp": "var(--color-prettylights-syntax-string-regexp, #0550ae)",
          "markupList": "var(--color-prettylights-syntax-markup-list, #3b2300)",
          "markupHeading": "var(--color-prettylights-syntax-markup-heading, #0550ae)",
          "markupItalic": "var(--color-prettylights-syntax-markup-italic, #24292f)",
          "markupBold": "var(--color-prettylights-syntax-markup-bold, #24292f)",
          "markupDeletedText": "var(--color-prettylights-syntax-markup-deleted-text, #6f3800)",
          "markupDeletedBg": "var(--color-prettylights-syntax-markup-deleted-bg, #fff5e8)",
          "markupInsertedText": "var(--color-prettylights-syntax-markup-inserted-text, #0550ae)",
          "markupInsertedBg": "var(--color-prettylights-syntax-markup-inserted-bg, #ddf4ff)",
          "markupChangedText": "var(--color-prettylights-syntax-markup-changed-text, #8a4600)",
          "markupChangedBg": "var(--color-prettylights-syntax-markup-changed-bg, #ffddb0)",
          "markupIgnoredText": "var(--color-prettylights-syntax-markup-ignored-text, #eaeef2)",
          "markupIgnoredBg": "var(--color-prettylights-syntax-markup-ignored-bg, #0550ae)",
          "metaDiffRange": "var(--color-prettylights-syntax-meta-diff-range, #8250df)",
          "brackethighlighterAngle": "var(--color-prettylights-syntax-brackethighlighter-angle, #57606a)",
          "sublimelinterGutterMark": "var(--color-prettylights-syntax-sublimelinter-gutter-mark, #8c959f)",
          "constantOtherReferenceLink": "var(--color-prettylights-syntax-constant-other-reference-link, #0a3069)"
        }
      },
      "codemirror": {
        "text": "var(--codeMirror-fgColor, var(--color-codemirror-text, #24292f))",
        "bg": "var(--codeMirror-bgColor, var(--color-codemirror-bg, #ffffff))",
        "guttersBg": "var(--codeMirror-gutters-bgColor, var(--color-codemirror-gutters-bg, #ffffff))",
        "guttermarkerText": "var(--codeMirror-gutterMarker-fgColor-default, var(--color-codemirror-guttermarker-text, #ffffff))",
        "guttermarkerSubtleText": "var(--codeMirror-gutterMarker-fgColor-muted, var(--color-codemirror-guttermarker-subtle-text, #6e7781))",
        "linenumberText": "var(--codeMirror-lineNumber-fgColor, var(--color-codemirror-linenumber-text, #57606a))",
        "cursor": "var(--codeMirror-cursor-fgColor, var(--color-codemirror-cursor, #24292f))",
        "selectionBg": "var(--codeMirror-selection-bgColor, var(--color-codemirror-selection-bg, rgba(84,174,255,0.4)))",
        "activelineBg": "var(--codeMirror-activeline-bgColor, var(--color-codemirror-activeline-bg, rgba(234,238,242,0.5)))",
        "matchingbracketText": "var(--codeMirror-matchingBracket-fgColor, var(--color-codemirror-matchingbracket-text, #24292f))",
        "linesBg": "var(--codeMirror-lines-bgColor, var(--color-codemirror-lines-bg, #ffffff))",
        "syntax": {
          "comment": "var(--codeMirror-syntax-fgColor-comment, var(--color-codemirror-syntax-comment, #24292f))",
          "constant": "var(--codeMirror-syntax-fgColor-constant, var(--color-codemirror-syntax-constant, #0550ae))",
          "entity": "var(--codeMirror-syntax-fgColor-entity, var(--color-codemirror-syntax-entity, #8250df))",
          "keyword": "var(--codeMirror-syntax-fgColor-keyword, var(--color-codemirror-syntax-keyword, #b35900))",
          "storage": "var(--codeMirror-syntax-fgColor-storage, var(--color-codemirror-syntax-storage, #b35900))",
          "string": "var(--codeMirror-syntax-fgColor-string, var(--color-codemirror-syntax-string, #0a3069))",
          "support": "var(--codeMirror-syntax-fgColor-support, var(--color-codemirror-syntax-support, #0550ae))",
          "variable": "var(--codeMirror-syntax-fgColor-variable, var(--color-codemirror-syntax-variable, #8a4600))"
        }
      },
      "checks": {
        "bg": "var(--color-checks-bg, #24292f)",
        "runBorderWidth": "var(--color-checks-run-border-width, 0px)",
        "containerBorderWidth": "var(--color-checks-container-border-width, 0px)",
        "textPrimary": "var(--color-checks-text-primary, #f6f8fa)",
        "textSecondary": "var(--color-checks-text-secondary, #8c959f)",
        "textLink": "var(--color-checks-text-link, #54aeff)",
        "btnIcon": "var(--color-checks-btn-icon, #afb8c1)",
        "btnHoverIcon": "var(--color-checks-btn-hover-icon, #f6f8fa)",
        "btnHoverBg": "var(--color-checks-btn-hover-bg, rgba(255,255,255,0.125))",
        "inputText": "var(--color-checks-input-text, #eaeef2)",
        "inputPlaceholderText": "var(--color-checks-input-placeholder-text, #8c959f)",
        "inputFocusText": "var(--color-checks-input-focus-text, #8c959f)",
        "inputBg": "var(--color-checks-input-bg, #32383f)",
        "inputShadow": "var(--color-checks-input-shadow, none)",
        "donutError": "var(--color-checks-donut-error, #dd7815)",
        "donutPending": "var(--color-checks-donut-pending, #bf8700)",
        "donutSuccess": "var(--color-checks-donut-success, #0969da)",
        "donutNeutral": "var(--color-checks-donut-neutral, #afb8c1)",
        "dropdownText": "var(--color-checks-dropdown-text, #afb8c1)",
        "dropdownBg": "var(--color-checks-dropdown-bg, #32383f)",
        "dropdownBorder": "var(--color-checks-dropdown-border, #424a53)",
        "dropdownShadow": "var(--color-checks-dropdown-shadow, rgba(27,31,36,0.3))",
        "dropdownHoverText": "var(--color-checks-dropdown-hover-text, #f6f8fa)",
        "dropdownHoverBg": "var(--color-checks-dropdown-hover-bg, #424a53)",
        "dropdownBtnHoverText": "var(--color-checks-dropdown-btn-hover-text, #f6f8fa)",
        "dropdownBtnHoverBg": "var(--color-checks-dropdown-btn-hover-bg, #32383f)",
        "scrollbarThumbBg": "var(--color-checks-scrollbar-thumb-bg, #57606a)",
        "headerLabelText": "var(--color-checks-header-label-text, #d0d7de)",
        "headerLabelOpenText": "var(--color-checks-header-label-open-text, #f6f8fa)",
        "headerBorder": "var(--color-checks-header-border, #32383f)",
        "headerIcon": "var(--color-checks-header-icon, #8c959f)",
        "lineText": "var(--color-checks-line-text, #d0d7de)",
        "lineNumText": "var(--color-checks-line-num-text, rgba(140,149,159,0.75))",
        "lineTimestampText": "var(--color-checks-line-timestamp-text, #8c959f)",
        "lineHoverBg": "var(--color-checks-line-hover-bg, #32383f)",
        "lineSelectedBg": "var(--color-checks-line-selected-bg, rgba(33,139,255,0.15))",
        "lineSelectedNumText": "var(--color-checks-line-selected-num-text, #54aeff)",
        "lineDtFmText": "var(--color-checks-line-dt-fm-text, #24292f)",
        "lineDtFmBg": "var(--color-checks-line-dt-fm-bg, #9a6700)",
        "gateBg": "var(--color-checks-gate-bg, rgba(125,78,0,0.15))",
        "gateText": "var(--color-checks-gate-text, #d0d7de)",
        "gateWaitingText": "var(--color-checks-gate-waiting-text, #d4a72c)",
        "stepHeaderOpenBg": "var(--color-checks-step-header-open-bg, #32383f)",
        "stepErrorText": "var(--color-checks-step-error-text, #f79939)",
        "stepWarningText": "var(--color-checks-step-warning-text, #d4a72c)",
        "loglineText": "var(--color-checks-logline-text, #8c959f)",
        "loglineNumText": "var(--color-checks-logline-num-text, rgba(140,149,159,0.75))",
        "loglineDebugText": "var(--color-checks-logline-debug-text, #c297ff)",
        "loglineErrorText": "var(--color-checks-logline-error-text, #d0d7de)",
        "loglineErrorNumText": "var(--color-checks-logline-error-num-text, #f79939)",
        "loglineErrorBg": "var(--color-checks-logline-error-bg, rgba(138,70,0,0.15))",
        "loglineWarningText": "var(--color-checks-logline-warning-text, #d0d7de)",
        "loglineWarningNumText": "var(--color-checks-logline-warning-num-text, #d4a72c)",
        "loglineWarningBg": "var(--color-checks-logline-warning-bg, rgba(125,78,0,0.15))",
        "loglineCommandText": "var(--color-checks-logline-command-text, #54aeff)",
        "loglineSectionText": "var(--color-checks-logline-section-text, #54aeff)",
        "ansi": {
          "black": "var(--color-checks-ansi-black, #24292f)",
          "blackBright": "var(--color-checks-ansi-black-bright, #32383f)",
          "white": "var(--color-checks-ansi-white, #d0d7de)",
          "whiteBright": "var(--color-checks-ansi-white-bright, #d0d7de)",
          "gray": "var(--color-checks-ansi-gray, #8c959f)",
          "red": "var(--color-checks-ansi-red, #f79939)",
          "redBright": "var(--color-checks-ansi-red-bright, #ffbc6d)",
          "green": "var(--color-checks-ansi-green, #54aeff)",
          "greenBright": "var(--color-checks-ansi-green-bright, #80ccff)",
          "yellow": "var(--color-checks-ansi-yellow, #d4a72c)",
          "yellowBright": "var(--color-checks-ansi-yellow-bright, #eac54f)",
          "blue": "var(--color-checks-ansi-blue, #54aeff)",
          "blueBright": "var(--color-checks-ansi-blue-bright, #80ccff)",
          "magenta": "var(--color-checks-ansi-magenta, #c297ff)",
          "magentaBright": "var(--color-checks-ansi-magenta-bright, #d8b9ff)",
          "cyan": "var(--color-checks-ansi-cyan, #76e3ea)",
          "cyanBright": "var(--color-checks-ansi-cyan-bright, #b3f0ff)"
        }
      },
      "project": {
        "headerBg": "var(--color-project-header-bg, #24292f)",
        "sidebarBg": "var(--color-project-sidebar-bg, #ffffff)",
        "gradientIn": "var(--color-project-gradient-in, #ffffff)",
        "gradientOut": "var(--color-project-gradient-out, rgba(255,255,255,0))"
      },
      "mktg": {
        "btn": {
          "bg": "var(--color-mktg-btn-bg, #1b1f23))"
        }
      },
      "control": {
        "borderColor": {
          "emphasis": "var(--control-borderColor-emphasis, var(--color-control-border-color-emphasis, #858F99))"
        }
      },
      "avatar": {
        "bg": "var(--avatar-bgColor, var(--color-avatar-bg, #ffffff))",
        "border": "var(--avatar-borderColor, var(--color-avatar-border, rgba(27,31,36,0.15)))",
        "stackFade": "var(--avatarStack-fade-bgColor-default, var(--color-avatar-stack-fade, #afb8c1))",
        "stackFadeMore": "var(--avatarStack-fade-bgColor-muted, var(--color-avatar-stack-fade-more, #d0d7de))"
      },
      "topicTag": {
        "border": "var(--topicTag-borderColor, var(--color-topic-tag-border, transparent))"
      },
      "counter": {
        "border": "var(--counter-borderColor, var(--color-counter-border, transparent))"
      },
      "selectMenu": {
        "backdropBorder": "var(--selectMenu-borderColor, var(--color-select-menu-backdrop-border, transparent))",
        "tapHighlight": "var(--control-bgColor-active, var(--color-select-menu-tap-highlight, rgba(175,184,193,0.5)))",
        "tapFocusBg": "var(--selectMenu-bgColor-active, var(--color-select-menu-tap-focus-bg, #b6e3ff))"
      },
      "overlay": {
        "backdrop": "var(--overlay-backdrop-bgColor, var(--color-overlay-backdrop, rgba(140,149,159,0.2)))"
      },
      "header": {
        "text": "var(--header-fgColor-default, var(--color-header-text, rgba(255,255,255,0.7)))",
        "bg": "var(--header-bgColor, var(--color-header-bg, #24292f))",
        "divider": "var(--header-borderColor-divider, var(--color-header-divider, #57606a))",
        "logo": "var(--header-fgColor-logo, var(--color-header-logo, #ffffff))"
      },
      "headerSearch": {
        "bg": "var(--headerSearch-bgColor, var(--color-header-search-bg, #24292f))",
        "border": "var(--headerSearch-borderColor, var(--color-header-search-border, #57606a))"
      },
      "sidenav": {
        "selectedBg": "var(--sideNav-bgColor-selected, var(--color-sidenav-selected-bg, #ffffff))"
      },
      "menu": {
        "bgActive": "var(--menu-bgColor-active, var(--color-menu-bg-active, transparent))"
      },
      "input": {
        "disabledBg": "var(--control-bgColor-disabled, var(--color-input-disabled-bg, rgba(175,184,193,0.2)))"
      },
      "timeline": {
        "badgeBg": "var(--timelineBadge-bgColor, var(--color-timeline-badge-bg, #eaeef2))"
      },
      "ansi": {
        "black": "var(--color-ansi-black, #24292f)",
        "blackBright": "var(--color-ansi-black-bright, #57606a)",
        "white": "var(--color-ansi-white, #6e7781)",
        "whiteBright": "var(--color-ansi-white-bright, #8c959f)",
        "gray": "var(--color-ansi-gray, #6e7781)",
        "red": "var(--color-ansi-red, #b35900)",
        "redBright": "var(--color-ansi-red-bright, #8a4600)",
        "green": "var(--color-ansi-green, #0550ae)",
        "greenBright": "var(--color-ansi-green-bright, #0969da)",
        "yellow": "var(--color-ansi-yellow, #4d2d00)",
        "yellowBright": "var(--color-ansi-yellow-bright, #633c01)",
        "blue": "var(--color-ansi-blue, #0969da)",
        "blueBright": "var(--color-ansi-blue-bright, #218bff)",
        "magenta": "var(--color-ansi-magenta, #8250df)",
        "magentaBright": "var(--color-ansi-magenta-bright, #a475f9)",
        "cyan": "var(--color-ansi-cyan, #1b7c83)",
        "cyanBright": "var(--color-ansi-cyan-bright, #3192aa)"
      },
      "btn": {
        "text": "var(--button-default-fgColor-rest, var(--color-btn-text, #24292f))",
        "bg": "var(--button-default-bgColor-rest, var(--color-btn-bg, #f6f8fa))",
        "border": "var(--button-default-borderColor-rest, var(--color-btn-border, rgba(27,31,36,0.15)))",
        "hoverBg": "var(--button-default-bgColor-hover, var(--color-btn-hover-bg, #f3f4f6))",
        "hoverBorder": "var(--button-default-borderColor-hover, var(--color-btn-hover-border, rgba(27,31,36,0.15)))",
        "activeBg": "var(--button-default-bgColor-active, var(--color-btn-active-bg, hsla(220,14%,93%,1)))",
        "activeBorder": "var(--button-default-borderColor-active, var(--color-btn-active-border, rgba(27,31,36,0.15)))",
        "selectedBg": "var(--button-default-bgColor-selected, var(--color-btn-selected-bg, hsla(220,14%,94%,1)))",
        "counterBg": "var(--buttonCounter-default-bgColor-rest, var(--color-btn-counter-bg, rgba(27,31,36,0.08)))",
        "primary": {
          "text": "var(--button-primary-fgColor-rest, var(--color-btn-primary-text, #ffffff))",
          "bg": "var(--button-primary-bgColor-rest, var(--color-btn-primary-bg, #0969da))",
          "border": "var(--button-primary-borderColor-rest, var(--color-btn-primary-border, rgba(27,31,36,0.15)))",
          "hoverBg": "var(--button-primary-bgColor-hover, var(--color-btn-primary-hover-bg, #0969da))",
          "hoverBorder": "var(--button-primary-borderColor-hover, var(--color-btn-primary-hover-border, rgba(27,31,36,0.15)))",
          "selectedBg": "var(--button-primary-bgColor-active, var(--color-btn-primary-selected-bg, hsla(212,92%,43%,1)))",
          "disabledText": "var(--button-primary-fgColor-disabled, var(--color-btn-primary-disabled-text, rgba(255,255,255,0.8)))",
          "disabledBg": "var(--button-primary-bgColor-disabled, var(--color-btn-primary-disabled-bg, #80ccff))",
          "disabledBorder": "var(--button-primary-borderColor-disabled, var(--color-btn-primary-disabled-border, rgba(27,31,36,0.15)))",
          "icon": "var(--button-primary-iconColor-rest, var(--color-btn-primary-icon, rgba(255,255,255,0.8)))",
          "counterBg": "var(--buttonCounter-primary-bgColor-rest, var(--color-btn-primary-counter-bg, rgba(0,33,85,0.2)))"
        },
        "outline": {
          "text": "var(--button-outline-fgColor-rest, var(--color-btn-outline-text, #0969da))",
          "hoverText": "var(--button-outline-fgColor-hover, var(--color-btn-outline-hover-text, #ffffff))",
          "hoverBg": "var(--button-outline-bgColor-hover, var(--color-btn-outline-hover-bg, #0969da))",
          "hoverBorder": "var(--button-outline-borderColor-hover, var(--color-btn-outline-hover-border, rgba(27,31,36,0.15)))",
          "hoverCounterBg": "var(--buttonCounter-outline-bgColor-hover, var(--color-btn-outline-hover-counter-bg, rgba(255,255,255,0.2)))",
          "selectedText": "var(--button-outline-fgColor-active, var(--color-btn-outline-selected-text, #ffffff))",
          "selectedBg": "var(--button-outline-bgColor-active, var(--color-btn-outline-selected-bg, hsla(212,92%,42%,1)))",
          "selectedBorder": "var(--button-outline-borderColor-active, var(--color-btn-outline-selected-border, rgba(27,31,36,0.15)))",
          "disabledText": "var(--button-outline-fgColor-disabled, var(--color-btn-outline-disabled-text, rgba(9,105,218,0.5)))",
          "disabledBg": "var(--button-outline-bgColor-disabled, var(--color-btn-outline-disabled-bg, #f6f8fa))",
          "disabledCounterBg": "var(--buttonCounter-outline-bgColor-disabled, var(--color-btn-outline-disabled-counter-bg, rgba(9,105,218,0.05)))",
          "counterBg": "var(--buttonCounter-outline-bgColor-rest, var(--color-btn-outline-counter-bg, #0969da1a))",
          "counterFg": "var(--buttonCounter-outline-fgColor-rest, var(--color-btn-outline-counter-fg, #0550ae))",
          "hoverCounterFg": "var(--buttonCounter-outline-fgColor-hover, var(--color-btn-outline-hover-counter-fg, #ffffff))",
          "disabledCounterFg": "var(--buttonCounter-outline-fgColor-disabled, var(--color-btn-outline-disabled-counter-fg, rgba(9,105,218,0.5)))"
        },
        "danger": {
          "text": "var(--button-danger-fgColor-rest, var(--color-btn-danger-text, #b35900))",
          "hoverText": "var(--button-danger-fgColor-hover, var(--color-btn-danger-hover-text, #ffffff))",
          "hoverBg": "var(--button-danger-bgColor-hover, var(--color-btn-danger-hover-bg, #8a4600))",
          "hoverBorder": "var(--button-danger-borderColor-hover, var(--color-btn-danger-hover-border, rgba(27,31,36,0.15)))",
          "hoverCounterBg": "var(--buttonCounter-danger-bgColor-hover, var(--color-btn-danger-hover-counter-bg, rgba(255,255,255,0.2)))",
          "selectedText": "var(--button-danger-fgColor-active, var(--color-btn-danger-selected-text, #ffffff))",
          "selectedBg": "var(--button-danger-bgColor-active, var(--color-btn-danger-selected-bg, hsla(30,100%,32%,1)))",
          "selectedBorder": "var(--button-danger-borderColor-active, var(--color-btn-danger-selected-border, rgba(27,31,36,0.15)))",
          "disabledText": "var(--button-danger-fgColor-disabled, var(--color-btn-danger-disabled-text, rgba(179,89,0,0.5)))",
          "disabledBg": "var(--button-danger-bgColor-disabled, var(--color-btn-danger-disabled-bg, #f6f8fa))",
          "disabledCounterBg": "var(--buttonCounter-danger-bgColor-disabled, var(--color-btn-danger-disabled-counter-bg, rgba(179,89,0,0.05)))",
          "counterBg": "var(--buttonCounter-danger-bgColor-rest, var(--color-btn-danger-counter-bg, rgba(179,89,0,0.1)))",
          "icon": "var(--button-danger-iconColor-rest, var(--color-btn-danger-icon, #b35900))",
          "hoverIcon": "var(--button-danger-iconColor-hover, var(--color-btn-danger-hover-icon, #ffffff))",
          "counterFg": "var(--buttonCounter-danger-fgColor-rest, var(--color-btn-danger-counter-fg, #8a4600))",
          "hoverCounterFg": "var(--buttonCounter-danger-fgColor-hover, var(--color-btn-danger-hover-counter-fg, #ffffff))",
          "disabledCounterFg": "var(--buttonCounter-danger-fgColor-disabled, var(--color-btn-danger-disabled-counter-fg, rgba(179,89,0,0.5)))"
        },
        "inactive": {
          "bg": "var(--button-inactive-bgColor-rest, var(--color-btn-inactive-bg, #eaeef2))",
          "text": "var(--button-inactive-fgColor-rest, var(--color-btn-inactive-text, #57606a))"
        }
      },
      "underlinenav": {
        "icon": "var(--underlineNav-iconColor-rest, var(--color-underlinenav-icon, #6e7781))",
        "borderHover": "var(--underlineNav-borderColor-hover, var(--color-underlinenav-border-hover, rgba(175,184,193,0.2)))"
      },
      "actionListItem": {
        "inlineDivider": "var(--borderColor-muted, var(--color-action-list-item-inline-divider, rgba(208,215,222,0.48)))",
        "default": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-action-list-item-default-hover-bg, rgba(208,215,222,0.32)))",
          "hoverBorder": "var(--control-transparent-borderColor-hover, var(--color-action-list-item-default-hover-border, transparent))",
          "activeBg": "var(--control-transparent-bgColor-active, var(--color-action-list-item-default-active-bg, rgba(208,215,222,0.48)))",
          "activeBorder": "var(--control-transparent-borderColor-active, var(--color-action-list-item-default-active-border, transparent))",
          "selectedBg": "var(--control-transparent-bgColor-selected, var(--color-action-list-item-default-selected-bg, rgba(208,215,222,0.24)))"
        },
        "danger": {
          "hoverBg": "var(--control-danger-bgColor-hover, var(--color-action-list-item-default-danger-hover-bg, rgba(255,245,232,0.64)))",
          "activeBg": "var(--control-danger-bgColor-active, var(--color-action-list-item-default-danger-active-bg, #fff5e8))",
          "hoverText": "var(--control-danger-fgColor-hover, var(--color-action-list-item-default-danger-hover-text, #b35900))"
        }
      },
      "switchTrack": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-switch-track-bg, #eaeef2))",
        "hoverBg": "var(--controlTrack-bgColor-hover, var(--color-switch-track-hover-bg, hsla(210,24%,90%,1)))",
        "activeBg": "var(--controlTrack-bgColor-active, var(--color-switch-track-active-bg, hsla(210,24%,88%,1)))",
        "disabledBg": "var(--controlTrack-bgColor-disabled, var(--color-switch-track-disabled-bg, #8c959f))",
        "fg": "var(--controlTrack-fgColor-rest, var(--color-switch-track-fg, #57606a))",
        "disabledFg": "var(--controlTrack-fgColor-disabled, var(--color-switch-track-disabled-fg, #ffffff))",
        "border": "var(--controlTrack-borderColor-rest, var(--color-switch-track-border, transparent))",
        "checked": {
          "bg": "var(--control-checked-bgColor-rest, var(--color-switch-track-checked-bg, #0969da))",
          "hoverBg": "var(--control-checked-bgColor-hover, var(--color-switch-track-checked-hover-bg, #0860CA))",
          "activeBg": "var(--control-checked-bgColor-active, var(--color-switch-track-checked-active-bg, #0757BA))",
          "fg": "var(--control-checked-fgColor-rest, var(--color-switch-track-checked-fg, #ffffff))",
          "disabledFg": "var(--control-checked-fgColor-disabled, var(--color-switch-track-checked-disabled-fg, #ffffff))",
          "border": "var(--borderColor-transparent, var(--color-switch-track-checked-border, transparent))"
        }
      },
      "switchKnob": {
        "bg": "var(--controlKnob-bgColor-rest, var(--color-switch-knob-bg, #ffffff))",
        "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-disabled-bg, #f6f8fa))",
        "border": "var(--controlKnob-borderColor-rest, var(--color-switch-knob-border, #858F99))",
        "checked": {
          "bg": "var(--controlKnob-bgColor-checked, var(--color-switch-knob-checked-bg, #ffffff))",
          "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-checked-disabled-bg, #f6f8fa))",
          "border": "var(--controlKnob-borderColor-checked, var(--color-switch-knob-checked-border, #0969da))"
        }
      },
      "segmentedControl": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-segmented-control-bg, #eaeef2))",
        "button": {
          "bg": "var(--controlKnob-bgColor-rest, var(--color-segmented-control-button-bg, #ffffff))",
          "hover": {
            "bg": "var(--controlTrack-bgColor-hover, var(--color-segmented-control-button-hover-bg, rgba(175,184,193,0.2)))"
          },
          "active": {
            "bg": "var(--controlTrack-bgColor-active, var(--color-segmented-control-button-hover-active-bg, rgba(175,184,193,0.4)))"
          },
          "selected": {
            "border": "var(--controlKnob-borderColor-rest, var(--color-segmented-control-button-hover-active-selected-border, #8c959f))"
          }
        }
      },
      "treeViewItem": {
        "chevron": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-tree-view-item-chevron-hover-bg, rgba(208,215,222,0.32)))"
        },
        "directory": {
          "fill": "var(--treeViewItem-leadingVisual-iconColor-rest, var(--color-tree-view-item-chevron-directory-fill, #54aeff))"
        }
      },
      "fg": {
        "default": "var(--fgColor-default, var(--color-fg-default, #24292f))",
        "muted": "var(--fgColor-muted, var(--color-fg-muted, #57606a))",
        "subtle": "var(--fgColor-muted, var(--color-fg-subtle, #6e7781))",
        "onEmphasis": "var(--fgColor-onEmphasis, var(--color-fg-on-emphasis, #ffffff))"
      },
      "canvas": {
        "default": "var(--bgColor-default, var(--color-canvas-default, #ffffff))",
        "overlay": "var(--overlay-bgColor, var(--color-canvas-overlay, #ffffff))",
        "inset": "var(--bgColor-inset, var(--color-canvas-inset, #f6f8fa))",
        "subtle": "var(--bgColor-muted, var(--color-canvas-subtle, #f6f8fa))"
      },
      "border": {
        "default": "var(--borderColor-default, var(--color-border-default, #d0d7de))",
        "muted": "var(--borderColor-muted, var(--color-border-muted, hsla(210,18%,87%,1)))",
        "subtle": "var(--borderColor-muted, var(--color-border-subtle, rgba(27,31,36,0.15)))"
      },
      "neutral": {
        "emphasisPlus": "var(--bgColor-emphasis, var(--color-neutral-emphasis-plus, #24292f))",
        "emphasis": "var(--bgColor-neutral-emphasis, var(--color-neutral-emphasis, #6e7781))",
        "muted": "var(--bgColor-neutral-muted, var(--color-neutral-muted, rgba(175,184,193,0.2)))",
        "subtle": "var(--bgColor-neutral-muted, var(--color-neutral-subtle, rgba(234,238,242,0.5)))"
      },
      "accent": {
        "fg": "var(--fgColor-accent, var(--color-accent-fg, #0969da))",
        "emphasis": "var(--bgColor-accent-emphasis, var(--color-accent-emphasis, #0969da))",
        "muted": "var(--borderColor-accent-muted, var(--color-accent-muted, rgba(84,174,255,0.4)))",
        "subtle": "var(--bgColor-accent-muted, var(--color-accent-subtle, #ddf4ff))"
      },
      "success": {
        "fg": "var(--fgColor-success, var(--color-success-fg, #0969da))",
        "emphasis": "var(--bgColor-success-emphasis, var(--color-success-emphasis, #0969da))",
        "muted": "var(--borderColor-success-muted, var(--color-success-muted, rgba(84,174,255,0.4)))",
        "subtle": "var(--bgColor-success-muted, var(--color-success-subtle, #ddf4ff))"
      },
      "attention": {
        "fg": "var(--fgColor-attention, var(--color-attention-fg, #9a6700))",
        "emphasis": "var(--bgColor-attention-emphasis, var(--color-attention-emphasis, #9a6700))",
        "muted": "var(--borderColor-attention-muted, var(--color-attention-muted, rgba(212,167,44,0.4)))",
        "subtle": "var(--bgColor-attention-muted, var(--color-attention-subtle, #fff8c5))"
      },
      "severe": {
        "fg": "var(--fgColor-severe, var(--color-severe-fg, #b35900))",
        "emphasis": "var(--bgColor-severe-emphasis, var(--color-severe-emphasis, #b35900))",
        "muted": "var(--borderColor-severe-muted, var(--color-severe-muted, rgba(247,153,57,0.4)))",
        "subtle": "var(--bgColor-severe-muted, var(--color-severe-subtle, #fff5e8))"
      },
      "danger": {
        "fg": "var(--fgColor-danger, var(--color-danger-fg, #b35900))",
        "emphasis": "var(--borderColor-danger-emphasis, var(--color-danger-emphasis, #b35900))",
        "muted": "var(--borderColor-danger-muted, var(--color-danger-muted, rgba(247,153,57,0.4)))",
        "subtle": "var(--bgColor-danger-muted, var(--color-danger-subtle, #fff5e8))"
      },
      "open": {
        "fg": "var(--fgColor-open, var(--color-open-fg, #b35900))",
        "emphasis": "var(--bgColor-open-emphasis, var(--color-open-emphasis, #dd7815))",
        "muted": "var(--borderColor-open-muted, var(--color-open-muted, rgba(247,153,57,0.4)))",
        "subtle": "var(--bgColor-open-muted, var(--color-open-subtle, #fff5e8))"
      },
      "closed": {
        "fg": "var(--fgColor-closed, var(--color-closed-fg, #6e7781))",
        "emphasis": "var(--bgColor-closed-emphasis, var(--color-closed-emphasis, #6e7781))",
        "muted": "var(--borderColor-closed-muted, var(--color-closed-muted, rgba(175,184,193,0.4)))",
        "subtle": "var(--bgColor-closed-muted, var(--color-closed-subtle, #f6f8fa))"
      },
      "done": {
        "fg": "var(--fgColor-done, var(--color-done-fg, #8250df))",
        "emphasis": "var(--bgColor-done-emphasis, var(--color-done-emphasis, #8250df))",
        "muted": "var(--borderColor-done-muted, var(--color-done-muted, rgba(194,151,255,0.4)))",
        "subtle": "var(--bgColor-done-muted, var(--color-done-subtle, #fbefff))"
      },
      "sponsors": {
        "fg": "var(--fgColor-sponsors, var(--color-sponsors-fg, #bf3989))",
        "emphasis": "var(--bgColor-sponsors-emphasis, var(--color-sponsors-emphasis, #bf3989))",
        "muted": "var(--borderColor-sponsors-muted, var(--color-sponsors-muted, rgba(255,128,200,0.4)))",
        "subtle": "var(--bgColor-sponsors-muted, var(--color-sponsors-subtle, #ffeff7))"
      },
      "primer": {
        "fg": {
          "disabled": "var(--fgColor-disabled, var(--color-primer-fg-disabled, #8c959f))"
        },
        "canvas": {
          "backdrop": "var(--overlay-backdrop-bgColor, var(--color-primer-fg-canvas-backdrop, rgba(27,31,36,0.5)))",
          "sticky": "var(--color-primer-canvas-sticky, rgba(255,255,255,0.95))"
        },
        "border": {
          "active": "var(--underlineNav-borderColor-active, var(--color-primer-border-active, #fd8c73))",
          "contrast": "var(--borderColor-muted, var(--color-primer-border-contrast, rgba(27,31,36,0.1)))"
        }
      }
    },
    "shadows": {
      "mktg": {
        "btn": {
          "shadow": {
            "outline": "var(--color-mktg-btn-shadow-outline, rgb(0 0 0 / 15%) 0 0 0 1px inset))",
            "focus": "var(--color-mktg-btn-shadow-focus, rgb(0 0 0 / 15%) 0 0 0 4px))",
            "hover": "var(--color-mktg-btn-shadow-hover, 0 3px 2px rgba(0, 0, 0, 0.07), 0 7px 5px rgba(0, 0, 0, 0.04), 0 12px 10px rgba(0, 0, 0, 0.03), 0 22px 18px rgba(0, 0, 0, 0.03), 0 42px 33px rgba(0, 0, 0, 0.02), 0 100px 80px rgba(0, 0, 0, 0.02)))",
            "hoverMuted": "var(--color-mktg-btn-shadow-hover-muted, rgb(0 0 0 / 70%) 0 0 0 2px inset))"
          }
        }
      },
      "avatar": {
        "childShadow": "var(--avatar-shadow, var(--color-avatar-child-shadow, 0 0 0 2px rgba(255,255,255,0.8)))"
      },
      "overlay": {
        "shadow": "var(--shadow-floating-small, var(--color-overlay-shadow, 0 1px 3px rgba(27,31,36,0.12), 0 8px 24px rgba(66,74,83,0.12)))"
      },
      "btn": {
        "shadow": "var(--button-default-shadow-resting, var(--color-btn-shadow, 0 1px 0 rgba(27,31,36,0.04)))",
        "insetShadow": "var(--button-default-shadow-inset, var(--color-btn-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.25)))",
        "primary": {
          "shadow": "var(--shadow-resting-small, var(--color-btn-primary-shadow, 0 1px 0 rgba(27,31,36,0.1)))",
          "insetShadow": "var(--shadow-highlight, var(--color-btn-primary-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.03)))",
          "selectedShadow": "var(--button-primary-shadow-selected, var(--color-btn-primary-selected-shadow, inset 0 1px 0 rgba(0,33,85,0.2)))"
        },
        "outline": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-outline-hover-shadow, 0 1px 0 rgba(27,31,36,0.1)))",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-outline-hover-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.03)))",
          "selectedShadow": "var(--button-outline-shadow-selected, var(--color-btn-outline-selected-shadow, inset 0 1px 0 rgba(0,33,85,0.2)))"
        },
        "danger": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-danger-hover-shadow, 0 1px 0 rgba(27,31,36,0.1)))",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-danger-hover-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.03)))",
          "selectedShadow": "var(--button-danger-shadow-selected, var(--color-btn-danger-selected-shadow, inset 0 1px 0 rgba(65,32,0,0.2)))"
        }
      },
      "shadow": {
        "small": "var(--shadow-resting-small, var(--color-shadow-small, 0 1px 0 rgba(27,31,36,0.04)))",
        "medium": "var(--shadow-resting-medium, var(--color-shadow-medium, 0 3px 6px rgba(140,149,159,0.15)))",
        "large": "var(--shadow-floating-large, var(--color-shadow-large, 0 8px 24px rgba(140,149,159,0.2)))",
        "extraLarge": "var(--shadow-floating-xlarge, var(--color-shadow-extra-large, 0 12px 28px rgba(140,149,159,0.3)))"
      },
      "primer": {
        "shadow": {
          "highlight": "var(--shadow-highlight, var(--color-primer-shadow-highlight, inset 0 1px 0 rgba(255,255,255,0.25)))",
          "inset": "var(--shadow-inset, var(--color-primer-shadow-inset, inset 0 1px 0 rgba(208,215,222,0.2)))"
        }
      }
    }
  },
  "light_tritanopia": {
    "colors": {
      "canvasDefaultTransparent": "var(--bgColor-transparent, var(--color-canvas-default-transparent, rgba(255,255,255,0)))",
      "pageHeaderBg": "var(--page-header-bgColor, var(--color-page-header-bg, #f6f8fa))",
      "marketingIcon": {
        "primary": "var(--color-marketing-icon-primary, #218bff)",
        "secondary": "var(--color-marketing-icon-secondary, #54aeff)"
      },
      "diffBlob": {
        "addition": {
          "numText": "var(--diffBlob-addition-fgColor-num, var(--color-diff-blob-addition-num-text, #24292f))",
          "fg": "var(--diffBlob-addition-fgColor-text, var(--color-diff-blob-addition-fg, #24292f))",
          "numBg": "var(--diffBlob-addition-bgColor-num, var(--color-diff-blob-addition-num-bg, rgba(84,174,255,0.4)))",
          "lineBg": "var(--diffBlob-addition-bgColor-line, var(--color-diff-blob-addition-line-bg, rgba(221,244,255,0.5)))",
          "wordBg": "var(--diffBlob-addition-bgColor-word, var(--color-diff-blob-addition-word-bg, rgba(84,174,255,0.4)))"
        },
        "deletion": {
          "numText": "var(--diffBlob-deletion-fgColor-num, var(--color-diff-blob-deletion-num-text, #24292f))",
          "fg": "var(--diffBlob-deletion-fgColor-text, var(--color-diff-blob-deletion-fg, #24292f))",
          "numBg": "var(--diffBlob-deletion-bgColor-num, var(--color-diff-blob-deletion-num-bg, rgba(255,129,130,0.4)))",
          "lineBg": "var(--diffBlob-deletion-bgColor-line, var(--color-diff-blob-deletion-line-bg, rgba(255,235,233,0.5)))",
          "wordBg": "var(--diffBlob-deletion-bgColor-word, var(--color-diff-blob-deletion-word-bg, rgba(255,171,168,0.5)))"
        },
        "hunk": {
          "numBg": "var(--diffBlob-hunk-bgColor-num, var(--color-diff-blob-hunk-num-bg, rgba(84,174,255,0.4)))"
        },
        "expander": {
          "icon": "var(--diffBlob-expander-iconColor, var(--color-diff-blob-expander-icon, #57606a))"
        },
        "selectedLineHighlightMixBlendMode": "var(--color-diff-blob-selected-line-highlight-mix-blend-mode, multiply)"
      },
      "diffstat": {
        "deletionBorder": "var(--color-diffstat-deletion-border, rgba(27,31,36,0.15))",
        "additionBorder": "var(--color-diffstat-addition-border, rgba(27,31,36,0.15))",
        "additionBg": "var(undefined, var(--color-diffstat-addition-bg, #0969da))"
      },
      "searchKeyword": {
        "hl": "var(--highlight-neutral-bgColor, var(--color-search-keyword-hl, #fff8c5))"
      },
      "prettylights": {
        "syntax": {
          "comment": "var(--color-prettylights-syntax-comment, #57606a)",
          "constant": "var(--color-prettylights-syntax-constant, #0550ae)",
          "entity": "var(--color-prettylights-syntax-entity, #6639ba)",
          "storageModifierImport": "var(--color-prettylights-syntax-storage-modifier-import, #24292f)",
          "entityTag": "var(--color-prettylights-syntax-entity-tag, #0550ae)",
          "keyword": "var(--color-prettylights-syntax-keyword, #cf222e)",
          "string": "var(--color-prettylights-syntax-string, #0a3069)",
          "variable": "var(--color-prettylights-syntax-variable, #a40e26)",
          "brackethighlighterUnmatched": "var(--color-prettylights-syntax-brackethighlighter-unmatched, #82071e)",
          "invalidIllegalText": "var(--color-prettylights-syntax-invalid-illegal-text, #f6f8fa)",
          "invalidIllegalBg": "var(--color-prettylights-syntax-invalid-illegal-bg, #82071e)",
          "carriageReturnText": "var(--color-prettylights-syntax-carriage-return-text, #f6f8fa)",
          "carriageReturnBg": "var(--color-prettylights-syntax-carriage-return-bg, #cf222e)",
          "stringRegexp": "var(--color-prettylights-syntax-string-regexp, #0550ae)",
          "markupList": "var(--color-prettylights-syntax-markup-list, #3b2300)",
          "markupHeading": "var(--color-prettylights-syntax-markup-heading, #0550ae)",
          "markupItalic": "var(--color-prettylights-syntax-markup-italic, #24292f)",
          "markupBold": "var(--color-prettylights-syntax-markup-bold, #24292f)",
          "markupDeletedText": "var(--color-prettylights-syntax-markup-deleted-text, #82071e)",
          "markupDeletedBg": "var(--color-prettylights-syntax-markup-deleted-bg, #ffebe9)",
          "markupInsertedText": "var(--color-prettylights-syntax-markup-inserted-text, #0550ae)",
          "markupInsertedBg": "var(--color-prettylights-syntax-markup-inserted-bg, #ddf4ff)",
          "markupChangedText": "var(--color-prettylights-syntax-markup-changed-text, #a40e26)",
          "markupChangedBg": "var(--color-prettylights-syntax-markup-changed-bg, #ffcecb)",
          "markupIgnoredText": "var(--color-prettylights-syntax-markup-ignored-text, #eaeef2)",
          "markupIgnoredBg": "var(--color-prettylights-syntax-markup-ignored-bg, #0550ae)",
          "metaDiffRange": "var(--color-prettylights-syntax-meta-diff-range, #8250df)",
          "brackethighlighterAngle": "var(--color-prettylights-syntax-brackethighlighter-angle, #57606a)",
          "sublimelinterGutterMark": "var(--color-prettylights-syntax-sublimelinter-gutter-mark, #8c959f)",
          "constantOtherReferenceLink": "var(--color-prettylights-syntax-constant-other-reference-link, #0a3069)"
        }
      },
      "codemirror": {
        "text": "var(--codeMirror-fgColor, var(--color-codemirror-text, #24292f))",
        "bg": "var(--codeMirror-bgColor, var(--color-codemirror-bg, #ffffff))",
        "guttersBg": "var(--codeMirror-gutters-bgColor, var(--color-codemirror-gutters-bg, #ffffff))",
        "guttermarkerText": "var(--codeMirror-gutterMarker-fgColor-default, var(--color-codemirror-guttermarker-text, #ffffff))",
        "guttermarkerSubtleText": "var(--codeMirror-gutterMarker-fgColor-muted, var(--color-codemirror-guttermarker-subtle-text, #6e7781))",
        "linenumberText": "var(--codeMirror-lineNumber-fgColor, var(--color-codemirror-linenumber-text, #57606a))",
        "cursor": "var(--codeMirror-cursor-fgColor, var(--color-codemirror-cursor, #24292f))",
        "selectionBg": "var(--codeMirror-selection-bgColor, var(--color-codemirror-selection-bg, rgba(84,174,255,0.4)))",
        "activelineBg": "var(--codeMirror-activeline-bgColor, var(--color-codemirror-activeline-bg, rgba(234,238,242,0.5)))",
        "matchingbracketText": "var(--codeMirror-matchingBracket-fgColor, var(--color-codemirror-matchingbracket-text, #24292f))",
        "linesBg": "var(--codeMirror-lines-bgColor, var(--color-codemirror-lines-bg, #ffffff))",
        "syntax": {
          "comment": "var(--codeMirror-syntax-fgColor-comment, var(--color-codemirror-syntax-comment, #24292f))",
          "constant": "var(--codeMirror-syntax-fgColor-constant, var(--color-codemirror-syntax-constant, #0550ae))",
          "entity": "var(--codeMirror-syntax-fgColor-entity, var(--color-codemirror-syntax-entity, #8250df))",
          "keyword": "var(--codeMirror-syntax-fgColor-keyword, var(--color-codemirror-syntax-keyword, #cf222e))",
          "storage": "var(--codeMirror-syntax-fgColor-storage, var(--color-codemirror-syntax-storage, #cf222e))",
          "string": "var(--codeMirror-syntax-fgColor-string, var(--color-codemirror-syntax-string, #0a3069))",
          "support": "var(--codeMirror-syntax-fgColor-support, var(--color-codemirror-syntax-support, #0550ae))",
          "variable": "var(--codeMirror-syntax-fgColor-variable, var(--color-codemirror-syntax-variable, #a40e26))"
        }
      },
      "checks": {
        "bg": "var(--color-checks-bg, #24292f)",
        "runBorderWidth": "var(--color-checks-run-border-width, 0px)",
        "containerBorderWidth": "var(--color-checks-container-border-width, 0px)",
        "textPrimary": "var(--color-checks-text-primary, #f6f8fa)",
        "textSecondary": "var(--color-checks-text-secondary, #8c959f)",
        "textLink": "var(--color-checks-text-link, #54aeff)",
        "btnIcon": "var(--color-checks-btn-icon, #afb8c1)",
        "btnHoverIcon": "var(--color-checks-btn-hover-icon, #f6f8fa)",
        "btnHoverBg": "var(--color-checks-btn-hover-bg, rgba(255,255,255,0.125))",
        "inputText": "var(--color-checks-input-text, #eaeef2)",
        "inputPlaceholderText": "var(--color-checks-input-placeholder-text, #8c959f)",
        "inputFocusText": "var(--color-checks-input-focus-text, #8c959f)",
        "inputBg": "var(--color-checks-input-bg, #32383f)",
        "inputShadow": "var(--color-checks-input-shadow, none)",
        "donutError": "var(--color-checks-donut-error, #fa4549)",
        "donutPending": "var(--color-checks-donut-pending, #bf8700)",
        "donutSuccess": "var(--color-checks-donut-success, #0969da)",
        "donutNeutral": "var(--color-checks-donut-neutral, #afb8c1)",
        "dropdownText": "var(--color-checks-dropdown-text, #afb8c1)",
        "dropdownBg": "var(--color-checks-dropdown-bg, #32383f)",
        "dropdownBorder": "var(--color-checks-dropdown-border, #424a53)",
        "dropdownShadow": "var(--color-checks-dropdown-shadow, rgba(27,31,36,0.3))",
        "dropdownHoverText": "var(--color-checks-dropdown-hover-text, #f6f8fa)",
        "dropdownHoverBg": "var(--color-checks-dropdown-hover-bg, #424a53)",
        "dropdownBtnHoverText": "var(--color-checks-dropdown-btn-hover-text, #f6f8fa)",
        "dropdownBtnHoverBg": "var(--color-checks-dropdown-btn-hover-bg, #32383f)",
        "scrollbarThumbBg": "var(--color-checks-scrollbar-thumb-bg, #57606a)",
        "headerLabelText": "var(--color-checks-header-label-text, #d0d7de)",
        "headerLabelOpenText": "var(--color-checks-header-label-open-text, #f6f8fa)",
        "headerBorder": "var(--color-checks-header-border, #32383f)",
        "headerIcon": "var(--color-checks-header-icon, #8c959f)",
        "lineText": "var(--color-checks-line-text, #d0d7de)",
        "lineNumText": "var(--color-checks-line-num-text, rgba(140,149,159,0.75))",
        "lineTimestampText": "var(--color-checks-line-timestamp-text, #8c959f)",
        "lineHoverBg": "var(--color-checks-line-hover-bg, #32383f)",
        "lineSelectedBg": "var(--color-checks-line-selected-bg, rgba(33,139,255,0.15))",
        "lineSelectedNumText": "var(--color-checks-line-selected-num-text, #54aeff)",
        "lineDtFmText": "var(--color-checks-line-dt-fm-text, #24292f)",
        "lineDtFmBg": "var(--color-checks-line-dt-fm-bg, #9a6700)",
        "gateBg": "var(--color-checks-gate-bg, rgba(125,78,0,0.15))",
        "gateText": "var(--color-checks-gate-text, #d0d7de)",
        "gateWaitingText": "var(--color-checks-gate-waiting-text, #d4a72c)",
        "stepHeaderOpenBg": "var(--color-checks-step-header-open-bg, #32383f)",
        "stepErrorText": "var(--color-checks-step-error-text, #ff8182)",
        "stepWarningText": "var(--color-checks-step-warning-text, #d4a72c)",
        "loglineText": "var(--color-checks-logline-text, #8c959f)",
        "loglineNumText": "var(--color-checks-logline-num-text, rgba(140,149,159,0.75))",
        "loglineDebugText": "var(--color-checks-logline-debug-text, #c297ff)",
        "loglineErrorText": "var(--color-checks-logline-error-text, #d0d7de)",
        "loglineErrorNumText": "var(--color-checks-logline-error-num-text, #ff8182)",
        "loglineErrorBg": "var(--color-checks-logline-error-bg, rgba(164,14,38,0.15))",
        "loglineWarningText": "var(--color-checks-logline-warning-text, #d0d7de)",
        "loglineWarningNumText": "var(--color-checks-logline-warning-num-text, #d4a72c)",
        "loglineWarningBg": "var(--color-checks-logline-warning-bg, rgba(125,78,0,0.15))",
        "loglineCommandText": "var(--color-checks-logline-command-text, #54aeff)",
        "loglineSectionText": "var(--color-checks-logline-section-text, #54aeff)",
        "ansi": {
          "black": "var(--color-checks-ansi-black, #24292f)",
          "blackBright": "var(--color-checks-ansi-black-bright, #32383f)",
          "white": "var(--color-checks-ansi-white, #d0d7de)",
          "whiteBright": "var(--color-checks-ansi-white-bright, #d0d7de)",
          "gray": "var(--color-checks-ansi-gray, #8c959f)",
          "red": "var(--color-checks-ansi-red, #ff8182)",
          "redBright": "var(--color-checks-ansi-red-bright, #ffaba8)",
          "green": "var(--color-checks-ansi-green, #54aeff)",
          "greenBright": "var(--color-checks-ansi-green-bright, #80ccff)",
          "yellow": "var(--color-checks-ansi-yellow, #d4a72c)",
          "yellowBright": "var(--color-checks-ansi-yellow-bright, #eac54f)",
          "blue": "var(--color-checks-ansi-blue, #54aeff)",
          "blueBright": "var(--color-checks-ansi-blue-bright, #80ccff)",
          "magenta": "var(--color-checks-ansi-magenta, #c297ff)",
          "magentaBright": "var(--color-checks-ansi-magenta-bright, #d8b9ff)",
          "cyan": "var(--color-checks-ansi-cyan, #76e3ea)",
          "cyanBright": "var(--color-checks-ansi-cyan-bright, #b3f0ff)"
        }
      },
      "project": {
        "headerBg": "var(--color-project-header-bg, #24292f)",
        "sidebarBg": "var(--color-project-sidebar-bg, #ffffff)",
        "gradientIn": "var(--color-project-gradient-in, #ffffff)",
        "gradientOut": "var(--color-project-gradient-out, rgba(255,255,255,0))"
      },
      "mktg": {
        "btn": {
          "bg": "var(--color-mktg-btn-bg, #1b1f23))"
        }
      },
      "control": {
        "borderColor": {
          "emphasis": "var(--control-borderColor-emphasis, var(--color-control-border-color-emphasis, #858F99))"
        }
      },
      "avatar": {
        "bg": "var(--avatar-bgColor, var(--color-avatar-bg, #ffffff))",
        "border": "var(--avatar-borderColor, var(--color-avatar-border, rgba(27,31,36,0.15)))",
        "stackFade": "var(--avatarStack-fade-bgColor-default, var(--color-avatar-stack-fade, #afb8c1))",
        "stackFadeMore": "var(--avatarStack-fade-bgColor-muted, var(--color-avatar-stack-fade-more, #d0d7de))"
      },
      "topicTag": {
        "border": "var(--topicTag-borderColor, var(--color-topic-tag-border, transparent))"
      },
      "counter": {
        "border": "var(--counter-borderColor, var(--color-counter-border, transparent))"
      },
      "selectMenu": {
        "backdropBorder": "var(--selectMenu-borderColor, var(--color-select-menu-backdrop-border, transparent))",
        "tapHighlight": "var(--control-bgColor-active, var(--color-select-menu-tap-highlight, rgba(175,184,193,0.5)))",
        "tapFocusBg": "var(--selectMenu-bgColor-active, var(--color-select-menu-tap-focus-bg, #b6e3ff))"
      },
      "overlay": {
        "backdrop": "var(--overlay-backdrop-bgColor, var(--color-overlay-backdrop, rgba(140,149,159,0.2)))"
      },
      "header": {
        "text": "var(--header-fgColor-default, var(--color-header-text, rgba(255,255,255,0.7)))",
        "bg": "var(--header-bgColor, var(--color-header-bg, #24292f))",
        "divider": "var(--header-borderColor-divider, var(--color-header-divider, #57606a))",
        "logo": "var(--header-fgColor-logo, var(--color-header-logo, #ffffff))"
      },
      "headerSearch": {
        "bg": "var(--headerSearch-bgColor, var(--color-header-search-bg, #24292f))",
        "border": "var(--headerSearch-borderColor, var(--color-header-search-border, #57606a))"
      },
      "sidenav": {
        "selectedBg": "var(--sideNav-bgColor-selected, var(--color-sidenav-selected-bg, #ffffff))"
      },
      "menu": {
        "bgActive": "var(--menu-bgColor-active, var(--color-menu-bg-active, transparent))"
      },
      "input": {
        "disabledBg": "var(--control-bgColor-disabled, var(--color-input-disabled-bg, rgba(175,184,193,0.2)))"
      },
      "timeline": {
        "badgeBg": "var(--timelineBadge-bgColor, var(--color-timeline-badge-bg, #eaeef2))"
      },
      "ansi": {
        "black": "var(--color-ansi-black, #24292f)",
        "blackBright": "var(--color-ansi-black-bright, #57606a)",
        "white": "var(--color-ansi-white, #6e7781)",
        "whiteBright": "var(--color-ansi-white-bright, #8c959f)",
        "gray": "var(--color-ansi-gray, #6e7781)",
        "red": "var(--color-ansi-red, #cf222e)",
        "redBright": "var(--color-ansi-red-bright, #a40e26)",
        "green": "var(--color-ansi-green, #0550ae)",
        "greenBright": "var(--color-ansi-green-bright, #0969da)",
        "yellow": "var(--color-ansi-yellow, #4d2d00)",
        "yellowBright": "var(--color-ansi-yellow-bright, #633c01)",
        "blue": "var(--color-ansi-blue, #0969da)",
        "blueBright": "var(--color-ansi-blue-bright, #218bff)",
        "magenta": "var(--color-ansi-magenta, #8250df)",
        "magentaBright": "var(--color-ansi-magenta-bright, #a475f9)",
        "cyan": "var(--color-ansi-cyan, #1b7c83)",
        "cyanBright": "var(--color-ansi-cyan-bright, #3192aa)"
      },
      "btn": {
        "text": "var(--button-default-fgColor-rest, var(--color-btn-text, #24292f))",
        "bg": "var(--button-default-bgColor-rest, var(--color-btn-bg, #f6f8fa))",
        "border": "var(--button-default-borderColor-rest, var(--color-btn-border, rgba(27,31,36,0.15)))",
        "hoverBg": "var(--button-default-bgColor-hover, var(--color-btn-hover-bg, #f3f4f6))",
        "hoverBorder": "var(--button-default-borderColor-hover, var(--color-btn-hover-border, rgba(27,31,36,0.15)))",
        "activeBg": "var(--button-default-bgColor-active, var(--color-btn-active-bg, hsla(220,14%,93%,1)))",
        "activeBorder": "var(--button-default-borderColor-active, var(--color-btn-active-border, rgba(27,31,36,0.15)))",
        "selectedBg": "var(--button-default-bgColor-selected, var(--color-btn-selected-bg, hsla(220,14%,94%,1)))",
        "counterBg": "var(--buttonCounter-default-bgColor-rest, var(--color-btn-counter-bg, rgba(27,31,36,0.08)))",
        "primary": {
          "text": "var(--button-primary-fgColor-rest, var(--color-btn-primary-text, #ffffff))",
          "bg": "var(--button-primary-bgColor-rest, var(--color-btn-primary-bg, #0969da))",
          "border": "var(--button-primary-borderColor-rest, var(--color-btn-primary-border, rgba(27,31,36,0.15)))",
          "hoverBg": "var(--button-primary-bgColor-hover, var(--color-btn-primary-hover-bg, #0969da))",
          "hoverBorder": "var(--button-primary-borderColor-hover, var(--color-btn-primary-hover-border, rgba(27,31,36,0.15)))",
          "selectedBg": "var(--button-primary-bgColor-active, var(--color-btn-primary-selected-bg, hsla(212,92%,43%,1)))",
          "disabledText": "var(--button-primary-fgColor-disabled, var(--color-btn-primary-disabled-text, rgba(255,255,255,0.8)))",
          "disabledBg": "var(--button-primary-bgColor-disabled, var(--color-btn-primary-disabled-bg, #80ccff))",
          "disabledBorder": "var(--button-primary-borderColor-disabled, var(--color-btn-primary-disabled-border, rgba(27,31,36,0.15)))",
          "icon": "var(--button-primary-iconColor-rest, var(--color-btn-primary-icon, rgba(255,255,255,0.8)))",
          "counterBg": "var(--buttonCounter-primary-bgColor-rest, var(--color-btn-primary-counter-bg, rgba(0,33,85,0.2)))"
        },
        "outline": {
          "text": "var(--button-outline-fgColor-rest, var(--color-btn-outline-text, #0969da))",
          "hoverText": "var(--button-outline-fgColor-hover, var(--color-btn-outline-hover-text, #ffffff))",
          "hoverBg": "var(--button-outline-bgColor-hover, var(--color-btn-outline-hover-bg, #0969da))",
          "hoverBorder": "var(--button-outline-borderColor-hover, var(--color-btn-outline-hover-border, rgba(27,31,36,0.15)))",
          "hoverCounterBg": "var(--buttonCounter-outline-bgColor-hover, var(--color-btn-outline-hover-counter-bg, rgba(255,255,255,0.2)))",
          "selectedText": "var(--button-outline-fgColor-active, var(--color-btn-outline-selected-text, #ffffff))",
          "selectedBg": "var(--button-outline-bgColor-active, var(--color-btn-outline-selected-bg, hsla(212,92%,42%,1)))",
          "selectedBorder": "var(--button-outline-borderColor-active, var(--color-btn-outline-selected-border, rgba(27,31,36,0.15)))",
          "disabledText": "var(--button-outline-fgColor-disabled, var(--color-btn-outline-disabled-text, rgba(9,105,218,0.5)))",
          "disabledBg": "var(--button-outline-bgColor-disabled, var(--color-btn-outline-disabled-bg, #f6f8fa))",
          "disabledCounterBg": "var(--buttonCounter-outline-bgColor-disabled, var(--color-btn-outline-disabled-counter-bg, rgba(9,105,218,0.05)))",
          "counterBg": "var(--buttonCounter-outline-bgColor-rest, var(--color-btn-outline-counter-bg, #0969da1a))",
          "counterFg": "var(--buttonCounter-outline-fgColor-rest, var(--color-btn-outline-counter-fg, #0550ae))",
          "hoverCounterFg": "var(--buttonCounter-outline-fgColor-hover, var(--color-btn-outline-hover-counter-fg, #ffffff))",
          "disabledCounterFg": "var(--buttonCounter-outline-fgColor-disabled, var(--color-btn-outline-disabled-counter-fg, rgba(9,105,218,0.5)))"
        },
        "danger": {
          "text": "var(--button-danger-fgColor-rest, var(--color-btn-danger-text, #cf222e))",
          "hoverText": "var(--button-danger-fgColor-hover, var(--color-btn-danger-hover-text, #ffffff))",
          "hoverBg": "var(--button-danger-bgColor-hover, var(--color-btn-danger-hover-bg, #a40e26))",
          "hoverBorder": "var(--button-danger-borderColor-hover, var(--color-btn-danger-hover-border, rgba(27,31,36,0.15)))",
          "hoverCounterBg": "var(--buttonCounter-danger-bgColor-hover, var(--color-btn-danger-hover-counter-bg, rgba(255,255,255,0.2)))",
          "selectedText": "var(--button-danger-fgColor-active, var(--color-btn-danger-selected-text, #ffffff))",
          "selectedBg": "var(--button-danger-bgColor-active, var(--color-btn-danger-selected-bg, hsla(356,72%,44%,1)))",
          "selectedBorder": "var(--button-danger-borderColor-active, var(--color-btn-danger-selected-border, rgba(27,31,36,0.15)))",
          "disabledText": "var(--button-danger-fgColor-disabled, var(--color-btn-danger-disabled-text, rgba(207,34,46,0.5)))",
          "disabledBg": "var(--button-danger-bgColor-disabled, var(--color-btn-danger-disabled-bg, #f6f8fa))",
          "disabledCounterBg": "var(--buttonCounter-danger-bgColor-disabled, var(--color-btn-danger-disabled-counter-bg, rgba(207,34,46,0.05)))",
          "counterBg": "var(--buttonCounter-danger-bgColor-rest, var(--color-btn-danger-counter-bg, rgba(207,34,46,0.1)))",
          "icon": "var(--button-danger-iconColor-rest, var(--color-btn-danger-icon, #cf222e))",
          "hoverIcon": "var(--button-danger-iconColor-hover, var(--color-btn-danger-hover-icon, #ffffff))",
          "counterFg": "var(--buttonCounter-danger-fgColor-rest, var(--color-btn-danger-counter-fg, #a40e26))",
          "hoverCounterFg": "var(--buttonCounter-danger-fgColor-hover, var(--color-btn-danger-hover-counter-fg, #ffffff))",
          "disabledCounterFg": "var(--buttonCounter-danger-fgColor-disabled, var(--color-btn-danger-disabled-counter-fg, rgba(207,34,46,0.5)))"
        },
        "inactive": {
          "bg": "var(--button-inactive-bgColor-rest, var(--color-btn-inactive-bg, #eaeef2))",
          "text": "var(--button-inactive-fgColor-rest, var(--color-btn-inactive-text, #57606a))"
        }
      },
      "underlinenav": {
        "icon": "var(--underlineNav-iconColor-rest, var(--color-underlinenav-icon, #6e7781))",
        "borderHover": "var(--underlineNav-borderColor-hover, var(--color-underlinenav-border-hover, rgba(175,184,193,0.2)))"
      },
      "actionListItem": {
        "inlineDivider": "var(--borderColor-muted, var(--color-action-list-item-inline-divider, rgba(208,215,222,0.48)))",
        "default": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-action-list-item-default-hover-bg, rgba(208,215,222,0.32)))",
          "hoverBorder": "var(--control-transparent-borderColor-hover, var(--color-action-list-item-default-hover-border, transparent))",
          "activeBg": "var(--control-transparent-bgColor-active, var(--color-action-list-item-default-active-bg, rgba(208,215,222,0.48)))",
          "activeBorder": "var(--control-transparent-borderColor-active, var(--color-action-list-item-default-active-border, transparent))",
          "selectedBg": "var(--control-transparent-bgColor-selected, var(--color-action-list-item-default-selected-bg, rgba(208,215,222,0.24)))"
        },
        "danger": {
          "hoverBg": "var(--control-danger-bgColor-hover, var(--color-action-list-item-default-danger-hover-bg, rgba(255,235,233,0.64)))",
          "activeBg": "var(--control-danger-bgColor-active, var(--color-action-list-item-default-danger-active-bg, #ffebe9))",
          "hoverText": "var(--control-danger-fgColor-hover, var(--color-action-list-item-default-danger-hover-text, #cf222e))"
        }
      },
      "switchTrack": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-switch-track-bg, #eaeef2))",
        "hoverBg": "var(--controlTrack-bgColor-hover, var(--color-switch-track-hover-bg, hsla(210,24%,90%,1)))",
        "activeBg": "var(--controlTrack-bgColor-active, var(--color-switch-track-active-bg, hsla(210,24%,88%,1)))",
        "disabledBg": "var(--controlTrack-bgColor-disabled, var(--color-switch-track-disabled-bg, #8c959f))",
        "fg": "var(--controlTrack-fgColor-rest, var(--color-switch-track-fg, #57606a))",
        "disabledFg": "var(--controlTrack-fgColor-disabled, var(--color-switch-track-disabled-fg, #ffffff))",
        "border": "var(--controlTrack-borderColor-rest, var(--color-switch-track-border, transparent))",
        "checked": {
          "bg": "var(--control-checked-bgColor-rest, var(--color-switch-track-checked-bg, #0969da))",
          "hoverBg": "var(--control-checked-bgColor-hover, var(--color-switch-track-checked-hover-bg, #0860CA))",
          "activeBg": "var(--control-checked-bgColor-active, var(--color-switch-track-checked-active-bg, #0757BA))",
          "fg": "var(--control-checked-fgColor-rest, var(--color-switch-track-checked-fg, #ffffff))",
          "disabledFg": "var(--control-checked-fgColor-disabled, var(--color-switch-track-checked-disabled-fg, #ffffff))",
          "border": "var(--borderColor-transparent, var(--color-switch-track-checked-border, transparent))"
        }
      },
      "switchKnob": {
        "bg": "var(--controlKnob-bgColor-rest, var(--color-switch-knob-bg, #ffffff))",
        "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-disabled-bg, #f6f8fa))",
        "border": "var(--controlKnob-borderColor-rest, var(--color-switch-knob-border, #858F99))",
        "checked": {
          "bg": "var(--controlKnob-bgColor-checked, var(--color-switch-knob-checked-bg, #ffffff))",
          "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-checked-disabled-bg, #f6f8fa))",
          "border": "var(--controlKnob-borderColor-checked, var(--color-switch-knob-checked-border, #0969da))"
        }
      },
      "segmentedControl": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-segmented-control-bg, #eaeef2))",
        "button": {
          "bg": "var(--controlKnob-bgColor-rest, var(--color-segmented-control-button-bg, #ffffff))",
          "hover": {
            "bg": "var(--controlTrack-bgColor-hover, var(--color-segmented-control-button-hover-bg, rgba(175,184,193,0.2)))"
          },
          "active": {
            "bg": "var(--controlTrack-bgColor-active, var(--color-segmented-control-button-hover-active-bg, rgba(175,184,193,0.4)))"
          },
          "selected": {
            "border": "var(--controlKnob-borderColor-rest, var(--color-segmented-control-button-hover-active-selected-border, #8c959f))"
          }
        }
      },
      "treeViewItem": {
        "chevron": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-tree-view-item-chevron-hover-bg, rgba(208,215,222,0.32)))"
        },
        "directory": {
          "fill": "var(--treeViewItem-leadingVisual-iconColor-rest, var(--color-tree-view-item-chevron-directory-fill, #54aeff))"
        }
      },
      "fg": {
        "default": "var(--fgColor-default, var(--color-fg-default, #24292f))",
        "muted": "var(--fgColor-muted, var(--color-fg-muted, #57606a))",
        "subtle": "var(--fgColor-muted, var(--color-fg-subtle, #6e7781))",
        "onEmphasis": "var(--fgColor-onEmphasis, var(--color-fg-on-emphasis, #ffffff))"
      },
      "canvas": {
        "default": "var(--bgColor-default, var(--color-canvas-default, #ffffff))",
        "overlay": "var(--overlay-bgColor, var(--color-canvas-overlay, #ffffff))",
        "inset": "var(--bgColor-inset, var(--color-canvas-inset, #f6f8fa))",
        "subtle": "var(--bgColor-muted, var(--color-canvas-subtle, #f6f8fa))"
      },
      "border": {
        "default": "var(--borderColor-default, var(--color-border-default, #d0d7de))",
        "muted": "var(--borderColor-muted, var(--color-border-muted, hsla(210,18%,87%,1)))",
        "subtle": "var(--borderColor-muted, var(--color-border-subtle, rgba(27,31,36,0.15)))"
      },
      "neutral": {
        "emphasisPlus": "var(--bgColor-emphasis, var(--color-neutral-emphasis-plus, #24292f))",
        "emphasis": "var(--bgColor-neutral-emphasis, var(--color-neutral-emphasis, #6e7781))",
        "muted": "var(--bgColor-neutral-muted, var(--color-neutral-muted, rgba(175,184,193,0.2)))",
        "subtle": "var(--bgColor-neutral-muted, var(--color-neutral-subtle, rgba(234,238,242,0.5)))"
      },
      "accent": {
        "fg": "var(--fgColor-accent, var(--color-accent-fg, #0969da))",
        "emphasis": "var(--bgColor-accent-emphasis, var(--color-accent-emphasis, #0969da))",
        "muted": "var(--borderColor-accent-muted, var(--color-accent-muted, rgba(84,174,255,0.4)))",
        "subtle": "var(--bgColor-accent-muted, var(--color-accent-subtle, #ddf4ff))"
      },
      "success": {
        "fg": "var(--fgColor-success, var(--color-success-fg, #0969da))",
        "emphasis": "var(--bgColor-success-emphasis, var(--color-success-emphasis, #0969da))",
        "muted": "var(--borderColor-success-muted, var(--color-success-muted, rgba(84,174,255,0.4)))",
        "subtle": "var(--bgColor-success-muted, var(--color-success-subtle, #ddf4ff))"
      },
      "attention": {
        "fg": "var(--fgColor-attention, var(--color-attention-fg, #9a6700))",
        "emphasis": "var(--bgColor-attention-emphasis, var(--color-attention-emphasis, #9a6700))",
        "muted": "var(--borderColor-attention-muted, var(--color-attention-muted, rgba(212,167,44,0.4)))",
        "subtle": "var(--bgColor-attention-muted, var(--color-attention-subtle, #fff8c5))"
      },
      "severe": {
        "fg": "var(--fgColor-severe, var(--color-severe-fg, #cf222e))",
        "emphasis": "var(--bgColor-severe-emphasis, var(--color-severe-emphasis, #cf222e))",
        "muted": "var(--borderColor-severe-muted, var(--color-severe-muted, rgba(255,129,130,0.4)))",
        "subtle": "var(--bgColor-severe-muted, var(--color-severe-subtle, #ffebe9))"
      },
      "danger": {
        "fg": "var(--fgColor-danger, var(--color-danger-fg, #cf222e))",
        "emphasis": "var(--borderColor-danger-emphasis, var(--color-danger-emphasis, #cf222e))",
        "muted": "var(--borderColor-danger-muted, var(--color-danger-muted, rgba(255,129,130,0.4)))",
        "subtle": "var(--bgColor-danger-muted, var(--color-danger-subtle, #ffebe9))"
      },
      "open": {
        "fg": "var(--fgColor-open, var(--color-open-fg, #cf222e))",
        "emphasis": "var(--bgColor-open-emphasis, var(--color-open-emphasis, #fa4549))",
        "muted": "var(--borderColor-open-muted, var(--color-open-muted, rgba(255,129,130,0.4)))",
        "subtle": "var(--bgColor-open-muted, var(--color-open-subtle, #ffebe9))"
      },
      "closed": {
        "fg": "var(--fgColor-closed, var(--color-closed-fg, #6e7781))",
        "emphasis": "var(--bgColor-closed-emphasis, var(--color-closed-emphasis, #6e7781))",
        "muted": "var(--borderColor-closed-muted, var(--color-closed-muted, rgba(175,184,193,0.4)))",
        "subtle": "var(--bgColor-closed-muted, var(--color-closed-subtle, #f6f8fa))"
      },
      "done": {
        "fg": "var(--fgColor-done, var(--color-done-fg, #8250df))",
        "emphasis": "var(--bgColor-done-emphasis, var(--color-done-emphasis, #8250df))",
        "muted": "var(--borderColor-done-muted, var(--color-done-muted, rgba(194,151,255,0.4)))",
        "subtle": "var(--bgColor-done-muted, var(--color-done-subtle, #fbefff))"
      },
      "sponsors": {
        "fg": "var(--fgColor-sponsors, var(--color-sponsors-fg, #bf3989))",
        "emphasis": "var(--bgColor-sponsors-emphasis, var(--color-sponsors-emphasis, #bf3989))",
        "muted": "var(--borderColor-sponsors-muted, var(--color-sponsors-muted, rgba(255,128,200,0.4)))",
        "subtle": "var(--bgColor-sponsors-muted, var(--color-sponsors-subtle, #ffeff7))"
      },
      "primer": {
        "fg": {
          "disabled": "var(--fgColor-disabled, var(--color-primer-fg-disabled, #8c959f))"
        },
        "canvas": {
          "backdrop": "var(--overlay-backdrop-bgColor, var(--color-primer-fg-canvas-backdrop, rgba(27,31,36,0.5)))",
          "sticky": "var(--color-primer-canvas-sticky, rgba(255,255,255,0.95))"
        },
        "border": {
          "active": "var(--underlineNav-borderColor-active, var(--color-primer-border-active, #fd8c73))",
          "contrast": "var(--borderColor-muted, var(--color-primer-border-contrast, rgba(27,31,36,0.1)))"
        }
      }
    },
    "shadows": {
      "mktg": {
        "btn": {
          "shadow": {
            "outline": "var(--color-mktg-btn-shadow-outline, rgb(0 0 0 / 15%) 0 0 0 1px inset))",
            "focus": "var(--color-mktg-btn-shadow-focus, rgb(0 0 0 / 15%) 0 0 0 4px))",
            "hover": "var(--color-mktg-btn-shadow-hover, 0 3px 2px rgba(0, 0, 0, 0.07), 0 7px 5px rgba(0, 0, 0, 0.04), 0 12px 10px rgba(0, 0, 0, 0.03), 0 22px 18px rgba(0, 0, 0, 0.03), 0 42px 33px rgba(0, 0, 0, 0.02), 0 100px 80px rgba(0, 0, 0, 0.02)))",
            "hoverMuted": "var(--color-mktg-btn-shadow-hover-muted, rgb(0 0 0 / 70%) 0 0 0 2px inset))"
          }
        }
      },
      "avatar": {
        "childShadow": "var(--avatar-shadow, var(--color-avatar-child-shadow, 0 0 0 2px rgba(255,255,255,0.8)))"
      },
      "overlay": {
        "shadow": "var(--shadow-floating-small, var(--color-overlay-shadow, 0 1px 3px rgba(27,31,36,0.12), 0 8px 24px rgba(66,74,83,0.12)))"
      },
      "btn": {
        "shadow": "var(--button-default-shadow-resting, var(--color-btn-shadow, 0 1px 0 rgba(27,31,36,0.04)))",
        "insetShadow": "var(--button-default-shadow-inset, var(--color-btn-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.25)))",
        "primary": {
          "shadow": "var(--shadow-resting-small, var(--color-btn-primary-shadow, 0 1px 0 rgba(27,31,36,0.1)))",
          "insetShadow": "var(--shadow-highlight, var(--color-btn-primary-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.03)))",
          "selectedShadow": "var(--button-primary-shadow-selected, var(--color-btn-primary-selected-shadow, inset 0 1px 0 rgba(0,33,85,0.2)))"
        },
        "outline": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-outline-hover-shadow, 0 1px 0 rgba(27,31,36,0.1)))",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-outline-hover-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.03)))",
          "selectedShadow": "var(--button-outline-shadow-selected, var(--color-btn-outline-selected-shadow, inset 0 1px 0 rgba(0,33,85,0.2)))"
        },
        "danger": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-danger-hover-shadow, 0 1px 0 rgba(27,31,36,0.1)))",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-danger-hover-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.03)))",
          "selectedShadow": "var(--button-danger-shadow-selected, var(--color-btn-danger-selected-shadow, inset 0 1px 0 rgba(76,0,20,0.2)))"
        }
      },
      "shadow": {
        "small": "var(--shadow-resting-small, var(--color-shadow-small, 0 1px 0 rgba(27,31,36,0.04)))",
        "medium": "var(--shadow-resting-medium, var(--color-shadow-medium, 0 3px 6px rgba(140,149,159,0.15)))",
        "large": "var(--shadow-floating-large, var(--color-shadow-large, 0 8px 24px rgba(140,149,159,0.2)))",
        "extraLarge": "var(--shadow-floating-xlarge, var(--color-shadow-extra-large, 0 12px 28px rgba(140,149,159,0.3)))"
      },
      "primer": {
        "shadow": {
          "highlight": "var(--shadow-highlight, var(--color-primer-shadow-highlight, inset 0 1px 0 rgba(255,255,255,0.25)))",
          "inset": "var(--shadow-inset, var(--color-primer-shadow-inset, inset 0 1px 0 rgba(208,215,222,0.2)))"
        }
      }
    }
  },
  "dark": {
    "colors": {
      "canvasDefaultTransparent": "var(--bgColor-transparent, var(--color-canvas-default-transparent, rgba(13,17,23,0)))",
      "pageHeaderBg": "var(--page-header-bgColor, var(--color-page-header-bg, #0d1117))",
      "marketingIcon": {
        "primary": "var(--color-marketing-icon-primary, #79c0ff)",
        "secondary": "var(--color-marketing-icon-secondary, #1f6feb)"
      },
      "diffBlob": {
        "addition": {
          "numText": "var(--diffBlob-addition-fgColor-num, var(--color-diff-blob-addition-num-text, #e6edf3))",
          "fg": "var(--diffBlob-addition-fgColor-text, var(--color-diff-blob-addition-fg, #e6edf3))",
          "numBg": "var(--diffBlob-addition-bgColor-num, var(--color-diff-blob-addition-num-bg, rgba(63,185,80,0.3)))",
          "lineBg": "var(--diffBlob-addition-bgColor-line, var(--color-diff-blob-addition-line-bg, rgba(46,160,67,0.15)))",
          "wordBg": "var(--diffBlob-addition-bgColor-word, var(--color-diff-blob-addition-word-bg, rgba(46,160,67,0.4)))"
        },
        "deletion": {
          "numText": "var(--diffBlob-deletion-fgColor-num, var(--color-diff-blob-deletion-num-text, #e6edf3))",
          "fg": "var(--diffBlob-deletion-fgColor-text, var(--color-diff-blob-deletion-fg, #e6edf3))",
          "numBg": "var(--diffBlob-deletion-bgColor-num, var(--color-diff-blob-deletion-num-bg, rgba(248,81,73,0.3)))",
          "lineBg": "var(--diffBlob-deletion-bgColor-line, var(--color-diff-blob-deletion-line-bg, rgba(248,81,73,0.1)))",
          "wordBg": "var(--diffBlob-deletion-bgColor-word, var(--color-diff-blob-deletion-word-bg, rgba(248,81,73,0.4)))"
        },
        "hunk": {
          "numBg": "var(--diffBlob-hunk-bgColor-num, var(--color-diff-blob-hunk-num-bg, rgba(56,139,253,0.4)))"
        },
        "expander": {
          "icon": "var(--diffBlob-expander-iconColor, var(--color-diff-blob-expander-icon, #848d97))"
        },
        "selectedLineHighlightMixBlendMode": "var(--color-diff-blob-selected-line-highlight-mix-blend-mode, screen)"
      },
      "diffstat": {
        "deletionBorder": "var(--color-diffstat-deletion-border, rgba(240,246,252,0.1))",
        "additionBorder": "var(--color-diffstat-addition-border, rgba(240,246,252,0.1))",
        "additionBg": "var(--diffStat-addition-bgColor, var(--color-diffstat-addition-bg, #3fb950))"
      },
      "searchKeyword": {
        "hl": "var(--highlight-neutral-bgColor, var(--color-search-keyword-hl, rgba(210,153,34,0.4)))"
      },
      "prettylights": {
        "syntax": {
          "comment": "var(--color-prettylights-syntax-comment, #8b949e)",
          "constant": "var(--color-prettylights-syntax-constant, #79c0ff)",
          "entity": "var(--color-prettylights-syntax-entity, #d2a8ff)",
          "storageModifierImport": "var(--color-prettylights-syntax-storage-modifier-import, #c9d1d9)",
          "entityTag": "var(--color-prettylights-syntax-entity-tag, #7ee787)",
          "keyword": "var(--color-prettylights-syntax-keyword, #ff7b72)",
          "string": "var(--color-prettylights-syntax-string, #a5d6ff)",
          "variable": "var(--color-prettylights-syntax-variable, #ffa657)",
          "brackethighlighterUnmatched": "var(--color-prettylights-syntax-brackethighlighter-unmatched, #f85149)",
          "invalidIllegalText": "var(--color-prettylights-syntax-invalid-illegal-text, #f0f6fc)",
          "invalidIllegalBg": "var(--color-prettylights-syntax-invalid-illegal-bg, #8e1519)",
          "carriageReturnText": "var(--color-prettylights-syntax-carriage-return-text, #f0f6fc)",
          "carriageReturnBg": "var(--color-prettylights-syntax-carriage-return-bg, #b62324)",
          "stringRegexp": "var(--color-prettylights-syntax-string-regexp, #7ee787)",
          "markupList": "var(--color-prettylights-syntax-markup-list, #f2cc60)",
          "markupHeading": "var(--color-prettylights-syntax-markup-heading, #1f6feb)",
          "markupItalic": "var(--color-prettylights-syntax-markup-italic, #c9d1d9)",
          "markupBold": "var(--color-prettylights-syntax-markup-bold, #c9d1d9)",
          "markupDeletedText": "var(--color-prettylights-syntax-markup-deleted-text, #ffdcd7)",
          "markupDeletedBg": "var(--color-prettylights-syntax-markup-deleted-bg, #67060c)",
          "markupInsertedText": "var(--color-prettylights-syntax-markup-inserted-text, #aff5b4)",
          "markupInsertedBg": "var(--color-prettylights-syntax-markup-inserted-bg, #033a16)",
          "markupChangedText": "var(--color-prettylights-syntax-markup-changed-text, #ffdfb6)",
          "markupChangedBg": "var(--color-prettylights-syntax-markup-changed-bg, #5a1e02)",
          "markupIgnoredText": "var(--color-prettylights-syntax-markup-ignored-text, #c9d1d9)",
          "markupIgnoredBg": "var(--color-prettylights-syntax-markup-ignored-bg, #1158c7)",
          "metaDiffRange": "var(--color-prettylights-syntax-meta-diff-range, #d2a8ff)",
          "brackethighlighterAngle": "var(--color-prettylights-syntax-brackethighlighter-angle, #8b949e)",
          "sublimelinterGutterMark": "var(--color-prettylights-syntax-sublimelinter-gutter-mark, #484f58)",
          "constantOtherReferenceLink": "var(--color-prettylights-syntax-constant-other-reference-link, #a5d6ff)"
        }
      },
      "codemirror": {
        "text": "var(--codeMirror-fgColor, var(--color-codemirror-text, #e6edf3))",
        "bg": "var(--codeMirror-bgColor, var(--color-codemirror-bg, #0d1117))",
        "guttersBg": "var(--codeMirror-gutters-bgColor, var(--color-codemirror-gutters-bg, #0d1117))",
        "guttermarkerText": "var(--codeMirror-gutterMarker-fgColor-default, var(--color-codemirror-guttermarker-text, #0d1117))",
        "guttermarkerSubtleText": "var(--codeMirror-gutterMarker-fgColor-muted, var(--color-codemirror-guttermarker-subtle-text, #6e7681))",
        "linenumberText": "var(--codeMirror-lineNumber-fgColor, var(--color-codemirror-linenumber-text, #848d97))",
        "cursor": "var(--codeMirror-cursor-fgColor, var(--color-codemirror-cursor, #e6edf3))",
        "selectionBg": "var(--codeMirror-selection-bgColor, var(--color-codemirror-selection-bg, rgba(56,139,253,0.4)))",
        "activelineBg": "var(--codeMirror-activeline-bgColor, var(--color-codemirror-activeline-bg, rgba(110,118,129,0.1)))",
        "matchingbracketText": "var(--codeMirror-matchingBracket-fgColor, var(--color-codemirror-matchingbracket-text, #e6edf3))",
        "linesBg": "var(--codeMirror-lines-bgColor, var(--color-codemirror-lines-bg, #0d1117))",
        "syntax": {
          "comment": "var(--codeMirror-syntax-fgColor-comment, var(--color-codemirror-syntax-comment, #8b949e))",
          "constant": "var(--codeMirror-syntax-fgColor-constant, var(--color-codemirror-syntax-constant, #79c0ff))",
          "entity": "var(--codeMirror-syntax-fgColor-entity, var(--color-codemirror-syntax-entity, #d2a8ff))",
          "keyword": "var(--codeMirror-syntax-fgColor-keyword, var(--color-codemirror-syntax-keyword, #ff7b72))",
          "storage": "var(--codeMirror-syntax-fgColor-storage, var(--color-codemirror-syntax-storage, #ff7b72))",
          "string": "var(--codeMirror-syntax-fgColor-string, var(--color-codemirror-syntax-string, #a5d6ff))",
          "support": "var(--codeMirror-syntax-fgColor-support, var(--color-codemirror-syntax-support, #79c0ff))",
          "variable": "var(--codeMirror-syntax-fgColor-variable, var(--color-codemirror-syntax-variable, #ffa657))"
        }
      },
      "checks": {
        "bg": "var(--color-checks-bg, #010409)",
        "runBorderWidth": "var(--color-checks-run-border-width, 1px)",
        "containerBorderWidth": "var(--color-checks-container-border-width, 1px)",
        "textPrimary": "var(--color-checks-text-primary, #e6edf3)",
        "textSecondary": "var(--color-checks-text-secondary, #848d97)",
        "textLink": "var(--color-checks-text-link, #2f81f7)",
        "btnIcon": "var(--color-checks-btn-icon, #848d97)",
        "btnHoverIcon": "var(--color-checks-btn-hover-icon, #e6edf3)",
        "btnHoverBg": "var(--color-checks-btn-hover-bg, rgba(110,118,129,0.1))",
        "inputText": "var(--color-checks-input-text, #848d97)",
        "inputPlaceholderText": "var(--color-checks-input-placeholder-text, #6e7681)",
        "inputFocusText": "var(--color-checks-input-focus-text, #e6edf3)",
        "inputBg": "var(--color-checks-input-bg, #161b22)",
        "donutError": "var(--color-checks-donut-error, #f85149)",
        "donutPending": "var(--color-checks-donut-pending, #d29922)",
        "donutSuccess": "var(--color-checks-donut-success, #2ea043)",
        "donutNeutral": "var(--color-checks-donut-neutral, #8b949e)",
        "dropdownText": "var(--color-checks-dropdown-text, #e6edf3)",
        "dropdownBg": "var(--color-checks-dropdown-bg, #161b22)",
        "dropdownBorder": "var(--color-checks-dropdown-border, #30363d)",
        "dropdownShadow": "var(--color-checks-dropdown-shadow, rgba(1,4,9,0.3))",
        "dropdownHoverText": "var(--color-checks-dropdown-hover-text, #e6edf3)",
        "dropdownHoverBg": "var(--color-checks-dropdown-hover-bg, rgba(110,118,129,0.1))",
        "dropdownBtnHoverText": "var(--color-checks-dropdown-btn-hover-text, #e6edf3)",
        "dropdownBtnHoverBg": "var(--color-checks-dropdown-btn-hover-bg, rgba(110,118,129,0.1))",
        "scrollbarThumbBg": "var(--color-checks-scrollbar-thumb-bg, rgba(110,118,129,0.4))",
        "headerLabelText": "var(--color-checks-header-label-text, #848d97)",
        "headerLabelOpenText": "var(--color-checks-header-label-open-text, #e6edf3)",
        "headerBorder": "var(--color-checks-header-border, #21262d)",
        "headerIcon": "var(--color-checks-header-icon, #848d97)",
        "lineText": "var(--color-checks-line-text, #848d97)",
        "lineNumText": "var(--color-checks-line-num-text, #6e7681)",
        "lineTimestampText": "var(--color-checks-line-timestamp-text, #6e7681)",
        "lineHoverBg": "var(--color-checks-line-hover-bg, rgba(110,118,129,0.1))",
        "lineSelectedBg": "var(--color-checks-line-selected-bg, rgba(56,139,253,0.1))",
        "lineSelectedNumText": "var(--color-checks-line-selected-num-text, #2f81f7)",
        "lineDtFmText": "var(--color-checks-line-dt-fm-text, #ffffff)",
        "lineDtFmBg": "var(--color-checks-line-dt-fm-bg, #9e6a03)",
        "gateBg": "var(--color-checks-gate-bg, rgba(187,128,9,0.15))",
        "gateText": "var(--color-checks-gate-text, #848d97)",
        "gateWaitingText": "var(--color-checks-gate-waiting-text, #d29922)",
        "stepHeaderOpenBg": "var(--color-checks-step-header-open-bg, #161b22)",
        "stepErrorText": "var(--color-checks-step-error-text, #f85149)",
        "stepWarningText": "var(--color-checks-step-warning-text, #d29922)",
        "loglineText": "var(--color-checks-logline-text, #848d97)",
        "loglineNumText": "var(--color-checks-logline-num-text, #6e7681)",
        "loglineDebugText": "var(--color-checks-logline-debug-text, #a371f7)",
        "loglineErrorText": "var(--color-checks-logline-error-text, #848d97)",
        "loglineErrorNumText": "var(--color-checks-logline-error-num-text, #6e7681)",
        "loglineErrorBg": "var(--color-checks-logline-error-bg, rgba(248,81,73,0.1))",
        "loglineWarningText": "var(--color-checks-logline-warning-text, #848d97)",
        "loglineWarningNumText": "var(--color-checks-logline-warning-num-text, #d29922)",
        "loglineWarningBg": "var(--color-checks-logline-warning-bg, rgba(187,128,9,0.15))",
        "loglineCommandText": "var(--color-checks-logline-command-text, #2f81f7)",
        "loglineSectionText": "var(--color-checks-logline-section-text, #3fb950)",
        "ansi": {
          "black": "var(--color-checks-ansi-black, #0d1117)",
          "blackBright": "var(--color-checks-ansi-black-bright, #161b22)",
          "white": "var(--color-checks-ansi-white, #b1bac4))",
          "whiteBright": "var(--color-checks-ansi-white-bright, #b1bac4)",
          "gray": "var(--color-checks-ansi-gray, #6e7681)",
          "red": "var(--color-checks-ansi-red, #ff7b72)",
          "redBright": "var(--color-checks-ansi-red-bright, #ffa198)",
          "green": "var(--color-checks-ansi-green, #3fb950)",
          "greenBright": "var(--color-checks-ansi-green-bright, #56d364)",
          "yellow": "var(--color-checks-ansi-yellow, #d29922)",
          "yellowBright": "var(--color-checks-ansi-yellow-bright, #e3b341)",
          "blue": "var(--color-checks-ansi-blue, #58a6ff)",
          "blueBright": "var(--color-checks-ansi-blue-bright, #79c0ff)",
          "magenta": "var(--color-checks-ansi-magenta, #bc8cff)",
          "magentaBright": "var(--color-checks-ansi-magenta-bright, #d2a8ff)",
          "cyan": "var(--color-checks-ansi-cyan, #76e3ea)",
          "cyanBright": "var(--color-checks-ansi-cyan-bright, #b3f0ff)"
        }
      },
      "project": {
        "headerBg": "var(--color-project-header-bg, #0d1117)",
        "sidebarBg": "var(--color-project-sidebar-bg, #161b22)",
        "gradientIn": "var(--color-project-gradient-in, #161b22)",
        "gradientOut": "var(--color-project-gradient-out, rgba(22,27,34,0))"
      },
      "mktg": {
        "btn": {
          "bg": "var(--color-mktg-btn-bg, #f6f8fa))"
        }
      },
      "control": {
        "borderColor": {
          "emphasis": "var(--control-borderColor-emphasis, var(--color-control-border-color-emphasis, #606771))"
        }
      },
      "avatar": {
        "bg": "var(--avatar-bgColor, var(--color-avatar-bg, rgba(255,255,255,0.1)))",
        "border": "var(--avatar-borderColor, var(--color-avatar-border, rgba(240,246,252,0.1)))",
        "stackFade": "var(--avatarStack-fade-bgColor-default, var(--color-avatar-stack-fade, #30363d))",
        "stackFadeMore": "var(--avatarStack-fade-bgColor-muted, var(--color-avatar-stack-fade-more, #21262d))"
      },
      "topicTag": {
        "border": "var(--topicTag-borderColor, var(--color-topic-tag-border, transparent))"
      },
      "counter": {
        "border": "var(--counter-borderColor, var(--color-counter-border, transparent))"
      },
      "selectMenu": {
        "backdropBorder": "var(--selectMenu-borderColor, var(--color-select-menu-backdrop-border, #484f58))",
        "tapHighlight": "var(--control-bgColor-active, var(--color-select-menu-tap-highlight, rgba(48,54,61,0.5)))",
        "tapFocusBg": "var(--selectMenu-bgColor-active, var(--color-select-menu-tap-focus-bg, #0c2d6b))"
      },
      "overlay": {
        "backdrop": "var(--overlay-backdrop-bgColor, var(--color-overlay-backdrop, rgba(22,27,34,0.4)))"
      },
      "header": {
        "text": "var(--header-fgColor-default, var(--color-header-text, rgba(255,255,255,0.7)))",
        "bg": "var(--header-bgColor, var(--color-header-bg, #161b22))",
        "divider": "var(--header-borderColor-divider, var(--color-header-divider, #8b949e))",
        "logo": "var(--header-fgColor-logo, var(--color-header-logo, #f0f6fc))"
      },
      "headerSearch": {
        "bg": "var(--headerSearch-bgColor, var(--color-header-search-bg, #0d1117))",
        "border": "var(--headerSearch-borderColor, var(--color-header-search-border, #30363d))"
      },
      "sidenav": {
        "selectedBg": "var(--sideNav-bgColor-selected, var(--color-sidenav-selected-bg, #21262d))"
      },
      "menu": {
        "bgActive": "var(--menu-bgColor-active, var(--color-menu-bg-active, #161b22))"
      },
      "input": {
        "disabledBg": "var(--control-bgColor-disabled, var(--color-input-disabled-bg, rgba(110,118,129,0)))"
      },
      "timeline": {
        "badgeBg": "var(--timelineBadge-bgColor, var(--color-timeline-badge-bg, #21262d))"
      },
      "ansi": {
        "black": "var(--color-ansi-black, #484f58)",
        "blackBright": "var(--color-ansi-black-bright, #6e7681)",
        "white": "var(--color-ansi-white, #b1bac4)",
        "whiteBright": "var(--color-ansi-white-bright, #ffffff)",
        "gray": "var(--color-ansi-gray, #6e7681)",
        "red": "var(--color-ansi-red, #ff7b72)",
        "redBright": "var(--color-ansi-red-bright, #ffa198)",
        "green": "var(--color-ansi-green, #3fb950)",
        "greenBright": "var(--color-ansi-green-bright, #56d364)",
        "yellow": "var(--color-ansi-yellow, #d29922)",
        "yellowBright": "var(--color-ansi-yellow-bright, #e3b341)",
        "blue": "var(--color-ansi-blue, #58a6ff)",
        "blueBright": "var(--color-ansi-blue-bright, #79c0ff)",
        "magenta": "var(--color-ansi-magenta, #bc8cff)",
        "magentaBright": "var(--color-ansi-magenta-bright, #d2a8ff)",
        "cyan": "var(--color-ansi-cyan, #39c5cf)",
        "cyanBright": "var(--color-ansi-cyan-bright, #56d4dd)"
      },
      "btn": {
        "text": "var(--button-default-fgColor-rest, var(--color-btn-text, #c9d1d9))",
        "bg": "var(--button-default-bgColor-rest, var(--color-btn-bg, #21262d))",
        "border": "var(--button-default-borderColor-rest, var(--color-btn-border, rgba(240,246,252,0.1)))",
        "hoverBg": "var(--button-default-bgColor-hover, var(--color-btn-hover-bg, #30363d))",
        "hoverBorder": "var(--button-default-borderColor-hover, var(--color-btn-hover-border, #8b949e))",
        "activeBg": "var(--button-default-bgColor-active, var(--color-btn-active-bg, hsla(212,12%,18%,1)))",
        "activeBorder": "var(--button-default-borderColor-active, var(--color-btn-active-border, #6e7681))",
        "selectedBg": "var(--button-default-bgColor-selected, var(--color-btn-selected-bg, #161b22))",
        "counterBg": "var(--buttonCounter-default-bgColor-rest, var(--color-btn-counter-bg, #30363d))",
        "primary": {
          "text": "var(--button-primary-fgColor-rest, var(--color-btn-primary-text, #ffffff))",
          "bg": "var(--button-primary-bgColor-rest, var(--color-btn-primary-bg, #238636))",
          "border": "var(--button-primary-borderColor-rest, var(--color-btn-primary-border, rgba(240,246,252,0.1)))",
          "hoverBg": "var(--button-primary-bgColor-hover, var(--color-btn-primary-hover-bg, #2ea043))",
          "hoverBorder": "var(--button-primary-borderColor-hover, var(--color-btn-primary-hover-border, rgba(240,246,252,0.1)))",
          "selectedBg": "var(--button-primary-bgColor-active, var(--color-btn-primary-selected-bg, #238636))",
          "disabledText": "var(--button-primary-fgColor-disabled, var(--color-btn-primary-disabled-text, rgba(255,255,255,0.5)))",
          "disabledBg": "var(--button-primary-bgColor-disabled, var(--color-btn-primary-disabled-bg, rgba(35,134,54,0.6)))",
          "disabledBorder": "var(--button-primary-borderColor-disabled, var(--color-btn-primary-disabled-border, rgba(240,246,252,0.1)))",
          "icon": "var(--button-primary-iconColor-rest, var(--color-btn-primary-icon, #ffffff))",
          "counterBg": "var(--buttonCounter-primary-bgColor-rest, var(--color-btn-primary-counter-bg, rgba(4,38,15,0.2)))"
        },
        "outline": {
          "text": "var(--button-outline-fgColor-rest, var(--color-btn-outline-text, #388bfd))",
          "hoverText": "var(--button-outline-fgColor-hover, var(--color-btn-outline-hover-text, #58a6ff))",
          "hoverBg": "var(--button-outline-bgColor-hover, var(--color-btn-outline-hover-bg, #30363d))",
          "hoverBorder": "var(--button-outline-borderColor-hover, var(--color-btn-outline-hover-border, rgba(240,246,252,0.1)))",
          "hoverCounterBg": "var(--buttonCounter-outline-bgColor-hover, var(--color-btn-outline-hover-counter-bg, rgba(5,29,77,0.2)))",
          "selectedText": "var(--button-outline-fgColor-active, var(--color-btn-outline-selected-text, #ffffff))",
          "selectedBg": "var(--button-outline-bgColor-active, var(--color-btn-outline-selected-bg, #0d419d))",
          "selectedBorder": "var(--button-outline-borderColor-active, var(--color-btn-outline-selected-border, rgba(240,246,252,0.1)))",
          "disabledText": "var(--button-outline-fgColor-disabled, var(--color-btn-outline-disabled-text, rgba(88,166,255,0.5)))",
          "disabledBg": "var(--button-outline-bgColor-disabled, var(--color-btn-outline-disabled-bg, #0d1117))",
          "disabledCounterBg": "var(--buttonCounter-outline-bgColor-disabled, var(--color-btn-outline-disabled-counter-bg, rgba(31,111,235,0.05)))",
          "counterBg": "var(--buttonCounter-outline-bgColor-rest, var(--color-btn-outline-counter-bg, rgba(5,29,77,0.2)))",
          "hoverCounterFg": "var(--buttonCounter-outline-fgColor-hover, var(--color-btn-outline-hover-counter-fg, #58a6ff))",
          "disabledCounterFg": "var(--buttonCounter-outline-fgColor-disabled, var(--color-btn-outline-disabled-counter-fg, rgba(47,129,247,0.5)))",
          "counterFg": "var(--buttonCounter-outline-fgColor-rest, var(--color-btn-outline-counter-fg, #388bfd))"
        },
        "danger": {
          "text": "var(--button-danger-fgColor-rest, var(--color-btn-danger-text, #f85149))",
          "hoverText": "var(--button-danger-fgColor-hover, var(--color-btn-danger-hover-text, #ffffff))",
          "hoverBg": "var(--button-danger-bgColor-hover, var(--color-btn-danger-hover-bg, #da3633))",
          "hoverBorder": "var(--button-danger-borderColor-hover, var(--color-btn-danger-hover-border, #f85149))",
          "hoverIcon": "var(--button-danger-iconColor-hover, var(--color-btn-danger-hover-icon, #ffffff))",
          "hoverCounterBg": "var(--buttonCounter-danger-bgColor-hover, var(--color-btn-danger-hover-counter-bg, rgba(255,255,255,0.2)))",
          "selectedText": "var(--button-danger-fgColor-active, var(--color-btn-danger-selected-text, #ffffff))",
          "selectedBg": "var(--button-danger-bgColor-active, var(--color-btn-danger-selected-bg, #b62324))",
          "selectedBorder": "var(--button-danger-borderColor-active, var(--color-btn-danger-selected-border, #ff7b72))",
          "disabledText": "var(--button-danger-fgColor-disabled, var(--color-btn-danger-disabled-text, rgba(248,81,73,0.5)))",
          "disabledBg": "var(--button-danger-bgColor-disabled, var(--color-btn-danger-disabled-bg, #0d1117))",
          "disabledCounterBg": "var(--buttonCounter-danger-bgColor-disabled, var(--color-btn-danger-disabled-counter-bg, rgba(218,54,51,0.05)))",
          "counterBg": "var(--buttonCounter-danger-bgColor-rest, var(--color-btn-danger-counter-bg, rgba(73,2,2,0.2)))",
          "icon": "var(--button-danger-iconColor-rest, var(--color-btn-danger-icon, #f85149))",
          "counterFg": "var(--buttonCounter-danger-fgColor-rest, var(--color-btn-danger-counter-fg, #f85149))",
          "disabledCounterFg": "var(--buttonCounter-danger-fgColor-disabled, var(--color-btn-danger-disabled-counter-fg, rgba(248,81,73,0.5)))",
          "hoverCounterFg": "var(--buttonCounter-danger-fgColor-hover, var(--color-btn-danger-hover-counter-fg, #ffffff))"
        },
        "inactive": {
          "bg": "var(--button-inactive-bgColor-rest, var(--color-btn-inactive-bg, #21262d))",
          "text": "var(--button-inactive-fgColor-rest, var(--color-btn-inactive-text, #8b949e))"
        }
      },
      "underlinenav": {
        "icon": "var(--underlineNav-iconColor-rest, var(--color-underlinenav-icon, #6e7681))",
        "borderHover": "var(--underlineNav-borderColor-hover, var(--color-underlinenav-border-hover, rgba(110,118,129,0.4)))"
      },
      "actionListItem": {
        "inlineDivider": "var(--borderColor-muted, var(--color-action-list-item-inline-divider, rgba(48,54,61,0.48)))",
        "default": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-action-list-item-default-hover-bg, rgba(177,186,196,0.12)))",
          "hoverBorder": "var(--control-transparent-borderColor-hover, var(--color-action-list-item-default-hover-border, transparent))",
          "activeBg": "var(--control-transparent-bgColor-active, var(--color-action-list-item-default-active-bg, rgba(177,186,196,0.2)))",
          "activeBorder": "var(--control-transparent-borderColor-active, var(--color-action-list-item-default-active-border, transparent))",
          "selectedBg": "var(--control-transparent-bgColor-selected, var(--color-action-list-item-default-selected-bg, rgba(177,186,196,0.08)))"
        },
        "danger": {
          "hoverBg": "var(--control-danger-bgColor-hover, var(--color-action-list-item-danger-hover-bg, rgba(248,81,73,0.16)))",
          "activeBg": "var(--control-danger-bgColor-active, var(--color-action-list-item-danger-active-bg, rgba(248,81,73,0.24)))",
          "hoverText": "var(--control-danger-fgColor-hover, var(--color-action-list-item-danger-hover-text, #ff7b72))"
        }
      },
      "switchTrack": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-switch-track-bg, rgba(110,118,129,0.1)))",
        "hoverBg": "var(--controlTrack-bgColor-hover, var(--color-switch-track-hover-bg, hsla(215,8%,72%,0.1)))",
        "activeBg": "var(--controlTrack-bgColor-active, var(--color-switch-track-active-bg, rgba(110,118,129,0.4)))",
        "disabledBg": "var(--controlTrack-bgColor-disabled, var(--color-switch-track-disabled-bg, #21262d))",
        "fg": "var(--controlTrack-fgColor-rest, var(--color-switch-track-fg, #848d97))",
        "disabledFg": "var(--controlTrack-fgColor-disabled, var(--color-switch-track-disabled-fg, #010409))",
        "border": "var(--controlTrack-borderColor-rest, var(--color-switch-track-border, transparent))",
        "checked": {
          "bg": "var(--control-checked-bgColor-rest, var(--color-switch-track-checked-bg, rgba(31,111,235,0.35)))",
          "hoverBg": "var(--control-checked-bgColor-hover, var(--color-switch-track-checked-hover-bg, rgba(31,111,235,0.5)))",
          "activeBg": "var(--control-checked-bgColor-active, var(--color-switch-track-checked-active-bg, rgba(31,111,235,0.65)))",
          "fg": "var(--control-checked-fgColor-rest, var(--color-switch-track-checked-fg, #ffffff))",
          "disabledFg": "var(--control-checked-fgColor-disabled, var(--color-switch-track-checked-disabled-fg, #010409))",
          "border": "var(--borderColor-transparent, var(--color-switch-track-checked-border, transparent))"
        }
      },
      "switchKnob": {
        "bg": "var(--controlKnob-bgColor-rest, var(--color-switch-knob-bg, #0d1117))",
        "border": "var(--controlKnob-borderColor-rest, var(--color-switch-knob-border, #606771))",
        "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-disabled-bg, #161b22))",
        "checked": {
          "bg": "var(--controlKnob-bgColor-checked, var(--color-switch-knob-checked-bg, #0d1117))",
          "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-checked-disabled-bg, #161b22))",
          "border": "var(--controlKnob-borderColor-checked, var(--color-switch-knob-checked-border, rgba(31,111,235,0.35)))"
        }
      },
      "segmentedControl": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-segmented-control-bg, rgba(110,118,129,0.1)))",
        "button": {
          "bg": "var(--controlKnob-bgColor-rest, var(--color-segmented-control-button-bg, #0d1117))",
          "hover": {
            "bg": "var(--controlTrack-bgColor-hover, var(--color-segmented-control-button-hover-bg, #30363d))"
          },
          "active": {
            "bg": "var(--controlTrack-bgColor-active, var(--color-segmented-control-button-active-bg, #21262d))"
          },
          "selected": {
            "border": "var(--controlKnob-borderColor-rest, var(--color-segmented-control-button-selected-border, #6e7681))"
          }
        }
      },
      "treeViewItem": {
        "chevron": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-tree-view-item-chevron-hover-bg, rgba(177,186,196,0.12)))"
        },
        "directory": {
          "fill": "var(--treeViewItem-leadingVisual-iconColor-rest, var(--color-tree-view-item-directory-fill, #848d97))"
        }
      },
      "fg": {
        "default": "var(--fgColor-default, var(--color-fg-default, #e6edf3))",
        "muted": "var(--fgColor-muted, var(--color-fg-muted, #848d97))",
        "subtle": "var(--fgColor-muted, var(--color-fg-subtle, #6e7681))",
        "onEmphasis": "var(--fgColor-onEmphasis, var(--color-fg-on-emphasis, #ffffff))"
      },
      "canvas": {
        "default": "var(--bgColor-default, var(--color-canvas-default, #0d1117))",
        "overlay": "var(--overlay-bgColor, var(--color-canvas-overlay, #161b22))",
        "inset": "var(--bgColor-inset, var(--color-canvas-inset, #010409))",
        "subtle": "var(--bgColor-muted, var(--color-canvas-subtle, #161b22))"
      },
      "border": {
        "default": "var(--borderColor-default, var(--color-border-default, #30363d))",
        "muted": "var(--borderColor-muted, var(--color-border-muted, #21262d))",
        "subtle": "var(--borderColor-muted, var(--color-border-subtle, rgba(240,246,252,0.1)))"
      },
      "neutral": {
        "emphasisPlus": "var(--bgColor-emphasis, var(--color-neutral-emphasis-plus, #6e7681))",
        "emphasis": "var(--bgColor-neutral-emphasis, var(--color-neutral-emphasis, #6e7681))",
        "muted": "var(--bgColor-neutral-muted, var(--color-neutral-muted, rgba(110,118,129,0.4)))",
        "subtle": "var(--bgColor-neutral-muted, var(--color-neutral-subtle, rgba(110,118,129,0.1)))"
      },
      "accent": {
        "fg": "var(--fgColor-accent, var(--color-accent-fg, #2f81f7))",
        "emphasis": "var(--bgColor-accent-emphasis, var(--color-accent-emphasis, #1f6feb))",
        "muted": "var(--borderColor-accent-muted, var(--color-accent-muted, rgba(56,139,253,0.4)))",
        "subtle": "var(--bgColor-accent-muted, var(--color-accent-subtle, rgba(56,139,253,0.1)))"
      },
      "success": {
        "fg": "var(--fgColor-success, var(--color-success-fg, #3fb950))",
        "emphasis": "var(--bgColor-success-emphasis, var(--color-success-emphasis, #238636))",
        "muted": "var(--borderColor-success-muted, var(--color-success-muted, rgba(46,160,67,0.4)))",
        "subtle": "var(--bgColor-success-muted, var(--color-success-subtle, rgba(46,160,67,0.15)))"
      },
      "attention": {
        "fg": "var(--fgColor-attention, var(--color-attention-fg, #d29922))",
        "emphasis": "var(--bgColor-attention-emphasis, var(--color-attention-emphasis, #9e6a03))",
        "muted": "var(--borderColor-attention-muted, var(--color-attention-muted, rgba(187,128,9,0.4)))",
        "subtle": "var(--bgColor-attention-muted, var(--color-attention-subtle, rgba(187,128,9,0.15)))"
      },
      "severe": {
        "fg": "var(--fgColor-severe, var(--color-severe-fg, #db6d28))",
        "emphasis": "var(--bgColor-severe-emphasis, var(--color-severe-emphasis, #bd561d))",
        "muted": "var(--borderColor-severe-muted, var(--color-severe-muted, rgba(219,109,40,0.4)))",
        "subtle": "var(--bgColor-severe-muted, var(--color-severe-subtle, rgba(219,109,40,0.1)))"
      },
      "danger": {
        "fg": "var(--fgColor-danger, var(--color-danger-fg, #f85149))",
        "emphasis": "var(--borderColor-danger-emphasis, var(--color-danger-emphasis, #da3633))",
        "muted": "var(--borderColor-danger-muted, var(--color-danger-muted, rgba(248,81,73,0.4)))",
        "subtle": "var(--bgColor-danger-muted, var(--color-danger-subtle, rgba(248,81,73,0.1)))"
      },
      "open": {
        "fg": "var(--fgColor-open, var(--color-open-fg, #3fb950))",
        "emphasis": "var(--bgColor-open-emphasis, var(--color-open-emphasis, #238636))",
        "muted": "var(--borderColor-open-muted, var(--color-open-muted, rgba(46,160,67,0.4)))",
        "subtle": "var(--bgColor-open-muted, var(--color-open-subtle, rgba(46,160,67,0.15)))"
      },
      "closed": {
        "fg": "var(--fgColor-closed, var(--color-closed-fg, #f85149))",
        "emphasis": "var(--bgColor-closed-emphasis, var(--color-closed-emphasis, #da3633))",
        "muted": "var(--borderColor-closed-muted, var(--color-closed-muted, rgba(248,81,73,0.4)))",
        "subtle": "var(--bgColor-closed-muted, var(--color-closed-subtle, rgba(248,81,73,0.15)))"
      },
      "done": {
        "fg": "var(--fgColor-done, var(--color-done-fg, #a371f7))",
        "emphasis": "var(--bgColor-done-emphasis, var(--color-done-emphasis, #8957e5))",
        "muted": "var(--borderColor-done-muted, var(--color-done-muted, rgba(163,113,247,0.4)))",
        "subtle": "var(--bgColor-done-muted, var(--color-done-subtle, rgba(163,113,247,0.1)))"
      },
      "sponsors": {
        "fg": "var(--fgColor-sponsors, var(--color-sponsors-fg, #db61a2))",
        "emphasis": "var(--bgColor-sponsors-emphasis, var(--color-sponsors-emphasis, #bf4b8a))",
        "muted": "var(--borderColor-sponsors-muted, var(--color-sponsors-muted, rgba(219,97,162,0.4)))",
        "subtle": "var(--bgColor-sponsors-muted, var(--color-sponsors-subtle, rgba(219,97,162,0.1)))"
      },
      "primer": {
        "fg": {
          "disabled": "var(--fgColor-disabled, var(--color-primer-fg-disabled, #484f58))"
        },
        "canvas": {
          "backdrop": "var(--overlay-backdrop-bgColor, var(--color-primer-canvas-backdrop, rgba(1,4,9,0.8)))",
          "sticky": "var(--color-primer-canvas-sticky, rgba(13,17,23,0.95))"
        },
        "border": {
          "active": "var(--underlineNav-borderColor-active, var(--color-primer-border-active, #f78166))",
          "contrast": "var(--borderColor-muted, var(--color-primer-border-contrast, rgba(255,255,255,0.2)))"
        }
      }
    },
    "shadows": {
      "checks": {
        "inputShadow": "var(--color-checks-input-shadow, 0 0 0 1px #30363d)"
      },
      "mktg": {
        "btn": {
          "shadow": {
            "outline": "var(--color-mktg-btn-shadow-outline, rgb(255 255 255 / 25%) 0 0 0 1px inset))",
            "focus": "var(--color-mktg-btn-shadow-focus, rgb(255 255 255 / 25%) 0 0 0 4px))",
            "hover": "var(--color-mktg-btn-shadow-hover, 0 4px 7px rgba(0, 0, 0, 0.15), 0 100px 80px rgba(255, 255, 255, 0.02), 0 42px 33px rgba(255, 255, 255, 0.024), 0 22px 18px rgba(255, 255, 255, 0.028), 0 12px 10px rgba(255, 255, 255, 0.034), 0 7px 5px rgba(255, 255, 255, 0.04), 0 3px 2px rgba(255, 255, 255, 0.07)))",
            "hoverMuted": "var(--color-mktg-btn-shadow-hover-muted, rgb(255 255 255) 0 0 0 2px inset))"
          }
        }
      },
      "avatar": {
        "childShadow": "var(--avatar-shadow, var(--color-avatar-child-shadow, 0 0 0 2px #0d1117))"
      },
      "overlay": {
        "shadow": "var(--shadow-floating-small, var(--color-overlay-shadow, 0 0 0 1px #30363d, 0 16px 32px rgba(1,4,9,0.85)))"
      },
      "btn": {
        "shadow": "var(--button-default-shadow-resting, var(--color-btn-shadow, 0 0 transparent))",
        "insetShadow": "var(--button-default-shadow-inset, var(--color-btn-inset-shadow, 0 0 transparent))",
        "primary": {
          "shadow": "var(--shadow-resting-small, var(--color-btn-primary-shadow, 0 0 transparent))",
          "insetShadow": "var(--shadow-highlight, var(--color-btn-primary-inset-shadow, 0 0 transparent))",
          "selectedShadow": "var(--button-primary-shadow-selected, var(--color-btn-primary-selected-shadow, 0 0 transparent))"
        },
        "outline": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-outline-hover-shadow, 0 1px 0 rgba(1,4,9,0.1)))",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-outline-hover-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.03)))",
          "selectedShadow": "var(--button-outline-shadow-selected, var(--color-btn-outline-selected-shadow, 0 0 transparent))"
        },
        "danger": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-danger-hover-shadow, 0 0 transparent))",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-danger-hover-inset-shadow, 0 0 transparent))",
          "selectedShadow": "var(--button-danger-shadow-selected, var(--color-btn-danger-selected-shadow, 0 0 transparent))"
        }
      },
      "shadow": {
        "small": "var(--shadow-resting-small, var(--color-shadow-small, 0 0 transparent))",
        "medium": "var(--shadow-resting-medium, var(--color-shadow-medium, 0 3px 6px #010409))",
        "large": "var(--shadow-floating-large, var(--color-shadow-large, 0 8px 24px #010409))",
        "extraLarge": "var(--shadow-floating-xlarge, var(--color-shadow-extra-large, 0 12px 48px #010409))"
      },
      "primer": {
        "shadow": {
          "highlight": "var(--shadow-highlight, var(--color-primer-shadow-highlight, 0 0 transparent))",
          "inset": "var(--shadow-inset, var(--color-primer-shadow-inset, 0 0 transparent))"
        }
      }
    }
  },
  "dark_dimmed": {
    "colors": {
      "canvasDefaultTransparent": "var(--bgColor-transparent, var(--color-canvas-default-transparent, rgba(34,39,46,0)))",
      "pageHeaderBg": "var(--page-header-bgColor, var(--color-page-header-bg, #22272e))",
      "marketingIcon": {
        "primary": "var(--color-marketing-icon-primary, #6cb6ff)",
        "secondary": "var(--color-marketing-icon-secondary, #316dca)"
      },
      "diffBlob": {
        "addition": {
          "numText": "var(--diffBlob-addition-fgColor-num, var(--color-diff-blob-addition-num-text, #adbac7))",
          "fg": "var(--diffBlob-addition-fgColor-text, var(--color-diff-blob-addition-fg, #adbac7))",
          "numBg": "var(--diffBlob-addition-bgColor-num, var(--color-diff-blob-addition-num-bg, rgba(87,171,90,0.3)))",
          "lineBg": "var(--diffBlob-addition-bgColor-line, var(--color-diff-blob-addition-line-bg, rgba(70,149,74,0.15)))",
          "wordBg": "var(--diffBlob-addition-bgColor-word, var(--color-diff-blob-addition-word-bg, rgba(70,149,74,0.4)))"
        },
        "deletion": {
          "numText": "var(--diffBlob-deletion-fgColor-num, var(--color-diff-blob-deletion-num-text, #adbac7))",
          "fg": "var(--diffBlob-deletion-fgColor-text, var(--color-diff-blob-deletion-fg, #adbac7))",
          "numBg": "var(--diffBlob-deletion-bgColor-num, var(--color-diff-blob-deletion-num-bg, rgba(229,83,75,0.3)))",
          "lineBg": "var(--diffBlob-deletion-bgColor-line, var(--color-diff-blob-deletion-line-bg, rgba(229,83,75,0.1)))",
          "wordBg": "var(--diffBlob-deletion-bgColor-word, var(--color-diff-blob-deletion-word-bg, rgba(229,83,75,0.4)))"
        },
        "hunk": {
          "numBg": "var(--diffBlob-hunk-bgColor-num, var(--color-diff-blob-hunk-num-bg, rgba(65,132,228,0.4)))"
        },
        "expander": {
          "icon": "#adbac7"
        },
        "selectedLineHighlightMixBlendMode": "var(--color-diff-blob-selected-line-highlight-mix-blend-mode, screen)"
      },
      "diffstat": {
        "deletionBorder": "var(--color-diffstat-deletion-border, rgba(205,217,229,0.1))",
        "additionBorder": "var(--color-diffstat-addition-border, rgba(205,217,229,0.1))",
        "additionBg": "var(--diffStat-addition-bgColor, var(--color-diffstat-addition-bg, #57ab5a))"
      },
      "searchKeyword": {
        "hl": "var(--highlight-neutral-bgColor, var(--color-search-keyword-hl, rgba(198,144,38,0.4)))"
      },
      "prettylights": {
        "syntax": {
          "comment": "var(--color-prettylights-syntax-comment, #768390)",
          "constant": "var(--color-prettylights-syntax-constant, #6cb6ff)",
          "entity": "var(--color-prettylights-syntax-entity, #dcbdfb)",
          "storageModifierImport": "var(--color-prettylights-syntax-storage-modifier-import, #adbac7)",
          "entityTag": "var(--color-prettylights-syntax-entity-tag, #8ddb8c)",
          "keyword": "var(--color-prettylights-syntax-keyword, #f47067)",
          "string": "var(--color-prettylights-syntax-string, #96d0ff)",
          "variable": "var(--color-prettylights-syntax-variable, #f69d50)",
          "brackethighlighterUnmatched": "var(--color-prettylights-syntax-brackethighlighter-unmatched, #e5534b)",
          "invalidIllegalText": "var(--color-prettylights-syntax-invalid-illegal-text, #cdd9e5)",
          "invalidIllegalBg": "var(--color-prettylights-syntax-invalid-illegal-bg, #922323)",
          "carriageReturnText": "var(--color-prettylights-syntax-carriage-return-text, #cdd9e5)",
          "carriageReturnBg": "var(--color-prettylights-syntax-carriage-return-bg, #ad2e2c)",
          "stringRegexp": "var(--color-prettylights-syntax-string-regexp, #8ddb8c)",
          "markupList": "var(--color-prettylights-syntax-markup-list, #eac55f)",
          "markupHeading": "var(--color-prettylights-syntax-markup-heading, #316dca)",
          "markupItalic": "var(--color-prettylights-syntax-markup-italic, #adbac7)",
          "markupBold": "var(--color-prettylights-syntax-markup-bold, #adbac7)",
          "markupDeletedText": "var(--color-prettylights-syntax-markup-deleted-text, #ffd8d3)",
          "markupDeletedBg": "var(--color-prettylights-syntax-markup-deleted-bg, #78191b)",
          "markupInsertedText": "var(--color-prettylights-syntax-markup-inserted-text, #b4f1b4)",
          "markupInsertedBg": "var(--color-prettylights-syntax-markup-inserted-bg, #1b4721)",
          "markupChangedText": "var(--color-prettylights-syntax-markup-changed-text, #ffddb0)",
          "markupChangedBg": "var(--color-prettylights-syntax-markup-changed-bg, #682d0f)",
          "markupIgnoredText": "var(--color-prettylights-syntax-markup-ignored-text, #adbac7)",
          "markupIgnoredBg": "var(--color-prettylights-syntax-markup-ignored-bg, #255ab2)",
          "metaDiffRange": "var(--color-prettylights-syntax-meta-diff-range, #dcbdfb)",
          "brackethighlighterAngle": "var(--color-prettylights-syntax-brackethighlighter-angle, #768390)",
          "sublimelinterGutterMark": "var(--color-prettylights-syntax-sublimelinter-gutter-mark, #545d68)",
          "constantOtherReferenceLink": "var(--color-prettylights-syntax-constant-other-reference-link, #96d0ff)"
        }
      },
      "codemirror": {
        "text": "var(--codeMirror-fgColor, var(--color-codemirror-text, #adbac7))",
        "bg": "var(--codeMirror-bgColor, var(--color-codemirror-bg, #22272e))",
        "guttersBg": "var(--codeMirror-gutters-bgColor, var(--color-codemirror-gutters-bg, #22272e))",
        "guttermarkerText": "var(--codeMirror-gutterMarker-fgColor-default, var(--color-codemirror-guttermarker-text, #22272e))",
        "guttermarkerSubtleText": "var(--codeMirror-gutterMarker-fgColor-muted, var(--color-codemirror-guttermarker-subtle-text, #636e7b))",
        "linenumberText": "var(--codeMirror-lineNumber-fgColor, var(--color-codemirror-linenumber-text, #768390))",
        "cursor": "var(--codeMirror-cursor-fgColor, var(--color-codemirror-cursor, #adbac7))",
        "selectionBg": "var(--codeMirror-selection-bgColor, var(--color-codemirror-selection-bg, rgba(65,132,228,0.4)))",
        "activelineBg": "var(--codeMirror-activeline-bgColor, var(--color-codemirror-activeline-bg, rgba(99,110,123,0.1)))",
        "matchingbracketText": "var(--codeMirror-matchingBracket-fgColor, var(--color-codemirror-matchingbracket-text, #adbac7))",
        "linesBg": "var(--codeMirror-lines-bgColor, var(--color-codemirror-lines-bg, #22272e))",
        "syntax": {
          "comment": "var(--codeMirror-syntax-fgColor-comment, var(--color-codemirror-syntax-comment, #768390))",
          "constant": "var(--codeMirror-syntax-fgColor-constant, var(--color-codemirror-syntax-constant, #6cb6ff))",
          "entity": "var(--codeMirror-syntax-fgColor-entity, var(--color-codemirror-syntax-entity, #dcbdfb))",
          "keyword": "var(--codeMirror-syntax-fgColor-keyword, var(--color-codemirror-syntax-keyword, #f47067))",
          "storage": "var(--codeMirror-syntax-fgColor-storage, var(--color-codemirror-syntax-storage, #f47067))",
          "string": "var(--codeMirror-syntax-fgColor-string, var(--color-codemirror-syntax-string, #96d0ff))",
          "support": "var(--codeMirror-syntax-fgColor-support, var(--color-codemirror-syntax-support, #6cb6ff))",
          "variable": "var(--codeMirror-syntax-fgColor-variable, var(--color-codemirror-syntax-variable, #f69d50))"
        }
      },
      "checks": {
        "bg": "var(--color-checks-bg, #1c2128)",
        "runBorderWidth": "var(--color-checks-run-border-width, 1px)",
        "containerBorderWidth": "var(--color-checks-container-border-width, 1px)",
        "textPrimary": "var(--color-checks-text-primary, #adbac7)",
        "textSecondary": "var(--color-checks-text-secondary, #768390)",
        "textLink": "var(--color-checks-text-link, #539bf5)",
        "btnIcon": "var(--color-checks-btn-icon, #768390)",
        "btnHoverIcon": "var(--color-checks-btn-hover-icon, #adbac7)",
        "btnHoverBg": "var(--color-checks-btn-hover-bg, rgba(99,110,123,0.1))",
        "inputText": "var(--color-checks-input-text, #768390)",
        "inputPlaceholderText": "var(--color-checks-input-placeholder-text, #636e7b)",
        "inputFocusText": "var(--color-checks-input-focus-text, #adbac7)",
        "inputBg": "var(--color-checks-input-bg, #2d333b)",
        "donutError": "var(--color-checks-donut-error, #e5534b)",
        "donutPending": "var(--color-checks-donut-pending, #c69026)",
        "donutSuccess": "var(--color-checks-donut-success, #46954a)",
        "donutNeutral": "var(--color-checks-donut-neutral, #768390)",
        "dropdownText": "var(--color-checks-dropdown-text, #adbac7)",
        "dropdownBg": "var(--color-checks-dropdown-bg, #2d333b)",
        "dropdownBorder": "var(--color-checks-dropdown-border, #444c56)",
        "dropdownShadow": "var(--color-checks-dropdown-shadow, rgba(28,33,40,0.3))",
        "dropdownHoverText": "var(--color-checks-dropdown-hover-text, #adbac7)",
        "dropdownHoverBg": "var(--color-checks-dropdown-hover-bg, rgba(99,110,123,0.1))",
        "dropdownBtnHoverText": "var(--color-checks-dropdown-btn-hover-text, #adbac7)",
        "dropdownBtnHoverBg": "var(--color-checks-dropdown-btn-hover-bg, rgba(99,110,123,0.1))",
        "scrollbarThumbBg": "var(--color-checks-scrollbar-thumb-bg, rgba(99,110,123,0.4))",
        "headerLabelText": "var(--color-checks-header-label-text, #768390)",
        "headerLabelOpenText": "var(--color-checks-header-label-open-text, #adbac7)",
        "headerBorder": "var(--color-checks-header-border, #373e47)",
        "headerIcon": "var(--color-checks-header-icon, #768390)",
        "lineText": "var(--color-checks-line-text, #768390)",
        "lineNumText": "var(--color-checks-line-num-text, #636e7b)",
        "lineTimestampText": "var(--color-checks-line-timestamp-text, #636e7b)",
        "lineHoverBg": "var(--color-checks-line-hover-bg, rgba(99,110,123,0.1))",
        "lineSelectedBg": "var(--color-checks-line-selected-bg, rgba(65,132,228,0.1))",
        "lineSelectedNumText": "var(--color-checks-line-selected-num-text, #539bf5)",
        "lineDtFmText": "var(--color-checks-line-dt-fm-text, #cdd9e5)",
        "lineDtFmBg": "var(--color-checks-line-dt-fm-bg, #966600)",
        "gateBg": "var(--color-checks-gate-bg, rgba(174,124,20,0.15))",
        "gateText": "var(--color-checks-gate-text, #768390)",
        "gateWaitingText": "var(--color-checks-gate-waiting-text, #c69026)",
        "stepHeaderOpenBg": "var(--color-checks-step-header-open-bg, #2d333b)",
        "stepErrorText": "var(--color-checks-step-error-text, #e5534b)",
        "stepWarningText": "var(--color-checks-step-warning-text, #c69026)",
        "loglineText": "var(--color-checks-logline-text, #768390)",
        "loglineNumText": "var(--color-checks-logline-num-text, #636e7b)",
        "loglineDebugText": "var(--color-checks-logline-debug-text, #986ee2)",
        "loglineErrorText": "var(--color-checks-logline-error-text, #768390)",
        "loglineErrorNumText": "var(--color-checks-logline-error-num-text, #636e7b)",
        "loglineErrorBg": "var(--color-checks-logline-error-bg, rgba(229,83,75,0.1))",
        "loglineWarningText": "var(--color-checks-logline-warning-text, #768390)",
        "loglineWarningNumText": "var(--color-checks-logline-warning-num-text, #c69026)",
        "loglineWarningBg": "var(--color-checks-logline-warning-bg, rgba(174,124,20,0.15))",
        "loglineCommandText": "var(--color-checks-logline-command-text, #539bf5)",
        "loglineSectionText": "var(--color-checks-logline-section-text, #57ab5a)",
        "ansi": {
          "black": "var(--color-checks-ansi-black, #22272e)",
          "blackBright": "var(--color-checks-ansi-black-bright, #2d333b)",
          "white": "var(--color-checks-ansi-white, #909dab))",
          "whiteBright": "var(--color-checks-ansi-white-bright, #909dab)",
          "gray": "var(--color-checks-ansi-gray, #636e7b)",
          "red": "var(--color-checks-ansi-red, #f47067)",
          "redBright": "var(--color-checks-ansi-red-bright, #ff938a)",
          "green": "var(--color-checks-ansi-green, #57ab5a)",
          "greenBright": "var(--color-checks-ansi-green-bright, #6bc46d)",
          "yellow": "var(--color-checks-ansi-yellow, #c69026)",
          "yellowBright": "var(--color-checks-ansi-yellow-bright, #daaa3f)",
          "blue": "var(--color-checks-ansi-blue, #539bf5)",
          "blueBright": "var(--color-checks-ansi-blue-bright, #6cb6ff)",
          "magenta": "var(--color-checks-ansi-magenta, #b083f0)",
          "magentaBright": "var(--color-checks-ansi-magenta-bright, #dcbdfb)",
          "cyan": "var(--color-checks-ansi-cyan, #76e3ea)",
          "cyanBright": "var(--color-checks-ansi-cyan-bright, #b3f0ff)"
        }
      },
      "project": {
        "headerBg": "var(--color-project-header-bg, #22272e)",
        "sidebarBg": "var(--color-project-sidebar-bg, #2d333b)",
        "gradientIn": "var(--color-project-gradient-in, #2d333b)",
        "gradientOut": "var(--color-project-gradient-out, rgba(45,51,59,0))"
      },
      "mktg": {
        "btn": {
          "bg": "var(--color-mktg-btn-bg, #f6f8fa))"
        }
      },
      "control": {
        "borderColor": {
          "emphasis": "var(--control-borderColor-emphasis, var(--color-control-border-color-emphasis, #606771))"
        }
      },
      "avatar": {
        "bg": "var(--avatar-bgColor, var(--color-avatar-bg, rgba(205,217,229,0.1)))",
        "border": "var(--avatar-borderColor, var(--color-avatar-border, rgba(205,217,229,0.1)))",
        "stackFade": "var(--avatarStack-fade-bgColor-default, var(--color-avatar-stack-fade, #444c56))",
        "stackFadeMore": "var(--avatarStack-fade-bgColor-muted, var(--color-avatar-stack-fade-more, #373e47))"
      },
      "topicTag": {
        "border": "var(--topicTag-borderColor, var(--color-topic-tag-border, transparent))"
      },
      "counter": {
        "border": "var(--counter-borderColor, var(--color-counter-border, transparent))"
      },
      "selectMenu": {
        "backdropBorder": "var(--selectMenu-borderColor, var(--color-select-menu-backdrop-border, #545d68))",
        "tapHighlight": "var(--control-bgColor-active, var(--color-select-menu-tap-highlight, rgba(68,76,86,0.5)))",
        "tapFocusBg": "var(--selectMenu-bgColor-active, var(--color-select-menu-tap-focus-bg, #143d79))"
      },
      "overlay": {
        "backdrop": "var(--overlay-backdrop-bgColor, var(--color-overlay-backdrop, rgba(45,51,59,0.4)))"
      },
      "header": {
        "text": "var(--header-fgColor-default, var(--color-header-text, rgba(205,217,229,0.7)))",
        "bg": "var(--header-bgColor, var(--color-header-bg, #2d333b))",
        "divider": "var(--header-borderColor-divider, var(--color-header-divider, #768390))",
        "logo": "var(--header-fgColor-logo, var(--color-header-logo, #cdd9e5))"
      },
      "headerSearch": {
        "bg": "var(--headerSearch-bgColor, var(--color-header-search-bg, #22272e))",
        "border": "var(--headerSearch-borderColor, var(--color-header-search-border, #444c56))"
      },
      "sidenav": {
        "selectedBg": "var(--sideNav-bgColor-selected, var(--color-sidenav-selected-bg, #373e47))"
      },
      "menu": {
        "bgActive": "var(--menu-bgColor-active, var(--color-menu-bg-active, #2d333b))"
      },
      "input": {
        "disabledBg": "var(--control-bgColor-disabled, var(--color-input-disabled-bg, rgba(99,110,123,0)))"
      },
      "timeline": {
        "badgeBg": "var(--timelineBadge-bgColor, var(--color-timeline-badge-bg, #373e47))"
      },
      "ansi": {
        "black": "var(--color-ansi-black, #545d68)",
        "blackBright": "var(--color-ansi-black-bright, #636e7b)",
        "white": "var(--color-ansi-white, #909dab)",
        "whiteBright": "var(--color-ansi-white-bright, #cdd9e5)",
        "gray": "var(--color-ansi-gray, #636e7b)",
        "red": "var(--color-ansi-red, #f47067)",
        "redBright": "var(--color-ansi-red-bright, #ff938a)",
        "green": "var(--color-ansi-green, #57ab5a)",
        "greenBright": "var(--color-ansi-green-bright, #6bc46d)",
        "yellow": "var(--color-ansi-yellow, #c69026)",
        "yellowBright": "var(--color-ansi-yellow-bright, #daaa3f)",
        "blue": "var(--color-ansi-blue, #539bf5)",
        "blueBright": "var(--color-ansi-blue-bright, #6cb6ff)",
        "magenta": "var(--color-ansi-magenta, #b083f0)",
        "magentaBright": "var(--color-ansi-magenta-bright, #dcbdfb)",
        "cyan": "var(--color-ansi-cyan, #39c5cf)",
        "cyanBright": "var(--color-ansi-cyan-bright, #56d4dd)"
      },
      "btn": {
        "text": "var(--button-default-fgColor-rest, var(--color-btn-text, #adbac7))",
        "bg": "var(--button-default-bgColor-rest, var(--color-btn-bg, #373e47))",
        "border": "var(--button-default-borderColor-rest, var(--color-btn-border, rgba(205,217,229,0.1)))",
        "hoverBg": "var(--button-default-bgColor-hover, var(--color-btn-hover-bg, #444c56))",
        "hoverBorder": "var(--button-default-borderColor-hover, var(--color-btn-hover-border, #768390))",
        "activeBg": "var(--button-default-bgColor-active, var(--color-btn-active-bg, hsla(213,12%,27%,1)))",
        "activeBorder": "var(--button-default-borderColor-active, var(--color-btn-active-border, #636e7b))",
        "selectedBg": "var(--button-default-bgColor-selected, var(--color-btn-selected-bg, #2d333b))",
        "counterBg": "var(--buttonCounter-default-bgColor-rest, var(--color-btn-counter-bg, #444c56))",
        "primary": {
          "text": "var(--button-primary-fgColor-rest, var(--color-btn-primary-text, #ffffff))",
          "bg": "var(--button-primary-bgColor-rest, var(--color-btn-primary-bg, #347d39))",
          "border": "var(--button-primary-borderColor-rest, var(--color-btn-primary-border, rgba(205,217,229,0.1)))",
          "hoverBg": "var(--button-primary-bgColor-hover, var(--color-btn-primary-hover-bg, #46954a))",
          "hoverBorder": "var(--button-primary-borderColor-hover, var(--color-btn-primary-hover-border, rgba(205,217,229,0.1)))",
          "selectedBg": "var(--button-primary-bgColor-active, var(--color-btn-primary-selected-bg, #347d39))",
          "disabledText": "var(--button-primary-fgColor-disabled, var(--color-btn-primary-disabled-text, rgba(205,217,229,0.5)))",
          "disabledBg": "var(--button-primary-bgColor-disabled, var(--color-btn-primary-disabled-bg, rgba(52,125,57,0.6)))",
          "disabledBorder": "var(--button-primary-borderColor-disabled, var(--color-btn-primary-disabled-border, rgba(205,217,229,0.1)))",
          "icon": "var(--button-primary-iconColor-rest, var(--color-btn-primary-icon, #cdd9e5))",
          "counterBg": "var(--buttonCounter-primary-bgColor-rest, var(--color-btn-primary-counter-bg, rgba(17,52,23,0.2)))"
        },
        "outline": {
          "text": "var(--button-outline-fgColor-rest, var(--color-btn-outline-text, #4184e4))",
          "hoverText": "var(--button-outline-fgColor-hover, var(--color-btn-outline-hover-text, #539bf5))",
          "hoverBg": "var(--button-outline-bgColor-hover, var(--color-btn-outline-hover-bg, #444c56))",
          "hoverBorder": "var(--button-outline-borderColor-hover, var(--color-btn-outline-hover-border, rgba(205,217,229,0.1)))",
          "hoverCounterBg": "var(--buttonCounter-outline-bgColor-hover, var(--color-btn-outline-hover-counter-bg, rgba(15,45,92,0.2)))",
          "selectedText": "var(--button-outline-fgColor-active, var(--color-btn-outline-selected-text, #cdd9e5))",
          "selectedBg": "var(--button-outline-bgColor-active, var(--color-btn-outline-selected-bg, #1b4b91))",
          "selectedBorder": "var(--button-outline-borderColor-active, var(--color-btn-outline-selected-border, rgba(205,217,229,0.1)))",
          "disabledText": "var(--button-outline-fgColor-disabled, var(--color-btn-outline-disabled-text, rgba(83,155,245,0.5)))",
          "disabledBg": "var(--button-outline-bgColor-disabled, var(--color-btn-outline-disabled-bg, #22272e))",
          "disabledCounterBg": "var(--buttonCounter-outline-bgColor-disabled, var(--color-btn-outline-disabled-counter-bg, rgba(49,109,202,0.05)))",
          "counterBg": "var(--buttonCounter-outline-bgColor-rest, var(--color-btn-outline-counter-bg, rgba(15,45,92,0.2)))",
          "hoverCounterFg": "var(--buttonCounter-outline-fgColor-hover, var(--color-btn-outline-hover-counter-fg, #539bf5))",
          "disabledCounterFg": "var(--buttonCounter-outline-fgColor-disabled, var(--color-btn-outline-disabled-counter-fg, rgba(83,155,245,0.5)))",
          "counterFg": "var(--buttonCounter-outline-fgColor-rest, var(--color-btn-outline-counter-fg, #4184e4))"
        },
        "danger": {
          "text": "var(--button-danger-fgColor-rest, var(--color-btn-danger-text, #e5534b))",
          "hoverText": "var(--button-danger-fgColor-hover, var(--color-btn-danger-hover-text, #cdd9e5))",
          "hoverBg": "var(--button-danger-bgColor-hover, var(--color-btn-danger-hover-bg, #c93c37))",
          "hoverBorder": "var(--button-danger-borderColor-hover, var(--color-btn-danger-hover-border, #e5534b))",
          "hoverIcon": "var(--button-danger-iconColor-hover, var(--color-btn-danger-hover-icon, #cdd9e5))",
          "hoverCounterBg": "var(--buttonCounter-danger-bgColor-hover, var(--color-btn-danger-hover-counter-bg, rgba(255,255,255,0.2)))",
          "selectedText": "var(--button-danger-fgColor-active, var(--color-btn-danger-selected-text, #ffffff))",
          "selectedBg": "var(--button-danger-bgColor-active, var(--color-btn-danger-selected-bg, #ad2e2c))",
          "selectedBorder": "var(--button-danger-borderColor-active, var(--color-btn-danger-selected-border, #f47067))",
          "disabledText": "var(--button-danger-fgColor-disabled, var(--color-btn-danger-disabled-text, rgba(229,83,75,0.5)))",
          "disabledBg": "var(--button-danger-bgColor-disabled, var(--color-btn-danger-disabled-bg, #22272e))",
          "disabledCounterBg": "var(--buttonCounter-danger-bgColor-disabled, var(--color-btn-danger-disabled-counter-bg, rgba(201,60,55,0.05)))",
          "counterBg": "var(--buttonCounter-danger-bgColor-rest, var(--color-btn-danger-counter-bg, rgba(93,15,18,0.2)))",
          "icon": "var(--button-danger-iconColor-rest, var(--color-btn-danger-icon, #e5534b))",
          "counterFg": "var(--buttonCounter-danger-fgColor-rest, var(--color-btn-danger-counter-fg, #e5534b))",
          "disabledCounterFg": "var(--buttonCounter-danger-fgColor-disabled, var(--color-btn-danger-disabled-counter-fg, rgba(229,83,75,0.5)))",
          "hoverCounterFg": "var(--buttonCounter-danger-fgColor-hover, var(--color-btn-danger-hover-counter-fg, #cdd9e5))"
        },
        "inactive": {
          "bg": "var(--button-inactive-bgColor-rest, var(--color-btn-inactive-bg, #373e47))",
          "text": "var(--button-inactive-fgColor-rest, var(--color-btn-inactive-text, #768390))"
        }
      },
      "underlinenav": {
        "icon": "var(--underlineNav-iconColor-rest, var(--color-underlinenav-icon, #636e7b))",
        "borderHover": "var(--underlineNav-borderColor-hover, var(--color-underlinenav-border-hover, rgba(99,110,123,0.4)))"
      },
      "actionListItem": {
        "inlineDivider": "var(--borderColor-muted, var(--color-action-list-item-inline-divider, rgba(68,76,86,0.48)))",
        "default": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-action-list-item-default-hover-bg, rgba(144,157,171,0.12)))",
          "hoverBorder": "var(--control-transparent-borderColor-hover, var(--color-action-list-item-default-hover-border, transparent))",
          "activeBg": "var(--control-transparent-bgColor-active, var(--color-action-list-item-default-active-bg, rgba(144,157,171,0.2)))",
          "activeBorder": "var(--control-transparent-borderColor-active, var(--color-action-list-item-default-active-border, transparent))",
          "selectedBg": "var(--control-transparent-bgColor-selected, var(--color-action-list-item-default-selected-bg, rgba(144,157,171,0.08)))"
        },
        "danger": {
          "hoverBg": "var(--control-danger-bgColor-hover, var(--color-action-list-item-danger-hover-bg, rgba(229,83,75,0.16)))",
          "activeBg": "var(--control-danger-bgColor-active, var(--color-action-list-item-danger-active-bg, rgba(229,83,75,0.24)))",
          "hoverText": "var(--control-danger-fgColor-hover, var(--color-action-list-item-danger-hover-text, #f47067))"
        }
      },
      "switchTrack": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-switch-track-bg, rgba(99,110,123,0.1)))",
        "hoverBg": "var(--controlTrack-bgColor-hover, var(--color-switch-track-hover-bg, hsla(213,11%,69%,0.1)))",
        "activeBg": "var(--controlTrack-bgColor-active, var(--color-switch-track-active-bg, rgba(99,110,123,0.4)))",
        "disabledBg": "var(--controlTrack-bgColor-disabled, var(--color-switch-track-disabled-bg, #373e47))",
        "fg": "var(--controlTrack-fgColor-rest, var(--color-switch-track-fg, #768390))",
        "disabledFg": "var(--controlTrack-fgColor-disabled, var(--color-switch-track-disabled-fg, #1c2128))",
        "border": "var(--controlTrack-borderColor-rest, var(--color-switch-track-border, transparent))",
        "checked": {
          "bg": "var(--control-checked-bgColor-rest, var(--color-switch-track-checked-bg, rgba(49,109,202,0.35)))",
          "hoverBg": "var(--control-checked-bgColor-hover, var(--color-switch-track-checked-hover-bg, rgba(49,109,202,0.5)))",
          "activeBg": "var(--control-checked-bgColor-active, var(--color-switch-track-checked-active-bg, rgba(49,109,202,0.65)))",
          "fg": "var(--control-checked-fgColor-rest, var(--color-switch-track-checked-fg, #cdd9e5))",
          "disabledFg": "var(--control-checked-fgColor-disabled, var(--color-switch-track-checked-disabled-fg, #1c2128))",
          "border": "var(--borderColor-transparent, var(--color-switch-track-checked-border, transparent))"
        }
      },
      "switchKnob": {
        "bg": "var(--controlKnob-bgColor-rest, var(--color-switch-knob-bg, #22272e))",
        "border": "var(--controlKnob-borderColor-rest, var(--color-switch-knob-border, #606771))",
        "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-disabled-bg, #2d333b))",
        "checked": {
          "bg": "var(--controlKnob-bgColor-checked, var(--color-switch-knob-checked-bg, #22272e))",
          "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-checked-disabled-bg, #2d333b))",
          "border": "var(--controlKnob-borderColor-checked, var(--color-switch-knob-checked-border, rgba(49,109,202,0.35)))"
        }
      },
      "segmentedControl": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-segmented-control-bg, rgba(99,110,123,0.1)))",
        "button": {
          "bg": "var(--controlKnob-bgColor-rest, var(--color-segmented-control-button-bg, #22272e))",
          "hover": {
            "bg": "var(--controlTrack-bgColor-hover, var(--color-segmented-control-button-hover-bg, #444c56))"
          },
          "active": {
            "bg": "var(--controlTrack-bgColor-active, var(--color-segmented-control-button-active-bg, #373e47))"
          },
          "selected": {
            "border": "var(--controlKnob-borderColor-rest, var(--color-segmented-control-button-selected-border, #636e7b))"
          }
        }
      },
      "treeViewItem": {
        "chevron": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-tree-view-item-chevron-hover-bg, rgba(144,157,171,0.12)))"
        },
        "directory": {
          "fill": "var(--treeViewItem-leadingVisual-iconColor-rest, var(--color-tree-view-item-directory-fill, #768390))"
        }
      },
      "fg": {
        "default": "var(--fgColor-default, var(--color-fg-default, #adbac7))",
        "muted": "var(--fgColor-muted, var(--color-fg-muted, #768390))",
        "subtle": "var(--fgColor-muted, var(--color-fg-subtle, #636e7b))",
        "onEmphasis": "var(--fgColor-onEmphasis, var(--color-fg-on-emphasis, #cdd9e5))"
      },
      "canvas": {
        "default": "var(--bgColor-default, var(--color-canvas-default, #22272e))",
        "overlay": "var(--overlay-bgColor, var(--color-canvas-overlay, #2d333b))",
        "inset": "var(--bgColor-inset, var(--color-canvas-inset, #1c2128))",
        "subtle": "var(--bgColor-muted, var(--color-canvas-subtle, #2d333b))"
      },
      "border": {
        "default": "var(--borderColor-default, var(--color-border-default, #444c56))",
        "muted": "var(--borderColor-muted, var(--color-border-muted, #373e47))",
        "subtle": "var(--borderColor-muted, var(--color-border-subtle, rgba(205,217,229,0.1)))"
      },
      "neutral": {
        "emphasisPlus": "var(--bgColor-emphasis, var(--color-neutral-emphasis-plus, #636e7b))",
        "emphasis": "var(--bgColor-neutral-emphasis, var(--color-neutral-emphasis, #636e7b))",
        "muted": "var(--bgColor-neutral-muted, var(--color-neutral-muted, rgba(99,110,123,0.4)))",
        "subtle": "var(--bgColor-neutral-muted, var(--color-neutral-subtle, rgba(99,110,123,0.1)))"
      },
      "accent": {
        "fg": "var(--fgColor-accent, var(--color-accent-fg, #539bf5))",
        "emphasis": "var(--bgColor-accent-emphasis, var(--color-accent-emphasis, #316dca))",
        "muted": "var(--borderColor-accent-muted, var(--color-accent-muted, rgba(65,132,228,0.4)))",
        "subtle": "var(--bgColor-accent-muted, var(--color-accent-subtle, rgba(65,132,228,0.1)))"
      },
      "success": {
        "fg": "var(--fgColor-success, var(--color-success-fg, #57ab5a))",
        "emphasis": "var(--bgColor-success-emphasis, var(--color-success-emphasis, #347d39))",
        "muted": "var(--borderColor-success-muted, var(--color-success-muted, rgba(70,149,74,0.4)))",
        "subtle": "var(--bgColor-success-muted, var(--color-success-subtle, rgba(70,149,74,0.15)))"
      },
      "attention": {
        "fg": "var(--fgColor-attention, var(--color-attention-fg, #c69026))",
        "emphasis": "var(--bgColor-attention-emphasis, var(--color-attention-emphasis, #966600))",
        "muted": "var(--borderColor-attention-muted, var(--color-attention-muted, rgba(174,124,20,0.4)))",
        "subtle": "var(--bgColor-attention-muted, var(--color-attention-subtle, rgba(174,124,20,0.15)))"
      },
      "severe": {
        "fg": "var(--fgColor-severe, var(--color-severe-fg, #cc6b2c))",
        "emphasis": "var(--bgColor-severe-emphasis, var(--color-severe-emphasis, #ae5622))",
        "muted": "var(--borderColor-severe-muted, var(--color-severe-muted, rgba(204,107,44,0.4)))",
        "subtle": "var(--bgColor-severe-muted, var(--color-severe-subtle, rgba(204,107,44,0.1)))"
      },
      "danger": {
        "fg": "var(--fgColor-danger, var(--color-danger-fg, #e5534b))",
        "emphasis": "var(--borderColor-danger-emphasis, var(--color-danger-emphasis, #c93c37))",
        "muted": "var(--borderColor-danger-muted, var(--color-danger-muted, rgba(229,83,75,0.4)))",
        "subtle": "var(--bgColor-danger-muted, var(--color-danger-subtle, rgba(229,83,75,0.1)))"
      },
      "open": {
        "fg": "var(--fgColor-open, var(--color-open-fg, #57ab5a))",
        "emphasis": "var(--bgColor-open-emphasis, var(--color-open-emphasis, #347d39))",
        "muted": "var(--borderColor-open-muted, var(--color-open-muted, rgba(70,149,74,0.4)))",
        "subtle": "var(--bgColor-open-muted, var(--color-open-subtle, rgba(70,149,74,0.15)))"
      },
      "closed": {
        "fg": "var(--fgColor-closed, var(--color-closed-fg, #e5534b))",
        "emphasis": "var(--bgColor-closed-emphasis, var(--color-closed-emphasis, #c93c37))",
        "muted": "var(--borderColor-closed-muted, var(--color-closed-muted, rgba(229,83,75,0.4)))",
        "subtle": "var(--bgColor-closed-muted, var(--color-closed-subtle, rgba(229,83,75,0.15)))"
      },
      "done": {
        "fg": "var(--fgColor-done, var(--color-done-fg, #986ee2))",
        "emphasis": "var(--bgColor-done-emphasis, var(--color-done-emphasis, #8256d0))",
        "muted": "var(--borderColor-done-muted, var(--color-done-muted, rgba(152,110,226,0.4)))",
        "subtle": "var(--bgColor-done-muted, var(--color-done-subtle, rgba(152,110,226,0.1)))"
      },
      "sponsors": {
        "fg": "var(--fgColor-sponsors, var(--color-sponsors-fg, #c96198))",
        "emphasis": "var(--bgColor-sponsors-emphasis, var(--color-sponsors-emphasis, #ae4c82))",
        "muted": "var(--borderColor-sponsors-muted, var(--color-sponsors-muted, rgba(201,97,152,0.4)))",
        "subtle": "var(--bgColor-sponsors-muted, var(--color-sponsors-subtle, rgba(201,97,152,0.1)))"
      },
      "primer": {
        "fg": {
          "disabled": "var(--fgColor-disabled, var(--color-primer-fg-disabled, #545d68))"
        },
        "canvas": {
          "backdrop": "var(--overlay-backdrop-bgColor, var(--color-primer-canvas-backdrop, rgba(28,33,40,0.8)))",
          "sticky": "var(--color-primer-canvas-sticky, rgba(34,39,46,0.95))"
        },
        "border": {
          "active": "var(--underlineNav-borderColor-active, var(--color-primer-border-active, #ec775c))",
          "contrast": "var(--borderColor-muted, var(--color-primer-border-contrast, rgba(205,217,229,0.2)))"
        }
      }
    },
    "shadows": {
      "checks": {
        "inputShadow": "var(--color-checks-input-shadow, 0 0 0 1px #444c56)"
      },
      "mktg": {
        "btn": {
          "shadow": {
            "outline": "var(--color-mktg-btn-shadow-outline, rgb(255 255 255 / 25%) 0 0 0 1px inset))",
            "focus": "var(--color-mktg-btn-shadow-focus, rgb(255 255 255 / 25%) 0 0 0 4px))",
            "hover": "var(--color-mktg-btn-shadow-hover, 0 4px 7px rgba(0, 0, 0, 0.15), 0 100px 80px rgba(255, 255, 255, 0.02), 0 42px 33px rgba(255, 255, 255, 0.024), 0 22px 18px rgba(255, 255, 255, 0.028), 0 12px 10px rgba(255, 255, 255, 0.034), 0 7px 5px rgba(255, 255, 255, 0.04), 0 3px 2px rgba(255, 255, 255, 0.07)))",
            "hoverMuted": "var(--color-mktg-btn-shadow-hover-muted, rgb(255 255 255) 0 0 0 2px inset))"
          }
        }
      },
      "avatar": {
        "childShadow": "var(--avatar-shadow, var(--color-avatar-child-shadow, 0 0 0 2px #22272e))"
      },
      "overlay": {
        "shadow": "var(--shadow-floating-small, var(--color-overlay-shadow, 0 0 0 1px #444c56, 0 16px 32px rgba(28,33,40,0.85)))"
      },
      "btn": {
        "shadow": "var(--button-default-shadow-resting, var(--color-btn-shadow, 0 0 transparent))",
        "insetShadow": "var(--button-default-shadow-inset, var(--color-btn-inset-shadow, 0 0 transparent))",
        "primary": {
          "shadow": "var(--shadow-resting-small, var(--color-btn-primary-shadow, 0 0 transparent))",
          "insetShadow": "var(--shadow-highlight, var(--color-btn-primary-inset-shadow, 0 0 transparent))",
          "selectedShadow": "var(--button-primary-shadow-selected, var(--color-btn-primary-selected-shadow, 0 0 transparent))"
        },
        "outline": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-outline-hover-shadow, 0 1px 0 rgba(28,33,40,0.1)))// HI_KATIE: no matches",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-outline-hover-inset-shadow, inset 0 1px 0 rgba(205,217,229,0.03)))// HI_KATIE: no matches",
          "selectedShadow": "var(--button-outline-shadow-selected, var(--color-btn-outline-selected-shadow, 0 0 transparent))"
        },
        "danger": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-danger-hover-shadow, 0 0 transparent))",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-danger-hover-inset-shadow, 0 0 transparent))",
          "selectedShadow": "var(--button-danger-shadow-selected, var(--color-btn-danger-selected-shadow, 0 0 transparent))"
        }
      },
      "shadow": {
        "small": "var(--shadow-resting-small, var(--color-shadow-small, 0 0 transparent))",
        "medium": "var(--shadow-resting-medium, var(--color-shadow-medium, 0 3px 6px #1c2128))",
        "large": "var(--shadow-floating-large, var(--color-shadow-large, 0 8px 24px #1c2128))",
        "extraLarge": "var(--shadow-floating-xlarge, var(--color-shadow-extra-large, 0 12px 48px #1c2128))"
      },
      "primer": {
        "shadow": {
          "highlight": "var(--shadow-highlight, var(--color-primer-shadow-highlight, 0 0 transparent))",
          "inset": "var(--shadow-inset, var(--color-primer-shadow-inset, 0 0 transparent))"
        }
      }
    }
  },
  "dark_high_contrast": {
    "colors": {
      "canvasDefaultTransparent": "var(--bgColor-transparent, var(--color-canvas-default-transparent, rgba(10,12,16,0)))",
      "pageHeaderBg": "var(--page-header-bgColor, var(--color-page-header-bg, #0a0c10))",
      "marketingIcon": {
        "primary": "var(--color-marketing-icon-primary, #91cbff)",
        "secondary": "var(--color-marketing-icon-secondary, #409eff)"
      },
      "diffBlob": {
        "addition": {
          "numText": "var(--diffBlob-addition-fgColor-num, var(--color-diff-blob-addition-num-text, #f0f3f6))",
          "fg": "var(--diffBlob-addition-fgColor-text, var(--color-diff-blob-addition-fg, #0a0c10))",
          "numBg": "var(--diffBlob-addition-bgColor-num, var(--color-diff-blob-addition-num-bg, rgba(38,205,77,0.3)))",
          "lineBg": "var(--diffBlob-addition-bgColor-line, var(--color-diff-blob-addition-line-bg, rgba(9,180,58,0.15)))",
          "wordBg": "var(--diffBlob-addition-bgColor-word, var(--color-diff-blob-addition-word-bg, #09b43a))"
        },
        "deletion": {
          "numText": "var(--diffBlob-deletion-fgColor-num, var(--color-diff-blob-deletion-num-text, #f0f3f6))",
          "fg": "var(--diffBlob-deletion-fgColor-text, var(--color-diff-blob-deletion-fg, #0a0c10))",
          "numBg": "var(--diffBlob-deletion-bgColor-num, var(--color-diff-blob-deletion-num-bg, rgba(255,106,105,0.3)))",
          "lineBg": "var(--diffBlob-deletion-bgColor-line, var(--color-diff-blob-deletion-line-bg, rgba(255,106,105,0.1)))",
          "wordBg": "var(--diffBlob-deletion-bgColor-word, var(--color-diff-blob-deletion-word-bg, #ff6a69))"
        },
        "hunk": {
          "numBg": "var(--diffBlob-hunk-bgColor-num, var(--color-diff-blob-hunk-num-bg, rgba(64,158,255,0.4)))"
        },
        "expander": {
          "icon": "var(--diffBlob-expander-iconColor, var(--color-diff-blob-expander-icon, #f0f3f6))"
        },
        "selectedLineHighlightMixBlendMode": "var(--color-diff-blob-selected-line-highlight-mix-blend-mode, screen)"
      },
      "diffstat": {
        "deletionBorder": "var(--color-diffstat-deletion-border, #ffb1af)",
        "additionBorder": "var(--color-diffstat-addition-border, #4ae168)",
        "additionBg": "var(--diffStat-addition-bgColor, var(--color-diffstat-addition-bg, #26cd4d))"
      },
      "searchKeyword": {
        "hl": "var(--highlight-neutral-bgColor, var(--color-search-keyword-hl, rgba(240,183,47,0.4)))"
      },
      "prettylights": {
        "syntax": {
          "comment": "var(--color-prettylights-syntax-comment, #bdc4cc)",
          "constant": "var(--color-prettylights-syntax-constant, #91cbff)",
          "entity": "var(--color-prettylights-syntax-entity, #dbb7ff)",
          "storageModifierImport": "var(--color-prettylights-syntax-storage-modifier-import, #f0f3f6)",
          "entityTag": "var(--color-prettylights-syntax-entity-tag, #72f088)",
          "keyword": "var(--color-prettylights-syntax-keyword, #ff9492)",
          "string": "var(--color-prettylights-syntax-string, #addcff)",
          "variable": "var(--color-prettylights-syntax-variable, #ffb757)",
          "brackethighlighterUnmatched": "var(--color-prettylights-syntax-brackethighlighter-unmatched, #ff6a69)",
          "invalidIllegalText": "var(--color-prettylights-syntax-invalid-illegal-text, #ffffff)",
          "invalidIllegalBg": "var(--color-prettylights-syntax-invalid-illegal-bg, #e82a2f)",
          "carriageReturnText": "var(--color-prettylights-syntax-carriage-return-text, #ffffff)",
          "carriageReturnBg": "var(--color-prettylights-syntax-carriage-return-bg, #ff4445)",
          "stringRegexp": "var(--color-prettylights-syntax-string-regexp, #72f088)",
          "markupList": "var(--color-prettylights-syntax-markup-list, #fbd669)",
          "markupHeading": "var(--color-prettylights-syntax-markup-heading, #409eff)",
          "markupItalic": "var(--color-prettylights-syntax-markup-italic, #f0f3f6)",
          "markupBold": "var(--color-prettylights-syntax-markup-bold, #f0f3f6)",
          "markupDeletedText": "var(--color-prettylights-syntax-markup-deleted-text, #ffdedb)",
          "markupDeletedBg": "var(--color-prettylights-syntax-markup-deleted-bg, #cc1421)",
          "markupInsertedText": "var(--color-prettylights-syntax-markup-inserted-text, #acf7b6)",
          "markupInsertedBg": "var(--color-prettylights-syntax-markup-inserted-bg, #007728)",
          "markupChangedText": "var(--color-prettylights-syntax-markup-changed-text, #ffe1b4)",
          "markupChangedBg": "var(--color-prettylights-syntax-markup-changed-bg, #a74c00)",
          "markupIgnoredText": "var(--color-prettylights-syntax-markup-ignored-text, #f0f3f6)",
          "markupIgnoredBg": "var(--color-prettylights-syntax-markup-ignored-bg, #318bf8)",
          "metaDiffRange": "var(--color-prettylights-syntax-meta-diff-range, #dbb7ff)",
          "brackethighlighterAngle": "var(--color-prettylights-syntax-brackethighlighter-angle, #bdc4cc)",
          "sublimelinterGutterMark": "var(--color-prettylights-syntax-sublimelinter-gutter-mark, #7a828e)",
          "constantOtherReferenceLink": "var(--color-prettylights-syntax-constant-other-reference-link, #addcff)"
        }
      },
      "codemirror": {
        "text": "var(--codeMirror-fgColor, var(--color-codemirror-text, #f0f3f6))",
        "bg": "var(--codeMirror-bgColor, var(--color-codemirror-bg, #0a0c10))",
        "guttersBg": "var(--codeMirror-gutters-bgColor, var(--color-codemirror-gutters-bg, #0a0c10))",
        "guttermarkerText": "var(--codeMirror-gutterMarker-fgColor-default, var(--color-codemirror-guttermarker-text, #0a0c10))",
        "guttermarkerSubtleText": "var(--codeMirror-gutterMarker-fgColor-muted, var(--color-codemirror-guttermarker-subtle-text, #9ea7b3))",
        "linenumberText": "var(--codeMirror-lineNumber-fgColor, var(--color-codemirror-linenumber-text, #f0f3f6))",
        "cursor": "var(--codeMirror-cursor-fgColor, var(--color-codemirror-cursor, #f0f3f6))",
        "selectionBg": "var(--codeMirror-selection-bgColor, var(--color-codemirror-selection-bg, rgba(64,158,255,0.4)))",
        "activelineBg": "var(--codeMirror-activeline-bgColor, var(--color-codemirror-activeline-bg, rgba(158,167,179,0.1)))",
        "matchingbracketText": "var(--codeMirror-matchingBracket-fgColor, var(--color-codemirror-matchingbracket-text, #f0f3f6))",
        "linesBg": "var(--codeMirror-lines-bgColor, var(--color-codemirror-lines-bg, #0a0c10))",
        "syntax": {
          "comment": "var(--codeMirror-syntax-fgColor-comment, var(--color-codemirror-syntax-comment, #bdc4cc))",
          "constant": "var(--codeMirror-syntax-fgColor-constant, var(--color-codemirror-syntax-constant, #91cbff))",
          "entity": "var(--codeMirror-syntax-fgColor-entity, var(--color-codemirror-syntax-entity, #dbb7ff))",
          "keyword": "var(--codeMirror-syntax-fgColor-keyword, var(--color-codemirror-syntax-keyword, #ff9492))",
          "storage": "var(--codeMirror-syntax-fgColor-storage, var(--color-codemirror-syntax-storage, #ff9492))",
          "string": "var(--codeMirror-syntax-fgColor-string, var(--color-codemirror-syntax-string, #addcff))",
          "support": "var(--codeMirror-syntax-fgColor-support, var(--color-codemirror-syntax-support, #91cbff))",
          "variable": "var(--codeMirror-syntax-fgColor-variable, var(--color-codemirror-syntax-variable, #ffb757))"
        }
      },
      "checks": {
        "bg": "var(--color-checks-bg, #010409)",
        "runBorderWidth": "var(--color-checks-run-border-width, 1px)",
        "containerBorderWidth": "var(--color-checks-container-border-width, 1px)",
        "textPrimary": "var(--color-checks-text-primary, #f0f3f6)",
        "textSecondary": "var(--color-checks-text-secondary, #f0f3f6)",
        "textLink": "var(--color-checks-text-link, #71b7ff)",
        "btnIcon": "var(--color-checks-btn-icon, #f0f3f6)",
        "btnHoverIcon": "var(--color-checks-btn-hover-icon, #f0f3f6)",
        "btnHoverBg": "var(--color-checks-btn-hover-bg, rgba(158,167,179,0.1))",
        "inputText": "var(--color-checks-input-text, #f0f3f6)",
        "inputPlaceholderText": "var(--color-checks-input-placeholder-text, #9ea7b3)",
        "inputFocusText": "var(--color-checks-input-focus-text, #f0f3f6)",
        "inputBg": "var(--color-checks-input-bg, #272b33)",
        "donutError": "var(--color-checks-donut-error, #ff6a69)",
        "donutPending": "var(--color-checks-donut-pending, #f0b72f)",
        "donutSuccess": "var(--color-checks-donut-success, #09b43a)",
        "donutNeutral": "var(--color-checks-donut-neutral, #bdc4cc)",
        "dropdownText": "var(--color-checks-dropdown-text, #f0f3f6)",
        "dropdownBg": "var(--color-checks-dropdown-bg, #272b33)",
        "dropdownBorder": "var(--color-checks-dropdown-border, #7a828e)",
        "dropdownShadow": "var(--color-checks-dropdown-shadow, rgba(1,4,9,0.3))",
        "dropdownHoverText": "var(--color-checks-dropdown-hover-text, #f0f3f6)",
        "dropdownHoverBg": "var(--color-checks-dropdown-hover-bg, rgba(158,167,179,0.1))",
        "dropdownBtnHoverText": "var(--color-checks-dropdown-btn-hover-text, #f0f3f6)",
        "dropdownBtnHoverBg": "var(--color-checks-dropdown-btn-hover-bg, rgba(158,167,179,0.1))",
        "scrollbarThumbBg": "var(--color-checks-scrollbar-thumb-bg, rgba(158,167,179,0.4))",
        "headerLabelText": "var(--color-checks-header-label-text, #f0f3f6)",
        "headerLabelOpenText": "var(--color-checks-header-label-open-text, #f0f3f6)",
        "headerBorder": "var(--color-checks-header-border, #7a828e)",
        "headerIcon": "var(--color-checks-header-icon, #f0f3f6)",
        "lineText": "var(--color-checks-line-text, #f0f3f6)",
        "lineNumText": "var(--color-checks-line-num-text, #9ea7b3)",
        "lineTimestampText": "var(--color-checks-line-timestamp-text, #9ea7b3)",
        "lineHoverBg": "var(--color-checks-line-hover-bg, rgba(158,167,179,0.1))",
        "lineSelectedBg": "var(--color-checks-line-selected-bg, rgba(64,158,255,0.1))",
        "lineSelectedNumText": "var(--color-checks-line-selected-num-text, #71b7ff)",
        "lineDtFmText": "var(--color-checks-line-dt-fm-text, #0a0c10)",
        "lineDtFmBg": "var(--color-checks-line-dt-fm-bg, #e09b13)",
        "gateBg": "var(--color-checks-gate-bg, rgba(224,155,19,0.15))",
        "gateText": "var(--color-checks-gate-text, #f0f3f6)",
        "gateWaitingText": "var(--color-checks-gate-waiting-text, #f0b72f)",
        "stepHeaderOpenBg": "var(--color-checks-step-header-open-bg, #272b33)",
        "stepErrorText": "var(--color-checks-step-error-text, #ff6a69)",
        "stepWarningText": "var(--color-checks-step-warning-text, #f0b72f)",
        "loglineText": "var(--color-checks-logline-text, #f0f3f6)",
        "loglineNumText": "var(--color-checks-logline-num-text, #9ea7b3)",
        "loglineDebugText": "var(--color-checks-logline-debug-text, #b780ff)",
        "loglineErrorText": "var(--color-checks-logline-error-text, #f0f3f6)",
        "loglineErrorNumText": "var(--color-checks-logline-error-num-text, #9ea7b3)",
        "loglineErrorBg": "var(--color-checks-logline-error-bg, rgba(255,106,105,0.1))",
        "loglineWarningText": "var(--color-checks-logline-warning-text, #f0f3f6)",
        "loglineWarningNumText": "var(--color-checks-logline-warning-num-text, #f0b72f)",
        "loglineWarningBg": "var(--color-checks-logline-warning-bg, rgba(224,155,19,0.15))",
        "loglineCommandText": "var(--color-checks-logline-command-text, #71b7ff)",
        "loglineSectionText": "var(--color-checks-logline-section-text, #26cd4d)",
        "ansi": {
          "black": "var(--color-checks-ansi-black, #0a0c10)",
          "blackBright": "var(--color-checks-ansi-black-bright, #272b33)",
          "white": "var(--color-checks-ansi-white, #d9dee3))",
          "whiteBright": "var(--color-checks-ansi-white-bright, #d9dee3)",
          "gray": "var(--color-checks-ansi-gray, #9ea7b3)",
          "red": "var(--color-checks-ansi-red, #ff9492)",
          "redBright": "var(--color-checks-ansi-red-bright, #ffb1af)",
          "green": "var(--color-checks-ansi-green, #26cd4d)",
          "greenBright": "var(--color-checks-ansi-green-bright, #4ae168)",
          "yellow": "var(--color-checks-ansi-yellow, #f0b72f)",
          "yellowBright": "var(--color-checks-ansi-yellow-bright, #f7c843)",
          "blue": "var(--color-checks-ansi-blue, #71b7ff)",
          "blueBright": "var(--color-checks-ansi-blue-bright, #91cbff)",
          "magenta": "var(--color-checks-ansi-magenta, #cb9eff)",
          "magentaBright": "var(--color-checks-ansi-magenta-bright, #dbb7ff)",
          "cyan": "var(--color-checks-ansi-cyan, #76e3ea)",
          "cyanBright": "var(--color-checks-ansi-cyan-bright, #b3f0ff)"
        }
      },
      "project": {
        "headerBg": "var(--color-project-header-bg, #0a0c10)",
        "sidebarBg": "var(--color-project-sidebar-bg, #272b33)",
        "gradientIn": "var(--color-project-gradient-in, #272b33)",
        "gradientOut": "var(--color-project-gradient-out, rgba(39,43,51,0))"
      },
      "mktg": {
        "btn": {
          "bg": "var(--color-mktg-btn-bg, #f6f8fa))"
        }
      },
      "control": {
        "borderColor": {
          "emphasis": "var(--control-borderColor-emphasis, var(--color-control-border-color-emphasis, #9ea7b3))"
        }
      },
      "avatar": {
        "bg": "var(--avatar-bgColor, var(--color-avatar-bg, rgba(255,255,255,0.1)))",
        "border": "var(--avatar-borderColor, var(--color-avatar-border, rgba(255,255,255,0.9)))",
        "stackFade": "var(--avatarStack-fade-bgColor-default, var(--color-avatar-stack-fade, #525964))",
        "stackFadeMore": "var(--avatarStack-fade-bgColor-muted, var(--color-avatar-stack-fade-more, #272b33))"
      },
      "topicTag": {
        "border": "var(--topicTag-borderColor, var(--color-topic-tag-border, #409eff))"
      },
      "counter": {
        "border": "var(--counter-borderColor, var(--color-counter-border, transparent))"
      },
      "selectMenu": {
        "backdropBorder": "var(--selectMenu-borderColor, var(--color-select-menu-backdrop-border, #7a828e))",
        "tapHighlight": "var(--control-bgColor-active, var(--color-select-menu-tap-highlight, rgba(82,89,100,0.5)))",
        "tapFocusBg": "var(--selectMenu-bgColor-active, var(--color-select-menu-tap-focus-bg, #1e60d5))"
      },
      "overlay": {
        "backdrop": "var(--overlay-backdrop-bgColor, var(--color-overlay-backdrop, rgba(39,43,51,0.4)))"
      },
      "header": {
        "text": "var(--header-fgColor-default, var(--color-header-text, rgba(255,255,255,0.7)))",
        "bg": "var(--header-bgColor, var(--color-header-bg, #272b33))",
        "divider": "var(--header-borderColor-divider, var(--color-header-divider, #bdc4cc))",
        "logo": "var(--header-fgColor-logo, var(--color-header-logo, #ffffff))"
      },
      "headerSearch": {
        "bg": "var(--headerSearch-bgColor, var(--color-header-search-bg, #0a0c10))",
        "border": "var(--headerSearch-borderColor, var(--color-header-search-border, #525964))"
      },
      "sidenav": {
        "selectedBg": "var(--sideNav-bgColor-selected, var(--color-sidenav-selected-bg, #272b33))"
      },
      "menu": {
        "bgActive": "var(--menu-bgColor-active, var(--color-menu-bg-active, #272b33))"
      },
      "input": {
        "disabledBg": "var(--control-bgColor-disabled, var(--color-input-disabled-bg, rgba(158,167,179,0)))"
      },
      "timeline": {
        "badgeBg": "var(--timelineBadge-bgColor, var(--color-timeline-badge-bg, #272b33))"
      },
      "ansi": {
        "black": "var(--color-ansi-black, #7a828e)",
        "blackBright": "var(--color-ansi-black-bright, #9ea7b3)",
        "white": "var(--color-ansi-white, #d9dee3)",
        "whiteBright": "var(--color-ansi-white-bright, #ffffff)",
        "gray": "var(--color-ansi-gray, #9ea7b3)",
        "red": "var(--color-ansi-red, #ff9492)",
        "redBright": "var(--color-ansi-red-bright, #ffb1af)",
        "green": "var(--color-ansi-green, #26cd4d)",
        "greenBright": "var(--color-ansi-green-bright, #4ae168)",
        "yellow": "var(--color-ansi-yellow, #f0b72f)",
        "yellowBright": "var(--color-ansi-yellow-bright, #f7c843)",
        "blue": "var(--color-ansi-blue, #71b7ff)",
        "blueBright": "var(--color-ansi-blue-bright, #91cbff)",
        "magenta": "var(--color-ansi-magenta, #cb9eff)",
        "magentaBright": "var(--color-ansi-magenta-bright, #dbb7ff)",
        "cyan": "var(--color-ansi-cyan, #39c5cf)",
        "cyanBright": "var(--color-ansi-cyan-bright, #56d4dd)"
      },
      "btn": {
        "text": "var(--button-default-fgColor-rest, var(--color-btn-text, #f0f3f6))",
        "bg": "var(--button-default-bgColor-rest, var(--color-btn-bg, #272b33))",
        "border": "var(--button-default-borderColor-rest, var(--color-btn-border, #7a828e))",
        "hoverBg": "var(--button-default-bgColor-hover, var(--color-btn-hover-bg, #525964))",
        "hoverBorder": "var(--button-default-borderColor-hover, var(--color-btn-hover-border, #bdc4cc))",
        "activeBg": "var(--button-default-bgColor-active, var(--color-btn-active-bg, hsla(217,10%,33%,1)))",
        "activeBorder": "var(--button-default-borderColor-active, var(--color-btn-active-border, #9ea7b3))",
        "selectedBg": "var(--button-default-bgColor-selected, var(--color-btn-selected-bg, rgba(82,89,100,0.9)))",
        "counterBg": "var(--buttonCounter-default-bgColor-rest, var(--color-btn-counter-bg, #525964))",
        "primary": {
          "text": "var(--button-primary-fgColor-rest, var(--color-btn-primary-text, #0a0c10))",
          "bg": "var(--button-primary-bgColor-rest, var(--color-btn-primary-bg, #09b43a))",
          "border": "var(--button-primary-borderColor-rest, var(--color-btn-primary-border, #4ae168))",
          "hoverBg": "var(--button-primary-bgColor-hover, var(--color-btn-primary-hover-bg, #26cd4d))",
          "hoverBorder": "var(--button-primary-borderColor-hover, var(--color-btn-primary-hover-border, #4ae168))",
          "selectedBg": "var(--button-primary-bgColor-active, var(--color-btn-primary-selected-bg, #09b43a))",
          "disabledText": "var(--button-primary-fgColor-disabled, var(--color-btn-primary-disabled-text, rgba(10,12,16,0.5)))",
          "disabledBg": "var(--button-primary-bgColor-disabled, var(--color-btn-primary-disabled-bg, rgba(9,180,58,0.6)))",
          "disabledBorder": "var(--button-primary-borderColor-disabled, var(--color-btn-primary-disabled-border, rgba(74,225,104,0.4)))",
          "icon": "var(--button-primary-iconColor-rest, var(--color-btn-primary-icon, #0a0c10))",
          "counterBg": "var(--buttonCounter-primary-bgColor-rest, var(--color-btn-primary-counter-bg, rgba(1,4,9,0.15)))"
        },
        "outline": {
          "text": "var(--button-outline-fgColor-rest, var(--color-btn-outline-text, #409eff))",
          "hoverText": "var(--button-outline-fgColor-hover, var(--color-btn-outline-hover-text, #71b7ff))",
          "hoverBg": "var(--button-outline-bgColor-hover, var(--color-btn-outline-hover-bg, #525964))",
          "hoverBorder": "var(--button-outline-borderColor-hover, var(--color-btn-outline-hover-border, #7a828e))",
          "hoverCounterBg": "var(--buttonCounter-outline-bgColor-hover, var(--color-btn-outline-hover-counter-bg, rgba(25,79,177,0.2)))",
          "selectedText": "var(--button-outline-fgColor-active, var(--color-btn-outline-selected-text, #ffffff))",
          "selectedBg": "var(--button-outline-bgColor-active, var(--color-btn-outline-selected-bg, #2672f3))",
          "selectedBorder": "var(--button-outline-borderColor-active, var(--color-btn-outline-selected-border, #7a828e))",
          "disabledText": "var(--button-outline-fgColor-disabled, var(--color-btn-outline-disabled-text, rgba(113,183,255,0.5)))",
          "disabledBg": "var(--button-outline-bgColor-disabled, var(--color-btn-outline-disabled-bg, #0a0c10))",
          "disabledCounterBg": "var(--buttonCounter-outline-bgColor-disabled, var(--color-btn-outline-disabled-counter-bg, rgba(64,158,255,0.05)))",
          "counterBg": "var(--buttonCounter-outline-bgColor-rest, var(--color-btn-outline-counter-bg, rgba(25,79,177,0.2)))",
          "hoverCounterFg": "var(--buttonCounter-outline-fgColor-hover, var(--color-btn-outline-hover-counter-fg, #71b7ff))",
          "disabledCounterFg": "var(--buttonCounter-outline-fgColor-disabled, var(--color-btn-outline-disabled-counter-fg, rgba(113,183,255,0.5)))",
          "counterFg": "var(--buttonCounter-outline-fgColor-rest, var(--color-btn-outline-counter-fg, #409eff))"
        },
        "danger": {
          "text": "var(--button-danger-fgColor-rest, var(--color-btn-danger-text, #ff6a69))",
          "hoverText": "var(--button-danger-fgColor-hover, var(--color-btn-danger-hover-text, #0a0c10))",
          "hoverBg": "var(--button-danger-bgColor-hover, var(--color-btn-danger-hover-bg, #ff6a69))",
          "hoverBorder": "var(--button-danger-borderColor-hover, var(--color-btn-danger-hover-border, #ff6a69))",
          "hoverIcon": "var(--button-danger-iconColor-hover, var(--color-btn-danger-hover-icon, #0a0c10))",
          "hoverCounterBg": "var(--buttonCounter-danger-bgColor-hover, var(--color-btn-danger-hover-counter-bg, rgba(1,4,9,0.15)))",
          "selectedText": "var(--button-danger-fgColor-active, var(--color-btn-danger-selected-text, #ffffff))",
          "selectedBg": "var(--button-danger-bgColor-active, var(--color-btn-danger-selected-bg, #ff4445))",
          "selectedBorder": "var(--button-danger-borderColor-active, var(--color-btn-danger-selected-border, #ff9492))",
          "disabledText": "var(--button-danger-fgColor-disabled, var(--color-btn-danger-disabled-text, rgba(255,106,105,0.5)))",
          "disabledBg": "var(--button-danger-bgColor-disabled, var(--color-btn-danger-disabled-bg, #0a0c10))",
          "disabledCounterBg": "var(--buttonCounter-danger-bgColor-disabled, var(--color-btn-danger-disabled-counter-bg, rgba(255,106,105,0.05)))",
          "counterBg": "var(--buttonCounter-danger-bgColor-rest, var(--color-btn-danger-counter-bg, rgba(1,4,9,0.15)))",
          "icon": "var(--button-danger-iconColor-rest, var(--color-btn-danger-icon, #ff6a69))",
          "counterFg": "var(--buttonCounter-danger-fgColor-rest, var(--color-btn-danger-counter-fg, #ff6a69))",
          "disabledCounterFg": "var(--buttonCounter-danger-fgColor-disabled, var(--color-btn-danger-disabled-counter-fg, rgba(255,106,105,0.5)))",
          "hoverCounterFg": "var(--buttonCounter-danger-fgColor-hover, var(--color-btn-danger-hover-counter-fg, #ffffff))"
        },
        "inactive": {
          "bg": "var(--button-inactive-bgColor-rest, var(--color-btn-inactive-bg, #272b33))",
          "text": "var(--button-inactive-fgColor-rest, var(--color-btn-inactive-text, #bdc4cc))"
        }
      },
      "underlinenav": {
        "icon": "var(--underlineNav-iconColor-rest, var(--color-underlinenav-icon, #f0f3f6))",
        "borderHover": "var(--underlineNav-borderColor-hover, var(--color-underlinenav-border-hover, #bdc4cc))"
      },
      "actionListItem": {
        "inlineDivider": "var(--borderColor-muted, var(--color-action-list-item-inline-divider, #7a828e))",
        "default": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-action-list-item-default-hover-bg, #272b33))",
          "hoverBorder": "var(--control-transparent-borderColor-hover, var(--color-action-list-item-default-hover-border, #7a828e))",
          "activeBg": "var(--control-transparent-bgColor-active, var(--color-action-list-item-default-active-bg, #525964))",
          "activeBorder": "var(--control-transparent-borderColor-active, var(--color-action-list-item-default-active-border, #9ea7b3))",
          "selectedBg": "var(--control-transparent-bgColor-selected, var(--color-action-list-item-default-selected-bg, #525964))"
        },
        "danger": {
          "hoverBg": "var(--control-danger-bgColor-hover, var(--color-action-list-item-danger-hover-bg, #ff6a69))",
          "activeBg": "var(--control-danger-bgColor-active, var(--color-action-list-item-danger-active-bg, #ff4445))",
          "hoverText": "var(--control-danger-fgColor-hover, var(--color-action-list-item-danger-hover-text, #0a0c10))"
        }
      },
      "switchTrack": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-switch-track-bg, #9ea7b3))",
        "hoverBg": "var(--controlTrack-bgColor-hover, var(--color-switch-track-hover-bg, hsla(214,12%,61%,1)))",
        "activeBg": "var(--controlTrack-bgColor-active, var(--color-switch-track-active-bg, hsla(214,12%,58%,1)))",
        "disabledBg": "var(--controlTrack-bgColor-disabled, var(--color-switch-track-disabled-bg, #272b33))",
        "fg": "var(--controlTrack-fgColor-rest, var(--color-switch-track-fg, #0a0c10))",
        "disabledFg": "var(--controlTrack-fgColor-disabled, var(--color-switch-track-disabled-fg, #010409))",
        "border": "var(--controlTrack-borderColor-rest, var(--color-switch-track-border, transparent))",
        "checked": {
          "bg": "var(--control-checked-bgColor-rest, var(--color-switch-track-checked-bg, #409eff))",
          "hoverBg": "var(--control-checked-bgColor-hover, var(--color-switch-track-checked-hover-bg, rgba(64,158,255,0.5)))",
          "activeBg": "var(--control-checked-bgColor-active, var(--color-switch-track-checked-active-bg, rgba(64,158,255,0.65)))",
          "fg": "var(--control-checked-fgColor-rest, var(--color-switch-track-checked-fg, #0a0c10))",
          "disabledFg": "var(--control-checked-fgColor-disabled, var(--color-switch-track-checked-disabled-fg, #010409))",
          "border": "var(--borderColor-transparent, var(--color-switch-track-checked-border, transparent))"
        }
      },
      "switchKnob": {
        "bg": "var(--controlKnob-bgColor-rest, var(--color-switch-knob-bg, #0a0c10))",
        "border": "var(--controlKnob-borderColor-rest, var(--color-switch-knob-border, #9ea7b3))",
        "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-disabled-bg, #272b33))",
        "checked": {
          "bg": "var(--controlKnob-bgColor-checked, var(--color-switch-knob-checked-bg, #0a0c10))",
          "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-checked-disabled-bg, #272b33))",
          "border": "var(--controlKnob-borderColor-checked, var(--color-switch-knob-checked-border, #409eff))"
        }
      },
      "segmentedControl": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-segmented-control-bg, rgba(158,167,179,0.1)))",
        "button": {
          "bg": "var(--controlKnob-bgColor-rest, var(--color-segmented-control-button-bg, #0a0c10))",
          "hover": {
            "bg": "var(--controlTrack-bgColor-hover, var(--color-segmented-control-button-hover-bg, #525964))"
          },
          "active": {
            "bg": "var(--controlTrack-bgColor-active, var(--color-segmented-control-button-active-bg, #272b33))"
          },
          "selected": {
            "border": "var(--controlKnob-borderColor-rest, var(--color-segmented-control-button-selected-border, #9ea7b3))"
          }
        }
      },
      "treeViewItem": {
        "chevron": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-tree-view-item-chevron-hover-bg, #525964))"
        },
        "directory": {
          "fill": "var(--treeViewItem-leadingVisual-iconColor-rest, var(--color-tree-view-item-directory-fill, #f0f3f6))"
        }
      },
      "fg": {
        "default": "var(--fgColor-default, var(--color-fg-default, #f0f3f6))",
        "muted": "var(--fgColor-muted, var(--color-fg-muted, #f0f3f6))",
        "subtle": "var(--fgColor-muted, var(--color-fg-subtle, #9ea7b3))",
        "onEmphasis": "var(--fgColor-onEmphasis, var(--color-fg-on-emphasis, #0a0c10))"
      },
      "canvas": {
        "default": "var(--bgColor-default, var(--color-canvas-default, #0a0c10))",
        "overlay": "var(--overlay-bgColor, var(--color-canvas-overlay, #272b33))",
        "inset": "var(--bgColor-inset, var(--color-canvas-inset, #010409))",
        "subtle": "var(--bgColor-muted, var(--color-canvas-subtle, #272b33))"
      },
      "border": {
        "default": "var(--borderColor-default, var(--color-border-default, #7a828e))",
        "muted": "var(--borderColor-muted, var(--color-border-muted, #7a828e))",
        "subtle": "var(--borderColor-muted, var(--color-border-subtle, #7a828e))"
      },
      "neutral": {
        "emphasisPlus": "var(--bgColor-emphasis, var(--color-neutral-emphasis-plus, #ffffff))",
        "emphasis": "var(--bgColor-neutral-emphasis, var(--color-neutral-emphasis, #9ea7b3))",
        "muted": "var(--bgColor-neutral-muted, var(--color-neutral-muted, rgba(158,167,179,0.4)))",
        "subtle": "var(--bgColor-neutral-muted, var(--color-neutral-subtle, rgba(158,167,179,0.1)))"
      },
      "accent": {
        "fg": "var(--fgColor-accent, var(--color-accent-fg, #71b7ff))",
        "emphasis": "var(--bgColor-accent-emphasis, var(--color-accent-emphasis, #409eff))",
        "muted": "var(--borderColor-accent-muted, var(--color-accent-muted, #409eff))",
        "subtle": "var(--bgColor-accent-muted, var(--color-accent-subtle, rgba(64,158,255,0.1)))"
      },
      "success": {
        "fg": "var(--fgColor-success, var(--color-success-fg, #26cd4d))",
        "emphasis": "var(--bgColor-success-emphasis, var(--color-success-emphasis, #09b43a))",
        "muted": "var(--borderColor-success-muted, var(--color-success-muted, #09b43a))",
        "subtle": "var(--bgColor-success-muted, var(--color-success-subtle, rgba(9,180,58,0.15)))"
      },
      "attention": {
        "fg": "var(--fgColor-attention, var(--color-attention-fg, #f0b72f))",
        "emphasis": "var(--bgColor-attention-emphasis, var(--color-attention-emphasis, #e09b13))",
        "muted": "var(--borderColor-attention-muted, var(--color-attention-muted, #e09b13))",
        "subtle": "var(--bgColor-attention-muted, var(--color-attention-subtle, rgba(224,155,19,0.15)))"
      },
      "severe": {
        "fg": "var(--fgColor-severe, var(--color-severe-fg, #e7811d))",
        "emphasis": "var(--bgColor-severe-emphasis, var(--color-severe-emphasis, #e7811d))",
        "muted": "var(--borderColor-severe-muted, var(--color-severe-muted, #e7811d))",
        "subtle": "var(--bgColor-severe-muted, var(--color-severe-subtle, rgba(231,129,29,0.1)))"
      },
      "danger": {
        "fg": "var(--fgColor-danger, var(--color-danger-fg, #ff6a69))",
        "emphasis": "var(--borderColor-danger-emphasis, var(--color-danger-emphasis, #ff6a69))",
        "muted": "var(--borderColor-danger-muted, var(--color-danger-muted, #ff6a69))",
        "subtle": "var(--bgColor-danger-muted, var(--color-danger-subtle, rgba(255,106,105,0.1)))"
      },
      "open": {
        "fg": "var(--fgColor-open, var(--color-open-fg, #26cd4d))",
        "emphasis": "var(--bgColor-open-emphasis, var(--color-open-emphasis, #09b43a))",
        "muted": "var(--borderColor-open-muted, var(--color-open-muted, rgba(9,180,58,0.4)))",
        "subtle": "var(--bgColor-open-muted, var(--color-open-subtle, rgba(9,180,58,0.15)))"
      },
      "closed": {
        "fg": "var(--fgColor-closed, var(--color-closed-fg, #ff6a69))",
        "emphasis": "var(--bgColor-closed-emphasis, var(--color-closed-emphasis, #ff6a69))",
        "muted": "var(--borderColor-closed-muted, var(--color-closed-muted, rgba(255,106,105,0.4)))",
        "subtle": "var(--bgColor-closed-muted, var(--color-closed-subtle, rgba(255,106,105,0.15)))"
      },
      "done": {
        "fg": "var(--fgColor-done, var(--color-done-fg, #b780ff))",
        "emphasis": "var(--bgColor-done-emphasis, var(--color-done-emphasis, #b87fff))",
        "muted": "var(--borderColor-done-muted, var(--color-done-muted, #b780ff))",
        "subtle": "var(--bgColor-done-muted, var(--color-done-subtle, rgba(183,128,255,0.1)))"
      },
      "sponsors": {
        "fg": "var(--fgColor-sponsors, var(--color-sponsors-fg, #ef6eb1))",
        "emphasis": "var(--bgColor-sponsors-emphasis, var(--color-sponsors-emphasis, #ef6eb1))",
        "muted": "var(--borderColor-sponsors-muted, var(--color-sponsors-muted, #ef6eb1))",
        "subtle": "var(--bgColor-sponsors-muted, var(--color-sponsors-subtle, rgba(239,110,177,0.1)))"
      },
      "primer": {
        "fg": {
          "disabled": "var(--fgColor-disabled, var(--color-primer-fg-disabled, #7a828e))"
        },
        "canvas": {
          "backdrop": "var(--overlay-backdrop-bgColor, var(--color-primer-canvas-backdrop, rgba(1,4,9,0.8)))",
          "sticky": "var(--color-primer-canvas-sticky, rgba(10,12,16,0.95))"
        },
        "border": {
          "active": "var(--underlineNav-borderColor-active, var(--color-primer-border-active, #ff967d))",
          "contrast": "var(--borderColor-muted, var(--color-primer-border-contrast, rgba(255,255,255,0.2)))"
        }
      }
    },
    "shadows": {
      "checks": {
        "inputShadow": "var(--color-checks-input-shadow, 0 0 0 1px #7a828e)"
      },
      "mktg": {
        "btn": {
          "shadow": {
            "outline": "var(--color-mktg-btn-shadow-outline, rgb(255 255 255 / 25%) 0 0 0 1px inset))",
            "focus": "var(--color-mktg-btn-shadow-focus, rgb(255 255 255 / 25%) 0 0 0 4px))",
            "hover": "var(--color-mktg-btn-shadow-hover, 0 4px 7px rgba(0, 0, 0, 0.15), 0 100px 80px rgba(255, 255, 255, 0.02), 0 42px 33px rgba(255, 255, 255, 0.024), 0 22px 18px rgba(255, 255, 255, 0.028), 0 12px 10px rgba(255, 255, 255, 0.034), 0 7px 5px rgba(255, 255, 255, 0.04), 0 3px 2px rgba(255, 255, 255, 0.07)))",
            "hoverMuted": "var(--color-mktg-btn-shadow-hover-muted, rgb(255 255 255) 0 0 0 2px inset))"
          }
        }
      },
      "avatar": {
        "childShadow": "var(--avatar-shadow, var(--color-avatar-child-shadow, 0 0 0 2px #0a0c10))"
      },
      "overlay": {
        "shadow": "var(--shadow-floating-small, var(--color-overlay-shadow, 0 0 0 1px #525964, 0 16px 32px rgba(1,4,9,0.85)))"
      },
      "btn": {
        "shadow": "var(--button-default-shadow-resting, var(--color-btn-shadow, 0 0 transparent))",
        "insetShadow": "var(--button-default-shadow-inset, var(--color-btn-inset-shadow, 0 0 transparent))",
        "primary": {
          "shadow": "var(--shadow-resting-small, var(--color-btn-primary-shadow, 0 0 transparent))",
          "insetShadow": "var(--shadow-highlight, var(--color-btn-primary-inset-shadow, 0 0 transparent))",
          "selectedShadow": "var(--button-primary-shadow-selected, var(--color-btn-primary-selected-shadow, 0 0 transparent))"
        },
        "outline": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-outline-hover-shadow, 0 1px 0 rgba(1,4,9,0.1)))// HI_KATIE: no matches",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-outline-hover-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.03)))// HI_KATIE: no matches",
          "selectedShadow": "var(--button-outline-shadow-selected, var(--color-btn-outline-selected-shadow, 0 0 transparent))"
        },
        "danger": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-danger-hover-shadow, 0 0 transparent))",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-danger-hover-inset-shadow, 0 0 transparent))",
          "selectedShadow": "var(--button-danger-shadow-selected, var(--color-btn-danger-selected-shadow, 0 0 transparent))"
        }
      },
      "shadow": {
        "small": "var(--shadow-resting-small, var(--color-shadow-small, 0 0 transparent))",
        "medium": "var(--shadow-resting-medium, var(--color-shadow-medium, 0 3px 6px #010409))",
        "large": "var(--shadow-floating-large, var(--color-shadow-large, 0 8px 24px #010409))",
        "extraLarge": "var(--shadow-floating-xlarge, var(--color-shadow-extra-large, 0 12px 48px #010409))"
      },
      "primer": {
        "shadow": {
          "highlight": "var(--shadow-highlight, var(--color-primer-shadow-highlight, 0 0 transparent))",
          "inset": "var(--shadow-inset, var(--color-primer-shadow-inset, 0 0 transparent))"
        }
      }
    }
  },
  "dark_colorblind": {
    "colors": {
      "canvasDefaultTransparent": "var(--bgColor-transparent, var(--color-canvas-default-transparent, rgba(13,17,23,0)))",
      "pageHeaderBg": "var(--page-header-bgColor, var(--color-page-header-bg, #0d1117))",
      "marketingIcon": {
        "primary": "var(--color-marketing-icon-primary, #79c0ff)",
        "secondary": "var(--color-marketing-icon-secondary, #1f6feb)"
      },
      "diffBlob": {
        "addition": {
          "numText": "var(--diffBlob-addition-fgColor-num, var(--color-diff-blob-addition-num-text, #c9d1d9))",
          "fg": "var(--diffBlob-addition-fgColor-text, var(--color-diff-blob-addition-fg, #c9d1d9))",
          "numBg": "var(--diffBlob-addition-bgColor-num, var(--color-diff-blob-addition-num-bg, rgba(88,166,255,0.3)))",
          "lineBg": "var(--diffBlob-addition-bgColor-line, var(--color-diff-blob-addition-line-bg, rgba(56,139,253,0.15)))",
          "wordBg": "var(--diffBlob-addition-bgColor-word, var(--color-diff-blob-addition-word-bg, rgba(56,139,253,0.4)))"
        },
        "deletion": {
          "numText": "var(--diffBlob-deletion-fgColor-num, var(--color-diff-blob-deletion-num-text, #c9d1d9))",
          "fg": "var(--diffBlob-deletion-fgColor-text, var(--color-diff-blob-deletion-fg, #c9d1d9))",
          "numBg": "var(--diffBlob-deletion-bgColor-num, var(--color-diff-blob-deletion-num-bg, rgba(212,118,22,0.3)))",
          "lineBg": "var(--diffBlob-deletion-bgColor-line, var(--color-diff-blob-deletion-line-bg, rgba(212,118,22,0.1)))",
          "wordBg": "var(--diffBlob-deletion-bgColor-word, var(--color-diff-blob-deletion-word-bg, rgba(212,118,22,0.4)))"
        },
        "hunk": {
          "numBg": "var(--diffBlob-hunk-bgColor-num, var(--color-diff-blob-hunk-num-bg, rgba(56,139,253,0.4)))"
        },
        "expander": {
          "icon": "var(--diffBlob-expander-iconColor, var(--color-diff-blob-expander-icon, #8b949e))"
        },
        "selectedLineHighlightMixBlendMode": "var(--color-diff-blob-selected-line-highlight-mix-blend-mode, screen)"
      },
      "diffstat": {
        "deletionBorder": "var(--color-diffstat-deletion-border, rgba(240,246,252,0.1))",
        "additionBorder": "var(--color-diffstat-addition-border, rgba(240,246,252,0.1))",
        "additionBg": "var(--diffStat-addition-bgColor, var(--color-diffstat-addition-bg, #58a6ff))"
      },
      "searchKeyword": {
        "hl": "var(--highlight-neutral-bgColor, var(--color-search-keyword-hl, rgba(210,153,34,0.4)))"
      },
      "prettylights": {
        "syntax": {
          "comment": "var(--color-prettylights-syntax-comment, #8b949e)",
          "constant": "var(--color-prettylights-syntax-constant, #79c0ff)",
          "entity": "var(--color-prettylights-syntax-entity, #d2a8ff)",
          "storageModifierImport": "var(--color-prettylights-syntax-storage-modifier-import, #c9d1d9)",
          "entityTag": "var(--color-prettylights-syntax-entity-tag, #a5d6ff)",
          "keyword": "var(--color-prettylights-syntax-keyword, #ec8e2c)",
          "string": "var(--color-prettylights-syntax-string, #a5d6ff)",
          "variable": "var(--color-prettylights-syntax-variable, #fdac54)",
          "brackethighlighterUnmatched": "var(--color-prettylights-syntax-brackethighlighter-unmatched, #d47616)",
          "invalidIllegalText": "var(--color-prettylights-syntax-invalid-illegal-text, #f0f6fc)",
          "invalidIllegalBg": "var(--color-prettylights-syntax-invalid-illegal-bg, #6c3906)",
          "carriageReturnText": "var(--color-prettylights-syntax-carriage-return-text, #f0f6fc)",
          "carriageReturnBg": "var(--color-prettylights-syntax-carriage-return-bg, #914d04)",
          "stringRegexp": "var(--color-prettylights-syntax-string-regexp, #a5d6ff)",
          "markupList": "var(--color-prettylights-syntax-markup-list, #f2cc60)",
          "markupHeading": "var(--color-prettylights-syntax-markup-heading, #1f6feb)",
          "markupItalic": "var(--color-prettylights-syntax-markup-italic, #c9d1d9)",
          "markupBold": "var(--color-prettylights-syntax-markup-bold, #c9d1d9)",
          "markupDeletedText": "var(--color-prettylights-syntax-markup-deleted-text, #ffe2bb)",
          "markupDeletedBg": "var(--color-prettylights-syntax-markup-deleted-bg, #4e2906)",
          "markupInsertedText": "var(--color-prettylights-syntax-markup-inserted-text, #cae8ff)",
          "markupInsertedBg": "var(--color-prettylights-syntax-markup-inserted-bg, #0c2d6b)",
          "markupChangedText": "var(--color-prettylights-syntax-markup-changed-text, #ffe2bb)",
          "markupChangedBg": "var(--color-prettylights-syntax-markup-changed-bg, #4e2906)",
          "markupIgnoredText": "var(--color-prettylights-syntax-markup-ignored-text, #c9d1d9)",
          "markupIgnoredBg": "var(--color-prettylights-syntax-markup-ignored-bg, #1158c7)",
          "metaDiffRange": "var(--color-prettylights-syntax-meta-diff-range, #d2a8ff)",
          "brackethighlighterAngle": "var(--color-prettylights-syntax-brackethighlighter-angle, #8b949e)",
          "sublimelinterGutterMark": "var(--color-prettylights-syntax-sublimelinter-gutter-mark, #484f58)",
          "constantOtherReferenceLink": "var(--color-prettylights-syntax-constant-other-reference-link, #a5d6ff)"
        }
      },
      "codemirror": {
        "text": "var(--codeMirror-fgColor, var(--color-codemirror-text, #c9d1d9))",
        "bg": "var(--codeMirror-bgColor, var(--color-codemirror-bg, #0d1117))",
        "guttersBg": "var(--codeMirror-gutters-bgColor, var(--color-codemirror-gutters-bg, #0d1117))",
        "guttermarkerText": "var(--codeMirror-gutterMarker-fgColor-default, var(--color-codemirror-guttermarker-text, #0d1117))",
        "guttermarkerSubtleText": "var(--codeMirror-gutterMarker-fgColor-muted, var(--color-codemirror-guttermarker-subtle-text, #6e7681))",
        "linenumberText": "var(--codeMirror-lineNumber-fgColor, var(--color-codemirror-linenumber-text, #8b949e))",
        "cursor": "var(--codeMirror-cursor-fgColor, var(--color-codemirror-cursor, #c9d1d9))",
        "selectionBg": "var(--codeMirror-selection-bgColor, var(--color-codemirror-selection-bg, rgba(56,139,253,0.4)))",
        "activelineBg": "var(--codeMirror-activeline-bgColor, var(--color-codemirror-activeline-bg, rgba(110,118,129,0.1)))",
        "matchingbracketText": "var(--codeMirror-matchingBracket-fgColor, var(--color-codemirror-matchingbracket-text, #c9d1d9))",
        "linesBg": "var(--codeMirror-lines-bgColor, var(--color-codemirror-lines-bg, #0d1117))",
        "syntax": {
          "comment": "var(--codeMirror-syntax-fgColor-comment, var(--color-codemirror-syntax-comment, #8b949e))",
          "constant": "var(--codeMirror-syntax-fgColor-constant, var(--color-codemirror-syntax-constant, #79c0ff))",
          "entity": "var(--codeMirror-syntax-fgColor-entity, var(--color-codemirror-syntax-entity, #d2a8ff))",
          "keyword": "var(--codeMirror-syntax-fgColor-keyword, var(--color-codemirror-syntax-keyword, #ec8e2c))",
          "storage": "var(--codeMirror-syntax-fgColor-storage, var(--color-codemirror-syntax-storage, #ec8e2c))",
          "string": "var(--codeMirror-syntax-fgColor-string, var(--color-codemirror-syntax-string, #a5d6ff))",
          "support": "var(--codeMirror-syntax-fgColor-support, var(--color-codemirror-syntax-support, #79c0ff))",
          "variable": "var(--codeMirror-syntax-fgColor-variable, var(--color-codemirror-syntax-variable, #fdac54))"
        }
      },
      "checks": {
        "bg": "var(--color-checks-bg, #010409)",
        "runBorderWidth": "var(--color-checks-run-border-width, 1px)",
        "containerBorderWidth": "var(--color-checks-container-border-width, 1px)",
        "textPrimary": "var(--color-checks-text-primary, #c9d1d9)",
        "textSecondary": "var(--color-checks-text-secondary, #8b949e)",
        "textLink": "var(--color-checks-text-link, #58a6ff)",
        "btnIcon": "var(--color-checks-btn-icon, #8b949e)",
        "btnHoverIcon": "var(--color-checks-btn-hover-icon, #c9d1d9)",
        "btnHoverBg": "var(--color-checks-btn-hover-bg, rgba(110,118,129,0.1))",
        "inputText": "var(--color-checks-input-text, #8b949e)",
        "inputPlaceholderText": "var(--color-checks-input-placeholder-text, #6e7681)",
        "inputFocusText": "var(--color-checks-input-focus-text, #c9d1d9)",
        "inputBg": "var(--color-checks-input-bg, #161b22)",
        "donutError": "var(--color-checks-donut-error, #d47616)",
        "donutPending": "var(--color-checks-donut-pending, #d29922)",
        "donutSuccess": "var(--color-checks-donut-success, #388bfd)",
        "donutNeutral": "var(--color-checks-donut-neutral, #8b949e)",
        "dropdownText": "var(--color-checks-dropdown-text, #c9d1d9)",
        "dropdownBg": "var(--color-checks-dropdown-bg, #161b22)",
        "dropdownBorder": "var(--color-checks-dropdown-border, #30363d)",
        "dropdownShadow": "var(--color-checks-dropdown-shadow, rgba(1,4,9,0.3))",
        "dropdownHoverText": "var(--color-checks-dropdown-hover-text, #c9d1d9)",
        "dropdownHoverBg": "var(--color-checks-dropdown-hover-bg, rgba(110,118,129,0.1))",
        "dropdownBtnHoverText": "var(--color-checks-dropdown-btn-hover-text, #c9d1d9)",
        "dropdownBtnHoverBg": "var(--color-checks-dropdown-btn-hover-bg, rgba(110,118,129,0.1))",
        "scrollbarThumbBg": "var(--color-checks-scrollbar-thumb-bg, rgba(110,118,129,0.4))",
        "headerLabelText": "var(--color-checks-header-label-text, #8b949e)",
        "headerLabelOpenText": "var(--color-checks-header-label-open-text, #c9d1d9)",
        "headerBorder": "var(--color-checks-header-border, #21262d)",
        "headerIcon": "var(--color-checks-header-icon, #8b949e)",
        "lineText": "var(--color-checks-line-text, #8b949e)",
        "lineNumText": "var(--color-checks-line-num-text, #6e7681)",
        "lineTimestampText": "var(--color-checks-line-timestamp-text, #6e7681)",
        "lineHoverBg": "var(--color-checks-line-hover-bg, rgba(110,118,129,0.1))",
        "lineSelectedBg": "var(--color-checks-line-selected-bg, rgba(56,139,253,0.1))",
        "lineSelectedNumText": "var(--color-checks-line-selected-num-text, #58a6ff)",
        "lineDtFmText": "var(--color-checks-line-dt-fm-text, #ffffff)",
        "lineDtFmBg": "var(--color-checks-line-dt-fm-bg, #9e6a03)",
        "gateBg": "var(--color-checks-gate-bg, rgba(187,128,9,0.15))",
        "gateText": "var(--color-checks-gate-text, #8b949e)",
        "gateWaitingText": "var(--color-checks-gate-waiting-text, #d29922)",
        "stepHeaderOpenBg": "var(--color-checks-step-header-open-bg, #161b22)",
        "stepErrorText": "var(--color-checks-step-error-text, #d47616)",
        "stepWarningText": "var(--color-checks-step-warning-text, #d29922)",
        "loglineText": "var(--color-checks-logline-text, #8b949e)",
        "loglineNumText": "var(--color-checks-logline-num-text, #6e7681)",
        "loglineDebugText": "var(--color-checks-logline-debug-text, #a371f7)",
        "loglineErrorText": "var(--color-checks-logline-error-text, #8b949e)",
        "loglineErrorNumText": "var(--color-checks-logline-error-num-text, #6e7681)",
        "loglineErrorBg": "var(--color-checks-logline-error-bg, rgba(212,118,22,0.1))",
        "loglineWarningText": "var(--color-checks-logline-warning-text, #8b949e)",
        "loglineWarningNumText": "var(--color-checks-logline-warning-num-text, #d29922)",
        "loglineWarningBg": "var(--color-checks-logline-warning-bg, rgba(187,128,9,0.15))",
        "loglineCommandText": "var(--color-checks-logline-command-text, #58a6ff)",
        "loglineSectionText": "var(--color-checks-logline-section-text, #58a6ff)",
        "ansi": {
          "black": "var(--color-checks-ansi-black, #0d1117)",
          "blackBright": "var(--color-checks-ansi-black-bright, #161b22)",
          "white": "var(--color-checks-ansi-white, #b1bac4))",
          "whiteBright": "var(--color-checks-ansi-white-bright, #b1bac4)",
          "gray": "var(--color-checks-ansi-gray, #6e7681)",
          "red": "var(--color-checks-ansi-red, #ec8e2c)",
          "redBright": "var(--color-checks-ansi-red-bright, #fdac54)",
          "green": "var(--color-checks-ansi-green, #58a6ff)",
          "greenBright": "var(--color-checks-ansi-green-bright, #79c0ff)",
          "yellow": "var(--color-checks-ansi-yellow, #d29922)",
          "yellowBright": "var(--color-checks-ansi-yellow-bright, #e3b341)",
          "blue": "var(--color-checks-ansi-blue, #58a6ff)",
          "blueBright": "var(--color-checks-ansi-blue-bright, #79c0ff)",
          "magenta": "var(--color-checks-ansi-magenta, #bc8cff)",
          "magentaBright": "var(--color-checks-ansi-magenta-bright, #d2a8ff)",
          "cyan": "var(--color-checks-ansi-cyan, #76e3ea)",
          "cyanBright": "var(--color-checks-ansi-cyan-bright, #b3f0ff)"
        }
      },
      "project": {
        "headerBg": "var(--color-project-header-bg, #0d1117)",
        "sidebarBg": "var(--color-project-sidebar-bg, #161b22)",
        "gradientIn": "var(--color-project-gradient-in, #161b22)",
        "gradientOut": "var(--color-project-gradient-out, rgba(22,27,34,0))"
      },
      "mktg": {
        "btn": {
          "bg": "var(--color-mktg-btn-bg, #f6f8fa))"
        }
      },
      "control": {
        "borderColor": {
          "emphasis": "var(--control-borderColor-emphasis, var(--color-control-border-color-emphasis, #606771))"
        }
      },
      "avatar": {
        "bg": "var(--avatar-bgColor, var(--color-avatar-bg, rgba(255,255,255,0.1)))",
        "border": "var(--avatar-borderColor, var(--color-avatar-border, rgba(240,246,252,0.1)))",
        "stackFade": "var(--avatarStack-fade-bgColor-default, var(--color-avatar-stack-fade, #30363d))",
        "stackFadeMore": "var(--avatarStack-fade-bgColor-muted, var(--color-avatar-stack-fade-more, #21262d))"
      },
      "topicTag": {
        "border": "var(--topicTag-borderColor, var(--color-topic-tag-border, transparent))"
      },
      "counter": {
        "border": "var(--counter-borderColor, var(--color-counter-border, transparent))"
      },
      "selectMenu": {
        "backdropBorder": "var(--selectMenu-borderColor, var(--color-select-menu-backdrop-border, #484f58))",
        "tapHighlight": "var(--control-bgColor-active, var(--color-select-menu-tap-highlight, rgba(48,54,61,0.5)))",
        "tapFocusBg": "var(--selectMenu-bgColor-active, var(--color-select-menu-tap-focus-bg, #0c2d6b))"
      },
      "overlay": {
        "backdrop": "var(--overlay-backdrop-bgColor, var(--color-overlay-backdrop, rgba(22,27,34,0.4)))"
      },
      "header": {
        "text": "var(--header-fgColor-default, var(--color-header-text, rgba(255,255,255,0.7)))",
        "bg": "var(--header-bgColor, var(--color-header-bg, #161b22))",
        "divider": "var(--header-borderColor-divider, var(--color-header-divider, #8b949e))",
        "logo": "var(--header-fgColor-logo, var(--color-header-logo, #f0f6fc))"
      },
      "headerSearch": {
        "bg": "var(--headerSearch-bgColor, var(--color-header-search-bg, #0d1117))",
        "border": "var(--headerSearch-borderColor, var(--color-header-search-border, #30363d))"
      },
      "sidenav": {
        "selectedBg": "var(--sideNav-bgColor-selected, var(--color-sidenav-selected-bg, #21262d))"
      },
      "menu": {
        "bgActive": "var(--menu-bgColor-active, var(--color-menu-bg-active, #161b22))"
      },
      "input": {
        "disabledBg": "var(--control-bgColor-disabled, var(--color-input-disabled-bg, rgba(110,118,129,0)))"
      },
      "timeline": {
        "badgeBg": "var(--timelineBadge-bgColor, var(--color-timeline-badge-bg, #21262d))"
      },
      "ansi": {
        "black": "var(--color-ansi-black, #484f58)",
        "blackBright": "var(--color-ansi-black-bright, #6e7681)",
        "white": "var(--color-ansi-white, #b1bac4)",
        "whiteBright": "var(--color-ansi-white-bright, #ffffff)",
        "gray": "var(--color-ansi-gray, #6e7681)",
        "red": "var(--color-ansi-red, #ec8e2c)",
        "redBright": "var(--color-ansi-red-bright, #fdac54)",
        "green": "var(--color-ansi-green, #58a6ff)",
        "greenBright": "var(--color-ansi-green-bright, #79c0ff)",
        "yellow": "var(--color-ansi-yellow, #d29922)",
        "yellowBright": "var(--color-ansi-yellow-bright, #e3b341)",
        "blue": "var(--color-ansi-blue, #58a6ff)",
        "blueBright": "var(--color-ansi-blue-bright, #79c0ff)",
        "magenta": "var(--color-ansi-magenta, #bc8cff)",
        "magentaBright": "var(--color-ansi-magenta-bright, #d2a8ff)",
        "cyan": "var(--color-ansi-cyan, #39c5cf)",
        "cyanBright": "var(--color-ansi-cyan-bright, #56d4dd)"
      },
      "btn": {
        "text": "var(--button-default-fgColor-rest, var(--color-btn-text, #c9d1d9))",
        "bg": "var(--button-default-bgColor-rest, var(--color-btn-bg, #21262d))",
        "border": "var(--button-default-borderColor-rest, var(--color-btn-border, rgba(240,246,252,0.1)))",
        "hoverBg": "var(--button-default-bgColor-hover, var(--color-btn-hover-bg, #30363d))",
        "hoverBorder": "var(--button-default-borderColor-hover, var(--color-btn-hover-border, #8b949e))",
        "activeBg": "var(--button-default-bgColor-active, var(--color-btn-active-bg, hsla(212,12%,18%,1)))",
        "activeBorder": "var(--button-default-borderColor-active, var(--color-btn-active-border, #6e7681))",
        "selectedBg": "var(--button-default-bgColor-selected, var(--color-btn-selected-bg, #161b22))",
        "counterBg": "var(--buttonCounter-default-bgColor-rest, var(--color-btn-counter-bg, #30363d))",
        "primary": {
          "text": "var(--button-primary-fgColor-rest, var(--color-btn-primary-text, #ffffff))",
          "bg": "var(--button-primary-bgColor-rest, var(--color-btn-primary-bg, #1f6feb))",
          "border": "var(--button-primary-borderColor-rest, var(--color-btn-primary-border, rgba(240,246,252,0.1)))",
          "hoverBg": "var(--button-primary-bgColor-hover, var(--color-btn-primary-hover-bg, #388bfd))",
          "hoverBorder": "var(--button-primary-borderColor-hover, var(--color-btn-primary-hover-border, rgba(240,246,252,0.1)))",
          "selectedBg": "var(--button-primary-bgColor-active, var(--color-btn-primary-selected-bg, #1f6feb))",
          "disabledText": "var(--button-primary-fgColor-disabled, var(--color-btn-primary-disabled-text, rgba(255,255,255,0.5)))",
          "disabledBg": "var(--button-primary-bgColor-disabled, var(--color-btn-primary-disabled-bg, rgba(31,111,235,0.6)))",
          "disabledBorder": "var(--button-primary-borderColor-disabled, var(--color-btn-primary-disabled-border, rgba(240,246,252,0.1)))",
          "icon": "var(--button-primary-iconColor-rest, var(--color-btn-primary-icon, #ffffff))",
          "counterBg": "var(--buttonCounter-primary-bgColor-rest, var(--color-btn-primary-counter-bg, rgba(5,29,77,0.2)))"
        },
        "outline": {
          "text": "var(--button-outline-fgColor-rest, var(--color-btn-outline-text, #388bfd))",
          "hoverText": "var(--button-outline-fgColor-hover, var(--color-btn-outline-hover-text, #58a6ff))",
          "hoverBg": "var(--button-outline-bgColor-hover, var(--color-btn-outline-hover-bg, #30363d))",
          "hoverBorder": "var(--button-outline-borderColor-hover, var(--color-btn-outline-hover-border, rgba(240,246,252,0.1)))",
          "hoverCounterBg": "var(--buttonCounter-outline-bgColor-hover, var(--color-btn-outline-hover-counter-bg, rgba(5,29,77,0.2)))",
          "selectedText": "var(--button-outline-fgColor-active, var(--color-btn-outline-selected-text, #ffffff))",
          "selectedBg": "var(--button-outline-bgColor-active, var(--color-btn-outline-selected-bg, #0d419d))",
          "selectedBorder": "var(--button-outline-borderColor-active, var(--color-btn-outline-selected-border, rgba(240,246,252,0.1)))",
          "disabledText": "var(--button-outline-fgColor-disabled, var(--color-btn-outline-disabled-text, rgba(88,166,255,0.5)))",
          "disabledBg": "var(--button-outline-bgColor-disabled, var(--color-btn-outline-disabled-bg, #0d1117))",
          "disabledCounterBg": "var(--buttonCounter-outline-bgColor-disabled, var(--color-btn-outline-disabled-counter-bg, rgba(31,111,235,0.05)))",
          "counterBg": "var(--buttonCounter-outline-bgColor-rest, var(--color-btn-outline-counter-bg, rgba(5,29,77,0.2)))",
          "hoverCounterFg": "var(--buttonCounter-outline-fgColor-hover, var(--color-btn-outline-hover-counter-fg, #58a6ff))",
          "disabledCounterFg": "var(--buttonCounter-outline-fgColor-disabled, var(--color-btn-outline-disabled-counter-fg, rgba(88,166,255,0.5)))",
          "counterFg": "var(--buttonCounter-outline-fgColor-rest, var(--color-btn-outline-counter-fg, #388bfd))"
        },
        "danger": {
          "text": "var(--button-danger-fgColor-rest, var(--color-btn-danger-text, #d47616))",
          "hoverText": "var(--button-danger-fgColor-hover, var(--color-btn-danger-hover-text, #ffffff))",
          "hoverBg": "var(--button-danger-bgColor-hover, var(--color-btn-danger-hover-bg, #b76100))",
          "hoverBorder": "var(--button-danger-borderColor-hover, var(--color-btn-danger-hover-border, #d47616))",
          "hoverIcon": "var(--button-danger-iconColor-hover, var(--color-btn-danger-hover-icon, #ffffff))",
          "hoverCounterBg": "var(--buttonCounter-danger-bgColor-hover, var(--color-btn-danger-hover-counter-bg, rgba(255,255,255,0.2)))",
          "selectedText": "var(--button-danger-fgColor-active, var(--color-btn-danger-selected-text, #ffffff))",
          "selectedBg": "var(--button-danger-bgColor-active, var(--color-btn-danger-selected-bg, #914d04))",
          "selectedBorder": "var(--button-danger-borderColor-active, var(--color-btn-danger-selected-border, #ec8e2c))",
          "disabledText": "var(--button-danger-fgColor-disabled, var(--color-btn-danger-disabled-text, rgba(212,118,22,0.5)))",
          "disabledBg": "var(--button-danger-bgColor-disabled, var(--color-btn-danger-disabled-bg, #0d1117))",
          "disabledCounterBg": "var(--buttonCounter-danger-bgColor-disabled, var(--color-btn-danger-disabled-counter-bg, rgba(183,97,0,0.05)))",
          "counterBg": "var(--buttonCounter-danger-bgColor-rest, var(--color-btn-danger-counter-bg, rgba(51,28,4,0.2)))",
          "icon": "var(--button-danger-iconColor-rest, var(--color-btn-danger-icon, #d47616))",
          "counterFg": "var(--buttonCounter-danger-fgColor-rest, var(--color-btn-danger-counter-fg, #d47616))",
          "disabledCounterFg": "var(--buttonCounter-danger-fgColor-disabled, var(--color-btn-danger-disabled-counter-fg, rgba(212,118,22,0.5)))",
          "hoverCounterFg": "var(--buttonCounter-danger-fgColor-hover, var(--color-btn-danger-hover-counter-fg, #ffffff))"
        },
        "inactive": {
          "bg": "var(--button-inactive-bgColor-rest, var(--color-btn-inactive-bg, #21262d))",
          "text": "var(--button-inactive-fgColor-rest, var(--color-btn-inactive-text, #8b949e))"
        }
      },
      "underlinenav": {
        "icon": "var(--underlineNav-iconColor-rest, var(--color-underlinenav-icon, #6e7681))",
        "borderHover": "var(--underlineNav-borderColor-hover, var(--color-underlinenav-border-hover, rgba(110,118,129,0.4)))"
      },
      "actionListItem": {
        "inlineDivider": "var(--borderColor-muted, var(--color-action-list-item-inline-divider, rgba(48,54,61,0.48)))",
        "default": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-action-list-item-default-hover-bg, rgba(177,186,196,0.12)))",
          "hoverBorder": "var(--control-transparent-borderColor-hover, var(--color-action-list-item-default-hover-border, transparent))",
          "activeBg": "var(--control-transparent-bgColor-active, var(--color-action-list-item-default-active-bg, rgba(177,186,196,0.2)))",
          "activeBorder": "var(--control-transparent-borderColor-active, var(--color-action-list-item-default-active-border, transparent))",
          "selectedBg": "var(--control-transparent-bgColor-selected, var(--color-action-list-item-default-selected-bg, rgba(177,186,196,0.08)))"
        },
        "danger": {
          "hoverBg": "var(--control-danger-bgColor-hover, var(--color-action-list-item-danger-hover-bg, rgba(212,118,22,0.16)))",
          "activeBg": "var(--control-danger-bgColor-active, var(--color-action-list-item-danger-active-bg, rgba(212,118,22,0.24)))",
          "hoverText": "var(--control-danger-fgColor-hover, var(--color-action-list-item-danger-hover-text, #ec8e2c))"
        }
      },
      "switchTrack": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-switch-track-bg, rgba(110,118,129,0.1)))",
        "hoverBg": "var(--controlTrack-bgColor-hover, var(--color-switch-track-hover-bg, hsla(215,8%,72%,0.1)))",
        "activeBg": "var(--controlTrack-bgColor-active, var(--color-switch-track-active-bg, rgba(110,118,129,0.4)))",
        "disabledBg": "var(--controlTrack-bgColor-disabled, var(--color-switch-track-disabled-bg, #21262d))",
        "fg": "var(--controlTrack-fgColor-rest, var(--color-switch-track-fg, #8b949e))",
        "disabledFg": "var(--controlTrack-fgColor-disabled, var(--color-switch-track-disabled-fg, #010409))",
        "border": "var(--controlTrack-borderColor-rest, var(--color-switch-track-border, transparent))",
        "checked": {
          "bg": "var(--control-checked-bgColor-rest, var(--color-switch-track-checked-bg, rgba(31,111,235,0.35)))",
          "hoverBg": "var(--control-checked-bgColor-hover, var(--color-switch-track-checked-hover-bg, rgba(31,111,235,0.5)))",
          "activeBg": "var(--control-checked-bgColor-active, var(--color-switch-track-checked-active-bg, rgba(31,111,235,0.65)))",
          "fg": "var(--control-checked-fgColor-rest, var(--color-switch-track-checked-fg, #ffffff))",
          "disabledFg": "var(--control-checked-fgColor-disabled, var(--color-switch-track-checked-disabled-fg, #010409))",
          "border": "var(--borderColor-transparent, var(--color-switch-track-checked-border, transparent))"
        }
      },
      "switchKnob": {
        "bg": "var(--controlKnob-bgColor-rest, var(--color-switch-knob-bg, #0d1117))",
        "border": "var(--controlKnob-borderColor-rest, var(--color-switch-knob-border, #606771))",
        "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-disabled-bg, #161b22))",
        "checked": {
          "bg": "var(--controlKnob-bgColor-checked, var(--color-switch-knob-checked-bg, #0d1117))",
          "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-checked-disabled-bg, #161b22))",
          "border": "var(--controlKnob-borderColor-checked, var(--color-switch-knob-checked-border, rgba(31,111,235,0.35)))"
        }
      },
      "segmentedControl": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-segmented-control-bg, rgba(110,118,129,0.1)))",
        "button": {
          "bg": "var(--controlKnob-bgColor-rest, var(--color-segmented-control-button-bg, #0d1117))",
          "hover": {
            "bg": "var(--controlTrack-bgColor-hover, var(--color-segmented-control-button-hover-bg, #30363d))"
          },
          "active": {
            "bg": "var(--controlTrack-bgColor-active, var(--color-segmented-control-button-active-bg, #21262d))"
          },
          "selected": {
            "border": "var(--controlKnob-borderColor-rest, var(--color-segmented-control-button-selected-border, #6e7681))"
          }
        }
      },
      "treeViewItem": {
        "chevron": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-tree-view-item-chevron-hover-bg, rgba(177,186,196,0.12)))"
        },
        "directory": {
          "fill": "var(--treeViewItem-leadingVisual-iconColor-rest, var(--color-tree-view-item-directory-fill, #8b949e))"
        }
      },
      "fg": {
        "default": "var(--fgColor-default, var(--color-fg-default, #c9d1d9))",
        "muted": "var(--fgColor-muted, var(--color-fg-muted, #8b949e))",
        "subtle": "var(--fgColor-muted, var(--color-fg-subtle, #6e7681))",
        "onEmphasis": "var(--fgColor-onEmphasis, var(--color-fg-on-emphasis, #ffffff))"
      },
      "canvas": {
        "default": "var(--bgColor-default, var(--color-canvas-default, #0d1117))",
        "overlay": "var(--overlay-bgColor, var(--color-canvas-overlay, #161b22))",
        "inset": "var(--bgColor-inset, var(--color-canvas-inset, #010409))",
        "subtle": "var(--bgColor-muted, var(--color-canvas-subtle, #161b22))"
      },
      "border": {
        "default": "var(--borderColor-default, var(--color-border-default, #30363d))",
        "muted": "var(--borderColor-muted, var(--color-border-muted, #21262d))",
        "subtle": "var(--borderColor-muted, var(--color-border-subtle, rgba(240,246,252,0.1)))"
      },
      "neutral": {
        "emphasisPlus": "var(--bgColor-emphasis, var(--color-neutral-emphasis-plus, #6e7681))",
        "emphasis": "var(--bgColor-neutral-emphasis, var(--color-neutral-emphasis, #6e7681))",
        "muted": "var(--bgColor-neutral-muted, var(--color-neutral-muted, rgba(110,118,129,0.4)))",
        "subtle": "var(--bgColor-neutral-muted, var(--color-neutral-subtle, rgba(110,118,129,0.1)))"
      },
      "accent": {
        "fg": "var(--fgColor-accent, var(--color-accent-fg, #58a6ff))",
        "emphasis": "var(--bgColor-accent-emphasis, var(--color-accent-emphasis, #1f6feb))",
        "muted": "var(--borderColor-accent-muted, var(--color-accent-muted, rgba(56,139,253,0.4)))",
        "subtle": "var(--bgColor-accent-muted, var(--color-accent-subtle, rgba(56,139,253,0.1)))"
      },
      "success": {
        "fg": "var(--fgColor-success, var(--color-success-fg, #58a6ff))",
        "emphasis": "var(--bgColor-success-emphasis, var(--color-success-emphasis, #1f6feb))",
        "muted": "var(--borderColor-success-muted, var(--color-success-muted, rgba(56,139,253,0.4)))",
        "subtle": "var(--bgColor-success-muted, var(--color-success-subtle, rgba(56,139,253,0.15)))"
      },
      "attention": {
        "fg": "var(--fgColor-attention, var(--color-attention-fg, #d29922))",
        "emphasis": "var(--bgColor-attention-emphasis, var(--color-attention-emphasis, #9e6a03))",
        "muted": "var(--borderColor-attention-muted, var(--color-attention-muted, rgba(187,128,9,0.4)))",
        "subtle": "var(--bgColor-attention-muted, var(--color-attention-subtle, rgba(187,128,9,0.15)))"
      },
      "severe": {
        "fg": "var(--fgColor-severe, var(--color-severe-fg, #d47616))",
        "emphasis": "var(--bgColor-severe-emphasis, var(--color-severe-emphasis, #b76100))",
        "muted": "var(--borderColor-severe-muted, var(--color-severe-muted, rgba(212,118,22,0.4)))",
        "subtle": "var(--bgColor-severe-muted, var(--color-severe-subtle, rgba(212,118,22,0.1)))"
      },
      "danger": {
        "fg": "var(--fgColor-danger, var(--color-danger-fg, #d47616))",
        "emphasis": "var(--borderColor-danger-emphasis, var(--color-danger-emphasis, #b76100))",
        "muted": "var(--borderColor-danger-muted, var(--color-danger-muted, rgba(212,118,22,0.4)))",
        "subtle": "var(--bgColor-danger-muted, var(--color-danger-subtle, rgba(212,118,22,0.1)))"
      },
      "open": {
        "fg": "var(--fgColor-open, var(--color-open-fg, #ec8e2c))",
        "emphasis": "var(--borderColor-open-emphasis, var(--color-open-emphasis, #b76100))",
        "muted": "var(--borderColor-open-muted, var(--color-open-muted, rgba(212,118,22,0.4)))",
        "subtle": "var(--bgColor-open-muted, var(--color-open-subtle, rgba(212,118,22,0.15)))"
      },
      "closed": {
        "fg": "var(--fgColor-closed, var(--color-open-fg, #8b949e))",
        "emphasis": "var(--borderColor-closed-emphasis, var(--color-closed-emphasis, #6e7681))",
        "muted": "var(--borderColor-closed-muted, var(--color-closed-muted, rgba(110,118,129,0.4)))",
        "subtle": "var(--bgColor-closed-muted, var(--color-closed-subtle, rgba(110,118,129,0.1)))"
      },
      "done": {
        "fg": "var(--fgColor-done, var(--color-done-fg, #a371f7))",
        "emphasis": "var(--bgColor-done-emphasis, var(--color-done-emphasis, #8957e5))",
        "muted": "var(--borderColor-done-muted, var(--color-done-muted, rgba(163,113,247,0.4)))",
        "subtle": "var(--bgColor-done-muted, var(--color-done-subtle, rgba(163,113,247,0.1)))"
      },
      "sponsors": {
        "fg": "var(--fgColor-sponsors, var(--color-sponsors-fg, #db61a2))",
        "emphasis": "var(--bgColor-sponsors-emphasis, var(--color-sponsors-emphasis, #bf4b8a))",
        "muted": "var(--borderColor-sponsors-muted, var(--color-sponsors-muted, rgba(219,97,162,0.4)))",
        "subtle": "var(--bgColor-sponsors-muted, var(--color-sponsors-subtle, rgba(219,97,162,0.1)))"
      },
      "primer": {
        "fg": {
          "disabled": "var(--fgColor-disabled, var(--color-primer-fg-disabled, #484f58))"
        },
        "canvas": {
          "backdrop": "var(--overlay-backdrop-bgColor, var(--color-primer-canvas-backdrop, rgba(1,4,9,0.8)))",
          "sticky": "var(--color-primer-canvas-sticky, rgba(13,17,23,0.95))"
        },
        "border": {
          "active": "var(--underlineNav-borderColor-active, var(--color-primer-border-active, #f78166))",
          "contrast": "var(--borderColor-muted, var(--color-primer-border-contrast, rgba(255,255,255,0.2)))"
        }
      }
    },
    "shadows": {
      "checks": {
        "inputShadow": "var(--color-checks-input-shadow, 0 0 0 1px #30363d)"
      },
      "mktg": {
        "btn": {
          "shadow": {
            "outline": "var(--color-mktg-btn-shadow-outline, rgb(255 255 255 / 25%) 0 0 0 1px inset))",
            "focus": "var(--color-mktg-btn-shadow-focus, rgb(255 255 255 / 25%) 0 0 0 4px))",
            "hover": "var(--color-mktg-btn-shadow-hover, 0 4px 7px rgba(0, 0, 0, 0.15), 0 100px 80px rgba(255, 255, 255, 0.02), 0 42px 33px rgba(255, 255, 255, 0.024), 0 22px 18px rgba(255, 255, 255, 0.028), 0 12px 10px rgba(255, 255, 255, 0.034), 0 7px 5px rgba(255, 255, 255, 0.04), 0 3px 2px rgba(255, 255, 255, 0.07)))",
            "hoverMuted": "var(--color-mktg-btn-shadow-hover-muted, rgb(255 255 255) 0 0 0 2px inset))"
          }
        }
      },
      "avatar": {
        "childShadow": "var(--avatar-shadow, var(--color-avatar-child-shadow, 0 0 0 2px #0d1117))"
      },
      "overlay": {
        "shadow": "var(--shadow-floating-small, var(--color-overlay-shadow, 0 0 0 1px #30363d, 0 16px 32px rgba(1,4,9,0.85)))"
      },
      "btn": {
        "shadow": "var(--button-default-shadow-resting, var(--color-btn-shadow, 0 0 transparent))",
        "insetShadow": "var(--button-default-shadow-inset, var(--color-btn-inset-shadow, 0 0 transparent))",
        "primary": {
          "shadow": "var(--shadow-resting-small, var(--color-btn-primary-shadow, 0 0 transparent))",
          "insetShadow": "var(--shadow-highlight, var(--color-btn-primary-inset-shadow, 0 0 transparent))",
          "selectedShadow": "var(--button-primary-shadow-selected, var(--color-btn-primary-selected-shadow, 0 0 transparent))"
        },
        "outline": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-outline-hover-shadow, 0 1px 0 rgba(1,4,9,0.1)))// HI_KATIE: no matches",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-outline-hover-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.03)))// HI_KATIE: no matches",
          "selectedShadow": "var(--button-outline-shadow-selected, var(--color-btn-outline-selected-shadow, 0 0 transparent))"
        },
        "danger": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-danger-hover-shadow, 0 0 transparent))",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-danger-hover-inset-shadow, 0 0 transparent))",
          "selectedShadow": "var(--button-danger-shadow-selected, var(--color-btn-danger-selected-shadow, 0 0 transparent))"
        }
      },
      "shadow": {
        "small": "var(--shadow-resting-small, var(--color-shadow-small, 0 0 transparent))",
        "medium": "var(--shadow-resting-medium, var(--color-shadow-medium, 0 3px 6px #010409))",
        "large": "var(--shadow-floating-large, var(--color-shadow-large, 0 8px 24px #010409))",
        "extraLarge": "var(--shadow-floating-xlarge, var(--color-shadow-extra-large, 0 12px 48px #010409))"
      },
      "primer": {
        "shadow": {
          "highlight": "var(--shadow-highlight, var(--color-primer-shadow-highlight, 0 0 transparent))",
          "inset": "var(--shadow-inset, var(--color-primer-shadow-inset, 0 0 transparent))"
        }
      }
    }
  },
  "dark_tritanopia": {
    "colors": {
      "canvasDefaultTransparent": "var(--bgColor-transparent, var(--color-canvas-default-transparent, rgba(13,17,23,0)))",
      "pageHeaderBg": "var(--page-header-bgColor, var(--color-page-header-bg, #0d1117))",
      "marketingIcon": {
        "primary": "var(--color-marketing-icon-primary, #79c0ff)",
        "secondary": "var(--color-marketing-icon-secondary, #1f6feb)"
      },
      "diffBlob": {
        "addition": {
          "numText": "var(--diffBlob-addition-fgColor-num, var(--color-diff-blob-addition-num-text, #c9d1d9))",
          "fg": "var(--diffBlob-addition-fgColor-text, var(--color-diff-blob-addition-fg, #c9d1d9))",
          "numBg": "var(--diffBlob-addition-bgColor-num, var(--color-diff-blob-addition-num-bg, rgba(88,166,255,0.3)))",
          "lineBg": "var(--diffBlob-addition-bgColor-line, var(--color-diff-blob-addition-line-bg, rgba(56,139,253,0.15)))",
          "wordBg": "var(--diffBlob-addition-bgColor-word, var(--color-diff-blob-addition-word-bg, rgba(56,139,253,0.4)))"
        },
        "deletion": {
          "numText": "var(--diffBlob-deletion-fgColor-num, var(--color-diff-blob-deletion-num-text, #c9d1d9))",
          "fg": "var(--diffBlob-deletion-fgColor-text, var(--color-diff-blob-deletion-fg, #c9d1d9))",
          "numBg": "var(--diffBlob-deletion-bgColor-num, var(--color-diff-blob-deletion-num-bg, rgba(248,81,73,0.3)))",
          "lineBg": "var(--diffBlob-deletion-bgColor-line, var(--color-diff-blob-deletion-line-bg, rgba(248,81,73,0.1)))",
          "wordBg": "var(--diffBlob-deletion-bgColor-word, var(--color-diff-blob-deletion-word-bg, rgba(248,81,73,0.4)))"
        },
        "hunk": {
          "numBg": "var(--diffBlob-hunk-bgColor-num, var(--color-diff-blob-hunk-num-bg, rgba(56,139,253,0.4)))"
        },
        "expander": {
          "icon": "var(--diffBlob-expander-iconColor, var(--color-diff-blob-expander-icon, #8b949e))"
        },
        "selectedLineHighlightMixBlendMode": "var(--color-diff-blob-selected-line-highlight-mix-blend-mode, screen)"
      },
      "diffstat": {
        "deletionBorder": "var(--color-diffstat-deletion-border, rgba(240,246,252,0.1))",
        "additionBorder": "var(--color-diffstat-addition-border, rgba(240,246,252,0.1))",
        "additionBg": "var(--diffStat-addition-bgColor, var(--color-diffstat-addition-bg, #58a6ff))"
      },
      "searchKeyword": {
        "hl": "var(--highlight-neutral-bgColor, var(--color-search-keyword-hl, rgba(210,153,34,0.4)))"
      },
      "prettylights": {
        "syntax": {
          "comment": "var(--color-prettylights-syntax-comment, #8b949e)",
          "constant": "var(--color-prettylights-syntax-constant, #79c0ff)",
          "entity": "var(--color-prettylights-syntax-entity, #d2a8ff)",
          "storageModifierImport": "var(--color-prettylights-syntax-storage-modifier-import, #c9d1d9)",
          "entityTag": "var(--color-prettylights-syntax-entity-tag, #a5d6ff)",
          "keyword": "var(--color-prettylights-syntax-keyword, #ff7b72)",
          "string": "var(--color-prettylights-syntax-string, #a5d6ff)",
          "variable": "var(--color-prettylights-syntax-variable, #ffa198)",
          "brackethighlighterUnmatched": "var(--color-prettylights-syntax-brackethighlighter-unmatched, #f85149)",
          "invalidIllegalText": "var(--color-prettylights-syntax-invalid-illegal-text, #f0f6fc)",
          "invalidIllegalBg": "var(--color-prettylights-syntax-invalid-illegal-bg, #8e1519)",
          "carriageReturnText": "var(--color-prettylights-syntax-carriage-return-text, #f0f6fc)",
          "carriageReturnBg": "var(--color-prettylights-syntax-carriage-return-bg, #b62324)",
          "stringRegexp": "var(--color-prettylights-syntax-string-regexp, #a5d6ff)",
          "markupList": "var(--color-prettylights-syntax-markup-list, #f2cc60)",
          "markupHeading": "var(--color-prettylights-syntax-markup-heading, #1f6feb)",
          "markupItalic": "var(--color-prettylights-syntax-markup-italic, #c9d1d9)",
          "markupBold": "var(--color-prettylights-syntax-markup-bold, #c9d1d9)",
          "markupDeletedText": "var(--color-prettylights-syntax-markup-deleted-text, #ffdcd7)",
          "markupDeletedBg": "var(--color-prettylights-syntax-markup-deleted-bg, #67060c)",
          "markupInsertedText": "var(--color-prettylights-syntax-markup-inserted-text, #cae8ff)",
          "markupInsertedBg": "var(--color-prettylights-syntax-markup-inserted-bg, #0c2d6b)",
          "markupChangedText": "var(--color-prettylights-syntax-markup-changed-text, #ffdcd7)",
          "markupChangedBg": "var(--color-prettylights-syntax-markup-changed-bg, #67060c)",
          "markupIgnoredText": "var(--color-prettylights-syntax-markup-ignored-text, #c9d1d9)",
          "markupIgnoredBg": "var(--color-prettylights-syntax-markup-ignored-bg, #1158c7)",
          "metaDiffRange": "var(--color-prettylights-syntax-meta-diff-range, #d2a8ff)",
          "brackethighlighterAngle": "var(--color-prettylights-syntax-brackethighlighter-angle, #8b949e)",
          "sublimelinterGutterMark": "var(--color-prettylights-syntax-sublimelinter-gutter-mark, #484f58)",
          "constantOtherReferenceLink": "var(--color-prettylights-syntax-constant-other-reference-link, #a5d6ff)"
        }
      },
      "codemirror": {
        "text": "var(--codeMirror-fgColor, var(--color-codemirror-text, #c9d1d9))",
        "bg": "var(--codeMirror-bgColor, var(--color-codemirror-bg, #0d1117))",
        "guttersBg": "var(--codeMirror-gutters-bgColor, var(--color-codemirror-gutters-bg, #0d1117))",
        "guttermarkerText": "var(--codeMirror-gutterMarker-fgColor-default, var(--color-codemirror-guttermarker-text, #0d1117))",
        "guttermarkerSubtleText": "var(--codeMirror-gutterMarker-fgColor-muted, var(--color-codemirror-guttermarker-subtle-text, #6e7681))",
        "linenumberText": "var(--codeMirror-lineNumber-fgColor, var(--color-codemirror-linenumber-text, #8b949e))",
        "cursor": "var(--codeMirror-cursor-fgColor, var(--color-codemirror-cursor, #c9d1d9))",
        "selectionBg": "var(--codeMirror-selection-bgColor, var(--color-codemirror-selection-bg, rgba(56,139,253,0.4)))",
        "activelineBg": "var(--codeMirror-activeline-bgColor, var(--color-codemirror-activeline-bg, rgba(110,118,129,0.1)))",
        "matchingbracketText": "var(--codeMirror-matchingBracket-fgColor, var(--color-codemirror-matchingbracket-text, #c9d1d9))",
        "linesBg": "var(--codeMirror-lines-bgColor, var(--color-codemirror-lines-bg, #0d1117))",
        "syntax": {
          "comment": "var(--codeMirror-syntax-fgColor-comment, var(--color-codemirror-syntax-comment, #8b949e))",
          "constant": "var(--codeMirror-syntax-fgColor-constant, var(--color-codemirror-syntax-constant, #79c0ff))",
          "entity": "var(--codeMirror-syntax-fgColor-entity, var(--color-codemirror-syntax-entity, #d2a8ff))",
          "keyword": "var(--codeMirror-syntax-fgColor-keyword, var(--color-codemirror-syntax-keyword, #ff7b72))",
          "storage": "var(--codeMirror-syntax-fgColor-storage, var(--color-codemirror-syntax-storage, #ff7b72))",
          "string": "var(--codeMirror-syntax-fgColor-string, var(--color-codemirror-syntax-string, #a5d6ff))",
          "support": "var(--codeMirror-syntax-fgColor-support, var(--color-codemirror-syntax-support, #79c0ff))",
          "variable": "var(--codeMirror-syntax-fgColor-variable, var(--color-codemirror-syntax-variable, #ffa198))"
        }
      },
      "checks": {
        "bg": "var(--color-checks-bg, #010409)",
        "runBorderWidth": "var(--color-checks-run-border-width, 1px)",
        "containerBorderWidth": "var(--color-checks-container-border-width, 1px)",
        "textPrimary": "var(--color-checks-text-primary, #c9d1d9)",
        "textSecondary": "var(--color-checks-text-secondary, #8b949e)",
        "textLink": "var(--color-checks-text-link, #58a6ff)",
        "btnIcon": "var(--color-checks-btn-icon, #8b949e)",
        "btnHoverIcon": "var(--color-checks-btn-hover-icon, #c9d1d9)",
        "btnHoverBg": "var(--color-checks-btn-hover-bg, rgba(110,118,129,0.1))",
        "inputText": "var(--color-checks-input-text, #8b949e)",
        "inputPlaceholderText": "var(--color-checks-input-placeholder-text, #6e7681)",
        "inputFocusText": "var(--color-checks-input-focus-text, #c9d1d9)",
        "inputBg": "var(--color-checks-input-bg, #161b22)",
        "donutError": "var(--color-checks-donut-error, #f85149)",
        "donutPending": "var(--color-checks-donut-pending, #d29922)",
        "donutSuccess": "var(--color-checks-donut-success, #388bfd)",
        "donutNeutral": "var(--color-checks-donut-neutral, #8b949e)",
        "dropdownText": "var(--color-checks-dropdown-text, #c9d1d9)",
        "dropdownBg": "var(--color-checks-dropdown-bg, #161b22)",
        "dropdownBorder": "var(--color-checks-dropdown-border, #30363d)",
        "dropdownShadow": "var(--color-checks-dropdown-shadow, rgba(1,4,9,0.3))",
        "dropdownHoverText": "var(--color-checks-dropdown-hover-text, #c9d1d9)",
        "dropdownHoverBg": "var(--color-checks-dropdown-hover-bg, rgba(110,118,129,0.1))",
        "dropdownBtnHoverText": "var(--color-checks-dropdown-btn-hover-text, #c9d1d9)",
        "dropdownBtnHoverBg": "var(--color-checks-dropdown-btn-hover-bg, rgba(110,118,129,0.1))",
        "scrollbarThumbBg": "var(--color-checks-scrollbar-thumb-bg, rgba(110,118,129,0.4))",
        "headerLabelText": "var(--color-checks-header-label-text, #8b949e)",
        "headerLabelOpenText": "var(--color-checks-header-label-open-text, #c9d1d9)",
        "headerBorder": "var(--color-checks-header-border, #21262d)",
        "headerIcon": "var(--color-checks-header-icon, #8b949e)",
        "lineText": "var(--color-checks-line-text, #8b949e)",
        "lineNumText": "var(--color-checks-line-num-text, #6e7681)",
        "lineTimestampText": "var(--color-checks-line-timestamp-text, #6e7681)",
        "lineHoverBg": "var(--color-checks-line-hover-bg, rgba(110,118,129,0.1))",
        "lineSelectedBg": "var(--color-checks-line-selected-bg, rgba(56,139,253,0.1))",
        "lineSelectedNumText": "var(--color-checks-line-selected-num-text, #58a6ff)",
        "lineDtFmText": "var(--color-checks-line-dt-fm-text, #ffffff)",
        "lineDtFmBg": "var(--color-checks-line-dt-fm-bg, #9e6a03)",
        "gateBg": "var(--color-checks-gate-bg, rgba(187,128,9,0.15))",
        "gateText": "var(--color-checks-gate-text, #8b949e)",
        "gateWaitingText": "var(--color-checks-gate-waiting-text, #d29922)",
        "stepHeaderOpenBg": "var(--color-checks-step-header-open-bg, #161b22)",
        "stepErrorText": "var(--color-checks-step-error-text, #f85149)",
        "stepWarningText": "var(--color-checks-step-warning-text, #d29922)",
        "loglineText": "var(--color-checks-logline-text, #8b949e)",
        "loglineNumText": "var(--color-checks-logline-num-text, #6e7681)",
        "loglineDebugText": "var(--color-checks-logline-debug-text, #a371f7)",
        "loglineErrorText": "var(--color-checks-logline-error-text, #8b949e)",
        "loglineErrorNumText": "var(--color-checks-logline-error-num-text, #6e7681)",
        "loglineErrorBg": "var(--color-checks-logline-error-bg, rgba(248,81,73,0.1))",
        "loglineWarningText": "var(--color-checks-logline-warning-text, #8b949e)",
        "loglineWarningNumText": "var(--color-checks-logline-warning-num-text, #d29922)",
        "loglineWarningBg": "var(--color-checks-logline-warning-bg, rgba(187,128,9,0.15))",
        "loglineCommandText": "var(--color-checks-logline-command-text, #58a6ff)",
        "loglineSectionText": "var(--color-checks-logline-section-text, #58a6ff)",
        "ansi": {
          "black": "var(--color-checks-ansi-black, #0d1117)",
          "blackBright": "var(--color-checks-ansi-black-bright, #161b22)",
          "white": "var(--color-checks-ansi-white, #b1bac4))",
          "whiteBright": "var(--color-checks-ansi-white-bright, #b1bac4)",
          "gray": "var(--color-checks-ansi-gray, #6e7681)",
          "red": "var(--color-checks-ansi-red, #ff7b72)",
          "redBright": "var(--color-checks-ansi-red-bright, #ffa198)",
          "green": "var(--color-checks-ansi-green, #58a6ff)",
          "greenBright": "var(--color-checks-ansi-green-bright, #79c0ff)",
          "yellow": "var(--color-checks-ansi-yellow, #d29922)",
          "yellowBright": "var(--color-checks-ansi-yellow-bright, #e3b341)",
          "blue": "var(--color-checks-ansi-blue, #58a6ff)",
          "blueBright": "var(--color-checks-ansi-blue-bright, #79c0ff)",
          "magenta": "var(--color-checks-ansi-magenta, #bc8cff)",
          "magentaBright": "var(--color-checks-ansi-magenta-bright, #d2a8ff)",
          "cyan": "var(--color-checks-ansi-cyan, #76e3ea)",
          "cyanBright": "var(--color-checks-ansi-cyan-bright, #b3f0ff)"
        }
      },
      "project": {
        "headerBg": "var(--color-project-header-bg, #0d1117)",
        "sidebarBg": "var(--color-project-sidebar-bg, #161b22)",
        "gradientIn": "var(--color-project-gradient-in, #161b22)",
        "gradientOut": "var(--color-project-gradient-out, rgba(22,27,34,0))"
      },
      "mktg": {
        "btn": {
          "bg": "var(--color-mktg-btn-bg, #f6f8fa))"
        }
      },
      "control": {
        "borderColor": {
          "emphasis": "var(--control-borderColor-emphasis, var(--color-control-border-color-emphasis, #606771))"
        }
      },
      "avatar": {
        "bg": "var(--avatar-bgColor, var(--color-avatar-bg, rgba(255,255,255,0.1)))",
        "border": "var(--avatar-borderColor, var(--color-avatar-border, rgba(240,246,252,0.1)))",
        "stackFade": "var(--avatarStack-fade-bgColor-default, var(--color-avatar-stack-fade, #30363d))",
        "stackFadeMore": "var(--avatarStack-fade-bgColor-muted, var(--color-avatar-stack-fade-more, #21262d))"
      },
      "topicTag": {
        "border": "var(--topicTag-borderColor, var(--color-topic-tag-border, transparent))"
      },
      "counter": {
        "border": "var(--counter-borderColor, var(--color-counter-border, transparent))"
      },
      "selectMenu": {
        "backdropBorder": "var(--selectMenu-borderColor, var(--color-select-menu-backdrop-border, #484f58))",
        "tapHighlight": "var(--control-bgColor-active, var(--color-select-menu-tap-highlight, rgba(48,54,61,0.5)))",
        "tapFocusBg": "var(--selectMenu-bgColor-active, var(--color-select-menu-tap-focus-bg, #0c2d6b))"
      },
      "overlay": {
        "backdrop": "var(--overlay-backdrop-bgColor, var(--color-overlay-backdrop, rgba(22,27,34,0.4)))"
      },
      "header": {
        "text": "var(--header-fgColor-default, var(--color-header-text, rgba(255,255,255,0.7)))",
        "bg": "var(--header-bgColor, var(--color-header-bg, #161b22))",
        "divider": "var(--header-borderColor-divider, var(--color-header-divider, #8b949e))",
        "logo": "var(--header-fgColor-logo, var(--color-header-logo, #f0f6fc))"
      },
      "headerSearch": {
        "bg": "var(--headerSearch-bgColor, var(--color-header-search-bg, #0d1117))",
        "border": "var(--headerSearch-borderColor, var(--color-header-search-border, #30363d))"
      },
      "sidenav": {
        "selectedBg": "var(--sideNav-bgColor-selected, var(--color-sidenav-selected-bg, #21262d))"
      },
      "menu": {
        "bgActive": "var(--menu-bgColor-active, var(--color-menu-bg-active, #161b22))"
      },
      "input": {
        "disabledBg": "var(--control-bgColor-disabled, var(--color-input-disabled-bg, rgba(110,118,129,0)))"
      },
      "timeline": {
        "badgeBg": "var(--timelineBadge-bgColor, var(--color-timeline-badge-bg, #21262d))"
      },
      "ansi": {
        "black": "var(--color-ansi-black, #484f58)",
        "blackBright": "var(--color-ansi-black-bright, #6e7681)",
        "white": "var(--color-ansi-white, #b1bac4)",
        "whiteBright": "var(--color-ansi-white-bright, #ffffff)",
        "gray": "var(--color-ansi-gray, #6e7681)",
        "red": "var(--color-ansi-red, #ff7b72)",
        "redBright": "var(--color-ansi-red-bright, #ffa198)",
        "green": "var(--color-ansi-green, #58a6ff)",
        "greenBright": "var(--color-ansi-green-bright, #79c0ff)",
        "yellow": "var(--color-ansi-yellow, #d29922)",
        "yellowBright": "var(--color-ansi-yellow-bright, #e3b341)",
        "blue": "var(--color-ansi-blue, #58a6ff)",
        "blueBright": "var(--color-ansi-blue-bright, #79c0ff)",
        "magenta": "var(--color-ansi-magenta, #bc8cff)",
        "magentaBright": "var(--color-ansi-magenta-bright, #d2a8ff)",
        "cyan": "var(--color-ansi-cyan, #39c5cf)",
        "cyanBright": "var(--color-ansi-cyan-bright, #56d4dd)"
      },
      "btn": {
        "text": "var(--button-default-fgColor-rest, var(--color-btn-text, #c9d1d9))",
        "bg": "var(--button-default-bgColor-rest, var(--color-btn-bg, #21262d))",
        "border": "var(--button-default-borderColor-rest, var(--color-btn-border, rgba(240,246,252,0.1)))",
        "hoverBg": "var(--button-default-bgColor-hover, var(--color-btn-hover-bg, #30363d))",
        "hoverBorder": "var(--button-default-borderColor-hover, var(--color-btn-hover-border, #8b949e))",
        "activeBg": "var(--button-default-bgColor-active, var(--color-btn-active-bg, hsla(212,12%,18%,1)))",
        "activeBorder": "var(--button-default-borderColor-active, var(--color-btn-active-border, #6e7681))",
        "selectedBg": "var(--button-default-bgColor-selected, var(--color-btn-selected-bg, #161b22))",
        "counterBg": "var(--buttonCounter-default-bgColor-rest, var(--color-btn-counter-bg, #30363d))",
        "primary": {
          "text": "var(--button-primary-fgColor-rest, var(--color-btn-primary-text, #ffffff))",
          "bg": "var(--button-primary-bgColor-rest, var(--color-btn-primary-bg, #1f6feb))",
          "border": "var(--button-primary-borderColor-rest, var(--color-btn-primary-border, rgba(240,246,252,0.1)))",
          "hoverBg": "var(--button-primary-bgColor-hover, var(--color-btn-primary-hover-bg, #388bfd))",
          "hoverBorder": "var(--button-primary-borderColor-hover, var(--color-btn-primary-hover-border, rgba(240,246,252,0.1)))",
          "selectedBg": "var(--button-primary-bgColor-active, var(--color-btn-primary-selected-bg, #1f6feb))",
          "disabledText": "var(--button-primary-fgColor-disabled, var(--color-btn-primary-disabled-text, rgba(255,255,255,0.5)))",
          "disabledBg": "var(--button-primary-bgColor-disabled, var(--color-btn-primary-disabled-bg, rgba(31,111,235,0.6)))",
          "disabledBorder": "var(--button-primary-borderColor-disabled, var(--color-btn-primary-disabled-border, rgba(240,246,252,0.1)))",
          "icon": "var(--button-primary-iconColor-rest, var(--color-btn-primary-icon, #ffffff))",
          "counterBg": "var(--buttonCounter-primary-bgColor-rest, var(--color-btn-primary-counter-bg, rgba(5,29,77,0.2)))"
        },
        "outline": {
          "text": "var(--button-outline-fgColor-rest, var(--color-btn-outline-text, #388bfd))",
          "hoverText": "var(--button-outline-fgColor-hover, var(--color-btn-outline-hover-text, #58a6ff))",
          "hoverBg": "var(--button-outline-bgColor-hover, var(--color-btn-outline-hover-bg, #30363d))",
          "hoverBorder": "var(--button-outline-borderColor-hover, var(--color-btn-outline-hover-border, rgba(240,246,252,0.1)))",
          "hoverCounterBg": "var(--buttonCounter-outline-bgColor-hover, var(--color-btn-outline-hover-counter-bg, rgba(5,29,77,0.2)))",
          "selectedText": "var(--button-outline-fgColor-active, var(--color-btn-outline-selected-text, #ffffff))",
          "selectedBg": "var(--button-outline-bgColor-active, var(--color-btn-outline-selected-bg, #0d419d))",
          "selectedBorder": "var(--button-outline-borderColor-active, var(--color-btn-outline-selected-border, rgba(240,246,252,0.1)))",
          "disabledText": "var(--button-outline-fgColor-disabled, var(--color-btn-outline-disabled-text, rgba(88,166,255,0.5)))",
          "disabledBg": "var(--button-outline-bgColor-disabled, var(--color-btn-outline-disabled-bg, #0d1117))",
          "disabledCounterBg": "var(--buttonCounter-outline-bgColor-disabled, var(--color-btn-outline-disabled-counter-bg, rgba(31,111,235,0.05)))",
          "counterBg": "var(--buttonCounter-outline-bgColor-rest, var(--color-btn-outline-counter-bg, rgba(5,29,77,0.2)))",
          "hoverCounterFg": "var(--buttonCounter-outline-fgColor-hover, var(--color-btn-outline-hover-counter-fg, #58a6ff))",
          "disabledCounterFg": "var(--buttonCounter-outline-fgColor-disabled, var(--color-btn-outline-disabled-counter-fg, rgba(88,166,255,0.5)))",
          "counterFg": "var(--buttonCounter-outline-fgColor-rest, var(--color-btn-outline-counter-fg, #388bfd))"
        },
        "danger": {
          "text": "var(--button-danger-fgColor-rest, var(--color-btn-danger-text, #f85149))",
          "hoverText": "var(--button-danger-fgColor-hover, var(--color-btn-danger-hover-text, #ffffff))",
          "hoverBg": "var(--button-danger-bgColor-hover, var(--color-btn-danger-hover-bg, #da3633))",
          "hoverBorder": "var(--button-danger-borderColor-hover, var(--color-btn-danger-hover-border, #f85149))",
          "hoverIcon": "var(--button-danger-iconColor-hover, var(--color-btn-danger-hover-icon, #ffffff))",
          "hoverCounterBg": "var(--buttonCounter-danger-bgColor-hover, var(--color-btn-danger-hover-counter-bg, rgba(255,255,255,0.2)))",
          "selectedText": "var(--button-danger-fgColor-active, var(--color-btn-danger-selected-text, #ffffff))",
          "selectedBg": "var(--button-danger-bgColor-active, var(--color-btn-danger-selected-bg, #b62324))",
          "selectedBorder": "var(--button-danger-borderColor-active, var(--color-btn-danger-selected-border, #ff7b72))",
          "disabledText": "var(--button-danger-fgColor-disabled, var(--color-btn-danger-disabled-text, rgba(248,81,73,0.5)))",
          "disabledBg": "var(--button-danger-bgColor-disabled, var(--color-btn-danger-disabled-bg, #0d1117))",
          "disabledCounterBg": "var(--buttonCounter-danger-bgColor-disabled, var(--color-btn-danger-disabled-counter-bg, rgba(218,54,51,0.05)))",
          "counterBg": "var(--buttonCounter-danger-bgColor-rest, var(--color-btn-danger-counter-bg, rgba(73,2,2,0.2)))",
          "icon": "var(--button-danger-iconColor-rest, var(--color-btn-danger-icon, #f85149))",
          "counterFg": "var(--buttonCounter-danger-fgColor-rest, var(--color-btn-danger-counter-fg, #f85149))",
          "disabledCounterFg": "var(--buttonCounter-danger-fgColor-disabled, var(--color-btn-danger-disabled-counter-fg, rgba(248,81,73,0.5)))",
          "hoverCounterFg": "var(--buttonCounter-danger-fgColor-hover, var(--color-btn-danger-hover-counter-fg, #ffffff))"
        },
        "inactive": {
          "bg": "var(--button-inactive-bgColor-rest, var(--color-btn-inactive-bg, #21262d))",
          "text": "var(--button-inactive-fgColor-rest, var(--color-btn-inactive-text, #8b949e))"
        }
      },
      "underlinenav": {
        "icon": "var(--underlineNav-iconColor-rest, var(--color-underlinenav-icon, #6e7681))",
        "borderHover": "var(--underlineNav-borderColor-hover, var(--color-underlinenav-border-hover, rgba(110,118,129,0.4)))"
      },
      "actionListItem": {
        "inlineDivider": "var(--borderColor-muted, var(--color-action-list-item-inline-divider, rgba(48,54,61,0.48)))",
        "default": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-action-list-item-default-hover-bg, rgba(177,186,196,0.12)))",
          "hoverBorder": "var(--control-transparent-borderColor-hover, var(--color-action-list-item-default-hover-border, transparent))",
          "activeBg": "var(--control-transparent-bgColor-active, var(--color-action-list-item-default-active-bg, rgba(177,186,196,0.2)))",
          "activeBorder": "var(--control-transparent-borderColor-active, var(--color-action-list-item-default-active-border, transparent))",
          "selectedBg": "var(--control-transparent-bgColor-selected, var(--color-action-list-item-default-selected-bg, rgba(177,186,196,0.08)))"
        },
        "danger": {
          "hoverBg": "var(--control-danger-bgColor-hover, var(--color-action-list-item-danger-hover-bg, rgba(248,81,73,0.16)))",
          "activeBg": "var(--control-danger-bgColor-active, var(--color-action-list-item-danger-active-bg, rgba(248,81,73,0.24)))",
          "hoverText": "var(--control-danger-fgColor-hover, var(--color-action-list-item-danger-hover-text, #ff7b72))"
        }
      },
      "switchTrack": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-switch-track-bg, rgba(110,118,129,0.1)))",
        "hoverBg": "var(--controlTrack-bgColor-hover, var(--color-switch-track-hover-bg, hsla(215,8%,72%,0.1)))",
        "activeBg": "var(--controlTrack-bgColor-active, var(--color-switch-track-active-bg, rgba(110,118,129,0.4)))",
        "disabledBg": "var(--controlTrack-bgColor-disabled, var(--color-switch-track-disabled-bg, #21262d))",
        "fg": "var(--controlTrack-fgColor-rest, var(--color-switch-track-fg, #8b949e))",
        "disabledFg": "var(--controlTrack-fgColor-disabled, var(--color-switch-track-disabled-fg, #010409))",
        "border": "var(--controlTrack-borderColor-rest, var(--color-switch-track-border, transparent))",
        "checked": {
          "bg": "var(--control-checked-bgColor-rest, var(--color-switch-track-checked-bg, rgba(31,111,235,0.35)))",
          "hoverBg": "var(--control-checked-bgColor-hover, var(--color-switch-track-checked-hover-bg, rgba(31,111,235,0.5)))",
          "activeBg": "var(--control-checked-bgColor-active, var(--color-switch-track-checked-active-bg, rgba(31,111,235,0.65)))",
          "fg": "var(--control-checked-fgColor-rest, var(--color-switch-track-checked-fg, #ffffff))",
          "disabledFg": "var(--control-checked-fgColor-disabled, var(--color-switch-track-checked-disabled-fg, #010409))",
          "border": "var(--borderColor-transparent, var(--color-switch-track-checked-border, transparent))"
        }
      },
      "switchKnob": {
        "bg": "var(--controlKnob-bgColor-rest, var(--color-switch-knob-bg, #0d1117))",
        "border": "var(--controlKnob-borderColor-rest, var(--color-switch-knob-border, #606771))",
        "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-disabled-bg, #161b22))",
        "checked": {
          "bg": "var(--controlKnob-bgColor-checked, var(--color-switch-knob-checked-bg, #0d1117))",
          "disabledBg": "var(--controlKnob-bgColor-disabled, var(--color-switch-knob-checked-disabled-bg, #161b22))",
          "border": "var(--controlKnob-borderColor-checked, var(--color-switch-knob-checked-border, rgba(31,111,235,0.35)))"
        }
      },
      "segmentedControl": {
        "bg": "var(--controlTrack-bgColor-rest, var(--color-segmented-control-bg, rgba(110,118,129,0.1)))",
        "button": {
          "bg": "var(--controlKnob-bgColor-rest, var(--color-segmented-control-button-bg, #0d1117))",
          "hover": {
            "bg": "var(--controlTrack-bgColor-hover, var(--color-segmented-control-button-hover-bg, #30363d))"
          },
          "active": {
            "bg": "var(--controlTrack-bgColor-active, var(--color-segmented-control-button-active-bg, #21262d))"
          },
          "selected": {
            "border": "var(--controlKnob-borderColor-rest, var(--color-segmented-control-button-selected-border, #6e7681))"
          }
        }
      },
      "treeViewItem": {
        "chevron": {
          "hoverBg": "var(--control-transparent-bgColor-hover, var(--color-tree-view-item-chevron-hover-bg, rgba(177,186,196,0.12)))"
        },
        "directory": {
          "fill": "var(--treeViewItem-leadingVisual-iconColor-rest, var(--color-tree-view-item-directory-fill, #8b949e))"
        }
      },
      "fg": {
        "default": "var(--fgColor-default, var(--color-fg-default, #c9d1d9))",
        "muted": "var(--fgColor-muted, var(--color-fg-muted, #8b949e))",
        "subtle": "var(--fgColor-muted, var(--color-fg-subtle, #6e7681))",
        "onEmphasis": "var(--fgColor-onEmphasis, var(--color-fg-on-emphasis, #ffffff))"
      },
      "canvas": {
        "default": "var(--bgColor-default, var(--color-canvas-default, #0d1117))",
        "overlay": "var(--overlay-bgColor, var(--color-canvas-overlay, #161b22))",
        "inset": "var(--bgColor-inset, var(--color-canvas-inset, #010409))",
        "subtle": "var(--bgColor-muted, var(--color-canvas-subtle, #161b22))"
      },
      "border": {
        "default": "var(--borderColor-default, var(--color-border-default, #30363d))",
        "muted": "var(--borderColor-muted, var(--color-border-muted, #21262d))",
        "subtle": "var(--borderColor-muted, var(--color-border-subtle, rgba(240,246,252,0.1)))"
      },
      "neutral": {
        "emphasisPlus": "var(--bgColor-emphasis, var(--color-neutral-emphasis-plus, #6e7681))",
        "emphasis": "var(--bgColor-neutral-emphasis, var(--color-neutral-emphasis, #6e7681))",
        "muted": "var(--bgColor-neutral-muted, var(--color-neutral-muted, rgba(110,118,129,0.4)))",
        "subtle": "var(--bgColor-neutral-muted, var(--color-neutral-subtle, rgba(110,118,129,0.1)))"
      },
      "accent": {
        "fg": "var(--fgColor-accent, var(--color-accent-fg, #58a6ff))",
        "emphasis": "var(--bgColor-accent-emphasis, var(--color-accent-emphasis, #1f6feb))",
        "muted": "var(--borderColor-accent-muted, var(--color-accent-muted, rgba(56,139,253,0.4)))",
        "subtle": "var(--bgColor-accent-muted, var(--color-accent-subtle, rgba(56,139,253,0.1)))"
      },
      "success": {
        "fg": "var(--fgColor-success, var(--color-success-fg, #58a6ff))",
        "emphasis": "var(--bgColor-success-emphasis, var(--color-success-emphasis, #1f6feb))",
        "muted": "var(--borderColor-success-muted, var(--color-success-muted, rgba(56,139,253,0.4)))",
        "subtle": "var(--bgColor-success-muted, var(--color-success-subtle, rgba(56,139,253,0.15)))"
      },
      "attention": {
        "fg": "var(--fgColor-attention, var(--color-attention-fg, #d29922))",
        "emphasis": "var(--bgColor-attention-emphasis, var(--color-attention-emphasis, #9e6a03))",
        "muted": "var(--borderColor-attention-muted, var(--color-attention-muted, rgba(187,128,9,0.4)))",
        "subtle": "var(--bgColor-attention-muted, var(--color-attention-subtle, rgba(187,128,9,0.15)))"
      },
      "severe": {
        "fg": "var(--fgColor-severe, var(--color-severe-fg, #f85149))",
        "emphasis": "var(--bgColor-severe-emphasis, var(--color-severe-emphasis, #da3633))",
        "muted": "var(--borderColor-severe-muted, var(--color-severe-muted, rgba(248,81,73,0.4)))",
        "subtle": "var(--bgColor-severe-muted, var(--color-severe-subtle, rgba(248,81,73,0.1)))"
      },
      "danger": {
        "fg": "var(--fgColor-danger, var(--color-danger-fg, #f85149))",
        "emphasis": "var(--borderColor-danger-emphasis, var(--color-danger-emphasis, #da3633))",
        "muted": "var(--borderColor-danger-muted, var(--color-danger-muted, rgba(248,81,73,0.4)))",
        "subtle": "var(--bgColor-danger-muted, var(--color-danger-subtle, rgba(248,81,73,0.1)))"
      },
      "open": {
        "fg": "var(--fgColor-open, var(--color-open-fg, #ff7b72))",
        "emphasis": "var(--bgColor-open-emphasis, var(--color-open-emphasis, #da3633))",
        "muted": "var(--borderColor-open-muted, var(--color-open-muted, rgba(248,81,73,0.4)))",
        "subtle": "var(--bgColor-open-muted, var(--color-open-subtle, rgba(248,81,73,0.15)))"
      },
      "closed": {
        "fg": "var(--fgColor-closed, var(--color-closed-fg, #8b949e))",
        "emphasis": "var(--bgColor-closed-emphasis, var(--color-closed-emphasis, #6e7681))",
        "muted": "var(--borderColor-closed-muted, var(--color-closed-muted, rgba(110,118,129,0.4)))",
        "subtle": "var(--bgColor-closed-muted, var(--color-closed-subtle, rgba(110,118,129,0.1)))"
      },
      "done": {
        "fg": "var(--fgColor-done, var(--color-done-fg, #a371f7))",
        "emphasis": "var(--bgColor-done-emphasis, var(--color-done-emphasis, #8957e5))",
        "muted": "var(--borderColor-done-muted, var(--color-done-muted, rgba(163,113,247,0.4)))",
        "subtle": "var(--bgColor-done-muted, var(--color-done-subtle, rgba(163,113,247,0.1)))"
      },
      "sponsors": {
        "fg": "var(--fgColor-sponsors, var(--color-sponsors-fg, #db61a2))",
        "emphasis": "var(--bgColor-sponsors-emphasis, var(--color-sponsors-emphasis, #bf4b8a))",
        "muted": "var(--borderColor-sponsors-muted, var(--color-sponsors-muted, rgba(219,97,162,0.4)))",
        "subtle": "var(--bgColor-sponsors-muted, var(--color-sponsors-subtle, rgba(219,97,162,0.1)))"
      },
      "primer": {
        "fg": {
          "disabled": "var(--fgColor-disabled, var(--color-primer-fg-disabled, #484f58))"
        },
        "canvas": {
          "backdrop": "var(--overlay-backdrop-bgColor, var(--color-primer-canvas-backdrop, rgba(1,4,9,0.8)))",
          "sticky": "var(--color-primer-canvas-sticky, rgba(13,17,23,0.95))"
        },
        "border": {
          "active": "var(--underlineNav-borderColor-active, var(--color-primer-border-active, #f78166))",
          "contrast": "var(--borderColor-muted, var(--color-primer-border-contrast, rgba(255,255,255,0.2)))"
        }
      }
    },
    "shadows": {
      "checks": {
        "inputShadow": "var(--color-checks-input-shadow, 0 0 0 1px #30363d)"
      },
      "mktg": {
        "btn": {
          "shadow": {
            "outline": "var(--color-mktg-btn-shadow-outline, rgb(255 255 255 / 25%) 0 0 0 1px inset))",
            "focus": "var(--color-mktg-btn-shadow-focus, rgb(255 255 255 / 25%) 0 0 0 4px))",
            "hover": "var(--color-mktg-btn-shadow-hover, 0 4px 7px rgba(0, 0, 0, 0.15), 0 100px 80px rgba(255, 255, 255, 0.02), 0 42px 33px rgba(255, 255, 255, 0.024), 0 22px 18px rgba(255, 255, 255, 0.028), 0 12px 10px rgba(255, 255, 255, 0.034), 0 7px 5px rgba(255, 255, 255, 0.04), 0 3px 2px rgba(255, 255, 255, 0.07)))",
            "hoverMuted": "var(--color-mktg-btn-shadow-hover-muted, rgb(255 255 255) 0 0 0 2px inset))"
          }
        }
      },
      "avatar": {
        "childShadow": "var(--avatar-shadow, var(--color-avatar-child-shadow, 0 0 0 2px #0d1117))"
      },
      "overlay": {
        "shadow": "var(--shadow-floating-small, var(--color-overlay-shadow, 0 0 0 1px #30363d, 0 16px 32px rgba(1,4,9,0.85)))"
      },
      "btn": {
        "shadow": "var(--button-default-shadow-resting, var(--color-btn-shadow, 0 0 transparent))",
        "insetShadow": "var(--button-default-shadow-inset, var(--color-btn-inset-shadow, 0 0 transparent))",
        "primary": {
          "shadow": "var(--shadow-resting-small, var(--color-btn-primary-shadow, 0 0 transparent))",
          "insetShadow": "var(--shadow-highlight, var(--color-btn-primary-inset-shadow, 0 0 transparent))",
          "selectedShadow": "var(--button-primary-shadow-selected, var(--color-btn-primary-selected-shadow, 0 0 transparent))"
        },
        "outline": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-outline-hover-shadow, 0 1px 0 rgba(1,4,9,0.1)))// HI_KATIE: no matches",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-outline-hover-inset-shadow, inset 0 1px 0 rgba(255,255,255,0.03)))// HI_KATIE: no matches",
          "selectedShadow": "var(--button-outline-shadow-selected, var(--color-btn-outline-selected-shadow, 0 0 transparent))"
        },
        "danger": {
          "hoverShadow": "var(--shadow-resting-small, var(--color-btn-danger-hover-shadow, 0 0 transparent))",
          "hoverInsetShadow": "var(--shadow-highlight, var(--color-btn-danger-hover-inset-shadow, 0 0 transparent))",
          "selectedShadow": "var(--button-danger-shadow-selected, var(--color-btn-danger-selected-shadow, 0 0 transparent))"
        }
      },
      "shadow": {
        "small": "var(--shadow-resting-small, var(--color-shadow-small, 0 0 transparent))",
        "medium": "var(--shadow-resting-medium, var(--color-shadow-medium, 0 3px 6px #010409))",
        "large": "var(--shadow-floating-large, var(--color-shadow-large, 0 8px 24px #010409))",
        "extraLarge": "var(--shadow-floating-xlarge, var(--color-shadow-extra-large, 0 12px 48px #010409))"
      },
      "primer": {
        "shadow": {
          "highlight": "var(--shadow-highlight, var(--color-primer-shadow-highlight, 0 0 transparent))",
          "inset": "var(--shadow-inset, var(--color-primer-shadow-inset, 0 0 transparent))"
        }
      }
    }
  }
};
const colorSchemes = colors$1;
const animation = {
  easeOutCubic: "cubic-bezier(0.33, 1, 0.68, 1)"
};
const breakpoints = ["544px", "768px", "1012px", "1280px"];
const fonts = {
  normal: fontStack(["-apple-system", "BlinkMacSystemFont", "Segoe UI", "Noto Sans", "Helvetica", "Arial", "sans-serif", "Apple Color Emoji", "Segoe UI Emoji"]),
  mono: `var(--fontStack-monospace, ${fontStack(["SFMono-Regular", "Consolas", "Liberation Mono", "Menlo", "Courier", "monospace"])})`
};
const lineHeights = {
  condensedUltra: 1,
  condensed: 1.25,
  default: 1.5
};
const fontWeights = {
  light: 300,
  normal: 400,
  semibold: 500,
  bold: 600
};
const borderWidths = [0, "1px"];
const radii$1 = ["0", "3px", "6px", "100px"];
const sizes$1 = {
  small: "544px",
  medium: "768px",
  large: "1012px",
  xlarge: "1280px"
};
const fontSizes = ["12px", "14px", "16px", "20px", "24px", "32px", "40px", "48px", "56px"];
const space$2 = ["0", "4px", "8px", "16px", "24px", "32px", "40px", "48px", "64px", "80px", "96px", "112px", "128px"];
const theme = {
  animation,
  borderWidths,
  breakpoints,
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
  radii: radii$1,
  sizes: sizes$1,
  space: space$2,
  colorSchemes
};
var objectAssignExports = requireObjectAssign();
const assign = /* @__PURE__ */ getDefaultExportFromCjs$1(objectAssignExports);
var merge$1 = function merge(a2, b2) {
  var result = assign({}, a2, b2);
  for (var key2 in a2) {
    var _assign;
    if (!a2[key2] || typeof b2[key2] !== "object") continue;
    assign(result, (_assign = {}, _assign[key2] = assign(a2[key2], b2[key2]), _assign));
  }
  return result;
};
var sort = function sort2(obj) {
  var next2 = {};
  Object.keys(obj).sort(function(a2, b2) {
    return a2.localeCompare(b2, void 0, {
      numeric: true,
      sensitivity: "base"
    });
  }).forEach(function(key2) {
    next2[key2] = obj[key2];
  });
  return next2;
};
var defaults$6 = {
  breakpoints: [40, 52, 64].map(function(n2) {
    return n2 + "em";
  })
};
var createMediaQuery = function createMediaQuery2(n2) {
  return "@media screen and (min-width: " + n2 + ")";
};
var getValue = function getValue2(n2, scale) {
  return get$5(scale, n2, n2);
};
var get$5 = function get2(obj, key2, def2, p2, undef) {
  key2 = key2 && key2.split ? key2.split(".") : [key2];
  for (p2 = 0; p2 < key2.length; p2++) {
    obj = obj ? obj[key2[p2]] : undef;
  }
  return obj === undef ? def2 : obj;
};
var createParser = function createParser2(config2) {
  var cache = {};
  var parse3 = function parse4(props) {
    var styles2 = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;
    for (var key2 in props) {
      if (!config2[key2]) continue;
      var sx2 = config2[key2];
      var raw = props[key2];
      var scale = get$5(props.theme, sx2.scale, sx2.defaults);
      if (typeof raw === "object") {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get$5(props.theme, "breakpoints", defaults$6.breakpoints);
        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
          styles2 = merge$1(styles2, parseResponsiveStyle(cache.media, sx2, scale, raw, props));
          continue;
        }
        if (raw !== null) {
          styles2 = merge$1(styles2, parseResponsiveObject(cache.breakpoints, sx2, scale, raw, props));
          shouldSort = true;
        }
        continue;
      }
      assign(styles2, sx2(raw, scale, props));
    }
    if (shouldSort) {
      styles2 = sort(styles2);
    }
    return styles2;
  };
  parse3.config = config2;
  parse3.propNames = Object.keys(config2);
  parse3.cache = cache;
  var keys2 = Object.keys(config2).filter(function(k2) {
    return k2 !== "config";
  });
  if (keys2.length > 1) {
    keys2.forEach(function(key2) {
      var _createParser;
      parse3[key2] = createParser2((_createParser = {}, _createParser[key2] = config2[key2], _createParser));
    });
  }
  return parse3;
};
var parseResponsiveStyle = function parseResponsiveStyle2(mediaQueries, sx2, scale, raw, _props) {
  var styles2 = {};
  raw.slice(0, mediaQueries.length).forEach(function(value, i) {
    var media = mediaQueries[i];
    var style3 = sx2(value, scale, _props);
    if (!media) {
      assign(styles2, style3);
    } else {
      var _assign2;
      assign(styles2, (_assign2 = {}, _assign2[media] = assign({}, styles2[media], style3), _assign2));
    }
  });
  return styles2;
};
var parseResponsiveObject = function parseResponsiveObject2(breakpoints2, sx2, scale, raw, _props) {
  var styles2 = {};
  for (var key2 in raw) {
    var breakpoint = breakpoints2[key2];
    var value = raw[key2];
    var style3 = sx2(value, scale, _props);
    if (!breakpoint) {
      assign(styles2, style3);
    } else {
      var _assign3;
      var media = createMediaQuery(breakpoint);
      assign(styles2, (_assign3 = {}, _assign3[media] = assign({}, styles2[media], style3), _assign3));
    }
  }
  return styles2;
};
var createStyleFunction = function createStyleFunction2(_ref) {
  var properties2 = _ref.properties, property = _ref.property, scale = _ref.scale, _ref$transform = _ref.transform, transform = _ref$transform === void 0 ? getValue : _ref$transform, defaultScale = _ref.defaultScale;
  properties2 = properties2 || [property];
  var sx2 = function sx3(value, scale2, _props) {
    var result = {};
    var n2 = transform(value, scale2, _props);
    if (n2 === null) return;
    properties2.forEach(function(prop) {
      result[prop] = n2;
    });
    return result;
  };
  sx2.scale = scale;
  sx2.defaults = defaultScale;
  return sx2;
};
var system$1 = function system(args) {
  if (args === void 0) {
    args = {};
  }
  var config2 = {};
  Object.keys(args).forEach(function(key2) {
    var conf = args[key2];
    if (conf === true) {
      config2[key2] = createStyleFunction({
        property: key2,
        scale: key2
      });
      return;
    }
    if (typeof conf === "function") {
      config2[key2] = conf;
      return;
    }
    config2[key2] = createStyleFunction(conf);
  });
  var parser = createParser(config2);
  return parser;
};
var compose$1 = function compose() {
  var config2 = {};
  for (var _len = arguments.length, parsers2 = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers2[_key] = arguments[_key];
  }
  parsers2.forEach(function(parser2) {
    if (!parser2 || !parser2.config) return;
    assign(config2, parser2.config);
  });
  var parser = createParser(config2);
  return parser;
};
var themeGet = function themeGet2(path2, fallback) {
  if (fallback === void 0) {
    fallback = null;
  }
  return function(props) {
    return get$5(props.theme, path2, fallback);
  };
};
var isNumber$3 = function isNumber(n2) {
  return typeof n2 === "number" && !isNaN(n2);
};
var getWidth = function getWidth2(n2, scale) {
  return get$5(scale, n2, !isNumber$3(n2) || n2 > 1 ? n2 : n2 * 100 + "%");
};
var config$7 = {
  width: {
    property: "width",
    scale: "sizes",
    transform: getWidth
  },
  height: {
    property: "height",
    scale: "sizes"
  },
  minWidth: {
    property: "minWidth",
    scale: "sizes"
  },
  minHeight: {
    property: "minHeight",
    scale: "sizes"
  },
  maxWidth: {
    property: "maxWidth",
    scale: "sizes"
  },
  maxHeight: {
    property: "maxHeight",
    scale: "sizes"
  },
  size: {
    properties: ["width", "height"],
    scale: "sizes"
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
var layout = system$1(config$7);
var config$6 = {
  color: {
    property: "color",
    scale: "colors"
  },
  backgroundColor: {
    property: "backgroundColor",
    scale: "colors"
  },
  opacity: true
};
config$6.bg = config$6.backgroundColor;
var color = system$1(config$6);
var defaults$5 = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var config$5 = {
  fontFamily: {
    property: "fontFamily",
    scale: "fonts"
  },
  fontSize: {
    property: "fontSize",
    scale: "fontSizes",
    defaultScale: defaults$5.fontSizes
  },
  fontWeight: {
    property: "fontWeight",
    scale: "fontWeights"
  },
  lineHeight: {
    property: "lineHeight",
    scale: "lineHeights"
  },
  letterSpacing: {
    property: "letterSpacing",
    scale: "letterSpacings"
  },
  textAlign: true,
  fontStyle: true
};
var typography$1 = system$1(config$5);
var config$4 = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = system$1(config$4);
var defaults$4 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config$3 = {
  gridGap: {
    property: "gridGap",
    scale: "space",
    defaultScale: defaults$4.space
  },
  gridColumnGap: {
    property: "gridColumnGap",
    scale: "space",
    defaultScale: defaults$4.space
  },
  gridRowGap: {
    property: "gridRowGap",
    scale: "space",
    defaultScale: defaults$4.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var grid = system$1(config$3);
var config$2 = {
  border: {
    property: "border",
    scale: "borders"
  },
  borderWidth: {
    property: "borderWidth",
    scale: "borderWidths"
  },
  borderStyle: {
    property: "borderStyle",
    scale: "borderStyles"
  },
  borderColor: {
    property: "borderColor",
    scale: "colors"
  },
  borderRadius: {
    property: "borderRadius",
    scale: "radii"
  },
  borderTop: {
    property: "borderTop",
    scale: "borders"
  },
  borderTopLeftRadius: {
    property: "borderTopLeftRadius",
    scale: "radii"
  },
  borderTopRightRadius: {
    property: "borderTopRightRadius",
    scale: "radii"
  },
  borderRight: {
    property: "borderRight",
    scale: "borders"
  },
  borderBottom: {
    property: "borderBottom",
    scale: "borders"
  },
  borderBottomLeftRadius: {
    property: "borderBottomLeftRadius",
    scale: "radii"
  },
  borderBottomRightRadius: {
    property: "borderBottomRightRadius",
    scale: "radii"
  },
  borderLeft: {
    property: "borderLeft",
    scale: "borders"
  },
  borderX: {
    properties: ["borderLeft", "borderRight"],
    scale: "borders"
  },
  borderY: {
    properties: ["borderTop", "borderBottom"],
    scale: "borders"
  }
};
config$2.borderTopWidth = {
  property: "borderTopWidth",
  scale: "borderWidths"
};
config$2.borderTopColor = {
  property: "borderTopColor",
  scale: "colors"
};
config$2.borderTopStyle = {
  property: "borderTopStyle",
  scale: "borderStyles"
};
config$2.borderTopLeftRadius = {
  property: "borderTopLeftRadius",
  scale: "radii"
};
config$2.borderTopRightRadius = {
  property: "borderTopRightRadius",
  scale: "radii"
};
config$2.borderBottomWidth = {
  property: "borderBottomWidth",
  scale: "borderWidths"
};
config$2.borderBottomColor = {
  property: "borderBottomColor",
  scale: "colors"
};
config$2.borderBottomStyle = {
  property: "borderBottomStyle",
  scale: "borderStyles"
};
config$2.borderBottomLeftRadius = {
  property: "borderBottomLeftRadius",
  scale: "radii"
};
config$2.borderBottomRightRadius = {
  property: "borderBottomRightRadius",
  scale: "radii"
};
config$2.borderLeftWidth = {
  property: "borderLeftWidth",
  scale: "borderWidths"
};
config$2.borderLeftColor = {
  property: "borderLeftColor",
  scale: "colors"
};
config$2.borderLeftStyle = {
  property: "borderLeftStyle",
  scale: "borderStyles"
};
config$2.borderRightWidth = {
  property: "borderRightWidth",
  scale: "borderWidths"
};
config$2.borderRightColor = {
  property: "borderRightColor",
  scale: "colors"
};
config$2.borderRightStyle = {
  property: "borderRightStyle",
  scale: "borderStyles"
};
var border = system$1(config$2);
var config$1 = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
config$1.bgImage = config$1.backgroundImage;
config$1.bgSize = config$1.backgroundSize;
config$1.bgPosition = config$1.backgroundPosition;
config$1.bgRepeat = config$1.backgroundRepeat;
var background = system$1(config$1);
var defaults$3 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config = {
  position: true,
  zIndex: {
    property: "zIndex",
    scale: "zIndices"
  },
  top: {
    property: "top",
    scale: "space",
    defaultScale: defaults$3.space
  },
  right: {
    property: "right",
    scale: "space",
    defaultScale: defaults$3.space
  },
  bottom: {
    property: "bottom",
    scale: "space",
    defaultScale: defaults$3.space
  },
  left: {
    property: "left",
    scale: "space",
    defaultScale: defaults$3.space
  }
};
var position$1 = system$1(config);
var defaults$2 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var isNumber$2 = function isNumber2(n2) {
  return typeof n2 === "number" && !isNaN(n2);
};
var getMargin = function getMargin2(n2, scale) {
  if (!isNumber$2(n2)) {
    return get$5(scale, n2, n2);
  }
  var isNegative = n2 < 0;
  var absolute = Math.abs(n2);
  var value = get$5(scale, absolute, absolute);
  if (!isNumber$2(value)) {
    return isNegative ? "-" + value : value;
  }
  return value * (isNegative ? -1 : 1);
};
var configs = {};
configs.margin = {
  margin: {
    property: "margin",
    scale: "space",
    transform: getMargin,
    defaultScale: defaults$2.space
  },
  marginTop: {
    property: "marginTop",
    scale: "space",
    transform: getMargin,
    defaultScale: defaults$2.space
  },
  marginRight: {
    property: "marginRight",
    scale: "space",
    transform: getMargin,
    defaultScale: defaults$2.space
  },
  marginBottom: {
    property: "marginBottom",
    scale: "space",
    transform: getMargin,
    defaultScale: defaults$2.space
  },
  marginLeft: {
    property: "marginLeft",
    scale: "space",
    transform: getMargin,
    defaultScale: defaults$2.space
  },
  marginX: {
    properties: ["marginLeft", "marginRight"],
    scale: "space",
    transform: getMargin,
    defaultScale: defaults$2.space
  },
  marginY: {
    properties: ["marginTop", "marginBottom"],
    scale: "space",
    transform: getMargin,
    defaultScale: defaults$2.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: "padding",
    scale: "space",
    defaultScale: defaults$2.space
  },
  paddingTop: {
    property: "paddingTop",
    scale: "space",
    defaultScale: defaults$2.space
  },
  paddingRight: {
    property: "paddingRight",
    scale: "space",
    defaultScale: defaults$2.space
  },
  paddingBottom: {
    property: "paddingBottom",
    scale: "space",
    defaultScale: defaults$2.space
  },
  paddingLeft: {
    property: "paddingLeft",
    scale: "space",
    defaultScale: defaults$2.space
  },
  paddingX: {
    properties: ["paddingLeft", "paddingRight"],
    scale: "space",
    defaultScale: defaults$2.space
  },
  paddingY: {
    properties: ["paddingTop", "paddingBottom"],
    scale: "space",
    defaultScale: defaults$2.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system$1(configs.margin);
var padding = system$1(configs.padding);
var space$1 = compose$1(margin, padding);
var shadow = system$1({
  boxShadow: {
    property: "boxShadow",
    scale: "shadows"
  },
  textShadow: {
    property: "textShadow",
    scale: "shadows"
  }
});
function _extends$1() {
  _extends$1 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
var get$4 = function get3(obj, key2, def2, p2, undef) {
  key2 = key2 && key2.split ? key2.split(".") : [key2];
  for (p2 = 0; p2 < key2.length; p2++) {
    obj = obj ? obj[key2[p2]] : undef;
  }
  return obj === undef ? def2 : obj;
};
var defaultBreakpoints = [40, 52, 64].map(function(n2) {
  return n2 + "em";
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases$1 = {
  bg: "backgroundColor",
  m: "margin",
  mt: "marginTop",
  mr: "marginRight",
  mb: "marginBottom",
  ml: "marginLeft",
  mx: "marginX",
  my: "marginY",
  p: "padding",
  pt: "paddingTop",
  pr: "paddingRight",
  pb: "paddingBottom",
  pl: "paddingLeft",
  px: "paddingX",
  py: "paddingY"
};
var multiples = {
  marginX: ["marginLeft", "marginRight"],
  marginY: ["marginTop", "marginBottom"],
  paddingX: ["paddingLeft", "paddingRight"],
  paddingY: ["paddingTop", "paddingBottom"],
  size: ["width", "height"]
};
var scales = {
  color: "colors",
  backgroundColor: "colors",
  borderColor: "colors",
  margin: "space",
  marginTop: "space",
  marginRight: "space",
  marginBottom: "space",
  marginLeft: "space",
  marginX: "space",
  marginY: "space",
  padding: "space",
  paddingTop: "space",
  paddingRight: "space",
  paddingBottom: "space",
  paddingLeft: "space",
  paddingX: "space",
  paddingY: "space",
  top: "space",
  right: "space",
  bottom: "space",
  left: "space",
  gridGap: "space",
  gridColumnGap: "space",
  gridRowGap: "space",
  gap: "space",
  columnGap: "space",
  rowGap: "space",
  fontFamily: "fonts",
  fontSize: "fontSizes",
  fontWeight: "fontWeights",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  border: "borders",
  borderTop: "borders",
  borderRight: "borders",
  borderBottom: "borders",
  borderLeft: "borders",
  borderWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderRadius: "radii",
  borderTopRightRadius: "radii",
  borderTopLeftRadius: "radii",
  borderBottomRightRadius: "radii",
  borderBottomLeftRadius: "radii",
  borderTopWidth: "borderWidths",
  borderTopColor: "colors",
  borderTopStyle: "borderStyles",
  borderBottomWidth: "borderWidths",
  borderBottomColor: "colors",
  borderBottomStyle: "borderStyles",
  borderLeftWidth: "borderWidths",
  borderLeftColor: "colors",
  borderLeftStyle: "borderStyles",
  borderRightWidth: "borderWidths",
  borderRightColor: "colors",
  borderRightStyle: "borderStyles",
  outlineColor: "colors",
  boxShadow: "shadows",
  textShadow: "shadows",
  zIndex: "zIndices",
  width: "sizes",
  minWidth: "sizes",
  maxWidth: "sizes",
  height: "sizes",
  minHeight: "sizes",
  maxHeight: "sizes",
  flexBasis: "sizes",
  size: "sizes",
  // svg
  fill: "colors",
  stroke: "colors"
};
var positiveOrNegative = function positiveOrNegative2(scale, value) {
  if (typeof value !== "number" || value >= 0) {
    return get$4(scale, value, value);
  }
  var absolute = Math.abs(value);
  var n2 = get$4(scale, absolute, absolute);
  if (typeof n2 === "string") return "-" + n2;
  return n2 * -1;
};
var transforms = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "top", "bottom", "left", "right"].reduce(function(acc, curr) {
  var _extends2;
  return _extends$1({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});
var responsive = function responsive2(styles2) {
  return function(theme2) {
    var next2 = {};
    var breakpoints2 = get$4(theme2, "breakpoints", defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints2.map(function(n2) {
      return "@media screen and (min-width: " + n2 + ")";
    }));
    for (var key2 in styles2) {
      var value = typeof styles2[key2] === "function" ? styles2[key2](theme2) : styles2[key2];
      if (value == null) continue;
      if (!Array.isArray(value)) {
        next2[key2] = value;
        continue;
      }
      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];
        if (!media) {
          next2[key2] = value[i];
          continue;
        }
        next2[media] = next2[media] || {};
        if (value[i] == null) continue;
        next2[media][key2] = value[i];
      }
    }
    return next2;
  };
};
var css = function css2(args) {
  return function(props) {
    if (props === void 0) {
      props = {};
    }
    var theme2 = _extends$1({}, defaultTheme, {}, props.theme || props);
    var result = {};
    var obj = typeof args === "function" ? args(theme2) : args;
    var styles2 = responsive(obj)(theme2);
    for (var key2 in styles2) {
      var x2 = styles2[key2];
      var val = typeof x2 === "function" ? x2(theme2) : x2;
      if (key2 === "variant") {
        var variant3 = css2(get$4(theme2, val))(theme2);
        result = _extends$1({}, result, {}, variant3);
        continue;
      }
      if (val && typeof val === "object") {
        result[key2] = css2(val)(theme2);
        continue;
      }
      var prop = get$4(aliases$1, key2, key2);
      var scaleName = get$4(scales, prop);
      var scale = get$4(theme2, scaleName, get$4(theme2, prop, {}));
      var transform = get$4(transforms, prop, get$4);
      var value = transform(scale, val, val);
      if (multiples[prop]) {
        var dirs = multiples[prop];
        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }
    return result;
  };
};
var variant = function variant2(_ref) {
  var _config;
  var scale = _ref.scale, _ref$prop = _ref.prop, prop = _ref$prop === void 0 ? "variant" : _ref$prop, _ref$variants = _ref.variants, variants2 = _ref$variants === void 0 ? {} : _ref$variants, key2 = _ref.key;
  var sx2;
  if (Object.keys(variants2).length) {
    sx2 = function sx3(value, scale2, props) {
      return css(get$5(scale2, value, null))(props.theme);
    };
  } else {
    sx2 = function sx3(value, scale2) {
      return get$5(scale2, value, null);
    };
  }
  sx2.scale = scale || key2;
  sx2.defaults = variants2;
  var config2 = (_config = {}, _config[prop] = sx2, _config);
  var parser = createParser(config2);
  return parser;
};
var buttonStyle$1 = variant({
  key: "buttons"
});
var textStyle = variant({
  key: "textStyles",
  prop: "textStyle"
});
var colorStyle = variant({
  key: "colorStyles",
  prop: "colors"
});
var width = layout.width, height = layout.height, minWidth = layout.minWidth, minHeight = layout.minHeight, maxWidth = layout.maxWidth, maxHeight = layout.maxHeight, size = layout.size, verticalAlign = layout.verticalAlign, display = layout.display, overflow = layout.overflow, overflowX = layout.overflowX, overflowY = layout.overflowY;
var opacity = color.opacity;
var fontSize = typography$1.fontSize, fontFamily = typography$1.fontFamily, fontWeight = typography$1.fontWeight, lineHeight = typography$1.lineHeight, textAlign = typography$1.textAlign, fontStyle = typography$1.fontStyle, letterSpacing = typography$1.letterSpacing;
var alignItems = flexbox.alignItems, alignContent = flexbox.alignContent, justifyItems = flexbox.justifyItems, justifyContent = flexbox.justifyContent, flexWrap = flexbox.flexWrap, flexDirection = flexbox.flexDirection, flex = flexbox.flex, flexGrow = flexbox.flexGrow, flexShrink = flexbox.flexShrink, flexBasis = flexbox.flexBasis, justifySelf = flexbox.justifySelf, alignSelf = flexbox.alignSelf, order$1 = flexbox.order;
var gridGap = grid.gridGap, gridColumnGap = grid.gridColumnGap, gridRowGap = grid.gridRowGap, gridColumn = grid.gridColumn, gridRow = grid.gridRow, gridAutoFlow = grid.gridAutoFlow, gridAutoColumns = grid.gridAutoColumns, gridAutoRows = grid.gridAutoRows, gridTemplateColumns = grid.gridTemplateColumns, gridTemplateRows = grid.gridTemplateRows, gridTemplateAreas = grid.gridTemplateAreas, gridArea = grid.gridArea;
var borderWidth = border.borderWidth, borderStyle = border.borderStyle, borderColor = border.borderColor, borderTop = border.borderTop, borderRight = border.borderRight, borderBottom = border.borderBottom, borderLeft = border.borderLeft, borderRadius = border.borderRadius;
var backgroundImage = background.backgroundImage, backgroundSize = background.backgroundSize, backgroundPosition = background.backgroundPosition, backgroundRepeat = background.backgroundRepeat;
var zIndex = position$1.zIndex, top = position$1.top, right = position$1.right, bottom = position$1.bottom, left = position$1.left;
var style$2 = function style(_ref) {
  var prop = _ref.prop, cssProperty = _ref.cssProperty, alias = _ref.alias, key2 = _ref.key, transformValue = _ref.transformValue, scale = _ref.scale, properties2 = _ref.properties;
  var config2 = {};
  config2[prop] = createStyleFunction({
    properties: properties2,
    property: cssProperty || prop,
    scale: key2,
    defaultScale: scale,
    transform: transformValue
  });
  if (alias) config2[alias] = config2[prop];
  var parse3 = createParser(config2);
  return parse3;
};
const styledSystem = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  alignContent,
  alignItems,
  alignSelf,
  background,
  backgroundImage,
  backgroundPosition,
  backgroundRepeat,
  backgroundSize,
  border,
  borderBottom,
  borderColor,
  borderLeft,
  borderRadius,
  borderRight,
  borderStyle,
  borderTop,
  borderWidth,
  borders: border,
  bottom,
  boxShadow: shadow,
  buttonStyle: buttonStyle$1,
  color,
  colorStyle,
  compose: compose$1,
  createParser,
  createStyleFunction,
  display,
  flex,
  flexBasis,
  flexDirection,
  flexGrow,
  flexShrink,
  flexWrap,
  flexbox,
  fontFamily,
  fontSize,
  fontStyle,
  fontWeight,
  get: get$5,
  grid,
  gridArea,
  gridAutoColumns,
  gridAutoFlow,
  gridAutoRows,
  gridColumn,
  gridColumnGap,
  gridGap,
  gridRow,
  gridRowGap,
  gridTemplateAreas,
  gridTemplateColumns,
  gridTemplateRows,
  height,
  justifyContent,
  justifyItems,
  justifySelf,
  layout,
  left,
  letterSpacing,
  lineHeight,
  margin,
  maxHeight,
  maxWidth,
  minHeight,
  minWidth,
  opacity,
  order: order$1,
  overflow,
  overflowX,
  overflowY,
  padding,
  position: position$1,
  right,
  shadow,
  size,
  space: space$1,
  style: style$2,
  system: system$1,
  textAlign,
  textShadow: shadow,
  textStyle,
  top,
  typography: typography$1,
  variant,
  verticalAlign,
  width,
  zIndex
}, Symbol.toStringTag, { value: "Module" }));
const {
  get: getKey,
  compose: compose2,
  system: system2
} = styledSystem;
const get$3 = (key2) => themeGet(key2, getKey(theme, key2));
const COMMON = compose2(space$1, color, display);
const whiteSpace = system2({
  whiteSpace: {
    property: "whiteSpace"
    // cssProperty: 'whiteSpace',
  }
});
const TYPOGRAPHY = compose2(typography$1, whiteSpace);
compose2(border, shadow);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @lightSyntaxTransform
 * @noflow
 * @nolint
 * @preventMunge
 * @preserve-invariant-messages
 */
var dist;
var hasRequiredDist;
function requireDist() {
  if (hasRequiredDist) return dist;
  hasRequiredDist = 1;
  var __create = Object.create;
  var __defProp3 = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all2) => {
    for (var name2 in all2)
      __defProp3(target, name2, { get: all2[name2], enumerable: true });
  };
  var __copyProps = (to2, from3, except, desc) => {
    if (from3 && typeof from3 === "object" || typeof from3 === "function") {
      for (let key2 of __getOwnPropNames(from3))
        if (!__hasOwnProp.call(to2, key2) && key2 !== except)
          __defProp3(to2, key2, { get: () => from3[key2], enumerable: !(desc = __getOwnPropDesc(from3, key2)) || desc.enumerable });
    }
    return to2;
  };
  var __toESM = (mod2, isNodeMode, target) => (target = mod2 != null ? __create(__getProtoOf(mod2)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !mod2 || !mod2.__esModule ? __defProp3(target, "default", { value: mod2, enumerable: true }) : target,
    mod2
  ));
  var __toCommonJS = (mod2) => __copyProps(__defProp3({}, "__esModule", { value: true }), mod2);
  var index_exports = {};
  __export(index_exports, {
    $dispatcherGuard: () => $dispatcherGuard,
    $makeReadOnly: () => $makeReadOnly,
    $reset: () => $reset,
    $structuralCheck: () => $structuralCheck,
    c: () => c2,
    clearRenderCounterRegistry: () => clearRenderCounterRegistry,
    renderCounterRegistry: () => renderCounterRegistry,
    useRenderCounter: () => useRenderCounter
  });
  dist = __toCommonJS(index_exports);
  var React2 = __toESM(React__default);
  var { useRef: useRef2, useEffect: useEffect2, isValidElement } = React2;
  var _a3;
  var ReactSecretInternals = (
    //@ts-ignore
    (_a3 = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE) != null ? _a3 : React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
  );
  var $empty = Symbol.for("react.memo_cache_sentinel");
  var _a22;
  var c2 = (
    // @ts-expect-error
    typeof ((_a22 = React2.__COMPILER_RUNTIME) == null ? void 0 : _a22.c) === "function" ? (
      // @ts-expect-error
      React2.__COMPILER_RUNTIME.c
    ) : function c22(size2) {
      return React2.useMemo(() => {
        const $2 = new Array(size2);
        for (let ii = 0; ii < size2; ii++) {
          $2[ii] = $empty;
        }
        $2[$empty] = true;
        return $2;
      }, []);
    }
  );
  var LazyGuardDispatcher = {};
  [
    "readContext",
    "useCallback",
    "useContext",
    "useEffect",
    "useImperativeHandle",
    "useInsertionEffect",
    "useLayoutEffect",
    "useMemo",
    "useReducer",
    "useRef",
    "useState",
    "useDebugValue",
    "useDeferredValue",
    "useTransition",
    "useMutableSource",
    "useSyncExternalStore",
    "useId",
    "unstable_isNewReconciler",
    "getCacheSignal",
    "getCacheForType",
    "useCacheRefresh"
  ].forEach((name2) => {
    LazyGuardDispatcher[name2] = () => {
      throw new Error(
        `[React] Unexpected React hook call (${name2}) from a React compiled function. Check that all hooks are called directly and named according to convention ('use[A-Z]') `
      );
    };
  });
  var originalDispatcher = null;
  LazyGuardDispatcher["useMemoCache"] = (count2) => {
    if (originalDispatcher == null) {
      throw new Error(
        "React Compiler internal invariant violation: unexpected null dispatcher"
      );
    } else {
      return originalDispatcher.useMemoCache(count2);
    }
  };
  function setCurrent(newDispatcher) {
    ReactSecretInternals.ReactCurrentDispatcher.current = newDispatcher;
    return ReactSecretInternals.ReactCurrentDispatcher.current;
  }
  var guardFrames = [];
  function $dispatcherGuard(kind) {
    const curr = ReactSecretInternals.ReactCurrentDispatcher.current;
    if (kind === 0) {
      guardFrames.push(curr);
      if (guardFrames.length === 1) {
        originalDispatcher = curr;
      }
      if (curr === LazyGuardDispatcher) {
        throw new Error(
          `[React] Unexpected call to custom hook or component from a React compiled function. Check that (1) all hooks are called directly and named according to convention ('use[A-Z]') and (2) components are returned as JSX instead of being directly invoked.`
        );
      }
      setCurrent(LazyGuardDispatcher);
    } else if (kind === 1) {
      const lastFrame = guardFrames.pop();
      if (lastFrame == null) {
        throw new Error(
          "React Compiler internal error: unexpected null in guard stack"
        );
      }
      if (guardFrames.length === 0) {
        originalDispatcher = null;
      }
      setCurrent(lastFrame);
    } else if (kind === 2) {
      guardFrames.push(curr);
      setCurrent(originalDispatcher);
    } else if (kind === 3) {
      const lastFrame = guardFrames.pop();
      if (lastFrame == null) {
        throw new Error(
          "React Compiler internal error: unexpected null in guard stack"
        );
      }
      setCurrent(lastFrame);
    } else {
      throw new Error("React Compiler internal error: unreachable block" + kind);
    }
  }
  function $reset($2) {
    for (let ii = 0; ii < $2.length; ii++) {
      $2[ii] = $empty;
    }
  }
  function $makeReadOnly() {
    throw new Error("TODO: implement $makeReadOnly in react-compiler-runtime");
  }
  var renderCounterRegistry = /* @__PURE__ */ new Map();
  function clearRenderCounterRegistry() {
    for (const counters of renderCounterRegistry.values()) {
      counters.forEach((counter) => {
        counter.count = 0;
      });
    }
  }
  function registerRenderCounter(name2, val) {
    let counters = renderCounterRegistry.get(name2);
    if (counters == null) {
      counters = /* @__PURE__ */ new Set();
      renderCounterRegistry.set(name2, counters);
    }
    counters.add(val);
  }
  function removeRenderCounter(name2, val) {
    const counters = renderCounterRegistry.get(name2);
    if (counters == null) {
      return;
    }
    counters.delete(val);
  }
  function useRenderCounter(name2) {
    const val = useRef2(null);
    if (val.current != null) {
      val.current.count += 1;
    }
    useEffect2(() => {
      if (val.current == null) {
        const counter = { count: 0 };
        registerRenderCounter(name2, counter);
        val.current = counter;
      }
      return () => {
        if (val.current !== null) {
          removeRenderCounter(name2, val.current);
        }
      };
    });
  }
  var seenErrors = /* @__PURE__ */ new Set();
  function $structuralCheck(oldValue, newValue, variableName, fnName, kind, loc) {
    function error2(l2, r2, path2, depth) {
      const str = `${fnName}:${loc} [${kind}] ${variableName}${path2} changed from ${l2} to ${r2} at depth ${depth}`;
      if (seenErrors.has(str)) {
        return;
      }
      seenErrors.add(str);
      console.error(str);
    }
    const depthLimit = 2;
    function recur(oldValue2, newValue2, path2, depth) {
      if (depth > depthLimit) {
        return;
      } else if (oldValue2 === newValue2) {
        return;
      } else if (typeof oldValue2 !== typeof newValue2) {
        error2(`type ${typeof oldValue2}`, `type ${typeof newValue2}`, path2, depth);
      } else if (typeof oldValue2 === "object") {
        const oldArray = Array.isArray(oldValue2);
        const newArray = Array.isArray(newValue2);
        if (oldValue2 === null && newValue2 !== null) {
          error2("null", `type ${typeof newValue2}`, path2, depth);
        } else if (newValue2 === null) {
          error2(`type ${typeof oldValue2}`, "null", path2, depth);
        } else if (oldValue2 instanceof Map) {
          if (!(newValue2 instanceof Map)) {
            error2(`Map instance`, `other value`, path2, depth);
          } else if (oldValue2.size !== newValue2.size) {
            error2(
              `Map instance with size ${oldValue2.size}`,
              `Map instance with size ${newValue2.size}`,
              path2,
              depth
            );
          } else {
            for (const [k2, v2] of oldValue2) {
              if (!newValue2.has(k2)) {
                error2(
                  `Map instance with key ${k2}`,
                  `Map instance without key ${k2}`,
                  path2,
                  depth
                );
              } else {
                recur(v2, newValue2.get(k2), `${path2}.get(${k2})`, depth + 1);
              }
            }
          }
        } else if (newValue2 instanceof Map) {
          error2("other value", `Map instance`, path2, depth);
        } else if (oldValue2 instanceof Set) {
          if (!(newValue2 instanceof Set)) {
            error2(`Set instance`, `other value`, path2, depth);
          } else if (oldValue2.size !== newValue2.size) {
            error2(
              `Set instance with size ${oldValue2.size}`,
              `Set instance with size ${newValue2.size}`,
              path2,
              depth
            );
          } else {
            for (const v2 of newValue2) {
              if (!oldValue2.has(v2)) {
                error2(
                  `Set instance without element ${v2}`,
                  `Set instance with element ${v2}`,
                  path2,
                  depth
                );
              }
            }
          }
        } else if (newValue2 instanceof Set) {
          error2("other value", `Set instance`, path2, depth);
        } else if (oldArray || newArray) {
          if (oldArray !== newArray) {
            error2(
              `type ${oldArray ? "array" : "object"}`,
              `type ${newArray ? "array" : "object"}`,
              path2,
              depth
            );
          } else if (oldValue2.length !== newValue2.length) {
            error2(
              `array with length ${oldValue2.length}`,
              `array with length ${newValue2.length}`,
              path2,
              depth
            );
          } else {
            for (let ii = 0; ii < oldValue2.length; ii++) {
              recur(oldValue2[ii], newValue2[ii], `${path2}[${ii}]`, depth + 1);
            }
          }
        } else if (isValidElement(oldValue2) || isValidElement(newValue2)) {
          if (isValidElement(oldValue2) !== isValidElement(newValue2)) {
            error2(
              `type ${isValidElement(oldValue2) ? "React element" : "object"}`,
              `type ${isValidElement(newValue2) ? "React element" : "object"}`,
              path2,
              depth
            );
          } else if (oldValue2.type !== newValue2.type) {
            error2(
              `React element of type ${oldValue2.type}`,
              `React element of type ${newValue2.type}`,
              path2,
              depth
            );
          } else {
            recur(
              oldValue2.props,
              newValue2.props,
              `[props of ${path2}]`,
              depth + 1
            );
          }
        } else {
          for (const key2 in newValue2) {
            if (!(key2 in oldValue2)) {
              error2(
                `object without key ${key2}`,
                `object with key ${key2}`,
                path2,
                depth
              );
            }
          }
          for (const key2 in oldValue2) {
            if (!(key2 in newValue2)) {
              error2(
                `object with key ${key2}`,
                `object without key ${key2}`,
                path2,
                depth
              );
            } else {
              recur(oldValue2[key2], newValue2[key2], `${path2}.${key2}`, depth + 1);
            }
          }
        }
      } else if (typeof oldValue2 === "function") {
        return;
      } else if (isNaN(oldValue2) || isNaN(newValue2)) {
        if (isNaN(oldValue2) !== isNaN(newValue2)) {
          error2(
            `${isNaN(oldValue2) ? "NaN" : "non-NaN value"}`,
            `${isNaN(newValue2) ? "NaN" : "non-NaN value"}`,
            path2,
            depth
          );
        }
      } else if (oldValue2 !== newValue2) {
        error2(oldValue2, newValue2, path2, depth);
      }
    }
    recur(oldValue, newValue, "", 0);
  }
  return dist;
}
var distExports = requireDist();
function stylis_min(W2) {
  function M2(d2, c2, e, h2, a2) {
    for (var m2 = 0, b2 = 0, v2 = 0, n2 = 0, q2, g2, x2 = 0, K2 = 0, k2, u2 = k2 = q2 = 0, l2 = 0, r2 = 0, I2 = 0, t2 = 0, B3 = e.length, J2 = B3 - 1, y2, f2 = "", p2 = "", F3 = "", G3 = "", C2; l2 < B3; ) {
      g2 = e.charCodeAt(l2);
      l2 === J2 && 0 !== b2 + n2 + v2 + m2 && (0 !== b2 && (g2 = 47 === b2 ? 10 : 47), n2 = v2 = m2 = 0, B3++, J2++);
      if (0 === b2 + n2 + v2 + m2) {
        if (l2 === J2 && (0 < r2 && (f2 = f2.replace(N2, "")), 0 < f2.trim().length)) {
          switch (g2) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              f2 += e.charAt(l2);
          }
          g2 = 59;
        }
        switch (g2) {
          case 123:
            f2 = f2.trim();
            q2 = f2.charCodeAt(0);
            k2 = 1;
            for (t2 = ++l2; l2 < B3; ) {
              switch (g2 = e.charCodeAt(l2)) {
                case 123:
                  k2++;
                  break;
                case 125:
                  k2--;
                  break;
                case 47:
                  switch (g2 = e.charCodeAt(l2 + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u2 = l2 + 1; u2 < J2; ++u2) {
                          switch (e.charCodeAt(u2)) {
                            case 47:
                              if (42 === g2 && 42 === e.charCodeAt(u2 - 1) && l2 + 2 !== u2) {
                                l2 = u2 + 1;
                                break a;
                              }
                              break;
                            case 10:
                              if (47 === g2) {
                                l2 = u2 + 1;
                                break a;
                              }
                          }
                        }
                        l2 = u2;
                      }
                  }
                  break;
                case 91:
                  g2++;
                case 40:
                  g2++;
                case 34:
                case 39:
                  for (; l2++ < J2 && e.charCodeAt(l2) !== g2; ) {
                  }
              }
              if (0 === k2) break;
              l2++;
            }
            k2 = e.substring(t2, l2);
            0 === q2 && (q2 = (f2 = f2.replace(ca, "").trim()).charCodeAt(0));
            switch (q2) {
              case 64:
                0 < r2 && (f2 = f2.replace(N2, ""));
                g2 = f2.charCodeAt(1);
                switch (g2) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r2 = c2;
                    break;
                  default:
                    r2 = O2;
                }
                k2 = M2(c2, r2, k2, g2, a2 + 1);
                t2 = k2.length;
                0 < A2 && (r2 = X2(O2, f2, I2), C2 = H2(3, k2, r2, c2, D2, z2, t2, g2, a2, h2), f2 = r2.join(""), void 0 !== C2 && 0 === (t2 = (k2 = C2.trim()).length) && (g2 = 0, k2 = ""));
                if (0 < t2) switch (g2) {
                  case 115:
                    f2 = f2.replace(da, ea);
                  case 100:
                  case 109:
                  case 45:
                    k2 = f2 + "{" + k2 + "}";
                    break;
                  case 107:
                    f2 = f2.replace(fa, "$1 $2");
                    k2 = f2 + "{" + k2 + "}";
                    k2 = 1 === w2 || 2 === w2 && L2("@" + k2, 3) ? "@-webkit-" + k2 + "@" + k2 : "@" + k2;
                    break;
                  default:
                    k2 = f2 + k2, 112 === h2 && (k2 = (p2 += k2, ""));
                }
                else k2 = "";
                break;
              default:
                k2 = M2(c2, X2(c2, f2, I2), k2, h2, a2 + 1);
            }
            F3 += k2;
            k2 = I2 = r2 = u2 = q2 = 0;
            f2 = "";
            g2 = e.charCodeAt(++l2);
            break;
          case 125:
          case 59:
            f2 = (0 < r2 ? f2.replace(N2, "") : f2).trim();
            if (1 < (t2 = f2.length)) switch (0 === u2 && (q2 = f2.charCodeAt(0), 45 === q2 || 96 < q2 && 123 > q2) && (t2 = (f2 = f2.replace(" ", ":")).length), 0 < A2 && void 0 !== (C2 = H2(1, f2, c2, d2, D2, z2, p2.length, h2, a2, h2)) && 0 === (t2 = (f2 = C2.trim()).length) && (f2 = "\0\0"), q2 = f2.charCodeAt(0), g2 = f2.charCodeAt(1), q2) {
              case 0:
                break;
              case 64:
                if (105 === g2 || 99 === g2) {
                  G3 += f2 + e.charAt(l2);
                  break;
                }
              default:
                58 !== f2.charCodeAt(t2 - 1) && (p2 += P2(f2, q2, g2, f2.charCodeAt(2)));
            }
            I2 = r2 = u2 = q2 = 0;
            f2 = "";
            g2 = e.charCodeAt(++l2);
        }
      }
      switch (g2) {
        case 13:
        case 10:
          47 === b2 ? b2 = 0 : 0 === 1 + q2 && 107 !== h2 && 0 < f2.length && (r2 = 1, f2 += "\0");
          0 < A2 * Y2 && H2(0, f2, c2, d2, D2, z2, p2.length, h2, a2, h2);
          z2 = 1;
          D2++;
          break;
        case 59:
        case 125:
          if (0 === b2 + n2 + v2 + m2) {
            z2++;
            break;
          }
        default:
          z2++;
          y2 = e.charAt(l2);
          switch (g2) {
            case 9:
            case 32:
              if (0 === n2 + m2 + b2) switch (x2) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y2 = "";
                  break;
                default:
                  32 !== g2 && (y2 = " ");
              }
              break;
            case 0:
              y2 = "\\0";
              break;
            case 12:
              y2 = "\\f";
              break;
            case 11:
              y2 = "\\v";
              break;
            case 38:
              0 === n2 + b2 + m2 && (r2 = I2 = 1, y2 = "\f" + y2);
              break;
            case 108:
              if (0 === n2 + b2 + m2 + E2 && 0 < u2) switch (l2 - u2) {
                case 2:
                  112 === x2 && 58 === e.charCodeAt(l2 - 3) && (E2 = x2);
                case 8:
                  111 === K2 && (E2 = K2);
              }
              break;
            case 58:
              0 === n2 + b2 + m2 && (u2 = l2);
              break;
            case 44:
              0 === b2 + v2 + n2 + m2 && (r2 = 1, y2 += "\r");
              break;
            case 34:
            case 39:
              0 === b2 && (n2 = n2 === g2 ? 0 : 0 === n2 ? g2 : n2);
              break;
            case 91:
              0 === n2 + b2 + v2 && m2++;
              break;
            case 93:
              0 === n2 + b2 + v2 && m2--;
              break;
            case 41:
              0 === n2 + b2 + m2 && v2--;
              break;
            case 40:
              if (0 === n2 + b2 + m2) {
                if (0 === q2) switch (2 * x2 + 3 * K2) {
                  case 533:
                    break;
                  default:
                    q2 = 1;
                }
                v2++;
              }
              break;
            case 64:
              0 === b2 + v2 + n2 + m2 + u2 + k2 && (k2 = 1);
              break;
            case 42:
            case 47:
              if (!(0 < n2 + m2 + v2)) switch (b2) {
                case 0:
                  switch (2 * g2 + 3 * e.charCodeAt(l2 + 1)) {
                    case 235:
                      b2 = 47;
                      break;
                    case 220:
                      t2 = l2, b2 = 42;
                  }
                  break;
                case 42:
                  47 === g2 && 42 === x2 && t2 + 2 !== l2 && (33 === e.charCodeAt(t2 + 2) && (p2 += e.substring(t2, l2 + 1)), y2 = "", b2 = 0);
              }
          }
          0 === b2 && (f2 += y2);
      }
      K2 = x2;
      x2 = g2;
      l2++;
    }
    t2 = p2.length;
    if (0 < t2) {
      r2 = c2;
      if (0 < A2 && (C2 = H2(2, p2, r2, d2, D2, z2, t2, h2, a2, h2), void 0 !== C2 && 0 === (p2 = C2).length)) return G3 + p2 + F3;
      p2 = r2.join(",") + "{" + p2 + "}";
      if (0 !== w2 * E2) {
        2 !== w2 || L2(p2, 2) || (E2 = 0);
        switch (E2) {
          case 111:
            p2 = p2.replace(ha, ":-moz-$1") + p2;
            break;
          case 112:
            p2 = p2.replace(Q2, "::-webkit-input-$1") + p2.replace(Q2, "::-moz-$1") + p2.replace(Q2, ":-ms-input-$1") + p2;
        }
        E2 = 0;
      }
    }
    return G3 + p2 + F3;
  }
  function X2(d2, c2, e) {
    var h2 = c2.trim().split(ia);
    c2 = h2;
    var a2 = h2.length, m2 = d2.length;
    switch (m2) {
      case 0:
      case 1:
        var b2 = 0;
        for (d2 = 0 === m2 ? "" : d2[0] + " "; b2 < a2; ++b2) {
          c2[b2] = Z2(d2, c2[b2], e).trim();
        }
        break;
      default:
        var v2 = b2 = 0;
        for (c2 = []; b2 < a2; ++b2) {
          for (var n2 = 0; n2 < m2; ++n2) {
            c2[v2++] = Z2(d2[n2] + " ", h2[b2], e).trim();
          }
        }
    }
    return c2;
  }
  function Z2(d2, c2, e) {
    var h2 = c2.charCodeAt(0);
    33 > h2 && (h2 = (c2 = c2.trim()).charCodeAt(0));
    switch (h2) {
      case 38:
        return c2.replace(F2, "$1" + d2.trim());
      case 58:
        return d2.trim() + c2.replace(F2, "$1" + d2.trim());
      default:
        if (0 < 1 * e && 0 < c2.indexOf("\f")) return c2.replace(F2, (58 === d2.charCodeAt(0) ? "" : "$1") + d2.trim());
    }
    return d2 + c2;
  }
  function P2(d2, c2, e, h2) {
    var a2 = d2 + ";", m2 = 2 * c2 + 3 * e + 4 * h2;
    if (944 === m2) {
      d2 = a2.indexOf(":", 9) + 1;
      var b2 = a2.substring(d2, a2.length - 1).trim();
      b2 = a2.substring(0, d2).trim() + b2 + ";";
      return 1 === w2 || 2 === w2 && L2(b2, 1) ? "-webkit-" + b2 + b2 : b2;
    }
    if (0 === w2 || 2 === w2 && !L2(a2, 1)) return a2;
    switch (m2) {
      case 1015:
        return 97 === a2.charCodeAt(10) ? "-webkit-" + a2 + a2 : a2;
      case 951:
        return 116 === a2.charCodeAt(3) ? "-webkit-" + a2 + a2 : a2;
      case 963:
        return 110 === a2.charCodeAt(5) ? "-webkit-" + a2 + a2 : a2;
      case 1009:
        if (100 !== a2.charCodeAt(4)) break;
      case 969:
      case 942:
        return "-webkit-" + a2 + a2;
      case 978:
        return "-webkit-" + a2 + "-moz-" + a2 + a2;
      case 1019:
      case 983:
        return "-webkit-" + a2 + "-moz-" + a2 + "-ms-" + a2 + a2;
      case 883:
        if (45 === a2.charCodeAt(8)) return "-webkit-" + a2 + a2;
        if (0 < a2.indexOf("image-set(", 11)) return a2.replace(ja, "$1-webkit-$2") + a2;
        break;
      case 932:
        if (45 === a2.charCodeAt(4)) switch (a2.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + a2.replace("-grow", "") + "-webkit-" + a2 + "-ms-" + a2.replace("grow", "positive") + a2;
          case 115:
            return "-webkit-" + a2 + "-ms-" + a2.replace("shrink", "negative") + a2;
          case 98:
            return "-webkit-" + a2 + "-ms-" + a2.replace("basis", "preferred-size") + a2;
        }
        return "-webkit-" + a2 + "-ms-" + a2 + a2;
      case 964:
        return "-webkit-" + a2 + "-ms-flex-" + a2 + a2;
      case 1023:
        if (99 !== a2.charCodeAt(8)) break;
        b2 = a2.substring(a2.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
        return "-webkit-box-pack" + b2 + "-webkit-" + a2 + "-ms-flex-pack" + b2 + a2;
      case 1005:
        return ka.test(a2) ? a2.replace(aa, ":-webkit-") + a2.replace(aa, ":-moz-") + a2 : a2;
      case 1e3:
        b2 = a2.substring(13).trim();
        c2 = b2.indexOf("-") + 1;
        switch (b2.charCodeAt(0) + b2.charCodeAt(c2)) {
          case 226:
            b2 = a2.replace(G2, "tb");
            break;
          case 232:
            b2 = a2.replace(G2, "tb-rl");
            break;
          case 220:
            b2 = a2.replace(G2, "lr");
            break;
          default:
            return a2;
        }
        return "-webkit-" + a2 + "-ms-" + b2 + a2;
      case 1017:
        if (-1 === a2.indexOf("sticky", 9)) break;
      case 975:
        c2 = (a2 = d2).length - 10;
        b2 = (33 === a2.charCodeAt(c2) ? a2.substring(0, c2) : a2).substring(d2.indexOf(":", 7) + 1).trim();
        switch (m2 = b2.charCodeAt(0) + (b2.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b2.charCodeAt(8)) break;
          case 115:
            a2 = a2.replace(b2, "-webkit-" + b2) + ";" + a2;
            break;
          case 207:
          case 102:
            a2 = a2.replace(b2, "-webkit-" + (102 < m2 ? "inline-" : "") + "box") + ";" + a2.replace(b2, "-webkit-" + b2) + ";" + a2.replace(b2, "-ms-" + b2 + "box") + ";" + a2;
        }
        return a2 + ";";
      case 938:
        if (45 === a2.charCodeAt(5)) switch (a2.charCodeAt(6)) {
          case 105:
            return b2 = a2.replace("-items", ""), "-webkit-" + a2 + "-webkit-box-" + b2 + "-ms-flex-" + b2 + a2;
          case 115:
            return "-webkit-" + a2 + "-ms-flex-item-" + a2.replace(ba, "") + a2;
          default:
            return "-webkit-" + a2 + "-ms-flex-line-pack" + a2.replace("align-content", "").replace(ba, "") + a2;
        }
        break;
      case 973:
      case 989:
        if (45 !== a2.charCodeAt(3) || 122 === a2.charCodeAt(4)) break;
      case 931:
      case 953:
        if (true === la.test(d2)) return 115 === (b2 = d2.substring(d2.indexOf(":") + 1)).charCodeAt(0) ? P2(d2.replace("stretch", "fill-available"), c2, e, h2).replace(":fill-available", ":stretch") : a2.replace(b2, "-webkit-" + b2) + a2.replace(b2, "-moz-" + b2.replace("fill-", "")) + a2;
        break;
      case 962:
        if (a2 = "-webkit-" + a2 + (102 === a2.charCodeAt(5) ? "-ms-" + a2 : "") + a2, 211 === e + h2 && 105 === a2.charCodeAt(13) && 0 < a2.indexOf("transform", 10)) return a2.substring(0, a2.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a2;
    }
    return a2;
  }
  function L2(d2, c2) {
    var e = d2.indexOf(1 === c2 ? ":" : "{"), h2 = d2.substring(0, 3 !== c2 ? e : 10);
    e = d2.substring(e + 1, d2.length - 1);
    return R2(2 !== c2 ? h2 : h2.replace(na, "$1"), e, c2);
  }
  function ea(d2, c2) {
    var e = P2(c2, c2.charCodeAt(0), c2.charCodeAt(1), c2.charCodeAt(2));
    return e !== c2 + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c2 + ")";
  }
  function H2(d2, c2, e, h2, a2, m2, b2, v2, n2, q2) {
    for (var g2 = 0, x2 = c2, w3; g2 < A2; ++g2) {
      switch (w3 = S2[g2].call(B2, d2, x2, e, h2, a2, m2, b2, v2, n2, q2)) {
        case void 0:
        case false:
        case true:
        case null:
          break;
        default:
          x2 = w3;
      }
    }
    if (x2 !== c2) return x2;
  }
  function T2(d2) {
    switch (d2) {
      case void 0:
      case null:
        A2 = S2.length = 0;
        break;
      default:
        if ("function" === typeof d2) S2[A2++] = d2;
        else if ("object" === typeof d2) for (var c2 = 0, e = d2.length; c2 < e; ++c2) {
          T2(d2[c2]);
        }
        else Y2 = !!d2 | 0;
    }
    return T2;
  }
  function U2(d2) {
    d2 = d2.prefix;
    void 0 !== d2 && (R2 = null, d2 ? "function" !== typeof d2 ? w2 = 1 : (w2 = 2, R2 = d2) : w2 = 0);
    return U2;
  }
  function B2(d2, c2) {
    var e = d2;
    33 > e.charCodeAt(0) && (e = e.trim());
    V2 = e;
    e = [V2];
    if (0 < A2) {
      var h2 = H2(-1, c2, e, e, D2, z2, 0, 0, 0, 0);
      void 0 !== h2 && "string" === typeof h2 && (c2 = h2);
    }
    var a2 = M2(O2, e, c2, 0, 0);
    0 < A2 && (h2 = H2(-2, a2, e, e, D2, z2, a2.length, 0, 0, 0), void 0 !== h2 && (a2 = h2));
    V2 = "";
    E2 = 0;
    z2 = D2 = 1;
    return a2;
  }
  var ca = /^\0+/g, N2 = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F2 = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q2 = /::(place)/g, ha = /:(read-only)/g, G2 = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z2 = 1, D2 = 1, E2 = 0, w2 = 1, O2 = [], S2 = [], A2 = 0, R2 = null, Y2 = 0, V2 = "";
  B2.use = T2;
  B2.set = U2;
  void 0 !== W2 && U2(W2);
  return B2;
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function y() {
  return (y = Object.assign || function(e) {
    for (var t2 = 1; t2 < arguments.length; t2++) {
      var n2 = arguments[t2];
      for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e[r2] = n2[r2]);
    }
    return e;
  }).apply(this, arguments);
}
var v = function(e, t2) {
  for (var n2 = [e[0]], r2 = 0, o2 = t2.length; r2 < o2; r2 += 1) n2.push(t2[r2], e[r2 + 1]);
  return n2;
}, g = function(t2) {
  return null !== t2 && "object" == typeof t2 && "[object Object]" === (t2.toString ? t2.toString() : Object.prototype.toString.call(t2)) && !reactIsExports.typeOf(t2);
}, S = Object.freeze([]), w = Object.freeze({});
function E(e) {
  return "function" == typeof e;
}
function b(e) {
  return "production" !== process.env.NODE_ENV && "string" == typeof e && e || e.displayName || e.name || "Component";
}
function _(e) {
  return e && "string" == typeof e.styledComponentId;
}
var N = "undefined" != typeof process && void 0 !== process.env && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", C = "undefined" != typeof window && "HTMLElement" in window, I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env && (void 0 !== process.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== process.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== process.env.REACT_APP_SC_DISABLE_SPEEDY && process.env.REACT_APP_SC_DISABLE_SPEEDY : void 0 !== process.env.SC_DISABLE_SPEEDY && "" !== process.env.SC_DISABLE_SPEEDY ? "false" !== process.env.SC_DISABLE_SPEEDY && process.env.SC_DISABLE_SPEEDY : "production" !== process.env.NODE_ENV)), O = "production" !== process.env.NODE_ENV ? { 1: "Cannot create styled-component for component: %s.\n\n", 2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n", 3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n", 4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n", 5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n", 6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n", 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: 'ThemeProvider: Please make your "theme" prop an object.\n\n', 9: "Missing document `<head>`\n\n", 10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n", 11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n", 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n", 14: 'ThemeProvider: "theme" prop is required.\n\n', 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n", 17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n" } : {};
function R() {
  for (var e = arguments.length <= 0 ? void 0 : arguments[0], t2 = [], n2 = 1, r2 = arguments.length; n2 < r2; n2 += 1) t2.push(n2 < 0 || arguments.length <= n2 ? void 0 : arguments[n2]);
  return t2.forEach(function(t3) {
    e = e.replace(/%[a-z]/, t3);
  }), e;
}
function D(e) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++) n2[r2 - 1] = arguments[r2];
  throw "production" === process.env.NODE_ENV ? new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n2.length > 0 ? " Args: " + n2.join(", ") : "")) : new Error(R.apply(void 0, [O[e]].concat(n2)).trim());
}
var j = function() {
  function e(e2) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e2;
  }
  var t2 = e.prototype;
  return t2.indexOfGroup = function(e2) {
    for (var t3 = 0, n2 = 0; n2 < e2; n2++) t3 += this.groupSizes[n2];
    return t3;
  }, t2.insertRules = function(e2, t3) {
    if (e2 >= this.groupSizes.length) {
      for (var n2 = this.groupSizes, r2 = n2.length, o2 = r2; e2 >= o2; ) (o2 <<= 1) < 0 && D(16, "" + e2);
      this.groupSizes = new Uint32Array(o2), this.groupSizes.set(n2), this.length = o2;
      for (var s2 = r2; s2 < o2; s2++) this.groupSizes[s2] = 0;
    }
    for (var i = this.indexOfGroup(e2 + 1), a2 = 0, c2 = t3.length; a2 < c2; a2++) this.tag.insertRule(i, t3[a2]) && (this.groupSizes[e2]++, i++);
  }, t2.clearGroup = function(e2) {
    if (e2 < this.length) {
      var t3 = this.groupSizes[e2], n2 = this.indexOfGroup(e2), r2 = n2 + t3;
      this.groupSizes[e2] = 0;
      for (var o2 = n2; o2 < r2; o2++) this.tag.deleteRule(n2);
    }
  }, t2.getGroup = function(e2) {
    var t3 = "";
    if (e2 >= this.length || 0 === this.groupSizes[e2]) return t3;
    for (var n2 = this.groupSizes[e2], r2 = this.indexOfGroup(e2), o2 = r2 + n2, s2 = r2; s2 < o2; s2++) t3 += this.tag.getRule(s2) + "/*!sc*/\n";
    return t3;
  }, e;
}(), T = /* @__PURE__ */ new Map(), x = /* @__PURE__ */ new Map(), k = 1, V = function(e) {
  if (T.has(e)) return T.get(e);
  for (; x.has(k); ) k++;
  var t2 = k++;
  return "production" !== process.env.NODE_ENV && ((0 | t2) < 0 || t2 > 1 << 30) && D(16, "" + t2), T.set(e, t2), x.set(t2, e), t2;
}, B = function(e) {
  return x.get(e);
}, z = function(e, t2) {
  t2 >= k && (k = t2 + 1), T.set(e, t2), x.set(t2, e);
}, M = "style[" + N + '][data-styled-version="5.3.11"]', G = new RegExp("^" + N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), L = function(e, t2, n2) {
  for (var r2, o2 = n2.split(","), s2 = 0, i = o2.length; s2 < i; s2++) (r2 = o2[s2]) && e.registerName(t2, r2);
}, F = function(e, t2) {
  for (var n2 = (t2.textContent || "").split("/*!sc*/\n"), r2 = [], o2 = 0, s2 = n2.length; o2 < s2; o2++) {
    var i = n2[o2].trim();
    if (i) {
      var a2 = i.match(G);
      if (a2) {
        var c2 = 0 | parseInt(a2[1], 10), u2 = a2[2];
        0 !== c2 && (z(u2, c2), L(e, u2, a2[3]), e.getTag().insertRules(c2, r2)), r2.length = 0;
      } else r2.push(i);
    }
  }
}, Y = function() {
  return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, q = function(e) {
  var t2 = document.head, n2 = e || t2, r2 = document.createElement("style"), o2 = function(e2) {
    for (var t3 = e2.childNodes, n3 = t3.length; n3 >= 0; n3--) {
      var r3 = t3[n3];
      if (r3 && 1 === r3.nodeType && r3.hasAttribute(N)) return r3;
    }
  }(n2), s2 = void 0 !== o2 ? o2.nextSibling : null;
  r2.setAttribute(N, "active"), r2.setAttribute("data-styled-version", "5.3.11");
  var i = Y();
  return i && r2.setAttribute("nonce", i), n2.insertBefore(r2, s2), r2;
}, H = function() {
  function e(e2) {
    var t3 = this.element = q(e2);
    t3.appendChild(document.createTextNode("")), this.sheet = function(e3) {
      if (e3.sheet) return e3.sheet;
      for (var t4 = document.styleSheets, n2 = 0, r2 = t4.length; n2 < r2; n2++) {
        var o2 = t4[n2];
        if (o2.ownerNode === e3) return o2;
      }
      D(17);
    }(t3), this.length = 0;
  }
  var t2 = e.prototype;
  return t2.insertRule = function(e2, t3) {
    try {
      return this.sheet.insertRule(t3, e2), this.length++, true;
    } catch (e3) {
      return false;
    }
  }, t2.deleteRule = function(e2) {
    this.sheet.deleteRule(e2), this.length--;
  }, t2.getRule = function(e2) {
    var t3 = this.sheet.cssRules[e2];
    return void 0 !== t3 && "string" == typeof t3.cssText ? t3.cssText : "";
  }, e;
}(), $ = function() {
  function e(e2) {
    var t3 = this.element = q(e2);
    this.nodes = t3.childNodes, this.length = 0;
  }
  var t2 = e.prototype;
  return t2.insertRule = function(e2, t3) {
    if (e2 <= this.length && e2 >= 0) {
      var n2 = document.createTextNode(t3), r2 = this.nodes[e2];
      return this.element.insertBefore(n2, r2 || null), this.length++, true;
    }
    return false;
  }, t2.deleteRule = function(e2) {
    this.element.removeChild(this.nodes[e2]), this.length--;
  }, t2.getRule = function(e2) {
    return e2 < this.length ? this.nodes[e2].textContent : "";
  }, e;
}(), W = function() {
  function e(e2) {
    this.rules = [], this.length = 0;
  }
  var t2 = e.prototype;
  return t2.insertRule = function(e2, t3) {
    return e2 <= this.length && (this.rules.splice(e2, 0, t3), this.length++, true);
  }, t2.deleteRule = function(e2) {
    this.rules.splice(e2, 1), this.length--;
  }, t2.getRule = function(e2) {
    return e2 < this.length ? this.rules[e2] : "";
  }, e;
}(), U = C, J = { isServer: !C, useCSSOMInjection: !I }, X = function() {
  function e(e2, t3, n2) {
    void 0 === e2 && (e2 = w), void 0 === t3 && (t3 = {}), this.options = y({}, J, {}, e2), this.gs = t3, this.names = new Map(n2), this.server = !!e2.isServer, !this.server && C && U && (U = false, function(e3) {
      for (var t4 = document.querySelectorAll(M), n3 = 0, r2 = t4.length; n3 < r2; n3++) {
        var o2 = t4[n3];
        o2 && "active" !== o2.getAttribute(N) && (F(e3, o2), o2.parentNode && o2.parentNode.removeChild(o2));
      }
    }(this));
  }
  e.registerId = function(e2) {
    return V(e2);
  };
  var t2 = e.prototype;
  return t2.reconstructWithOptions = function(t3, n2) {
    return void 0 === n2 && (n2 = true), new e(y({}, this.options, {}, t3), this.gs, n2 && this.names || void 0);
  }, t2.allocateGSInstance = function(e2) {
    return this.gs[e2] = (this.gs[e2] || 0) + 1;
  }, t2.getTag = function() {
    return this.tag || (this.tag = (n2 = (t3 = this.options).isServer, r2 = t3.useCSSOMInjection, o2 = t3.target, e2 = n2 ? new W(o2) : r2 ? new H(o2) : new $(o2), new j(e2)));
    var e2, t3, n2, r2, o2;
  }, t2.hasNameForId = function(e2, t3) {
    return this.names.has(e2) && this.names.get(e2).has(t3);
  }, t2.registerName = function(e2, t3) {
    if (V(e2), this.names.has(e2)) this.names.get(e2).add(t3);
    else {
      var n2 = /* @__PURE__ */ new Set();
      n2.add(t3), this.names.set(e2, n2);
    }
  }, t2.insertRules = function(e2, t3, n2) {
    this.registerName(e2, t3), this.getTag().insertRules(V(e2), n2);
  }, t2.clearNames = function(e2) {
    this.names.has(e2) && this.names.get(e2).clear();
  }, t2.clearRules = function(e2) {
    this.getTag().clearGroup(V(e2)), this.clearNames(e2);
  }, t2.clearTag = function() {
    this.tag = void 0;
  }, t2.toString = function() {
    return function(e2) {
      for (var t3 = e2.getTag(), n2 = t3.length, r2 = "", o2 = 0; o2 < n2; o2++) {
        var s2 = B(o2);
        if (void 0 !== s2) {
          var i = e2.names.get(s2), a2 = t3.getGroup(o2);
          if (i && a2 && i.size) {
            var c2 = N + ".g" + o2 + '[id="' + s2 + '"]', u2 = "";
            void 0 !== i && i.forEach(function(e3) {
              e3.length > 0 && (u2 += e3 + ",");
            }), r2 += "" + a2 + c2 + '{content:"' + u2 + '"}/*!sc*/\n';
          }
        }
      }
      return r2;
    }(this);
  }, e;
}(), Z = /(a)(d)/gi, K = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function Q(e) {
  var t2, n2 = "";
  for (t2 = Math.abs(e); t2 > 52; t2 = t2 / 52 | 0) n2 = K(t2 % 52) + n2;
  return (K(t2 % 52) + n2).replace(Z, "$1-$2");
}
var ee = function(e, t2) {
  for (var n2 = t2.length; n2; ) e = 33 * e ^ t2.charCodeAt(--n2);
  return e;
}, te = function(e) {
  return ee(5381, e);
};
function ne(e) {
  for (var t2 = 0; t2 < e.length; t2 += 1) {
    var n2 = e[t2];
    if (E(n2) && !_(n2)) return false;
  }
  return true;
}
var re$1 = te("5.3.11"), oe = function() {
  function e(e2, t2, n2) {
    this.rules = e2, this.staticRulesId = "", this.isStatic = "production" === process.env.NODE_ENV && (void 0 === n2 || n2.isStatic) && ne(e2), this.componentId = t2, this.baseHash = ee(re$1, t2), this.baseStyle = n2, X.registerId(t2);
  }
  return e.prototype.generateAndInjectStyles = function(e2, t2, n2) {
    var r2 = this.componentId, o2 = [];
    if (this.baseStyle && o2.push(this.baseStyle.generateAndInjectStyles(e2, t2, n2)), this.isStatic && !n2.hash) if (this.staticRulesId && t2.hasNameForId(r2, this.staticRulesId)) o2.push(this.staticRulesId);
    else {
      var s2 = _e(this.rules, e2, t2, n2).join(""), i = Q(ee(this.baseHash, s2) >>> 0);
      if (!t2.hasNameForId(r2, i)) {
        var a2 = n2(s2, "." + i, void 0, r2);
        t2.insertRules(r2, i, a2);
      }
      o2.push(i), this.staticRulesId = i;
    }
    else {
      for (var c2 = this.rules.length, u2 = ee(this.baseHash, n2.hash), l2 = "", d2 = 0; d2 < c2; d2++) {
        var h2 = this.rules[d2];
        if ("string" == typeof h2) l2 += h2, "production" !== process.env.NODE_ENV && (u2 = ee(u2, h2 + d2));
        else if (h2) {
          var p2 = _e(h2, e2, t2, n2), f2 = Array.isArray(p2) ? p2.join("") : p2;
          u2 = ee(u2, f2 + d2), l2 += f2;
        }
      }
      if (l2) {
        var m2 = Q(u2 >>> 0);
        if (!t2.hasNameForId(r2, m2)) {
          var y2 = n2(l2, "." + m2, void 0, r2);
          t2.insertRules(r2, m2, y2);
        }
        o2.push(m2);
      }
    }
    return o2.join(" ");
  }, e;
}(), se = /^\s*\/\/.*$/gm, ie$2 = [":", "[", ".", "#"];
function ae(e) {
  var t2, n2, r2, o2, s2 = w, i = s2.options, a2 = void 0 === i ? w : i, c2 = s2.plugins, u2 = void 0 === c2 ? S : c2, l2 = new stylis_min(a2), d2 = [], p2 = /* @__PURE__ */ function(e2) {
    function t3(t4) {
      if (t4) try {
        e2(t4 + "}");
      } catch (e3) {
      }
    }
    return function(n3, r3, o3, s3, i2, a3, c3, u3, l3, d3) {
      switch (n3) {
        case 1:
          if (0 === l3 && 64 === r3.charCodeAt(0)) return e2(r3 + ";"), "";
          break;
        case 2:
          if (0 === u3) return r3 + "/*|*/";
          break;
        case 3:
          switch (u3) {
            case 102:
            case 112:
              return e2(o3[0] + r3), "";
            default:
              return r3 + (0 === d3 ? "/*|*/" : "");
          }
        case -2:
          r3.split("/*|*/}").forEach(t3);
      }
    };
  }(function(e2) {
    d2.push(e2);
  }), f2 = function(e2, r3, s3) {
    return 0 === r3 && -1 !== ie$2.indexOf(s3[n2.length]) || s3.match(o2) ? e2 : "." + t2;
  };
  function m2(e2, s3, i2, a3) {
    void 0 === a3 && (a3 = "&");
    var c3 = e2.replace(se, ""), u3 = s3 && i2 ? i2 + " " + s3 + " { " + c3 + " }" : c3;
    return t2 = a3, n2 = s3, r2 = new RegExp("\\" + n2 + "\\b", "g"), o2 = new RegExp("(\\" + n2 + "\\b){2,}"), l2(i2 || !s3 ? "" : s3, u3);
  }
  return l2.use([].concat(u2, [function(e2, t3, o3) {
    2 === e2 && o3.length && o3[0].lastIndexOf(n2) > 0 && (o3[0] = o3[0].replace(r2, f2));
  }, p2, function(e2) {
    if (-2 === e2) {
      var t3 = d2;
      return d2 = [], t3;
    }
  }])), m2.hash = u2.length ? u2.reduce(function(e2, t3) {
    return t3.name || D(15), ee(e2, t3.name);
  }, 5381).toString() : "", m2;
}
var ce = React__default.createContext();
ce.Consumer;
var le = React__default.createContext(), de = (le.Consumer, new X()), he = ae();
function pe() {
  return useContext(ce) || de;
}
function fe() {
  return useContext(le) || he;
}
var ye = function() {
  function e(e2, t2) {
    var n2 = this;
    this.inject = function(e3, t3) {
      void 0 === t3 && (t3 = he);
      var r2 = n2.name + t3.hash;
      e3.hasNameForId(n2.id, r2) || e3.insertRules(n2.id, r2, t3(n2.rules, r2, "@keyframes"));
    }, this.toString = function() {
      return D(12, String(n2.name));
    }, this.name = e2, this.id = "sc-keyframes-" + e2, this.rules = t2;
  }
  return e.prototype.getName = function(e2) {
    return void 0 === e2 && (e2 = he), this.name + e2.hash;
  }, e;
}(), ve = /([A-Z])/, ge = /([A-Z])/g, Se = /^ms-/, we = function(e) {
  return "-" + e.toLowerCase();
};
function Ee(e) {
  return ve.test(e) ? e.replace(ge, we).replace(Se, "-ms-") : e;
}
var be = function(e) {
  return null == e || false === e || "" === e;
};
function _e(e, n2, r2, o2) {
  if (Array.isArray(e)) {
    for (var s2, i = [], a2 = 0, c2 = e.length; a2 < c2; a2 += 1) "" !== (s2 = _e(e[a2], n2, r2, o2)) && (Array.isArray(s2) ? i.push.apply(i, s2) : i.push(s2));
    return i;
  }
  if (be(e)) return "";
  if (_(e)) return "." + e.styledComponentId;
  if (E(e)) {
    if ("function" != typeof (l2 = e) || l2.prototype && l2.prototype.isReactComponent || !n2) return e;
    var u2 = e(n2);
    return "production" !== process.env.NODE_ENV && reactIsExports.isElement(u2) && console.warn(b(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), _e(u2, n2, r2, o2);
  }
  var l2;
  return e instanceof ye ? r2 ? (e.inject(r2, o2), e.getName(o2)) : e : g(e) ? function e2(t2, n3) {
    var r3, o3, s3 = [];
    for (var i2 in t2) t2.hasOwnProperty(i2) && !be(t2[i2]) && (Array.isArray(t2[i2]) && t2[i2].isCss || E(t2[i2]) ? s3.push(Ee(i2) + ":", t2[i2], ";") : g(t2[i2]) ? s3.push.apply(s3, e2(t2[i2], i2)) : s3.push(Ee(i2) + ": " + (r3 = i2, null == (o3 = t2[i2]) || "boolean" == typeof o3 || "" === o3 ? "" : "number" != typeof o3 || 0 === o3 || r3 in unitlessKeys || r3.startsWith("--") ? String(o3).trim() : o3 + "px") + ";"));
    return n3 ? [n3 + " {"].concat(s3, ["}"]) : s3;
  }(e) : e.toString();
}
var Ne = function(e) {
  return Array.isArray(e) && (e.isCss = true), e;
};
function Ae(e) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++) n2[r2 - 1] = arguments[r2];
  return E(e) || g(e) ? Ne(_e(v(S, [e].concat(n2)))) : 0 === n2.length && 1 === e.length && "string" == typeof e[0] ? e : Ne(_e(v(e, n2)));
}
var Ce = /invalid hook call/i, Ie = /* @__PURE__ */ new Set(), Pe = function(e, t2) {
  if ("production" !== process.env.NODE_ENV) {
    var n2 = "The component " + e + (t2 ? ' with the id of "' + t2 + '"' : "") + " has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.", r2 = console.error;
    try {
      var o2 = true;
      console.error = function(e2) {
        if (Ce.test(e2)) o2 = false, Ie.delete(n2);
        else {
          for (var t3 = arguments.length, s2 = new Array(t3 > 1 ? t3 - 1 : 0), i = 1; i < t3; i++) s2[i - 1] = arguments[i];
          r2.apply(void 0, [e2].concat(s2));
        }
      }, useRef(), o2 && !Ie.has(n2) && (console.warn(n2), Ie.add(n2));
    } catch (e2) {
      Ce.test(e2.message) && Ie.delete(n2);
    } finally {
      console.error = r2;
    }
  }
}, Oe = function(e, t2, n2) {
  return void 0 === n2 && (n2 = w), e.theme !== n2.theme && e.theme || t2 || n2.theme;
}, Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, De = /(^-|-$)/g;
function je(e) {
  return e.replace(Re, "-").replace(De, "");
}
var Te = function(e) {
  return Q(te(e) >>> 0);
};
function xe(e) {
  return "string" == typeof e && ("production" === process.env.NODE_ENV || e.charAt(0) === e.charAt(0).toLowerCase());
}
var ke = function(e) {
  return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, Ve = function(e) {
  return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function Be(e, t2, n2) {
  var r2 = e[n2];
  ke(t2) && ke(r2) ? ze(r2, t2) : e[n2] = t2;
}
function ze(e) {
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++) n2[r2 - 1] = arguments[r2];
  for (var o2 = 0, s2 = n2; o2 < s2.length; o2++) {
    var i = s2[o2];
    if (ke(i)) for (var a2 in i) Ve(a2) && Be(e, i[a2], a2);
  }
  return e;
}
var Me = React__default.createContext();
Me.Consumer;
function Le(e) {
  var t2 = useContext(Me), n2 = useMemo$1(function() {
    return function(e2, t3) {
      if (!e2) return D(14);
      if (E(e2)) {
        var n3 = e2(t3);
        return "production" === process.env.NODE_ENV || null !== n3 && !Array.isArray(n3) && "object" == typeof n3 ? n3 : D(7);
      }
      return Array.isArray(e2) || "object" != typeof e2 ? D(8) : t3 ? y({}, t3, {}, e2) : e2;
    }(e.theme, t2);
  }, [e.theme, t2]);
  return e.children ? React__default.createElement(Me.Provider, { value: n2 }, e.children) : null;
}
var Fe = {};
function Ye(e, t2, n2) {
  var o2 = _(e), i = !xe(e), a2 = t2.attrs, c2 = void 0 === a2 ? S : a2, l2 = t2.componentId, d2 = void 0 === l2 ? function(e2, t3) {
    var n3 = "string" != typeof e2 ? "sc" : je(e2);
    Fe[n3] = (Fe[n3] || 0) + 1;
    var r2 = n3 + "-" + Te("5.3.11" + n3 + Fe[n3]);
    return t3 ? t3 + "-" + r2 : r2;
  }(t2.displayName, t2.parentComponentId) : l2, h2 = t2.displayName, p2 = void 0 === h2 ? function(e2) {
    return xe(e2) ? "styled." + e2 : "Styled(" + b(e2) + ")";
  }(e) : h2, v2 = t2.displayName && t2.componentId ? je(t2.displayName) + "-" + t2.componentId : t2.componentId || d2, g2 = o2 && e.attrs ? Array.prototype.concat(e.attrs, c2).filter(Boolean) : c2, N2 = t2.shouldForwardProp;
  o2 && e.shouldForwardProp && (N2 = t2.shouldForwardProp ? function(n3, r2, o3) {
    return e.shouldForwardProp(n3, r2, o3) && t2.shouldForwardProp(n3, r2, o3);
  } : e.shouldForwardProp);
  var A2, C2 = new oe(n2, v2, o2 ? e.componentStyle : void 0), I2 = C2.isStatic && 0 === c2.length, P2 = function(e2, t3) {
    return function(e3, t4, n3, r2) {
      var o3 = e3.attrs, i2 = e3.componentStyle, a3 = e3.defaultProps, c3 = e3.foldedComponentIds, l3 = e3.shouldForwardProp, d3 = e3.styledComponentId, h3 = e3.target, p3 = function(e4, t5, n4) {
        void 0 === e4 && (e4 = w);
        var r3 = y({}, t5, { theme: e4 }), o4 = {};
        return n4.forEach(function(e5) {
          var t6, n5, s2, i3 = e5;
          for (t6 in E(i3) && (i3 = i3(r3)), i3) r3[t6] = o4[t6] = "className" === t6 ? (n5 = o4[t6], s2 = i3[t6], n5 && s2 ? n5 + " " + s2 : n5 || s2) : i3[t6];
        }), [r3, o4];
      }(Oe(t4, useContext(Me), a3) || w, t4, o3), m2 = p3[0], v3 = p3[1], g3 = function(e4, t5, n4, r3) {
        var o4 = pe(), s2 = fe(), i3 = t5 ? e4.generateAndInjectStyles(w, o4, s2) : e4.generateAndInjectStyles(n4, o4, s2);
        return "production" !== process.env.NODE_ENV && !t5 && r3 && r3(i3), i3;
      }(i2, r2, m2, "production" !== process.env.NODE_ENV ? e3.warnTooManyClasses : void 0), S2 = n3, b2 = v3.$as || t4.$as || v3.as || t4.as || h3, _2 = xe(b2), N3 = v3 !== t4 ? y({}, t4, {}, v3) : t4, A3 = {};
      for (var C3 in N3) "$" !== C3[0] && "as" !== C3 && ("forwardedAs" === C3 ? A3.as = N3[C3] : (l3 ? l3(C3, isPropValid, b2) : !_2 || isPropValid(C3)) && (A3[C3] = N3[C3]));
      return t4.style && v3.style !== t4.style && (A3.style = y({}, t4.style, {}, v3.style)), A3.className = Array.prototype.concat(c3, d3, g3 !== d3 ? g3 : null, t4.className, v3.className).filter(Boolean).join(" "), A3.ref = S2, createElement(b2, A3);
    }(A2, e2, t3, I2);
  };
  return P2.displayName = p2, (A2 = React__default.forwardRef(P2)).attrs = g2, A2.componentStyle = C2, A2.displayName = p2, A2.shouldForwardProp = N2, A2.foldedComponentIds = o2 ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : S, A2.styledComponentId = v2, A2.target = o2 ? e.target : e, A2.withComponent = function(e2) {
    var r2 = t2.componentId, o3 = function(e3, t3) {
      if (null == e3) return {};
      var n3, r3, o4 = {}, s3 = Object.keys(e3);
      for (r3 = 0; r3 < s3.length; r3++) n3 = s3[r3], t3.indexOf(n3) >= 0 || (o4[n3] = e3[n3]);
      return o4;
    }(t2, ["componentId"]), s2 = r2 && r2 + "-" + (xe(e2) ? e2 : je(b(e2)));
    return Ye(e2, y({}, o3, { attrs: g2, componentId: s2 }), n2);
  }, Object.defineProperty(A2, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(t3) {
    this._foldedDefaultProps = o2 ? ze({}, e.defaultProps, t3) : t3;
  } }), "production" !== process.env.NODE_ENV && (Pe(p2, v2), A2.warnTooManyClasses = /* @__PURE__ */ function(e2, t3) {
    var n3 = {}, r2 = false;
    return function(o3) {
      if (!r2 && (n3[o3] = true, Object.keys(n3).length >= 200)) {
        var s2 = t3 ? ' with the id of "' + t3 + '"' : "";
        console.warn("Over 200 classes were generated for component " + e2 + s2 + ".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"), r2 = true, n3 = {};
      }
    };
  }(p2, v2)), Object.defineProperty(A2, "toString", { value: function() {
    return "." + A2.styledComponentId;
  } }), i && m(A2, e, { attrs: true, componentStyle: true, displayName: true, foldedComponentIds: true, shouldForwardProp: true, styledComponentId: true, target: true, withComponent: true }), A2;
}
var qe = function(e) {
  return function e2(t2, r2, o2) {
    if (void 0 === o2 && (o2 = w), !reactIsExports.isValidElementType(r2)) return D(1, String(r2));
    var s2 = function() {
      return t2(r2, o2, Ae.apply(void 0, arguments));
    };
    return s2.withConfig = function(n2) {
      return e2(t2, r2, y({}, o2, {}, n2));
    }, s2.attrs = function(n2) {
      return e2(t2, r2, y({}, o2, { attrs: Array.prototype.concat(o2.attrs, n2).filter(Boolean) }));
    }, s2;
  }(Ye, e);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e) {
  qe[e] = qe(e);
});
function We(e) {
  "production" !== process.env.NODE_ENV && "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r2 = 1; r2 < t2; r2++) n2[r2 - 1] = arguments[r2];
  var o2 = Ae.apply(void 0, [e].concat(n2)).join(""), s2 = Te(o2);
  return new ye(s2, o2);
}
"production" !== process.env.NODE_ENV && "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"), "production" !== process.env.NODE_ENV && "test" !== process.env.NODE_ENV && "undefined" != typeof window && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, 1 === window["__styled-components-init__"] && console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."), window["__styled-components-init__"] += 1);
var cjs$2;
var hasRequiredCjs$2;
function requireCjs$2() {
  if (hasRequiredCjs$2) return cjs$2;
  hasRequiredCjs$2 = 1;
  var isMergeableObject = function isMergeableObject2(value) {
    return isNonNullObject(value) && !isSpecial(value);
  };
  function isNonNullObject(value) {
    return !!value && typeof value === "object";
  }
  function isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
  }
  var canUseSymbol = typeof Symbol === "function" && Symbol.for;
  var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
  function isReactElement(value) {
    return value.$$typeof === REACT_ELEMENT_TYPE;
  }
  function emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
  }
  function cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? deepmerge2(emptyTarget(value), value, options) : value;
  }
  function defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element2) {
      return cloneUnlessOtherwiseSpecified(element2, options);
    });
  }
  function getMergeFunction(key2, options) {
    if (!options.customMerge) {
      return deepmerge2;
    }
    var customMerge = options.customMerge(key2);
    return typeof customMerge === "function" ? customMerge : deepmerge2;
  }
  function getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
      return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
  }
  function getKeys(target) {
    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
  }
  function propertyIsOnObject(object, property) {
    try {
      return property in object;
    } catch (_2) {
      return false;
    }
  }
  function propertyIsUnsafe(target, key2) {
    return propertyIsOnObject(target, key2) && !(Object.hasOwnProperty.call(target, key2) && Object.propertyIsEnumerable.call(target, key2));
  }
  function mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) {
      getKeys(target).forEach(function(key2) {
        destination[key2] = cloneUnlessOtherwiseSpecified(target[key2], options);
      });
    }
    getKeys(source).forEach(function(key2) {
      if (propertyIsUnsafe(target, key2)) {
        return;
      }
      if (propertyIsOnObject(target, key2) && options.isMergeableObject(source[key2])) {
        destination[key2] = getMergeFunction(key2, options)(target[key2], source[key2], options);
      } else {
        destination[key2] = cloneUnlessOtherwiseSpecified(source[key2], options);
      }
    });
    return destination;
  }
  function deepmerge2(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || isMergeableObject;
    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) {
      return cloneUnlessOtherwiseSpecified(source, options);
    } else if (sourceIsArray) {
      return options.arrayMerge(target, source, options);
    } else {
      return mergeObject(target, source, options);
    }
  }
  deepmerge2.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) {
      throw new Error("first argument should be an array");
    }
    return array.reduce(function(prev2, next2) {
      return deepmerge2(prev2, next2, options);
    }, {});
  };
  var deepmerge_1 = deepmerge2;
  cjs$2 = deepmerge_1;
  return cjs$2;
}
var cjsExports$1 = requireCjs$2();
const deepmerge = /* @__PURE__ */ getDefaultExportFromCjs$1(cjsExports$1);
const useSyncedState = (initialValue, t0) => {
  const $2 = distExports.c(2);
  const {
    isPropUpdateDisabled: t1,
    isEqual: t2
  } = {};
  const isPropUpdateDisabled = t1 === void 0 ? false : t1;
  const isEqual7 = t2 === void 0 ? Object.is : t2;
  const [state, setState] = useState(initialValue);
  const [previous2, setPrevious] = useState(initialValue);
  const nextInitialValue = initialValue instanceof Function ? initialValue() : initialValue;
  if (!isPropUpdateDisabled && !isEqual7(previous2, nextInitialValue)) {
    setPrevious(nextInitialValue);
    setState(nextInitialValue);
  }
  let t3;
  if ($2[0] !== state) {
    t3 = [state, setState];
    $2[0] = state;
    $2[1] = t3;
  } else {
    t3 = $2[1];
  }
  return t3;
};
function useId(id) {
  const uniqueId2 = useId$2();
  if (id) {
    return id;
  }
  return uniqueId2;
}
const defaultColorMode = "day";
const defaultDayScheme = "light";
const defaultNightScheme = "dark";
const ThemeContext = /* @__PURE__ */ React__default.createContext({
  setColorMode: () => null,
  setDayScheme: () => null,
  setNightScheme: () => null
});
const getServerHandoff = (id) => {
  try {
    var _document$getElementB;
    const serverData = (_document$getElementB = document.getElementById(`__PRIMER_DATA_${id}__`)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.textContent;
    if (serverData) return JSON.parse(serverData);
  } catch (_error) {
  }
  return {};
};
const ThemeProvider = ({
  children,
  ...props
}) => {
  var _ref, _props$theme, _ref2, _props$colorMode, _ref3, _props$dayScheme, _ref4, _props$nightScheme;
  const {
    theme: fallbackTheme,
    colorMode: fallbackColorMode,
    dayScheme: fallbackDayScheme,
    nightScheme: fallbackNightScheme
  } = useTheme();
  const theme$1 = (_ref = (_props$theme = props.theme) !== null && _props$theme !== void 0 ? _props$theme : fallbackTheme) !== null && _ref !== void 0 ? _ref : theme;
  const uniqueDataId = useId();
  const {
    resolvedServerColorMode
  } = getServerHandoff(uniqueDataId);
  const resolvedColorModePassthrough = React__default.useRef(resolvedServerColorMode);
  const [colorMode, setColorMode] = useSyncedState((_ref2 = (_props$colorMode = props.colorMode) !== null && _props$colorMode !== void 0 ? _props$colorMode : fallbackColorMode) !== null && _ref2 !== void 0 ? _ref2 : defaultColorMode);
  const [dayScheme, setDayScheme] = useSyncedState((_ref3 = (_props$dayScheme = props.dayScheme) !== null && _props$dayScheme !== void 0 ? _props$dayScheme : fallbackDayScheme) !== null && _ref3 !== void 0 ? _ref3 : defaultDayScheme);
  const [nightScheme, setNightScheme] = useSyncedState((_ref4 = (_props$nightScheme = props.nightScheme) !== null && _props$nightScheme !== void 0 ? _props$nightScheme : fallbackNightScheme) !== null && _ref4 !== void 0 ? _ref4 : defaultNightScheme);
  const systemColorMode = useSystemColorMode();
  const resolvedColorMode = resolvedColorModePassthrough.current || resolveColorMode(colorMode, systemColorMode);
  const colorScheme = chooseColorScheme(resolvedColorMode, dayScheme, nightScheme);
  const {
    resolvedTheme,
    resolvedColorScheme
  } = React__default.useMemo(() => applyColorScheme(theme$1, colorScheme), [theme$1, colorScheme]);
  React__default.useEffect(function updateColorModeAfterServerPassthrough() {
    const resolvedColorModeOnClient = resolveColorMode(colorMode, systemColorMode);
    if (resolvedColorModePassthrough.current) {
      if (resolvedColorModePassthrough.current !== resolvedColorModeOnClient) {
        window.setTimeout(() => {
          ReactDOM__default.flushSync(() => {
            setColorMode(resolvedColorModeOnClient);
          });
          setColorMode(colorMode);
        });
      }
      resolvedColorModePassthrough.current = null;
    }
  }, [colorMode, systemColorMode, setColorMode]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext.Provider, {
    value: {
      theme: resolvedTheme,
      colorScheme,
      colorMode,
      resolvedColorMode,
      resolvedColorScheme,
      dayScheme,
      nightScheme,
      setColorMode,
      setDayScheme,
      setNightScheme
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Le, {
      theme: resolvedTheme,
      children: [children, props.preventSSRMismatch ? /* @__PURE__ */ jsxRuntimeExports.jsx("script", {
        type: "application/json",
        id: `__PRIMER_DATA_${uniqueDataId}__`,
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            resolvedServerColorMode: resolvedColorMode
          })
        }
      }) : null]
    })
  });
};
ThemeProvider.displayName = "ThemeProvider";
function useTheme() {
  return React__default.useContext(ThemeContext);
}
function useSystemColorMode() {
  const $2 = distExports.c(2);
  const [systemColorMode, setSystemColorMode] = React__default.useState(getSystemColorMode);
  let t0;
  let t1;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      var _window, _window$matchMedia;
      const media = (_window = window) === null || _window === void 0 ? void 0 : (_window$matchMedia = _window.matchMedia) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.call(_window, "(prefers-color-scheme: dark)");
      const matchesMediaToColorMode = function matchesMediaToColorMode2(matches2) {
        return matches2 ? "night" : "day";
      };
      const handleChange = function handleChange2(event) {
        const isNight = event.matches;
        setSystemColorMode(matchesMediaToColorMode(isNight));
      };
      if (media) {
        const isNight_0 = media.matches;
        setSystemColorMode(matchesMediaToColorMode(isNight_0));
        if (media.addEventListener !== void 0) {
          media.addEventListener("change", handleChange);
          return function cleanup() {
            media.removeEventListener("change", handleChange);
          };
        } else {
          if (media.addListener !== void 0) {
            media.addListener(handleChange);
            return function cleanup() {
              media.removeListener(handleChange);
            };
          }
        }
      }
    };
    t1 = [];
    $2[0] = t0;
    $2[1] = t1;
  } else {
    t0 = $2[0];
    t1 = $2[1];
  }
  React__default.useEffect(t0, t1);
  return systemColorMode;
}
function getSystemColorMode() {
  var _window$matchMedia2, _window2, _window$matchMedia2$c;
  if (typeof window !== "undefined" && (_window$matchMedia2 = (_window2 = window).matchMedia) !== null && _window$matchMedia2 !== void 0 && (_window$matchMedia2$c = _window$matchMedia2.call(_window2, "(prefers-color-scheme: dark)")) !== null && _window$matchMedia2$c !== void 0 && _window$matchMedia2$c.matches) {
    return "night";
  }
  return "day";
}
function resolveColorMode(colorMode, systemColorMode) {
  switch (colorMode) {
    case "auto":
      return systemColorMode;
    default:
      return colorMode;
  }
}
function chooseColorScheme(colorMode, dayScheme, nightScheme) {
  switch (colorMode) {
    case "day":
    case "light":
      return dayScheme;
    case "dark":
    case "night":
      return nightScheme;
  }
}
function applyColorScheme(theme2, colorScheme) {
  if (!theme2.colorSchemes) {
    return {
      resolvedTheme: theme2,
      resolvedColorScheme: void 0
    };
  }
  if (!theme2.colorSchemes[colorScheme]) {
    console.error(`\`${colorScheme}\` scheme not defined in \`theme.colorSchemes\``);
    const defaultColorScheme = Object.keys(theme2.colorSchemes)[0];
    return {
      resolvedTheme: deepmerge(theme2, theme2.colorSchemes[defaultColorScheme]),
      resolvedColorScheme: defaultColorScheme
    };
  }
  return {
    resolvedTheme: deepmerge(theme2, theme2.colorSchemes[colorScheme]),
    resolvedColorScheme: colorScheme
  };
}
var classes$Q = { "BaseStyles": "prc-src-BaseStyles-dl-St" };
var focusVisible$1 = { exports: {} };
var focusVisible = focusVisible$1.exports;
var hasRequiredFocusVisible;
function requireFocusVisible() {
  if (hasRequiredFocusVisible) return focusVisible$1.exports;
  hasRequiredFocusVisible = 1;
  (function(module2, exports) {
    (function(global2, factory) {
      factory();
    })(focusVisible, function() {
      function applyFocusVisiblePolyfill(scope) {
        var hadKeyboardEvent = true;
        var hadFocusVisibleRecently = false;
        var hadFocusVisibleRecentlyTimeout = null;
        var inputTypesAllowlist = {
          text: true,
          search: true,
          url: true,
          tel: true,
          email: true,
          password: true,
          number: true,
          date: true,
          month: true,
          week: true,
          time: true,
          datetime: true,
          "datetime-local": true
        };
        function isValidFocusTarget(el) {
          if (el && el !== document && el.nodeName !== "HTML" && el.nodeName !== "BODY" && "classList" in el && "contains" in el.classList) {
            return true;
          }
          return false;
        }
        function focusTriggersKeyboardModality(el) {
          var type = el.type;
          var tagName = el.tagName;
          if (tagName === "INPUT" && inputTypesAllowlist[type] && !el.readOnly) {
            return true;
          }
          if (tagName === "TEXTAREA" && !el.readOnly) {
            return true;
          }
          if (el.isContentEditable) {
            return true;
          }
          return false;
        }
        function addFocusVisibleClass(el) {
          if (el.classList.contains("focus-visible")) {
            return;
          }
          el.classList.add("focus-visible");
          el.setAttribute("data-focus-visible-added", "");
        }
        function removeFocusVisibleClass(el) {
          if (!el.hasAttribute("data-focus-visible-added")) {
            return;
          }
          el.classList.remove("focus-visible");
          el.removeAttribute("data-focus-visible-added");
        }
        function onKeyDown(e) {
          if (e.metaKey || e.altKey || e.ctrlKey) {
            return;
          }
          if (isValidFocusTarget(scope.activeElement)) {
            addFocusVisibleClass(scope.activeElement);
          }
          hadKeyboardEvent = true;
        }
        function onPointerDown(e) {
          hadKeyboardEvent = false;
        }
        function onFocus(e) {
          if (!isValidFocusTarget(e.target)) {
            return;
          }
          if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
            addFocusVisibleClass(e.target);
          }
        }
        function onBlur(e) {
          if (!isValidFocusTarget(e.target)) {
            return;
          }
          if (e.target.classList.contains("focus-visible") || e.target.hasAttribute("data-focus-visible-added")) {
            hadFocusVisibleRecently = true;
            window.clearTimeout(hadFocusVisibleRecentlyTimeout);
            hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
              hadFocusVisibleRecently = false;
            }, 100);
            removeFocusVisibleClass(e.target);
          }
        }
        function onVisibilityChange(e) {
          if (document.visibilityState === "hidden") {
            if (hadFocusVisibleRecently) {
              hadKeyboardEvent = true;
            }
            addInitialPointerMoveListeners();
          }
        }
        function addInitialPointerMoveListeners() {
          document.addEventListener("mousemove", onInitialPointerMove);
          document.addEventListener("mousedown", onInitialPointerMove);
          document.addEventListener("mouseup", onInitialPointerMove);
          document.addEventListener("pointermove", onInitialPointerMove);
          document.addEventListener("pointerdown", onInitialPointerMove);
          document.addEventListener("pointerup", onInitialPointerMove);
          document.addEventListener("touchmove", onInitialPointerMove);
          document.addEventListener("touchstart", onInitialPointerMove);
          document.addEventListener("touchend", onInitialPointerMove);
        }
        function removeInitialPointerMoveListeners() {
          document.removeEventListener("mousemove", onInitialPointerMove);
          document.removeEventListener("mousedown", onInitialPointerMove);
          document.removeEventListener("mouseup", onInitialPointerMove);
          document.removeEventListener("pointermove", onInitialPointerMove);
          document.removeEventListener("pointerdown", onInitialPointerMove);
          document.removeEventListener("pointerup", onInitialPointerMove);
          document.removeEventListener("touchmove", onInitialPointerMove);
          document.removeEventListener("touchstart", onInitialPointerMove);
          document.removeEventListener("touchend", onInitialPointerMove);
        }
        function onInitialPointerMove(e) {
          if (e.target.nodeName && e.target.nodeName.toLowerCase() === "html") {
            return;
          }
          hadKeyboardEvent = false;
          removeInitialPointerMoveListeners();
        }
        document.addEventListener("keydown", onKeyDown, true);
        document.addEventListener("mousedown", onPointerDown, true);
        document.addEventListener("pointerdown", onPointerDown, true);
        document.addEventListener("touchstart", onPointerDown, true);
        document.addEventListener("visibilitychange", onVisibilityChange, true);
        addInitialPointerMoveListeners();
        scope.addEventListener("focus", onFocus, true);
        scope.addEventListener("blur", onBlur, true);
        if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
          scope.host.setAttribute("data-js-focus-visible", "");
        } else if (scope.nodeType === Node.DOCUMENT_NODE) {
          document.documentElement.classList.add("js-focus-visible");
          document.documentElement.setAttribute("data-js-focus-visible", "");
        }
      }
      if (typeof window !== "undefined" && typeof document !== "undefined") {
        window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;
        var event;
        try {
          event = new CustomEvent("focus-visible-polyfill-ready");
        } catch (error2) {
          event = document.createEvent("CustomEvent");
          event.initCustomEvent("focus-visible-polyfill-ready", false, false, {});
        }
        window.dispatchEvent(event);
      }
      if (typeof document !== "undefined") {
        applyFocusVisiblePolyfill(document);
      }
    });
  })();
  return focusVisible$1.exports;
}
requireFocusVisible();
const defaultSxProp = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {};
const COMMON_PROP_NAMES = new Set(Object.keys(COMMON));
const TYPOGRAPHY_PROP_NAMES = new Set(Object.keys(TYPOGRAPHY));
const includesSystemProps = (props) => {
  if (props.sx) {
    return true;
  }
  return Object.keys(props).some((prop) => {
    return TYPOGRAPHY_PROP_NAMES.has(prop) || COMMON_PROP_NAMES.has(prop);
  });
};
const sx = (props) => css(props.sx);
const Box = qe.div.withConfig({
  displayName: "Box",
  componentId: "sc-g0xbh4-0"
})(space$1, color, typography$1, layout, flexbox, grid, background, border, position$1, shadow, sx);
const BoxWithFallback = /* @__PURE__ */ React__default.forwardRef(function BoxWithFallback2(t0, ref2) {
  const $2 = distExports.c(13);
  let rest;
  let t1;
  let t2;
  if ($2[0] !== t0) {
    ({
      as: t1,
      sx: t2,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = rest;
    $2[2] = t1;
    $2[3] = t2;
  } else {
    rest = $2[1];
    t1 = $2[2];
    t2 = $2[3];
  }
  const BaseComponent = t1 === void 0 ? "div" : t1;
  const sx2 = t2 === void 0 ? defaultSxProp : t2;
  if (sx2 !== defaultSxProp || includesSystemProps(rest)) {
    let t32;
    if ($2[4] !== BaseComponent || $2[5] !== ref2 || $2[6] !== rest || $2[7] !== sx2) {
      t32 = /* @__PURE__ */ jsxRuntimeExports.jsx(Box, {
        ...rest,
        ref: ref2,
        as: BaseComponent,
        sx: sx2
      });
      $2[4] = BaseComponent;
      $2[5] = ref2;
      $2[6] = rest;
      $2[7] = sx2;
      $2[8] = t32;
    } else {
      t32 = $2[8];
    }
    return t32;
  }
  let t3;
  if ($2[9] !== BaseComponent || $2[10] !== ref2 || $2[11] !== rest) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx(BaseComponent, {
      ...rest,
      ref: ref2
    });
    $2[9] = BaseComponent;
    $2[10] = ref2;
    $2[11] = rest;
    $2[12] = t3;
  } else {
    t3 = $2[12];
  }
  return t3;
});
function BaseStyles(t0) {
  const $2 = distExports.c(27);
  let children;
  let className;
  let color2;
  let fontFamily2;
  let lineHeight2;
  let rest;
  let style3;
  let t1;
  if ($2[0] !== t0) {
    ({
      children,
      color: color2,
      fontFamily: fontFamily2,
      lineHeight: lineHeight2,
      className,
      as: t1,
      style: style3,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = className;
    $2[3] = color2;
    $2[4] = fontFamily2;
    $2[5] = lineHeight2;
    $2[6] = rest;
    $2[7] = style3;
    $2[8] = t1;
  } else {
    children = $2[1];
    className = $2[2];
    color2 = $2[3];
    fontFamily2 = $2[4];
    lineHeight2 = $2[5];
    rest = $2[6];
    style3 = $2[7];
    t1 = $2[8];
  }
  const Component2 = t1 === void 0 ? "div" : t1;
  const {
    colorMode,
    colorScheme,
    dayScheme,
    nightScheme
  } = useTheme();
  let t2;
  if ($2[9] !== className) {
    t2 = clsx(classes$Q.BaseStyles, className);
    $2[9] = className;
    $2[10] = t2;
  } else {
    t2 = $2[10];
  }
  const newClassName = t2;
  let t3;
  if ($2[11] !== color2 || $2[12] !== fontFamily2 || $2[13] !== lineHeight2) {
    t3 = {
      "--BaseStyles-fgColor": color2,
      "--BaseStyles-fontFamily": fontFamily2,
      "--BaseStyles-lineHeight": lineHeight2
    };
    $2[11] = color2;
    $2[12] = fontFamily2;
    $2[13] = lineHeight2;
    $2[14] = t3;
  } else {
    t3 = $2[14];
  }
  const baseStyles2 = t3;
  const t4 = colorMode === "auto" ? "auto" : colorScheme !== null && colorScheme !== void 0 && colorScheme.includes("dark") ? "dark" : "light";
  let t5;
  if ($2[15] !== baseStyles2 || $2[16] !== style3) {
    t5 = {
      ...baseStyles2,
      ...style3
    };
    $2[15] = baseStyles2;
    $2[16] = style3;
    $2[17] = t5;
  } else {
    t5 = $2[17];
  }
  let t6;
  if ($2[18] !== Component2 || $2[19] !== children || $2[20] !== dayScheme || $2[21] !== newClassName || $2[22] !== nightScheme || $2[23] !== rest || $2[24] !== t4 || $2[25] !== t5) {
    t6 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: Component2,
      className: newClassName,
      "data-portal-root": true,
      "data-color-mode": t4,
      "data-light-theme": dayScheme,
      "data-dark-theme": nightScheme,
      style: t5,
      ...rest,
      children
    });
    $2[18] = Component2;
    $2[19] = children;
    $2[20] = dayScheme;
    $2[21] = newClassName;
    $2[22] = nightScheme;
    $2[23] = rest;
    $2[24] = t4;
    $2[25] = t5;
    $2[26] = t6;
  } else {
    t6 = $2[26];
  }
  return t6;
}
function useSafeTimeout() {
  const timers = useRef(/* @__PURE__ */ new Set());
  const safeSetTimeout = useCallback$1((handler, timeout, ...args) => {
    const id = window.setTimeout(handler, timeout, ...args);
    timers.current.add(id);
    return id;
  }, []);
  const safeClearTimeout = useCallback$1((id) => {
    clearTimeout(id);
    timers.current.delete(id);
  }, []);
  useEffect(() => {
    return () => {
      for (const id of timers.current) {
        clearTimeout(id);
      }
    };
  }, []);
  return {
    safeSetTimeout,
    safeClearTimeout
  };
}
const stopPropagation$1 = true;
function handleClick$1(event) {
  if (!event.defaultPrevented) {
    for (const handler of Object.values(registry$1).reverse()) {
      if (handler(event) === stopPropagation$1 || event.defaultPrevented) {
        break;
      }
    }
  }
}
const registry$1 = {};
function register$1(id, handler) {
  registry$1[id] = handler;
}
function deregister$1(id) {
  delete registry$1[id];
}
let handlerId$1 = 0;
const useOnOutsideClick = ({
  containerRef,
  ignoreClickRefs,
  onClickOutside
}) => {
  const id = useMemo$1(() => handlerId$1++, []);
  const handler = useCallback$1((event) => {
    var _containerRef$current;
    if (event instanceof MouseEvent && event.button > 0) {
      return stopPropagation$1;
    }
    if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(event.target)) {
      return stopPropagation$1;
    }
    if (ignoreClickRefs && ignoreClickRefs.some(({
      current
    }) => current === null || current === void 0 ? void 0 : current.contains(event.target))) {
      return stopPropagation$1;
    }
    onClickOutside(event);
  }, [containerRef, ignoreClickRefs, onClickOutside]);
  useEffect(() => {
    if (Object.keys(registry$1).length === 0) {
      document.addEventListener("mousedown", handleClick$1, {
        capture: true
      });
    }
    register$1(id, handler);
    return () => {
      deregister$1(id);
      if (Object.keys(registry$1).length === 0) {
        document.removeEventListener("mousedown", handleClick$1, {
          capture: true
        });
      }
    };
  }, [id, handler]);
};
function* iterateFocusableElements(container, options = {}) {
  var _a3, _b;
  const strict = (_a3 = options.strict) !== null && _a3 !== void 0 ? _a3 : false;
  const acceptFn = ((_b = options.onlyTabbable) !== null && _b !== void 0 ? _b : false) ? isTabbable : isFocusable$1;
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (node2) => node2 instanceof HTMLElement && acceptFn(node2, strict) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  let nextNode = null;
  if (!options.reverse && acceptFn(container, strict)) {
    yield container;
  }
  if (options.reverse) {
    let lastChild = walker.lastChild();
    while (lastChild) {
      nextNode = lastChild;
      lastChild = walker.lastChild();
    }
  } else {
    nextNode = walker.firstChild();
  }
  while (nextNode instanceof HTMLElement) {
    yield nextNode;
    nextNode = options.reverse ? walker.previousNode() : walker.nextNode();
  }
  if (options.reverse && acceptFn(container, strict)) {
    yield container;
  }
  return void 0;
}
function getFocusableChild(container, lastChild = false) {
  return iterateFocusableElements(container, { reverse: lastChild, strict: true, onlyTabbable: true }).next().value;
}
function isFocusable$1(elem, strict = false) {
  const disabledAttrInert = ["BUTTON", "INPUT", "SELECT", "TEXTAREA", "OPTGROUP", "OPTION", "FIELDSET"].includes(elem.tagName) && elem.disabled;
  const hiddenInert = elem.hidden;
  const hiddenInputInert = elem instanceof HTMLInputElement && elem.type === "hidden";
  const sentinelInert = elem.classList.contains("sentinel");
  if (disabledAttrInert || hiddenInert || hiddenInputInert || sentinelInert) {
    return false;
  }
  if (strict) {
    const style3 = getComputedStyle(elem);
    const sizeInert = elem.offsetWidth === 0 || elem.offsetHeight === 0;
    const visibilityInert = ["hidden", "collapse"].includes(style3.visibility);
    const displayInert = style3.display === "none" || !elem.offsetParent;
    const clientRectsInert = elem.getClientRects().length === 0;
    if (sizeInert || visibilityInert || clientRectsInert || displayInert) {
      return false;
    }
  }
  if (elem.getAttribute("tabindex") != null) {
    return true;
  }
  if (elem.getAttribute("contenteditable") === "true" || elem.getAttribute("contenteditable") === "plaintext-only") {
    return true;
  }
  if (elem instanceof HTMLAnchorElement && elem.getAttribute("href") == null) {
    return false;
  }
  return elem.tabIndex !== -1;
}
function isTabbable(elem, strict = false) {
  return isFocusable$1(elem, strict) && elem.getAttribute("tabindex") !== "-1";
}
let idSeed = 1e4;
function uniqueId() {
  return `__primer_id_${idSeed++}`;
}
let isMac = void 0;
function isMacOS$1() {
  if (isMac === void 0) {
    isMac = /^mac/i.test(window.navigator.platform);
  }
  return isMac;
}
function useOpenAndCloseFocus(t0) {
  const $2 = distExports.c(10);
  const {
    initialFocusRef,
    returnFocusRef,
    containerRef,
    preventFocusOnOpen
  } = t0;
  let t1;
  if ($2[0] !== containerRef || $2[1] !== initialFocusRef || $2[2] !== preventFocusOnOpen || $2[3] !== returnFocusRef.current) {
    t1 = () => {
      if (!preventFocusOnOpen) {
        if (initialFocusRef && initialFocusRef.current) {
          initialFocusRef.current.focus();
        } else {
          if (containerRef.current) {
            const firstItem2 = iterateFocusableElements(containerRef.current).next().value;
            firstItem2 === null || firstItem2 === void 0 ? void 0 : firstItem2.focus();
          }
        }
      }
      const returnFocusRefCurrent = returnFocusRef.current;
      return function() {
        returnFocusRefCurrent === null || returnFocusRefCurrent === void 0 ? void 0 : returnFocusRefCurrent.focus();
      };
    };
    $2[0] = containerRef;
    $2[1] = initialFocusRef;
    $2[2] = preventFocusOnOpen;
    $2[3] = returnFocusRef.current;
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  let t2;
  if ($2[5] !== containerRef || $2[6] !== initialFocusRef || $2[7] !== preventFocusOnOpen || $2[8] !== returnFocusRef) {
    t2 = [initialFocusRef, returnFocusRef, containerRef, preventFocusOnOpen];
    $2[5] = containerRef;
    $2[6] = initialFocusRef;
    $2[7] = preventFocusOnOpen;
    $2[8] = returnFocusRef;
    $2[9] = t2;
  } else {
    t2 = $2[9];
  }
  useEffect(t1, t2);
}
function handleEscape(event) {
  if (!event.defaultPrevented) {
    for (const handler of Object.values(registry).reverse()) {
      handler(event);
      if (event.defaultPrevented) break;
    }
  }
}
const registry = {};
function register(id, handler) {
  registry[id] = handler;
}
function deregister(id) {
  delete registry[id];
}
let handlerId = 0;
const useOnEscapePress = (onEscape, callbackDependencies = [onEscape]) => {
  const escapeCallback = useCallback$1(onEscape, callbackDependencies);
  const handler = useCallback$1((event) => {
    if (event.key === "Escape") escapeCallback(event);
  }, [escapeCallback]);
  const id = useMemo$1(() => handlerId++, []);
  useEffect(() => {
    if (Object.keys(registry).length === 0) {
      document.addEventListener("keydown", handleEscape);
    }
    register(id, handler);
    return () => {
      deregister(id);
      if (Object.keys(registry).length === 0) {
        document.removeEventListener("keydown", handleEscape);
      }
    };
  }, [id, handler]);
};
function useProvidedRefOrCreate(providedRef) {
  const createdRef = React__default.useRef(null);
  return providedRef !== null && providedRef !== void 0 ? providedRef : createdRef;
}
const useOverlay = (t0) => {
  const $2 = distExports.c(13);
  const {
    overlayRef: _overlayRef,
    returnFocusRef,
    initialFocusRef,
    onEscape,
    ignoreClickRefs,
    onClickOutside,
    preventFocusOnOpen
  } = t0;
  const overlayRef = useProvidedRefOrCreate(_overlayRef);
  let t1;
  if ($2[0] !== initialFocusRef || $2[1] !== overlayRef || $2[2] !== preventFocusOnOpen || $2[3] !== returnFocusRef) {
    t1 = {
      containerRef: overlayRef,
      returnFocusRef,
      initialFocusRef,
      preventFocusOnOpen
    };
    $2[0] = initialFocusRef;
    $2[1] = overlayRef;
    $2[2] = preventFocusOnOpen;
    $2[3] = returnFocusRef;
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  useOpenAndCloseFocus(t1);
  let t2;
  if ($2[5] !== ignoreClickRefs || $2[6] !== onClickOutside || $2[7] !== overlayRef) {
    t2 = {
      containerRef: overlayRef,
      ignoreClickRefs,
      onClickOutside
    };
    $2[5] = ignoreClickRefs;
    $2[6] = onClickOutside;
    $2[7] = overlayRef;
    $2[8] = t2;
  } else {
    t2 = $2[8];
  }
  useOnOutsideClick(t2);
  let t3;
  if ($2[9] !== onEscape) {
    t3 = (event) => {
      onEscape(event);
      event.preventDefault();
    };
    $2[9] = onEscape;
    $2[10] = t3;
  } else {
    t3 = $2[10];
  }
  const preventeddefaultCheckedEscape = t3;
  useOnEscapePress(preventeddefaultCheckedEscape);
  let t4;
  if ($2[11] !== overlayRef) {
    t4 = {
      ref: overlayRef
    };
    $2[11] = overlayRef;
    $2[12] = t4;
  } else {
    t4 = $2[12];
  }
  return t4;
};
var client = {};
var hasRequiredClient;
function requireClient() {
  if (hasRequiredClient) return client;
  hasRequiredClient = 1;
  var m2 = ReactDOM__default;
  if (process.env.NODE_ENV === "production") {
    client.createRoot = m2.createRoot;
    client.hydrateRoot = m2.hydrateRoot;
  } else {
    var i = m2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    client.createRoot = function(c2, o2) {
      i.usingClientEntryPoint = true;
      try {
        return m2.createRoot(c2, o2);
      } finally {
        i.usingClientEntryPoint = false;
      }
    };
    client.hydrateRoot = function(c2, h2, o2) {
      i.usingClientEntryPoint = true;
      try {
        return m2.hydrateRoot(c2, h2, o2);
      } finally {
        i.usingClientEntryPoint = false;
      }
    };
  }
  return client;
}
requireClient();
const alternateOrders = {
  "outside-top": ["outside-bottom", "outside-right", "outside-left", "outside-bottom"],
  "outside-bottom": ["outside-top", "outside-right", "outside-left", "outside-bottom"],
  "outside-left": ["outside-right", "outside-bottom", "outside-top", "outside-bottom"],
  "outside-right": ["outside-left", "outside-bottom", "outside-top", "outside-bottom"]
};
const alternateAlignments = {
  start: ["end", "center"],
  end: ["start", "center"],
  center: ["end", "start"]
};
function getAnchoredPosition(floatingElement, anchorElement, settings = {}) {
  const parentElement = getPositionedParent(floatingElement);
  const clippingRect = getClippingRect(parentElement);
  const parentElementStyle = getComputedStyle(parentElement);
  const parentElementRect = parentElement.getBoundingClientRect();
  const [borderTop2, borderLeft2] = [parentElementStyle.borderTopWidth, parentElementStyle.borderLeftWidth].map((v2) => parseInt(v2, 10) || 0);
  const relativeRect = {
    top: parentElementRect.top + borderTop2,
    left: parentElementRect.left + borderLeft2
  };
  return pureCalculateAnchoredPosition(clippingRect, relativeRect, floatingElement.getBoundingClientRect(), anchorElement instanceof Element ? anchorElement.getBoundingClientRect() : anchorElement, getDefaultSettings(settings));
}
function getPositionedParent(element2) {
  if (isOnTopLayer(element2))
    return document.body;
  let parentNode2 = element2.parentNode;
  while (parentNode2 !== null) {
    if (parentNode2 instanceof HTMLElement && getComputedStyle(parentNode2).position !== "static") {
      return parentNode2;
    }
    parentNode2 = parentNode2.parentNode;
  }
  return document.body;
}
function isOnTopLayer(element2) {
  var _a3;
  if (element2.tagName === "DIALOG") {
    return true;
  }
  try {
    if (element2.matches(":popover-open") && /native code/.test((_a3 = document.body.showPopover) === null || _a3 === void 0 ? void 0 : _a3.toString())) {
      return true;
    }
  } catch (_b) {
    return false;
  }
  return false;
}
function getClippingRect(element2) {
  let parentNode2 = element2;
  while (parentNode2 !== null) {
    if (!(parentNode2 instanceof Element)) {
      break;
    }
    const parentNodeStyle = getComputedStyle(parentNode2);
    if (parentNodeStyle.overflow !== "visible") {
      break;
    }
    parentNode2 = parentNode2.parentNode;
  }
  const clippingNode = parentNode2 === document.body || !(parentNode2 instanceof HTMLElement) ? document.body : parentNode2;
  const elemRect = clippingNode.getBoundingClientRect();
  const elemStyle = getComputedStyle(clippingNode);
  const [borderTop2, borderLeft2, borderRight2, borderBottom2] = [
    elemStyle.borderTopWidth,
    elemStyle.borderLeftWidth,
    elemStyle.borderRightWidth,
    elemStyle.borderBottomWidth
  ].map((v2) => parseInt(v2, 10) || 0);
  return {
    top: elemRect.top + borderTop2,
    left: elemRect.left + borderLeft2,
    width: elemRect.width - borderRight2 - borderLeft2,
    height: Math.max(elemRect.height - borderTop2 - borderBottom2, clippingNode === document.body ? window.innerHeight : -Infinity)
  };
}
const positionDefaults = {
  side: "outside-bottom",
  align: "start",
  anchorOffset: 4,
  alignmentOffset: 4,
  allowOutOfBounds: false
};
function getDefaultSettings(settings = {}) {
  var _a3, _b, _c, _d, _e2;
  const side = (_a3 = settings.side) !== null && _a3 !== void 0 ? _a3 : positionDefaults.side;
  const align = (_b = settings.align) !== null && _b !== void 0 ? _b : positionDefaults.align;
  return {
    side,
    align,
    anchorOffset: (_c = settings.anchorOffset) !== null && _c !== void 0 ? _c : side === "inside-center" ? 0 : positionDefaults.anchorOffset,
    alignmentOffset: (_d = settings.alignmentOffset) !== null && _d !== void 0 ? _d : align !== "center" && side.startsWith("inside") ? positionDefaults.alignmentOffset : 0,
    allowOutOfBounds: (_e2 = settings.allowOutOfBounds) !== null && _e2 !== void 0 ? _e2 : positionDefaults.allowOutOfBounds
  };
}
function pureCalculateAnchoredPosition(viewportRect, relativePosition, floatingRect, anchorRect, { side, align, allowOutOfBounds, anchorOffset, alignmentOffset }) {
  const relativeViewportRect = {
    top: viewportRect.top - relativePosition.top,
    left: viewportRect.left - relativePosition.left,
    width: viewportRect.width,
    height: viewportRect.height
  };
  let pos = calculatePosition(floatingRect, anchorRect, side, align, anchorOffset, alignmentOffset);
  let anchorSide = side;
  let anchorAlign = align;
  pos.top -= relativePosition.top;
  pos.left -= relativePosition.left;
  if (!allowOutOfBounds) {
    const alternateOrder = alternateOrders[side];
    let positionAttempt = 0;
    if (alternateOrder) {
      let prevSide = side;
      while (positionAttempt < alternateOrder.length && shouldRecalculatePosition(prevSide, pos, relativeViewportRect, floatingRect)) {
        const nextSide = alternateOrder[positionAttempt++];
        prevSide = nextSide;
        pos = calculatePosition(floatingRect, anchorRect, nextSide, align, anchorOffset, alignmentOffset);
        pos.top -= relativePosition.top;
        pos.left -= relativePosition.left;
        anchorSide = nextSide;
      }
    }
    const alternateAlignment = alternateAlignments[align];
    let alignmentAttempt = 0;
    if (alternateAlignment) {
      let prevAlign = align;
      while (alignmentAttempt < alternateAlignment.length && shouldRecalculateAlignment(prevAlign, pos, relativeViewportRect, floatingRect)) {
        const nextAlign = alternateAlignment[alignmentAttempt++];
        prevAlign = nextAlign;
        pos = calculatePosition(floatingRect, anchorRect, anchorSide, nextAlign, anchorOffset, alignmentOffset);
        pos.top -= relativePosition.top;
        pos.left -= relativePosition.left;
        anchorAlign = nextAlign;
      }
    }
    if (pos.top < relativeViewportRect.top) {
      pos.top = relativeViewportRect.top;
    }
    if (pos.left < relativeViewportRect.left) {
      pos.left = relativeViewportRect.left;
    }
    if (pos.left + floatingRect.width > viewportRect.width + relativeViewportRect.left) {
      pos.left = viewportRect.width + relativeViewportRect.left - floatingRect.width;
    }
    if (alternateOrder && positionAttempt < alternateOrder.length) {
      if (pos.top + floatingRect.height > viewportRect.height + relativeViewportRect.top) {
        pos.top = Math.max(viewportRect.height + relativeViewportRect.top - floatingRect.height, 0);
      }
    }
  }
  return Object.assign(Object.assign({}, pos), { anchorSide, anchorAlign });
}
function calculatePosition(elementDimensions, anchorPosition, side, align, anchorOffset, alignmentOffset) {
  const anchorRight = anchorPosition.left + anchorPosition.width;
  const anchorBottom = anchorPosition.top + anchorPosition.height;
  let top2 = -1;
  let left2 = -1;
  if (side === "outside-top") {
    top2 = anchorPosition.top - anchorOffset - elementDimensions.height;
  } else if (side === "outside-bottom") {
    top2 = anchorBottom + anchorOffset;
  } else if (side === "outside-left") {
    left2 = anchorPosition.left - anchorOffset - elementDimensions.width;
  } else if (side === "outside-right") {
    left2 = anchorRight + anchorOffset;
  }
  if (side === "outside-top" || side === "outside-bottom") {
    if (align === "start") {
      left2 = anchorPosition.left + alignmentOffset;
    } else if (align === "center") {
      left2 = anchorPosition.left - (elementDimensions.width - anchorPosition.width) / 2 + alignmentOffset;
    } else {
      left2 = anchorRight - elementDimensions.width - alignmentOffset;
    }
  }
  if (side === "outside-left" || side === "outside-right") {
    if (align === "start") {
      top2 = anchorPosition.top + alignmentOffset;
    } else if (align === "center") {
      top2 = anchorPosition.top - (elementDimensions.height - anchorPosition.height) / 2 + alignmentOffset;
    } else {
      top2 = anchorBottom - elementDimensions.height - alignmentOffset;
    }
  }
  if (side === "inside-top") {
    top2 = anchorPosition.top + anchorOffset;
  } else if (side === "inside-bottom") {
    top2 = anchorBottom - anchorOffset - elementDimensions.height;
  } else if (side === "inside-left") {
    left2 = anchorPosition.left + anchorOffset;
  } else if (side === "inside-right") {
    left2 = anchorRight - anchorOffset - elementDimensions.width;
  } else if (side === "inside-center") {
    left2 = (anchorRight + anchorPosition.left) / 2 - elementDimensions.width / 2 + anchorOffset;
  }
  if (side === "inside-top" || side === "inside-bottom") {
    if (align === "start") {
      left2 = anchorPosition.left + alignmentOffset;
    } else if (align === "center") {
      left2 = anchorPosition.left - (elementDimensions.width - anchorPosition.width) / 2 + alignmentOffset;
    } else {
      left2 = anchorRight - elementDimensions.width - alignmentOffset;
    }
  } else if (side === "inside-left" || side === "inside-right" || side === "inside-center") {
    if (align === "start") {
      top2 = anchorPosition.top + alignmentOffset;
    } else if (align === "center") {
      top2 = anchorPosition.top - (elementDimensions.height - anchorPosition.height) / 2 + alignmentOffset;
    } else {
      top2 = anchorBottom - elementDimensions.height - alignmentOffset;
    }
  }
  return { top: top2, left: left2 };
}
function shouldRecalculatePosition(side, currentPos, containerDimensions, elementDimensions) {
  if (side === "outside-top" || side === "outside-bottom") {
    return currentPos.top < containerDimensions.top || currentPos.top + elementDimensions.height > containerDimensions.height + containerDimensions.top;
  } else {
    return currentPos.left < containerDimensions.left || currentPos.left + elementDimensions.width > containerDimensions.width + containerDimensions.left;
  }
}
function shouldRecalculateAlignment(align, currentPos, containerDimensions, elementDimensions) {
  if (align === "end") {
    return currentPos.left < containerDimensions.left;
  } else if (align === "start" || align === "center") {
    return currentPos.left + elementDimensions.width > containerDimensions.left + containerDimensions.width || currentPos.left < containerDimensions.left;
  }
}
let signalSupported = false;
function noop$3() {
}
try {
  const options = Object.create({}, {
    signal: {
      get() {
        signalSupported = true;
      }
    }
  });
  window.addEventListener("test", noop$3, options);
  window.removeEventListener("test", noop$3, options);
} catch (e) {
}
function featureSupported() {
  return signalSupported;
}
function monkeyPatch() {
  if (typeof window === "undefined") {
    return;
  }
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function(name2, originalCallback, optionsOrCapture) {
    if (typeof optionsOrCapture === "object" && "signal" in optionsOrCapture && optionsOrCapture.signal instanceof AbortSignal) {
      originalAddEventListener.call(optionsOrCapture.signal, "abort", () => {
        this.removeEventListener(name2, originalCallback, optionsOrCapture);
      });
    }
    return originalAddEventListener.call(this, name2, originalCallback, optionsOrCapture);
  };
}
function polyfill() {
  if (!featureSupported()) {
    monkeyPatch();
    signalSupported = true;
  }
}
polyfill();
const suspendedTrapStack = [];
let activeTrap = void 0;
function tryReactivate() {
  const trapToReactivate = suspendedTrapStack.pop();
  if (trapToReactivate) {
    focusTrap(trapToReactivate.container, trapToReactivate.initialFocus, trapToReactivate.originalSignal);
  }
}
function followSignal(signal) {
  const controller = new AbortController();
  signal.addEventListener("abort", () => {
    controller.abort();
  });
  return controller;
}
function observeFocusTrap(container, sentinels) {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "childList" && mutation.addedNodes.length) {
        const sentinelChildren = Array.from(mutation.addedNodes).filter((e) => e instanceof HTMLElement && e.classList.contains("sentinel") && e.tagName === "SPAN");
        if (sentinelChildren.length) {
          return;
        }
        const firstChild = container.firstElementChild;
        const lastChild = container.lastElementChild;
        const [sentinelStart, sentinelEnd] = sentinels;
        if (!(firstChild === null || firstChild === void 0 ? void 0 : firstChild.classList.contains("sentinel"))) {
          container.insertAdjacentElement("afterbegin", sentinelStart);
        }
        if (!(lastChild === null || lastChild === void 0 ? void 0 : lastChild.classList.contains("sentinel"))) {
          container.insertAdjacentElement("beforeend", sentinelEnd);
        }
      }
    }
  });
  observer.observe(container, { childList: true });
  return observer;
}
function focusTrap(container, initialFocus, abortSignal) {
  const controller = new AbortController();
  const signal = abortSignal !== null && abortSignal !== void 0 ? abortSignal : controller.signal;
  container.setAttribute("data-focus-trap", "active");
  const sentinelStart = document.createElement("span");
  sentinelStart.setAttribute("class", "sentinel");
  sentinelStart.setAttribute("tabindex", "0");
  sentinelStart.setAttribute("aria-hidden", "true");
  sentinelStart.onfocus = () => {
    const lastFocusableChild = getFocusableChild(container, true);
    lastFocusableChild === null || lastFocusableChild === void 0 ? void 0 : lastFocusableChild.focus();
  };
  const sentinelEnd = document.createElement("span");
  sentinelEnd.setAttribute("class", "sentinel");
  sentinelEnd.setAttribute("tabindex", "0");
  sentinelEnd.setAttribute("aria-hidden", "true");
  sentinelEnd.onfocus = () => {
    const firstFocusableChild = getFocusableChild(container);
    firstFocusableChild === null || firstFocusableChild === void 0 ? void 0 : firstFocusableChild.focus();
  };
  const existingSentinels = Array.from(container.children).filter((e) => e.classList.contains("sentinel") && e.tagName === "SPAN");
  if (!existingSentinels.length) {
    container.prepend(sentinelStart);
    container.append(sentinelEnd);
  }
  const observer = observeFocusTrap(container, [sentinelStart, sentinelEnd]);
  let lastFocusedChild = void 0;
  function ensureTrapZoneHasFocus(focusedElement) {
    if (focusedElement instanceof HTMLElement && document.contains(container)) {
      if (container.contains(focusedElement)) {
        lastFocusedChild = focusedElement;
        return;
      } else {
        if (lastFocusedChild && isTabbable(lastFocusedChild) && container.contains(lastFocusedChild)) {
          lastFocusedChild.focus();
          return;
        } else if (initialFocus && container.contains(initialFocus)) {
          initialFocus.focus();
          return;
        } else {
          const firstFocusableChild = getFocusableChild(container);
          firstFocusableChild === null || firstFocusableChild === void 0 ? void 0 : firstFocusableChild.focus();
          return;
        }
      }
    }
  }
  const wrappingController = followSignal(signal);
  if (activeTrap) {
    const suspendedTrap = activeTrap;
    activeTrap.container.setAttribute("data-focus-trap", "suspended");
    activeTrap.controller.abort();
    suspendedTrapStack.push(suspendedTrap);
  }
  wrappingController.signal.addEventListener("abort", () => {
    activeTrap = void 0;
  });
  signal.addEventListener("abort", () => {
    container.removeAttribute("data-focus-trap");
    const sentinels = container.getElementsByClassName("sentinel");
    while (sentinels.length > 0)
      sentinels[0].remove();
    const suspendedTrapIndex2 = suspendedTrapStack.findIndex((t2) => t2.container === container);
    if (suspendedTrapIndex2 >= 0) {
      suspendedTrapStack.splice(suspendedTrapIndex2, 1);
    }
    observer.disconnect();
    tryReactivate();
  });
  document.addEventListener("focus", (event) => {
    ensureTrapZoneHasFocus(event.target);
  }, { signal: wrappingController.signal, capture: true });
  ensureTrapZoneHasFocus(document.activeElement);
  activeTrap = {
    container,
    controller: wrappingController,
    initialFocus,
    originalSignal: signal
  };
  const suspendedTrapIndex = suspendedTrapStack.findIndex((t2) => t2.container === container);
  if (suspendedTrapIndex >= 0) {
    suspendedTrapStack.splice(suspendedTrapIndex, 1);
  }
  if (!abortSignal) {
    return controller;
  }
}
polyfill();
var FocusKeys;
(function(FocusKeys2) {
  FocusKeys2[FocusKeys2["ArrowHorizontal"] = 1] = "ArrowHorizontal";
  FocusKeys2[FocusKeys2["ArrowVertical"] = 2] = "ArrowVertical";
  FocusKeys2[FocusKeys2["JK"] = 4] = "JK";
  FocusKeys2[FocusKeys2["HL"] = 8] = "HL";
  FocusKeys2[FocusKeys2["HomeAndEnd"] = 16] = "HomeAndEnd";
  FocusKeys2[FocusKeys2["PageUpDown"] = 256] = "PageUpDown";
  FocusKeys2[FocusKeys2["WS"] = 32] = "WS";
  FocusKeys2[FocusKeys2["AD"] = 64] = "AD";
  FocusKeys2[FocusKeys2["Tab"] = 128] = "Tab";
  FocusKeys2[FocusKeys2["Backspace"] = 512] = "Backspace";
  FocusKeys2[FocusKeys2["ArrowAll"] = 3] = "ArrowAll";
  FocusKeys2[FocusKeys2["HJKL"] = 12] = "HJKL";
  FocusKeys2[FocusKeys2["WASD"] = 96] = "WASD";
  FocusKeys2[FocusKeys2["All"] = 511] = "All";
})(FocusKeys || (FocusKeys = {}));
const KEY_TO_BIT = {
  ArrowLeft: FocusKeys.ArrowHorizontal,
  ArrowDown: FocusKeys.ArrowVertical,
  ArrowUp: FocusKeys.ArrowVertical,
  ArrowRight: FocusKeys.ArrowHorizontal,
  h: FocusKeys.HL,
  j: FocusKeys.JK,
  k: FocusKeys.JK,
  l: FocusKeys.HL,
  a: FocusKeys.AD,
  s: FocusKeys.WS,
  w: FocusKeys.WS,
  d: FocusKeys.AD,
  Tab: FocusKeys.Tab,
  Home: FocusKeys.HomeAndEnd,
  End: FocusKeys.HomeAndEnd,
  PageUp: FocusKeys.PageUpDown,
  PageDown: FocusKeys.PageUpDown,
  Backspace: FocusKeys.Backspace
};
const KEY_TO_DIRECTION = {
  ArrowLeft: "previous",
  ArrowDown: "next",
  ArrowUp: "previous",
  ArrowRight: "next",
  h: "previous",
  j: "next",
  k: "previous",
  l: "next",
  a: "previous",
  s: "next",
  w: "previous",
  d: "next",
  Tab: "next",
  Home: "start",
  End: "end",
  PageUp: "start",
  PageDown: "end",
  Backspace: "previous"
};
function getDirection(keyboardEvent) {
  const direction = KEY_TO_DIRECTION[keyboardEvent.key];
  if (keyboardEvent.key === "Tab" && keyboardEvent.shiftKey) {
    return "previous";
  }
  const isMac2 = isMacOS$1();
  if (isMac2 && keyboardEvent.metaKey || !isMac2 && keyboardEvent.ctrlKey) {
    if (keyboardEvent.key === "ArrowLeft" || keyboardEvent.key === "ArrowUp") {
      return "start";
    } else if (keyboardEvent.key === "ArrowRight" || keyboardEvent.key === "ArrowDown") {
      return "end";
    }
  }
  return direction;
}
function shouldIgnoreFocusHandling(keyboardEvent, activeElement) {
  const key2 = keyboardEvent.key;
  const keyLength = [...key2].length;
  const isTextInput = activeElement instanceof HTMLInputElement && activeElement.type === "text" || activeElement instanceof HTMLTextAreaElement;
  if (isTextInput && (keyLength === 1 || key2 === "Home" || key2 === "End")) {
    return true;
  }
  if (activeElement instanceof HTMLSelectElement) {
    if (keyLength === 1) {
      return true;
    }
    if (key2 === "ArrowDown" && isMacOS$1() && !keyboardEvent.metaKey) {
      return true;
    }
    if (key2 === "ArrowDown" && !isMacOS$1() && keyboardEvent.altKey) {
      return true;
    }
  }
  if (activeElement instanceof HTMLTextAreaElement && (key2 === "PageUp" || key2 === "PageDown")) {
    return true;
  }
  if (isTextInput) {
    const textInput = activeElement;
    const cursorAtStart = textInput.selectionStart === 0 && textInput.selectionEnd === 0;
    const cursorAtEnd = textInput.selectionStart === textInput.value.length && textInput.selectionEnd === textInput.value.length;
    if (key2 === "ArrowLeft" && !cursorAtStart) {
      return true;
    }
    if (key2 === "ArrowRight" && !cursorAtEnd) {
      return true;
    }
    if (textInput instanceof HTMLTextAreaElement) {
      if (key2 === "ArrowUp" && !cursorAtStart) {
        return true;
      }
      if (key2 === "ArrowDown" && !cursorAtEnd) {
        return true;
      }
    }
  }
  return false;
}
const isActiveDescendantAttribute = "data-is-active-descendant";
const activeDescendantActivatedDirectly = "activated-directly";
const activeDescendantActivatedIndirectly = "activated-indirectly";
const hasActiveDescendantAttribute = "data-has-active-descendant";
function focusZone(container, settings) {
  var _a3, _b, _c, _d, _e2;
  const focusableElements = [];
  const savedTabIndex = /* @__PURE__ */ new WeakMap();
  const bindKeys = (_a3 = settings === null || settings === void 0 ? void 0 : settings.bindKeys) !== null && _a3 !== void 0 ? _a3 : ((settings === null || settings === void 0 ? void 0 : settings.getNextFocusable) ? FocusKeys.ArrowAll : FocusKeys.ArrowVertical) | FocusKeys.HomeAndEnd;
  const focusOutBehavior = (_b = settings === null || settings === void 0 ? void 0 : settings.focusOutBehavior) !== null && _b !== void 0 ? _b : "stop";
  const focusInStrategy = (_c = settings === null || settings === void 0 ? void 0 : settings.focusInStrategy) !== null && _c !== void 0 ? _c : "previous";
  const activeDescendantControl = settings === null || settings === void 0 ? void 0 : settings.activeDescendantControl;
  const activeDescendantCallback = settings === null || settings === void 0 ? void 0 : settings.onActiveDescendantChanged;
  let currentFocusedElement;
  const preventScroll = (_d = settings === null || settings === void 0 ? void 0 : settings.preventScroll) !== null && _d !== void 0 ? _d : false;
  function getFirstFocusableElement() {
    return focusableElements[0];
  }
  function isActiveDescendantInputFocused() {
    return document.activeElement === activeDescendantControl;
  }
  function updateFocusedElement(to2, directlyActivated = false) {
    const from3 = currentFocusedElement;
    currentFocusedElement = to2;
    if (activeDescendantControl) {
      if (to2 && isActiveDescendantInputFocused()) {
        setActiveDescendant(from3, to2, directlyActivated);
      } else {
        clearActiveDescendant();
      }
      return;
    }
    if (from3 && from3 !== to2 && savedTabIndex.has(from3)) {
      from3.setAttribute("tabindex", "-1");
    }
    to2 === null || to2 === void 0 ? void 0 : to2.setAttribute("tabindex", "0");
  }
  function setActiveDescendant(from3, to2, directlyActivated = false) {
    if (!to2.id) {
      to2.setAttribute("id", uniqueId());
    }
    if (from3 && from3 !== to2) {
      from3.removeAttribute(isActiveDescendantAttribute);
    }
    if (!activeDescendantControl || !directlyActivated && activeDescendantControl.getAttribute("aria-activedescendant") === to2.id) {
      return;
    }
    activeDescendantControl.setAttribute("aria-activedescendant", to2.id);
    container.setAttribute(hasActiveDescendantAttribute, to2.id);
    to2.setAttribute(isActiveDescendantAttribute, directlyActivated ? activeDescendantActivatedDirectly : activeDescendantActivatedIndirectly);
    activeDescendantCallback === null || activeDescendantCallback === void 0 ? void 0 : activeDescendantCallback(to2, from3, directlyActivated);
  }
  function clearActiveDescendant(previouslyActiveElement = currentFocusedElement) {
    if (focusInStrategy === "first") {
      currentFocusedElement = void 0;
    }
    activeDescendantControl === null || activeDescendantControl === void 0 ? void 0 : activeDescendantControl.removeAttribute("aria-activedescendant");
    container.removeAttribute(hasActiveDescendantAttribute);
    previouslyActiveElement === null || previouslyActiveElement === void 0 ? void 0 : previouslyActiveElement.removeAttribute(isActiveDescendantAttribute);
    for (const item of container.querySelectorAll(`[${isActiveDescendantAttribute}]`)) {
      item === null || item === void 0 ? void 0 : item.removeAttribute(isActiveDescendantAttribute);
    }
    activeDescendantCallback === null || activeDescendantCallback === void 0 ? void 0 : activeDescendantCallback(void 0, previouslyActiveElement, false);
  }
  function beginFocusManagement(...elements) {
    const filteredElements = elements.filter((e) => {
      var _a4, _b2;
      return (_b2 = (_a4 = settings === null || settings === void 0 ? void 0 : settings.focusableElementFilter) === null || _a4 === void 0 ? void 0 : _a4.call(settings, e)) !== null && _b2 !== void 0 ? _b2 : true;
    });
    if (filteredElements.length === 0) {
      return;
    }
    focusableElements.splice(findInsertionIndex(filteredElements), 0, ...filteredElements);
    for (const element2 of filteredElements) {
      if (!savedTabIndex.has(element2)) {
        savedTabIndex.set(element2, element2.getAttribute("tabindex"));
      }
      element2.setAttribute("tabindex", "-1");
    }
    if (!currentFocusedElement) {
      updateFocusedElement(getFirstFocusableElement());
    }
  }
  function findInsertionIndex(elementsToInsert) {
    const firstElementToInsert = elementsToInsert[0];
    if (focusableElements.length === 0)
      return 0;
    let iMin = 0;
    let iMax = focusableElements.length - 1;
    while (iMin <= iMax) {
      const i = Math.floor((iMin + iMax) / 2);
      const element2 = focusableElements[i];
      if (followsInDocument(firstElementToInsert, element2)) {
        iMax = i - 1;
      } else {
        iMin = i + 1;
      }
    }
    return iMin;
  }
  function followsInDocument(first2, second) {
    return (second.compareDocumentPosition(first2) & Node.DOCUMENT_POSITION_PRECEDING) > 0;
  }
  function endFocusManagement(...elements) {
    for (const element2 of elements) {
      const focusableElementIndex = focusableElements.indexOf(element2);
      if (focusableElementIndex >= 0) {
        focusableElements.splice(focusableElementIndex, 1);
      }
      const savedIndex = savedTabIndex.get(element2);
      if (savedIndex !== void 0) {
        if (savedIndex === null) {
          element2.removeAttribute("tabindex");
        } else {
          element2.setAttribute("tabindex", savedIndex);
        }
        savedTabIndex.delete(element2);
      }
      if (element2 === currentFocusedElement) {
        const nextElementToFocus = getFirstFocusableElement();
        updateFocusedElement(nextElementToFocus);
      }
    }
  }
  const iterateFocusableElementsOptions = {
    reverse: settings === null || settings === void 0 ? void 0 : settings.reverse,
    strict: settings === null || settings === void 0 ? void 0 : settings.strict,
    onlyTabbable: settings === null || settings === void 0 ? void 0 : settings.onlyTabbable
  };
  beginFocusManagement(...iterateFocusableElements(container, iterateFocusableElementsOptions));
  const initialElement = typeof focusInStrategy === "function" ? focusInStrategy(document.body) : getFirstFocusableElement();
  updateFocusedElement(initialElement);
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const removedNode of mutation.removedNodes) {
        if (removedNode instanceof HTMLElement) {
          endFocusManagement(...iterateFocusableElements(removedNode));
        }
      }
      if (mutation.type === "attributes" && mutation.oldValue === null) {
        if (mutation.target instanceof HTMLElement) {
          endFocusManagement(mutation.target);
        }
      }
    }
    for (const mutation of mutations) {
      for (const addedNode of mutation.addedNodes) {
        if (addedNode instanceof HTMLElement) {
          beginFocusManagement(...iterateFocusableElements(addedNode, iterateFocusableElementsOptions));
        }
      }
      if (mutation.type === "attributes" && mutation.oldValue !== null) {
        if (mutation.target instanceof HTMLElement) {
          beginFocusManagement(mutation.target);
        }
      }
    }
  });
  observer.observe(container, {
    subtree: true,
    childList: true,
    attributeFilter: ["hidden", "disabled"],
    attributeOldValue: true
  });
  const controller = new AbortController();
  const signal = (_e2 = settings === null || settings === void 0 ? void 0 : settings.abortSignal) !== null && _e2 !== void 0 ? _e2 : controller.signal;
  signal.addEventListener("abort", () => {
    endFocusManagement(...focusableElements);
  });
  let elementIndexFocusedByClick = void 0;
  container.addEventListener("mousedown", (event) => {
    if (event.target instanceof HTMLElement && event.target !== document.activeElement) {
      elementIndexFocusedByClick = focusableElements.indexOf(event.target);
    }
  }, { signal });
  if (activeDescendantControl) {
    container.addEventListener("focusin", (event) => {
      if (event.target instanceof HTMLElement && focusableElements.includes(event.target)) {
        activeDescendantControl.focus({ preventScroll });
        updateFocusedElement(event.target);
      }
    }, { signal });
    container.addEventListener("mousemove", ({ target }) => {
      if (!(target instanceof Node)) {
        return;
      }
      const focusableElement = focusableElements.find((element2) => element2.contains(target));
      if (focusableElement) {
        updateFocusedElement(focusableElement);
      }
    }, { signal, capture: true });
    activeDescendantControl.addEventListener("focusin", () => {
      if (!currentFocusedElement) {
        updateFocusedElement(getFirstFocusableElement());
      } else {
        setActiveDescendant(void 0, currentFocusedElement);
      }
    }, { signal });
    activeDescendantControl.addEventListener("focusout", () => {
      clearActiveDescendant();
    }, { signal });
  } else {
    container.addEventListener("focusin", (event) => {
      if (event.target instanceof HTMLElement) {
        if (elementIndexFocusedByClick !== void 0) {
          if (elementIndexFocusedByClick >= 0) {
            if (focusableElements[elementIndexFocusedByClick] !== currentFocusedElement) {
              updateFocusedElement(focusableElements[elementIndexFocusedByClick]);
            }
          }
          elementIndexFocusedByClick = void 0;
        } else {
          if (focusInStrategy === "previous") {
            updateFocusedElement(event.target);
          } else if (focusInStrategy === "closest" || focusInStrategy === "first") {
            if (event.relatedTarget instanceof Element && !container.contains(event.relatedTarget)) {
              const targetElementIndex = lastKeyboardFocusDirection === "previous" ? focusableElements.length - 1 : 0;
              const targetElement = focusableElements[targetElementIndex];
              targetElement === null || targetElement === void 0 ? void 0 : targetElement.focus({ preventScroll });
              return;
            } else {
              updateFocusedElement(event.target);
            }
          } else if (typeof focusInStrategy === "function") {
            if (event.relatedTarget instanceof Element && !container.contains(event.relatedTarget)) {
              const elementToFocus = focusInStrategy(event.relatedTarget);
              const requestedFocusElementIndex = elementToFocus ? focusableElements.indexOf(elementToFocus) : -1;
              if (requestedFocusElementIndex >= 0 && elementToFocus instanceof HTMLElement) {
                elementToFocus.focus({ preventScroll });
                return;
              } else {
                console.warn("Element requested is not a known focusable element.");
              }
            } else {
              updateFocusedElement(event.target);
            }
          }
        }
      }
      lastKeyboardFocusDirection = void 0;
    }, { signal });
  }
  const keyboardEventRecipient = activeDescendantControl !== null && activeDescendantControl !== void 0 ? activeDescendantControl : container;
  let lastKeyboardFocusDirection = void 0;
  if (focusInStrategy === "closest") {
    document.addEventListener("keydown", (event) => {
      if (event.key === "Tab") {
        lastKeyboardFocusDirection = getDirection(event);
      }
    }, { signal, capture: true });
  }
  function getCurrentFocusedIndex() {
    if (!currentFocusedElement) {
      return 0;
    }
    const focusedIndex = focusableElements.indexOf(currentFocusedElement);
    const fallbackIndex = currentFocusedElement === container ? -1 : 0;
    return focusedIndex !== -1 ? focusedIndex : fallbackIndex;
  }
  keyboardEventRecipient.addEventListener("keydown", (event) => {
    var _a4;
    if (event.key in KEY_TO_DIRECTION) {
      const keyBit = KEY_TO_BIT[event.key];
      if (!event.defaultPrevented && (keyBit & bindKeys) > 0 && !shouldIgnoreFocusHandling(event, document.activeElement)) {
        const direction = getDirection(event);
        let nextElementToFocus = void 0;
        if (settings === null || settings === void 0 ? void 0 : settings.getNextFocusable) {
          nextElementToFocus = settings.getNextFocusable(direction, (_a4 = document.activeElement) !== null && _a4 !== void 0 ? _a4 : void 0, event);
        }
        if (!nextElementToFocus) {
          const lastFocusedIndex = getCurrentFocusedIndex();
          let nextFocusedIndex = lastFocusedIndex;
          if (direction === "previous") {
            nextFocusedIndex -= 1;
          } else if (direction === "start") {
            nextFocusedIndex = 0;
          } else if (direction === "next") {
            nextFocusedIndex += 1;
          } else {
            nextFocusedIndex = focusableElements.length - 1;
          }
          if (nextFocusedIndex < 0) {
            if (focusOutBehavior === "wrap" && event.key !== "Tab") {
              nextFocusedIndex = focusableElements.length - 1;
            } else {
              nextFocusedIndex = 0;
            }
          }
          if (nextFocusedIndex >= focusableElements.length) {
            if (focusOutBehavior === "wrap" && event.key !== "Tab") {
              nextFocusedIndex = 0;
            } else {
              nextFocusedIndex = focusableElements.length - 1;
            }
          }
          if (lastFocusedIndex !== nextFocusedIndex) {
            nextElementToFocus = focusableElements[nextFocusedIndex];
          }
        }
        if (activeDescendantControl) {
          updateFocusedElement(nextElementToFocus || currentFocusedElement, true);
        } else if (nextElementToFocus) {
          lastKeyboardFocusDirection = direction;
          nextElementToFocus.focus({ preventScroll });
        }
        if (event.key !== "Tab" || nextElementToFocus) {
          event.preventDefault();
        }
      }
    }
  }, { signal });
  return controller;
}
function scrollIntoView$1(child, viewingArea, { direction = "vertical", startMargin = 0, endMargin = 0, behavior = "smooth" } = {}) {
  const startSide = direction === "vertical" ? "top" : "left";
  const endSide = direction === "vertical" ? "bottom" : "right";
  const scrollSide = direction === "vertical" ? "scrollTop" : "scrollLeft";
  const { [startSide]: childStart, [endSide]: childEnd } = child.getBoundingClientRect();
  const { [startSide]: viewingAreaStart, [endSide]: viewingAreaEnd } = viewingArea.getBoundingClientRect();
  const isChildStartAboveViewingArea = childStart < viewingAreaStart + startMargin;
  const isChildBottomBelowViewingArea = childEnd > viewingAreaEnd - endMargin;
  if (isChildStartAboveViewingArea) {
    const scrollHeightToChildStart = childStart - viewingAreaStart + viewingArea[scrollSide];
    viewingArea.scrollTo({ behavior, [startSide]: scrollHeightToChildStart - startMargin });
  } else if (isChildBottomBelowViewingArea) {
    const scrollHeightToChildBottom = childEnd - viewingAreaEnd + viewingArea[scrollSide];
    viewingArea.scrollTo({ behavior, [startSide]: scrollHeightToChildBottom + endMargin });
  }
}
const getAlignContentSize = (alignContent2 = "center") => ({
  justifyContent: alignContent2 === "center" ? "center" : "flex-start"
});
function useRefObjectAsForwardedRef(forwardedRef, refObject) {
  const $2 = distExports.c(2);
  let t0;
  if ($2[0] !== refObject.current) {
    t0 = () => refObject.current;
    $2[0] = refObject.current;
    $2[1] = t0;
  } else {
    t0 = $2[1];
  }
  useImperativeHandle(forwardedRef, t0);
}
const ConditionalWrapper = (props) => {
  const $2 = distExports.c(8);
  let condition;
  let rest;
  if ($2[0] !== props) {
    ({
      if: condition,
      ...rest
    } = props);
    $2[0] = props;
    $2[1] = condition;
    $2[2] = rest;
  } else {
    condition = $2[1];
    rest = $2[2];
  }
  if (condition) {
    let t0;
    if ($2[3] !== props.children || $2[4] !== rest) {
      t0 = /* @__PURE__ */ jsxRuntimeExports.jsx(Box, {
        ...rest,
        children: props.children
      });
      $2[3] = props.children;
      $2[4] = rest;
      $2[5] = t0;
    } else {
      t0 = $2[5];
    }
    return t0;
  } else {
    let t0;
    if ($2[6] !== props.children) {
      t0 = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
        children: props.children
      });
      $2[6] = props.children;
      $2[7] = t0;
    } else {
      t0 = $2[7];
    }
    return t0;
  }
};
var classes$P = { "ButtonBase": "prc-Button-ButtonBase-c50BI", "CounterLabel": "prc-Button-CounterLabel-f5-4u", "Visual": "prc-Button-Visual-2epfX", "VisualWrap": "prc-Button-VisualWrap-Db-eB", "IconButton": "prc-Button-IconButton-szpyj", "ButtonContent": "prc-Button-ButtonContent-HKbr-", "Label": "prc-Button-Label-pTQ3x", "LoadingSpinner": "prc-Button-LoadingSpinner-hLV6o", "ConditionalWrapper": "prc-Button-ConditionalWrapper-WLT4Z" };
var classes$O = { "Box": "prc-Spinner-Box-qNUI9", "SpinnerAnimation": "prc-Spinner-SpinnerAnimation-e7Gf-" };
var classes$N = { "VisuallyHidden": "prc-VisuallyHidden-VisuallyHidden-UNWQp" };
const VisuallyHidden$1 = (t0) => {
  const $2 = distExports.c(10);
  let children;
  let className;
  let rest;
  if ($2[0] !== t0) {
    ({
      className,
      children,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = className;
    $2[3] = rest;
  } else {
    children = $2[1];
    className = $2[2];
    rest = $2[3];
  }
  let t1;
  if ($2[4] !== className) {
    t1 = clsx(className, classes$N.VisuallyHidden);
    $2[4] = className;
    $2[5] = t1;
  } else {
    t1 = $2[5];
  }
  let t2;
  if ($2[6] !== children || $2[7] !== rest || $2[8] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: "span",
      className: t1,
      ...rest,
      children
    });
    $2[6] = children;
    $2[7] = rest;
    $2[8] = t1;
    $2[9] = t2;
  } else {
    t2 = $2[9];
  }
  return t2;
};
const sizeMap$1 = {
  small: "16px",
  medium: "32px",
  large: "64px"
};
function Spinner(t0) {
  var _ariaLabel;
  const $2 = distExports.c(23);
  let ariaLabel;
  let className;
  let props;
  let style3;
  let t1;
  let t2;
  if ($2[0] !== t0) {
    ({
      size: t1,
      srText: t2,
      "aria-label": ariaLabel,
      className,
      style: style3,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = ariaLabel;
    $2[2] = className;
    $2[3] = props;
    $2[4] = style3;
    $2[5] = t1;
    $2[6] = t2;
  } else {
    ariaLabel = $2[1];
    className = $2[2];
    props = $2[3];
    style3 = $2[4];
    t1 = $2[5];
    t2 = $2[6];
  }
  const sizeKey = t1 === void 0 ? "medium" : t1;
  const srText = t2 === void 0 ? "Loading" : t2;
  const size2 = sizeMap$1[sizeKey];
  const hasHiddenLabel = srText !== null && ariaLabel === void 0;
  const labelId = useId();
  const t3 = (_ariaLabel = ariaLabel) !== null && _ariaLabel !== void 0 ? _ariaLabel : void 0;
  const t4 = hasHiddenLabel ? labelId : void 0;
  let t5;
  let t6;
  if ($2[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsx("circle", {
      cx: "8",
      cy: "8",
      r: "7",
      stroke: "currentColor",
      strokeOpacity: "0.25",
      strokeWidth: "2",
      vectorEffect: "non-scaling-stroke"
    });
    t6 = /* @__PURE__ */ jsxRuntimeExports.jsx("path", {
      d: "M15 8a7.002 7.002 0 00-7-7",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      vectorEffect: "non-scaling-stroke"
    });
    $2[7] = t5;
    $2[8] = t6;
  } else {
    t5 = $2[7];
    t6 = $2[8];
  }
  let t7;
  if ($2[9] !== className || $2[10] !== props || $2[11] !== size2 || $2[12] !== style3 || $2[13] !== t3 || $2[14] !== t4) {
    t7 = /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", {
      height: size2,
      width: size2,
      viewBox: "0 0 16 16",
      fill: "none",
      "aria-hidden": true,
      "aria-label": t3,
      "aria-labelledby": t4,
      className,
      style: style3,
      ...props,
      children: [t5, t6]
    });
    $2[9] = className;
    $2[10] = props;
    $2[11] = size2;
    $2[12] = style3;
    $2[13] = t3;
    $2[14] = t4;
    $2[15] = t7;
  } else {
    t7 = $2[15];
  }
  let t8;
  if ($2[16] !== hasHiddenLabel || $2[17] !== labelId || $2[18] !== srText) {
    t8 = hasHiddenLabel ? /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, {
      id: labelId,
      children: srText
    }) : null;
    $2[16] = hasHiddenLabel;
    $2[17] = labelId;
    $2[18] = srText;
    $2[19] = t8;
  } else {
    t8 = $2[19];
  }
  let t9;
  if ($2[20] !== t7 || $2[21] !== t8) {
    t9 = /* @__PURE__ */ jsxRuntimeExports.jsxs("span", {
      className: classes$O.Box,
      children: [t7, t8]
    });
    $2[20] = t7;
    $2[21] = t8;
    $2[22] = t9;
  } else {
    t9 = $2[22];
  }
  return t9;
}
function StyledSpinner(t0) {
  const $2 = distExports.c(8);
  let className;
  let props;
  if ($2[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = props;
  } else {
    className = $2[1];
    props = $2[2];
  }
  let t1;
  if ($2[3] !== className) {
    t1 = clsx(className, classes$O.SpinnerAnimation);
    $2[3] = className;
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  let t2;
  if ($2[5] !== props || $2[6] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: Spinner,
      className: t1,
      ...props
    });
    $2[5] = props;
    $2[6] = t1;
    $2[7] = t2;
  } else {
    t2 = $2[7];
  }
  return t2;
}
StyledSpinner.displayName = "Spinner";
const Ordering = {
  Less: "less",
  Equal: "equal",
  Greater: "greater"
};
var __typeError$2 = (msg) => {
  throw TypeError(msg);
};
var __accessCheck$2 = (obj, member, msg) => member.has(obj) || __typeError$2("Cannot " + msg);
var __privateGet$2 = (obj, member, getter) => (__accessCheck$2(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$2 = (obj, member, value) => member.has(obj) ? __typeError$2("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$2 = (obj, member, value, setter) => (__accessCheck$2(obj, member, "write to private field"), member.set(obj, value), value);
var __privateMethod$1 = (obj, member, method) => (__accessCheck$2(obj, member, "access private method"), method);
var _compareFn, _heap, _MinHeap_instances, heapifyDown_fn, heapifyUp_fn;
class MinHeap {
  constructor({ compareFn }) {
    __privateAdd$2(this, _MinHeap_instances);
    __privateAdd$2(this, _compareFn);
    __privateAdd$2(this, _heap);
    __privateSet$2(this, _compareFn, compareFn);
    __privateSet$2(this, _heap, []);
  }
  insert(value) {
    __privateGet$2(this, _heap).push(value);
    __privateMethod$1(this, _MinHeap_instances, heapifyUp_fn).call(this);
  }
  pop() {
    const item = __privateGet$2(this, _heap)[0];
    if (__privateGet$2(this, _heap)[__privateGet$2(this, _heap).length - 1]) {
      __privateGet$2(this, _heap)[0] = __privateGet$2(this, _heap)[__privateGet$2(this, _heap).length - 1];
      __privateGet$2(this, _heap).pop();
    }
    __privateMethod$1(this, _MinHeap_instances, heapifyDown_fn).call(this);
    return item;
  }
  peek() {
    return __privateGet$2(this, _heap)[0];
  }
  delete(value) {
    const index2 = __privateGet$2(this, _heap).indexOf(value);
    if (index2 === -1) {
      return;
    }
    swap(__privateGet$2(this, _heap), index2, __privateGet$2(this, _heap).length - 1);
    __privateGet$2(this, _heap).pop();
    __privateMethod$1(this, _MinHeap_instances, heapifyDown_fn).call(this);
  }
  clear() {
    __privateSet$2(this, _heap, []);
  }
  get size() {
    return __privateGet$2(this, _heap).length;
  }
}
_compareFn = /* @__PURE__ */ new WeakMap();
_heap = /* @__PURE__ */ new WeakMap();
_MinHeap_instances = /* @__PURE__ */ new WeakSet();
heapifyDown_fn = function() {
  let index2 = 0;
  while (hasLeftChild(index2, __privateGet$2(this, _heap).length)) {
    let smallerChildIndex = getLeftChildIndex(index2);
    if (hasRightChild(index2, __privateGet$2(this, _heap).length) && __privateGet$2(this, _compareFn).call(this, rightChild(__privateGet$2(this, _heap), index2), leftChild(__privateGet$2(this, _heap), index2)) === Ordering.Less) {
      smallerChildIndex = getRightChildIndex(index2);
    }
    if (__privateGet$2(this, _compareFn).call(this, __privateGet$2(this, _heap)[index2], __privateGet$2(this, _heap)[smallerChildIndex]) === Ordering.Less) {
      break;
    } else {
      swap(__privateGet$2(this, _heap), index2, smallerChildIndex);
    }
    index2 = smallerChildIndex;
  }
};
heapifyUp_fn = function() {
  let index2 = __privateGet$2(this, _heap).length - 1;
  while (hasParent(index2) && __privateGet$2(this, _compareFn).call(this, __privateGet$2(this, _heap)[index2], parent(__privateGet$2(this, _heap), index2)) === Ordering.Less) {
    swap(__privateGet$2(this, _heap), index2, getParentIndex(index2));
    index2 = getParentIndex(index2);
  }
};
function getLeftChildIndex(index2) {
  return 2 * index2 + 1;
}
function getRightChildIndex(index2) {
  return 2 * index2 + 2;
}
function getParentIndex(index2) {
  return Math.floor((index2 - 1) / 2);
}
function hasLeftChild(index2, size2) {
  return getLeftChildIndex(index2) < size2;
}
function hasRightChild(index2, size2) {
  return getRightChildIndex(index2) < size2;
}
function hasParent(index2) {
  return index2 > 0;
}
function leftChild(heap, index2) {
  return heap[getLeftChildIndex(index2)];
}
function rightChild(heap, index2) {
  return heap[getRightChildIndex(index2)];
}
function parent(heap, index2) {
  return heap[getParentIndex(index2)];
}
function swap(heap, a2, b2) {
  const tmp = heap[a2];
  heap[a2] = heap[b2];
  heap[b2] = tmp;
}
var __defProp2 = Object.defineProperty;
var __typeError$1 = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp2 = (obj, key2, value) => key2 in obj ? __defProp2(obj, key2, { enumerable: true, configurable: true, writable: true, value }) : obj[key2] = value;
var __publicField2 = (obj, key2, value) => __defNormalProp2(obj, typeof key2 !== "symbol" ? key2 + "" : key2, value);
var __accessCheck$1 = (obj, member, msg) => member.has(obj) || __typeError$1("Cannot " + msg);
var __privateGet$1 = (obj, member, getter) => (__accessCheck$1(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$1 = (obj, member, value) => member.has(obj) ? __typeError$1("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$1 = (obj, member, value, setter) => (__accessCheck$1(obj, member, "write to private field"), member.set(obj, value), value);
var _a, _promise, _resolve, _reject;
_a = Symbol.toStringTag;
class Deferred {
  constructor() {
    __publicField2(this, _a, "Deferred");
    __privateAdd$1(this, _promise);
    __privateAdd$1(this, _resolve);
    __privateAdd$1(this, _reject);
    __privateSet$1(this, _promise, new Promise((resolve, reject) => {
      __privateSet$1(this, _resolve, resolve);
      __privateSet$1(this, _reject, reject);
    }));
  }
  then(onfulfilled, onrejected) {
    return Promise.prototype.then.apply(__privateGet$1(this, _promise), [onfulfilled, onrejected]);
  }
  catch(onrejected) {
    return Promise.prototype.catch.apply(__privateGet$1(this, _promise), [onrejected]);
  }
  finally(onfinally) {
    return Promise.prototype.finally.apply(__privateGet$1(this, _promise), [onfinally]);
  }
  resolve(value) {
    __privateGet$1(this, _resolve).call(this, value);
  }
  reject(reason) {
    __privateGet$1(this, _reject).call(this, reason);
  }
  getPromise() {
    return __privateGet$1(this, _promise);
  }
}
_promise = /* @__PURE__ */ new WeakMap();
_resolve = /* @__PURE__ */ new WeakMap();
_reject = /* @__PURE__ */ new WeakMap();
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _pending, _queue, _timeoutId, _LiveRegionElement_instances, performWork_fn, updateContainerWithMessage_fn;
const DEFAULT_THROTTLE_DELAY_MS = 150;
class LiveRegionElement extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _LiveRegionElement_instances);
    __privateAdd(this, _pending);
    __privateAdd(this, _queue);
    __privateAdd(this, _timeoutId);
    if (!this.shadowRoot) {
      const template2 = getTemplate();
      const shadowRoot = this.attachShadow({ mode: "open" });
      shadowRoot.appendChild(template2.content.cloneNode(true));
    }
    __privateSet(this, _pending, false);
    __privateSet(this, _timeoutId, null);
    __privateSet(this, _queue, new MinHeap({
      compareFn: compareMessages
    }));
  }
  /**
   * The delay in milliseconds to wait between announcements. This helps to
   * prevent announcements getting dropped if multiple are made at the same time.
   */
  get delay() {
    const value = this.getAttribute("delay");
    if (value) {
      return parseInt(value, 10);
    }
    return DEFAULT_THROTTLE_DELAY_MS;
  }
  set delay(value) {
    this.setAttribute("delay", `${value}`);
  }
  /**
   * Announce a message using a live region with a corresponding politeness
   * level.
   */
  announce(message2, options = {}) {
    const { delayMs: delayMs2, politeness = "polite" } = options;
    const now2 = Date.now();
    const deferred = new Deferred();
    const item = {
      deferred,
      politeness,
      contents: message2,
      scheduled: delayMs2 !== void 0 ? now2 + delayMs2 : now2
    };
    __privateGet(this, _queue).insert(item);
    __privateMethod(this, _LiveRegionElement_instances, performWork_fn).call(this);
    return {
      ...deferred.getPromise(),
      cancel: () => {
        __privateGet(this, _queue).delete(item);
        deferred.resolve();
      }
    };
  }
  /**
   * Announce a message using the text content of an element with a
   * corresponding politeness level
   */
  announceFromElement(element2, options) {
    const textContent = getTextContent$1(element2);
    if (textContent !== "") {
      return this.announce(textContent, options);
    }
    const promise = Promise.resolve();
    return {
      ...promise,
      cancel: noop$2
    };
  }
  getMessage(politeness = "polite") {
    var _a3;
    const container = (_a3 = this.shadowRoot) == null ? void 0 : _a3.getElementById(politeness);
    if (!container) {
      throw new Error("Unable to find container for message");
    }
    return container.textContent;
  }
  /**
   * Prevent pending messages from being announced by the live region.
   */
  clear() {
    if (__privateGet(this, _timeoutId) !== null) {
      clearTimeout(__privateGet(this, _timeoutId));
      __privateSet(this, _timeoutId, null);
    }
    __privateSet(this, _pending, false);
    __privateGet(this, _queue).clear();
  }
}
_pending = /* @__PURE__ */ new WeakMap();
_queue = /* @__PURE__ */ new WeakMap();
_timeoutId = /* @__PURE__ */ new WeakMap();
_LiveRegionElement_instances = /* @__PURE__ */ new WeakSet();
performWork_fn = function() {
  if (__privateGet(this, _pending)) {
    return;
  }
  let message2 = __privateGet(this, _queue).peek();
  if (!message2) {
    return;
  }
  if (__privateGet(this, _timeoutId) !== null) {
    clearTimeout(__privateGet(this, _timeoutId));
    __privateSet(this, _timeoutId, null);
  }
  const now2 = Date.now();
  if (message2.scheduled <= now2) {
    message2 = __privateGet(this, _queue).pop();
    if (message2) {
      __privateMethod(this, _LiveRegionElement_instances, updateContainerWithMessage_fn).call(this, message2);
    }
    __privateMethod(this, _LiveRegionElement_instances, performWork_fn).call(this);
    return;
  }
  const timeout = message2.scheduled - now2;
  __privateSet(this, _timeoutId, window.setTimeout(() => {
    __privateSet(this, _timeoutId, null);
    __privateMethod(this, _LiveRegionElement_instances, performWork_fn).call(this);
  }, timeout));
};
updateContainerWithMessage_fn = function(message2) {
  var _a3;
  __privateSet(this, _pending, true);
  const { contents, deferred, politeness } = message2;
  const container = (_a3 = this.shadowRoot) == null ? void 0 : _a3.getElementById(politeness);
  if (!container) {
    __privateSet(this, _pending, false);
    throw new Error(`Unable to find container for message. Expected a container with id="${politeness}"`);
  }
  if (container.textContent === contents) {
    container.textContent = `${contents} `;
  } else {
    container.textContent = contents;
  }
  if (__privateGet(this, _timeoutId) !== null) {
    clearTimeout(__privateGet(this, _timeoutId));
  }
  deferred.resolve();
  if (this.delay > 0) {
    __privateSet(this, _timeoutId, window.setTimeout(() => {
      __privateSet(this, _timeoutId, null);
      __privateSet(this, _pending, false);
      __privateMethod(this, _LiveRegionElement_instances, performWork_fn).call(this);
    }, this.delay));
  } else {
    __privateSet(this, _timeoutId, null);
    __privateSet(this, _pending, false);
    __privateMethod(this, _LiveRegionElement_instances, performWork_fn).call(this);
  }
};
function getTextContent$1(element2) {
  let value = "";
  if (element2.hasAttribute("aria-label")) {
    value = element2.getAttribute("aria-label");
  } else if (element2.innerText) {
    value = element2.innerText;
  } else if (element2.textContent) {
    value = element2.textContent;
  }
  return value ? value.trim() : "";
}
let template = null;
const templateContent = `
<style>
:host {
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
</style>
<div id="polite" aria-live="polite" aria-atomic="true"></div>
<div id="assertive" aria-live="assertive" aria-atomic="true"></div>
`;
function getTemplate() {
  if (template) {
    return template;
  }
  template = document.createElement("template");
  template.innerHTML = templateContent;
  return template;
}
function compareMessages(a2, b2) {
  if (a2.politeness === b2.politeness) {
    if (a2.scheduled === b2.scheduled) {
      return Ordering.Equal;
    }
    if (a2.scheduled < b2.scheduled) {
      return Ordering.Less;
    }
    return Ordering.Greater;
  }
  if (a2.politeness === "assertive" && b2.politeness !== "assertive") {
    return Ordering.Less;
  }
  if (a2.politeness !== "assertive" && b2.politeness === "assertive") {
    return Ordering.Greater;
  }
  return Ordering.Equal;
}
function noop$2() {
}
if (!customElements.get("live-region")) {
  customElements.define("live-region", LiveRegionElement);
}
function announce(message2, options = {}) {
  let liveRegion = findLiveRegion(options.from);
  if (!liveRegion) {
    liveRegion = document.createElement("live-region");
    if (options.appendTo) {
      options.appendTo.appendChild(liveRegion);
    } else {
      const container = getLiveRegionContainer(options.from);
      container.appendChild(liveRegion);
    }
    if (process.env.NODE_ENV === "test") {
      return liveRegion.announce(message2, options);
    }
    let canceled = false;
    let cancel = () => {
      canceled = true;
    };
    const promise = wait(REGISTER_WAIT_MS).then(() => {
      if (!canceled) {
        const result = liveRegion.announce(message2, options);
        cancel = result.cancel;
        return result;
      }
    });
    return {
      ...promise,
      cancel: () => {
        cancel();
      }
    };
  }
  return liveRegion.announce(message2, options);
}
function announceFromElement(element2, options = {}) {
  let liveRegion = findLiveRegion(options.from);
  if (!liveRegion) {
    liveRegion = document.createElement("live-region");
    if (options.appendTo) {
      options.appendTo.appendChild(liveRegion);
    } else {
      const container = getLiveRegionContainer(options.from);
      container.appendChild(liveRegion);
    }
    if (process.env.NODE_ENV === "test") {
      return liveRegion.announceFromElement(element2, options);
    }
    let canceled = false;
    let cancel = () => {
      canceled = true;
    };
    const promise = wait(REGISTER_WAIT_MS).then(() => {
      if (!canceled) {
        const result = liveRegion.announceFromElement(element2, options);
        cancel = result.cancel;
        return result;
      }
    });
    return {
      ...promise,
      cancel: () => {
        cancel();
      }
    };
  }
  return liveRegion.announceFromElement(element2, options);
}
function findLiveRegion(from3) {
  let liveRegion = null;
  liveRegion = from3 ? getClosestLiveRegion(from3) : null;
  if (liveRegion !== null) {
    return liveRegion;
  }
  const container = getLiveRegionContainer(from3);
  liveRegion = container.querySelector("live-region");
  if (liveRegion !== null) {
    return liveRegion;
  }
  return null;
}
function getClosestLiveRegion(from3) {
  const dialog = from3.closest("dialog");
  let current = from3;
  while (current = current.parentElement) {
    if (dialog && !dialog.contains(current)) {
      break;
    }
    for (const child of current.childNodes) {
      if (child instanceof LiveRegionElement) {
        return child;
      }
    }
  }
  return null;
}
function getLiveRegionContainer(from3) {
  let container = document.body;
  if (from3) {
    const dialog = from3.closest("dialog");
    if (dialog) {
      container = dialog;
    }
  }
  return container;
}
const REGISTER_WAIT_MS = 150;
function wait(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
function useEffectOnce(callback) {
  const $2 = distExports.c(2);
  const savedCallback = useRef(callback);
  const called = useRef(false);
  let t0;
  let t1;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (called.current === true) {
        return;
      }
      called.current = true;
      savedCallback.current();
    };
    t1 = [];
    $2[0] = t0;
    $2[1] = t1;
  } else {
    t0 = $2[0];
    t1 = $2[1];
  }
  useEffect(t0, t1);
}
function useEffectCallback(callback) {
  const $2 = distExports.c(4);
  const savedCallback = useRef(callback);
  let t0;
  let t1;
  if ($2[0] !== callback) {
    t0 = () => {
      savedCallback.current = callback;
    };
    t1 = [callback];
    $2[0] = callback;
    $2[1] = t0;
    $2[2] = t1;
  } else {
    t0 = $2[1];
    t1 = $2[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($2[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (...t3) => {
      const args = t3;
      return savedCallback.current(...args);
    };
    $2[3] = t2;
  } else {
    t2 = $2[3];
  }
  return t2;
}
function Announce(t0) {
  const $2 = distExports.c(23);
  let children;
  let delayMs2;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($2[0] !== t0) {
    ({
      announceOnShow: t1,
      children,
      delayMs: delayMs2,
      hidden: t2,
      politeness: t3,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = delayMs2;
    $2[3] = rest;
    $2[4] = t1;
    $2[5] = t2;
    $2[6] = t3;
  } else {
    children = $2[1];
    delayMs2 = $2[2];
    rest = $2[3];
    t1 = $2[4];
    t2 = $2[5];
    t3 = $2[6];
  }
  const announceOnShow = t1 === void 0 ? true : t1;
  const hidden = t2 === void 0 ? false : t2;
  const politeness = t3 === void 0 ? "polite" : t3;
  const ref2 = useRef(null);
  const [previousAnnouncementText, setPreviousAnnouncementText] = useState(null);
  const savedAnnouncement = useRef(null);
  let t4;
  if ($2[7] !== delayMs2 || $2[8] !== hidden || $2[9] !== politeness || $2[10] !== previousAnnouncementText) {
    t4 = () => {
      var _savedAnnouncement$cu;
      const {
        current: element2
      } = ref2;
      if (!element2) {
        return;
      }
      if (hidden) {
        return;
      }
      const style3 = window.getComputedStyle(element2);
      if (style3.display === "none") {
        return;
      }
      if (style3.visibility === "hidden") {
        return;
      }
      const textContent = getTextContent(element2);
      if (textContent === previousAnnouncementText) {
        return;
      }
      (_savedAnnouncement$cu = savedAnnouncement.current) === null || _savedAnnouncement$cu === void 0 ? void 0 : _savedAnnouncement$cu.cancel();
      savedAnnouncement.current = announceFromElement(element2, politeness === "assertive" ? {
        politeness
      } : {
        politeness,
        delayMs: delayMs2
      });
      setPreviousAnnouncementText(textContent);
    };
    $2[7] = delayMs2;
    $2[8] = hidden;
    $2[9] = politeness;
    $2[10] = previousAnnouncementText;
    $2[11] = t4;
  } else {
    t4 = $2[11];
  }
  const announce2 = useEffectCallback(t4);
  let t5;
  if ($2[12] !== announce2 || $2[13] !== announceOnShow) {
    t5 = () => {
      if (announceOnShow) {
        announce2();
      }
    };
    $2[12] = announce2;
    $2[13] = announceOnShow;
    $2[14] = t5;
  } else {
    t5 = $2[14];
  }
  useEffectOnce(t5);
  let t6;
  let t7;
  if ($2[15] !== announce2) {
    t6 = () => {
      const {
        current: container
      } = ref2;
      if (container === null) {
        return;
      }
      const observer = new MutationObserver(() => {
        announce2();
      });
      observer.observe(container, {
        subtree: true,
        characterData: true,
        childList: true
      });
      return () => {
        observer.disconnect();
      };
    };
    t7 = [announce2];
    $2[15] = announce2;
    $2[16] = t6;
    $2[17] = t7;
  } else {
    t6 = $2[16];
    t7 = $2[17];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($2[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => () => {
      if (savedAnnouncement.current !== null) {
        savedAnnouncement.current.cancel();
        savedAnnouncement.current = null;
      }
    };
    t9 = [];
    $2[18] = t8;
    $2[19] = t9;
  } else {
    t8 = $2[18];
    t9 = $2[19];
  }
  useEffect(t8, t9);
  let t10;
  if ($2[20] !== children || $2[21] !== rest) {
    t10 = /* @__PURE__ */ jsxRuntimeExports.jsx(Box, {
      ...rest,
      ref: ref2,
      children
    });
    $2[20] = children;
    $2[21] = rest;
    $2[22] = t10;
  } else {
    t10 = $2[22];
  }
  return t10;
}
function getTextContent(element2) {
  let value = "";
  if (element2.hasAttribute("aria-label")) {
    value = element2.getAttribute("aria-label");
  } else if (element2.textContent) {
    value = element2.textContent;
  }
  return value ? value.trim() : "";
}
function AriaStatus(t0) {
  const $2 = distExports.c(8);
  let children;
  let rest;
  let t1;
  if ($2[0] !== t0) {
    ({
      announceOnShow: t1,
      children,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = rest;
    $2[3] = t1;
  } else {
    children = $2[1];
    rest = $2[2];
    t1 = $2[3];
  }
  const announceOnShow = t1 === void 0 ? false : t1;
  let t2;
  if ($2[4] !== announceOnShow || $2[5] !== children || $2[6] !== rest) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(Announce, {
      ...rest,
      announceOnShow,
      politeness: "polite",
      children
    });
    $2[4] = announceOnShow;
    $2[5] = children;
    $2[6] = rest;
    $2[7] = t2;
  } else {
    t2 = $2[7];
  }
  return t2;
}
var classes$M = { "CounterLabel": "prc-CounterLabel-CounterLabel-ZwXPe" };
const CounterLabel = /* @__PURE__ */ forwardRef$1((t0, forwardedRef) => {
  const $2 = distExports.c(20);
  let children;
  let className;
  let rest;
  let t1;
  if ($2[0] !== t0) {
    ({
      scheme: t1,
      className,
      children,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = className;
    $2[3] = rest;
    $2[4] = t1;
  } else {
    children = $2[1];
    className = $2[2];
    rest = $2[3];
    t1 = $2[4];
  }
  const scheme2 = t1 === void 0 ? "secondary" : t1;
  let t2;
  if ($2[5] !== children) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsxs(VisuallyHidden$1, {
      children: [" (", children, ")"]
    });
    $2[5] = children;
    $2[6] = t2;
  } else {
    t2 = $2[6];
  }
  const label = t2;
  let t3;
  if ($2[7] !== forwardedRef || $2[8] !== rest || $2[9] !== scheme2) {
    t3 = {
      ref: forwardedRef,
      "aria-hidden": "true",
      "data-scheme": scheme2,
      ...rest
    };
    $2[7] = forwardedRef;
    $2[8] = rest;
    $2[9] = scheme2;
    $2[10] = t3;
  } else {
    t3 = $2[10];
  }
  const counterProps = t3;
  let t4;
  if ($2[11] !== className) {
    t4 = clsx(className, classes$M.CounterLabel);
    $2[11] = className;
    $2[12] = t4;
  } else {
    t4 = $2[12];
  }
  let t5;
  if ($2[13] !== children || $2[14] !== counterProps || $2[15] !== t4) {
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: "span",
      ...counterProps,
      className: t4,
      children
    });
    $2[13] = children;
    $2[14] = counterProps;
    $2[15] = t4;
    $2[16] = t5;
  } else {
    t5 = $2[16];
  }
  let t6;
  if ($2[17] !== label || $2[18] !== t5) {
    t6 = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
      children: [t5, label]
    });
    $2[17] = label;
    $2[18] = t5;
    $2[19] = t6;
  } else {
    t6 = $2[19];
  }
  return t6;
});
CounterLabel.displayName = "CounterLabel";
const renderModuleVisual = (Visual2, loading, visualName, counterLabel) => /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
  "data-component": visualName,
  className: clsx(!counterLabel && classes$P.Visual, loading ? classes$P.LoadingSpinner : classes$P.VisualWrap),
  children: loading ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {
    size: "small"
  }) : reactIsExports.isElement(Visual2) ? Visual2 : /* @__PURE__ */ jsxRuntimeExports.jsx(Visual2, {})
});
renderModuleVisual.displayName = "renderModuleVisual";
const ButtonBase = /* @__PURE__ */ forwardRef$1(({
  children,
  as: Component2 = "button",
  sx: sxProp = defaultSxProp,
  ...props
}, forwardedRef) => {
  const {
    leadingVisual: LeadingVisual2,
    trailingVisual: TrailingVisual2,
    trailingAction: TrailingAction2,
    ["aria-describedby"]: ariaDescribedBy,
    ["aria-labelledby"]: ariaLabelledBy,
    count: count2,
    icon: Icon2,
    id,
    variant: variant3 = "default",
    size: size2 = "medium",
    alignContent: alignContent2 = "center",
    block: block2 = false,
    loading,
    loadingAnnouncement = "Loading",
    inactive,
    onClick,
    labelWrap,
    className,
    ...rest
  } = props;
  const innerRef = React__default.useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  const uuid2 = useId(id);
  const loadingAnnouncementID = `${uuid2}-loading-announcement`;
  if (process.env.NODE_ENV !== "production") {
    React__default.useEffect(() => {
      if (innerRef.current && !(innerRef.current instanceof HTMLButtonElement) && !(innerRef.current instanceof HTMLAnchorElement) && !(innerRef.current.tagName === "SUMMARY")) {
        console.warn("This component should be an instanceof a semantic button or anchor");
      }
    }, [innerRef]);
  }
  if (sxProp !== defaultSxProp) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ConditionalWrapper,
      {
        if: typeof loading !== "undefined",
        className: block2 ? classes$P.ConditionalWrapper : void 0,
        "data-loading-wrapper": true,
        children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Box, {
          as: Component2,
          sx: sxProp,
          "aria-disabled": loading ? true : void 0,
          ...rest,
          ref: innerRef,
          className: clsx(classes$P.ButtonBase, className),
          "data-block": block2 ? "block" : null,
          "data-inactive": inactive ? true : void 0,
          "data-loading": Boolean(loading),
          "data-no-visuals": !LeadingVisual2 && !TrailingVisual2 && !TrailingAction2 ? true : void 0,
          "data-size": size2,
          "data-variant": variant3,
          "data-label-wrap": labelWrap,
          "data-has-count": count2 !== void 0 ? true : void 0,
          "aria-describedby": [loadingAnnouncementID, ariaDescribedBy].filter((descriptionID) => Boolean(descriptionID)).join(" "),
          "aria-labelledby": loading ? [`${uuid2}-label`, ariaLabelledBy].filter((labelID) => Boolean(labelID)).join(" ") : ariaLabelledBy,
          id,
          onClick: loading ? void 0 : onClick,
          children: Icon2 ? loading ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {
            size: "small"
          }) : reactIsExports.isElement(Icon2) ? Icon2 : /* @__PURE__ */ jsxRuntimeExports.jsx(Icon2, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, {
                as: "span",
                "data-component": "buttonContent",
                sx: getAlignContentSize(alignContent2),
                className: classes$P.ButtonContent,
                children: [
                  /* If there are no leading/trailing visuals/actions to replace with a loading spinner,
                   render a loading spiner in place of the button content. */
                  loading && !LeadingVisual2 && !TrailingVisual2 && !TrailingAction2 && count2 === void 0 && renderModuleVisual(StyledSpinner, loading, "loadingSpinner", false),
                  /* Render a leading visual unless the button is in a loading state.
                    Then replace the leading visual with a loading spinner. */
                  LeadingVisual2 && renderModuleVisual(LeadingVisual2, Boolean(loading), "leadingVisual", false),
                  children && /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
                    "data-component": "text",
                    className: classes$P.Label,
                    id: loading ? `${uuid2}-label` : void 0,
                    children
                  }),
                  /* If there is a count, render a counter label unless there is a trailing visual.
                   Then render the counter label as a trailing visual.
                   Replace the counter label or the trailing visual with a loading spinner if:
                   - the button is in a loading state
                   - there is no leading visual to replace with a loading spinner
                  */
                  count2 !== void 0 && !TrailingVisual2 ? renderModuleVisual(() => /* @__PURE__ */ jsxRuntimeExports.jsx(CounterLabel, {
                    className: classes$P.CounterLabel,
                    "data-component": "ButtonCounter",
                    children: count2
                  }), Boolean(loading) && !LeadingVisual2, "trailingVisual", true) : TrailingVisual2 ? renderModuleVisual(TrailingVisual2, Boolean(loading) && !LeadingVisual2, "trailingVisual", false) : null
                ]
              }),
              /* If there is a trailing action, render it unless the button is in a loading state
               and there is no leading or trailing visual to replace with a loading spinner. */
              TrailingAction2 && renderModuleVisual(TrailingAction2, Boolean(loading) && !LeadingVisual2 && !TrailingVisual2, "trailingAction", false)
            ]
          })
        }), loading && /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, {
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(AriaStatus, {
            id: loadingAnnouncementID,
            children: loadingAnnouncement
          })
        })]
      }
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    ConditionalWrapper,
    {
      if: typeof loading !== "undefined",
      className: block2 ? classes$P.ConditionalWrapper : void 0,
      "data-loading-wrapper": true,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Component2, {
        "aria-disabled": loading ? true : void 0,
        ...rest,
        // @ts-ignore temporary disable as we migrate to css modules, until we remove PolymorphicForwardRefComponent
        ref: innerRef,
        className: clsx(classes$P.ButtonBase, className),
        "data-block": block2 ? "block" : null,
        "data-inactive": inactive ? true : void 0,
        "data-loading": Boolean(loading),
        "data-no-visuals": !LeadingVisual2 && !TrailingVisual2 && !TrailingAction2 ? true : void 0,
        "data-size": size2,
        "data-variant": variant3,
        "data-label-wrap": labelWrap,
        "data-has-count": count2 !== void 0 ? true : void 0,
        "aria-describedby": [loadingAnnouncementID, ariaDescribedBy].filter((descriptionID) => Boolean(descriptionID)).join(" "),
        "aria-labelledby": loading ? [`${uuid2}-label`, ariaLabelledBy].filter((labelID) => Boolean(labelID)).join(" ") : ariaLabelledBy,
        id,
        onClick: loading ? void 0 : onClick,
        children: Icon2 ? loading ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {
          size: "small"
        }) : reactIsExports.isElement(Icon2) ? Icon2 : /* @__PURE__ */ jsxRuntimeExports.jsx(Icon2, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", {
              "data-component": "buttonContent",
              "data-align": alignContent2,
              className: classes$P.ButtonContent,
              children: [
                /* If there are no leading/trailing visuals/actions to replace with a loading spinner,
                   render a loading spiner in place of the button content. */
                loading && !LeadingVisual2 && !TrailingVisual2 && !TrailingAction2 && count2 === void 0 && renderModuleVisual(StyledSpinner, loading, "loadingSpinner", false),
                /* Render a leading visual unless the button is in a loading state.
                   Then replace the leading visual with a loading spinner. */
                LeadingVisual2 && renderModuleVisual(LeadingVisual2, Boolean(loading), "leadingVisual", false),
                children && /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
                  "data-component": "text",
                  className: classes$P.Label,
                  id: loading ? `${uuid2}-label` : void 0,
                  children
                }),
                /* If there is a count, render a counter label unless there is a trailing visual.
                   Then render the counter label as a trailing visual.
                   Replace the counter label or the trailing visual with a loading spinner if:
                   - the button is in a loading state
                   - there is no leading visual to replace with a loading spinner
                */
                count2 !== void 0 && !TrailingVisual2 ? renderModuleVisual(() => /* @__PURE__ */ jsxRuntimeExports.jsx(CounterLabel, {
                  className: classes$P.CounterLabel,
                  "data-component": "ButtonCounter",
                  children: count2
                }), Boolean(loading) && !LeadingVisual2, "trailingVisual", true) : TrailingVisual2 ? renderModuleVisual(TrailingVisual2, Boolean(loading) && !LeadingVisual2, "trailingVisual", false) : null
              ]
            }),
            /* If there is a trailing action, render it unless the button is in a loading state
               and there is no leading or trailing visual to replace with a loading spinner. */
            TrailingAction2 && renderModuleVisual(TrailingAction2, Boolean(loading) && !LeadingVisual2 && !TrailingVisual2, "trailingAction", false)
          ]
        })
      }), loading && /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(AriaStatus, {
          id: loadingAnnouncementID,
          children: loadingAnnouncement
        })
      })]
    }
  );
});
const ButtonComponent = /* @__PURE__ */ forwardRef$1(({
  children,
  sx: sxProp = defaultSxProp,
  ...props
}, forwardedRef) => {
  const {
    block: block2,
    size: size2 = "medium",
    leadingVisual,
    trailingVisual,
    trailingAction
  } = props;
  let sxStyles = sxProp;
  const style3 = {};
  if (sxProp !== null && Object.keys(sxProp).length > 0) {
    sxStyles = generateCustomSxProp({
      block: block2,
      size: size2,
      leadingVisual,
      trailingVisual,
      trailingAction
    }, sxProp);
    const {
      color: color2
    } = sxProp;
    if (color2) style3["--button-color"] = color2;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonBase, {
    ref: forwardedRef,
    as: "button",
    sx: sxStyles,
    style: style3,
    type: "button",
    ...props,
    children
  });
});
function generateCustomSxProp(props, providedSx) {
  const size2 = `[data-size="${props.size}"]`;
  const block2 = props.block ? `[data-block="block"]` : "";
  const noVisuals = props.leadingVisual || props.trailingVisual || props.trailingAction ? "" : "[data-no-visuals]";
  const cssSelector = `&${size2}${block2}${noVisuals}`;
  const customSxProp = {};
  if (!providedSx) return customSxProp;
  else {
    customSxProp[cssSelector] = providedSx;
    return customSxProp;
  }
}
ButtonComponent.displayName = "Button";
function emptyFunction$1() {
}
const invariant = process.env.NODE_ENV !== "production" ? (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function invariant2(condition, format2, ...args) {
    if (!condition) {
      let error2;
      if (format2 === void 0) {
        error2 = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      } else {
        let index2 = 0;
        const message2 = format2.replace(/%s/g, () => {
          return args[index2++];
        });
        error2 = new Error(message2);
        error2.name = "Invariant Violation";
      }
      throw error2;
    }
  }
) : emptyFunction$1;
function emptyFunction() {
}
const warn$2 = process.env.NODE_ENV !== "production" ? function warn(message2) {
  console.warn("Warning:", message2);
} : emptyFunction;
const warning2 = process.env.NODE_ENV !== "production" ? (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function warning3(condition, format2, ...args) {
    if (condition) {
      let index2 = 0;
      const message2 = format2.replace(/%s/g, () => {
        return args[index2++];
      });
      warn$2(message2);
    }
  }
) : emptyFunction;
var ToggleEvent = class extends Event {
  constructor(type, { oldState = "", newState = "", ...init2 } = {}) {
    super(type, init2);
    __publicField(this, "oldState");
    __publicField(this, "newState");
    this.oldState = String(oldState || "");
    this.newState = String(newState || "");
  }
};
var popoverToggleTaskQueue = /* @__PURE__ */ new WeakMap();
function queuePopoverToggleEventTask(element2, oldState, newState) {
  popoverToggleTaskQueue.set(
    element2,
    setTimeout(() => {
      if (!popoverToggleTaskQueue.has(element2)) return;
      element2.dispatchEvent(
        new ToggleEvent("toggle", {
          cancelable: false,
          oldState,
          newState
        })
      );
    }, 0)
  );
}
var ShadowRoot$1 = globalThis.ShadowRoot || function() {
};
var HTMLDialogElement = globalThis.HTMLDialogElement || function() {
};
var topLayerElements = /* @__PURE__ */ new WeakMap();
var autoPopoverList = /* @__PURE__ */ new WeakMap();
var visibilityState = /* @__PURE__ */ new WeakMap();
function getPopoverVisibilityState(popover) {
  return visibilityState.get(popover) || "hidden";
}
var popoverInvoker = /* @__PURE__ */ new WeakMap();
function popoverTargetAttributeActivationBehavior(element2) {
  const popover = element2.popoverTargetElement;
  if (!(popover instanceof HTMLElement)) {
    return;
  }
  const visibility = getPopoverVisibilityState(popover);
  if (element2.popoverTargetAction === "show" && visibility === "showing") {
    return;
  }
  if (element2.popoverTargetAction === "hide" && visibility === "hidden") return;
  if (visibility === "showing") {
    hidePopover(popover, true, true);
  } else if (checkPopoverValidity(popover, false)) {
    popoverInvoker.set(popover, element2);
    showPopover(popover);
  }
}
function checkPopoverValidity(element2, expectedToBeShowing) {
  if (element2.popover !== "auto" && element2.popover !== "manual") {
    return false;
  }
  if (!element2.isConnected) return false;
  if (expectedToBeShowing && getPopoverVisibilityState(element2) !== "showing") {
    return false;
  }
  if (!expectedToBeShowing && getPopoverVisibilityState(element2) !== "hidden") {
    return false;
  }
  if (element2 instanceof HTMLDialogElement && element2.hasAttribute("open")) {
    return false;
  }
  if (document.fullscreenElement === element2) return false;
  return true;
}
function getStackPosition(popover) {
  if (!popover) return 0;
  return Array.from(autoPopoverList.get(popover.ownerDocument) || []).indexOf(
    popover
  ) + 1;
}
function topMostClickedPopover(target) {
  const clickedPopover = nearestInclusiveOpenPopover(target);
  const invokerPopover = nearestInclusiveTargetPopoverForInvoker(target);
  if (getStackPosition(clickedPopover) > getStackPosition(invokerPopover)) {
    return clickedPopover;
  }
  return invokerPopover;
}
function topMostAutoPopover(document2) {
  const documentPopovers = autoPopoverList.get(document2);
  for (const popover of documentPopovers || []) {
    if (!popover.isConnected) {
      documentPopovers.delete(popover);
    } else {
      return popover;
    }
  }
  return null;
}
function getRootNode(node2) {
  if (typeof node2.getRootNode === "function") {
    return node2.getRootNode();
  }
  if (node2.parentNode) return getRootNode(node2.parentNode);
  return node2;
}
function nearestInclusiveOpenPopover(node2) {
  while (node2) {
    if (node2 instanceof HTMLElement && node2.popover === "auto" && visibilityState.get(node2) === "showing") {
      return node2;
    }
    node2 = node2 instanceof Element && node2.assignedSlot || node2.parentElement || getRootNode(node2);
    if (node2 instanceof ShadowRoot$1) node2 = node2.host;
    if (node2 instanceof Document) return;
  }
}
function nearestInclusiveTargetPopoverForInvoker(node2) {
  while (node2) {
    const nodePopover = node2.popoverTargetElement;
    if (nodePopover instanceof HTMLElement) return nodePopover;
    node2 = node2.parentElement || getRootNode(node2);
    if (node2 instanceof ShadowRoot$1) node2 = node2.host;
    if (node2 instanceof Document) return;
  }
}
function topMostPopoverAncestor(newPopover) {
  const popoverPositions = /* @__PURE__ */ new Map();
  let i = 0;
  for (const popover of autoPopoverList.get(newPopover.ownerDocument) || []) {
    popoverPositions.set(popover, i);
    i += 1;
  }
  popoverPositions.set(newPopover, i);
  i += 1;
  let topMostPopoverAncestor2 = null;
  function checkAncestor(candidate) {
    const candidateAncestor = nearestInclusiveOpenPopover(candidate);
    if (candidateAncestor === null) return null;
    const candidatePosition = popoverPositions.get(candidateAncestor);
    if (topMostPopoverAncestor2 === null || popoverPositions.get(topMostPopoverAncestor2) < candidatePosition) {
      topMostPopoverAncestor2 = candidateAncestor;
    }
  }
  checkAncestor(newPopover.parentElement || getRootNode(newPopover));
  return topMostPopoverAncestor2;
}
function isFocusable(focusTarget) {
  if (focusTarget.hidden || focusTarget instanceof ShadowRoot$1) return false;
  if (focusTarget instanceof HTMLButtonElement || focusTarget instanceof HTMLInputElement || focusTarget instanceof HTMLSelectElement || focusTarget instanceof HTMLTextAreaElement || focusTarget instanceof HTMLOptGroupElement || focusTarget instanceof HTMLOptionElement || focusTarget instanceof HTMLFieldSetElement) {
    if (focusTarget.disabled) return false;
  }
  if (focusTarget instanceof HTMLInputElement && focusTarget.type === "hidden") {
    return false;
  }
  if (focusTarget instanceof HTMLAnchorElement && focusTarget.href === "") {
    return false;
  }
  return typeof focusTarget.tabIndex === "number" && focusTarget.tabIndex !== -1;
}
function focusDelegate(focusTarget) {
  if (focusTarget.shadowRoot && focusTarget.shadowRoot.delegatesFocus !== true) {
    return null;
  }
  let whereToLook = focusTarget;
  if (whereToLook.shadowRoot) {
    whereToLook = whereToLook.shadowRoot;
  }
  let autoFocusDelegate = whereToLook.querySelector("[autofocus]");
  if (autoFocusDelegate) {
    return autoFocusDelegate;
  } else {
    const slots = whereToLook.querySelectorAll("slot");
    for (const slot of slots) {
      const assignedElements = slot.assignedElements({ flatten: true });
      for (const el of assignedElements) {
        if (el.hasAttribute("autofocus")) {
          return el;
        } else {
          autoFocusDelegate = el.querySelector("[autofocus]");
          if (autoFocusDelegate) {
            return autoFocusDelegate;
          }
        }
      }
    }
  }
  const walker = focusTarget.ownerDocument.createTreeWalker(
    whereToLook,
    NodeFilter.SHOW_ELEMENT
  );
  let descendant = walker.currentNode;
  while (descendant) {
    if (isFocusable(descendant)) {
      return descendant;
    }
    descendant = walker.nextNode();
  }
}
function popoverFocusingSteps(subject) {
  var _a3;
  (_a3 = focusDelegate(subject)) == null ? void 0 : _a3.focus();
}
var previouslyFocusedElements = /* @__PURE__ */ new WeakMap();
function showPopover(element2) {
  if (!checkPopoverValidity(element2, false)) {
    return;
  }
  const document2 = element2.ownerDocument;
  if (!element2.dispatchEvent(
    new ToggleEvent("beforetoggle", {
      cancelable: true,
      oldState: "closed",
      newState: "open"
    })
  )) {
    return;
  }
  if (!checkPopoverValidity(element2, false)) {
    return;
  }
  let shouldRestoreFocus = false;
  if (element2.popover === "auto") {
    const originalType = element2.getAttribute("popover");
    const ancestor = topMostPopoverAncestor(element2) || document2;
    hideAllPopoversUntil(ancestor, false, true);
    if (originalType !== element2.getAttribute("popover") || !checkPopoverValidity(element2, false)) {
      return;
    }
  }
  if (!topMostAutoPopover(document2)) {
    shouldRestoreFocus = true;
  }
  previouslyFocusedElements.delete(element2);
  const originallyFocusedElement = document2.activeElement;
  element2.classList.add(":popover-open");
  visibilityState.set(element2, "showing");
  if (!topLayerElements.has(document2)) {
    topLayerElements.set(document2, /* @__PURE__ */ new Set());
  }
  topLayerElements.get(document2).add(element2);
  popoverFocusingSteps(element2);
  if (element2.popover === "auto") {
    if (!autoPopoverList.has(document2)) {
      autoPopoverList.set(document2, /* @__PURE__ */ new Set());
    }
    autoPopoverList.get(document2).add(element2);
    setInvokerAriaExpanded(popoverInvoker.get(element2), true);
  }
  if (shouldRestoreFocus && originallyFocusedElement && element2.popover === "auto") {
    previouslyFocusedElements.set(element2, originallyFocusedElement);
  }
  queuePopoverToggleEventTask(element2, "closed", "open");
}
function hidePopover(element2, focusPreviousElement = false, fireEvents = false) {
  var _a3, _b;
  if (!checkPopoverValidity(element2, true)) {
    return;
  }
  const document2 = element2.ownerDocument;
  if (element2.popover === "auto") {
    hideAllPopoversUntil(element2, focusPreviousElement, fireEvents);
    if (!checkPopoverValidity(element2, true)) {
      return;
    }
  }
  setInvokerAriaExpanded(popoverInvoker.get(element2), false);
  popoverInvoker.delete(element2);
  if (fireEvents) {
    element2.dispatchEvent(
      new ToggleEvent("beforetoggle", {
        oldState: "open",
        newState: "closed"
      })
    );
    if (!checkPopoverValidity(element2, true)) {
      return;
    }
  }
  (_a3 = topLayerElements.get(document2)) == null ? void 0 : _a3.delete(element2);
  (_b = autoPopoverList.get(document2)) == null ? void 0 : _b.delete(element2);
  element2.classList.remove(":popover-open");
  visibilityState.set(element2, "hidden");
  if (fireEvents) {
    queuePopoverToggleEventTask(element2, "open", "closed");
  }
  const previouslyFocusedElement = previouslyFocusedElements.get(element2);
  if (previouslyFocusedElement) {
    previouslyFocusedElements.delete(element2);
    if (focusPreviousElement) {
      previouslyFocusedElement.focus();
    }
  }
}
function closeAllOpenPopovers(document2, focusPreviousElement = false, fireEvents = false) {
  let popover = topMostAutoPopover(document2);
  while (popover) {
    hidePopover(popover, focusPreviousElement, fireEvents);
    popover = topMostAutoPopover(document2);
  }
}
function hideAllPopoversUntil(endpoint, focusPreviousElement, fireEvents) {
  var _a3;
  const document2 = endpoint.ownerDocument || endpoint;
  if (endpoint instanceof Document) {
    return closeAllOpenPopovers(document2, focusPreviousElement, fireEvents);
  }
  let lastToHide = null;
  let foundEndpoint = false;
  for (const popover of autoPopoverList.get(document2) || []) {
    if (popover === endpoint) {
      foundEndpoint = true;
    } else if (foundEndpoint) {
      lastToHide = popover;
      break;
    }
  }
  if (!foundEndpoint) {
    return closeAllOpenPopovers(document2, focusPreviousElement, fireEvents);
  }
  while (lastToHide && getPopoverVisibilityState(lastToHide) === "showing" && ((_a3 = autoPopoverList.get(document2)) == null ? void 0 : _a3.size)) {
    hidePopover(lastToHide, focusPreviousElement, fireEvents);
  }
}
var popoverPointerDownTargets = /* @__PURE__ */ new WeakMap();
function lightDismissOpenPopovers(event) {
  if (!event.isTrusted) return;
  const target = event.composedPath()[0];
  if (!target) return;
  const document2 = target.ownerDocument;
  const topMostPopover = topMostAutoPopover(document2);
  if (!topMostPopover) return;
  const ancestor = topMostClickedPopover(target);
  if (ancestor && event.type === "pointerdown") {
    popoverPointerDownTargets.set(document2, ancestor);
  } else if (event.type === "pointerup") {
    const sameTarget = popoverPointerDownTargets.get(document2) === ancestor;
    popoverPointerDownTargets.delete(document2);
    if (sameTarget) {
      hideAllPopoversUntil(ancestor || document2, false, true);
    }
  }
}
var initialAriaExpandedValue = /* @__PURE__ */ new WeakMap();
function setInvokerAriaExpanded(el, force = false) {
  if (!el) return;
  if (!initialAriaExpandedValue.has(el)) {
    initialAriaExpandedValue.set(el, el.getAttribute("aria-expanded"));
  }
  const popover = el.popoverTargetElement;
  if (popover instanceof HTMLElement && popover.popover === "auto") {
    el.setAttribute("aria-expanded", String(force));
  } else {
    const initialValue = initialAriaExpandedValue.get(el);
    if (!initialValue) {
      el.removeAttribute("aria-expanded");
    } else {
      el.setAttribute("aria-expanded", initialValue);
    }
  }
}
var ShadowRoot2 = globalThis.ShadowRoot || function() {
};
function isSupported() {
  return typeof HTMLElement !== "undefined" && typeof HTMLElement.prototype === "object" && "popover" in HTMLElement.prototype;
}
function patchSelectorFn(object, name2, mapper) {
  const original = object[name2];
  Object.defineProperty(object, name2, {
    value(selector2) {
      return original.call(this, mapper(selector2));
    }
  });
}
var nonEscapedPopoverSelector = /(^|[^\\]):popover-open\b/g;
function hasLayerSupport() {
  return typeof globalThis.CSSLayerBlockRule === "function";
}
function getStyles3() {
  const useLayer = hasLayerSupport();
  return `
${useLayer ? "@layer popover-polyfill {" : ""}
  :where([popover]) {
    position: fixed;
    z-index: 2147483647;
    inset: 0;
    padding: 0.25em;
    width: fit-content;
    height: fit-content;
    border-width: initial;
    border-color: initial;
    border-image: initial;
    border-style: solid;
    background-color: canvas;
    color: canvastext;
    overflow: auto;
    margin: auto;
  }

  :where([popover]:not(.\\:popover-open)) {
    display: none;
  }

  :where(dialog[popover].\\:popover-open) {
    display: block;
  }

  :where(dialog[popover][open]) {
    display: revert;
  }

  :where([anchor].\\:popover-open) {
    inset: auto;
  }

  :where([anchor]:popover-open) {
    inset: auto;
  }

  @supports not (background-color: canvas) {
    :where([popover]) {
      background-color: white;
      color: black;
    }
  }

  @supports (width: -moz-fit-content) {
    :where([popover]) {
      width: -moz-fit-content;
      height: -moz-fit-content;
    }
  }

  @supports not (inset: 0) {
    :where([popover]) {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
${useLayer ? "}" : ""}
`;
}
var popoverStyleSheet = null;
function injectStyles(root2) {
  const styles2 = getStyles3();
  if (popoverStyleSheet === null) {
    try {
      popoverStyleSheet = new CSSStyleSheet();
      popoverStyleSheet.replaceSync(styles2);
    } catch {
      popoverStyleSheet = false;
    }
  }
  if (popoverStyleSheet === false) {
    const sheet = document.createElement("style");
    sheet.textContent = styles2;
    if (root2 instanceof Document) {
      root2.head.prepend(sheet);
    } else {
      root2.prepend(sheet);
    }
  } else {
    root2.adoptedStyleSheets = [popoverStyleSheet, ...root2.adoptedStyleSheets];
  }
}
function apply$1() {
  if (typeof window === "undefined") return;
  window.ToggleEvent = window.ToggleEvent || ToggleEvent;
  function rewriteSelector(selector2) {
    if (selector2 == null ? void 0 : selector2.includes(":popover-open")) {
      selector2 = selector2.replace(
        nonEscapedPopoverSelector,
        "$1.\\:popover-open"
      );
    }
    return selector2;
  }
  patchSelectorFn(Document.prototype, "querySelector", rewriteSelector);
  patchSelectorFn(Document.prototype, "querySelectorAll", rewriteSelector);
  patchSelectorFn(Element.prototype, "querySelector", rewriteSelector);
  patchSelectorFn(Element.prototype, "querySelectorAll", rewriteSelector);
  patchSelectorFn(Element.prototype, "matches", rewriteSelector);
  patchSelectorFn(Element.prototype, "closest", rewriteSelector);
  patchSelectorFn(
    DocumentFragment.prototype,
    "querySelectorAll",
    rewriteSelector
  );
  Object.defineProperties(HTMLElement.prototype, {
    popover: {
      enumerable: true,
      configurable: true,
      get() {
        if (!this.hasAttribute("popover")) return null;
        const value = (this.getAttribute("popover") || "").toLowerCase();
        if (value === "" || value == "auto") return "auto";
        return "manual";
      },
      set(value) {
        if (value === null) {
          this.removeAttribute("popover");
        } else {
          this.setAttribute("popover", value);
        }
      }
    },
    showPopover: {
      enumerable: true,
      configurable: true,
      value() {
        showPopover(this);
      }
    },
    hidePopover: {
      enumerable: true,
      configurable: true,
      value() {
        hidePopover(this, true, true);
      }
    },
    togglePopover: {
      enumerable: true,
      configurable: true,
      value(force) {
        if (visibilityState.get(this) === "showing" && force === void 0 || force === false) {
          hidePopover(this, true, true);
        } else if (force === void 0 || force === true) {
          showPopover(this);
        }
      }
    }
  });
  const originalAttachShadow = Element.prototype.attachShadow;
  if (originalAttachShadow) {
    Object.defineProperties(Element.prototype, {
      attachShadow: {
        enumerable: true,
        configurable: true,
        writable: true,
        value(options) {
          const shadowRoot = originalAttachShadow.call(this, options);
          injectStyles(shadowRoot);
          return shadowRoot;
        }
      }
    });
  }
  const originalAttachInternals = HTMLElement.prototype.attachInternals;
  if (originalAttachInternals) {
    Object.defineProperties(HTMLElement.prototype, {
      attachInternals: {
        enumerable: true,
        configurable: true,
        writable: true,
        value() {
          const internals = originalAttachInternals.call(this);
          if (internals.shadowRoot) {
            injectStyles(internals.shadowRoot);
          }
          return internals;
        }
      }
    });
  }
  const popoverTargetAssociatedElements = /* @__PURE__ */ new WeakMap();
  function applyPopoverInvokerElementMixin(ElementClass) {
    Object.defineProperties(ElementClass.prototype, {
      popoverTargetElement: {
        enumerable: true,
        configurable: true,
        set(targetElement) {
          if (targetElement === null) {
            this.removeAttribute("popovertarget");
            popoverTargetAssociatedElements.delete(this);
          } else if (!(targetElement instanceof Element)) {
            throw new TypeError(
              `popoverTargetElement must be an element or null`
            );
          } else {
            this.setAttribute("popovertarget", "");
            popoverTargetAssociatedElements.set(this, targetElement);
          }
        },
        get() {
          if (this.localName !== "button" && this.localName !== "input") {
            return null;
          }
          if (this.localName === "input" && this.type !== "reset" && this.type !== "image" && this.type !== "button") {
            return null;
          }
          if (this.disabled) {
            return null;
          }
          if (this.form && this.type === "submit") {
            return null;
          }
          const targetElement = popoverTargetAssociatedElements.get(this);
          if (targetElement && targetElement.isConnected) {
            return targetElement;
          } else if (targetElement && !targetElement.isConnected) {
            popoverTargetAssociatedElements.delete(this);
            return null;
          }
          const root2 = getRootNode(this);
          const idref = this.getAttribute("popovertarget");
          if ((root2 instanceof Document || root2 instanceof ShadowRoot2) && idref) {
            return root2.getElementById(idref) || null;
          }
          return null;
        }
      },
      popoverTargetAction: {
        enumerable: true,
        configurable: true,
        get() {
          const value = (this.getAttribute("popovertargetaction") || "").toLowerCase();
          if (value === "show" || value === "hide") return value;
          return "toggle";
        },
        set(value) {
          this.setAttribute("popovertargetaction", value);
        }
      }
    });
  }
  applyPopoverInvokerElementMixin(HTMLButtonElement);
  applyPopoverInvokerElementMixin(HTMLInputElement);
  const handleInvokerActivation = (event) => {
    const composedPath = event.composedPath();
    const target = composedPath[0];
    if (!(target instanceof Element) || (target == null ? void 0 : target.shadowRoot)) {
      return;
    }
    const root2 = getRootNode(target);
    if (!(root2 instanceof ShadowRoot2 || root2 instanceof Document)) {
      return;
    }
    const invoker = composedPath.find(
      (el) => {
        var _a3;
        return (_a3 = el.matches) == null ? void 0 : _a3.call(el, "[popovertargetaction],[popovertarget]");
      }
    );
    if (invoker) {
      popoverTargetAttributeActivationBehavior(invoker);
      event.preventDefault();
      return;
    }
  };
  const onKeydown = (event) => {
    const key2 = event.key;
    const target = event.target;
    if (!event.defaultPrevented && target && (key2 === "Escape" || key2 === "Esc")) {
      hideAllPopoversUntil(target.ownerDocument, true, true);
    }
  };
  const addEventListeners = (root2) => {
    root2.addEventListener("click", handleInvokerActivation);
    root2.addEventListener("keydown", onKeydown);
    root2.addEventListener("pointerdown", lightDismissOpenPopovers);
    root2.addEventListener("pointerup", lightDismissOpenPopovers);
  };
  addEventListeners(document);
  injectStyles(document);
}
var classes$L = { "Tooltip": "prc-TooltipV2-Tooltip-cYMVY", "KeybindingHintContainer": "prc-TooltipV2-KeybindingHintContainer-iabqv", "HasTextBefore": "prc-TooltipV2-HasTextBefore-cCzYC" };
var classes$K = { "InternalVisuallyHidden": "prc-src-InternalVisuallyHidden-nlR9R" };
function VisuallyHidden(t0) {
  const $2 = distExports.c(14);
  let children;
  let className;
  let isVisible4;
  let rest;
  let t1;
  if ($2[0] !== t0) {
    ({
      isVisible: isVisible4,
      children,
      as: t1,
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = className;
    $2[3] = isVisible4;
    $2[4] = rest;
    $2[5] = t1;
  } else {
    children = $2[1];
    className = $2[2];
    isVisible4 = $2[3];
    rest = $2[4];
    t1 = $2[5];
  }
  const as2 = t1 === void 0 ? "span" : t1;
  const t2 = !isVisible4;
  let t3;
  if ($2[6] !== className || $2[7] !== t2) {
    t3 = clsx(className, {
      [classes$K.InternalVisuallyHidden]: t2
    });
    $2[6] = className;
    $2[7] = t2;
    $2[8] = t3;
  } else {
    t3 = $2[8];
  }
  let t4;
  if ($2[9] !== as2 || $2[10] !== children || $2[11] !== rest || $2[12] !== t3) {
    t4 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: as2,
      className: t3,
      ...rest,
      children
    });
    $2[9] = as2;
    $2[10] = children;
    $2[11] = rest;
    $2[12] = t3;
    $2[13] = t4;
  } else {
    t4 = $2[13];
  }
  return t4;
}
const canUseDOM$1 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function useIsMacOS() {
  const $2 = distExports.c(2);
  const [isMacOS$1$1, setIsMacOS] = useState(_temp$8);
  let t0;
  let t1;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setIsMacOS(isMacOS$1());
    t1 = [];
    $2[0] = t0;
    $2[1] = t1;
  } else {
    t0 = $2[0];
    t1 = $2[1];
  }
  useEffect(t0, t1);
  return isMacOS$1$1;
}
function _temp$8() {
  return canUseDOM$1 ? isMacOS$1() : false;
}
const capitalize = ([first2, ...rest]) => {
  var _first$toUpperCase;
  return ((_first$toUpperCase = first2 === null || first2 === void 0 ? void 0 : first2.toUpperCase()) !== null && _first$toUpperCase !== void 0 ? _first$toUpperCase : "") + rest.join("").toLowerCase();
};
const condensedKeyName = (key2, isMacOS2) => {
  var _alt$control$shift$me;
  return (_alt$control$shift$me = {
    alt: isMacOS2 ? "⌥" : "Alt",
    // the alt key _is_ the option key on MacOS - in the browser there is no "option" key
    control: "⌃",
    shift: "⇧",
    meta: isMacOS2 ? "⌘" : "Win",
    mod: isMacOS2 ? "⌘" : "⌃",
    pageup: "PgUp",
    pagedown: "PgDn",
    arrowup: "↑",
    arrowdown: "↓",
    arrowleft: "←",
    arrowright: "→",
    plus: "+",
    // needed to allow +-separated chords
    backspace: "⌫",
    delete: "Del",
    space: "␣",
    // needed to allow space-separated sequences
    tab: "⇥",
    enter: "⏎",
    escape: "Esc",
    function: "Fn",
    capslock: "CapsLock",
    insert: "Ins",
    printscreen: "PrtScn"
  }[key2]) !== null && _alt$control$shift$me !== void 0 ? _alt$control$shift$me : capitalize(key2);
};
const fullKeyName = (key2, isMacOS2) => {
  var _alt$mod$$pageup$pag;
  return (_alt$mod$$pageup$pag = {
    alt: isMacOS2 ? "Option" : "Alt",
    mod: isMacOS2 ? "Command" : "Control",
    "+": "Plus",
    pageup: "Page Up",
    pagedown: "Page Down",
    arrowup: "Up Arrow",
    arrowdown: "Down Arrow",
    arrowleft: "Left Arrow",
    arrowright: "Right Arrow",
    capslock: "Caps Lock",
    printscreen: "Print Screen"
  }[key2]) !== null && _alt$mod$$pageup$pag !== void 0 ? _alt$mod$$pageup$pag : capitalize(key2);
};
const accessibleKeyName = (key2, isMacOS2) => {
  var _alt$meta$mod$pageup$;
  return (_alt$meta$mod$pageup$ = {
    alt: isMacOS2 ? "option" : "alt",
    meta: isMacOS2 ? "command" : "Windows",
    mod: isMacOS2 ? "command" : "control",
    // Screen readers may not be able to pronounce concatenated words - this provides a better experience
    pageup: "page up",
    pagedown: "page down",
    arrowup: "up arrow",
    arrowdown: "down arrow",
    arrowleft: "left arrow",
    arrowright: "right arrow",
    capslock: "caps lock",
    printscreen: "print screen",
    // We don't need to represent _every_ symbol - only those found on standard keyboards.
    // Other symbols should be avoided as keyboard shortcuts anyway.
    // These should match the colloqiual names of the keys, not the names of the symbols. Ie,
    // "Equals" not "Equal Sign", "Dash" not "Minus", "Period" not "Dot", etc.
    "`": "backtick",
    "~": "tilde",
    "!": "exclamation point",
    "@": "at",
    "#": "hash",
    $: "dollar sign",
    "%": "percent",
    "^": "caret",
    "&": "ampersand",
    "*": "asterisk",
    "(": "left parenthesis",
    ")": "right parenthesis",
    _: "underscore",
    "-": "dash",
    "+": "plus",
    "=": "equals",
    "[": "left bracket",
    "{": "left curly brace",
    "]": "right bracket",
    "}": "right curly brace",
    "\\": "backslash",
    "|": "pipe",
    ";": "semicolon",
    ":": "colon",
    "'": "single quote",
    '"': "double quote",
    ",": "comma",
    "<": "left angle bracket",
    ".": "period",
    ">": "right angle bracket",
    "/": "forward slash",
    "?": "question mark",
    " ": "space"
  }[key2]) !== null && _alt$meta$mod$pageup$ !== void 0 ? _alt$meta$mod$pageup$ : key2.toLowerCase();
};
const Key = (t0) => {
  const $2 = distExports.c(14);
  const {
    name: name2,
    format: format2
  } = t0;
  const isMacOS2 = useIsMacOS();
  let t1;
  if ($2[0] !== isMacOS2 || $2[1] !== name2) {
    t1 = accessibleKeyName(name2, isMacOS2);
    $2[0] = isMacOS2;
    $2[1] = name2;
    $2[2] = t1;
  } else {
    t1 = $2[2];
  }
  let t2;
  if ($2[3] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden, {
      children: t1
    });
    $2[3] = t1;
    $2[4] = t2;
  } else {
    t2 = $2[4];
  }
  let t3;
  if ($2[5] !== format2 || $2[6] !== isMacOS2 || $2[7] !== name2) {
    t3 = format2 === "condensed" ? condensedKeyName(name2, isMacOS2) : fullKeyName(name2, isMacOS2);
    $2[5] = format2;
    $2[6] = isMacOS2;
    $2[7] = name2;
    $2[8] = t3;
  } else {
    t3 = $2[8];
  }
  let t4;
  if ($2[9] !== t3) {
    t4 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      "aria-hidden": true,
      children: t3
    });
    $2[9] = t3;
    $2[10] = t4;
  } else {
    t4 = $2[10];
  }
  let t5;
  if ($2[11] !== t2 || $2[12] !== t4) {
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
      children: [t2, t4]
    });
    $2[11] = t2;
    $2[12] = t4;
    $2[13] = t5;
  } else {
    t5 = $2[13];
  }
  return t5;
};
var classes$J = { "Text": "prc-Text-Text-0ima0" };
const Text$2 = /* @__PURE__ */ forwardRef$1((t0, forwardedRef) => {
  const $2 = distExports.c(14);
  let className;
  let props;
  let size2;
  let t1;
  let weight;
  if ($2[0] !== t0) {
    ({
      as: t1,
      className,
      size: size2,
      weight,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = props;
    $2[3] = size2;
    $2[4] = t1;
    $2[5] = weight;
  } else {
    className = $2[1];
    props = $2[2];
    size2 = $2[3];
    t1 = $2[4];
    weight = $2[5];
  }
  const Component2 = t1 === void 0 ? "span" : t1;
  const innerRef = React__default.useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  let t2;
  if ($2[6] !== className) {
    t2 = clsx(className, classes$J.Text);
    $2[6] = className;
    $2[7] = t2;
  } else {
    t2 = $2[7];
  }
  let t3;
  if ($2[8] !== Component2 || $2[9] !== props || $2[10] !== size2 || $2[11] !== t2 || $2[12] !== weight) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: Component2,
      className: t2,
      "data-size": size2,
      "data-weight": weight,
      ...props,
      ref: innerRef
    });
    $2[8] = Component2;
    $2[9] = props;
    $2[10] = size2;
    $2[11] = t2;
    $2[12] = weight;
    $2[13] = t3;
  } else {
    t3 = $2[13];
  }
  return t3;
});
Text$2.displayName = "Text";
const keySortPriorities = {
  control: 1,
  meta: 2,
  alt: 3,
  option: 4,
  shift: 5,
  function: 6
};
const keySortPriority = (priority) => {
  var _keySortPriorities$pr;
  return (_keySortPriorities$pr = keySortPriorities[priority]) !== null && _keySortPriorities$pr !== void 0 ? _keySortPriorities$pr : Infinity;
};
const compareLowercaseKeys = (a2, b2) => keySortPriority(a2) - keySortPriority(b2);
const splitChord = (chord) => chord.split("+").map((k2) => k2.toLowerCase()).sort(compareLowercaseKeys);
const backgroundColors = {
  normal: "var(--bgColor-transparent)",
  onEmphasis: "var(--counter-bgColor-emphasis)",
  onPrimary: "var(--button-primary-bgColor-active)"
};
const Chord = (t0) => {
  const $2 = distExports.c(17);
  const {
    keys: keys2,
    format: t1,
    variant: t2,
    size: t3
  } = t0;
  const format2 = t1 === void 0 ? "condensed" : t1;
  const variant3 = t2 === void 0 ? "normal" : t2;
  const size2 = t3 === void 0 ? "normal" : t3;
  const t4 = backgroundColors[variant3];
  const t5 = variant3 === "normal" ? "var(--fgColor-muted)" : "var(--fgColor-onEmphasis)";
  const t6 = variant3 === "normal" ? "var(--borderColor-default)" : "transparent";
  const t7 = size2 === "small" ? 1 : 2;
  const t8 = size2 === "small" ? "11px" : 0;
  const t9 = size2 === "small" ? "2px" : 1;
  const t10 = size2 === "small" ? "8px" : "10px";
  const t11 = size2 === "small" ? "var(--base-size-16)" : "var(--base-size-20)";
  let t12;
  if ($2[0] !== t10 || $2[1] !== t11 || $2[2] !== t4 || $2[3] !== t5 || $2[4] !== t6 || $2[5] !== t7 || $2[6] !== t8 || $2[7] !== t9) {
    t12 = {
      display: "inline-flex",
      bg: t4,
      color: t5,
      border: "1px solid",
      borderColor: t6,
      borderRadius: t7,
      fontWeight: "normal",
      fontFamily: "normal",
      fontSize: t8,
      p: t9,
      gap: "0.5ch",
      boxShadow: "none",
      verticalAlign: "baseline",
      overflow: "hidden",
      lineHeight: t10,
      minWidth: t11,
      justifyContent: "center"
    };
    $2[0] = t10;
    $2[1] = t11;
    $2[2] = t4;
    $2[3] = t5;
    $2[4] = t6;
    $2[5] = t7;
    $2[6] = t8;
    $2[7] = t9;
    $2[8] = t12;
  } else {
    t12 = $2[8];
  }
  let t13;
  if ($2[9] !== format2 || $2[10] !== keys2) {
    let t142;
    if ($2[12] !== format2) {
      t142 = (k2, i) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment$1, {
        children: [i > 0 && format2 === "full" ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          "aria-hidden": true,
          children: " + "
        }) : " ", /* @__PURE__ */ jsxRuntimeExports.jsx(Key, {
          name: k2,
          format: format2
        })]
      }, i);
      $2[12] = format2;
      $2[13] = t142;
    } else {
      t142 = $2[13];
    }
    t13 = splitChord(keys2).map(t142);
    $2[9] = format2;
    $2[10] = keys2;
    $2[11] = t13;
  } else {
    t13 = $2[11];
  }
  let t14;
  if ($2[14] !== t12 || $2[15] !== t13) {
    t14 = /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, {
      sx: t12,
      children: t13
    });
    $2[14] = t12;
    $2[15] = t13;
    $2[16] = t14;
  } else {
    t14 = $2[16];
  }
  return t14;
};
const accessibleChordString = (chord, isMacOS2) => splitChord(chord).map((key2) => accessibleKeyName(key2, isMacOS2)).join(" ");
const splitSequence = (sequence) => sequence.split(" ");
const Sequence = ({
  keys: keys2,
  ...chordProps
}) => splitSequence(keys2).map((c2, i) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment$1, {
  children: [
    //  Since we audibly separate individual keys in chord with space, we need some other separator for chords in a sequence
    i > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden, {
        children: "then"
      }), " "]
    }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Chord, {
      keys: c2,
      ...chordProps
    })
  ]
}, i));
const accessibleSequenceString = (sequence, isMacOS2) => splitSequence(sequence).map((chord) => accessibleChordString(chord, isMacOS2)).join(" then ");
var classes$I = { "KeybindingHint": "prc-KeybindingHint-KeybindingHint-0pyit" };
const Kbd = (t0) => {
  const $2 = distExports.c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($2[0] !== className) {
    t1 = clsx(className, classes$I.KeybindingHint);
    $2[0] = className;
    $2[1] = t1;
  } else {
    t1 = $2[1];
  }
  let t2;
  if ($2[2] !== children || $2[3] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, {
      as: "kbd",
      className: t1,
      "data-testid": "keybinding-hint",
      children
    });
    $2[2] = children;
    $2[3] = t1;
    $2[4] = t2;
  } else {
    t2 = $2[4];
  }
  return t2;
};
const KeybindingHint = /* @__PURE__ */ memo((t0) => {
  const $2 = distExports.c(8);
  let className;
  let props;
  if ($2[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = props;
  } else {
    className = $2[1];
    props = $2[2];
  }
  let t1;
  if ($2[3] !== props) {
    t1 = /* @__PURE__ */ jsxRuntimeExports.jsx(Sequence, {
      ...props
    });
    $2[3] = props;
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  let t2;
  if ($2[5] !== className || $2[6] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(Kbd, {
      className,
      children: t1
    });
    $2[5] = className;
    $2[6] = t1;
    $2[7] = t2;
  } else {
    t2 = $2[7];
  }
  return t2;
});
KeybindingHint.displayName = "KeybindingHint";
const getAccessibleKeybindingHintString = accessibleSequenceString;
const directionToPosition = {
  nw: {
    side: "outside-top",
    align: "end"
  },
  n: {
    side: "outside-top",
    align: "center"
  },
  ne: {
    side: "outside-top",
    align: "start"
  },
  e: {
    side: "outside-right",
    align: "center"
  },
  se: {
    side: "outside-bottom",
    align: "start"
  },
  s: {
    side: "outside-bottom",
    align: "center"
  },
  sw: {
    side: "outside-bottom",
    align: "end"
  },
  w: {
    side: "outside-left",
    align: "center"
  }
};
const positionToDirection = {
  "outside-top-end": "nw",
  "outside-top-center": "n",
  "outside-top-start": "ne",
  "outside-right-center": "e",
  "outside-bottom-start": "se",
  "outside-bottom-center": "s",
  "outside-bottom-end": "sw",
  "outside-left-center": "w"
};
const interactiveElements$1 = ["a[href]", "button:not([disabled])", "summary", "select", "input:not([type=hidden])", "textarea"];
const isInteractive = (element2) => {
  return interactiveElements$1.some((selector2) => element2.matches(selector2)) || element2.hasAttribute("role") && element2.getAttribute("role") === "button";
};
const TooltipContext$1 = /* @__PURE__ */ React__default.createContext({});
const Tooltip = /* @__PURE__ */ React__default.forwardRef(({
  direction = "s",
  text: text2,
  type = "description",
  children,
  id,
  className,
  keybindingHint,
  ...rest
}, forwardedRef) => {
  const tooltipId = useId(id);
  const child = Children.only(children);
  const triggerRef = useProvidedRefOrCreate(forwardedRef);
  const tooltipElRef = useRef(null);
  const [calculatedDirection, setCalculatedDirection] = useState(direction);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const openTimeoutRef = React__default.useRef(null);
  const {
    safeSetTimeout,
    safeClearTimeout
  } = useSafeTimeout();
  const openTooltip = () => {
    try {
      if (tooltipElRef.current && triggerRef.current && tooltipElRef.current.hasAttribute("popover") && !tooltipElRef.current.matches(":popover-open")) {
        const tooltip = tooltipElRef.current;
        const trigger = triggerRef.current;
        tooltip.showPopover();
        setIsPopoverOpen(true);
        const settings = {
          side: directionToPosition[direction].side,
          align: directionToPosition[direction].align
        };
        const {
          top: top2,
          left: left2,
          anchorAlign,
          anchorSide
        } = getAnchoredPosition(tooltip, trigger, settings);
        const calculatedDirection_0 = positionToDirection[`${anchorSide}-${anchorAlign}`];
        setCalculatedDirection(calculatedDirection_0);
        tooltip.style.top = `${top2}px`;
        tooltip.style.left = `${left2}px`;
      }
    } catch (error2) {
      if (error2 && typeof error2 === "object" && "message" in error2 && typeof error2.message === "string" && error2.message.includes("not a valid selector")) ;
      else {
        throw error2;
      }
    }
  };
  const closeTooltip = () => {
    if (openTimeoutRef.current) {
      safeClearTimeout(openTimeoutRef.current);
      openTimeoutRef.current = null;
    }
    try {
      if (tooltipElRef.current && triggerRef.current && tooltipElRef.current.hasAttribute("popover") && tooltipElRef.current.matches(":popover-open")) {
        tooltipElRef.current.hidePopover();
        setIsPopoverOpen(false);
      } else {
        setIsPopoverOpen(false);
      }
    } catch (error_0) {
      if (error_0 && typeof error_0 === "object" && "message" in error_0 && typeof error_0.message === "string" && error_0.message.includes("not a valid selector")) ;
      else {
        throw error_0;
      }
    }
  };
  const value = useMemo$1(() => ({
    tooltipId
  }), [tooltipId]);
  useEffect(() => {
    if (!tooltipElRef.current || !triggerRef.current) return;
    const isTriggerInteractive = isInteractive(triggerRef.current);
    const triggerChildren = triggerRef.current.childNodes;
    const hasInteractiveDescendant = Array.from(triggerChildren).some((child_0) => {
      return child_0 instanceof HTMLElement && isInteractive(child_0) || Array.from(child_0.childNodes).some((grandChild) => grandChild instanceof HTMLElement && isInteractive(grandChild));
    });
    !(isTriggerInteractive || hasInteractiveDescendant) ? process.env.NODE_ENV !== "production" ? invariant(false, "The `Tooltip` component expects a single React element that contains interactive content. Consider using a `<button>` or equivalent interactive element instead.") : invariant(false) : void 0;
    if (type === "label") {
      const hasAriaLabel = triggerRef.current.hasAttribute("aria-label");
      const hasAriaLabelInChildren = Array.from(triggerRef.current.childNodes).some((child_1) => child_1 instanceof HTMLElement && child_1.hasAttribute("aria-label"));
      process.env.NODE_ENV !== "production" ? warning2(hasAriaLabel || hasAriaLabelInChildren, "The label type `Tooltip` is going to be used here to label the trigger element. Please remove the aria-label from the trigger element.") : void 0;
    }
    if (typeof window !== "undefined") {
      if (!isSupported()) {
        apply$1();
      }
    }
    const tooltip_0 = tooltipElRef.current;
    tooltip_0.setAttribute("popover", "auto");
  }, [tooltipElRef, triggerRef, direction, type]);
  useOnEscapePress((event) => {
    if (isPopoverOpen) {
      event.stopImmediatePropagation();
      event.preventDefault();
      closeTooltip();
    }
  }, [isPopoverOpen]);
  const isMacOS2 = useIsMacOS();
  const hasAriaLabel_0 = "aria-label" in rest;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipContext$1.Provider, {
    value,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
      children: [/* @__PURE__ */ React__default.isValidElement(child) && /* @__PURE__ */ React__default.cloneElement(child, {
        ref: triggerRef,
        // If it is a type description, we use tooltip to describe the trigger
        "aria-describedby": (() => {
          if (type !== "description") {
            return child.props["aria-describedby"];
          }
          const existingDescribedBy = child.props["aria-describedby"];
          if (existingDescribedBy) {
            return `${existingDescribedBy} ${tooltipId}`;
          }
          return tooltipId;
        })(),
        // If it is a label type, we use tooltip to label the trigger
        "aria-labelledby": type === "label" ? tooltipId : child.props["aria-labelledby"],
        onBlur: (event_0) => {
          var _child$props$onBlur, _child$props;
          closeTooltip();
          (_child$props$onBlur = (_child$props = child.props).onBlur) === null || _child$props$onBlur === void 0 ? void 0 : _child$props$onBlur.call(_child$props, event_0);
        },
        onTouchEnd: (event_1) => {
          var _child$props$onTouchE, _child$props2;
          (_child$props$onTouchE = (_child$props2 = child.props).onTouchEnd) === null || _child$props$onTouchE === void 0 ? void 0 : _child$props$onTouchE.call(_child$props2, event_1);
          safeSetTimeout(() => closeTooltip(), 10);
        },
        onFocus: (event_2) => {
          var _child$props$onFocus, _child$props3;
          try {
            if (!event_2.target.matches(":focus-visible")) return;
          } catch (_error) {
          }
          openTooltip();
          (_child$props$onFocus = (_child$props3 = child.props).onFocus) === null || _child$props$onFocus === void 0 ? void 0 : _child$props$onFocus.call(_child$props3, event_2);
        },
        onMouseOverCapture: (event_3) => {
          openTimeoutRef.current = safeSetTimeout(() => {
            var _child$props$onMouseE, _child$props4;
            openTooltip();
            (_child$props$onMouseE = (_child$props4 = child.props).onMouseEnter) === null || _child$props$onMouseE === void 0 ? void 0 : _child$props$onMouseE.call(_child$props4, event_3);
          }, 50);
        },
        onMouseLeave: (event_4) => {
          var _child$props$onMouseL, _child$props5;
          closeTooltip();
          (_child$props$onMouseL = (_child$props5 = child.props).onMouseLeave) === null || _child$props$onMouseL === void 0 ? void 0 : _child$props$onMouseL.call(_child$props5, event_4);
        }
      }), /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
        as: "span",
        className: clsx(className, classes$L.Tooltip),
        ref: tooltipElRef,
        "data-direction": calculatedDirection,
        ...rest,
        // Only need tooltip role if the tooltip is a description for supplementary information
        role: type === "description" ? "tooltip" : void 0,
        "aria-hidden": true,
        onMouseEnter: openTooltip,
        onMouseLeave: closeTooltip,
        id: hasAriaLabel_0 || !keybindingHint ? tooltipId : void 0,
        children: keybindingHint ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
          children: [/* @__PURE__ */ jsxRuntimeExports.jsxs("span", {
            id: hasAriaLabel_0 ? void 0 : tooltipId,
            children: [text2, /* @__PURE__ */ jsxRuntimeExports.jsxs(VisuallyHidden, {
              children: ["(", getAccessibleKeybindingHintString(keybindingHint, isMacOS2), ")"]
            })]
          }), /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
            className: clsx(classes$L.KeybindingHintContainer, text2 && classes$L.HasTextBefore),
            "aria-hidden": true,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(KeybindingHint, {
              keys: keybindingHint,
              format: "condensed",
              variant: "onEmphasis",
              size: "small"
            })
          })]
        }) : text2
      })]
    })
  });
});
qe.span.withConfig({
  displayName: "Tooltip__TooltipBase",
  componentId: "sc-17tf59c-0"
})(["position:relative;display:inline-block;&::after{position:absolute;z-index:1000000;display:none;padding:0.5em 0.75em;font:normal normal 11px/1.5 ", ";-webkit-font-smoothing:subpixel-antialiased;color:var(--tooltip-fgColor,", ");text-align:center;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-wrap:break-word;white-space:pre;pointer-events:none;content:attr(aria-label);background:var(--tooltip-bgColor,", ");border-radius:", ";opacity:0;}@keyframes tooltip-appear{from{opacity:0;}to{opacity:1;}}&:hover,&:active,&:focus,&:focus-within{&::after{display:inline-block;text-decoration:none;animation-name:tooltip-appear;animation-duration:0.1s;animation-fill-mode:forwards;animation-timing-function:ease-in;animation-delay:0s;}}&.tooltipped-no-delay:hover,&.tooltipped-no-delay:active,&.tooltipped-no-delay:focus,&.tooltipped-no-delay:focus-within{&::after{animation-delay:0s;}}&.tooltipped-multiline:hover,&.tooltipped-multiline:active,&.tooltipped-multiline:focus,&.tooltipped-multiline:focus-within{&::after{display:table-cell;}}&.tooltipped-s,&.tooltipped-se,&.tooltipped-sw{&::after{top:100%;right:50%;margin-top:6px;}}&.tooltipped-se{&::after{right:auto;left:50%;margin-left:-", ";}}&.tooltipped-sw::after{margin-right:-", ";}&.tooltipped-n,&.tooltipped-ne,&.tooltipped-nw{&::after{right:50%;bottom:100%;margin-bottom:6px;}}&.tooltipped-ne{&::after{right:auto;left:50%;margin-left:-", ";}}&.tooltipped-nw::after{margin-right:-", ";}&.tooltipped-s::after,&.tooltipped-n::after{transform:translateX(50%);}&.tooltipped-w{&::after{right:100%;bottom:50%;margin-right:6px;transform:translateY(50%);}}&.tooltipped-e{&::after{bottom:50%;left:100%;margin-left:6px;transform:translateY(50%);}}&.tooltipped-multiline{&::after{width:max-content;max-width:250px;word-wrap:break-word;white-space:pre-line;border-collapse:separate;}&.tooltipped-s::after,&.tooltipped-n::after{right:auto;left:50%;transform:translateX(-50%);}&.tooltipped-w::after,&.tooltipped-e::after{right:100%;}}&.tooltipped-align-right-2::after{right:0;margin-right:0;}&.tooltipped-align-left-2::after{left:0;margin-left:0;}", ";"], get$3("fonts.normal"), get$3("colors.fg.onEmphasis"), get$3("colors.neutral.emphasisPlus"), get$3("radii.2"), get$3("space.3"), get$3("space.3"), get$3("space.3"), get$3("space.3"), sx);
const TooltipContext = /* @__PURE__ */ React__default.createContext({});
const IconButton = /* @__PURE__ */ forwardRef$1(({
  sx: sxProp = defaultSxProp,
  icon: Icon2,
  "aria-label": ariaLabel,
  description,
  disabled,
  tooltipDirection,
  // This is planned to be a temporary prop until the default tooltip on icon buttons are fully rolled out.
  unsafeDisableTooltip = false,
  keyshortcuts,
  keybindingHint,
  className,
  ...props
}, forwardedRef) => {
  let sxStyles = sxProp;
  const {
    size: size2 = "medium"
  } = props;
  if (sxProp !== null && Object.keys(sxProp).length > 0) {
    sxStyles = generateCustomSxProp({
      size: size2
    }, sxProp);
  }
  const {
    tooltipId
  } = React__default.useContext(TooltipContext$1);
  const {
    tooltipId: tooltipIdV1
  } = React__default.useContext(TooltipContext);
  const hasExternalTooltip = tooltipId || tooltipIdV1;
  const withoutTooltip = unsafeDisableTooltip || disabled || ariaLabel === void 0 || ariaLabel === "" || hasExternalTooltip;
  if (withoutTooltip) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonBase, {
      icon: Icon2,
      className: clsx(className, classes$P.IconButton),
      "data-component": "IconButton",
      sx: sxStyles,
      type: "button",
      "aria-label": ariaLabel,
      disabled,
      ...props,
      // @ts-expect-error StyledButton wants both Anchor and Button refs
      ref: forwardedRef
    });
  } else {
    const tooltipText = description !== null && description !== void 0 ? description : ariaLabel;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, {
      ref: forwardedRef,
      text: tooltipText,
      type: description ? void 0 : "label",
      direction: tooltipDirection,
      keybindingHint: keybindingHint !== null && keybindingHint !== void 0 ? keybindingHint : keyshortcuts,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonBase, {
        icon: Icon2,
        className: clsx(className, classes$P.IconButton),
        "data-component": "IconButton",
        sx: sxStyles,
        type: "button",
        "aria-keyshortcuts": keyshortcuts !== null && keyshortcuts !== void 0 ? keyshortcuts : void 0,
        "aria-label": description ? ariaLabel : void 0,
        ...props
      })
    });
  }
});
function useFocusTrap(settings, dependencies = []) {
  const containerRef = useProvidedRefOrCreate(settings === null || settings === void 0 ? void 0 : settings.containerRef);
  const initialFocusRef = useProvidedRefOrCreate(settings === null || settings === void 0 ? void 0 : settings.initialFocusRef);
  const disabled = settings === null || settings === void 0 ? void 0 : settings.disabled;
  const abortController = React__default.useRef();
  const previousFocusedElement = React__default.useRef(null);
  if (!previousFocusedElement.current && !(settings !== null && settings !== void 0 && settings.disabled)) {
    previousFocusedElement.current = document.activeElement;
  }
  function disableTrap() {
    var _abortController$curr;
    (_abortController$curr = abortController.current) === null || _abortController$curr === void 0 ? void 0 : _abortController$curr.abort();
    if (settings !== null && settings !== void 0 && settings.returnFocusRef && settings.returnFocusRef.current instanceof HTMLElement) {
      settings.returnFocusRef.current.focus();
    } else if (settings !== null && settings !== void 0 && settings.restoreFocusOnCleanUp && previousFocusedElement.current instanceof HTMLElement) {
      previousFocusedElement.current.focus();
      previousFocusedElement.current = null;
    }
  }
  React__default.useEffect(
    () => {
      if (containerRef.current instanceof HTMLElement) {
        if (!disabled) {
          var _initialFocusRef$curr;
          abortController.current = focusTrap(containerRef.current, (_initialFocusRef$curr = initialFocusRef.current) !== null && _initialFocusRef$curr !== void 0 ? _initialFocusRef$curr : void 0);
          return () => {
            disableTrap();
          };
        } else {
          disableTrap();
        }
      }
    },
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [containerRef, initialFocusRef, disabled, ...dependencies]
  );
  return {
    containerRef,
    initialFocusRef
  };
}
function ownKeys(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key2) {
      _defineProperty(target, key2, source[key2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key2) {
      Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
    });
  }
  return target;
}
function _defineProperty(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key2 = sourceKeys[i];
    if (excluded.indexOf(key2) >= 0) continue;
    target[key2] = source[key2];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
var _excluded = ["aria-label", "aria-labelledby", "tabIndex", "className", "fill", "size", "verticalAlign", "id", "title", "style"];
var sizeMap = {
  small: 16,
  medium: 32,
  large: 64
};
function createIconComponent(name2, defaultClassName, getSVGData) {
  var svgDataByHeight = getSVGData();
  var heights = Object.keys(svgDataByHeight);
  var Icon2 = /* @__PURE__ */ React__default.forwardRef(function(_ref, forwardedRef) {
    var ariaLabel = _ref["aria-label"], arialabelledby = _ref["aria-labelledby"], tabIndex = _ref.tabIndex, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? "currentColor" : _ref$fill, _ref$size = _ref.size, size2 = _ref$size === void 0 ? 16 : _ref$size, _ref$verticalAlign = _ref.verticalAlign, verticalAlign2 = _ref$verticalAlign === void 0 ? "text-bottom" : _ref$verticalAlign, id = _ref.id, title = _ref.title, style3 = _ref.style, rest = _objectWithoutProperties(_ref, _excluded);
    var height2 = sizeMap[size2] || size2;
    var naturalHeight = closestNaturalHeight(heights, height2);
    var naturalWidth = svgDataByHeight[naturalHeight].width;
    var width2 = height2 * (naturalWidth / naturalHeight);
    var path2 = svgDataByHeight[naturalHeight].path;
    var labelled = ariaLabel || arialabelledby;
    var role = labelled ? "img" : void 0;
    return /* @__PURE__ */ React__default.createElement("svg", _extends({
      ref: forwardedRef
    }, rest, {
      "aria-hidden": labelled ? void 0 : "true",
      tabIndex,
      focusable: tabIndex >= 0 ? "true" : "false",
      "aria-label": ariaLabel,
      "aria-labelledby": arialabelledby,
      className: "".concat(defaultClassName, " ").concat(className).trim(),
      role,
      viewBox: "0 0 ".concat(naturalWidth, " ").concat(naturalHeight),
      width: width2,
      height: height2,
      fill,
      id,
      display: "inline-block",
      overflow: "visible",
      style: _objectSpread2({
        verticalAlign: verticalAlign2
      }, style3)
    }), title ? /* @__PURE__ */ React__default.createElement("title", null, title) : null, path2);
  });
  Icon2.displayName = name2;
  return Icon2;
}
function closestNaturalHeight(naturalHeights, height2) {
  return naturalHeights.map(function(naturalHeight) {
    return parseInt(naturalHeight, 10);
  }).reduce(function(acc, naturalHeight) {
    return naturalHeight <= height2 ? naturalHeight : acc;
  }, naturalHeights[0]);
}
var AlertIcon = /* @__PURE__ */ createIconComponent("AlertIcon", "octicon octicon-alert", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M6.457 1.047c.659-1.234 2.427-1.234 3.086 0l6.082 11.378A1.75 1.75 0 0 1 14.082 15H1.918a1.75 1.75 0 0 1-1.543-2.575Zm1.763.707a.25.25 0 0 0-.44 0L1.698 13.132a.25.25 0 0 0 .22.368h12.164a.25.25 0 0 0 .22-.368Zm.53 3.996v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 1.5 0ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M13 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-.25-8.25a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0v-4.5Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M9.836 3.244c.963-1.665 3.365-1.665 4.328 0l8.967 15.504c.963 1.667-.24 3.752-2.165 3.752H3.034c-1.926 0-3.128-2.085-2.165-3.752Zm3.03.751a1.002 1.002 0 0 0-1.732 0L2.168 19.499A1.002 1.002 0 0 0 3.034 21h17.932a1.002 1.002 0 0 0 .866-1.5L12.866 3.994Z"
      }))
    }
  };
});
var AlertFillIcon = /* @__PURE__ */ createIconComponent("AlertFillIcon", "octicon octicon-alert-fill", function() {
  return {
    "12": {
      "width": 12,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M4.855.708c.5-.896 1.79-.896 2.29 0l4.675 8.351a1.312 1.312 0 0 1-1.146 1.954H1.33A1.313 1.313 0 0 1 .183 9.058ZM7 7V3H5v4Zm-1 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      })
    },
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M6.457 1.047c.659-1.234 2.427-1.234 3.086 0l6.082 11.378A1.75 1.75 0 0 1 14.082 15H1.918a1.75 1.75 0 0 1-1.543-2.575ZM8 5a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 0 1.5 0v-2.5A.75.75 0 0 0 8 5Zm1 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M9.836 3.244c.963-1.665 3.365-1.665 4.328 0l8.967 15.504c.963 1.667-.24 3.752-2.165 3.752H3.034c-1.926 0-3.128-2.085-2.165-3.752ZM12 8.5a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 12 8.5Zm1 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
      })
    }
  };
});
var ArrowDownIcon = /* @__PURE__ */ createIconComponent("ArrowDownIcon", "octicon octicon-arrow-down", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M13.03 8.22a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L3.47 9.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l2.97 2.97V3.75a.75.75 0 0 1 1.5 0v7.44l2.97-2.97a.75.75 0 0 1 1.06 0Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M4.97 13.22a.75.75 0 0 1 1.06 0L11 18.19V3.75a.75.75 0 0 1 1.5 0v14.44l4.97-4.97a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-6.25 6.25a.75.75 0 0 1-1.06 0l-6.25-6.25a.75.75 0 0 1 0-1.06Z"
      })
    }
  };
});
var ArrowLeftIcon = /* @__PURE__ */ createIconComponent("ArrowLeftIcon", "octicon octicon-arrow-left", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M7.78 12.53a.75.75 0 0 1-1.06 0L2.47 8.28a.75.75 0 0 1 0-1.06l4.25-4.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L4.81 7h7.44a.75.75 0 0 1 0 1.5H4.81l2.97 2.97a.75.75 0 0 1 0 1.06Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M10.78 19.03a.75.75 0 0 1-1.06 0l-6.25-6.25a.75.75 0 0 1 0-1.06l6.25-6.25a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L5.81 11.5h14.44a.75.75 0 0 1 0 1.5H5.81l4.97 4.97a.75.75 0 0 1 0 1.06Z"
      })
    }
  };
});
var ArrowRightIcon = /* @__PURE__ */ createIconComponent("ArrowRightIcon", "octicon octicon-arrow-right", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M8.22 2.97a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l2.97-2.97H3.75a.75.75 0 0 1 0-1.5h7.44L8.22 4.03a.75.75 0 0 1 0-1.06Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M13.22 19.03a.75.75 0 0 1 0-1.06L18.19 13H3.75a.75.75 0 0 1 0-1.5h14.44l-4.97-4.97a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215l6.25 6.25a.75.75 0 0 1 0 1.06l-6.25 6.25a.75.75 0 0 1-1.06 0Z"
      })
    }
  };
});
var ArrowUpIcon = /* @__PURE__ */ createIconComponent("ArrowUpIcon", "octicon octicon-arrow-up", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M3.47 7.78a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0l4.25 4.25a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018L9 4.81v7.44a.75.75 0 0 1-1.5 0V4.81L4.53 7.78a.75.75 0 0 1-1.06 0Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M18.655 10.405a.75.75 0 0 1-1.06 0l-4.97-4.97v14.44a.75.75 0 0 1-1.5 0V5.435l-4.97 4.97a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l6.25-6.25a.75.75 0 0 1 1.06 0l6.25 6.25a.75.75 0 0 1 0 1.06Z"
      })
    }
  };
});
var BoldIcon = /* @__PURE__ */ createIconComponent("BoldIcon", "octicon octicon-bold", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M4 2h4.5a3.501 3.501 0 0 1 2.852 5.53A3.499 3.499 0 0 1 9.5 14H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm1 7v3h4.5a1.5 1.5 0 0 0 0-3Zm3.5-2a1.5 1.5 0 0 0 0-3H5v3Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M6 4.75c0-.69.56-1.25 1.25-1.25h5a4.752 4.752 0 0 1 3.888 7.479A5 5 0 0 1 14 20.5H7.25c-.69 0-1.25-.56-1.25-1.25ZM8.5 13v5H14a2.5 2.5 0 1 0 0-5Zm0-2.5h3.751A2.25 2.25 0 0 0 12.25 6H8.5Z"
      })
    }
  };
});
var BookmarkIcon = /* @__PURE__ */ createIconComponent("BookmarkIcon", "octicon octicon-bookmark", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M3 2.75C3 1.784 3.784 1 4.75 1h6.5c.966 0 1.75.784 1.75 1.75v11.5a.75.75 0 0 1-1.227.579L8 11.722l-3.773 3.107A.751.751 0 0 1 3 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v9.91l3.023-2.489a.75.75 0 0 1 .954 0l3.023 2.49V2.75a.25.25 0 0 0-.25-.25Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M5 3.75C5 2.784 5.784 2 6.75 2h10.5c.966 0 1.75.784 1.75 1.75v17.5a.75.75 0 0 1-1.218.586L12 17.21l-5.781 4.625A.75.75 0 0 1 5 21.25Zm1.75-.25a.25.25 0 0 0-.25.25v15.94l5.031-4.026a.749.749 0 0 1 .938 0L17.5 19.69V3.75a.25.25 0 0 0-.25-.25Z"
      })
    }
  };
});
var CalendarIcon2 = /* @__PURE__ */ createIconComponent("CalendarIcon", "octicon octicon-calendar", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M4.75 0a.75.75 0 0 1 .75.75V2h5V.75a.75.75 0 0 1 1.5 0V2h1.25c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 16H2.75A1.75 1.75 0 0 1 1 14.25V3.75C1 2.784 1.784 2 2.75 2H4V.75A.75.75 0 0 1 4.75 0ZM2.5 7.5v6.75c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V7.5Zm10.75-4H2.75a.25.25 0 0 0-.25.25V6h11V3.75a.25.25 0 0 0-.25-.25Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M6.75 0a.75.75 0 0 1 .75.75V3h9V.75a.75.75 0 0 1 1.5 0V3h2.75c.966 0 1.75.784 1.75 1.75v16a1.75 1.75 0 0 1-1.75 1.75H3.25a1.75 1.75 0 0 1-1.75-1.75v-16C1.5 3.784 2.284 3 3.25 3H6V.75A.75.75 0 0 1 6.75 0ZM21 9.5H3v11.25c0 .138.112.25.25.25h17.5a.25.25 0 0 0 .25-.25Zm-17.75-5a.25.25 0 0 0-.25.25V8h18V4.75a.25.25 0 0 0-.25-.25Z"
      })
    }
  };
});
var CheckIcon = /* @__PURE__ */ createIconComponent("CheckIcon", "octicon octicon-check", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L2.22 9.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M21.03 5.72a.75.75 0 0 1 0 1.06l-11.5 11.5a.747.747 0 0 1-1.072-.012l-5.5-5.75a.75.75 0 1 1 1.084-1.036l4.97 5.195L19.97 5.72a.75.75 0 0 1 1.06 0Z"
      })
    }
  };
});
var CheckCircleIcon = /* @__PURE__ */ createIconComponent("CheckCircleIcon", "octicon octicon-check-circle", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm1.5 0a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm10.28-1.72-4.5 4.5a.75.75 0 0 1-1.06 0l-2-2a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l1.47 1.47 3.97-3.97a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M17.28 9.28a.75.75 0 0 0-1.06-1.06l-5.97 5.97-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l6.5-6.5Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
      }))
    }
  };
});
var CheckCircleFillIcon = /* @__PURE__ */ createIconComponent("CheckCircleFillIcon", "octicon octicon-check-circle-fill", function() {
  return {
    "12": {
      "width": 12,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0Zm-.705 8.737L9.63 4.403 8.392 3.166 5.295 6.263l-1.7-1.702L2.356 5.8l2.938 2.938Z"
      })
    },
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm3.78-9.72a.751.751 0 0 0-.018-1.042.751.751 0 0 0-1.042-.018L6.75 9.19 5.28 7.72a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042l2 2a.75.75 0 0 0 1.06 0Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm16.28-2.72a.751.751 0 0 0-.018-1.042.751.751 0 0 0-1.042-.018l-5.97 5.97-2.47-2.47a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042l3 3a.75.75 0 0 0 1.06 0Z"
      })
    }
  };
});
var CheckboxIcon = /* @__PURE__ */ createIconComponent("CheckboxIcon", "octicon octicon-checkbox", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M2.75 1h10.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1ZM2.5 2.75v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25H2.75a.25.25 0 0 0-.25.25Zm9.28 3.53-4.5 4.5a.75.75 0 0 1-1.06 0l-2-2a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l1.47 1.47 3.97-3.97a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M17.28 9.28a.75.75 0 0 0-1.06-1.06l-5.97 5.97-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l6.5-6.5Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2ZM3.5 3.75v16.5c0 .138.112.25.25.25h16.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25H3.75a.25.25 0 0 0-.25.25Z"
      }))
    }
  };
});
var ChevronDownIcon = /* @__PURE__ */ createIconComponent("ChevronDownIcon", "octicon octicon-chevron-down", function() {
  return {
    "12": {
      "width": 12,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M6 8.825c-.2 0-.4-.1-.5-.2l-3.3-3.3c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l2.7 2.7 2.7-2.7c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1l-3.2 3.2c-.2.2-.4.3-.6.3Z"
      })
    },
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M12.78 5.22a.749.749 0 0 1 0 1.06l-4.25 4.25a.749.749 0 0 1-1.06 0L3.22 6.28a.749.749 0 1 1 1.06-1.06L8 8.939l3.72-3.719a.749.749 0 0 1 1.06 0Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M5.22 8.22a.749.749 0 0 0 0 1.06l6.25 6.25a.749.749 0 0 0 1.06 0l6.25-6.25a.749.749 0 1 0-1.06-1.06L12 13.939 6.28 8.22a.749.749 0 0 0-1.06 0Z"
      })
    }
  };
});
var ChevronLeftIcon = /* @__PURE__ */ createIconComponent("ChevronLeftIcon", "octicon octicon-chevron-left", function() {
  return {
    "12": {
      "width": 12,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M3.587 6.025c0 .2.1.4.2.5l3.3 3.3c.3.3.8.3 1.1 0 .3-.3.3-.8 0-1.1l-2.7-2.7 2.7-2.7c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0l-3.2 3.2c-.2.2-.3.4-.3.6Z"
      })
    },
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M9.78 12.78a.75.75 0 0 1-1.06 0L4.47 8.53a.75.75 0 0 1 0-1.06l4.25-4.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L6.06 8l3.72 3.72a.75.75 0 0 1 0 1.06Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M15.28 5.22a.75.75 0 0 1 0 1.06L9.56 12l5.72 5.72a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-6.25-6.25a.75.75 0 0 1 0-1.06l6.25-6.25a.75.75 0 0 1 1.06 0Z"
      })
    }
  };
});
var ChevronRightIcon = /* @__PURE__ */ createIconComponent("ChevronRightIcon", "octicon octicon-chevron-right", function() {
  return {
    "12": {
      "width": 12,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M4.7 10c-.2 0-.4-.1-.5-.2-.3-.3-.3-.8 0-1.1L6.9 6 4.2 3.3c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l3.3 3.2c.3.3.3.8 0 1.1L5.3 9.7c-.2.2-.4.3-.6.3Z"
      })
    },
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M6.22 3.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L9.94 8 6.22 4.28a.75.75 0 0 1 0-1.06Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M8.72 18.78a.75.75 0 0 1 0-1.06L14.44 12 8.72 6.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l6.25 6.25a.75.75 0 0 1 0 1.06l-6.25 6.25a.75.75 0 0 1-1.06 0Z"
      })
    }
  };
});
var ChevronUpIcon = /* @__PURE__ */ createIconComponent("ChevronUpIcon", "octicon octicon-chevron-up", function() {
  return {
    "12": {
      "width": 12,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M6 4c-.2 0-.4.1-.5.2L2.2 7.5c-.3.3-.3.8 0 1.1.3.3.8.3 1.1 0L6 5.9l2.7 2.7c.3.3.8.3 1.1 0 .3-.3.3-.8 0-1.1L6.6 4.3C6.4 4.1 6.2 4 6 4Z"
      })
    },
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M3.22 10.53a.749.749 0 0 1 0-1.06l4.25-4.25a.749.749 0 0 1 1.06 0l4.25 4.25a.749.749 0 1 1-1.06 1.06L8 6.811 4.28 10.53a.749.749 0 0 1-1.06 0Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M18.78 15.78a.749.749 0 0 1-1.06 0L12 10.061 6.28 15.78a.749.749 0 1 1-1.06-1.06l6.25-6.25a.749.749 0 0 1 1.06 0l6.25 6.25a.749.749 0 0 1 0 1.06Z"
      })
    }
  };
});
var ColumnsIcon = /* @__PURE__ */ createIconComponent("ColumnsIcon", "octicon octicon-columns", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M2.75 0h2.5C6.216 0 7 .784 7 1.75v12.5A1.75 1.75 0 0 1 5.25 16h-2.5A1.75 1.75 0 0 1 1 14.25V1.75C1 .784 1.784 0 2.75 0Zm8 0h2.5C14.216 0 15 .784 15 1.75v12.5A1.75 1.75 0 0 1 13.25 16h-2.5A1.75 1.75 0 0 1 9 14.25V1.75C9 .784 9.784 0 10.75 0ZM2.5 1.75v12.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25Zm8 0v12.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M3.75 2h5.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 9.25 22h-5.5A1.75 1.75 0 0 1 2 20.25V3.75C2 2.784 2.784 2 3.75 2Zm11 0h5.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22h-5.5A1.75 1.75 0 0 1 13 20.25V3.75c0-.966.784-1.75 1.75-1.75ZM3.5 3.75v16.5c0 .138.112.25.25.25h5.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25h-5.5a.25.25 0 0 0-.25.25Zm11 0v16.5c0 .138.112.25.25.25h5.5a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25h-5.5a.25.25 0 0 0-.25.25Z"
      })
    }
  };
});
var CopyIcon = /* @__PURE__ */ createIconComponent("CopyIcon", "octicon octicon-copy", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"
      }))
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M7.024 3.75c0-.966.784-1.75 1.75-1.75H20.25c.966 0 1.75.784 1.75 1.75v11.498a1.75 1.75 0 0 1-1.75 1.75H8.774a1.75 1.75 0 0 1-1.75-1.75Zm1.75-.25a.25.25 0 0 0-.25.25v11.498c0 .139.112.25.25.25H20.25a.25.25 0 0 0 .25-.25V3.75a.25.25 0 0 0-.25-.25Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M1.995 10.749a1.75 1.75 0 0 1 1.75-1.751H5.25a.75.75 0 1 1 0 1.5H3.745a.25.25 0 0 0-.25.25L3.5 20.25c0 .138.111.25.25.25h9.5a.25.25 0 0 0 .25-.25v-1.51a.75.75 0 1 1 1.5 0v1.51A1.75 1.75 0 0 1 13.25 22h-9.5A1.75 1.75 0 0 1 2 20.25l-.005-9.501Z"
      }))
    }
  };
});
var DeviceMobileIcon = /* @__PURE__ */ createIconComponent("DeviceMobileIcon", "octicon octicon-device-mobile", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M3.75 0h8.5C13.216 0 14 .784 14 1.75v12.5A1.75 1.75 0 0 1 12.25 16h-8.5A1.75 1.75 0 0 1 2 14.25V1.75C2 .784 2.784 0 3.75 0ZM3.5 1.75v12.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25ZM8 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M10.25 5.25A.75.75 0 0 1 11 4.5h2A.75.75 0 0 1 13 6h-2a.75.75 0 0 1-.75-.75ZM12 19.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M4 2.75C4 1.784 4.784 1 5.75 1h12.5c.966 0 1.75.784 1.75 1.75v18.5A1.75 1.75 0 0 1 18.25 23H5.75A1.75 1.75 0 0 1 4 21.25Zm1.75-.25a.25.25 0 0 0-.25.25v18.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25Z"
      }))
    }
  };
});
var DiffAddedIcon = /* @__PURE__ */ createIconComponent("DiffAddedIcon", "octicon octicon-diff-added", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M2.75 1h10.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 13.25 15H2.75A1.75 1.75 0 0 1 1 13.25V2.75C1 1.784 1.784 1 2.75 1Zm10.5 1.5H2.75a.25.25 0 0 0-.25.25v10.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25V2.75a.25.25 0 0 0-.25-.25ZM8 4a.75.75 0 0 1 .75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5A.75.75 0 0 1 8 4Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M12.75 7a.75.75 0 0 0-1.5 0v4.25H7a.75.75 0 0 0 0 1.5h4.25V17a.75.75 0 0 0 1.5 0v-4.25H17a.75.75 0 0 0 0-1.5h-4.25V7Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M3.75 2A1.75 1.75 0 0 0 2 3.75v16.5c0 .966.784 1.75 1.75 1.75h16.5A1.75 1.75 0 0 0 22 20.25V3.75A1.75 1.75 0 0 0 20.25 2H3.75ZM3.5 3.75a.25.25 0 0 1 .25-.25h16.5a.25.25 0 0 1 .25.25v16.5a.25.25 0 0 1-.25.25H3.75a.25.25 0 0 1-.25-.25V3.75Z"
      }))
    }
  };
});
var DotFillIcon = /* @__PURE__ */ createIconComponent("DotFillIcon", "octicon octicon-dot-fill", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M8 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
      })
    }
  };
});
var FileIcon = /* @__PURE__ */ createIconComponent("FileIcon", "octicon octicon-file", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M2 1.75C2 .784 2.784 0 3.75 0h6.586c.464 0 .909.184 1.237.513l2.914 2.914c.329.328.513.773.513 1.237v9.586A1.75 1.75 0 0 1 13.25 16h-9.5A1.75 1.75 0 0 1 2 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25V6h-2.75A1.75 1.75 0 0 1 9 4.25V1.5Zm6.75.062V4.25c0 .138.112.25.25.25h2.688l-.011-.013-2.914-2.914-.013-.011Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M3 3a2 2 0 0 1 2-2h9.982a2 2 0 0 1 1.414.586l4.018 4.018A2 2 0 0 1 21 7.018V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Zm2-.5a.5.5 0 0 0-.5.5v18a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V8.5h-4a2 2 0 0 1-2-2v-4Zm10 0v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0-.146-.336l-4.018-4.018A.5.5 0 0 0 15 2.5Z"
      })
    }
  };
});
var FilterIcon = /* @__PURE__ */ createIconComponent("FilterIcon", "octicon octicon-filter", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M.75 3h14.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5ZM3 7.75A.75.75 0 0 1 3.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 3 7.75Zm3 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M2.75 6a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5H2.75ZM6 11.75a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1-.75-.75Zm4 4.938a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
      })
    }
  };
});
var FilterRemoveIcon = /* @__PURE__ */ createIconComponent("FilterRemoveIcon", "octicon octicon-filter-remove", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M14.384 4.57a.752.752 0 0 0 1.061 0 .752.752 0 0 0 0-1.061l-.884-.884.883-.884A.75.75 0 0 0 14.384.68l-.884.884-.884-.884a.75.75 0 0 0-1.06 1.061l.883.884-.883.884a.75.75 0 0 0 1.06 1.061l.884-.884.884.884ZM.75 3a.75.75 0 0 0 0 1.5H9A.75.75 0 0 0 9 3H.75ZM3 7.75A.75.75 0 0 1 3.75 7h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 3 7.75Zm3 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M21.587 9.273a.75.75 0 1 0 1.061-1.061l-1.591-1.591 1.591-1.591a.749.749 0 1 0-1.061-1.06l-1.591 1.591-1.591-1.591a.749.749 0 1 0-1.06 1.06l1.591 1.591-1.591 1.591a.75.75 0 0 0 1.06 1.061l1.591-1.591 1.591 1.591ZM1.75 6a.75.75 0 0 0 0 1.5H14.5a.75.75 0 0 0 0-1.5H1.75ZM5 11.75a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1-.75-.75Zm4 4.938a.75.75 0 0 1 .75-.75h2.5a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
      })
    }
  };
});
var FoldIcon = /* @__PURE__ */ createIconComponent("FoldIcon", "octicon octicon-fold", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M10.896 2H8.75V.75a.75.75 0 0 0-1.5 0V2H5.104a.25.25 0 0 0-.177.427l2.896 2.896a.25.25 0 0 0 .354 0l2.896-2.896A.25.25 0 0 0 10.896 2ZM8.75 15.25a.75.75 0 0 1-1.5 0V14H5.104a.25.25 0 0 1-.177-.427l2.896-2.896a.25.25 0 0 1 .354 0l2.896 2.896a.25.25 0 0 1-.177.427H8.75v1.25Zm-6.5-6.5a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM6 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 6 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM12 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 12 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M12 15c.199 0 .389.079.53.22l3.25 3.25a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L12 16.81l-2.72 2.72a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l3.25-3.25A.749.749 0 0 1 12 15Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M12.53 8.78a.75.75 0 0 1-1.06 0L8.22 5.53a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L12 7.19l2.72-2.72a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734ZM12 15.75a.75.75 0 0 1 .75.75v5.75a.75.75 0 0 1-1.5 0V16.5a.75.75 0 0 1 .75-.75Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M12 8.5a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-.75.75ZM2.75 12a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Z"
      }))
    }
  };
});
var GearIcon = /* @__PURE__ */ createIconComponent("GearIcon", "octicon octicon-gear", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M8 0a8.2 8.2 0 0 1 .701.031C9.444.095 9.99.645 10.16 1.29l.288 1.107c.018.066.079.158.212.224.231.114.454.243.668.386.123.082.233.09.299.071l1.103-.303c.644-.176 1.392.021 1.82.63.27.385.506.792.704 1.218.315.675.111 1.422-.364 1.891l-.814.806c-.049.048-.098.147-.088.294.016.257.016.515 0 .772-.01.147.038.246.088.294l.814.806c.475.469.679 1.216.364 1.891a7.977 7.977 0 0 1-.704 1.217c-.428.61-1.176.807-1.82.63l-1.102-.302c-.067-.019-.177-.011-.3.071a5.909 5.909 0 0 1-.668.386c-.133.066-.194.158-.211.224l-.29 1.106c-.168.646-.715 1.196-1.458 1.26a8.006 8.006 0 0 1-1.402 0c-.743-.064-1.289-.614-1.458-1.26l-.289-1.106c-.018-.066-.079-.158-.212-.224a5.738 5.738 0 0 1-.668-.386c-.123-.082-.233-.09-.299-.071l-1.103.303c-.644.176-1.392-.021-1.82-.63a8.12 8.12 0 0 1-.704-1.218c-.315-.675-.111-1.422.363-1.891l.815-.806c.05-.048.098-.147.088-.294a6.214 6.214 0 0 1 0-.772c.01-.147-.038-.246-.088-.294l-.815-.806C.635 6.045.431 5.298.746 4.623a7.92 7.92 0 0 1 .704-1.217c.428-.61 1.176-.807 1.82-.63l1.102.302c.067.019.177.011.3-.071.214-.143.437-.272.668-.386.133-.066.194-.158.211-.224l.29-1.106C6.009.645 6.556.095 7.299.03 7.53.01 7.764 0 8 0Zm-.571 1.525c-.036.003-.108.036-.137.146l-.289 1.105c-.147.561-.549.967-.998 1.189-.173.086-.34.183-.5.29-.417.278-.97.423-1.529.27l-1.103-.303c-.109-.03-.175.016-.195.045-.22.312-.412.644-.573.99-.014.031-.021.11.059.19l.815.806c.411.406.562.957.53 1.456a4.709 4.709 0 0 0 0 .582c.032.499-.119 1.05-.53 1.456l-.815.806c-.081.08-.073.159-.059.19.162.346.353.677.573.989.02.03.085.076.195.046l1.102-.303c.56-.153 1.113-.008 1.53.27.161.107.328.204.501.29.447.222.85.629.997 1.189l.289 1.105c.029.109.101.143.137.146a6.6 6.6 0 0 0 1.142 0c.036-.003.108-.036.137-.146l.289-1.105c.147-.561.549-.967.998-1.189.173-.086.34-.183.5-.29.417-.278.97-.423 1.529-.27l1.103.303c.109.029.175-.016.195-.045.22-.313.411-.644.573-.99.014-.031.021-.11-.059-.19l-.815-.806c-.411-.406-.562-.957-.53-1.456a4.709 4.709 0 0 0 0-.582c-.032-.499.119-1.05.53-1.456l.815-.806c.081-.08.073-.159.059-.19a6.464 6.464 0 0 0-.573-.989c-.02-.03-.085-.076-.195-.046l-1.102.303c-.56.153-1.113.008-1.53-.27a4.44 4.44 0 0 0-.501-.29c-.447-.222-.85-.629-.997-1.189l-.289-1.105c-.029-.11-.101-.143-.137-.146a6.6 6.6 0 0 0-1.142 0ZM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM9.5 8a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 9.5 8Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-1.5 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M12 1c.266 0 .532.009.797.028.763.055 1.345.617 1.512 1.304l.352 1.45c.019.078.09.171.225.221.247.089.49.19.728.302.13.061.246.044.315.002l1.275-.776c.603-.368 1.411-.353 1.99.147.402.349.78.726 1.128 1.129.501.578.515 1.386.147 1.99l-.776 1.274c-.042.069-.058.185.002.315.112.238.213.481.303.728.048.135.142.205.22.225l1.45.352c.687.167 1.249.749 1.303 1.512.038.531.038 1.063 0 1.594-.054.763-.616 1.345-1.303 1.512l-1.45.352c-.078.019-.171.09-.221.225-.089.248-.19.491-.302.728-.061.13-.044.246-.002.315l.776 1.275c.368.603.353 1.411-.147 1.99-.349.402-.726.78-1.129 1.128-.578.501-1.386.515-1.99.147l-1.274-.776c-.069-.042-.185-.058-.314.002a8.606 8.606 0 0 1-.729.303c-.135.048-.205.142-.225.22l-.352 1.45c-.167.687-.749 1.249-1.512 1.303-.531.038-1.063.038-1.594 0-.763-.054-1.345-.616-1.512-1.303l-.352-1.45c-.019-.078-.09-.171-.225-.221a8.138 8.138 0 0 1-.728-.302c-.13-.061-.246-.044-.315-.002l-1.275.776c-.603.368-1.411.353-1.99-.147-.402-.349-.78-.726-1.128-1.129-.501-.578-.515-1.386-.147-1.99l.776-1.274c.042-.069.058-.185-.002-.314a8.606 8.606 0 0 1-.303-.729c-.048-.135-.142-.205-.22-.225l-1.45-.352c-.687-.167-1.249-.749-1.304-1.512a11.158 11.158 0 0 1 0-1.594c.055-.763.617-1.345 1.304-1.512l1.45-.352c.078-.019.171-.09.221-.225.089-.248.19-.491.302-.728.061-.13.044-.246.002-.315l-.776-1.275c-.368-.603-.353-1.411.147-1.99.349-.402.726-.78 1.129-1.128.578-.501 1.386-.515 1.99-.147l1.274.776c.069.042.185.058.315-.002.238-.112.481-.213.728-.303.135-.048.205-.142.225-.22l.352-1.45c.167-.687.749-1.249 1.512-1.304C11.466 1.01 11.732 1 12 1Zm-.69 1.525c-.055.004-.135.05-.161.161l-.353 1.45a1.832 1.832 0 0 1-1.172 1.277 7.147 7.147 0 0 0-.6.249 1.833 1.833 0 0 1-1.734-.074l-1.274-.776c-.098-.06-.186-.036-.228 0a9.774 9.774 0 0 0-.976.976c-.036.042-.06.131 0 .228l.776 1.274c.314.529.342 1.18.074 1.734a7.147 7.147 0 0 0-.249.6 1.831 1.831 0 0 1-1.278 1.173l-1.45.351c-.11.027-.156.107-.16.162a9.63 9.63 0 0 0 0 1.38c.004.055.05.135.161.161l1.45.353a1.832 1.832 0 0 1 1.277 1.172c.074.204.157.404.249.6.268.553.24 1.204-.074 1.733l-.776 1.275c-.06.098-.036.186 0 .228.301.348.628.675.976.976.042.036.131.06.228 0l1.274-.776a1.83 1.83 0 0 1 1.734-.075c.196.093.396.176.6.25a1.831 1.831 0 0 1 1.173 1.278l.351 1.45c.027.11.107.156.162.16a9.63 9.63 0 0 0 1.38 0c.055-.004.135-.05.161-.161l.353-1.45a1.834 1.834 0 0 1 1.172-1.278 6.82 6.82 0 0 0 .6-.248 1.831 1.831 0 0 1 1.733.074l1.275.776c.098.06.186.036.228 0 .348-.301.675-.628.976-.976.036-.042.06-.131 0-.228l-.776-1.275a1.834 1.834 0 0 1-.075-1.733c.093-.196.176-.396.25-.6a1.831 1.831 0 0 1 1.278-1.173l1.45-.351c.11-.027.156-.107.16-.162a9.63 9.63 0 0 0 0-1.38c-.004-.055-.05-.135-.161-.161l-1.45-.353c-.626-.152-1.08-.625-1.278-1.172a6.576 6.576 0 0 0-.248-.6 1.833 1.833 0 0 1 .074-1.734l.776-1.274c.06-.098.036-.186 0-.228a9.774 9.774 0 0 0-.976-.976c-.042-.036-.131-.06-.228 0l-1.275.776a1.831 1.831 0 0 1-1.733.074 6.88 6.88 0 0 0-.6-.249 1.835 1.835 0 0 1-1.173-1.278l-.351-1.45c-.027-.11-.107-.156-.162-.16a9.63 9.63 0 0 0-1.38 0Z"
      }))
    }
  };
});
var GrabberIcon = /* @__PURE__ */ createIconComponent("GrabberIcon", "octicon octicon-grabber", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M10 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0-4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-4 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm5-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M9 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm6 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
      })
    }
  };
});
var HistoryIcon = /* @__PURE__ */ createIconComponent("HistoryIcon", "octicon octicon-history", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "m.427 1.927 1.215 1.215a8.002 8.002 0 1 1-1.6 5.685.75.75 0 1 1 1.493-.154 6.5 6.5 0 1 0 1.18-4.458l1.358 1.358A.25.25 0 0 1 3.896 6H.25A.25.25 0 0 1 0 5.75V2.104a.25.25 0 0 1 .427-.177ZM7.75 4a.75.75 0 0 1 .75.75v2.992l2.028.812a.75.75 0 0 1-.557 1.392l-2.5-1A.751.751 0 0 1 7 8.25v-3.5A.75.75 0 0 1 7.75 4Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M11.998 2.5A9.503 9.503 0 0 0 3.378 8H5.75a.75.75 0 0 1 0 1.5H2a1 1 0 0 1-1-1V4.75a.75.75 0 0 1 1.5 0v1.697A10.997 10.997 0 0 1 11.998 1C18.074 1 23 5.925 23 12s-4.926 11-11.002 11C6.014 23 1.146 18.223 1 12.275a.75.75 0 0 1 1.5-.037 9.5 9.5 0 0 0 9.498 9.262c5.248 0 9.502-4.253 9.502-9.5s-4.254-9.5-9.502-9.5Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M12.5 7.25a.75.75 0 0 0-1.5 0v5.5c0 .27.144.518.378.651l3.5 2a.75.75 0 0 0 .744-1.302L12.5 12.315V7.25Z"
      }))
    }
  };
});
var HomeIcon = /* @__PURE__ */ createIconComponent("HomeIcon", "octicon octicon-home", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M6.906.664a1.749 1.749 0 0 1 2.187 0l5.25 4.2c.415.332.657.835.657 1.367v7.019A1.75 1.75 0 0 1 13.25 15h-3.5a.75.75 0 0 1-.75-.75V9H7v5.25a.75.75 0 0 1-.75.75h-3.5A1.75 1.75 0 0 1 1 13.25V6.23c0-.531.242-1.034.657-1.366l5.25-4.2Zm1.25 1.171a.25.25 0 0 0-.312 0l-5.25 4.2a.25.25 0 0 0-.094.196v7.019c0 .138.112.25.25.25H5.5V8.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v5.25h2.75a.25.25 0 0 0 .25-.25V6.23a.25.25 0 0 0-.094-.195Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M11.03 2.59a1.501 1.501 0 0 1 1.94 0l7.5 6.363a1.5 1.5 0 0 1 .53 1.144V19.5a1.5 1.5 0 0 1-1.5 1.5h-5.75a.75.75 0 0 1-.75-.75V14h-2v6.25a.75.75 0 0 1-.75.75H4.5A1.5 1.5 0 0 1 3 19.5v-9.403c0-.44.194-.859.53-1.144ZM12 3.734l-7.5 6.363V19.5h5v-6.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v6.25h5v-9.403Z"
      })
    }
  };
});
var HorizontalRuleIcon = /* @__PURE__ */ createIconComponent("HorizontalRuleIcon", "octicon octicon-horizontal-rule", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M0 7.75A.75.75 0 0 1 .75 7h14.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 7.75Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M2 12.75a.75.75 0 0 1 .75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z"
      })
    }
  };
});
var InfoIcon = /* @__PURE__ */ createIconComponent("InfoIcon", "octicon octicon-info", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM6.5 7.75A.75.75 0 0 1 7.25 7h1a.75.75 0 0 1 .75.75v2.75h.25a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1 0-1.5h.25v-2h-.25a.75.75 0 0 1-.75-.75ZM8 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M13 7.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-3 3.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v4.25h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75V12h-.75a.75.75 0 0 1-.75-.75Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
      }))
    }
  };
});
var ItalicIcon = /* @__PURE__ */ createIconComponent("ItalicIcon", "octicon octicon-italic", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M6 2.75A.75.75 0 0 1 6.75 2h6.5a.75.75 0 0 1 0 1.5h-2.505l-3.858 9H9.25a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h2.505l3.858-9H6.75A.75.75 0 0 1 6 2.75Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M10 4.75a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-3.514l-5.828 13h3.342a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5h3.514l5.828-13H10.75a.75.75 0 0 1-.75-.75Z"
      })
    }
  };
});
var KebabHorizontalIcon = /* @__PURE__ */ createIconComponent("KebabHorizontalIcon", "octicon octicon-kebab-horizontal", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M8 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM1.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm13 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M20 14a2 2 0 1 1-.001-3.999A2 2 0 0 1 20 14ZM6 12a2 2 0 1 1-3.999.001A2 2 0 0 1 6 12Zm8 0a2 2 0 1 1-3.999.001A2 2 0 0 1 14 12Z"
      })
    }
  };
});
var LinkIcon = /* @__PURE__ */ createIconComponent("LinkIcon", "octicon octicon-link", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "m7.775 3.275 1.25-1.25a3.5 3.5 0 1 1 4.95 4.95l-2.5 2.5a3.5 3.5 0 0 1-4.95 0 .751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018 1.998 1.998 0 0 0 2.83 0l2.5-2.5a2.002 2.002 0 0 0-2.83-2.83l-1.25 1.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042Zm-4.69 9.64a1.998 1.998 0 0 0 2.83 0l1.25-1.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-1.25 1.25a3.5 3.5 0 1 1-4.95-4.95l2.5-2.5a3.5 3.5 0 0 1 4.95 0 .751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018 1.998 1.998 0 0 0-2.83 0l-2.5 2.5a1.998 1.998 0 0 0 0 2.83Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M14.78 3.653a3.936 3.936 0 1 1 5.567 5.567l-3.627 3.627a3.936 3.936 0 0 1-5.88-.353.75.75 0 0 0-1.18.928 5.436 5.436 0 0 0 8.12.486l3.628-3.628a5.436 5.436 0 1 0-7.688-7.688l-3 3a.75.75 0 0 0 1.06 1.061l3-3Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M7.28 11.153a3.936 3.936 0 0 1 5.88.353.75.75 0 0 0 1.18-.928 5.436 5.436 0 0 0-8.12-.486L2.592 13.72a5.436 5.436 0 1 0 7.688 7.688l3-3a.75.75 0 1 0-1.06-1.06l-3 3a3.936 3.936 0 0 1-5.567-5.568l3.627-3.627Z"
      }))
    }
  };
});
var LinkExternalIcon = /* @__PURE__ */ createIconComponent("LinkExternalIcon", "octicon octicon-link-external", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M3.75 2h3.5a.75.75 0 0 1 0 1.5h-3.5a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-3.5a.75.75 0 0 1 1.5 0v3.5A1.75 1.75 0 0 1 12.25 14h-8.5A1.75 1.75 0 0 1 2 12.25v-8.5C2 2.784 2.784 2 3.75 2Zm6.854-1h4.146a.25.25 0 0 1 .25.25v4.146a.25.25 0 0 1-.427.177L13.03 4.03 9.28 7.78a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042l3.75-3.75-1.543-1.543A.25.25 0 0 1 10.604 1Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M15.5 2.25a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V4.06l-6.22 6.22a.75.75 0 1 1-1.06-1.06L19.94 3h-3.69a.75.75 0 0 1-.75-.75Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M2.5 4.25c0-.966.784-1.75 1.75-1.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.25.25 0 0 0-.25.25v15.5c0 .138.112.25.25.25h15.5a.25.25 0 0 0 .25-.25v-8.5a.75.75 0 0 1 1.5 0v8.5a1.75 1.75 0 0 1-1.75 1.75H4.25a1.75 1.75 0 0 1-1.75-1.75V4.25Z"
      }))
    }
  };
});
var ListOrderedIcon = /* @__PURE__ */ createIconComponent("ListOrderedIcon", "octicon octicon-list-ordered", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M5 3.25a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 5 3.25Zm0 5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 5 8.25Zm0 5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75ZM.924 10.32a.5.5 0 0 1-.851-.525l.001-.001.001-.002.002-.004.007-.011c.097-.144.215-.273.348-.384.228-.19.588-.392 1.068-.392.468 0 .858.181 1.126.484.259.294.377.673.377 1.038 0 .987-.686 1.495-1.156 1.845l-.047.035c-.303.225-.522.4-.654.597h1.357a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5c0-1.005.692-1.52 1.167-1.875l.035-.025c.531-.396.8-.625.8-1.078a.57.57 0 0 0-.128-.376C1.806 10.068 1.695 10 1.5 10a.658.658 0 0 0-.429.163.835.835 0 0 0-.144.153ZM2.003 2.5V6h.503a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1h.503V3.308l-.28.14a.5.5 0 0 1-.446-.895l1.003-.5a.5.5 0 0 1 .723.447Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M3.604 3.089A.75.75 0 0 1 4 3.75V8.5h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 1 1 0-1.5h.75V5.151l-.334.223a.75.75 0 0 1-.832-1.248l1.5-1a.75.75 0 0 1 .77-.037ZM8.75 5.5a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H8.75Zm0 6a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H8.75Zm0 6a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H8.75ZM5.5 15.75c0-.704-.271-1.286-.72-1.686a2.302 2.302 0 0 0-1.53-.564c-.535 0-1.094.178-1.53.565-.449.399-.72.982-.72 1.685a.75.75 0 0 0 1.5 0c0-.296.104-.464.217-.564A.805.805 0 0 1 3.25 15c.215 0 .406.072.533.185.113.101.217.268.217.565 0 .332-.069.48-.21.657-.092.113-.216.24-.403.419l-.147.14c-.152.144-.33.313-.52.504l-1.5 1.5a.75.75 0 0 0-.22.53v.25c0 .414.336.75.75.75H5A.75.75 0 0 0 5 19H3.31l.47-.47c.176-.176.333-.324.48-.465l.165-.156a5.98 5.98 0 0 0 .536-.566c.358-.447.539-.925.539-1.593Z"
      })
    }
  };
});
var ListUnorderedIcon = /* @__PURE__ */ createIconComponent("ListUnorderedIcon", "octicon octicon-list-unordered", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M5.75 2.5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5Zm0 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5Zm0 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5ZM2 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM2 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M8.75 5.5h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5Zm0 6h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5Zm0 6h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1 0-1.5ZM5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM4 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
      })
    }
  };
});
var LockIcon = /* @__PURE__ */ createIconComponent("LockIcon", "octicon octicon-lock", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M4 4a4 4 0 0 1 8 0v2h.25c.966 0 1.75.784 1.75 1.75v5.5A1.75 1.75 0 0 1 12.25 15h-8.5A1.75 1.75 0 0 1 2 13.25v-5.5C2 6.784 2.784 6 3.75 6H4Zm8.25 3.5h-8.5a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-5.5a.25.25 0 0 0-.25-.25ZM10.5 6V4a2.5 2.5 0 1 0-5 0v2Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M6 9V7.25C6 3.845 8.503 1 12 1s6 2.845 6 6.25V9h.5a2.5 2.5 0 0 1 2.5 2.5v8a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 19.5v-8A2.5 2.5 0 0 1 5.5 9Zm-1.5 2.5v8a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-13a1 1 0 0 0-1 1Zm3-4.25V9h9V7.25c0-2.67-1.922-4.75-4.5-4.75-2.578 0-4.5 2.08-4.5 4.75Z"
      })
    }
  };
});
var MailIcon = /* @__PURE__ */ createIconComponent("MailIcon", "octicon octicon-mail", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25v-8.5C0 2.784.784 2 1.75 2ZM1.5 12.251c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V5.809L8.38 9.397a.75.75 0 0 1-.76 0L1.5 5.809v6.442Zm13-8.181v-.32a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25v.32L8 7.88Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14a1.75 1.75 0 0 1-1.75 1.75H1.75A1.75 1.75 0 0 1 0 18.75v-14C0 3.784.784 3 1.75 3ZM1.5 7.412V18.75c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V7.412l-9.52 6.433c-.592.4-1.368.4-1.96 0Zm0-2.662v.852l10.36 7a.25.25 0 0 0 .28 0l10.36-7V4.75a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Z"
      })
    }
  };
});
var MilestoneIcon = /* @__PURE__ */ createIconComponent("MilestoneIcon", "octicon octicon-milestone", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M7.75 0a.75.75 0 0 1 .75.75V3h3.634c.414 0 .814.147 1.13.414l2.07 1.75a1.75 1.75 0 0 1 0 2.672l-2.07 1.75a1.75 1.75 0 0 1-1.13.414H8.5v5.25a.75.75 0 0 1-1.5 0V10H2.75A1.75 1.75 0 0 1 1 8.25v-3.5C1 3.784 1.784 3 2.75 3H7V.75A.75.75 0 0 1 7.75 0Zm4.384 8.5a.25.25 0 0 0 .161-.06l2.07-1.75a.248.248 0 0 0 0-.38l-2.07-1.75a.25.25 0 0 0-.161-.06H2.75a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h9.384Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M11.75 1a.75.75 0 0 1 .75.75V4h6.532c.42 0 .826.15 1.143.425l3.187 2.75a1.75 1.75 0 0 1 0 2.65l-3.187 2.75a1.75 1.75 0 0 1-1.143.425H12.5v9.25a.75.75 0 0 1-1.5 0V13H3.75A1.75 1.75 0 0 1 2 11.25v-5.5C2 4.783 2.784 4 3.75 4H11V1.75a.75.75 0 0 1 .75-.75Zm7.282 4.5H3.75a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h15.282c.06 0 .118-.021.163-.06l3.188-2.75a.248.248 0 0 0 0-.38l-3.188-2.75a.249.249 0 0 0-.163-.06Z"
      })
    }
  };
});
var MoveToEndIcon = /* @__PURE__ */ createIconComponent("MoveToEndIcon", "octicon octicon-move-to-end", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "m10.78 8.53-3.75 3.75a.749.749 0 1 1-1.06-1.06l2.469-2.47H1.75a.75.75 0 0 1 0-1.5h6.689L5.97 4.78a.749.749 0 1 1 1.06-1.06l3.75 3.75a.749.749 0 0 1 0 1.06ZM13 12.25v-8.5a.75.75 0 0 1 1.5 0v8.5a.75.75 0 0 1-1.5 0Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M11.22 5.22a.749.749 0 0 1 1.06 0l6.25 6.25a.749.749 0 0 1 0 1.06l-6.25 6.25a.749.749 0 1 1-1.06-1.06l4.969-4.97H1.75a.75.75 0 0 1 0-1.5h14.439L11.22 6.28a.749.749 0 0 1 0-1.06Zm10.03-1.47a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0v-15a.75.75 0 0 1 .75-.75Z"
      })
    }
  };
});
var MoveToStartIcon = /* @__PURE__ */ createIconComponent("MoveToStartIcon", "octicon octicon-move-to-start", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M5.22 7.47a.749.749 0 0 0 0 1.06l3.75 3.75a.749.749 0 1 0 1.06-1.06L7.561 8.75h6.689a.75.75 0 0 0 0-1.5H7.561l2.469-2.47a.749.749 0 1 0-1.06-1.06L5.22 7.47ZM3 3.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0v-8.5Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M12.78 18.78a.749.749 0 0 1-1.06 0l-6.25-6.25a.749.749 0 0 1 0-1.06l6.25-6.25a.749.749 0 1 1 1.06 1.06l-4.969 4.97H22.25a.75.75 0 0 1 0 1.5H7.811l4.969 4.97a.749.749 0 0 1 0 1.06ZM2.75 3.75a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0v-15a.75.75 0 0 1 .75-.75Z"
      })
    }
  };
});
var NoteIcon = /* @__PURE__ */ createIconComponent("NoteIcon", "octicon octicon-note", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M0 3.75C0 2.784.784 2 1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25Zm1.75-.25a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25ZM3.5 6.25a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75Zm.75 2.25h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M0 4.75C0 3.784.784 3 1.75 3h20.5c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0 1 22.25 21H1.75A1.75 1.75 0 0 1 0 19.25Zm1.75-.25a.25.25 0 0 0-.25.25v14.5c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V4.75a.25.25 0 0 0-.25-.25Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M5 8.75A.75.75 0 0 1 5.75 8h11.5a.75.75 0 0 1 0 1.5H5.75A.75.75 0 0 1 5 8.75Zm0 4a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Z"
      }))
    }
  };
});
var NumberIcon = /* @__PURE__ */ createIconComponent("NumberIcon", "octicon octicon-number", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M9 4.75A.75.75 0 0 1 9.75 4h4a.75.75 0 0 1 .53 1.28l-1.89 1.892c.312.076.604.18.867.319.742.391 1.244 1.063 1.244 2.005 0 .653-.231 1.208-.629 1.627-.386.408-.894.653-1.408.777-1.01.243-2.225.063-3.124-.527a.751.751 0 0 1 .822-1.254c.534.35 1.32.474 1.951.322.306-.073.53-.201.67-.349.129-.136.218-.32.218-.596 0-.308-.123-.509-.444-.678-.373-.197-.98-.318-1.806-.318a.75.75 0 0 1-.53-1.28l1.72-1.72H9.75A.75.75 0 0 1 9 4.75Zm-3.587 5.763c-.35-.05-.77.113-.983.572a.75.75 0 1 1-1.36-.632c.508-1.094 1.589-1.565 2.558-1.425 1 .145 1.872.945 1.872 2.222 0 1.433-1.088 2.192-1.79 2.681-.308.216-.571.397-.772.573H7a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75c0-.69.3-1.211.67-1.61.348-.372.8-.676 1.15-.92.8-.56 1.18-.904 1.18-1.474 0-.473-.267-.69-.587-.737ZM5.604.089A.75.75 0 0 1 6 .75v4.77h.711a.75.75 0 0 1 0 1.5H3.759a.75.75 0 0 1 0-1.5H4.5V2.15l-.334.223a.75.75 0 0 1-.832-1.248l1.5-1a.75.75 0 0 1 .77-.037Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M13.003 7.754a.75.75 0 0 1 .75-.75h5.232a.75.75 0 0 1 .53 1.28l-2.776 2.777c.55.097 1.057.253 1.492.483.905.477 1.504 1.284 1.504 2.418 0 .966-.471 1.75-1.172 2.27-.687.511-1.587.77-2.521.77-1.367 0-2.274-.528-2.667-.756a.75.75 0 0 1 .755-1.297c.331.193.953.553 1.912.553.673 0 1.243-.188 1.627-.473.37-.275.566-.635.566-1.067 0-.5-.219-.836-.703-1.091-.538-.284-1.375-.443-2.471-.443a.75.75 0 0 1-.53-1.28l2.643-2.644h-3.421a.75.75 0 0 1-.75-.75ZM7.88 15.215a1.4 1.4 0 0 0-1.446.83.75.75 0 0 1-1.37-.61 2.899 2.899 0 0 1 2.986-1.71c.589.06 1.139.323 1.557.743.434.446.685 1.058.685 1.778 0 1.641-1.254 2.437-2.12 2.986-.538.341-1.18.694-1.495 1.273H9.75a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75c0-1.799 1.337-2.63 2.243-3.21 1.032-.659 1.55-1.031 1.55-1.8 0-.355-.116-.584-.26-.732a1.071 1.071 0 0 0-.652-.298Zm.234-13.121a.75.75 0 0 1 .386.656V9h1.252a.75.75 0 0 1 0 1.5H5.75a.75.75 0 0 1 0-1.5H7V4.103l-.853.533a.749.749 0 1 1-.795-1.272l2-1.25a.749.749 0 0 1 .762-.02Z"
      })
    }
  };
});
var PencilIcon = /* @__PURE__ */ createIconComponent("PencilIcon", "octicon octicon-pencil", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M11.013 1.427a1.75 1.75 0 0 1 2.474 0l1.086 1.086a1.75 1.75 0 0 1 0 2.474l-8.61 8.61c-.21.21-.47.364-.756.445l-3.251.93a.75.75 0 0 1-.927-.928l.929-3.25c.081-.286.235-.547.445-.758l8.61-8.61Zm.176 4.823L9.75 4.81l-6.286 6.287a.253.253 0 0 0-.064.108l-.558 1.953 1.953-.558a.253.253 0 0 0 .108-.064Zm1.238-3.763a.25.25 0 0 0-.354 0L10.811 3.75l1.439 1.44 1.263-1.263a.25.25 0 0 0 0-.354Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M17.263 2.177a1.75 1.75 0 0 1 2.474 0l2.586 2.586a1.75 1.75 0 0 1 0 2.474L19.53 10.03l-.012.013L8.69 20.378a1.753 1.753 0 0 1-.699.409l-5.523 1.68a.748.748 0 0 1-.747-.188.748.748 0 0 1-.188-.747l1.673-5.5a1.75 1.75 0 0 1 .466-.756L14.476 4.963ZM4.708 16.361a.26.26 0 0 0-.067.108l-1.264 4.154 4.177-1.271a.253.253 0 0 0 .1-.059l10.273-9.806-2.94-2.939-10.279 9.813ZM19 8.44l2.263-2.262a.25.25 0 0 0 0-.354l-2.586-2.586a.25.25 0 0 0-.354 0L16.061 5.5Z"
      })
    }
  };
});
var PinIcon = /* @__PURE__ */ createIconComponent("PinIcon", "octicon octicon-pin", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "m11.294.984 3.722 3.722a1.75 1.75 0 0 1-.504 2.826l-1.327.613a3.089 3.089 0 0 0-1.707 2.084l-.584 2.454c-.317 1.332-1.972 1.8-2.94.832L5.75 11.311 1.78 15.28a.749.749 0 1 1-1.06-1.06l3.969-3.97-2.204-2.204c-.968-.968-.5-2.623.832-2.94l2.454-.584a3.08 3.08 0 0 0 2.084-1.707l.613-1.327a1.75 1.75 0 0 1 2.826-.504ZM6.283 9.723l2.732 2.731a.25.25 0 0 0 .42-.119l.584-2.454a4.586 4.586 0 0 1 2.537-3.098l1.328-.613a.25.25 0 0 0 .072-.404l-3.722-3.722a.25.25 0 0 0-.404.072l-.613 1.328a4.584 4.584 0 0 1-3.098 2.537l-2.454.584a.25.25 0 0 0-.119.42l2.731 2.732Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "m16.114 1.553 6.333 6.333a1.75 1.75 0 0 1-.603 2.869l-1.63.633a5.67 5.67 0 0 0-3.395 3.725l-1.131 3.959a1.75 1.75 0 0 1-2.92.757L9 16.061l-5.595 5.594a.749.749 0 1 1-1.06-1.06L7.939 15l-3.768-3.768a1.75 1.75 0 0 1 .757-2.92l3.959-1.131a5.666 5.666 0 0 0 3.725-3.395l.633-1.63a1.75 1.75 0 0 1 2.869-.603ZM5.232 10.171l8.597 8.597a.25.25 0 0 0 .417-.108l1.131-3.959A7.17 7.17 0 0 1 19.67 9.99l1.63-.634a.25.25 0 0 0 .086-.409l-6.333-6.333a.25.25 0 0 0-.409.086l-.634 1.63a7.17 7.17 0 0 1-4.711 4.293L5.34 9.754a.25.25 0 0 0-.108.417Z"
      })
    }
  };
});
var PlayIcon = /* @__PURE__ */ createIconComponent("PlayIcon", "octicon octicon-play", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm4.879-2.773 4.264 2.559a.25.25 0 0 1 0 .428l-4.264 2.559A.25.25 0 0 1 6 10.559V5.442a.25.25 0 0 1 .379-.215Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M9.5 15.584V8.416a.5.5 0 0 1 .77-.42l5.576 3.583a.5.5 0 0 1 0 .842l-5.576 3.584a.5.5 0 0 1-.77-.42Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm11-9.5A9.5 9.5 0 0 0 2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5Z"
      }))
    }
  };
});
var PlusIcon = /* @__PURE__ */ createIconComponent("PlusIcon", "octicon octicon-plus", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M7.75 2a.75.75 0 0 1 .75.75V7h4.25a.75.75 0 0 1 0 1.5H8.5v4.25a.75.75 0 0 1-1.5 0V8.5H2.75a.75.75 0 0 1 0-1.5H7V2.75A.75.75 0 0 1 7.75 2Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M11.75 4.5a.75.75 0 0 1 .75.75V11h5.75a.75.75 0 0 1 0 1.5H12.5v5.75a.75.75 0 0 1-1.5 0V12.5H5.25a.75.75 0 0 1 0-1.5H11V5.25a.75.75 0 0 1 .75-.75Z"
      })
    }
  };
});
var QuestionIcon = /* @__PURE__ */ createIconComponent("QuestionIcon", "octicon octicon-question", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM6.92 6.085h.001a.749.749 0 1 1-1.342-.67c.169-.339.436-.701.849-.977C6.845 4.16 7.369 4 8 4a2.756 2.756 0 0 1 1.637.525c.503.377.863.965.863 1.725 0 .448-.115.83-.329 1.15-.205.307-.47.513-.692.662-.109.072-.22.138-.313.195l-.006.004a6.24 6.24 0 0 0-.26.16.952.952 0 0 0-.276.245.75.75 0 0 1-1.248-.832c.184-.264.42-.489.692-.661.103-.067.207-.132.313-.195l.007-.004c.1-.061.182-.11.258-.161a.969.969 0 0 0 .277-.245C8.96 6.514 9 6.427 9 6.25a.612.612 0 0 0-.262-.525A1.27 1.27 0 0 0 8 5.5c-.369 0-.595.09-.74.187a1.01 1.01 0 0 0-.34.398ZM9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M10.97 8.265a1.45 1.45 0 0 0-.487.57.75.75 0 0 1-1.341-.67c.2-.402.513-.826.997-1.148C10.627 6.69 11.244 6.5 12 6.5c.658 0 1.369.195 1.934.619a2.45 2.45 0 0 1 1.004 2.006c0 1.033-.513 1.72-1.027 2.215-.19.183-.399.358-.579.508l-.147.123a4.329 4.329 0 0 0-.435.409v1.37a.75.75 0 1 1-1.5 0v-1.473c0-.237.067-.504.247-.736.22-.28.486-.517.718-.714l.183-.153.001-.001c.172-.143.324-.27.47-.412.368-.355.569-.676.569-1.136a.953.953 0 0 0-.404-.806C12.766 8.118 12.384 8 12 8c-.494 0-.814.121-1.03.265ZM13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
      }))
    }
  };
});
var QuoteIcon = /* @__PURE__ */ createIconComponent("QuoteIcon", "octicon octicon-quote", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M1.75 2.5h10.5a.75.75 0 0 1 0 1.5H1.75a.75.75 0 0 1 0-1.5Zm4 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5Zm0 5h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5ZM2.5 7.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 1.5 0Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M3 6.25a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.25Zm5 6.063a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75Zm0 5.937a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75ZM3.75 11a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7a.75.75 0 0 1 .75-.75Z"
      })
    }
  };
});
var ReplyIcon = /* @__PURE__ */ createIconComponent("ReplyIcon", "octicon octicon-reply", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M6.78 1.97a.75.75 0 0 1 0 1.06L3.81 6h6.44A4.75 4.75 0 0 1 15 10.75v2.5a.75.75 0 0 1-1.5 0v-2.5a3.25 3.25 0 0 0-3.25-3.25H3.81l2.97 2.97a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L1.47 7.28a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M10.53 5.03a.75.75 0 1 0-1.06-1.06l-6.25 6.25a.75.75 0 0 0 0 1.06l6.25 6.25a.75.75 0 1 0 1.06-1.06L5.56 11.5H17a3.248 3.248 0 0 1 3.25 3.248v4.502a.75.75 0 0 0 1.5 0v-4.502A4.748 4.748 0 0 0 17 10H5.56l4.97-4.97Z"
      })
    }
  };
});
var ScreenFullIcon = /* @__PURE__ */ createIconComponent("ScreenFullIcon", "octicon octicon-screen-full", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M1.75 10a.75.75 0 0 1 .75.75v2.5c0 .138.112.25.25.25h2.5a.75.75 0 0 1 0 1.5h-2.5A1.75 1.75 0 0 1 1 13.25v-2.5a.75.75 0 0 1 .75-.75Zm12.5 0a.75.75 0 0 1 .75.75v2.5A1.75 1.75 0 0 1 13.25 15h-2.5a.75.75 0 0 1 0-1.5h2.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 .75-.75ZM2.75 2.5a.25.25 0 0 0-.25.25v2.5a.75.75 0 0 1-1.5 0v-2.5C1 1.784 1.784 1 2.75 1h2.5a.75.75 0 0 1 0 1.5ZM10 1.75a.75.75 0 0 1 .75-.75h2.5c.966 0 1.75.784 1.75 1.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.25.25 0 0 0-.25-.25h-2.5a.75.75 0 0 1-.75-.75Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M3.75 15a.75.75 0 0 1 .75.75v3.5c0 .138.112.25.25.25h3.5a.75.75 0 0 1 0 1.5h-3.5A1.75 1.75 0 0 1 3 19.25v-3.5a.75.75 0 0 1 .75-.75Zm16.5 0a.75.75 0 0 1 .75.75v3.5A1.75 1.75 0 0 1 19.25 21h-3.5a.75.75 0 0 1 0-1.5h3.5a.25.25 0 0 0 .25-.25v-3.5a.75.75 0 0 1 .75-.75ZM4.75 4.5a.25.25 0 0 0-.25.25v3.5a.75.75 0 0 1-1.5 0v-3.5C3 3.784 3.784 3 4.75 3h3.5a.75.75 0 0 1 0 1.5ZM15 3.75a.75.75 0 0 1 .75-.75h3.5c.966 0 1.75.784 1.75 1.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.25.25 0 0 0-.25-.25h-3.5a.75.75 0 0 1-.75-.75Z"
      })
    }
  };
});
var SearchIcon = /* @__PURE__ */ createIconComponent("SearchIcon", "octicon octicon-search", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M10.68 11.74a6 6 0 0 1-7.922-8.982 6 6 0 0 1 8.982 7.922l3.04 3.04a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215ZM11.5 7a4.499 4.499 0 1 0-8.997 0A4.499 4.499 0 0 0 11.5 7Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M10.25 2a8.25 8.25 0 0 1 6.34 13.53l5.69 5.69a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215l-5.69-5.69A8.25 8.25 0 1 1 10.25 2ZM3.5 10.25a6.75 6.75 0 1 0 13.5 0 6.75 6.75 0 0 0-13.5 0Z"
      })
    }
  };
});
var ServerIcon = /* @__PURE__ */ createIconComponent("ServerIcon", "octicon octicon-server", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M1.75 1h12.5c.966 0 1.75.784 1.75 1.75v4c0 .372-.116.717-.314 1 .198.283.314.628.314 1v4a1.75 1.75 0 0 1-1.75 1.75H1.75A1.75 1.75 0 0 1 0 12.75v-4c0-.358.109-.707.314-1a1.739 1.739 0 0 1-.314-1v-4C0 1.784.784 1 1.75 1ZM1.5 2.75v4c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Zm.25 5.75a.25.25 0 0 0-.25.25v4c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25ZM7 4.75A.75.75 0 0 1 7.75 4h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 7 4.75ZM7.75 10h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5ZM3 4.75A.75.75 0 0 1 3.75 4h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 4.75ZM3.75 10h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M10.75 6.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5ZM6 7.25a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 6 7.25Zm4 9a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Zm-3.25-.75a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M3.25 2h17.5c.966 0 1.75.784 1.75 1.75v7c0 .372-.116.716-.314 1 .198.284.314.628.314 1v7a1.75 1.75 0 0 1-1.75 1.75H3.25a1.75 1.75 0 0 1-1.75-1.75v-7c0-.358.109-.707.314-1a1.741 1.741 0 0 1-.314-1v-7C1.5 2.784 2.284 2 3.25 2Zm0 10.5a.25.25 0 0 0-.25.25v7c0 .138.112.25.25.25h17.5a.25.25 0 0 0 .25-.25v-7a.25.25 0 0 0-.25-.25Zm0-1.5h17.5a.25.25 0 0 0 .25-.25v-7a.25.25 0 0 0-.25-.25H3.25a.25.25 0 0 0-.25.25v7c0 .138.112.25.25.25Z"
      }))
    }
  };
});
var SmileyIcon = /* @__PURE__ */ createIconComponent("SmileyIcon", "octicon octicon-smiley", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm3.82 1.636a.75.75 0 0 1 1.038.175l.007.009c.103.118.22.222.35.31.264.178.683.37 1.285.37.602 0 1.02-.192 1.285-.371.13-.088.247-.192.35-.31l.007-.008a.75.75 0 0 1 1.222.87l-.022-.015c.02.013.021.015.021.015v.001l-.001.002-.002.003-.005.007-.014.019a2.066 2.066 0 0 1-.184.213c-.16.166-.338.316-.53.445-.63.418-1.37.638-2.127.629-.946 0-1.652-.308-2.126-.63a3.331 3.331 0 0 1-.715-.657l-.014-.02-.005-.006-.002-.003v-.002h-.001l.613-.432-.614.43a.75.75 0 0 1 .183-1.044ZM12 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM5 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm5.25 2.25.592.416a97.71 97.71 0 0 0-.592-.416Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M8.456 14.494a.75.75 0 0 1 1.068.17 3.08 3.08 0 0 0 .572.492A3.381 3.381 0 0 0 12 15.72c.855 0 1.487-.283 1.904-.562a3.081 3.081 0 0 0 .572-.492l.021-.026a.75.75 0 0 1 1.197.905l-.027.034c-.013.016-.03.038-.052.063-.044.05-.105.119-.184.198a4.569 4.569 0 0 1-.695.566A4.88 4.88 0 0 1 12 17.22a4.88 4.88 0 0 1-2.736-.814 4.57 4.57 0 0 1-.695-.566 3.253 3.253 0 0 1-.236-.261c-.259-.332-.223-.824.123-1.084Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1ZM2.5 12a9.5 9.5 0 0 0 9.5 9.5 9.5 9.5 0 0 0 9.5-9.5A9.5 9.5 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M9 10.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM16.25 12a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
      }))
    }
  };
});
var StopIcon = /* @__PURE__ */ createIconComponent("StopIcon", "octicon octicon-stop", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M4.47.22A.749.749 0 0 1 5 0h6c.199 0 .389.079.53.22l4.25 4.25c.141.14.22.331.22.53v6a.749.749 0 0 1-.22.53l-4.25 4.25A.749.749 0 0 1 11 16H5a.749.749 0 0 1-.53-.22L.22 11.53A.749.749 0 0 1 0 11V5c0-.199.079-.389.22-.53Zm.84 1.28L1.5 5.31v5.38l3.81 3.81h5.38l3.81-3.81V5.31L10.69 1.5ZM8 4a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 4Zm0 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M12 7a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 12 7Zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M7.328 1.47a.749.749 0 0 1 .53-.22h8.284c.199 0 .389.079.53.22l5.858 5.858c.141.14.22.33.22.53v8.284a.749.749 0 0 1-.22.53l-5.858 5.858a.749.749 0 0 1-.53.22H7.858a.749.749 0 0 1-.53-.22L1.47 16.672a.749.749 0 0 1-.22-.53V7.858c0-.199.079-.389.22-.53Zm.84 1.28L2.75 8.169v7.662l5.419 5.419h7.662l5.419-5.418V8.168L15.832 2.75Z"
      }))
    }
  };
});
var StrikethroughIcon = /* @__PURE__ */ createIconComponent("StrikethroughIcon", "octicon octicon-strikethrough", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M11.055 8.5c.524.536.815 1.257.811 2.007a3.133 3.133 0 0 1-1.12 2.408C9.948 13.597 8.748 14 7.096 14c-1.706 0-3.104-.607-3.902-1.377a.751.751 0 0 1 1.042-1.079c.48.463 1.487.956 2.86.956 1.422 0 2.232-.346 2.676-.726.435-.372.594-.839.594-1.267 0-.472-.208-.857-.647-1.197-.448-.346-1.116-.623-1.951-.81H1.75a.75.75 0 0 1 0-1.5h12.5a.75.75 0 0 1 0 1.5ZM7.581 3.25c-2.036 0-2.778 1.082-2.778 1.786 0 .055.002.107.006.157a.75.75 0 0 1-1.496.114 3.506 3.506 0 0 1-.01-.271c0-1.832 1.75-3.286 4.278-3.286 1.418 0 2.721.58 3.514 1.093a.75.75 0 1 1-.814 1.26c-.64-.414-1.662-.853-2.7-.853Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "m16.533 12.5.054.043c.93.75 1.538 1.77 1.538 3.066a4.13 4.13 0 0 1-1.479 3.177c-1.058.904-2.679 1.464-4.974 1.464-2.35 0-4.252-.837-5.318-1.865a.75.75 0 1 1 1.042-1.08c.747.722 2.258 1.445 4.276 1.445 2.065 0 3.296-.504 3.999-1.105a2.63 2.63 0 0 0 .954-2.036c0-.764-.337-1.38-.979-1.898-.649-.523-1.598-.931-2.76-1.211H3.75a.75.75 0 0 1 0-1.5h16.5a.75.75 0 0 1 0 1.5ZM12.36 5C9.37 5 8.105 6.613 8.105 7.848c0 .411.072.744.193 1.02a.75.75 0 0 1-1.373.603 3.988 3.988 0 0 1-.32-1.623c0-2.363 2.271-4.348 5.755-4.348 1.931 0 3.722.794 4.814 1.5a.75.75 0 1 1-.814 1.26c-.94-.607-2.448-1.26-4-1.26Z"
      })
    }
  };
});
var TabExternalIcon = /* @__PURE__ */ createIconComponent("TabExternalIcon", "octicon octicon-tab-external", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M3.25 4a.25.25 0 0 0-.25.25v9a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1 0-1.5h.75V4.25c0-.966.784-1.75 1.75-1.75h9.5c.966 0 1.75.784 1.75 1.75v8.25h.75a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75v-9a.25.25 0 0 0-.25-.25h-9.5Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "m7.97 7.97-2.75 2.75a.75.75 0 1 0 1.06 1.06l2.75-2.75 1.543 1.543a.25.25 0 0 0 .427-.177V6.25a.25.25 0 0 0-.25-.25H6.604a.25.25 0 0 0-.177.427L7.97 7.97Z"
      }))
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M3 5.75C3 4.784 3.784 4 4.75 4h14.5c.966 0 1.75.784 1.75 1.75V18.5h2a.75.75 0 0 1 0 1.5h-2.65a.85.85 0 0 1-.85-.85V5.75a.25.25 0 0 0-.25-.25H4.75a.25.25 0 0 0-.25.25v13.4c0 .47-.38.85-.85.85H1a.75.75 0 0 1 0-1.5h2V5.75Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M16.404 13.7a.75.75 0 0 1-1.29.547 689.448 689.448 0 0 0-1.92-1.976l-4.141 4.14a.75.75 0 0 1-1.061-1.06l4.14-4.14-1.94-1.94A.75.75 0 0 1 10.703 8h4.95a.75.75 0 0 1 .75.75v4.95Z"
      }))
    }
  };
});
var TableIcon = /* @__PURE__ */ createIconComponent("TableIcon", "octicon octicon-table", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25ZM6.5 6.5v8h7.75a.25.25 0 0 0 .25-.25V6.5Zm8-1.5V1.75a.25.25 0 0 0-.25-.25H6.5V5Zm-13 1.5v7.75c0 .138.112.25.25.25H5v-8ZM5 5V1.5H1.75a.25.25 0 0 0-.25.25V5Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H3.75A1.75 1.75 0 0 1 2 20.25ZM9 9v11.5h11.25a.25.25 0 0 0 .25-.25V9Zm11.5-1.5V3.75a.25.25 0 0 0-.25-.25H9v4ZM3.5 9v11.25c0 .138.112.25.25.25H7.5V9Zm4-1.5v-4H3.75a.25.25 0 0 0-.25.25V7.5Z"
      })
    }
  };
});
var TagIcon = /* @__PURE__ */ createIconComponent("TagIcon", "octicon octicon-tag", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M1 7.775V2.75C1 1.784 1.784 1 2.75 1h5.025c.464 0 .91.184 1.238.513l6.25 6.25a1.75 1.75 0 0 1 0 2.474l-5.026 5.026a1.75 1.75 0 0 1-2.474 0l-6.25-6.25A1.752 1.752 0 0 1 1 7.775Zm1.5 0c0 .066.026.13.073.177l6.25 6.25a.25.25 0 0 0 .354 0l5.025-5.025a.25.25 0 0 0 0-.354l-6.25-6.25a.25.25 0 0 0-.177-.073H2.75a.25.25 0 0 0-.25.25ZM6 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M7.75 6.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M2.5 1h8.44a1.5 1.5 0 0 1 1.06.44l10.25 10.25a1.5 1.5 0 0 1 0 2.12l-8.44 8.44a1.5 1.5 0 0 1-2.12 0L1.44 12A1.497 1.497 0 0 1 1 10.94V2.5A1.5 1.5 0 0 1 2.5 1Zm0 1.5v8.44l10.25 10.25 8.44-8.44L10.94 2.5Z"
      }))
    }
  };
});
var TrashIcon = /* @__PURE__ */ createIconComponent("TrashIcon", "octicon octicon-trash", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M11 1.75V3h2.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5H5V1.75C5 .784 5.784 0 6.75 0h2.5C10.216 0 11 .784 11 1.75ZM4.496 6.675l.66 6.6a.25.25 0 0 0 .249.225h5.19a.25.25 0 0 0 .249-.225l.66-6.6a.75.75 0 0 1 1.492.149l-.66 6.6A1.748 1.748 0 0 1 10.595 15h-5.19a1.75 1.75 0 0 1-1.741-1.575l-.66-6.6a.75.75 0 1 1 1.492-.15ZM6.5 1.75V3h3V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M16 1.75V3h5.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5H8V1.75C8 .784 8.784 0 9.75 0h4.5C15.216 0 16 .784 16 1.75Zm-6.5 0V3h5V1.75a.25.25 0 0 0-.25-.25h-4.5a.25.25 0 0 0-.25.25ZM4.997 6.178a.75.75 0 1 0-1.493.144L4.916 20.92a1.75 1.75 0 0 0 1.742 1.58h10.684a1.75 1.75 0 0 0 1.742-1.581l1.413-14.597a.75.75 0 0 0-1.494-.144l-1.412 14.596a.25.25 0 0 1-.249.226H6.658a.25.25 0 0 1-.249-.226L4.997 6.178Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M9.206 7.501a.75.75 0 0 1 .793.705l.5 8.5A.75.75 0 1 1 9 16.794l-.5-8.5a.75.75 0 0 1 .705-.793Zm6.293.793A.75.75 0 1 0 14 8.206l-.5 8.5a.75.75 0 0 0 1.498.088l.5-8.5Z"
      }))
    }
  };
});
var TriangleDownIcon = /* @__PURE__ */ createIconComponent("TriangleDownIcon", "octicon octicon-triangle-down", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "m4.427 7.427 3.396 3.396a.25.25 0 0 0 .354 0l3.396-3.396A.25.25 0 0 0 11.396 7H4.604a.25.25 0 0 0-.177.427Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M11.646 15.146 5.854 9.354a.5.5 0 0 1 .353-.854h11.586a.5.5 0 0 1 .353.854l-5.793 5.792a.5.5 0 0 1-.707 0Z"
      })
    }
  };
});
var TypographyIcon = /* @__PURE__ */ createIconComponent("TypographyIcon", "octicon octicon-typography", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M6.71 10H2.332l-.874 2.498a.75.75 0 0 1-1.415-.496l3.39-9.688a1.217 1.217 0 0 1 2.302.018l3.227 9.681a.75.75 0 0 1-1.423.474Zm3.13-4.358C10.53 4.374 11.87 4 13 4c1.5 0 3 .939 3 2.601v5.649a.75.75 0 0 1-1.448.275C13.995 12.82 13.3 13 12.5 13c-.77 0-1.514-.231-2.078-.709-.577-.488-.922-1.199-.922-2.041 0-.694.265-1.411.887-1.944C11 7.78 11.88 7.5 13 7.5h1.5v-.899c0-.54-.5-1.101-1.5-1.101-.869 0-1.528.282-1.84.858a.75.75 0 1 1-1.32-.716ZM6.21 8.5 4.574 3.594 2.857 8.5Zm8.29.5H13c-.881 0-1.375.22-1.637.444-.253.217-.363.5-.363.806 0 .408.155.697.39.896.249.21.63.354 1.11.354.732 0 1.26-.209 1.588-.449.35-.257.412-.495.412-.551Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M10.414 15H3.586l-1.631 4.505a.75.75 0 1 1-1.41-.51l5.08-14.03a1.463 1.463 0 0 1 2.75 0l5.08 14.03a.75.75 0 1 1-1.411.51Zm4.532-5.098c.913-1.683 2.703-2.205 4.284-2.205 1.047 0 2.084.312 2.878.885.801.577 1.392 1.455 1.392 2.548v8.12a.75.75 0 0 1-1.5 0v-.06l-.044.025c-.893.52-2.096.785-3.451.785-1.051 0-2.048-.315-2.795-.948-.76-.643-1.217-1.578-1.217-2.702 0-.919.349-1.861 1.168-2.563.81-.694 2-1.087 3.569-1.087H22v-1.57c0-.503-.263-.967-.769-1.332-.513-.37-1.235-.6-2.001-.6-1.319 0-2.429.43-2.966 1.42a.75.75 0 0 1-1.318-.716ZM9.87 13.5 7 5.572 4.13 13.5Zm12.13.7h-2.77c-1.331 0-2.134.333-2.593.726a1.822 1.822 0 0 0-.644 1.424c0 .689.267 1.203.686 1.557.43.365 1.065.593 1.826.593 1.183 0 2.102-.235 2.697-.581.582-.34.798-.74.798-1.134Z"
      })
    }
  };
});
var UnfoldIcon = /* @__PURE__ */ createIconComponent("UnfoldIcon", "octicon octicon-unfold", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "m8.177.677 2.896 2.896a.25.25 0 0 1-.177.427H8.75v1.25a.75.75 0 0 1-1.5 0V4H5.104a.25.25 0 0 1-.177-.427L7.823.677a.25.25 0 0 1 .354 0ZM7.25 10.75a.75.75 0 0 1 1.5 0V12h2.146a.25.25 0 0 1 .177.427l-2.896 2.896a.25.25 0 0 1-.354 0l-2.896-2.896A.25.25 0 0 1 5.104 12H7.25v-1.25Zm-5-2a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM6 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 6 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5ZM12 8a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1 0-1.5h.5A.75.75 0 0 1 12 8Zm2.25.75a.75.75 0 0 0 0-1.5h-.5a.75.75 0 0 0 0 1.5h.5Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M12 23a.749.749 0 0 1-.53-.22l-3.25-3.25a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215L12 21.19l2.72-2.72a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734l-3.25 3.25A.749.749 0 0 1 12 23Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M11.47 1.22a.75.75 0 0 1 1.06 0l3.25 3.25a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018L12 2.81 9.28 5.53a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042ZM12 22.25a.75.75 0 0 1-.75-.75v-5.75a.75.75 0 0 1 1.5 0v5.75a.75.75 0 0 1-.75.75ZM2.75 12a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm4 0a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M12 1.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6A.75.75 0 0 1 12 1.5Z"
      }))
    }
  };
});
var UploadIcon = /* @__PURE__ */ createIconComponent("UploadIcon", "octicon octicon-upload", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M2.75 14A1.75 1.75 0 0 1 1 12.25v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 14Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M11.78 4.72a.749.749 0 1 1-1.06 1.06L8.75 3.811V9.5a.75.75 0 0 1-1.5 0V3.811L5.28 5.78a.749.749 0 1 1-1.06-1.06l3.25-3.25a.749.749 0 0 1 1.06 0l3.25 3.25Z"
      }))
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
        d: "M4 20.25V18a.75.75 0 0 1 1.5 0v2.25c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V18a.75.75 0 0 1 1.5 0v2.25A1.75 1.75 0 0 1 18.25 22H5.75A1.75 1.75 0 0 1 4 20.25Z"
      }), /* @__PURE__ */ React__default.createElement("path", {
        d: "M5.22 9.53a.749.749 0 0 1 0-1.06l6.25-6.25a.749.749 0 0 1 1.06 0l6.25 6.25a.749.749 0 1 1-1.06 1.06l-4.97-4.969V16.75a.75.75 0 0 1-1.5 0V4.561L6.28 9.53a.749.749 0 0 1-1.06 0Z"
      }))
    }
  };
});
var VersionsIcon = /* @__PURE__ */ createIconComponent("VersionsIcon", "octicon octicon-versions", function() {
  return {
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M7.75 14A1.75 1.75 0 0 1 6 12.25v-8.5C6 2.784 6.784 2 7.75 2h6.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14Zm-.25-1.75c0 .138.112.25.25.25h6.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25h-6.5a.25.25 0 0 0-.25.25ZM4.9 3.508a.75.75 0 0 1-.274 1.025.249.249 0 0 0-.126.217v6.5c0 .09.048.173.126.217a.75.75 0 0 1-.752 1.298A1.75 1.75 0 0 1 3 11.25v-6.5c0-.649.353-1.214.874-1.516a.75.75 0 0 1 1.025.274ZM1.625 5.533h.001a.249.249 0 0 0-.126.217v4.5c0 .09.048.173.126.217a.75.75 0 0 1-.752 1.298A1.748 1.748 0 0 1 0 10.25v-4.5a1.748 1.748 0 0 1 .873-1.516.75.75 0 1 1 .752 1.299Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M10 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2Zm-.5-2a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H10a.5.5 0 0 0-.5.5ZM6.17 4.165a.75.75 0 0 1-.335 1.006c-.228.114-.295.177-.315.201a.035.035 0 0 0-.008.016.423.423 0 0 0-.012.112v13c0 .07.008.102.012.112a.03.03 0 0 0 .008.016c.02.024.087.087.315.201a.749.749 0 1 1-.67 1.342c-.272-.136-.58-.315-.81-.598C4.1 19.259 4 18.893 4 18.5v-13c0-.393.1-.759.355-1.073.23-.283.538-.462.81-.598a.75.75 0 0 1 1.006.336ZM2.15 5.624a.75.75 0 0 1-.274 1.025c-.15.087-.257.17-.32.245C1.5 6.96 1.5 6.99 1.5 7v10c0 .01 0 .04.056.106.063.074.17.158.32.245a.75.75 0 0 1-.752 1.298C.73 18.421 0 17.907 0 17V7c0-.907.73-1.42 1.124-1.65a.75.75 0 0 1 1.025.274Z"
      })
    }
  };
});
var XIcon = /* @__PURE__ */ createIconComponent("XIcon", "octicon octicon-x", function() {
  return {
    "12": {
      "width": 12,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M2.22 2.22a.749.749 0 0 1 1.06 0L6 4.939 8.72 2.22a.749.749 0 1 1 1.06 1.06L7.061 6 9.78 8.72a.749.749 0 1 1-1.06 1.06L6 7.061 3.28 9.78a.749.749 0 1 1-1.06-1.06L4.939 6 2.22 3.28a.749.749 0 0 1 0-1.06Z"
      })
    },
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M3.72 3.72a.75.75 0 0 1 1.06 0L8 6.94l3.22-3.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L9.06 8l3.22 3.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L8 9.06l-3.22 3.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L6.94 8 3.72 4.78a.75.75 0 0 1 0-1.06Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M5.72 5.72a.75.75 0 0 1 1.06 0L12 10.94l5.22-5.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L13.06 12l5.22 5.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L12 13.06l-5.22 5.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L10.94 12 5.72 6.78a.75.75 0 0 1 0-1.06Z"
      })
    }
  };
});
var XCircleFillIcon = /* @__PURE__ */ createIconComponent("XCircleFillIcon", "octicon octicon-x-circle-fill", function() {
  return {
    "12": {
      "width": 12,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M1.757 10.243a6.001 6.001 0 1 1 8.488-8.486 6.001 6.001 0 0 1-8.488 8.486ZM6 4.763l-2-2L2.763 4l2 2-2 2L4 9.237l2-2 2 2L9.237 8l-2-2 2-2L8 2.763Z"
      })
    },
    "16": {
      "width": 16,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M2.343 13.657A8 8 0 1 1 13.658 2.343 8 8 0 0 1 2.343 13.657ZM6.03 4.97a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042L6.94 8 4.97 9.97a.749.749 0 0 0 .326 1.275.749.749 0 0 0 .734-.215L8 9.06l1.97 1.97a.749.749 0 0 0 1.275-.326.749.749 0 0 0-.215-.734L9.06 8l1.97-1.97a.749.749 0 0 0-.326-1.275.749.749 0 0 0-.734.215L8 6.94Z"
      })
    },
    "24": {
      "width": 24,
      "path": /* @__PURE__ */ React__default.createElement("path", {
        d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12Zm8.036-4.024a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042L10.939 12l-2.963 2.963a.749.749 0 0 0 .326 1.275.749.749 0 0 0 .734-.215L12 13.06l2.963 2.964a.75.75 0 0 0 1.061-1.06L13.061 12l2.963-2.964a.749.749 0 0 0-.326-1.275.749.749 0 0 0-.734.215L12 10.939Z"
      })
    }
  };
});
function useFocusZone(settings = {}, dependencies = []) {
  const containerRef = useProvidedRefOrCreate(settings.containerRef);
  const useActiveDescendant = !!settings.activeDescendantFocus;
  const passedActiveDescendantRef = typeof settings.activeDescendantFocus === "boolean" || !settings.activeDescendantFocus ? void 0 : settings.activeDescendantFocus;
  const activeDescendantControlRef = useProvidedRefOrCreate(passedActiveDescendantRef);
  const disabled = settings.disabled;
  const abortController = React__default.useRef();
  useEffect(
    () => {
      if (containerRef.current instanceof HTMLElement && (!useActiveDescendant || activeDescendantControlRef.current instanceof HTMLElement)) {
        if (!disabled) {
          var _activeDescendantCont;
          const vanillaSettings = {
            ...settings,
            activeDescendantControl: (_activeDescendantCont = activeDescendantControlRef.current) !== null && _activeDescendantCont !== void 0 ? _activeDescendantCont : void 0
          };
          abortController.current = focusZone(containerRef.current, vanillaSettings);
          return () => {
            var _abortController$curr;
            (_abortController$curr = abortController.current) === null || _abortController$curr === void 0 ? void 0 : _abortController$curr.abort();
          };
        } else {
          var _abortController$curr2;
          (_abortController$curr2 = abortController.current) === null || _abortController$curr2 === void 0 ? void 0 : _abortController$curr2.abort();
        }
      }
    },
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [disabled, ...dependencies]
  );
  return {
    containerRef,
    activeDescendantControlRef
  };
}
const useIsomorphicLayoutEffect$2 = typeof window !== "undefined" && // eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
typeof window.document !== "undefined" && // eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
typeof window.document.createElement !== "undefined" ? useLayoutEffect : useEffect;
const PRIMER_PORTAL_ROOT_ID = "__primerPortalRoot__";
const DEFAULT_PORTAL_CONTAINER_NAME = "__default__";
const portalRootRegistry = {};
function registerPortalRoot(root2, name2 = DEFAULT_PORTAL_CONTAINER_NAME) {
  portalRootRegistry[name2] = root2;
}
function ensureDefaultPortal() {
  const existingDefaultPortalContainer = portalRootRegistry[DEFAULT_PORTAL_CONTAINER_NAME];
  if (!existingDefaultPortalContainer || !document.body.contains(existingDefaultPortalContainer)) {
    let defaultPortalContainer = document.getElementById(PRIMER_PORTAL_ROOT_ID);
    if (!(defaultPortalContainer instanceof Element)) {
      defaultPortalContainer = document.createElement("div");
      defaultPortalContainer.setAttribute("id", PRIMER_PORTAL_ROOT_ID);
      defaultPortalContainer.style.position = "absolute";
      defaultPortalContainer.style.top = "0";
      defaultPortalContainer.style.left = "0";
      const suitablePortalRoot = document.querySelector("[data-portal-root]");
      if (suitablePortalRoot) {
        suitablePortalRoot.appendChild(defaultPortalContainer);
      } else {
        document.body.appendChild(defaultPortalContainer);
      }
    }
    registerPortalRoot(defaultPortalContainer);
  }
}
const Portal = ({
  children,
  onMount,
  containerName: _containerName
}) => {
  const elementRef = React__default.useRef(null);
  if (!elementRef.current) {
    const div = document.createElement("div");
    div.style.position = "relative";
    div.style.zIndex = "1";
    elementRef.current = div;
  }
  const element2 = elementRef.current;
  useIsomorphicLayoutEffect$2(() => {
    let containerName = _containerName;
    if (containerName === void 0) {
      containerName = DEFAULT_PORTAL_CONTAINER_NAME;
      ensureDefaultPortal();
    }
    const parentElement = portalRootRegistry[containerName];
    if (!parentElement) {
      throw new Error(`Portal container '${_containerName}' is not yet registered. Container must be registered with registerPortal before use.`);
    }
    parentElement.appendChild(element2);
    onMount === null || onMount === void 0 ? void 0 : onMount();
    return () => {
      parentElement.removeChild(element2);
    };
  }, [element2]);
  return /* @__PURE__ */ createPortal(children, element2);
};
var classes$H = { "Backdrop": "prc-Dialog-Backdrop-ugYqZ", "Dialog": "prc-Dialog-Dialog-luvDS", "DisableScroll": "prc-Dialog-DisableScroll-F6LZa", "DialogOverflowWrapper": "prc-Dialog-DialogOverflowWrapper-oDYJo", "Footer": "prc-Dialog-Footer-jQfN4", "Header": "prc-Dialog-Header-cjbcl", "Title": "prc-Dialog-Title-oQ-W6", "Subtitle": "prc-Dialog-Subtitle-sITpo", "Body": "prc-Dialog-Body-LCvER" };
function useOverflow(ref2) {
  const $2 = distExports.c(4);
  const [hasOverflow, setHasOverflow] = useState(false);
  let t0;
  if ($2[0] !== ref2.current) {
    t0 = () => {
      if (ref2.current === null) {
        return;
      }
      const observer = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (entry.target.scrollHeight > entry.target.clientHeight || entry.target.scrollWidth > entry.target.clientWidth) {
            setHasOverflow(true);
            break;
          }
        }
      });
      observer.observe(ref2.current);
      return () => {
        observer.disconnect();
      };
    };
    $2[0] = ref2.current;
    $2[1] = t0;
  } else {
    t0 = $2[1];
  }
  let t1;
  if ($2[2] !== ref2) {
    t1 = [ref2];
    $2[2] = ref2;
    $2[3] = t1;
  } else {
    t1 = $2[3];
  }
  useEffect(t0, t1);
  return hasOverflow;
}
const defaultStyles$2 = {
  // When setting overflow, we also set `position: relative` to avoid
  // `position: absolute` items breaking out of the container and causing
  // scrollbars on the page. This can occur with common classes like `sr-only`
  // and can cause difficult to track down layout issues
  position: "relative",
  overflow: "auto"
};
function ScrollableRegion(t0) {
  const $2 = distExports.c(13);
  let children;
  let label;
  let labelledby;
  let rest;
  if ($2[0] !== t0) {
    ({
      "aria-label": label,
      "aria-labelledby": labelledby,
      children,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = label;
    $2[3] = labelledby;
    $2[4] = rest;
  } else {
    children = $2[1];
    label = $2[2];
    labelledby = $2[3];
    rest = $2[4];
  }
  const ref2 = React__default.useRef(null);
  const hasOverflow = useOverflow(ref2);
  let t1;
  if ($2[5] !== hasOverflow || $2[6] !== label || $2[7] !== labelledby) {
    t1 = hasOverflow ? {
      "aria-label": label,
      "aria-labelledby": labelledby,
      role: "region",
      tabIndex: 0
    } : {};
    $2[5] = hasOverflow;
    $2[6] = label;
    $2[7] = labelledby;
    $2[8] = t1;
  } else {
    t1 = $2[8];
  }
  const regionProps = t1;
  let t2;
  if ($2[9] !== children || $2[10] !== regionProps || $2[11] !== rest) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(Box, {
      ...rest,
      ...regionProps,
      ref: ref2,
      sx: defaultStyles$2,
      children
    });
    $2[9] = children;
    $2[10] = regionProps;
    $2[11] = rest;
    $2[12] = t2;
  } else {
    t2 = $2[12];
  }
  return t2;
}
const DefaultHeader = (t0) => {
  const $2 = distExports.c(16);
  const {
    dialogLabelId,
    title,
    subtitle,
    dialogDescriptionId,
    onClose
  } = t0;
  let t1;
  if ($2[0] !== onClose) {
    t1 = () => {
      onClose("close-button");
    };
    $2[0] = onClose;
    $2[1] = t1;
  } else {
    t1 = $2[1];
  }
  const onCloseClick = t1;
  const t2 = title !== null && title !== void 0 ? title : "Dialog";
  let t3;
  if ($2[2] !== dialogLabelId || $2[3] !== t2) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog.Title, {
      id: dialogLabelId,
      children: t2
    });
    $2[2] = dialogLabelId;
    $2[3] = t2;
    $2[4] = t3;
  } else {
    t3 = $2[4];
  }
  let t4;
  if ($2[5] !== dialogDescriptionId || $2[6] !== subtitle) {
    t4 = subtitle && /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog.Subtitle, {
      id: dialogDescriptionId,
      children: subtitle
    });
    $2[5] = dialogDescriptionId;
    $2[6] = subtitle;
    $2[7] = t4;
  } else {
    t4 = $2[7];
  }
  let t5;
  if ($2[8] !== t3 || $2[9] !== t4) {
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, {
      display: "flex",
      px: 2,
      py: "6px",
      flexDirection: "column",
      flexGrow: 1,
      children: [t3, t4]
    });
    $2[8] = t3;
    $2[9] = t4;
    $2[10] = t5;
  } else {
    t5 = $2[10];
  }
  let t6;
  if ($2[11] !== onCloseClick) {
    t6 = /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog.CloseButton, {
      onClose: onCloseClick
    });
    $2[11] = onCloseClick;
    $2[12] = t6;
  } else {
    t6 = $2[12];
  }
  let t7;
  if ($2[13] !== t5 || $2[14] !== t6) {
    t7 = /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog.Header, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, {
        display: "flex",
        children: [t5, t6]
      })
    });
    $2[13] = t5;
    $2[14] = t6;
    $2[15] = t7;
  } else {
    t7 = $2[15];
  }
  return t7;
};
const DefaultBody = (t0) => {
  const $2 = distExports.c(2);
  const {
    children
  } = t0;
  let t1;
  if ($2[0] !== children) {
    t1 = /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog.Body, {
      children
    });
    $2[0] = children;
    $2[1] = t1;
  } else {
    t1 = $2[1];
  }
  return t1;
};
const DefaultFooter = (t0) => {
  const $2 = distExports.c(4);
  const {
    footerButtons
  } = t0;
  let t1;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      bindKeys: FocusKeys.ArrowHorizontal | FocusKeys.Tab,
      focusInStrategy: "closest"
    };
    $2[0] = t1;
  } else {
    t1 = $2[0];
  }
  const {
    containerRef: footerRef
  } = useFocusZone(t1);
  let t2;
  if ($2[1] !== footerButtons || $2[2] !== footerRef) {
    t2 = footerButtons ? /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog.Footer, {
      ref: footerRef,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog.Buttons, {
        buttons: footerButtons
      })
    }) : null;
    $2[1] = footerButtons;
    $2[2] = footerRef;
    $2[3] = t2;
  } else {
    t2 = $2[3];
  }
  return t2;
};
const defaultPosition = {
  narrow: "center",
  regular: "center"
};
const defaultFooterButtons = [];
const _Dialog = /* @__PURE__ */ React__default.forwardRef((props, forwardedRef) => {
  const {
    title = "Dialog",
    subtitle = "",
    renderHeader,
    renderBody,
    renderFooter,
    onClose,
    role = "dialog",
    width: width2 = "xlarge",
    height: height2 = "auto",
    footerButtons = defaultFooterButtons,
    position: position4 = defaultPosition,
    returnFocusRef,
    initialFocusRef,
    sx: sx2,
    className
  } = props;
  const dialogLabelId = useId();
  const dialogDescriptionId = useId();
  const autoFocusedFooterButtonRef = useRef(null);
  for (const footerButton of footerButtons) {
    if (footerButton.autoFocus) {
      footerButton.ref = autoFocusedFooterButtonRef;
    }
  }
  const [lastMouseDownIsBackdrop, setLastMouseDownIsBackdrop] = useState(false);
  const defaultedProps = {
    ...props,
    title,
    subtitle,
    role,
    dialogLabelId,
    dialogDescriptionId
  };
  const onBackdropClick = useCallback$1((e) => {
    if (e.target === e.currentTarget && lastMouseDownIsBackdrop) {
      onClose("escape");
    }
  }, [onClose, lastMouseDownIsBackdrop]);
  const dialogRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, dialogRef);
  const backdropRef = useRef(null);
  useFocusTrap({
    containerRef: dialogRef,
    initialFocusRef: initialFocusRef !== null && initialFocusRef !== void 0 ? initialFocusRef : autoFocusedFooterButtonRef,
    restoreFocusOnCleanUp: returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current ? false : true,
    returnFocusRef
  });
  useOnEscapePress((event) => {
    onClose("escape");
    event.preventDefault();
  }, [onClose]);
  React__default.useEffect(() => {
    var _dialogRef$current;
    const scrollbarWidth = window.innerWidth - document.body.clientWidth;
    (_dialogRef$current = dialogRef.current) === null || _dialogRef$current === void 0 ? void 0 : _dialogRef$current.classList.add(classes$H.DisableScroll);
    document.body.style.setProperty("--prc-dialog-scrollgutter", `${scrollbarWidth}px`);
  }, []);
  const header = (renderHeader !== null && renderHeader !== void 0 ? renderHeader : DefaultHeader)(defaultedProps);
  const body = (renderBody !== null && renderBody !== void 0 ? renderBody : DefaultBody)(defaultedProps);
  const footer2 = (renderFooter !== null && renderFooter !== void 0 ? renderFooter : DefaultFooter)(defaultedProps);
  const positionDataAttributes = typeof position4 === "string" ? {
    "data-position-regular": position4
  } : Object.fromEntries(Object.entries(position4).map(([key2, value]) => {
    return [`data-position-${key2}`, value];
  }));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
        as: "div",
        ref: backdropRef,
        className: classes$H.Backdrop,
        ...positionDataAttributes,
        onClick: onBackdropClick,
        onMouseDown: (e_0) => {
          setLastMouseDownIsBackdrop(e_0.target === e_0.currentTarget);
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(BoxWithFallback, {
          as: "div",
          ref: dialogRef,
          role,
          "aria-labelledby": dialogLabelId,
          "aria-describedby": dialogDescriptionId,
          "aria-modal": true,
          ...positionDataAttributes,
          "data-width": width2,
          "data-height": height2,
          sx: sx2,
          className: clsx(className, classes$H.Dialog),
          children: [header, /* @__PURE__ */ jsxRuntimeExports.jsx(ScrollableRegion, {
            "aria-labelledby": dialogLabelId,
            className: classes$H.DialogOverflowWrapper,
            children: body
          }), footer2]
        })
      })
    })
  });
});
_Dialog.displayName = "Dialog";
const Header$4 = /* @__PURE__ */ React__default.forwardRef(function Header(t0, forwardRef2) {
  const $2 = distExports.c(9);
  let className;
  let rest;
  if ($2[0] !== t0) {
    ({
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = rest;
  } else {
    className = $2[1];
    rest = $2[2];
  }
  let t1;
  if ($2[3] !== className) {
    t1 = clsx(className, classes$H.Header);
    $2[3] = className;
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  let t2;
  if ($2[5] !== forwardRef2 || $2[6] !== rest || $2[7] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: "div",
      ref: forwardRef2,
      className: t1,
      ...rest
    });
    $2[5] = forwardRef2;
    $2[6] = rest;
    $2[7] = t1;
    $2[8] = t2;
  } else {
    t2 = $2[8];
  }
  return t2;
});
Header$4.displayName = "Dialog.Header";
const Title = /* @__PURE__ */ React__default.forwardRef(function Title2(t0, forwardRef2) {
  const $2 = distExports.c(9);
  let className;
  let rest;
  if ($2[0] !== t0) {
    ({
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = rest;
  } else {
    className = $2[1];
    rest = $2[2];
  }
  let t1;
  if ($2[3] !== className) {
    t1 = clsx(className, classes$H.Title);
    $2[3] = className;
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  let t2;
  if ($2[5] !== forwardRef2 || $2[6] !== rest || $2[7] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: "h1",
      ref: forwardRef2,
      className: t1,
      ...rest
    });
    $2[5] = forwardRef2;
    $2[6] = rest;
    $2[7] = t1;
    $2[8] = t2;
  } else {
    t2 = $2[8];
  }
  return t2;
});
Title.displayName = "Dialog.Title";
const Subtitle = /* @__PURE__ */ React__default.forwardRef(function Subtitle2(t0, forwardRef2) {
  const $2 = distExports.c(9);
  let className;
  let rest;
  if ($2[0] !== t0) {
    ({
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = rest;
  } else {
    className = $2[1];
    rest = $2[2];
  }
  let t1;
  if ($2[3] !== className) {
    t1 = clsx(className, classes$H.Subtitle);
    $2[3] = className;
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  let t2;
  if ($2[5] !== forwardRef2 || $2[6] !== rest || $2[7] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: "h2",
      ref: forwardRef2,
      className: t1,
      ...rest
    });
    $2[5] = forwardRef2;
    $2[6] = rest;
    $2[7] = t1;
    $2[8] = t2;
  } else {
    t2 = $2[8];
  }
  return t2;
});
Subtitle.displayName = "Dialog.Subtitle";
const Body = /* @__PURE__ */ React__default.forwardRef(function Body2(t0, forwardRef2) {
  const $2 = distExports.c(9);
  let className;
  let rest;
  if ($2[0] !== t0) {
    ({
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = rest;
  } else {
    className = $2[1];
    rest = $2[2];
  }
  let t1;
  if ($2[3] !== className) {
    t1 = clsx(className, classes$H.Body);
    $2[3] = className;
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  let t2;
  if ($2[5] !== forwardRef2 || $2[6] !== rest || $2[7] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: "div",
      ref: forwardRef2,
      className: t1,
      ...rest
    });
    $2[5] = forwardRef2;
    $2[6] = rest;
    $2[7] = t1;
    $2[8] = t2;
  } else {
    t2 = $2[8];
  }
  return t2;
});
Body.displayName = "Dialog.Body";
const Footer$1 = /* @__PURE__ */ React__default.forwardRef(function Footer(t0, forwardRef2) {
  const $2 = distExports.c(9);
  let className;
  let rest;
  if ($2[0] !== t0) {
    ({
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = rest;
  } else {
    className = $2[1];
    rest = $2[2];
  }
  let t1;
  if ($2[3] !== className) {
    t1 = clsx(className, classes$H.Footer);
    $2[3] = className;
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  let t2;
  if ($2[5] !== forwardRef2 || $2[6] !== rest || $2[7] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: "div",
      ref: forwardRef2,
      className: t1,
      ...rest
    });
    $2[5] = forwardRef2;
    $2[6] = rest;
    $2[7] = t1;
    $2[8] = t2;
  } else {
    t2 = $2[8];
  }
  return t2;
});
Footer$1.displayName = "Dialog.Footer";
const Buttons = ({
  buttons
}) => {
  var _buttons$find;
  const autoFocusRef = useProvidedRefOrCreate((_buttons$find = buttons.find((button) => button.autoFocus)) === null || _buttons$find === void 0 ? void 0 : _buttons$find.ref);
  let autoFocusCount = 0;
  const [hasRendered, setHasRendered] = useState(0);
  useEffect(() => {
    if (hasRendered === 1) {
      var _autoFocusRef$current;
      (_autoFocusRef$current = autoFocusRef.current) === null || _autoFocusRef$current === void 0 ? void 0 : _autoFocusRef$current.focus();
    } else {
      setHasRendered(hasRendered + 1);
    }
  }, [autoFocusRef, hasRendered]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
    children: buttons.map((dialogButtonProps, index2) => {
      const {
        content: content2,
        buttonType = "default",
        autoFocus = false,
        ...buttonProps
      } = dialogButtonProps;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
        ...buttonProps,
        // 'normal' value is equivalent to 'default', this is used for backwards compatibility
        variant: buttonType === "normal" ? "default" : buttonType,
        ref: autoFocus && autoFocusCount === 0 ? (autoFocusCount++, autoFocusRef) : null,
        children: content2
      }, index2);
    })
  });
};
const CloseButton = (t0) => {
  const $2 = distExports.c(2);
  const {
    onClose
  } = t0;
  let t1;
  if ($2[0] !== onClose) {
    t1 = /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, {
      icon: XIcon,
      "aria-label": "Close",
      onClick: onClose,
      variant: "invisible"
    });
    $2[0] = onClose;
    $2[1] = t1;
  } else {
    t1 = $2[1];
  }
  return t1;
};
const Dialog = Object.assign(_Dialog, {
  Header: Header$4,
  Title,
  Subtitle,
  Body,
  Footer: Footer$1,
  Buttons,
  CloseButton
});
var classes$G = { "ConfirmationHeader": "prc-ConfirmationDialog-ConfirmationHeader-yiLEc", "ConfirmationBody": "prc-ConfirmationDialog-ConfirmationBody-ht9P-", "ConfirmationFooter": "prc-ConfirmationDialog-ConfirmationFooter-AqKBI" };
const ConfirmationHeader = ({
  title,
  onClose,
  dialogLabelId
}) => {
  const onCloseClick = useCallback$1(() => {
    onClose("close-button");
  }, [onClose]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
    className: classes$G.ConfirmationHeader,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("h1", {
      id: dialogLabelId,
      children: title
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog.CloseButton, {
      onClose: onCloseClick
    })]
  });
};
ConfirmationHeader.displayName = "ConfirmationHeader";
const ConfirmationBody = ({
  children
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    className: classes$G.ConfirmationBody,
    children
  });
};
ConfirmationBody.displayName = "ConfirmationBody";
const ConfirmationFooter = ({
  footerButtons
}) => {
  const {
    containerRef: footerRef
  } = useFocusZone({
    bindKeys: FocusKeys.ArrowHorizontal | FocusKeys.Tab,
    focusInStrategy: "closest"
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    ref: footerRef,
    className: classes$G.ConfirmationFooter,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog.Buttons, {
      buttons: footerButtons !== null && footerButtons !== void 0 ? footerButtons : []
    })
  });
};
ConfirmationFooter.displayName = "ConfirmationFooter";
const ConfirmationDialog = (props) => {
  const {
    onClose,
    title,
    cancelButtonContent = "Cancel",
    confirmButtonContent = "OK",
    confirmButtonType = "normal",
    children,
    className,
    width: width2 = "medium",
    height: height2
  } = props;
  const onCancelButtonClick = useCallback$1(() => {
    onClose("cancel");
  }, [onClose]);
  const onConfirmButtonClick = useCallback$1(() => {
    onClose("confirm");
  }, [onClose]);
  const isConfirmationDangerous = confirmButtonType === "danger";
  const cancelButton = {
    content: cancelButtonContent,
    onClick: onCancelButtonClick,
    autoFocus: isConfirmationDangerous
  };
  const confirmButton = {
    content: confirmButtonContent,
    buttonType: confirmButtonType,
    onClick: onConfirmButtonClick,
    autoFocus: !isConfirmationDangerous
  };
  const footerButtons = [cancelButton, confirmButton];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog, {
    onClose,
    title,
    footerButtons,
    role: "alertdialog",
    width: width2,
    height: height2,
    className,
    renderHeader: ConfirmationHeader,
    renderBody: ConfirmationBody,
    renderFooter: ConfirmationFooter,
    children
  });
};
ConfirmationDialog.displayName = "ConfirmationDialog";
function useResizeObserver$1(callback, target, depsArray = []) {
  const [targetClientRect, setTargetClientRect] = useState(null);
  const savedCallback = useRef(callback);
  useIsomorphicLayoutEffect$2(() => {
    savedCallback.current = callback;
  });
  useIsomorphicLayoutEffect$2(() => {
    const targetEl = target && "current" in target ? target.current : document.documentElement;
    if (!targetEl) {
      return;
    }
    if (typeof ResizeObserver === "function") {
      const observer = new ResizeObserver((entries) => {
        savedCallback.current(entries);
      });
      observer.observe(targetEl);
      return () => {
        observer.disconnect();
      };
    } else {
      const saveTargetDimensions = () => {
        const currTargetRect = targetEl.getBoundingClientRect();
        if (currTargetRect.width !== (targetClientRect === null || targetClientRect === void 0 ? void 0 : targetClientRect.width) || currTargetRect.height !== targetClientRect.height) {
          savedCallback.current([{
            contentRect: currTargetRect
          }]);
        }
        setTargetClientRect(currTargetRect);
      };
      window.addEventListener("resize", saveTargetDimensions);
      return () => {
        window.removeEventListener("resize", saveTargetDimensions);
      };
    }
  }, [target === null || target === void 0 ? void 0 : target.current, ...depsArray]);
}
function useMedia(mediaQueryString, defaultState) {
  const $2 = distExports.c(12);
  const features = useContext(MatchMediaContext);
  let t0;
  if ($2[0] !== defaultState || $2[1] !== features || $2[2] !== mediaQueryString) {
    t0 = () => {
      if (features[mediaQueryString] !== void 0) {
        return features[mediaQueryString];
      }
      {
        return defaultState;
      }
    };
    $2[0] = defaultState;
    $2[1] = features;
    $2[2] = mediaQueryString;
    $2[3] = t0;
  } else {
    t0 = $2[3];
  }
  const [matches2, setMatches] = React__default.useState(t0);
  let t1;
  let t2;
  if ($2[4] !== features || $2[5] !== mediaQueryString) {
    t1 = () => {
      if (features[mediaQueryString] !== void 0) {
        setMatches(features[mediaQueryString]);
      }
    };
    t2 = [features, mediaQueryString];
    $2[4] = features;
    $2[5] = mediaQueryString;
    $2[6] = t1;
    $2[7] = t2;
  } else {
    t1 = $2[6];
    t2 = $2[7];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($2[8] !== features || $2[9] !== mediaQueryString) {
    t3 = () => {
      if (features[mediaQueryString] !== void 0) {
        return;
      }
      const listener = function listener2(event) {
        setMatches(event.matches);
      };
      const mediaQueryList = window.matchMedia(mediaQueryString);
      if (mediaQueryList.addEventListener) {
        mediaQueryList.addEventListener("change", listener);
      } else {
        mediaQueryList.addListener(listener);
      }
      setMatches(mediaQueryList.matches);
      return () => {
        if (mediaQueryList.addEventListener) {
          mediaQueryList.removeEventListener("change", listener);
        } else {
          mediaQueryList.removeListener(listener);
        }
      };
    };
    t4 = [features, mediaQueryString];
    $2[8] = features;
    $2[9] = mediaQueryString;
    $2[10] = t3;
    $2[11] = t4;
  } else {
    t3 = $2[10];
    t4 = $2[11];
  }
  useEffect(t3, t4);
  return matches2;
}
const MatchMediaContext = /* @__PURE__ */ createContext({});
const viewportRanges = {
  narrow: "(max-width: calc(768px - 0.02px))",
  // < 768px
  regular: "(min-width: 768px)",
  // >= 768px
  wide: "(min-width: 1400px)"
  // >= 1400px
};
function isResponsiveValue(value) {
  return typeof value === "object" && Object.keys(value).some((key2) => ["narrow", "regular", "wide"].includes(key2));
}
function useResponsiveValue(value, fallback) {
  const isNarrowViewport = useMedia(viewportRanges.narrow, false);
  const isRegularViewport = useMedia(viewportRanges.regular, false);
  const isWideViewport = useMedia(viewportRanges.wide, false);
  if (isResponsiveValue(value)) {
    const responsiveValue = value;
    if (isNarrowViewport && "narrow" in responsiveValue) {
      return responsiveValue.narrow;
    } else {
      if (isWideViewport && "wide" in responsiveValue) {
        return responsiveValue.wide;
      } else {
        if (isRegularViewport && "regular" in responsiveValue) {
          return responsiveValue.regular;
        } else {
          return fallback;
        }
      }
    }
  } else {
    return value;
  }
}
const ActionListContainerContext = /* @__PURE__ */ React__default.createContext({});
function useSlots(children, config2) {
  const slots = mapValues(config2, () => void 0);
  const rest = [];
  const keys2 = Object.keys(config2);
  const values2 = Object.values(config2);
  React__default.Children.forEach(children, (child) => {
    if (!/* @__PURE__ */ React__default.isValidElement(child)) {
      rest.push(child);
      return;
    }
    const index2 = values2.findIndex((value) => {
      if (Array.isArray(value)) {
        const [component, testFn] = value;
        return child.type === component && testFn(child.props);
      } else {
        return child.type === value;
      }
    });
    if (index2 === -1) {
      rest.push(child);
      return;
    }
    const slotKey = keys2[index2];
    if (slots[slotKey]) {
      process.env.NODE_ENV !== "production" ? warning2(true, `Found duplicate "${String(slotKey)}" slot. Only the first will be rendered.`) : void 0;
      return;
    }
    slots[slotKey] = child;
  });
  return [slots, rest];
}
function mapValues(obj, fn2) {
  return Object.keys(obj).reduce((result, key2) => {
    result[key2] = fn2(obj[key2]);
    return result;
  }, {});
}
const ItemContext = /* @__PURE__ */ React__default.createContext({});
const ListContext = /* @__PURE__ */ React__default.createContext({});
var classes$F = { "ActionListHeader": "prc-ActionList-ActionListHeader-lEr8v" };
var classes$E = { "Heading": "prc-Heading-Heading-6CmGO" };
const Heading$4 = /* @__PURE__ */ forwardRef$1(({
  as: Component2 = "h2",
  className,
  variant: variant3,
  ...props
}, forwardedRef) => {
  const innerRef = React__default.useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  if (process.env.NODE_ENV !== "production") {
    useEffect(() => {
      if (innerRef.current && !(innerRef.current instanceof HTMLHeadingElement)) {
        console.warn("This Heading component should be an instanceof of h1-h6");
      }
    }, [innerRef]);
  }
  if (props.sx) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, {
      as: Component2,
      className: clsx(className, classes$E.Heading),
      "data-variant": variant3,
      ...props,
      // @ts-ignore temporary disable as we migrate to css modules, until we remove PolymorphicForwardRefComponent
      ref: innerRef
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, {
    className: clsx(className, classes$E.Heading),
    "data-variant": variant3,
    ...props,
    ref: innerRef
  });
});
Heading$4.displayName = "Heading";
const Heading$3 = /* @__PURE__ */ forwardRef$1(({
  as: as2,
  size: size2,
  children,
  visuallyHidden: visuallyHidden2 = false,
  className,
  ...props
}, forwardedRef) => {
  var _props$id;
  const innerRef = React__default.useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  const {
    headingId,
    variant: listVariant
  } = React__default.useContext(ListContext);
  const {
    container
  } = React__default.useContext(ActionListContainerContext);
  !(container !== "ActionMenu") ? process.env.NODE_ENV !== "production" ? invariant(false, `ActionList.Heading shouldn't be used within an ActionMenu container. Menus are labelled by the menu button's name.`) : invariant(false) : void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden, {
    isVisible: !visuallyHidden2,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$4, {
      as: as2,
      variant: size2,
      ref: innerRef,
      id: (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : headingId,
      className: clsx(className, classes$F.ActionListHeader),
      "data-list-variant": listVariant,
      ...props,
      children
    })
  });
});
Heading$3.displayName = "ActionList.Heading";
var classes$D = { "ActionList": "prc-ActionList-ActionList-X4RiC", "ActionListItem": "prc-ActionList-ActionListItem-uq6I7", "ActionListSubContent": "prc-ActionList-ActionListSubContent-lP9xj", "Divider": "prc-ActionList-Divider-rsZFG", "ItemLabel": "prc-ActionList-ItemLabel-TmBhn", "TrailingAction": "prc-ActionList-TrailingAction-RmUk1", "TrailingVisual": "prc-ActionList-TrailingVisual-XocgV", "InactiveWarning": "prc-ActionList-InactiveWarning-YRMKV", "ActionListContent": "prc-ActionList-ActionListContent-sg9-x", "Spacer": "prc-ActionList-Spacer-dydlX", "MultiSelectCheckbox": "prc-ActionList-MultiSelectCheckbox-nK6PJ", "Description": "prc-ActionList-Description-G0lJ3", "SingleSelectCheckmark": "prc-ActionList-SingleSelectCheckmark-Vqn87", "LeadingAction": "prc-ActionList-LeadingAction-Oy04M", "LeadingVisual": "prc-ActionList-LeadingVisual-dxXxW", "ItemDescriptionWrap": "prc-ActionList-ItemDescriptionWrap-VJA7h", "VisualWrap": "prc-ActionList-VisualWrap-rfjV-", "TrailingActionButton": "prc-ActionList-TrailingActionButton-i2wnc", "InactiveButtonWrap": "prc-ActionList-InactiveButtonWrap-T6Jfa", "InactiveButtonReset": "prc-ActionList-InactiveButtonReset-3lIQX" };
const List = /* @__PURE__ */ React__default.forwardRef(({
  variant: variant3 = "inset",
  selectionVariant,
  showDividers = false,
  role,
  disableFocusZone = false,
  className,
  ...props
}, forwardedRef) => {
  var _slots$heading$props$;
  const [slots, childrenWithoutSlots] = useSlots(props.children, {
    heading: Heading$3
  });
  const headingId = useId();
  const {
    listRole: listRoleFromContainer,
    listLabelledBy,
    selectionVariant: containerSelectionVariant,
    // TODO: Remove after DropdownMenu2 deprecation
    enableFocusZone: enableFocusZoneFromContainer
  } = React__default.useContext(ActionListContainerContext);
  const ariaLabelledBy = slots.heading ? (_slots$heading$props$ = slots.heading.props.id) !== null && _slots$heading$props$ !== void 0 ? _slots$heading$props$ : headingId : listLabelledBy;
  const listRole = role || listRoleFromContainer;
  const listRef = useProvidedRefOrCreate(forwardedRef);
  let enableFocusZone = false;
  if (enableFocusZoneFromContainer !== void 0) enableFocusZone = enableFocusZoneFromContainer;
  else if (listRole && !disableFocusZone) enableFocusZone = ["menu", "menubar", "listbox"].includes(listRole);
  useFocusZone({
    disabled: !enableFocusZone,
    containerRef: listRef,
    bindKeys: FocusKeys.ArrowVertical | FocusKeys.HomeAndEnd | FocusKeys.PageUpDown,
    focusOutBehavior: listRole === "menu" ? "wrap" : void 0
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ListContext.Provider, {
    value: {
      variant: variant3,
      selectionVariant: selectionVariant || containerSelectionVariant,
      showDividers,
      role: listRole,
      headingId
    },
    children: [slots.heading, /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: "ul",
      className: clsx(classes$D.ActionList, className),
      role: listRole,
      "aria-labelledby": ariaLabelledBy,
      ref: listRef,
      "data-dividers": showDividers,
      "data-variant": variant3,
      ...props,
      children: childrenWithoutSlots
    })]
  });
});
List.displayName = "ActionList";
var groupClasses = { "Group": "prc-ActionList-Group-fXpF9", "GroupHeadingWrap": "prc-ActionList-GroupHeadingWrap-pfbd9", "GroupList": "prc-ActionList-GroupList-sj8d3", "GroupHeading": "prc-ActionList-GroupHeading-eahp0" };
const Heading$2 = ({
  as: Component2 = "h3",
  className,
  children,
  id,
  ...rest
}) => {
  return (
    // Box is temporary to support lingering sx usage
    /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: Component2,
      className,
      id,
      ...rest,
      children
    })
  );
};
Heading$2.displayName = "Heading";
const HeadingWrap = ({
  as: as2 = "div",
  children,
  className,
  ...rest
}) => {
  return /* @__PURE__ */ React__default.createElement(as2, {
    ...rest,
    className
  }, children);
};
const GroupContext = /* @__PURE__ */ React__default.createContext({
  groupHeadingId: void 0,
  selectionVariant: void 0
});
const Group = ({
  title,
  variant: variant3 = "subtle",
  auxiliaryText,
  selectionVariant,
  role,
  className,
  "aria-label": ariaLabel,
  ...props
}) => {
  var _slots$groupHeading;
  const id = useId();
  const {
    role: listRole
  } = React__default.useContext(ListContext);
  const [slots, childrenWithoutSlots] = useSlots(props.children, {
    groupHeading: GroupHeading
  });
  let groupHeadingId = void 0;
  if (slots.groupHeading) {
    var _slots$groupHeading$p;
    groupHeadingId = (_slots$groupHeading$p = slots.groupHeading.props.id) !== null && _slots$groupHeading$p !== void 0 ? _slots$groupHeading$p : id;
  }
  if (title) {
    groupHeadingId = id;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
    as: "li",
    className: clsx(className, groupClasses.Group),
    role: listRole ? "none" : void 0,
    ...props,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(GroupContext.Provider, {
      value: {
        selectionVariant,
        groupHeadingId
      },
      children: [title && !slots.groupHeading ? (
        // Escape hatch: supports old API <ActionList.Group title="group title"> in a non breaking way
        /* @__PURE__ */ jsxRuntimeExports.jsx(GroupHeading, {
          variant: variant3,
          auxiliaryText,
          _internalBackwardCompatibleTitle: title
        })
      ) : null, !title && slots.groupHeading ? /* @__PURE__ */ React__default.cloneElement(slots.groupHeading) : null, /* @__PURE__ */ jsxRuntimeExports.jsx("ul", {
        // if listRole is set (listbox or menu), we don't label the list with the groupHeadingId
        // because the heading is hidden from the accessibility tree and only used for presentation role.
        // We will instead use aria-label to label the list. See a line below.
        "aria-labelledby": listRole ? void 0 : groupHeadingId,
        "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : listRole ? title !== null && title !== void 0 ? title : (_slots$groupHeading = slots.groupHeading) === null || _slots$groupHeading === void 0 ? void 0 : _slots$groupHeading.props.children : void 0,
        role: role || listRole && "group",
        className: groupClasses.GroupList,
        children: slots.groupHeading ? childrenWithoutSlots : props.children
      })]
    })
  });
};
Group.displayName = "Group";
const GroupHeading = ({
  as: as2,
  variant: variant3 = "subtle",
  // We are not recommending this prop to be used, it should only be used internally for incremental rollout.
  _internalBackwardCompatibleTitle,
  auxiliaryText,
  children,
  className,
  sx: sx2,
  headingWrapElement = "div",
  ...props
}) => {
  const {
    role: listRole
  } = React__default.useContext(ListContext);
  const {
    groupHeadingId
  } = React__default.useContext(GroupContext);
  const missingAsForList = (listRole === void 0 || listRole === "list") && children !== void 0 && as2 === void 0;
  const unnecessaryAsForListboxOrMenu = listRole !== void 0 && listRole !== "list" && children !== void 0 && as2 !== void 0;
  !// 'as' prop is required for list roles. <GroupHeading as="h2">...</GroupHeading>
  !missingAsForList ? process.env.NODE_ENV !== "production" ? invariant(false, `You are setting a heading for a list, that requires a heading level. Please use 'as' prop to set a proper heading level.`) : invariant(false) : void 0;
  !// 'as' prop on listbox or menu roles are not needed since they are rendered as divs and they could be misleading.
  !unnecessaryAsForListboxOrMenu ? process.env.NODE_ENV !== "production" ? invariant(false, `Looks like you are trying to set a heading level to a ${listRole} role. Group headings for ${listRole} type action lists are for representational purposes, and rendered as divs. Therefore they don't need a heading level.`) : invariant(false) : void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
    children: listRole && listRole !== "list" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(HeadingWrap, {
      role: "presentation",
      className: groupClasses.GroupHeadingWrap,
      "aria-hidden": "true",
      "data-variant": variant3,
      "data-component": "GroupHeadingWrap",
      as: headingWrapElement,
      ...props,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: clsx(className, groupClasses.GroupHeading),
        id: groupHeadingId,
        children: _internalBackwardCompatibleTitle !== null && _internalBackwardCompatibleTitle !== void 0 ? _internalBackwardCompatibleTitle : children
      }), auxiliaryText && /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
        className: classes$D.Description,
        children: auxiliaryText
      })]
    }) : (
      // for explicit (role="list" is passed as prop) and implicit list roles (ActionList ins rendered as list by default), group titles are proper heading tags.
      /* @__PURE__ */ jsxRuntimeExports.jsxs(HeadingWrap, {
        className: groupClasses.GroupHeadingWrap,
        "data-variant": variant3,
        as: headingWrapElement,
        "data-component": "GroupHeadingWrap",
        children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Heading$2, {
          className: clsx(className, groupClasses.GroupHeading),
          as: as2 || "h3",
          id: groupHeadingId,
          sx: sx2,
          ...props,
          children: _internalBackwardCompatibleTitle !== null && _internalBackwardCompatibleTitle !== void 0 ? _internalBackwardCompatibleTitle : children
        }), auxiliaryText && /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
          className: classes$D.Description,
          children: auxiliaryText
        })]
      })
    )
  });
};
GroupHeading.displayName = "ActionList.GroupHeading";
Group.displayName = "ActionList.Group";
var classes$C = { "Truncate": "prc-Truncate-Truncate-A9Wn6" };
const Truncate = /* @__PURE__ */ React__default.forwardRef(function Truncate2({
  as: as2,
  children,
  className,
  title,
  inline: inline2,
  expandable,
  maxWidth: maxWidth2 = 125,
  style: style3,
  sx: sx2,
  ...rest
}, ref2) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
    ...rest,
    ref: ref2,
    as: as2,
    className: clsx(className, classes$C.Truncate),
    "data-expandable": expandable,
    "data-inline": inline2,
    title,
    style: {
      ...style3,
      [`--truncate-max-width`]: typeof maxWidth2 === "number" ? `${maxWidth2}px` : typeof maxWidth2 === "string" ? maxWidth2 : void 0
    },
    sx: sx2,
    children
  });
});
if (process.env.NODE_ENV !== "production") {
  Truncate.displayName = "Truncate";
}
const Description$1 = ({
  variant: variant3 = "inline",
  sx: sx2,
  className,
  truncate,
  ...props
}) => {
  const {
    blockDescriptionId,
    inlineDescriptionId
  } = React__default.useContext(ItemContext);
  const containerRef = React__default.useRef(null);
  const [computedTitle, setComputedTitle] = React__default.useState("");
  React__default.useEffect(() => {
    if (truncate && containerRef.current) {
      const textContent = containerRef.current.textContent || "";
      setComputedTitle(textContent);
    }
  }, [truncate, props.children]);
  const effectiveTitle = typeof props.children === "string" ? props.children : computedTitle;
  if (variant3 === "block" || !truncate) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: "span",
      sx: sx2,
      id: variant3 === "block" ? blockDescriptionId : inlineDescriptionId,
      className: clsx(className, classes$D.Description),
      "data-component": "ActionList.Description",
      children: props.children
    });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Truncate, {
      ref: containerRef,
      id: inlineDescriptionId,
      className: clsx(className, classes$D.Description),
      sx: sx2,
      title: effectiveTitle,
      inline: true,
      maxWidth: "100%",
      "data-component": "ActionList.Description",
      children: props.children
    });
  }
};
const VisualContainer = ({
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
    as: "span",
    className: clsx(className, classes$D.VisualWrap),
    ...props
  });
};
VisualContainer.displayName = "VisualContainer";
const LeadingVisual = ({
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VisualContainer, {
    className: clsx(className, classes$D.LeadingVisual),
    ...props,
    children: props.children
  });
};
LeadingVisual.displayName = "LeadingVisual";
const TrailingVisual = ({
  className,
  ...props
}) => {
  const {
    trailingVisualId
  } = React__default.useContext(ItemContext);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VisualContainer, {
    className: clsx(className, classes$D.TrailingVisual),
    id: trailingVisualId,
    ...props,
    children: props.children
  });
};
TrailingVisual.displayName = "TrailingVisual";
const VisualOrIndicator = ({
  children,
  labelId,
  loading,
  inactiveText,
  itemHasLeadingVisual,
  position: position4,
  className
}) => {
  const VisualComponent = position4 === "leading" ? LeadingVisual : TrailingVisual;
  if (!loading && !inactiveText) return children;
  if (itemHasLeadingVisual && position4 === "trailing" || // has a leading visual, and it's in the trailing position, or
  !itemHasLeadingVisual && position4 === "leading") {
    return children;
  }
  return inactiveText ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    className: classes$D.InactiveButtonWrap,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, {
      text: inactiveText,
      type: "description",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("button", {
        type: "button",
        className: classes$D.InactiveButtonReset,
        "aria-labelledby": labelId,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(VisualComponent, {
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon, {})
        })
      })
    })
  }) : /* @__PURE__ */ jsxRuntimeExports.jsx(VisualComponent, {
    className,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {
      size: "small"
    })
  });
};
LeadingVisual.displayName = "ActionList.LeadingVisual";
TrailingVisual.displayName = "ActionList.TrailingVisual";
const CheckboxOrRadioGroupContext = /* @__PURE__ */ React__default.createContext({});
var classes$B = { "Body": "prc-CheckboxOrRadioGroup-Body-cNQoa", "GroupFieldset": "prc-CheckboxOrRadioGroup-GroupFieldset-0NZzG", "GroupLegend": "prc-CheckboxOrRadioGroup-GroupLegend-HW4-c", "CheckboxOrRadioGroupCaption": "prc-CheckboxOrRadioGroup-CheckboxOrRadioGroupCaption-9GgyY", "RadioGroupLabel": "prc-CheckboxOrRadioGroup-RadioGroupLabel-anQ3U", "GroupLabelChildren": "prc-CheckboxOrRadioGroup-GroupLabelChildren-j5sBI" };
const CheckboxOrRadioGroupCaption = ({
  className,
  children,
  sx: sx2
}) => {
  const {
    captionId
  } = React__default.useContext(CheckboxOrRadioGroupContext);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, {
    className: clsx(className, classes$B.CheckboxOrRadioGroupCaption),
    id: captionId,
    sx: sx2,
    children
  });
};
CheckboxOrRadioGroupCaption.displayName = "CheckboxOrRadioGroupCaption";
function getResponsiveAttributes(property, values2) {
  if (values2 === void 0 || values2 === null) {
    return;
  }
  if (typeof values2 == "object") {
    return Object.fromEntries(Object.entries(values2).map(([key2, value]) => {
      return serialize$1(`data-${property}-${key2}`, value);
    }));
  }
  return Object.fromEntries([serialize$1(`data-${property}`, values2)]);
}
function serialize$1(property, value) {
  return [property, value];
}
var classes$A = { "Stack": "prc-Stack-Stack-WJVsK", "StackItem": "prc-Stack-StackItem-CweWT" };
const Stack$1 = /* @__PURE__ */ forwardRef$1((t0, forwardedRef) => {
  const $2 = distExports.c(37);
  let as2;
  let children;
  let className;
  let gap;
  let rest;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($2[0] !== t0) {
    ({
      as: as2,
      children,
      align: t1,
      direction: t2,
      gap,
      justify: t3,
      padding: t4,
      wrap: t5,
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = as2;
    $2[2] = children;
    $2[3] = className;
    $2[4] = gap;
    $2[5] = rest;
    $2[6] = t1;
    $2[7] = t2;
    $2[8] = t3;
    $2[9] = t4;
    $2[10] = t5;
  } else {
    as2 = $2[1];
    children = $2[2];
    className = $2[3];
    gap = $2[4];
    rest = $2[5];
    t1 = $2[6];
    t2 = $2[7];
    t3 = $2[8];
    t4 = $2[9];
    t5 = $2[10];
  }
  const align = t1 === void 0 ? "stretch" : t1;
  const direction = t2 === void 0 ? "vertical" : t2;
  const justify = t3 === void 0 ? "start" : t3;
  const padding2 = t4 === void 0 ? "none" : t4;
  const wrap2 = t5 === void 0 ? "nowrap" : t5;
  let t6;
  if ($2[11] !== className) {
    t6 = clsx(className, classes$A.Stack);
    $2[11] = className;
    $2[12] = t6;
  } else {
    t6 = $2[12];
  }
  let t7;
  if ($2[13] !== gap) {
    t7 = getResponsiveAttributes("gap", gap);
    $2[13] = gap;
    $2[14] = t7;
  } else {
    t7 = $2[14];
  }
  let t8;
  if ($2[15] !== direction) {
    t8 = getResponsiveAttributes("direction", direction);
    $2[15] = direction;
    $2[16] = t8;
  } else {
    t8 = $2[16];
  }
  let t9;
  if ($2[17] !== align) {
    t9 = getResponsiveAttributes("align", align);
    $2[17] = align;
    $2[18] = t9;
  } else {
    t9 = $2[18];
  }
  let t10;
  if ($2[19] !== wrap2) {
    t10 = getResponsiveAttributes("wrap", wrap2);
    $2[19] = wrap2;
    $2[20] = t10;
  } else {
    t10 = $2[20];
  }
  let t11;
  if ($2[21] !== justify) {
    t11 = getResponsiveAttributes("justify", justify);
    $2[21] = justify;
    $2[22] = t11;
  } else {
    t11 = $2[22];
  }
  let t12;
  if ($2[23] !== padding2) {
    t12 = getResponsiveAttributes("padding", padding2);
    $2[23] = padding2;
    $2[24] = t12;
  } else {
    t12 = $2[24];
  }
  let t13;
  if ($2[25] !== as2 || $2[26] !== children || $2[27] !== forwardedRef || $2[28] !== rest || $2[29] !== t10 || $2[30] !== t11 || $2[31] !== t12 || $2[32] !== t6 || $2[33] !== t7 || $2[34] !== t8 || $2[35] !== t9) {
    t13 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: as2,
      ref: forwardedRef,
      ...rest,
      className: t6,
      ...t7,
      ...t8,
      ...t9,
      ...t10,
      ...t11,
      ...t12,
      children
    });
    $2[25] = as2;
    $2[26] = children;
    $2[27] = forwardedRef;
    $2[28] = rest;
    $2[29] = t10;
    $2[30] = t11;
    $2[31] = t12;
    $2[32] = t6;
    $2[33] = t7;
    $2[34] = t8;
    $2[35] = t9;
    $2[36] = t13;
  } else {
    t13 = $2[36];
  }
  return t13;
});
const StackItem = /* @__PURE__ */ forwardRef$1((t0, forwardedRef) => {
  const $2 = distExports.c(21);
  let as2;
  let children;
  let className;
  let grow;
  let rest;
  let shrink3;
  if ($2[0] !== t0) {
    ({
      as: as2,
      children,
      grow,
      shrink: shrink3,
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = as2;
    $2[2] = children;
    $2[3] = className;
    $2[4] = grow;
    $2[5] = rest;
    $2[6] = shrink3;
  } else {
    as2 = $2[1];
    children = $2[2];
    className = $2[3];
    grow = $2[4];
    rest = $2[5];
    shrink3 = $2[6];
  }
  let t1;
  if ($2[7] !== className) {
    t1 = clsx(className, classes$A.StackItem);
    $2[7] = className;
    $2[8] = t1;
  } else {
    t1 = $2[8];
  }
  let t2;
  if ($2[9] !== grow) {
    t2 = getResponsiveAttributes("grow", grow);
    $2[9] = grow;
    $2[10] = t2;
  } else {
    t2 = $2[10];
  }
  let t3;
  if ($2[11] !== shrink3) {
    t3 = getResponsiveAttributes("shrink", shrink3);
    $2[11] = shrink3;
    $2[12] = t3;
  } else {
    t3 = $2[12];
  }
  let t4;
  if ($2[13] !== as2 || $2[14] !== children || $2[15] !== forwardedRef || $2[16] !== rest || $2[17] !== t1 || $2[18] !== t2 || $2[19] !== t3) {
    t4 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: as2,
      ref: forwardedRef,
      ...rest,
      className: t1,
      ...t2,
      ...t3,
      children
    });
    $2[13] = as2;
    $2[14] = children;
    $2[15] = forwardedRef;
    $2[16] = rest;
    $2[17] = t1;
    $2[18] = t2;
    $2[19] = t3;
    $2[20] = t4;
  } else {
    t4 = $2[20];
  }
  return t4;
});
const Stack = Object.assign(Stack$1, {
  Item: StackItem
});
const CheckboxOrRadioGroupLabel = ({
  children,
  className,
  visuallyHidden: visuallyHidden2 = false,
  sx: sx2
}) => {
  const {
    required: required2,
    disabled
  } = React__default.useContext(CheckboxOrRadioGroupContext);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden, {
    className: clsx(className, classes$B.RadioGroupLabel),
    isVisible: !visuallyHidden2,
    title: required2 ? "required field" : void 0,
    "data-label-disabled": disabled ? "" : void 0,
    sx: sx2,
    children: required2 ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, {
      direction: "horizontal",
      gap: "none",
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
        className: classes$B.GroupLabelChildren,
        children
      }), /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        children: "*"
      })]
    }) : children
  });
};
CheckboxOrRadioGroupLabel.displayName = "CheckboxOrRadioGroupLabel";
var classes$z = { "InputValidation": "prc-components-InputValidation-GjS0D", "ValidationIcon": "prc-components-ValidationIcon-Kdbbr", "ValidationText": "prc-components-ValidationText-jjsBp" };
const validationIconMap = {
  success: CheckCircleFillIcon,
  error: AlertFillIcon
};
const InputValidation = (t0) => {
  const $2 = distExports.c(14);
  const {
    children,
    className,
    id,
    validationStatus,
    sx: sx2
  } = t0;
  const IconComponent = validationStatus ? validationIconMap[validationStatus] : void 0;
  let t1;
  if ($2[0] !== className) {
    t1 = clsx(className, classes$z.InputValidation);
    $2[0] = className;
    $2[1] = t1;
  } else {
    t1 = $2[1];
  }
  let t2;
  if ($2[2] !== IconComponent) {
    t2 = IconComponent ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      "aria-hidden": "true",
      className: classes$z.ValidationIcon,
      style: {
        "--inputValidation-iconSize": 16
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconComponent, {
        size: 12,
        fill: "currentColor"
      })
    }) : null;
    $2[2] = IconComponent;
    $2[3] = t2;
  } else {
    t2 = $2[3];
  }
  let t3;
  if ($2[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      "--inputValidation-lineHeight": 1.3333333333333333
    };
    $2[4] = t3;
  } else {
    t3 = $2[4];
  }
  let t4;
  if ($2[5] !== children || $2[6] !== id) {
    t4 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      id,
      className: classes$z.ValidationText,
      style: t3,
      children
    });
    $2[5] = children;
    $2[6] = id;
    $2[7] = t4;
  } else {
    t4 = $2[7];
  }
  let t5;
  if ($2[8] !== sx2 || $2[9] !== t1 || $2[10] !== t2 || $2[11] !== t4 || $2[12] !== validationStatus) {
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$2, {
      className: t1,
      "data-validation-status": validationStatus,
      sx: sx2,
      children: [t2, t4]
    });
    $2[8] = sx2;
    $2[9] = t1;
    $2[10] = t2;
    $2[11] = t4;
    $2[12] = validationStatus;
    $2[13] = t5;
  } else {
    t5 = $2[13];
  }
  return t5;
};
const CheckboxOrRadioGroupValidation = ({
  children,
  variant: variant3,
  sx: sx2
}) => {
  const {
    validationMessageId = ""
  } = React__default.useContext(CheckboxOrRadioGroupContext);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputValidation, {
    validationStatus: variant3,
    id: validationMessageId,
    sx: sx2,
    children
  });
};
CheckboxOrRadioGroupValidation.displayName = "CheckboxOrRadioGroupValidation";
function useRenderForcingRef(value) {
  const [refCurrent, setRefCurrent] = useState(value || null);
  const ref2 = useRef(null);
  ref2.current = refCurrent;
  const setRef = useCallback$1((newRef) => {
    ref2.current = newRef;
    setRefCurrent(newRef);
  }, [ref2]);
  return [ref2, setRef];
}
const fadeIn = We(["0%{opacity:0;transform:translateY(-100%);}100%{opacity:1;transform:translateY(0);}"]);
const AnimatedElement = qe.div.withConfig({
  displayName: "ValidationAnimationContainer__AnimatedElement",
  componentId: "sc-8z5a3g-0"
})(["animation:", ";@media (prefers-reduced-motion){animation:none;}"], (props) => props.show && Ae(["170ms ", " cubic-bezier(0.44,0.74,0.36,1);"], fadeIn));
const ValidationAnimationContainer = (t0) => {
  const $2 = distExports.c(10);
  const {
    show,
    children
  } = t0;
  const [shouldRender, setRender] = useState(show);
  let t1;
  let t2;
  if ($2[0] !== show) {
    t1 = () => {
      if (show) {
        setRender(true);
      }
    };
    t2 = [show];
    $2[0] = show;
    $2[1] = t1;
    $2[2] = t2;
  } else {
    t1 = $2[1];
    t2 = $2[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($2[3] !== show) {
    t3 = () => {
      if (!show) {
        setRender(false);
      }
    };
    $2[3] = show;
    $2[4] = t3;
  } else {
    t3 = $2[4];
  }
  const onAnimationEnd = t3;
  let t4;
  if ($2[5] !== children || $2[6] !== onAnimationEnd || $2[7] !== shouldRender || $2[8] !== show) {
    t4 = shouldRender ? /* @__PURE__ */ jsxRuntimeExports.jsx(Box, {
      height: show ? "auto" : 0,
      overflow: "hidden",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(AnimatedElement, {
        show,
        onAnimationEnd,
        children
      })
    }) : null;
    $2[5] = children;
    $2[6] = onAnimationEnd;
    $2[7] = shouldRender;
    $2[8] = show;
    $2[9] = t4;
  } else {
    t4 = $2[9];
  }
  return t4;
};
const CheckboxOrRadioGroup = ({
  "aria-labelledby": ariaLabelledby,
  children,
  disabled = false,
  id: idProp,
  required: required2 = false,
  className,
  sx: sx2
}) => {
  const [slots, rest] = useSlots(children, {
    caption: CheckboxOrRadioGroupCaption,
    label: CheckboxOrRadioGroupLabel,
    validation: CheckboxOrRadioGroupValidation
  });
  const labelChild = React__default.Children.toArray(children).find((child) => /* @__PURE__ */ React__default.isValidElement(child) && child.type === CheckboxOrRadioGroupLabel);
  const validationChild = React__default.Children.toArray(children).find((child) => /* @__PURE__ */ React__default.isValidElement(child) && child.type === CheckboxOrRadioGroupValidation ? child : null);
  const captionChild = React__default.Children.toArray(children).find((child) => /* @__PURE__ */ React__default.isValidElement(child) && child.type === CheckboxOrRadioGroupCaption ? child : null);
  const id = useId(idProp);
  const validationMessageId = validationChild ? `${id}-validationMessage` : void 0;
  const captionId = captionChild ? `${id}-caption` : void 0;
  if (!labelChild && !ariaLabelledby) {
    console.warn("A choice group must be labelled using a `CheckboxOrRadioGroup.Label` child, or by passing `aria-labelledby` to the CheckboxOrRadioGroup component.");
  }
  const isLegendVisible = /* @__PURE__ */ React__default.isValidElement(labelChild) && !labelChild.props.visuallyHidden;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxOrRadioGroupContext.Provider, {
    value: {
      disabled,
      required: required2,
      captionId,
      validationMessageId
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      children: [/* @__PURE__ */ jsxRuntimeExports.jsxs(BoxWithFallback, {
        className: clsx(className, classes$B.GroupFieldset),
        "data-validation": validationChild ? "" : void 0,
        ...labelChild ? {
          as: "fieldset",
          disabled
        } : {},
        sx: sx2,
        children: [labelChild ? (
          /*
                Placing the caption text and validation text in the <legend> provides a better user
                experience for more screenreaders.
                 Reference: https://blog.tenon.io/accessible-validation-of-checkbox-and-radiobutton-groups/
              */
          /* @__PURE__ */ jsxRuntimeExports.jsxs("legend", {
            className: classes$B.GroupLegend,
            "data-legend-visible": isLegendVisible ? "" : void 0,
            children: [slots.label, slots.caption, /* @__PURE__ */ React__default.isValidElement(slots.validation) && slots.validation.props.children && /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden, {
              children: slots.validation.props.children
            })]
          })
        ) : (
          /*
                If CheckboxOrRadioGroup.Label wasn't passed as a child, we don't render a <legend>
                but we still want to render a caption
              */
          slots.caption
        ), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
          className: classes$B.Body,
          ...!labelChild ? {
            ["aria-labelledby"]: ariaLabelledby,
            ["aria-describedby"]: [validationMessageId, captionId].filter(Boolean).join(" "),
            as: "div",
            role: "group"
          } : {},
          children: React__default.Children.toArray(rest).filter((child) => /* @__PURE__ */ React__default.isValidElement(child))
        })]
      }), validationChild && /* @__PURE__ */ jsxRuntimeExports.jsx(
        ValidationAnimationContainer,
        {
          "aria-hidden": Boolean(labelChild),
          show: true,
          children: slots.validation
        }
      )]
    })
  });
};
CheckboxOrRadioGroup.displayName = "CheckboxOrRadioGroup";
var CheckboxOrRadioGroup$1 = Object.assign(CheckboxOrRadioGroup, {
  Caption: CheckboxOrRadioGroupCaption,
  Label: CheckboxOrRadioGroupLabel,
  Validation: CheckboxOrRadioGroupValidation
});
const RadioGroupContext = /* @__PURE__ */ createContext(null);
const RadioGroup = (t0) => {
  const $2 = distExports.c(23);
  let children;
  let disabled;
  let name2;
  let onChange;
  let rest;
  if ($2[0] !== t0) {
    ({
      children,
      disabled,
      onChange,
      name: name2,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = disabled;
    $2[3] = name2;
    $2[4] = onChange;
    $2[5] = rest;
  } else {
    children = $2[1];
    disabled = $2[2];
    name2 = $2[3];
    onChange = $2[4];
    rest = $2[5];
  }
  const [selectedRadioValue, setSelectedRadioValue] = useRenderForcingRef(null);
  let t1;
  if ($2[6] !== setSelectedRadioValue) {
    t1 = (e) => {
      const {
        value,
        checked
      } = e.currentTarget;
      if (checked) {
        setSelectedRadioValue(value);
        return;
      }
    };
    $2[6] = setSelectedRadioValue;
    $2[7] = t1;
  } else {
    t1 = $2[7];
  }
  const updateSelectedCheckboxes = t1;
  let t2;
  if ($2[8] !== onChange || $2[9] !== selectedRadioValue || $2[10] !== updateSelectedCheckboxes) {
    t2 = (e_0) => {
      if (onChange) {
        updateSelectedCheckboxes(e_0);
        onChange(selectedRadioValue.current, e_0);
      }
    };
    $2[8] = onChange;
    $2[9] = selectedRadioValue;
    $2[10] = updateSelectedCheckboxes;
    $2[11] = t2;
  } else {
    t2 = $2[11];
  }
  let t3;
  if ($2[12] !== disabled || $2[13] !== name2 || $2[14] !== t2) {
    t3 = {
      disabled,
      name: name2,
      onChange: t2
    };
    $2[12] = disabled;
    $2[13] = name2;
    $2[14] = t2;
    $2[15] = t3;
  } else {
    t3 = $2[15];
  }
  let t4;
  if ($2[16] !== children || $2[17] !== disabled || $2[18] !== rest) {
    t4 = /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxOrRadioGroup$1, {
      disabled,
      ...rest,
      children
    });
    $2[16] = children;
    $2[17] = disabled;
    $2[18] = rest;
    $2[19] = t4;
  } else {
    t4 = $2[19];
  }
  let t5;
  if ($2[20] !== t3 || $2[21] !== t4) {
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroupContext.Provider, {
      value: t3,
      children: t4
    });
    $2[20] = t3;
    $2[21] = t4;
    $2[22] = t5;
  } else {
    t5 = $2[22];
  }
  return t5;
};
Object.assign(RadioGroup, {
  Caption: CheckboxOrRadioGroupCaption,
  Label: CheckboxOrRadioGroupLabel,
  Validation: CheckboxOrRadioGroupValidation
});
var sharedClasses = { "Input": "prc-Checkbox-Input-mxggT" };
var classes$y = { "Radio": "prc-Radio-Radio-Ly4MR" };
const Radio = /* @__PURE__ */ React__default.forwardRef((t0, ref2) => {
  const $2 = distExports.c(26);
  let checked;
  let className;
  let disabled;
  let nameProp;
  let onChange;
  let required2;
  let rest;
  let t1;
  let value;
  if ($2[0] !== t0) {
    ({
      checked,
      disabled,
      name: nameProp,
      onChange,
      required: required2,
      value,
      className,
      "aria-hidden": t1,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = checked;
    $2[2] = className;
    $2[3] = disabled;
    $2[4] = nameProp;
    $2[5] = onChange;
    $2[6] = required2;
    $2[7] = rest;
    $2[8] = t1;
    $2[9] = value;
  } else {
    checked = $2[1];
    className = $2[2];
    disabled = $2[3];
    nameProp = $2[4];
    onChange = $2[5];
    required2 = $2[6];
    rest = $2[7];
    t1 = $2[8];
    value = $2[9];
  }
  const ariaHidden = t1 === void 0 ? false : t1;
  const radioGroupContext = useContext(RadioGroupContext);
  let t2;
  if ($2[10] !== onChange || $2[11] !== radioGroupContext) {
    t2 = (e) => {
      (radioGroupContext === null || radioGroupContext === void 0 ? void 0 : radioGroupContext.onChange) && radioGroupContext.onChange(e);
      onChange && onChange(e);
    };
    $2[10] = onChange;
    $2[11] = radioGroupContext;
    $2[12] = t2;
  } else {
    t2 = $2[12];
  }
  const handleOnChange = t2;
  const name2 = nameProp || (radioGroupContext === null || radioGroupContext === void 0 ? void 0 : radioGroupContext.name);
  if (!name2 && !ariaHidden) {
    console.warn("A radio input must have a `name` attribute. Pass `name` as a prop directly to each Radio, or nest them in a `RadioGroup` component with a `name` prop");
  }
  const t3 = checked ? "true" : "false";
  let t4;
  if ($2[13] !== className) {
    t4 = clsx(className, sharedClasses.Input, classes$y.Radio);
    $2[13] = className;
    $2[14] = t4;
  } else {
    t4 = $2[14];
  }
  let t5;
  if ($2[15] !== checked || $2[16] !== disabled || $2[17] !== handleOnChange || $2[18] !== name2 || $2[19] !== ref2 || $2[20] !== required2 || $2[21] !== rest || $2[22] !== t3 || $2[23] !== t4 || $2[24] !== value) {
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: "input",
      type: "radio",
      value,
      name: name2,
      ref: ref2,
      disabled,
      checked,
      "aria-checked": t3,
      required: required2,
      onChange: handleOnChange,
      className: t4,
      ...rest
    });
    $2[15] = checked;
    $2[16] = disabled;
    $2[17] = handleOnChange;
    $2[18] = name2;
    $2[19] = ref2;
    $2[20] = required2;
    $2[21] = rest;
    $2[22] = t3;
    $2[23] = t4;
    $2[24] = value;
    $2[25] = t5;
  } else {
    t5 = $2[25];
  }
  return t5;
});
Radio.displayName = "Radio";
const Selection$1 = ({
  selected,
  className
}) => {
  const {
    selectionVariant: listSelectionVariant,
    role: listRole
  } = React__default.useContext(ListContext);
  const {
    selectionVariant: groupSelectionVariant
  } = React__default.useContext(GroupContext);
  let selectionVariant;
  if (typeof groupSelectionVariant !== "undefined") selectionVariant = groupSelectionVariant;
  else selectionVariant = listSelectionVariant;
  if (!selectionVariant) {
    if (selected) {
      process.env.NODE_ENV !== "production" ? warning2(true, "For Item to be selected, ActionList or ActionList.Group should have a selectionVariant defined.") : void 0;
    }
    return null;
  }
  if (selectionVariant === "radio") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(VisualContainer, {
      className,
      "data-component": "ActionList.Selection",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Radio, {
        value: "unused",
        checked: selected,
        "aria-hidden": true,
        tabIndex: -1
      })
    });
  }
  if (selectionVariant === "single" || listRole === "menu") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(VisualContainer, {
      className,
      "data-component": "ActionList.Selection",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckIcon, {
        className: classes$D.SingleSelectCheckmark
      })
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VisualContainer, {
    className,
    "data-component": "ActionList.Selection",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: classes$D.MultiSelectCheckbox
    })
  });
};
Selection$1.displayName = "Selection";
const TrailingAction = /* @__PURE__ */ forwardRef$1(({
  as: as2 = "button",
  icon,
  label,
  href = null,
  className,
  loading,
  ...props
}, forwardedRef) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    className: clsx(className, classes$D.TrailingAction),
    children: icon ? /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, {
      as: as2,
      "aria-label": label,
      icon,
      variant: "invisible",
      tooltipDirection: "w",
      href,
      loading,
      "data-loading": Boolean(loading),
      ref: forwardedRef,
      className: classes$D.TrailingActionButton,
      ...props
    }) : (
      // @ts-expect-error shhh
      /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
        variant: "invisible",
        as: as2,
        href,
        loading,
        "data-loading": Boolean(loading),
        ref: forwardedRef,
        className: classes$D.TrailingActionButton,
        ...props,
        children: label
      })
    )
  });
});
const SubItem = ({
  children
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
    children
  });
};
SubItem.displayName = "ActionList.SubItem";
const ButtonItemContainerNoBox = /* @__PURE__ */ React__default.forwardRef(({
  children,
  style: style3,
  ...props
}, forwardedRef) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("button", {
    type: "button",
    ref: forwardedRef,
    style: style3,
    ...props,
    children
  });
});
const DivItemContainerNoBox = /* @__PURE__ */ React__default.forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    ref: forwardedRef,
    ...props,
    children
  });
});
const Item$1 = /* @__PURE__ */ React__default.forwardRef(({
  variant: variant3 = "default",
  size: size2 = "medium",
  disabled = false,
  inactiveText,
  selected = void 0,
  active = false,
  onSelect: onSelectUser,
  sx: sxProp,
  id,
  role,
  loading,
  _PrivateItemWrapper,
  className,
  groupId: _groupId,
  renderItem: _renderItem,
  handleAddItem: _handleAddItem,
  ...props
}, forwardedRef) => {
  var _slots$trailingVisual, _slots$description$pr, _slots$description;
  const baseSlots = {
    leadingVisual: LeadingVisual,
    trailingVisual: TrailingVisual,
    trailingAction: TrailingAction,
    subItem: SubItem
  };
  const [partialSlots, childrenWithoutSlots] = useSlots(props.children, {
    ...baseSlots,
    description: Description$1
  });
  const slots = {
    description: void 0,
    ...partialSlots
  };
  const {
    container,
    afterSelect,
    selectionAttribute,
    defaultTrailingVisual
  } = React__default.useContext(ActionListContainerContext);
  const wrappedDefaultTrailingVisual = defaultTrailingVisual ? /* @__PURE__ */ jsxRuntimeExports.jsx(TrailingVisual, {
    children: defaultTrailingVisual
  }) : null;
  const trailingVisual = (_slots$trailingVisual = slots.trailingVisual) !== null && _slots$trailingVisual !== void 0 ? _slots$trailingVisual : wrappedDefaultTrailingVisual;
  const {
    role: listRole,
    selectionVariant: listSelectionVariant
  } = React__default.useContext(ListContext);
  const {
    selectionVariant: groupSelectionVariant
  } = React__default.useContext(GroupContext);
  const inactive = Boolean(inactiveText);
  const menuContext = container === "ActionMenu" || container === "SelectPanel";
  const showInactiveIndicator = inactive && !(listRole !== void 0 && ["menu", "listbox"].includes(listRole));
  const onSelect = React__default.useCallback((event, afterSelect2) => {
    if (typeof onSelectUser === "function") onSelectUser(event);
    if (event.defaultPrevented) return;
    if (typeof afterSelect2 === "function") afterSelect2(event);
  }, [onSelectUser]);
  const selectionVariant = groupSelectionVariant ? groupSelectionVariant : listSelectionVariant;
  let inferredItemRole;
  if (container === "ActionMenu") {
    if (selectionVariant === "single") inferredItemRole = "menuitemradio";
    else if (selectionVariant === "multiple") inferredItemRole = "menuitemcheckbox";
    else inferredItemRole = "menuitem";
  } else if (listRole === "listbox") {
    if (selectionVariant !== void 0 && !role) inferredItemRole = "option";
  }
  const itemRole = role || inferredItemRole;
  if (slots.trailingAction) {
    !!menuContext ? process.env.NODE_ENV !== "production" ? invariant(false, `ActionList.TrailingAction can not be used within a list with an ARIA role of "menu" or "listbox".`) : invariant(false) : void 0;
  }
  let inferredSelectionAttribute;
  if (itemRole === "menuitemradio" || itemRole === "menuitemcheckbox") inferredSelectionAttribute = "aria-checked";
  else if (itemRole === "option") inferredSelectionAttribute = "aria-selected";
  const itemSelectionAttribute = selectionAttribute || inferredSelectionAttribute;
  const listItemSemantics = role === "option" || role === "menuitem" || role === "menuitemradio" || role === "menuitemcheckbox";
  const listRoleTypes = ["listbox", "menu", "list"];
  const listSemantics = listRole && listRoleTypes.includes(listRole) || inactive || listItemSemantics;
  const buttonSemantics = !listSemantics && !_PrivateItemWrapper;
  const clickHandler2 = React__default.useCallback((event) => {
    if (disabled || inactive || loading) return;
    onSelect(event, afterSelect);
  }, [onSelect, disabled, inactive, afterSelect, loading]);
  const keyPressHandler = React__default.useCallback((event) => {
    if (disabled || inactive || loading) return;
    if ([" ", "Enter"].includes(event.key)) {
      if (event.key === " ") {
        event.preventDefault();
        event.defaultPrevented = false;
      }
      onSelect(event, afterSelect);
    }
  }, [onSelect, disabled, loading, inactive, afterSelect]);
  const itemId = useId(id);
  const labelId = `${itemId}--label`;
  const inlineDescriptionId = `${itemId}--inline-description`;
  const blockDescriptionId = `${itemId}--block-description`;
  const trailingVisualId = `${itemId}--trailing-visual`;
  const inactiveWarningId = inactive && !showInactiveIndicator ? `${itemId}--warning-message` : void 0;
  const DefaultItemWrapper = listSemantics ? DivItemContainerNoBox : ButtonItemContainerNoBox;
  const ItemWrapper = _PrivateItemWrapper || DefaultItemWrapper;
  const selectableRoles = ["menuitemradio", "menuitemcheckbox", "option"];
  const includeSelectionAttribute = itemSelectionAttribute && itemRole && selectableRoles.includes(itemRole);
  let focusable;
  if (showInactiveIndicator) {
    focusable = true;
  }
  const descriptionVariant = (_slots$description$pr = (_slots$description = slots.description) === null || _slots$description === void 0 ? void 0 : _slots$description.props.variant) !== null && _slots$description$pr !== void 0 ? _slots$description$pr : "inline";
  const menuItemProps = {
    onClick: clickHandler2,
    onKeyPress: !buttonSemantics ? keyPressHandler : void 0,
    "aria-disabled": disabled ? true : void 0,
    "data-inactive": inactive ? true : void 0,
    "data-loading": loading && !inactive ? true : void 0,
    tabIndex: focusable ? void 0 : 0,
    "aria-labelledby": `${labelId} ${slots.trailingVisual ? trailingVisualId : ""} ${slots.description && descriptionVariant === "inline" ? inlineDescriptionId : ""}`,
    "aria-describedby": [slots.description && descriptionVariant === "block" ? blockDescriptionId : void 0, inactiveWarningId !== null && inactiveWarningId !== void 0 ? inactiveWarningId : void 0].filter(String).join(" ").trim() || void 0,
    ...includeSelectionAttribute && {
      [itemSelectionAttribute]: selected
    },
    role: itemRole,
    id: itemId
  };
  const containerProps = _PrivateItemWrapper ? {
    role: itemRole ? "none" : void 0,
    ...props
  } : (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    listSemantics && {
      ...menuItemProps,
      ...props,
      ref: forwardedRef
    } || {}
  );
  const wrapperProps = _PrivateItemWrapper ? menuItemProps : !listSemantics && {
    ...menuItemProps,
    ...props,
    ref: forwardedRef
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ItemContext.Provider, {
    value: {
      variant: variant3,
      size: size2,
      disabled,
      inactive: Boolean(inactiveText),
      inlineDescriptionId,
      blockDescriptionId,
      trailingVisualId
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(BoxWithFallback, {
      ...containerProps,
      as: "li",
      sx: sxProp,
      ref: listSemantics ? forwardedRef : null,
      "data-variant": variant3 === "danger" ? variant3 : void 0,
      "data-active": active ? true : void 0,
      "data-inactive": inactiveText ? true : void 0,
      "data-has-subitem": slots.subItem ? true : void 0,
      "data-has-description": slots.description ? true : false,
      className: clsx(classes$D.ActionListItem, className),
      children: [/* @__PURE__ */ jsxRuntimeExports.jsxs(ItemWrapper, {
        ...wrapperProps,
        className: classes$D.ActionListContent,
        "data-size": size2,
        children: [/* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: classes$D.Spacer
        }), /* @__PURE__ */ jsxRuntimeExports.jsx(Selection$1, {
          selected,
          className: classes$D.LeadingAction
        }), /* @__PURE__ */ jsxRuntimeExports.jsx(VisualOrIndicator, {
          inactiveText: showInactiveIndicator ? inactiveText : void 0,
          itemHasLeadingVisual: Boolean(slots.leadingVisual),
          labelId,
          loading,
          position: "leading",
          children: slots.leadingVisual
        }), /* @__PURE__ */ jsxRuntimeExports.jsxs("span", {
          className: classes$D.ActionListSubContent,
          "data-component": "ActionList.Item--DividerContainer",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(ConditionalWrapper, {
              if: !!slots.description,
              className: classes$D.ItemDescriptionWrap,
              "data-description-variant": descriptionVariant,
              children: [/* @__PURE__ */ jsxRuntimeExports.jsxs("span", {
                id: labelId,
                className: classes$D.ItemLabel,
                children: [childrenWithoutSlots, loading === true && !inactive && /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden, {
                  children: "Loading"
                })]
              }), slots.description]
            }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(VisualOrIndicator, {
              inactiveText: showInactiveIndicator ? inactiveText : void 0,
              itemHasLeadingVisual: Boolean(slots.leadingVisual),
              labelId,
              loading,
              position: "trailing",
              children: trailingVisual
            }),
            // If the item is inactive, but it's not in an overlay (e.g. ActionMenu, SelectPanel),
            // render the inactive warning message directly in the item.
            !showInactiveIndicator && inactiveText ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
              className: classes$D.InactiveWarning,
              id: inactiveWarningId,
              children: inactiveText
            }) : null
          ]
        })]
      }), !inactive && !loading && !menuContext && Boolean(slots.trailingAction) && slots.trailingAction, slots.subItem]
    })
  });
});
Item$1.displayName = "ActionList.Item";
var classes$x = { "Link": "prc-Link-Link-85e08" };
const Link$1 = /* @__PURE__ */ forwardRef$1(({
  as: Component2 = "a",
  className,
  inline: inline2,
  underline,
  hoverColor,
  ...props
}, forwardedRef) => {
  const innerRef = React__default.useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  if (process.env.NODE_ENV !== "production") {
    useEffect(() => {
      if (innerRef.current && !(innerRef.current instanceof HTMLButtonElement) && !(innerRef.current instanceof HTMLAnchorElement)) {
        console.error("Error: Found `Link` component that renders an inaccessible element", innerRef.current, "Please ensure `Link` always renders as <a> or <button>");
      }
    }, [innerRef]);
  }
  if (props.sx) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, {
      as: Component2,
      className: clsx(className, classes$x.Link),
      "data-muted": props.muted,
      "data-inline": inline2,
      "data-underline": underline,
      "data-hover-color": hoverColor,
      ...props,
      // @ts-ignore shh
      ref: innerRef
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, {
    className: clsx(className, classes$x.Link),
    "data-muted": props.muted,
    "data-inline": inline2,
    "data-underline": underline,
    "data-hover-color": hoverColor,
    ...props,
    // @ts-ignore shh
    ref: innerRef
  });
});
Link$1.displayName = "Link";
const LinkItem = /* @__PURE__ */ React__default.forwardRef(({
  sx: sx2,
  active,
  inactiveText,
  variant: variant3,
  as: Component2,
  className,
  ...props
}, forwardedRef) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Item$1, {
    className,
    active,
    inactiveText,
    "data-inactive": inactiveText ? true : void 0,
    variant: variant3,
    sx: sx2,
    _PrivateItemWrapper: ({
      children,
      onClick,
      ...rest
    }) => {
      const clickHandler2 = (event) => {
        onClick && onClick(event);
        props.onClick && props.onClick(event);
      };
      return inactiveText ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        ...rest,
        children
      }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Link$1, {
        as: Component2,
        ...rest,
        ...props,
        onClick: clickHandler2,
        ref: forwardedRef,
        children
      });
    },
    children: props.children
  });
});
LinkItem.displayName = "ActionList.LinkItem";
const Divider$1 = ({
  sx: sx2,
  className
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
    className: clsx(className, classes$D.Divider),
    as: "li",
    "aria-hidden": "true",
    sx: sx2,
    "data-component": "ActionList.Divider"
  });
};
Divider$1.displayName = "Divider";
const ActionList = Object.assign(List, {
  /** Collects related `Items` in an `ActionList`. */
  Group,
  /** An actionable or selectable `Item` */
  Item: Item$1,
  /** A `Item` that renders a full-size anchor inside ListItem */
  LinkItem,
  /** Visually separates `Item`s or `Group`s in an `ActionList`. */
  Divider: Divider$1,
  /** Secondary text which provides additional information about an `Item`. */
  Description: Description$1,
  /** Icon (or similar) positioned before `Item` text. */
  LeadingVisual,
  /** Icon (or similar) positioned after `Item` text. */
  TrailingVisual,
  /** Heading for an `ActionList`. */
  Heading: Heading$3,
  /** Heading for `ActionList.Group` */
  GroupHeading,
  /** Secondary action */
  TrailingAction
});
var classes$w = { "Label": "prc-Label-Label--LG6X" };
const Label = /* @__PURE__ */ React__default.forwardRef(function Label2(t0, ref2) {
  const $2 = distExports.c(23);
  let as2;
  let className;
  let rest;
  let t1;
  let t2;
  if ($2[0] !== t0) {
    ({
      as: as2,
      size: t1,
      variant: t2,
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = as2;
    $2[2] = className;
    $2[3] = rest;
    $2[4] = t1;
    $2[5] = t2;
  } else {
    as2 = $2[1];
    className = $2[2];
    rest = $2[3];
    t1 = $2[4];
    t2 = $2[5];
  }
  const size2 = t1 === void 0 ? "small" : t1;
  const variant3 = t2 === void 0 ? "default" : t2;
  const Component2 = as2 || "span";
  if (rest.sx) {
    let t32;
    if ($2[6] !== className) {
      t32 = clsx(className, classes$w.Label);
      $2[6] = className;
      $2[7] = t32;
    } else {
      t32 = $2[7];
    }
    let t42;
    if ($2[8] !== Component2 || $2[9] !== ref2 || $2[10] !== rest || $2[11] !== size2 || $2[12] !== t32 || $2[13] !== variant3) {
      t42 = /* @__PURE__ */ jsxRuntimeExports.jsx(Box, {
        as: Component2,
        className: t32,
        "data-size": size2,
        "data-variant": variant3,
        ref: ref2,
        ...rest
      });
      $2[8] = Component2;
      $2[9] = ref2;
      $2[10] = rest;
      $2[11] = size2;
      $2[12] = t32;
      $2[13] = variant3;
      $2[14] = t42;
    } else {
      t42 = $2[14];
    }
    return t42;
  }
  let t3;
  if ($2[15] !== className) {
    t3 = clsx(className, classes$w.Label);
    $2[15] = className;
    $2[16] = t3;
  } else {
    t3 = $2[16];
  }
  let t4;
  if ($2[17] !== Component2 || $2[18] !== rest || $2[19] !== size2 || $2[20] !== t3 || $2[21] !== variant3) {
    t4 = /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, {
      className: t3,
      "data-size": size2,
      "data-variant": variant3,
      ...rest
    });
    $2[17] = Component2;
    $2[18] = rest;
    $2[19] = size2;
    $2[20] = t3;
    $2[21] = variant3;
    $2[22] = t4;
  } else {
    t4 = $2[22];
  }
  return t4;
});
function buildPaginationModel(pageCount, currentPage, showPages, marginPageCount, surroundingPageCount) {
  const prev2 = {
    type: "PREV",
    num: currentPage - 1,
    disabled: currentPage === 1
  };
  const next2 = {
    type: "NEXT",
    num: currentPage + 1,
    disabled: currentPage === pageCount
  };
  if (!showPages) {
    return [prev2, next2];
  }
  if (pageCount <= 0) {
    return [prev2, {
      ...next2,
      disabled: true
    }];
  }
  const pages = [];
  const standardGap = surroundingPageCount + marginPageCount;
  const maxVisiblePages = standardGap + standardGap + 3;
  if (pageCount <= maxVisiblePages) {
    addPages(1, pageCount, false);
    return [prev2, ...pages, next2];
  }
  let startGap = 0;
  let startOffset = 0;
  if (currentPage - standardGap - 1 <= 1) {
    startOffset = currentPage - standardGap - 2;
  } else {
    startGap = currentPage - standardGap - 1;
  }
  let endGap = 0;
  let endOffset = 0;
  if (pageCount - currentPage - standardGap <= 1) {
    endOffset = pageCount - currentPage - standardGap - 1;
  } else {
    endGap = pageCount - currentPage - standardGap;
  }
  const hasStartEllipsis = startGap > 0;
  const hasEndEllipsis = endGap > 0;
  addPages(1, marginPageCount, hasStartEllipsis);
  if (hasStartEllipsis) {
    addEllipsis(marginPageCount);
  }
  addPages(marginPageCount + startGap + endOffset + 1, pageCount - startOffset - endGap - marginPageCount, hasEndEllipsis);
  if (hasEndEllipsis) {
    addEllipsis(pageCount - startOffset - endGap - marginPageCount);
  }
  addPages(pageCount - marginPageCount + 1, pageCount);
  return [prev2, ...pages, next2];
  function addEllipsis(previousPage) {
    pages.push({
      type: "BREAK",
      num: previousPage + 1
    });
  }
  function addPages(start4, end2, precedesBreak = false) {
    for (let i = start4; i <= end2; i++) {
      pages.push({
        type: "NUM",
        num: i,
        selected: i === currentPage,
        precedesBreak: i === end2 && precedesBreak
      });
    }
  }
}
var styles$7 = { "List": "prc-ActionBar-List-Z4LzW", "Nav": "prc-ActionBar-Nav-hc-9G", "Divider": "prc-ActionBar-Divider-CcBO8" };
var styles$6 = { "ActionMenuContainer": "prc-ActionMenu-ActionMenuContainer-XdFHv" };
function useProvidedStateOrCreate(externalState, setExternalState, defaultState) {
  const $2 = distExports.c(5);
  const [internalState, setInternalState] = useState(defaultState);
  const state = externalState !== null && externalState !== void 0 ? externalState : internalState;
  let t0;
  if ($2[0] !== setExternalState) {
    t0 = (s2) => {
      setInternalState(s2);
      if (setExternalState) {
        setExternalState(s2);
      }
    };
    $2[0] = setExternalState;
    $2[1] = t0;
  } else {
    t0 = $2[1];
  }
  const setState = t0;
  let t1;
  if ($2[2] !== setState || $2[3] !== state) {
    t1 = [state, setState];
    $2[2] = setState;
    $2[3] = state;
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  return t1;
}
const useMenuInitialFocus = (open, containerRef, anchorRef) => {
  const [openingGesture, setOpeningGesture] = React__default.useState(void 0);
  React__default.useEffect(function inferOpeningKey() {
    const anchorElement = anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current;
    const clickHandler2 = (event) => {
      if (event.detail !== 0) setOpeningGesture("mouse-click");
    };
    const keydownHandler2 = (event) => {
      if (["Space", "Enter", "ArrowDown", "ArrowUp"].includes(event.code)) {
        setOpeningGesture(event.code);
      }
    };
    anchorElement === null || anchorElement === void 0 ? void 0 : anchorElement.addEventListener("click", clickHandler2);
    anchorElement === null || anchorElement === void 0 ? void 0 : anchorElement.addEventListener("keydown", keydownHandler2);
    return () => {
      anchorElement === null || anchorElement === void 0 ? void 0 : anchorElement.removeEventListener("click", clickHandler2);
      anchorElement === null || anchorElement === void 0 ? void 0 : anchorElement.removeEventListener("keydown", keydownHandler2);
    };
  }, [anchorRef]);
  React__default.useEffect(
    function moveFocusOnOpen() {
      if (!open || !(containerRef !== null && containerRef !== void 0 && containerRef.current)) return;
      const iterable = iterateFocusableElements(containerRef.current);
      if (openingGesture === "mouse-click") {
        if (anchorRef !== null && anchorRef !== void 0 && anchorRef.current) anchorRef.current.focus();
        else throw new Error("For focus management, please attach anchorRef");
      } else if (openingGesture && ["ArrowDown", "Space", "Enter"].includes(openingGesture)) {
        const firstElement = iterable.next().value;
        setTimeout(() => firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus());
      } else if ("ArrowUp" === openingGesture) {
        const elements = [...iterable];
        const lastElement = elements[elements.length - 1];
        setTimeout(() => lastElement.focus());
      } else {
        const firstElement = iterable.next().value;
        setTimeout(() => firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus());
      }
    },
    // we don't want containerRef in dependencies
    // because re-renders to containerRef while it's open should not fire initialMenuFocus
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [open, openingGesture, anchorRef]
  );
};
const useMnemonics = (open, providedRef) => {
  const $2 = distExports.c(9);
  const containerRef = useProvidedRefOrCreate(providedRef);
  let t0;
  let t1;
  if ($2[0] !== containerRef || $2[1] !== open) {
    t0 = function addAriaKeyshortcuts() {
      if (!open || !containerRef.current) {
        return;
      }
      const container = containerRef.current;
      const focusableItems = [...iterateFocusableElements(container)];
      focusableItems.map(_temp$7);
    };
    t1 = [open, containerRef];
    $2[0] = containerRef;
    $2[1] = open;
    $2[2] = t0;
    $2[3] = t1;
  } else {
    t0 = $2[2];
    t1 = $2[3];
  }
  React__default.useEffect(t0, t1);
  let t2;
  if ($2[4] !== containerRef || $2[5] !== open) {
    t2 = [open, containerRef];
    $2[4] = containerRef;
    $2[5] = open;
    $2[6] = t2;
  } else {
    t2 = $2[6];
  }
  React__default.useEffect(function handleKeyDown2() {
    if (!open || !containerRef.current) {
      return;
    }
    const container_0 = containerRef.current;
    const handler = (event) => {
      var _elementToFocus;
      const activeElement = document.activeElement;
      if (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA") {
        return;
      }
      const hasModifier = event.ctrlKey || event.altKey || event.metaKey;
      if (hasModifier) {
        return;
      }
      if (!isAlphabetKey(event)) {
        return;
      }
      event.stopPropagation();
      const query = event.key.toLowerCase();
      let elementToFocus;
      const focusableItems_0 = [...iterateFocusableElements(container_0)];
      const itemsMatchingKey = focusableItems_0.filter((item_0) => {
        var _item_0$getAttribute;
        const keyshortcuts = (_item_0$getAttribute = item_0.getAttribute("aria-keyshortcuts")) === null || _item_0$getAttribute === void 0 ? void 0 : _item_0$getAttribute.split(" ").map(_temp2$4);
        return keyshortcuts && keyshortcuts.includes(query);
      });
      const currentActiveIndex = itemsMatchingKey.indexOf(activeElement);
      if (currentActiveIndex === itemsMatchingKey.length - 1) {
        elementToFocus = itemsMatchingKey[0];
      } else {
        elementToFocus = itemsMatchingKey.find((item_1, index2) => index2 > currentActiveIndex);
      }
      (_elementToFocus = elementToFocus) === null || _elementToFocus === void 0 ? void 0 : _elementToFocus.focus();
    };
    container_0.addEventListener("keydown", handler);
    return () => container_0.removeEventListener("keydown", handler);
  }, t2);
  const isAlphabetKey = _temp3$2;
  let t3;
  if ($2[7] !== containerRef) {
    t3 = {
      containerRef
    };
    $2[7] = containerRef;
    $2[8] = t3;
  } else {
    t3 = $2[8];
  }
  return t3;
};
function _temp$7(item) {
  var _item$textContent;
  if (item.getAttribute("aria-keyshortcuts")) {
    return;
  }
  const firstLetter = (_item$textContent = item.textContent) === null || _item$textContent === void 0 ? void 0 : _item$textContent.toLowerCase()[0];
  if (firstLetter) {
    item.setAttribute("aria-keyshortcuts", firstLetter);
  }
}
function _temp2$4(shortcut) {
  return shortcut.toLowerCase();
}
function _temp3$2(event_0) {
  return event_0.key.length === 1 && /[a-z\d]/i.test(event_0.key);
}
const useMenuKeyboardNavigation = (open, onClose, containerRef, anchorRef, t0) => {
  const isSubmenu = t0 === void 0 ? false : t0;
  useMenuInitialFocus(open, containerRef, anchorRef);
  useMnemonics(open, containerRef);
  useCloseMenuOnTab(open, onClose, containerRef, anchorRef);
  useMoveFocusToMenuItem(open, containerRef, anchorRef);
  useCloseSubmenuOnArrow(open, isSubmenu, onClose, containerRef);
};
const useCloseMenuOnTab = (open, onClose, containerRef, anchorRef) => {
  const $2 = distExports.c(10);
  let t0;
  if ($2[0] !== (anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current) || $2[1] !== (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) || $2[2] !== onClose || $2[3] !== open) {
    t0 = () => {
      const container = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
      const anchor = anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current;
      const handler = (event) => {
        if (open && event.key === "Tab") {
          onClose === null || onClose === void 0 ? void 0 : onClose("tab");
        }
      };
      container === null || container === void 0 ? void 0 : container.addEventListener("keydown", handler);
      anchor === null || anchor === void 0 ? void 0 : anchor.addEventListener("keydown", handler);
      return () => {
        container === null || container === void 0 ? void 0 : container.removeEventListener("keydown", handler);
        anchor === null || anchor === void 0 ? void 0 : anchor.removeEventListener("keydown", handler);
      };
    };
    $2[0] = anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current;
    $2[1] = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
    $2[2] = onClose;
    $2[3] = open;
    $2[4] = t0;
  } else {
    t0 = $2[4];
  }
  let t1;
  if ($2[5] !== anchorRef || $2[6] !== containerRef || $2[7] !== onClose || $2[8] !== open) {
    t1 = [open, onClose, containerRef, anchorRef];
    $2[5] = anchorRef;
    $2[6] = containerRef;
    $2[7] = onClose;
    $2[8] = open;
    $2[9] = t1;
  } else {
    t1 = $2[9];
  }
  React__default.useEffect(t0, t1);
};
const useCloseSubmenuOnArrow = (open, isSubmenu, onClose, containerRef) => {
  const $2 = distExports.c(10);
  let t0;
  if ($2[0] !== (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) || $2[1] !== isSubmenu || $2[2] !== onClose || $2[3] !== open) {
    t0 = () => {
      const container = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
      const handler = (event) => {
        if (open && isSubmenu && event.key === "ArrowLeft") {
          onClose === null || onClose === void 0 ? void 0 : onClose("arrow-left");
        }
      };
      container === null || container === void 0 ? void 0 : container.addEventListener("keydown", handler);
      return () => {
        container === null || container === void 0 ? void 0 : container.removeEventListener("keydown", handler);
      };
    };
    $2[0] = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
    $2[1] = isSubmenu;
    $2[2] = onClose;
    $2[3] = open;
    $2[4] = t0;
  } else {
    t0 = $2[4];
  }
  let t1;
  if ($2[5] !== containerRef || $2[6] !== isSubmenu || $2[7] !== onClose || $2[8] !== open) {
    t1 = [open, onClose, containerRef, isSubmenu];
    $2[5] = containerRef;
    $2[6] = isSubmenu;
    $2[7] = onClose;
    $2[8] = open;
    $2[9] = t1;
  } else {
    t1 = $2[9];
  }
  React__default.useEffect(t0, t1);
};
const useMoveFocusToMenuItem = (open, containerRef, anchorRef) => {
  const $2 = distExports.c(8);
  let t0;
  if ($2[0] !== (anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current) || $2[1] !== (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) || $2[2] !== open) {
    t0 = () => {
      const container = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
      const anchor = anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current;
      const handler = (event) => {
        if (!open || !container) {
          return;
        }
        const iterable = iterateFocusableElements(container);
        if (event.key === "ArrowDown") {
          const firstElement = iterable.next().value;
          setTimeout(() => firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus());
        } else {
          if (event.key === "ArrowUp") {
            const elements = [...iterable];
            const lastElement = elements[elements.length - 1];
            setTimeout(() => lastElement.focus());
          }
        }
      };
      anchor === null || anchor === void 0 ? void 0 : anchor.addEventListener("keydown", handler);
      return () => anchor === null || anchor === void 0 ? void 0 : anchor.addEventListener("keydown", handler);
    };
    $2[0] = anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current;
    $2[1] = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
    $2[2] = open;
    $2[3] = t0;
  } else {
    t0 = $2[3];
  }
  let t1;
  if ($2[4] !== anchorRef || $2[5] !== containerRef || $2[6] !== open) {
    t1 = [open, containerRef, anchorRef];
    $2[4] = anchorRef;
    $2[5] = containerRef;
    $2[6] = open;
    $2[7] = t1;
  } else {
    t1 = $2[7];
  }
  React__default.useEffect(t0, t1);
};
var classes$v = { "ResponsiveCloseButtonContainer": "prc-AnchoredOverlay-ResponsiveCloseButtonContainer-NL5kN", "ResponsiveCloseButton": "prc-AnchoredOverlay-ResponsiveCloseButton-Rr-c2" };
function useAnchoredPosition(settings, dependencies = []) {
  const floatingElementRef = useProvidedRefOrCreate(settings === null || settings === void 0 ? void 0 : settings.floatingElementRef);
  const anchorElementRef = useProvidedRefOrCreate(settings === null || settings === void 0 ? void 0 : settings.anchorElementRef);
  const savedOnPositionChange = React__default.useRef(settings === null || settings === void 0 ? void 0 : settings.onPositionChange);
  const [position4, setPosition] = React__default.useState(void 0);
  const [_2, setPrevHeight] = React__default.useState(void 0);
  const topPositionChanged = (prevPosition, newPosition) => {
    return prevPosition && ["outside-top", "inside-top"].includes(prevPosition.anchorSide) && // either the anchor changed or the element is trying to shrink in height
    (prevPosition.anchorSide !== newPosition.anchorSide || prevPosition.top < newPosition.top);
  };
  const updateElementHeight = () => {
    let heightUpdated = false;
    setPrevHeight((prevHeight) => {
      var _floatingElementRef$c, _floatingElementRef$c2;
      if (prevHeight && prevHeight > ((_floatingElementRef$c = (_floatingElementRef$c2 = floatingElementRef.current) === null || _floatingElementRef$c2 === void 0 ? void 0 : _floatingElementRef$c2.clientHeight) !== null && _floatingElementRef$c !== void 0 ? _floatingElementRef$c : 0)) {
        requestAnimationFrame(() => {
          floatingElementRef.current.style.height = `${prevHeight}px`;
        });
        heightUpdated = true;
      }
      return prevHeight;
    });
    return heightUpdated;
  };
  const updatePosition = React__default.useCallback(
    () => {
      var _floatingElementRef$c5;
      if (floatingElementRef.current instanceof Element && anchorElementRef.current instanceof Element) {
        const newPosition = getAnchoredPosition(floatingElementRef.current, anchorElementRef.current, settings);
        setPosition((prev2) => {
          if (settings !== null && settings !== void 0 && settings.pinPosition && topPositionChanged(prev2, newPosition)) {
            var _anchorElementRef$cur, _anchorElementRef$cur2, _floatingElementRef$c3, _floatingElementRef$c4;
            const anchorTop = (_anchorElementRef$cur = (_anchorElementRef$cur2 = anchorElementRef.current) === null || _anchorElementRef$cur2 === void 0 ? void 0 : _anchorElementRef$cur2.getBoundingClientRect().top) !== null && _anchorElementRef$cur !== void 0 ? _anchorElementRef$cur : 0;
            const elementStillFitsOnTop = anchorTop > ((_floatingElementRef$c3 = (_floatingElementRef$c4 = floatingElementRef.current) === null || _floatingElementRef$c4 === void 0 ? void 0 : _floatingElementRef$c4.clientHeight) !== null && _floatingElementRef$c3 !== void 0 ? _floatingElementRef$c3 : 0);
            if (elementStillFitsOnTop && updateElementHeight()) {
              return prev2;
            }
          }
          if (prev2 && prev2.anchorSide === newPosition.anchorSide) {
            var _savedOnPositionChang;
            (_savedOnPositionChang = savedOnPositionChange.current) === null || _savedOnPositionChang === void 0 ? void 0 : _savedOnPositionChang.call(savedOnPositionChange, newPosition);
          }
          return newPosition;
        });
      } else {
        var _savedOnPositionChang2;
        setPosition(void 0);
        (_savedOnPositionChang2 = savedOnPositionChange.current) === null || _savedOnPositionChang2 === void 0 ? void 0 : _savedOnPositionChang2.call(savedOnPositionChange, void 0);
      }
      setPrevHeight((_floatingElementRef$c5 = floatingElementRef.current) === null || _floatingElementRef$c5 === void 0 ? void 0 : _floatingElementRef$c5.clientHeight);
    },
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [floatingElementRef, anchorElementRef, ...dependencies]
  );
  useIsomorphicLayoutEffect$2(() => {
    savedOnPositionChange.current = settings === null || settings === void 0 ? void 0 : settings.onPositionChange;
  }, [settings === null || settings === void 0 ? void 0 : settings.onPositionChange]);
  useIsomorphicLayoutEffect$2(updatePosition, [updatePosition]);
  useResizeObserver$1(updatePosition);
  useResizeObserver$1(updatePosition, floatingElementRef);
  return {
    floatingElementRef,
    anchorElementRef,
    position: position4
  };
}
var classes$u = { "Overlay": "prc-Overlay-Overlay-dVyJl" };
class FeatureFlagScope {
  static create(flags) {
    return new FeatureFlagScope(flags);
  }
  static merge(a2, b2) {
    const merged = new FeatureFlagScope();
    for (const [key2, value] of a2.flags) {
      merged.flags.set(key2, value);
    }
    for (const [key2, value] of b2.flags) {
      merged.flags.set(key2, value);
    }
    return merged;
  }
  constructor(flags = {}) {
    this.flags = /* @__PURE__ */ new Map();
    for (const [key2, value] of Object.entries(flags)) {
      this.flags.set(key2, value !== null && value !== void 0 ? value : false);
    }
  }
  /**
   * Enable a feature flag
   */
  enable(name2) {
    this.flags.set(name2, true);
  }
  /**
   * Disable a feature flag
   */
  disable(name2) {
    this.flags.set(name2, false);
  }
  /**
   * Check if a feature flag is enabled
   */
  enabled(name2) {
    var _this$flags$get;
    return (_this$flags$get = this.flags.get(name2)) !== null && _this$flags$get !== void 0 ? _this$flags$get : false;
  }
}
const DefaultFeatureFlags = FeatureFlagScope.create({
  primer_react_css_modules_ga: false,
  primer_react_action_list_item_as_button: false,
  primer_react_overlay_overflow: false,
  primer_react_segmented_control_tooltip: false,
  primer_react_select_panel_fullscreen_on_narrow: false,
  primer_react_select_panel_order_selected_at_top: false
});
const FeatureFlagContext = /* @__PURE__ */ createContext(DefaultFeatureFlags);
function useFeatureFlag(flag) {
  const $2 = distExports.c(3);
  const context = useContext(FeatureFlagContext);
  let t0;
  if ($2[0] !== context || $2[1] !== flag) {
    t0 = context.enabled(flag);
    $2[0] = context;
    $2[1] = flag;
    $2[2] = t0;
  } else {
    t0 = $2[2];
  }
  return t0;
}
const heightMap = {
  xsmall: "192px",
  small: "256px",
  medium: "320px",
  large: "432px",
  xlarge: "600px",
  auto: "auto",
  initial: "auto",
  // Passing 'initial' initially applies 'auto'
  "fit-content": "fit-content"
};
const animationDuration = 200;
function getSlideAnimationStartingVector(anchorSide) {
  if (anchorSide !== null && anchorSide !== void 0 && anchorSide.endsWith("bottom")) {
    return {
      x: 0,
      y: -1
    };
  } else if (anchorSide !== null && anchorSide !== void 0 && anchorSide.endsWith("top")) {
    return {
      x: 0,
      y: 1
    };
  } else if (anchorSide !== null && anchorSide !== void 0 && anchorSide.endsWith("right")) {
    return {
      x: -1,
      y: 0
    };
  } else if (anchorSide !== null && anchorSide !== void 0 && anchorSide.endsWith("left")) {
    return {
      x: 1,
      y: 0
    };
  }
  return {
    x: 0,
    y: 0
  };
}
const BaseOverlay = /* @__PURE__ */ React__default.forwardRef(({
  visibility,
  height: height2,
  width: width2,
  top: top2,
  left: left2,
  right: right2,
  bottom: bottom2,
  position: position4,
  style: styleFromProps,
  className,
  maxHeight: maxHeight2,
  maxWidth: maxWidth2,
  ...rest
}, forwardedRef) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
    as: "div",
    ...rest,
    ref: forwardedRef,
    style: {
      left: left2,
      right: right2,
      top: top2,
      bottom: bottom2,
      position: position4,
      ...styleFromProps
    },
    [`data-width-${width2}`]: "",
    [`data-max-width-${maxWidth2}`]: maxWidth2 ? "" : void 0,
    [`data-height-${height2}`]: "",
    [`data-max-height-${maxHeight2}`]: maxHeight2 ? "" : void 0,
    [`data-visibility-${visibility}`]: "",
    [`data-overflow-${rest.overflow}`]: rest.overflow ? "" : void 0,
    className: clsx(className, classes$u.Overlay)
  });
});
const Overlay$1 = /* @__PURE__ */ React__default.forwardRef((t0, forwardedRef) => {
  const $2 = distExports.c(51);
  let anchorSide;
  let ignoreClickRefs;
  let initialFocusRef;
  let left2;
  let onClickOutside;
  let onEscape;
  let portalContainerName;
  let preventFocusOnOpen;
  let props;
  let responsiveVariant;
  let returnFocusRef;
  let right2;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($2[0] !== t0) {
    ({
      anchorSide,
      height: t1,
      ignoreClickRefs,
      initialFocusRef,
      left: left2,
      onClickOutside,
      onEscape,
      portalContainerName,
      preventOverflow: t2,
      preventFocusOnOpen,
      returnFocusRef,
      right: right2,
      role: t3,
      visibility: t4,
      width: t5,
      responsiveVariant,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = anchorSide;
    $2[2] = ignoreClickRefs;
    $2[3] = initialFocusRef;
    $2[4] = left2;
    $2[5] = onClickOutside;
    $2[6] = onEscape;
    $2[7] = portalContainerName;
    $2[8] = preventFocusOnOpen;
    $2[9] = props;
    $2[10] = responsiveVariant;
    $2[11] = returnFocusRef;
    $2[12] = right2;
    $2[13] = t1;
    $2[14] = t2;
    $2[15] = t3;
    $2[16] = t4;
    $2[17] = t5;
  } else {
    anchorSide = $2[1];
    ignoreClickRefs = $2[2];
    initialFocusRef = $2[3];
    left2 = $2[4];
    onClickOutside = $2[5];
    onEscape = $2[6];
    portalContainerName = $2[7];
    preventFocusOnOpen = $2[8];
    props = $2[9];
    responsiveVariant = $2[10];
    returnFocusRef = $2[11];
    right2 = $2[12];
    t1 = $2[13];
    t2 = $2[14];
    t3 = $2[15];
    t4 = $2[16];
    t5 = $2[17];
  }
  const height2 = t1 === void 0 ? "auto" : t1;
  const preventOverflow = t2 === void 0 ? true : t2;
  const role = t3 === void 0 ? "none" : t3;
  const visibility = t4 === void 0 ? "visible" : t4;
  const width2 = t5 === void 0 ? "auto" : t5;
  const overlayRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, overlayRef);
  const {
    theme: theme2
  } = useTheme();
  let t6;
  if ($2[18] !== theme2) {
    t6 = get$3("space.2")(theme2).replace("px", "");
    $2[18] = theme2;
    $2[19] = t6;
  } else {
    t6 = $2[19];
  }
  const slideAnimationDistance = parseInt(t6);
  let t7;
  if ($2[20] !== theme2) {
    t7 = get$3("animation.easeOutCubic")(theme2);
    $2[20] = theme2;
    $2[21] = t7;
  } else {
    t7 = $2[21];
  }
  const slideAnimationEasing = t7;
  let t8;
  if ($2[22] !== ignoreClickRefs || $2[23] !== initialFocusRef || $2[24] !== onClickOutside || $2[25] !== onEscape || $2[26] !== preventFocusOnOpen || $2[27] !== returnFocusRef) {
    t8 = {
      overlayRef,
      returnFocusRef,
      onEscape,
      ignoreClickRefs,
      onClickOutside,
      initialFocusRef,
      preventFocusOnOpen
    };
    $2[22] = ignoreClickRefs;
    $2[23] = initialFocusRef;
    $2[24] = onClickOutside;
    $2[25] = onEscape;
    $2[26] = preventFocusOnOpen;
    $2[27] = returnFocusRef;
    $2[28] = t8;
  } else {
    t8 = $2[28];
  }
  useOverlay(t8);
  let t10;
  let t9;
  if ($2[29] !== height2) {
    t9 = () => {
      var _overlayRef$current;
      if (height2 === "initial" && (_overlayRef$current = overlayRef.current) !== null && _overlayRef$current !== void 0 && _overlayRef$current.clientHeight) {
        overlayRef.current.style.height = `${overlayRef.current.clientHeight}px`;
      }
    };
    t10 = [height2];
    $2[29] = height2;
    $2[30] = t10;
    $2[31] = t9;
  } else {
    t10 = $2[30];
    t9 = $2[31];
  }
  useEffect(t9, t10);
  let t11;
  let t12;
  if ($2[32] !== anchorSide || $2[33] !== slideAnimationDistance || $2[34] !== slideAnimationEasing || $2[35] !== visibility) {
    t11 = () => {
      var _overlayRef$current2;
      const {
        x: x2,
        y: y2
      } = getSlideAnimationStartingVector(anchorSide);
      if (!x2 && !y2 || !((_overlayRef$current2 = overlayRef.current) !== null && _overlayRef$current2 !== void 0 && _overlayRef$current2.animate) || visibility === "hidden") {
        return;
      }
      overlayRef.current.animate({
        transform: [`translate(${slideAnimationDistance * x2}px, ${slideAnimationDistance * y2}px)`, "translate(0, 0)"]
      }, {
        duration: animationDuration,
        easing: slideAnimationEasing
      });
    };
    t12 = [anchorSide, slideAnimationDistance, slideAnimationEasing, visibility];
    $2[32] = anchorSide;
    $2[33] = slideAnimationDistance;
    $2[34] = slideAnimationEasing;
    $2[35] = visibility;
    $2[36] = t11;
    $2[37] = t12;
  } else {
    t11 = $2[36];
    t12 = $2[37];
  }
  useIsomorphicLayoutEffect$2(t11, t12);
  const leftPosition = left2 === void 0 && right2 === void 0 ? 0 : left2;
  const overflowEnabled = useFeatureFlag("primer_react_overlay_overflow");
  const t13 = overflowEnabled || !preventOverflow ? true : void 0;
  let t14;
  if ($2[38] !== height2 || $2[39] !== leftPosition || $2[40] !== props || $2[41] !== responsiveVariant || $2[42] !== right2 || $2[43] !== role || $2[44] !== t13 || $2[45] !== visibility || $2[46] !== width2) {
    t14 = /* @__PURE__ */ jsxRuntimeExports.jsx(BaseOverlay, {
      role,
      width: width2,
      "data-reflow-container": t13,
      ref: overlayRef,
      left: leftPosition,
      right: right2,
      height: height2,
      visibility,
      "data-responsive": responsiveVariant,
      ...props
    });
    $2[38] = height2;
    $2[39] = leftPosition;
    $2[40] = props;
    $2[41] = responsiveVariant;
    $2[42] = right2;
    $2[43] = role;
    $2[44] = t13;
    $2[45] = visibility;
    $2[46] = width2;
    $2[47] = t14;
  } else {
    t14 = $2[47];
  }
  let t15;
  if ($2[48] !== portalContainerName || $2[49] !== t14) {
    t15 = /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
      containerName: portalContainerName,
      children: t14
    });
    $2[48] = portalContainerName;
    $2[49] = t14;
    $2[50] = t15;
  } else {
    t15 = $2[50];
  }
  return t15;
});
const defaultVariant$1 = {
  regular: "anchored",
  narrow: "anchored"
};
const defaultCloseButtonProps = {};
const AnchoredOverlay = ({
  renderAnchor,
  anchorRef: externalAnchorRef,
  anchorId: externalAnchorId,
  children,
  open,
  onOpen,
  onClose,
  height: height2,
  width: width2,
  overlayProps,
  focusTrapSettings,
  focusZoneSettings: focusZoneSettings2,
  side = (overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps["anchorSide"]) || "outside-bottom",
  align = "start",
  alignmentOffset,
  anchorOffset,
  className,
  pinPosition,
  variant: variant3 = defaultVariant$1,
  preventOverflow = true,
  onPositionChange,
  displayCloseButton = true,
  closeButtonProps = defaultCloseButtonProps
}) => {
  const anchorRef = useProvidedRefOrCreate(externalAnchorRef);
  const [overlayRef, updateOverlayRef] = useRenderForcingRef();
  const anchorId = useId(externalAnchorId);
  const onClickOutside = useCallback$1(() => onClose === null || onClose === void 0 ? void 0 : onClose("click-outside"), [onClose]);
  const onEscape = useCallback$1(() => onClose === null || onClose === void 0 ? void 0 : onClose("escape"), [onClose]);
  const onAnchorKeyDown = useCallback$1((event) => {
    if (!event.defaultPrevented) {
      if (!open && ["ArrowDown", "ArrowUp", " ", "Enter"].includes(event.key)) {
        onOpen === null || onOpen === void 0 ? void 0 : onOpen("anchor-key-press", event);
        event.preventDefault();
      }
    }
  }, [open, onOpen]);
  const onAnchorClick = useCallback$1((event_0) => {
    if (event_0.defaultPrevented || event_0.button !== 0) {
      return;
    }
    if (!open) {
      onOpen === null || onOpen === void 0 ? void 0 : onOpen("anchor-click");
    } else {
      onClose === null || onClose === void 0 ? void 0 : onClose("anchor-click");
    }
  }, [open, onOpen, onClose]);
  const positionChange = (position4) => {
    if (onPositionChange && position4) {
      onPositionChange({
        position: position4
      });
    }
  };
  const {
    position: position_0
  } = useAnchoredPosition({
    anchorElementRef: anchorRef,
    floatingElementRef: overlayRef,
    pinPosition,
    side,
    align,
    alignmentOffset,
    anchorOffset,
    onPositionChange: positionChange
  }, [overlayRef.current]);
  useEffect(() => {
    if (!open && overlayRef.current) {
      updateOverlayRef(null);
    }
  }, [open, overlayRef, updateOverlayRef]);
  useFocusZone({
    containerRef: overlayRef,
    disabled: !open || !position_0,
    ...focusZoneSettings2
  });
  useFocusTrap({
    containerRef: overlayRef,
    disabled: !open || !position_0,
    ...focusTrapSettings
  });
  const currentResponsiveVariant = useResponsiveValue(variant3, "anchored");
  const showXIcon = onClose && variant3.narrow === "fullscreen" && displayCloseButton;
  const XButtonAriaLabelledBy = closeButtonProps["aria-labelledby"];
  const XButtonAriaLabel = closeButtonProps["aria-label"];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [renderAnchor && renderAnchor({
      ref: anchorRef,
      id: anchorId,
      "aria-haspopup": "true",
      "aria-expanded": open,
      tabIndex: 0,
      onClick: onAnchorClick,
      onKeyDown: onAnchorKeyDown
    }), open ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Overlay$1, {
      returnFocusRef: anchorRef,
      onClickOutside,
      ignoreClickRefs: [anchorRef],
      onEscape,
      ref: updateOverlayRef,
      role: "none",
      visibility: position_0 ? "visible" : "hidden",
      height: height2,
      width: width2,
      top: currentResponsiveVariant === "anchored" ? (position_0 === null || position_0 === void 0 ? void 0 : position_0.top) || 0 : void 0,
      left: currentResponsiveVariant === "anchored" ? (position_0 === null || position_0 === void 0 ? void 0 : position_0.left) || 0 : void 0,
      responsiveVariant: variant3.narrow === "fullscreen" ? "fullscreen" : void 0,
      "data-variant": currentResponsiveVariant,
      anchorSide: position_0 === null || position_0 === void 0 ? void 0 : position_0.anchorSide,
      className,
      preventOverflow,
      ...overlayProps,
      children: [showXIcon ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
        className: classes$v.ResponsiveCloseButtonContainer,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, {
          ...closeButtonProps,
          type: "button",
          variant: "invisible",
          icon: XIcon,
          ...XButtonAriaLabelledBy ? {
            "aria-labelledby": XButtonAriaLabelledBy,
            "aria-label": void 0
          } : {
            "aria-label": XButtonAriaLabel !== null && XButtonAriaLabel !== void 0 ? XButtonAriaLabel : "Close",
            "aria-labelledby": void 0
          },
          className: clsx(classes$v.ResponsiveCloseButton, closeButtonProps.className),
          onClick: () => {
            onClose("close");
          }
        })
      }) : null, children]
    }) : null]
  });
};
AnchoredOverlay.displayName = "AnchoredOverlay";
const MenuContext = /* @__PURE__ */ React__default.createContext({
  renderAnchor: null,
  open: false
});
const mergeAnchorHandlers = (anchorProps, buttonProps) => {
  const mergedAnchorProps = {
    ...anchorProps
  };
  if (typeof buttonProps.onClick === "function") {
    const anchorOnClick = anchorProps.onClick;
    const mergedOnClick = (event) => {
      var _buttonProps$onClick;
      (_buttonProps$onClick = buttonProps.onClick) === null || _buttonProps$onClick === void 0 ? void 0 : _buttonProps$onClick.call(buttonProps, event);
      anchorOnClick === null || anchorOnClick === void 0 ? void 0 : anchorOnClick(event);
    };
    mergedAnchorProps.onClick = mergedOnClick;
  }
  if (typeof buttonProps.onKeyDown === "function") {
    const anchorOnKeyDown = anchorProps.onKeyDown;
    const mergedOnAnchorKeyDown = (event) => {
      var _buttonProps$onKeyDow;
      (_buttonProps$onKeyDow = buttonProps.onKeyDown) === null || _buttonProps$onKeyDow === void 0 ? void 0 : _buttonProps$onKeyDow.call(buttonProps, event);
      anchorOnKeyDown === null || anchorOnKeyDown === void 0 ? void 0 : anchorOnKeyDown(event);
    };
    mergedAnchorProps.onKeyDown = mergedOnAnchorKeyDown;
  }
  return mergedAnchorProps;
};
const Menu = ({
  anchorRef: externalAnchorRef,
  open,
  onOpenChange,
  children
}) => {
  const parentMenuContext = useContext(MenuContext);
  const [combinedOpenState, setCombinedOpenState] = useProvidedStateOrCreate(open, onOpenChange, false);
  const onOpen = React__default.useCallback(() => setCombinedOpenState(true), [setCombinedOpenState]);
  const isNarrow = useResponsiveValue({
    narrow: true
  }, false);
  const onClose = React__default.useCallback((gesture) => {
    var _parentMenuContext$on;
    if (isNarrow && open && gesture === "tab") {
      return;
    }
    setCombinedOpenState(false);
    switch (gesture) {
      case "tab":
      case "item-select":
        (_parentMenuContext$on = parentMenuContext.onClose) === null || _parentMenuContext$on === void 0 ? void 0 : _parentMenuContext$on.call(parentMenuContext, gesture);
    }
  }, [setCombinedOpenState, parentMenuContext, open, isNarrow]);
  const menuButtonChild = React__default.Children.toArray(children).find((child) => /* @__PURE__ */ React__default.isValidElement(child) && (child.type === MenuButton || child.type === Anchor));
  const menuButtonChildId = /* @__PURE__ */ React__default.isValidElement(menuButtonChild) ? menuButtonChild.props.id : void 0;
  const anchorRef = useProvidedRefOrCreate(externalAnchorRef);
  const anchorId = useId(menuButtonChildId);
  let renderAnchor = null;
  const contents = React__default.Children.map(children, (child) => {
    if (child.type === Tooltip) {
      const anchorChildren = child.props.children;
      if (anchorChildren.type === MenuButton) {
        renderAnchor = (anchorProps) => {
          const triggerButton = /* @__PURE__ */ React__default.cloneElement(anchorChildren, mergeAnchorHandlers({
            ...anchorProps
          }, anchorChildren.props));
          return /* @__PURE__ */ React__default.cloneElement(child, {
            children: triggerButton,
            ref: anchorRef
          });
        };
      }
      return null;
    } else if (child.type === Anchor) {
      const anchorChildren = child.props.children;
      const isWrappedWithTooltip = anchorChildren !== void 0 ? anchorChildren.type === Tooltip : false;
      if (isWrappedWithTooltip) {
        if (anchorChildren.props.children !== null) {
          renderAnchor = (anchorProps) => {
            const tooltipTrigger = anchorChildren.props.children;
            const tooltipTriggerEl = /* @__PURE__ */ React__default.cloneElement(tooltipTrigger, mergeAnchorHandlers({
              ...anchorProps
            }, tooltipTrigger.props));
            const tooltip = /* @__PURE__ */ React__default.cloneElement(anchorChildren, {
              children: tooltipTriggerEl
            });
            return /* @__PURE__ */ React__default.cloneElement(child, {
              children: tooltip,
              ref: anchorRef
            });
          };
        }
      } else {
        renderAnchor = (anchorProps) => /* @__PURE__ */ React__default.cloneElement(child, anchorProps);
      }
      return null;
    } else if (child.type === MenuButton) {
      renderAnchor = (anchorProps) => /* @__PURE__ */ React__default.cloneElement(child, mergeAnchorHandlers(anchorProps, child.props));
      return null;
    } else {
      return child;
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuContext.Provider, {
    value: {
      anchorRef,
      renderAnchor,
      anchorId,
      open: combinedOpenState,
      onOpen,
      onClose,
      // will be undefined for the outermost level, then false for the top menu, then true inside that
      isSubmenu: parentMenuContext.isSubmenu !== void 0
    },
    children: contents
  });
};
Menu.displayName = "Menu";
const Anchor = /* @__PURE__ */ React__default.forwardRef(({
  children: child,
  ...anchorProps
}, anchorRef) => {
  const {
    onOpen,
    isSubmenu
  } = React__default.useContext(MenuContext);
  const openSubmenuOnRightArrow = useCallback$1((event) => {
    if (isSubmenu && event.key === "ArrowRight" && !event.defaultPrevented) onOpen === null || onOpen === void 0 ? void 0 : onOpen("anchor-key-press");
  }, [isSubmenu, onOpen]);
  const onButtonClick = (event) => {
    var _child$props$onClick, _child$props, _anchorProps$onClick;
    (_child$props$onClick = (_child$props = child.props).onClick) === null || _child$props$onClick === void 0 ? void 0 : _child$props$onClick.call(_child$props, event);
    (_anchorProps$onClick = anchorProps.onClick) === null || _anchorProps$onClick === void 0 ? void 0 : _anchorProps$onClick.call(anchorProps, event);
  };
  const onButtonKeyDown = (event) => {
    var _child$props$onKeyDow, _child$props2, _anchorProps$onKeyDow;
    (_child$props$onKeyDow = (_child$props2 = child.props).onKeyDown) === null || _child$props$onKeyDow === void 0 ? void 0 : _child$props$onKeyDow.call(_child$props2, event);
    openSubmenuOnRightArrow(event);
    (_anchorProps$onKeyDow = anchorProps.onKeyDown) === null || _anchorProps$onKeyDow === void 0 ? void 0 : _anchorProps$onKeyDow.call(anchorProps, event);
  };
  const parentActionListContext = useContext(ActionListContainerContext);
  const thisActionListContext = useMemo$1(() => isSubmenu ? {
    ...parentActionListContext,
    defaultTrailingVisual: /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronRightIcon, {}),
    // Default behavior is to close after selecting; we want to open the submenu instead
    afterSelect: () => onOpen === null || onOpen === void 0 ? void 0 : onOpen("anchor-click")
  } : parentActionListContext, [isSubmenu, onOpen, parentActionListContext]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionListContainerContext.Provider, {
    value: thisActionListContext,
    children: /* @__PURE__ */ React__default.cloneElement(child, {
      ...anchorProps,
      ref: anchorRef,
      onClick: onButtonClick,
      onKeyDown: onButtonKeyDown
    })
  });
});
const MenuButton = /* @__PURE__ */ React__default.forwardRef(({
  ...props
}, anchorRef) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Anchor, {
    ref: anchorRef,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
      type: "button",
      trailingAction: TriangleDownIcon,
      ...props
    })
  });
});
const defaultVariant = {
  regular: "anchored",
  narrow: "anchored"
};
const Overlay = ({
  children,
  align = "start",
  side,
  onPositionChange,
  "aria-labelledby": ariaLabelledby,
  variant: variant3 = defaultVariant,
  ...overlayProps
}) => {
  const {
    anchorRef,
    renderAnchor,
    anchorId,
    open,
    onOpen,
    onClose,
    isSubmenu = false
  } = React__default.useContext(MenuContext);
  const containerRef = React__default.useRef(null);
  useMenuKeyboardNavigation(open, onClose, containerRef, anchorRef, isSubmenu);
  const isNarrow = useResponsiveValue({
    narrow: true
  }, false);
  const responsiveVariant = useResponsiveValue(variant3, {
    regular: "anchored",
    narrow: "anchored"
  });
  const isNarrowFullscreen = !!isNarrow && variant3.narrow === "fullscreen";
  const [anchorAriaLabelledby, setAnchorAriaLabelledby] = useState(null);
  useEffect(() => {
    if (anchorRef !== null && anchorRef !== void 0 && anchorRef.current) {
      const ariaLabelledby2 = anchorRef.current.getAttribute("aria-labelledby");
      if (ariaLabelledby2) {
        setAnchorAriaLabelledby(ariaLabelledby2);
      }
    }
  }, [anchorRef]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AnchoredOverlay, {
    anchorRef,
    renderAnchor,
    anchorId,
    open,
    onOpen,
    onClose,
    align,
    side: side !== null && side !== void 0 ? side : isSubmenu ? "outside-right" : "outside-bottom",
    overlayProps,
    focusZoneSettings: isNarrowFullscreen ? {
      disabled: true
    } : {
      focusOutBehavior: "wrap"
    },
    onPositionChange,
    variant: variant3,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      ref: containerRef,
      className: styles$6.ActionMenuContainer,
      "data-variant": responsiveVariant,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionListContainerContext.Provider, {
        value: {
          container: "ActionMenu",
          listRole: "menu",
          // If there is a custom aria-labelledby, use that. Otherwise, if exists, use the id that labels the anchor such as tooltip. If none of them exist, use anchor id.
          listLabelledBy: ariaLabelledby || anchorAriaLabelledby || anchorId,
          selectionAttribute: "aria-checked",
          // Should this be here?
          afterSelect: () => onClose === null || onClose === void 0 ? void 0 : onClose("item-select"),
          enableFocusZone: isNarrowFullscreen
          // AnchoredOverlay takes care of focus zone. We only want to enable this if menu is narrow fullscreen.
        },
        children
      })
    })
  });
};
Overlay.displayName = "Overlay";
Menu.displayName = "ActionMenu";
const ActionMenu = Object.assign(Menu, {
  Button: MenuButton,
  Anchor,
  Overlay,
  Divider: Divider$1
});
const ActionBarContext = /* @__PURE__ */ React__default.createContext({
  size: "medium",
  setChildrenWidth: () => null
});
const MORE_BTN_WIDTH = 86;
const getValidChildren = (children) => {
  return React__default.Children.toArray(children).filter((child) => {
    return /* @__PURE__ */ React__default.isValidElement(child);
  });
};
const calculatePossibleItems = (childWidthArray, navWidth, moreMenuWidth = 0) => {
  const widthToFit = navWidth - moreMenuWidth;
  let breakpoint = childWidthArray.length;
  let sumsOfChildWidth = 0;
  for (const [index2, childWidth] of childWidthArray.entries()) {
    sumsOfChildWidth = sumsOfChildWidth + childWidth.width;
    if (sumsOfChildWidth > widthToFit) {
      breakpoint = index2;
      break;
    } else {
      continue;
    }
  }
  return breakpoint;
};
const overflowEffect = (navWidth, moreMenuWidth, childArray, childWidthArray, updateListAndMenu, hasActiveMenu) => {
  if (childWidthArray.length === 0) {
    updateListAndMenu({
      items: childArray,
      menuItems: []
    });
  }
  const numberOfItemsPossible = calculatePossibleItems(childWidthArray, navWidth);
  const numberOfItemsPossibleWithMoreMenu = calculatePossibleItems(childWidthArray, navWidth, moreMenuWidth || MORE_BTN_WIDTH);
  const items = [];
  const menuItems = [];
  if (childArray.length >= numberOfItemsPossible) {
    const numberOfItemsInMenu = childArray.length - numberOfItemsPossibleWithMoreMenu;
    const numberOfListItems = numberOfItemsInMenu === 1 ? numberOfItemsPossibleWithMoreMenu - 1 : numberOfItemsPossibleWithMoreMenu;
    for (const [index2, child] of childArray.entries()) {
      if (index2 < numberOfListItems) {
        items.push(child);
      } else if (childWidthArray[index2].text === "divider") {
        if (index2 === numberOfListItems - 1 || index2 === numberOfListItems) {
          continue;
        } else {
          const divider = /* @__PURE__ */ React__default.createElement(ActionList.Divider, {
            key: index2
          });
          menuItems.push(divider);
        }
      } else {
        menuItems.push(child);
      }
    }
    updateListAndMenu({
      items,
      menuItems
    });
  } else if (numberOfItemsPossible > childArray.length && hasActiveMenu) {
    updateListAndMenu({
      items: childArray,
      menuItems: []
    });
  }
};
const ActionBar$1 = (props) => {
  const {
    size: size2 = "medium",
    children,
    "aria-label": ariaLabel,
    flush: flush3 = false,
    className
  } = props;
  const [childWidthArray, setChildWidthArray] = useState([]);
  const setChildrenWidth = useCallback$1((size_0) => {
    setChildWidthArray((arr) => {
      const newArr = [...arr, size_0];
      return newArr;
    });
  }, []);
  const navRef = useRef(null);
  const listRef = useRef(null);
  const moreMenuRef = useRef(null);
  const moreMenuBtnRef = useRef(null);
  const containerRef = React__default.useRef(null);
  const validChildren = getValidChildren(children);
  const [responsiveProps, setResponsiveProps] = useState({
    items: validChildren,
    menuItems: []
  });
  const listItems = responsiveProps.items.map((item) => {
    var _validChildren$find;
    return (_validChildren$find = validChildren.find((child) => child.key === item.key)) !== null && _validChildren$find !== void 0 ? _validChildren$find : item;
  });
  const menuItems = responsiveProps.menuItems.map((menuItem) => {
    var _validChildren$find2;
    return (_validChildren$find2 = validChildren.find((child_0) => child_0.key === menuItem.key)) !== null && _validChildren$find2 !== void 0 ? _validChildren$find2 : menuItem;
  });
  const updateListAndMenu = useCallback$1((props_0) => {
    setResponsiveProps(props_0);
  }, []);
  useResizeObserver$1((resizeObserverEntries) => {
    var _moreMenuRef$current$, _moreMenuRef$current;
    const navWidth = resizeObserverEntries[0].contentRect.width;
    const moreMenuWidth = (_moreMenuRef$current$ = (_moreMenuRef$current = moreMenuRef.current) === null || _moreMenuRef$current === void 0 ? void 0 : _moreMenuRef$current.getBoundingClientRect().width) !== null && _moreMenuRef$current$ !== void 0 ? _moreMenuRef$current$ : 0;
    const hasActiveMenu = menuItems.length > 0;
    navWidth !== 0 && overflowEffect(navWidth, moreMenuWidth, validChildren, childWidthArray, updateListAndMenu, hasActiveMenu);
  }, navRef);
  const [isWidgetOpen, setIsWidgetOpen] = useState(false);
  const closeOverlay = React__default.useCallback(() => {
    setIsWidgetOpen(false);
  }, [setIsWidgetOpen]);
  const focusOnMoreMenuBtn = React__default.useCallback(() => {
    var _moreMenuBtnRef$curre;
    (_moreMenuBtnRef$curre = moreMenuBtnRef.current) === null || _moreMenuBtnRef$curre === void 0 ? void 0 : _moreMenuBtnRef$curre.focus();
  }, []);
  useOnEscapePress((event) => {
    if (isWidgetOpen) {
      event.preventDefault();
      closeOverlay();
      focusOnMoreMenuBtn();
    }
  }, [isWidgetOpen]);
  useOnOutsideClick({
    onClickOutside: closeOverlay,
    containerRef,
    ignoreClickRefs: [moreMenuBtnRef]
  });
  useFocusZone({
    containerRef: listRef,
    bindKeys: FocusKeys.ArrowHorizontal | FocusKeys.HomeAndEnd,
    focusOutBehavior: "wrap"
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionBarContext.Provider, {
    value: {
      size: size2,
      setChildrenWidth
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      ref: navRef,
      className: clsx(className, styles$7.Nav),
      "data-flush": flush3,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
        ref: listRef,
        role: "toolbar",
        className: styles$7.List,
        children: [listItems, menuItems.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionMenu, {
          children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Anchor, {
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, {
              variant: "invisible",
              "aria-label": `More ${ariaLabel} items`,
              icon: KebabHorizontalIcon
            })
          }), /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Overlay, {
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList, {
              children: menuItems.map((menuItem_0, index2) => {
                if (menuItem_0.type === ActionList.Divider) {
                  return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Divider, {}, index2);
                } else {
                  const {
                    children: menuItemChildren,
                    onClick,
                    icon: Icon2,
                    "aria-label": ariaLabel_0,
                    disabled
                  } = menuItem_0.props;
                  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionList.Item, {
                    // eslint-disable-next-line primer-react/prefer-action-list-item-onselect
                    onClick: (event_0) => {
                      closeOverlay();
                      focusOnMoreMenuBtn();
                      typeof onClick === "function" && onClick(event_0);
                    },
                    disabled,
                    children: [Icon2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.LeadingVisual, {
                      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon2, {})
                    }) : null, ariaLabel_0]
                  }, menuItemChildren);
                }
              })
            })
          })]
        })]
      })
    })
  });
};
ActionBar$1.displayName = "ActionBar";
const ActionBarIconButton = /* @__PURE__ */ forwardRef$1((t0, forwardedRef) => {
  const $2 = distExports.c(20);
  let disabled;
  let onClick;
  let props;
  if ($2[0] !== t0) {
    ({
      disabled,
      onClick,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = disabled;
    $2[2] = onClick;
    $2[3] = props;
  } else {
    disabled = $2[1];
    onClick = $2[2];
    props = $2[3];
  }
  const backupRef = useRef(null);
  const ref2 = forwardedRef !== null && forwardedRef !== void 0 ? forwardedRef : backupRef;
  const {
    size: size2,
    setChildrenWidth
  } = React__default.useContext(ActionBarContext);
  let t1;
  if ($2[4] !== props || $2[5] !== ref2 || $2[6] !== setChildrenWidth) {
    t1 = () => {
      const text2 = props["aria-label"] ? props["aria-label"] : "";
      const domRect = ref2.current.getBoundingClientRect();
      setChildrenWidth({
        text: text2,
        width: domRect.width
      });
    };
    $2[4] = props;
    $2[5] = ref2;
    $2[6] = setChildrenWidth;
    $2[7] = t1;
  } else {
    t1 = $2[7];
  }
  let t2;
  if ($2[8] !== ref2 || $2[9] !== setChildrenWidth) {
    t2 = [ref2, setChildrenWidth];
    $2[8] = ref2;
    $2[9] = setChildrenWidth;
    $2[10] = t2;
  } else {
    t2 = $2[10];
  }
  useIsomorphicLayoutEffect$2(t1, t2);
  let t3;
  if ($2[11] !== disabled || $2[12] !== onClick) {
    t3 = (event) => {
      var _onClick;
      if (disabled) {
        return;
      }
      (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick(event);
    };
    $2[11] = disabled;
    $2[12] = onClick;
    $2[13] = t3;
  } else {
    t3 = $2[13];
  }
  const clickHandler2 = t3;
  let t4;
  if ($2[14] !== clickHandler2 || $2[15] !== disabled || $2[16] !== props || $2[17] !== ref2 || $2[18] !== size2) {
    t4 = /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, {
      "aria-disabled": disabled,
      ref: ref2,
      size: size2,
      onClick: clickHandler2,
      ...props,
      variant: "invisible"
    });
    $2[14] = clickHandler2;
    $2[15] = disabled;
    $2[16] = props;
    $2[17] = ref2;
    $2[18] = size2;
    $2[19] = t4;
  } else {
    t4 = $2[19];
  }
  return t4;
});
const VerticalDivider$1 = () => {
  const $2 = distExports.c(4);
  const ref2 = useRef(null);
  const {
    setChildrenWidth
  } = React__default.useContext(ActionBarContext);
  let t0;
  let t1;
  if ($2[0] !== setChildrenWidth) {
    t0 = () => {
      const domRect = ref2.current.getBoundingClientRect();
      setChildrenWidth({
        text: "divider",
        width: domRect.width
      });
    };
    t1 = [ref2, setChildrenWidth];
    $2[0] = setChildrenWidth;
    $2[1] = t0;
    $2[2] = t1;
  } else {
    t0 = $2[1];
    t1 = $2[2];
  }
  useIsomorphicLayoutEffect$2(t0, t1);
  let t2;
  if ($2[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      ref: ref2,
      "data-component": "ActionBar.VerticalDivider",
      "aria-hidden": "true",
      className: styles$7.Divider
    });
    $2[3] = t2;
  } else {
    t2 = $2[3];
  }
  return t2;
};
const ActionBar = Object.assign(ActionBar$1, {
  IconButton: ActionBarIconButton,
  Divider: VerticalDivider$1
});
var classes$t = { "Avatar": "prc-Avatar-Avatar-ZRS-m" };
const DEFAULT_AVATAR_SIZE = 20;
const Avatar = /* @__PURE__ */ React__default.forwardRef(function Avatar2(t0, ref2) {
  const $2 = distExports.c(29);
  let className;
  let rest;
  let style3;
  let sxProp;
  let t1;
  let t2;
  let t3;
  if ($2[0] !== t0) {
    ({
      alt: t1,
      size: t2,
      square: t3,
      sx: sxProp,
      className,
      style: style3,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = rest;
    $2[3] = style3;
    $2[4] = sxProp;
    $2[5] = t1;
    $2[6] = t2;
    $2[7] = t3;
  } else {
    className = $2[1];
    rest = $2[2];
    style3 = $2[3];
    sxProp = $2[4];
    t1 = $2[5];
    t2 = $2[6];
    t3 = $2[7];
  }
  const alt = t1 === void 0 ? "" : t1;
  const size2 = t2 === void 0 ? DEFAULT_AVATAR_SIZE : t2;
  const square = t3 === void 0 ? false : t3;
  let t4;
  if ($2[8] !== size2) {
    t4 = isResponsiveValue(size2);
    $2[8] = size2;
    $2[9] = t4;
  } else {
    t4 = $2[9];
  }
  const isResponsive = t4;
  let cssSizeVars;
  if ($2[10] !== isResponsive || $2[11] !== size2) {
    cssSizeVars = {};
    if (isResponsive) {
      for (const [key2, value] of Object.entries(size2)) {
        cssSizeVars[`--avatarSize-${key2}`] = `${value}px`;
      }
    } else {
      cssSizeVars["--avatarSize-regular"] = `${size2}px`;
    }
    $2[10] = isResponsive;
    $2[11] = size2;
    $2[12] = cssSizeVars;
  } else {
    cssSizeVars = $2[12];
  }
  let t5;
  if ($2[13] !== className) {
    t5 = clsx(className, classes$t.Avatar);
    $2[13] = className;
    $2[14] = t5;
  } else {
    t5 = $2[14];
  }
  const t6 = isResponsive ? "" : void 0;
  const t7 = square ? "" : void 0;
  const t8 = isResponsive ? void 0 : size2;
  const t9 = isResponsive ? void 0 : size2;
  let t10;
  if ($2[15] !== cssSizeVars || $2[16] !== style3) {
    t10 = style3 ? {
      ...cssSizeVars,
      ...style3
    } : cssSizeVars;
    $2[15] = cssSizeVars;
    $2[16] = style3;
    $2[17] = t10;
  } else {
    t10 = $2[17];
  }
  let t11;
  if ($2[18] !== alt || $2[19] !== ref2 || $2[20] !== rest || $2[21] !== sxProp || $2[22] !== t10 || $2[23] !== t5 || $2[24] !== t6 || $2[25] !== t7 || $2[26] !== t8 || $2[27] !== t9) {
    t11 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: "img",
      "data-component": "Avatar",
      className: t5,
      ref: ref2,
      alt,
      "data-responsive": t6,
      "data-square": t7,
      width: t8,
      height: t9,
      style: t10,
      sx: sxProp,
      ...rest
    });
    $2[18] = alt;
    $2[19] = ref2;
    $2[20] = rest;
    $2[21] = sxProp;
    $2[22] = t10;
    $2[23] = t5;
    $2[24] = t6;
    $2[25] = t7;
    $2[26] = t8;
    $2[27] = t9;
    $2[28] = t11;
  } else {
    t11 = $2[28];
  }
  return t11;
});
if (process.env.NODE_ENV !== "production") {
  Avatar.displayName = "Avatar";
}
var classes$s = { "AvatarPair": "prc-AvatarPair-AvatarPair-Av0UV", "AvatarChild": "prc-AvatarPair-AvatarChild-icdQd" };
var classes$r = { "SkeletonBox": "prc-Skeleton-SkeletonBox-nSZk3" };
const SkeletonBox = /* @__PURE__ */ React__default.forwardRef(function SkeletonBox2(t0, ref2) {
  const $2 = distExports.c(17);
  let className;
  let height2;
  let props;
  let style3;
  let width2;
  if ($2[0] !== t0) {
    ({
      height: height2,
      width: width2,
      className,
      style: style3,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = height2;
    $2[3] = props;
    $2[4] = style3;
    $2[5] = width2;
  } else {
    className = $2[1];
    height2 = $2[2];
    props = $2[3];
    style3 = $2[4];
    width2 = $2[5];
  }
  const t1 = ref2;
  let t2;
  if ($2[6] !== className) {
    t2 = clsx(className, classes$r.SkeletonBox);
    $2[6] = className;
    $2[7] = t2;
  } else {
    t2 = $2[7];
  }
  const t3 = style3;
  let t4;
  if ($2[8] !== height2 || $2[9] !== t3 || $2[10] !== width2) {
    t4 = deepmerge(t3, {
      height: height2,
      width: width2
    });
    $2[8] = height2;
    $2[9] = t3;
    $2[10] = width2;
    $2[11] = t4;
  } else {
    t4 = $2[11];
  }
  let t5;
  if ($2[12] !== props || $2[13] !== t1 || $2[14] !== t2 || $2[15] !== t4) {
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      ref: t1,
      className: t2,
      style: t4,
      ...props
    });
    $2[12] = props;
    $2[13] = t1;
    $2[14] = t2;
    $2[15] = t4;
    $2[16] = t5;
  } else {
    t5 = $2[16];
  }
  return t5;
});
var classes$q = { "SkeletonAvatar": "prc-SkeletonAvatar-SkeletonAvatar-inefu" };
function SkeletonAvatar(t0) {
  const $2 = distExports.c(31);
  let className;
  let rest;
  let square;
  let style3;
  let t1;
  if ($2[0] !== t0) {
    ({
      size: t1,
      square,
      className,
      style: style3,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = rest;
    $2[3] = square;
    $2[4] = style3;
    $2[5] = t1;
  } else {
    className = $2[1];
    rest = $2[2];
    square = $2[3];
    style3 = $2[4];
    t1 = $2[5];
  }
  const size2 = t1 === void 0 ? DEFAULT_AVATAR_SIZE : t1;
  let t2;
  if ($2[6] !== size2) {
    t2 = isResponsiveValue(size2);
    $2[6] = size2;
    $2[7] = t2;
  } else {
    t2 = $2[7];
  }
  const responsive3 = t2;
  let T0;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($2[8] !== className || $2[9] !== responsive3 || $2[10] !== rest || $2[11] !== size2 || $2[12] !== square || $2[13] !== style3) {
    const cssSizeVars = {};
    if (responsive3) {
      for (const [key2, value] of Object.entries(size2)) {
        cssSizeVars[`--avatarSize-${key2}`] = `${value}px`;
      }
    } else {
      cssSizeVars["--avatarSize-regular"] = `${size2}px`;
    }
    T0 = SkeletonBox;
    if ($2[21] !== className) {
      t3 = clsx(className, classes$q.SkeletonAvatar);
      $2[21] = className;
      $2[22] = t3;
    } else {
      t3 = $2[22];
    }
    t4 = rest;
    t5 = "SkeletonAvatar";
    t6 = responsive3 ? "" : void 0;
    t7 = square ? "" : void 0;
    t8 = deepmerge(style3, cssSizeVars);
    $2[8] = className;
    $2[9] = responsive3;
    $2[10] = rest;
    $2[11] = size2;
    $2[12] = square;
    $2[13] = style3;
    $2[14] = T0;
    $2[15] = t3;
    $2[16] = t4;
    $2[17] = t5;
    $2[18] = t6;
    $2[19] = t7;
    $2[20] = t8;
  } else {
    T0 = $2[14];
    t3 = $2[15];
    t4 = $2[16];
    t5 = $2[17];
    t6 = $2[18];
    t7 = $2[19];
    t8 = $2[20];
  }
  let t9;
  if ($2[23] !== T0 || $2[24] !== t3 || $2[25] !== t4 || $2[26] !== t5 || $2[27] !== t6 || $2[28] !== t7 || $2[29] !== t8) {
    t9 = /* @__PURE__ */ jsxRuntimeExports.jsx(T0, {
      className: t3,
      ...t4,
      "data-component": t5,
      "data-responsive": t6,
      "data-square": t7,
      style: t8
    });
    $2[23] = T0;
    $2[24] = t3;
    $2[25] = t4;
    $2[26] = t5;
    $2[27] = t6;
    $2[28] = t7;
    $2[29] = t8;
    $2[30] = t9;
  } else {
    t9 = $2[30];
  }
  return t9;
}
const AvatarPair = (t0) => {
  const $2 = distExports.c(12);
  let children;
  let className;
  let rest;
  if ($2[0] !== t0) {
    ({
      children,
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = className;
    $2[3] = rest;
  } else {
    children = $2[1];
    className = $2[2];
    rest = $2[3];
  }
  let t1;
  if ($2[4] !== children) {
    t1 = React__default.Children.map(children, _temp$6);
    $2[4] = children;
    $2[5] = t1;
  } else {
    t1 = $2[5];
  }
  const avatars = t1;
  let t2;
  if ($2[6] !== className) {
    t2 = clsx(className, classes$s.AvatarPair);
    $2[6] = className;
    $2[7] = t2;
  } else {
    t2 = $2[7];
  }
  let t3;
  if ($2[8] !== avatars || $2[9] !== rest || $2[10] !== t2) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: t2,
      ...rest,
      children: avatars
    });
    $2[8] = avatars;
    $2[9] = rest;
    $2[10] = t2;
    $2[11] = t3;
  } else {
    t3 = $2[11];
  }
  return t3;
};
AvatarPair.displayName = "AvatarPair";
function _temp$6(child, i) {
  if (!/* @__PURE__ */ React__default.isValidElement(child)) {
    return child;
  }
  if (i === 0) {
    return /* @__PURE__ */ React__default.cloneElement(child, {
      size: 40
    });
  }
  if (child.type === SkeletonAvatar) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SkeletonAvatar, {
      ...child.props,
      size: 20
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Avatar, {
    className: clsx(child.props.className, classes$s.AvatarChild),
    ...child.props,
    size: 20
  });
}
_temp$6.displayName = "_temp";
var classes$p = { "AvatarStack": "prc-AvatarStack-AvatarStack-N-r3C", "AvatarItem": "prc-AvatarStack-AvatarItem-nS1mt", "AvatarStackBody": "prc-AvatarStack-AvatarStackBody-mSyoJ" };
const nonValidSelectors = {
  disabled: "[disabled]",
  hidden: "[hidden]",
  inert: "[inert]",
  negativeTabIndex: '[tabindex="-1"]'
};
const interactiveElementsSelectors = [`a[href]`, `button`, "summary", "select", "input:not([type=hidden])", "textarea", '[tabindex="0"]', `audio[controls]`, `video[controls]`, `[contenteditable]`];
const interactiveElements = interactiveElementsSelectors.map((selector2) => `${selector2}:not(${Object.values(nonValidSelectors).join("):not(")})`);
function hasInteractiveNodes(node2, ignoreNodes) {
  if (!node2 || isNonValidInteractiveNode(node2)) return false;
  const nodesToIgnore = [node2];
  const interactiveNodes = findInteractiveChildNodes(node2, nodesToIgnore);
  return Boolean(interactiveNodes);
}
function isNonValidInteractiveNode(node2) {
  const nodeStyle = getComputedStyle(node2);
  const isNonInteractive = node2.matches("[disabled], [hidden], [inert]");
  const isHiddenVisually = nodeStyle.display === "none" || nodeStyle.visibility === "hidden";
  return isNonInteractive || isHiddenVisually;
}
function findInteractiveChildNodes(node2, ignoreNodes) {
  if (!node2) return;
  const ignoreSelector = ignoreNodes.find((elem) => elem === node2);
  const isNotValidNode = isNonValidInteractiveNode(node2);
  if (node2.matches(interactiveElements.join(", ")) && !ignoreSelector && !isNotValidNode) {
    return node2;
  }
  for (const child of node2.children) {
    const interactiveNode = findInteractiveChildNodes(child, ignoreNodes);
    if (interactiveNode) return true;
  }
}
const transformChildren = (children) => {
  return React__default.Children.map(children, (child) => {
    if (!/* @__PURE__ */ React__default.isValidElement(child)) return child;
    return /* @__PURE__ */ React__default.cloneElement(child, {
      ...child.props,
      className: clsx(child.props.className, "pc-AvatarItem", classes$p.AvatarItem)
    });
  });
};
const AvatarStackBody = ({
  disableExpand,
  hasInteractiveChildren,
  stackContainer,
  children
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    "data-disable-expand": disableExpand ? "" : void 0,
    className: clsx({
      "pc-AvatarStack--disableExpand": disableExpand
    }, "pc-AvatarStackBody", classes$p.AvatarStackBody),
    tabIndex: !hasInteractiveChildren && !disableExpand ? 0 : void 0,
    ref: stackContainer,
    children
  });
};
AvatarStackBody.displayName = "AvatarStackBody";
const AvatarStack = ({
  children,
  alignRight,
  disableExpand,
  size: size2,
  className,
  style: style3,
  sx: sxProp
}) => {
  const [hasInteractiveChildren, setHasInteractiveChildren] = useState(false);
  const stackContainer = useRef(null);
  const count2 = React__default.Children.count(children);
  const getAvatarChildSizes = () => {
    const avatarSizeMap = {
      narrow: [],
      regular: [],
      wide: []
    };
    return React__default.Children.toArray(children).reduce((acc, child) => {
      if (!/* @__PURE__ */ React__default.isValidElement(child)) return acc;
      for (const responsiveKey of Object.keys(avatarSizeMap)) {
        if (isResponsiveValue(child.props.size)) {
          avatarSizeMap[responsiveKey].push(child.props.size[responsiveKey] || DEFAULT_AVATAR_SIZE);
        } else {
          avatarSizeMap[responsiveKey].push(child.props.size || DEFAULT_AVATAR_SIZE);
        }
        acc[responsiveKey] = Math.min(...avatarSizeMap[responsiveKey]);
      }
      return acc;
    }, {
      narrow: DEFAULT_AVATAR_SIZE,
      regular: DEFAULT_AVATAR_SIZE,
      wide: DEFAULT_AVATAR_SIZE
    });
  };
  const childSizes = getAvatarChildSizes();
  useEffect(() => {
    if (stackContainer.current) {
      const interactiveChildren = () => {
        setHasInteractiveChildren(hasInteractiveNodes(stackContainer.current));
      };
      const observer = new MutationObserver(interactiveChildren);
      observer.observe(stackContainer.current, {
        childList: true
      });
      interactiveChildren();
      return () => {
        observer.disconnect();
      };
    }
  }, []);
  const getResponsiveAvatarSizeStyles = () => {
    if (!size2) {
      return {
        "--stackSize-narrow": `${childSizes.narrow}px`,
        "--stackSize-regular": `${childSizes.regular}px`,
        "--stackSize-wide": `${childSizes.wide}px`
      };
    }
    if (isResponsiveValue(size2)) {
      return {
        "--stackSize-narrow": `${size2.narrow || DEFAULT_AVATAR_SIZE}px`,
        "--stackSize-regular": `${size2.regular || DEFAULT_AVATAR_SIZE}px`,
        "--stackSize-wide": `${size2.wide || DEFAULT_AVATAR_SIZE}px`
      };
    }
    return {
      "--avatar-stack-size": `${size2}px`
    };
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
    as: "span",
    "data-avatar-count": count2 > 3 ? "3+" : count2,
    "data-align-right": alignRight ? "" : void 0,
    "data-responsive": !size2 || isResponsiveValue(size2) ? "" : void 0,
    className: clsx({
      "pc-AvatarStack--two": count2 === 2,
      "pc-AvatarStack--three": count2 === 3,
      "pc-AvatarStack--three-plus": count2 > 3,
      "pc-AvatarStack--right": alignRight
    }, className, classes$p.AvatarStack),
    style: {
      ...getResponsiveAvatarSizeStyles(),
      ...style3
    },
    sx: sxProp,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(AvatarStackBody, {
      disableExpand,
      hasInteractiveChildren,
      stackContainer,
      children: [" ", transformChildren(children)]
    })
  });
};
AvatarStack.displayName = "AvatarStack";
function useMergedRefs(...refs) {
  return useCallback$1((instance) => {
    for (const ref2 of refs) {
      if (typeof ref2 === "function") {
        ref2(instance);
      } else if (ref2) {
        ref2.current = instance;
      }
    }
  }, refs);
}
const Icon$1 = /* @__PURE__ */ React__default.forwardRef((props, ref2) => {
  const $2 = distExports.c(7);
  let IconComponent;
  let rest;
  if ($2[0] !== props) {
    ({
      icon: IconComponent,
      ...rest
    } = props);
    $2[0] = props;
    $2[1] = IconComponent;
    $2[2] = rest;
  } else {
    IconComponent = $2[1];
    rest = $2[2];
  }
  let t0;
  if ($2[3] !== IconComponent || $2[4] !== ref2 || $2[5] !== rest) {
    t0 = /* @__PURE__ */ jsxRuntimeExports.jsx(IconComponent, {
      ...rest,
      ref: ref2
    });
    $2[3] = IconComponent;
    $2[4] = ref2;
    $2[5] = rest;
    $2[6] = t0;
  } else {
    t0 = $2[6];
  }
  return t0;
});
const Octicon = qe(Icon$1).withConfig({
  shouldForwardProp(prop) {
    return prop !== "sx";
  }
}).withConfig({
  displayName: "Octicon",
  componentId: "sc-9kayk9-0"
})(["", ""], ({
  color: color2,
  sx: sxProp
}) => sx({
  sx: {
    color: color2,
    ...sxProp
  }
}));
var all = compose$1(space$1, typography$1, color, layout, flexbox, border, background, position$1, grid, shadow, buttonStyle$1, textStyle, colorStyle);
var regex = new RegExp("^(" + all.propNames.join("|") + ")$");
var omit = function omit2(props) {
  var next2 = {};
  for (var key2 in props) {
    if (regex.test(key2)) continue;
    next2[key2] = props[key2];
  }
  return next2;
};
var classes$o = { "TokenBase": "prc-Token-TokenBase-PfQzJ" };
const tokenSizes = {
  small: "16px",
  medium: "20px",
  large: "24px",
  xlarge: "32px"
};
const defaultTokenSize = "medium";
const isTokenInteractive = ({
  as: as2 = "span",
  onClick,
  onFocus,
  tabIndex = -1,
  disabled
}) => {
  if (disabled) {
    return false;
  }
  return Boolean(onFocus || onClick || tabIndex > -1 || ["a", "button"].includes(as2));
};
const TokenBase = /* @__PURE__ */ React__default.forwardRef((t0, forwardedRef) => {
  const $2 = distExports.c(26);
  let className;
  let id;
  let onKeyDown;
  let onRemove;
  let rest;
  let t1;
  let t2;
  if ($2[0] !== t0) {
    const {
      onRemove: t32,
      onKeyDown: t42,
      id: t52,
      className: t62,
      size: t72,
      isSelected: _isSelected,
      as: t8,
      ...t9
    } = t0;
    onRemove = t32;
    onKeyDown = t42;
    id = t52;
    className = t62;
    t1 = t72;
    t2 = t8;
    rest = t9;
    $2[0] = t0;
    $2[1] = className;
    $2[2] = id;
    $2[3] = onKeyDown;
    $2[4] = onRemove;
    $2[5] = rest;
    $2[6] = t1;
    $2[7] = t2;
  } else {
    className = $2[1];
    id = $2[2];
    onKeyDown = $2[3];
    onRemove = $2[4];
    rest = $2[5];
    t1 = $2[6];
    t2 = $2[7];
  }
  const size2 = t1 === void 0 ? defaultTokenSize : t1;
  const as2 = t2 === void 0 ? "span" : t2;
  let t3;
  if ($2[8] !== onKeyDown || $2[9] !== onRemove) {
    t3 = (event) => {
      onKeyDown && onKeyDown(event);
      if ((event.key === "Backspace" || event.key === "Delete") && onRemove) {
        onRemove();
      }
    };
    $2[8] = onKeyDown;
    $2[9] = onRemove;
    $2[10] = t3;
  } else {
    t3 = $2[10];
  }
  let t4;
  if ($2[11] !== className) {
    t4 = clsx(classes$o.TokenBase, className);
    $2[11] = className;
    $2[12] = t4;
  } else {
    t4 = $2[12];
  }
  let t5;
  if ($2[13] !== rest) {
    t5 = isTokenInteractive(rest);
    $2[13] = rest;
    $2[14] = t5;
  } else {
    t5 = $2[14];
  }
  let t6;
  if ($2[15] !== id) {
    var _id;
    t6 = (_id = id) === null || _id === void 0 ? void 0 : _id.toString();
    $2[15] = id;
    $2[16] = t6;
  } else {
    t6 = $2[16];
  }
  let t7;
  if ($2[17] !== as2 || $2[18] !== forwardedRef || $2[19] !== rest || $2[20] !== size2 || $2[21] !== t3 || $2[22] !== t4 || $2[23] !== t5 || $2[24] !== t6) {
    t7 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: as2,
      onKeyDown: t3,
      className: t4,
      "data-cursor-is-interactive": t5,
      "data-size": size2,
      id: t6,
      ...rest,
      ref: forwardedRef
    });
    $2[17] = as2;
    $2[18] = forwardedRef;
    $2[19] = rest;
    $2[20] = size2;
    $2[21] = t3;
    $2[22] = t4;
    $2[23] = t5;
    $2[24] = t6;
    $2[25] = t7;
  } else {
    t7 = $2[25];
  }
  return t7;
});
var classes$n = { "TokenButton": "prc-Token-TokenButton-F4Y8h" };
const getTokenButtonIconSize = (size2) => parseInt(tokenSizes[size2 || defaultTokenSize], 10) * 0.75;
const RemoveTokenButton = ({
  "aria-label": ariaLabel,
  isParentInteractive,
  size: size2 = defaultTokenSize,
  className,
  borderOffset = 0,
  as: _as,
  ...rest
}) => {
  delete rest.children;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
    as: isParentInteractive ? "span" : "button",
    tabIndex: isParentInteractive ? -1 : void 0,
    "aria-label": !isParentInteractive ? "Remove token" : ariaLabel,
    "data-size": size2,
    className: clsx(classes$n.TokenButton, className),
    style: {
      transform: `translate(${borderOffset}px, -${borderOffset}px)`
    },
    ...rest,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(XIcon, {
      size: getTokenButtonIconSize(size2)
    })
  });
};
RemoveTokenButton.displayName = "RemoveTokenButton";
var classes$m = { "TokenTextContainer": "prc-Token-TokenTextContainer--rlDJ" };
const TokenTextContainer = (t0) => {
  const $2 = distExports.c(7);
  let children;
  let props;
  if ($2[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = props;
  } else {
    children = $2[1];
    props = $2[2];
  }
  let t1;
  if ($2[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx(classes$m.TokenTextContainer);
    $2[3] = t1;
  } else {
    t1 = $2[3];
  }
  let t2;
  if ($2[4] !== children || $2[5] !== props) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: "span",
      className: t1,
      ...props,
      children
    });
    $2[4] = children;
    $2[5] = props;
    $2[6] = t2;
  } else {
    t2 = $2[6];
  }
  return t2;
};
var classes$l = { "Token": "prc-Token-Token-L2-At", "LeadingVisualContainer": "prc-Token-LeadingVisualContainer-YTg7O", "LargeLeadingVisual": "prc-Token-LargeLeadingVisual-UdxDk" };
const tokenBorderWidthPx = 1;
const LeadingVisualContainer = (t0) => {
  const $2 = distExports.c(7);
  const {
    children,
    size: size2
  } = t0;
  let t1;
  if ($2[0] !== size2) {
    t1 = size2 && ["large", "xlarge"].includes(size2);
    $2[0] = size2;
    $2[1] = t1;
  } else {
    t1 = $2[1];
  }
  let t2;
  if ($2[2] !== t1) {
    t2 = clsx(classes$l.LeadingVisualContainer, {
      [classes$l.LargeLeadingVisual]: t1
    });
    $2[2] = t1;
    $2[3] = t2;
  } else {
    t2 = $2[3];
  }
  let t3;
  if ($2[4] !== children || $2[5] !== t2) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: t2,
      children
    });
    $2[4] = children;
    $2[5] = t2;
    $2[6] = t3;
  } else {
    t3 = $2[6];
  }
  return t3;
};
const Token = /* @__PURE__ */ forwardRef$1((props, forwardedRef) => {
  const $2 = distExports.c(66);
  let LeadingVisual2;
  let as2;
  let className;
  let hideRemoveButton;
  let href;
  let id;
  let onClick;
  let onRemove;
  let rest;
  let style3;
  let t0;
  let text2;
  if ($2[0] !== props) {
    ({
      as: as2,
      onRemove,
      id,
      leadingVisual: LeadingVisual2,
      text: text2,
      size: t0,
      hideRemoveButton,
      href,
      onClick,
      className,
      style: style3,
      ...rest
    } = props);
    $2[0] = props;
    $2[1] = LeadingVisual2;
    $2[2] = as2;
    $2[3] = className;
    $2[4] = hideRemoveButton;
    $2[5] = href;
    $2[6] = id;
    $2[7] = onClick;
    $2[8] = onRemove;
    $2[9] = rest;
    $2[10] = style3;
    $2[11] = t0;
    $2[12] = text2;
  } else {
    LeadingVisual2 = $2[1];
    as2 = $2[2];
    className = $2[3];
    hideRemoveButton = $2[4];
    href = $2[5];
    id = $2[6];
    onClick = $2[7];
    onRemove = $2[8];
    rest = $2[9];
    style3 = $2[10];
    t0 = $2[11];
    text2 = $2[12];
  }
  const size2 = t0 === void 0 ? defaultTokenSize : t0;
  let t1;
  if ($2[13] !== hideRemoveButton || $2[14] !== onRemove || $2[15] !== props) {
    t1 = isTokenInteractive(props) && Boolean(onRemove) && !hideRemoveButton;
    $2[13] = hideRemoveButton;
    $2[14] = onRemove;
    $2[15] = props;
    $2[16] = t1;
  } else {
    t1 = $2[16];
  }
  const hasMultipleActionTargets = t1;
  let t2;
  if ($2[17] !== onRemove) {
    t2 = (e) => {
      e.stopPropagation();
      onRemove && onRemove();
    };
    $2[17] = onRemove;
    $2[18] = t2;
  } else {
    t2 = $2[18];
  }
  const onRemoveClick = t2;
  let t3;
  if ($2[19] !== as2 || $2[20] !== href || $2[21] !== onClick) {
    t3 = {
      as: as2,
      href,
      onClick
    };
    $2[19] = as2;
    $2[20] = href;
    $2[21] = onClick;
    $2[22] = t3;
  } else {
    t3 = $2[22];
  }
  const interactiveTokenProps = t3;
  let t4;
  if ($2[23] !== id) {
    var _id;
    t4 = (_id = id) === null || _id === void 0 ? void 0 : _id.toString();
    $2[23] = id;
    $2[24] = t4;
  } else {
    t4 = $2[24];
  }
  let t5;
  if ($2[25] !== className) {
    t5 = clsx(className, classes$l.Token);
    $2[25] = className;
    $2[26] = t5;
  } else {
    t5 = $2[26];
  }
  const t6 = !(hideRemoveButton || !onRemove);
  let t7;
  if ($2[27] !== hasMultipleActionTargets || $2[28] !== interactiveTokenProps) {
    t7 = !hasMultipleActionTargets ? interactiveTokenProps : {};
    $2[27] = hasMultipleActionTargets;
    $2[28] = interactiveTokenProps;
    $2[29] = t7;
  } else {
    t7 = $2[29];
  }
  let t8;
  if ($2[30] !== style3) {
    t8 = {
      borderWidth: `${tokenBorderWidthPx}px`,
      ...style3
    };
    $2[30] = style3;
    $2[31] = t8;
  } else {
    t8 = $2[31];
  }
  let t9;
  if ($2[32] !== LeadingVisual2 || $2[33] !== size2) {
    t9 = LeadingVisual2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(LeadingVisualContainer, {
      size: size2,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(LeadingVisual2, {})
    }) : null;
    $2[32] = LeadingVisual2;
    $2[33] = size2;
    $2[34] = t9;
  } else {
    t9 = $2[34];
  }
  let t10;
  if ($2[35] !== hasMultipleActionTargets || $2[36] !== interactiveTokenProps) {
    t10 = hasMultipleActionTargets ? interactiveTokenProps : {};
    $2[35] = hasMultipleActionTargets;
    $2[36] = interactiveTokenProps;
    $2[37] = t10;
  } else {
    t10 = $2[37];
  }
  let t11;
  if ($2[38] !== onRemove) {
    t11 = onRemove && /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden, {
      children: " (press backspace or delete to remove)"
    });
    $2[38] = onRemove;
    $2[39] = t11;
  } else {
    t11 = $2[39];
  }
  let t12;
  if ($2[40] !== t10 || $2[41] !== t11 || $2[42] !== text2) {
    t12 = /* @__PURE__ */ jsxRuntimeExports.jsxs(TokenTextContainer, {
      ...t10,
      children: [text2, t11]
    });
    $2[40] = t10;
    $2[41] = t11;
    $2[42] = text2;
    $2[43] = t12;
  } else {
    t12 = $2[43];
  }
  let t13;
  if ($2[44] !== hasMultipleActionTargets || $2[45] !== hideRemoveButton || $2[46] !== onRemove || $2[47] !== onRemoveClick || $2[48] !== props || $2[49] !== size2) {
    t13 = !hideRemoveButton && onRemove ? /* @__PURE__ */ jsxRuntimeExports.jsx(RemoveTokenButton, {
      borderOffset: tokenBorderWidthPx,
      onClick: onRemoveClick,
      size: size2,
      isParentInteractive: isTokenInteractive(props),
      "aria-hidden": hasMultipleActionTargets ? "true" : "false"
    }) : null;
    $2[44] = hasMultipleActionTargets;
    $2[45] = hideRemoveButton;
    $2[46] = onRemove;
    $2[47] = onRemoveClick;
    $2[48] = props;
    $2[49] = size2;
    $2[50] = t13;
  } else {
    t13 = $2[50];
  }
  let t14;
  if ($2[51] !== forwardedRef || $2[52] !== onRemove || $2[53] !== props.isSelected || $2[54] !== rest || $2[55] !== size2 || $2[56] !== t12 || $2[57] !== t13 || $2[58] !== t4 || $2[59] !== t5 || $2[60] !== t6 || $2[61] !== t7 || $2[62] !== t8 || $2[63] !== t9 || $2[64] !== text2) {
    t14 = /* @__PURE__ */ jsxRuntimeExports.jsxs(TokenBase, {
      onRemove,
      id: t4,
      className: t5,
      text: text2,
      size: size2,
      "data-is-selected": props.isSelected,
      "data-is-remove-btn": t6,
      ...t7,
      ...rest,
      ref: forwardedRef,
      style: t8,
      children: [t9, t12, t13]
    });
    $2[51] = forwardedRef;
    $2[52] = onRemove;
    $2[53] = props.isSelected;
    $2[54] = rest;
    $2[55] = size2;
    $2[56] = t12;
    $2[57] = t13;
    $2[58] = t4;
    $2[59] = t5;
    $2[60] = t6;
    $2[61] = t7;
    $2[62] = t8;
    $2[63] = t9;
    $2[64] = text2;
    $2[65] = t14;
  } else {
    t14 = $2[65];
  }
  return t14;
});
Token.displayName = "Token";
var styles$5 = { "TextInputBaseWrapper": "prc-components-TextInputBaseWrapper-ueK9q", "TextInputWrapper": "prc-components-TextInputWrapper-i1ofR" };
const TextInputBaseWrapper = /* @__PURE__ */ React__default.forwardRef(function TextInputBaseWrapper2(t0, forwardRef2) {
  const $2 = distExports.c(37);
  let block2;
  let className;
  let contrast;
  let disabled;
  let hasTrailingAction;
  let isInputFocused;
  let maxWidth2;
  let minWidth2;
  let monospace;
  let restProps;
  let size2;
  let style3;
  let validationStatus;
  let variant3;
  let width2;
  if ($2[0] !== t0) {
    ({
      className,
      style: style3,
      variant: variant3,
      size: size2,
      isInputFocused,
      hasTrailingAction,
      validationStatus,
      disabled,
      contrast,
      monospace,
      block: block2,
      width: width2,
      minWidth: minWidth2,
      maxWidth: maxWidth2,
      ...restProps
    } = t0);
    $2[0] = t0;
    $2[1] = block2;
    $2[2] = className;
    $2[3] = contrast;
    $2[4] = disabled;
    $2[5] = hasTrailingAction;
    $2[6] = isInputFocused;
    $2[7] = maxWidth2;
    $2[8] = minWidth2;
    $2[9] = monospace;
    $2[10] = restProps;
    $2[11] = size2;
    $2[12] = style3;
    $2[13] = validationStatus;
    $2[14] = variant3;
    $2[15] = width2;
  } else {
    block2 = $2[1];
    className = $2[2];
    contrast = $2[3];
    disabled = $2[4];
    hasTrailingAction = $2[5];
    isInputFocused = $2[6];
    maxWidth2 = $2[7];
    minWidth2 = $2[8];
    monospace = $2[9];
    restProps = $2[10];
    size2 = $2[11];
    style3 = $2[12];
    validationStatus = $2[13];
    variant3 = $2[14];
    width2 = $2[15];
  }
  let t1;
  if ($2[16] !== className) {
    t1 = clsx(className, styles$5.TextInputBaseWrapper);
    $2[16] = className;
    $2[17] = t1;
  } else {
    t1 = $2[17];
  }
  const t2 = block2 || void 0;
  const t3 = contrast || void 0;
  const t4 = disabled || void 0;
  const t5 = isInputFocused || void 0;
  const t6 = monospace || void 0;
  const t7 = size2 || void 0;
  const t8 = hasTrailingAction || void 0;
  const t9 = validationStatus || void 0;
  const t10 = variant3 || void 0;
  let t11;
  if ($2[18] !== maxWidth2 || $2[19] !== minWidth2 || $2[20] !== style3 || $2[21] !== width2) {
    t11 = typeof width2 === "string" || typeof minWidth2 === "string" || typeof maxWidth2 === "string" ? {
      width: width2,
      maxWidth: maxWidth2,
      minWidth: minWidth2,
      ...style3
    } : style3;
    $2[18] = maxWidth2;
    $2[19] = minWidth2;
    $2[20] = style3;
    $2[21] = width2;
    $2[22] = t11;
  } else {
    t11 = $2[22];
  }
  let t12;
  if ($2[23] !== forwardRef2 || $2[24] !== restProps || $2[25] !== t1 || $2[26] !== t10 || $2[27] !== t11 || $2[28] !== t2 || $2[29] !== t3 || $2[30] !== t4 || $2[31] !== t5 || $2[32] !== t6 || $2[33] !== t7 || $2[34] !== t8 || $2[35] !== t9) {
    t12 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: "span",
      ref: forwardRef2,
      className: t1,
      "data-block": t2,
      "data-contrast": t3,
      "data-disabled": t4,
      "data-focused": t5,
      "data-monospace": t6,
      "data-size": t7,
      "data-trailing-action": t8,
      "data-validation": t9,
      "data-variant": t10,
      style: t11,
      ...restProps
    });
    $2[23] = forwardRef2;
    $2[24] = restProps;
    $2[25] = t1;
    $2[26] = t10;
    $2[27] = t11;
    $2[28] = t2;
    $2[29] = t3;
    $2[30] = t4;
    $2[31] = t5;
    $2[32] = t6;
    $2[33] = t7;
    $2[34] = t8;
    $2[35] = t9;
    $2[36] = t12;
  } else {
    t12 = $2[36];
  }
  return t12;
});
TextInputBaseWrapper.displayName = "TextInputBaseWrapper";
const TextInputWrapper = /* @__PURE__ */ React__default.forwardRef(function TextInputWrapper2(t0, forwardRef2) {
  const $2 = distExports.c(13);
  let className;
  let hasLeadingVisual;
  let hasTrailingVisual;
  let restProps;
  if ($2[0] !== t0) {
    ({
      className,
      hasLeadingVisual,
      hasTrailingVisual,
      ...restProps
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = hasLeadingVisual;
    $2[3] = hasTrailingVisual;
    $2[4] = restProps;
  } else {
    className = $2[1];
    hasLeadingVisual = $2[2];
    hasTrailingVisual = $2[3];
    restProps = $2[4];
  }
  let t1;
  if ($2[5] !== className) {
    t1 = clsx(className, styles$5.TextInputWrapper);
    $2[5] = className;
    $2[6] = t1;
  } else {
    t1 = $2[6];
  }
  const t2 = hasLeadingVisual || void 0;
  const t3 = hasTrailingVisual || void 0;
  let t4;
  if ($2[7] !== forwardRef2 || $2[8] !== restProps || $2[9] !== t1 || $2[10] !== t2 || $2[11] !== t3) {
    t4 = /* @__PURE__ */ jsxRuntimeExports.jsx(TextInputBaseWrapper, {
      ref: forwardRef2,
      className: t1,
      "data-leading-visual": t2,
      "data-trailing-visual": t3,
      ...restProps
    });
    $2[7] = forwardRef2;
    $2[8] = restProps;
    $2[9] = t1;
    $2[10] = t2;
    $2[11] = t3;
    $2[12] = t4;
  } else {
    t4 = $2[12];
  }
  return t4;
});
var styles$4 = { "Input": "prc-components-Input-Ic-y8" };
const UnstyledTextInput = /* @__PURE__ */ React__default.forwardRef(function UnstyledTextInput2(t0, forwardRef2) {
  const $2 = distExports.c(9);
  let className;
  let rest;
  if ($2[0] !== t0) {
    ({
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = rest;
  } else {
    className = $2[1];
    rest = $2[2];
  }
  let t1;
  if ($2[3] !== className) {
    t1 = clsx(className, styles$4.Input);
    $2[3] = className;
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  let t2;
  if ($2[5] !== forwardRef2 || $2[6] !== rest || $2[7] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: "input",
      ref: forwardRef2,
      ...rest,
      className: t1
    });
    $2[5] = forwardRef2;
    $2[6] = rest;
    $2[7] = t1;
    $2[8] = t2;
  } else {
    t2 = $2[8];
  }
  return t2;
});
UnstyledTextInput.displayName = "UnstyledTextInput";
var styles$3 = { "Spinner": "prc-components-Spinner-Azb7p", "SpinnerLeading": "prc-components-SpinnerLeading-s-LyA", "SpinnerHidden": "prc-components-SpinnerHidden-GG1PJ", "SpinnerVisible": "prc-components-SpinnerVisible-w5g8l", "Box": "prc-components-Box-QK3tG" };
const TextInputInnerVisualSlot = (t0) => {
  const $2 = distExports.c(17);
  const {
    children,
    hasLoadingIndicator,
    showLoadingIndicator,
    visualPosition,
    id
  } = t0;
  const isLeading = visualPosition === "leading";
  if (!children && !hasLoadingIndicator || isLeading && !children && !showLoadingIndicator) {
    return null;
  }
  if (!hasLoadingIndicator) {
    let t12;
    if ($2[0] !== children || $2[1] !== id) {
      t12 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: "TextInput-icon",
        id,
        "aria-hidden": "true",
        children
      });
      $2[0] = children;
      $2[1] = id;
      $2[2] = t12;
    } else {
      t12 = $2[2];
    }
    return t12;
  }
  let t1;
  if ($2[3] !== children || $2[4] !== showLoadingIndicator) {
    t1 = children && /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: clsx(showLoadingIndicator ? styles$3.SpinnerHidden : styles$3.SpinnerVisible),
      children
    });
    $2[3] = children;
    $2[4] = showLoadingIndicator;
    $2[5] = t1;
  } else {
    t1 = $2[5];
  }
  const t2 = showLoadingIndicator ? styles$3.SpinnerVisible : styles$3.SpinnerHidden;
  const t3 = children && styles$3.Spinner;
  const t4 = children && isLeading && styles$3.SpinnerLeading;
  let t5;
  if ($2[6] !== t2 || $2[7] !== t3 || $2[8] !== t4) {
    t5 = clsx(t2, t3, t4);
    $2[6] = t2;
    $2[7] = t3;
    $2[8] = t4;
    $2[9] = t5;
  } else {
    t5 = $2[9];
  }
  const t6 = children ? void 0 : "small";
  let t7;
  if ($2[10] !== t5 || $2[11] !== t6) {
    t7 = /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {
      srText: null,
      className: t5,
      size: t6
    });
    $2[10] = t5;
    $2[11] = t6;
    $2[12] = t7;
  } else {
    t7 = $2[12];
  }
  let t8;
  if ($2[13] !== id || $2[14] !== t1 || $2[15] !== t7) {
    t8 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: "TextInput-icon",
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
        className: styles$3.Box,
        id,
        children: [t1, t7]
      })
    });
    $2[13] = id;
    $2[14] = t1;
    $2[15] = t7;
    $2[16] = t8;
  } else {
    t8 = $2[16];
  }
  return t8;
};
var styles$2 = { "TextInputWrapper": "prc-TextInputWithTokens-TextInputWrapper-kj1cB", "UnstyledTextInput": "prc-TextInputWithTokens-UnstyledTextInput-F582M", "InputWrapper": "prc-TextInputWithTokens-InputWrapper-wloGg", "Container": "prc-TextInputWithTokens-Container-mBzq-" };
const overflowCountFontSizeMap = {
  small: 0,
  medium: 1,
  large: 1,
  xlarge: 2
};
function TextInputWithTokensInnerComponent(t0, forwardedRef) {
  const $2 = distExports.c(139);
  let IconComponent;
  let LeadingVisual2;
  let TrailingVisual2;
  let block2;
  let className;
  let contrast;
  let disabled;
  let loading;
  let maxHeight2;
  let maxWidthProp;
  let minWidthProp;
  let onTokenRemove;
  let rest;
  let style3;
  let sxProp;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let tokens2;
  let validationStatus;
  let variantProp;
  let visibleTokenCount;
  let widthProp;
  if ($2[0] !== t0) {
    ({
      icon: IconComponent,
      leadingVisual: LeadingVisual2,
      trailingVisual: TrailingVisual2,
      loading,
      loaderPosition: t1,
      contrast,
      className,
      block: block2,
      disabled,
      sx: sxProp,
      tokens: tokens2,
      onTokenRemove,
      tokenComponent: t2,
      preventTokenWrapping: t3,
      size: t4,
      hideTokenRemoveButtons: t5,
      maxHeight: maxHeight2,
      width: widthProp,
      minWidth: minWidthProp,
      maxWidth: maxWidthProp,
      validationStatus,
      variant: variantProp,
      visibleTokenCount,
      style: style3,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = IconComponent;
    $2[2] = LeadingVisual2;
    $2[3] = TrailingVisual2;
    $2[4] = block2;
    $2[5] = className;
    $2[6] = contrast;
    $2[7] = disabled;
    $2[8] = loading;
    $2[9] = maxHeight2;
    $2[10] = maxWidthProp;
    $2[11] = minWidthProp;
    $2[12] = onTokenRemove;
    $2[13] = rest;
    $2[14] = style3;
    $2[15] = sxProp;
    $2[16] = t1;
    $2[17] = t2;
    $2[18] = t3;
    $2[19] = t4;
    $2[20] = t5;
    $2[21] = tokens2;
    $2[22] = validationStatus;
    $2[23] = variantProp;
    $2[24] = visibleTokenCount;
    $2[25] = widthProp;
  } else {
    IconComponent = $2[1];
    LeadingVisual2 = $2[2];
    TrailingVisual2 = $2[3];
    block2 = $2[4];
    className = $2[5];
    contrast = $2[6];
    disabled = $2[7];
    loading = $2[8];
    maxHeight2 = $2[9];
    maxWidthProp = $2[10];
    minWidthProp = $2[11];
    onTokenRemove = $2[12];
    rest = $2[13];
    style3 = $2[14];
    sxProp = $2[15];
    t1 = $2[16];
    t2 = $2[17];
    t3 = $2[18];
    t4 = $2[19];
    t5 = $2[20];
    tokens2 = $2[21];
    validationStatus = $2[22];
    variantProp = $2[23];
    visibleTokenCount = $2[24];
    widthProp = $2[25];
  }
  const loaderPosition = t1 === void 0 ? "auto" : t1;
  const TokenComponent = t2 === void 0 ? Token : t2;
  const preventTokenWrapping = t3 === void 0 ? false : t3;
  const size2 = t4 === void 0 ? "xlarge" : t4;
  const hideTokenRemoveButtons = t5 === void 0 ? false : t5;
  let t6;
  if ($2[26] !== rest) {
    t6 = omit(rest);
    $2[26] = rest;
    $2[27] = t6;
  } else {
    t6 = $2[27];
  }
  let inputPropsRest;
  let onBlur;
  let onFocus;
  let onKeyDown;
  if ($2[28] !== t6) {
    ({
      onBlur,
      onFocus,
      onKeyDown,
      ...inputPropsRest
    } = t6);
    $2[28] = t6;
    $2[29] = inputPropsRest;
    $2[30] = onBlur;
    $2[31] = onFocus;
    $2[32] = onKeyDown;
  } else {
    inputPropsRest = $2[29];
    onBlur = $2[30];
    onFocus = $2[31];
    onKeyDown = $2[32];
  }
  const ref2 = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, ref2);
  const [selectedTokenIndex, setSelectedTokenIndex] = useState();
  const [tokensAreTruncated, setTokensAreTruncated] = useState(Boolean(visibleTokenCount));
  let t7;
  if ($2[33] !== selectedTokenIndex) {
    t7 = [selectedTokenIndex];
    $2[33] = selectedTokenIndex;
    $2[34] = t7;
  } else {
    t7 = $2[34];
  }
  const {
    containerRef: t8
  } = useFocusZone({
    focusOutBehavior: "wrap",
    bindKeys: FocusKeys.ArrowHorizontal | FocusKeys.HomeAndEnd,
    focusableElementFilter: _temp$5,
    getNextFocusable: (direction) => {
      var _containerRef$current;
      if (!selectedTokenIndex && selectedTokenIndex !== 0) {
        return;
      }
      let nextIndex = selectedTokenIndex + 1;
      if (direction === "next") {
        nextIndex = nextIndex + 1;
      }
      if (direction === "previous") {
        nextIndex = nextIndex - 1;
      }
      if (nextIndex > tokens2.length || nextIndex < 1) {
        return ref2.current || void 0;
      }
      return (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.children[nextIndex];
    }
  }, t7);
  const containerRef = t8;
  let t9;
  if ($2[35] !== containerRef || $2[36] !== onTokenRemove || $2[37] !== selectedTokenIndex) {
    t9 = (tokenId) => {
      onTokenRemove(tokenId);
      setTimeout(() => {
        var _containerRef$current2, _containerRef$current3;
        const nextElementToFocus = (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.children[selectedTokenIndex || 0];
        const firstFocusable = nextElementToFocus && isFocusable$1(nextElementToFocus) ? nextElementToFocus : Array.from(((_containerRef$current3 = containerRef.current) === null || _containerRef$current3 === void 0 ? void 0 : _containerRef$current3.children) || []).find(_temp2$3);
        if (firstFocusable) {
          firstFocusable.focus();
        } else {
          var _ref$current;
          (_ref$current = ref2.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
        }
      }, 0);
    };
    $2[35] = containerRef;
    $2[36] = onTokenRemove;
    $2[37] = selectedTokenIndex;
    $2[38] = t9;
  } else {
    t9 = $2[38];
  }
  const handleTokenRemove = t9;
  let t10;
  if ($2[39] !== disabled) {
    t10 = (tokenIndex) => () => {
      if (!disabled) {
        setSelectedTokenIndex(tokenIndex);
      }
    };
    $2[39] = disabled;
    $2[40] = t10;
  } else {
    t10 = $2[40];
  }
  const handleTokenFocus = t10;
  let t11;
  if ($2[41] !== containerRef || $2[42] !== visibleTokenCount) {
    t11 = () => {
      setSelectedTokenIndex(void 0);
      setTimeout(() => {
        var _containerRef$current4;
        if (!((_containerRef$current4 = containerRef.current) !== null && _containerRef$current4 !== void 0 && _containerRef$current4.contains(document.activeElement)) && visibleTokenCount) {
          setTokensAreTruncated(true);
        }
      }, 0);
    };
    $2[41] = containerRef;
    $2[42] = visibleTokenCount;
    $2[43] = t11;
  } else {
    t11 = $2[43];
  }
  const handleTokenBlur = t11;
  let t12;
  if ($2[44] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = (event) => {
      if (event.key === "Escape") {
        var _ref$current2;
        (_ref$current2 = ref2.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.focus();
      }
    };
    $2[44] = t12;
  } else {
    t12 = $2[44];
  }
  const handleTokenKeyUp = t12;
  let t13;
  if ($2[45] !== onFocus || $2[46] !== visibleTokenCount) {
    t13 = (event_0) => {
      onFocus && onFocus(event_0);
      setSelectedTokenIndex(void 0);
      visibleTokenCount && setTokensAreTruncated(false);
    };
    $2[45] = onFocus;
    $2[46] = visibleTokenCount;
    $2[47] = t13;
  } else {
    t13 = $2[47];
  }
  const handleInputFocus = t13;
  let t14;
  if ($2[48] !== containerRef || $2[49] !== onBlur || $2[50] !== visibleTokenCount) {
    t14 = (event_1) => {
      onBlur && onBlur(event_1);
      setTimeout(() => {
        var _containerRef$current5;
        if (!((_containerRef$current5 = containerRef.current) !== null && _containerRef$current5 !== void 0 && _containerRef$current5.contains(document.activeElement)) && visibleTokenCount) {
          setTokensAreTruncated(true);
        }
      }, 0);
    };
    $2[48] = containerRef;
    $2[49] = onBlur;
    $2[50] = visibleTokenCount;
    $2[51] = t14;
  } else {
    t14 = $2[51];
  }
  const handleInputBlur = t14;
  let t15;
  if ($2[52] !== handleTokenRemove || $2[53] !== onKeyDown || $2[54] !== tokens2) {
    t15 = (e) => {
      var _ref$current3;
      if (onKeyDown) {
        onKeyDown(e);
      }
      if ((_ref$current3 = ref2.current) !== null && _ref$current3 !== void 0 && _ref$current3.value) {
        return;
      }
      const lastToken = tokens2[tokens2.length - 1];
      if (e.key === "Backspace" && lastToken) {
        handleTokenRemove(lastToken.id);
        if (ref2.current) {
          ref2.current.value = `${lastToken.text} `;
        }
        setTimeout(() => {
          var _ref$current4;
          (_ref$current4 = ref2.current) === null || _ref$current4 === void 0 ? void 0 : _ref$current4.select();
        }, 0);
      }
    };
    $2[52] = handleTokenRemove;
    $2[53] = onKeyDown;
    $2[54] = tokens2;
    $2[55] = t15;
  } else {
    t15 = $2[55];
  }
  const handleInputKeyDown = t15;
  let t16;
  if ($2[56] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => {
      var _ref$current5;
      (_ref$current5 = ref2.current) === null || _ref$current5 === void 0 ? void 0 : _ref$current5.focus();
    };
    $2[56] = t16;
  } else {
    t16 = $2[56];
  }
  const focusInput = t16;
  const preventTokenClickPropagation = _temp3$1;
  let t17;
  if ($2[57] !== tokens2 || $2[58] !== tokensAreTruncated || $2[59] !== visibleTokenCount) {
    t17 = tokensAreTruncated ? tokens2.slice(0, visibleTokenCount) : tokens2;
    $2[57] = tokens2;
    $2[58] = tokensAreTruncated;
    $2[59] = visibleTokenCount;
    $2[60] = t17;
  } else {
    t17 = $2[60];
  }
  const visibleTokens = t17;
  let t18;
  if ($2[61] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      small: "small",
      medium: "small",
      large: "medium",
      xlarge: "medium"
    };
    $2[61] = t18;
  } else {
    t18 = $2[61];
  }
  const inputSizeMap = t18;
  const showLeadingLoadingIndicator = loading && (loaderPosition === "leading" || Boolean(LeadingVisual2 && loaderPosition !== "trailing"));
  const showTrailingLoadingIndicator = loading && (loaderPosition === "trailing" || loaderPosition === "auto" && !LeadingVisual2);
  const t19 = Boolean(LeadingVisual2 || showLeadingLoadingIndicator);
  const t20 = Boolean(TrailingVisual2 || showTrailingLoadingIndicator);
  const t21 = inputSizeMap[size2];
  const t22 = Boolean(preventTokenWrapping || maxHeight2) || void 0;
  let t23;
  if ($2[62] !== className) {
    t23 = clsx(className, styles$2.TextInputWrapper);
    $2[62] = className;
    $2[63] = t23;
  } else {
    t23 = $2[63];
  }
  let t24;
  if ($2[64] !== maxHeight2 || $2[65] !== style3) {
    t24 = maxHeight2 ? {
      maxHeight: maxHeight2,
      ...style3
    } : style3;
    $2[64] = maxHeight2;
    $2[65] = style3;
    $2[66] = t24;
  } else {
    t24 = $2[66];
  }
  let t25;
  if ($2[67] !== IconComponent || $2[68] !== LeadingVisual2) {
    t25 = IconComponent && !LeadingVisual2 && /* @__PURE__ */ jsxRuntimeExports.jsx(IconComponent, {
      className: "TextInput-icon"
    });
    $2[67] = IconComponent;
    $2[68] = LeadingVisual2;
    $2[69] = t25;
  } else {
    t25 = $2[69];
  }
  const t26 = typeof loading === "boolean";
  let t27;
  if ($2[70] !== LeadingVisual2) {
    t27 = typeof LeadingVisual2 !== "string" && reactIsExports.isValidElementType(LeadingVisual2) ? /* @__PURE__ */ jsxRuntimeExports.jsx(LeadingVisual2, {}) : LeadingVisual2;
    $2[70] = LeadingVisual2;
    $2[71] = t27;
  } else {
    t27 = $2[71];
  }
  let t28;
  if ($2[72] !== showLeadingLoadingIndicator || $2[73] !== t26 || $2[74] !== t27) {
    t28 = /* @__PURE__ */ jsxRuntimeExports.jsx(TextInputInnerVisualSlot, {
      hasLoadingIndicator: t26,
      visualPosition: "leading",
      showLoadingIndicator: showLeadingLoadingIndicator,
      children: t27
    });
    $2[72] = showLeadingLoadingIndicator;
    $2[73] = t26;
    $2[74] = t27;
    $2[75] = t28;
  } else {
    t28 = $2[75];
  }
  const t29 = containerRef;
  const t30 = validationStatus === "error" ? "true" : "false";
  let t31;
  if ($2[76] !== disabled || $2[77] !== handleInputBlur || $2[78] !== handleInputFocus || $2[79] !== handleInputKeyDown || $2[80] !== inputPropsRest || $2[81] !== t30) {
    t31 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: styles$2.InputWrapper,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(UnstyledTextInput, {
        ref: ref2,
        disabled,
        onFocus: handleInputFocus,
        onBlur: handleInputBlur,
        onKeyDown: handleInputKeyDown,
        type: "text",
        className: styles$2.UnstyledTextInput,
        "aria-invalid": t30,
        ...inputPropsRest
      })
    });
    $2[76] = disabled;
    $2[77] = handleInputBlur;
    $2[78] = handleInputFocus;
    $2[79] = handleInputKeyDown;
    $2[80] = inputPropsRest;
    $2[81] = t30;
    $2[82] = t31;
  } else {
    t31 = $2[82];
  }
  let t32;
  if ($2[83] !== TokenComponent || $2[84] !== disabled || $2[85] !== handleTokenBlur || $2[86] !== handleTokenFocus || $2[87] !== handleTokenRemove || $2[88] !== hideTokenRemoveButtons || $2[89] !== selectedTokenIndex || $2[90] !== size2 || $2[91] !== visibleTokens) {
    let t332;
    if ($2[93] !== TokenComponent || $2[94] !== disabled || $2[95] !== handleTokenBlur || $2[96] !== handleTokenFocus || $2[97] !== handleTokenRemove || $2[98] !== hideTokenRemoveButtons || $2[99] !== selectedTokenIndex || $2[100] !== size2) {
      t332 = (t342, i) => {
        const {
          id,
          ...tokenRest
        } = t342;
        return /* @__PURE__ */ jsxRuntimeExports.jsx(TokenComponent, {
          disabled,
          onFocus: handleTokenFocus(i),
          onBlur: handleTokenBlur,
          onKeyUp: handleTokenKeyUp,
          onClick: preventTokenClickPropagation,
          isSelected: selectedTokenIndex === i,
          onRemove: () => {
            handleTokenRemove(id);
          },
          hideRemoveButton: disabled || hideTokenRemoveButtons,
          size: size2,
          tabIndex: 0,
          ...tokenRest
        }, id);
      };
      $2[93] = TokenComponent;
      $2[94] = disabled;
      $2[95] = handleTokenBlur;
      $2[96] = handleTokenFocus;
      $2[97] = handleTokenRemove;
      $2[98] = hideTokenRemoveButtons;
      $2[99] = selectedTokenIndex;
      $2[100] = size2;
      $2[101] = t332;
    } else {
      t332 = $2[101];
    }
    t32 = visibleTokens.map(t332);
    $2[83] = TokenComponent;
    $2[84] = disabled;
    $2[85] = handleTokenBlur;
    $2[86] = handleTokenFocus;
    $2[87] = handleTokenRemove;
    $2[88] = hideTokenRemoveButtons;
    $2[89] = selectedTokenIndex;
    $2[90] = size2;
    $2[91] = visibleTokens;
    $2[92] = t32;
  } else {
    t32 = $2[92];
  }
  let t33;
  if ($2[102] !== size2 || $2[103] !== tokens2 || $2[104] !== tokensAreTruncated || $2[105] !== visibleTokens.length) {
    t33 = tokensAreTruncated && tokens2.length - visibleTokens.length ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$2, {
      color: "fg.muted",
      fontSize: overflowCountFontSizeMap[size2],
      children: ["+", tokens2.length - visibleTokens.length]
    }) : null;
    $2[102] = size2;
    $2[103] = tokens2;
    $2[104] = tokensAreTruncated;
    $2[105] = visibleTokens.length;
    $2[106] = t33;
  } else {
    t33 = $2[106];
  }
  let t34;
  if ($2[107] !== preventTokenWrapping || $2[108] !== t29 || $2[109] !== t31 || $2[110] !== t32 || $2[111] !== t33) {
    t34 = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      ref: t29,
      className: styles$2.Container,
      "data-prevent-token-wrapping": preventTokenWrapping,
      children: [t31, t32, t33]
    });
    $2[107] = preventTokenWrapping;
    $2[108] = t29;
    $2[109] = t31;
    $2[110] = t32;
    $2[111] = t33;
    $2[112] = t34;
  } else {
    t34 = $2[112];
  }
  const t35 = typeof loading === "boolean";
  let t36;
  if ($2[113] !== TrailingVisual2) {
    t36 = typeof TrailingVisual2 !== "string" && reactIsExports.isValidElementType(TrailingVisual2) ? /* @__PURE__ */ jsxRuntimeExports.jsx(TrailingVisual2, {}) : TrailingVisual2;
    $2[113] = TrailingVisual2;
    $2[114] = t36;
  } else {
    t36 = $2[114];
  }
  let t37;
  if ($2[115] !== showTrailingLoadingIndicator || $2[116] !== t35 || $2[117] !== t36) {
    t37 = /* @__PURE__ */ jsxRuntimeExports.jsx(TextInputInnerVisualSlot, {
      hasLoadingIndicator: t35,
      visualPosition: "trailing",
      showLoadingIndicator: showTrailingLoadingIndicator,
      children: t36
    });
    $2[115] = showTrailingLoadingIndicator;
    $2[116] = t35;
    $2[117] = t36;
    $2[118] = t37;
  } else {
    t37 = $2[118];
  }
  let t38;
  if ($2[119] !== block2 || $2[120] !== contrast || $2[121] !== disabled || $2[122] !== maxWidthProp || $2[123] !== minWidthProp || $2[124] !== sxProp || $2[125] !== t19 || $2[126] !== t20 || $2[127] !== t21 || $2[128] !== t22 || $2[129] !== t23 || $2[130] !== t24 || $2[131] !== t25 || $2[132] !== t28 || $2[133] !== t34 || $2[134] !== t37 || $2[135] !== validationStatus || $2[136] !== variantProp || $2[137] !== widthProp) {
    t38 = /* @__PURE__ */ jsxRuntimeExports.jsxs(TextInputWrapper, {
      block: block2,
      contrast,
      disabled,
      hasLeadingVisual: t19,
      hasTrailingVisual: t20,
      width: widthProp,
      minWidth: minWidthProp,
      maxWidth: maxWidthProp,
      size: t21,
      validationStatus,
      variant: variantProp,
      onClick: focusInput,
      "data-token-wrapping": t22,
      className: t23,
      style: t24,
      sx: sxProp,
      children: [t25, t28, t34, t37]
    });
    $2[119] = block2;
    $2[120] = contrast;
    $2[121] = disabled;
    $2[122] = maxWidthProp;
    $2[123] = minWidthProp;
    $2[124] = sxProp;
    $2[125] = t19;
    $2[126] = t20;
    $2[127] = t21;
    $2[128] = t22;
    $2[129] = t23;
    $2[130] = t24;
    $2[131] = t25;
    $2[132] = t28;
    $2[133] = t34;
    $2[134] = t37;
    $2[135] = validationStatus;
    $2[136] = variantProp;
    $2[137] = widthProp;
    $2[138] = t38;
  } else {
    t38 = $2[138];
  }
  return t38;
}
function _temp3$1(event_2) {
  event_2.stopPropagation();
}
function _temp2$3(el) {
  return isFocusable$1(el);
}
function _temp$5(element2) {
  return !element2.getAttributeNames().includes("aria-hidden");
}
const TextInputWithTokens = /* @__PURE__ */ React__default.forwardRef(TextInputWithTokensInnerComponent);
TextInputWithTokens.displayName = "TextInputWithTokens";
const CheckboxGroupContext = /* @__PURE__ */ createContext({});
var classes$k = { "Checkbox": "prc-Checkbox-Checkbox-gIwWX" };
const Checkbox$1 = /* @__PURE__ */ React__default.forwardRef(({
  checked,
  className,
  defaultChecked,
  indeterminate,
  disabled,
  onChange,
  sx: sxProp,
  required: required2,
  validationStatus,
  value,
  ...rest
}, ref2) => {
  const checkboxRef = useProvidedRefOrCreate(ref2);
  const checkboxGroupContext = useContext(CheckboxGroupContext);
  const handleOnChange = (e) => {
    checkboxGroupContext.onChange && checkboxGroupContext.onChange(e);
    onChange && onChange(e);
  };
  const inputProps = {
    type: "checkbox",
    disabled,
    ref: checkboxRef,
    checked: indeterminate ? false : checked,
    defaultChecked,
    required: required2,
    ["aria-required"]: required2 ? "true" : "false",
    ["aria-invalid"]: validationStatus === "error" ? "true" : "false",
    onChange: handleOnChange,
    value,
    name: value,
    ...rest
  };
  useIsomorphicLayoutEffect$2(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate || false;
    }
  }, [indeterminate, checked, checkboxRef]);
  useEffect(() => {
    const {
      current: checkbox
    } = checkboxRef;
    if (!checkbox) {
      return;
    }
    if (indeterminate) {
      checkbox.setAttribute("aria-checked", "mixed");
    } else {
      checkbox.setAttribute("aria-checked", checkbox.checked ? "true" : "false");
    }
  });
  if (sxProp) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, {
      as: "input",
      ...inputProps,
      className: clsx(className, sharedClasses.Input, classes$k.Checkbox),
      sx: sxProp
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("input", {
    ...inputProps,
    className: clsx(className, sharedClasses.Input, classes$k.Checkbox)
  });
});
Checkbox$1.displayName = "Checkbox";
var classes$j = { "TextArea": "prc-Textarea-TextArea-13q4j" };
const DEFAULT_TEXTAREA_ROWS = 7;
const DEFAULT_TEXTAREA_COLS = 30;
const DEFAULT_TEXTAREA_RESIZE = "both";
const Textarea = /* @__PURE__ */ React__default.forwardRef((t0, ref2) => {
  const $2 = distExports.c(31);
  let block2;
  let className;
  let contrast;
  let disabled;
  let required2;
  let rest;
  let sxProp;
  let t1;
  let t2;
  let t3;
  let validationStatus;
  let value;
  if ($2[0] !== t0) {
    ({
      value,
      disabled,
      sx: sxProp,
      required: required2,
      validationStatus,
      rows: t1,
      cols: t2,
      resize: t3,
      block: block2,
      contrast,
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = block2;
    $2[2] = className;
    $2[3] = contrast;
    $2[4] = disabled;
    $2[5] = required2;
    $2[6] = rest;
    $2[7] = sxProp;
    $2[8] = t1;
    $2[9] = t2;
    $2[10] = t3;
    $2[11] = validationStatus;
    $2[12] = value;
  } else {
    block2 = $2[1];
    className = $2[2];
    contrast = $2[3];
    disabled = $2[4];
    required2 = $2[5];
    rest = $2[6];
    sxProp = $2[7];
    t1 = $2[8];
    t2 = $2[9];
    t3 = $2[10];
    validationStatus = $2[11];
    value = $2[12];
  }
  const rows = t1 === void 0 ? DEFAULT_TEXTAREA_ROWS : t1;
  const cols = t2 === void 0 ? DEFAULT_TEXTAREA_COLS : t2;
  const resize = t3 === void 0 ? DEFAULT_TEXTAREA_RESIZE : t3;
  const t4 = validationStatus === "error" ? "true" : "false";
  let t5;
  if ($2[13] !== cols || $2[14] !== disabled || $2[15] !== ref2 || $2[16] !== required2 || $2[17] !== resize || $2[18] !== rest || $2[19] !== rows || $2[20] !== t4 || $2[21] !== value) {
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsx("textarea", {
      value,
      "data-resize": resize,
      "aria-required": required2,
      "aria-invalid": t4,
      ref: ref2,
      disabled,
      rows,
      cols,
      className: classes$j.TextArea,
      ...rest
    });
    $2[13] = cols;
    $2[14] = disabled;
    $2[15] = ref2;
    $2[16] = required2;
    $2[17] = resize;
    $2[18] = rest;
    $2[19] = rows;
    $2[20] = t4;
    $2[21] = value;
    $2[22] = t5;
  } else {
    t5 = $2[22];
  }
  let t6;
  if ($2[23] !== block2 || $2[24] !== className || $2[25] !== contrast || $2[26] !== disabled || $2[27] !== sxProp || $2[28] !== t5 || $2[29] !== validationStatus) {
    t6 = /* @__PURE__ */ jsxRuntimeExports.jsx(TextInputBaseWrapper, {
      sx: sxProp,
      validationStatus,
      disabled,
      block: block2,
      contrast,
      className,
      children: t5
    });
    $2[23] = block2;
    $2[24] = className;
    $2[25] = contrast;
    $2[26] = disabled;
    $2[27] = sxProp;
    $2[28] = t5;
    $2[29] = validationStatus;
    $2[30] = t6;
  } else {
    t6 = $2[30];
  }
  return t6;
});
Textarea.displayName = "Textarea";
var classes$i = { "PageLayoutRoot": "prc-PageLayout-PageLayoutRoot-1zlEO", "PageLayoutWrapper": "prc-PageLayout-PageLayoutWrapper-s2ao4", "PageLayoutContent": "prc-PageLayout-PageLayoutContent-jzDMn", "HorizontalDivider": "prc-PageLayout-HorizontalDivider-CYLp5", "VerticalDivider": "prc-PageLayout-VerticalDivider-4A4Qm", "Header": "prc-PageLayout-Header-mQXK1", "HeaderContent": "prc-PageLayout-HeaderContent-dVIQb", "HeaderHorizontalDivider": "prc-PageLayout-HeaderHorizontalDivider-bofyb", "ContentWrapper": "prc-PageLayout-ContentWrapper-b-QRo", "Content": "prc-PageLayout-Content--F7-I", "PaneWrapper": "prc-PageLayout-PaneWrapper-nGO0U", "PaneVerticalDivider": "prc-PageLayout-PaneVerticalDivider-1c9vy", "Pane": "prc-PageLayout-Pane-Vl5LI", "PaneHorizontalDivider": "prc-PageLayout-PaneHorizontalDivider-4exOb", "FooterWrapper": "prc-PageLayout-FooterWrapper-WZwgZ", "FooterHorizontalDivider": "prc-PageLayout-FooterHorizontalDivider-sNLmj", "FooterContent": "prc-PageLayout-FooterContent-UFWGW" };
const PageLayoutContext = /* @__PURE__ */ React__default.createContext({
  padding: "normal",
  rowGap: "normal",
  columnGap: "normal",
  paneRef: {
    current: null
  }
});
const Root = (t0) => {
  const $2 = distExports.c(27);
  const {
    containerWidth: t1,
    padding: t2,
    rowGap: t3,
    columnGap: t4,
    children,
    sx: sx2,
    className,
    style: style3,
    _slotsConfig: slotsConfig
  } = t0;
  const containerWidth = t1 === void 0 ? "xlarge" : t1;
  const padding2 = t2 === void 0 ? "normal" : t2;
  const rowGap = t3 === void 0 ? "normal" : t3;
  const columnGap = t4 === void 0 ? "normal" : t4;
  const paneRef = useRef(null);
  let t5;
  if ($2[0] !== slotsConfig) {
    t5 = slotsConfig !== null && slotsConfig !== void 0 ? slotsConfig : {
      header: Header$3,
      footer: Footer2
    };
    $2[0] = slotsConfig;
    $2[1] = t5;
  } else {
    t5 = $2[1];
  }
  const [slots, rest] = useSlots(children, t5);
  let t6;
  let t7;
  if ($2[2] !== columnGap || $2[3] !== padding2 || $2[4] !== rowGap) {
    t7 = {
      padding: padding2,
      rowGap,
      columnGap,
      paneRef
    };
    $2[2] = columnGap;
    $2[3] = padding2;
    $2[4] = rowGap;
    $2[5] = t7;
  } else {
    t7 = $2[5];
  }
  t6 = t7;
  const memoizedContextValue = t6;
  const t8 = `var(--spacing-${padding2})`;
  let t9;
  if ($2[6] !== style3 || $2[7] !== t8) {
    t9 = {
      "--spacing": t8,
      ...style3
    };
    $2[6] = style3;
    $2[7] = t8;
    $2[8] = t9;
  } else {
    t9 = $2[8];
  }
  const t10 = t9;
  let t11;
  if ($2[9] !== className) {
    t11 = clsx(classes$i.PageLayoutRoot, className);
    $2[9] = className;
    $2[10] = t11;
  } else {
    t11 = $2[10];
  }
  const t12 = slots.header;
  let t13;
  if ($2[11] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = clsx(classes$i.PageLayoutContent);
    $2[11] = t13;
  } else {
    t13 = $2[11];
  }
  let t14;
  if ($2[12] !== rest) {
    t14 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: t13,
      children: rest
    });
    $2[12] = rest;
    $2[13] = t14;
  } else {
    t14 = $2[13];
  }
  let t15;
  if ($2[14] !== containerWidth || $2[15] !== slots.footer || $2[16] !== slots.header || $2[17] !== t14) {
    t15 = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      className: classes$i.PageLayoutWrapper,
      "data-width": containerWidth,
      children: [t12, t14, slots.footer]
    });
    $2[14] = containerWidth;
    $2[15] = slots.footer;
    $2[16] = slots.header;
    $2[17] = t14;
    $2[18] = t15;
  } else {
    t15 = $2[18];
  }
  let t16;
  if ($2[19] !== sx2 || $2[20] !== t10 || $2[21] !== t11 || $2[22] !== t15) {
    t16 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      style: t10,
      sx: sx2,
      className: t11,
      children: t15
    });
    $2[19] = sx2;
    $2[20] = t10;
    $2[21] = t11;
    $2[22] = t15;
    $2[23] = t16;
  } else {
    t16 = $2[23];
  }
  let t17;
  if ($2[24] !== memoizedContextValue || $2[25] !== t16) {
    t17 = /* @__PURE__ */ jsxRuntimeExports.jsx(PageLayoutContext.Provider, {
      value: memoizedContextValue,
      children: t16
    });
    $2[24] = memoizedContextValue;
    $2[25] = t16;
    $2[26] = t17;
  } else {
    t17 = $2[26];
  }
  return t17;
};
Root.displayName = "PageLayout";
const HorizontalDivider = (t0) => {
  const $2 = distExports.c(11);
  const {
    variant: t1,
    sx: sx2,
    className,
    position: position4,
    style: style3
  } = t0;
  const variant3 = t1 === void 0 ? "none" : t1;
  const {
    padding: padding2
  } = React__default.useContext(PageLayoutContext);
  const responsiveVariant = useResponsiveValue(variant3, "none");
  let t2;
  if ($2[0] !== className) {
    t2 = clsx(classes$i.HorizontalDivider, className);
    $2[0] = className;
    $2[1] = t2;
  } else {
    t2 = $2[1];
  }
  const t3 = `var(--spacing-${padding2})`;
  let t4;
  if ($2[2] !== style3 || $2[3] !== t3) {
    t4 = {
      "--spacing-divider": t3,
      ...style3
    };
    $2[2] = style3;
    $2[3] = t3;
    $2[4] = t4;
  } else {
    t4 = $2[4];
  }
  const t5 = t4;
  let t6;
  if ($2[5] !== position4 || $2[6] !== responsiveVariant || $2[7] !== sx2 || $2[8] !== t2 || $2[9] !== t5) {
    t6 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      sx: sx2,
      className: t2,
      "data-variant": responsiveVariant,
      "data-position": position4,
      style: t5
    });
    $2[5] = position4;
    $2[6] = responsiveVariant;
    $2[7] = sx2;
    $2[8] = t2;
    $2[9] = t5;
    $2[10] = t6;
  } else {
    t6 = $2[10];
  }
  return t6;
};
const VerticalDivider = (t0) => {
  const $2 = distExports.c(37);
  const {
    variant: t1,
    draggable: t2,
    onDragStart: onDragStart4,
    onDrag,
    onDragEnd: onDragEnd4,
    onDoubleClick,
    position: position4,
    className,
    style: style3,
    sx: sx2
  } = t0;
  const variant3 = t1 === void 0 ? "none" : t1;
  const draggable2 = t2 === void 0 ? false : t2;
  const [isDragging, setIsDragging] = React__default.useState(false);
  const [isKeyboardDrag, setIsKeyboardDrag] = React__default.useState(false);
  const responsiveVariant = useResponsiveValue(variant3, "none");
  const stableOnDrag = React__default.useRef(onDrag);
  const stableOnDragEnd = React__default.useRef(onDragEnd4);
  const {
    paneRef
  } = React__default.useContext(PageLayoutContext);
  const [minWidth2, setMinWidth] = React__default.useState(0);
  const [maxWidth2, setMaxWidth] = React__default.useState(0);
  const [currentWidth, setCurrentWidth] = React__default.useState(0);
  let t3;
  if ($2[0] !== paneRef) {
    t3 = () => {
      if (paneRef.current !== null) {
        const paneStyles = getComputedStyle(paneRef.current);
        const maxPaneWidthDiffPixels = paneStyles.getPropertyValue("--pane-max-width-diff");
        const minWidthPixels = paneStyles.getPropertyValue("--pane-min-width");
        const paneWidth = paneRef.current.getBoundingClientRect().width;
        const maxPaneWidthDiff = Number(maxPaneWidthDiffPixels.split("px")[0]);
        const minPaneWidth = Number(minWidthPixels.split("px")[0]);
        const viewportWidth = window.innerWidth;
        const maxPaneWidth = viewportWidth > maxPaneWidthDiff ? viewportWidth - maxPaneWidthDiff : viewportWidth;
        setMinWidth(minPaneWidth);
        setMaxWidth(maxPaneWidth);
        setCurrentWidth(paneWidth || 0);
      }
    };
    $2[0] = paneRef;
    $2[1] = t3;
  } else {
    t3 = $2[1];
  }
  let t4;
  if ($2[2] !== isDragging || $2[3] !== isKeyboardDrag || $2[4] !== paneRef) {
    t4 = [paneRef, isKeyboardDrag, isDragging];
    $2[2] = isDragging;
    $2[3] = isKeyboardDrag;
    $2[4] = paneRef;
    $2[5] = t4;
  } else {
    t4 = $2[5];
  }
  React__default.useEffect(t3, t4);
  let t5;
  let t6;
  if ($2[6] !== onDrag) {
    t5 = () => {
      stableOnDrag.current = onDrag;
    };
    t6 = [onDrag];
    $2[6] = onDrag;
    $2[7] = t5;
    $2[8] = t6;
  } else {
    t5 = $2[7];
    t6 = $2[8];
  }
  React__default.useEffect(t5, t6);
  let t7;
  let t8;
  if ($2[9] !== onDragEnd4) {
    t7 = () => {
      stableOnDragEnd.current = onDragEnd4;
    };
    t8 = [onDragEnd4];
    $2[9] = onDragEnd4;
    $2[10] = t7;
    $2[11] = t8;
  } else {
    t7 = $2[10];
    t8 = $2[11];
  }
  React__default.useEffect(t7, t8);
  let t10;
  let t9;
  if ($2[12] !== currentWidth || $2[13] !== isDragging || $2[14] !== isKeyboardDrag || $2[15] !== maxWidth2 || $2[16] !== minWidth2) {
    t9 = () => {
      const handleDrag = function handleDrag2(event) {
        var _stableOnDrag$current;
        (_stableOnDrag$current = stableOnDrag.current) === null || _stableOnDrag$current === void 0 ? void 0 : _stableOnDrag$current.call(stableOnDrag, event.movementX, false);
        event.preventDefault();
      };
      const handleDragEnd = function handleDragEnd2(event_0) {
        var _stableOnDragEnd$curr;
        setIsDragging(false);
        (_stableOnDragEnd$curr = stableOnDragEnd.current) === null || _stableOnDragEnd$curr === void 0 ? void 0 : _stableOnDragEnd$curr.call(stableOnDragEnd);
        event_0.preventDefault();
      };
      const handleKeyDrag = function handleKeyDrag2(event_1) {
        var _stableOnDrag$current2;
        let delta;
        if ((event_1.key === "ArrowLeft" || event_1.key === "ArrowDown") && currentWidth > minWidth2) {
          delta = -3;
        } else {
          if ((event_1.key === "ArrowRight" || event_1.key === "ArrowUp") && currentWidth < maxWidth2) {
            delta = 3;
          } else {
            return;
          }
        }
        setCurrentWidth(currentWidth + delta);
        (_stableOnDrag$current2 = stableOnDrag.current) === null || _stableOnDrag$current2 === void 0 ? void 0 : _stableOnDrag$current2.call(stableOnDrag, delta, true);
        event_1.preventDefault();
      };
      const handleKeyDragEnd = function handleKeyDragEnd2(event_2) {
        var _stableOnDragEnd$curr2;
        setIsKeyboardDrag(false);
        (_stableOnDragEnd$curr2 = stableOnDragEnd.current) === null || _stableOnDragEnd$curr2 === void 0 ? void 0 : _stableOnDragEnd$curr2.call(stableOnDragEnd);
        event_2.preventDefault();
      };
      if (isDragging || isKeyboardDrag) {
        window.addEventListener("mousemove", handleDrag);
        window.addEventListener("keydown", handleKeyDrag);
        window.addEventListener("mouseup", handleDragEnd);
        window.addEventListener("keyup", handleKeyDragEnd);
        const body = document.body;
        body === null || body === void 0 ? void 0 : body.setAttribute("data-page-layout-dragging", "true");
      } else {
        window.removeEventListener("mousemove", handleDrag);
        window.removeEventListener("mouseup", handleDragEnd);
        window.removeEventListener("keydown", handleKeyDrag);
        window.removeEventListener("keyup", handleKeyDragEnd);
        const body_0 = document.body;
        body_0 === null || body_0 === void 0 ? void 0 : body_0.removeAttribute("data-page-layout-dragging");
      }
      return () => {
        window.removeEventListener("mousemove", handleDrag);
        window.removeEventListener("mouseup", handleDragEnd);
        window.removeEventListener("keydown", handleKeyDrag);
        window.removeEventListener("keyup", handleKeyDragEnd);
        const body_1 = document.body;
        body_1 === null || body_1 === void 0 ? void 0 : body_1.removeAttribute("data-page-layout-dragging");
      };
    };
    t10 = [isDragging, isKeyboardDrag, currentWidth, minWidth2, maxWidth2];
    $2[12] = currentWidth;
    $2[13] = isDragging;
    $2[14] = isKeyboardDrag;
    $2[15] = maxWidth2;
    $2[16] = minWidth2;
    $2[17] = t10;
    $2[18] = t9;
  } else {
    t10 = $2[17];
    t9 = $2[18];
  }
  React__default.useEffect(t9, t10);
  let t11;
  if ($2[19] !== className) {
    t11 = clsx(classes$i.VerticalDivider, className);
    $2[19] = className;
    $2[20] = t11;
  } else {
    t11 = $2[20];
  }
  let t12;
  if ($2[21] !== currentWidth || $2[22] !== draggable2 || $2[23] !== isDragging || $2[24] !== isKeyboardDrag || $2[25] !== maxWidth2 || $2[26] !== minWidth2 || $2[27] !== onDoubleClick || $2[28] !== onDragStart4) {
    t12 = draggable2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box, {
        sx: {
          position: "absolute",
          inset: "0 -2px",
          cursor: "col-resize",
          bg: isDragging || isKeyboardDrag ? "accent.fg" : "transparent",
          transitionDelay: "0.1s",
          "&:hover": {
            bg: isDragging || isKeyboardDrag ? "accent.fg" : "neutral.muted"
          }
        },
        role: "slider",
        "aria-label": "Draggable pane splitter",
        "aria-valuemin": minWidth2,
        "aria-valuemax": maxWidth2,
        "aria-valuenow": currentWidth,
        "aria-valuetext": `Pane width ${currentWidth} pixels`,
        tabIndex: 0,
        onMouseDown: (event_3) => {
          if (event_3.button === 0) {
            setIsDragging(true);
            onDragStart4 === null || onDragStart4 === void 0 ? void 0 : onDragStart4();
          }
        },
        onKeyDown: (event_4) => {
          if (event_4.key === "ArrowLeft" || event_4.key === "ArrowRight" || event_4.key === "ArrowUp" || event_4.key === "ArrowDown") {
            setIsKeyboardDrag(true);
            onDragStart4 === null || onDragStart4 === void 0 ? void 0 : onDragStart4();
          }
        },
        onDoubleClick
      })
    }) : null;
    $2[21] = currentWidth;
    $2[22] = draggable2;
    $2[23] = isDragging;
    $2[24] = isKeyboardDrag;
    $2[25] = maxWidth2;
    $2[26] = minWidth2;
    $2[27] = onDoubleClick;
    $2[28] = onDragStart4;
    $2[29] = t12;
  } else {
    t12 = $2[29];
  }
  let t13;
  if ($2[30] !== position4 || $2[31] !== responsiveVariant || $2[32] !== style3 || $2[33] !== sx2 || $2[34] !== t11 || $2[35] !== t12) {
    t13 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      sx: sx2,
      className: t11,
      "data-variant": responsiveVariant,
      "data-position": position4,
      style: style3,
      children: t12
    });
    $2[30] = position4;
    $2[31] = responsiveVariant;
    $2[32] = style3;
    $2[33] = sx2;
    $2[34] = t11;
    $2[35] = t12;
    $2[36] = t13;
  } else {
    t13 = $2[36];
  }
  return t13;
};
const Header$3 = (t0) => {
  const $2 = distExports.c(27);
  const {
    "aria-label": label,
    "aria-labelledby": labelledBy,
    padding: t1,
    divider: t2,
    dividerWhenNarrow: t3,
    hidden: t4,
    children,
    style: style3,
    sx: sx2,
    className
  } = t0;
  const padding2 = t1 === void 0 ? "none" : t1;
  const divider = t2 === void 0 ? "none" : t2;
  const dividerWhenNarrow = t3 === void 0 ? "inherit" : t3;
  const hidden = t4 === void 0 ? false : t4;
  let t5;
  if ($2[0] !== divider || $2[1] !== dividerWhenNarrow) {
    t5 = !isResponsiveValue(divider) && dividerWhenNarrow !== "inherit" ? {
      regular: divider,
      narrow: dividerWhenNarrow
    } : divider;
    $2[0] = divider;
    $2[1] = dividerWhenNarrow;
    $2[2] = t5;
  } else {
    t5 = $2[2];
  }
  const dividerProp = t5;
  const dividerVariant = useResponsiveValue(dividerProp, "none");
  const isHidden = useResponsiveValue(hidden, false);
  const {
    rowGap
  } = React__default.useContext(PageLayoutContext);
  let t6;
  if ($2[3] !== className) {
    t6 = clsx(classes$i.Header, className);
    $2[3] = className;
    $2[4] = t6;
  } else {
    t6 = $2[4];
  }
  const t7 = `var(--spacing-${rowGap})`;
  let t8;
  if ($2[5] !== style3 || $2[6] !== t7) {
    t8 = {
      "--spacing": t7,
      ...style3
    };
    $2[5] = style3;
    $2[6] = t7;
    $2[7] = t8;
  } else {
    t8 = $2[7];
  }
  const t9 = t8;
  const t10 = `var(--spacing-${padding2})`;
  let t11;
  if ($2[8] !== t10) {
    t11 = {
      "--spacing": t10
    };
    $2[8] = t10;
    $2[9] = t11;
  } else {
    t11 = $2[9];
  }
  const t12 = t11;
  let t13;
  if ($2[10] !== children || $2[11] !== t12) {
    t13 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: classes$i.HeaderContent,
      style: t12,
      children
    });
    $2[10] = children;
    $2[11] = t12;
    $2[12] = t13;
  } else {
    t13 = $2[12];
  }
  const t14 = `var(--spacing-${rowGap})`;
  let t15;
  if ($2[13] !== t14) {
    t15 = {
      "--spacing": t14
    };
    $2[13] = t14;
    $2[14] = t15;
  } else {
    t15 = $2[14];
  }
  const t16 = t15;
  let t17;
  if ($2[15] !== dividerVariant || $2[16] !== t16) {
    t17 = /* @__PURE__ */ jsxRuntimeExports.jsx(HorizontalDivider, {
      variant: dividerVariant,
      className: classes$i.HeaderHorizontalDivider,
      style: t16
    });
    $2[15] = dividerVariant;
    $2[16] = t16;
    $2[17] = t17;
  } else {
    t17 = $2[17];
  }
  let t18;
  if ($2[18] !== isHidden || $2[19] !== label || $2[20] !== labelledBy || $2[21] !== sx2 || $2[22] !== t13 || $2[23] !== t17 || $2[24] !== t6 || $2[25] !== t9) {
    t18 = /* @__PURE__ */ jsxRuntimeExports.jsxs(BoxWithFallback, {
      as: "header",
      "aria-label": label,
      "aria-labelledby": labelledBy,
      hidden: isHidden,
      sx: sx2,
      className: t6,
      style: t9,
      children: [t13, t17]
    });
    $2[18] = isHidden;
    $2[19] = label;
    $2[20] = labelledBy;
    $2[21] = sx2;
    $2[22] = t13;
    $2[23] = t17;
    $2[24] = t6;
    $2[25] = t9;
    $2[26] = t18;
  } else {
    t18 = $2[26];
  }
  return t18;
};
Header$3.displayName = "PageLayout.Header";
const Content = (t0) => {
  const $2 = distExports.c(17);
  const {
    as: t1,
    "aria-label": label,
    "aria-labelledby": labelledBy,
    width: t2,
    padding: t3,
    hidden: t4,
    children,
    sx: sx2,
    className,
    style: style3
  } = t0;
  const as2 = t1 === void 0 ? "main" : t1;
  const width2 = t2 === void 0 ? "full" : t2;
  const padding2 = t3 === void 0 ? "none" : t3;
  const hidden = t4 === void 0 ? false : t4;
  const isHidden = useResponsiveValue(hidden, false);
  let t5;
  if ($2[0] !== className) {
    t5 = clsx(classes$i.ContentWrapper, className);
    $2[0] = className;
    $2[1] = t5;
  } else {
    t5 = $2[1];
  }
  const t6 = `var(--spacing-${padding2})`;
  let t7;
  if ($2[2] !== t6) {
    t7 = {
      "--spacing": t6
    };
    $2[2] = t6;
    $2[3] = t7;
  } else {
    t7 = $2[3];
  }
  const t8 = t7;
  let t9;
  if ($2[4] !== children || $2[5] !== t8 || $2[6] !== width2) {
    t9 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: classes$i.Content,
      "data-width": width2,
      style: t8,
      children
    });
    $2[4] = children;
    $2[5] = t8;
    $2[6] = width2;
    $2[7] = t9;
  } else {
    t9 = $2[7];
  }
  let t10;
  if ($2[8] !== as2 || $2[9] !== isHidden || $2[10] !== label || $2[11] !== labelledBy || $2[12] !== style3 || $2[13] !== sx2 || $2[14] !== t5 || $2[15] !== t9) {
    t10 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: as2,
      "aria-label": label,
      "aria-labelledby": labelledBy,
      style: style3,
      sx: sx2,
      className: t5,
      "data-is-hidden": isHidden,
      children: t9
    });
    $2[8] = as2;
    $2[9] = isHidden;
    $2[10] = label;
    $2[11] = labelledBy;
    $2[12] = style3;
    $2[13] = sx2;
    $2[14] = t5;
    $2[15] = t9;
    $2[16] = t10;
  } else {
    t10 = $2[16];
  }
  return t10;
};
Content.displayName = "PageLayout.Content";
const isCustomWidthOptions = (width2) => {
  return width2.default !== void 0;
};
const isPaneWidth = (width2) => {
  return ["small", "medium", "large"].includes(width2);
};
const defaultPaneWidth = {
  small: 256,
  medium: 296,
  large: 320
};
const overflowProps = {
  tabIndex: 0,
  role: "region"
};
const Pane = /* @__PURE__ */ React__default.forwardRef((t0, forwardRef2) => {
  const $2 = distExports.c(82);
  const {
    "aria-label": label,
    "aria-labelledby": labelledBy,
    position: t1,
    positionWhenNarrow: t2,
    width: t3,
    minWidth: t4,
    padding: t5,
    resizable: t6,
    widthStorageKey: t7,
    divider: t8,
    dividerWhenNarrow: t9,
    sticky: t10,
    offsetHeader: t11,
    hidden: t12,
    children,
    id,
    sx: sx2,
    className,
    style: style3
  } = t0;
  const responsivePosition = t1 === void 0 ? "end" : t1;
  const positionWhenNarrow = t2 === void 0 ? "inherit" : t2;
  const width2 = t3 === void 0 ? "medium" : t3;
  const minWidth2 = t4 === void 0 ? 256 : t4;
  const padding2 = t5 === void 0 ? "none" : t5;
  const resizable = t6 === void 0 ? false : t6;
  const widthStorageKey = t7 === void 0 ? "paneWidth" : t7;
  const responsiveDivider = t8 === void 0 ? "none" : t8;
  const dividerWhenNarrow = t9 === void 0 ? "inherit" : t9;
  const sticky = t10 === void 0 ? false : t10;
  const offsetHeader = t11 === void 0 ? 0 : t11;
  const responsiveHidden = t12 === void 0 ? false : t12;
  let t13;
  if ($2[0] !== positionWhenNarrow || $2[1] !== responsivePosition) {
    t13 = !isResponsiveValue(responsivePosition) && positionWhenNarrow !== "inherit" ? {
      regular: responsivePosition,
      narrow: positionWhenNarrow
    } : responsivePosition;
    $2[0] = positionWhenNarrow;
    $2[1] = responsivePosition;
    $2[2] = t13;
  } else {
    t13 = $2[2];
  }
  const positionProp = t13;
  const position4 = useResponsiveValue(positionProp, "end");
  let t14;
  if ($2[3] !== dividerWhenNarrow || $2[4] !== responsiveDivider) {
    t14 = !isResponsiveValue(responsiveDivider) && dividerWhenNarrow !== "inherit" ? {
      regular: responsiveDivider,
      narrow: dividerWhenNarrow
    } : responsiveDivider;
    $2[3] = dividerWhenNarrow;
    $2[4] = responsiveDivider;
    $2[5] = t14;
  } else {
    t14 = $2[5];
  }
  const dividerProp = t14;
  const dividerVariant = useResponsiveValue(dividerProp, "none");
  const isHidden = useResponsiveValue(responsiveHidden, false);
  const {
    rowGap,
    columnGap,
    paneRef
  } = React__default.useContext(PageLayoutContext);
  const getDefaultPaneWidth = _temp$4;
  let t15;
  if ($2[6] !== width2 || $2[7] !== widthStorageKey) {
    t15 = () => {
      if (!canUseDOM$1) {
        return getDefaultPaneWidth(width2);
      }
      let storedWidth;
      try {
        storedWidth = localStorage.getItem(widthStorageKey);
      } catch (t162) {
        storedWidth = null;
      }
      return storedWidth && !isNaN(Number(storedWidth)) ? Number(storedWidth) : getDefaultPaneWidth(width2);
    };
    $2[6] = width2;
    $2[7] = widthStorageKey;
    $2[8] = t15;
  } else {
    t15 = $2[8];
  }
  const [paneWidth, setPaneWidth] = React__default.useState(t15);
  let t16;
  if ($2[9] !== widthStorageKey) {
    t16 = (width_1) => {
      setPaneWidth(width_1);
      try {
        localStorage.setItem(widthStorageKey, width_1.toString());
      } catch (t172) {
      }
    };
    $2[9] = widthStorageKey;
    $2[10] = t16;
  } else {
    t16 = $2[10];
  }
  const updatePaneWidth = t16;
  useRefObjectAsForwardedRef(forwardRef2, paneRef);
  const hasOverflow = useOverflow(paneRef);
  const paneId = useId(id);
  let labelProp;
  if ($2[11] !== hasOverflow || $2[12] !== label || $2[13] !== labelledBy) {
    labelProp = {};
    if (hasOverflow) {
      process.env.NODE_ENV !== "production" ? warning2(label === void 0 && labelledBy === void 0, "The <PageLayout.Pane> has overflow and `aria-label` or `aria-labelledby` has not been set. Please provide `aria-label` or `aria-labelledby` to <PageLayout.Pane> in order to label this region.") : void 0;
      if (labelledBy) {
        labelProp["aria-labelledby"] = labelledBy;
      } else {
        if (label) {
          labelProp["aria-label"] = label;
        }
      }
    }
    $2[11] = hasOverflow;
    $2[12] = label;
    $2[13] = labelledBy;
    $2[14] = labelProp;
  } else {
    labelProp = $2[14];
  }
  let t17;
  if ($2[15] !== className) {
    t17 = clsx(classes$i.PaneWrapper, className);
    $2[15] = className;
    $2[16] = t17;
  } else {
    t17 = $2[16];
  }
  const t18 = typeof offsetHeader === "number" ? `${offsetHeader}px` : offsetHeader;
  const t19 = `var(--spacing-${rowGap})`;
  const t20 = `var(--spacing-${columnGap})`;
  let t21;
  if ($2[17] !== style3 || $2[18] !== t18 || $2[19] !== t19 || $2[20] !== t20) {
    t21 = {
      "--offset-header": t18,
      "--spacing-row": t19,
      "--spacing-column": t20,
      ...style3
    };
    $2[17] = style3;
    $2[18] = t18;
    $2[19] = t19;
    $2[20] = t20;
    $2[21] = t21;
  } else {
    t21 = $2[21];
  }
  const t22 = sticky || void 0;
  let t23;
  if ($2[22] !== dividerVariant) {
    t23 = {
      narrow: dividerVariant,
      regular: "none"
    };
    $2[22] = dividerVariant;
    $2[23] = t23;
  } else {
    t23 = $2[23];
  }
  const t24 = `var(--spacing-${rowGap})`;
  let t25;
  if ($2[24] !== t24) {
    t25 = {
      "--spacing": t24
    };
    $2[24] = t24;
    $2[25] = t25;
  } else {
    t25 = $2[25];
  }
  const t26 = t25;
  let t27;
  if ($2[26] !== position4 || $2[27] !== t23 || $2[28] !== t26) {
    t27 = /* @__PURE__ */ jsxRuntimeExports.jsx(HorizontalDivider, {
      variant: t23,
      className: classes$i.PaneHorizontalDivider,
      style: t26,
      position: position4
    });
    $2[26] = position4;
    $2[27] = t23;
    $2[28] = t26;
    $2[29] = t27;
  } else {
    t27 = $2[29];
  }
  let t28;
  if ($2[30] !== hasOverflow) {
    t28 = hasOverflow ? overflowProps : {};
    $2[30] = hasOverflow;
    $2[31] = t28;
  } else {
    t28 = $2[31];
  }
  let t29;
  if ($2[32] !== id || $2[33] !== paneId) {
    t29 = id && {
      id: paneId
    };
    $2[32] = id;
    $2[33] = paneId;
    $2[34] = t29;
  } else {
    t29 = $2[34];
  }
  const t30 = resizable || void 0;
  const t31 = `var(--spacing-${padding2})`;
  const t32 = isCustomWidthOptions(width2) ? width2.min : `${minWidth2}px`;
  const t33 = isCustomWidthOptions(width2) ? width2.max : "calc(100vw - var(--pane-max-width-diff))";
  const t34 = isCustomWidthOptions(width2) ? width2.default : void 0;
  const t35 = `var(--pane-width-${isPaneWidth(width2) ? width2 : "custom"})`;
  const t36 = `${paneWidth}px`;
  let t37;
  if ($2[35] !== t31 || $2[36] !== t32 || $2[37] !== t33 || $2[38] !== t34 || $2[39] !== t35 || $2[40] !== t36) {
    t37 = {
      "--spacing": t31,
      "--pane-min-width": t32,
      "--pane-max-width": t33,
      "--pane-width-custom": t34,
      "--pane-width-size": t35,
      "--pane-width": t36
    };
    $2[35] = t31;
    $2[36] = t32;
    $2[37] = t33;
    $2[38] = t34;
    $2[39] = t35;
    $2[40] = t36;
    $2[41] = t37;
  } else {
    t37 = $2[41];
  }
  const t38 = t37;
  let t39;
  if ($2[42] !== children || $2[43] !== labelProp || $2[44] !== paneRef || $2[45] !== t28 || $2[46] !== t29 || $2[47] !== t30 || $2[48] !== t38) {
    t39 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      ref: paneRef,
      ...t28,
      ...labelProp,
      ...t29,
      className: classes$i.Pane,
      "data-resizable": t30,
      style: t38,
      children
    });
    $2[42] = children;
    $2[43] = labelProp;
    $2[44] = paneRef;
    $2[45] = t28;
    $2[46] = t29;
    $2[47] = t30;
    $2[48] = t38;
    $2[49] = t39;
  } else {
    t39 = $2[49];
  }
  const t40 = resizable ? "line" : dividerVariant;
  let t41;
  if ($2[50] !== t40) {
    t41 = {
      narrow: "none",
      regular: t40
    };
    $2[50] = t40;
    $2[51] = t41;
  } else {
    t41 = $2[51];
  }
  let t42;
  if ($2[52] !== paneWidth || $2[53] !== position4 || $2[54] !== updatePaneWidth) {
    t42 = (delta, t432) => {
      const isKeyboard = t432 === void 0 ? false : t432;
      let deltaWithDirection;
      if (isKeyboard) {
        deltaWithDirection = delta;
      } else {
        deltaWithDirection = position4 === "end" ? -delta : delta;
      }
      updatePaneWidth(paneWidth + deltaWithDirection);
    };
    $2[52] = paneWidth;
    $2[53] = position4;
    $2[54] = updatePaneWidth;
    $2[55] = t42;
  } else {
    t42 = $2[55];
  }
  let t43;
  if ($2[56] !== paneRef.current || $2[57] !== updatePaneWidth) {
    t43 = () => {
      var _paneRef$current;
      const paneRect = (_paneRef$current = paneRef.current) === null || _paneRef$current === void 0 ? void 0 : _paneRef$current.getBoundingClientRect();
      if (!paneRect) {
        return;
      }
      updatePaneWidth(paneRect.width);
    };
    $2[56] = paneRef.current;
    $2[57] = updatePaneWidth;
    $2[58] = t43;
  } else {
    t43 = $2[58];
  }
  let t44;
  if ($2[59] !== updatePaneWidth || $2[60] !== width2) {
    t44 = () => updatePaneWidth(getDefaultPaneWidth(width2));
    $2[59] = updatePaneWidth;
    $2[60] = width2;
    $2[61] = t44;
  } else {
    t44 = $2[61];
  }
  const t45 = `var(--spacing-${columnGap})`;
  let t46;
  if ($2[62] !== t45) {
    t46 = {
      "--spacing": t45
    };
    $2[62] = t45;
    $2[63] = t46;
  } else {
    t46 = $2[63];
  }
  const t47 = t46;
  let t48;
  if ($2[64] !== position4 || $2[65] !== resizable || $2[66] !== t41 || $2[67] !== t42 || $2[68] !== t43 || $2[69] !== t44 || $2[70] !== t47) {
    t48 = /* @__PURE__ */ jsxRuntimeExports.jsx(VerticalDivider, {
      variant: t41,
      draggable: resizable,
      onDrag: t42,
      onDragEnd: t43,
      position: position4,
      onDoubleClick: t44,
      className: classes$i.PaneVerticalDivider,
      style: t47
    });
    $2[64] = position4;
    $2[65] = resizable;
    $2[66] = t41;
    $2[67] = t42;
    $2[68] = t43;
    $2[69] = t44;
    $2[70] = t47;
    $2[71] = t48;
  } else {
    t48 = $2[71];
  }
  let t49;
  if ($2[72] !== isHidden || $2[73] !== position4 || $2[74] !== sx2 || $2[75] !== t17 || $2[76] !== t21 || $2[77] !== t22 || $2[78] !== t27 || $2[79] !== t39 || $2[80] !== t48) {
    t49 = /* @__PURE__ */ jsxRuntimeExports.jsxs(BoxWithFallback, {
      sx: sx2,
      className: t17,
      style: t21,
      "data-is-hidden": isHidden,
      "data-position": position4,
      "data-sticky": t22,
      children: [t27, t39, t48]
    });
    $2[72] = isHidden;
    $2[73] = position4;
    $2[74] = sx2;
    $2[75] = t17;
    $2[76] = t21;
    $2[77] = t22;
    $2[78] = t27;
    $2[79] = t39;
    $2[80] = t48;
    $2[81] = t49;
  } else {
    t49 = $2[81];
  }
  return t49;
});
Pane.displayName = "PageLayout.Pane";
const Footer2 = (t0) => {
  const $2 = distExports.c(27);
  const {
    "aria-label": label,
    "aria-labelledby": labelledBy,
    padding: t1,
    divider: t2,
    dividerWhenNarrow: t3,
    hidden: t4,
    children,
    sx: sx2,
    className,
    style: style3
  } = t0;
  const padding2 = t1 === void 0 ? "none" : t1;
  const divider = t2 === void 0 ? "none" : t2;
  const dividerWhenNarrow = t3 === void 0 ? "inherit" : t3;
  const hidden = t4 === void 0 ? false : t4;
  let t5;
  if ($2[0] !== divider || $2[1] !== dividerWhenNarrow) {
    t5 = !isResponsiveValue(divider) && dividerWhenNarrow !== "inherit" ? {
      regular: divider,
      narrow: dividerWhenNarrow
    } : divider;
    $2[0] = divider;
    $2[1] = dividerWhenNarrow;
    $2[2] = t5;
  } else {
    t5 = $2[2];
  }
  const dividerProp = t5;
  const dividerVariant = useResponsiveValue(dividerProp, "none");
  const isHidden = useResponsiveValue(hidden, false);
  const {
    rowGap
  } = React__default.useContext(PageLayoutContext);
  let t6;
  if ($2[3] !== className) {
    t6 = clsx(classes$i.FooterWrapper, className);
    $2[3] = className;
    $2[4] = t6;
  } else {
    t6 = $2[4];
  }
  const t7 = `var(--spacing-${rowGap})`;
  let t8;
  if ($2[5] !== style3 || $2[6] !== t7) {
    t8 = {
      "--spacing": t7,
      ...style3
    };
    $2[5] = style3;
    $2[6] = t7;
    $2[7] = t8;
  } else {
    t8 = $2[7];
  }
  const t9 = t8;
  const t10 = `var(--spacing-${rowGap})`;
  let t11;
  if ($2[8] !== t10) {
    t11 = {
      "--spacing": t10
    };
    $2[8] = t10;
    $2[9] = t11;
  } else {
    t11 = $2[9];
  }
  const t12 = t11;
  let t13;
  if ($2[10] !== dividerVariant || $2[11] !== t12) {
    t13 = /* @__PURE__ */ jsxRuntimeExports.jsx(HorizontalDivider, {
      className: classes$i.FooterHorizontalDivider,
      style: t12,
      variant: dividerVariant
    });
    $2[10] = dividerVariant;
    $2[11] = t12;
    $2[12] = t13;
  } else {
    t13 = $2[12];
  }
  const t14 = `var(--spacing-${padding2})`;
  let t15;
  if ($2[13] !== t14) {
    t15 = {
      "--spacing": t14
    };
    $2[13] = t14;
    $2[14] = t15;
  } else {
    t15 = $2[14];
  }
  const t16 = t15;
  let t17;
  if ($2[15] !== children || $2[16] !== t16) {
    t17 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: classes$i.FooterContent,
      style: t16,
      children
    });
    $2[15] = children;
    $2[16] = t16;
    $2[17] = t17;
  } else {
    t17 = $2[17];
  }
  let t18;
  if ($2[18] !== isHidden || $2[19] !== label || $2[20] !== labelledBy || $2[21] !== sx2 || $2[22] !== t13 || $2[23] !== t17 || $2[24] !== t6 || $2[25] !== t9) {
    t18 = /* @__PURE__ */ jsxRuntimeExports.jsxs(BoxWithFallback, {
      as: "footer",
      "aria-label": label,
      "aria-labelledby": labelledBy,
      hidden: isHidden,
      className: t6,
      sx: sx2,
      style: t9,
      children: [t13, t17]
    });
    $2[18] = isHidden;
    $2[19] = label;
    $2[20] = labelledBy;
    $2[21] = sx2;
    $2[22] = t13;
    $2[23] = t17;
    $2[24] = t6;
    $2[25] = t9;
    $2[26] = t18;
  } else {
    t18 = $2[26];
  }
  return t18;
};
Footer2.displayName = "PageLayout.Footer";
const PageLayout = Object.assign(Root, {
  Header: Header$3,
  Content,
  Pane,
  Footer: Footer2
});
function _temp$4(width_0) {
  if (isPaneWidth(width_0)) {
    return defaultPaneWidth[width_0];
  } else {
    if (isCustomWidthOptions(width_0)) {
      return Number(width_0.default.split("px")[0]);
    }
  }
  return 0;
}
const AutocompleteContext = /* @__PURE__ */ createContext(null);
var styles$1 = { "Invisible": "prc-components-Invisible-uIWry", "TextInputAction": "prc-components-TextInputAction-YT3YI", "ConditionalTooltip": "prc-components-ConditionalTooltip-6cihH" };
const ConditionalTooltip = (t0) => {
  const $2 = distExports.c(6);
  const {
    "aria-label": ariaLabel,
    children,
    tooltipDirection
  } = t0;
  let t1;
  if ($2[0] !== ariaLabel || $2[1] !== children || $2[2] !== tooltipDirection) {
    t1 = ariaLabel ? /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, {
      text: ariaLabel,
      direction: tooltipDirection,
      className: styles$1.ConditionalTooltip,
      children
    }) : children;
    $2[0] = ariaLabel;
    $2[1] = children;
    $2[2] = tooltipDirection;
    $2[3] = t1;
  } else {
    t1 = $2[3];
  }
  let t2;
  if ($2[4] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
      children: t1
    });
    $2[4] = t1;
    $2[5] = t2;
  } else {
    t2 = $2[5];
  }
  return t2;
};
const TextInputAction = /* @__PURE__ */ forwardRef$1((t0, forwardedRef) => {
  const $2 = distExports.c(32);
  let ariaLabel;
  let ariaLabelledBy;
  let children;
  let className;
  let icon;
  let rest;
  let sxProp;
  let t1;
  let tooltipDirection;
  if ($2[0] !== t0) {
    ({
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelledBy,
      tooltipDirection,
      children,
      icon,
      sx: sxProp,
      className,
      variant: t1,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = ariaLabel;
    $2[2] = ariaLabelledBy;
    $2[3] = children;
    $2[4] = className;
    $2[5] = icon;
    $2[6] = rest;
    $2[7] = sxProp;
    $2[8] = t1;
    $2[9] = tooltipDirection;
  } else {
    ariaLabel = $2[1];
    ariaLabelledBy = $2[2];
    children = $2[3];
    className = $2[4];
    icon = $2[5];
    rest = $2[6];
    sxProp = $2[7];
    t1 = $2[8];
    tooltipDirection = $2[9];
  }
  const variant3 = t1 === void 0 ? "invisible" : t1;
  const t2 = variant3 === "invisible" && styles$1.Invisible;
  let t3;
  if ($2[10] !== className || $2[11] !== t2) {
    t3 = clsx(t2, className);
    $2[10] = className;
    $2[11] = t2;
    $2[12] = t3;
  } else {
    t3 = $2[12];
  }
  let t4;
  if ($2[13] !== sxProp) {
    t4 = sxProp || {};
    $2[13] = sxProp;
    $2[14] = t4;
  } else {
    t4 = $2[14];
  }
  let t5;
  if ($2[15] !== t3 || $2[16] !== t4) {
    t5 = {
      className: t3,
      sx: t4
    };
    $2[15] = t3;
    $2[16] = t4;
    $2[17] = t5;
  } else {
    t5 = $2[17];
  }
  const styleProps = t5;
  if (icon && !ariaLabel || !children && !ariaLabel) {
    console.warn("Use the `aria-label` prop to provide an accessible label for assistive technology");
  }
  let t6;
  if ($2[18] !== ariaLabel || $2[19] !== ariaLabelledBy) {
    t6 = ariaLabel ? {
      "aria-label": ariaLabel
    } : ariaLabelledBy ? {
      "aria-labelledby": ariaLabelledBy
    } : {
      "aria-label": ""
    };
    $2[18] = ariaLabel;
    $2[19] = ariaLabelledBy;
    $2[20] = t6;
  } else {
    t6 = $2[20];
  }
  const accessibleLabel = t6;
  let t7;
  if ($2[21] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = clsx("TextInput-action", styles$1.TextInputAction);
    $2[21] = t7;
  } else {
    t7 = $2[21];
  }
  let t8;
  if ($2[22] !== accessibleLabel || $2[23] !== ariaLabel || $2[24] !== children || $2[25] !== forwardedRef || $2[26] !== icon || $2[27] !== rest || $2[28] !== styleProps || $2[29] !== tooltipDirection || $2[30] !== variant3) {
    var _tooltipDirection;
    t8 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: t7,
      children: icon && !children && ariaLabel ? /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, {
        ...accessibleLabel,
        tooltipDirection: (_tooltipDirection = tooltipDirection) !== null && _tooltipDirection !== void 0 ? _tooltipDirection : "s",
        variant: variant3,
        type: "button",
        icon,
        size: "small",
        ...styleProps,
        ...rest,
        ref: forwardedRef
      }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ConditionalTooltip, {
        "aria-label": ariaLabel,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
          variant: variant3,
          type: "button",
          ...styleProps,
          ...rest,
          ref: forwardedRef,
          children
        })
      })
    });
    $2[22] = accessibleLabel;
    $2[23] = ariaLabel;
    $2[24] = children;
    $2[25] = forwardedRef;
    $2[26] = icon;
    $2[27] = rest;
    $2[28] = styleProps;
    $2[29] = tooltipDirection;
    $2[30] = variant3;
    $2[31] = t8;
  } else {
    t8 = $2[31];
  }
  return t8;
});
const TextInput = /* @__PURE__ */ React__default.forwardRef(({
  icon: IconComponent,
  leadingVisual: LeadingVisual2,
  trailingVisual: TrailingVisual2,
  trailingAction,
  block: block2,
  className,
  contrast,
  disabled,
  loading,
  loaderPosition = "auto",
  loaderText = "Loading",
  monospace,
  validationStatus,
  sx: sxProp,
  size: sizeProp,
  onFocus,
  onBlur,
  // start deprecated props
  width: widthProp,
  minWidth: minWidthProp,
  maxWidth: maxWidthProp,
  variant: variantProp,
  // end deprecated props
  type = "text",
  required: required2,
  ...inputProps
}, ref2) => {
  const [isInputFocused, setIsInputFocused] = useState(false);
  const inputRef = useProvidedRefOrCreate(ref2);
  const wrapperClasses = clsx(className, "TextInput-wrapper");
  const showLeadingLoadingIndicator = loading && (loaderPosition === "leading" || Boolean(LeadingVisual2 && loaderPosition !== "trailing"));
  const showTrailingLoadingIndicator = loading && (loaderPosition === "trailing" || Boolean(loaderPosition === "auto" && !LeadingVisual2));
  const focusInput = () => {
    var _inputRef$current;
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  };
  const leadingVisualId = useId$2();
  const trailingVisualId = useId$2();
  const loadingId = useId$2();
  const inputDescribedBy = clsx(inputProps["aria-describedby"], LeadingVisual2 && leadingVisualId, TrailingVisual2 && trailingVisualId, loading && loadingId) || void 0;
  const handleInputFocus = useCallback$1((e) => {
    setIsInputFocused(true);
    onFocus && onFocus(e);
  }, [onFocus]);
  const handleInputBlur = useCallback$1((e_0) => {
    setIsInputFocused(false);
    onBlur && onBlur(e_0);
  }, [onBlur]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(TextInputWrapper, {
    block: block2,
    className: wrapperClasses,
    validationStatus,
    contrast,
    disabled,
    monospace,
    sx: sxProp,
    size: sizeProp,
    width: widthProp,
    minWidth: minWidthProp,
    maxWidth: maxWidthProp,
    variant: variantProp,
    hasLeadingVisual: Boolean(LeadingVisual2 || showLeadingLoadingIndicator),
    hasTrailingVisual: Boolean(TrailingVisual2 || showTrailingLoadingIndicator),
    hasTrailingAction: Boolean(trailingAction),
    isInputFocused,
    onClick: focusInput,
    "aria-busy": Boolean(loading),
    children: [IconComponent && /* @__PURE__ */ jsxRuntimeExports.jsx(IconComponent, {
      className: "TextInput-icon"
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(TextInputInnerVisualSlot, {
      visualPosition: "leading",
      showLoadingIndicator: showLeadingLoadingIndicator,
      hasLoadingIndicator: typeof loading === "boolean",
      id: leadingVisualId,
      children: typeof LeadingVisual2 !== "string" && reactIsExports.isValidElementType(LeadingVisual2) ? /* @__PURE__ */ jsxRuntimeExports.jsx(LeadingVisual2, {}) : LeadingVisual2
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(UnstyledTextInput, {
      ref: inputRef,
      disabled,
      onFocus: handleInputFocus,
      onBlur: handleInputBlur,
      type,
      "aria-required": required2,
      "aria-invalid": validationStatus === "error" ? "true" : void 0,
      ...inputProps,
      "aria-describedby": inputDescribedBy,
      "data-component": "input"
    }), loading && /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden, {
      id: loadingId,
      children: loaderText
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(TextInputInnerVisualSlot, {
      visualPosition: "trailing",
      showLoadingIndicator: showTrailingLoadingIndicator,
      hasLoadingIndicator: typeof loading === "boolean",
      id: trailingVisualId,
      "data-testid": "text-input-trailing-visual",
      children: typeof TrailingVisual2 !== "string" && reactIsExports.isValidElementType(TrailingVisual2) ? /* @__PURE__ */ jsxRuntimeExports.jsx(TrailingVisual2, {}) : TrailingVisual2
    }), trailingAction]
  });
});
TextInput.displayName = "TextInput";
var TextInput$1 = Object.assign(TextInput, {
  Action: TextInputAction
});
const ARROW_KEYS_NAV = /* @__PURE__ */ new Set(["ArrowUp", "ArrowDown"]);
const AutocompleteInput = /* @__PURE__ */ React__default.forwardRef(({
  as: Component2 = TextInput$1,
  onFocus,
  onBlur,
  onChange,
  onKeyDown,
  onKeyUp,
  onKeyPress,
  value,
  openOnFocus = false,
  ...props
}, forwardedRef) => {
  const autocompleteContext = useContext(AutocompleteContext);
  if (autocompleteContext === null) {
    throw new Error("AutocompleteContext returned null values");
  }
  const {
    activeDescendantRef,
    autocompleteSuggestion = "",
    id,
    inputRef,
    inputValue = "",
    isMenuDirectlyActivated,
    setInputValue,
    setShowMenu,
    showMenu
  } = autocompleteContext;
  useRefObjectAsForwardedRef(forwardedRef, inputRef);
  const [highlightRemainingText, setHighlightRemainingText] = useState(true);
  const {
    safeSetTimeout
  } = useSafeTimeout();
  const handleInputFocus = (event) => {
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    if (openOnFocus) {
      setShowMenu(true);
    }
  };
  const handleInputBlur = useCallback$1((event) => {
    onBlur && onBlur(event);
    safeSetTimeout(() => {
      if (document.activeElement !== inputRef.current) {
        setShowMenu(false);
      }
    }, 0);
  }, [onBlur, setShowMenu, inputRef, safeSetTimeout]);
  const handleInputChange = (event) => {
    onChange && onChange(event);
    setInputValue(event.currentTarget.value);
    if (!showMenu) {
      setShowMenu(true);
    }
  };
  const handleInputKeyDown = useCallback$1((event) => {
    var _inputRef$current;
    onKeyDown && onKeyDown(event);
    if (event.key === "Backspace") {
      setHighlightRemainingText(false);
    }
    if (event.key === "Escape" && (_inputRef$current = inputRef.current) !== null && _inputRef$current !== void 0 && _inputRef$current.value) {
      setInputValue("");
      inputRef.current.value = "";
    }
    if (!showMenu && ARROW_KEYS_NAV.has(event.key) && !event.altKey) {
      setShowMenu(true);
    }
  }, [inputRef, setInputValue, setHighlightRemainingText, onKeyDown, showMenu, setShowMenu]);
  const handleInputKeyUp = useCallback$1((event) => {
    onKeyUp && onKeyUp(event);
    if (event.key === "Backspace") {
      setHighlightRemainingText(true);
    }
  }, [setHighlightRemainingText, onKeyUp]);
  const onInputKeyPress = useCallback$1((event) => {
    onKeyPress && onKeyPress(event);
    if (showMenu && event.key === "Enter" && activeDescendantRef.current) {
      event.preventDefault();
      event.nativeEvent.stopImmediatePropagation();
      const activeDescendantEvent = new KeyboardEvent(event.type, event.nativeEvent);
      activeDescendantRef.current.dispatchEvent(activeDescendantEvent);
    }
  }, [activeDescendantRef, showMenu, onKeyPress]);
  useEffect(() => {
    if (!inputRef.current) {
      return;
    }
    if (!autocompleteSuggestion) {
      inputRef.current.value = inputValue;
    }
    if (highlightRemainingText && autocompleteSuggestion && (inputValue || isMenuDirectlyActivated)) {
      inputRef.current.value = autocompleteSuggestion;
      if (autocompleteSuggestion.toLowerCase().indexOf(inputValue.toLowerCase()) === 0) {
        inputRef.current.setSelectionRange(inputValue.length, autocompleteSuggestion.length);
      }
    }
  }, [autocompleteSuggestion, inputValue, inputRef, isMenuDirectlyActivated]);
  useEffect(() => {
    setInputValue(typeof value !== "undefined" ? value.toString() : "");
  }, [value, setInputValue]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, {
    onFocus: handleInputFocus,
    onBlur: handleInputBlur,
    onChange: handleInputChange,
    onKeyDown: handleInputKeyDown,
    onKeyPress: onInputKeyPress,
    onKeyUp: handleInputKeyUp,
    ref: inputRef,
    "aria-controls": `${id}-listbox`,
    "aria-autocomplete": "both",
    role: "combobox",
    "aria-expanded": showMenu,
    "aria-haspopup": "listbox",
    "aria-owns": `${id}-listbox`,
    autoComplete: "off",
    id,
    ...props
  });
});
AutocompleteInput.displayName = "AutocompleteInput";
function throttle$1(callback, wait2 = 0, { start: start4 = true, middle = true, once = false } = {}) {
  let innerStart = start4;
  let last = 0;
  let timer;
  let cancelled = false;
  function fn2(...args) {
    if (cancelled)
      return;
    const delta = Date.now() - last;
    last = Date.now();
    if (start4 && middle && delta >= wait2) {
      innerStart = true;
    }
    if (innerStart) {
      innerStart = false;
      callback.apply(this, args);
      if (once)
        fn2.cancel();
    } else if (middle && delta < wait2 || !middle) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        last = Date.now();
        callback.apply(this, args);
        if (once)
          fn2.cancel();
      }, !middle ? wait2 : wait2 - delta);
    }
  }
  fn2.cancel = () => {
    clearTimeout(timer);
    cancelled = true;
  };
  return fn2;
}
function debounce(callback, wait2 = 0, { start: start4 = false, middle = false, once = false } = {}) {
  return throttle$1(callback, wait2, { start: start4, middle, once });
}
var classes$h = { "SpinnerWrapper": "prc-Autocomplete-SpinnerWrapper-OvHpT", "EmptyStateWrapper": "prc-Autocomplete-EmptyStateWrapper-tAx1w" };
const getDefaultSortFn = (isItemSelectedFn) => (itemIdA, itemIdB) => isItemSelectedFn(itemIdA) === isItemSelectedFn(itemIdB) ? 0 : isItemSelectedFn(itemIdA) ? -1 : 1;
const menuScrollMargins$1 = {
  startMargin: 0,
  endMargin: 8
};
function getDefaultItemFilter(filterValue2) {
  return function(item, _i) {
    var _item$text;
    return Boolean((_item$text = item.text) === null || _item$text === void 0 ? void 0 : _item$text.toLowerCase().startsWith(filterValue2.toLowerCase()));
  };
}
function getdefaultCheckedSelectionChange(setInputValueFn) {
  return function(itemOrItems) {
    const {
      text: text2 = ""
    } = Array.isArray(itemOrItems) ? itemOrItems.slice(-1)[0] : itemOrItems;
    setInputValueFn(text2);
  };
}
const isItemSelected = (itemId, selectedItemIds) => selectedItemIds.includes(itemId);
function getItemById2(itemId, items) {
  return items.find((item) => item.id === itemId);
}
const debounceAnnouncement = debounce((announcement) => {
  announce(announcement);
}, 250);
function AutocompleteMenu(props) {
  const autocompleteContext = useContext(AutocompleteContext);
  if (autocompleteContext === null) {
    throw new Error("AutocompleteContext returned null values");
  }
  const {
    activeDescendantRef,
    id,
    inputRef,
    inputValue = "",
    scrollContainerRef,
    setAutocompleteSuggestion,
    setShowMenu,
    setInputValue,
    setIsMenuDirectlyActivated,
    setSelectedItemLength,
    showMenu
  } = autocompleteContext;
  const {
    items,
    selectedItemIds,
    sortOnCloseFn,
    emptyStateText = "No selectable options",
    addNewItem,
    loading,
    selectionVariant = "single",
    filterFn,
    "aria-labelledby": ariaLabelledBy,
    onOpenChange,
    onSelectedChange,
    customScrollContainerRef
  } = props;
  const listContainerRef = useRef(null);
  const allItemsToRenderRef = useRef([]);
  const [highlightedItem, setHighlightedItem] = useState();
  const [sortedItemIds, setSortedItemIds] = useState(items.map(({
    id: itemId
  }) => itemId));
  const generatedUniqueId = useId(id);
  const selectableItems = useMemo$1(() => items.map((selectableItem) => {
    return {
      ...selectableItem,
      role: "option",
      id: selectableItem.id,
      active: (highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.id) === selectableItem.id,
      selected: selectionVariant === "multiple" ? selectedItemIds.includes(selectableItem.id) : void 0,
      onAction: (item) => {
        const otherSelectedItemIds = selectedItemIds.filter((selectedItemId) => selectedItemId !== item.id);
        const newSelectedItemIds = selectedItemIds.includes(item.id) ? otherSelectedItemIds : [...otherSelectedItemIds, item.id];
        const onSelectedChangeFn = onSelectedChange ? onSelectedChange : getdefaultCheckedSelectionChange(setInputValue);
        onSelectedChangeFn(newSelectedItemIds.map((newSelectedItemId) => getItemById2(newSelectedItemId, items)));
        if (selectionVariant === "multiple") {
          setInputValue("");
          setAutocompleteSuggestion("");
        } else {
          var _inputRef$current;
          setShowMenu(false);
          (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
        }
      }
    };
  }), [highlightedItem, items, selectedItemIds, inputRef, onSelectedChange, selectionVariant, setAutocompleteSuggestion, setInputValue, setShowMenu]);
  const itemSortOrderData = useMemo$1(() => sortedItemIds.reduce((acc, curr, i) => {
    acc[curr] = i;
    return acc;
  }, {}), [sortedItemIds]);
  const sortedAndFilteredItemsToRender = useMemo$1(() => selectableItems.filter(filterFn ? filterFn : getDefaultItemFilter(inputValue)).sort((a2, b2) => itemSortOrderData[a2.id] - itemSortOrderData[b2.id]), [selectableItems, itemSortOrderData, filterFn, inputValue]);
  const allItemsToRender = useMemo$1(() => [
    // sorted and filtered selectable items
    ...sortedAndFilteredItemsToRender,
    // menu item used for creating a token from whatever is in the text input
    ...addNewItem ? [{
      ...addNewItem,
      role: "option",
      key: addNewItem.id,
      active: (highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.id) === addNewItem.id,
      selected: selectionVariant === "multiple" ? selectedItemIds.includes(addNewItem.id) : void 0,
      leadingVisual: () => /* @__PURE__ */ jsxRuntimeExports.jsx(PlusIcon, {}),
      onAction: (item_0) => {
        addNewItem.handleAddItem({
          ...item_0,
          id: item_0.id || generatedUniqueId,
          leadingVisual: void 0
        });
        if (selectionVariant === "multiple") {
          setInputValue("");
          setAutocompleteSuggestion("");
        }
      }
    }] : []
  ], [sortedAndFilteredItemsToRender, addNewItem, setAutocompleteSuggestion, selectionVariant, setInputValue, generatedUniqueId, highlightedItem, selectedItemIds]);
  React__default.useEffect(() => {
    allItemsToRenderRef.current = allItemsToRender;
  });
  React__default.useEffect(() => {
    if (allItemsToRender.length === 0) {
      debounceAnnouncement(emptyStateText);
    }
  }, [allItemsToRender, emptyStateText]);
  useFocusZone({
    containerRef: listContainerRef,
    focusOutBehavior: "wrap",
    focusableElementFilter: (element2) => {
      return !(element2 instanceof HTMLInputElement);
    },
    activeDescendantFocus: inputRef,
    onActiveDescendantChanged: (current, _previous, directlyActivated) => {
      activeDescendantRef.current = current || null;
      if (current) {
        const selectedItem = allItemsToRenderRef.current.find((item_1) => {
          var _current$closest;
          return item_1.id === ((_current$closest = current.closest("li")) === null || _current$closest === void 0 ? void 0 : _current$closest.getAttribute("data-id"));
        });
        setHighlightedItem(selectedItem);
        setIsMenuDirectlyActivated(directlyActivated);
      }
      if (current && customScrollContainerRef && customScrollContainerRef.current && directlyActivated) {
        scrollIntoView$1(current, customScrollContainerRef.current, menuScrollMargins$1);
      } else if (current && scrollContainerRef.current && directlyActivated) {
        scrollIntoView$1(current, scrollContainerRef.current, menuScrollMargins$1);
      }
    }
  }, [loading]);
  useEffect(() => {
    var _highlightedItem$text;
    if (highlightedItem !== null && highlightedItem !== void 0 && (_highlightedItem$text = highlightedItem.text) !== null && _highlightedItem$text !== void 0 && _highlightedItem$text.startsWith(inputValue) && !selectedItemIds.includes(highlightedItem.id)) {
      setAutocompleteSuggestion(highlightedItem.text);
    } else {
      setAutocompleteSuggestion("");
    }
  }, [highlightedItem, inputValue, selectedItemIds, setAutocompleteSuggestion]);
  useEffect(() => {
    const itemIdSortResult = [...sortedItemIds].sort(sortOnCloseFn ? sortOnCloseFn : getDefaultSortFn((itemId_0) => isItemSelected(itemId_0, selectedItemIds)));
    const sortResultMatchesState = itemIdSortResult.length === sortedItemIds.length && itemIdSortResult.every((element_0, index2) => element_0 === sortedItemIds[index2]);
    if (showMenu === false && !sortResultMatchesState) {
      setSortedItemIds(itemIdSortResult);
    }
    onOpenChange && onOpenChange(Boolean(showMenu));
  }, [showMenu, onOpenChange, selectedItemIds, sortOnCloseFn, sortedItemIds]);
  useEffect(() => {
    if (selectedItemIds.length) {
      setSelectedItemLength(selectedItemIds.length);
    }
  }, [selectedItemIds, setSelectedItemLength]);
  if (selectionVariant === "single" && selectedItemIds.length > 1) {
    throw new Error('Autocomplete: selectionVariant "single" cannot be used with multiple selected items');
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden, {
    isVisible: showMenu,
    children: loading ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: classes$h.SpinnerWrapper,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {})
    }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      ref: listContainerRef,
      children: allItemsToRender.length ? /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList, {
        selectionVariant,
        role: "listbox",
        id: `${id}-listbox`,
        "aria-labelledby": ariaLabelledBy,
        children: allItemsToRender.map((item_2) => {
          const {
            id: id_0,
            onAction,
            children,
            text: text2,
            leadingVisual: LeadingVisual2,
            trailingVisual: TrailingVisual2,
            // @ts-expect-error this is defined in the items above but is
            // missing in TS
            key: key2,
            ...itemProps
          } = item_2;
          return /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionList.Item, {
            onSelect: () => onAction(item_2),
            ...itemProps,
            id: id_0,
            "data-id": id_0,
            children: [LeadingVisual2 && /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.LeadingVisual, {
              children: reactIsExports.isElement(LeadingVisual2) ? LeadingVisual2 : /* @__PURE__ */ jsxRuntimeExports.jsx(LeadingVisual2, {})
            }), children !== null && children !== void 0 ? children : text2, TrailingVisual2 && /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.TrailingVisual, {
              children: reactIsExports.isElement(TrailingVisual2) ? TrailingVisual2 : /* @__PURE__ */ jsxRuntimeExports.jsx(TrailingVisual2, {})
            })]
          }, key2 !== null && key2 !== void 0 ? key2 : id_0);
        })
      }) : emptyStateText !== false && emptyStateText !== null ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
        className: classes$h.EmptyStateWrapper,
        children: emptyStateText
      }) : null
    })
  });
}
AutocompleteMenu.displayName = "AutocompleteMenu";
AutocompleteMenu.displayName = "AutocompleteMenu";
var classes$g = { "Overlay": "prc-Autocomplete-Overlay-4kapX" };
function AutocompleteOverlay(t0) {
  const $2 = distExports.c(24);
  let children;
  let menuAnchorRef;
  let newOverlayProps;
  let oldOverlayProps;
  if ($2[0] !== t0) {
    ({
      menuAnchorRef,
      overlayProps: oldOverlayProps,
      children,
      ...newOverlayProps
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = menuAnchorRef;
    $2[3] = newOverlayProps;
    $2[4] = oldOverlayProps;
  } else {
    children = $2[1];
    menuAnchorRef = $2[2];
    newOverlayProps = $2[3];
    oldOverlayProps = $2[4];
  }
  const autocompleteContext = useContext(AutocompleteContext);
  if (autocompleteContext === null) {
    throw new Error("AutocompleteContext returned null values");
  }
  let t1;
  if ($2[5] !== newOverlayProps || $2[6] !== oldOverlayProps) {
    t1 = {
      ...oldOverlayProps,
      ...newOverlayProps
    };
    $2[5] = newOverlayProps;
    $2[6] = oldOverlayProps;
    $2[7] = t1;
  } else {
    t1 = $2[7];
  }
  const overlayProps = t1;
  const {
    inputRef,
    scrollContainerRef,
    selectedItemLength,
    setShowMenu,
    showMenu: t2
  } = autocompleteContext;
  const showMenu = t2 === void 0 ? false : t2;
  const t3 = menuAnchorRef ? menuAnchorRef : inputRef;
  let t4;
  if ($2[8] !== t3) {
    t4 = {
      side: "outside-bottom",
      align: "start",
      anchorElementRef: t3
    };
    $2[8] = t3;
    $2[9] = t4;
  } else {
    t4 = $2[9];
  }
  let t5;
  if ($2[10] !== selectedItemLength || $2[11] !== showMenu) {
    t5 = [showMenu, selectedItemLength];
    $2[10] = selectedItemLength;
    $2[11] = showMenu;
    $2[12] = t5;
  } else {
    t5 = $2[12];
  }
  const {
    floatingElementRef,
    position: position4
  } = useAnchoredPosition(t4, t5);
  useRefObjectAsForwardedRef(scrollContainerRef, floatingElementRef);
  let t6;
  if ($2[13] !== setShowMenu) {
    t6 = () => {
      setShowMenu(false);
    };
    $2[13] = setShowMenu;
    $2[14] = t6;
  } else {
    t6 = $2[14];
  }
  const closeOptionList = t6;
  if (typeof window === "undefined") {
    return null;
  }
  let t7;
  if ($2[15] !== children || $2[16] !== closeOptionList || $2[17] !== floatingElementRef || $2[18] !== inputRef || $2[19] !== overlayProps || $2[20] !== (position4 === null || position4 === void 0 ? void 0 : position4.left) || $2[21] !== (position4 === null || position4 === void 0 ? void 0 : position4.top) || $2[22] !== showMenu) {
    t7 = showMenu ? /* @__PURE__ */ jsxRuntimeExports.jsx(Overlay$1, {
      returnFocusRef: inputRef,
      preventFocusOnOpen: true,
      onClickOutside: closeOptionList,
      onEscape: closeOptionList,
      ref: floatingElementRef,
      top: position4 === null || position4 === void 0 ? void 0 : position4.top,
      left: position4 === null || position4 === void 0 ? void 0 : position4.left,
      className: classes$g.Overlay,
      ...overlayProps,
      children
    }) : /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden, {
      "aria-hidden": "true",
      children
    });
    $2[15] = children;
    $2[16] = closeOptionList;
    $2[17] = floatingElementRef;
    $2[18] = inputRef;
    $2[19] = overlayProps;
    $2[20] = position4 === null || position4 === void 0 ? void 0 : position4.left;
    $2[21] = position4 === null || position4 === void 0 ? void 0 : position4.top;
    $2[22] = showMenu;
    $2[23] = t7;
  } else {
    t7 = $2[23];
  }
  return t7;
}
AutocompleteOverlay.displayName = "AutocompleteOverlay";
const initialState = {
  inputValue: "",
  showMenu: false,
  isMenuDirectlyActivated: false,
  autocompleteSuggestion: "",
  selectedItemLength: 0
};
const reducer$1 = (state, action) => {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case "inputValue":
      return {
        ...state,
        inputValue: payload
      };
    case "showMenu":
      return {
        ...state,
        showMenu: payload
      };
    case "isMenuDirectlyActivated":
      return {
        ...state,
        isMenuDirectlyActivated: payload
      };
    case "autocompleteSuggestion":
      return {
        ...state,
        autocompleteSuggestion: payload
      };
    case "selectedItemLength":
      return {
        ...state,
        selectedItemLength: payload
      };
    default:
      return state;
  }
};
const Autocomplete = (t0) => {
  const $2 = distExports.c(15);
  const {
    children,
    id: idProp
  } = t0;
  const activeDescendantRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const inputRef = useRef(null);
  const [state, dispatch] = useReducer(reducer$1, initialState);
  const {
    inputValue,
    showMenu,
    autocompleteSuggestion,
    isMenuDirectlyActivated,
    selectedItemLength
  } = state;
  let t1;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (value) => {
      dispatch({
        type: "inputValue",
        payload: value
      });
    };
    $2[0] = t1;
  } else {
    t1 = $2[0];
  }
  const setInputValue = t1;
  let t2;
  if ($2[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (value_0) => {
      dispatch({
        type: "showMenu",
        payload: value_0
      });
    };
    $2[1] = t2;
  } else {
    t2 = $2[1];
  }
  const setShowMenu = t2;
  let t3;
  if ($2[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (value_1) => {
      dispatch({
        type: "autocompleteSuggestion",
        payload: value_1
      });
    };
    $2[2] = t3;
  } else {
    t3 = $2[2];
  }
  const setAutocompleteSuggestion = t3;
  let t4;
  if ($2[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (value_2) => {
      dispatch({
        type: "isMenuDirectlyActivated",
        payload: value_2
      });
    };
    $2[3] = t4;
  } else {
    t4 = $2[3];
  }
  const setIsMenuDirectlyActivated = t4;
  let t5;
  if ($2[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = (value_3) => {
      dispatch({
        type: "selectedItemLength",
        payload: value_3
      });
    };
    $2[4] = t5;
  } else {
    t5 = $2[4];
  }
  const setSelectedItemLength = t5;
  const id = useId(idProp);
  let t6;
  if ($2[5] !== autocompleteSuggestion || $2[6] !== id || $2[7] !== inputValue || $2[8] !== isMenuDirectlyActivated || $2[9] !== selectedItemLength || $2[10] !== showMenu) {
    t6 = {
      activeDescendantRef,
      autocompleteSuggestion,
      id,
      inputRef,
      inputValue,
      isMenuDirectlyActivated,
      scrollContainerRef,
      selectedItemLength,
      setAutocompleteSuggestion,
      setInputValue,
      setIsMenuDirectlyActivated,
      setShowMenu,
      setSelectedItemLength,
      showMenu
    };
    $2[5] = autocompleteSuggestion;
    $2[6] = id;
    $2[7] = inputValue;
    $2[8] = isMenuDirectlyActivated;
    $2[9] = selectedItemLength;
    $2[10] = showMenu;
    $2[11] = t6;
  } else {
    t6 = $2[11];
  }
  let t7;
  if ($2[12] !== children || $2[13] !== t6) {
    t7 = /* @__PURE__ */ jsxRuntimeExports.jsx(AutocompleteContext.Provider, {
      value: t6,
      children
    });
    $2[12] = children;
    $2[13] = t6;
    $2[14] = t7;
  } else {
    t7 = $2[14];
  }
  return t7;
};
var Autocomplete$1 = Object.assign(Autocomplete, {
  Context: AutocompleteContext,
  Input: AutocompleteInput,
  Menu: AutocompleteMenu,
  Overlay: AutocompleteOverlay
});
var classes$f = { "Select": "prc-Select-Select-F7Flx", "TextInputWrapper": "prc-Select-TextInputWrapper-eBxmL", "Disabled": "prc-Select-Disabled-EtgGW", "ArrowIndicator": "prc-Select-ArrowIndicator-vtddB" };
const ArrowIndicatorSVG = (t0) => {
  const $2 = distExports.c(3);
  const {
    className
  } = t0;
  let t1;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /* @__PURE__ */ jsxRuntimeExports.jsx("path", {
      d: "m4.074 9.427 3.396 3.396a.25.25 0 0 0 .354 0l3.396-3.396A.25.25 0 0 0 11.043 9H4.251a.25.25 0 0 0-.177.427ZM4.074 7.47 7.47 4.073a.25.25 0 0 1 .354 0L11.22 7.47a.25.25 0 0 1-.177.426H4.251a.25.25 0 0 1-.177-.426Z"
    });
    $2[0] = t1;
  } else {
    t1 = $2[0];
  }
  let t2;
  if ($2[1] !== className) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx("svg", {
      "aria-hidden": "true",
      width: "16",
      height: "16",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: t1
    });
    $2[1] = className;
    $2[2] = t2;
  } else {
    t2 = $2[2];
  }
  return t2;
};
const ArrowIndicator = (t0) => {
  const $2 = distExports.c(4);
  const {
    className
  } = t0;
  let t1;
  if ($2[0] !== className) {
    t1 = clsx(classes$f.ArrowIndicator, className);
    $2[0] = className;
    $2[1] = t1;
  } else {
    t1 = $2[1];
  }
  let t2;
  if ($2[2] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowIndicatorSVG, {
      className: t1
    });
    $2[2] = t1;
    $2[3] = t2;
  } else {
    t2 = $2[3];
  }
  return t2;
};
const Select = /* @__PURE__ */ React__default.forwardRef((t0, ref2) => {
  var _ref, _defaultValue;
  const $2 = distExports.c(39);
  let block2;
  let children;
  let className;
  let contrast;
  let defaultValue2;
  let disabled;
  let placeholder2;
  let required2;
  let rest;
  let size2;
  let sx2;
  let validationStatus;
  if ($2[0] !== t0) {
    ({
      block: block2,
      children,
      className,
      contrast,
      defaultValue: defaultValue2,
      disabled,
      placeholder: placeholder2,
      size: size2,
      required: required2,
      validationStatus,
      sx: sx2,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = block2;
    $2[2] = children;
    $2[3] = className;
    $2[4] = contrast;
    $2[5] = defaultValue2;
    $2[6] = disabled;
    $2[7] = placeholder2;
    $2[8] = required2;
    $2[9] = rest;
    $2[10] = size2;
    $2[11] = sx2;
    $2[12] = validationStatus;
  } else {
    block2 = $2[1];
    children = $2[2];
    className = $2[3];
    contrast = $2[4];
    defaultValue2 = $2[5];
    disabled = $2[6];
    placeholder2 = $2[7];
    required2 = $2[8];
    rest = $2[9];
    size2 = $2[10];
    sx2 = $2[11];
    validationStatus = $2[12];
  }
  const t1 = validationStatus === "error" ? "true" : "false";
  const t2 = disabled && classes$f.Disabled;
  let t3;
  if ($2[13] !== className || $2[14] !== t2) {
    t3 = clsx(className, classes$f.Select, t2);
    $2[13] = className;
    $2[14] = t2;
    $2[15] = t3;
  } else {
    t3 = $2[15];
  }
  const t4 = Boolean(placeholder2);
  const t5 = (_ref = (_defaultValue = defaultValue2) !== null && _defaultValue !== void 0 ? _defaultValue : placeholder2) !== null && _ref !== void 0 ? _ref : void 0;
  let t6;
  if ($2[16] !== placeholder2 || $2[17] !== required2) {
    t6 = placeholder2 && /* @__PURE__ */ jsxRuntimeExports.jsx("option", {
      value: "",
      disabled: required2,
      hidden: required2,
      children: placeholder2
    });
    $2[16] = placeholder2;
    $2[17] = required2;
    $2[18] = t6;
  } else {
    t6 = $2[18];
  }
  let t7;
  if ($2[19] !== children || $2[20] !== disabled || $2[21] !== ref2 || $2[22] !== required2 || $2[23] !== rest || $2[24] !== t1 || $2[25] !== t3 || $2[26] !== t4 || $2[27] !== t5 || $2[28] !== t6) {
    t7 = /* @__PURE__ */ jsxRuntimeExports.jsxs("select", {
      ...rest,
      ref: ref2,
      required: required2,
      disabled,
      "aria-invalid": t1,
      className: t3,
      "data-hasplaceholder": t4,
      defaultValue: t5,
      children: [t6, children]
    });
    $2[19] = children;
    $2[20] = disabled;
    $2[21] = ref2;
    $2[22] = required2;
    $2[23] = rest;
    $2[24] = t1;
    $2[25] = t3;
    $2[26] = t4;
    $2[27] = t5;
    $2[28] = t6;
    $2[29] = t7;
  } else {
    t7 = $2[29];
  }
  let t8;
  if ($2[30] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowIndicator, {
      className: classes$f.ArrowIndicator
    });
    $2[30] = t8;
  } else {
    t8 = $2[30];
  }
  let t9;
  if ($2[31] !== block2 || $2[32] !== contrast || $2[33] !== disabled || $2[34] !== size2 || $2[35] !== sx2 || $2[36] !== t7 || $2[37] !== validationStatus) {
    t9 = /* @__PURE__ */ jsxRuntimeExports.jsxs(TextInputWrapper, {
      block: block2,
      contrast,
      disabled,
      size: size2,
      validationStatus,
      className: classes$f.TextInputWrapper,
      sx: sx2,
      children: [t7, t8]
    });
    $2[31] = block2;
    $2[32] = contrast;
    $2[33] = disabled;
    $2[34] = size2;
    $2[35] = sx2;
    $2[36] = t7;
    $2[37] = validationStatus;
    $2[38] = t9;
  } else {
    t9 = $2[38];
  }
  return t9;
});
const Option = (props) => {
  const $2 = distExports.c(2);
  let t0;
  if ($2[0] !== props) {
    t0 = /* @__PURE__ */ jsxRuntimeExports.jsx("option", {
      ...props
    });
    $2[0] = props;
    $2[1] = t0;
  } else {
    t0 = $2[1];
  }
  return t0;
};
const OptGroup = (props) => {
  const $2 = distExports.c(2);
  let t0;
  if ($2[0] !== props) {
    t0 = /* @__PURE__ */ jsxRuntimeExports.jsx("optgroup", {
      ...props
    });
    $2[0] = props;
    $2[1] = t0;
  } else {
    t0 = $2[1];
  }
  return t0;
};
var Select$1 = Object.assign(Select, {
  Option,
  OptGroup
});
var classes$e = { "Caption": "prc-FormControl-Caption-tfuKU" };
const FormControlContext = /* @__PURE__ */ createContext(null);
const FormControlContextProvider = FormControlContext.Provider;
function useFormControlContext() {
  var _useContext;
  return (_useContext = useContext(FormControlContext)) !== null && _useContext !== void 0 ? _useContext : {};
}
function useFormControlForwardedProps(externalProps) {
  const $2 = distExports.c(9);
  const context = useContext(FormControlContext);
  if (!context) {
    return externalProps;
  }
  let t0;
  if ($2[0] !== context.captionId || $2[1] !== context.validationMessageId) {
    t0 = [context.validationMessageId, context.captionId].filter(Boolean).join(" ") || void 0;
    $2[0] = context.captionId;
    $2[1] = context.validationMessageId;
    $2[2] = t0;
  } else {
    t0 = $2[2];
  }
  let t1;
  if ($2[3] !== context.disabled || $2[4] !== context.id || $2[5] !== context.required || $2[6] !== externalProps || $2[7] !== t0) {
    t1 = {
      disabled: context.disabled,
      id: context.id,
      required: context.required,
      "aria-describedby": t0,
      ...externalProps
    };
    $2[3] = context.disabled;
    $2[4] = context.id;
    $2[5] = context.required;
    $2[6] = externalProps;
    $2[7] = t0;
    $2[8] = t1;
  } else {
    t1 = $2[8];
  }
  return t1;
}
function FormControlCaption(t0) {
  const $2 = distExports.c(8);
  const {
    id,
    children,
    sx: sx2,
    className
  } = t0;
  const {
    captionId,
    disabled
  } = useFormControlContext();
  const t1 = id !== null && id !== void 0 ? id : captionId;
  let t2;
  if ($2[0] !== className) {
    t2 = clsx(className, classes$e.Caption);
    $2[0] = className;
    $2[1] = t2;
  } else {
    t2 = $2[1];
  }
  const t3 = disabled ? "" : void 0;
  let t4;
  if ($2[2] !== children || $2[3] !== sx2 || $2[4] !== t1 || $2[5] !== t2 || $2[6] !== t3) {
    t4 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: Text$2,
      id: t1,
      className: t2,
      "data-control-disabled": t3,
      sx: sx2,
      children
    });
    $2[2] = children;
    $2[3] = sx2;
    $2[4] = t1;
    $2[5] = t2;
    $2[6] = t3;
    $2[7] = t4;
  } else {
    t4 = $2[7];
  }
  return t4;
}
var classes$d = { "Label": "prc-components-Label-bE-kK", "RequiredText": "prc-components-RequiredText-ztJvt" };
function InputLabel(t0) {
  const $2 = distExports.c(30);
  let children;
  let className;
  let disabled;
  let htmlFor;
  let id;
  let props;
  let required2;
  let requiredIndicator;
  let requiredText;
  let sx2;
  let t1;
  let visuallyHidden2;
  if ($2[0] !== t0) {
    ({
      children,
      disabled,
      htmlFor,
      id,
      required: required2,
      requiredText,
      requiredIndicator,
      visuallyHidden: visuallyHidden2,
      sx: sx2,
      as: t1,
      className,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = className;
    $2[3] = disabled;
    $2[4] = htmlFor;
    $2[5] = id;
    $2[6] = props;
    $2[7] = required2;
    $2[8] = requiredIndicator;
    $2[9] = requiredText;
    $2[10] = sx2;
    $2[11] = t1;
    $2[12] = visuallyHidden2;
  } else {
    children = $2[1];
    className = $2[2];
    disabled = $2[3];
    htmlFor = $2[4];
    id = $2[5];
    props = $2[6];
    required2 = $2[7];
    requiredIndicator = $2[8];
    requiredText = $2[9];
    sx2 = $2[10];
    t1 = $2[11];
    visuallyHidden2 = $2[12];
  }
  const as2 = t1 === void 0 ? "label" : t1;
  const t2 = disabled ? "" : void 0;
  const t3 = visuallyHidden2 ? "" : void 0;
  let t4;
  if ($2[13] !== className) {
    t4 = clsx(className, classes$d.Label);
    $2[13] = className;
    $2[14] = t4;
  } else {
    t4 = $2[14];
  }
  let t5;
  if ($2[15] !== children || $2[16] !== required2 || $2[17] !== requiredIndicator || $2[18] !== requiredText) {
    var _requiredText;
    t5 = required2 || requiredText ? /* @__PURE__ */ jsxRuntimeExports.jsxs("span", {
      className: classes$d.RequiredText,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        children
      }), /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        "aria-hidden": requiredIndicator ? void 0 : true,
        children: (_requiredText = requiredText) !== null && _requiredText !== void 0 ? _requiredText : "*"
      })]
    }) : children;
    $2[15] = children;
    $2[16] = required2;
    $2[17] = requiredIndicator;
    $2[18] = requiredText;
    $2[19] = t5;
  } else {
    t5 = $2[19];
  }
  let t6;
  if ($2[20] !== as2 || $2[21] !== htmlFor || $2[22] !== id || $2[23] !== props || $2[24] !== sx2 || $2[25] !== t2 || $2[26] !== t3 || $2[27] !== t4 || $2[28] !== t5) {
    t6 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      as: as2,
      sx: sx2,
      "data-control-disabled": t2,
      "data-visually-hidden": t3,
      htmlFor,
      id,
      className: t4,
      ...props,
      children: t5
    });
    $2[20] = as2;
    $2[21] = htmlFor;
    $2[22] = id;
    $2[23] = props;
    $2[24] = sx2;
    $2[25] = t2;
    $2[26] = t3;
    $2[27] = t4;
    $2[28] = t5;
    $2[29] = t6;
  } else {
    t6 = $2[29];
  }
  return t6;
}
const FormControlLabel = (t0) => {
  const $2 = distExports.c(27);
  let as2;
  let children;
  let className;
  let htmlFor;
  let id;
  let props;
  let requiredText;
  let sx2;
  let t1;
  let visuallyHidden2;
  if ($2[0] !== t0) {
    ({
      as: as2,
      children,
      htmlFor,
      id,
      visuallyHidden: visuallyHidden2,
      requiredIndicator: t1,
      requiredText,
      sx: sx2,
      className,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = as2;
    $2[2] = children;
    $2[3] = className;
    $2[4] = htmlFor;
    $2[5] = id;
    $2[6] = props;
    $2[7] = requiredText;
    $2[8] = sx2;
    $2[9] = t1;
    $2[10] = visuallyHidden2;
  } else {
    as2 = $2[1];
    children = $2[2];
    className = $2[3];
    htmlFor = $2[4];
    id = $2[5];
    props = $2[6];
    requiredText = $2[7];
    sx2 = $2[8];
    t1 = $2[9];
    visuallyHidden2 = $2[10];
  }
  const requiredIndicator = t1 === void 0 ? true : t1;
  const {
    disabled,
    id: formControlId,
    required: required2
  } = useFormControlContext();
  let t2;
  if ($2[11] !== as2 || $2[12] !== className || $2[13] !== disabled || $2[14] !== formControlId || $2[15] !== htmlFor || $2[16] !== id || $2[17] !== props || $2[18] !== required2 || $2[19] !== requiredIndicator || $2[20] !== requiredText || $2[21] !== sx2 || $2[22] !== visuallyHidden2) {
    t2 = as2 === "legend" || as2 === "span" ? {
      as: as2,
      id,
      className,
      visuallyHidden: visuallyHidden2,
      required: required2,
      requiredText,
      requiredIndicator,
      disabled,
      sx: sx2,
      ...props
    } : {
      as: as2,
      id,
      className,
      visuallyHidden: visuallyHidden2,
      htmlFor: htmlFor || formControlId,
      required: required2,
      requiredText,
      requiredIndicator,
      disabled,
      sx: sx2,
      ...props
    };
    $2[11] = as2;
    $2[12] = className;
    $2[13] = disabled;
    $2[14] = formControlId;
    $2[15] = htmlFor;
    $2[16] = id;
    $2[17] = props;
    $2[18] = required2;
    $2[19] = requiredIndicator;
    $2[20] = requiredText;
    $2[21] = sx2;
    $2[22] = visuallyHidden2;
    $2[23] = t2;
  } else {
    t2 = $2[23];
  }
  const labelProps = t2;
  let t3;
  if ($2[24] !== children || $2[25] !== labelProps) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel, {
      ...labelProps,
      children
    });
    $2[24] = children;
    $2[25] = labelProps;
    $2[26] = t3;
  } else {
    t3 = $2[26];
  }
  return t3;
};
const FormControlLeadingVisual = (t0) => {
  const $2 = distExports.c(5);
  const {
    children,
    sx: sx2
  } = t0;
  const {
    disabled,
    captionId
  } = useFormControlContext();
  const t1 = disabled ? "" : void 0;
  const t2 = captionId ? "" : void 0;
  let t3;
  if ($2[0] !== children || $2[1] !== sx2 || $2[2] !== t1 || $2[3] !== t2) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLeadingVisual, {
      "data-control-disabled": t1,
      "data-has-caption": t2,
      sx: sx2,
      children
    });
    $2[0] = children;
    $2[1] = sx2;
    $2[2] = t1;
    $2[3] = t2;
    $2[4] = t3;
  } else {
    t3 = $2[4];
  }
  return t3;
};
const StyledLeadingVisual = qe.div.withConfig({
  displayName: "FormControlLeadingVisual__StyledLeadingVisual",
  componentId: "sc-1c26i0t-0"
})(["--leadingVisual-size:", ";color:var(--fgColor-default);display:flex;align-items:center;&:where([data-control-disabled]){color:var(--control-fgColor-disabled);}& > *{min-width:var(--leadingVisual-size);min-height:var(--leadingVisual-size);fill:currentColor;}&:where([data-has-caption]){--leadingVisual-size:", ";}", ""], get$3("fontSizes.2"), get$3("fontSizes.4"), sx);
const FormControlValidation = (t0) => {
  const $2 = distExports.c(6);
  const {
    children,
    className,
    variant: variant3,
    sx: sx2,
    id
  } = t0;
  const {
    validationMessageId
  } = useFormControlContext();
  const t1 = id || validationMessageId || "";
  let t2;
  if ($2[0] !== children || $2[1] !== className || $2[2] !== sx2 || $2[3] !== t1 || $2[4] !== variant3) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(InputValidation, {
      className,
      validationStatus: variant3,
      id: t1,
      sx: sx2,
      children
    });
    $2[0] = children;
    $2[1] = className;
    $2[2] = sx2;
    $2[3] = t1;
    $2[4] = variant3;
    $2[5] = t2;
  } else {
    t2 = $2[5];
  }
  return t2;
};
var classes$c = { "ControlHorizontalLayout": "prc-FormControl-ControlHorizontalLayout-GkYZF", "ControlVerticalLayout": "prc-FormControl-ControlVerticalLayout-wOp8f", "ControlChoiceInputs": "prc-FormControl-ControlChoiceInputs-VxfAy", "LabelContainer": "prc-FormControl-LabelContainer-lwQsw", "LeadingVisual": "prc-FormControl-LeadingVisual-fEyC5" };
var classes$b = { "Overlay": "prc-SelectPanel-Overlay-arLk6", "Wrapper": "prc-SelectPanel-Wrapper-43Iz8", "Header": "prc-SelectPanel-Header-4dLqk", "Title": "prc-SelectPanel-Title--CZN1", "Subtitle": "prc-SelectPanel-Subtitle-tMSzu", "Notice": "prc-SelectPanel-Notice-xDTd4", "Footer": "prc-SelectPanel-Footer-78rgp", "FilteredActionList": "prc-SelectPanel-FilteredActionList-wzS7m", "Message": "prc-SelectPanel-Message-CSpwI", "MessageTitle": "prc-SelectPanel-MessageTitle-o6PpS", "MessageBody": "prc-SelectPanel-MessageBody-89DEz", "MessageIcon": "prc-SelectPanel-MessageIcon-GS8ry", "MessageAction": "prc-SelectPanel-MessageAction-qwola", "ResponsiveCloseButton": "prc-SelectPanel-ResponsiveCloseButton-3mdX2", "ResponsiveFooter": "prc-SelectPanel-ResponsiveFooter-e-JSD", "SecondaryAction": "prc-SelectPanel-SecondaryAction-aWzLU", "CancelSaveButtons": "prc-SelectPanel-CancelSaveButtons-kk2cT", "ResponsiveSaveButton": "prc-SelectPanel-ResponsiveSaveButton-Ooz4Y", "Backdrop": "prc-SelectPanel-Backdrop-7XJa-" };
const SelectPanelMessage$1 = ({
  variant: variant3,
  title,
  children,
  className,
  icon: CustomIcon,
  action
}) => {
  const IconComponent = CustomIcon || (variant3 !== "empty" ? AlertIcon : void 0);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
    className: clsx(classes$b.Message, className),
    children: [IconComponent && /* @__PURE__ */ jsxRuntimeExports.jsx(Octicon, {
      icon: IconComponent,
      className: classes$b.MessageIcon,
      "data-variant": variant3
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, {
      className: classes$b.MessageTitle,
      children: title
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, {
      className: classes$b.MessageBody,
      children
    }), action && /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: classes$b.MessageAction,
      children: action
    })]
  });
};
SelectPanelMessage$1.displayName = "SelectPanelMessage";
const LinkButton = /* @__PURE__ */ forwardRef$1(({
  children,
  as: Component2 = "a",
  sx: sx2 = defaultSxProp,
  ...props
}, forwardedRef) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonBase, {
    as: Component2,
    ref: forwardedRef,
    sx: sx2,
    ...props,
    children
  });
});
var classes$a = { "LoadingSkeleton": "prc-FilteredActionList-LoadingSkeleton-x9WXt" };
class FilteredActionListLoadingType {
  constructor(name2, appearsInBody) {
    this.name = name2;
    this.appearsInBody = appearsInBody;
  }
}
const FilteredActionListLoadingTypes = {
  bodySpinner: new FilteredActionListLoadingType("body-spinner", true),
  bodySkeleton: new FilteredActionListLoadingType("body-skeleton", true),
  input: new FilteredActionListLoadingType("input", false)
};
const SKELETON_ROW_HEIGHT = 24;
const SKELETON_MIN_ROWS = 3;
function FilteredActionListBodyLoader(t0) {
  const $2 = distExports.c(4);
  const {
    loadingType,
    height: height2
  } = t0;
  switch (loadingType) {
    case FilteredActionListLoadingTypes.bodySpinner: {
      let t1;
      if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSpinner, {
          "data-testid": "filtered-action-list-spinner"
        });
        $2[0] = t1;
      } else {
        t1 = $2[0];
      }
      return t1;
    }
    case FilteredActionListLoadingTypes.bodySkeleton: {
      const rows = height2 < SKELETON_ROW_HEIGHT ? SKELETON_MIN_ROWS : height2 / SKELETON_ROW_HEIGHT;
      let t1;
      if ($2[1] !== rows) {
        t1 = /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, {
          "data-testid": "filtered-action-list-skeleton",
          rows
        });
        $2[1] = rows;
        $2[2] = t1;
      } else {
        t1 = $2[2];
      }
      return t1;
    }
    default: {
      let t1;
      if ($2[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
        $2[3] = t1;
      } else {
        t1 = $2[3];
      }
      return t1;
    }
  }
}
function LoadingSpinner(t0) {
  const $2 = distExports.c(5);
  let props;
  if ($2[0] !== t0) {
    ({
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = props;
  } else {
    props = $2[1];
  }
  let t1;
  if ($2[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignContent: "center",
      textAlign: "center",
      height: "100%"
    };
    $2[2] = t1;
  } else {
    t1 = $2[2];
  }
  let t2;
  if ($2[3] !== props) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(Box, {
      p: 3,
      flexGrow: 1,
      sx: t1,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {
        ...props
      })
    });
    $2[3] = props;
    $2[4] = t2;
  } else {
    t2 = $2[4];
  }
  return t2;
}
function LoadingSkeleton(t0) {
  const $2 = distExports.c(8);
  let props;
  let t1;
  if ($2[0] !== t0) {
    ({
      rows: t1,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = props;
    $2[2] = t1;
  } else {
    props = $2[1];
    t1 = $2[2];
  }
  const rows = t1 === void 0 ? 10 : t1;
  let t2;
  if ($2[3] !== rows) {
    t2 = Array.from({
      length: rows
    }, _temp$3);
    $2[3] = rows;
    $2[4] = t2;
  } else {
    t2 = $2[4];
  }
  let t3;
  if ($2[5] !== props || $2[6] !== t2) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx(Box, {
      p: 2,
      display: "flex",
      flexGrow: 1,
      flexDirection: "column",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Stack$1, {
        direction: "vertical",
        justify: "center",
        gap: "condensed",
        ...props,
        children: t2
      })
    });
    $2[5] = props;
    $2[6] = t2;
    $2[7] = t3;
  } else {
    t3 = $2[7];
  }
  return t3;
}
function _temp$3(_2, i) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack$1, {
    direction: "horizontal",
    gap: "condensed",
    align: "center",
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SkeletonBox, {
      width: "16px",
      height: "16px"
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(SkeletonBox, {
      height: "10px",
      width: `${Math.random() * 60 + 20}%`,
      className: classes$a.LoadingSkeleton
    })]
  }, i);
}
_temp$3.displayName = "_temp";
function useScrollFlash(scrollContainerRef) {
  useEffect(() => {
    const scrollContainer2 = scrollContainerRef.current;
    if (!scrollContainer2) {
      return;
    }
    const currentScroll = scrollContainer2.scrollTop;
    const maxScroll = scrollContainer2.scrollHeight;
    const altScroll = currentScroll < Math.min(1, maxScroll) ? currentScroll + 1 : currentScroll - 1;
    scrollContainer2.scrollTop = altScroll;
    scrollContainer2.scrollTop = currentScroll;
  }, [scrollContainerRef]);
}
var classes$9 = { "Container": "prc-FilteredActionList-Container-2A9NQ", "FullScreenTextInput": "prc-FilteredActionList-FullScreenTextInput-rCAiq", "SelectAllContainer": "prc-FilteredActionList-SelectAllContainer-w5otq", "SelectAllCheckbox": "prc-FilteredActionList-SelectAllCheckbox-dq2yL", "SelectAllLabel": "prc-FilteredActionList-SelectAllLabel-l34LA" };
const delayMs = 500;
const useFirstRender = () => {
  const firstRender = useRef(true);
  useEffect(() => {
    firstRender.current = false;
  }, []);
  return firstRender.current;
};
const getItemWithActiveDescendant = (listRef, items) => {
  const listElement = listRef.current;
  const activeItemElement = listElement === null || listElement === void 0 ? void 0 : listElement.querySelector("[data-is-active-descendant]");
  if (!listElement || !(activeItemElement !== null && activeItemElement !== void 0 && activeItemElement.textContent)) return;
  const optionElements = listElement.querySelectorAll('[role="option"]');
  const index2 = Array.from(optionElements).indexOf(activeItemElement);
  const activeItem = items[index2];
  const text2 = activeItem === null || activeItem === void 0 ? void 0 : activeItem.text;
  const selected = activeItem === null || activeItem === void 0 ? void 0 : activeItem.selected;
  return {
    index: index2,
    text: text2,
    selected
  };
};
const useAnnouncements = (items, listContainerRef, inputRef, t0, t1, message2) => {
  const $2 = distExports.c(28);
  const enabled = t0 === void 0 ? true : t0;
  const loading = t1 === void 0 ? false : t1;
  let t2;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = document.querySelector("live-region");
    $2[0] = t2;
  } else {
    t2 = $2[0];
  }
  const liveRegion = t2;
  let t3;
  if ($2[1] !== enabled) {
    t3 = (...t42) => {
      const args = t42;
      if (enabled) {
        return announce(...args);
      }
    };
    $2[1] = enabled;
    $2[2] = t3;
  } else {
    t3 = $2[2];
  }
  const announce$1 = t3;
  let t4;
  if ($2[3] !== announce$1 || $2[4] !== inputRef.current || $2[5] !== items || $2[6] !== listContainerRef) {
    t4 = function announceInitialFocus() {
      const focusHandler = () => {
        window.requestAnimationFrame(() => {
          const activeItem = getItemWithActiveDescendant(listContainerRef, items);
          if (!activeItem) {
            return;
          }
          const {
            index: index2,
            text: text2,
            selected
          } = activeItem;
          const announcementText = ["Focus on filter text box and list of items", `Focused item: ${text2}`, `${selected ? "selected" : "not selected"}`, `${index2 + 1} of ${items.length}`].join(", ");
          announce$1(announcementText, {
            delayMs,
            from: liveRegion ? liveRegion : void 0
          });
        });
      };
      const inputElement = inputRef.current;
      inputElement === null || inputElement === void 0 ? void 0 : inputElement.addEventListener("focus", focusHandler);
      return () => inputElement === null || inputElement === void 0 ? void 0 : inputElement.removeEventListener("focus", focusHandler);
    };
    $2[3] = announce$1;
    $2[4] = inputRef.current;
    $2[5] = items;
    $2[6] = listContainerRef;
    $2[7] = t4;
  } else {
    t4 = $2[7];
  }
  let t5;
  if ($2[8] !== announce$1 || $2[9] !== inputRef || $2[10] !== items || $2[11] !== listContainerRef) {
    t5 = [listContainerRef, inputRef, items, liveRegion, announce$1];
    $2[8] = announce$1;
    $2[9] = inputRef;
    $2[10] = items;
    $2[11] = listContainerRef;
    $2[12] = t5;
  } else {
    t5 = $2[12];
  }
  useEffect(t4, t5);
  const isFirstRender = useFirstRender();
  let t6;
  if ($2[13] !== announce$1 || $2[14] !== isFirstRender || $2[15] !== items || $2[16] !== listContainerRef || $2[17] !== loading || $2[18] !== (message2 === null || message2 === void 0 ? void 0 : message2.description) || $2[19] !== (message2 === null || message2 === void 0 ? void 0 : message2.title)) {
    t6 = function announceListUpdates() {
      if (isFirstRender) {
        return;
      }
      liveRegion === null || liveRegion === void 0 ? void 0 : liveRegion.clear();
      if (items.length === 0 && !loading) {
        announce$1(`${message2 === null || message2 === void 0 ? void 0 : message2.title}. ${message2 === null || message2 === void 0 ? void 0 : message2.description}`, {
          delayMs
        });
        return;
      }
      window.requestAnimationFrame(() => {
        const activeItem_0 = getItemWithActiveDescendant(listContainerRef, items);
        if (!activeItem_0) {
          return;
        }
        const {
          index: index_0,
          text: text_0,
          selected: selected_0
        } = activeItem_0;
        const announcementText_0 = ["List updated", `Focused item: ${text_0}`, `${selected_0 ? "selected" : "not selected"}`, `${index_0 + 1} of ${items.length}`].join(", ");
        announce$1(announcementText_0, {
          delayMs,
          from: liveRegion ? liveRegion : void 0
        });
      });
    };
    $2[13] = announce$1;
    $2[14] = isFirstRender;
    $2[15] = items;
    $2[16] = listContainerRef;
    $2[17] = loading;
    $2[18] = message2 === null || message2 === void 0 ? void 0 : message2.description;
    $2[19] = message2 === null || message2 === void 0 ? void 0 : message2.title;
    $2[20] = t6;
  } else {
    t6 = $2[20];
  }
  let t7;
  if ($2[21] !== announce$1 || $2[22] !== isFirstRender || $2[23] !== items || $2[24] !== listContainerRef || $2[25] !== loading || $2[26] !== message2) {
    t7 = [announce$1, isFirstRender, items, listContainerRef, liveRegion, loading, message2];
    $2[21] = announce$1;
    $2[22] = isFirstRender;
    $2[23] = items;
    $2[24] = listContainerRef;
    $2[25] = loading;
    $2[26] = message2;
    $2[27] = t7;
  } else {
    t7 = $2[27];
  }
  useEffect(t6, t7);
};
const menuScrollMargins = {
  startMargin: 0,
  endMargin: 8
};
const StyledHeader = qe.div.withConfig({
  displayName: "FilteredActionList__StyledHeader",
  componentId: "sc-1oqgb0s-0"
})(["box-shadow:0 1px 0 ", ";z-index:1;"], get$3("colors.border.default"));
function FilteredActionList({
  loading = false,
  placeholderText,
  filterValue: externalFilterValue,
  loadingType = FilteredActionListLoadingTypes.bodySpinner,
  onFilterChange,
  onListContainerRefChanged,
  onInputRefChanged,
  items,
  textInputProps,
  inputRef: providedInputRef,
  sx: sx2,
  groupMetadata,
  showItemDividers,
  message: message2,
  messageText,
  className,
  announcementsEnabled = true,
  fullScreenOnNarrow,
  onSelectAllChange,
  ...listProps
}) {
  const [filterValue2, setInternalFilterValue] = useProvidedStateOrCreate(externalFilterValue, void 0, "");
  const onInputChange = useCallback$1((e) => {
    const value = e.target.value;
    onFilterChange(value, e);
    setInternalFilterValue(value);
  }, [onFilterChange, setInternalFilterValue]);
  const scrollContainerRef = useRef(null);
  const inputRef = useProvidedRefOrCreate(providedInputRef);
  const [listContainerElement, setListContainerElement] = useState(null);
  const activeDescendantRef = useRef();
  const listId = useId();
  const inputDescriptionTextId = useId();
  const selectAllChecked = items.length > 0 && items.every((item) => item.selected);
  const selectAllIndeterminate = !selectAllChecked && items.some((item_0) => item_0.selected);
  const selectAllLabelText = selectAllChecked ? "Deselect all" : "Select all";
  const onInputKeyPress = useCallback$1((event) => {
    if (event.key === "Enter" && activeDescendantRef.current) {
      event.preventDefault();
      event.nativeEvent.stopImmediatePropagation();
      const activeDescendantEvent = new KeyboardEvent(event.type, event.nativeEvent);
      activeDescendantRef.current.dispatchEvent(activeDescendantEvent);
    }
  }, [activeDescendantRef]);
  const listContainerRefCallback = useCallback$1((node2) => {
    setListContainerElement(node2);
    onListContainerRefChanged === null || onListContainerRefChanged === void 0 ? void 0 : onListContainerRefChanged(node2);
  }, [onListContainerRefChanged]);
  useEffect(() => {
    onInputRefChanged === null || onInputRefChanged === void 0 ? void 0 : onInputRefChanged(inputRef);
  }, [inputRef, onInputRefChanged]);
  useFocusZone({
    containerRef: {
      current: listContainerElement
    },
    bindKeys: FocusKeys.ArrowVertical | FocusKeys.PageUpDown,
    focusOutBehavior: "wrap",
    focusableElementFilter: (element2) => {
      return !(element2 instanceof HTMLInputElement);
    },
    activeDescendantFocus: inputRef,
    onActiveDescendantChanged: (current, previous2, directlyActivated) => {
      activeDescendantRef.current = current;
      if (current && scrollContainerRef.current && directlyActivated) {
        scrollIntoView$1(current, scrollContainerRef.current, menuScrollMargins);
      }
    }
  }, [
    // List container isn't in the DOM while loading.  Need to re-bind focus zone when it changes.
    listContainerElement
  ]);
  useEffect(() => {
    if (activeDescendantRef.current && scrollContainerRef.current) {
      scrollIntoView$1(activeDescendantRef.current, scrollContainerRef.current, {
        ...menuScrollMargins,
        behavior: "auto"
      });
    }
  }, [items]);
  useAnnouncements(items, {
    current: listContainerElement
  }, inputRef, announcementsEnabled, loading, messageText);
  useScrollFlash(scrollContainerRef);
  const handleSelectAllChange = useCallback$1((e_0) => {
    if (onSelectAllChange) {
      onSelectAllChange(e_0.target.checked);
    }
  }, [onSelectAllChange]);
  function getItemListForEachGroup(groupId) {
    const itemsInGroup = [];
    for (const item_1 of items) {
      if (item_1.groupId === groupId) {
        itemsInGroup.push(item_1);
      }
    }
    return itemsInGroup;
  }
  function getBodyContent() {
    if (loading && scrollContainerRef.current && loadingType.appearsInBody) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FilteredActionListBodyLoader, {
        loadingType,
        height: scrollContainerRef.current.clientHeight
      });
    }
    if (message2) {
      return message2;
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList, {
      ref: listContainerRefCallback,
      showDividers: showItemDividers,
      ...listProps,
      role: "listbox",
      id: listId,
      sx: {
        flexGrow: 1
      },
      children: groupMetadata !== null && groupMetadata !== void 0 && groupMetadata.length ? groupMetadata.map((group, index2) => {
        var _group$header, _group$header2;
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionList.Group, {
          children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.GroupHeading, {
            variant: (_group$header = group.header) !== null && _group$header !== void 0 && _group$header.variant ? group.header.variant : void 0,
            children: (_group$header2 = group.header) !== null && _group$header2 !== void 0 && _group$header2.title ? group.header.title : `Group ${group.groupId}`
          }), getItemListForEachGroup(group.groupId).map(({
            key: itemKey,
            ...item_2
          }, index_0) => {
            var _ref, _item_2$id;
            const key2 = (_ref = itemKey !== null && itemKey !== void 0 ? itemKey : (_item_2$id = item_2.id) === null || _item_2$id === void 0 ? void 0 : _item_2$id.toString()) !== null && _ref !== void 0 ? _ref : index_0.toString();
            return /* @__PURE__ */ jsxRuntimeExports.jsx(MappedActionListItem, {
              ...item_2,
              renderItem: listProps.renderItem
            }, key2);
          })]
        }, index2);
      }) : items.map(({
        key: itemKey_0,
        ...item_3
      }, index_1) => {
        var _ref2, _item_3$id;
        const key_0 = (_ref2 = itemKey_0 !== null && itemKey_0 !== void 0 ? itemKey_0 : (_item_3$id = item_3.id) === null || _item_3$id === void 0 ? void 0 : _item_3$id.toString()) !== null && _ref2 !== void 0 ? _ref2 : index_1.toString();
        return /* @__PURE__ */ jsxRuntimeExports.jsx(MappedActionListItem, {
          ...item_3,
          renderItem: listProps.renderItem
        }, key_0);
      })
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    sx: sx2,
    className,
    "data-testid": "filtered-action-list",
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput$1, {
        ref: inputRef,
        block: true,
        width: "auto",
        color: "fg.default",
        value: filterValue2,
        onChange: onInputChange,
        onKeyPress: onInputKeyPress,
        placeholder: placeholderText,
        role: "combobox",
        "aria-expanded": "true",
        "aria-autocomplete": "list",
        "aria-controls": listId,
        "aria-label": placeholderText,
        "aria-describedby": inputDescriptionTextId,
        loaderPosition: "leading",
        loading: loading && !loadingType.appearsInBody,
        className: clsx(textInputProps === null || textInputProps === void 0 ? void 0 : textInputProps.className, fullScreenOnNarrow && classes$9.FullScreenTextInput),
        ...textInputProps
      })
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, {
      id: inputDescriptionTextId,
      children: "Items will be filtered as you type"
    }), onSelectAllChange !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      className: classes$9.SelectAllContainer,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$1, {
        id: "select-all-checkbox",
        className: classes$9.SelectAllCheckbox,
        checked: selectAllChecked,
        indeterminate: selectAllIndeterminate,
        onChange: handleSelectAllChange
      }), /* @__PURE__ */ jsxRuntimeExports.jsx("label", {
        className: classes$9.SelectAllLabel,
        htmlFor: "select-all-checkbox",
        children: selectAllLabelText
      })]
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      ref: scrollContainerRef,
      className: classes$9.Container,
      children: getBodyContent()
    })]
  });
}
FilteredActionList.displayName = "FilteredActionList";
function MappedActionListItem(item) {
  const $2 = distExports.c(35);
  if (typeof item.renderItem === "function") {
    let t02;
    if ($2[0] !== item) {
      t02 = item.renderItem(item);
      $2[0] = item;
      $2[1] = t02;
    } else {
      t02 = $2[1];
    }
    return t02;
  }
  let LeadingVisual2;
  let TrailingIcon;
  let TrailingVisual2;
  let children;
  let description;
  let descriptionVariant;
  let id;
  let onAction;
  let rest;
  let text2;
  let trailingText;
  if ($2[2] !== item) {
    ({
      id,
      description,
      descriptionVariant,
      text: text2,
      trailingVisual: TrailingVisual2,
      leadingVisual: LeadingVisual2,
      trailingText,
      trailingIcon: TrailingIcon,
      onAction,
      children,
      ...rest
    } = item);
    $2[2] = item;
    $2[3] = LeadingVisual2;
    $2[4] = TrailingIcon;
    $2[5] = TrailingVisual2;
    $2[6] = children;
    $2[7] = description;
    $2[8] = descriptionVariant;
    $2[9] = id;
    $2[10] = onAction;
    $2[11] = rest;
    $2[12] = text2;
    $2[13] = trailingText;
  } else {
    LeadingVisual2 = $2[3];
    TrailingIcon = $2[4];
    TrailingVisual2 = $2[5];
    children = $2[6];
    description = $2[7];
    descriptionVariant = $2[8];
    id = $2[9];
    onAction = $2[10];
    rest = $2[11];
    text2 = $2[12];
    trailingText = $2[13];
  }
  let t0;
  if ($2[14] !== item || $2[15] !== onAction) {
    t0 = (e) => {
      if (typeof onAction === "function") {
        onAction(item, e);
      }
    };
    $2[14] = item;
    $2[15] = onAction;
    $2[16] = t0;
  } else {
    t0 = $2[16];
  }
  let t1;
  if ($2[17] !== LeadingVisual2) {
    t1 = LeadingVisual2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.LeadingVisual, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(LeadingVisual2, {})
    }) : null;
    $2[17] = LeadingVisual2;
    $2[18] = t1;
  } else {
    t1 = $2[18];
  }
  let t2;
  if ($2[19] !== description || $2[20] !== descriptionVariant) {
    t2 = description ? /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Description, {
      variant: descriptionVariant,
      children: description
    }) : null;
    $2[19] = description;
    $2[20] = descriptionVariant;
    $2[21] = t2;
  } else {
    t2 = $2[21];
  }
  let t3;
  if ($2[22] !== TrailingIcon || $2[23] !== TrailingVisual2 || $2[24] !== trailingText) {
    t3 = TrailingVisual2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.TrailingVisual, {
      children: typeof TrailingVisual2 !== "string" && reactIsExports.isValidElementType(TrailingVisual2) ? /* @__PURE__ */ jsxRuntimeExports.jsx(TrailingVisual2, {}) : TrailingVisual2
    }) : TrailingIcon || trailingText ? /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionList.TrailingVisual, {
      children: [trailingText, TrailingIcon && /* @__PURE__ */ jsxRuntimeExports.jsx(TrailingIcon, {})]
    }) : null;
    $2[22] = TrailingIcon;
    $2[23] = TrailingVisual2;
    $2[24] = trailingText;
    $2[25] = t3;
  } else {
    t3 = $2[25];
  }
  let t4;
  if ($2[26] !== children || $2[27] !== id || $2[28] !== rest || $2[29] !== t0 || $2[30] !== t1 || $2[31] !== t2 || $2[32] !== t3 || $2[33] !== text2) {
    t4 = /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionList.Item, {
      role: "option",
      onSelect: t0,
      "data-id": id,
      ...rest,
      children: [t1, children, text2, t2, t3]
    });
    $2[26] = children;
    $2[27] = id;
    $2[28] = rest;
    $2[29] = t0;
    $2[30] = t1;
    $2[31] = t2;
    $2[32] = t3;
    $2[33] = text2;
    $2[34] = t4;
  } else {
    t4 = $2[34];
  }
  return t4;
}
FilteredActionList.displayName = "FilteredActionList";
const SHORT_DELAY_MS = 500;
const LONG_DELAY_MS = 1e3;
const EMPTY_MESSAGE = {
  title: "No items available",
  description: ""
};
const DefaultEmptyMessage = /* @__PURE__ */ jsxRuntimeExports.jsx(SelectPanelMessage$1, {
  variant: "empty",
  title: EMPTY_MESSAGE.title,
  children: EMPTY_MESSAGE.description
}, "empty-message");
async function announceText(text2, delayMs2 = SHORT_DELAY_MS) {
  const liveRegion = document.querySelector("live-region");
  liveRegion === null || liveRegion === void 0 ? void 0 : liveRegion.clear();
  await announce(text2, {
    delayMs: delayMs2,
    from: liveRegion ? liveRegion : void 0
    // announce will create a liveRegion if it doesn't find one
  });
}
async function announceLoading() {
  await announceText("Loading.");
}
function isMultiSelectVariant(selected) {
  return Array.isArray(selected);
}
const focusZoneSettings = {
  // Let FilteredActionList handle focus zone
  disabled: true
};
const areItemsEqual = (itemA, itemB) => {
  if (typeof itemA.id !== "undefined") return itemA.id === itemB.id;
  else return itemA === itemB;
};
const doesItemsIncludeItem = (items, item) => {
  return items.some((i) => areItemsEqual(i, item));
};
const defaultRenderAnchor = (props) => {
  const {
    children,
    ...rest
  } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
    trailingAction: TriangleDownIcon,
    ...rest,
    children
  });
};
defaultRenderAnchor.displayName = "defaultRenderAnchor";
function Panel$1({
  open,
  onOpenChange,
  renderAnchor = defaultRenderAnchor,
  anchorRef: externalAnchorRef,
  placeholder: placeholder2,
  placeholderText = "Filter items",
  inputLabel = placeholderText,
  selected,
  title = isMultiSelectVariant(selected) ? "Select items" : "Select an item",
  subtitle,
  onSelectedChange,
  filterValue: externalFilterValue,
  onFilterChange: externalOnFilterChange,
  items,
  footer: footer2,
  textInputProps,
  overlayProps,
  sx: sx2,
  loading,
  initialLoadingType = "spinner",
  className,
  height: height2,
  width: width2,
  id,
  message: message2,
  notice,
  onCancel,
  variant: variant3 = "anchored",
  secondaryAction,
  showSelectedOptionsFirst = true,
  disableFullscreenOnNarrow,
  align,
  showSelectAll = false,
  ...listProps
}) {
  var _listProps$groupMetad;
  const titleId = useId();
  const subtitleId = useId();
  const [dataLoadedOnce, setDataLoadedOnce] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [filterValue2, setInternalFilterValue] = useProvidedStateOrCreate(externalFilterValue, void 0, "");
  const {
    safeSetTimeout,
    safeClearTimeout
  } = useSafeTimeout();
  const loadingDelayTimeoutId = useRef(null);
  const loadingManagedInternally = loading === void 0;
  const loadingManagedExternally = !loadingManagedInternally;
  const [inputRef, setInputRef] = React__default.useState(null);
  const [listContainerElement, setListContainerElement] = useState(null);
  const [needsNoItemsAnnouncement, setNeedsNoItemsAnnouncement] = useState(false);
  const isNarrowScreenSize = useResponsiveValue({
    narrow: true,
    regular: false,
    wide: false
  }, false);
  const [selectedOnSort, setSelectedOnSort] = useState([]);
  const [prevItems, setPrevItems] = useState([]);
  const [prevOpen, setPrevOpen] = useState(open);
  const initialHeightRef = useRef(0);
  const initialScaleRef = useRef(1);
  const noticeRef = useRef(null);
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);
  const [availablePanelHeight, setAvailablePanelHeight] = useState(void 0);
  const KEYBOARD_VISIBILITY_THRESHOLD = 10;
  const featureFlagFullScreenOnNarrow = useFeatureFlag("primer_react_select_panel_fullscreen_on_narrow");
  const usingFullScreenOnNarrow = disableFullscreenOnNarrow ? false : featureFlagFullScreenOnNarrow;
  const shouldOrderSelectedFirst = useFeatureFlag("primer_react_select_panel_order_selected_at_top") && showSelectedOptionsFirst;
  const isSingleSelectModal = variant3 === "modal" && !isMultiSelectVariant(selected);
  const [intermediateSelected, setIntermediateSelected] = useState(isSingleSelectModal ? selected : void 0);
  useEffect(() => {
    setIntermediateSelected(isSingleSelectModal ? selected : void 0);
  }, [isSingleSelectModal, open, selected]);
  const onListContainerRefChanged = useCallback$1((node2) => {
    setListContainerElement(node2);
    if (!node2 && needsNoItemsAnnouncement) {
      setNeedsNoItemsAnnouncement(false);
    }
  }, [needsNoItemsAnnouncement]);
  const onInputRefChanged = useCallback$1((ref2) => {
    setInputRef(ref2);
  }, [setInputRef]);
  const resetSort = useCallback$1(() => {
    if (isMultiSelectVariant(selected)) {
      setSelectedOnSort(selected);
    } else if (selected) {
      setSelectedOnSort([selected]);
    } else {
      setSelectedOnSort([]);
    }
  }, [selected]);
  const onFilterChange = useCallback$1((value, e) => {
    if (loadingManagedInternally) {
      if (loadingDelayTimeoutId.current) {
        safeClearTimeout(loadingDelayTimeoutId.current);
      }
      if (dataLoadedOnce) {
        loadingDelayTimeoutId.current = safeSetTimeout(() => {
          setIsLoading(true);
          announceLoading();
        }, LONG_DELAY_MS);
      } else {
        if (items.length === 0) {
          setIsLoading(true);
        }
        loadingDelayTimeoutId.current = safeSetTimeout(() => {
          announceLoading();
        }, LONG_DELAY_MS);
      }
    }
    externalOnFilterChange(value, e);
    setInternalFilterValue(value);
    if (!value) {
      resetSort();
    }
  }, [loadingManagedInternally, externalOnFilterChange, setInternalFilterValue, dataLoadedOnce, safeSetTimeout, safeClearTimeout, items.length, resetSort]);
  const handleSelectAllChange = useCallback$1((checked) => {
    if (!isMultiSelectVariant(selected)) {
      return;
    }
    const multiSelectOnChange = onSelectedChange;
    const selectedArray = selected;
    const selectedItemsNotInFilteredView = selectedArray.filter((selectedItem) => !items.some((item) => areItemsEqual(item, selectedItem)));
    if (checked) {
      multiSelectOnChange([...selectedItemsNotInFilteredView, ...items]);
    } else {
      multiSelectOnChange(selectedItemsNotInFilteredView);
    }
  }, [items, onSelectedChange, selected]);
  useEffect(() => {
    if (open && isNarrowScreenSize && usingFullScreenOnNarrow) {
      const bodyOverflowStyle = document.body.style.overflow || "";
      if (bodyOverflowStyle === "hidden") {
        return;
      }
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = bodyOverflowStyle;
      };
    }
  }, [isNarrowScreenSize, open, usingFullScreenOnNarrow]);
  useEffect(() => {
    if (open) {
      if (items.length === 0 && !(isLoading || loading)) {
        setNeedsNoItemsAnnouncement(true);
      }
    }
    if (loadingManagedExternally) {
      if (items.length > 0) {
        setDataLoadedOnce(true);
      }
      return;
    }
    if (isLoading || items.length > 0) {
      setIsLoading(false);
      setDataLoadedOnce(true);
    }
    if (loadingDelayTimeoutId.current) {
      safeClearTimeout(loadingDelayTimeoutId.current);
    }
  }, [items]);
  useEffect(() => {
    if (inputRef !== null && inputRef !== void 0 && inputRef.current) {
      const ref2 = inputRef.current;
      if (open) {
        ref2.focus();
      }
    }
  }, [inputRef, open]);
  useEffect(() => {
    if (loadingManagedExternally) {
      if (isLoading) {
        loadingDelayTimeoutId.current = safeSetTimeout(() => {
          announceLoading();
        }, LONG_DELAY_MS);
      } else {
        if (loadingDelayTimeoutId.current) {
          safeClearTimeout(loadingDelayTimeoutId.current);
        }
      }
    }
  }, [isLoading, loadingManagedExternally, safeSetTimeout, safeClearTimeout]);
  useEffect(() => {
    if (loadingManagedExternally) return;
    if (dataLoadedOnce) return;
    if (open) {
      if (items.length === 0) {
        onFilterChange(filterValue2, null);
      }
    }
  }, [open, dataLoadedOnce, onFilterChange, filterValue2, items, loadingManagedExternally, listContainerElement]);
  useEffect(() => {
    if (!window.visualViewport || !open || !isNarrowScreenSize) {
      return;
    }
    initialHeightRef.current = window.visualViewport.height;
    initialScaleRef.current = window.visualViewport.scale;
    const handleViewportChange = debounce(() => {
      if (window.visualViewport) {
        const currentScale = window.visualViewport.scale;
        const isZooming = currentScale !== initialScaleRef.current;
        if (!isZooming) {
          const currentHeight = window.visualViewport.height;
          const keyboardVisible = initialHeightRef.current - currentHeight > KEYBOARD_VISIBILITY_THRESHOLD;
          setIsKeyboardVisible(keyboardVisible);
          setAvailablePanelHeight(keyboardVisible ? currentHeight : void 0);
        }
      }
    }, 100);
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", handleViewportChange);
      window.visualViewport.addEventListener("scroll", handleViewportChange);
    }
    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", handleViewportChange);
        window.visualViewport.removeEventListener("scroll", handleViewportChange);
      }
      handleViewportChange.cancel();
    };
  }, [open, isNarrowScreenSize]);
  useEffect(() => {
    const announceNotice = async () => {
      if (!noticeRef.current) return;
      const liveRegion = document.querySelector("live-region");
      liveRegion === null || liveRegion === void 0 ? void 0 : liveRegion.clear();
      await announceFromElement(noticeRef.current, {
        from: liveRegion ? liveRegion : void 0
      });
    };
    if (open && notice) {
      announceNotice();
    }
  }, [notice, open]);
  const anchorRef = useProvidedRefOrCreate(externalAnchorRef);
  const onOpen = useCallback$1((gesture) => onOpenChange(true, gesture), [onOpenChange]);
  const onCancelRequested = useCallback$1(() => {
    onOpenChange(false, "cancel");
  }, [onOpenChange]);
  const onClose = useCallback$1((gesture) => {
    if (variant3 === "modal" && gesture === "click-outside") {
      onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    }
    if (gesture === "close") {
      onCancel === null || onCancel === void 0 ? void 0 : onCancel();
      onCancelRequested();
    } else {
      onOpenChange(false, gesture);
    }
  }, [onOpenChange, variant3, onCancel, onCancelRequested]);
  const renderMenuAnchor = useMemo$1(() => {
    if (renderAnchor === null) {
      return null;
    }
    const selectedItems = Array.isArray(selected) ? selected : [...selected ? [selected] : []];
    return (props) => {
      return renderAnchor({
        ...props,
        children: selectedItems.length ? selectedItems.map((item) => item.text).join(", ") : placeholder2
      });
    };
  }, [placeholder2, renderAnchor, selected]);
  const isItemCurrentlySelected = useCallback$1((item) => {
    if (isMultiSelectVariant(selected)) {
      return doesItemsIncludeItem(selected, item);
    }
    if (isSingleSelectModal) {
      return (intermediateSelected === null || intermediateSelected === void 0 ? void 0 : intermediateSelected.id) !== void 0 ? intermediateSelected.id === item.id : intermediateSelected === item;
    }
    return (selected === null || selected === void 0 ? void 0 : selected.id) !== void 0 ? selected.id === item.id : selected === item;
  }, [selected, intermediateSelected, isSingleSelectModal]);
  const itemsToRender = useMemo$1(() => {
    return items.map((item) => {
      return {
        ...item,
        role: "option",
        selected: "selected" in item && item.selected === void 0 ? void 0 : isItemCurrentlySelected(item),
        onAction: (itemFromAction, event) => {
          var _item$onAction;
          (_item$onAction = item.onAction) === null || _item$onAction === void 0 ? void 0 : _item$onAction.call(item, itemFromAction, event);
          if (event.defaultPrevented) {
            return;
          }
          if (isMultiSelectVariant(selected)) {
            const otherSelectedItems = selected.filter((selectedItem) => !areItemsEqual(selectedItem, item));
            const newSelectedItems = doesItemsIncludeItem(selected, item) ? otherSelectedItems : [...otherSelectedItems, item];
            const multiSelectOnChange = onSelectedChange;
            multiSelectOnChange(newSelectedItems);
            return;
          }
          if (isSingleSelectModal) {
            if ((intermediateSelected === null || intermediateSelected === void 0 ? void 0 : intermediateSelected.id) === item.id) {
              setIntermediateSelected(void 0);
            } else {
              setIntermediateSelected(item);
            }
            return;
          }
          const singleSelectOnChange = onSelectedChange;
          singleSelectOnChange(item === selected ? void 0 : item);
          onClose("selection");
        }
      };
    }).sort((itemA, itemB) => {
      if (shouldOrderSelectedFirst) {
        const itemASelected = selectedOnSort.some((item) => Object.entries(item).every(([key2, value]) => {
          if (key2 === "selected") {
            return true;
          }
          return itemA[key2] === value;
        }));
        const itemBSelected = selectedOnSort.some((item) => Object.entries(item).every(([key2, value]) => {
          if (key2 === "selected") {
            return true;
          }
          return itemB[key2] === value;
        }));
        if (itemASelected > itemBSelected) {
          return -1;
        } else if (itemASelected < itemBSelected) {
          return 1;
        }
      }
      return 0;
    });
  }, [onClose, onSelectedChange, items, selected, isItemCurrentlySelected, isSingleSelectModal, intermediateSelected, shouldOrderSelectedFirst, selectedOnSort]);
  if (prevItems !== items) {
    setPrevItems(items);
    if (prevItems.length === 0 && items.length > 0) {
      resetSort();
    }
  }
  if (open !== prevOpen) {
    setPrevOpen(open);
    resetSort();
  }
  const focusTrapSettings = {
    initialFocusRef: inputRef || void 0
  };
  const extendedTextInputProps = useMemo$1(() => {
    return {
      sx: {
        m: 2
      },
      contrast: true,
      leadingVisual: SearchIcon,
      "aria-label": inputLabel,
      ...textInputProps
    };
  }, [inputLabel, textInputProps]);
  const loadingType = () => {
    if (dataLoadedOnce) {
      return FilteredActionListLoadingTypes.input;
    } else {
      if (initialLoadingType === "spinner") {
        return FilteredActionListLoadingTypes.bodySpinner;
      } else {
        return FilteredActionListLoadingTypes.bodySkeleton;
      }
    }
  };
  const iconForNoticeVariant = {
    info: /* @__PURE__ */ jsxRuntimeExports.jsx(InfoIcon, {
      size: 16
    }),
    warning: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon, {
      size: 16
    }),
    error: /* @__PURE__ */ jsxRuntimeExports.jsx(StopIcon, {
      size: 16
    })
  };
  function getMessage() {
    if (items.length === 0 && !message2) {
      return DefaultEmptyMessage;
    } else if (message2) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SelectPanelMessage$1, {
        title: message2.title,
        variant: message2.variant,
        icon: message2.icon,
        action: message2.action,
        children: message2.body
      });
    }
  }
  const showPermanentCancelSaveButtons = variant3 === "modal";
  const showResponsiveCancelSaveButtons = variant3 !== "modal" && usingFullScreenOnNarrow && isMultiSelectVariant(selected) && onCancel !== void 0;
  const showResponsiveSaveAndCloseButton = variant3 !== "modal" && usingFullScreenOnNarrow && isMultiSelectVariant(selected) && onCancel === void 0;
  const renderFooter = secondaryAction !== void 0 || showPermanentCancelSaveButtons || showResponsiveSaveAndCloseButton || showResponsiveCancelSaveButtons;
  const displayFooter = secondaryAction !== void 0 || showPermanentCancelSaveButtons ? "always" : showResponsiveSaveAndCloseButton || showResponsiveCancelSaveButtons ? "only-small" : void 0;
  const stretchSecondaryAction = showResponsiveSaveAndCloseButton || showResponsiveCancelSaveButtons ? "only-big" : showPermanentCancelSaveButtons ? "never" : "always";
  const stretchSaveButton = showResponsiveSaveAndCloseButton && secondaryAction === void 0 ? "only-small" : "never";
  const showXCloseIcon = (onCancel !== void 0 || !isMultiSelectVariant(selected)) && usingFullScreenOnNarrow;
  const currentResponsiveVariant = useResponsiveValue(usingFullScreenOnNarrow ? {
    regular: "anchored",
    narrow: "fullscreen"
  } : void 0, "anchored");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(AnchoredOverlay, {
      renderAnchor: renderMenuAnchor,
      anchorRef,
      align,
      open,
      onOpen,
      onClose,
      overlayProps: {
        role: "dialog",
        "aria-labelledby": titleId,
        "aria-describedby": subtitle ? subtitleId : void 0,
        ...overlayProps,
        ...variant3 === "modal" ? {
          /* override AnchoredOverlay position */
          top: "50vh",
          left: "50vw",
          anchorSide: void 0
        } : {},
        style: {
          /* override AnchoredOverlay position */
          transform: variant3 === "modal" ? "translate(-50%, -50%)" : void 0,
          // set maxHeight based on calculated availablePanelHeight when keyboard is visible
          ...isKeyboardVisible ? {
            maxHeight: availablePanelHeight !== void 0 ? `${availablePanelHeight}px` : "auto"
          } : {}
        }
      },
      focusTrapSettings,
      focusZoneSettings,
      height: height2,
      width: width2,
      anchorId: id,
      variant: usingFullScreenOnNarrow ? {
        regular: "anchored",
        narrow: "fullscreen"
      } : void 0,
      pinPosition: !height2,
      className: classes$b.Overlay,
      displayCloseButton: showXCloseIcon,
      closeButtonProps: {
        "aria-label": "Cancel and close"
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
        className: classes$b.Wrapper,
        "data-variant": variant3,
        children: [/* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
          className: classes$b.Header,
          "data-variant": currentResponsiveVariant,
          children: [/* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
            children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Heading$4, {
              as: "h1",
              id: titleId,
              className: classes$b.Title,
              children: title
            }), subtitle ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
              id: subtitleId,
              className: classes$b.Subtitle,
              children: subtitle
            }) : null]
          }), variant3 === "modal" && !isNarrowScreenSize ? /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, {
            type: "button",
            variant: "invisible",
            icon: XIcon,
            "aria-label": "Cancel and close",
            className: classes$b.ResponsiveCloseButton,
            onClick: () => {
              onCancel === null || onCancel === void 0 ? void 0 : onCancel();
              onCancelRequested();
            }
          }) : null]
        }), notice && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
          ref: noticeRef,
          "data-variant": notice.variant,
          className: classes$b.Notice,
          children: [iconForNoticeVariant[notice.variant], /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
            children: notice.text
          })]
        }), /* @__PURE__ */ jsxRuntimeExports.jsx(FilteredActionList, {
          filterValue: filterValue2,
          onFilterChange,
          onListContainerRefChanged,
          onInputRefChanged,
          placeholderText,
          ...listProps,
          variant: (_listProps$groupMetad = listProps.groupMetadata) !== null && _listProps$groupMetad !== void 0 && _listProps$groupMetad.length ? "horizontal-inset" : "inset",
          role: "listbox",
          "aria-labelledby": listProps["aria-label"] ? void 0 : titleId,
          "aria-multiselectable": isMultiSelectVariant(selected) ? "true" : "false",
          selectionVariant: isSingleSelectModal ? "radio" : isMultiSelectVariant(selected) ? "multiple" : "single",
          items: itemsToRender,
          textInputProps: extendedTextInputProps,
          loading: loading || isLoading && !message2,
          loadingType: loadingType(),
          onSelectAllChange: showSelectAll ? handleSelectAllChange : void 0,
          message: getMessage(),
          messageText: {
            title: (message2 === null || message2 === void 0 ? void 0 : message2.title) || EMPTY_MESSAGE.title,
            description: typeof (message2 === null || message2 === void 0 ? void 0 : message2.body) === "string" ? message2.body : EMPTY_MESSAGE.description
          },
          fullScreenOnNarrow: usingFullScreenOnNarrow,
          sx: sx2,
          className: clsx(className, classes$b.FilteredActionList),
          announcementsEnabled: true
        }), footer2 ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
          className: classes$b.Footer,
          children: footer2
        }) : renderFooter ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
          "data-display-footer": displayFooter,
          "data-stretch-secondary-action": stretchSecondaryAction,
          "data-stretch-save-button": stretchSaveButton,
          className: clsx(classes$b.Footer, classes$b.ResponsiveFooter),
          children: [/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
            "data-stretch-secondary-action": stretchSecondaryAction,
            className: classes$b.SecondaryAction,
            children: secondaryAction
          }), showPermanentCancelSaveButtons || showResponsiveCancelSaveButtons ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
            "data-stretch-save-button": stretchSaveButton,
            className: clsx(classes$b.CancelSaveButtons, {
              [classes$b.ResponsiveSaveButton]: showResponsiveCancelSaveButtons
            }),
            children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
              size: "medium",
              onClick: () => {
                onCancel === null || onCancel === void 0 ? void 0 : onCancel();
                onCancelRequested();
              },
              children: "Cancel"
            }), /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
              block: onCancel === void 0,
              variant: "primary",
              size: "medium",
              onClick: () => {
                if (isSingleSelectModal) {
                  const singleSelectOnChange = onSelectedChange;
                  singleSelectOnChange(intermediateSelected);
                }
                onClose(variant3 === "modal" ? "selection" : "click-outside");
              },
              children: "Save"
            })]
          }) : null, showResponsiveSaveAndCloseButton ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
            className: classes$b.ResponsiveSaveButton,
            "data-stretch-save-button": stretchSaveButton,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
              block: true,
              variant: "primary",
              size: "medium",
              onClick: () => {
                onClose("click-outside");
              },
              children: "Save and close"
            })
          }) : null]
        }) : null]
      })
    }), variant3 === "modal" && open ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: classes$b.Backdrop
    }) : null]
  });
}
const SecondaryButton$1 = (props) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
    block: true,
    ...props,
    children: props.children
  });
};
SecondaryButton$1.displayName = "SecondaryButton";
const SecondaryLink$1 = (props) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(LinkButton, {
    ...props,
    variant: "invisible",
    block: true,
    children: props.children
  });
};
SecondaryLink$1.displayName = "SecondaryLink";
const SelectPanel$1 = Object.assign(Panel$1, {
  SecondaryActionButton: SecondaryButton$1,
  SecondaryActionLink: SecondaryLink$1
});
const FormControl = /* @__PURE__ */ React__default.forwardRef((t0, ref2) => {
  var _slots$validation, _slots$label;
  const $2 = distExports.c(27);
  const {
    children,
    disabled: disabledProp,
    layout: t1,
    id: idProp,
    required: required2,
    sx: sx2,
    className
  } = t0;
  const layout2 = t1 === void 0 ? "vertical" : t1;
  let t2;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      caption: FormControlCaption,
      label: FormControlLabel,
      leadingVisual: FormControlLeadingVisual,
      validation: FormControlValidation
    };
    $2[0] = t2;
  } else {
    t2 = $2[0];
  }
  const [slots, childrenWithoutSlots] = useSlots(children, t2);
  const expectedInputComponents = [Autocomplete$1, Checkbox$1, Radio, Select$1, TextInput$1, TextInputWithTokens, Textarea, SelectPanel$1];
  const choiceGroupContext = useContext(CheckboxOrRadioGroupContext);
  const disabled = choiceGroupContext.disabled || disabledProp;
  const id = useId(idProp);
  const validationMessageId = slots.validation ? `${id}-validationMessage` : void 0;
  const captionId = slots.caption ? `${id}-caption` : void 0;
  const validationStatus = (_slots$validation = slots.validation) === null || _slots$validation === void 0 ? void 0 : _slots$validation.props.variant;
  const InputComponent = childrenWithoutSlots.find((child) => expectedInputComponents.some((inputComponent) => /* @__PURE__ */ React__default.isValidElement(child) && child.type === inputComponent));
  const inputProps = /* @__PURE__ */ React__default.isValidElement(InputComponent) && InputComponent.props;
  const isChoiceInput = /* @__PURE__ */ React__default.isValidElement(InputComponent) && (InputComponent.type === Checkbox$1 || InputComponent.type === Radio);
  const isRadioInput2 = /* @__PURE__ */ React__default.isValidElement(InputComponent) && InputComponent.type === Radio;
  if (InputComponent) {
    process.env.NODE_ENV !== "production" ? warning2(inputProps === null || inputProps === void 0 ? void 0 : inputProps.id, "instead of passing the 'id' prop directly to the input component, it should be passed to the parent component, <FormControl>") : void 0;
    process.env.NODE_ENV !== "production" ? warning2(inputProps === null || inputProps === void 0 ? void 0 : inputProps.disabled, "instead of passing the 'disabled' prop directly to the input component, it should be passed to the parent component, <FormControl>") : void 0;
    process.env.NODE_ENV !== "production" ? warning2(inputProps === null || inputProps === void 0 ? void 0 : inputProps.required, "instead of passing the 'required' prop directly to the input component, it should be passed to the parent component, <FormControl>") : void 0;
  }
  if (!slots.label) {
    console.error(`The input field with the id ${id} MUST have a FormControl.Label child.

If you want to hide the label, pass the 'visuallyHidden' prop to the FormControl.Label component.`);
  }
  if (isChoiceInput) {
    process.env.NODE_ENV !== "production" ? warning2(!!slots.validation, "Validation messages are not rendered for an individual checkbox or radio. The validation message should be shown for all options.") : void 0;
    process.env.NODE_ENV !== "production" ? warning2(isRadioInput2 && childrenWithoutSlots.find(_temp$2), "An individual radio cannot be a required field.") : void 0;
  } else {
    process.env.NODE_ENV !== "production" ? warning2(!!slots.leadingVisual, "A leading visual is only rendered for a checkbox or radio form control. If you want to render a leading visual inside of your input, check if your input supports a leading visual.") : void 0;
  }
  const isLabelHidden = (_slots$label = slots.label) === null || _slots$label === void 0 ? void 0 : _slots$label.props.visuallyHidden;
  const t3 = classes$c;
  const t4 = /* @__PURE__ */ React__default.isValidElement(InputComponent) ? /* @__PURE__ */ React__default.cloneElement(InputComponent, {
    id,
    disabled,
    required: required2 && !isRadioInput2,
    "aria-describedby": captionId
  }) : null;
  let t5;
  if ($2[1] !== childrenWithoutSlots) {
    t5 = childrenWithoutSlots.filter(_temp2$2);
    $2[1] = childrenWithoutSlots;
    $2[2] = t5;
  } else {
    t5 = $2[2];
  }
  let t6;
  if ($2[3] !== t3.ControlChoiceInputs || $2[4] !== t4 || $2[5] !== t5) {
    t6 = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      className: t3.ControlChoiceInputs,
      children: [t4, t5]
    });
    $2[3] = t3.ControlChoiceInputs;
    $2[4] = t4;
    $2[5] = t5;
    $2[6] = t6;
  } else {
    t6 = $2[6];
  }
  let t7;
  if ($2[7] !== disabled || $2[8] !== slots.caption || $2[9] !== slots.leadingVisual) {
    t7 = slots.leadingVisual ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: classes$c.LeadingVisual,
      "data-disabled": disabled ? "" : void 0,
      "data-has-caption": slots.caption ? "" : void 0,
      children: slots.leadingVisual
    }) : null;
    $2[7] = disabled;
    $2[8] = slots.caption;
    $2[9] = slots.leadingVisual;
    $2[10] = t7;
  } else {
    t7 = $2[10];
  }
  let t8;
  if ($2[11] !== slots.caption || $2[12] !== slots.label) {
    t8 = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      className: classes$c.LabelContainer,
      children: [slots.label, slots.caption]
    });
    $2[11] = slots.caption;
    $2[12] = slots.label;
    $2[13] = t8;
  } else {
    t8 = $2[13];
  }
  let t9;
  if ($2[14] !== t6 || $2[15] !== t7 || $2[16] !== t8) {
    t9 = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
      children: [t6, t7, t8]
    });
    $2[14] = t6;
    $2[15] = t7;
    $2[16] = t8;
    $2[17] = t9;
  } else {
    t9 = $2[17];
  }
  const InputChildren = t9;
  let t10;
  if ($2[18] !== captionId || $2[19] !== disabled || $2[20] !== id || $2[21] !== required2 || $2[22] !== validationMessageId) {
    t10 = {
      captionId,
      disabled,
      id,
      required: required2,
      validationMessageId
    };
    $2[18] = captionId;
    $2[19] = disabled;
    $2[20] = id;
    $2[21] = required2;
    $2[22] = validationMessageId;
    $2[23] = t10;
  } else {
    t10 = $2[23];
  }
  const t11 = isChoiceInput || layout2 === "horizontal" ? /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
    ref: ref2,
    "data-has-leading-visual": slots.leadingVisual ? "" : void 0,
    sx: sx2,
    className: clsx(className, classes$c.ControlHorizontalLayout),
    children: InputChildren
  }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(BoxWithFallback, {
    ref: ref2,
    "data-has-label": !isLabelHidden ? "" : void 0,
    sx: sx2,
    className: clsx(className, classes$c.ControlVerticalLayout),
    children: [slots.label, /* @__PURE__ */ React__default.isValidElement(InputComponent) && /* @__PURE__ */ React__default.cloneElement(InputComponent, Object.assign({
      id,
      required: required2,
      disabled,
      validationStatus,
      "aria-describedby": [validationMessageId, captionId].filter(Boolean).join(" ")
    }, InputComponent.props)), childrenWithoutSlots.filter((child_2) => /* @__PURE__ */ React__default.isValidElement(child_2) && !expectedInputComponents.some((inputComponent_1) => child_2.type === inputComponent_1)), slots.validation ? /* @__PURE__ */ jsxRuntimeExports.jsx(ValidationAnimationContainer, {
      show: true,
      children: slots.validation
    }) : null, slots.caption]
  });
  let t12;
  if ($2[24] !== t10 || $2[25] !== t11) {
    t12 = /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContextProvider, {
      value: t10,
      children: t11
    });
    $2[24] = t10;
    $2[25] = t11;
    $2[26] = t12;
  } else {
    t12 = $2[26];
  }
  return t12;
});
var FormControl$1 = Object.assign(FormControl, {
  Caption: FormControlCaption,
  Label: FormControlLabel,
  LeadingVisual: FormControlLeadingVisual,
  Validation: FormControlValidation
});
function _temp$2(child_0) {
  var _child_0$props;
  return /* @__PURE__ */ React__default.isValidElement(child_0) && ((_child_0$props = child_0.props) === null || _child_0$props === void 0 ? void 0 : _child_0$props.required);
}
function _temp2$2(child_1) {
  return /* @__PURE__ */ React__default.isValidElement(child_1) && ![Checkbox$1, Radio].some((inputComponent_0) => child_1.type === inputComponent_0);
}
const CheckboxGroup = (t0) => {
  const $2 = distExports.c(24);
  let children;
  let disabled;
  let onChange;
  let rest;
  if ($2[0] !== t0) {
    ({
      children,
      disabled,
      onChange,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = disabled;
    $2[3] = onChange;
    $2[4] = rest;
  } else {
    children = $2[1];
    disabled = $2[2];
    onChange = $2[3];
    rest = $2[4];
  }
  let t1;
  if ($2[5] !== children) {
    const formControlComponentChildren = React__default.Children.toArray(children).filter(_temp$1).map(_temp2$1).flat();
    t1 = React__default.Children.toArray(formControlComponentChildren).filter(_temp3).map(_temp4).filter(Boolean);
    $2[5] = children;
    $2[6] = t1;
  } else {
    t1 = $2[6];
  }
  const checkedCheckboxes = t1;
  const [selectedCheckboxValues, setSelectedCheckboxValues] = useRenderForcingRef(checkedCheckboxes);
  let t2;
  if ($2[7] !== selectedCheckboxValues || $2[8] !== setSelectedCheckboxValues) {
    t2 = (e) => {
      const {
        value,
        checked
      } = e.currentTarget;
      if (checked) {
        setSelectedCheckboxValues([...selectedCheckboxValues.current || [], value]);
        return;
      }
      setSelectedCheckboxValues((selectedCheckboxValues.current || []).filter((selectedValue) => selectedValue !== value));
    };
    $2[7] = selectedCheckboxValues;
    $2[8] = setSelectedCheckboxValues;
    $2[9] = t2;
  } else {
    t2 = $2[9];
  }
  const updateSelectedCheckboxes = t2;
  let t3;
  if ($2[10] !== onChange || $2[11] !== selectedCheckboxValues || $2[12] !== updateSelectedCheckboxes) {
    t3 = (e_0) => {
      if (onChange) {
        updateSelectedCheckboxes(e_0);
        onChange(selectedCheckboxValues.current || [], e_0);
      }
    };
    $2[10] = onChange;
    $2[11] = selectedCheckboxValues;
    $2[12] = updateSelectedCheckboxes;
    $2[13] = t3;
  } else {
    t3 = $2[13];
  }
  let t4;
  if ($2[14] !== disabled || $2[15] !== t3) {
    t4 = {
      disabled,
      onChange: t3
    };
    $2[14] = disabled;
    $2[15] = t3;
    $2[16] = t4;
  } else {
    t4 = $2[16];
  }
  let t5;
  if ($2[17] !== children || $2[18] !== disabled || $2[19] !== rest) {
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxOrRadioGroup$1, {
      disabled,
      ...rest,
      children
    });
    $2[17] = children;
    $2[18] = disabled;
    $2[19] = rest;
    $2[20] = t5;
  } else {
    t5 = $2[20];
  }
  let t6;
  if ($2[21] !== t4 || $2[22] !== t5) {
    t6 = /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxGroupContext.Provider, {
      value: t4,
      children: t5
    });
    $2[21] = t4;
    $2[22] = t5;
    $2[23] = t6;
  } else {
    t6 = $2[23];
  }
  return t6;
};
var CheckboxGroup$1 = Object.assign(CheckboxGroup, {
  Caption: CheckboxOrRadioGroupCaption,
  Label: CheckboxOrRadioGroupLabel,
  Validation: CheckboxOrRadioGroupValidation
});
function _temp$1(child) {
  return /* @__PURE__ */ React__default.isValidElement(child) && child.type === FormControl$1;
}
function _temp2$1(formControlComponent) {
  return /* @__PURE__ */ React__default.isValidElement(formControlComponent) ? formControlComponent.props.children : [];
}
function _temp3(child_0) {
  return /* @__PURE__ */ React__default.isValidElement(child_0) && child_0.type === Checkbox$1;
}
function _temp4(checkbox) {
  return /* @__PURE__ */ React__default.isValidElement(checkbox) && (checkbox.props.checked || checkbox.props.defaultChecked) && checkbox.props.value;
}
var classes$8 = { "Popover": "prc-Popover-Popover-v1ShS", "PopoverContent": "prc-Popover-PopoverContent-nMzFS" };
const Popover = /* @__PURE__ */ React__default.forwardRef(function Popover2(t0, forwardRef2) {
  const $2 = distExports.c(15);
  let className;
  let open;
  let props;
  let relative;
  let t1;
  if ($2[0] !== t0) {
    ({
      className,
      caret: t1,
      open,
      relative,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = open;
    $2[3] = props;
    $2[4] = relative;
    $2[5] = t1;
  } else {
    className = $2[1];
    open = $2[2];
    props = $2[3];
    relative = $2[4];
    t1 = $2[5];
  }
  const caret2 = t1 === void 0 ? "top" : t1;
  const t2 = open ? "" : void 0;
  const t3 = relative ? "" : void 0;
  let t4;
  if ($2[6] !== className) {
    t4 = clsx(className, classes$8.Popover);
    $2[6] = className;
    $2[7] = t4;
  } else {
    t4 = $2[7];
  }
  let t5;
  if ($2[8] !== caret2 || $2[9] !== forwardRef2 || $2[10] !== props || $2[11] !== t2 || $2[12] !== t3 || $2[13] !== t4) {
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      ...props,
      ref: forwardRef2,
      "data-open": t2,
      "data-relative": t3,
      "data-caret": caret2,
      className: t4
    });
    $2[8] = caret2;
    $2[9] = forwardRef2;
    $2[10] = props;
    $2[11] = t2;
    $2[12] = t3;
    $2[13] = t4;
    $2[14] = t5;
  } else {
    t5 = $2[14];
  }
  return t5;
});
Popover.displayName = "Popover";
const PopoverContent = (t0) => {
  const $2 = distExports.c(14);
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  if ($2[0] !== t0) {
    ({
      className,
      width: t1,
      height: t2,
      overflow: t3,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = props;
    $2[3] = t1;
    $2[4] = t2;
    $2[5] = t3;
  } else {
    className = $2[1];
    props = $2[2];
    t1 = $2[3];
    t2 = $2[4];
    t3 = $2[5];
  }
  const width2 = t1 === void 0 ? "small" : t1;
  const height2 = t2 === void 0 ? "fit-content" : t2;
  const overflow2 = t3 === void 0 ? "auto" : t3;
  let t4;
  if ($2[6] !== className) {
    t4 = clsx(className, classes$8.PopoverContent);
    $2[6] = className;
    $2[7] = t4;
  } else {
    t4 = $2[7];
  }
  let t5;
  if ($2[8] !== height2 || $2[9] !== overflow2 || $2[10] !== props || $2[11] !== t4 || $2[12] !== width2) {
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      "data-width": width2,
      "data-height": height2,
      "data-overflow": overflow2,
      className: t4,
      ...props
    });
    $2[8] = height2;
    $2[9] = overflow2;
    $2[10] = props;
    $2[11] = t4;
    $2[12] = width2;
    $2[13] = t5;
  } else {
    t5 = $2[13];
  }
  return t5;
};
PopoverContent.displayName = "Popover.Content";
var Popover$1 = Object.assign(Popover, {
  Content: PopoverContent
});
var classes$7 = { "Timeline": "prc-Timeline-Timeline-iQjcc", "TimelineItem": "prc-Timeline-TimelineItem-Sd-t-", "TimelineBadge": "prc-Timeline-TimelineBadge-BqMiN", "TimelineBadgeWrapper": "prc-Timeline-TimelineBadgeWrapper-75vYD", "TimelineBody": "prc-Timeline-TimelineBody-WWZY0", "TimelineBreak": "prc-Timeline-TimelineBreak-dPnDJ" };
const Timeline = /* @__PURE__ */ React__default.forwardRef((t0, forwardRef2) => {
  const $2 = distExports.c(11);
  let className;
  let clipSidebar;
  let props;
  if ($2[0] !== t0) {
    ({
      clipSidebar,
      className,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = clipSidebar;
    $2[3] = props;
  } else {
    className = $2[1];
    clipSidebar = $2[2];
    props = $2[3];
  }
  let t1;
  if ($2[4] !== className) {
    t1 = clsx(className, classes$7.Timeline);
    $2[4] = className;
    $2[5] = t1;
  } else {
    t1 = $2[5];
  }
  const t2 = clipSidebar ? "" : void 0;
  let t3;
  if ($2[6] !== forwardRef2 || $2[7] !== props || $2[8] !== t1 || $2[9] !== t2) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      ...props,
      className: t1,
      ref: forwardRef2,
      "data-clip-sidebar": t2
    });
    $2[6] = forwardRef2;
    $2[7] = props;
    $2[8] = t1;
    $2[9] = t2;
    $2[10] = t3;
  } else {
    t3 = $2[10];
  }
  return t3;
});
Timeline.displayName = "Timeline";
const TimelineItem = /* @__PURE__ */ React__default.forwardRef((t0, forwardRef2) => {
  const $2 = distExports.c(11);
  let className;
  let condensed;
  let props;
  if ($2[0] !== t0) {
    ({
      condensed,
      className,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = condensed;
    $2[3] = props;
  } else {
    className = $2[1];
    condensed = $2[2];
    props = $2[3];
  }
  let t1;
  if ($2[4] !== className) {
    t1 = clsx(className, "Timeline-Item", classes$7.TimelineItem);
    $2[4] = className;
    $2[5] = t1;
  } else {
    t1 = $2[5];
  }
  const t2 = condensed ? "" : void 0;
  let t3;
  if ($2[6] !== forwardRef2 || $2[7] !== props || $2[8] !== t1 || $2[9] !== t2) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      ...props,
      className: t1,
      ref: forwardRef2,
      "data-condensed": t2
    });
    $2[6] = forwardRef2;
    $2[7] = props;
    $2[8] = t1;
    $2[9] = t2;
    $2[10] = t3;
  } else {
    t3 = $2[10];
  }
  return t3;
});
TimelineItem.displayName = "TimelineItem";
const TimelineBadge = (t0) => {
  const $2 = distExports.c(8);
  let className;
  let props;
  if ($2[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = props;
  } else {
    className = $2[1];
    props = $2[2];
  }
  let t1;
  if ($2[3] !== className) {
    t1 = clsx(className, classes$7.TimelineBadge);
    $2[3] = className;
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  let t2;
  if ($2[5] !== props || $2[6] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: classes$7.TimelineBadgeWrapper,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
        ...props,
        className: t1
      })
    });
    $2[5] = props;
    $2[6] = t1;
    $2[7] = t2;
  } else {
    t2 = $2[7];
  }
  return t2;
};
TimelineBadge.displayName = "Timeline.Badge";
const TimelineBody = /* @__PURE__ */ React__default.forwardRef((t0, forwardRef2) => {
  const $2 = distExports.c(9);
  let className;
  let props;
  if ($2[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = props;
  } else {
    className = $2[1];
    props = $2[2];
  }
  let t1;
  if ($2[3] !== className) {
    t1 = clsx(className, classes$7.TimelineBody);
    $2[3] = className;
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  let t2;
  if ($2[5] !== forwardRef2 || $2[6] !== props || $2[7] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      ...props,
      className: t1,
      ref: forwardRef2
    });
    $2[5] = forwardRef2;
    $2[6] = props;
    $2[7] = t1;
    $2[8] = t2;
  } else {
    t2 = $2[8];
  }
  return t2;
});
TimelineBody.displayName = "TimelineBody";
const TimelineBreak = /* @__PURE__ */ React__default.forwardRef((t0, forwardRef2) => {
  const $2 = distExports.c(9);
  let className;
  let props;
  if ($2[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = props;
  } else {
    className = $2[1];
    props = $2[2];
  }
  let t1;
  if ($2[3] !== className) {
    t1 = clsx(className, classes$7.TimelineBreak);
    $2[3] = className;
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  let t2;
  if ($2[5] !== forwardRef2 || $2[6] !== props || $2[7] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      ...props,
      className: t1,
      ref: forwardRef2
    });
    $2[5] = forwardRef2;
    $2[6] = props;
    $2[7] = t1;
    $2[8] = t2;
  } else {
    t2 = $2[8];
  }
  return t2;
});
TimelineBreak.displayName = "TimelineBreak";
var Timeline$1 = Object.assign(Timeline, {
  Item: TimelineItem,
  Badge: TimelineBadge,
  Body: TimelineBody,
  Break: TimelineBreak
});
var classes$6 = { "SkeletonText": "prc-SkeletonText-SkeletonText-tW5nH", "SkeletonTextWrapper": "prc-SkeletonText-SkeletonTextWrapper-3Z0sU" };
function SkeletonText(t0) {
  const $2 = distExports.c(32);
  let className;
  let maxWidth2;
  let rest;
  let style3;
  let t1;
  let t2;
  if ($2[0] !== t0) {
    ({
      lines: t1,
      maxWidth: maxWidth2,
      size: t2,
      className,
      style: style3,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = maxWidth2;
    $2[3] = rest;
    $2[4] = style3;
    $2[5] = t1;
    $2[6] = t2;
  } else {
    className = $2[1];
    maxWidth2 = $2[2];
    rest = $2[3];
    style3 = $2[4];
    t1 = $2[5];
    t2 = $2[6];
  }
  const lines = t1 === void 0 ? 1 : t1;
  const size2 = t2 === void 0 ? "bodyMedium" : t2;
  if (lines < 2) {
    let t32;
    if ($2[7] !== className) {
      t32 = clsx(className, classes$6.SkeletonText);
      $2[7] = className;
      $2[8] = t32;
    } else {
      t32 = $2[8];
    }
    let t42;
    if ($2[9] !== maxWidth2 || $2[10] !== style3) {
      t42 = {
        ...style3,
        maxWidth: maxWidth2
      };
      $2[9] = maxWidth2;
      $2[10] = style3;
      $2[11] = t42;
    } else {
      t42 = $2[11];
    }
    let t52;
    if ($2[12] !== rest || $2[13] !== size2 || $2[14] !== t32 || $2[15] !== t42) {
      t52 = /* @__PURE__ */ jsxRuntimeExports.jsx(SkeletonBox, {
        "data-component": "SkeletonText",
        "data-text-skeleton-size": size2,
        width: "100%",
        className: t32,
        style: t42,
        ...rest
      });
      $2[12] = rest;
      $2[13] = size2;
      $2[14] = t32;
      $2[15] = t42;
      $2[16] = t52;
    } else {
      t52 = $2[16];
    }
    return t52;
  }
  let t3;
  if ($2[17] !== maxWidth2 || $2[18] !== style3) {
    t3 = {
      ...style3,
      maxWidth: maxWidth2
    };
    $2[17] = maxWidth2;
    $2[18] = style3;
    $2[19] = t3;
  } else {
    t3 = $2[19];
  }
  let t4;
  if ($2[20] !== className || $2[21] !== lines || $2[22] !== rest || $2[23] !== size2) {
    let t52;
    if ($2[25] !== className || $2[26] !== rest || $2[27] !== size2) {
      t52 = (_2, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(SkeletonBox, {
        "data-component": "SkeletonText",
        "data-in-multiline": "true",
        "data-text-skeleton-size": size2,
        className: clsx(className, classes$6.SkeletonText),
        ...rest
      }, index2);
      $2[25] = className;
      $2[26] = rest;
      $2[27] = size2;
      $2[28] = t52;
    } else {
      t52 = $2[28];
    }
    t4 = Array.from({
      length: lines
    }, t52);
    $2[20] = className;
    $2[21] = lines;
    $2[22] = rest;
    $2[23] = size2;
    $2[24] = t4;
  } else {
    t4 = $2[24];
  }
  let t5;
  if ($2[29] !== t3 || $2[30] !== t4) {
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      "data-component": "multilineContainer",
      className: classes$6.SkeletonTextWrapper,
      style: t3,
      children: t4
    });
    $2[29] = t3;
    $2[30] = t4;
    $2[31] = t5;
  } else {
    t5 = $2[31];
  }
  return t5;
}
const DirtyCopy = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Truncate, { maxWidth: "100%", inline: true, title: "Unsaved, save and apply, or reset to revert", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "condensed", align: "center", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(StopIcon, { fill: "var(--fgColor-danger) !important" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text$2,
    {
      weight: "medium",
      size: "medium",
      children: "Unsaved, save and apply, or reset to revert"
    }
  )
] }) });
const CleanCopy = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Truncate, { maxWidth: "100%", inline: true, title: "Saved, nothing added or changed.", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "normal", align: "center", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(SmileyIcon, { fill: "var(--fgColor-accent) !important" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text$2,
    {
      weight: "medium",
      size: "medium",
      children: "Saved, nothing added or changed."
    }
  )
] }) });
const PreviewButton = ({ onPreview }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  ButtonComponent,
  {
    variant: "invisible",
    size: "small",
    onClick: onPreview,
    leadingVisual: PlayIcon,
    children: "Preview"
  }
);
const HistoryButton = ({ onClick }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  ButtonComponent,
  {
    variant: "invisible",
    size: "small",
    onClick,
    leadingVisual: HistoryIcon,
    children: "History"
  }
);
const aiAvatarAsset = "data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2080%2080'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='80'%20height='80'%20fill='%232188FF'/%3e%3cg%20clip-path='url(%23clip0_6230_27586)'%3e%3cpath%20d='M33.2197%2037.0054C34.4864%2037.0054%2035.5132%2038.0322%2035.5132%2039.2989V43.8859C35.5132%2045.1526%2034.4864%2044.8691%2033.2197%2044.8691C31.953%2044.8691%2030.9262%2045.1526%2030.9262%2043.8859V39.2989C30.9262%2038.0322%2031.953%2037.0054%2033.2197%2037.0054Z'%20fill='white'/%3e%3cpath%20d='M49.2744%2039.2989C49.2744%2038.0322%2048.2475%2037.0054%2046.9809%2037.0054C45.7142%2037.0054%2044.6873%2038.0322%2044.6873%2039.2989V43.8859C44.6873%2045.1526%2045.7142%2044.8691%2046.9809%2044.8691C48.2475%2044.8691%2049.2744%2045.1526%2049.2744%2043.8859V39.2989Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M34.7487%2016.2544C33.482%2016.2544%2032.4552%2017.2812%2032.4552%2018.5479C32.4552%2019.8146%2033.482%2020.8414%2034.7487%2020.8414H38.5713V24.7732H27.1036C23.3036%2024.7732%2020.223%2027.8537%2020.223%2031.6538V38.5344H17.9295C16.6628%2038.5344%2015.636%2039.5612%2015.636%2040.8279C15.636%2042.0946%2016.6628%2043.1214%2017.9295%2043.1214H20.223V51.531C20.223%2055.3311%2023.3036%2058.4116%2027.1036%2058.4116H53.0969C56.897%2058.4116%2059.9775%2055.3311%2059.9775%2051.531V43.1214H62.271C63.5377%2043.1214%2064.5646%2042.0946%2064.5646%2040.8279C64.5646%2039.5612%2063.5377%2038.5344%2062.271%2038.5344H59.9775V31.6538C59.9775%2027.8537%2056.897%2024.7732%2053.0969%2024.7732H43.1583V18.5479C43.1583%2017.2812%2042.1315%2016.2544%2040.8648%2016.2544H34.7487ZM24.8101%2031.6538C24.8101%2030.3871%2025.8369%2029.3603%2027.1036%2029.3603H53.0969C54.3636%2029.3603%2055.3904%2030.3871%2055.3904%2031.6538V51.531C55.3904%2052.7977%2054.3636%2053.8245%2053.0969%2053.8245H27.1036C25.8369%2053.8245%2024.8101%2052.7977%2024.8101%2051.531V31.6538Z'%20fill='white'/%3e%3cpath%20d='M25.4575%2058.1963H37.0647L27.7104%2064.4325C26.7474%2065.0745%2025.4575%2064.3841%2025.4575%2063.2268V58.1963Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_6230_27586'%3e%3crect%20x='5.1001'%20y='5.1001'%20width='70'%20height='70'%20rx='15'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
const defaultAvatarAsset = "data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2080%2080'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20aria-label='Avatar'%3e%3crect%20width='80'%20height='80'%20rx='16'%20fill='%2357606A'/%3e%3cg%20clip-path='url(%23clip0_default_avatar)'%3e%3cpath%20d='M40%2042c6.075%200%2011-4.925%2011-11s-4.925-11-11-11-11%204.925-11%2011%204.925%2011%2011%2011z'%20fill='%23FFFFFF'%20fill-opacity='0.9'/%3e%3cpath%20d='M20%2060c0-8.837%208.954-16%2020-16s20%207.163%2020%2016v2H20v-2z'%20fill='%23FFFFFF'%20fill-opacity='0.9'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_default_avatar'%3e%3crect%20x='10'%20y='10'%20width='60'%20height='60'%20rx='12'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
const InitialsAvatar = forwardRef$1(({
  initials,
  isAI = false,
  isTimeline = false,
  size: size2 = 20,
  avatarUrl,
  alt,
  aiAvatarUrl,
  title,
  ...rest
}, ref2) => {
  const fallbackDefault = defaultAvatarAsset;
  const candidate = avatarUrl ?? null;
  const [primaryFailed, setPrimaryFailed] = useState(false);
  const primarySrc = primaryFailed ? fallbackDefault : typeof candidate === "string" && candidate.trim().length > 0 ? candidate : fallbackDefault;
  const fallbackAi = aiAvatarAsset;
  const secondarySrc = typeof aiAvatarUrl === "string" && aiAvatarUrl.trim().length > 0 ? aiAvatarUrl : fallbackAi;
  const aiSize = Math.max(8, Math.round(size2 * 0.5));
  if (!isAI) {
    const avatar = /* @__PURE__ */ jsxRuntimeExports.jsx(
      Avatar,
      {
        ref: ref2,
        src: primarySrc,
        alt: alt ?? initials,
        title: title ?? alt ?? initials,
        size: size2,
        onError: () => setPrimaryFailed(true),
        loading: "lazy",
        ...rest
      }
    );
    if (isTimeline) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { width: `${size2}px`, height: `${size2}px`, overflow: "visible" }, children: avatar });
    }
    return avatar;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { width: `${size2}px`, height: `${size2}px`, overflow: "visible" }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(AvatarPair, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Avatar,
      {
        ref: ref2,
        src: primarySrc,
        alt: alt ?? initials,
        sx: { width: `${size2}px`, height: `${size2}px` },
        onError: () => setPrimaryFailed(true),
        loading: "lazy",
        title: title ?? alt ?? initials,
        ...rest
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Avatar,
      {
        src: secondarySrc,
        alt: "AI",
        sx: { width: `${aiSize}px`, height: `${aiSize}px` },
        loading: "lazy"
      }
    )
  ] }) });
});
InitialsAvatar.displayName = "InitialsAvatar";
const OnlineEditors = ({ editors, isLoading }) => {
  if (isLoading) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { display: "flex", alignItems: "center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, { size: "small" }) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AvatarStack, { alignRight: true, children: editors.map((editor, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    InitialsAvatar,
    {
      initials: editor.initials,
      title: editor.name,
      size: 20,
      avatarUrl: editor.avatarUrl
    },
    index2
  )) });
};
const StateBarV2 = ({
  children,
  dirty = false,
  disabled = false,
  onSave,
  onReset,
  onPreview,
  onHistoryOpen,
  onlineEditors,
  onlineEditorsLoading = false
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  Box,
  {
    as: "header",
    display: "flex",
    pl: 4,
    height: 56,
    sx: {
      bg: dirty ? "danger.subtle" : "accent.subtle",
      borderBottom: "1.5px solid " + (dirty ? "var(--borderColor-danger-muted)" : "var(--borderColor-accent-muted)"),
      marginRight: "-10px",
      paddingRight: "524px",
      zIndex: 0
    },
    justifyContent: "space-between",
    alignItems: "center",
    children: [
      dirty ? /* @__PURE__ */ jsxRuntimeExports.jsx(DirtyCopy, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(CleanCopy, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Stack,
        {
          direction: "horizontal",
          gap: "condensed",
          align: "center",
          sx: { minWidth: "fit-content", flexShrink: 0 },
          children: [
            (onlineEditorsLoading || onlineEditors && onlineEditors.length) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                OnlineEditors,
                {
                  editors: onlineEditors || [],
                  isLoading: onlineEditorsLoading
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(ActionBar.Divider, {})
            ] }),
            onPreview && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(PreviewButton, { onPreview }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(ActionBar.Divider, {})
            ] }),
            children,
            onHistoryOpen && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(HistoryButton, { onClick: onHistoryOpen }),
              dirty && /* @__PURE__ */ jsxRuntimeExports.jsx(ActionBar.Divider, {})
            ] }),
            dirty && onReset !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
              ButtonComponent,
              {
                variant: "invisible",
                size: "medium",
                onClick: onReset,
                sx: {
                  color: "var(--fgColor-danger)"
                },
                children: "Reset"
              }
            ),
            dirty && /* @__PURE__ */ jsxRuntimeExports.jsx(
              ButtonComponent,
              {
                variant: "primary",
                size: "medium",
                disabled,
                onClick: onSave,
                children: "Save"
              }
            )
          ]
        }
      )
    ]
  }
);
function useCombinedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return useMemo$1(
    () => (node2) => {
      refs.forEach((ref2) => ref2(node2));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs
  );
}
const canUseDOM = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function isWindow(element2) {
  const elementString = Object.prototype.toString.call(element2);
  return elementString === "[object Window]" || // In Electron context the Window object serializes to [object global]
  elementString === "[object global]";
}
function isNode(node2) {
  return "nodeType" in node2;
}
function getWindow(target) {
  var _target$ownerDocument, _target$ownerDocument2;
  if (!target) {
    return window;
  }
  if (isWindow(target)) {
    return target;
  }
  if (!isNode(target)) {
    return window;
  }
  return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function isDocument(node2) {
  const {
    Document: Document2
  } = getWindow(node2);
  return node2 instanceof Document2;
}
function isHTMLElement(node2) {
  if (isWindow(node2)) {
    return false;
  }
  return node2 instanceof getWindow(node2).HTMLElement;
}
function isSVGElement(node2) {
  return node2 instanceof getWindow(node2).SVGElement;
}
function getOwnerDocument(target) {
  if (!target) {
    return document;
  }
  if (isWindow(target)) {
    return target.document;
  }
  if (!isNode(target)) {
    return document;
  }
  if (isDocument(target)) {
    return target;
  }
  if (isHTMLElement(target) || isSVGElement(target)) {
    return target.ownerDocument;
  }
  return document;
}
const useIsomorphicLayoutEffect$1 = canUseDOM ? useLayoutEffect : useEffect;
function useEvent(handler) {
  const handlerRef = useRef(handler);
  useIsomorphicLayoutEffect$1(() => {
    handlerRef.current = handler;
  });
  return useCallback$1(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return handlerRef.current == null ? void 0 : handlerRef.current(...args);
  }, []);
}
function useInterval() {
  const intervalRef = useRef(null);
  const set2 = useCallback$1((listener, duration) => {
    intervalRef.current = setInterval(listener, duration);
  }, []);
  const clear = useCallback$1(() => {
    if (intervalRef.current !== null) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);
  return [set2, clear];
}
function useLatestValue(value, dependencies) {
  if (dependencies === void 0) {
    dependencies = [value];
  }
  const valueRef = useRef(value);
  useIsomorphicLayoutEffect$1(() => {
    if (valueRef.current !== value) {
      valueRef.current = value;
    }
  }, dependencies);
  return valueRef;
}
function useLazyMemo(callback, dependencies) {
  const valueRef = useRef();
  return useMemo$1(
    () => {
      const newValue = callback(valueRef.current);
      valueRef.current = newValue;
      return newValue;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...dependencies]
  );
}
function useNodeRef(onChange) {
  const onChangeHandler = useEvent(onChange);
  const node2 = useRef(null);
  const setNodeRef = useCallback$1(
    (element2) => {
      if (element2 !== node2.current) {
        onChangeHandler == null ? void 0 : onChangeHandler(element2, node2.current);
      }
      node2.current = element2;
    },
    //eslint-disable-next-line
    []
  );
  return [node2, setNodeRef];
}
function usePrevious(value) {
  const ref2 = useRef();
  useEffect(() => {
    ref2.current = value;
  }, [value]);
  return ref2.current;
}
let ids = {};
function useUniqueId(prefix2, value) {
  return useMemo$1(() => {
    if (value) {
      return value;
    }
    const id = ids[prefix2] == null ? 0 : ids[prefix2] + 1;
    ids[prefix2] = id;
    return prefix2 + "-" + id;
  }, [prefix2, value]);
}
function createAdjustmentFn(modifier) {
  return function(object) {
    for (var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      adjustments[_key - 1] = arguments[_key];
    }
    return adjustments.reduce((accumulator, adjustment) => {
      const entries = Object.entries(adjustment);
      for (const [key2, valueAdjustment] of entries) {
        const value = accumulator[key2];
        if (value != null) {
          accumulator[key2] = value + modifier * valueAdjustment;
        }
      }
      return accumulator;
    }, {
      ...object
    });
  };
}
const add$2 = /* @__PURE__ */ createAdjustmentFn(1);
const subtract$2 = /* @__PURE__ */ createAdjustmentFn(-1);
function hasViewportRelativeCoordinates(event) {
  return "clientX" in event && "clientY" in event;
}
function isKeyboardEvent(event) {
  if (!event) {
    return false;
  }
  const {
    KeyboardEvent: KeyboardEvent2
  } = getWindow(event.target);
  return KeyboardEvent2 && event instanceof KeyboardEvent2;
}
function isTouchEvent(event) {
  if (!event) {
    return false;
  }
  const {
    TouchEvent
  } = getWindow(event.target);
  return TouchEvent && event instanceof TouchEvent;
}
function getEventCoordinates(event) {
  if (isTouchEvent(event)) {
    if (event.touches && event.touches.length) {
      const {
        clientX: x2,
        clientY: y2
      } = event.touches[0];
      return {
        x: x2,
        y: y2
      };
    } else if (event.changedTouches && event.changedTouches.length) {
      const {
        clientX: x2,
        clientY: y2
      } = event.changedTouches[0];
      return {
        x: x2,
        y: y2
      };
    }
  }
  if (hasViewportRelativeCoordinates(event)) {
    return {
      x: event.clientX,
      y: event.clientY
    };
  }
  return null;
}
const CSS$1 = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(transform) {
      if (!transform) {
        return;
      }
      const {
        x: x2,
        y: y2
      } = transform;
      return "translate3d(" + (x2 ? Math.round(x2) : 0) + "px, " + (y2 ? Math.round(y2) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(transform) {
      if (!transform) {
        return;
      }
      const {
        scaleX,
        scaleY
      } = transform;
      return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
    }
  },
  Transform: {
    toString(transform) {
      if (!transform) {
        return;
      }
      return [CSS$1.Translate.toString(transform), CSS$1.Scale.toString(transform)].join(" ");
    }
  },
  Transition: {
    toString(_ref) {
      let {
        property,
        duration,
        easing
      } = _ref;
      return property + " " + duration + "ms " + easing;
    }
  }
});
const SELECTOR = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function findFirstFocusableNode(element2) {
  if (element2.matches(SELECTOR)) {
    return element2;
  }
  return element2.querySelector(SELECTOR);
}
const hiddenStyles = {
  display: "none"
};
function HiddenText(_ref) {
  let {
    id,
    value
  } = _ref;
  return React__default.createElement("div", {
    id,
    style: hiddenStyles
  }, value);
}
function LiveRegion$1(_ref) {
  let {
    id,
    announcement,
    ariaLiveType = "assertive"
  } = _ref;
  const visuallyHidden2 = {
    position: "fixed",
    top: 0,
    left: 0,
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return React__default.createElement("div", {
    id,
    style: visuallyHidden2,
    role: "status",
    "aria-live": ariaLiveType,
    "aria-atomic": true
  }, announcement);
}
function useAnnouncement() {
  const [announcement, setAnnouncement] = useState("");
  const announce2 = useCallback$1((value) => {
    if (value != null) {
      setAnnouncement(value);
    }
  }, []);
  return {
    announce: announce2,
    announcement
  };
}
const DndMonitorContext = /* @__PURE__ */ createContext(null);
function useDndMonitor(listener) {
  const registerListener = useContext(DndMonitorContext);
  useEffect(() => {
    if (!registerListener) {
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    }
    const unsubscribe = registerListener(listener);
    return unsubscribe;
  }, [listener, registerListener]);
}
function useDndMonitorProvider() {
  const [listeners] = useState(() => /* @__PURE__ */ new Set());
  const registerListener = useCallback$1((listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, [listeners]);
  const dispatch = useCallback$1((_ref) => {
    let {
      type,
      event
    } = _ref;
    listeners.forEach((listener) => {
      var _listener$type;
      return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
    });
  }, [listeners]);
  return [dispatch, registerListener];
}
const defaultScreenReaderInstructions = {
  draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const defaultAnnouncements = {
  onDragStart(_ref) {
    let {
      active
    } = _ref;
    return "Picked up draggable item " + active.id + ".";
  },
  onDragOver(_ref2) {
    let {
      active,
      over
    } = _ref2;
    if (over) {
      return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
    }
    return "Draggable item " + active.id + " is no longer over a droppable area.";
  },
  onDragEnd(_ref3) {
    let {
      active,
      over
    } = _ref3;
    if (over) {
      return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
    }
    return "Draggable item " + active.id + " was dropped.";
  },
  onDragCancel(_ref4) {
    let {
      active
    } = _ref4;
    return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
  }
};
function Accessibility(_ref) {
  let {
    announcements = defaultAnnouncements,
    container,
    hiddenTextDescribedById,
    screenReaderInstructions = defaultScreenReaderInstructions
  } = _ref;
  const {
    announce: announce2,
    announcement
  } = useAnnouncement();
  const liveRegionId = useUniqueId("DndLiveRegion");
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  useDndMonitor(useMemo$1(() => ({
    onDragStart(_ref2) {
      let {
        active
      } = _ref2;
      announce2(announcements.onDragStart({
        active
      }));
    },
    onDragMove(_ref3) {
      let {
        active,
        over
      } = _ref3;
      if (announcements.onDragMove) {
        announce2(announcements.onDragMove({
          active,
          over
        }));
      }
    },
    onDragOver(_ref4) {
      let {
        active,
        over
      } = _ref4;
      announce2(announcements.onDragOver({
        active,
        over
      }));
    },
    onDragEnd(_ref5) {
      let {
        active,
        over
      } = _ref5;
      announce2(announcements.onDragEnd({
        active,
        over
      }));
    },
    onDragCancel(_ref6) {
      let {
        active,
        over
      } = _ref6;
      announce2(announcements.onDragCancel({
        active,
        over
      }));
    }
  }), [announce2, announcements]));
  if (!mounted) {
    return null;
  }
  const markup = React__default.createElement(React__default.Fragment, null, React__default.createElement(HiddenText, {
    id: hiddenTextDescribedById,
    value: screenReaderInstructions.draggable
  }), React__default.createElement(LiveRegion$1, {
    id: liveRegionId,
    announcement
  }));
  return container ? createPortal(markup, container) : markup;
}
var Action;
(function(Action2) {
  Action2["DragStart"] = "dragStart";
  Action2["DragMove"] = "dragMove";
  Action2["DragEnd"] = "dragEnd";
  Action2["DragCancel"] = "dragCancel";
  Action2["DragOver"] = "dragOver";
  Action2["RegisterDroppable"] = "registerDroppable";
  Action2["SetDroppableDisabled"] = "setDroppableDisabled";
  Action2["UnregisterDroppable"] = "unregisterDroppable";
})(Action || (Action = {}));
function noop$1() {
}
function useSensor(sensor, options) {
  return useMemo$1(
    () => ({
      sensor,
      options: options != null ? options : {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sensor, options]
  );
}
function useSensors() {
  for (var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++) {
    sensors[_key] = arguments[_key];
  }
  return useMemo$1(
    () => [...sensors].filter((sensor) => sensor != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...sensors]
  );
}
const defaultCoordinates = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function distanceBetween(p1, p2) {
  return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function getRelativeTransformOrigin(event, rect) {
  const eventCoordinates = getEventCoordinates(event);
  if (!eventCoordinates) {
    return "0 0";
  }
  const transformOrigin = {
    x: (eventCoordinates.x - rect.left) / rect.width * 100,
    y: (eventCoordinates.y - rect.top) / rect.height * 100
  };
  return transformOrigin.x + "% " + transformOrigin.y + "%";
}
function sortCollisionsAsc(_ref, _ref2) {
  let {
    data: {
      value: a2
    }
  } = _ref;
  let {
    data: {
      value: b2
    }
  } = _ref2;
  return a2 - b2;
}
function sortCollisionsDesc(_ref3, _ref4) {
  let {
    data: {
      value: a2
    }
  } = _ref3;
  let {
    data: {
      value: b2
    }
  } = _ref4;
  return b2 - a2;
}
function cornersOfRectangle(_ref5) {
  let {
    left: left2,
    top: top2,
    height: height2,
    width: width2
  } = _ref5;
  return [{
    x: left2,
    y: top2
  }, {
    x: left2 + width2,
    y: top2
  }, {
    x: left2,
    y: top2 + height2
  }, {
    x: left2 + width2,
    y: top2 + height2
  }];
}
function getFirstCollision(collisions, property) {
  if (!collisions || collisions.length === 0) {
    return null;
  }
  const [firstCollision] = collisions;
  return firstCollision[property];
}
function centerOfRectangle(rect, left2, top2) {
  if (left2 === void 0) {
    left2 = rect.left;
  }
  if (top2 === void 0) {
    top2 = rect.top;
  }
  return {
    x: left2 + rect.width * 0.5,
    y: top2 + rect.height * 0.5
  };
}
const closestCenter = (_ref) => {
  let {
    collisionRect,
    droppableRects,
    droppableContainers
  } = _ref;
  const centerRect = centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
  const collisions = [];
  for (const droppableContainer of droppableContainers) {
    const {
      id
    } = droppableContainer;
    const rect = droppableRects.get(id);
    if (rect) {
      const distBetween = distanceBetween(centerOfRectangle(rect), centerRect);
      collisions.push({
        id,
        data: {
          droppableContainer,
          value: distBetween
        }
      });
    }
  }
  return collisions.sort(sortCollisionsAsc);
};
const closestCorners = (_ref) => {
  let {
    collisionRect,
    droppableRects,
    droppableContainers
  } = _ref;
  const corners = cornersOfRectangle(collisionRect);
  const collisions = [];
  for (const droppableContainer of droppableContainers) {
    const {
      id
    } = droppableContainer;
    const rect = droppableRects.get(id);
    if (rect) {
      const rectCorners = cornersOfRectangle(rect);
      const distances = corners.reduce((accumulator, corner, index2) => {
        return accumulator + distanceBetween(rectCorners[index2], corner);
      }, 0);
      const effectiveDistance = Number((distances / 4).toFixed(4));
      collisions.push({
        id,
        data: {
          droppableContainer,
          value: effectiveDistance
        }
      });
    }
  }
  return collisions.sort(sortCollisionsAsc);
};
function getIntersectionRatio(entry, target) {
  const top2 = Math.max(target.top, entry.top);
  const left2 = Math.max(target.left, entry.left);
  const right2 = Math.min(target.left + target.width, entry.left + entry.width);
  const bottom2 = Math.min(target.top + target.height, entry.top + entry.height);
  const width2 = right2 - left2;
  const height2 = bottom2 - top2;
  if (left2 < right2 && top2 < bottom2) {
    const targetArea = target.width * target.height;
    const entryArea = entry.width * entry.height;
    const intersectionArea = width2 * height2;
    const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
    return Number(intersectionRatio.toFixed(4));
  }
  return 0;
}
const rectIntersection = (_ref) => {
  let {
    collisionRect,
    droppableRects,
    droppableContainers
  } = _ref;
  const collisions = [];
  for (const droppableContainer of droppableContainers) {
    const {
      id
    } = droppableContainer;
    const rect = droppableRects.get(id);
    if (rect) {
      const intersectionRatio = getIntersectionRatio(rect, collisionRect);
      if (intersectionRatio > 0) {
        collisions.push({
          id,
          data: {
            droppableContainer,
            value: intersectionRatio
          }
        });
      }
    }
  }
  return collisions.sort(sortCollisionsDesc);
};
function adjustScale(transform, rect1, rect2) {
  return {
    ...transform,
    scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
    scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
  };
}
function getRectDelta(rect1, rect2) {
  return rect1 && rect2 ? {
    x: rect1.left - rect2.left,
    y: rect1.top - rect2.top
  } : defaultCoordinates;
}
function createRectAdjustmentFn(modifier) {
  return function adjustClientRect(rect) {
    for (var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      adjustments[_key - 1] = arguments[_key];
    }
    return adjustments.reduce((acc, adjustment) => ({
      ...acc,
      top: acc.top + modifier * adjustment.y,
      bottom: acc.bottom + modifier * adjustment.y,
      left: acc.left + modifier * adjustment.x,
      right: acc.right + modifier * adjustment.x
    }), {
      ...rect
    });
  };
}
const getAdjustedRect = /* @__PURE__ */ createRectAdjustmentFn(1);
function parseTransform(transform) {
  if (transform.startsWith("matrix3d(")) {
    const transformArray = transform.slice(9, -1).split(/, /);
    return {
      x: +transformArray[12],
      y: +transformArray[13],
      scaleX: +transformArray[0],
      scaleY: +transformArray[5]
    };
  } else if (transform.startsWith("matrix(")) {
    const transformArray = transform.slice(7, -1).split(/, /);
    return {
      x: +transformArray[4],
      y: +transformArray[5],
      scaleX: +transformArray[0],
      scaleY: +transformArray[3]
    };
  }
  return null;
}
function inverseTransform(rect, transform, transformOrigin) {
  const parsedTransform = parseTransform(transform);
  if (!parsedTransform) {
    return rect;
  }
  const {
    scaleX,
    scaleY,
    x: translateX,
    y: translateY
  } = parsedTransform;
  const x2 = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
  const y2 = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(" ") + 1));
  const w2 = scaleX ? rect.width / scaleX : rect.width;
  const h2 = scaleY ? rect.height / scaleY : rect.height;
  return {
    width: w2,
    height: h2,
    top: y2,
    right: x2 + w2,
    bottom: y2 + h2,
    left: x2
  };
}
const defaultOptions = {
  ignoreTransform: false
};
function getClientRect(element2, options) {
  if (options === void 0) {
    options = defaultOptions;
  }
  let rect = element2.getBoundingClientRect();
  if (options.ignoreTransform) {
    const {
      transform,
      transformOrigin
    } = getWindow(element2).getComputedStyle(element2);
    if (transform) {
      rect = inverseTransform(rect, transform, transformOrigin);
    }
  }
  const {
    top: top2,
    left: left2,
    width: width2,
    height: height2,
    bottom: bottom2,
    right: right2
  } = rect;
  return {
    top: top2,
    left: left2,
    width: width2,
    height: height2,
    bottom: bottom2,
    right: right2
  };
}
function getTransformAgnosticClientRect(element2) {
  return getClientRect(element2, {
    ignoreTransform: true
  });
}
function getWindowClientRect(element2) {
  const width2 = element2.innerWidth;
  const height2 = element2.innerHeight;
  return {
    top: 0,
    left: 0,
    right: width2,
    bottom: height2,
    width: width2,
    height: height2
  };
}
function isFixed(node2, computedStyle) {
  if (computedStyle === void 0) {
    computedStyle = getWindow(node2).getComputedStyle(node2);
  }
  return computedStyle.position === "fixed";
}
function isScrollable(element2, computedStyle) {
  if (computedStyle === void 0) {
    computedStyle = getWindow(element2).getComputedStyle(element2);
  }
  const overflowRegex = /(auto|scroll|overlay)/;
  const properties2 = ["overflow", "overflowX", "overflowY"];
  return properties2.some((property) => {
    const value = computedStyle[property];
    return typeof value === "string" ? overflowRegex.test(value) : false;
  });
}
function getScrollableAncestors(element2, limit) {
  const scrollParents = [];
  function findScrollableAncestors(node2) {
    if (limit != null && scrollParents.length >= limit) {
      return scrollParents;
    }
    if (!node2) {
      return scrollParents;
    }
    if (isDocument(node2) && node2.scrollingElement != null && !scrollParents.includes(node2.scrollingElement)) {
      scrollParents.push(node2.scrollingElement);
      return scrollParents;
    }
    if (!isHTMLElement(node2) || isSVGElement(node2)) {
      return scrollParents;
    }
    if (scrollParents.includes(node2)) {
      return scrollParents;
    }
    const computedStyle = getWindow(element2).getComputedStyle(node2);
    if (node2 !== element2) {
      if (isScrollable(node2, computedStyle)) {
        scrollParents.push(node2);
      }
    }
    if (isFixed(node2, computedStyle)) {
      return scrollParents;
    }
    return findScrollableAncestors(node2.parentNode);
  }
  if (!element2) {
    return scrollParents;
  }
  return findScrollableAncestors(element2);
}
function getFirstScrollableAncestor(node2) {
  const [firstScrollableAncestor] = getScrollableAncestors(node2, 1);
  return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function getScrollableElement(element2) {
  if (!canUseDOM || !element2) {
    return null;
  }
  if (isWindow(element2)) {
    return element2;
  }
  if (!isNode(element2)) {
    return null;
  }
  if (isDocument(element2) || element2 === getOwnerDocument(element2).scrollingElement) {
    return window;
  }
  if (isHTMLElement(element2)) {
    return element2;
  }
  return null;
}
function getScrollXCoordinate(element2) {
  if (isWindow(element2)) {
    return element2.scrollX;
  }
  return element2.scrollLeft;
}
function getScrollYCoordinate(element2) {
  if (isWindow(element2)) {
    return element2.scrollY;
  }
  return element2.scrollTop;
}
function getScrollCoordinates(element2) {
  return {
    x: getScrollXCoordinate(element2),
    y: getScrollYCoordinate(element2)
  };
}
var Direction;
(function(Direction2) {
  Direction2[Direction2["Forward"] = 1] = "Forward";
  Direction2[Direction2["Backward"] = -1] = "Backward";
})(Direction || (Direction = {}));
function isDocumentScrollingElement(element2) {
  if (!canUseDOM || !element2) {
    return false;
  }
  return element2 === document.scrollingElement;
}
function getScrollPosition(scrollingContainer) {
  const minScroll2 = {
    x: 0,
    y: 0
  };
  const dimensions = isDocumentScrollingElement(scrollingContainer) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: scrollingContainer.clientHeight,
    width: scrollingContainer.clientWidth
  };
  const maxScroll = {
    x: scrollingContainer.scrollWidth - dimensions.width,
    y: scrollingContainer.scrollHeight - dimensions.height
  };
  const isTop = scrollingContainer.scrollTop <= minScroll2.y;
  const isLeft = scrollingContainer.scrollLeft <= minScroll2.x;
  const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
  const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
  return {
    isTop,
    isLeft,
    isBottom,
    isRight,
    maxScroll,
    minScroll: minScroll2
  };
}
const defaultThreshold = {
  x: 0.2,
  y: 0.2
};
function getScrollDirectionAndSpeed(scrollContainer2, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
  let {
    top: top2,
    left: left2,
    right: right2,
    bottom: bottom2
  } = _ref;
  if (acceleration === void 0) {
    acceleration = 10;
  }
  if (thresholdPercentage === void 0) {
    thresholdPercentage = defaultThreshold;
  }
  const {
    isTop,
    isBottom,
    isLeft,
    isRight
  } = getScrollPosition(scrollContainer2);
  const direction = {
    x: 0,
    y: 0
  };
  const speed = {
    x: 0,
    y: 0
  };
  const threshold = {
    height: scrollContainerRect.height * thresholdPercentage.y,
    width: scrollContainerRect.width * thresholdPercentage.x
  };
  if (!isTop && top2 <= scrollContainerRect.top + threshold.height) {
    direction.y = Direction.Backward;
    speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top2) / threshold.height);
  } else if (!isBottom && bottom2 >= scrollContainerRect.bottom - threshold.height) {
    direction.y = Direction.Forward;
    speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom2) / threshold.height);
  }
  if (!isRight && right2 >= scrollContainerRect.right - threshold.width) {
    direction.x = Direction.Forward;
    speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right2) / threshold.width);
  } else if (!isLeft && left2 <= scrollContainerRect.left + threshold.width) {
    direction.x = Direction.Backward;
    speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left2) / threshold.width);
  }
  return {
    direction,
    speed
  };
}
function getScrollElementRect(element2) {
  if (element2 === document.scrollingElement) {
    const {
      innerWidth,
      innerHeight: innerHeight2
    } = window;
    return {
      top: 0,
      left: 0,
      right: innerWidth,
      bottom: innerHeight2,
      width: innerWidth,
      height: innerHeight2
    };
  }
  const {
    top: top2,
    left: left2,
    right: right2,
    bottom: bottom2
  } = element2.getBoundingClientRect();
  return {
    top: top2,
    left: left2,
    right: right2,
    bottom: bottom2,
    width: element2.clientWidth,
    height: element2.clientHeight
  };
}
function getScrollOffsets(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node2) => {
    return add$2(acc, getScrollCoordinates(node2));
  }, defaultCoordinates);
}
function getScrollXOffset(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node2) => {
    return acc + getScrollXCoordinate(node2);
  }, 0);
}
function getScrollYOffset(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node2) => {
    return acc + getScrollYCoordinate(node2);
  }, 0);
}
function scrollIntoViewIfNeeded(element2, measure) {
  if (measure === void 0) {
    measure = getClientRect;
  }
  if (!element2) {
    return;
  }
  const {
    top: top2,
    left: left2,
    bottom: bottom2,
    right: right2
  } = measure(element2);
  const firstScrollableAncestor = getFirstScrollableAncestor(element2);
  if (!firstScrollableAncestor) {
    return;
  }
  if (bottom2 <= 0 || right2 <= 0 || top2 >= window.innerHeight || left2 >= window.innerWidth) {
    element2.scrollIntoView({
      block: "center",
      inline: "center"
    });
  }
}
const properties = [["x", ["left", "right"], getScrollXOffset], ["y", ["top", "bottom"], getScrollYOffset]];
class Rect {
  constructor(rect, element2) {
    this.rect = void 0;
    this.width = void 0;
    this.height = void 0;
    this.top = void 0;
    this.bottom = void 0;
    this.right = void 0;
    this.left = void 0;
    const scrollableAncestors = getScrollableAncestors(element2);
    const scrollOffsets = getScrollOffsets(scrollableAncestors);
    this.rect = {
      ...rect
    };
    this.width = rect.width;
    this.height = rect.height;
    for (const [axis, keys2, getScrollOffset] of properties) {
      for (const key2 of keys2) {
        Object.defineProperty(this, key2, {
          get: () => {
            const currentOffsets = getScrollOffset(scrollableAncestors);
            const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
            return this.rect[key2] + scrollOffsetsDeltla;
          },
          enumerable: true
        });
      }
    }
    Object.defineProperty(this, "rect", {
      enumerable: false
    });
  }
}
class Listeners {
  constructor(target) {
    this.target = void 0;
    this.listeners = [];
    this.removeAll = () => {
      this.listeners.forEach((listener) => {
        var _this$target;
        return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
      });
    };
    this.target = target;
  }
  add(eventName, handler, options) {
    var _this$target2;
    (_this$target2 = this.target) == null ? void 0 : _this$target2.addEventListener(eventName, handler, options);
    this.listeners.push([eventName, handler, options]);
  }
}
function getEventListenerTarget(target) {
  const {
    EventTarget: EventTarget2
  } = getWindow(target);
  return target instanceof EventTarget2 ? target : getOwnerDocument(target);
}
function hasExceededDistance(delta, measurement) {
  const dx = Math.abs(delta.x);
  const dy = Math.abs(delta.y);
  if (typeof measurement === "number") {
    return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
  }
  if ("x" in measurement && "y" in measurement) {
    return dx > measurement.x && dy > measurement.y;
  }
  if ("x" in measurement) {
    return dx > measurement.x;
  }
  if ("y" in measurement) {
    return dy > measurement.y;
  }
  return false;
}
var EventName;
(function(EventName2) {
  EventName2["Click"] = "click";
  EventName2["DragStart"] = "dragstart";
  EventName2["Keydown"] = "keydown";
  EventName2["ContextMenu"] = "contextmenu";
  EventName2["Resize"] = "resize";
  EventName2["SelectionChange"] = "selectionchange";
  EventName2["VisibilityChange"] = "visibilitychange";
})(EventName || (EventName = {}));
function preventDefault(event) {
  event.preventDefault();
}
function stopPropagation(event) {
  event.stopPropagation();
}
var KeyboardCode;
(function(KeyboardCode2) {
  KeyboardCode2["Space"] = "Space";
  KeyboardCode2["Down"] = "ArrowDown";
  KeyboardCode2["Right"] = "ArrowRight";
  KeyboardCode2["Left"] = "ArrowLeft";
  KeyboardCode2["Up"] = "ArrowUp";
  KeyboardCode2["Esc"] = "Escape";
  KeyboardCode2["Enter"] = "Enter";
  KeyboardCode2["Tab"] = "Tab";
})(KeyboardCode || (KeyboardCode = {}));
const defaultKeyboardCodes = {
  start: [KeyboardCode.Space, KeyboardCode.Enter],
  cancel: [KeyboardCode.Esc],
  end: [KeyboardCode.Space, KeyboardCode.Enter, KeyboardCode.Tab]
};
const defaultKeyboardCoordinateGetter = (event, _ref) => {
  let {
    currentCoordinates
  } = _ref;
  switch (event.code) {
    case KeyboardCode.Right:
      return {
        ...currentCoordinates,
        x: currentCoordinates.x + 25
      };
    case KeyboardCode.Left:
      return {
        ...currentCoordinates,
        x: currentCoordinates.x - 25
      };
    case KeyboardCode.Down:
      return {
        ...currentCoordinates,
        y: currentCoordinates.y + 25
      };
    case KeyboardCode.Up:
      return {
        ...currentCoordinates,
        y: currentCoordinates.y - 25
      };
  }
  return void 0;
};
class KeyboardSensor {
  constructor(props) {
    this.props = void 0;
    this.autoScrollEnabled = false;
    this.referenceCoordinates = void 0;
    this.listeners = void 0;
    this.windowListeners = void 0;
    this.props = props;
    const {
      event: {
        target
      }
    } = props;
    this.props = props;
    this.listeners = new Listeners(getOwnerDocument(target));
    this.windowListeners = new Listeners(getWindow(target));
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.attach();
  }
  attach() {
    this.handleStart();
    this.windowListeners.add(EventName.Resize, this.handleCancel);
    this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
    setTimeout(() => this.listeners.add(EventName.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode,
      onStart
    } = this.props;
    const node2 = activeNode.node.current;
    if (node2) {
      scrollIntoViewIfNeeded(node2);
    }
    onStart(defaultCoordinates);
  }
  handleKeyDown(event) {
    if (isKeyboardEvent(event)) {
      const {
        active,
        context,
        options
      } = this.props;
      const {
        keyboardCodes = defaultKeyboardCodes,
        coordinateGetter = defaultKeyboardCoordinateGetter,
        scrollBehavior = "smooth"
      } = options;
      const {
        code
      } = event;
      if (keyboardCodes.end.includes(code)) {
        this.handleEnd(event);
        return;
      }
      if (keyboardCodes.cancel.includes(code)) {
        this.handleCancel(event);
        return;
      }
      const {
        collisionRect
      } = context.current;
      const currentCoordinates = collisionRect ? {
        x: collisionRect.left,
        y: collisionRect.top
      } : defaultCoordinates;
      if (!this.referenceCoordinates) {
        this.referenceCoordinates = currentCoordinates;
      }
      const newCoordinates = coordinateGetter(event, {
        active,
        context: context.current,
        currentCoordinates
      });
      if (newCoordinates) {
        const coordinatesDelta = subtract$2(newCoordinates, currentCoordinates);
        const scrollDelta = {
          x: 0,
          y: 0
        };
        const {
          scrollableAncestors
        } = context.current;
        for (const scrollContainer2 of scrollableAncestors) {
          const direction = event.code;
          const {
            isTop,
            isRight,
            isLeft,
            isBottom,
            maxScroll,
            minScroll: minScroll2
          } = getScrollPosition(scrollContainer2);
          const scrollElementRect = getScrollElementRect(scrollContainer2);
          const clampedCoordinates = {
            x: Math.min(direction === KeyboardCode.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === KeyboardCode.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
            y: Math.min(direction === KeyboardCode.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === KeyboardCode.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
          };
          const canScrollX = direction === KeyboardCode.Right && !isRight || direction === KeyboardCode.Left && !isLeft;
          const canScrollY = direction === KeyboardCode.Down && !isBottom || direction === KeyboardCode.Up && !isTop;
          if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
            const newScrollCoordinates = scrollContainer2.scrollLeft + coordinatesDelta.x;
            const canScrollToNewCoordinates = direction === KeyboardCode.Right && newScrollCoordinates <= maxScroll.x || direction === KeyboardCode.Left && newScrollCoordinates >= minScroll2.x;
            if (canScrollToNewCoordinates && !coordinatesDelta.y) {
              scrollContainer2.scrollTo({
                left: newScrollCoordinates,
                behavior: scrollBehavior
              });
              return;
            }
            if (canScrollToNewCoordinates) {
              scrollDelta.x = scrollContainer2.scrollLeft - newScrollCoordinates;
            } else {
              scrollDelta.x = direction === KeyboardCode.Right ? scrollContainer2.scrollLeft - maxScroll.x : scrollContainer2.scrollLeft - minScroll2.x;
            }
            if (scrollDelta.x) {
              scrollContainer2.scrollBy({
                left: -scrollDelta.x,
                behavior: scrollBehavior
              });
            }
            break;
          } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
            const newScrollCoordinates = scrollContainer2.scrollTop + coordinatesDelta.y;
            const canScrollToNewCoordinates = direction === KeyboardCode.Down && newScrollCoordinates <= maxScroll.y || direction === KeyboardCode.Up && newScrollCoordinates >= minScroll2.y;
            if (canScrollToNewCoordinates && !coordinatesDelta.x) {
              scrollContainer2.scrollTo({
                top: newScrollCoordinates,
                behavior: scrollBehavior
              });
              return;
            }
            if (canScrollToNewCoordinates) {
              scrollDelta.y = scrollContainer2.scrollTop - newScrollCoordinates;
            } else {
              scrollDelta.y = direction === KeyboardCode.Down ? scrollContainer2.scrollTop - maxScroll.y : scrollContainer2.scrollTop - minScroll2.y;
            }
            if (scrollDelta.y) {
              scrollContainer2.scrollBy({
                top: -scrollDelta.y,
                behavior: scrollBehavior
              });
            }
            break;
          }
        }
        this.handleMove(event, add$2(subtract$2(newCoordinates, this.referenceCoordinates), scrollDelta));
      }
    }
  }
  handleMove(event, coordinates) {
    const {
      onMove
    } = this.props;
    event.preventDefault();
    onMove(coordinates);
  }
  handleEnd(event) {
    const {
      onEnd
    } = this.props;
    event.preventDefault();
    this.detach();
    onEnd();
  }
  handleCancel(event) {
    const {
      onCancel
    } = this.props;
    event.preventDefault();
    this.detach();
    onCancel();
  }
  detach() {
    this.listeners.removeAll();
    this.windowListeners.removeAll();
  }
}
KeyboardSensor.activators = [{
  eventName: "onKeyDown",
  handler: (event, _ref, _ref2) => {
    let {
      keyboardCodes = defaultKeyboardCodes,
      onActivation
    } = _ref;
    let {
      active
    } = _ref2;
    const {
      code
    } = event.nativeEvent;
    if (keyboardCodes.start.includes(code)) {
      const activator = active.activatorNode.current;
      if (activator && event.target !== activator) {
        return false;
      }
      event.preventDefault();
      onActivation == null ? void 0 : onActivation({
        event: event.nativeEvent
      });
      return true;
    }
    return false;
  }
}];
function isDistanceConstraint(constraint) {
  return Boolean(constraint && "distance" in constraint);
}
function isDelayConstraint(constraint) {
  return Boolean(constraint && "delay" in constraint);
}
class AbstractPointerSensor {
  constructor(props, events2, listenerTarget) {
    var _getEventCoordinates;
    if (listenerTarget === void 0) {
      listenerTarget = getEventListenerTarget(props.event.target);
    }
    this.props = void 0;
    this.events = void 0;
    this.autoScrollEnabled = true;
    this.document = void 0;
    this.activated = false;
    this.initialCoordinates = void 0;
    this.timeoutId = null;
    this.listeners = void 0;
    this.documentListeners = void 0;
    this.windowListeners = void 0;
    this.props = props;
    this.events = events2;
    const {
      event
    } = props;
    const {
      target
    } = event;
    this.props = props;
    this.events = events2;
    this.document = getOwnerDocument(target);
    this.documentListeners = new Listeners(this.document);
    this.listeners = new Listeners(listenerTarget);
    this.windowListeners = new Listeners(getWindow(target));
    this.initialCoordinates = (_getEventCoordinates = getEventCoordinates(event)) != null ? _getEventCoordinates : defaultCoordinates;
    this.handleStart = this.handleStart.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.removeTextSelection = this.removeTextSelection.bind(this);
    this.attach();
  }
  attach() {
    const {
      events: events2,
      props: {
        options: {
          activationConstraint,
          bypassActivationConstraint
        }
      }
    } = this;
    this.listeners.add(events2.move.name, this.handleMove, {
      passive: false
    });
    this.listeners.add(events2.end.name, this.handleEnd);
    if (events2.cancel) {
      this.listeners.add(events2.cancel.name, this.handleCancel);
    }
    this.windowListeners.add(EventName.Resize, this.handleCancel);
    this.windowListeners.add(EventName.DragStart, preventDefault);
    this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
    this.windowListeners.add(EventName.ContextMenu, preventDefault);
    this.documentListeners.add(EventName.Keydown, this.handleKeydown);
    if (activationConstraint) {
      if (bypassActivationConstraint != null && bypassActivationConstraint({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      })) {
        return this.handleStart();
      }
      if (isDelayConstraint(activationConstraint)) {
        this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
        this.handlePending(activationConstraint);
        return;
      }
      if (isDistanceConstraint(activationConstraint)) {
        this.handlePending(activationConstraint);
        return;
      }
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll();
    this.windowListeners.removeAll();
    setTimeout(this.documentListeners.removeAll, 50);
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
  handlePending(constraint, offset3) {
    const {
      active,
      onPending
    } = this.props;
    onPending(active, constraint, this.initialCoordinates, offset3);
  }
  handleStart() {
    const {
      initialCoordinates
    } = this;
    const {
      onStart
    } = this.props;
    if (initialCoordinates) {
      this.activated = true;
      this.documentListeners.add(EventName.Click, stopPropagation, {
        capture: true
      });
      this.removeTextSelection();
      this.documentListeners.add(EventName.SelectionChange, this.removeTextSelection);
      onStart(initialCoordinates);
    }
  }
  handleMove(event) {
    var _getEventCoordinates2;
    const {
      activated,
      initialCoordinates,
      props
    } = this;
    const {
      onMove,
      options: {
        activationConstraint
      }
    } = props;
    if (!initialCoordinates) {
      return;
    }
    const coordinates = (_getEventCoordinates2 = getEventCoordinates(event)) != null ? _getEventCoordinates2 : defaultCoordinates;
    const delta = subtract$2(initialCoordinates, coordinates);
    if (!activated && activationConstraint) {
      if (isDistanceConstraint(activationConstraint)) {
        if (activationConstraint.tolerance != null && hasExceededDistance(delta, activationConstraint.tolerance)) {
          return this.handleCancel();
        }
        if (hasExceededDistance(delta, activationConstraint.distance)) {
          return this.handleStart();
        }
      }
      if (isDelayConstraint(activationConstraint)) {
        if (hasExceededDistance(delta, activationConstraint.tolerance)) {
          return this.handleCancel();
        }
      }
      this.handlePending(activationConstraint, delta);
      return;
    }
    if (event.cancelable) {
      event.preventDefault();
    }
    onMove(coordinates);
  }
  handleEnd() {
    const {
      onAbort,
      onEnd
    } = this.props;
    this.detach();
    if (!this.activated) {
      onAbort(this.props.active);
    }
    onEnd();
  }
  handleCancel() {
    const {
      onAbort,
      onCancel
    } = this.props;
    this.detach();
    if (!this.activated) {
      onAbort(this.props.active);
    }
    onCancel();
  }
  handleKeydown(event) {
    if (event.code === KeyboardCode.Esc) {
      this.handleCancel();
    }
  }
  removeTextSelection() {
    var _this$document$getSel;
    (_this$document$getSel = this.document.getSelection()) == null ? void 0 : _this$document$getSel.removeAllRanges();
  }
}
const events = {
  cancel: {
    name: "pointercancel"
  },
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class PointerSensor extends AbstractPointerSensor {
  constructor(props) {
    const {
      event
    } = props;
    const listenerTarget = getOwnerDocument(event.target);
    super(props, events, listenerTarget);
  }
}
PointerSensor.activators = [{
  eventName: "onPointerDown",
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;
    if (!event.isPrimary || event.button !== 0) {
      return false;
    }
    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];
const events$1 = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var MouseButton;
(function(MouseButton2) {
  MouseButton2[MouseButton2["RightClick"] = 2] = "RightClick";
})(MouseButton || (MouseButton = {}));
class MouseSensor extends AbstractPointerSensor {
  constructor(props) {
    super(props, events$1, getOwnerDocument(props.event.target));
  }
}
MouseSensor.activators = [{
  eventName: "onMouseDown",
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;
    if (event.button === MouseButton.RightClick) {
      return false;
    }
    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];
const events$2 = {
  cancel: {
    name: "touchcancel"
  },
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class TouchSensor extends AbstractPointerSensor {
  constructor(props) {
    super(props, events$2);
  }
  static setup() {
    window.addEventListener(events$2.move.name, noop6, {
      capture: false,
      passive: false
    });
    return function teardown() {
      window.removeEventListener(events$2.move.name, noop6);
    };
    function noop6() {
    }
  }
}
TouchSensor.activators = [{
  eventName: "onTouchStart",
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;
    const {
      touches
    } = event;
    if (touches.length > 1) {
      return false;
    }
    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];
var AutoScrollActivator;
(function(AutoScrollActivator2) {
  AutoScrollActivator2[AutoScrollActivator2["Pointer"] = 0] = "Pointer";
  AutoScrollActivator2[AutoScrollActivator2["DraggableRect"] = 1] = "DraggableRect";
})(AutoScrollActivator || (AutoScrollActivator = {}));
var TraversalOrder;
(function(TraversalOrder2) {
  TraversalOrder2[TraversalOrder2["TreeOrder"] = 0] = "TreeOrder";
  TraversalOrder2[TraversalOrder2["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})(TraversalOrder || (TraversalOrder = {}));
function useAutoScroller(_ref) {
  let {
    acceleration,
    activator = AutoScrollActivator.Pointer,
    canScroll,
    draggingRect,
    enabled,
    interval = 5,
    order: order2 = TraversalOrder.TreeOrder,
    pointerCoordinates,
    scrollableAncestors,
    scrollableAncestorRects,
    delta,
    threshold
  } = _ref;
  const scrollIntent = useScrollIntent({
    delta,
    disabled: !enabled
  });
  const [setAutoScrollInterval, clearAutoScrollInterval] = useInterval();
  const scrollSpeed = useRef({
    x: 0,
    y: 0
  });
  const scrollDirection = useRef({
    x: 0,
    y: 0
  });
  const rect = useMemo$1(() => {
    switch (activator) {
      case AutoScrollActivator.Pointer:
        return pointerCoordinates ? {
          top: pointerCoordinates.y,
          bottom: pointerCoordinates.y,
          left: pointerCoordinates.x,
          right: pointerCoordinates.x
        } : null;
      case AutoScrollActivator.DraggableRect:
        return draggingRect;
    }
  }, [activator, draggingRect, pointerCoordinates]);
  const scrollContainerRef = useRef(null);
  const autoScroll2 = useCallback$1(() => {
    const scrollContainer2 = scrollContainerRef.current;
    if (!scrollContainer2) {
      return;
    }
    const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
    const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
    scrollContainer2.scrollBy(scrollLeft, scrollTop);
  }, []);
  const sortedScrollableAncestors = useMemo$1(() => order2 === TraversalOrder.TreeOrder ? [...scrollableAncestors].reverse() : scrollableAncestors, [order2, scrollableAncestors]);
  useEffect(
    () => {
      if (!enabled || !scrollableAncestors.length || !rect) {
        clearAutoScrollInterval();
        return;
      }
      for (const scrollContainer2 of sortedScrollableAncestors) {
        if ((canScroll == null ? void 0 : canScroll(scrollContainer2)) === false) {
          continue;
        }
        const index2 = scrollableAncestors.indexOf(scrollContainer2);
        const scrollContainerRect = scrollableAncestorRects[index2];
        if (!scrollContainerRect) {
          continue;
        }
        const {
          direction,
          speed
        } = getScrollDirectionAndSpeed(scrollContainer2, scrollContainerRect, rect, acceleration, threshold);
        for (const axis of ["x", "y"]) {
          if (!scrollIntent[axis][direction[axis]]) {
            speed[axis] = 0;
            direction[axis] = 0;
          }
        }
        if (speed.x > 0 || speed.y > 0) {
          clearAutoScrollInterval();
          scrollContainerRef.current = scrollContainer2;
          setAutoScrollInterval(autoScroll2, interval);
          scrollSpeed.current = speed;
          scrollDirection.current = direction;
          return;
        }
      }
      scrollSpeed.current = {
        x: 0,
        y: 0
      };
      scrollDirection.current = {
        x: 0,
        y: 0
      };
      clearAutoScrollInterval();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      acceleration,
      autoScroll2,
      canScroll,
      clearAutoScrollInterval,
      enabled,
      interval,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(rect),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(scrollIntent),
      setAutoScrollInterval,
      scrollableAncestors,
      sortedScrollableAncestors,
      scrollableAncestorRects,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(threshold)
    ]
  );
}
const defaultScrollIntent = {
  x: {
    [Direction.Backward]: false,
    [Direction.Forward]: false
  },
  y: {
    [Direction.Backward]: false,
    [Direction.Forward]: false
  }
};
function useScrollIntent(_ref2) {
  let {
    delta,
    disabled
  } = _ref2;
  const previousDelta = usePrevious(delta);
  return useLazyMemo((previousIntent) => {
    if (disabled || !previousDelta || !previousIntent) {
      return defaultScrollIntent;
    }
    const direction = {
      x: Math.sign(delta.x - previousDelta.x),
      y: Math.sign(delta.y - previousDelta.y)
    };
    return {
      x: {
        [Direction.Backward]: previousIntent.x[Direction.Backward] || direction.x === -1,
        [Direction.Forward]: previousIntent.x[Direction.Forward] || direction.x === 1
      },
      y: {
        [Direction.Backward]: previousIntent.y[Direction.Backward] || direction.y === -1,
        [Direction.Forward]: previousIntent.y[Direction.Forward] || direction.y === 1
      }
    };
  }, [disabled, delta, previousDelta]);
}
function useCachedNode(draggableNodes, id) {
  const draggableNode = id != null ? draggableNodes.get(id) : void 0;
  const node2 = draggableNode ? draggableNode.node.current : null;
  return useLazyMemo((cachedNode) => {
    var _ref;
    if (id == null) {
      return null;
    }
    return (_ref = node2 != null ? node2 : cachedNode) != null ? _ref : null;
  }, [node2, id]);
}
function useCombineActivators(sensors, getSyntheticHandler) {
  return useMemo$1(() => sensors.reduce((accumulator, sensor) => {
    const {
      sensor: Sensor
    } = sensor;
    const sensorActivators = Sensor.activators.map((activator) => ({
      eventName: activator.eventName,
      handler: getSyntheticHandler(activator.handler, sensor)
    }));
    return [...accumulator, ...sensorActivators];
  }, []), [sensors, getSyntheticHandler]);
}
var MeasuringStrategy;
(function(MeasuringStrategy2) {
  MeasuringStrategy2[MeasuringStrategy2["Always"] = 0] = "Always";
  MeasuringStrategy2[MeasuringStrategy2["BeforeDragging"] = 1] = "BeforeDragging";
  MeasuringStrategy2[MeasuringStrategy2["WhileDragging"] = 2] = "WhileDragging";
})(MeasuringStrategy || (MeasuringStrategy = {}));
var MeasuringFrequency;
(function(MeasuringFrequency2) {
  MeasuringFrequency2["Optimized"] = "optimized";
})(MeasuringFrequency || (MeasuringFrequency = {}));
const defaultValue = /* @__PURE__ */ new Map();
function useDroppableMeasuring(containers, _ref) {
  let {
    dragging,
    dependencies,
    config: config2
  } = _ref;
  const [queue, setQueue] = useState(null);
  const {
    frequency,
    measure,
    strategy
  } = config2;
  const containersRef = useRef(containers);
  const disabled = isDisabled();
  const disabledRef = useLatestValue(disabled);
  const measureDroppableContainers = useCallback$1(function(ids2) {
    if (ids2 === void 0) {
      ids2 = [];
    }
    if (disabledRef.current) {
      return;
    }
    setQueue((value) => {
      if (value === null) {
        return ids2;
      }
      return value.concat(ids2.filter((id) => !value.includes(id)));
    });
  }, [disabledRef]);
  const timeoutId = useRef(null);
  const droppableRects = useLazyMemo((previousValue) => {
    if (disabled && !dragging) {
      return defaultValue;
    }
    if (!previousValue || previousValue === defaultValue || containersRef.current !== containers || queue != null) {
      const map3 = /* @__PURE__ */ new Map();
      for (let container of containers) {
        if (!container) {
          continue;
        }
        if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
          map3.set(container.id, container.rect.current);
          continue;
        }
        const node2 = container.node.current;
        const rect = node2 ? new Rect(measure(node2), node2) : null;
        container.rect.current = rect;
        if (rect) {
          map3.set(container.id, rect);
        }
      }
      return map3;
    }
    return previousValue;
  }, [containers, queue, dragging, disabled, measure]);
  useEffect(() => {
    containersRef.current = containers;
  }, [containers]);
  useEffect(
    () => {
      if (disabled) {
        return;
      }
      measureDroppableContainers();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dragging, disabled]
  );
  useEffect(
    () => {
      if (queue && queue.length > 0) {
        setQueue(null);
      }
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(queue)]
  );
  useEffect(
    () => {
      if (disabled || typeof frequency !== "number" || timeoutId.current !== null) {
        return;
      }
      timeoutId.current = setTimeout(() => {
        measureDroppableContainers();
        timeoutId.current = null;
      }, frequency);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [frequency, disabled, measureDroppableContainers, ...dependencies]
  );
  return {
    droppableRects,
    measureDroppableContainers,
    measuringScheduled: queue != null
  };
  function isDisabled() {
    switch (strategy) {
      case MeasuringStrategy.Always:
        return false;
      case MeasuringStrategy.BeforeDragging:
        return dragging;
      default:
        return !dragging;
    }
  }
}
function useInitialValue(value, computeFn) {
  return useLazyMemo((previousValue) => {
    if (!value) {
      return null;
    }
    if (previousValue) {
      return previousValue;
    }
    return typeof computeFn === "function" ? computeFn(value) : value;
  }, [computeFn, value]);
}
function useInitialRect(node2, measure) {
  return useInitialValue(node2, measure);
}
function useMutationObserver(_ref) {
  let {
    callback,
    disabled
  } = _ref;
  const handleMutations = useEvent(callback);
  const mutationObserver = useMemo$1(() => {
    if (disabled || typeof window === "undefined" || typeof window.MutationObserver === "undefined") {
      return void 0;
    }
    const {
      MutationObserver: MutationObserver2
    } = window;
    return new MutationObserver2(handleMutations);
  }, [handleMutations, disabled]);
  useEffect(() => {
    return () => mutationObserver == null ? void 0 : mutationObserver.disconnect();
  }, [mutationObserver]);
  return mutationObserver;
}
function useResizeObserver(_ref) {
  let {
    callback,
    disabled
  } = _ref;
  const handleResize = useEvent(callback);
  const resizeObserver = useMemo$1(
    () => {
      if (disabled || typeof window === "undefined" || typeof window.ResizeObserver === "undefined") {
        return void 0;
      }
      const {
        ResizeObserver: ResizeObserver2
      } = window;
      return new ResizeObserver2(handleResize);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [disabled]
  );
  useEffect(() => {
    return () => resizeObserver == null ? void 0 : resizeObserver.disconnect();
  }, [resizeObserver]);
  return resizeObserver;
}
function defaultMeasure(element2) {
  return new Rect(getClientRect(element2), element2);
}
function useRect(element2, measure, fallbackRect) {
  if (measure === void 0) {
    measure = defaultMeasure;
  }
  const [rect, setRect] = useState(null);
  function measureRect() {
    setRect((currentRect) => {
      if (!element2) {
        return null;
      }
      if (element2.isConnected === false) {
        var _ref;
        return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
      }
      const newRect = measure(element2);
      if (JSON.stringify(currentRect) === JSON.stringify(newRect)) {
        return currentRect;
      }
      return newRect;
    });
  }
  const mutationObserver = useMutationObserver({
    callback(records) {
      if (!element2) {
        return;
      }
      for (const record of records) {
        const {
          type,
          target
        } = record;
        if (type === "childList" && target instanceof HTMLElement && target.contains(element2)) {
          measureRect();
          break;
        }
      }
    }
  });
  const resizeObserver = useResizeObserver({
    callback: measureRect
  });
  useIsomorphicLayoutEffect$1(() => {
    measureRect();
    if (element2) {
      resizeObserver == null ? void 0 : resizeObserver.observe(element2);
      mutationObserver == null ? void 0 : mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    } else {
      resizeObserver == null ? void 0 : resizeObserver.disconnect();
      mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }
  }, [element2]);
  return rect;
}
function useRectDelta(rect) {
  const initialRect = useInitialValue(rect);
  return getRectDelta(rect, initialRect);
}
const defaultValue$1 = [];
function useScrollableAncestors(node2) {
  const previousNode = useRef(node2);
  const ancestors = useLazyMemo((previousValue) => {
    if (!node2) {
      return defaultValue$1;
    }
    if (previousValue && previousValue !== defaultValue$1 && node2 && previousNode.current && node2.parentNode === previousNode.current.parentNode) {
      return previousValue;
    }
    return getScrollableAncestors(node2);
  }, [node2]);
  useEffect(() => {
    previousNode.current = node2;
  }, [node2]);
  return ancestors;
}
function useScrollOffsets(elements) {
  const [scrollCoordinates, setScrollCoordinates] = useState(null);
  const prevElements = useRef(elements);
  const handleScroll = useCallback$1((event) => {
    const scrollingElement = getScrollableElement(event.target);
    if (!scrollingElement) {
      return;
    }
    setScrollCoordinates((scrollCoordinates2) => {
      if (!scrollCoordinates2) {
        return null;
      }
      scrollCoordinates2.set(scrollingElement, getScrollCoordinates(scrollingElement));
      return new Map(scrollCoordinates2);
    });
  }, []);
  useEffect(() => {
    const previousElements = prevElements.current;
    if (elements !== previousElements) {
      cleanup(previousElements);
      const entries = elements.map((element2) => {
        const scrollableElement = getScrollableElement(element2);
        if (scrollableElement) {
          scrollableElement.addEventListener("scroll", handleScroll, {
            passive: true
          });
          return [scrollableElement, getScrollCoordinates(scrollableElement)];
        }
        return null;
      }).filter((entry) => entry != null);
      setScrollCoordinates(entries.length ? new Map(entries) : null);
      prevElements.current = elements;
    }
    return () => {
      cleanup(elements);
      cleanup(previousElements);
    };
    function cleanup(elements2) {
      elements2.forEach((element2) => {
        const scrollableElement = getScrollableElement(element2);
        scrollableElement == null ? void 0 : scrollableElement.removeEventListener("scroll", handleScroll);
      });
    }
  }, [handleScroll, elements]);
  return useMemo$1(() => {
    if (elements.length) {
      return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates) => add$2(acc, coordinates), defaultCoordinates) : getScrollOffsets(elements);
    }
    return defaultCoordinates;
  }, [elements, scrollCoordinates]);
}
function useScrollOffsetsDelta(scrollOffsets, dependencies) {
  if (dependencies === void 0) {
    dependencies = [];
  }
  const initialScrollOffsets = useRef(null);
  useEffect(
    () => {
      initialScrollOffsets.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencies
  );
  useEffect(() => {
    const hasScrollOffsets = scrollOffsets !== defaultCoordinates;
    if (hasScrollOffsets && !initialScrollOffsets.current) {
      initialScrollOffsets.current = scrollOffsets;
    }
    if (!hasScrollOffsets && initialScrollOffsets.current) {
      initialScrollOffsets.current = null;
    }
  }, [scrollOffsets]);
  return initialScrollOffsets.current ? subtract$2(scrollOffsets, initialScrollOffsets.current) : defaultCoordinates;
}
function useSensorSetup(sensors) {
  useEffect(
    () => {
      if (!canUseDOM) {
        return;
      }
      const teardownFns = sensors.map((_ref) => {
        let {
          sensor
        } = _ref;
        return sensor.setup == null ? void 0 : sensor.setup();
      });
      return () => {
        for (const teardown of teardownFns) {
          teardown == null ? void 0 : teardown();
        }
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2) => {
      let {
        sensor
      } = _ref2;
      return sensor;
    })
  );
}
function useSyntheticListeners(listeners, id) {
  return useMemo$1(() => {
    return listeners.reduce((acc, _ref) => {
      let {
        eventName,
        handler
      } = _ref;
      acc[eventName] = (event) => {
        handler(event, id);
      };
      return acc;
    }, {});
  }, [listeners, id]);
}
function useWindowRect(element2) {
  return useMemo$1(() => element2 ? getWindowClientRect(element2) : null, [element2]);
}
const defaultValue$2 = [];
function useRects(elements, measure) {
  if (measure === void 0) {
    measure = getClientRect;
  }
  const [firstElement] = elements;
  const windowRect2 = useWindowRect(firstElement ? getWindow(firstElement) : null);
  const [rects, setRects] = useState(defaultValue$2);
  function measureRects() {
    setRects(() => {
      if (!elements.length) {
        return defaultValue$2;
      }
      return elements.map((element2) => isDocumentScrollingElement(element2) ? windowRect2 : new Rect(measure(element2), element2));
    });
  }
  const resizeObserver = useResizeObserver({
    callback: measureRects
  });
  useIsomorphicLayoutEffect$1(() => {
    resizeObserver == null ? void 0 : resizeObserver.disconnect();
    measureRects();
    elements.forEach((element2) => resizeObserver == null ? void 0 : resizeObserver.observe(element2));
  }, [elements]);
  return rects;
}
function getMeasurableNode(node2) {
  if (!node2) {
    return null;
  }
  if (node2.children.length > 1) {
    return node2;
  }
  const firstChild = node2.children[0];
  return isHTMLElement(firstChild) ? firstChild : node2;
}
function useDragOverlayMeasuring(_ref) {
  let {
    measure
  } = _ref;
  const [rect, setRect] = useState(null);
  const handleResize = useCallback$1((entries) => {
    for (const {
      target
    } of entries) {
      if (isHTMLElement(target)) {
        setRect((rect2) => {
          const newRect = measure(target);
          return rect2 ? {
            ...rect2,
            width: newRect.width,
            height: newRect.height
          } : newRect;
        });
        break;
      }
    }
  }, [measure]);
  const resizeObserver = useResizeObserver({
    callback: handleResize
  });
  const handleNodeChange = useCallback$1((element2) => {
    const node2 = getMeasurableNode(element2);
    resizeObserver == null ? void 0 : resizeObserver.disconnect();
    if (node2) {
      resizeObserver == null ? void 0 : resizeObserver.observe(node2);
    }
    setRect(node2 ? measure(node2) : null);
  }, [measure, resizeObserver]);
  const [nodeRef, setRef] = useNodeRef(handleNodeChange);
  return useMemo$1(() => ({
    nodeRef,
    rect,
    setRef
  }), [rect, nodeRef, setRef]);
}
const defaultSensors = [{
  sensor: PointerSensor,
  options: {}
}, {
  sensor: KeyboardSensor,
  options: {}
}];
const defaultData = {
  current: {}
};
const defaultMeasuringConfiguration = {
  draggable: {
    measure: getTransformAgnosticClientRect
  },
  droppable: {
    measure: getTransformAgnosticClientRect,
    strategy: MeasuringStrategy.WhileDragging,
    frequency: MeasuringFrequency.Optimized
  },
  dragOverlay: {
    measure: getClientRect
  }
};
class DroppableContainersMap extends Map {
  get(id) {
    var _super$get;
    return id != null ? (_super$get = super.get(id)) != null ? _super$get : void 0 : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((_ref) => {
      let {
        disabled
      } = _ref;
      return !disabled;
    });
  }
  getNodeFor(id) {
    var _this$get$node$curren, _this$get;
    return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : void 0;
  }
}
const defaultPublicContext = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new DroppableContainersMap(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: noop$1
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: defaultMeasuringConfiguration,
  measureDroppableContainers: noop$1,
  windowRect: null,
  measuringScheduled: false
};
const defaultInternalContext = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: noop$1,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: noop$1
};
const InternalContext = /* @__PURE__ */ createContext(defaultInternalContext);
const PublicContext = /* @__PURE__ */ createContext(defaultPublicContext);
function getInitialState() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new DroppableContainersMap()
    }
  };
}
function reducer(state, action) {
  switch (action.type) {
    case Action.DragStart:
      return {
        ...state,
        draggable: {
          ...state.draggable,
          initialCoordinates: action.initialCoordinates,
          active: action.active
        }
      };
    case Action.DragMove:
      if (state.draggable.active == null) {
        return state;
      }
      return {
        ...state,
        draggable: {
          ...state.draggable,
          translate: {
            x: action.coordinates.x - state.draggable.initialCoordinates.x,
            y: action.coordinates.y - state.draggable.initialCoordinates.y
          }
        }
      };
    case Action.DragEnd:
    case Action.DragCancel:
      return {
        ...state,
        draggable: {
          ...state.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case Action.RegisterDroppable: {
      const {
        element: element2
      } = action;
      const {
        id
      } = element2;
      const containers = new DroppableContainersMap(state.droppable.containers);
      containers.set(id, element2);
      return {
        ...state,
        droppable: {
          ...state.droppable,
          containers
        }
      };
    }
    case Action.SetDroppableDisabled: {
      const {
        id,
        key: key2,
        disabled
      } = action;
      const element2 = state.droppable.containers.get(id);
      if (!element2 || key2 !== element2.key) {
        return state;
      }
      const containers = new DroppableContainersMap(state.droppable.containers);
      containers.set(id, {
        ...element2,
        disabled
      });
      return {
        ...state,
        droppable: {
          ...state.droppable,
          containers
        }
      };
    }
    case Action.UnregisterDroppable: {
      const {
        id,
        key: key2
      } = action;
      const element2 = state.droppable.containers.get(id);
      if (!element2 || key2 !== element2.key) {
        return state;
      }
      const containers = new DroppableContainersMap(state.droppable.containers);
      containers.delete(id);
      return {
        ...state,
        droppable: {
          ...state.droppable,
          containers
        }
      };
    }
    default: {
      return state;
    }
  }
}
function RestoreFocus(_ref) {
  let {
    disabled
  } = _ref;
  const {
    active,
    activatorEvent,
    draggableNodes
  } = useContext(InternalContext);
  const previousActivatorEvent = usePrevious(activatorEvent);
  const previousActiveId = usePrevious(active == null ? void 0 : active.id);
  useEffect(() => {
    if (disabled) {
      return;
    }
    if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
      if (!isKeyboardEvent(previousActivatorEvent)) {
        return;
      }
      if (document.activeElement === previousActivatorEvent.target) {
        return;
      }
      const draggableNode = draggableNodes.get(previousActiveId);
      if (!draggableNode) {
        return;
      }
      const {
        activatorNode,
        node: node2
      } = draggableNode;
      if (!activatorNode.current && !node2.current) {
        return;
      }
      requestAnimationFrame(() => {
        for (const element2 of [activatorNode.current, node2.current]) {
          if (!element2) {
            continue;
          }
          const focusableNode = findFirstFocusableNode(element2);
          if (focusableNode) {
            focusableNode.focus();
            break;
          }
        }
      });
    }
  }, [activatorEvent, disabled, draggableNodes, previousActiveId, previousActivatorEvent]);
  return null;
}
function applyModifiers(modifiers2, _ref) {
  let {
    transform,
    ...args
  } = _ref;
  return modifiers2 != null && modifiers2.length ? modifiers2.reduce((accumulator, modifier) => {
    return modifier({
      transform: accumulator,
      ...args
    });
  }, transform) : transform;
}
function useMeasuringConfiguration(config2) {
  return useMemo$1(
    () => ({
      draggable: {
        ...defaultMeasuringConfiguration.draggable,
        ...config2 == null ? void 0 : config2.draggable
      },
      droppable: {
        ...defaultMeasuringConfiguration.droppable,
        ...config2 == null ? void 0 : config2.droppable
      },
      dragOverlay: {
        ...defaultMeasuringConfiguration.dragOverlay,
        ...config2 == null ? void 0 : config2.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [config2 == null ? void 0 : config2.draggable, config2 == null ? void 0 : config2.droppable, config2 == null ? void 0 : config2.dragOverlay]
  );
}
function useLayoutShiftScrollCompensation(_ref) {
  let {
    activeNode,
    measure,
    initialRect,
    config: config2 = true
  } = _ref;
  const initialized = useRef(false);
  const {
    x: x2,
    y: y2
  } = typeof config2 === "boolean" ? {
    x: config2,
    y: config2
  } : config2;
  useIsomorphicLayoutEffect$1(() => {
    const disabled = !x2 && !y2;
    if (disabled || !activeNode) {
      initialized.current = false;
      return;
    }
    if (initialized.current || !initialRect) {
      return;
    }
    const node2 = activeNode == null ? void 0 : activeNode.node.current;
    if (!node2 || node2.isConnected === false) {
      return;
    }
    const rect = measure(node2);
    const rectDelta = getRectDelta(rect, initialRect);
    if (!x2) {
      rectDelta.x = 0;
    }
    if (!y2) {
      rectDelta.y = 0;
    }
    initialized.current = true;
    if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
      const firstScrollableAncestor = getFirstScrollableAncestor(node2);
      if (firstScrollableAncestor) {
        firstScrollableAncestor.scrollBy({
          top: rectDelta.y,
          left: rectDelta.x
        });
      }
    }
  }, [activeNode, x2, y2, initialRect, measure]);
}
const ActiveDraggableContext = /* @__PURE__ */ createContext({
  ...defaultCoordinates,
  scaleX: 1,
  scaleY: 1
});
var Status;
(function(Status2) {
  Status2[Status2["Uninitialized"] = 0] = "Uninitialized";
  Status2[Status2["Initializing"] = 1] = "Initializing";
  Status2[Status2["Initialized"] = 2] = "Initialized";
})(Status || (Status = {}));
const DndContext = /* @__PURE__ */ memo(function DndContext2(_ref) {
  var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
  let {
    id,
    accessibility,
    autoScroll: autoScroll2 = true,
    children,
    sensors = defaultSensors,
    collisionDetection = rectIntersection,
    measuring,
    modifiers: modifiers2,
    ...props
  } = _ref;
  const store = useReducer(reducer, void 0, getInitialState);
  const [state, dispatch] = store;
  const [dispatchMonitorEvent, registerMonitorListener] = useDndMonitorProvider();
  const [status, setStatus] = useState(Status.Uninitialized);
  const isInitialized = status === Status.Initialized;
  const {
    draggable: {
      active: activeId,
      nodes: draggableNodes,
      translate
    },
    droppable: {
      containers: droppableContainers
    }
  } = state;
  const node2 = activeId != null ? draggableNodes.get(activeId) : null;
  const activeRects = useRef({
    initial: null,
    translated: null
  });
  const active = useMemo$1(() => {
    var _node$data;
    return activeId != null ? {
      id: activeId,
      // It's possible for the active node to unmount while dragging
      data: (_node$data = node2 == null ? void 0 : node2.data) != null ? _node$data : defaultData,
      rect: activeRects
    } : null;
  }, [activeId, node2]);
  const activeRef = useRef(null);
  const [activeSensor, setActiveSensor] = useState(null);
  const [activatorEvent, setActivatorEvent] = useState(null);
  const latestProps = useLatestValue(props, Object.values(props));
  const draggableDescribedById = useUniqueId("DndDescribedBy", id);
  const enabledDroppableContainers = useMemo$1(() => droppableContainers.getEnabled(), [droppableContainers]);
  const measuringConfiguration = useMeasuringConfiguration(measuring);
  const {
    droppableRects,
    measureDroppableContainers,
    measuringScheduled
  } = useDroppableMeasuring(enabledDroppableContainers, {
    dragging: isInitialized,
    dependencies: [translate.x, translate.y],
    config: measuringConfiguration.droppable
  });
  const activeNode = useCachedNode(draggableNodes, activeId);
  const activationCoordinates = useMemo$1(() => activatorEvent ? getEventCoordinates(activatorEvent) : null, [activatorEvent]);
  const autoScrollOptions = getAutoScrollerOptions();
  const initialActiveNodeRect = useInitialRect(activeNode, measuringConfiguration.draggable.measure);
  useLayoutShiftScrollCompensation({
    activeNode: activeId != null ? draggableNodes.get(activeId) : null,
    config: autoScrollOptions.layoutShiftCompensation,
    initialRect: initialActiveNodeRect,
    measure: measuringConfiguration.draggable.measure
  });
  const activeNodeRect = useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
  const containerNodeRect = useRect(activeNode ? activeNode.parentElement : null);
  const sensorContext = useRef({
    activatorEvent: null,
    active: null,
    activeNode,
    collisionRect: null,
    collisions: null,
    droppableRects,
    draggableNodes,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  });
  const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
  const dragOverlay = useDragOverlayMeasuring({
    measure: measuringConfiguration.dragOverlay.measure
  });
  const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
  const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
  const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect);
  const nodeRectDelta = useRectDelta(usesDragOverlay ? null : activeNodeRect);
  const windowRect2 = useWindowRect(draggingNode ? getWindow(draggingNode) : null);
  const scrollableAncestors = useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
  const scrollableAncestorRects = useRects(scrollableAncestors);
  const modifiedTranslate = applyModifiers(modifiers2, {
    transform: {
      x: translate.x - nodeRectDelta.x,
      y: translate.y - nodeRectDelta.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent,
    active,
    activeNodeRect,
    containerNodeRect,
    draggingNodeRect,
    over: sensorContext.current.over,
    overlayNodeRect: dragOverlay.rect,
    scrollableAncestors,
    scrollableAncestorRects,
    windowRect: windowRect2
  });
  const pointerCoordinates = activationCoordinates ? add$2(activationCoordinates, translate) : null;
  const scrollOffsets = useScrollOffsets(scrollableAncestors);
  const scrollAdjustment = useScrollOffsetsDelta(scrollOffsets);
  const activeNodeScrollDelta = useScrollOffsetsDelta(scrollOffsets, [activeNodeRect]);
  const scrollAdjustedTranslate = add$2(modifiedTranslate, scrollAdjustment);
  const collisionRect = draggingNodeRect ? getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
  const collisions = active && collisionRect ? collisionDetection({
    active,
    collisionRect,
    droppableRects,
    droppableContainers: enabledDroppableContainers,
    pointerCoordinates
  }) : null;
  const overId = getFirstCollision(collisions, "id");
  const [over, setOver] = useState(null);
  const appliedTranslate = usesDragOverlay ? modifiedTranslate : add$2(modifiedTranslate, activeNodeScrollDelta);
  const transform = adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
  const activeSensorRef = useRef(null);
  const instantiateSensor = useCallback$1(
    (event, _ref2) => {
      let {
        sensor: Sensor,
        options
      } = _ref2;
      if (activeRef.current == null) {
        return;
      }
      const activeNode2 = draggableNodes.get(activeRef.current);
      if (!activeNode2) {
        return;
      }
      const activatorEvent2 = event.nativeEvent;
      const sensorInstance = new Sensor({
        active: activeRef.current,
        activeNode: activeNode2,
        event: activatorEvent2,
        options,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: sensorContext,
        onAbort(id2) {
          const draggableNode = draggableNodes.get(id2);
          if (!draggableNode) {
            return;
          }
          const {
            onDragAbort
          } = latestProps.current;
          const event2 = {
            id: id2
          };
          onDragAbort == null ? void 0 : onDragAbort(event2);
          dispatchMonitorEvent({
            type: "onDragAbort",
            event: event2
          });
        },
        onPending(id2, constraint, initialCoordinates, offset3) {
          const draggableNode = draggableNodes.get(id2);
          if (!draggableNode) {
            return;
          }
          const {
            onDragPending
          } = latestProps.current;
          const event2 = {
            id: id2,
            constraint,
            initialCoordinates,
            offset: offset3
          };
          onDragPending == null ? void 0 : onDragPending(event2);
          dispatchMonitorEvent({
            type: "onDragPending",
            event: event2
          });
        },
        onStart(initialCoordinates) {
          const id2 = activeRef.current;
          if (id2 == null) {
            return;
          }
          const draggableNode = draggableNodes.get(id2);
          if (!draggableNode) {
            return;
          }
          const {
            onDragStart: onDragStart4
          } = latestProps.current;
          const event2 = {
            activatorEvent: activatorEvent2,
            active: {
              id: id2,
              data: draggableNode.data,
              rect: activeRects
            }
          };
          unstable_batchedUpdates(() => {
            onDragStart4 == null ? void 0 : onDragStart4(event2);
            setStatus(Status.Initializing);
            dispatch({
              type: Action.DragStart,
              initialCoordinates,
              active: id2
            });
            dispatchMonitorEvent({
              type: "onDragStart",
              event: event2
            });
            setActiveSensor(activeSensorRef.current);
            setActivatorEvent(activatorEvent2);
          });
        },
        onMove(coordinates) {
          dispatch({
            type: Action.DragMove,
            coordinates
          });
        },
        onEnd: createHandler(Action.DragEnd),
        onCancel: createHandler(Action.DragCancel)
      });
      activeSensorRef.current = sensorInstance;
      function createHandler(type) {
        return async function handler() {
          const {
            active: active2,
            collisions: collisions2,
            over: over2,
            scrollAdjustedTranslate: scrollAdjustedTranslate2
          } = sensorContext.current;
          let event2 = null;
          if (active2 && scrollAdjustedTranslate2) {
            const {
              cancelDrop
            } = latestProps.current;
            event2 = {
              activatorEvent: activatorEvent2,
              active: active2,
              collisions: collisions2,
              delta: scrollAdjustedTranslate2,
              over: over2
            };
            if (type === Action.DragEnd && typeof cancelDrop === "function") {
              const shouldCancel = await Promise.resolve(cancelDrop(event2));
              if (shouldCancel) {
                type = Action.DragCancel;
              }
            }
          }
          activeRef.current = null;
          unstable_batchedUpdates(() => {
            dispatch({
              type
            });
            setStatus(Status.Uninitialized);
            setOver(null);
            setActiveSensor(null);
            setActivatorEvent(null);
            activeSensorRef.current = null;
            const eventName = type === Action.DragEnd ? "onDragEnd" : "onDragCancel";
            if (event2) {
              const handler2 = latestProps.current[eventName];
              handler2 == null ? void 0 : handler2(event2);
              dispatchMonitorEvent({
                type: eventName,
                event: event2
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [draggableNodes]
  );
  const bindActivatorToSensorInstantiator = useCallback$1((handler, sensor) => {
    return (event, active2) => {
      const nativeEvent = event.nativeEvent;
      const activeDraggableNode = draggableNodes.get(active2);
      if (
        // Another sensor is already instantiating
        activeRef.current !== null || // No active draggable
        !activeDraggableNode || // Event has already been captured
        nativeEvent.dndKit || nativeEvent.defaultPrevented
      ) {
        return;
      }
      const activationContext = {
        active: activeDraggableNode
      };
      const shouldActivate = handler(event, sensor.options, activationContext);
      if (shouldActivate === true) {
        nativeEvent.dndKit = {
          capturedBy: sensor.sensor
        };
        activeRef.current = active2;
        instantiateSensor(event, sensor);
      }
    };
  }, [draggableNodes, instantiateSensor]);
  const activators = useCombineActivators(sensors, bindActivatorToSensorInstantiator);
  useSensorSetup(sensors);
  useIsomorphicLayoutEffect$1(() => {
    if (activeNodeRect && status === Status.Initializing) {
      setStatus(Status.Initialized);
    }
  }, [activeNodeRect, status]);
  useEffect(
    () => {
      const {
        onDragMove
      } = latestProps.current;
      const {
        active: active2,
        activatorEvent: activatorEvent2,
        collisions: collisions2,
        over: over2
      } = sensorContext.current;
      if (!active2 || !activatorEvent2) {
        return;
      }
      const event = {
        active: active2,
        activatorEvent: activatorEvent2,
        collisions: collisions2,
        delta: {
          x: scrollAdjustedTranslate.x,
          y: scrollAdjustedTranslate.y
        },
        over: over2
      };
      unstable_batchedUpdates(() => {
        onDragMove == null ? void 0 : onDragMove(event);
        dispatchMonitorEvent({
          type: "onDragMove",
          event
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [scrollAdjustedTranslate.x, scrollAdjustedTranslate.y]
  );
  useEffect(
    () => {
      const {
        active: active2,
        activatorEvent: activatorEvent2,
        collisions: collisions2,
        droppableContainers: droppableContainers2,
        scrollAdjustedTranslate: scrollAdjustedTranslate2
      } = sensorContext.current;
      if (!active2 || activeRef.current == null || !activatorEvent2 || !scrollAdjustedTranslate2) {
        return;
      }
      const {
        onDragOver
      } = latestProps.current;
      const overContainer = droppableContainers2.get(overId);
      const over2 = overContainer && overContainer.rect.current ? {
        id: overContainer.id,
        rect: overContainer.rect.current,
        data: overContainer.data,
        disabled: overContainer.disabled
      } : null;
      const event = {
        active: active2,
        activatorEvent: activatorEvent2,
        collisions: collisions2,
        delta: {
          x: scrollAdjustedTranslate2.x,
          y: scrollAdjustedTranslate2.y
        },
        over: over2
      };
      unstable_batchedUpdates(() => {
        setOver(over2);
        onDragOver == null ? void 0 : onDragOver(event);
        dispatchMonitorEvent({
          type: "onDragOver",
          event
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [overId]
  );
  useIsomorphicLayoutEffect$1(() => {
    sensorContext.current = {
      activatorEvent,
      active,
      activeNode,
      collisionRect,
      collisions,
      droppableRects,
      draggableNodes,
      draggingNode,
      draggingNodeRect,
      droppableContainers,
      over,
      scrollableAncestors,
      scrollAdjustedTranslate
    };
    activeRects.current = {
      initial: draggingNodeRect,
      translated: collisionRect
    };
  }, [active, activeNode, collisions, collisionRect, draggableNodes, draggingNode, draggingNodeRect, droppableRects, droppableContainers, over, scrollableAncestors, scrollAdjustedTranslate]);
  useAutoScroller({
    ...autoScrollOptions,
    delta: translate,
    draggingRect: collisionRect,
    pointerCoordinates,
    scrollableAncestors,
    scrollableAncestorRects
  });
  const publicContext = useMemo$1(() => {
    const context = {
      active,
      activeNode,
      activeNodeRect,
      activatorEvent,
      collisions,
      containerNodeRect,
      dragOverlay,
      draggableNodes,
      droppableContainers,
      droppableRects,
      over,
      measureDroppableContainers,
      scrollableAncestors,
      scrollableAncestorRects,
      measuringConfiguration,
      measuringScheduled,
      windowRect: windowRect2
    };
    return context;
  }, [active, activeNode, activeNodeRect, activatorEvent, collisions, containerNodeRect, dragOverlay, draggableNodes, droppableContainers, droppableRects, over, measureDroppableContainers, scrollableAncestors, scrollableAncestorRects, measuringConfiguration, measuringScheduled, windowRect2]);
  const internalContext = useMemo$1(() => {
    const context = {
      activatorEvent,
      activators,
      active,
      activeNodeRect,
      ariaDescribedById: {
        draggable: draggableDescribedById
      },
      dispatch,
      draggableNodes,
      over,
      measureDroppableContainers
    };
    return context;
  }, [activatorEvent, activators, active, activeNodeRect, dispatch, draggableDescribedById, draggableNodes, over, measureDroppableContainers]);
  return React__default.createElement(DndMonitorContext.Provider, {
    value: registerMonitorListener
  }, React__default.createElement(InternalContext.Provider, {
    value: internalContext
  }, React__default.createElement(PublicContext.Provider, {
    value: publicContext
  }, React__default.createElement(ActiveDraggableContext.Provider, {
    value: transform
  }, children)), React__default.createElement(RestoreFocus, {
    disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
  })), React__default.createElement(Accessibility, {
    ...accessibility,
    hiddenTextDescribedById: draggableDescribedById
  }));
  function getAutoScrollerOptions() {
    const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
    const autoScrollGloballyDisabled = typeof autoScroll2 === "object" ? autoScroll2.enabled === false : autoScroll2 === false;
    const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
    if (typeof autoScroll2 === "object") {
      return {
        ...autoScroll2,
        enabled
      };
    }
    return {
      enabled
    };
  }
});
const NullContext = /* @__PURE__ */ createContext(null);
const defaultRole = "button";
const ID_PREFIX$1 = "Draggable";
function useDraggable(_ref) {
  let {
    id,
    data,
    disabled = false,
    attributes
  } = _ref;
  const key2 = useUniqueId(ID_PREFIX$1);
  const {
    activators,
    activatorEvent,
    active,
    activeNodeRect,
    ariaDescribedById,
    draggableNodes,
    over
  } = useContext(InternalContext);
  const {
    role = defaultRole,
    roleDescription = "draggable",
    tabIndex = 0
  } = attributes != null ? attributes : {};
  const isDragging = (active == null ? void 0 : active.id) === id;
  const transform = useContext(isDragging ? ActiveDraggableContext : NullContext);
  const [node2, setNodeRef] = useNodeRef();
  const [activatorNode, setActivatorNodeRef] = useNodeRef();
  const listeners = useSyntheticListeners(activators, id);
  const dataRef = useLatestValue(data);
  useIsomorphicLayoutEffect$1(
    () => {
      draggableNodes.set(id, {
        id,
        key: key2,
        node: node2,
        activatorNode,
        data: dataRef
      });
      return () => {
        const node3 = draggableNodes.get(id);
        if (node3 && node3.key === key2) {
          draggableNodes.delete(id);
        }
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [draggableNodes, id]
  );
  const memoizedAttributes = useMemo$1(() => ({
    role,
    tabIndex,
    "aria-disabled": disabled,
    "aria-pressed": isDragging && role === defaultRole ? true : void 0,
    "aria-roledescription": roleDescription,
    "aria-describedby": ariaDescribedById.draggable
  }), [disabled, role, tabIndex, isDragging, roleDescription, ariaDescribedById.draggable]);
  return {
    active,
    activatorEvent,
    activeNodeRect,
    attributes: memoizedAttributes,
    isDragging,
    listeners: disabled ? void 0 : listeners,
    node: node2,
    over,
    setNodeRef,
    setActivatorNodeRef,
    transform
  };
}
function useDndContext() {
  return useContext(PublicContext);
}
const ID_PREFIX$1$1 = "Droppable";
const defaultResizeObserverConfig = {
  timeout: 25
};
function useDroppable(_ref) {
  let {
    data,
    disabled = false,
    id,
    resizeObserverConfig
  } = _ref;
  const key2 = useUniqueId(ID_PREFIX$1$1);
  const {
    active,
    dispatch,
    over,
    measureDroppableContainers
  } = useContext(InternalContext);
  const previous2 = useRef({
    disabled
  });
  const resizeObserverConnected = useRef(false);
  const rect = useRef(null);
  const callbackId = useRef(null);
  const {
    disabled: resizeObserverDisabled,
    updateMeasurementsFor,
    timeout: resizeObserverTimeout
  } = {
    ...defaultResizeObserverConfig,
    ...resizeObserverConfig
  };
  const ids2 = useLatestValue(updateMeasurementsFor != null ? updateMeasurementsFor : id);
  const handleResize = useCallback$1(
    () => {
      if (!resizeObserverConnected.current) {
        resizeObserverConnected.current = true;
        return;
      }
      if (callbackId.current != null) {
        clearTimeout(callbackId.current);
      }
      callbackId.current = setTimeout(() => {
        measureDroppableContainers(Array.isArray(ids2.current) ? ids2.current : [ids2.current]);
        callbackId.current = null;
      }, resizeObserverTimeout);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [resizeObserverTimeout]
  );
  const resizeObserver = useResizeObserver({
    callback: handleResize,
    disabled: resizeObserverDisabled || !active
  });
  const handleNodeChange = useCallback$1((newElement, previousElement) => {
    if (!resizeObserver) {
      return;
    }
    if (previousElement) {
      resizeObserver.unobserve(previousElement);
      resizeObserverConnected.current = false;
    }
    if (newElement) {
      resizeObserver.observe(newElement);
    }
  }, [resizeObserver]);
  const [nodeRef, setNodeRef] = useNodeRef(handleNodeChange);
  const dataRef = useLatestValue(data);
  useEffect(() => {
    if (!resizeObserver || !nodeRef.current) {
      return;
    }
    resizeObserver.disconnect();
    resizeObserverConnected.current = false;
    resizeObserver.observe(nodeRef.current);
  }, [nodeRef, resizeObserver]);
  useEffect(
    () => {
      dispatch({
        type: Action.RegisterDroppable,
        element: {
          id,
          key: key2,
          disabled,
          node: nodeRef,
          rect,
          data: dataRef
        }
      });
      return () => dispatch({
        type: Action.UnregisterDroppable,
        key: key2,
        id
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id]
  );
  useEffect(() => {
    if (disabled !== previous2.current.disabled) {
      dispatch({
        type: Action.SetDroppableDisabled,
        id,
        key: key2,
        disabled
      });
      previous2.current.disabled = disabled;
    }
  }, [id, key2, disabled, dispatch]);
  return {
    active,
    rect,
    isOver: (over == null ? void 0 : over.id) === id,
    node: nodeRef,
    over,
    setNodeRef
  };
}
function AnimationManager(_ref) {
  let {
    animation: animation2,
    children
  } = _ref;
  const [clonedChildren, setClonedChildren] = useState(null);
  const [element2, setElement] = useState(null);
  const previousChildren = usePrevious(children);
  if (!children && !clonedChildren && previousChildren) {
    setClonedChildren(previousChildren);
  }
  useIsomorphicLayoutEffect$1(() => {
    if (!element2) {
      return;
    }
    const key2 = clonedChildren == null ? void 0 : clonedChildren.key;
    const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
    if (key2 == null || id == null) {
      setClonedChildren(null);
      return;
    }
    Promise.resolve(animation2(id, element2)).then(() => {
      setClonedChildren(null);
    });
  }, [animation2, clonedChildren, element2]);
  return React__default.createElement(React__default.Fragment, null, children, clonedChildren ? cloneElement(clonedChildren, {
    ref: setElement
  }) : null);
}
const defaultTransform = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1
};
function NullifiedContextProvider(_ref) {
  let {
    children
  } = _ref;
  return React__default.createElement(InternalContext.Provider, {
    value: defaultInternalContext
  }, React__default.createElement(ActiveDraggableContext.Provider, {
    value: defaultTransform
  }, children));
}
const baseStyles = {
  position: "fixed",
  touchAction: "none"
};
const defaultTransition$1 = (activatorEvent) => {
  const isKeyboardActivator = isKeyboardEvent(activatorEvent);
  return isKeyboardActivator ? "transform 250ms ease" : void 0;
};
const PositionedOverlay = /* @__PURE__ */ forwardRef$1((_ref, ref2) => {
  let {
    as: as2,
    activatorEvent,
    adjustScale: adjustScale2,
    children,
    className,
    rect,
    style: style3,
    transform,
    transition = defaultTransition$1
  } = _ref;
  if (!rect) {
    return null;
  }
  const scaleAdjustedTransform = adjustScale2 ? transform : {
    ...transform,
    scaleX: 1,
    scaleY: 1
  };
  const styles2 = {
    ...baseStyles,
    width: rect.width,
    height: rect.height,
    top: rect.top,
    left: rect.left,
    transform: CSS$1.Transform.toString(scaleAdjustedTransform),
    transformOrigin: adjustScale2 && activatorEvent ? getRelativeTransformOrigin(activatorEvent, rect) : void 0,
    transition: typeof transition === "function" ? transition(activatorEvent) : transition,
    ...style3
  };
  return React__default.createElement(as2, {
    className,
    style: styles2,
    ref: ref2
  }, children);
});
const defaultDropAnimationSideEffects = (options) => (_ref) => {
  let {
    active,
    dragOverlay
  } = _ref;
  const originalStyles = {};
  const {
    styles: styles2,
    className
  } = options;
  if (styles2 != null && styles2.active) {
    for (const [key2, value] of Object.entries(styles2.active)) {
      if (value === void 0) {
        continue;
      }
      originalStyles[key2] = active.node.style.getPropertyValue(key2);
      active.node.style.setProperty(key2, value);
    }
  }
  if (styles2 != null && styles2.dragOverlay) {
    for (const [key2, value] of Object.entries(styles2.dragOverlay)) {
      if (value === void 0) {
        continue;
      }
      dragOverlay.node.style.setProperty(key2, value);
    }
  }
  if (className != null && className.active) {
    active.node.classList.add(className.active);
  }
  if (className != null && className.dragOverlay) {
    dragOverlay.node.classList.add(className.dragOverlay);
  }
  return function cleanup() {
    for (const [key2, value] of Object.entries(originalStyles)) {
      active.node.style.setProperty(key2, value);
    }
    if (className != null && className.active) {
      active.node.classList.remove(className.active);
    }
  };
};
const defaultKeyframeResolver = (_ref2) => {
  let {
    transform: {
      initial,
      final
    }
  } = _ref2;
  return [{
    transform: CSS$1.Transform.toString(initial)
  }, {
    transform: CSS$1.Transform.toString(final)
  }];
};
const defaultDropAnimationConfiguration = {
  duration: 250,
  easing: "ease",
  keyframes: defaultKeyframeResolver,
  sideEffects: /* @__PURE__ */ defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: "0"
      }
    }
  })
};
function useDropAnimation(_ref3) {
  let {
    config: config2,
    draggableNodes,
    droppableContainers,
    measuringConfiguration
  } = _ref3;
  return useEvent((id, node2) => {
    if (config2 === null) {
      return;
    }
    const activeDraggable = draggableNodes.get(id);
    if (!activeDraggable) {
      return;
    }
    const activeNode = activeDraggable.node.current;
    if (!activeNode) {
      return;
    }
    const measurableNode = getMeasurableNode(node2);
    if (!measurableNode) {
      return;
    }
    const {
      transform
    } = getWindow(node2).getComputedStyle(node2);
    const parsedTransform = parseTransform(transform);
    if (!parsedTransform) {
      return;
    }
    const animation2 = typeof config2 === "function" ? config2 : createDefaultDropAnimation(config2);
    scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
    return animation2({
      active: {
        id,
        data: activeDraggable.data,
        node: activeNode,
        rect: measuringConfiguration.draggable.measure(activeNode)
      },
      draggableNodes,
      dragOverlay: {
        node: node2,
        rect: measuringConfiguration.dragOverlay.measure(measurableNode)
      },
      droppableContainers,
      measuringConfiguration,
      transform: parsedTransform
    });
  });
}
function createDefaultDropAnimation(options) {
  const {
    duration,
    easing,
    sideEffects,
    keyframes
  } = {
    ...defaultDropAnimationConfiguration,
    ...options
  };
  return (_ref4) => {
    let {
      active,
      dragOverlay,
      transform,
      ...rest
    } = _ref4;
    if (!duration) {
      return;
    }
    const delta = {
      x: dragOverlay.rect.left - active.rect.left,
      y: dragOverlay.rect.top - active.rect.top
    };
    const scale = {
      scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
      scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
    };
    const finalTransform = {
      x: transform.x - delta.x,
      y: transform.y - delta.y,
      ...scale
    };
    const animationKeyframes = keyframes({
      ...rest,
      active,
      dragOverlay,
      transform: {
        initial: transform,
        final: finalTransform
      }
    });
    const [firstKeyframe] = animationKeyframes;
    const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
    if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) {
      return;
    }
    const cleanup = sideEffects == null ? void 0 : sideEffects({
      active,
      dragOverlay,
      ...rest
    });
    const animation2 = dragOverlay.node.animate(animationKeyframes, {
      duration,
      easing,
      fill: "forwards"
    });
    return new Promise((resolve) => {
      animation2.onfinish = () => {
        cleanup == null ? void 0 : cleanup();
        resolve();
      };
    });
  };
}
let key = 0;
function useKey(id) {
  return useMemo$1(() => {
    if (id == null) {
      return;
    }
    key++;
    return key;
  }, [id]);
}
const DragOverlay = /* @__PURE__ */ React__default.memo((_ref) => {
  let {
    adjustScale: adjustScale2 = false,
    children,
    dropAnimation: dropAnimationConfig,
    style: style3,
    transition,
    modifiers: modifiers2,
    wrapperElement = "div",
    className,
    zIndex: zIndex2 = 999
  } = _ref;
  const {
    activatorEvent,
    active,
    activeNodeRect,
    containerNodeRect,
    draggableNodes,
    droppableContainers,
    dragOverlay,
    over,
    measuringConfiguration,
    scrollableAncestors,
    scrollableAncestorRects,
    windowRect: windowRect2
  } = useDndContext();
  const transform = useContext(ActiveDraggableContext);
  const key2 = useKey(active == null ? void 0 : active.id);
  const modifiedTransform = applyModifiers(modifiers2, {
    activatorEvent,
    active,
    activeNodeRect,
    containerNodeRect,
    draggingNodeRect: dragOverlay.rect,
    over,
    overlayNodeRect: dragOverlay.rect,
    scrollableAncestors,
    scrollableAncestorRects,
    transform,
    windowRect: windowRect2
  });
  const initialRect = useInitialValue(activeNodeRect);
  const dropAnimation = useDropAnimation({
    config: dropAnimationConfig,
    draggableNodes,
    droppableContainers,
    measuringConfiguration
  });
  const ref2 = initialRect ? dragOverlay.setRef : void 0;
  return React__default.createElement(NullifiedContextProvider, null, React__default.createElement(AnimationManager, {
    animation: dropAnimation
  }, active && key2 ? React__default.createElement(PositionedOverlay, {
    key: key2,
    id: active.id,
    ref: ref2,
    as: wrapperElement,
    activatorEvent,
    adjustScale: adjustScale2,
    className,
    transition,
    rect: initialRect,
    style: {
      zIndex: zIndex2,
      ...style3
    },
    transform: modifiedTransform
  }, children) : null));
});
const restrictToVerticalAxis = (_ref) => {
  let {
    transform
  } = _ref;
  return {
    ...transform,
    x: 0
  };
};
function arrayMove(array, from3, to2) {
  const newArray = array.slice();
  newArray.splice(to2 < 0 ? newArray.length + to2 : to2, 0, newArray.splice(from3, 1)[0]);
  return newArray;
}
function getSortedRects(items, rects) {
  return items.reduce((accumulator, id, index2) => {
    const rect = rects.get(id);
    if (rect) {
      accumulator[index2] = rect;
    }
    return accumulator;
  }, Array(items.length));
}
function isValidIndex(index2) {
  return index2 !== null && index2 >= 0;
}
function itemsEqual(a2, b2) {
  if (a2 === b2) {
    return true;
  }
  if (a2.length !== b2.length) {
    return false;
  }
  for (let i = 0; i < a2.length; i++) {
    if (a2[i] !== b2[i]) {
      return false;
    }
  }
  return true;
}
function normalizeDisabled(disabled) {
  if (typeof disabled === "boolean") {
    return {
      draggable: disabled,
      droppable: disabled
    };
  }
  return disabled;
}
const rectSortingStrategy = (_ref) => {
  let {
    rects,
    activeIndex,
    overIndex,
    index: index2
  } = _ref;
  const newRects = arrayMove(rects, overIndex, activeIndex);
  const oldRect = rects[index2];
  const newRect = newRects[index2];
  if (!newRect || !oldRect) {
    return null;
  }
  return {
    x: newRect.left - oldRect.left,
    y: newRect.top - oldRect.top,
    scaleX: newRect.width / oldRect.width,
    scaleY: newRect.height / oldRect.height
  };
};
const defaultScale$1 = {
  scaleX: 1,
  scaleY: 1
};
const verticalListSortingStrategy = (_ref) => {
  var _rects$activeIndex;
  let {
    activeIndex,
    activeNodeRect: fallbackActiveRect,
    index: index2,
    rects,
    overIndex
  } = _ref;
  const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
  if (!activeNodeRect) {
    return null;
  }
  if (index2 === activeIndex) {
    const overIndexRect = rects[overIndex];
    if (!overIndexRect) {
      return null;
    }
    return {
      x: 0,
      y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
      ...defaultScale$1
    };
  }
  const itemGap = getItemGap$1(rects, index2, activeIndex);
  if (index2 > activeIndex && index2 <= overIndex) {
    return {
      x: 0,
      y: -activeNodeRect.height - itemGap,
      ...defaultScale$1
    };
  }
  if (index2 < activeIndex && index2 >= overIndex) {
    return {
      x: 0,
      y: activeNodeRect.height + itemGap,
      ...defaultScale$1
    };
  }
  return {
    x: 0,
    y: 0,
    ...defaultScale$1
  };
};
function getItemGap$1(clientRects, index2, activeIndex) {
  const currentRect = clientRects[index2];
  const previousRect = clientRects[index2 - 1];
  const nextRect = clientRects[index2 + 1];
  if (!currentRect) {
    return 0;
  }
  if (activeIndex < index2) {
    return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
  }
  return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const ID_PREFIX = "Sortable";
const Context = /* @__PURE__ */ React__default.createContext({
  activeIndex: -1,
  containerId: ID_PREFIX,
  disableTransforms: false,
  items: [],
  overIndex: -1,
  useDragOverlay: false,
  sortedRects: [],
  strategy: rectSortingStrategy,
  disabled: {
    draggable: false,
    droppable: false
  }
});
function SortableContext(_ref) {
  let {
    children,
    id,
    items: userDefinedItems,
    strategy = rectSortingStrategy,
    disabled: disabledProp = false
  } = _ref;
  const {
    active,
    dragOverlay,
    droppableRects,
    over,
    measureDroppableContainers
  } = useDndContext();
  const containerId = useUniqueId(ID_PREFIX, id);
  const useDragOverlay = Boolean(dragOverlay.rect !== null);
  const items = useMemo$1(() => userDefinedItems.map((item) => typeof item === "object" && "id" in item ? item.id : item), [userDefinedItems]);
  const isDragging = active != null;
  const activeIndex = active ? items.indexOf(active.id) : -1;
  const overIndex = over ? items.indexOf(over.id) : -1;
  const previousItemsRef = useRef(items);
  const itemsHaveChanged = !itemsEqual(items, previousItemsRef.current);
  const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
  const disabled = normalizeDisabled(disabledProp);
  useIsomorphicLayoutEffect$1(() => {
    if (itemsHaveChanged && isDragging) {
      measureDroppableContainers(items);
    }
  }, [itemsHaveChanged, items, isDragging, measureDroppableContainers]);
  useEffect(() => {
    previousItemsRef.current = items;
  }, [items]);
  const contextValue = useMemo$1(
    () => ({
      activeIndex,
      containerId,
      disabled,
      disableTransforms,
      items,
      overIndex,
      useDragOverlay,
      sortedRects: getSortedRects(items, droppableRects),
      strategy
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeIndex, containerId, disabled.draggable, disabled.droppable, disableTransforms, items, overIndex, droppableRects, useDragOverlay, strategy]
  );
  return React__default.createElement(Context.Provider, {
    value: contextValue
  }, children);
}
const defaultNewIndexGetter = (_ref) => {
  let {
    id,
    items,
    activeIndex,
    overIndex
  } = _ref;
  return arrayMove(items, activeIndex, overIndex).indexOf(id);
};
const defaultAnimateLayoutChanges = (_ref2) => {
  let {
    containerId,
    isSorting,
    wasDragging,
    index: index2,
    items,
    newIndex,
    previousItems,
    previousContainerId,
    transition
  } = _ref2;
  if (!transition || !wasDragging) {
    return false;
  }
  if (previousItems !== items && index2 === newIndex) {
    return false;
  }
  if (isSorting) {
    return true;
  }
  return newIndex !== index2 && containerId === previousContainerId;
};
const defaultTransition = {
  duration: 200,
  easing: "ease"
};
const transitionProperty = "transform";
const disabledTransition = /* @__PURE__ */ CSS$1.Transition.toString({
  property: transitionProperty,
  duration: 0,
  easing: "linear"
});
const defaultAttributes$1 = {
  roleDescription: "sortable"
};
function useDerivedTransform(_ref) {
  let {
    disabled,
    index: index2,
    node: node2,
    rect
  } = _ref;
  const [derivedTransform, setDerivedtransform] = useState(null);
  const previousIndex = useRef(index2);
  useIsomorphicLayoutEffect$1(() => {
    if (!disabled && index2 !== previousIndex.current && node2.current) {
      const initial = rect.current;
      if (initial) {
        const current = getClientRect(node2.current, {
          ignoreTransform: true
        });
        const delta = {
          x: initial.left - current.left,
          y: initial.top - current.top,
          scaleX: initial.width / current.width,
          scaleY: initial.height / current.height
        };
        if (delta.x || delta.y) {
          setDerivedtransform(delta);
        }
      }
    }
    if (index2 !== previousIndex.current) {
      previousIndex.current = index2;
    }
  }, [disabled, index2, node2, rect]);
  useEffect(() => {
    if (derivedTransform) {
      setDerivedtransform(null);
    }
  }, [derivedTransform]);
  return derivedTransform;
}
function useSortable(_ref) {
  let {
    animateLayoutChanges = defaultAnimateLayoutChanges,
    attributes: userDefinedAttributes,
    disabled: localDisabled,
    data: customData,
    getNewIndex = defaultNewIndexGetter,
    id,
    strategy: localStrategy,
    resizeObserverConfig,
    transition = defaultTransition
  } = _ref;
  const {
    items,
    containerId,
    activeIndex,
    disabled: globalDisabled,
    disableTransforms,
    sortedRects,
    overIndex,
    useDragOverlay,
    strategy: globalStrategy
  } = useContext(Context);
  const disabled = normalizeLocalDisabled(localDisabled, globalDisabled);
  const index2 = items.indexOf(id);
  const data = useMemo$1(() => ({
    sortable: {
      containerId,
      index: index2,
      items
    },
    ...customData
  }), [containerId, customData, index2, items]);
  const itemsAfterCurrentSortable = useMemo$1(() => items.slice(items.indexOf(id)), [items, id]);
  const {
    rect,
    node: node2,
    isOver,
    setNodeRef: setDroppableNodeRef
  } = useDroppable({
    id,
    data,
    disabled: disabled.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: itemsAfterCurrentSortable,
      ...resizeObserverConfig
    }
  });
  const {
    active,
    activatorEvent,
    activeNodeRect,
    attributes,
    setNodeRef: setDraggableNodeRef,
    listeners,
    isDragging,
    over,
    setActivatorNodeRef,
    transform
  } = useDraggable({
    id,
    data,
    attributes: {
      ...defaultAttributes$1,
      ...userDefinedAttributes
    },
    disabled: disabled.draggable
  });
  const setNodeRef = useCombinedRefs(setDroppableNodeRef, setDraggableNodeRef);
  const isSorting = Boolean(active);
  const displaceItem = isSorting && !disableTransforms && isValidIndex(activeIndex) && isValidIndex(overIndex);
  const shouldDisplaceDragSource = !useDragOverlay && isDragging;
  const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
  const strategy = localStrategy != null ? localStrategy : globalStrategy;
  const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
    rects: sortedRects,
    activeNodeRect,
    activeIndex,
    overIndex,
    index: index2
  }) : null;
  const newIndex = isValidIndex(activeIndex) && isValidIndex(overIndex) ? getNewIndex({
    id,
    items,
    activeIndex,
    overIndex
  }) : index2;
  const activeId = active == null ? void 0 : active.id;
  const previous2 = useRef({
    activeId,
    items,
    newIndex,
    containerId
  });
  const itemsHaveChanged = items !== previous2.current.items;
  const shouldAnimateLayoutChanges = animateLayoutChanges({
    active,
    containerId,
    isDragging,
    isSorting,
    id,
    index: index2,
    items,
    newIndex: previous2.current.newIndex,
    previousItems: previous2.current.items,
    previousContainerId: previous2.current.containerId,
    transition,
    wasDragging: previous2.current.activeId != null
  });
  const derivedTransform = useDerivedTransform({
    disabled: !shouldAnimateLayoutChanges,
    index: index2,
    node: node2,
    rect
  });
  useEffect(() => {
    if (isSorting && previous2.current.newIndex !== newIndex) {
      previous2.current.newIndex = newIndex;
    }
    if (containerId !== previous2.current.containerId) {
      previous2.current.containerId = containerId;
    }
    if (items !== previous2.current.items) {
      previous2.current.items = items;
    }
  }, [isSorting, newIndex, containerId, items]);
  useEffect(() => {
    if (activeId === previous2.current.activeId) {
      return;
    }
    if (activeId != null && previous2.current.activeId == null) {
      previous2.current.activeId = activeId;
      return;
    }
    const timeoutId = setTimeout(() => {
      previous2.current.activeId = activeId;
    }, 50);
    return () => clearTimeout(timeoutId);
  }, [activeId]);
  return {
    active,
    activeIndex,
    attributes,
    data,
    rect,
    index: index2,
    newIndex,
    items,
    isOver,
    isSorting,
    isDragging,
    listeners,
    node: node2,
    overIndex,
    over,
    setNodeRef,
    setActivatorNodeRef,
    setDroppableNodeRef,
    setDraggableNodeRef,
    transform: derivedTransform != null ? derivedTransform : finalTransform,
    transition: getTransition()
  };
  function getTransition() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
      itemsHaveChanged && previous2.current.newIndex === index2
    ) {
      return disabledTransition;
    }
    if (shouldDisplaceDragSource && !isKeyboardEvent(activatorEvent) || !transition) {
      return void 0;
    }
    if (isSorting || shouldAnimateLayoutChanges) {
      return CSS$1.Transition.toString({
        ...transition,
        property: transitionProperty
      });
    }
    return void 0;
  }
}
function normalizeLocalDisabled(localDisabled, globalDisabled) {
  var _localDisabled$dragga, _localDisabled$droppa;
  if (typeof localDisabled === "boolean") {
    return {
      draggable: localDisabled,
      // Backwards compatibility
      droppable: false
    };
  }
  return {
    draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
    droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
  };
}
function hasSortableData(entry) {
  if (!entry) {
    return false;
  }
  const data = entry.data.current;
  if (data && "sortable" in data && typeof data.sortable === "object" && "containerId" in data.sortable && "items" in data.sortable && "index" in data.sortable) {
    return true;
  }
  return false;
}
const directions = [KeyboardCode.Down, KeyboardCode.Right, KeyboardCode.Up, KeyboardCode.Left];
const sortableKeyboardCoordinates = (event, _ref) => {
  let {
    context: {
      active,
      collisionRect,
      droppableRects,
      droppableContainers,
      over,
      scrollableAncestors
    }
  } = _ref;
  if (directions.includes(event.code)) {
    event.preventDefault();
    if (!active || !collisionRect) {
      return;
    }
    const filteredContainers = [];
    droppableContainers.getEnabled().forEach((entry) => {
      if (!entry || entry != null && entry.disabled) {
        return;
      }
      const rect = droppableRects.get(entry.id);
      if (!rect) {
        return;
      }
      switch (event.code) {
        case KeyboardCode.Down:
          if (collisionRect.top < rect.top) {
            filteredContainers.push(entry);
          }
          break;
        case KeyboardCode.Up:
          if (collisionRect.top > rect.top) {
            filteredContainers.push(entry);
          }
          break;
        case KeyboardCode.Left:
          if (collisionRect.left > rect.left) {
            filteredContainers.push(entry);
          }
          break;
        case KeyboardCode.Right:
          if (collisionRect.left < rect.left) {
            filteredContainers.push(entry);
          }
          break;
      }
    });
    const collisions = closestCorners({
      collisionRect,
      droppableRects,
      droppableContainers: filteredContainers
    });
    let closestId = getFirstCollision(collisions, "id");
    if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) {
      closestId = collisions[1].id;
    }
    if (closestId != null) {
      const activeDroppable = droppableContainers.get(active.id);
      const newDroppable = droppableContainers.get(closestId);
      const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
      const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
      if (newNode && newRect && activeDroppable && newDroppable) {
        const newScrollAncestors = getScrollableAncestors(newNode);
        const hasDifferentScrollAncestors = newScrollAncestors.some((element2, index2) => scrollableAncestors[index2] !== element2);
        const hasSameContainer = isSameContainer(activeDroppable, newDroppable);
        const isAfterActive = isAfter$1(activeDroppable, newDroppable);
        const offset3 = hasDifferentScrollAncestors || !hasSameContainer ? {
          x: 0,
          y: 0
        } : {
          x: isAfterActive ? collisionRect.width - newRect.width : 0,
          y: isAfterActive ? collisionRect.height - newRect.height : 0
        };
        const rectCoordinates = {
          x: newRect.left,
          y: newRect.top
        };
        const newCoordinates = offset3.x && offset3.y ? rectCoordinates : subtract$2(rectCoordinates, offset3);
        return newCoordinates;
      }
    }
  }
  return void 0;
};
function isSameContainer(a2, b2) {
  if (!hasSortableData(a2) || !hasSortableData(b2)) {
    return false;
  }
  return a2.data.current.sortable.containerId === b2.data.current.sortable.containerId;
}
function isAfter$1(a2, b2) {
  if (!hasSortableData(a2) || !hasSortableData(b2)) {
    return false;
  }
  if (!isSameContainer(a2, b2)) {
    return false;
  }
  return a2.data.current.sortable.index < b2.data.current.sortable.index;
}
const SortableListItem = ({
  page,
  onClick,
  overlayItems
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: page.name
  });
  const style3 = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : void 0,
    transition,
    zIndex: isDragging ? 1 : void 0
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    ActionList.Item,
    {
      ref: setNodeRef,
      style: style3,
      active: isDragging,
      sx: {
        marginInline: "0 !important",
        "&:hover": {
          backgroundColor: "actionListItem.default.hoverBg"
        }
      },
      onClick,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", justify: "space-between", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Stack,
          {
            direction: "horizontal",
            gap: "condensed",
            align: "start",
            sx: { padding: 0 },
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "div",
                {
                  ...attributes,
                  ...listeners,
                  style: {
                    cursor: isDragging ? "grabbing" : "grab",
                    color: "fg.muted",
                    display: "flex",
                    alignItems: "center",
                    marginTop: "2px"
                  },
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(GrabberIcon, { size: "small" })
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { gap: "none", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: page.label }) })
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          AnchoredOverlay,
          {
            open: isMenuOpen,
            onOpen: () => setIsMenuOpen(true),
            onClose: () => setIsMenuOpen(false),
            renderAnchor: (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              IconButton,
              {
                ...props,
                icon: KebabHorizontalIcon,
                size: "small",
                "aria-label": "Page options",
                variant: "invisible",
                "aria-labelledby": void 0,
                onClick: (event) => {
                  var _a3;
                  event.stopPropagation();
                  (_a3 = props.onClick) == null ? void 0 : _a3.call(props, event);
                },
                onMouseDown: (event) => {
                  var _a3;
                  event.stopPropagation();
                  (_a3 = props.onMouseDown) == null ? void 0 : _a3.call(props, event);
                }
              }
            ),
            side: "outside-right",
            align: "end",
            anchorOffset: 20,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                onClick: (event) => event.stopPropagation(),
                onMouseDown: (event) => event.stopPropagation(),
                onKeyDown: (event) => event.stopPropagation(),
                children: overlayItems({ closeMenu: () => setIsMenuOpen(false) })
              }
            )
          }
        )
      ] })
    }
  );
};
const GregDialogFooter = ({
  leftButtonText,
  rightButtonText,
  onLeftButtonClick,
  onRightButtonClick
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      px: 3,
      py: 4,
      sx: { borderTop: "1px solid", borderColor: "border.default" },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", justify: "space-between", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          ButtonComponent,
          {
            onClick: onLeftButtonClick,
            variant: "invisible",
            size: "large",
            style: { minWidth: "150px" },
            children: leftButtonText
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          ButtonComponent,
          {
            onClick: onRightButtonClick,
            variant: "primary",
            size: "large",
            style: { minWidth: "150px" },
            children: rightButtonText
          }
        )
      ] })
    }
  );
};
const BaseDialog = ({
  isOpen,
  onClose,
  title,
  width: width2 = "750px",
  position: position4 = "right",
  showFooter = true,
  leftButtonText = "Cancel",
  rightButtonText = "Save",
  onLeftButtonClick,
  onRightButtonClick,
  showHeader = true,
  headerIcon: HeaderIcon = MilestoneIcon,
  headerActions,
  children
}) => {
  const handleLeftButtonClick = onLeftButtonClick || onClose;
  const handleRightButtonClick = onRightButtonClick || onClose;
  const isSemanticSize = typeof width2 === "string" && ["small", "medium", "large", "xlarge"].includes(width2);
  const dialogWidth = isSemanticSize ? void 0 : width2;
  const semanticWidth = isSemanticSize ? width2 : void 0;
  return isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
    Dialog,
    {
      onClose,
      position: position4,
      width: semanticWidth,
      sx: {
        ...dialogWidth && { width: dialogWidth },
        backgroundColor: "bg.secondary",
        height: "var(--available-height)",
        maxHeight: "var(--available-height)"
      },
      renderFooter: () => showFooter ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        GregDialogFooter,
        {
          leftButtonText,
          rightButtonText,
          onLeftButtonClick: handleLeftButtonClick,
          onRightButtonClick: handleRightButtonClick
        }
      ) : null,
      renderHeader: () => showHeader ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Box,
        {
          mx: 4,
          py: 3,
          mb: 0,
          sx: {
            flexShrink: 0,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid",
            borderColor: "border.default",
            bg: "bg.secondary"
          },
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", gap: "condensed", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderIcon, {}),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "semibold", children: title })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", gap: "condensed", children: [
              headerActions,
              /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog.CloseButton, { onClose })
            ] })
          ]
        }
      ) : null,
      renderBody: () => /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { px: 4, py: 3, bg: "bg.secondary", children })
    }
  );
};
const Divider = ({
  color: color2 = "#D0D7DE",
  height: height2 = 1,
  ...rest
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Box,
  {
    style: {
      backgroundColor: "#D0D7DE",
      height: height2,
      width: "100%"
    },
    ...rest
  }
);
const Accordion = ({
  title,
  children,
  icon,
  px,
  py,
  divider = true,
  defaultOpen = false
}) => {
  const [open, setOpen] = useState(defaultOpen);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { px, py, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Stack,
      {
        direction: "horizontal",
        justify: "space-between",
        align: "center",
        style: { cursor: "pointer" },
        onClick: () => setOpen((prev2) => !prev2),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", gap: "condensed", children: [
            icon,
            /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: title })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              variant: "invisible",
              size: "small",
              "aria-label": open ? "Collapse" : "Expand",
              icon: open ? ChevronDownIcon : ChevronUpIcon
            }
          )
        ]
      }
    ),
    open && /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { py: 3, children: [
      divider && /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { my: 3 }),
      children
    ] })
  ] });
};
const TracksVisibilityForm = ({
  field,
  tracks,
  onChange
}) => {
  const isVisibleToAllTracks = !hasTracksSelected(field);
  const handleVisibleToAllTracksChange = (event) => {
    if (event.target.checked) {
      onChange([]);
    }
  };
  const handleIndividualTracksChange = (value) => {
    onChange(value.map((id) => Number(id)));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { bg: "neutral.muted", p: 2, borderRadius: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.LeadingVisual, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(LockIcon, {}) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Checkbox$1,
        {
          checked: isVisibleToAllTracks,
          onChange: handleVisibleToAllTracksChange
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Visible to all tracks" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "This field will be visible to all tracks." })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Or Selected Tracks" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CheckboxGroup$1,
      {
        onChange: handleIndividualTracksChange,
        children: tracks == null ? void 0 : tracks.map((track2) => {
          var _a3;
          return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Checkbox$1,
              {
                value: track2.id.toString(),
                checked: ((_a3 = field.tracks) == null ? void 0 : _a3.includes(track2.id)) || false
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: track2.name }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: track2.description })
          ] }, track2.id);
        })
      }
    )
  ] });
};
const TracksVisibilityItem = ({
  field,
  onChange,
  defaultOpen = false
}) => {
  const { tracks } = useTracks();
  const { dispatch, formSettings, form } = useRegForm();
  const tracksVisibilitySource = getTracksVisibilitySource(field, form);
  if (!formSettings.tracksEnabled || tracks === void 0 || protectFromHideOrDelete(field, formSettings) || (tracks == null ? void 0 : tracks.length) === 0 || isPreRegField(field, form)) {
    return null;
  }
  if (tracksVisibilitySource !== void 0 && tracksVisibilitySource.name !== field.name) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { children: [
        "Track visibility has been set by",
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: tracksVisibilitySource == null ? void 0 : tracksVisibilitySource.label }),
        " to",
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(FieldTrackList, { field: tracksVisibilitySource })
      ] })
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Track Visibility", divider: false, defaultOpen, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      TracksVisibilityForm,
      {
        field,
        tracks,
        onChange: (tracks2) => {
          if (onChange) {
            onChange({ tracks: tracks2 });
            return;
          }
          dispatch({
            type: "update_field",
            name: field.name,
            payload: { tracks: tracks2 }
          });
        }
      }
    ) })
  ] });
};
const DEFAULT_MIN_LEGNTH = 3;
const MinLengthInput = ({
  minLength = DEFAULT_MIN_LEGNTH,
  value,
  onChange,
  ...inputProps
}) => {
  const [inputValue, setInputValue] = useState(value);
  const inputRef = useRef(null);
  useEffect(() => {
    setInputValue(value);
  }, [value]);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  const handleChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    if (newValue.length >= minLength) {
      onChange == null ? void 0 : onChange(e);
    } else {
      if (value !== void 0) {
        onChange == null ? void 0 : onChange({ ...e, target: { ...e.target, value: value.toString() } });
      }
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TextInput$1,
    {
      ...inputProps,
      ref: inputRef,
      value: inputValue,
      onChange: handleChange,
      size: "large",
      block: true,
      autoComplete: "off",
      "data-1p-ignore": "true",
      "data-lpignore": "true",
      "data-form-type": "other"
    }
  );
};
const isInputField = (field) => field.type !== "page" && field.type !== "section" && field.type !== "info";
const FieldTextForm = ({
  field,
  onChange,
  labelFieldLabel = "Label"
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { id: "labelText", required: true, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: labelFieldLabel }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        MinLengthInput,
        {
          value: field.label || "",
          placeholder: labelFieldLabel,
          onChange: (e) => onChange({ label: e.target.value }),
          autoFocus: true
        }
      )
    ] }),
    isInputField(field) && /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { id: "helpText", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Caption" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Textarea,
        {
          value: field.helpText,
          onChange: (e) => onChange({ helpText: e.target.value }),
          rows: 2,
          placeholder: "Provide additional instructions to help the attendee.",
          sx: {
            width: "100%"
          }
        }
      )
    ] })
  ] });
};
const DataTagField = ({
  field,
  onKeyChange,
  onValueChange,
  onAction,
  isNew = false,
  inputRef
}) => {
  const Reply2 = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { style: { transform: "rotate(180deg)" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ReplyIcon, { size: "small" }) });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { mb: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "condensed", align: "center", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Reply2, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { required: !isNew, sx: { width: "100%" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextInput$1,
      {
        size: "large",
        placeholder: "Key",
        value: (field == null ? void 0 : field.key) || "",
        onChange: (e) => onKeyChange(e.target.value),
        ref: inputRef,
        sx: { width: "100%" }
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { required: !isNew, sx: { width: "100%" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextInput$1,
      {
        size: "large",
        placeholder: "Value",
        value: (field == null ? void 0 : field.value) || "",
        onChange: (e) => onValueChange(e.target.value),
        sx: { width: "100%" }
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconButton,
      {
        icon: isNew ? PlusIcon : TrashIcon,
        "aria-label": isNew ? "Add" : "Delete",
        size: "large",
        variant: isNew ? "default" : "danger",
        onClick: onAction,
        tooltipDirection: "e"
      }
    )
  ] }) });
};
const DataTagEditor = ({
  metadata: initialMetadata,
  onSave,
  scrollRef
}) => {
  const [metadata, setMetadata] = useState(initialMetadata || []);
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");
  const newKeyInputRef = useRef(null);
  const updateMetadata = (next2) => {
    setMetadata(next2);
    onSave(next2.filter(isValidMetaTag));
  };
  const handleFieldChange = (index2, key2, value) => {
    const updated = metadata.map(
      (item, i) => i === index2 ? { key: key2, value } : item
    );
    updateMetadata(updated);
  };
  const handleRemove = (index2) => {
    const updated = metadata.filter((_2, i) => i !== index2);
    updateMetadata(updated);
  };
  const handleAddItem = () => {
    if (newKey.trim() && newValue.trim()) {
      const updated = [
        ...metadata,
        { key: newKey.trim(), value: newValue.trim() }
      ];
      setNewKey("");
      setNewValue("");
      updateMetadata(updated);
      setTimeout(() => {
        var _a3, _b;
        (_a3 = scrollRef == null ? void 0 : scrollRef.current) == null ? void 0 : _a3.scrollIntoView({
          block: "end",
          behavior: "smooth"
        });
        (_b = newKeyInputRef.current) == null ? void 0 : _b.focus();
      }, 30);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { children: [
    metadata.map((field, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      DataTagField,
      {
        field,
        onKeyChange: (key2) => handleFieldChange(index2, key2, field.value || ""),
        onValueChange: (value) => handleFieldChange(index2, field.key || "", value),
        onAction: () => handleRemove(index2),
        isNew: false
      },
      index2
    )),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      DataTagField,
      {
        field: { key: newKey, value: newValue },
        onKeyChange: setNewKey,
        onValueChange: setNewValue,
        onAction: handleAddItem,
        isNew: true,
        inputRef: newKeyInputRef
      }
    )
  ] });
};
const InfoBanner = ({ text: text2, href, linkText, onClick }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      sx: {
        backgroundColor: "accent.subtle",
        border: "1px solid",
        borderColor: "accent.muted"
      },
      p: 3,
      borderRadius: 2,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$2, { weight: "normal", size: "medium", sx: { color: "fg.muted" }, children: [
        text2,
        href && /* @__PURE__ */ jsxRuntimeExports.jsx(Link$1, { href, inline: true, muted: true, underline: true, children: linkText }),
        onClick && /* @__PURE__ */ jsxRuntimeExports.jsx(Link$1, { onClick, inline: true, muted: true, underline: true, children: linkText })
      ] })
    }
  );
};
const DataTagsForm = ({ field, onSave }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      InfoBanner,
      {
        text: "Data tags are an advanced tool to dynamically add registration data to mobile apps, name-badges, and integrations, enabling seamless automation and personalization, ",
        href: "https://google.com",
        linkText: "find out more..."
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(DataTagEditor, { metadata: field.metadata, onSave })
  ] });
};
const SectionFormFields = ({
  value,
  onChange,
  metadataEnabled
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "spacious", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldTextForm, { field: value, onChange }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(TracksVisibilityItem, { field: value, onChange, defaultOpen: true }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
    metadataEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Data Tags", divider: false, defaultOpen: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DataTagsForm, { field: value, onSave: (metadata) => onChange({ metadata }) }) })
  ] });
};
const EditSection = ({
  field,
  isOpen,
  onClose,
  onSave
}) => {
  const { dispatch, formSettings } = useRegForm();
  const [draft, setDraft] = useState(field);
  useEffect(() => {
    if (isOpen) {
      setDraft(field);
    }
  }, [isOpen]);
  const handleChange = (update2) => {
    setDraft((prev2) => ({
      ...prev2,
      ...update2
    }));
  };
  const handleDelete2 = () => {
    if (confirm("Are you sure you want to delete this section?")) {
      dispatch({ type: "delete_field", name: field.name });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseDialog,
    {
      isOpen,
      onClose,
      title: "Section",
      width: "750px",
      position: "right",
      onLeftButtonClick: () => onClose(),
      onRightButtonClick: () => {
        dispatch({ type: "update_field", name: field.name, payload: draft });
        onSave(draft);
      },
      headerActions: !protectFromHideOrDelete(field, formSettings) && /* @__PURE__ */ jsxRuntimeExports.jsx(
        ButtonComponent,
        {
          variant: "danger",
          onClick: handleDelete2,
          leadingVisual: TrashIcon,
          children: "Remove Section"
        }
      ),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        SectionFormFields,
        {
          value: draft,
          onChange: handleChange,
          metadataEnabled: formSettings.metadataEnabled
        }
      )
    }
  );
};
const SectionsMenuListing = ({ pages }) => {
  const { dispatch, formSettings } = useRegForm();
  const [editingSection, setEditingSection] = useState(
    null
  );
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })
  );
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (over && active.id !== over.id) {
      const newIndex = pages.findIndex((page) => page.name === over.id);
      dispatch({
        type: "move_page",
        name: active.id.toString(),
        toIndex: newIndex
      });
    }
  };
  const OverlayItems = ({ page, closeMenu }) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionList, { role: "menu", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        ActionList.Item,
        {
          role: "menuitem",
          onSelect: () => {
            closeMenu();
            setEditingSection(page);
          },
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.LeadingVisual, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(PencilIcon, { size: "small" }) }),
            "Edit"
          ]
        }
      ),
      !protectFromHideOrDelete(page, formSettings) && /* @__PURE__ */ jsxRuntimeExports.jsx(
        ActionList.Item,
        {
          variant: "danger",
          role: "menuitem",
          onSelect: () => {
            closeMenu();
            if (confirm("Are you sure you want to delete this section?")) {
              dispatch({ type: "delete_field", name: page.name });
            }
          },
          children: "Delete"
        }
      )
    ] });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      DndContext,
      {
        sensors,
        collisionDetection: closestCenter,
        onDragEnd: handleDragEnd,
        modifiers: [restrictToVerticalAxis],
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          SortableContext,
          {
            items: pages.map((page) => ({ id: page.name })),
            strategy: verticalListSortingStrategy,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList, { className: "t-pages-list", children: pages.map((page) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              SortableListItem,
              {
                page,
                overlayItems: ({ closeMenu }) => /* @__PURE__ */ jsxRuntimeExports.jsx(OverlayItems, { page, closeMenu }),
                onClick: () => {
                  dispatch({
                    type: "select_page",
                    name: page.name,
                    showEditor: false
                  });
                }
              },
              page.name
            )) })
          }
        )
      }
    ),
    editingSection && /* @__PURE__ */ jsxRuntimeExports.jsx(
      EditSection,
      {
        field: editingSection,
        isOpen: !!editingSection,
        onClose: () => setEditingSection(null),
        onSave: () => setEditingSection(null)
      }
    )
  ] });
};
const createInitialPage = () => ({
  type: "page",
  name: idGenerator(),
  label: "New Section",
  fields: [],
  metadata: []
});
const AddSection = ({ isOpen, onClose, onSave }) => {
  const { formSettings } = useRegForm();
  const [draft, setDraft] = useState(createInitialPage());
  useEffect(() => {
    if (isOpen) {
      setDraft(createInitialPage());
    }
  }, [isOpen]);
  const handleChange = (update2) => {
    setDraft((prev2) => ({
      ...prev2,
      ...update2
    }));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseDialog,
    {
      isOpen,
      onClose: () => onClose(),
      title: "Add Form Section",
      width: "750px",
      position: "right",
      headerIcon: VersionsIcon,
      onRightButtonClick: () => onSave(draft),
      onLeftButtonClick: () => onClose(),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        SectionFormFields,
        {
          value: draft,
          onChange: handleChange,
          metadataEnabled: formSettings.metadataEnabled
        }
      )
    }
  );
};
const PagesHeader = ({
  isCollapsed,
  onCollapse
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", justify: "space-between", align: "center", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "condensed", align: "center", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(VersionsIcon, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { weight: "semibold", size: "medium", children: "Sections" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    IconButton,
    {
      variant: "invisible",
      size: "small",
      "aria-label": "Collapse",
      icon: !isCollapsed ? ChevronDownIcon : ChevronUpIcon,
      onClick: () => onCollapse(!isCollapsed)
    }
  )
] });
const SectionsMenu = () => {
  const { form, dispatch } = useRegForm();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isAddSectionOpen, setIsAddSectionOpen] = useState(false);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Box,
      {
        sx: {
          display: "flex",
          flexDirection: "column",
          bg: "canvas.inset"
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Box,
            {
              py: 3,
              px: 4,
              sx: {
                flexShrink: 0,
                borderBottom: "1px solid",
                borderColor: "border.default"
              },
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(PagesHeader, { isCollapsed, onCollapse: setIsCollapsed })
            }
          ),
          !isCollapsed && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Box,
            {
              sx: {
                flex: 1,
                overflowY: "auto",
                overflowX: "hidden"
              },
              children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { p: 4, pt: 0, children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(SectionsMenuListing, { pages: form.fields }),
                form.fields.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { mt: 2, mb: 3 }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  ButtonComponent,
                  {
                    variant: "invisible",
                    size: "medium",
                    onClick: () => setIsAddSectionOpen(true),
                    leadingVisual: PlusIcon,
                    sx: { width: "100%", justifyContent: "flex-start" },
                    children: "Add Section"
                  }
                )
              ] })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddSection,
      {
        isOpen: isAddSectionOpen,
        onClose: () => {
          setIsAddSectionOpen(false);
        },
        onSave: (page) => {
          dispatch({ type: "add_page", page });
          setIsAddSectionOpen(false);
        }
      }
    )
  ] });
};
const BlankslateContext = /* @__PURE__ */ createContext(null);
function useBlankslate() {
  const context = useContext(BlankslateContext);
  if (!context) {
    throw new Error("useBlankslate must be used within a BlankslateProvider");
  }
  return context;
}
const Provider = BlankslateContext.Provider;
var classes$5 = { "Container": "prc-Blankslate-Container-XATLP", "Blankslate": "prc-Blankslate-Blankslate-7GPW-", "Description": "prc-Blankslate-Description-OGHRk", "Heading": "prc-Blankslate-Heading-H4xby", "Visual": "prc-Blankslate-Visual-PeTD-", "Action": "prc-Blankslate-Action-SK5XS" };
function Blankslate(t0) {
  const $2 = distExports.c(25);
  let border2;
  let children;
  let className;
  let narrow;
  let rest;
  let spacious;
  let t1;
  if ($2[0] !== t0) {
    ({
      border: border2,
      children,
      narrow,
      spacious,
      className,
      size: t1,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = border2;
    $2[2] = children;
    $2[3] = className;
    $2[4] = narrow;
    $2[5] = rest;
    $2[6] = spacious;
    $2[7] = t1;
  } else {
    border2 = $2[1];
    children = $2[2];
    className = $2[3];
    narrow = $2[4];
    rest = $2[5];
    spacious = $2[6];
    t1 = $2[7];
  }
  const size2 = t1 === void 0 ? "medium" : t1;
  let t2;
  let t3;
  if ($2[8] !== size2) {
    t3 = {
      size: size2
    };
    $2[8] = size2;
    $2[9] = t3;
  } else {
    t3 = $2[9];
  }
  t2 = t3;
  const value = t2;
  let t4;
  if ($2[10] !== className) {
    t4 = clsx(classes$5.Blankslate, className);
    $2[10] = className;
    $2[11] = t4;
  } else {
    t4 = $2[11];
  }
  const t5 = border2 ? "" : void 0;
  const t6 = narrow ? "" : void 0;
  const t7 = spacious ? "" : void 0;
  let t8;
  if ($2[12] !== children || $2[13] !== size2 || $2[14] !== t4 || $2[15] !== t5 || $2[16] !== t6 || $2[17] !== t7) {
    t8 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: t4,
      "data-border": t5,
      "data-narrow": t6,
      "data-spacious": t7,
      "data-size": size2,
      children
    });
    $2[12] = children;
    $2[13] = size2;
    $2[14] = t4;
    $2[15] = t5;
    $2[16] = t6;
    $2[17] = t7;
    $2[18] = t8;
  } else {
    t8 = $2[18];
  }
  let t9;
  if ($2[19] !== rest || $2[20] !== t8) {
    t9 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      ...rest,
      className: classes$5.Container,
      children: t8
    });
    $2[19] = rest;
    $2[20] = t8;
    $2[21] = t9;
  } else {
    t9 = $2[21];
  }
  let t10;
  if ($2[22] !== t9 || $2[23] !== value) {
    t10 = /* @__PURE__ */ jsxRuntimeExports.jsx(Provider, {
      value,
      children: t9
    });
    $2[22] = t9;
    $2[23] = value;
    $2[24] = t10;
  } else {
    t10 = $2[24];
  }
  return t10;
}
function Visual(t0) {
  const $2 = distExports.c(10);
  let children;
  let className;
  let rest;
  if ($2[0] !== t0) {
    ({
      children,
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = className;
    $2[3] = rest;
  } else {
    children = $2[1];
    className = $2[2];
    rest = $2[3];
  }
  let t1;
  if ($2[4] !== className) {
    t1 = clsx("Blankslate-Visual", classes$5.Visual, className);
    $2[4] = className;
    $2[5] = t1;
  } else {
    t1 = $2[5];
  }
  let t2;
  if ($2[6] !== children || $2[7] !== rest || $2[8] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      ...rest,
      className: t1,
      children
    });
    $2[6] = children;
    $2[7] = rest;
    $2[8] = t1;
    $2[9] = t2;
  } else {
    t2 = $2[9];
  }
  return t2;
}
function Heading$1(t0) {
  const $2 = distExports.c(12);
  let children;
  let className;
  let rest;
  let t1;
  if ($2[0] !== t0) {
    ({
      as: t1,
      children,
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = className;
    $2[3] = rest;
    $2[4] = t1;
  } else {
    children = $2[1];
    className = $2[2];
    rest = $2[3];
    t1 = $2[4];
  }
  const Component2 = t1 === void 0 ? "h2" : t1;
  let t2;
  if ($2[5] !== className) {
    t2 = clsx("Blankslate-Heading", classes$5.Heading, className);
    $2[5] = className;
    $2[6] = t2;
  } else {
    t2 = $2[6];
  }
  let t3;
  if ($2[7] !== Component2 || $2[8] !== children || $2[9] !== rest || $2[10] !== t2) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, {
      ...rest,
      className: t2,
      children
    });
    $2[7] = Component2;
    $2[8] = children;
    $2[9] = rest;
    $2[10] = t2;
    $2[11] = t3;
  } else {
    t3 = $2[11];
  }
  return t3;
}
function Description(t0) {
  const $2 = distExports.c(10);
  let children;
  let className;
  let rest;
  if ($2[0] !== t0) {
    ({
      children,
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = className;
    $2[3] = rest;
  } else {
    children = $2[1];
    className = $2[2];
    rest = $2[3];
  }
  let t1;
  if ($2[4] !== className) {
    t1 = clsx("Blankslate-Description", classes$5.Description, className);
    $2[4] = className;
    $2[5] = t1;
  } else {
    t1 = $2[5];
  }
  let t2;
  if ($2[6] !== children || $2[7] !== rest || $2[8] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx("p", {
      ...rest,
      className: t1,
      children
    });
    $2[6] = children;
    $2[7] = rest;
    $2[8] = t1;
    $2[9] = t2;
  } else {
    t2 = $2[9];
  }
  return t2;
}
function PrimaryAction(t0) {
  const $2 = distExports.c(11);
  let children;
  let href;
  let props;
  if ($2[0] !== t0) {
    ({
      children,
      href,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = href;
    $2[3] = props;
  } else {
    children = $2[1];
    href = $2[2];
    props = $2[3];
  }
  const {
    size: size2
  } = useBlankslate();
  let t1;
  if ($2[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx("Blankslate-Action", classes$5.Action);
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  const t2 = href ? "a" : "button";
  const t3 = size2 === "small" ? "small" : void 0;
  let t4;
  if ($2[5] !== children || $2[6] !== href || $2[7] !== props || $2[8] !== t2 || $2[9] !== t3) {
    t4 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: t1,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
        ...props,
        as: t2,
        href,
        variant: "primary",
        size: t3,
        children
      })
    });
    $2[5] = children;
    $2[6] = href;
    $2[7] = props;
    $2[8] = t2;
    $2[9] = t3;
    $2[10] = t4;
  } else {
    t4 = $2[10];
  }
  return t4;
}
function SecondaryAction(t0) {
  const $2 = distExports.c(4);
  const {
    children,
    href
  } = t0;
  let t1;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx("Blankslate-Action", classes$5.Action);
    $2[0] = t1;
  } else {
    t1 = $2[0];
  }
  let t2;
  if ($2[1] !== children || $2[2] !== href) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: t1,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Link$1, {
        href,
        children
      })
    });
    $2[1] = children;
    $2[2] = href;
    $2[3] = t2;
  } else {
    t2 = $2[3];
  }
  return t2;
}
const BlankslateContainer = Object.assign(Blankslate, {
  Visual,
  Heading: Heading$1,
  Description,
  PrimaryAction,
  SecondaryAction
});
var classes$4 = { "Banner": "prc-Banner-Banner-IR8eJ", "BannerContainer": "prc-Banner-BannerContainer-lbx3d", "BannerContent": "prc-Banner-BannerContent-zTITK", "BannerActions": "prc-Banner-BannerActions-XCfHL", "BannerTitle": "prc-Banner-BannerTitle-TcuJl", "BannerIcon": "prc-Banner-BannerIcon-WuOyf", "BannerDismiss": "prc-Banner-BannerDismiss-uBZVm", "BannerActionsContainer": "prc-Banner-BannerActionsContainer-ukGMH" };
const iconForVariant = {
  critical: /* @__PURE__ */ jsxRuntimeExports.jsx(StopIcon, {}),
  info: /* @__PURE__ */ jsxRuntimeExports.jsx(InfoIcon, {}),
  success: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckCircleIcon, {}),
  upsell: /* @__PURE__ */ jsxRuntimeExports.jsx(InfoIcon, {}),
  warning: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon, {})
};
const labels = {
  critical: "Critical",
  info: "Information",
  success: "Success",
  upsell: "Recommendation",
  warning: "Warning"
};
const Banner$1 = /* @__PURE__ */ React__default.forwardRef(function Banner({
  "aria-label": label,
  children,
  className,
  description,
  hideTitle,
  icon,
  onDismiss,
  primaryAction,
  secondaryAction,
  title,
  variant: variant3 = "info",
  ...rest
}, forwardRef2) {
  const dismissible = !!onDismiss;
  const hasActions = primaryAction || secondaryAction;
  const bannerRef = React__default.useRef(null);
  const ref2 = useMergedRefs(forwardRef2, bannerRef);
  const supportsCustomIcon = variant3 === "info" || variant3 === "upsell";
  if (process.env.NODE_ENV !== "production") {
    useEffect(() => {
      if (title) {
        return;
      }
      const {
        current: banner
      } = bannerRef;
      if (!banner) {
        return;
      }
      const hasTitle = banner.querySelector("[data-banner-title]");
      if (!hasTitle) {
        throw new Error("Expected a title to be provided to the <Banner> component with the `title` prop or through `<Banner.Title>` but no title was found");
      }
    }, [title]);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("section", {
    ...rest,
    "aria-label": label !== null && label !== void 0 ? label : labels[variant3],
    className: clsx(className, classes$4.Banner),
    "data-dismissible": onDismiss ? "" : void 0,
    "data-title-hidden": hideTitle ? "" : void 0,
    "data-variant": variant3,
    tabIndex: -1,
    ref: ref2,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: classes$4.BannerIcon,
      children: icon && supportsCustomIcon ? icon : iconForVariant[variant3]
    }), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      className: classes$4.BannerContainer,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
        className: classes$4.BannerContent,
        children: [title ? hideTitle ? /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, {
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(BannerTitle, {
            children: title
          })
        }) : /* @__PURE__ */ jsxRuntimeExports.jsx(BannerTitle, {
          children: title
        }) : null, description ? /* @__PURE__ */ jsxRuntimeExports.jsx(BannerDescription, {
          children: description
        }) : null, children]
      }), hasActions ? /* @__PURE__ */ jsxRuntimeExports.jsx(BannerActions, {
        primaryAction,
        secondaryAction
      }) : null]
    }), dismissible ? /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, {
      "aria-label": "Dismiss banner",
      onClick: onDismiss,
      className: classes$4.BannerDismiss,
      icon: XIcon,
      variant: "invisible"
    }) : null]
  });
});
function BannerTitle(props) {
  const $2 = distExports.c(12);
  let children;
  let className;
  let rest;
  let t0;
  if ($2[0] !== props) {
    ({
      as: t0,
      className,
      children,
      ...rest
    } = props);
    $2[0] = props;
    $2[1] = children;
    $2[2] = className;
    $2[3] = rest;
    $2[4] = t0;
  } else {
    children = $2[1];
    className = $2[2];
    rest = $2[3];
    t0 = $2[4];
  }
  const Heading2 = t0 === void 0 ? "h2" : t0;
  let t1;
  if ($2[5] !== className) {
    t1 = clsx(className, classes$4.BannerTitle);
    $2[5] = className;
    $2[6] = t1;
  } else {
    t1 = $2[6];
  }
  let t2;
  if ($2[7] !== Heading2 || $2[8] !== children || $2[9] !== rest || $2[10] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(Heading2, {
      ...rest,
      className: t1,
      "data-banner-title": "",
      children
    });
    $2[7] = Heading2;
    $2[8] = children;
    $2[9] = rest;
    $2[10] = t1;
    $2[11] = t2;
  } else {
    t2 = $2[11];
  }
  return t2;
}
function BannerDescription(t0) {
  const $2 = distExports.c(10);
  let children;
  let className;
  let rest;
  if ($2[0] !== t0) {
    ({
      children,
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = className;
    $2[3] = rest;
  } else {
    children = $2[1];
    className = $2[2];
    rest = $2[3];
  }
  let t1;
  if ($2[4] !== className) {
    t1 = clsx("BannerDescription", className);
    $2[4] = className;
    $2[5] = t1;
  } else {
    t1 = $2[5];
  }
  let t2;
  if ($2[6] !== children || $2[7] !== rest || $2[8] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      ...rest,
      className: t1,
      children
    });
    $2[6] = children;
    $2[7] = rest;
    $2[8] = t1;
    $2[9] = t2;
  } else {
    t2 = $2[9];
  }
  return t2;
}
function BannerActions(t0) {
  const $2 = distExports.c(9);
  const {
    primaryAction,
    secondaryAction
  } = t0;
  const t1 = secondaryAction !== null && secondaryAction !== void 0 ? secondaryAction : null;
  const t2 = primaryAction !== null && primaryAction !== void 0 ? primaryAction : null;
  let t3;
  if ($2[0] !== t1 || $2[1] !== t2) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      className: classes$4.BannerActionsContainer,
      "data-primary-action": "trailing",
      children: [t1, t2]
    });
    $2[0] = t1;
    $2[1] = t2;
    $2[2] = t3;
  } else {
    t3 = $2[2];
  }
  const t4 = primaryAction !== null && primaryAction !== void 0 ? primaryAction : null;
  const t5 = secondaryAction !== null && secondaryAction !== void 0 ? secondaryAction : null;
  let t6;
  if ($2[3] !== t4 || $2[4] !== t5) {
    t6 = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      className: classes$4.BannerActionsContainer,
      "data-primary-action": "leading",
      children: [t4, t5]
    });
    $2[3] = t4;
    $2[4] = t5;
    $2[5] = t6;
  } else {
    t6 = $2[5];
  }
  let t7;
  if ($2[6] !== t3 || $2[7] !== t6) {
    t7 = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      className: classes$4.BannerActions,
      children: [t3, t6]
    });
    $2[6] = t3;
    $2[7] = t6;
    $2[8] = t7;
  } else {
    t7 = $2[8];
  }
  return t7;
}
const BannerPrimaryAction = /* @__PURE__ */ forwardRef$1((t0, forwardedRef) => {
  const $2 = distExports.c(11);
  let children;
  let className;
  let rest;
  if ($2[0] !== t0) {
    ({
      children,
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = className;
    $2[3] = rest;
  } else {
    children = $2[1];
    className = $2[2];
    rest = $2[3];
  }
  let t1;
  if ($2[4] !== className) {
    t1 = clsx("BannerPrimaryAction", className);
    $2[4] = className;
    $2[5] = t1;
  } else {
    t1 = $2[5];
  }
  let t2;
  if ($2[6] !== children || $2[7] !== forwardedRef || $2[8] !== rest || $2[9] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
      ref: forwardedRef,
      className: t1,
      variant: "default",
      ...rest,
      children
    });
    $2[6] = children;
    $2[7] = forwardedRef;
    $2[8] = rest;
    $2[9] = t1;
    $2[10] = t2;
  } else {
    t2 = $2[10];
  }
  return t2;
});
BannerPrimaryAction.displayName = "BannerPrimaryAction";
const BannerSecondaryAction = /* @__PURE__ */ forwardRef$1((t0, forwardedRef) => {
  const $2 = distExports.c(11);
  let children;
  let className;
  let rest;
  if ($2[0] !== t0) {
    ({
      children,
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = className;
    $2[3] = rest;
  } else {
    children = $2[1];
    className = $2[2];
    rest = $2[3];
  }
  let t1;
  if ($2[4] !== className) {
    t1 = clsx("BannerPrimaryAction", className);
    $2[4] = className;
    $2[5] = t1;
  } else {
    t1 = $2[5];
  }
  let t2;
  if ($2[6] !== children || $2[7] !== forwardedRef || $2[8] !== rest || $2[9] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
      ref: forwardedRef,
      className: t1,
      variant: "link",
      ...rest,
      children
    });
    $2[6] = children;
    $2[7] = forwardedRef;
    $2[8] = rest;
    $2[9] = t1;
    $2[10] = t2;
  } else {
    t2 = $2[10];
  }
  return t2;
});
BannerSecondaryAction.displayName = "BannerSecondaryAction";
const Banner2 = Object.assign(Banner$1, {
  Title: BannerTitle,
  Description: BannerDescription,
  PrimaryAction: BannerPrimaryAction,
  SecondaryAction: BannerSecondaryAction
});
function ErrorDialog(t0) {
  const $2 = distExports.c(7);
  const {
    title: t1,
    children,
    onRetry,
    onDismiss
  } = t0;
  const title = t1 === void 0 ? "Error" : t1;
  let t2;
  if ($2[0] !== onDismiss || $2[1] !== onRetry) {
    t2 = (gesture) => {
      if (gesture === "confirm") {
        onRetry === null || onRetry === void 0 ? void 0 : onRetry();
      } else {
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
      }
    };
    $2[0] = onDismiss;
    $2[1] = onRetry;
    $2[2] = t2;
  } else {
    t2 = $2[2];
  }
  let t3;
  if ($2[3] !== children || $2[4] !== t2 || $2[5] !== title) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx(ConfirmationDialog, {
      title,
      onClose: t2,
      confirmButtonContent: "Retry",
      cancelButtonContent: "Dismiss",
      children
    });
    $2[3] = children;
    $2[4] = t2;
    $2[5] = title;
    $2[6] = t3;
  } else {
    t3 = $2[6];
  }
  return t3;
}
function useTableLayout(columns) {
  return {
    gridTemplateColumns: getGridTemplateFromColumns(columns).join(" ")
  };
}
function getGridTemplateFromColumns(columns) {
  return columns.map((column2) => {
    var _column$width;
    const columnWidth = (_column$width = column2.width) !== null && _column$width !== void 0 ? _column$width : "grow";
    let minWidth2 = "auto";
    let maxWidth2 = "1fr";
    if (columnWidth === "auto") {
      maxWidth2 = "auto";
    }
    if (columnWidth === "grow" && !column2.maxWidth) {
      minWidth2 = "max-content";
    }
    if (columnWidth === "growCollapse") {
      minWidth2 = "0";
    }
    if (column2.minWidth) {
      minWidth2 = typeof column2.minWidth === "number" ? `${column2.minWidth}px` : column2.minWidth;
    }
    if (column2.maxWidth) {
      maxWidth2 = typeof column2.maxWidth === "number" ? `${column2.maxWidth}px` : column2.maxWidth;
    }
    if (typeof columnWidth !== "number" && ["grow", "growCollapse", "auto"].includes(columnWidth)) {
      return minWidth2 === maxWidth2 ? minWidth2 : `minmax(${minWidth2}, ${maxWidth2})`;
    }
    return typeof columnWidth === "number" ? `${columnWidth}px` : columnWidth;
  });
}
var classes$3 = { "ButtonReset": "prc-components-ButtonReset-9kafa" };
const Button = (t0) => {
  const $2 = distExports.c(10);
  let children;
  let className;
  let rest;
  if ($2[0] !== t0) {
    ({
      children,
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = className;
    $2[3] = rest;
  } else {
    children = $2[1];
    className = $2[2];
    rest = $2[3];
  }
  let t1;
  if ($2[4] !== className) {
    t1 = clsx(className, classes$3.ButtonReset);
    $2[4] = className;
    $2[5] = t1;
  } else {
    t1 = $2[5];
  }
  let t2;
  if ($2[6] !== children || $2[7] !== rest || $2[8] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx("button", {
      className: t1,
      type: "button",
      ...rest,
      children
    });
    $2[6] = children;
    $2[7] = rest;
    $2[8] = t1;
    $2[9] = t2;
  } else {
    t2 = $2[9];
  }
  return t2;
};
var classes$2 = { "TableContainer": "prc-DataTable-TableContainer-Gm3sY", "TableTitle": "prc-DataTable-TableTitle-Q7qQd", "TableSubtitle": "prc-DataTable-TableSubtitle-DEyv-", "TableActions": "prc-DataTable-TableActions-IEEii", "TableDivider": "prc-DataTable-TableDivider-OsO1X", "TableOverflowWrapper": "prc-DataTable-TableOverflowWrapper-PFgsy", "Table": "prc-DataTable-Table-qYfrL", "TableCell": "prc-DataTable-TableCell-dVc-6", "TableHeader": "prc-DataTable-TableHeader-CRPoj", "TableHead": "prc-DataTable-TableHead-eOrJU", "TableRow": "prc-DataTable-TableRow-1vLX7", "TableBody": "prc-DataTable-TableBody-p56SS", "TableCellSkeletonItem": "prc-DataTable-TableCellSkeletonItem-jFqti", "TableCellSkeleton": "prc-DataTable-TableCellSkeleton-ge8WK", "TableCellSkeletonItems": "prc-DataTable-TableCellSkeletonItems-XEGdI" };
const Table$2 = /* @__PURE__ */ React__default.forwardRef(function Table(t0, ref2) {
  const $2 = distExports.c(21);
  let className;
  let gridTemplateColumns2;
  let labelledby;
  let rest;
  let t1;
  if ($2[0] !== t0) {
    ({
      "aria-labelledby": labelledby,
      cellPadding: t1,
      className,
      gridTemplateColumns: gridTemplateColumns2,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = gridTemplateColumns2;
    $2[3] = labelledby;
    $2[4] = rest;
    $2[5] = t1;
  } else {
    className = $2[1];
    gridTemplateColumns2 = $2[2];
    labelledby = $2[3];
    rest = $2[4];
    t1 = $2[5];
  }
  const cellPadding = t1 === void 0 ? "normal" : t1;
  let t2;
  if ($2[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = clsx("TableOverflowWrapper", classes$2.TableOverflowWrapper);
    $2[6] = t2;
  } else {
    t2 = $2[6];
  }
  let t3;
  if ($2[7] !== className) {
    t3 = clsx(className, "Table", classes$2.Table);
    $2[7] = className;
    $2[8] = t3;
  } else {
    t3 = $2[8];
  }
  let t4;
  if ($2[9] !== gridTemplateColumns2) {
    t4 = {
      "--grid-template-columns": gridTemplateColumns2
    };
    $2[9] = gridTemplateColumns2;
    $2[10] = t4;
  } else {
    t4 = $2[10];
  }
  const t5 = t4;
  let t6;
  if ($2[11] !== cellPadding || $2[12] !== labelledby || $2[13] !== ref2 || $2[14] !== rest || $2[15] !== t3 || $2[16] !== t5) {
    t6 = /* @__PURE__ */ jsxRuntimeExports.jsx("table", {
      ...rest,
      "aria-labelledby": labelledby,
      "data-cell-padding": cellPadding,
      className: t3,
      role: "table",
      ref: ref2,
      style: t5
    });
    $2[11] = cellPadding;
    $2[12] = labelledby;
    $2[13] = ref2;
    $2[14] = rest;
    $2[15] = t3;
    $2[16] = t5;
    $2[17] = t6;
  } else {
    t6 = $2[17];
  }
  let t7;
  if ($2[18] !== labelledby || $2[19] !== t6) {
    t7 = /* @__PURE__ */ jsxRuntimeExports.jsx(ScrollableRegion, {
      "aria-labelledby": labelledby,
      className: t2,
      children: t6
    });
    $2[18] = labelledby;
    $2[19] = t6;
    $2[20] = t7;
  } else {
    t7 = $2[20];
  }
  return t7;
});
function TableHead(t0) {
  const $2 = distExports.c(3);
  const {
    children
  } = t0;
  let t1;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx("TableHead", classes$2.TableHead);
    $2[0] = t1;
  } else {
    t1 = $2[0];
  }
  let t2;
  if ($2[1] !== children) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx("thead", {
      className: t1,
      role: "rowgroup",
      children
    });
    $2[1] = children;
    $2[2] = t2;
  } else {
    t2 = $2[2];
  }
  return t2;
}
function TableBody(t0) {
  const $2 = distExports.c(3);
  const {
    children
  } = t0;
  let t1;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx("TableBody", classes$2.TableBody);
    $2[0] = t1;
  } else {
    t1 = $2[0];
  }
  let t2;
  if ($2[1] !== children) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", {
      className: t1,
      role: "rowgroup",
      children
    });
    $2[1] = children;
    $2[2] = t2;
  } else {
    t2 = $2[2];
  }
  return t2;
}
function TableHeader$1(t0) {
  const $2 = distExports.c(9);
  let align;
  let children;
  let rest;
  if ($2[0] !== t0) {
    ({
      align,
      children,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = align;
    $2[2] = children;
    $2[3] = rest;
  } else {
    align = $2[1];
    children = $2[2];
    rest = $2[3];
  }
  let t1;
  if ($2[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx("TableHeader", classes$2.TableHeader);
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  let t2;
  if ($2[5] !== align || $2[6] !== children || $2[7] !== rest) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx("th", {
      ...rest,
      className: t1,
      role: "columnheader",
      scope: "col",
      "data-cell-align": align,
      children
    });
    $2[5] = align;
    $2[6] = children;
    $2[7] = rest;
    $2[8] = t2;
  } else {
    t2 = $2[8];
  }
  return t2;
}
function TableRow$1(t0) {
  const $2 = distExports.c(7);
  let children;
  let rest;
  if ($2[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = rest;
  } else {
    children = $2[1];
    rest = $2[2];
  }
  let t1;
  if ($2[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx("TableRow", classes$2.TableRow);
    $2[3] = t1;
  } else {
    t1 = $2[3];
  }
  let t2;
  if ($2[4] !== children || $2[5] !== rest) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx("tr", {
      ...rest,
      className: t1,
      role: "row",
      children
    });
    $2[4] = children;
    $2[5] = rest;
    $2[6] = t2;
  } else {
    t2 = $2[6];
  }
  return t2;
}
function TableCell$1(t0) {
  const $2 = distExports.c(16);
  let align;
  let children;
  let className;
  let rest;
  let scope;
  if ($2[0] !== t0) {
    ({
      align,
      className,
      children,
      scope,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = align;
    $2[2] = children;
    $2[3] = className;
    $2[4] = rest;
    $2[5] = scope;
  } else {
    align = $2[1];
    children = $2[2];
    className = $2[3];
    rest = $2[4];
    scope = $2[5];
  }
  const BaseComponent = scope ? "th" : "td";
  const role = scope ? "rowheader" : "cell";
  let t1;
  if ($2[6] !== className) {
    t1 = clsx("TableCell", className, classes$2.TableCell);
    $2[6] = className;
    $2[7] = t1;
  } else {
    t1 = $2[7];
  }
  let t2;
  if ($2[8] !== BaseComponent || $2[9] !== align || $2[10] !== children || $2[11] !== rest || $2[12] !== role || $2[13] !== scope || $2[14] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(BaseComponent, {
      ...rest,
      className: t1,
      scope,
      role,
      "data-cell-align": align,
      children
    });
    $2[8] = BaseComponent;
    $2[9] = align;
    $2[10] = children;
    $2[11] = rest;
    $2[12] = role;
    $2[13] = scope;
    $2[14] = t1;
    $2[15] = t2;
  } else {
    t2 = $2[15];
  }
  return t2;
}
function TableCellPlaceholder(t0) {
  const $2 = distExports.c(2);
  const {
    children
  } = t0;
  let t1;
  if ($2[0] !== children) {
    t1 = /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, {
      color: "fg.subtle",
      children
    });
    $2[0] = children;
    $2[1] = t1;
  } else {
    t1 = $2[1];
  }
  return t1;
}
function TableContainer$1(t0) {
  const $2 = distExports.c(10);
  let children;
  let className;
  let rest;
  if ($2[0] !== t0) {
    ({
      children,
      className,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = className;
    $2[3] = rest;
  } else {
    children = $2[1];
    className = $2[2];
    rest = $2[3];
  }
  let t1;
  if ($2[4] !== className) {
    t1 = clsx(className, classes$2.TableContainer);
    $2[4] = className;
    $2[5] = t1;
  } else {
    t1 = $2[5];
  }
  let t2;
  if ($2[6] !== children || $2[7] !== rest || $2[8] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(BoxWithFallback, {
      ...rest,
      className: t1,
      children
    });
    $2[6] = children;
    $2[7] = rest;
    $2[8] = t1;
    $2[9] = t2;
  } else {
    t2 = $2[9];
  }
  return t2;
}
const TableTitle = /* @__PURE__ */ React__default.forwardRef(function TableTitle2(t0, ref2) {
  const $2 = distExports.c(6);
  const {
    as: t1,
    children,
    id
  } = t0;
  const Component2 = t1 === void 0 ? "h2" : t1;
  const BaseComponent = Component2;
  let t2;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = clsx("TableTitle", classes$2.TableTitle);
    $2[0] = t2;
  } else {
    t2 = $2[0];
  }
  let t3;
  if ($2[1] !== BaseComponent || $2[2] !== children || $2[3] !== id || $2[4] !== ref2) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx(BaseComponent, {
      className: t2,
      id,
      ref: ref2,
      children
    });
    $2[1] = BaseComponent;
    $2[2] = children;
    $2[3] = id;
    $2[4] = ref2;
    $2[5] = t3;
  } else {
    t3 = $2[5];
  }
  return t3;
});
function TableSubtitle(t0) {
  const $2 = distExports.c(5);
  const {
    as: t1,
    children,
    id
  } = t0;
  const BaseComponent = t1 === void 0 ? "div" : t1;
  let t2;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = clsx("TableSubtitle", classes$2.TableSubtitle);
    $2[0] = t2;
  } else {
    t2 = $2[0];
  }
  let t3;
  if ($2[1] !== BaseComponent || $2[2] !== children || $2[3] !== id) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx(BaseComponent, {
      className: t2,
      id,
      children
    });
    $2[1] = BaseComponent;
    $2[2] = children;
    $2[3] = id;
    $2[4] = t3;
  } else {
    t3 = $2[4];
  }
  return t3;
}
function TableDivider() {
  const $2 = distExports.c(1);
  let t0;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: clsx("TableDivider", classes$2.TableDivider),
      role: "presentation"
    });
    $2[0] = t0;
  } else {
    t0 = $2[0];
  }
  return t0;
}
function TableActions(t0) {
  const $2 = distExports.c(3);
  const {
    children
  } = t0;
  let t1;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx("TableActions", classes$2.TableActions);
    $2[0] = t1;
  } else {
    t1 = $2[0];
  }
  let t2;
  if ($2[1] !== children) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: t1,
      children
    });
    $2[1] = children;
    $2[2] = t2;
  } else {
    t2 = $2[2];
  }
  return t2;
}
function TableSkeleton(t0) {
  const $2 = distExports.c(20);
  let cellPadding;
  let columns;
  let rest;
  let t1;
  if ($2[0] !== t0) {
    ({
      cellPadding,
      columns,
      rows: t1,
      ...rest
    } = t0);
    $2[0] = t0;
    $2[1] = cellPadding;
    $2[2] = columns;
    $2[3] = rest;
    $2[4] = t1;
  } else {
    cellPadding = $2[1];
    columns = $2[2];
    rest = $2[3];
    t1 = $2[4];
  }
  const rows = t1 === void 0 ? 10 : t1;
  const {
    gridTemplateColumns: gridTemplateColumns2
  } = useTableLayout(columns);
  let t2;
  if ($2[5] !== columns) {
    t2 = Array.isArray(columns) ? columns.map(_temp) : null;
    $2[5] = columns;
    $2[6] = t2;
  } else {
    t2 = $2[6];
  }
  let t3;
  if ($2[7] !== t2) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx(TableHead, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(TableRow$1, {
        children: t2
      })
    });
    $2[7] = t2;
    $2[8] = t3;
  } else {
    t3 = $2[8];
  }
  let t4;
  if ($2[9] !== columns.length) {
    t4 = Array.from({
      length: columns.length
    });
    $2[9] = columns.length;
    $2[10] = t4;
  } else {
    t4 = $2[10];
  }
  let t5;
  if ($2[11] !== rows || $2[12] !== t4) {
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsx(TableBody, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(TableRow$1, {
        children: t4.map((_2, i_0) => /* @__PURE__ */ jsxRuntimeExports.jsxs(TableCell$1, {
          className: clsx("TableCellSkeleton", classes$2.TableCellSkeleton),
          children: [/* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden, {
            children: "Loading"
          }), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
            className: clsx("TableCellSkeletonItems", classes$2.TableCellSkeletonItems),
            children: Array.from({
              length: rows
            }).map(_temp2)
          })]
        }, i_0))
      })
    });
    $2[11] = rows;
    $2[12] = t4;
    $2[13] = t5;
  } else {
    t5 = $2[13];
  }
  let t6;
  if ($2[14] !== cellPadding || $2[15] !== gridTemplateColumns2 || $2[16] !== rest || $2[17] !== t3 || $2[18] !== t5) {
    t6 = /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$2, {
      ...rest,
      cellPadding,
      gridTemplateColumns: gridTemplateColumns2,
      children: [t3, t5]
    });
    $2[14] = cellPadding;
    $2[15] = gridTemplateColumns2;
    $2[16] = rest;
    $2[17] = t3;
    $2[18] = t5;
    $2[19] = t6;
  } else {
    t6 = $2[19];
  }
  return t6;
}
function _temp2(__0, i_1) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    className: clsx("TableCellSkeletonItem", classes$2.TableCellSkeletonItem),
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(SkeletonText, {})
  }, i_1);
}
_temp2.displayName = "_temp2";
function _temp(column2, i) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TableHeader$1, {
    children: typeof column2.header === "string" ? column2.header : column2.header()
  }, i);
}
_temp.displayName = "_temp";
const LiveRegionContext = /* @__PURE__ */ React__default.createContext(null);
function useLiveRegion() {
  const context = React__default.useContext(LiveRegionContext);
  if (!context) {
    throw new Error("useLiveRegion() must be used within a <LiveRegion>");
  }
  return context;
}
function LiveRegion(t0) {
  const $2 = distExports.c(5);
  const {
    children
  } = t0;
  const [message2, setMessage] = React__default.useState("");
  let t1;
  let t2;
  if ($2[0] !== message2) {
    t2 = {
      announce: setMessage,
      message: message2
    };
    $2[0] = message2;
    $2[1] = t2;
  } else {
    t2 = $2[1];
  }
  t1 = t2;
  const value = t1;
  let t3;
  if ($2[2] !== children || $2[3] !== value) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx(LiveRegionContext.Provider, {
      value,
      children
    });
    $2[2] = children;
    $2[3] = value;
    $2[4] = t3;
  } else {
    t3 = $2[4];
  }
  return t3;
}
function LiveRegionOutlet() {
  const $2 = distExports.c(2);
  const liveRegion = useLiveRegion();
  let t0;
  if ($2[0] !== liveRegion.message) {
    t0 = /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, {
      role: "status",
      "aria-live": "polite",
      "aria-atomic": true,
      children: liveRegion.message
    });
    $2[0] = liveRegion.message;
    $2[1] = t0;
  } else {
    t0 = $2[1];
  }
  return t0;
}
function Message(t0) {
  const $2 = distExports.c(8);
  const {
    value
  } = t0;
  const liveRegion = useLiveRegion();
  const savedLiveRegion = React__default.useRef(liveRegion);
  const committedRef = React__default.useRef(false);
  let t1;
  let t2;
  if ($2[0] !== liveRegion) {
    t1 = () => {
      savedLiveRegion.current = liveRegion;
    };
    t2 = [liveRegion];
    $2[0] = liveRegion;
    $2[1] = t1;
    $2[2] = t2;
  } else {
    t1 = $2[1];
    t2 = $2[2];
  }
  React__default.useEffect(t1, t2);
  let t3;
  let t4;
  if ($2[3] !== value) {
    t3 = () => {
      if (committedRef.current !== true) {
        return;
      }
      const timeoutId = setTimeout(() => {
        savedLiveRegion.current.announce(value);
      }, 750);
      return () => {
        clearTimeout(timeoutId);
      };
    };
    t4 = [value];
    $2[3] = value;
    $2[4] = t3;
    $2[5] = t4;
  } else {
    t3 = $2[4];
    t4 = $2[5];
  }
  React__default.useEffect(t3, t4);
  let t5;
  let t6;
  if ($2[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      committedRef.current = true;
      return () => {
        committedRef.current = false;
      };
    };
    t6 = [];
    $2[6] = t5;
    $2[7] = t6;
  } else {
    t5 = $2[6];
    t6 = $2[7];
  }
  React__default.useEffect(t5, t6);
  return null;
}
var classes$1 = { "TablePagination": "prc-DataTable-TablePagination-ZbY9p", "TablePaginationSteps": "prc-DataTable-TablePaginationSteps-Qqz6y", "TablePaginationRange": "prc-DataTable-TablePaginationRange-Kp7GT", "TablePaginationStep": "prc-DataTable-TablePaginationStep-0FsgZ", "TablePaginationAction": "prc-DataTable-TablePaginationAction-kKQK4", "TablePaginationPage": "prc-DataTable-TablePaginationPage-MQm-t", "TablePaginationTruncationStep": "prc-DataTable-TablePaginationTruncationStep-HEMTY" };
const defaultShowPages = {
  narrow: false
};
function Pagination({
  "aria-label": label,
  defaultPageIndex,
  id,
  onChange,
  pageSize = 25,
  showPages = defaultShowPages,
  totalCount
}) {
  const {
    pageIndex,
    pageStart,
    pageEnd,
    pageCount,
    hasPreviousPage,
    hasNextPage,
    selectPage,
    selectNextPage,
    selectPreviousPage
  } = usePagination({
    defaultPageIndex,
    onChange,
    pageSize,
    totalCount
  });
  const getViewportRangesToHidePages = useCallback$1(() => {
    if (typeof showPages !== "boolean") {
      return Object.keys(showPages).filter((key2) => !showPages[key2]);
    }
    if (showPages) {
      return [];
    } else {
      return Object.keys(viewportRanges);
    }
  }, [showPages]);
  const model = useMemo$1(() => {
    return buildPaginationModel(pageCount, pageIndex + 1, !!showPages, 1, 2);
  }, [pageCount, pageIndex, showPages]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(LiveRegion, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(LiveRegionOutlet, {}), /* @__PURE__ */ jsxRuntimeExports.jsxs("nav", {
      "aria-label": label,
      className: clsx("TablePagination", classes$1.TablePagination),
      id,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Range, {
        pageStart,
        pageEnd,
        totalCount
      }), /* @__PURE__ */ jsxRuntimeExports.jsxs("ol", {
        className: clsx("TablePaginationSteps", classes$1.TablePaginationSteps),
        "data-hidden-viewport-ranges": getViewportRangesToHidePages().join(" "),
        children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Step$1, {
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Button, {
            className: clsx("TablePaginationAction", classes$1.TablePaginationAction),
            type: "button",
            "data-has-page": hasPreviousPage ? true : void 0,
            "aria-disabled": !hasPreviousPage ? true : void 0,
            onClick: () => {
              if (!hasPreviousPage) {
                return;
              }
              selectPreviousPage();
            },
            children: [hasPreviousPage ? /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronLeftIcon, {}) : null, /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
              children: "Previous"
            }), /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, {
              children: " page"
            })]
          })
        }), model.map((page, i) => {
          if (page.type === "BREAK") {
            return /* @__PURE__ */ jsxRuntimeExports.jsx(TruncationStep, {}, `truncation-${i}`);
          } else if (page.type === "NUM") {
            return /* @__PURE__ */ jsxRuntimeExports.jsx(Step$1, {
              children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Page, {
                active: !!page.selected,
                onClick: () => {
                  selectPage(page.num - 1);
                },
                children: [page.num, page.precedesBreak ? /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, {
                  children: "…"
                }) : null]
              })
            }, i);
          }
        }), /* @__PURE__ */ jsxRuntimeExports.jsx(Step$1, {
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Button, {
            className: clsx("TablePaginationAction", classes$1.TablePaginationAction),
            type: "button",
            "data-has-page": hasNextPage ? true : void 0,
            "aria-disabled": !hasNextPage ? true : void 0,
            onClick: () => {
              if (!hasNextPage) {
                return;
              }
              selectNextPage();
            },
            children: [/* @__PURE__ */ jsxRuntimeExports.jsx("span", {
              children: "Next"
            }), /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, {
              children: " page"
            }), hasNextPage ? /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronRightIcon, {}) : null]
          })
        })]
      })]
    })]
  });
}
Pagination.displayName = "Pagination";
function Range(t0) {
  const $2 = distExports.c(12);
  const {
    pageStart,
    pageEnd,
    totalCount
  } = t0;
  const start4 = pageStart + 1;
  const end2 = pageEnd;
  const t1 = `Showing ${start4} through ${end2} of ${totalCount}`;
  let t2;
  if ($2[0] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(Message, {
      value: t1
    });
    $2[0] = t1;
    $2[1] = t2;
  } else {
    t2 = $2[1];
  }
  let t3;
  if ($2[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = clsx("TablePaginationRange", classes$1.TablePaginationRange);
    $2[2] = t3;
  } else {
    t3 = $2[2];
  }
  let t4;
  let t5;
  if ($2[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, {
      children: " through "
    });
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      "aria-hidden": "true",
      children: "‒"
    });
    $2[3] = t4;
    $2[4] = t5;
  } else {
    t4 = $2[3];
    t5 = $2[4];
  }
  let t6;
  if ($2[5] !== end2 || $2[6] !== start4 || $2[7] !== totalCount) {
    t6 = /* @__PURE__ */ jsxRuntimeExports.jsxs("p", {
      className: t3,
      children: [start4, t4, t5, end2, " of ", totalCount]
    });
    $2[5] = end2;
    $2[6] = start4;
    $2[7] = totalCount;
    $2[8] = t6;
  } else {
    t6 = $2[8];
  }
  let t7;
  if ($2[9] !== t2 || $2[10] !== t6) {
    t7 = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
      children: [t2, t6]
    });
    $2[9] = t2;
    $2[10] = t6;
    $2[11] = t7;
  } else {
    t7 = $2[11];
  }
  return t7;
}
function TruncationStep() {
  const $2 = distExports.c(1);
  let t0;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /* @__PURE__ */ jsxRuntimeExports.jsx("li", {
      "aria-hidden": "true",
      className: clsx("TablePaginationTruncationStep", classes$1.TablePaginationTruncationStep),
      children: "…"
    });
    $2[0] = t0;
  } else {
    t0 = $2[0];
  }
  return t0;
}
function Step$1(t0) {
  const $2 = distExports.c(3);
  const {
    children
  } = t0;
  let t1;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx("TablePaginationStep", classes$1.TablePaginationStep);
    $2[0] = t1;
  } else {
    t1 = $2[0];
  }
  let t2;
  if ($2[1] !== children) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx("li", {
      className: t1,
      children
    });
    $2[1] = children;
    $2[2] = t2;
  } else {
    t2 = $2[2];
  }
  return t2;
}
function Page(t0) {
  const $2 = distExports.c(7);
  const {
    active,
    children,
    onClick
  } = t0;
  let t1;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx("TablePaginationPage", classes$1.TablePaginationPage);
    $2[0] = t1;
  } else {
    t1 = $2[0];
  }
  const t2 = active ? true : void 0;
  const t3 = active ? true : void 0;
  let t4;
  if ($2[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, {
      children: "Page "
    });
    $2[1] = t4;
  } else {
    t4 = $2[1];
  }
  let t5;
  if ($2[2] !== children || $2[3] !== onClick || $2[4] !== t2 || $2[5] !== t3) {
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsxs(Button, {
      className: t1,
      type: "button",
      "data-active": t2,
      "aria-current": t3,
      onClick,
      children: [t4, children]
    });
    $2[2] = children;
    $2[3] = onClick;
    $2[4] = t2;
    $2[5] = t3;
    $2[6] = t5;
  } else {
    t5 = $2[6];
  }
  return t5;
}
function usePagination(config2) {
  const $2 = distExports.c(24);
  const {
    defaultPageIndex,
    onChange,
    pageSize,
    totalCount
  } = config2;
  const pageCount = Math.ceil(totalCount / pageSize);
  let t0;
  if ($2[0] !== defaultPageIndex || $2[1] !== pageCount) {
    t0 = () => {
      if (defaultPageIndex !== void 0) {
        if (defaultPageIndex >= 0 && defaultPageIndex < pageCount) {
          return defaultPageIndex;
        }
        process.env.NODE_ENV !== "production" ? warning2(true, "<Pagination> expected `defaultPageIndex` to be less than the total number of pages. Instead, received a `defaultPageIndex` of %s with %s total pages.", defaultPageIndex, pageCount) : void 0;
      }
      return 0;
    };
    $2[0] = defaultPageIndex;
    $2[1] = pageCount;
    $2[2] = t0;
  } else {
    t0 = $2[2];
  }
  const [defaultIndex, setDefaultIndex] = useState(t0);
  const [pageIndex, setPageIndex] = useState(defaultIndex);
  const validDefaultPageCount = defaultPageIndex !== void 0 && defaultPageIndex >= 0 && defaultPageIndex < pageCount;
  if (validDefaultPageCount && defaultIndex !== defaultPageIndex) {
    setDefaultIndex(defaultPageIndex);
    setPageIndex(defaultPageIndex);
    onChange === null || onChange === void 0 ? void 0 : onChange({
      pageIndex: defaultPageIndex
    });
  }
  const pageStart = pageIndex * pageSize;
  const pageEnd = Math.min((pageIndex + 1) * pageSize, totalCount);
  const hasNextPage = pageIndex + 1 < pageCount;
  const hasPreviousPage = pageIndex > 0;
  let t1;
  if ($2[3] !== onChange || $2[4] !== pageIndex) {
    t1 = function selectPage2(newPageIndex) {
      if (pageIndex !== newPageIndex) {
        setPageIndex(newPageIndex);
        onChange === null || onChange === void 0 ? void 0 : onChange({
          pageIndex: newPageIndex
        });
      }
    };
    $2[3] = onChange;
    $2[4] = pageIndex;
    $2[5] = t1;
  } else {
    t1 = $2[5];
  }
  const selectPage = t1;
  let t2;
  if ($2[6] !== hasPreviousPage || $2[7] !== pageIndex || $2[8] !== selectPage) {
    t2 = function selectPreviousPage2() {
      if (hasPreviousPage) {
        selectPage(pageIndex - 1);
      }
    };
    $2[6] = hasPreviousPage;
    $2[7] = pageIndex;
    $2[8] = selectPage;
    $2[9] = t2;
  } else {
    t2 = $2[9];
  }
  const selectPreviousPage = t2;
  let t3;
  if ($2[10] !== hasNextPage || $2[11] !== pageIndex || $2[12] !== selectPage) {
    t3 = function selectNextPage2() {
      if (hasNextPage) {
        selectPage(pageIndex + 1);
      }
    };
    $2[10] = hasNextPage;
    $2[11] = pageIndex;
    $2[12] = selectPage;
    $2[13] = t3;
  } else {
    t3 = $2[13];
  }
  const selectNextPage = t3;
  let t4;
  if ($2[14] !== hasNextPage || $2[15] !== hasPreviousPage || $2[16] !== pageCount || $2[17] !== pageEnd || $2[18] !== pageIndex || $2[19] !== pageStart || $2[20] !== selectNextPage || $2[21] !== selectPage || $2[22] !== selectPreviousPage) {
    t4 = {
      pageIndex,
      pageStart,
      pageEnd,
      pageCount,
      hasNextPage,
      hasPreviousPage,
      selectPage,
      selectPreviousPage,
      selectNextPage
    };
    $2[14] = hasNextPage;
    $2[15] = hasPreviousPage;
    $2[16] = pageCount;
    $2[17] = pageEnd;
    $2[18] = pageIndex;
    $2[19] = pageStart;
    $2[20] = selectNextPage;
    $2[21] = selectPage;
    $2[22] = selectPreviousPage;
    $2[23] = t4;
  } else {
    t4 = $2[23];
  }
  return t4;
}
const Table$1 = Object.assign(Table$2, {
  Container: TableContainer$1,
  Title: TableTitle,
  Subtitle: TableSubtitle,
  Actions: TableActions,
  Divider: TableDivider,
  Skeleton: TableSkeleton,
  Head: TableHead,
  Body: TableBody,
  Header: TableHeader$1,
  Row: TableRow$1,
  Cell: TableCell$1,
  CellPlaceholder: TableCellPlaceholder,
  Pagination,
  ErrorDialog
});
var classes = { "Overlay": "prc-SelectPanel2-Overlay-ZMksW", "Form": "prc-SelectPanel2-Form-lMUVZ", "Container": "prc-SelectPanel2-Container-Vl6-E", "HeaderContent": "prc-SelectPanel2-HeaderContent-eO40v", "TitleWrapper": "prc-SelectPanel2-TitleWrapper-aGk1d", "TextInput": "prc-SelectPanel2-TextInput--jmMP", "Checkbox": "prc-SelectPanel2-Checkbox-xomBK", "FlexBox": "prc-SelectPanel2-FlexBox-tWKl9", "Title": "prc-SelectPanel2-Title-apmeG", "Description": "prc-SelectPanel2-Description-va-gM", "ClearAction": "prc-SelectPanel2-ClearAction-AQbaB", "Footer": "prc-SelectPanel2-Footer-fHAYu", "FooterContent": "prc-SelectPanel2-FooterContent-CPvyu", "FooterActions": "prc-SelectPanel2-FooterActions-l17C5", "SecondaryCheckbox": "prc-SelectPanel2-SecondaryCheckbox-MV5My", "SmallText": "prc-SelectPanel2-SmallText-qwyN0", "SelectPanelLoading": "prc-SelectPanel2-SelectPanelLoading-JO-Ac", "LoadingText": "prc-SelectPanel2-LoadingText-LSSZI", "MessageFull": "prc-SelectPanel2-MessageFull-qnkev", "Octicon": "prc-SelectPanel2-Octicon-huKe9", "Error": "prc-SelectPanel2-Error-xuHY6", "Warning": "prc-SelectPanel2-Warning-f9ypV", "MessageTitle": "prc-SelectPanel2-MessageTitle-xZZN5", "MessageContent": "prc-SelectPanel2-MessageContent-SydzC", "MessageInline": "prc-SelectPanel2-MessageInline-KBMXw", "Header": "prc-SelectPanel2-Header-e7A2e" };
const SelectPanelContext = /* @__PURE__ */ React__default.createContext({
  title: "",
  description: void 0,
  panelId: "",
  onCancel: () => {
  },
  onClearSelection: void 0,
  searchQuery: "",
  setSearchQuery: () => {
  },
  selectionVariant: "multiple",
  moveFocusToList: () => {
  }
});
const responsiveButtonSizes = {
  narrow: "medium",
  regular: "small"
};
const Panel = ({
  title,
  description,
  variant: propsVariant,
  selectionVariant = "multiple",
  id,
  defaultOpen = false,
  open: propsOpen,
  anchorRef: providedAnchorRef,
  anchoredPositionSettings,
  onCancel: propsOnCancel,
  onClearSelection: propsOnClearSelection,
  onSubmit: propsOnSubmit,
  width: width2 = "medium",
  maxHeight: maxHeight2 = "large",
  className,
  ...props
}) => {
  var _position$top, _position$left, _slots$header;
  const [internalOpen, setInternalOpen] = React__default.useState(defaultOpen);
  const responsiveVariants = Object.assign(
    {
      regular: "anchored",
      narrow: "full-screen"
    },
    // defaults
    typeof propsVariant === "string" ? {
      regular: propsVariant
    } : propsVariant
  );
  const currentVariant = useResponsiveValue(responsiveVariants, "anchored");
  if (propsOpen !== void 0 && internalOpen !== propsOpen) setInternalOpen(propsOpen);
  let Anchor2;
  const anchorRef = useProvidedRefOrCreate(providedAnchorRef);
  const onAnchorClick = () => {
    if (!internalOpen) setInternalOpen(true);
    else onInternalCancel();
  };
  const contents = React__default.Children.map(props.children, (child) => {
    if (/* @__PURE__ */ React__default.isValidElement(child) && child.type === SelectPanelButton) {
      Anchor2 = /* @__PURE__ */ React__default.cloneElement(child, {
        // @ts-ignore TODO
        ref: anchorRef,
        onClick: child.props.onClick || onAnchorClick,
        "aria-haspopup": true,
        "aria-expanded": internalOpen
      });
      return null;
    }
    return child;
  });
  const onInternalClose = React__default.useCallback(() => {
    if (internalOpen === false) return;
    if (propsOpen === void 0) setInternalOpen(false);
  }, [internalOpen, propsOpen]);
  const onInternalCancel = React__default.useCallback(() => {
    onInternalClose();
    if (typeof propsOnCancel === "function") propsOnCancel();
  }, [onInternalClose, propsOnCancel]);
  const onInternalSubmit = (event) => {
    event === null || event === void 0 ? void 0 : event.preventDefault();
    onInternalClose();
    if (typeof propsOnSubmit === "function") propsOnSubmit(event);
  };
  const onInternalClearSelection = () => {
    if (typeof propsOnClearSelection === "function") propsOnClearSelection();
  };
  const internalAfterSelect = (event_0) => {
    if (selectionVariant === "instant") onInternalSubmit();
    if (event_0.type === "keypress") {
      if (event_0.key === "Enter") onInternalSubmit();
    }
  };
  const [searchQuery, setSearchQuery] = React__default.useState("");
  const panelId = useId(id);
  const [slots, childrenInBody] = useSlots(contents, {
    header: SelectPanelHeader,
    footer: SelectPanelFooter
  });
  const moveFocusToList = () => {
    var _dialogRef$current;
    const selector2 = "ul[role=listbox] li:not([role=none])";
    const firstListElement = (_dialogRef$current = dialogRef.current) === null || _dialogRef$current === void 0 ? void 0 : _dialogRef$current.querySelector(selector2);
    firstListElement === null || firstListElement === void 0 ? void 0 : firstListElement.focus();
  };
  const dialogRef = React__default.useRef(null);
  React__default.useEffect(() => {
    var _dialogRef$current2, _dialogRef$current3;
    if (internalOpen) (_dialogRef$current2 = dialogRef.current) === null || _dialogRef$current2 === void 0 ? void 0 : _dialogRef$current2.showModal();
    else if ((_dialogRef$current3 = dialogRef.current) !== null && _dialogRef$current3 !== void 0 && _dialogRef$current3.open) dialogRef.current.close();
  }, [internalOpen]);
  React__default.useEffect(() => {
    const dialogEl = dialogRef.current;
    dialogEl === null || dialogEl === void 0 ? void 0 : dialogEl.addEventListener("close", onInternalClose);
    return () => dialogEl === null || dialogEl === void 0 ? void 0 : dialogEl.removeEventListener("close", onInternalClose);
  }, [onInternalClose]);
  React__default.useEffect(() => {
    const dialogEl_0 = dialogRef.current;
    const handler = (event_1) => {
      if (event_1.key === "Escape") onInternalCancel();
    };
    dialogEl_0 === null || dialogEl_0 === void 0 ? void 0 : dialogEl_0.addEventListener("keydown", handler);
    return () => dialogEl_0 === null || dialogEl_0 === void 0 ? void 0 : dialogEl_0.removeEventListener("keydown", handler);
  }, [onInternalCancel]);
  React__default.useEffect(function initialFocus() {
    if (internalOpen) {
      const searchInput = document.querySelector("dialog[open] input");
      if (searchInput) searchInput.focus();
      else moveFocusToList();
    }
  }, [internalOpen]);
  const {
    position: position4
  } = useAnchoredPosition({
    anchorElementRef: anchorRef,
    floatingElementRef: dialogRef,
    side: "outside-bottom",
    align: "start",
    ...anchoredPositionSettings
  }, [internalOpen, anchorRef.current, dialogRef.current]);
  const onClickOutside = onInternalCancel;
  let maxHeightValue = heightMap[maxHeight2];
  if (currentVariant === "bottom-sheet") {
    maxHeightValue = "calc(100vh - 64px)";
  } else if (currentVariant === "full-screen") {
    maxHeightValue = "100vh";
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [Anchor2, /* @__PURE__ */ jsxRuntimeExports.jsx(BaseOverlay, {
      as: "dialog",
      ref: dialogRef,
      "aria-labelledby": `${panelId}--title`,
      "aria-describedby": description ? `${panelId}--description` : void 0,
      width: width2,
      height: "fit-content",
      maxHeight: maxHeight2,
      "data-variant": currentVariant,
      style: {
        "--max-height": maxHeightValue,
        "--position-top": `${(_position$top = position4 === null || position4 === void 0 ? void 0 : position4.top) !== null && _position$top !== void 0 ? _position$top : 0}px`,
        "--position-left": `${(_position$left = position4 === null || position4 === void 0 ? void 0 : position4.left) !== null && _position$left !== void 0 ? _position$left : 0}px`,
        visibility: internalOpen ? "visible" : "hidden",
        display: "flex"
      },
      className: clsx(classes.Overlay, className),
      ...props,
      onClick: (event_2) => {
        if (event_2.target === event_2.currentTarget) onClickOutside();
      },
      children: internalOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(SelectPanelContext.Provider, {
          value: {
            panelId,
            title,
            description,
            onCancel: onInternalCancel,
            onClearSelection: propsOnClearSelection ? onInternalClearSelection : void 0,
            searchQuery,
            setSearchQuery,
            selectionVariant,
            moveFocusToList
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs("form", {
            method: "dialog",
            onSubmit: onInternalSubmit,
            className: classes.Form,
            children: [(_slots$header = slots.header) !== null && _slots$header !== void 0 ? _slots$header : (
              /* render default header as fallback */
              /* @__PURE__ */ jsxRuntimeExports.jsx(SelectPanelHeader, {})
            ), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
              className: classes.Container,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionListContainerContext.Provider, {
                value: {
                  container: "SelectPanel",
                  listRole: "listbox",
                  selectionAttribute: "aria-selected",
                  selectionVariant: selectionVariant === "instant" ? "single" : selectionVariant,
                  afterSelect: internalAfterSelect,
                  listLabelledBy: `${panelId}--title`,
                  enableFocusZone: true
                  // Arrow keys navigation for list items
                },
                children: childrenInBody
              })
            }), slots.footer]
          })
        })
      })
    })]
  });
};
const SelectPanelButton = /* @__PURE__ */ React__default.forwardRef((props, anchorRef) => {
  const inputProps = useFormControlForwardedProps(props);
  const [labelText, setLabelText] = useState("");
  useEffect(() => {
    const label = document.querySelector(`[for='${inputProps.id}']`);
    if (label !== null && label !== void 0 && label.textContent) {
      setLabelText(label.textContent);
    }
  }, [inputProps.id]);
  if (labelText) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
      ref: anchorRef,
      "aria-label": `${anchorRef.current.textContent}, ${labelText}`,
      ...inputProps
    });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
      ref: anchorRef,
      ...props
    });
  }
});
const SelectPanelHeader = (t0) => {
  const $2 = distExports.c(42);
  let children;
  let className;
  let onBack;
  let props;
  if ($2[0] !== t0) {
    ({
      children,
      onBack,
      className,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = className;
    $2[3] = onBack;
    $2[4] = props;
  } else {
    children = $2[1];
    className = $2[2];
    onBack = $2[3];
    props = $2[4];
  }
  let t1;
  if ($2[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      searchInput: SelectPanelSearchInput
    };
    $2[5] = t1;
  } else {
    t1 = $2[5];
  }
  const [slots, childrenWithoutSlots] = useSlots(children, t1);
  const {
    title,
    description,
    panelId,
    onCancel,
    onClearSelection
  } = React__default.useContext(SelectPanelContext);
  let t2;
  if ($2[6] !== className) {
    t2 = clsx(classes.Header, className);
    $2[6] = className;
    $2[7] = t2;
  } else {
    t2 = $2[7];
  }
  const t3 = description ? true : void 0;
  const t4 = slots.searchInput ? true : void 0;
  let t5;
  if ($2[8] !== onBack) {
    t5 = onBack ? /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, {
      type: "button",
      variant: "invisible",
      icon: ArrowLeftIcon,
      "aria-label": "Back",
      onClick: () => onBack()
    }) : null;
    $2[8] = onBack;
    $2[9] = t5;
  } else {
    t5 = $2[9];
  }
  const t6 = description ? true : void 0;
  const t7 = onBack ? true : void 0;
  const t8 = `${panelId}--title`;
  let t9;
  if ($2[10] !== t8 || $2[11] !== title) {
    t9 = /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$4, {
      as: "h1",
      id: t8,
      className: classes.Title,
      children: title
    });
    $2[10] = t8;
    $2[11] = title;
    $2[12] = t9;
  } else {
    t9 = $2[12];
  }
  let t10;
  if ($2[13] !== description || $2[14] !== panelId) {
    t10 = description ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      id: `${panelId}--description`,
      className: classes.Description,
      children: description
    }) : null;
    $2[13] = description;
    $2[14] = panelId;
    $2[15] = t10;
  } else {
    t10 = $2[15];
  }
  let t11;
  if ($2[16] !== t10 || $2[17] !== t6 || $2[18] !== t7 || $2[19] !== t9) {
    t11 = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      className: classes.TitleWrapper,
      "data-description": t6,
      "data-on-back": t7,
      children: [t9, t10]
    });
    $2[16] = t10;
    $2[17] = t6;
    $2[18] = t7;
    $2[19] = t9;
    $2[20] = t11;
  } else {
    t11 = $2[20];
  }
  let t12;
  if ($2[21] !== t11 || $2[22] !== t5) {
    t12 = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      className: classes.FlexBox,
      children: [t5, t11]
    });
    $2[21] = t11;
    $2[22] = t5;
    $2[23] = t12;
  } else {
    t12 = $2[23];
  }
  let t13;
  if ($2[24] !== onClearSelection) {
    t13 = onClearSelection ? /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, {
      type: "button",
      variant: "invisible",
      icon: FilterRemoveIcon,
      "aria-label": "Clear selection",
      onClick: onClearSelection
    }) : null;
    $2[24] = onClearSelection;
    $2[25] = t13;
  } else {
    t13 = $2[25];
  }
  let t14;
  if ($2[26] !== onCancel) {
    t14 = /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, {
      type: "button",
      variant: "invisible",
      icon: XIcon,
      "aria-label": "Close",
      onClick: () => onCancel()
    });
    $2[26] = onCancel;
    $2[27] = t14;
  } else {
    t14 = $2[27];
  }
  let t15;
  if ($2[28] !== t13 || $2[29] !== t14) {
    t15 = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      children: [t13, t14]
    });
    $2[28] = t13;
    $2[29] = t14;
    $2[30] = t15;
  } else {
    t15 = $2[30];
  }
  let t16;
  if ($2[31] !== t12 || $2[32] !== t15 || $2[33] !== t3 || $2[34] !== t4) {
    t16 = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      className: classes.HeaderContent,
      "data-description": t3,
      "data-search-input": t4,
      children: [t12, t15]
    });
    $2[31] = t12;
    $2[32] = t15;
    $2[33] = t3;
    $2[34] = t4;
    $2[35] = t16;
  } else {
    t16 = $2[35];
  }
  let t17;
  if ($2[36] !== childrenWithoutSlots || $2[37] !== props || $2[38] !== slots.searchInput || $2[39] !== t16 || $2[40] !== t2) {
    t17 = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      className: t2,
      ...props,
      children: [t16, slots.searchInput, childrenWithoutSlots]
    });
    $2[36] = childrenWithoutSlots;
    $2[37] = props;
    $2[38] = slots.searchInput;
    $2[39] = t16;
    $2[40] = t2;
    $2[41] = t17;
  } else {
    t17 = $2[41];
  }
  return t17;
};
const SelectPanelSearchInput = (t0) => {
  const $2 = distExports.c(22);
  let className;
  let props;
  let propsOnChange;
  let propsOnKeyDown;
  if ($2[0] !== t0) {
    ({
      onChange: propsOnChange,
      onKeyDown: propsOnKeyDown,
      className,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = props;
    $2[3] = propsOnChange;
    $2[4] = propsOnKeyDown;
  } else {
    className = $2[1];
    props = $2[2];
    propsOnChange = $2[3];
    propsOnKeyDown = $2[4];
  }
  let t1;
  if ($2[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /* @__PURE__ */ React__default.createRef();
    $2[5] = t1;
  } else {
    t1 = $2[5];
  }
  const inputRef = t1;
  const {
    setSearchQuery,
    moveFocusToList
  } = React__default.useContext(SelectPanelContext);
  let t2;
  if ($2[6] !== propsOnChange || $2[7] !== setSearchQuery) {
    t2 = (event) => {
      if (typeof propsOnChange === "function") {
        propsOnChange(event);
      } else {
        setSearchQuery(event.target.value);
      }
    };
    $2[6] = propsOnChange;
    $2[7] = setSearchQuery;
    $2[8] = t2;
  } else {
    t2 = $2[8];
  }
  const internalOnChange = t2;
  let t3;
  if ($2[9] !== moveFocusToList || $2[10] !== propsOnKeyDown) {
    t3 = (event_0) => {
      if (event_0.key === "ArrowDown") {
        event_0.preventDefault();
        moveFocusToList();
      }
      if (typeof propsOnKeyDown === "function") {
        propsOnKeyDown(event_0);
      }
    };
    $2[9] = moveFocusToList;
    $2[10] = propsOnKeyDown;
    $2[11] = t3;
  } else {
    t3 = $2[11];
  }
  const internalKeyDown = t3;
  let t4;
  if ($2[12] !== propsOnChange) {
    t4 = /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput$1.Action, {
      icon: XCircleFillIcon,
      "aria-label": "Clear",
      tooltipDirection: "w",
      className: classes.ClearAction,
      onClick: () => {
        if (inputRef.current) {
          inputRef.current.value = "";
        }
        if (typeof propsOnChange === "function") {
          propsOnChange({
            target: inputRef.current,
            currentTarget: inputRef.current
          });
        }
      }
    });
    $2[12] = propsOnChange;
    $2[13] = t4;
  } else {
    t4 = $2[13];
  }
  let t5;
  if ($2[14] !== className) {
    t5 = clsx(classes.TextInput, className);
    $2[14] = className;
    $2[15] = t5;
  } else {
    t5 = $2[15];
  }
  let t6;
  if ($2[16] !== internalKeyDown || $2[17] !== internalOnChange || $2[18] !== props || $2[19] !== t4 || $2[20] !== t5) {
    t6 = /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput$1, {
      ref: inputRef,
      block: true,
      leadingVisual: SearchIcon,
      placeholder: "Search",
      trailingAction: t4,
      className: t5,
      onChange: internalOnChange,
      onKeyDown: internalKeyDown,
      ...props
    });
    $2[16] = internalKeyDown;
    $2[17] = internalOnChange;
    $2[18] = props;
    $2[19] = t4;
    $2[20] = t5;
    $2[21] = t6;
  } else {
    t6 = $2[21];
  }
  return t6;
};
const FooterContext = /* @__PURE__ */ React__default.createContext(false);
const SelectPanelFooter = (t0) => {
  const $2 = distExports.c(13);
  let props;
  if ($2[0] !== t0) {
    ({
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = props;
  } else {
    props = $2[1];
  }
  const {
    onCancel,
    selectionVariant
  } = React__default.useContext(SelectPanelContext);
  const hidePrimaryActions = selectionVariant === "instant";
  const buttonSize = useResponsiveValue(responsiveButtonSizes, "small");
  if (hidePrimaryActions && !props.children) {
    return null;
  }
  const t1 = hidePrimaryActions || void 0;
  const t2 = hidePrimaryActions || void 0;
  let t3;
  if ($2[2] !== props.children || $2[3] !== t2) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: classes.FooterContent,
      "data-hide-primary-actions": t2,
      children: props.children
    });
    $2[2] = props.children;
    $2[3] = t2;
    $2[4] = t3;
  } else {
    t3 = $2[4];
  }
  let t4;
  if ($2[5] !== buttonSize || $2[6] !== hidePrimaryActions || $2[7] !== onCancel) {
    t4 = hidePrimaryActions ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      className: classes.FooterActions,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
        type: "button",
        size: buttonSize,
        onClick: () => onCancel(),
        children: "Cancel"
      }), /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
        type: "submit",
        size: buttonSize,
        variant: "primary",
        children: "Save"
      })]
    });
    $2[5] = buttonSize;
    $2[6] = hidePrimaryActions;
    $2[7] = onCancel;
    $2[8] = t4;
  } else {
    t4 = $2[8];
  }
  let t5;
  if ($2[9] !== t1 || $2[10] !== t3 || $2[11] !== t4) {
    t5 = /* @__PURE__ */ jsxRuntimeExports.jsx(FooterContext.Provider, {
      value: true,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
        className: classes.Footer,
        "data-hide-primary-actions": t1,
        children: [t3, t4]
      })
    });
    $2[9] = t1;
    $2[10] = t3;
    $2[11] = t4;
    $2[12] = t5;
  } else {
    t5 = $2[12];
  }
  return t5;
};
const SecondaryButton = (props) => {
  const $2 = distExports.c(3);
  const size2 = useResponsiveValue(responsiveButtonSizes, "small");
  let t0;
  if ($2[0] !== props || $2[1] !== size2) {
    t0 = /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
      type: "button",
      size: size2,
      block: true,
      ...props
    });
    $2[0] = props;
    $2[1] = size2;
    $2[2] = t0;
  } else {
    t0 = $2[2];
  }
  return t0;
};
const SecondaryLink = (t0) => {
  const $2 = distExports.c(9);
  let className;
  let props;
  if ($2[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = className;
    $2[2] = props;
  } else {
    className = $2[1];
    props = $2[2];
  }
  const size2 = useResponsiveValue(responsiveButtonSizes, "small");
  let t1;
  if ($2[3] !== className) {
    t1 = clsx(classes.SmallText, className);
    $2[3] = className;
    $2[4] = t1;
  } else {
    t1 = $2[4];
  }
  let t2;
  if ($2[5] !== props || $2[6] !== size2 || $2[7] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, {
      as: Link$1,
      size: size2,
      variant: "invisible",
      block: true,
      ...props,
      className: t1,
      children: props.children
    });
    $2[5] = props;
    $2[6] = size2;
    $2[7] = t1;
    $2[8] = t2;
  } else {
    t2 = $2[8];
  }
  return t2;
};
const SecondaryCheckbox = (t0) => {
  const $2 = distExports.c(17);
  let children;
  let className;
  let id;
  let props;
  if ($2[0] !== t0) {
    ({
      id,
      children,
      className,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = children;
    $2[2] = className;
    $2[3] = id;
    $2[4] = props;
  } else {
    children = $2[1];
    className = $2[2];
    id = $2[3];
    props = $2[4];
  }
  const checkboxId = useId(id);
  const {
    selectionVariant
  } = React__default.useContext(SelectPanelContext);
  !(selectionVariant !== "instant") ? process.env.NODE_ENV !== "production" ? invariant(false, 'Sorry! SelectPanel.SecondaryAction with variant="checkbox" is not allowed inside selectionVariant="instant"') : invariant(false) : void 0;
  let t1;
  if ($2[5] !== className) {
    t1 = clsx(classes.Checkbox, className);
    $2[5] = className;
    $2[6] = t1;
  } else {
    t1 = $2[6];
  }
  let t2;
  if ($2[7] !== checkboxId || $2[8] !== props || $2[9] !== t1) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$1, {
      id: checkboxId,
      className: t1,
      ...props
    });
    $2[7] = checkboxId;
    $2[8] = props;
    $2[9] = t1;
    $2[10] = t2;
  } else {
    t2 = $2[10];
  }
  let t3;
  if ($2[11] !== checkboxId || $2[12] !== children) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel, {
      htmlFor: checkboxId,
      className: classes.SmallText,
      children
    });
    $2[11] = checkboxId;
    $2[12] = children;
    $2[13] = t3;
  } else {
    t3 = $2[13];
  }
  let t4;
  if ($2[14] !== t2 || $2[15] !== t3) {
    t4 = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      className: classes.SecondaryCheckbox,
      children: [t2, t3]
    });
    $2[14] = t2;
    $2[15] = t3;
    $2[16] = t4;
  } else {
    t4 = $2[16];
  }
  return t4;
};
const SelectPanelSecondaryAction = (t0) => {
  const $2 = distExports.c(9);
  let props;
  let variant3;
  if ($2[0] !== t0) {
    ({
      variant: variant3,
      ...props
    } = t0);
    $2[0] = t0;
    $2[1] = props;
    $2[2] = variant3;
  } else {
    props = $2[1];
    variant3 = $2[2];
  }
  const insideFooter = React__default.useContext(FooterContext);
  !insideFooter ? process.env.NODE_ENV !== "production" ? invariant(false, "SelectPanel.SecondaryAction is only allowed inside SelectPanel.Footer") : invariant(false) : void 0;
  if (variant3 === "button") {
    let t1;
    if ($2[3] !== props) {
      t1 = /* @__PURE__ */ jsxRuntimeExports.jsx(SecondaryButton, {
        ...props
      });
      $2[3] = props;
      $2[4] = t1;
    } else {
      t1 = $2[4];
    }
    return t1;
  } else {
    if (variant3 === "link") {
      let t1;
      if ($2[5] !== props) {
        t1 = /* @__PURE__ */ jsxRuntimeExports.jsx(SecondaryLink, {
          ...props
        });
        $2[5] = props;
        $2[6] = t1;
      } else {
        t1 = $2[6];
      }
      return t1;
    } else {
      if (variant3 === "checkbox") {
        let t1;
        if ($2[7] !== props) {
          t1 = /* @__PURE__ */ jsxRuntimeExports.jsx(SecondaryCheckbox, {
            ...props
          });
          $2[7] = props;
          $2[8] = t1;
        } else {
          t1 = $2[8];
        }
        return t1;
      }
    }
  }
};
const SelectPanelLoading = (t0) => {
  const $2 = distExports.c(3);
  const {
    children: t1
  } = t0;
  const children = t1 === void 0 ? "Fetching items..." : t1;
  let t2;
  if ($2[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {
      size: "medium",
      srText: null
    });
    $2[0] = t2;
  } else {
    t2 = $2[0];
  }
  let t3;
  if ($2[1] !== children) {
    t3 = /* @__PURE__ */ jsxRuntimeExports.jsxs(AriaStatus, {
      announceOnShow: true,
      className: classes.SelectPanelLoading,
      children: [t2, /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: classes.LoadingText,
        children
      })]
    });
    $2[1] = children;
    $2[2] = t3;
  } else {
    t3 = $2[2];
  }
  return t3;
};
const SelectPanelMessage = ({
  variant: variant3 = "warning",
  size: size2 = variant3 === "empty" ? "full" : "inline",
  title,
  children
}) => {
  if (size2 === "full") {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      "aria-live": variant3 === "empty" ? void 0 : "polite",
      className: classes.MessageFull,
      children: [variant3 !== "empty" ? /* @__PURE__ */ jsxRuntimeExports.jsx(Octicon, {
        icon: AlertIcon,
        className: clsx(classes.Octicon, variant3 === "error" ? classes.Error : void 0, variant3 === "warning" ? classes.Warning : void 0)
      }) : null, /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: classes.MessageTitle,
        children: title
      }), /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: classes.MessageContent,
        children
      })]
    });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      "aria-live": variant3 === "empty" ? void 0 : "polite",
      className: classes.MessageInline,
      "data-variant": variant3,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon, {
        size: 16
      }), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
        children
      })]
    });
  }
};
const SelectPanel = Object.assign(Panel, {
  Button: SelectPanelButton,
  Header: SelectPanelHeader,
  SearchInput: SelectPanelSearchInput,
  Footer: SelectPanelFooter,
  Loading: SelectPanelLoading,
  Message: SelectPanelMessage,
  SecondaryAction: SelectPanelSecondaryAction
});
const TracksHeader$1 = ({
  isCollapsed,
  onCollapse
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", justify: "space-between", align: "center", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "condensed", align: "center", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(MilestoneIcon, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { weight: "semibold", size: "medium", children: "Tracks" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    IconButton,
    {
      variant: "invisible",
      size: "small",
      "aria-label": "Collapse",
      icon: !isCollapsed ? ChevronDownIcon : ChevronUpIcon,
      onClick: () => onCollapse(!isCollapsed)
    }
  )
] });
const TracksBlankPattern = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { bg: "canvas.inset", py: 3, px: 4, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TracksHeader$1, { isCollapsed, onCollapse: setIsCollapsed }),
    !isCollapsed && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { mt: 3, mb: 0 }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(BlankslateContainer, { size: "small", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(BlankslateContainer.Visual, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(MilestoneIcon, { size: "medium" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(BlankslateContainer.Heading, { children: "Tracks Unavailable" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(BlankslateContainer.Description, { children: "Registrations were created without tracks. To enable tracks, please delete all existing registrations." })
      ] })
    ] })
  ] });
};
const TrackCapacity = ({
  track: track2,
  tracks
}) => {
  const capacity = trackCapacity(track2, tracks);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$2, { size: "small", weight: "medium", sx: { color: "fg.muted" }, children: [
    "Registrations",
    " ",
    track2.numberBooked ? track2.numberBooked : 0,
    " / ",
    " ",
    (capacity == null ? void 0 : capacity.toString()) || "Unlimited"
  ] });
};
const TrackMenuItem = ({
  track: track2,
  tracks,
  onClick,
  overlayItems
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: track2.id
  });
  const style3 = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : void 0,
    transition,
    zIndex: isDragging ? 1 : void 0
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    ActionList.Item,
    {
      ref: setNodeRef,
      style: style3,
      onClick,
      active: isDragging,
      sx: { marginInline: "0 !important" },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", justify: "space-between", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Stack,
          {
            direction: "horizontal",
            gap: "condensed",
            align: "start",
            padding: "none",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "div",
                {
                  ...attributes,
                  ...listeners,
                  style: {
                    cursor: isDragging ? "grabbing" : "grab",
                    color: "fg.muted",
                    display: "flex",
                    alignItems: "center",
                    marginTop: "2px"
                  },
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(GrabberIcon, { size: "small" })
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "none", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: track2.name }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(TrackCapacity, { track: track2, tracks })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          AnchoredOverlay,
          {
            open: isMenuOpen,
            onOpen: () => setIsMenuOpen(true),
            onClose: () => setIsMenuOpen(false),
            renderAnchor: (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              IconButton,
              {
                ...props,
                icon: KebabHorizontalIcon,
                size: "small",
                "aria-label": "Track options",
                variant: "invisible",
                "aria-labelledby": void 0
              }
            ),
            side: "outside-right",
            align: "end",
            anchorOffset: 20,
            children: overlayItems({ closeMenu: () => setIsMenuOpen(false) })
          }
        )
      ] })
    }
  );
};
const GuestInviteInput = ({
  guestTrack,
  inviterTrack,
  maxInvites,
  onChange
}) => {
  const [value, setValue] = useState(
    guestInvitesFor(guestTrack, inviterTrack)
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TextInput$1,
    {
      type: "number",
      min: 0,
      max: maxInvites,
      block: true,
      value,
      onChange: (event) => {
        const valueAsNumber = parseInt(event.target.value, 10);
        if (isNaN(valueAsNumber)) {
          setValue(void 0);
        } else {
          setValue(valueAsNumber);
        }
        onChange(valueAsNumber);
      }
    }
  );
};
const MAX_GUEST_BOOKINGS = 10;
const GuestTrackInvites = ({
  guestTrack,
  onChange
}) => {
  const { data: tracks, error: error2 } = useTracks();
  const [guestInvites, dispatch] = useReducer(
    reducer$4,
    guestTrack.guestInvites || []
  );
  useEffect(() => {
    onChange(guestInvites);
  }, [guestInvites]);
  if (error2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { color: "danger.fg", children: "Error loading tracks" }) });
  }
  if (tracks === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {});
  }
  const handleInvitesChange = (track2, numberOfInvites) => {
    if (isNaN(numberOfInvites) || numberOfInvites === 0) {
      dispatch({ type: "remove_invite", inviterTrackId: track2.id });
    } else if (guestInvites.some((i) => idsEqual(i.inviterTrackId, track2.id))) {
      dispatch({
        type: "update_invite",
        inviterTrackId: track2.id,
        numberOfInvites
      });
    } else {
      dispatch({
        type: "add_invite",
        inviterTrackId: track2.id,
        numberOfInvites
      });
    }
  };
  const invitingTracks = getInvitingTracks(guestTrack, tracks);
  if (invitingTracks.length === 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { color: "attention.fg", children: "Please add at least one non-guest track to set guest invite options." }) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { direction: "vertical", gap: "normal", sx: { px: 4, width: "100%" }, children: getInvitingTracks(guestTrack, tracks).map((track2) => /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1.Label, { children: [
      track2.name,
      " Guests Limit"
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      GuestInviteInput,
      {
        guestTrack,
        inviterTrack: track2,
        maxInvites: MAX_GUEST_BOOKINGS,
        onChange: (value) => handleInvitesChange(track2, value)
      }
    )
  ] }, track2.id)) });
};
const DatePickerPrimer = ({
  selectedDate,
  onChange,
  isClearable = false,
  inputProps,
  placeholder: placeholder2,
  placeholderText,
  minDate,
  maxDate,
  onChangeRaw,
  showTimeSelect,
  onFocus,
  ...otherProps
}) => {
  const formatDateForInput = (date) => {
    if (!date) return "";
    if (showTimeSelect) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours2 = String(date.getHours()).padStart(2, "0");
      const minutes2 = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours2}:${minutes2}`;
    }
    return date.toISOString().split("T")[0];
  };
  const handleChange = (event) => {
    if (onChangeRaw) {
      onChangeRaw(event);
    }
    const value = event.target.value;
    if (value) {
      const date = new Date(value);
      onChange(date);
    } else if (isClearable) {
      onChange(void 0);
    }
  };
  const formatMinDate = minDate ? formatDateForInput(minDate) : void 0;
  const formatMaxDate = maxDate ? formatDateForInput(maxDate) : void 0;
  const finalPlaceholder = placeholder2 || placeholderText;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TextInput$1,
    {
      type: showTimeSelect ? "datetime-local" : "date",
      size: "large",
      block: true,
      value: formatDateForInput(selectedDate),
      onChange: handleChange,
      onFocus,
      placeholder: finalPlaceholder,
      min: formatMinDate,
      max: formatMaxDate,
      ...inputProps
    }
  );
};
const formatWithoutTz = "yyyy-MM-dd HH:mm:ss.SSS";
const zeroPad = (date) => String(Math.abs(date)).padStart(2, "0");
const plusOrMinus = (date) => date < 0 ? "-" : "+";
const utcOffSetMillisecondsToFormatString = (utcOffsetMs) => {
  const utcOffsetSeconds = utcOffsetMs / 1e3;
  const utcOffsetHours = utcOffsetSeconds / 3600;
  const utcOffsetMinutes = utcOffsetSeconds % 3600 / 60;
  return `${plusOrMinus(utcOffsetHours)}${zeroPad(utcOffsetHours)}:${zeroPad(
    utcOffsetMinutes
  )}`;
};
const setLocalZone = (date, timezone) => {
  const dateInZone = toZonedTime(date, timezone);
  const dateInZoneFormattedWithoutZone = format$2(dateInZone, formatWithoutTz);
  const localZone = format$2(
    parse$4(dateInZoneFormattedWithoutZone, formatWithoutTz, /* @__PURE__ */ new Date()),
    "X"
  );
  return new Date(dateInZoneFormattedWithoutZone + localZone);
};
const setOtherZone = (date, timezone) => {
  const dateWithoutZone = format$2(date, formatWithoutTz);
  const offset3 = getTimezoneOffset(timezone, date);
  const offsetFormatted = utcOffSetMillisecondsToFormatString(offset3);
  return new Date(dateWithoutZone + offsetFormatted);
};
const TimeZoneMappingDatePicker = ({
  timezone,
  onChange,
  selectedDate,
  primer,
  ...props
}) => {
  const PickerComponent = primer ? DatePickerPrimer : DatePicker;
  return timezone !== void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    PickerComponent,
    {
      selectedDate: selectedDate ? setLocalZone(selectedDate, timezone) : void 0,
      onChange: (v2) => {
        onChange(v2 ? setOtherZone(v2, timezone) : void 0);
      },
      ...props
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    PickerComponent,
    {
      selectedDate,
      onChange,
      ...props
    }
  );
};
const TicketTypeRow = ({
  ticketType,
  onChange,
  onDelete,
  onEditMetadata,
  index: index2,
  onAddTicketType
}) => {
  const { formSettings } = useRegForm();
  const [name2, setName] = useState(ticketType.name);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: ticketType.id
  });
  const style3 = {
    transform: CSS$1.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  };
  const handleNameChange = (e) => {
    const newName = e.target.value;
    setName(newName);
    onChange({ ...ticketType, name: newName });
  };
  const handleCapacityChange = (e) => {
    onChange({ ...ticketType, capacity: parseInt(e.target.value) || 0 });
  };
  const handlePriceChange = (e) => {
    onChange({
      ...ticketType,
      priceInCents: parseInt(e.target.value) || 0
    });
  };
  const handleAvailableFromChange = (availableFrom) => {
    onChange({ ...ticketType, availableFrom: availableFrom || void 0 });
  };
  const handleAvailableToChange = (availableTo) => {
    onChange({ ...ticketType, availableTo: availableTo || void 0 });
  };
  const gridTemplateColumns2 = formSettings.shoppingCartEnabled ? "40px 1fr 185px 185px 80px 100px 40px 40px" : "40px 1fr 185px 185px 80px 40px 40px";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      as: Stack,
      direction: "horizontal",
      ref: setNodeRef,
      style: style3,
      sx: {
        display: "grid",
        gridTemplateColumns: gridTemplateColumns2,
        gap: 2
      },
      mb: 3,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: GrabberIcon,
            "aria-label": "Grab",
            size: "large",
            variant: "invisible",
            sx: { color: "fg.muted", cursor: "grab" },
            ...attributes,
            ...listeners
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextInput$1,
          {
            size: "large",
            value: name2,
            placeholder: "Name",
            onChange: handleNameChange,
            width: "100%",
            autoComplete: "new-password",
            "data-1p-ignore": "true",
            "data-lpignore": "true",
            "data-form-type": "other"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TimeZoneMappingDatePicker,
          {
            clearButtonTitle: "Clear",
            placeholderText: "From",
            selectsStart: true,
            startDate: ticketType.availableFrom,
            endDate: ticketType.availableTo,
            maxDate: ticketType.availableTo,
            onChange: (date) => handleAvailableFromChange(date),
            selectedDate: ticketType.availableFrom,
            dateFormat: `${formSettings.dateFormat} HH:mm`,
            showTimeSelect: true,
            timeFormat: "HH:mm",
            timeIntervals: 15,
            timezone: formSettings.timezone,
            primer: true
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TimeZoneMappingDatePicker,
          {
            clearButtonTitle: "Clear",
            placeholderText: "To",
            selectsEnd: true,
            startDate: ticketType.availableFrom,
            endDate: ticketType.availableTo,
            minDate: ticketType.availableFrom,
            onChange: (date) => handleAvailableToChange(date),
            selectedDate: ticketType.availableTo,
            dateFormat: `${formSettings.dateFormat} HH:mm`,
            showTimeSelect: true,
            timeFormat: "HH:mm",
            timeIntervals: 15,
            timezone: formSettings.timezone,
            primer: true
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextInput$1,
          {
            size: "large",
            value: ticketType.capacity,
            onChange: handleCapacityChange,
            type: "number",
            min: 0,
            placeholder: "Qty",
            width: "100%"
          }
        ) }),
        formSettings.shoppingCartEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextInput$1,
          {
            size: "large",
            value: ticketType.priceInCents,
            onChange: handlePriceChange,
            type: "number",
            placeholder: "$",
            width: "100%"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          AnchoredOverlay,
          {
            open: isMenuOpen,
            onOpen: () => setIsMenuOpen(true),
            onClose: () => setIsMenuOpen(false),
            renderAnchor: (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              IconButton,
              {
                ...props,
                icon: KebabHorizontalIcon,
                size: "large",
                "aria-label": "Ticket type options",
                "aria-labelledby": void 0,
                onClick: () => setIsMenuOpen(true)
              }
            ),
            side: "outside-right",
            align: "end",
            anchorOffset: 20,
            children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionList, { role: "menu", children: [
              onEditMetadata !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
                ActionList.Item,
                {
                  role: "menuitem",
                  onSelect: () => onEditMetadata(ticketType),
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.LeadingVisual, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(PlusIcon, { size: "small" }) }),
                    "Data Tags"
                  ]
                }
              ),
              onDelete !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Divider, {}),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  ActionList.Item,
                  {
                    variant: "danger",
                    role: "menuitem",
                    onSelect: onDelete,
                    children: "Delete"
                  }
                )
              ] })
            ] })
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: PlusIcon,
            size: "large",
            "aria-label": "Add Ticket Type",
            onClick: onAddTicketType ?? void 0,
            variant: "primary",
            sx: {
              visibility: onAddTicketType ? "visible" : "hidden"
            }
          }
        )
      ]
    }
  );
};
const Headers$3 = ["Name", "Available From", "Available To", "Quantity"];
const TicketTypeTableHeader = () => {
  const { formSettings } = useRegForm();
  const gridTemplateColumns2 = (formSettings == null ? void 0 : formSettings.shoppingCartEnabled) ? "40px 1fr 185px 185px 80px 100px 40px 40px" : "40px 1fr 185px 185px 80px 40px 40px";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      as: Stack,
      direction: "horizontal",
      sx: {
        display: "grid",
        gridTemplateColumns: gridTemplateColumns2,
        gap: 2,
        height: "16px !important"
      },
      mb: 3,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { visibility: "hidden" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: GrabberIcon,
            "aria-label": "Grab",
            size: "large",
            variant: "invisible"
          }
        ) }),
        Headers$3.map((header) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          Text$2,
          {
            size: "medium",
            weight: "medium",
            sx: {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            children: header
          },
          header
        )),
        (formSettings == null ? void 0 : formSettings.shoppingCartEnabled) && /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Price ($)" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: GrabberIcon,
            "aria-label": "Ticket type options",
            size: "large",
            variant: "invisible",
            sx: { visibility: "hidden" }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: GrabberIcon,
            "aria-label": "Add Ticket Type",
            size: "large",
            variant: "invisible",
            sx: { visibility: "hidden" }
          }
        )
      ]
    }
  );
};
const TicketTypeTable = ({
  track: track2,
  dispatch,
  onEditMetadata,
  onAddTicketType
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor)
  );
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (over && active.id !== over.id) {
      const oldIndex = track2.ticketTypes.findIndex((t2) => t2.id === active.id);
      const newIndex = track2.ticketTypes.findIndex((t2) => t2.id === over.id);
      dispatch({
        type: "move_ticket_type",
        payload: {
          fromIndex: oldIndex,
          toIndex: newIndex
        }
      });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TicketTypeTableHeader, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      DndContext,
      {
        sensors,
        modifiers: [restrictToVerticalAxis],
        onDragEnd: handleDragEnd,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { mb: 2 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          SortableContext,
          {
            items: track2.ticketTypes.map((t2) => t2.id),
            strategy: verticalListSortingStrategy,
            children: getSortedItems(track2.ticketTypes).map((ticketType, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              TicketTypeRow,
              {
                index: index2,
                ticketType,
                onChange: (t2) => dispatch({ type: "update_ticket_type", payload: t2 }),
                onDelete: track2.ticketTypes.length > 1 && !(ticketType.numberBooked !== void 0 && ticketType.numberBooked > 0) ? () => dispatch({
                  type: "delete_ticket_type",
                  payload: ticketType
                }) : void 0,
                onEditMetadata,
                onAddTicketType: index2 === track2.ticketTypes.length - 1 ? onAddTicketType : void 0
              },
              ticketType.id
            ))
          }
        ) })
      }
    )
  ] });
};
const Reply = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { style: { transform: "rotate(180deg)" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ReplyIcon, { size: "small" }) });
const KEY_VALIDATION_RULES = {
  pattern: {
    value: /^[a-zA-Z][a-zA-Z0-9_]*/,
    message: "Key must contain letters, numbers and underscores only and must start with a letter"
  },
  minLength: {
    value: 3,
    message: "Minimum length is three characters"
  },
  maxLength: {
    value: 30,
    message: "Maximum length is 30 characters"
  }
};
const MetadataField = ({
  register: register2,
  errors,
  watch,
  onAction,
  isNew = false,
  index: index2,
  field
}) => {
  var _a3, _b, _c, _d, _e2, _f, _g, _h, _i, _j, _k, _l;
  const getKeyValidation = () => {
    const baseValidation = KEY_VALIDATION_RULES;
    if (isNew) {
      return {
        ...baseValidation,
        validate: (value) => {
          const valueField = watch("newValue");
          if ((valueField == null ? void 0 : valueField.trim()) && !(value == null ? void 0 : value.trim())) {
            return "Please enter a key";
          }
          return true;
        }
      };
    }
    return {
      ...baseValidation,
      required: "Please enter a key"
    };
  };
  const getValueValidation = () => {
    if (isNew) {
      return {
        validate: (value) => {
          const keyValue = watch("newKey");
          if ((keyValue == null ? void 0 : keyValue.trim()) && !(value == null ? void 0 : value.trim())) {
            return "Please enter a value";
          }
          return true;
        }
      };
    }
    return {
      required: "Please enter a value"
    };
  };
  const fieldName = isNew ? {
    key: "newKey",
    value: "newValue"
  } : index2 !== void 0 ? {
    key: `metadata.${index2}.key`,
    value: `metadata.${index2}.value`
  } : {
    key: "newKey",
    value: "newValue"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { mb: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "condensed", align: "center", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Reply, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { required: !isNew, sx: { width: "100%" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextInput$1,
        {
          size: "large",
          placeholder: "Key",
          id: isNew ? void 0 : fieldName.key,
          defaultValue: field == null ? void 0 : field.key,
          ...register2(fieldName.key, getKeyValidation()),
          sx: { width: "100%" }
        }
      ),
      (isNew ? errors == null ? void 0 : errors.newKey : (_b = (_a3 = errors == null ? void 0 : errors.metadata) == null ? void 0 : _a3[index2]) == null ? void 0 : _b.key) && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Validation, { variant: "error", children: isNew ? (_c = errors.newKey) == null ? void 0 : _c.message : (_f = (_e2 = (_d = errors == null ? void 0 : errors.metadata) == null ? void 0 : _d[index2]) == null ? void 0 : _e2.key) == null ? void 0 : _f.message })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { required: !isNew, sx: { width: "100%" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextInput$1,
        {
          size: "large",
          placeholder: "Value",
          id: isNew ? void 0 : fieldName.value,
          defaultValue: field == null ? void 0 : field.value,
          ...register2(fieldName.value, getValueValidation()),
          sx: { width: "100%" }
        }
      ),
      (isNew ? errors == null ? void 0 : errors.newValue : (_h = (_g = errors == null ? void 0 : errors.metadata) == null ? void 0 : _g[index2]) == null ? void 0 : _h.value) && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Validation, { variant: "error", children: isNew ? (_i = errors.newValue) == null ? void 0 : _i.message : (_l = (_k = (_j = errors == null ? void 0 : errors.metadata) == null ? void 0 : _j[index2]) == null ? void 0 : _k.value) == null ? void 0 : _l.message })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconButton,
      {
        icon: isNew ? PlusIcon : TrashIcon,
        "aria-label": isNew ? "Add" : "Delete",
        size: "large",
        variant: isNew ? "default" : "danger",
        onClick: onAction,
        tooltipDirection: "e"
      }
    )
  ] }) });
};
const MetadataFormPrimer = ({
  metadata,
  onSave,
  onCancel,
  formRef,
  scrollRef,
  showSubmitButton = true
}) => {
  const {
    register: register2,
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors }
  } = useNestedForm({
    defaultValues: {
      metadata: metadata || [],
      newKey: "",
      newValue: ""
    },
    mode: "onSubmit",
    reValidateMode: "onSubmit"
  });
  const { fields, append: append3, remove } = useFieldArray({
    control,
    name: "metadata"
  });
  const newKey = watch("newKey");
  const newValue = watch("newValue");
  const handleAddItem = () => {
    if (newKey.trim() && newValue.trim()) {
      append3({ key: newKey, value: newValue });
      setValue("newKey", "");
      setValue("newValue", "");
    } else {
      append3({});
    }
    setTimeout(
      () => {
        var _a3;
        return (_a3 = scrollRef == null ? void 0 : scrollRef.current) == null ? void 0 : _a3.scrollIntoView({
          block: "end",
          behavior: "smooth"
        });
      },
      30
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    ResetForm,
    {
      ref: formRef,
      onSubmit: handleSubmit((values2) => {
        var _a3, _b;
        const allMetadata = [...values2.metadata || []];
        if (((_a3 = values2.newKey) == null ? void 0 : _a3.trim()) || ((_b = values2.newValue) == null ? void 0 : _b.trim())) {
          allMetadata.push({
            key: values2.newKey.trim(),
            value: values2.newValue.trim()
          });
        }
        onSave(allMetadata.filter(isValidMetaTag));
      }),
      children: [
        fields.map((field, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          MetadataField,
          {
            index: index2,
            field,
            register: register2,
            errors,
            onAction: () => remove(index2)
          },
          field.id
        )),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          MetadataField,
          {
            register: register2,
            errors,
            watch,
            onAction: handleAddItem,
            isNew: true
          }
        ),
        showSubmitButton && /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "normal", justify: "end", children: [
          onCancel !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, { onClick: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            ButtonComponent,
            {
              variant: "primary",
              type: "submit",
              size: "large",
              style: { minWidth: "150px" },
              children: "Save"
            }
          )
        ] })
      ]
    }
  );
};
function useNestedDialog(isOpen) {
  const anchorRef = React__default.useRef(null);
  const [hasParentDialog, setHasParentDialog] = React__default.useState(false);
  React__default.useLayoutEffect(() => {
    if (!isOpen) {
      setHasParentDialog(false);
      return;
    }
    const anchor = anchorRef.current;
    const parentDialog = anchor == null ? void 0 : anchor.closest('[role="dialog"]');
    if (!parentDialog) {
      setHasParentDialog(false);
      return;
    }
    setHasParentDialog(true);
    parentDialog.setAttribute("inert", "");
    return () => {
      parentDialog.removeAttribute("inert");
      setHasParentDialog(false);
    };
  }, [isOpen]);
  return { anchorRef, hasParentDialog };
}
const NestedPrimerDialog = ({
  isOpen,
  title,
  onClose,
  width: width2 = "medium",
  renderFooter,
  renderHeader,
  children,
  className,
  sx: sx2,
  titleIcon
}) => {
  const { anchorRef, hasParentDialog } = useNestedDialog(isOpen);
  const widthProp = typeof width2 === "string" && ["small", "medium", "large"].includes(width2) ? width2 : "medium";
  const computedHeader = renderHeader || (titleIcon ? () => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      mx: 3,
      py: 3,
      mb: 0,
      sx: {
        flexShrink: 0,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px solid",
        borderColor: "border.default",
        bg: "bg.secondary"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", gap: "condensed", children: [
          titleIcon ? React__default.createElement(titleIcon) : null,
          /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "semibold", children: title })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog.CloseButton, { onClose })
      ]
    }
  ) : void 0);
  const content2 = /* @__PURE__ */ jsxRuntimeExports.jsx(
    Dialog,
    {
      title,
      onClose,
      width: widthProp,
      renderFooter,
      renderHeader: computedHeader,
      className,
      sx: {
        backgroundColor: "bg.secondary",
        ...sx2,
        zIndex: hasParentDialog ? 9999 : (sx2 == null ? void 0 : sx2.zIndex) ?? 1e3,
        ...hasParentDialog ? { "&, & *": { pointerEvents: "auto" } } : {}
      },
      children
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { ref: anchorRef }),
    isOpen ? hasParentDialog ? createPortal(content2, document.body) : content2 : null
  ] });
};
const MetadataModalPrimer = ({
  title = "Data Tags",
  fieldName,
  metadata,
  onSave,
  isOpen,
  onClose
}) => {
  const formRef = React__default.createRef();
  const handleSave = () => {
    if (formRef.current) {
      formRef.current.requestSubmit();
    }
  };
  const dialogContent = /* @__PURE__ */ jsxRuntimeExports.jsx(
    NestedPrimerDialog,
    {
      isOpen,
      onClose,
      title,
      width: "large",
      titleIcon: TagIcon,
      renderFooter: () => /* @__PURE__ */ jsxRuntimeExports.jsx(
        GregDialogFooter,
        {
          leftButtonText: "Cancel",
          rightButtonText: "Save",
          onLeftButtonClick: onClose,
          onRightButtonClick: handleSave
        }
      ),
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "spacious", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          InfoBanner,
          {
            text: "Data tags are an advanced tool to dynamically add registration data to mobile apps, name-badges, and integrations, enabling seamless automation and personalization, ",
            href: "https://google.com",
            linkText: "find out more..."
          }
        ),
        fieldName && /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$2, { weight: "semibold", size: "large", children: [
          "Field: ",
          fieldName
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          MetadataFormPrimer,
          {
            metadata,
            onSave: (metadata2) => {
              onSave(metadata2);
              onClose();
            },
            onCancel: onClose,
            formRef,
            showSubmitButton: false
          }
        )
      ] })
    }
  );
  return isOpen ? dialogContent : null;
};
const TicketTypeEditor = ({
  track: initialTrack,
  onChange
}) => {
  const { formSettings } = useRegForm();
  const [track2, dispatch] = useReducer(ticketTypeReducer, initialTrack);
  const [editMetaTicketType, setEditMetaTicketType] = useState();
  const scrollRef = useRef(null);
  useEffect(() => {
    onChange(track2.ticketTypes, track2.deletedTicketTypes);
  }, [track2]);
  const handleAddTicketType = () => {
    dispatch({
      type: "add_ticket_type",
      payload: {
        name: ticketTypeDefaults.name,
        sort: getNextSort(track2.ticketTypes)
      }
    });
    setTimeout(
      () => {
        var _a3;
        return (_a3 = scrollRef == null ? void 0 : scrollRef.current) == null ? void 0 : _a3.scrollIntoView({
          block: "end",
          behavior: "smooth"
        });
      },
      30
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { ref: scrollRef, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      TicketTypeTable,
      {
        track: track2,
        dispatch,
        onEditMetadata: formSettings.metadataEnabled ? setEditMetaTicketType : void 0,
        onAddTicketType: handleAddTicketType
      }
    ),
    editMetaTicketType !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
      MetadataModalPrimer,
      {
        isOpen: editMetaTicketType !== void 0,
        onClose: () => setEditMetaTicketType(void 0),
        onSave: (metadata) => dispatch({
          type: "update_ticket_type",
          payload: { ...editMetaTicketType, metadata }
        }),
        metadata: editMetaTicketType.metadata || []
      }
    )
  ] });
};
const CopyableInput = ({ text: text2, caption }) => {
  const { onCopy } = useClipboard(text2);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Track Invite URL" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextInput$1,
      {
        value: text2,
        size: "large",
        block: true,
        trailingAction: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextInput$1.Action,
          {
            onClick: onCopy,
            icon: CopyIcon,
            "aria-label": "Copy to clipboard"
          }
        )
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: caption })
  ] });
};
function TrackForm({
  track: initialTrack,
  onSubmit,
  formRef
}) {
  const { formSettings } = useRegForm();
  const [deletedTicketTypes, setDeletedTicketTypes] = useState(initialTrack == null ? void 0 : initialTrack.deletedTicketTypes);
  const {
    handleSubmit,
    control,
    register: register2,
    watch,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues: { ticketTypes: [defaultTicketType()], ...initialTrack }
  });
  const track2 = { ...watch(), deletedTicketTypes };
  useEffect(() => {
    if (track2.isGuestTrack && track2.inviteOnly) {
      setValue("inviteOnly", false);
    }
  }, [track2.isGuestTrack, track2.inviteOnly, setValue]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "form",
    {
      id: "track-form",
      onSubmit: handleSubmit((update2) => {
        onSubmit({ ...update2, deletedTicketTypes });
      }),
      ref: formRef,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { required: true, id: "track_name", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Name" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              TextInput$1,
              {
                size: "large",
                block: true,
                id: `track-${(initialTrack == null ? void 0 : initialTrack.id) !== void 0 ? initialTrack.id : "new"}`,
                ...register2("name", { required: "Track name is required" }),
                placeholder: "Enter track name",
                autoComplete: "off",
                "data-1p-ignore": "true",
                "data-lpignore": "true",
                "data-form-type": "other"
              }
            ),
            errors.name && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Validation, { variant: "error", children: errors.name.message })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { id: "track_description", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Description" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Textarea,
              {
                rows: 3,
                block: true,
                ...register2("description"),
                placeholder: "Provide additional instructions to help the attendee"
              }
            ),
            errors.description && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Validation, { variant: "error", children: errors.description.message })
          ] }),
          formSettings.guestBookingEnabled && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Track Options", divider: false, defaultOpen: true, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { id: "is_guest_track", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$1, { ...register2("isGuestTrack") }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Guest Track" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "This track is only available to guests of other tracks." })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { id: "invite_only", disabled: track2.isGuestTrack, children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$1, { ...register2("inviteOnly") }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Invite Only" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "This track is only available via invitation." })
              ] })
            ] }) })
          ] }),
          track2.isGuestTrack && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Guest Track Options", divider: false, defaultOpen: true, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "Select the number of guests that can be added to this track by attendees registering on other tracks on this event." }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                Controller,
                {
                  control,
                  name: "guestInvites",
                  render: ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                    GuestTrackInvites,
                    {
                      guestTrack: { ...track2, id: initialTrack == null ? void 0 : initialTrack.id },
                      onChange: field.onChange
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { mt: 3, mb: 3 }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { id: "guest_account_activation", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$1, { ...register2("guestAccountActivation") }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Guests receive a registration confirmation email" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "When selected, guests will receive a registration confirmation email, allowing them to activate their account and update their registration details." })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { id: "override_registration_close", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$1, { ...register2("overrideRegistrationClose") }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Allow Guest Registration After Event Close" }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "When enabled, inviters can continue registering guests even after the main event registration has closed or been frozen." })
              ] })
            ] }) })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { sx: { width: "100%" }, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { sx: { mb: 2, fontWeight: "semibold" }, children: "Invite Options" }),
              (initialTrack == null ? void 0 : initialTrack.inviteUrl) === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "small", color: "fg.muted", children: "Please save the Track to generate the invite link." }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CopyableInput, { text: initialTrack.inviteUrl })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { mt: 4, mb: 4 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Admission Types", divider: false, defaultOpen: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Controller,
          {
            name: "ticketTypes",
            control,
            render: ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              TicketTypeEditor,
              {
                track: track2,
                onChange: (ticketTypes, deletedTicketTypes2) => {
                  field.onChange(ticketTypes);
                  setDeletedTicketTypes(deletedTicketTypes2);
                }
              }
            )
          }
        ) })
      ]
    }
  );
}
const EditTrack = ({
  track: initialTrack,
  onUpdated,
  formRef
}) => {
  const mutation = useUpdateTrack({ onSuccess: onUpdated });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TrackForm,
    {
      formRef,
      track: initialTrack,
      onSubmit: (track2) => mutation.mutate({ ...track2, id: initialTrack.id })
    }
  );
};
const TrackDialog = ({
  isOpen,
  onClose,
  onSave,
  title,
  leftButtonText,
  rightButtonText,
  children
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseDialog,
    {
      isOpen,
      onClose,
      title,
      width: "900px",
      position: "right",
      leftButtonText,
      rightButtonText,
      onLeftButtonClick: onClose,
      onRightButtonClick: onSave,
      children
    }
  );
};
const EditTrackPrimer = ({
  isOpen,
  track: track2,
  onUpdated,
  onClose
}) => {
  const formRef = React__default.createRef();
  const onSave = () => {
    var _a3;
    (_a3 = formRef == null ? void 0 : formRef.current) == null ? void 0 : _a3.dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TrackDialog,
    {
      isOpen,
      onClose,
      onSave,
      title: "Edit Event Track",
      leftButtonText: "Cancel",
      rightButtonText: "Save Track",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        EditTrack,
        {
          track: track2,
          onUpdated: () => {
            onUpdated == null ? void 0 : onUpdated.call(void 0, track2);
            onClose();
          },
          formRef
        }
      )
    }
  );
};
const getFieldIcon = (type) => {
  switch (type) {
    case "text":
      return TypographyIcon;
    case "telephone":
      return DeviceMobileIcon;
    case "checkbox":
      return CheckIcon;
    case "date":
      return CalendarIcon2;
    case "email":
      return MailIcon;
    case "document":
      return UploadIcon;
    case "dropdown":
    case "select":
      return ChevronDownIcon;
    case "radio":
      return DotFillIcon;
    case "integer":
    case "number":
      return NumberIcon;
    case "textarea":
      return NoteIcon;
    case "room_block":
      return HomeIcon;
    case "session_booking":
      return BookmarkIcon;
    case "lead_scanner":
      return ScreenFullIcon;
    case "info":
      return NoteIcon;
    case "page":
      return FileIcon;
    case "section":
      return ServerIcon;
    default:
      return TypographyIcon;
  }
};
const SectionListItem = ({ field }) => {
  const IconComponent = getFieldIcon(field.type);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { mx: -4, mb: -4 }, px: 8, pt: 2, pb: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: field.label || humanizeString(field.name), icon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconComponent, {}), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { gap: "normal", children: field.fields.map((field2, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldListItem$1, { field: field2 }, field2.name) }, index2)) }) }) });
};
const InfoListItem = ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "start", gap: "condensed", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NoteIcon, {}) }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { mt: -3, mb: -3, dangerouslySetInnerHTML: { __html: marked(field.text) } })
] });
const getIcon = (field) => {
  const IconComponent = getFieldIcon(field.type);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IconComponent, {});
};
const InputFieldListItem = ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "start", gap: "condensed", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: getIcon(field) }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: field.label || humanizeString(field.name) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", gap: "condensed", children: [
      field.required && /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { children: "Required" }),
      field.officeOnly && /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { children: "Admin Visible Only" })
    ] })
  ] })
] });
const SessionFieldListItem = ({
  field
}) => {
  const IconComponent = getFieldIcon(field.type);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "start", gap: "condensed", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconComponent, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: field.label || humanizeString(field.name) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", gap: "condensed", children: [
        field.required && /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { children: "Required" }),
        field.officeOnly && /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { children: "Admin Visible Only" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { children: "Session Booking" })
      ] })
    ] })
  ] });
};
const RoomBlockListItem = ({ field }) => {
  const IconComponent = getFieldIcon(field.type);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "start", gap: "condensed", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconComponent, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: field.label || humanizeString(field.name) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", gap: "condensed", children: [
        field.required && /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { children: "Required" }),
        field.officeOnly && /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { children: "Admin Visible Only" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { children: "Room Block" })
      ] })
    ] })
  ] });
};
const LeadScannerListItem = ({
  field
}) => {
  const IconComponent = getFieldIcon(field.type);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "start", gap: "condensed", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconComponent, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: field.label || humanizeString(field.name) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", gap: "condensed", children: [
        field.required && /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { children: "Required" }),
        field.officeOnly && /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { children: "Admin Visible Only" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { children: "Lead Scanner" })
      ] })
    ] })
  ] });
};
const FieldListItem$1 = ({ field }) => {
  switch (field.type) {
    case "section":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SectionListItem, { field });
    case "session_booking":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SessionFieldListItem, { field });
    case "info":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(InfoListItem, { field });
    case "room_block":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(RoomBlockListItem, { field });
    case "lead_scanner":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(LeadScannerListItem, { field });
    case "page":
      return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Page" });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(InputFieldListItem, { field });
  }
};
const PageListItem = ({ field }) => {
  const hasMultipleFields = field.fields.length >= 1;
  const pageTitle = field.label || humanizeString(field.name);
  if (!hasMultipleFields) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { p: 4, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", gap: "condensed", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FileIcon, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: pageTitle })
      ] }),
      field.fields.map((field2, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldListItem$1, { field: field2 }, field2.name) }, index2))
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: pageTitle, px: "4", py: "4", icon: /* @__PURE__ */ jsxRuntimeExports.jsx(FileIcon, {}), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { children: field.fields.map((field2, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldListItem$1, { field: field2 }, field2.name) }, index2)) }) });
};
const style$1 = {
  borderBottom: "1px solid",
  borderColor: "border.default"
};
const TrackFieldList = ({ fields, track: track2 }) => {
  const trackFields = fields.filter((f2) => isTrackVisible(f2, track2));
  return trackFields.map((field) => /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: style$1, children: isPage$1(field) && /* @__PURE__ */ jsxRuntimeExports.jsx(PageListItem, { field }) }, field.name));
};
const Header$2 = ({ onClose }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      p: 4,
      style: {
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px solid",
        borderColor: "#D0D7DE"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", gap: "condensed", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(MilestoneIcon, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Track Preview" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            variant: "invisible",
            size: "small",
            "aria-label": "Close",
            icon: XIcon,
            onClick: onClose
          }
        )
      ]
    }
  );
};
const TrackPreview = ({
  track: track2,
  isOpen,
  onClose
}) => {
  const { form } = useRegForm();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
    Dialog,
    {
      position: "left",
      onClose,
      renderBody: () => /* @__PURE__ */ jsxRuntimeExports.jsx(TrackFieldList, { track: track2, fields: form.fields }),
      renderHeader: () => /* @__PURE__ */ jsxRuntimeExports.jsx(Header$2, { onClose })
    }
  ) });
};
const TrackURLDialog = ({
  trackURL,
  onClose,
  isOpen
}) => {
  return isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog, { title: "Track URL", onClose, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { p: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    CopyableInput,
    {
      text: trackURL,
      caption: "Direct registration path and simplified process, even for invite-only tracks."
    }
  ) }) });
};
const TracksMenuListing = ({
  tracks,
  onMoveTrack
}) => {
  const updateTrackMutation = useUpdateTrack();
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })
  );
  const deleteMutation = useDeleteTrack();
  const [editingTrack, setEditingTrack] = useState(null);
  const [previewTrack, setPreviewTrack] = useState(null);
  const [dataTagsTrack, setDataTagsTrack] = useState(null);
  const [selectedTrack, setSelectedTrack] = useState(null);
  const openEditingModal = (track2) => {
    setEditingTrack(track2);
  };
  const closeEditingModal = () => {
    setEditingTrack(null);
  };
  const handleMoveTrack = (event) => {
    const { active, over } = event;
    if (over && active.id !== over.id) {
      const newIndex = tracks.findIndex((track2) => track2.id === over.id);
      onMoveTrack(active.id.toString(), newIndex);
    }
  };
  const OverlayItems = ({ track: track2, closeMenu }) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionList, { role: "menu", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        ActionList.Item,
        {
          role: "menuitem",
          onClick: () => {
            closeMenu();
            openEditingModal(track2);
          },
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.LeadingVisual, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(PencilIcon, { size: "small" }) }),
            "Edit"
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionList.Item, { role: "menuitem", onClick: () => {
        closeMenu();
        setPreviewTrack(track2);
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.LeadingVisual, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(MilestoneIcon, { size: "small" }) }),
        "Track Preview"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        ActionList.Item,
        {
          role: "menuitem",
          onClick: () => {
            closeMenu();
            setSelectedTrack(track2);
          },
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.LeadingVisual, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CopyIcon, { size: "small" }) }),
            "Track Invite Link"
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        ActionList.Item,
        {
          role: "menuitem",
          onClick: () => {
            closeMenu();
            setDataTagsTrack(track2);
          },
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.LeadingVisual, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(PlusIcon, { size: "small" }) }),
            "Data Tags"
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ActionList.Item,
        {
          variant: "danger",
          role: "menuitem",
          onClick: () => {
            if (confirm("Are you sure you want to delete this track?")) {
              deleteMutation.mutate(track2);
            }
          },
          children: "Delete"
        }
      )
    ] });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      DndContext,
      {
        sensors,
        collisionDetection: closestCenter,
        onDragEnd: handleMoveTrack,
        modifiers: [restrictToVerticalAxis],
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          SortableContext,
          {
            items: tracks == null ? void 0 : tracks.map((track2) => ({ id: track2.id })),
            strategy: verticalListSortingStrategy,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList, { className: "t-pages-list", children: tracks == null ? void 0 : tracks.map((track2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              TrackMenuItem,
              {
                track: track2,
                tracks,
                overlayItems: ({ closeMenu }) => /* @__PURE__ */ jsxRuntimeExports.jsx(OverlayItems, { track: track2, closeMenu }),
                onClick: () => {
                }
              },
              track2.name
            )) })
          }
        )
      }
    ),
    editingTrack && /* @__PURE__ */ jsxRuntimeExports.jsx(
      EditTrackPrimer,
      {
        isOpen: !!editingTrack,
        track: editingTrack,
        onUpdated: () => setEditingTrack(null),
        onClose: closeEditingModal
      }
    ),
    previewTrack && /* @__PURE__ */ jsxRuntimeExports.jsx(
      TrackPreview,
      {
        track: previewTrack,
        isOpen: !!previewTrack,
        onClose: () => setPreviewTrack(null)
      }
    ),
    dataTagsTrack && /* @__PURE__ */ jsxRuntimeExports.jsx(
      MetadataModalPrimer,
      {
        isOpen: !!dataTagsTrack,
        onClose: () => setDataTagsTrack(null),
        metadata: dataTagsTrack == null ? void 0 : dataTagsTrack.metadata,
        onSave: (metadata) => updateTrackMutation.mutate({
          id: dataTagsTrack.id,
          metadata
        })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      TrackURLDialog,
      {
        isOpen: !!selectedTrack,
        onClose: () => setSelectedTrack(null),
        trackURL: (selectedTrack == null ? void 0 : selectedTrack.inviteUrl) || ""
      }
    )
  ] });
};
const AddTrack = ({ onAdded, formRef }) => {
  const mutation = useAddTrack({ onSuccess: onAdded });
  const { tracks } = useTracks();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TrackForm,
    {
      formRef,
      onSubmit: (track2) => mutation.mutate({
        ...track2,
        sort: getNextSort(tracks)
      })
    }
  );
};
const AddTrackPrimer = ({
  onAdded,
  isOpen,
  onClose
}) => {
  const formRef = React__default.createRef();
  const onSave = () => {
    var _a3;
    (_a3 = formRef == null ? void 0 : formRef.current) == null ? void 0 : _a3.dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TrackDialog,
    {
      isOpen,
      onClose,
      onSave,
      title: "Add Event Track",
      leftButtonText: "Cancel",
      rightButtonText: "Add Track",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        AddTrack,
        {
          formRef,
          onAdded: (track2) => {
            onAdded == null ? void 0 : onAdded.call(void 0, track2);
            onClose();
          }
        }
      )
    }
  );
};
const TracksHeader = ({
  isCollapsed,
  onCollapse
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", justify: "space-between", align: "center", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "condensed", align: "center", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(MilestoneIcon, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { weight: "semibold", size: "medium", children: "Tracks" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    IconButton,
    {
      variant: "invisible",
      size: "small",
      "aria-label": "Collapse",
      icon: !isCollapsed ? ChevronDownIcon : ChevronUpIcon,
      onClick: () => onCollapse(!isCollapsed)
    }
  )
] });
const TracksMenuPrimer = ({
  tracks,
  onMoveTrack
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isAddTrackOpen, setIsAddTrackOpen] = useState(false);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { bg: "canvas.inset", py: 3, px: 4, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(TracksHeader, { isCollapsed, onCollapse: setIsCollapsed }),
      !isCollapsed && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { mt: 3, mb: 2 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(TracksMenuListing, { tracks, onMoveTrack }),
        tracks.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { mt: 2, mb: 3 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          ButtonComponent,
          {
            variant: "invisible",
            size: "medium",
            onClick: () => setIsAddTrackOpen(true),
            leadingVisual: PlusIcon,
            sx: { width: "100%", justifyContent: "flex-start" },
            children: "Add Track"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddTrackPrimer,
      {
        isOpen: isAddTrackOpen,
        onClose: () => setIsAddTrackOpen(false)
      }
    )
  ] });
};
const TracksMenuContainer = () => {
  const { data, isLoading, selectedTracks, selectTracks } = useTracks();
  const mutation = useUpdateTrack();
  const [tracks, setTracks] = useState();
  useEffect(() => {
    if (data !== void 0) {
      const sortedTracks = getSortedItems(data);
      setTracks(sortedTracks);
    }
  }, [data]);
  if (tracks === void 0 || isLoading) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Box,
      {
        sx: {
          alignItems: "center",
          display: "flex",
          justifyContent: "center"
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {})
      }
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TracksMenuPrimer,
    {
      tracks,
      onMoveTrack: (trackId, toIndex) => {
        const fromIndex = tracks.findIndex((t2) => idsEqual(trackId, t2.id));
        if (fromIndex === -1) {
          console.error(`No track found with ID ${trackId}`);
          return;
        }
        const track2 = tracks[fromIndex];
        track2.sort = getNewSort(tracks, fromIndex, toIndex);
        setTracks(getSortedItems(tracks));
        mutation.mutate({ id: track2.id, sort: track2.sort });
      },
      onSelectTracks: selectTracks,
      selectedTracks
    }
  );
};
const SidebarPrimer = () => {
  const { formSettings } = useRegForm();
  if (formSettings.tracksEnabled || formSettings.tracksBlockedByUntrackedRegistrations) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      formSettings.tracksBlockedByUntrackedRegistrations ? /* @__PURE__ */ jsxRuntimeExports.jsx(TracksBlankPattern, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(TracksMenuContainer, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { height: "1px", backgroundColor: "border.default" } }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(SectionsMenu, {})
    ] });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(SectionsMenu, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { height: "1px", backgroundColor: "border.default" } })
    ] });
  }
};
const FieldButtonPrimer = ({ input, onClick }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      onClick,
      sx: {
        cursor: "pointer",
        backgroundColor: "transparent",
        transition: "background-color 0.2s ease",
        "&:hover": {
          backgroundColor: "neutral.subtle"
        }
      },
      p: 1,
      py: 0,
      borderRadius: 2,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { direction: "horizontal", align: "center", justify: "space-between", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Stack,
        {
          direction: "horizontal",
          gap: "condensed",
          align: "start",
          padding: "condensed",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                style: {
                  color: "fg.muted",
                  display: "flex",
                  alignItems: "center",
                  marginTop: "4px"
                },
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(input.Icon, { size: "small" })
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "none", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Text$2,
                {
                  size: "medium",
                  weight: input.label === "Regi Form Asisstant" ? "semibold" : "medium",
                  mt: 0,
                  mb: 0,
                  children: input.label
                }
              ),
              input.description && /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "small", weight: "medium", sx: { color: "fg.muted" }, children: input.description })
            ] })
          ]
        }
      ) })
    }
  );
};
const StickySectionHeader = ({ children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      sx: {
        position: "sticky",
        top: 0,
        bg: "bg.secondary",
        zIndex: 1,
        py: 2,
        mb: 0,
        "& p": {
          margin: 0
        }
      },
      children
    }
  );
};
const GrAiBotIcon = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        d: "M36.5366 0.703125C38.242 0.703125 39.6245 2.0856 39.6245 3.79102C39.6245 5.4964 38.242 6.87891 36.5366 6.87891H34.2065V12.1729H49.646C54.7622 12.1729 58.9097 16.3203 58.9097 21.4365V30.7002H61.0591C62.7645 30.7002 64.147 32.0827 64.147 33.7881C64.1469 35.4934 62.7644 36.876 61.0591 36.876H58.9097V48.1982C58.9097 53.3145 54.7622 57.4619 49.646 57.4619H27.6226L15.4653 65.5674C14.1688 66.4317 12.4322 65.5025 12.4321 63.9443V57.1924C8.38704 56.1984 5.38624 52.55 5.38623 48.1982V36.876H3.23682C1.53146 36.876 0.149013 35.4934 0.148926 33.7881C0.148926 32.0827 1.5314 30.7002 3.23682 30.7002H5.38623V21.4365C5.38623 16.3203 9.53366 12.1729 14.6499 12.1729H28.0308V3.79102C28.0308 2.0856 29.4132 0.703125 31.1187 0.703125H36.5366ZM14.6499 18.3486C12.9445 18.3486 11.562 19.7311 11.562 21.4365V48.1982C11.562 49.9036 12.9445 51.2861 14.6499 51.2861H49.646C51.3514 51.2861 52.7339 49.9036 52.7339 48.1982V21.4365C52.7339 19.7311 51.3514 18.3486 49.646 18.3486H14.6499ZM22.8843 28.6416C24.5896 28.6417 25.9722 30.0241 25.9722 31.7295V37.9053C25.9721 39.6105 24.5896 39.2285 22.8843 39.2285C21.1789 39.2285 19.7965 39.6105 19.7964 37.9053V31.7295C19.7964 30.0241 21.1789 28.6416 22.8843 28.6416ZM41.4116 28.6416C43.117 28.6416 44.4995 30.0241 44.4995 31.7295V37.9053C44.4994 39.6105 43.117 39.2285 41.4116 39.2285C39.7063 39.2285 38.3238 39.6105 38.3237 37.9053V31.7295C38.3237 30.0241 39.7062 28.6416 41.4116 28.6416Z",
        fill: "currentColor"
      }
    )
  }
);
const aiInput = {
  label: "Regi Form Assistant",
  description: "Design powerful forms in seconds through simple conversation. Describe what you need, and intelligent AI will transform your words into inputs.",
  Icon: GrAiBotIcon
};
const layoutInputs = [
  {
    label: "Subsection",
    description: "Group related fields together neatly.",
    Icon: ServerIcon,
    field: fieldDefaults.section
  },
  {
    label: "Info Text",
    description: "Show informative text within the form.",
    Icon: QuestionIcon,
    field: fieldDefaults.infoField
  }
];
const standartInputs = [
  {
    label: "Text Field",
    description: "Collect simple text input from users.",
    Icon: TypographyIcon,
    field: fieldDefaults.textField
  },
  {
    label: "Check Box",
    description: "Use checkboxes for yes / no responses.",
    Icon: CheckIcon,
    field: fieldDefaults.checkBoxField
  },
  {
    label: "Drop Down",
    description: "Provide a list of selectable options.",
    Icon: ChevronDownIcon,
    field: fieldDefaults.dropDownField
  },
  {
    label: "Radio",
    description: "Use radio buttons for single-choice selection.",
    Icon: DotFillIcon,
    field: fieldDefaults.radioField
  },
  {
    label: "Number",
    description: "Collect numeric data from Attendees.",
    Icon: NumberIcon,
    field: fieldDefaults.numberField
  },
  {
    label: "Text Area",
    description: "Allow users to pick a formatted date, easily.",
    Icon: NoteIcon,
    field: fieldDefaults.textAreaField
  }
];
const formattedInputs = [
  {
    label: "Date",
    description: "Allow users to pick a formatted date, easily.",
    Icon: CalendarIcon2,
    field: fieldDefaults.dateField
  },
  {
    label: "Email",
    description: "Collect valid email addresses form attendees.",
    Icon: MailIcon,
    field: fieldDefaults.emailField
  },
  {
    label: "Phone Number",
    description: "Gather telephone numbers from attendees",
    Icon: DeviceMobileIcon,
    field: fieldDefaults.phoneNumberField
  },
  {
    label: "Document Upload",
    description: "Allow file uploads during registration.",
    Icon: UploadIcon,
    field: fieldDefaults.documentField
  }
];
const defaultStyles$1 = {
  borderRadius: 9999,
  height: 20,
  width: 20,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "neutral.muted"
};
const inFormStyles$1 = {
  backgroundColor: "success.emphasis"
};
const RoomBlockTableItem = ({
  roomBlock,
  onEditRoomBlock,
  onSelectRoomBlock,
  divider
}) => {
  const { form } = useRegForm();
  const inForm = hasRoomBlockField(form, roomBlock);
  const dateRange = `${format$2(roomBlock.startDate, "MMM d yyyy")} - ${format$2(
    roomBlock.endDate,
    "MMM d yyyy"
  )}`;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Stack,
    {
      direction: "horizontal",
      gap: "condensed",
      align: "center",
      justify: "space-between",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { ...defaultStyles$1, ...inForm && inFormStyles$1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckIcon, { size: 12, fill: "var(--fgColor-white) !important" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Box,
          {
            borderBottom: divider ? "1px solid" : "none",
            borderColor: "border.default",
            py: 2,
            width: "100%",
            children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
              Box,
              {
                sx: {
                  display: "grid",
                  gridTemplateColumns: "2fr 2fr 1fr 1fr 1fr",
                  gap: 2,
                  alignItems: "center",
                  width: "100%"
                },
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: roomBlock == null ? void 0 : roomBlock.name }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: dateRange }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$2, { size: "medium", weight: "medium", children: [
                    roomBlock == null ? void 0 : roomBlock.roomTypes.length,
                    " Type",
                    (roomBlock == null ? void 0 : roomBlock.roomTypes.length) > 1 && "s"
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$2, { size: "medium", weight: "medium", children: [
                    roomBlock == null ? void 0 : roomBlock.numberBooked,
                    " booking"
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { justifySelf: "end" }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "condensed", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      IconButton,
                      {
                        icon: GearIcon,
                        "aria-label": "Edit",
                        size: "large",
                        variant: "default",
                        onClick: () => onEditRoomBlock(roomBlock),
                        tooltipDirection: "e"
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      ButtonComponent,
                      {
                        variant: "primary",
                        size: "large",
                        onClick: () => onSelectRoomBlock(roomBlock),
                        children: "Add To Form"
                      }
                    )
                  ] }) })
                ]
              }
            )
          }
        )
      ]
    }
  ) });
};
const RoomBlockTable = ({
  roomBlocks: roomBlocks2,
  onEditRoomBlock,
  onSelectRoomBlock
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "vertical", gap: "normal", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Room Blocks" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { direction: "vertical", gap: "none", children: roomBlocks2.map((roomBlock, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      RoomBlockTableItem,
      {
        roomBlock,
        onEditRoomBlock,
        onSelectRoomBlock,
        divider: index2 !== roomBlocks2.length - 1
      },
      roomBlock.id
    )) })
  ] });
};
const ListRoomBlocks = ({
  onEditRoomBlock,
  onSelectRoomBlock,
  onClose,
  onAddNewSession
}) => {
  const { isLoading, error: error2, data: roomBlocks2 } = useRoomBlocks();
  const infoBannerText = `Getting Started: Room blocks help you manage event lodging options that attendees can select during registration. You can create multiple room blocks, set availability for different room types on various nights, and use form dependencies and track visibility controls to determine which attendees can book specific room nights and at what price, `;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      InfoBanner,
      {
        text: infoBannerText,
        linkText: "find out more...",
        href: "https://www.google.com"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { my: 3 }),
    isLoading && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {}),
    roomBlocks2 && roomBlocks2.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
      RoomBlockTable,
      {
        roomBlocks: getSortedRoomBlocks(roomBlocks2),
        onEditRoomBlock,
        onSelectRoomBlock
      }
    ),
    roomBlocks2 && roomBlocks2.length === 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(BlankslateContainer, { size: "small", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(BlankslateContainer.Visual, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(HomeIcon, { size: "medium" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(BlankslateContainer.Heading, { children: "No Room Blocks" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(BlankslateContainer.Description, { children: "Create your first room block to get started. Room blocks help you manage event lodging options that attendees can select during registration." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { my: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", justify: "space-between", align: "center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ButtonComponent,
        {
          variant: "invisible",
          size: "large",
          style: { minWidth: "150px" },
          onClick: onClose,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ButtonComponent,
        {
          variant: "default",
          size: "large",
          style: { minWidth: "150px" },
          onClick: onAddNewSession,
          leadingVisual: PlusIcon,
          children: "Add Room Block"
        }
      )
    ] })
  ] });
};
const PriceInput$2 = ({
  id,
  valueInCents,
  defaultValue: defaultValue2,
  currency = "$",
  precision = 2,
  onChange,
  onBlur: onBlurExternal,
  disabled = false,
  size: size2 = "medium"
}) => {
  const [value, setValue] = useState(
    defaultValue2 !== void 0 ? (defaultValue2 / 100).toString() : ""
  );
  useEffect(() => {
    if (valueInCents !== null && valueInCents !== void 0) {
      const clean7 = (valueInCents / 100).toString();
      if (value !== clean7) setValue(clean7);
    }
  }, [valueInCents]);
  const handleChange = (e) => {
    if (disabled) return;
    const raw = e.target.value;
    if (!/^[\d,]*\.?\d*$/.test(raw)) return;
    setValue(raw);
    const numeric2 = parseFloat(raw.replace(/,/g, ""));
    if (!isNaN(numeric2)) {
      onChange(numberToCents(numeric2));
    } else {
      onChange(void 0);
    }
  };
  const handleBlur = () => {
    if (disabled) return;
    const numeric2 = parseFloat(value.replace(/,/g, ""));
    if (!isNaN(numeric2)) {
      setValue(numeric2.toFixed(precision));
    }
    onBlurExternal == null ? void 0 : onBlurExternal();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TextInput$1,
    {
      block: true,
      id,
      type: "text",
      inputMode: "decimal",
      value,
      onChange: handleChange,
      onBlur: handleBlur,
      leadingVisual: currency,
      maxLength: 20,
      placeholder: "0.00",
      size: size2,
      disabled
    }
  );
};
const RoomTypeRow = ({
  roomType,
  formSettings,
  onUpdateRoomType,
  onDeleteRoomType,
  onEditMetadata,
  onEditAvailability,
  onAddRoomType
}) => {
  const [name2, setName] = useState(roomType.name);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: roomType.id
  });
  const style3 = {
    transform: CSS$1.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  };
  const columns = "1fr 8fr 8fr 8fr 8fr 8fr 2fr";
  const handleNameChange = (e) => {
    const newName = e.target.value;
    setName(newName);
    if (onUpdateRoomType) {
      onUpdateRoomType(roomType.id, { name: newName });
    }
  };
  const handleMinOccupancyChange = (e) => {
    const value = parseInt(e.target.value);
    if (!isNaN(value) && onUpdateRoomType) {
      onUpdateRoomType(roomType.id, { minOccupancy: value });
    }
  };
  const handleMaxOccupancyChange = (e) => {
    const value = parseInt(e.target.value);
    if (!isNaN(value) && onUpdateRoomType) {
      onUpdateRoomType(roomType.id, { maxOccupancy: value });
    }
  };
  const handlePriceChange = (priceInCents) => {
    if (onUpdateRoomType) {
      onUpdateRoomType(roomType.id, { price: priceInCents });
    }
  };
  const handleResortFeeChange = (resortFeeInCents) => {
    if (onUpdateRoomType) {
      onUpdateRoomType(roomType.id, { resortFee: resortFeeInCents });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      ref: setNodeRef,
      style: style3,
      sx: {
        display: "grid",
        gridTemplateColumns: columns,
        gap: 2,
        mb: 3,
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: GrabberIcon,
            "aria-label": "Grab",
            size: "large",
            variant: "invisible",
            sx: { color: "fg.muted", cursor: "grab" },
            ...attributes,
            ...listeners
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextInput$1,
          {
            size: "large",
            value: name2,
            placeholder: "Room Type Name",
            onChange: handleNameChange,
            width: "100%"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextInput$1,
          {
            size: "large",
            value: roomType.minOccupancy,
            onChange: handleMinOccupancyChange,
            type: "number",
            min: 1,
            max: roomType.maxOccupancy,
            width: "100%"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextInput$1,
          {
            size: "large",
            value: roomType.maxOccupancy,
            onChange: handleMaxOccupancyChange,
            type: "number",
            min: roomType.minOccupancy,
            width: "100%"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          PriceInput$2,
          {
            currency: formSettings.shoppingCartCurrency,
            onChange: handlePriceChange,
            valueInCents: roomType.price,
            size: "large"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          PriceInput$2,
          {
            currency: formSettings.shoppingCartCurrency,
            onChange: handleResortFeeChange,
            valueInCents: roomType.resortFee,
            size: "large"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "condensed", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            AnchoredOverlay,
            {
              open: isMenuOpen,
              onOpen: () => setIsMenuOpen(true),
              onClose: () => setIsMenuOpen(false),
              renderAnchor: (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                IconButton,
                {
                  ...props,
                  icon: KebabHorizontalIcon,
                  size: "large",
                  "aria-label": "Room type options",
                  "aria-labelledby": void 0,
                  onClick: () => setIsMenuOpen(true)
                }
              ),
              side: "outside-right",
              align: "end",
              anchorOffset: 20,
              children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionList, { role: "menu", children: [
                onEditAvailability !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  ActionList.Item,
                  {
                    role: "menuitem",
                    onSelect: () => onEditAvailability(roomType),
                    children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.LeadingVisual, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxIcon, { size: "small" }) }),
                      "Per Day Availability"
                    ]
                  }
                ),
                onEditMetadata !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  ActionList.Item,
                  {
                    role: "menuitem",
                    onSelect: () => onEditMetadata(roomType),
                    children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.LeadingVisual, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(PlusIcon, { size: "small" }) }),
                      "Data Tags"
                    ]
                  }
                ),
                onDeleteRoomType !== void 0 && !roomType.hasValidBookings && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Divider, {}),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    ActionList.Item,
                    {
                      variant: "danger",
                      role: "menuitem",
                      onSelect: () => onDeleteRoomType(roomType.id),
                      children: "Delete"
                    }
                  )
                ] })
              ] })
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              icon: PlusIcon,
              size: "large",
              "aria-label": "Add Room Type",
              onClick: () => onAddRoomType == null ? void 0 : onAddRoomType(roomType),
              variant: "primary",
              sx: {
                visibility: onAddRoomType ? "visible" : "hidden"
              }
            }
          )
        ] })
      ]
    }
  );
};
const Headers$2 = [
  "Room Type",
  "Min Occupancy",
  "Max Occupancy",
  "Rate",
  "Resort Fee"
];
const RoomTypeTableHeader = () => {
  const columns = "1fr 8fr 8fr 8fr 8fr 8fr 1fr 1fr";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      sx: {
        display: "grid",
        gridTemplateColumns: columns,
        gap: 2,
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { visibility: "hidden" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: GrabberIcon,
            "aria-label": "Grab",
            size: "large",
            variant: "invisible"
          }
        ) }),
        Headers$2.map((header) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          Text$2,
          {
            size: "medium",
            weight: "medium",
            sx: {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            children: header
          },
          header
        )),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { visibility: "hidden" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: GrabberIcon,
            "aria-label": "Action Button 1",
            size: "large",
            variant: "invisible"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { visibility: "hidden" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: GrabberIcon,
            "aria-label": "Action Button 2",
            size: "large",
            variant: "invisible"
          }
        ) })
      ]
    }
  );
};
const RoomTypeTable = ({
  roomBlock,
  onUpdateRoomType,
  onMoveRoomType,
  onDeleteRoomType,
  onAddRoomType,
  onEditAvailability
}) => {
  const { formSettings } = useRegForm();
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor)
  );
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (over && active.id !== over.id) {
      const oldIndex = roomBlock == null ? void 0 : roomBlock.roomTypes.findIndex(
        (t2) => t2.id === active.id
      );
      const newIndex = roomBlock == null ? void 0 : roomBlock.roomTypes.findIndex((t2) => t2.id === over.id);
      if (onMoveRoomType && oldIndex !== -1 && newIndex !== -1) {
        onMoveRoomType(oldIndex, newIndex);
      }
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(RoomTypeTableHeader, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      DndContext,
      {
        sensors,
        modifiers: [restrictToVerticalAxis],
        onDragEnd: handleDragEnd,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          SortableContext,
          {
            items: getSortedItems(roomBlock.roomTypes).map((t2) => t2.id),
            strategy: verticalListSortingStrategy,
            children: getSortedItems(roomBlock.roomTypes).map(
              (roomType, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                RoomTypeRow,
                {
                  roomType,
                  formSettings,
                  onUpdateRoomType,
                  onDeleteRoomType: roomBlock.roomTypes.length > 1 && !roomType.hasValidBookings ? onDeleteRoomType : void 0,
                  onEditAvailability,
                  onAddRoomType: index2 === roomBlock.roomTypes.length - 1 ? onAddRoomType : void 0
                },
                roomType.id
              )
            )
          }
        )
      }
    )
  ] });
};
const PercentageInput = ({
  onChange,
  value: initialValue,
  ...props
}) => {
  const safeInitialValue = Array.isArray(initialValue) ? initialValue[0] : initialValue;
  const [value, setValue] = useState(
    safeInitialValue
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TextInput$1,
    {
      ...props,
      value,
      onChange: (e) => {
        setValue(e.target.value);
        if (!isNaN(Number(e.target.value))) {
          onChange(Number(e.target.value));
        }
      },
      size: "large",
      type: "number",
      placeholder: "0",
      width: "100%",
      leadingVisual: "%"
    }
  );
};
const CapacityInput$1 = ({
  id,
  value = "",
  defaultValue: defaultValue2 = 0,
  onChange,
  block: block2 = false,
  size: size2 = "large",
  ...props
}) => {
  const handleChange = (e) => {
    const valueAsNumber = parseInt(e.target.value, 10);
    if (isNaN(valueAsNumber)) {
      onChange(defaultValue2);
    } else {
      onChange(valueAsNumber);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TextInput$1,
    {
      id,
      type: "number",
      min: 0,
      value,
      onChange: handleChange,
      size: size2,
      placeholder: "0",
      block: block2
    }
  );
};
const EditAvailabilityModal = ({
  roomBlock,
  isOpen,
  onSave,
  onCancel
}) => {
  const nights = getRoomBlockDateRange(roomBlock);
  const allRoomNights = roomBlock.roomTypes.flatMap(
    (roomType) => roomType.nights
  );
  const dateToRoomNightMap = /* @__PURE__ */ new Map();
  allRoomNights.forEach((roomNight) => {
    const dateKey = format$2(roomNight.date, "yyyy-MM-dd");
    dateToRoomNightMap.set(dateKey, roomNight);
  });
  const [availabilityChanges, setAvailabilityChanges] = React__default.useState(/* @__PURE__ */ new Map());
  const handleAvailabilityChange = (dateKey, availability) => {
    setAvailabilityChanges((prev2) => new Map(prev2).set(dateKey, availability));
  };
  const handleSave = () => {
    const updates = [];
    availabilityChanges.forEach((availability, dateKey) => {
      const roomNight = dateToRoomNightMap.get(dateKey);
      if (roomNight) {
        updates.push({ roomNight, availability });
      }
    });
    onSave(updates);
  };
  const getCurrentAvailability = (dateKey) => {
    const changedValue = availabilityChanges.get(dateKey);
    if (changedValue !== void 0) {
      return changedValue;
    }
    const roomNight = dateToRoomNightMap.get(dateKey);
    return (roomNight == null ? void 0 : roomNight.availability) || 0;
  };
  const dialogContent = /* @__PURE__ */ jsxRuntimeExports.jsx(
    NestedPrimerDialog,
    {
      isOpen,
      onClose: onCancel,
      title: `Availability / ${roomBlock.name}`,
      width: "large",
      titleIcon: HomeIcon,
      renderFooter: () => /* @__PURE__ */ jsxRuntimeExports.jsx(
        GregDialogFooter,
        {
          leftButtonText: "Cancel",
          rightButtonText: "Save",
          onLeftButtonClick: onCancel,
          onRightButtonClick: handleSave
        }
      ),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { gap: "normal", block: true, children: nights.map((night) => {
        const dateKey = format$2(night, "yyyy-MM-dd");
        const roomNight = dateToRoomNightMap.get(dateKey);
        if (!roomNight) return null;
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: format$2(night, "EEEE d MMM yyyy") }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1.Caption, { children: [
            "Available rooms for ",
            format$2(night, "EEEE d MMM yyyy")
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            CapacityInput$1,
            {
              value: getCurrentAvailability(dateKey),
              onChange: (value) => handleAvailabilityChange(dateKey, value),
              block: true,
              size: "large"
            }
          )
        ] }, night.toISOString());
      }) })
    }
  );
  return isOpen ? dialogContent : null;
};
const RoomBlockForm = React__default.forwardRef(({ roomBlock, onSubmit, isEditing = false }, ref2) => {
  const { formSettings } = useRegForm();
  const [taxRateEnabled, setTaxRateEnabled] = useState(!!(roomBlock == null ? void 0 : roomBlock.taxRate));
  const [availabilityModalOpen, setAvailabilityModalOpen] = useState(false);
  const [selectedRoomType, setSelectedRoomType] = useState(null);
  const defaultRoomType = {
    ...roomTypeDefaults,
    id: idGenerator(),
    sort: getNextSort([]),
    name: "Standard Room",
    price: 1e4,
    minOccupancy: 1,
    maxOccupancy: 2,
    nights: []
  };
  const {
    control,
    register: register2,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: {
      name: (roomBlock == null ? void 0 : roomBlock.name) || "",
      description: "",
      startDate: (roomBlock == null ? void 0 : roomBlock.startDate) || formSettings.startDate,
      endDate: (roomBlock == null ? void 0 : roomBlock.endDate) || formSettings.endDate,
      collectPayment: (roomBlock == null ? void 0 : roomBlock.collectPayment) || false,
      hidePrices: (roomBlock == null ? void 0 : roomBlock.hidePrices) || false,
      taxRate: roomBlock == null ? void 0 : roomBlock.taxRate,
      roomTypes: (roomBlock == null ? void 0 : roomBlock.roomTypes) || [defaultRoomType]
    }
  });
  const { append: append3, remove, move: move4, update: update2 } = useFieldArray({
    control,
    name: "roomTypes"
  });
  const watchedValues = watch();
  useEffect(() => {
    if (watchedValues.startDate && watchedValues.endDate && watchedValues.roomTypes.length > 0) {
      const roomTypesNeedNights = watchedValues.roomTypes.some((rt) => rt.nights.length === 0);
      if (roomTypesNeedNights) {
        const roomBlockWithDates = {
          ...watchedValues,
          startDate: watchedValues.startDate,
          endDate: watchedValues.endDate
        };
        const updatedRoomBlock = setRoomTypeNights(roomBlockWithDates);
        updatedRoomBlock.roomTypes.forEach((roomType, index2) => {
          var _a3;
          if (((_a3 = watchedValues.roomTypes[index2]) == null ? void 0 : _a3.nights.length) === 0) {
            update2(index2, roomType);
          }
        });
      }
    }
  }, [watchedValues.startDate, watchedValues.endDate, watchedValues.roomTypes.length, update2]);
  React__default.useImperativeHandle(ref2, () => ({
    triggerSave: () => {
      handleSubmit(onSubmit)();
    }
  }));
  const handleAddRoomType = () => {
    const newRoomType = {
      ...roomTypeDefaults,
      id: idGenerator(),
      sort: getNextSort(watchedValues.roomTypes),
      name: `Room Type ${watchedValues.roomTypes.length + 1}`,
      price: 1e4,
      // $100 default price
      minOccupancy: 1,
      maxOccupancy: 2,
      nights: []
    };
    const roomBlockWithNewType = {
      ...watchedValues,
      roomTypes: [...watchedValues.roomTypes, newRoomType]
    };
    if (watchedValues.startDate && watchedValues.endDate) {
      const updatedRoomBlock = setRoomTypeNights(roomBlockWithNewType);
      const newRoomTypeWithNights = updatedRoomBlock.roomTypes[updatedRoomBlock.roomTypes.length - 1];
      append3(newRoomTypeWithNights);
    } else {
      append3(newRoomType);
    }
  };
  const handleRemoveRoomType = (id) => {
    if (watchedValues.roomTypes.length <= 1) {
      return;
    }
    const index2 = watchedValues.roomTypes.findIndex((rt) => rt.id === id);
    if (index2 !== -1) {
      const roomType = watchedValues.roomTypes[index2];
      if (roomType.hasValidBookings) {
        console.warn("Cannot delete room type with existing bookings");
        return;
      }
      remove(index2);
    }
  };
  const handleMoveRoomType = (fromIndex, toIndex) => {
    move4(fromIndex, toIndex);
  };
  const handleUpdateRoomType = (id, updates) => {
    const index2 = watchedValues.roomTypes.findIndex((rt) => rt.id === id);
    if (index2 !== -1) {
      const currentRoomType = watchedValues.roomTypes[index2];
      const updatedRoomType = { ...currentRoomType, ...updates };
      update2(index2, updatedRoomType);
    }
  };
  const handleDateChange = (field, date) => {
    field.onChange(date);
    const startDate = field.name === "startDate" ? date : watchedValues.startDate;
    const endDate = field.name === "endDate" ? date : watchedValues.endDate;
    if (startDate && endDate && startDate < endDate) {
      const roomBlockWithNewDates = {
        ...watchedValues,
        startDate,
        endDate,
        roomTypes: watchedValues.roomTypes
      };
      const updatedRoomBlock = setRoomTypeNights(roomBlockWithNewDates);
      updatedRoomBlock.roomTypes.forEach((roomType, index2) => {
        update2(index2, roomType);
      });
    }
  };
  const handleEditAvailability = (roomType) => {
    setSelectedRoomType(roomType);
    setAvailabilityModalOpen(true);
  };
  const handleAvailabilitySave = (updates) => {
    const roomTypeUpdates = /* @__PURE__ */ new Map();
    updates.forEach(({ roomNight, availability }) => {
      const roomTypeIndex = watchedValues.roomTypes.findIndex(
        (rt) => rt.nights.some((night) => night.id === roomNight.id)
      );
      if (roomTypeIndex !== -1) {
        const currentRoomType = roomTypeUpdates.get(roomTypeIndex) || watchedValues.roomTypes[roomTypeIndex];
        const updatedNights = currentRoomType.nights.map(
          (night) => night.id === roomNight.id ? { ...night, availability } : night
        );
        roomTypeUpdates.set(roomTypeIndex, { ...currentRoomType, nights: updatedNights });
      }
    });
    roomTypeUpdates.forEach((roomType, roomTypeIndex) => {
      update2(roomTypeIndex, roomType);
    });
    setAvailabilityModalOpen(false);
    setSelectedRoomType(null);
  };
  const handleAvailabilityCancel = () => {
    setAvailabilityModalOpen(false);
    setSelectedRoomType(null);
  };
  const sortedRoomTypes = getSortedItems(watchedValues.roomTypes);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "form",
    {
      id: "room-block-form",
      onSubmit: handleSubmit(onSubmit),
      style: { height: "100%", display: "flex", flexDirection: "column" },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { required: true, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Name" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              TextInput$1,
              {
                block: true,
                size: "large",
                ...register2("name", { required: "Room block name is required" }),
                autoComplete: "off",
                "data-1p-ignore": "true",
                "data-lpignore": "true",
                "data-form-type": "other"
              }
            ),
            errors.name && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Validation, { variant: "error", children: errors.name.message })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { as: Stack, direction: "horizontal", gap: "normal", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { required: true, sx: { flex: 1 }, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Start Date" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Controller,
                {
                  name: "startDate",
                  control,
                  rules: { required: "Start date is required" },
                  render: ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                    DatePickerPrimer,
                    {
                      onChange: (date) => date && handleDateChange(field, date),
                      selectedDate: field.value,
                      maxDate: watchedValues.endDate,
                      placeholder: "Select Start Date"
                    }
                  )
                }
              ),
              errors.startDate && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Validation, { variant: "error", children: errors.startDate.message })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { required: true, sx: { flex: 1 }, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "End Date" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Controller,
                {
                  name: "endDate",
                  control,
                  rules: { required: "End date is required" },
                  render: ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                    DatePickerPrimer,
                    {
                      onChange: (date) => date && handleDateChange(field, date),
                      selectedDate: field.value,
                      minDate: watchedValues.startDate,
                      placeholder: "Select End Date"
                    }
                  )
                }
              ),
              errors.endDate && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Validation, { variant: "error", children: errors.endDate.message })
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { visuallyHidden: true }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Textarea,
              {
                rows: 3,
                ...register2("description"),
                placeholder: "Provide additional information about this room block.",
                resize: "vertical",
                block: true
              }
            ),
            errors.description && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Validation, { variant: "error", children: errors.description.message })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$1, { ...register2("collectPayment") }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Invoice Full Amount" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "The full amount will be added to the attendee invoice." })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$1, { ...register2("hidePrices") }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Hide Room Prices" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "Room prices will be hidden from attendees during the registration process." })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Checkbox$1,
                {
                  checked: taxRateEnabled,
                  onChange: (e) => setTaxRateEnabled(e.target.checked)
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Add a Tax Rate" }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1.Caption, { children: [
                "This will be added to the registration invoice as a separate line item.",
                taxRateEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Controller,
                  {
                    name: "taxRate",
                    control,
                    render: ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                      PercentageInput,
                      {
                        value: field.value,
                        onChange: field.onChange,
                        placeholder: "Tax rate",
                        size: "medium"
                      }
                    )
                  }
                )
              ] })
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Room Types", divider: false, defaultOpen: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            RoomTypeTable,
            {
              roomBlock: {
                ...roomBlock,
                startDate: watchedValues.startDate,
                endDate: watchedValues.endDate,
                roomTypes: sortedRoomTypes
              },
              onAddRoomType: handleAddRoomType,
              onDeleteRoomType: handleRemoveRoomType,
              onMoveRoomType: handleMoveRoomType,
              onUpdateRoomType: handleUpdateRoomType,
              onEditAvailability: handleEditAvailability
            }
          ) })
        ] }),
        selectedRoomType && /* @__PURE__ */ jsxRuntimeExports.jsx(
          EditAvailabilityModal,
          {
            roomBlock: {
              ...watchedValues,
              roomTypes: [selectedRoomType],
              // Only pass the selected room type
              id: (roomBlock == null ? void 0 : roomBlock.id) || "",
              numberBooked: (roomBlock == null ? void 0 : roomBlock.numberBooked) || 0
            },
            isOpen: availabilityModalOpen,
            onSave: handleAvailabilitySave,
            onCancel: handleAvailabilityCancel
          }
        )
      ]
    }
  );
});
RoomBlockForm.displayName = "RoomBlockForm";
const AddRoomBlock = React__default.forwardRef(({ onAdded }, ref2) => {
  const mutation = useAddRoomBlockPrimer({ onSuccess: onAdded });
  const handleSubmit = (data) => {
    const roomBlock = {
      name: data.name,
      startDate: data.startDate,
      endDate: data.endDate,
      collectPayment: data.collectPayment || false,
      hidePrices: data.hidePrices || false,
      taxRate: data.taxRate,
      roomTypes: data.roomTypes || []
    };
    const roomBlockWithNights = setRoomTypeNights(roomBlock);
    mutation.mutate(roomBlockWithNights);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    RoomBlockForm,
    {
      ref: ref2,
      onSubmit: handleSubmit,
      isEditing: false
    }
  );
});
AddRoomBlock.displayName = "AddRoomBlock";
const AddRoomBlockDialog = ({
  onAdded,
  isOpen,
  onClose
}) => {
  const addRoomBlockRef = React__default.useRef(null);
  const onSave = () => {
    if (addRoomBlockRef.current) {
      addRoomBlockRef.current.triggerSave();
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseDialog,
    {
      isOpen,
      onClose,
      title: "Add Room Block",
      width: "900px",
      position: "right",
      headerIcon: HomeIcon,
      leftButtonText: "Cancel",
      rightButtonText: "Add Room Block",
      onLeftButtonClick: onClose,
      onRightButtonClick: onSave,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        AddRoomBlock,
        {
          onAdded: (roomBlock) => {
            onAdded == null ? void 0 : onAdded(roomBlock);
            onClose();
          },
          ref: addRoomBlockRef
        }
      )
    }
  );
};
const EditRoomBlock = React__default.forwardRef(({ roomBlock, onUpdated }, ref2) => {
  const { form, formSettings, dispatch: formDispatch } = useRegForm();
  const mutation = useUpdateRoomBlock({
    onSuccess: (updatedRoomBlock) => {
      normalizeRoomingFieldDates(updatedRoomBlock, form, formDispatch);
      onUpdated == null ? void 0 : onUpdated(updatedRoomBlock);
    }
  });
  const handleSubmit = (data) => {
    const { description, ...formData } = data;
    const updatedRoomBlock = {
      ...roomBlock,
      ...formData
    };
    mutation.mutate(updatedRoomBlock);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    RoomBlockForm,
    {
      ref: ref2,
      roomBlock,
      onSubmit: handleSubmit,
      isEditing: true
    }
  );
});
EditRoomBlock.displayName = "EditRoomBlock";
const EditRoomBlockDialog = ({
  roomBlock,
  isOpen,
  onClose,
  onUpdated,
  onDeleted
}) => {
  const { form } = useRegForm();
  const deleteMutation = useDeleteRoomBlock({
    onSuccess: () => {
      onDeleted == null ? void 0 : onDeleted();
      onClose();
    }
  });
  const editRoomBlockRef = React__default.useRef(null);
  const handleSaveClick = () => {
    if (editRoomBlockRef.current) {
      editRoomBlockRef.current.triggerSave();
    }
  };
  const handleDeleteClick = () => {
    if (window.confirm(`Are you sure you want to delete "${roomBlock.name}"? This action cannot be undone.`)) {
      deleteMutation.mutate(roomBlock);
    }
  };
  const canDelete = roomBlock.numberBooked === 0 && !hasRoomBlockField(form, roomBlock);
  const headerActions = canDelete ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    ButtonComponent,
    {
      variant: "danger",
      size: "medium",
      leadingVisual: TrashIcon,
      onClick: handleDeleteClick,
      disabled: deleteMutation.isLoading,
      children: "Delete Room Block"
    }
  ) : void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseDialog,
    {
      isOpen,
      onClose,
      title: "Edit Room Block",
      width: "900px",
      position: "right",
      headerIcon: HomeIcon,
      headerActions,
      leftButtonText: "Cancel",
      rightButtonText: "Save",
      onLeftButtonClick: onClose,
      onRightButtonClick: () => {
        handleSaveClick();
        onClose();
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        EditRoomBlock,
        {
          ref: editRoomBlockRef,
          roomBlock,
          onUpdated
        }
      )
    }
  );
};
const RoomingManager = ({
  onSelectRoomBlock,
  renderButton
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isLoading, error: error2, data: roomBlocks2 } = useRoomBlocks();
  const [page, setPage] = useState(
    "ListRoomBlocks"
    /* ListRoomBlocks */
  );
  const [roomBlock, setRoomBlock] = useState();
  useEffect(() => {
    if (isOpen) {
      setPage(
        "ListRoomBlocks"
        /* ListRoomBlocks */
      );
    }
  }, [isOpen]);
  const handleAddToForm = (roomBlock2) => {
    onSelectRoomBlock(roomBlock2);
    setIsOpen(false);
  };
  const onClose = () => {
    setIsOpen(false);
    setPage(
      "ListRoomBlocks"
      /* ListRoomBlocks */
    );
  };
  const onAddNewSession = () => {
    setPage(
      "AddRoomBlock"
      /* AddRoomBlock */
    );
  };
  const handleEditRoomBlock = (roomBlock2) => {
    setRoomBlock(roomBlock2);
    setPage(
      "EditRoomBlock"
      /* EditRoomBlock */
    );
  };
  const handleRoomBlockDeleted = () => {
    setPage(
      "ListRoomBlocks"
      /* ListRoomBlocks */
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    renderButton({
      onClick: () => {
        setIsOpen(true);
      }
    }),
    page === "ListRoomBlocks" && /* @__PURE__ */ jsxRuntimeExports.jsxs(
      BaseDialog,
      {
        isOpen,
        onClose,
        title: "Room Blocks",
        width: "900px",
        position: "right",
        headerIcon: HomeIcon,
        showFooter: false,
        children: [
          isLoading && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {}),
          roomBlocks2 && roomBlocks2.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
            ListRoomBlocks,
            {
              onEditRoomBlock: handleEditRoomBlock,
              onSelectRoomBlock: handleAddToForm,
              onClose,
              onAddNewSession
            }
          ),
          (roomBlocks2 == null ? void 0 : roomBlocks2.length) === 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
            ListRoomBlocks,
            {
              onEditRoomBlock: handleEditRoomBlock,
              onSelectRoomBlock: handleAddToForm,
              onClose,
              onAddNewSession
            }
          )
        ]
      }
    ),
    page === "AddRoomBlock" && /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddRoomBlockDialog,
      {
        isOpen,
        onClose: () => setPage(
          "ListRoomBlocks"
          /* ListRoomBlocks */
        ),
        onAdded: (roomBlock2) => {
          setRoomBlock(roomBlock2);
          setPage(
            "EditRoomBlock"
            /* EditRoomBlock */
          );
        }
      }
    ),
    page === "EditRoomBlock" && roomBlock && /* @__PURE__ */ jsxRuntimeExports.jsx(
      EditRoomBlockDialog,
      {
        roomBlock,
        isOpen,
        onClose: () => setPage(
          "ListRoomBlocks"
          /* ListRoomBlocks */
        ),
        onUpdated: (updatedRoomBlock) => {
          setRoomBlock(updatedRoomBlock);
        },
        onDeleted: handleRoomBlockDeleted
      }
    )
  ] });
};
const defaultStyles = {
  borderRadius: 9999,
  height: 20,
  width: 20,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "neutral.muted"
};
const inFormStyles = {
  backgroundColor: "success.emphasis"
};
const SessionsTableItem = ({
  session,
  onEditSlots,
  onSelectSession,
  divider
}) => {
  const { form } = useRegForm();
  const inForm = hasSessionFormField(form, session);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Stack,
    {
      direction: "horizontal",
      gap: "condensed",
      align: "center",
      justify: "space-between",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { ...defaultStyles, ...inForm && inFormStyles }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckIcon, { size: 12, fill: "var(--fgColor-white) !important" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Box,
          {
            borderBottom: divider ? "1px solid" : "none",
            borderColor: "border.default",
            py: 2,
            width: "100%",
            children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
              Box,
              {
                sx: {
                  display: "grid",
                  gridTemplateColumns: "2fr 1fr",
                  gap: 2,
                  alignItems: "center",
                  width: "100%"
                },
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: session.name }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { justifySelf: "end" }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "condensed", children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      IconButton,
                      {
                        icon: GearIcon,
                        "aria-label": "Edit",
                        size: "large",
                        variant: "default",
                        onClick: () => onEditSlots(session),
                        tooltipDirection: "e"
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      ButtonComponent,
                      {
                        variant: "primary",
                        size: "large",
                        onClick: () => onSelectSession(session),
                        children: "Add To Form"
                      }
                    )
                  ] }) })
                ]
              }
            )
          }
        )
      ]
    }
  ) });
};
const SessionsTable = ({
  sessions,
  onSelectSession,
  onEditSlots,
  onDeleteSession
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "vertical", gap: "normal", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Bookable Sessions" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { direction: "vertical", gap: "none", children: sessions.map((session, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      SessionsTableItem,
      {
        session,
        onEditSlots,
        onSelectSession,
        divider: index2 !== sessions.length - 1
      },
      session.id
    )) })
  ] });
};
const ListSessions = ({
  onSelectSession,
  onEditSlots,
  onNewSession,
  onClose
}) => {
  const { isLoading, sessions } = useSessions();
  const mutation = useDeleteSession();
  const infoBannerText = `Getting Started: Bookable sessions are capacity-limited parts of the event that attendees can select. Each session offers multiple slots, if marked as required, attendees must choose an available slot to complete their registration, `;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      InfoBanner,
      {
        text: infoBannerText,
        linkText: "find out more...",
        href: "https://www.google.com"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { my: 3 }),
    isLoading && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {}),
    sessions && sessions.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
      SessionsTable,
      {
        sessions,
        onSelectSession,
        onEditSlots,
        onDeleteSession: (session) => mutation.mutate(session)
      }
    ),
    sessions && sessions.length === 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(BlankslateContainer, { size: "small", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(BlankslateContainer.Visual, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BookmarkIcon, { size: "medium" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(BlankslateContainer.Heading, { children: "No Bookable Sessions" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(BlankslateContainer.Description, { children: "Create your first bookable session to get started. Sessions are capacity-limited parts of your event that attendees can select during registration." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { my: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", justify: "space-between", align: "center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ButtonComponent,
        {
          variant: "invisible",
          size: "large",
          style: { minWidth: "150px" },
          onClick: onClose,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ButtonComponent,
        {
          variant: "default",
          size: "large",
          style: { minWidth: "150px" },
          onClick: onNewSession,
          leadingVisual: PlusIcon,
          children: "Add New Session"
        }
      )
    ] })
  ] });
};
const eventConfigs = {
  fourDay: {
    startDate: parseISO$1("2050-01-10"),
    endDate: parseISO$1("2050-01-13")
  },
  singleDay: {
    startDate: parseISO$1("2050-01-10"),
    endDate: parseISO$1("2050-01-10")
  }
};
const ListSessionsDialog = ({
  form,
  showPrices,
  currency,
  onSelectSession,
  onNewSession,
  onEditSlots,
  isOpen,
  onClose
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseDialog,
    {
      isOpen,
      onClose,
      title: "Add Session",
      width: "900px",
      position: "right",
      headerIcon: BookmarkIcon,
      showFooter: false,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        FormStateProvider,
        {
          formSettings: { ...defaultFormSettings, ...eventConfigs.fourDay },
          form,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            ListSessions,
            {
              form,
              onSelectSession,
              onEditSlots: onEditSlots || (() => {
              }),
              onNewSession: onNewSession || (() => {
              }),
              onClose
            }
          )
        }
      )
    }
  );
};
const CapacityInput = ({
  id,
  value = "",
  defaultValue: defaultValue2 = 0,
  onChange
}) => {
  const handleChange = (e) => {
    const valueAsNumber = parseInt(e.target.value, 10);
    if (isNaN(valueAsNumber)) {
      onChange(defaultValue2);
    } else {
      onChange(valueAsNumber);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    TextInput$1,
    {
      id,
      type: "number",
      min: 0,
      value,
      onChange: handleChange,
      size: "large",
      placeholder: "0",
      width: "100%"
    }
  ) });
};
const PriceInput$1 = ({
  id,
  valueInCents,
  defaultValue: defaultValue2,
  currency = "$",
  precision = 2,
  onChange
}) => {
  const [value, setValue] = useState(
    defaultValue2 !== void 0 ? (defaultValue2 / 100).toString() : ""
  );
  useEffect(() => {
    if (valueInCents !== null && valueInCents !== void 0) {
      const clean7 = (valueInCents / 100).toString();
      if (value !== clean7) setValue(clean7);
    }
  }, [valueInCents]);
  const handleChange = (e) => {
    const raw = e.target.value;
    if (!/^[\d,]*\.?\d*$/.test(raw)) return;
    setValue(raw);
    const numeric2 = parseFloat(raw.replace(/,/g, ""));
    if (!isNaN(numeric2)) {
      onChange(numberToCents(numeric2));
    } else {
      onChange(void 0);
    }
  };
  const handleBlur = () => {
    const numeric2 = parseFloat(value.replace(/,/g, ""));
    if (!isNaN(numeric2)) {
      setValue(numeric2.toFixed(precision));
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    TextInput$1,
    {
      id,
      type: "text",
      inputMode: "decimal",
      value,
      onChange: handleChange,
      onBlur: handleBlur,
      leadingVisual: currency,
      maxLength: 20,
      placeholder: "0.00",
      size: "large",
      width: "100%"
    }
  ) });
};
const SlotsTableItem = ({
  slot,
  session,
  index: index2,
  onUpdateSlot,
  onDeleteSlot,
  onEditMetadata,
  onEditDetails,
  formSettings,
  onAddSlot
}) => {
  const [name2, setName] = useState(slot.name);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: slot.id
  });
  const style3 = {
    transform: CSS$1.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  };
  const handleNameChange = (e) => {
    const newName = e.target.value;
    setName(newName);
    onUpdateSlot({ ...slot, name: newName });
  };
  const handleCapacityChange = (totalCapacity) => {
    onUpdateSlot({ ...slot, totalCapacity });
  };
  const handlePriceChange = (priceInCents) => {
    onUpdateSlot({ ...slot, priceInCents: priceInCents || null });
  };
  const gridTemplateColumns2 = (formSettings == null ? void 0 : formSettings.shoppingCartEnabled) ? "1fr 8fr 8fr 8fr 8fr 1fr 1fr" : "1fr 8fr 8fr 8fr 1fr 1fr";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      as: Stack,
      direction: "horizontal",
      ref: setNodeRef,
      style: style3,
      sx: {
        display: "grid",
        gridTemplateColumns: gridTemplateColumns2,
        gap: 2
      },
      mb: 3,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: GrabberIcon,
            "aria-label": "Grab",
            size: "large",
            variant: "invisible",
            sx: { color: "fg.muted", cursor: "grab" },
            ...attributes,
            ...listeners
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextInput$1,
          {
            size: "large",
            value: name2,
            placeholder: "Name",
            onChange: handleNameChange,
            width: "100%"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CapacityInput,
          {
            value: slot.totalCapacity,
            onChange: handleCapacityChange
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextInput$1,
          {
            size: "large",
            value: slot == null ? void 0 : slot.numberBooked,
            placeholder: "Booked",
            disabled: true,
            width: "100%"
          }
        ),
        (formSettings == null ? void 0 : formSettings.shoppingCartEnabled) && /* @__PURE__ */ jsxRuntimeExports.jsx(
          PriceInput$1,
          {
            valueInCents: slot.priceInCents,
            currency: (formSettings == null ? void 0 : formSettings.shoppingCartCurrency) || "$",
            onChange: handlePriceChange
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          AnchoredOverlay,
          {
            open: isMenuOpen,
            onOpen: () => setIsMenuOpen(true),
            onClose: () => setIsMenuOpen(false),
            renderAnchor: (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              IconButton,
              {
                ...props,
                icon: KebabHorizontalIcon,
                size: "large",
                "aria-label": "Page options",
                "aria-labelledby": void 0,
                onClick: () => setIsMenuOpen(true)
              }
            ),
            side: "outside-right",
            align: "end",
            anchorOffset: 20,
            children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionList, { role: "menu", children: [
              onEditDetails !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
                ActionList.Item,
                {
                  role: "menuitem",
                  onSelect: () => onEditDetails(slot),
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.LeadingVisual, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxIcon, { size: "small" }) }),
                    "Slot Details"
                  ]
                }
              ),
              onEditMetadata !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
                ActionList.Item,
                {
                  role: "menuitem",
                  onSelect: () => onEditMetadata(slot),
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.LeadingVisual, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(PlusIcon, { size: "small" }) }),
                    "Data Tags"
                  ]
                }
              ),
              onDeleteSlot !== void 0 && canDeleteSlot(slot, session) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Divider, {}),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  ActionList.Item,
                  {
                    variant: "danger",
                    role: "menuitem",
                    onSelect: () => onDeleteSlot(slot),
                    children: "Delete"
                  }
                )
              ] })
            ] })
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: PlusIcon,
            size: "large",
            "aria-label": "Add Slot",
            onClick: onAddSlot ?? void 0,
            variant: "primary",
            sx: {
              visibility: onAddSlot ? "visible" : "hidden"
            }
          }
        )
      ]
    }
  );
};
const Headers$1 = ["Name", "Total Capacity", "Total Booked"];
const SlotTableHeader = () => {
  const { formSettings } = useRegForm();
  const gridTemplateColumns2 = (formSettings == null ? void 0 : formSettings.shoppingCartEnabled) ? "1fr 8fr 8fr 8fr 8fr 1fr 1fr" : "1fr 8fr 8fr 8fr 1fr 1fr";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      sx: {
        display: "grid",
        gridTemplateColumns: gridTemplateColumns2,
        gap: 2,
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { visibility: "hidden" }, bg: "blue", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: GrabberIcon,
            "aria-label": "Grab",
            size: "large",
            variant: "invisible"
          }
        ) }),
        Headers$1.map((header) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          Text$2,
          {
            size: "medium",
            weight: "medium",
            sx: {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            children: header
          },
          header
        )),
        (formSettings == null ? void 0 : formSettings.shoppingCartEnabled) && /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Price ($)" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { visibility: "hidden" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: GrabberIcon,
            "aria-label": "Grab",
            size: "large",
            variant: "invisible"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { visibility: "hidden" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: GrabberIcon,
            "aria-label": "Grab",
            size: "large",
            variant: "invisible"
          }
        ) })
      ]
    }
  );
};
const SlotsTable = ({
  session,
  onUpdateSlot,
  onDeleteSlot,
  onMoveSlot,
  onEditMetadata,
  onEditDetails,
  onAddSlot
}) => {
  const { formSettings } = useRegForm();
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor)
  );
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (over && active.id !== over.id && session) {
      const oldIndex = session.slots.findIndex((s2) => s2.id === active.id);
      const newIndex = session.slots.findIndex((s2) => s2.id === over.id);
      if (oldIndex !== -1 && newIndex !== -1) {
        onMoveSlot(oldIndex, newIndex);
      }
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(SlotTableHeader, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      DndContext,
      {
        sensors,
        modifiers: [restrictToVerticalAxis],
        onDragEnd: handleDragEnd,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          SortableContext,
          {
            items: (session == null ? void 0 : session.slots.map((s2) => s2.id)) ?? [],
            strategy: verticalListSortingStrategy,
            children: session == null ? void 0 : session.slots.map((slot, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              SlotsTableItem,
              {
                index: index2,
                slot,
                session,
                onUpdateSlot,
                onDeleteSlot,
                onEditMetadata,
                onEditDetails,
                formSettings: {
                  shoppingCartEnabled: formSettings.shoppingCartEnabled,
                  shoppingCartCurrency: formSettings.shoppingCartCurrency
                },
                onAddSlot: index2 === (session == null ? void 0 : session.slots.length) - 1 ? onAddSlot : void 0
              },
              slot.id
            ))
          }
        )
      }
    )
  ] });
};
const useAddSessionWithSlots = (options) => {
  const { sessions } = useAdminApi();
  const queryClient = useQueryClient();
  const mutateFn = (newSession) => sessions.createSessionWithSlots(newSession);
  return useMutation(mutateFn, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.refetchQueries({ queryKey: ["sessions"] });
    }
  });
};
const EditSlotDetailsModal = ({
  slot,
  isOpen,
  onSave,
  onCancel
}) => {
  const { formSettings } = useRegForm();
  const parseDate2 = (date) => {
    if (!date) return void 0;
    return typeof date === "string" ? parseISO$1(date) : date;
  };
  const {
    handleSubmit,
    register: register2,
    control,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: {
      description: slot.description || "",
      startTime: parseDate2(slot.startTime),
      endTime: parseDate2(slot.endTime)
    }
  });
  const watchedValues = watch();
  const handleSave = (data) => {
    onSave({
      description: data.description,
      startTime: data.startTime,
      endTime: data.endTime
    });
  };
  const dialogContent = /* @__PURE__ */ jsxRuntimeExports.jsx(
    NestedPrimerDialog,
    {
      isOpen,
      title: `Slot / ${slot.name}`,
      onClose: onCancel,
      width: "large",
      titleIcon: BookmarkIcon,
      renderFooter: () => /* @__PURE__ */ jsxRuntimeExports.jsx(
        GregDialogFooter,
        {
          leftButtonText: "Cancel",
          rightButtonText: "Save",
          onLeftButtonClick: onCancel,
          onRightButtonClick: handleSubmit(handleSave)
        }
      ),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("form", { id: "slot-details-form", onSubmit: handleSubmit(handleSave), children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { sx: { flex: 1 }, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Start Time" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Controller,
              {
                name: "startTime",
                control,
                rules: { required: "Start time is required" },
                render: ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                  DatePickerPrimer,
                  {
                    selectedDate: field.value,
                    onChange: field.onChange,
                    showTimeSelect: true,
                    placeholder: "Select start date and time"
                  }
                )
              }
            ),
            errors.startTime && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Validation, { variant: "error", children: errors.startTime.message })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { sx: { flex: 1 }, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "End Time" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Controller,
              {
                name: "endTime",
                control,
                rules: { required: "End time is required" },
                render: ({ field }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                  DatePickerPrimer,
                  {
                    selectedDate: field.value,
                    onChange: field.onChange,
                    showTimeSelect: true,
                    placeholder: "Select end date and time",
                    minDate: watchedValues.startTime
                  }
                )
              }
            ),
            errors.endTime && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Validation, { variant: "error", children: errors.endTime.message })
          ] })
        ] }),
        formSettings.sessionSlotDescriptionsEnabled && /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Sessions Description" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Textarea,
            {
              ...register2("description"),
              placeholder: "Provide additional information to help the attendee.",
              resize: "vertical",
              block: true
            }
          )
        ] })
      ] }) })
    }
  );
  return isOpen ? dialogContent : null;
};
const SessionForm = forwardRef$1(({ mode, initialSession, formRef, onAdded, onUpdated }, ref2) => {
  const [slotDetailsModal, setSlotDetailsModal] = useState({ isOpen: false, slot: null });
  const [metadataModal, setMetadataModal] = useState({ isOpen: false, slot: null });
  const addMutation = useAddSessionWithSlots();
  const updateMutation = useUpdateSession();
  const getInitialSession = () => {
    if (mode === "edit" && initialSession) {
      return initialSession;
    }
    const defaultSlot = {
      ...initializeSlot({
        slots: []
      }),
      id: idGenerator(),
      isNew: true,
      // Mark as new slot
      sort: 1
    };
    return {
      id: 0,
      slots: [defaultSlot],
      name: "",
      description: "",
      checkpointCreation: 0
    };
  };
  const [session, dispatch] = useReducer(reducer$3, getInitialSession());
  const {
    handleSubmit,
    register: register2,
    getValues,
    setValue,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: {
      name: session.name,
      description: session.description,
      checkpointCreation: session.checkpointCreation
    }
  });
  React__default.useImperativeHandle(ref2, () => ({
    triggerSave: () => {
      handleSubmit(onSubmit)();
    }
  }));
  const onSubmit = (data) => {
    if (mode === "add") {
      const sessionData = {
        ...data,
        slots: session.slots
      };
      addMutation.mutate(sessionData, {
        onSuccess: (newSession) => {
          onAdded == null ? void 0 : onAdded(newSession);
        }
      });
    } else {
      const sessionData = {
        ...data,
        slots: session.slots,
        deletedSlots: session.deletedSlots
      };
      updateMutation.mutate(
        { ...sessionData, id: session.id },
        {
          onSuccess: (updatedSession) => {
            onUpdated == null ? void 0 : onUpdated(updatedSession);
          }
        }
      );
    }
  };
  const handleAddSlot = () => {
    const newSlot = {
      ...initializeSlot(session),
      id: idGenerator(),
      isNew: true,
      sort: session.slots.length + 1
    };
    dispatch({ type: "add_slot", payload: newSlot });
  };
  const handleUpdateSlot = (slotData) => {
    dispatch({ type: "update_slot", payload: slotData });
  };
  const handleDeleteSlot = (slot) => {
    dispatch({ type: "delete_slot", payload: slot });
  };
  const handleMoveSlot = (fromIndex, toIndex) => {
    dispatch({ type: "move_slot", fromIndex, toIndex });
  };
  const handleEditSlotDetails = (slot) => {
    setSlotDetailsModal({ isOpen: true, slot });
  };
  const handleEditMetadata = (slot) => {
    setMetadataModal({ isOpen: true, slot });
  };
  const handleCloseSlotDetails = () => {
    setSlotDetailsModal({ isOpen: false, slot: null });
  };
  const handleCloseMetadata = () => {
    setMetadataModal({ isOpen: false, slot: null });
  };
  const handleUpdateSlotDetails = (slotData) => {
    if (slotDetailsModal.slot) {
      handleUpdateSlot({ ...slotDetailsModal.slot, ...slotData });
    }
    handleCloseSlotDetails();
  };
  const handleUpdateMetadata = (metadata) => {
    if (metadataModal.slot) {
      handleUpdateSlot({
        ...metadataModal.slot,
        metadata
      });
    }
    handleCloseMetadata();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("form", { ref: formRef, id: "add-session-form", onSubmit: handleSubmit(onSubmit), children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Session Name *" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { required: true, id: "room_block_name", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { visuallyHidden: true }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextInput$1,
          {
            size: "large",
            ...register2("name", { required: "Session name is required" }),
            placeholder: "Session name",
            autoComplete: "off",
            "data-1p-ignore": "true",
            "data-lpignore": "true",
            "data-form-type": "other",
            block: true
          }
        ),
        errors.name && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Validation, { variant: "error", children: errors.name && errors.name.message })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Session Description" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { visuallyHidden: true }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Textarea,
          {
            rows: 2,
            ...register2("description"),
            placeholder: "Provide additional instructions to help the attendee.",
            block: true
          }
        ),
        errors.description && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Validation, { variant: "error", children: errors.description && errors.description.message })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Bookable Sessions Options", divider: false, defaultOpen: true, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "spacious", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          InfoBanner,
          {
            text: "Checkpoints are used by the GR Check-in app to track attendee access to sessions. Choose from multiple setup options to find the best fit for your needs, ",
            linkText: "find out more",
            href: "https://www.google.com"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Checkpoint Creation" }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { sx: { marginTop: "3px" }, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { visuallyHidden: true }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              Select$1,
              {
                id: "checkpointCreation",
                ...register2("checkpointCreation", { valueAsNumber: true }),
                size: "large",
                block: true,
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Select$1.Option, { value: "0", children: "No Checkpoints" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Select$1.Option, { value: "1", children: "Checkpoints Per Session" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Select$1.Option, { value: "2", children: "Checkpoints Per Session Slots" })
                ]
              }
            )
          ] })
        ] })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Session Slots", divider: false, defaultOpen: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        SlotsTable,
        {
          session,
          onUpdateSlot: handleUpdateSlot,
          onDeleteSlot: handleDeleteSlot,
          onMoveSlot: handleMoveSlot,
          onEditMetadata: handleEditMetadata,
          onEditDetails: handleEditSlotDetails,
          onAddSlot: handleAddSlot
        }
      ) })
    ] }) }),
    slotDetailsModal.isOpen && slotDetailsModal.slot && /* @__PURE__ */ jsxRuntimeExports.jsx(
      EditSlotDetailsModal,
      {
        slot: slotDetailsModal.slot,
        isOpen: slotDetailsModal.isOpen,
        onCancel: handleCloseSlotDetails,
        onSave: handleUpdateSlotDetails
      }
    ),
    metadataModal.isOpen && metadataModal.slot && /* @__PURE__ */ jsxRuntimeExports.jsx(
      MetadataModalPrimer,
      {
        isOpen: metadataModal.isOpen,
        onClose: handleCloseMetadata,
        onSave: handleUpdateMetadata,
        metadata: metadataModal.slot.metadata || []
      }
    )
  ] });
});
SessionForm.displayName = "SessionForm";
const AddSession = ({ formRef, onAdded }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SessionForm,
    {
      mode: "add",
      formRef,
      onAdded
    }
  );
};
const AddSessionDialog = ({
  onAdded,
  isOpen,
  onClose
}) => {
  const formRef = React__default.createRef();
  const onSave = () => {
    var _a3;
    (_a3 = formRef == null ? void 0 : formRef.current) == null ? void 0 : _a3.dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseDialog,
    {
      isOpen,
      onClose,
      title: "Add Bookable Session",
      width: "900px",
      position: "right",
      headerIcon: BookmarkIcon,
      leftButtonText: "Cancel",
      rightButtonText: "Add Session",
      onLeftButtonClick: onClose,
      onRightButtonClick: onSave,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        AddSession,
        {
          formRef,
          onAdded: (session) => {
            onAdded == null ? void 0 : onAdded.call(void 0, session);
          }
        }
      )
    }
  );
};
const EditSession = React__default.forwardRef(({ session, onUpdated }, ref2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SessionForm,
    {
      ref: ref2,
      mode: "edit",
      initialSession: session,
      onUpdated
    }
  );
});
EditSession.displayName = "EditSession";
const SessionBookingManager = ({
  form,
  showPrices,
  currency,
  onSelectSession,
  renderButton
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [page, setPage] = useState(
    "ListSessions"
    /* ListSessions */
  );
  const [session, setSession] = useState(null);
  const editSessionFormRef = useRef(null);
  const handleSaveClick = () => {
    if (page === "EditSession" && editSessionFormRef.current) {
      editSessionFormRef.current.triggerSave();
    }
    setPage(
      "ListSessions"
      /* ListSessions */
    );
  };
  useEffect(() => {
    if (isOpen) {
      setPage(
        "ListSessions"
        /* ListSessions */
      );
    }
  }, [isOpen]);
  const onClose = () => {
    setIsOpen(false);
    setPage(
      "ListSessions"
      /* ListSessions */
    );
  };
  const handleEditSession = (session2) => {
    setSession(session2);
    setPage(
      "EditSession"
      /* EditSession */
    );
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    renderButton({
      onClick: () => {
        setIsOpen(true);
      }
    }),
    page === "ListSessions" && /* @__PURE__ */ jsxRuntimeExports.jsx(
      ListSessionsDialog,
      {
        form,
        showPrices,
        currency,
        onSelectSession: (session2) => {
          onSelectSession(session2);
          onClose();
        },
        onNewSession: () => setPage(
          "AddSession"
          /* AddSession */
        ),
        onEditSlots: handleEditSession,
        isOpen,
        onClose
      }
    ),
    page === "AddSession" && /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddSessionDialog,
      {
        isOpen,
        onClose: () => setPage(
          "ListSessions"
          /* ListSessions */
        ),
        onAdded: () => {
          setPage(
            "ListSessions"
            /* ListSessions */
          );
        }
      }
    ),
    page === "EditSession" && /* @__PURE__ */ jsxRuntimeExports.jsx(
      BaseDialog,
      {
        isOpen,
        onClose,
        title: "Edit Bookable Session",
        width: "900px",
        position: "right",
        headerIcon: BookmarkIcon,
        leftButtonText: "Cancel",
        rightButtonText: "Save",
        onLeftButtonClick: onClose,
        onRightButtonClick: () => {
          handleSaveClick();
          onClose();
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          EditSession,
          {
            ref: editSessionFormRef,
            session
          }
        )
      }
    )
  ] });
};
function stringify$1(values2, options) {
  const settings = {};
  const input = values2[values2.length - 1] === "" ? [...values2, ""] : values2;
  return input.join(
    (settings.padRight ? " " : "") + "," + (settings.padLeft === false ? "" : " ")
  ).trim();
}
const nameRe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;
const nameReJsx = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;
const emptyOptions$1 = {};
function name(name2, options) {
  const settings = emptyOptions$1;
  const re2 = settings.jsx ? nameReJsx : nameRe;
  return re2.test(name2);
}
const re = /[ \t\n\f\r]/g;
function whitespace$1(thing) {
  return typeof thing === "object" ? thing.type === "text" ? empty$1(thing.value) : false : empty$1(thing);
}
function empty$1(value) {
  return value.replace(re, "") === "";
}
let Schema$1 = class Schema {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(property, normal, space2) {
    this.normal = normal;
    this.property = property;
    if (space2) {
      this.space = space2;
    }
  }
};
Schema$1.prototype.normal = {};
Schema$1.prototype.property = {};
Schema$1.prototype.space = void 0;
function merge2(definitions, space2) {
  const property = {};
  const normal = {};
  for (const definition2 of definitions) {
    Object.assign(property, definition2.property);
    Object.assign(normal, definition2.normal);
  }
  return new Schema$1(property, normal, space2);
}
function normalize$2(value) {
  return value.toLowerCase();
}
class Info {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(property, attribute) {
    this.attribute = attribute;
    this.property = property;
  }
}
Info.prototype.attribute = "";
Info.prototype.booleanish = false;
Info.prototype.boolean = false;
Info.prototype.commaOrSpaceSeparated = false;
Info.prototype.commaSeparated = false;
Info.prototype.defined = false;
Info.prototype.mustUseProperty = false;
Info.prototype.number = false;
Info.prototype.overloadedBoolean = false;
Info.prototype.property = "";
Info.prototype.spaceSeparated = false;
Info.prototype.space = void 0;
let powers = 0;
const boolean = increment();
const booleanish = increment();
const overloadedBoolean = increment();
const number = increment();
const spaceSeparated = increment();
const commaSeparated = increment();
const commaOrSpaceSeparated = increment();
function increment() {
  return 2 ** ++powers;
}
const types = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean,
  booleanish,
  commaOrSpaceSeparated,
  commaSeparated,
  number,
  overloadedBoolean,
  spaceSeparated
}, Symbol.toStringTag, { value: "Module" }));
const checks = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(types)
);
class DefinedInfo extends Info {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(property, attribute, mask, space2) {
    let index2 = -1;
    super(property, attribute);
    mark(this, "space", space2);
    if (typeof mask === "number") {
      while (++index2 < checks.length) {
        const check = checks[index2];
        mark(this, checks[index2], (mask & types[check]) === types[check]);
      }
    }
  }
}
DefinedInfo.prototype.defined = true;
function mark(values2, key2, value) {
  if (value) {
    values2[key2] = value;
  }
}
function create(definition2) {
  const properties2 = {};
  const normals = {};
  for (const [property, value] of Object.entries(definition2.properties)) {
    const info = new DefinedInfo(
      property,
      definition2.transform(definition2.attributes || {}, property),
      value,
      definition2.space
    );
    if (definition2.mustUseProperty && definition2.mustUseProperty.includes(property)) {
      info.mustUseProperty = true;
    }
    properties2[property] = info;
    normals[normalize$2(property)] = property;
    normals[normalize$2(info.attribute)] = property;
  }
  return new Schema$1(properties2, normals, definition2.space);
}
const aria = create({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  },
  transform(_2, property) {
    return property === "role" ? property : "aria-" + property.slice(4).toLowerCase();
  }
});
function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute;
}
function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase());
}
const html$2 = create({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: boolean,
    allowPaymentRequest: boolean,
    allowUserMedia: boolean,
    alt: null,
    as: null,
    async: boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean,
    autoPlay: boolean,
    blocking: spaceSeparated,
    capture: null,
    charSet: null,
    checked: boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean,
    defer: boolean,
    dir: null,
    dirName: null,
    disabled: boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: overloadedBoolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: boolean,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: boolean,
    muted: boolean,
    name: null,
    nonce: null,
    noModule: boolean,
    noValidate: boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean,
    reversed: boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean,
    seamless: boolean,
    selected: boolean,
    shadowRootClonable: boolean,
    shadowRootDelegatesFocus: boolean,
    shadowRootMode: null,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: number,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: boolean,
    // Lists. Use CSS to reduce space between items instead
    declare: boolean,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: number,
    // `<img>` and `<object>`
    leftMargin: number,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: number,
    // `<body>`
    marginWidth: number,
    // `<body>`
    noResize: boolean,
    // `<frame>`
    noHref: boolean,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: number,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: booleanish,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: number,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean,
    disableRemotePlayback: boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: caseInsensitiveTransform
});
const svg$1 = create({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: caseSensitiveTransform
});
const xlink = create({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(_2, property) {
    return "xlink:" + property.slice(5).toLowerCase();
  }
});
const xmlns = create({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: caseInsensitiveTransform
});
const xml = create({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(_2, property) {
    return "xml:" + property.slice(3).toLowerCase();
  }
});
const hastToReact = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
};
const cap$1 = /[A-Z]/g;
const dash = /-[a-z]/g;
const valid = /^data[-\w.:]+$/i;
function find$1(schema, value) {
  const normal = normalize$2(value);
  let property = value;
  let Type = Info;
  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]];
  }
  if (normal.length > 4 && normal.slice(0, 4) === "data" && valid.test(value)) {
    if (value.charAt(4) === "-") {
      const rest = value.slice(5).replace(dash, camelcase);
      property = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
    } else {
      const rest = value.slice(4);
      if (!dash.test(rest)) {
        let dashes = rest.replace(cap$1, kebab);
        if (dashes.charAt(0) !== "-") {
          dashes = "-" + dashes;
        }
        value = "data" + dashes;
      }
    }
    Type = DefinedInfo;
  }
  return new Type(property, value);
}
function kebab($0) {
  return "-" + $0.toLowerCase();
}
function camelcase($0) {
  return $0.charAt(1).toUpperCase();
}
const html$1 = merge2([aria, html$2, xlink, xmlns, xml], "html");
const svg = merge2([aria, svg$1, xlink, xmlns, xml], "svg");
function stringify(values2) {
  return values2.join(" ").trim();
}
var cjs$1 = {};
var inlineStyleParser;
var hasRequiredInlineStyleParser;
function requireInlineStyleParser() {
  if (hasRequiredInlineStyleParser) return inlineStyleParser;
  hasRequiredInlineStyleParser = 1;
  var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
  var NEWLINE_REGEX = /\n/g;
  var WHITESPACE_REGEX = /^\s*/;
  var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
  var COLON_REGEX = /^:\s*/;
  var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
  var SEMICOLON_REGEX = /^[;\s]*/;
  var TRIM_REGEX = /^\s+|\s+$/g;
  var NEWLINE = "\n";
  var FORWARD_SLASH = "/";
  var ASTERISK2 = "*";
  var EMPTY_STRING = "";
  var TYPE_COMMENT = "comment";
  var TYPE_DECLARATION = "declaration";
  inlineStyleParser = function(style3, options) {
    if (typeof style3 !== "string") {
      throw new TypeError("First argument must be a string");
    }
    if (!style3) return [];
    options = options || {};
    var lineno = 1;
    var column2 = 1;
    function updatePosition(str) {
      var lines = str.match(NEWLINE_REGEX);
      if (lines) lineno += lines.length;
      var i = str.lastIndexOf(NEWLINE);
      column2 = ~i ? str.length - i : column2 + str.length;
    }
    function position4() {
      var start4 = { line: lineno, column: column2 };
      return function(node2) {
        node2.position = new Position(start4);
        whitespace2();
        return node2;
      };
    }
    function Position(start4) {
      this.start = start4;
      this.end = { line: lineno, column: column2 };
      this.source = options.source;
    }
    Position.prototype.content = style3;
    function error2(msg) {
      var err = new Error(
        options.source + ":" + lineno + ":" + column2 + ": " + msg
      );
      err.reason = msg;
      err.filename = options.source;
      err.line = lineno;
      err.column = column2;
      err.source = style3;
      if (options.silent) ;
      else {
        throw err;
      }
    }
    function match5(re2) {
      var m2 = re2.exec(style3);
      if (!m2) return;
      var str = m2[0];
      updatePosition(str);
      style3 = style3.slice(str.length);
      return m2;
    }
    function whitespace2() {
      match5(WHITESPACE_REGEX);
    }
    function comments(rules) {
      var c2;
      rules = rules || [];
      while (c2 = comment2()) {
        if (c2 !== false) {
          rules.push(c2);
        }
      }
      return rules;
    }
    function comment2() {
      var pos = position4();
      if (FORWARD_SLASH != style3.charAt(0) || ASTERISK2 != style3.charAt(1)) return;
      var i = 2;
      while (EMPTY_STRING != style3.charAt(i) && (ASTERISK2 != style3.charAt(i) || FORWARD_SLASH != style3.charAt(i + 1))) {
        ++i;
      }
      i += 2;
      if (EMPTY_STRING === style3.charAt(i - 1)) {
        return error2("End of comment missing");
      }
      var str = style3.slice(2, i - 2);
      column2 += 2;
      updatePosition(str);
      style3 = style3.slice(i);
      column2 += 2;
      return pos({
        type: TYPE_COMMENT,
        comment: str
      });
    }
    function declaration2() {
      var pos = position4();
      var prop = match5(PROPERTY_REGEX);
      if (!prop) return;
      comment2();
      if (!match5(COLON_REGEX)) return error2("property missing ':'");
      var val = match5(VALUE_REGEX);
      var ret = pos({
        type: TYPE_DECLARATION,
        property: trim2(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
        value: val ? trim2(val[0].replace(COMMENT_REGEX, EMPTY_STRING)) : EMPTY_STRING
      });
      match5(SEMICOLON_REGEX);
      return ret;
    }
    function declarations() {
      var decls = [];
      comments(decls);
      var decl;
      while (decl = declaration2()) {
        if (decl !== false) {
          decls.push(decl);
          comments(decls);
        }
      }
      return decls;
    }
    whitespace2();
    return declarations();
  };
  function trim2(str) {
    return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
  }
  return inlineStyleParser;
}
var hasRequiredCjs$1;
function requireCjs$1() {
  if (hasRequiredCjs$1) return cjs$1;
  hasRequiredCjs$1 = 1;
  var __importDefault = cjs$1 && cjs$1.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : { "default": mod2 };
  };
  Object.defineProperty(cjs$1, "__esModule", { value: true });
  cjs$1.default = StyleToObject;
  var inline_style_parser_1 = __importDefault(requireInlineStyleParser());
  function StyleToObject(style3, iterator) {
    var styleObject = null;
    if (!style3 || typeof style3 !== "string") {
      return styleObject;
    }
    var declarations = (0, inline_style_parser_1.default)(style3);
    var hasIterator = typeof iterator === "function";
    declarations.forEach(function(declaration2) {
      if (declaration2.type !== "declaration") {
        return;
      }
      var property = declaration2.property, value = declaration2.value;
      if (hasIterator) {
        iterator(property, value, declaration2);
      } else if (value) {
        styleObject = styleObject || {};
        styleObject[property] = value;
      }
    });
    return styleObject;
  }
  return cjs$1;
}
var utilities = {};
var hasRequiredUtilities;
function requireUtilities() {
  if (hasRequiredUtilities) return utilities;
  hasRequiredUtilities = 1;
  Object.defineProperty(utilities, "__esModule", { value: true });
  utilities.camelCase = void 0;
  var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/;
  var HYPHEN_REGEX = /-([a-z])/g;
  var NO_HYPHEN_REGEX = /^[^-]+$/;
  var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
  var MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
  var skipCamelCase = function(property) {
    return !property || NO_HYPHEN_REGEX.test(property) || CUSTOM_PROPERTY_REGEX.test(property);
  };
  var capitalize2 = function(match5, character2) {
    return character2.toUpperCase();
  };
  var trimHyphen = function(match5, prefix2) {
    return "".concat(prefix2, "-");
  };
  var camelCase = function(property, options) {
    if (options === void 0) {
      options = {};
    }
    if (skipCamelCase(property)) {
      return property;
    }
    property = property.toLowerCase();
    if (options.reactCompat) {
      property = property.replace(MS_VENDOR_PREFIX_REGEX, trimHyphen);
    } else {
      property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
    }
    return property.replace(HYPHEN_REGEX, capitalize2);
  };
  utilities.camelCase = camelCase;
  return utilities;
}
var cjs;
var hasRequiredCjs;
function requireCjs() {
  if (hasRequiredCjs) return cjs;
  hasRequiredCjs = 1;
  var __importDefault = cjs && cjs.__importDefault || function(mod2) {
    return mod2 && mod2.__esModule ? mod2 : { "default": mod2 };
  };
  var style_to_object_1 = __importDefault(requireCjs$1());
  var utilities_1 = requireUtilities();
  function StyleToJS(style3, options) {
    var output = {};
    if (!style3 || typeof style3 !== "string") {
      return output;
    }
    (0, style_to_object_1.default)(style3, function(property, value) {
      if (property && value) {
        output[(0, utilities_1.camelCase)(property, options)] = value;
      }
    });
    return output;
  }
  StyleToJS.default = StyleToJS;
  cjs = StyleToJS;
  return cjs;
}
var cjsExports = requireCjs();
const styleToJs = /* @__PURE__ */ getDefaultExportFromCjs$1(cjsExports);
const pointEnd = point("end");
const pointStart = point("start");
function point(type) {
  return point2;
  function point2(node2) {
    const point3 = node2 && node2.position && node2.position[type] || {};
    if (typeof point3.line === "number" && point3.line > 0 && typeof point3.column === "number" && point3.column > 0) {
      return {
        line: point3.line,
        column: point3.column,
        offset: typeof point3.offset === "number" && point3.offset > -1 ? point3.offset : void 0
      };
    }
  }
}
function position3(node2) {
  const start4 = pointStart(node2);
  const end2 = pointEnd(node2);
  if (start4 && end2) {
    return { start: start4, end: end2 };
  }
}
class VFileMessage extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(causeOrReason, optionsOrParentOrPlace, origin2) {
    super();
    if (typeof optionsOrParentOrPlace === "string") {
      origin2 = optionsOrParentOrPlace;
      optionsOrParentOrPlace = void 0;
    }
    let reason = "";
    let options = {};
    let legacyCause = false;
    if (optionsOrParentOrPlace) {
      if ("line" in optionsOrParentOrPlace && "column" in optionsOrParentOrPlace) {
        options = { place: optionsOrParentOrPlace };
      } else if ("start" in optionsOrParentOrPlace && "end" in optionsOrParentOrPlace) {
        options = { place: optionsOrParentOrPlace };
      } else if ("type" in optionsOrParentOrPlace) {
        options = {
          ancestors: [optionsOrParentOrPlace],
          place: optionsOrParentOrPlace.position
        };
      } else {
        options = { ...optionsOrParentOrPlace };
      }
    }
    if (typeof causeOrReason === "string") {
      reason = causeOrReason;
    } else if (!options.cause && causeOrReason) {
      legacyCause = true;
      reason = causeOrReason.message;
      options.cause = causeOrReason;
    }
    if (!options.ruleId && !options.source && typeof origin2 === "string") {
      const index2 = origin2.indexOf(":");
      if (index2 === -1) {
        options.ruleId = origin2;
      } else {
        options.source = origin2.slice(0, index2);
        options.ruleId = origin2.slice(index2 + 1);
      }
    }
    if (!options.place && options.ancestors && options.ancestors) {
      const parent2 = options.ancestors[options.ancestors.length - 1];
      if (parent2) {
        options.place = parent2.position;
      }
    }
    const start4 = options.place && "start" in options.place ? options.place.start : options.place;
    this.ancestors = options.ancestors || void 0;
    this.cause = options.cause || void 0;
    this.column = start4 ? start4.column : void 0;
    this.fatal = void 0;
    this.file = "";
    this.message = reason;
    this.line = start4 ? start4.line : void 0;
    this.name = stringifyPosition(options.place) || "1:1";
    this.place = options.place || void 0;
    this.reason = this.message;
    this.ruleId = options.ruleId || void 0;
    this.source = options.source || void 0;
    this.stack = legacyCause && options.cause && typeof options.cause.stack === "string" ? options.cause.stack : "";
    this.actual = void 0;
    this.expected = void 0;
    this.note = void 0;
    this.url = void 0;
  }
}
VFileMessage.prototype.file = "";
VFileMessage.prototype.name = "";
VFileMessage.prototype.reason = "";
VFileMessage.prototype.message = "";
VFileMessage.prototype.stack = "";
VFileMessage.prototype.column = void 0;
VFileMessage.prototype.line = void 0;
VFileMessage.prototype.ancestors = void 0;
VFileMessage.prototype.cause = void 0;
VFileMessage.prototype.fatal = void 0;
VFileMessage.prototype.place = void 0;
VFileMessage.prototype.ruleId = void 0;
VFileMessage.prototype.source = void 0;
const own$2 = {}.hasOwnProperty;
const emptyMap = /* @__PURE__ */ new Map();
const cap = /[A-Z]/g;
const tableElements = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]);
const tableCellElement = /* @__PURE__ */ new Set(["td", "th"]);
const docs = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function toJsxRuntime(tree, options) {
  if (!options || options.Fragment === void 0) {
    throw new TypeError("Expected `Fragment` in options");
  }
  const filePath = options.filePath || void 0;
  let create2;
  if (options.development) {
    if (typeof options.jsxDEV !== "function") {
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    }
    create2 = developmentCreate(filePath, options.jsxDEV);
  } else {
    if (typeof options.jsx !== "function") {
      throw new TypeError("Expected `jsx` in production options");
    }
    if (typeof options.jsxs !== "function") {
      throw new TypeError("Expected `jsxs` in production options");
    }
    create2 = productionCreate(filePath, options.jsx, options.jsxs);
  }
  const state = {
    Fragment: options.Fragment,
    ancestors: [],
    components: options.components || {},
    create: create2,
    elementAttributeNameCase: options.elementAttributeNameCase || "react",
    evaluater: options.createEvaluater ? options.createEvaluater() : void 0,
    filePath,
    ignoreInvalidStyle: options.ignoreInvalidStyle || false,
    passKeys: options.passKeys !== false,
    passNode: options.passNode || false,
    schema: options.space === "svg" ? svg : html$1,
    stylePropertyNameCase: options.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: options.tableCellAlignToStyle !== false
  };
  const result = one(state, tree, void 0);
  if (result && typeof result !== "string") {
    return result;
  }
  return state.create(
    tree,
    state.Fragment,
    { children: result || void 0 },
    void 0
  );
}
function one(state, node2, key2) {
  if (node2.type === "element") {
    return element(state, node2, key2);
  }
  if (node2.type === "mdxFlowExpression" || node2.type === "mdxTextExpression") {
    return mdxExpression(state, node2);
  }
  if (node2.type === "mdxJsxFlowElement" || node2.type === "mdxJsxTextElement") {
    return mdxJsxElement(state, node2, key2);
  }
  if (node2.type === "mdxjsEsm") {
    return mdxEsm(state, node2);
  }
  if (node2.type === "root") {
    return root$1(state, node2, key2);
  }
  if (node2.type === "text") {
    return text$1(state, node2);
  }
}
function element(state, node2, key2) {
  const parentSchema = state.schema;
  let schema = parentSchema;
  if (node2.tagName.toLowerCase() === "svg" && parentSchema.space === "html") {
    schema = svg;
    state.schema = schema;
  }
  state.ancestors.push(node2);
  const type = findComponentFromName(state, node2.tagName, false);
  const props = createElementProps(state, node2);
  let children = createChildren(state, node2);
  if (tableElements.has(node2.tagName)) {
    children = children.filter(function(child) {
      return typeof child === "string" ? !whitespace$1(child) : true;
    });
  }
  addNode$1(state, props, type, node2);
  addChildren(props, children);
  state.ancestors.pop();
  state.schema = parentSchema;
  return state.create(node2, type, props, key2);
}
function mdxExpression(state, node2) {
  if (node2.data && node2.data.estree && state.evaluater) {
    const program = node2.data.estree;
    const expression = program.body[0];
    ok$1(expression.type === "ExpressionStatement");
    return (
      /** @type {Child | undefined} */
      state.evaluater.evaluateExpression(expression.expression)
    );
  }
  crashEstree(state, node2.position);
}
function mdxEsm(state, node2) {
  if (node2.data && node2.data.estree && state.evaluater) {
    return (
      /** @type {Child | undefined} */
      state.evaluater.evaluateProgram(node2.data.estree)
    );
  }
  crashEstree(state, node2.position);
}
function mdxJsxElement(state, node2, key2) {
  const parentSchema = state.schema;
  let schema = parentSchema;
  if (node2.name === "svg" && parentSchema.space === "html") {
    schema = svg;
    state.schema = schema;
  }
  state.ancestors.push(node2);
  const type = node2.name === null ? state.Fragment : findComponentFromName(state, node2.name, true);
  const props = createJsxElementProps(state, node2);
  const children = createChildren(state, node2);
  addNode$1(state, props, type, node2);
  addChildren(props, children);
  state.ancestors.pop();
  state.schema = parentSchema;
  return state.create(node2, type, props, key2);
}
function root$1(state, node2, key2) {
  const props = {};
  addChildren(props, createChildren(state, node2));
  return state.create(node2, state.Fragment, props, key2);
}
function text$1(_2, node2) {
  return node2.value;
}
function addNode$1(state, props, type, node2) {
  if (typeof type !== "string" && type !== state.Fragment && state.passNode) {
    props.node = node2;
  }
}
function addChildren(props, children) {
  if (children.length > 0) {
    const value = children.length > 1 ? children : children[0];
    if (value) {
      props.children = value;
    }
  }
}
function productionCreate(_2, jsx, jsxs) {
  return create2;
  function create2(_3, type, props, key2) {
    const isStaticChildren = Array.isArray(props.children);
    const fn2 = isStaticChildren ? jsxs : jsx;
    return key2 ? fn2(type, props, key2) : fn2(type, props);
  }
}
function developmentCreate(filePath, jsxDEV) {
  return create2;
  function create2(node2, type, props, key2) {
    const isStaticChildren = Array.isArray(props.children);
    const point2 = pointStart(node2);
    return jsxDEV(
      type,
      props,
      key2,
      isStaticChildren,
      {
        columnNumber: point2 ? point2.column - 1 : void 0,
        fileName: filePath,
        lineNumber: point2 ? point2.line : void 0
      },
      void 0
    );
  }
}
function createElementProps(state, node2) {
  const props = {};
  let alignValue;
  let prop;
  for (prop in node2.properties) {
    if (prop !== "children" && own$2.call(node2.properties, prop)) {
      const result = createProperty(state, prop, node2.properties[prop]);
      if (result) {
        const [key2, value] = result;
        if (state.tableCellAlignToStyle && key2 === "align" && typeof value === "string" && tableCellElement.has(node2.tagName)) {
          alignValue = value;
        } else {
          props[key2] = value;
        }
      }
    }
  }
  if (alignValue) {
    const style3 = (
      /** @type {Style} */
      props.style || (props.style = {})
    );
    style3[state.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = alignValue;
  }
  return props;
}
function createJsxElementProps(state, node2) {
  const props = {};
  for (const attribute of node2.attributes) {
    if (attribute.type === "mdxJsxExpressionAttribute") {
      if (attribute.data && attribute.data.estree && state.evaluater) {
        const program = attribute.data.estree;
        const expression = program.body[0];
        ok$1(expression.type === "ExpressionStatement");
        const objectExpression = expression.expression;
        ok$1(objectExpression.type === "ObjectExpression");
        const property = objectExpression.properties[0];
        ok$1(property.type === "SpreadElement");
        Object.assign(
          props,
          state.evaluater.evaluateExpression(property.argument)
        );
      } else {
        crashEstree(state, node2.position);
      }
    } else {
      const name2 = attribute.name;
      let value;
      if (attribute.value && typeof attribute.value === "object") {
        if (attribute.value.data && attribute.value.data.estree && state.evaluater) {
          const program = attribute.value.data.estree;
          const expression = program.body[0];
          ok$1(expression.type === "ExpressionStatement");
          value = state.evaluater.evaluateExpression(expression.expression);
        } else {
          crashEstree(state, node2.position);
        }
      } else {
        value = attribute.value === null ? true : attribute.value;
      }
      props[name2] = /** @type {Props[keyof Props]} */
      value;
    }
  }
  return props;
}
function createChildren(state, node2) {
  const children = [];
  let index2 = -1;
  const countsByName = state.passKeys ? /* @__PURE__ */ new Map() : emptyMap;
  while (++index2 < node2.children.length) {
    const child = node2.children[index2];
    let key2;
    if (state.passKeys) {
      const name2 = child.type === "element" ? child.tagName : child.type === "mdxJsxFlowElement" || child.type === "mdxJsxTextElement" ? child.name : void 0;
      if (name2) {
        const count2 = countsByName.get(name2) || 0;
        key2 = name2 + "-" + count2;
        countsByName.set(name2, count2 + 1);
      }
    }
    const result = one(state, child, key2);
    if (result !== void 0) children.push(result);
  }
  return children;
}
function createProperty(state, prop, value) {
  const info = find$1(state.schema, prop);
  if (value === null || value === void 0 || typeof value === "number" && Number.isNaN(value)) {
    return;
  }
  if (Array.isArray(value)) {
    value = info.commaSeparated ? stringify$1(value) : stringify(value);
  }
  if (info.property === "style") {
    let styleObject = typeof value === "object" ? value : parseStyle(state, String(value));
    if (state.stylePropertyNameCase === "css") {
      styleObject = transformStylesToCssCasing(styleObject);
    }
    return ["style", styleObject];
  }
  return [
    state.elementAttributeNameCase === "react" && info.space ? hastToReact[info.property] || info.property : info.attribute,
    value
  ];
}
function parseStyle(state, value) {
  try {
    return styleToJs(value, { reactCompat: true });
  } catch (error2) {
    if (state.ignoreInvalidStyle) {
      return {};
    }
    const cause = (
      /** @type {Error} */
      error2
    );
    const message2 = new VFileMessage("Cannot parse `style` attribute", {
      ancestors: state.ancestors,
      cause,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    message2.file = state.filePath || void 0;
    message2.url = docs + "#cannot-parse-style-attribute";
    throw message2;
  }
}
function findComponentFromName(state, name$1, allowExpression) {
  let result;
  if (!allowExpression) {
    result = { type: "Literal", value: name$1 };
  } else if (name$1.includes(".")) {
    const identifiers = name$1.split(".");
    let index2 = -1;
    let node2;
    while (++index2 < identifiers.length) {
      const prop = name(identifiers[index2]) ? { type: "Identifier", name: identifiers[index2] } : { type: "Literal", value: identifiers[index2] };
      node2 = node2 ? {
        type: "MemberExpression",
        object: node2,
        property: prop,
        computed: Boolean(index2 && prop.type === "Literal"),
        optional: false
      } : prop;
    }
    result = node2;
  } else {
    result = name(name$1) && !/^[a-z]/.test(name$1) ? { type: "Identifier", name: name$1 } : { type: "Literal", value: name$1 };
  }
  if (result.type === "Literal") {
    const name2 = (
      /** @type {string | number} */
      result.value
    );
    return own$2.call(state.components, name2) ? state.components[name2] : name2;
  }
  if (state.evaluater) {
    return state.evaluater.evaluateExpression(result);
  }
  crashEstree(state);
}
function crashEstree(state, place) {
  const message2 = new VFileMessage(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: state.ancestors,
      place,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  message2.file = state.filePath || void 0;
  message2.url = docs + "#cannot-handle-mdx-estrees-without-createevaluater";
  throw message2;
}
function transformStylesToCssCasing(domCasing) {
  const cssCasing = {};
  let from3;
  for (from3 in domCasing) {
    if (own$2.call(domCasing, from3)) {
      cssCasing[transformStyleToCssCasing(from3)] = domCasing[from3];
    }
  }
  return cssCasing;
}
function transformStyleToCssCasing(from3) {
  let to2 = from3.replace(cap, toDash);
  if (to2.slice(0, 3) === "ms-") to2 = "-" + to2;
  return to2;
}
function toDash($0) {
  return "-" + $0.toLowerCase();
}
const urlAttributes = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
};
function remarkParse(options) {
  const self2 = this;
  self2.parser = parser;
  function parser(doc2) {
    return fromMarkdown(doc2, {
      ...self2.data("settings"),
      ...options,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: self2.data("micromarkExtensions") || [],
      mdastExtensions: self2.data("fromMarkdownExtensions") || []
    });
  }
}
function blockquote(state, node2) {
  const result = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: state.wrap(state.all(node2), true)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function hardBreak(state, node2) {
  const result = { type: "element", tagName: "br", properties: {}, children: [] };
  state.patch(node2, result);
  return [state.applyData(node2, result), { type: "text", value: "\n" }];
}
function code$1(state, node2) {
  const value = node2.value ? node2.value + "\n" : "";
  const properties2 = {};
  if (node2.lang) {
    properties2.className = ["language-" + node2.lang];
  }
  let result = {
    type: "element",
    tagName: "code",
    properties: properties2,
    children: [{ type: "text", value }]
  };
  if (node2.meta) {
    result.data = { meta: node2.meta };
  }
  state.patch(node2, result);
  result = state.applyData(node2, result);
  result = { type: "element", tagName: "pre", properties: {}, children: [result] };
  state.patch(node2, result);
  return result;
}
function strikethrough(state, node2) {
  const result = {
    type: "element",
    tagName: "del",
    properties: {},
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function emphasis(state, node2) {
  const result = {
    type: "element",
    tagName: "em",
    properties: {},
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function footnoteReference(state, node2) {
  const clobberPrefix = typeof state.options.clobberPrefix === "string" ? state.options.clobberPrefix : "user-content-";
  const id = String(node2.identifier).toUpperCase();
  const safeId = normalizeUri(id.toLowerCase());
  const index2 = state.footnoteOrder.indexOf(id);
  let counter;
  let reuseCounter = state.footnoteCounts.get(id);
  if (reuseCounter === void 0) {
    reuseCounter = 0;
    state.footnoteOrder.push(id);
    counter = state.footnoteOrder.length;
  } else {
    counter = index2 + 1;
  }
  reuseCounter += 1;
  state.footnoteCounts.set(id, reuseCounter);
  const link2 = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + clobberPrefix + "fn-" + safeId,
      id: clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : ""),
      dataFootnoteRef: true,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(counter) }]
  };
  state.patch(node2, link2);
  const sup = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [link2]
  };
  state.patch(node2, sup);
  return state.applyData(node2, sup);
}
function heading(state, node2) {
  const result = {
    type: "element",
    tagName: "h" + node2.depth,
    properties: {},
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function html(state, node2) {
  if (state.options.allowDangerousHtml) {
    const result = { type: "raw", value: node2.value };
    state.patch(node2, result);
    return state.applyData(node2, result);
  }
  return void 0;
}
function revert(state, node2) {
  const subtype = node2.referenceType;
  let suffix2 = "]";
  if (subtype === "collapsed") {
    suffix2 += "[]";
  } else if (subtype === "full") {
    suffix2 += "[" + (node2.label || node2.identifier) + "]";
  }
  if (node2.type === "imageReference") {
    return [{ type: "text", value: "![" + node2.alt + suffix2 }];
  }
  const contents = state.all(node2);
  const head = contents[0];
  if (head && head.type === "text") {
    head.value = "[" + head.value;
  } else {
    contents.unshift({ type: "text", value: "[" });
  }
  const tail = contents[contents.length - 1];
  if (tail && tail.type === "text") {
    tail.value += suffix2;
  } else {
    contents.push({ type: "text", value: suffix2 });
  }
  return contents;
}
function imageReference(state, node2) {
  const id = String(node2.identifier).toUpperCase();
  const definition2 = state.definitionById.get(id);
  if (!definition2) {
    return revert(state, node2);
  }
  const properties2 = { src: normalizeUri(definition2.url || ""), alt: node2.alt };
  if (definition2.title !== null && definition2.title !== void 0) {
    properties2.title = definition2.title;
  }
  const result = { type: "element", tagName: "img", properties: properties2, children: [] };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function image(state, node2) {
  const properties2 = { src: normalizeUri(node2.url) };
  if (node2.alt !== null && node2.alt !== void 0) {
    properties2.alt = node2.alt;
  }
  if (node2.title !== null && node2.title !== void 0) {
    properties2.title = node2.title;
  }
  const result = { type: "element", tagName: "img", properties: properties2, children: [] };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function inlineCode(state, node2) {
  const text2 = { type: "text", value: node2.value.replace(/\r?\n|\r/g, " ") };
  state.patch(node2, text2);
  const result = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [text2]
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function linkReference(state, node2) {
  const id = String(node2.identifier).toUpperCase();
  const definition2 = state.definitionById.get(id);
  if (!definition2) {
    return revert(state, node2);
  }
  const properties2 = { href: normalizeUri(definition2.url || "") };
  if (definition2.title !== null && definition2.title !== void 0) {
    properties2.title = definition2.title;
  }
  const result = {
    type: "element",
    tagName: "a",
    properties: properties2,
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function link(state, node2) {
  const properties2 = { href: normalizeUri(node2.url) };
  if (node2.title !== null && node2.title !== void 0) {
    properties2.title = node2.title;
  }
  const result = {
    type: "element",
    tagName: "a",
    properties: properties2,
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function listItem(state, node2, parent2) {
  const results = state.all(node2);
  const loose = parent2 ? listLoose(parent2) : listItemLoose(node2);
  const properties2 = {};
  const children = [];
  if (typeof node2.checked === "boolean") {
    const head = results[0];
    let paragraph2;
    if (head && head.type === "element" && head.tagName === "p") {
      paragraph2 = head;
    } else {
      paragraph2 = { type: "element", tagName: "p", properties: {}, children: [] };
      results.unshift(paragraph2);
    }
    if (paragraph2.children.length > 0) {
      paragraph2.children.unshift({ type: "text", value: " " });
    }
    paragraph2.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: node2.checked, disabled: true },
      children: []
    });
    properties2.className = ["task-list-item"];
  }
  let index2 = -1;
  while (++index2 < results.length) {
    const child = results[index2];
    if (loose || index2 !== 0 || child.type !== "element" || child.tagName !== "p") {
      children.push({ type: "text", value: "\n" });
    }
    if (child.type === "element" && child.tagName === "p" && !loose) {
      children.push(...child.children);
    } else {
      children.push(child);
    }
  }
  const tail = results[results.length - 1];
  if (tail && (loose || tail.type !== "element" || tail.tagName !== "p")) {
    children.push({ type: "text", value: "\n" });
  }
  const result = { type: "element", tagName: "li", properties: properties2, children };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function listLoose(node2) {
  let loose = false;
  if (node2.type === "list") {
    loose = node2.spread || false;
    const children = node2.children;
    let index2 = -1;
    while (!loose && ++index2 < children.length) {
      loose = listItemLoose(children[index2]);
    }
  }
  return loose;
}
function listItemLoose(node2) {
  const spread = node2.spread;
  return spread === null || spread === void 0 ? node2.children.length > 1 : spread;
}
function list(state, node2) {
  const properties2 = {};
  const results = state.all(node2);
  let index2 = -1;
  if (typeof node2.start === "number" && node2.start !== 1) {
    properties2.start = node2.start;
  }
  while (++index2 < results.length) {
    const child = results[index2];
    if (child.type === "element" && child.tagName === "li" && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes("task-list-item")) {
      properties2.className = ["contains-task-list"];
      break;
    }
  }
  const result = {
    type: "element",
    tagName: node2.ordered ? "ol" : "ul",
    properties: properties2,
    children: state.wrap(results, true)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function paragraph(state, node2) {
  const result = {
    type: "element",
    tagName: "p",
    properties: {},
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function root(state, node2) {
  const result = { type: "root", children: state.wrap(state.all(node2)) };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function strong(state, node2) {
  const result = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function table(state, node2) {
  const rows = state.all(node2);
  const firstRow = rows.shift();
  const tableContent = [];
  if (firstRow) {
    const head = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: state.wrap([firstRow], true)
    };
    state.patch(node2.children[0], head);
    tableContent.push(head);
  }
  if (rows.length > 0) {
    const body = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: state.wrap(rows, true)
    };
    const start4 = pointStart(node2.children[1]);
    const end2 = pointEnd(node2.children[node2.children.length - 1]);
    if (start4 && end2) body.position = { start: start4, end: end2 };
    tableContent.push(body);
  }
  const result = {
    type: "element",
    tagName: "table",
    properties: {},
    children: state.wrap(tableContent, true)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function tableRow(state, node2, parent2) {
  const siblings = parent2 ? parent2.children : void 0;
  const rowIndex = siblings ? siblings.indexOf(node2) : 1;
  const tagName = rowIndex === 0 ? "th" : "td";
  const align = parent2 && parent2.type === "table" ? parent2.align : void 0;
  const length2 = align ? align.length : node2.children.length;
  let cellIndex = -1;
  const cells = [];
  while (++cellIndex < length2) {
    const cell = node2.children[cellIndex];
    const properties2 = {};
    const alignValue = align ? align[cellIndex] : void 0;
    if (alignValue) {
      properties2.align = alignValue;
    }
    let result2 = { type: "element", tagName, properties: properties2, children: [] };
    if (cell) {
      result2.children = state.all(cell);
      state.patch(cell, result2);
      result2 = state.applyData(cell, result2);
    }
    cells.push(result2);
  }
  const result = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: state.wrap(cells, true)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function tableCell(state, node2) {
  const result = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
const tab = 9;
const space = 32;
function trimLines(value) {
  const source = String(value);
  const search2 = /\r?\n|\r/g;
  let match5 = search2.exec(source);
  let last = 0;
  const lines = [];
  while (match5) {
    lines.push(
      trimLine(source.slice(last, match5.index), last > 0, true),
      match5[0]
    );
    last = match5.index + match5[0].length;
    match5 = search2.exec(source);
  }
  lines.push(trimLine(source.slice(last), last > 0, false));
  return lines.join("");
}
function trimLine(value, start4, end2) {
  let startIndex = 0;
  let endIndex = value.length;
  if (start4) {
    let code = value.codePointAt(startIndex);
    while (code === tab || code === space) {
      startIndex++;
      code = value.codePointAt(startIndex);
    }
  }
  if (end2) {
    let code = value.codePointAt(endIndex - 1);
    while (code === tab || code === space) {
      endIndex--;
      code = value.codePointAt(endIndex - 1);
    }
  }
  return endIndex > startIndex ? value.slice(startIndex, endIndex) : "";
}
function text(state, node2) {
  const result = { type: "text", value: trimLines(String(node2.value)) };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function thematicBreak(state, node2) {
  const result = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
const handlers$1 = {
  blockquote,
  break: hardBreak,
  code: code$1,
  delete: strikethrough,
  emphasis,
  footnoteReference,
  heading,
  html,
  imageReference,
  image,
  inlineCode,
  linkReference,
  link,
  listItem,
  list,
  paragraph,
  // @ts-expect-error: root is different, but hard to type.
  root,
  strong,
  table,
  tableCell,
  tableRow,
  text,
  thematicBreak,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
};
function ignore() {
  return void 0;
}
const VOID = -1;
const PRIMITIVE = 0;
const ARRAY = 1;
const OBJECT = 2;
const DATE$1 = 3;
const REGEXP = 4;
const MAP = 5;
const SET = 6;
const ERROR = 7;
const BIGINT = 8;
const env = typeof self === "object" ? self : globalThis;
const deserializer = ($2, _2) => {
  const as2 = (out, index2) => {
    $2.set(index2, out);
    return out;
  };
  const unpair = (index2) => {
    if ($2.has(index2))
      return $2.get(index2);
    const [type, value] = _2[index2];
    switch (type) {
      case PRIMITIVE:
      case VOID:
        return as2(value, index2);
      case ARRAY: {
        const arr = as2([], index2);
        for (const index3 of value)
          arr.push(unpair(index3));
        return arr;
      }
      case OBJECT: {
        const object = as2({}, index2);
        for (const [key2, index3] of value)
          object[unpair(key2)] = unpair(index3);
        return object;
      }
      case DATE$1:
        return as2(new Date(value), index2);
      case REGEXP: {
        const { source, flags } = value;
        return as2(new RegExp(source, flags), index2);
      }
      case MAP: {
        const map3 = as2(/* @__PURE__ */ new Map(), index2);
        for (const [key2, index3] of value)
          map3.set(unpair(key2), unpair(index3));
        return map3;
      }
      case SET: {
        const set2 = as2(/* @__PURE__ */ new Set(), index2);
        for (const index3 of value)
          set2.add(unpair(index3));
        return set2;
      }
      case ERROR: {
        const { name: name2, message: message2 } = value;
        return as2(new env[name2](message2), index2);
      }
      case BIGINT:
        return as2(BigInt(value), index2);
      case "BigInt":
        return as2(Object(BigInt(value)), index2);
      case "ArrayBuffer":
        return as2(new Uint8Array(value).buffer, value);
      case "DataView": {
        const { buffer } = new Uint8Array(value);
        return as2(new DataView(buffer), value);
      }
    }
    return as2(new env[type](value), index2);
  };
  return unpair;
};
const deserialize = (serialized) => deserializer(/* @__PURE__ */ new Map(), serialized)(0);
const EMPTY = "";
const { toString: toString$1 } = {};
const { keys: keys$2 } = Object;
const typeOf = (value) => {
  const type = typeof value;
  if (type !== "object" || !value)
    return [PRIMITIVE, type];
  const asString = toString$1.call(value).slice(8, -1);
  switch (asString) {
    case "Array":
      return [ARRAY, EMPTY];
    case "Object":
      return [OBJECT, EMPTY];
    case "Date":
      return [DATE$1, EMPTY];
    case "RegExp":
      return [REGEXP, EMPTY];
    case "Map":
      return [MAP, EMPTY];
    case "Set":
      return [SET, EMPTY];
    case "DataView":
      return [ARRAY, asString];
  }
  if (asString.includes("Array"))
    return [ARRAY, asString];
  if (asString.includes("Error"))
    return [ERROR, asString];
  return [OBJECT, asString];
};
const shouldSkip = ([TYPE, type]) => TYPE === PRIMITIVE && (type === "function" || type === "symbol");
const serializer = (strict, json, $2, _2) => {
  const as2 = (out, value) => {
    const index2 = _2.push(out) - 1;
    $2.set(value, index2);
    return index2;
  };
  const pair = (value) => {
    if ($2.has(value))
      return $2.get(value);
    let [TYPE, type] = typeOf(value);
    switch (TYPE) {
      case PRIMITIVE: {
        let entry = value;
        switch (type) {
          case "bigint":
            TYPE = BIGINT;
            entry = value.toString();
            break;
          case "function":
          case "symbol":
            if (strict)
              throw new TypeError("unable to serialize " + type);
            entry = null;
            break;
          case "undefined":
            return as2([VOID], value);
        }
        return as2([TYPE, entry], value);
      }
      case ARRAY: {
        if (type) {
          let spread = value;
          if (type === "DataView") {
            spread = new Uint8Array(value.buffer);
          } else if (type === "ArrayBuffer") {
            spread = new Uint8Array(value);
          }
          return as2([type, [...spread]], value);
        }
        const arr = [];
        const index2 = as2([TYPE, arr], value);
        for (const entry of value)
          arr.push(pair(entry));
        return index2;
      }
      case OBJECT: {
        if (type) {
          switch (type) {
            case "BigInt":
              return as2([type, value.toString()], value);
            case "Boolean":
            case "Number":
            case "String":
              return as2([type, value.valueOf()], value);
          }
        }
        if (json && "toJSON" in value)
          return pair(value.toJSON());
        const entries = [];
        const index2 = as2([TYPE, entries], value);
        for (const key2 of keys$2(value)) {
          if (strict || !shouldSkip(typeOf(value[key2])))
            entries.push([pair(key2), pair(value[key2])]);
        }
        return index2;
      }
      case DATE$1:
        return as2([TYPE, value.toISOString()], value);
      case REGEXP: {
        const { source, flags } = value;
        return as2([TYPE, { source, flags }], value);
      }
      case MAP: {
        const entries = [];
        const index2 = as2([TYPE, entries], value);
        for (const [key2, entry] of value) {
          if (strict || !(shouldSkip(typeOf(key2)) || shouldSkip(typeOf(entry))))
            entries.push([pair(key2), pair(entry)]);
        }
        return index2;
      }
      case SET: {
        const entries = [];
        const index2 = as2([TYPE, entries], value);
        for (const entry of value) {
          if (strict || !shouldSkip(typeOf(entry)))
            entries.push(pair(entry));
        }
        return index2;
      }
    }
    const { message: message2 } = value;
    return as2([TYPE, { name: type, message: message2 }], value);
  };
  return pair;
};
const serialize = (value, { json, lossy } = {}) => {
  const _2 = [];
  return serializer(!(json || lossy), !!json, /* @__PURE__ */ new Map(), _2)(value), _2;
};
const structuredClone$1 = typeof structuredClone === "function" ? (
  /* c8 ignore start */
  (any, options) => options && ("json" in options || "lossy" in options) ? deserialize(serialize(any, options)) : structuredClone(any)
) : (any, options) => deserialize(serialize(any, options));
function defaultFootnoteBackContent(_2, rereferenceIndex) {
  const result = [{ type: "text", value: "↩" }];
  if (rereferenceIndex > 1) {
    result.push({
      type: "element",
      tagName: "sup",
      properties: {},
      children: [{ type: "text", value: String(rereferenceIndex) }]
    });
  }
  return result;
}
function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
  return "Back to reference " + (referenceIndex + 1) + (rereferenceIndex > 1 ? "-" + rereferenceIndex : "");
}
function footer(state) {
  const clobberPrefix = typeof state.options.clobberPrefix === "string" ? state.options.clobberPrefix : "user-content-";
  const footnoteBackContent = state.options.footnoteBackContent || defaultFootnoteBackContent;
  const footnoteBackLabel = state.options.footnoteBackLabel || defaultFootnoteBackLabel;
  const footnoteLabel = state.options.footnoteLabel || "Footnotes";
  const footnoteLabelTagName = state.options.footnoteLabelTagName || "h2";
  const footnoteLabelProperties = state.options.footnoteLabelProperties || {
    className: ["sr-only"]
  };
  const listItems = [];
  let referenceIndex = -1;
  while (++referenceIndex < state.footnoteOrder.length) {
    const definition2 = state.footnoteById.get(
      state.footnoteOrder[referenceIndex]
    );
    if (!definition2) {
      continue;
    }
    const content2 = state.all(definition2);
    const id = String(definition2.identifier).toUpperCase();
    const safeId = normalizeUri(id.toLowerCase());
    let rereferenceIndex = 0;
    const backReferences = [];
    const counts = state.footnoteCounts.get(id);
    while (counts !== void 0 && ++rereferenceIndex <= counts) {
      if (backReferences.length > 0) {
        backReferences.push({ type: "text", value: " " });
      }
      let children = typeof footnoteBackContent === "string" ? footnoteBackContent : footnoteBackContent(referenceIndex, rereferenceIndex);
      if (typeof children === "string") {
        children = { type: "text", value: children };
      }
      backReferences.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + clobberPrefix + "fnref-" + safeId + (rereferenceIndex > 1 ? "-" + rereferenceIndex : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof footnoteBackLabel === "string" ? footnoteBackLabel : footnoteBackLabel(referenceIndex, rereferenceIndex),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(children) ? children : [children]
      });
    }
    const tail = content2[content2.length - 1];
    if (tail && tail.type === "element" && tail.tagName === "p") {
      const tailTail = tail.children[tail.children.length - 1];
      if (tailTail && tailTail.type === "text") {
        tailTail.value += " ";
      } else {
        tail.children.push({ type: "text", value: " " });
      }
      tail.children.push(...backReferences);
    } else {
      content2.push(...backReferences);
    }
    const listItem2 = {
      type: "element",
      tagName: "li",
      properties: { id: clobberPrefix + "fn-" + safeId },
      children: state.wrap(content2, true)
    };
    state.patch(definition2, listItem2);
    listItems.push(listItem2);
  }
  if (listItems.length === 0) {
    return;
  }
  return {
    type: "element",
    tagName: "section",
    properties: { dataFootnotes: true, className: ["footnotes"] },
    children: [
      {
        type: "element",
        tagName: footnoteLabelTagName,
        properties: {
          ...structuredClone$1(footnoteLabelProperties),
          id: "footnote-label"
        },
        children: [{ type: "text", value: footnoteLabel }]
      },
      { type: "text", value: "\n" },
      {
        type: "element",
        tagName: "ol",
        properties: {},
        children: state.wrap(listItems, true)
      },
      { type: "text", value: "\n" }
    ]
  };
}
const own$1 = {}.hasOwnProperty;
const emptyOptions = {};
function createState(tree, options) {
  const settings = options || emptyOptions;
  const definitionById = /* @__PURE__ */ new Map();
  const footnoteById = /* @__PURE__ */ new Map();
  const footnoteCounts = /* @__PURE__ */ new Map();
  const handlers2 = { ...handlers$1, ...settings.handlers };
  const state = {
    all: all2,
    applyData,
    definitionById,
    footnoteById,
    footnoteCounts,
    footnoteOrder: [],
    handlers: handlers2,
    one: one2,
    options: settings,
    patch: patch3,
    wrap: wrap$2
  };
  visit(tree, function(node2) {
    if (node2.type === "definition" || node2.type === "footnoteDefinition") {
      const map3 = node2.type === "definition" ? definitionById : footnoteById;
      const id = String(node2.identifier).toUpperCase();
      if (!map3.has(id)) {
        map3.set(id, node2);
      }
    }
  });
  return state;
  function one2(node2, parent2) {
    const type = node2.type;
    const handle2 = state.handlers[type];
    if (own$1.call(state.handlers, type) && handle2) {
      return handle2(state, node2, parent2);
    }
    if (state.options.passThrough && state.options.passThrough.includes(type)) {
      if ("children" in node2) {
        const { children, ...shallow } = node2;
        const result = structuredClone$1(shallow);
        result.children = state.all(node2);
        return result;
      }
      return structuredClone$1(node2);
    }
    const unknown2 = state.options.unknownHandler || defaultUnknownHandler;
    return unknown2(state, node2, parent2);
  }
  function all2(parent2) {
    const values2 = [];
    if ("children" in parent2) {
      const nodes = parent2.children;
      let index2 = -1;
      while (++index2 < nodes.length) {
        const result = state.one(nodes[index2], parent2);
        if (result) {
          if (index2 && nodes[index2 - 1].type === "break") {
            if (!Array.isArray(result) && result.type === "text") {
              result.value = trimMarkdownSpaceStart(result.value);
            }
            if (!Array.isArray(result) && result.type === "element") {
              const head = result.children[0];
              if (head && head.type === "text") {
                head.value = trimMarkdownSpaceStart(head.value);
              }
            }
          }
          if (Array.isArray(result)) {
            values2.push(...result);
          } else {
            values2.push(result);
          }
        }
      }
    }
    return values2;
  }
}
function patch3(from3, to2) {
  if (from3.position) to2.position = position3(from3);
}
function applyData(from3, to2) {
  let result = to2;
  if (from3 && from3.data) {
    const hName = from3.data.hName;
    const hChildren = from3.data.hChildren;
    const hProperties = from3.data.hProperties;
    if (typeof hName === "string") {
      if (result.type === "element") {
        result.tagName = hName;
      } else {
        const children = "children" in result ? result.children : [result];
        result = { type: "element", tagName: hName, properties: {}, children };
      }
    }
    if (result.type === "element" && hProperties) {
      Object.assign(result.properties, structuredClone$1(hProperties));
    }
    if ("children" in result && result.children && hChildren !== null && hChildren !== void 0) {
      result.children = hChildren;
    }
  }
  return result;
}
function defaultUnknownHandler(state, node2) {
  const data = node2.data || {};
  const result = "value" in node2 && !(own$1.call(data, "hProperties") || own$1.call(data, "hChildren")) ? { type: "text", value: node2.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: state.all(node2)
  };
  state.patch(node2, result);
  return state.applyData(node2, result);
}
function wrap$2(nodes, loose) {
  const result = [];
  let index2 = -1;
  if (loose) {
    result.push({ type: "text", value: "\n" });
  }
  while (++index2 < nodes.length) {
    if (index2) result.push({ type: "text", value: "\n" });
    result.push(nodes[index2]);
  }
  if (loose && nodes.length > 0) {
    result.push({ type: "text", value: "\n" });
  }
  return result;
}
function trimMarkdownSpaceStart(value) {
  let index2 = 0;
  let code = value.charCodeAt(index2);
  while (code === 9 || code === 32) {
    index2++;
    code = value.charCodeAt(index2);
  }
  return value.slice(index2);
}
function toHast(tree, options) {
  const state = createState(tree, options);
  const node2 = state.one(tree, void 0);
  const foot = footer(state);
  const result = Array.isArray(node2) ? { type: "root", children: node2 } : node2 || { type: "root", children: [] };
  if (foot) {
    result.children.push({ type: "text", value: "\n" }, foot);
  }
  return result;
}
function remarkRehype(destination, options) {
  if (destination && "run" in destination) {
    return async function(tree, file) {
      const hastTree = (
        /** @type {HastRoot} */
        toHast(tree, { file, ...options })
      );
      await destination.run(hastTree, file);
    };
  }
  return function(tree, file) {
    return (
      /** @type {HastRoot} */
      toHast(tree, { file, ...destination || options })
    );
  };
}
function bail(error2) {
  if (error2) {
    throw error2;
  }
}
var extend$2;
var hasRequiredExtend;
function requireExtend() {
  if (hasRequiredExtend) return extend$2;
  hasRequiredExtend = 1;
  var hasOwn = Object.prototype.hasOwnProperty;
  var toStr = Object.prototype.toString;
  var defineProperty = Object.defineProperty;
  var gOPD = Object.getOwnPropertyDescriptor;
  var isArray2 = function isArray3(arr) {
    if (typeof Array.isArray === "function") {
      return Array.isArray(arr);
    }
    return toStr.call(arr) === "[object Array]";
  };
  var isPlainObject2 = function isPlainObject3(obj) {
    if (!obj || toStr.call(obj) !== "[object Object]") {
      return false;
    }
    var hasOwnConstructor = hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
      return false;
    }
    var key2;
    for (key2 in obj) {
    }
    return typeof key2 === "undefined" || hasOwn.call(obj, key2);
  };
  var setProperty = function setProperty2(target, options) {
    if (defineProperty && options.name === "__proto__") {
      defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
      });
    } else {
      target[options.name] = options.newValue;
    }
  };
  var getProperty = function getProperty2(obj, name2) {
    if (name2 === "__proto__") {
      if (!hasOwn.call(obj, name2)) {
        return void 0;
      } else if (gOPD) {
        return gOPD(obj, name2).value;
      }
    }
    return obj[name2];
  };
  extend$2 = function extend2() {
    var options, name2, src, copy2, copyIsArray, clone2;
    var target = arguments[0];
    var i = 1;
    var length2 = arguments.length;
    var deep = false;
    if (typeof target === "boolean") {
      deep = target;
      target = arguments[1] || {};
      i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") {
      target = {};
    }
    for (; i < length2; ++i) {
      options = arguments[i];
      if (options != null) {
        for (name2 in options) {
          src = getProperty(target, name2);
          copy2 = getProperty(options, name2);
          if (target !== copy2) {
            if (deep && copy2 && (isPlainObject2(copy2) || (copyIsArray = isArray2(copy2)))) {
              if (copyIsArray) {
                copyIsArray = false;
                clone2 = src && isArray2(src) ? src : [];
              } else {
                clone2 = src && isPlainObject2(src) ? src : {};
              }
              setProperty(target, { name: name2, newValue: extend2(deep, clone2, copy2) });
            } else if (typeof copy2 !== "undefined") {
              setProperty(target, { name: name2, newValue: copy2 });
            }
          }
        }
      }
    }
    return target;
  };
  return extend$2;
}
var extendExports = requireExtend();
const extend$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(extendExports);
function isPlainObject$1(value) {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}
function trough() {
  const fns = [];
  const pipeline = { run: run2, use };
  return pipeline;
  function run2(...values2) {
    let middlewareIndex = -1;
    const callback = values2.pop();
    if (typeof callback !== "function") {
      throw new TypeError("Expected function as last argument, not " + callback);
    }
    next2(null, ...values2);
    function next2(error2, ...output) {
      const fn2 = fns[++middlewareIndex];
      let index2 = -1;
      if (error2) {
        callback(error2);
        return;
      }
      while (++index2 < values2.length) {
        if (output[index2] === null || output[index2] === void 0) {
          output[index2] = values2[index2];
        }
      }
      values2 = output;
      if (fn2) {
        wrap$1(fn2, next2)(...output);
      } else {
        callback(null, ...output);
      }
    }
  }
  function use(middelware) {
    if (typeof middelware !== "function") {
      throw new TypeError(
        "Expected `middelware` to be a function, not " + middelware
      );
    }
    fns.push(middelware);
    return pipeline;
  }
}
function wrap$1(middleware2, callback) {
  let called;
  return wrapped;
  function wrapped(...parameters) {
    const fnExpectsCallback = middleware2.length > parameters.length;
    let result;
    if (fnExpectsCallback) {
      parameters.push(done);
    }
    try {
      result = middleware2.apply(this, parameters);
    } catch (error2) {
      const exception = (
        /** @type {Error} */
        error2
      );
      if (fnExpectsCallback && called) {
        throw exception;
      }
      return done(exception);
    }
    if (!fnExpectsCallback) {
      if (result && result.then && typeof result.then === "function") {
        result.then(then, done);
      } else if (result instanceof Error) {
        done(result);
      } else {
        then(result);
      }
    }
  }
  function done(error2, ...output) {
    if (!called) {
      called = true;
      callback(error2, ...output);
    }
  }
  function then(value) {
    done(null, value);
  }
}
const minpath = { basename, dirname, extname, join: join$1, sep: "/" };
function basename(path2, extname2) {
  if (extname2 !== void 0 && typeof extname2 !== "string") {
    throw new TypeError('"ext" argument must be a string');
  }
  assertPath$1(path2);
  let start4 = 0;
  let end2 = -1;
  let index2 = path2.length;
  let seenNonSlash;
  if (extname2 === void 0 || extname2.length === 0 || extname2.length > path2.length) {
    while (index2--) {
      if (path2.codePointAt(index2) === 47) {
        if (seenNonSlash) {
          start4 = index2 + 1;
          break;
        }
      } else if (end2 < 0) {
        seenNonSlash = true;
        end2 = index2 + 1;
      }
    }
    return end2 < 0 ? "" : path2.slice(start4, end2);
  }
  if (extname2 === path2) {
    return "";
  }
  let firstNonSlashEnd = -1;
  let extnameIndex = extname2.length - 1;
  while (index2--) {
    if (path2.codePointAt(index2) === 47) {
      if (seenNonSlash) {
        start4 = index2 + 1;
        break;
      }
    } else {
      if (firstNonSlashEnd < 0) {
        seenNonSlash = true;
        firstNonSlashEnd = index2 + 1;
      }
      if (extnameIndex > -1) {
        if (path2.codePointAt(index2) === extname2.codePointAt(extnameIndex--)) {
          if (extnameIndex < 0) {
            end2 = index2;
          }
        } else {
          extnameIndex = -1;
          end2 = firstNonSlashEnd;
        }
      }
    }
  }
  if (start4 === end2) {
    end2 = firstNonSlashEnd;
  } else if (end2 < 0) {
    end2 = path2.length;
  }
  return path2.slice(start4, end2);
}
function dirname(path2) {
  assertPath$1(path2);
  if (path2.length === 0) {
    return ".";
  }
  let end2 = -1;
  let index2 = path2.length;
  let unmatchedSlash;
  while (--index2) {
    if (path2.codePointAt(index2) === 47) {
      if (unmatchedSlash) {
        end2 = index2;
        break;
      }
    } else if (!unmatchedSlash) {
      unmatchedSlash = true;
    }
  }
  return end2 < 0 ? path2.codePointAt(0) === 47 ? "/" : "." : end2 === 1 && path2.codePointAt(0) === 47 ? "//" : path2.slice(0, end2);
}
function extname(path2) {
  assertPath$1(path2);
  let index2 = path2.length;
  let end2 = -1;
  let startPart = 0;
  let startDot = -1;
  let preDotState = 0;
  let unmatchedSlash;
  while (index2--) {
    const code = path2.codePointAt(index2);
    if (code === 47) {
      if (unmatchedSlash) {
        startPart = index2 + 1;
        break;
      }
      continue;
    }
    if (end2 < 0) {
      unmatchedSlash = true;
      end2 = index2 + 1;
    }
    if (code === 46) {
      if (startDot < 0) {
        startDot = index2;
      } else if (preDotState !== 1) {
        preDotState = 1;
      }
    } else if (startDot > -1) {
      preDotState = -1;
    }
  }
  if (startDot < 0 || end2 < 0 || // We saw a non-dot character immediately before the dot.
  preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
  preDotState === 1 && startDot === end2 - 1 && startDot === startPart + 1) {
    return "";
  }
  return path2.slice(startDot, end2);
}
function join$1(...segments) {
  let index2 = -1;
  let joined;
  while (++index2 < segments.length) {
    assertPath$1(segments[index2]);
    if (segments[index2]) {
      joined = joined === void 0 ? segments[index2] : joined + "/" + segments[index2];
    }
  }
  return joined === void 0 ? "." : normalize$1(joined);
}
function normalize$1(path2) {
  assertPath$1(path2);
  const absolute = path2.codePointAt(0) === 47;
  let value = normalizeString(path2, !absolute);
  if (value.length === 0 && !absolute) {
    value = ".";
  }
  if (value.length > 0 && path2.codePointAt(path2.length - 1) === 47) {
    value += "/";
  }
  return absolute ? "/" + value : value;
}
function normalizeString(path2, allowAboveRoot) {
  let result = "";
  let lastSegmentLength = 0;
  let lastSlash = -1;
  let dots = 0;
  let index2 = -1;
  let code;
  let lastSlashIndex;
  while (++index2 <= path2.length) {
    if (index2 < path2.length) {
      code = path2.codePointAt(index2);
    } else if (code === 47) {
      break;
    } else {
      code = 47;
    }
    if (code === 47) {
      if (lastSlash === index2 - 1 || dots === 1) ;
      else if (lastSlash !== index2 - 1 && dots === 2) {
        if (result.length < 2 || lastSegmentLength !== 2 || result.codePointAt(result.length - 1) !== 46 || result.codePointAt(result.length - 2) !== 46) {
          if (result.length > 2) {
            lastSlashIndex = result.lastIndexOf("/");
            if (lastSlashIndex !== result.length - 1) {
              if (lastSlashIndex < 0) {
                result = "";
                lastSegmentLength = 0;
              } else {
                result = result.slice(0, lastSlashIndex);
                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
              }
              lastSlash = index2;
              dots = 0;
              continue;
            }
          } else if (result.length > 0) {
            result = "";
            lastSegmentLength = 0;
            lastSlash = index2;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          result = result.length > 0 ? result + "/.." : "..";
          lastSegmentLength = 2;
        }
      } else {
        if (result.length > 0) {
          result += "/" + path2.slice(lastSlash + 1, index2);
        } else {
          result = path2.slice(lastSlash + 1, index2);
        }
        lastSegmentLength = index2 - lastSlash - 1;
      }
      lastSlash = index2;
      dots = 0;
    } else if (code === 46 && dots > -1) {
      dots++;
    } else {
      dots = -1;
    }
  }
  return result;
}
function assertPath$1(path2) {
  if (typeof path2 !== "string") {
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(path2)
    );
  }
}
const minproc = { cwd };
function cwd() {
  return "/";
}
function isUrl(fileUrlOrPath) {
  return Boolean(
    fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && "href" in fileUrlOrPath && fileUrlOrPath.href && "protocol" in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === void 0
  );
}
function urlToPath(path2) {
  if (typeof path2 === "string") {
    path2 = new URL(path2);
  } else if (!isUrl(path2)) {
    const error2 = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + path2 + "`"
    );
    error2.code = "ERR_INVALID_ARG_TYPE";
    throw error2;
  }
  if (path2.protocol !== "file:") {
    const error2 = new TypeError("The URL must be of scheme file");
    error2.code = "ERR_INVALID_URL_SCHEME";
    throw error2;
  }
  return getPathFromURLPosix(path2);
}
function getPathFromURLPosix(url) {
  if (url.hostname !== "") {
    const error2 = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    error2.code = "ERR_INVALID_FILE_URL_HOST";
    throw error2;
  }
  const pathname = url.pathname;
  let index2 = -1;
  while (++index2 < pathname.length) {
    if (pathname.codePointAt(index2) === 37 && pathname.codePointAt(index2 + 1) === 50) {
      const third = pathname.codePointAt(index2 + 2);
      if (third === 70 || third === 102) {
        const error2 = new TypeError(
          "File URL path must not include encoded / characters"
        );
        error2.code = "ERR_INVALID_FILE_URL_PATH";
        throw error2;
      }
    }
  }
  return decodeURIComponent(pathname);
}
const order = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class VFile {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(value) {
    let options;
    if (!value) {
      options = {};
    } else if (isUrl(value)) {
      options = { path: value };
    } else if (typeof value === "string" || isUint8Array$1(value)) {
      options = { value };
    } else {
      options = value;
    }
    this.cwd = "cwd" in options ? "" : minproc.cwd();
    this.data = {};
    this.history = [];
    this.messages = [];
    this.value;
    this.map;
    this.result;
    this.stored;
    let index2 = -1;
    while (++index2 < order.length) {
      const field2 = order[index2];
      if (field2 in options && options[field2] !== void 0 && options[field2] !== null) {
        this[field2] = field2 === "history" ? [...options[field2]] : options[field2];
      }
    }
    let field;
    for (field in options) {
      if (!order.includes(field)) {
        this[field] = options[field];
      }
    }
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path === "string" ? minpath.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(basename2) {
    assertNonEmpty(basename2, "basename");
    assertPart(basename2, "basename");
    this.path = minpath.join(this.dirname || "", basename2);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path === "string" ? minpath.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(dirname2) {
    assertPath(this.basename, "dirname");
    this.path = minpath.join(dirname2 || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path === "string" ? minpath.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(extname2) {
    assertPart(extname2, "extname");
    assertPath(this.dirname, "extname");
    if (extname2) {
      if (extname2.codePointAt(0) !== 46) {
        throw new Error("`extname` must start with `.`");
      }
      if (extname2.includes(".", 1)) {
        throw new Error("`extname` cannot contain multiple dots");
      }
    }
    this.path = minpath.join(this.dirname, this.stem + (extname2 || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(path2) {
    if (isUrl(path2)) {
      path2 = urlToPath(path2);
    }
    assertNonEmpty(path2, "path");
    if (this.path !== path2) {
      this.history.push(path2);
    }
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path === "string" ? minpath.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(stem) {
    assertNonEmpty(stem, "stem");
    assertPart(stem, "stem");
    this.path = minpath.join(this.dirname || "", stem + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(causeOrReason, optionsOrParentOrPlace, origin2) {
    const message2 = this.message(causeOrReason, optionsOrParentOrPlace, origin2);
    message2.fatal = true;
    throw message2;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(causeOrReason, optionsOrParentOrPlace, origin2) {
    const message2 = this.message(causeOrReason, optionsOrParentOrPlace, origin2);
    message2.fatal = void 0;
    return message2;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(causeOrReason, optionsOrParentOrPlace, origin2) {
    const message2 = new VFileMessage(
      // @ts-expect-error: the overloads are fine.
      causeOrReason,
      optionsOrParentOrPlace,
      origin2
    );
    if (this.path) {
      message2.name = this.path + ":" + message2.name;
      message2.file = this.path;
    }
    message2.fatal = false;
    this.messages.push(message2);
    return message2;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(encoding) {
    if (this.value === void 0) {
      return "";
    }
    if (typeof this.value === "string") {
      return this.value;
    }
    const decoder = new TextDecoder(encoding || void 0);
    return decoder.decode(this.value);
  }
}
function assertPart(part, name2) {
  if (part && part.includes(minpath.sep)) {
    throw new Error(
      "`" + name2 + "` cannot be a path: did not expect `" + minpath.sep + "`"
    );
  }
}
function assertNonEmpty(part, name2) {
  if (!part) {
    throw new Error("`" + name2 + "` cannot be empty");
  }
}
function assertPath(path2, name2) {
  if (!path2) {
    throw new Error("Setting `" + name2 + "` requires `path` to be set too");
  }
}
function isUint8Array$1(value) {
  return Boolean(
    value && typeof value === "object" && "byteLength" in value && "byteOffset" in value
  );
}
const CallableInstance = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(property) {
    const self2 = this;
    const constr = self2.constructor;
    const proto2 = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      constr.prototype
    );
    const value = proto2[property];
    const apply4 = function() {
      return value.apply(apply4, arguments);
    };
    Object.setPrototypeOf(apply4, proto2);
    return apply4;
  }
);
const own = {}.hasOwnProperty;
class Processor extends CallableInstance {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy");
    this.Compiler = void 0;
    this.Parser = void 0;
    this.attachers = [];
    this.compiler = void 0;
    this.freezeIndex = -1;
    this.frozen = void 0;
    this.namespace = {};
    this.parser = void 0;
    this.transformers = trough();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const destination = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Processor()
    );
    let index2 = -1;
    while (++index2 < this.attachers.length) {
      const attacher = this.attachers[index2];
      destination.use(...attacher);
    }
    destination.data(extend$1(true, {}, this.namespace));
    return destination;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(key2, value) {
    if (typeof key2 === "string") {
      if (arguments.length === 2) {
        assertUnfrozen("data", this.frozen);
        this.namespace[key2] = value;
        return this;
      }
      return own.call(this.namespace, key2) && this.namespace[key2] || void 0;
    }
    if (key2) {
      assertUnfrozen("data", this.frozen);
      this.namespace = key2;
      return this;
    }
    return this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen) {
      return this;
    }
    const self2 = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    while (++this.freezeIndex < this.attachers.length) {
      const [attacher, ...options] = this.attachers[this.freezeIndex];
      if (options[0] === false) {
        continue;
      }
      if (options[0] === true) {
        options[0] = void 0;
      }
      const transformer = attacher.call(self2, ...options);
      if (typeof transformer === "function") {
        this.transformers.use(transformer);
      }
    }
    this.frozen = true;
    this.freezeIndex = Number.POSITIVE_INFINITY;
    return this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(file) {
    this.freeze();
    const realFile = vfile(file);
    const parser = this.parser || this.Parser;
    assertParser("parse", parser);
    return parser(String(realFile), realFile);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(file, done) {
    const self2 = this;
    this.freeze();
    assertParser("process", this.parser || this.Parser);
    assertCompiler("process", this.compiler || this.Compiler);
    return done ? executor(void 0, done) : new Promise(executor);
    function executor(resolve, reject) {
      const realFile = vfile(file);
      const parseTree = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        self2.parse(realFile)
      );
      self2.run(parseTree, realFile, function(error2, tree, file2) {
        if (error2 || !tree || !file2) {
          return realDone(error2);
        }
        const compileTree = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          tree
        );
        const compileResult = self2.stringify(compileTree, file2);
        if (looksLikeAValue(compileResult)) {
          file2.value = compileResult;
        } else {
          file2.result = compileResult;
        }
        realDone(
          error2,
          /** @type {VFileWithOutput<CompileResult>} */
          file2
        );
      });
      function realDone(error2, file2) {
        if (error2 || !file2) {
          reject(error2);
        } else if (resolve) {
          resolve(file2);
        } else {
          done(void 0, file2);
        }
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(file) {
    let complete = false;
    let result;
    this.freeze();
    assertParser("processSync", this.parser || this.Parser);
    assertCompiler("processSync", this.compiler || this.Compiler);
    this.process(file, realDone);
    assertDone("processSync", "process", complete);
    return result;
    function realDone(error2, file2) {
      complete = true;
      bail(error2);
      result = file2;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(tree, file, done) {
    assertNode(tree);
    this.freeze();
    const transformers = this.transformers;
    if (!done && typeof file === "function") {
      done = file;
      file = void 0;
    }
    return done ? executor(void 0, done) : new Promise(executor);
    function executor(resolve, reject) {
      const realFile = vfile(file);
      transformers.run(tree, realFile, realDone);
      function realDone(error2, outputTree, file2) {
        const resultingTree = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          outputTree || tree
        );
        if (error2) {
          reject(error2);
        } else if (resolve) {
          resolve(resultingTree);
        } else {
          done(void 0, resultingTree, file2);
        }
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(tree, file) {
    let complete = false;
    let result;
    this.run(tree, file, realDone);
    assertDone("runSync", "run", complete);
    return result;
    function realDone(error2, tree2) {
      bail(error2);
      result = tree2;
      complete = true;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(tree, file) {
    this.freeze();
    const realFile = vfile(file);
    const compiler2 = this.compiler || this.Compiler;
    assertCompiler("stringify", compiler2);
    assertNode(tree);
    return compiler2(tree, realFile);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(value, ...parameters) {
    const attachers = this.attachers;
    const namespace = this.namespace;
    assertUnfrozen("use", this.frozen);
    if (value === null || value === void 0) ;
    else if (typeof value === "function") {
      addPlugin(value, parameters);
    } else if (typeof value === "object") {
      if (Array.isArray(value)) {
        addList(value);
      } else {
        addPreset(value);
      }
    } else {
      throw new TypeError("Expected usable value, not `" + value + "`");
    }
    return this;
    function add4(value2) {
      if (typeof value2 === "function") {
        addPlugin(value2, []);
      } else if (typeof value2 === "object") {
        if (Array.isArray(value2)) {
          const [plugin2, ...parameters2] = (
            /** @type {PluginTuple<Array<unknown>>} */
            value2
          );
          addPlugin(plugin2, parameters2);
        } else {
          addPreset(value2);
        }
      } else {
        throw new TypeError("Expected usable value, not `" + value2 + "`");
      }
    }
    function addPreset(result) {
      if (!("plugins" in result) && !("settings" in result)) {
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      }
      addList(result.plugins);
      if (result.settings) {
        namespace.settings = extend$1(true, namespace.settings, result.settings);
      }
    }
    function addList(plugins) {
      let index2 = -1;
      if (plugins === null || plugins === void 0) ;
      else if (Array.isArray(plugins)) {
        while (++index2 < plugins.length) {
          const thing = plugins[index2];
          add4(thing);
        }
      } else {
        throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
      }
    }
    function addPlugin(plugin2, parameters2) {
      let index2 = -1;
      let entryIndex = -1;
      while (++index2 < attachers.length) {
        if (attachers[index2][0] === plugin2) {
          entryIndex = index2;
          break;
        }
      }
      if (entryIndex === -1) {
        attachers.push([plugin2, ...parameters2]);
      } else if (parameters2.length > 0) {
        let [primary, ...rest] = parameters2;
        const currentPrimary = attachers[entryIndex][1];
        if (isPlainObject$1(currentPrimary) && isPlainObject$1(primary)) {
          primary = extend$1(true, currentPrimary, primary);
        }
        attachers[entryIndex] = [plugin2, primary, ...rest];
      }
    }
  }
}
const unified = new Processor().freeze();
function assertParser(name2, value) {
  if (typeof value !== "function") {
    throw new TypeError("Cannot `" + name2 + "` without `parser`");
  }
}
function assertCompiler(name2, value) {
  if (typeof value !== "function") {
    throw new TypeError("Cannot `" + name2 + "` without `compiler`");
  }
}
function assertUnfrozen(name2, frozen) {
  if (frozen) {
    throw new Error(
      "Cannot call `" + name2 + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
  }
}
function assertNode(node2) {
  if (!isPlainObject$1(node2) || typeof node2.type !== "string") {
    throw new TypeError("Expected node, got `" + node2 + "`");
  }
}
function assertDone(name2, asyncName, complete) {
  if (!complete) {
    throw new Error(
      "`" + name2 + "` finished async. Use `" + asyncName + "` instead"
    );
  }
}
function vfile(value) {
  return looksLikeAVFile(value) ? value : new VFile(value);
}
function looksLikeAVFile(value) {
  return Boolean(
    value && typeof value === "object" && "message" in value && "messages" in value
  );
}
function looksLikeAValue(value) {
  return typeof value === "string" || isUint8Array(value);
}
function isUint8Array(value) {
  return Boolean(
    value && typeof value === "object" && "byteLength" in value && "byteOffset" in value
  );
}
const changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md";
const emptyPlugins = [];
const emptyRemarkRehypeOptions = { allowDangerousHtml: true };
const safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;
const deprecations$1 = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  { from: "className", id: "remove-classname" },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Markdown(options) {
  const processor = createProcessor(options);
  const file = createFile(options);
  return post(processor.runSync(processor.parse(file), file), options);
}
function createProcessor(options) {
  const rehypePlugins = options.rehypePlugins || emptyPlugins;
  const remarkPlugins = options.remarkPlugins || emptyPlugins;
  const remarkRehypeOptions = options.remarkRehypeOptions ? { ...options.remarkRehypeOptions, ...emptyRemarkRehypeOptions } : emptyRemarkRehypeOptions;
  const processor = unified().use(remarkParse).use(remarkPlugins).use(remarkRehype, remarkRehypeOptions).use(rehypePlugins);
  return processor;
}
function createFile(options) {
  const children = options.children || "";
  const file = new VFile();
  if (typeof children === "string") {
    file.value = children;
  }
  return file;
}
function post(tree, options) {
  const allowedElements = options.allowedElements;
  const allowElement = options.allowElement;
  const components = options.components;
  const disallowedElements = options.disallowedElements;
  const skipHtml = options.skipHtml;
  const unwrapDisallowed = options.unwrapDisallowed;
  const urlTransform = options.urlTransform || defaultUrlTransform;
  for (const deprecation of deprecations$1) {
    if (Object.hasOwn(options, deprecation.from)) {
      unreachable(
        "Unexpected `" + deprecation.from + "` prop, " + (deprecation.to ? "use `" + deprecation.to + "` instead" : "remove it") + " (see <" + changelog + "#" + deprecation.id + "> for more info)"
      );
    }
  }
  visit(tree, transform);
  return toJsxRuntime(tree, {
    Fragment: jsxRuntimeExports.Fragment,
    components,
    ignoreInvalidStyle: true,
    jsx: jsxRuntimeExports.jsx,
    jsxs: jsxRuntimeExports.jsxs,
    passKeys: true,
    passNode: true
  });
  function transform(node2, index2, parent2) {
    if (node2.type === "raw" && parent2 && typeof index2 === "number") {
      if (skipHtml) {
        parent2.children.splice(index2, 1);
      } else {
        parent2.children[index2] = { type: "text", value: node2.value };
      }
      return index2;
    }
    if (node2.type === "element") {
      let key2;
      for (key2 in urlAttributes) {
        if (Object.hasOwn(urlAttributes, key2) && Object.hasOwn(node2.properties, key2)) {
          const value = node2.properties[key2];
          const test = urlAttributes[key2];
          if (test === null || test.includes(node2.tagName)) {
            node2.properties[key2] = urlTransform(String(value || ""), key2, node2);
          }
        }
      }
    }
    if (node2.type === "element") {
      let remove = allowedElements ? !allowedElements.includes(node2.tagName) : disallowedElements ? disallowedElements.includes(node2.tagName) : false;
      if (!remove && allowElement && typeof index2 === "number") {
        remove = !allowElement(node2, index2, parent2);
      }
      if (remove && parent2 && typeof index2 === "number") {
        if (unwrapDisallowed && node2.children) {
          parent2.children.splice(index2, 1, ...node2.children);
        } else {
          parent2.children.splice(index2, 1);
        }
        return index2;
      }
    }
  }
}
function defaultUrlTransform(value) {
  const colon = value.indexOf(":");
  const questionMark = value.indexOf("?");
  const numberSign = value.indexOf("#");
  const slash = value.indexOf("/");
  if (
    // If there is no protocol, it’s relative.
    colon === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash !== -1 && colon > slash || questionMark !== -1 && colon > questionMark || numberSign !== -1 && colon > numberSign || // It is a protocol, it should be allowed.
    safeProtocol.test(value.slice(0, colon))
  ) {
    return value;
  }
  return "";
}
const MessageContainer = ({ children, type, avatarUrl, author }) => {
  const isAI = type === "ai";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      p: 3,
      border: "1px solid",
      borderColor: isAI ? "border.accent.muted" : "border.default",
      borderRadius: 2,
      minWidth: isAI ? "80%" : null,
      maxWidth: isAI ? "96%" : "84%",
      width: "fit-content",
      alignSelf: isAI ? "flex-start" : "flex-end",
      bg: isAI ? "accent.subtle" : "canvas.default",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { direction: "horizontal", align: "start", gap: "none", children: isAI ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(InitialsAvatar, { initials: "AI", size: 20, avatarUrl: avatarUrl || aiAvatarAsset }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { flex: 1, ml: 2, pr: 4, lineHeight: 1 }, children })
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { flex: 1, mr: 2, lineHeight: 1 }, children }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(InitialsAvatar, { initials: (author == null ? void 0 : author[0]) || "U", size: 20, avatarUrl })
      ] }) })
    }
  );
};
const AIMessageOutput = ({ content: content2, author, avatarUrl }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MessageContainer, { type: "ai", avatarUrl, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", sx: { "& p": { marginTop: 0 }, lineHeight: "var(--text-body-lineHeight-medium, 1.4285)" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Markdown, { children: content2 }) }) });
};
const MarkdownOutput = ({
  blockMatch
}) => {
  if (!blockMatch.isVisible) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    AIMessageOutput,
    {
      content: blockMatch.output,
      author: "Assistant"
    }
  );
};
const getActionIcon = (action) => {
  const fieldTypeMap = {
    "add_text_field": "text",
    "update_text_field": "text",
    "add_textarea_field": "textarea",
    "update_textarea_field": "textarea",
    "add_email_field": "email",
    "update_email_field": "email",
    "add_number_field": "number",
    "update_number_field": "number",
    "add_phone_number_field": "telephone",
    "update_phone_number_field": "telephone",
    "add_dropdown_field": "dropdown",
    "update_dropdown_field": "dropdown",
    "add_radio_field": "radio",
    "update_radio_field": "radio",
    "add_checkbox_field": "checkbox",
    "update_checkbox_field": "checkbox",
    "add_date_field": "date",
    "update_date_field": "date",
    "add_room_block_field": "room_block",
    "update_room_block_field": "room_block",
    "add_session_booking_field": "session_booking",
    "update_session_booking_field": "session_booking",
    "add_section": "section",
    "update_section": "section",
    "add_page": "page",
    "update_page": "page",
    "add_info_field": "info",
    "update_info_field": "info",
    "add_lead_scanner_field": "lead_scanner",
    "update_lead_scanner_field": "lead_scanner"
  };
  const fieldType = fieldTypeMap[action.type];
  return fieldType ? getFieldIcon(fieldType) : null;
};
const ActionSuggestions = ({
  suggestion,
  status,
  onAccept,
  onReject
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MessageContainer, { type: "ai", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "vertical", gap: "condensed", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Sure, here are the changes you've requested:" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { direction: "vertical", gap: "condensed", children: suggestion.actions.map((action, index2) => {
      const IconComponent = getActionIcon(action);
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", gap: "condensed", children: [
        IconComponent && /* @__PURE__ */ jsxRuntimeExports.jsx(IconComponent, { size: 16 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", children: getActionSummary(action) })
      ] }, index2);
    }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", justify: "space-between", children: [
      status === "pending" && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, { variant: "invisible", size: "medium", onClick: onReject, children: "Cancel" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, { variant: "primary", size: "medium", onClick: onAccept, children: "Apply Changes" })
      ] }),
      status === "accepted" && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, { variant: "primary", size: "medium", onClick: onAccept, disabled: true, children: "Accepted" })
      ] }),
      status === "rejected" && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, { variant: "invisible", size: "medium", onClick: onReject, disabled: true, children: "Rejected" })
    ] })
  ] }) });
};
const ActionSuggestionsContainer = ({
  suggestion,
  messageId,
  status
}) => {
  const [acceptanceStatus, setAcceptanceStatus] = useState(status);
  const { dispatch } = useCollabRegForm();
  const { onSuggestionAccepted, onSuggestionRejected } = useChat();
  const handleAccept = useCallback$1(() => {
    setAcceptanceStatus("accepted");
    onSuggestionAccepted == null ? void 0 : onSuggestionAccepted(messageId);
    const transformedActions = suggestion.actions.map(
      (action) => ydocChangeSuggestionsActionTransformer(action)
    );
    dispatch({
      type: "batch_change",
      payload: transformedActions
    });
  }, [suggestion]);
  const handleReject = useCallback$1(() => {
    onSuggestionRejected == null ? void 0 : onSuggestionRejected(messageId);
    setAcceptanceStatus("rejected");
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    ActionSuggestions,
    {
      suggestion,
      status: acceptanceStatus,
      onAccept: handleAccept,
      onReject: handleReject
    }
  );
};
const BuildingComponent = () => /* @__PURE__ */ jsxRuntimeExports.jsx(MessageContainer, { type: "ai", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "condensed", sx: { alignItems: "center" }, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, { size: "small", "aria-label": "Building" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "small", color: "fg.muted", children: "Building, please wait..." })
] }) });
const SuggestedActionsOutput = ({
  blockMatch,
  isStreamFinished,
  messageId,
  status
}) => {
  const { onAsk, onError: onErrorChat } = useChat();
  const timeoutRef = useRef();
  const hasReportedRef = useRef(false);
  const { data: suggestion, error: error2 } = zFormAssistantChangeSuggestion.safeParse(
    parseJson5(blockMatch.output)
  );
  useEffect(() => {
    if (error2 && onAsk && isStreamFinished && !hasReportedRef.current) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        if (!hasReportedRef.current) {
          hasReportedRef.current = true;
          onErrorChat == null ? void 0 : onErrorChat(messageId, `*System Message*: Error parsing form assistant actions: ${error2.toString()}`);
        }
      }, 500);
    }
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [Boolean(error2), onAsk, onErrorChat, isStreamFinished]);
  if (!blockMatch.isVisible) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(BuildingComponent, {}, `${messageId}-hidden`);
  }
  if (error2) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionSuggestionsContainer, { suggestion, messageId, status });
};
const ReasoningOutput = ({
  blockMatch
}) => {
  const hasLoggedRef = useRef(false);
  useEffect(() => {
    if (hasLoggedRef.current) return;
    console.log(blockMatch.output);
    hasLoggedRef.current = true;
  }, []);
  return null;
};
const buttonsSchema = z$1.object({
  type: z$1.literal("buttons"),
  question: z$1.string(),
  buttons: z$1.array(z$1.object({ text: z$1.string(), type: z$1.string().optional() }))
});
const ButtonsOutput = ({
  blockMatch
}) => {
  const { onAsk } = useChat();
  const [chosenOption, setChosenOption] = useState(null);
  const onChoiceClick = (text2) => {
    setChosenOption(text2);
    onAsk == null ? void 0 : onAsk(text2);
  };
  if (!blockMatch.isVisible) {
    return null;
  }
  const { data: buttons, error: error2 } = buttonsSchema.safeParse(
    parseJson5(blockMatch.output)
  );
  if (error2) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MessageContainer, { type: "ai", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "vertical", gap: "condensed", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: buttons.question }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
    buttons.buttons.length === 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      ButtonComponent,
      {
        variant: "primary",
        disabled: chosenOption !== null,
        onClick: () => onChoiceClick(buttons.buttons[0].text),
        leadingVisual: buttons.buttons[0].type ? getFieldIcon(buttons.buttons[0].type) : void 0,
        children: buttons.buttons[0].text
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionMenu, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Button, { variant: "invisible", disabled: chosenOption !== null, children: chosenOption || "Choose an option" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Overlay, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList, { children: buttons.buttons.map((button, index2) => {
        const IconComponent = button.type ? getFieldIcon(button.type) : null;
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(
          ActionList.Item,
          {
            onSelect: () => onChoiceClick(button.text),
            disabled: chosenOption !== null,
            children: [
              IconComponent && /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.LeadingVisual, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconComponent, { size: "small" }) }),
              button.text
            ]
          },
          index2
        );
      }) }) })
    ] })
  ] }) });
};
const newEntitiesSchema = z$1.object({
  type: z$1.literal("new_entities"),
  entities: z$1.array(z$1.object({ type: z$1.string(), id: z$1.string(), name: z$1.string() }))
});
const NewEntitiesOutput = ({
  blockMatch
}) => {
  if (!blockMatch.isVisible) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(BuildingComponent, {});
  }
  const { data: entities, error: error2 } = newEntitiesSchema.safeParse(
    parseJson5(blockMatch.output)
  );
  if (error2) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MessageContainer, { type: "ai", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "vertical", gap: "condensed", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Here are the entities we've created:" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { direction: "vertical", gap: "condensed", children: entities.entities.map((entity, index2) => {
      const IconComponent = getFieldIcon(entity.type);
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", gap: "condensed", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(IconComponent, { size: 16 }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$2, { size: "medium", sx: { textTransform: "capitalize" }, children: [
          entity.name,
          " (",
          entity.type,
          ")"
        ] })
      ] }, index2);
    }) })
  ] }) });
};
const throttle = throttleBasic({
  readAheadChars: 10,
  targetBufferChars: 7,
  adjustPercentage: 0.35,
  frameLookBackMs: 1e4,
  windowLookBackMs: 2e3
});
const FormAssistantChatMessage = ({
  message: message2
}) => {
  const [_2, forceUpdate] = useState(0);
  const { blockMatches, isFinished } = useLLMOutput({
    llmOutput: message2.content,
    blocks: [
      {
        ...jsonBlock({ type: "form_assistant_actions", defaultVisible: false }),
        component: (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          SuggestedActionsOutput,
          {
            isStreamFinished: message2.isStreamFinished,
            messageId: message2.id,
            status: message2.status,
            ...props
          }
        )
      },
      {
        ...jsonBlock({ type: "reasoning", defaultVisible: false }),
        component: ReasoningOutput
      },
      {
        ...jsonBlock({ type: "buttons", defaultVisible: false }),
        component: ButtonsOutput
      },
      {
        ...jsonBlock({ type: "new_entities", defaultVisible: false }),
        component: NewEntitiesOutput
      }
    ],
    fallbackBlock: {
      component: MarkdownOutput,
      // from Step 1
      lookBack: markdownLookBack()
    },
    isStreamFinished: message2.isStreamFinished,
    throttle
  });
  useEffect(() => {
    if (isFinished && message2.isStreamFinished) {
      const frame = requestAnimationFrame(() => {
        forceUpdate((prev2) => prev2 + 1);
      });
      return () => {
        cancelAnimationFrame(frame);
      };
    }
  }, [message2.isStreamFinished, isFinished]);
  if (message2.status === "error") return null;
  return blockMatches.map((match5, index2) => {
    const BlockComponent = match5.block.component;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(BlockComponent, { blockMatch: match5 }, index2);
  });
};
const ChatInputField = ({
  onSend,
  placeholder: placeholder2 = "Design powerful forms in seconds through simple conversation. Just describe what you need, and watch as intelligent AI transforms your words into inputs...",
  disabled = false
}) => {
  const [message2, setMessage] = useState("");
  const textareaRef = useRef(null);
  const handleSend = () => {
    if (message2.trim() && !disabled) {
      onSend(message2.trim());
      setMessage("");
    }
  };
  const handleKeyDown2 = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [message2]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      p: 3,
      bg: "bg.secondary",
      borderTop: "1px solid",
      borderColor: "border.default",
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Box,
        {
          position: "relative",
          bg: "#fff",
          borderRadius: 2,
          border: "1px solid",
          borderColor: "border.default",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "textarea",
              {
                ref: textareaRef,
                value: message2,
                onChange: (e) => setMessage(e.target.value),
                onKeyDown: handleKeyDown2,
                placeholder: placeholder2,
                disabled,
                style: {
                  width: "100%",
                  minHeight: "100px",
                  maxHeight: "200px",
                  padding: "12px 16px",
                  border: "none",
                  outline: "none",
                  resize: "none",
                  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif",
                  fontSize: "14px",
                  lineHeight: "1.4",
                  color: "#24292f",
                  backgroundColor: "transparent",
                  boxSizing: "border-box"
                }
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              IconButton,
              {
                icon: ArrowUpIcon,
                "aria-label": "Send",
                onClick: handleSend,
                sx: {
                  position: "absolute",
                  right: 3,
                  bottom: 3,
                  backgroundColor: "accent.fg"
                },
                size: "large",
                variant: "primary"
              }
            )
          ]
        }
      )
    }
  );
};
const ChatHeader = () => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { borderBottom: "1px solid", borderColor: "border.default" }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(BlankslateContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { mb: 3, sx: { width: 64, height: 64 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Avatar,
      {
        src: aiAvatarAsset,
        alt: "AI Avatar",
        size: 64
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(BlankslateContainer.Heading, { children: "Regi Form Assistant" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(BlankslateContainer.Description, { children: "Hello! I'm Regi, your friendly AI form-building assistant! Need help creating forms, editing or adding fields? I'm here to make your form-building experience quick and easy, just ask!" })
  ] }) });
};
const MessageOutput = ({ message: message2, avatarUrl }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MessageContainer, { type: "user", avatarUrl, author: message2.author, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", sx: { lineHeight: "var(--text-body-lineHeight-medium, 1.4285)" }, children: message2.content }) });
};
const Header$1 = ({ title, onClose }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { px: 4, pt: 3, bg: "bg.secondary", borderTopLeftRadius: 3, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", justify: "space-between", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "semibold", children: title }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, { variant: "invisible", onClick: onClose, children: /* @__PURE__ */ jsxRuntimeExports.jsx(XIcon, {}) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { mt: 2 })
  ] });
};
const StatusIndicator = ({ message: message2 }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "condensed", sx: { alignItems: "center" }, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, { size: "small" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "small", color: "fg.muted", role: "status", "aria-live": "polite", children: message2 })
] });
const ErrorIndicator = ({ message: message2 }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Banner2, { title: "Error", description: message2, variant: "critical" });
const FormAssistantChat = ({
  renderButton
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { chat, chatHistory, onAsk, assistantState, avatarUrl } = useChat();
  const endRef = useRef(null);
  const scrollToEnd = useCallback$1(() => {
    var _a3;
    (_a3 = endRef.current) == null ? void 0 : _a3.scrollIntoView({ behavior: "smooth", block: "end" });
  }, []);
  useEffect(() => {
    const timer = setTimeout(scrollToEnd, 100);
    return () => clearTimeout(timer);
  }, [chatHistory, assistantState, scrollToEnd]);
  if (!chat || !onAsk) {
    return null;
  }
  const onClose = () => {
    setIsOpen(false);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    !isOpen && renderButton({
      onClick: () => {
        setIsOpen(true);
      }
    }),
    isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Dialog,
      {
        onClose,
        position: "right",
        width: "large",
        sx: {
          backgroundColor: "bg.secondary",
          height: "var(--available-height)",
          maxHeight: "var(--available-height)"
        },
        renderFooter: () => /* @__PURE__ */ jsxRuntimeExports.jsx(
          ChatInputField,
          {
            onSend: onAsk,
            placeholder: "Design powerful forms in seconds through simple conversation. Just describe what you need, and watch as intelligent AI transforms your words into inputs..."
          }
        ),
        renderHeader: () => /* @__PURE__ */ jsxRuntimeExports.jsx(Header$1, { title: "AI Form Assistant", onClose }),
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ChatHeader, {}),
          chatHistory.map((message2) => {
            if (message2.hidden) return null;
            if (message2.isCurrentUser) {
              return /* @__PURE__ */ jsxRuntimeExports.jsx(MessageOutput, { message: message2, avatarUrl }, message2.id);
            } else {
              return /* @__PURE__ */ jsxRuntimeExports.jsx(FormAssistantChatMessage, { message: message2 }, message2.id);
            }
          }),
          assistantState === AssistantState.PROCESSING && /* @__PURE__ */ jsxRuntimeExports.jsx(StatusIndicator, { message: "Thinking..." }),
          assistantState === AssistantState.TOOL_CALLS && /* @__PURE__ */ jsxRuntimeExports.jsx(StatusIndicator, { message: "Tinkering with tools..." }),
          assistantState === AssistantState.ERROR_CORRECTION && /* @__PURE__ */ jsxRuntimeExports.jsx(StatusIndicator, { message: "Something went wrong, trying to fix it..." }),
          assistantState === AssistantState.ERROR && /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorIndicator, { message: "An unexpected error occurred. Please try again, or contact support if the issue persists." }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: endRef })
        ] })
      }
    )
  ] });
};
const AddPanelPrimer = ({ onFieldAdded }) => {
  const { form, editorState, formSettings, dispatch } = useRegForm();
  const { chat } = useChat();
  const addFieldHandler = (field) => {
    dispatch({ type: "add_field", field });
    onFieldAdded == null ? void 0 : onFieldAdded();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      sx: {
        flex: 1,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        bg: "bg.secondary",
        borderTopLeftRadius: "12px",
        border: "1px solid",
        borderColor: "border.default",
        overflow: "hidden",
        position: "relative",
        zIndex: 4
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Box,
          {
            mx: 4,
            py: 3,
            mb: 3,
            sx: {
              flexShrink: 0,
              borderBottom: "1px solid",
              borderColor: "border.default"
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { weight: "semibold", size: "medium", children: "Form Builder" })
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Box,
          {
            sx: {
              flex: 1,
              overflowY: "auto",
              overflowX: "hidden"
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { px: 4, pb: 3, children: [
              chat && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(StickySectionHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "geologica-header", children: "AI FORM BUILDER" }) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  FormAssistantChat,
                  {
                    renderButton: (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(FieldButtonPrimer, { input: aiInput, onClick: props.onClick })
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { my: 3 })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(StickySectionHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "geologica-header", children: "LAYOUT" }) }),
              layoutInputs.map((field) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                FieldButtonPrimer,
                {
                  input: field,
                  onClick: () => {
                    if (field.label === "Section") {
                      dispatch({ type: "add_page" });
                      onFieldAdded == null ? void 0 : onFieldAdded();
                    } else {
                      addFieldHandler(field.field);
                    }
                  }
                },
                field.label
              )),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { my: 2 }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(StickySectionHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "geologica-header", children: "STANDARD INPUTS" }) }),
              standartInputs.map((field) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                FieldButtonPrimer,
                {
                  input: field,
                  onClick: () => {
                    addFieldHandler(field.field);
                  }
                },
                field.label
              )),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { my: 3 }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(StickySectionHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "geologica-header", children: "FORMATTED INPUTS" }) }),
              formattedInputs.map((field) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                FieldButtonPrimer,
                {
                  input: field,
                  onClick: () => {
                    addFieldHandler(field.field);
                  }
                },
                field.label
              )),
              !isPreRegPageSelected(form, editorState) && complexFieldTypesEnabled(formSettings) && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { my: 3 }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(StickySectionHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "geologica-header", children: "WIDGETS" }) }),
                formSettings.sessionBookingEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  SessionBookingManager,
                  {
                    form,
                    showPrices: formSettings.shoppingCartEnabled,
                    currency: formSettings.shoppingCartCurrency,
                    onSelectSession: (session) => {
                      dispatch({
                        type: "add_field",
                        field: defaultSessionField(session)
                      });
                      onFieldAdded == null ? void 0 : onFieldAdded();
                    },
                    renderButton: (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                      FieldButtonPrimer,
                      {
                        input: {
                          label: "Bookable Sessions",
                          description: "Add bookable sessions with capacity limits.",
                          Icon: BookmarkIcon
                        },
                        onClick: props.onClick
                      }
                    )
                  }
                ),
                formSettings.roomingEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  RoomingManager,
                  {
                    onSelectRoomBlock: (roomBlock) => {
                      dispatch({
                        type: "add_field",
                        field: defaultRoomBlockField(roomBlock, formSettings)
                      });
                      onFieldAdded == null ? void 0 : onFieldAdded();
                    },
                    renderButton: (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                      FieldButtonPrimer,
                      {
                        input: {
                          label: "Room Block",
                          description: "Enable room blocking for attendees.",
                          Icon: HomeIcon
                        },
                        onClick: props.onClick
                      }
                    )
                  }
                ),
                formSettings.leadScannersEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  FieldButtonPrimer,
                  {
                    input: {
                      label: "Lead Scanner",
                      description: "Allow attendees to enable lead scanning.",
                      Icon: DeviceMobileIcon
                    },
                    onClick: () => {
                      dispatch({
                        type: "add_field",
                        field: fieldDefaults.leadScannerField
                      });
                      onFieldAdded == null ? void 0 : onFieldAdded();
                    }
                  }
                )
              ] })
            ] })
          }
        )
      ]
    }
  );
};
const FieldPropertiesForm = ({
  field,
  onChange
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
    field.type !== "info" && /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { id: "required", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Checkbox$1,
        {
          checked: field.required,
          onChange: (e) => onChange({ required: e.target.checked })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Required" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "This field is required to be filled in by the attendee." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { id: "officeOnly", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Checkbox$1,
        {
          checked: field.officeOnly,
          onChange: (e) => onChange({ officeOnly: e.target.checked })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Admin visible only" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "This field is only visible to admins, and not attendees." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { id: "editLocked", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Checkbox$1,
        {
          checked: field.editLocked,
          onChange: (e) => onChange({ editLocked: e.target.checked })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Edit Locked" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "If selected, attendees cannot edit this field after registration." })
    ] }),
    field.type === "boolean" && /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Checkbox$1,
        {
          checked: field.checkpoint,
          onChange: (e) => onChange({ checkpoint: e.target.checked })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Create a checkpoint" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "Create a checkpoint for users who select this field" })
    ] })
  ] });
};
const SessionDependsCheckboxGroup = ({ dependsValue, sessionBookingField, onChange }) => {
  const { data: session } = useSession(sessionBookingField.session);
  if (session === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {});
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Value" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CheckboxGroup$1,
      {
        onChange: (values2) => {
          onChange(values2.map((v2) => Number(v2)));
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { gap: "normal", children: session.slots.map((slot) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          Checkbox$1,
          {
            value: slot.id.toString(),
            checked: dependsValue == null ? void 0 : dependsValue.map((v2) => v2.toString()).includes(slot.id.toString()),
            children: slot.name
          },
          slot.id
        )) })
      }
    )
  ] });
};
const EventPathCheckboxGroup$2 = ({
  form,
  dependsValue,
  sessions,
  tracks,
  onChange
}) => {
  const eventPaths = getEventPathValues(form, tracks, sessions);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Paths" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxGroup$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { gap: "condensed", children: Array.from(eventPaths.values()).sort().map((path2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox$1,
      {
        value: path2,
        checked: dependsValue == null ? void 0 : dependsValue.includes(path2),
        onChange: (e) => {
          const isChecked = e.target.checked;
          const newValues = dependsValue || [];
          if (isChecked) {
            onChange([...newValues, path2]);
          } else {
            onChange(newValues.filter((v2) => v2 !== path2));
          }
        },
        children: path2
      },
      path2
    )) }) })
  ] });
};
const getAvailableRoomTypes = (roomBlock, roomBlockField) => {
  if (roomBlockField.includeRoomTypes === void 0) {
    return roomBlock.roomTypes;
  } else {
    return roomBlock.roomTypes.filter(
      (rt) => {
        var _a3;
        return (_a3 = roomBlockField.includeRoomTypes) == null ? void 0 : _a3.includes(rt.id);
      }
    );
  }
};
const RoomBlockDependsValueCheckboxes = ({ dependsValue, roomBlockField, onChange }) => {
  const { data: roomBlock } = useRoomBlock(roomBlockField.roomBlockId);
  if (roomBlock === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {});
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Booked" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { gap: "condensed", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Checkbox$1,
        {
          checked: dependsValue === void 0,
          onChange: () => onChange(void 0),
          children: "Not booked"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Room type" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        CheckboxGroup$1,
        {
          onChange: (values2) => onChange(values2.map((v2) => v2.toString())),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { gap: "condensed", children: getAvailableRoomTypes(roomBlock, roomBlockField).map(
            (roomType) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              Checkbox$1,
              {
                value: roomType.id.toString(),
                checked: dependsValue == null ? void 0 : dependsValue.map((v2) => v2.toString()).includes(roomType.id.toString()),
                children: roomType.name
              },
              roomType.id
            )
          ) })
        }
      )
    ] })
  ] });
};
const DependsValueForm = ({
  form,
  dependsTarget,
  field,
  sessions = [],
  tracks = [],
  onChange
}) => {
  var _a3;
  if (!isDependsField(dependsTarget)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      EventPathCheckboxGroup$2,
      {
        form,
        sessions,
        tracks,
        onChange,
        dependsValue: (_a3 = getDependsValue(field)) == null ? void 0 : _a3.map((v2) => v2.toString())
      }
    );
  }
  switch (dependsTarget.type) {
    case "boolean":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$1, { checked: true, disabled: true }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: dependsTarget.label }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "This field will be visible when the checkbox is checked." })
      ] });
    case "session_booking":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        SessionDependsCheckboxGroup,
        {
          dependsValue: getDependsValue(field),
          sessionBookingField: dependsTarget,
          onChange
        }
      );
    case "room_block":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        RoomBlockDependsValueCheckboxes,
        {
          dependsValue: getDependsValue(field),
          roomBlockField: dependsTarget,
          onChange
        }
      );
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(
        CheckboxGroup$1,
        {
          onChange,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxGroup$1.Label, { children: "Field Values" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxGroup$1.Caption, { children: "Select one or more values" }),
            normalizedFieldChoices(dependsTarget).map((choice) => {
              var _a4, _b;
              return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$1, { value: ((_a4 = choice.value) == null ? void 0 : _a4.toString()) || choice.label }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: ((_b = choice.value) == null ? void 0 : _b.toString()) || choice.label }) })
              ] }, choice.value || choice.label);
            })
          ]
        }
      );
  }
};
const Checkbox = ({
  label,
  caption,
  checked,
  onChange,
  disabled = false,
  id
}) => {
  const handleChange = (event) => {
    onChange(event.target.checked);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox$1,
      {
        checked,
        onChange: handleChange,
        disabled,
        id
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: label }) }),
    caption && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: caption })
  ] });
};
const DependsOnForm = ({
  field,
  sessions,
  tracks,
  onChange
}) => {
  const [isDependsOnActive, setIsDependsOnActive] = useState(!!field.dependsOn);
  const { form } = useRegForm();
  const dependTargets = getDependTargetsWithEventPath(
    form,
    field,
    sessions,
    tracks
  );
  const [dependsTarget, setDependsTarget] = useState(
    dependTargets.find(
      (f2) => isDependsField(f2) ? f2.name === getDependsName(field) : "EVENT_PATH" === getDependsName(field)
    )
  );
  const handleFieldChange = (e) => {
    const newTarget = e.target.value === "EVENT_PATH" ? "EVENT_PATH" : getDependTarget(form, e.target.value);
    setDependsTarget(newTarget);
    if (newTarget === void 0) {
      onChange({ dependsOn: void 0 });
    } else if (newTarget !== "EVENT_PATH" && (newTarget.type === "boolean" || newTarget.type === "room_block")) {
      onChange({ dependsOn: newTarget.name });
    }
  };
  const handleValueChange = (values2) => {
    if (dependsTarget !== void 0) {
      onChange({
        dependsOn: [targetName(dependsTarget), values2]
      });
    }
  };
  const handleToggleChange = (active) => {
    setIsDependsOnActive(active);
    if (!active) {
      onChange({ dependsOn: void 0 });
      setDependsTarget(void 0);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox,
      {
        label: "Field Depends On",
        caption: "Only visible if another field is selected",
        checked: isDependsOnActive,
        onChange: handleToggleChange
      }
    ),
    isDependsOnActive && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { id: "depends_on", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Box,
      {
        as: Stack,
        direction: "horizontal",
        gap: "normal",
        align: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { style: { transform: "rotate(180deg)" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ReplyIcon, { size: "small" }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            Select$1,
            {
              value: dependsTarget !== void 0 ? targetName(dependsTarget) : "",
              onChange: handleFieldChange,
              block: true,
              size: "large",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Select$1.Option, { value: "", children: "Please Choose" }),
                dependTargets.map(
                  (target) => isDependsField(target) ? /* @__PURE__ */ jsxRuntimeExports.jsx(Select$1.Option, { value: target.name, children: fieldLabel(target) }, target.name) : /* @__PURE__ */ jsxRuntimeExports.jsx(Select$1.Option, { value: "EVENT_PATH", children: "EVENT_PATH" }, "EVENT_PATH")
                )
              ]
            }
          )
        ]
      }
    ) }),
    isDependsOnActive && dependsTarget !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "normal", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { style: { opacity: 0 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ReplyIcon, { size: "small" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DependsValueForm,
        {
          form,
          dependsTarget,
          field,
          sessions,
          tracks,
          onChange: handleValueChange
        }
      )
    ] })
  ] });
};
const DependsOnFormWithEventPath = ({
  field,
  onChange
}) => {
  const {
    error: sessionsError,
    isLoading: sessionsLoading,
    sessions
  } = useSessions();
  const { error: tracksError, isLoading: tracksLoading, tracks } = useTracks();
  if (sessionsError) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { status: "error", children: "Error Fetching Sessions" });
  }
  if (tracksError) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { status: "error", children: "Error Fetching Tracks" });
  }
  if (tracksLoading || sessionsLoading) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {});
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DependsOnForm,
    {
      field,
      onChange,
      sessions,
      tracks
    }
  );
};
const DependsOnFormContainer = ({
  field,
  onChange
}) => {
  const { formSettings } = useRegForm();
  if (formSettings.metadataEnabled) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(DependsOnFormWithEventPath, { field, onChange });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(DependsOnForm, { field, onChange });
  }
};
const fieldLabels = {
  attendee_reference: "Text Field",
  checkbox: "Check Box",
  date: "Date",
  document: "Document",
  dropdown: "Dropdown",
  email: "Email Address",
  info: "Info Text",
  integer: "Number",
  lead_scanner: "Lead Scanner",
  page: "Section",
  telephone: "Phone Number",
  radio: "Radio Buttons",
  room_block: "Room Block",
  section: "Subsection",
  session_booking: "Session Booking",
  textarea: "Text Area",
  text: "Text Field"
};
const getLabel = (formItem) => fieldLabels["kind" in formItem && formItem.kind !== void 0 ? formItem.kind : formItem.type];
const getFieldIconForField = (field) => {
  const fieldType = "kind" in field ? field.kind : field.type;
  return getFieldIcon(fieldType);
};
const Header2 = ({ field, onDelete, onClose, sideAction }) => {
  const { formSettings } = useRegForm();
  const Icon2 = getFieldIconForField(field);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      mx: 4,
      py: 3,
      mb: 0,
      sx: {
        flexShrink: 0,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px solid",
        borderColor: "border.default",
        bg: "bg.secondary"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", gap: "condensed", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Icon2, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "semibold", children: getLabel(field) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", gap: "condensed", children: [
          sideAction,
          !protectFromHideOrDelete(field, formSettings) && /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonComponent, { variant: "danger", onClick: onDelete, children: [
            "Remove ",
            getLabel(field)
          ] }),
          onClose && /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog.CloseButton, { onClose })
        ] })
      ]
    }
  );
};
const ChoicesTableItem = ({
  choice,
  onCommitEdit,
  onUpdateChoice,
  onDeleteChoice,
  onEditMetadata,
  showPrices = false,
  currency = "$"
}) => {
  const [label, setLabel] = useState(choice.label);
  const [value, setValue] = useState(choice.value);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: choice.id
  });
  const style3 = {
    transform: CSS$1.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  };
  const handleLabelChange = (e) => {
    const newLabel = e.target.value;
    setLabel(newLabel);
    setValue(newLabel);
    onUpdateChoice(choice, { label: newLabel, value: newLabel });
  };
  const handleBlur = () => {
    onCommitEdit();
  };
  const handleValueChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    onUpdateChoice(choice, { value: newValue });
  };
  const gridTemplateColumns2 = showPrices ? "1fr 8fr 8fr 8fr 1fr" : "1fr 8fr 8fr 1fr";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      as: Stack,
      direction: "horizontal",
      ref: setNodeRef,
      style: style3,
      sx: {
        display: "grid",
        gridTemplateColumns: gridTemplateColumns2,
        gap: 2
      },
      mb: 3,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: GrabberIcon,
            "aria-label": "Grab",
            size: "large",
            variant: "invisible",
            sx: { color: "fg.muted", cursor: "grab" },
            ...attributes,
            ...listeners
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextInput$1,
          {
            size: "large",
            value: label,
            placeholder: "Label",
            onChange: handleLabelChange,
            onBlur: handleBlur,
            width: "100%"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextInput$1,
          {
            size: "large",
            value,
            placeholder: "Value",
            onChange: handleValueChange,
            onBlur: handleBlur,
            width: "100%"
          }
        ) }),
        showPrices && /* @__PURE__ */ jsxRuntimeExports.jsx(
          PriceInput$2,
          {
            valueInCents: choice.price,
            currency: currency || "$",
            onChange: (price) => onUpdateChoice(choice, { price }),
            onBlur: handleBlur,
            size: "large"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          AnchoredOverlay,
          {
            open: isMenuOpen,
            onOpen: () => setIsMenuOpen(true),
            onClose: () => setIsMenuOpen(false),
            renderAnchor: (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              IconButton,
              {
                ...props,
                icon: KebabHorizontalIcon,
                size: "large",
                "aria-label": "Page options",
                "aria-labelledby": void 0,
                onClick: () => setIsMenuOpen(true)
              }
            ),
            side: "outside-right",
            align: "end",
            anchorOffset: 20,
            children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionList, { role: "menu", children: [
              onEditMetadata !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
                ActionList.Item,
                {
                  role: "menuitem",
                  onSelect: () => onEditMetadata(choice),
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.LeadingVisual, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(PlusIcon, { size: "small" }) }),
                    "Data Tags"
                  ]
                }
              ),
              onDeleteChoice !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Divider, {}),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  ActionList.Item,
                  {
                    variant: "danger",
                    role: "menuitem",
                    onSelect: () => onDeleteChoice(choice),
                    children: "Delete"
                  }
                )
              ] })
            ] })
          }
        )
      ]
    }
  );
};
const Headers = ["Label", "Value"];
const ChoicesTableHeader = ({
  showPrices = false,
  currency = "$"
}) => {
  const gridTemplateColumns2 = showPrices ? "1fr 8fr 8fr 8fr 1fr" : "1fr 8fr 8fr 1fr";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      sx: {
        display: "grid",
        gridTemplateColumns: gridTemplateColumns2,
        gap: 2,
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { visibility: "hidden" }, bg: "blue", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: GrabberIcon,
            "aria-label": "Grab",
            size: "large",
            variant: "invisible"
          }
        ) }),
        Headers.map((header) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          Text$2,
          {
            size: "medium",
            weight: "medium",
            sx: {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            children: header
          },
          header
        )),
        showPrices && /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$2, { size: "medium", weight: "medium", children: [
          "Price (",
          currency || "$",
          ")"
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { visibility: "hidden" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: GrabberIcon,
            "aria-label": "Grab",
            size: "large",
            variant: "invisible"
          }
        ) })
      ]
    }
  );
};
const NewChoiceItem = ({ onAddChoice }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      sx: {
        display: "flex",
        justifyContent: "flex-end",
        width: "100%"
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        IconButton,
        {
          icon: PlusIcon,
          size: "large",
          "aria-label": "Add Slot",
          onClick: onAddChoice ?? void 0,
          variant: "primary",
          sx: {
            visibility: onAddChoice ? "visible" : "hidden"
          }
        }
      )
    }
  );
};
const ChoicesTable = ({
  choices,
  showPrices = false,
  currency = "$",
  onCommitEdit,
  onMoveChoice,
  onUpdateChoice,
  onDeleteChoice,
  onAddChoice,
  onEditMetadata
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor)
  );
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (over && active.id !== over.id && choices) {
      const oldIndex = choices.findIndex((s2) => s2.id === active.id);
      const newIndex = choices.findIndex((s2) => s2.id === over.id);
      if (oldIndex !== -1 && newIndex !== -1) {
        onMoveChoice(oldIndex, newIndex);
      }
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ChoicesTableHeader, { showPrices, currency }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      DndContext,
      {
        sensors,
        modifiers: [restrictToVerticalAxis],
        onDragEnd: handleDragEnd,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          SortableContext,
          {
            items: choices.map((c2) => c2.id) ?? [],
            strategy: verticalListSortingStrategy,
            children: choices.map((choice, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              ChoicesTableItem,
              {
                choice,
                onCommitEdit,
                onUpdateChoice,
                onDeleteChoice,
                onAddChoice: index2 === choices.length - 1 ? onAddChoice : void 0,
                onEditMetadata,
                showPrices,
                currency
              },
              choice.id
            ))
          }
        )
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(NewChoiceItem, { onAddChoice })
  ] });
};
const placholderText = `Choice 1, value 1
Choice 2, value 2
Choice 3, value 3
`;
const ImportChoicesModal = ({
  isOpen,
  onAppend,
  onCancel
}) => {
  const [importText, setImportText] = useState("");
  const [errors, setErrors] = useState([]);
  const handleSave = () => {
    setErrors([]);
    const newErrors = [];
    const choices = [];
    const parsed = papaparse_minExports.parse(importText, { header: false, delimiter: "," });
    if (parsed.errors.length > 0) {
      newErrors.push(`Error parsing CSV: ${parsed.errors[0].message}`);
    }
    if (parsed.data.length === 0) {
      newErrors.push("Error: No rows found");
    }
    parsed.data.forEach((row, index2) => {
      if (row.length === 0) return;
      if (row.length === 1 && row[0] === "") return;
      if (row.length < 2) {
        newErrors.push(
          `Error on line ${index2 + 1}: Each row must have at least two columns`
        );
      } else {
        choices.push({
          label: row[0],
          value: row[1]
        });
      }
    });
    if (newErrors.length > 0) {
      setErrors(newErrors);
    } else {
      onAppend(choices);
    }
  };
  return isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
    Dialog,
    {
      title: "Import Choices",
      onClose: onCancel,
      width: "large",
      renderFooter: () => /* @__PURE__ */ jsxRuntimeExports.jsx(
        GregDialogFooter,
        {
          leftButtonText: "Cancel",
          rightButtonText: "Import",
          onLeftButtonClick: onCancel,
          onRightButtonClick: handleSave
        }
      ),
      sx: {
        backgroundColor: "bg.secondary",
        zIndex: 1e3
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("form", { id: "import-choices-form", onSubmit: () => {
      }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { direction: "horizontal", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { sx: { width: "100%" }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "CSV for Choices" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Textarea,
          {
            value: importText,
            placeholder: placholderText,
            onChange: (e) => setImportText(e.target.value),
            block: true
          }
        ),
        errors.map((error2, idx) => /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Validation, { variant: "error", children: error2 }, idx)),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "Enter choice labels and values in CSV format" })
      ] }) }) }) })
    }
  );
};
const ChoicesEditor = ({ field: initialField }) => {
  var _a3;
  const { formSettings, dispatch } = useRegForm();
  const [metadataModal, setMetadataModal] = useState({ isOpen: false, choice: null });
  const [field, setField] = useState(initialField);
  const [importChoicesModal, setImportChoicesModal] = useState({ isOpen: false });
  useEffect(() => {
    setField(initialField);
  }, [initialField]);
  const applyFieldUpdate = useCallback$1(
    (update2, options = {}) => {
      setField((prev2) => {
        const next2 = {
          ...prev2,
          ...update2,
          choices: update2.choices ?? prev2.choices
        };
        if (options.persist) {
          dispatch({
            type: "update_field",
            name: next2.name,
            payload: inferDataTypeFromChoices(next2)
          });
        }
        return next2;
      });
    },
    [dispatch]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
    field.kind !== "radio" && /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { bg: "#f2f4f6", p: 2, borderRadius: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Checkbox$1,
        {
          checked: field.includeBlank,
          onChange: () => {
            applyFieldUpdate(
              { includeBlank: !field.includeBlank },
              { persist: true }
            );
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Add an empty option" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "This will insert a blank choice at the beginning of the list" })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      InfoBanner,
      {
        text: "Create " + (field == null ? void 0 : field.kind) + " options for attendees. Labels show on the form, values are saved for reporting. Advanced: ",
        linkText: "Import multiple choices with CSV format.",
        onClick: () => setImportChoicesModal({ isOpen: true })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ChoicesEditorInner,
      {
        field,
        showPrices: formSettings.shoppingCartEnabled,
        currency: formSettings.shoppingCartCurrency,
        onChange: (update2) => {
          applyFieldUpdate(update2);
        },
        onCommit: (update2) => {
          applyFieldUpdate(update2, { persist: true });
        },
        onEditMetadata: formSettings.metadataEnabled ? (choice) => {
          setMetadataModal({ isOpen: true, choice });
        } : void 0
      },
      ((_a3 = field.choices) == null ? void 0 : _a3.length) ?? 0
    ),
    metadataModal.choice && metadataModal.isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
      MetadataModalPrimer,
      {
        isOpen: metadataModal.isOpen,
        onClose: () => setMetadataModal({ isOpen: false, choice: null }),
        metadata: metadataModal.choice.metadata,
        onSave: (metadata) => {
          if (!metadataModal.choice) return;
          const updatedChoices = (field.choices ?? []).map((c2) => normalizedChoiceWithId(c2)).map(
            (c2) => c2.id === metadataModal.choice.id ? { ...c2, metadata } : c2
          );
          applyFieldUpdate({ choices: updatedChoices }, { persist: true });
          setMetadataModal({ isOpen: false, choice: null });
        }
      }
    ),
    importChoicesModal.isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
      ImportChoicesModal,
      {
        isOpen: importChoicesModal.isOpen,
        onAppend: (choices) => {
          applyFieldUpdate(
            {
              choices: [...field.choices, ...choices].map(
                normalizedChoiceWithId
              )
            },
            { persist: true }
          );
          setImportChoicesModal({ isOpen: false });
        },
        onCancel: () => setImportChoicesModal({ isOpen: false })
      }
    )
  ] });
};
const ChoicesEditorInner = ({
  field,
  showPrices,
  currency,
  onChange,
  onCommit,
  onEditMetadata
}) => {
  const [choices, dispatch] = useReducer(
    choicesReducer,
    normalizedFieldChoices(field)
  );
  useEffect(() => {
    onChange({ choices });
  }, [choices, onChange]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    ChoicesTable,
    {
      choices,
      showPrices,
      currency,
      onCommitEdit: () => onCommit({ choices }),
      onMoveChoice: (startIndex, endIndex) => {
        const newChoices = [...choices];
        const [movedChoice] = newChoices.splice(startIndex, 1);
        newChoices.splice(endIndex, 0, movedChoice);
        dispatch({ type: "move_choice", startIndex, endIndex });
        onCommit({ choices: newChoices });
      },
      onUpdateChoice: (choice, update2) => {
        dispatch({ type: "update_choice", id: choice.id, payload: update2 });
      },
      onDeleteChoice: (choice) => {
        const newChoices = choices.filter((c2) => c2.id !== choice.id);
        dispatch({ type: "delete_choice", id: choice.id });
        onCommit({ choices: newChoices });
      },
      onAddChoice: () => {
        onCommit({ choices });
        const newChoice = normalizedChoiceWithId({
          label: `Choice ${choices.length + 1}`,
          value: `Choice ${choices.length + 1}`
        });
        const next2 = [...choices, newChoice];
        dispatch({ type: "add_choice", payload: newChoice });
        onCommit({ choices: next2 });
      },
      onEditMetadata: onEditMetadata ?? void 0
    }
  ) });
};
const numericPrice = (price) => price === void 0 || price === "" ? void 0 : Number(price);
const FieldPriceForm = ({
  field,
  currency,
  onChange
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { visuallyHidden: true, children: "Price to attendee when selected" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    PriceInput$2,
    {
      valueInCents: numericPrice(field.price),
      onChange: (price) => onChange({ price }),
      currency: currency === "USD" ? "$" : currency === "EUR" ? "€" : currency === "GBP" ? "£" : currency
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "Price to attendee when selected" })
] });
const InputEditor = ({ field }) => {
  const [isOpen, setIsOpen] = useState(true);
  const { dispatch, formSettings } = useRegForm();
  const handleChange = (update2) => {
    dispatch({
      type: "update_field",
      name: field.name,
      payload: update2
    });
  };
  const handleDelete2 = () => {
    dispatch({ type: "delete_field", name: field.name });
    setIsOpen(false);
  };
  const handleClose = () => {
    dispatch({ type: "deselect_field" });
    setIsOpen(false);
  };
  const renderBody = () => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { p: 4, bg: "bg.secondary", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FieldTextForm, { field, onChange: handleChange }),
      (field.kind === "radio" || field.kind === "dropdown") && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Choices", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChoicesEditor, { field }) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Field Options", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldPropertiesForm, { field, onChange: handleChange }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TracksVisibilityItem, { field }),
      formSettings.shoppingCartEnabled && field.type === "boolean" && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Price", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          FieldPriceForm,
          {
            field,
            onChange: handleChange,
            currency: formSettings.shoppingCartCurrency
          }
        ) })
      ] }),
      field.type !== "attendee_reference" && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Depends On", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DependsOnFormContainer, { field, onChange: handleChange }) })
      ] }),
      formSettings.metadataEnabled && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Data Tags", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          DataTagsForm,
          {
            field,
            onSave: (metadata) => handleChange({ metadata })
          }
        ) })
      ] })
    ] }) });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "field-editor-dialog", children: isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
    Dialog,
    {
      width: "large",
      sx: {
        backgroundColor: "bg.secondary",
        zIndex: 5,
        height: "var(--available-height)",
        maxHeight: "var(--available-height)"
      },
      position: "right",
      onClose: handleClose,
      renderBody,
      renderHeader: () => /* @__PURE__ */ jsxRuntimeExports.jsx(
        Header2,
        {
          field,
          onDelete: handleDelete2,
          onClose: handleClose
        }
      )
    }
  ) });
};
const ContainerEditor = ({ field }) => {
  const [isOpen, setIsOpen] = useState(true);
  const { dispatch, formSettings } = useRegForm();
  const handleChange = (update2) => {
    dispatch({
      type: "update_field",
      name: field.name,
      payload: update2
    });
  };
  const handleDelete2 = (field2) => dispatch({ type: "delete_field", name: field2.name });
  const handleClose = () => {
    dispatch({ type: "deselect_field" });
    setIsOpen(false);
  };
  const renderBody = () => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { p: 4, bg: "bg.secondary", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        FieldTextForm,
        {
          field,
          labelFieldLabel: "Label",
          onChange: handleChange
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TracksVisibilityItem, { field }),
      field.type === "section" && !protectFromHideOrDelete(field, formSettings) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Depends On", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DependsOnFormContainer, { field, onChange: handleChange }) })
      ] }),
      formSettings.metadataEnabled && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Data Tags", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          DataTagsForm,
          {
            field,
            onSave: (metadata) => handleChange({ metadata })
          }
        ) })
      ] })
    ] }) });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "field-editor-dialog", children: isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
    Dialog,
    {
      width: "large",
      sx: {
        backgroundColor: "bg.secondary",
        height: "var(--available-height)",
        maxHeight: "var(--available-height)"
      },
      position: "right",
      onClose: handleClose,
      renderBody,
      renderHeader: () => /* @__PURE__ */ jsxRuntimeExports.jsx(
        Header2,
        {
          field,
          onDelete: () => handleDelete2(field),
          onClose: handleClose
        }
      )
    }
  ) });
};
const InfoSectionEditor = ({ field }) => {
  const [isOpen, setIsOpen] = useState(true);
  const { dispatch, formSettings } = useRegForm();
  const handleChange = (update2) => {
    dispatch({
      type: "update_field",
      name: field.name,
      payload: update2
    });
  };
  const handleDelete2 = (field2) => dispatch({ type: "delete_field", name: field2.name });
  const handleClose = () => {
    dispatch({ type: "deselect_field" });
    setIsOpen(false);
  };
  const renderBody = () => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { px: 4, py: 2, bg: "bg.secondary", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { required: true, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Content" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Textarea,
          {
            rows: 9,
            value: field.text,
            onChange: (e) => handleChange({ text: e.target.value }),
            block: true
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "Markdown is accepted" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TracksVisibilityItem, { field }),
      !protectFromHideOrDelete(field, formSettings) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Depends on", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DependsOnFormContainer, { field, onChange: handleChange }) })
      ] })
    ] }) });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "info-field-editor-dialog", children: isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
    Dialog,
    {
      width: "large",
      sx: {
        backgroundColor: "bg.secondary",
        height: "var(--available-height)",
        maxHeight: "var(--available-height)"
      },
      position: "right",
      onClose: handleClose,
      renderBody,
      renderHeader: () => /* @__PURE__ */ jsxRuntimeExports.jsx(
        Header2,
        {
          field,
          onDelete: () => handleDelete2(field),
          onClose: handleClose
        }
      )
    }
  ) });
};
const SlotInclusionFormPrimer = ({
  field,
  session,
  onChange
}) => {
  var _a3;
  const [selectedSlots, setSelectedSlots] = useState(
    ((_a3 = field.includeSlots) == null ? void 0 : _a3.map((s2) => s2.toString())) || []
  );
  const handleIncludeAllChange = (checked) => {
    if (checked) {
      onChange([]);
      setSelectedSlots([]);
    }
  };
  const handleSlotChange = (slotId, checked) => {
    let newSelectedSlots;
    if (checked) {
      newSelectedSlots = [...selectedSlots, slotId];
    } else {
      newSelectedSlots = selectedSlots.filter((id) => id !== slotId);
    }
    setSelectedSlots(newSelectedSlots);
    onChange(newSelectedSlots.length > 0 ? newSelectedSlots.map(Number) : void 0);
  };
  const includeAll = !hasIncludeSlots(field);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { bg: "#f2f4f6", p: 2, borderRadius: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Checkbox$1,
        {
          checked: includeAll,
          onChange: (e) => handleIncludeAllChange(e.target.checked)
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Include all session slots" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "When enabled, all available session slots will be included in the form field." })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Or Selected Session Slots" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(CheckboxGroup$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxGroup$1.Label, { visuallyHidden: true, children: "Include selected session slots" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxGroup$1.Caption, { children: "Choose specific session slots to include in the form field." }),
      session.slots.map((slot) => /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { sx: { mt: 2 }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Checkbox$1,
          {
            checked: selectedSlots.includes(slot.id.toString()),
            onChange: (e) => handleSlotChange(slot.id.toString(), e.target.checked)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: slot.name }) }),
        slot.description && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: slot.description })
      ] }, slot.id))
    ] })
  ] });
};
const maxChoicesForMin = (field, minChoices) => {
  if (field.maxChoices === void 0 || field.maxChoices < minChoices) {
    return minChoices;
  } else {
    return field.maxChoices;
  }
};
const minChoicesForMax = (field, maxChoices) => {
  if (field.minChoices === void 0 || field.minChoices <= maxChoices) {
    return field.minChoices;
  } else {
    return maxChoices;
  }
};
const MinMaxSlotChoicesPrimer = ({
  field,
  onChange
}) => {
  var _a3;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { pt: 3, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Number of slot choices" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { my: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "normal", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { sx: { flex: 1 }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Minimum" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "The minimum session slots a user can select for this field." }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextInput$1,
          {
            block: true,
            type: "number",
            value: field.minChoices || "",
            onChange: (e) => {
              const value = parseInt(e.target.value, 10);
              if (!isNaN(value)) {
                onChange({
                  minChoices: value,
                  maxChoices: maxChoicesForMin(field, value)
                });
              } else {
                onChange({
                  minChoices: void 0
                });
              }
            },
            min: 0,
            placeholder: "0"
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { sx: { flex: 1 }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Maximum" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "The maximum session slots a user can select for this field." }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          TextInput$1,
          {
            block: true,
            type: "number",
            value: field.maxChoices || "",
            onChange: (e) => {
              const value = parseInt(e.target.value, 10);
              if (!isNaN(value)) {
                const newMax = Math.max(value, 1);
                onChange({
                  maxChoices: newMax,
                  minChoices: minChoicesForMax(field, newMax)
                });
              } else {
                onChange({
                  maxChoices: void 0
                });
              }
            },
            min: ((_a3 = field == null ? void 0 : field.defaultSlots) == null ? void 0 : _a3.length) || 1,
            placeholder: "1"
          }
        )
      ] })
    ] })
  ] });
};
const SlotDefaultsFormPrimer = ({
  field,
  session,
  onChange,
  onFieldChange,
  showMinMaxChoices = false
}) => {
  var _a3;
  const [selectedSlots, setSelectedSlots] = useState(
    ((_a3 = field.defaultSlots) == null ? void 0 : _a3.map((s2) => s2.toString())) || []
  );
  const handleSlotChange = (slotId, checked) => {
    let newSelectedSlots;
    if (checked) {
      newSelectedSlots = [...selectedSlots, slotId];
    } else {
      newSelectedSlots = selectedSlots.filter((id) => id !== slotId);
    }
    setSelectedSlots(newSelectedSlots);
    onChange(newSelectedSlots.length > 0 ? newSelectedSlots.map(Number) : void 0);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(CheckboxGroup$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxGroup$1.Label, { visuallyHidden: true, children: "Slot Options" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxGroup$1.Caption, { children: "Slots to be selected by default" }),
      visibleSlots(field, session).map((slot) => /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { sx: { mt: 2 }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Checkbox$1,
          {
            checked: selectedSlots.includes(slot.id.toString()),
            onChange: (e) => handleSlotChange(slot.id.toString(), e.target.checked)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: slot.name }) }),
        slot.description && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: slot.description })
      ] }, slot.id))
    ] }),
    showMinMaxChoices && onFieldChange && /* @__PURE__ */ jsxRuntimeExports.jsx(
      MinMaxSlotChoicesPrimer,
      {
        field,
        onChange: onFieldChange
      }
    )
  ] });
};
const SessionPricingForm = ({
  field,
  session,
  onChange,
  isLoading = false,
  error: error2 = null
}) => {
  const { formSettings } = useRegForm();
  const handlePriceChange = (slotId, price) => {
    const currentOverrides = field.priceOverrides || {};
    if (price !== void 0) {
      onChange({
        priceOverrides: {
          ...currentOverrides,
          [slotId]: price
        }
      });
    } else {
      const newOverrides = { ...currentOverrides };
      delete newOverrides[slotId];
      onChange({ priceOverrides: newOverrides });
    }
  };
  const slots = session ? visibleSlots(field, session) : [];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
    error2 && /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { p: 3, sx: { bg: "danger.subtle", borderRadius: 2 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "small", sx: { color: "danger.fg" }, children: "Error loading Session" }) }),
    isLoading && /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { p: 4, textAlign: "center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {}) }),
    !isLoading && !error2 && slots.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        InfoBanner,
        {
          text: "Override price used for specific sessions when users choose sessions using this form field."
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Box,
        {
          mb: -2,
          sx: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: 2,
            alignItems: "center"
          },
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Slot" }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Default" }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Override" }) })
          ]
        }
      ),
      slots.map((slot) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Box,
        {
          sx: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: 2,
            alignItems: "center"
          },
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { visuallyHidden: true, children: "Slot" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                TextInput$1,
                {
                  value: slot.name,
                  readOnly: true,
                  sx: {
                    bg: "neutral.muted",
                    borderColor: "border.default",
                    color: "fg.default"
                  }
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { visuallyHidden: true, children: "Default Price" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                TextInput$1,
                {
                  value: slot.priceInCents ? priceWithSymbol({
                    price: slot.priceInCents,
                    currency: formSettings.shoppingCartCurrency
                  }) : "No Price",
                  readOnly: true,
                  sx: {
                    bg: "neutral.muted",
                    borderColor: "border.default",
                    color: "fg.default"
                  }
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { visuallyHidden: true, children: "Override Price" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                PriceInput$2,
                {
                  currency: formSettings.shoppingCartCurrency,
                  valueInCents: getPriceOverride(field, slot),
                  onChange: (price) => handlePriceChange(slot.id, price),
                  size: "medium"
                }
              )
            ] })
          ]
        },
        slot.id
      ))
    ] }) }),
    !isLoading && !error2 && slots.length === 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { p: 4, textAlign: "center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { children: "No session slots available" }) })
  ] });
};
const SessionBookingFieldEditor = ({
  field,
  session
}) => {
  const { dispatch, formSettings } = useRegForm();
  const handleChange = (update2) => {
    dispatch({
      type: "update_field",
      name: field.name,
      payload: update2
    });
  };
  const handleChangeDefaults = (defaultSlots) => {
    const filteredDefaultSlots = defaultSlots == null ? void 0 : defaultSlots.filter(
      (id) => isVisibleSlot(field, session, id)
    );
    if (filteredDefaultSlots === void 0 || field.maxChoices !== void 0 && field.maxChoices > filteredDefaultSlots.length) {
      handleChange({ defaultSlots });
    } else {
      handleChange({ defaultSlots, maxChoices: filteredDefaultSlots.length });
    }
  };
  const renderBody = () => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { px: 4, py: 2, bg: "bg.secondary", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FieldTextForm, { field, onChange: handleChange }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Session Slot Visibility", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        SlotInclusionFormPrimer,
        {
          field,
          session,
          onChange: (includeSlots) => handleChange({
            includeSlots: includeSlots == null ? void 0 : includeSlots.map((id) => Number(id))
          })
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Session Slots Options", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        SlotDefaultsFormPrimer,
        {
          field,
          session,
          onChange: (defaultSlots) => handleChangeDefaults(defaultSlots == null ? void 0 : defaultSlots.map((id) => Number(id))),
          onFieldChange: handleChange,
          showMinMaxChoices: formSettings.multipleSessionSlotChoices
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Slot Pricing", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        SessionPricingForm,
        {
          field,
          session,
          onChange: handleChange
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Field Options", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldPropertiesForm, { field, onChange: handleChange }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TracksVisibilityItem, { field }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Depends On", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DependsOnFormContainer, { field, onChange: handleChange }) }),
      formSettings.metadataEnabled && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Data Tags", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            InfoBanner,
            {
              text: "Data tags are an advanced tool to dynamically add registration data to mobile apps, name-badges, and integrations, enabling seamless automation and personalization, ",
              href: "https://google.com",
              linkText: "find out more..."
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            DataTagEditor,
            {
              metadata: field.metadata || [],
              onSave: (metadata) => handleChange({ metadata })
            }
          )
        ] }) })
      ] })
    ] }) });
  };
  return renderBody();
};
const EditSessionDialog = ({
  session,
  onUpdated,
  isOpen,
  onClose
}) => {
  const formRef = React__default.createRef();
  const onSave = () => {
    var _a3;
    (_a3 = formRef == null ? void 0 : formRef.current) == null ? void 0 : _a3.triggerSave();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseDialog,
    {
      isOpen,
      onClose,
      title: "Edit Bookable Session",
      width: "900px",
      position: "right",
      headerIcon: BookmarkIcon,
      leftButtonText: "Cancel",
      rightButtonText: "Save",
      onLeftButtonClick: onClose,
      onRightButtonClick: onSave,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        EditSession,
        {
          ref: formRef,
          session,
          onUpdated
        }
      )
    }
  );
};
const SessionBookingFieldEditorContainer = ({
  field
}) => {
  const { isLoading, data: session } = useSession(field.session);
  const [isOpen, setIsOpen] = useState(true);
  const [isEditSessionOpen, setIsEditSessionOpen] = useState(false);
  const { dispatch } = useRegForm();
  const handleDelete2 = (field2) => dispatch({ type: "delete_field", name: field2.name });
  const handleClose = () => {
    dispatch({ type: "deselect_field" });
    setIsOpen(false);
  };
  if (isLoading) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {}) });
  }
  if (session === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Error loading session" });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { id: "field-editor-dialog", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      BaseDialog,
      {
        isOpen,
        onClose: handleClose,
        title: "Session Booking",
        width: "large",
        position: "right",
        headerIcon: BookmarkIcon,
        leftButtonText: "Cancel",
        rightButtonText: "Save",
        showFooter: false,
        headerActions: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", gap: "condensed", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              icon: GearIcon,
              "aria-label": "Edit session",
              variant: "default",
              onClick: () => setIsEditSessionOpen(true),
              tooltipDirection: "s"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              icon: TrashIcon,
              "aria-label": "Delete session field",
              variant: "danger",
              onClick: () => handleDelete2(field),
              tooltipDirection: "s"
            }
          )
        ] }),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(SessionBookingFieldEditor, { field, session })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      EditSessionDialog,
      {
        session,
        isOpen: isEditSessionOpen,
        onClose: () => setIsEditSessionOpen(false),
        onUpdated: (updatedSession) => {
          setIsEditSessionOpen(false);
        }
      }
    )
  ] });
};
const RoomTypeInclusionForm = ({
  field,
  roomBlock,
  onChange
}) => {
  const isVisibleToAllTracks = !hasIncludeRoomTypes(field);
  const handleVisibleToAllTracksChange = (event) => {
    if (event.target.checked) {
      onChange([]);
    }
  };
  const handleIndividualTracksChange = (value) => {
    onChange(value);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { bg: "#f2f4f6", p: 2, borderRadius: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Checkbox$1,
        {
          checked: isVisibleToAllTracks,
          onChange: handleVisibleToAllTracksChange
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "All Room Types" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "All room types will be visible" })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Or Selected Room Types" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CheckboxGroup$1,
      {
        onChange: handleIndividualTracksChange,
        children: roomBlock.roomTypes.map((roomType) => /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$1, { value: roomType.id.toString() }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: roomType.name })
        ] }, roomType.id))
      }
    )
  ] });
};
const RoomingFieldDefaultsForm = ({
  roomBlock,
  field,
  onChange
}) => {
  const { dateFormats: dateFormats2 } = useLocale();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Start Date" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DatePickerPrimer,
        {
          onChangeRaw: (e) => e.preventDefault(),
          minDate: roomBlock.startDate,
          maxDate: subDays$1(roomBlock.endDate),
          dateFormat: dateFormats2.regular,
          onChange: (defaultCheckIn) => onChange({ defaultCheckIn: formatISODate(defaultCheckIn) }),
          selectedDate: parseISODate(field.defaultCheckIn),
          inputProps: {
            size: "medium",
            block: true
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Text$2,
        {
          size: "small",
          weight: "medium",
          sx: { color: "fg.muted", marginTop: -1 },
          children: "Pre-selected check-in date for guests"
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "End Date" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DatePickerPrimer,
        {
          onChangeRaw: (e) => e.preventDefault(),
          minDate: addDays$1(roomBlock.startDate, 1),
          maxDate: roomBlock.endDate,
          dateFormat: dateFormats2.regular,
          onChange: (defaultCheckOut) => onChange({ defaultCheckOut: formatISODate(defaultCheckOut) }),
          selectedDate: parseISODate(field.defaultCheckOut),
          inputProps: {
            size: "medium",
            block: true
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Text$2,
        {
          size: "small",
          weight: "medium",
          sx: { color: "fg.muted", marginTop: -1 },
          children: "Pre-selected check-out date for guests"
        }
      )
    ] })
  ] });
};
const RoomingFieldAvailableDatesForm = ({
  roomBlock,
  field,
  onChange
}) => {
  const { dateFormats: dateFormats2 } = useLocale();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Start Date" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DatePickerPrimer,
        {
          onChangeRaw: (e) => e.preventDefault(),
          minDate: roomBlock.startDate,
          maxDate: subDays$1(roomBlock.endDate),
          dateFormat: dateFormats2.regular,
          onChange: (availabilityStartDate) => onChange({
            availableFrom: formatISODate(availabilityStartDate)
          }),
          selectedDate: parseISODate(field.availableFrom),
          inputProps: {
            size: "medium",
            block: true
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Text$2,
        {
          size: "small",
          weight: "medium",
          sx: { color: "fg.muted", marginTop: -1 },
          children: "Override the default start date. Admins can always book outside these dates."
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "End Date" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DatePickerPrimer,
        {
          onChangeRaw: (e) => e.preventDefault(),
          minDate: addDays$1(roomBlock.startDate, 1),
          maxDate: roomBlock.endDate,
          dateFormat: dateFormats2.regular,
          onChange: (availabilityEndDate) => onChange({
            availableTo: formatISODate(availabilityEndDate)
          }),
          selectedDate: parseISODate(field.availableTo),
          inputProps: {
            size: "medium",
            block: true
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Text$2,
        {
          size: "small",
          weight: "medium",
          sx: { color: "fg.muted", marginTop: -1 },
          children: "Override the default end date. Admins can always book outside these dates."
        }
      )
    ] })
  ] });
};
const RoomingPricingForm = ({
  field,
  onChange
}) => {
  const { formSettings } = useRegForm();
  const { data: roomBlock, error: error2, isLoading } = useRoomBlock(field.roomBlockId);
  const handlePriceChange = (roomTypeId, nightId, price) => {
    if (field.occupancyPricing) {
      const currentOverrides = field.occupancyPriceOverrides || {};
      const nightOverrides = currentOverrides[nightId] || {};
      if (price !== void 0) {
        const occupancy = 1;
        nightOverrides[occupancy] = price;
        onChange({
          occupancyPriceOverrides: {
            ...currentOverrides,
            [nightId]: nightOverrides
          }
        });
      } else {
        const newNightOverrides = { ...nightOverrides };
        delete newNightOverrides[1];
        if (Object.keys(newNightOverrides).length === 0) {
          const newOverrides = { ...currentOverrides };
          delete newOverrides[nightId];
          onChange({ occupancyPriceOverrides: newOverrides });
        } else {
          onChange({
            occupancyPriceOverrides: {
              ...currentOverrides,
              [nightId]: newNightOverrides
            }
          });
        }
      }
    } else {
      const currentOverrides = field.priceOverrides || {};
      if (price !== void 0) {
        onChange({
          priceOverrides: {
            ...currentOverrides,
            [nightId]: price
          }
        });
      } else {
        const newOverrides = { ...currentOverrides };
        delete newOverrides[nightId];
        onChange({ priceOverrides: newOverrides });
      }
    }
  };
  const getPriceOverride2 = (nightId) => {
    var _a3, _b, _c;
    if (field.occupancyPricing) {
      return (_b = (_a3 = field.occupancyPriceOverrides) == null ? void 0 : _a3[nightId]) == null ? void 0 : _b[1];
    } else {
      return (_c = field.priceOverrides) == null ? void 0 : _c[nightId];
    }
  };
  if (isLoading) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { p: 4, textAlign: "center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { children: "Loading room block..." }) });
  }
  if (error2 || !roomBlock) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { p: 4, textAlign: "center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { children: "Error loading room block" }) });
  }
  const nights = getRoomBlockDateRange(roomBlock);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
    formSettings.occupancyPricingEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { bg: "neutral.muted", p: 2, borderRadius: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Checkbox$1,
        {
          checked: field.occupancyPricing,
          onChange: () => onChange({ occupancyPricing: !field.occupancyPricing })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: "Occupancy Based Pricing" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { children: "Override the default room price for selected nights" })
    ] }) }),
    roomBlock.roomTypes.length > 0 ? roomBlock.roomTypes.map((roomType) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      Accordion,
      {
        title: roomType.name,
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { transform: "rotate(180deg)" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ReplyIcon, { size: 16 }) }),
        divider: false,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "small", weight: "medium", mb: 2, children: "Default Price" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              PriceInput$2,
              {
                currency: formSettings.shoppingCartCurrency,
                valueInCents: roomType.price,
                onChange: () => {
                },
                disabled: true,
                size: "medium"
              }
            )
          ] }),
          nights.length > 0 && roomType.nights.length > 0 ? nights.map((night) => {
            var _a3;
            const nightId = (_a3 = roomType.nights.find(
              (n2) => n2.date.toDateString() === night.toDateString()
            )) == null ? void 0 : _a3.id;
            if (!nightId) return null;
            return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "small", weight: "medium", mb: 2, children: format$2(night, "EEEE d MMM yyyy") }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                PriceInput$2,
                {
                  currency: formSettings.shoppingCartCurrency,
                  valueInCents: getPriceOverride2(nightId),
                  onChange: (price) => handlePriceChange(roomType.id, nightId, price),
                  size: "medium"
                }
              )
            ] }, night.toISOString());
          }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { p: 2, textAlign: "center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "small", children: nights.length === 0 ? "No nights available" : "No room nights configured" }) })
        ] })
      },
      roomType.id
    )) : /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { p: 4, textAlign: "center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { children: "No room types available" }) })
  ] });
};
const RoomBlockFieldEditor = ({
  field,
  roomBlock
}) => {
  const { dispatch } = useRegForm();
  const handleChange = (update2) => dispatch({
    type: "update_field",
    name: field.name,
    payload: update2
  });
  const handleRoomingChange = (update2) => {
    const normalisedUpdate = normalisedRoomBlockDates(roomBlock, {
      ...field,
      ...update2
    });
    dispatch({
      type: "update_field",
      name: field.name,
      payload: { ...update2, ...normalisedUpdate }
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldTextForm, { field, onChange: handleChange }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Room Types", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      RoomTypeInclusionForm,
      {
        field,
        roomBlock,
        onChange: (includeRoomTypes) => handleRoomingChange({ includeRoomTypes })
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Room Pricing Overrides", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(RoomingPricingForm, { field, onChange: handleChange }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Available Dates", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      RoomingFieldAvailableDatesForm,
      {
        roomBlock,
        field,
        onChange: (update2) => handleRoomingChange(update2)
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Default Dates", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      RoomingFieldDefaultsForm,
      {
        roomBlock,
        field,
        onChange: (update2) => handleRoomingChange(update2)
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Field Options", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldPropertiesForm, { field, onChange: handleChange }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(TracksVisibilityItem, { field, onChange: handleChange }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Depends on", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DependsOnFormContainer, { field, onChange: handleChange }) })
  ] });
};
const RoomBlockFieldEditorContainer = ({
  field
}) => {
  const { error: error2, data: roomBlock } = useRoomBlock(field.roomBlockId);
  const [isOpen, setIsOpen] = useState(true);
  const [isEditRoomBlockOpen, setIsEditRoomBlockOpen] = useState(false);
  const { dispatch } = useRegForm();
  if (error2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Error loading room block" });
  }
  if (roomBlock === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { display: "flex", justifyContent: "center" }, p: 6, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {}) });
  }
  const handleDelete2 = (field2) => dispatch({ type: "delete_field", name: field2.name });
  const handleClose = () => {
    dispatch({ type: "deselect_field" });
    setIsOpen(false);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { id: "field-editor-dialog", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      BaseDialog,
      {
        isOpen,
        onClose: handleClose,
        title: "Room Block",
        width: "large",
        position: "right",
        headerIcon: HomeIcon,
        leftButtonText: "Cancel",
        rightButtonText: "Save",
        showFooter: false,
        headerActions: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", gap: "condensed", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              icon: GearIcon,
              "aria-label": "Edit room block",
              variant: "default",
              onClick: () => setIsEditRoomBlockOpen(true),
              tooltipDirection: "s"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              icon: TrashIcon,
              "aria-label": "Delete room block field",
              variant: "danger",
              onClick: () => handleDelete2(field),
              tooltipDirection: "s"
            }
          )
        ] }),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(RoomBlockFieldEditor, { field, roomBlock })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      EditRoomBlockDialog,
      {
        roomBlock,
        isOpen: isEditRoomBlockOpen,
        onClose: () => setIsEditRoomBlockOpen(false),
        onUpdated: (updatedRoomBlock) => {
          console.log("Room block updated:", updatedRoomBlock);
        }
      }
    )
  ] });
};
const LeadScannerEditor = ({ field }) => {
  const [isOpen, setIsOpen] = useState(true);
  const { dispatch, formSettings } = useRegForm();
  const handleChange = (update2) => {
    dispatch({
      type: "update_field",
      name: field.name,
      payload: update2
    });
  };
  const handleDelete2 = () => {
    dispatch({ type: "delete_field", name: field.name });
    setIsOpen(false);
  };
  const handleClose = () => {
    dispatch({ type: "deselect_field" });
    setIsOpen(false);
  };
  const renderBody = () => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { p: 4, bg: "bg.secondary", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FieldTextForm, { field, onChange: handleChange }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Field Options", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldPropertiesForm, { field, onChange: handleChange }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TracksVisibilityItem, { field }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Depends On", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DependsOnFormContainer, { field, onChange: handleChange }) }),
      formSettings.shoppingCartEnabled && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Price", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          FieldPriceForm,
          {
            field,
            onChange: handleChange,
            currency: formSettings.shoppingCartCurrency
          }
        ) })
      ] }),
      formSettings.metadataEnabled && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { title: "Data Tags", divider: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          DataTagsForm,
          {
            field,
            onSave: (metadata) => handleChange({ metadata })
          }
        ) })
      ] })
    ] }) });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "field-editor-dialog", children: isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
    Dialog,
    {
      width: "large",
      sx: {
        backgroundColor: "bg.secondary"
      },
      position: "right",
      onClose: handleClose,
      renderBody,
      renderHeader: () => /* @__PURE__ */ jsxRuntimeExports.jsx(
        Header2,
        {
          field,
          onDelete: handleDelete2,
          onClose: handleClose
        }
      )
    }
  ) });
};
const FieldEditorPrimer = ({ field: v1Field }) => {
  if (v1Field === null || v1Field === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { children: "Please select a field to start editing" });
  }
  const field = formItemToV2(v1Field);
  switch (field.type) {
    case "page":
      return null;
    case "section":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerEditor, { field }, field.name);
    case "info":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(InfoSectionEditor, { field }, field.name);
    case "session_booking":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SessionBookingFieldEditorContainer, { field }, field.name);
    case "room_block":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(RoomBlockFieldEditorContainer, { field }, field.name);
    case "lead_scanner":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(LeadScannerEditor, { field }, field.name);
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(InputEditor, { field }, field.name);
  }
};
const getText$2 = (change) => {
  switch (change.type) {
    case "save_form":
      return "saved the form.";
    case "reset_form":
      return "reset the form.";
    case "add_item":
      return `added ${change.item.label || change.item.name}.`;
    case "update_item":
      return `updated ${change.item.label || change.item.name}.`;
    case "delete_item":
      return `deleted ${change.item.label || change.item.name}.`;
    case "item_changeset":
      const changeset = change;
      const changeCount = changeset.includedChanges.length;
      return `made ${changeCount} changes`;
    default:
      return "made changes to the form.";
  }
};
const ChangeDescription = ({ change }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$2, { size: "medium", weight: "medium", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$2, { as: "span", color: "fg.default", children: [
      change.user.name,
      ", "
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { as: "span", color: "fg.muted", children: getText$2(change) })
  ] });
};
const ChangeItem = ({
  change,
  isUndoable,
  isAI,
  onUndo,
  expandable = false,
  onExpand,
  isExpanded = false
}) => {
  var _a3;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Timeline$1.Item, { sx: { alignItems: "center", padding: "8px 0" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Timeline$1.Badge, { sx: {
      overflow: "visible"
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      InitialsAvatar,
      {
        initials: change.user.initials,
        isAI,
        isTimeline: true,
        size: 32,
        avatarUrl: (_a3 = change.user) == null ? void 0 : _a3.avatarUrl
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Timeline$1.Body, { sx: { ml: 3 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", justify: "space-between", gap: "none", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "vertical", gap: "none", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ChangeDescription, { change }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "small", weight: "medium", color: "fg.muted", children: new Date(change.timestamp).toLocaleTimeString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit"
        }) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", align: "center", children: [
        expandable && /* @__PURE__ */ jsxRuntimeExports.jsx(
          ButtonComponent,
          {
            variant: "invisible",
            onClick: onExpand,
            leadingVisual: isExpanded ? FoldIcon : UnfoldIcon,
            size: "small",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "small", weight: "semibold", color: "accent.fg", children: isExpanded ? "Hide" : "Expand" })
          }
        ),
        isUndoable && /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionMenu, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Anchor, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              icon: KebabHorizontalIcon,
              sx: { transform: "rotate(90deg)" },
              "aria-label": "Open menu",
              variant: "invisible"
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Overlay, { width: "medium", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Item, { variant: "danger", onSelect: onUndo, children: "Undo Changes" }) }) })
        ] })
      ] })
    ] }) })
  ] });
};
const CollapsibleChangeGroup = ({
  change,
  isUndoable = false,
  onUndo,
  children
}) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const isAI = Boolean(change.ai);
  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ChangeItem,
      {
        change,
        isUndoable,
        isAI,
        onUndo,
        expandable: true,
        onExpand: toggleExpanded,
        isExpanded
      }
    ),
    isExpanded && /* @__PURE__ */ jsxRuntimeExports.jsx(Timeline$1.Break, {}),
    isExpanded && children,
    isExpanded && /* @__PURE__ */ jsxRuntimeExports.jsx(Timeline$1.Break, {})
  ] });
};
const ChangeHistoryListContainer = ({
  isOpen,
  onClose
}) => {
  const context = useChangeHistory();
  const { dispatch } = useRegForm();
  if (context === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "No context" });
  }
  const { changeHistory } = context;
  const hasUnsaved = changeHistory.unsavedChanges.length > 0;
  const hasPrevious = changeHistory.previousChanges.length > 0;
  const handleUndo = (changeId) => {
    dispatch({ type: "undo_change", changeId });
  };
  const renderChange = (change, enableUndo, isFirst = false) => {
    const isAI = Boolean(change.ai);
    const isUndoable = enableUndo && isFirst && change.type !== "save_form" && change.type !== "reset_form";
    if (change.type === "item_changeset") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        CollapsibleChangeGroup,
        {
          change,
          isUndoable,
          onUndo: () => handleUndo(change.id),
          children: change.includedChanges.map((includedChange) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            ChangeItem,
            {
              change: includedChange,
              isUndoable: false,
              isAI,
              onUndo: () => {
              }
            },
            includedChange.id
          ))
        },
        change.id
      );
    }
    if (change.type === "delete_item" && "includedChanges" in change && Array.isArray(change.includedChanges) && change.includedChanges.length > 0) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        CollapsibleChangeGroup,
        {
          change,
          isUndoable,
          onUndo: () => handleUndo(change.id),
          children: change.includedChanges.map((nestedChange) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            ChangeItem,
            {
              change: nestedChange,
              isUndoable: false,
              isAI,
              onUndo: () => {
              }
            },
            nestedChange.id
          ))
        },
        change.id
      );
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      ChangeItem,
      {
        change,
        isUndoable,
        isAI,
        onUndo: () => handleUndo(change.id)
      },
      change.id
    );
  };
  return isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
    Dialog,
    {
      onClose,
      position: "right",
      width: "large",
      sx: {
        backgroundColor: "bg.secondary",
        zIndex: 5,
        height: "var(--available-height)",
        maxHeight: "var(--available-height)"
      },
      renderHeader: () => /* @__PURE__ */ jsxRuntimeExports.jsx(Header$1, { title: "Form History", onClose }),
      renderBody: () => /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { px: 6, py: 3, bg: "bg.secondary", children: hasUnsaved || hasPrevious ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Timeline$1, { clipSidebar: true, children: [
        changeHistory.unsavedChanges.map(
          (change, index2) => renderChange(change, true, index2 === 0)
        ),
        hasUnsaved && hasPrevious && /* @__PURE__ */ jsxRuntimeExports.jsx(Timeline$1.Break, {}),
        changeHistory.previousChanges.map(
          (change, index2) => renderChange(change, !hasUnsaved, index2 === 0)
        )
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { textAlign: "center", color: "gray" }, children: "No changes to display" }) })
    }
  );
};
const RightPanelPrimer = ({ onFieldAdded }) => {
  const { form, editorState, dispatch } = useRegForm();
  const { selectedField } = getSelectedItems$1({
    fields: form.fields,
    ...editorState
  });
  const isEditOrHistory = editorState.selectedTab === "edit" || editorState.selectedTab === "history";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      sx: {
        width: "480px",
        height: "var(--available-height)",
        maxHeight: "var(--available-height)",
        position: "fixed",
        right: 0,
        top: 0,
        zIndex: isEditOrHistory ? 1 : 4
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(AddPanelPrimer, { onFieldAdded }),
        editorState.selectedTab === "edit" && /* @__PURE__ */ jsxRuntimeExports.jsx(FieldEditorPrimer, { field: selectedField }),
        editorState.selectedTab === "history" && /* @__PURE__ */ jsxRuntimeExports.jsx(
          ChangeHistoryListContainer,
          {
            isOpen: true,
            onClose: () => dispatch({ type: "select_tab", tab: "add" })
          }
        )
      ]
    }
  );
};
const DateField = ({
  name: name2,
  label,
  helpText,
  required: required2,
  onSelect,
  isSelected
}) => {
  const baseBoxProps = {
    onClick: () => onSelect == null ? void 0 : onSelect(name2 || ""),
    p: 4,
    bg: isSelected ? "bg.blue-light" : "bg.secondary"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ...baseBoxProps, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { required: required2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: label }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextInput$1,
      {
        block: true,
        size: "large",
        type: "date",
        name: name2,
        "aria-describedby": helpText ? `${name2}-help` : void 0
      }
    ),
    helpText && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { id: helpText ? `${name2}-help` : void 0, children: helpText })
  ] }) });
};
const InfoSection = ({ name: name2, text: text2, onSelect, isSelected }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { onClick: () => onSelect == null ? void 0 : onSelect(name2 || ""), p: 4, bg: isSelected ? "bg.blue-light" : "bg.secondary", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text$2,
    {
      as: "div",
      size: "medium",
      dangerouslySetInnerHTML: { __html: marked(text2 || "") }
    }
  ) });
};
function priceLabel({
  label,
  price,
  showPrice,
  currency
}) {
  if (showPrice && price) {
    return `${label} (${currency}${formatCents(price)})`;
  } else {
    return label;
  }
}
const getFieldLabel = (text2, name2) => {
  return text2 ? text2 : name2 ? humanizeString(name2) : "";
};
const InputField = ({
  name: name2,
  label,
  price,
  helpText,
  required: required2,
  type,
  showPrice = false,
  currency = "$",
  onSelect,
  isSelected
}) => {
  let inputType;
  switch (type) {
    case "boolean":
      inputType = "checkbox";
      break;
    case "email":
      inputType = type;
      break;
    default:
      inputType = "text";
  }
  const labelText = priceLabel({
    label: getFieldLabel(label, name2),
    price: typeof price === "string" ? parseFloat(price) : price,
    showPrice: showPrice && type === "boolean",
    currency
  });
  const baseBoxProps = {
    onClick: () => onSelect == null ? void 0 : onSelect(name2 || ""),
    p: 4,
    bg: isSelected ? "bg.blue-light" : "bg.secondary"
  };
  if (type === "boolean") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ...baseBoxProps, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox,
      {
        label: labelText,
        caption: helpText,
        checked: name2 === "true",
        onChange: () => onSelect == null ? void 0 : onSelect(name2 || "")
      }
    ) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ...baseBoxProps, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { required: required2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: labelText }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextInput$1,
      {
        block: true,
        size: "large",
        "aria-describedby": helpText ? `${name2}-help` : void 0,
        type: inputType
      }
    ),
    helpText && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { id: helpText ? `${name2}-help` : void 0, children: helpText })
  ] }) });
};
function choiceToObject(choice) {
  if (typeof choice === "object" && choice !== null && "value" in choice) {
    return { label: String(choice.label), value: String(choice.value) };
  }
  if (typeof choice === "object" && choice !== null && "label" in choice) {
    return { label: String(choice.label), value: String(choice.label) };
  }
  if (Array.isArray(choice)) {
    return { label: String(choice[0]), value: String(choice[1]) };
  }
  return { label: String(choice), value: String(choice) };
}
const RadioField = ({
  name: name2,
  label,
  required: required2 = false,
  helpText,
  choices = [],
  includeBlank = false,
  blankText = "--- Please select ----",
  showPrices = false,
  currency = "$",
  onSelect,
  isSelected
}) => {
  const options = choices.map(choiceToObject);
  if (includeBlank) {
    options.unshift({ label: blankText, value: "" });
  }
  const baseBoxProps = {
    onClick: () => onSelect == null ? void 0 : onSelect(name2 || ""),
    p: 4,
    bg: isSelected ? "bg.blue-light" : "bg.secondary"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ...baseBoxProps, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { required: required2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: label }),
    options.map((option) => /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Radio, { name: name2, value: option.value }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: priceLabel({ ...option, showPrice: showPrices, currency }) })
    ] }, option.value)),
    helpText && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { id: helpText ? `${name2}-help` : void 0, children: helpText })
  ] }) });
};
const SortableField = ({ field, onSelect }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: field.name
  });
  const style3 = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : void 0,
    transition,
    zIndex: isDragging ? 1 : void 0
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ref: setNodeRef,
      style: style3,
      className: `t-field ${field.type}`,
      onClick: () => onSelect(field.name),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ...attributes, ...listeners, style: { cursor: "grab" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FieldListItem, { field, onSelect }) })
    }
  );
};
const SortableSection = ({ field, onSelect }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: field.name
  });
  const style3 = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : void 0,
    transition,
    zIndex: isDragging ? 1 : void 0
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ref: setNodeRef,
      style: style3,
      className: "t-field",
      onClick: () => onSelect(field.name),
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ...attributes, ...listeners, style: { cursor: "grab" }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { onClick: () => onSelect(field.name), children: field.label }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { paddingLeft: "1rem" }, children: field.fields.map((subField) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          SortableField,
          {
            field: subField,
            onSelect
          },
          subField.name
        )) })
      ] })
    }
  );
};
const FieldList = ({
  fields = [],
  onSelect,
  onMoveField
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor)
  );
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (over && active.id !== over.id) {
      const overIndex = fields.findIndex((field) => field.name === over.id);
      onMoveField({
        field: active.id,
        destination: null,
        // For now, we're not handling nested sections
        index: overIndex
      });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    DndContext,
    {
      sensors,
      collisionDetection: closestCenter,
      onDragEnd: handleDragEnd,
      modifiers: [restrictToVerticalAxis],
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        SortableContext,
        {
          items: fields.map((field) => field.name),
          strategy: verticalListSortingStrategy,
          children: fields.map((field) => {
            if (field.type === "section") {
              return /* @__PURE__ */ jsxRuntimeExports.jsx(
                SortableSection,
                {
                  field,
                  onSelect
                },
                field.name
              );
            } else {
              return /* @__PURE__ */ jsxRuntimeExports.jsx(
                SortableField,
                {
                  field,
                  onSelect
                },
                field.name
              );
            }
          })
        }
      )
    }
  ) });
};
const isFormSection = (field) => {
  return field.type === "section";
};
const Section$2 = ({
  field,
  isExpanded = false,
  renderChildren = true,
  onSelect,
  onExpand,
  onCollapse
}) => {
  const handleToggle = () => {
    if (isExpanded) {
      onCollapse(field.name);
    } else {
      onExpand(field.name);
    }
  };
  const handleSelect = (id) => {
    onSelect(id);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      sx: {
        borderBottom: "1px solid",
        borderColor: "border.default"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { px: 4, py: 3, onClick: () => onSelect(field.name), children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", justify: "space-between", align: "center", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "semibold", children: field.label }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              "aria-label": "Toggle section",
              onClick: handleToggle,
              icon: KebabHorizontalIcon,
              variant: "invisible"
            }
          )
        ] }) }),
        renderChildren && isFormSection(field) && /* @__PURE__ */ jsxRuntimeExports.jsx(
          FieldList,
          {
            fields: field.fields,
            onSelect: handleSelect,
            onMoveField: () => {
            }
          }
        )
      ]
    }
  );
};
const SelectField = ({
  name: name2,
  label,
  required: required2 = false,
  helpText,
  choices = [],
  includeBlank = false,
  blankText = "Please Select",
  showPrices = false,
  currency = "$",
  onSelect,
  isSelected
}) => {
  const options = choices.map(choiceToObject);
  if (includeBlank) {
    options.unshift({ label: blankText, value: "" });
  }
  const baseBoxProps = {
    onClick: () => onSelect == null ? void 0 : onSelect(name2 || ""),
    p: 4,
    bg: isSelected ? "bg.blue-light" : "bg.secondary"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ...baseBoxProps, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { required: required2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: label }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Select$1,
      {
        block: true,
        size: "large",
        "aria-describedby": helpText ? `${name2}-help` : void 0,
        children: options.map((option) => /* @__PURE__ */ jsxRuntimeExports.jsx(Select$1.Option, { value: option.value, children: priceLabel({ ...option, showPrice: showPrices, currency }) }, option.value))
      }
    ),
    helpText && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { id: helpText ? `${name2}-help` : void 0, children: helpText })
  ] }) });
};
const TextAreaField = ({
  name: name2,
  label,
  helpText,
  required: required2,
  onSelect,
  isSelected
}) => {
  const baseBoxProps = {
    onClick: () => onSelect == null ? void 0 : onSelect(name2 || ""),
    p: 4,
    bg: isSelected ? "bg.blue-light" : "bg.secondary"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ...baseBoxProps, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { required: required2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: label }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Textarea,
      {
        block: true,
        name: name2,
        readOnly: true,
        "aria-describedby": helpText ? `${name2}-help` : void 0
      }
    ),
    helpText && /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { id: helpText ? `${name2}-help` : void 0, children: helpText })
  ] }) });
};
const LeadScannerFieldPreview = ({
  field,
  onSelect,
  isSelected
}) => {
  const { formSettings } = useRegForm();
  const labelText = priceLabel({
    label: field.label || "",
    price: typeof field.price === "string" ? parseFloat(field.price) : field.price,
    showPrice: formSettings.shoppingCartEnabled,
    currency: formSettings.shoppingCartCurrency
  });
  const baseBoxProps = {
    onClick: () => onSelect == null ? void 0 : onSelect(field.name || ""),
    p: 4,
    bg: isSelected ? "bg.blue-light" : "bg.secondary"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ...baseBoxProps, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Checkbox,
    {
      label: labelText,
      caption: field.helpText,
      checked: field.name === "true",
      onChange: () => onSelect == null ? void 0 : onSelect(field.name || "")
    }
  ) });
};
const DocumentField = ({
  name: name2,
  label,
  required: required2,
  onSelect,
  isSelected
}) => {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const baseBoxProps = {
    onClick: () => onSelect == null ? void 0 : onSelect(name2 || ""),
    p: 4,
    bg: isSelected ? "bg.blue-light" : "bg.secondary"
  };
  const handleFileButtonClick = () => {
    var _a3;
    (_a3 = fileInputRef.current) == null ? void 0 : _a3.click();
  };
  const handleFileChange = (event) => {
    var _a3, _b;
    const file = (_b = (_a3 = event == null ? void 0 : event.target) == null ? void 0 : _a3.files) == null ? void 0 : _b[0];
    if (file) {
      setSelectedFile(file);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ...baseBoxProps, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { required: required2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: label }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        ref: fileInputRef,
        type: "file",
        style: { display: "none" },
        onChange: handleFileChange
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "condensed", align: "center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ButtonComponent,
        {
          size: "large",
          onClick: handleFileButtonClick,
          children: "Choose File"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "small", weight: "regular", sx: { color: "fg.muted" }, children: selectedFile ? selectedFile.name : "No file selected" })
    ] })
  ] }) });
};
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var hookCallback;
function hooks() {
  return hookCallback.apply(null, arguments);
}
function setHookCallback(callback) {
  hookCallback = callback;
}
function isArray(input) {
  return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
}
function isObject(input) {
  return input != null && Object.prototype.toString.call(input) === "[object Object]";
}
function hasOwnProp(a2, b2) {
  return Object.prototype.hasOwnProperty.call(a2, b2);
}
function isObjectEmpty(obj) {
  if (Object.getOwnPropertyNames) {
    return Object.getOwnPropertyNames(obj).length === 0;
  } else {
    var k2;
    for (k2 in obj) {
      if (hasOwnProp(obj, k2)) {
        return false;
      }
    }
    return true;
  }
}
function isUndefined(input) {
  return input === void 0;
}
function isNumber$1(input) {
  return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
}
function isDate(input) {
  return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
}
function map(arr, fn2) {
  var res = [], i, arrLen = arr.length;
  for (i = 0; i < arrLen; ++i) {
    res.push(fn2(arr[i], i));
  }
  return res;
}
function extend(a2, b2) {
  for (var i in b2) {
    if (hasOwnProp(b2, i)) {
      a2[i] = b2[i];
    }
  }
  if (hasOwnProp(b2, "toString")) {
    a2.toString = b2.toString;
  }
  if (hasOwnProp(b2, "valueOf")) {
    a2.valueOf = b2.valueOf;
  }
  return a2;
}
function createUTC(input, format2, locale2, strict) {
  return createLocalOrUTC(input, format2, locale2, strict, true).utc();
}
function defaultParsingFlags() {
  return {
    empty: false,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: false,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: false,
    userInvalidated: false,
    iso: false,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: false,
    weekdayMismatch: false
  };
}
function getParsingFlags(m2) {
  if (m2._pf == null) {
    m2._pf = defaultParsingFlags();
  }
  return m2._pf;
}
var some;
if (Array.prototype.some) {
  some = Array.prototype.some;
} else {
  some = function(fun) {
    var t2 = Object(this), len = t2.length >>> 0, i;
    for (i = 0; i < len; i++) {
      if (i in t2 && fun.call(this, t2[i], i, t2)) {
        return true;
      }
    }
    return false;
  };
}
function isValid(m2) {
  var flags = null, parsedParts = false, isNowValid = m2._d && !isNaN(m2._d.getTime());
  if (isNowValid) {
    flags = getParsingFlags(m2);
    parsedParts = some.call(flags.parsedDateParts, function(i) {
      return i != null;
    });
    isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
    if (m2._strict) {
      isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === void 0;
    }
  }
  if (Object.isFrozen == null || !Object.isFrozen(m2)) {
    m2._isValid = isNowValid;
  } else {
    return isNowValid;
  }
  return m2._isValid;
}
function createInvalid(flags) {
  var m2 = createUTC(NaN);
  if (flags != null) {
    extend(getParsingFlags(m2), flags);
  } else {
    getParsingFlags(m2).userInvalidated = true;
  }
  return m2;
}
var momentProperties = hooks.momentProperties = [], updateInProgress = false;
function copyConfig(to2, from3) {
  var i, prop, val, momentPropertiesLen = momentProperties.length;
  if (!isUndefined(from3._isAMomentObject)) {
    to2._isAMomentObject = from3._isAMomentObject;
  }
  if (!isUndefined(from3._i)) {
    to2._i = from3._i;
  }
  if (!isUndefined(from3._f)) {
    to2._f = from3._f;
  }
  if (!isUndefined(from3._l)) {
    to2._l = from3._l;
  }
  if (!isUndefined(from3._strict)) {
    to2._strict = from3._strict;
  }
  if (!isUndefined(from3._tzm)) {
    to2._tzm = from3._tzm;
  }
  if (!isUndefined(from3._isUTC)) {
    to2._isUTC = from3._isUTC;
  }
  if (!isUndefined(from3._offset)) {
    to2._offset = from3._offset;
  }
  if (!isUndefined(from3._pf)) {
    to2._pf = getParsingFlags(from3);
  }
  if (!isUndefined(from3._locale)) {
    to2._locale = from3._locale;
  }
  if (momentPropertiesLen > 0) {
    for (i = 0; i < momentPropertiesLen; i++) {
      prop = momentProperties[i];
      val = from3[prop];
      if (!isUndefined(val)) {
        to2[prop] = val;
      }
    }
  }
  return to2;
}
function Moment(config2) {
  copyConfig(this, config2);
  this._d = new Date(config2._d != null ? config2._d.getTime() : NaN);
  if (!this.isValid()) {
    this._d = /* @__PURE__ */ new Date(NaN);
  }
  if (updateInProgress === false) {
    updateInProgress = true;
    hooks.updateOffset(this);
    updateInProgress = false;
  }
}
function isMoment(obj) {
  return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
}
function warn$1(msg) {
  if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) {
    console.warn("Deprecation warning: " + msg);
  }
}
function deprecate(msg, fn2) {
  var firstTime = true;
  return extend(function() {
    if (hooks.deprecationHandler != null) {
      hooks.deprecationHandler(null, msg);
    }
    if (firstTime) {
      var args = [], arg, i, key2, argLen = arguments.length;
      for (i = 0; i < argLen; i++) {
        arg = "";
        if (typeof arguments[i] === "object") {
          arg += "\n[" + i + "] ";
          for (key2 in arguments[0]) {
            if (hasOwnProp(arguments[0], key2)) {
              arg += key2 + ": " + arguments[0][key2] + ", ";
            }
          }
          arg = arg.slice(0, -2);
        } else {
          arg = arguments[i];
        }
        args.push(arg);
      }
      warn$1(
        msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack
      );
      firstTime = false;
    }
    return fn2.apply(this, arguments);
  }, fn2);
}
var deprecations = {};
function deprecateSimple(name2, msg) {
  if (hooks.deprecationHandler != null) {
    hooks.deprecationHandler(name2, msg);
  }
  if (!deprecations[name2]) {
    warn$1(msg);
    deprecations[name2] = true;
  }
}
hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;
function isFunction$1(input) {
  return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
}
function set(config2) {
  var prop, i;
  for (i in config2) {
    if (hasOwnProp(config2, i)) {
      prop = config2[i];
      if (isFunction$1(prop)) {
        this[i] = prop;
      } else {
        this["_" + i] = prop;
      }
    }
  }
  this._config = config2;
  this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function mergeConfigs(parentConfig, childConfig) {
  var res = extend({}, parentConfig), prop;
  for (prop in childConfig) {
    if (hasOwnProp(childConfig, prop)) {
      if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
        res[prop] = {};
        extend(res[prop], parentConfig[prop]);
        extend(res[prop], childConfig[prop]);
      } else if (childConfig[prop] != null) {
        res[prop] = childConfig[prop];
      } else {
        delete res[prop];
      }
    }
  }
  for (prop in parentConfig) {
    if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
      res[prop] = extend({}, res[prop]);
    }
  }
  return res;
}
function Locale(config2) {
  if (config2 != null) {
    this.set(config2);
  }
}
var keys$1;
if (Object.keys) {
  keys$1 = Object.keys;
} else {
  keys$1 = function(obj) {
    var i, res = [];
    for (i in obj) {
      if (hasOwnProp(obj, i)) {
        res.push(i);
      }
    }
    return res;
  };
}
var defaultCalendar = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function calendar(key2, mom, now2) {
  var output = this._calendar[key2] || this._calendar["sameElse"];
  return isFunction$1(output) ? output.call(mom, now2) : output;
}
function zeroFill(number2, targetLength, forceSign) {
  var absNumber = "" + Math.abs(number2), zerosToFill = targetLength - absNumber.length, sign2 = number2 >= 0;
  return (sign2 ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}
var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
function addFormatToken(token2, padded, ordinal2, callback) {
  var func = callback;
  if (typeof callback === "string") {
    func = function() {
      return this[callback]();
    };
  }
  if (token2) {
    formatTokenFunctions[token2] = func;
  }
  if (padded) {
    formatTokenFunctions[padded[0]] = function() {
      return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
    };
  }
  if (ordinal2) {
    formatTokenFunctions[ordinal2] = function() {
      return this.localeData().ordinal(
        func.apply(this, arguments),
        token2
      );
    };
  }
}
function removeFormattingTokens(input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|\]$/g, "");
  }
  return input.replace(/\\/g, "");
}
function makeFormatFunction(format2) {
  var array = format2.match(formattingTokens), i, length2;
  for (i = 0, length2 = array.length; i < length2; i++) {
    if (formatTokenFunctions[array[i]]) {
      array[i] = formatTokenFunctions[array[i]];
    } else {
      array[i] = removeFormattingTokens(array[i]);
    }
  }
  return function(mom) {
    var output = "", i2;
    for (i2 = 0; i2 < length2; i2++) {
      output += isFunction$1(array[i2]) ? array[i2].call(mom, format2) : array[i2];
    }
    return output;
  };
}
function formatMoment(m2, format2) {
  if (!m2.isValid()) {
    return m2.localeData().invalidDate();
  }
  format2 = expandFormat(format2, m2.localeData());
  formatFunctions[format2] = formatFunctions[format2] || makeFormatFunction(format2);
  return formatFunctions[format2](m2);
}
function expandFormat(format2, locale2) {
  var i = 5;
  function replaceLongDateFormatTokens(input) {
    return locale2.longDateFormat(input) || input;
  }
  localFormattingTokens.lastIndex = 0;
  while (i >= 0 && localFormattingTokens.test(format2)) {
    format2 = format2.replace(
      localFormattingTokens,
      replaceLongDateFormatTokens
    );
    localFormattingTokens.lastIndex = 0;
    i -= 1;
  }
  return format2;
}
var defaultLongDateFormat = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function longDateFormat(key2) {
  var format2 = this._longDateFormat[key2], formatUpper = this._longDateFormat[key2.toUpperCase()];
  if (format2 || !formatUpper) {
    return format2;
  }
  this._longDateFormat[key2] = formatUpper.match(formattingTokens).map(function(tok) {
    if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") {
      return tok.slice(1);
    }
    return tok;
  }).join("");
  return this._longDateFormat[key2];
}
var defaultInvalidDate = "Invalid date";
function invalidDate() {
  return this._invalidDate;
}
var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
function ordinal(number2) {
  return this._ordinal.replace("%d", number2);
}
var defaultRelativeTime = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function relativeTime(number2, withoutSuffix, string2, isFuture) {
  var output = this._relativeTime[string2];
  return isFunction$1(output) ? output(number2, withoutSuffix, string2, isFuture) : output.replace(/%d/i, number2);
}
function pastFuture(diff2, output) {
  var format2 = this._relativeTime[diff2 > 0 ? "future" : "past"];
  return isFunction$1(format2) ? format2(output) : format2.replace(/%s/i, output);
}
var aliases = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function normalizeUnits(units) {
  return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : void 0;
}
function normalizeObjectUnits(inputObject) {
  var normalizedInput = {}, normalizedProp, prop;
  for (prop in inputObject) {
    if (hasOwnProp(inputObject, prop)) {
      normalizedProp = normalizeUnits(prop);
      if (normalizedProp) {
        normalizedInput[normalizedProp] = inputObject[prop];
      }
    }
  }
  return normalizedInput;
}
var priorities = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function getPrioritizedUnits(unitsObj) {
  var units = [], u2;
  for (u2 in unitsObj) {
    if (hasOwnProp(unitsObj, u2)) {
      units.push({ unit: u2, priority: priorities[u2] });
    }
  }
  units.sort(function(a2, b2) {
    return a2.priority - b2.priority;
  });
  return units;
}
var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
regexes = {};
function addRegexToken(token2, regex2, strictRegex) {
  regexes[token2] = isFunction$1(regex2) ? regex2 : function(isStrict, localeData2) {
    return isStrict && strictRegex ? strictRegex : regex2;
  };
}
function getParseRegexForToken(token2, config2) {
  if (!hasOwnProp(regexes, token2)) {
    return new RegExp(unescapeFormat(token2));
  }
  return regexes[token2](config2._strict, config2._locale);
}
function unescapeFormat(s2) {
  return regexEscape(
    s2.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }
    )
  );
}
function regexEscape(s2) {
  return s2.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function absFloor(number2) {
  if (number2 < 0) {
    return Math.ceil(number2) || 0;
  } else {
    return Math.floor(number2);
  }
}
function toInt(argumentForCoercion) {
  var coercedNumber = +argumentForCoercion, value = 0;
  if (coercedNumber !== 0 && isFinite(coercedNumber)) {
    value = absFloor(coercedNumber);
  }
  return value;
}
var tokens = {};
function addParseToken(token2, callback) {
  var i, func = callback, tokenLen;
  if (typeof token2 === "string") {
    token2 = [token2];
  }
  if (isNumber$1(callback)) {
    func = function(input, array) {
      array[callback] = toInt(input);
    };
  }
  tokenLen = token2.length;
  for (i = 0; i < tokenLen; i++) {
    tokens[token2[i]] = func;
  }
}
function addWeekParseToken(token2, callback) {
  addParseToken(token2, function(input, array, config2, token3) {
    config2._w = config2._w || {};
    callback(input, config2._w, config2, token3);
  });
}
function addTimeToArrayFromToken(token2, input, config2) {
  if (input != null && hasOwnProp(tokens, token2)) {
    tokens[token2](input, config2._a, config2, token2);
  }
}
function isLeapYear(year) {
  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
addFormatToken("Y", 0, 0, function() {
  var y2 = this.year();
  return y2 <= 9999 ? zeroFill(y2, 4) : "+" + y2;
});
addFormatToken(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
addFormatToken(0, ["YYYY", 4], 0, "year");
addFormatToken(0, ["YYYYY", 5], 0, "year");
addFormatToken(0, ["YYYYYY", 6, true], 0, "year");
addRegexToken("Y", matchSigned);
addRegexToken("YY", match1to2, match2);
addRegexToken("YYYY", match1to4, match4);
addRegexToken("YYYYY", match1to6, match6);
addRegexToken("YYYYYY", match1to6, match6);
addParseToken(["YYYYY", "YYYYYY"], YEAR);
addParseToken("YYYY", function(input, array) {
  array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken("YY", function(input, array) {
  array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken("Y", function(input, array) {
  array[YEAR] = parseInt(input, 10);
});
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
hooks.parseTwoDigitYear = function(input) {
  return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3);
};
var getSetYear = makeGetSet("FullYear", true);
function getIsLeapYear() {
  return isLeapYear(this.year());
}
function makeGetSet(unit, keepTime) {
  return function(value) {
    if (value != null) {
      set$1(this, unit, value);
      hooks.updateOffset(this, keepTime);
      return this;
    } else {
      return get4(this, unit);
    }
  };
}
function get4(mom, unit) {
  if (!mom.isValid()) {
    return NaN;
  }
  var d2 = mom._d, isUTC = mom._isUTC;
  switch (unit) {
    case "Milliseconds":
      return isUTC ? d2.getUTCMilliseconds() : d2.getMilliseconds();
    case "Seconds":
      return isUTC ? d2.getUTCSeconds() : d2.getSeconds();
    case "Minutes":
      return isUTC ? d2.getUTCMinutes() : d2.getMinutes();
    case "Hours":
      return isUTC ? d2.getUTCHours() : d2.getHours();
    case "Date":
      return isUTC ? d2.getUTCDate() : d2.getDate();
    case "Day":
      return isUTC ? d2.getUTCDay() : d2.getDay();
    case "Month":
      return isUTC ? d2.getUTCMonth() : d2.getMonth();
    case "FullYear":
      return isUTC ? d2.getUTCFullYear() : d2.getFullYear();
    default:
      return NaN;
  }
}
function set$1(mom, unit, value) {
  var d2, isUTC, year, month, date;
  if (!mom.isValid() || isNaN(value)) {
    return;
  }
  d2 = mom._d;
  isUTC = mom._isUTC;
  switch (unit) {
    case "Milliseconds":
      return void (isUTC ? d2.setUTCMilliseconds(value) : d2.setMilliseconds(value));
    case "Seconds":
      return void (isUTC ? d2.setUTCSeconds(value) : d2.setSeconds(value));
    case "Minutes":
      return void (isUTC ? d2.setUTCMinutes(value) : d2.setMinutes(value));
    case "Hours":
      return void (isUTC ? d2.setUTCHours(value) : d2.setHours(value));
    case "Date":
      return void (isUTC ? d2.setUTCDate(value) : d2.setDate(value));
    // case 'Day': // Not real
    //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
    // case 'Month': // Not used because we need to pass two variables
    //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
    case "FullYear":
      break;
    // See below ...
    default:
      return;
  }
  year = value;
  month = mom.month();
  date = mom.date();
  date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
  void (isUTC ? d2.setUTCFullYear(year, month, date) : d2.setFullYear(year, month, date));
}
function stringGet(units) {
  units = normalizeUnits(units);
  if (isFunction$1(this[units])) {
    return this[units]();
  }
  return this;
}
function stringSet(units, value) {
  if (typeof units === "object") {
    units = normalizeObjectUnits(units);
    var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
    for (i = 0; i < prioritizedLen; i++) {
      this[prioritized[i].unit](units[prioritized[i].unit]);
    }
  } else {
    units = normalizeUnits(units);
    if (isFunction$1(this[units])) {
      return this[units](value);
    }
  }
  return this;
}
function mod(n2, x2) {
  return (n2 % x2 + x2) % x2;
}
var indexOf;
if (Array.prototype.indexOf) {
  indexOf = Array.prototype.indexOf;
} else {
  indexOf = function(o2) {
    var i;
    for (i = 0; i < this.length; ++i) {
      if (this[i] === o2) {
        return i;
      }
    }
    return -1;
  };
}
function daysInMonth(year, month) {
  if (isNaN(year) || isNaN(month)) {
    return NaN;
  }
  var modMonth = mod(month, 12);
  year += (month - modMonth) / 12;
  return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
}
addFormatToken("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
addFormatToken("MMM", 0, 0, function(format2) {
  return this.localeData().monthsShort(this, format2);
});
addFormatToken("MMMM", 0, 0, function(format2) {
  return this.localeData().months(this, format2);
});
addRegexToken("M", match1to2, match1to2NoLeadingZero);
addRegexToken("MM", match1to2, match2);
addRegexToken("MMM", function(isStrict, locale2) {
  return locale2.monthsShortRegex(isStrict);
});
addRegexToken("MMMM", function(isStrict, locale2) {
  return locale2.monthsRegex(isStrict);
});
addParseToken(["M", "MM"], function(input, array) {
  array[MONTH] = toInt(input) - 1;
});
addParseToken(["MMM", "MMMM"], function(input, array, config2, token2) {
  var month = config2._locale.monthsParse(input, token2, config2._strict);
  if (month != null) {
    array[MONTH] = month;
  } else {
    getParsingFlags(config2).invalidMonth = input;
  }
});
var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
function localeMonths(m2, format2) {
  if (!m2) {
    return isArray(this._months) ? this._months : this._months["standalone"];
  }
  return isArray(this._months) ? this._months[m2.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format2) ? "format" : "standalone"][m2.month()];
}
function localeMonthsShort(m2, format2) {
  if (!m2) {
    return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
  }
  return isArray(this._monthsShort) ? this._monthsShort[m2.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format2) ? "format" : "standalone"][m2.month()];
}
function handleStrictParse(monthName, format2, strict) {
  var i, ii, mom, llc = monthName.toLocaleLowerCase();
  if (!this._monthsParse) {
    this._monthsParse = [];
    this._longMonthsParse = [];
    this._shortMonthsParse = [];
    for (i = 0; i < 12; ++i) {
      mom = createUTC([2e3, i]);
      this._shortMonthsParse[i] = this.monthsShort(
        mom,
        ""
      ).toLocaleLowerCase();
      this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
    }
  }
  if (strict) {
    if (format2 === "MMM") {
      ii = indexOf.call(this._shortMonthsParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._longMonthsParse, llc);
      return ii !== -1 ? ii : null;
    }
  } else {
    if (format2 === "MMM") {
      ii = indexOf.call(this._shortMonthsParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._longMonthsParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._longMonthsParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortMonthsParse, llc);
      return ii !== -1 ? ii : null;
    }
  }
}
function localeMonthsParse(monthName, format2, strict) {
  var i, mom, regex2;
  if (this._monthsParseExact) {
    return handleStrictParse.call(this, monthName, format2, strict);
  }
  if (!this._monthsParse) {
    this._monthsParse = [];
    this._longMonthsParse = [];
    this._shortMonthsParse = [];
  }
  for (i = 0; i < 12; i++) {
    mom = createUTC([2e3, i]);
    if (strict && !this._longMonthsParse[i]) {
      this._longMonthsParse[i] = new RegExp(
        "^" + this.months(mom, "").replace(".", "") + "$",
        "i"
      );
      this._shortMonthsParse[i] = new RegExp(
        "^" + this.monthsShort(mom, "").replace(".", "") + "$",
        "i"
      );
    }
    if (!strict && !this._monthsParse[i]) {
      regex2 = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
      this._monthsParse[i] = new RegExp(regex2.replace(".", ""), "i");
    }
    if (strict && format2 === "MMMM" && this._longMonthsParse[i].test(monthName)) {
      return i;
    } else if (strict && format2 === "MMM" && this._shortMonthsParse[i].test(monthName)) {
      return i;
    } else if (!strict && this._monthsParse[i].test(monthName)) {
      return i;
    }
  }
}
function setMonth(mom, value) {
  if (!mom.isValid()) {
    return mom;
  }
  if (typeof value === "string") {
    if (/^\d+$/.test(value)) {
      value = toInt(value);
    } else {
      value = mom.localeData().monthsParse(value);
      if (!isNumber$1(value)) {
        return mom;
      }
    }
  }
  var month = value, date = mom.date();
  date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
  void (mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date));
  return mom;
}
function getSetMonth(value) {
  if (value != null) {
    setMonth(this, value);
    hooks.updateOffset(this, true);
    return this;
  } else {
    return get4(this, "Month");
  }
}
function getDaysInMonth() {
  return daysInMonth(this.year(), this.month());
}
function monthsShortRegex(isStrict) {
  if (this._monthsParseExact) {
    if (!hasOwnProp(this, "_monthsRegex")) {
      computeMonthsParse.call(this);
    }
    if (isStrict) {
      return this._monthsShortStrictRegex;
    } else {
      return this._monthsShortRegex;
    }
  } else {
    if (!hasOwnProp(this, "_monthsShortRegex")) {
      this._monthsShortRegex = defaultMonthsShortRegex;
    }
    return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
  }
}
function monthsRegex(isStrict) {
  if (this._monthsParseExact) {
    if (!hasOwnProp(this, "_monthsRegex")) {
      computeMonthsParse.call(this);
    }
    if (isStrict) {
      return this._monthsStrictRegex;
    } else {
      return this._monthsRegex;
    }
  } else {
    if (!hasOwnProp(this, "_monthsRegex")) {
      this._monthsRegex = defaultMonthsRegex;
    }
    return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
  }
}
function computeMonthsParse() {
  function cmpLenRev(a2, b2) {
    return b2.length - a2.length;
  }
  var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
  for (i = 0; i < 12; i++) {
    mom = createUTC([2e3, i]);
    shortP = regexEscape(this.monthsShort(mom, ""));
    longP = regexEscape(this.months(mom, ""));
    shortPieces.push(shortP);
    longPieces.push(longP);
    mixedPieces.push(longP);
    mixedPieces.push(shortP);
  }
  shortPieces.sort(cmpLenRev);
  longPieces.sort(cmpLenRev);
  mixedPieces.sort(cmpLenRev);
  this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._monthsShortRegex = this._monthsRegex;
  this._monthsStrictRegex = new RegExp(
    "^(" + longPieces.join("|") + ")",
    "i"
  );
  this._monthsShortStrictRegex = new RegExp(
    "^(" + shortPieces.join("|") + ")",
    "i"
  );
}
function createDate(y2, m2, d2, h2, M2, s2, ms) {
  var date;
  if (y2 < 100 && y2 >= 0) {
    date = new Date(y2 + 400, m2, d2, h2, M2, s2, ms);
    if (isFinite(date.getFullYear())) {
      date.setFullYear(y2);
    }
  } else {
    date = new Date(y2, m2, d2, h2, M2, s2, ms);
  }
  return date;
}
function createUTCDate(y2) {
  var date, args;
  if (y2 < 100 && y2 >= 0) {
    args = Array.prototype.slice.call(arguments);
    args[0] = y2 + 400;
    date = new Date(Date.UTC.apply(null, args));
    if (isFinite(date.getUTCFullYear())) {
      date.setUTCFullYear(y2);
    }
  } else {
    date = new Date(Date.UTC.apply(null, arguments));
  }
  return date;
}
function firstWeekOffset(year, dow, doy) {
  var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
  return -fwdlw + fwd - 1;
}
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
  var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
  if (dayOfYear <= 0) {
    resYear = year - 1;
    resDayOfYear = daysInYear(resYear) + dayOfYear;
  } else if (dayOfYear > daysInYear(year)) {
    resYear = year + 1;
    resDayOfYear = dayOfYear - daysInYear(year);
  } else {
    resYear = year;
    resDayOfYear = dayOfYear;
  }
  return {
    year: resYear,
    dayOfYear: resDayOfYear
  };
}
function weekOfYear(mom, dow, doy) {
  var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
  if (week < 1) {
    resYear = mom.year() - 1;
    resWeek = week + weeksInYear(resYear, dow, doy);
  } else if (week > weeksInYear(mom.year(), dow, doy)) {
    resWeek = week - weeksInYear(mom.year(), dow, doy);
    resYear = mom.year() + 1;
  } else {
    resYear = mom.year();
    resWeek = week;
  }
  return {
    week: resWeek,
    year: resYear
  };
}
function weeksInYear(year, dow, doy) {
  var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
  return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}
addFormatToken("w", ["ww", 2], "wo", "week");
addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
addRegexToken("w", match1to2, match1to2NoLeadingZero);
addRegexToken("ww", match1to2, match2);
addRegexToken("W", match1to2, match1to2NoLeadingZero);
addRegexToken("WW", match1to2, match2);
addWeekParseToken(
  ["w", "ww", "W", "WW"],
  function(input, week, config2, token2) {
    week[token2.substr(0, 1)] = toInt(input);
  }
);
function localeWeek(mom) {
  return weekOfYear(mom, this._week.dow, this._week.doy).week;
}
var defaultLocaleWeek = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function localeFirstDayOfWeek() {
  return this._week.dow;
}
function localeFirstDayOfYear() {
  return this._week.doy;
}
function getSetWeek(input) {
  var week = this.localeData().week(this);
  return input == null ? week : this.add((input - week) * 7, "d");
}
function getSetISOWeek(input) {
  var week = weekOfYear(this, 1, 4).week;
  return input == null ? week : this.add((input - week) * 7, "d");
}
addFormatToken("d", 0, "do", "day");
addFormatToken("dd", 0, 0, function(format2) {
  return this.localeData().weekdaysMin(this, format2);
});
addFormatToken("ddd", 0, 0, function(format2) {
  return this.localeData().weekdaysShort(this, format2);
});
addFormatToken("dddd", 0, 0, function(format2) {
  return this.localeData().weekdays(this, format2);
});
addFormatToken("e", 0, 0, "weekday");
addFormatToken("E", 0, 0, "isoWeekday");
addRegexToken("d", match1to2);
addRegexToken("e", match1to2);
addRegexToken("E", match1to2);
addRegexToken("dd", function(isStrict, locale2) {
  return locale2.weekdaysMinRegex(isStrict);
});
addRegexToken("ddd", function(isStrict, locale2) {
  return locale2.weekdaysShortRegex(isStrict);
});
addRegexToken("dddd", function(isStrict, locale2) {
  return locale2.weekdaysRegex(isStrict);
});
addWeekParseToken(["dd", "ddd", "dddd"], function(input, week, config2, token2) {
  var weekday = config2._locale.weekdaysParse(input, token2, config2._strict);
  if (weekday != null) {
    week.d = weekday;
  } else {
    getParsingFlags(config2).invalidWeekday = input;
  }
});
addWeekParseToken(["d", "e", "E"], function(input, week, config2, token2) {
  week[token2] = toInt(input);
});
function parseWeekday(input, locale2) {
  if (typeof input !== "string") {
    return input;
  }
  if (!isNaN(input)) {
    return parseInt(input, 10);
  }
  input = locale2.weekdaysParse(input);
  if (typeof input === "number") {
    return input;
  }
  return null;
}
function parseIsoWeekday(input, locale2) {
  if (typeof input === "string") {
    return locale2.weekdaysParse(input) % 7 || 7;
  }
  return isNaN(input) ? null : input;
}
function shiftWeekdays(ws, n2) {
  return ws.slice(n2, 7).concat(ws.slice(0, n2));
}
var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
function localeWeekdays(m2, format2) {
  var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m2 && m2 !== true && this._weekdays.isFormat.test(format2) ? "format" : "standalone"];
  return m2 === true ? shiftWeekdays(weekdays, this._week.dow) : m2 ? weekdays[m2.day()] : weekdays;
}
function localeWeekdaysShort(m2) {
  return m2 === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m2 ? this._weekdaysShort[m2.day()] : this._weekdaysShort;
}
function localeWeekdaysMin(m2) {
  return m2 === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m2 ? this._weekdaysMin[m2.day()] : this._weekdaysMin;
}
function handleStrictParse$1(weekdayName, format2, strict) {
  var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
  if (!this._weekdaysParse) {
    this._weekdaysParse = [];
    this._shortWeekdaysParse = [];
    this._minWeekdaysParse = [];
    for (i = 0; i < 7; ++i) {
      mom = createUTC([2e3, 1]).day(i);
      this._minWeekdaysParse[i] = this.weekdaysMin(
        mom,
        ""
      ).toLocaleLowerCase();
      this._shortWeekdaysParse[i] = this.weekdaysShort(
        mom,
        ""
      ).toLocaleLowerCase();
      this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
    }
  }
  if (strict) {
    if (format2 === "dddd") {
      ii = indexOf.call(this._weekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else if (format2 === "ddd") {
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    }
  } else {
    if (format2 === "dddd") {
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else if (format2 === "ddd") {
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._minWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    }
  }
}
function localeWeekdaysParse(weekdayName, format2, strict) {
  var i, mom, regex2;
  if (this._weekdaysParseExact) {
    return handleStrictParse$1.call(this, weekdayName, format2, strict);
  }
  if (!this._weekdaysParse) {
    this._weekdaysParse = [];
    this._minWeekdaysParse = [];
    this._shortWeekdaysParse = [];
    this._fullWeekdaysParse = [];
  }
  for (i = 0; i < 7; i++) {
    mom = createUTC([2e3, 1]).day(i);
    if (strict && !this._fullWeekdaysParse[i]) {
      this._fullWeekdaysParse[i] = new RegExp(
        "^" + this.weekdays(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
      this._shortWeekdaysParse[i] = new RegExp(
        "^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
      this._minWeekdaysParse[i] = new RegExp(
        "^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
    }
    if (!this._weekdaysParse[i]) {
      regex2 = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
      this._weekdaysParse[i] = new RegExp(regex2.replace(".", ""), "i");
    }
    if (strict && format2 === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (strict && format2 === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (strict && format2 === "dd" && this._minWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
      return i;
    }
  }
}
function getSetDayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  var day = get4(this, "Day");
  if (input != null) {
    input = parseWeekday(input, this.localeData());
    return this.add(input - day, "d");
  } else {
    return day;
  }
}
function getSetLocaleDayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return input == null ? weekday : this.add(input - weekday, "d");
}
function getSetISODayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  if (input != null) {
    var weekday = parseIsoWeekday(input, this.localeData());
    return this.day(this.day() % 7 ? weekday : weekday - 7);
  } else {
    return this.day() || 7;
  }
}
function weekdaysRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysStrictRegex;
    } else {
      return this._weekdaysRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      this._weekdaysRegex = defaultWeekdaysRegex;
    }
    return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
  }
}
function weekdaysShortRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysShortStrictRegex;
    } else {
      return this._weekdaysShortRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysShortRegex")) {
      this._weekdaysShortRegex = defaultWeekdaysShortRegex;
    }
    return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
  }
}
function weekdaysMinRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysMinStrictRegex;
    } else {
      return this._weekdaysMinRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysMinRegex")) {
      this._weekdaysMinRegex = defaultWeekdaysMinRegex;
    }
    return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
  }
}
function computeWeekdaysParse() {
  function cmpLenRev(a2, b2) {
    return b2.length - a2.length;
  }
  var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
  for (i = 0; i < 7; i++) {
    mom = createUTC([2e3, 1]).day(i);
    minp = regexEscape(this.weekdaysMin(mom, ""));
    shortp = regexEscape(this.weekdaysShort(mom, ""));
    longp = regexEscape(this.weekdays(mom, ""));
    minPieces.push(minp);
    shortPieces.push(shortp);
    longPieces.push(longp);
    mixedPieces.push(minp);
    mixedPieces.push(shortp);
    mixedPieces.push(longp);
  }
  minPieces.sort(cmpLenRev);
  shortPieces.sort(cmpLenRev);
  longPieces.sort(cmpLenRev);
  mixedPieces.sort(cmpLenRev);
  this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._weekdaysShortRegex = this._weekdaysRegex;
  this._weekdaysMinRegex = this._weekdaysRegex;
  this._weekdaysStrictRegex = new RegExp(
    "^(" + longPieces.join("|") + ")",
    "i"
  );
  this._weekdaysShortStrictRegex = new RegExp(
    "^(" + shortPieces.join("|") + ")",
    "i"
  );
  this._weekdaysMinStrictRegex = new RegExp(
    "^(" + minPieces.join("|") + ")",
    "i"
  );
}
function hFormat() {
  return this.hours() % 12 || 12;
}
function kFormat() {
  return this.hours() || 24;
}
addFormatToken("H", ["HH", 2], 0, "hour");
addFormatToken("h", ["hh", 2], 0, hFormat);
addFormatToken("k", ["kk", 2], 0, kFormat);
addFormatToken("hmm", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});
addFormatToken("hmmss", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
addFormatToken("Hmm", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2);
});
addFormatToken("Hmmss", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
function meridiem(token2, lowercase) {
  addFormatToken(token2, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      lowercase
    );
  });
}
meridiem("a", true);
meridiem("A", false);
function matchMeridiem(isStrict, locale2) {
  return locale2._meridiemParse;
}
addRegexToken("a", matchMeridiem);
addRegexToken("A", matchMeridiem);
addRegexToken("H", match1to2, match1to2HasZero);
addRegexToken("h", match1to2, match1to2NoLeadingZero);
addRegexToken("k", match1to2, match1to2NoLeadingZero);
addRegexToken("HH", match1to2, match2);
addRegexToken("hh", match1to2, match2);
addRegexToken("kk", match1to2, match2);
addRegexToken("hmm", match3to4);
addRegexToken("hmmss", match5to6);
addRegexToken("Hmm", match3to4);
addRegexToken("Hmmss", match5to6);
addParseToken(["H", "HH"], HOUR);
addParseToken(["k", "kk"], function(input, array, config2) {
  var kInput = toInt(input);
  array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(["a", "A"], function(input, array, config2) {
  config2._isPm = config2._locale.isPM(input);
  config2._meridiem = input;
});
addParseToken(["h", "hh"], function(input, array, config2) {
  array[HOUR] = toInt(input);
  getParsingFlags(config2).bigHour = true;
});
addParseToken("hmm", function(input, array, config2) {
  var pos = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos));
  array[MINUTE] = toInt(input.substr(pos));
  getParsingFlags(config2).bigHour = true;
});
addParseToken("hmmss", function(input, array, config2) {
  var pos1 = input.length - 4, pos2 = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos1));
  array[MINUTE] = toInt(input.substr(pos1, 2));
  array[SECOND] = toInt(input.substr(pos2));
  getParsingFlags(config2).bigHour = true;
});
addParseToken("Hmm", function(input, array, config2) {
  var pos = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos));
  array[MINUTE] = toInt(input.substr(pos));
});
addParseToken("Hmmss", function(input, array, config2) {
  var pos1 = input.length - 4, pos2 = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos1));
  array[MINUTE] = toInt(input.substr(pos1, 2));
  array[SECOND] = toInt(input.substr(pos2));
});
function localeIsPM(input) {
  return (input + "").toLowerCase().charAt(0) === "p";
}
var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", true);
function localeMeridiem(hours2, minutes2, isLower) {
  if (hours2 > 11) {
    return isLower ? "pm" : "PM";
  } else {
    return isLower ? "am" : "AM";
  }
}
var baseConfig = {
  calendar: defaultCalendar,
  longDateFormat: defaultLongDateFormat,
  invalidDate: defaultInvalidDate,
  ordinal: defaultOrdinal,
  dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
  relativeTime: defaultRelativeTime,
  months: defaultLocaleMonths,
  monthsShort: defaultLocaleMonthsShort,
  week: defaultLocaleWeek,
  weekdays: defaultLocaleWeekdays,
  weekdaysMin: defaultLocaleWeekdaysMin,
  weekdaysShort: defaultLocaleWeekdaysShort,
  meridiemParse: defaultLocaleMeridiemParse
};
var locales = {}, localeFamilies = {}, globalLocale;
function commonPrefix(arr1, arr2) {
  var i, minl = Math.min(arr1.length, arr2.length);
  for (i = 0; i < minl; i += 1) {
    if (arr1[i] !== arr2[i]) {
      return i;
    }
  }
  return minl;
}
function normalizeLocale(key2) {
  return key2 ? key2.toLowerCase().replace("_", "-") : key2;
}
function chooseLocale(names) {
  var i = 0, j2, next2, locale2, split2;
  while (i < names.length) {
    split2 = normalizeLocale(names[i]).split("-");
    j2 = split2.length;
    next2 = normalizeLocale(names[i + 1]);
    next2 = next2 ? next2.split("-") : null;
    while (j2 > 0) {
      locale2 = loadLocale(split2.slice(0, j2).join("-"));
      if (locale2) {
        return locale2;
      }
      if (next2 && next2.length >= j2 && commonPrefix(split2, next2) >= j2 - 1) {
        break;
      }
      j2--;
    }
    i++;
  }
  return globalLocale;
}
function isLocaleNameSane(name2) {
  return !!(name2 && name2.match("^[^/\\\\]*$"));
}
function loadLocale(name2) {
  var oldLocale = null, aliasedRequire;
  if (locales[name2] === void 0 && typeof module !== "undefined" && module && module.exports && isLocaleNameSane(name2)) {
    try {
      oldLocale = globalLocale._abbr;
      aliasedRequire = require;
      aliasedRequire("./locale/" + name2);
      getSetGlobalLocale(oldLocale);
    } catch (e) {
      locales[name2] = null;
    }
  }
  return locales[name2];
}
function getSetGlobalLocale(key2, values2) {
  var data;
  if (key2) {
    if (isUndefined(values2)) {
      data = getLocale(key2);
    } else {
      data = defineLocale(key2, values2);
    }
    if (data) {
      globalLocale = data;
    } else {
      if (typeof console !== "undefined" && console.warn) {
        console.warn(
          "Locale " + key2 + " not found. Did you forget to load it?"
        );
      }
    }
  }
  return globalLocale._abbr;
}
function defineLocale(name2, config2) {
  if (config2 !== null) {
    var locale2, parentConfig = baseConfig;
    config2.abbr = name2;
    if (locales[name2] != null) {
      deprecateSimple(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      );
      parentConfig = locales[name2]._config;
    } else if (config2.parentLocale != null) {
      if (locales[config2.parentLocale] != null) {
        parentConfig = locales[config2.parentLocale]._config;
      } else {
        locale2 = loadLocale(config2.parentLocale);
        if (locale2 != null) {
          parentConfig = locale2._config;
        } else {
          if (!localeFamilies[config2.parentLocale]) {
            localeFamilies[config2.parentLocale] = [];
          }
          localeFamilies[config2.parentLocale].push({
            name: name2,
            config: config2
          });
          return null;
        }
      }
    }
    locales[name2] = new Locale(mergeConfigs(parentConfig, config2));
    if (localeFamilies[name2]) {
      localeFamilies[name2].forEach(function(x2) {
        defineLocale(x2.name, x2.config);
      });
    }
    getSetGlobalLocale(name2);
    return locales[name2];
  } else {
    delete locales[name2];
    return null;
  }
}
function updateLocale(name2, config2) {
  if (config2 != null) {
    var locale2, tmpLocale, parentConfig = baseConfig;
    if (locales[name2] != null && locales[name2].parentLocale != null) {
      locales[name2].set(mergeConfigs(locales[name2]._config, config2));
    } else {
      tmpLocale = loadLocale(name2);
      if (tmpLocale != null) {
        parentConfig = tmpLocale._config;
      }
      config2 = mergeConfigs(parentConfig, config2);
      if (tmpLocale == null) {
        config2.abbr = name2;
      }
      locale2 = new Locale(config2);
      locale2.parentLocale = locales[name2];
      locales[name2] = locale2;
    }
    getSetGlobalLocale(name2);
  } else {
    if (locales[name2] != null) {
      if (locales[name2].parentLocale != null) {
        locales[name2] = locales[name2].parentLocale;
        if (name2 === getSetGlobalLocale()) {
          getSetGlobalLocale(name2);
        }
      } else if (locales[name2] != null) {
        delete locales[name2];
      }
    }
  }
  return locales[name2];
}
function getLocale(key2) {
  var locale2;
  if (key2 && key2._locale && key2._locale._abbr) {
    key2 = key2._locale._abbr;
  }
  if (!key2) {
    return globalLocale;
  }
  if (!isArray(key2)) {
    locale2 = loadLocale(key2);
    if (locale2) {
      return locale2;
    }
    key2 = [key2];
  }
  return chooseLocale(key2);
}
function listLocales() {
  return keys$1(locales);
}
function checkOverflow(m2) {
  var overflow2, a2 = m2._a;
  if (a2 && getParsingFlags(m2).overflow === -2) {
    overflow2 = a2[MONTH] < 0 || a2[MONTH] > 11 ? MONTH : a2[DATE] < 1 || a2[DATE] > daysInMonth(a2[YEAR], a2[MONTH]) ? DATE : a2[HOUR] < 0 || a2[HOUR] > 24 || a2[HOUR] === 24 && (a2[MINUTE] !== 0 || a2[SECOND] !== 0 || a2[MILLISECOND] !== 0) ? HOUR : a2[MINUTE] < 0 || a2[MINUTE] > 59 ? MINUTE : a2[SECOND] < 0 || a2[SECOND] > 59 ? SECOND : a2[MILLISECOND] < 0 || a2[MILLISECOND] > 999 ? MILLISECOND : -1;
    if (getParsingFlags(m2)._overflowDayOfYear && (overflow2 < YEAR || overflow2 > DATE)) {
      overflow2 = DATE;
    }
    if (getParsingFlags(m2)._overflowWeeks && overflow2 === -1) {
      overflow2 = WEEK;
    }
    if (getParsingFlags(m2)._overflowWeekday && overflow2 === -1) {
      overflow2 = WEEKDAY;
    }
    getParsingFlags(m2).overflow = overflow2;
  }
  return m2;
}
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, false],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, false],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, false],
  ["YYYY", /\d{4}/, false]
], isoTimes = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function configFromISO(config2) {
  var i, l2, string2 = config2._i, match5 = extendedIsoRegex.exec(string2) || basicIsoRegex.exec(string2), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
  if (match5) {
    getParsingFlags(config2).iso = true;
    for (i = 0, l2 = isoDatesLen; i < l2; i++) {
      if (isoDates[i][1].exec(match5[1])) {
        dateFormat = isoDates[i][0];
        allowTime = isoDates[i][2] !== false;
        break;
      }
    }
    if (dateFormat == null) {
      config2._isValid = false;
      return;
    }
    if (match5[3]) {
      for (i = 0, l2 = isoTimesLen; i < l2; i++) {
        if (isoTimes[i][1].exec(match5[3])) {
          timeFormat = (match5[2] || " ") + isoTimes[i][0];
          break;
        }
      }
      if (timeFormat == null) {
        config2._isValid = false;
        return;
      }
    }
    if (!allowTime && timeFormat != null) {
      config2._isValid = false;
      return;
    }
    if (match5[4]) {
      if (tzRegex.exec(match5[4])) {
        tzFormat = "Z";
      } else {
        config2._isValid = false;
        return;
      }
    }
    config2._f = dateFormat + (timeFormat || "") + (tzFormat || "");
    configFromStringAndFormat(config2);
  } else {
    config2._isValid = false;
  }
}
function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  var result = [
    untruncateYear(yearStr),
    defaultLocaleMonthsShort.indexOf(monthStr),
    parseInt(dayStr, 10),
    parseInt(hourStr, 10),
    parseInt(minuteStr, 10)
  ];
  if (secondStr) {
    result.push(parseInt(secondStr, 10));
  }
  return result;
}
function untruncateYear(yearStr) {
  var year = parseInt(yearStr, 10);
  if (year <= 49) {
    return 2e3 + year;
  } else if (year <= 999) {
    return 1900 + year;
  }
  return year;
}
function preprocessRFC2822(s2) {
  return s2.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function checkWeekday(weekdayStr, parsedInput, config2) {
  if (weekdayStr) {
    var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(
      parsedInput[0],
      parsedInput[1],
      parsedInput[2]
    ).getDay();
    if (weekdayProvided !== weekdayActual) {
      getParsingFlags(config2).weekdayMismatch = true;
      config2._isValid = false;
      return false;
    }
  }
  return true;
}
function calculateOffset(obsOffset, militaryOffset, numOffset) {
  if (obsOffset) {
    return obsOffsets[obsOffset];
  } else if (militaryOffset) {
    return 0;
  } else {
    var hm = parseInt(numOffset, 10), m2 = hm % 100, h2 = (hm - m2) / 100;
    return h2 * 60 + m2;
  }
}
function configFromRFC2822(config2) {
  var match5 = rfc2822.exec(preprocessRFC2822(config2._i)), parsedArray;
  if (match5) {
    parsedArray = extractFromRFC2822Strings(
      match5[4],
      match5[3],
      match5[2],
      match5[5],
      match5[6],
      match5[7]
    );
    if (!checkWeekday(match5[1], parsedArray, config2)) {
      return;
    }
    config2._a = parsedArray;
    config2._tzm = calculateOffset(match5[8], match5[9], match5[10]);
    config2._d = createUTCDate.apply(null, config2._a);
    config2._d.setUTCMinutes(config2._d.getUTCMinutes() - config2._tzm);
    getParsingFlags(config2).rfc2822 = true;
  } else {
    config2._isValid = false;
  }
}
function configFromString(config2) {
  var matched = aspNetJsonRegex.exec(config2._i);
  if (matched !== null) {
    config2._d = /* @__PURE__ */ new Date(+matched[1]);
    return;
  }
  configFromISO(config2);
  if (config2._isValid === false) {
    delete config2._isValid;
  } else {
    return;
  }
  configFromRFC2822(config2);
  if (config2._isValid === false) {
    delete config2._isValid;
  } else {
    return;
  }
  if (config2._strict) {
    config2._isValid = false;
  } else {
    hooks.createFromInputFallback(config2);
  }
}
hooks.createFromInputFallback = deprecate(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(config2) {
    config2._d = /* @__PURE__ */ new Date(config2._i + (config2._useUTC ? " UTC" : ""));
  }
);
function defaults$1(a2, b2, c2) {
  if (a2 != null) {
    return a2;
  }
  if (b2 != null) {
    return b2;
  }
  return c2;
}
function currentDateArray(config2) {
  var nowValue = new Date(hooks.now());
  if (config2._useUTC) {
    return [
      nowValue.getUTCFullYear(),
      nowValue.getUTCMonth(),
      nowValue.getUTCDate()
    ];
  }
  return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}
function configFromArray(config2) {
  var i, date, input = [], currentDate, expectedWeekday, yearToUse;
  if (config2._d) {
    return;
  }
  currentDate = currentDateArray(config2);
  if (config2._w && config2._a[DATE] == null && config2._a[MONTH] == null) {
    dayOfYearFromWeekInfo(config2);
  }
  if (config2._dayOfYear != null) {
    yearToUse = defaults$1(config2._a[YEAR], currentDate[YEAR]);
    if (config2._dayOfYear > daysInYear(yearToUse) || config2._dayOfYear === 0) {
      getParsingFlags(config2)._overflowDayOfYear = true;
    }
    date = createUTCDate(yearToUse, 0, config2._dayOfYear);
    config2._a[MONTH] = date.getUTCMonth();
    config2._a[DATE] = date.getUTCDate();
  }
  for (i = 0; i < 3 && config2._a[i] == null; ++i) {
    config2._a[i] = input[i] = currentDate[i];
  }
  for (; i < 7; i++) {
    config2._a[i] = input[i] = config2._a[i] == null ? i === 2 ? 1 : 0 : config2._a[i];
  }
  if (config2._a[HOUR] === 24 && config2._a[MINUTE] === 0 && config2._a[SECOND] === 0 && config2._a[MILLISECOND] === 0) {
    config2._nextDay = true;
    config2._a[HOUR] = 0;
  }
  config2._d = (config2._useUTC ? createUTCDate : createDate).apply(
    null,
    input
  );
  expectedWeekday = config2._useUTC ? config2._d.getUTCDay() : config2._d.getDay();
  if (config2._tzm != null) {
    config2._d.setUTCMinutes(config2._d.getUTCMinutes() - config2._tzm);
  }
  if (config2._nextDay) {
    config2._a[HOUR] = 24;
  }
  if (config2._w && typeof config2._w.d !== "undefined" && config2._w.d !== expectedWeekday) {
    getParsingFlags(config2).weekdayMismatch = true;
  }
}
function dayOfYearFromWeekInfo(config2) {
  var w2, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
  w2 = config2._w;
  if (w2.GG != null || w2.W != null || w2.E != null) {
    dow = 1;
    doy = 4;
    weekYear = defaults$1(
      w2.GG,
      config2._a[YEAR],
      weekOfYear(createLocal(), 1, 4).year
    );
    week = defaults$1(w2.W, 1);
    weekday = defaults$1(w2.E, 1);
    if (weekday < 1 || weekday > 7) {
      weekdayOverflow = true;
    }
  } else {
    dow = config2._locale._week.dow;
    doy = config2._locale._week.doy;
    curWeek = weekOfYear(createLocal(), dow, doy);
    weekYear = defaults$1(w2.gg, config2._a[YEAR], curWeek.year);
    week = defaults$1(w2.w, curWeek.week);
    if (w2.d != null) {
      weekday = w2.d;
      if (weekday < 0 || weekday > 6) {
        weekdayOverflow = true;
      }
    } else if (w2.e != null) {
      weekday = w2.e + dow;
      if (w2.e < 0 || w2.e > 6) {
        weekdayOverflow = true;
      }
    } else {
      weekday = dow;
    }
  }
  if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
    getParsingFlags(config2)._overflowWeeks = true;
  } else if (weekdayOverflow != null) {
    getParsingFlags(config2)._overflowWeekday = true;
  } else {
    temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
    config2._a[YEAR] = temp.year;
    config2._dayOfYear = temp.dayOfYear;
  }
}
hooks.ISO_8601 = function() {
};
hooks.RFC_2822 = function() {
};
function configFromStringAndFormat(config2) {
  if (config2._f === hooks.ISO_8601) {
    configFromISO(config2);
    return;
  }
  if (config2._f === hooks.RFC_2822) {
    configFromRFC2822(config2);
    return;
  }
  config2._a = [];
  getParsingFlags(config2).empty = true;
  var string2 = "" + config2._i, i, parsedInput, tokens2, token2, skipped, stringLength = string2.length, totalParsedInputLength = 0, era, tokenLen;
  tokens2 = expandFormat(config2._f, config2._locale).match(formattingTokens) || [];
  tokenLen = tokens2.length;
  for (i = 0; i < tokenLen; i++) {
    token2 = tokens2[i];
    parsedInput = (string2.match(getParseRegexForToken(token2, config2)) || [])[0];
    if (parsedInput) {
      skipped = string2.substr(0, string2.indexOf(parsedInput));
      if (skipped.length > 0) {
        getParsingFlags(config2).unusedInput.push(skipped);
      }
      string2 = string2.slice(
        string2.indexOf(parsedInput) + parsedInput.length
      );
      totalParsedInputLength += parsedInput.length;
    }
    if (formatTokenFunctions[token2]) {
      if (parsedInput) {
        getParsingFlags(config2).empty = false;
      } else {
        getParsingFlags(config2).unusedTokens.push(token2);
      }
      addTimeToArrayFromToken(token2, parsedInput, config2);
    } else if (config2._strict && !parsedInput) {
      getParsingFlags(config2).unusedTokens.push(token2);
    }
  }
  getParsingFlags(config2).charsLeftOver = stringLength - totalParsedInputLength;
  if (string2.length > 0) {
    getParsingFlags(config2).unusedInput.push(string2);
  }
  if (config2._a[HOUR] <= 12 && getParsingFlags(config2).bigHour === true && config2._a[HOUR] > 0) {
    getParsingFlags(config2).bigHour = void 0;
  }
  getParsingFlags(config2).parsedDateParts = config2._a.slice(0);
  getParsingFlags(config2).meridiem = config2._meridiem;
  config2._a[HOUR] = meridiemFixWrap(
    config2._locale,
    config2._a[HOUR],
    config2._meridiem
  );
  era = getParsingFlags(config2).era;
  if (era !== null) {
    config2._a[YEAR] = config2._locale.erasConvertYear(era, config2._a[YEAR]);
  }
  configFromArray(config2);
  checkOverflow(config2);
}
function meridiemFixWrap(locale2, hour, meridiem2) {
  var isPm;
  if (meridiem2 == null) {
    return hour;
  }
  if (locale2.meridiemHour != null) {
    return locale2.meridiemHour(hour, meridiem2);
  } else if (locale2.isPM != null) {
    isPm = locale2.isPM(meridiem2);
    if (isPm && hour < 12) {
      hour += 12;
    }
    if (!isPm && hour === 12) {
      hour = 0;
    }
    return hour;
  } else {
    return hour;
  }
}
function configFromStringAndArray(config2) {
  var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config2._f.length;
  if (configfLen === 0) {
    getParsingFlags(config2).invalidFormat = true;
    config2._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (i = 0; i < configfLen; i++) {
    currentScore = 0;
    validFormatFound = false;
    tempConfig = copyConfig({}, config2);
    if (config2._useUTC != null) {
      tempConfig._useUTC = config2._useUTC;
    }
    tempConfig._f = config2._f[i];
    configFromStringAndFormat(tempConfig);
    if (isValid(tempConfig)) {
      validFormatFound = true;
    }
    currentScore += getParsingFlags(tempConfig).charsLeftOver;
    currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
    getParsingFlags(tempConfig).score = currentScore;
    if (!bestFormatIsValid) {
      if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
        if (validFormatFound) {
          bestFormatIsValid = true;
        }
      }
    } else {
      if (currentScore < scoreToBeat) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
      }
    }
  }
  extend(config2, bestMoment || tempConfig);
}
function configFromObject(config2) {
  if (config2._d) {
    return;
  }
  var i = normalizeObjectUnits(config2._i), dayOrDate = i.day === void 0 ? i.date : i.day;
  config2._a = map(
    [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
    function(obj) {
      return obj && parseInt(obj, 10);
    }
  );
  configFromArray(config2);
}
function createFromConfig(config2) {
  var res = new Moment(checkOverflow(prepareConfig(config2)));
  if (res._nextDay) {
    res.add(1, "d");
    res._nextDay = void 0;
  }
  return res;
}
function prepareConfig(config2) {
  var input = config2._i, format2 = config2._f;
  config2._locale = config2._locale || getLocale(config2._l);
  if (input === null || format2 === void 0 && input === "") {
    return createInvalid({ nullInput: true });
  }
  if (typeof input === "string") {
    config2._i = input = config2._locale.preparse(input);
  }
  if (isMoment(input)) {
    return new Moment(checkOverflow(input));
  } else if (isDate(input)) {
    config2._d = input;
  } else if (isArray(format2)) {
    configFromStringAndArray(config2);
  } else if (format2) {
    configFromStringAndFormat(config2);
  } else {
    configFromInput(config2);
  }
  if (!isValid(config2)) {
    config2._d = null;
  }
  return config2;
}
function configFromInput(config2) {
  var input = config2._i;
  if (isUndefined(input)) {
    config2._d = new Date(hooks.now());
  } else if (isDate(input)) {
    config2._d = new Date(input.valueOf());
  } else if (typeof input === "string") {
    configFromString(config2);
  } else if (isArray(input)) {
    config2._a = map(input.slice(0), function(obj) {
      return parseInt(obj, 10);
    });
    configFromArray(config2);
  } else if (isObject(input)) {
    configFromObject(config2);
  } else if (isNumber$1(input)) {
    config2._d = new Date(input);
  } else {
    hooks.createFromInputFallback(config2);
  }
}
function createLocalOrUTC(input, format2, locale2, strict, isUTC) {
  var c2 = {};
  if (format2 === true || format2 === false) {
    strict = format2;
    format2 = void 0;
  }
  if (locale2 === true || locale2 === false) {
    strict = locale2;
    locale2 = void 0;
  }
  if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
    input = void 0;
  }
  c2._isAMomentObject = true;
  c2._useUTC = c2._isUTC = isUTC;
  c2._l = locale2;
  c2._i = input;
  c2._f = format2;
  c2._strict = strict;
  return createFromConfig(c2);
}
function createLocal(input, format2, locale2, strict) {
  return createLocalOrUTC(input, format2, locale2, strict, false);
}
var prototypeMin = deprecate(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var other2 = createLocal.apply(null, arguments);
    if (this.isValid() && other2.isValid()) {
      return other2 < this ? this : other2;
    } else {
      return createInvalid();
    }
  }
), prototypeMax = deprecate(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var other2 = createLocal.apply(null, arguments);
    if (this.isValid() && other2.isValid()) {
      return other2 > this ? this : other2;
    } else {
      return createInvalid();
    }
  }
);
function pickBy(fn2, moments) {
  var res, i;
  if (moments.length === 1 && isArray(moments[0])) {
    moments = moments[0];
  }
  if (!moments.length) {
    return createLocal();
  }
  res = moments[0];
  for (i = 1; i < moments.length; ++i) {
    if (!moments[i].isValid() || moments[i][fn2](res)) {
      res = moments[i];
    }
  }
  return res;
}
function min() {
  var args = [].slice.call(arguments, 0);
  return pickBy("isBefore", args);
}
function max() {
  var args = [].slice.call(arguments, 0);
  return pickBy("isAfter", args);
}
var now = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
};
var ordering = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function isDurationValid(m2) {
  var key2, unitHasDecimal = false, i, orderLen = ordering.length;
  for (key2 in m2) {
    if (hasOwnProp(m2, key2) && !(indexOf.call(ordering, key2) !== -1 && (m2[key2] == null || !isNaN(m2[key2])))) {
      return false;
    }
  }
  for (i = 0; i < orderLen; ++i) {
    if (m2[ordering[i]]) {
      if (unitHasDecimal) {
        return false;
      }
      if (parseFloat(m2[ordering[i]]) !== toInt(m2[ordering[i]])) {
        unitHasDecimal = true;
      }
    }
  }
  return true;
}
function isValid$1() {
  return this._isValid;
}
function createInvalid$1() {
  return createDuration(NaN);
}
function Duration(duration) {
  var normalizedInput = normalizeObjectUnits(duration), years2 = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months2 = normalizedInput.month || 0, weeks2 = normalizedInput.week || normalizedInput.isoWeek || 0, days2 = normalizedInput.day || 0, hours2 = normalizedInput.hour || 0, minutes2 = normalizedInput.minute || 0, seconds2 = normalizedInput.second || 0, milliseconds2 = normalizedInput.millisecond || 0;
  this._isValid = isDurationValid(normalizedInput);
  this._milliseconds = +milliseconds2 + seconds2 * 1e3 + // 1000
  minutes2 * 6e4 + // 1000 * 60
  hours2 * 1e3 * 60 * 60;
  this._days = +days2 + weeks2 * 7;
  this._months = +months2 + quarters * 3 + years2 * 12;
  this._data = {};
  this._locale = getLocale();
  this._bubble();
}
function isDuration(obj) {
  return obj instanceof Duration;
}
function absRound(number2) {
  if (number2 < 0) {
    return Math.round(-1 * number2) * -1;
  } else {
    return Math.round(number2);
  }
}
function compareArrays(array1, array2, dontConvert) {
  var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
  for (i = 0; i < len; i++) {
    if (toInt(array1[i]) !== toInt(array2[i])) {
      diffs++;
    }
  }
  return diffs + lengthDiff;
}
function offset2(token2, separator) {
  addFormatToken(token2, 0, 0, function() {
    var offset3 = this.utcOffset(), sign2 = "+";
    if (offset3 < 0) {
      offset3 = -offset3;
      sign2 = "-";
    }
    return sign2 + zeroFill(~~(offset3 / 60), 2) + separator + zeroFill(~~offset3 % 60, 2);
  });
}
offset2("Z", ":");
offset2("ZZ", "");
addRegexToken("Z", matchShortOffset);
addRegexToken("ZZ", matchShortOffset);
addParseToken(["Z", "ZZ"], function(input, array, config2) {
  config2._useUTC = true;
  config2._tzm = offsetFromString(matchShortOffset, input);
});
var chunkOffset = /([\+\-]|\d\d)/gi;
function offsetFromString(matcher, string2) {
  var matches2 = (string2 || "").match(matcher), chunk, parts, minutes2;
  if (matches2 === null) {
    return null;
  }
  chunk = matches2[matches2.length - 1] || [];
  parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
  minutes2 = +(parts[1] * 60) + toInt(parts[2]);
  return minutes2 === 0 ? 0 : parts[0] === "+" ? minutes2 : -minutes2;
}
function cloneWithOffset(input, model) {
  var res, diff2;
  if (model._isUTC) {
    res = model.clone();
    diff2 = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
    res._d.setTime(res._d.valueOf() + diff2);
    hooks.updateOffset(res, false);
    return res;
  } else {
    return createLocal(input).local();
  }
}
function getDateOffset(m2) {
  return -Math.round(m2._d.getTimezoneOffset());
}
hooks.updateOffset = function() {
};
function getSetOffset(input, keepLocalTime, keepMinutes) {
  var offset3 = this._offset || 0, localAdjust;
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  if (input != null) {
    if (typeof input === "string") {
      input = offsetFromString(matchShortOffset, input);
      if (input === null) {
        return this;
      }
    } else if (Math.abs(input) < 16 && !keepMinutes) {
      input = input * 60;
    }
    if (!this._isUTC && keepLocalTime) {
      localAdjust = getDateOffset(this);
    }
    this._offset = input;
    this._isUTC = true;
    if (localAdjust != null) {
      this.add(localAdjust, "m");
    }
    if (offset3 !== input) {
      if (!keepLocalTime || this._changeInProgress) {
        addSubtract(
          this,
          createDuration(input - offset3, "m"),
          1,
          false
        );
      } else if (!this._changeInProgress) {
        this._changeInProgress = true;
        hooks.updateOffset(this, true);
        this._changeInProgress = null;
      }
    }
    return this;
  } else {
    return this._isUTC ? offset3 : getDateOffset(this);
  }
}
function getSetZone(input, keepLocalTime) {
  if (input != null) {
    if (typeof input !== "string") {
      input = -input;
    }
    this.utcOffset(input, keepLocalTime);
    return this;
  } else {
    return -this.utcOffset();
  }
}
function setOffsetToUTC(keepLocalTime) {
  return this.utcOffset(0, keepLocalTime);
}
function setOffsetToLocal(keepLocalTime) {
  if (this._isUTC) {
    this.utcOffset(0, keepLocalTime);
    this._isUTC = false;
    if (keepLocalTime) {
      this.subtract(getDateOffset(this), "m");
    }
  }
  return this;
}
function setOffsetToParsedOffset() {
  if (this._tzm != null) {
    this.utcOffset(this._tzm, false, true);
  } else if (typeof this._i === "string") {
    var tZone = offsetFromString(matchOffset, this._i);
    if (tZone != null) {
      this.utcOffset(tZone);
    } else {
      this.utcOffset(0, true);
    }
  }
  return this;
}
function hasAlignedHourOffset(input) {
  if (!this.isValid()) {
    return false;
  }
  input = input ? createLocal(input).utcOffset() : 0;
  return (this.utcOffset() - input) % 60 === 0;
}
function isDaylightSavingTime() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function isDaylightSavingTimeShifted() {
  if (!isUndefined(this._isDSTShifted)) {
    return this._isDSTShifted;
  }
  var c2 = {}, other2;
  copyConfig(c2, this);
  c2 = prepareConfig(c2);
  if (c2._a) {
    other2 = c2._isUTC ? createUTC(c2._a) : createLocal(c2._a);
    this._isDSTShifted = this.isValid() && compareArrays(c2._a, other2.toArray()) > 0;
  } else {
    this._isDSTShifted = false;
  }
  return this._isDSTShifted;
}
function isLocal() {
  return this.isValid() ? !this._isUTC : false;
}
function isUtcOffset() {
  return this.isValid() ? this._isUTC : false;
}
function isUtc() {
  return this.isValid() ? this._isUTC && this._offset === 0 : false;
}
var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function createDuration(input, key2) {
  var duration = input, match5 = null, sign2, ret, diffRes;
  if (isDuration(input)) {
    duration = {
      ms: input._milliseconds,
      d: input._days,
      M: input._months
    };
  } else if (isNumber$1(input) || !isNaN(+input)) {
    duration = {};
    if (key2) {
      duration[key2] = +input;
    } else {
      duration.milliseconds = +input;
    }
  } else if (match5 = aspNetRegex.exec(input)) {
    sign2 = match5[1] === "-" ? -1 : 1;
    duration = {
      y: 0,
      d: toInt(match5[DATE]) * sign2,
      h: toInt(match5[HOUR]) * sign2,
      m: toInt(match5[MINUTE]) * sign2,
      s: toInt(match5[SECOND]) * sign2,
      ms: toInt(absRound(match5[MILLISECOND] * 1e3)) * sign2
      // the millisecond decimal point is included in the match
    };
  } else if (match5 = isoRegex.exec(input)) {
    sign2 = match5[1] === "-" ? -1 : 1;
    duration = {
      y: parseIso(match5[2], sign2),
      M: parseIso(match5[3], sign2),
      w: parseIso(match5[4], sign2),
      d: parseIso(match5[5], sign2),
      h: parseIso(match5[6], sign2),
      m: parseIso(match5[7], sign2),
      s: parseIso(match5[8], sign2)
    };
  } else if (duration == null) {
    duration = {};
  } else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
    diffRes = momentsDifference(
      createLocal(duration.from),
      createLocal(duration.to)
    );
    duration = {};
    duration.ms = diffRes.milliseconds;
    duration.M = diffRes.months;
  }
  ret = new Duration(duration);
  if (isDuration(input) && hasOwnProp(input, "_locale")) {
    ret._locale = input._locale;
  }
  if (isDuration(input) && hasOwnProp(input, "_isValid")) {
    ret._isValid = input._isValid;
  }
  return ret;
}
createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;
function parseIso(inp, sign2) {
  var res = inp && parseFloat(inp.replace(",", "."));
  return (isNaN(res) ? 0 : res) * sign2;
}
function positiveMomentsDifference(base2, other2) {
  var res = {};
  res.months = other2.month() - base2.month() + (other2.year() - base2.year()) * 12;
  if (base2.clone().add(res.months, "M").isAfter(other2)) {
    --res.months;
  }
  res.milliseconds = +other2 - +base2.clone().add(res.months, "M");
  return res;
}
function momentsDifference(base2, other2) {
  var res;
  if (!(base2.isValid() && other2.isValid())) {
    return { milliseconds: 0, months: 0 };
  }
  other2 = cloneWithOffset(other2, base2);
  if (base2.isBefore(other2)) {
    res = positiveMomentsDifference(base2, other2);
  } else {
    res = positiveMomentsDifference(other2, base2);
    res.milliseconds = -res.milliseconds;
    res.months = -res.months;
  }
  return res;
}
function createAdder(direction, name2) {
  return function(val, period) {
    var dur, tmp;
    if (period !== null && !isNaN(+period)) {
      deprecateSimple(
        name2,
        "moment()." + name2 + "(period, number) is deprecated. Please use moment()." + name2 + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
      );
      tmp = val;
      val = period;
      period = tmp;
    }
    dur = createDuration(val, period);
    addSubtract(this, dur, direction);
    return this;
  };
}
function addSubtract(mom, duration, isAdding, updateOffset) {
  var milliseconds2 = duration._milliseconds, days2 = absRound(duration._days), months2 = absRound(duration._months);
  if (!mom.isValid()) {
    return;
  }
  updateOffset = updateOffset == null ? true : updateOffset;
  if (months2) {
    setMonth(mom, get4(mom, "Month") + months2 * isAdding);
  }
  if (days2) {
    set$1(mom, "Date", get4(mom, "Date") + days2 * isAdding);
  }
  if (milliseconds2) {
    mom._d.setTime(mom._d.valueOf() + milliseconds2 * isAdding);
  }
  if (updateOffset) {
    hooks.updateOffset(mom, days2 || months2);
  }
}
var add3 = createAdder(1, "add"), subtract3 = createAdder(-1, "subtract");
function isString(input) {
  return typeof input === "string" || input instanceof String;
}
function isMomentInput(input) {
  return isMoment(input) || isDate(input) || isString(input) || isNumber$1(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === void 0;
}
function isMomentInputObject(input) {
  var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties2 = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], i, property, propertyLen = properties2.length;
  for (i = 0; i < propertyLen; i += 1) {
    property = properties2[i];
    propertyTest = propertyTest || hasOwnProp(input, property);
  }
  return objectTest && propertyTest;
}
function isNumberOrStringArray(input) {
  var arrayTest = isArray(input), dataTypeTest = false;
  if (arrayTest) {
    dataTypeTest = input.filter(function(item) {
      return !isNumber$1(item) && isString(input);
    }).length === 0;
  }
  return arrayTest && dataTypeTest;
}
function isCalendarSpec(input) {
  var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties2 = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], i, property;
  for (i = 0; i < properties2.length; i += 1) {
    property = properties2[i];
    propertyTest = propertyTest || hasOwnProp(input, property);
  }
  return objectTest && propertyTest;
}
function getCalendarFormat(myMoment, now2) {
  var diff2 = myMoment.diff(now2, "days", true);
  return diff2 < -6 ? "sameElse" : diff2 < -1 ? "lastWeek" : diff2 < 0 ? "lastDay" : diff2 < 1 ? "sameDay" : diff2 < 2 ? "nextDay" : diff2 < 7 ? "nextWeek" : "sameElse";
}
function calendar$1(time, formats) {
  if (arguments.length === 1) {
    if (!arguments[0]) {
      time = void 0;
      formats = void 0;
    } else if (isMomentInput(arguments[0])) {
      time = arguments[0];
      formats = void 0;
    } else if (isCalendarSpec(arguments[0])) {
      formats = arguments[0];
      time = void 0;
    }
  }
  var now2 = time || createLocal(), sod = cloneWithOffset(now2, this).startOf("day"), format2 = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction$1(formats[format2]) ? formats[format2].call(this, now2) : formats[format2]);
  return this.format(
    output || this.localeData().calendar(format2, this, createLocal(now2))
  );
}
function clone() {
  return new Moment(this);
}
function isAfter(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input);
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() > localInput.valueOf();
  } else {
    return localInput.valueOf() < this.clone().startOf(units).valueOf();
  }
}
function isBefore(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input);
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() < localInput.valueOf();
  } else {
    return this.clone().endOf(units).valueOf() < localInput.valueOf();
  }
}
function isBetween(from3, to2, units, inclusivity) {
  var localFrom = isMoment(from3) ? from3 : createLocal(from3), localTo = isMoment(to2) ? to2 : createLocal(to2);
  if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
    return false;
  }
  inclusivity = inclusivity || "()";
  return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
}
function isSame(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input), inputMs;
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() === localInput.valueOf();
  } else {
    inputMs = localInput.valueOf();
    return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
  }
}
function isSameOrAfter(input, units) {
  return this.isSame(input, units) || this.isAfter(input, units);
}
function isSameOrBefore(input, units) {
  return this.isSame(input, units) || this.isBefore(input, units);
}
function diff(input, units, asFloat) {
  var that, zoneDelta, output;
  if (!this.isValid()) {
    return NaN;
  }
  that = cloneWithOffset(input, this);
  if (!that.isValid()) {
    return NaN;
  }
  zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
  units = normalizeUnits(units);
  switch (units) {
    case "year":
      output = monthDiff(this, that) / 12;
      break;
    case "month":
      output = monthDiff(this, that);
      break;
    case "quarter":
      output = monthDiff(this, that) / 3;
      break;
    case "second":
      output = (this - that) / 1e3;
      break;
    // 1000
    case "minute":
      output = (this - that) / 6e4;
      break;
    // 1000 * 60
    case "hour":
      output = (this - that) / 36e5;
      break;
    // 1000 * 60 * 60
    case "day":
      output = (this - that - zoneDelta) / 864e5;
      break;
    // 1000 * 60 * 60 * 24, negate dst
    case "week":
      output = (this - that - zoneDelta) / 6048e5;
      break;
    // 1000 * 60 * 60 * 24 * 7, negate dst
    default:
      output = this - that;
  }
  return asFloat ? output : absFloor(output);
}
function monthDiff(a2, b2) {
  if (a2.date() < b2.date()) {
    return -monthDiff(b2, a2);
  }
  var wholeMonthDiff = (b2.year() - a2.year()) * 12 + (b2.month() - a2.month()), anchor = a2.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
  if (b2 - anchor < 0) {
    anchor2 = a2.clone().add(wholeMonthDiff - 1, "months");
    adjust = (b2 - anchor) / (anchor - anchor2);
  } else {
    anchor2 = a2.clone().add(wholeMonthDiff + 1, "months");
    adjust = (b2 - anchor) / (anchor2 - anchor);
  }
  return -(wholeMonthDiff + adjust) || 0;
}
hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function toString2() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function toISOString(keepOffset) {
  if (!this.isValid()) {
    return null;
  }
  var utc = keepOffset !== true, m2 = utc ? this.clone().utc() : this;
  if (m2.year() < 0 || m2.year() > 9999) {
    return formatMoment(
      m2,
      utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
    );
  }
  if (isFunction$1(Date.prototype.toISOString)) {
    if (utc) {
      return this.toDate().toISOString();
    } else {
      return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(m2, "Z"));
    }
  }
  return formatMoment(
    m2,
    utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function inspect() {
  if (!this.isValid()) {
    return "moment.invalid(/* " + this._i + " */)";
  }
  var func = "moment", zone = "", prefix2, year, datetime, suffix2;
  if (!this.isLocal()) {
    func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
    zone = "Z";
  }
  prefix2 = "[" + func + '("]';
  year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
  datetime = "-MM-DD[T]HH:mm:ss.SSS";
  suffix2 = zone + '[")]';
  return this.format(prefix2 + year + datetime + suffix2);
}
function format(inputString) {
  if (!inputString) {
    inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
  }
  var output = formatMoment(this, inputString);
  return this.localeData().postformat(output);
}
function from(time, withoutSuffix) {
  if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
    return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
  } else {
    return this.localeData().invalidDate();
  }
}
function fromNow(withoutSuffix) {
  return this.from(createLocal(), withoutSuffix);
}
function to(time, withoutSuffix) {
  if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
    return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
  } else {
    return this.localeData().invalidDate();
  }
}
function toNow(withoutSuffix) {
  return this.to(createLocal(), withoutSuffix);
}
function locale(key2) {
  var newLocaleData;
  if (key2 === void 0) {
    return this._locale._abbr;
  } else {
    newLocaleData = getLocale(key2);
    if (newLocaleData != null) {
      this._locale = newLocaleData;
    }
    return this;
  }
}
var lang = deprecate(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(key2) {
    if (key2 === void 0) {
      return this.localeData();
    } else {
      return this.locale(key2);
    }
  }
);
function localeData() {
  return this._locale;
}
var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
function mod$1(dividend, divisor) {
  return (dividend % divisor + divisor) % divisor;
}
function localStartOfDate(y2, m2, d2) {
  if (y2 < 100 && y2 >= 0) {
    return new Date(y2 + 400, m2, d2) - MS_PER_400_YEARS;
  } else {
    return new Date(y2, m2, d2).valueOf();
  }
}
function utcStartOfDate(y2, m2, d2) {
  if (y2 < 100 && y2 >= 0) {
    return Date.UTC(y2 + 400, m2, d2) - MS_PER_400_YEARS;
  } else {
    return Date.UTC(y2, m2, d2);
  }
}
function startOf(units) {
  var time, startOfDate;
  units = normalizeUnits(units);
  if (units === void 0 || units === "millisecond" || !this.isValid()) {
    return this;
  }
  startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
  switch (units) {
    case "year":
      time = startOfDate(this.year(), 0, 1);
      break;
    case "quarter":
      time = startOfDate(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      time = startOfDate(this.year(), this.month(), 1);
      break;
    case "week":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      time = startOfDate(this.year(), this.month(), this.date());
      break;
    case "hour":
      time = this._d.valueOf();
      time -= mod$1(
        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      );
      break;
    case "minute":
      time = this._d.valueOf();
      time -= mod$1(time, MS_PER_MINUTE);
      break;
    case "second":
      time = this._d.valueOf();
      time -= mod$1(time, MS_PER_SECOND);
      break;
  }
  this._d.setTime(time);
  hooks.updateOffset(this, true);
  return this;
}
function endOf(units) {
  var time, startOfDate;
  units = normalizeUnits(units);
  if (units === void 0 || units === "millisecond" || !this.isValid()) {
    return this;
  }
  startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
  switch (units) {
    case "year":
      time = startOfDate(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      time = startOfDate(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      time = startOfDate(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      time = this._d.valueOf();
      time += MS_PER_HOUR - mod$1(
        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      ) - 1;
      break;
    case "minute":
      time = this._d.valueOf();
      time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
      break;
    case "second":
      time = this._d.valueOf();
      time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
      break;
  }
  this._d.setTime(time);
  hooks.updateOffset(this, true);
  return this;
}
function valueOf() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function unix() {
  return Math.floor(this.valueOf() / 1e3);
}
function toDate() {
  return new Date(this.valueOf());
}
function toArray() {
  var m2 = this;
  return [
    m2.year(),
    m2.month(),
    m2.date(),
    m2.hour(),
    m2.minute(),
    m2.second(),
    m2.millisecond()
  ];
}
function toObject() {
  var m2 = this;
  return {
    years: m2.year(),
    months: m2.month(),
    date: m2.date(),
    hours: m2.hours(),
    minutes: m2.minutes(),
    seconds: m2.seconds(),
    milliseconds: m2.milliseconds()
  };
}
function toJSON() {
  return this.isValid() ? this.toISOString() : null;
}
function isValid$2() {
  return isValid(this);
}
function parsingFlags() {
  return extend({}, getParsingFlags(this));
}
function invalidAt() {
  return getParsingFlags(this).overflow;
}
function creationData() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
addFormatToken("N", 0, 0, "eraAbbr");
addFormatToken("NN", 0, 0, "eraAbbr");
addFormatToken("NNN", 0, 0, "eraAbbr");
addFormatToken("NNNN", 0, 0, "eraName");
addFormatToken("NNNNN", 0, 0, "eraNarrow");
addFormatToken("y", ["y", 1], "yo", "eraYear");
addFormatToken("y", ["yy", 2], 0, "eraYear");
addFormatToken("y", ["yyy", 3], 0, "eraYear");
addFormatToken("y", ["yyyy", 4], 0, "eraYear");
addRegexToken("N", matchEraAbbr);
addRegexToken("NN", matchEraAbbr);
addRegexToken("NNN", matchEraAbbr);
addRegexToken("NNNN", matchEraName);
addRegexToken("NNNNN", matchEraNarrow);
addParseToken(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(input, array, config2, token2) {
    var era = config2._locale.erasParse(input, token2, config2._strict);
    if (era) {
      getParsingFlags(config2).era = era;
    } else {
      getParsingFlags(config2).invalidEra = input;
    }
  }
);
addRegexToken("y", matchUnsigned);
addRegexToken("yy", matchUnsigned);
addRegexToken("yyy", matchUnsigned);
addRegexToken("yyyy", matchUnsigned);
addRegexToken("yo", matchEraYearOrdinal);
addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
addParseToken(["yo"], function(input, array, config2, token2) {
  var match5;
  if (config2._locale._eraYearOrdinalRegex) {
    match5 = input.match(config2._locale._eraYearOrdinalRegex);
  }
  if (config2._locale.eraYearOrdinalParse) {
    array[YEAR] = config2._locale.eraYearOrdinalParse(input, match5);
  } else {
    array[YEAR] = parseInt(input, 10);
  }
});
function localeEras(m2, format2) {
  var i, l2, date, eras = this._eras || getLocale("en")._eras;
  for (i = 0, l2 = eras.length; i < l2; ++i) {
    switch (typeof eras[i].since) {
      case "string":
        date = hooks(eras[i].since).startOf("day");
        eras[i].since = date.valueOf();
        break;
    }
    switch (typeof eras[i].until) {
      case "undefined":
        eras[i].until = Infinity;
        break;
      case "string":
        date = hooks(eras[i].until).startOf("day").valueOf();
        eras[i].until = date.valueOf();
        break;
    }
  }
  return eras;
}
function localeErasParse(eraName, format2, strict) {
  var i, l2, eras = this.eras(), name2, abbr, narrow;
  eraName = eraName.toUpperCase();
  for (i = 0, l2 = eras.length; i < l2; ++i) {
    name2 = eras[i].name.toUpperCase();
    abbr = eras[i].abbr.toUpperCase();
    narrow = eras[i].narrow.toUpperCase();
    if (strict) {
      switch (format2) {
        case "N":
        case "NN":
        case "NNN":
          if (abbr === eraName) {
            return eras[i];
          }
          break;
        case "NNNN":
          if (name2 === eraName) {
            return eras[i];
          }
          break;
        case "NNNNN":
          if (narrow === eraName) {
            return eras[i];
          }
          break;
      }
    } else if ([name2, abbr, narrow].indexOf(eraName) >= 0) {
      return eras[i];
    }
  }
}
function localeErasConvertYear(era, year) {
  var dir = era.since <= era.until ? 1 : -1;
  if (year === void 0) {
    return hooks(era.since).year();
  } else {
    return hooks(era.since).year() + (year - era.offset) * dir;
  }
}
function getEraName() {
  var i, l2, val, eras = this.localeData().eras();
  for (i = 0, l2 = eras.length; i < l2; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].name;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].name;
    }
  }
  return "";
}
function getEraNarrow() {
  var i, l2, val, eras = this.localeData().eras();
  for (i = 0, l2 = eras.length; i < l2; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].narrow;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].narrow;
    }
  }
  return "";
}
function getEraAbbr() {
  var i, l2, val, eras = this.localeData().eras();
  for (i = 0, l2 = eras.length; i < l2; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].abbr;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].abbr;
    }
  }
  return "";
}
function getEraYear() {
  var i, l2, dir, val, eras = this.localeData().eras();
  for (i = 0, l2 = eras.length; i < l2; ++i) {
    dir = eras[i].since <= eras[i].until ? 1 : -1;
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
      return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
    }
  }
  return this.year();
}
function erasNameRegex(isStrict) {
  if (!hasOwnProp(this, "_erasNameRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasNameRegex : this._erasRegex;
}
function erasAbbrRegex(isStrict) {
  if (!hasOwnProp(this, "_erasAbbrRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasAbbrRegex : this._erasRegex;
}
function erasNarrowRegex(isStrict) {
  if (!hasOwnProp(this, "_erasNarrowRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasNarrowRegex : this._erasRegex;
}
function matchEraAbbr(isStrict, locale2) {
  return locale2.erasAbbrRegex(isStrict);
}
function matchEraName(isStrict, locale2) {
  return locale2.erasNameRegex(isStrict);
}
function matchEraNarrow(isStrict, locale2) {
  return locale2.erasNarrowRegex(isStrict);
}
function matchEraYearOrdinal(isStrict, locale2) {
  return locale2._eraYearOrdinalRegex || matchUnsigned;
}
function computeErasParse() {
  var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l2, erasName, erasAbbr, erasNarrow, eras = this.eras();
  for (i = 0, l2 = eras.length; i < l2; ++i) {
    erasName = regexEscape(eras[i].name);
    erasAbbr = regexEscape(eras[i].abbr);
    erasNarrow = regexEscape(eras[i].narrow);
    namePieces.push(erasName);
    abbrPieces.push(erasAbbr);
    narrowPieces.push(erasNarrow);
    mixedPieces.push(erasName);
    mixedPieces.push(erasAbbr);
    mixedPieces.push(erasNarrow);
  }
  this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
  this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
  this._erasNarrowRegex = new RegExp(
    "^(" + narrowPieces.join("|") + ")",
    "i"
  );
}
addFormatToken(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
addFormatToken(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function addWeekYearFormatToken(token2, getter) {
  addFormatToken(0, [token2, token2.length], 0, getter);
}
addWeekYearFormatToken("gggg", "weekYear");
addWeekYearFormatToken("ggggg", "weekYear");
addWeekYearFormatToken("GGGG", "isoWeekYear");
addWeekYearFormatToken("GGGGG", "isoWeekYear");
addRegexToken("G", matchSigned);
addRegexToken("g", matchSigned);
addRegexToken("GG", match1to2, match2);
addRegexToken("gg", match1to2, match2);
addRegexToken("GGGG", match1to4, match4);
addRegexToken("gggg", match1to4, match4);
addRegexToken("GGGGG", match1to6, match6);
addRegexToken("ggggg", match1to6, match6);
addWeekParseToken(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(input, week, config2, token2) {
    week[token2.substr(0, 2)] = toInt(input);
  }
);
addWeekParseToken(["gg", "GG"], function(input, week, config2, token2) {
  week[token2] = hooks.parseTwoDigitYear(input);
});
function getSetWeekYear(input) {
  return getSetWeekYearHelper.call(
    this,
    input,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function getSetISOWeekYear(input) {
  return getSetWeekYearHelper.call(
    this,
    input,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function getISOWeeksInYear() {
  return weeksInYear(this.year(), 1, 4);
}
function getISOWeeksInISOWeekYear() {
  return weeksInYear(this.isoWeekYear(), 1, 4);
}
function getWeeksInYear() {
  var weekInfo = this.localeData()._week;
  return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}
function getWeeksInWeekYear() {
  var weekInfo = this.localeData()._week;
  return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
}
function getSetWeekYearHelper(input, week, weekday, dow, doy) {
  var weeksTarget;
  if (input == null) {
    return weekOfYear(this, dow, doy).year;
  } else {
    weeksTarget = weeksInYear(input, dow, doy);
    if (week > weeksTarget) {
      week = weeksTarget;
    }
    return setWeekAll.call(this, input, week, weekday, dow, doy);
  }
}
function setWeekAll(weekYear, week, weekday, dow, doy) {
  var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
  this.year(date.getUTCFullYear());
  this.month(date.getUTCMonth());
  this.date(date.getUTCDate());
  return this;
}
addFormatToken("Q", 0, "Qo", "quarter");
addRegexToken("Q", match1);
addParseToken("Q", function(input, array) {
  array[MONTH] = (toInt(input) - 1) * 3;
});
function getSetQuarter(input) {
  return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}
addFormatToken("D", ["DD", 2], "Do", "date");
addRegexToken("D", match1to2, match1to2NoLeadingZero);
addRegexToken("DD", match1to2, match2);
addRegexToken("Do", function(isStrict, locale2) {
  return isStrict ? locale2._dayOfMonthOrdinalParse || locale2._ordinalParse : locale2._dayOfMonthOrdinalParseLenient;
});
addParseToken(["D", "DD"], DATE);
addParseToken("Do", function(input, array) {
  array[DATE] = toInt(input.match(match1to2)[0]);
});
var getSetDayOfMonth = makeGetSet("Date", true);
addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
addRegexToken("DDD", match1to3);
addRegexToken("DDDD", match3);
addParseToken(["DDD", "DDDD"], function(input, array, config2) {
  config2._dayOfYear = toInt(input);
});
function getSetDayOfYear(input) {
  var dayOfYear = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
}
addFormatToken("m", ["mm", 2], 0, "minute");
addRegexToken("m", match1to2, match1to2HasZero);
addRegexToken("mm", match1to2, match2);
addParseToken(["m", "mm"], MINUTE);
var getSetMinute = makeGetSet("Minutes", false);
addFormatToken("s", ["ss", 2], 0, "second");
addRegexToken("s", match1to2, match1to2HasZero);
addRegexToken("ss", match1to2, match2);
addParseToken(["s", "ss"], SECOND);
var getSetSecond = makeGetSet("Seconds", false);
addFormatToken("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
addFormatToken(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
addFormatToken(0, ["SSS", 3], 0, "millisecond");
addFormatToken(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
addFormatToken(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
addFormatToken(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
addFormatToken(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
addRegexToken("S", match1to3, match1);
addRegexToken("SS", match1to3, match2);
addRegexToken("SSS", match1to3, match3);
var token, getSetMillisecond;
for (token = "SSSS"; token.length <= 9; token += "S") {
  addRegexToken(token, matchUnsigned);
}
function parseMs(input, array) {
  array[MILLISECOND] = toInt(("0." + input) * 1e3);
}
for (token = "S"; token.length <= 9; token += "S") {
  addParseToken(token, parseMs);
}
getSetMillisecond = makeGetSet("Milliseconds", false);
addFormatToken("z", 0, 0, "zoneAbbr");
addFormatToken("zz", 0, 0, "zoneName");
function getZoneAbbr() {
  return this._isUTC ? "UTC" : "";
}
function getZoneName() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var proto = Moment.prototype;
proto.add = add3;
proto.calendar = calendar$1;
proto.clone = clone;
proto.diff = diff;
proto.endOf = endOf;
proto.format = format;
proto.from = from;
proto.fromNow = fromNow;
proto.to = to;
proto.toNow = toNow;
proto.get = stringGet;
proto.invalidAt = invalidAt;
proto.isAfter = isAfter;
proto.isBefore = isBefore;
proto.isBetween = isBetween;
proto.isSame = isSame;
proto.isSameOrAfter = isSameOrAfter;
proto.isSameOrBefore = isSameOrBefore;
proto.isValid = isValid$2;
proto.lang = lang;
proto.locale = locale;
proto.localeData = localeData;
proto.max = prototypeMax;
proto.min = prototypeMin;
proto.parsingFlags = parsingFlags;
proto.set = stringSet;
proto.startOf = startOf;
proto.subtract = subtract3;
proto.toArray = toArray;
proto.toObject = toObject;
proto.toDate = toDate;
proto.toISOString = toISOString;
proto.inspect = inspect;
if (typeof Symbol !== "undefined" && Symbol.for != null) {
  proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
    return "Moment<" + this.format() + ">";
  };
}
proto.toJSON = toJSON;
proto.toString = toString2;
proto.unix = unix;
proto.valueOf = valueOf;
proto.creationData = creationData;
proto.eraName = getEraName;
proto.eraNarrow = getEraNarrow;
proto.eraAbbr = getEraAbbr;
proto.eraYear = getEraYear;
proto.year = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week = proto.weeks = getSetWeek;
proto.isoWeek = proto.isoWeeks = getSetISOWeek;
proto.weeksInYear = getWeeksInYear;
proto.weeksInWeekYear = getWeeksInWeekYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
proto.date = getSetDayOfMonth;
proto.day = proto.days = getSetDayOfWeek;
proto.weekday = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset = getSetOffset;
proto.utc = setOffsetToUTC;
proto.local = setOffsetToLocal;
proto.parseZone = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST = isDaylightSavingTime;
proto.isLocal = isLocal;
proto.isUtcOffset = isUtcOffset;
proto.isUtc = isUtc;
proto.isUTC = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates = deprecate(
  "dates accessor is deprecated. Use date instead.",
  getSetDayOfMonth
);
proto.months = deprecate(
  "months accessor is deprecated. Use month instead",
  getSetMonth
);
proto.years = deprecate(
  "years accessor is deprecated. Use year instead",
  getSetYear
);
proto.zone = deprecate(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  getSetZone
);
proto.isDSTShifted = deprecate(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  isDaylightSavingTimeShifted
);
function createUnix(input) {
  return createLocal(input * 1e3);
}
function createInZone() {
  return createLocal.apply(null, arguments).parseZone();
}
function preParsePostFormat(string2) {
  return string2;
}
var proto$1 = Locale.prototype;
proto$1.calendar = calendar;
proto$1.longDateFormat = longDateFormat;
proto$1.invalidDate = invalidDate;
proto$1.ordinal = ordinal;
proto$1.preparse = preParsePostFormat;
proto$1.postformat = preParsePostFormat;
proto$1.relativeTime = relativeTime;
proto$1.pastFuture = pastFuture;
proto$1.set = set;
proto$1.eras = localeEras;
proto$1.erasParse = localeErasParse;
proto$1.erasConvertYear = localeErasConvertYear;
proto$1.erasAbbrRegex = erasAbbrRegex;
proto$1.erasNameRegex = erasNameRegex;
proto$1.erasNarrowRegex = erasNarrowRegex;
proto$1.months = localeMonths;
proto$1.monthsShort = localeMonthsShort;
proto$1.monthsParse = localeMonthsParse;
proto$1.monthsRegex = monthsRegex;
proto$1.monthsShortRegex = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;
proto$1.weekdays = localeWeekdays;
proto$1.weekdaysMin = localeWeekdaysMin;
proto$1.weekdaysShort = localeWeekdaysShort;
proto$1.weekdaysParse = localeWeekdaysParse;
proto$1.weekdaysRegex = weekdaysRegex;
proto$1.weekdaysShortRegex = weekdaysShortRegex;
proto$1.weekdaysMinRegex = weekdaysMinRegex;
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;
function get$1(format2, index2, field, setter) {
  var locale2 = getLocale(), utc = createUTC().set(setter, index2);
  return locale2[field](utc, format2);
}
function listMonthsImpl(format2, index2, field) {
  if (isNumber$1(format2)) {
    index2 = format2;
    format2 = void 0;
  }
  format2 = format2 || "";
  if (index2 != null) {
    return get$1(format2, index2, field, "month");
  }
  var i, out = [];
  for (i = 0; i < 12; i++) {
    out[i] = get$1(format2, i, field, "month");
  }
  return out;
}
function listWeekdaysImpl(localeSorted, format2, index2, field) {
  if (typeof localeSorted === "boolean") {
    if (isNumber$1(format2)) {
      index2 = format2;
      format2 = void 0;
    }
    format2 = format2 || "";
  } else {
    format2 = localeSorted;
    index2 = format2;
    localeSorted = false;
    if (isNumber$1(format2)) {
      index2 = format2;
      format2 = void 0;
    }
    format2 = format2 || "";
  }
  var locale2 = getLocale(), shift3 = localeSorted ? locale2._week.dow : 0, i, out = [];
  if (index2 != null) {
    return get$1(format2, (index2 + shift3) % 7, field, "day");
  }
  for (i = 0; i < 7; i++) {
    out[i] = get$1(format2, (i + shift3) % 7, field, "day");
  }
  return out;
}
function listMonths(format2, index2) {
  return listMonthsImpl(format2, index2, "months");
}
function listMonthsShort(format2, index2) {
  return listMonthsImpl(format2, index2, "monthsShort");
}
function listWeekdays(localeSorted, format2, index2) {
  return listWeekdaysImpl(localeSorted, format2, index2, "weekdays");
}
function listWeekdaysShort(localeSorted, format2, index2) {
  return listWeekdaysImpl(localeSorted, format2, index2, "weekdaysShort");
}
function listWeekdaysMin(localeSorted, format2, index2) {
  return listWeekdaysImpl(localeSorted, format2, index2, "weekdaysMin");
}
getSetGlobalLocale("en", {
  eras: [
    {
      since: "0001-01-01",
      until: Infinity,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -Infinity,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(number2) {
    var b2 = number2 % 10, output = toInt(number2 % 100 / 10) === 1 ? "th" : b2 === 1 ? "st" : b2 === 2 ? "nd" : b2 === 3 ? "rd" : "th";
    return number2 + output;
  }
});
hooks.lang = deprecate(
  "moment.lang is deprecated. Use moment.locale instead.",
  getSetGlobalLocale
);
hooks.langData = deprecate(
  "moment.langData is deprecated. Use moment.localeData instead.",
  getLocale
);
var mathAbs = Math.abs;
function abs() {
  var data = this._data;
  this._milliseconds = mathAbs(this._milliseconds);
  this._days = mathAbs(this._days);
  this._months = mathAbs(this._months);
  data.milliseconds = mathAbs(data.milliseconds);
  data.seconds = mathAbs(data.seconds);
  data.minutes = mathAbs(data.minutes);
  data.hours = mathAbs(data.hours);
  data.months = mathAbs(data.months);
  data.years = mathAbs(data.years);
  return this;
}
function addSubtract$1(duration, input, value, direction) {
  var other2 = createDuration(input, value);
  duration._milliseconds += direction * other2._milliseconds;
  duration._days += direction * other2._days;
  duration._months += direction * other2._months;
  return duration._bubble();
}
function add$1(input, value) {
  return addSubtract$1(this, input, value, 1);
}
function subtract$1(input, value) {
  return addSubtract$1(this, input, value, -1);
}
function absCeil(number2) {
  if (number2 < 0) {
    return Math.floor(number2);
  } else {
    return Math.ceil(number2);
  }
}
function bubble() {
  var milliseconds2 = this._milliseconds, days2 = this._days, months2 = this._months, data = this._data, seconds2, minutes2, hours2, years2, monthsFromDays;
  if (!(milliseconds2 >= 0 && days2 >= 0 && months2 >= 0 || milliseconds2 <= 0 && days2 <= 0 && months2 <= 0)) {
    milliseconds2 += absCeil(monthsToDays(months2) + days2) * 864e5;
    days2 = 0;
    months2 = 0;
  }
  data.milliseconds = milliseconds2 % 1e3;
  seconds2 = absFloor(milliseconds2 / 1e3);
  data.seconds = seconds2 % 60;
  minutes2 = absFloor(seconds2 / 60);
  data.minutes = minutes2 % 60;
  hours2 = absFloor(minutes2 / 60);
  data.hours = hours2 % 24;
  days2 += absFloor(hours2 / 24);
  monthsFromDays = absFloor(daysToMonths(days2));
  months2 += monthsFromDays;
  days2 -= absCeil(monthsToDays(monthsFromDays));
  years2 = absFloor(months2 / 12);
  months2 %= 12;
  data.days = days2;
  data.months = months2;
  data.years = years2;
  return this;
}
function daysToMonths(days2) {
  return days2 * 4800 / 146097;
}
function monthsToDays(months2) {
  return months2 * 146097 / 4800;
}
function as(units) {
  if (!this.isValid()) {
    return NaN;
  }
  var days2, months2, milliseconds2 = this._milliseconds;
  units = normalizeUnits(units);
  if (units === "month" || units === "quarter" || units === "year") {
    days2 = this._days + milliseconds2 / 864e5;
    months2 = this._months + daysToMonths(days2);
    switch (units) {
      case "month":
        return months2;
      case "quarter":
        return months2 / 3;
      case "year":
        return months2 / 12;
    }
  } else {
    days2 = this._days + Math.round(monthsToDays(this._months));
    switch (units) {
      case "week":
        return days2 / 7 + milliseconds2 / 6048e5;
      case "day":
        return days2 + milliseconds2 / 864e5;
      case "hour":
        return days2 * 24 + milliseconds2 / 36e5;
      case "minute":
        return days2 * 1440 + milliseconds2 / 6e4;
      case "second":
        return days2 * 86400 + milliseconds2 / 1e3;
      // Math.floor prevents floating point math errors here
      case "millisecond":
        return Math.floor(days2 * 864e5) + milliseconds2;
      default:
        throw new Error("Unknown unit " + units);
    }
  }
}
function makeAs(alias) {
  return function() {
    return this.as(alias);
  };
}
var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
function clone$1() {
  return createDuration(this);
}
function get$2(units) {
  units = normalizeUnits(units);
  return this.isValid() ? this[units + "s"]() : NaN;
}
function makeGetter(name2) {
  return function() {
    return this.isValid() ? this._data[name2] : NaN;
  };
}
var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
function weeks() {
  return absFloor(this.days() / 7);
}
var round = Math.round, thresholds = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function substituteTimeAgo(string2, number2, withoutSuffix, isFuture, locale2) {
  return locale2.relativeTime(number2 || 1, !!withoutSuffix, string2, isFuture);
}
function relativeTime$1(posNegDuration, withoutSuffix, thresholds2, locale2) {
  var duration = createDuration(posNegDuration).abs(), seconds2 = round(duration.as("s")), minutes2 = round(duration.as("m")), hours2 = round(duration.as("h")), days2 = round(duration.as("d")), months2 = round(duration.as("M")), weeks2 = round(duration.as("w")), years2 = round(duration.as("y")), a2 = seconds2 <= thresholds2.ss && ["s", seconds2] || seconds2 < thresholds2.s && ["ss", seconds2] || minutes2 <= 1 && ["m"] || minutes2 < thresholds2.m && ["mm", minutes2] || hours2 <= 1 && ["h"] || hours2 < thresholds2.h && ["hh", hours2] || days2 <= 1 && ["d"] || days2 < thresholds2.d && ["dd", days2];
  if (thresholds2.w != null) {
    a2 = a2 || weeks2 <= 1 && ["w"] || weeks2 < thresholds2.w && ["ww", weeks2];
  }
  a2 = a2 || months2 <= 1 && ["M"] || months2 < thresholds2.M && ["MM", months2] || years2 <= 1 && ["y"] || ["yy", years2];
  a2[2] = withoutSuffix;
  a2[3] = +posNegDuration > 0;
  a2[4] = locale2;
  return substituteTimeAgo.apply(null, a2);
}
function getSetRelativeTimeRounding(roundingFunction) {
  if (roundingFunction === void 0) {
    return round;
  }
  if (typeof roundingFunction === "function") {
    round = roundingFunction;
    return true;
  }
  return false;
}
function getSetRelativeTimeThreshold(threshold, limit) {
  if (thresholds[threshold] === void 0) {
    return false;
  }
  if (limit === void 0) {
    return thresholds[threshold];
  }
  thresholds[threshold] = limit;
  if (threshold === "s") {
    thresholds.ss = limit - 1;
  }
  return true;
}
function humanize(argWithSuffix, argThresholds) {
  if (!this.isValid()) {
    return this.localeData().invalidDate();
  }
  var withSuffix = false, th = thresholds, locale2, output;
  if (typeof argWithSuffix === "object") {
    argThresholds = argWithSuffix;
    argWithSuffix = false;
  }
  if (typeof argWithSuffix === "boolean") {
    withSuffix = argWithSuffix;
  }
  if (typeof argThresholds === "object") {
    th = Object.assign({}, thresholds, argThresholds);
    if (argThresholds.s != null && argThresholds.ss == null) {
      th.ss = argThresholds.s - 1;
    }
  }
  locale2 = this.localeData();
  output = relativeTime$1(this, !withSuffix, th, locale2);
  if (withSuffix) {
    output = locale2.pastFuture(+this, output);
  }
  return locale2.postformat(output);
}
var abs$1 = Math.abs;
function sign(x2) {
  return (x2 > 0) - (x2 < 0) || +x2;
}
function toISOString$1() {
  if (!this.isValid()) {
    return this.localeData().invalidDate();
  }
  var seconds2 = abs$1(this._milliseconds) / 1e3, days2 = abs$1(this._days), months2 = abs$1(this._months), minutes2, hours2, years2, s2, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
  if (!total) {
    return "P0D";
  }
  minutes2 = absFloor(seconds2 / 60);
  hours2 = absFloor(minutes2 / 60);
  seconds2 %= 60;
  minutes2 %= 60;
  years2 = absFloor(months2 / 12);
  months2 %= 12;
  s2 = seconds2 ? seconds2.toFixed(3).replace(/\.?0+$/, "") : "";
  totalSign = total < 0 ? "-" : "";
  ymSign = sign(this._months) !== sign(total) ? "-" : "";
  daysSign = sign(this._days) !== sign(total) ? "-" : "";
  hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
  return totalSign + "P" + (years2 ? ymSign + years2 + "Y" : "") + (months2 ? ymSign + months2 + "M" : "") + (days2 ? daysSign + days2 + "D" : "") + (hours2 || minutes2 || seconds2 ? "T" : "") + (hours2 ? hmsSign + hours2 + "H" : "") + (minutes2 ? hmsSign + minutes2 + "M" : "") + (seconds2 ? hmsSign + s2 + "S" : "");
}
var proto$2 = Duration.prototype;
proto$2.isValid = isValid$1;
proto$2.abs = abs;
proto$2.add = add$1;
proto$2.subtract = subtract$1;
proto$2.as = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds = asSeconds;
proto$2.asMinutes = asMinutes;
proto$2.asHours = asHours;
proto$2.asDays = asDays;
proto$2.asWeeks = asWeeks;
proto$2.asMonths = asMonths;
proto$2.asQuarters = asQuarters;
proto$2.asYears = asYears;
proto$2.valueOf = valueOf$1;
proto$2._bubble = bubble;
proto$2.clone = clone$1;
proto$2.get = get$2;
proto$2.milliseconds = milliseconds;
proto$2.seconds = seconds;
proto$2.minutes = minutes;
proto$2.hours = hours;
proto$2.days = days;
proto$2.weeks = weeks;
proto$2.months = months;
proto$2.years = years;
proto$2.humanize = humanize;
proto$2.toISOString = toISOString$1;
proto$2.toString = toISOString$1;
proto$2.toJSON = toISOString$1;
proto$2.locale = locale;
proto$2.localeData = localeData;
proto$2.toIsoString = deprecate(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  toISOString$1
);
proto$2.lang = lang;
addFormatToken("X", 0, 0, "unix");
addFormatToken("x", 0, 0, "valueOf");
addRegexToken("x", matchSigned);
addRegexToken("X", matchTimestamp);
addParseToken("X", function(input, array, config2) {
  config2._d = new Date(parseFloat(input) * 1e3);
});
addParseToken("x", function(input, array, config2) {
  config2._d = new Date(toInt(input));
});
//! moment.js
hooks.version = "2.30.1";
setHookCallback(createLocal);
hooks.fn = proto;
hooks.min = min;
hooks.max = max;
hooks.now = now;
hooks.utc = createUTC;
hooks.unix = createUnix;
hooks.months = listMonths;
hooks.isDate = isDate;
hooks.locale = getSetGlobalLocale;
hooks.invalid = createInvalid;
hooks.duration = createDuration;
hooks.isMoment = isMoment;
hooks.weekdays = listWeekdays;
hooks.parseZone = createInZone;
hooks.localeData = getLocale;
hooks.isDuration = isDuration;
hooks.monthsShort = listMonthsShort;
hooks.weekdaysMin = listWeekdaysMin;
hooks.defineLocale = defineLocale;
hooks.updateLocale = updateLocale;
hooks.locales = listLocales;
hooks.weekdaysShort = listWeekdaysShort;
hooks.normalizeUnits = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat = getCalendarFormat;
hooks.prototype = proto;
hooks.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const buildAvailableRoomType = (roomType2, checkIn, checkOut) => ({
  id: roomType2.id,
  name: roomType2.name,
  minOccupancy: roomType2.minOccupancy,
  maxOccupancy: roomType2.maxOccupancy,
  sort: roomType2.sort,
  totalPrice: getBookingNightsCount({ checkIn, checkOut }) * roomType2.price
});
const buildRegFlowRoomBlock = (roomBlock3) => ({ ...roomBlock3, roomTypes: void 0 });
({
  startDate: hooks("2050-01-10"),
  endDate: hooks("2050-01-14")
});
({
  startDate: hooks("2050-02-21"),
  endDate: hooks("2050-02-24")
});
const roomTypes = {
  single: {
    id: "1233",
    name: "Single",
    price: 11e3,
    minOccupancy: 1,
    maxOccupancy: 1,
    nights: [],
    sort: 1
  },
  double: {
    id: "1234",
    name: "Standard double",
    price: 12e3,
    minOccupancy: 1,
    maxOccupancy: 2,
    nights: [],
    sort: 1,
    hasValidBookings: true
  },
  king: {
    id: "1236",
    name: "King",
    price: 15e3,
    minOccupancy: 1,
    maxOccupancy: 2,
    nights: [],
    sort: 2,
    hasValidBookings: false
  },
  suite: {
    id: "1238",
    name: "Suite",
    price: 25e3,
    minOccupancy: 2,
    maxOccupancy: 5,
    nights: [],
    sort: 3
  }
};
const roomBlocks = {
  fourDay: setRoomTypeNights({
    id: 1,
    name: "Room block 4 days",
    startDate: parseISO$1("2050-01-10"),
    endDate: parseISO$1("2050-01-14"),
    numberBooked: 2,
    roomTypes: [
      roomTypes.single,
      roomTypes.double,
      roomTypes.king,
      roomTypes.suite
    ]
  }),
  tenDay: setRoomTypeNights({
    id: 2,
    name: "Room block 10 days",
    startDate: parseISO$1("2050-01-10"),
    endDate: parseISO$1("2050-01-20"),
    numberBooked: 0,
    roomTypes: [roomTypes.double, roomTypes.king, roomTypes.suite],
    hidePrices: true
  }),
  oneDay: setRoomTypeNights({
    id: 3,
    name: "Room block 1 day",
    startDate: parseISO$1("2050-01-10"),
    endDate: parseISO$1("2050-01-11"),
    numberBooked: 99,
    roomTypes: [roomTypes.double, roomTypes.king, roomTypes.suite]
  })
};
({
  fourDay: buildRegFlowRoomBlock(roomBlocks.fourDay),
  tenDay: buildRegFlowRoomBlock(roomBlocks.tenDay),
  oneDay: buildRegFlowRoomBlock(roomBlocks.oneDay)
});
({
  fourDay: {
    roomType: buildAvailableRoomType(
      roomTypes.double,
      roomBlocks.fourDay.startDate,
      roomBlocks.fourDay.endDate
    ),
    checkIn: roomBlocks.fourDay.startDate,
    checkOut: roomBlocks.fourDay.endDate
  },
  tenDay: {
    roomType: buildAvailableRoomType(
      roomTypes.suite,
      roomBlocks.tenDay.startDate,
      roomBlocks.tenDay.endDate
    ),
    checkIn: roomBlocks.tenDay.startDate,
    checkOut: roomBlocks.tenDay.endDate
  }
});
const defaultStartDate = (field, roomBlock) => {
  if (field.defaultCheckIn !== void 0) {
    return parseISO$1(field.defaultCheckIn);
  }
  if (field.availableFrom !== void 0) {
    return parseISO$1(field.availableFrom);
  }
  return roomBlock.startDate;
};
const defaultEndDate = (field, roomBlock) => {
  if (field.defaultCheckOut !== void 0) {
    return parseISO$1(field.defaultCheckOut);
  }
  if (field.availableTo !== void 0) {
    return parseISO$1(field.availableTo);
  }
  return roomBlock.endDate;
};
const RoomingFieldPreview = ({
  field,
  onSelect,
  isSelected
}) => {
  const { dateFormats: dateFormats2, currency } = useLocale();
  const { isLoading, error: error2, data: roomBlock } = useRoomBlock(field.roomBlockId);
  const [booking, setBooking] = useState();
  const [selectedRoomType, setSelectedRoomType] = useState();
  useEffect(() => {
    if (booking === void 0 && roomBlock !== void 0) {
      setBooking({ checkIn: roomBlock.startDate, checkOut: roomBlock.endDate });
    }
  }, [roomBlock, booking]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      onClick: () => onSelect(field.name),
      bg: isSelected ? "bg.blue-light" : "bg.secondary",
      p: 4,
      children: isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { as: Stack, align: "center", justify: "center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {}) }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "spacious", children: [
        error2 && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { children: "Error loading room block" }),
        roomBlock !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { as: Stack, direction: "horizontal", gap: "spacious", flex: 1, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { sx: { flex: 1 }, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Check In" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                DatePickerPrimer,
                {
                  selectedDate: (booking == null ? void 0 : booking.checkIn) || defaultStartDate(field, roomBlock),
                  onChange: (date) => {
                    if (date) {
                      setBooking({ ...booking, checkIn: date });
                      if (selectedRoomType && (booking == null ? void 0 : booking.checkOut)) {
                        const roomType = roomBlock == null ? void 0 : roomBlock.roomTypes.find((rt) => rt.id === selectedRoomType.id);
                        if (roomType) {
                          const availableRoomType = buildAvailableRoomType(
                            roomType,
                            date,
                            booking.checkOut
                          );
                          setSelectedRoomType(availableRoomType);
                        }
                      }
                    }
                  },
                  selectsStart: true,
                  dateFormat: dateFormats2.regular,
                  block: true
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { sx: { flex: 1 }, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Check Out" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                DatePickerPrimer,
                {
                  selectedDate: (booking == null ? void 0 : booking.checkOut) || defaultEndDate(field, roomBlock),
                  onChange: (date) => {
                    if (date) {
                      setBooking({ ...booking, checkOut: date });
                      if (selectedRoomType && (booking == null ? void 0 : booking.checkIn)) {
                        const roomType = roomBlock == null ? void 0 : roomBlock.roomTypes.find((rt) => rt.id === selectedRoomType.id);
                        if (roomType) {
                          const availableRoomType = buildAvailableRoomType(
                            roomType,
                            booking.checkIn,
                            date
                          );
                          setSelectedRoomType(availableRoomType);
                        }
                      }
                    }
                  },
                  selectsEnd: true,
                  dateFormat: dateFormats2.regular,
                  block: true
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { sx: { flex: 3 }, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Room Type" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Select$1,
                {
                  value: (selectedRoomType == null ? void 0 : selectedRoomType.id) || "",
                  onChange: (e) => {
                    const roomType = roomBlock == null ? void 0 : roomBlock.roomTypes.find((rt) => rt.id === e.target.value);
                    if (roomType && (booking == null ? void 0 : booking.checkIn) && (booking == null ? void 0 : booking.checkOut)) {
                      const availableRoomType = buildAvailableRoomType(
                        roomType,
                        booking.checkIn,
                        booking.checkOut
                      );
                      setSelectedRoomType(availableRoomType);
                      setBooking({ ...booking, roomType: availableRoomType });
                    }
                  },
                  size: "large",
                  block: true,
                  children: roomBlock == null ? void 0 : roomBlock.roomTypes.map((rt) => /* @__PURE__ */ jsxRuntimeExports.jsx(Select$1.Option, { value: rt.id, children: rt.name }, rt.id))
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "spacious", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { sx: { flex: 1 }, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { visuallyHidden: true, children: "Special Requests" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Textarea,
                {
                  placeholder: "Special Requests...",
                  value: booking == null ? void 0 : booking.note,
                  rows: 5,
                  block: true,
                  onChange: (e) => setBooking({ ...booking, note: e.target.value })
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Box,
              {
                flex: 1,
                sx: {
                  bg: "accent.subtle",
                  border: "1px solid",
                  borderColor: "border.subtle"
                },
                p: 3,
                borderRadius: 2,
                children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "none", align: "center", justify: "center", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Text$2,
                    {
                      size: "small",
                      weight: "medium",
                      sx: { color: "fg.muted" },
                      align: "center",
                      children: "Reserved for 30 Minutes"
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "small", sx: { color: "fg.muted" }, align: "center", children: "Your reservation is not secured until you complete your registration" }),
                  selectedRoomType && roomBlock && !roomBlock.hidePrices && /* @__PURE__ */ jsxRuntimeExports.jsxs(
                    Text$2,
                    {
                      size: "large",
                      weight: "bold",
                      sx: { color: "fg.default", marginTop: 2 },
                      children: [
                        "Total Cost:",
                        " ",
                        /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { weight: "semibold", sx: { color: "fg.default" }, align: "center", children: priceWithSymbol({
                          price: selectedRoomType.totalPrice,
                          currency: currency.symbol
                        }) })
                      ]
                    }
                  )
                ] })
              }
            )
          ] })
        ] })
      ] })
    }
  );
};
const SlotChoicesInfo = ({ field }) => {
  if (field.maxChoices !== void 0 && field.minChoices !== void 0) {
    if (field.maxChoices === field.minChoices) {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Choose exactly ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: field.minChoices }),
        " slots"
      ] });
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Choose between ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: field.minChoices }),
        " and ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: field.maxChoices }),
        " ",
        "slots."
      ] });
    }
  }
  if (field.maxChoices !== void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      "Choose up to ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: field.maxChoices }),
      " slots"
    ] });
  }
  if (field.minChoices !== void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      "Choose at least ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: field.minChoices }),
      " slots"
    ] });
  }
  return null;
};
const SessionSlotChecklist = ({
  field,
  session,
  currency = "$"
}) => {
  const [openPopoverId, setOpenPopoverId] = useState(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(CheckboxGroup$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxGroup$1.Label, { children: "Select session slots" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { children: visibleSlots(field, session).map((slot) => /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$1, { value: slot.id.toString() }, slot.id),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", children: slot.name }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Caption, { sx: { marginTop: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "condensed", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Label, { children: [
            slot.totalCapacity - (slot.numberBooked || 0),
            " Available"
          ] }),
          slot.priceInCents && /* @__PURE__ */ jsxRuntimeExports.jsx(ActionBar.Divider, {}),
          slot.priceInCents && /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$2, { size: "small", weight: "medium", children: [
            currency,
            formatCents(getSessionSlotFieldPrice(slot, field) || 0)
          ] }),
          slot.startTime && slot.endTime && /* @__PURE__ */ jsxRuntimeExports.jsx(ActionBar.Divider, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$2, { size: "small", children: [
            slot.startTime && format$2(slot.startTime, "HH:mmaaa"),
            slot.endTime && ` - ${format$2(slot.endTime, "HH:mmaaa")}`
          ] }),
          slot.description && /* @__PURE__ */ jsxRuntimeExports.jsx(ActionBar.Divider, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Text$2,
            {
              onMouseEnter: () => setOpenPopoverId(slot.id.toString()),
              onMouseLeave: () => setOpenPopoverId(null),
              size: "small",
              sx: { cursor: "pointer" },
              children: slot.description
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Popover$1, { open: openPopoverId === slot.id.toString(), children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Popover$1.Content, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Heading$4, { sx: { fontSize: 2 }, children: slot.name }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "small", children: slot.description })
          ] }) })
        ] }) })
      ] }, slot.id)) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SlotChoicesInfo, { field }) })
  ] });
};
const SessionSlotPreview = ({
  field,
  session,
  currency = "$",
  error: error2
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { gap: "normal", children: [
  error2 && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { children: "Error loading session data" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: session && /* @__PURE__ */ jsxRuntimeExports.jsx(
    SessionSlotChecklist,
    {
      field,
      session,
      currency
    }
  ) })
] });
const SessionFieldPreview = ({
  field,
  showPrices = false,
  currency = "$",
  onSelect,
  isSelected
}) => {
  const { isLoading, error: error2, data: session } = useSession(field.session);
  if (error2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: "Error loading session" });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      onClick: () => onSelect(field.name),
      p: 4,
      bg: isSelected ? "bg.blue-light" : "bg.secondary",
      children: isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { py: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {}) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        SessionSlotPreview,
        {
          field,
          session,
          error: error2,
          currency
        }
      )
    }
  );
};
const FieldListItem = ({
  field,
  onSelect,
  renderChildren = true,
  isExpanded = true,
  showPrices = false,
  currency = "$",
  onExpand,
  onCollapse
}) => {
  const { form, editorState } = useRegForm();
  const { selectedField } = getSelectedItems$1({
    fields: form.fields,
    ...editorState
  });
  const isSelected = (selectedField == null ? void 0 : selectedField.name) === field.name;
  const isInputField2 = (field2) => {
    return field2.type !== "room_block" && field2.type !== "session_booking" && field2.type !== "info" && field2.type !== "lead_scanner" && field2.type !== "section";
  };
  if (isInputField2(field) && field.widget === "textarea") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(TextAreaField, { ...field, onSelect, isSelected });
  } else if (isInputField2(field) && field.choices && field.choices.length) {
    if (field.widget === "radio") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        RadioField,
        {
          ...field,
          choices: field.choices || [],
          showPrices,
          currency,
          onSelect,
          isSelected
        }
      );
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        SelectField,
        {
          ...field,
          choices: field.choices || [],
          showPrices,
          currency,
          onSelect,
          isSelected
        }
      );
    }
  }
  switch (field.type) {
    case "date":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DateField, { ...field, onSelect, isSelected });
    case "info":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(InfoSection, { ...field, onSelect, isSelected });
    case "section":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Section$2,
        {
          field,
          onSelect,
          renderChildren,
          isExpanded,
          onExpand: onExpand || (() => {
          }),
          onCollapse: onCollapse || (() => {
          })
        }
      );
    case "room_block":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        RoomingFieldPreview,
        {
          field,
          onSelect,
          isSelected
        }
      );
    case "session_booking":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        SessionFieldPreview,
        {
          field,
          onSelect,
          showPrices,
          currency,
          isSelected
        }
      );
    case "lead_scanner":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        LeadScannerFieldPreview,
        {
          field,
          onSelect,
          isSelected
        }
      );
    case "document":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DocumentField, { ...field, onSelect, isSelected });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        InputField,
        {
          ...field,
          onSelect,
          showPrice: showPrices,
          isSelected
        }
      );
  }
};
function flatFields(container) {
  if (container.fields) {
    const fields = [container];
    container.fields.forEach((f2) => {
      flatFields(f2).forEach((innerF) => {
        fields.push(innerF);
      });
    });
    return fields;
  } else {
    return [container];
  }
}
function containerToTreeItem(container, treeData) {
  const treeItem = {
    id: container.name,
    data: container
  };
  treeItem.hasChildren = true;
  treeItem.isExpanded = true;
  if (container.fields && container.fields.length > 0) {
    treeItem.children = container.fields.map((f2) => f2.name);
  } else {
    const placeholderId = `placeholder-${container.name}`;
    treeItem.children = [placeholderId];
    treeData.items[placeholderId] = {
      id: placeholderId,
      data: { type: "placeholder" }
    };
  }
  return treeItem;
}
function fieldToTreeItem(field, treeData) {
  if (field.type === "section" || field.type === "page") {
    return containerToTreeItem(field, treeData);
  }
  const treeItem = {
    id: field.name,
    data: field
  };
  if (field.fields) {
    treeItem.hasChildren = true;
    treeItem.children = field.fields.map((f2) => f2.name);
    treeItem.isExpanded = true;
  } else {
    treeItem.hasChildren = false;
  }
  return treeItem;
}
function pageToTree(page) {
  const treeData = {
    rootId: page.name,
    items: {}
  };
  flatFields(page).map((f2) => fieldToTreeItem(f2, treeData)).forEach((i) => {
    treeData.items[i.id] = i;
  });
  Object.values(treeData.items).forEach((item) => {
    if (item.hasChildren) {
      const lastChildName = item.children[item.children.length - 1];
      treeData.items[lastChildName].isLastChild = true;
    }
  });
  return treeData;
}
const FormPlaceholder = ({ provided }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { py: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: "t-field",
      ref: provided == null ? void 0 : provided.innerRef,
      ...provided == null ? void 0 : provided.draggableProps,
      style: {
        backgroundColor: "#fff"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ...provided == null ? void 0 : provided.dragHandleProps }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { align: "center", justify: "center", height: "100%", gap: "normal", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(DiffAddedIcon, { size: 24, fill: "gray" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { size: "medium", weight: "medium", color: "gray", children: "Simply drop form inputs here to create a new section" })
        ] })
      ]
    }
  ) });
};
const renderItemFactory = ({
  onSelect,
  showPrices,
  currency
}) => {
  const renderItem = ({
    item,
    onExpand,
    onCollapse,
    provided
  }) => {
    const draggableProps = {
      ...provided.draggableProps,
      style: {
        ...provided.draggableProps.style,
        paddingLeft: 0
      }
    };
    if (item.data.type === "placeholder") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormPlaceholder, { provided });
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Box,
        {
          ref: provided.innerRef,
          ...draggableProps,
          ...provided.dragHandleProps,
          onClick: () => onSelect(item.id),
          borderBottom: "1px solid",
          borderColor: "border.default",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            FieldListItem,
            {
              field: item.data,
              onSelect,
              renderChildren: false,
              isExpanded: item.isExpanded,
              showPrices,
              currency,
              onExpand,
              onCollapse
            }
          )
        }
      );
    }
  };
  return renderItem;
};
const simpleRenderItem = ({ item, provided }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ref: provided.innerRef,
      ...provided.draggableProps,
      ...provided.dragHandleProps,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: item.data.name })
    }
  );
};
const TreeFieldList = ({
  page,
  showPrices = false,
  currency = "$",
  onSelect,
  onMoveField,
  simple = false
}) => {
  const [tree, setTree] = useState(pageToTree(page));
  const [collapsedItems, setCollapsedItems] = useState(/* @__PURE__ */ new Set());
  useEffect(() => {
    let newTree = pageToTree(page);
    newTree = collapseItemsOnTree(newTree, collapsedItems);
    setTree(newTree);
  }, [page]);
  const collapseItemsOnTree = (tree2, collapsed) => {
    let newTree = tree2;
    Object.values(tree2.items).filter((i) => i.hasChildren).forEach((item) => {
      if (collapsed.has(item.id)) {
        newTree = mutateTree(newTree, item.id, { isExpanded: false });
      } else {
        newTree = mutateTree(newTree, item.id, { isExpanded: true });
      }
    });
    return newTree;
  };
  const handleDragEnd = (source, destination) => {
    if (!destination) {
      return;
    }
    const newTree = moveItemOnTree(tree, source, destination);
    setTree(newTree);
    onMoveField({
      field: tree.items[source.parentId].children[source.index],
      destination: destination.parentId,
      index: destination.index || 0
    });
  };
  const handleExpand = (itemId) => {
    collapsedItems.delete(itemId);
    setTree(collapseItemsOnTree(tree, collapsedItems));
    setCollapsedItems(collapsedItems);
  };
  const handleCollapse = (itemId) => {
    collapsedItems.add(itemId);
    setTree(collapseItemsOnTree(tree, collapsedItems));
    setCollapsedItems(collapsedItems);
  };
  const renderItem = simple ? simpleRenderItem : renderItemFactory({ onSelect, showPrices, currency });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "form-field-list", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tree,
    {
      tree,
      renderItem,
      isNestingEnabled: false,
      onDragEnd: handleDragEnd,
      onExpand: handleExpand,
      onCollapse: handleCollapse,
      isDragEnabled: true
    }
  ) });
};
const FieldListContainer = () => {
  const { form, formSettings, editorState, dispatch } = useRegForm();
  if (form.fields.length === 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { p: 4, children: "Add a page to get started" });
  }
  const { selectedPage } = getSelectedItems$1({ ...form, ...editorState });
  if (!selectedPage) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { p: 4, children: "Select a page to get started" });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TreeFieldList,
    {
      page: selectedPage,
      showPrices: formSettings.shoppingCartEnabled,
      currency: formSettings.shoppingCartCurrency,
      onSelect: (name2) => dispatch({ type: "select_field", name: String(name2) }),
      onMoveField: ({
        field,
        destination,
        index: index2
      }) => dispatch({
        type: "move_field",
        field,
        index: index2,
        destination
      })
    }
  );
};
const SCROLL_DELAY_MS = 100;
const SCROLL_EXTRA_SPACE = 200;
const scrollToNewField = (scrollContainer2, fieldElement) => {
  const containerRect = scrollContainer2.getBoundingClientRect();
  const fieldRect = fieldElement.getBoundingClientRect();
  const fieldBottom = fieldRect.bottom - containerRect.top + scrollContainer2.scrollTop;
  const containerHeight = containerRect.height;
  const targetScrollTop = fieldBottom - containerHeight + SCROLL_EXTRA_SPACE;
  const finalScrollTop = Math.max(0, targetScrollTop);
  scrollContainer2.scrollTo({
    top: finalScrollTop,
    behavior: "smooth"
  });
};
const CollaborativeFormEditorPrimer = ({
  ydoc: initialYdoc,
  currentUser,
  chat,
  onSave,
  onReset,
  onPreview,
  awarenessUsers,
  assistantEvents,
  ...settings
}) => {
  const formSettings = {
    ...defaultFormSettings,
    ...settings
  };
  const [{ ydoc, editorState: uiState }, dispatchWithoutUser] = useReducer(
    ydocFormReducer,
    {
      ydoc: initialYdoc,
      editorState: {
        selectedTab: "add"
      },
      formSettings
    }
  );
  const [changeHistory, setChangeHistory] = useState(
    getChangeHistory$1(ydoc)
  );
  const [, historyDispatch] = useReducer(ydocFormHistoryReducer, ydoc);
  const editorEndRef = useRef(null);
  const dispatch = (action) => dispatchWithoutUser({ ...action, user: currentUser });
  ydoc.on("update", () => {
    dispatch({ type: "update_ydoc", payload: { ydoc } });
    const changeHistory2 = getChangeHistory$1(ydoc);
    console.log("updating change history", changeHistory2);
    setChangeHistory(changeHistory2);
  });
  const fields = getFieldsAsTree(ydoc);
  useEffect(() => {
    if (fields.length > 0 && !uiState.selectedPageName) {
      dispatch({
        type: "select_page",
        name: fields[0].name,
        showEditor: false
      });
    }
  }, [fields.length > 0]);
  fields.find(
    (page) => page.name === uiState.selectedPageName
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormProvider,
    {
      form: { fields },
      formSettings,
      editorState: uiState,
      dispatch,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChangeHistoryProvider, { changeHistory, children: /* @__PURE__ */ jsxRuntimeExports.jsx(TrackUpdateProvider, { tracksLastUpdated: settings.tracksLastUpdated, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        SessionUpdateProvider,
        {
          sessionsLastUpdated: settings.sessionsLastUpdated,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChatProvider, { chat, assistantEvents, dispatch, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Box,
            {
              overflow: "hidden",
              height: "var(--available-height)",
              position: "relative",
              style: {
                contain: "layout style paint"
              },
              children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "horizontal", gap: "none", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { flex: 2 }, width: "100%", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  PageLayout,
                  {
                    rowGap: "none",
                    columnGap: "none",
                    padding: "none",
                    containerWidth: "full",
                    sx: { position: "relative", paddingTop: "56px", paddingRight: "480px" },
                    children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(PageLayout.Header, { sx: { position: "absolute", top: 0, width: "100%", zIndex: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                        StateBarV2,
                        {
                          dirty: ydocIsDirty$1(ydoc),
                          onlineEditors: awarenessUsers,
                          onSave: () => {
                            historyDispatch({
                              id: uuid(),
                              type: "save_form",
                              user: currentUser,
                              timestamp: (/* @__PURE__ */ new Date()).getTime()
                            });
                            onSave();
                          },
                          onReset: () => {
                            historyDispatch({
                              id: uuid(),
                              type: "reset_form",
                              user: currentUser,
                              timestamp: (/* @__PURE__ */ new Date()).getTime()
                            });
                            onReset();
                          },
                          onPreview: fields.length !== 0 ? () => onPreview(fields) : void 0,
                          onHistoryOpen: () => dispatch({ type: "select_tab", tab: "history" })
                        }
                      ) }),
                      /* @__PURE__ */ jsxRuntimeExports.jsxs(
                        PageLayout.Content,
                        {
                          className: "js-scrollContainer",
                          sx: {
                            overflow: "auto",
                            height: "var(--available-height)",
                            maxHeight: "var(--available-height)",
                            paddingBottom: "20px"
                          },
                          children: [
                            /* @__PURE__ */ jsxRuntimeExports.jsx(FieldListContainer, {}),
                            /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { height: 100 }),
                            /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ref: editorEndRef })
                          ]
                        }
                      ),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        PageLayout.Pane,
                        {
                          position: "start",
                          divider: "line",
                          resizable: true,
                          minWidth: 350,
                          sx: { bg: "canvas.inset", overflow: "auto", height: "var(--available-height)", maxHeight: "var(--available-height)", paddingBottom: "56px" },
                          children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarPrimer, {})
                        }
                      )
                    ]
                  }
                ) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  RightPanelPrimer,
                  {
                    onFieldAdded: () => {
                      const scrollContainer2 = document.querySelector(".js-scrollContainer");
                      if (scrollContainer2 && (editorEndRef == null ? void 0 : editorEndRef.current)) {
                        setTimeout(() => {
                          if (!editorEndRef.current) return;
                          scrollToNewField(scrollContainer2, editorEndRef.current);
                        }, SCROLL_DELAY_MS);
                      }
                    }
                  }
                ) })
              ] })
            }
          ) })
        }
      ) }) })
    }
  );
};
let EventEmitter$1 = class EventEmitter {
  constructor() {
    this.listeners = /* @__PURE__ */ new Map();
    this.anyListeners = /* @__PURE__ */ new Set();
  }
  on(event, handler) {
    let set2 = this.listeners.get(event);
    if (!set2) {
      set2 = /* @__PURE__ */ new Set();
      this.listeners.set(event, set2);
    }
    set2.add(handler);
    return () => this.off(event, handler);
  }
  off(event, handler) {
    const set2 = this.listeners.get(event);
    if (!set2) return;
    set2.delete(handler);
  }
  onAny(handler) {
    this.anyListeners.add(handler);
    return () => this.anyListeners.delete(handler);
  }
  emit(event, payload) {
    const set2 = this.listeners.get(event);
    if (set2) {
      for (const fn2 of set2) {
        try {
          fn2(payload);
        } catch (e) {
          console.error(`Error emitting event ${String(event)}:`, e);
        }
      }
    }
    for (const handler of this.anyListeners) {
      try {
        handler({ event, payload });
      } catch (e) {
        console.error(`Error in 'any' listener for ${String(event)}:`, e);
      }
    }
  }
};
const pageHasSections = (page) => {
  var _a3;
  return ((_a3 = page == null ? void 0 : page.sections) == null ? void 0 : _a3.length) > 0;
};
const pageHasLink = (page) => (page == null ? void 0 : page.href) !== void 0 && page.href !== "" && page.href !== null;
function PagesMenu$1({
  pages,
  pageIdProp = "id",
  pageLabelProp = "title",
  onSelectPage,
  onAddPage,
  onMovePage
}) {
  const handleDragEnd = (result) => {
    if (result.destination) {
      onMovePage(result.draggableId, result.destination.index);
    }
  };
  const handleAddPage = (e) => {
    e.preventDefault();
    onAddPage();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DragDropContext$1, { onDragEnd: handleDragEnd, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "menu-panel t-pages-menu", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("article", { className: "type-system-serif", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("header", { className: "txl cf", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "light mlc fl", children: "pages" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: "t-add-page button add light fr",
          onClick: handleAddPage,
          children: "Add Page"
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectedDroppable$1, { droppableId: "pagesMenu", children: (provided, snapshot) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "nav",
      {
        className: "form-page",
        ref: provided.innerRef,
        ...provided.droppableProps,
        children: [
          pages.map((page, index2) => {
            const pageId = page[pageIdProp];
            const label = page[pageLabelProp] || humanizeString(pageId.toString());
            return /* @__PURE__ */ jsxRuntimeExports.jsx(
              PublicDraggable,
              {
                draggableId: pageId.toString(),
                index: index2,
                children: (provided2, snapshot2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "li",
                  {
                    ref: provided2.innerRef,
                    ...provided2.draggableProps,
                    ...provided2.dragHandleProps,
                    onClick: (e) => onSelectPage(pageId),
                    className: classNames(
                      "t-page-item form-page-item editable",
                      {
                        external: pageHasLink(page)
                      }
                    ),
                    children: label
                  }
                )
              },
              pageId.toString()
            );
          }),
          provided.placeholder
        ]
      }
    ) })
  ] }) }) });
}
function InlineImage$1({ file }) {
  if (!!file.url) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("img", { alt: file.title, src: file.url });
  } else {
    return null;
  }
}
const getDownloadTitle = (file) => {
  if (file.title) {
    return file.title;
  } else {
    return file.fileName;
  }
};
function Download$1({ file }) {
  if (file.url && file.fileName) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "t-download ui-centered", children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { className: "button ghost", href: file.url, children: getDownloadTitle(file) }) });
  } else {
    return false;
  }
}
const renderMarkdown$1 = (section) => {
  return { __html: marked(section.content) };
};
const Section$1 = React__default.forwardRef(
  ({ section, useRichText = false, onSelect, onAddSection }, ref2) => {
    const style3 = {};
    const imageUrl = section.image && section.image.url;
    if (imageUrl) {
      style3.backgroundImage = "url('" + imageUrl + "')";
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        ref: ref2,
        style: style3,
        className: classNames("t-section", "ui-editor-row", {
          "with-bg": imageUrl
        }),
        onClick: onSelect,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ui-editor-row-inner", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("header", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "t-section-title", children: section.title }) }),
            section.inlineImage && /* @__PURE__ */ jsxRuntimeExports.jsx(InlineImage$1, { file: section.inlineImage }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                className: "content",
                dangerouslySetInnerHTML: useRichText && section.html !== void 0 && section.html !== null ? { __html: section.html } : renderMarkdown$1(section)
              }
            ),
            section.download && /* @__PURE__ */ jsxRuntimeExports.jsx(Download$1, { file: section.download })
          ] }),
          onAddSection && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ui-insert-section", children: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "t-insert-section", onClick: onAddSection, children: "Insert section below" }) })
        ]
      },
      section.id
    ) });
  }
);
const SPONSOR_SECTION_TYPE = "Microsite::SponsorshipSection";
const SPONSOR_STYLINGS = [
  "Listing",
  "Logo and name",
  "Medium logos",
  "Large logos"
];
const DEFAULT_SPONSOR_STYLING = 0;
const useSponsorTiers = () => {
  const { sponsors } = useAdminApi();
  return useQuery(
    ["sponsorTiers"],
    () => sponsors.getSponsorTiers()
  );
};
const ErrorMessage = ({ children }) => /* @__PURE__ */ jsxRuntimeExports.jsx("p", { style: { color: "red" }, children });
const getSponsorTier = (id, sponsorTiers) => sponsorTiers.find((s2) => idsEqual(id, s2.id));
const SponsorSection = ({
  section,
  sponsorTiers,
  onSelect,
  onAddSection
}) => {
  var _a3;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { onClick: onSelect, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ui-editor-row-inner", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("header", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "t-section-title", children: section.title }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
        "Sponsor tier:",
        " ",
        (_a3 = getSponsorTier(section.sponsorTierId, sponsorTiers)) == null ? void 0 : _a3.title
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
        "Style: ",
        SPONSOR_STYLINGS[section.styling]
      ] })
    ] }),
    onAddSection && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ui-insert-section", children: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "t-insert-section", onClick: onAddSection, children: "Insert section below" }) })
  ] }, section.id) });
};
const SponsorSectionContainer = (props) => {
  const { error: error2, data: sponsorTiers } = useSponsorTiers();
  if (error2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage, { children: "Error loading Sponsor Tiers" });
  }
  if (sponsorTiers === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {});
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SponsorSection, { sponsorTiers, ...props });
};
function PageEditor$1({
  page,
  selectedSection,
  useRichText = false,
  onSelectSection,
  onMoveSection,
  onAddSection
}) {
  const selectedSectionRef = useRef(null);
  useEffect(() => {
    var _a3;
    (_a3 = selectedSectionRef == null ? void 0 : selectedSectionRef.current) == null ? void 0 : _a3.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }, [selectedSection == null ? void 0 : selectedSection.id]);
  const handleDragEnd = (result) => {
    if (result.destination) {
      onMoveSection(result.draggableId, result.destination.index);
    }
  };
  const addSectionHandler = (section, index2) => {
    if (index2 === page.sections.length - 1) {
      return (e) => {
        e.preventDefault();
        onAddSection(section.id);
      };
    } else {
      return null;
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DragDropContext$1, { onDragEnd: handleDragEnd, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "form-panel t-page-editor", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("article", { className: "type-system-serif", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("header", { className: "txl cf", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { className: "t-page-title fl pll", children: [
        "page Editor / ",
        page.title
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "button info fr prn", children: " select section to edit " })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectedDroppable$1, { droppableId: "pagesEditor", children: (provided, snapshot) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ref: provided.innerRef, ...provided.droppableProps, children: [
      page.sections && page.sections.map((section, index2) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          PublicDraggable,
          {
            draggableId: section.id.toString(),
            index: index2,
            children: (provided2, snapshot2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                ref: provided2.innerRef,
                ...provided2.draggableProps,
                ...provided2.dragHandleProps,
                children: section.type === SPONSOR_SECTION_TYPE ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                  SponsorSectionContainer,
                  {
                    ref: section.id === (selectedSection == null ? void 0 : selectedSection.id) ? selectedSectionRef : null,
                    onSelect: () => onSelectSection(section.id),
                    onAddSection: addSectionHandler(section, index2),
                    section
                  }
                ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Section$1,
                  {
                    ref: section.id === (selectedSection == null ? void 0 : selectedSection.id) ? selectedSectionRef : null,
                    useRichText,
                    onSelect: (e) => onSelectSection(section.id),
                    onAddSection: addSectionHandler(section, index2),
                    section
                  }
                )
              }
            )
          },
          section.id.toString()
        );
      }),
      provided.placeholder
    ] }) })
  ] }) }) });
}
function UploadForm$1({
  file,
  fieldName,
  label,
  showTitleField,
  onChange,
  onTitleChange,
  onRemoveFile
}) {
  const htmlId = `id_${fieldName}_file`;
  const titleHtmlId = `id_${fieldName}_title`;
  let currentFileName;
  if (file) {
    if (file.uploading) {
      currentFileName = "Uploading: " + file.fileName + " ... ";
    } else {
      currentFileName = file.fileName;
    }
  }
  const handleFileChange = (e) => {
    const file2 = e.target.files[0];
    onChange(file2);
  };
  const handleTitleChange = (e) => {
    e.preventDefault();
    onTitleChange(e.target.value);
  };
  const handleRemoveFile = (e) => {
    e.preventDefault();
    onRemoveFile();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "file-editor", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: htmlId, children: label }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("strong", { children: [
        "Current ",
        label,
        ":"
      ] }),
      " ",
      currentFileName,
      file && /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          type: "button",
          onClick: handleRemoveFile,
          className: "t-remove-file danger",
          children: "x"
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        id: htmlId,
        className: "t-upload-file",
        disabled: file && file.uploading,
        type: "file",
        name: fieldName,
        onChange: handleFileChange
      },
      fieldName
    ),
    showTitleField && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { htmlFor: titleHtmlId, children: [
        label,
        " title"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          id: titleHtmlId,
          type: "text",
          name: `${fieldName}_title`,
          value: (file == null ? void 0 : file.title) || "",
          onChange: handleTitleChange
        }
      )
    ] })
  ] });
}
const MicrositeContext = createContext(
  void 0
);
const MicrositeEventContext = createContext(
  void 0
);
const MicrositeProvider = ({ children, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MicrositeContext.Provider, { value: props, children: /* @__PURE__ */ jsxRuntimeExports.jsx(QueryClientProvider, { client: new QueryClient(), children }) });
};
const MicrositeEventProvider = ({ children, ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MicrositeEventContext.Provider, { value: props, children });
};
const useMicrosite = () => useContext(MicrositeContext);
const useMicrositeEvent = () => useContext(MicrositeEventContext);
var MicrositeAccessLevel = /* @__PURE__ */ ((MicrositeAccessLevel2) => {
  MicrositeAccessLevel2[MicrositeAccessLevel2["unrestricted"] = 0] = "unrestricted";
  MicrositeAccessLevel2[MicrositeAccessLevel2["invitee"] = 1] = "invitee";
  MicrositeAccessLevel2[MicrositeAccessLevel2["attendee"] = 2] = "attendee";
  MicrositeAccessLevel2[MicrositeAccessLevel2["admin"] = 3] = "admin";
  MicrositeAccessLevel2[MicrositeAccessLevel2["eventPath"] = 4] = "eventPath";
  MicrositeAccessLevel2[MicrositeAccessLevel2["trackInvitee"] = 5] = "trackInvitee";
  MicrositeAccessLevel2[MicrositeAccessLevel2["trackAttendee"] = 6] = "trackAttendee";
  return MicrositeAccessLevel2;
})(MicrositeAccessLevel || {});
const EventPathCheckboxGroup$1 = ({
  availableEventPaths,
  eventPaths,
  onChange
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { fontWeight: "bold", children: "Event paths" }),
  eventPaths === void 0 || eventPaths.size === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { status: "warning", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon$1, {}),
    "Please select one or more event paths below"
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { status: "success", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon$1, {}),
    "Event paths selected"
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    CheckboxGroup$2,
    {
      value: eventPaths !== void 0 ? Array.from(eventPaths) : void 0,
      onChange,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", spacing: 4, children: availableEventPaths.sort().map((path2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$2, { value: path2, children: path2 }, path2)) })
    }
  )
] }) });
const TracksCheckboxGroup$1 = ({
  availableTracks,
  object,
  onChange
}) => {
  var _a3;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { fontWeight: "bold", children: "Tracks" }),
    object.trackIds === void 0 || object.trackIds.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { status: "warning", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon$1, {}),
      "Please select one or more tracks below"
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { status: "success", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon$1, {}),
      "Tracks selected"
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CheckboxGroup$2,
      {
        value: (_a3 = object.trackIds) == null ? void 0 : _a3.map((i) => i.toString()),
        onChange: (values2) => onChange(values2.map((v2) => Number(v2))),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", spacing: 4, children: availableTracks.map((track2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$2, { value: track2.id.toString(), children: track2.name }, track2.id)) })
      }
    )
  ] }) });
};
const getObjectEventPaths = (object) => object.metadata !== void 0 ? getMetaValues("EVENT_PATH", object.metadata) : void 0;
const metadataReplacingPageEventPath = (object, paths) => {
  if (object.metadata === void 0 && paths === void 0) {
    return void 0;
  }
  const metadataWithoutPath = object.metadata === void 0 ? [] : object.metadata.filter((tag2) => tag2.key !== "EVENT_PATH");
  if (paths === void 0) {
    return metadataWithoutPath;
  }
  return metadataWithoutPath.concat(
    Array.from(paths).map((path2) => ({ key: "EVENT_PATH", value: path2 }))
  );
};
const hasTrackSelect$1 = (level) => level === MicrositeAccessLevel.trackInvitee || level === MicrositeAccessLevel.trackAttendee;
const AccessForm$1 = ({
  object,
  availableEventPaths,
  availableTracks,
  onChange
}) => {
  const [level, setLevel] = useState(
    object.access || MicrositeAccessLevel.unrestricted
  );
  const [eventPaths, setEventPath] = useState(
    getObjectEventPaths(object)
  );
  const [trackIds, setTrackIds] = useState(
    object.trackIds
  );
  useEffect(() => {
    setLevel(object.access || MicrositeAccessLevel.unrestricted);
    setEventPath(getObjectEventPaths(object));
  }, [object.access, object.metadata]);
  useEffect(() => {
    return () => {
      if (level !== object.access) {
        setLevel(object.access || MicrositeAccessLevel.unrestricted);
        setEventPath(getObjectEventPaths(object));
        setTrackIds(object.trackIds);
      }
    };
  }, []);
  const handleLevelChange = (nextValue) => {
    const newLevel = Number(nextValue);
    setLevel(newLevel);
    if (newLevel !== MicrositeAccessLevel.eventPath) {
      if (!hasTrackSelect$1(newLevel)) {
        onChange({
          access: newLevel,
          metadata: metadataReplacingPageEventPath(object, void 0),
          trackIds: void 0
        });
      } else if (trackIds !== void 0) {
        onChange({
          access: newLevel,
          metadata: metadataReplacingPageEventPath(object, void 0),
          trackIds
        });
      }
    }
    if (newLevel !== MicrositeAccessLevel.eventPath) {
      setEventPath(void 0);
    }
    if (!hasTrackSelect$1(level)) {
      setTrackIds(void 0);
    }
  };
  const handleEventPathsChange = (values2) => {
    const newEventPaths = new Set(values2);
    setEventPath(newEventPaths);
    if (newEventPaths.size > 0) {
      onChange({
        access: level,
        metadata: metadataReplacingPageEventPath(object, newEventPaths),
        trackIds: void 0
      });
    }
  };
  const handleTracksChange = (newTrackIds) => {
    setTrackIds(newTrackIds);
    if (newTrackIds.length > 0) {
      onChange({
        access: level,
        metadata: metadataReplacingPageEventPath(object, eventPaths),
        trackIds: newTrackIds
      });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup$1, { value: level.toString(), onChange: handleLevelChange, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", pt: 2, pl: 3, pb: 10, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Radio$1,
        {
          size: "sm",
          style: { textTransform: "none" },
          value: MicrositeAccessLevel.unrestricted.toString(),
          children: "Unrestricted"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Radio$1,
        {
          size: "sm",
          style: { textTransform: "none" },
          value: MicrositeAccessLevel.invitee.toString(),
          children: "Invited users and attendees only"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Radio$1,
        {
          size: "sm",
          style: { textTransform: "none" },
          value: MicrositeAccessLevel.attendee.toString(),
          children: "Attendees only"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Radio$1,
        {
          size: "sm",
          style: { textTransform: "none" },
          value: MicrositeAccessLevel.admin.toString(),
          children: "Admins only (preview mode)"
        }
      ),
      availableEventPaths !== void 0 && availableEventPaths.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Radio$1,
        {
          size: "sm",
          style: { textTransform: "none" },
          value: MicrositeAccessLevel.eventPath.toString(),
          children: "Attendees with selected event path only"
        }
      ),
      availableTracks !== void 0 && availableTracks.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Radio$1,
          {
            size: "sm",
            style: { textTransform: "none" },
            value: MicrositeAccessLevel.trackInvitee.toString(),
            children: "Users invited to or registered for selected tracks only."
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Radio$1,
          {
            size: "sm",
            style: { textTransform: "none" },
            value: MicrositeAccessLevel.trackAttendee.toString(),
            children: "Users registered for selected tracks only."
          }
        )
      ] })
    ] }) }),
    availableEventPaths !== void 0 && (availableEventPaths == null ? void 0 : availableEventPaths.length) > 0 && level === MicrositeAccessLevel.eventPath && /* @__PURE__ */ jsxRuntimeExports.jsx(
      EventPathCheckboxGroup$1,
      {
        availableEventPaths,
        eventPaths,
        onChange: handleEventPathsChange
      }
    ),
    availableTracks !== void 0 && availableTracks.length > 0 && hasTrackSelect$1(level) && /* @__PURE__ */ jsxRuntimeExports.jsx(
      TracksCheckboxGroup$1,
      {
        availableTracks,
        object,
        onChange: handleTracksChange
      }
    )
  ] });
};
const AccessFormContainer = ({
  object,
  onChange
}) => {
  const { eventPaths, tracks } = useMicrositeEvent();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    AccessForm$1,
    {
      object,
      onChange,
      availableEventPaths: eventPaths,
      availableTracks: tracks
    }
  );
};
const EventPathCheckboxGroup = ({
  availableEventPaths,
  eventPaths,
  onChange
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { fontWeight: "bold", children: "Event paths" }),
  eventPaths === void 0 || eventPaths.size === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { status: "warning", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon$1, {}),
    "Please select one or more event paths below"
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { status: "success", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon$1, {}),
    "Event paths selected"
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    CheckboxGroup$2,
    {
      value: eventPaths !== void 0 ? Array.from(eventPaths) : void 0,
      onChange,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", spacing: 4, children: availableEventPaths.sort().map((path2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$2, { value: path2, children: path2 }, path2)) })
    }
  )
] }) });
const TracksCheckboxGroup = ({
  availableTracks,
  object,
  onChange
}) => {
  var _a3;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { fontWeight: "bold", children: "Tracks" }),
    object.trackIds === void 0 || object.trackIds.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { status: "warning", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon$1, {}),
      "Please select one or more tracks below"
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { status: "success", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon$1, {}),
      "Tracks selected"
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CheckboxGroup$2,
      {
        value: (_a3 = object.trackIds) == null ? void 0 : _a3.map((i) => i.toString()),
        onChange: (values2) => onChange(values2.map((v2) => Number(v2))),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", spacing: 4, children: availableTracks.map((track2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$2, { value: track2.id.toString(), children: track2.name }, track2.id)) })
      }
    )
  ] }) });
};
const hasTrackSelect = (level) => level === MicrositeAccessLevel.trackInvitee || level === MicrositeAccessLevel.trackAttendee;
const AccessForm = ({
  object,
  availableEventPaths,
  availableTracks,
  onChange
}) => {
  const [level, setLevel] = useState(
    object.access || MicrositeAccessLevel.unrestricted
  );
  const [eventPaths, setEventPath] = useState(
    getObjectEventPaths(object)
  );
  const [trackIds, setTrackIds] = useState(
    object.trackIds
  );
  useEffect(() => {
    setLevel(object.access || MicrositeAccessLevel.unrestricted);
    setEventPath(getObjectEventPaths(object));
  }, [object.access, object.metadata]);
  useEffect(() => {
    return () => {
      if (level !== object.access) {
        setLevel(object.access || MicrositeAccessLevel.unrestricted);
        setEventPath(getObjectEventPaths(object));
        setTrackIds(object.trackIds);
      }
    };
  }, []);
  const handleLevelChange = (nextValue) => {
    const newLevel = Number(nextValue);
    setLevel(newLevel);
    if (newLevel !== MicrositeAccessLevel.eventPath) {
      if (!hasTrackSelect(newLevel)) {
        onChange({
          access: newLevel,
          metadata: metadataReplacingPageEventPath(object, void 0),
          trackIds: void 0
        });
      } else if (trackIds !== void 0) {
        onChange({
          access: newLevel,
          metadata: metadataReplacingPageEventPath(object, void 0),
          trackIds
        });
      }
    }
    if (newLevel !== MicrositeAccessLevel.eventPath) {
      setEventPath(void 0);
    }
    if (!hasTrackSelect(level)) {
      setTrackIds(void 0);
    }
  };
  const handleEventPathsChange = (values2) => {
    const newEventPaths = new Set(values2);
    setEventPath(newEventPaths);
    if (newEventPaths.size > 0) {
      onChange({
        access: level,
        metadata: metadataReplacingPageEventPath(object, newEventPaths),
        trackIds: void 0
      });
    }
  };
  const handleTracksChange = (newTrackIds) => {
    setTrackIds(newTrackIds);
    if (newTrackIds.length > 0) {
      onChange({
        access: level,
        metadata: metadataReplacingPageEventPath(object, eventPaths),
        trackIds: newTrackIds
      });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup$1, { value: level.toString(), onChange: handleLevelChange, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", pt: 2, pl: 3, pb: 10, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Radio$1,
        {
          size: "sm",
          style: { textTransform: "none" },
          value: MicrositeAccessLevel.unrestricted.toString(),
          children: "Unrestricted"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Radio$1,
        {
          size: "sm",
          style: { textTransform: "none" },
          value: MicrositeAccessLevel.invitee.toString(),
          children: "Invited users and attendees only"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Radio$1,
        {
          size: "sm",
          style: { textTransform: "none" },
          value: MicrositeAccessLevel.attendee.toString(),
          children: "Attendees only"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Radio$1,
        {
          size: "sm",
          style: { textTransform: "none" },
          value: MicrositeAccessLevel.admin.toString(),
          children: "Admins only (preview mode)"
        }
      ),
      availableEventPaths !== void 0 && availableEventPaths.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Radio$1,
        {
          size: "sm",
          style: { textTransform: "none" },
          value: MicrositeAccessLevel.eventPath.toString(),
          children: "Attendees with selected event path only"
        }
      ),
      availableTracks !== void 0 && availableTracks.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Radio$1,
          {
            size: "sm",
            style: { textTransform: "none" },
            value: MicrositeAccessLevel.trackInvitee.toString(),
            children: "Users invited to or registered for selected tracks only."
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Radio$1,
          {
            size: "sm",
            style: { textTransform: "none" },
            value: MicrositeAccessLevel.trackAttendee.toString(),
            children: "Users registered for selected tracks only."
          }
        )
      ] })
    ] }) }),
    availableEventPaths !== void 0 && (availableEventPaths == null ? void 0 : availableEventPaths.length) > 0 && level === MicrositeAccessLevel.eventPath && /* @__PURE__ */ jsxRuntimeExports.jsx(
      EventPathCheckboxGroup,
      {
        availableEventPaths,
        eventPaths,
        onChange: handleEventPathsChange
      }
    ),
    availableTracks !== void 0 && availableTracks.length > 0 && hasTrackSelect(level) && /* @__PURE__ */ jsxRuntimeExports.jsx(
      TracksCheckboxGroup,
      {
        availableTracks,
        object,
        onChange: handleTracksChange
      }
    )
  ] });
};
function OrderedMap(content2) {
  this.content = content2;
}
OrderedMap.prototype = {
  constructor: OrderedMap,
  find: function(key2) {
    for (var i = 0; i < this.content.length; i += 2)
      if (this.content[i] === key2) return i;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(key2) {
    var found2 = this.find(key2);
    return found2 == -1 ? void 0 : this.content[found2 + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(key2, value, newKey) {
    var self2 = newKey && newKey != key2 ? this.remove(newKey) : this;
    var found2 = self2.find(key2), content2 = self2.content.slice();
    if (found2 == -1) {
      content2.push(newKey || key2, value);
    } else {
      content2[found2 + 1] = value;
      if (newKey) content2[found2] = newKey;
    }
    return new OrderedMap(content2);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(key2) {
    var found2 = this.find(key2);
    if (found2 == -1) return this;
    var content2 = this.content.slice();
    content2.splice(found2, 2);
    return new OrderedMap(content2);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(key2, value) {
    return new OrderedMap([key2, value].concat(this.remove(key2).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(key2, value) {
    var content2 = this.remove(key2).content.slice();
    content2.push(key2, value);
    return new OrderedMap(content2);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(place, key2, value) {
    var without = this.remove(key2), content2 = without.content.slice();
    var found2 = without.find(place);
    content2.splice(found2 == -1 ? content2.length : found2, 0, key2, value);
    return new OrderedMap(content2);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(f2) {
    for (var i = 0; i < this.content.length; i += 2)
      f2(this.content[i], this.content[i + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(map3) {
    map3 = OrderedMap.from(map3);
    if (!map3.size) return this;
    return new OrderedMap(map3.content.concat(this.subtract(map3).content));
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(map3) {
    map3 = OrderedMap.from(map3);
    if (!map3.size) return this;
    return new OrderedMap(this.subtract(map3).content.concat(map3.content));
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(map3) {
    var result = this;
    map3 = OrderedMap.from(map3);
    for (var i = 0; i < map3.content.length; i += 2)
      result = result.remove(map3.content[i]);
    return result;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var result = {};
    this.forEach(function(key2, value) {
      result[key2] = value;
    });
    return result;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
OrderedMap.from = function(value) {
  if (value instanceof OrderedMap) return value;
  var content2 = [];
  if (value) for (var prop in value) content2.push(prop, value[prop]);
  return new OrderedMap(content2);
};
function findDiffStart(a2, b2, pos) {
  for (let i = 0; ; i++) {
    if (i == a2.childCount || i == b2.childCount)
      return a2.childCount == b2.childCount ? null : pos;
    let childA = a2.child(i), childB = b2.child(i);
    if (childA == childB) {
      pos += childA.nodeSize;
      continue;
    }
    if (!childA.sameMarkup(childB))
      return pos;
    if (childA.isText && childA.text != childB.text) {
      for (let j2 = 0; childA.text[j2] == childB.text[j2]; j2++)
        pos++;
      return pos;
    }
    if (childA.content.size || childB.content.size) {
      let inner = findDiffStart(childA.content, childB.content, pos + 1);
      if (inner != null)
        return inner;
    }
    pos += childA.nodeSize;
  }
}
function findDiffEnd(a2, b2, posA, posB) {
  for (let iA = a2.childCount, iB = b2.childCount; ; ) {
    if (iA == 0 || iB == 0)
      return iA == iB ? null : { a: posA, b: posB };
    let childA = a2.child(--iA), childB = b2.child(--iB), size2 = childA.nodeSize;
    if (childA == childB) {
      posA -= size2;
      posB -= size2;
      continue;
    }
    if (!childA.sameMarkup(childB))
      return { a: posA, b: posB };
    if (childA.isText && childA.text != childB.text) {
      let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
      while (same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]) {
        same++;
        posA--;
        posB--;
      }
      return { a: posA, b: posB };
    }
    if (childA.content.size || childB.content.size) {
      let inner = findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
      if (inner)
        return inner;
    }
    posA -= size2;
    posB -= size2;
  }
}
class Fragment {
  /**
  @internal
  */
  constructor(content2, size2) {
    this.content = content2;
    this.size = size2 || 0;
    if (size2 == null)
      for (let i = 0; i < content2.length; i++)
        this.size += content2[i].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(from3, to2, f2, nodeStart = 0, parent2) {
    for (let i = 0, pos = 0; pos < to2; i++) {
      let child = this.content[i], end2 = pos + child.nodeSize;
      if (end2 > from3 && f2(child, nodeStart + pos, parent2 || null, i) !== false && child.content.size) {
        let start4 = pos + 1;
        child.nodesBetween(Math.max(0, from3 - start4), Math.min(child.content.size, to2 - start4), f2, nodeStart + start4);
      }
      pos = end2;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(f2) {
    this.nodesBetween(0, this.size, f2);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(from3, to2, blockSeparator, leafText) {
    let text2 = "", first2 = true;
    this.nodesBetween(from3, to2, (node2, pos) => {
      let nodeText = node2.isText ? node2.text.slice(Math.max(from3, pos) - pos, to2 - pos) : !node2.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node2) : leafText : node2.type.spec.leafText ? node2.type.spec.leafText(node2) : "";
      if (node2.isBlock && (node2.isLeaf && nodeText || node2.isTextblock) && blockSeparator) {
        if (first2)
          first2 = false;
        else
          text2 += blockSeparator;
      }
      text2 += nodeText;
    }, 0);
    return text2;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(other2) {
    if (!other2.size)
      return this;
    if (!this.size)
      return other2;
    let last = this.lastChild, first2 = other2.firstChild, content2 = this.content.slice(), i = 0;
    if (last.isText && last.sameMarkup(first2)) {
      content2[content2.length - 1] = last.withText(last.text + first2.text);
      i = 1;
    }
    for (; i < other2.content.length; i++)
      content2.push(other2.content[i]);
    return new Fragment(content2, this.size + other2.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(from3, to2 = this.size) {
    if (from3 == 0 && to2 == this.size)
      return this;
    let result = [], size2 = 0;
    if (to2 > from3)
      for (let i = 0, pos = 0; pos < to2; i++) {
        let child = this.content[i], end2 = pos + child.nodeSize;
        if (end2 > from3) {
          if (pos < from3 || end2 > to2) {
            if (child.isText)
              child = child.cut(Math.max(0, from3 - pos), Math.min(child.text.length, to2 - pos));
            else
              child = child.cut(Math.max(0, from3 - pos - 1), Math.min(child.content.size, to2 - pos - 1));
          }
          result.push(child);
          size2 += child.nodeSize;
        }
        pos = end2;
      }
    return new Fragment(result, size2);
  }
  /**
  @internal
  */
  cutByIndex(from3, to2) {
    if (from3 == to2)
      return Fragment.empty;
    if (from3 == 0 && to2 == this.content.length)
      return this;
    return new Fragment(this.content.slice(from3, to2));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(index2, node2) {
    let current = this.content[index2];
    if (current == node2)
      return this;
    let copy2 = this.content.slice();
    let size2 = this.size + node2.nodeSize - current.nodeSize;
    copy2[index2] = node2;
    return new Fragment(copy2, size2);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(node2) {
    return new Fragment([node2].concat(this.content), this.size + node2.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(node2) {
    return new Fragment(this.content.concat(node2), this.size + node2.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(other2) {
    if (this.content.length != other2.content.length)
      return false;
    for (let i = 0; i < this.content.length; i++)
      if (!this.content[i].eq(other2.content[i]))
        return false;
    return true;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(index2) {
    let found2 = this.content[index2];
    if (!found2)
      throw new RangeError("Index " + index2 + " out of range for " + this);
    return found2;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(index2) {
    return this.content[index2] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(f2) {
    for (let i = 0, p2 = 0; i < this.content.length; i++) {
      let child = this.content[i];
      f2(child, p2, i);
      p2 += child.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(other2, pos = 0) {
    return findDiffStart(this, other2, pos);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(other2, pos = this.size, otherPos = other2.size) {
    return findDiffEnd(this, other2, pos, otherPos);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(pos) {
    if (pos == 0)
      return retIndex(0, pos);
    if (pos == this.size)
      return retIndex(this.content.length, pos);
    if (pos > this.size || pos < 0)
      throw new RangeError(`Position ${pos} outside of fragment (${this})`);
    for (let i = 0, curPos = 0; ; i++) {
      let cur = this.child(i), end2 = curPos + cur.nodeSize;
      if (end2 >= pos) {
        if (end2 == pos)
          return retIndex(i + 1, end2);
        return retIndex(i, curPos);
      }
      curPos = end2;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((n2) => n2.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(schema, value) {
    if (!value)
      return Fragment.empty;
    if (!Array.isArray(value))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new Fragment(value.map(schema.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(array) {
    if (!array.length)
      return Fragment.empty;
    let joined, size2 = 0;
    for (let i = 0; i < array.length; i++) {
      let node2 = array[i];
      size2 += node2.nodeSize;
      if (i && node2.isText && array[i - 1].sameMarkup(node2)) {
        if (!joined)
          joined = array.slice(0, i);
        joined[joined.length - 1] = node2.withText(joined[joined.length - 1].text + node2.text);
      } else if (joined) {
        joined.push(node2);
      }
    }
    return new Fragment(joined || array, size2);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(nodes) {
    if (!nodes)
      return Fragment.empty;
    if (nodes instanceof Fragment)
      return nodes;
    if (Array.isArray(nodes))
      return this.fromArray(nodes);
    if (nodes.attrs)
      return new Fragment([nodes], nodes.nodeSize);
    throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
Fragment.empty = new Fragment([], 0);
const found = { index: 0, offset: 0 };
function retIndex(index2, offset3) {
  found.index = index2;
  found.offset = offset3;
  return found;
}
function compareDeep(a2, b2) {
  if (a2 === b2)
    return true;
  if (!(a2 && typeof a2 == "object") || !(b2 && typeof b2 == "object"))
    return false;
  let array = Array.isArray(a2);
  if (Array.isArray(b2) != array)
    return false;
  if (array) {
    if (a2.length != b2.length)
      return false;
    for (let i = 0; i < a2.length; i++)
      if (!compareDeep(a2[i], b2[i]))
        return false;
  } else {
    for (let p2 in a2)
      if (!(p2 in b2) || !compareDeep(a2[p2], b2[p2]))
        return false;
    for (let p2 in b2)
      if (!(p2 in a2))
        return false;
  }
  return true;
}
let Mark$1 = class Mark {
  /**
  @internal
  */
  constructor(type, attrs) {
    this.type = type;
    this.attrs = attrs;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(set2) {
    let copy2, placed = false;
    for (let i = 0; i < set2.length; i++) {
      let other2 = set2[i];
      if (this.eq(other2))
        return set2;
      if (this.type.excludes(other2.type)) {
        if (!copy2)
          copy2 = set2.slice(0, i);
      } else if (other2.type.excludes(this.type)) {
        return set2;
      } else {
        if (!placed && other2.type.rank > this.type.rank) {
          if (!copy2)
            copy2 = set2.slice(0, i);
          copy2.push(this);
          placed = true;
        }
        if (copy2)
          copy2.push(other2);
      }
    }
    if (!copy2)
      copy2 = set2.slice();
    if (!placed)
      copy2.push(this);
    return copy2;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(set2) {
    for (let i = 0; i < set2.length; i++)
      if (this.eq(set2[i]))
        return set2.slice(0, i).concat(set2.slice(i + 1));
    return set2;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(set2) {
    for (let i = 0; i < set2.length; i++)
      if (this.eq(set2[i]))
        return true;
    return false;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(other2) {
    return this == other2 || this.type == other2.type && compareDeep(this.attrs, other2.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let obj = { type: this.type.name };
    for (let _2 in this.attrs) {
      obj.attrs = this.attrs;
      break;
    }
    return obj;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(schema, json) {
    if (!json)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let type = schema.marks[json.type];
    if (!type)
      throw new RangeError(`There is no mark type ${json.type} in this schema`);
    let mark2 = type.create(json.attrs);
    type.checkAttrs(mark2.attrs);
    return mark2;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(a2, b2) {
    if (a2 == b2)
      return true;
    if (a2.length != b2.length)
      return false;
    for (let i = 0; i < a2.length; i++)
      if (!a2[i].eq(b2[i]))
        return false;
    return true;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(marks) {
    if (!marks || Array.isArray(marks) && marks.length == 0)
      return Mark.none;
    if (marks instanceof Mark)
      return [marks];
    let copy2 = marks.slice();
    copy2.sort((a2, b2) => a2.type.rank - b2.type.rank);
    return copy2;
  }
};
Mark$1.none = [];
class ReplaceError extends Error {
}
class Slice {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(content2, openStart, openEnd) {
    this.content = content2;
    this.openStart = openStart;
    this.openEnd = openEnd;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(pos, fragment) {
    let content2 = insertInto(this.content, pos + this.openStart, fragment);
    return content2 && new Slice(content2, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(from3, to2) {
    return new Slice(removeRange(this.content, from3 + this.openStart, to2 + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(other2) {
    return this.content.eq(other2.content) && this.openStart == other2.openStart && this.openEnd == other2.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let json = { content: this.content.toJSON() };
    if (this.openStart > 0)
      json.openStart = this.openStart;
    if (this.openEnd > 0)
      json.openEnd = this.openEnd;
    return json;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(schema, json) {
    if (!json)
      return Slice.empty;
    let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
    if (typeof openStart != "number" || typeof openEnd != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new Slice(Fragment.fromJSON(schema, json.content), openStart, openEnd);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(fragment, openIsolating = true) {
    let openStart = 0, openEnd = 0;
    for (let n2 = fragment.firstChild; n2 && !n2.isLeaf && (openIsolating || !n2.type.spec.isolating); n2 = n2.firstChild)
      openStart++;
    for (let n2 = fragment.lastChild; n2 && !n2.isLeaf && (openIsolating || !n2.type.spec.isolating); n2 = n2.lastChild)
      openEnd++;
    return new Slice(fragment, openStart, openEnd);
  }
}
Slice.empty = new Slice(Fragment.empty, 0, 0);
function removeRange(content2, from3, to2) {
  let { index: index2, offset: offset3 } = content2.findIndex(from3), child = content2.maybeChild(index2);
  let { index: indexTo, offset: offsetTo } = content2.findIndex(to2);
  if (offset3 == from3 || child.isText) {
    if (offsetTo != to2 && !content2.child(indexTo).isText)
      throw new RangeError("Removing non-flat range");
    return content2.cut(0, from3).append(content2.cut(to2));
  }
  if (index2 != indexTo)
    throw new RangeError("Removing non-flat range");
  return content2.replaceChild(index2, child.copy(removeRange(child.content, from3 - offset3 - 1, to2 - offset3 - 1)));
}
function insertInto(content2, dist2, insert2, parent2) {
  let { index: index2, offset: offset3 } = content2.findIndex(dist2), child = content2.maybeChild(index2);
  if (offset3 == dist2 || child.isText) {
    return content2.cut(0, dist2).append(insert2).append(content2.cut(dist2));
  }
  let inner = insertInto(child.content, dist2 - offset3 - 1, insert2);
  return inner && content2.replaceChild(index2, child.copy(inner));
}
function replace($from, $to, slice3) {
  if (slice3.openStart > $from.depth)
    throw new ReplaceError("Inserted content deeper than insertion position");
  if ($from.depth - slice3.openStart != $to.depth - slice3.openEnd)
    throw new ReplaceError("Inconsistent open depths");
  return replaceOuter($from, $to, slice3, 0);
}
function replaceOuter($from, $to, slice3, depth) {
  let index2 = $from.index(depth), node2 = $from.node(depth);
  if (index2 == $to.index(depth) && depth < $from.depth - slice3.openStart) {
    let inner = replaceOuter($from, $to, slice3, depth + 1);
    return node2.copy(node2.content.replaceChild(index2, inner));
  } else if (!slice3.content.size) {
    return close(node2, replaceTwoWay($from, $to, depth));
  } else if (!slice3.openStart && !slice3.openEnd && $from.depth == depth && $to.depth == depth) {
    let parent2 = $from.parent, content2 = parent2.content;
    return close(parent2, content2.cut(0, $from.parentOffset).append(slice3.content).append(content2.cut($to.parentOffset)));
  } else {
    let { start: start4, end: end2 } = prepareSliceForReplace(slice3, $from);
    return close(node2, replaceThreeWay($from, start4, end2, $to, depth));
  }
}
function checkJoin(main, sub) {
  if (!sub.type.compatibleContent(main.type))
    throw new ReplaceError("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function joinable$1($before, $after, depth) {
  let node2 = $before.node(depth);
  checkJoin(node2, $after.node(depth));
  return node2;
}
function addNode(child, target) {
  let last = target.length - 1;
  if (last >= 0 && child.isText && child.sameMarkup(target[last]))
    target[last] = child.withText(target[last].text + child.text);
  else
    target.push(child);
}
function addRange($start, $end, depth, target) {
  let node2 = ($end || $start).node(depth);
  let startIndex = 0, endIndex = $end ? $end.index(depth) : node2.childCount;
  if ($start) {
    startIndex = $start.index(depth);
    if ($start.depth > depth) {
      startIndex++;
    } else if ($start.textOffset) {
      addNode($start.nodeAfter, target);
      startIndex++;
    }
  }
  for (let i = startIndex; i < endIndex; i++)
    addNode(node2.child(i), target);
  if ($end && $end.depth == depth && $end.textOffset)
    addNode($end.nodeBefore, target);
}
function close(node2, content2) {
  node2.type.checkContent(content2);
  return node2.copy(content2);
}
function replaceThreeWay($from, $start, $end, $to, depth) {
  let openStart = $from.depth > depth && joinable$1($from, $start, depth + 1);
  let openEnd = $to.depth > depth && joinable$1($end, $to, depth + 1);
  let content2 = [];
  addRange(null, $from, depth, content2);
  if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
    checkJoin(openStart, openEnd);
    addNode(close(openStart, replaceThreeWay($from, $start, $end, $to, depth + 1)), content2);
  } else {
    if (openStart)
      addNode(close(openStart, replaceTwoWay($from, $start, depth + 1)), content2);
    addRange($start, $end, depth, content2);
    if (openEnd)
      addNode(close(openEnd, replaceTwoWay($end, $to, depth + 1)), content2);
  }
  addRange($to, null, depth, content2);
  return new Fragment(content2);
}
function replaceTwoWay($from, $to, depth) {
  let content2 = [];
  addRange(null, $from, depth, content2);
  if ($from.depth > depth) {
    let type = joinable$1($from, $to, depth + 1);
    addNode(close(type, replaceTwoWay($from, $to, depth + 1)), content2);
  }
  addRange($to, null, depth, content2);
  return new Fragment(content2);
}
function prepareSliceForReplace(slice3, $along) {
  let extra = $along.depth - slice3.openStart, parent2 = $along.node(extra);
  let node2 = parent2.copy(slice3.content);
  for (let i = extra - 1; i >= 0; i--)
    node2 = $along.node(i).copy(Fragment.from(node2));
  return {
    start: node2.resolveNoCache(slice3.openStart + extra),
    end: node2.resolveNoCache(node2.content.size - slice3.openEnd - extra)
  };
}
class ResolvedPos {
  /**
  @internal
  */
  constructor(pos, path2, parentOffset) {
    this.pos = pos;
    this.path = path2;
    this.parentOffset = parentOffset;
    this.depth = path2.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(val) {
    if (val == null)
      return this.depth;
    if (val < 0)
      return this.depth + val;
    return val;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(depth) {
    return this.path[this.resolveDepth(depth) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(depth) {
    return this.path[this.resolveDepth(depth) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(depth) {
    depth = this.resolveDepth(depth);
    return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(depth) {
    depth = this.resolveDepth(depth);
    return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(depth) {
    depth = this.resolveDepth(depth);
    return this.start(depth) + this.node(depth).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(depth) {
    depth = this.resolveDepth(depth);
    if (!depth)
      throw new RangeError("There is no position before the top-level node");
    return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(depth) {
    depth = this.resolveDepth(depth);
    if (!depth)
      throw new RangeError("There is no position after the top-level node");
    return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let parent2 = this.parent, index2 = this.index(this.depth);
    if (index2 == parent2.childCount)
      return null;
    let dOff = this.pos - this.path[this.path.length - 1], child = parent2.child(index2);
    return dOff ? parent2.child(index2).cut(dOff) : child;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let index2 = this.index(this.depth);
    let dOff = this.pos - this.path[this.path.length - 1];
    if (dOff)
      return this.parent.child(index2).cut(0, dOff);
    return index2 == 0 ? null : this.parent.child(index2 - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(index2, depth) {
    depth = this.resolveDepth(depth);
    let node2 = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    for (let i = 0; i < index2; i++)
      pos += node2.child(i).nodeSize;
    return pos;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let parent2 = this.parent, index2 = this.index();
    if (parent2.content.size == 0)
      return Mark$1.none;
    if (this.textOffset)
      return parent2.child(index2).marks;
    let main = parent2.maybeChild(index2 - 1), other2 = parent2.maybeChild(index2);
    if (!main) {
      let tmp = main;
      main = other2;
      other2 = tmp;
    }
    let marks = main.marks;
    for (var i = 0; i < marks.length; i++)
      if (marks[i].type.spec.inclusive === false && (!other2 || !marks[i].isInSet(other2.marks)))
        marks = marks[i--].removeFromSet(marks);
    return marks;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross($end) {
    let after = this.parent.maybeChild(this.index());
    if (!after || !after.isInline)
      return null;
    let marks = after.marks, next2 = $end.parent.maybeChild($end.index());
    for (var i = 0; i < marks.length; i++)
      if (marks[i].type.spec.inclusive === false && (!next2 || !marks[i].isInSet(next2.marks)))
        marks = marks[i--].removeFromSet(marks);
    return marks;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(pos) {
    for (let depth = this.depth; depth > 0; depth--)
      if (this.start(depth) <= pos && this.end(depth) >= pos)
        return depth;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(other2 = this, pred) {
    if (other2.pos < this.pos)
      return other2.blockRange(this);
    for (let d2 = this.depth - (this.parent.inlineContent || this.pos == other2.pos ? 1 : 0); d2 >= 0; d2--)
      if (other2.pos <= this.end(d2) && (!pred || pred(this.node(d2))))
        return new NodeRange(this, other2, d2);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(other2) {
    return this.pos - this.parentOffset == other2.pos - other2.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(other2) {
    return other2.pos > this.pos ? other2 : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(other2) {
    return other2.pos < this.pos ? other2 : this;
  }
  /**
  @internal
  */
  toString() {
    let str = "";
    for (let i = 1; i <= this.depth; i++)
      str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
    return str + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(doc2, pos) {
    if (!(pos >= 0 && pos <= doc2.content.size))
      throw new RangeError("Position " + pos + " out of range");
    let path2 = [];
    let start4 = 0, parentOffset = pos;
    for (let node2 = doc2; ; ) {
      let { index: index2, offset: offset3 } = node2.content.findIndex(parentOffset);
      let rem = parentOffset - offset3;
      path2.push(node2, index2, start4 + offset3);
      if (!rem)
        break;
      node2 = node2.child(index2);
      if (node2.isText)
        break;
      parentOffset = rem - 1;
      start4 += offset3 + 1;
    }
    return new ResolvedPos(pos, path2, parentOffset);
  }
  /**
  @internal
  */
  static resolveCached(doc2, pos) {
    let cache = resolveCache.get(doc2);
    if (cache) {
      for (let i = 0; i < cache.elts.length; i++) {
        let elt = cache.elts[i];
        if (elt.pos == pos)
          return elt;
      }
    } else {
      resolveCache.set(doc2, cache = new ResolveCache());
    }
    let result = cache.elts[cache.i] = ResolvedPos.resolve(doc2, pos);
    cache.i = (cache.i + 1) % resolveCacheSize;
    return result;
  }
}
class ResolveCache {
  constructor() {
    this.elts = [];
    this.i = 0;
  }
}
const resolveCacheSize = 12, resolveCache = /* @__PURE__ */ new WeakMap();
class NodeRange {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor($from, $to, depth) {
    this.$from = $from;
    this.$to = $to;
    this.depth = depth;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const emptyAttrs = /* @__PURE__ */ Object.create(null);
let Node$2 = class Node2 {
  /**
  @internal
  */
  constructor(type, attrs, content2, marks = Mark$1.none) {
    this.type = type;
    this.attrs = attrs;
    this.marks = marks;
    this.content = content2 || Fragment.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(index2) {
    return this.content.child(index2);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(index2) {
    return this.content.maybeChild(index2);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(f2) {
    this.content.forEach(f2);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(from3, to2, f2, startPos = 0) {
    this.content.nodesBetween(from3, to2, f2, startPos, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(f2) {
    this.nodesBetween(0, this.content.size, f2);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(from3, to2, blockSeparator, leafText) {
    return this.content.textBetween(from3, to2, blockSeparator, leafText);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(other2) {
    return this == other2 || this.sameMarkup(other2) && this.content.eq(other2.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(other2) {
    return this.hasMarkup(other2.type, other2.attrs, other2.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(type, attrs, marks) {
    return this.type == type && compareDeep(this.attrs, attrs || type.defaultAttrs || emptyAttrs) && Mark$1.sameSet(this.marks, marks || Mark$1.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(content2 = null) {
    if (content2 == this.content)
      return this;
    return new Node2(this.type, this.attrs, content2, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(marks) {
    return marks == this.marks ? this : new Node2(this.type, this.attrs, this.content, marks);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(from3, to2 = this.content.size) {
    if (from3 == 0 && to2 == this.content.size)
      return this;
    return this.copy(this.content.cut(from3, to2));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(from3, to2 = this.content.size, includeParents = false) {
    if (from3 == to2)
      return Slice.empty;
    let $from = this.resolve(from3), $to = this.resolve(to2);
    let depth = includeParents ? 0 : $from.sharedDepth(to2);
    let start4 = $from.start(depth), node2 = $from.node(depth);
    let content2 = node2.content.cut($from.pos - start4, $to.pos - start4);
    return new Slice(content2, $from.depth - depth, $to.depth - depth);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(from3, to2, slice3) {
    return replace(this.resolve(from3), this.resolve(to2), slice3);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(pos) {
    for (let node2 = this; ; ) {
      let { index: index2, offset: offset3 } = node2.content.findIndex(pos);
      node2 = node2.maybeChild(index2);
      if (!node2)
        return null;
      if (offset3 == pos || node2.isText)
        return node2;
      pos -= offset3 + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(pos) {
    let { index: index2, offset: offset3 } = this.content.findIndex(pos);
    return { node: this.content.maybeChild(index2), index: index2, offset: offset3 };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(pos) {
    if (pos == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: index2, offset: offset3 } = this.content.findIndex(pos);
    if (offset3 < pos)
      return { node: this.content.child(index2), index: index2, offset: offset3 };
    let node2 = this.content.child(index2 - 1);
    return { node: node2, index: index2 - 1, offset: offset3 - node2.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(pos) {
    return ResolvedPos.resolveCached(this, pos);
  }
  /**
  @internal
  */
  resolveNoCache(pos) {
    return ResolvedPos.resolve(this, pos);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(from3, to2, type) {
    let found2 = false;
    if (to2 > from3)
      this.nodesBetween(from3, to2, (node2) => {
        if (type.isInSet(node2.marks))
          found2 = true;
        return !found2;
      });
    return found2;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let name2 = this.type.name;
    if (this.content.size)
      name2 += "(" + this.content.toStringInner() + ")";
    return wrapMarks(this.marks, name2);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(index2) {
    let match5 = this.type.contentMatch.matchFragment(this.content, 0, index2);
    if (!match5)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return match5;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(from3, to2, replacement = Fragment.empty, start4 = 0, end2 = replacement.childCount) {
    let one2 = this.contentMatchAt(from3).matchFragment(replacement, start4, end2);
    let two = one2 && one2.matchFragment(this.content, to2);
    if (!two || !two.validEnd)
      return false;
    for (let i = start4; i < end2; i++)
      if (!this.type.allowsMarks(replacement.child(i).marks))
        return false;
    return true;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(from3, to2, type, marks) {
    if (marks && !this.type.allowsMarks(marks))
      return false;
    let start4 = this.contentMatchAt(from3).matchType(type);
    let end2 = start4 && start4.matchFragment(this.content, to2);
    return end2 ? end2.validEnd : false;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(other2) {
    if (other2.content.size)
      return this.canReplace(this.childCount, this.childCount, other2.content);
    else
      return this.type.compatibleContent(other2.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content);
    this.type.checkAttrs(this.attrs);
    let copy2 = Mark$1.none;
    for (let i = 0; i < this.marks.length; i++) {
      let mark2 = this.marks[i];
      mark2.type.checkAttrs(mark2.attrs);
      copy2 = mark2.addToSet(copy2);
    }
    if (!Mark$1.sameSet(copy2, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m2) => m2.type.name)}`);
    this.content.forEach((node2) => node2.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let obj = { type: this.type.name };
    for (let _2 in this.attrs) {
      obj.attrs = this.attrs;
      break;
    }
    if (this.content.size)
      obj.content = this.content.toJSON();
    if (this.marks.length)
      obj.marks = this.marks.map((n2) => n2.toJSON());
    return obj;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(schema, json) {
    if (!json)
      throw new RangeError("Invalid input for Node.fromJSON");
    let marks = void 0;
    if (json.marks) {
      if (!Array.isArray(json.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      marks = json.marks.map(schema.markFromJSON);
    }
    if (json.type == "text") {
      if (typeof json.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return schema.text(json.text, marks);
    }
    let content2 = Fragment.fromJSON(schema, json.content);
    let node2 = schema.nodeType(json.type).create(json.attrs, content2, marks);
    node2.type.checkAttrs(node2.attrs);
    return node2;
  }
};
Node$2.prototype.text = void 0;
class TextNode extends Node$2 {
  /**
  @internal
  */
  constructor(type, attrs, content2, marks) {
    super(type, attrs, null, marks);
    if (!content2)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = content2;
  }
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    return wrapMarks(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(from3, to2) {
    return this.text.slice(from3, to2);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(marks) {
    return marks == this.marks ? this : new TextNode(this.type, this.attrs, this.text, marks);
  }
  withText(text2) {
    if (text2 == this.text)
      return this;
    return new TextNode(this.type, this.attrs, text2, this.marks);
  }
  cut(from3 = 0, to2 = this.text.length) {
    if (from3 == 0 && to2 == this.text.length)
      return this;
    return this.withText(this.text.slice(from3, to2));
  }
  eq(other2) {
    return this.sameMarkup(other2) && this.text == other2.text;
  }
  toJSON() {
    let base2 = super.toJSON();
    base2.text = this.text;
    return base2;
  }
}
function wrapMarks(marks, str) {
  for (let i = marks.length - 1; i >= 0; i--)
    str = marks[i].type.name + "(" + str + ")";
  return str;
}
class ContentMatch {
  /**
  @internal
  */
  constructor(validEnd) {
    this.validEnd = validEnd;
    this.next = [];
    this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(string2, nodeTypes) {
    let stream = new TokenStream(string2, nodeTypes);
    if (stream.next == null)
      return ContentMatch.empty;
    let expr = parseExpr(stream);
    if (stream.next)
      stream.err("Unexpected trailing text");
    let match5 = dfa(nfa(expr));
    checkForDeadEnds(match5, stream);
    return match5;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(type) {
    for (let i = 0; i < this.next.length; i++)
      if (this.next[i].type == type)
        return this.next[i].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(frag, start4 = 0, end2 = frag.childCount) {
    let cur = this;
    for (let i = start4; cur && i < end2; i++)
      cur = cur.matchType(frag.child(i).type);
    return cur;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let i = 0; i < this.next.length; i++) {
      let { type } = this.next[i];
      if (!(type.isText || type.hasRequiredAttrs()))
        return type;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(other2) {
    for (let i = 0; i < this.next.length; i++)
      for (let j2 = 0; j2 < other2.next.length; j2++)
        if (this.next[i].type == other2.next[j2].type)
          return true;
    return false;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(after, toEnd = false, startIndex = 0) {
    let seen = [this];
    function search2(match5, types2) {
      let finished = match5.matchFragment(after, startIndex);
      if (finished && (!toEnd || finished.validEnd))
        return Fragment.from(types2.map((tp) => tp.createAndFill()));
      for (let i = 0; i < match5.next.length; i++) {
        let { type, next: next2 } = match5.next[i];
        if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next2) == -1) {
          seen.push(next2);
          let found2 = search2(next2, types2.concat(type));
          if (found2)
            return found2;
        }
      }
      return null;
    }
    return search2(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(target) {
    for (let i = 0; i < this.wrapCache.length; i += 2)
      if (this.wrapCache[i] == target)
        return this.wrapCache[i + 1];
    let computed = this.computeWrapping(target);
    this.wrapCache.push(target, computed);
    return computed;
  }
  /**
  @internal
  */
  computeWrapping(target) {
    let seen = /* @__PURE__ */ Object.create(null), active = [{ match: this, type: null, via: null }];
    while (active.length) {
      let current = active.shift(), match5 = current.match;
      if (match5.matchType(target)) {
        let result = [];
        for (let obj = current; obj.type; obj = obj.via)
          result.push(obj.type);
        return result.reverse();
      }
      for (let i = 0; i < match5.next.length; i++) {
        let { type, next: next2 } = match5.next[i];
        if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next2.validEnd)) {
          active.push({ match: type.contentMatch, type, via: current });
          seen[type.name] = true;
        }
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(n2) {
    if (n2 >= this.next.length)
      throw new RangeError(`There's no ${n2}th edge in this content match`);
    return this.next[n2];
  }
  /**
  @internal
  */
  toString() {
    let seen = [];
    function scan(m2) {
      seen.push(m2);
      for (let i = 0; i < m2.next.length; i++)
        if (seen.indexOf(m2.next[i].next) == -1)
          scan(m2.next[i].next);
    }
    scan(this);
    return seen.map((m2, i) => {
      let out = i + (m2.validEnd ? "*" : " ") + " ";
      for (let i2 = 0; i2 < m2.next.length; i2++)
        out += (i2 ? ", " : "") + m2.next[i2].type.name + "->" + seen.indexOf(m2.next[i2].next);
      return out;
    }).join("\n");
  }
}
ContentMatch.empty = new ContentMatch(true);
class TokenStream {
  constructor(string2, nodeTypes) {
    this.string = string2;
    this.nodeTypes = nodeTypes;
    this.inline = null;
    this.pos = 0;
    this.tokens = string2.split(/\s*(?=\b|\W|$)/);
    if (this.tokens[this.tokens.length - 1] == "")
      this.tokens.pop();
    if (this.tokens[0] == "")
      this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(tok) {
    return this.next == tok && (this.pos++ || true);
  }
  err(str) {
    throw new SyntaxError(str + " (in content expression '" + this.string + "')");
  }
}
function parseExpr(stream) {
  let exprs = [];
  do {
    exprs.push(parseExprSeq(stream));
  } while (stream.eat("|"));
  return exprs.length == 1 ? exprs[0] : { type: "choice", exprs };
}
function parseExprSeq(stream) {
  let exprs = [];
  do {
    exprs.push(parseExprSubscript(stream));
  } while (stream.next && stream.next != ")" && stream.next != "|");
  return exprs.length == 1 ? exprs[0] : { type: "seq", exprs };
}
function parseExprSubscript(stream) {
  let expr = parseExprAtom(stream);
  for (; ; ) {
    if (stream.eat("+"))
      expr = { type: "plus", expr };
    else if (stream.eat("*"))
      expr = { type: "star", expr };
    else if (stream.eat("?"))
      expr = { type: "opt", expr };
    else if (stream.eat("{"))
      expr = parseExprRange(stream, expr);
    else
      break;
  }
  return expr;
}
function parseNum(stream) {
  if (/\D/.test(stream.next))
    stream.err("Expected number, got '" + stream.next + "'");
  let result = Number(stream.next);
  stream.pos++;
  return result;
}
function parseExprRange(stream, expr) {
  let min2 = parseNum(stream), max2 = min2;
  if (stream.eat(",")) {
    if (stream.next != "}")
      max2 = parseNum(stream);
    else
      max2 = -1;
  }
  if (!stream.eat("}"))
    stream.err("Unclosed braced range");
  return { type: "range", min: min2, max: max2, expr };
}
function resolveName(stream, name2) {
  let types2 = stream.nodeTypes, type = types2[name2];
  if (type)
    return [type];
  let result = [];
  for (let typeName in types2) {
    let type2 = types2[typeName];
    if (type2.isInGroup(name2))
      result.push(type2);
  }
  if (result.length == 0)
    stream.err("No node type or group '" + name2 + "' found");
  return result;
}
function parseExprAtom(stream) {
  if (stream.eat("(")) {
    let expr = parseExpr(stream);
    if (!stream.eat(")"))
      stream.err("Missing closing paren");
    return expr;
  } else if (!/\W/.test(stream.next)) {
    let exprs = resolveName(stream, stream.next).map((type) => {
      if (stream.inline == null)
        stream.inline = type.isInline;
      else if (stream.inline != type.isInline)
        stream.err("Mixing inline and block content");
      return { type: "name", value: type };
    });
    stream.pos++;
    return exprs.length == 1 ? exprs[0] : { type: "choice", exprs };
  } else {
    stream.err("Unexpected token '" + stream.next + "'");
  }
}
function nfa(expr) {
  let nfa2 = [[]];
  connect2(compile2(expr, 0), node2());
  return nfa2;
  function node2() {
    return nfa2.push([]) - 1;
  }
  function edge(from3, to2, term) {
    let edge2 = { term, to: to2 };
    nfa2[from3].push(edge2);
    return edge2;
  }
  function connect2(edges, to2) {
    edges.forEach((edge2) => edge2.to = to2);
  }
  function compile2(expr2, from3) {
    if (expr2.type == "choice") {
      return expr2.exprs.reduce((out, expr3) => out.concat(compile2(expr3, from3)), []);
    } else if (expr2.type == "seq") {
      for (let i = 0; ; i++) {
        let next2 = compile2(expr2.exprs[i], from3);
        if (i == expr2.exprs.length - 1)
          return next2;
        connect2(next2, from3 = node2());
      }
    } else if (expr2.type == "star") {
      let loop = node2();
      edge(from3, loop);
      connect2(compile2(expr2.expr, loop), loop);
      return [edge(loop)];
    } else if (expr2.type == "plus") {
      let loop = node2();
      connect2(compile2(expr2.expr, from3), loop);
      connect2(compile2(expr2.expr, loop), loop);
      return [edge(loop)];
    } else if (expr2.type == "opt") {
      return [edge(from3)].concat(compile2(expr2.expr, from3));
    } else if (expr2.type == "range") {
      let cur = from3;
      for (let i = 0; i < expr2.min; i++) {
        let next2 = node2();
        connect2(compile2(expr2.expr, cur), next2);
        cur = next2;
      }
      if (expr2.max == -1) {
        connect2(compile2(expr2.expr, cur), cur);
      } else {
        for (let i = expr2.min; i < expr2.max; i++) {
          let next2 = node2();
          edge(cur, next2);
          connect2(compile2(expr2.expr, cur), next2);
          cur = next2;
        }
      }
      return [edge(cur)];
    } else if (expr2.type == "name") {
      return [edge(from3, void 0, expr2.value)];
    } else {
      throw new Error("Unknown expr type");
    }
  }
}
function cmp(a2, b2) {
  return b2 - a2;
}
function nullFrom(nfa2, node2) {
  let result = [];
  scan(node2);
  return result.sort(cmp);
  function scan(node3) {
    let edges = nfa2[node3];
    if (edges.length == 1 && !edges[0].term)
      return scan(edges[0].to);
    result.push(node3);
    for (let i = 0; i < edges.length; i++) {
      let { term, to: to2 } = edges[i];
      if (!term && result.indexOf(to2) == -1)
        scan(to2);
    }
  }
}
function dfa(nfa2) {
  let labeled = /* @__PURE__ */ Object.create(null);
  return explore(nullFrom(nfa2, 0));
  function explore(states) {
    let out = [];
    states.forEach((node2) => {
      nfa2[node2].forEach(({ term, to: to2 }) => {
        if (!term)
          return;
        let set2;
        for (let i = 0; i < out.length; i++)
          if (out[i][0] == term)
            set2 = out[i][1];
        nullFrom(nfa2, to2).forEach((node3) => {
          if (!set2)
            out.push([term, set2 = []]);
          if (set2.indexOf(node3) == -1)
            set2.push(node3);
        });
      });
    });
    let state = labeled[states.join(",")] = new ContentMatch(states.indexOf(nfa2.length - 1) > -1);
    for (let i = 0; i < out.length; i++) {
      let states2 = out[i][1].sort(cmp);
      state.next.push({ type: out[i][0], next: labeled[states2.join(",")] || explore(states2) });
    }
    return state;
  }
}
function checkForDeadEnds(match5, stream) {
  for (let i = 0, work = [match5]; i < work.length; i++) {
    let state = work[i], dead = !state.validEnd, nodes = [];
    for (let j2 = 0; j2 < state.next.length; j2++) {
      let { type, next: next2 } = state.next[j2];
      nodes.push(type.name);
      if (dead && !(type.isText || type.hasRequiredAttrs()))
        dead = false;
      if (work.indexOf(next2) == -1)
        work.push(next2);
    }
    if (dead)
      stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function defaultAttrs(attrs) {
  let defaults2 = /* @__PURE__ */ Object.create(null);
  for (let attrName in attrs) {
    let attr = attrs[attrName];
    if (!attr.hasDefault)
      return null;
    defaults2[attrName] = attr.default;
  }
  return defaults2;
}
function computeAttrs(attrs, value) {
  let built = /* @__PURE__ */ Object.create(null);
  for (let name2 in attrs) {
    let given = value && value[name2];
    if (given === void 0) {
      let attr = attrs[name2];
      if (attr.hasDefault)
        given = attr.default;
      else
        throw new RangeError("No value supplied for attribute " + name2);
    }
    built[name2] = given;
  }
  return built;
}
function checkAttrs(attrs, values2, type, name2) {
  for (let name3 in values2)
    if (!(name3 in attrs))
      throw new RangeError(`Unsupported attribute ${name3} for ${type} of type ${name3}`);
  for (let name3 in attrs) {
    let attr = attrs[name3];
    if (attr.validate)
      attr.validate(values2[name3]);
  }
}
function initAttrs(typeName, attrs) {
  let result = /* @__PURE__ */ Object.create(null);
  if (attrs)
    for (let name2 in attrs)
      result[name2] = new Attribute(typeName, name2, attrs[name2]);
  return result;
}
let NodeType$1 = class NodeType {
  /**
  @internal
  */
  constructor(name2, schema, spec) {
    this.name = name2;
    this.schema = schema;
    this.spec = spec;
    this.markSet = null;
    this.groups = spec.group ? spec.group.split(" ") : [];
    this.attrs = initAttrs(name2, spec.attrs);
    this.defaultAttrs = defaultAttrs(this.attrs);
    this.contentMatch = null;
    this.inlineContent = null;
    this.isBlock = !(spec.inline || name2 == "text");
    this.isText = name2 == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == ContentMatch.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(group) {
    return this.groups.indexOf(group) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let n2 in this.attrs)
      if (this.attrs[n2].isRequired)
        return true;
    return false;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(other2) {
    return this == other2 || this.contentMatch.compatible(other2.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(attrs) {
    if (!attrs && this.defaultAttrs)
      return this.defaultAttrs;
    else
      return computeAttrs(this.attrs, attrs);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(attrs = null, content2, marks) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Node$2(this, this.computeAttrs(attrs), Fragment.from(content2), Mark$1.setFrom(marks));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(attrs = null, content2, marks) {
    content2 = Fragment.from(content2);
    this.checkContent(content2);
    return new Node$2(this, this.computeAttrs(attrs), content2, Mark$1.setFrom(marks));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(attrs = null, content2, marks) {
    attrs = this.computeAttrs(attrs);
    content2 = Fragment.from(content2);
    if (content2.size) {
      let before = this.contentMatch.fillBefore(content2);
      if (!before)
        return null;
      content2 = before.append(content2);
    }
    let matched = this.contentMatch.matchFragment(content2);
    let after = matched && matched.fillBefore(Fragment.empty, true);
    if (!after)
      return null;
    return new Node$2(this, attrs, content2.append(after), Mark$1.setFrom(marks));
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(content2) {
    let result = this.contentMatch.matchFragment(content2);
    if (!result || !result.validEnd)
      return false;
    for (let i = 0; i < content2.childCount; i++)
      if (!this.allowsMarks(content2.child(i).marks))
        return false;
    return true;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(content2) {
    if (!this.validContent(content2))
      throw new RangeError(`Invalid content for node ${this.name}: ${content2.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(attrs) {
    checkAttrs(this.attrs, attrs, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(markType) {
    return this.markSet == null || this.markSet.indexOf(markType) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(marks) {
    if (this.markSet == null)
      return true;
    for (let i = 0; i < marks.length; i++)
      if (!this.allowsMarkType(marks[i].type))
        return false;
    return true;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(marks) {
    if (this.markSet == null)
      return marks;
    let copy2;
    for (let i = 0; i < marks.length; i++) {
      if (!this.allowsMarkType(marks[i].type)) {
        if (!copy2)
          copy2 = marks.slice(0, i);
      } else if (copy2) {
        copy2.push(marks[i]);
      }
    }
    return !copy2 ? marks : copy2.length ? copy2 : Mark$1.none;
  }
  /**
  @internal
  */
  static compile(nodes, schema) {
    let result = /* @__PURE__ */ Object.create(null);
    nodes.forEach((name2, spec) => result[name2] = new NodeType(name2, schema, spec));
    let topType = schema.spec.topNode || "doc";
    if (!result[topType])
      throw new RangeError("Schema is missing its top node type ('" + topType + "')");
    if (!result.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let _2 in result.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return result;
  }
};
function validateType(typeName, attrName, type) {
  let types2 = type.split("|");
  return (value) => {
    let name2 = value === null ? "null" : typeof value;
    if (types2.indexOf(name2) < 0)
      throw new RangeError(`Expected value of type ${types2} for attribute ${attrName} on type ${typeName}, got ${name2}`);
  };
}
class Attribute {
  constructor(typeName, attrName, options) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
    this.default = options.default;
    this.validate = typeof options.validate == "string" ? validateType(typeName, attrName, options.validate) : options.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class MarkType {
  /**
  @internal
  */
  constructor(name2, rank, schema, spec) {
    this.name = name2;
    this.rank = rank;
    this.schema = schema;
    this.spec = spec;
    this.attrs = initAttrs(name2, spec.attrs);
    this.excluded = null;
    let defaults2 = defaultAttrs(this.attrs);
    this.instance = defaults2 ? new Mark$1(this, defaults2) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(attrs = null) {
    if (!attrs && this.instance)
      return this.instance;
    return new Mark$1(this, computeAttrs(this.attrs, attrs));
  }
  /**
  @internal
  */
  static compile(marks, schema) {
    let result = /* @__PURE__ */ Object.create(null), rank = 0;
    marks.forEach((name2, spec) => result[name2] = new MarkType(name2, rank++, schema, spec));
    return result;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(set2) {
    for (var i = 0; i < set2.length; i++)
      if (set2[i].type == this) {
        set2 = set2.slice(0, i).concat(set2.slice(i + 1));
        i--;
      }
    return set2;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(set2) {
    for (let i = 0; i < set2.length; i++)
      if (set2[i].type == this)
        return set2[i];
  }
  /**
  @internal
  */
  checkAttrs(attrs) {
    checkAttrs(this.attrs, attrs, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(other2) {
    return this.excluded.indexOf(other2) > -1;
  }
}
class Schema2 {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(spec) {
    this.linebreakReplacement = null;
    this.cached = /* @__PURE__ */ Object.create(null);
    let instanceSpec = this.spec = {};
    for (let prop in spec)
      instanceSpec[prop] = spec[prop];
    instanceSpec.nodes = OrderedMap.from(spec.nodes), instanceSpec.marks = OrderedMap.from(spec.marks || {}), this.nodes = NodeType$1.compile(this.spec.nodes, this);
    this.marks = MarkType.compile(this.spec.marks, this);
    let contentExprCache = /* @__PURE__ */ Object.create(null);
    for (let prop in this.nodes) {
      if (prop in this.marks)
        throw new RangeError(prop + " can not be both a node and a mark");
      let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
      type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = ContentMatch.parse(contentExpr, this.nodes));
      type.inlineContent = type.contentMatch.inlineContent;
      if (type.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!type.isInline || !type.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = type;
      }
      type.markSet = markExpr == "_" ? null : markExpr ? gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
    }
    for (let prop in this.marks) {
      let type = this.marks[prop], excl = type.spec.excludes;
      type.excluded = excl == null ? [type] : excl == "" ? [] : gatherMarks(this, excl.split(" "));
    }
    this.nodeFromJSON = (json) => Node$2.fromJSON(this, json);
    this.markFromJSON = (json) => Mark$1.fromJSON(this, json);
    this.topNodeType = this.nodes[this.spec.topNode || "doc"];
    this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(type, attrs = null, content2, marks) {
    if (typeof type == "string")
      type = this.nodeType(type);
    else if (!(type instanceof NodeType$1))
      throw new RangeError("Invalid node type: " + type);
    else if (type.schema != this)
      throw new RangeError("Node type from different schema used (" + type.name + ")");
    return type.createChecked(attrs, content2, marks);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(text2, marks) {
    let type = this.nodes.text;
    return new TextNode(type, type.defaultAttrs, text2, Mark$1.setFrom(marks));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(type, attrs) {
    if (typeof type == "string")
      type = this.marks[type];
    return type.create(attrs);
  }
  /**
  @internal
  */
  nodeType(name2) {
    let found2 = this.nodes[name2];
    if (!found2)
      throw new RangeError("Unknown node type: " + name2);
    return found2;
  }
}
function gatherMarks(schema, marks) {
  let found2 = [];
  for (let i = 0; i < marks.length; i++) {
    let name2 = marks[i], mark2 = schema.marks[name2], ok2 = mark2;
    if (mark2) {
      found2.push(mark2);
    } else {
      for (let prop in schema.marks) {
        let mark3 = schema.marks[prop];
        if (name2 == "_" || mark3.spec.group && mark3.spec.group.split(" ").indexOf(name2) > -1)
          found2.push(ok2 = mark3);
      }
    }
    if (!ok2)
      throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
  }
  return found2;
}
function isTagRule(rule) {
  return rule.tag != null;
}
function isStyleRule(rule) {
  return rule.style != null;
}
class DOMParser {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(schema, rules) {
    this.schema = schema;
    this.rules = rules;
    this.tags = [];
    this.styles = [];
    let matchedStyles = this.matchedStyles = [];
    rules.forEach((rule) => {
      if (isTagRule(rule)) {
        this.tags.push(rule);
      } else if (isStyleRule(rule)) {
        let prop = /[^=]*/.exec(rule.style)[0];
        if (matchedStyles.indexOf(prop) < 0)
          matchedStyles.push(prop);
        this.styles.push(rule);
      }
    });
    this.normalizeLists = !this.tags.some((r2) => {
      if (!/^(ul|ol)\b/.test(r2.tag) || !r2.node)
        return false;
      let node2 = schema.nodes[r2.node];
      return node2.contentMatch.matchType(node2);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(dom, options = {}) {
    let context = new ParseContext(this, options, false);
    context.addAll(dom, Mark$1.none, options.from, options.to);
    return context.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(dom, options = {}) {
    let context = new ParseContext(this, options, true);
    context.addAll(dom, Mark$1.none, options.from, options.to);
    return Slice.maxOpen(context.finish());
  }
  /**
  @internal
  */
  matchTag(dom, context, after) {
    for (let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++) {
      let rule = this.tags[i];
      if (matches(dom, rule.tag) && (rule.namespace === void 0 || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
        if (rule.getAttrs) {
          let result = rule.getAttrs(dom);
          if (result === false)
            continue;
          rule.attrs = result || void 0;
        }
        return rule;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(prop, value, context, after) {
    for (let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++) {
      let rule = this.styles[i], style3 = rule.style;
      if (style3.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      style3.length > prop.length && (style3.charCodeAt(prop.length) != 61 || style3.slice(prop.length + 1) != value))
        continue;
      if (rule.getAttrs) {
        let result = rule.getAttrs(value);
        if (result === false)
          continue;
        rule.attrs = result || void 0;
      }
      return rule;
    }
  }
  /**
  @internal
  */
  static schemaRules(schema) {
    let result = [];
    function insert2(rule) {
      let priority = rule.priority == null ? 50 : rule.priority, i = 0;
      for (; i < result.length; i++) {
        let next2 = result[i], nextPriority = next2.priority == null ? 50 : next2.priority;
        if (nextPriority < priority)
          break;
      }
      result.splice(i, 0, rule);
    }
    for (let name2 in schema.marks) {
      let rules = schema.marks[name2].spec.parseDOM;
      if (rules)
        rules.forEach((rule) => {
          insert2(rule = copy(rule));
          if (!(rule.mark || rule.ignore || rule.clearMark))
            rule.mark = name2;
        });
    }
    for (let name2 in schema.nodes) {
      let rules = schema.nodes[name2].spec.parseDOM;
      if (rules)
        rules.forEach((rule) => {
          insert2(rule = copy(rule));
          if (!(rule.node || rule.ignore || rule.mark))
            rule.node = name2;
        });
    }
    return result;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(schema) {
    return schema.cached.domParser || (schema.cached.domParser = new DOMParser(schema, DOMParser.schemaRules(schema)));
  }
}
const blockTags = {
  address: true,
  article: true,
  aside: true,
  blockquote: true,
  canvas: true,
  dd: true,
  div: true,
  dl: true,
  fieldset: true,
  figcaption: true,
  figure: true,
  footer: true,
  form: true,
  h1: true,
  h2: true,
  h3: true,
  h4: true,
  h5: true,
  h6: true,
  header: true,
  hgroup: true,
  hr: true,
  li: true,
  noscript: true,
  ol: true,
  output: true,
  p: true,
  pre: true,
  section: true,
  table: true,
  tfoot: true,
  ul: true
};
const ignoreTags = {
  head: true,
  noscript: true,
  object: true,
  script: true,
  style: true,
  title: true
};
const listTags = { ol: true, ul: true };
const OPT_PRESERVE_WS = 1, OPT_PRESERVE_WS_FULL = 2, OPT_OPEN_LEFT = 4;
function wsOptionsFor(type, preserveWhitespace, base2) {
  if (preserveWhitespace != null)
    return (preserveWhitespace ? OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? OPT_PRESERVE_WS_FULL : 0);
  return type && type.whitespace == "pre" ? OPT_PRESERVE_WS | OPT_PRESERVE_WS_FULL : base2 & ~OPT_OPEN_LEFT;
}
class NodeContext {
  constructor(type, attrs, marks, solid, match5, options) {
    this.type = type;
    this.attrs = attrs;
    this.marks = marks;
    this.solid = solid;
    this.options = options;
    this.content = [];
    this.activeMarks = Mark$1.none;
    this.match = match5 || (options & OPT_OPEN_LEFT ? null : type.contentMatch);
  }
  findWrapping(node2) {
    if (!this.match) {
      if (!this.type)
        return [];
      let fill = this.type.contentMatch.fillBefore(Fragment.from(node2));
      if (fill) {
        this.match = this.type.contentMatch.matchFragment(fill);
      } else {
        let start4 = this.type.contentMatch, wrap2;
        if (wrap2 = start4.findWrapping(node2.type)) {
          this.match = start4;
          return wrap2;
        } else {
          return null;
        }
      }
    }
    return this.match.findWrapping(node2.type);
  }
  finish(openEnd) {
    if (!(this.options & OPT_PRESERVE_WS)) {
      let last = this.content[this.content.length - 1], m2;
      if (last && last.isText && (m2 = /[ \t\r\n\u000c]+$/.exec(last.text))) {
        let text2 = last;
        if (last.text.length == m2[0].length)
          this.content.pop();
        else
          this.content[this.content.length - 1] = text2.withText(text2.text.slice(0, text2.text.length - m2[0].length));
      }
    }
    let content2 = Fragment.from(this.content);
    if (!openEnd && this.match)
      content2 = content2.append(this.match.fillBefore(Fragment.empty, true));
    return this.type ? this.type.create(this.attrs, content2, this.marks) : content2;
  }
  inlineContext(node2) {
    if (this.type)
      return this.type.inlineContent;
    if (this.content.length)
      return this.content[0].isInline;
    return node2.parentNode && !blockTags.hasOwnProperty(node2.parentNode.nodeName.toLowerCase());
  }
}
class ParseContext {
  constructor(parser, options, isOpen) {
    this.parser = parser;
    this.options = options;
    this.isOpen = isOpen;
    this.open = 0;
    this.localPreserveWS = false;
    let topNode = options.topNode, topContext;
    let topOptions = wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? OPT_OPEN_LEFT : 0);
    if (topNode)
      topContext = new NodeContext(topNode.type, topNode.attrs, Mark$1.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
    else if (isOpen)
      topContext = new NodeContext(null, null, Mark$1.none, true, null, topOptions);
    else
      topContext = new NodeContext(parser.schema.topNodeType, null, Mark$1.none, true, null, topOptions);
    this.nodes = [topContext];
    this.find = options.findPositions;
    this.needsBlock = false;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(dom, marks) {
    if (dom.nodeType == 3)
      this.addTextNode(dom, marks);
    else if (dom.nodeType == 1)
      this.addElement(dom, marks);
  }
  addTextNode(dom, marks) {
    let value = dom.nodeValue;
    let top2 = this.top, preserveWS = top2.options & OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top2.options & OPT_PRESERVE_WS) > 0;
    if (preserveWS === "full" || top2.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
      if (!preserveWS) {
        value = value.replace(/[ \t\r\n\u000c]+/g, " ");
        if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
          let nodeBefore = top2.content[top2.content.length - 1];
          let domNodeBefore = dom.previousSibling;
          if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == "BR" || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text))
            value = value.slice(1);
        }
      } else if (preserveWS !== "full") {
        value = value.replace(/\r?\n|\r/g, " ");
      } else {
        value = value.replace(/\r\n?/g, "\n");
      }
      if (value)
        this.insertNode(this.parser.schema.text(value), marks, !/\S/.test(value));
      this.findInText(dom);
    } else {
      this.findInside(dom);
    }
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(dom, marks, matchAfter) {
    let outerWS = this.localPreserveWS, top2 = this.top;
    if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace))
      this.localPreserveWS = true;
    let name2 = dom.nodeName.toLowerCase(), ruleID;
    if (listTags.hasOwnProperty(name2) && this.parser.normalizeLists)
      normalizeList(dom);
    let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
    out: if (rule ? rule.ignore : ignoreTags.hasOwnProperty(name2)) {
      this.findInside(dom);
      this.ignoreFallback(dom, marks);
    } else if (!rule || rule.skip || rule.closeParent) {
      if (rule && rule.closeParent)
        this.open = Math.max(0, this.open - 1);
      else if (rule && rule.skip.nodeType)
        dom = rule.skip;
      let sync, oldNeedsBlock = this.needsBlock;
      if (blockTags.hasOwnProperty(name2)) {
        if (top2.content.length && top2.content[0].isInline && this.open) {
          this.open--;
          top2 = this.top;
        }
        sync = true;
        if (!top2.type)
          this.needsBlock = true;
      } else if (!dom.firstChild) {
        this.leafFallback(dom, marks);
        break out;
      }
      let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
      if (innerMarks)
        this.addAll(dom, innerMarks);
      if (sync)
        this.sync(top2);
      this.needsBlock = oldNeedsBlock;
    } else {
      let innerMarks = this.readStyles(dom, marks);
      if (innerMarks)
        this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : void 0);
    }
    this.localPreserveWS = outerWS;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(dom, marks) {
    if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent)
      this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
  }
  // Called for ignored nodes
  ignoreFallback(dom, marks) {
    if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent))
      this.findPlace(this.parser.schema.text("-"), marks, true);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(dom, marks) {
    let styles2 = dom.style;
    if (styles2 && styles2.length)
      for (let i = 0; i < this.parser.matchedStyles.length; i++) {
        let name2 = this.parser.matchedStyles[i], value = styles2.getPropertyValue(name2);
        if (value)
          for (let after = void 0; ; ) {
            let rule = this.parser.matchStyle(name2, value, this, after);
            if (!rule)
              break;
            if (rule.ignore)
              return null;
            if (rule.clearMark)
              marks = marks.filter((m2) => !rule.clearMark(m2));
            else
              marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
            if (rule.consuming === false)
              after = rule;
            else
              break;
          }
      }
    return marks;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(dom, rule, marks, continueAfter) {
    let sync, nodeType;
    if (rule.node) {
      nodeType = this.parser.schema.nodes[rule.node];
      if (!nodeType.isLeaf) {
        let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
        if (inner) {
          sync = true;
          marks = inner;
        }
      } else if (!this.insertNode(nodeType.create(rule.attrs), marks, dom.nodeName == "BR")) {
        this.leafFallback(dom, marks);
      }
    } else {
      let markType = this.parser.schema.marks[rule.mark];
      marks = marks.concat(markType.create(rule.attrs));
    }
    let startIn = this.top;
    if (nodeType && nodeType.isLeaf) {
      this.findInside(dom);
    } else if (continueAfter) {
      this.addElement(dom, marks, continueAfter);
    } else if (rule.getContent) {
      this.findInside(dom);
      rule.getContent(dom, this.parser.schema).forEach((node2) => this.insertNode(node2, marks, false));
    } else {
      let contentDOM = dom;
      if (typeof rule.contentElement == "string")
        contentDOM = dom.querySelector(rule.contentElement);
      else if (typeof rule.contentElement == "function")
        contentDOM = rule.contentElement(dom);
      else if (rule.contentElement)
        contentDOM = rule.contentElement;
      this.findAround(dom, contentDOM, true);
      this.addAll(contentDOM, marks);
      this.findAround(dom, contentDOM, false);
    }
    if (sync && this.sync(startIn))
      this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(parent2, marks, startIndex, endIndex) {
    let index2 = startIndex || 0;
    for (let dom = startIndex ? parent2.childNodes[startIndex] : parent2.firstChild, end2 = endIndex == null ? null : parent2.childNodes[endIndex]; dom != end2; dom = dom.nextSibling, ++index2) {
      this.findAtPoint(parent2, index2);
      this.addDOM(dom, marks);
    }
    this.findAtPoint(parent2, index2);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(node2, marks, cautious) {
    let route, sync;
    for (let depth = this.open, penalty = 0; depth >= 0; depth--) {
      let cx = this.nodes[depth];
      let found2 = cx.findWrapping(node2);
      if (found2 && (!route || route.length > found2.length + penalty)) {
        route = found2;
        sync = cx;
        if (!found2.length)
          break;
      }
      if (cx.solid) {
        if (cautious)
          break;
        penalty += 2;
      }
    }
    if (!route)
      return null;
    this.sync(sync);
    for (let i = 0; i < route.length; i++)
      marks = this.enterInner(route[i], null, marks, false);
    return marks;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(node2, marks, cautious) {
    if (node2.isInline && this.needsBlock && !this.top.type) {
      let block2 = this.textblockFromContext();
      if (block2)
        marks = this.enterInner(block2, null, marks);
    }
    let innerMarks = this.findPlace(node2, marks, cautious);
    if (innerMarks) {
      this.closeExtra();
      let top2 = this.top;
      if (top2.match)
        top2.match = top2.match.matchType(node2.type);
      let nodeMarks = Mark$1.none;
      for (let m2 of innerMarks.concat(node2.marks))
        if (top2.type ? top2.type.allowsMarkType(m2.type) : markMayApply(m2.type, node2.type))
          nodeMarks = m2.addToSet(nodeMarks);
      top2.content.push(node2.mark(nodeMarks));
      return true;
    }
    return false;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(type, attrs, marks, preserveWS) {
    let innerMarks = this.findPlace(type.create(attrs), marks, false);
    if (innerMarks)
      innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
    return innerMarks;
  }
  // Open a node of the given type
  enterInner(type, attrs, marks, solid = false, preserveWS) {
    this.closeExtra();
    let top2 = this.top;
    top2.match = top2.match && top2.match.matchType(type);
    let options = wsOptionsFor(type, preserveWS, top2.options);
    if (top2.options & OPT_OPEN_LEFT && top2.content.length == 0)
      options |= OPT_OPEN_LEFT;
    let applyMarks = Mark$1.none;
    marks = marks.filter((m2) => {
      if (top2.type ? top2.type.allowsMarkType(m2.type) : markMayApply(m2.type, type)) {
        applyMarks = m2.addToSet(applyMarks);
        return false;
      }
      return true;
    });
    this.nodes.push(new NodeContext(type, attrs, applyMarks, solid, null, options));
    this.open++;
    return marks;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(openEnd = false) {
    let i = this.nodes.length - 1;
    if (i > this.open) {
      for (; i > this.open; i--)
        this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    this.open = 0;
    this.closeExtra(this.isOpen);
    return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(to2) {
    for (let i = this.open; i >= 0; i--) {
      if (this.nodes[i] == to2) {
        this.open = i;
        return true;
      } else if (this.localPreserveWS) {
        this.nodes[i].options |= OPT_PRESERVE_WS;
      }
    }
    return false;
  }
  get currentPos() {
    this.closeExtra();
    let pos = 0;
    for (let i = this.open; i >= 0; i--) {
      let content2 = this.nodes[i].content;
      for (let j2 = content2.length - 1; j2 >= 0; j2--)
        pos += content2[j2].nodeSize;
      if (i)
        pos++;
    }
    return pos;
  }
  findAtPoint(parent2, offset3) {
    if (this.find)
      for (let i = 0; i < this.find.length; i++) {
        if (this.find[i].node == parent2 && this.find[i].offset == offset3)
          this.find[i].pos = this.currentPos;
      }
  }
  findInside(parent2) {
    if (this.find)
      for (let i = 0; i < this.find.length; i++) {
        if (this.find[i].pos == null && parent2.nodeType == 1 && parent2.contains(this.find[i].node))
          this.find[i].pos = this.currentPos;
      }
  }
  findAround(parent2, content2, before) {
    if (parent2 != content2 && this.find)
      for (let i = 0; i < this.find.length; i++) {
        if (this.find[i].pos == null && parent2.nodeType == 1 && parent2.contains(this.find[i].node)) {
          let pos = content2.compareDocumentPosition(this.find[i].node);
          if (pos & (before ? 2 : 4))
            this.find[i].pos = this.currentPos;
        }
      }
  }
  findInText(textNode) {
    if (this.find)
      for (let i = 0; i < this.find.length; i++) {
        if (this.find[i].node == textNode)
          this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
      }
  }
  // Determines whether the given context string matches this context.
  matchesContext(context) {
    if (context.indexOf("|") > -1)
      return context.split(/\s*\|\s*/).some(this.matchesContext, this);
    let parts = context.split("/");
    let option = this.options.context;
    let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
    let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
    let match5 = (i, depth) => {
      for (; i >= 0; i--) {
        let part = parts[i];
        if (part == "") {
          if (i == parts.length - 1 || i == 0)
            continue;
          for (; depth >= minDepth; depth--)
            if (match5(i - 1, depth))
              return true;
          return false;
        } else {
          let next2 = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
          if (!next2 || next2.name != part && !next2.isInGroup(part))
            return false;
          depth--;
        }
      }
      return true;
    };
    return match5(parts.length - 1, this.open);
  }
  textblockFromContext() {
    let $context = this.options.context;
    if ($context)
      for (let d2 = $context.depth; d2 >= 0; d2--) {
        let deflt = $context.node(d2).contentMatchAt($context.indexAfter(d2)).defaultType;
        if (deflt && deflt.isTextblock && deflt.defaultAttrs)
          return deflt;
      }
    for (let name2 in this.parser.schema.nodes) {
      let type = this.parser.schema.nodes[name2];
      if (type.isTextblock && type.defaultAttrs)
        return type;
    }
  }
}
function normalizeList(dom) {
  for (let child = dom.firstChild, prevItem = null; child; child = child.nextSibling) {
    let name2 = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
    if (name2 && listTags.hasOwnProperty(name2) && prevItem) {
      prevItem.appendChild(child);
      child = prevItem;
    } else if (name2 == "li") {
      prevItem = child;
    } else if (name2) {
      prevItem = null;
    }
  }
}
function matches(dom, selector2) {
  return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector2);
}
function copy(obj) {
  let copy2 = {};
  for (let prop in obj)
    copy2[prop] = obj[prop];
  return copy2;
}
function markMayApply(markType, nodeType) {
  let nodes = nodeType.schema.nodes;
  for (let name2 in nodes) {
    let parent2 = nodes[name2];
    if (!parent2.allowsMarkType(markType))
      continue;
    let seen = [], scan = (match5) => {
      seen.push(match5);
      for (let i = 0; i < match5.edgeCount; i++) {
        let { type, next: next2 } = match5.edge(i);
        if (type == nodeType)
          return true;
        if (seen.indexOf(next2) < 0 && scan(next2))
          return true;
      }
    };
    if (scan(parent2.contentMatch))
      return true;
  }
}
class DOMSerializer {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(nodes, marks) {
    this.nodes = nodes;
    this.marks = marks;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(fragment, options = {}, target) {
    if (!target)
      target = doc$1(options).createDocumentFragment();
    let top2 = target, active = [];
    fragment.forEach((node2) => {
      if (active.length || node2.marks.length) {
        let keep = 0, rendered = 0;
        while (keep < active.length && rendered < node2.marks.length) {
          let next2 = node2.marks[rendered];
          if (!this.marks[next2.type.name]) {
            rendered++;
            continue;
          }
          if (!next2.eq(active[keep][0]) || next2.type.spec.spanning === false)
            break;
          keep++;
          rendered++;
        }
        while (keep < active.length)
          top2 = active.pop()[1];
        while (rendered < node2.marks.length) {
          let add4 = node2.marks[rendered++];
          let markDOM = this.serializeMark(add4, node2.isInline, options);
          if (markDOM) {
            active.push([add4, top2]);
            top2.appendChild(markDOM.dom);
            top2 = markDOM.contentDOM || markDOM.dom;
          }
        }
      }
      top2.appendChild(this.serializeNodeInner(node2, options));
    });
    return target;
  }
  /**
  @internal
  */
  serializeNodeInner(node2, options) {
    let { dom, contentDOM } = renderSpec(doc$1(options), this.nodes[node2.type.name](node2), null, node2.attrs);
    if (contentDOM) {
      if (node2.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(node2.content, options, contentDOM);
    }
    return dom;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(node2, options = {}) {
    let dom = this.serializeNodeInner(node2, options);
    for (let i = node2.marks.length - 1; i >= 0; i--) {
      let wrap2 = this.serializeMark(node2.marks[i], node2.isInline, options);
      if (wrap2) {
        (wrap2.contentDOM || wrap2.dom).appendChild(dom);
        dom = wrap2.dom;
      }
    }
    return dom;
  }
  /**
  @internal
  */
  serializeMark(mark2, inline2, options = {}) {
    let toDOM = this.marks[mark2.type.name];
    return toDOM && renderSpec(doc$1(options), toDOM(mark2, inline2), null, mark2.attrs);
  }
  static renderSpec(doc2, structure, xmlNS = null, blockArraysIn) {
    return renderSpec(doc2, structure, xmlNS, blockArraysIn);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(schema) {
    return schema.cached.domSerializer || (schema.cached.domSerializer = new DOMSerializer(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(schema) {
    let result = gatherToDOM(schema.nodes);
    if (!result.text)
      result.text = (node2) => node2.text;
    return result;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(schema) {
    return gatherToDOM(schema.marks);
  }
}
function gatherToDOM(obj) {
  let result = {};
  for (let name2 in obj) {
    let toDOM = obj[name2].spec.toDOM;
    if (toDOM)
      result[name2] = toDOM;
  }
  return result;
}
function doc$1(options) {
  return options.document || window.document;
}
const suspiciousAttributeCache = /* @__PURE__ */ new WeakMap();
function suspiciousAttributes(attrs) {
  let value = suspiciousAttributeCache.get(attrs);
  if (value === void 0)
    suspiciousAttributeCache.set(attrs, value = suspiciousAttributesInner(attrs));
  return value;
}
function suspiciousAttributesInner(attrs) {
  let result = null;
  function scan(value) {
    if (value && typeof value == "object") {
      if (Array.isArray(value)) {
        if (typeof value[0] == "string") {
          if (!result)
            result = [];
          result.push(value);
        } else {
          for (let i = 0; i < value.length; i++)
            scan(value[i]);
        }
      } else {
        for (let prop in value)
          scan(value[prop]);
      }
    }
  }
  scan(attrs);
  return result;
}
function renderSpec(doc2, structure, xmlNS, blockArraysIn) {
  if (typeof structure == "string")
    return { dom: doc2.createTextNode(structure) };
  if (structure.nodeType != null)
    return { dom: structure };
  if (structure.dom && structure.dom.nodeType != null)
    return structure;
  let tagName = structure[0], suspicious;
  if (typeof tagName != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (blockArraysIn && (suspicious = suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let space2 = tagName.indexOf(" ");
  if (space2 > 0) {
    xmlNS = tagName.slice(0, space2);
    tagName = tagName.slice(space2 + 1);
  }
  let contentDOM;
  let dom = xmlNS ? doc2.createElementNS(xmlNS, tagName) : doc2.createElement(tagName);
  let attrs = structure[1], start4 = 1;
  if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
    start4 = 2;
    for (let name2 in attrs)
      if (attrs[name2] != null) {
        let space3 = name2.indexOf(" ");
        if (space3 > 0)
          dom.setAttributeNS(name2.slice(0, space3), name2.slice(space3 + 1), attrs[name2]);
        else if (name2 == "style" && dom.style)
          dom.style.cssText = attrs[name2];
        else
          dom.setAttribute(name2, attrs[name2]);
      }
  }
  for (let i = start4; i < structure.length; i++) {
    let child = structure[i];
    if (child === 0) {
      if (i < structure.length - 1 || i > start4)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom, contentDOM: dom };
    } else {
      let { dom: inner, contentDOM: innerContent } = renderSpec(doc2, child, xmlNS, blockArraysIn);
      dom.appendChild(inner);
      if (innerContent) {
        if (contentDOM)
          throw new RangeError("Multiple content holes");
        contentDOM = innerContent;
      }
    }
  }
  return { dom, contentDOM };
}
const lower16 = 65535;
const factor16 = Math.pow(2, 16);
function makeRecover(index2, offset3) {
  return index2 + offset3 * factor16;
}
function recoverIndex(value) {
  return value & lower16;
}
function recoverOffset(value) {
  return (value - (value & lower16)) / factor16;
}
const DEL_BEFORE = 1, DEL_AFTER = 2, DEL_ACROSS = 4, DEL_SIDE = 8;
class MapResult {
  /**
  @internal
  */
  constructor(pos, delInfo, recover) {
    this.pos = pos;
    this.delInfo = delInfo;
    this.recover = recover;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & DEL_SIDE) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (DEL_BEFORE | DEL_ACROSS)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (DEL_AFTER | DEL_ACROSS)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & DEL_ACROSS) > 0;
  }
}
class StepMap {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(ranges, inverted = false) {
    this.ranges = ranges;
    this.inverted = inverted;
    if (!ranges.length && StepMap.empty)
      return StepMap.empty;
  }
  /**
  @internal
  */
  recover(value) {
    let diff2 = 0, index2 = recoverIndex(value);
    if (!this.inverted)
      for (let i = 0; i < index2; i++)
        diff2 += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
    return this.ranges[index2 * 3] + diff2 + recoverOffset(value);
  }
  mapResult(pos, assoc = 1) {
    return this._map(pos, assoc, false);
  }
  map(pos, assoc = 1) {
    return this._map(pos, assoc, true);
  }
  /**
  @internal
  */
  _map(pos, assoc, simple) {
    let diff2 = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let start4 = this.ranges[i] - (this.inverted ? diff2 : 0);
      if (start4 > pos)
        break;
      let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end2 = start4 + oldSize;
      if (pos <= end2) {
        let side = !oldSize ? assoc : pos == start4 ? -1 : pos == end2 ? 1 : assoc;
        let result = start4 + diff2 + (side < 0 ? 0 : newSize);
        if (simple)
          return result;
        let recover = pos == (assoc < 0 ? start4 : end2) ? null : makeRecover(i / 3, pos - start4);
        let del = pos == start4 ? DEL_AFTER : pos == end2 ? DEL_BEFORE : DEL_ACROSS;
        if (assoc < 0 ? pos != start4 : pos != end2)
          del |= DEL_SIDE;
        return new MapResult(result, del, recover);
      }
      diff2 += newSize - oldSize;
    }
    return simple ? pos + diff2 : new MapResult(pos + diff2, 0, null);
  }
  /**
  @internal
  */
  touches(pos, recover) {
    let diff2 = 0, index2 = recoverIndex(recover);
    let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let start4 = this.ranges[i] - (this.inverted ? diff2 : 0);
      if (start4 > pos)
        break;
      let oldSize = this.ranges[i + oldIndex], end2 = start4 + oldSize;
      if (pos <= end2 && i == index2 * 3)
        return true;
      diff2 += this.ranges[i + newIndex] - oldSize;
    }
    return false;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(f2) {
    let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
    for (let i = 0, diff2 = 0; i < this.ranges.length; i += 3) {
      let start4 = this.ranges[i], oldStart = start4 - (this.inverted ? diff2 : 0), newStart = start4 + (this.inverted ? 0 : diff2);
      let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
      f2(oldStart, oldStart + oldSize, newStart, newStart + newSize);
      diff2 += newSize - oldSize;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new StepMap(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(n2) {
    return n2 == 0 ? StepMap.empty : new StepMap(n2 < 0 ? [0, -n2, 0] : [0, 0, n2]);
  }
}
StepMap.empty = new StepMap([]);
class Mapping {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(maps, mirror, from3 = 0, to2 = maps ? maps.length : 0) {
    this.mirror = mirror;
    this.from = from3;
    this.to = to2;
    this._maps = maps || [];
    this.ownData = !(maps || mirror);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(from3 = 0, to2 = this.maps.length) {
    return new Mapping(this._maps, this.mirror, from3, to2);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(map3, mirrors) {
    if (!this.ownData) {
      this._maps = this._maps.slice();
      this.mirror = this.mirror && this.mirror.slice();
      this.ownData = true;
    }
    this.to = this._maps.push(map3);
    if (mirrors != null)
      this.setMirror(this._maps.length - 1, mirrors);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(mapping) {
    for (let i = 0, startSize = this._maps.length; i < mapping._maps.length; i++) {
      let mirr = mapping.getMirror(i);
      this.appendMap(mapping._maps[i], mirr != null && mirr < i ? startSize + mirr : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(n2) {
    if (this.mirror) {
      for (let i = 0; i < this.mirror.length; i++)
        if (this.mirror[i] == n2)
          return this.mirror[i + (i % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(n2, m2) {
    if (!this.mirror)
      this.mirror = [];
    this.mirror.push(n2, m2);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(mapping) {
    for (let i = mapping.maps.length - 1, totalSize = this._maps.length + mapping._maps.length; i >= 0; i--) {
      let mirr = mapping.getMirror(i);
      this.appendMap(mapping._maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let inverse = new Mapping();
    inverse.appendMappingInverted(this);
    return inverse;
  }
  /**
  Map a position through this mapping.
  */
  map(pos, assoc = 1) {
    if (this.mirror)
      return this._map(pos, assoc, true);
    for (let i = this.from; i < this.to; i++)
      pos = this._maps[i].map(pos, assoc);
    return pos;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(pos, assoc = 1) {
    return this._map(pos, assoc, false);
  }
  /**
  @internal
  */
  _map(pos, assoc, simple) {
    let delInfo = 0;
    for (let i = this.from; i < this.to; i++) {
      let map3 = this._maps[i], result = map3.mapResult(pos, assoc);
      if (result.recover != null) {
        let corr = this.getMirror(i);
        if (corr != null && corr > i && corr < this.to) {
          i = corr;
          pos = this._maps[corr].recover(result.recover);
          continue;
        }
      }
      delInfo |= result.delInfo;
      pos = result.pos;
    }
    return simple ? pos : new MapResult(pos, delInfo, null);
  }
}
const stepsByID = /* @__PURE__ */ Object.create(null);
class Step {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return StepMap.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(other2) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(schema, json) {
    if (!json || !json.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let type = stepsByID[json.stepType];
    if (!type)
      throw new RangeError(`No step type ${json.stepType} defined`);
    return type.fromJSON(schema, json);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(id, stepClass) {
    if (id in stepsByID)
      throw new RangeError("Duplicate use of step JSON ID " + id);
    stepsByID[id] = stepClass;
    stepClass.prototype.jsonID = id;
    return stepClass;
  }
}
class StepResult {
  /**
  @internal
  */
  constructor(doc2, failed) {
    this.doc = doc2;
    this.failed = failed;
  }
  /**
  Create a successful step result.
  */
  static ok(doc2) {
    return new StepResult(doc2, null);
  }
  /**
  Create a failed step result.
  */
  static fail(message2) {
    return new StepResult(null, message2);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(doc2, from3, to2, slice3) {
    try {
      return StepResult.ok(doc2.replace(from3, to2, slice3));
    } catch (e) {
      if (e instanceof ReplaceError)
        return StepResult.fail(e.message);
      throw e;
    }
  }
}
function mapFragment(fragment, f2, parent2) {
  let mapped = [];
  for (let i = 0; i < fragment.childCount; i++) {
    let child = fragment.child(i);
    if (child.content.size)
      child = child.copy(mapFragment(child.content, f2, child));
    if (child.isInline)
      child = f2(child, parent2, i);
    mapped.push(child);
  }
  return Fragment.fromArray(mapped);
}
class AddMarkStep extends Step {
  /**
  Create a mark step.
  */
  constructor(from3, to2, mark2) {
    super();
    this.from = from3;
    this.to = to2;
    this.mark = mark2;
  }
  apply(doc2) {
    let oldSlice = doc2.slice(this.from, this.to), $from = doc2.resolve(this.from);
    let parent2 = $from.node($from.sharedDepth(this.to));
    let slice3 = new Slice(mapFragment(oldSlice.content, (node2, parent3) => {
      if (!node2.isAtom || !parent3.type.allowsMarkType(this.mark.type))
        return node2;
      return node2.mark(this.mark.addToSet(node2.marks));
    }, parent2), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc2, this.from, this.to, slice3);
  }
  invert() {
    return new RemoveMarkStep(this.from, this.to, this.mark);
  }
  map(mapping) {
    let from3 = mapping.mapResult(this.from, 1), to2 = mapping.mapResult(this.to, -1);
    if (from3.deleted && to2.deleted || from3.pos >= to2.pos)
      return null;
    return new AddMarkStep(from3.pos, to2.pos, this.mark);
  }
  merge(other2) {
    if (other2 instanceof AddMarkStep && other2.mark.eq(this.mark) && this.from <= other2.to && this.to >= other2.from)
      return new AddMarkStep(Math.min(this.from, other2.from), Math.max(this.to, other2.to), this.mark);
    return null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new AddMarkStep(json.from, json.to, schema.markFromJSON(json.mark));
  }
}
Step.jsonID("addMark", AddMarkStep);
class RemoveMarkStep extends Step {
  /**
  Create a mark-removing step.
  */
  constructor(from3, to2, mark2) {
    super();
    this.from = from3;
    this.to = to2;
    this.mark = mark2;
  }
  apply(doc2) {
    let oldSlice = doc2.slice(this.from, this.to);
    let slice3 = new Slice(mapFragment(oldSlice.content, (node2) => {
      return node2.mark(this.mark.removeFromSet(node2.marks));
    }, doc2), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc2, this.from, this.to, slice3);
  }
  invert() {
    return new AddMarkStep(this.from, this.to, this.mark);
  }
  map(mapping) {
    let from3 = mapping.mapResult(this.from, 1), to2 = mapping.mapResult(this.to, -1);
    if (from3.deleted && to2.deleted || from3.pos >= to2.pos)
      return null;
    return new RemoveMarkStep(from3.pos, to2.pos, this.mark);
  }
  merge(other2) {
    if (other2 instanceof RemoveMarkStep && other2.mark.eq(this.mark) && this.from <= other2.to && this.to >= other2.from)
      return new RemoveMarkStep(Math.min(this.from, other2.from), Math.max(this.to, other2.to), this.mark);
    return null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new RemoveMarkStep(json.from, json.to, schema.markFromJSON(json.mark));
  }
}
Step.jsonID("removeMark", RemoveMarkStep);
class AddNodeMarkStep extends Step {
  /**
  Create a node mark step.
  */
  constructor(pos, mark2) {
    super();
    this.pos = pos;
    this.mark = mark2;
  }
  apply(doc2) {
    let node2 = doc2.nodeAt(this.pos);
    if (!node2)
      return StepResult.fail("No node at mark step's position");
    let updated = node2.type.create(node2.attrs, null, this.mark.addToSet(node2.marks));
    return StepResult.fromReplace(doc2, this.pos, this.pos + 1, new Slice(Fragment.from(updated), 0, node2.isLeaf ? 0 : 1));
  }
  invert(doc2) {
    let node2 = doc2.nodeAt(this.pos);
    if (node2) {
      let newSet = this.mark.addToSet(node2.marks);
      if (newSet.length == node2.marks.length) {
        for (let i = 0; i < node2.marks.length; i++)
          if (!node2.marks[i].isInSet(newSet))
            return new AddNodeMarkStep(this.pos, node2.marks[i]);
        return new AddNodeMarkStep(this.pos, this.mark);
      }
    }
    return new RemoveNodeMarkStep(this.pos, this.mark);
  }
  map(mapping) {
    let pos = mapping.mapResult(this.pos, 1);
    return pos.deletedAfter ? null : new AddNodeMarkStep(pos.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(schema, json) {
    if (typeof json.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new AddNodeMarkStep(json.pos, schema.markFromJSON(json.mark));
  }
}
Step.jsonID("addNodeMark", AddNodeMarkStep);
class RemoveNodeMarkStep extends Step {
  /**
  Create a mark-removing step.
  */
  constructor(pos, mark2) {
    super();
    this.pos = pos;
    this.mark = mark2;
  }
  apply(doc2) {
    let node2 = doc2.nodeAt(this.pos);
    if (!node2)
      return StepResult.fail("No node at mark step's position");
    let updated = node2.type.create(node2.attrs, null, this.mark.removeFromSet(node2.marks));
    return StepResult.fromReplace(doc2, this.pos, this.pos + 1, new Slice(Fragment.from(updated), 0, node2.isLeaf ? 0 : 1));
  }
  invert(doc2) {
    let node2 = doc2.nodeAt(this.pos);
    if (!node2 || !this.mark.isInSet(node2.marks))
      return this;
    return new AddNodeMarkStep(this.pos, this.mark);
  }
  map(mapping) {
    let pos = mapping.mapResult(this.pos, 1);
    return pos.deletedAfter ? null : new RemoveNodeMarkStep(pos.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(schema, json) {
    if (typeof json.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new RemoveNodeMarkStep(json.pos, schema.markFromJSON(json.mark));
  }
}
Step.jsonID("removeNodeMark", RemoveNodeMarkStep);
class ReplaceStep extends Step {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(from3, to2, slice3, structure = false) {
    super();
    this.from = from3;
    this.to = to2;
    this.slice = slice3;
    this.structure = structure;
  }
  apply(doc2) {
    if (this.structure && contentBetween(doc2, this.from, this.to))
      return StepResult.fail("Structure replace would overwrite content");
    return StepResult.fromReplace(doc2, this.from, this.to, this.slice);
  }
  getMap() {
    return new StepMap([this.from, this.to - this.from, this.slice.size]);
  }
  invert(doc2) {
    return new ReplaceStep(this.from, this.from + this.slice.size, doc2.slice(this.from, this.to));
  }
  map(mapping) {
    let from3 = mapping.mapResult(this.from, 1), to2 = mapping.mapResult(this.to, -1);
    if (from3.deletedAcross && to2.deletedAcross)
      return null;
    return new ReplaceStep(from3.pos, Math.max(from3.pos, to2.pos), this.slice, this.structure);
  }
  merge(other2) {
    if (!(other2 instanceof ReplaceStep) || other2.structure || this.structure)
      return null;
    if (this.from + this.slice.size == other2.from && !this.slice.openEnd && !other2.slice.openStart) {
      let slice3 = this.slice.size + other2.slice.size == 0 ? Slice.empty : new Slice(this.slice.content.append(other2.slice.content), this.slice.openStart, other2.slice.openEnd);
      return new ReplaceStep(this.from, this.to + (other2.to - other2.from), slice3, this.structure);
    } else if (other2.to == this.from && !this.slice.openStart && !other2.slice.openEnd) {
      let slice3 = this.slice.size + other2.slice.size == 0 ? Slice.empty : new Slice(other2.slice.content.append(this.slice.content), other2.slice.openStart, this.slice.openEnd);
      return new ReplaceStep(other2.from, this.to, slice3, this.structure);
    } else {
      return null;
    }
  }
  toJSON() {
    let json = { stepType: "replace", from: this.from, to: this.to };
    if (this.slice.size)
      json.slice = this.slice.toJSON();
    if (this.structure)
      json.structure = true;
    return json;
  }
  /**
  @internal
  */
  static fromJSON(schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new ReplaceStep(json.from, json.to, Slice.fromJSON(schema, json.slice), !!json.structure);
  }
}
Step.jsonID("replace", ReplaceStep);
class ReplaceAroundStep extends Step {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(from3, to2, gapFrom, gapTo, slice3, insert2, structure = false) {
    super();
    this.from = from3;
    this.to = to2;
    this.gapFrom = gapFrom;
    this.gapTo = gapTo;
    this.slice = slice3;
    this.insert = insert2;
    this.structure = structure;
  }
  apply(doc2) {
    if (this.structure && (contentBetween(doc2, this.from, this.gapFrom) || contentBetween(doc2, this.gapTo, this.to)))
      return StepResult.fail("Structure gap-replace would overwrite content");
    let gap = doc2.slice(this.gapFrom, this.gapTo);
    if (gap.openStart || gap.openEnd)
      return StepResult.fail("Gap is not a flat range");
    let inserted = this.slice.insertAt(this.insert, gap.content);
    if (!inserted)
      return StepResult.fail("Content does not fit in gap");
    return StepResult.fromReplace(doc2, this.from, this.to, inserted);
  }
  getMap() {
    return new StepMap([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(doc2) {
    let gap = this.gapTo - this.gapFrom;
    return new ReplaceAroundStep(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc2.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(mapping) {
    let from3 = mapping.mapResult(this.from, 1), to2 = mapping.mapResult(this.to, -1);
    let gapFrom = this.from == this.gapFrom ? from3.pos : mapping.map(this.gapFrom, -1);
    let gapTo = this.to == this.gapTo ? to2.pos : mapping.map(this.gapTo, 1);
    if (from3.deletedAcross && to2.deletedAcross || gapFrom < from3.pos || gapTo > to2.pos)
      return null;
    return new ReplaceAroundStep(from3.pos, to2.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let json = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    if (this.slice.size)
      json.slice = this.slice.toJSON();
    if (this.structure)
      json.structure = true;
    return json;
  }
  /**
  @internal
  */
  static fromJSON(schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new ReplaceAroundStep(json.from, json.to, json.gapFrom, json.gapTo, Slice.fromJSON(schema, json.slice), json.insert, !!json.structure);
  }
}
Step.jsonID("replaceAround", ReplaceAroundStep);
function contentBetween(doc2, from3, to2) {
  let $from = doc2.resolve(from3), dist2 = to2 - from3, depth = $from.depth;
  while (dist2 > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount) {
    depth--;
    dist2--;
  }
  if (dist2 > 0) {
    let next2 = $from.node(depth).maybeChild($from.indexAfter(depth));
    while (dist2 > 0) {
      if (!next2 || next2.isLeaf)
        return true;
      next2 = next2.firstChild;
      dist2--;
    }
  }
  return false;
}
function addMark(tr2, from3, to2, mark2) {
  let removed = [], added = [];
  let removing, adding;
  tr2.doc.nodesBetween(from3, to2, (node2, pos, parent2) => {
    if (!node2.isInline)
      return;
    let marks = node2.marks;
    if (!mark2.isInSet(marks) && parent2.type.allowsMarkType(mark2.type)) {
      let start4 = Math.max(pos, from3), end2 = Math.min(pos + node2.nodeSize, to2);
      let newSet = mark2.addToSet(marks);
      for (let i = 0; i < marks.length; i++) {
        if (!marks[i].isInSet(newSet)) {
          if (removing && removing.to == start4 && removing.mark.eq(marks[i]))
            removing.to = end2;
          else
            removed.push(removing = new RemoveMarkStep(start4, end2, marks[i]));
        }
      }
      if (adding && adding.to == start4)
        adding.to = end2;
      else
        added.push(adding = new AddMarkStep(start4, end2, mark2));
    }
  });
  removed.forEach((s2) => tr2.step(s2));
  added.forEach((s2) => tr2.step(s2));
}
function removeMark(tr2, from3, to2, mark2) {
  let matched = [], step = 0;
  tr2.doc.nodesBetween(from3, to2, (node2, pos) => {
    if (!node2.isInline)
      return;
    step++;
    let toRemove = null;
    if (mark2 instanceof MarkType) {
      let set2 = node2.marks, found2;
      while (found2 = mark2.isInSet(set2)) {
        (toRemove || (toRemove = [])).push(found2);
        set2 = found2.removeFromSet(set2);
      }
    } else if (mark2) {
      if (mark2.isInSet(node2.marks))
        toRemove = [mark2];
    } else {
      toRemove = node2.marks;
    }
    if (toRemove && toRemove.length) {
      let end2 = Math.min(pos + node2.nodeSize, to2);
      for (let i = 0; i < toRemove.length; i++) {
        let style3 = toRemove[i], found2;
        for (let j2 = 0; j2 < matched.length; j2++) {
          let m2 = matched[j2];
          if (m2.step == step - 1 && style3.eq(matched[j2].style))
            found2 = m2;
        }
        if (found2) {
          found2.to = end2;
          found2.step = step;
        } else {
          matched.push({ style: style3, from: Math.max(pos, from3), to: end2, step });
        }
      }
    }
  });
  matched.forEach((m2) => tr2.step(new RemoveMarkStep(m2.from, m2.to, m2.style)));
}
function clearIncompatible(tr2, pos, parentType, match5 = parentType.contentMatch, clearNewlines = true) {
  let node2 = tr2.doc.nodeAt(pos);
  let replSteps = [], cur = pos + 1;
  for (let i = 0; i < node2.childCount; i++) {
    let child = node2.child(i), end2 = cur + child.nodeSize;
    let allowed = match5.matchType(child.type);
    if (!allowed) {
      replSteps.push(new ReplaceStep(cur, end2, Slice.empty));
    } else {
      match5 = allowed;
      for (let j2 = 0; j2 < child.marks.length; j2++)
        if (!parentType.allowsMarkType(child.marks[j2].type))
          tr2.step(new RemoveMarkStep(cur, end2, child.marks[j2]));
      if (clearNewlines && child.isText && parentType.whitespace != "pre") {
        let m2, newline2 = /\r?\n|\r/g, slice3;
        while (m2 = newline2.exec(child.text)) {
          if (!slice3)
            slice3 = new Slice(Fragment.from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
          replSteps.push(new ReplaceStep(cur + m2.index, cur + m2.index + m2[0].length, slice3));
        }
      }
    }
    cur = end2;
  }
  if (!match5.validEnd) {
    let fill = match5.fillBefore(Fragment.empty, true);
    tr2.replace(cur, cur, new Slice(fill, 0, 0));
  }
  for (let i = replSteps.length - 1; i >= 0; i--)
    tr2.step(replSteps[i]);
}
function canCut(node2, start4, end2) {
  return (start4 == 0 || node2.canReplace(start4, node2.childCount)) && (end2 == node2.childCount || node2.canReplace(0, end2));
}
function liftTarget(range) {
  let parent2 = range.parent;
  let content2 = parent2.content.cutByIndex(range.startIndex, range.endIndex);
  for (let depth = range.depth; ; --depth) {
    let node2 = range.$from.node(depth);
    let index2 = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
    if (depth < range.depth && node2.canReplace(index2, endIndex, content2))
      return depth;
    if (depth == 0 || node2.type.spec.isolating || !canCut(node2, index2, endIndex))
      break;
  }
  return null;
}
function lift$2(tr2, range, target) {
  let { $from, $to, depth } = range;
  let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
  let start4 = gapStart, end2 = gapEnd;
  let before = Fragment.empty, openStart = 0;
  for (let d2 = depth, splitting = false; d2 > target; d2--)
    if (splitting || $from.index(d2) > 0) {
      splitting = true;
      before = Fragment.from($from.node(d2).copy(before));
      openStart++;
    } else {
      start4--;
    }
  let after = Fragment.empty, openEnd = 0;
  for (let d2 = depth, splitting = false; d2 > target; d2--)
    if (splitting || $to.after(d2 + 1) < $to.end(d2)) {
      splitting = true;
      after = Fragment.from($to.node(d2).copy(after));
      openEnd++;
    } else {
      end2++;
    }
  tr2.step(new ReplaceAroundStep(start4, end2, gapStart, gapEnd, new Slice(before.append(after), openStart, openEnd), before.size - openStart, true));
}
function findWrapping(range, nodeType, attrs = null, innerRange = range) {
  let around = findWrappingOutside(range, nodeType);
  let inner = around && findWrappingInside(innerRange, nodeType);
  if (!inner)
    return null;
  return around.map(withAttrs).concat({ type: nodeType, attrs }).concat(inner.map(withAttrs));
}
function withAttrs(type) {
  return { type, attrs: null };
}
function findWrappingOutside(range, type) {
  let { parent: parent2, startIndex, endIndex } = range;
  let around = parent2.contentMatchAt(startIndex).findWrapping(type);
  if (!around)
    return null;
  let outer = around.length ? around[0] : type;
  return parent2.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function findWrappingInside(range, type) {
  let { parent: parent2, startIndex, endIndex } = range;
  let inner = parent2.child(startIndex);
  let inside = type.contentMatch.findWrapping(inner.type);
  if (!inside)
    return null;
  let lastType = inside.length ? inside[inside.length - 1] : type;
  let innerMatch = lastType.contentMatch;
  for (let i = startIndex; innerMatch && i < endIndex; i++)
    innerMatch = innerMatch.matchType(parent2.child(i).type);
  if (!innerMatch || !innerMatch.validEnd)
    return null;
  return inside;
}
function wrap(tr2, range, wrappers) {
  let content2 = Fragment.empty;
  for (let i = wrappers.length - 1; i >= 0; i--) {
    if (content2.size) {
      let match5 = wrappers[i].type.contentMatch.matchFragment(content2);
      if (!match5 || !match5.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    content2 = Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content2));
  }
  let start4 = range.start, end2 = range.end;
  tr2.step(new ReplaceAroundStep(start4, end2, start4, end2, new Slice(content2, 0, 0), wrappers.length, true));
}
function setBlockType$1(tr2, from3, to2, type, attrs) {
  if (!type.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let mapFrom = tr2.steps.length;
  tr2.doc.nodesBetween(from3, to2, (node2, pos) => {
    let attrsHere = typeof attrs == "function" ? attrs(node2) : attrs;
    if (node2.isTextblock && !node2.hasMarkup(type, attrsHere) && canChangeType(tr2.doc, tr2.mapping.slice(mapFrom).map(pos), type)) {
      let convertNewlines = null;
      if (type.schema.linebreakReplacement) {
        let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
        if (pre && !supportLinebreak)
          convertNewlines = false;
        else if (!pre && supportLinebreak)
          convertNewlines = true;
      }
      if (convertNewlines === false)
        replaceLinebreaks(tr2, node2, pos, mapFrom);
      clearIncompatible(tr2, tr2.mapping.slice(mapFrom).map(pos, 1), type, void 0, convertNewlines === null);
      let mapping = tr2.mapping.slice(mapFrom);
      let startM = mapping.map(pos, 1), endM = mapping.map(pos + node2.nodeSize, 1);
      tr2.step(new ReplaceAroundStep(startM, endM, startM + 1, endM - 1, new Slice(Fragment.from(type.create(attrsHere, null, node2.marks)), 0, 0), 1, true));
      if (convertNewlines === true)
        replaceNewlines(tr2, node2, pos, mapFrom);
      return false;
    }
  });
}
function replaceNewlines(tr2, node2, pos, mapFrom) {
  node2.forEach((child, offset3) => {
    if (child.isText) {
      let m2, newline2 = /\r?\n|\r/g;
      while (m2 = newline2.exec(child.text)) {
        let start4 = tr2.mapping.slice(mapFrom).map(pos + 1 + offset3 + m2.index);
        tr2.replaceWith(start4, start4 + 1, node2.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function replaceLinebreaks(tr2, node2, pos, mapFrom) {
  node2.forEach((child, offset3) => {
    if (child.type == child.type.schema.linebreakReplacement) {
      let start4 = tr2.mapping.slice(mapFrom).map(pos + 1 + offset3);
      tr2.replaceWith(start4, start4 + 1, node2.type.schema.text("\n"));
    }
  });
}
function canChangeType(doc2, pos, type) {
  let $pos = doc2.resolve(pos), index2 = $pos.index();
  return $pos.parent.canReplaceWith(index2, index2 + 1, type);
}
function setNodeMarkup(tr2, pos, type, attrs, marks) {
  let node2 = tr2.doc.nodeAt(pos);
  if (!node2)
    throw new RangeError("No node at given position");
  if (!type)
    type = node2.type;
  let newNode = type.create(attrs, null, marks || node2.marks);
  if (node2.isLeaf)
    return tr2.replaceWith(pos, pos + node2.nodeSize, newNode);
  if (!type.validContent(node2.content))
    throw new RangeError("Invalid content for node type " + type.name);
  tr2.step(new ReplaceAroundStep(pos, pos + node2.nodeSize, pos + 1, pos + node2.nodeSize - 1, new Slice(Fragment.from(newNode), 0, 0), 1, true));
}
function canSplit(doc2, pos, depth = 1, typesAfter) {
  let $pos = doc2.resolve(pos), base2 = $pos.depth - depth;
  let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
  if (base2 < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount)))
    return false;
  for (let d2 = $pos.depth - 1, i = depth - 2; d2 > base2; d2--, i--) {
    let node2 = $pos.node(d2), index3 = $pos.index(d2);
    if (node2.type.spec.isolating)
      return false;
    let rest = node2.content.cutByIndex(index3, node2.childCount);
    let overrideChild = typesAfter && typesAfter[i + 1];
    if (overrideChild)
      rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
    let after = typesAfter && typesAfter[i] || node2;
    if (!node2.canReplace(index3 + 1, node2.childCount) || !after.type.validContent(rest))
      return false;
  }
  let index2 = $pos.indexAfter(base2);
  let baseType = typesAfter && typesAfter[0];
  return $pos.node(base2).canReplaceWith(index2, index2, baseType ? baseType.type : $pos.node(base2 + 1).type);
}
function split(tr2, pos, depth = 1, typesAfter) {
  let $pos = tr2.doc.resolve(pos), before = Fragment.empty, after = Fragment.empty;
  for (let d2 = $pos.depth, e = $pos.depth - depth, i = depth - 1; d2 > e; d2--, i--) {
    before = Fragment.from($pos.node(d2).copy(before));
    let typeAfter = typesAfter && typesAfter[i];
    after = Fragment.from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d2).copy(after));
  }
  tr2.step(new ReplaceStep(pos, pos, new Slice(before.append(after), depth, depth), true));
}
function canJoin(doc2, pos) {
  let $pos = doc2.resolve(pos), index2 = $pos.index();
  return joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index2, index2 + 1);
}
function canAppendWithSubstitutedLinebreaks(a2, b2) {
  if (!b2.content.size)
    a2.type.compatibleContent(b2.type);
  let match5 = a2.contentMatchAt(a2.childCount);
  let { linebreakReplacement } = a2.type.schema;
  for (let i = 0; i < b2.childCount; i++) {
    let child = b2.child(i);
    let type = child.type == linebreakReplacement ? a2.type.schema.nodes.text : child.type;
    match5 = match5.matchType(type);
    if (!match5)
      return false;
    if (!a2.type.allowsMarks(child.marks))
      return false;
  }
  return match5.validEnd;
}
function joinable(a2, b2) {
  return !!(a2 && b2 && !a2.isLeaf && canAppendWithSubstitutedLinebreaks(a2, b2));
}
function joinPoint(doc2, pos, dir = -1) {
  let $pos = doc2.resolve(pos);
  for (let d2 = $pos.depth; ; d2--) {
    let before, after, index2 = $pos.index(d2);
    if (d2 == $pos.depth) {
      before = $pos.nodeBefore;
      after = $pos.nodeAfter;
    } else if (dir > 0) {
      before = $pos.node(d2 + 1);
      index2++;
      after = $pos.node(d2).maybeChild(index2);
    } else {
      before = $pos.node(d2).maybeChild(index2 - 1);
      after = $pos.node(d2 + 1);
    }
    if (before && !before.isTextblock && joinable(before, after) && $pos.node(d2).canReplace(index2, index2 + 1))
      return pos;
    if (d2 == 0)
      break;
    pos = dir < 0 ? $pos.before(d2) : $pos.after(d2);
  }
}
function join(tr2, pos, depth) {
  let convertNewlines = null;
  let { linebreakReplacement } = tr2.doc.type.schema;
  let $before = tr2.doc.resolve(pos - depth), beforeType = $before.node().type;
  if (linebreakReplacement && beforeType.inlineContent) {
    let pre = beforeType.whitespace == "pre";
    let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
    if (pre && !supportLinebreak)
      convertNewlines = false;
    else if (!pre && supportLinebreak)
      convertNewlines = true;
  }
  let mapFrom = tr2.steps.length;
  if (convertNewlines === false) {
    let $after = tr2.doc.resolve(pos + depth);
    replaceLinebreaks(tr2, $after.node(), $after.before(), mapFrom);
  }
  if (beforeType.inlineContent)
    clearIncompatible(tr2, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
  let mapping = tr2.mapping.slice(mapFrom), start4 = mapping.map(pos - depth);
  tr2.step(new ReplaceStep(start4, mapping.map(pos + depth, -1), Slice.empty, true));
  if (convertNewlines === true) {
    let $full = tr2.doc.resolve(start4);
    replaceNewlines(tr2, $full.node(), $full.before(), tr2.steps.length);
  }
  return tr2;
}
function insertPoint(doc2, pos, nodeType) {
  let $pos = doc2.resolve(pos);
  if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType))
    return pos;
  if ($pos.parentOffset == 0)
    for (let d2 = $pos.depth - 1; d2 >= 0; d2--) {
      let index2 = $pos.index(d2);
      if ($pos.node(d2).canReplaceWith(index2, index2, nodeType))
        return $pos.before(d2 + 1);
      if (index2 > 0)
        return null;
    }
  if ($pos.parentOffset == $pos.parent.content.size)
    for (let d2 = $pos.depth - 1; d2 >= 0; d2--) {
      let index2 = $pos.indexAfter(d2);
      if ($pos.node(d2).canReplaceWith(index2, index2, nodeType))
        return $pos.after(d2 + 1);
      if (index2 < $pos.node(d2).childCount)
        return null;
    }
  return null;
}
function dropPoint(doc2, pos, slice3) {
  let $pos = doc2.resolve(pos);
  if (!slice3.content.size)
    return pos;
  let content2 = slice3.content;
  for (let i = 0; i < slice3.openStart; i++)
    content2 = content2.firstChild.content;
  for (let pass = 1; pass <= (slice3.openStart == 0 && slice3.size ? 2 : 1); pass++) {
    for (let d2 = $pos.depth; d2 >= 0; d2--) {
      let bias = d2 == $pos.depth ? 0 : $pos.pos <= ($pos.start(d2 + 1) + $pos.end(d2 + 1)) / 2 ? -1 : 1;
      let insertPos = $pos.index(d2) + (bias > 0 ? 1 : 0);
      let parent2 = $pos.node(d2), fits = false;
      if (pass == 1) {
        fits = parent2.canReplace(insertPos, insertPos, content2);
      } else {
        let wrapping = parent2.contentMatchAt(insertPos).findWrapping(content2.firstChild.type);
        fits = wrapping && parent2.canReplaceWith(insertPos, insertPos, wrapping[0]);
      }
      if (fits)
        return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d2 + 1) : $pos.after(d2 + 1);
    }
  }
  return null;
}
function replaceStep(doc2, from3, to2 = from3, slice3 = Slice.empty) {
  if (from3 == to2 && !slice3.size)
    return null;
  let $from = doc2.resolve(from3), $to = doc2.resolve(to2);
  if (fitsTrivially($from, $to, slice3))
    return new ReplaceStep(from3, to2, slice3);
  return new Fitter($from, $to, slice3).fit();
}
function fitsTrivially($from, $to, slice3) {
  return !slice3.openStart && !slice3.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice3.content);
}
class Fitter {
  constructor($from, $to, unplaced) {
    this.$from = $from;
    this.$to = $to;
    this.unplaced = unplaced;
    this.frontier = [];
    this.placed = Fragment.empty;
    for (let i = 0; i <= $from.depth; i++) {
      let node2 = $from.node(i);
      this.frontier.push({
        type: node2.type,
        match: node2.contentMatchAt($from.indexAfter(i))
      });
    }
    for (let i = $from.depth; i > 0; i--)
      this.placed = Fragment.from($from.node(i).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    while (this.unplaced.size) {
      let fit = this.findFittable();
      if (fit)
        this.placeNodes(fit);
      else
        this.openMore() || this.dropNode();
    }
    let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
    let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
    if (!$to)
      return null;
    let content2 = this.placed, openStart = $from.depth, openEnd = $to.depth;
    while (openStart && openEnd && content2.childCount == 1) {
      content2 = content2.firstChild.content;
      openStart--;
      openEnd--;
    }
    let slice3 = new Slice(content2, openStart, openEnd);
    if (moveInline > -1)
      return new ReplaceAroundStep($from.pos, moveInline, this.$to.pos, this.$to.end(), slice3, placedSize);
    if (slice3.size || $from.pos != this.$to.pos)
      return new ReplaceStep($from.pos, $to.pos, slice3);
    return null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let startDepth = this.unplaced.openStart;
    for (let cur = this.unplaced.content, d2 = 0, openEnd = this.unplaced.openEnd; d2 < startDepth; d2++) {
      let node2 = cur.firstChild;
      if (cur.childCount > 1)
        openEnd = 0;
      if (node2.type.spec.isolating && openEnd <= d2) {
        startDepth = d2;
        break;
      }
      cur = node2.content;
    }
    for (let pass = 1; pass <= 2; pass++) {
      for (let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--) {
        let fragment, parent2 = null;
        if (sliceDepth) {
          parent2 = contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
          fragment = parent2.content;
        } else {
          fragment = this.unplaced.content;
        }
        let first2 = fragment.firstChild;
        for (let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--) {
          let { type, match: match5 } = this.frontier[frontierDepth], wrap2, inject = null;
          if (pass == 1 && (first2 ? match5.matchType(first2.type) || (inject = match5.fillBefore(Fragment.from(first2), false)) : parent2 && type.compatibleContent(parent2.type)))
            return { sliceDepth, frontierDepth, parent: parent2, inject };
          else if (pass == 2 && first2 && (wrap2 = match5.findWrapping(first2.type)))
            return { sliceDepth, frontierDepth, parent: parent2, wrap: wrap2 };
          if (parent2 && match5.matchType(parent2.type))
            break;
        }
      }
    }
  }
  openMore() {
    let { content: content2, openStart, openEnd } = this.unplaced;
    let inner = contentAt(content2, openStart);
    if (!inner.childCount || inner.firstChild.isLeaf)
      return false;
    this.unplaced = new Slice(content2, openStart + 1, Math.max(openEnd, inner.size + openStart >= content2.size - openEnd ? openStart + 1 : 0));
    return true;
  }
  dropNode() {
    let { content: content2, openStart, openEnd } = this.unplaced;
    let inner = contentAt(content2, openStart);
    if (inner.childCount <= 1 && openStart > 0) {
      let openAtEnd = content2.size - openStart <= openStart + inner.size;
      this.unplaced = new Slice(dropFromFragment(content2, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
    } else {
      this.unplaced = new Slice(dropFromFragment(content2, openStart, 1), openStart, openEnd);
    }
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth, frontierDepth, parent: parent2, inject, wrap: wrap2 }) {
    while (this.depth > frontierDepth)
      this.closeFrontierNode();
    if (wrap2)
      for (let i = 0; i < wrap2.length; i++)
        this.openFrontierNode(wrap2[i]);
    let slice3 = this.unplaced, fragment = parent2 ? parent2.content : slice3.content;
    let openStart = slice3.openStart - sliceDepth;
    let taken = 0, add4 = [];
    let { match: match5, type } = this.frontier[frontierDepth];
    if (inject) {
      for (let i = 0; i < inject.childCount; i++)
        add4.push(inject.child(i));
      match5 = match5.matchFragment(inject);
    }
    let openEndCount = fragment.size + sliceDepth - (slice3.content.size - slice3.openEnd);
    while (taken < fragment.childCount) {
      let next2 = fragment.child(taken), matches2 = match5.matchType(next2.type);
      if (!matches2)
        break;
      taken++;
      if (taken > 1 || openStart == 0 || next2.content.size) {
        match5 = matches2;
        add4.push(closeNodeStart(next2.mark(type.allowedMarks(next2.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
      }
    }
    let toEnd = taken == fragment.childCount;
    if (!toEnd)
      openEndCount = -1;
    this.placed = addToFragment(this.placed, frontierDepth, Fragment.from(add4));
    this.frontier[frontierDepth].match = match5;
    if (toEnd && openEndCount < 0 && parent2 && parent2.type == this.frontier[this.depth].type && this.frontier.length > 1)
      this.closeFrontierNode();
    for (let i = 0, cur = fragment; i < openEndCount; i++) {
      let node2 = cur.lastChild;
      this.frontier.push({ type: node2.type, match: node2.contentMatchAt(node2.childCount) });
      cur = node2.content;
    }
    this.unplaced = !toEnd ? new Slice(dropFromFragment(slice3.content, sliceDepth, taken), slice3.openStart, slice3.openEnd) : sliceDepth == 0 ? Slice.empty : new Slice(dropFromFragment(slice3.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice3.openEnd : sliceDepth - 1);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let top2 = this.frontier[this.depth], level;
    if (!top2.type.isTextblock || !contentAfterFits(this.$to, this.$to.depth, top2.type, top2.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth)
      return -1;
    let { depth } = this.$to, after = this.$to.after(depth);
    while (depth > 1 && after == this.$to.end(--depth))
      ++after;
    return after;
  }
  findCloseLevel($to) {
    scan: for (let i = Math.min(this.depth, $to.depth); i >= 0; i--) {
      let { match: match5, type } = this.frontier[i];
      let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
      let fit = contentAfterFits($to, i, type, match5, dropInner);
      if (!fit)
        continue;
      for (let d2 = i - 1; d2 >= 0; d2--) {
        let { match: match7, type: type2 } = this.frontier[d2];
        let matches2 = contentAfterFits($to, d2, type2, match7, true);
        if (!matches2 || matches2.childCount)
          continue scan;
      }
      return { depth: i, fit, move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to };
    }
  }
  close($to) {
    let close2 = this.findCloseLevel($to);
    if (!close2)
      return null;
    while (this.depth > close2.depth)
      this.closeFrontierNode();
    if (close2.fit.childCount)
      this.placed = addToFragment(this.placed, close2.depth, close2.fit);
    $to = close2.move;
    for (let d2 = close2.depth + 1; d2 <= $to.depth; d2++) {
      let node2 = $to.node(d2), add4 = node2.type.contentMatch.fillBefore(node2.content, true, $to.index(d2));
      this.openFrontierNode(node2.type, node2.attrs, add4);
    }
    return $to;
  }
  openFrontierNode(type, attrs = null, content2) {
    let top2 = this.frontier[this.depth];
    top2.match = top2.match.matchType(type);
    this.placed = addToFragment(this.placed, this.depth, Fragment.from(type.create(attrs, content2)));
    this.frontier.push({ type, match: type.contentMatch });
  }
  closeFrontierNode() {
    let open = this.frontier.pop();
    let add4 = open.match.fillBefore(Fragment.empty, true);
    if (add4.childCount)
      this.placed = addToFragment(this.placed, this.frontier.length, add4);
  }
}
function dropFromFragment(fragment, depth, count2) {
  if (depth == 0)
    return fragment.cutByIndex(count2, fragment.childCount);
  return fragment.replaceChild(0, fragment.firstChild.copy(dropFromFragment(fragment.firstChild.content, depth - 1, count2)));
}
function addToFragment(fragment, depth, content2) {
  if (depth == 0)
    return fragment.append(content2);
  return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy(addToFragment(fragment.lastChild.content, depth - 1, content2)));
}
function contentAt(fragment, depth) {
  for (let i = 0; i < depth; i++)
    fragment = fragment.firstChild.content;
  return fragment;
}
function closeNodeStart(node2, openStart, openEnd) {
  if (openStart <= 0)
    return node2;
  let frag = node2.content;
  if (openStart > 1)
    frag = frag.replaceChild(0, closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
  if (openStart > 0) {
    frag = node2.type.contentMatch.fillBefore(frag).append(frag);
    if (openEnd <= 0)
      frag = frag.append(node2.type.contentMatch.matchFragment(frag).fillBefore(Fragment.empty, true));
  }
  return node2.copy(frag);
}
function contentAfterFits($to, depth, type, match5, open) {
  let node2 = $to.node(depth), index2 = open ? $to.indexAfter(depth) : $to.index(depth);
  if (index2 == node2.childCount && !type.compatibleContent(node2.type))
    return null;
  let fit = match5.fillBefore(node2.content, true, index2);
  return fit && !invalidMarks(type, node2.content, index2) ? fit : null;
}
function invalidMarks(type, fragment, start4) {
  for (let i = start4; i < fragment.childCount; i++)
    if (!type.allowsMarks(fragment.child(i).marks))
      return true;
  return false;
}
function definesContent(type) {
  return type.spec.defining || type.spec.definingForContent;
}
function replaceRange(tr2, from3, to2, slice3) {
  if (!slice3.size)
    return tr2.deleteRange(from3, to2);
  let $from = tr2.doc.resolve(from3), $to = tr2.doc.resolve(to2);
  if (fitsTrivially($from, $to, slice3))
    return tr2.step(new ReplaceStep(from3, to2, slice3));
  let targetDepths = coveredDepths($from, tr2.doc.resolve(to2));
  if (targetDepths[targetDepths.length - 1] == 0)
    targetDepths.pop();
  let preferredTarget = -($from.depth + 1);
  targetDepths.unshift(preferredTarget);
  for (let d2 = $from.depth, pos = $from.pos - 1; d2 > 0; d2--, pos--) {
    let spec = $from.node(d2).type.spec;
    if (spec.defining || spec.definingAsContext || spec.isolating)
      break;
    if (targetDepths.indexOf(d2) > -1)
      preferredTarget = d2;
    else if ($from.before(d2) == pos)
      targetDepths.splice(1, 0, -d2);
  }
  let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
  let leftNodes = [], preferredDepth = slice3.openStart;
  for (let content2 = slice3.content, i = 0; ; i++) {
    let node2 = content2.firstChild;
    leftNodes.push(node2);
    if (i == slice3.openStart)
      break;
    content2 = node2.content;
  }
  for (let d2 = preferredDepth - 1; d2 >= 0; d2--) {
    let leftNode = leftNodes[d2], def2 = definesContent(leftNode.type);
    if (def2 && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1)))
      preferredDepth = d2;
    else if (def2 || !leftNode.type.isTextblock)
      break;
  }
  for (let j2 = slice3.openStart; j2 >= 0; j2--) {
    let openDepth = (j2 + preferredDepth + 1) % (slice3.openStart + 1);
    let insert2 = leftNodes[openDepth];
    if (!insert2)
      continue;
    for (let i = 0; i < targetDepths.length; i++) {
      let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand3 = true;
      if (targetDepth < 0) {
        expand3 = false;
        targetDepth = -targetDepth;
      }
      let parent2 = $from.node(targetDepth - 1), index2 = $from.index(targetDepth - 1);
      if (parent2.canReplaceWith(index2, index2, insert2.type, insert2.marks))
        return tr2.replace($from.before(targetDepth), expand3 ? $to.after(targetDepth) : to2, new Slice(closeFragment(slice3.content, 0, slice3.openStart, openDepth), openDepth, slice3.openEnd));
    }
  }
  let startSteps = tr2.steps.length;
  for (let i = targetDepths.length - 1; i >= 0; i--) {
    tr2.replace(from3, to2, slice3);
    if (tr2.steps.length > startSteps)
      break;
    let depth = targetDepths[i];
    if (depth < 0)
      continue;
    from3 = $from.before(depth);
    to2 = $to.after(depth);
  }
}
function closeFragment(fragment, depth, oldOpen, newOpen, parent2) {
  if (depth < oldOpen) {
    let first2 = fragment.firstChild;
    fragment = fragment.replaceChild(0, first2.copy(closeFragment(first2.content, depth + 1, oldOpen, newOpen, first2)));
  }
  if (depth > newOpen) {
    let match5 = parent2.contentMatchAt(0);
    let start4 = match5.fillBefore(fragment).append(fragment);
    fragment = start4.append(match5.matchFragment(start4).fillBefore(Fragment.empty, true));
  }
  return fragment;
}
function replaceRangeWith(tr2, from3, to2, node2) {
  if (!node2.isInline && from3 == to2 && tr2.doc.resolve(from3).parent.content.size) {
    let point2 = insertPoint(tr2.doc, from3, node2.type);
    if (point2 != null)
      from3 = to2 = point2;
  }
  tr2.replaceRange(from3, to2, new Slice(Fragment.from(node2), 0, 0));
}
function deleteRange$1(tr2, from3, to2) {
  let $from = tr2.doc.resolve(from3), $to = tr2.doc.resolve(to2);
  let covered = coveredDepths($from, $to);
  for (let i = 0; i < covered.length; i++) {
    let depth = covered[i], last = i == covered.length - 1;
    if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd)
      return tr2.delete($from.start(depth), $to.end(depth));
    if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1))))
      return tr2.delete($from.before(depth), $to.after(depth));
  }
  for (let d2 = 1; d2 <= $from.depth && d2 <= $to.depth; d2++) {
    if (from3 - $from.start(d2) == $from.depth - d2 && to2 > $from.end(d2) && $to.end(d2) - to2 != $to.depth - d2 && $from.start(d2 - 1) == $to.start(d2 - 1) && $from.node(d2 - 1).canReplace($from.index(d2 - 1), $to.index(d2 - 1)))
      return tr2.delete($from.before(d2), to2);
  }
  tr2.delete(from3, to2);
}
function coveredDepths($from, $to) {
  let result = [], minDepth = Math.min($from.depth, $to.depth);
  for (let d2 = minDepth; d2 >= 0; d2--) {
    let start4 = $from.start(d2);
    if (start4 < $from.pos - ($from.depth - d2) || $to.end(d2) > $to.pos + ($to.depth - d2) || $from.node(d2).type.spec.isolating || $to.node(d2).type.spec.isolating)
      break;
    if (start4 == $to.start(d2) || d2 == $from.depth && d2 == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d2 && $to.start(d2 - 1) == start4 - 1)
      result.push(d2);
  }
  return result;
}
class AttrStep extends Step {
  /**
  Construct an attribute step.
  */
  constructor(pos, attr, value) {
    super();
    this.pos = pos;
    this.attr = attr;
    this.value = value;
  }
  apply(doc2) {
    let node2 = doc2.nodeAt(this.pos);
    if (!node2)
      return StepResult.fail("No node at attribute step's position");
    let attrs = /* @__PURE__ */ Object.create(null);
    for (let name2 in node2.attrs)
      attrs[name2] = node2.attrs[name2];
    attrs[this.attr] = this.value;
    let updated = node2.type.create(attrs, null, node2.marks);
    return StepResult.fromReplace(doc2, this.pos, this.pos + 1, new Slice(Fragment.from(updated), 0, node2.isLeaf ? 0 : 1));
  }
  getMap() {
    return StepMap.empty;
  }
  invert(doc2) {
    return new AttrStep(this.pos, this.attr, doc2.nodeAt(this.pos).attrs[this.attr]);
  }
  map(mapping) {
    let pos = mapping.mapResult(this.pos, 1);
    return pos.deletedAfter ? null : new AttrStep(pos.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(schema, json) {
    if (typeof json.pos != "number" || typeof json.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new AttrStep(json.pos, json.attr, json.value);
  }
}
Step.jsonID("attr", AttrStep);
class DocAttrStep extends Step {
  /**
  Construct an attribute step.
  */
  constructor(attr, value) {
    super();
    this.attr = attr;
    this.value = value;
  }
  apply(doc2) {
    let attrs = /* @__PURE__ */ Object.create(null);
    for (let name2 in doc2.attrs)
      attrs[name2] = doc2.attrs[name2];
    attrs[this.attr] = this.value;
    let updated = doc2.type.create(attrs, doc2.content, doc2.marks);
    return StepResult.ok(updated);
  }
  getMap() {
    return StepMap.empty;
  }
  invert(doc2) {
    return new DocAttrStep(this.attr, doc2.attrs[this.attr]);
  }
  map(mapping) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(schema, json) {
    if (typeof json.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new DocAttrStep(json.attr, json.value);
  }
}
Step.jsonID("docAttr", DocAttrStep);
let TransformError = class extends Error {
};
TransformError = function TransformError2(message2) {
  let err = Error.call(this, message2);
  err.__proto__ = TransformError2.prototype;
  return err;
};
TransformError.prototype = Object.create(Error.prototype);
TransformError.prototype.constructor = TransformError;
TransformError.prototype.name = "TransformError";
class Transform {
  /**
  Create a transform that starts with the given document.
  */
  constructor(doc2) {
    this.doc = doc2;
    this.steps = [];
    this.docs = [];
    this.mapping = new Mapping();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(step) {
    let result = this.maybeStep(step);
    if (result.failed)
      throw new TransformError(result.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(step) {
    let result = step.apply(this.doc);
    if (!result.failed)
      this.addStep(step, result.doc);
    return result;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(step, doc2) {
    this.docs.push(this.doc);
    this.steps.push(step);
    this.mapping.appendMap(step.getMap());
    this.doc = doc2;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(from3, to2 = from3, slice3 = Slice.empty) {
    let step = replaceStep(this.doc, from3, to2, slice3);
    if (step)
      this.step(step);
    return this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(from3, to2, content2) {
    return this.replace(from3, to2, new Slice(Fragment.from(content2), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(from3, to2) {
    return this.replace(from3, to2, Slice.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(pos, content2) {
    return this.replaceWith(pos, pos, content2);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(from3, to2, slice3) {
    replaceRange(this, from3, to2, slice3);
    return this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(from3, to2, node2) {
    replaceRangeWith(this, from3, to2, node2);
    return this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(from3, to2) {
    deleteRange$1(this, from3, to2);
    return this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(range, target) {
    lift$2(this, range, target);
    return this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(pos, depth = 1) {
    join(this, pos, depth);
    return this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(range, wrappers) {
    wrap(this, range, wrappers);
    return this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(from3, to2 = from3, type, attrs = null) {
    setBlockType$1(this, from3, to2, type, attrs);
    return this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(pos, type, attrs = null, marks) {
    setNodeMarkup(this, pos, type, attrs, marks);
    return this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(pos, attr, value) {
    this.step(new AttrStep(pos, attr, value));
    return this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(attr, value) {
    this.step(new DocAttrStep(attr, value));
    return this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(pos, mark2) {
    this.step(new AddNodeMarkStep(pos, mark2));
    return this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(pos, mark2) {
    let node2 = this.doc.nodeAt(pos);
    if (!node2)
      throw new RangeError("No node at position " + pos);
    if (mark2 instanceof Mark$1) {
      if (mark2.isInSet(node2.marks))
        this.step(new RemoveNodeMarkStep(pos, mark2));
    } else {
      let set2 = node2.marks, found2, steps = [];
      while (found2 = mark2.isInSet(set2)) {
        steps.push(new RemoveNodeMarkStep(pos, found2));
        set2 = found2.removeFromSet(set2);
      }
      for (let i = steps.length - 1; i >= 0; i--)
        this.step(steps[i]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(pos, depth = 1, typesAfter) {
    split(this, pos, depth, typesAfter);
    return this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(from3, to2, mark2) {
    addMark(this, from3, to2, mark2);
    return this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(from3, to2, mark2) {
    removeMark(this, from3, to2, mark2);
    return this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(pos, parentType, match5) {
    clearIncompatible(this, pos, parentType, match5);
    return this;
  }
}
const classesById = /* @__PURE__ */ Object.create(null);
class Selection {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor($anchor, $head, ranges) {
    this.$anchor = $anchor;
    this.$head = $head;
    this.ranges = ranges || [new SelectionRange($anchor.min($head), $anchor.max($head))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let ranges = this.ranges;
    for (let i = 0; i < ranges.length; i++)
      if (ranges[i].$from.pos != ranges[i].$to.pos)
        return false;
    return true;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, true);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(tr2, content2 = Slice.empty) {
    let lastNode = content2.content.lastChild, lastParent = null;
    for (let i = 0; i < content2.openEnd; i++) {
      lastParent = lastNode;
      lastNode = lastNode.lastChild;
    }
    let mapFrom = tr2.steps.length, ranges = this.ranges;
    for (let i = 0; i < ranges.length; i++) {
      let { $from, $to } = ranges[i], mapping = tr2.mapping.slice(mapFrom);
      tr2.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? Slice.empty : content2);
      if (i == 0)
        selectionToInsertionEnd$1(tr2, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(tr2, node2) {
    let mapFrom = tr2.steps.length, ranges = this.ranges;
    for (let i = 0; i < ranges.length; i++) {
      let { $from, $to } = ranges[i], mapping = tr2.mapping.slice(mapFrom);
      let from3 = mapping.map($from.pos), to2 = mapping.map($to.pos);
      if (i) {
        tr2.deleteRange(from3, to2);
      } else {
        tr2.replaceRangeWith(from3, to2, node2);
        selectionToInsertionEnd$1(tr2, mapFrom, node2.isInline ? -1 : 1);
      }
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom($pos, dir, textOnly = false) {
    let inner = $pos.parent.inlineContent ? new TextSelection($pos) : findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
    if (inner)
      return inner;
    for (let depth = $pos.depth - 1; depth >= 0; depth--) {
      let found2 = dir < 0 ? findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
      if (found2)
        return found2;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near($pos, bias = 1) {
    return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new AllSelection($pos.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(doc2) {
    return findSelectionIn(doc2, doc2, 0, 0, 1) || new AllSelection(doc2);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(doc2) {
    return findSelectionIn(doc2, doc2, doc2.content.size, doc2.childCount, -1) || new AllSelection(doc2);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(doc2, json) {
    if (!json || !json.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let cls = classesById[json.type];
    if (!cls)
      throw new RangeError(`No selection type ${json.type} defined`);
    return cls.fromJSON(doc2, json);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(id, selectionClass) {
    if (id in classesById)
      throw new RangeError("Duplicate use of selection JSON ID " + id);
    classesById[id] = selectionClass;
    selectionClass.prototype.jsonID = id;
    return selectionClass;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return TextSelection.between(this.$anchor, this.$head).getBookmark();
  }
}
Selection.prototype.visible = true;
class SelectionRange {
  /**
  Create a range.
  */
  constructor($from, $to) {
    this.$from = $from;
    this.$to = $to;
  }
}
let warnedAboutTextSelection = false;
function checkTextSelection($pos) {
  if (!warnedAboutTextSelection && !$pos.parent.inlineContent) {
    warnedAboutTextSelection = true;
    console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
  }
}
class TextSelection extends Selection {
  /**
  Construct a text selection between the given points.
  */
  constructor($anchor, $head = $anchor) {
    checkTextSelection($anchor);
    checkTextSelection($head);
    super($anchor, $head);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(doc2, mapping) {
    let $head = doc2.resolve(mapping.map(this.head));
    if (!$head.parent.inlineContent)
      return Selection.near($head);
    let $anchor = doc2.resolve(mapping.map(this.anchor));
    return new TextSelection($anchor.parent.inlineContent ? $anchor : $head, $head);
  }
  replace(tr2, content2 = Slice.empty) {
    super.replace(tr2, content2);
    if (content2 == Slice.empty) {
      let marks = this.$from.marksAcross(this.$to);
      if (marks)
        tr2.ensureMarks(marks);
    }
  }
  eq(other2) {
    return other2 instanceof TextSelection && other2.anchor == this.anchor && other2.head == this.head;
  }
  getBookmark() {
    return new TextBookmark(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(doc2, json) {
    if (typeof json.anchor != "number" || typeof json.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new TextSelection(doc2.resolve(json.anchor), doc2.resolve(json.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(doc2, anchor, head = anchor) {
    let $anchor = doc2.resolve(anchor);
    return new this($anchor, head == anchor ? $anchor : doc2.resolve(head));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between($anchor, $head, bias) {
    let dPos = $anchor.pos - $head.pos;
    if (!bias || dPos)
      bias = dPos >= 0 ? 1 : -1;
    if (!$head.parent.inlineContent) {
      let found2 = Selection.findFrom($head, bias, true) || Selection.findFrom($head, -bias, true);
      if (found2)
        $head = found2.$head;
      else
        return Selection.near($head, bias);
    }
    if (!$anchor.parent.inlineContent) {
      if (dPos == 0) {
        $anchor = $head;
      } else {
        $anchor = (Selection.findFrom($anchor, -bias, true) || Selection.findFrom($anchor, bias, true)).$anchor;
        if ($anchor.pos < $head.pos != dPos < 0)
          $anchor = $head;
      }
    }
    return new TextSelection($anchor, $head);
  }
}
Selection.jsonID("text", TextSelection);
class TextBookmark {
  constructor(anchor, head) {
    this.anchor = anchor;
    this.head = head;
  }
  map(mapping) {
    return new TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
  }
  resolve(doc2) {
    return TextSelection.between(doc2.resolve(this.anchor), doc2.resolve(this.head));
  }
}
class NodeSelection extends Selection {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor($pos) {
    let node2 = $pos.nodeAfter;
    let $end = $pos.node(0).resolve($pos.pos + node2.nodeSize);
    super($pos, $end);
    this.node = node2;
  }
  map(doc2, mapping) {
    let { deleted, pos } = mapping.mapResult(this.anchor);
    let $pos = doc2.resolve(pos);
    if (deleted)
      return Selection.near($pos);
    return new NodeSelection($pos);
  }
  content() {
    return new Slice(Fragment.from(this.node), 0, 0);
  }
  eq(other2) {
    return other2 instanceof NodeSelection && other2.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new NodeBookmark(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(doc2, json) {
    if (typeof json.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new NodeSelection(doc2.resolve(json.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(doc2, from3) {
    return new NodeSelection(doc2.resolve(from3));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(node2) {
    return !node2.isText && node2.type.spec.selectable !== false;
  }
}
NodeSelection.prototype.visible = false;
Selection.jsonID("node", NodeSelection);
class NodeBookmark {
  constructor(anchor) {
    this.anchor = anchor;
  }
  map(mapping) {
    let { deleted, pos } = mapping.mapResult(this.anchor);
    return deleted ? new TextBookmark(pos, pos) : new NodeBookmark(pos);
  }
  resolve(doc2) {
    let $pos = doc2.resolve(this.anchor), node2 = $pos.nodeAfter;
    if (node2 && NodeSelection.isSelectable(node2))
      return new NodeSelection($pos);
    return Selection.near($pos);
  }
}
class AllSelection extends Selection {
  /**
  Create an all-selection over the given document.
  */
  constructor(doc2) {
    super(doc2.resolve(0), doc2.resolve(doc2.content.size));
  }
  replace(tr2, content2 = Slice.empty) {
    if (content2 == Slice.empty) {
      tr2.delete(0, tr2.doc.content.size);
      let sel = Selection.atStart(tr2.doc);
      if (!sel.eq(tr2.selection))
        tr2.setSelection(sel);
    } else {
      super.replace(tr2, content2);
    }
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(doc2) {
    return new AllSelection(doc2);
  }
  map(doc2) {
    return new AllSelection(doc2);
  }
  eq(other2) {
    return other2 instanceof AllSelection;
  }
  getBookmark() {
    return AllBookmark;
  }
}
Selection.jsonID("all", AllSelection);
const AllBookmark = {
  map() {
    return this;
  },
  resolve(doc2) {
    return new AllSelection(doc2);
  }
};
function findSelectionIn(doc2, node2, pos, index2, dir, text2 = false) {
  if (node2.inlineContent)
    return TextSelection.create(doc2, pos);
  for (let i = index2 - (dir > 0 ? 0 : 1); dir > 0 ? i < node2.childCount : i >= 0; i += dir) {
    let child = node2.child(i);
    if (!child.isAtom) {
      let inner = findSelectionIn(doc2, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text2);
      if (inner)
        return inner;
    } else if (!text2 && NodeSelection.isSelectable(child)) {
      return NodeSelection.create(doc2, pos - (dir < 0 ? child.nodeSize : 0));
    }
    pos += child.nodeSize * dir;
  }
  return null;
}
function selectionToInsertionEnd$1(tr2, startLen, bias) {
  let last = tr2.steps.length - 1;
  if (last < startLen)
    return;
  let step = tr2.steps[last];
  if (!(step instanceof ReplaceStep || step instanceof ReplaceAroundStep))
    return;
  let map3 = tr2.mapping.maps[last], end2;
  map3.forEach((_from, _to, _newFrom, newTo) => {
    if (end2 == null)
      end2 = newTo;
  });
  tr2.setSelection(Selection.near(tr2.doc.resolve(end2), bias));
}
const UPDATED_SEL = 1, UPDATED_MARKS = 2, UPDATED_SCROLL = 4;
class Transaction extends Transform {
  /**
  @internal
  */
  constructor(state) {
    super(state.doc);
    this.curSelectionFor = 0;
    this.updated = 0;
    this.meta = /* @__PURE__ */ Object.create(null);
    this.time = Date.now();
    this.curSelection = state.selection;
    this.storedMarks = state.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    if (this.curSelectionFor < this.steps.length) {
      this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
      this.curSelectionFor = this.steps.length;
    }
    return this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(selection) {
    if (selection.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    this.curSelection = selection;
    this.curSelectionFor = this.steps.length;
    this.updated = (this.updated | UPDATED_SEL) & ~UPDATED_MARKS;
    this.storedMarks = null;
    return this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & UPDATED_SEL) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(marks) {
    this.storedMarks = marks;
    this.updated |= UPDATED_MARKS;
    return this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(marks) {
    if (!Mark$1.sameSet(this.storedMarks || this.selection.$from.marks(), marks))
      this.setStoredMarks(marks);
    return this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(mark2) {
    return this.ensureMarks(mark2.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(mark2) {
    return this.ensureMarks(mark2.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & UPDATED_MARKS) > 0;
  }
  /**
  @internal
  */
  addStep(step, doc2) {
    super.addStep(step, doc2);
    this.updated = this.updated & ~UPDATED_MARKS;
    this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(time) {
    this.time = time;
    return this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(slice3) {
    this.selection.replace(this, slice3);
    return this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(node2, inheritMarks = true) {
    let selection = this.selection;
    if (inheritMarks)
      node2 = node2.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || Mark$1.none));
    selection.replaceWith(this, node2);
    return this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    this.selection.replace(this);
    return this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(text2, from3, to2) {
    let schema = this.doc.type.schema;
    if (from3 == null) {
      if (!text2)
        return this.deleteSelection();
      return this.replaceSelectionWith(schema.text(text2), true);
    } else {
      if (to2 == null)
        to2 = from3;
      to2 = to2 == null ? from3 : to2;
      if (!text2)
        return this.deleteRange(from3, to2);
      let marks = this.storedMarks;
      if (!marks) {
        let $from = this.doc.resolve(from3);
        marks = to2 == from3 ? $from.marks() : $from.marksAcross(this.doc.resolve(to2));
      }
      this.replaceRangeWith(from3, to2, schema.text(text2, marks));
      if (!this.selection.empty)
        this.setSelection(Selection.near(this.selection.$to));
      return this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(key2, value) {
    this.meta[typeof key2 == "string" ? key2 : key2.key] = value;
    return this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(key2) {
    return this.meta[typeof key2 == "string" ? key2 : key2.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let _2 in this.meta)
      return false;
    return true;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    this.updated |= UPDATED_SCROLL;
    return this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & UPDATED_SCROLL) > 0;
  }
}
function bind(f2, self2) {
  return !self2 || !f2 ? f2 : f2.bind(self2);
}
class FieldDesc {
  constructor(name2, desc, self2) {
    this.name = name2;
    this.init = bind(desc.init, self2);
    this.apply = bind(desc.apply, self2);
  }
}
const baseFields = [
  new FieldDesc("doc", {
    init(config2) {
      return config2.doc || config2.schema.topNodeType.createAndFill();
    },
    apply(tr2) {
      return tr2.doc;
    }
  }),
  new FieldDesc("selection", {
    init(config2, instance) {
      return config2.selection || Selection.atStart(instance.doc);
    },
    apply(tr2) {
      return tr2.selection;
    }
  }),
  new FieldDesc("storedMarks", {
    init(config2) {
      return config2.storedMarks || null;
    },
    apply(tr2, _marks, _old, state) {
      return state.selection.$cursor ? tr2.storedMarks : null;
    }
  }),
  new FieldDesc("scrollToSelection", {
    init() {
      return 0;
    },
    apply(tr2, prev2) {
      return tr2.scrolledIntoView ? prev2 + 1 : prev2;
    }
  })
];
class Configuration {
  constructor(schema, plugins) {
    this.schema = schema;
    this.plugins = [];
    this.pluginsByKey = /* @__PURE__ */ Object.create(null);
    this.fields = baseFields.slice();
    if (plugins)
      plugins.forEach((plugin2) => {
        if (this.pluginsByKey[plugin2.key])
          throw new RangeError("Adding different instances of a keyed plugin (" + plugin2.key + ")");
        this.plugins.push(plugin2);
        this.pluginsByKey[plugin2.key] = plugin2;
        if (plugin2.spec.state)
          this.fields.push(new FieldDesc(plugin2.key, plugin2.spec.state, plugin2));
      });
  }
}
class EditorState {
  /**
  @internal
  */
  constructor(config2) {
    this.config = config2;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(tr2) {
    return this.applyTransaction(tr2).state;
  }
  /**
  @internal
  */
  filterTransaction(tr2, ignore2 = -1) {
    for (let i = 0; i < this.config.plugins.length; i++)
      if (i != ignore2) {
        let plugin2 = this.config.plugins[i];
        if (plugin2.spec.filterTransaction && !plugin2.spec.filterTransaction.call(plugin2, tr2, this))
          return false;
      }
    return true;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(rootTr) {
    if (!this.filterTransaction(rootTr))
      return { state: this, transactions: [] };
    let trs = [rootTr], newState = this.applyInner(rootTr), seen = null;
    for (; ; ) {
      let haveNew = false;
      for (let i = 0; i < this.config.plugins.length; i++) {
        let plugin2 = this.config.plugins[i];
        if (plugin2.spec.appendTransaction) {
          let n2 = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
          let tr2 = n2 < trs.length && plugin2.spec.appendTransaction.call(plugin2, n2 ? trs.slice(n2) : trs, oldState, newState);
          if (tr2 && newState.filterTransaction(tr2, i)) {
            tr2.setMeta("appendedTransaction", rootTr);
            if (!seen) {
              seen = [];
              for (let j2 = 0; j2 < this.config.plugins.length; j2++)
                seen.push(j2 < i ? { state: newState, n: trs.length } : { state: this, n: 0 });
            }
            trs.push(tr2);
            newState = newState.applyInner(tr2);
            haveNew = true;
          }
          if (seen)
            seen[i] = { state: newState, n: trs.length };
        }
      }
      if (!haveNew)
        return { state: newState, transactions: trs };
    }
  }
  /**
  @internal
  */
  applyInner(tr2) {
    if (!tr2.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let newInstance = new EditorState(this.config), fields = this.config.fields;
    for (let i = 0; i < fields.length; i++) {
      let field = fields[i];
      newInstance[field.name] = field.apply(tr2, this[field.name], this, newInstance);
    }
    return newInstance;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new Transaction(this);
  }
  /**
  Create a new state.
  */
  static create(config2) {
    let $config = new Configuration(config2.doc ? config2.doc.type.schema : config2.schema, config2.plugins);
    let instance = new EditorState($config);
    for (let i = 0; i < $config.fields.length; i++)
      instance[$config.fields[i].name] = $config.fields[i].init(config2, instance);
    return instance;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(config2) {
    let $config = new Configuration(this.schema, config2.plugins);
    let fields = $config.fields, instance = new EditorState($config);
    for (let i = 0; i < fields.length; i++) {
      let name2 = fields[i].name;
      instance[name2] = this.hasOwnProperty(name2) ? this[name2] : fields[i].init(config2, instance);
    }
    return instance;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(pluginFields) {
    let result = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks)
      result.storedMarks = this.storedMarks.map((m2) => m2.toJSON());
    if (pluginFields && typeof pluginFields == "object")
      for (let prop in pluginFields) {
        if (prop == "doc" || prop == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let plugin2 = pluginFields[prop], state = plugin2.spec.state;
        if (state && state.toJSON)
          result[prop] = state.toJSON.call(plugin2, this[plugin2.key]);
      }
    return result;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(config2, json, pluginFields) {
    if (!json)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!config2.schema)
      throw new RangeError("Required config field 'schema' missing");
    let $config = new Configuration(config2.schema, config2.plugins);
    let instance = new EditorState($config);
    $config.fields.forEach((field) => {
      if (field.name == "doc") {
        instance.doc = Node$2.fromJSON(config2.schema, json.doc);
      } else if (field.name == "selection") {
        instance.selection = Selection.fromJSON(instance.doc, json.selection);
      } else if (field.name == "storedMarks") {
        if (json.storedMarks)
          instance.storedMarks = json.storedMarks.map(config2.schema.markFromJSON);
      } else {
        if (pluginFields)
          for (let prop in pluginFields) {
            let plugin2 = pluginFields[prop], state = plugin2.spec.state;
            if (plugin2.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
              instance[field.name] = state.fromJSON.call(plugin2, config2, json[prop], instance);
              return;
            }
          }
        instance[field.name] = field.init(config2, instance);
      }
    });
    return instance;
  }
}
function bindProps(obj, self2, target) {
  for (let prop in obj) {
    let val = obj[prop];
    if (val instanceof Function)
      val = val.bind(self2);
    else if (prop == "handleDOMEvents")
      val = bindProps(val, self2, {});
    target[prop] = val;
  }
  return target;
}
class Plugin {
  /**
  Create a plugin.
  */
  constructor(spec) {
    this.spec = spec;
    this.props = {};
    if (spec.props)
      bindProps(spec.props, this, this.props);
    this.key = spec.key ? spec.key.key : createKey("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(state) {
    return state[this.key];
  }
}
const keys = /* @__PURE__ */ Object.create(null);
function createKey(name2) {
  if (name2 in keys)
    return name2 + "$" + ++keys[name2];
  keys[name2] = 0;
  return name2 + "$";
}
class PluginKey {
  /**
  Create a plugin key.
  */
  constructor(name2 = "key") {
    this.key = createKey(name2);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(state) {
    return state.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(state) {
    return state[this.key];
  }
}
const domIndex = function(node2) {
  for (var index2 = 0; ; index2++) {
    node2 = node2.previousSibling;
    if (!node2)
      return index2;
  }
};
const parentNode = function(node2) {
  let parent2 = node2.assignedSlot || node2.parentNode;
  return parent2 && parent2.nodeType == 11 ? parent2.host : parent2;
};
let reusedRange = null;
const textRange = function(node2, from3, to2) {
  let range = reusedRange || (reusedRange = document.createRange());
  range.setEnd(node2, to2 == null ? node2.nodeValue.length : to2);
  range.setStart(node2, from3 || 0);
  return range;
};
const clearReusedRange = function() {
  reusedRange = null;
};
const isEquivalentPosition = function(node2, off, targetNode, targetOff) {
  return targetNode && (scanFor(node2, off, targetNode, targetOff, -1) || scanFor(node2, off, targetNode, targetOff, 1));
};
const atomElements = /^(img|br|input|textarea|hr)$/i;
function scanFor(node2, off, targetNode, targetOff, dir) {
  var _a3;
  for (; ; ) {
    if (node2 == targetNode && off == targetOff)
      return true;
    if (off == (dir < 0 ? 0 : nodeSize(node2))) {
      let parent2 = node2.parentNode;
      if (!parent2 || parent2.nodeType != 1 || hasBlockDesc(node2) || atomElements.test(node2.nodeName) || node2.contentEditable == "false")
        return false;
      off = domIndex(node2) + (dir < 0 ? 0 : 1);
      node2 = parent2;
    } else if (node2.nodeType == 1) {
      let child = node2.childNodes[off + (dir < 0 ? -1 : 0)];
      if (child.nodeType == 1 && child.contentEditable == "false") {
        if ((_a3 = child.pmViewDesc) === null || _a3 === void 0 ? void 0 : _a3.ignoreForSelection)
          off += dir;
        else
          return false;
      } else {
        node2 = child;
        off = dir < 0 ? nodeSize(node2) : 0;
      }
    } else {
      return false;
    }
  }
}
function nodeSize(node2) {
  return node2.nodeType == 3 ? node2.nodeValue.length : node2.childNodes.length;
}
function textNodeBefore$1(node2, offset3) {
  for (; ; ) {
    if (node2.nodeType == 3 && offset3)
      return node2;
    if (node2.nodeType == 1 && offset3 > 0) {
      if (node2.contentEditable == "false")
        return null;
      node2 = node2.childNodes[offset3 - 1];
      offset3 = nodeSize(node2);
    } else if (node2.parentNode && !hasBlockDesc(node2)) {
      offset3 = domIndex(node2);
      node2 = node2.parentNode;
    } else {
      return null;
    }
  }
}
function textNodeAfter$1(node2, offset3) {
  for (; ; ) {
    if (node2.nodeType == 3 && offset3 < node2.nodeValue.length)
      return node2;
    if (node2.nodeType == 1 && offset3 < node2.childNodes.length) {
      if (node2.contentEditable == "false")
        return null;
      node2 = node2.childNodes[offset3];
      offset3 = 0;
    } else if (node2.parentNode && !hasBlockDesc(node2)) {
      offset3 = domIndex(node2) + 1;
      node2 = node2.parentNode;
    } else {
      return null;
    }
  }
}
function isOnEdge(node2, offset3, parent2) {
  for (let atStart = offset3 == 0, atEnd = offset3 == nodeSize(node2); atStart || atEnd; ) {
    if (node2 == parent2)
      return true;
    let index2 = domIndex(node2);
    node2 = node2.parentNode;
    if (!node2)
      return false;
    atStart = atStart && index2 == 0;
    atEnd = atEnd && index2 == nodeSize(node2);
  }
}
function hasBlockDesc(dom) {
  let desc;
  for (let cur = dom; cur; cur = cur.parentNode)
    if (desc = cur.pmViewDesc)
      break;
  return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
const selectionCollapsed = function(domSel) {
  return domSel.focusNode && isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function keyEvent(keyCode, key2) {
  let event = document.createEvent("Event");
  event.initEvent("keydown", true, true);
  event.keyCode = keyCode;
  event.key = event.code = key2;
  return event;
}
function deepActiveElement(doc2) {
  let elt = doc2.activeElement;
  while (elt && elt.shadowRoot)
    elt = elt.shadowRoot.activeElement;
  return elt;
}
function caretFromPoint(doc2, x2, y2) {
  if (doc2.caretPositionFromPoint) {
    try {
      let pos = doc2.caretPositionFromPoint(x2, y2);
      if (pos)
        return { node: pos.offsetNode, offset: Math.min(nodeSize(pos.offsetNode), pos.offset) };
    } catch (_2) {
    }
  }
  if (doc2.caretRangeFromPoint) {
    let range = doc2.caretRangeFromPoint(x2, y2);
    if (range)
      return { node: range.startContainer, offset: Math.min(nodeSize(range.startContainer), range.startOffset) };
  }
}
const nav = typeof navigator != "undefined" ? navigator : null;
const doc = typeof document != "undefined" ? document : null;
const agent = nav && nav.userAgent || "";
const ie_edge = /Edge\/(\d+)/.exec(agent);
const ie_upto10 = /MSIE \d/.exec(agent);
const ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(agent);
const ie$1 = !!(ie_upto10 || ie_11up || ie_edge);
const ie_version = ie_upto10 ? document.documentMode : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : 0;
const gecko = !ie$1 && /gecko\/(\d+)/i.test(agent);
gecko && +(/Firefox\/(\d+)/.exec(agent) || [0, 0])[1];
const _chrome = !ie$1 && /Chrome\/(\d+)/.exec(agent);
const chrome = !!_chrome;
const chrome_version = _chrome ? +_chrome[1] : 0;
const safari = !ie$1 && !!nav && /Apple Computer/.test(nav.vendor);
const ios = safari && (/Mobile\/\w+/.test(agent) || !!nav && nav.maxTouchPoints > 2);
const mac$2 = ios || (nav ? /Mac/.test(nav.platform) : false);
const windows$1 = nav ? /Win/.test(nav.platform) : false;
const android = /Android \d/.test(agent);
const webkit = !!doc && "webkitFontSmoothing" in doc.documentElement.style;
const webkit_version = webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function windowRect(doc2) {
  let vp = doc2.defaultView && doc2.defaultView.visualViewport;
  if (vp)
    return {
      left: 0,
      right: vp.width,
      top: 0,
      bottom: vp.height
    };
  return {
    left: 0,
    right: doc2.documentElement.clientWidth,
    top: 0,
    bottom: doc2.documentElement.clientHeight
  };
}
function getSide(value, side) {
  return typeof value == "number" ? value : value[side];
}
function clientRect(node2) {
  let rect = node2.getBoundingClientRect();
  let scaleX = rect.width / node2.offsetWidth || 1;
  let scaleY = rect.height / node2.offsetHeight || 1;
  return {
    left: rect.left,
    right: rect.left + node2.clientWidth * scaleX,
    top: rect.top,
    bottom: rect.top + node2.clientHeight * scaleY
  };
}
function scrollRectIntoView(view, rect, startDOM) {
  let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
  let doc2 = view.dom.ownerDocument;
  for (let parent2 = startDOM || view.dom; ; ) {
    if (!parent2)
      break;
    if (parent2.nodeType != 1) {
      parent2 = parentNode(parent2);
      continue;
    }
    let elt = parent2;
    let atTop = elt == doc2.body;
    let bounding = atTop ? windowRect(doc2) : clientRect(elt);
    let moveX = 0, moveY = 0;
    if (rect.top < bounding.top + getSide(scrollThreshold, "top"))
      moveY = -(bounding.top - rect.top + getSide(scrollMargin, "top"));
    else if (rect.bottom > bounding.bottom - getSide(scrollThreshold, "bottom"))
      moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + getSide(scrollMargin, "bottom");
    if (rect.left < bounding.left + getSide(scrollThreshold, "left"))
      moveX = -(bounding.left - rect.left + getSide(scrollMargin, "left"));
    else if (rect.right > bounding.right - getSide(scrollThreshold, "right"))
      moveX = rect.right - bounding.right + getSide(scrollMargin, "right");
    if (moveX || moveY) {
      if (atTop) {
        doc2.defaultView.scrollBy(moveX, moveY);
      } else {
        let startX = elt.scrollLeft, startY = elt.scrollTop;
        if (moveY)
          elt.scrollTop += moveY;
        if (moveX)
          elt.scrollLeft += moveX;
        let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
        rect = { left: rect.left - dX, top: rect.top - dY, right: rect.right - dX, bottom: rect.bottom - dY };
      }
    }
    let pos = atTop ? "fixed" : getComputedStyle(parent2).position;
    if (/^(fixed|sticky)$/.test(pos))
      break;
    parent2 = pos == "absolute" ? parent2.offsetParent : parentNode(parent2);
  }
}
function storeScrollPos(view) {
  let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
  let refDOM, refTop;
  for (let x2 = (rect.left + rect.right) / 2, y2 = startY + 1; y2 < Math.min(innerHeight, rect.bottom); y2 += 5) {
    let dom = view.root.elementFromPoint(x2, y2);
    if (!dom || dom == view.dom || !view.dom.contains(dom))
      continue;
    let localRect = dom.getBoundingClientRect();
    if (localRect.top >= startY - 20) {
      refDOM = dom;
      refTop = localRect.top;
      break;
    }
  }
  return { refDOM, refTop, stack: scrollStack(view.dom) };
}
function scrollStack(dom) {
  let stack = [], doc2 = dom.ownerDocument;
  for (let cur = dom; cur; cur = parentNode(cur)) {
    stack.push({ dom: cur, top: cur.scrollTop, left: cur.scrollLeft });
    if (dom == doc2)
      break;
  }
  return stack;
}
function resetScrollPos({ refDOM, refTop, stack }) {
  let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
  restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function restoreScrollStack(stack, dTop) {
  for (let i = 0; i < stack.length; i++) {
    let { dom, top: top2, left: left2 } = stack[i];
    if (dom.scrollTop != top2 + dTop)
      dom.scrollTop = top2 + dTop;
    if (dom.scrollLeft != left2)
      dom.scrollLeft = left2;
  }
}
let preventScrollSupported = null;
function focusPreventScroll(dom) {
  if (dom.setActive)
    return dom.setActive();
  if (preventScrollSupported)
    return dom.focus(preventScrollSupported);
  let stored = scrollStack(dom);
  dom.focus(preventScrollSupported == null ? {
    get preventScroll() {
      preventScrollSupported = { preventScroll: true };
      return true;
    }
  } : void 0);
  if (!preventScrollSupported) {
    preventScrollSupported = false;
    restoreScrollStack(stored, 0);
  }
}
function findOffsetInNode(node2, coords) {
  let closest4, dxClosest = 2e8, coordsClosest, offset3 = 0;
  let rowBot = coords.top, rowTop = coords.top;
  let firstBelow, coordsBelow;
  for (let child = node2.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++) {
    let rects;
    if (child.nodeType == 1)
      rects = child.getClientRects();
    else if (child.nodeType == 3)
      rects = textRange(child).getClientRects();
    else
      continue;
    for (let i = 0; i < rects.length; i++) {
      let rect = rects[i];
      if (rect.top <= rowBot && rect.bottom >= rowTop) {
        rowBot = Math.max(rect.bottom, rowBot);
        rowTop = Math.min(rect.top, rowTop);
        let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
        if (dx < dxClosest) {
          closest4 = child;
          dxClosest = dx;
          coordsClosest = dx && closest4.nodeType == 3 ? {
            left: rect.right < coords.left ? rect.right : rect.left,
            top: coords.top
          } : coords;
          if (child.nodeType == 1 && dx)
            offset3 = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
          continue;
        }
      } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
        firstBelow = child;
        coordsBelow = { left: Math.max(rect.left, Math.min(rect.right, coords.left)), top: rect.top };
      }
      if (!closest4 && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom))
        offset3 = childIndex + 1;
    }
  }
  if (!closest4 && firstBelow) {
    closest4 = firstBelow;
    coordsClosest = coordsBelow;
    dxClosest = 0;
  }
  if (closest4 && closest4.nodeType == 3)
    return findOffsetInText(closest4, coordsClosest);
  if (!closest4 || dxClosest && closest4.nodeType == 1)
    return { node: node2, offset: offset3 };
  return findOffsetInNode(closest4, coordsClosest);
}
function findOffsetInText(node2, coords) {
  let len = node2.nodeValue.length;
  let range = document.createRange();
  for (let i = 0; i < len; i++) {
    range.setEnd(node2, i + 1);
    range.setStart(node2, i);
    let rect = singleRect(range, 1);
    if (rect.top == rect.bottom)
      continue;
    if (inRect(coords, rect))
      return { node: node2, offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0) };
  }
  return { node: node2, offset: 0 };
}
function inRect(coords, rect) {
  return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function targetKludge(dom, coords) {
  let parent2 = dom.parentNode;
  if (parent2 && /^li$/i.test(parent2.nodeName) && coords.left < dom.getBoundingClientRect().left)
    return parent2;
  return dom;
}
function posFromElement(view, elt, coords) {
  let { node: node2, offset: offset3 } = findOffsetInNode(elt, coords), bias = -1;
  if (node2.nodeType == 1 && !node2.firstChild) {
    let rect = node2.getBoundingClientRect();
    bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
  }
  return view.docView.posFromDOM(node2, offset3, bias);
}
function posFromCaret(view, node2, offset3, coords) {
  let outsideBlock = -1;
  for (let cur = node2, sawBlock = false; ; ) {
    if (cur == view.dom)
      break;
    let desc = view.docView.nearestDesc(cur, true), rect;
    if (!desc)
      return null;
    if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
      if (desc.node.isBlock && desc.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(desc.dom.nodeName)) {
        if (!sawBlock && rect.left > coords.left || rect.top > coords.top)
          outsideBlock = desc.posBefore;
        else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top)
          outsideBlock = desc.posAfter;
        sawBlock = true;
      }
      if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
        let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
        return before ? desc.posBefore : desc.posAfter;
      }
    }
    cur = desc.dom.parentNode;
  }
  return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node2, offset3, -1);
}
function elementFromPoint(element2, coords, box) {
  let len = element2.childNodes.length;
  if (len && box.top < box.bottom) {
    for (let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI; ; ) {
      let child = element2.childNodes[i];
      if (child.nodeType == 1) {
        let rects = child.getClientRects();
        for (let j2 = 0; j2 < rects.length; j2++) {
          let rect = rects[j2];
          if (inRect(coords, rect))
            return elementFromPoint(child, coords, rect);
        }
      }
      if ((i = (i + 1) % len) == startI)
        break;
    }
  }
  return element2;
}
function posAtCoords(view, coords) {
  let doc2 = view.dom.ownerDocument, node2, offset3 = 0;
  let caret2 = caretFromPoint(doc2, coords.left, coords.top);
  if (caret2)
    ({ node: node2, offset: offset3 } = caret2);
  let elt = (view.root.elementFromPoint ? view.root : doc2).elementFromPoint(coords.left, coords.top);
  let pos;
  if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
    let box = view.dom.getBoundingClientRect();
    if (!inRect(coords, box))
      return null;
    elt = elementFromPoint(view.dom, coords, box);
    if (!elt)
      return null;
  }
  if (safari) {
    for (let p2 = elt; node2 && p2; p2 = parentNode(p2))
      if (p2.draggable)
        node2 = void 0;
  }
  elt = targetKludge(elt, coords);
  if (node2) {
    if (gecko && node2.nodeType == 1) {
      offset3 = Math.min(offset3, node2.childNodes.length);
      if (offset3 < node2.childNodes.length) {
        let next2 = node2.childNodes[offset3], box;
        if (next2.nodeName == "IMG" && (box = next2.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top)
          offset3++;
      }
    }
    let prev2;
    if (webkit && offset3 && node2.nodeType == 1 && (prev2 = node2.childNodes[offset3 - 1]).nodeType == 1 && prev2.contentEditable == "false" && prev2.getBoundingClientRect().top >= coords.top)
      offset3--;
    if (node2 == view.dom && offset3 == node2.childNodes.length - 1 && node2.lastChild.nodeType == 1 && coords.top > node2.lastChild.getBoundingClientRect().bottom)
      pos = view.state.doc.content.size;
    else if (offset3 == 0 || node2.nodeType != 1 || node2.childNodes[offset3 - 1].nodeName != "BR")
      pos = posFromCaret(view, node2, offset3, coords);
  }
  if (pos == null)
    pos = posFromElement(view, elt, coords);
  let desc = view.docView.nearestDesc(elt, true);
  return { pos, inside: desc ? desc.posAtStart - desc.border : -1 };
}
function nonZero(rect) {
  return rect.top < rect.bottom || rect.left < rect.right;
}
function singleRect(target, bias) {
  let rects = target.getClientRects();
  if (rects.length) {
    let first2 = rects[bias < 0 ? 0 : rects.length - 1];
    if (nonZero(first2))
      return first2;
  }
  return Array.prototype.find.call(rects, nonZero) || target.getBoundingClientRect();
}
const BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function coordsAtPos(view, pos, side) {
  let { node: node2, offset: offset3, atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
  let supportEmptyRange = webkit || gecko;
  if (node2.nodeType == 3) {
    if (supportEmptyRange && (BIDI.test(node2.nodeValue) || (side < 0 ? !offset3 : offset3 == node2.nodeValue.length))) {
      let rect = singleRect(textRange(node2, offset3, offset3), side);
      if (gecko && offset3 && /\s/.test(node2.nodeValue[offset3 - 1]) && offset3 < node2.nodeValue.length) {
        let rectBefore = singleRect(textRange(node2, offset3 - 1, offset3 - 1), -1);
        if (rectBefore.top == rect.top) {
          let rectAfter = singleRect(textRange(node2, offset3, offset3 + 1), -1);
          if (rectAfter.top != rect.top)
            return flattenV(rectAfter, rectAfter.left < rectBefore.left);
        }
      }
      return rect;
    } else {
      let from3 = offset3, to2 = offset3, takeSide = side < 0 ? 1 : -1;
      if (side < 0 && !offset3) {
        to2++;
        takeSide = -1;
      } else if (side >= 0 && offset3 == node2.nodeValue.length) {
        from3--;
        takeSide = 1;
      } else if (side < 0) {
        from3--;
      } else {
        to2++;
      }
      return flattenV(singleRect(textRange(node2, from3, to2), takeSide), takeSide < 0);
    }
  }
  let $dom = view.state.doc.resolve(pos - (atom || 0));
  if (!$dom.parent.inlineContent) {
    if (atom == null && offset3 && (side < 0 || offset3 == nodeSize(node2))) {
      let before = node2.childNodes[offset3 - 1];
      if (before.nodeType == 1)
        return flattenH(before.getBoundingClientRect(), false);
    }
    if (atom == null && offset3 < nodeSize(node2)) {
      let after = node2.childNodes[offset3];
      if (after.nodeType == 1)
        return flattenH(after.getBoundingClientRect(), true);
    }
    return flattenH(node2.getBoundingClientRect(), side >= 0);
  }
  if (atom == null && offset3 && (side < 0 || offset3 == nodeSize(node2))) {
    let before = node2.childNodes[offset3 - 1];
    let target = before.nodeType == 3 ? textRange(before, nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
    if (target)
      return flattenV(singleRect(target, 1), false);
  }
  if (atom == null && offset3 < nodeSize(node2)) {
    let after = node2.childNodes[offset3];
    while (after.pmViewDesc && after.pmViewDesc.ignoreForCoords)
      after = after.nextSibling;
    let target = !after ? null : after.nodeType == 3 ? textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
    if (target)
      return flattenV(singleRect(target, -1), true);
  }
  return flattenV(singleRect(node2.nodeType == 3 ? textRange(node2) : node2, -side), side >= 0);
}
function flattenV(rect, left2) {
  if (rect.width == 0)
    return rect;
  let x2 = left2 ? rect.left : rect.right;
  return { top: rect.top, bottom: rect.bottom, left: x2, right: x2 };
}
function flattenH(rect, top2) {
  if (rect.height == 0)
    return rect;
  let y2 = top2 ? rect.top : rect.bottom;
  return { top: y2, bottom: y2, left: rect.left, right: rect.right };
}
function withFlushedState(view, state, f2) {
  let viewState = view.state, active = view.root.activeElement;
  if (viewState != state)
    view.updateState(state);
  if (active != view.dom)
    view.focus();
  try {
    return f2();
  } finally {
    if (viewState != state)
      view.updateState(viewState);
    if (active != view.dom && active)
      active.focus();
  }
}
function endOfTextblockVertical(view, state, dir) {
  let sel = state.selection;
  let $pos = dir == "up" ? sel.$from : sel.$to;
  return withFlushedState(view, state, () => {
    let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
    for (; ; ) {
      let nearest = view.docView.nearestDesc(dom, true);
      if (!nearest)
        break;
      if (nearest.node.isBlock) {
        dom = nearest.contentDOM || nearest.dom;
        break;
      }
      dom = nearest.dom.parentNode;
    }
    let coords = coordsAtPos(view, $pos.pos, 1);
    for (let child = dom.firstChild; child; child = child.nextSibling) {
      let boxes;
      if (child.nodeType == 1)
        boxes = child.getClientRects();
      else if (child.nodeType == 3)
        boxes = textRange(child, 0, child.nodeValue.length).getClientRects();
      else
        continue;
      for (let i = 0; i < boxes.length; i++) {
        let box = boxes[i];
        if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2))
          return false;
      }
    }
    return true;
  });
}
const maybeRTL = /[\u0590-\u08ac]/;
function endOfTextblockHorizontal(view, state, dir) {
  let { $head } = state.selection;
  if (!$head.parent.isTextblock)
    return false;
  let offset3 = $head.parentOffset, atStart = !offset3, atEnd = offset3 == $head.parent.content.size;
  let sel = view.domSelection();
  if (!sel)
    return $head.pos == $head.start() || $head.pos == $head.end();
  if (!maybeRTL.test($head.parent.textContent) || !sel.modify)
    return dir == "left" || dir == "backward" ? atStart : atEnd;
  return withFlushedState(view, state, () => {
    let { focusNode: oldNode, focusOffset: oldOff, anchorNode, anchorOffset } = view.domSelectionRange();
    let oldBidiLevel = sel.caretBidiLevel;
    sel.modify("move", dir, "character");
    let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
    let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
    let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
    try {
      sel.collapse(anchorNode, anchorOffset);
      if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend)
        sel.extend(oldNode, oldOff);
    } catch (_2) {
    }
    if (oldBidiLevel != null)
      sel.caretBidiLevel = oldBidiLevel;
    return result;
  });
}
let cachedState = null;
let cachedDir = null;
let cachedResult = false;
function endOfTextblock(view, state, dir) {
  if (cachedState == state && cachedDir == dir)
    return cachedResult;
  cachedState = state;
  cachedDir = dir;
  return cachedResult = dir == "up" || dir == "down" ? endOfTextblockVertical(view, state, dir) : endOfTextblockHorizontal(view, state, dir);
}
const NOT_DIRTY = 0, CHILD_DIRTY = 1, CONTENT_DIRTY = 2, NODE_DIRTY = 3;
class ViewDesc {
  constructor(parent2, children, dom, contentDOM) {
    this.parent = parent2;
    this.children = children;
    this.dom = dom;
    this.contentDOM = contentDOM;
    this.dirty = NOT_DIRTY;
    dom.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(widget) {
    return false;
  }
  matchesMark(mark2) {
    return false;
  }
  matchesNode(node2, outerDeco, innerDeco) {
    return false;
  }
  matchesHack(nodeName) {
    return false;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(event) {
    return false;
  }
  // The size of the content represented by this desc.
  get size() {
    let size2 = 0;
    for (let i = 0; i < this.children.length; i++)
      size2 += this.children[i].size;
    return size2;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0;
    if (this.dom.pmViewDesc == this)
      this.dom.pmViewDesc = void 0;
    for (let i = 0; i < this.children.length; i++)
      this.children[i].destroy();
  }
  posBeforeChild(child) {
    for (let i = 0, pos = this.posAtStart; ; i++) {
      let cur = this.children[i];
      if (cur == child)
        return pos;
      pos += cur.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(dom, offset3, bias) {
    if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
      if (bias < 0) {
        let domBefore, desc;
        if (dom == this.contentDOM) {
          domBefore = dom.childNodes[offset3 - 1];
        } else {
          while (dom.parentNode != this.contentDOM)
            dom = dom.parentNode;
          domBefore = dom.previousSibling;
        }
        while (domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))
          domBefore = domBefore.previousSibling;
        return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
      } else {
        let domAfter, desc;
        if (dom == this.contentDOM) {
          domAfter = dom.childNodes[offset3];
        } else {
          while (dom.parentNode != this.contentDOM)
            dom = dom.parentNode;
          domAfter = dom.nextSibling;
        }
        while (domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))
          domAfter = domAfter.nextSibling;
        return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
      }
    }
    let atEnd;
    if (dom == this.dom && this.contentDOM) {
      atEnd = offset3 > domIndex(this.contentDOM);
    } else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) {
      atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
    } else if (this.dom.firstChild) {
      if (offset3 == 0)
        for (let search2 = dom; ; search2 = search2.parentNode) {
          if (search2 == this.dom) {
            atEnd = false;
            break;
          }
          if (search2.previousSibling)
            break;
        }
      if (atEnd == null && offset3 == dom.childNodes.length)
        for (let search2 = dom; ; search2 = search2.parentNode) {
          if (search2 == this.dom) {
            atEnd = true;
            break;
          }
          if (search2.nextSibling)
            break;
        }
    }
    return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(dom, onlyNodes = false) {
    for (let first2 = true, cur = dom; cur; cur = cur.parentNode) {
      let desc = this.getDesc(cur), nodeDOM;
      if (desc && (!onlyNodes || desc.node)) {
        if (first2 && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom))
          first2 = false;
        else
          return desc;
      }
    }
  }
  getDesc(dom) {
    let desc = dom.pmViewDesc;
    for (let cur = desc; cur; cur = cur.parent)
      if (cur == this)
        return desc;
  }
  posFromDOM(dom, offset3, bias) {
    for (let scan = dom; scan; scan = scan.parentNode) {
      let desc = this.getDesc(scan);
      if (desc)
        return desc.localPosFromDOM(dom, offset3, bias);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(pos) {
    for (let i = 0, offset3 = 0; i < this.children.length; i++) {
      let child = this.children[i], end2 = offset3 + child.size;
      if (offset3 == pos && end2 != offset3) {
        while (!child.border && child.children.length) {
          for (let i2 = 0; i2 < child.children.length; i2++) {
            let inner = child.children[i2];
            if (inner.size) {
              child = inner;
              break;
            }
          }
        }
        return child;
      }
      if (pos < end2)
        return child.descAt(pos - offset3 - child.border);
      offset3 = end2;
    }
  }
  domFromPos(pos, side) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: pos + 1 };
    let i = 0, offset3 = 0;
    for (let curPos = 0; i < this.children.length; i++) {
      let child = this.children[i], end2 = curPos + child.size;
      if (end2 > pos || child instanceof TrailingHackViewDesc) {
        offset3 = pos - curPos;
        break;
      }
      curPos = end2;
    }
    if (offset3)
      return this.children[i].domFromPos(offset3 - this.children[i].border, side);
    for (let prev2; i && !(prev2 = this.children[i - 1]).size && prev2 instanceof WidgetViewDesc && prev2.side >= 0; i--) {
    }
    if (side <= 0) {
      let prev2, enter2 = true;
      for (; ; i--, enter2 = false) {
        prev2 = i ? this.children[i - 1] : null;
        if (!prev2 || prev2.dom.parentNode == this.contentDOM)
          break;
      }
      if (prev2 && side && enter2 && !prev2.border && !prev2.domAtom)
        return prev2.domFromPos(prev2.size, side);
      return { node: this.contentDOM, offset: prev2 ? domIndex(prev2.dom) + 1 : 0 };
    } else {
      let next2, enter2 = true;
      for (; ; i++, enter2 = false) {
        next2 = i < this.children.length ? this.children[i] : null;
        if (!next2 || next2.dom.parentNode == this.contentDOM)
          break;
      }
      if (next2 && enter2 && !next2.border && !next2.domAtom)
        return next2.domFromPos(0, side);
      return { node: this.contentDOM, offset: next2 ? domIndex(next2.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(from3, to2, base2 = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: from3, to: to2, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let fromOffset = -1, toOffset = -1;
    for (let offset3 = base2, i = 0; ; i++) {
      let child = this.children[i], end2 = offset3 + child.size;
      if (fromOffset == -1 && from3 <= end2) {
        let childBase = offset3 + child.border;
        if (from3 >= childBase && to2 <= end2 - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM))
          return child.parseRange(from3, to2, childBase);
        from3 = offset3;
        for (let j2 = i; j2 > 0; j2--) {
          let prev2 = this.children[j2 - 1];
          if (prev2.size && prev2.dom.parentNode == this.contentDOM && !prev2.emptyChildAt(1)) {
            fromOffset = domIndex(prev2.dom) + 1;
            break;
          }
          from3 -= prev2.size;
        }
        if (fromOffset == -1)
          fromOffset = 0;
      }
      if (fromOffset > -1 && (end2 > to2 || i == this.children.length - 1)) {
        to2 = end2;
        for (let j2 = i + 1; j2 < this.children.length; j2++) {
          let next2 = this.children[j2];
          if (next2.size && next2.dom.parentNode == this.contentDOM && !next2.emptyChildAt(-1)) {
            toOffset = domIndex(next2.dom);
            break;
          }
          to2 += next2.size;
        }
        if (toOffset == -1)
          toOffset = this.contentDOM.childNodes.length;
        break;
      }
      offset3 = end2;
    }
    return { node: this.contentDOM, from: from3, to: to2, fromOffset, toOffset };
  }
  emptyChildAt(side) {
    if (this.border || !this.contentDOM || !this.children.length)
      return false;
    let child = this.children[side < 0 ? 0 : this.children.length - 1];
    return child.size == 0 || child.emptyChildAt(side);
  }
  domAfterPos(pos) {
    let { node: node2, offset: offset3 } = this.domFromPos(pos, 0);
    if (node2.nodeType != 1 || offset3 == node2.childNodes.length)
      throw new RangeError("No node after pos " + pos);
    return node2.childNodes[offset3];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(anchor, head, view, force = false) {
    let from3 = Math.min(anchor, head), to2 = Math.max(anchor, head);
    for (let i = 0, offset3 = 0; i < this.children.length; i++) {
      let child = this.children[i], end2 = offset3 + child.size;
      if (from3 > offset3 && to2 < end2)
        return child.setSelection(anchor - offset3 - child.border, head - offset3 - child.border, view, force);
      offset3 = end2;
    }
    let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
    let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
    let domSel = view.root.getSelection();
    let selRange = view.domSelectionRange();
    let brKludge = false;
    if ((gecko || safari) && anchor == head) {
      let { node: node2, offset: offset3 } = anchorDOM;
      if (node2.nodeType == 3) {
        brKludge = !!(offset3 && node2.nodeValue[offset3 - 1] == "\n");
        if (brKludge && offset3 == node2.nodeValue.length) {
          for (let scan = node2, after; scan; scan = scan.parentNode) {
            if (after = scan.nextSibling) {
              if (after.nodeName == "BR")
                anchorDOM = headDOM = { node: after.parentNode, offset: domIndex(after) + 1 };
              break;
            }
            let desc = scan.pmViewDesc;
            if (desc && desc.node && desc.node.isBlock)
              break;
          }
        }
      } else {
        let prev2 = node2.childNodes[offset3 - 1];
        brKludge = prev2 && (prev2.nodeName == "BR" || prev2.contentEditable == "false");
      }
    }
    if (gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
      let after = selRange.focusNode.childNodes[selRange.focusOffset];
      if (after && after.contentEditable == "false")
        force = true;
    }
    if (!(force || brKludge && safari) && isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset))
      return;
    let domSelExtended = false;
    if ((domSel.extend || anchor == head) && !brKludge) {
      domSel.collapse(anchorDOM.node, anchorDOM.offset);
      try {
        if (anchor != head)
          domSel.extend(headDOM.node, headDOM.offset);
        domSelExtended = true;
      } catch (_2) {
      }
    }
    if (!domSelExtended) {
      if (anchor > head) {
        let tmp = anchorDOM;
        anchorDOM = headDOM;
        headDOM = tmp;
      }
      let range = document.createRange();
      range.setEnd(headDOM.node, headDOM.offset);
      range.setStart(anchorDOM.node, anchorDOM.offset);
      domSel.removeAllRanges();
      domSel.addRange(range);
    }
  }
  ignoreMutation(mutation) {
    return !this.contentDOM && mutation.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(from3, to2) {
    for (let offset3 = 0, i = 0; i < this.children.length; i++) {
      let child = this.children[i], end2 = offset3 + child.size;
      if (offset3 == end2 ? from3 <= end2 && to2 >= offset3 : from3 < end2 && to2 > offset3) {
        let startInside = offset3 + child.border, endInside = end2 - child.border;
        if (from3 >= startInside && to2 <= endInside) {
          this.dirty = from3 == offset3 || to2 == end2 ? CONTENT_DIRTY : CHILD_DIRTY;
          if (from3 == startInside && to2 == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM))
            child.dirty = NODE_DIRTY;
          else
            child.markDirty(from3 - startInside, to2 - startInside);
          return;
        } else {
          child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? CONTENT_DIRTY : NODE_DIRTY;
        }
      }
      offset3 = end2;
    }
    this.dirty = CONTENT_DIRTY;
  }
  markParentsDirty() {
    let level = 1;
    for (let node2 = this.parent; node2; node2 = node2.parent, level++) {
      let dirty = level == 1 ? CONTENT_DIRTY : CHILD_DIRTY;
      if (node2.dirty < dirty)
        node2.dirty = dirty;
    }
  }
  get domAtom() {
    return false;
  }
  get ignoreForCoords() {
    return false;
  }
  get ignoreForSelection() {
    return false;
  }
  isText(text2) {
    return false;
  }
}
class WidgetViewDesc extends ViewDesc {
  constructor(parent2, widget, view, pos) {
    let self2, dom = widget.type.toDOM;
    if (typeof dom == "function")
      dom = dom(view, () => {
        if (!self2)
          return pos;
        if (self2.parent)
          return self2.parent.posBeforeChild(self2);
      });
    if (!widget.type.spec.raw) {
      if (dom.nodeType != 1) {
        let wrap2 = document.createElement("span");
        wrap2.appendChild(dom);
        dom = wrap2;
      }
      dom.contentEditable = "false";
      dom.classList.add("ProseMirror-widget");
    }
    super(parent2, [], dom, null);
    this.widget = widget;
    this.widget = widget;
    self2 = this;
  }
  matchesWidget(widget) {
    return this.dirty == NOT_DIRTY && widget.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: true };
  }
  stopEvent(event) {
    let stop = this.widget.spec.stopEvent;
    return stop ? stop(event) : false;
  }
  ignoreMutation(mutation) {
    return mutation.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom);
    super.destroy();
  }
  get domAtom() {
    return true;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class CompositionViewDesc extends ViewDesc {
  constructor(parent2, dom, textDOM, text2) {
    super(parent2, [], dom, null);
    this.textDOM = textDOM;
    this.text = text2;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(dom, offset3) {
    if (dom != this.textDOM)
      return this.posAtStart + (offset3 ? this.size : 0);
    return this.posAtStart + offset3;
  }
  domFromPos(pos) {
    return { node: this.textDOM, offset: pos };
  }
  ignoreMutation(mut) {
    return mut.type === "characterData" && mut.target.nodeValue == mut.oldValue;
  }
}
class MarkViewDesc extends ViewDesc {
  constructor(parent2, mark2, dom, contentDOM, spec) {
    super(parent2, [], dom, contentDOM);
    this.mark = mark2;
    this.spec = spec;
  }
  static create(parent2, mark2, inline2, view) {
    let custom2 = view.nodeViews[mark2.type.name];
    let spec = custom2 && custom2(mark2, view, inline2);
    if (!spec || !spec.dom)
      spec = DOMSerializer.renderSpec(document, mark2.type.spec.toDOM(mark2, inline2), null, mark2.attrs);
    return new MarkViewDesc(parent2, mark2, spec.dom, spec.contentDOM || spec.dom, spec);
  }
  parseRule() {
    if (this.dirty & NODE_DIRTY || this.mark.type.spec.reparseInView)
      return null;
    return { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(mark2) {
    return this.dirty != NODE_DIRTY && this.mark.eq(mark2);
  }
  markDirty(from3, to2) {
    super.markDirty(from3, to2);
    if (this.dirty != NOT_DIRTY) {
      let parent2 = this.parent;
      while (!parent2.node)
        parent2 = parent2.parent;
      if (parent2.dirty < this.dirty)
        parent2.dirty = this.dirty;
      this.dirty = NOT_DIRTY;
    }
  }
  slice(from3, to2, view) {
    let copy2 = MarkViewDesc.create(this.parent, this.mark, true, view);
    let nodes = this.children, size2 = this.size;
    if (to2 < size2)
      nodes = replaceNodes(nodes, to2, size2, view);
    if (from3 > 0)
      nodes = replaceNodes(nodes, 0, from3, view);
    for (let i = 0; i < nodes.length; i++)
      nodes[i].parent = copy2;
    copy2.children = nodes;
    return copy2;
  }
  ignoreMutation(mutation) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
  }
  destroy() {
    if (this.spec.destroy)
      this.spec.destroy();
    super.destroy();
  }
}
class NodeViewDesc extends ViewDesc {
  constructor(parent2, node2, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos) {
    super(parent2, [], dom, contentDOM);
    this.node = node2;
    this.outerDeco = outerDeco;
    this.innerDeco = innerDeco;
    this.nodeDOM = nodeDOM;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(parent2, node2, outerDeco, innerDeco, view, pos) {
    let custom2 = view.nodeViews[node2.type.name], descObj;
    let spec = custom2 && custom2(node2, view, () => {
      if (!descObj)
        return pos;
      if (descObj.parent)
        return descObj.parent.posBeforeChild(descObj);
    }, outerDeco, innerDeco);
    let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
    if (node2.isText) {
      if (!dom)
        dom = document.createTextNode(node2.text);
      else if (dom.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else if (!dom) {
      let spec2 = DOMSerializer.renderSpec(document, node2.type.spec.toDOM(node2), null, node2.attrs);
      ({ dom, contentDOM } = spec2);
    }
    if (!contentDOM && !node2.isText && dom.nodeName != "BR") {
      if (!dom.hasAttribute("contenteditable"))
        dom.contentEditable = "false";
      if (node2.type.spec.draggable)
        dom.draggable = true;
    }
    let nodeDOM = dom;
    dom = applyOuterDeco(dom, outerDeco, node2);
    if (spec)
      return descObj = new CustomNodeViewDesc(parent2, node2, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
    else if (node2.isText)
      return new TextViewDesc(parent2, node2, outerDeco, innerDeco, dom, nodeDOM, view);
    else
      return new NodeViewDesc(parent2, node2, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let rule = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre")
      rule.preserveWhitespace = "full";
    if (!this.contentDOM) {
      rule.getContent = () => this.node.content;
    } else if (!this.contentLost) {
      rule.contentElement = this.contentDOM;
    } else {
      for (let i = this.children.length - 1; i >= 0; i--) {
        let child = this.children[i];
        if (this.dom.contains(child.dom.parentNode)) {
          rule.contentElement = child.dom.parentNode;
          break;
        }
      }
      if (!rule.contentElement)
        rule.getContent = () => Fragment.empty;
    }
    return rule;
  }
  matchesNode(node2, outerDeco, innerDeco) {
    return this.dirty == NOT_DIRTY && node2.eq(this.node) && sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(view, pos) {
    let inline2 = this.node.inlineContent, off = pos;
    let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
    let localComposition = composition && composition.pos > -1 ? composition : null;
    let compositionInChild = composition && composition.pos < 0;
    let updater = new ViewTreeUpdater(this, localComposition && localComposition.node, view);
    iterDeco(this.node, this.innerDeco, (widget, i, insideNode) => {
      if (widget.spec.marks)
        updater.syncToMarks(widget.spec.marks, inline2, view);
      else if (widget.type.side >= 0 && !insideNode)
        updater.syncToMarks(i == this.node.childCount ? Mark$1.none : this.node.child(i).marks, inline2, view);
      updater.placeWidget(widget, view, off);
    }, (child, outerDeco, innerDeco, i) => {
      updater.syncToMarks(child.marks, inline2, view);
      let compIndex;
      if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
      else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
      else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
      else {
        updater.addNode(child, outerDeco, innerDeco, view, off);
      }
      off += child.nodeSize;
    });
    updater.syncToMarks([], inline2, view);
    if (this.node.isTextblock)
      updater.addTextblockHacks();
    updater.destroyRest();
    if (updater.changed || this.dirty == CONTENT_DIRTY) {
      if (localComposition)
        this.protectLocalComposition(view, localComposition);
      renderDescs(this.contentDOM, this.children, view);
      if (ios)
        iosHacks(this.dom);
    }
  }
  localCompositionInfo(view, pos) {
    let { from: from3, to: to2 } = view.state.selection;
    if (!(view.state.selection instanceof TextSelection) || from3 < pos || to2 > pos + this.node.content.size)
      return null;
    let textNode = view.input.compositionNode;
    if (!textNode || !this.dom.contains(textNode.parentNode))
      return null;
    if (this.node.inlineContent) {
      let text2 = textNode.nodeValue;
      let textPos = findTextInFragment(this.node.content, text2, from3 - pos, to2 - pos);
      return textPos < 0 ? null : { node: textNode, pos: textPos, text: text2 };
    } else {
      return { node: textNode, pos: -1, text: "" };
    }
  }
  protectLocalComposition(view, { node: node2, pos, text: text2 }) {
    if (this.getDesc(node2))
      return;
    let topNode = node2;
    for (; ; topNode = topNode.parentNode) {
      if (topNode.parentNode == this.contentDOM)
        break;
      while (topNode.previousSibling)
        topNode.parentNode.removeChild(topNode.previousSibling);
      while (topNode.nextSibling)
        topNode.parentNode.removeChild(topNode.nextSibling);
      if (topNode.pmViewDesc)
        topNode.pmViewDesc = void 0;
    }
    let desc = new CompositionViewDesc(this, topNode, node2, text2);
    view.input.compositionNodes.push(desc);
    this.children = replaceNodes(this.children, pos, pos + text2.length, view, desc);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(node2, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY || !node2.sameMarkup(this.node))
      return false;
    this.updateInner(node2, outerDeco, innerDeco, view);
    return true;
  }
  updateInner(node2, outerDeco, innerDeco, view) {
    this.updateOuterDeco(outerDeco);
    this.node = node2;
    this.innerDeco = innerDeco;
    if (this.contentDOM)
      this.updateChildren(view, this.posAtStart);
    this.dirty = NOT_DIRTY;
  }
  updateOuterDeco(outerDeco) {
    if (sameOuterDeco(outerDeco, this.outerDeco))
      return;
    let needsWrap = this.nodeDOM.nodeType != 1;
    let oldDOM = this.dom;
    this.dom = patchOuterDeco(this.dom, this.nodeDOM, computeOuterDeco(this.outerDeco, this.node, needsWrap), computeOuterDeco(outerDeco, this.node, needsWrap));
    if (this.dom != oldDOM) {
      oldDOM.pmViewDesc = void 0;
      this.dom.pmViewDesc = this;
    }
    this.outerDeco = outerDeco;
  }
  // Mark this node as being the selected node.
  selectNode() {
    if (this.nodeDOM.nodeType == 1)
      this.nodeDOM.classList.add("ProseMirror-selectednode");
    if (this.contentDOM || !this.node.type.spec.draggable)
      this.dom.draggable = true;
  }
  // Remove selected node marking from this node.
  deselectNode() {
    if (this.nodeDOM.nodeType == 1) {
      this.nodeDOM.classList.remove("ProseMirror-selectednode");
      if (this.contentDOM || !this.node.type.spec.draggable)
        this.dom.removeAttribute("draggable");
    }
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function docViewDesc(doc2, outerDeco, innerDeco, dom, view) {
  applyOuterDeco(dom, outerDeco, doc2);
  let docView = new NodeViewDesc(void 0, doc2, outerDeco, innerDeco, dom, dom, dom, view, 0);
  if (docView.contentDOM)
    docView.updateChildren(view, 0);
  return docView;
}
class TextViewDesc extends NodeViewDesc {
  constructor(parent2, node2, outerDeco, innerDeco, dom, nodeDOM, view) {
    super(parent2, node2, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
  }
  parseRule() {
    let skip = this.nodeDOM.parentNode;
    while (skip && skip != this.dom && !skip.pmIsDeco)
      skip = skip.parentNode;
    return { skip: skip || true };
  }
  update(node2, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY || this.dirty != NOT_DIRTY && !this.inParent() || !node2.sameMarkup(this.node))
      return false;
    this.updateOuterDeco(outerDeco);
    if ((this.dirty != NOT_DIRTY || node2.text != this.node.text) && node2.text != this.nodeDOM.nodeValue) {
      this.nodeDOM.nodeValue = node2.text;
      if (view.trackWrites == this.nodeDOM)
        view.trackWrites = null;
    }
    this.node = node2;
    this.dirty = NOT_DIRTY;
    return true;
  }
  inParent() {
    let parentDOM = this.parent.contentDOM;
    for (let n2 = this.nodeDOM; n2; n2 = n2.parentNode)
      if (n2 == parentDOM)
        return true;
    return false;
  }
  domFromPos(pos) {
    return { node: this.nodeDOM, offset: pos };
  }
  localPosFromDOM(dom, offset3, bias) {
    if (dom == this.nodeDOM)
      return this.posAtStart + Math.min(offset3, this.node.text.length);
    return super.localPosFromDOM(dom, offset3, bias);
  }
  ignoreMutation(mutation) {
    return mutation.type != "characterData" && mutation.type != "selection";
  }
  slice(from3, to2, view) {
    let node2 = this.node.cut(from3, to2), dom = document.createTextNode(node2.text);
    return new TextViewDesc(this.parent, node2, this.outerDeco, this.innerDeco, dom, dom, view);
  }
  markDirty(from3, to2) {
    super.markDirty(from3, to2);
    if (this.dom != this.nodeDOM && (from3 == 0 || to2 == this.nodeDOM.nodeValue.length))
      this.dirty = NODE_DIRTY;
  }
  get domAtom() {
    return false;
  }
  isText(text2) {
    return this.node.text == text2;
  }
}
class TrailingHackViewDesc extends ViewDesc {
  parseRule() {
    return { ignore: true };
  }
  matchesHack(nodeName) {
    return this.dirty == NOT_DIRTY && this.dom.nodeName == nodeName;
  }
  get domAtom() {
    return true;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class CustomNodeViewDesc extends NodeViewDesc {
  constructor(parent2, node2, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos) {
    super(parent2, node2, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
    this.spec = spec;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(node2, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY)
      return false;
    if (this.spec.update && (this.node.type == node2.type || this.spec.multiType)) {
      let result = this.spec.update(node2, outerDeco, innerDeco);
      if (result)
        this.updateInner(node2, outerDeco, innerDeco, view);
      return result;
    } else if (!this.contentDOM && !node2.isLeaf) {
      return false;
    } else {
      return super.update(node2, outerDeco, innerDeco, view);
    }
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(anchor, head, view, force) {
    this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
  }
  destroy() {
    if (this.spec.destroy)
      this.spec.destroy();
    super.destroy();
  }
  stopEvent(event) {
    return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
  }
  ignoreMutation(mutation) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
  }
}
function renderDescs(parentDOM, descs, view) {
  let dom = parentDOM.firstChild, written = false;
  for (let i = 0; i < descs.length; i++) {
    let desc = descs[i], childDOM = desc.dom;
    if (childDOM.parentNode == parentDOM) {
      while (childDOM != dom) {
        dom = rm(dom);
        written = true;
      }
      dom = dom.nextSibling;
    } else {
      written = true;
      parentDOM.insertBefore(childDOM, dom);
    }
    if (desc instanceof MarkViewDesc) {
      let pos = dom ? dom.previousSibling : parentDOM.lastChild;
      renderDescs(desc.contentDOM, desc.children, view);
      dom = pos ? pos.nextSibling : parentDOM.firstChild;
    }
  }
  while (dom) {
    dom = rm(dom);
    written = true;
  }
  if (written && view.trackWrites == parentDOM)
    view.trackWrites = null;
}
const OuterDecoLevel = function(nodeName) {
  if (nodeName)
    this.nodeName = nodeName;
};
OuterDecoLevel.prototype = /* @__PURE__ */ Object.create(null);
const noDeco = [new OuterDecoLevel()];
function computeOuterDeco(outerDeco, node2, needsWrap) {
  if (outerDeco.length == 0)
    return noDeco;
  let top2 = needsWrap ? noDeco[0] : new OuterDecoLevel(), result = [top2];
  for (let i = 0; i < outerDeco.length; i++) {
    let attrs = outerDeco[i].type.attrs;
    if (!attrs)
      continue;
    if (attrs.nodeName)
      result.push(top2 = new OuterDecoLevel(attrs.nodeName));
    for (let name2 in attrs) {
      let val = attrs[name2];
      if (val == null)
        continue;
      if (needsWrap && result.length == 1)
        result.push(top2 = new OuterDecoLevel(node2.isInline ? "span" : "div"));
      if (name2 == "class")
        top2.class = (top2.class ? top2.class + " " : "") + val;
      else if (name2 == "style")
        top2.style = (top2.style ? top2.style + ";" : "") + val;
      else if (name2 != "nodeName")
        top2[name2] = val;
    }
  }
  return result;
}
function patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
  if (prevComputed == noDeco && curComputed == noDeco)
    return nodeDOM;
  let curDOM = nodeDOM;
  for (let i = 0; i < curComputed.length; i++) {
    let deco = curComputed[i], prev2 = prevComputed[i];
    if (i) {
      let parent2;
      if (prev2 && prev2.nodeName == deco.nodeName && curDOM != outerDOM && (parent2 = curDOM.parentNode) && parent2.nodeName.toLowerCase() == deco.nodeName) {
        curDOM = parent2;
      } else {
        parent2 = document.createElement(deco.nodeName);
        parent2.pmIsDeco = true;
        parent2.appendChild(curDOM);
        prev2 = noDeco[0];
        curDOM = parent2;
      }
    }
    patchAttributes(curDOM, prev2 || noDeco[0], deco);
  }
  return curDOM;
}
function patchAttributes(dom, prev2, cur) {
  for (let name2 in prev2)
    if (name2 != "class" && name2 != "style" && name2 != "nodeName" && !(name2 in cur))
      dom.removeAttribute(name2);
  for (let name2 in cur)
    if (name2 != "class" && name2 != "style" && name2 != "nodeName" && cur[name2] != prev2[name2])
      dom.setAttribute(name2, cur[name2]);
  if (prev2.class != cur.class) {
    let prevList = prev2.class ? prev2.class.split(" ").filter(Boolean) : [];
    let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
    for (let i = 0; i < prevList.length; i++)
      if (curList.indexOf(prevList[i]) == -1)
        dom.classList.remove(prevList[i]);
    for (let i = 0; i < curList.length; i++)
      if (prevList.indexOf(curList[i]) == -1)
        dom.classList.add(curList[i]);
    if (dom.classList.length == 0)
      dom.removeAttribute("class");
  }
  if (prev2.style != cur.style) {
    if (prev2.style) {
      let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m2;
      while (m2 = prop.exec(prev2.style))
        dom.style.removeProperty(m2[1]);
    }
    if (cur.style)
      dom.style.cssText += cur.style;
  }
}
function applyOuterDeco(dom, deco, node2) {
  return patchOuterDeco(dom, dom, noDeco, computeOuterDeco(deco, node2, dom.nodeType != 1));
}
function sameOuterDeco(a2, b2) {
  if (a2.length != b2.length)
    return false;
  for (let i = 0; i < a2.length; i++)
    if (!a2[i].type.eq(b2[i].type))
      return false;
  return true;
}
function rm(dom) {
  let next2 = dom.nextSibling;
  dom.parentNode.removeChild(dom);
  return next2;
}
class ViewTreeUpdater {
  constructor(top2, lock, view) {
    this.lock = lock;
    this.view = view;
    this.index = 0;
    this.stack = [];
    this.changed = false;
    this.top = top2;
    this.preMatch = preMatch(top2.node.content, top2);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(start4, end2) {
    if (start4 == end2)
      return;
    for (let i = start4; i < end2; i++)
      this.top.children[i].destroy();
    this.top.children.splice(start4, end2 - start4);
    this.changed = true;
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(marks, inline2, view) {
    let keep = 0, depth = this.stack.length >> 1;
    let maxKeep = Math.min(depth, marks.length);
    while (keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)
      keep++;
    while (keep < depth) {
      this.destroyRest();
      this.top.dirty = NOT_DIRTY;
      this.index = this.stack.pop();
      this.top = this.stack.pop();
      depth--;
    }
    while (depth < marks.length) {
      this.stack.push(this.top, this.index + 1);
      let found2 = -1;
      for (let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++) {
        let next2 = this.top.children[i];
        if (next2.matchesMark(marks[depth]) && !this.isLocked(next2.dom)) {
          found2 = i;
          break;
        }
      }
      if (found2 > -1) {
        if (found2 > this.index) {
          this.changed = true;
          this.destroyBetween(this.index, found2);
        }
        this.top = this.top.children[this.index];
      } else {
        let markDesc = MarkViewDesc.create(this.top, marks[depth], inline2, view);
        this.top.children.splice(this.index, 0, markDesc);
        this.top = markDesc;
        this.changed = true;
      }
      this.index = 0;
      depth++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(node2, outerDeco, innerDeco, index2) {
    let found2 = -1, targetDesc;
    if (index2 >= this.preMatch.index && (targetDesc = this.preMatch.matches[index2 - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node2, outerDeco, innerDeco)) {
      found2 = this.top.children.indexOf(targetDesc, this.index);
    } else {
      for (let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++) {
        let child = this.top.children[i];
        if (child.matchesNode(node2, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
          found2 = i;
          break;
        }
      }
    }
    if (found2 < 0)
      return false;
    this.destroyBetween(this.index, found2);
    this.index++;
    return true;
  }
  updateNodeAt(node2, outerDeco, innerDeco, index2, view) {
    let child = this.top.children[index2];
    if (child.dirty == NODE_DIRTY && child.dom == child.contentDOM)
      child.dirty = CONTENT_DIRTY;
    if (!child.update(node2, outerDeco, innerDeco, view))
      return false;
    this.destroyBetween(this.index, index2);
    this.index++;
    return true;
  }
  findIndexWithChild(domNode) {
    for (; ; ) {
      let parent2 = domNode.parentNode;
      if (!parent2)
        return -1;
      if (parent2 == this.top.contentDOM) {
        let desc = domNode.pmViewDesc;
        if (desc)
          for (let i = this.index; i < this.top.children.length; i++) {
            if (this.top.children[i] == desc)
              return i;
          }
        return -1;
      }
      domNode = parent2;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(node2, outerDeco, innerDeco, view, index2, pos) {
    for (let i = this.index; i < this.top.children.length; i++) {
      let next2 = this.top.children[i];
      if (next2 instanceof NodeViewDesc) {
        let preMatch2 = this.preMatch.matched.get(next2);
        if (preMatch2 != null && preMatch2 != index2)
          return false;
        let nextDOM = next2.dom, updated;
        let locked = this.isLocked(nextDOM) && !(node2.isText && next2.node && next2.node.isText && next2.nodeDOM.nodeValue == node2.text && next2.dirty != NODE_DIRTY && sameOuterDeco(outerDeco, next2.outerDeco));
        if (!locked && next2.update(node2, outerDeco, innerDeco, view)) {
          this.destroyBetween(this.index, i);
          if (next2.dom != nextDOM)
            this.changed = true;
          this.index++;
          return true;
        } else if (!locked && (updated = this.recreateWrapper(next2, node2, outerDeco, innerDeco, view, pos))) {
          this.destroyBetween(this.index, i);
          this.top.children[this.index] = updated;
          if (updated.contentDOM) {
            updated.dirty = CONTENT_DIRTY;
            updated.updateChildren(view, pos + 1);
            updated.dirty = NOT_DIRTY;
          }
          this.changed = true;
          this.index++;
          return true;
        }
        break;
      }
    }
    return false;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(next2, node2, outerDeco, innerDeco, view, pos) {
    if (next2.dirty || node2.isAtom || !next2.children.length || !next2.node.content.eq(node2.content) || !sameOuterDeco(outerDeco, next2.outerDeco) || !innerDeco.eq(next2.innerDeco))
      return null;
    let wrapper = NodeViewDesc.create(this.top, node2, outerDeco, innerDeco, view, pos);
    if (wrapper.contentDOM) {
      wrapper.children = next2.children;
      next2.children = [];
      for (let ch of wrapper.children)
        ch.parent = wrapper;
    }
    next2.destroy();
    return wrapper;
  }
  // Insert the node as a newly created node desc.
  addNode(node2, outerDeco, innerDeco, view, pos) {
    let desc = NodeViewDesc.create(this.top, node2, outerDeco, innerDeco, view, pos);
    if (desc.contentDOM)
      desc.updateChildren(view, pos + 1);
    this.top.children.splice(this.index++, 0, desc);
    this.changed = true;
  }
  placeWidget(widget, view, pos) {
    let next2 = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (next2 && next2.matchesWidget(widget) && (widget == next2.widget || !next2.widget.type.toDOM.parentNode)) {
      this.index++;
    } else {
      let desc = new WidgetViewDesc(this.top, widget, view, pos);
      this.top.children.splice(this.index++, 0, desc);
      this.changed = true;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let lastChild = this.top.children[this.index - 1], parent2 = this.top;
    while (lastChild instanceof MarkViewDesc) {
      parent2 = lastChild;
      lastChild = parent2.children[parent2.children.length - 1];
    }
    if (!lastChild || // Empty textblock
    !(lastChild instanceof TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
      if ((safari || chrome) && lastChild && lastChild.dom.contentEditable == "false")
        this.addHackNode("IMG", parent2);
      this.addHackNode("BR", this.top);
    }
  }
  addHackNode(nodeName, parent2) {
    if (parent2 == this.top && this.index < parent2.children.length && parent2.children[this.index].matchesHack(nodeName)) {
      this.index++;
    } else {
      let dom = document.createElement(nodeName);
      if (nodeName == "IMG") {
        dom.className = "ProseMirror-separator";
        dom.alt = "";
      }
      if (nodeName == "BR")
        dom.className = "ProseMirror-trailingBreak";
      let hack = new TrailingHackViewDesc(this.top, [], dom, null);
      if (parent2 != this.top)
        parent2.children.push(hack);
      else
        parent2.children.splice(this.index++, 0, hack);
      this.changed = true;
    }
  }
  isLocked(node2) {
    return this.lock && (node2 == this.lock || node2.nodeType == 1 && node2.contains(this.lock.parentNode));
  }
}
function preMatch(frag, parentDesc) {
  let curDesc = parentDesc, descI = curDesc.children.length;
  let fI = frag.childCount, matched = /* @__PURE__ */ new Map(), matches2 = [];
  outer: while (fI > 0) {
    let desc;
    for (; ; ) {
      if (descI) {
        let next2 = curDesc.children[descI - 1];
        if (next2 instanceof MarkViewDesc) {
          curDesc = next2;
          descI = next2.children.length;
        } else {
          desc = next2;
          descI--;
          break;
        }
      } else if (curDesc == parentDesc) {
        break outer;
      } else {
        descI = curDesc.parent.children.indexOf(curDesc);
        curDesc = curDesc.parent;
      }
    }
    let node2 = desc.node;
    if (!node2)
      continue;
    if (node2 != frag.child(fI - 1))
      break;
    --fI;
    matched.set(desc, fI);
    matches2.push(desc);
  }
  return { index: fI, matched, matches: matches2.reverse() };
}
function compareSide(a2, b2) {
  return a2.type.side - b2.type.side;
}
function iterDeco(parent2, deco, onWidget, onNode) {
  let locals = deco.locals(parent2), offset3 = 0;
  if (locals.length == 0) {
    for (let i = 0; i < parent2.childCount; i++) {
      let child = parent2.child(i);
      onNode(child, locals, deco.forChild(offset3, child), i);
      offset3 += child.nodeSize;
    }
    return;
  }
  let decoIndex = 0, active = [], restNode = null;
  for (let parentIndex = 0; ; ) {
    let widget, widgets;
    while (decoIndex < locals.length && locals[decoIndex].to == offset3) {
      let next2 = locals[decoIndex++];
      if (next2.widget) {
        if (!widget)
          widget = next2;
        else
          (widgets || (widgets = [widget])).push(next2);
      }
    }
    if (widget) {
      if (widgets) {
        widgets.sort(compareSide);
        for (let i = 0; i < widgets.length; i++)
          onWidget(widgets[i], parentIndex, !!restNode);
      } else {
        onWidget(widget, parentIndex, !!restNode);
      }
    }
    let child, index2;
    if (restNode) {
      index2 = -1;
      child = restNode;
      restNode = null;
    } else if (parentIndex < parent2.childCount) {
      index2 = parentIndex;
      child = parent2.child(parentIndex++);
    } else {
      break;
    }
    for (let i = 0; i < active.length; i++)
      if (active[i].to <= offset3)
        active.splice(i--, 1);
    while (decoIndex < locals.length && locals[decoIndex].from <= offset3 && locals[decoIndex].to > offset3)
      active.push(locals[decoIndex++]);
    let end2 = offset3 + child.nodeSize;
    if (child.isText) {
      let cutAt = end2;
      if (decoIndex < locals.length && locals[decoIndex].from < cutAt)
        cutAt = locals[decoIndex].from;
      for (let i = 0; i < active.length; i++)
        if (active[i].to < cutAt)
          cutAt = active[i].to;
      if (cutAt < end2) {
        restNode = child.cut(cutAt - offset3);
        child = child.cut(0, cutAt - offset3);
        end2 = cutAt;
        index2 = -1;
      }
    } else {
      while (decoIndex < locals.length && locals[decoIndex].to < end2)
        decoIndex++;
    }
    let outerDeco = child.isInline && !child.isLeaf ? active.filter((d2) => !d2.inline) : active.slice();
    onNode(child, outerDeco, deco.forChild(offset3, child), index2);
    offset3 = end2;
  }
}
function iosHacks(dom) {
  if (dom.nodeName == "UL" || dom.nodeName == "OL") {
    let oldCSS = dom.style.cssText;
    dom.style.cssText = oldCSS + "; list-style: square !important";
    window.getComputedStyle(dom).listStyle;
    dom.style.cssText = oldCSS;
  }
}
function findTextInFragment(frag, text2, from3, to2) {
  for (let i = 0, pos = 0; i < frag.childCount && pos <= to2; ) {
    let child = frag.child(i++), childStart = pos;
    pos += child.nodeSize;
    if (!child.isText)
      continue;
    let str = child.text;
    while (i < frag.childCount) {
      let next2 = frag.child(i++);
      pos += next2.nodeSize;
      if (!next2.isText)
        break;
      str += next2.text;
    }
    if (pos >= from3) {
      if (pos >= to2 && str.slice(to2 - text2.length - childStart, to2 - childStart) == text2)
        return to2 - text2.length;
      let found2 = childStart < to2 ? str.lastIndexOf(text2, to2 - childStart - 1) : -1;
      if (found2 >= 0 && found2 + text2.length + childStart >= from3)
        return childStart + found2;
      if (from3 == to2 && str.length >= to2 + text2.length - childStart && str.slice(to2 - childStart, to2 - childStart + text2.length) == text2)
        return to2;
    }
  }
  return -1;
}
function replaceNodes(nodes, from3, to2, view, replacement) {
  let result = [];
  for (let i = 0, off = 0; i < nodes.length; i++) {
    let child = nodes[i], start4 = off, end2 = off += child.size;
    if (start4 >= to2 || end2 <= from3) {
      result.push(child);
    } else {
      if (start4 < from3)
        result.push(child.slice(0, from3 - start4, view));
      if (replacement) {
        result.push(replacement);
        replacement = void 0;
      }
      if (end2 > to2)
        result.push(child.slice(to2 - start4, child.size, view));
    }
  }
  return result;
}
function selectionFromDOM(view, origin2 = null) {
  let domSel = view.domSelectionRange(), doc2 = view.state.doc;
  if (!domSel.focusNode)
    return null;
  let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
  let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
  if (head < 0)
    return null;
  let $head = doc2.resolve(head), anchor, selection;
  if (selectionCollapsed(domSel)) {
    anchor = head;
    while (nearestDesc && !nearestDesc.node)
      nearestDesc = nearestDesc.parent;
    let nearestDescNode = nearestDesc.node;
    if (nearestDesc && nearestDescNode.isAtom && NodeSelection.isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
      let pos = nearestDesc.posBefore;
      selection = new NodeSelection(head == pos ? $head : doc2.resolve(pos));
    }
  } else {
    if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
      let min2 = head, max2 = head;
      for (let i = 0; i < domSel.rangeCount; i++) {
        let range = domSel.getRangeAt(i);
        min2 = Math.min(min2, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
        max2 = Math.max(max2, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
      }
      if (min2 < 0)
        return null;
      [anchor, head] = max2 == view.state.selection.anchor ? [max2, min2] : [min2, max2];
      $head = doc2.resolve(head);
    } else {
      anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
    }
    if (anchor < 0)
      return null;
  }
  let $anchor = doc2.resolve(anchor);
  if (!selection) {
    let bias = origin2 == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
    selection = selectionBetween(view, $anchor, $head, bias);
  }
  return selection;
}
function editorOwnsSelection(view) {
  return view.editable ? view.hasFocus() : hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function selectionToDOM(view, force = false) {
  let sel = view.state.selection;
  syncNodeSelection(view, sel);
  if (!editorOwnsSelection(view))
    return;
  if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && chrome) {
    let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
    if (domSel.anchorNode && curSel.anchorNode && isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
      view.input.mouseDown.delayedSelectionSync = true;
      view.domObserver.setCurSelection();
      return;
    }
  }
  view.domObserver.disconnectSelection();
  if (view.cursorWrapper) {
    selectCursorWrapper(view);
  } else {
    let { anchor, head } = sel, resetEditableFrom, resetEditableTo;
    if (brokenSelectBetweenUneditable && !(sel instanceof TextSelection)) {
      if (!sel.$from.parent.inlineContent)
        resetEditableFrom = temporarilyEditableNear(view, sel.from);
      if (!sel.empty && !sel.$from.parent.inlineContent)
        resetEditableTo = temporarilyEditableNear(view, sel.to);
    }
    view.docView.setSelection(anchor, head, view, force);
    if (brokenSelectBetweenUneditable) {
      if (resetEditableFrom)
        resetEditable(resetEditableFrom);
      if (resetEditableTo)
        resetEditable(resetEditableTo);
    }
    if (sel.visible) {
      view.dom.classList.remove("ProseMirror-hideselection");
    } else {
      view.dom.classList.add("ProseMirror-hideselection");
      if ("onselectionchange" in document)
        removeClassOnSelectionChange(view);
    }
  }
  view.domObserver.setCurSelection();
  view.domObserver.connectSelection();
}
const brokenSelectBetweenUneditable = safari || chrome && chrome_version < 63;
function temporarilyEditableNear(view, pos) {
  let { node: node2, offset: offset3 } = view.docView.domFromPos(pos, 0);
  let after = offset3 < node2.childNodes.length ? node2.childNodes[offset3] : null;
  let before = offset3 ? node2.childNodes[offset3 - 1] : null;
  if (safari && after && after.contentEditable == "false")
    return setEditable(after);
  if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
    if (after)
      return setEditable(after);
    else if (before)
      return setEditable(before);
  }
}
function setEditable(element2) {
  element2.contentEditable = "true";
  if (safari && element2.draggable) {
    element2.draggable = false;
    element2.wasDraggable = true;
  }
  return element2;
}
function resetEditable(element2) {
  element2.contentEditable = "false";
  if (element2.wasDraggable) {
    element2.draggable = true;
    element2.wasDraggable = null;
  }
}
function removeClassOnSelectionChange(view) {
  let doc2 = view.dom.ownerDocument;
  doc2.removeEventListener("selectionchange", view.input.hideSelectionGuard);
  let domSel = view.domSelectionRange();
  let node2 = domSel.anchorNode, offset3 = domSel.anchorOffset;
  doc2.addEventListener("selectionchange", view.input.hideSelectionGuard = () => {
    if (domSel.anchorNode != node2 || domSel.anchorOffset != offset3) {
      doc2.removeEventListener("selectionchange", view.input.hideSelectionGuard);
      setTimeout(() => {
        if (!editorOwnsSelection(view) || view.state.selection.visible)
          view.dom.classList.remove("ProseMirror-hideselection");
      }, 20);
    }
  });
}
function selectCursorWrapper(view) {
  let domSel = view.domSelection(), range = document.createRange();
  if (!domSel)
    return;
  let node2 = view.cursorWrapper.dom, img = node2.nodeName == "IMG";
  if (img)
    range.setStart(node2.parentNode, domIndex(node2) + 1);
  else
    range.setStart(node2, 0);
  range.collapse(true);
  domSel.removeAllRanges();
  domSel.addRange(range);
  if (!img && !view.state.selection.visible && ie$1 && ie_version <= 11) {
    node2.disabled = true;
    node2.disabled = false;
  }
}
function syncNodeSelection(view, sel) {
  if (sel instanceof NodeSelection) {
    let desc = view.docView.descAt(sel.from);
    if (desc != view.lastSelectedViewDesc) {
      clearNodeSelection(view);
      if (desc)
        desc.selectNode();
      view.lastSelectedViewDesc = desc;
    }
  } else {
    clearNodeSelection(view);
  }
}
function clearNodeSelection(view) {
  if (view.lastSelectedViewDesc) {
    if (view.lastSelectedViewDesc.parent)
      view.lastSelectedViewDesc.deselectNode();
    view.lastSelectedViewDesc = void 0;
  }
}
function selectionBetween(view, $anchor, $head, bias) {
  return view.someProp("createSelectionBetween", (f2) => f2(view, $anchor, $head)) || TextSelection.between($anchor, $head, bias);
}
function hasFocusAndSelection(view) {
  if (view.editable && !view.hasFocus())
    return false;
  return hasSelection(view);
}
function hasSelection(view) {
  let sel = view.domSelectionRange();
  if (!sel.anchorNode)
    return false;
  try {
    return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
  } catch (_2) {
    return false;
  }
}
function anchorInRightPlace(view) {
  let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
  let domSel = view.domSelectionRange();
  return isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function moveSelectionBlock(state, dir) {
  let { $anchor, $head } = state.selection;
  let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
  let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
  return $start && Selection.findFrom($start, dir);
}
function apply3(view, sel) {
  view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
  return true;
}
function selectHorizontally(view, dir, mods) {
  let sel = view.state.selection;
  if (sel instanceof TextSelection) {
    if (mods.indexOf("s") > -1) {
      let { $head } = sel, node2 = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
      if (!node2 || node2.isText || !node2.isLeaf)
        return false;
      let $newHead = view.state.doc.resolve($head.pos + node2.nodeSize * (dir < 0 ? -1 : 1));
      return apply3(view, new TextSelection(sel.$anchor, $newHead));
    } else if (!sel.empty) {
      return false;
    } else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
      let next2 = moveSelectionBlock(view.state, dir);
      if (next2 && next2 instanceof NodeSelection)
        return apply3(view, next2);
      return false;
    } else if (!(mac$2 && mods.indexOf("m") > -1)) {
      let $head = sel.$head, node2 = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
      if (!node2 || node2.isText)
        return false;
      let nodePos = dir < 0 ? $head.pos - node2.nodeSize : $head.pos;
      if (!(node2.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM))
        return false;
      if (NodeSelection.isSelectable(node2)) {
        return apply3(view, new NodeSelection(dir < 0 ? view.state.doc.resolve($head.pos - node2.nodeSize) : $head));
      } else if (webkit) {
        return apply3(view, new TextSelection(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node2.nodeSize)));
      } else {
        return false;
      }
    }
  } else if (sel instanceof NodeSelection && sel.node.isInline) {
    return apply3(view, new TextSelection(dir > 0 ? sel.$to : sel.$from));
  } else {
    let next2 = moveSelectionBlock(view.state, dir);
    if (next2)
      return apply3(view, next2);
    return false;
  }
}
function nodeLen(node2) {
  return node2.nodeType == 3 ? node2.nodeValue.length : node2.childNodes.length;
}
function isIgnorable(dom, dir) {
  let desc = dom.pmViewDesc;
  return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function skipIgnoredNodes(view, dir) {
  return dir < 0 ? skipIgnoredNodesBefore(view) : skipIgnoredNodesAfter(view);
}
function skipIgnoredNodesBefore(view) {
  let sel = view.domSelectionRange();
  let node2 = sel.focusNode, offset3 = sel.focusOffset;
  if (!node2)
    return;
  let moveNode, moveOffset, force = false;
  if (gecko && node2.nodeType == 1 && offset3 < nodeLen(node2) && isIgnorable(node2.childNodes[offset3], -1))
    force = true;
  for (; ; ) {
    if (offset3 > 0) {
      if (node2.nodeType != 1) {
        break;
      } else {
        let before = node2.childNodes[offset3 - 1];
        if (isIgnorable(before, -1)) {
          moveNode = node2;
          moveOffset = --offset3;
        } else if (before.nodeType == 3) {
          node2 = before;
          offset3 = node2.nodeValue.length;
        } else
          break;
      }
    } else if (isBlockNode(node2)) {
      break;
    } else {
      let prev2 = node2.previousSibling;
      while (prev2 && isIgnorable(prev2, -1)) {
        moveNode = node2.parentNode;
        moveOffset = domIndex(prev2);
        prev2 = prev2.previousSibling;
      }
      if (!prev2) {
        node2 = node2.parentNode;
        if (node2 == view.dom)
          break;
        offset3 = 0;
      } else {
        node2 = prev2;
        offset3 = nodeLen(node2);
      }
    }
  }
  if (force)
    setSelFocus(view, node2, offset3);
  else if (moveNode)
    setSelFocus(view, moveNode, moveOffset);
}
function skipIgnoredNodesAfter(view) {
  let sel = view.domSelectionRange();
  let node2 = sel.focusNode, offset3 = sel.focusOffset;
  if (!node2)
    return;
  let len = nodeLen(node2);
  let moveNode, moveOffset;
  for (; ; ) {
    if (offset3 < len) {
      if (node2.nodeType != 1)
        break;
      let after = node2.childNodes[offset3];
      if (isIgnorable(after, 1)) {
        moveNode = node2;
        moveOffset = ++offset3;
      } else
        break;
    } else if (isBlockNode(node2)) {
      break;
    } else {
      let next2 = node2.nextSibling;
      while (next2 && isIgnorable(next2, 1)) {
        moveNode = next2.parentNode;
        moveOffset = domIndex(next2) + 1;
        next2 = next2.nextSibling;
      }
      if (!next2) {
        node2 = node2.parentNode;
        if (node2 == view.dom)
          break;
        offset3 = len = 0;
      } else {
        node2 = next2;
        offset3 = 0;
        len = nodeLen(node2);
      }
    }
  }
  if (moveNode)
    setSelFocus(view, moveNode, moveOffset);
}
function isBlockNode(dom) {
  let desc = dom.pmViewDesc;
  return desc && desc.node && desc.node.isBlock;
}
function textNodeAfter(node2, offset3) {
  while (node2 && offset3 == node2.childNodes.length && !hasBlockDesc(node2)) {
    offset3 = domIndex(node2) + 1;
    node2 = node2.parentNode;
  }
  while (node2 && offset3 < node2.childNodes.length) {
    let next2 = node2.childNodes[offset3];
    if (next2.nodeType == 3)
      return next2;
    if (next2.nodeType == 1 && next2.contentEditable == "false")
      break;
    node2 = next2;
    offset3 = 0;
  }
}
function textNodeBefore(node2, offset3) {
  while (node2 && !offset3 && !hasBlockDesc(node2)) {
    offset3 = domIndex(node2);
    node2 = node2.parentNode;
  }
  while (node2 && offset3) {
    let next2 = node2.childNodes[offset3 - 1];
    if (next2.nodeType == 3)
      return next2;
    if (next2.nodeType == 1 && next2.contentEditable == "false")
      break;
    node2 = next2;
    offset3 = node2.childNodes.length;
  }
}
function setSelFocus(view, node2, offset3) {
  if (node2.nodeType != 3) {
    let before, after;
    if (after = textNodeAfter(node2, offset3)) {
      node2 = after;
      offset3 = 0;
    } else if (before = textNodeBefore(node2, offset3)) {
      node2 = before;
      offset3 = before.nodeValue.length;
    }
  }
  let sel = view.domSelection();
  if (!sel)
    return;
  if (selectionCollapsed(sel)) {
    let range = document.createRange();
    range.setEnd(node2, offset3);
    range.setStart(node2, offset3);
    sel.removeAllRanges();
    sel.addRange(range);
  } else if (sel.extend) {
    sel.extend(node2, offset3);
  }
  view.domObserver.setCurSelection();
  let { state } = view;
  setTimeout(() => {
    if (view.state == state)
      selectionToDOM(view);
  }, 50);
}
function findDirection(view, pos) {
  let $pos = view.state.doc.resolve(pos);
  if (!(chrome || windows$1) && $pos.parent.inlineContent) {
    let coords = view.coordsAtPos(pos);
    if (pos > $pos.start()) {
      let before = view.coordsAtPos(pos - 1);
      let mid = (before.top + before.bottom) / 2;
      if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1)
        return before.left < coords.left ? "ltr" : "rtl";
    }
    if (pos < $pos.end()) {
      let after = view.coordsAtPos(pos + 1);
      let mid = (after.top + after.bottom) / 2;
      if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1)
        return after.left > coords.left ? "ltr" : "rtl";
    }
  }
  let computed = getComputedStyle(view.dom).direction;
  return computed == "rtl" ? "rtl" : "ltr";
}
function selectVertically(view, dir, mods) {
  let sel = view.state.selection;
  if (sel instanceof TextSelection && !sel.empty || mods.indexOf("s") > -1)
    return false;
  if (mac$2 && mods.indexOf("m") > -1)
    return false;
  let { $from, $to } = sel;
  if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
    let next2 = moveSelectionBlock(view.state, dir);
    if (next2 && next2 instanceof NodeSelection)
      return apply3(view, next2);
  }
  if (!$from.parent.inlineContent) {
    let side = dir < 0 ? $from : $to;
    let beyond = sel instanceof AllSelection ? Selection.near(side, dir) : Selection.findFrom(side, dir);
    return beyond ? apply3(view, beyond) : false;
  }
  return false;
}
function stopNativeHorizontalDelete(view, dir) {
  if (!(view.state.selection instanceof TextSelection))
    return true;
  let { $head, $anchor, empty: empty2 } = view.state.selection;
  if (!$head.sameParent($anchor))
    return true;
  if (!empty2)
    return false;
  if (view.endOfTextblock(dir > 0 ? "forward" : "backward"))
    return true;
  let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
  if (nextNode && !nextNode.isText) {
    let tr2 = view.state.tr;
    if (dir < 0)
      tr2.delete($head.pos - nextNode.nodeSize, $head.pos);
    else
      tr2.delete($head.pos, $head.pos + nextNode.nodeSize);
    view.dispatch(tr2);
    return true;
  }
  return false;
}
function switchEditable(view, node2, state) {
  view.domObserver.stop();
  node2.contentEditable = state;
  view.domObserver.start();
}
function safariDownArrowBug(view) {
  if (!safari || view.state.selection.$head.parentOffset > 0)
    return false;
  let { focusNode, focusOffset } = view.domSelectionRange();
  if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
    let child = focusNode.firstChild;
    switchEditable(view, child, "true");
    setTimeout(() => switchEditable(view, child, "false"), 20);
  }
  return false;
}
function getMods(event) {
  let result = "";
  if (event.ctrlKey)
    result += "c";
  if (event.metaKey)
    result += "m";
  if (event.altKey)
    result += "a";
  if (event.shiftKey)
    result += "s";
  return result;
}
function captureKeyDown(view, event) {
  let code = event.keyCode, mods = getMods(event);
  if (code == 8 || mac$2 && code == 72 && mods == "c") {
    return stopNativeHorizontalDelete(view, -1) || skipIgnoredNodes(view, -1);
  } else if (code == 46 && !event.shiftKey || mac$2 && code == 68 && mods == "c") {
    return stopNativeHorizontalDelete(view, 1) || skipIgnoredNodes(view, 1);
  } else if (code == 13 || code == 27) {
    return true;
  } else if (code == 37 || mac$2 && code == 66 && mods == "c") {
    let dir = code == 37 ? findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return selectHorizontally(view, dir, mods) || skipIgnoredNodes(view, dir);
  } else if (code == 39 || mac$2 && code == 70 && mods == "c") {
    let dir = code == 39 ? findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return selectHorizontally(view, dir, mods) || skipIgnoredNodes(view, dir);
  } else if (code == 38 || mac$2 && code == 80 && mods == "c") {
    return selectVertically(view, -1, mods) || skipIgnoredNodes(view, -1);
  } else if (code == 40 || mac$2 && code == 78 && mods == "c") {
    return safariDownArrowBug(view) || selectVertically(view, 1, mods) || skipIgnoredNodes(view, 1);
  } else if (mods == (mac$2 ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) {
    return true;
  }
  return false;
}
function serializeForClipboard(view, slice3) {
  view.someProp("transformCopied", (f2) => {
    slice3 = f2(slice3, view);
  });
  let context = [], { content: content2, openStart, openEnd } = slice3;
  while (openStart > 1 && openEnd > 1 && content2.childCount == 1 && content2.firstChild.childCount == 1) {
    openStart--;
    openEnd--;
    let node2 = content2.firstChild;
    context.push(node2.type.name, node2.attrs != node2.type.defaultAttrs ? node2.attrs : null);
    content2 = node2.content;
  }
  let serializer2 = view.someProp("clipboardSerializer") || DOMSerializer.fromSchema(view.state.schema);
  let doc2 = detachedDoc(), wrap2 = doc2.createElement("div");
  wrap2.appendChild(serializer2.serializeFragment(content2, { document: doc2 }));
  let firstChild = wrap2.firstChild, needsWrap, wrappers = 0;
  while (firstChild && firstChild.nodeType == 1 && (needsWrap = wrapMap[firstChild.nodeName.toLowerCase()])) {
    for (let i = needsWrap.length - 1; i >= 0; i--) {
      let wrapper = doc2.createElement(needsWrap[i]);
      while (wrap2.firstChild)
        wrapper.appendChild(wrap2.firstChild);
      wrap2.appendChild(wrapper);
      wrappers++;
    }
    firstChild = wrap2.firstChild;
  }
  if (firstChild && firstChild.nodeType == 1)
    firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
  let text2 = view.someProp("clipboardTextSerializer", (f2) => f2(slice3, view)) || slice3.content.textBetween(0, slice3.content.size, "\n\n");
  return { dom: wrap2, text: text2, slice: slice3 };
}
function parseFromClipboard(view, text2, html2, plainText, $context) {
  let inCode = $context.parent.type.spec.code;
  let dom, slice3;
  if (!html2 && !text2)
    return null;
  let asText = text2 && (plainText || inCode || !html2);
  if (asText) {
    view.someProp("transformPastedText", (f2) => {
      text2 = f2(text2, inCode || plainText, view);
    });
    if (inCode)
      return text2 ? new Slice(Fragment.from(view.state.schema.text(text2.replace(/\r\n?/g, "\n"))), 0, 0) : Slice.empty;
    let parsed = view.someProp("clipboardTextParser", (f2) => f2(text2, $context, plainText, view));
    if (parsed) {
      slice3 = parsed;
    } else {
      let marks = $context.marks();
      let { schema } = view.state, serializer2 = DOMSerializer.fromSchema(schema);
      dom = document.createElement("div");
      text2.split(/(?:\r\n?|\n)+/).forEach((block2) => {
        let p2 = dom.appendChild(document.createElement("p"));
        if (block2)
          p2.appendChild(serializer2.serializeNode(schema.text(block2, marks)));
      });
    }
  } else {
    view.someProp("transformPastedHTML", (f2) => {
      html2 = f2(html2, view);
    });
    dom = readHTML(html2);
    if (webkit)
      restoreReplacedSpaces(dom);
  }
  let contextNode = dom && dom.querySelector("[data-pm-slice]");
  let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
  if (sliceData && sliceData[3])
    for (let i = +sliceData[3]; i > 0; i--) {
      let child = dom.firstChild;
      while (child && child.nodeType != 1)
        child = child.nextSibling;
      if (!child)
        break;
      dom = child;
    }
  if (!slice3) {
    let parser = view.someProp("clipboardParser") || view.someProp("domParser") || DOMParser.fromSchema(view.state.schema);
    slice3 = parser.parseSlice(dom, {
      preserveWhitespace: !!(asText || sliceData),
      context: $context,
      ruleFromNode(dom2) {
        if (dom2.nodeName == "BR" && !dom2.nextSibling && dom2.parentNode && !inlineParents.test(dom2.parentNode.nodeName))
          return { ignore: true };
        return null;
      }
    });
  }
  if (sliceData) {
    slice3 = addContext(closeSlice(slice3, +sliceData[1], +sliceData[2]), sliceData[4]);
  } else {
    slice3 = Slice.maxOpen(normalizeSiblings(slice3.content, $context), true);
    if (slice3.openStart || slice3.openEnd) {
      let openStart = 0, openEnd = 0;
      for (let node2 = slice3.content.firstChild; openStart < slice3.openStart && !node2.type.spec.isolating; openStart++, node2 = node2.firstChild) {
      }
      for (let node2 = slice3.content.lastChild; openEnd < slice3.openEnd && !node2.type.spec.isolating; openEnd++, node2 = node2.lastChild) {
      }
      slice3 = closeSlice(slice3, openStart, openEnd);
    }
  }
  view.someProp("transformPasted", (f2) => {
    slice3 = f2(slice3, view);
  });
  return slice3;
}
const inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function normalizeSiblings(fragment, $context) {
  if (fragment.childCount < 2)
    return fragment;
  for (let d2 = $context.depth; d2 >= 0; d2--) {
    let parent2 = $context.node(d2);
    let match5 = parent2.contentMatchAt($context.index(d2));
    let lastWrap, result = [];
    fragment.forEach((node2) => {
      if (!result)
        return;
      let wrap2 = match5.findWrapping(node2.type), inLast;
      if (!wrap2)
        return result = null;
      if (inLast = result.length && lastWrap.length && addToSibling(wrap2, lastWrap, node2, result[result.length - 1], 0)) {
        result[result.length - 1] = inLast;
      } else {
        if (result.length)
          result[result.length - 1] = closeRight(result[result.length - 1], lastWrap.length);
        let wrapped = withWrappers(node2, wrap2);
        result.push(wrapped);
        match5 = match5.matchType(wrapped.type);
        lastWrap = wrap2;
      }
    });
    if (result)
      return Fragment.from(result);
  }
  return fragment;
}
function withWrappers(node2, wrap2, from3 = 0) {
  for (let i = wrap2.length - 1; i >= from3; i--)
    node2 = wrap2[i].create(null, Fragment.from(node2));
  return node2;
}
function addToSibling(wrap2, lastWrap, node2, sibling, depth) {
  if (depth < wrap2.length && depth < lastWrap.length && wrap2[depth] == lastWrap[depth]) {
    let inner = addToSibling(wrap2, lastWrap, node2, sibling.lastChild, depth + 1);
    if (inner)
      return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
    let match5 = sibling.contentMatchAt(sibling.childCount);
    if (match5.matchType(depth == wrap2.length - 1 ? node2.type : wrap2[depth + 1]))
      return sibling.copy(sibling.content.append(Fragment.from(withWrappers(node2, wrap2, depth + 1))));
  }
}
function closeRight(node2, depth) {
  if (depth == 0)
    return node2;
  let fragment = node2.content.replaceChild(node2.childCount - 1, closeRight(node2.lastChild, depth - 1));
  let fill = node2.contentMatchAt(node2.childCount).fillBefore(Fragment.empty, true);
  return node2.copy(fragment.append(fill));
}
function closeRange(fragment, side, from3, to2, depth, openEnd) {
  let node2 = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node2.content;
  if (fragment.childCount > 1)
    openEnd = 0;
  if (depth < to2 - 1)
    inner = closeRange(inner, side, from3, to2, depth + 1, openEnd);
  if (depth >= from3)
    inner = side < 0 ? node2.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node2.contentMatchAt(node2.childCount).fillBefore(Fragment.empty, true));
  return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node2.copy(inner));
}
function closeSlice(slice3, openStart, openEnd) {
  if (openStart < slice3.openStart)
    slice3 = new Slice(closeRange(slice3.content, -1, openStart, slice3.openStart, 0, slice3.openEnd), openStart, slice3.openEnd);
  if (openEnd < slice3.openEnd)
    slice3 = new Slice(closeRange(slice3.content, 1, openEnd, slice3.openEnd, 0, 0), slice3.openStart, openEnd);
  return slice3;
}
const wrapMap = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let _detachedDoc = null;
function detachedDoc() {
  return _detachedDoc || (_detachedDoc = document.implementation.createHTMLDocument("title"));
}
let _policy = null;
function maybeWrapTrusted(html2) {
  let trustedTypes = window.trustedTypes;
  if (!trustedTypes)
    return html2;
  if (!_policy)
    _policy = trustedTypes.defaultPolicy || trustedTypes.createPolicy("ProseMirrorClipboard", { createHTML: (s2) => s2 });
  return _policy.createHTML(html2);
}
function readHTML(html2) {
  let metas = /^(\s*<meta [^>]*>)*/.exec(html2);
  if (metas)
    html2 = html2.slice(metas[0].length);
  let elt = detachedDoc().createElement("div");
  let firstTag = /<([a-z][^>\s]+)/i.exec(html2), wrap2;
  if (wrap2 = firstTag && wrapMap[firstTag[1].toLowerCase()])
    html2 = wrap2.map((n2) => "<" + n2 + ">").join("") + html2 + wrap2.map((n2) => "</" + n2 + ">").reverse().join("");
  elt.innerHTML = maybeWrapTrusted(html2);
  if (wrap2)
    for (let i = 0; i < wrap2.length; i++)
      elt = elt.querySelector(wrap2[i]) || elt;
  return elt;
}
function restoreReplacedSpaces(dom) {
  let nodes = dom.querySelectorAll(chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let i = 0; i < nodes.length; i++) {
    let node2 = nodes[i];
    if (node2.childNodes.length == 1 && node2.textContent == " " && node2.parentNode)
      node2.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node2);
  }
}
function addContext(slice3, context) {
  if (!slice3.size)
    return slice3;
  let schema = slice3.content.firstChild.type.schema, array;
  try {
    array = JSON.parse(context);
  } catch (e) {
    return slice3;
  }
  let { content: content2, openStart, openEnd } = slice3;
  for (let i = array.length - 2; i >= 0; i -= 2) {
    let type = schema.nodes[array[i]];
    if (!type || type.hasRequiredAttrs())
      break;
    content2 = Fragment.from(type.create(array[i + 1], content2));
    openStart++;
    openEnd++;
  }
  return new Slice(content2, openStart, openEnd);
}
const handlers = {};
const editHandlers = {};
const passiveHandlers = { touchstart: true, touchmove: true };
class InputState {
  constructor() {
    this.shiftKey = false;
    this.mouseDown = null;
    this.lastKeyCode = null;
    this.lastKeyCodeTime = 0;
    this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 };
    this.lastSelectionOrigin = null;
    this.lastSelectionTime = 0;
    this.lastIOSEnter = 0;
    this.lastIOSEnterFallbackTimeout = -1;
    this.lastFocus = 0;
    this.lastTouch = 0;
    this.lastChromeDelete = 0;
    this.composing = false;
    this.compositionNode = null;
    this.composingTimeout = -1;
    this.compositionNodes = [];
    this.compositionEndedAt = -2e8;
    this.compositionID = 1;
    this.compositionPendingChanges = 0;
    this.domChangeCount = 0;
    this.eventHandlers = /* @__PURE__ */ Object.create(null);
    this.hideSelectionGuard = null;
  }
}
function initInput(view) {
  for (let event in handlers) {
    let handler = handlers[event];
    view.dom.addEventListener(event, view.input.eventHandlers[event] = (event2) => {
      if (eventBelongsToView(view, event2) && !runCustomHandler(view, event2) && (view.editable || !(event2.type in editHandlers)))
        handler(view, event2);
    }, passiveHandlers[event] ? { passive: true } : void 0);
  }
  if (safari)
    view.dom.addEventListener("input", () => null);
  ensureListeners(view);
}
function setSelectionOrigin(view, origin2) {
  view.input.lastSelectionOrigin = origin2;
  view.input.lastSelectionTime = Date.now();
}
function destroyInput(view) {
  view.domObserver.stop();
  for (let type in view.input.eventHandlers)
    view.dom.removeEventListener(type, view.input.eventHandlers[type]);
  clearTimeout(view.input.composingTimeout);
  clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function ensureListeners(view) {
  view.someProp("handleDOMEvents", (currentHandlers) => {
    for (let type in currentHandlers)
      if (!view.input.eventHandlers[type])
        view.dom.addEventListener(type, view.input.eventHandlers[type] = (event) => runCustomHandler(view, event));
  });
}
function runCustomHandler(view, event) {
  return view.someProp("handleDOMEvents", (handlers2) => {
    let handler = handlers2[event.type];
    return handler ? handler(view, event) || event.defaultPrevented : false;
  });
}
function eventBelongsToView(view, event) {
  if (!event.bubbles)
    return true;
  if (event.defaultPrevented)
    return false;
  for (let node2 = event.target; node2 != view.dom; node2 = node2.parentNode)
    if (!node2 || node2.nodeType == 11 || node2.pmViewDesc && node2.pmViewDesc.stopEvent(event))
      return false;
  return true;
}
function dispatchEvent(view, event) {
  if (!runCustomHandler(view, event) && handlers[event.type] && (view.editable || !(event.type in editHandlers)))
    handlers[event.type](view, event);
}
editHandlers.keydown = (view, _event) => {
  let event = _event;
  view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
  if (inOrNearComposition(view, event))
    return;
  view.input.lastKeyCode = event.keyCode;
  view.input.lastKeyCodeTime = Date.now();
  if (android && chrome && event.keyCode == 13)
    return;
  if (event.keyCode != 229)
    view.domObserver.forceFlush();
  if (ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
    let now2 = Date.now();
    view.input.lastIOSEnter = now2;
    view.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
      if (view.input.lastIOSEnter == now2) {
        view.someProp("handleKeyDown", (f2) => f2(view, keyEvent(13, "Enter")));
        view.input.lastIOSEnter = 0;
      }
    }, 200);
  } else if (view.someProp("handleKeyDown", (f2) => f2(view, event)) || captureKeyDown(view, event)) {
    event.preventDefault();
  } else {
    setSelectionOrigin(view, "key");
  }
};
editHandlers.keyup = (view, event) => {
  if (event.keyCode == 16)
    view.input.shiftKey = false;
};
editHandlers.keypress = (view, _event) => {
  let event = _event;
  if (inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || mac$2 && event.metaKey)
    return;
  if (view.someProp("handleKeyPress", (f2) => f2(view, event))) {
    event.preventDefault();
    return;
  }
  let sel = view.state.selection;
  if (!(sel instanceof TextSelection) || !sel.$from.sameParent(sel.$to)) {
    let text2 = String.fromCharCode(event.charCode);
    let deflt = () => view.state.tr.insertText(text2).scrollIntoView();
    if (!/[\r\n]/.test(text2) && !view.someProp("handleTextInput", (f2) => f2(view, sel.$from.pos, sel.$to.pos, text2, deflt)))
      view.dispatch(deflt());
    event.preventDefault();
  }
};
function eventCoords(event) {
  return { left: event.clientX, top: event.clientY };
}
function isNear(event, click) {
  let dx = click.x - event.clientX, dy = click.y - event.clientY;
  return dx * dx + dy * dy < 100;
}
function runHandlerOnContext(view, propName, pos, inside, event) {
  if (inside == -1)
    return false;
  let $pos = view.state.doc.resolve(inside);
  for (let i = $pos.depth + 1; i > 0; i--) {
    if (view.someProp(propName, (f2) => i > $pos.depth ? f2(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f2(view, pos, $pos.node(i), $pos.before(i), event, false)))
      return true;
  }
  return false;
}
function updateSelection(view, selection, origin2) {
  if (!view.focused)
    view.focus();
  if (view.state.selection.eq(selection))
    return;
  let tr2 = view.state.tr.setSelection(selection);
  tr2.setMeta("pointer", true);
  view.dispatch(tr2);
}
function selectClickedLeaf(view, inside) {
  if (inside == -1)
    return false;
  let $pos = view.state.doc.resolve(inside), node2 = $pos.nodeAfter;
  if (node2 && node2.isAtom && NodeSelection.isSelectable(node2)) {
    updateSelection(view, new NodeSelection($pos));
    return true;
  }
  return false;
}
function selectClickedNode(view, inside) {
  if (inside == -1)
    return false;
  let sel = view.state.selection, selectedNode, selectAt;
  if (sel instanceof NodeSelection)
    selectedNode = sel.node;
  let $pos = view.state.doc.resolve(inside);
  for (let i = $pos.depth + 1; i > 0; i--) {
    let node2 = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
    if (NodeSelection.isSelectable(node2)) {
      if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos)
        selectAt = $pos.before(sel.$from.depth);
      else
        selectAt = $pos.before(i);
      break;
    }
  }
  if (selectAt != null) {
    updateSelection(view, NodeSelection.create(view.state.doc, selectAt));
    return true;
  } else {
    return false;
  }
}
function handleSingleClick(view, pos, inside, event, selectNode) {
  return runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f2) => f2(view, pos, event)) || (selectNode ? selectClickedNode(view, inside) : selectClickedLeaf(view, inside));
}
function handleDoubleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f2) => f2(view, pos, event));
}
function handleTripleClick$1(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f2) => f2(view, pos, event)) || defaultTripleClick(view, inside, event);
}
function defaultTripleClick(view, inside, event) {
  if (event.button != 0)
    return false;
  let doc2 = view.state.doc;
  if (inside == -1) {
    if (doc2.inlineContent) {
      updateSelection(view, TextSelection.create(doc2, 0, doc2.content.size));
      return true;
    }
    return false;
  }
  let $pos = doc2.resolve(inside);
  for (let i = $pos.depth + 1; i > 0; i--) {
    let node2 = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
    let nodePos = $pos.before(i);
    if (node2.inlineContent)
      updateSelection(view, TextSelection.create(doc2, nodePos + 1, nodePos + 1 + node2.content.size));
    else if (NodeSelection.isSelectable(node2))
      updateSelection(view, NodeSelection.create(doc2, nodePos));
    else
      continue;
    return true;
  }
}
function forceDOMFlush(view) {
  return endComposition(view);
}
const selectNodeModifier = mac$2 ? "metaKey" : "ctrlKey";
handlers.mousedown = (view, _event) => {
  let event = _event;
  view.input.shiftKey = event.shiftKey;
  let flushed = forceDOMFlush(view);
  let now2 = Date.now(), type = "singleClick";
  if (now2 - view.input.lastClick.time < 500 && isNear(event, view.input.lastClick) && !event[selectNodeModifier] && view.input.lastClick.button == event.button) {
    if (view.input.lastClick.type == "singleClick")
      type = "doubleClick";
    else if (view.input.lastClick.type == "doubleClick")
      type = "tripleClick";
  }
  view.input.lastClick = { time: now2, x: event.clientX, y: event.clientY, type, button: event.button };
  let pos = view.posAtCoords(eventCoords(event));
  if (!pos)
    return;
  if (type == "singleClick") {
    if (view.input.mouseDown)
      view.input.mouseDown.done();
    view.input.mouseDown = new MouseDown(view, pos, event, !!flushed);
  } else if ((type == "doubleClick" ? handleDoubleClick : handleTripleClick$1)(view, pos.pos, pos.inside, event)) {
    event.preventDefault();
  } else {
    setSelectionOrigin(view, "pointer");
  }
};
class MouseDown {
  constructor(view, pos, event, flushed) {
    this.view = view;
    this.pos = pos;
    this.event = event;
    this.flushed = flushed;
    this.delayedSelectionSync = false;
    this.mightDrag = null;
    this.startDoc = view.state.doc;
    this.selectNode = !!event[selectNodeModifier];
    this.allowDefault = event.shiftKey;
    let targetNode, targetPos;
    if (pos.inside > -1) {
      targetNode = view.state.doc.nodeAt(pos.inside);
      targetPos = pos.inside;
    } else {
      let $pos = view.state.doc.resolve(pos.pos);
      targetNode = $pos.parent;
      targetPos = $pos.depth ? $pos.before() : 0;
    }
    const target = flushed ? null : event.target;
    const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
    this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
    let { selection } = view.state;
    if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof NodeSelection && selection.from <= targetPos && selection.to > targetPos)
      this.mightDrag = {
        node: targetNode,
        pos: targetPos,
        addAttr: !!(this.target && !this.target.draggable),
        setUneditable: !!(this.target && gecko && !this.target.hasAttribute("contentEditable"))
      };
    if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
      this.view.domObserver.stop();
      if (this.mightDrag.addAttr)
        this.target.draggable = true;
      if (this.mightDrag.setUneditable)
        setTimeout(() => {
          if (this.view.input.mouseDown == this)
            this.target.setAttribute("contentEditable", "false");
        }, 20);
      this.view.domObserver.start();
    }
    view.root.addEventListener("mouseup", this.up = this.up.bind(this));
    view.root.addEventListener("mousemove", this.move = this.move.bind(this));
    setSelectionOrigin(view, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up);
    this.view.root.removeEventListener("mousemove", this.move);
    if (this.mightDrag && this.target) {
      this.view.domObserver.stop();
      if (this.mightDrag.addAttr)
        this.target.removeAttribute("draggable");
      if (this.mightDrag.setUneditable)
        this.target.removeAttribute("contentEditable");
      this.view.domObserver.start();
    }
    if (this.delayedSelectionSync)
      setTimeout(() => selectionToDOM(this.view));
    this.view.input.mouseDown = null;
  }
  up(event) {
    this.done();
    if (!this.view.dom.contains(event.target))
      return;
    let pos = this.pos;
    if (this.view.state.doc != this.startDoc)
      pos = this.view.posAtCoords(eventCoords(event));
    this.updateAllowDefault(event);
    if (this.allowDefault || !pos) {
      setSelectionOrigin(this.view, "pointer");
    } else if (handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) {
      event.preventDefault();
    } else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
      updateSelection(this.view, Selection.near(this.view.state.doc.resolve(pos.pos)));
      event.preventDefault();
    } else {
      setSelectionOrigin(this.view, "pointer");
    }
  }
  move(event) {
    this.updateAllowDefault(event);
    setSelectionOrigin(this.view, "pointer");
    if (event.buttons == 0)
      this.done();
  }
  updateAllowDefault(event) {
    if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4))
      this.allowDefault = true;
  }
}
handlers.touchstart = (view) => {
  view.input.lastTouch = Date.now();
  forceDOMFlush(view);
  setSelectionOrigin(view, "pointer");
};
handlers.touchmove = (view) => {
  view.input.lastTouch = Date.now();
  setSelectionOrigin(view, "pointer");
};
handlers.contextmenu = (view) => forceDOMFlush(view);
function inOrNearComposition(view, event) {
  if (view.composing)
    return true;
  if (safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
    view.input.compositionEndedAt = -2e8;
    return true;
  }
  return false;
}
const timeoutComposition = android ? 5e3 : -1;
editHandlers.compositionstart = editHandlers.compositionupdate = (view) => {
  if (!view.composing) {
    view.domObserver.flush();
    let { state } = view, $pos = state.selection.$to;
    if (state.selection instanceof TextSelection && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m2) => m2.type.spec.inclusive === false))) {
      view.markCursor = view.state.storedMarks || $pos.marks();
      endComposition(view, true);
      view.markCursor = null;
    } else {
      endComposition(view, !state.selection.empty);
      if (gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
        let sel = view.domSelectionRange();
        for (let node2 = sel.focusNode, offset3 = sel.focusOffset; node2 && node2.nodeType == 1 && offset3 != 0; ) {
          let before = offset3 < 0 ? node2.lastChild : node2.childNodes[offset3 - 1];
          if (!before)
            break;
          if (before.nodeType == 3) {
            let sel2 = view.domSelection();
            if (sel2)
              sel2.collapse(before, before.nodeValue.length);
            break;
          } else {
            node2 = before;
            offset3 = -1;
          }
        }
      }
    }
    view.input.composing = true;
  }
  scheduleComposeEnd(view, timeoutComposition);
};
editHandlers.compositionend = (view, event) => {
  if (view.composing) {
    view.input.composing = false;
    view.input.compositionEndedAt = event.timeStamp;
    view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
    view.input.compositionNode = null;
    if (view.input.compositionPendingChanges)
      Promise.resolve().then(() => view.domObserver.flush());
    view.input.compositionID++;
    scheduleComposeEnd(view, 20);
  }
};
function scheduleComposeEnd(view, delay) {
  clearTimeout(view.input.composingTimeout);
  if (delay > -1)
    view.input.composingTimeout = setTimeout(() => endComposition(view), delay);
}
function clearComposition(view) {
  if (view.composing) {
    view.input.composing = false;
    view.input.compositionEndedAt = timestampFromCustomEvent();
  }
  while (view.input.compositionNodes.length > 0)
    view.input.compositionNodes.pop().markParentsDirty();
}
function findCompositionNode(view) {
  let sel = view.domSelectionRange();
  if (!sel.focusNode)
    return null;
  let textBefore = textNodeBefore$1(sel.focusNode, sel.focusOffset);
  let textAfter = textNodeAfter$1(sel.focusNode, sel.focusOffset);
  if (textBefore && textAfter && textBefore != textAfter) {
    let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
    if (textBefore == lastChanged || textAfter == lastChanged)
      return lastChanged;
    if (!descAfter || !descAfter.isText(textAfter.nodeValue)) {
      return textAfter;
    } else if (view.input.compositionNode == textAfter) {
      let descBefore = textBefore.pmViewDesc;
      if (!(!descBefore || !descBefore.isText(textBefore.nodeValue)))
        return textAfter;
    }
  }
  return textBefore || textAfter;
}
function timestampFromCustomEvent() {
  let event = document.createEvent("Event");
  event.initEvent("event", true, true);
  return event.timeStamp;
}
function endComposition(view, restarting = false) {
  if (android && view.domObserver.flushingSoon >= 0)
    return;
  view.domObserver.forceFlush();
  clearComposition(view);
  if (restarting || view.docView && view.docView.dirty) {
    let sel = selectionFromDOM(view), cur = view.state.selection;
    if (sel && !sel.eq(cur))
      view.dispatch(view.state.tr.setSelection(sel));
    else if ((view.markCursor || restarting) && !cur.$from.node(cur.$from.sharedDepth(cur.to)).inlineContent)
      view.dispatch(view.state.tr.deleteSelection());
    else
      view.updateState(view.state);
    return true;
  }
  return false;
}
function captureCopy(view, dom) {
  if (!view.dom.parentNode)
    return;
  let wrap2 = view.dom.parentNode.appendChild(document.createElement("div"));
  wrap2.appendChild(dom);
  wrap2.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let sel = getSelection(), range = document.createRange();
  range.selectNodeContents(dom);
  view.dom.blur();
  sel.removeAllRanges();
  sel.addRange(range);
  setTimeout(() => {
    if (wrap2.parentNode)
      wrap2.parentNode.removeChild(wrap2);
    view.focus();
  }, 50);
}
const brokenClipboardAPI = ie$1 && ie_version < 15 || ios && webkit_version < 604;
handlers.copy = editHandlers.cut = (view, _event) => {
  let event = _event;
  let sel = view.state.selection, cut2 = event.type == "cut";
  if (sel.empty)
    return;
  let data = brokenClipboardAPI ? null : event.clipboardData;
  let slice3 = sel.content(), { dom, text: text2 } = serializeForClipboard(view, slice3);
  if (data) {
    event.preventDefault();
    data.clearData();
    data.setData("text/html", dom.innerHTML);
    data.setData("text/plain", text2);
  } else {
    captureCopy(view, dom);
  }
  if (cut2)
    view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function sliceSingleNode(slice3) {
  return slice3.openStart == 0 && slice3.openEnd == 0 && slice3.content.childCount == 1 ? slice3.content.firstChild : null;
}
function capturePaste(view, event) {
  if (!view.dom.parentNode)
    return;
  let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
  let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
  if (!plainText)
    target.contentEditable = "true";
  target.style.cssText = "position: fixed; left: -10000px; top: 10px";
  target.focus();
  let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
  setTimeout(() => {
    view.focus();
    if (target.parentNode)
      target.parentNode.removeChild(target);
    if (plainText)
      doPaste(view, target.value, null, plain, event);
    else
      doPaste(view, target.textContent, target.innerHTML, plain, event);
  }, 50);
}
function doPaste(view, text2, html2, preferPlain, event) {
  let slice3 = parseFromClipboard(view, text2, html2, preferPlain, view.state.selection.$from);
  if (view.someProp("handlePaste", (f2) => f2(view, event, slice3 || Slice.empty)))
    return true;
  if (!slice3)
    return false;
  let singleNode = sliceSingleNode(slice3);
  let tr2 = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice3);
  view.dispatch(tr2.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
  return true;
}
function getText$1(clipboardData) {
  let text2 = clipboardData.getData("text/plain") || clipboardData.getData("Text");
  if (text2)
    return text2;
  let uris = clipboardData.getData("text/uri-list");
  return uris ? uris.replace(/\r?\n/g, " ") : "";
}
editHandlers.paste = (view, _event) => {
  let event = _event;
  if (view.composing && !android)
    return;
  let data = brokenClipboardAPI ? null : event.clipboardData;
  let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
  if (data && doPaste(view, getText$1(data), data.getData("text/html"), plain, event))
    event.preventDefault();
  else
    capturePaste(view, event);
};
class Dragging {
  constructor(slice3, move4, node2) {
    this.slice = slice3;
    this.move = move4;
    this.node = node2;
  }
}
const dragCopyModifier = mac$2 ? "altKey" : "ctrlKey";
function dragMoves(view, event) {
  let moves = view.someProp("dragCopies", (test) => !test(event));
  return moves != null ? moves : !event[dragCopyModifier];
}
handlers.dragstart = (view, _event) => {
  let event = _event;
  let mouseDown = view.input.mouseDown;
  if (mouseDown)
    mouseDown.done();
  if (!event.dataTransfer)
    return;
  let sel = view.state.selection;
  let pos = sel.empty ? null : view.posAtCoords(eventCoords(event));
  let node2;
  if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof NodeSelection ? sel.to - 1 : sel.to)) ;
  else if (mouseDown && mouseDown.mightDrag) {
    node2 = NodeSelection.create(view.state.doc, mouseDown.mightDrag.pos);
  } else if (event.target && event.target.nodeType == 1) {
    let desc = view.docView.nearestDesc(event.target, true);
    if (desc && desc.node.type.spec.draggable && desc != view.docView)
      node2 = NodeSelection.create(view.state.doc, desc.posBefore);
  }
  let draggedSlice = (node2 || view.state.selection).content();
  let { dom, text: text2, slice: slice3 } = serializeForClipboard(view, draggedSlice);
  if (!event.dataTransfer.files.length || !chrome || chrome_version > 120)
    event.dataTransfer.clearData();
  event.dataTransfer.setData(brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
  event.dataTransfer.effectAllowed = "copyMove";
  if (!brokenClipboardAPI)
    event.dataTransfer.setData("text/plain", text2);
  view.dragging = new Dragging(slice3, dragMoves(view, event), node2);
};
handlers.dragend = (view) => {
  let dragging = view.dragging;
  window.setTimeout(() => {
    if (view.dragging == dragging)
      view.dragging = null;
  }, 50);
};
editHandlers.dragover = editHandlers.dragenter = (_2, e) => e.preventDefault();
editHandlers.drop = (view, _event) => {
  let event = _event;
  let dragging = view.dragging;
  view.dragging = null;
  if (!event.dataTransfer)
    return;
  let eventPos = view.posAtCoords(eventCoords(event));
  if (!eventPos)
    return;
  let $mouse = view.state.doc.resolve(eventPos.pos);
  let slice3 = dragging && dragging.slice;
  if (slice3) {
    view.someProp("transformPasted", (f2) => {
      slice3 = f2(slice3, view);
    });
  } else {
    slice3 = parseFromClipboard(view, getText$1(event.dataTransfer), brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
  }
  let move4 = !!(dragging && dragMoves(view, event));
  if (view.someProp("handleDrop", (f2) => f2(view, event, slice3 || Slice.empty, move4))) {
    event.preventDefault();
    return;
  }
  if (!slice3)
    return;
  event.preventDefault();
  let insertPos = slice3 ? dropPoint(view.state.doc, $mouse.pos, slice3) : $mouse.pos;
  if (insertPos == null)
    insertPos = $mouse.pos;
  let tr2 = view.state.tr;
  if (move4) {
    let { node: node2 } = dragging;
    if (node2)
      node2.replace(tr2);
    else
      tr2.deleteSelection();
  }
  let pos = tr2.mapping.map(insertPos);
  let isNode2 = slice3.openStart == 0 && slice3.openEnd == 0 && slice3.content.childCount == 1;
  let beforeInsert = tr2.doc;
  if (isNode2)
    tr2.replaceRangeWith(pos, pos, slice3.content.firstChild);
  else
    tr2.replaceRange(pos, pos, slice3);
  if (tr2.doc.eq(beforeInsert))
    return;
  let $pos = tr2.doc.resolve(pos);
  if (isNode2 && NodeSelection.isSelectable(slice3.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice3.content.firstChild)) {
    tr2.setSelection(new NodeSelection($pos));
  } else {
    let end2 = tr2.mapping.map(insertPos);
    tr2.mapping.maps[tr2.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo) => end2 = newTo);
    tr2.setSelection(selectionBetween(view, $pos, tr2.doc.resolve(end2)));
  }
  view.focus();
  view.dispatch(tr2.setMeta("uiEvent", "drop"));
};
handlers.focus = (view) => {
  view.input.lastFocus = Date.now();
  if (!view.focused) {
    view.domObserver.stop();
    view.dom.classList.add("ProseMirror-focused");
    view.domObserver.start();
    view.focused = true;
    setTimeout(() => {
      if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange()))
        selectionToDOM(view);
    }, 20);
  }
};
handlers.blur = (view, _event) => {
  let event = _event;
  if (view.focused) {
    view.domObserver.stop();
    view.dom.classList.remove("ProseMirror-focused");
    view.domObserver.start();
    if (event.relatedTarget && view.dom.contains(event.relatedTarget))
      view.domObserver.currentSelection.clear();
    view.focused = false;
  }
};
handlers.beforeinput = (view, _event) => {
  let event = _event;
  if (chrome && android && event.inputType == "deleteContentBackward") {
    view.domObserver.flushSoon();
    let { domChangeCount } = view.input;
    setTimeout(() => {
      if (view.input.domChangeCount != domChangeCount)
        return;
      view.dom.blur();
      view.focus();
      if (view.someProp("handleKeyDown", (f2) => f2(view, keyEvent(8, "Backspace"))))
        return;
      let { $cursor } = view.state.selection;
      if ($cursor && $cursor.pos > 0)
        view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
    }, 50);
  }
};
for (let prop in editHandlers)
  handlers[prop] = editHandlers[prop];
function compareObjs(a2, b2) {
  if (a2 == b2)
    return true;
  for (let p2 in a2)
    if (a2[p2] !== b2[p2])
      return false;
  for (let p2 in b2)
    if (!(p2 in a2))
      return false;
  return true;
}
class WidgetType {
  constructor(toDOM, spec) {
    this.toDOM = toDOM;
    this.spec = spec || noSpec;
    this.side = this.spec.side || 0;
  }
  map(mapping, span, offset3, oldOffset) {
    let { pos, deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
    return deleted ? null : new Decoration(pos - offset3, pos - offset3, this);
  }
  valid() {
    return true;
  }
  eq(other2) {
    return this == other2 || other2 instanceof WidgetType && (this.spec.key && this.spec.key == other2.spec.key || this.toDOM == other2.toDOM && compareObjs(this.spec, other2.spec));
  }
  destroy(node2) {
    if (this.spec.destroy)
      this.spec.destroy(node2);
  }
}
class InlineType {
  constructor(attrs, spec) {
    this.attrs = attrs;
    this.spec = spec || noSpec;
  }
  map(mapping, span, offset3, oldOffset) {
    let from3 = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset3;
    let to2 = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset3;
    return from3 >= to2 ? null : new Decoration(from3, to2, this);
  }
  valid(_2, span) {
    return span.from < span.to;
  }
  eq(other2) {
    return this == other2 || other2 instanceof InlineType && compareObjs(this.attrs, other2.attrs) && compareObjs(this.spec, other2.spec);
  }
  static is(span) {
    return span.type instanceof InlineType;
  }
  destroy() {
  }
}
class NodeType2 {
  constructor(attrs, spec) {
    this.attrs = attrs;
    this.spec = spec || noSpec;
  }
  map(mapping, span, offset3, oldOffset) {
    let from3 = mapping.mapResult(span.from + oldOffset, 1);
    if (from3.deleted)
      return null;
    let to2 = mapping.mapResult(span.to + oldOffset, -1);
    if (to2.deleted || to2.pos <= from3.pos)
      return null;
    return new Decoration(from3.pos - offset3, to2.pos - offset3, this);
  }
  valid(node2, span) {
    let { index: index2, offset: offset3 } = node2.content.findIndex(span.from), child;
    return offset3 == span.from && !(child = node2.child(index2)).isText && offset3 + child.nodeSize == span.to;
  }
  eq(other2) {
    return this == other2 || other2 instanceof NodeType2 && compareObjs(this.attrs, other2.attrs) && compareObjs(this.spec, other2.spec);
  }
  destroy() {
  }
}
class Decoration {
  /**
  @internal
  */
  constructor(from3, to2, type) {
    this.from = from3;
    this.to = to2;
    this.type = type;
  }
  /**
  @internal
  */
  copy(from3, to2) {
    return new Decoration(from3, to2, this.type);
  }
  /**
  @internal
  */
  eq(other2, offset3 = 0) {
    return this.type.eq(other2.type) && this.from + offset3 == other2.from && this.to + offset3 == other2.to;
  }
  /**
  @internal
  */
  map(mapping, offset3, oldOffset) {
    return this.type.map(mapping, this, offset3, oldOffset);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(pos, toDOM, spec) {
    return new Decoration(pos, pos, new WidgetType(toDOM, spec));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(from3, to2, attrs, spec) {
    return new Decoration(from3, to2, new InlineType(attrs, spec));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(from3, to2, attrs, spec) {
    return new Decoration(from3, to2, new NodeType2(attrs, spec));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof InlineType;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof WidgetType;
  }
}
const none = [], noSpec = {};
class DecorationSet {
  /**
  @internal
  */
  constructor(local, children) {
    this.local = local.length ? local : none;
    this.children = children.length ? children : none;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(doc2, decorations) {
    return decorations.length ? buildTree(decorations, doc2, 0, noSpec) : empty;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(start4, end2, predicate) {
    let result = [];
    this.findInner(start4 == null ? 0 : start4, end2 == null ? 1e9 : end2, result, 0, predicate);
    return result;
  }
  findInner(start4, end2, result, offset3, predicate) {
    for (let i = 0; i < this.local.length; i++) {
      let span = this.local[i];
      if (span.from <= end2 && span.to >= start4 && (!predicate || predicate(span.spec)))
        result.push(span.copy(span.from + offset3, span.to + offset3));
    }
    for (let i = 0; i < this.children.length; i += 3) {
      if (this.children[i] < end2 && this.children[i + 1] > start4) {
        let childOff = this.children[i] + 1;
        this.children[i + 2].findInner(start4 - childOff, end2 - childOff, result, offset3 + childOff, predicate);
      }
    }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(mapping, doc2, options) {
    if (this == empty || mapping.maps.length == 0)
      return this;
    return this.mapInner(mapping, doc2, 0, 0, options || noSpec);
  }
  /**
  @internal
  */
  mapInner(mapping, node2, offset3, oldOffset, options) {
    let newLocal;
    for (let i = 0; i < this.local.length; i++) {
      let mapped = this.local[i].map(mapping, offset3, oldOffset);
      if (mapped && mapped.type.valid(node2, mapped))
        (newLocal || (newLocal = [])).push(mapped);
      else if (options.onRemove)
        options.onRemove(this.local[i].spec);
    }
    if (this.children.length)
      return mapChildren(this.children, newLocal || [], mapping, node2, offset3, oldOffset, options);
    else
      return newLocal ? new DecorationSet(newLocal.sort(byPos), none) : empty;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(doc2, decorations) {
    if (!decorations.length)
      return this;
    if (this == empty)
      return DecorationSet.create(doc2, decorations);
    return this.addInner(doc2, decorations, 0);
  }
  addInner(doc2, decorations, offset3) {
    let children, childIndex = 0;
    doc2.forEach((childNode, childOffset) => {
      let baseOffset = childOffset + offset3, found2;
      if (!(found2 = takeSpansForNode(decorations, childNode, baseOffset)))
        return;
      if (!children)
        children = this.children.slice();
      while (childIndex < children.length && children[childIndex] < childOffset)
        childIndex += 3;
      if (children[childIndex] == childOffset)
        children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found2, baseOffset + 1);
      else
        children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, buildTree(found2, childNode, baseOffset + 1, noSpec));
      childIndex += 3;
    });
    let local = moveSpans(childIndex ? withoutNulls(decorations) : decorations, -offset3);
    for (let i = 0; i < local.length; i++)
      if (!local[i].type.valid(doc2, local[i]))
        local.splice(i--, 1);
    return new DecorationSet(local.length ? this.local.concat(local).sort(byPos) : this.local, children || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(decorations) {
    if (decorations.length == 0 || this == empty)
      return this;
    return this.removeInner(decorations, 0);
  }
  removeInner(decorations, offset3) {
    let children = this.children, local = this.local;
    for (let i = 0; i < children.length; i += 3) {
      let found2;
      let from3 = children[i] + offset3, to2 = children[i + 1] + offset3;
      for (let j2 = 0, span; j2 < decorations.length; j2++)
        if (span = decorations[j2]) {
          if (span.from > from3 && span.to < to2) {
            decorations[j2] = null;
            (found2 || (found2 = [])).push(span);
          }
        }
      if (!found2)
        continue;
      if (children == this.children)
        children = this.children.slice();
      let removed = children[i + 2].removeInner(found2, from3 + 1);
      if (removed != empty) {
        children[i + 2] = removed;
      } else {
        children.splice(i, 3);
        i -= 3;
      }
    }
    if (local.length) {
      for (let i = 0, span; i < decorations.length; i++)
        if (span = decorations[i]) {
          for (let j2 = 0; j2 < local.length; j2++)
            if (local[j2].eq(span, offset3)) {
              if (local == this.local)
                local = this.local.slice();
              local.splice(j2--, 1);
            }
        }
    }
    if (children == this.children && local == this.local)
      return this;
    return local.length || children.length ? new DecorationSet(local, children) : empty;
  }
  forChild(offset3, node2) {
    if (this == empty)
      return this;
    if (node2.isLeaf)
      return DecorationSet.empty;
    let child, local;
    for (let i = 0; i < this.children.length; i += 3)
      if (this.children[i] >= offset3) {
        if (this.children[i] == offset3)
          child = this.children[i + 2];
        break;
      }
    let start4 = offset3 + 1, end2 = start4 + node2.content.size;
    for (let i = 0; i < this.local.length; i++) {
      let dec = this.local[i];
      if (dec.from < end2 && dec.to > start4 && dec.type instanceof InlineType) {
        let from3 = Math.max(start4, dec.from) - start4, to2 = Math.min(end2, dec.to) - start4;
        if (from3 < to2)
          (local || (local = [])).push(dec.copy(from3, to2));
      }
    }
    if (local) {
      let localSet = new DecorationSet(local.sort(byPos), none);
      return child ? new DecorationGroup([localSet, child]) : localSet;
    }
    return child || empty;
  }
  /**
  @internal
  */
  eq(other2) {
    if (this == other2)
      return true;
    if (!(other2 instanceof DecorationSet) || this.local.length != other2.local.length || this.children.length != other2.children.length)
      return false;
    for (let i = 0; i < this.local.length; i++)
      if (!this.local[i].eq(other2.local[i]))
        return false;
    for (let i = 0; i < this.children.length; i += 3)
      if (this.children[i] != other2.children[i] || this.children[i + 1] != other2.children[i + 1] || !this.children[i + 2].eq(other2.children[i + 2]))
        return false;
    return true;
  }
  /**
  @internal
  */
  locals(node2) {
    return removeOverlap(this.localsInner(node2));
  }
  /**
  @internal
  */
  localsInner(node2) {
    if (this == empty)
      return none;
    if (node2.inlineContent || !this.local.some(InlineType.is))
      return this.local;
    let result = [];
    for (let i = 0; i < this.local.length; i++) {
      if (!(this.local[i].type instanceof InlineType))
        result.push(this.local[i]);
    }
    return result;
  }
  forEachSet(f2) {
    f2(this);
  }
}
DecorationSet.empty = new DecorationSet([], []);
DecorationSet.removeOverlap = removeOverlap;
const empty = DecorationSet.empty;
class DecorationGroup {
  constructor(members) {
    this.members = members;
  }
  map(mapping, doc2) {
    const mappedDecos = this.members.map((member) => member.map(mapping, doc2, noSpec));
    return DecorationGroup.from(mappedDecos);
  }
  forChild(offset3, child) {
    if (child.isLeaf)
      return DecorationSet.empty;
    let found2 = [];
    for (let i = 0; i < this.members.length; i++) {
      let result = this.members[i].forChild(offset3, child);
      if (result == empty)
        continue;
      if (result instanceof DecorationGroup)
        found2 = found2.concat(result.members);
      else
        found2.push(result);
    }
    return DecorationGroup.from(found2);
  }
  eq(other2) {
    if (!(other2 instanceof DecorationGroup) || other2.members.length != this.members.length)
      return false;
    for (let i = 0; i < this.members.length; i++)
      if (!this.members[i].eq(other2.members[i]))
        return false;
    return true;
  }
  locals(node2) {
    let result, sorted = true;
    for (let i = 0; i < this.members.length; i++) {
      let locals = this.members[i].localsInner(node2);
      if (!locals.length)
        continue;
      if (!result) {
        result = locals;
      } else {
        if (sorted) {
          result = result.slice();
          sorted = false;
        }
        for (let j2 = 0; j2 < locals.length; j2++)
          result.push(locals[j2]);
      }
    }
    return result ? removeOverlap(sorted ? result : result.sort(byPos)) : none;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(members) {
    switch (members.length) {
      case 0:
        return empty;
      case 1:
        return members[0];
      default:
        return new DecorationGroup(members.every((m2) => m2 instanceof DecorationSet) ? members : members.reduce((r2, m2) => r2.concat(m2 instanceof DecorationSet ? m2 : m2.members), []));
    }
  }
  forEachSet(f2) {
    for (let i = 0; i < this.members.length; i++)
      this.members[i].forEachSet(f2);
  }
}
function mapChildren(oldChildren, newLocal, mapping, node2, offset3, oldOffset, options) {
  let children = oldChildren.slice();
  for (let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++) {
    let moved = 0;
    mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd) => {
      let dSize = newEnd - newStart - (oldEnd - oldStart);
      for (let i2 = 0; i2 < children.length; i2 += 3) {
        let end2 = children[i2 + 1];
        if (end2 < 0 || oldStart > end2 + baseOffset - moved)
          continue;
        let start4 = children[i2] + baseOffset - moved;
        if (oldEnd >= start4) {
          children[i2 + 1] = oldStart <= start4 ? -2 : -1;
        } else if (oldStart >= baseOffset && dSize) {
          children[i2] += dSize;
          children[i2 + 1] += dSize;
        }
      }
      moved += dSize;
    });
    baseOffset = mapping.maps[i].map(baseOffset, -1);
  }
  let mustRebuild = false;
  for (let i = 0; i < children.length; i += 3)
    if (children[i + 1] < 0) {
      if (children[i + 1] == -2) {
        mustRebuild = true;
        children[i + 1] = -1;
        continue;
      }
      let from3 = mapping.map(oldChildren[i] + oldOffset), fromLocal = from3 - offset3;
      if (fromLocal < 0 || fromLocal >= node2.content.size) {
        mustRebuild = true;
        continue;
      }
      let to2 = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to2 - offset3;
      let { index: index2, offset: childOffset } = node2.content.findIndex(fromLocal);
      let childNode = node2.maybeChild(index2);
      if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
        let mapped = children[i + 2].mapInner(mapping, childNode, from3 + 1, oldChildren[i] + oldOffset + 1, options);
        if (mapped != empty) {
          children[i] = fromLocal;
          children[i + 1] = toLocal;
          children[i + 2] = mapped;
        } else {
          children[i + 1] = -2;
          mustRebuild = true;
        }
      } else {
        mustRebuild = true;
      }
    }
  if (mustRebuild) {
    let decorations = mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset3, oldOffset, options);
    let built = buildTree(decorations, node2, 0, options);
    newLocal = built.local;
    for (let i = 0; i < children.length; i += 3)
      if (children[i + 1] < 0) {
        children.splice(i, 3);
        i -= 3;
      }
    for (let i = 0, j2 = 0; i < built.children.length; i += 3) {
      let from3 = built.children[i];
      while (j2 < children.length && children[j2] < from3)
        j2 += 3;
      children.splice(j2, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
    }
  }
  return new DecorationSet(newLocal.sort(byPos), children);
}
function moveSpans(spans, offset3) {
  if (!offset3 || !spans.length)
    return spans;
  let result = [];
  for (let i = 0; i < spans.length; i++) {
    let span = spans[i];
    result.push(new Decoration(span.from + offset3, span.to + offset3, span.type));
  }
  return result;
}
function mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset3, oldOffset, options) {
  function gather(set2, oldOffset2) {
    for (let i = 0; i < set2.local.length; i++) {
      let mapped = set2.local[i].map(mapping, offset3, oldOffset2);
      if (mapped)
        decorations.push(mapped);
      else if (options.onRemove)
        options.onRemove(set2.local[i].spec);
    }
    for (let i = 0; i < set2.children.length; i += 3)
      gather(set2.children[i + 2], set2.children[i] + oldOffset2 + 1);
  }
  for (let i = 0; i < children.length; i += 3)
    if (children[i + 1] == -1)
      gather(children[i + 2], oldChildren[i] + oldOffset + 1);
  return decorations;
}
function takeSpansForNode(spans, node2, offset3) {
  if (node2.isLeaf)
    return null;
  let end2 = offset3 + node2.nodeSize, found2 = null;
  for (let i = 0, span; i < spans.length; i++) {
    if ((span = spans[i]) && span.from > offset3 && span.to < end2) {
      (found2 || (found2 = [])).push(span);
      spans[i] = null;
    }
  }
  return found2;
}
function withoutNulls(array) {
  let result = [];
  for (let i = 0; i < array.length; i++)
    if (array[i] != null)
      result.push(array[i]);
  return result;
}
function buildTree(spans, node2, offset3, options) {
  let children = [], hasNulls = false;
  node2.forEach((childNode, localStart) => {
    let found2 = takeSpansForNode(spans, childNode, localStart + offset3);
    if (found2) {
      hasNulls = true;
      let subtree = buildTree(found2, childNode, offset3 + localStart + 1, options);
      if (subtree != empty)
        children.push(localStart, localStart + childNode.nodeSize, subtree);
    }
  });
  let locals = moveSpans(hasNulls ? withoutNulls(spans) : spans, -offset3).sort(byPos);
  for (let i = 0; i < locals.length; i++)
    if (!locals[i].type.valid(node2, locals[i])) {
      if (options.onRemove)
        options.onRemove(locals[i].spec);
      locals.splice(i--, 1);
    }
  return locals.length || children.length ? new DecorationSet(locals, children) : empty;
}
function byPos(a2, b2) {
  return a2.from - b2.from || a2.to - b2.to;
}
function removeOverlap(spans) {
  let working = spans;
  for (let i = 0; i < working.length - 1; i++) {
    let span = working[i];
    if (span.from != span.to)
      for (let j2 = i + 1; j2 < working.length; j2++) {
        let next2 = working[j2];
        if (next2.from == span.from) {
          if (next2.to != span.to) {
            if (working == spans)
              working = spans.slice();
            working[j2] = next2.copy(next2.from, span.to);
            insertAhead(working, j2 + 1, next2.copy(span.to, next2.to));
          }
          continue;
        } else {
          if (next2.from < span.to) {
            if (working == spans)
              working = spans.slice();
            working[i] = span.copy(span.from, next2.from);
            insertAhead(working, j2, span.copy(next2.from, span.to));
          }
          break;
        }
      }
  }
  return working;
}
function insertAhead(array, i, deco) {
  while (i < array.length && byPos(deco, array[i]) > 0)
    i++;
  array.splice(i, 0, deco);
}
function viewDecorations(view) {
  let found2 = [];
  view.someProp("decorations", (f2) => {
    let result = f2(view.state);
    if (result && result != empty)
      found2.push(result);
  });
  if (view.cursorWrapper)
    found2.push(DecorationSet.create(view.state.doc, [view.cursorWrapper.deco]));
  return DecorationGroup.from(found2);
}
const observeOptions = {
  childList: true,
  characterData: true,
  characterDataOldValue: true,
  attributes: true,
  attributeOldValue: true,
  subtree: true
};
const useCharData = ie$1 && ie_version <= 11;
class SelectionState {
  constructor() {
    this.anchorNode = null;
    this.anchorOffset = 0;
    this.focusNode = null;
    this.focusOffset = 0;
  }
  set(sel) {
    this.anchorNode = sel.anchorNode;
    this.anchorOffset = sel.anchorOffset;
    this.focusNode = sel.focusNode;
    this.focusOffset = sel.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(sel) {
    return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
  }
}
class DOMObserver {
  constructor(view, handleDOMChange) {
    this.view = view;
    this.handleDOMChange = handleDOMChange;
    this.queue = [];
    this.flushingSoon = -1;
    this.observer = null;
    this.currentSelection = new SelectionState();
    this.onCharData = null;
    this.suppressingSelectionUpdates = false;
    this.lastChangedTextNode = null;
    this.observer = window.MutationObserver && new window.MutationObserver((mutations) => {
      for (let i = 0; i < mutations.length; i++)
        this.queue.push(mutations[i]);
      if (ie$1 && ie_version <= 11 && mutations.some((m2) => m2.type == "childList" && m2.removedNodes.length || m2.type == "characterData" && m2.oldValue.length > m2.target.nodeValue.length))
        this.flushSoon();
      else
        this.flush();
    });
    if (useCharData) {
      this.onCharData = (e) => {
        this.queue.push({ target: e.target, type: "characterData", oldValue: e.prevValue });
        this.flushSoon();
      };
    }
    this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    if (this.flushingSoon < 0)
      this.flushingSoon = window.setTimeout(() => {
        this.flushingSoon = -1;
        this.flush();
      }, 20);
  }
  forceFlush() {
    if (this.flushingSoon > -1) {
      window.clearTimeout(this.flushingSoon);
      this.flushingSoon = -1;
      this.flush();
    }
  }
  start() {
    if (this.observer) {
      this.observer.takeRecords();
      this.observer.observe(this.view.dom, observeOptions);
    }
    if (this.onCharData)
      this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
    this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let take = this.observer.takeRecords();
      if (take.length) {
        for (let i = 0; i < take.length; i++)
          this.queue.push(take[i]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    if (this.onCharData)
      this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
    this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = true;
    setTimeout(() => this.suppressingSelectionUpdates = false, 50);
  }
  onSelectionChange() {
    if (!hasFocusAndSelection(this.view))
      return;
    if (this.suppressingSelectionUpdates)
      return selectionToDOM(this.view);
    if (ie$1 && ie_version <= 11 && !this.view.state.selection.empty) {
      let sel = this.view.domSelectionRange();
      if (sel.focusNode && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset))
        return this.flushSoon();
    }
    this.flush();
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(sel) {
    if (!sel.focusNode)
      return true;
    let ancestors = /* @__PURE__ */ new Set(), container;
    for (let scan = sel.focusNode; scan; scan = parentNode(scan))
      ancestors.add(scan);
    for (let scan = sel.anchorNode; scan; scan = parentNode(scan))
      if (ancestors.has(scan)) {
        container = scan;
        break;
      }
    let desc = container && this.view.docView.nearestDesc(container);
    if (desc && desc.ignoreMutation({
      type: "selection",
      target: container.nodeType == 3 ? container.parentNode : container
    })) {
      this.setCurSelection();
      return true;
    }
  }
  pendingRecords() {
    if (this.observer)
      for (let mut of this.observer.takeRecords())
        this.queue.push(mut);
    return this.queue;
  }
  flush() {
    let { view } = this;
    if (!view.docView || this.flushingSoon > -1)
      return;
    let mutations = this.pendingRecords();
    if (mutations.length)
      this.queue = [];
    let sel = view.domSelectionRange();
    let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
    let from3 = -1, to2 = -1, typeOver = false, added = [];
    if (view.editable) {
      for (let i = 0; i < mutations.length; i++) {
        let result = this.registerMutation(mutations[i], added);
        if (result) {
          from3 = from3 < 0 ? result.from : Math.min(result.from, from3);
          to2 = to2 < 0 ? result.to : Math.max(result.to, to2);
          if (result.typeOver)
            typeOver = true;
        }
      }
    }
    if (gecko && added.length) {
      let brs = added.filter((n2) => n2.nodeName == "BR");
      if (brs.length == 2) {
        let [a2, b2] = brs;
        if (a2.parentNode && a2.parentNode.parentNode == b2.parentNode)
          b2.remove();
        else
          a2.remove();
      } else {
        let { focusNode } = this.currentSelection;
        for (let br2 of brs) {
          let parent2 = br2.parentNode;
          if (parent2 && parent2.nodeName == "LI" && (!focusNode || blockParent(view, focusNode) != parent2))
            br2.remove();
        }
      }
    }
    let readSel = null;
    if (from3 < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && selectionCollapsed(sel) && (readSel = selectionFromDOM(view)) && readSel.eq(Selection.near(view.state.doc.resolve(0), 1))) {
      view.input.lastFocus = 0;
      selectionToDOM(view);
      this.currentSelection.set(sel);
      view.scrollToSelection();
    } else if (from3 > -1 || newSel) {
      if (from3 > -1) {
        view.docView.markDirty(from3, to2);
        checkCSS(view);
      }
      this.handleDOMChange(from3, to2, typeOver, added);
      if (view.docView && view.docView.dirty)
        view.updateState(view.state);
      else if (!this.currentSelection.eq(sel))
        selectionToDOM(view);
      this.currentSelection.set(sel);
    }
  }
  registerMutation(mut, added) {
    if (added.indexOf(mut.target) > -1)
      return null;
    let desc = this.view.docView.nearestDesc(mut.target);
    if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style")))
      return null;
    if (!desc || desc.ignoreMutation(mut))
      return null;
    if (mut.type == "childList") {
      for (let i = 0; i < mut.addedNodes.length; i++) {
        let node2 = mut.addedNodes[i];
        added.push(node2);
        if (node2.nodeType == 3)
          this.lastChangedTextNode = node2;
      }
      if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target))
        return { from: desc.posBefore, to: desc.posAfter };
      let prev2 = mut.previousSibling, next2 = mut.nextSibling;
      if (ie$1 && ie_version <= 11 && mut.addedNodes.length) {
        for (let i = 0; i < mut.addedNodes.length; i++) {
          let { previousSibling, nextSibling } = mut.addedNodes[i];
          if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0)
            prev2 = previousSibling;
          if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0)
            next2 = nextSibling;
        }
      }
      let fromOffset = prev2 && prev2.parentNode == mut.target ? domIndex(prev2) + 1 : 0;
      let from3 = desc.localPosFromDOM(mut.target, fromOffset, -1);
      let toOffset = next2 && next2.parentNode == mut.target ? domIndex(next2) : mut.target.childNodes.length;
      let to2 = desc.localPosFromDOM(mut.target, toOffset, 1);
      return { from: from3, to: to2 };
    } else if (mut.type == "attributes") {
      return { from: desc.posAtStart - desc.border, to: desc.posAtEnd + desc.border };
    } else {
      this.lastChangedTextNode = mut.target;
      return {
        from: desc.posAtStart,
        to: desc.posAtEnd,
        // An event was generated for a text change that didn't change
        // any text. Mark the dom change to fall back to assuming the
        // selection was typed over with an identical value if it can't
        // find another change.
        typeOver: mut.target.nodeValue == mut.oldValue
      };
    }
  }
}
let cssChecked = /* @__PURE__ */ new WeakMap();
let cssCheckWarned = false;
function checkCSS(view) {
  if (cssChecked.has(view))
    return;
  cssChecked.set(view, null);
  if (["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
    view.requiresGeckoHackNode = gecko;
    if (cssCheckWarned)
      return;
    console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
    cssCheckWarned = true;
  }
}
function rangeToSelectionRange(view, range) {
  let anchorNode = range.startContainer, anchorOffset = range.startOffset;
  let focusNode = range.endContainer, focusOffset = range.endOffset;
  let currentAnchor = view.domAtPos(view.state.selection.anchor);
  if (isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset))
    [anchorNode, anchorOffset, focusNode, focusOffset] = [focusNode, focusOffset, anchorNode, anchorOffset];
  return { anchorNode, anchorOffset, focusNode, focusOffset };
}
function safariShadowSelectionRange(view, selection) {
  if (selection.getComposedRanges) {
    let range = selection.getComposedRanges(view.root)[0];
    if (range)
      return rangeToSelectionRange(view, range);
  }
  let found2;
  function read(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    found2 = event.getTargetRanges()[0];
  }
  view.dom.addEventListener("beforeinput", read, true);
  document.execCommand("indent");
  view.dom.removeEventListener("beforeinput", read, true);
  return found2 ? rangeToSelectionRange(view, found2) : null;
}
function blockParent(view, node2) {
  for (let p2 = node2.parentNode; p2 && p2 != view.dom; p2 = p2.parentNode) {
    let desc = view.docView.nearestDesc(p2, true);
    if (desc && desc.node.isBlock)
      return p2;
  }
  return null;
}
function parseBetween(view, from_, to_) {
  let { node: parent2, fromOffset, toOffset, from: from3, to: to2 } = view.docView.parseRange(from_, to_);
  let domSel = view.domSelectionRange();
  let find2;
  let anchor = domSel.anchorNode;
  if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
    find2 = [{ node: anchor, offset: domSel.anchorOffset }];
    if (!selectionCollapsed(domSel))
      find2.push({ node: domSel.focusNode, offset: domSel.focusOffset });
  }
  if (chrome && view.input.lastKeyCode === 8) {
    for (let off = toOffset; off > fromOffset; off--) {
      let node2 = parent2.childNodes[off - 1], desc = node2.pmViewDesc;
      if (node2.nodeName == "BR" && !desc) {
        toOffset = off;
        break;
      }
      if (!desc || desc.size)
        break;
    }
  }
  let startDoc = view.state.doc;
  let parser = view.someProp("domParser") || DOMParser.fromSchema(view.state.schema);
  let $from = startDoc.resolve(from3);
  let sel = null, doc2 = parser.parse(parent2, {
    topNode: $from.parent,
    topMatch: $from.parent.contentMatchAt($from.index()),
    topOpen: true,
    from: fromOffset,
    to: toOffset,
    preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
    findPositions: find2,
    ruleFromNode,
    context: $from
  });
  if (find2 && find2[0].pos != null) {
    let anchor2 = find2[0].pos, head = find2[1] && find2[1].pos;
    if (head == null)
      head = anchor2;
    sel = { anchor: anchor2 + from3, head: head + from3 };
  }
  return { doc: doc2, sel, from: from3, to: to2 };
}
function ruleFromNode(dom) {
  let desc = dom.pmViewDesc;
  if (desc) {
    return desc.parseRule();
  } else if (dom.nodeName == "BR" && dom.parentNode) {
    if (safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
      let skip = document.createElement("div");
      skip.appendChild(document.createElement("li"));
      return { skip };
    } else if (dom.parentNode.lastChild == dom || safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) {
      return { ignore: true };
    }
  } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) {
    return { ignore: true };
  }
  return null;
}
const isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function readDOMChange(view, from3, to2, typeOver, addedNodes) {
  let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
  view.input.compositionPendingChanges = 0;
  if (from3 < 0) {
    let origin2 = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
    let newSel = selectionFromDOM(view, origin2);
    if (newSel && !view.state.selection.eq(newSel)) {
      if (chrome && android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f2) => f2(view, keyEvent(13, "Enter"))))
        return;
      let tr2 = view.state.tr.setSelection(newSel);
      if (origin2 == "pointer")
        tr2.setMeta("pointer", true);
      else if (origin2 == "key")
        tr2.scrollIntoView();
      if (compositionID)
        tr2.setMeta("composition", compositionID);
      view.dispatch(tr2);
    }
    return;
  }
  let $before = view.state.doc.resolve(from3);
  let shared2 = $before.sharedDepth(to2);
  from3 = $before.before(shared2 + 1);
  to2 = view.state.doc.resolve(to2).after(shared2 + 1);
  let sel = view.state.selection;
  let parse3 = parseBetween(view, from3, to2);
  let doc2 = view.state.doc, compare = doc2.slice(parse3.from, parse3.to);
  let preferredPos, preferredSide;
  if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
    preferredPos = view.state.selection.to;
    preferredSide = "end";
  } else {
    preferredPos = view.state.selection.from;
    preferredSide = "start";
  }
  view.input.lastKeyCode = null;
  let change = findDiff(compare.content, parse3.doc.content, parse3.from, preferredPos, preferredSide);
  if (change)
    view.input.domChangeCount++;
  if ((ios && view.input.lastIOSEnter > Date.now() - 225 || android) && addedNodes.some((n2) => n2.nodeType == 1 && !isInline.test(n2.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f2) => f2(view, keyEvent(13, "Enter")))) {
    view.input.lastIOSEnter = 0;
    return;
  }
  if (!change) {
    if (typeOver && sel instanceof TextSelection && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse3.sel && parse3.sel.anchor != parse3.sel.head)) {
      change = { start: sel.from, endA: sel.to, endB: sel.to };
    } else {
      if (parse3.sel) {
        let sel2 = resolveSelection(view, view.state.doc, parse3.sel);
        if (sel2 && !sel2.eq(view.state.selection)) {
          let tr2 = view.state.tr.setSelection(sel2);
          if (compositionID)
            tr2.setMeta("composition", compositionID);
          view.dispatch(tr2);
        }
      }
      return;
    }
  }
  if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof TextSelection) {
    if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse3.from) {
      change.start = view.state.selection.from;
    } else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse3.to) {
      change.endB += view.state.selection.to - change.endA;
      change.endA = view.state.selection.to;
    }
  }
  if (ie$1 && ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse3.from && parse3.doc.textBetween(change.start - parse3.from - 1, change.start - parse3.from + 1) == "  ") {
    change.start--;
    change.endA--;
    change.endB--;
  }
  let $from = parse3.doc.resolveNoCache(change.start - parse3.from);
  let $to = parse3.doc.resolveNoCache(change.endB - parse3.from);
  let $fromA = doc2.resolve(change.start);
  let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
  let nextSel;
  if ((ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n2) => n2.nodeName == "DIV" || n2.nodeName == "P")) || !inlineChange && $from.pos < parse3.doc.content.size && (!$from.sameParent($to) || !$from.parent.inlineContent) && !/\S/.test(parse3.doc.textBetween($from.pos, $to.pos, "", "")) && (nextSel = Selection.findFrom(parse3.doc.resolve($from.pos + 1), 1, true)) && nextSel.head > $from.pos) && view.someProp("handleKeyDown", (f2) => f2(view, keyEvent(13, "Enter")))) {
    view.input.lastIOSEnter = 0;
    return;
  }
  if (view.state.selection.anchor > change.start && looksLikeBackspace(doc2, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f2) => f2(view, keyEvent(8, "Backspace")))) {
    if (android && chrome)
      view.domObserver.suppressSelectionUpdates();
    return;
  }
  if (chrome && change.endB == change.start)
    view.input.lastChromeDelete = Date.now();
  if (android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse3.sel && parse3.sel.anchor == parse3.sel.head && parse3.sel.head == change.endA) {
    change.endB -= 2;
    $to = parse3.doc.resolveNoCache(change.endB - parse3.from);
    setTimeout(() => {
      view.someProp("handleKeyDown", function(f2) {
        return f2(view, keyEvent(13, "Enter"));
      });
    }, 20);
  }
  let chFrom = change.start, chTo = change.endA;
  let mkTr = (base2) => {
    let tr2 = base2 || view.state.tr.replace(chFrom, chTo, parse3.doc.slice(change.start - parse3.from, change.endB - parse3.from));
    if (parse3.sel) {
      let sel2 = resolveSelection(view, tr2.doc, parse3.sel);
      if (sel2 && !(chrome && view.composing && sel2.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel2.head == chFrom || sel2.head == tr2.mapping.map(chTo) - 1) || ie$1 && sel2.empty && sel2.head == chFrom))
        tr2.setSelection(sel2);
    }
    if (compositionID)
      tr2.setMeta("composition", compositionID);
    return tr2.scrollIntoView();
  };
  let markChange;
  if (inlineChange) {
    if ($from.pos == $to.pos) {
      if (ie$1 && ie_version <= 11 && $from.parentOffset == 0) {
        view.domObserver.suppressSelectionUpdates();
        setTimeout(() => selectionToDOM(view), 20);
      }
      let tr2 = mkTr(view.state.tr.delete(chFrom, chTo));
      let marks = doc2.resolve(change.start).marksAcross(doc2.resolve(change.endA));
      if (marks)
        tr2.ensureMarks(marks);
      view.dispatch(tr2);
    } else if (
      // Adding or removing a mark
      change.endA == change.endB && (markChange = isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))
    ) {
      let tr2 = mkTr(view.state.tr);
      if (markChange.type == "add")
        tr2.addMark(chFrom, chTo, markChange.mark);
      else
        tr2.removeMark(chFrom, chTo, markChange.mark);
      view.dispatch(tr2);
    } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
      let text2 = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
      let deflt = () => mkTr(view.state.tr.insertText(text2, chFrom, chTo));
      if (!view.someProp("handleTextInput", (f2) => f2(view, chFrom, chTo, text2, deflt)))
        view.dispatch(deflt());
    }
  } else {
    view.dispatch(mkTr());
  }
}
function resolveSelection(view, doc2, parsedSel) {
  if (Math.max(parsedSel.anchor, parsedSel.head) > doc2.content.size)
    return null;
  return selectionBetween(view, doc2.resolve(parsedSel.anchor), doc2.resolve(parsedSel.head));
}
function isMarkChange(cur, prev2) {
  let curMarks = cur.firstChild.marks, prevMarks = prev2.firstChild.marks;
  let added = curMarks, removed = prevMarks, type, mark2, update2;
  for (let i = 0; i < prevMarks.length; i++)
    added = prevMarks[i].removeFromSet(added);
  for (let i = 0; i < curMarks.length; i++)
    removed = curMarks[i].removeFromSet(removed);
  if (added.length == 1 && removed.length == 0) {
    mark2 = added[0];
    type = "add";
    update2 = (node2) => node2.mark(mark2.addToSet(node2.marks));
  } else if (added.length == 0 && removed.length == 1) {
    mark2 = removed[0];
    type = "remove";
    update2 = (node2) => node2.mark(mark2.removeFromSet(node2.marks));
  } else {
    return null;
  }
  let updated = [];
  for (let i = 0; i < prev2.childCount; i++)
    updated.push(update2(prev2.child(i)));
  if (Fragment.from(updated).eq(cur))
    return { mark: mark2, type };
}
function looksLikeBackspace(old, start4, end2, $newStart, $newEnd) {
  if (
    // The content must have shrunk
    end2 - start4 <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    skipClosingAndOpening($newStart, true, false) < $newEnd.pos
  )
    return false;
  let $start = old.resolve(start4);
  if (!$newStart.parent.isTextblock) {
    let after = $start.nodeAfter;
    return after != null && end2 == start4 + after.nodeSize;
  }
  if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock)
    return false;
  let $next = old.resolve(skipClosingAndOpening($start, true, true));
  if (!$next.parent.isTextblock || $next.pos > end2 || skipClosingAndOpening($next, true, false) < end2)
    return false;
  return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function skipClosingAndOpening($pos, fromEnd, mayOpen) {
  let depth = $pos.depth, end2 = fromEnd ? $pos.end() : $pos.pos;
  while (depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)) {
    depth--;
    end2++;
    fromEnd = false;
  }
  if (mayOpen) {
    let next2 = $pos.node(depth).maybeChild($pos.indexAfter(depth));
    while (next2 && !next2.isLeaf) {
      next2 = next2.firstChild;
      end2++;
    }
  }
  return end2;
}
function findDiff(a2, b2, pos, preferredPos, preferredSide) {
  let start4 = a2.findDiffStart(b2, pos);
  if (start4 == null)
    return null;
  let { a: endA, b: endB } = a2.findDiffEnd(b2, pos + a2.size, pos + b2.size);
  if (preferredSide == "end") {
    let adjust = Math.max(0, start4 - Math.min(endA, endB));
    preferredPos -= endA + adjust - start4;
  }
  if (endA < start4 && a2.size < b2.size) {
    let move4 = preferredPos <= start4 && preferredPos >= endA ? start4 - preferredPos : 0;
    start4 -= move4;
    if (start4 && start4 < b2.size && isSurrogatePair(b2.textBetween(start4 - 1, start4 + 1)))
      start4 += move4 ? 1 : -1;
    endB = start4 + (endB - endA);
    endA = start4;
  } else if (endB < start4) {
    let move4 = preferredPos <= start4 && preferredPos >= endB ? start4 - preferredPos : 0;
    start4 -= move4;
    if (start4 && start4 < a2.size && isSurrogatePair(a2.textBetween(start4 - 1, start4 + 1)))
      start4 += move4 ? 1 : -1;
    endA = start4 + (endA - endB);
    endB = start4;
  }
  return { start: start4, endA, endB };
}
function isSurrogatePair(str) {
  if (str.length != 2)
    return false;
  let a2 = str.charCodeAt(0), b2 = str.charCodeAt(1);
  return a2 >= 56320 && a2 <= 57343 && b2 >= 55296 && b2 <= 56319;
}
class EditorView {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(place, props) {
    this._root = null;
    this.focused = false;
    this.trackWrites = null;
    this.mounted = false;
    this.markCursor = null;
    this.cursorWrapper = null;
    this.lastSelectedViewDesc = void 0;
    this.input = new InputState();
    this.prevDirectPlugins = [];
    this.pluginViews = [];
    this.requiresGeckoHackNode = false;
    this.dragging = null;
    this._props = props;
    this.state = props.state;
    this.directPlugins = props.plugins || [];
    this.directPlugins.forEach(checkStateComponent);
    this.dispatch = this.dispatch.bind(this);
    this.dom = place && place.mount || document.createElement("div");
    if (place) {
      if (place.appendChild)
        place.appendChild(this.dom);
      else if (typeof place == "function")
        place(this.dom);
      else if (place.mount)
        this.mounted = true;
    }
    this.editable = getEditable(this);
    updateCursorWrapper(this);
    this.nodeViews = buildNodeViews(this);
    this.docView = docViewDesc(this.state.doc, computeDocDeco(this), viewDecorations(this), this.dom, this);
    this.domObserver = new DOMObserver(this, (from3, to2, typeOver, added) => readDOMChange(this, from3, to2, typeOver, added));
    this.domObserver.start();
    initInput(this);
    this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let prev2 = this._props;
      this._props = {};
      for (let name2 in prev2)
        this._props[name2] = prev2[name2];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(props) {
    if (props.handleDOMEvents != this._props.handleDOMEvents)
      ensureListeners(this);
    let prevProps = this._props;
    this._props = props;
    if (props.plugins) {
      props.plugins.forEach(checkStateComponent);
      this.directPlugins = props.plugins;
    }
    this.updateStateInner(props.state, prevProps);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(props) {
    let updated = {};
    for (let name2 in this._props)
      updated[name2] = this._props[name2];
    updated.state = this.state;
    for (let name2 in props)
      updated[name2] = props[name2];
    this.update(updated);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(state) {
    this.updateStateInner(state, this._props);
  }
  updateStateInner(state, prevProps) {
    var _a3;
    let prev2 = this.state, redraw = false, updateSel = false;
    if (state.storedMarks && this.composing) {
      clearComposition(this);
      updateSel = true;
    }
    this.state = state;
    let pluginsChanged = prev2.plugins != state.plugins || this._props.plugins != prevProps.plugins;
    if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
      let nodeViews = buildNodeViews(this);
      if (changedNodeViews(nodeViews, this.nodeViews)) {
        this.nodeViews = nodeViews;
        redraw = true;
      }
    }
    if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) {
      ensureListeners(this);
    }
    this.editable = getEditable(this);
    updateCursorWrapper(this);
    let innerDeco = viewDecorations(this), outerDeco = computeDocDeco(this);
    let scroll4 = prev2.plugins != state.plugins && !prev2.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev2.scrollToSelection ? "to selection" : "preserve";
    let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
    if (updateDoc || !state.selection.eq(prev2.selection))
      updateSel = true;
    let oldScrollPos = scroll4 == "preserve" && updateSel && this.dom.style.overflowAnchor == null && storeScrollPos(this);
    if (updateSel) {
      this.domObserver.stop();
      let forceSelUpdate = updateDoc && (ie$1 || chrome) && !this.composing && !prev2.selection.empty && !state.selection.empty && selectionContextChanged(prev2.selection, state.selection);
      if (updateDoc) {
        let chromeKludge = chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
        if (this.composing)
          this.input.compositionNode = findCompositionNode(this);
        if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
          this.docView.updateOuterDeco(outerDeco);
          this.docView.destroy();
          this.docView = docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
        }
        if (chromeKludge && !this.trackWrites)
          forceSelUpdate = true;
      }
      if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && anchorInRightPlace(this))) {
        selectionToDOM(this, forceSelUpdate);
      } else {
        syncNodeSelection(this, state.selection);
        this.domObserver.setCurSelection();
      }
      this.domObserver.start();
    }
    this.updatePluginViews(prev2);
    if (((_a3 = this.dragging) === null || _a3 === void 0 ? void 0 : _a3.node) && !prev2.doc.eq(state.doc))
      this.updateDraggedNode(this.dragging, prev2);
    if (scroll4 == "reset") {
      this.dom.scrollTop = 0;
    } else if (scroll4 == "to selection") {
      this.scrollToSelection();
    } else if (oldScrollPos) {
      resetScrollPos(oldScrollPos);
    }
  }
  /**
  @internal
  */
  scrollToSelection() {
    let startDOM = this.domSelectionRange().focusNode;
    if (!startDOM || !this.dom.contains(startDOM.nodeType == 1 ? startDOM : startDOM.parentNode)) ;
    else if (this.someProp("handleScrollToSelection", (f2) => f2(this))) ;
    else if (this.state.selection instanceof NodeSelection) {
      let target = this.docView.domAfterPos(this.state.selection.from);
      if (target.nodeType == 1)
        scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
    } else {
      scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
  }
  destroyPluginViews() {
    let view;
    while (view = this.pluginViews.pop())
      if (view.destroy)
        view.destroy();
  }
  updatePluginViews(prevState) {
    if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins;
      this.destroyPluginViews();
      for (let i = 0; i < this.directPlugins.length; i++) {
        let plugin2 = this.directPlugins[i];
        if (plugin2.spec.view)
          this.pluginViews.push(plugin2.spec.view(this));
      }
      for (let i = 0; i < this.state.plugins.length; i++) {
        let plugin2 = this.state.plugins[i];
        if (plugin2.spec.view)
          this.pluginViews.push(plugin2.spec.view(this));
      }
    } else {
      for (let i = 0; i < this.pluginViews.length; i++) {
        let pluginView = this.pluginViews[i];
        if (pluginView.update)
          pluginView.update(this, prevState);
      }
    }
  }
  updateDraggedNode(dragging, prev2) {
    let sel = dragging.node, found2 = -1;
    if (this.state.doc.nodeAt(sel.from) == sel.node) {
      found2 = sel.from;
    } else {
      let movedPos = sel.from + (this.state.doc.content.size - prev2.doc.content.size);
      let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
      if (moved == sel.node)
        found2 = movedPos;
    }
    this.dragging = new Dragging(dragging.slice, dragging.move, found2 < 0 ? void 0 : NodeSelection.create(this.state.doc, found2));
  }
  someProp(propName, f2) {
    let prop = this._props && this._props[propName], value;
    if (prop != null && (value = f2 ? f2(prop) : prop))
      return value;
    for (let i = 0; i < this.directPlugins.length; i++) {
      let prop2 = this.directPlugins[i].props[propName];
      if (prop2 != null && (value = f2 ? f2(prop2) : prop2))
        return value;
    }
    let plugins = this.state.plugins;
    if (plugins)
      for (let i = 0; i < plugins.length; i++) {
        let prop2 = plugins[i].props[propName];
        if (prop2 != null && (value = f2 ? f2(prop2) : prop2))
          return value;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (ie$1) {
      let node2 = this.root.activeElement;
      if (node2 == this.dom)
        return true;
      if (!node2 || !this.dom.contains(node2))
        return false;
      while (node2 && this.dom != node2 && this.dom.contains(node2)) {
        if (node2.contentEditable == "false")
          return false;
        node2 = node2.parentElement;
      }
      return true;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop();
    if (this.editable)
      focusPreventScroll(this.dom);
    selectionToDOM(this);
    this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let cached = this._root;
    if (cached == null)
      for (let search2 = this.dom.parentNode; search2; search2 = search2.parentNode) {
        if (search2.nodeType == 9 || search2.nodeType == 11 && search2.host) {
          if (!search2.getSelection)
            Object.getPrototypeOf(search2).getSelection = () => search2.ownerDocument.getSelection();
          return this._root = search2;
        }
      }
    return cached || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(coords) {
    return posAtCoords(this, coords);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(pos, side = 1) {
    return coordsAtPos(this, pos, side);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(pos, side = 0) {
    return this.docView.domFromPos(pos, side);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(pos) {
    let desc = this.docView.descAt(pos);
    return desc ? desc.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(node2, offset3, bias = -1) {
    let pos = this.docView.posFromDOM(node2, offset3, bias);
    if (pos == null)
      throw new RangeError("DOM position not inside the editor");
    return pos;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(dir, state) {
    return endOfTextblock(this, state || this.state, dir);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(html2, event) {
    return doPaste(this, "", html2, false, event || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(text2, event) {
    return doPaste(this, text2, null, true, event || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(slice3) {
    return serializeForClipboard(this, slice3);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    if (!this.docView)
      return;
    destroyInput(this);
    this.destroyPluginViews();
    if (this.mounted) {
      this.docView.update(this.state.doc, [], viewDecorations(this), this);
      this.dom.textContent = "";
    } else if (this.dom.parentNode) {
      this.dom.parentNode.removeChild(this.dom);
    }
    this.docView.destroy();
    this.docView = null;
    clearReusedRange();
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(event) {
    return dispatchEvent(this, event);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let sel = this.domSelection();
    if (!sel)
      return { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
    return safari && this.root.nodeType === 11 && deepActiveElement(this.dom.ownerDocument) == this.dom && safariShadowSelectionRange(this, sel) || sel;
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
EditorView.prototype.dispatch = function(tr2) {
  let dispatchTransaction = this._props.dispatchTransaction;
  if (dispatchTransaction)
    dispatchTransaction.call(this, tr2);
  else
    this.updateState(this.state.apply(tr2));
};
function computeDocDeco(view) {
  let attrs = /* @__PURE__ */ Object.create(null);
  attrs.class = "ProseMirror";
  attrs.contenteditable = String(view.editable);
  view.someProp("attributes", (value) => {
    if (typeof value == "function")
      value = value(view.state);
    if (value)
      for (let attr in value) {
        if (attr == "class")
          attrs.class += " " + value[attr];
        else if (attr == "style")
          attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
        else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName")
          attrs[attr] = String(value[attr]);
      }
  });
  if (!attrs.translate)
    attrs.translate = "no";
  return [Decoration.node(0, view.state.doc.content.size, attrs)];
}
function updateCursorWrapper(view) {
  if (view.markCursor) {
    let dom = document.createElement("img");
    dom.className = "ProseMirror-separator";
    dom.setAttribute("mark-placeholder", "true");
    dom.setAttribute("alt", "");
    view.cursorWrapper = { dom, deco: Decoration.widget(view.state.selection.from, dom, { raw: true, marks: view.markCursor }) };
  } else {
    view.cursorWrapper = null;
  }
}
function getEditable(view) {
  return !view.someProp("editable", (value) => value(view.state) === false);
}
function selectionContextChanged(sel1, sel2) {
  let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
  return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function buildNodeViews(view) {
  let result = /* @__PURE__ */ Object.create(null);
  function add4(obj) {
    for (let prop in obj)
      if (!Object.prototype.hasOwnProperty.call(result, prop))
        result[prop] = obj[prop];
  }
  view.someProp("nodeViews", add4);
  view.someProp("markViews", add4);
  return result;
}
function changedNodeViews(a2, b2) {
  let nA = 0, nB = 0;
  for (let prop in a2) {
    if (a2[prop] != b2[prop])
      return true;
    nA++;
  }
  for (let _2 in b2)
    nB++;
  return nA != nB;
}
function checkStateComponent(plugin2) {
  if (plugin2.spec.state || plugin2.spec.filterTransaction || plugin2.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var base = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
};
var shift2 = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
};
var mac$1 = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var i = 0; i < 10; i++) base[48 + i] = base[96 + i] = String(i);
for (var i = 1; i <= 24; i++) base[i + 111] = "F" + i;
for (var i = 65; i <= 90; i++) {
  base[i] = String.fromCharCode(i + 32);
  shift2[i] = String.fromCharCode(i);
}
for (var code in base) if (!shift2.hasOwnProperty(code)) shift2[code] = base[code];
function keyName(event) {
  var ignoreKey = mac$1 && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
  var name2 = !ignoreKey && event.key || (event.shiftKey ? shift2 : base)[event.keyCode] || event.key || "Unidentified";
  if (name2 == "Esc") name2 = "Escape";
  if (name2 == "Del") name2 = "Delete";
  if (name2 == "Left") name2 = "ArrowLeft";
  if (name2 == "Up") name2 = "ArrowUp";
  if (name2 == "Right") name2 = "ArrowRight";
  if (name2 == "Down") name2 = "ArrowDown";
  return name2;
}
const mac = typeof navigator != "undefined" && /Mac|iP(hone|[oa]d)/.test(navigator.platform);
const windows = typeof navigator != "undefined" && /Win/.test(navigator.platform);
function normalizeKeyName$1(name2) {
  let parts = name2.split(/-(?!$)/), result = parts[parts.length - 1];
  if (result == "Space")
    result = " ";
  let alt, ctrl, shift3, meta;
  for (let i = 0; i < parts.length - 1; i++) {
    let mod2 = parts[i];
    if (/^(cmd|meta|m)$/i.test(mod2))
      meta = true;
    else if (/^a(lt)?$/i.test(mod2))
      alt = true;
    else if (/^(c|ctrl|control)$/i.test(mod2))
      ctrl = true;
    else if (/^s(hift)?$/i.test(mod2))
      shift3 = true;
    else if (/^mod$/i.test(mod2)) {
      if (mac)
        meta = true;
      else
        ctrl = true;
    } else
      throw new Error("Unrecognized modifier name: " + mod2);
  }
  if (alt)
    result = "Alt-" + result;
  if (ctrl)
    result = "Ctrl-" + result;
  if (meta)
    result = "Meta-" + result;
  if (shift3)
    result = "Shift-" + result;
  return result;
}
function normalize(map3) {
  let copy2 = /* @__PURE__ */ Object.create(null);
  for (let prop in map3)
    copy2[normalizeKeyName$1(prop)] = map3[prop];
  return copy2;
}
function modifiers(name2, event, shift3 = true) {
  if (event.altKey)
    name2 = "Alt-" + name2;
  if (event.ctrlKey)
    name2 = "Ctrl-" + name2;
  if (event.metaKey)
    name2 = "Meta-" + name2;
  if (shift3 && event.shiftKey)
    name2 = "Shift-" + name2;
  return name2;
}
function keymap(bindings) {
  return new Plugin({ props: { handleKeyDown: keydownHandler(bindings) } });
}
function keydownHandler(bindings) {
  let map3 = normalize(bindings);
  return function(view, event) {
    let name2 = keyName(event), baseName, direct = map3[modifiers(name2, event)];
    if (direct && direct(view.state, view.dispatch, view))
      return true;
    if (name2.length == 1 && name2 != " ") {
      if (event.shiftKey) {
        let noShift = map3[modifiers(name2, event, false)];
        if (noShift && noShift(view.state, view.dispatch, view))
          return true;
      }
      if ((event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(windows && event.ctrlKey && event.altKey) && (baseName = base[event.keyCode]) && baseName != name2) {
        let fromCode = map3[modifiers(baseName, event)];
        if (fromCode && fromCode(view.state, view.dispatch, view))
          return true;
      }
    }
    return false;
  };
}
const deleteSelection$1 = (state, dispatch) => {
  if (state.selection.empty)
    return false;
  if (dispatch)
    dispatch(state.tr.deleteSelection().scrollIntoView());
  return true;
};
function atBlockStart(state, view) {
  let { $cursor } = state.selection;
  if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0))
    return null;
  return $cursor;
}
const joinBackward$1 = (state, dispatch, view) => {
  let $cursor = atBlockStart(state, view);
  if (!$cursor)
    return false;
  let $cut = findCutBefore($cursor);
  if (!$cut) {
    let range = $cursor.blockRange(), target = range && liftTarget(range);
    if (target == null)
      return false;
    if (dispatch)
      dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
  }
  let before = $cut.nodeBefore;
  if (deleteBarrier(state, $cut, dispatch, -1))
    return true;
  if ($cursor.parent.content.size == 0 && (textblockAt(before, "end") || NodeSelection.isSelectable(before))) {
    for (let depth = $cursor.depth; ; depth--) {
      let delStep = replaceStep(state.doc, $cursor.before(depth), $cursor.after(depth), Slice.empty);
      if (delStep && delStep.slice.size < delStep.to - delStep.from) {
        if (dispatch) {
          let tr2 = state.tr.step(delStep);
          tr2.setSelection(textblockAt(before, "end") ? Selection.findFrom(tr2.doc.resolve(tr2.mapping.map($cut.pos, -1)), -1) : NodeSelection.create(tr2.doc, $cut.pos - before.nodeSize));
          dispatch(tr2.scrollIntoView());
        }
        return true;
      }
      if (depth == 1 || $cursor.node(depth - 1).childCount > 1)
        break;
    }
  }
  if (before.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch)
      dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
    return true;
  }
  return false;
};
const joinTextblockBackward$1 = (state, dispatch, view) => {
  let $cursor = atBlockStart(state, view);
  if (!$cursor)
    return false;
  let $cut = findCutBefore($cursor);
  return $cut ? joinTextblocksAround(state, $cut, dispatch) : false;
};
const joinTextblockForward$1 = (state, dispatch, view) => {
  let $cursor = atBlockEnd(state, view);
  if (!$cursor)
    return false;
  let $cut = findCutAfter($cursor);
  return $cut ? joinTextblocksAround(state, $cut, dispatch) : false;
};
function joinTextblocksAround(state, $cut, dispatch) {
  let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
  for (; !beforeText.isTextblock; beforePos--) {
    if (beforeText.type.spec.isolating)
      return false;
    let child = beforeText.lastChild;
    if (!child)
      return false;
    beforeText = child;
  }
  let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
  for (; !afterText.isTextblock; afterPos++) {
    if (afterText.type.spec.isolating)
      return false;
    let child = afterText.firstChild;
    if (!child)
      return false;
    afterText = child;
  }
  let step = replaceStep(state.doc, beforePos, afterPos, Slice.empty);
  if (!step || step.from != beforePos || step instanceof ReplaceStep && step.slice.size >= afterPos - beforePos)
    return false;
  if (dispatch) {
    let tr2 = state.tr.step(step);
    tr2.setSelection(TextSelection.create(tr2.doc, beforePos));
    dispatch(tr2.scrollIntoView());
  }
  return true;
}
function textblockAt(node2, side, only = false) {
  for (let scan = node2; scan; scan = side == "start" ? scan.firstChild : scan.lastChild) {
    if (scan.isTextblock)
      return true;
    if (only && scan.childCount != 1)
      return false;
  }
  return false;
}
const selectNodeBackward$1 = (state, dispatch, view) => {
  let { $head, empty: empty2 } = state.selection, $cut = $head;
  if (!empty2)
    return false;
  if ($head.parent.isTextblock) {
    if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0)
      return false;
    $cut = findCutBefore($head);
  }
  let node2 = $cut && $cut.nodeBefore;
  if (!node2 || !NodeSelection.isSelectable(node2))
    return false;
  if (dispatch)
    dispatch(state.tr.setSelection(NodeSelection.create(state.doc, $cut.pos - node2.nodeSize)).scrollIntoView());
  return true;
};
function findCutBefore($pos) {
  if (!$pos.parent.type.spec.isolating)
    for (let i = $pos.depth - 1; i >= 0; i--) {
      if ($pos.index(i) > 0)
        return $pos.doc.resolve($pos.before(i + 1));
      if ($pos.node(i).type.spec.isolating)
        break;
    }
  return null;
}
function atBlockEnd(state, view) {
  let { $cursor } = state.selection;
  if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size))
    return null;
  return $cursor;
}
const joinForward$1 = (state, dispatch, view) => {
  let $cursor = atBlockEnd(state, view);
  if (!$cursor)
    return false;
  let $cut = findCutAfter($cursor);
  if (!$cut)
    return false;
  let after = $cut.nodeAfter;
  if (deleteBarrier(state, $cut, dispatch, 1))
    return true;
  if ($cursor.parent.content.size == 0 && (textblockAt(after, "start") || NodeSelection.isSelectable(after))) {
    let delStep = replaceStep(state.doc, $cursor.before(), $cursor.after(), Slice.empty);
    if (delStep && delStep.slice.size < delStep.to - delStep.from) {
      if (dispatch) {
        let tr2 = state.tr.step(delStep);
        tr2.setSelection(textblockAt(after, "start") ? Selection.findFrom(tr2.doc.resolve(tr2.mapping.map($cut.pos)), 1) : NodeSelection.create(tr2.doc, tr2.mapping.map($cut.pos)));
        dispatch(tr2.scrollIntoView());
      }
      return true;
    }
  }
  if (after.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch)
      dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
    return true;
  }
  return false;
};
const selectNodeForward$1 = (state, dispatch, view) => {
  let { $head, empty: empty2 } = state.selection, $cut = $head;
  if (!empty2)
    return false;
  if ($head.parent.isTextblock) {
    if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size)
      return false;
    $cut = findCutAfter($head);
  }
  let node2 = $cut && $cut.nodeAfter;
  if (!node2 || !NodeSelection.isSelectable(node2))
    return false;
  if (dispatch)
    dispatch(state.tr.setSelection(NodeSelection.create(state.doc, $cut.pos)).scrollIntoView());
  return true;
};
function findCutAfter($pos) {
  if (!$pos.parent.type.spec.isolating)
    for (let i = $pos.depth - 1; i >= 0; i--) {
      let parent2 = $pos.node(i);
      if ($pos.index(i) + 1 < parent2.childCount)
        return $pos.doc.resolve($pos.after(i + 1));
      if (parent2.type.spec.isolating)
        break;
    }
  return null;
}
const joinUp$1 = (state, dispatch) => {
  let sel = state.selection, nodeSel = sel instanceof NodeSelection, point2;
  if (nodeSel) {
    if (sel.node.isTextblock || !canJoin(state.doc, sel.from))
      return false;
    point2 = sel.from;
  } else {
    point2 = joinPoint(state.doc, sel.from, -1);
    if (point2 == null)
      return false;
  }
  if (dispatch) {
    let tr2 = state.tr.join(point2);
    if (nodeSel)
      tr2.setSelection(NodeSelection.create(tr2.doc, point2 - state.doc.resolve(point2).nodeBefore.nodeSize));
    dispatch(tr2.scrollIntoView());
  }
  return true;
};
const joinDown$1 = (state, dispatch) => {
  let sel = state.selection, point2;
  if (sel instanceof NodeSelection) {
    if (sel.node.isTextblock || !canJoin(state.doc, sel.to))
      return false;
    point2 = sel.to;
  } else {
    point2 = joinPoint(state.doc, sel.to, 1);
    if (point2 == null)
      return false;
  }
  if (dispatch)
    dispatch(state.tr.join(point2).scrollIntoView());
  return true;
};
const lift$1 = (state, dispatch) => {
  let { $from, $to } = state.selection;
  let range = $from.blockRange($to), target = range && liftTarget(range);
  if (target == null)
    return false;
  if (dispatch)
    dispatch(state.tr.lift(range, target).scrollIntoView());
  return true;
};
const newlineInCode$1 = (state, dispatch) => {
  let { $head, $anchor } = state.selection;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor))
    return false;
  if (dispatch)
    dispatch(state.tr.insertText("\n").scrollIntoView());
  return true;
};
function defaultBlockAt$1(match5) {
  for (let i = 0; i < match5.edgeCount; i++) {
    let { type } = match5.edge(i);
    if (type.isTextblock && !type.hasRequiredAttrs())
      return type;
  }
  return null;
}
const exitCode$1 = (state, dispatch) => {
  let { $head, $anchor } = state.selection;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor))
    return false;
  let above = $head.node(-1), after = $head.indexAfter(-1), type = defaultBlockAt$1(above.contentMatchAt(after));
  if (!type || !above.canReplaceWith(after, after, type))
    return false;
  if (dispatch) {
    let pos = $head.after(), tr2 = state.tr.replaceWith(pos, pos, type.createAndFill());
    tr2.setSelection(Selection.near(tr2.doc.resolve(pos), 1));
    dispatch(tr2.scrollIntoView());
  }
  return true;
};
const createParagraphNear$1 = (state, dispatch) => {
  let sel = state.selection, { $from, $to } = sel;
  if (sel instanceof AllSelection || $from.parent.inlineContent || $to.parent.inlineContent)
    return false;
  let type = defaultBlockAt$1($to.parent.contentMatchAt($to.indexAfter()));
  if (!type || !type.isTextblock)
    return false;
  if (dispatch) {
    let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
    let tr2 = state.tr.insert(side, type.createAndFill());
    tr2.setSelection(TextSelection.create(tr2.doc, side + 1));
    dispatch(tr2.scrollIntoView());
  }
  return true;
};
const liftEmptyBlock$1 = (state, dispatch) => {
  let { $cursor } = state.selection;
  if (!$cursor || $cursor.parent.content.size)
    return false;
  if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
    let before = $cursor.before();
    if (canSplit(state.doc, before)) {
      if (dispatch)
        dispatch(state.tr.split(before).scrollIntoView());
      return true;
    }
  }
  let range = $cursor.blockRange(), target = range && liftTarget(range);
  if (target == null)
    return false;
  if (dispatch)
    dispatch(state.tr.lift(range, target).scrollIntoView());
  return true;
};
function splitBlockAs(splitNode) {
  return (state, dispatch) => {
    let { $from, $to } = state.selection;
    if (state.selection instanceof NodeSelection && state.selection.node.isBlock) {
      if (!$from.parentOffset || !canSplit(state.doc, $from.pos))
        return false;
      if (dispatch)
        dispatch(state.tr.split($from.pos).scrollIntoView());
      return true;
    }
    if (!$from.depth)
      return false;
    let types2 = [];
    let splitDepth, deflt, atEnd = false, atStart = false;
    for (let d2 = $from.depth; ; d2--) {
      let node2 = $from.node(d2);
      if (node2.isBlock) {
        atEnd = $from.end(d2) == $from.pos + ($from.depth - d2);
        atStart = $from.start(d2) == $from.pos - ($from.depth - d2);
        deflt = defaultBlockAt$1($from.node(d2 - 1).contentMatchAt($from.indexAfter(d2 - 1)));
        types2.unshift(atEnd && deflt ? { type: deflt } : null);
        splitDepth = d2;
        break;
      } else {
        if (d2 == 1)
          return false;
        types2.unshift(null);
      }
    }
    let tr2 = state.tr;
    if (state.selection instanceof TextSelection || state.selection instanceof AllSelection)
      tr2.deleteSelection();
    let splitPos = tr2.mapping.map($from.pos);
    let can = canSplit(tr2.doc, splitPos, types2.length, types2);
    if (!can) {
      types2[0] = deflt ? { type: deflt } : null;
      can = canSplit(tr2.doc, splitPos, types2.length, types2);
    }
    if (!can)
      return false;
    tr2.split(splitPos, types2.length, types2);
    if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
      let first2 = tr2.mapping.map($from.before(splitDepth)), $first = tr2.doc.resolve(first2);
      if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt))
        tr2.setNodeMarkup(tr2.mapping.map($from.before(splitDepth)), deflt);
    }
    if (dispatch)
      dispatch(tr2.scrollIntoView());
    return true;
  };
}
const splitBlock$1 = splitBlockAs();
const selectParentNode$1 = (state, dispatch) => {
  let { $from, to: to2 } = state.selection, pos;
  let same = $from.sharedDepth(to2);
  if (same == 0)
    return false;
  pos = $from.before(same);
  if (dispatch)
    dispatch(state.tr.setSelection(NodeSelection.create(state.doc, pos)));
  return true;
};
function joinMaybeClear(state, $pos, dispatch) {
  let before = $pos.nodeBefore, after = $pos.nodeAfter, index2 = $pos.index();
  if (!before || !after || !before.type.compatibleContent(after.type))
    return false;
  if (!before.content.size && $pos.parent.canReplace(index2 - 1, index2)) {
    if (dispatch)
      dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
    return true;
  }
  if (!$pos.parent.canReplace(index2, index2 + 1) || !(after.isTextblock || canJoin(state.doc, $pos.pos)))
    return false;
  if (dispatch)
    dispatch(state.tr.join($pos.pos).scrollIntoView());
  return true;
}
function deleteBarrier(state, $cut, dispatch, dir) {
  let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match5;
  let isolated = before.type.spec.isolating || after.type.spec.isolating;
  if (!isolated && joinMaybeClear(state, $cut, dispatch))
    return true;
  let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
  if (canDelAfter && (conn = (match5 = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match5.matchType(conn[0] || after.type).validEnd) {
    if (dispatch) {
      let end2 = $cut.pos + after.nodeSize, wrap2 = Fragment.empty;
      for (let i = conn.length - 1; i >= 0; i--)
        wrap2 = Fragment.from(conn[i].create(null, wrap2));
      wrap2 = Fragment.from(before.copy(wrap2));
      let tr2 = state.tr.step(new ReplaceAroundStep($cut.pos - 1, end2, $cut.pos, end2, new Slice(wrap2, 1, 0), conn.length, true));
      let $joinAt = tr2.doc.resolve(end2 + 2 * conn.length);
      if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && canJoin(tr2.doc, $joinAt.pos))
        tr2.join($joinAt.pos);
      dispatch(tr2.scrollIntoView());
    }
    return true;
  }
  let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : Selection.findFrom($cut, 1);
  let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && liftTarget(range);
  if (target != null && target >= $cut.depth) {
    if (dispatch)
      dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
  }
  if (canDelAfter && textblockAt(after, "start", true) && textblockAt(before, "end")) {
    let at = before, wrap2 = [];
    for (; ; ) {
      wrap2.push(at);
      if (at.isTextblock)
        break;
      at = at.lastChild;
    }
    let afterText = after, afterDepth = 1;
    for (; !afterText.isTextblock; afterText = afterText.firstChild)
      afterDepth++;
    if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
      if (dispatch) {
        let end2 = Fragment.empty;
        for (let i = wrap2.length - 1; i >= 0; i--)
          end2 = Fragment.from(wrap2[i].copy(end2));
        let tr2 = state.tr.step(new ReplaceAroundStep($cut.pos - wrap2.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new Slice(end2, wrap2.length, 0), 0, true));
        dispatch(tr2.scrollIntoView());
      }
      return true;
    }
  }
  return false;
}
function selectTextblockSide(side) {
  return function(state, dispatch) {
    let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
    let depth = $pos.depth;
    while ($pos.node(depth).isInline) {
      if (!depth)
        return false;
      depth--;
    }
    if (!$pos.node(depth).isTextblock)
      return false;
    if (dispatch)
      dispatch(state.tr.setSelection(TextSelection.create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
    return true;
  };
}
const selectTextblockStart$1 = selectTextblockSide(-1);
const selectTextblockEnd$1 = selectTextblockSide(1);
function wrapIn$1(nodeType, attrs = null) {
  return function(state, dispatch) {
    let { $from, $to } = state.selection;
    let range = $from.blockRange($to), wrapping = range && findWrapping(range, nodeType, attrs);
    if (!wrapping)
      return false;
    if (dispatch)
      dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
    return true;
  };
}
function setBlockType(nodeType, attrs = null) {
  return function(state, dispatch) {
    let applicable = false;
    for (let i = 0; i < state.selection.ranges.length && !applicable; i++) {
      let { $from: { pos: from3 }, $to: { pos: to2 } } = state.selection.ranges[i];
      state.doc.nodesBetween(from3, to2, (node2, pos) => {
        if (applicable)
          return false;
        if (!node2.isTextblock || node2.hasMarkup(nodeType, attrs))
          return;
        if (node2.type == nodeType) {
          applicable = true;
        } else {
          let $pos = state.doc.resolve(pos), index2 = $pos.index();
          applicable = $pos.parent.canReplaceWith(index2, index2 + 1, nodeType);
        }
      });
    }
    if (!applicable)
      return false;
    if (dispatch) {
      let tr2 = state.tr;
      for (let i = 0; i < state.selection.ranges.length; i++) {
        let { $from: { pos: from3 }, $to: { pos: to2 } } = state.selection.ranges[i];
        tr2.setBlockType(from3, to2, nodeType, attrs);
      }
      dispatch(tr2.scrollIntoView());
    }
    return true;
  };
}
function chainCommands(...commands2) {
  return function(state, dispatch, view) {
    for (let i = 0; i < commands2.length; i++)
      if (commands2[i](state, dispatch, view))
        return true;
    return false;
  };
}
chainCommands(deleteSelection$1, joinBackward$1, selectNodeBackward$1);
chainCommands(deleteSelection$1, joinForward$1, selectNodeForward$1);
({
  "Enter": chainCommands(newlineInCode$1, createParagraphNear$1, liftEmptyBlock$1, splitBlock$1)
});
typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
function wrapInList$1(listType, attrs = null) {
  return function(state, dispatch) {
    let { $from, $to } = state.selection;
    let range = $from.blockRange($to);
    if (!range)
      return false;
    let tr2 = dispatch ? state.tr : null;
    if (!wrapRangeInList(tr2, range, listType, attrs))
      return false;
    if (dispatch)
      dispatch(tr2.scrollIntoView());
    return true;
  };
}
function wrapRangeInList(tr2, range, listType, attrs = null) {
  let doJoin = false, outerRange = range, doc2 = range.$from.doc;
  if (range.depth >= 2 && range.$from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex == 0) {
    if (range.$from.index(range.depth - 1) == 0)
      return false;
    let $insert = doc2.resolve(range.start - 2);
    outerRange = new NodeRange($insert, $insert, range.depth);
    if (range.endIndex < range.parent.childCount)
      range = new NodeRange(range.$from, doc2.resolve(range.$to.end(range.depth)), range.depth);
    doJoin = true;
  }
  let wrap2 = findWrapping(outerRange, listType, attrs, range);
  if (!wrap2)
    return false;
  if (tr2)
    doWrapInList(tr2, range, wrap2, doJoin, listType);
  return true;
}
function doWrapInList(tr2, range, wrappers, joinBefore, listType) {
  let content2 = Fragment.empty;
  for (let i = wrappers.length - 1; i >= 0; i--)
    content2 = Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content2));
  tr2.step(new ReplaceAroundStep(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new Slice(content2, 0, 0), wrappers.length, true));
  let found2 = 0;
  for (let i = 0; i < wrappers.length; i++)
    if (wrappers[i].type == listType)
      found2 = i + 1;
  let splitDepth = wrappers.length - found2;
  let splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0), parent2 = range.parent;
  for (let i = range.startIndex, e = range.endIndex, first2 = true; i < e; i++, first2 = false) {
    if (!first2 && canSplit(tr2.doc, splitPos, splitDepth)) {
      tr2.split(splitPos, splitDepth);
      splitPos += 2 * splitDepth;
    }
    splitPos += parent2.child(i).nodeSize;
  }
  return tr2;
}
function liftListItem$1(itemType) {
  return function(state, dispatch) {
    let { $from, $to } = state.selection;
    let range = $from.blockRange($to, (node2) => node2.childCount > 0 && node2.firstChild.type == itemType);
    if (!range)
      return false;
    if (!dispatch)
      return true;
    if ($from.node(range.depth - 1).type == itemType)
      return liftToOuterList(state, dispatch, itemType, range);
    else
      return liftOutOfList(state, dispatch, range);
  };
}
function liftToOuterList(state, dispatch, itemType, range) {
  let tr2 = state.tr, end2 = range.end, endOfList = range.$to.end(range.depth);
  if (end2 < endOfList) {
    tr2.step(new ReplaceAroundStep(end2 - 1, endOfList, end2, endOfList, new Slice(Fragment.from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
    range = new NodeRange(tr2.doc.resolve(range.$from.pos), tr2.doc.resolve(endOfList), range.depth);
  }
  const target = liftTarget(range);
  if (target == null)
    return false;
  tr2.lift(range, target);
  let $after = tr2.doc.resolve(tr2.mapping.map(end2, -1) - 1);
  if (canJoin(tr2.doc, $after.pos) && $after.nodeBefore.type == $after.nodeAfter.type)
    tr2.join($after.pos);
  dispatch(tr2.scrollIntoView());
  return true;
}
function liftOutOfList(state, dispatch, range) {
  let tr2 = state.tr, list2 = range.parent;
  for (let pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--) {
    pos -= list2.child(i).nodeSize;
    tr2.delete(pos - 1, pos + 1);
  }
  let $start = tr2.doc.resolve(range.start), item = $start.nodeAfter;
  if (tr2.mapping.map(range.end) != range.start + $start.nodeAfter.nodeSize)
    return false;
  let atStart = range.startIndex == 0, atEnd = range.endIndex == list2.childCount;
  let parent2 = $start.node(-1), indexBefore = $start.index(-1);
  if (!parent2.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? Fragment.empty : Fragment.from(list2))))
    return false;
  let start4 = $start.pos, end2 = start4 + item.nodeSize;
  tr2.step(new ReplaceAroundStep(start4 - (atStart ? 1 : 0), end2 + (atEnd ? 1 : 0), start4 + 1, end2 - 1, new Slice((atStart ? Fragment.empty : Fragment.from(list2.copy(Fragment.empty))).append(atEnd ? Fragment.empty : Fragment.from(list2.copy(Fragment.empty))), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
  dispatch(tr2.scrollIntoView());
  return true;
}
function sinkListItem$1(itemType) {
  return function(state, dispatch) {
    let { $from, $to } = state.selection;
    let range = $from.blockRange($to, (node2) => node2.childCount > 0 && node2.firstChild.type == itemType);
    if (!range)
      return false;
    let startIndex = range.startIndex;
    if (startIndex == 0)
      return false;
    let parent2 = range.parent, nodeBefore = parent2.child(startIndex - 1);
    if (nodeBefore.type != itemType)
      return false;
    if (dispatch) {
      let nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type == parent2.type;
      let inner = Fragment.from(nestedBefore ? itemType.create() : null);
      let slice3 = new Slice(Fragment.from(itemType.create(null, Fragment.from(parent2.type.create(null, inner)))), nestedBefore ? 3 : 1, 0);
      let before = range.start, after = range.end;
      dispatch(state.tr.step(new ReplaceAroundStep(before - (nestedBefore ? 3 : 1), after, before, after, slice3, 1, true)).scrollIntoView());
    }
    return true;
  };
}
function createChainableState(config2) {
  const { state, transaction } = config2;
  let { selection } = transaction;
  let { doc: doc2 } = transaction;
  let { storedMarks } = transaction;
  return {
    ...state,
    apply: state.apply.bind(state),
    applyTransaction: state.applyTransaction.bind(state),
    plugins: state.plugins,
    schema: state.schema,
    reconfigure: state.reconfigure.bind(state),
    toJSON: state.toJSON.bind(state),
    get storedMarks() {
      return storedMarks;
    },
    get selection() {
      return selection;
    },
    get doc() {
      return doc2;
    },
    get tr() {
      selection = transaction.selection;
      doc2 = transaction.doc;
      storedMarks = transaction.storedMarks;
      return transaction;
    }
  };
}
class CommandManager {
  constructor(props) {
    this.editor = props.editor;
    this.rawCommands = this.editor.extensionManager.commands;
    this.customState = props.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands, editor, state } = this;
    const { view } = editor;
    const { tr: tr2 } = state;
    const props = this.buildProps(tr2);
    return Object.fromEntries(Object.entries(rawCommands).map(([name2, command2]) => {
      const method = (...args) => {
        const callback = command2(...args)(props);
        if (!tr2.getMeta("preventDispatch") && !this.hasCustomState) {
          view.dispatch(tr2);
        }
        return callback;
      };
      return [name2, method];
    }));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(startTr, shouldDispatch = true) {
    const { rawCommands, editor, state } = this;
    const { view } = editor;
    const callbacks = [];
    const hasStartTransaction = !!startTr;
    const tr2 = startTr || state.tr;
    const run2 = () => {
      if (!hasStartTransaction && shouldDispatch && !tr2.getMeta("preventDispatch") && !this.hasCustomState) {
        view.dispatch(tr2);
      }
      return callbacks.every((callback) => callback === true);
    };
    const chain = {
      ...Object.fromEntries(Object.entries(rawCommands).map(([name2, command2]) => {
        const chainedCommand = (...args) => {
          const props = this.buildProps(tr2, shouldDispatch);
          const callback = command2(...args)(props);
          callbacks.push(callback);
          return chain;
        };
        return [name2, chainedCommand];
      })),
      run: run2
    };
    return chain;
  }
  createCan(startTr) {
    const { rawCommands, state } = this;
    const dispatch = false;
    const tr2 = startTr || state.tr;
    const props = this.buildProps(tr2, dispatch);
    const formattedCommands = Object.fromEntries(Object.entries(rawCommands).map(([name2, command2]) => {
      return [name2, (...args) => command2(...args)({ ...props, dispatch: void 0 })];
    }));
    return {
      ...formattedCommands,
      chain: () => this.createChain(tr2, dispatch)
    };
  }
  buildProps(tr2, shouldDispatch = true) {
    const { rawCommands, editor, state } = this;
    const { view } = editor;
    const props = {
      tr: tr2,
      editor,
      view,
      state: createChainableState({
        state,
        transaction: tr2
      }),
      dispatch: shouldDispatch ? () => void 0 : void 0,
      chain: () => this.createChain(tr2, shouldDispatch),
      can: () => this.createCan(tr2),
      get commands() {
        return Object.fromEntries(Object.entries(rawCommands).map(([name2, command2]) => {
          return [name2, (...args) => command2(...args)(props)];
        }));
      }
    };
    return props;
  }
}
class EventEmitter2 {
  constructor() {
    this.callbacks = {};
  }
  on(event, fn2) {
    if (!this.callbacks[event]) {
      this.callbacks[event] = [];
    }
    this.callbacks[event].push(fn2);
    return this;
  }
  emit(event, ...args) {
    const callbacks = this.callbacks[event];
    if (callbacks) {
      callbacks.forEach((callback) => callback.apply(this, args));
    }
    return this;
  }
  off(event, fn2) {
    const callbacks = this.callbacks[event];
    if (callbacks) {
      if (fn2) {
        this.callbacks[event] = callbacks.filter((callback) => callback !== fn2);
      } else {
        delete this.callbacks[event];
      }
    }
    return this;
  }
  once(event, fn2) {
    const onceFn = (...args) => {
      this.off(event, onceFn);
      fn2.apply(this, args);
    };
    return this.on(event, onceFn);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function getExtensionField(extension2, field, context) {
  if (extension2.config[field] === void 0 && extension2.parent) {
    return getExtensionField(extension2.parent, field, context);
  }
  if (typeof extension2.config[field] === "function") {
    const value = extension2.config[field].bind({
      ...context,
      parent: extension2.parent ? getExtensionField(extension2.parent, field, context) : null
    });
    return value;
  }
  return extension2.config[field];
}
function splitExtensions(extensions) {
  const baseExtensions = extensions.filter((extension2) => extension2.type === "extension");
  const nodeExtensions = extensions.filter((extension2) => extension2.type === "node");
  const markExtensions = extensions.filter((extension2) => extension2.type === "mark");
  return {
    baseExtensions,
    nodeExtensions,
    markExtensions
  };
}
function getAttributesFromExtensions(extensions) {
  const extensionAttributes = [];
  const { nodeExtensions, markExtensions } = splitExtensions(extensions);
  const nodeAndMarkExtensions = [...nodeExtensions, ...markExtensions];
  const defaultAttribute = {
    default: null,
    rendered: true,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: true,
    isRequired: false
  };
  extensions.forEach((extension2) => {
    const context = {
      name: extension2.name,
      options: extension2.options,
      storage: extension2.storage,
      extensions: nodeAndMarkExtensions
    };
    const addGlobalAttributes = getExtensionField(extension2, "addGlobalAttributes", context);
    if (!addGlobalAttributes) {
      return;
    }
    const globalAttributes = addGlobalAttributes();
    globalAttributes.forEach((globalAttribute) => {
      globalAttribute.types.forEach((type) => {
        Object.entries(globalAttribute.attributes).forEach(([name2, attribute]) => {
          extensionAttributes.push({
            type,
            name: name2,
            attribute: {
              ...defaultAttribute,
              ...attribute
            }
          });
        });
      });
    });
  });
  nodeAndMarkExtensions.forEach((extension2) => {
    const context = {
      name: extension2.name,
      options: extension2.options,
      storage: extension2.storage
    };
    const addAttributes = getExtensionField(extension2, "addAttributes", context);
    if (!addAttributes) {
      return;
    }
    const attributes = addAttributes();
    Object.entries(attributes).forEach(([name2, attribute]) => {
      const mergedAttr = {
        ...defaultAttribute,
        ...attribute
      };
      if (typeof (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === "function") {
        mergedAttr.default = mergedAttr.default();
      }
      if ((mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.isRequired) && (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === void 0) {
        delete mergedAttr.default;
      }
      extensionAttributes.push({
        type: extension2.name,
        name: name2,
        attribute: mergedAttr
      });
    });
  });
  return extensionAttributes;
}
function getNodeType(nameOrType, schema) {
  if (typeof nameOrType === "string") {
    if (!schema.nodes[nameOrType]) {
      throw Error(`There is no node type named '${nameOrType}'. Maybe you forgot to add the extension?`);
    }
    return schema.nodes[nameOrType];
  }
  return nameOrType;
}
function mergeAttributes(...objects) {
  return objects.filter((item) => !!item).reduce((items, item) => {
    const mergedAttributes = { ...items };
    Object.entries(item).forEach(([key2, value]) => {
      const exists = mergedAttributes[key2];
      if (!exists) {
        mergedAttributes[key2] = value;
        return;
      }
      if (key2 === "class") {
        const valueClasses = value ? String(value).split(" ") : [];
        const existingClasses = mergedAttributes[key2] ? mergedAttributes[key2].split(" ") : [];
        const insertClasses = valueClasses.filter((valueClass) => !existingClasses.includes(valueClass));
        mergedAttributes[key2] = [...existingClasses, ...insertClasses].join(" ");
      } else if (key2 === "style") {
        const newStyles = value ? value.split(";").map((style3) => style3.trim()).filter(Boolean) : [];
        const existingStyles = mergedAttributes[key2] ? mergedAttributes[key2].split(";").map((style3) => style3.trim()).filter(Boolean) : [];
        const styleMap = /* @__PURE__ */ new Map();
        existingStyles.forEach((style3) => {
          const [property, val] = style3.split(":").map((part) => part.trim());
          styleMap.set(property, val);
        });
        newStyles.forEach((style3) => {
          const [property, val] = style3.split(":").map((part) => part.trim());
          styleMap.set(property, val);
        });
        mergedAttributes[key2] = Array.from(styleMap.entries()).map(([property, val]) => `${property}: ${val}`).join("; ");
      } else {
        mergedAttributes[key2] = value;
      }
    });
    return mergedAttributes;
  }, {});
}
function getRenderedAttributes(nodeOrMark, extensionAttributes) {
  return extensionAttributes.filter((attribute) => attribute.type === nodeOrMark.type.name).filter((item) => item.attribute.rendered).map((item) => {
    if (!item.attribute.renderHTML) {
      return {
        [item.name]: nodeOrMark.attrs[item.name]
      };
    }
    return item.attribute.renderHTML(nodeOrMark.attrs) || {};
  }).reduce((attributes, attribute) => mergeAttributes(attributes, attribute), {});
}
function isFunction(value) {
  return typeof value === "function";
}
function callOrReturn(value, context = void 0, ...props) {
  if (isFunction(value)) {
    if (context) {
      return value.bind(context)(...props);
    }
    return value(...props);
  }
  return value;
}
function isEmptyObject(value = {}) {
  return Object.keys(value).length === 0 && value.constructor === Object;
}
function fromString(value) {
  if (typeof value !== "string") {
    return value;
  }
  if (value.match(/^[+-]?(?:\d*\.)?\d+$/)) {
    return Number(value);
  }
  if (value === "true") {
    return true;
  }
  if (value === "false") {
    return false;
  }
  return value;
}
function injectExtensionAttributesToParseRule(parseRule, extensionAttributes) {
  if ("style" in parseRule) {
    return parseRule;
  }
  return {
    ...parseRule,
    getAttrs: (node2) => {
      const oldAttributes = parseRule.getAttrs ? parseRule.getAttrs(node2) : parseRule.attrs;
      if (oldAttributes === false) {
        return false;
      }
      const newAttributes = extensionAttributes.reduce((items, item) => {
        const value = item.attribute.parseHTML ? item.attribute.parseHTML(node2) : fromString(node2.getAttribute(item.name));
        if (value === null || value === void 0) {
          return items;
        }
        return {
          ...items,
          [item.name]: value
        };
      }, {});
      return { ...oldAttributes, ...newAttributes };
    }
  };
}
function cleanUpSchemaItem(data) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(data).filter(([key2, value]) => {
      if (key2 === "attrs" && isEmptyObject(value)) {
        return false;
      }
      return value !== null && value !== void 0;
    })
  );
}
function getSchemaByResolvedExtensions(extensions, editor) {
  var _a3;
  const allAttributes = getAttributesFromExtensions(extensions);
  const { nodeExtensions, markExtensions } = splitExtensions(extensions);
  const topNode = (_a3 = nodeExtensions.find((extension2) => getExtensionField(extension2, "topNode"))) === null || _a3 === void 0 ? void 0 : _a3.name;
  const nodes = Object.fromEntries(nodeExtensions.map((extension2) => {
    const extensionAttributes = allAttributes.filter((attribute) => attribute.type === extension2.name);
    const context = {
      name: extension2.name,
      options: extension2.options,
      storage: extension2.storage,
      editor
    };
    const extraNodeFields = extensions.reduce((fields, e) => {
      const extendNodeSchema = getExtensionField(e, "extendNodeSchema", context);
      return {
        ...fields,
        ...extendNodeSchema ? extendNodeSchema(extension2) : {}
      };
    }, {});
    const schema = cleanUpSchemaItem({
      ...extraNodeFields,
      content: callOrReturn(getExtensionField(extension2, "content", context)),
      marks: callOrReturn(getExtensionField(extension2, "marks", context)),
      group: callOrReturn(getExtensionField(extension2, "group", context)),
      inline: callOrReturn(getExtensionField(extension2, "inline", context)),
      atom: callOrReturn(getExtensionField(extension2, "atom", context)),
      selectable: callOrReturn(getExtensionField(extension2, "selectable", context)),
      draggable: callOrReturn(getExtensionField(extension2, "draggable", context)),
      code: callOrReturn(getExtensionField(extension2, "code", context)),
      whitespace: callOrReturn(getExtensionField(extension2, "whitespace", context)),
      linebreakReplacement: callOrReturn(getExtensionField(extension2, "linebreakReplacement", context)),
      defining: callOrReturn(getExtensionField(extension2, "defining", context)),
      isolating: callOrReturn(getExtensionField(extension2, "isolating", context)),
      attrs: Object.fromEntries(extensionAttributes.map((extensionAttribute) => {
        var _a4;
        return [extensionAttribute.name, { default: (_a4 = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a4 === void 0 ? void 0 : _a4.default }];
      }))
    });
    const parseHTML = callOrReturn(getExtensionField(extension2, "parseHTML", context));
    if (parseHTML) {
      schema.parseDOM = parseHTML.map((parseRule) => injectExtensionAttributesToParseRule(parseRule, extensionAttributes));
    }
    const renderHTML = getExtensionField(extension2, "renderHTML", context);
    if (renderHTML) {
      schema.toDOM = (node2) => renderHTML({
        node: node2,
        HTMLAttributes: getRenderedAttributes(node2, extensionAttributes)
      });
    }
    const renderText = getExtensionField(extension2, "renderText", context);
    if (renderText) {
      schema.toText = renderText;
    }
    return [extension2.name, schema];
  }));
  const marks = Object.fromEntries(markExtensions.map((extension2) => {
    const extensionAttributes = allAttributes.filter((attribute) => attribute.type === extension2.name);
    const context = {
      name: extension2.name,
      options: extension2.options,
      storage: extension2.storage,
      editor
    };
    const extraMarkFields = extensions.reduce((fields, e) => {
      const extendMarkSchema = getExtensionField(e, "extendMarkSchema", context);
      return {
        ...fields,
        ...extendMarkSchema ? extendMarkSchema(extension2) : {}
      };
    }, {});
    const schema = cleanUpSchemaItem({
      ...extraMarkFields,
      inclusive: callOrReturn(getExtensionField(extension2, "inclusive", context)),
      excludes: callOrReturn(getExtensionField(extension2, "excludes", context)),
      group: callOrReturn(getExtensionField(extension2, "group", context)),
      spanning: callOrReturn(getExtensionField(extension2, "spanning", context)),
      code: callOrReturn(getExtensionField(extension2, "code", context)),
      attrs: Object.fromEntries(extensionAttributes.map((extensionAttribute) => {
        var _a4;
        return [extensionAttribute.name, { default: (_a4 = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a4 === void 0 ? void 0 : _a4.default }];
      }))
    });
    const parseHTML = callOrReturn(getExtensionField(extension2, "parseHTML", context));
    if (parseHTML) {
      schema.parseDOM = parseHTML.map((parseRule) => injectExtensionAttributesToParseRule(parseRule, extensionAttributes));
    }
    const renderHTML = getExtensionField(extension2, "renderHTML", context);
    if (renderHTML) {
      schema.toDOM = (mark2) => renderHTML({
        mark: mark2,
        HTMLAttributes: getRenderedAttributes(mark2, extensionAttributes)
      });
    }
    return [extension2.name, schema];
  }));
  return new Schema2({
    topNode,
    nodes,
    marks
  });
}
function getSchemaTypeByName(name2, schema) {
  return schema.nodes[name2] || schema.marks[name2] || null;
}
function isExtensionRulesEnabled(extension2, enabled) {
  if (Array.isArray(enabled)) {
    return enabled.some((enabledExtension) => {
      const name2 = typeof enabledExtension === "string" ? enabledExtension : enabledExtension.name;
      return name2 === extension2.name;
    });
  }
  return enabled;
}
function getHTMLFromFragment(fragment, schema) {
  const documentFragment = DOMSerializer.fromSchema(schema).serializeFragment(fragment);
  const temporaryDocument = document.implementation.createHTMLDocument();
  const container = temporaryDocument.createElement("div");
  container.appendChild(documentFragment);
  return container.innerHTML;
}
const getTextContentFromNodes = ($from, maxMatch = 500) => {
  let textBefore = "";
  const sliceEndPos = $from.parentOffset;
  $from.parent.nodesBetween(Math.max(0, sliceEndPos - maxMatch), sliceEndPos, (node2, pos, parent2, index2) => {
    var _a3, _b;
    const chunk = ((_b = (_a3 = node2.type.spec).toText) === null || _b === void 0 ? void 0 : _b.call(_a3, {
      node: node2,
      pos,
      parent: parent2,
      index: index2
    })) || node2.textContent || "%leaf%";
    textBefore += node2.isAtom && !node2.isText ? chunk : chunk.slice(0, Math.max(0, sliceEndPos - pos));
  });
  return textBefore;
};
function isRegExp(value) {
  return Object.prototype.toString.call(value) === "[object RegExp]";
}
class InputRule {
  constructor(config2) {
    this.find = config2.find;
    this.handler = config2.handler;
  }
}
const inputRuleMatcherHandler = (text2, find2) => {
  if (isRegExp(find2)) {
    return find2.exec(text2);
  }
  const inputRuleMatch = find2(text2);
  if (!inputRuleMatch) {
    return null;
  }
  const result = [inputRuleMatch.text];
  result.index = inputRuleMatch.index;
  result.input = text2;
  result.data = inputRuleMatch.data;
  if (inputRuleMatch.replaceWith) {
    if (!inputRuleMatch.text.includes(inputRuleMatch.replaceWith)) {
      console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".');
    }
    result.push(inputRuleMatch.replaceWith);
  }
  return result;
};
function run$1$1(config2) {
  var _a3;
  const { editor, from: from3, to: to2, text: text2, rules, plugin: plugin2 } = config2;
  const { view } = editor;
  if (view.composing) {
    return false;
  }
  const $from = view.state.doc.resolve(from3);
  if (
    // check for code node
    $from.parent.type.spec.code || !!((_a3 = $from.nodeBefore || $from.nodeAfter) === null || _a3 === void 0 ? void 0 : _a3.marks.find((mark2) => mark2.type.spec.code))
  ) {
    return false;
  }
  let matched = false;
  const textBefore = getTextContentFromNodes($from) + text2;
  rules.forEach((rule) => {
    if (matched) {
      return;
    }
    const match5 = inputRuleMatcherHandler(textBefore, rule.find);
    if (!match5) {
      return;
    }
    const tr2 = view.state.tr;
    const state = createChainableState({
      state: view.state,
      transaction: tr2
    });
    const range = {
      from: from3 - (match5[0].length - text2.length),
      to: to2
    };
    const { commands: commands2, chain, can } = new CommandManager({
      editor,
      state
    });
    const handler = rule.handler({
      state,
      range,
      match: match5,
      commands: commands2,
      chain,
      can
    });
    if (handler === null || !tr2.steps.length) {
      return;
    }
    tr2.setMeta(plugin2, {
      transform: tr2,
      from: from3,
      to: to2,
      text: text2
    });
    view.dispatch(tr2);
    matched = true;
  });
  return matched;
}
function inputRulesPlugin(props) {
  const { editor, rules } = props;
  const plugin2 = new Plugin({
    state: {
      init() {
        return null;
      },
      apply(tr2, prev2, state) {
        const stored = tr2.getMeta(plugin2);
        if (stored) {
          return stored;
        }
        const simulatedInputMeta = tr2.getMeta("applyInputRules");
        const isSimulatedInput = !!simulatedInputMeta;
        if (isSimulatedInput) {
          setTimeout(() => {
            let { text: text2 } = simulatedInputMeta;
            if (typeof text2 === "string") {
              text2 = text2;
            } else {
              text2 = getHTMLFromFragment(Fragment.from(text2), state.schema);
            }
            const { from: from3 } = simulatedInputMeta;
            const to2 = from3 + text2.length;
            run$1$1({
              editor,
              from: from3,
              to: to2,
              text: text2,
              rules,
              plugin: plugin2
            });
          });
        }
        return tr2.selectionSet || tr2.docChanged ? null : prev2;
      }
    },
    props: {
      handleTextInput(view, from3, to2, text2) {
        return run$1$1({
          editor,
          from: from3,
          to: to2,
          text: text2,
          rules,
          plugin: plugin2
        });
      },
      handleDOMEvents: {
        compositionend: (view) => {
          setTimeout(() => {
            const { $cursor } = view.state.selection;
            if ($cursor) {
              run$1$1({
                editor,
                from: $cursor.pos,
                to: $cursor.pos,
                text: "",
                rules,
                plugin: plugin2
              });
            }
          });
          return false;
        }
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(view, event) {
        if (event.key !== "Enter") {
          return false;
        }
        const { $cursor } = view.state.selection;
        if ($cursor) {
          return run$1$1({
            editor,
            from: $cursor.pos,
            to: $cursor.pos,
            text: "\n",
            rules,
            plugin: plugin2
          });
        }
        return false;
      }
    },
    // @ts-ignore
    isInputRules: true
  });
  return plugin2;
}
function getType(value) {
  return Object.prototype.toString.call(value).slice(8, -1);
}
function isPlainObject(value) {
  if (getType(value) !== "Object") {
    return false;
  }
  return value.constructor === Object && Object.getPrototypeOf(value) === Object.prototype;
}
function mergeDeep(target, source) {
  const output = { ...target };
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach((key2) => {
      if (isPlainObject(source[key2]) && isPlainObject(target[key2])) {
        output[key2] = mergeDeep(target[key2], source[key2]);
      } else {
        output[key2] = source[key2];
      }
    });
  }
  return output;
}
class Mark2 {
  constructor(config2 = {}) {
    this.type = "mark";
    this.name = "mark";
    this.parent = null;
    this.child = null;
    this.config = {
      name: this.name,
      defaultOptions: {}
    };
    this.config = {
      ...this.config,
      ...config2
    };
    this.name = this.config.name;
    if (config2.defaultOptions && Object.keys(config2.defaultOptions).length > 0) {
      console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
    }
    this.options = this.config.defaultOptions;
    if (this.config.addOptions) {
      this.options = callOrReturn(getExtensionField(this, "addOptions", {
        name: this.name
      }));
    }
    this.storage = callOrReturn(getExtensionField(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(config2 = {}) {
    return new Mark2(config2);
  }
  configure(options = {}) {
    const extension2 = this.extend({
      ...this.config,
      addOptions: () => {
        return mergeDeep(this.options, options);
      }
    });
    extension2.name = this.name;
    extension2.parent = this.parent;
    return extension2;
  }
  extend(extendedConfig = {}) {
    const extension2 = new Mark2(extendedConfig);
    extension2.parent = this;
    this.child = extension2;
    extension2.name = extendedConfig.name ? extendedConfig.name : extension2.parent.name;
    if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) {
      console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension2.name}".`);
    }
    extension2.options = callOrReturn(getExtensionField(extension2, "addOptions", {
      name: extension2.name
    }));
    extension2.storage = callOrReturn(getExtensionField(extension2, "addStorage", {
      name: extension2.name,
      options: extension2.options
    }));
    return extension2;
  }
  static handleExit({ editor, mark: mark2 }) {
    const { tr: tr2 } = editor.state;
    const currentPos = editor.state.selection.$from;
    const isAtEnd = currentPos.pos === currentPos.end();
    if (isAtEnd) {
      const currentMarks = currentPos.marks();
      const isInMark = !!currentMarks.find((m2) => (m2 === null || m2 === void 0 ? void 0 : m2.type.name) === mark2.name);
      if (!isInMark) {
        return false;
      }
      const removeMark2 = currentMarks.find((m2) => (m2 === null || m2 === void 0 ? void 0 : m2.type.name) === mark2.name);
      if (removeMark2) {
        tr2.removeStoredMark(removeMark2);
      }
      tr2.insertText(" ", currentPos.pos);
      editor.view.dispatch(tr2);
      return true;
    }
    return false;
  }
}
function isNumber3(value) {
  return typeof value === "number";
}
class PasteRule {
  constructor(config2) {
    this.find = config2.find;
    this.handler = config2.handler;
  }
}
const pasteRuleMatcherHandler = (text2, find2, event) => {
  if (isRegExp(find2)) {
    return [...text2.matchAll(find2)];
  }
  const matches2 = find2(text2, event);
  if (!matches2) {
    return [];
  }
  return matches2.map((pasteRuleMatch) => {
    const result = [pasteRuleMatch.text];
    result.index = pasteRuleMatch.index;
    result.input = text2;
    result.data = pasteRuleMatch.data;
    if (pasteRuleMatch.replaceWith) {
      if (!pasteRuleMatch.text.includes(pasteRuleMatch.replaceWith)) {
        console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".');
      }
      result.push(pasteRuleMatch.replaceWith);
    }
    return result;
  });
};
function run$2(config2) {
  const { editor, state, from: from3, to: to2, rule, pasteEvent, dropEvent } = config2;
  const { commands: commands2, chain, can } = new CommandManager({
    editor,
    state
  });
  const handlers2 = [];
  state.doc.nodesBetween(from3, to2, (node2, pos) => {
    if (!node2.isTextblock || node2.type.spec.code) {
      return;
    }
    const resolvedFrom = Math.max(from3, pos);
    const resolvedTo = Math.min(to2, pos + node2.content.size);
    const textToMatch = node2.textBetween(resolvedFrom - pos, resolvedTo - pos, void 0, "￼");
    const matches2 = pasteRuleMatcherHandler(textToMatch, rule.find, pasteEvent);
    matches2.forEach((match5) => {
      if (match5.index === void 0) {
        return;
      }
      const start4 = resolvedFrom + match5.index + 1;
      const end2 = start4 + match5[0].length;
      const range = {
        from: state.tr.mapping.map(start4),
        to: state.tr.mapping.map(end2)
      };
      const handler = rule.handler({
        state,
        range,
        match: match5,
        commands: commands2,
        chain,
        can,
        pasteEvent,
        dropEvent
      });
      handlers2.push(handler);
    });
  });
  const success = handlers2.every((handler) => handler !== null);
  return success;
}
let tiptapDragFromOtherEditor = null;
const createClipboardPasteEvent = (text2) => {
  var _a3;
  const event = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  (_a3 = event.clipboardData) === null || _a3 === void 0 ? void 0 : _a3.setData("text/html", text2);
  return event;
};
function pasteRulesPlugin(props) {
  const { editor, rules } = props;
  let dragSourceElement = null;
  let isPastedFromProseMirror = false;
  let isDroppedFromProseMirror = false;
  let pasteEvent = typeof ClipboardEvent !== "undefined" ? new ClipboardEvent("paste") : null;
  let dropEvent;
  try {
    dropEvent = typeof DragEvent !== "undefined" ? new DragEvent("drop") : null;
  } catch {
    dropEvent = null;
  }
  const processEvent = ({ state, from: from3, to: to2, rule, pasteEvt }) => {
    const tr2 = state.tr;
    const chainableState = createChainableState({
      state,
      transaction: tr2
    });
    const handler = run$2({
      editor,
      state: chainableState,
      from: Math.max(from3 - 1, 0),
      to: to2.b - 1,
      rule,
      pasteEvent: pasteEvt,
      dropEvent
    });
    if (!handler || !tr2.steps.length) {
      return;
    }
    try {
      dropEvent = typeof DragEvent !== "undefined" ? new DragEvent("drop") : null;
    } catch {
      dropEvent = null;
    }
    pasteEvent = typeof ClipboardEvent !== "undefined" ? new ClipboardEvent("paste") : null;
    return tr2;
  };
  const plugins = rules.map((rule) => {
    return new Plugin({
      // we register a global drag handler to track the current drag source element
      view(view) {
        const handleDragstart = (event) => {
          var _a3;
          dragSourceElement = ((_a3 = view.dom.parentElement) === null || _a3 === void 0 ? void 0 : _a3.contains(event.target)) ? view.dom.parentElement : null;
          if (dragSourceElement) {
            tiptapDragFromOtherEditor = editor;
          }
        };
        const handleDragend = () => {
          if (tiptapDragFromOtherEditor) {
            tiptapDragFromOtherEditor = null;
          }
        };
        window.addEventListener("dragstart", handleDragstart);
        window.addEventListener("dragend", handleDragend);
        return {
          destroy() {
            window.removeEventListener("dragstart", handleDragstart);
            window.removeEventListener("dragend", handleDragend);
          }
        };
      },
      props: {
        handleDOMEvents: {
          drop: (view, event) => {
            isDroppedFromProseMirror = dragSourceElement === view.dom.parentElement;
            dropEvent = event;
            if (!isDroppedFromProseMirror) {
              const dragFromOtherEditor = tiptapDragFromOtherEditor;
              if (dragFromOtherEditor === null || dragFromOtherEditor === void 0 ? void 0 : dragFromOtherEditor.isEditable) {
                setTimeout(() => {
                  const selection = dragFromOtherEditor.state.selection;
                  if (selection) {
                    dragFromOtherEditor.commands.deleteRange({ from: selection.from, to: selection.to });
                  }
                }, 10);
              }
            }
            return false;
          },
          paste: (_view, event) => {
            var _a3;
            const html2 = (_a3 = event.clipboardData) === null || _a3 === void 0 ? void 0 : _a3.getData("text/html");
            pasteEvent = event;
            isPastedFromProseMirror = !!(html2 === null || html2 === void 0 ? void 0 : html2.includes("data-pm-slice"));
            return false;
          }
        }
      },
      appendTransaction: (transactions, oldState, state) => {
        const transaction = transactions[0];
        const isPaste = transaction.getMeta("uiEvent") === "paste" && !isPastedFromProseMirror;
        const isDrop = transaction.getMeta("uiEvent") === "drop" && !isDroppedFromProseMirror;
        const simulatedPasteMeta = transaction.getMeta("applyPasteRules");
        const isSimulatedPaste = !!simulatedPasteMeta;
        if (!isPaste && !isDrop && !isSimulatedPaste) {
          return;
        }
        if (isSimulatedPaste) {
          let { text: text2 } = simulatedPasteMeta;
          if (typeof text2 === "string") {
            text2 = text2;
          } else {
            text2 = getHTMLFromFragment(Fragment.from(text2), state.schema);
          }
          const { from: from4 } = simulatedPasteMeta;
          const to3 = from4 + text2.length;
          const pasteEvt = createClipboardPasteEvent(text2);
          return processEvent({
            rule,
            state,
            from: from4,
            to: { b: to3 },
            pasteEvt
          });
        }
        const from3 = oldState.doc.content.findDiffStart(state.doc.content);
        const to2 = oldState.doc.content.findDiffEnd(state.doc.content);
        if (!isNumber3(from3) || !to2 || from3 === to2.b) {
          return;
        }
        return processEvent({
          rule,
          state,
          from: from3,
          to: to2,
          pasteEvt: pasteEvent
        });
      }
    });
  });
  return plugins;
}
function findDuplicates(items) {
  const filtered = items.filter((el, index2) => items.indexOf(el) !== index2);
  return Array.from(new Set(filtered));
}
class ExtensionManager {
  constructor(extensions, editor) {
    this.splittableMarks = [];
    this.editor = editor;
    this.extensions = ExtensionManager.resolve(extensions);
    this.schema = getSchemaByResolvedExtensions(this.extensions, editor);
    this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(extensions) {
    const resolvedExtensions = ExtensionManager.sort(ExtensionManager.flatten(extensions));
    const duplicatedNames = findDuplicates(resolvedExtensions.map((extension2) => extension2.name));
    if (duplicatedNames.length) {
      console.warn(`[tiptap warn]: Duplicate extension names found: [${duplicatedNames.map((item) => `'${item}'`).join(", ")}]. This can lead to issues.`);
    }
    return resolvedExtensions;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(extensions) {
    return extensions.map((extension2) => {
      const context = {
        name: extension2.name,
        options: extension2.options,
        storage: extension2.storage
      };
      const addExtensions = getExtensionField(extension2, "addExtensions", context);
      if (addExtensions) {
        return [extension2, ...this.flatten(addExtensions())];
      }
      return extension2;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(extensions) {
    const defaultPriority = 100;
    return extensions.sort((a2, b2) => {
      const priorityA = getExtensionField(a2, "priority") || defaultPriority;
      const priorityB = getExtensionField(b2, "priority") || defaultPriority;
      if (priorityA > priorityB) {
        return -1;
      }
      if (priorityA < priorityB) {
        return 1;
      }
      return 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((commands2, extension2) => {
      const context = {
        name: extension2.name,
        options: extension2.options,
        storage: extension2.storage,
        editor: this.editor,
        type: getSchemaTypeByName(extension2.name, this.schema)
      };
      const addCommands = getExtensionField(extension2, "addCommands", context);
      if (!addCommands) {
        return commands2;
      }
      return {
        ...commands2,
        ...addCommands()
      };
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor } = this;
    const extensions = ExtensionManager.sort([...this.extensions].reverse());
    const inputRules = [];
    const pasteRules = [];
    const allPlugins = extensions.map((extension2) => {
      const context = {
        name: extension2.name,
        options: extension2.options,
        storage: extension2.storage,
        editor,
        type: getSchemaTypeByName(extension2.name, this.schema)
      };
      const plugins = [];
      const addKeyboardShortcuts = getExtensionField(extension2, "addKeyboardShortcuts", context);
      let defaultBindings = {};
      if (extension2.type === "mark" && getExtensionField(extension2, "exitable", context)) {
        defaultBindings.ArrowRight = () => Mark2.handleExit({ editor, mark: extension2 });
      }
      if (addKeyboardShortcuts) {
        const bindings = Object.fromEntries(Object.entries(addKeyboardShortcuts()).map(([shortcut, method]) => {
          return [shortcut, () => method({ editor })];
        }));
        defaultBindings = { ...defaultBindings, ...bindings };
      }
      const keyMapPlugin = keymap(defaultBindings);
      plugins.push(keyMapPlugin);
      const addInputRules = getExtensionField(extension2, "addInputRules", context);
      if (isExtensionRulesEnabled(extension2, editor.options.enableInputRules) && addInputRules) {
        inputRules.push(...addInputRules());
      }
      const addPasteRules = getExtensionField(extension2, "addPasteRules", context);
      if (isExtensionRulesEnabled(extension2, editor.options.enablePasteRules) && addPasteRules) {
        pasteRules.push(...addPasteRules());
      }
      const addProseMirrorPlugins = getExtensionField(extension2, "addProseMirrorPlugins", context);
      if (addProseMirrorPlugins) {
        const proseMirrorPlugins = addProseMirrorPlugins();
        plugins.push(...proseMirrorPlugins);
      }
      return plugins;
    }).flat();
    return [
      inputRulesPlugin({
        editor,
        rules: inputRules
      }),
      ...pasteRulesPlugin({
        editor,
        rules: pasteRules
      }),
      ...allPlugins
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return getAttributesFromExtensions(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor } = this;
    const { nodeExtensions } = splitExtensions(this.extensions);
    return Object.fromEntries(nodeExtensions.filter((extension2) => !!getExtensionField(extension2, "addNodeView")).map((extension2) => {
      const extensionAttributes = this.attributes.filter((attribute) => attribute.type === extension2.name);
      const context = {
        name: extension2.name,
        options: extension2.options,
        storage: extension2.storage,
        editor,
        type: getNodeType(extension2.name, this.schema)
      };
      const addNodeView = getExtensionField(extension2, "addNodeView", context);
      if (!addNodeView) {
        return [];
      }
      const nodeview = (node2, view, getPos, decorations, innerDecorations) => {
        const HTMLAttributes = getRenderedAttributes(node2, extensionAttributes);
        return addNodeView()({
          // pass-through
          node: node2,
          view,
          getPos,
          decorations,
          innerDecorations,
          // tiptap-specific
          editor,
          extension: extension2,
          HTMLAttributes
        });
      };
      return [extension2.name, nodeview];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((extension2) => {
      var _a3;
      this.editor.extensionStorage[extension2.name] = extension2.storage;
      const context = {
        name: extension2.name,
        options: extension2.options,
        storage: extension2.storage,
        editor: this.editor,
        type: getSchemaTypeByName(extension2.name, this.schema)
      };
      if (extension2.type === "mark") {
        const keepOnSplit = (_a3 = callOrReturn(getExtensionField(extension2, "keepOnSplit", context))) !== null && _a3 !== void 0 ? _a3 : true;
        if (keepOnSplit) {
          this.splittableMarks.push(extension2.name);
        }
      }
      const onBeforeCreate = getExtensionField(extension2, "onBeforeCreate", context);
      const onCreate = getExtensionField(extension2, "onCreate", context);
      const onUpdate = getExtensionField(extension2, "onUpdate", context);
      const onSelectionUpdate = getExtensionField(extension2, "onSelectionUpdate", context);
      const onTransaction = getExtensionField(extension2, "onTransaction", context);
      const onFocus = getExtensionField(extension2, "onFocus", context);
      const onBlur = getExtensionField(extension2, "onBlur", context);
      const onDestroy = getExtensionField(extension2, "onDestroy", context);
      if (onBeforeCreate) {
        this.editor.on("beforeCreate", onBeforeCreate);
      }
      if (onCreate) {
        this.editor.on("create", onCreate);
      }
      if (onUpdate) {
        this.editor.on("update", onUpdate);
      }
      if (onSelectionUpdate) {
        this.editor.on("selectionUpdate", onSelectionUpdate);
      }
      if (onTransaction) {
        this.editor.on("transaction", onTransaction);
      }
      if (onFocus) {
        this.editor.on("focus", onFocus);
      }
      if (onBlur) {
        this.editor.on("blur", onBlur);
      }
      if (onDestroy) {
        this.editor.on("destroy", onDestroy);
      }
    });
  }
}
class Extension {
  constructor(config2 = {}) {
    this.type = "extension";
    this.name = "extension";
    this.parent = null;
    this.child = null;
    this.config = {
      name: this.name,
      defaultOptions: {}
    };
    this.config = {
      ...this.config,
      ...config2
    };
    this.name = this.config.name;
    if (config2.defaultOptions && Object.keys(config2.defaultOptions).length > 0) {
      console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
    }
    this.options = this.config.defaultOptions;
    if (this.config.addOptions) {
      this.options = callOrReturn(getExtensionField(this, "addOptions", {
        name: this.name
      }));
    }
    this.storage = callOrReturn(getExtensionField(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(config2 = {}) {
    return new Extension(config2);
  }
  configure(options = {}) {
    const extension2 = this.extend({
      ...this.config,
      addOptions: () => {
        return mergeDeep(this.options, options);
      }
    });
    extension2.name = this.name;
    extension2.parent = this.parent;
    return extension2;
  }
  extend(extendedConfig = {}) {
    const extension2 = new Extension({ ...this.config, ...extendedConfig });
    extension2.parent = this;
    this.child = extension2;
    extension2.name = extendedConfig.name ? extendedConfig.name : extension2.parent.name;
    if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) {
      console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension2.name}".`);
    }
    extension2.options = callOrReturn(getExtensionField(extension2, "addOptions", {
      name: extension2.name
    }));
    extension2.storage = callOrReturn(getExtensionField(extension2, "addStorage", {
      name: extension2.name,
      options: extension2.options
    }));
    return extension2;
  }
}
function getTextBetween(startNode, range, options) {
  const { from: from3, to: to2 } = range;
  const { blockSeparator = "\n\n", textSerializers = {} } = options || {};
  let text2 = "";
  startNode.nodesBetween(from3, to2, (node2, pos, parent2, index2) => {
    var _a3;
    if (node2.isBlock && pos > from3) {
      text2 += blockSeparator;
    }
    const textSerializer = textSerializers === null || textSerializers === void 0 ? void 0 : textSerializers[node2.type.name];
    if (textSerializer) {
      if (parent2) {
        text2 += textSerializer({
          node: node2,
          pos,
          parent: parent2,
          index: index2,
          range
        });
      }
      return false;
    }
    if (node2.isText) {
      text2 += (_a3 = node2 === null || node2 === void 0 ? void 0 : node2.text) === null || _a3 === void 0 ? void 0 : _a3.slice(Math.max(from3, pos) - pos, to2 - pos);
    }
  });
  return text2;
}
function getTextSerializersFromSchema(schema) {
  return Object.fromEntries(Object.entries(schema.nodes).filter(([, node2]) => node2.spec.toText).map(([name2, node2]) => [name2, node2.spec.toText]));
}
const ClipboardTextSerializer = Extension.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor } = this;
            const { state, schema } = editor;
            const { doc: doc2, selection } = state;
            const { ranges } = selection;
            const from3 = Math.min(...ranges.map((range2) => range2.$from.pos));
            const to2 = Math.max(...ranges.map((range2) => range2.$to.pos));
            const textSerializers = getTextSerializersFromSchema(schema);
            const range = { from: from3, to: to2 };
            return getTextBetween(doc2, range, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers
            });
          }
        }
      })
    ];
  }
});
const blur = () => ({ editor, view }) => {
  requestAnimationFrame(() => {
    var _a3;
    if (!editor.isDestroyed) {
      view.dom.blur();
      (_a3 = window === null || window === void 0 ? void 0 : window.getSelection()) === null || _a3 === void 0 ? void 0 : _a3.removeAllRanges();
    }
  });
  return true;
};
const clearContent = (emitUpdate = false) => ({ commands: commands2 }) => {
  return commands2.setContent("", emitUpdate);
};
const clearNodes = () => ({ state, tr: tr2, dispatch }) => {
  const { selection } = tr2;
  const { ranges } = selection;
  if (!dispatch) {
    return true;
  }
  ranges.forEach(({ $from, $to }) => {
    state.doc.nodesBetween($from.pos, $to.pos, (node2, pos) => {
      if (node2.type.isText) {
        return;
      }
      const { doc: doc2, mapping } = tr2;
      const $mappedFrom = doc2.resolve(mapping.map(pos));
      const $mappedTo = doc2.resolve(mapping.map(pos + node2.nodeSize));
      const nodeRange = $mappedFrom.blockRange($mappedTo);
      if (!nodeRange) {
        return;
      }
      const targetLiftDepth = liftTarget(nodeRange);
      if (node2.type.isTextblock) {
        const { defaultType } = $mappedFrom.parent.contentMatchAt($mappedFrom.index());
        tr2.setNodeMarkup(nodeRange.start, defaultType);
      }
      if (targetLiftDepth || targetLiftDepth === 0) {
        tr2.lift(nodeRange, targetLiftDepth);
      }
    });
  });
  return true;
};
const command = (fn2) => (props) => {
  return fn2(props);
};
const createParagraphNear = () => ({ state, dispatch }) => {
  return createParagraphNear$1(state, dispatch);
};
const cut = (originRange, targetPos) => ({ editor, tr: tr2 }) => {
  const { state } = editor;
  const contentSlice = state.doc.slice(originRange.from, originRange.to);
  tr2.deleteRange(originRange.from, originRange.to);
  const newPos = tr2.mapping.map(targetPos);
  tr2.insert(newPos, contentSlice.content);
  tr2.setSelection(new TextSelection(tr2.doc.resolve(Math.max(newPos - 1, 0))));
  return true;
};
const deleteCurrentNode = () => ({ tr: tr2, dispatch }) => {
  const { selection } = tr2;
  const currentNode = selection.$anchor.node();
  if (currentNode.content.size > 0) {
    return false;
  }
  const $pos = tr2.selection.$anchor;
  for (let depth = $pos.depth; depth > 0; depth -= 1) {
    const node2 = $pos.node(depth);
    if (node2.type === currentNode.type) {
      if (dispatch) {
        const from3 = $pos.before(depth);
        const to2 = $pos.after(depth);
        tr2.delete(from3, to2).scrollIntoView();
      }
      return true;
    }
  }
  return false;
};
const deleteNode = (typeOrName) => ({ tr: tr2, state, dispatch }) => {
  const type = getNodeType(typeOrName, state.schema);
  const $pos = tr2.selection.$anchor;
  for (let depth = $pos.depth; depth > 0; depth -= 1) {
    const node2 = $pos.node(depth);
    if (node2.type === type) {
      if (dispatch) {
        const from3 = $pos.before(depth);
        const to2 = $pos.after(depth);
        tr2.delete(from3, to2).scrollIntoView();
      }
      return true;
    }
  }
  return false;
};
const deleteRange = (range) => ({ tr: tr2, dispatch }) => {
  const { from: from3, to: to2 } = range;
  if (dispatch) {
    tr2.delete(from3, to2);
  }
  return true;
};
const deleteSelection = () => ({ state, dispatch }) => {
  return deleteSelection$1(state, dispatch);
};
const enter = () => ({ commands: commands2 }) => {
  return commands2.keyboardShortcut("Enter");
};
const exitCode = () => ({ state, dispatch }) => {
  return exitCode$1(state, dispatch);
};
function objectIncludes(object1, object2, options = { strict: true }) {
  const keys2 = Object.keys(object2);
  if (!keys2.length) {
    return true;
  }
  return keys2.every((key2) => {
    if (options.strict) {
      return object2[key2] === object1[key2];
    }
    if (isRegExp(object2[key2])) {
      return object2[key2].test(object1[key2]);
    }
    return object2[key2] === object1[key2];
  });
}
function findMarkInSet(marks, type, attributes = {}) {
  return marks.find((item) => {
    return item.type === type && objectIncludes(
      // Only check equality for the attributes that are provided
      Object.fromEntries(Object.keys(attributes).map((k2) => [k2, item.attrs[k2]])),
      attributes
    );
  });
}
function isMarkInSet(marks, type, attributes = {}) {
  return !!findMarkInSet(marks, type, attributes);
}
function getMarkRange($pos, type, attributes) {
  var _a3;
  if (!$pos || !type) {
    return;
  }
  let start4 = $pos.parent.childAfter($pos.parentOffset);
  if (!start4.node || !start4.node.marks.some((mark3) => mark3.type === type)) {
    start4 = $pos.parent.childBefore($pos.parentOffset);
  }
  if (!start4.node || !start4.node.marks.some((mark3) => mark3.type === type)) {
    return;
  }
  attributes = attributes || ((_a3 = start4.node.marks[0]) === null || _a3 === void 0 ? void 0 : _a3.attrs);
  const mark2 = findMarkInSet([...start4.node.marks], type, attributes);
  if (!mark2) {
    return;
  }
  let startIndex = start4.index;
  let startPos = $pos.start() + start4.offset;
  let endIndex = startIndex + 1;
  let endPos = startPos + start4.node.nodeSize;
  while (startIndex > 0 && isMarkInSet([...$pos.parent.child(startIndex - 1).marks], type, attributes)) {
    startIndex -= 1;
    startPos -= $pos.parent.child(startIndex).nodeSize;
  }
  while (endIndex < $pos.parent.childCount && isMarkInSet([...$pos.parent.child(endIndex).marks], type, attributes)) {
    endPos += $pos.parent.child(endIndex).nodeSize;
    endIndex += 1;
  }
  return {
    from: startPos,
    to: endPos
  };
}
function getMarkType(nameOrType, schema) {
  if (typeof nameOrType === "string") {
    if (!schema.marks[nameOrType]) {
      throw Error(`There is no mark type named '${nameOrType}'. Maybe you forgot to add the extension?`);
    }
    return schema.marks[nameOrType];
  }
  return nameOrType;
}
const extendMarkRange = (typeOrName, attributes = {}) => ({ tr: tr2, state, dispatch }) => {
  const type = getMarkType(typeOrName, state.schema);
  const { doc: doc2, selection } = tr2;
  const { $from, from: from3, to: to2 } = selection;
  if (dispatch) {
    const range = getMarkRange($from, type, attributes);
    if (range && range.from <= from3 && range.to >= to2) {
      const newSelection = TextSelection.create(doc2, range.from, range.to);
      tr2.setSelection(newSelection);
    }
  }
  return true;
};
const first = (commands2) => (props) => {
  const items = typeof commands2 === "function" ? commands2(props) : commands2;
  for (let i = 0; i < items.length; i += 1) {
    if (items[i](props)) {
      return true;
    }
  }
  return false;
};
function isTextSelection(value) {
  return value instanceof TextSelection;
}
function minMax(value = 0, min2 = 0, max2 = 0) {
  return Math.min(Math.max(value, min2), max2);
}
function resolveFocusPosition(doc2, position4 = null) {
  if (!position4) {
    return null;
  }
  const selectionAtStart = Selection.atStart(doc2);
  const selectionAtEnd = Selection.atEnd(doc2);
  if (position4 === "start" || position4 === true) {
    return selectionAtStart;
  }
  if (position4 === "end") {
    return selectionAtEnd;
  }
  const minPos = selectionAtStart.from;
  const maxPos = selectionAtEnd.to;
  if (position4 === "all") {
    return TextSelection.create(doc2, minMax(0, minPos, maxPos), minMax(doc2.content.size, minPos, maxPos));
  }
  return TextSelection.create(doc2, minMax(position4, minPos, maxPos), minMax(position4, minPos, maxPos));
}
function isAndroid() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function isiOS() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const focus = (position4 = null, options = {}) => ({ editor, view, tr: tr2, dispatch }) => {
  options = {
    scrollIntoView: true,
    ...options
  };
  const delayedFocus = () => {
    if (isiOS() || isAndroid()) {
      view.dom.focus();
    }
    requestAnimationFrame(() => {
      if (!editor.isDestroyed) {
        view.focus();
        if (options === null || options === void 0 ? void 0 : options.scrollIntoView) {
          editor.commands.scrollIntoView();
        }
      }
    });
  };
  if (view.hasFocus() && position4 === null || position4 === false) {
    return true;
  }
  if (dispatch && position4 === null && !isTextSelection(editor.state.selection)) {
    delayedFocus();
    return true;
  }
  const selection = resolveFocusPosition(tr2.doc, position4) || editor.state.selection;
  const isSameSelection = editor.state.selection.eq(selection);
  if (dispatch) {
    if (!isSameSelection) {
      tr2.setSelection(selection);
    }
    if (isSameSelection && tr2.storedMarks) {
      tr2.setStoredMarks(tr2.storedMarks);
    }
    delayedFocus();
  }
  return true;
};
const forEach = (items, fn2) => (props) => {
  return items.every((item, index2) => fn2(item, { ...props, index: index2 }));
};
const insertContent = (value, options) => ({ tr: tr2, commands: commands2 }) => {
  return commands2.insertContentAt({ from: tr2.selection.from, to: tr2.selection.to }, value, options);
};
const removeWhitespaces = (node2) => {
  const children = node2.childNodes;
  for (let i = children.length - 1; i >= 0; i -= 1) {
    const child = children[i];
    if (child.nodeType === 3 && child.nodeValue && /^(\n\s\s|\n)$/.test(child.nodeValue)) {
      node2.removeChild(child);
    } else if (child.nodeType === 1) {
      removeWhitespaces(child);
    }
  }
  return node2;
};
function elementFromString(value) {
  const wrappedValue = `<body>${value}</body>`;
  const html2 = new window.DOMParser().parseFromString(wrappedValue, "text/html").body;
  return removeWhitespaces(html2);
}
function createNodeFromContent(content2, schema, options) {
  if (content2 instanceof Node$2 || content2 instanceof Fragment) {
    return content2;
  }
  options = {
    slice: true,
    parseOptions: {},
    ...options
  };
  const isJSONContent = typeof content2 === "object" && content2 !== null;
  const isTextContent = typeof content2 === "string";
  if (isJSONContent) {
    try {
      const isArrayContent = Array.isArray(content2) && content2.length > 0;
      if (isArrayContent) {
        return Fragment.fromArray(content2.map((item) => schema.nodeFromJSON(item)));
      }
      const node2 = schema.nodeFromJSON(content2);
      if (options.errorOnInvalidContent) {
        node2.check();
      }
      return node2;
    } catch (error2) {
      if (options.errorOnInvalidContent) {
        throw new Error("[tiptap error]: Invalid JSON content", { cause: error2 });
      }
      console.warn("[tiptap warn]: Invalid content.", "Passed value:", content2, "Error:", error2);
      return createNodeFromContent("", schema, options);
    }
  }
  if (isTextContent) {
    if (options.errorOnInvalidContent) {
      let hasInvalidContent = false;
      let invalidContent = "";
      const contentCheckSchema = new Schema2({
        topNode: schema.spec.topNode,
        marks: schema.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: schema.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (e) => {
                  hasInvalidContent = true;
                  invalidContent = typeof e === "string" ? e : e.outerHTML;
                  return null;
                }
              }
            ]
          }
        })
      });
      if (options.slice) {
        DOMParser.fromSchema(contentCheckSchema).parseSlice(elementFromString(content2), options.parseOptions);
      } else {
        DOMParser.fromSchema(contentCheckSchema).parse(elementFromString(content2), options.parseOptions);
      }
      if (options.errorOnInvalidContent && hasInvalidContent) {
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${invalidContent}`) });
      }
    }
    const parser = DOMParser.fromSchema(schema);
    if (options.slice) {
      return parser.parseSlice(elementFromString(content2), options.parseOptions).content;
    }
    return parser.parse(elementFromString(content2), options.parseOptions);
  }
  return createNodeFromContent("", schema, options);
}
function selectionToInsertionEnd(tr2, startLen, bias) {
  const last = tr2.steps.length - 1;
  if (last < startLen) {
    return;
  }
  const step = tr2.steps[last];
  if (!(step instanceof ReplaceStep || step instanceof ReplaceAroundStep)) {
    return;
  }
  const map3 = tr2.mapping.maps[last];
  let end2 = 0;
  map3.forEach((_from, _to, _newFrom, newTo) => {
    if (end2 === 0) {
      end2 = newTo;
    }
  });
  tr2.setSelection(Selection.near(tr2.doc.resolve(end2), bias));
}
const isFragment = (nodeOrFragment) => {
  return !("type" in nodeOrFragment);
};
const insertContentAt = (position4, value, options) => ({ tr: tr2, dispatch, editor }) => {
  var _a3;
  if (dispatch) {
    options = {
      parseOptions: editor.options.parseOptions,
      updateSelection: true,
      applyInputRules: false,
      applyPasteRules: false,
      ...options
    };
    let content2;
    const emitContentError = (error2) => {
      editor.emit("contentError", {
        editor,
        error: error2,
        disableCollaboration: () => {
          if (editor.storage.collaboration) {
            editor.storage.collaboration.isDisabled = true;
          }
        }
      });
    };
    const parseOptions = {
      preserveWhitespace: "full",
      ...options.parseOptions
    };
    if (!options.errorOnInvalidContent && !editor.options.enableContentCheck && editor.options.emitContentError) {
      try {
        createNodeFromContent(value, editor.schema, {
          parseOptions,
          errorOnInvalidContent: true
        });
      } catch (e) {
        emitContentError(e);
      }
    }
    try {
      content2 = createNodeFromContent(value, editor.schema, {
        parseOptions,
        errorOnInvalidContent: (_a3 = options.errorOnInvalidContent) !== null && _a3 !== void 0 ? _a3 : editor.options.enableContentCheck
      });
    } catch (e) {
      emitContentError(e);
      return false;
    }
    let { from: from3, to: to2 } = typeof position4 === "number" ? { from: position4, to: position4 } : { from: position4.from, to: position4.to };
    let isOnlyTextContent = true;
    let isOnlyBlockContent = true;
    const nodes = isFragment(content2) ? content2 : [content2];
    nodes.forEach((node2) => {
      node2.check();
      isOnlyTextContent = isOnlyTextContent ? node2.isText && node2.marks.length === 0 : false;
      isOnlyBlockContent = isOnlyBlockContent ? node2.isBlock : false;
    });
    if (from3 === to2 && isOnlyBlockContent) {
      const { parent: parent2 } = tr2.doc.resolve(from3);
      const isEmptyTextBlock = parent2.isTextblock && !parent2.type.spec.code && !parent2.childCount;
      if (isEmptyTextBlock) {
        from3 -= 1;
        to2 += 1;
      }
    }
    let newContent;
    if (isOnlyTextContent) {
      if (Array.isArray(value)) {
        newContent = value.map((v2) => v2.text || "").join("");
      } else if (value instanceof Fragment) {
        let text2 = "";
        value.forEach((node2) => {
          if (node2.text) {
            text2 += node2.text;
          }
        });
        newContent = text2;
      } else if (typeof value === "object" && !!value && !!value.text) {
        newContent = value.text;
      } else {
        newContent = value;
      }
      tr2.insertText(newContent, from3, to2);
    } else {
      newContent = content2;
      tr2.replaceWith(from3, to2, newContent);
    }
    if (options.updateSelection) {
      selectionToInsertionEnd(tr2, tr2.steps.length - 1, -1);
    }
    if (options.applyInputRules) {
      tr2.setMeta("applyInputRules", { from: from3, text: newContent });
    }
    if (options.applyPasteRules) {
      tr2.setMeta("applyPasteRules", { from: from3, text: newContent });
    }
  }
  return true;
};
const joinUp = () => ({ state, dispatch }) => {
  return joinUp$1(state, dispatch);
};
const joinDown = () => ({ state, dispatch }) => {
  return joinDown$1(state, dispatch);
};
const joinBackward = () => ({ state, dispatch }) => {
  return joinBackward$1(state, dispatch);
};
const joinForward = () => ({ state, dispatch }) => {
  return joinForward$1(state, dispatch);
};
const joinItemBackward = () => ({ state, dispatch, tr: tr2 }) => {
  try {
    const point2 = joinPoint(state.doc, state.selection.$from.pos, -1);
    if (point2 === null || point2 === void 0) {
      return false;
    }
    tr2.join(point2, 2);
    if (dispatch) {
      dispatch(tr2);
    }
    return true;
  } catch {
    return false;
  }
};
const joinItemForward = () => ({ state, dispatch, tr: tr2 }) => {
  try {
    const point2 = joinPoint(state.doc, state.selection.$from.pos, 1);
    if (point2 === null || point2 === void 0) {
      return false;
    }
    tr2.join(point2, 2);
    if (dispatch) {
      dispatch(tr2);
    }
    return true;
  } catch {
    return false;
  }
};
const joinTextblockBackward = () => ({ state, dispatch }) => {
  return joinTextblockBackward$1(state, dispatch);
};
const joinTextblockForward = () => ({ state, dispatch }) => {
  return joinTextblockForward$1(state, dispatch);
};
function isMacOS() {
  return typeof navigator !== "undefined" ? /Mac/.test(navigator.platform) : false;
}
function normalizeKeyName(name2) {
  const parts = name2.split(/-(?!$)/);
  let result = parts[parts.length - 1];
  if (result === "Space") {
    result = " ";
  }
  let alt;
  let ctrl;
  let shift3;
  let meta;
  for (let i = 0; i < parts.length - 1; i += 1) {
    const mod2 = parts[i];
    if (/^(cmd|meta|m)$/i.test(mod2)) {
      meta = true;
    } else if (/^a(lt)?$/i.test(mod2)) {
      alt = true;
    } else if (/^(c|ctrl|control)$/i.test(mod2)) {
      ctrl = true;
    } else if (/^s(hift)?$/i.test(mod2)) {
      shift3 = true;
    } else if (/^mod$/i.test(mod2)) {
      if (isiOS() || isMacOS()) {
        meta = true;
      } else {
        ctrl = true;
      }
    } else {
      throw new Error(`Unrecognized modifier name: ${mod2}`);
    }
  }
  if (alt) {
    result = `Alt-${result}`;
  }
  if (ctrl) {
    result = `Ctrl-${result}`;
  }
  if (meta) {
    result = `Meta-${result}`;
  }
  if (shift3) {
    result = `Shift-${result}`;
  }
  return result;
}
const keyboardShortcut = (name2) => ({ editor, view, tr: tr2, dispatch }) => {
  const keys2 = normalizeKeyName(name2).split(/-(?!$)/);
  const key2 = keys2.find((item) => !["Alt", "Ctrl", "Meta", "Shift"].includes(item));
  const event = new KeyboardEvent("keydown", {
    key: key2 === "Space" ? " " : key2,
    altKey: keys2.includes("Alt"),
    ctrlKey: keys2.includes("Ctrl"),
    metaKey: keys2.includes("Meta"),
    shiftKey: keys2.includes("Shift"),
    bubbles: true,
    cancelable: true
  });
  const capturedTransaction = editor.captureTransaction(() => {
    view.someProp("handleKeyDown", (f2) => f2(view, event));
  });
  capturedTransaction === null || capturedTransaction === void 0 ? void 0 : capturedTransaction.steps.forEach((step) => {
    const newStep = step.map(tr2.mapping);
    if (newStep && dispatch) {
      tr2.maybeStep(newStep);
    }
  });
  return true;
};
function isNodeActive(state, typeOrName, attributes = {}) {
  const { from: from3, to: to2, empty: empty2 } = state.selection;
  const type = typeOrName ? getNodeType(typeOrName, state.schema) : null;
  const nodeRanges = [];
  state.doc.nodesBetween(from3, to2, (node2, pos) => {
    if (node2.isText) {
      return;
    }
    const relativeFrom = Math.max(from3, pos);
    const relativeTo = Math.min(to2, pos + node2.nodeSize);
    nodeRanges.push({
      node: node2,
      from: relativeFrom,
      to: relativeTo
    });
  });
  const selectionRange = to2 - from3;
  const matchedNodeRanges = nodeRanges.filter((nodeRange) => {
    if (!type) {
      return true;
    }
    return type.name === nodeRange.node.type.name;
  }).filter((nodeRange) => objectIncludes(nodeRange.node.attrs, attributes, { strict: false }));
  if (empty2) {
    return !!matchedNodeRanges.length;
  }
  const range = matchedNodeRanges.reduce((sum, nodeRange) => sum + nodeRange.to - nodeRange.from, 0);
  return range >= selectionRange;
}
const lift3 = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
  const type = getNodeType(typeOrName, state.schema);
  const isActive2 = isNodeActive(state, type, attributes);
  if (!isActive2) {
    return false;
  }
  return lift$1(state, dispatch);
};
const liftEmptyBlock = () => ({ state, dispatch }) => {
  return liftEmptyBlock$1(state, dispatch);
};
const liftListItem = (typeOrName) => ({ state, dispatch }) => {
  const type = getNodeType(typeOrName, state.schema);
  return liftListItem$1(type)(state, dispatch);
};
const newlineInCode = () => ({ state, dispatch }) => {
  return newlineInCode$1(state, dispatch);
};
function getSchemaTypeNameByName(name2, schema) {
  if (schema.nodes[name2]) {
    return "node";
  }
  if (schema.marks[name2]) {
    return "mark";
  }
  return null;
}
function deleteProps(obj, propOrProps) {
  const props = typeof propOrProps === "string" ? [propOrProps] : propOrProps;
  return Object.keys(obj).reduce((newObj, prop) => {
    if (!props.includes(prop)) {
      newObj[prop] = obj[prop];
    }
    return newObj;
  }, {});
}
const resetAttributes = (typeOrName, attributes) => ({ tr: tr2, state, dispatch }) => {
  let nodeType = null;
  let markType = null;
  const schemaType = getSchemaTypeNameByName(typeof typeOrName === "string" ? typeOrName : typeOrName.name, state.schema);
  if (!schemaType) {
    return false;
  }
  if (schemaType === "node") {
    nodeType = getNodeType(typeOrName, state.schema);
  }
  if (schemaType === "mark") {
    markType = getMarkType(typeOrName, state.schema);
  }
  if (dispatch) {
    tr2.selection.ranges.forEach((range) => {
      state.doc.nodesBetween(range.$from.pos, range.$to.pos, (node2, pos) => {
        if (nodeType && nodeType === node2.type) {
          tr2.setNodeMarkup(pos, void 0, deleteProps(node2.attrs, attributes));
        }
        if (markType && node2.marks.length) {
          node2.marks.forEach((mark2) => {
            if (markType === mark2.type) {
              tr2.addMark(pos, pos + node2.nodeSize, markType.create(deleteProps(mark2.attrs, attributes)));
            }
          });
        }
      });
    });
  }
  return true;
};
const scrollIntoView = () => ({ tr: tr2, dispatch }) => {
  if (dispatch) {
    tr2.scrollIntoView();
  }
  return true;
};
const selectAll = () => ({ tr: tr2, dispatch }) => {
  if (dispatch) {
    const selection = new AllSelection(tr2.doc);
    tr2.setSelection(selection);
  }
  return true;
};
const selectNodeBackward = () => ({ state, dispatch }) => {
  return selectNodeBackward$1(state, dispatch);
};
const selectNodeForward = () => ({ state, dispatch }) => {
  return selectNodeForward$1(state, dispatch);
};
const selectParentNode = () => ({ state, dispatch }) => {
  return selectParentNode$1(state, dispatch);
};
const selectTextblockEnd = () => ({ state, dispatch }) => {
  return selectTextblockEnd$1(state, dispatch);
};
const selectTextblockStart = () => ({ state, dispatch }) => {
  return selectTextblockStart$1(state, dispatch);
};
function createDocument(content2, schema, parseOptions = {}, options = {}) {
  return createNodeFromContent(content2, schema, {
    slice: false,
    parseOptions,
    errorOnInvalidContent: options.errorOnInvalidContent
  });
}
const setContent = (content2, emitUpdate = false, parseOptions = {}, options = {}) => ({ editor, tr: tr2, dispatch, commands: commands2 }) => {
  var _a3, _b;
  const { doc: doc2 } = tr2;
  if (parseOptions.preserveWhitespace !== "full") {
    const document2 = createDocument(content2, editor.schema, parseOptions, {
      errorOnInvalidContent: (_a3 = options.errorOnInvalidContent) !== null && _a3 !== void 0 ? _a3 : editor.options.enableContentCheck
    });
    if (dispatch) {
      tr2.replaceWith(0, doc2.content.size, document2).setMeta("preventUpdate", !emitUpdate);
    }
    return true;
  }
  if (dispatch) {
    tr2.setMeta("preventUpdate", !emitUpdate);
  }
  return commands2.insertContentAt({ from: 0, to: doc2.content.size }, content2, {
    parseOptions,
    errorOnInvalidContent: (_b = options.errorOnInvalidContent) !== null && _b !== void 0 ? _b : editor.options.enableContentCheck
  });
};
function getMarkAttributes(state, typeOrName) {
  const type = getMarkType(typeOrName, state.schema);
  const { from: from3, to: to2, empty: empty2 } = state.selection;
  const marks = [];
  if (empty2) {
    if (state.storedMarks) {
      marks.push(...state.storedMarks);
    }
    marks.push(...state.selection.$head.marks());
  } else {
    state.doc.nodesBetween(from3, to2, (node2) => {
      marks.push(...node2.marks);
    });
  }
  const mark2 = marks.find((markItem) => markItem.type.name === type.name);
  if (!mark2) {
    return {};
  }
  return { ...mark2.attrs };
}
function combineTransactionSteps(oldDoc, transactions) {
  const transform = new Transform(oldDoc);
  transactions.forEach((transaction) => {
    transaction.steps.forEach((step) => {
      transform.step(step);
    });
  });
  return transform;
}
function defaultBlockAt(match5) {
  for (let i = 0; i < match5.edgeCount; i += 1) {
    const { type } = match5.edge(i);
    if (type.isTextblock && !type.hasRequiredAttrs()) {
      return type;
    }
  }
  return null;
}
function findChildrenInRange(node2, range, predicate) {
  const nodesWithPos = [];
  node2.nodesBetween(range.from, range.to, (child, pos) => {
    if (predicate(child)) {
      nodesWithPos.push({
        node: child,
        pos
      });
    }
  });
  return nodesWithPos;
}
function findParentNodeClosestToPos($pos, predicate) {
  for (let i = $pos.depth; i > 0; i -= 1) {
    const node2 = $pos.node(i);
    if (predicate(node2)) {
      return {
        pos: i > 0 ? $pos.before(i) : 0,
        start: $pos.start(i),
        depth: i,
        node: node2
      };
    }
  }
}
function findParentNode(predicate) {
  return (selection) => findParentNodeClosestToPos(selection.$from, predicate);
}
function getText(node2, options) {
  const range = {
    from: 0,
    to: node2.content.size
  };
  return getTextBetween(node2, range, options);
}
function getNodeAttributes(state, typeOrName) {
  const type = getNodeType(typeOrName, state.schema);
  const { from: from3, to: to2 } = state.selection;
  const nodes = [];
  state.doc.nodesBetween(from3, to2, (node3) => {
    nodes.push(node3);
  });
  const node2 = nodes.reverse().find((nodeItem) => nodeItem.type.name === type.name);
  if (!node2) {
    return {};
  }
  return { ...node2.attrs };
}
function getAttributes(state, typeOrName) {
  const schemaType = getSchemaTypeNameByName(typeof typeOrName === "string" ? typeOrName : typeOrName.name, state.schema);
  if (schemaType === "node") {
    return getNodeAttributes(state, typeOrName);
  }
  if (schemaType === "mark") {
    return getMarkAttributes(state, typeOrName);
  }
  return {};
}
function removeDuplicates(array, by = JSON.stringify) {
  const seen = {};
  return array.filter((item) => {
    const key2 = by(item);
    return Object.prototype.hasOwnProperty.call(seen, key2) ? false : seen[key2] = true;
  });
}
function simplifyChangedRanges(changes) {
  const uniqueChanges = removeDuplicates(changes);
  return uniqueChanges.length === 1 ? uniqueChanges : uniqueChanges.filter((change, index2) => {
    const rest = uniqueChanges.filter((_2, i) => i !== index2);
    return !rest.some((otherChange) => {
      return change.oldRange.from >= otherChange.oldRange.from && change.oldRange.to <= otherChange.oldRange.to && change.newRange.from >= otherChange.newRange.from && change.newRange.to <= otherChange.newRange.to;
    });
  });
}
function getChangedRanges(transform) {
  const { mapping, steps } = transform;
  const changes = [];
  mapping.maps.forEach((stepMap, index2) => {
    const ranges = [];
    if (!stepMap.ranges.length) {
      const { from: from3, to: to2 } = steps[index2];
      if (from3 === void 0 || to2 === void 0) {
        return;
      }
      ranges.push({ from: from3, to: to2 });
    } else {
      stepMap.forEach((from3, to2) => {
        ranges.push({ from: from3, to: to2 });
      });
    }
    ranges.forEach(({ from: from3, to: to2 }) => {
      const newStart = mapping.slice(index2).map(from3, -1);
      const newEnd = mapping.slice(index2).map(to2);
      const oldStart = mapping.invert().map(newStart, -1);
      const oldEnd = mapping.invert().map(newEnd);
      changes.push({
        oldRange: {
          from: oldStart,
          to: oldEnd
        },
        newRange: {
          from: newStart,
          to: newEnd
        }
      });
    });
  });
  return simplifyChangedRanges(changes);
}
function getMarksBetween(from3, to2, doc2) {
  const marks = [];
  if (from3 === to2) {
    doc2.resolve(from3).marks().forEach((mark2) => {
      const $pos = doc2.resolve(from3);
      const range = getMarkRange($pos, mark2.type);
      if (!range) {
        return;
      }
      marks.push({
        mark: mark2,
        ...range
      });
    });
  } else {
    doc2.nodesBetween(from3, to2, (node2, pos) => {
      if (!node2 || (node2 === null || node2 === void 0 ? void 0 : node2.nodeSize) === void 0) {
        return;
      }
      marks.push(...node2.marks.map((mark2) => ({
        from: pos,
        to: pos + node2.nodeSize,
        mark: mark2
      })));
    });
  }
  return marks;
}
function getSplittedAttributes(extensionAttributes, typeName, attributes) {
  return Object.fromEntries(Object.entries(attributes).filter(([name2]) => {
    const extensionAttribute = extensionAttributes.find((item) => {
      return item.type === typeName && item.name === name2;
    });
    if (!extensionAttribute) {
      return false;
    }
    return extensionAttribute.attribute.keepOnSplit;
  }));
}
function isMarkActive(state, typeOrName, attributes = {}) {
  const { empty: empty2, ranges } = state.selection;
  const type = typeOrName ? getMarkType(typeOrName, state.schema) : null;
  if (empty2) {
    return !!(state.storedMarks || state.selection.$from.marks()).filter((mark2) => {
      if (!type) {
        return true;
      }
      return type.name === mark2.type.name;
    }).find((mark2) => objectIncludes(mark2.attrs, attributes, { strict: false }));
  }
  let selectionRange = 0;
  const markRanges = [];
  ranges.forEach(({ $from, $to }) => {
    const from3 = $from.pos;
    const to2 = $to.pos;
    state.doc.nodesBetween(from3, to2, (node2, pos) => {
      if (!node2.isText && !node2.marks.length) {
        return;
      }
      const relativeFrom = Math.max(from3, pos);
      const relativeTo = Math.min(to2, pos + node2.nodeSize);
      const range2 = relativeTo - relativeFrom;
      selectionRange += range2;
      markRanges.push(...node2.marks.map((mark2) => ({
        mark: mark2,
        from: relativeFrom,
        to: relativeTo
      })));
    });
  });
  if (selectionRange === 0) {
    return false;
  }
  const matchedRange = markRanges.filter((markRange) => {
    if (!type) {
      return true;
    }
    return type.name === markRange.mark.type.name;
  }).filter((markRange) => objectIncludes(markRange.mark.attrs, attributes, { strict: false })).reduce((sum, markRange) => sum + markRange.to - markRange.from, 0);
  const excludedRange = markRanges.filter((markRange) => {
    if (!type) {
      return true;
    }
    return markRange.mark.type !== type && markRange.mark.type.excludes(type);
  }).reduce((sum, markRange) => sum + markRange.to - markRange.from, 0);
  const range = matchedRange > 0 ? matchedRange + excludedRange : matchedRange;
  return range >= selectionRange;
}
function isActive(state, name2, attributes = {}) {
  if (!name2) {
    return isNodeActive(state, null, attributes) || isMarkActive(state, null, attributes);
  }
  const schemaType = getSchemaTypeNameByName(name2, state.schema);
  if (schemaType === "node") {
    return isNodeActive(state, name2, attributes);
  }
  if (schemaType === "mark") {
    return isMarkActive(state, name2, attributes);
  }
  return false;
}
function isList(name2, extensions) {
  const { nodeExtensions } = splitExtensions(extensions);
  const extension2 = nodeExtensions.find((item) => item.name === name2);
  if (!extension2) {
    return false;
  }
  const context = {
    name: extension2.name,
    options: extension2.options,
    storage: extension2.storage
  };
  const group = callOrReturn(getExtensionField(extension2, "group", context));
  if (typeof group !== "string") {
    return false;
  }
  return group.split(" ").includes("list");
}
function isNodeEmpty(node2, { checkChildren = true, ignoreWhitespace = false } = {}) {
  var _a3;
  if (ignoreWhitespace) {
    if (node2.type.name === "hardBreak") {
      return true;
    }
    if (node2.isText) {
      return /^\s*$/m.test((_a3 = node2.text) !== null && _a3 !== void 0 ? _a3 : "");
    }
  }
  if (node2.isText) {
    return !node2.text;
  }
  if (node2.isAtom || node2.isLeaf) {
    return false;
  }
  if (node2.content.childCount === 0) {
    return true;
  }
  if (checkChildren) {
    let isContentEmpty = true;
    node2.content.forEach((childNode) => {
      if (isContentEmpty === false) {
        return;
      }
      if (!isNodeEmpty(childNode, { ignoreWhitespace, checkChildren })) {
        isContentEmpty = false;
      }
    });
    return isContentEmpty;
  }
  return false;
}
function isNodeSelection(value) {
  return value instanceof NodeSelection;
}
function canSetMark(state, tr2, newMarkType) {
  var _a3;
  const { selection } = tr2;
  let cursor2 = null;
  if (isTextSelection(selection)) {
    cursor2 = selection.$cursor;
  }
  if (cursor2) {
    const currentMarks = (_a3 = state.storedMarks) !== null && _a3 !== void 0 ? _a3 : cursor2.marks();
    return !!newMarkType.isInSet(currentMarks) || !currentMarks.some((mark2) => mark2.type.excludes(newMarkType));
  }
  const { ranges } = selection;
  return ranges.some(({ $from, $to }) => {
    let someNodeSupportsMark = $from.depth === 0 ? state.doc.inlineContent && state.doc.type.allowsMarkType(newMarkType) : false;
    state.doc.nodesBetween($from.pos, $to.pos, (node2, _pos, parent2) => {
      if (someNodeSupportsMark) {
        return false;
      }
      if (node2.isInline) {
        const parentAllowsMarkType = !parent2 || parent2.type.allowsMarkType(newMarkType);
        const currentMarksAllowMarkType = !!newMarkType.isInSet(node2.marks) || !node2.marks.some((otherMark) => otherMark.type.excludes(newMarkType));
        someNodeSupportsMark = parentAllowsMarkType && currentMarksAllowMarkType;
      }
      return !someNodeSupportsMark;
    });
    return someNodeSupportsMark;
  });
}
const setMark = (typeOrName, attributes = {}) => ({ tr: tr2, state, dispatch }) => {
  const { selection } = tr2;
  const { empty: empty2, ranges } = selection;
  const type = getMarkType(typeOrName, state.schema);
  if (dispatch) {
    if (empty2) {
      const oldAttributes = getMarkAttributes(state, type);
      tr2.addStoredMark(type.create({
        ...oldAttributes,
        ...attributes
      }));
    } else {
      ranges.forEach((range) => {
        const from3 = range.$from.pos;
        const to2 = range.$to.pos;
        state.doc.nodesBetween(from3, to2, (node2, pos) => {
          const trimmedFrom = Math.max(pos, from3);
          const trimmedTo = Math.min(pos + node2.nodeSize, to2);
          const someHasMark = node2.marks.find((mark2) => mark2.type === type);
          if (someHasMark) {
            node2.marks.forEach((mark2) => {
              if (type === mark2.type) {
                tr2.addMark(trimmedFrom, trimmedTo, type.create({
                  ...mark2.attrs,
                  ...attributes
                }));
              }
            });
          } else {
            tr2.addMark(trimmedFrom, trimmedTo, type.create(attributes));
          }
        });
      });
    }
  }
  return canSetMark(state, tr2, type);
};
const setMeta = (key2, value) => ({ tr: tr2 }) => {
  tr2.setMeta(key2, value);
  return true;
};
const setNode = (typeOrName, attributes = {}) => ({ state, dispatch, chain }) => {
  const type = getNodeType(typeOrName, state.schema);
  let attributesToCopy;
  if (state.selection.$anchor.sameParent(state.selection.$head)) {
    attributesToCopy = state.selection.$anchor.parent.attrs;
  }
  if (!type.isTextblock) {
    console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.');
    return false;
  }
  return chain().command(({ commands: commands2 }) => {
    const canSetBlock = setBlockType(type, { ...attributesToCopy, ...attributes })(state);
    if (canSetBlock) {
      return true;
    }
    return commands2.clearNodes();
  }).command(({ state: updatedState }) => {
    return setBlockType(type, { ...attributesToCopy, ...attributes })(updatedState, dispatch);
  }).run();
};
const setNodeSelection = (position4) => ({ tr: tr2, dispatch }) => {
  if (dispatch) {
    const { doc: doc2 } = tr2;
    const from3 = minMax(position4, 0, doc2.content.size);
    const selection = NodeSelection.create(doc2, from3);
    tr2.setSelection(selection);
  }
  return true;
};
const setTextSelection = (position4) => ({ tr: tr2, dispatch }) => {
  if (dispatch) {
    const { doc: doc2 } = tr2;
    const { from: from3, to: to2 } = typeof position4 === "number" ? { from: position4, to: position4 } : position4;
    const minPos = TextSelection.atStart(doc2).from;
    const maxPos = TextSelection.atEnd(doc2).to;
    const resolvedFrom = minMax(from3, minPos, maxPos);
    const resolvedEnd = minMax(to2, minPos, maxPos);
    const selection = TextSelection.create(doc2, resolvedFrom, resolvedEnd);
    tr2.setSelection(selection);
  }
  return true;
};
const sinkListItem = (typeOrName) => ({ state, dispatch }) => {
  const type = getNodeType(typeOrName, state.schema);
  return sinkListItem$1(type)(state, dispatch);
};
function ensureMarks(state, splittableMarks) {
  const marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
  if (marks) {
    const filteredMarks = marks.filter((mark2) => splittableMarks === null || splittableMarks === void 0 ? void 0 : splittableMarks.includes(mark2.type.name));
    state.tr.ensureMarks(filteredMarks);
  }
}
const splitBlock = ({ keepMarks = true } = {}) => ({ tr: tr2, state, dispatch, editor }) => {
  const { selection, doc: doc2 } = tr2;
  const { $from, $to } = selection;
  const extensionAttributes = editor.extensionManager.attributes;
  const newAttributes = getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs);
  if (selection instanceof NodeSelection && selection.node.isBlock) {
    if (!$from.parentOffset || !canSplit(doc2, $from.pos)) {
      return false;
    }
    if (dispatch) {
      if (keepMarks) {
        ensureMarks(state, editor.extensionManager.splittableMarks);
      }
      tr2.split($from.pos).scrollIntoView();
    }
    return true;
  }
  if (!$from.parent.isBlock) {
    return false;
  }
  const atEnd = $to.parentOffset === $to.parent.content.size;
  const deflt = $from.depth === 0 ? void 0 : defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)));
  let types2 = atEnd && deflt ? [
    {
      type: deflt,
      attrs: newAttributes
    }
  ] : void 0;
  let can = canSplit(tr2.doc, tr2.mapping.map($from.pos), 1, types2);
  if (!types2 && !can && canSplit(tr2.doc, tr2.mapping.map($from.pos), 1, deflt ? [{ type: deflt }] : void 0)) {
    can = true;
    types2 = deflt ? [
      {
        type: deflt,
        attrs: newAttributes
      }
    ] : void 0;
  }
  if (dispatch) {
    if (can) {
      if (selection instanceof TextSelection) {
        tr2.deleteSelection();
      }
      tr2.split(tr2.mapping.map($from.pos), 1, types2);
      if (deflt && !atEnd && !$from.parentOffset && $from.parent.type !== deflt) {
        const first2 = tr2.mapping.map($from.before());
        const $first = tr2.doc.resolve(first2);
        if ($from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) {
          tr2.setNodeMarkup(tr2.mapping.map($from.before()), deflt);
        }
      }
    }
    if (keepMarks) {
      ensureMarks(state, editor.extensionManager.splittableMarks);
    }
    tr2.scrollIntoView();
  }
  return can;
};
const splitListItem = (typeOrName, overrideAttrs = {}) => ({ tr: tr2, state, dispatch, editor }) => {
  var _a3;
  const type = getNodeType(typeOrName, state.schema);
  const { $from, $to } = state.selection;
  const node2 = state.selection.node;
  if (node2 && node2.isBlock || $from.depth < 2 || !$from.sameParent($to)) {
    return false;
  }
  const grandParent = $from.node(-1);
  if (grandParent.type !== type) {
    return false;
  }
  const extensionAttributes = editor.extensionManager.attributes;
  if ($from.parent.content.size === 0 && $from.node(-1).childCount === $from.indexAfter(-1)) {
    if ($from.depth === 2 || $from.node(-3).type !== type || $from.index(-2) !== $from.node(-2).childCount - 1) {
      return false;
    }
    if (dispatch) {
      let wrap2 = Fragment.empty;
      const depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
      for (let d2 = $from.depth - depthBefore; d2 >= $from.depth - 3; d2 -= 1) {
        wrap2 = Fragment.from($from.node(d2).copy(wrap2));
      }
      const depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
      const newNextTypeAttributes2 = {
        ...getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs),
        ...overrideAttrs
      };
      const nextType2 = ((_a3 = type.contentMatch.defaultType) === null || _a3 === void 0 ? void 0 : _a3.createAndFill(newNextTypeAttributes2)) || void 0;
      wrap2 = wrap2.append(Fragment.from(type.createAndFill(null, nextType2) || void 0));
      const start4 = $from.before($from.depth - (depthBefore - 1));
      tr2.replace(start4, $from.after(-depthAfter), new Slice(wrap2, 4 - depthBefore, 0));
      let sel = -1;
      tr2.doc.nodesBetween(start4, tr2.doc.content.size, (n2, pos) => {
        if (sel > -1) {
          return false;
        }
        if (n2.isTextblock && n2.content.size === 0) {
          sel = pos + 1;
        }
      });
      if (sel > -1) {
        tr2.setSelection(TextSelection.near(tr2.doc.resolve(sel)));
      }
      tr2.scrollIntoView();
    }
    return true;
  }
  const nextType = $to.pos === $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
  const newTypeAttributes = {
    ...getSplittedAttributes(extensionAttributes, grandParent.type.name, grandParent.attrs),
    ...overrideAttrs
  };
  const newNextTypeAttributes = {
    ...getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs),
    ...overrideAttrs
  };
  tr2.delete($from.pos, $to.pos);
  const types2 = nextType ? [
    { type, attrs: newTypeAttributes },
    { type: nextType, attrs: newNextTypeAttributes }
  ] : [{ type, attrs: newTypeAttributes }];
  if (!canSplit(tr2.doc, $from.pos, 2)) {
    return false;
  }
  if (dispatch) {
    const { selection, storedMarks } = state;
    const { splittableMarks } = editor.extensionManager;
    const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
    tr2.split($from.pos, 2, types2).scrollIntoView();
    if (!marks || !dispatch) {
      return true;
    }
    const filteredMarks = marks.filter((mark2) => splittableMarks.includes(mark2.type.name));
    tr2.ensureMarks(filteredMarks);
  }
  return true;
};
const joinListBackwards = (tr2, listType) => {
  const list2 = findParentNode((node2) => node2.type === listType)(tr2.selection);
  if (!list2) {
    return true;
  }
  const before = tr2.doc.resolve(Math.max(0, list2.pos - 1)).before(list2.depth);
  if (before === void 0) {
    return true;
  }
  const nodeBefore = tr2.doc.nodeAt(before);
  const canJoinBackwards = list2.node.type === (nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.type) && canJoin(tr2.doc, list2.pos);
  if (!canJoinBackwards) {
    return true;
  }
  tr2.join(list2.pos);
  return true;
};
const joinListForwards = (tr2, listType) => {
  const list2 = findParentNode((node2) => node2.type === listType)(tr2.selection);
  if (!list2) {
    return true;
  }
  const after = tr2.doc.resolve(list2.start).after(list2.depth);
  if (after === void 0) {
    return true;
  }
  const nodeAfter = tr2.doc.nodeAt(after);
  const canJoinForwards = list2.node.type === (nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.type) && canJoin(tr2.doc, after);
  if (!canJoinForwards) {
    return true;
  }
  tr2.join(after);
  return true;
};
const toggleList = (listTypeOrName, itemTypeOrName, keepMarks, attributes = {}) => ({ editor, tr: tr2, state, dispatch, chain, commands: commands2, can }) => {
  const { extensions, splittableMarks } = editor.extensionManager;
  const listType = getNodeType(listTypeOrName, state.schema);
  const itemType = getNodeType(itemTypeOrName, state.schema);
  const { selection, storedMarks } = state;
  const { $from, $to } = selection;
  const range = $from.blockRange($to);
  const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
  if (!range) {
    return false;
  }
  const parentList = findParentNode((node2) => isList(node2.type.name, extensions))(selection);
  if (range.depth >= 1 && parentList && range.depth - parentList.depth <= 1) {
    if (parentList.node.type === listType) {
      return commands2.liftListItem(itemType);
    }
    if (isList(parentList.node.type.name, extensions) && listType.validContent(parentList.node.content) && dispatch) {
      return chain().command(() => {
        tr2.setNodeMarkup(parentList.pos, listType);
        return true;
      }).command(() => joinListBackwards(tr2, listType)).command(() => joinListForwards(tr2, listType)).run();
    }
  }
  if (!keepMarks || !marks || !dispatch) {
    return chain().command(() => {
      const canWrapInList = can().wrapInList(listType, attributes);
      if (canWrapInList) {
        return true;
      }
      return commands2.clearNodes();
    }).wrapInList(listType, attributes).command(() => joinListBackwards(tr2, listType)).command(() => joinListForwards(tr2, listType)).run();
  }
  return chain().command(() => {
    const canWrapInList = can().wrapInList(listType, attributes);
    const filteredMarks = marks.filter((mark2) => splittableMarks.includes(mark2.type.name));
    tr2.ensureMarks(filteredMarks);
    if (canWrapInList) {
      return true;
    }
    return commands2.clearNodes();
  }).wrapInList(listType, attributes).command(() => joinListBackwards(tr2, listType)).command(() => joinListForwards(tr2, listType)).run();
};
const toggleMark = (typeOrName, attributes = {}, options = {}) => ({ state, commands: commands2 }) => {
  const { extendEmptyMarkRange = false } = options;
  const type = getMarkType(typeOrName, state.schema);
  const isActive2 = isMarkActive(state, type, attributes);
  if (isActive2) {
    return commands2.unsetMark(type, { extendEmptyMarkRange });
  }
  return commands2.setMark(type, attributes);
};
const toggleNode = (typeOrName, toggleTypeOrName, attributes = {}) => ({ state, commands: commands2 }) => {
  const type = getNodeType(typeOrName, state.schema);
  const toggleType = getNodeType(toggleTypeOrName, state.schema);
  const isActive2 = isNodeActive(state, type, attributes);
  let attributesToCopy;
  if (state.selection.$anchor.sameParent(state.selection.$head)) {
    attributesToCopy = state.selection.$anchor.parent.attrs;
  }
  if (isActive2) {
    return commands2.setNode(toggleType, attributesToCopy);
  }
  return commands2.setNode(type, { ...attributesToCopy, ...attributes });
};
const toggleWrap = (typeOrName, attributes = {}) => ({ state, commands: commands2 }) => {
  const type = getNodeType(typeOrName, state.schema);
  const isActive2 = isNodeActive(state, type, attributes);
  if (isActive2) {
    return commands2.lift(type);
  }
  return commands2.wrapIn(type, attributes);
};
const undoInputRule = () => ({ state, dispatch }) => {
  const plugins = state.plugins;
  for (let i = 0; i < plugins.length; i += 1) {
    const plugin2 = plugins[i];
    let undoable;
    if (plugin2.spec.isInputRules && (undoable = plugin2.getState(state))) {
      if (dispatch) {
        const tr2 = state.tr;
        const toUndo = undoable.transform;
        for (let j2 = toUndo.steps.length - 1; j2 >= 0; j2 -= 1) {
          tr2.step(toUndo.steps[j2].invert(toUndo.docs[j2]));
        }
        if (undoable.text) {
          const marks = tr2.doc.resolve(undoable.from).marks();
          tr2.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks));
        } else {
          tr2.delete(undoable.from, undoable.to);
        }
      }
      return true;
    }
  }
  return false;
};
const unsetAllMarks = () => ({ tr: tr2, dispatch }) => {
  const { selection } = tr2;
  const { empty: empty2, ranges } = selection;
  if (empty2) {
    return true;
  }
  if (dispatch) {
    ranges.forEach((range) => {
      tr2.removeMark(range.$from.pos, range.$to.pos);
    });
  }
  return true;
};
const unsetMark = (typeOrName, options = {}) => ({ tr: tr2, state, dispatch }) => {
  var _a3;
  const { extendEmptyMarkRange = false } = options;
  const { selection } = tr2;
  const type = getMarkType(typeOrName, state.schema);
  const { $from, empty: empty2, ranges } = selection;
  if (!dispatch) {
    return true;
  }
  if (empty2 && extendEmptyMarkRange) {
    let { from: from3, to: to2 } = selection;
    const attrs = (_a3 = $from.marks().find((mark2) => mark2.type === type)) === null || _a3 === void 0 ? void 0 : _a3.attrs;
    const range = getMarkRange($from, type, attrs);
    if (range) {
      from3 = range.from;
      to2 = range.to;
    }
    tr2.removeMark(from3, to2, type);
  } else {
    ranges.forEach((range) => {
      tr2.removeMark(range.$from.pos, range.$to.pos, type);
    });
  }
  tr2.removeStoredMark(type);
  return true;
};
const updateAttributes = (typeOrName, attributes = {}) => ({ tr: tr2, state, dispatch }) => {
  let nodeType = null;
  let markType = null;
  const schemaType = getSchemaTypeNameByName(typeof typeOrName === "string" ? typeOrName : typeOrName.name, state.schema);
  if (!schemaType) {
    return false;
  }
  if (schemaType === "node") {
    nodeType = getNodeType(typeOrName, state.schema);
  }
  if (schemaType === "mark") {
    markType = getMarkType(typeOrName, state.schema);
  }
  if (dispatch) {
    tr2.selection.ranges.forEach((range) => {
      const from3 = range.$from.pos;
      const to2 = range.$to.pos;
      let lastPos;
      let lastNode;
      let trimmedFrom;
      let trimmedTo;
      if (tr2.selection.empty) {
        state.doc.nodesBetween(from3, to2, (node2, pos) => {
          if (nodeType && nodeType === node2.type) {
            trimmedFrom = Math.max(pos, from3);
            trimmedTo = Math.min(pos + node2.nodeSize, to2);
            lastPos = pos;
            lastNode = node2;
          }
        });
      } else {
        state.doc.nodesBetween(from3, to2, (node2, pos) => {
          if (pos < from3 && nodeType && nodeType === node2.type) {
            trimmedFrom = Math.max(pos, from3);
            trimmedTo = Math.min(pos + node2.nodeSize, to2);
            lastPos = pos;
            lastNode = node2;
          }
          if (pos >= from3 && pos <= to2) {
            if (nodeType && nodeType === node2.type) {
              tr2.setNodeMarkup(pos, void 0, {
                ...node2.attrs,
                ...attributes
              });
            }
            if (markType && node2.marks.length) {
              node2.marks.forEach((mark2) => {
                if (markType === mark2.type) {
                  const trimmedFrom2 = Math.max(pos, from3);
                  const trimmedTo2 = Math.min(pos + node2.nodeSize, to2);
                  tr2.addMark(trimmedFrom2, trimmedTo2, markType.create({
                    ...mark2.attrs,
                    ...attributes
                  }));
                }
              });
            }
          }
        });
      }
      if (lastNode) {
        if (lastPos !== void 0) {
          tr2.setNodeMarkup(lastPos, void 0, {
            ...lastNode.attrs,
            ...attributes
          });
        }
        if (markType && lastNode.marks.length) {
          lastNode.marks.forEach((mark2) => {
            if (markType === mark2.type) {
              tr2.addMark(trimmedFrom, trimmedTo, markType.create({
                ...mark2.attrs,
                ...attributes
              }));
            }
          });
        }
      }
    });
  }
  return true;
};
const wrapIn = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
  const type = getNodeType(typeOrName, state.schema);
  return wrapIn$1(type, attributes)(state, dispatch);
};
const wrapInList = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
  const type = getNodeType(typeOrName, state.schema);
  return wrapInList$1(type, attributes)(state, dispatch);
};
var commands = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur,
  clearContent,
  clearNodes,
  command,
  createParagraphNear,
  cut,
  deleteCurrentNode,
  deleteNode,
  deleteRange,
  deleteSelection,
  enter,
  exitCode,
  extendMarkRange,
  first,
  focus,
  forEach,
  insertContent,
  insertContentAt,
  joinBackward,
  joinDown,
  joinForward,
  joinItemBackward,
  joinItemForward,
  joinTextblockBackward,
  joinTextblockForward,
  joinUp,
  keyboardShortcut,
  lift: lift3,
  liftEmptyBlock,
  liftListItem,
  newlineInCode,
  resetAttributes,
  scrollIntoView,
  selectAll,
  selectNodeBackward,
  selectNodeForward,
  selectParentNode,
  selectTextblockEnd,
  selectTextblockStart,
  setContent,
  setMark,
  setMeta,
  setNode,
  setNodeSelection,
  setTextSelection,
  sinkListItem,
  splitBlock,
  splitListItem,
  toggleList,
  toggleMark,
  toggleNode,
  toggleWrap,
  undoInputRule,
  unsetAllMarks,
  unsetMark,
  updateAttributes,
  wrapIn,
  wrapInList
});
const Commands = Extension.create({
  name: "commands",
  addCommands() {
    return {
      ...commands
    };
  }
});
const Drop = Extension.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("tiptapDrop"),
        props: {
          handleDrop: (_2, e, slice3, moved) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: slice3,
              moved
            });
          }
        }
      })
    ];
  }
});
const Editable = Extension.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
});
const focusEventsPluginKey = new PluginKey("focusEvents");
const FocusEvents = Extension.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor } = this;
    return [
      new Plugin({
        key: focusEventsPluginKey,
        props: {
          handleDOMEvents: {
            focus: (view, event) => {
              editor.isFocused = true;
              const transaction = editor.state.tr.setMeta("focus", { event }).setMeta("addToHistory", false);
              view.dispatch(transaction);
              return false;
            },
            blur: (view, event) => {
              editor.isFocused = false;
              const transaction = editor.state.tr.setMeta("blur", { event }).setMeta("addToHistory", false);
              view.dispatch(transaction);
              return false;
            }
          }
        }
      })
    ];
  }
});
const Keymap = Extension.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const handleBackspace = () => this.editor.commands.first(({ commands: commands2 }) => [
      () => commands2.undoInputRule(),
      // maybe convert first text block node to default node
      () => commands2.command(({ tr: tr2 }) => {
        const { selection, doc: doc2 } = tr2;
        const { empty: empty2, $anchor } = selection;
        const { pos, parent: parent2 } = $anchor;
        const $parentPos = $anchor.parent.isTextblock && pos > 0 ? tr2.doc.resolve(pos - 1) : $anchor;
        const parentIsIsolating = $parentPos.parent.type.spec.isolating;
        const parentPos = $anchor.pos - $anchor.parentOffset;
        const isAtStart = parentIsIsolating && $parentPos.parent.childCount === 1 ? parentPos === $anchor.pos : Selection.atStart(doc2).from === pos;
        if (!empty2 || !parent2.type.isTextblock || parent2.textContent.length || !isAtStart || isAtStart && $anchor.parent.type.name === "paragraph") {
          return false;
        }
        return commands2.clearNodes();
      }),
      () => commands2.deleteSelection(),
      () => commands2.joinBackward(),
      () => commands2.selectNodeBackward()
    ]);
    const handleDelete2 = () => this.editor.commands.first(({ commands: commands2 }) => [
      () => commands2.deleteSelection(),
      () => commands2.deleteCurrentNode(),
      () => commands2.joinForward(),
      () => commands2.selectNodeForward()
    ]);
    const handleEnter = () => this.editor.commands.first(({ commands: commands2 }) => [
      () => commands2.newlineInCode(),
      () => commands2.createParagraphNear(),
      () => commands2.liftEmptyBlock(),
      () => commands2.splitBlock()
    ]);
    const baseKeymap = {
      Enter: handleEnter,
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: handleBackspace,
      "Mod-Backspace": handleBackspace,
      "Shift-Backspace": handleBackspace,
      Delete: handleDelete2,
      "Mod-Delete": handleDelete2,
      "Mod-a": () => this.editor.commands.selectAll()
    };
    const pcKeymap = {
      ...baseKeymap
    };
    const macKeymap = {
      ...baseKeymap,
      "Ctrl-h": handleBackspace,
      "Alt-Backspace": handleBackspace,
      "Ctrl-d": handleDelete2,
      "Ctrl-Alt-Backspace": handleDelete2,
      "Alt-Delete": handleDelete2,
      "Alt-d": handleDelete2,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    if (isiOS() || isMacOS()) {
      return macKeymap;
    }
    return pcKeymap;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Plugin({
        key: new PluginKey("clearDocument"),
        appendTransaction: (transactions, oldState, newState) => {
          if (transactions.some((tr3) => tr3.getMeta("composition"))) {
            return;
          }
          const docChanges = transactions.some((transaction) => transaction.docChanged) && !oldState.doc.eq(newState.doc);
          const ignoreTr = transactions.some((transaction) => transaction.getMeta("preventClearDocument"));
          if (!docChanges || ignoreTr) {
            return;
          }
          const { empty: empty2, from: from3, to: to2 } = oldState.selection;
          const allFrom = Selection.atStart(oldState.doc).from;
          const allEnd = Selection.atEnd(oldState.doc).to;
          const allWasSelected = from3 === allFrom && to2 === allEnd;
          if (empty2 || !allWasSelected) {
            return;
          }
          const isEmpty2 = isNodeEmpty(newState.doc);
          if (!isEmpty2) {
            return;
          }
          const tr2 = newState.tr;
          const state = createChainableState({
            state: newState,
            transaction: tr2
          });
          const { commands: commands2 } = new CommandManager({
            editor: this.editor,
            state
          });
          commands2.clearNodes();
          if (!tr2.steps.length) {
            return;
          }
          return tr2;
        }
      })
    ];
  }
});
const Paste = Extension.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("tiptapPaste"),
        props: {
          handlePaste: (_view, e, slice3) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: slice3
            });
          }
        }
      })
    ];
  }
});
const Tabindex = Extension.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class NodePos {
  get name() {
    return this.node.type.name;
  }
  constructor(pos, editor, isBlock = false, node2 = null) {
    this.currentNode = null;
    this.actualDepth = null;
    this.isBlock = isBlock;
    this.resolvedPos = pos;
    this.editor = editor;
    this.currentNode = node2;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var _a3;
    return (_a3 = this.actualDepth) !== null && _a3 !== void 0 ? _a3 : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(content2) {
    let from3 = this.from;
    let to2 = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      from3 = this.from + 1;
      to2 = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: from3, to: to2 }, content2);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    if (this.isBlock) {
      return this.pos;
    }
    return this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    if (this.isBlock) {
      return this.pos + this.size;
    }
    return this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0) {
      return null;
    }
    const parentPos = this.resolvedPos.start(this.resolvedPos.depth - 1);
    const $pos = this.resolvedPos.doc.resolve(parentPos);
    return new NodePos($pos, this.editor);
  }
  get before() {
    let $pos = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    if ($pos.depth !== this.depth) {
      $pos = this.resolvedPos.doc.resolve(this.from - 3);
    }
    return new NodePos($pos, this.editor);
  }
  get after() {
    let $pos = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    if ($pos.depth !== this.depth) {
      $pos = this.resolvedPos.doc.resolve(this.to + 3);
    }
    return new NodePos($pos, this.editor);
  }
  get children() {
    const children = [];
    this.node.content.forEach((node2, offset3) => {
      const isBlock = node2.isBlock && !node2.isTextblock;
      const isNonTextAtom = node2.isAtom && !node2.isText;
      const targetPos = this.pos + offset3 + (isNonTextAtom ? 0 : 1);
      if (targetPos < 0 || targetPos > this.resolvedPos.doc.nodeSize - 2) {
        return;
      }
      const $pos = this.resolvedPos.doc.resolve(targetPos);
      if (!isBlock && $pos.depth <= this.depth) {
        return;
      }
      const childNodePos = new NodePos($pos, this.editor, isBlock, isBlock ? node2 : null);
      if (isBlock) {
        childNodePos.actualDepth = this.depth + 1;
      }
      children.push(new NodePos($pos, this.editor, isBlock, isBlock ? node2 : null));
    });
    return children;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const children = this.children;
    return children[children.length - 1] || null;
  }
  closest(selector2, attributes = {}) {
    let node2 = null;
    let currentNode = this.parent;
    while (currentNode && !node2) {
      if (currentNode.node.type.name === selector2) {
        if (Object.keys(attributes).length > 0) {
          const nodeAttributes = currentNode.node.attrs;
          const attrKeys = Object.keys(attributes);
          for (let index2 = 0; index2 < attrKeys.length; index2 += 1) {
            const key2 = attrKeys[index2];
            if (nodeAttributes[key2] !== attributes[key2]) {
              break;
            }
          }
        } else {
          node2 = currentNode;
        }
      }
      currentNode = currentNode.parent;
    }
    return node2;
  }
  querySelector(selector2, attributes = {}) {
    return this.querySelectorAll(selector2, attributes, true)[0] || null;
  }
  querySelectorAll(selector2, attributes = {}, firstItemOnly = false) {
    let nodes = [];
    if (!this.children || this.children.length === 0) {
      return nodes;
    }
    const attrKeys = Object.keys(attributes);
    this.children.forEach((childPos) => {
      if (firstItemOnly && nodes.length > 0) {
        return;
      }
      if (childPos.node.type.name === selector2) {
        const doesAllAttributesMatch = attrKeys.every((key2) => attributes[key2] === childPos.node.attrs[key2]);
        if (doesAllAttributesMatch) {
          nodes.push(childPos);
        }
      }
      if (firstItemOnly && nodes.length > 0) {
        return;
      }
      nodes = nodes.concat(childPos.querySelectorAll(selector2, attributes, firstItemOnly));
    });
    return nodes;
  }
  setAttribute(attributes) {
    const { tr: tr2 } = this.editor.state;
    tr2.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...attributes
    });
    this.editor.view.dispatch(tr2);
  }
}
const style2 = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function createStyleTag(style3, nonce, suffix2) {
  const tiptapStyleTag = document.querySelector(`style[data-tiptap-style${""}]`);
  if (tiptapStyleTag !== null) {
    return tiptapStyleTag;
  }
  const styleNode = document.createElement("style");
  if (nonce) {
    styleNode.setAttribute("nonce", nonce);
  }
  styleNode.setAttribute(`data-tiptap-style${""}`, "");
  styleNode.innerHTML = style3;
  document.getElementsByTagName("head")[0].appendChild(styleNode);
  return styleNode;
}
class Editor extends EventEmitter2 {
  constructor(options = {}) {
    super();
    this.isFocused = false;
    this.isInitialized = false;
    this.extensionStorage = {};
    this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: true,
      injectNonce: void 0,
      extensions: [],
      autofocus: false,
      editable: true,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: true,
      enablePasteRules: true,
      enableCoreExtensions: true,
      enableContentCheck: false,
      emitContentError: false,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: error2 }) => {
        throw error2;
      },
      onPaste: () => null,
      onDrop: () => null
    };
    this.isCapturingTransaction = false;
    this.capturedTransaction = null;
    this.setOptions(options);
    this.createExtensionManager();
    this.createCommandManager();
    this.createSchema();
    this.on("beforeCreate", this.options.onBeforeCreate);
    this.emit("beforeCreate", { editor: this });
    this.on("contentError", this.options.onContentError);
    this.createView();
    this.injectCSS();
    this.on("create", this.options.onCreate);
    this.on("update", this.options.onUpdate);
    this.on("selectionUpdate", this.options.onSelectionUpdate);
    this.on("transaction", this.options.onTransaction);
    this.on("focus", this.options.onFocus);
    this.on("blur", this.options.onBlur);
    this.on("destroy", this.options.onDestroy);
    this.on("drop", ({ event, slice: slice3, moved }) => this.options.onDrop(event, slice3, moved));
    this.on("paste", ({ event, slice: slice3 }) => this.options.onPaste(event, slice3));
    window.setTimeout(() => {
      if (this.isDestroyed) {
        return;
      }
      this.commands.focus(this.options.autofocus);
      this.emit("create", { editor: this });
      this.isInitialized = true;
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    if (this.options.injectCSS && document) {
      this.css = createStyleTag(style2, this.options.injectNonce);
    }
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(options = {}) {
    this.options = {
      ...this.options,
      ...options
    };
    if (!this.view || !this.state || this.isDestroyed) {
      return;
    }
    if (this.options.editorProps) {
      this.view.setProps(this.options.editorProps);
    }
    this.view.updateState(this.state);
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(editable, emitUpdate = true) {
    this.setOptions({ editable });
    if (emitUpdate) {
      this.emit("update", { editor: this, transaction: this.state.tr });
    }
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(plugin2, handlePlugins) {
    const plugins = isFunction(handlePlugins) ? handlePlugins(plugin2, [...this.state.plugins]) : [...this.state.plugins, plugin2];
    const state = this.state.reconfigure({ plugins });
    this.view.updateState(state);
    return state;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(nameOrPluginKeyToRemove) {
    if (this.isDestroyed) {
      return void 0;
    }
    const prevPlugins = this.state.plugins;
    let plugins = prevPlugins;
    [].concat(nameOrPluginKeyToRemove).forEach((nameOrPluginKey) => {
      const name2 = typeof nameOrPluginKey === "string" ? `${nameOrPluginKey}$` : nameOrPluginKey.key;
      plugins = plugins.filter((plugin2) => !plugin2.key.startsWith(name2));
    });
    if (prevPlugins.length === plugins.length) {
      return void 0;
    }
    const state = this.state.reconfigure({
      plugins
    });
    this.view.updateState(state);
    return state;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var _a3, _b;
    const coreExtensions = this.options.enableCoreExtensions ? [
      Editable,
      ClipboardTextSerializer.configure({
        blockSeparator: (_b = (_a3 = this.options.coreExtensionOptions) === null || _a3 === void 0 ? void 0 : _a3.clipboardTextSerializer) === null || _b === void 0 ? void 0 : _b.blockSeparator
      }),
      Commands,
      FocusEvents,
      Keymap,
      Tabindex,
      Drop,
      Paste
    ].filter((ext) => {
      if (typeof this.options.enableCoreExtensions === "object") {
        return this.options.enableCoreExtensions[ext.name] !== false;
      }
      return true;
    }) : [];
    const allExtensions = [...coreExtensions, ...this.options.extensions].filter((extension2) => {
      return ["extension", "node", "mark"].includes(extension2 === null || extension2 === void 0 ? void 0 : extension2.type);
    });
    this.extensionManager = new ExtensionManager(allExtensions, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new CommandManager({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    var _a3;
    let doc2;
    try {
      doc2 = createDocument(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (e) {
      if (!(e instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(e.message)) {
        throw e;
      }
      this.emit("contentError", {
        editor: this,
        error: e,
        disableCollaboration: () => {
          if (this.storage.collaboration) {
            this.storage.collaboration.isDisabled = true;
          }
          this.options.extensions = this.options.extensions.filter((extension2) => extension2.name !== "collaboration");
          this.createExtensionManager();
        }
      });
      doc2 = createDocument(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: false });
    }
    const selection = resolveFocusPosition(doc2, this.options.autofocus);
    this.view = new EditorView(this.options.element, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(_a3 = this.options.editorProps) === null || _a3 === void 0 ? void 0 : _a3.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: EditorState.create({
        doc: doc2,
        selection: selection || void 0
      })
    });
    const newState = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(newState);
    this.createNodeViews();
    this.prependClass();
    const dom = this.view.dom;
    dom.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    if (this.view.isDestroyed) {
      return;
    }
    this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(fn2) {
    this.isCapturingTransaction = true;
    fn2();
    this.isCapturingTransaction = false;
    const tr2 = this.capturedTransaction;
    this.capturedTransaction = null;
    return tr2;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(transaction) {
    if (this.view.isDestroyed) {
      return;
    }
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = transaction;
        return;
      }
      transaction.steps.forEach((step) => {
        var _a3;
        return (_a3 = this.capturedTransaction) === null || _a3 === void 0 ? void 0 : _a3.step(step);
      });
      return;
    }
    const state = this.state.apply(transaction);
    const selectionHasChanged = !this.state.selection.eq(state.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction,
      nextState: state
    });
    this.view.updateState(state);
    this.emit("transaction", {
      editor: this,
      transaction
    });
    if (selectionHasChanged) {
      this.emit("selectionUpdate", {
        editor: this,
        transaction
      });
    }
    const focus2 = transaction.getMeta("focus");
    const blur2 = transaction.getMeta("blur");
    if (focus2) {
      this.emit("focus", {
        editor: this,
        event: focus2.event,
        transaction
      });
    }
    if (blur2) {
      this.emit("blur", {
        editor: this,
        event: blur2.event,
        transaction
      });
    }
    if (!transaction.docChanged || transaction.getMeta("preventUpdate")) {
      return;
    }
    this.emit("update", {
      editor: this,
      transaction
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(nameOrType) {
    return getAttributes(this.state, nameOrType);
  }
  isActive(nameOrAttributes, attributesOrUndefined) {
    const name2 = typeof nameOrAttributes === "string" ? nameOrAttributes : null;
    const attributes = typeof nameOrAttributes === "string" ? attributesOrUndefined : nameOrAttributes;
    return isActive(this.state, name2, attributes);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return getHTMLFromFragment(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(options) {
    const { blockSeparator = "\n\n", textSerializers = {} } = options || {};
    return getText(this.state.doc, {
      blockSeparator,
      textSerializers: {
        ...getTextSerializersFromSchema(this.schema),
        ...textSerializers
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return isNodeEmpty(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.');
    return this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.emit("destroy");
    if (this.view) {
      const dom = this.view.dom;
      if (dom && dom.editor) {
        delete dom.editor;
      }
      this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var _a3;
    return !((_a3 = this.view) === null || _a3 === void 0 ? void 0 : _a3.docView);
  }
  $node(selector2, attributes) {
    var _a3;
    return ((_a3 = this.$doc) === null || _a3 === void 0 ? void 0 : _a3.querySelector(selector2, attributes)) || null;
  }
  $nodes(selector2, attributes) {
    var _a3;
    return ((_a3 = this.$doc) === null || _a3 === void 0 ? void 0 : _a3.querySelectorAll(selector2, attributes)) || null;
  }
  $pos(pos) {
    const $pos = this.state.doc.resolve(pos);
    return new NodePos($pos, this);
  }
  get $doc() {
    return this.$pos(0);
  }
}
function markInputRule(config2) {
  return new InputRule({
    find: config2.find,
    handler: ({ state, range, match: match5 }) => {
      const attributes = callOrReturn(config2.getAttributes, void 0, match5);
      if (attributes === false || attributes === null) {
        return null;
      }
      const { tr: tr2 } = state;
      const captureGroup = match5[match5.length - 1];
      const fullMatch = match5[0];
      if (captureGroup) {
        const startSpaces = fullMatch.search(/\S/);
        const textStart = range.from + fullMatch.indexOf(captureGroup);
        const textEnd = textStart + captureGroup.length;
        const excludedMarks = getMarksBetween(range.from, range.to, state.doc).filter((item) => {
          const excluded = item.mark.type.excluded;
          return excluded.find((type) => type === config2.type && type !== item.mark.type);
        }).filter((item) => item.to > textStart);
        if (excludedMarks.length) {
          return null;
        }
        if (textEnd < range.to) {
          tr2.delete(textEnd, range.to);
        }
        if (textStart > range.from) {
          tr2.delete(range.from + startSpaces, textStart);
        }
        const markEnd = range.from + startSpaces + captureGroup.length;
        tr2.addMark(range.from + startSpaces, markEnd, config2.type.create(attributes || {}));
        tr2.removeStoredMark(config2.type);
      }
    }
  });
}
function nodeInputRule(config2) {
  return new InputRule({
    find: config2.find,
    handler: ({ state, range, match: match5 }) => {
      const attributes = callOrReturn(config2.getAttributes, void 0, match5) || {};
      const { tr: tr2 } = state;
      const start4 = range.from;
      let end2 = range.to;
      const newNode = config2.type.create(attributes);
      if (match5[1]) {
        const offset3 = match5[0].lastIndexOf(match5[1]);
        let matchStart = start4 + offset3;
        if (matchStart > end2) {
          matchStart = end2;
        } else {
          end2 = matchStart + match5[1].length;
        }
        const lastChar = match5[0][match5[0].length - 1];
        tr2.insertText(lastChar, start4 + match5[0].length - 1);
        tr2.replaceWith(matchStart, end2, newNode);
      } else if (match5[0]) {
        const insertionStart = config2.type.isInline ? start4 : start4 - 1;
        tr2.insert(insertionStart, config2.type.create(attributes)).delete(tr2.mapping.map(start4), tr2.mapping.map(end2));
      }
      tr2.scrollIntoView();
    }
  });
}
function textblockTypeInputRule(config2) {
  return new InputRule({
    find: config2.find,
    handler: ({ state, range, match: match5 }) => {
      const $start = state.doc.resolve(range.from);
      const attributes = callOrReturn(config2.getAttributes, void 0, match5) || {};
      if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), config2.type)) {
        return null;
      }
      state.tr.delete(range.from, range.to).setBlockType(range.from, range.from, config2.type, attributes);
    }
  });
}
function wrappingInputRule(config2) {
  return new InputRule({
    find: config2.find,
    handler: ({ state, range, match: match5, chain }) => {
      const attributes = callOrReturn(config2.getAttributes, void 0, match5) || {};
      const tr2 = state.tr.delete(range.from, range.to);
      const $start = tr2.doc.resolve(range.from);
      const blockRange = $start.blockRange();
      const wrapping = blockRange && findWrapping(blockRange, config2.type, attributes);
      if (!wrapping) {
        return null;
      }
      tr2.wrap(blockRange, wrapping);
      if (config2.keepMarks && config2.editor) {
        const { selection, storedMarks } = state;
        const { splittableMarks } = config2.editor.extensionManager;
        const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
        if (marks) {
          const filteredMarks = marks.filter((mark2) => splittableMarks.includes(mark2.type.name));
          tr2.ensureMarks(filteredMarks);
        }
      }
      if (config2.keepAttributes) {
        const nodeType = config2.type.name === "bulletList" || config2.type.name === "orderedList" ? "listItem" : "taskList";
        chain().updateAttributes(nodeType, attributes).run();
      }
      const before = tr2.doc.resolve(range.from - 1).nodeBefore;
      if (before && before.type === config2.type && canJoin(tr2.doc, range.from - 1) && (!config2.joinPredicate || config2.joinPredicate(match5, before))) {
        tr2.join(range.from - 1);
      }
    }
  });
}
let Node$1 = class Node3 {
  constructor(config2 = {}) {
    this.type = "node";
    this.name = "node";
    this.parent = null;
    this.child = null;
    this.config = {
      name: this.name,
      defaultOptions: {}
    };
    this.config = {
      ...this.config,
      ...config2
    };
    this.name = this.config.name;
    if (config2.defaultOptions && Object.keys(config2.defaultOptions).length > 0) {
      console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
    }
    this.options = this.config.defaultOptions;
    if (this.config.addOptions) {
      this.options = callOrReturn(getExtensionField(this, "addOptions", {
        name: this.name
      }));
    }
    this.storage = callOrReturn(getExtensionField(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(config2 = {}) {
    return new Node3(config2);
  }
  configure(options = {}) {
    const extension2 = this.extend({
      ...this.config,
      addOptions: () => {
        return mergeDeep(this.options, options);
      }
    });
    extension2.name = this.name;
    extension2.parent = this.parent;
    return extension2;
  }
  extend(extendedConfig = {}) {
    const extension2 = new Node3(extendedConfig);
    extension2.parent = this;
    this.child = extension2;
    extension2.name = extendedConfig.name ? extendedConfig.name : extension2.parent.name;
    if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) {
      console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension2.name}".`);
    }
    extension2.options = callOrReturn(getExtensionField(extension2, "addOptions", {
      name: extension2.name
    }));
    extension2.storage = callOrReturn(getExtensionField(extension2, "addStorage", {
      name: extension2.name,
      options: extension2.options
    }));
    return extension2;
  }
};
function markPasteRule(config2) {
  return new PasteRule({
    find: config2.find,
    handler: ({ state, range, match: match5, pasteEvent }) => {
      const attributes = callOrReturn(config2.getAttributes, void 0, match5, pasteEvent);
      if (attributes === false || attributes === null) {
        return null;
      }
      const { tr: tr2 } = state;
      const captureGroup = match5[match5.length - 1];
      const fullMatch = match5[0];
      let markEnd = range.to;
      if (captureGroup) {
        const startSpaces = fullMatch.search(/\S/);
        const textStart = range.from + fullMatch.indexOf(captureGroup);
        const textEnd = textStart + captureGroup.length;
        const excludedMarks = getMarksBetween(range.from, range.to, state.doc).filter((item) => {
          const excluded = item.mark.type.excluded;
          return excluded.find((type) => type === config2.type && type !== item.mark.type);
        }).filter((item) => item.to > textStart);
        if (excludedMarks.length) {
          return null;
        }
        if (textEnd < range.to) {
          tr2.delete(textEnd, range.to);
        }
        if (textStart > range.from) {
          tr2.delete(range.from + startSpaces, textStart);
        }
        markEnd = range.from + startSpaces + captureGroup.length;
        tr2.addMark(range.from + startSpaces, markEnd, config2.type.create(attributes || {}));
        tr2.removeStoredMark(config2.type);
      }
    }
  });
}
function canInsertNode(state, nodeType) {
  const { selection } = state;
  const { $from } = selection;
  if (selection instanceof NodeSelection) {
    const index2 = $from.index();
    const parent2 = $from.parent;
    return parent2.canReplaceWith(index2, index2 + 1, nodeType);
  }
  let depth = $from.depth;
  while (depth >= 0) {
    const index2 = $from.index(depth);
    const parent2 = $from.node(depth);
    const match5 = parent2.contentMatchAt(index2);
    if (match5.matchType(nodeType)) {
      return true;
    }
    depth -= 1;
  }
  return false;
}
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var shim = { exports: {} };
var useSyncExternalStoreShim_production_min = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production_min;
function requireUseSyncExternalStoreShim_production_min() {
  if (hasRequiredUseSyncExternalStoreShim_production_min) return useSyncExternalStoreShim_production_min;
  hasRequiredUseSyncExternalStoreShim_production_min = 1;
  var e = React__default;
  function h2(a2, b2) {
    return a2 === b2 && (0 !== a2 || 1 / a2 === 1 / b2) || a2 !== a2 && b2 !== b2;
  }
  var k2 = "function" === typeof Object.is ? Object.is : h2, l2 = e.useState, m2 = e.useEffect, n2 = e.useLayoutEffect, p2 = e.useDebugValue;
  function q2(a2, b2) {
    var d2 = b2(), f2 = l2({ inst: { value: d2, getSnapshot: b2 } }), c2 = f2[0].inst, g2 = f2[1];
    n2(function() {
      c2.value = d2;
      c2.getSnapshot = b2;
      r2(c2) && g2({ inst: c2 });
    }, [a2, d2, b2]);
    m2(function() {
      r2(c2) && g2({ inst: c2 });
      return a2(function() {
        r2(c2) && g2({ inst: c2 });
      });
    }, [a2]);
    p2(d2);
    return d2;
  }
  function r2(a2) {
    var b2 = a2.getSnapshot;
    a2 = a2.value;
    try {
      var d2 = b2();
      return !k2(a2, d2);
    } catch (f2) {
      return true;
    }
  }
  function t2(a2, b2) {
    return b2();
  }
  var u2 = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? t2 : q2;
  useSyncExternalStoreShim_production_min.useSyncExternalStore = void 0 !== e.useSyncExternalStore ? e.useSyncExternalStore : u2;
  return useSyncExternalStoreShim_production_min;
}
var useSyncExternalStoreShim_development = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  if (hasRequiredUseSyncExternalStoreShim_development) return useSyncExternalStoreShim_development;
  hasRequiredUseSyncExternalStoreShim_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }
      var React$1 = React__default;
      var ReactSharedInternals = React$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error2(format2) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format2, args);
          }
        }
      }
      function printWarning(level, format2, args) {
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum();
          if (stack !== "") {
            format2 += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format2);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      function is2(x2, y2) {
        return x2 === y2 && (x2 !== 0 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
      }
      var objectIs = typeof Object.is === "function" ? Object.is : is2;
      var useState2 = React$1.useState, useEffect2 = React$1.useEffect, useLayoutEffect2 = React$1.useLayoutEffect, useDebugValue2 = React$1.useDebugValue;
      var didWarnOld18Alpha = false;
      var didWarnUncachedGetSnapshot = false;
      function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        {
          if (!didWarnOld18Alpha) {
            if (React$1.startTransition !== void 0) {
              didWarnOld18Alpha = true;
              error2("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release.");
            }
          }
        }
        var value = getSnapshot();
        {
          if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            if (!objectIs(value, cachedValue)) {
              error2("The result of getSnapshot should be cached to avoid an infinite loop");
              didWarnUncachedGetSnapshot = true;
            }
          }
        }
        var _useState = useState2({
          inst: {
            value,
            getSnapshot
          }
        }), inst = _useState[0].inst, forceUpdate = _useState[1];
        useLayoutEffect2(function() {
          inst.value = value;
          inst.getSnapshot = getSnapshot;
          if (checkIfSnapshotChanged(inst)) {
            forceUpdate({
              inst
            });
          }
        }, [subscribe, value, getSnapshot]);
        useEffect2(function() {
          if (checkIfSnapshotChanged(inst)) {
            forceUpdate({
              inst
            });
          }
          var handleStoreChange = function() {
            if (checkIfSnapshotChanged(inst)) {
              forceUpdate({
                inst
              });
            }
          };
          return subscribe(handleStoreChange);
        }, [subscribe]);
        useDebugValue2(value);
        return value;
      }
      function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
          var nextValue = latestGetSnapshot();
          return !objectIs(prevValue, nextValue);
        } catch (error3) {
          return true;
        }
      }
      function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
        return getSnapshot();
      }
      var canUseDOM2 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
      var isServerEnvironment = !canUseDOM2;
      var shim2 = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore;
      var useSyncExternalStore$2 = React$1.useSyncExternalStore !== void 0 ? React$1.useSyncExternalStore : shim2;
      useSyncExternalStoreShim_development.useSyncExternalStore = useSyncExternalStore$2;
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
  return useSyncExternalStoreShim_development;
}
if (process.env.NODE_ENV === "production") {
  shim.exports = requireUseSyncExternalStoreShim_production_min();
} else {
  shim.exports = requireUseSyncExternalStoreShim_development();
}
var shimExports = shim.exports;
const mergeRefs = (...refs) => {
  return (node2) => {
    refs.forEach((ref2) => {
      if (typeof ref2 === "function") {
        ref2(node2);
      } else if (ref2) {
        ref2.current = node2;
      }
    });
  };
};
const Portals = ({ contentComponent }) => {
  const renderers = shimExports.useSyncExternalStore(contentComponent.subscribe, contentComponent.getSnapshot, contentComponent.getServerSnapshot);
  return React__default.createElement(React__default.Fragment, null, Object.values(renderers));
};
function getInstance() {
  const subscribers = /* @__PURE__ */ new Set();
  let renderers = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(callback) {
      subscribers.add(callback);
      return () => {
        subscribers.delete(callback);
      };
    },
    getSnapshot() {
      return renderers;
    },
    getServerSnapshot() {
      return renderers;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(id, renderer) {
      renderers = {
        ...renderers,
        [id]: ReactDOM__default.createPortal(renderer.reactElement, renderer.element, id)
      };
      subscribers.forEach((subscriber) => subscriber());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(id) {
      const nextRenderers = { ...renderers };
      delete nextRenderers[id];
      renderers = nextRenderers;
      subscribers.forEach((subscriber) => subscriber());
    }
  };
}
class PureEditorContent extends React__default.Component {
  constructor(props) {
    var _a3;
    super(props);
    this.editorContentRef = React__default.createRef();
    this.initialized = false;
    this.state = {
      hasContentComponentInitialized: Boolean((_a3 = props.editor) === null || _a3 === void 0 ? void 0 : _a3.contentComponent)
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const editor = this.props.editor;
    if (editor && !editor.isDestroyed && editor.options.element) {
      if (editor.contentComponent) {
        return;
      }
      const element2 = this.editorContentRef.current;
      element2.append(...editor.options.element.childNodes);
      editor.setOptions({
        element: element2
      });
      editor.contentComponent = getInstance();
      if (!this.state.hasContentComponentInitialized) {
        this.unsubscribeToContentComponent = editor.contentComponent.subscribe(() => {
          this.setState((prevState) => {
            if (!prevState.hasContentComponentInitialized) {
              return {
                hasContentComponentInitialized: true
              };
            }
            return prevState;
          });
          if (this.unsubscribeToContentComponent) {
            this.unsubscribeToContentComponent();
          }
        });
      }
      editor.createNodeViews();
      this.initialized = true;
    }
  }
  componentWillUnmount() {
    const editor = this.props.editor;
    if (!editor) {
      return;
    }
    this.initialized = false;
    if (!editor.isDestroyed) {
      editor.view.setProps({
        nodeViews: {}
      });
    }
    if (this.unsubscribeToContentComponent) {
      this.unsubscribeToContentComponent();
    }
    editor.contentComponent = null;
    if (!editor.options.element.firstChild) {
      return;
    }
    const newElement = document.createElement("div");
    newElement.append(...editor.options.element.childNodes);
    editor.setOptions({
      element: newElement
    });
  }
  render() {
    const { editor, innerRef, ...rest } = this.props;
    return React__default.createElement(
      React__default.Fragment,
      null,
      React__default.createElement("div", { ref: mergeRefs(innerRef, this.editorContentRef), ...rest }),
      (editor === null || editor === void 0 ? void 0 : editor.contentComponent) && React__default.createElement(Portals, { contentComponent: editor.contentComponent })
    );
  }
}
const EditorContentWithKey = forwardRef$1((props, ref2) => {
  const key2 = React__default.useMemo(() => {
    return Math.floor(Math.random() * 4294967295).toString();
  }, [props.editor]);
  return React__default.createElement(PureEditorContent, {
    key: key2,
    innerRef: ref2,
    ...props
  });
});
const EditorContent = React__default.memo(EditorContentWithKey);
var react = function equal(a2, b2) {
  if (a2 === b2) return true;
  if (a2 && b2 && typeof a2 == "object" && typeof b2 == "object") {
    if (a2.constructor !== b2.constructor) return false;
    var length2, i, keys2;
    if (Array.isArray(a2)) {
      length2 = a2.length;
      if (length2 != b2.length) return false;
      for (i = length2; i-- !== 0; )
        if (!equal(a2[i], b2[i])) return false;
      return true;
    }
    if (a2 instanceof Map && b2 instanceof Map) {
      if (a2.size !== b2.size) return false;
      for (i of a2.entries())
        if (!b2.has(i[0])) return false;
      for (i of a2.entries())
        if (!equal(i[1], b2.get(i[0]))) return false;
      return true;
    }
    if (a2 instanceof Set && b2 instanceof Set) {
      if (a2.size !== b2.size) return false;
      for (i of a2.entries())
        if (!b2.has(i[0])) return false;
      return true;
    }
    if (ArrayBuffer.isView(a2) && ArrayBuffer.isView(b2)) {
      length2 = a2.length;
      if (length2 != b2.length) return false;
      for (i = length2; i-- !== 0; )
        if (a2[i] !== b2[i]) return false;
      return true;
    }
    if (a2.constructor === RegExp) return a2.source === b2.source && a2.flags === b2.flags;
    if (a2.valueOf !== Object.prototype.valueOf) return a2.valueOf() === b2.valueOf();
    if (a2.toString !== Object.prototype.toString) return a2.toString() === b2.toString();
    keys2 = Object.keys(a2);
    length2 = keys2.length;
    if (length2 !== Object.keys(b2).length) return false;
    for (i = length2; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b2, keys2[i])) return false;
    for (i = length2; i-- !== 0; ) {
      var key2 = keys2[i];
      if (key2 === "_owner" && a2.$$typeof) {
        continue;
      }
      if (!equal(a2[key2], b2[key2])) return false;
    }
    return true;
  }
  return a2 !== a2 && b2 !== b2;
};
var deepEqual = /* @__PURE__ */ getDefaultExportFromCjs(react);
var withSelector = { exports: {} };
var withSelector_production_min = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_production_min;
function requireWithSelector_production_min() {
  if (hasRequiredWithSelector_production_min) return withSelector_production_min;
  hasRequiredWithSelector_production_min = 1;
  var h2 = React__default, n2 = shimExports;
  function p2(a2, b2) {
    return a2 === b2 && (0 !== a2 || 1 / a2 === 1 / b2) || a2 !== a2 && b2 !== b2;
  }
  var q2 = "function" === typeof Object.is ? Object.is : p2, r2 = n2.useSyncExternalStore, t2 = h2.useRef, u2 = h2.useEffect, v2 = h2.useMemo, w2 = h2.useDebugValue;
  withSelector_production_min.useSyncExternalStoreWithSelector = function(a2, b2, e, l2, g2) {
    var c2 = t2(null);
    if (null === c2.current) {
      var f2 = { hasValue: false, value: null };
      c2.current = f2;
    } else f2 = c2.current;
    c2 = v2(function() {
      function a3(a4) {
        if (!c3) {
          c3 = true;
          d3 = a4;
          a4 = l2(a4);
          if (void 0 !== g2 && f2.hasValue) {
            var b3 = f2.value;
            if (g2(b3, a4)) return k2 = b3;
          }
          return k2 = a4;
        }
        b3 = k2;
        if (q2(d3, a4)) return b3;
        var e2 = l2(a4);
        if (void 0 !== g2 && g2(b3, e2)) return b3;
        d3 = a4;
        return k2 = e2;
      }
      var c3 = false, d3, k2, m2 = void 0 === e ? null : e;
      return [function() {
        return a3(b2());
      }, null === m2 ? void 0 : function() {
        return a3(m2());
      }];
    }, [b2, e, l2, g2]);
    var d2 = r2(a2, c2[0], c2[1]);
    u2(function() {
      f2.hasValue = true;
      f2.value = d2;
    }, [d2]);
    w2(d2);
    return d2;
  };
  return withSelector_production_min;
}
var withSelector_development = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_development;
function requireWithSelector_development() {
  if (hasRequiredWithSelector_development) return withSelector_development;
  hasRequiredWithSelector_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }
      var React$1 = React__default;
      var shim2 = shimExports;
      function is2(x2, y2) {
        return x2 === y2 && (x2 !== 0 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
      }
      var objectIs = typeof Object.is === "function" ? Object.is : is2;
      var useSyncExternalStore = shim2.useSyncExternalStore;
      var useRef2 = React$1.useRef, useEffect2 = React$1.useEffect, useMemo2 = React$1.useMemo, useDebugValue2 = React$1.useDebugValue;
      function useSyncExternalStoreWithSelector(subscribe, getSnapshot, getServerSnapshot, selector2, isEqual7) {
        var instRef = useRef2(null);
        var inst;
        if (instRef.current === null) {
          inst = {
            hasValue: false,
            value: null
          };
          instRef.current = inst;
        } else {
          inst = instRef.current;
        }
        var _useMemo = useMemo2(function() {
          var hasMemo = false;
          var memoizedSnapshot;
          var memoizedSelection;
          var memoizedSelector = function(nextSnapshot) {
            if (!hasMemo) {
              hasMemo = true;
              memoizedSnapshot = nextSnapshot;
              var _nextSelection = selector2(nextSnapshot);
              if (isEqual7 !== void 0) {
                if (inst.hasValue) {
                  var currentSelection = inst.value;
                  if (isEqual7(currentSelection, _nextSelection)) {
                    memoizedSelection = currentSelection;
                    return currentSelection;
                  }
                }
              }
              memoizedSelection = _nextSelection;
              return _nextSelection;
            }
            var prevSnapshot = memoizedSnapshot;
            var prevSelection = memoizedSelection;
            if (objectIs(prevSnapshot, nextSnapshot)) {
              return prevSelection;
            }
            var nextSelection = selector2(nextSnapshot);
            if (isEqual7 !== void 0 && isEqual7(prevSelection, nextSelection)) {
              return prevSelection;
            }
            memoizedSnapshot = nextSnapshot;
            memoizedSelection = nextSelection;
            return nextSelection;
          };
          var maybeGetServerSnapshot = getServerSnapshot === void 0 ? null : getServerSnapshot;
          var getSnapshotWithSelector = function() {
            return memoizedSelector(getSnapshot());
          };
          var getServerSnapshotWithSelector = maybeGetServerSnapshot === null ? void 0 : function() {
            return memoizedSelector(maybeGetServerSnapshot());
          };
          return [getSnapshotWithSelector, getServerSnapshotWithSelector];
        }, [getSnapshot, getServerSnapshot, selector2, isEqual7]), getSelection2 = _useMemo[0], getServerSelection = _useMemo[1];
        var value = useSyncExternalStore(subscribe, getSelection2, getServerSelection);
        useEffect2(function() {
          inst.hasValue = true;
          inst.value = value;
        }, [value]);
        useDebugValue2(value);
        return value;
      }
      withSelector_development.useSyncExternalStoreWithSelector = useSyncExternalStoreWithSelector;
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
  return withSelector_development;
}
if (process.env.NODE_ENV === "production") {
  withSelector.exports = requireWithSelector_production_min();
} else {
  withSelector.exports = requireWithSelector_development();
}
var withSelectorExports = withSelector.exports;
const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
class EditorStateManager {
  constructor(initialEditor) {
    this.transactionNumber = 0;
    this.lastTransactionNumber = 0;
    this.subscribers = /* @__PURE__ */ new Set();
    this.editor = initialEditor;
    this.lastSnapshot = { editor: initialEditor, transactionNumber: 0 };
    this.getSnapshot = this.getSnapshot.bind(this);
    this.getServerSnapshot = this.getServerSnapshot.bind(this);
    this.watch = this.watch.bind(this);
    this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    if (this.transactionNumber === this.lastTransactionNumber) {
      return this.lastSnapshot;
    }
    this.lastTransactionNumber = this.transactionNumber;
    this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber };
    return this.lastSnapshot;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(callback) {
    this.subscribers.add(callback);
    return () => {
      this.subscribers.delete(callback);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(nextEditor) {
    this.editor = nextEditor;
    if (this.editor) {
      const fn2 = () => {
        this.transactionNumber += 1;
        this.subscribers.forEach((callback) => callback());
      };
      const currentEditor = this.editor;
      currentEditor.on("transaction", fn2);
      return () => {
        currentEditor.off("transaction", fn2);
      };
    }
    return void 0;
  }
}
function useEditorState(options) {
  var _a3;
  const [editorStateManager] = useState(() => new EditorStateManager(options.editor));
  const selectedState = withSelectorExports.useSyncExternalStoreWithSelector(editorStateManager.subscribe, editorStateManager.getSnapshot, editorStateManager.getServerSnapshot, options.selector, (_a3 = options.equalityFn) !== null && _a3 !== void 0 ? _a3 : deepEqual);
  useIsomorphicLayoutEffect(() => {
    return editorStateManager.watch(options.editor);
  }, [options.editor, editorStateManager]);
  useDebugValue(selectedState);
  return selectedState;
}
const isDev = process.env.NODE_ENV !== "production";
const isSSR = typeof window === "undefined";
const isNext = isSSR || Boolean(typeof window !== "undefined" && window.next);
class EditorInstanceManager {
  constructor(options) {
    this.editor = null;
    this.subscriptions = /* @__PURE__ */ new Set();
    this.isComponentMounted = false;
    this.previousDeps = null;
    this.instanceId = "";
    this.options = options;
    this.subscriptions = /* @__PURE__ */ new Set();
    this.setEditor(this.getInitialEditor());
    this.scheduleDestroy();
    this.getEditor = this.getEditor.bind(this);
    this.getServerSnapshot = this.getServerSnapshot.bind(this);
    this.subscribe = this.subscribe.bind(this);
    this.refreshEditorInstance = this.refreshEditorInstance.bind(this);
    this.scheduleDestroy = this.scheduleDestroy.bind(this);
    this.onRender = this.onRender.bind(this);
    this.createEditor = this.createEditor.bind(this);
  }
  setEditor(editor) {
    this.editor = editor;
    this.instanceId = Math.random().toString(36).slice(2, 9);
    this.subscriptions.forEach((cb) => cb());
  }
  getInitialEditor() {
    if (this.options.current.immediatelyRender === void 0) {
      if (isSSR || isNext) {
        if (isDev) {
          console.warn("Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches.");
        }
        return null;
      }
      return this.createEditor();
    }
    if (this.options.current.immediatelyRender && isSSR && isDev) {
      throw new Error("Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.");
    }
    if (this.options.current.immediatelyRender) {
      return this.createEditor();
    }
    return null;
  }
  /**
   * Create a new editor instance. And attach event listeners.
   */
  createEditor() {
    const optionsToApply = {
      ...this.options.current,
      // Always call the most recent version of the callback function by default
      onBeforeCreate: (...args) => {
        var _a3, _b;
        return (_b = (_a3 = this.options.current).onBeforeCreate) === null || _b === void 0 ? void 0 : _b.call(_a3, ...args);
      },
      onBlur: (...args) => {
        var _a3, _b;
        return (_b = (_a3 = this.options.current).onBlur) === null || _b === void 0 ? void 0 : _b.call(_a3, ...args);
      },
      onCreate: (...args) => {
        var _a3, _b;
        return (_b = (_a3 = this.options.current).onCreate) === null || _b === void 0 ? void 0 : _b.call(_a3, ...args);
      },
      onDestroy: (...args) => {
        var _a3, _b;
        return (_b = (_a3 = this.options.current).onDestroy) === null || _b === void 0 ? void 0 : _b.call(_a3, ...args);
      },
      onFocus: (...args) => {
        var _a3, _b;
        return (_b = (_a3 = this.options.current).onFocus) === null || _b === void 0 ? void 0 : _b.call(_a3, ...args);
      },
      onSelectionUpdate: (...args) => {
        var _a3, _b;
        return (_b = (_a3 = this.options.current).onSelectionUpdate) === null || _b === void 0 ? void 0 : _b.call(_a3, ...args);
      },
      onTransaction: (...args) => {
        var _a3, _b;
        return (_b = (_a3 = this.options.current).onTransaction) === null || _b === void 0 ? void 0 : _b.call(_a3, ...args);
      },
      onUpdate: (...args) => {
        var _a3, _b;
        return (_b = (_a3 = this.options.current).onUpdate) === null || _b === void 0 ? void 0 : _b.call(_a3, ...args);
      },
      onContentError: (...args) => {
        var _a3, _b;
        return (_b = (_a3 = this.options.current).onContentError) === null || _b === void 0 ? void 0 : _b.call(_a3, ...args);
      },
      onDrop: (...args) => {
        var _a3, _b;
        return (_b = (_a3 = this.options.current).onDrop) === null || _b === void 0 ? void 0 : _b.call(_a3, ...args);
      },
      onPaste: (...args) => {
        var _a3, _b;
        return (_b = (_a3 = this.options.current).onPaste) === null || _b === void 0 ? void 0 : _b.call(_a3, ...args);
      }
    };
    const editor = new Editor(optionsToApply);
    return editor;
  }
  /**
   * Get the current editor instance.
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return null;
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(onStoreChange) {
    this.subscriptions.add(onStoreChange);
    return () => {
      this.subscriptions.delete(onStoreChange);
    };
  }
  static compareOptions(a2, b2) {
    return Object.keys(a2).every((key2) => {
      if (["onCreate", "onBeforeCreate", "onDestroy", "onUpdate", "onTransaction", "onFocus", "onBlur", "onSelectionUpdate", "onContentError", "onDrop", "onPaste"].includes(key2)) {
        return true;
      }
      if (key2 === "extensions" && a2.extensions && b2.extensions) {
        if (a2.extensions.length !== b2.extensions.length) {
          return false;
        }
        return a2.extensions.every((extension2, index2) => {
          var _a3;
          if (extension2 !== ((_a3 = b2.extensions) === null || _a3 === void 0 ? void 0 : _a3[index2])) {
            return false;
          }
          return true;
        });
      }
      if (a2[key2] !== b2[key2]) {
        return false;
      }
      return true;
    });
  }
  /**
   * On each render, we will create, update, or destroy the editor instance.
   * @param deps The dependencies to watch for changes
   * @returns A cleanup function
   */
  onRender(deps) {
    return () => {
      this.isComponentMounted = true;
      clearTimeout(this.scheduledDestructionTimeout);
      if (this.editor && !this.editor.isDestroyed && deps.length === 0) {
        if (!EditorInstanceManager.compareOptions(this.options.current, this.editor.options)) {
          this.editor.setOptions({
            ...this.options.current,
            editable: this.editor.isEditable
          });
        }
      } else {
        this.refreshEditorInstance(deps);
      }
      return () => {
        this.isComponentMounted = false;
        this.scheduleDestroy();
      };
    };
  }
  /**
   * Recreate the editor instance if the dependencies have changed.
   */
  refreshEditorInstance(deps) {
    if (this.editor && !this.editor.isDestroyed) {
      if (this.previousDeps === null) {
        this.previousDeps = deps;
        return;
      }
      const depsAreEqual = this.previousDeps.length === deps.length && this.previousDeps.every((dep, index2) => dep === deps[index2]);
      if (depsAreEqual) {
        return;
      }
    }
    if (this.editor && !this.editor.isDestroyed) {
      this.editor.destroy();
    }
    this.setEditor(this.createEditor());
    this.previousDeps = deps;
  }
  /**
   * Schedule the destruction of the editor instance.
   * This will only destroy the editor if it was not mounted on the next tick.
   * This is to avoid destroying the editor instance when it's actually still mounted.
   */
  scheduleDestroy() {
    const currentInstanceId = this.instanceId;
    const currentEditor = this.editor;
    this.scheduledDestructionTimeout = setTimeout(() => {
      if (this.isComponentMounted && this.instanceId === currentInstanceId) {
        if (currentEditor) {
          currentEditor.setOptions(this.options.current);
        }
        return;
      }
      if (currentEditor && !currentEditor.isDestroyed) {
        currentEditor.destroy();
        if (this.instanceId === currentInstanceId) {
          this.setEditor(null);
        }
      }
    }, 1);
  }
}
function useEditor(options = {}, deps = []) {
  const mostRecentOptions = useRef(options);
  mostRecentOptions.current = options;
  const [instanceManager] = useState(() => new EditorInstanceManager(mostRecentOptions));
  const editor = shimExports.useSyncExternalStore(instanceManager.subscribe, instanceManager.getEditor, instanceManager.getServerSnapshot);
  useDebugValue(editor);
  useEffect(instanceManager.onRender(deps));
  useEditorState({
    editor,
    selector: ({ transactionNumber }) => {
      if (options.shouldRerenderOnTransaction === false) {
        return null;
      }
      if (options.immediatelyRender && transactionNumber === 0) {
        return 0;
      }
      return transactionNumber + 1;
    }
  });
  return editor;
}
const EditorContext = createContext({
  editor: null
});
EditorContext.Consumer;
const ReactNodeViewContext = createContext({
  onDragStart: void 0
});
const useReactNodeView = () => useContext(ReactNodeViewContext);
React__default.forwardRef((props, ref2) => {
  const { onDragStart: onDragStart4 } = useReactNodeView();
  const Tag = props.as || "div";
  return (
    // @ts-ignore
    React__default.createElement(Tag, { ...props, ref: ref2, "data-node-view-wrapper": "", onDragStart: onDragStart4, style: {
      whiteSpace: "normal",
      ...props.style
    } })
  );
});
const mergeNestedSpanStyles = (element2) => {
  if (!element2.children.length) {
    return;
  }
  const childSpans = element2.querySelectorAll("span");
  if (!childSpans) {
    return;
  }
  childSpans.forEach((childSpan) => {
    var _a3, _b;
    const childStyle = childSpan.getAttribute("style");
    const closestParentSpanStyleOfChild = (_b = (_a3 = childSpan.parentElement) === null || _a3 === void 0 ? void 0 : _a3.closest("span")) === null || _b === void 0 ? void 0 : _b.getAttribute("style");
    childSpan.setAttribute("style", `${closestParentSpanStyleOfChild};${childStyle}`);
  });
};
const TextStyle = Mark2.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: false
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (element2) => {
          const hasStyles = element2.hasAttribute("style");
          if (!hasStyles) {
            return false;
          }
          if (this.options.mergeNestedSpanStyles) {
            mergeNestedSpanStyles(element2);
          }
          return {};
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ tr: tr2 }) => {
        const { selection } = tr2;
        tr2.doc.nodesBetween(selection.from, selection.to, (node2, pos) => {
          if (node2.isTextblock) {
            return true;
          }
          if (!node2.marks.filter((mark2) => mark2.type === this.type).some((mark2) => Object.values(mark2.attrs).some((value) => !!value))) {
            tr2.removeMark(pos, pos + node2.nodeSize, this.type);
          }
        });
        return true;
      }
    };
  }
});
const Color = Extension.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (element2) => {
              var _a3;
              return (_a3 = element2.style.color) === null || _a3 === void 0 ? void 0 : _a3.replace(/['"]+/g, "");
            },
            renderHTML: (attributes) => {
              if (!attributes.color) {
                return {};
              }
              return {
                style: `color: ${attributes.color}`
              };
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (color2) => ({ chain }) => {
        return chain().setMark("textStyle", { color: color2 }).run();
      },
      unsetColor: () => ({ chain }) => {
        return chain().setMark("textStyle", { color: null }).removeEmptyTextStyle().run();
      }
    };
  }
});
const TextAlign = Extension.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (element2) => {
              const alignment = element2.style.textAlign;
              return this.options.alignments.includes(alignment) ? alignment : this.options.defaultAlignment;
            },
            renderHTML: (attributes) => {
              if (!attributes.textAlign) {
                return {};
              }
              return { style: `text-align: ${attributes.textAlign}` };
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (alignment) => ({ commands: commands2 }) => {
        if (!this.options.alignments.includes(alignment)) {
          return false;
        }
        return this.options.types.map((type) => commands2.updateAttributes(type, { textAlign: alignment })).every((response) => response);
      },
      unsetTextAlign: () => ({ commands: commands2 }) => {
        return this.options.types.map((type) => commands2.resetAttributes(type, "textAlign")).every((response) => response);
      },
      toggleTextAlign: (alignment) => ({ editor, commands: commands2 }) => {
        if (!this.options.alignments.includes(alignment)) {
          return false;
        }
        if (editor.isActive({ textAlign: alignment })) {
          return commands2.unsetTextAlign();
        }
        return commands2.setTextAlign(alignment);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
});
const FontSize = Extension.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (element2) => element2.style.fontSize.replace(/['"]+/g, ""),
            renderHTML: (attributes) => {
              if (!attributes.fontSize) {
                return {};
              }
              return {
                style: `font-size: ${attributes.fontSize}`
              };
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (fontSize2) => ({ chain }) => {
        return chain().setMark("textStyle", { fontSize: fontSize2 }).run();
      },
      unsetFontSize: () => ({ chain }) => {
        return chain().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run();
      }
    };
  }
});
var readFromCache;
var addToCache;
if (typeof WeakMap != "undefined") {
  let cache = /* @__PURE__ */ new WeakMap();
  readFromCache = (key2) => cache.get(key2);
  addToCache = (key2, value) => {
    cache.set(key2, value);
    return value;
  };
} else {
  const cache = [];
  const cacheSize = 10;
  let cachePos = 0;
  readFromCache = (key2) => {
    for (let i = 0; i < cache.length; i += 2)
      if (cache[i] == key2) return cache[i + 1];
  };
  addToCache = (key2, value) => {
    if (cachePos == cacheSize) cachePos = 0;
    cache[cachePos++] = key2;
    return cache[cachePos++] = value;
  };
}
var TableMap = class {
  constructor(width2, height2, map3, problems) {
    this.width = width2;
    this.height = height2;
    this.map = map3;
    this.problems = problems;
  }
  // Find the dimensions of the cell at the given position.
  findCell(pos) {
    for (let i = 0; i < this.map.length; i++) {
      const curPos = this.map[i];
      if (curPos != pos) continue;
      const left2 = i % this.width;
      const top2 = i / this.width | 0;
      let right2 = left2 + 1;
      let bottom2 = top2 + 1;
      for (let j2 = 1; right2 < this.width && this.map[i + j2] == curPos; j2++) {
        right2++;
      }
      for (let j2 = 1; bottom2 < this.height && this.map[i + this.width * j2] == curPos; j2++) {
        bottom2++;
      }
      return { left: left2, top: top2, right: right2, bottom: bottom2 };
    }
    throw new RangeError(`No cell with offset ${pos} found`);
  }
  // Find the left side of the cell at the given position.
  colCount(pos) {
    for (let i = 0; i < this.map.length; i++) {
      if (this.map[i] == pos) {
        return i % this.width;
      }
    }
    throw new RangeError(`No cell with offset ${pos} found`);
  }
  // Find the next cell in the given direction, starting from the cell
  // at `pos`, if any.
  nextCell(pos, axis, dir) {
    const { left: left2, right: right2, top: top2, bottom: bottom2 } = this.findCell(pos);
    if (axis == "horiz") {
      if (dir < 0 ? left2 == 0 : right2 == this.width) return null;
      return this.map[top2 * this.width + (dir < 0 ? left2 - 1 : right2)];
    } else {
      if (dir < 0 ? top2 == 0 : bottom2 == this.height) return null;
      return this.map[left2 + this.width * (dir < 0 ? top2 - 1 : bottom2)];
    }
  }
  // Get the rectangle spanning the two given cells.
  rectBetween(a2, b2) {
    const {
      left: leftA,
      right: rightA,
      top: topA,
      bottom: bottomA
    } = this.findCell(a2);
    const {
      left: leftB,
      right: rightB,
      top: topB,
      bottom: bottomB
    } = this.findCell(b2);
    return {
      left: Math.min(leftA, leftB),
      top: Math.min(topA, topB),
      right: Math.max(rightA, rightB),
      bottom: Math.max(bottomA, bottomB)
    };
  }
  // Return the position of all cells that have the top left corner in
  // the given rectangle.
  cellsInRect(rect) {
    const result = [];
    const seen = {};
    for (let row = rect.top; row < rect.bottom; row++) {
      for (let col = rect.left; col < rect.right; col++) {
        const index2 = row * this.width + col;
        const pos = this.map[index2];
        if (seen[pos]) continue;
        seen[pos] = true;
        if (col == rect.left && col && this.map[index2 - 1] == pos || row == rect.top && row && this.map[index2 - this.width] == pos) {
          continue;
        }
        result.push(pos);
      }
    }
    return result;
  }
  // Return the position at which the cell at the given row and column
  // starts, or would start, if a cell started there.
  positionAt(row, col, table2) {
    for (let i = 0, rowStart = 0; ; i++) {
      const rowEnd = rowStart + table2.child(i).nodeSize;
      if (i == row) {
        let index2 = col + row * this.width;
        const rowEndIndex = (row + 1) * this.width;
        while (index2 < rowEndIndex && this.map[index2] < rowStart) index2++;
        return index2 == rowEndIndex ? rowEnd - 1 : this.map[index2];
      }
      rowStart = rowEnd;
    }
  }
  // Find the table map for the given table node.
  static get(table2) {
    return readFromCache(table2) || addToCache(table2, computeMap(table2));
  }
};
function computeMap(table2) {
  if (table2.type.spec.tableRole != "table")
    throw new RangeError("Not a table node: " + table2.type.name);
  const width2 = findWidth(table2), height2 = table2.childCount;
  const map3 = [];
  let mapPos = 0;
  let problems = null;
  const colWidths = [];
  for (let i = 0, e = width2 * height2; i < e; i++) map3[i] = 0;
  for (let row = 0, pos = 0; row < height2; row++) {
    const rowNode = table2.child(row);
    pos++;
    for (let i = 0; ; i++) {
      while (mapPos < map3.length && map3[mapPos] != 0) mapPos++;
      if (i == rowNode.childCount) break;
      const cellNode = rowNode.child(i);
      const { colspan, rowspan, colwidth } = cellNode.attrs;
      for (let h2 = 0; h2 < rowspan; h2++) {
        if (h2 + row >= height2) {
          (problems || (problems = [])).push({
            type: "overlong_rowspan",
            pos,
            n: rowspan - h2
          });
          break;
        }
        const start4 = mapPos + h2 * width2;
        for (let w2 = 0; w2 < colspan; w2++) {
          if (map3[start4 + w2] == 0) map3[start4 + w2] = pos;
          else
            (problems || (problems = [])).push({
              type: "collision",
              row,
              pos,
              n: colspan - w2
            });
          const colW = colwidth && colwidth[w2];
          if (colW) {
            const widthIndex = (start4 + w2) % width2 * 2, prev2 = colWidths[widthIndex];
            if (prev2 == null || prev2 != colW && colWidths[widthIndex + 1] == 1) {
              colWidths[widthIndex] = colW;
              colWidths[widthIndex + 1] = 1;
            } else if (prev2 == colW) {
              colWidths[widthIndex + 1]++;
            }
          }
        }
      }
      mapPos += colspan;
      pos += cellNode.nodeSize;
    }
    const expectedPos = (row + 1) * width2;
    let missing = 0;
    while (mapPos < expectedPos) if (map3[mapPos++] == 0) missing++;
    if (missing)
      (problems || (problems = [])).push({ type: "missing", row, n: missing });
    pos++;
  }
  if (width2 === 0 || height2 === 0)
    (problems || (problems = [])).push({ type: "zero_sized" });
  const tableMap = new TableMap(width2, height2, map3, problems);
  let badWidths = false;
  for (let i = 0; !badWidths && i < colWidths.length; i += 2)
    if (colWidths[i] != null && colWidths[i + 1] < height2) badWidths = true;
  if (badWidths) findBadColWidths(tableMap, colWidths, table2);
  return tableMap;
}
function findWidth(table2) {
  let width2 = -1;
  let hasRowSpan = false;
  for (let row = 0; row < table2.childCount; row++) {
    const rowNode = table2.child(row);
    let rowWidth = 0;
    if (hasRowSpan)
      for (let j2 = 0; j2 < row; j2++) {
        const prevRow = table2.child(j2);
        for (let i = 0; i < prevRow.childCount; i++) {
          const cell = prevRow.child(i);
          if (j2 + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
        }
      }
    for (let i = 0; i < rowNode.childCount; i++) {
      const cell = rowNode.child(i);
      rowWidth += cell.attrs.colspan;
      if (cell.attrs.rowspan > 1) hasRowSpan = true;
    }
    if (width2 == -1) width2 = rowWidth;
    else if (width2 != rowWidth) width2 = Math.max(width2, rowWidth);
  }
  return width2;
}
function findBadColWidths(map3, colWidths, table2) {
  if (!map3.problems) map3.problems = [];
  const seen = {};
  for (let i = 0; i < map3.map.length; i++) {
    const pos = map3.map[i];
    if (seen[pos]) continue;
    seen[pos] = true;
    const node2 = table2.nodeAt(pos);
    if (!node2) {
      throw new RangeError(`No cell with offset ${pos} found`);
    }
    let updated = null;
    const attrs = node2.attrs;
    for (let j2 = 0; j2 < attrs.colspan; j2++) {
      const col = (i + j2) % map3.width;
      const colWidth = colWidths[col * 2];
      if (colWidth != null && (!attrs.colwidth || attrs.colwidth[j2] != colWidth))
        (updated || (updated = freshColWidth(attrs)))[j2] = colWidth;
    }
    if (updated)
      map3.problems.unshift({
        type: "colwidth mismatch",
        pos,
        colwidth: updated
      });
  }
}
function freshColWidth(attrs) {
  if (attrs.colwidth) return attrs.colwidth.slice();
  const result = [];
  for (let i = 0; i < attrs.colspan; i++) result.push(0);
  return result;
}
function tableNodeTypes(schema) {
  let result = schema.cached.tableNodeTypes;
  if (!result) {
    result = schema.cached.tableNodeTypes = {};
    for (const name2 in schema.nodes) {
      const type = schema.nodes[name2], role = type.spec.tableRole;
      if (role) result[role] = type;
    }
  }
  return result;
}
var tableEditingKey = new PluginKey("selectingCells");
function cellAround($pos) {
  for (let d2 = $pos.depth - 1; d2 > 0; d2--)
    if ($pos.node(d2).type.spec.tableRole == "row")
      return $pos.node(0).resolve($pos.before(d2 + 1));
  return null;
}
function cellWrapping($pos) {
  for (let d2 = $pos.depth; d2 > 0; d2--) {
    const role = $pos.node(d2).type.spec.tableRole;
    if (role === "cell" || role === "header_cell") return $pos.node(d2);
  }
  return null;
}
function isInTable(state) {
  const $head = state.selection.$head;
  for (let d2 = $head.depth; d2 > 0; d2--)
    if ($head.node(d2).type.spec.tableRole == "row") return true;
  return false;
}
function selectionCell(state) {
  const sel = state.selection;
  if ("$anchorCell" in sel && sel.$anchorCell) {
    return sel.$anchorCell.pos > sel.$headCell.pos ? sel.$anchorCell : sel.$headCell;
  } else if ("node" in sel && sel.node && sel.node.type.spec.tableRole == "cell") {
    return sel.$anchor;
  }
  const $cell = cellAround(sel.$head) || cellNear(sel.$head);
  if ($cell) {
    return $cell;
  }
  throw new RangeError(`No cell found around position ${sel.head}`);
}
function cellNear($pos) {
  for (let after = $pos.nodeAfter, pos = $pos.pos; after; after = after.firstChild, pos++) {
    const role = after.type.spec.tableRole;
    if (role == "cell" || role == "header_cell") return $pos.doc.resolve(pos);
  }
  for (let before = $pos.nodeBefore, pos = $pos.pos; before; before = before.lastChild, pos--) {
    const role = before.type.spec.tableRole;
    if (role == "cell" || role == "header_cell")
      return $pos.doc.resolve(pos - before.nodeSize);
  }
}
function pointsAtCell($pos) {
  return $pos.parent.type.spec.tableRole == "row" && !!$pos.nodeAfter;
}
function moveCellForward($pos) {
  return $pos.node(0).resolve($pos.pos + $pos.nodeAfter.nodeSize);
}
function inSameTable($cellA, $cellB) {
  return $cellA.depth == $cellB.depth && $cellA.pos >= $cellB.start(-1) && $cellA.pos <= $cellB.end(-1);
}
function nextCell($pos, axis, dir) {
  const table2 = $pos.node(-1);
  const map3 = TableMap.get(table2);
  const tableStart = $pos.start(-1);
  const moved = map3.nextCell($pos.pos - tableStart, axis, dir);
  return moved == null ? null : $pos.node(0).resolve(tableStart + moved);
}
function removeColSpan(attrs, pos, n2 = 1) {
  const result = { ...attrs, colspan: attrs.colspan - n2 };
  if (result.colwidth) {
    result.colwidth = result.colwidth.slice();
    result.colwidth.splice(pos, n2);
    if (!result.colwidth.some((w2) => w2 > 0)) result.colwidth = null;
  }
  return result;
}
function addColSpan(attrs, pos, n2 = 1) {
  const result = { ...attrs, colspan: attrs.colspan + n2 };
  if (result.colwidth) {
    result.colwidth = result.colwidth.slice();
    for (let i = 0; i < n2; i++) result.colwidth.splice(pos, 0, 0);
  }
  return result;
}
function columnIsHeader(map3, table2, col) {
  const headerCell = tableNodeTypes(table2.type.schema).header_cell;
  for (let row = 0; row < map3.height; row++)
    if (table2.nodeAt(map3.map[col + row * map3.width]).type != headerCell)
      return false;
  return true;
}
var CellSelection = class _CellSelection extends Selection {
  // A table selection is identified by its anchor and head cells. The
  // positions given to this constructor should point _before_ two
  // cells in the same table. They may be the same, to select a single
  // cell.
  constructor($anchorCell, $headCell = $anchorCell) {
    const table2 = $anchorCell.node(-1);
    const map3 = TableMap.get(table2);
    const tableStart = $anchorCell.start(-1);
    const rect = map3.rectBetween(
      $anchorCell.pos - tableStart,
      $headCell.pos - tableStart
    );
    const doc2 = $anchorCell.node(0);
    const cells = map3.cellsInRect(rect).filter((p2) => p2 != $headCell.pos - tableStart);
    cells.unshift($headCell.pos - tableStart);
    const ranges = cells.map((pos) => {
      const cell = table2.nodeAt(pos);
      if (!cell) {
        throw RangeError(`No cell with offset ${pos} found`);
      }
      const from3 = tableStart + pos + 1;
      return new SelectionRange(
        doc2.resolve(from3),
        doc2.resolve(from3 + cell.content.size)
      );
    });
    super(ranges[0].$from, ranges[0].$to, ranges);
    this.$anchorCell = $anchorCell;
    this.$headCell = $headCell;
  }
  map(doc2, mapping) {
    const $anchorCell = doc2.resolve(mapping.map(this.$anchorCell.pos));
    const $headCell = doc2.resolve(mapping.map(this.$headCell.pos));
    if (pointsAtCell($anchorCell) && pointsAtCell($headCell) && inSameTable($anchorCell, $headCell)) {
      const tableChanged = this.$anchorCell.node(-1) != $anchorCell.node(-1);
      if (tableChanged && this.isRowSelection())
        return _CellSelection.rowSelection($anchorCell, $headCell);
      else if (tableChanged && this.isColSelection())
        return _CellSelection.colSelection($anchorCell, $headCell);
      else return new _CellSelection($anchorCell, $headCell);
    }
    return TextSelection.between($anchorCell, $headCell);
  }
  // Returns a rectangular slice of table rows containing the selected
  // cells.
  content() {
    const table2 = this.$anchorCell.node(-1);
    const map3 = TableMap.get(table2);
    const tableStart = this.$anchorCell.start(-1);
    const rect = map3.rectBetween(
      this.$anchorCell.pos - tableStart,
      this.$headCell.pos - tableStart
    );
    const seen = {};
    const rows = [];
    for (let row = rect.top; row < rect.bottom; row++) {
      const rowContent = [];
      for (let index2 = row * map3.width + rect.left, col = rect.left; col < rect.right; col++, index2++) {
        const pos = map3.map[index2];
        if (seen[pos]) continue;
        seen[pos] = true;
        const cellRect = map3.findCell(pos);
        let cell = table2.nodeAt(pos);
        if (!cell) {
          throw RangeError(`No cell with offset ${pos} found`);
        }
        const extraLeft = rect.left - cellRect.left;
        const extraRight = cellRect.right - rect.right;
        if (extraLeft > 0 || extraRight > 0) {
          let attrs = cell.attrs;
          if (extraLeft > 0) {
            attrs = removeColSpan(attrs, 0, extraLeft);
          }
          if (extraRight > 0) {
            attrs = removeColSpan(
              attrs,
              attrs.colspan - extraRight,
              extraRight
            );
          }
          if (cellRect.left < rect.left) {
            cell = cell.type.createAndFill(attrs);
            if (!cell) {
              throw RangeError(
                `Could not create cell with attrs ${JSON.stringify(attrs)}`
              );
            }
          } else {
            cell = cell.type.create(attrs, cell.content);
          }
        }
        if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
          const attrs = {
            ...cell.attrs,
            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
          };
          if (cellRect.top < rect.top) {
            cell = cell.type.createAndFill(attrs);
          } else {
            cell = cell.type.create(attrs, cell.content);
          }
        }
        rowContent.push(cell);
      }
      rows.push(table2.child(row).copy(Fragment.from(rowContent)));
    }
    const fragment = this.isColSelection() && this.isRowSelection() ? table2 : rows;
    return new Slice(Fragment.from(fragment), 1, 1);
  }
  replace(tr2, content2 = Slice.empty) {
    const mapFrom = tr2.steps.length, ranges = this.ranges;
    for (let i = 0; i < ranges.length; i++) {
      const { $from, $to } = ranges[i], mapping = tr2.mapping.slice(mapFrom);
      tr2.replace(
        mapping.map($from.pos),
        mapping.map($to.pos),
        i ? Slice.empty : content2
      );
    }
    const sel = Selection.findFrom(
      tr2.doc.resolve(tr2.mapping.slice(mapFrom).map(this.to)),
      -1
    );
    if (sel) tr2.setSelection(sel);
  }
  replaceWith(tr2, node2) {
    this.replace(tr2, new Slice(Fragment.from(node2), 0, 0));
  }
  forEachCell(f2) {
    const table2 = this.$anchorCell.node(-1);
    const map3 = TableMap.get(table2);
    const tableStart = this.$anchorCell.start(-1);
    const cells = map3.cellsInRect(
      map3.rectBetween(
        this.$anchorCell.pos - tableStart,
        this.$headCell.pos - tableStart
      )
    );
    for (let i = 0; i < cells.length; i++) {
      f2(table2.nodeAt(cells[i]), tableStart + cells[i]);
    }
  }
  // True if this selection goes all the way from the top to the
  // bottom of the table.
  isColSelection() {
    const anchorTop = this.$anchorCell.index(-1);
    const headTop = this.$headCell.index(-1);
    if (Math.min(anchorTop, headTop) > 0) return false;
    const anchorBottom = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
    const headBottom = headTop + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(anchorBottom, headBottom) == this.$headCell.node(-1).childCount;
  }
  // Returns the smallest column selection that covers the given anchor
  // and head cell.
  static colSelection($anchorCell, $headCell = $anchorCell) {
    const table2 = $anchorCell.node(-1);
    const map3 = TableMap.get(table2);
    const tableStart = $anchorCell.start(-1);
    const anchorRect = map3.findCell($anchorCell.pos - tableStart);
    const headRect = map3.findCell($headCell.pos - tableStart);
    const doc2 = $anchorCell.node(0);
    if (anchorRect.top <= headRect.top) {
      if (anchorRect.top > 0)
        $anchorCell = doc2.resolve(tableStart + map3.map[anchorRect.left]);
      if (headRect.bottom < map3.height)
        $headCell = doc2.resolve(
          tableStart + map3.map[map3.width * (map3.height - 1) + headRect.right - 1]
        );
    } else {
      if (headRect.top > 0)
        $headCell = doc2.resolve(tableStart + map3.map[headRect.left]);
      if (anchorRect.bottom < map3.height)
        $anchorCell = doc2.resolve(
          tableStart + map3.map[map3.width * (map3.height - 1) + anchorRect.right - 1]
        );
    }
    return new _CellSelection($anchorCell, $headCell);
  }
  // True if this selection goes all the way from the left to the
  // right of the table.
  isRowSelection() {
    const table2 = this.$anchorCell.node(-1);
    const map3 = TableMap.get(table2);
    const tableStart = this.$anchorCell.start(-1);
    const anchorLeft = map3.colCount(this.$anchorCell.pos - tableStart);
    const headLeft = map3.colCount(this.$headCell.pos - tableStart);
    if (Math.min(anchorLeft, headLeft) > 0) return false;
    const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
    const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(anchorRight, headRight) == map3.width;
  }
  eq(other2) {
    return other2 instanceof _CellSelection && other2.$anchorCell.pos == this.$anchorCell.pos && other2.$headCell.pos == this.$headCell.pos;
  }
  // Returns the smallest row selection that covers the given anchor
  // and head cell.
  static rowSelection($anchorCell, $headCell = $anchorCell) {
    const table2 = $anchorCell.node(-1);
    const map3 = TableMap.get(table2);
    const tableStart = $anchorCell.start(-1);
    const anchorRect = map3.findCell($anchorCell.pos - tableStart);
    const headRect = map3.findCell($headCell.pos - tableStart);
    const doc2 = $anchorCell.node(0);
    if (anchorRect.left <= headRect.left) {
      if (anchorRect.left > 0)
        $anchorCell = doc2.resolve(
          tableStart + map3.map[anchorRect.top * map3.width]
        );
      if (headRect.right < map3.width)
        $headCell = doc2.resolve(
          tableStart + map3.map[map3.width * (headRect.top + 1) - 1]
        );
    } else {
      if (headRect.left > 0)
        $headCell = doc2.resolve(tableStart + map3.map[headRect.top * map3.width]);
      if (anchorRect.right < map3.width)
        $anchorCell = doc2.resolve(
          tableStart + map3.map[map3.width * (anchorRect.top + 1) - 1]
        );
    }
    return new _CellSelection($anchorCell, $headCell);
  }
  toJSON() {
    return {
      type: "cell",
      anchor: this.$anchorCell.pos,
      head: this.$headCell.pos
    };
  }
  static fromJSON(doc2, json) {
    return new _CellSelection(doc2.resolve(json.anchor), doc2.resolve(json.head));
  }
  static create(doc2, anchorCell, headCell = anchorCell) {
    return new _CellSelection(doc2.resolve(anchorCell), doc2.resolve(headCell));
  }
  getBookmark() {
    return new CellBookmark(this.$anchorCell.pos, this.$headCell.pos);
  }
};
CellSelection.prototype.visible = false;
Selection.jsonID("cell", CellSelection);
var CellBookmark = class _CellBookmark {
  constructor(anchor, head) {
    this.anchor = anchor;
    this.head = head;
  }
  map(mapping) {
    return new _CellBookmark(mapping.map(this.anchor), mapping.map(this.head));
  }
  resolve(doc2) {
    const $anchorCell = doc2.resolve(this.anchor), $headCell = doc2.resolve(this.head);
    if ($anchorCell.parent.type.spec.tableRole == "row" && $headCell.parent.type.spec.tableRole == "row" && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && inSameTable($anchorCell, $headCell))
      return new CellSelection($anchorCell, $headCell);
    else return Selection.near($headCell, 1);
  }
};
function drawCellSelection(state) {
  if (!(state.selection instanceof CellSelection)) return null;
  const cells = [];
  state.selection.forEachCell((node2, pos) => {
    cells.push(
      Decoration.node(pos, pos + node2.nodeSize, { class: "selectedCell" })
    );
  });
  return DecorationSet.create(state.doc, cells);
}
function isCellBoundarySelection({ $from, $to }) {
  if ($from.pos == $to.pos || $from.pos < $to.pos - 6) return false;
  let afterFrom = $from.pos;
  let beforeTo = $to.pos;
  let depth = $from.depth;
  for (; depth >= 0; depth--, afterFrom++)
    if ($from.after(depth + 1) < $from.end(depth)) break;
  for (let d2 = $to.depth; d2 >= 0; d2--, beforeTo--)
    if ($to.before(d2 + 1) > $to.start(d2)) break;
  return afterFrom == beforeTo && /row|table/.test($from.node(depth).type.spec.tableRole);
}
function isTextSelectionAcrossCells({ $from, $to }) {
  let fromCellBoundaryNode;
  let toCellBoundaryNode;
  for (let i = $from.depth; i > 0; i--) {
    const node2 = $from.node(i);
    if (node2.type.spec.tableRole === "cell" || node2.type.spec.tableRole === "header_cell") {
      fromCellBoundaryNode = node2;
      break;
    }
  }
  for (let i = $to.depth; i > 0; i--) {
    const node2 = $to.node(i);
    if (node2.type.spec.tableRole === "cell" || node2.type.spec.tableRole === "header_cell") {
      toCellBoundaryNode = node2;
      break;
    }
  }
  return fromCellBoundaryNode !== toCellBoundaryNode && $to.parentOffset === 0;
}
function normalizeSelection(state, tr2, allowTableNodeSelection) {
  const sel = (tr2 || state).selection;
  const doc2 = (tr2 || state).doc;
  let normalize2;
  let role;
  if (sel instanceof NodeSelection && (role = sel.node.type.spec.tableRole)) {
    if (role == "cell" || role == "header_cell") {
      normalize2 = CellSelection.create(doc2, sel.from);
    } else if (role == "row") {
      const $cell = doc2.resolve(sel.from + 1);
      normalize2 = CellSelection.rowSelection($cell, $cell);
    } else if (!allowTableNodeSelection) {
      const map3 = TableMap.get(sel.node);
      const start4 = sel.from + 1;
      const lastCell = start4 + map3.map[map3.width * map3.height - 1];
      normalize2 = CellSelection.create(doc2, start4 + 1, lastCell);
    }
  } else if (sel instanceof TextSelection && isCellBoundarySelection(sel)) {
    normalize2 = TextSelection.create(doc2, sel.from);
  } else if (sel instanceof TextSelection && isTextSelectionAcrossCells(sel)) {
    normalize2 = TextSelection.create(doc2, sel.$from.start(), sel.$from.end());
  }
  if (normalize2) (tr2 || (tr2 = state.tr)).setSelection(normalize2);
  return tr2;
}
var fixTablesKey = new PluginKey("fix-tables");
function changedDescendants(old, cur, offset3, f2) {
  const oldSize = old.childCount, curSize = cur.childCount;
  outer: for (let i = 0, j2 = 0; i < curSize; i++) {
    const child = cur.child(i);
    for (let scan = j2, e = Math.min(oldSize, i + 3); scan < e; scan++) {
      if (old.child(scan) == child) {
        j2 = scan + 1;
        offset3 += child.nodeSize;
        continue outer;
      }
    }
    f2(child, offset3);
    if (j2 < oldSize && old.child(j2).sameMarkup(child))
      changedDescendants(old.child(j2), child, offset3 + 1, f2);
    else child.nodesBetween(0, child.content.size, f2, offset3 + 1);
    offset3 += child.nodeSize;
  }
}
function fixTables(state, oldState) {
  let tr2;
  const check = (node2, pos) => {
    if (node2.type.spec.tableRole == "table")
      tr2 = fixTable(state, node2, pos, tr2);
  };
  if (!oldState) state.doc.descendants(check);
  else if (oldState.doc != state.doc)
    changedDescendants(oldState.doc, state.doc, 0, check);
  return tr2;
}
function fixTable(state, table2, tablePos, tr2) {
  const map3 = TableMap.get(table2);
  if (!map3.problems) return tr2;
  if (!tr2) tr2 = state.tr;
  const mustAdd = [];
  for (let i = 0; i < map3.height; i++) mustAdd.push(0);
  for (let i = 0; i < map3.problems.length; i++) {
    const prob = map3.problems[i];
    if (prob.type == "collision") {
      const cell = table2.nodeAt(prob.pos);
      if (!cell) continue;
      const attrs = cell.attrs;
      for (let j2 = 0; j2 < attrs.rowspan; j2++) mustAdd[prob.row + j2] += prob.n;
      tr2.setNodeMarkup(
        tr2.mapping.map(tablePos + 1 + prob.pos),
        null,
        removeColSpan(attrs, attrs.colspan - prob.n, prob.n)
      );
    } else if (prob.type == "missing") {
      mustAdd[prob.row] += prob.n;
    } else if (prob.type == "overlong_rowspan") {
      const cell = table2.nodeAt(prob.pos);
      if (!cell) continue;
      tr2.setNodeMarkup(tr2.mapping.map(tablePos + 1 + prob.pos), null, {
        ...cell.attrs,
        rowspan: cell.attrs.rowspan - prob.n
      });
    } else if (prob.type == "colwidth mismatch") {
      const cell = table2.nodeAt(prob.pos);
      if (!cell) continue;
      tr2.setNodeMarkup(tr2.mapping.map(tablePos + 1 + prob.pos), null, {
        ...cell.attrs,
        colwidth: prob.colwidth
      });
    } else if (prob.type == "zero_sized") {
      const pos = tr2.mapping.map(tablePos);
      tr2.delete(pos, pos + table2.nodeSize);
    }
  }
  let first2, last;
  for (let i = 0; i < mustAdd.length; i++)
    if (mustAdd[i]) {
      if (first2 == null) first2 = i;
      last = i;
    }
  for (let i = 0, pos = tablePos + 1; i < map3.height; i++) {
    const row = table2.child(i);
    const end2 = pos + row.nodeSize;
    const add4 = mustAdd[i];
    if (add4 > 0) {
      let role = "cell";
      if (row.firstChild) {
        role = row.firstChild.type.spec.tableRole;
      }
      const nodes = [];
      for (let j2 = 0; j2 < add4; j2++) {
        const node2 = tableNodeTypes(state.schema)[role].createAndFill();
        if (node2) nodes.push(node2);
      }
      const side = (i == 0 || first2 == i - 1) && last == i ? pos + 1 : end2 - 1;
      tr2.insert(tr2.mapping.map(side), nodes);
    }
    pos = end2;
  }
  return tr2.setMeta(fixTablesKey, { fixTables: true });
}
function selectedRect(state) {
  const sel = state.selection;
  const $pos = selectionCell(state);
  const table2 = $pos.node(-1);
  const tableStart = $pos.start(-1);
  const map3 = TableMap.get(table2);
  const rect = sel instanceof CellSelection ? map3.rectBetween(
    sel.$anchorCell.pos - tableStart,
    sel.$headCell.pos - tableStart
  ) : map3.findCell($pos.pos - tableStart);
  return { ...rect, tableStart, map: map3, table: table2 };
}
function addColumn(tr2, { map: map3, tableStart, table: table2 }, col) {
  let refColumn = col > 0 ? -1 : 0;
  if (columnIsHeader(map3, table2, col + refColumn)) {
    refColumn = col == 0 || col == map3.width ? null : 0;
  }
  for (let row = 0; row < map3.height; row++) {
    const index2 = row * map3.width + col;
    if (col > 0 && col < map3.width && map3.map[index2 - 1] == map3.map[index2]) {
      const pos = map3.map[index2];
      const cell = table2.nodeAt(pos);
      tr2.setNodeMarkup(
        tr2.mapping.map(tableStart + pos),
        null,
        addColSpan(cell.attrs, col - map3.colCount(pos))
      );
      row += cell.attrs.rowspan - 1;
    } else {
      const type = refColumn == null ? tableNodeTypes(table2.type.schema).cell : table2.nodeAt(map3.map[index2 + refColumn]).type;
      const pos = map3.positionAt(row, col, table2);
      tr2.insert(tr2.mapping.map(tableStart + pos), type.createAndFill());
    }
  }
  return tr2;
}
function addColumnBefore(state, dispatch) {
  if (!isInTable(state)) return false;
  if (dispatch) {
    const rect = selectedRect(state);
    dispatch(addColumn(state.tr, rect, rect.left));
  }
  return true;
}
function addColumnAfter(state, dispatch) {
  if (!isInTable(state)) return false;
  if (dispatch) {
    const rect = selectedRect(state);
    dispatch(addColumn(state.tr, rect, rect.right));
  }
  return true;
}
function removeColumn(tr2, { map: map3, table: table2, tableStart }, col) {
  const mapStart = tr2.mapping.maps.length;
  for (let row = 0; row < map3.height; ) {
    const index2 = row * map3.width + col;
    const pos = map3.map[index2];
    const cell = table2.nodeAt(pos);
    const attrs = cell.attrs;
    if (col > 0 && map3.map[index2 - 1] == pos || col < map3.width - 1 && map3.map[index2 + 1] == pos) {
      tr2.setNodeMarkup(
        tr2.mapping.slice(mapStart).map(tableStart + pos),
        null,
        removeColSpan(attrs, col - map3.colCount(pos))
      );
    } else {
      const start4 = tr2.mapping.slice(mapStart).map(tableStart + pos);
      tr2.delete(start4, start4 + cell.nodeSize);
    }
    row += attrs.rowspan;
  }
}
function deleteColumn(state, dispatch) {
  if (!isInTable(state)) return false;
  if (dispatch) {
    const rect = selectedRect(state);
    const tr2 = state.tr;
    if (rect.left == 0 && rect.right == rect.map.width) return false;
    for (let i = rect.right - 1; ; i--) {
      removeColumn(tr2, rect, i);
      if (i == rect.left) break;
      const table2 = rect.tableStart ? tr2.doc.nodeAt(rect.tableStart - 1) : tr2.doc;
      if (!table2) {
        throw RangeError("No table found");
      }
      rect.table = table2;
      rect.map = TableMap.get(table2);
    }
    dispatch(tr2);
  }
  return true;
}
function rowIsHeader(map3, table2, row) {
  var _a3;
  const headerCell = tableNodeTypes(table2.type.schema).header_cell;
  for (let col = 0; col < map3.width; col++)
    if (((_a3 = table2.nodeAt(map3.map[col + row * map3.width])) == null ? void 0 : _a3.type) != headerCell)
      return false;
  return true;
}
function addRow(tr2, { map: map3, tableStart, table: table2 }, row) {
  var _a3;
  let rowPos = tableStart;
  for (let i = 0; i < row; i++) rowPos += table2.child(i).nodeSize;
  const cells = [];
  let refRow = row > 0 ? -1 : 0;
  if (rowIsHeader(map3, table2, row + refRow))
    refRow = row == 0 || row == map3.height ? null : 0;
  for (let col = 0, index2 = map3.width * row; col < map3.width; col++, index2++) {
    if (row > 0 && row < map3.height && map3.map[index2] == map3.map[index2 - map3.width]) {
      const pos = map3.map[index2];
      const attrs = table2.nodeAt(pos).attrs;
      tr2.setNodeMarkup(tableStart + pos, null, {
        ...attrs,
        rowspan: attrs.rowspan + 1
      });
      col += attrs.colspan - 1;
    } else {
      const type = refRow == null ? tableNodeTypes(table2.type.schema).cell : (_a3 = table2.nodeAt(map3.map[index2 + refRow * map3.width])) == null ? void 0 : _a3.type;
      const node2 = type == null ? void 0 : type.createAndFill();
      if (node2) cells.push(node2);
    }
  }
  tr2.insert(rowPos, tableNodeTypes(table2.type.schema).row.create(null, cells));
  return tr2;
}
function addRowBefore(state, dispatch) {
  if (!isInTable(state)) return false;
  if (dispatch) {
    const rect = selectedRect(state);
    dispatch(addRow(state.tr, rect, rect.top));
  }
  return true;
}
function addRowAfter(state, dispatch) {
  if (!isInTable(state)) return false;
  if (dispatch) {
    const rect = selectedRect(state);
    dispatch(addRow(state.tr, rect, rect.bottom));
  }
  return true;
}
function removeRow(tr2, { map: map3, table: table2, tableStart }, row) {
  let rowPos = 0;
  for (let i = 0; i < row; i++) rowPos += table2.child(i).nodeSize;
  const nextRow = rowPos + table2.child(row).nodeSize;
  const mapFrom = tr2.mapping.maps.length;
  tr2.delete(rowPos + tableStart, nextRow + tableStart);
  const seen = /* @__PURE__ */ new Set();
  for (let col = 0, index2 = row * map3.width; col < map3.width; col++, index2++) {
    const pos = map3.map[index2];
    if (seen.has(pos)) continue;
    seen.add(pos);
    if (row > 0 && pos == map3.map[index2 - map3.width]) {
      const attrs = table2.nodeAt(pos).attrs;
      tr2.setNodeMarkup(tr2.mapping.slice(mapFrom).map(pos + tableStart), null, {
        ...attrs,
        rowspan: attrs.rowspan - 1
      });
      col += attrs.colspan - 1;
    } else if (row < map3.height && pos == map3.map[index2 + map3.width]) {
      const cell = table2.nodeAt(pos);
      const attrs = cell.attrs;
      const copy2 = cell.type.create(
        { ...attrs, rowspan: cell.attrs.rowspan - 1 },
        cell.content
      );
      const newPos = map3.positionAt(row + 1, col, table2);
      tr2.insert(tr2.mapping.slice(mapFrom).map(tableStart + newPos), copy2);
      col += attrs.colspan - 1;
    }
  }
}
function deleteRow(state, dispatch) {
  if (!isInTable(state)) return false;
  if (dispatch) {
    const rect = selectedRect(state), tr2 = state.tr;
    if (rect.top == 0 && rect.bottom == rect.map.height) return false;
    for (let i = rect.bottom - 1; ; i--) {
      removeRow(tr2, rect, i);
      if (i == rect.top) break;
      const table2 = rect.tableStart ? tr2.doc.nodeAt(rect.tableStart - 1) : tr2.doc;
      if (!table2) {
        throw RangeError("No table found");
      }
      rect.table = table2;
      rect.map = TableMap.get(rect.table);
    }
    dispatch(tr2);
  }
  return true;
}
function isEmpty(cell) {
  const c2 = cell.content;
  return c2.childCount == 1 && c2.child(0).isTextblock && c2.child(0).childCount == 0;
}
function cellsOverlapRectangle({ width: width2, height: height2, map: map3 }, rect) {
  let indexTop = rect.top * width2 + rect.left, indexLeft = indexTop;
  let indexBottom = (rect.bottom - 1) * width2 + rect.left, indexRight = indexTop + (rect.right - rect.left - 1);
  for (let i = rect.top; i < rect.bottom; i++) {
    if (rect.left > 0 && map3[indexLeft] == map3[indexLeft - 1] || rect.right < width2 && map3[indexRight] == map3[indexRight + 1])
      return true;
    indexLeft += width2;
    indexRight += width2;
  }
  for (let i = rect.left; i < rect.right; i++) {
    if (rect.top > 0 && map3[indexTop] == map3[indexTop - width2] || rect.bottom < height2 && map3[indexBottom] == map3[indexBottom + width2])
      return true;
    indexTop++;
    indexBottom++;
  }
  return false;
}
function mergeCells(state, dispatch) {
  const sel = state.selection;
  if (!(sel instanceof CellSelection) || sel.$anchorCell.pos == sel.$headCell.pos)
    return false;
  const rect = selectedRect(state), { map: map3 } = rect;
  if (cellsOverlapRectangle(map3, rect)) return false;
  if (dispatch) {
    const tr2 = state.tr;
    const seen = {};
    let content2 = Fragment.empty;
    let mergedPos;
    let mergedCell;
    for (let row = rect.top; row < rect.bottom; row++) {
      for (let col = rect.left; col < rect.right; col++) {
        const cellPos = map3.map[row * map3.width + col];
        const cell = rect.table.nodeAt(cellPos);
        if (seen[cellPos] || !cell) continue;
        seen[cellPos] = true;
        if (mergedPos == null) {
          mergedPos = cellPos;
          mergedCell = cell;
        } else {
          if (!isEmpty(cell)) content2 = content2.append(cell.content);
          const mapped = tr2.mapping.map(cellPos + rect.tableStart);
          tr2.delete(mapped, mapped + cell.nodeSize);
        }
      }
    }
    if (mergedPos == null || mergedCell == null) {
      return true;
    }
    tr2.setNodeMarkup(mergedPos + rect.tableStart, null, {
      ...addColSpan(
        mergedCell.attrs,
        mergedCell.attrs.colspan,
        rect.right - rect.left - mergedCell.attrs.colspan
      ),
      rowspan: rect.bottom - rect.top
    });
    if (content2.size) {
      const end2 = mergedPos + 1 + mergedCell.content.size;
      const start4 = isEmpty(mergedCell) ? mergedPos + 1 : end2;
      tr2.replaceWith(start4 + rect.tableStart, end2 + rect.tableStart, content2);
    }
    tr2.setSelection(
      new CellSelection(tr2.doc.resolve(mergedPos + rect.tableStart))
    );
    dispatch(tr2);
  }
  return true;
}
function splitCell(state, dispatch) {
  const nodeTypes = tableNodeTypes(state.schema);
  return splitCellWithType(({ node: node2 }) => {
    return nodeTypes[node2.type.spec.tableRole];
  })(state, dispatch);
}
function splitCellWithType(getCellType) {
  return (state, dispatch) => {
    var _a3;
    const sel = state.selection;
    let cellNode;
    let cellPos;
    if (!(sel instanceof CellSelection)) {
      cellNode = cellWrapping(sel.$from);
      if (!cellNode) return false;
      cellPos = (_a3 = cellAround(sel.$from)) == null ? void 0 : _a3.pos;
    } else {
      if (sel.$anchorCell.pos != sel.$headCell.pos) return false;
      cellNode = sel.$anchorCell.nodeAfter;
      cellPos = sel.$anchorCell.pos;
    }
    if (cellNode == null || cellPos == null) {
      return false;
    }
    if (cellNode.attrs.colspan == 1 && cellNode.attrs.rowspan == 1) {
      return false;
    }
    if (dispatch) {
      let baseAttrs = cellNode.attrs;
      const attrs = [];
      const colwidth = baseAttrs.colwidth;
      if (baseAttrs.rowspan > 1) baseAttrs = { ...baseAttrs, rowspan: 1 };
      if (baseAttrs.colspan > 1) baseAttrs = { ...baseAttrs, colspan: 1 };
      const rect = selectedRect(state), tr2 = state.tr;
      for (let i = 0; i < rect.right - rect.left; i++)
        attrs.push(
          colwidth ? {
            ...baseAttrs,
            colwidth: colwidth && colwidth[i] ? [colwidth[i]] : null
          } : baseAttrs
        );
      let lastCell;
      for (let row = rect.top; row < rect.bottom; row++) {
        let pos = rect.map.positionAt(row, rect.left, rect.table);
        if (row == rect.top) pos += cellNode.nodeSize;
        for (let col = rect.left, i = 0; col < rect.right; col++, i++) {
          if (col == rect.left && row == rect.top) continue;
          tr2.insert(
            lastCell = tr2.mapping.map(pos + rect.tableStart, 1),
            getCellType({ node: cellNode, row, col }).createAndFill(attrs[i])
          );
        }
      }
      tr2.setNodeMarkup(
        cellPos,
        getCellType({ node: cellNode, row: rect.top, col: rect.left }),
        attrs[0]
      );
      if (sel instanceof CellSelection)
        tr2.setSelection(
          new CellSelection(
            tr2.doc.resolve(sel.$anchorCell.pos),
            lastCell ? tr2.doc.resolve(lastCell) : void 0
          )
        );
      dispatch(tr2);
    }
    return true;
  };
}
function setCellAttr(name2, value) {
  return function(state, dispatch) {
    if (!isInTable(state)) return false;
    const $cell = selectionCell(state);
    if ($cell.nodeAfter.attrs[name2] === value) return false;
    if (dispatch) {
      const tr2 = state.tr;
      if (state.selection instanceof CellSelection)
        state.selection.forEachCell((node2, pos) => {
          if (node2.attrs[name2] !== value)
            tr2.setNodeMarkup(pos, null, {
              ...node2.attrs,
              [name2]: value
            });
        });
      else
        tr2.setNodeMarkup($cell.pos, null, {
          ...$cell.nodeAfter.attrs,
          [name2]: value
        });
      dispatch(tr2);
    }
    return true;
  };
}
function deprecated_toggleHeader(type) {
  return function(state, dispatch) {
    if (!isInTable(state)) return false;
    if (dispatch) {
      const types2 = tableNodeTypes(state.schema);
      const rect = selectedRect(state), tr2 = state.tr;
      const cells = rect.map.cellsInRect(
        type == "column" ? {
          left: rect.left,
          top: 0,
          right: rect.right,
          bottom: rect.map.height
        } : type == "row" ? {
          left: 0,
          top: rect.top,
          right: rect.map.width,
          bottom: rect.bottom
        } : rect
      );
      const nodes = cells.map((pos) => rect.table.nodeAt(pos));
      for (let i = 0; i < cells.length; i++)
        if (nodes[i].type == types2.header_cell)
          tr2.setNodeMarkup(
            rect.tableStart + cells[i],
            types2.cell,
            nodes[i].attrs
          );
      if (tr2.steps.length == 0)
        for (let i = 0; i < cells.length; i++)
          tr2.setNodeMarkup(
            rect.tableStart + cells[i],
            types2.header_cell,
            nodes[i].attrs
          );
      dispatch(tr2);
    }
    return true;
  };
}
function isHeaderEnabledByType(type, rect, types2) {
  const cellPositions = rect.map.cellsInRect({
    left: 0,
    top: 0,
    right: type == "row" ? rect.map.width : 1,
    bottom: type == "column" ? rect.map.height : 1
  });
  for (let i = 0; i < cellPositions.length; i++) {
    const cell = rect.table.nodeAt(cellPositions[i]);
    if (cell && cell.type !== types2.header_cell) {
      return false;
    }
  }
  return true;
}
function toggleHeader(type, options) {
  options = options || { useDeprecatedLogic: false };
  if (options.useDeprecatedLogic) return deprecated_toggleHeader(type);
  return function(state, dispatch) {
    if (!isInTable(state)) return false;
    if (dispatch) {
      const types2 = tableNodeTypes(state.schema);
      const rect = selectedRect(state), tr2 = state.tr;
      const isHeaderRowEnabled = isHeaderEnabledByType("row", rect, types2);
      const isHeaderColumnEnabled = isHeaderEnabledByType(
        "column",
        rect,
        types2
      );
      const isHeaderEnabled = type === "column" ? isHeaderRowEnabled : type === "row" ? isHeaderColumnEnabled : false;
      const selectionStartsAt = isHeaderEnabled ? 1 : 0;
      const cellsRect = type == "column" ? {
        left: 0,
        top: selectionStartsAt,
        right: 1,
        bottom: rect.map.height
      } : type == "row" ? {
        left: selectionStartsAt,
        top: 0,
        right: rect.map.width,
        bottom: 1
      } : rect;
      const newType = type == "column" ? isHeaderColumnEnabled ? types2.cell : types2.header_cell : type == "row" ? isHeaderRowEnabled ? types2.cell : types2.header_cell : types2.cell;
      rect.map.cellsInRect(cellsRect).forEach((relativeCellPos) => {
        const cellPos = relativeCellPos + rect.tableStart;
        const cell = tr2.doc.nodeAt(cellPos);
        if (cell) {
          tr2.setNodeMarkup(cellPos, newType, cell.attrs);
        }
      });
      dispatch(tr2);
    }
    return true;
  };
}
toggleHeader("row", {
  useDeprecatedLogic: true
});
toggleHeader("column", {
  useDeprecatedLogic: true
});
var toggleHeaderCell = toggleHeader("cell", {
  useDeprecatedLogic: true
});
function findNextCell($cell, dir) {
  if (dir < 0) {
    const before = $cell.nodeBefore;
    if (before) return $cell.pos - before.nodeSize;
    for (let row = $cell.index(-1) - 1, rowEnd = $cell.before(); row >= 0; row--) {
      const rowNode = $cell.node(-1).child(row);
      const lastChild = rowNode.lastChild;
      if (lastChild) {
        return rowEnd - 1 - lastChild.nodeSize;
      }
      rowEnd -= rowNode.nodeSize;
    }
  } else {
    if ($cell.index() < $cell.parent.childCount - 1) {
      return $cell.pos + $cell.nodeAfter.nodeSize;
    }
    const table2 = $cell.node(-1);
    for (let row = $cell.indexAfter(-1), rowStart = $cell.after(); row < table2.childCount; row++) {
      const rowNode = table2.child(row);
      if (rowNode.childCount) return rowStart + 1;
      rowStart += rowNode.nodeSize;
    }
  }
  return null;
}
function goToNextCell(direction) {
  return function(state, dispatch) {
    if (!isInTable(state)) return false;
    const cell = findNextCell(selectionCell(state), direction);
    if (cell == null) return false;
    if (dispatch) {
      const $cell = state.doc.resolve(cell);
      dispatch(
        state.tr.setSelection(TextSelection.between($cell, moveCellForward($cell))).scrollIntoView()
      );
    }
    return true;
  };
}
function deleteTable(state, dispatch) {
  const $pos = state.selection.$anchor;
  for (let d2 = $pos.depth; d2 > 0; d2--) {
    const node2 = $pos.node(d2);
    if (node2.type.spec.tableRole == "table") {
      if (dispatch)
        dispatch(
          state.tr.delete($pos.before(d2), $pos.after(d2)).scrollIntoView()
        );
      return true;
    }
  }
  return false;
}
function deleteCellSelection(state, dispatch) {
  const sel = state.selection;
  if (!(sel instanceof CellSelection)) return false;
  if (dispatch) {
    const tr2 = state.tr;
    const baseContent = tableNodeTypes(state.schema).cell.createAndFill().content;
    sel.forEachCell((cell, pos) => {
      if (!cell.content.eq(baseContent))
        tr2.replace(
          tr2.mapping.map(pos + 1),
          tr2.mapping.map(pos + cell.nodeSize - 1),
          new Slice(baseContent, 0, 0)
        );
    });
    if (tr2.docChanged) dispatch(tr2);
  }
  return true;
}
function pastedCells(slice3) {
  if (!slice3.size) return null;
  let { content: content2, openStart, openEnd } = slice3;
  while (content2.childCount == 1 && (openStart > 0 && openEnd > 0 || content2.child(0).type.spec.tableRole == "table")) {
    openStart--;
    openEnd--;
    content2 = content2.child(0).content;
  }
  const first2 = content2.child(0);
  const role = first2.type.spec.tableRole;
  const schema = first2.type.schema, rows = [];
  if (role == "row") {
    for (let i = 0; i < content2.childCount; i++) {
      let cells = content2.child(i).content;
      const left2 = i ? 0 : Math.max(0, openStart - 1);
      const right2 = i < content2.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
      if (left2 || right2)
        cells = fitSlice(
          tableNodeTypes(schema).row,
          new Slice(cells, left2, right2)
        ).content;
      rows.push(cells);
    }
  } else if (role == "cell" || role == "header_cell") {
    rows.push(
      openStart || openEnd ? fitSlice(
        tableNodeTypes(schema).row,
        new Slice(content2, openStart, openEnd)
      ).content : content2
    );
  } else {
    return null;
  }
  return ensureRectangular(schema, rows);
}
function ensureRectangular(schema, rows) {
  const widths = [];
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];
    for (let j2 = row.childCount - 1; j2 >= 0; j2--) {
      const { rowspan, colspan } = row.child(j2).attrs;
      for (let r2 = i; r2 < i + rowspan; r2++)
        widths[r2] = (widths[r2] || 0) + colspan;
    }
  }
  let width2 = 0;
  for (let r2 = 0; r2 < widths.length; r2++) width2 = Math.max(width2, widths[r2]);
  for (let r2 = 0; r2 < widths.length; r2++) {
    if (r2 >= rows.length) rows.push(Fragment.empty);
    if (widths[r2] < width2) {
      const empty2 = tableNodeTypes(schema).cell.createAndFill();
      const cells = [];
      for (let i = widths[r2]; i < width2; i++) {
        cells.push(empty2);
      }
      rows[r2] = rows[r2].append(Fragment.from(cells));
    }
  }
  return { height: rows.length, width: width2, rows };
}
function fitSlice(nodeType, slice3) {
  const node2 = nodeType.createAndFill();
  const tr2 = new Transform(node2).replace(0, node2.content.size, slice3);
  return tr2.doc;
}
function clipCells({ width: width2, height: height2, rows }, newWidth, newHeight) {
  if (width2 != newWidth) {
    const added = [];
    const newRows = [];
    for (let row = 0; row < rows.length; row++) {
      const frag = rows[row], cells = [];
      for (let col = added[row] || 0, i = 0; col < newWidth; i++) {
        let cell = frag.child(i % frag.childCount);
        if (col + cell.attrs.colspan > newWidth)
          cell = cell.type.createChecked(
            removeColSpan(
              cell.attrs,
              cell.attrs.colspan,
              col + cell.attrs.colspan - newWidth
            ),
            cell.content
          );
        cells.push(cell);
        col += cell.attrs.colspan;
        for (let j2 = 1; j2 < cell.attrs.rowspan; j2++)
          added[row + j2] = (added[row + j2] || 0) + cell.attrs.colspan;
      }
      newRows.push(Fragment.from(cells));
    }
    rows = newRows;
    width2 = newWidth;
  }
  if (height2 != newHeight) {
    const newRows = [];
    for (let row = 0, i = 0; row < newHeight; row++, i++) {
      const cells = [], source = rows[i % height2];
      for (let j2 = 0; j2 < source.childCount; j2++) {
        let cell = source.child(j2);
        if (row + cell.attrs.rowspan > newHeight)
          cell = cell.type.create(
            {
              ...cell.attrs,
              rowspan: Math.max(1, newHeight - cell.attrs.rowspan)
            },
            cell.content
          );
        cells.push(cell);
      }
      newRows.push(Fragment.from(cells));
    }
    rows = newRows;
    height2 = newHeight;
  }
  return { width: width2, height: height2, rows };
}
function growTable(tr2, map3, table2, start4, width2, height2, mapFrom) {
  const schema = tr2.doc.type.schema;
  const types2 = tableNodeTypes(schema);
  let empty2;
  let emptyHead;
  if (width2 > map3.width) {
    for (let row = 0, rowEnd = 0; row < map3.height; row++) {
      const rowNode = table2.child(row);
      rowEnd += rowNode.nodeSize;
      const cells = [];
      let add4;
      if (rowNode.lastChild == null || rowNode.lastChild.type == types2.cell)
        add4 = empty2 || (empty2 = types2.cell.createAndFill());
      else add4 = emptyHead || (emptyHead = types2.header_cell.createAndFill());
      for (let i = map3.width; i < width2; i++) cells.push(add4);
      tr2.insert(tr2.mapping.slice(mapFrom).map(rowEnd - 1 + start4), cells);
    }
  }
  if (height2 > map3.height) {
    const cells = [];
    for (let i = 0, start22 = (map3.height - 1) * map3.width; i < Math.max(map3.width, width2); i++) {
      const header = i >= map3.width ? false : table2.nodeAt(map3.map[start22 + i]).type == types2.header_cell;
      cells.push(
        header ? emptyHead || (emptyHead = types2.header_cell.createAndFill()) : empty2 || (empty2 = types2.cell.createAndFill())
      );
    }
    const emptyRow = types2.row.create(null, Fragment.from(cells)), rows = [];
    for (let i = map3.height; i < height2; i++) rows.push(emptyRow);
    tr2.insert(tr2.mapping.slice(mapFrom).map(start4 + table2.nodeSize - 2), rows);
  }
  return !!(empty2 || emptyHead);
}
function isolateHorizontal(tr2, map3, table2, start4, left2, right2, top2, mapFrom) {
  if (top2 == 0 || top2 == map3.height) return false;
  let found2 = false;
  for (let col = left2; col < right2; col++) {
    const index2 = top2 * map3.width + col, pos = map3.map[index2];
    if (map3.map[index2 - map3.width] == pos) {
      found2 = true;
      const cell = table2.nodeAt(pos);
      const { top: cellTop, left: cellLeft } = map3.findCell(pos);
      tr2.setNodeMarkup(tr2.mapping.slice(mapFrom).map(pos + start4), null, {
        ...cell.attrs,
        rowspan: top2 - cellTop
      });
      tr2.insert(
        tr2.mapping.slice(mapFrom).map(map3.positionAt(top2, cellLeft, table2)),
        cell.type.createAndFill({
          ...cell.attrs,
          rowspan: cellTop + cell.attrs.rowspan - top2
        })
      );
      col += cell.attrs.colspan - 1;
    }
  }
  return found2;
}
function isolateVertical(tr2, map3, table2, start4, top2, bottom2, left2, mapFrom) {
  if (left2 == 0 || left2 == map3.width) return false;
  let found2 = false;
  for (let row = top2; row < bottom2; row++) {
    const index2 = row * map3.width + left2, pos = map3.map[index2];
    if (map3.map[index2 - 1] == pos) {
      found2 = true;
      const cell = table2.nodeAt(pos);
      const cellLeft = map3.colCount(pos);
      const updatePos = tr2.mapping.slice(mapFrom).map(pos + start4);
      tr2.setNodeMarkup(
        updatePos,
        null,
        removeColSpan(
          cell.attrs,
          left2 - cellLeft,
          cell.attrs.colspan - (left2 - cellLeft)
        )
      );
      tr2.insert(
        updatePos + cell.nodeSize,
        cell.type.createAndFill(
          removeColSpan(cell.attrs, 0, left2 - cellLeft)
        )
      );
      row += cell.attrs.rowspan - 1;
    }
  }
  return found2;
}
function insertCells(state, dispatch, tableStart, rect, cells) {
  let table2 = tableStart ? state.doc.nodeAt(tableStart - 1) : state.doc;
  if (!table2) {
    throw new Error("No table found");
  }
  let map3 = TableMap.get(table2);
  const { top: top2, left: left2 } = rect;
  const right2 = left2 + cells.width, bottom2 = top2 + cells.height;
  const tr2 = state.tr;
  let mapFrom = 0;
  function recomp() {
    table2 = tableStart ? tr2.doc.nodeAt(tableStart - 1) : tr2.doc;
    if (!table2) {
      throw new Error("No table found");
    }
    map3 = TableMap.get(table2);
    mapFrom = tr2.mapping.maps.length;
  }
  if (growTable(tr2, map3, table2, tableStart, right2, bottom2, mapFrom)) recomp();
  if (isolateHorizontal(tr2, map3, table2, tableStart, left2, right2, top2, mapFrom))
    recomp();
  if (isolateHorizontal(tr2, map3, table2, tableStart, left2, right2, bottom2, mapFrom))
    recomp();
  if (isolateVertical(tr2, map3, table2, tableStart, top2, bottom2, left2, mapFrom))
    recomp();
  if (isolateVertical(tr2, map3, table2, tableStart, top2, bottom2, right2, mapFrom))
    recomp();
  for (let row = top2; row < bottom2; row++) {
    const from3 = map3.positionAt(row, left2, table2), to2 = map3.positionAt(row, right2, table2);
    tr2.replace(
      tr2.mapping.slice(mapFrom).map(from3 + tableStart),
      tr2.mapping.slice(mapFrom).map(to2 + tableStart),
      new Slice(cells.rows[row - top2], 0, 0)
    );
  }
  recomp();
  tr2.setSelection(
    new CellSelection(
      tr2.doc.resolve(tableStart + map3.positionAt(top2, left2, table2)),
      tr2.doc.resolve(tableStart + map3.positionAt(bottom2 - 1, right2 - 1, table2))
    )
  );
  dispatch(tr2);
}
var handleKeyDown$1 = keydownHandler({
  ArrowLeft: arrow$1("horiz", -1),
  ArrowRight: arrow$1("horiz", 1),
  ArrowUp: arrow$1("vert", -1),
  ArrowDown: arrow$1("vert", 1),
  "Shift-ArrowLeft": shiftArrow("horiz", -1),
  "Shift-ArrowRight": shiftArrow("horiz", 1),
  "Shift-ArrowUp": shiftArrow("vert", -1),
  "Shift-ArrowDown": shiftArrow("vert", 1),
  Backspace: deleteCellSelection,
  "Mod-Backspace": deleteCellSelection,
  Delete: deleteCellSelection,
  "Mod-Delete": deleteCellSelection
});
function maybeSetSelection(state, dispatch, selection) {
  if (selection.eq(state.selection)) return false;
  if (dispatch) dispatch(state.tr.setSelection(selection).scrollIntoView());
  return true;
}
function arrow$1(axis, dir) {
  return (state, dispatch, view) => {
    if (!view) return false;
    const sel = state.selection;
    if (sel instanceof CellSelection) {
      return maybeSetSelection(
        state,
        dispatch,
        Selection.near(sel.$headCell, dir)
      );
    }
    if (axis != "horiz" && !sel.empty) return false;
    const end2 = atEndOfCell(view, axis, dir);
    if (end2 == null) return false;
    if (axis == "horiz") {
      return maybeSetSelection(
        state,
        dispatch,
        Selection.near(state.doc.resolve(sel.head + dir), dir)
      );
    } else {
      const $cell = state.doc.resolve(end2);
      const $next = nextCell($cell, axis, dir);
      let newSel;
      if ($next) newSel = Selection.near($next, 1);
      else if (dir < 0)
        newSel = Selection.near(state.doc.resolve($cell.before(-1)), -1);
      else newSel = Selection.near(state.doc.resolve($cell.after(-1)), 1);
      return maybeSetSelection(state, dispatch, newSel);
    }
  };
}
function shiftArrow(axis, dir) {
  return (state, dispatch, view) => {
    if (!view) return false;
    const sel = state.selection;
    let cellSel;
    if (sel instanceof CellSelection) {
      cellSel = sel;
    } else {
      const end2 = atEndOfCell(view, axis, dir);
      if (end2 == null) return false;
      cellSel = new CellSelection(state.doc.resolve(end2));
    }
    const $head = nextCell(cellSel.$headCell, axis, dir);
    if (!$head) return false;
    return maybeSetSelection(
      state,
      dispatch,
      new CellSelection(cellSel.$anchorCell, $head)
    );
  };
}
function handleTripleClick(view, pos) {
  const doc2 = view.state.doc, $cell = cellAround(doc2.resolve(pos));
  if (!$cell) return false;
  view.dispatch(view.state.tr.setSelection(new CellSelection($cell)));
  return true;
}
function handlePaste(view, _2, slice3) {
  if (!isInTable(view.state)) return false;
  let cells = pastedCells(slice3);
  const sel = view.state.selection;
  if (sel instanceof CellSelection) {
    if (!cells)
      cells = {
        width: 1,
        height: 1,
        rows: [
          Fragment.from(
            fitSlice(tableNodeTypes(view.state.schema).cell, slice3)
          )
        ]
      };
    const table2 = sel.$anchorCell.node(-1);
    const start4 = sel.$anchorCell.start(-1);
    const rect = TableMap.get(table2).rectBetween(
      sel.$anchorCell.pos - start4,
      sel.$headCell.pos - start4
    );
    cells = clipCells(cells, rect.right - rect.left, rect.bottom - rect.top);
    insertCells(view.state, view.dispatch, start4, rect, cells);
    return true;
  } else if (cells) {
    const $cell = selectionCell(view.state);
    const start4 = $cell.start(-1);
    insertCells(
      view.state,
      view.dispatch,
      start4,
      TableMap.get($cell.node(-1)).findCell($cell.pos - start4),
      cells
    );
    return true;
  } else {
    return false;
  }
}
function handleMouseDown(view, startEvent) {
  var _a3;
  if (startEvent.ctrlKey || startEvent.metaKey) return;
  const startDOMCell = domInCell(view, startEvent.target);
  let $anchor;
  if (startEvent.shiftKey && view.state.selection instanceof CellSelection) {
    setCellSelection(view.state.selection.$anchorCell, startEvent);
    startEvent.preventDefault();
  } else if (startEvent.shiftKey && startDOMCell && ($anchor = cellAround(view.state.selection.$anchor)) != null && ((_a3 = cellUnderMouse(view, startEvent)) == null ? void 0 : _a3.pos) != $anchor.pos) {
    setCellSelection($anchor, startEvent);
    startEvent.preventDefault();
  } else if (!startDOMCell) {
    return;
  }
  function setCellSelection($anchor2, event) {
    let $head = cellUnderMouse(view, event);
    const starting = tableEditingKey.getState(view.state) == null;
    if (!$head || !inSameTable($anchor2, $head)) {
      if (starting) $head = $anchor2;
      else return;
    }
    const selection = new CellSelection($anchor2, $head);
    if (starting || !view.state.selection.eq(selection)) {
      const tr2 = view.state.tr.setSelection(selection);
      if (starting) tr2.setMeta(tableEditingKey, $anchor2.pos);
      view.dispatch(tr2);
    }
  }
  function stop() {
    view.root.removeEventListener("mouseup", stop);
    view.root.removeEventListener("dragstart", stop);
    view.root.removeEventListener("mousemove", move4);
    if (tableEditingKey.getState(view.state) != null)
      view.dispatch(view.state.tr.setMeta(tableEditingKey, -1));
  }
  function move4(_event) {
    const event = _event;
    const anchor = tableEditingKey.getState(view.state);
    let $anchor2;
    if (anchor != null) {
      $anchor2 = view.state.doc.resolve(anchor);
    } else if (domInCell(view, event.target) != startDOMCell) {
      $anchor2 = cellUnderMouse(view, startEvent);
      if (!$anchor2) return stop();
    }
    if ($anchor2) setCellSelection($anchor2, event);
  }
  view.root.addEventListener("mouseup", stop);
  view.root.addEventListener("dragstart", stop);
  view.root.addEventListener("mousemove", move4);
}
function atEndOfCell(view, axis, dir) {
  if (!(view.state.selection instanceof TextSelection)) return null;
  const { $head } = view.state.selection;
  for (let d2 = $head.depth - 1; d2 >= 0; d2--) {
    const parent2 = $head.node(d2), index2 = dir < 0 ? $head.index(d2) : $head.indexAfter(d2);
    if (index2 != (dir < 0 ? 0 : parent2.childCount)) return null;
    if (parent2.type.spec.tableRole == "cell" || parent2.type.spec.tableRole == "header_cell") {
      const cellPos = $head.before(d2);
      const dirStr = axis == "vert" ? dir > 0 ? "down" : "up" : dir > 0 ? "right" : "left";
      return view.endOfTextblock(dirStr) ? cellPos : null;
    }
  }
  return null;
}
function domInCell(view, dom) {
  for (; dom && dom != view.dom; dom = dom.parentNode) {
    if (dom.nodeName == "TD" || dom.nodeName == "TH") {
      return dom;
    }
  }
  return null;
}
function cellUnderMouse(view, event) {
  const mousePos = view.posAtCoords({
    left: event.clientX,
    top: event.clientY
  });
  if (!mousePos) return null;
  return mousePos ? cellAround(view.state.doc.resolve(mousePos.pos)) : null;
}
var TableView$1 = class TableView {
  constructor(node2, defaultCellMinWidth) {
    this.node = node2;
    this.defaultCellMinWidth = defaultCellMinWidth;
    this.dom = document.createElement("div");
    this.dom.className = "tableWrapper";
    this.table = this.dom.appendChild(document.createElement("table"));
    this.table.style.setProperty(
      "--default-cell-min-width",
      `${defaultCellMinWidth}px`
    );
    this.colgroup = this.table.appendChild(document.createElement("colgroup"));
    updateColumnsOnResize(node2, this.colgroup, this.table, defaultCellMinWidth);
    this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(node2) {
    if (node2.type != this.node.type) return false;
    this.node = node2;
    updateColumnsOnResize(
      node2,
      this.colgroup,
      this.table,
      this.defaultCellMinWidth
    );
    return true;
  }
  ignoreMutation(record) {
    return record.type == "attributes" && (record.target == this.table || this.colgroup.contains(record.target));
  }
};
function updateColumnsOnResize(node2, colgroup, table2, defaultCellMinWidth, overrideCol, overrideValue) {
  var _a3;
  let totalWidth = 0;
  let fixedWidth = true;
  let nextDOM = colgroup.firstChild;
  const row = node2.firstChild;
  if (!row) return;
  for (let i = 0, col = 0; i < row.childCount; i++) {
    const { colspan, colwidth } = row.child(i).attrs;
    for (let j2 = 0; j2 < colspan; j2++, col++) {
      const hasWidth = overrideCol == col ? overrideValue : colwidth && colwidth[j2];
      const cssWidth = hasWidth ? hasWidth + "px" : "";
      totalWidth += hasWidth || defaultCellMinWidth;
      if (!hasWidth) fixedWidth = false;
      if (!nextDOM) {
        const col2 = document.createElement("col");
        col2.style.width = cssWidth;
        colgroup.appendChild(col2);
      } else {
        if (nextDOM.style.width != cssWidth) {
          nextDOM.style.width = cssWidth;
        }
        nextDOM = nextDOM.nextSibling;
      }
    }
  }
  while (nextDOM) {
    const after = nextDOM.nextSibling;
    (_a3 = nextDOM.parentNode) == null ? void 0 : _a3.removeChild(nextDOM);
    nextDOM = after;
  }
  if (fixedWidth) {
    table2.style.width = totalWidth + "px";
    table2.style.minWidth = "";
  } else {
    table2.style.width = "";
    table2.style.minWidth = totalWidth + "px";
  }
}
var columnResizingPluginKey = new PluginKey(
  "tableColumnResizing"
);
function columnResizing({
  handleWidth = 5,
  cellMinWidth = 25,
  defaultCellMinWidth = 100,
  View = TableView$1,
  lastColumnResizable = true
} = {}) {
  const plugin2 = new Plugin({
    key: columnResizingPluginKey,
    state: {
      init(_2, state) {
        var _a3, _b;
        const nodeViews = (_b = (_a3 = plugin2.spec) == null ? void 0 : _a3.props) == null ? void 0 : _b.nodeViews;
        const tableName = tableNodeTypes(state.schema).table.name;
        if (View && nodeViews) {
          nodeViews[tableName] = (node2, view) => {
            return new View(node2, defaultCellMinWidth, view);
          };
        }
        return new ResizeState(-1, false);
      },
      apply(tr2, prev2) {
        return prev2.apply(tr2);
      }
    },
    props: {
      attributes: (state) => {
        const pluginState = columnResizingPluginKey.getState(state);
        return pluginState && pluginState.activeHandle > -1 ? { class: "resize-cursor" } : {};
      },
      handleDOMEvents: {
        mousemove: (view, event) => {
          handleMouseMove(view, event, handleWidth, lastColumnResizable);
        },
        mouseleave: (view) => {
          handleMouseLeave(view);
        },
        mousedown: (view, event) => {
          handleMouseDown2(view, event, cellMinWidth, defaultCellMinWidth);
        }
      },
      decorations: (state) => {
        const pluginState = columnResizingPluginKey.getState(state);
        if (pluginState && pluginState.activeHandle > -1) {
          return handleDecorations(state, pluginState.activeHandle);
        }
      },
      nodeViews: {}
    }
  });
  return plugin2;
}
var ResizeState = class _ResizeState {
  constructor(activeHandle, dragging) {
    this.activeHandle = activeHandle;
    this.dragging = dragging;
  }
  apply(tr2) {
    const state = this;
    const action = tr2.getMeta(columnResizingPluginKey);
    if (action && action.setHandle != null)
      return new _ResizeState(action.setHandle, false);
    if (action && action.setDragging !== void 0)
      return new _ResizeState(state.activeHandle, action.setDragging);
    if (state.activeHandle > -1 && tr2.docChanged) {
      let handle2 = tr2.mapping.map(state.activeHandle, -1);
      if (!pointsAtCell(tr2.doc.resolve(handle2))) {
        handle2 = -1;
      }
      return new _ResizeState(handle2, state.dragging);
    }
    return state;
  }
};
function handleMouseMove(view, event, handleWidth, lastColumnResizable) {
  if (!view.editable) return;
  const pluginState = columnResizingPluginKey.getState(view.state);
  if (!pluginState) return;
  if (!pluginState.dragging) {
    const target = domCellAround(event.target);
    let cell = -1;
    if (target) {
      const { left: left2, right: right2 } = target.getBoundingClientRect();
      if (event.clientX - left2 <= handleWidth)
        cell = edgeCell(view, event, "left", handleWidth);
      else if (right2 - event.clientX <= handleWidth)
        cell = edgeCell(view, event, "right", handleWidth);
    }
    if (cell != pluginState.activeHandle) {
      if (!lastColumnResizable && cell !== -1) {
        const $cell = view.state.doc.resolve(cell);
        const table2 = $cell.node(-1);
        const map3 = TableMap.get(table2);
        const tableStart = $cell.start(-1);
        const col = map3.colCount($cell.pos - tableStart) + $cell.nodeAfter.attrs.colspan - 1;
        if (col == map3.width - 1) {
          return;
        }
      }
      updateHandle(view, cell);
    }
  }
}
function handleMouseLeave(view) {
  if (!view.editable) return;
  const pluginState = columnResizingPluginKey.getState(view.state);
  if (pluginState && pluginState.activeHandle > -1 && !pluginState.dragging)
    updateHandle(view, -1);
}
function handleMouseDown2(view, event, cellMinWidth, defaultCellMinWidth) {
  var _a3;
  if (!view.editable) return false;
  const win = (_a3 = view.dom.ownerDocument.defaultView) != null ? _a3 : window;
  const pluginState = columnResizingPluginKey.getState(view.state);
  if (!pluginState || pluginState.activeHandle == -1 || pluginState.dragging)
    return false;
  const cell = view.state.doc.nodeAt(pluginState.activeHandle);
  const width2 = currentColWidth(view, pluginState.activeHandle, cell.attrs);
  view.dispatch(
    view.state.tr.setMeta(columnResizingPluginKey, {
      setDragging: { startX: event.clientX, startWidth: width2 }
    })
  );
  function finish4(event2) {
    win.removeEventListener("mouseup", finish4);
    win.removeEventListener("mousemove", move4);
    const pluginState2 = columnResizingPluginKey.getState(view.state);
    if (pluginState2 == null ? void 0 : pluginState2.dragging) {
      updateColumnWidth(
        view,
        pluginState2.activeHandle,
        draggedWidth(pluginState2.dragging, event2, cellMinWidth)
      );
      view.dispatch(
        view.state.tr.setMeta(columnResizingPluginKey, { setDragging: null })
      );
    }
  }
  function move4(event2) {
    if (!event2.which) return finish4(event2);
    const pluginState2 = columnResizingPluginKey.getState(view.state);
    if (!pluginState2) return;
    if (pluginState2.dragging) {
      const dragged = draggedWidth(pluginState2.dragging, event2, cellMinWidth);
      displayColumnWidth(
        view,
        pluginState2.activeHandle,
        dragged,
        defaultCellMinWidth
      );
    }
  }
  displayColumnWidth(
    view,
    pluginState.activeHandle,
    width2,
    defaultCellMinWidth
  );
  win.addEventListener("mouseup", finish4);
  win.addEventListener("mousemove", move4);
  event.preventDefault();
  return true;
}
function currentColWidth(view, cellPos, { colspan, colwidth }) {
  const width2 = colwidth && colwidth[colwidth.length - 1];
  if (width2) return width2;
  const dom = view.domAtPos(cellPos);
  const node2 = dom.node.childNodes[dom.offset];
  let domWidth = node2.offsetWidth, parts = colspan;
  if (colwidth) {
    for (let i = 0; i < colspan; i++)
      if (colwidth[i]) {
        domWidth -= colwidth[i];
        parts--;
      }
  }
  return domWidth / parts;
}
function domCellAround(target) {
  while (target && target.nodeName != "TD" && target.nodeName != "TH")
    target = target.classList && target.classList.contains("ProseMirror") ? null : target.parentNode;
  return target;
}
function edgeCell(view, event, side, handleWidth) {
  const offset3 = side == "right" ? -handleWidth : handleWidth;
  const found2 = view.posAtCoords({
    left: event.clientX + offset3,
    top: event.clientY
  });
  if (!found2) return -1;
  const { pos } = found2;
  const $cell = cellAround(view.state.doc.resolve(pos));
  if (!$cell) return -1;
  if (side == "right") return $cell.pos;
  const map3 = TableMap.get($cell.node(-1)), start4 = $cell.start(-1);
  const index2 = map3.map.indexOf($cell.pos - start4);
  return index2 % map3.width == 0 ? -1 : start4 + map3.map[index2 - 1];
}
function draggedWidth(dragging, event, resizeMinWidth) {
  const offset3 = event.clientX - dragging.startX;
  return Math.max(resizeMinWidth, dragging.startWidth + offset3);
}
function updateHandle(view, value) {
  view.dispatch(
    view.state.tr.setMeta(columnResizingPluginKey, { setHandle: value })
  );
}
function updateColumnWidth(view, cell, width2) {
  const $cell = view.state.doc.resolve(cell);
  const table2 = $cell.node(-1), map3 = TableMap.get(table2), start4 = $cell.start(-1);
  const col = map3.colCount($cell.pos - start4) + $cell.nodeAfter.attrs.colspan - 1;
  const tr2 = view.state.tr;
  for (let row = 0; row < map3.height; row++) {
    const mapIndex = row * map3.width + col;
    if (row && map3.map[mapIndex] == map3.map[mapIndex - map3.width]) continue;
    const pos = map3.map[mapIndex];
    const attrs = table2.nodeAt(pos).attrs;
    const index2 = attrs.colspan == 1 ? 0 : col - map3.colCount(pos);
    if (attrs.colwidth && attrs.colwidth[index2] == width2) continue;
    const colwidth = attrs.colwidth ? attrs.colwidth.slice() : zeroes(attrs.colspan);
    colwidth[index2] = width2;
    tr2.setNodeMarkup(start4 + pos, null, { ...attrs, colwidth });
  }
  if (tr2.docChanged) view.dispatch(tr2);
}
function displayColumnWidth(view, cell, width2, defaultCellMinWidth) {
  const $cell = view.state.doc.resolve(cell);
  const table2 = $cell.node(-1), start4 = $cell.start(-1);
  const col = TableMap.get(table2).colCount($cell.pos - start4) + $cell.nodeAfter.attrs.colspan - 1;
  let dom = view.domAtPos($cell.start(-1)).node;
  while (dom && dom.nodeName != "TABLE") {
    dom = dom.parentNode;
  }
  if (!dom) return;
  updateColumnsOnResize(
    table2,
    dom.firstChild,
    dom,
    defaultCellMinWidth,
    col,
    width2
  );
}
function zeroes(n2) {
  return Array(n2).fill(0);
}
function handleDecorations(state, cell) {
  var _a3;
  const decorations = [];
  const $cell = state.doc.resolve(cell);
  const table2 = $cell.node(-1);
  if (!table2) {
    return DecorationSet.empty;
  }
  const map3 = TableMap.get(table2);
  const start4 = $cell.start(-1);
  const col = map3.colCount($cell.pos - start4) + $cell.nodeAfter.attrs.colspan - 1;
  for (let row = 0; row < map3.height; row++) {
    const index2 = col + row * map3.width;
    if ((col == map3.width - 1 || map3.map[index2] != map3.map[index2 + 1]) && (row == 0 || map3.map[index2] != map3.map[index2 - map3.width])) {
      const cellPos = map3.map[index2];
      const pos = start4 + cellPos + table2.nodeAt(cellPos).nodeSize - 1;
      const dom = document.createElement("div");
      dom.className = "column-resize-handle";
      if ((_a3 = columnResizingPluginKey.getState(state)) == null ? void 0 : _a3.dragging) {
        decorations.push(
          Decoration.node(
            start4 + cellPos,
            start4 + cellPos + table2.nodeAt(cellPos).nodeSize,
            {
              class: "column-resize-dragging"
            }
          )
        );
      }
      decorations.push(Decoration.widget(pos, dom));
    }
  }
  return DecorationSet.create(state.doc, decorations);
}
function tableEditing({
  allowTableNodeSelection = false
} = {}) {
  return new Plugin({
    key: tableEditingKey,
    // This piece of state is used to remember when a mouse-drag
    // cell-selection is happening, so that it can continue even as
    // transactions (which might move its anchor cell) come in.
    state: {
      init() {
        return null;
      },
      apply(tr2, cur) {
        const set2 = tr2.getMeta(tableEditingKey);
        if (set2 != null) return set2 == -1 ? null : set2;
        if (cur == null || !tr2.docChanged) return cur;
        const { deleted, pos } = tr2.mapping.mapResult(cur);
        return deleted ? null : pos;
      }
    },
    props: {
      decorations: drawCellSelection,
      handleDOMEvents: {
        mousedown: handleMouseDown
      },
      createSelectionBetween(view) {
        return tableEditingKey.getState(view.state) != null ? view.state.selection : null;
      },
      handleTripleClick,
      handleKeyDown: handleKeyDown$1,
      handlePaste
    },
    appendTransaction(_2, oldState, state) {
      return normalizeSelection(
        state,
        fixTables(state, oldState),
        allowTableNodeSelection
      );
    }
  });
}
function getColStyleDeclaration(minWidth2, width2) {
  if (width2) {
    return ["width", `${Math.max(width2, minWidth2)}px`];
  }
  return ["min-width", `${minWidth2}px`];
}
function updateColumns(node2, colgroup, table2, cellMinWidth, overrideCol, overrideValue) {
  var _a3;
  let totalWidth = 0;
  let fixedWidth = true;
  let nextDOM = colgroup.firstChild;
  const row = node2.firstChild;
  if (row !== null) {
    for (let i = 0, col = 0; i < row.childCount; i += 1) {
      const { colspan, colwidth } = row.child(i).attrs;
      for (let j2 = 0; j2 < colspan; j2 += 1, col += 1) {
        const hasWidth = overrideCol === col ? overrideValue : colwidth && colwidth[j2];
        const cssWidth = hasWidth ? `${hasWidth}px` : "";
        totalWidth += hasWidth || cellMinWidth;
        if (!hasWidth) {
          fixedWidth = false;
        }
        if (!nextDOM) {
          const colElement = document.createElement("col");
          const [propertyKey, propertyValue] = getColStyleDeclaration(cellMinWidth, hasWidth);
          colElement.style.setProperty(propertyKey, propertyValue);
          colgroup.appendChild(colElement);
        } else {
          if (nextDOM.style.width !== cssWidth) {
            const [propertyKey, propertyValue] = getColStyleDeclaration(cellMinWidth, hasWidth);
            nextDOM.style.setProperty(propertyKey, propertyValue);
          }
          nextDOM = nextDOM.nextSibling;
        }
      }
    }
  }
  while (nextDOM) {
    const after = nextDOM.nextSibling;
    (_a3 = nextDOM.parentNode) === null || _a3 === void 0 ? void 0 : _a3.removeChild(nextDOM);
    nextDOM = after;
  }
  if (fixedWidth) {
    table2.style.width = `${totalWidth}px`;
    table2.style.minWidth = "";
  } else {
    table2.style.width = "";
    table2.style.minWidth = `${totalWidth}px`;
  }
}
class TableView2 {
  constructor(node2, cellMinWidth) {
    this.node = node2;
    this.cellMinWidth = cellMinWidth;
    this.dom = document.createElement("div");
    this.dom.className = "tableWrapper";
    this.table = this.dom.appendChild(document.createElement("table"));
    this.colgroup = this.table.appendChild(document.createElement("colgroup"));
    updateColumns(node2, this.colgroup, this.table, cellMinWidth);
    this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(node2) {
    if (node2.type !== this.node.type) {
      return false;
    }
    this.node = node2;
    updateColumns(node2, this.colgroup, this.table, this.cellMinWidth);
    return true;
  }
  ignoreMutation(mutation) {
    return mutation.type === "attributes" && (mutation.target === this.table || this.colgroup.contains(mutation.target));
  }
}
function createColGroup(node2, cellMinWidth, overrideCol, overrideValue) {
  let totalWidth = 0;
  let fixedWidth = true;
  const cols = [];
  const row = node2.firstChild;
  if (!row) {
    return {};
  }
  for (let i = 0, col = 0; i < row.childCount; i += 1) {
    const { colspan, colwidth } = row.child(i).attrs;
    for (let j2 = 0; j2 < colspan; j2 += 1, col += 1) {
      const hasWidth = overrideCol === col ? overrideValue : colwidth && colwidth[j2];
      totalWidth += hasWidth || cellMinWidth;
      if (!hasWidth) {
        fixedWidth = false;
      }
      const [property, value] = getColStyleDeclaration(cellMinWidth, hasWidth);
      cols.push([
        "col",
        { style: `${property}: ${value}` }
      ]);
    }
  }
  const tableWidth = fixedWidth ? `${totalWidth}px` : "";
  const tableMinWidth = fixedWidth ? "" : `${totalWidth}px`;
  const colgroup = ["colgroup", {}, ...cols];
  return { colgroup, tableWidth, tableMinWidth };
}
function createCell(cellType, cellContent) {
  return cellType.createAndFill();
}
function getTableNodeTypes(schema) {
  if (schema.cached.tableNodeTypes) {
    return schema.cached.tableNodeTypes;
  }
  const roles = {};
  Object.keys(schema.nodes).forEach((type) => {
    const nodeType = schema.nodes[type];
    if (nodeType.spec.tableRole) {
      roles[nodeType.spec.tableRole] = nodeType;
    }
  });
  schema.cached.tableNodeTypes = roles;
  return roles;
}
function createTable(schema, rowsCount, colsCount, withHeaderRow, cellContent) {
  const types2 = getTableNodeTypes(schema);
  const headerCells = [];
  const cells = [];
  for (let index2 = 0; index2 < colsCount; index2 += 1) {
    const cell = createCell(types2.cell);
    if (cell) {
      cells.push(cell);
    }
    if (withHeaderRow) {
      const headerCell = createCell(types2.header_cell);
      if (headerCell) {
        headerCells.push(headerCell);
      }
    }
  }
  const rows = [];
  for (let index2 = 0; index2 < rowsCount; index2 += 1) {
    rows.push(types2.row.createChecked(null, withHeaderRow && index2 === 0 ? headerCells : cells));
  }
  return types2.table.createChecked(null, rows);
}
function isCellSelection(value) {
  return value instanceof CellSelection;
}
const deleteTableWhenAllCellsSelected = ({ editor }) => {
  const { selection } = editor.state;
  if (!isCellSelection(selection)) {
    return false;
  }
  let cellCount = 0;
  const table2 = findParentNodeClosestToPos(selection.ranges[0].$from, (node2) => {
    return node2.type.name === "table";
  });
  table2 === null || table2 === void 0 ? void 0 : table2.node.descendants((node2) => {
    if (node2.type.name === "table") {
      return false;
    }
    if (["tableCell", "tableHeader"].includes(node2.type.name)) {
      cellCount += 1;
    }
  });
  const allCellsSelected = cellCount === selection.ranges.length;
  if (!allCellsSelected) {
    return false;
  }
  editor.commands.deleteTable();
  return true;
};
const Table2 = Node$1.create({
  name: "table",
  // @ts-ignore
  addOptions() {
    return {
      HTMLAttributes: {},
      resizable: false,
      handleWidth: 5,
      cellMinWidth: 25,
      // TODO: fix
      View: TableView2,
      lastColumnResizable: true,
      allowTableNodeSelection: false
    };
  },
  content: "tableRow+",
  tableRole: "table",
  isolating: true,
  group: "block",
  parseHTML() {
    return [{ tag: "table" }];
  },
  renderHTML({ node: node2, HTMLAttributes }) {
    const { colgroup, tableWidth, tableMinWidth } = createColGroup(node2, this.options.cellMinWidth);
    const table2 = [
      "table",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        style: tableWidth ? `width: ${tableWidth}` : `min-width: ${tableMinWidth}`
      }),
      colgroup,
      ["tbody", 0]
    ];
    return table2;
  },
  addCommands() {
    return {
      insertTable: ({ rows = 3, cols = 3, withHeaderRow = true } = {}) => ({ tr: tr2, dispatch, editor }) => {
        const node2 = createTable(editor.schema, rows, cols, withHeaderRow);
        if (dispatch) {
          const offset3 = tr2.selection.from + 1;
          tr2.replaceSelectionWith(node2).scrollIntoView().setSelection(TextSelection.near(tr2.doc.resolve(offset3)));
        }
        return true;
      },
      addColumnBefore: () => ({ state, dispatch }) => {
        return addColumnBefore(state, dispatch);
      },
      addColumnAfter: () => ({ state, dispatch }) => {
        return addColumnAfter(state, dispatch);
      },
      deleteColumn: () => ({ state, dispatch }) => {
        return deleteColumn(state, dispatch);
      },
      addRowBefore: () => ({ state, dispatch }) => {
        return addRowBefore(state, dispatch);
      },
      addRowAfter: () => ({ state, dispatch }) => {
        return addRowAfter(state, dispatch);
      },
      deleteRow: () => ({ state, dispatch }) => {
        return deleteRow(state, dispatch);
      },
      deleteTable: () => ({ state, dispatch }) => {
        return deleteTable(state, dispatch);
      },
      mergeCells: () => ({ state, dispatch }) => {
        return mergeCells(state, dispatch);
      },
      splitCell: () => ({ state, dispatch }) => {
        return splitCell(state, dispatch);
      },
      toggleHeaderColumn: () => ({ state, dispatch }) => {
        return toggleHeader("column")(state, dispatch);
      },
      toggleHeaderRow: () => ({ state, dispatch }) => {
        return toggleHeader("row")(state, dispatch);
      },
      toggleHeaderCell: () => ({ state, dispatch }) => {
        return toggleHeaderCell(state, dispatch);
      },
      mergeOrSplit: () => ({ state, dispatch }) => {
        if (mergeCells(state, dispatch)) {
          return true;
        }
        return splitCell(state, dispatch);
      },
      setCellAttribute: (name2, value) => ({ state, dispatch }) => {
        return setCellAttr(name2, value)(state, dispatch);
      },
      goToNextCell: () => ({ state, dispatch }) => {
        return goToNextCell(1)(state, dispatch);
      },
      goToPreviousCell: () => ({ state, dispatch }) => {
        return goToNextCell(-1)(state, dispatch);
      },
      fixTables: () => ({ state, dispatch }) => {
        if (dispatch) {
          fixTables(state);
        }
        return true;
      },
      setCellSelection: (position4) => ({ tr: tr2, dispatch }) => {
        if (dispatch) {
          const selection = CellSelection.create(tr2.doc, position4.anchorCell, position4.headCell);
          tr2.setSelection(selection);
        }
        return true;
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      Tab: () => {
        if (this.editor.commands.goToNextCell()) {
          return true;
        }
        if (!this.editor.can().addRowAfter()) {
          return false;
        }
        return this.editor.chain().addRowAfter().goToNextCell().run();
      },
      "Shift-Tab": () => this.editor.commands.goToPreviousCell(),
      Backspace: deleteTableWhenAllCellsSelected,
      "Mod-Backspace": deleteTableWhenAllCellsSelected,
      Delete: deleteTableWhenAllCellsSelected,
      "Mod-Delete": deleteTableWhenAllCellsSelected
    };
  },
  addProseMirrorPlugins() {
    const isResizable = this.options.resizable && this.editor.isEditable;
    return [
      ...isResizable ? [
        columnResizing({
          handleWidth: this.options.handleWidth,
          cellMinWidth: this.options.cellMinWidth,
          defaultCellMinWidth: this.options.cellMinWidth,
          View: this.options.View,
          lastColumnResizable: this.options.lastColumnResizable
        })
      ] : [],
      tableEditing({
        allowTableNodeSelection: this.options.allowTableNodeSelection
      })
    ];
  },
  extendNodeSchema(extension2) {
    const context = {
      name: extension2.name,
      options: extension2.options,
      storage: extension2.storage
    };
    return {
      tableRole: callOrReturn(getExtensionField(extension2, "tableRole", context))
    };
  }
});
const TableCell = Node$1.create({
  name: "tableCell",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (element2) => {
          const colwidth = element2.getAttribute("colwidth");
          const value = colwidth ? colwidth.split(",").map((width2) => parseInt(width2, 10)) : null;
          return value;
        }
      }
    };
  },
  tableRole: "cell",
  isolating: true,
  parseHTML() {
    return [
      { tag: "td" }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["td", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  }
});
const TableHeader = Node$1.create({
  name: "tableHeader",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (element2) => {
          const colwidth = element2.getAttribute("colwidth");
          const value = colwidth ? colwidth.split(",").map((width2) => parseInt(width2, 10)) : null;
          return value;
        }
      }
    };
  },
  tableRole: "header_cell",
  isolating: true,
  parseHTML() {
    return [
      { tag: "th" }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["th", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  }
});
const TableRow = Node$1.create({
  name: "tableRow",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "(tableCell | tableHeader)*",
  tableRole: "row",
  parseHTML() {
    return [
      { tag: "tr" }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["tr", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  }
});
const encodedTlds = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2";
const encodedUtlds = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2";
const numeric = "numeric";
const ascii = "ascii";
const alpha = "alpha";
const asciinumeric = "asciinumeric";
const alphanumeric = "alphanumeric";
const domain = "domain";
const emoji = "emoji";
const scheme = "scheme";
const slashscheme = "slashscheme";
const whitespace = "whitespace";
function registerGroup(name2, groups) {
  if (!(name2 in groups)) {
    groups[name2] = [];
  }
  return groups[name2];
}
function addToGroups(t2, flags, groups) {
  if (flags[numeric]) {
    flags[asciinumeric] = true;
    flags[alphanumeric] = true;
  }
  if (flags[ascii]) {
    flags[asciinumeric] = true;
    flags[alpha] = true;
  }
  if (flags[asciinumeric]) {
    flags[alphanumeric] = true;
  }
  if (flags[alpha]) {
    flags[alphanumeric] = true;
  }
  if (flags[alphanumeric]) {
    flags[domain] = true;
  }
  if (flags[emoji]) {
    flags[domain] = true;
  }
  for (const k2 in flags) {
    const group = registerGroup(k2, groups);
    if (group.indexOf(t2) < 0) {
      group.push(t2);
    }
  }
}
function flagsForToken(t2, groups) {
  const result = {};
  for (const c2 in groups) {
    if (groups[c2].indexOf(t2) >= 0) {
      result[c2] = true;
    }
  }
  return result;
}
function State(token2 = null) {
  this.j = {};
  this.jr = [];
  this.jd = null;
  this.t = token2;
}
State.groups = {};
State.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(input) {
    const state = this;
    const nextState = state.j[input];
    if (nextState) {
      return nextState;
    }
    for (let i = 0; i < state.jr.length; i++) {
      const regex2 = state.jr[i][0];
      const nextState2 = state.jr[i][1];
      if (nextState2 && regex2.test(input)) {
        return nextState2;
      }
    }
    return state.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(input, exactOnly = false) {
    return exactOnly ? input in this.j : !!this.go(input);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(inputs, next2, flags, groups) {
    for (let i = 0; i < inputs.length; i++) {
      this.tt(inputs[i], next2, flags, groups);
    }
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(regexp, next2, flags, groups) {
    groups = groups || State.groups;
    let nextState;
    if (next2 && next2.j) {
      nextState = next2;
    } else {
      nextState = new State(next2);
      if (flags && groups) {
        addToGroups(next2, flags, groups);
      }
    }
    this.jr.push([regexp, nextState]);
    return nextState;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(input, next2, flags, groups) {
    let state = this;
    const len = input.length;
    if (!len) {
      return state;
    }
    for (let i = 0; i < len - 1; i++) {
      state = state.tt(input[i]);
    }
    return state.tt(input[len - 1], next2, flags, groups);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(input, next2, flags, groups) {
    groups = groups || State.groups;
    const state = this;
    if (next2 && next2.j) {
      state.j[input] = next2;
      return next2;
    }
    const t2 = next2;
    let nextState, templateState = state.go(input);
    if (templateState) {
      nextState = new State();
      Object.assign(nextState.j, templateState.j);
      nextState.jr.push.apply(nextState.jr, templateState.jr);
      nextState.jd = templateState.jd;
      nextState.t = templateState.t;
    } else {
      nextState = new State();
    }
    if (t2) {
      if (groups) {
        if (nextState.t && typeof nextState.t === "string") {
          const allFlags = Object.assign(flagsForToken(nextState.t, groups), flags);
          addToGroups(t2, allFlags, groups);
        } else if (flags) {
          addToGroups(t2, flags, groups);
        }
      }
      nextState.t = t2;
    }
    state.j[input] = nextState;
    return nextState;
  }
};
const ta = (state, input, next2, flags, groups) => state.ta(input, next2, flags, groups);
const tr = (state, regexp, next2, flags, groups) => state.tr(regexp, next2, flags, groups);
const ts = (state, input, next2, flags, groups) => state.ts(input, next2, flags, groups);
const tt = (state, input, next2, flags, groups) => state.tt(input, next2, flags, groups);
const WORD = "WORD";
const UWORD = "UWORD";
const ASCIINUMERICAL = "ASCIINUMERICAL";
const ALPHANUMERICAL = "ALPHANUMERICAL";
const LOCALHOST = "LOCALHOST";
const TLD = "TLD";
const UTLD = "UTLD";
const SCHEME = "SCHEME";
const SLASH_SCHEME = "SLASH_SCHEME";
const NUM = "NUM";
const WS = "WS";
const NL = "NL";
const OPENBRACE = "OPENBRACE";
const CLOSEBRACE = "CLOSEBRACE";
const OPENBRACKET = "OPENBRACKET";
const CLOSEBRACKET = "CLOSEBRACKET";
const OPENPAREN = "OPENPAREN";
const CLOSEPAREN = "CLOSEPAREN";
const OPENANGLEBRACKET = "OPENANGLEBRACKET";
const CLOSEANGLEBRACKET = "CLOSEANGLEBRACKET";
const FULLWIDTHLEFTPAREN = "FULLWIDTHLEFTPAREN";
const FULLWIDTHRIGHTPAREN = "FULLWIDTHRIGHTPAREN";
const LEFTCORNERBRACKET = "LEFTCORNERBRACKET";
const RIGHTCORNERBRACKET = "RIGHTCORNERBRACKET";
const LEFTWHITECORNERBRACKET = "LEFTWHITECORNERBRACKET";
const RIGHTWHITECORNERBRACKET = "RIGHTWHITECORNERBRACKET";
const FULLWIDTHLESSTHAN = "FULLWIDTHLESSTHAN";
const FULLWIDTHGREATERTHAN = "FULLWIDTHGREATERTHAN";
const AMPERSAND = "AMPERSAND";
const APOSTROPHE = "APOSTROPHE";
const ASTERISK = "ASTERISK";
const AT = "AT";
const BACKSLASH = "BACKSLASH";
const BACKTICK = "BACKTICK";
const CARET = "CARET";
const COLON = "COLON";
const COMMA = "COMMA";
const DOLLAR = "DOLLAR";
const DOT = "DOT";
const EQUALS = "EQUALS";
const EXCLAMATION = "EXCLAMATION";
const HYPHEN = "HYPHEN";
const PERCENT = "PERCENT";
const PIPE = "PIPE";
const PLUS = "PLUS";
const POUND = "POUND";
const QUERY = "QUERY";
const QUOTE = "QUOTE";
const FULLWIDTHMIDDLEDOT = "FULLWIDTHMIDDLEDOT";
const SEMI = "SEMI";
const SLASH = "SLASH";
const TILDE = "TILDE";
const UNDERSCORE = "UNDERSCORE";
const EMOJI$1 = "EMOJI";
const SYM = "SYM";
var tk = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL,
  AMPERSAND,
  APOSTROPHE,
  ASCIINUMERICAL,
  ASTERISK,
  AT,
  BACKSLASH,
  BACKTICK,
  CARET,
  CLOSEANGLEBRACKET,
  CLOSEBRACE,
  CLOSEBRACKET,
  CLOSEPAREN,
  COLON,
  COMMA,
  DOLLAR,
  DOT,
  EMOJI: EMOJI$1,
  EQUALS,
  EXCLAMATION,
  FULLWIDTHGREATERTHAN,
  FULLWIDTHLEFTPAREN,
  FULLWIDTHLESSTHAN,
  FULLWIDTHMIDDLEDOT,
  FULLWIDTHRIGHTPAREN,
  HYPHEN,
  LEFTCORNERBRACKET,
  LEFTWHITECORNERBRACKET,
  LOCALHOST,
  NL,
  NUM,
  OPENANGLEBRACKET,
  OPENBRACE,
  OPENBRACKET,
  OPENPAREN,
  PERCENT,
  PIPE,
  PLUS,
  POUND,
  QUERY,
  QUOTE,
  RIGHTCORNERBRACKET,
  RIGHTWHITECORNERBRACKET,
  SCHEME,
  SEMI,
  SLASH,
  SLASH_SCHEME,
  SYM,
  TILDE,
  TLD,
  UNDERSCORE,
  UTLD,
  UWORD,
  WORD,
  WS
});
const ASCII_LETTER = /[a-z]/;
const LETTER = new RegExp("\\p{L}", "u");
const EMOJI = new RegExp("\\p{Emoji}", "u");
const DIGIT = /\d/;
const SPACE = /\s/;
const CR = "\r";
const LF = "\n";
const EMOJI_VARIATION = "️";
const EMOJI_JOINER = "‍";
const OBJECT_REPLACEMENT = "￼";
let tlds = null, utlds = null;
function init$2(customSchemes = []) {
  const groups = {};
  State.groups = groups;
  const Start = new State();
  if (tlds == null) {
    tlds = decodeTlds(encodedTlds);
  }
  if (utlds == null) {
    utlds = decodeTlds(encodedUtlds);
  }
  tt(Start, "'", APOSTROPHE);
  tt(Start, "{", OPENBRACE);
  tt(Start, "}", CLOSEBRACE);
  tt(Start, "[", OPENBRACKET);
  tt(Start, "]", CLOSEBRACKET);
  tt(Start, "(", OPENPAREN);
  tt(Start, ")", CLOSEPAREN);
  tt(Start, "<", OPENANGLEBRACKET);
  tt(Start, ">", CLOSEANGLEBRACKET);
  tt(Start, "（", FULLWIDTHLEFTPAREN);
  tt(Start, "）", FULLWIDTHRIGHTPAREN);
  tt(Start, "「", LEFTCORNERBRACKET);
  tt(Start, "」", RIGHTCORNERBRACKET);
  tt(Start, "『", LEFTWHITECORNERBRACKET);
  tt(Start, "』", RIGHTWHITECORNERBRACKET);
  tt(Start, "＜", FULLWIDTHLESSTHAN);
  tt(Start, "＞", FULLWIDTHGREATERTHAN);
  tt(Start, "&", AMPERSAND);
  tt(Start, "*", ASTERISK);
  tt(Start, "@", AT);
  tt(Start, "`", BACKTICK);
  tt(Start, "^", CARET);
  tt(Start, ":", COLON);
  tt(Start, ",", COMMA);
  tt(Start, "$", DOLLAR);
  tt(Start, ".", DOT);
  tt(Start, "=", EQUALS);
  tt(Start, "!", EXCLAMATION);
  tt(Start, "-", HYPHEN);
  tt(Start, "%", PERCENT);
  tt(Start, "|", PIPE);
  tt(Start, "+", PLUS);
  tt(Start, "#", POUND);
  tt(Start, "?", QUERY);
  tt(Start, '"', QUOTE);
  tt(Start, "/", SLASH);
  tt(Start, ";", SEMI);
  tt(Start, "~", TILDE);
  tt(Start, "_", UNDERSCORE);
  tt(Start, "\\", BACKSLASH);
  tt(Start, "・", FULLWIDTHMIDDLEDOT);
  const Num = tr(Start, DIGIT, NUM, {
    [numeric]: true
  });
  tr(Num, DIGIT, Num);
  const Asciinumeric = tr(Num, ASCII_LETTER, ASCIINUMERICAL, {
    [asciinumeric]: true
  });
  const Alphanumeric = tr(Num, LETTER, ALPHANUMERICAL, {
    [alphanumeric]: true
  });
  const Word = tr(Start, ASCII_LETTER, WORD, {
    [ascii]: true
  });
  tr(Word, DIGIT, Asciinumeric);
  tr(Word, ASCII_LETTER, Word);
  tr(Asciinumeric, DIGIT, Asciinumeric);
  tr(Asciinumeric, ASCII_LETTER, Asciinumeric);
  const UWord = tr(Start, LETTER, UWORD, {
    [alpha]: true
  });
  tr(UWord, ASCII_LETTER);
  tr(UWord, DIGIT, Alphanumeric);
  tr(UWord, LETTER, UWord);
  tr(Alphanumeric, DIGIT, Alphanumeric);
  tr(Alphanumeric, ASCII_LETTER);
  tr(Alphanumeric, LETTER, Alphanumeric);
  const Nl2 = tt(Start, LF, NL, {
    [whitespace]: true
  });
  const Cr = tt(Start, CR, WS, {
    [whitespace]: true
  });
  const Ws = tr(Start, SPACE, WS, {
    [whitespace]: true
  });
  tt(Start, OBJECT_REPLACEMENT, Ws);
  tt(Cr, LF, Nl2);
  tt(Cr, OBJECT_REPLACEMENT, Ws);
  tr(Cr, SPACE, Ws);
  tt(Ws, CR);
  tt(Ws, LF);
  tr(Ws, SPACE, Ws);
  tt(Ws, OBJECT_REPLACEMENT, Ws);
  const Emoji = tr(Start, EMOJI, EMOJI$1, {
    [emoji]: true
  });
  tt(Emoji, "#");
  tr(Emoji, EMOJI, Emoji);
  tt(Emoji, EMOJI_VARIATION, Emoji);
  const EmojiJoiner = tt(Emoji, EMOJI_JOINER);
  tt(EmojiJoiner, "#");
  tr(EmojiJoiner, EMOJI, Emoji);
  const wordjr = [[ASCII_LETTER, Word], [DIGIT, Asciinumeric]];
  const uwordjr = [[ASCII_LETTER, null], [LETTER, UWord], [DIGIT, Alphanumeric]];
  for (let i = 0; i < tlds.length; i++) {
    fastts(Start, tlds[i], TLD, WORD, wordjr);
  }
  for (let i = 0; i < utlds.length; i++) {
    fastts(Start, utlds[i], UTLD, UWORD, uwordjr);
  }
  addToGroups(TLD, {
    tld: true,
    ascii: true
  }, groups);
  addToGroups(UTLD, {
    utld: true,
    alpha: true
  }, groups);
  fastts(Start, "file", SCHEME, WORD, wordjr);
  fastts(Start, "mailto", SCHEME, WORD, wordjr);
  fastts(Start, "http", SLASH_SCHEME, WORD, wordjr);
  fastts(Start, "https", SLASH_SCHEME, WORD, wordjr);
  fastts(Start, "ftp", SLASH_SCHEME, WORD, wordjr);
  fastts(Start, "ftps", SLASH_SCHEME, WORD, wordjr);
  addToGroups(SCHEME, {
    scheme: true,
    ascii: true
  }, groups);
  addToGroups(SLASH_SCHEME, {
    slashscheme: true,
    ascii: true
  }, groups);
  customSchemes = customSchemes.sort((a2, b2) => a2[0] > b2[0] ? 1 : -1);
  for (let i = 0; i < customSchemes.length; i++) {
    const sch = customSchemes[i][0];
    const optionalSlashSlash = customSchemes[i][1];
    const flags = optionalSlashSlash ? {
      [scheme]: true
    } : {
      [slashscheme]: true
    };
    if (sch.indexOf("-") >= 0) {
      flags[domain] = true;
    } else if (!ASCII_LETTER.test(sch)) {
      flags[numeric] = true;
    } else if (DIGIT.test(sch)) {
      flags[asciinumeric] = true;
    } else {
      flags[ascii] = true;
    }
    ts(Start, sch, sch, flags);
  }
  ts(Start, "localhost", LOCALHOST, {
    ascii: true
  });
  Start.jd = new State(SYM);
  return {
    start: Start,
    tokens: Object.assign({
      groups
    }, tk)
  };
}
function run$1(start4, str) {
  const iterable = stringToArray(str.replace(/[A-Z]/g, (c2) => c2.toLowerCase()));
  const charCount = iterable.length;
  const tokens2 = [];
  let cursor2 = 0;
  let charCursor = 0;
  while (charCursor < charCount) {
    let state = start4;
    let nextState = null;
    let tokenLength = 0;
    let latestAccepting = null;
    let sinceAccepts = -1;
    let charsSinceAccepts = -1;
    while (charCursor < charCount && (nextState = state.go(iterable[charCursor]))) {
      state = nextState;
      if (state.accepts()) {
        sinceAccepts = 0;
        charsSinceAccepts = 0;
        latestAccepting = state;
      } else if (sinceAccepts >= 0) {
        sinceAccepts += iterable[charCursor].length;
        charsSinceAccepts++;
      }
      tokenLength += iterable[charCursor].length;
      cursor2 += iterable[charCursor].length;
      charCursor++;
    }
    cursor2 -= sinceAccepts;
    charCursor -= charsSinceAccepts;
    tokenLength -= sinceAccepts;
    tokens2.push({
      t: latestAccepting.t,
      // token type/name
      v: str.slice(cursor2 - tokenLength, cursor2),
      // string value
      s: cursor2 - tokenLength,
      // start index
      e: cursor2
      // end index (excluding)
    });
  }
  return tokens2;
}
function stringToArray(str) {
  const result = [];
  const len = str.length;
  let index2 = 0;
  while (index2 < len) {
    let first2 = str.charCodeAt(index2);
    let second;
    let char2 = first2 < 55296 || first2 > 56319 || index2 + 1 === len || (second = str.charCodeAt(index2 + 1)) < 56320 || second > 57343 ? str[index2] : str.slice(index2, index2 + 2);
    result.push(char2);
    index2 += char2.length;
  }
  return result;
}
function fastts(state, input, t2, defaultt, jr) {
  let next2;
  const len = input.length;
  for (let i = 0; i < len - 1; i++) {
    const char2 = input[i];
    if (state.j[char2]) {
      next2 = state.j[char2];
    } else {
      next2 = new State(defaultt);
      next2.jr = jr.slice();
      state.j[char2] = next2;
    }
    state = next2;
  }
  next2 = new State(t2);
  next2.jr = jr.slice();
  state.j[input[len - 1]] = next2;
  return next2;
}
function decodeTlds(encoded) {
  const words = [];
  const stack = [];
  let i = 0;
  let digits = "0123456789";
  while (i < encoded.length) {
    let popDigitCount = 0;
    while (digits.indexOf(encoded[i + popDigitCount]) >= 0) {
      popDigitCount++;
    }
    if (popDigitCount > 0) {
      words.push(stack.join(""));
      for (let popCount = parseInt(encoded.substring(i, i + popDigitCount), 10); popCount > 0; popCount--) {
        stack.pop();
      }
      i += popDigitCount;
    } else {
      stack.push(encoded[i]);
      i++;
    }
  }
  return words;
}
const defaults = {
  defaultProtocol: "http",
  events: null,
  format: noop5,
  formatHref: noop5,
  nl2br: false,
  tagName: "a",
  target: null,
  rel: null,
  validate: true,
  truncate: Infinity,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function Options(opts, defaultRender = null) {
  let o2 = Object.assign({}, defaults);
  if (opts) {
    o2 = Object.assign(o2, opts instanceof Options ? opts.o : opts);
  }
  const ignoredTags = o2.ignoreTags;
  const uppercaseIgnoredTags = [];
  for (let i = 0; i < ignoredTags.length; i++) {
    uppercaseIgnoredTags.push(ignoredTags[i].toUpperCase());
  }
  this.o = o2;
  if (defaultRender) {
    this.defaultRender = defaultRender;
  }
  this.ignoreTags = uppercaseIgnoredTags;
}
Options.prototype = {
  o: defaults,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(ir) {
    return ir;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(token2) {
    return this.get("validate", token2.toString(), token2);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(key2, operator, token2) {
    const isCallable = operator != null;
    let option = this.o[key2];
    if (!option) {
      return option;
    }
    if (typeof option === "object") {
      option = token2.t in option ? option[token2.t] : defaults[key2];
      if (typeof option === "function" && isCallable) {
        option = option(operator, token2);
      }
    } else if (typeof option === "function" && isCallable) {
      option = option(operator, token2.t, token2);
    }
    return option;
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(key2, operator, token2) {
    let obj = this.o[key2];
    if (typeof obj === "function" && operator != null) {
      obj = obj(operator, token2.t, token2);
    }
    return obj;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(token2) {
    const ir = token2.render(this);
    const renderFn = this.get("render", null, token2) || this.defaultRender;
    return renderFn(ir, token2.t, token2);
  }
};
function noop5(val) {
  return val;
}
function MultiToken(value, tokens2) {
  this.t = "token";
  this.v = value;
  this.tk = tokens2;
}
MultiToken.prototype = {
  isLink: false,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(scheme2) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(options) {
    const val = this.toString();
    const truncate = options.get("truncate", val, this);
    const formatted = options.get("format", val, this);
    return truncate && formatted.length > truncate ? formatted.substring(0, truncate) + "…" : formatted;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(options) {
    return options.get("formatHref", this.toHref(options.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(protocol = defaults.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(protocol),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(options) {
    return {
      type: this.t,
      value: this.toFormattedString(options),
      isLink: this.isLink,
      href: this.toFormattedHref(options),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(options) {
    return options.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(options) {
    const token2 = this;
    const href = this.toHref(options.get("defaultProtocol"));
    const formattedHref = options.get("formatHref", href, this);
    const tagName = options.get("tagName", href, token2);
    const content2 = this.toFormattedString(options);
    const attributes = {};
    const className = options.get("className", href, token2);
    const target = options.get("target", href, token2);
    const rel = options.get("rel", href, token2);
    const attrs = options.getObj("attributes", href, token2);
    const eventListeners = options.getObj("events", href, token2);
    attributes.href = formattedHref;
    if (className) {
      attributes.class = className;
    }
    if (target) {
      attributes.target = target;
    }
    if (rel) {
      attributes.rel = rel;
    }
    if (attrs) {
      Object.assign(attributes, attrs);
    }
    return {
      tagName,
      attributes,
      content: content2,
      eventListeners
    };
  }
};
function createTokenClass(type, props) {
  class Token2 extends MultiToken {
    constructor(value, tokens2) {
      super(value, tokens2);
      this.t = type;
    }
  }
  for (const p2 in props) {
    Token2.prototype[p2] = props[p2];
  }
  Token2.t = type;
  return Token2;
}
const Email = createTokenClass("email", {
  isLink: true,
  toHref() {
    return "mailto:" + this.toString();
  }
});
const Text$1 = createTokenClass("text");
const Nl = createTokenClass("nl");
const Url = createTokenClass("url", {
  isLink: true,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(scheme2 = defaults.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${scheme2}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const tokens2 = this.tk;
    return tokens2.length >= 2 && tokens2[0].t !== LOCALHOST && tokens2[1].t === COLON;
  }
});
const makeState = (arg) => new State(arg);
function init$1({
  groups
}) {
  const qsAccepting = groups.domain.concat([AMPERSAND, ASTERISK, AT, BACKSLASH, BACKTICK, CARET, DOLLAR, EQUALS, HYPHEN, NUM, PERCENT, PIPE, PLUS, POUND, SLASH, SYM, TILDE, UNDERSCORE]);
  const qsNonAccepting = [APOSTROPHE, COLON, COMMA, DOT, EXCLAMATION, PERCENT, QUERY, QUOTE, SEMI, OPENANGLEBRACKET, CLOSEANGLEBRACKET, OPENBRACE, CLOSEBRACE, CLOSEBRACKET, OPENBRACKET, OPENPAREN, CLOSEPAREN, FULLWIDTHLEFTPAREN, FULLWIDTHRIGHTPAREN, LEFTCORNERBRACKET, RIGHTCORNERBRACKET, LEFTWHITECORNERBRACKET, RIGHTWHITECORNERBRACKET, FULLWIDTHLESSTHAN, FULLWIDTHGREATERTHAN];
  const localpartAccepting = [AMPERSAND, APOSTROPHE, ASTERISK, BACKSLASH, BACKTICK, CARET, DOLLAR, EQUALS, HYPHEN, OPENBRACE, CLOSEBRACE, PERCENT, PIPE, PLUS, POUND, QUERY, SLASH, SYM, TILDE, UNDERSCORE];
  const Start = makeState();
  const Localpart = tt(Start, TILDE);
  ta(Localpart, localpartAccepting, Localpart);
  ta(Localpart, groups.domain, Localpart);
  const Domain = makeState(), Scheme = makeState(), SlashScheme = makeState();
  ta(Start, groups.domain, Domain);
  ta(Start, groups.scheme, Scheme);
  ta(Start, groups.slashscheme, SlashScheme);
  ta(Domain, localpartAccepting, Localpart);
  ta(Domain, groups.domain, Domain);
  const LocalpartAt = tt(Domain, AT);
  tt(Localpart, AT, LocalpartAt);
  tt(Scheme, AT, LocalpartAt);
  tt(SlashScheme, AT, LocalpartAt);
  const LocalpartDot = tt(Localpart, DOT);
  ta(LocalpartDot, localpartAccepting, Localpart);
  ta(LocalpartDot, groups.domain, Localpart);
  const EmailDomain = makeState();
  ta(LocalpartAt, groups.domain, EmailDomain);
  ta(EmailDomain, groups.domain, EmailDomain);
  const EmailDomainDot = tt(EmailDomain, DOT);
  ta(EmailDomainDot, groups.domain, EmailDomain);
  const Email$1 = makeState(Email);
  ta(EmailDomainDot, groups.tld, Email$1);
  ta(EmailDomainDot, groups.utld, Email$1);
  tt(LocalpartAt, LOCALHOST, Email$1);
  const EmailDomainHyphen = tt(EmailDomain, HYPHEN);
  tt(EmailDomainHyphen, HYPHEN, EmailDomainHyphen);
  ta(EmailDomainHyphen, groups.domain, EmailDomain);
  ta(Email$1, groups.domain, EmailDomain);
  tt(Email$1, DOT, EmailDomainDot);
  tt(Email$1, HYPHEN, EmailDomainHyphen);
  const EmailColon = tt(Email$1, COLON);
  ta(EmailColon, groups.numeric, Email);
  const DomainHyphen = tt(Domain, HYPHEN);
  const DomainDot = tt(Domain, DOT);
  tt(DomainHyphen, HYPHEN, DomainHyphen);
  ta(DomainHyphen, groups.domain, Domain);
  ta(DomainDot, localpartAccepting, Localpart);
  ta(DomainDot, groups.domain, Domain);
  const DomainDotTld = makeState(Url);
  ta(DomainDot, groups.tld, DomainDotTld);
  ta(DomainDot, groups.utld, DomainDotTld);
  ta(DomainDotTld, groups.domain, Domain);
  ta(DomainDotTld, localpartAccepting, Localpart);
  tt(DomainDotTld, DOT, DomainDot);
  tt(DomainDotTld, HYPHEN, DomainHyphen);
  tt(DomainDotTld, AT, LocalpartAt);
  const DomainDotTldColon = tt(DomainDotTld, COLON);
  const DomainDotTldColonPort = makeState(Url);
  ta(DomainDotTldColon, groups.numeric, DomainDotTldColonPort);
  const Url$1 = makeState(Url);
  const UrlNonaccept = makeState();
  ta(Url$1, qsAccepting, Url$1);
  ta(Url$1, qsNonAccepting, UrlNonaccept);
  ta(UrlNonaccept, qsAccepting, Url$1);
  ta(UrlNonaccept, qsNonAccepting, UrlNonaccept);
  tt(DomainDotTld, SLASH, Url$1);
  tt(DomainDotTldColonPort, SLASH, Url$1);
  const SchemeColon = tt(Scheme, COLON);
  const SlashSchemeColon = tt(SlashScheme, COLON);
  const SlashSchemeColonSlash = tt(SlashSchemeColon, SLASH);
  const UriPrefix = tt(SlashSchemeColonSlash, SLASH);
  ta(Scheme, groups.domain, Domain);
  tt(Scheme, DOT, DomainDot);
  tt(Scheme, HYPHEN, DomainHyphen);
  ta(SlashScheme, groups.domain, Domain);
  tt(SlashScheme, DOT, DomainDot);
  tt(SlashScheme, HYPHEN, DomainHyphen);
  ta(SchemeColon, groups.domain, Url$1);
  tt(SchemeColon, SLASH, Url$1);
  tt(SchemeColon, QUERY, Url$1);
  ta(UriPrefix, groups.domain, Url$1);
  ta(UriPrefix, qsAccepting, Url$1);
  tt(UriPrefix, SLASH, Url$1);
  const bracketPairs = [
    [OPENBRACE, CLOSEBRACE],
    // {}
    [OPENBRACKET, CLOSEBRACKET],
    // []
    [OPENPAREN, CLOSEPAREN],
    // ()
    [OPENANGLEBRACKET, CLOSEANGLEBRACKET],
    // <>
    [FULLWIDTHLEFTPAREN, FULLWIDTHRIGHTPAREN],
    // （）
    [LEFTCORNERBRACKET, RIGHTCORNERBRACKET],
    // 「」
    [LEFTWHITECORNERBRACKET, RIGHTWHITECORNERBRACKET],
    // 『』
    [FULLWIDTHLESSTHAN, FULLWIDTHGREATERTHAN]
    // ＜＞
  ];
  for (let i = 0; i < bracketPairs.length; i++) {
    const [OPEN, CLOSE] = bracketPairs[i];
    const UrlOpen = tt(Url$1, OPEN);
    tt(UrlNonaccept, OPEN, UrlOpen);
    tt(UrlOpen, CLOSE, Url$1);
    const UrlOpenQ = makeState(Url);
    ta(UrlOpen, qsAccepting, UrlOpenQ);
    const UrlOpenSyms = makeState();
    ta(UrlOpen, qsNonAccepting);
    ta(UrlOpenQ, qsAccepting, UrlOpenQ);
    ta(UrlOpenQ, qsNonAccepting, UrlOpenSyms);
    ta(UrlOpenSyms, qsAccepting, UrlOpenQ);
    ta(UrlOpenSyms, qsNonAccepting, UrlOpenSyms);
    tt(UrlOpenQ, CLOSE, Url$1);
    tt(UrlOpenSyms, CLOSE, Url$1);
  }
  tt(Start, LOCALHOST, DomainDotTld);
  tt(Start, NL, Nl);
  return {
    start: Start,
    tokens: tk
  };
}
function run(start4, input, tokens2) {
  let len = tokens2.length;
  let cursor2 = 0;
  let multis = [];
  let textTokens = [];
  while (cursor2 < len) {
    let state = start4;
    let secondState = null;
    let nextState = null;
    let multiLength = 0;
    let latestAccepting = null;
    let sinceAccepts = -1;
    while (cursor2 < len && !(secondState = state.go(tokens2[cursor2].t))) {
      textTokens.push(tokens2[cursor2++]);
    }
    while (cursor2 < len && (nextState = secondState || state.go(tokens2[cursor2].t))) {
      secondState = null;
      state = nextState;
      if (state.accepts()) {
        sinceAccepts = 0;
        latestAccepting = state;
      } else if (sinceAccepts >= 0) {
        sinceAccepts++;
      }
      cursor2++;
      multiLength++;
    }
    if (sinceAccepts < 0) {
      cursor2 -= multiLength;
      if (cursor2 < len) {
        textTokens.push(tokens2[cursor2]);
        cursor2++;
      }
    } else {
      if (textTokens.length > 0) {
        multis.push(initMultiToken(Text$1, input, textTokens));
        textTokens = [];
      }
      cursor2 -= sinceAccepts;
      multiLength -= sinceAccepts;
      const Multi = latestAccepting.t;
      const subtokens = tokens2.slice(cursor2 - multiLength, cursor2);
      multis.push(initMultiToken(Multi, input, subtokens));
    }
  }
  if (textTokens.length > 0) {
    multis.push(initMultiToken(Text$1, input, textTokens));
  }
  return multis;
}
function initMultiToken(Multi, input, tokens2) {
  const startIdx = tokens2[0].s;
  const endIdx = tokens2[tokens2.length - 1].e;
  const value = input.slice(startIdx, endIdx);
  return new Multi(value, tokens2);
}
const warn2 = typeof console !== "undefined" && console && console.warn || (() => {
});
const warnAdvice = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.";
const INIT = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: false
};
function reset() {
  State.groups = {};
  INIT.scanner = null;
  INIT.parser = null;
  INIT.tokenQueue = [];
  INIT.pluginQueue = [];
  INIT.customSchemes = [];
  INIT.initialized = false;
  return INIT;
}
function registerCustomProtocol(scheme2, optionalSlashSlash = false) {
  if (INIT.initialized) {
    warn2(`linkifyjs: already initialized - will not register custom scheme "${scheme2}" ${warnAdvice}`);
  }
  if (!/^[0-9a-z]+(-[0-9a-z]+)*$/.test(scheme2)) {
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  }
  INIT.customSchemes.push([scheme2, optionalSlashSlash]);
}
function init() {
  INIT.scanner = init$2(INIT.customSchemes);
  for (let i = 0; i < INIT.tokenQueue.length; i++) {
    INIT.tokenQueue[i][1]({
      scanner: INIT.scanner
    });
  }
  INIT.parser = init$1(INIT.scanner.tokens);
  for (let i = 0; i < INIT.pluginQueue.length; i++) {
    INIT.pluginQueue[i][1]({
      scanner: INIT.scanner,
      parser: INIT.parser
    });
  }
  INIT.initialized = true;
  return INIT;
}
function tokenize(str) {
  if (!INIT.initialized) {
    init();
  }
  return run(INIT.parser.start, str, run$1(INIT.scanner.start, str));
}
tokenize.scan = run$1;
function find(str, type = null, opts = null) {
  if (type && typeof type === "object") {
    if (opts) {
      throw Error(`linkifyjs: Invalid link type ${type}; must be a string`);
    }
    opts = type;
    type = null;
  }
  const options = new Options(opts);
  const tokens2 = tokenize(str);
  const filtered = [];
  for (let i = 0; i < tokens2.length; i++) {
    const token2 = tokens2[i];
    if (token2.isLink && (!type || token2.t === type) && options.check(token2)) {
      filtered.push(token2.toFormattedObject(options));
    }
  }
  return filtered;
}
const UNICODE_WHITESPACE_PATTERN = "[\0-   ᠎ -\u2029 　]";
const UNICODE_WHITESPACE_REGEX = new RegExp(UNICODE_WHITESPACE_PATTERN);
const UNICODE_WHITESPACE_REGEX_END = new RegExp(`${UNICODE_WHITESPACE_PATTERN}$`);
const UNICODE_WHITESPACE_REGEX_GLOBAL = new RegExp(UNICODE_WHITESPACE_PATTERN, "g");
function isValidLinkStructure(tokens2) {
  if (tokens2.length === 1) {
    return tokens2[0].isLink;
  }
  if (tokens2.length === 3 && tokens2[1].isLink) {
    return ["()", "[]"].includes(tokens2[0].value + tokens2[2].value);
  }
  return false;
}
function autolink(options) {
  return new Plugin({
    key: new PluginKey("autolink"),
    appendTransaction: (transactions, oldState, newState) => {
      const docChanges = transactions.some((transaction) => transaction.docChanged) && !oldState.doc.eq(newState.doc);
      const preventAutolink = transactions.some((transaction) => transaction.getMeta("preventAutolink"));
      if (!docChanges || preventAutolink) {
        return;
      }
      const { tr: tr2 } = newState;
      const transform = combineTransactionSteps(oldState.doc, [...transactions]);
      const changes = getChangedRanges(transform);
      changes.forEach(({ newRange }) => {
        const nodesInChangedRanges = findChildrenInRange(newState.doc, newRange, (node2) => node2.isTextblock);
        let textBlock;
        let textBeforeWhitespace;
        if (nodesInChangedRanges.length > 1) {
          textBlock = nodesInChangedRanges[0];
          textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, textBlock.pos + textBlock.node.nodeSize, void 0, " ");
        } else if (nodesInChangedRanges.length) {
          const endText = newState.doc.textBetween(newRange.from, newRange.to, " ", " ");
          if (!UNICODE_WHITESPACE_REGEX_END.test(endText)) {
            return;
          }
          textBlock = nodesInChangedRanges[0];
          textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, newRange.to, void 0, " ");
        }
        if (textBlock && textBeforeWhitespace) {
          const wordsBeforeWhitespace = textBeforeWhitespace.split(UNICODE_WHITESPACE_REGEX).filter(Boolean);
          if (wordsBeforeWhitespace.length <= 0) {
            return false;
          }
          const lastWordBeforeSpace = wordsBeforeWhitespace[wordsBeforeWhitespace.length - 1];
          const lastWordAndBlockOffset = textBlock.pos + textBeforeWhitespace.lastIndexOf(lastWordBeforeSpace);
          if (!lastWordBeforeSpace) {
            return false;
          }
          const linksBeforeSpace = tokenize(lastWordBeforeSpace).map((t2) => t2.toObject(options.defaultProtocol));
          if (!isValidLinkStructure(linksBeforeSpace)) {
            return false;
          }
          linksBeforeSpace.filter((link2) => link2.isLink).map((link2) => ({
            ...link2,
            from: lastWordAndBlockOffset + link2.start + 1,
            to: lastWordAndBlockOffset + link2.end + 1
          })).filter((link2) => {
            if (!newState.schema.marks.code) {
              return true;
            }
            return !newState.doc.rangeHasMark(link2.from, link2.to, newState.schema.marks.code);
          }).filter((link2) => options.validate(link2.value)).filter((link2) => options.shouldAutoLink(link2.value)).forEach((link2) => {
            if (getMarksBetween(link2.from, link2.to, newState.doc).some((item) => item.mark.type === options.type)) {
              return;
            }
            tr2.addMark(link2.from, link2.to, options.type.create({
              href: link2.href
            }));
          });
        }
      });
      if (!tr2.steps.length) {
        return;
      }
      return tr2;
    }
  });
}
function clickHandler(options) {
  return new Plugin({
    key: new PluginKey("handleClickLink"),
    props: {
      handleClick: (view, pos, event) => {
        var _a3, _b;
        if (event.button !== 0) {
          return false;
        }
        if (!view.editable) {
          return false;
        }
        let a2 = event.target;
        const els = [];
        while (a2.nodeName !== "DIV") {
          els.push(a2);
          a2 = a2.parentNode;
        }
        if (!els.find((value) => value.nodeName === "A")) {
          return false;
        }
        const attrs = getAttributes(view.state, options.type.name);
        const link2 = event.target;
        const href = (_a3 = link2 === null || link2 === void 0 ? void 0 : link2.href) !== null && _a3 !== void 0 ? _a3 : attrs.href;
        const target = (_b = link2 === null || link2 === void 0 ? void 0 : link2.target) !== null && _b !== void 0 ? _b : attrs.target;
        if (link2 && href) {
          window.open(href, target);
          return true;
        }
        return false;
      }
    }
  });
}
function pasteHandler(options) {
  return new Plugin({
    key: new PluginKey("handlePasteLink"),
    props: {
      handlePaste: (view, event, slice3) => {
        const { state } = view;
        const { selection } = state;
        const { empty: empty2 } = selection;
        if (empty2) {
          return false;
        }
        let textContent = "";
        slice3.content.forEach((node2) => {
          textContent += node2.textContent;
        });
        const link2 = find(textContent, { defaultProtocol: options.defaultProtocol }).find((item) => item.isLink && item.value === textContent);
        if (!textContent || !link2) {
          return false;
        }
        return options.editor.commands.setMark(options.type, {
          href: link2.href
        });
      }
    }
  });
}
function isAllowedUri(uri, protocols) {
  const allowedProtocols = [
    "http",
    "https",
    "ftp",
    "ftps",
    "mailto",
    "tel",
    "callto",
    "sms",
    "cid",
    "xmpp"
  ];
  if (protocols) {
    protocols.forEach((protocol) => {
      const nextProtocol = typeof protocol === "string" ? protocol : protocol.scheme;
      if (nextProtocol) {
        allowedProtocols.push(nextProtocol);
      }
    });
  }
  return !uri || uri.replace(UNICODE_WHITESPACE_REGEX_GLOBAL, "").match(new RegExp(
    // eslint-disable-next-line no-useless-escape
    `^(?:(?:${allowedProtocols.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
    "i"
  ));
}
const Link = Mark2.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: false,
  exitable: true,
  onCreate() {
    if (this.options.validate && !this.options.shouldAutoLink) {
      this.options.shouldAutoLink = this.options.validate;
      console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.");
    }
    this.options.protocols.forEach((protocol) => {
      if (typeof protocol === "string") {
        registerCustomProtocol(protocol);
        return;
      }
      registerCustomProtocol(protocol.scheme, protocol.optionalSlashes);
    });
  },
  onDestroy() {
    reset();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: true,
      linkOnPaste: true,
      autolink: true,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (url, ctx) => !!isAllowedUri(url, ctx.protocols),
      validate: (url) => !!url,
      shouldAutoLink: (url) => !!url
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(element2) {
          return element2.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (dom) => {
          const href = dom.getAttribute("href");
          if (!href || !this.options.isAllowedUri(href, {
            defaultValidate: (url) => !!isAllowedUri(url, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          })) {
            return false;
          }
          return null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    if (!this.options.isAllowedUri(HTMLAttributes.href, {
      defaultValidate: (href) => !!isAllowedUri(href, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    })) {
      return [
        "a",
        mergeAttributes(this.options.HTMLAttributes, { ...HTMLAttributes, href: "" }),
        0
      ];
    }
    return ["a", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      setLink: (attributes) => ({ chain }) => {
        const { href } = attributes;
        if (!this.options.isAllowedUri(href, {
          defaultValidate: (url) => !!isAllowedUri(url, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        })) {
          return false;
        }
        return chain().setMark(this.name, attributes).setMeta("preventAutolink", true).run();
      },
      toggleLink: (attributes) => ({ chain }) => {
        const { href } = attributes;
        if (!this.options.isAllowedUri(href, {
          defaultValidate: (url) => !!isAllowedUri(url, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        })) {
          return false;
        }
        return chain().toggleMark(this.name, attributes, { extendEmptyMarkRange: true }).setMeta("preventAutolink", true).run();
      },
      unsetLink: () => ({ chain }) => {
        return chain().unsetMark(this.name, { extendEmptyMarkRange: true }).setMeta("preventAutolink", true).run();
      }
    };
  },
  addPasteRules() {
    return [
      markPasteRule({
        find: (text2) => {
          const foundLinks = [];
          if (text2) {
            const { protocols, defaultProtocol } = this.options;
            const links = find(text2).filter((item) => item.isLink && this.options.isAllowedUri(item.value, {
              defaultValidate: (href) => !!isAllowedUri(href, protocols),
              protocols,
              defaultProtocol
            }));
            if (links.length) {
              links.forEach((link2) => foundLinks.push({
                text: link2.value,
                data: {
                  href: link2.href
                },
                index: link2.start
              }));
            }
          }
          return foundLinks;
        },
        type: this.type,
        getAttributes: (match5) => {
          var _a3;
          return {
            href: (_a3 = match5.data) === null || _a3 === void 0 ? void 0 : _a3.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const plugins = [];
    const { protocols, defaultProtocol } = this.options;
    if (this.options.autolink) {
      plugins.push(autolink({
        type: this.type,
        defaultProtocol: this.options.defaultProtocol,
        validate: (url) => this.options.isAllowedUri(url, {
          defaultValidate: (href) => !!isAllowedUri(href, protocols),
          protocols,
          defaultProtocol
        }),
        shouldAutoLink: this.options.shouldAutoLink
      }));
    }
    if (this.options.openOnClick === true) {
      plugins.push(clickHandler({
        type: this.type
      }));
    }
    if (this.options.linkOnPaste) {
      plugins.push(pasteHandler({
        editor: this.editor,
        defaultProtocol: this.options.defaultProtocol,
        type: this.type
      }));
    }
    return plugins;
  }
});
function TbAlignCenter(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M4 6l16 0" }, "child": [] }, { "tag": "path", "attr": { "d": "M8 12l8 0" }, "child": [] }, { "tag": "path", "attr": { "d": "M6 18l12 0" }, "child": [] }] })(props);
}
function TbAlignJustified(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M4 6l16 0" }, "child": [] }, { "tag": "path", "attr": { "d": "M4 12l16 0" }, "child": [] }, { "tag": "path", "attr": { "d": "M4 18l12 0" }, "child": [] }] })(props);
}
function TbAlignLeft(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M4 6l16 0" }, "child": [] }, { "tag": "path", "attr": { "d": "M4 12l10 0" }, "child": [] }, { "tag": "path", "attr": { "d": "M4 18l14 0" }, "child": [] }] })(props);
}
function TbAlignRight(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M4 6l16 0" }, "child": [] }, { "tag": "path", "attr": { "d": "M10 12l10 0" }, "child": [] }, { "tag": "path", "attr": { "d": "M6 18l14 0" }, "child": [] }] })(props);
}
function TbBold(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M7 5h6a3.5 3.5 0 0 1 0 7h-6z" }, "child": [] }, { "tag": "path", "attr": { "d": "M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7" }, "child": [] }] })(props);
}
function TbColumnInsertLeft(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M14 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z" }, "child": [] }, { "tag": "path", "attr": { "d": "M5 12l4 0" }, "child": [] }, { "tag": "path", "attr": { "d": "M7 10l0 4" }, "child": [] }] })(props);
}
function TbColumnInsertRight(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M6 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z" }, "child": [] }, { "tag": "path", "attr": { "d": "M15 12l4 0" }, "child": [] }, { "tag": "path", "attr": { "d": "M17 10l0 4" }, "child": [] }] })(props);
}
function TbColumnRemove(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M6 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z" }, "child": [] }, { "tag": "path", "attr": { "d": "M16 10l4 4" }, "child": [] }, { "tag": "path", "attr": { "d": "M16 14l4 -4" }, "child": [] }] })(props);
}
function TbItalic(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M11 5l6 0" }, "child": [] }, { "tag": "path", "attr": { "d": "M7 19l6 0" }, "child": [] }, { "tag": "path", "attr": { "d": "M14 5l-4 14" }, "child": [] }] })(props);
}
function TbLink(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M9 15l6 -6" }, "child": [] }, { "tag": "path", "attr": { "d": "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" }, "child": [] }, { "tag": "path", "attr": { "d": "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" }, "child": [] }] })(props);
}
function TbListNumbers(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M11 6h9" }, "child": [] }, { "tag": "path", "attr": { "d": "M11 12h9" }, "child": [] }, { "tag": "path", "attr": { "d": "M12 18h8" }, "child": [] }, { "tag": "path", "attr": { "d": "M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4" }, "child": [] }, { "tag": "path", "attr": { "d": "M6 10v-6l-2 2" }, "child": [] }] })(props);
}
function TbList(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M9 6l11 0" }, "child": [] }, { "tag": "path", "attr": { "d": "M9 12l11 0" }, "child": [] }, { "tag": "path", "attr": { "d": "M9 18l11 0" }, "child": [] }, { "tag": "path", "attr": { "d": "M5 6l0 .01" }, "child": [] }, { "tag": "path", "attr": { "d": "M5 12l0 .01" }, "child": [] }, { "tag": "path", "attr": { "d": "M5 18l0 .01" }, "child": [] }] })(props);
}
function TbMinus(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M5 12l14 0" }, "child": [] }] })(props);
}
function TbRowInsertBottom(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M20 6v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1z" }, "child": [] }, { "tag": "path", "attr": { "d": "M12 15l0 4" }, "child": [] }, { "tag": "path", "attr": { "d": "M14 17l-4 0" }, "child": [] }] })(props);
}
function TbRowInsertTop(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M4 18v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z" }, "child": [] }, { "tag": "path", "attr": { "d": "M12 9v-4" }, "child": [] }, { "tag": "path", "attr": { "d": "M10 7l4 0" }, "child": [] }] })(props);
}
function TbRowRemove(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M20 6v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1z" }, "child": [] }, { "tag": "path", "attr": { "d": "M10 16l4 4" }, "child": [] }, { "tag": "path", "attr": { "d": "M10 20l4 -4" }, "child": [] }] })(props);
}
function TbStrikethrough(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M5 12l14 0" }, "child": [] }, { "tag": "path", "attr": { "d": "M16 6.5a4 2 0 0 0 -4 -1.5h-1a3.5 3.5 0 0 0 0 7h2a3.5 3.5 0 0 1 0 7h-1.5a4 2 0 0 1 -4 -1.5" }, "child": [] }] })(props);
}
function TbTablePlus(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5" }, "child": [] }, { "tag": "path", "attr": { "d": "M3 10h18" }, "child": [] }, { "tag": "path", "attr": { "d": "M10 3v18" }, "child": [] }, { "tag": "path", "attr": { "d": "M16 19h6" }, "child": [] }, { "tag": "path", "attr": { "d": "M19 16v6" }, "child": [] }] })(props);
}
function TbTableRow(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z" }, "child": [] }, { "tag": "path", "attr": { "d": "M9 3l-6 6" }, "child": [] }, { "tag": "path", "attr": { "d": "M14 3l-7 7" }, "child": [] }, { "tag": "path", "attr": { "d": "M19 3l-7 7" }, "child": [] }, { "tag": "path", "attr": { "d": "M21 6l-4 4" }, "child": [] }, { "tag": "path", "attr": { "d": "M3 10h18" }, "child": [] }, { "tag": "path", "attr": { "d": "M10 10v11" }, "child": [] }] })(props);
}
const inputRegex$5 = /^\s*>\s$/;
const Blockquote = Node$1.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: true,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["blockquote", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: commands2 }) => {
        return commands2.wrapIn(this.name);
      },
      toggleBlockquote: () => ({ commands: commands2 }) => {
        return commands2.toggleWrap(this.name);
      },
      unsetBlockquote: () => ({ commands: commands2 }) => {
        return commands2.lift(this.name);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      wrappingInputRule({
        find: inputRegex$5,
        type: this.type
      })
    ];
  }
});
const starInputRegex$1 = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/;
const starPasteRegex$1 = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g;
const underscoreInputRegex$1 = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/;
const underscorePasteRegex$1 = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g;
const Bold = Mark2.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (node2) => node2.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (mark2) => mark2.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (value) => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["strong", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: commands2 }) => {
        return commands2.setMark(this.name);
      },
      toggleBold: () => ({ commands: commands2 }) => {
        return commands2.toggleMark(this.name);
      },
      unsetBold: () => ({ commands: commands2 }) => {
        return commands2.unsetMark(this.name);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      markInputRule({
        find: starInputRegex$1,
        type: this.type
      }),
      markInputRule({
        find: underscoreInputRegex$1,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      markPasteRule({
        find: starPasteRegex$1,
        type: this.type
      }),
      markPasteRule({
        find: underscorePasteRegex$1,
        type: this.type
      })
    ];
  }
});
const ListItemName$1 = "listItem";
const TextStyleName$1 = "textStyle";
const inputRegex$4 = /^\s*([-+*])\s$/;
const BulletList = Node$1.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: false,
      keepAttributes: false
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["ul", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: commands2, chain }) => {
        if (this.options.keepAttributes) {
          return chain().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(ListItemName$1, this.editor.getAttributes(TextStyleName$1)).run();
        }
        return commands2.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let inputRule = wrappingInputRule({
      find: inputRegex$4,
      type: this.type
    });
    if (this.options.keepMarks || this.options.keepAttributes) {
      inputRule = wrappingInputRule({
        find: inputRegex$4,
        type: this.type,
        keepMarks: this.options.keepMarks,
        keepAttributes: this.options.keepAttributes,
        getAttributes: () => {
          return this.editor.getAttributes(TextStyleName$1);
        },
        editor: this.editor
      });
    }
    return [
      inputRule
    ];
  }
});
const inputRegex$3 = /(^|[^`])`([^`]+)`(?!`)/;
const pasteRegex$2 = /(^|[^`])`([^`]+)`(?!`)/g;
const Code = Mark2.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: true,
  exitable: true,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["code", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: commands2 }) => {
        return commands2.setMark(this.name);
      },
      toggleCode: () => ({ commands: commands2 }) => {
        return commands2.toggleMark(this.name);
      },
      unsetCode: () => ({ commands: commands2 }) => {
        return commands2.unsetMark(this.name);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      markInputRule({
        find: inputRegex$3,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      markPasteRule({
        find: pasteRegex$2,
        type: this.type
      })
    ];
  }
});
const backtickInputRegex = /^```([a-z]+)?[\s\n]$/;
const tildeInputRegex = /^~~~([a-z]+)?[\s\n]$/;
const CodeBlock = Node$1.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: true,
      exitOnArrowDown: true,
      defaultLanguage: null,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: true,
  defining: true,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (element2) => {
          var _a3;
          const { languageClassPrefix } = this.options;
          const classNames2 = [...((_a3 = element2.firstElementChild) === null || _a3 === void 0 ? void 0 : _a3.classList) || []];
          const languages = classNames2.filter((className) => className.startsWith(languageClassPrefix)).map((className) => className.replace(languageClassPrefix, ""));
          const language = languages[0];
          if (!language) {
            return null;
          }
          return language;
        },
        rendered: false
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: node2, HTMLAttributes }) {
    return [
      "pre",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      [
        "code",
        {
          class: node2.attrs.language ? this.options.languageClassPrefix + node2.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (attributes) => ({ commands: commands2 }) => {
        return commands2.setNode(this.name, attributes);
      },
      toggleCodeBlock: (attributes) => ({ commands: commands2 }) => {
        return commands2.toggleNode(this.name, "paragraph", attributes);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: empty2, $anchor } = this.editor.state.selection;
        const isAtStart = $anchor.pos === 1;
        if (!empty2 || $anchor.parent.type.name !== this.name) {
          return false;
        }
        if (isAtStart || !$anchor.parent.textContent.length) {
          return this.editor.commands.clearNodes();
        }
        return false;
      },
      // exit node on triple enter
      Enter: ({ editor }) => {
        if (!this.options.exitOnTripleEnter) {
          return false;
        }
        const { state } = editor;
        const { selection } = state;
        const { $from, empty: empty2 } = selection;
        if (!empty2 || $from.parent.type !== this.type) {
          return false;
        }
        const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
        const endsWithDoubleNewline = $from.parent.textContent.endsWith("\n\n");
        if (!isAtEnd || !endsWithDoubleNewline) {
          return false;
        }
        return editor.chain().command(({ tr: tr2 }) => {
          tr2.delete($from.pos - 2, $from.pos);
          return true;
        }).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor }) => {
        if (!this.options.exitOnArrowDown) {
          return false;
        }
        const { state } = editor;
        const { selection, doc: doc2 } = state;
        const { $from, empty: empty2 } = selection;
        if (!empty2 || $from.parent.type !== this.type) {
          return false;
        }
        const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
        if (!isAtEnd) {
          return false;
        }
        const after = $from.after();
        if (after === void 0) {
          return false;
        }
        const nodeAfter = doc2.nodeAt(after);
        if (nodeAfter) {
          return editor.commands.command(({ tr: tr2 }) => {
            tr2.setSelection(Selection.near(doc2.resolve(after)));
            return true;
          });
        }
        return editor.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      textblockTypeInputRule({
        find: backtickInputRegex,
        type: this.type,
        getAttributes: (match5) => ({
          language: match5[1]
        })
      }),
      textblockTypeInputRule({
        find: tildeInputRegex,
        type: this.type,
        getAttributes: (match5) => ({
          language: match5[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new Plugin({
        key: new PluginKey("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (view, event) => {
            if (!event.clipboardData) {
              return false;
            }
            if (this.editor.isActive(this.type.name)) {
              return false;
            }
            const text2 = event.clipboardData.getData("text/plain");
            const vscode = event.clipboardData.getData("vscode-editor-data");
            const vscodeData = vscode ? JSON.parse(vscode) : void 0;
            const language = vscodeData === null || vscodeData === void 0 ? void 0 : vscodeData.mode;
            if (!text2 || !language) {
              return false;
            }
            const { tr: tr2, schema } = view.state;
            const textNode = schema.text(text2.replace(/\r\n?/g, "\n"));
            tr2.replaceSelectionWith(this.type.create({ language }, textNode));
            if (tr2.selection.$from.parent.type !== this.type) {
              tr2.setSelection(TextSelection.near(tr2.doc.resolve(Math.max(0, tr2.selection.from - 2))));
            }
            tr2.setMeta("paste", true);
            view.dispatch(tr2);
            return true;
          }
        }
      })
    ];
  }
});
const Document$1 = Node$1.create({
  name: "doc",
  topNode: true,
  content: "block+"
});
function dropCursor(options = {}) {
  return new Plugin({
    view(editorView) {
      return new DropCursorView(editorView, options);
    }
  });
}
class DropCursorView {
  constructor(editorView, options) {
    var _a3;
    this.editorView = editorView;
    this.cursorPos = null;
    this.element = null;
    this.timeout = -1;
    this.width = (_a3 = options.width) !== null && _a3 !== void 0 ? _a3 : 1;
    this.color = options.color === false ? void 0 : options.color || "black";
    this.class = options.class;
    this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((name2) => {
      let handler = (e) => {
        this[name2](e);
      };
      editorView.dom.addEventListener(name2, handler);
      return { name: name2, handler };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: name2, handler }) => this.editorView.dom.removeEventListener(name2, handler));
  }
  update(editorView, prevState) {
    if (this.cursorPos != null && prevState.doc != editorView.state.doc) {
      if (this.cursorPos > editorView.state.doc.content.size)
        this.setCursor(null);
      else
        this.updateOverlay();
    }
  }
  setCursor(pos) {
    if (pos == this.cursorPos)
      return;
    this.cursorPos = pos;
    if (pos == null) {
      this.element.parentNode.removeChild(this.element);
      this.element = null;
    } else {
      this.updateOverlay();
    }
  }
  updateOverlay() {
    let $pos = this.editorView.state.doc.resolve(this.cursorPos);
    let isBlock = !$pos.parent.inlineContent, rect;
    let editorDOM = this.editorView.dom, editorRect = editorDOM.getBoundingClientRect();
    let scaleX = editorRect.width / editorDOM.offsetWidth, scaleY = editorRect.height / editorDOM.offsetHeight;
    if (isBlock) {
      let before = $pos.nodeBefore, after = $pos.nodeAfter;
      if (before || after) {
        let node2 = this.editorView.nodeDOM(this.cursorPos - (before ? before.nodeSize : 0));
        if (node2) {
          let nodeRect = node2.getBoundingClientRect();
          let top2 = before ? nodeRect.bottom : nodeRect.top;
          if (before && after)
            top2 = (top2 + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2;
          let halfWidth = this.width / 2 * scaleY;
          rect = { left: nodeRect.left, right: nodeRect.right, top: top2 - halfWidth, bottom: top2 + halfWidth };
        }
      }
    }
    if (!rect) {
      let coords = this.editorView.coordsAtPos(this.cursorPos);
      let halfWidth = this.width / 2 * scaleX;
      rect = { left: coords.left - halfWidth, right: coords.left + halfWidth, top: coords.top, bottom: coords.bottom };
    }
    let parent2 = this.editorView.dom.offsetParent;
    if (!this.element) {
      this.element = parent2.appendChild(document.createElement("div"));
      if (this.class)
        this.element.className = this.class;
      this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;";
      if (this.color) {
        this.element.style.backgroundColor = this.color;
      }
    }
    this.element.classList.toggle("prosemirror-dropcursor-block", isBlock);
    this.element.classList.toggle("prosemirror-dropcursor-inline", !isBlock);
    let parentLeft, parentTop;
    if (!parent2 || parent2 == document.body && getComputedStyle(parent2).position == "static") {
      parentLeft = -pageXOffset;
      parentTop = -pageYOffset;
    } else {
      let rect2 = parent2.getBoundingClientRect();
      let parentScaleX = rect2.width / parent2.offsetWidth, parentScaleY = rect2.height / parent2.offsetHeight;
      parentLeft = rect2.left - parent2.scrollLeft * parentScaleX;
      parentTop = rect2.top - parent2.scrollTop * parentScaleY;
    }
    this.element.style.left = (rect.left - parentLeft) / scaleX + "px";
    this.element.style.top = (rect.top - parentTop) / scaleY + "px";
    this.element.style.width = (rect.right - rect.left) / scaleX + "px";
    this.element.style.height = (rect.bottom - rect.top) / scaleY + "px";
  }
  scheduleRemoval(timeout) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.setCursor(null), timeout);
  }
  dragover(event) {
    if (!this.editorView.editable)
      return;
    let pos = this.editorView.posAtCoords({ left: event.clientX, top: event.clientY });
    let node2 = pos && pos.inside >= 0 && this.editorView.state.doc.nodeAt(pos.inside);
    let disableDropCursor = node2 && node2.type.spec.disableDropCursor;
    let disabled = typeof disableDropCursor == "function" ? disableDropCursor(this.editorView, pos, event) : disableDropCursor;
    if (pos && !disabled) {
      let target = pos.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let point2 = dropPoint(this.editorView.state.doc, target, this.editorView.dragging.slice);
        if (point2 != null)
          target = point2;
      }
      this.setCursor(target);
      this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(event) {
    if (!this.editorView.dom.contains(event.relatedTarget))
      this.setCursor(null);
  }
}
const Dropcursor = Extension.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      dropCursor(this.options)
    ];
  }
});
class GapCursor extends Selection {
  /**
  Create a gap cursor.
  */
  constructor($pos) {
    super($pos, $pos);
  }
  map(doc2, mapping) {
    let $pos = doc2.resolve(mapping.map(this.head));
    return GapCursor.valid($pos) ? new GapCursor($pos) : Selection.near($pos);
  }
  content() {
    return Slice.empty;
  }
  eq(other2) {
    return other2 instanceof GapCursor && other2.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(doc2, json) {
    if (typeof json.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new GapCursor(doc2.resolve(json.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new GapBookmark(this.anchor);
  }
  /**
  @internal
  */
  static valid($pos) {
    let parent2 = $pos.parent;
    if (parent2.isTextblock || !closedBefore($pos) || !closedAfter($pos))
      return false;
    let override = parent2.type.spec.allowGapCursor;
    if (override != null)
      return override;
    let deflt = parent2.contentMatchAt($pos.index()).defaultType;
    return deflt && deflt.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom($pos, dir, mustMove = false) {
    search: for (; ; ) {
      if (!mustMove && GapCursor.valid($pos))
        return $pos;
      let pos = $pos.pos, next2 = null;
      for (let d2 = $pos.depth; ; d2--) {
        let parent2 = $pos.node(d2);
        if (dir > 0 ? $pos.indexAfter(d2) < parent2.childCount : $pos.index(d2) > 0) {
          next2 = parent2.child(dir > 0 ? $pos.indexAfter(d2) : $pos.index(d2) - 1);
          break;
        } else if (d2 == 0) {
          return null;
        }
        pos += dir;
        let $cur = $pos.doc.resolve(pos);
        if (GapCursor.valid($cur))
          return $cur;
      }
      for (; ; ) {
        let inside = dir > 0 ? next2.firstChild : next2.lastChild;
        if (!inside) {
          if (next2.isAtom && !next2.isText && !NodeSelection.isSelectable(next2)) {
            $pos = $pos.doc.resolve(pos + next2.nodeSize * dir);
            mustMove = false;
            continue search;
          }
          break;
        }
        next2 = inside;
        pos += dir;
        let $cur = $pos.doc.resolve(pos);
        if (GapCursor.valid($cur))
          return $cur;
      }
      return null;
    }
  }
}
GapCursor.prototype.visible = false;
GapCursor.findFrom = GapCursor.findGapCursorFrom;
Selection.jsonID("gapcursor", GapCursor);
class GapBookmark {
  constructor(pos) {
    this.pos = pos;
  }
  map(mapping) {
    return new GapBookmark(mapping.map(this.pos));
  }
  resolve(doc2) {
    let $pos = doc2.resolve(this.pos);
    return GapCursor.valid($pos) ? new GapCursor($pos) : Selection.near($pos);
  }
}
function closedBefore($pos) {
  for (let d2 = $pos.depth; d2 >= 0; d2--) {
    let index2 = $pos.index(d2), parent2 = $pos.node(d2);
    if (index2 == 0) {
      if (parent2.type.spec.isolating)
        return true;
      continue;
    }
    for (let before = parent2.child(index2 - 1); ; before = before.lastChild) {
      if (before.childCount == 0 && !before.inlineContent || before.isAtom || before.type.spec.isolating)
        return true;
      if (before.inlineContent)
        return false;
    }
  }
  return true;
}
function closedAfter($pos) {
  for (let d2 = $pos.depth; d2 >= 0; d2--) {
    let index2 = $pos.indexAfter(d2), parent2 = $pos.node(d2);
    if (index2 == parent2.childCount) {
      if (parent2.type.spec.isolating)
        return true;
      continue;
    }
    for (let after = parent2.child(index2); ; after = after.firstChild) {
      if (after.childCount == 0 && !after.inlineContent || after.isAtom || after.type.spec.isolating)
        return true;
      if (after.inlineContent)
        return false;
    }
  }
  return true;
}
function gapCursor() {
  return new Plugin({
    props: {
      decorations: drawGapCursor,
      createSelectionBetween(_view, $anchor, $head) {
        return $anchor.pos == $head.pos && GapCursor.valid($head) ? new GapCursor($head) : null;
      },
      handleClick,
      handleKeyDown,
      handleDOMEvents: { beforeinput }
    }
  });
}
const handleKeyDown = keydownHandler({
  "ArrowLeft": arrow("horiz", -1),
  "ArrowRight": arrow("horiz", 1),
  "ArrowUp": arrow("vert", -1),
  "ArrowDown": arrow("vert", 1)
});
function arrow(axis, dir) {
  const dirStr = axis == "vert" ? dir > 0 ? "down" : "up" : dir > 0 ? "right" : "left";
  return function(state, dispatch, view) {
    let sel = state.selection;
    let $start = dir > 0 ? sel.$to : sel.$from, mustMove = sel.empty;
    if (sel instanceof TextSelection) {
      if (!view.endOfTextblock(dirStr) || $start.depth == 0)
        return false;
      mustMove = false;
      $start = state.doc.resolve(dir > 0 ? $start.after() : $start.before());
    }
    let $found = GapCursor.findGapCursorFrom($start, dir, mustMove);
    if (!$found)
      return false;
    if (dispatch)
      dispatch(state.tr.setSelection(new GapCursor($found)));
    return true;
  };
}
function handleClick(view, pos, event) {
  if (!view || !view.editable)
    return false;
  let $pos = view.state.doc.resolve(pos);
  if (!GapCursor.valid($pos))
    return false;
  let clickPos = view.posAtCoords({ left: event.clientX, top: event.clientY });
  if (clickPos && clickPos.inside > -1 && NodeSelection.isSelectable(view.state.doc.nodeAt(clickPos.inside)))
    return false;
  view.dispatch(view.state.tr.setSelection(new GapCursor($pos)));
  return true;
}
function beforeinput(view, event) {
  if (event.inputType != "insertCompositionText" || !(view.state.selection instanceof GapCursor))
    return false;
  let { $from } = view.state.selection;
  let insert2 = $from.parent.contentMatchAt($from.index()).findWrapping(view.state.schema.nodes.text);
  if (!insert2)
    return false;
  let frag = Fragment.empty;
  for (let i = insert2.length - 1; i >= 0; i--)
    frag = Fragment.from(insert2[i].createAndFill(null, frag));
  let tr2 = view.state.tr.replace($from.pos, $from.pos, new Slice(frag, 0, 0));
  tr2.setSelection(TextSelection.near(tr2.doc.resolve($from.pos + 1)));
  view.dispatch(tr2);
  return false;
}
function drawGapCursor(state) {
  if (!(state.selection instanceof GapCursor))
    return null;
  let node2 = document.createElement("div");
  node2.className = "ProseMirror-gapcursor";
  return DecorationSet.create(state.doc, [Decoration.widget(state.selection.head, node2, { key: "gapcursor" })]);
}
const Gapcursor = Extension.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      gapCursor()
    ];
  },
  extendNodeSchema(extension2) {
    var _a3;
    const context = {
      name: extension2.name,
      options: extension2.options,
      storage: extension2.storage
    };
    return {
      allowGapCursor: (_a3 = callOrReturn(getExtensionField(extension2, "allowGapCursor", context))) !== null && _a3 !== void 0 ? _a3 : null
    };
  }
});
const HardBreak = Node$1.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: true,
      HTMLAttributes: {}
    };
  },
  inline: true,
  group: "inline",
  selectable: false,
  linebreakReplacement: true,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["br", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
  },
  renderText() {
    return "\n";
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: commands2, chain, state, editor }) => {
        return commands2.first([
          () => commands2.exitCode(),
          () => commands2.command(() => {
            const { selection, storedMarks } = state;
            if (selection.$from.parent.type.spec.isolating) {
              return false;
            }
            const { keepMarks } = this.options;
            const { splittableMarks } = editor.extensionManager;
            const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
            return chain().insertContent({ type: this.name }).command(({ tr: tr2, dispatch }) => {
              if (dispatch && marks && keepMarks) {
                const filteredMarks = marks.filter((mark2) => splittableMarks.includes(mark2.type.name));
                tr2.ensureMarks(filteredMarks);
              }
              return true;
            }).run();
          })
        ]);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
});
const Heading = Node$1.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: true,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: false
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((level) => ({
      tag: `h${level}`,
      attrs: { level }
    }));
  },
  renderHTML({ node: node2, HTMLAttributes }) {
    const hasLevel = this.options.levels.includes(node2.attrs.level);
    const level = hasLevel ? node2.attrs.level : this.options.levels[0];
    return [`h${level}`, mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      setHeading: (attributes) => ({ commands: commands2 }) => {
        if (!this.options.levels.includes(attributes.level)) {
          return false;
        }
        return commands2.setNode(this.name, attributes);
      },
      toggleHeading: (attributes) => ({ commands: commands2 }) => {
        if (!this.options.levels.includes(attributes.level)) {
          return false;
        }
        return commands2.toggleNode(this.name, "paragraph", attributes);
      }
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((items, level) => ({
      ...items,
      ...{
        [`Mod-Alt-${level}`]: () => this.editor.commands.toggleHeading({ level })
      }
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((level) => {
      return textblockTypeInputRule({
        find: new RegExp(`^(#{${Math.min(...this.options.levels)},${level}})\\s$`),
        type: this.type,
        getAttributes: {
          level
        }
      });
    });
  }
});
var GOOD_LEAF_SIZE = 200;
var RopeSequence = function RopeSequence2() {
};
RopeSequence.prototype.append = function append2(other2) {
  if (!other2.length) {
    return this;
  }
  other2 = RopeSequence.from(other2);
  return !this.length && other2 || other2.length < GOOD_LEAF_SIZE && this.leafAppend(other2) || this.length < GOOD_LEAF_SIZE && other2.leafPrepend(this) || this.appendInner(other2);
};
RopeSequence.prototype.prepend = function prepend(other2) {
  if (!other2.length) {
    return this;
  }
  return RopeSequence.from(other2).append(this);
};
RopeSequence.prototype.appendInner = function appendInner(other2) {
  return new Append(this, other2);
};
RopeSequence.prototype.slice = function slice2(from3, to2) {
  if (from3 === void 0) from3 = 0;
  if (to2 === void 0) to2 = this.length;
  if (from3 >= to2) {
    return RopeSequence.empty;
  }
  return this.sliceInner(Math.max(0, from3), Math.min(this.length, to2));
};
RopeSequence.prototype.get = function get5(i) {
  if (i < 0 || i >= this.length) {
    return void 0;
  }
  return this.getInner(i);
};
RopeSequence.prototype.forEach = function forEach2(f2, from3, to2) {
  if (from3 === void 0) from3 = 0;
  if (to2 === void 0) to2 = this.length;
  if (from3 <= to2) {
    this.forEachInner(f2, from3, to2, 0);
  } else {
    this.forEachInvertedInner(f2, from3, to2, 0);
  }
};
RopeSequence.prototype.map = function map2(f2, from3, to2) {
  if (from3 === void 0) from3 = 0;
  if (to2 === void 0) to2 = this.length;
  var result = [];
  this.forEach(function(elt, i) {
    return result.push(f2(elt, i));
  }, from3, to2);
  return result;
};
RopeSequence.from = function from2(values2) {
  if (values2 instanceof RopeSequence) {
    return values2;
  }
  return values2 && values2.length ? new Leaf(values2) : RopeSequence.empty;
};
var Leaf = /* @__PURE__ */ function(RopeSequence3) {
  function Leaf2(values2) {
    RopeSequence3.call(this);
    this.values = values2;
  }
  if (RopeSequence3) Leaf2.__proto__ = RopeSequence3;
  Leaf2.prototype = Object.create(RopeSequence3 && RopeSequence3.prototype);
  Leaf2.prototype.constructor = Leaf2;
  var prototypeAccessors = { length: { configurable: true }, depth: { configurable: true } };
  Leaf2.prototype.flatten = function flatten() {
    return this.values;
  };
  Leaf2.prototype.sliceInner = function sliceInner(from3, to2) {
    if (from3 == 0 && to2 == this.length) {
      return this;
    }
    return new Leaf2(this.values.slice(from3, to2));
  };
  Leaf2.prototype.getInner = function getInner(i) {
    return this.values[i];
  };
  Leaf2.prototype.forEachInner = function forEachInner(f2, from3, to2, start4) {
    for (var i = from3; i < to2; i++) {
      if (f2(this.values[i], start4 + i) === false) {
        return false;
      }
    }
  };
  Leaf2.prototype.forEachInvertedInner = function forEachInvertedInner(f2, from3, to2, start4) {
    for (var i = from3 - 1; i >= to2; i--) {
      if (f2(this.values[i], start4 + i) === false) {
        return false;
      }
    }
  };
  Leaf2.prototype.leafAppend = function leafAppend(other2) {
    if (this.length + other2.length <= GOOD_LEAF_SIZE) {
      return new Leaf2(this.values.concat(other2.flatten()));
    }
  };
  Leaf2.prototype.leafPrepend = function leafPrepend(other2) {
    if (this.length + other2.length <= GOOD_LEAF_SIZE) {
      return new Leaf2(other2.flatten().concat(this.values));
    }
  };
  prototypeAccessors.length.get = function() {
    return this.values.length;
  };
  prototypeAccessors.depth.get = function() {
    return 0;
  };
  Object.defineProperties(Leaf2.prototype, prototypeAccessors);
  return Leaf2;
}(RopeSequence);
RopeSequence.empty = new Leaf([]);
var Append = /* @__PURE__ */ function(RopeSequence3) {
  function Append2(left2, right2) {
    RopeSequence3.call(this);
    this.left = left2;
    this.right = right2;
    this.length = left2.length + right2.length;
    this.depth = Math.max(left2.depth, right2.depth) + 1;
  }
  if (RopeSequence3) Append2.__proto__ = RopeSequence3;
  Append2.prototype = Object.create(RopeSequence3 && RopeSequence3.prototype);
  Append2.prototype.constructor = Append2;
  Append2.prototype.flatten = function flatten() {
    return this.left.flatten().concat(this.right.flatten());
  };
  Append2.prototype.getInner = function getInner(i) {
    return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
  };
  Append2.prototype.forEachInner = function forEachInner(f2, from3, to2, start4) {
    var leftLen = this.left.length;
    if (from3 < leftLen && this.left.forEachInner(f2, from3, Math.min(to2, leftLen), start4) === false) {
      return false;
    }
    if (to2 > leftLen && this.right.forEachInner(f2, Math.max(from3 - leftLen, 0), Math.min(this.length, to2) - leftLen, start4 + leftLen) === false) {
      return false;
    }
  };
  Append2.prototype.forEachInvertedInner = function forEachInvertedInner(f2, from3, to2, start4) {
    var leftLen = this.left.length;
    if (from3 > leftLen && this.right.forEachInvertedInner(f2, from3 - leftLen, Math.max(to2, leftLen) - leftLen, start4 + leftLen) === false) {
      return false;
    }
    if (to2 < leftLen && this.left.forEachInvertedInner(f2, Math.min(from3, leftLen), to2, start4) === false) {
      return false;
    }
  };
  Append2.prototype.sliceInner = function sliceInner(from3, to2) {
    if (from3 == 0 && to2 == this.length) {
      return this;
    }
    var leftLen = this.left.length;
    if (to2 <= leftLen) {
      return this.left.slice(from3, to2);
    }
    if (from3 >= leftLen) {
      return this.right.slice(from3 - leftLen, to2 - leftLen);
    }
    return this.left.slice(from3, leftLen).append(this.right.slice(0, to2 - leftLen));
  };
  Append2.prototype.leafAppend = function leafAppend(other2) {
    var inner = this.right.leafAppend(other2);
    if (inner) {
      return new Append2(this.left, inner);
    }
  };
  Append2.prototype.leafPrepend = function leafPrepend(other2) {
    var inner = this.left.leafPrepend(other2);
    if (inner) {
      return new Append2(inner, this.right);
    }
  };
  Append2.prototype.appendInner = function appendInner2(other2) {
    if (this.left.depth >= Math.max(this.right.depth, other2.depth) + 1) {
      return new Append2(this.left, new Append2(this.right, other2));
    }
    return new Append2(this, other2);
  };
  return Append2;
}(RopeSequence);
const max_empty_items = 500;
class Branch {
  constructor(items, eventCount) {
    this.items = items;
    this.eventCount = eventCount;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(state, preserveItems) {
    if (this.eventCount == 0)
      return null;
    let end2 = this.items.length;
    for (; ; end2--) {
      let next2 = this.items.get(end2 - 1);
      if (next2.selection) {
        --end2;
        break;
      }
    }
    let remap, mapFrom;
    if (preserveItems) {
      remap = this.remapping(end2, this.items.length);
      mapFrom = remap.maps.length;
    }
    let transform = state.tr;
    let selection, remaining;
    let addAfter = [], addBefore = [];
    this.items.forEach((item, i) => {
      if (!item.step) {
        if (!remap) {
          remap = this.remapping(end2, i + 1);
          mapFrom = remap.maps.length;
        }
        mapFrom--;
        addBefore.push(item);
        return;
      }
      if (remap) {
        addBefore.push(new Item(item.map));
        let step = item.step.map(remap.slice(mapFrom)), map3;
        if (step && transform.maybeStep(step).doc) {
          map3 = transform.mapping.maps[transform.mapping.maps.length - 1];
          addAfter.push(new Item(map3, void 0, void 0, addAfter.length + addBefore.length));
        }
        mapFrom--;
        if (map3)
          remap.appendMap(map3, mapFrom);
      } else {
        transform.maybeStep(item.step);
      }
      if (item.selection) {
        selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
        remaining = new Branch(this.items.slice(0, end2).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
        return false;
      }
    }, this.items.length, 0);
    return { remaining, transform, selection };
  }
  // Create a new branch with the given transform added.
  addTransform(transform, selection, histOptions, preserveItems) {
    let newItems = [], eventCount = this.eventCount;
    let oldItems = this.items, lastItem2 = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
    for (let i = 0; i < transform.steps.length; i++) {
      let step = transform.steps[i].invert(transform.docs[i]);
      let item = new Item(transform.mapping.maps[i], step, selection), merged;
      if (merged = lastItem2 && lastItem2.merge(item)) {
        item = merged;
        if (i)
          newItems.pop();
        else
          oldItems = oldItems.slice(0, oldItems.length - 1);
      }
      newItems.push(item);
      if (selection) {
        eventCount++;
        selection = void 0;
      }
      if (!preserveItems)
        lastItem2 = item;
    }
    let overflow2 = eventCount - histOptions.depth;
    if (overflow2 > DEPTH_OVERFLOW) {
      oldItems = cutOffEvents(oldItems, overflow2);
      eventCount -= overflow2;
    }
    return new Branch(oldItems.append(newItems), eventCount);
  }
  remapping(from3, to2) {
    let maps = new Mapping();
    this.items.forEach((item, i) => {
      let mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from3 ? maps.maps.length - item.mirrorOffset : void 0;
      maps.appendMap(item.map, mirrorPos);
    }, from3, to2);
    return maps;
  }
  addMaps(array) {
    if (this.eventCount == 0)
      return this;
    return new Branch(this.items.append(array.map((map3) => new Item(map3))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(rebasedTransform, rebasedCount) {
    if (!this.eventCount)
      return this;
    let rebasedItems = [], start4 = Math.max(0, this.items.length - rebasedCount);
    let mapping = rebasedTransform.mapping;
    let newUntil = rebasedTransform.steps.length;
    let eventCount = this.eventCount;
    this.items.forEach((item) => {
      if (item.selection)
        eventCount--;
    }, start4);
    let iRebased = rebasedCount;
    this.items.forEach((item) => {
      let pos = mapping.getMirror(--iRebased);
      if (pos == null)
        return;
      newUntil = Math.min(newUntil, pos);
      let map3 = mapping.maps[pos];
      if (item.step) {
        let step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
        let selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
        if (selection)
          eventCount++;
        rebasedItems.push(new Item(map3, step, selection));
      } else {
        rebasedItems.push(new Item(map3));
      }
    }, start4);
    let newMaps = [];
    for (let i = rebasedCount; i < newUntil; i++)
      newMaps.push(new Item(mapping.maps[i]));
    let items = this.items.slice(0, start4).append(newMaps).append(rebasedItems);
    let branch = new Branch(items, eventCount);
    if (branch.emptyItemCount() > max_empty_items)
      branch = branch.compress(this.items.length - rebasedItems.length);
    return branch;
  }
  emptyItemCount() {
    let count2 = 0;
    this.items.forEach((item) => {
      if (!item.step)
        count2++;
    });
    return count2;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(upto = this.items.length) {
    let remap = this.remapping(0, upto), mapFrom = remap.maps.length;
    let items = [], events2 = 0;
    this.items.forEach((item, i) => {
      if (i >= upto) {
        items.push(item);
        if (item.selection)
          events2++;
      } else if (item.step) {
        let step = item.step.map(remap.slice(mapFrom)), map3 = step && step.getMap();
        mapFrom--;
        if (map3)
          remap.appendMap(map3, mapFrom);
        if (step) {
          let selection = item.selection && item.selection.map(remap.slice(mapFrom));
          if (selection)
            events2++;
          let newItem = new Item(map3.invert(), step, selection), merged, last = items.length - 1;
          if (merged = items.length && items[last].merge(newItem))
            items[last] = merged;
          else
            items.push(newItem);
        }
      } else if (item.map) {
        mapFrom--;
      }
    }, this.items.length, 0);
    return new Branch(RopeSequence.from(items.reverse()), events2);
  }
}
Branch.empty = new Branch(RopeSequence.empty, 0);
function cutOffEvents(items, n2) {
  let cutPoint;
  items.forEach((item, i) => {
    if (item.selection && n2-- == 0) {
      cutPoint = i;
      return false;
    }
  });
  return items.slice(cutPoint);
}
class Item {
  constructor(map3, step, selection, mirrorOffset) {
    this.map = map3;
    this.step = step;
    this.selection = selection;
    this.mirrorOffset = mirrorOffset;
  }
  merge(other2) {
    if (this.step && other2.step && !other2.selection) {
      let step = other2.step.merge(this.step);
      if (step)
        return new Item(step.getMap().invert(), step, this.selection);
    }
  }
}
class HistoryState {
  constructor(done, undone, prevRanges, prevTime, prevComposition) {
    this.done = done;
    this.undone = undone;
    this.prevRanges = prevRanges;
    this.prevTime = prevTime;
    this.prevComposition = prevComposition;
  }
}
const DEPTH_OVERFLOW = 20;
function applyTransaction(history2, state, tr2, options) {
  let historyTr = tr2.getMeta(historyKey), rebased;
  if (historyTr)
    return historyTr.historyState;
  if (tr2.getMeta(closeHistoryKey))
    history2 = new HistoryState(history2.done, history2.undone, null, 0, -1);
  let appended = tr2.getMeta("appendedTransaction");
  if (tr2.steps.length == 0) {
    return history2;
  } else if (appended && appended.getMeta(historyKey)) {
    if (appended.getMeta(historyKey).redo)
      return new HistoryState(history2.done.addTransform(tr2, void 0, options, mustPreserveItems(state)), history2.undone, rangesFor(tr2.mapping.maps), history2.prevTime, history2.prevComposition);
    else
      return new HistoryState(history2.done, history2.undone.addTransform(tr2, void 0, options, mustPreserveItems(state)), null, history2.prevTime, history2.prevComposition);
  } else if (tr2.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
    let composition = tr2.getMeta("composition");
    let newGroup = history2.prevTime == 0 || !appended && history2.prevComposition != composition && (history2.prevTime < (tr2.time || 0) - options.newGroupDelay || !isAdjacentTo(tr2, history2.prevRanges));
    let prevRanges = appended ? mapRanges(history2.prevRanges, tr2.mapping) : rangesFor(tr2.mapping.maps);
    return new HistoryState(history2.done.addTransform(tr2, newGroup ? state.selection.getBookmark() : void 0, options, mustPreserveItems(state)), Branch.empty, prevRanges, tr2.time, composition == null ? history2.prevComposition : composition);
  } else if (rebased = tr2.getMeta("rebased")) {
    return new HistoryState(history2.done.rebased(tr2, rebased), history2.undone.rebased(tr2, rebased), mapRanges(history2.prevRanges, tr2.mapping), history2.prevTime, history2.prevComposition);
  } else {
    return new HistoryState(history2.done.addMaps(tr2.mapping.maps), history2.undone.addMaps(tr2.mapping.maps), mapRanges(history2.prevRanges, tr2.mapping), history2.prevTime, history2.prevComposition);
  }
}
function isAdjacentTo(transform, prevRanges) {
  if (!prevRanges)
    return false;
  if (!transform.docChanged)
    return true;
  let adjacent = false;
  transform.mapping.maps[0].forEach((start4, end2) => {
    for (let i = 0; i < prevRanges.length; i += 2)
      if (start4 <= prevRanges[i + 1] && end2 >= prevRanges[i])
        adjacent = true;
  });
  return adjacent;
}
function rangesFor(maps) {
  let result = [];
  for (let i = maps.length - 1; i >= 0 && result.length == 0; i--)
    maps[i].forEach((_from, _to, from3, to2) => result.push(from3, to2));
  return result;
}
function mapRanges(ranges, mapping) {
  if (!ranges)
    return null;
  let result = [];
  for (let i = 0; i < ranges.length; i += 2) {
    let from3 = mapping.map(ranges[i], 1), to2 = mapping.map(ranges[i + 1], -1);
    if (from3 <= to2)
      result.push(from3, to2);
  }
  return result;
}
function histTransaction(history2, state, redo2) {
  let preserveItems = mustPreserveItems(state);
  let histOptions = historyKey.get(state).spec.config;
  let pop = (redo2 ? history2.undone : history2.done).popEvent(state, preserveItems);
  if (!pop)
    return null;
  let selection = pop.selection.resolve(pop.transform.doc);
  let added = (redo2 ? history2.done : history2.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
  let newHist = new HistoryState(redo2 ? added : pop.remaining, redo2 ? pop.remaining : added, null, 0, -1);
  return pop.transform.setSelection(selection).setMeta(historyKey, { redo: redo2, historyState: newHist });
}
let cachedPreserveItems = false, cachedPreserveItemsPlugins = null;
function mustPreserveItems(state) {
  let plugins = state.plugins;
  if (cachedPreserveItemsPlugins != plugins) {
    cachedPreserveItems = false;
    cachedPreserveItemsPlugins = plugins;
    for (let i = 0; i < plugins.length; i++)
      if (plugins[i].spec.historyPreserveItems) {
        cachedPreserveItems = true;
        break;
      }
  }
  return cachedPreserveItems;
}
const historyKey = new PluginKey("history");
const closeHistoryKey = new PluginKey("closeHistory");
function history(config2 = {}) {
  config2 = {
    depth: config2.depth || 100,
    newGroupDelay: config2.newGroupDelay || 500
  };
  return new Plugin({
    key: historyKey,
    state: {
      init() {
        return new HistoryState(Branch.empty, Branch.empty, null, 0, -1);
      },
      apply(tr2, hist, state) {
        return applyTransaction(hist, state, tr2, config2);
      }
    },
    config: config2,
    props: {
      handleDOMEvents: {
        beforeinput(view, e) {
          let inputType = e.inputType;
          let command2 = inputType == "historyUndo" ? undo : inputType == "historyRedo" ? redo : null;
          if (!command2)
            return false;
          e.preventDefault();
          return command2(view.state, view.dispatch);
        }
      }
    }
  });
}
function buildCommand(redo2, scroll4) {
  return (state, dispatch) => {
    let hist = historyKey.getState(state);
    if (!hist || (redo2 ? hist.undone : hist.done).eventCount == 0)
      return false;
    if (dispatch) {
      let tr2 = histTransaction(hist, state, redo2);
      if (tr2)
        dispatch(scroll4 ? tr2.scrollIntoView() : tr2);
    }
    return true;
  };
}
const undo = buildCommand(false, true);
const redo = buildCommand(true, true);
const History = Extension.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state, dispatch }) => {
        return undo(state, dispatch);
      },
      redo: () => ({ state, dispatch }) => {
        return redo(state, dispatch);
      }
    };
  },
  addProseMirrorPlugins() {
    return [
      history(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
});
const HorizontalRule = Node$1.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["hr", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain, state }) => {
        if (!canInsertNode(state, state.schema.nodes[this.name])) {
          return false;
        }
        const { selection } = state;
        const { $from: $originFrom, $to: $originTo } = selection;
        const currentChain = chain();
        if ($originFrom.parentOffset === 0) {
          currentChain.insertContentAt({
            from: Math.max($originFrom.pos - 1, 0),
            to: $originTo.pos
          }, {
            type: this.name
          });
        } else if (isNodeSelection(selection)) {
          currentChain.insertContentAt($originTo.pos, {
            type: this.name
          });
        } else {
          currentChain.insertContent({ type: this.name });
        }
        return currentChain.command(({ tr: tr2, dispatch }) => {
          var _a3;
          if (dispatch) {
            const { $to } = tr2.selection;
            const posAfter = $to.end();
            if ($to.nodeAfter) {
              if ($to.nodeAfter.isTextblock) {
                tr2.setSelection(TextSelection.create(tr2.doc, $to.pos + 1));
              } else if ($to.nodeAfter.isBlock) {
                tr2.setSelection(NodeSelection.create(tr2.doc, $to.pos));
              } else {
                tr2.setSelection(TextSelection.create(tr2.doc, $to.pos));
              }
            } else {
              const node2 = (_a3 = $to.parent.type.contentMatch.defaultType) === null || _a3 === void 0 ? void 0 : _a3.create();
              if (node2) {
                tr2.insert(posAfter, node2);
                tr2.setSelection(TextSelection.create(tr2.doc, posAfter + 1));
              }
            }
            tr2.scrollIntoView();
          }
          return true;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      nodeInputRule({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
});
const starInputRegex = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/;
const starPasteRegex = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g;
const underscoreInputRegex = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/;
const underscorePasteRegex = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g;
const Italic = Mark2.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (node2) => node2.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (mark2) => mark2.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["em", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: commands2 }) => {
        return commands2.setMark(this.name);
      },
      toggleItalic: () => ({ commands: commands2 }) => {
        return commands2.toggleMark(this.name);
      },
      unsetItalic: () => ({ commands: commands2 }) => {
        return commands2.unsetMark(this.name);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      markInputRule({
        find: starInputRegex,
        type: this.type
      }),
      markInputRule({
        find: underscoreInputRegex,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      markPasteRule({
        find: starPasteRegex,
        type: this.type
      }),
      markPasteRule({
        find: underscorePasteRegex,
        type: this.type
      })
    ];
  }
});
const ListItem = Node$1.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: true,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["li", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
});
const ListItemName = "listItem";
const TextStyleName = "textStyle";
const inputRegex$2 = /^(\d+)\.\s$/;
const OrderedList = Node$1.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: false,
      keepAttributes: false
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (element2) => {
          return element2.hasAttribute("start") ? parseInt(element2.getAttribute("start") || "", 10) : 1;
        }
      },
      type: {
        default: null,
        parseHTML: (element2) => element2.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    const { start: start4, ...attributesWithoutStart } = HTMLAttributes;
    return start4 === 1 ? ["ol", mergeAttributes(this.options.HTMLAttributes, attributesWithoutStart), 0] : ["ol", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: commands2, chain }) => {
        if (this.options.keepAttributes) {
          return chain().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(ListItemName, this.editor.getAttributes(TextStyleName)).run();
        }
        return commands2.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let inputRule = wrappingInputRule({
      find: inputRegex$2,
      type: this.type,
      getAttributes: (match5) => ({ start: +match5[1] }),
      joinPredicate: (match5, node2) => node2.childCount + node2.attrs.start === +match5[1]
    });
    if (this.options.keepMarks || this.options.keepAttributes) {
      inputRule = wrappingInputRule({
        find: inputRegex$2,
        type: this.type,
        keepMarks: this.options.keepMarks,
        keepAttributes: this.options.keepAttributes,
        getAttributes: (match5) => ({ start: +match5[1], ...this.editor.getAttributes(TextStyleName) }),
        joinPredicate: (match5, node2) => node2.childCount + node2.attrs.start === +match5[1],
        editor: this.editor
      });
    }
    return [
      inputRule
    ];
  }
});
const Paragraph = Node$1.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["p", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: commands2 }) => {
        return commands2.setNode(this.name);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
});
const inputRegex$1 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/;
const pasteRegex$1 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g;
const Strike = Mark2.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: false,
        getAttrs: (style3) => style3.includes("line-through") ? {} : false
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["s", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: commands2 }) => {
        return commands2.setMark(this.name);
      },
      toggleStrike: () => ({ commands: commands2 }) => {
        return commands2.toggleMark(this.name);
      },
      unsetStrike: () => ({ commands: commands2 }) => {
        return commands2.unsetMark(this.name);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      markInputRule({
        find: inputRegex$1,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      markPasteRule({
        find: pasteRegex$1,
        type: this.type
      })
    ];
  }
});
const Text = Node$1.create({
  name: "text",
  group: "inline"
});
const StarterKit = Extension.create({
  name: "starterKit",
  addExtensions() {
    const extensions = [];
    if (this.options.bold !== false) {
      extensions.push(Bold.configure(this.options.bold));
    }
    if (this.options.blockquote !== false) {
      extensions.push(Blockquote.configure(this.options.blockquote));
    }
    if (this.options.bulletList !== false) {
      extensions.push(BulletList.configure(this.options.bulletList));
    }
    if (this.options.code !== false) {
      extensions.push(Code.configure(this.options.code));
    }
    if (this.options.codeBlock !== false) {
      extensions.push(CodeBlock.configure(this.options.codeBlock));
    }
    if (this.options.document !== false) {
      extensions.push(Document$1.configure(this.options.document));
    }
    if (this.options.dropcursor !== false) {
      extensions.push(Dropcursor.configure(this.options.dropcursor));
    }
    if (this.options.gapcursor !== false) {
      extensions.push(Gapcursor.configure(this.options.gapcursor));
    }
    if (this.options.hardBreak !== false) {
      extensions.push(HardBreak.configure(this.options.hardBreak));
    }
    if (this.options.heading !== false) {
      extensions.push(Heading.configure(this.options.heading));
    }
    if (this.options.history !== false) {
      extensions.push(History.configure(this.options.history));
    }
    if (this.options.horizontalRule !== false) {
      extensions.push(HorizontalRule.configure(this.options.horizontalRule));
    }
    if (this.options.italic !== false) {
      extensions.push(Italic.configure(this.options.italic));
    }
    if (this.options.listItem !== false) {
      extensions.push(ListItem.configure(this.options.listItem));
    }
    if (this.options.orderedList !== false) {
      extensions.push(OrderedList.configure(this.options.orderedList));
    }
    if (this.options.paragraph !== false) {
      extensions.push(Paragraph.configure(this.options.paragraph));
    }
    if (this.options.strike !== false) {
      extensions.push(Strike.configure(this.options.strike));
    }
    if (this.options.text !== false) {
      extensions.push(Text.configure(this.options.text));
    }
    return extensions;
  }
});
function RiMergeCellsHorizontal(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "currentColor" }, "child": [{ "tag": "path", "attr": { "d": "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM11 5H5V10.999H7V9L10 12L7 15V13H5V19H11V17H13V19H19V13H17V15L14 12L17 9V10.999H19V5H13V7H11V5ZM13 13V15H11V13H13ZM13 9V11H11V9H13Z" }, "child": [] }] })(props);
}
function RiSplitCellsHorizontal(props) {
  return GenIcon({ "attr": { "viewBox": "0 0 24 24", "fill": "currentColor" }, "child": [{ "tag": "path", "attr": { "d": "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM11 5H5V19H11V15H13V19H19V5H13V9H11V5ZM15 9L18 12L15 15V13H9V15L6 12L9 9V11H15V9Z" }, "child": [] }] })(props);
}
const StyledEditor = chakra(EditorContent);
const TipTapContentEditor = forwardRef$1(
  ({ content: content2, defaultContent = "<p></p>", onChange = () => {
  }, isInvalid }, ref2) => {
    const editor = useEditor({
      extensions: [
        StarterKit,
        Color,
        FontSize,
        TextStyle,
        TextAlign.configure({
          types: ["heading", "paragraph"]
        }),
        Link.configure({
          openOnClick: false,
          autolink: true
        }),
        Table2.configure({
          resizable: false
        }),
        TableRow,
        TableHeader,
        TableCell
      ],
      content: content2 || defaultContent,
      onUpdate: ({ editor: editor2 }) => onChange(editor2.getHTML())
    });
    useEffect(() => {
      const oldContent = editor == null ? void 0 : editor.getHTML();
      if (oldContent === content2) return;
      editor == null ? void 0 : editor.commands.setContent(content2 || defaultContent);
    }, [content2]);
    if (!editor) {
      return null;
    }
    const isBold = editor == null ? void 0 : editor.isActive("bold");
    const isItalic = editor == null ? void 0 : editor.isActive("italic");
    const isStrike = editor == null ? void 0 : editor.isActive("strike");
    const isOrderedList = editor == null ? void 0 : editor.isActive("orderedList");
    const isBulletList = editor == null ? void 0 : editor.isActive("bulletList");
    const headingLevel = editor == null ? void 0 : editor.getAttributes("heading").level;
    const fontSize2 = editor == null ? void 0 : editor.getAttributes("textStyle").fontSize;
    const color2 = editor == null ? void 0 : editor.getAttributes("textStyle").color;
    const focus2 = () => editor == null ? void 0 : editor.chain().focus();
    const onBold = () => editor == null ? void 0 : editor.chain().focus().toggleBold().run();
    const onItalic = () => editor == null ? void 0 : editor.chain().focus().toggleItalic().run();
    const onStrike = () => editor == null ? void 0 : editor.chain().focus().toggleStrike().run();
    const onHeading = (newLevel) => {
      const level = newLevel === 0 ? headingLevel : newLevel;
      editor == null ? void 0 : editor.chain().focus().toggleHeading({ level }).run();
    };
    const onOrderedList = () => editor == null ? void 0 : editor.chain().focus().toggleOrderedList().run();
    const onBulletList = () => editor == null ? void 0 : editor.chain().focus().toggleBulletList().run();
    const onHorizontalRule = () => editor == null ? void 0 : editor.chain().focus().setHorizontalRule().run();
    const onFontsize = (size2) => editor == null ? void 0 : editor.chain().focus().setFontSize(size2).run();
    const onInsertTable = () => editor.chain().focus().insertTable({ rows: 3, cols: 2, withHeaderRow: true }).run();
    const onAddColumnBefore = () => editor.chain().focus().addColumnBefore().run();
    const onAddColumnAfter = () => editor.chain().focus().addColumnAfter().run();
    const onDeleteColumn = () => editor.chain().focus().deleteColumn().run();
    const onAddRowBefore = () => editor.chain().focus().addRowBefore().run();
    const onAddRowAfter = () => editor.chain().focus().addRowAfter().run();
    const onDeleteRow = () => editor.chain().focus().deleteRow().run();
    const onMergeCells = () => editor.chain().focus().mergeCells().run();
    const onSplitCell = () => editor.chain().focus().splitCell().run();
    const onToggleHeaderRow = () => editor.chain().focus().toggleHeaderRow().run();
    const onLink = () => {
      const previousUrl = editor.getAttributes("link").href;
      const url = window.prompt("URL", previousUrl);
      if (url === null) {
        return;
      }
      if (url === "") {
        editor.chain().focus().extendMarkRange("link").unsetLink().run();
        return;
      }
      editor.chain().focus().extendMarkRange("link").setLink({ href: url }).run();
    };
    const iconButtonProps = {
      size: "sm",
      variant: "ghost",
      sx: {
        display: "inline",
        fontSize: "1.2em",
        margin: 0,
        padding: 0
      }
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Box$1,
      {
        pb: "4",
        mb: "8",
        w: "full",
        bg: "white",
        onClick: focus2,
        borderRadius: "md",
        border: "1px solid",
        borderColor: isInvalid ? "red.500" : "gray.200",
        boxShadow: isInvalid ? "invalidInput" : "none",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            HStack,
            {
              p: "1",
              mb: "4",
              spacing: "1",
              divider: /* @__PURE__ */ jsxRuntimeExports.jsx(StackDivider, {}),
              borderBottom: "1px solid",
              borderBottomColor: "gray.200",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { flexWrap: "wrap", spacing: "1", my: "1", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs(
                    Select$2,
                    {
                      style: {
                        marginBottom: "0",
                        fontSize: "10",
                        height: "32px"
                      },
                      mb: "0",
                      fontSize: "10",
                      width: "fit-content",
                      height: "32px",
                      onClick: (e) => e.stopPropagation(),
                      onChange: (e) => {
                        onHeading(parseInt(e.target.value));
                      },
                      value: headingLevel || 0,
                      children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "0", children: "Body Text" }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "1", children: "Heading 1" }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "2", children: "Heading 2" }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "3", children: "Heading 3" })
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs(
                    Select$2,
                    {
                      style: {
                        marginBottom: "0",
                        fontSize: "10",
                        height: "32px"
                      },
                      mb: "0",
                      fontSize: "10",
                      width: "fit-content",
                      height: "32px",
                      onClick: (e) => e.stopPropagation(),
                      onChange: (e) => onFontsize(e.target.value),
                      value: fontSize2 || "inherit",
                      children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "inherit", children: "Normal" }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "12px", children: "12px" }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "24px", children: "24px" }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "36px", children: "36px" }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "48px", children: "48px" })
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "input",
                    {
                      style: {
                        marginBottom: "0",
                        height: "32px",
                        padding: "4px",
                        width: "32px"
                      },
                      type: "color",
                      onInput: (event) => {
                        const newColor = event.target.value;
                        editor.chain().focus().setColor(newColor).run();
                      },
                      value: color2,
                      onClick: (e) => e.stopPropagation()
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { flexWrap: "wrap", spacing: "1", my: "1", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Bold", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "bold",
                      variant: isBold ? "solid" : "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbBold }),
                      onClick: onBold,
                      style: { margin: 0, padding: 0 }
                    }
                  ) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Italic", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "italic",
                      variant: isItalic ? "solid" : "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbItalic }),
                      onClick: onItalic,
                      style: { margin: 0, padding: 0 }
                    }
                  ) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Strikethrough", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "strikethrough",
                      variant: isStrike ? "solid" : "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbStrikethrough }),
                      onClick: onStrike,
                      style: { margin: 0, padding: 0 }
                    }
                  ) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Horizontal Rule", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "horizontal rule",
                      variant: "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbMinus }),
                      onClick: onHorizontalRule,
                      style: { margin: 0, padding: 0 }
                    }
                  ) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Insert Link", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "link",
                      variant: "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbLink }),
                      onClick: onLink,
                      style: { margin: 0, padding: 0 }
                    }
                  ) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Numbered List", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "ordered list",
                      variant: isOrderedList ? "solid" : "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbListNumbers }),
                      onClick: onOrderedList,
                      style: { margin: 0, padding: 0 }
                    }
                  ) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Bullet List", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "bullet list",
                      variant: isBulletList ? "solid" : "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbList }),
                      onClick: onBulletList,
                      style: { margin: 0, padding: 0 }
                    }
                  ) })
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { flexWrap: "wrap", spacing: "1", my: "1", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Align Left", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      style: { margin: 0, padding: 0 },
                      "aria-label": "align left",
                      variant: "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbAlignLeft }),
                      onClick: () => editor.chain().focus().setTextAlign("left").run(),
                      children: "left"
                    }
                  ) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Align Center", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      style: { margin: 0, padding: 0 },
                      "aria-label": "align center",
                      variant: "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbAlignCenter }),
                      onClick: () => editor.chain().focus().setTextAlign("center").run(),
                      children: "center"
                    }
                  ) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Align Right", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      style: { margin: 0, padding: 0 },
                      "aria-label": "align right",
                      variant: "ghost",
                      onClick: () => editor.chain().focus().setTextAlign("right").run(),
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbAlignRight }),
                      children: "right"
                    }
                  ) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Justify Text", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      style: { margin: 0, padding: 0 },
                      "aria-label": "justify text",
                      variant: "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbAlignJustified }),
                      onClick: () => editor.chain().focus().setTextAlign("justify").run(),
                      children: "justify"
                    }
                  ) })
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Insert Table", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "insert table",
                      variant: "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbTablePlus }),
                      onClick: onInsertTable,
                      style: { margin: 0, padding: 0 }
                    }
                  ) }),
                  editor.can().addColumnBefore() && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Add Column Before", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "add column before",
                      variant: "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbColumnInsertLeft }),
                      onClick: onAddColumnBefore,
                      style: { margin: 0, padding: 0 }
                    }
                  ) }),
                  editor.can().addColumnAfter() && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Add Column After", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "add column after",
                      variant: "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbColumnInsertRight }),
                      onClick: onAddColumnAfter,
                      style: { margin: 0, padding: 0 }
                    }
                  ) }),
                  editor.can().deleteColumn() && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Delete Column", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "delete column",
                      variant: "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbColumnRemove }),
                      onClick: onDeleteColumn,
                      style: { margin: 0, padding: 0 }
                    }
                  ) }),
                  editor.can().addRowBefore() && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Add Row Before", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "add row before",
                      variant: "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbRowInsertTop }),
                      onClick: onAddRowBefore,
                      style: { margin: 0, padding: 0 }
                    }
                  ) }),
                  editor.can().addRowAfter() && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Add Row After", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "add row after",
                      variant: "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbRowInsertBottom }),
                      onClick: onAddRowAfter,
                      style: { margin: 0, padding: 0 }
                    }
                  ) }),
                  editor.can().deleteRow() && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Delete Row", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "delete row",
                      variant: "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbRowRemove }),
                      onClick: onDeleteRow,
                      style: { margin: 0, padding: 0 }
                    }
                  ) }),
                  editor.can().mergeCells() && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Merge Cells", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "merge cells",
                      variant: "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: RiMergeCellsHorizontal }),
                      onClick: onMergeCells,
                      style: { margin: 0, padding: 0 }
                    }
                  ) }),
                  editor.can().splitCell() && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Split Cell", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "split cell",
                      variant: "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: RiSplitCellsHorizontal }),
                      onClick: onSplitCell,
                      style: { margin: 0, padding: 0 }
                    }
                  ) }),
                  editor.can().toggleHeaderRow() && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { label: "Toggle Header Row", placement: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    IconButton$1,
                    {
                      ...iconButtonProps,
                      "aria-label": "toggle header row",
                      variant: "ghost",
                      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { as: TbTableRow }),
                      onClick: onToggleHeaderRow,
                      style: { margin: 0, padding: 0 }
                    }
                  ) })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            StyledEditor,
            {
              ref: ref2,
              editor,
              content: content2,
              sx: {
                minH: "36",
                pl: 4,
                "& :focus-visible": { outline: "0px" }
              }
            }
          )
        ]
      }
    ) });
  }
);
TipTapContentEditor.displayName = "TipTapContentEditor";
const FontFamily = Extension.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (element2) => {
              var _a3;
              return (_a3 = element2.style.fontFamily) == null ? void 0 : _a3.replace(/['"]+/g, "");
            },
            renderHTML: (attributes) => {
              if (!attributes.fontFamily) {
                return {};
              }
              return {
                style: `font-family: ${attributes.fontFamily}`
              };
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (fontFamily2) => ({ chain }) => {
        return chain().setMark("textStyle", { fontFamily: fontFamily2 }).run();
      },
      unsetFontFamily: () => ({ chain }) => {
        return chain().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run();
      }
    };
  }
});
const HandlebarsVariable = Node$1.create({
  name: "handlebarsVariable",
  group: "inline",
  inline: true,
  atom: true,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return {
      variable: {
        default: null,
        parseHTML: (element2) => element2.getAttribute("data-variable"),
        renderHTML: (attributes) => {
          return {
            "data-variable": attributes.variable
          };
        }
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "span[data-variable]"
      }
    ];
  },
  renderHTML({ node: node2, HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        "class": "handlebars-variable",
        "data-type": "handlebarsVariable"
      }),
      `{{${node2.attrs.variable}}}`
    ];
  },
  renderText({ node: node2 }) {
    return `{{${node2.attrs.variable}}}`;
  },
  addCommands() {
    return {
      insertHandlebarsVariable: (variable) => ({ commands: commands2 }) => {
        return commands2.insertContent({
          type: this.name,
          attrs: { variable }
        });
      }
    };
  }
});
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const toKebabCase = (string2) => string2.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const toCamelCase = (string2) => string2.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (match5, p1, p2) => p2 ? p2.toUpperCase() : p1.toLowerCase()
);
const toPascalCase = (string2) => {
  const camelCase = toCamelCase(string2);
  return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const mergeClasses = (...classes2) => classes2.filter((className, index2, array) => {
  return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index2;
}).join(" ").trim();
const hasA11yProp = (props) => {
  for (const prop in props) {
    if (prop.startsWith("aria-") || prop === "role" || prop === "title") {
      return true;
    }
  }
};
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Icon = forwardRef$1(
  ({
    color: color2 = "currentColor",
    size: size2 = 24,
    strokeWidth = 2,
    absoluteStrokeWidth,
    className = "",
    children,
    iconNode,
    ...rest
  }, ref2) => createElement(
    "svg",
    {
      ref: ref2,
      ...defaultAttributes,
      width: size2,
      height: size2,
      stroke: color2,
      strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size2) : strokeWidth,
      className: mergeClasses("lucide", className),
      ...!children && !hasA11yProp(rest) && { "aria-hidden": "true" },
      ...rest
    },
    [
      ...iconNode.map(([tag2, attrs]) => createElement(tag2, attrs)),
      ...Array.isArray(children) ? children : [children]
    ]
  )
);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const createLucideIcon = (iconName, iconNode) => {
  const Component2 = forwardRef$1(
    ({ className, ...props }, ref2) => createElement(Icon, {
      ref: ref2,
      iconNode,
      className: mergeClasses(
        `lucide-${toKebabCase(toPascalCase(iconName))}`,
        `lucide-${iconName}`,
        className
      ),
      ...props
    })
  );
  Component2.displayName = toPascalCase(iconName);
  return Component2;
};
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$7 = [
  ["path", { d: "M4 20h16", key: "14thso" }],
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
];
const Baseline = createLucideIcon("baseline", __iconNode$7);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$6 = [
  ["path", { d: "M20 4v7a4 4 0 0 1-4 4H4", key: "6o5b7l" }],
  ["path", { d: "m9 10-5 5 5 5", key: "1kshq7" }]
];
const CornerDownLeft = createLucideIcon("corner-down-left", __iconNode$6);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$5 = [
  ["path", { d: "m9 11-6 6v3h9l3-3", key: "1a3l36" }],
  ["path", { d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4", key: "14a9rk" }]
];
const Highlighter = createLucideIcon("highlighter", __iconNode$5);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$4 = [
  ["path", { d: "M21 5H3", key: "1fi0y6" }],
  ["path", { d: "M17 12H7", key: "16if0g" }],
  ["path", { d: "M19 19H5", key: "vjpgq2" }]
];
const TextAlignCenter = createLucideIcon("text-align-center", __iconNode$4);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$3 = [
  ["path", { d: "M21 5H3", key: "1fi0y6" }],
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M21 19H7", key: "4cu937" }]
];
const TextAlignEnd = createLucideIcon("text-align-end", __iconNode$3);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$2 = [
  ["path", { d: "M3 5h18", key: "1u36vt" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 19h18", key: "awlh7x" }]
];
const TextAlignJustify = createLucideIcon("text-align-justify", __iconNode$2);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode$1 = [
  ["path", { d: "M21 5H3", key: "1fi0y6" }],
  ["path", { d: "M15 12H3", key: "6jk70r" }],
  ["path", { d: "M17 19H3", key: "z6ezky" }]
];
const TextAlignStart = createLucideIcon("text-align-start", __iconNode$1);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __iconNode = [
  ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4", key: "9kb039" }],
  ["line", { x1: "4", x2: "20", y1: "20", y2: "20", key: "nun2al" }]
];
const Underline$1 = createLucideIcon("underline", __iconNode);
const Underline = Mark2.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: false,
        getAttrs: (style3) => style3.includes("underline") ? {} : false
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["u", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: commands2 }) => {
        return commands2.setMark(this.name);
      },
      toggleUnderline: () => ({ commands: commands2 }) => {
        return commands2.toggleMark(this.name);
      },
      unsetUnderline: () => ({ commands: commands2 }) => {
        return commands2.unsetMark(this.name);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
});
const inputRegex = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))$/;
const pasteRegex = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))/g;
const Highlight = Mark2.create({
  name: "highlight",
  addOptions() {
    return {
      multicolor: false,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    if (!this.options.multicolor) {
      return {};
    }
    return {
      color: {
        default: null,
        parseHTML: (element2) => element2.getAttribute("data-color") || element2.style.backgroundColor,
        renderHTML: (attributes) => {
          if (!attributes.color) {
            return {};
          }
          return {
            "data-color": attributes.color,
            style: `background-color: ${attributes.color}; color: inherit`
          };
        }
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "mark"
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["mark", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      setHighlight: (attributes) => ({ commands: commands2 }) => {
        return commands2.setMark(this.name, attributes);
      },
      toggleHighlight: (attributes) => ({ commands: commands2 }) => {
        return commands2.toggleMark(this.name, attributes);
      },
      unsetHighlight: () => ({ commands: commands2 }) => {
        return commands2.unsetMark(this.name);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-h": () => this.editor.commands.toggleHighlight()
    };
  },
  addInputRules() {
    return [
      markInputRule({
        find: inputRegex,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      markPasteRule({
        find: pasteRegex,
        type: this.type
      })
    ];
  }
});
const Superscript = Mark2.create({
  name: "superscript",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "sup"
      },
      {
        style: "vertical-align",
        getAttrs(value) {
          if (value !== "super") {
            return false;
          }
          return null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["sup", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      setSuperscript: () => ({ commands: commands2 }) => {
        return commands2.setMark(this.name);
      },
      toggleSuperscript: () => ({ commands: commands2 }) => {
        return commands2.toggleMark(this.name);
      },
      unsetSuperscript: () => ({ commands: commands2 }) => {
        return commands2.unsetMark(this.name);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-.": () => this.editor.commands.toggleSuperscript()
    };
  }
});
const Subscript = Mark2.create({
  name: "subscript",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "sub"
      },
      {
        style: "vertical-align",
        getAttrs(value) {
          if (value !== "sub") {
            return false;
          }
          return null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["sub", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      setSubscript: () => ({ commands: commands2 }) => {
        return commands2.setMark(this.name);
      },
      toggleSubscript: () => ({ commands: commands2 }) => {
        return commands2.toggleMark(this.name);
      },
      unsetSubscript: () => ({ commands: commands2 }) => {
        return commands2.unsetMark(this.name);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-,": () => this.editor.commands.toggleSubscript()
    };
  }
});
const Placeholder = Extension.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: true,
      showOnlyCurrent: true,
      includeChildren: false
    };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("placeholder"),
        props: {
          decorations: ({ doc: doc2, selection }) => {
            const active = this.editor.isEditable || !this.options.showOnlyWhenEditable;
            const { anchor } = selection;
            const decorations = [];
            if (!active) {
              return null;
            }
            const isEmptyDoc = this.editor.isEmpty;
            doc2.descendants((node2, pos) => {
              const hasAnchor = anchor >= pos && anchor <= pos + node2.nodeSize;
              const isEmpty2 = !node2.isLeaf && isNodeEmpty(node2);
              if ((hasAnchor || !this.options.showOnlyCurrent) && isEmpty2) {
                const classes2 = [this.options.emptyNodeClass];
                if (isEmptyDoc) {
                  classes2.push(this.options.emptyEditorClass);
                }
                const decoration = Decoration.node(pos, pos + node2.nodeSize, {
                  class: classes2.join(" "),
                  "data-placeholder": typeof this.options.placeholder === "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: node2,
                    pos,
                    hasAnchor
                  }) : this.options.placeholder
                });
                decorations.push(decoration);
              }
              return this.options.includeChildren;
            });
            return DecorationSet.create(doc2, decorations);
          }
        }
      })
    ];
  }
});
const PDF_SAFE_FONTS = [
  { value: "default", label: "Default Font" },
  { value: "Arial, sans-serif", label: "Arial" },
  { value: "Helvetica, sans-serif", label: "Helvetica" },
  { value: "'Times New Roman', serif", label: "Times New Roman" },
  { value: "'Courier New', monospace", label: "Courier New" },
  { value: "Calibri, sans-serif", label: "Calibri" },
  { value: "Garamond, serif", label: "Garamond" },
  { value: "Verdana, sans-serif", label: "Verdana" }
];
const FONT_SIZES = [
  { value: "default", label: "Default Size" },
  { value: "12px", label: "Small" },
  { value: "14px", label: "Normal" },
  { value: "18px", label: "Large" },
  { value: "24px", label: "XLarge" }
];
const HEADING_LEVELS = [
  { value: "0", label: "Paragraph" },
  { value: "1", label: "Heading 1" },
  { value: "2", label: "Heading 2" },
  { value: "3", label: "Heading 3" }
];
const iconButtonSx = {
  "&:hover": {
    backgroundColor: "neutral.muted"
  }
};
const ToolbarButton = ({ icon, label, isActive: isActive2 = false, onClick }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  IconButton,
  {
    icon,
    "aria-label": label,
    size: "small",
    variant: isActive2 ? "default" : "invisible",
    onClick,
    sx: iconButtonSx
  }
);
const TipTapHandlebarsEditor = forwardRef$1(
  ({
    content: content2,
    defaultContent = "<p></p>",
    onChange = () => {
    },
    isInvalid,
    availableVariables = []
  }, ref2) => {
    const editor = useEditor({
      extensions: [
        StarterKit,
        Color,
        FontSize,
        FontFamily,
        TextStyle,
        HandlebarsVariable,
        Underline,
        Highlight.configure({ multicolor: true }),
        Superscript,
        Subscript,
        Placeholder.configure({
          placeholder: "Start typing your content or insert variables..."
        }),
        TextAlign.configure({
          types: ["heading", "paragraph"]
        }),
        Link.configure({
          openOnClick: false,
          autolink: true
        }),
        Table2.configure({
          resizable: false
        }),
        TableRow,
        TableHeader,
        TableCell
      ],
      content: content2 || defaultContent,
      onUpdate: ({ editor: editor2 }) => onChange(editor2.getHTML())
    });
    useEffect(() => {
      const oldContent = editor == null ? void 0 : editor.getHTML();
      if (oldContent === content2) return;
      editor == null ? void 0 : editor.commands.setContent(content2 || defaultContent);
    }, [content2, editor, defaultContent]);
    if (!editor) {
      return null;
    }
    const insertVariable = (variableKey) => {
      editor.chain().focus().insertHandlebarsVariable(variableKey).run();
    };
    const isBold = editor == null ? void 0 : editor.isActive("bold");
    const isItalic = editor == null ? void 0 : editor.isActive("italic");
    const isUnderline = editor == null ? void 0 : editor.isActive("underline");
    const isStrike = editor == null ? void 0 : editor.isActive("strike");
    const isOrderedList = editor == null ? void 0 : editor.isActive("orderedList");
    const isBulletList = editor == null ? void 0 : editor.isActive("bulletList");
    const isLink = editor == null ? void 0 : editor.isActive("link");
    const isBlockquote = editor == null ? void 0 : editor.isActive("blockquote");
    const isSuperscript = editor == null ? void 0 : editor.isActive("superscript");
    const isSubscript = editor == null ? void 0 : editor.isActive("subscript");
    editor == null ? void 0 : editor.isActive("highlight");
    const headingLevel = editor == null ? void 0 : editor.getAttributes("heading").level;
    const currentColor = editor == null ? void 0 : editor.getAttributes("textStyle").color;
    const currentFontSize = editor == null ? void 0 : editor.getAttributes("textStyle").fontSize;
    const currentFontFamily = editor == null ? void 0 : editor.getAttributes("textStyle").fontFamily;
    const isAlignLeft = editor == null ? void 0 : editor.isActive({ textAlign: "left" });
    const isAlignCenter = editor == null ? void 0 : editor.isActive({ textAlign: "center" });
    const isAlignRight = editor == null ? void 0 : editor.isActive({ textAlign: "right" });
    const isAlignJustify = editor == null ? void 0 : editor.isActive({ textAlign: "justify" });
    const onBold = () => editor == null ? void 0 : editor.chain().focus().toggleBold().run();
    const onItalic = () => editor == null ? void 0 : editor.chain().focus().toggleItalic().run();
    const onUnderline = () => editor == null ? void 0 : editor.chain().focus().toggleUnderline().run();
    const onStrike = () => editor == null ? void 0 : editor.chain().focus().toggleStrike().run();
    const onSuperscript = () => editor == null ? void 0 : editor.chain().focus().toggleSuperscript().run();
    const onSubscript = () => editor == null ? void 0 : editor.chain().focus().toggleSubscript().run();
    const onOrderedList = () => editor == null ? void 0 : editor.chain().focus().toggleOrderedList().run();
    const onBulletList = () => editor == null ? void 0 : editor.chain().focus().toggleBulletList().run();
    const onBlockquote = () => editor == null ? void 0 : editor.chain().focus().toggleBlockquote().run();
    const onLink = () => {
      const url = window.prompt("Enter URL:");
      if (url) {
        editor == null ? void 0 : editor.chain().focus().setLink({ href: url }).run();
      }
    };
    const onInsertTable = () => {
      editor == null ? void 0 : editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run();
    };
    const onAddColumnBefore = () => editor == null ? void 0 : editor.chain().focus().addColumnBefore().run();
    const onAddColumnAfter = () => editor == null ? void 0 : editor.chain().focus().addColumnAfter().run();
    const onDeleteColumn = () => editor == null ? void 0 : editor.chain().focus().deleteColumn().run();
    const onAddRowBefore = () => editor == null ? void 0 : editor.chain().focus().addRowBefore().run();
    const onAddRowAfter = () => editor == null ? void 0 : editor.chain().focus().addRowAfter().run();
    const onDeleteRow = () => editor == null ? void 0 : editor.chain().focus().deleteRow().run();
    const onDeleteTable = () => editor == null ? void 0 : editor.chain().focus().deleteTable().run();
    const onMergeCells = () => editor == null ? void 0 : editor.chain().focus().mergeCells().run();
    const onSplitCell = () => editor == null ? void 0 : editor.chain().focus().splitCell().run();
    const onToggleHeaderRow = () => editor == null ? void 0 : editor.chain().focus().toggleHeaderRow().run();
    const getHeadingLabel = () => {
      if (headingLevel === 1) return "Heading 1";
      if (headingLevel === 2) return "Heading 2";
      if (headingLevel === 3) return "Heading 3";
      return "Paragraph";
    };
    const getFontSizeLabel = () => {
      if (currentFontSize === "12px") return "Small";
      if (currentFontSize === "14px") return "Normal";
      if (currentFontSize === "18px") return "Large";
      if (currentFontSize === "24px") return "XLarge";
      return "Default Size";
    };
    const getFontFamilyLabel = () => {
      if (!currentFontFamily) return "Default Font";
      return currentFontFamily.split(",")[0].replace(/['"]+/g, "");
    };
    const onHeadingChange = (level) => {
      if (level === "0") {
        editor == null ? void 0 : editor.chain().focus().setParagraph().run();
      } else {
        editor == null ? void 0 : editor.chain().focus().toggleHeading({ level: parseInt(level) }).run();
      }
    };
    const onFontSizeChange = (size2) => {
      if (size2 === "default") {
        editor == null ? void 0 : editor.chain().focus().unsetFontSize().run();
      } else {
        editor == null ? void 0 : editor.chain().focus().setFontSize(size2).run();
      }
    };
    const onFontFamilyChange = (fontFamily2) => {
      if (fontFamily2 === "default") {
        editor == null ? void 0 : editor.chain().focus().unsetFontFamily().run();
      } else {
        editor == null ? void 0 : editor.chain().focus().setFontFamily(fontFamily2).run();
      }
    };
    const onColorChange = (color2) => {
      editor == null ? void 0 : editor.chain().focus().setColor(color2).run();
    };
    const onHighlight = (color2) => {
      if (color2) {
        editor == null ? void 0 : editor.chain().focus().toggleHighlight({ color: color2 }).run();
      } else {
        editor == null ? void 0 : editor.chain().focus().toggleHighlight().run();
      }
    };
    const onAlignLeft = () => editor == null ? void 0 : editor.chain().focus().setTextAlign("left").run();
    const onAlignCenter = () => editor == null ? void 0 : editor.chain().focus().setTextAlign("center").run();
    const onAlignRight = () => editor == null ? void 0 : editor.chain().focus().setTextAlign("right").run();
    const onAlignJustify = () => editor == null ? void 0 : editor.chain().focus().setTextAlign("justify").run();
    const onInsertHR = () => editor == null ? void 0 : editor.chain().focus().setHorizontalRule().run();
    const onHardBreak = () => editor == null ? void 0 : editor.chain().focus().setHardBreak().run();
    const onUndo = () => editor == null ? void 0 : editor.chain().focus().undo().run();
    const onRedo = () => editor == null ? void 0 : editor.chain().focus().redo().run();
    const onClearFormatting = () => {
      editor == null ? void 0 : editor.chain().focus().clearNodes().unsetAllMarks().run();
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Box,
      {
        borderColor: isInvalid ? "danger.emphasis" : "border.default",
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: 2,
        sx: {
          ".ProseMirror": {
            minHeight: "200px",
            padding: 3,
            outline: "none",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
            fontSize: "inherit",
            lineHeight: "1.6",
            overflowWrap: "break-word",
            wordBreak: "break-word",
            "&:focus": {
              outline: "none"
            }
          },
          ".ProseMirror h1": {
            fontSize: "2em",
            margin: "0.67em 0",
            fontWeight: "bold",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif"
          },
          ".ProseMirror h2": {
            fontSize: "1.5em",
            margin: "0.75em 0",
            fontWeight: "bold",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif"
          },
          ".ProseMirror h3": {
            fontSize: "1.17em",
            margin: "0.83em 0",
            fontWeight: "bold",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif"
          },
          ".ProseMirror p": {
            margin: "1em 0"
          },
          ".ProseMirror br": {
            display: "block",
            margin: 0,
            lineHeight: "1.6",
            content: '""'
          },
          ".ProseMirror strong, .ProseMirror b": {
            fontWeight: "bold !important"
          },
          ".ProseMirror em, .ProseMirror i": {
            fontStyle: "italic !important"
          },
          ".ProseMirror u": {
            textDecoration: "underline !important"
          },
          ".ProseMirror s, .ProseMirror strike": {
            textDecoration: "line-through !important"
          },
          ".ProseMirror sup": {
            verticalAlign: "super",
            fontSize: "smaller"
          },
          ".ProseMirror sub": {
            verticalAlign: "sub",
            fontSize: "smaller"
          },
          ".ProseMirror ul": {
            listStyleType: "disc",
            paddingLeft: "2em",
            margin: "1em 0"
          },
          ".ProseMirror ol": {
            listStyleType: "decimal",
            paddingLeft: "2em",
            margin: "1em 0"
          },
          ".ProseMirror li": {
            margin: "0.5em 0"
          },
          ".ProseMirror a": {
            color: "#0969da",
            textDecoration: "none"
          },
          ".ProseMirror hr": {
            border: 0,
            borderTop: "1px solid #d0d7de",
            margin: "1.5em 0"
          },
          ".ProseMirror table": {
            borderCollapse: "collapse",
            width: "100%",
            margin: "1em 0"
          },
          ".ProseMirror table td, .ProseMirror table th": {
            border: "1px solid #d0d7de",
            padding: "0.5em",
            overflowWrap: "break-word",
            wordBreak: "break-word"
          },
          ".ProseMirror table th": {
            backgroundColor: "#f6f8fa",
            fontWeight: "bold"
          },
          ".handlebars-variable": {
            backgroundColor: "neutral.muted",
            padding: "2px 6px",
            borderRadius: 1,
            fontFamily: "mono",
            color: "danger.fg",
            cursor: "pointer",
            border: "1px solid",
            borderColor: "border.default"
          },
          ".ProseMirror blockquote": {
            borderLeft: "4px solid #d0d7de",
            paddingLeft: "1em",
            marginLeft: 0,
            color: "#57606a"
          },
          ".ProseMirror mark": {
            backgroundColor: "yellow",
            padding: "0.1em 0.2em"
          }
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            Box,
            {
              display: "flex",
              p: 2,
              borderBottomWidth: 1,
              borderBottomStyle: "solid",
              borderColor: "border.default",
              sx: { gap: 2, flexWrap: "wrap" },
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { display: "flex", sx: { gap: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionMenu, { children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Button, { size: "small", variant: "invisible", children: "Insert Variable" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Overlay, { width: "medium", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList, { children: availableVariables.length > 0 ? availableVariables.map((variable) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                    ActionList.Item,
                    {
                      onSelect: () => insertVariable(variable.key),
                      children: variable.label
                    },
                    variable.key
                  )) : /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Item, { disabled: true, children: "No variables available" }) }) })
                ] }) }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  Box,
                  {
                    display: "flex",
                    sx: { gap: 1 },
                    paddingLeft: 2,
                    paddingRight: 2,
                    borderLeftWidth: 1,
                    borderLeftStyle: "solid",
                    borderColor: "border.default",
                    children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionMenu, { children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Button, { size: "small", variant: "invisible", children: getHeadingLabel() }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Overlay, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList, { children: HEADING_LEVELS.map((level) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                          ActionList.Item,
                          {
                            onSelect: () => onHeadingChange(level.value),
                            selected: level.value === "0" ? !headingLevel : headingLevel === parseInt(level.value),
                            children: level.label
                          },
                          level.value
                        )) }) })
                      ] }),
                      /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionMenu, { children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Button, { size: "small", variant: "invisible", children: getFontSizeLabel() }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Overlay, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList, { children: FONT_SIZES.map((size2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                          ActionList.Item,
                          {
                            onSelect: () => onFontSizeChange(size2.value),
                            selected: size2.value === "default" ? !currentFontSize : currentFontSize === size2.value,
                            children: size2.label
                          },
                          size2.value
                        )) }) })
                      ] }),
                      /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionMenu, { children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Button, { size: "small", variant: "invisible", children: getFontFamilyLabel() }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Overlay, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList, { children: PDF_SAFE_FONTS.map((font) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                          ActionList.Item,
                          {
                            onSelect: () => onFontFamilyChange(font.value),
                            selected: font.value === "default" ? !currentFontFamily : currentFontFamily == null ? void 0 : currentFontFamily.includes(font.label),
                            children: font.label
                          },
                          font.value
                        )) }) })
                      ] })
                    ]
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  Box,
                  {
                    display: "flex",
                    sx: { gap: 1 },
                    paddingLeft: 2,
                    paddingRight: 2,
                    borderLeftWidth: 1,
                    borderLeftStyle: "solid",
                    borderColor: "border.default",
                    children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: BoldIcon, label: "Bold", isActive: isBold, onClick: onBold }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: ItalicIcon, label: "Italic", isActive: isItalic, onClick: onItalic }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: () => /* @__PURE__ */ jsxRuntimeExports.jsx(Underline$1, { size: 16 }), label: "Underline", isActive: isUnderline, onClick: onUnderline }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: StrikethroughIcon, label: "Strikethrough", isActive: isStrike, onClick: onStrike }),
                      /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionMenu, { children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Button, { size: "small", variant: "invisible", children: "x²" }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Overlay, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionList, { children: [
                          /* @__PURE__ */ jsxRuntimeExports.jsx(
                            ActionList.Item,
                            {
                              onSelect: onSuperscript,
                              selected: isSuperscript,
                              children: "Superscript (x²)"
                            }
                          ),
                          /* @__PURE__ */ jsxRuntimeExports.jsx(
                            ActionList.Item,
                            {
                              onSelect: onSubscript,
                              selected: isSubscript,
                              children: "Subscript (x₂)"
                            }
                          )
                        ] }) })
                      ] })
                    ]
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  Box,
                  {
                    display: "flex",
                    sx: { gap: 1 },
                    paddingLeft: 2,
                    borderLeftWidth: 1,
                    borderLeftStyle: "solid",
                    borderColor: "border.default",
                    children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: ListUnorderedIcon, label: "Bullet List", isActive: isBulletList, onClick: onBulletList }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: ListOrderedIcon, label: "Numbered List", isActive: isOrderedList, onClick: onOrderedList }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: QuoteIcon, label: "Blockquote", isActive: isBlockquote, onClick: onBlockquote })
                    ]
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  Box,
                  {
                    display: "flex",
                    sx: { gap: 1, alignItems: "center" },
                    paddingLeft: 2,
                    paddingRight: 2,
                    borderLeftWidth: 1,
                    borderLeftStyle: "solid",
                    borderColor: "border.default",
                    children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { display: "flex", sx: { alignItems: "center", gap: 1 }, children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx(Baseline, { size: 16, "aria-label": "Text Color" }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx(
                          "input",
                          {
                            type: "color",
                            value: currentColor || "#000000",
                            onChange: (e) => onColorChange(e.target.value),
                            title: "Text Color",
                            "aria-label": "Text Color",
                            style: {
                              width: "28px",
                              height: "28px",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                              padding: "2px",
                              marginBottom: "0"
                            }
                          }
                        )
                      ] }),
                      /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { display: "flex", sx: { alignItems: "center", gap: 1 }, children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx(Highlighter, { size: 16, "aria-label": "Highlight Color" }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx(
                          "input",
                          {
                            type: "color",
                            value: (editor == null ? void 0 : editor.getAttributes("highlight").color) || "#ffff00",
                            onChange: (e) => onHighlight(e.target.value),
                            title: "Highlight Color",
                            "aria-label": "Highlight Color",
                            style: {
                              width: "28px",
                              height: "28px",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                              padding: "2px",
                              marginBottom: "0"
                            }
                          }
                        )
                      ] })
                    ]
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  Box,
                  {
                    display: "flex",
                    sx: { gap: 1 },
                    paddingLeft: 2,
                    paddingRight: 2,
                    borderLeftWidth: 1,
                    borderLeftStyle: "solid",
                    borderColor: "border.default",
                    children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: () => /* @__PURE__ */ jsxRuntimeExports.jsx(TextAlignStart, { size: 16 }), label: "Align Left", isActive: isAlignLeft, onClick: onAlignLeft }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: () => /* @__PURE__ */ jsxRuntimeExports.jsx(TextAlignCenter, { size: 16 }), label: "Align Center", isActive: isAlignCenter, onClick: onAlignCenter }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: () => /* @__PURE__ */ jsxRuntimeExports.jsx(TextAlignEnd, { size: 16 }), label: "Align Right", isActive: isAlignRight, onClick: onAlignRight }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: () => /* @__PURE__ */ jsxRuntimeExports.jsx(TextAlignJustify, { size: 16 }), label: "Align Justify", isActive: isAlignJustify, onClick: onAlignJustify })
                    ]
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  Box,
                  {
                    display: "flex",
                    sx: { gap: 1 },
                    paddingLeft: 2,
                    borderLeftWidth: 1,
                    borderLeftStyle: "solid",
                    borderColor: "border.default",
                    children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: HorizontalRuleIcon, label: "Insert Horizontal Rule", onClick: onInsertHR }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: () => /* @__PURE__ */ jsxRuntimeExports.jsx(CornerDownLeft, { size: 16 }), label: "Insert Line Break", onClick: onHardBreak }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: LinkIcon, label: "Insert Link", isActive: isLink, onClick: onLink }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: TableIcon, label: "Insert Table", onClick: onInsertTable }),
                      (editor == null ? void 0 : editor.can().addColumnBefore()) && /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionMenu, { children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Button, { size: "small", variant: "invisible", children: "Table" }),
                        /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Overlay, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionList, { children: [
                          /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Item, { onSelect: onAddColumnBefore, children: "Add Column Before" }),
                          /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Item, { onSelect: onAddColumnAfter, children: "Add Column After" }),
                          /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Item, { onSelect: onDeleteColumn, children: "Delete Column" }),
                          /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Divider, {}),
                          /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Item, { onSelect: onAddRowBefore, children: "Add Row Before" }),
                          /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Item, { onSelect: onAddRowAfter, children: "Add Row After" }),
                          /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Item, { onSelect: onDeleteRow, children: "Delete Row" }),
                          /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Divider, {}),
                          (editor == null ? void 0 : editor.can().mergeCells()) && /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Item, { onSelect: onMergeCells, children: "Merge Cells" }),
                          (editor == null ? void 0 : editor.can().splitCell()) && /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Item, { onSelect: onSplitCell, children: "Split Cell" }),
                          /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Item, { onSelect: onToggleHeaderRow, children: "Toggle Header Row" }),
                          /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Divider, {}),
                          /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList.Item, { onSelect: onDeleteTable, variant: "danger", children: "Delete Table" })
                        ] }) })
                      ] })
                    ]
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Box,
                  {
                    display: "flex",
                    sx: { gap: 1 },
                    paddingLeft: 2,
                    borderLeftWidth: 1,
                    borderLeftStyle: "solid",
                    borderColor: "border.default",
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: TrashIcon, label: "Clear Formatting", onClick: onClearFormatting })
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  Box,
                  {
                    display: "flex",
                    sx: { gap: 1 },
                    paddingLeft: 2,
                    borderLeftWidth: 1,
                    borderLeftStyle: "solid",
                    borderColor: "border.default",
                    children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: ArrowLeftIcon, label: "Undo", onClick: onUndo }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarButton, { icon: ArrowRightIcon, label: "Redo", onClick: onRedo })
                    ]
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ref: ref2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EditorContent, { editor, content: content2 }) })
        ]
      }
    );
  }
);
TipTapHandlebarsEditor.displayName = "TipTapHandlebarsEditor";
const isValidSponsorSection = (section) => section.title !== void 0 && section.sponsorTierId !== void 0 && section.styling !== void 0;
const isMarkdownSection = (content2) => content2.type === "Microsite::MarkdownSection";
const isRegularMicrositeSection = (content2) => content2.type === "Microsite::Section" || content2.type === null || content2.type === void 0;
const MARKDOWN_CHEAT_SHEET$1 = "https://s3.amazonaws.com/helpscout.net/docs/assets/5c53282b042863543ccc71dd/attachments/5d8f545204286364bc8fad59/getregistered%C2%AE-Markdown-Cheatsheet.pdf";
function SectionForm({
  section,
  eventPaths = void 0,
  tracks = void 0,
  useRichText = false,
  onChange,
  onFileChange,
  onRemoveFile,
  onSave,
  onDelete
}) {
  const handleSubmit = (e) => e.preventDefault();
  const handleInputChange = (e) => {
    onChange(e.target.name, e.target.value);
  };
  const handleDelete2 = (e) => {
    e.preventDefault();
    onDelete();
  };
  const handleSave = (e) => {
    e.preventDefault();
    onSave();
  };
  const scopedFieldName = (name2) => `section_${section.id}_name`;
  if (!section) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "small-caps", children: "Select a field to start editing." });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "t-section-form field-editor", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("header", { className: "txl", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { className: "t-section-title", children: [
        "Edit Section / ",
        section.title
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "form",
        {
          className: "full",
          encType: "multipart/form-data",
          onSubmit: handleSubmit,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "label", children: "Section title" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "input",
              {
                type: "text",
                name: "title",
                value: section.title,
                onChange: handleInputChange,
                className: "t-title-input"
              }
            ),
            useRichText && !isMarkdownSection(section) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
              TipTapContentEditor,
              {
                content: section.html || marked(section.content),
                onChange: (html2) => onChange("html", html2)
              },
              `section-${section.id}`
            ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "content", children: "Section content - markdown format is applied" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "textarea",
                {
                  className: "full-txt-area",
                  style: {
                    marginBottom: 3
                  },
                  name: "content",
                  value: section.content,
                  onChange: handleInputChange
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { minHeight: 25 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                "a",
                {
                  className: "ar",
                  target: "_blank",
                  rel: "noreferrer",
                  href: MARKDOWN_CHEAT_SHEET$1,
                  children: "markdown guide"
                }
              ) })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              UploadForm$1,
              {
                showTitleField: true,
                file: section.download,
                label: "File Download",
                fieldName: scopedFieldName(),
                onChange: (file) => onFileChange("download", file),
                onTitleChange: (title) => onChange("download", { ...section.download, title }),
                onRemoveFile: () => onRemoveFile("download")
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              UploadForm$1,
              {
                file: section.image,
                label: "Background Image",
                fieldName: scopedFieldName(),
                onChange: (file) => onFileChange("image", file),
                onRemoveFile: () => onRemoveFile("image")
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              UploadForm$1,
              {
                showTitleField: true,
                file: section.inlineImage,
                label: "Inline Image",
                fieldName: scopedFieldName(),
                onChange: (file) => onFileChange("inlineImage", file),
                onTitleChange: (title) => onChange("inlineImage", { ...section.inlineImage, title }),
                onRemoveFile: () => onRemoveFile("inlineImage")
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: "Access level" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              AccessForm,
              {
                object: section,
                availableEventPaths: eventPaths,
                availableTracks: tracks,
                onChange: ({ access, metadata, trackIds }) => {
                  onChange("access", access);
                  onChange("metadata", metadata);
                  onChange("trackIds", trackIds);
                }
              },
              section.id
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "save fr", onClick: handleSave, children: "Save" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                type: "button",
                className: "t-delete danger fr",
                onClick: handleDelete2,
                children: "Delete"
              }
            )
          ]
        }
      )
    ] });
  }
}
function isValidUrl(url) {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}
const ExternalLinkForm = ({
  linkedItem,
  onChange
}) => {
  const [error2, setError] = React__default.useState(void 0);
  const [url, setUrl] = React__default.useState(linkedItem.href);
  const handleChange = (e) => {
    const newUrl = e.target.value;
    setUrl(newUrl);
    if (isValidUrl(newUrl)) {
      setError(void 0);
      onChange(newUrl);
    } else if (newUrl === "") {
      setError(void 0);
      onChange(void 0);
    } else {
      setError("Please enter a valid url");
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { isInvalid: error2 !== void 0, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "External link" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Input$1, { value: url, onChange: handleChange }),
    error2 && /* @__PURE__ */ jsxRuntimeExports.jsx(FormErrorMessage, { children: error2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, { children: "Set this field to display this item as an external menu link." })
  ] });
};
function PageForm$1({
  page,
  eventPaths = void 0,
  tracks = void 0,
  allowDelete,
  onChange,
  onSave,
  onDelete
}) {
  const [title, setTitle] = React__default.useState(page.title);
  const handleSubmit = (e) => e.preventDefault();
  const handleSave = (e) => {
    e.preventDefault();
    onSave();
  };
  const handleDelete2 = (e) => {
    e.preventDefault();
    onDelete();
  };
  console.log("microsite page", page);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "field-editor t-page-form", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("header", { className: "txl", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { children: [
      "Edit Page / ",
      page.title
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "form",
      {
        className: "full",
        encType: "multipart/form-data",
        onSubmit: handleSubmit,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "label", children: "Page title" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "input",
            {
              className: "t-title-input",
              type: "text",
              name: "title",
              value: title,
              onChange: (e) => {
                const { value } = e.target;
                setTitle(value);
                if (value.length > 0) {
                  onChange("title", value);
                }
              }
            }
          ),
          !pageHasSections(page) && /* @__PURE__ */ jsxRuntimeExports.jsx(
            ExternalLinkForm,
            {
              linkedItem: page,
              onChange: (href) => {
                onChange("href", href);
              }
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: "Access level" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            AccessForm,
            {
              object: page,
              availableEventPaths: eventPaths,
              availableTracks: tracks,
              onChange: ({ access, metadata, trackIds }) => {
                onChange("access", access);
                onChange("metadata", metadata);
                onChange("trackIds", trackIds);
              }
            },
            page.id
          ),
          allowDelete && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              type: "button",
              className: "t-delete danger fr",
              onClick: handleDelete2,
              children: "Delete"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "save fr", onClick: handleSave, children: "Save" })
        ]
      }
    )
  ] });
}
const AddSponsorSectionButton = ({
  sponsorTiers,
  onClick
}) => {
  if (sponsorTiers.length === 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "t-add-section", children: "Create a Sponsor Tier to start adding sponsorship sections" });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "li",
    {
      className: "t-add-section",
      onClick: () => {
        var _a3;
        return onClick({
          title: "New sponsor section",
          type: SPONSOR_SECTION_TYPE,
          styling: DEFAULT_SPONSOR_STYLING,
          sponsorTierId: (_a3 = sponsorTiers[0]) == null ? void 0 : _a3.id
        });
      },
      children: "Add Sponsor Section"
    }
  );
};
const AddSponsorSectionButtonContainer = (props) => {
  const { error: error2, data: sponsorTiers } = useSponsorTiers();
  if (error2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage, { children: "Error loading Sponsor Tiers" });
  }
  if (sponsorTiers === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {});
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AddSponsorSectionButton, { sponsorTiers, ...props });
};
function AddTab({
  selectedPage,
  sponsorshipEnabled,
  markdownSectionsEnabled,
  onAddSection,
  onAddPage
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { className: "create-menu t-create-menu", children: [
    !pageHasLink(selectedPage) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "li",
        {
          className: "t-add-section",
          onClick: () => onAddSection(),
          children: "Add Section"
        },
        "add-section"
      ),
      markdownSectionsEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
        "li",
        {
          className: "t-add-markdown-section",
          onClick: () => onAddSection({ type: "Microsite::MarkdownSection" }),
          children: "Add Markdown Section"
        },
        "add-markdown-section"
      ),
      sponsorshipEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
        AddSponsorSectionButtonContainer,
        {
          onClick: onAddSection
        },
        "add-sponsor-section"
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "t-add-page", onClick: onAddPage, children: "Add Page" }, "add-page")
  ] });
}
const pageDefaults = {
  title: "New Page",
  isNew: true
};
const sectionDefaults = {
  title: "New Section",
  content: "Lorem ipsum",
  isNew: true
};
const getSelectedItems = (state) => {
  const selectedPage = state.pages.find((p2) => p2.id === state.selectedPageId) || state.pages[0];
  const selectedSection = selectedPage.sections && selectedPage.sections.find((s2) => s2.id === state.selectedSectionId);
  return { selectedPage, selectedSection };
};
const findPage = (draft, id) => {
  const page = draft.pages.find((p2) => idsEqual(p2.id, id));
  if (page === void 0) {
    throw new Error(`Page not found with ID: ${id}`);
  }
  return page;
};
const findSection$1 = (draft, id) => {
  if (!draft.selectedPageId) {
    throw new Error("You must select a page before selecting a section");
  }
  const section = findPage(draft, draft.selectedPageId).sections.find(
    (s2) => s2.id === id
  );
  if (!section) {
    throw new Error(`Section not found with ID: ${id}`);
  }
  return section;
};
const selectedPageToEdit = (draft, callback) => {
  callback(findPage(draft, draft.selectedPageId));
};
const findSectionToEdit = (draft, id, callback) => {
  selectedPageToEdit(draft, (selectedPage) => {
    if (!selectedPage.sections) {
      throw new Error(`Page with ID ${selectedPage.id} has no sections`);
    }
    const sectionIndex = selectedPage.sections.findIndex(
      (s2) => idsEqual(s2.id, id)
    );
    if (!sectionIndex === -1) {
      throw new Error(`Section not found with ID: ${id}`);
    }
    const section = selectedPage.sections[sectionIndex];
    callback({ selectedPage, sectionIndex, section });
  });
};
function micrositeReducer(state, action) {
  return fn(state, (draft) => {
    switch (action.type) {
      case "select_page":
        draft.selectedPageId = findPage(draft, action.id).id;
        draft.selectedTab = "page";
        break;
      case "select_section":
        draft.selectedSectionId = findSection$1(draft, action.id).id;
        draft.selectedTab = "edit";
        break;
      case "select_tab":
        draft.selectedTab = action.tab;
        break;
      case "add_page":
        const newPage = { ...pageDefaults, ...action.page };
        if (!newPage.id) {
          newPage.id = idGenerator();
        }
        if (!draft.pages) {
          draft.pages = [newPage];
        } else {
          draft.pages.push(newPage);
        }
        draft.selectedPage = newPage;
        draft.dirty = true;
        break;
      case "delete_page":
        const pageIndex = draft.pages.findIndex((p2) => p2.id === action.id);
        if (pageIndex === -1) {
          throw new Error(`Page not found with ID: ${action.id}`);
        }
        const pageToDelete = draft.pages[pageIndex];
        if (!pageToDelete.isNew) {
          if (!draft.deletedPages) {
            draft.deletedPages = [pageToDelete.id];
          } else {
            draft.deletedPages.push(pageToDelete.id);
          }
        }
        draft.pages.splice(pageIndex, 1);
        draft.dirty = true;
        if (action.id === draft.selectedPageId) {
          draft.selectedPageId = draft.pages[0].id;
          draft.selectedSectionId = null;
        }
        break;
      case "update_page":
        const page = findPage(draft, action.id);
        if (page === void 0) {
          throw new Error(`Page not found with ID: ${action.id}`);
        }
        Object.assign(page, action.payload);
        draft.dirty = true;
        break;
      case "move_page":
        const startIndex = draft.pages.findIndex(
          (p2) => idsEqual(p2.id, action.id)
        );
        if (startIndex === -1) {
          throw new Error(`Page not found with ID: ${action.id}`);
        }
        const pageToMove = draft.pages.splice(startIndex, 1)[0];
        draft.pages.splice(action.toIndex, 0, pageToMove);
        draft.dirty = true;
        break;
      case "reset_pages":
        draft.pages = action.pages;
        draft.dirty = false;
        delete draft.deletedPages;
        break;
      case "set_dirty":
        draft.dirty = action.dirty;
        break;
      case "add_section":
        const newSection = { ...sectionDefaults, ...action.section };
        if (!newSection.id) {
          newSection.id = idGenerator();
        }
        selectedPageToEdit(draft, (selectedPage) => {
          if (!selectedPage.sections) {
            selectedPage.sections = [newSection];
          } else {
            selectedPage.sections.push(newSection);
          }
        });
        draft.selectedSectionId = newSection.id;
        draft.selectedTab = "edit";
        draft.dirty = true;
        break;
      case "delete_section":
        findSectionToEdit(
          draft,
          action.id,
          ({ selectedPage, section, sectionIndex }) => {
            selectedPage.sections.splice(sectionIndex, 1);
            if (!section.isNew) {
              if (!selectedPage.deletedSections) {
                selectedPage.deletedSections = [section.id];
              } else {
                selectedPage.deletedSections.push(section.id);
              }
            }
          }
        );
        draft.dirty = true;
        break;
      case "update_section":
        findSectionToEdit(draft, action.id, ({ section }) => {
          Object.assign(section, action.payload);
        });
        draft.dirty = true;
        break;
      case "remove_section_file":
        findSectionToEdit(draft, action.id, ({ section }) => {
          delete section[action.file];
        });
        draft.dirty = true;
        break;
      case "move_section":
        findSectionToEdit(
          draft,
          action.id,
          ({ selectedPage, sectionIndex }) => {
            const section = selectedPage.sections.splice(sectionIndex, 1)[0];
            selectedPage.sections.splice(action.toIndex, 0, section);
          }
        );
        draft.dirty = true;
        break;
      default:
        throw new Error();
    }
  });
}
const numberOrUndefined = (s2) => {
  const parsed = Number(s2);
  if (isNaN(parsed)) {
    return void 0;
  } else {
    return parsed;
  }
};
const SponsorSectionForm = ({
  section: initialSection,
  sponsorTiers,
  onChange,
  onSave,
  onDelete
}) => {
  var _a3;
  const [section, setSection] = useState(initialSection);
  useEffect(() => {
    setSection(initialSection);
    console.log("initial section changed", initialSection);
  }, [initialSection]);
  const handleChange = (update2) => {
    const newSection = {
      ...section,
      ...update2
    };
    if (isValidSponsorSection(section)) {
      setSection(newSection);
      onChange(newSection);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "t-section-form field-editor", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("header", { className: "txl", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { className: "t-section-title", children: [
      "Edit Sponsor Section / ",
      section.title
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Title" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Input$1,
          {
            name: "title",
            value: section.title,
            onChange: (e) => handleChange({ title: e.target.value })
          }
        )
      ] }, "title"),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Sponsor tier" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Select$2,
          {
            name: "sponsorTier",
            value: section.sponsorTierId,
            onChange: (e) => handleChange({
              sponsorTierId: numberOrUndefined(e.target.value)
            }),
            children: sponsorTiers.map((tier) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: tier.id, children: tier.title }, tier.id))
          }
        )
      ] }, "sponsorTier"),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Styling" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Select$2,
          {
            name: "styling",
            value: (_a3 = section.styling) == null ? void 0 : _a3.toString(),
            onChange: (e) => handleChange({
              styling: numberOrUndefined(e.target.value)
            }),
            children: SPONSOR_STYLINGS.map((label, value) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value, children: label }, value))
          }
        )
      ] }, "styling")
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { mt: 8, justifyContent: "flex-end", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          colorScheme: "red",
          size: "sm",
          onClick: onDelete,
          className: "t-delete",
          children: "Delete"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          colorScheme: "green",
          size: "sm",
          onClick: onSave,
          className: "t-form-save",
          children: "Save"
        }
      )
    ] })
  ] });
};
const SponsorSectionFormContainer = (props) => {
  const { error: error2, data: sponsorTiers } = useSponsorTiers();
  if (error2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage, { children: "Error loading Sponsor Tiers" });
  }
  if (sponsorTiers === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {});
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SponsorSectionForm, { sponsorTiers, ...props });
};
function MicrositeEditor({
  initialPages,
  sponsorshipEnabled,
  eventPaths = void 0,
  tracks = void 0,
  markdownSectionsEnabled = false,
  useRichText = false,
  onSave,
  onFileUpload
}) {
  const initialState2 = {
    selectedPageId: initialPages[0].id,
    pages: initialPages
  };
  const [state, dispatch] = useReducer(micrositeReducer, initialState2);
  const [saving, setSaving] = useState(false);
  const { selectedTab, pages, deletedPages, dirty } = state;
  const { selectedPage, selectedSection } = getSelectedItems(state);
  useEffect(() => {
    const doSave = async () => {
      if (saving) {
        const success = await onSave(pages, deletedPages);
        setSaving(false);
        if (success) {
          dispatch({ type: "set_dirty", dirty: false });
        }
      }
    };
    doSave();
  }, [saving]);
  useEffect(() => {
    dispatch({ type: "reset_pages", pages: initialPages });
  }, [initialPages]);
  const updateSection = (payload) => {
    dispatch({
      type: "update_section",
      pageId: selectedPage.id,
      id: selectedSection.id,
      payload
    });
  };
  const updateSectionField = (name2, value) => {
    console.log("updateSectionField", name2, value);
    const payload = {};
    payload[name2] = value;
    updateSection(payload);
  };
  const handleSave = () => {
    setSaving(true);
  };
  const handleUpdatePage = (field, value) => {
    const payload = {};
    payload[field] = value;
    dispatch({ type: "update_page", id: selectedPage.id, payload });
  };
  const handleFileUpload = async (fieldName, file) => {
    updateSectionField(fieldName, file);
    const uploadedFile = await onFileUpload(file);
    updateSectionField(fieldName, uploadedFile);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(QueryClientProvider, { client: new QueryClient(), children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "dynamic-editor", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      StateBar,
      {
        dirty,
        onSave: handleSave,
        onReset: () => dispatch({ type: "reset_pages", pages: initialPages })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PagesMenu$1,
      {
        pages,
        onSelectPage: (id) => dispatch({ type: "select_page", id }),
        onAddPage: (page) => dispatch({ type: "add_page", page }),
        onMovePage: (id, toIndex) => dispatch({ type: "move_page", id, toIndex })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PageEditor$1,
      {
        page: selectedPage,
        useRichText,
        selectedSection,
        onSelectSection: (id) => dispatch({ type: "select_section", id }),
        onMoveSection: (id, toIndex) => {
          dispatch({ type: "move_section", id, toIndex });
        },
        onAddSection: () => dispatch({ type: "add_section" })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "edit-panel", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("article", { className: "type-system-serif", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { className: "tabs-menu t-tabs-menu", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "li",
          {
            className: classNames("thirds", {
              selected: selectedTab === "edit"
            }),
            onClick: () => dispatch({ type: "select_tab", tab: "edit" }),
            children: "Edit"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "li",
          {
            className: classNames("thirds", {
              selected: selectedTab === "add"
            }),
            onClick: () => dispatch({ type: "select_tab", tab: "add" }),
            children: "Add"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "li",
          {
            className: classNames("thirds", {
              selected: selectedTab === "page"
            }),
            onClick: () => dispatch({ type: "select_tab", tab: "page" }),
            children: "Page"
          }
        )
      ] }),
      (() => {
        switch (selectedTab) {
          case "edit":
            if ((selectedSection == null ? void 0 : selectedSection.type) === SPONSOR_SECTION_TYPE) {
              return /* @__PURE__ */ jsxRuntimeExports.jsx(
                SponsorSectionFormContainer,
                {
                  section: selectedSection,
                  onChange: updateSection,
                  onSave: handleSave,
                  onDelete: () => dispatch({
                    type: "delete_section",
                    id: selectedSection.id
                  })
                }
              );
            }
            return /* @__PURE__ */ jsxRuntimeExports.jsx(
              SectionForm,
              {
                section: selectedSection,
                eventPaths,
                tracks,
                useRichText,
                onChange: updateSectionField,
                onRemoveFile: (file) => dispatch({
                  type: "remove_section_file",
                  file,
                  id: selectedSection.id
                }),
                onFileChange: handleFileUpload,
                onSave: handleSave,
                onDelete: () => dispatch({
                  type: "delete_section",
                  id: selectedSection.id
                })
              }
            );
          case "add":
            return /* @__PURE__ */ jsxRuntimeExports.jsx(
              AddTab,
              {
                selectedPage,
                sponsorshipEnabled,
                markdownSectionsEnabled,
                onAddSection: (section) => dispatch({ type: "add_section", section }),
                onAddPage: () => dispatch({ type: "add_page" })
              }
            );
          case "page":
            return /* @__PURE__ */ jsxRuntimeExports.jsx(
              PageForm$1,
              {
                page: selectedPage,
                allowDelete: pages.length > 1,
                eventPaths,
                tracks,
                onChange: handleUpdatePage,
                onSave: handleSave,
                onDelete: () => dispatch({ type: "delete_page", id: selectedPage.id })
              },
              selectedPage.id
            );
          default:
            return null;
        }
      })()
    ] }) })
  ] }) });
}
const editorUIStateReducer = (state, action) => {
  return fn(state, (draft) => {
    switch (action.type) {
      case "select_page":
        draft.selectedPage = action.payload.page.id;
        break;
      case "select_section":
        draft.selectedSection = action.payload.section.id;
        draft.selectedTab = "edit";
        break;
      case "select_tab":
        draft.selectedTab = action.payload.tab;
        break;
      case "show_rebase_modal":
        draft.showRebaseModal = true;
        break;
      case "hide_rebase_modal":
        draft.showRebaseModal = false;
        break;
    }
  });
};
function pageYMapKey(pageId) {
  return `page-${pageId}`;
}
function sectionYMapKey(sectionId) {
  return `section-${sectionId}`;
}
function isValidSection(input) {
  return typeof input === "object" && "id" in input && "pageId" in input && "sort" in input && "type" in input;
}
function getPages(state) {
  const pageIds = Array.from(state.getArray("pageIds"));
  const pagesArray = pageIds.map((pageId) => {
    const pageMap = state.getMap(pageId);
    return pageMap.toJSON();
  });
  pagesArray.sort((a2, b2) => Number(a2.sort) - Number(b2.sort));
  return pagesArray;
}
function getPage(state, pageId) {
  const pageMap = state.getMap(pageYMapKey(pageId));
  return pageMap.toJSON();
}
function getPageWithSections(state, pageId) {
  const page = getPage(state, pageId);
  return {
    ...page,
    sections: getSectionsForPage(state, pageId)
  };
}
function getMaxPagesSort(state) {
  var _a3;
  const pages = getPages(state);
  return Number(((_a3 = pages[pages.length - 1]) == null ? void 0 : _a3.sort) ?? 0);
}
function pageFromYDocPage(state, page) {
  return {
    ...page,
    sections: getSectionsForPage(state, page.id)
  };
}
function getPagesWithSections(state) {
  return getPages(state).map((page) => pageFromYDocPage(state, page));
}
function getSections(state) {
  const sectionIds = state.getArray("sectionIds");
  const sectionsArray = Array.from(sectionIds).map((sectionId) => {
    const sectionMap = state.getMap(sectionId);
    return sectionMap.toJSON();
  });
  sectionsArray.sort((a2, b2) => Number(a2.sort) - Number(b2.sort));
  return sectionsArray;
}
function getSectionsForPage(state, pageId) {
  const sectionIds = state.getArray("sectionIds");
  const sectionsArray = Array.from(sectionIds).map((sectionId) => {
    const sectionMap = state.getMap(sectionId);
    return sectionMap.toJSON();
  }).filter((section) => isValidSection(section)).filter((section) => idsEqual(section.pageId, pageId.toString()));
  sectionsArray.sort((a2, b2) => Number(a2.sort) - Number(b2.sort));
  return sectionsArray;
}
function getSection(state, sectionId) {
  const section = findSection(state, sectionId);
  if (!section) {
    throw new Error(`Section with id ${sectionId} not found`);
  }
  return section;
}
function findSection(state, sectionId) {
  const section = state.getMap(
    sectionYMapKey(sectionId)
  );
  return section.toJSON();
}
function findSectionFromEditorState(state, editorState) {
  if (!editorState.selectedSection) {
    return void 0;
  }
  return findSection(state, editorState.selectedSection);
}
function getMaxSectionSort(state, pageId) {
  var _a3;
  const sections = getSectionsForPage(state, pageId);
  return Number(((_a3 = sections[sections.length - 1]) == null ? void 0 : _a3.sort) ?? 0);
}
function ydocIsDirty(state) {
  return state.getMap("editorState").get("isDirty") === true;
}
function getDuplicatedIndexes(array) {
  const indexes = [];
  array.forEach((value, index2) => {
    if (array.indexOf(value) !== index2) {
      indexes.push(index2);
    }
  });
  return indexes;
}
function removeDuplicated(yArray) {
  const jsArray = yArray.toArray();
  const duplicatedIndexes = getDuplicatedIndexes(jsArray).reverse();
  duplicatedIndexes.forEach((index2) => {
    yArray.delete(index2, 1);
  });
}
function setYMapValues(ymap, obj) {
  Object.entries(obj).forEach(([key2, value]) => {
    if (typeof value === "bigint") {
      ymap.set(key2, Number(value));
    } else {
      ymap.set(key2, value);
    }
  });
}
function setDirty(ydoc) {
  ydoc.getMap("editorState").set("isDirty", true);
}
const ydocMicrositeOperationsReducer = (state, action) => {
  switch (action.type) {
    case "add_page": {
      state.transact(() => {
        const pageIds = state.getArray("pageIds");
        const newPageId = pageYMapKey(action.payload.page.id);
        pageIds.push([newPageId]);
        const pageMap = state.getMap(newPageId);
        const pageObj = action.payload.page;
        for (const key2 in pageObj) {
          if (Object.prototype.hasOwnProperty.call(pageObj, key2)) {
            pageMap.set(key2, pageObj[key2]);
          }
        }
        setDirty(state);
      });
      break;
    }
    case "update_page": {
      state.transact(() => {
        const pageMap = state.getMap(
          pageYMapKey(action.payload.id)
        );
        const updateObj = action.payload.update;
        for (const key2 in updateObj) {
          if (Object.prototype.hasOwnProperty.call(updateObj, key2)) {
            pageMap.set(key2, updateObj[key2]);
          }
        }
        setDirty(state);
      });
      break;
    }
    case "delete_page": {
      state.transact(() => {
        const pageIds = state.getArray("pageIds");
        const jsArray = pageIds.toArray();
        const deletePageId = pageYMapKey(action.payload.id);
        const index2 = jsArray.indexOf(deletePageId);
        if (index2 === -1) {
          throw new Error(`Page with id ${action.payload.id} not found`);
        }
        pageIds.delete(index2, 1);
        const pageMap = state.getMap(deletePageId);
        pageMap.set("isDeleted", true);
        setDirty(state);
      });
      break;
    }
    case "add_section": {
      state.transact(() => {
        if (!isValidSection(action.payload.section)) {
          throw new Error("Invalid section", action.payload.section);
        }
        const sectionIds = state.getArray("sectionIds");
        const newSectionId = sectionYMapKey(action.payload.section.id);
        sectionIds.push([newSectionId]);
        const sectionMap = state.getMap(newSectionId);
        setYMapValues(
          sectionMap,
          action.payload.section
        );
        setDirty(state);
      });
      break;
    }
    case "update_section": {
      state.transact(() => {
        const sectionMap = state.getMap(
          sectionYMapKey(action.payload.id)
        );
        setYMapValues(
          sectionMap,
          action.payload.update
        );
        setDirty(state);
      });
      break;
    }
    case "delete_section": {
      state.transact(() => {
        const sectionIds = state.getArray("sectionIds");
        const jsArray = sectionIds.toArray();
        const deleteSectionId = sectionYMapKey(action.payload.id);
        const index2 = jsArray.indexOf(deleteSectionId);
        if (index2 === -1) {
          throw new Error(`Section with id ${action.payload.id} not found`);
        }
        sectionIds.delete(index2, 1);
        const sectionMap = state.getMap(deleteSectionId);
        sectionMap.set("isDeleted", true);
        setDirty(state);
      });
      break;
    }
    case "de_dupe": {
      state.transact(() => {
        removeDuplicated(state.getArray("pageIds"));
        removeDuplicated(state.getArray("sectionIds"));
      });
      break;
    }
  }
  return state;
};
function initEntity(input) {
  return {
    ...input,
    id: input.id ?? uuid(),
    isNew: true
  };
}
function getUnsavedChanges(ydoc) {
  return ydoc.getArray("unsavedChanges");
}
function getPreviousChanges(ydoc) {
  return ydoc.getArray("previousChanges");
}
function getChangeHistory(ydoc) {
  return {
    unsavedChanges: getUnsavedChanges(ydoc).toArray(),
    previousChanges: getPreviousChanges(ydoc).toArray()
  };
}
function getLastUpdateIndexForUser(changes, userId) {
  const lastChangeIndexForUser = changes.findIndex(
    (change2) => idsEqual(change2.user.id, userId)
  );
  if (lastChangeIndexForUser === -1) {
    return -1;
  }
  const change = changes[lastChangeIndexForUser];
  if (change.type === "update_page" || change.type === "update_section") {
    return lastChangeIndexForUser;
  } else {
    return -1;
  }
}
function mergedChanges(originalChange, newChange) {
  if (originalChange.type === "update_section" && newChange.type === "update_section") {
    return {
      ...newChange,
      operation: {
        type: "update_section",
        payload: {
          id: originalChange.operation.payload.id,
          update: {
            ...originalChange.operation.payload.update,
            ...newChange.operation.payload.update
          }
        }
      },
      // Keep the original undoOperation (points to state before first change)
      undoOperation: originalChange.undoOperation
    };
  } else if (originalChange.type === "update_page" && newChange.type === "update_page") {
    return {
      ...newChange,
      operation: {
        type: "update_page",
        payload: {
          id: originalChange.operation.payload.id,
          update: {
            ...originalChange.operation.payload.update,
            ...newChange.operation.payload.update
          }
        }
      },
      // Keep the original undoOperation (points to state before first change)
      undoOperation: originalChange.undoOperation
    };
  } else {
    throw new Error("Cannot merge changes of different types");
  }
}
function uniqueChangeUsers(changes) {
  const users = /* @__PURE__ */ new Map();
  changes.forEach((change) => {
    if (change.user) {
      users.set(String(change.user.id), change.user);
    }
  });
  return Array.from(users.values());
}
const MAX_HISTORY_ENTRIES = 100;
const ydocMicrositeHistoryReducer = (state, action) => {
  switch (action.type) {
    case "add_page":
    case "delete_page":
    case "add_section":
    case "delete_section": {
      const unsavedChanges = getUnsavedChanges(state);
      unsavedChanges.unshift([action]);
      return state;
    }
    case "update_page":
    case "update_section": {
      state.transact(() => {
        const unsavedChanges = getUnsavedChanges(state);
        const unsavedChangesArray = unsavedChanges.toArray();
        const updateItemIndex = getLastUpdateIndexForUser(
          unsavedChangesArray,
          action.user.id
        );
        if (updateItemIndex === -1) {
          unsavedChanges.unshift([action]);
          return;
        }
        const updateItemChange = unsavedChangesArray[updateItemIndex];
        const currentOperationId = action.operation.payload.id;
        const previousOperationId = updateItemChange.operation.payload.id;
        if (previousOperationId !== currentOperationId) {
          unsavedChanges.unshift([action]);
          return;
        }
        if (action.type === "update_page" && updateItemChange.type === "update_page") {
          const mergedChange = mergedChanges(updateItemChange, action);
          unsavedChanges.delete(updateItemIndex, 1);
          unsavedChanges.unshift([mergedChange]);
        } else if (action.type === "update_section" && updateItemChange.type === "update_section") {
          const mergedChange = mergedChanges(updateItemChange, action);
          unsavedChanges.delete(updateItemIndex, 1);
          unsavedChanges.unshift([mergedChange]);
        } else {
          unsavedChanges.unshift([action]);
        }
      });
      return state;
    }
    case "batch": {
      const unsavedChanges = getUnsavedChanges(state);
      unsavedChanges.unshift([action]);
      return state;
    }
    case "save_microsite": {
      state.transact(() => {
        const unsavedChanges = getUnsavedChanges(state);
        const previousChanges = getPreviousChanges(state);
        previousChanges.unshift([action, ...unsavedChanges.toArray()]);
        unsavedChanges.delete(0, unsavedChanges.length);
        if (previousChanges.length > MAX_HISTORY_ENTRIES) {
          previousChanges.delete(
            MAX_HISTORY_ENTRIES,
            previousChanges.length - MAX_HISTORY_ENTRIES
          );
        }
      });
      return state;
    }
    case "reset_microsite": {
      state.transact(() => {
        const unsavedChanges = getUnsavedChanges(state);
        const previousChanges = getPreviousChanges(state);
        unsavedChanges.delete(0, unsavedChanges.length);
        previousChanges.unshift([action]);
      });
      return state;
    }
    default:
      return state;
  }
};
function createAddPageChange(operation, user, ai) {
  return {
    id: v4(),
    timestamp: Date.now(),
    type: "add_page",
    pageId: String(operation.payload.page.id),
    page: operation.payload.page,
    operation,
    user,
    ai,
    undoOperation: { type: "delete_page", payload: { id: operation.payload.page.id } }
  };
}
function createUpdatePageChange(operation, user, pageId, originalPage, ai) {
  let undoUpdate = {};
  if (originalPage && operation.payload.update) {
    for (const key2 of Object.keys(operation.payload.update)) {
      undoUpdate[key2] = originalPage[key2];
    }
  } else {
    undoUpdate = operation.payload.update;
  }
  return {
    id: v4(),
    timestamp: Date.now(),
    type: "update_page",
    pageId,
    operation,
    user,
    ai,
    undoOperation: {
      type: "update_page",
      payload: { id: pageId, update: undoUpdate }
    }
  };
}
function createDeletePageChange(operation, user, pageId, page, ai) {
  return {
    id: v4(),
    timestamp: Date.now(),
    type: "delete_page",
    pageId,
    operation,
    user,
    ai,
    undoOperation: { type: "add_page", payload: { page } },
    includedChanges: []
  };
}
function createAddSectionChange(operation, user, ai) {
  let section;
  if (operation.payload.section.type === "Microsite::SponsorshipSection") {
    section = operation.payload.section;
  } else {
    section = operation.payload.section;
  }
  return {
    id: v4(),
    timestamp: Date.now(),
    type: "add_section",
    sectionId: String(operation.payload.section.id),
    section,
    operation,
    user,
    ai,
    undoOperation: { type: "delete_section", payload: { id: operation.payload.section.id } }
  };
}
function createUpdateSectionChange(operation, user, sectionId, originalSection, ai) {
  let undoUpdate = {};
  if (originalSection && operation.payload.update) {
    for (const key2 of Object.keys(operation.payload.update)) {
      undoUpdate[key2] = originalSection[key2];
    }
  } else {
    undoUpdate = operation.payload.update;
  }
  return {
    id: v4(),
    timestamp: Date.now(),
    type: "update_section",
    sectionId,
    operation,
    user,
    ai,
    undoOperation: {
      type: "update_section",
      payload: { id: sectionId, update: undoUpdate }
    }
  };
}
function createDeleteSectionChange(operation, user, sectionId, section, pageId, ai) {
  return {
    id: v4(),
    timestamp: Date.now(),
    type: "delete_section",
    sectionId,
    operation,
    user,
    ai,
    undoOperation: { type: "add_section", payload: { pageId, section } }
  };
}
function initYDocSection(sectionInput) {
  switch (sectionInput.type) {
    case "Microsite::MarkdownSection":
      return { ...sectionInput };
    case "Microsite::SponsorshipSection":
      return { ...sectionInput };
    default:
      return { ...sectionInput };
  }
}
const ydocMicrositeReducer = (state, action) => {
  switch (action.type) {
    case "select_page":
    case "select_section":
    case "select_tab":
    case "show_rebase_modal":
    case "hide_rebase_modal":
      return {
        ...state,
        editorState: editorUIStateReducer(state.editorState, action)
      };
    case "create_page": {
      const page = initEntity({
        title: action.payload.page.title ?? "New Page",
        ...action.payload.page,
        sort: getMaxPagesSort(state.ydoc) + 1
      });
      const addPageOperation = {
        type: "add_page",
        payload: { page }
      };
      ydocMicrositeOperationsReducer(state.ydoc, addPageOperation);
      const addedPage = pageFromYDocPage(state.ydoc, page);
      const addPageChange = createAddPageChange(addPageOperation, action.user);
      ydocMicrositeHistoryReducer(state.ydoc, addPageChange);
      const editorState = editorUIStateReducer(state.editorState, {
        type: "select_page",
        payload: { page: addedPage }
      });
      return {
        ydoc: state.ydoc,
        editorState
      };
    }
    case "update_page": {
      const originalPage = getPage(state.ydoc, action.payload.id);
      ydocMicrositeOperationsReducer(state.ydoc, action);
      const updatePageChange = createUpdatePageChange(
        action,
        action.user,
        String(action.payload.id),
        originalPage
      );
      ydocMicrositeHistoryReducer(state.ydoc, updatePageChange);
      return {
        ydoc: state.ydoc,
        editorState: state.editorState
      };
    }
    case "delete_page": {
      const originalPage = getPage(state.ydoc, action.payload.id);
      ydocMicrositeOperationsReducer(state.ydoc, action);
      const deletePageChange = createDeletePageChange(
        action,
        action.user,
        String(action.payload.id),
        originalPage
      );
      ydocMicrositeHistoryReducer(state.ydoc, deletePageChange);
      return {
        ydoc: state.ydoc,
        editorState: state.editorState
      };
    }
    case "create_section": {
      const { pageId, section: sectionInput } = action.payload;
      const baseSection = {
        id: "id" in sectionInput && sectionInput.id || v4(),
        sort: getMaxSectionSort(state.ydoc, pageId) + 1,
        title: sectionInput.title ?? "Untitled Section",
        pageId: sectionInput.pageId ?? pageId
      };
      let sectionWithId;
      if (sectionInput.type === "Microsite::MarkdownSection") {
        sectionWithId = {
          ...baseSection,
          ...sectionInput,
          type: "Microsite::MarkdownSection"
        };
      } else {
        sectionWithId = {
          ...baseSection,
          ...sectionInput,
          type: "Microsite::Section"
        };
      }
      const section = initYDocSection(sectionWithId);
      const addSectionOperation = {
        type: "add_section",
        payload: { pageId, section }
      };
      ydocMicrositeOperationsReducer(state.ydoc, addSectionOperation);
      const addSectionChange = createAddSectionChange(addSectionOperation, action.user);
      ydocMicrositeHistoryReducer(state.ydoc, addSectionChange);
      const editorState = editorUIStateReducer(state.editorState, {
        type: "select_section",
        payload: { section }
      });
      return {
        ydoc: state.ydoc,
        editorState
      };
    }
    case "create_sponsor_section": {
      const { pageId, section: sectionInput } = action.payload;
      const baseSection = {
        id: "id" in sectionInput && sectionInput.id || v4(),
        sort: getMaxSectionSort(state.ydoc, pageId) + 1,
        title: sectionInput.title ?? "Untitled Sponsor Section",
        pageId
      };
      const sectionWithId = {
        ...baseSection,
        ...sectionInput,
        type: "Microsite::SponsorshipSection"
      };
      const section = initYDocSection(sectionWithId);
      const addSectionOperation = {
        type: "add_section",
        payload: { pageId, section }
      };
      ydocMicrositeOperationsReducer(state.ydoc, addSectionOperation);
      const addSectionChange = createAddSectionChange(addSectionOperation, action.user);
      ydocMicrositeHistoryReducer(state.ydoc, addSectionChange);
      const editorState = editorUIStateReducer(state.editorState, {
        type: "select_section",
        payload: { section }
      });
      return {
        ydoc: state.ydoc,
        editorState
      };
    }
    case "update_section": {
      const originalSection = getSection(state.ydoc, action.payload.id);
      ydocMicrositeOperationsReducer(state.ydoc, action);
      const updateSectionChange = createUpdateSectionChange(
        action,
        action.user,
        String(action.payload.id),
        originalSection
      );
      ydocMicrositeHistoryReducer(state.ydoc, updateSectionChange);
      return {
        ydoc: state.ydoc,
        editorState: state.editorState
      };
    }
    case "delete_section": {
      const originalSection = getSection(state.ydoc, action.payload.id);
      ydocMicrositeOperationsReducer(state.ydoc, action);
      const deleteSectionChange = createDeleteSectionChange(
        action,
        action.user,
        String(action.payload.id),
        originalSection,
        String(originalSection.pageId)
      );
      ydocMicrositeHistoryReducer(state.ydoc, deleteSectionChange);
      if (state.editorState.selectedSection === action.payload.id) {
        return {
          ydoc: state.ydoc,
          editorState: {
            ...state.editorState,
            selectedSection: void 0
          }
        };
      }
      return {
        ydoc: state.ydoc,
        editorState: state.editorState
      };
    }
    case "undo_change": {
      const unsavedChanges = state.ydoc.getArray("unsavedChanges");
      const changesArray = unsavedChanges.toArray();
      const idx = changesArray.findIndex(
        (entry2) => entry2.id === action.changeId
      );
      if (idx === -1) {
        throw new Error(`Change or changeset with id ${action.changeId} not found`);
      }
      const entry = changesArray[idx];
      const applyUndo = (change) => {
        if (change.type === "delete_page" && Array.isArray(change.includedChanges) && change.includedChanges.length > 0) {
          for (let i = change.includedChanges.length - 1; i >= 0; i--) {
            applyUndo(change.includedChanges[i]);
          }
        }
        if ("undoOperation" in change && change.undoOperation && typeof change.undoOperation === "object" && Object.keys(change.undoOperation).length > 0) {
          if ((change.type === "update_page" || change.type === "update_section") && change.undoOperation.type === change.type) {
            ydocMicrositeOperationsReducer(state.ydoc, change.undoOperation);
          } else if ((change.type === "delete_page" || change.type === "delete_section") && (change.undoOperation.type === "add_page" || change.undoOperation.type === "add_section")) {
            ydocMicrositeOperationsReducer(state.ydoc, change.undoOperation);
          } else if ((change.type === "add_page" || change.type === "add_section") && (change.undoOperation.type === "delete_page" || change.undoOperation.type === "delete_section")) {
            ydocMicrositeOperationsReducer(state.ydoc, change.undoOperation);
          }
        }
      };
      applyUndo(entry);
      unsavedChanges.delete(idx, 1);
      return {
        ydoc: state.ydoc,
        editorState: state.editorState
      };
    }
    // Basically a no-op but we need to send an action to trigger the react
    // rendering cycle after the ydoc is updated from the server.
    case "update_ydoc": {
      ydocMicrositeOperationsReducer(state.ydoc, { type: "de_dupe" });
      return {
        ...state,
        ydoc: action.payload.ydoc
      };
    }
  }
};
const initializeState = (state) => {
  if (state.editorState.selectedPage) {
    return state;
  }
  const pages = getPages(state.ydoc);
  console.log("Initializing state with pages", pages);
  if (pages.length === 0) {
    return state;
  } else {
    return {
      ...state,
      editorState: {
        ...state.editorState,
        selectedPage: pages[0].id
      }
    };
  }
};
const MicrositeChangeHistoryContext = createContext(
  void 0
);
const MicrositeChangeHistoryProvider = ({
  changeHistory,
  children
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(MicrositeChangeHistoryContext.Provider, { value: { changeHistory }, children });
const useMicrositeChangeHistory = () => useContext(MicrositeChangeHistoryContext);
const MicrositeChangeHistoryIndicator = ({
  changes
}) => {
  if (changes.length === 0) {
    return null;
  }
  const editors = uniqueChangeUsers(changes);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: editors.map((user) => /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("b", { style: { color: user.color }, children: user.initials }) }, user.id)) });
};
const MicrositeChangeHistoryContainer = ({
  item,
  children
}) => {
  const context = useMicrositeChangeHistory();
  if (context === void 0) {
    return children;
  }
  const { changeHistory } = context;
  const unsavedItemChanges = changeHistory.unsavedChanges.filter((change) => {
    if (change.type === "add_page" || change.type === "update_page" || change.type === "delete_page") {
      return change.pageId === item.id;
    }
    if (change.type === "add_section" || change.type === "update_section" || change.type === "delete_section") {
      return change.sectionId === item.id;
    }
    return false;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    unsavedItemChanges.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(MicrositeChangeHistoryIndicator, { changes: unsavedItemChanges }),
    children
  ] });
};
const PagesMenu = ({
  pages,
  onSelectPage,
  onAddPage,
  onUpdatePage
}) => {
  const sortedPages = getSortedItems(pages);
  const handleDragEnd = (result) => {
    console.log("drag end", result);
    if (result.destination) {
      const fromIndex = result.source.index;
      const toIndex = result.destination.index;
      const page = sortedPages[fromIndex];
      const newSort = getNewSort(sortedPages, fromIndex, toIndex);
      console.log("got new sort", newSort);
      onUpdatePage(page.id, { sort: newSort });
    }
  };
  const handleAddPage = (e) => {
    e.preventDefault();
    onAddPage({});
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { className: "t-pages-menu", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(DragDropContext$1, { onDragEnd: handleDragEnd, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectedDroppable$1, { droppableId: "pagesMenu", children: (provided) => /* @__PURE__ */ jsxRuntimeExports.jsxs(List$1, { ref: provided.innerRef, children: [
      sortedPages.map((page, index2) => {
        const pageId = page.id.toString();
        const label = page.title || humanizeString(pageId);
        return /* @__PURE__ */ jsxRuntimeExports.jsx(PublicDraggable, { draggableId: pageId, index: index2, children: (provided2) => /* @__PURE__ */ jsxRuntimeExports.jsx(MicrositeChangeHistoryContainer, { item: { id: pageId }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          SidebarItem,
          {
            ref: provided2.innerRef,
            ...provided2.draggableProps,
            ...provided2.dragHandleProps,
            onClick: () => onSelectPage(page),
            className: "t-page-item",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Link$2,
              {
                sx: { cursor: "inherit" },
                _hover: {
                  textDecoration: "none",
                  color: "inherit",
                  display: "block"
                },
                onClick: () => onSelectPage(page),
                children: label
              }
            )
          }
        ) }) }, pageId);
      }),
      provided.placeholder
    ] }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { py: 5, pr: 5, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        width: "full",
        className: "t-add-page",
        colorScheme: "blue",
        onClick: handleAddPage,
        children: "Add Page"
      }
    ) })
  ] });
};
const InlineImage = ({ file }) => file.url ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: file.url, alt: file.title }) : null;
const Download = ({ file }) => {
  if (!file.url || !file.fileName) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "t-download ui-centered", children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { className: "button ghost", href: file.url, children: file.title || file.fileName }) });
};
const renderMarkdown = (section) => {
  if (section.content !== void 0) {
    return { __html: marked(section.content) };
  }
};
const Section = forwardRef$1(
  ({ section, onSelect, onAddSection, useRichText }, ref2) => {
    var _a3;
    const style3 = {};
    const imageUrl = (_a3 = section.image) == null ? void 0 : _a3.url;
    if (imageUrl) {
      style3.backgroundImage = "url('" + imageUrl + "')";
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        ref: ref2,
        style: style3,
        className: classNames("t-section", "ui-editor-row", {
          "with-bg": imageUrl
        }),
        onClick: () => onSelect(section),
        "data-testid": `section-preview-${section.id}`,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ui-editor-row-inner", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("header", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "t-section-title", children: section.title }) }),
            section.inlineImage && /* @__PURE__ */ jsxRuntimeExports.jsx(InlineImage, { file: section.inlineImage }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                className: "content",
                dangerouslySetInnerHTML: useRichText && isRegularMicrositeSection(section) && section.html !== void 0 && section.html !== null ? { __html: section.html } : renderMarkdown(section)
              }
            ),
            section.download && /* @__PURE__ */ jsxRuntimeExports.jsx(Download, { file: section.download })
          ] }),
          onAddSection && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "ui-insert-section", children: /* @__PURE__ */ jsxRuntimeExports.jsx("button", { className: "t-insert-section", onClick: onAddSection, children: "Insert section below" }) })
        ]
      },
      section.id
    ) });
  }
);
Section.displayName = "Section";
const PageEditor = ({
  page,
  selectedSection,
  useRichText,
  onSelectSection,
  onUpdateSection,
  onAddSection
}) => {
  const selectedSectionRef = useRef(null);
  useEffect(() => {
    var _a3;
    (_a3 = selectedSectionRef == null ? void 0 : selectedSectionRef.current) == null ? void 0 : _a3.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }, [selectedSection == null ? void 0 : selectedSection.id]);
  const sortedSections = getSortedItems(page.sections);
  const handleDragEnd = (result) => {
    if (result.destination) {
      const fromIndex = result.source.index;
      const toIndex = result.destination.index;
      const section = sortedSections[fromIndex];
      const newSort = getNewSort(sortedSections, fromIndex, toIndex);
      onUpdateSection(section.id, { sort: newSort });
    }
  };
  const addSectionHandler = (index2) => {
    if (index2 === page.sections.length - 1) {
      return onAddSection;
    } else {
      return void 0;
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DragDropContext$1, { onDragEnd: handleDragEnd, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "form-panel t-page-editor", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("article", { className: "type-system-serif", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("header", { className: "txl cf", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { className: "t-page-title fl pll", children: [
      "page Editor / ",
      page.title
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectedDroppable$1, { droppableId: "pagesEditor", children: (provided) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ref: provided.innerRef, ...provided.droppableProps, children: [
      page.sections && sortedSections.map((section, index2) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          PublicDraggable,
          {
            draggableId: section.id.toString(),
            index: index2,
            children: (provided2) => /* @__PURE__ */ jsxRuntimeExports.jsx(MicrositeChangeHistoryContainer, { item: { id: section.id.toString() }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                ref: provided2.innerRef,
                ...provided2.draggableProps,
                ...provided2.dragHandleProps,
                children: section.type === SPONSOR_SECTION_TYPE ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                  SponsorSectionContainer,
                  {
                    itemRef: section.id === (selectedSection == null ? void 0 : selectedSection.id) ? selectedSectionRef : null,
                    onSelect: () => onSelectSection(section),
                    onAddSection: addSectionHandler(index2),
                    section
                  }
                ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Section,
                  {
                    ref: section.id === (selectedSection == null ? void 0 : selectedSection.id) ? selectedSectionRef : null,
                    useRichText,
                    onSelect: () => onSelectSection(section),
                    onAddSection: addSectionHandler(index2),
                    section
                  }
                )
              }
            ) })
          },
          section.id
        );
      }),
      provided.placeholder
    ] }) })
  ] }) }) });
};
const getFileName = (file) => {
  if (file instanceof File) {
    return file.name;
  } else if (file) {
    return file.fileName;
  }
};
const getFileTitle = (file) => {
  if (file === void 0 || file instanceof File) return "";
  return file.title || "";
};
const UploadForm = ({
  file,
  fieldName,
  label,
  onChange,
  onTitleChange,
  onRemoveFile
}) => {
  const htmlId = `id_${fieldName}_file`;
  const titleHtmlId = `id_${fieldName}_title`;
  const currentFileName = getFileName(file);
  const handleFileChange = (e) => {
    if (!e.target.files) {
      return;
    }
    onChange(e.target.files[0]);
  };
  const handleRemoveFile = (e) => {
    e.preventDefault();
    onRemoveFile();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "file-editor", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: htmlId, children: label }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("strong", { children: [
        "Current ",
        label,
        ":"
      ] }),
      " ",
      currentFileName,
      file && /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          type: "button",
          onClick: handleRemoveFile,
          className: "t-remove-file danger",
          children: "x"
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        id: htmlId,
        className: "t-upload-file",
        type: "file",
        name: fieldName,
        onChange: handleFileChange
      },
      fieldName
    ),
    onTitleChange !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { htmlFor: titleHtmlId, children: [
        label,
        " title"
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          id: titleHtmlId,
          type: "text",
          name: `${fieldName}_title`,
          value: getFileTitle(file),
          onChange: (e) => onTitleChange(e.target.value)
        }
      )
    ] })
  ] });
};
const MARKDOWN_CHEAT_SHEET = "https://s3.amazonaws.com/helpscout.net/docs/assets/5c53282b042863543ccc71dd/attachments/5d8f545204286364bc8fad59/getregistered%C2%AE-Markdown-Cheatsheet.pdf";
const getSectionHTML = (section) => {
  if (isRegularMicrositeSection(section) && section.html !== void 0 && section.html !== null) {
    return section.html;
  }
  if (section.content !== void 0) {
    return marked(section.content, { async: false });
  }
  return void 0;
};
const SectionEditor = ({
  section,
  useRichText,
  onChange,
  onFileChange,
  onRemoveFile,
  onSave,
  onDelete
}) => {
  const handleInputChange = (e) => {
    onChange({ [e.target.name]: e.target.value });
  };
  const scopedFieldName = (name2) => `section_${section.id}_${name2}`;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "t-section-form field-editor", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("header", { className: "txl", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { className: "t-section-title", children: [
      "Edit Section / ",
      section.title
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "form",
      {
        className: "full",
        encType: "multipart/form-data",
        onSubmit: (e) => e.preventDefault(),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "title", children: "Section title" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "input",
            {
              id: "title",
              type: "text",
              name: "title",
              value: section.title,
              onChange: handleInputChange,
              className: "t-title-input"
            }
          ),
          useRichText ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            TipTapContentEditor,
            {
              content: getSectionHTML(section),
              onChange: (html2) => onChange({ html: html2 })
            },
            `section-${section.id}`
          ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "content", children: "Section content - markdown format is applied" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "textarea",
              {
                className: "full-txt-area",
                style: {
                  marginBottom: 3
                },
                name: "content",
                value: section.content,
                onChange: handleInputChange
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { minHeight: 25 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              "a",
              {
                className: "ar",
                target: "_blank",
                rel: "noreferrer",
                href: MARKDOWN_CHEAT_SHEET,
                children: "markdown guide"
              }
            ) })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            UploadForm,
            {
              file: section.download,
              label: "File Download",
              fieldName: scopedFieldName("download"),
              onChange: (file) => onFileChange("download", file),
              onTitleChange: (title) => onChange({
                download: { ...section.download, title }
              }),
              onRemoveFile: () => onRemoveFile("download")
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            UploadForm,
            {
              file: section.image,
              label: "Background Image",
              fieldName: scopedFieldName("image"),
              onChange: (file) => onFileChange("image", file),
              onRemoveFile: () => onRemoveFile("image")
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            UploadForm,
            {
              file: section.inlineImage,
              label: "Inline Image",
              fieldName: scopedFieldName("inline_image"),
              onChange: (file) => onFileChange("inlineImage", file),
              onTitleChange: (title) => onChange({
                inlineImage: { ...section.inlineImage, title }
              }),
              onRemoveFile: () => onRemoveFile("inlineImage")
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: "Access level" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            AccessFormContainer,
            {
              object: section,
              onChange: ({ access, metadata, trackIds }) => {
                onChange({ access, metadata, trackIds });
              }
            },
            section.id
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "cssClasses", children: "Section CSS Classes" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "input",
            {
              id: "cssClasses",
              type: "text",
              name: "cssClasses",
              value: section.cssClasses,
              onChange: handleInputChange,
              className: "t-css-classes-input"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { justifyContent: "flex-end", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button$1,
              {
                colorScheme: "red",
                size: "sm",
                onClick: onDelete,
                className: "t-delete",
                children: "Delete"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button$1,
              {
                colorScheme: "green",
                size: "sm",
                onClick: onSave,
                className: "t-form-save",
                children: "Save"
              }
            )
          ] })
        ]
      }
    )
  ] }, section.id);
};
const SectionEditorContainer = () => {
  const { ydoc, editorState, dispatch, onSave, onFileUpload } = useMicrosite();
  const { useRichText } = useMicrositeEvent();
  const selectedSection = findSectionFromEditorState(ydoc, editorState);
  if (selectedSection === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "small-caps", children: "Select a section to start editing." });
  }
  if (selectedSection.type === "Microsite::SponsorshipSection") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      SponsorSectionFormContainer,
      {
        section: selectedSection,
        onChange: (section) => dispatch({
          type: "update_section",
          payload: { id: selectedSection.id, update: section }
        }),
        onSave,
        onDelete: () => dispatch({
          type: "delete_section",
          payload: { id: selectedSection.id }
        })
      }
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SectionEditor,
    {
      section: selectedSection,
      useRichText: useRichText && selectedSection.type !== "Microsite::MarkdownSection",
      onChange: (section) => dispatch({
        type: "update_section",
        payload: { id: selectedSection.id, update: section }
      }),
      onFileChange: async (whichFile, file) => {
        const uploadResult = await onFileUpload(file);
        dispatch({
          type: "update_section",
          payload: {
            id: selectedSection.id,
            update: { [whichFile]: uploadResult }
          }
        });
      },
      onSave,
      onDelete: () => dispatch({
        type: "delete_section",
        payload: { id: selectedSection.id }
      }),
      onRemoveFile: (whichFile) => dispatch({
        type: "update_section",
        payload: {
          id: selectedSection.id,
          update: { [whichFile]: void 0 }
        }
      })
    }
  );
};
const AddItemLink = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Link$2, { _hover: { textDecoration: "none" }, ...props });
const SponsorSectionButton = ({
  label = "Sponsor Section",
  description = "Display sponsor information"
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  FieldButton,
  {
    label,
    description,
    Icon: fieldIcons.sponsor
  }
);
const AddSponsorSectionLink = ({
  onClick
}) => {
  const { error: error2, data: sponsorTiers } = useSponsorTiers();
  if (error2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage, { children: "Error loading Sponsor Tiers" });
  }
  if (sponsorTiers === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {});
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    AddItemLink,
    {
      onClick: () => {
        var _a3;
        return onClick({
          title: "New sponsor section",
          type: SPONSOR_SECTION_TYPE,
          styling: DEFAULT_SPONSOR_STYLING,
          sponsorTierId: (_a3 = sponsorTiers[0]) == null ? void 0 : _a3.id
        });
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(SponsorSectionButton, {})
    }
  );
};
const AddPanel = ({
  sponsorshipEnabled = false,
  markdownSectionsEnabled = false,
  onAddPage,
  onAddSection,
  onAddSponsorSection
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { px: 4, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddItemLink,
      {
        onClick: () => onAddSection(),
        className: "t-add-section",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(SectionButton, { description: "Microsite content section" })
      },
      "add-section"
    ),
    markdownSectionsEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddItemLink,
      {
        onClick: () => onAddSection({ type: "Microsite::MarkdownSection" }),
        className: "t-add-markdown-section",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          SectionButton,
          {
            label: "Markdown section",
            description: "Microsite content section (markdown / html)"
          }
        )
      },
      "add-markdown-section"
    ),
    sponsorshipEnabled && /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddSponsorSectionLink,
      {
        onClick: onAddSponsorSection
      },
      "add-sponsor-section"
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AddItemLink, { onClick: onAddPage, className: "t-add-page", children: /* @__PURE__ */ jsxRuntimeExports.jsx(PageButton, {}) })
  ] });
};
const PageForm = ({
  page,
  onChange,
  onSave,
  onDelete
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "field-editor t-page-form", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("header", { className: "txl", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { children: [
      "Edit Page / ",
      page.title
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "form",
      {
        className: "full",
        encType: "multipart/form-data",
        onSubmit: (e) => e.preventDefault(),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "page_title", children: "Page title" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "input",
            {
              id: "page_title",
              className: "t-title-input",
              type: "text",
              name: "title",
              value: page.title,
              onChange: (e) => onChange({ title: e.target.value })
            }
          ),
          !pageHasSections(page) && /* @__PURE__ */ jsxRuntimeExports.jsx(
            ExternalLinkForm,
            {
              linkedItem: page,
              onChange: (href) => onChange({ href })
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("label", { children: "Access level" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(AccessFormContainer, { object: page, onChange }, page.id),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { justifyContent: "flex-end", children: [
            onDelete !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button$1,
              {
                colorScheme: "red",
                size: "sm",
                onClick: onDelete,
                className: "t-delete",
                children: "Delete"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button$1,
              {
                colorScheme: "green",
                size: "sm",
                onClick: onSave,
                className: "t-form-save",
                children: "Save"
              }
            )
          ] })
        ]
      }
    )
  ] });
};
const PageFormContainer = () => {
  const { pages, editorState, dispatch, onSave } = useMicrosite();
  const selectedPage = pages.find(
    (page) => page.id === editorState.selectedPage
  );
  if (selectedPage === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "small-caps", children: "Select a page to start editing." });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    PageForm,
    {
      page: selectedPage,
      onChange: (update2) => dispatch({
        type: "update_page",
        payload: { id: selectedPage.id, update: update2 }
      }),
      onSave,
      onDelete: () => dispatch({ type: "delete_page", payload: { id: selectedPage.id } })
    }
  );
};
const MicrositeChangeDescription = ({ change }) => {
  var _a3;
  switch (change.type) {
    case "save_microsite":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Saved ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: "the microsite" })
      ] });
    case "reset_microsite":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Reset ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: "the microsite" })
      ] });
    case "add_page":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Added page ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: change.page.title || "Untitled Page" })
      ] });
    case "update_page":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Updated page ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: change.pageId })
      ] });
    case "delete_page":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Deleted page ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: change.pageId })
      ] });
    case "add_section":
      const sectionTitle = (_a3 = change.section) == null ? void 0 : _a3.title;
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Added section ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: sectionTitle || "Untitled Section" })
      ] });
    case "update_section":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Updated section ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: change.sectionId })
      ] });
    case "delete_section":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Deleted section ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: change.sectionId })
      ] });
    case "batch":
      const changeset = change;
      const addCount = changeset.includedChanges.filter((c2) => c2.type === "add_page" || c2.type === "add_section").length;
      const updateCount = changeset.includedChanges.filter((c2) => c2.type === "update_page" || c2.type === "update_section").length;
      const deleteCount = changeset.includedChanges.filter((c2) => c2.type === "delete_page" || c2.type === "delete_section").length;
      const actions = [];
      if (addCount > 0) actions.push(`${addCount} added`);
      if (updateCount > 0) actions.push(`${updateCount} updated`);
      if (deleteCount > 0) actions.push(`${deleteCount} deleted`);
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: "Batch operation" }),
        " (",
        actions.join(", "),
        ")"
      ] });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Made changes to ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: "the microsite" })
      ] });
  }
};
const MicrositeChangeHistoryList = ({
  changes,
  enableUndo = true
}) => {
  const { dispatch } = useMicrosite();
  const [expandedChangesets, setExpandedChangesets] = useState(/* @__PURE__ */ new Set());
  const handleUndo = (changeId) => {
    dispatch({ type: "undo_change", changeId });
  };
  const toggleChangeset = (changesetId) => {
    const newExpanded = new Set(expandedChangesets);
    if (newExpanded.has(changesetId)) {
      newExpanded.delete(changesetId);
    } else {
      newExpanded.add(changesetId);
    }
    setExpandedChangesets(newExpanded);
  };
  const firstUndoableIndex = changes.findIndex(
    (c2) => c2.type !== "save_microsite" && c2.type !== "reset_microsite"
  );
  const firstUndoableId = firstUndoableIndex !== -1 ? changes[firstUndoableIndex].id : null;
  const renderChange = (change, depth = 0, isNested = false) => {
    const isAI = Boolean(change.ai);
    const isUndoable = enableUndo && !isNested && change.id === firstUndoableId && change.type !== "save_microsite" && change.type !== "reset_microsite";
    if (change.type === "batch") {
      const changeset = change;
      const isExpanded = expandedChangesets.has(changeset.id);
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { border: "1px", borderColor: "blue.200", borderRadius: "md", p: 3, mb: 2, ml: depth * 24, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { justify: "space-between", align: "center", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { flex: 1, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              IconButton$1,
              {
                size: "sm",
                variant: "ghost",
                icon: isExpanded ? /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronDownIcon$1, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronRightIcon$1, {}),
                onClick: () => toggleChangeset(changeset.id),
                "aria-label": isExpanded ? "Collapse" : "Expand"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { fontWeight: "bold", color: change.user.color, children: change.user.name }),
            isAI && /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { colorScheme: "green", ml: 2, children: "AI" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(MicrositeChangeDescription, { change }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { fontSize: "sm", color: "gray.500", children: [
              "at ",
              new Date(change.timestamp).toLocaleTimeString()
            ] })
          ] }),
          isUndoable && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              size: "sm",
              colorScheme: "blue",
              variant: "outline",
              onClick: () => handleUndo(change.id),
              children: "Undo"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Collapse, { in: isExpanded, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { ml: 8, mt: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "start", spacing: 1, children: changeset.includedChanges.map((nestedChange, idx) => /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pl: 2, borderLeft: "2px", borderColor: "blue.300", children: renderChange(nestedChange, depth + 1, true) }, nestedChange.id || idx)) }) }) })
      ] }, change.id);
    }
    if (change.type === "delete_page" && "includedChanges" in change && Array.isArray(change.includedChanges) && change.includedChanges.length > 0) {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { border: "1px", borderColor: "red.200", borderRadius: "md", p: 3, mb: 2, ml: depth * 24, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { justify: "space-between", align: "center", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { fontWeight: "bold", color: change.user.color, children: change.user.name }),
            isAI && /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { colorScheme: "green", ml: 2, children: "AI" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(MicrositeChangeDescription, { change }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { fontSize: "sm", color: "gray.500", children: [
              "at ",
              new Date(change.timestamp).toLocaleTimeString()
            ] })
          ] }),
          isUndoable && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              size: "sm",
              colorScheme: "blue",
              variant: "outline",
              onClick: () => handleUndo(change.id),
              children: "Undo"
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { ml: 8, mt: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "start", spacing: 1, children: change.includedChanges.map((nestedChange, idx) => /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pl: 2, borderLeft: "2px", borderColor: "red.300", children: renderChange(nestedChange, depth + 1, true) }, nestedChange.id || idx)) }) })
      ] }, change.id);
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { border: "1px", borderColor: "gray.200", borderRadius: "md", p: 3, mb: 2, ml: depth * 24, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { justify: "space-between", align: "center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { fontWeight: "bold", color: change.user.color, children: change.user.name }),
        isAI && /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { colorScheme: "green", ml: 2, children: "AI" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(MicrositeChangeDescription, { change }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { fontSize: "sm", color: "gray.500", children: [
          "at ",
          new Date(change.timestamp).toLocaleTimeString()
        ] })
      ] }),
      isUndoable && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          size: "sm",
          colorScheme: "blue",
          variant: "outline",
          onClick: () => handleUndo(change.id),
          children: "Undo"
        }
      )
    ] }) }, change.id);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "stretch", spacing: 0, children: changes.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { color: "gray.500", textAlign: "center", py: 4, children: "No changes to display" }) : changes.map((change) => renderChange(change)) });
};
const MicrositeChangeHistoryListContainer = () => {
  const context = useMicrositeChangeHistory();
  if (context === void 0) {
    return null;
  }
  const { changeHistory } = context;
  const hasUnsaved = changeHistory.unsavedChanges.length > 0;
  const hasPrevious = changeHistory.previousChanges.length > 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    hasUnsaved && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: "Unsaved changes" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(MicrositeChangeHistoryList, { changes: changeHistory.unsavedChanges, enableUndo: true })
    ] }),
    hasPrevious && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: "Previous changes" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(MicrositeChangeHistoryList, { changes: changeHistory.previousChanges, enableUndo: !hasUnsaved })
    ] }),
    !hasUnsaved && !hasPrevious && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { textAlign: "center", color: "gray" }, children: "No changes to display" })
  ] });
};
const TabOptions = {
  0: "add",
  1: "edit",
  2: "page",
  3: "history"
};
const getSelectedIndex = (editorState) => {
  switch (editorState.selectedTab) {
    case "edit":
      return 1;
    case "page":
      return 2;
    case "history":
      return 3;
    default:
      return 0;
  }
};
const MicrositeRightPanel = () => {
  const { editorState, dispatch } = useMicrosite();
  const { sponsorshipEnabled, markdownSectionsEnabled } = useMicrositeEvent();
  const tabIndex = getSelectedIndex(editorState);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Tabs,
    {
      isFitted: true,
      index: tabIndex,
      onChange: (index2) => dispatch({ type: "select_tab", payload: { tab: TabOptions[index2] } }),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(TabList, { borderBottomWidth: 1, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(RightPanelTab, { className: "t-add-tab", children: "Add" }, "add"),
          /* @__PURE__ */ jsxRuntimeExports.jsx(RightPanelTab, { className: "t-edit-tab", children: "Edit" }, "edit"),
          /* @__PURE__ */ jsxRuntimeExports.jsx(RightPanelTab, { className: "t-page-tab", children: "Page" }, "page"),
          /* @__PURE__ */ jsxRuntimeExports.jsx(RightPanelTab, { className: "t-history-tab", children: "History" }, "history")
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(TabPanels, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(TabPanel, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            AddPanel,
            {
              sponsorshipEnabled,
              markdownSectionsEnabled,
              onAddPage: () => dispatch({
                type: "create_page",
                payload: { page: { title: "New Page" } }
              }),
              onAddSection: (sectionInput = {}) => {
                if (editorState.selectedPage === void 0) {
                  return;
                }
                dispatch({
                  type: "create_section",
                  payload: {
                    pageId: editorState.selectedPage,
                    section: { title: "New Section", ...sectionInput }
                  }
                });
              },
              onAddSponsorSection: (sectionInput) => {
                if (editorState.selectedPage === void 0) {
                  return;
                }
                dispatch({
                  type: "create_sponsor_section",
                  payload: {
                    pageId: editorState.selectedPage,
                    section: { title: "New Sponsor Section", ...sectionInput }
                  }
                });
              }
            }
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(TabPanel, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SectionEditorContainer, {}) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(TabPanel, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(PageFormContainer, {}) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(TabPanel, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(MicrositeChangeHistoryListContainer, {}) })
        ] })
      ]
    }
  );
};
const CollaborativeMicrositeEditor = ({
  ydoc: initialYdoc,
  currentUser,
  onSave,
  onReset,
  onFileUpload,
  eventPaths,
  tracks,
  sponsorshipEnabled,
  markdownSectionsEnabled,
  useRichText
}) => {
  const [{ ydoc, editorState }, dispatchWithoutUser] = useReducer(
    ydocMicrositeReducer,
    {
      ydoc: initialYdoc,
      editorState: {}
    },
    initializeState
  );
  const [changeHistory, setChangeHistory] = useState(
    getChangeHistory(ydoc)
  );
  const [, historyDispatch] = useReducer(ydocMicrositeHistoryReducer, ydoc);
  const dispatch = (action) => dispatchWithoutUser({ ...action, user: currentUser });
  ydoc.on("update", () => {
    dispatch({ type: "update_ydoc", payload: { ydoc } });
    setChangeHistory(getChangeHistory(ydoc));
  });
  const pages = getPagesWithSections(ydoc);
  useEffect(() => {
    if (pages.length > 0 && editorState.selectedPage === void 0) {
      dispatch({ type: "select_page", payload: { page: pages[0] } });
    }
  }, [pages]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    MicrositeProvider,
    {
      ydoc,
      pages,
      editorState,
      dispatch,
      onSave,
      onFileUpload,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(MicrositeChangeHistoryProvider, { changeHistory, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        MicrositeEventProvider,
        {
          eventPaths,
          tracks,
          sponsorshipEnabled,
          markdownSectionsEnabled,
          useRichText,
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs(EditorLayout, { className: "t-microsite-editor", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(EditorHeader$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              StateBarV2$1,
              {
                onSave: () => {
                  historyDispatch({
                    id: uuid(),
                    type: "save_microsite",
                    operation: { type: "save_microsite" },
                    user: currentUser,
                    timestamp: (/* @__PURE__ */ new Date()).getTime()
                  });
                  onSave();
                },
                onReset: () => {
                  historyDispatch({
                    id: uuid(),
                    type: "reset_microsite",
                    operation: { type: "reset_microsite" },
                    user: currentUser,
                    timestamp: (/* @__PURE__ */ new Date()).getTime()
                  });
                  onReset();
                },
                confirmReset: true,
                dirty: ydocIsDirty(ydoc)
              }
            ) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              EditorSidebar,
              {
                overflow: "auto",
                background: "grayAlpha.800",
                color: "white",
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  PagesMenu,
                  {
                    pages,
                    onSelectPage: (page) => dispatch({ type: "select_page", payload: { page } }),
                    onAddPage: (page) => dispatch({ type: "create_page", payload: { page } }),
                    onUpdatePage: (id, update2) => dispatch({ type: "update_page", payload: { id, update: update2 } })
                  }
                )
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(EditorMain, { overflow: "auto", px: 8, pb: 16, children: editorState.selectedPage !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
              PageEditor,
              {
                page: getPageWithSections(ydoc, editorState.selectedPage),
                useRichText,
                onSelectSection: (section) => {
                  dispatch({ type: "select_section", payload: { section } });
                },
                onUpdateSection: (id, update2) => dispatch({ type: "update_section", payload: { id, update: update2 } }),
                onAddSection: () => {
                  if (editorState.selectedPage === void 0) {
                    return;
                  }
                  dispatch({
                    type: "create_section",
                    payload: { pageId: editorState.selectedPage, section: {} }
                  });
                }
              }
            ) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(EditorRightPanel, { overflow: "auto", children: /* @__PURE__ */ jsxRuntimeExports.jsx(MicrositeRightPanel, {}) })
          ] })
        }
      ) })
    }
  );
};
function addedKeys(a2, b2) {
  const keysA = new Set(Object.keys(a2));
  const keysB = new Set(Object.keys(b2));
  return Array.from(keysA).filter((key2) => !keysB.has(key2));
}
function getChangedFields$1(original, updated) {
  const changes = {};
  for (const key2 in updated) {
    if (updated[key2] !== original[key2]) {
      changes[key2] = updated[key2];
    }
  }
  const removed = addedKeys(original, updated);
  removed.forEach((key2) => {
    changes[key2] = void 0;
  });
  return changes;
}
function syncMicrositeYDocs(source, target) {
  target.transact(() => {
    const sourcePages = getPages(source);
    const targetPages = getPages(target);
    sourcePages.forEach((sourcePage) => {
      const existingPage = targetPages.find(
        (page) => page.id === sourcePage.id
      );
      if (existingPage) {
        const changes = getChangedFields$1(existingPage, sourcePage);
        if (Object.keys(changes).length > 0) {
          const action = {
            type: "update_page",
            payload: { id: sourcePage.id, update: changes }
          };
          ydocMicrositeOperationsReducer(target, action);
        }
      } else {
        const action = {
          type: "add_page",
          payload: { page: sourcePage }
        };
        ydocMicrositeOperationsReducer(target, action);
      }
    });
    targetPages.forEach((targetPage) => {
      if (!sourcePages.some((sourcePage) => sourcePage.id === targetPage.id)) {
        const action = {
          type: "delete_page",
          payload: { id: targetPage.id }
        };
        ydocMicrositeOperationsReducer(target, action);
      }
    });
    const sourceSections = getSections(source);
    const targetSections = getSections(target);
    sourceSections.forEach((sourceSection) => {
      const existingSection = targetSections.find(
        (section) => section.id === sourceSection.id
      );
      if (existingSection) {
        const changes = getChangedFields$1(existingSection, sourceSection);
        if (Object.keys(changes).length > 0) {
          const action = {
            type: "update_section",
            payload: { id: sourceSection.id, update: changes }
          };
          ydocMicrositeOperationsReducer(target, action);
        }
      } else {
        const action = {
          type: "add_section",
          payload: { section: sourceSection, pageId: sourceSection.pageId }
        };
        ydocMicrositeOperationsReducer(target, action);
      }
    });
    targetSections.forEach((targetSection) => {
      const sourceSection = sourceSections.find(
        (section) => section.id === targetSection.id
      );
      if (!sourceSection) {
        const action = {
          type: "delete_section",
          payload: { id: targetSection.id }
        };
        ydocMicrositeOperationsReducer(target, action);
      }
    });
  });
  return target;
}
function getChangedFields(original, updated) {
  const changes = {};
  for (const key2 in updated) {
    if (updated[key2] !== original[key2]) {
      changes[key2] = updated[key2];
    }
  }
  return changes;
}
function syncFormYDocs(source, target) {
  target.transact(() => {
    const sourceItems = getItems(source);
    const targetItems = getItems(target);
    sourceItems.forEach((sourceItem) => {
      const existingItem = targetItems.find(
        (item) => item.name === sourceItem.name
      );
      if (existingItem) {
        const changes = getChangedFields(existingItem, sourceItem);
        if (Object.keys(changes).length > 0) {
          const action = {
            type: "update_item",
            id: sourceItem.name,
            payload: changes
          };
          ydocFormOperationsReducer(target, action);
        }
      } else {
        const action = {
          type: "add_item",
          payload: sourceItem
        };
        ydocFormOperationsReducer(target, action);
      }
    });
    targetItems.forEach((targetItem) => {
      if (!sourceItems.some((sourceItem) => sourceItem.name === targetItem.name)) {
        const action = {
          type: "delete_item",
          id: targetItem.name
        };
        ydocFormOperationsReducer(target, action);
      }
    });
  });
  return target;
}
const colors = {
  red: {
    500: "#DB4F61"
  },
  green: {
    500: "#1e8449"
  },
  blue: {
    500: "#2D9CDB"
  },
  gray: {
    50: "#F7F7F7",
    500: "#999999",
    700: "#333333"
  },
  redAlpha: {
    400: "rgba(214, 44, 65, 0.9)"
  },
  blueAlpha: {
    400: "rgba(95, 137, 187, 0.9)",
    500: "rgba(71, 125, 202, 0.5)"
  },
  grayAlpha: {
    500: "rgba(51,51,51,0.5)",
    800: "rgba(40, 45, 49, 0.8)"
  },
  blackAlpha: {
    30: "rgba(0, 0, 0, 0.03)"
  },
  features: {
    sessions: "#8040bf",
    accommodation: "dark-blue"
  }
};
const radii = {
  md: "0.1875rem"
};
const styles = {
  global: {
    button: {
      color: "white",
      textTransform: "uppercase"
    },
    ".dynamic-editor .form-field-list div.t-field": {
      paddingRight: "3em"
    },
    ".dynamic-editor .form-field-list div.t-field.session_booking": {
      paddingRight: "0.75em"
    }
  }
};
const typography = {
  fonts: {
    body: '"Open Sans", sans-serif',
    heading: '"Open Sans", sans-serif'
  },
  fontSizes: {
    xs: "8px",
    sm: "12px",
    md: "14px",
    lg: "20px"
  },
  textStyles: {
    label: {
      fontSize: "12px",
      textTransform: "uppercase",
      fontWeight: "bold",
      letterSpacing: "0.5px"
    },
    formPageTitle: {
      textTransform: "uppercase",
      fontSize: "2.4rem",
      fontWeight: 500
    },
    editorH2: {
      textTransform: "uppercase",
      fontSize: "1.2rem"
    },
    editorItemLabel: {
      textTransform: "uppercase",
      fontSize: "12px",
      fontWeight: 800,
      letterSpacing: "0.03125rem"
    }
  }
};
const baseStyle$1 = {
  textTransform: "uppercase",
  fontWeight: "extrabold",
  color: "inherit"
};
const sizes = {
  md: {
    px: "14px"
  }
};
const variantGrSolid = (props) => {
  const { colorScheme: c2 } = props;
  const style3 = {
    borderRadius: "3px",
    color: "white",
    backgroundColor: `${c2}.500`,
    _hover: {
      backgroundColor: `${c2}.500`,
      opacity: 0.9
    }
  };
  if (c2 === "gray") {
    return {
      ...style3,
      bgGradient: "linear(#999, #887272)"
    };
  } else {
    return style3;
  }
};
const variants = {
  grSolid: variantGrSolid
};
const buttonStyle = { baseStyle: baseStyle$1, sizes, variants };
const baseStyle = {
  textTransform: "uppercase",
  fontWeight: 500,
  letterSpacing: "2px"
};
const headingStyle = {
  baseStyle
};
const baseStyleHeader = {
  px: 6,
  py: 4,
  fontSize: "lg",
  fontWeight: 400,
  color: "grayAlpha.500",
  textTransform: "uppercase"
};
const modal = {
  baseStyle: {
    header: baseStyleHeader,
    closeButton: {
      color: "gray.300"
    }
  }
};
const gregAdminTheme = extendTheme({
  colors,
  radii,
  styles,
  ...typography,
  components: { Button: buttonStyle, Heading: headingStyle, Modal: modal }
});
const customTheme = deepmerge(theme, {
  colorSchemes: {
    light: {
      colors: {
        bg: {
          primary: "#FFFFFF",
          secondary: "#FAFBFC",
          default: "#FFFFFF",
          "blue-light": "rgba(241, 248, 255, 1)",
          accent: {
            subtle: "rgba(221, 244, 255, 1)"
          }
        },
        border: {
          accent: {
            muted: "rgba(84, 174, 255, 0.4)"
          }
        }
      }
    },
    dark: {}
  }
});
const GregPrimerTheme = ({
  children
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: customTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseStyles, { children }) });
const BlankCell = ({ className }) => {
  const classes2 = classNames("blank-cell", className);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: classes2 });
};
function ActionButton(props) {
  const {
    className = "button common",
    href,
    text: text2 = "Action",
    ...attrs
  } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("a", { ...attrs, className, href, children: text2 });
}
function DeleteButton$1(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionButton, { ...props });
}
DeleteButton$1.defaultProps = {
  className: "button danger",
  "data-method": "delete",
  "data-confirm": "Beware, this will permanently delete",
  "data-type": "error",
  rel: "nofollow",
  text: "Delete"
};
function DeleteButton(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionButton, { ...props });
}
DeleteButton.defaultProps = {
  className: "button",
  "data-method": "put",
  rel: "nofollow",
  text: "Update"
};
function ButtonGroup(props) {
  const { buttons, ...rest } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ...rest, children: buttons.map(function(button) {
    const { type, ...props2 } = button;
    if (type === "delete") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DeleteButton$1, { ...props2 });
    } else if (type === "update") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DeleteButton, { ...props2 });
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionButton, { ...props2 });
    }
  }) });
}
ButtonGroup.defaultProps = {
  className: "button-group"
};
function ButtonCell$1({ className, ...rest }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroup, { ...rest }) });
}
const LinkCell$1 = ({ href, text: text2, className, disableTurbolinks = false }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className, children: disableTurbolinks ? /* @__PURE__ */ jsxRuntimeExports.jsx("a", { "data-turbolinks": "false", href, children: text2 }) : /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href, children: text2 }) });
};
const ValueCell = ({ value, className }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className, children: value });
};
const displayValue = ({ item, column: column2 }) => {
  if (column2.boolean) {
    return item[column2.key] ? column2.trueValue : column2.falseValue;
  } else {
    const value = item[column2.key];
    if (value && value.displayValue !== void 0) {
      return value.displayValue;
    } else {
      return value;
    }
  }
};
const logicalValue = ({ item, column: column2 }) => {
  const value = item[column2.key];
  if (value && value.text) {
    return value.text;
  } else if (value && value.rawValue !== void 0) {
    return value.rawValue;
  } else {
    return value;
  }
};
const choiceSelected = ({ item, column: column2, choice }) => {
  const value = logicalValue({ item, column: column2 });
  if (column2.isMultiChoice) {
    return Array.isArray(value) && value.includes(choice.value);
  } else {
    return value === choice.value;
  }
};
const filterValue = ({ item, column: column2 }) => {
  return [displayValue({ item, column: column2 }), logicalValue({ item, column: column2 })].join(
    "-"
  );
};
const NumberCell = ({ value, className }) => /* @__PURE__ */ jsxRuntimeExports.jsx("td", { align: "right", className, children: value });
const SelectedRowContext = createContext(void 0);
const SelectedRowProvider = ({
  children,
  ...props
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(SelectedRowContext.Provider, { value: props, children });
const CheckboxSelectionCell$1 = ({
  row,
  className
}) => {
  const { isSelectedRow, selectRow, deselectRow } = useContext(SelectedRowContext);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "input",
    {
      type: "checkbox",
      checked: isSelectedRow(row),
      onChange: (e) => e.target.checked ? selectRow(row) : deselectRow(row)
    }
  ) });
};
const RowEditContext = React__default.createContext(
  void 0
);
const useRowEditContext = () => {
  return React__default.useContext(RowEditContext);
};
const RowEditModal$1 = ({
  row,
  column: column2,
  onClose
}) => {
  const { RowEditor, reloadGridResults } = useRowEditContext();
  if (RowEditor === void 0) {
    console.error(
      "A RowEditor component must be provided to PaginatedGrid to use row edit columns"
    );
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: true, onClose, returnFocusOnClose: false, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      RowEditor,
      {
        row,
        column: column2,
        onSave: () => {
          reloadGridResults();
          onClose();
        },
        onCancel: onClose
      }
    )
  ] });
};
const RowEditCell$1 = ({
  row,
  column: column2,
  className
}) => {
  const [open, setOpen] = useState(false);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("td", { className, children: [
    open && /* @__PURE__ */ jsxRuntimeExports.jsx(
      RowEditModal$1,
      {
        row,
        column: column2,
        onClose: () => setOpen(false)
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: () => setOpen(true), children: "Edit" })
  ] });
};
const isLinkCell$1 = (cell) => typeof cell === "object" && cell !== null && "href" in cell;
const isButtonCell$1 = (cell) => typeof cell === "object" && cell !== null && "buttons" in cell;
const CellRenderer$1 = ({ row, column: column2 }) => {
  const rawValue = row[column2.key];
  const value = displayValue({ item: row, column: column2 });
  const className = column2.cellClass;
  if (column2.type === "row_edit") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(RowEditCell$1, { row, column: column2, className });
  }
  if (column2.type === "checkbox") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxSelectionCell$1, { row, className });
  }
  if (column2.actionButtons && isButtonCell$1(rawValue)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonCell$1, { ...rawValue, className });
  }
  if (value === null || value === void 0 || value === "") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(BlankCell, { className });
  }
  if (column2.type === "integer" || column2.type === "currency") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(NumberCell, { value, className });
  }
  if (isLinkCell$1(rawValue)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(LinkCell$1, { ...rawValue, className });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ValueCell, { value, className });
};
function ButtonCell({ buttons, gap = "condensed", ...rest }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { direction: "horizontal", gap, ...rest, children: buttons.map(({ key: key2, text: text2, onClick, href, "data-target": dataTarget, variant: variant3 = "default" }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    ButtonComponent,
    {
      onClick,
      href,
      as: href ? "a" : "button",
      "data-target": dataTarget,
      variant: variant3,
      size: "small",
      children: text2
    },
    key2
  )) });
}
const LinkCell = ({ href, text: text2, disableTurbolinks = false }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    LinkButton,
    {
      href,
      leadingVisual: LinkExternalIcon,
      variant: "invisible",
      size: "small",
      "data-turbolinks": disableTurbolinks ? "false" : void 0,
      children: text2
    }
  );
};
function BooleanCell({ value }) {
  const isTrue = value === "Yes" ? true : value === "No" ? false : void 0;
  if (isTrue === void 0) return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "--" });
  if (isTrue) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "span",
      {
        style: {
          display: "inline-flex",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          color: "var(--fgColor-success)"
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckIcon, { size: 16 })
      }
    );
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "span",
      {
        style: {
          display: "inline-flex",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          color: "var(--fgColor-danger)"
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(XIcon, { size: 16 })
      }
    );
  }
}
const CheckboxSelectionCell = ({
  row
}) => {
  const { isSelectedRow, selectRow, deselectRow } = useContext(SelectedRowContext);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Checkbox$1,
    {
      checked: isSelectedRow(row),
      onChange: (e) => e.target.checked ? selectRow(row) : deselectRow(row)
    }
  );
};
const RowEditModal = ({
  row,
  column: column2,
  onClose
}) => {
  const { RowEditor, reloadGridResults } = useRowEditContext();
  if (RowEditor === void 0) {
    console.error(
      "A RowEditor component must be provided to PaginatedGrid to use row edit columns"
    );
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog, { onClose, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    RowEditor,
    {
      row,
      column: column2,
      onSave: () => {
        reloadGridResults();
        onClose();
      },
      onCancel: onClose
    }
  ) });
};
const RowEditCell = ({ row, column: column2 }) => {
  const [open, setOpen] = useState(false);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    open && /* @__PURE__ */ jsxRuntimeExports.jsx(
      RowEditModal,
      {
        row,
        column: column2,
        onClose: () => setOpen(false)
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, { onClick: () => setOpen(true), children: "Edit" })
  ] });
};
const isLinkCell = (cell) => typeof cell === "object" && cell !== null && "href" in cell;
const isButtonCell = (cell) => typeof cell === "object" && cell !== null && "buttons" in cell;
const CellRenderer = ({
  row,
  column: column2,
  ...rest
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Table$1.Cell,
  {
    ...rest,
    scope: column2.rowHeader ? "row" : void 0,
    align: column2.type === "integer" || column2.type === "currency" ? "end" : "start",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(CellImpl, { row, column: column2 })
  }
);
const CellImpl = ({ row, column: column2 }) => {
  const rawValue = row[column2.key];
  const value = displayValue({ item: row, column: column2 });
  const className = column2.cellClass;
  if (column2.type === "boolean") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(BooleanCell, { value });
  }
  if (column2.type === "row_edit") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(RowEditCell, { row, column: column2, className });
  }
  if (column2.type === "checkbox") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxSelectionCell, { row, className });
  }
  if (isLinkCell(rawValue)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(LinkCell, { ...rawValue, className });
  }
  if (column2.actionButtons && isButtonCell(rawValue)) {
    const convertedButtons = rawValue.buttons.map((button) => ({
      ...button,
      type: button.type || "action",
      onClick: button.onClick || ((event) => {
        if (button.href) window.location.href = button.href;
      })
    }));
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonCell, { buttons: convertedButtons, className });
  }
  if (value === null || value === void 0 || value === "") {
    return "--";
  }
  return value;
};
function useActionMenuScrollClose() {
  const containerRef = useRef(null);
  useEffect(() => {
    let scrollStartY = 0;
    let isScrolling = false;
    let scrollTimer;
    const handleScroll = (event) => {
      const target = event.target;
      const currentScrollY = target.scrollTop;
      if (!isScrolling) {
        scrollStartY = currentScrollY;
        isScrolling = true;
      }
      const totalScrollDistance = Math.abs(currentScrollY - scrollStartY);
      if (totalScrollDistance > 20) {
        document.dispatchEvent(new KeyboardEvent("keydown", {
          key: "Escape",
          keyCode: 27,
          bubbles: true,
          cancelable: true
        }));
        scrollStartY = currentScrollY;
      }
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        isScrolling = false;
      }, 150);
    };
    const findScrollContainer = () => {
      if (!containerRef.current) return null;
      const tableWrapper = containerRef.current.closest(".TableOverflowWrapper");
      if (tableWrapper) {
        return tableWrapper;
      }
      let parent2 = containerRef.current.parentElement;
      while (parent2 && parent2 !== document.body) {
        const style3 = window.getComputedStyle(parent2);
        if ((style3.overflow === "auto" || style3.overflow === "scroll" || style3.overflowY === "auto" || style3.overflowY === "scroll") && parent2.scrollHeight > parent2.clientHeight) {
          return parent2;
        }
        parent2 = parent2.parentElement;
      }
      return null;
    };
    const scrollContainer2 = findScrollContainer();
    if (scrollContainer2) {
      scrollContainer2.scrollTop;
      scrollContainer2.addEventListener("scroll", handleScroll, { passive: true });
      return () => {
        clearTimeout(scrollTimer);
        scrollContainer2.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);
  return containerRef;
}
function needsSpecialHandling(button) {
  return button.type === "delete" || button.type === "update";
}
function getButtonVariant(button) {
  if (button.variant) {
    return button.variant;
  }
  if (button.type === "delete" || button.key === "delete" || button.key === "cancel") {
    return "danger";
  }
  return "default";
}
function processButtonAction(button) {
  var _a3;
  if (!button.href) return;
  const csrfToken = (_a3 = document.querySelector('meta[name="csrf-token"]')) == null ? void 0 : _a3.getAttribute("content");
  if (button.type === "delete") {
    fetch(button.href, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": csrfToken || "",
        "Accept": "application/json",
        "Content-Type": "application/json"
      }
    }).then((response) => {
      if (response.ok) {
        window.location.reload();
      } else {
        console.error("DELETE request failed:", response.status, response.statusText);
      }
    }).catch((error2) => {
      console.error("Error processing DELETE action:", error2);
    });
  } else if (button.type === "update") {
    fetch(button.href, {
      method: "PUT",
      headers: {
        "X-CSRF-Token": csrfToken || "",
        "Accept": "application/json",
        "Content-Type": "application/json"
      }
    }).then((response) => {
      if (response.ok) {
        window.location.reload();
      } else {
        console.error("UPDATE request failed:", response.status, response.statusText);
      }
    }).catch((error2) => {
      console.error("Error processing UPDATE action:", error2);
    });
  } else {
    window.location.href = button.href;
  }
}
function createOnClickHandler(button) {
  if (button.onClick) {
    return button.onClick;
  }
  if (button.href) {
    return () => {
      if (button["data-confirm"]) {
        if (!confirm(button["data-confirm"])) {
          return;
        }
      }
      processButtonAction(button);
    };
  }
  return () => console.warn("Button has no onClick or href:", button);
}
const ActionIcon$1 = memo(function ActionIcon2() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(KebabHorizontalIcon, { "aria-label": "actions" });
});
const ActionMenuCell = ({ actions, portalId }) => {
  const containerRef = useActionMenuScrollClose();
  return actions.length === 0 ? null : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: containerRef, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionMenu, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Anchor, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconButton,
      {
        "aria-label": "Actions",
        icon: ActionIcon$1,
        variant: "invisible",
        unsafeDisableTooltip: true,
        sx: {
          transform: "rotate(90deg)",
          "&:hover svg": {
            fill: "accent.fg"
          }
        }
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ActionMenu.Overlay,
      {
        portalContainerName: portalId,
        sx: {
          zIndex: 9999
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList, { children: actions.map((action) => {
          if (action.href) {
            return /* @__PURE__ */ jsxRuntimeExports.jsx(
              ActionList.LinkItem,
              {
                href: action.href,
                variant: action.variant,
                children: action.title
              },
              action.title
            );
          }
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            ActionList.Item,
            {
              onSelect: action.onClick,
              variant: action.variant,
              children: action.title
            },
            action.title
          );
        }) })
      }
    )
  ] }) });
};
function ActionMenuCellAdapter({ buttons }) {
  const actions = buttons.map((button) => {
    const variant3 = getButtonVariant(button);
    if (button.onClick) {
      return { title: button.text, onClick: button.onClick, variant: variant3 };
    }
    if (needsSpecialHandling(button)) {
      return { title: button.text, onClick: createOnClickHandler(button), variant: variant3 };
    }
    return { title: button.text, href: button.href, variant: variant3 };
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenuCell, { actions });
}
var lodash_isequal = { exports: {} };
lodash_isequal.exports;
var hasRequiredLodash_isequal;
function requireLodash_isequal() {
  if (hasRequiredLodash_isequal) return lodash_isequal.exports;
  hasRequiredLodash_isequal = 1;
  (function(module2, exports) {
    var LARGE_ARRAY_SIZE = 200;
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    var MAX_SAFE_INTEGER = 9007199254740991;
    var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal || freeSelf || Function("return this")();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function arrayFilter(array, predicate) {
      var index2 = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result = [];
      while (++index2 < length2) {
        var value = array[index2];
        if (predicate(value, index2, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayPush(array, values2) {
      var index2 = -1, length2 = values2.length, offset3 = array.length;
      while (++index2 < length2) {
        array[offset3 + index2] = values2[index2];
      }
      return array;
    }
    function arraySome(array, predicate) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      while (++index2 < length2) {
        if (predicate(array[index2], index2, array)) {
          return true;
        }
      }
      return false;
    }
    function baseTimes(n2, iteratee) {
      var index2 = -1, result = Array(n2);
      while (++index2 < n2) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    function cacheHas(cache, key2) {
      return cache.has(key2);
    }
    function getValue3(object, key2) {
      return object == null ? void 0 : object[key2];
    }
    function mapToArray(map3) {
      var index2 = -1, result = Array(map3.size);
      map3.forEach(function(value, key2) {
        result[++index2] = [key2, value];
      });
      return result;
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function setToArray(set2) {
      var index2 = -1, result = Array(set2.size);
      set2.forEach(function(value) {
        result[++index2] = value;
      });
      return result;
    }
    var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
    var coreJsData = root2["__core-js_shared__"];
    var funcToString = funcProto.toString;
    var hasOwnProperty2 = objectProto.hasOwnProperty;
    var maskSrcKey = function() {
      var uid2 = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid2 ? "Symbol(src)_1." + uid2 : "";
    }();
    var nativeObjectToString = objectProto.toString;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    var Buffer2 = moduleExports ? root2.Buffer : void 0, Symbol2 = root2.Symbol, Uint8Array2 = root2.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice2 = arrayProto.splice, symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0, nativeKeys = overArg(Object.keys, Object);
    var DataView2 = getNative(root2, "DataView"), Map2 = getNative(root2, "Map"), Promise2 = getNative(root2, "Promise"), Set2 = getNative(root2, "Set"), WeakMap2 = getNative(root2, "WeakMap"), nativeCreate = getNative(Object, "create");
    var dataViewCtorString = toSource(DataView2), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
    function Hash(entries) {
      var index2 = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index2 < length2) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    function hashDelete(key2) {
      var result = this.has(key2) && delete this.__data__[key2];
      this.size -= result ? 1 : 0;
      return result;
    }
    function hashGet(key2) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key2];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty2.call(data, key2) ? data[key2] : void 0;
    }
    function hashHas(key2) {
      var data = this.__data__;
      return nativeCreate ? data[key2] !== void 0 : hasOwnProperty2.call(data, key2);
    }
    function hashSet(key2, value) {
      var data = this.__data__;
      this.size += this.has(key2) ? 0 : 1;
      data[key2] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    function ListCache(entries) {
      var index2 = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index2 < length2) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    function listCacheDelete(key2) {
      var data = this.__data__, index2 = assocIndexOf(data, key2);
      if (index2 < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index2 == lastIndex) {
        data.pop();
      } else {
        splice2.call(data, index2, 1);
      }
      --this.size;
      return true;
    }
    function listCacheGet(key2) {
      var data = this.__data__, index2 = assocIndexOf(data, key2);
      return index2 < 0 ? void 0 : data[index2][1];
    }
    function listCacheHas(key2) {
      return assocIndexOf(this.__data__, key2) > -1;
    }
    function listCacheSet(key2, value) {
      var data = this.__data__, index2 = assocIndexOf(data, key2);
      if (index2 < 0) {
        ++this.size;
        data.push([key2, value]);
      } else {
        data[index2][1] = value;
      }
      return this;
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    function MapCache(entries) {
      var index2 = -1, length2 = entries == null ? 0 : entries.length;
      this.clear();
      while (++index2 < length2) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    function mapCacheDelete(key2) {
      var result = getMapData(this, key2)["delete"](key2);
      this.size -= result ? 1 : 0;
      return result;
    }
    function mapCacheGet(key2) {
      return getMapData(this, key2).get(key2);
    }
    function mapCacheHas(key2) {
      return getMapData(this, key2).has(key2);
    }
    function mapCacheSet(key2, value) {
      var data = getMapData(this, key2), size2 = data.size;
      data.set(key2, value);
      this.size += data.size == size2 ? 0 : 1;
      return this;
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    function SetCache(values2) {
      var index2 = -1, length2 = values2 == null ? 0 : values2.length;
      this.__data__ = new MapCache();
      while (++index2 < length2) {
        this.add(values2[index2]);
      }
    }
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }
    function setCacheHas(value) {
      return this.__data__.has(value);
    }
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    function Stack2(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    function stackDelete(key2) {
      var data = this.__data__, result = data["delete"](key2);
      this.size = data.size;
      return result;
    }
    function stackGet(key2) {
      return this.__data__.get(key2);
    }
    function stackHas(key2) {
      return this.__data__.has(key2);
    }
    function stackSet(key2, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key2, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key2, value);
      this.size = data.size;
      return this;
    }
    Stack2.prototype.clear = stackClear;
    Stack2.prototype["delete"] = stackDelete;
    Stack2.prototype.get = stackGet;
    Stack2.prototype.has = stackHas;
    Stack2.prototype.set = stackSet;
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length2 = result.length;
      for (var key2 in value) {
        if (hasOwnProperty2.call(value, key2) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
        (key2 == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key2 == "offset" || key2 == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key2 == "buffer" || key2 == "byteLength" || key2 == "byteOffset") || // Skip index properties.
        isIndex(key2, length2)))) {
          result.push(key2);
        }
      }
      return result;
    }
    function assocIndexOf(array, key2) {
      var length2 = array.length;
      while (length2--) {
        if (eq(array[length2][0], key2)) {
          return length2;
        }
      }
      return -1;
    }
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray2(object) ? result : arrayPush(result, symbolsFunc(object));
    }
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    function baseIsEqual(value, other2, bitmask, customizer, stack) {
      if (value === other2) {
        return true;
      }
      if (value == null || other2 == null || !isObjectLike(value) && !isObjectLike(other2)) {
        return value !== value && other2 !== other2;
      }
      return baseIsEqualDeep(value, other2, bitmask, customizer, baseIsEqual, stack);
    }
    function baseIsEqualDeep(object, other2, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray2(object), othIsArr = isArray2(other2), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other2);
      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;
      var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other2)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack2());
        return objIsArr || isTypedArray(object) ? equalArrays(object, other2, bitmask, customizer, equalFunc, stack) : equalByTag(object, other2, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other2, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other2.value() : other2;
          stack || (stack = new Stack2());
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack2());
      return equalObjects(object, other2, bitmask, customizer, equalFunc, stack);
    }
    function baseIsNative(value) {
      if (!isObject2(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction2(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key2 in Object(object)) {
        if (hasOwnProperty2.call(object, key2) && key2 != "constructor") {
          result.push(key2);
        }
      }
      return result;
    }
    function equalArrays(array, other2, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other2.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      var stacked = stack.get(array);
      if (stacked && stack.get(other2)) {
        return stacked == other2;
      }
      var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
      stack.set(array, other2);
      stack.set(other2, array);
      while (++index2 < arrLength) {
        var arrValue = array[index2], othValue = other2[index2];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, arrValue, index2, other2, array, stack) : customizer(arrValue, othValue, index2, array, other2, stack);
        }
        if (compared !== void 0) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        if (seen) {
          if (!arraySome(other2, function(othValue2, othIndex) {
            if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          result = false;
          break;
        }
      }
      stack["delete"](array);
      stack["delete"](other2);
      return result;
    }
    function equalByTag(object, other2, tag2, bitmask, customizer, equalFunc, stack) {
      switch (tag2) {
        case dataViewTag:
          if (object.byteLength != other2.byteLength || object.byteOffset != other2.byteOffset) {
            return false;
          }
          object = object.buffer;
          other2 = other2.buffer;
        case arrayBufferTag:
          if (object.byteLength != other2.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other2))) {
            return false;
          }
          return true;
        case boolTag:
        case dateTag:
        case numberTag:
          return eq(+object, +other2);
        case errorTag:
          return object.name == other2.name && object.message == other2.message;
        case regexpTag:
        case stringTag:
          return object == other2 + "";
        case mapTag:
          var convert2 = mapToArray;
        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert2 || (convert2 = setToArray);
          if (object.size != other2.size && !isPartial) {
            return false;
          }
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other2;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;
          stack.set(object, other2);
          var result = equalArrays(convert2(object), convert2(other2), bitmask, customizer, equalFunc, stack);
          stack["delete"](object);
          return result;
        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other2);
          }
      }
      return false;
    }
    function equalObjects(object, other2, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other2), othLength = othProps.length;
      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index2 = objLength;
      while (index2--) {
        var key2 = objProps[index2];
        if (!(isPartial ? key2 in other2 : hasOwnProperty2.call(other2, key2))) {
          return false;
        }
      }
      var stacked = stack.get(object);
      if (stacked && stack.get(other2)) {
        return stacked == other2;
      }
      var result = true;
      stack.set(object, other2);
      stack.set(other2, object);
      var skipCtor = isPartial;
      while (++index2 < objLength) {
        key2 = objProps[index2];
        var objValue = object[key2], othValue = other2[key2];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, objValue, key2, other2, object, stack) : customizer(objValue, othValue, key2, object, other2, stack);
        }
        if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key2 == "constructor");
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other2.constructor;
        if (objCtor != othCtor && ("constructor" in object && "constructor" in other2) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack["delete"](object);
      stack["delete"](other2);
      return result;
    }
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys2, getSymbols);
    }
    function getMapData(map3, key2) {
      var data = map3.__data__;
      return isKeyable(key2) ? data[typeof key2 == "string" ? "string" : "hash"] : data.map;
    }
    function getNative(object, key2) {
      var value = getValue3(object, key2);
      return baseIsNative(value) ? value : void 0;
    }
    function getRawTag(value) {
      var isOwn = hasOwnProperty2.call(value, symToStringTag), tag2 = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag2;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };
    var getTag = baseGetTag;
    if (DataView2 && getTag(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
      getTag = function(value) {
        var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }
    function isIndex(value, length2) {
      length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
      return !!length2 && (typeof value == "number" || reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
    }
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    function isPrototype(value) {
      var Ctor = value && value.constructor, proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value === proto2;
    }
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    function eq(value, other2) {
      return value === other2 || value !== value && other2 !== other2;
    }
    var isArguments = baseIsArguments(/* @__PURE__ */ function() {
      return arguments;
    }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    var isArray2 = Array.isArray;
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction2(value);
    }
    var isBuffer = nativeIsBuffer || stubFalse;
    function isEqual7(value, other2) {
      return baseIsEqual(value, other2);
    }
    function isFunction2(value) {
      if (!isObject2(value)) {
        return false;
      }
      var tag2 = baseGetTag(value);
      return tag2 == funcTag || tag2 == genTag || tag2 == asyncTag || tag2 == proxyTag;
    }
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    function isObject2(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    function keys2(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }
    function stubArray() {
      return [];
    }
    function stubFalse() {
      return false;
    }
    module2.exports = isEqual7;
  })(lodash_isequal, lodash_isequal.exports);
  return lodash_isequal.exports;
}
var lodash_isequalExports = requireLodash_isequal();
const isEqual6 = /* @__PURE__ */ getDefaultExportFromCjs$1(lodash_isequalExports);
const isFilterDefined = (filter) => (filter == null ? void 0 : filter.max) !== void 0 || (filter == null ? void 0 : filter.min) !== void 0;
const isDateFilter = (filter) => typeof filter === "object" && ("min" in filter || "max" in filter) && ((filter == null ? void 0 : filter.min) instanceof Date || (filter == null ? void 0 : filter.max) instanceof Date);
const isNumberFilter = (filter) => typeof filter === "object" && ("min" in filter || "max" in filter) && (typeof (filter == null ? void 0 : filter.min) === "number" || typeof (filter == null ? void 0 : filter.max) === "number");
const isWrapperColumn = (column2) => column2.resultColumns !== void 0;
const isLockedFilter = (grid2, column2) => {
  var _a3;
  return ((_a3 = grid2 == null ? void 0 : grid2.fixedFilters) == null ? void 0 : _a3[column2.key]) !== void 0;
};
const getResultColumns = (columns) => columns.reduce(
  (result, column2) => isWrapperColumn(column2) ? [...result, ...column2.resultColumns] : [...result, column2],
  []
);
const labelledColumn = (column2, grid2) => {
  var _a3;
  const override = (_a3 = grid2 == null ? void 0 : grid2.labels) == null ? void 0 : _a3[column2.key];
  if (override === void 0) {
    return column2;
  } else {
    return { ...column2, label: override };
  }
};
const labelledResultColumns = (grid2) => {
  const labels2 = grid2.labels;
  if (labels2 === void 0) {
    return getResultColumns(grid2.columns);
  } else {
    return getResultColumns(grid2.columns).map((c2) => labelledColumn(c2, grid2));
  }
};
const isColumn = (column2) => column2 !== void 0;
const getTotalsColumns = (grid2) => {
  if (grid2.totalsColumns === void 0) {
    return void 0;
  }
  const columns = getResultColumns(grid2.columns);
  return grid2.totalsColumns.map((key2) => columns.find((c2) => c2.key === key2)).filter(isColumn).map((c2) => labelledColumn(c2, grid2));
};
const useLoadRecords = (loader, options, cacheKey, useQueryOptions = {}) => useQuery(
  [cacheKey, loader.loadRecordsKey(options)],
  (context) => {
    return loader.loadRecords(options, context.signal);
  },
  { keepPreviousData: true, ...useQueryOptions }
);
const useSelectedRows$1 = ({
  rows: initialRows,
  onChange
}) => {
  const [selectedRows, setSelectedRows] = useState(initialRows);
  const setRows = (rows) => {
    setSelectedRows(rows);
    onChange == null ? void 0 : onChange(rows);
  };
  const isSelectedRow = (row) => selectedRows !== void 0 && selectedRows.some((r2) => r2.id === row.id);
  const setRowWindow = (rowWindow) => {
    setRows(
      selectedRows == null ? void 0 : selectedRows.filter((sr) => rowWindow.some((r2) => r2.id === sr.id))
    );
  };
  return {
    rows: selectedRows,
    setRows,
    selectRow: (row) => {
      if (!isSelectedRow(row)) {
        setRows([...selectedRows || [], row]);
      }
    },
    deselectRow: (row) => {
      if (selectedRows === void 0) {
        return;
      }
      setRows(selectedRows.filter((r2) => r2.id !== row.id));
    },
    isSelectedRow,
    clear: () => setRows(void 0),
    setRowWindow
  };
};
const readIntFromLocalStorage$1 = (key2, defaultValue2) => {
  const raw = localStorage.getItem(key2);
  if (raw === null) {
    return defaultValue2;
  } else {
    return JSON.parse(raw);
  }
};
const writeIntToLocalStorage$1 = (key2, value) => {
  localStorage.setItem(key2, JSON.stringify(value));
};
const getInitialPerPage$1 = (props) => {
  if (props.perPageStorageKey !== void 0) {
    return readIntFromLocalStorage$1(
      props.perPageStorageKey,
      props.defaultPerPage
    );
  } else {
    return props.defaultPerPage;
  }
};
const useGrid$1 = (props) => {
  const [grid2, setGrid] = useState(props.grid);
  const [savePoint, setSavePoint] = useState(props.grid);
  const [page, setPage] = useState(props.page);
  const [perPage, setPerPageState] = useState(getInitialPerPage$1(props));
  const [isDirty2, setIsDirty] = useState(false);
  const selectedRows = useSelectedRows$1({
    rows: props.selectedRows,
    onChange: props.onSelectionChange
  });
  const totalsColumns = getTotalsColumns(grid2);
  const setTotalsColumns = (totalsColumns2) => setGrid({ ...grid2, totalsColumns: totalsColumns2.map((c2) => c2.key) });
  const setPerPage = (newPerPage) => {
    setPerPageState(newPerPage);
    if (newPerPage !== perPage) {
      setPage(1);
    }
    if (props.perPageStorageKey !== void 0) {
      writeIntToLocalStorage$1(props.perPageStorageKey, newPerPage);
    }
  };
  const updateGrid = (update2) => {
    const updated = { ...grid2, ...update2 };
    if (!isEqual6(updated, grid2)) {
      setGrid(updated);
      setPage(1);
      setIsDirty(true);
    }
    return updated;
  };
  const saveGrid = async (update2) => {
    if (props.onSave === void 0) {
      throw new Error("onSave prop must be defined to save the grid");
    }
    const gridToSave = update2 !== void 0 ? updateGrid(update2) : grid2;
    const result = await props.onSave({ ...gridToSave });
    if (result.type === "success") {
      setSavePoint({ ...gridToSave, ...result.grid });
      setIsDirty(false);
    }
    return result;
  };
  const resetGrid = () => {
    setGrid(savePoint);
    setIsDirty(false);
  };
  const addTotalsColumn = (column2) => {
    let newColumns;
    if (totalsColumns === void 0) {
      newColumns = [column2];
      setTotalsColumns(newColumns);
      setIsDirty(true);
    } else if (!totalsColumns.some((c2) => c2.key === column2.key)) {
      newColumns = [...totalsColumns, column2];
      setTotalsColumns(newColumns);
      setIsDirty(true);
    } else {
      newColumns = totalsColumns;
    }
    return newColumns;
  };
  const removeTotalsColumn = (column2) => {
    if (totalsColumns === void 0) {
      return;
    }
    setIsDirty(true);
    setTotalsColumns(totalsColumns.filter((c2) => c2.key !== column2.key));
  };
  const loadRecordsResults = useLoadRecords(
    props.loader,
    {
      pageParams: { page, perPage },
      filters: { ...grid2.filters, ...grid2.fixedFilters },
      sort: grid2.sort
    },
    props.resultsCacheKey,
    {
      onSuccess: (data) => "rows" in data && selectedRows.setRowWindow(data.rows)
    }
  );
  const queryClient = useQueryClient();
  const reloadGridResults = () => queryClient.invalidateQueries();
  return {
    grid: grid2,
    results: loadRecordsResults.data,
    reloadGridResults,
    page,
    perPage,
    isLoading: loadRecordsResults.isLoading,
    isError: loadRecordsResults.isError,
    isFetching: loadRecordsResults.isFetching,
    isDirty: isDirty2,
    setPage,
    setPerPage,
    updateGrid,
    resetGrid,
    saveGrid,
    totalsColumns,
    addTotalsColumn,
    removeTotalsColumn,
    selectedRows
  };
};
const PER_PAGE_OPTIONS$1 = [10, 20, 50, 100, 200];
const pageRange$1 = (perPage, totalResults) => {
  const pageCount = Math.ceil(totalResults / perPage);
  return Array.from({ length: pageCount }, (x2, i) => i + 1);
};
const Pager$1 = ({
  perPage,
  totalResults,
  currentPage,
  isDisabled = false,
  onSelectPage,
  onSelectPerPage
}) => {
  const pages = pageRange$1(perPage, totalResults);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { justify: "center", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconButton$1,
      {
        "aria-label": "First page",
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(MdOutlineFirstPage, {}),
        isDisabled: isDisabled || currentPage === 1,
        onClick: () => onSelectPage(1)
      },
      "first-page"
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconButton$1,
      {
        "aria-label": "Previous page",
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(MdOutlineChevronLeft, {}),
        isDisabled: isDisabled || currentPage === 1,
        onClick: () => onSelectPage(currentPage - 1)
      },
      "prev-page"
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { children: [
      "Page ",
      currentPage,
      " / ",
      pages.length
    ] }, "page-text"),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconButton$1,
      {
        "aria-label": "Next page",
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(MdOutlineChevronRight, {}),
        isDisabled: isDisabled || currentPage === pages.length,
        onClick: () => onSelectPage(currentPage + 1)
      },
      "next-page"
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconButton$1,
      {
        "aria-label": "Last page",
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(MdOutlineLastPage, {}),
        isDisabled: isDisabled || currentPage === pages.length,
        onClick: () => onSelectPage(pages.length)
      },
      "last-page"
    ),
    onSelectPerPage !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { alignItems: "center", px: 2, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { textStyle: "body", p: 0, m: 0, minW: 16, children: "Per Page" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Select$2,
        {
          value: perPage,
          onChange: (e) => onSelectPerPage(Number(e.target.value)),
          children: PER_PAGE_OPTIONS$1.map((i) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: i, children: i }, i))
        }
      )
    ] }, "per-page")
  ] });
};
const ColumnLabelEditor$1 = ({
  grid: grid2,
  column: column2,
  onUpdateLabel
}) => {
  var _a3;
  const value = (_a3 = grid2 == null ? void 0 : grid2.labels) == null ? void 0 : _a3[column2.key];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { minWidth: 200, pl: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(InputGroup, { size: "md", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Input$1,
      {
        placeholder: "Override label",
        value: value || "",
        onChange: (e) => onUpdateLabel(column2.key, e.target.value)
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputRightElement, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconButton$1,
      {
        "aria-label": "Clear",
        size: "sm",
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, {}),
        onClick: () => onUpdateLabel(column2.key, void 0),
        isDisabled: !value
      }
    ) })
  ] }) });
};
const SimpleColumnRow$1 = ({
  grid: grid2,
  column: column2,
  index: index2,
  onUpdateLabel
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(PublicDraggable, { draggableId: column2.key, index: index2, children: (provided, snapshot) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  Tr,
  {
    display: snapshot.isDragging ? "table" : "table-row",
    ref: provided.innerRef,
    ...provided.draggableProps,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "15%", ...provided.dragHandleProps, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pl: 4, pb: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DragHandleIcon, { color: "gray.500" }) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { children: column2.label }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        ColumnLabelEditor$1,
        {
          grid: grid2,
          column: column2,
          onUpdateLabel
        }
      ) })
    ]
  }
) }, column2.key);
const WrapperColumnRow = ({
  grid: grid2,
  column: column2,
  index: index2,
  onUpdateLabel
}) => {
  const [open, setOpen] = useState(false);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    PublicDraggable,
    {
      isDragDisabled: open,
      draggableId: column2.key,
      index: index2,
      children: (provided, snapshot) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Tr,
        {
          display: snapshot.isDragging ? "table" : "table-row",
          ref: provided.innerRef,
          ...provided.draggableProps,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { width: "15%", ...provided.dragHandleProps, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { pl: 4, pb: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DragHandleIcon, { color: "gray.500" }) }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { colSpan: 2, px: 2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion$1, { allowToggle: true, index: open ? 0 : -1, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(AccordionItem, { border: 0, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(
                AccordionButton,
                {
                  color: "gray.800",
                  backgroundColor: "white",
                  maxW: "initial",
                  pl: 1,
                  alignItems: "initial",
                  onClick: () => setOpen(!open),
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsxs(
                      Text$3,
                      {
                        textStyle: "body",
                        textAlign: "center",
                        textTransform: "initial",
                        fontSize: "md",
                        children: [
                          column2.label,
                          " - ",
                          column2.resultColumns.length,
                          " columns"
                        ]
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionIcon, {})
                  ]
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionPanel, { pt: 0, px: 0, pb: 0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(TableContainer$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Table$3, { size: "sm", style: { tableLayout: "fixed" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Tbody, { children: column2.resultColumns.map((column22) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { whiteSpace: "initial", children: column22.label }) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Td, { pr: 2, pl: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  ColumnLabelEditor$1,
                  {
                    grid: grid2,
                    column: column22,
                    onUpdateLabel
                  }
                ) })
              ] }, column22.key)) }) }) }) })
            ] }) }) })
          ]
        }
      )
    },
    column2.key
  );
};
const ColumnsTable$1 = ({ grid: grid2, onChange }) => {
  const handleDragEnd = (result) => {
    if (result.destination) {
      const newColumns = [...grid2.columns];
      const [removed] = newColumns.splice(result.source.index, 1);
      newColumns.splice(result.destination.index, 0, removed);
      onChange({ columns: newColumns });
    }
  };
  const handleUpdateLabel = (key2, text2) => {
    const newLabels = { ...grid2.labels };
    if (text2 === void 0) {
      delete newLabels[key2];
      onChange({ labels: newLabels });
    } else {
      onChange({
        labels: { ...newLabels, [key2]: text2 }
      });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DragDropContext$1, { onDragEnd: handleDragEnd, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$3, { size: "sm", style: { tableLayout: "fixed" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Thead, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Tr, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { width: "15%", children: "Drag to reorder" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Default label" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Th, { children: "Override label" })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectedDroppable$1, { droppableId: "gridColumns", children: (provided) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Tbody, { ref: provided.innerRef, ...provided.droppableProps, children: [
      grid2.columns.map(
        (column2, index2) => isWrapperColumn(column2) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          WrapperColumnRow,
          {
            grid: grid2,
            column: column2,
            index: index2,
            onUpdateLabel: handleUpdateLabel
          },
          column2.key
        ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
          SimpleColumnRow$1,
          {
            grid: grid2,
            column: column2,
            index: index2,
            onUpdateLabel: handleUpdateLabel
          },
          column2.key
        )
      ),
      provided.placeholder
    ] }) })
  ] }) });
};
const GridColumnEditor$1 = ({
  grid: initialGrid,
  onSave,
  onUpdate
}) => {
  const [grid2, setGrid] = useState(initialGrid);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const handleSave = async () => {
    const result = await onSave(grid2);
    if (result.type === "success") {
      onClose();
    }
  };
  const handleUpdate = () => {
    onUpdate(grid2);
    onClose();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: onOpen, colorScheme: "blue", children: "Edit columns" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Modal,
      {
        isOpen,
        onClose,
        size: "xl",
        scrollBehavior: "inside",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalContent, { minW: 700, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, children: "Edit columns" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(ModalCloseButton, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              ColumnsTable$1,
              {
                grid: grid2,
                onChange: (update2) => setGrid({ ...grid2, ...update2 })
              }
            ) }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              ModalFooter,
              {
                px: 10,
                display: "flex",
                bg: "gray.50",
                justifyContent: "space-between",
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: onClose, children: "Close" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonGroup$1, { children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: handleUpdate, colorScheme: "blue", children: "Apply" }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: handleSave, colorScheme: "green", children: "Save" })
                  ] })
                ]
              }
            )
          ] })
        ]
      }
    )
  ] });
};
const getColumn = (columns, key2) => columns.find((c2) => c2.key === key2);
const rowUpdatedAt = (row) => {
  var _a3;
  if (((_a3 = row == null ? void 0 : row.meta) == null ? void 0 : _a3.updated_at) !== void 0) {
    return new Date(Date.parse(row.meta.updated_at));
  }
};
const isEmptyCell = ({ column: column2, item }) => {
  const value = logicalValue({ column: column2, item });
  return value === null || value === void 0 || value === "";
};
const matchesFilter = ({
  column: column2,
  item,
  searchValue
}) => {
  const value = filterValue({ column: column2, item });
  return value == null ? void 0 : value.toLowerCase().includes(searchValue.toString().toLowerCase());
};
const choiceMatchesFilter = ({
  column: column2,
  item,
  searchValue
}) => {
  const choice = { value: searchValue };
  return choiceSelected({ item, column: column2, choice });
};
const dateMatchesFilter = ({
  column: column2,
  item,
  searchValue
}) => {
  if (!isFilterDefined(searchValue)) {
    return true;
  }
  const rawValue = logicalValue({ column: column2, item });
  if (rawValue === void 0) {
    return false;
  }
  const dateValue = parseISO$1(rawValue);
  if (searchValue.max !== void 0 && dateValue > searchValue.max) {
    return false;
  }
  if (searchValue.min !== void 0 && dateValue < searchValue.min) {
    return false;
  }
  return true;
};
const intMatchesFilter = ({
  column: column2,
  item,
  searchValue
}) => {
  if (!isFilterDefined(searchValue)) {
    return true;
  }
  const numberValue = logicalValue({ column: column2, item });
  if (numberValue === void 0) {
    return false;
  }
  if (searchValue.max !== void 0 && numberValue > searchValue.max) {
    return false;
  }
  if (searchValue.min !== void 0 && numberValue < searchValue.min) {
    return false;
  }
  return true;
};
const filterItems = ({
  columns,
  items,
  filters
}) => {
  if (filters === void 0) {
    return items;
  }
  return items.filter((item) => {
    return Object.entries(filters).every(([key2, filter]) => {
      const column2 = getColumn(columns, key2);
      if (column2 === void 0 || column2.noClientFilter) {
        return true;
      }
      if (Array.isArray(filter)) {
        if (filter.length === 0) {
          return isEmptyCell({ column: column2, item });
        }
        return filter.some(
          (value) => choiceMatchesFilter({ column: column2, item, searchValue: value })
        );
      } else if (column2.type === "date") {
        return dateMatchesFilter({
          column: column2,
          item,
          searchValue: filter
        });
      } else if (column2.type === "integer" || column2.type === "currency") {
        return intMatchesFilter({
          column: column2,
          item,
          searchValue: filter
        });
      } else {
        return matchesFilter({ column: column2, item, searchValue: filter });
      }
    });
  });
};
const HeaderRow$1 = ({ columns, onSort, sort: sort3, showPlacholderColumn = true }) => {
  const sortClass = (column2) => {
    if (column2.noSort) {
      return "noSort";
    }
    if (!sort3) {
      return null;
    }
    const ascOrDesc = sort3.order === "asc" ? "headerSortAsc" : "headerSortDesc";
    return sort3.column === column2.key ? ascOrDesc : "";
  };
  const classes2 = (column2) => {
    return classNames(
      "header",
      "column-header",
      `column-header-${column2.key}`,
      sortClass(column2)
    );
  };
  const handleClick2 = (column2) => {
    if (column2.noSort) return;
    const newSort = { column: column2.key };
    if (sort3 && sort3.column === column2.key && sort3.order === "asc") {
      newSort.order = "desc";
    } else {
      newSort.order = "asc";
    }
    onSort(newSort);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { children: [
    showPlacholderColumn && /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "placeholder" }, "_placeholder"),
    columns.map((column2) => {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "th",
        {
          className: classes2(column2),
          onClick: () => handleClick2(column2),
          children: column2.label
        },
        column2.key
      );
    })
  ] });
};
const FilterCell$1 = ({ name: name2, value, onChange, placeholder: placeholder2 = "Type…" }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "input",
    {
      placeholder: placeholder2,
      autocomplete: "off",
      autocorrect: "off",
      autocapitalize: "off",
      spellcheck: "false",
      value: value || "",
      className: "filter",
      onChange: (e) => onChange(name2, e.target.value)
    }
  ) });
};
const GridFilterBadge$1 = ({ children, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
  Badge,
  {
    size: "xs",
    maxWidth: 20,
    overflow: "hidden",
    textOverflow: "ellipsis",
    ...props,
    children
  }
) });
const findChoice$1 = (value, choices) => choices.find((c2) => c2.value === value);
const ChoiceBadges$1 = ({
  choices,
  selectedChoices
}) => {
  if (selectedChoices === void 0) return null;
  if (selectedChoices.length === 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterBadge$1, { children: "None" });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: selectedChoices.map((choiceValue) => {
    const choice = findChoice$1(choiceValue, choices);
    if (choice === void 0) {
      return null;
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterBadge$1, { children: choice.label }, choice.value);
    }
  }) });
};
const ChoiceFilterForm = ({
  choices,
  selectedChoices,
  allowNullSelection = true,
  onChange
}) => {
  const handleChange = (values2) => {
    if (Array.isArray(values2) && values2.length === 0) {
      onChange(void 0);
    } else {
      const changeValues = values2.map(
        (v2) => {
          var _a3;
          return (_a3 = choices.find((c2) => c2.value.toString() === v2)) == null ? void 0 : _a3.value;
        }
      );
      onChange(changeValues);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CheckboxGroup$2,
      {
        value: selectedChoices == null ? void 0 : selectedChoices.map((v2) => v2.toString()),
        onChange: handleChange,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", children: choices.map((choice) => /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox$2, { value: choice.value.toString(), children: choice.label }, choice.value)) })
      }
    ),
    allowNullSelection && /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { borderTopWidth: "1px", mt: 1, pt: 1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox$2,
      {
        isChecked: (selectedChoices == null ? void 0 : selectedChoices.length) === 0,
        onChange: (e) => onChange(e.target.checked ? [] : void 0),
        children: "No value (field is blank)"
      },
      "_null"
    ) })
  ] });
};
const FilterPopover$1 = ({
  buttonText,
  children,
  onClear,
  onCancel,
  onSave
}) => {
  const { isOpen, onClose, onToggle } = useDisclosure();
  const handleClose = () => {
    onCancel();
    onClose();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Popover$2, { isLazy: true, closeOnBlur: true, isOpen, onClose: handleClose, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(PopoverTrigger, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { size: "xs", onClick: onToggle, children: buttonText }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Portal$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(PopoverContent$1, { pt: 4, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(PopoverArrow, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        PopoverCloseButton,
        {
          onClick: handleClose,
          background: "transparent",
          color: "gray.800"
        }
      ),
      children,
      /* @__PURE__ */ jsxRuntimeExports.jsxs(PopoverFooter, { display: "flex", justifyContent: "space-between", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroup$1, { size: "sm", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button$1,
          {
            onClick: () => {
              onClear();
              onClose();
            },
            colorScheme: "red",
            children: "Clear"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroup$1, { size: "sm", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button$1,
          {
            onClick: () => {
              onSave();
              onClose();
            },
            colorScheme: "blue",
            children: "Apply"
          }
        ) })
      ] })
    ] }) })
  ] });
};
const GridFilter$1 = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  HStack,
  {
    justify: "space-between",
    alignContent: "flex-start",
    width: "100%",
    ...props
  }
);
const GridFilterStatus$1 = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { maxWidth: "calc(13.75rem - 40px)", lineHeight: 1.1, ...props });
const ChoiceFilter$1 = ({
  choices,
  selectedChoices: initialSelectedChoices,
  allowNullSelection,
  onChange
}) => {
  const [selectedChoices, setSelectedChoices] = useState(initialSelectedChoices);
  useEffect(() => {
    if (!isEqual6(selectedChoices, initialSelectedChoices)) {
      setSelectedChoices(initialSelectedChoices);
    }
  }, [initialSelectedChoices]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridFilter$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterStatus$1, { children: selectedChoices !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(ChoiceBadges$1, { choices, selectedChoices }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FilterPopover$1,
      {
        buttonText: selectedChoices === void 0 ? "Filter" : "Edit",
        onClear: () => {
          setSelectedChoices(void 0);
          onChange(void 0);
        },
        onCancel: () => setSelectedChoices(initialSelectedChoices),
        onSave: () => onChange(selectedChoices),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopoverBody, { maxH: 60, overflowY: "auto", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          ChoiceFilterForm,
          {
            choices,
            selectedChoices,
            onChange: setSelectedChoices,
            allowNullSelection
          }
        ) })
      }
    )
  ] });
};
const DateFilterForm = ({
  filter,
  onChange
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { align: "left", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      DatePicker,
      {
        onChange: (value) => onChange({ ...filter, min: value }),
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select",
        isClearable: true,
        selectedDate: filter == null ? void 0 : filter.min,
        placeholderText: "Min",
        maxDate: filter == null ? void 0 : filter.max
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      DatePicker,
      {
        onChange: (value) => onChange({ ...filter, max: value }),
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select",
        isClearable: true,
        selectedDate: filter == null ? void 0 : filter.max,
        placeholderText: "Max",
        minDate: filter == null ? void 0 : filter.min
      }
    ) })
  ] });
};
const DateFilterBadges$1 = ({ filter }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  (filter == null ? void 0 : filter.min) !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(Badge, { fontSize: "sm", children: [
    "From: ",
    filter.min.toLocaleDateString()
  ] }, "min"),
  " ",
  (filter == null ? void 0 : filter.max) !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(Badge, { fontSize: "sm", children: [
    "To: ",
    filter.max.toLocaleDateString()
  ] }, "max")
] });
const parsedDateFilter = (filter) => ({
  min: parseDateOrString(filter.min),
  max: parseDateOrString(filter.max)
});
const initFilter$1 = (filter) => filter !== void 0 ? parsedDateFilter(filter) : void 0;
const DateFilter$1 = ({
  filter: initialFilter,
  onChange
}) => {
  const [filter, setFilter] = useState(
    initFilter$1(initialFilter)
  );
  useEffect(() => {
    setFilter(initFilter$1(initialFilter));
  }, [initialFilter]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridFilter$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterStatus$1, { children: isFilterDefined(filter) && /* @__PURE__ */ jsxRuntimeExports.jsx(DateFilterBadges$1, { filter }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FilterPopover$1,
      {
        buttonText: isFilterDefined(filter) ? "Edit" : "Filter",
        onClear: () => {
          setFilter(void 0);
          onChange(void 0);
        },
        onCancel: () => setFilter(initFilter$1(initialFilter)),
        onSave: () => onChange(filter),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopoverBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(DateFilterForm, { filter, onChange: setFilter }) })
      }
    )
  ] });
};
const NumberFilterForm$1 = ({
  filter,
  onChange
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { align: "left", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Min" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      NumberInput,
      {
        value: filter == null ? void 0 : filter.min,
        onChange: (valueAsString, valueAsNumber) => {
          console.log({ valueAsString, valueAsNumber });
          onChange({
            ...filter,
            min: Number.isNaN(valueAsNumber) ? void 0 : valueAsNumber
          });
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(NumberInputField, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(NumberInputStepper, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(NumberIncrementStepper, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsx(NumberDecrementStepper, {})
          ] })
        ]
      }
    )
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Max" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      NumberInput,
      {
        value: filter == null ? void 0 : filter.max,
        onChange: (valueAsString, valueAsNumber) => onChange({
          ...filter,
          max: Number.isNaN(valueAsNumber) ? void 0 : valueAsNumber
        }),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(NumberInputField, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(NumberInputStepper, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(NumberIncrementStepper, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsx(NumberDecrementStepper, {})
          ] })
        ]
      }
    )
  ] })
] });
const NumberFilterBadges$1 = ({ filter }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  (filter == null ? void 0 : filter.min) !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(Badge, { fontSize: "sm", children: [
    "Min: ",
    filter.min
  ] }, "min"),
  " ",
  (filter == null ? void 0 : filter.max) !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(Badge, { fontSize: "sm", children: [
    "Max: ",
    filter.max
  ] }, "max")
] });
const NumberFilter$1 = ({
  filter: initialFilter,
  onChange
}) => {
  const [filter, setFilter] = useState(
    initialFilter
  );
  useEffect(() => {
    setFilter(initialFilter);
  }, [initialFilter]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridFilter$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterStatus$1, { children: isFilterDefined(filter) && /* @__PURE__ */ jsxRuntimeExports.jsx(NumberFilterBadges$1, { filter }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FilterPopover$1,
      {
        buttonText: isFilterDefined(filter) ? "Edit" : "Filter",
        onClear: () => {
          setFilter(void 0);
          onChange(void 0);
        },
        onCancel: () => setFilter(initialFilter),
        onSave: () => onChange(filter),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopoverBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NumberFilterForm$1, { filter, onChange: setFilter }) })
      }
    )
  ] });
};
const CurrencyFilterForm$1 = ({
  column: column2,
  filter,
  onChange
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { align: "left", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Min" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PriceInput$3,
      {
        currency: column2.currency,
        valueInCents: filter == null ? void 0 : filter.min,
        onChange: (min2) => onChange({ ...filter, min: min2 })
      }
    )
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Max" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PriceInput$3,
      {
        currency: column2.currency,
        valueInCents: filter == null ? void 0 : filter.max,
        onChange: (max2) => onChange({ ...filter, max: max2 })
      }
    )
  ] })
] });
const CurrencyFilterBadges$1 = ({
  column: column2,
  filter
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  (filter == null ? void 0 : filter.min) !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(Badge, { fontSize: "sm", children: [
    "Min: ",
    priceWithSymbol({ currency: column2.currency, price: filter.min })
  ] }, "min"),
  " ",
  (filter == null ? void 0 : filter.max) !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(Badge, { fontSize: "sm", children: [
    "Max: ",
    priceWithSymbol({ currency: column2.currency, price: filter.max })
  ] }, "max")
] });
const CurrencyFilter$1 = ({
  column: column2,
  filter: initialFilter,
  onChange
}) => {
  const [filter, setFilter] = useState(
    initialFilter
  );
  useEffect(() => {
    setFilter(initialFilter);
  }, [initialFilter]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridFilter$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterStatus$1, { children: isFilterDefined(filter) && /* @__PURE__ */ jsxRuntimeExports.jsx(CurrencyFilterBadges$1, { column: column2, filter }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FilterPopover$1,
      {
        buttonText: isFilterDefined(filter) ? "Edit" : "Filter",
        onClear: () => {
          setFilter(void 0);
          onChange(void 0);
        },
        onCancel: () => setFilter(initialFilter),
        onSave: () => onChange(filter),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopoverBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          CurrencyFilterForm$1,
          {
            column: column2,
            filter,
            onChange: setFilter
          }
        ) })
      }
    )
  ] });
};
const LockedFilter$1 = ({ filter }) => {
  if (isDateFilter(filter)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(DateFilterBadges$1, { filter: parsedDateFilter(filter) });
  }
  if (isNumberFilter(filter)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(NumberFilterBadges$1, { filter });
  }
  if (Array.isArray(filter)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: filter.map((value) => /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterBadge$1, { children: value }, value.toString())) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterBadge$1, { children: filter });
};
const BooleanFilterForm$1 = ({
  selectedValue,
  onChange
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox$2,
      {
        isChecked: selectedValue === true,
        onChange: () => onChange(selectedValue === true ? void 0 : true),
        children: "Yes"
      },
      "yes"
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox$2,
      {
        isChecked: selectedValue === false,
        onChange: () => onChange(selectedValue === false ? void 0 : false),
        children: "No"
      },
      "no"
    )
  ] });
};
const BooleanBadges$1 = ({
  selectedValue
}) => {
  if (selectedValue === void 0) return null;
  if (selectedValue) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterBadge$1, { children: "Yes" });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterBadge$1, { children: "No" });
  }
};
const BooleanFilter$1 = ({
  onChange,
  selectedValue: initialValue
}) => {
  const [selectedValue, setSelectedValue] = useState(
    initialValue
  );
  useEffect(() => {
    if (initialValue !== selectedValue) {
      setSelectedValue(initialValue);
    }
  }, [initialValue]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridFilter$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterStatus$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BooleanBadges$1, { selectedValue }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FilterPopover$1,
      {
        buttonText: selectedValue === void 0 ? "Filter" : "Edit",
        onClear: () => {
          setSelectedValue(void 0);
          onChange(void 0);
        },
        onCancel: () => setSelectedValue(initialValue),
        onSave: () => onChange(selectedValue),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopoverBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          BooleanFilterForm$1,
          {
            onChange: setSelectedValue,
            selectedValue
          }
        ) })
      }
    )
  ] });
};
const SingleChoiceFilterForm$1 = ({
  choices,
  selectedChoice,
  onChange
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "left", children: choices.map((choice) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Checkbox$2,
    {
      value: choice.value.toString(),
      isChecked: (selectedChoice == null ? void 0 : selectedChoice.toString()) === choice.value.toString(),
      onChange: (e) => onChange(e.target.checked ? choice.value : void 0),
      children: choice.label
    },
    choice.value
  )) }) });
};
const SingleChoiceFilter$1 = ({
  choices,
  selectedChoice: initialSelectedChoice,
  onChange
}) => {
  const [selectedChoice, setSelectedChoice] = useState(initialSelectedChoice);
  useEffect(() => {
    if (!isEqual6(selectedChoice, initialSelectedChoice)) {
      setSelectedChoice(initialSelectedChoice);
    }
  }, [initialSelectedChoice]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridFilter$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterStatus$1, { children: selectedChoice !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(ChoiceBadges$1, { choices, selectedChoices: [selectedChoice] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FilterPopover$1,
      {
        buttonText: selectedChoice === void 0 ? "Filter" : "Edit",
        onClear: () => {
          setSelectedChoice(void 0);
          onChange(void 0);
        },
        onCancel: () => setSelectedChoice(initialSelectedChoice),
        onSave: () => onChange(selectedChoice),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopoverBody, { maxH: 60, overflowY: "auto", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          SingleChoiceFilterForm$1,
          {
            choices,
            selectedChoice,
            onChange: setSelectedChoice
          }
        ) })
      }
    )
  ] });
};
const FilterRow$1 = ({
  grid: grid2,
  onFilter,
  placeholder: placeholder2 = void 0
}) => {
  const handleFilterChange = (name2, value) => {
    if (value === void 0 || value === null || value === "") {
      const newFilters = { ...grid2.filters };
      delete newFilters[name2];
      onFilter(newFilters);
    } else {
      const update2 = {
        [name2]: value
      };
      onFilter({ ...grid2.filters, ...update2 });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "filters-label", children: "filters" }, "_filter-label"),
    getResultColumns(grid2.columns).map((column2) => {
      var _a3, _b, _c, _d, _e2, _f, _g, _h;
      if (column2.noFilter) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "noFilter" }, column2.key);
      } else if (isLockedFilter(grid2, column2)) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          LockedFilter$1,
          {
            filter: (_a3 = grid2 == null ? void 0 : grid2.fixedFilters) == null ? void 0 : _a3[column2.key]
          }
        ) }, column2.key);
      } else if (column2.type === "date") {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "dateFilter", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          DateFilter$1,
          {
            column: column2,
            filter: (_b = grid2 == null ? void 0 : grid2.filters) == null ? void 0 : _b[column2.key],
            onChange: (filterValue2) => handleFilterChange(column2.key, filterValue2)
          }
        ) }, column2.key);
      } else if (column2.choices !== void 0) {
        if (column2.singleChoiceFilter) {
          return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "choiceFilter", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            SingleChoiceFilter$1,
            {
              choices: column2.choices,
              selectedChoice: (_c = grid2 == null ? void 0 : grid2.filters) == null ? void 0 : _c[column2.key],
              onChange: (selectedChoiceValue) => handleFilterChange(column2.key, selectedChoiceValue)
            }
          ) }, column2.key);
        } else {
          return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "choiceFilter", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            ChoiceFilter$1,
            {
              choices: column2.choices,
              selectedChoices: (_d = grid2 == null ? void 0 : grid2.filters) == null ? void 0 : _d[column2.key],
              allowNullSelection: (column2 == null ? void 0 : column2.allowNullFilter) === void 0 || (column2 == null ? void 0 : column2.allowNullFilter) === true,
              onChange: (selectedChoiceValues) => handleFilterChange(column2.key, selectedChoiceValues)
            }
          ) }, column2.key);
        }
      } else if (column2.type === "integer") {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "choiceFilter", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          NumberFilter$1,
          {
            column: column2,
            filter: (_e2 = grid2 == null ? void 0 : grid2.filters) == null ? void 0 : _e2[column2.key],
            onChange: (filterValue2) => handleFilterChange(column2.key, filterValue2)
          }
        ) }, column2.key);
      } else if (column2.type === "currency") {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "choiceFilter", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          CurrencyFilter$1,
          {
            column: column2,
            filter: (_f = grid2 == null ? void 0 : grid2.filters) == null ? void 0 : _f[column2.key],
            onChange: (filterValue2) => handleFilterChange(column2.key, filterValue2)
          }
        ) }, column2.key);
      } else if (column2.type === "boolean") {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "booleanFilter", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          BooleanFilter$1,
          {
            selectedValue: (_g = grid2 == null ? void 0 : grid2.filters) == null ? void 0 : _g[column2.key],
            onChange: (filterValue2) => handleFilterChange(column2.key, filterValue2)
          }
        ) }, column2.key);
      } else {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          FilterCell$1,
          {
            name: column2.key,
            value: (_h = grid2 == null ? void 0 : grid2.filters) == null ? void 0 : _h[column2.key],
            onChange: handleFilterChange,
            placeholder: placeholder2
          },
          column2.key
        );
      }
    })
  ] });
};
const inLast24Hours = (when) => when && hooks(when).isAfter(hooks().subtract(1, "days"));
function MetaCell$1({ updated }) {
  if (updated && inLast24Hours(updated)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("td", { className: "timestamp", children: [
      "Updated ",
      hooks(updated).format("ddd MMM D kk:mm:ss Z")
    ] });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "timestamp" });
  }
}
const KeyHolder$1 = ({ children }) => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children });
const DataRow$1 = ({
  columns,
  row,
  renderCell,
  showMetaCell = true
}) => {
  const updated = rowUpdatedAt(row);
  const classes2 = classNames({
    "data-row": true,
    "updated-row": inLast24Hours(updated)
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { className: classes2, children: [
    showMetaCell && /* @__PURE__ */ jsxRuntimeExports.jsx(MetaCell$1, { updated: rowUpdatedAt(row) }, "_meta"),
    columns.map((column2) => {
      if (typeof renderCell === "function") {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(KeyHolder$1, { children: renderCell({ row, column: column2 }) }, column2.key);
      } else {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(CellRenderer$1, { column: column2, row }, column2.key);
      }
    })
  ] });
};
const useColumnTotal$1 = (props) => {
  const [results, setResults] = useState({
    type: "loading"
  });
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    let isSubscribed = true;
    const abortController = new AbortController();
    setIsLoading(true);
    const fetchResult = async () => {
      const newResult = await props.loader.loadTotal(
        {
          column: props.column,
          filters: props.grid.filters
        },
        abortController.signal
      );
      if (isSubscribed) {
        setResults(newResult);
        setIsLoading(false);
      }
    };
    fetchResult().catch(console.error);
    return () => {
      abortController.abort();
      isSubscribed = false;
    };
  }, [props.grid]);
  return {
    results,
    isLoading
  };
};
const ColumnTotal$1 = (props) => {
  const { results, isLoading } = useColumnTotal$1(props);
  if (results.type === "loading" || isLoading) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Loading..." });
  }
  if (results.type === "error") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Error..." });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { align: "right", children: results.totals.map((total) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { textAlign: "right", children: [
    total.label,
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: total.value })
  ] }, total.label)) });
};
const addFilterParams = (params, columns, filters) => {
  if (filters === void 0) {
    return;
  }
  Object.entries(filters).forEach(([k2, v2]) => {
    const column2 = columns.find((c2) => c2.key === k2);
    if (column2 === void 0) {
      return;
    }
    if (column2.choices !== void 0 && !column2.singleChoiceFilter) {
      const value = v2;
      if ((value == null ? void 0 : value.length) === 0) {
        params.append(`f[${k2}]`, "");
      } else {
        value.forEach((val) => params.append(`f[${k2}][]`, val.toString()));
      }
    } else if (column2.type === "date") {
      const dateFilter = parsedDateFilter(v2);
      if (dateFilter.min !== void 0) {
        params.append(`f[${k2}][min]`, dateFilter.min.toISOString());
      }
      if (dateFilter.max !== void 0) {
        params.append(`f[${k2}][max]`, dateFilter.max.toISOString());
      }
    } else if (column2.type === "integer" || column2.type === "currency") {
      const numberFilter = v2;
      if (numberFilter.min !== void 0) {
        params.append(`f[${k2}][min]`, numberFilter.min.toString());
      }
      if (numberFilter.max !== void 0) {
        params.append(`f[${k2}][max]`, numberFilter.max.toString());
      }
    } else {
      params.append(`f[${k2}]`, v2.toString());
    }
  });
};
const gridResultsParams = (columns, { pageParams, filters, sort: sort3 }) => {
  const params = new URLSearchParams({
    p: pageParams.page.toString(),
    pp: pageParams.perPage.toString()
  });
  if (sort3 !== void 0) {
    params.append("s", sort3.column);
    params.append("so", sort3.order);
  }
  addFilterParams(params, columns, filters);
  return params;
};
const TotalsLoaderRow$1 = ({
  grid: grid2,
  loader,
  onAddToGrid
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { className: "totals", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("td", {}, "_empty"),
  getResultColumns(grid2.columns).map((column2) => /* @__PURE__ */ jsxRuntimeExports.jsx("td", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { justify: "space-between", alignItems: "flex-start", children: [
    (column2 == null ? void 0 : column2.gridTotals) && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        size: "xs",
        variant: "grSolid",
        colorScheme: "blue",
        onClick: () => onAddToGrid(column2),
        children: "Breakdown"
      }
    ),
    (column2 == null ? void 0 : column2.simpleTotal) && /* @__PURE__ */ jsxRuntimeExports.jsx(ColumnTotal$1, { grid: grid2, column: column2, loader })
  ] }) }, column2.key))
] });
const PaginatedTable$1 = ({
  grid: grid2,
  result,
  loader,
  tableClasses,
  renderCell,
  onFilterChange,
  onSortChange,
  onLoadTotal
}) => {
  const rows = filterItems({
    columns: grid2.columns,
    items: result.rows,
    filters: grid2.filters
  });
  const columns = labelledResultColumns(grid2);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "table",
    {
      cellSpacing: "0",
      className: classNames("tablesorter table-borders fluid", tableClasses),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("thead", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderRow$1, { columns, sort: grid2.sort, onSort: onSortChange }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(FilterRow$1, { grid: grid2, onFilter: onFilterChange })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: rows.map((row) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          DataRow$1,
          {
            columns,
            row,
            renderCell
          },
          row.id
        )) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("tfoot", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TotalsLoaderRow$1,
          {
            loader,
            grid: grid2,
            onAddToGrid: onLoadTotal
          }
        ) })
      ]
    }
  );
};
const toCmpVal = (val) => {
  if (Array.isArray(val)) {
    return toCmpVal(val[0]);
  }
  return typeof val === "number" ? Number(val).toLocaleString() : val;
};
const safeLocaleCompare = (valA, valB) => toCmpVal(valA).localeCompare(toCmpVal(valB));
const isEmptyArray = (val) => Array.isArray(val) && val.length === 0;
const sortItems = ({ column: column2, items, order: order2 = "asc" }) => {
  const sortedItems = items.concat().sort((a2, b2) => {
    const valA = logicalValue({ column: column2, item: a2 });
    const valB = logicalValue({ column: column2, item: b2 });
    if (valA === valB) {
      return 0;
    }
    if (valA === null || valA === void 0 || isEmptyArray(valA)) {
      return -1;
    }
    if (valB === null || valB === void 0 || isEmptyArray(valB)) {
      return 1;
    }
    if (column2.type === "integer" || column2.type === "currency") {
      return valA - valB;
    }
    return safeLocaleCompare(valA, valB);
  });
  if (order2 === "asc") {
    return sortedItems;
  } else {
    return sortedItems.reverse();
  }
};
const useTotalsGrid$1 = (props) => {
  const [totalsResults, setTotalsResults] = useState({
    type: "loading"
  });
  const [isLoading, setIsLoading] = useState(false);
  const [sort3, setSort] = useState();
  useEffect(() => {
    let isSubscribed = true;
    const abortController = new AbortController();
    const fetchResult = async () => {
      const newResult = await props.loader.loadTotalsGrid(
        {
          filters: props.parentGrid.filters,
          column: props.column
        },
        abortController.signal
      );
      if (isSubscribed) {
        setTotalsResults(newResult);
        setIsLoading(false);
      }
    };
    fetchResult().catch(console.error);
    return () => {
      abortController.abort();
      isSubscribed = false;
    };
  }, [props.parentGrid]);
  const getSort = () => {
    var _a3;
    if (sort3 !== void 0) {
      return sort3;
    } else if (totalsResults.type === "success") {
      return (_a3 = totalsResults == null ? void 0 : totalsResults.grid) == null ? void 0 : _a3.sort;
    }
  };
  const sortedRows = () => {
    if (totalsResults.type === "success") {
      if (sort3 === void 0) {
        return totalsResults.rows;
      }
      const column2 = totalsResults.grid.columns.find(
        (c2) => c2.key === (sort3 == null ? void 0 : sort3.column)
      );
      if (column2 === void 0) {
        return totalsResults.rows;
      } else {
        return sortItems({
          column: column2,
          items: totalsResults.rows,
          order: sort3 == null ? void 0 : sort3.order
        });
      }
    } else {
      return void 0;
    }
  };
  return {
    isLoading,
    totalsResults,
    rows: sortedRows(),
    sort: getSort(),
    setSort
  };
};
function TotalCell$1({ total }) {
  if (!Number.isFinite(total)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "no-total" });
  }
  if (total === 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { align: "right", className: "total zero", children: "0" });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { align: "right", className: "total", children: total });
}
function BooleanTotalCell$1({ rows, column: column2 }) {
  const total = rows.reduce((sum, row) => {
    const value = logicalValue({ column: column2, item: row });
    if (!!value) {
      return sum + 1;
    } else {
      return sum;
    }
  }, 0);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TotalCell$1, { total });
}
function talliedChoices$3({ rows, column: column2 }) {
  return column2.choices.map((choice) => {
    return {
      key: choice.value,
      label: choice.label,
      value: rows.reduce((sum, row) => {
        if (choiceSelected({ item: row, column: column2, choice })) {
          return sum + 1;
        } else {
          return sum;
        }
      }, 0)
    };
  });
}
function ChoicesTotalCell$1({ rows, column: column2 }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { className: "total choices", children: talliedChoices$3({ rows, column: column2 }).map(({ key: key2, label, value }) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("dl", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("dt", { children: label }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("dd", { children: value })
    ] }, key2);
  }) });
}
function CurrencyTotalCell$1({ rows, column: column2 }) {
  const total = rows.reduce((sum, row) => {
    const value = logicalValue({ column: column2, item: row });
    if (Number.isFinite(value)) {
      return sum + value;
    } else {
      return sum;
    }
  }, 0);
  const formattedTotal = priceWithSymbol({
    currency: column2.currency,
    price: total
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { align: "right", className: "total", children: formattedTotal });
}
function IntegerTotalCell$1({ rows, column: column2 }) {
  const total = rows.reduce((sum, row) => {
    const value = logicalValue({ column: column2, item: row });
    if (Number.isFinite(value)) {
      return sum + value;
    } else {
      return sum;
    }
  }, 0);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TotalCell$1, { total });
}
function talliedChoices$2({ rows, column: column2 }) {
  return column2.choices.map((choice) => {
    return {
      value: choice.value,
      label: choice.label,
      count: rows.reduce((count2, row) => {
        if (logicalValue({ item: row, column: column2 }) === choice.value) {
          return count2 + 1;
        } else {
          return count2;
        }
      }, 0),
      sum: rows.reduce((sum, row) => {
        if (logicalValue({ item: row, column: column2 }) === choice.value) {
          return sum + choice.value;
        } else {
          return sum;
        }
      }, 0)
    };
  });
}
function IntegerChoicesTotalCell$1({ rows, column: column2 }) {
  const totals = talliedChoices$2({ rows, column: column2 });
  const grandTotal = totals.reduce((total, { sum }) => total + sum, 0);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("td", { className: "total choices", children: [
    totals.map(({ label, value, count: count2, sum }) => {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("dl", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("dt", { children: label }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("dd", { style: { width: "100%" }, children: [
          count2,
          " x ",
          value,
          " = ",
          sum
        ] })
      ] }, value);
    }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("dl", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("dt", { children: "Total" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("dd", { style: { textAlign: "right", width: "20%" }, children: grandTotal })
    ] }, "_grandTotal")
  ] });
}
function TotalCellRenderer$1({ rows, column: column2 }) {
  if (column2.noTotal) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(TotalCell$1, { total: null });
  } else if (column2.choices && column2.type === "integer") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(IntegerChoicesTotalCell$1, { column: column2, rows });
  } else if (column2.choices) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ChoicesTotalCell$1, { column: column2, rows });
  } else if (column2.type === "integer") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(IntegerTotalCell$1, { column: column2, rows });
  } else if (column2.type === "currency") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(CurrencyTotalCell$1, { column: column2, rows });
  } else if (column2.type === "boolean") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(BooleanTotalCell$1, { column: column2, rows });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(TotalCell$1, { total: null });
  }
}
function TotalsRow$1({
  rows,
  columns,
  totalResults = void 0,
  showMetaCell = true
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { className: "totals", children: [
    showMetaCell && /* @__PURE__ */ jsxRuntimeExports.jsxs("td", { className: "filters-label", children: [
      "Total ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: totalResults || rows.length })
    ] }),
    columns.map((column2) => /* @__PURE__ */ jsxRuntimeExports.jsx(TotalCellRenderer$1, { column: column2, rows }, column2.key))
  ] });
}
const TotalsGrid$1 = (props) => {
  const { isLoading, totalsResults, rows, sort: sort3, setSort } = useTotalsGrid$1(props);
  if (totalsResults.type === "loading" || isLoading) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Loading..." });
  }
  if (totalsResults.type === "error") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Error..." });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("table", { cellSpacing: "0", className: "tablesorter table-borders fluid", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("thead", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      HeaderRow$1,
      {
        columns: totalsResults.grid.columns,
        sort: sort3,
        onSort: setSort,
        showPlacholderColumn: false
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: rows == null ? void 0 : rows.map((row) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      DataRow$1,
      {
        columns: totalsResults.grid.columns,
        row,
        showMetaCell: false
      },
      row.id
    )) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("tfoot", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      TotalsRow$1,
      {
        rows: totalsResults.rows,
        columns: totalsResults.grid.columns,
        showMetaCell: false
      }
    ) })
  ] });
};
const GridTab$1 = forwardRef$1((props, ref2) => {
  const tabProps = useTab({ ...props, ref: ref2 });
  const tabBoxStyle = {
    position: "relative",
    alignItems: "stretch",
    marginBottom: "-2px"
  };
  const tabStyleOverride = {
    color: "gray.700",
    height: "100%",
    marginBottom: 0,
    backgroundColor: "transparent",
    _hover: {
      color: "gray.700",
      backgroundColor: "transparent"
    }
  };
  if (props.onClose !== void 0) {
    tabStyleOverride.paddingRight = "2em";
  }
  const styles2 = useMultiStyleConfig("Tabs", tabProps);
  const tabStyle = { ...styles2.tab, ...tabStyleOverride };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { __css: tabBoxStyle, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { __css: tabStyle, ...tabProps, children: tabProps.children }),
    props.onClose !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
      CloseButton$1,
      {
        __css: {
          position: "absolute",
          top: 0,
          right: 0,
          background: "transparent",
          color: "gray.800"
        },
        onClick: props.onClose
      }
    )
  ] });
});
GridTab$1.displayName = "GridTab";
const firstItem$1 = (page, perPage) => (page - 1) * perPage + 1;
const lastItem$1 = (page, perPage, totalResults) => Math.min(page * perPage, totalResults);
const ResultSummary$1 = ({
  isLoading,
  results,
  page,
  perPage
}) => {
  if (isLoading || results.type !== "success") {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { m: 0, children: "Loading results" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {})
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { children: [
    "Displaying ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: firstItem$1(page, perPage) }),
    " -",
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: lastItem$1(page, perPage, results.totalResults) }),
    " of",
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: results.totalResults })
  ] });
};
const PaginatedGrid$1 = ({
  resultsCacheKey = 1,
  ...props
}) => {
  const {
    grid: grid2,
    results,
    reloadGridResults,
    page,
    perPage,
    isDirty: isDirty2,
    isLoading,
    isFetching,
    isError: isError2,
    updateGrid,
    resetGrid,
    saveGrid,
    setPage,
    setPerPage,
    totalsColumns,
    addTotalsColumn,
    removeTotalsColumn,
    selectedRows
  } = useGrid$1({ resultsCacheKey, ...props });
  const [tabIndex, setTabIndex] = useState(0);
  const handleLoadTotal = (column2) => {
    const newColumns = addTotalsColumn(column2);
    const newIndex = newColumns.findIndex((c2) => c2.key === column2.key);
    setTabIndex(newIndex + 1);
  };
  const handleRemoveTotalsColumn = (column2) => {
    const isColumnSelected = (totalsColumns == null ? void 0 : totalsColumns.findIndex((c2) => c2.key === column2.key)) === tabIndex - 1;
    removeTotalsColumn(column2);
    if (isColumnSelected) {
      setTabIndex(0);
    }
  };
  useEffect(() => {
    if (grid2.totalsColumns === void 0 || grid2.totalsColumns.length === 0) {
      setTabIndex(0);
    }
  }, [grid2]);
  if (isLoading || results === void 0 || results.type === "loading") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Loading..." });
  }
  if (isError2 || results.type === "error") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Error..." });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(QueryClientProvider, { client: new QueryClient(), children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    RowEditContext.Provider,
    {
      value: {
        RowEditor: props.RowEditor,
        reloadGridResults
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { height: "100%", alignItems: "stretch", overflow: "hidden", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          HStack,
          {
            p: 8,
            position: "sticky",
            alignSelf: "top",
            alignItems: "top",
            justifyContent: "space-between",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "left", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Pager$1,
                  {
                    perPage,
                    totalResults: results.totalResults,
                    currentPage: page,
                    onSelectPage: setPage,
                    onSelectPerPage: props.hidePerPageControl ? void 0 : setPerPage
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  ResultSummary$1,
                  {
                    page,
                    perPage,
                    isLoading: isFetching,
                    results
                  }
                )
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonGroup$1, { children: [
                props.onSave !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                  isDirty2 && /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: resetGrid, children: "Reset" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    GridColumnEditor$1,
                    {
                      grid: grid2,
                      onSave: saveGrid,
                      onUpdate: updateGrid
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "green", onClick: () => saveGrid(), children: "Save" })
                ] }),
                props.actionLinks !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(Menu$1, { children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(MenuButton$1, { as: Button$1, rightIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronDownIcon$1, {}), children: "Download" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(MenuList, { children: props.actionLinks.map(({ title, onClick }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                    MenuItem,
                    {
                      backgroundColor: "transparent",
                      onClick: () => onClick(grid2),
                      children: title
                    },
                    title
                  )) })
                ] })
              ] }) })
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Tabs, { index: tabIndex, onChange: setTabIndex, flexGrow: 1, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(TabList, { background: "white", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(GridTab$1, { children: "Results" }, "_results"),
            totalsColumns == null ? void 0 : totalsColumns.map((column2) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
              GridTab$1,
              {
                onClose: () => handleRemoveTotalsColumn(column2),
                children: [
                  column2.label,
                  " - Totals"
                ]
              },
              column2.key
            ))
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(TabPanels, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(TabPanel, { width: "100%", overflow: "auto", children: /* @__PURE__ */ jsxRuntimeExports.jsx(SelectedRowProvider, { ...selectedRows, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              PaginatedTable$1,
              {
                grid: grid2,
                result: results,
                loader: props.loader,
                renderCell: props.renderCell,
                onFilterChange: (filters) => updateGrid({ filters }),
                onSortChange: (sort3) => updateGrid({ sort: sort3 }),
                onLoadTotal: handleLoadTotal
              }
            ) }) }, "_results"),
            totalsColumns == null ? void 0 : totalsColumns.map((column2) => /* @__PURE__ */ jsxRuntimeExports.jsx(TabPanel, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              TotalsGrid$1,
              {
                parentGrid: grid2,
                column: column2,
                loader: props.loader
              }
            ) }, column2.key))
          ] })
        ] })
      ] })
    }
  ) });
};
const PaginatedGridContainer$1 = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(QueryClientProvider, { client: new QueryClient(), children: /* @__PURE__ */ jsxRuntimeExports.jsx(PaginatedGrid$1, { ...props }) });
const GridContext = createContext(void 0);
const GridProvider = ({
  children,
  rowActions = []
}) => {
  const portalId = useId$2();
  useEffect(() => {
    console.log(`registering portal for id ${portalId}`);
    const portalRoot = document.getElementById(portalId);
    if (portalRoot) {
      registerPortalRoot(portalRoot, portalId);
    }
  }, [portalId]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridContext.Provider, { value: { portalId, rowActions }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: portalId, style: { position: "relative", zIndex: 4 } }),
    children
  ] });
};
const useGridContext = () => {
  const context = useContext(GridContext);
  if (context === void 0) {
    throw new Error("useGridContext must be used within a GridProvider");
  }
  return context;
};
const ColumnLabelEditor = ({
  grid: grid2,
  column: column2,
  onUpdateLabel
}) => {
  var _a3;
  const value = ((_a3 = grid2 == null ? void 0 : grid2.labels) == null ? void 0 : _a3[column2.key]) ?? "";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    FormControl$1,
    {
      sx: {
        minWidth: 0,
        width: "100%",
        display: "flex",
        flexDirection: "row"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { visuallyHidden: true, children: column2.label }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Box,
          {
            onKeyDownCapture: (e) => {
              if (e.key === " " || e.key === "Enter") {
                e.stopPropagation();
              }
            },
            sx: { width: "100%" },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              TextInput$1,
              {
                size: "medium",
                placeholder: "Update Label",
                autoComplete: "off",
                value,
                onChange: (e) => onUpdateLabel(column2.key, e.target.value),
                sx: { width: "100%" },
                trailingAction: value.length ? /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { justify: "center", sx: { minWidth: "34px" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  TextInput$1.Action,
                  {
                    onClick: () => onUpdateLabel(column2.key, void 0),
                    icon: XCircleFillIcon,
                    "aria-label": "Clear"
                  }
                ) }) : void 0
              }
            )
          }
        )
      ]
    }
  );
};
const ActionItemRow = forwardRef$1(
  ({ children, listeners, attributes, sx: sx2, ...props }, ref2) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Box,
      {
        ref: ref2,
        role: "presentation",
        tabIndex: -1,
        ...listeners,
        ...attributes,
        sx: {
          display: "flex",
          alignItems: "center",
          px: 3,
          py: 2,
          borderRadius: 2,
          gap: 3,
          cursor: "default",
          transition: "background-color 0.12s ease",
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: "canvas.subtle"
            // Light hover tone
          },
          "&:focus-within": {
            backgroundColor: "canvas.subtle"
            // Light hover tone
          },
          ...sx2
        },
        ...props,
        children
      }
    );
  }
);
ActionItemRow.displayName = "ActionItemRow";
const CompoundColumnRow = forwardRef$1(
  ({
    grid: grid2,
    column: column2,
    onUpdateLabel,
    style: style3,
    preventOpen = false,
    isOpen,
    onToggle,
    listeners,
    attributes,
    isFirst = false
  }, ref2) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { ref: ref2, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionItemRow, { style: style3, listeners, attributes, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { display: "flex", alignItems: "center", cursor: "grab" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(GrabberIcon, {}) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { flex: 1, minWidth: 0 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          ButtonComponent,
          {
            variant: "invisible",
            onClick: onToggle,
            disabled: preventOpen,
            sx: {
              display: "flex",
              alignItems: "center",
              fontWeight: "medium",
              px: 0
            },
            children: [
              isOpen ? /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronDownIcon, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronRightIcon, {}),
              isFirst && /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { ml: 1, mr: 1, color: "accent.fg" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PinIcon, { size: 16 }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(
                Text$2,
                {
                  sx: {
                    fontSize: 1,
                    ml: isFirst ? 0 : 1,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "200px",
                    display: "inline-block",
                    verticalAlign: "top"
                  },
                  children: [
                    column2.label,
                    " (",
                    column2.resultColumns.length,
                    ")"
                  ]
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { width: 240 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          ColumnLabelEditor,
          {
            grid: grid2,
            column: column2,
            onUpdateLabel
          }
        ) })
      ] }),
      isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Box,
        {
          sx: {
            pl: 6,
            pt: 1,
            pb: 2,
            display: "flex",
            flexDirection: "column",
            gap: 2
          },
          children: column2.resultColumns.map((subCol) => /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionItemRow, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { flex: 1, minWidth: 0 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Text$2,
              {
                sx: {
                  fontSize: 1,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "200px",
                  display: "inline-block",
                  verticalAlign: "top"
                },
                children: subCol.label
              }
            ) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { width: 240 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              ColumnLabelEditor,
              {
                grid: grid2,
                column: subCol,
                onUpdateLabel
              }
            ) })
          ] }, subCol.key))
        }
      )
    ] });
  }
);
CompoundColumnRow.displayName = "CompoundColumnRow";
const DraggableCompoundColumnRow = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: props.column.key });
  const style3 = {
    transform: CSS$1.Transform.toString(transform),
    transition
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundColumnRow,
    {
      ref: setNodeRef,
      style: style3,
      ...props,
      listeners,
      attributes
    }
  );
};
const SimpleColumnRow = forwardRef$1(
  ({ grid: grid2, column: column2, onUpdateLabel, style: style3, listeners, attributes, isFirst = false }, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionItemRow, { ref: ref2, style: style3, listeners, attributes, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { display: "flex", alignItems: "center", cursor: "grab" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(GrabberIcon, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { sx: { flex: 1, minWidth: 0, display: "flex", alignItems: "center" }, children: [
      isFirst && /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { display: "flex", mr: 2, color: "accent.fg" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PinIcon, { size: 14 }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Text$2,
        {
          sx: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "240px",
            fontSize: 1,
            display: "inline-block",
            verticalAlign: "top"
          },
          children: column2.label
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { width: 240 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      ColumnLabelEditor,
      {
        grid: grid2,
        column: column2,
        onUpdateLabel
      }
    ) })
  ] })
);
SimpleColumnRow.displayName = "SimpleColumnRow";
const DraggableSimpleColumnRow = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: props.column.key });
  const style3 = {
    transform: CSS$1.Transform.toString(transform),
    transition
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SimpleColumnRow,
    {
      ref: setNodeRef,
      style: style3,
      ...props,
      listeners,
      attributes
    }
  );
};
const ColumnsTable = ({ grid: grid2, onChange }) => {
  const [activeColumn, setActiveColumn] = useState(null);
  const [expanded, setExpanded] = useState({});
  const toggleExpand = (key2) => setExpanded((prev2) => ({ ...prev2, [key2]: !prev2[key2] }));
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5
      }
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })
  );
  const handleDragStart = (event) => {
    const draggedColumn = grid2.columns.find(
      (col) => col.key === event.active.id
    );
    setActiveColumn(draggedColumn || null);
  };
  const handleDragEnd = (event) => {
    const { active, over } = event;
    setActiveColumn(null);
    if (over && active.id !== over.id) {
      const oldIndex = grid2.columns.findIndex((col) => col.key === active.id);
      const newIndex = grid2.columns.findIndex((col) => col.key === over.id);
      onChange({ columns: arrayMove(grid2.columns, oldIndex, newIndex) });
    }
  };
  const handleUpdateLabel = (key2, text2) => {
    const newLabels = { ...grid2.labels };
    if (text2 === void 0) {
      delete newLabels[key2];
    } else {
      newLabels[key2] = text2;
    }
    onChange({ labels: newLabels });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DndContext,
    {
      sensors,
      modifiers: [restrictToVerticalAxis],
      collisionDetection: closestCenter,
      onDragStart: handleDragStart,
      onDragEnd: handleDragEnd,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { mb: 4 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Banner2, { variant: "info", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Banner2.Title, { children: "Column editing" }),
          "Drag columns to reorder. The first row (marked with a pin icon) will be a pinned column in the report. You can also override their labels using the inputs on the right."
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          SortableContext,
          {
            items: grid2.columns.filter((col) => !isActionColumn(col)).map((col) => col.key),
            strategy: verticalListSortingStrategy,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { display: "flex", flexDirection: "column", gap: 0 }, children: grid2.columns.filter((column2) => !isActionColumn(column2)).map((column2, index2) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { children: [
                isCompoundColumn(column2) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                  DraggableCompoundColumnRow,
                  {
                    grid: grid2,
                    column: column2,
                    onUpdateLabel: handleUpdateLabel,
                    isOpen: !!expanded[column2.key],
                    onToggle: () => toggleExpand(column2.key),
                    preventOpen: activeColumn !== null,
                    isFirst: index2 === 0
                  }
                ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                  DraggableSimpleColumnRow,
                  {
                    grid: grid2,
                    column: column2,
                    onUpdateLabel: handleUpdateLabel,
                    isFirst: index2 === 0
                  }
                ),
                index2 < grid2.columns.filter((col) => !isActionColumn(col)).length - 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Box,
                  {
                    sx: {
                      height: "1px",
                      bg: "border.muted",
                      width: "100%"
                    }
                  }
                )
              ] }, column2.key)) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(DragOverlay, { children: activeColumn ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                Box,
                {
                  sx: {
                    bg: "canvas.overlay",
                    border: "1px solid",
                    borderColor: "border.default",
                    borderRadius: 2,
                    p: 2,
                    width: "100%"
                  },
                  children: isCompoundColumn(activeColumn) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                    CompoundColumnRow,
                    {
                      grid: grid2,
                      column: activeColumn,
                      onUpdateLabel: handleUpdateLabel,
                      isOpen: !!expanded[activeColumn.key],
                      onToggle: () => {
                      },
                      preventOpen: true,
                      isFirst: false
                    }
                  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                    SimpleColumnRow,
                    {
                      grid: grid2,
                      column: activeColumn,
                      onUpdateLabel: handleUpdateLabel,
                      isFirst: false
                    }
                  )
                }
              ) : null })
            ]
          }
        )
      ] })
    }
  );
};
const isCompoundColumn = (column2) => {
  return "resultColumns" in column2;
};
const isActionColumn = (column2) => {
  return column2.actionButtons === true || column2.key === "action_menu";
};
const CommonButton = forwardRef$1(
  ({ children, ...props }, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    ButtonComponent,
    {
      ref: ref2,
      ...props,
      variant: "default",
      sx: {
        backgroundColor: "accent.emphasis",
        // Primer blue background
        color: "fg.onEmphasis",
        // White text (adaptive)
        border: "1px solid",
        borderColor: "accent.emphasis",
        "&:hover": {
          backgroundColor: "accent.fg",
          // Slightly lighter blue on hover
          color: "fg.onEmphasis",
          borderColor: "accent.fg"
        },
        "&:disabled": {
          backgroundColor: "canvas.subtle",
          color: "fg.muted",
          borderColor: "border.default"
        },
        ...props.sx
        // Allow overriding styles if needed
      },
      children
    }
  )
);
CommonButton.displayName = "CommonButton";
const GridColumnEditor = ({
  grid: initialGrid,
  onSave,
  onUpdate
}) => {
  const [grid2, setGrid] = useState(initialGrid);
  const [isOpen, setIsOpen] = useState(false);
  const save = async () => {
    const result = await onSave(grid2);
    if (result.type === "success") {
      setIsOpen(false);
    }
  };
  const { portalId } = useGridContext();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const portal = document.getElementById(portalId);
    if (portal instanceof HTMLElement) {
      registerPortalRoot(portal);
      setMounted(true);
    }
  }, [portalId]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(CommonButton, { onClick: () => setIsOpen(true), children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { marginRight: 8, display: "inline-block" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ColumnsIcon, { size: 16 }) }),
      "Manage Columns"
    ] }),
    isOpen && mounted && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Dialog,
      {
        position: "right",
        onClose: () => setIsOpen(false),
        title: "Manage Columns",
        renderFooter: () => /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Box,
          {
            sx: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              borderTop: "1px solid",
              borderColor: "border.default"
            },
            py: 4,
            px: 3,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, { variant: "default", onClick: () => setIsOpen(false), children: "Cancel" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { display: "flex", gap: 2 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, { variant: "primary", onClick: save, children: "Save Changes" }) })
            ]
          }
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Box,
          {
            sx: {
              display: "flex",
              flexDirection: "column",
              height: "100%"
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Box,
              {
                as: Dialog.Body,
                sx: {
                  overflow: "auto",
                  flexGrow: 1
                },
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  ColumnsTable,
                  {
                    grid: grid2,
                    onChange: (update2) => setGrid({ ...grid2, ...update2 })
                  }
                )
              }
            )
          }
        )
      }
    )
  ] });
};
function useAvailableHeightWithSelectors(selectors = []) {
  const [height2, setHeight] = useState(null);
  const calculateHeight = () => {
    let usedHeight = 0;
    selectors.forEach((selector2) => {
      const elements = document.querySelectorAll(selector2);
      elements.forEach((el) => {
        if (el) {
          usedHeight += el.getBoundingClientRect().height;
        }
      });
    });
    const newHeight = Math.max(window.innerHeight - usedHeight, 0);
    setHeight(newHeight);
  };
  useLayoutEffect(() => {
    const rafId = requestAnimationFrame(() => {
      calculateHeight();
    });
    return () => {
      cancelAnimationFrame(rafId);
    };
  }, [selectors.join(",")]);
  return height2;
}
function useSoftRerenderOnResize(threshold = 10) {
  const [key2, setKey] = useState(0);
  const lastSize = useRef({ width: window.innerWidth, height: window.innerHeight });
  useLayoutEffect(() => {
    const onResize = () => {
      const width2 = window.innerWidth;
      const height2 = window.innerHeight;
      const dw = Math.abs(width2 - lastSize.current.width);
      const dh = Math.abs(height2 - lastSize.current.height);
      if (dw >= threshold || dh >= threshold) {
        lastSize.current = { width: width2, height: height2 };
        setKey((prev2) => prev2 + 1);
      }
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [threshold]);
  return key2;
}
const TableContainer = ({ children }) => {
  const height2 = useAvailableHeightWithSelectors([".js-measure"]);
  const key2 = useSoftRerenderOnResize();
  if (height2 === null) {
    return null;
  }
  const displayHeight = height2 === 0 ? 400 : height2;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      display: "grid",
      overflow: "auto",
      width: "100%",
      sx: {
        maxHeight: `${displayHeight}px`,
        ".TableOverflowWrapper": {
          overscrollBehavior: "contain",
          gridArea: "auto"
        }
      },
      children
    },
    key2
  );
};
const ActionIcon = memo(function ActionIcon22() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(KebabHorizontalIcon, { "aria-label": "actions" });
});
const RowActions = ({ row }) => {
  const { portalId, rowActions } = useGridContext();
  return rowActions.length === 0 ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionMenu, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Anchor, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconButton,
      {
        "aria-label": "Actions",
        icon: ActionIcon,
        variant: "invisible",
        sx: {
          transform: "rotate(90deg)",
          "&:hover svg": {
            fill: "accent.fg"
          }
        }
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Overlay, { portalContainerName: portalId, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList, { children: rowActions.map((action) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      ActionList.Item,
      {
        onClick: () => action.onClick(row),
        children: action.title
      },
      action.title
    )) }) })
  ] });
};
function MetaCell({ updated }) {
  if (updated && inLast24Hours(updated)) {
    const formattedDate = hooks(updated).format("ddd MMM D kk:mm:ss Z");
    const tooltipText = `Updated ${formattedDate}`;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Cell, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { text: tooltipText, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconButton,
      {
        icon: DotFillIcon,
        size: "small",
        variant: "invisible",
        sx: {
          color: "accent.fg",
          // Primer's blue color token
          "&:hover": {
            backgroundColor: "accent.subtle"
          }
        },
        "aria-label": "Updated Status Indicator"
      }
    ) }) });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Cell, {});
  }
}
const KeyHolder = ({ children }) => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children });
const DataRow = ({
  columns,
  row,
  renderCell,
  showMetaCell = true,
  showActions = true,
  actionCellRenderer = "menu"
}) => {
  const updated = rowUpdatedAt(row);
  const classes2 = classNames({
    "data-row": true,
    "updated-row": inLast24Hours(updated)
  });
  const render = (column2) => {
    var _a3;
    if (typeof renderCell === "function") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(KeyHolder, { children: renderCell({ row, column: column2 }) }, column2.key);
    }
    if (column2.key === "action_menu" && ((_a3 = row.action_menu) == null ? void 0 : _a3.buttons)) {
      if (actionCellRenderer === "buttons") {
        const formattedButtons = row.action_menu.buttons.map((button, index2) => ({
          type: "action",
          key: button.text || `button-${index2}`,
          // Generate key if not present
          text: button.text,
          onClick: button.onClick || (() => console.warn(`No onClick handler for button: ${button.text}`))
        }));
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Cell, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonCell, { buttons: formattedButtons }) }, column2.key);
      } else {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Cell, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenuCellAdapter, { buttons: row.action_menu.buttons }) }, column2.key);
      }
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(CellRenderer, { column: column2, row }, column2.key);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$1.Row, { className: classes2, children: [
    showMetaCell && /* @__PURE__ */ jsxRuntimeExports.jsx(MetaCell, { updated: rowUpdatedAt(row) }, "_meta"),
    columns.map(render),
    showActions && /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Cell, { scope: "row", children: /* @__PURE__ */ jsxRuntimeExports.jsx(RowActions, { row }) })
  ] });
};
const Input = styled(TextInput$1)`
  min-width: 150px;
  padding-left: 6px;
  && > input {
    border: none;
    margin: inherit;
    padding: inherit;
    padding-left: 0;

    :focus {
      box-shadow: none;
    }
  }
`;
const Search = () => /* @__PURE__ */ jsxRuntimeExports.jsx(SearchIcon, { "aria-label": "Search" });
const FilterCell = ({
  name: name2,
  value,
  onChange,
  placeholder: placeholder2 = ""
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Header, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1.Label, { visuallyHidden: true, children: [
      "Filter ",
      name2
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Input,
      {
        block: true,
        placeholder: placeholder2,
        leadingVisual: Search,
        size: "medium",
        autoComplete: "off",
        autoCorrect: "off",
        autoCapitalize: "off",
        spellCheck: "false",
        value: value || "",
        onChange: (e) => onChange(name2, e.target.value)
      }
    )
  ] }) });
};
const FilterPopover = ({
  children,
  onClear,
  onCancel,
  onSave
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    SelectPanel,
    {
      title: "",
      onSubmit: onSave,
      onCancel,
      onClearSelection: onClear,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          SelectPanel.Button,
          {
            leadingVisual: FilterIcon,
            size: "medium",
            block: true,
            sx: {
              backgroundColor: "canvas.default",
              "&:hover": {
                backgroundColor: "neutral.subtle"
              }
            }
          }
        ),
        children,
        /* @__PURE__ */ jsxRuntimeExports.jsx(SelectPanel.Footer, {})
      ]
    }
  );
};
const GridFilter = ({ children, ...props }) => {
  const childCount = React__default.Children.count(children);
  const gap = childCount > 1 ? 2 : 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { display: "flex", width: "100%", alignItems: "center", sx: { gap }, ...props, children });
};
const GridFilterStatus = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { maxWidth: "calc(13.75rem - 40px)", lineHeight: 1.1 }, ...props });
const GridFilterBadge = ({
  children,
  ...props
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { ...props, children }) });
const BooleanBadges = ({
  selectedValue
}) => {
  if (selectedValue === void 0) return null;
  if (selectedValue) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterBadge, { children: "Yes" });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterBadge, { children: "No" });
  }
};
const BooleanFilterForm = ({
  selectedValue,
  onChange
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { display: "flex", flexDirection: "column", p: 2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Yes" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox$1,
      {
        checked: selectedValue === true,
        onChange: () => onChange(selectedValue === true ? void 0 : true)
      }
    )
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "No" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox$1,
      {
        checked: selectedValue === false,
        onChange: () => onChange(selectedValue === false ? void 0 : false)
      }
    )
  ] })
] });
const BooleanFilter = ({
  onChange,
  selectedValue: initialValue
}) => {
  const [selectedValue, setSelectedValue] = useState(
    initialValue
  );
  const hasBadge = initialValue !== void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridFilter, { position: "relative", children: [
    hasBadge && /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterStatus, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BooleanBadges, { selectedValue: initialValue }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FilterPopover,
      {
        onClear: () => {
          setSelectedValue(void 0);
        },
        onCancel: () => setSelectedValue(initialValue),
        onSave: () => onChange(selectedValue),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          BooleanFilterForm,
          {
            onChange: setSelectedValue,
            selectedValue
          }
        )
      }
    )
  ] });
};
const ChoiceFilter = ({
  choices,
  selectedChoices,
  allowNullSelection,
  onChange
}) => {
  const [selected, setSelected] = useState(
    () => new Set(selectedChoices || [])
  );
  useEffect(() => {
    setSelected(new Set(selectedChoices || []));
  }, [selectedChoices]);
  const handleSelect = (value) => {
    const newSelected = new Set(selected);
    if (newSelected.has(value)) {
      newSelected.delete(value);
    } else {
      newSelected.add(value);
    }
    setSelected(newSelected);
  };
  const cancel = () => setSelected(new Set(selectedChoices || []));
  const clear = () => setSelected(/* @__PURE__ */ new Set());
  const submit = () => {
    if (selected.size === 0 && allowNullSelection) {
      onChange(void 0);
    } else {
      onChange(Array.from(selected));
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilter, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    SelectPanel,
    {
      title: "",
      onSubmit: submit,
      onCancel: cancel,
      onClearSelection: clear,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          SelectPanel.Button,
          {
            leadingVisual: FilterIcon,
            count: selectedChoices == null ? void 0 : selectedChoices.length,
            size: "medium",
            block: true,
            sx: {
              backgroundColor: "canvas.default",
              "&:hover": {
                backgroundColor: "neutral.subtle"
              }
            }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList, { children: choices.map((choice) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          ActionList.Item,
          {
            onSelect: () => handleSelect(choice.value),
            selected: selected.has(choice.value),
            children: choice.label
          },
          choice.value
        )) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(SelectPanel.Footer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SelectPanel.SecondaryAction, { variant: "checkbox", children: "Include blanks" }) })
      ]
    }
  ) });
};
const formatNumber = (value, precision = 2) => {
  return value.toFixed(precision).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
const PriceInput = ({
  id,
  valueInCents,
  defaultValue: defaultValue2,
  currency = "$",
  precision = 2,
  onChange,
  inputFieldProps = {}
}) => {
  const { theme: theme2 } = useTheme();
  const [value, setValue] = useState(
    defaultValue2 !== void 0 ? (defaultValue2 / 100).toString() : ""
  );
  const [isFocused, setIsFocused] = useState(false);
  useEffect(() => {
    if (valueInCents !== null && valueInCents !== void 0) {
      const clean7 = (valueInCents / 100).toString();
      if (value !== clean7) setValue(clean7);
    }
  }, [valueInCents]);
  const handleChange = (e) => {
    const raw = e.target.value;
    if (!/^[\d,]*\.?\d*$/.test(raw)) return;
    setValue(raw);
    const numeric2 = parseFloat(raw.replace(/,/g, ""));
    if (!isNaN(numeric2)) {
      onChange(numberToCents(numeric2));
    } else {
      onChange(void 0);
    }
  };
  const handleFocus = (e) => {
    setIsFocused(true);
    if (inputFieldProps.onFocus) {
      inputFieldProps.onFocus(e);
    }
  };
  const handleBlur = (e) => {
    setIsFocused(false);
    if (inputFieldProps.onBlur) {
      inputFieldProps.onBlur(e);
    }
    const numeric2 = parseFloat(value.replace(/,/g, ""));
    if (!isNaN(numeric2)) {
      setValue(formatNumber(numeric2, precision));
    }
  };
  const { size: size2, ...restInputFieldProps } = inputFieldProps;
  const textInputSize = typeof size2 === "string" ? size2 : void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TextInput$1,
    {
      id,
      type: "text",
      inputMode: "decimal",
      value,
      onChange: handleChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      leadingVisual: () => /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: {
        fontWeight: isFocused ? 600 : 400,
        transition: "color 0.2s ease, font-weight 0.2s ease"
      }, children: currency }),
      maxLength: 20,
      placeholder: "0.00",
      sx: {
        width: "100%",
        "&:focus-within": theme2 && theme2.colors && theme2.colors.accent && theme2.colors.accent.emphasis ? { boxShadow: `0 0 0 2px ${theme2.colors.accent.emphasis}` } : {}
      },
      size: textInputSize,
      ...restInputFieldProps
    }
  );
};
const CurrencyFilterForm = ({
  column: column2,
  filter,
  onChange
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { py: 3, px: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "vertical", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Min" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PriceInput,
      {
        currency: column2.currency,
        valueInCents: filter == null ? void 0 : filter.min,
        onChange: (min2) => onChange({ ...filter, min: min2 })
      }
    )
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Max" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PriceInput,
      {
        currency: column2.currency,
        valueInCents: filter == null ? void 0 : filter.max,
        onChange: (max2) => onChange({ ...filter, max: max2 })
      }
    )
  ] })
] }) });
const CurrencyFilterBadges = ({
  column: column2,
  filter
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  (filter == null ? void 0 : filter.min) !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(Label, { size: "small", children: [
    "Min: ",
    priceWithSymbol({ currency: column2.currency, price: filter.min })
  ] }, "min"),
  " ",
  (filter == null ? void 0 : filter.max) !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(Label, { size: "small", children: [
    "Max: ",
    priceWithSymbol({ currency: column2.currency, price: filter.max })
  ] }, "max")
] });
const CurrencyFilter = ({
  column: column2,
  filter: initialFilter,
  onChange
}) => {
  const [filter, setFilter] = useState(
    initialFilter
  );
  useEffect(() => {
    setFilter(initialFilter);
  }, [initialFilter]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridFilter, { position: "relative", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterStatus, { children: isFilterDefined(filter) && /* @__PURE__ */ jsxRuntimeExports.jsx(CurrencyFilterBadges, { column: column2, filter }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FilterPopover,
      {
        onClear: () => {
          setFilter(void 0);
          onChange(void 0);
        },
        onCancel: () => setFilter(initialFilter),
        onSave: () => onChange(filter),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          CurrencyFilterForm,
          {
            column: column2,
            filter,
            onChange: setFilter
          }
        )
      }
    )
  ] });
};
const filterDateToString = (d2) => {
  try {
    const value = formatISODate(parseDateOrString(d2)) ?? "";
    return value;
  } catch {
    return "";
  }
};
const DateRangeNative = ({
  filter,
  onChange
}) => {
  const [startDate, setStartDate] = useState(filterDateToString(filter == null ? void 0 : filter.min));
  const [endDate, setEndDate] = useState(filterDateToString(filter == null ? void 0 : filter.max));
  useEffect(() => {
    const filter2 = parsedDateFilter({
      min: startDate,
      max: endDate
    });
    if (!isValid$6(filter2.min)) filter2.min = void 0;
    if (!isValid$6(filter2.max)) filter2.max = void 0;
    onChange(filter2);
  }, [startDate, endDate, onChange]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "vertical", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Start Date" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextInput$1,
        {
          block: true,
          type: "date",
          value: startDate,
          onChange: (e) => setStartDate(e.target.value)
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "End Date" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextInput$1,
        {
          block: true,
          type: "date",
          value: endDate,
          onChange: (e) => setEndDate(e.target.value)
        }
      )
    ] })
  ] });
};
const initFilter = (filter) => filter !== void 0 ? parsedDateFilter(filter) : void 0;
const AnchorButton = forwardRef$1(
  (props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, { ...props, ref: ref2, size: "small", leadingVisual: FilterIcon })
);
AnchorButton.displayName = "AnchorButton";
const DateFilter = ({
  filter: initialFilter,
  onChange
}) => {
  const [filter, setFilter] = useState(
    initFilter(initialFilter)
  );
  const clear = () => setFilter({ min: void 0, max: void 0 });
  const cancel = () => {
    setFilter(initFilter(initialFilter));
    onChange(filter);
  };
  const save = () => {
    setFilter(initFilter(filter));
    onChange(filter);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilter, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    FilterPopover,
    {
      onSave: save,
      onCancel: cancel,
      onClear: clear,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Box,
        {
          p: 3,
          sx: {
            display: "flex",
            flexDirection: "column",
            flex: 1,
            height: "100%",
            justifyContent: "space-between"
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(DateRangeNative, { filter, onChange: setFilter })
        }
      )
    }
  ) });
};
const DateFilterBadges = ({ filter }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  (filter == null ? void 0 : filter.min) !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(Label, { size: "small", children: [
    "From: ",
    filter.min.toLocaleDateString()
  ] }, "min"),
  " ",
  (filter == null ? void 0 : filter.max) !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(Label, { size: "small", children: [
    "To: ",
    filter.max.toLocaleDateString()
  ] }, "max")
] });
const NumberFilterBadges = ({
  filter: { min: min2 = void 0, max: max2 = void 0 }
}) => {
  if (min2 !== void 0 && max2 !== void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Label, { size: "small", children: [
      min2,
      " – ",
      max2
    ] });
  }
  if (min2 !== void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Label, { size: "small", children: [
      "≥ ",
      min2
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Label, { size: "small", children: [
    "≤ ",
    max2
  ] });
};
const LockedFilter = ({ filter }) => {
  if (isDateFilter(filter)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(DateFilterBadges, { filter: parsedDateFilter(filter) });
  }
  if (isNumberFilter(filter)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(NumberFilterBadges, { filter });
  }
  if (Array.isArray(filter)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: filter.map((value) => /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterBadge, { children: value }, value.toString())) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterBadge, { children: filter });
};
const maybeNumber = (value) => value !== void 0 && value.trim() !== "" ? Number.parseFloat(value) : void 0;
const NumberFilterForm = ({
  filter,
  onChange
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { direction: "vertical", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Min" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextInput$1,
      {
        type: "number",
        block: true,
        value: (filter == null ? void 0 : filter.min) ?? "",
        onChange: (e) => {
          onChange({
            ...filter,
            min: maybeNumber(e.target.value)
          });
        }
      }
    )
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: "Max" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextInput$1,
      {
        type: "number",
        block: true,
        value: (filter == null ? void 0 : filter.max) ?? "",
        onChange: (e) => onChange({
          ...filter,
          max: maybeNumber(e.target.value)
        })
      }
    )
  ] })
] });
const NumberFilter = ({
  filter: initialFilter,
  onChange
}) => {
  const [filter, setFilter] = useState(
    initialFilter
  );
  useEffect(() => {
    setFilter(initialFilter);
  }, [initialFilter]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridFilter, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterStatus, { children: isFilterDefined(initialFilter) && /* @__PURE__ */ jsxRuntimeExports.jsx(NumberFilterBadges, { filter: initialFilter }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FilterPopover,
      {
        onClear: () => {
          setFilter(void 0);
          onChange(void 0);
        },
        onCancel: () => setFilter(initialFilter),
        onSave: () => onChange(filter),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Box,
          {
            p: 3,
            sx: {
              display: "flex",
              flexDirection: "column",
              flex: 1,
              height: "100%",
              justifyContent: "space-between"
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(NumberFilterForm, { filter, onChange: setFilter })
          }
        )
      }
    )
  ] });
};
const findChoice = (value, choices) => choices.find((c2) => c2.value === value);
const ChoiceBadges = ({
  choices,
  selectedChoices
}) => {
  if (selectedChoices === void 0) return null;
  if (selectedChoices.length === 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterBadge, { children: "None" });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: selectedChoices.map((choiceValue) => {
    const choice = findChoice(choiceValue, choices);
    if (choice === void 0) {
      return null;
    } else {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterBadge, { children: choice.label }, choice.value);
    }
  }) });
};
const SingleChoiceFilterForm = ({
  choices,
  selectedChoice,
  onChange
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { display: "flex", flexDirection: "column", children: choices.map((choice) => /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormControl$1.Label, { children: choice.label }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox$1,
      {
        value: choice.value.toString(),
        checked: (selectedChoice == null ? void 0 : selectedChoice.toString()) === choice.value.toString(),
        onChange: (e) => onChange(e.target.checked ? choice.value : void 0)
      }
    )
  ] }, choice.label)) }) });
};
const SingleChoiceFilter = ({
  choices,
  selectedChoice: initialSelectedChoice,
  onChange
}) => {
  const [selectedChoice, setSelectedChoice] = useState(initialSelectedChoice);
  useEffect(() => {
    if (!isEqual6(selectedChoice, initialSelectedChoice)) {
      setSelectedChoice(initialSelectedChoice);
    }
  }, [initialSelectedChoice]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridFilter, { position: "relative", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterStatus, { children: selectedChoice !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(ChoiceBadges, { choices, selectedChoices: [selectedChoice] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FilterPopover,
      {
        onClear: () => {
          setSelectedChoice(void 0);
          onChange(void 0);
        },
        onCancel: () => setSelectedChoice(initialSelectedChoice),
        onSave: () => onChange(selectedChoice),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          SingleChoiceFilterForm,
          {
            choices,
            selectedChoice,
            onChange: setSelectedChoice
          }
        )
      }
    )
  ] });
};
const FilterRow = ({
  grid: grid2,
  onFilter,
  placeholder: placeholder2 = void 0,
  showActions = true,
  showMetaCell = true
}) => {
  const handleFilterChange = (name2, value) => {
    if (value === void 0) {
      const newFilters = { ...grid2.filters };
      delete newFilters[name2];
      onFilter(newFilters);
    } else {
      const update2 = {
        [name2]: value
      };
      onFilter({ ...grid2.filters, ...update2 });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$1.Row, { children: [
    showMetaCell && /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Header, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, { children: "Meta" }) }),
    getResultColumns(grid2.columns).map((column2) => {
      var _a3, _b, _c, _d, _e2, _f, _g, _h;
      if (column2.noFilter) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Header, { className: "noFilter" }, column2.key);
      }
      if (isLockedFilter(grid2, column2)) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Header, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          LockedFilter,
          {
            filter: (_a3 = grid2 == null ? void 0 : grid2.fixedFilters) == null ? void 0 : _a3[column2.key]
          }
        ) }, column2.key);
      }
      if (column2.type === "date") {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Header, { className: "dateFilter", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          DateFilter,
          {
            column: column2,
            filter: (_b = grid2 == null ? void 0 : grid2.filters) == null ? void 0 : _b[column2.key],
            onChange: (filterValue2) => handleFilterChange(column2.key, filterValue2)
          }
        ) }, column2.key);
      }
      if (column2.choices !== void 0) {
        if (column2.singleChoiceFilter) {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Header, { className: "choiceFilter", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            SingleChoiceFilter,
            {
              choices: column2.choices,
              selectedChoice: (_c = grid2 == null ? void 0 : grid2.filters) == null ? void 0 : _c[column2.key],
              onChange: (selectedChoiceValue) => handleFilterChange(column2.key, selectedChoiceValue)
            }
          ) }, column2.key);
        }
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Header, { className: "choiceFilter", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          ChoiceFilter,
          {
            choices: column2.choices,
            selectedChoices: (_d = grid2 == null ? void 0 : grid2.filters) == null ? void 0 : _d[column2.key],
            allowNullSelection: (column2 == null ? void 0 : column2.allowNullFilter) === void 0 || (column2 == null ? void 0 : column2.allowNullFilter) === true,
            onChange: (selectedChoiceValues) => handleFilterChange(column2.key, selectedChoiceValues)
          }
        ) }, column2.key);
      }
      if (column2.type === "integer") {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Header, { className: "choiceFilter", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          NumberFilter,
          {
            column: column2,
            filter: (_e2 = grid2 == null ? void 0 : grid2.filters) == null ? void 0 : _e2[column2.key],
            onChange: (filterValue2) => handleFilterChange(column2.key, filterValue2)
          }
        ) }, column2.key);
      }
      if (column2.type === "currency") {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Header, { className: "choiceFilter", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          CurrencyFilter,
          {
            column: column2,
            filter: (_f = grid2 == null ? void 0 : grid2.filters) == null ? void 0 : _f[column2.key],
            onChange: (filterValue2) => handleFilterChange(column2.key, filterValue2)
          }
        ) }, column2.key);
      }
      if (column2.type === "boolean") {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Header, { className: "booleanFilter", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          BooleanFilter,
          {
            selectedValue: (_g = grid2 == null ? void 0 : grid2.filters) == null ? void 0 : _g[column2.key],
            onChange: (filterValue2) => handleFilterChange(column2.key, filterValue2)
          }
        ) }, column2.key);
      }
      const value = (_h = grid2 == null ? void 0 : grid2.filters) == null ? void 0 : _h[column2.key];
      if (value !== void 0 && typeof value !== "string" && typeof value !== "number") {
        return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { background: "red" }, children: "Error - value is the wrong type" }, column2.key);
      }
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        FilterCell,
        {
          name: column2.key,
          value,
          onChange: handleFilterChange,
          placeholder: placeholder2
        },
        column2.key
      );
    }),
    showActions && /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Header, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, { children: "Actions" }) })
  ] });
};
const HeaderRow = ({
  columns,
  onSort,
  sort: sort3,
  showActions = true,
  showMetaCell = true
}) => {
  const handleClick2 = (column2) => {
    if (column2.noSort) return;
    const newSort = { column: column2.key, order: "asc" };
    if (sort3 && sort3.column === column2.key && sort3.order === "asc") {
      newSort.order = "desc";
    } else {
      newSort.order = "asc";
    }
    onSort(newSort);
  };
  const renderSortIcon = (column2) => {
    if (!sort3 || sort3.column !== column2.key) return null;
    return sort3.order === "asc" ? /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowUpIcon, { size: 14 }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowDownIcon, { size: 14 });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$1.Row, { children: [
    showMetaCell && /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Header, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, { children: "Meta" }) }),
    columns.map((column2) => {
      const isSortable = !column2.noSort;
      const isSorted = (sort3 == null ? void 0 : sort3.column) === column2.key;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Table$1.Header,
        {
          onClick: () => handleClick2(column2),
          title: column2.label,
          align: column2.type === "integer" || column2.type === "currency" ? "end" : "start",
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
            Box,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                gap: 2,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                py: 2,
                fontWeight: isSorted ? 600 : 500,
                cursor: isSortable ? "pointer" : "default",
                color: "fg.default",
                justifyContent: column2.type === "integer" || column2.type === "currency" ? "flex-end" : "flex-start",
                "&:hover": isSortable ? {
                  color: "fg.muted"
                } : void 0
              },
              children: [
                column2.label,
                renderSortIcon(column2)
              ]
            }
          )
        },
        column2.key
      );
    }),
    showActions && /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Header, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, { children: "Actions" }) })
  ] });
};
const useColumnTotal = (props) => {
  const [results, setResults] = useState({
    type: "loading"
  });
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    let isSubscribed = true;
    const abortController = new AbortController();
    setIsLoading(true);
    const fetchResult = async () => {
      const newResult = await props.loader.loadTotal(
        {
          column: props.column,
          filters: props.grid.filters
        },
        abortController.signal
      );
      if (isSubscribed) {
        setResults(newResult);
        setIsLoading(false);
      }
    };
    fetchResult().catch(console.error);
    return () => {
      abortController.abort();
      isSubscribed = false;
    };
  }, [props.grid]);
  return {
    results,
    isLoading
  };
};
const ColumnTotal = (props) => {
  const { results, isLoading } = useColumnTotal(props);
  if (results.type === "loading" || isLoading) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Loading..." });
  }
  if (results.type === "error") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Error..." });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      sx: { display: "flex", flexDirection: "column", alignItems: "flex-end" },
      children: results.totals.map((total) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Text$2,
        {
          textAlign: "right",
          fontSize: "12px",
          sx: { display: "flex", gap: 1 },
          children: [
            total.label,
            ": ",
            /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: `${total.value}` })
          ]
        },
        total.label
      ))
    }
  );
};
const TotalsLoaderRow = ({
  grid: grid2,
  loader,
  onAddToGrid,
  showActions = true,
  showMetaCell = true
}) => {
  const resultColumns = getResultColumns(grid2.columns);
  const hasTotals = resultColumns.some(
    (column2) => (column2 == null ? void 0 : column2.gridTotals) || (column2 == null ? void 0 : column2.simpleTotal)
  );
  if (!hasTotals) return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$1.Row, { className: "totals", children: [
    showMetaCell && /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Cell, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, { children: "Meta" }) }),
    resultColumns.map((column2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Cell, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Box,
      {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        flex: 1,
        sx: { gap: 5 },
        children: [
          (column2 == null ? void 0 : column2.gridTotals) && /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              icon: TabExternalIcon,
              "aria-label": "View breakdown",
              size: "medium",
              variant: "default",
              onClick: () => onAddToGrid(column2)
            }
          ),
          (column2 == null ? void 0 : column2.simpleTotal) && /* @__PURE__ */ jsxRuntimeExports.jsx(ColumnTotal, { grid: grid2, column: column2, loader })
        ]
      }
    ) }, column2.key)),
    showActions && /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Cell, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden$1, { children: "Actions" }) })
  ] });
};
const StyledTable = styled(Table$1)`
  margin-bottom: 0;
  font-size: 13px;

  .TableHead .TableRow:first-of-type .TableHeader:first-child {
    border-top-left-radius: 0 !important;
    padding-left: 36px !important;
  }

  .TableHead .TableRow:first-of-type .TableHeader:last-child {
    border-top-right-radius: 0 !important;
  }

  .TableCell:first-child,
  .TableHeader:first-child {
    border-left: 0;
    padding-left: 36px !important;
  }

  .TableCell:last-child,
  .TableHeader:last-child {
    border-right: 0;
  }

  th,
  td {
    white-space: nowrap;

    :first-child {
      position: sticky;
      left: 0;
      border-right: 2px solid #d0d7de !important;
      z-index: 2;
      font-weight: 600;
    }

    :last-child {
      position: sticky;
      right: 0;
      border-left: 2px solid #d0d7de !important;
      z-index: 2;
    }

    :not(:nth-last-child(2)) {
      border-right: 1px solid #d0d7de;
    }
  }

  /* When MetaCell is present, make first two columns sticky */
  &.with-meta-cell {
    th,
    td {
      :first-child {
        position: sticky;
        left: 0;
        min-width: 48px;
        border-right: 0px !important;
        z-index: 2;
        padding-left: 12px !important;
        text-align: center;
      }

      :nth-child(2) {
        position: sticky;
        left: 48px;
        border-right: 2px solid #d0d7de !important;
        z-index: 2;
        font-weight: 600;
      }
    }
  }

  thead {
    position: sticky;
    top: 0;
    z-index: 3;
    background-color: #FAFBFCE6 !important;


    &:hover {
      background-color: #FAFBFC !important;
    }

    th {
      background-color: #FAFBFCE6 !important;
      backdrop-filter: blur(6px);
    }


    tr:last-child th {
      border-top: none;
    }

    tr:not(:last-child) th {
      border-bottom: none;
    }
  }

  tbody {
    th,
    td {
      background-color: #ffffff;
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }

    tr {
      &:hover {
        th,
        td {
          background-color: #f6f8fa !important;
        }
      }
    }
  }

  tfoot {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: -1 / 1;
    position: sticky;
    bottom: 0;
    z-index: 2;
    background-color: #FAFBFCE6 !important;


    &:hover {
      background-color: #FAFBFC !important;
    }

    tr {
      border-top: 1px solid #d0d7de;
    }

    td {
      background-color: #FAFBFCE6 !important;
      backdrop-filter: blur(6px);
    }
    :first-child {
      border-bottom-left-radius: var(--table-border-radius);
    }

    :last-child {
      border-bottom-right-radius: var(--table-border-radius);
    }
  }
`;
const PaginatedTable = ({
  grid: grid2,
  result,
  loader,
  tableClasses,
  renderCell,
  onFilterChange,
  onSortChange,
  onLoadTotal,
  showActions = true,
  showMetaCell = true,
  actionCellRenderer = "menu"
}) => {
  const rows = filterItems({
    columns: grid2.columns,
    items: result.rows,
    filters: grid2.filters
  });
  const columns = labelledResultColumns(grid2);
  const gridTemplate = `repeat(${columns.length + (showActions ? 1 : 0) + (showMetaCell ? 1 : 0)}, auto)`;
  const tableClassName = `${tableClasses || ""} ${showMetaCell ? "with-meta-cell" : ""}`.trim();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TableContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledTable, { className: tableClassName, gridTemplateColumns: gridTemplate, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$1.Head, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        HeaderRow,
        {
          columns,
          sort: grid2.sort,
          onSort: onSortChange,
          showActions,
          showMetaCell
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        FilterRow,
        {
          grid: grid2,
          onFilter: onFilterChange,
          showActions,
          showMetaCell
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Body, { children: rows.map((row) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      DataRow,
      {
        columns,
        row,
        renderCell,
        showActions,
        showMetaCell,
        actionCellRenderer
      },
      row.id
    )) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("tfoot", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      TotalsLoaderRow,
      {
        loader,
        grid: grid2,
        onAddToGrid: onLoadTotal,
        showActions,
        showMetaCell
      }
    ) })
  ] }) });
};
const GridTab = ({
  isActive: isActive2,
  selectTab,
  children,
  onClose
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      as: "button",
      type: "button",
      onClick: selectTab,
      position: "relative",
      sx: {
        all: "unset",
        display: "flex",
        alignItems: "center",
        gap: 2,
        fontWeight: isActive2 ? "bold" : "normal",
        fontSize: 1,
        color: isActive2 ? "fg.default" : "fg.muted",
        px: 3,
        py: 2,
        cursor: "pointer",
        borderBottom: "2px solid",
        borderColor: isActive2 ? "accent.emphasis" : "transparent",
        "&:hover": {
          color: "fg.default"
        },
        maxWidth: 400
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Text$2,
          {
            as: "span",
            sx: {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: 200
            },
            children
          }
        ),
        onClose && /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconButton,
          {
            icon: XIcon,
            "aria-label": "Close tab",
            size: "small",
            variant: "invisible",
            onClick: (e) => {
              e.stopPropagation();
              onClose();
            },
            sx: {
              flexShrink: 0
            }
          }
        )
      ]
    }
  );
};
GridTab.displayName = "GridTab";
const LoadingAnimation = ({
  rows = 12,
  columns = 6,
  skeletonHeight = "20px",
  skeletonGap = 3,
  skeletonMarginBottom = 3,
  showSpinner = true,
  containerWidth = "98%",
  marginTop = 6
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      gap: 4,
      mt: marginTop,
      children: [
        showSpinner && /* @__PURE__ */ jsxRuntimeExports.jsx(
          StyledSpinner,
          {
            sx: {
              color: "accent.fg",
              "@keyframes spin": {
                to: { transform: "rotate(360deg)" }
              },
              animation: "spin 0.6s linear infinite"
            }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { width: containerWidth, mt: 4 }, children: [...Array(rows)].map((_2, rowIndex) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          Box,
          {
            sx: {
              display: "flex",
              gap: skeletonGap,
              mb: skeletonMarginBottom
            },
            children: [...Array(columns)].map((__, colIndex) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              Box,
              {
                sx: {
                  flex: 1,
                  height: skeletonHeight,
                  bg: "rgba(0, 0, 0, 0.1)",
                  borderRadius: 2,
                  "@keyframes pulse": {
                    "0%": { opacity: 0.3 },
                    "50%": { opacity: 0.7 },
                    "100%": { opacity: 0.3 }
                  },
                  animation: "pulse 1.5s ease-in-out infinite"
                }
              },
              colIndex
            ))
          },
          rowIndex
        )) })
      ]
    }
  );
};
const PER_PAGE_OPTIONS = [10, 20, 50, 100, 200];
const pageRange = (perPage, totalResults) => {
  const pageCount = Math.ceil(totalResults / perPage);
  return Array.from({ length: pageCount }, (x2, i) => i + 1);
};
const Pager = ({
  perPage,
  totalResults,
  currentPage,
  isDisabled = false,
  onSelectPage,
  onSelectPerPage
}) => {
  const pages = pageRange(perPage, totalResults);
  const totalPages = pages.length;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      sx: { gap: 3 },
      children: [
        onSelectPerPage !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Box,
          {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            sx: { gap: 2, mr: 4 },
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { fontSize: 0, children: "Per page" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Select$1,
                {
                  value: perPage.toString(),
                  onChange: (e) => onSelectPerPage(Number(e.target.value)),
                  size: "small",
                  disabled: isDisabled,
                  children: PER_PAGE_OPTIONS.map((option) => /* @__PURE__ */ jsxRuntimeExports.jsx(Select$1.Option, { value: option.toString(), children: option }, option))
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { display: "flex", alignItems: "center", sx: { gap: 1 }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              "aria-label": "Go to first page",
              icon: MoveToStartIcon,
              size: "small",
              disabled: isDisabled || currentPage === 1,
              onClick: () => onSelectPage(1)
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              "aria-label": "Go to previous page",
              icon: ArrowLeftIcon,
              size: "small",
              disabled: isDisabled || currentPage === 1,
              onClick: () => onSelectPage(currentPage - 1)
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$2, { fontSize: 0, sx: { mx: 2 }, children: [
            "Page ",
            currentPage,
            " of ",
            totalPages
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              "aria-label": "Go to next page",
              icon: ArrowRightIcon,
              size: "small",
              disabled: isDisabled || currentPage === totalPages,
              onClick: () => onSelectPage(currentPage + 1)
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            IconButton,
            {
              "aria-label": "Go to last page",
              icon: MoveToEndIcon,
              size: "small",
              disabled: isDisabled || currentPage === totalPages,
              onClick: () => onSelectPage(totalPages)
            }
          )
        ] })
      ]
    }
  );
};
const firstItem = (page, perPage) => (page - 1) * perPage + 1;
const lastItem = (page, perPage, totalResults) => Math.min(page * perPage, totalResults);
const ResultSummary = ({
  isLoading,
  results,
  page,
  perPage
}) => {
  if (isLoading || results.type !== "success") {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 2 }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { sx: { fontSize: 0 }, children: "Loading results" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinner, {})
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$2, { sx: { fontSize: 0 }, children: [
    "Displaying ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: firstItem(page, perPage) }),
    " -",
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: lastItem(page, perPage, results.totalResults) }),
    " of",
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: results.totalResults })
  ] });
};
function TotalCell({ total }) {
  if (!Number.isFinite(total)) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Cell, { style: { justifyContent: "flex-end" } });
  }
  if (total === 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Cell, { style: { justifyContent: "flex-end" }, children: "0" });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Cell, { style: { justifyContent: "flex-end" }, className: "total", children: total });
}
function BooleanTotalCell({
  rows,
  column: column2
}) {
  const total = rows.reduce((sum, row) => {
    const value = logicalValue({ column: column2, item: row });
    if (value) {
      return sum + 1;
    } else {
      return sum;
    }
  }, 0);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TotalCell, { total });
}
function talliedChoices$1({ rows, column: column2 }) {
  var _a3;
  return (_a3 = column2 == null ? void 0 : column2.choices) == null ? void 0 : _a3.map((choice) => {
    return {
      key: choice.value,
      label: choice.label,
      value: rows.reduce((sum, row) => {
        if (choiceSelected({ item: row, column: column2, choice })) {
          return sum + 1;
        } else {
          return sum;
        }
      }, 0)
    };
  });
}
function ChoicesTotalCell({
  rows,
  column: column2
}) {
  const tallied = talliedChoices$1({ rows, column: column2 }) || [];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Cell, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { display: "flex", flexDirection: "column" }, children: tallied.map(({ key: key2, label, value }) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Box,
      {
        as: "dl",
        sx: {
          display: "flex",
          paddingY: 2,
          justifyContent: "space-between",
          borderBottom: "1px solid",
          borderColor: "border.default"
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { as: "dt", children: label }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { as: "dd", children: value })
        ]
      },
      key2
    );
  }) }) });
}
function CurrencyTotalCell({
  rows,
  column: column2
}) {
  const total = rows.reduce((sum, row) => {
    const value = logicalValue({ column: column2, item: row });
    if (Number.isFinite(value)) {
      return sum + value;
    } else {
      return sum;
    }
  }, 0);
  const formattedTotal = priceWithSymbol({
    currency: column2.currency || "",
    price: total
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Cell, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { marginLeft: "auto" }, children: formattedTotal }) });
}
function IntegerTotalCell({ rows, column: column2 }) {
  const total = rows.reduce((sum, row) => {
    const value = logicalValue({ column: column2, item: row });
    if (Number.isFinite(value)) {
      return sum + value;
    } else {
      return sum;
    }
  }, 0);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TotalCell, { total });
}
function talliedChoices({ rows, column: column2 }) {
  var _a3;
  return (_a3 = column2.choices) == null ? void 0 : _a3.map((choice) => {
    return {
      value: choice.value,
      label: choice.label,
      count: rows.reduce((count2, row) => {
        if (logicalValue({ item: row, column: column2 }) === choice.value) {
          return count2 + 1;
        } else {
          return count2;
        }
      }, 0),
      sum: rows.reduce((sum, row) => {
        if (logicalValue({ item: row, column: column2 }) === choice.value) {
          return sum + Number(choice.value);
        } else {
          return sum;
        }
      }, 0)
    };
  });
}
function IntegerChoicesTotalCell({
  rows,
  column: column2
}) {
  const totals = talliedChoices({ rows, column: column2 });
  const grandTotal = totals == null ? void 0 : totals.reduce((total, { sum }) => total + sum, 0);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Cell, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { sx: { display: "flex", flexDirection: "column", flex: 1 }, children: [
    totals == null ? void 0 : totals.map(({ label, value, count: count2, sum }) => {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Box,
        {
          as: "dl",
          sx: {
            display: "flex",
            justifyContent: "space-between",
            margin: 0,
            paddingY: 2,
            borderBottomWidth: 1,
            borderBottomColor: "border.default",
            borderBottomStyle: "solid"
          },
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { as: "dt", children: label }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { as: "dd", children: [
              count2,
              " x ",
              value,
              " = ",
              sum
            ] })
          ]
        },
        value
      );
    }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Box,
      {
        as: "dl",
        sx: {
          display: "flex",
          justifyContent: "space-between",
          margin: 0,
          paddingY: 2
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { as: "dt", children: "Total" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { as: "dd", children: grandTotal })
        ]
      }
    )
  ] }) });
}
function TotalCellRenderer({
  rows,
  column: column2
}) {
  if (column2.noTotal) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(TotalCell, { total: null });
  } else if (column2.choices && column2.type === "integer") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(IntegerChoicesTotalCell, { column: column2, rows });
  } else if (column2.choices) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ChoicesTotalCell, { column: column2, rows });
  } else if (column2.type === "integer") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(IntegerTotalCell, { column: column2, rows });
  } else if (column2.type === "currency") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(CurrencyTotalCell, { column: column2, rows });
  } else if (column2.type === "boolean") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(BooleanTotalCell, { column: column2, rows });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(TotalCell, { total: null });
  }
}
function TotalsRow({
  rows,
  columns,
  totalResults = void 0,
  showMetaCell = true,
  showActions = true
  // Added with default value
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$1.Row, { children: [
    showMetaCell && /* @__PURE__ */ jsxRuntimeExports.jsxs(Table$1.Cell, { children: [
      "Total ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: totalResults || rows.length })
    ] }),
    columns.map((column2) => /* @__PURE__ */ jsxRuntimeExports.jsx(TotalCellRenderer, { column: column2, rows }, column2.key)),
    showActions && /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Cell, {})
  ] });
}
const useTotalsGrid = (props) => {
  const [totalsResults, setTotalsResults] = useState({
    type: "loading"
  });
  const [isLoading, setIsLoading] = useState(false);
  const [sort3, setSort] = useState();
  useEffect(() => {
    let isSubscribed = true;
    const abortController = new AbortController();
    const fetchResult = async () => {
      const newResult = await props.loader.loadTotalsGrid(
        {
          filters: props.parentGrid.filters,
          column: props.column
        },
        abortController.signal
      );
      if (isSubscribed) {
        setTotalsResults(newResult);
        setIsLoading(false);
      }
    };
    fetchResult().catch(console.error);
    return () => {
      abortController.abort();
      isSubscribed = false;
    };
  }, [props.parentGrid]);
  const getSort = () => {
    var _a3;
    if (sort3 !== void 0) {
      return sort3;
    } else if (totalsResults.type === "success") {
      return (_a3 = totalsResults == null ? void 0 : totalsResults.grid) == null ? void 0 : _a3.sort;
    }
  };
  const sortedRows = () => {
    if (totalsResults.type === "success") {
      if (sort3 === void 0) {
        return totalsResults.rows;
      }
      const column2 = totalsResults.grid.columns.find(
        (c2) => c2.key === (sort3 == null ? void 0 : sort3.column)
      );
      if (column2 === void 0) {
        return totalsResults.rows;
      } else {
        return sortItems({
          column: column2,
          items: totalsResults.rows,
          order: sort3 == null ? void 0 : sort3.order
        });
      }
    } else {
      return void 0;
    }
  };
  return {
    isLoading,
    totalsResults,
    rows: sortedRows(),
    sort: getSort(),
    setSort
  };
};
const TotalsGrid = (props) => {
  const { isLoading, totalsResults, rows, sort: sort3, setSort } = useTotalsGrid(props);
  if (totalsResults.type === "loading" || isLoading) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingAnimation, { rows: 8, columns: 4 });
  }
  if (totalsResults.type === "error") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Error..." });
  }
  const colCount = totalsResults.grid.columns.length ?? 0;
  const gridTemplate = `repeat(${colCount}, auto)`;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TableContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledTable, { gridTemplateColumns: gridTemplate, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Head, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      HeaderRow,
      {
        columns: totalsResults.grid.columns,
        sort: sort3,
        onSort: setSort,
        showActions: false,
        showMetaCell: false
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1.Body, { children: rows == null ? void 0 : rows.map((row) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      DataRow,
      {
        columns: totalsResults.grid.columns,
        row,
        showMetaCell: false,
        showActions: false
      },
      row.id
    )) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("tfoot", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      TotalsRow,
      {
        rows: totalsResults.rows,
        columns: totalsResults.grid.columns,
        showMetaCell: false,
        showActions: false
      }
    ) })
  ] }) });
};
const useSelectedRows = ({
  rows: initialRows,
  onChange
}) => {
  const [selectedRows, setSelectedRows] = useState(initialRows);
  const setRows = (rows) => {
    setSelectedRows(rows);
    onChange == null ? void 0 : onChange(rows);
  };
  const isSelectedRow = (row) => selectedRows !== void 0 && selectedRows.some((r2) => r2.id === row.id);
  const setRowWindow = (rowWindow) => {
    setRows(
      selectedRows == null ? void 0 : selectedRows.filter((sr) => rowWindow.some((r2) => r2.id === sr.id))
    );
  };
  return {
    rows: selectedRows,
    setRows,
    selectRow: (row) => {
      if (!isSelectedRow(row)) {
        setRows([...selectedRows || [], row]);
      }
    },
    deselectRow: (row) => {
      if (selectedRows === void 0) {
        return;
      }
      setRows(selectedRows.filter((r2) => r2.id !== row.id));
    },
    isSelectedRow,
    clear: () => setRows(void 0),
    setRowWindow
  };
};
const readIntFromLocalStorage = (key2, defaultValue2) => {
  const raw = localStorage.getItem(key2);
  if (raw === null) {
    return defaultValue2;
  } else {
    return JSON.parse(raw);
  }
};
const writeIntToLocalStorage = (key2, value) => {
  localStorage.setItem(key2, JSON.stringify(value));
};
const getInitialPerPage = (props) => {
  if (props.perPageStorageKey !== void 0) {
    return readIntFromLocalStorage(
      props.perPageStorageKey,
      props.defaultPerPage
    );
  } else {
    return props.defaultPerPage;
  }
};
const useGrid = (props) => {
  const [grid2, setGrid] = useState(props.grid);
  const [savePoint, setSavePoint] = useState(props.grid);
  const [page, setPage] = useState(props.page);
  const [perPage, setPerPageState] = useState(getInitialPerPage(props));
  const [isDirty2, setIsDirty] = useState(false);
  const selectedRows = useSelectedRows({
    rows: props.selectedRows,
    onChange: props.onSelectionChange
  });
  const totalsColumns = getTotalsColumns(grid2);
  const setTotalsColumns = (totalsColumns2) => setGrid({ ...grid2, totalsColumns: totalsColumns2.map((c2) => c2.key) });
  const setPerPage = (newPerPage) => {
    setPerPageState(newPerPage);
    if (newPerPage !== perPage) {
      setPage(1);
    }
    if (props.perPageStorageKey !== void 0) {
      writeIntToLocalStorage(props.perPageStorageKey, newPerPage);
    }
  };
  const updateGrid = (update2) => {
    const updated = { ...grid2, ...update2 };
    if (!isEqual6(updated, grid2)) {
      setGrid(updated);
      setPage(1);
      setIsDirty(true);
    }
    return updated;
  };
  const saveGrid = async (update2) => {
    if (props.onSave === void 0) {
      throw new Error("onSave prop must be defined to save the grid");
    }
    const gridToSave = update2 !== void 0 ? updateGrid(update2) : grid2;
    const result = await props.onSave({ ...gridToSave });
    if (result.type === "success") {
      setSavePoint({ ...gridToSave, ...result.grid });
      setIsDirty(false);
    }
    return result;
  };
  const resetGrid = () => {
    setGrid(savePoint);
    setIsDirty(false);
  };
  const addTotalsColumn = (column2) => {
    let newColumns;
    if (totalsColumns === void 0) {
      newColumns = [column2];
      setTotalsColumns(newColumns);
      setIsDirty(true);
    } else if (!totalsColumns.some((c2) => c2.key === column2.key)) {
      newColumns = [...totalsColumns, column2];
      setTotalsColumns(newColumns);
      setIsDirty(true);
    } else {
      newColumns = totalsColumns;
    }
    return newColumns;
  };
  const removeTotalsColumn = (column2) => {
    if (totalsColumns === void 0) {
      return;
    }
    setIsDirty(true);
    setTotalsColumns(totalsColumns.filter((c2) => c2.key !== column2.key));
  };
  const loadRecordsResults = useLoadRecords(
    props.loader,
    {
      pageParams: { page, perPage },
      filters: { ...grid2.filters, ...grid2.fixedFilters },
      sort: grid2.sort
    },
    props.resultsCacheKey,
    {
      onSuccess: (data) => "rows" in data && selectedRows.setRowWindow(data.rows)
    }
  );
  const queryClient = useQueryClient();
  const reloadGridResults = () => queryClient.invalidateQueries();
  return {
    grid: grid2,
    results: loadRecordsResults.data,
    reloadGridResults,
    page,
    perPage,
    isLoading: loadRecordsResults.isLoading,
    isError: loadRecordsResults.isError,
    isFetching: loadRecordsResults.isFetching,
    isDirty: isDirty2,
    setPage,
    setPerPage,
    updateGrid,
    resetGrid,
    saveGrid,
    totalsColumns,
    addTotalsColumn,
    removeTotalsColumn,
    selectedRows
  };
};
const PaginatedGrid = ({
  resultsCacheKey = 1,
  rowActions,
  showActions = true,
  showMetaCell = true,
  actionCellRenderer = "menu",
  // Add the new prop with default value
  ...props
}) => {
  const {
    grid: grid2,
    results,
    reloadGridResults,
    page,
    perPage,
    isDirty: isDirty2,
    isLoading,
    isFetching,
    isError: isError2,
    updateGrid,
    resetGrid,
    saveGrid,
    setPage,
    setPerPage,
    totalsColumns,
    addTotalsColumn,
    removeTotalsColumn,
    selectedRows
  } = useGrid({ resultsCacheKey, ...props });
  const [tabIndex, setTabIndex] = useState(0);
  const handleLoadTotal = (column2) => {
    const newColumns = addTotalsColumn(column2);
    const newIndex = newColumns.findIndex((c2) => c2.key === column2.key);
    setTabIndex(newIndex + 1);
  };
  const handleRemoveTotalsColumn = (column2) => {
    const isColumnSelected = (totalsColumns == null ? void 0 : totalsColumns.findIndex((c2) => c2.key === column2.key)) === tabIndex - 1;
    removeTotalsColumn(column2);
    if (isColumnSelected) {
      setTabIndex(0);
    }
  };
  useEffect(() => {
    if (grid2.totalsColumns === void 0 || grid2.totalsColumns.length === 0) {
      setTabIndex(0);
    }
  }, [grid2]);
  if (isLoading || results === void 0 || results.type === "loading") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingAnimation, {});
  }
  if (isError2 || results.type === "error") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Error..." });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(QueryClientProvider, { client: new QueryClient(), children: /* @__PURE__ */ jsxRuntimeExports.jsx(GridProvider, { rowActions, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    RowEditContext.Provider,
    {
      value: {
        RowEditor: props.RowEditor,
        reloadGridResults
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Box,
        {
          display: "flex",
          flexDirection: "column",
          height: "100%",
          alignItems: "stretch",
          overflow: "hidden",
          className: "js-measure",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              Box,
              {
                display: "flex",
                bg: "#FAFBFC",
                flexDirection: "row",
                p: 5,
                pt: 4,
                pb: 2,
                position: "sticky",
                alignSelf: "top",
                alignItems: "top",
                justifyContent: "space-between",
                zIndex: 1,
                sx: {
                  gap: 4
                },
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsxs(
                    Box,
                    {
                      align: "left",
                      display: "flex",
                      flexDirection: "row",
                      flex: 1,
                      justifyContent: "space-between",
                      alignItems: "center",
                      children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx(
                          Pager,
                          {
                            perPage,
                            totalResults: results.totalResults,
                            currentPage: page,
                            onSelectPage: setPage,
                            onSelectPerPage: props.hidePerPageControl ? void 0 : setPerPage
                          }
                        ),
                        /* @__PURE__ */ jsxRuntimeExports.jsx(
                          ResultSummary,
                          {
                            page,
                            perPage,
                            isLoading: isFetching,
                            results
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { sx: { display: "flex", flexDirection: "row", alignItems: "center", gap: 2 }, children: [
                    props.onSave !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(
                      Box,
                      {
                        sx: {
                          display: "flex",
                          flexDirection: "row",
                          zIndex: 1,
                          gap: 2
                        },
                        children: [
                          isDirty2 && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, { variant: "danger", onClick: resetGrid, children: "Reset Filters" }),
                          isDirty2 && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonComponent, { variant: "primary", onClick: () => saveGrid(), children: "Save Filters" }),
                          /* @__PURE__ */ jsxRuntimeExports.jsx(
                            GridColumnEditor,
                            {
                              grid: grid2,
                              onSave: saveGrid,
                              onUpdate: updateGrid
                            }
                          )
                        ]
                      }
                    ),
                    props.actionLinks !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(ActionMenu, { children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Button, { children: "Download" }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(ActionMenu.Overlay, { width: "medium", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionList, { children: props.actionLinks.map(({ title, onClick }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                        ActionList.Item,
                        {
                          onClick: () => onClick(grid2),
                          children: title
                        },
                        title
                      )) }) })
                    ] })
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { flexGrow: 1, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { sx: { display: "flex", flexDirection: "row", gap: 2, px: 5, bg: "#FAFBFC" }, children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  GridTab,
                  {
                    isActive: tabIndex === 0,
                    selectTab: () => setTabIndex(0),
                    children: "All"
                  }
                ),
                totalsColumns == null ? void 0 : totalsColumns.map((column2, columnIndex) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                  GridTab,
                  {
                    onClose: () => handleRemoveTotalsColumn(column2),
                    selectTab: () => setTabIndex(columnIndex + 1),
                    isActive: tabIndex === columnIndex + 1,
                    children: column2.label
                  },
                  column2.key
                ))
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Box,
                {
                  sx: { display: tabIndex === 0 ? "flex" : "none" },
                  width: "100%",
                  overflow: "auto",
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(SelectedRowProvider, { ...selectedRows, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    PaginatedTable,
                    {
                      grid: grid2,
                      result: results,
                      loader: props.loader,
                      renderCell: props.renderCell,
                      onFilterChange: (filters) => updateGrid({ filters }),
                      onSortChange: (sort3) => updateGrid({ sort: sort3 }),
                      onLoadTotal: handleLoadTotal,
                      showActions,
                      showMetaCell,
                      actionCellRenderer
                    }
                  ) })
                },
                "_results"
              ),
              totalsColumns == null ? void 0 : totalsColumns.map((column2, columnIndex) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                Box,
                {
                  sx: { display: tabIndex === columnIndex + 1 ? "flex" : "none" },
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    TotalsGrid,
                    {
                      parentGrid: grid2,
                      column: column2,
                      loader: props.loader
                    }
                  )
                },
                column2.key
              ))
            ] })
          ]
        }
      )
    }
  ) }) });
};
const PaginatedGridContainer = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(QueryClientProvider, { client: new QueryClient(), children: /* @__PURE__ */ jsxRuntimeExports.jsx(PaginatedGrid, { ...props }) });
const SimpleGrid = ({
  columns,
  rows,
  renderCell,
  tableClasses
}) => {
  const [sort3, setSort] = useState();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "table",
    {
      cellSpacing: "0",
      className: classNames("tablesorter table-borders fluid", tableClasses),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("thead", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderRow$1, { columns, sort: sort3, onSort: setSort }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: rows.map((row) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          DataRow$1,
          {
            columns,
            row,
            renderCell
          },
          row.id
        )) })
      ]
    }
  );
};
const PaginatedGridWrapper = (props) => {
  const key2 = useSoftRerenderOnResize();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PaginatedGrid, { ...props }, key2);
};
const QRCodeReader = ({ onCodeScan }) => {
  const [devices, setDevices] = useState([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState();
  const codeReader = new BrowserQRCodeReader();
  const videoRef = React__default.useRef(null);
  useEffect(() => {
    (async () => {
      const devices2 = await BrowserQRCodeReader.listVideoInputDevices();
      let deviceId;
      setDevices(devices2);
      if (devices2.length > 0) {
        deviceId = devices2[0].deviceId;
        setSelectedDeviceId(deviceId);
      }
    })();
  }, []);
  useEffect(() => {
    let controls;
    if (devices.length === 0) {
      return;
    }
    (async () => {
      const deviceControls = await codeReader.decodeFromVideoDevice(
        selectedDeviceId,
        videoRef.current || void 0,
        (result) => {
          if (result !== void 0 && result !== null) {
            onCodeScan(result);
          }
        }
      );
      controls = deviceControls;
    })();
    return function cleanup() {
      controls == null ? void 0 : controls.stop();
    };
  }, [devices, selectedDeviceId]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("main", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("video", { ref: videoRef, style: { flex: "1", borderRadius: "8px" } })
      },
      "scanner"
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: "24px"
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("label", { htmlFor: "sourceSelect", children: "Change Video Source" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "select",
            {
              value: selectedDeviceId,
              onChange: (e) => setSelectedDeviceId(e.target.value),
              children: devices.map((element2) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: element2.deviceId, children: element2.label }, element2.deviceId))
            }
          )
        ]
      },
      "source"
    )
  ] }) });
};
const useLeadScanner = ({
  onCodeScan,
  onUpdateLead
}) => {
  const [scanResult, setScanResult] = useState();
  const [leadResult, setLeadResult] = useState();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const doScan = async () => {
      if (scanResult !== void 0) {
        setLoading(true);
        const leadResult2 = await onCodeScan(scanResult);
        setLeadResult(leadResult2);
        setLoading(false);
      }
    };
    if (!loading) {
      doScan();
    }
  }, [scanResult]);
  const updateNote = async (notes) => {
    if ((leadResult == null ? void 0 : leadResult.status) !== "success" || onUpdateLead === void 0) {
      return;
    }
    setLoading(true);
    const updatedResult = await onUpdateLead(leadResult.lead.id, notes);
    setLeadResult(updatedResult);
    setLoading(false);
  };
  return {
    scanResult,
    setScanResult,
    leadResult,
    setLeadResult,
    updateNote,
    loading
  };
};
const LeadScanner = ({ onCodeScan }) => {
  const { setScanResult, leadResult } = useLeadScanner({ onCodeScan });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
    leadResult !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { status: leadResult.status, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon$1, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(AlertTitle, { children: leadResult.messageTitle }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(AlertDescription, { children: leadResult.messageBody })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(QRCodeReader, { onCodeScan: setScanResult })
  ] });
};
const LeadScanSuccessModal = ({
  lead,
  onClose,
  onUpdateLead,
  onDeleteLead
}) => {
  const [notes, setNotes] = useState(lead.notes);
  const handleConfirmLead = async () => {
    if (notes !== lead.notes && notes !== void 0) {
      await (onUpdateLead == null ? void 0 : onUpdateLead.call(void 0, lead.id, notes));
    }
    onClose();
  };
  const handleRemoveLead = async () => {
    await (onDeleteLead == null ? void 0 : onDeleteLead.call(void 0, lead.id));
    onClose();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: true, onClose: handleConfirmLead, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalContent, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { pb: 1, pt: 4, children: "Lead Scanned" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { p: 4, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { status: "success", flexDirection: "column", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon$1, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(AlertTitle, { children: "Lead Found!" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { pt: 2, children: [
          "Name: ",
          lead.firstName,
          " ",
          lead.lastName
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { pb: 2, children: [
          "Email: ",
          lead.email
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { htmlFor: "notes", children: "Notes (optional):" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Textarea$1,
            {
              name: "notes",
              value: notes,
              placeholder: "Add notes about this lead",
              onChange: (e) => setNotes(e.target.value)
            }
          )
        ] })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        ModalFooter,
        {
          px: 10,
          display: "flex",
          bg: "gray.50",
          justifyContent: "space-between",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "red", onClick: handleRemoveLead, children: "Cancel" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: handleConfirmLead, colorScheme: "green", children: "Save" })
          ]
        }
      )
    ] })
  ] });
};
const LeadScanFailedModal = ({
  result,
  onClose
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: true, onClose, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalOverlay, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalContent, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { p: 1, children: "Lead Scan Failed" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { p: 4, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { status: "error", flexDirection: "column", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon$1, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(AlertTitle, { children: result.messageTitle }),
        result.messageBody !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(AlertDescription, { children: result.messageBody })
      ] }) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalFooter, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: onClose, colorScheme: "green", children: "Ok" }) })
    ] })
  ] });
};
const ModalLeadScanner = ({
  onCodeScan,
  onUpdateLead,
  onDeleteLead
}) => {
  const { setScanResult, leadResult, setLeadResult } = useLeadScanner({
    onCodeScan
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
    (leadResult == null ? void 0 : leadResult.status) === "success" && /* @__PURE__ */ jsxRuntimeExports.jsx(
      LeadScanSuccessModal,
      {
        lead: leadResult.lead,
        onClose: () => setLeadResult(void 0),
        onUpdateLead,
        onDeleteLead
      }
    ),
    (leadResult == null ? void 0 : leadResult.status) === "error" && /* @__PURE__ */ jsxRuntimeExports.jsx(
      LeadScanFailedModal,
      {
        result: leadResult,
        onClose: () => setLeadResult(void 0)
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      QRCodeReader,
      {
        onCodeScan: (code) => {
          console.log(code);
          setScanResult(code);
        }
      }
    )
  ] });
};
const LeadEditModalContent = ({
  lead,
  onSave,
  onCancel
}) => {
  const [notes, setNotes] = useState(lead.notes);
  const handleSave = async () => {
    await onSave(lead.id, notes);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalContent, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Edit lead" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { p: 4, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { children: [
        "Name: ",
        lead.firstName,
        " ",
        lead.lastName
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$3, { pb: 4, children: [
        "Email: ",
        lead.email
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { id: "notes", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Notes" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Textarea$1,
          {
            value: notes,
            onChange: (e) => setNotes(e.target.value),
            placeholder: "Notes"
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ModalFooter,
      {
        px: 10,
        display: "flex",
        bg: "gray.50",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "red", mr: 3, onClick: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "green", mr: 3, onClick: handleSave, children: "Save" })
        ]
      }
    )
  ] });
};
const useRoomBlockAvailability = (params) => {
  const { roomBooking } = useRegFlowApi();
  return useQuery(
    [
      "roomBlockAvailability",
      params.formField,
      params.checkIn,
      params.checkOut
    ],
    () => roomBooking.getRoomBlockAvailability(
      params.formField,
      params.checkIn,
      params.checkOut
    )
  );
};
const formatRoomType = (roomType, formField, roomBlock, currency) => {
  const parts = [roomType.name];
  if (formField.occupancyPricing && roomType.occupancy !== void 0) {
    parts.push(`Adult Occupants: ${roomType.occupancy}`);
  }
  if (roomType.totalPrice !== void 0 && !roomBlock.hidePrices) {
    parts.push(priceWithSymbol({ currency, price: roomType.totalPrice }));
  }
  return parts.join(" - ");
};
const RoomTypeSelect = ({
  formField,
  roomBlock,
  roomTypes: roomTypes2,
  selectedRoomType,
  blankText = "-- Please select --",
  onChange
}) => {
  const locale2 = useLocale();
  useEffect(() => {
    if (selectedRoomType && !roomTypes2.find((rt) => rt.id === selectedRoomType.id)) {
      onChange(void 0);
    }
  }, [roomTypes2]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Select$2,
    {
      value: selectedRoomType == null ? void 0 : selectedRoomType.id,
      onChange: (event) => {
        onChange(getAvailableRoomType(roomTypes2, event.target.value));
      },
      placeholder: blankText,
      style: {
        width: "100%"
      },
      children: roomTypes2.map((roomType) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        "option",
        {
          value: availableRoomTypeId(roomType),
          children: formatRoomType(
            roomType,
            formField,
            roomBlock,
            locale2.currency.symbol
          )
        },
        availableRoomTypeId(roomType)
      ))
    }
  );
};
const RoomTypeSelectContainer = ({
  booking,
  roomBlock,
  formField,
  onChange,
  selectedRoomType
}) => {
  const { error: error2, data: roomTypes2 } = useRoomBlockAvailability({
    formField: formField.name,
    checkIn: booking.checkIn,
    checkOut: booking.checkOut
  });
  if (error2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { status: "error", children: "Error loading room booking data" });
  }
  if (roomTypes2 === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {});
  }
  if (roomTypes2 === void 0 || roomTypes2.length === 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { status: "info", children: "No rooms available for the selected dates" });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    RoomTypeSelect,
    {
      roomBlock,
      formField,
      roomTypes: roomTypes2,
      selectedRoomType,
      onChange
    }
  );
};
const RoomTypeSelectionForm = ({
  roomBlock,
  formField,
  booking: initialBooking,
  isSaving = false,
  onSelectRoomType,
  onCancelEdit
}) => {
  const locale2 = useLocale();
  const [booking, setBooking] = useState(initialBooking);
  useEffect(() => {
    setBooking(initialBooking);
  }, [initialBooking]);
  const handleDateChange = (update2) => {
    setBooking({ ...booking, ...update2, roomType: void 0 });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { flexGrow: 1, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { pr: 5, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Check in" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          DatePicker,
          {
            selectsStart: true,
            dateFormat: locale2.dateFormats.regular,
            startDate: booking.checkIn,
            endDate: booking.checkOut,
            minDate: roomBlock.startDate,
            maxDate: booking.checkOut || roomBlock.endDate,
            selectedDate: booking.checkIn,
            onChange: (date) => handleDateChange({ checkIn: date })
          }
        )
      ] }, "checkIn"),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        FormControl$2,
        {
          pr: 5,
          isDisabled: booking.checkIn === void 0,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Check out" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              DatePicker,
              {
                selectsEnd: true,
                disabled: booking.checkIn === void 0,
                dateFormat: locale2.dateFormats.regular,
                startDate: booking.checkIn,
                endDate: booking.checkOut,
                minDate: booking.checkIn || roomBlock.startDate,
                maxDate: roomBlock.endDate,
                selectedDate: booking.checkOut,
                onChange: (date) => handleDateChange({ checkOut: date })
              }
            )
          ]
        },
        "checkOut"
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        FormControl$2,
        {
          pr: 5,
          isDisabled: !roomBookingHasDates(booking),
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Room type" }),
            roomBookingHasDates(booking) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
              RoomTypeSelectContainer,
              {
                booking,
                selectedRoomType: void 0,
                roomBlock,
                formField,
                onChange: (roomType) => {
                  if (roomType === void 0) {
                    setBooking({ ...booking, roomType });
                    return;
                  }
                  const updatedBooking = {
                    ...booking,
                    roomType,
                    occupancy: getInitialOccupancy(booking, roomType)
                  };
                  if (isValidRoomBooking(updatedBooking)) {
                    onSelectRoomType(updatedBooking);
                  }
                }
              }
            ) : /* @__PURE__ */ jsxRuntimeExports.jsx(Select$2, { disabled: true })
          ]
        },
        "roomType"
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Center, { flexShrink: 0, pt: 7, width: "100px", children: [
      booking.status !== "new" && /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", onClick: onCancelEdit, children: "Back" }),
      isSaving && /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {})
    ] })
  ] });
};
const DisabledInputControl = ({
  labelText,
  value,
  opacity: opacity2 = 0.7,
  ...props
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { isDisabled: true, ...props, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { _disabled: { opacity: opacity2 }, children: labelText }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Input$1, { _disabled: { opacity: opacity2 }, fontSize: "16px", value })
] });
const RoomBookingInfo = ({
  booking,
  showUndoButton = false,
  onEditBooking,
  onCancelBooking
}) => {
  const { dateFormats: dateFormats2 } = useLocale();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { flexGrow: 1, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DisabledInputControl,
        {
          pr: 5,
          labelText: "Check in",
          value: format$2(booking.checkIn, dateFormats2.regular)
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DisabledInputControl,
        {
          pr: 5,
          labelText: "Check out",
          value: format$2(booking.checkOut, dateFormats2.regular)
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        DisabledInputControl,
        {
          pr: 5,
          labelText: "Room type",
          value: booking.roomType.name
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroup$1, { flexShrink: 0, pt: 7, width: "100px", children: showUndoButton ? /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: onCancelBooking, colorScheme: "green", children: "Undo" }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      onEditBooking !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", onClick: onEditBooking, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EditIcon, {}) }),
      onCancelBooking !== void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "red", onClick: onCancelBooking, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, {}) })
    ] }) })
  ] });
};
const BookingNights = ({ numberOfNights }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: numberOfNights }),
  " ",
  numberOfNights === 1 ? "night" : "nights"
] });
const RegFormText = ({ style: style3, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Text$3,
  {
    ...props,
    style: { ...style3, marginBottom: 0, lineHeight: "inherit" }
  }
);
const OccupancyControl = ({
  booking,
  occupancy,
  onChange,
  onBlur
}) => {
  var _a3, _b, _c;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    FormControl$2,
    {
      maxW: "85px",
      isDisabled: booking.roomType === void 0,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Occupancy" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          NumberInput,
          {
            size: "md",
            min: (_a3 = booking.roomType) == null ? void 0 : _a3.minOccupancy,
            max: (_b = booking.roomType) == null ? void 0 : _b.maxOccupancy,
            value: occupancy || ((_c = booking.roomType) == null ? void 0 : _c.minOccupancy) || 1,
            onChange: (valueAsString, valueAsNumber) => !Number.isNaN(valueAsNumber) && onChange(valueAsNumber),
            onBlur,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(NumberInputField, { min: 0, sx: { marginBottom: "0px !important" } }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(NumberInputStepper, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(NumberIncrementStepper, {}),
                /* @__PURE__ */ jsxRuntimeExports.jsx(NumberDecrementStepper, {})
              ] })
            ]
          }
        )
      ]
    },
    "occupancy"
  );
};
const initGuests = (booking) => {
  if (booking.guests === void 0) {
    return Array(booking.roomType.maxOccupancy).fill("");
  }
  if (booking.guests.length > booking.roomType.maxOccupancy) {
    return booking.guests.slice(0, booking.occupancy);
  }
  if (booking.guests.length < booking.roomType.maxOccupancy) {
    return booking.guests.concat(
      Array(booking.roomType.maxOccupancy - booking.guests.length).fill("")
    );
  }
  return booking.guests;
};
const RoomBookingGuestForm = ({
  roomBooking,
  onChange,
  onCancel
}) => {
  const [guests, setGuests] = React__default.useState(initGuests(roomBooking));
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { width: "100%", children: [
    guests.map((guest, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      Input$1,
      {
        bg: "white",
        placeholder: "Occupant name " + (Number(i) + 1),
        value: guest,
        onChange: (e) => {
          const newGuests = [...guests];
          newGuests[i] = e.target.value;
          setGuests(newGuests);
        }
      },
      i
    )),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonGroup$1, { width: "100%", justifyContent: "space-between", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "red", onClick: onCancel, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, {}) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "green", onClick: () => onChange(guests), children: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckIcon$1, {}) })
    ] })
  ] });
};
const RoomBookingGuestsList = ({
  roomBooking
}) => {
  if (roomBooking.guests === void 0 || roomBooking.guests.length === 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { color: "red", children: "Enter the full name for each person staying in the room" });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: roomBooking.guests.map((guest, i) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: guest }, i)) });
};
const RoomBookingGuests = ({
  roomBooking,
  onChange
}) => {
  const [editing, setEditing] = useState(false);
  useEffect(() => {
    setEditing(false);
  }, [roomBooking]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { justifyContent: "space-evenly", alignItems: "start", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Room Occupants (inc. Children)" }),
    editing ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      RoomBookingGuestForm,
      {
        roomBooking,
        onChange: (guests) => {
          onChange(guests.filter((g2) => g2 != ""));
          setEditing(false);
        },
        onCancel: () => setEditing(false)
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(RoomBookingGuestsList, { roomBooking }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { colorScheme: "blue", onClick: () => setEditing(true), children: "Edit Names" })
    ] })
  ] });
};
const RoomBookingOptionsForm = ({
  formField,
  roomBlock,
  booking,
  originalBooking,
  editingBooking = false,
  onChange
}) => {
  const locale2 = useLocale();
  const [bookingOptions, setBookingOptions] = useState({
    occupancy: booking.occupancy,
    note: booking.note
  });
  useEffect(() => {
    setBookingOptions({
      occupancy: booking.occupancy,
      note: booking.note,
      guests: booking.guests
    });
  }, [booking]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { py: 4, justifyContent: "space-between", alignItems: "start", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { minW: 226, mr: "5", children: formField.occupancyPricing ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      RoomBookingGuests,
      {
        roomBooking: booking,
        onChange: (guests) => {
          const newOptions = { ...bookingOptions, guests };
          setBookingOptions(newOptions);
          onChange(newOptions);
        }
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
      OccupancyControl,
      {
        booking,
        occupancy: bookingOptions.occupancy,
        onChange: (occupancy) => setBookingOptions({
          ...bookingOptions,
          occupancy
        }),
        onBlur: () => onChange(bookingOptions)
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$2, { isDisabled: !isValidRoomBooking(booking), children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Additional requests" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Textarea$1,
        {
          maxW: 226,
          mt: "1",
          mr: "5",
          value: bookingOptions.note,
          onChange: (e) => {
            setBookingOptions({ ...bookingOptions, note: e.target.value });
          },
          onBlur: () => onChange(bookingOptions)
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { minW: 250, maxW: 300, children: !editingBooking && /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { justifyContent: "space-evenly", alignItems: "end", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(RegFormText, { align: "right", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(BookingNights, { numberOfNights: getBookingNightsCount(booking) }),
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: booking.occupancy }),
        " person occupancy",
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        shouldShowPrice(roomBlock, booking) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          "Total Price ",
          " = ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: priceWithSymbol({
            price: booking.priceCents,
            currency: locale2.currency.symbol
          }) })
        ] })
      ] }),
      booking.status === "hold" && (originalBooking !== void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(RegFormText, { align: "right", children: "Please save registration within 30 minutes to confirm changes." }) : /* @__PURE__ */ jsxRuntimeExports.jsx(RegFormText, { align: "right", children: "Please save registration within 30 minutes to confirm selection." })),
      booking.status === "booked" && /* @__PURE__ */ jsxRuntimeExports.jsx(RegFormText, { align: "right", children: "Booking confirmed" })
    ] }) })
  ] });
};
const RoomBookingForm = ({
  roomBlock,
  formField,
  booking,
  originalBooking,
  editingBooking = true,
  onEditBooking,
  onSelectRoomType,
  onUpdateBookingOptions,
  onClearBooking
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    editingBooking ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      RoomTypeSelectionForm,
      {
        roomBlock,
        formField,
        booking,
        onSelectRoomType,
        onCancelEdit: () => onEditBooking == null ? void 0 : onEditBooking(false)
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
      RoomBookingInfo,
      {
        booking,
        onEditBooking: () => onEditBooking == null ? void 0 : onEditBooking(true),
        showUndoButton: originalBooking !== void 0 && "id" in booking && booking.status === "hold" && originalBooking.status !== "hold",
        onCancelBooking: onClearBooking !== void 0 ? () => onClearBooking(booking) : void 0
      }
    ),
    booking.status !== "new" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      RoomBookingOptionsForm,
      {
        formField,
        roomBlock,
        booking,
        originalBooking,
        editingBooking,
        onChange: onUpdateBookingOptions
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { mt: 4, children: "Select your preferred room type from the options above." })
  ] });
};
const roomBookingQueryKey = (formField) => ["roomBookings", formField];
const useRoomBooking = (roomBlockId, formField, options) => {
  const { roomBooking } = useRegFlowApi();
  return useQuery(
    roomBookingQueryKey(formField),
    () => roomBooking.getBooking(formField),
    options
  );
};
const useAddBooking = (options) => {
  const { roomBooking } = useRegFlowApi();
  const queryClient = useQueryClient();
  const mutateFn = ({ booking }) => roomBooking.createBooking(booking);
  return useMutation(mutateFn, {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.setQueryData(
        roomBookingQueryKey(variables.booking.formField),
        data
      );
      if ((options == null ? void 0 : options.onSuccess) !== void 0) {
        return options.onSuccess(data, variables, context);
      }
    }
  });
};
const useCancelBooking = (options) => {
  const { roomBooking } = useRegFlowApi();
  const queryClient = useQueryClient();
  const mutateFn = ({ booking }) => roomBooking.cancelBooking(booking);
  return useMutation(
    mutateFn,
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries(
          roomBookingQueryKey(variables.booking.formField)
        );
        if ((options == null ? void 0 : options.onSuccess) !== void 0) {
          return options.onSuccess(data, variables, context);
        }
      }
    }
  );
};
const defaultBooking = {
  status: "new"
};
const initializeBooking = (formField) => ({
  ...defaultBooking,
  checkIn: parseISODate(formField.defaultCheckIn),
  checkOut: parseISODate(formField.defaultCheckOut)
});
const useUpdateBooking = (options) => {
  const { roomBooking } = useRegFlowApi();
  const queryClient = useQueryClient();
  const mutateFn = ({ formField, update: update2 }) => roomBooking.updateBooking(formField, update2);
  return useMutation(
    mutateFn,
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        var _a3;
        await queryClient.setQueryData(
          roomBookingQueryKey(variables.formField),
          data
        );
        (_a3 = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a3.call(options, data, variables, context);
      }
    }
  );
};
const CancellationRequested = ({
  booking,
  onUndoCancellation
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(RoomBookingInfo, { booking }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { py: 4, px: 4, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(RegFormText, { align: "center", children: "Cancellation requested" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(RegFormText, { align: "center", children: "Submit the registration form using the button below to confirm cancellation." })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Center, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { onClick: onUndoCancellation, colorScheme: "green", children: "Undo cancellation" }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        type: "hidden",
        name: "registration[room_booking_cancellations][]",
        value: booking.id
      }
    )
  ] });
};
const RoomBookingFormContainer = ({
  formField,
  roomBlock,
  originalBooking,
  canEditBooking = false,
  onChange,
  onClear
}) => {
  const [booking, setBooking] = useState();
  const [editingBooking, setEditingBooking] = useState(true);
  const [cancelBookingRequested, setCancelBookingRequested] = useState(false);
  const {
    error: loadBookingError,
    data: savedBooking,
    isLoading: bookingIsLoading
  } = useRoomBooking(formField.roomBlockId, formField.name, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: false
  });
  const addBooking = useAddBooking({
    onSuccess: (addedBooking) => {
      setBooking(addedBooking);
      onChange(addedBooking);
      setEditingBooking(false);
    }
  });
  const cancelBooking = useCancelBooking({
    onSuccess: () => {
      if (originalBooking !== void 0 && originalBooking.status !== "hold") {
        setBooking(originalBooking);
        setEditingBooking(false);
        onChange(originalBooking);
      } else {
        onClear();
        setEditingBooking(true);
        const newBooking = initializeBooking(formField);
        onChange(newBooking);
        setBooking(newBooking);
      }
    }
  });
  const updateBooking = useUpdateBooking({
    onSuccess: (updatedBooking) => {
      setBooking(updatedBooking);
      onChange(updatedBooking);
    }
  });
  const handleRoomTypeSelect = (selectedBooking) => {
    addBooking.mutate({
      booking: { ...selectedBooking, formField: formField.name }
    });
  };
  const handleClearBooking = (booking2) => {
    if (booking2.status === "hold") {
      cancelBooking.mutate({
        booking: { ...booking2, formField: formField.name }
      });
    } else {
      setCancelBookingRequested(true);
    }
  };
  useEffect(() => {
    if (savedBooking !== void 0 && savedBooking !== null) {
      setBooking(savedBooking);
      setEditingBooking(false);
      onChange(savedBooking);
    } else if (originalBooking === void 0) {
      const newBooking = initializeBooking(formField);
      setBooking(newBooking);
      setEditingBooking(true);
      onChange(newBooking);
    }
  }, [savedBooking]);
  if (loadBookingError) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { status: "error", children: "Error loading room booking" });
  }
  if (bookingIsLoading || booking === void 0) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {});
  }
  if (cancelBookingRequested) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      CancellationRequested,
      {
        booking,
        onUndoCancellation: () => setCancelBookingRequested(false)
      }
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    RoomBookingForm,
    {
      formField,
      roomBlock,
      editingBooking,
      onEditBooking: canEditBooking && !cancelBookingRequested ? setEditingBooking : void 0,
      booking,
      originalBooking,
      isSaving: addBooking.isLoading || cancelBooking.isLoading,
      onSelectRoomType: handleRoomTypeSelect,
      onUpdateBookingOptions: (update2) => {
        if (booking.status === "new") {
          throw new Error("Trying to update a booking before saving");
        }
        updateBooking.mutate({
          formField: formField.name,
          update: update2
        });
      },
      onClearBooking: canEditBooking && !cancelBookingRequested && !(formField.required && booking.status === "booked") ? handleClearBooking : void 0
    }
  );
};
const RoomBookingFormField = ({
  field,
  roomBlock,
  originalBooking: ogOriginalBooking,
  canEditBooking = true,
  onChange
}) => {
  var _a3;
  const [roomRequired, setRoomRequired] = useState(
    field.required === true || ogOriginalBooking !== void 0
  );
  const [booking, setBooking] = useState();
  const [originalBooking, setOriginalBooking] = useState(ogOriginalBooking);
  const eventRef = React__default.useRef(null);
  const handleSetBooking = (nextBooking) => {
    var _a4;
    setBooking(nextBooking);
    onChange == null ? void 0 : onChange(nextBooking);
    (_a4 = eventRef.current) == null ? void 0 : _a4.dispatchEvent(new CustomEvent("roomTypeChange"));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(QueryClientProvider, { client: new QueryClient(), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Checkbox$2,
      {
        isDisabled: booking !== null && booking !== void 0 && booking.status !== "new",
        onChange: () => {
          setRoomRequired(!roomRequired);
          if (!roomRequired) {
            setBooking(null);
            onChange == null ? void 0 : onChange(null);
          }
        },
        isChecked: roomRequired,
        children: field.label
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FieldHelp, { helpText: field.helpText }),
    roomRequired && /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { py: 10, "data-room-type": (_a3 = booking == null ? void 0 : booking.roomType) == null ? void 0 : _a3.id, ref: eventRef, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      RoomBookingFormContainer,
      {
        roomBlock,
        formField: field,
        canEditBooking,
        originalBooking,
        onChange: handleSetBooking,
        onClear: () => {
          if ((originalBooking == null ? void 0 : originalBooking.status) === "hold") {
            setOriginalBooking(void 0);
            setBooking(null);
            onChange == null ? void 0 : onChange(null);
          }
          setRoomRequired(field.required === true);
        }
      }
    ) })
  ] });
};
export {
  ActionMenuCellAdapter,
  AdminApiClient,
  AdminApiContext,
  CellRenderer$1 as CellRenderer,
  CellRenderer as CellRendererPrimer,
  CollaborativeFormEditor,
  CollaborativeFormEditorPrimer,
  CollaborativeMicrositeEditor,
  EventEmitter$1 as EventEmitter,
  FormEditorV3 as FormEditor,
  FormEditorV3,
  GregPrimerTheme,
  LeadEditModalContent,
  LeadScanner,
  LocaleProvider,
  MetadataFormPrimer,
  MetadataModalPrimer,
  MicrositeEditor,
  ModalLeadScanner,
  PaginatedGridContainer$1 as PaginatedGrid,
  PaginatedGridContainer as PaginatedGridPrimer,
  PaginatedGridWrapper,
  QRCodeReader,
  RegFlowApiClient,
  RegFlowApiContext,
  RoomBookingFormField,
  SimpleGrid,
  TipTapContentEditor,
  TipTapHandlebarsEditor,
  adaptRegFlowRoomBlockFromResponse,
  adaptRoomBookingResponse,
  addFilterParams,
  getResultColumns,
  gregAdminTheme,
  gridResultsParams,
  syncFormYDocs,
  syncMicrositeYDocs
};
